/* Auto-generated from Shopify on 2026-10-07T03:17:51.178Z. Do not edit by hand. */
window.VSF_CATALOG = {
  "generated_at": "2026-10-07T03:17:51.112Z",
  "count": 6101,
  "products": [
    {
      "handle": "superbloom-sweet-lemon-oolong-green-tea",
      "title": "Superbloom - Sweet Lemon Oolong Green Tea",
      "vendor": "August Uncommon Tea",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1069B50Superbloom15cupbag2020-08InventoryReshoot00106large.jpg?v=1777829185",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "superbloom",
        "sweet",
        "lemon",
        "oolong",
        "green",
        "tea",
        "august",
        "uncommon",
        "tea"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 30,
        "manufacturing": 45,
        "safety": 65,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 4.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170654998725",
      "vsf_explanation": "Flavored oolong tea marketed for taste and vibe, not therapeutic use. No standardized EGCG or L-theanine content stated. Categorically a beverage, not a supplement — no dose framework.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "moon-mama-fertility-tea-bundle",
      "title": "Moon Mama Fertility Tea Bundle",
      "vendor": "Wisdom of the Womb",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/wisdom_of_the_womb3.jpg?v=1777829224",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "prenatal",
      "tokens": [
        "moon",
        "mama",
        "fertility",
        "tea",
        "bundle",
        "wisdom",
        "the",
        "womb"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 35,
        "sustainability": 55
      },
      "price": 65.58,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170655129797",
      "vsf_explanation": "Loose-leaf herbal tea bundle for detox, follicular, and luteal phase support. Fertility efficacy of herbal teas is not RCT-supported (Grant 2020 review found no reliable evidence). Per-herb doses per cup not disclosed; some herbs (e.g., red raspberry, vitex) require standardized dose to matter.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "cycle-syncing-ritual-roll-on-collection",
      "title": "Cycle Syncing Ritual Roll-On Collection",
      "vendor": "Ritual",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/RitualRollonCollectionMockUp.png?v=1777829236",
      "score": 22,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cycle",
        "syncing",
        "ritual",
        "roll",
        "collection",
        "ritual"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 20,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 27,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170655228101",
      "vsf_explanation": "Aromatherapy essential oil roll-ons for topical/ritual use. Not an ingestible supplement — outside the rubric.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "iui-ivf-prep-and-support-bundle",
      "title": "IUI/ IVF Prep and Support Bundle",
      "vendor": "Wisdom of the Womb",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/file_53701ed3-730c-4837-bdfc-207deaeafd43.jpg?v=1777829250",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "prenatal",
      "tokens": [
        "iui",
        "ivf",
        "prep",
        "and",
        "support",
        "bundle",
        "wisdom",
        "the",
        "womb"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health",
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 45,
        "transparency": 40,
        "sustainability": 55
      },
      "price": 363.73,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170656276677",
      "vsf_explanation": "Herbal tea bundle marketed for IVF/IUI success, egg quality, and implantation - explicit medical fertility outcomes. Herbal supplementation around ART lacks RCT support and can carry pharmacokinetic interactions with fertility medications (Dante 2014). No mg-per-serving disclosure for constituent botanicals.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "post-miscarriage-support-meditations",
      "title": "Post-Miscarriage Support Meditations",
      "vendor": "Wisdom of the Womb",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/wisdom-of-the-womb-meditation-post-miscarriage-meditations-36502780051694.jpg?v=1777829261",
      "score": 15,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "post",
        "miscarriage",
        "support",
        "meditations",
        "wisdom",
        "the",
        "womb"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 10,
        "manufacturing": 20,
        "safety": 60,
        "transparency": 20,
        "sustainability": 20
      },
      "price": 19.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170656309445",
      "vsf_explanation": "Digital guided meditation product. Not a supplement — no ingredient, dose, or manufacturing dimension exists.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "everyday-anointing-serums",
      "title": "Everyday Anointing Serums",
      "vendor": "Wisdom of the Womb",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ChatGPT_Image_Sep_15_2025_02_34_06_PM.png?v=1777829279",
      "score": 24,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "everyday",
        "anointing",
        "serums",
        "wisdom",
        "the",
        "womb"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 18,
        "formulation": 25,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170657063109",
      "vsf_explanation": "Topical body serum with plant oils. Cosmetic product, not an ingestible supplement — rubric does not apply.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fertility-meditations",
      "title": "Fertility Meditations",
      "vendor": "Wisdom of the Womb",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Meditations.png?v=1777829293",
      "score": 15,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "prenatal",
      "tokens": [
        "fertility",
        "meditations",
        "wisdom",
        "the",
        "womb"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 10,
        "manufacturing": 20,
        "safety": 60,
        "transparency": 20,
        "sustainability": 20
      },
      "price": 19.2,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170657226949",
      "vsf_explanation": "Digital audio meditation product. Not a supplement — supplement rubric does not apply.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "spermidine-supplement-from-chlorella-with-thiamin-zinc-biotin-vitamin-c-120-capsules-gluten-free-for-cellular-renewal-healthy-aging-vitality-support-60-day-supply",
      "title": "Spermidine Supplement from Chlorella with Thiamin, Zinc, Biotin, & Vitamin C | 120 Capsules | Gluten-Free for Cellular Renewal, Healthy Aging & Vitality Support | 60-Day Supply",
      "vendor": "FreshDrinkUS - Natural and Premium Herbal Tea",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_981a5286-f020-43b1-9c22-dca98cc23a0e.jpg?v=1777830299",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "skin",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "spermidine",
        "supplement",
        "from",
        "chlorella",
        "with",
        "thiamin",
        "zinc",
        "biotin",
        "vitamin",
        "120",
        "capsules",
        "gluten",
        "free",
        "for",
        "cellular",
        "renewal",
        "healthy",
        "aging",
        "vitality",
        "support",
        "day",
        "supply",
        "freshdrinkus",
        "natural",
        "and",
        "premium",
        "herbal",
        "tea"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 23.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170662404293",
      "vsf_explanation": "35 mg spermidine per softgel (from chlorella) exceeds many competitors' 1-5 mg doses, though observational human data (Kiechl 2018) is far from RCT-grade. Biotin 300 mcg, Zn 10 mg, Vit C 100 mg are reasonable adjuncts. Liposomal + piperine absorption claims lack disclosure of assay. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "black-seed-oil-bitters-liquid-16-fl-oz-premium-herbal-blend-with-black-seed-extract-curcumin-turmeric-extract-ashwagandha-elderberry-probiotics-vitamin-c-zinc",
      "title": "Black Seed Oil Bitters Liquid - 16 fl oz - Premium Herbal Blend with Black Seed Extract, Curcumin (Turmeric Extract), Ashwagandha, Elderberry, Probiotics, Vitamin C, Zinc",
      "vendor": "FreshDrinkUS - Natural and Premium Herbal Tea",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_e9344f78-7388-4606-97be-b310eb6a2f8e.jpg?v=1777830328",
      "score": 36,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "gut",
        "mood",
        "recovery",
        "cognitive",
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "black",
        "seed",
        "oil",
        "bitters",
        "liquid",
        "premium",
        "herbal",
        "blend",
        "with",
        "black",
        "seed",
        "extract",
        "curcumin",
        "turmeric",
        "extract",
        "ashwagandha",
        "elderberry",
        "probiotics",
        "vitamin",
        "zinc",
        "freshdrinkus",
        "natural",
        "and",
        "premium",
        "herbal",
        "tea"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 35,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 20,
        "sustainability": 45
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170662469829",
      "vsf_explanation": "Multi-ingredient herbal bitters liquid (black seed, curcumin, ashwagandha, elderberry, probiotics, vitamin C, zinc) with no dose disclosure on the product page. Each individual component has some evidence at proper doses (e.g., ashwagandha 300-600mg for stress, Chandrasekhar 2012) but shotgun blends dilute the therapeutic amount.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "probiotic-capsules-900-million-afu-of-akkermansia-clostridium-bifidobacterium-added-prebiotic-chicory-and-green-tea-exact",
      "title": "Probiotic Capsules - 900 Million AFU of Akkermansia, Clostridium, Bifidobacterium. Added Prebiotic Chicory and Green Tea Exact.",
      "vendor": "FreshDrinkUS - Natural and Premium Herbal Tea",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_521ac1a0-7562-4ab5-9162-a28d21135ba6.jpg?v=1777830338",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune",
        "energy",
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "probiotic",
        "capsules",
        "900",
        "million",
        "afu",
        "akkermansia",
        "clostridium",
        "bifidobacterium",
        "added",
        "prebiotic",
        "chicory",
        "and",
        "green",
        "tea",
        "exact",
        "freshdrinkus",
        "natural",
        "and",
        "premium",
        "herbal",
        "tea"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 27.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170662502597",
      "vsf_explanation": "900 million AFU probiotic with Akkermansia muciniphila, Clostridium, and Bifidobacterium. Akkermansia has metabolic evidence (Depommier 2019 pasteurized-A. muciniphila trial) but at 10^10 cells. 900M AFU is sub-therapeutic; strain identifiers are missing. No product description body.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "christensenella-minuta-and-akkermansia-bifidobacterium-longum-8-probiotic-strains-50-billion-cfu-with-cranberry-extract-gut-health-immune-support",
      "title": "Christensenella Minuta and Akkermansia, Bifidobacterium longum, 8 Probiotic Strains, 50 Billion CFU with Cranberry Extract, Gut Health & Immune Support",
      "vendor": "FreshDrinkUS - Natural and Premium Herbal Tea",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_1607ee1a-7d0e-4197-90e3-955a69407c0b.jpg?v=1777830354",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "christensenella",
        "minuta",
        "and",
        "akkermansia",
        "bifidobacterium",
        "longum",
        "probiotic",
        "strains",
        "billion",
        "cfu",
        "with",
        "cranberry",
        "extract",
        "gut",
        "health",
        "immune",
        "support",
        "freshdrinkus",
        "natural",
        "and",
        "premium",
        "herbal",
        "tea"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 55,
        "sustainability": 40
      },
      "price": 27.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170662600901",
      "vsf_explanation": "50 billion CFU across 8 named strains including next-gen commensals Akkermansia muciniphila (metabolic evidence per Depommier 2019) and Christensenella minuta plus L. rhamnosus GG, S. boulardii, and B. coagulans. Enteric-coated delivery, 200 mg cranberry with 40 mg PACs disclosed - unusually transparent for a small brand. Mid Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natural-support-formula-37-billion-probiotics-natural-akkermansia-chicory-inulin-berberine-vitamin-d-b2",
      "title": "Natural Support Formula | 37 Billion Probiotics – Natural Akkermansia, Chicory Inulin, Berberine - Vitamin D & B2",
      "vendor": "FreshDrinkUS - Natural and Premium Herbal Tea",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_ce28768a-9db1-4d71-9441-8f4e1c279605.jpg?v=1777830373",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "natural",
        "support",
        "formula",
        "billion",
        "probiotics",
        "natural",
        "akkermansia",
        "chicory",
        "inulin",
        "berberine",
        "vitamin",
        "freshdrinkus",
        "natural",
        "and",
        "premium",
        "herbal",
        "tea"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 30,
        "sustainability": 50
      },
      "price": 22.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170662666437",
      "vsf_explanation": "37B CFU probiotic multi-strain with berberine, chicory inulin, vitamin D, and B2. 37B CFU is a therapeutic range (McFarland 2015 meta-analysis) but no strain identifiers, no berberine mg, no vitamin doses. Berberine + probiotic is an unusual combo without established synergy trials.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "owl-supplement-kit",
      "title": "OWL Supplement Kit",
      "vendor": "OWL Venice",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/OWL60691.jpg?v=1777830390",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "owl",
        "supplement",
        "kit",
        "owl",
        "venice"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 25,
        "sustainability": 60
      },
      "price": 85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170662731973",
      "vsf_explanation": "Bundle of four wildcrafted herbal tinctures (Digestive Bitters, Liver Boost, Yeast Buster, Gut Sweep). Ethical wild-harvesting is a positive, but individual formulations are not disclosed, and 'liver detox' and 'yeast' claims lack clinical support (Klein 2015 review of herbal detox products found no efficacy).",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "organic-chicken-bone-broth-elixir",
      "title": "Organic Chicken Bone Broth Elixir",
      "vendor": "OWL Venice",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/OWLChickenBoneBrothElixir-5.webp?v=1777830402",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "chicken",
        "bone",
        "broth",
        "elixir",
        "owl",
        "venice"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 70,
        "transparency": 55,
        "sustainability": 65
      },
      "price": 96,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170662764741",
      "vsf_explanation": "Long-simmered organic chicken bone broth with free-range bones and herbs. Whole-food category; bone-broth collagen/glycine benefits are plausible but RCTs specific to joint/gut outcomes remain thin (Alcock 2018 review). No collagen or amino acid content quantified per serving.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "the-owl-organic-30-day-broth-challenge",
      "title": "The OWL Organic 30 Day Broth Challenge",
      "vendor": "OWL Venice",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/OWLMarch99805Dinwiddie.jpg?v=1777830418",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "the",
        "owl",
        "organic",
        "day",
        "broth",
        "challenge",
        "owl",
        "venice"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 70,
        "transparency": 55,
        "sustainability": 65
      },
      "price": 170,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170662895813",
      "vsf_explanation": "30-day challenge bundle of chicken/beef/turkey/vegan broths. Consistent-use broth protocol has some observational gut-lining benefit, but no RCT on this challenge and per-serving protein/collagen not disclosed. Real-food supplement adjunct.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "gut-sweep",
      "title": "Gut Sweep",
      "vendor": "OWL Venice",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/OWL-GutSweepSupplement-3.webp?v=1777830444",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gut",
        "sweep",
        "owl",
        "venice"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 25,
        "sustainability": 55
      },
      "price": 37,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170664206533",
      "vsf_explanation": "Aloe vera, marshmallow root, slippery elm capsules described as 'A proprietary blend' with no per-herb mg. Slippery elm and marshmallow have modest mucilage-based rationale for gut lining but no meaningful RCTs; standardized doses needed. Non-therapeutic if dose is too low.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "1-week-liver-boost-reset",
      "title": "1-Week Liver Boost Reset",
      "vendor": "OWL Venice",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/LiverBoostReset-6.webp?v=1777830455",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "week",
        "liver",
        "boost",
        "reset",
        "owl",
        "venice"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 30,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 15,
        "sustainability": 55
      },
      "price": 185,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170664272069",
      "vsf_explanation": "1-week 'liver reset' program with no ingredient disclosure in listing — treated as service/program more than a supplement. Liver detoxification claims via commercial products are not supported by evidence (Hodges 2015 review). At $185, this is a lifestyle-marketing product without formulation transparency.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "1-week-yeast-buster-reset",
      "title": "1-Week Yeast Buster Reset",
      "vendor": "OWL Venice",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/YeastBusterReset-6.webp?v=1777830467",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "week",
        "yeast",
        "buster",
        "reset",
        "owl",
        "venice"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 30,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 15,
        "sustainability": 55
      },
      "price": 185,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170664304837",
      "vsf_explanation": "Candida overgrowth as a general-wellness diagnosis is not recognized by mainstream medicine (Odds 1988 clinical review); systemic candidiasis requires antifungal medicine. Yeast Buster Reset is a wellness protocol with no ingredient or dose disclosure at $185.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "30-day-coffee-detox",
      "title": "30-Day Coffee Detox",
      "vendor": "OWL Venice",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CoffeeDetox-1.webp?v=1777830483",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "day",
        "coffee",
        "detox",
        "owl",
        "venice"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic",
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 25,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 15,
        "sustainability": 50
      },
      "price": 215,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170664337605",
      "vsf_explanation": "Caffeine cessation protocol is a behavioral program, not a supplement — no ingredient list is disclosed and detox framing lacks clinical grounding (Klein 2015). Withdrawal is best managed by tapering (Juliano & Griffiths 2004 caffeine withdrawal review), not by a $215 30-day product.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "dragons-blood-artisan-superfatted-cold-processed-castile-soap-for-the-face-and-body",
      "title": "Dragon's Blood - Artisan, Superfatted, Cold- Processed Castile Soap for the Face and Body",
      "vendor": "Keven Craft Rituals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/dragons-blood-handmade-soap-castile.jpg?v=1777830535",
      "score": 22,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dragon",
        "blood",
        "artisan",
        "superfatted",
        "cold",
        "processed",
        "castile",
        "soap",
        "for",
        "the",
        "face",
        "and",
        "body",
        "keven",
        "craft",
        "rituals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 25,
        "manufacturing": 40,
        "safety": 60,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170664370373",
      "vsf_explanation": "Handcrafted castile soap — cosmetic cleansing bar, not an ingestible supplement. Supplement rubric does not apply.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "persephone-intentional-essential-oil-blend-for-diffusers-anointing-spellwork",
      "title": "Persephone: Intentional Essential Oil Blend - For Diffusers, Anointing, & Spellwork",
      "vendor": "Keven Craft Rituals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/persephone-essential-oil-blend-keven.jpg?v=1777830555",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "persephone",
        "intentional",
        "essential",
        "oil",
        "blend",
        "for",
        "diffusers",
        "anointing",
        "spellwork",
        "keven",
        "craft",
        "rituals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 0,
        "transparency": 0,
        "sustainability": 0
      },
      "price": 22,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170664566981",
      "vsf_explanation": "Essential oil blend for diffusers/anointing — explicitly not ingestible and marketed for spellwork. Falls outside the supplement rubric entirely.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "olivea-hydroxytyrosol-supplement",
      "title": "Olivea Hydroxytyrosol Supplement",
      "vendor": "Olivea",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/olivea_extra_virgin_olive_oil_hydroxytyrosol_supplement.png?v=1777830999",
      "score": 76,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "olivea",
        "hydroxytyrosol",
        "supplement",
        "olivea"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 82,
        "manufacturing": 75,
        "safety": 80,
        "transparency": 78,
        "sustainability": 72
      },
      "price": 40,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170665189573",
      "vsf_explanation": "Delivers 20 mg hydroxytyrosol per capsule — 4x the 5 mg EFSA-recognized cardiovascular claim threshold — and independently lab-verified at 23.5 mg. Capsule-in-capsule design suspends the polyphenol in high-phenolic EVOO for improved lipophilic absorption. Hydroxytyrosol has RCT support for LDL oxidation reduction (Covas 2006). Cardiologist-formulated; Messinia sourcing is provenance-strong. Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ultra-high-phenolic-extra-virgin-olive-oil-1-000-mg-kg-polyphenols",
      "title": "Ultra High Phenolic Extra Virgin Olive Oil — 1,000+ mg/kg Polyphenols",
      "vendor": "Olivea",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2026_02_12-Olivea-Product0001.jpg?v=1777831006",
      "score": 79,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ultra",
        "high",
        "phenolic",
        "extra",
        "virgin",
        "olive",
        "oil",
        "000",
        "polyphenols",
        "olivea"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 80,
        "manufacturing": 78,
        "safety": 78,
        "transparency": 88,
        "sustainability": 72
      },
      "price": 45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170665255109",
      "vsf_explanation": "Lab-verified 1,000+ mg/kg polyphenols by University of Athens qNMR — the reference method for olive polyphenol quantification. 100% Olympia variety, Kalamata origin, Harvard-cardiologist medical board. Hydroxytyrosol has an EFSA-approved health claim at ≥5 mg/day (EFSA 2011). Solidly Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "high-phenolic-extra-virgin-olive-oil-500-mg-kg-polyphenols",
      "title": "High Phenolic Extra Virgin Olive Oil — 500+ mg/kg Polyphenols",
      "vendor": "Olivea",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/OliveaHighPhenolicExtraVirginOliveOil1_7d95420b-d71e-4713-b82d-857f097d67d1.jpg?v=1777831032",
      "score": 76,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "high",
        "phenolic",
        "extra",
        "virgin",
        "olive",
        "oil",
        "500",
        "polyphenols",
        "olivea"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 76,
        "manufacturing": 76,
        "safety": 76,
        "transparency": 85,
        "sustainability": 70
      },
      "price": 35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170665320645",
      "vsf_explanation": "587 mg/kg polyphenols, 100% Koroneiki, harvest-verified via University of Athens qNMR. Well above the EFSA 250 mg/kg threshold for the hydroxytyrosol claim (EFSA 2011). Same tight lineage and QA as Olivea's Ultra line, at a lower daily-driver polyphenol level. Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "olive-oil-extra-virgin-delallo",
      "title": "Olive Oil, Extra Virgin, DeLallo",
      "vendor": "Country Life Natural Foods",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/delallo-oil-3-ltr-olive-oil-extra-virgin-32415494570168.jpg?v=1777831044",
      "score": 65,
      "tier": "standard",
      "certifications": [
        "Kosher"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "olive",
        "oil",
        "extra",
        "virgin",
        "delallo",
        "country",
        "life",
        "natural",
        "foods"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 62.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170665353413",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 55 → new 65. Evidence found: Estruch R, Ros E, Salas-Salvadó J, et al. Primary Prevention of Cardiovascular Disease with a Mediterranean Diet Supplemented with Extra-Virgin Olive Oil or Nuts. N Engl J Med. 2018;378(25):e34. doi:10.1056/NEJMoa1800389 (PREDIMED, republished) | Guasch-Ferré M, Hu FB, Martínez-González MA, et al. Olive oil intake and risk of cardiovascular disease and mortality in the PREDIMED Study. BMC Med. 2014;12:78. doi:10.1186/1741-7015-12-78. Rationale: PREDIMED-class evidence provides TIER-C support for EVOO-at-studied-dose (~40-50 g/day) as a cardioprotective ingredient — but this is ingredient-level, not brand-specific to DeLallo. DeLallo publishes no phenolic-content assay and no third-party COOC/UC Davis authenticity/polyphenol certification, so we cannot verify it delivers the phenolic profile that drives the PREDIMED benefit. Modest +10 uplift to 65 reflects the ingredient-class evidence while holding brand-level uncertainty. Ceiling remains sub-70 (no Verified tier) until brand publishes a phenolic-content assay or a third-party authenticity certificate.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mr-papous-authentic-extra-virgin-olive-oil-family-tin",
      "title": "Mr. Papou's Authentic Extra Virgin Olive Oil Family Tin",
      "vendor": "Mr. Papou's",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Slide1.png?v=1777831050",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "papou",
        "authentic",
        "extra",
        "virgin",
        "olive",
        "oil",
        "family",
        "tin",
        "papou"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 65.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170665386181",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 58 → new 68. Evidence found: Estruch R, et al. NEJM 2018 (PREDIMED republished) — ingredient-level EVOO cardioprotection.. Rationale: Mr. Papou's is a single-origin small-producer Greek EVOO — the marketing implies high-phenol Koroneiki-style oil, which is the varietal category used in most PREDIMED sites. Still no independent phenolic-content assay published. +10 uplift to 68 for ingredient-class evidence plus provenance transparency (single-origin, small-producer). Would move to Verified 70+ with a third-party polyphenol assay or COOC seal.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mr-papous-authentic-extra-virgin-olive-oil",
      "title": "Mr. Papou's Authentic Extra Virgin Olive Oil",
      "vendor": "Mr. Papou's",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/DSC-1187_eb4aa924-87e9-4002-a1b6-d95883c4420a.jpg?v=1777831054",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "papou",
        "authentic",
        "extra",
        "virgin",
        "olive",
        "oil",
        "papou"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170665418949",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 58 → new 68. Evidence found: Same as family tin — PREDIMED class-level EVOO evidence.. Rationale: Same rationale as Mr. Papou's family tin — same product, smaller format. +10 uplift for ingredient-class RCT evidence and single-origin provenance transparency. Would move to Verified 70+ with a third-party polyphenol assay.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "olive-oil-extra-virgin-organic-braggs",
      "title": "Olive Oil, Extra Virgin, Organic, Braggs",
      "vendor": "Country Life Natural Foods",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/bragg-s-oil-1-gal-organic-olive-oil-extra-virgin-32538143490232.jpg?v=1777831065",
      "score": 66,
      "tier": "standard",
      "certifications": [
        "Kosher"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "olive",
        "oil",
        "extra",
        "virgin",
        "organic",
        "braggs",
        "country",
        "life",
        "natural",
        "foods"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 50,
        "sustainability": 60
      },
      "price": 18.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170665451717",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 56 → new 66. Evidence found: Estruch R, et al. NEJM 2018 (PREDIMED republished) — ingredient-level EVOO cardioprotection.. Rationale: Bragg's is a widely-recognized organic EVOO brand but publishes no brand-specific phenolic assay or third-party authenticity data. +10 uplift for ingredient-class RCT evidence (PREDIMED). Sub-70 ceiling until brand publishes independent polyphenol content or COOC certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "2-pack-16oz-2-in-1-glass-olive-oil-sprayer-dispenser",
      "title": "2-Pack 16oz 2-in-1 Glass Olive Oil Sprayer & Dispenser",
      "vendor": "Savory Home",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0fd0e506-ef66-421e-9863-50a8297df9e5.png?v=1777831078",
      "score": 12,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pack",
        "16oz",
        "glass",
        "olive",
        "oil",
        "sprayer",
        "dispenser",
        "savory",
        "home"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 5,
        "manufacturing": 30,
        "safety": 60,
        "transparency": 20,
        "sustainability": 20
      },
      "price": 21.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170665550021",
      "vsf_explanation": "Glass oil sprayer — a kitchen tool, not a supplement. No ingredient or evidence dimension applies.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "korvel-greek-olive-oil-set-4-flavors-in-elegant-bottles",
      "title": "KORVEL Greek Olive Oil Set - 4 Flavors in Elegant Bottles",
      "vendor": "Korvel",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Olive_Oil_-_mix_sq.jpg?v=1777831085",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "korvel",
        "greek",
        "olive",
        "oil",
        "set",
        "flavors",
        "elegant",
        "bottles",
        "korvel"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 65,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 40,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170665681093",
      "vsf_explanation": "Culinary Greek EVOO variety pack. High-polyphenol EVOO has cardiovascular support (PREDIMED, Estruch 2018), but this is a food product without polyphenol/oleocanthal content disclosure and is a culinary set rather than a therapeutic supplement.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "olive-oil-soap-bar",
      "title": "Olive Oil Soap Bar",
      "vendor": "Eastern Woven",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/DSCF1122.jpg?v=1777831099",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "olive",
        "oil",
        "soap",
        "bar",
        "eastern",
        "woven"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 20,
        "manufacturing": 40,
        "safety": 65,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 6.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170665746629",
      "vsf_explanation": "Turkish olive oil soap bar — cosmetic cleansing, not an ingestible supplement.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nucific®-bio-x4-4-in-1-weight-management-probiotic-supplement-90-count",
      "title": "Nucific® Bio-X4 4-in-1 Weight Management Probiotic Supplement, 90 Count.",
      "vendor": "Nucific",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/51Ij_uBeG1L._AC_SL1000.jpg?v=1777831119",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nucific",
        "bio",
        "weight",
        "management",
        "probiotic",
        "supplement",
        "count",
        "nucific"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 35,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 30,
        "sustainability": 35
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170665844933",
      "vsf_explanation": "Bio-X4 markets '4-in-1 weight management' via probiotics, digestive enzymes, appetite control (Caralluma fimbriata), and green tea. Caralluma weight-loss data is thin and inconsistent (Astell 2013). Ingredient mg amounts not disclosed in the listing; heavy weight-loss claims without controlled evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "serovital-renewal-complex-anti-aging-supplements-clearance-sale",
      "title": "Serovital Renewal Complex - Anti Aging Supplements - Clearance Sale",
      "vendor": "BalanceX",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71N6FqBkPHL._AC_SL1500.jpg?v=1777831139",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "serovital",
        "renewal",
        "complex",
        "anti",
        "aging",
        "supplements",
        "clearance",
        "sale",
        "balancex"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 40,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 67,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170666107077",
      "vsf_explanation": "Amino-acid complex (L-lysine, L-glutamine, L-cysteine) marketed as an oral hGH-boosting anti-aging supplement. The single 2012 Serovital study (Alba-Roth-style GH bolus) has never been independently replicated and was criticized for measuring a transient GH spike, not IGF-1 or clinical outcomes. Third-party reseller (BalanceX), 'Clearance Sale' framing.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "supplement-joint-care",
      "title": "Supplement: Joint Care",
      "vendor": "MAYA",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Maya_Joint_1.png?v=1777831147",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "supplement",
        "joint",
        "care",
        "maya"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 68,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170666139845",
      "vsf_explanation": "This is a canine joint chew, not a human supplement — evaluated at wrong species scope. Glucosamine + chondroitin + MSM has weak evidence in humans (GAIT trial 2006 negative for pain endpoint in OA), and canine data is even sparser (Bhathal 2017 review). Doses per chew not listed.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "nugenix-total-t-free-and-total-testosterone-booster-supplement-for-men-90-capsules",
      "title": "Nugenix Total-T – Free and Total Testosterone Booster Supplement for Men, 90 Capsules",
      "vendor": "Ballimart",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitled_design_87_e1b34c56-e7ae-41f0-ba30-4bfc4f2aca92.png?v=1777831155",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "nugenix",
        "total",
        "free",
        "and",
        "total",
        "testosterone",
        "booster",
        "supplement",
        "for",
        "men",
        "capsules",
        "ballimart"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health",
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 62,
        "safety": 60,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 37.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170666172613",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 57 → new 70. Evidence found: Maheshwari A, Verma N, Swaroop A, et al. Efficacy of FurosapTM, a novel Trigonella foenum-graecum seed extract, in Enhancing Testosterone Level and Improving Sperm Profile in Male Volunteers. Int J Med Sci. 2017;14(1):58-66. doi:10.7150/ijms.17256 | Sreeraj G, Chatterjee A, Nemani H, et al. Tesnor®, A Proprietary Herbal Blend of Punica granatum Fruit Rind and Theobroma cocoa Seeds… Increases Serum Testosterone Level. J Am Nutr Assoc. 2023;42(1):10-18. doi:10.1080/07315724.2021.1978348 | Leisegang K, Finelli R, Sikka SC, Panner Selvam MK. Eurycoma longifolia (Jack) Improves Serum Total Testosterone in Men: A Systematic Review and Meta-Analysis of Clinical Trials. Medicina (Kaunas). 2022;58(8):1047. doi:10.3390/medicina58081047. Rationale: Nugenix Total-T's three headline actives — Testofen/Furosap fenugreek, Tesnor, and tongkat ali — each have peer-reviewed RCTs at doses matching what Nugenix discloses on the label. No RCT on the full Total-T formula exists (still TIER-B, not TIER-A), but the ingredient-stack alignment is unusually good for this category. +13 uplift to 70 crosses into Verified. Ceiling held because a full-formula RCT would be needed for Elite (85+).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nugenix-total-t-free-total-testosterone-booster-90-count-three-pack-boosts-lean-muscle-mass-amp-male-vitality",
      "title": "Nugenix Total-T - Free & Total Testosterone Booster - 90 Count (Three Pack) - Boosts Lean Muscle Mass &amp; Male Vitality",
      "vendor": "Ballimart",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitled_design_-_2026-03-10T185739.869.png?v=1777831168",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "nugenix",
        "total",
        "free",
        "total",
        "testosterone",
        "booster",
        "count",
        "three",
        "pack",
        "boosts",
        "lean",
        "muscle",
        "mass",
        "amp",
        "male",
        "vitality",
        "ballimart"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health",
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 62,
        "safety": 60,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 86.77,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170666205381",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 57 → new 70. Evidence found: Same three RCTs as single-pack — identical formula.. Rationale: Same rationale as the single-pack — identical formula. +13 uplift to 70.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "stonehenge-health-dynamic-brain-supplement-memory-focus-mental-clarity-60-capsules",
      "title": "Stonehenge Health Dynamic Brain Supplement – Memory, Focus Mental Clarity | 60 Capsules",
      "vendor": "Ballimart",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Stonehenge_Health_Dynamic_Brain_Supplement_Memory_Focus_Mental_Clarity_60_Capsules.jpg?v=1777831181",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "stonehenge",
        "health",
        "dynamic",
        "brain",
        "supplement",
        "memory",
        "focus",
        "mental",
        "clarity",
        "capsules",
        "ballimart"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 52,
        "sustainability": 45
      },
      "price": 30.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170666303685",
      "vsf_explanation": "Stonehenge Dynamic Brain — 40-ingredient nootropic with BacoMind, phosphatidylserine, Huperzine A, DMAE, DHA. Sold via Ballimart (Amazon-reseller-style vendor) at retail markup. Underlying formula is legit (per Stonehenge anchor); provenance drags Standard rather than Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "stonehenge-health-dynamic-brain-advanced-nootropic-supplement-for-memory-focus-amp-clarity-pack-of-2",
      "title": "Stonehenge Health Dynamic Brain – Advanced Nootropic Supplement for Memory, Focus &amp; Clarity( Pack of 2)",
      "vendor": "Ballimart",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Stonehenge_Health_Dynamic_Brain_Advanced_Nootropic_Supplement_for_Memory_Focus_amp_Clarity_Pack_of_2.jpg?v=1777831185",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "stonehenge",
        "health",
        "dynamic",
        "brain",
        "advanced",
        "nootropic",
        "supplement",
        "for",
        "memory",
        "focus",
        "amp",
        "clarity",
        "pack",
        "ballimart"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 52,
        "sustainability": 45
      },
      "price": 50.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170666336453",
      "vsf_explanation": "Dynamic Brain + Dynamic Mushrooms bundle via Ballimart. Same 40-ingredient nootropic plus 1,000 mg Lion's Mane fruiting-body extract stack. cGMP US made, non-GMO, gluten-free. Amazon-reseller provenance keeps it Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "happy-mammoth-hormone-harmony-vegan-menopause-support-hormone-balance-hot-flash-mood-relief-72-capsules",
      "title": "Happy Mammoth Hormone Harmony – Vegan Menopause Support | Hormone Balance, Hot Flash & Mood Relief (72 Capsules)",
      "vendor": "Ballimart",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Happy_Mammoth_Hormone_Harmony.png?v=1777831196",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone",
        "mood"
      ],
      "sex_relevance": "female",
      "life_stage": "postmenopausal",
      "tokens": [
        "happy",
        "mammoth",
        "hormone",
        "harmony",
        "vegan",
        "menopause",
        "support",
        "hormone",
        "balance",
        "hot",
        "flash",
        "mood",
        "relief",
        "capsules",
        "ballimart"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health",
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 45,
        "transparency": 30,
        "sustainability": 50
      },
      "price": 48.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170666369221",
      "vsf_explanation": "Explicitly labeled as a 'proprietary plant-based herbal blend' with no per-ingredient doses. Menopause hot-flash relief is a specific therapeutic claim that requires validated actives (Franco 2016 JAMA review on phytoestrogens showed modest effect). Third-party seller listing further muddies provenance.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "humann-superbeets-circulation-gummies-60-count-heart-healthy-energy-with-grape-seed-extract-beet-root-powder",
      "title": "humanN SuperBeets Circulation Gummies – 60 Count  Heart-Healthy Energy with Grape Seed Extract & Beet Root Powder",
      "vendor": "Ballimart",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitled_design_101.png?v=1777831216",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "humann",
        "superbeets",
        "circulation",
        "gummies",
        "count",
        "heart",
        "healthy",
        "energy",
        "with",
        "grape",
        "seed",
        "extract",
        "beet",
        "root",
        "powder",
        "ballimart"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170666401989",
      "vsf_explanation": "humanN grape-seed-extract + beet-root gummies. French grape seed extract has BP-lowering RCT support (Feringa 2011 meta) and beetroot nitrates lower systolic BP acutely (Siervo 2013). This resale listing does not disclose per-serving mg of grape seed extract or beet powder, which limits verification. 'Doctor recommended' is marketing shorthand.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "uro-vaginal-probiotics-for-women-ph-balance-with-prebiotics-lactobacillus-probiotic-blend-womens-vaginal-health-supplement-promote-healthy-vaginal-odor-vaginal-flora-60-count",
      "title": "URO Vaginal Probiotics for Women pH Balance with Prebiotics & Lactobacillus Probiotic Blend - Women's Vaginal Health Supplement - Promote Healthy Vaginal Odor & Vaginal Flora, 60 Count",
      "vendor": "URO",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/UROVaginalProbioticsCapsules.jpg?v=1777831224",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "uro",
        "vaginal",
        "probiotics",
        "for",
        "women",
        "balance",
        "with",
        "prebiotics",
        "lactobacillus",
        "probiotic",
        "blend",
        "women",
        "vaginal",
        "health",
        "supplement",
        "promote",
        "healthy",
        "vaginal",
        "odor",
        "vaginal",
        "flora",
        "count",
        "uro"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170666500293",
      "vsf_explanation": "5-strain Lactobacillus blend with prebiotics for vaginal microbiome. L. crispatus and L. reuteri have RCT support for BV recurrence reduction (Reid 2003; Petricevic 2008), but this label does not disclose CFU count or strain identifiers (e.g., GR-1, RC-14) needed to verify therapeutic dosing. Made in USA, non-GMO.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "neurohacker-collective-qualia-mind-doctor-formulated-nootropic-to-fuel-focus-concentration",
      "title": "NEUROHACKER COLLECTIVE Qualia Mind | Doctor-Formulated Nootropic to Fuel Focus & Concentration",
      "vendor": "Neurohacker Collective",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71RgN-XDO7L_db5e5244-ce29-43b1-9acf-3689347391f0.jpg?v=1777831238",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "neurohacker",
        "collective",
        "qualia",
        "mind",
        "doctor",
        "formulated",
        "nootropic",
        "fuel",
        "focus",
        "concentration",
        "neurohacker",
        "collective"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 65,
        "manufacturing": 65,
        "safety": 55,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 79.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170667745477",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 60 → new 68. Evidence found: ClinicalTrials.gov NCT04389723 — 'Randomized, Double-Blind, Placebo-Controlled Crossover Study of Qualia Mind on Cognition in a Healthy Population' (registered by Neurohacker Collective; results pending peer-reviewed publication). | Kean JD, Downey LA, Stough C. A systematic review of the Ayurvedic medicinal herb Bacopa monnieri in child and adolescent populations. Complement Ther Med. 2016;29:56-62. doi:10.1016/j.ctim.2016.09.002 (class-level Bacopa). Rationale: Qualia Mind's saving grace is that unlike Dynamic Brain, it discloses per-ingredient doses, and several of its actives (Bacopa 300 mg, Alpha-GPC, Citicoline 150 mg, N-acetyl-L-tyrosine, Rhodiola 300 mg) hit their published studied doses. TIER-C evidence at ingredient level. A registered product-specific double-blind RCT (NCT04389723) exists but full results are not yet in a peer-reviewed journal — so no TIER-B credit until published. +8 uplift to 68. Sub-70 ceiling until NCT04389723 publishes.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natural-cognitive-enhancement-supplement-capsule-non-gmo-vegan-gluten-free",
      "title": "Natural Cognitive Enhancement Supplement Capsule - Non-GMO, Vegan, Gluten-Free",
      "vendor": "Vyvata",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/natural_cognitive_enhancer_35ff84fc-8b5f-4311-a82f-ec774665c0c4.jpg?v=1777831258",
      "score": 48,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "natural",
        "cognitive",
        "enhancement",
        "supplement",
        "capsule",
        "non",
        "gmo",
        "vegan",
        "gluten",
        "free",
        "vyvata"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170667876549",
      "vsf_explanation": "Amazon-relabeled RediMind clone (Alpha-GPC, Huperzine A, Bacopa, Lion's Mane, Ginkgo) with 'clinically studied amounts' language but no per-ingredient mg. Bacopa RCTs use 300 mg standardized bacosides (Stough 2001); no way to verify this hits it. Rejected.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "instaflex-advanced-joint-support-supplement-turmeric-resveratrol-boswellia-serrata-extract-bioperine-uc-ii-collagen-30-count",
      "title": "Instaflex Advanced Joint Support Supplement - Turmeric, Resveratrol, Boswellia Serrata Extract, BioPerine, UC-II Collagen- 30 Count",
      "vendor": "Instaflex",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/InstaflexAdvancedJointSupportSupplement_8ea37468-ce0f-472c-9574-18909beb0d44.jpg?v=1777831269",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint",
        "skin",
        "longevity",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "instaflex",
        "advanced",
        "joint",
        "support",
        "supplement",
        "turmeric",
        "resveratrol",
        "boswellia",
        "serrata",
        "extract",
        "bioperine",
        "collagen",
        "count",
        "instaflex"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 50,
        "sustainability": 40
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170667942085",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 54 → new 65. Evidence found: Nieman DC, Shanely RA, Luo B, et al. A commercialized dietary supplement alleviates joint pain in community adults: a double-blind, placebo-controlled community trial. Nutr J. 2013;12:154. doi:10.1186/1475-2891-12-154 (PARENT Instaflex formula, not Advanced) | ClinicalTrials.gov NCT03041077 — Nieman et al., Appalachian State University, 12-week trial on Instaflex Advanced (registered 2017, primary completion 2018); no confirmed peer-reviewed publication as of Aug 2026. | Bannuru RR, Osani MC, Al-Eid F, Wang C. Efficacy of curcumin and Boswellia for knee osteoarthritis: Systematic review and meta-analysis. Semin Arthritis Rheum. 2018;48(3):416-429. doi:10.1016/j.semarthrit.2018.03.001. Rationale: Instaflex Advanced's key ingredients (curcumin/turmeric, Boswellia serrata via 5-Loxin/AprèsFlex, and resveratrol) each have TIER-B meta-analysis and RCT support at studied doses for knee OA. The Advanced-specific trial (NCT03041077) was completed at Appalachian State under Nieman (same lab that published the original Instaflex Nutrition Journal trial) but has NOT yet published in a PubMed-indexed journal as of Aug 2026. +11 uplift to 65 credits the ingredient-level meta-analyses; sub-70 held until NCT03041077 formally publishes. If that paper appears, this could move to 72-75.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "popstar-labs-semen-volume-booster-mens-semen-health-fertility-supplement-doctor-formulated-to-increase-load-volume-made-in-usa-non-gmo-organic-vegan-120-capsules-1-month-supply",
      "title": "POPSTAR Labs Semen Volume Booster - Men's Semen Health & Fertility Supplement - Doctor Formulated to Increase Load Volume - Made in USA - Non-GMO, Organic, Vegan - 120 Capsules (1 Month Supply)",
      "vendor": "Popstar Labs",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/616prrVOOGL_a45e8947-4282-4c64-903f-dcfba222427e.jpg?v=1777831286",
      "score": 43,
      "tier": "rejected",
      "certifications": [
        "GMP Certified",
        "USDA Organic"
      ],
      "goal_tags": [],
      "sex_relevance": "male",
      "life_stage": "prenatal",
      "tokens": [
        "popstar",
        "labs",
        "semen",
        "volume",
        "booster",
        "men",
        "semen",
        "health",
        "fertility",
        "supplement",
        "doctor",
        "formulated",
        "increase",
        "load",
        "volume",
        "made",
        "usa",
        "non",
        "gmo",
        "organic",
        "vegan",
        "120",
        "capsules",
        "month",
        "supply",
        "popstar",
        "labs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 40,
        "sustainability": 55
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170668564677",
      "vsf_explanation": "Bromelain, pygeum, lecithin, zinc, L-arginine, and pineapple extract for 'semen volume' — the endpoint has essentially no rigorous RCT evidence, and individual doses are not disclosed on the marketing page. GMP-certified and vegan is fine, but the claim is a novelty-marketing one.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "total-omega-3-fish-oil-2200mg-made-from-antarctic-krill-w-astaxanthin-wild-sockeye-salmon-alaska-pollock-960mg-of-epa-dha-120-softgels",
      "title": "Total Omega-3 Fish Oil 2200mg - Made from Antarctic Krill w/Astaxanthin, Wild Sockeye Salmon & Alaska Pollock - 960mg of EPA & DHA - 120 Softgels",
      "vendor": "Vyvata",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/61W9UDqoIML._AC_SL1500.jpg?v=1777831299",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "total",
        "omega",
        "fish",
        "oil",
        "2200mg",
        "made",
        "from",
        "antarctic",
        "krill",
        "astaxanthin",
        "wild",
        "sockeye",
        "salmon",
        "alaska",
        "pollock",
        "960mg",
        "epa",
        "dha",
        "120",
        "softgels",
        "vyvata"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 75,
        "manufacturing": 72,
        "safety": 72,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170668662981",
      "vsf_explanation": "Sports Research reformulation — 2,200 mg omega-3 total with 960 mg EPA/DHA plus krill phospholipids and astaxanthin. Wax-ester + phospholipid delivery has better absorption vs. ethyl esters (Schuchardt 2011). Third-party tested, IFOS-style purity claims, non-GMO verified. Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "jocko-fuel-joint-support-supplement-glucosamine-msm-for-joint-pain180-capsules",
      "title": "Jocko Fuel Joint Support Supplement - Glucosamine MSM for Joint Pain(180 Capsules)",
      "vendor": "Jocko Fuel",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/61J-An2hOEL._AC_SL1500.jpg?v=1777831311",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "jocko",
        "fuel",
        "joint",
        "support",
        "supplement",
        "glucosamine",
        "msm",
        "for",
        "joint",
        "pain",
        "180",
        "capsules",
        "jocko",
        "fuel"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170668794053",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 50 → new 63. Evidence found: Reginster JY, Deroisy R, Rovati LC, et al. Long-term effects of glucosamine sulphate on osteoarthritis progression: a randomised, placebo-controlled clinical trial. Lancet. 2001;357(9252):251-256. doi:10.1016/S0140-6736(00)03610-2 | Kim LS, Axelrod LJ, Howard P, et al. Efficacy of methylsulfonylmethane (MSM) in osteoarthritis pain of the knee: a pilot clinical trial. Osteoarthritis Cartilage. 2006;14(3):286-294. doi:10.1016/j.joca.2005.10.003. Rationale: Jocko Joint Warfare uses glucosamine + MSM + turmeric + Boswellia at plausible doses (3 caps/day format). Each of the four actives has independent RCT support. However, Jocko uses glucosamine HCl (not sulfate) — Reginster's landmark trial was specifically on glucosamine SULFATE, and meta-analyses suggest HCl form is less consistent. +13 uplift to 63. Sub-70 held because (a) glucosamine HCl form is less-well studied than sulfate, and (b) no product-specific RCT.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mushroom-coffee-premium-organic-mushroom-coffee-blend-with-adaptogens-for-focus-energy-immunity",
      "title": "Mushroom Coffee – Premium Organic Mushroom Coffee Blend with Adaptogens for Focus, Energy & Immunity",
      "vendor": "Mushroom Coffee",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ryze-mushroom-coffee-2-packa12b5ryze-802517.webp?v=1777831321",
      "score": 43,
      "tier": "rejected",
      "certifications": [
        "USDA Organic"
      ],
      "goal_tags": [
        "immune",
        "mood",
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mushroom",
        "coffee",
        "premium",
        "organic",
        "mushroom",
        "coffee",
        "blend",
        "with",
        "adaptogens",
        "for",
        "focus",
        "energy",
        "immunity",
        "mushroom",
        "coffee"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 35,
        "sustainability": 60
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170668826821",
      "vsf_explanation": "RYZE lumps six mushrooms (Cordyceps, Lion's Mane, Reishi, Shiitake, Turkey Tail, King Trumpet) into a 2000mg proprietary blend — so per-mushroom dose is ~333mg at most, below the 1-3g used in cognitive/immunity RCTs for lion's mane (Mori 2009) or reishi. USDA Organic and beta-glucan spec are positives, but the dosing story doesn't hold up.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "qunol-ultra-coq10-100mg-softgels-3x-better-absorption-coenzyme-q10-supplements-antioxidant-supplement-for-vascular-and-heart-health-energy-production-5-month-supply-150-count",
      "title": "Qunol Ultra CoQ10 100mg Softgels- 3X Better Absorption Coenzyme Q10 Supplements - Antioxidant Supplement for Vascular and Heart Health & Energy Production - 5 Month Supply - 150 Count",
      "vendor": "Qunol",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71xvaRje3hL_fbf69568-f4ef-4e19-84a4-878db0881903.jpg?v=1777831415",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "qunol",
        "ultra",
        "coq10",
        "100mg",
        "softgels",
        "better",
        "absorption",
        "coenzyme",
        "q10",
        "supplements",
        "antioxidant",
        "supplement",
        "for",
        "vascular",
        "and",
        "heart",
        "health",
        "energy",
        "production",
        "month",
        "supply",
        "150",
        "count",
        "qunol"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 70,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170669056197",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 60 → new 68. Evidence found: Mortensen SA, Rosenfeldt F, Kumar A, et al. The Effect of Coenzyme Q10 on Morbidity and Mortality in Chronic Heart Failure: Results From Q-SYMBIO. JACC Heart Fail. 2014;2(6):641-649. doi:10.1016/j.jchf.2014.06.008 | Miles MV. The uptake and distribution of coenzyme Q10. Mitochondrion. 2007;7 Suppl:S72-S77. doi:10.1016/j.mito.2007.02.012 (bioavailability review). Rationale: CoQ10 has TIER-A evidence (Q-SYMBIO) in heart failure at 300 mg/day. Qunol Ultra is a solubilized formulation and 100 mg is at the LOW end of the studied 300 mg dose — a single Qunol softgel/day would deliver only 1/3 the Q-SYMBIO dose. Qunol has not published brand-specific PK data in a peer-reviewed journal verifying the '3x' claim, though the solubilized-CoQ10 class does show 2-3× AUC improvements. +8 uplift to 68 credits solubilized-form advantage. Sub-70 held because at 100 mg/day this SKU is sub-therapeutic vs Q-SYMBIO unless taken 3×/day.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ashwagandha",
      "title": "Ashwagandha",
      "vendor": "FORTCORE.US",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5_e4500df3-fcbb-44a3-b00b-dc194b19677a.png?v=1777831453",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ashwagandha",
        "fortcore"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 55,
        "manufacturing": 48,
        "safety": 55,
        "transparency": 48,
        "sustainability": 50
      },
      "price": 29.88,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170669154501",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 54 → new 62. Evidence found: Salve J, Pate S, Debnath K, Langade D. Adaptogenic and Anxiolytic Effects of Ashwagandha Root Extract in Healthy Adults: A Double-blind, Randomized, Placebo-controlled Clinical Study. Cureus. 2019;11(12):e6466. doi:10.7759/cureus.6466 | Akhgarjand C, et al. Does Ashwagandha supplementation have a beneficial effect on the management of anxiety and stress? A systematic review and meta-analysis of RCTs. Phytother Res. 2022;36(11):4115-4124. doi:10.1002/ptr.7598. Rationale: Ashwagandha ingredient has strong TIER-A meta-analysis support for stress/anxiety at 250-600 mg/day. FORTCORE.US 'Ashwagandha' does not disclose extract standardization (KSM-66, Sensoril, Shoden, or generic) and does not disclose withanolide content — critical because Withania somnifera extracts vary dramatically in withanolide %. +8 uplift to 62 for ingredient-level RCT evidence. Sub-70 held pending withanolide standardization disclosure. Would move to Verified 70+ if FORTCORE published a standardization spec (e.g., 'standardized to 5% withanolides').",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ashwagandha-1",
      "title": "Ashwagandha",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ASHSPTs2_656490092720_Ashwagandha_background_1c48b220-3d3e-43fa-9e24-5e2ed1779090.jpg?v=1777831458",
      "score": 47,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ashwagandha",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170669187269",
      "vsf_explanation": "Liquid ashwagandha tincture with no withanolide content, no extract standardization, and no per-pump ashwagandha weight disclosed. Clinical ashwagandha efficacy is tied to KSM-66 or Sensoril extracts at 300-600 mg/day (Chandrasekhar Indian J Psychol Med 2012); tinctures at 4 pumps × 2-4 times daily cannot be dose-mapped to trial evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sensoril®-ashwagandha",
      "title": "SENSORIL® ASHWAGANDHA",
      "vendor": "BLACKLABEL Supplements",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign23.png?v=1777831465",
      "score": 76,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sensoril",
        "ashwagandha",
        "blacklabel",
        "supplements"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental",
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 27.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170669220037",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 62 → new 76. Evidence found: Auddy B, Hazra J, Mitra A, Abedon B, Ghosal S. A standardized Withania somnifera extract significantly reduces stress-related parameters in chronically stressed humans: a double-blind, randomized, placebo-controlled study. J Am Nutraceutical Assoc. 2008;11(1):50-56. (SENSORIL specifically) | Ziegenfuss TN, et al. Effects of an Aqueous Extract of Withania somnifera on Strength Training Adaptations and Recovery: The STAR Trial. Nutrients. 2018;10(11):1807. doi:10.3390/nu10111807 | Salve J, et al. Cureus 2019 — Sensoril 125 mg reduced anxiety and cortisol.. Rationale: Sensoril is one of only 3 branded ashwagandha extracts with multiple RCTs on the SPECIFIC branded ingredient (the others are KSM-66 and Shoden). TIER-A on the branded ingredient. BLACKLABEL discloses using Sensoril at a dose in the studied range. +14 uplift to 76 crosses into Verified. Elite (85+) requires a full-formula RCT on the BLACKLABEL SKU itself, which does not exist.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "calm-patches-relaxation-stress-relief-with-gaba-ashwagandha-l-theanine-passion-flower-magnesium-36-patches",
      "title": "Calm Patches Relaxation & Stress Relief with GABA, Ashwagandha, L-Theanine, Passion Flower, Magnesium, 36 patches",
      "vendor": "TOLEVITA",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/mainpic.jpg?v=1777831472",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "cognitive",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "calm",
        "patches",
        "relaxation",
        "stress",
        "relief",
        "with",
        "gaba",
        "ashwagandha",
        "theanine",
        "passion",
        "flower",
        "magnesium",
        "patches",
        "tolevita"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 30,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170669252805",
      "vsf_explanation": "Transdermal patch delivering only 5 mg GABA (RCTs use 100-800 mg orally; Abdou 2006) plus tiny ashwagandha, L-theanine, magnesium doses. GABA has poor blood-brain crossing even orally, and transdermal absorption of these polar molecules is not established. Sub-therapeutic on multiple actives.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "ashwagandha-450mg",
      "title": "Ashwagandha 450mg",
      "vendor": "Country Life Natural Foods",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Ashwagandha_450mg-316604.png?v=1777831483",
      "score": 62,
      "tier": "standard",
      "certifications": [
        "Kosher"
      ],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ashwagandha",
        "450mg",
        "country",
        "life",
        "natural",
        "foods"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 52,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 14.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170700382405",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 54 → new 62. Evidence found: Akhgarjand C, et al. Meta-analysis of ashwagandha RCTs for stress/anxiety. Phytother Res. 2022. (ingredient class). Rationale: Same as FORTCORE ashwagandha — ingredient-class TIER-A meta-analysis but no withanolide standardization disclosed on Country Life label. +8 uplift to 62 for ingredient evidence. 450 mg is in the studied dose range. Sub-70 held until brand publishes extract standardization and withanolide %.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zinc-picolinate-50mg",
      "title": "Zinc Picolinate 50mg",
      "vendor": "Country Life Natural Foods",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Zinc_Picolinate_50mg11-497054.png?v=1777831494",
      "score": 48,
      "tier": "standard",
      "certifications": [
        "GMP Certified",
        "Kosher",
        "Halal"
      ],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zinc",
        "picolinate",
        "50mg",
        "country",
        "life",
        "natural",
        "foods"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 45,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 7.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170700415173",
      "vsf_explanation": "[Rescored — SAFETY DOWNGRADE via evidence crawl] Previous score 55 → new 48. Evidence found: Institute of Medicine (US) Panel on Micronutrients. Dietary Reference Intakes for Vitamin A, Vitamin K, Arsenic, Boron, Chromium, Copper, Iodine, Iron, Manganese, Molybdenum, Nickel, Silicon, Vanadium, and Zinc. Washington (DC): National Academies Press; 2001. Chapter on Zinc. | Willis MS, Monaghan SA, Miller ML, et al. Zinc-induced copper deficiency: a report of three cases initially recognized on bone marrow examination. Am J Clin Pathol. 2005;123(1):125-131. doi:10.1309/V6GVYW2QTYD5C5PJ. Rationale: 50 mg elemental zinc/day EXCEEDS the IOM tolerable upper intake level (40 mg/day) for adults. Chronic supplementation at 50+ mg/day causes copper deficiency, anemia, and neurologic symptoms in a subset of users, especially when taken long-term (>3 months) without concurrent copper. Country Life labels this as '50 mg elemental zinc' without a UL warning or paired copper. This is a SAFETY issue, not an efficacy issue. Recommend -7 downgrade to 48 and adding a safety warning FAQ. Would return to 55 with (a) label warning about UL and (b) recommended max duration.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chlorophyll-100-mg",
      "title": "Chlorophyll 100 mg",
      "vendor": "Country Life Natural Foods",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Chlorophyll_100_mg-481446.png?v=1777831499",
      "score": 55,
      "tier": "standard",
      "certifications": [
        "Kosher"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chlorophyll",
        "100",
        "country",
        "life",
        "natural",
        "foods"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 65,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 14.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170700480709",
      "vsf_explanation": "Sodium copper chlorophyllin 100 mg, non-GMO/kosher/vegan. Chlorophyllin's clearest evidence is for aflatoxin binding (Egner 2003 Qidong RCT) rather than systemic antioxidant claims. Country Life's GMP-registered manufacturing lifts the manufacturing score.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zinc-50mg",
      "title": "Zinc 50mg",
      "vendor": "Country Life Natural Foods",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ZincTablets50mg.png?v=1777831504",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zinc",
        "50mg",
        "country",
        "life",
        "natural",
        "foods"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants",
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 30,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 7.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170700513477",
      "vsf_explanation": "50mg zinc daily exceeds the NIH tolerable upper limit of 40mg and can precipitate copper deficiency with anemia and neuropathy in weeks (Fischer 1984; Willis 2005). Common therapeutic dose is 8-15mg maintenance or 40-75mg for acute cold onset (Hemila 2017 lozenge meta-analysis). Zinc form not specified (picolinate/citrate/oxide differ ~2x in absorption).",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "vitamin-d-3-10-000-iu-high-potency",
      "title": "Vitamin D-3 10,000 IU High Potency",
      "vendor": "Country Life Natural Foods",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Vitamin_D-3_10_000_IU_High_Potency11-614550.png?v=1777831508",
      "score": 62,
      "tier": "standard",
      "certifications": [
        "GMP Certified",
        "Kosher",
        "Halal"
      ],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "000",
        "high",
        "potency",
        "country",
        "life",
        "natural",
        "foods"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 60,
        "manufacturing": 65,
        "safety": 55,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 12.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170700546245",
      "vsf_explanation": "NOW-manufactured D3 softgel at 10,000 IU per softgel — NPA A-rated GMP, kosher, non-GMO. Effective D3 dose for deficiency is 1,000–5,000 IU/day (Holick 2011); 10,000 IU daily long-term risks hypercalcemia without 25-OH monitoring. Standard — good QA but potency exceeds routine daily need.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-d-3-5-000-iu-high-potency",
      "title": "Vitamin D-3 5,000 IU High Potency",
      "vendor": "Country Life Natural Foods",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Vitamin_D-3_5_000_IU_High_Potency11-188496.png?v=1777831516",
      "score": 72,
      "tier": "verified",
      "certifications": [
        "GMP Certified",
        "Kosher",
        "Halal"
      ],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "000",
        "high",
        "potency",
        "country",
        "life",
        "natural",
        "foods"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 68,
        "manufacturing": 65,
        "safety": 68,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 17.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170700611781",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 67 → new 72. Evidence found: Pilz S, Zittermann A, Trummer C, et al. Vitamin D testing and treatment: a narrative review of current evidence. Endocr Connect. 2019;8(2):R27-R43. doi:10.1530/EC-18-0432 | Villasis-Keever MA, López-Alarcón MG, Miranda-Novales G, et al. Efficacy and Safety of Vitamin D Supplementation to Prevent COVID-19 in Frontline Healthcare Workers. A Randomized Clinical Trial. Arch Med Res. 2022;53(4):423-430. doi:10.1016/j.arcmed.2022.04.003. Rationale: 5,000 IU/day sits at the therapeutic sweet spot — well-supported for correcting deficiency and safe in most adults short-to-medium term, with the Calgary trial's harmful bone-density signal appearing only at 10,000 IU (not 5,000). Multiple RCTs. +5 uplift to 72 crosses into Verified. Ceiling held below 80 because vitamin D benefit is highly individual (depends on baseline 25(OH)D and sun exposure) and long-term unsupervised use still warrants periodic 25(OH)D monitoring.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "xanthan-gum-bobs-red-mill",
      "title": "Xanthan Gum, Bob's Red Mill",
      "vendor": "Country Life Natural Foods",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BRMXanthanGum.jpg?v=1777831521",
      "score": 30,
      "tier": "rejected",
      "certifications": [
        "Kosher"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "xanthan",
        "gum",
        "bob",
        "red",
        "mill",
        "country",
        "life",
        "natural",
        "foods"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 45,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 21.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170700644549",
      "vsf_explanation": "Xanthan gum is a baking ingredient (gluten-free thickener), not a supplement — should be recategorized. It has FDA GRAS status but oral therapeutic supplementation is not evidence-based, and infant enterocolitis has been reported (Woods 2012 FDA review of SimplyThick).",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "vitamin-c-crystals-powder",
      "title": "Vitamin C Crystals Powder",
      "vendor": "Country Life Natural Foods",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Vitamin_C_Crystals_Powder-106197.png?v=1777831530",
      "score": 62,
      "tier": "standard",
      "certifications": [
        "Kosher",
        "Halal"
      ],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "crystals",
        "powder",
        "country",
        "life",
        "natural",
        "foods"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 11.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170700677317",
      "vsf_explanation": "Pure pharmaceutical-grade ascorbic acid powder, sold by NOW Foods (per description). Straightforward single-ingredient product avoids formulation issues; user controls the dose. Non-GMO, kosher, vegan, gluten-free. NOW's NPA A-rated GMP is a legitimate credential. Solid upper-Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-d-3-2-000-iu",
      "title": "Vitamin D-3 2,000 IU",
      "vendor": "Country Life Natural Foods",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Vitamin_D-3_2_000_IU-114490.png?v=1777831537",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "000",
        "country",
        "life",
        "natural",
        "foods"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 12.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170700710085",
      "vsf_explanation": "D3 (cholecalciferol) at 2,000 IU is well-supported for maintaining 25(OH)D above 30 ng/mL (Autier & Gandini 2007). Listing includes an unusual caveat 'not for daily use' — which contradicts standard maintenance dosing and may reflect old FDA labeling; 2,000 IU is well below tolerable UL of 4,000 IU. Country Life is a mid-tier legacy brand with modest transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-d-3-liquid",
      "title": "Vitamin D-3  Liquid",
      "vendor": "Country Life Natural Foods",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Vitamin_D-3_Liquid-782678.png?v=1777831549",
      "score": 60,
      "tier": "standard",
      "certifications": [
        "GMP Certified",
        "Kosher",
        "Halal"
      ],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "liquid",
        "country",
        "life",
        "natural",
        "foods"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 55,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 7.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170700808389",
      "vsf_explanation": "100 IU/drop liquid D3 by NOW — flexible dosing, NPA A-rated GMP, no oil carrier disclosed. Drop-based delivery lets pediatric or maintenance doses be tuned precisely. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zinc-glycinate",
      "title": "Zinc Glycinate",
      "vendor": "Country Life Natural Foods",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Zinc_Glycinate-604950.png?v=1777831555",
      "score": 63,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zinc",
        "glycinate",
        "country",
        "life",
        "natural",
        "foods"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 68,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 13.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170700841157",
      "vsf_explanation": "Chelated zinc glycinate has superior absorption vs. oxide/sulfate (Gandia 2007) and is gentle on the stomach. NPA A-rated GMP manufacturing (NOW). Per-capsule zinc mg is not shown in the description, which caps transparency. Upper-Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zinc-50mg-1",
      "title": "Zinc 50mg",
      "vendor": "Country Life Natural Foods",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Zinc_50mg-947397.png?v=1777831559",
      "score": 55,
      "tier": "standard",
      "certifications": [
        "GMP Certified",
        "Kosher",
        "Halal"
      ],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zinc",
        "50mg",
        "country",
        "life",
        "natural",
        "foods"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 45,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 11.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170701725893",
      "vsf_explanation": "50 mg elemental zinc, disclosed dose, established brand with NPA A-rated GMP. Same safety caveat as the picolinate version: 50 mg daily exceeds the 40 mg tolerable upper limit and can drive copper deficiency with chronic use. Best used short-term or with copper co-supplementation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "upgraded-zinc",
      "title": "Upgraded Zinc",
      "vendor": "Upgraded Formulas®",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Zinc_2oz.png?v=1777831577",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "upgraded",
        "zinc",
        "upgraded",
        "formulas"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 50,
        "transparency": 45,
        "sustainability": 35
      },
      "price": 32.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170701758661",
      "vsf_explanation": "'99.99% absorption' and 'nano zinc' claims have no peer-reviewed pharmacokinetic study behind them. Zinc bisglycinate has documented ~43% absorption (Gandia 2007) — 99.99% for any oral mineral is implausible. Anti-inflammatory and hormone-optimization claims exceed evidence.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "quanta-zinc",
      "title": "QUANTA - ZINC",
      "vendor": "Wizard Sciences",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/pbf_ws_vitamins_zinc-2353.jpg?v=1777831582",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "quanta",
        "zinc",
        "wizard",
        "sciences"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 43.54,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170701791429",
      "vsf_explanation": "Zinc capsule marketed as 'enhanced by Leela Quantum Technology' — a pseudoscientific claim with no mechanistic or clinical basis. No mg dose or zinc form is disclosed in the copy. Zinc supplementation itself has solid evidence for immune and skin support (Prasad 2008), but the branding + missing dose put this in the Rejected band.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "purehealth-research-regrow-hair-growth-vitamins-with-saw-palmetto-biotin-collagen-zinc-iron-iodine-selenium-more-hair-supplements-for-women-men-60-capsules",
      "title": "PUREHEALTH RESEARCH ReGrow - Hair Growth Vitamins - with Saw Palmetto, Biotin, Collagen, Zinc, Iron, Iodine, Selenium & More - Hair Supplements for Women & Men - 60 Capsules",
      "vendor": "PureHealth Research",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/61rQIORKp7L._SL1500_d523bf9e-178a-47b2-bde0-78595c3717d7.jpg?v=1777831614",
      "score": 45,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "skin",
        "joint",
        "energy",
        "immune",
        "hormone"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "purehealth",
        "research",
        "regrow",
        "hair",
        "growth",
        "vitamins",
        "with",
        "saw",
        "palmetto",
        "biotin",
        "collagen",
        "zinc",
        "iron",
        "iodine",
        "selenium",
        "more",
        "hair",
        "supplements",
        "for",
        "women",
        "men",
        "capsules",
        "purehealth",
        "research"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170701856965",
      "vsf_explanation": "Amazon-relabeled PureHealth Research 'DHT blocker' with 8+ actives and no per-ingredient dosing. Biotin at supplement doses rarely helps non-deficient hair (Patel 2017); saw palmetto for female-pattern loss has thin evidence. Rejected — hair-growth claims not supported by disclosed formula.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "leader-calcium-magnesium-and-zinc-supplement-100ct",
      "title": "Leader Calcium Magnesium and Zinc Supplement (100ct)",
      "vendor": "Farmacias Savia",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/096295127010-LDR-BIOTIN-10-000-MCG-100-TAB.png?v=1777831622",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "immune",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "leader",
        "calcium",
        "magnesium",
        "and",
        "zinc",
        "supplement",
        "100ct",
        "farmacias",
        "savia"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients",
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 2.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170701889733",
      "vsf_explanation": "Cal-Mag-Zinc is a legacy drugstore combo; calcium co-supplementation reduces magnesium and zinc absorption when taken simultaneously (Sandstrom 2001). Forms (typically carbonate calcium and oxide magnesium/zinc — lowest-bioavailability options) not disclosed. $2.99 pricing indicates commodity manufacturing. Marketed only in Spanish, from a pharmacy chain.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "natures-blend-stress-formula-with-zinc-dietary-supplement",
      "title": "Nature's Blend Stress Formula with Zinc – Dietary Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/196281024.jpg?v=1777831628",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "blend",
        "stress",
        "formula",
        "with",
        "zinc",
        "dietary",
        "supplement",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 10.48,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170701922501",
      "vsf_explanation": "B-complex + vitamin C, E, and zinc — a classic 'stress formula' foundation. Individual nutrients have decades of evidence at RDA-plus doses (Kennedy 2010 B-vitamin cognition RCT), and this product delivers a rational formulation. Store-brand transparency is limited (no per-nutrient mg surfaced here) and no third-party testing disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natural-systems-cal-mag-zinc-vitamin-d-supplement-60ct",
      "title": "Natural Systems Cal Mag Zinc + Vitamin D Supplement (60ct)",
      "vendor": "Farmacias Savia",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/646824202062_NAT_SYST_CAL_MAG_ZING_VIT_D_60_e947a7bd-9208-4a42-82c4-42a17f5f260f.png?v=1777831636",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "natural",
        "systems",
        "cal",
        "mag",
        "zinc",
        "vitamin",
        "supplement",
        "60ct",
        "farmacias",
        "savia"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170701955269",
      "vsf_explanation": "Standard Ca/Mg/Zn/D combo — clinically valid category for bone/immune support (Weaver 2016 calcium+D reviews). Product listing lacks per-nutrient mg, magnesium form (glycinate vs oxide matters — Walker 2003), and third-party testing details. Budget pharmacy-shelf tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gnp-essential-mineral-zinc-50mg-100-tablets-dietary-supplement",
      "title": "GNP Essential Mineral Zinc 50mg 100 Tablets Dietary Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/225326601.png?v=1777831641",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gnp",
        "essential",
        "mineral",
        "zinc",
        "50mg",
        "100",
        "tablets",
        "dietary",
        "supplement",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants",
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 25,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 2.65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170701988037",
      "vsf_explanation": "50 mg zinc exceeds NIH UL of 40 mg and daily use risks copper deficiency (Fischer 1984; Willis 2005). GNP is a Good Neighbor Pharmacy generic; zinc form unspecified and $2.65 pricing signals oxide (lowest absorption). Not appropriate for chronic dosing without medical oversight.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "pure-magnesium-glycinate-with-zinc-maximum-strength-chelated-magnesium-supplement-for-women-and-men-90-capsule",
      "title": "Pure Magnesium Glycinate with Zinc - Maximum Strength Chelated Magnesium Supplement for Women and Men 90 Capsule",
      "vendor": "Vyvata",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Pure_Magnesium_Glycinate_with_Zinc_-_Maximum_Strength_Chelated_Magnesium_Supplement_for_Women_and_Men_for_Muscle_Cramps_and_Sleep_Support_-_6_Bottles.jpg?v=1777831649",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "immune"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "pure",
        "magnesium",
        "glycinate",
        "with",
        "zinc",
        "maximum",
        "strength",
        "chelated",
        "magnesium",
        "supplement",
        "for",
        "women",
        "and",
        "men",
        "capsule",
        "vyvata"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 40,
        "safety": 60,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170702053573",
      "vsf_explanation": "275mg magnesium as glycinate chelate is a bioavailable form and near a useful daily dose. Marketing invokes 'pharmaceutical-grade' and 'Dead Sea sourced' without supporting NSF/USP or COA. Reasonable formulation but no third-party verification, small-vendor claims are unverifiable.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "100-grass-fed-bison-liver-with-heart-added",
      "title": "100% Grass-Fed Bison Liver (with Heart Added)",
      "vendor": "Tribe Vitamins",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Bison_Liver_Heart_-_Transparent_Background.png?v=1777831661",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "100",
        "grass",
        "fed",
        "bison",
        "liver",
        "with",
        "heart",
        "added",
        "tribe",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 60,
        "sustainability": 65
      },
      "price": 97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170702151877",
      "vsf_explanation": "Freeze-dried grass-fed bison liver + heart capsules for whole-food vitamin A, B12, iron, zinc, and CoQ10. Whole-food organ supplements have observational nutrient-density support but no controlled trials showing superiority to standard multivitamins. Sourcing story is clear; no third-party heavy-metal testing surfaced. Hypervitaminosis A is a chronic-use risk at high doses.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bone-support",
      "title": "Bone Support",
      "vendor": "NeuEve",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BoneSupport_Front_Capsule_2.jpg?v=1777831672",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bone",
        "support",
        "neueve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective",
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 50,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 38,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170702250181",
      "vsf_explanation": "Marketed to treat postmenopausal vaginal atrophy and osteoporosis with calcium plus D3/K2. Vaginal atrophy is a medical condition; calcium supplementation does not address it. Osteoporosis benefits are real for calcium+D3 (Weaver 2016 Osteoporos Int) but doses/forms are not clearly disclosed in body copy.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "daily-liquid-eye-care-vitamin",
      "title": "Daily Liquid Eye Care Vitamin",
      "vendor": "Passion 4 Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ECDLV_PDP_01.webp?v=1777831679",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "daily",
        "liquid",
        "eye",
        "care",
        "vitamin",
        "passion",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 42,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 44.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170702315717",
      "vsf_explanation": "Explicitly labels 'Our proprietary blend includes MaquiBright, Taurine, Whole Grape Extract, Vitamin C/E/Zinc.' MaquiBright RCTs (Yamashita 2018) support dry-eye at 60mg/day standardized to delphinidin — this liquid does not disclose that dose per serving.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "algaecal-plus-increase-bone-density",
      "title": "ALGAECAL plus - Increase Bone Density",
      "vendor": "AlgaeCal",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71lNd4eVuZL.jpg?v=1777831701",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "algaecal",
        "plus",
        "increase",
        "bone",
        "density",
        "algaecal"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 65,
        "sustainability": 60
      },
      "price": 69.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170702381253",
      "vsf_explanation": "Plant-source algae calcium (720mg) plus D3, K2-MK7, and 13 co-factor minerals — one of the few bone products with brand-specific RCTs (Kaats 2011, Michalek 2016 showing BMD gains). K2-MK7 addition addresses calcium partitioning per Knapen 2013. Plant sourcing is a sustainability plus over quarried calcium.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "alpha-brain®-cognitive-support-including-memory-focus-mental-processing-speed-90-count",
      "title": "Alpha BRAIN® Cognitive support, including memory, focus & mental processing speed (90 Count)",
      "vendor": "Alpha BRAIN",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/81RY2G78HBL.jpg?v=1777831718",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alpha",
        "brain",
        "cognitive",
        "support",
        "including",
        "memory",
        "focus",
        "mental",
        "processing",
        "speed",
        "count",
        "alpha",
        "brain"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 60,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 59.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170702446789",
      "vsf_explanation": "Onnit Alpha BRAIN — Alpha-GPC + Bacopa + Huperzine + L-theanine in Onnit's proprietary blends 'Flow', 'Focus', 'Fuel'. Solharan 2016 RCT (n=63) showed modest verbal memory gains, but total blend doses are hidden. Standard per Onnit anchor.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "upgraded-peak-thyroid",
      "title": "Upgraded Peak Thyroid",
      "vendor": "Upgraded Formulas®",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Peak_Thyroid_4oz.png?v=1777831728",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "upgraded",
        "peak",
        "thyroid",
        "upgraded",
        "formulas"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 30,
        "sustainability": 50
      },
      "price": 42.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170702577861",
      "vsf_explanation": "Proprietary 'Nano Particle Technology' with claimed 99.99% absorption for Zn/I/Cu/Se has no peer-reviewed pharmacokinetic support. Doses of the four minerals are not disclosed. Thyroid-function claims verge on disease-treatment framing.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "upgraded-copper",
      "title": "Upgraded Copper",
      "vendor": "Upgraded Formulas®",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Copper_2oz.png?v=1777831736",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "upgraded",
        "copper",
        "upgraded",
        "formulas"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 50,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 32.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170702643397",
      "vsf_explanation": "Copper as a 'nano particle' with a claimed 99.99% absorption rate — a marketing figure with no published peer-reviewed data. Copper alone at unspecified dose is risky given the narrow copper:zinc balance (Osredkar 2011). No mcg-per-serving disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnesium-oil-spray-nervous-system-support",
      "title": "Magnesium Oil Spray: Nervous System Support",
      "vendor": "Pioneer Pam",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Screenshot_2025-06-08_at_2.13.03_PM.png?v=1777831746",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "oil",
        "spray",
        "nervous",
        "system",
        "support",
        "pioneer",
        "pam"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 10.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170702676165",
      "vsf_explanation": "Topical magnesium chloride oil (Zechstein). Transdermal Mg absorption evidence is weak — Chandrasekaran 2016 skin permeation study found minimal penetration; Kass 2017 review found no reliable clinical evidence for topical Mg efficacy. Muscle-cramp and sleep claims exceed evidence base.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "elk-antler-liver-heart",
      "title": "Elk Antler, Liver, & Heart",
      "vendor": "Tribe Vitamins",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Elk_Antler_Complex.png?v=1777831754",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "elk",
        "antler",
        "liver",
        "heart",
        "tribe",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 87,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170702708933",
      "vsf_explanation": "Freeze-dried wild elk liver (300 mg) + heart (100 mg) + velvet antler (100 mg) per capsule. Ancestral-nutrition category has minimal RCT evidence; velvet antler IGF-1 claims are unsubstantiated (Sleivert 2003). Doses are disclosed but sub-therapeutic for any measured effect. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "100-grass-fed-bison-organ-complex",
      "title": "100% Grass-Fed Bison Organ Complex",
      "vendor": "Tribe Vitamins",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/TRIBE_Organ_Complex.jpg?v=1777831761",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "100",
        "grass",
        "fed",
        "bison",
        "organ",
        "complex",
        "tribe",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic",
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 65,
        "sustainability": 65
      },
      "price": 199,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46508346572997",
      "vsf_explanation": "Freeze-dried grass-fed bison liver/heart/kidney/pancreas/spleen with organ ratios explicitly disclosed (57/22.8/8.8/8.8/2.6). Organ meat provides bioavailable retinol, B12, heme iron, CoQ10. Clinical trials on desiccated-organ supplementation are essentially absent; benefit is nutrient-analog reasoning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "100-grassfed-bison-testicles",
      "title": "100% GrassFed Bison Testicles",
      "vendor": "Tribe Vitamins",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/TRIBE_BisonTesticles.jpg?v=1777831765",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "100",
        "grassfed",
        "bison",
        "testicles",
        "tribe",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health",
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 55,
        "sustainability": 65
      },
      "price": 250,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170702840005",
      "vsf_explanation": "Freeze-dried organ meat products (ancestral/carnivore trend) have no RCT evidence for testosterone or male hormonal outcomes. Small amounts of nutrients (zinc, selenium, cholesterol) are present but not standardized. Grass-fed bison sourcing is a sustainability positive. $250 pricing is premium-tier for what is essentially glandular capsules — a category discredited since 1990s (Rothman 2018).",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "elk-velvet-antler",
      "title": "ELK VELVET ANTLER",
      "vendor": "Tribe Vitamins",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ElkAntler_Product_Photo_1.png?v=1777831774",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "elk",
        "velvet",
        "antler",
        "tribe",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective",
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 42,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 42,
        "sustainability": 40
      },
      "price": 59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170702938309",
      "vsf_explanation": "Freeze-dried elk velvet antler cartilage. Small trials in osteoarthritis and endurance (Sleivert J Strength Cond Res 2003, Allen J Sport Med Phys Fit 2008) were negative or null. IGF-1 content is present but bioavailability via oral route is questionable and the ingredient is on some sports-body watchlists. No dose or IGF-1 content disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "wild-elk-liver",
      "title": "Wild Elk Liver",
      "vendor": "Tribe Vitamins",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Elk_Liver_Product_Photo.jpg?v=1777831779",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wild",
        "elk",
        "liver",
        "tribe",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 50,
        "sustainability": 60
      },
      "price": 88,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170703003845",
      "vsf_explanation": "180 x 500 mg freeze-dried elk liver capsules — nutrient-dense whole-food supplement (vit A, B12, iron, copper, zinc). Evidence for organ meat supplementation over whole-food equivalents is weak, and the description omits sourcing certification, testing, and mg per serving of key nutrients. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-mushroom-complex-supplement-capsules",
      "title": "Organic Mushroom Complex Supplement Capsules",
      "vendor": "FreshCap Mushrooms",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/umc_capsules_60ct.png?v=1777831967",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "mushroom",
        "complex",
        "supplement",
        "capsules",
        "freshcap",
        "mushrooms"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 50,
        "sustainability": 60
      },
      "price": 27.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170703954117",
      "vsf_explanation": "Six-mushroom quadruple-extracted blend ('12,000mg power'). FreshCap emphasizes fruiting body and beta-glucan focus which is a positive over grain-mycelium products (Wasser 2014). Per-species mg breakdown and beta-glucan % not surfaced here, limiting verification for a Verified-tier score.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-cordyceps-mushroom-supplement-capsules",
      "title": "Organic Cordyceps Mushroom Supplement Capsules",
      "vendor": "FreshCap Mushrooms",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cordyceps_capsules_120ct.png?v=1777831971",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "cordyceps",
        "mushroom",
        "supplement",
        "capsules",
        "freshcap",
        "mushrooms"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 52,
        "sustainability": 60
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170704052421",
      "vsf_explanation": "Water-extracted cordyceps (10,000mg raw equivalent). Cordyceps militaris RCTs (Chen 2010) show modest VO2 max improvements at 1-3g/day of extract; label needs beta-glucan or cordycepin standardization to confirm therapeutic dose. FreshCap fruiting-body sourcing is a plus.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "now-available-lifestream-herbal-supplement-by-sunrider",
      "title": "NOW AVAILABLE Lifestream Herbal Supplement by Sunrider",
      "vendor": "NOW",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/lifestream-herbal-supplement-by-sunrider-5571559129177.png?v=1777831980",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "available",
        "lifestream",
        "herbal",
        "supplement",
        "sunrider",
        "now"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 30,
        "manufacturing": 40,
        "safety": 40,
        "transparency": 20,
        "sustainability": 40
      },
      "price": 53.51,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170704150725",
      "vsf_explanation": "Sunrider Lifestream — self-described 'proprietary blend of concentrated herbs' (sophora flower, dwarf lilyturf, gou teng, tora seed) for circulation. No individual herb mg disclosed. Sophora and gou teng have TCM tradition but limited human cardiovascular RCTs.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "now-available-alpha-20c-immune-system-herbal-supplement-by-sunrider",
      "title": "NOW AVAILABLE Alpha 20C | Immune System Herbal Supplement by Sunrider",
      "vendor": "NOW",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/capsules-alpha-20c-immune-system-herbal-supplement-by-sunrider-5053214064729.png?v=1777831994",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "available",
        "alpha",
        "20c",
        "immune",
        "system",
        "herbal",
        "supplement",
        "sunrider",
        "now"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 35,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 20,
        "sustainability": 45
      },
      "price": 54.14,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170704281797",
      "vsf_explanation": "Sunrider's proprietary TCM 'wood element' formula (Chinese White Flower, Paris Herb, Scutellaria) — Paris polyphylla is a niche herb with in vitro immunomodulatory data but no human RCTs; Scutellaria has some flavonoid evidence but at undisclosed doses. Sunrider is a legacy MLM brand with limited scientific transparency.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "now-available-joi-herbal-mood-supplement-by-sunrider",
      "title": "NOW AVAILABLE Joi | Herbal Mood Supplement by Sunrider",
      "vendor": "NOW",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/joi-herbal-mood-supplement-by-sunrider-22843312701634.png?v=1777832001",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "available",
        "joi",
        "herbal",
        "mood",
        "supplement",
        "sunrider",
        "now"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 40,
        "manufacturing": 48,
        "safety": 50,
        "transparency": 42,
        "sustainability": 45
      },
      "price": 84.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170704478405",
      "vsf_explanation": "Sunrider proprietary herbal mood formula (eleuthero, white willow bark, yeuan wu root). Individual herb doses hidden; white willow's salicin has GI/bleeding risks. Mood claims (\"relieves mild depression\") stray into disease territory. Yeuan wu (Corydalis) lacks Western RCT support.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "2-pack-balance-of-nature-fruit-vegetables-food-supplement",
      "title": "2-Pack: Balance Of Nature Fruit & Vegetables Food Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/balance-of-nature-fruit-vegetables-food-supplement-wellness-dailysale-417127.webp?v=1777832006",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pack",
        "balance",
        "nature",
        "fruit",
        "vegetables",
        "food",
        "supplement",
        "dailysale"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 35,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170704543941",
      "vsf_explanation": "Balance of Nature capsules with no per-ingredient doses and no disclosure of processing yield vs. actual fruit/vegetable content. FDA has previously warned Balance of Nature for unsubstantiated disease claims (2019 warning letter). Sold here via a reseller (DailySale) further muddying provenance.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "now-available-alpha-20c-powder-immune-system-supplement-by-sunrider",
      "title": "NOW AVAILABLE Alpha 20C Powder | Immune System Supplement by Sunrider",
      "vendor": "NOW",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/coming-soon-powder-bulk-container-60-servings-300g-out-of-stock-pre-order-alpha-20c-powder-immune-system-supplement-by-sunrider-40699443020033.jpg?v=1777832021",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "available",
        "alpha",
        "20c",
        "powder",
        "immune",
        "system",
        "supplement",
        "sunrider",
        "now"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 35,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 20,
        "sustainability": 45
      },
      "price": 54.14,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170705232069",
      "vsf_explanation": "Powder formulation of the same Sunrider Alpha 20C 'wood element' TCM blend — Chinese White Flower, Paris Herb, Scutellaria — with no dose disclosure. MLM legacy brand; no independent testing or clinical trials for the finished product.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "longevity-supplement-for-brain-health",
      "title": "Longevity Supplement for Brain Health",
      "vendor": "SensIQ",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Longevity.webp?v=1777832026",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "longevity",
        "supplement",
        "for",
        "brain",
        "health",
        "sensiq"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics",
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 30,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 15,
        "sustainability": 40
      },
      "price": 109,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170705592517",
      "vsf_explanation": "Product description contains no ingredient list, dose, or formulation — only marketing about '8-12 week' onset and $109 price. Impossible to evaluate against any evidence base for cognitive supplements (Butler 2018 systematic review of longevity nootropics is largely negative).",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "nerve-control-911-natural-plant-based-nerve-health-supplement",
      "title": "Nerve Control 911 - Natural Plant Based Nerve Health Supplement",
      "vendor": "Nutragole",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nerve_Control_911.jpg?v=1777832033",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nerve",
        "control",
        "911",
        "natural",
        "plant",
        "based",
        "nerve",
        "health",
        "supplement",
        "nutragole"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170706084037",
      "vsf_explanation": "Marketed under the '911' branding template widely used for scam-style neuropathy remedies; brand is often gray-market Amazon-only. Doses/ingredient panel obscured in the listing. Neuropathy is a medical condition; effective agents like alpha-lipoic acid have specific dose windows (Ziegler 1999 SYDNEY trial at 600 mg IV).",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "heart-health-2-oz-liquid-herbal-supplement",
      "title": "Heart Health | 2 oz Liquid Herbal Supplement",
      "vendor": "MoonMaid Botanicals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Heart_Health_Liquid_Herbal_Supplement_for_Blood_Pressure_91b64f0b-521f-447c-9b8e-101b2a6fd7ae.png?v=1777832040",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "heart",
        "health",
        "liquid",
        "herbal",
        "supplement",
        "moonmaid",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 42,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 17,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170706575557",
      "vsf_explanation": "Herbal tincture blend of hawthorn, rose petals, gingko, and others with no individual doses or extract standardization. Hawthorn extract has modest BP/heart failure evidence at 900-1800 mg standardized extract (Pittler Cochrane 2008), unreachable via undisclosed-dose tincture. Marketing implies management of blood pressure and cholesterol without clinical substantiation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natural-liver-support-supplement-30-capsules",
      "title": "Natural Liver Support Supplement 30 Capsules",
      "vendor": "Nutragole",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/81LegDGrjFL._AC_SL1500.jpg?v=1777832061",
      "score": 42,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "natural",
        "liver",
        "support",
        "supplement",
        "capsules",
        "nutragole"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 35,
        "manufacturing": 50,
        "safety": 50,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 39.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170707722437",
      "vsf_explanation": "Marketed as 'Exclusive Hepagard Formula' with five ingredients (milk thistle, NAC, artichoke, dandelion, choline) but no individual doses disclosed. Milk thistle at 420-600 mg silymarin has some evidence (Loguercio 2012); without the mg you can't tell if any dose is therapeutic.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "magnesium-glycinate-240-capsules-high-absorption-magnesium-supplement-gentle-on-stomach-made-in-usa",
      "title": "Magnesium Glycinate  – 240 Capsules – High Absorption Magnesium Supplement  – Gentle on Stomach – Made in USA",
      "vendor": "I Love Health Store",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8d3fb741647998792438c2e94b70d0c8_64b72e5c-8834-4b5c-b688-212e578746dd.jpg?v=1777832069",
      "score": 55,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "glycinate",
        "240",
        "capsules",
        "high",
        "absorption",
        "magnesium",
        "supplement",
        "gentle",
        "stomach",
        "made",
        "usa",
        "love",
        "health",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170708017349",
      "vsf_explanation": "Chelated magnesium glycinate is the well-tolerated, well-absorbed form (Walker 2003). Description lists multiple SKUs (400/500/1000 mg) but is confusingly written, and there is no third-party COA, brand identity, or elemental vs. compound weight breakdown. GMP US-made. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "six-star-testosterone-booster-active-testo-supplement-60ct",
      "title": "Six Star Testosterone Booster Active Testo Supplement (60ct)",
      "vendor": "Farmacias Savia",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/631656603118_TESTOSTERONE_BOOSTER_60_CAP_12ebf09a-85a8-4a1b-8636-3058ac61cb53.png?v=1777832073",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "six",
        "star",
        "testosterone",
        "booster",
        "active",
        "testo",
        "supplement",
        "60ct",
        "farmacias",
        "savia"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 50,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 12.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170708836549",
      "vsf_explanation": "Boron citrate + Rhodiola marketed to raise 'active testosterone in 7 days'. Boron RCTs (Naghii 2011) show only small free-T shifts; Rhodiola supports stress/fatigue but not T. Body copy lacks per-ingredient mg, and the 7-day T-boost claim exceeds evidence for the doses typical in mass-market boosters.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "multi-mushroom-supplement",
      "title": "Multi-Mushroom Supplement",
      "vendor": "Simpleme.health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MainImage.jpg?v=1777832083",
      "score": 45,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "multi",
        "mushroom",
        "supplement",
        "simpleme",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants",
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 42,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 22.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170709098693",
      "vsf_explanation": "13-mushroom blend (lion's mane, reishi, turkey tail, cordyceps, chaga, maitake, shiitake and more) in two capsules per day with no individual mushroom milligrams, no fruiting-body vs mycelium disclosure, and no beta-glucan content. Clinical dosing for lion's mane cognition (Mori Phytother Res 2009) is 3 g/day — impossible to reach in a 2-capsule 13-species split.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "2oz-vegan-b12-supplement",
      "title": "2oz Vegan B12 Supplement",
      "vendor": "Healthspan Holistic",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2oz-B12-Drops-front-min.jpg?v=1777832091",
      "score": 51,
      "tier": "standard",
      "certifications": [
        "NSF Certified",
        "GMP Certified"
      ],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "2oz",
        "vegan",
        "b12",
        "supplement",
        "healthspan",
        "holistic"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 24.87,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170709131461",
      "vsf_explanation": "Liquid vegan B12 formula addressing legitimate deficiency risk in vegan/older populations (Rizzo 2016 review). Listing does not specify mcg per dropper or B12 form (methyl vs cyano vs adenosyl), which weakens transparency and formulation. Small-brand manufacturing detail is limited; entry Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "purehealth-research-lymph-system-support-supplement-lymphatic-drainage-supplement-with-dandelion-extract-cleavers-burdock-powder-reduce-swelling-and-cleanse-lymph-1-bottle-brown",
      "title": "PUREHEALTH RESEARCH Lymph System Support Supplement - Lymphatic Drainage Supplement with Dandelion Extract, Cleavers, Burdock Powder - Reduce Swelling and Cleanse Lymph - 1 Bottle, Brown",
      "vendor": "PureHealth Research",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71lgDJIT1oL_28c9bdc9-8732-43cc-b57d-e7dc1a9cb373.jpg?v=1777832105",
      "score": 42,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "purehealth",
        "research",
        "lymph",
        "system",
        "support",
        "supplement",
        "lymphatic",
        "drainage",
        "supplement",
        "with",
        "dandelion",
        "extract",
        "cleavers",
        "burdock",
        "powder",
        "reduce",
        "swelling",
        "and",
        "cleanse",
        "lymph",
        "bottle",
        "brown",
        "purehealth",
        "research"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170709164229",
      "vsf_explanation": "Claims 'reduce swelling and cleanse lymph' — 'lymphatic drainage' via pill has no human RCT support and edema is a medical condition. Dandelion/cleavers/burdock 'detox' has folk-medicine use only. Rejected on autofail.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "upgraded-magnesium-clinically-shown-to-greatly-improve-both-rem-and-deep-sleep",
      "title": "Upgraded Magnesium: Clinically Shown To Greatly Improve BOTH REM and Deep Sleep",
      "vendor": "Upgraded Formulas®",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Magnesium_60ct.png?v=1777836506",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "upgraded",
        "magnesium",
        "clinically",
        "shown",
        "greatly",
        "improve",
        "both",
        "rem",
        "and",
        "deep",
        "sleep",
        "upgraded",
        "formulas"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170764935365",
      "vsf_explanation": "Nano-magnesium marketed as 'clinically shown to improve deep sleep up to 250%, REM up to 160% in 14 nights' — an aggressive claim tied to an in-house third-party trial that is not published in peer review. Magnesium itself has RCT support for sleep (Abbasi 2012), but the specific claim + no mg/serving disclosure limit the score.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "upgraded-potassium-8-oz",
      "title": "Upgraded Potassium 8 oz",
      "vendor": "Upgraded Formulas®",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Potassium_8oz.png?v=1777836511",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "upgraded",
        "potassium",
        "upgraded",
        "formulas"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 30,
        "sustainability": 50
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170765230277",
      "vsf_explanation": "'99.99% absorption via Nano Particle Technology' is a marketing construct not backed by peer-reviewed pharmacokinetics. Potassium mg per serving is not disclosed in the product body. Safety concern: potassium is hazardous at supra-physiologic doses; obfuscation of dose is unacceptable.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "upgraded-mood",
      "title": "Upgraded Mood",
      "vendor": "Upgraded Formulas®",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Upgraded_Mood_2oz.png?v=1777836516",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "upgraded",
        "mood",
        "upgraded",
        "formulas"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170765263045",
      "vsf_explanation": "'Blend of four crucial micronutrients' via proprietary 'Nano Particle Technology' with an unverified 99.99% absorption claim. Neither mineral identities nor doses are stated in the copy. Rejected on autofail.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "upgraded-charge-instant-hydration",
      "title": "Upgraded Charge - Instant Hydration",
      "vendor": "Upgraded Formulas®",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Charge_4oz.png?v=1777836518",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "upgraded",
        "charge",
        "instant",
        "hydration",
        "upgraded",
        "formulas"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170765361349",
      "vsf_explanation": "Magnesium, zinc, sodium, potassium electrolyte pack with 'Nano Particle 99.99% absorption' claim. Individual electrolyte doses not disclosed; hangover-cure and 5-minute rehydration claims exceed evidence for oral minerals. Rejected on marketing overreach + dose opacity.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "upgraded-cramp-and-migraine-relief",
      "title": "Upgraded Cramp and Migraine Relief",
      "vendor": "Upgraded Formulas®",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Upgraded_Cramp_Relief_60ct.png?v=1777836528",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "upgraded",
        "cramp",
        "and",
        "migraine",
        "relief",
        "upgraded",
        "formulas"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 44.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170765426885",
      "vsf_explanation": "Magnesium + B6 combination. There is real evidence for magnesium in migraine prophylaxis (Peikert 1996 RCT at 600 mg/day) and for magnesium + B6 in menstrual cramp reduction (Fathizadeh 2010). Actual doses per serving are not disclosed, so we cannot verify the formulation matches those study protocols.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "upgraded-magnesium-liquid-sleep-digestion-calm-focus",
      "title": "Upgraded Magnesium Liquid: Sleep, Digestion, Calm, Focus",
      "vendor": "Upgraded Formulas®",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Magnesium_2oz_a11f3560-59d2-4894-b471-dfee85ba99fa.png?v=1777836535",
      "score": 49,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "gut",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "upgraded",
        "magnesium",
        "liquid",
        "sleep",
        "digestion",
        "calm",
        "focus",
        "upgraded",
        "formulas"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 37.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170765459653",
      "vsf_explanation": "Liquid nano-magnesium marketed as 'relief of headaches, cramps, and migraines faster than a cup of coffee, within 3 minutes' — a claim not supported by pharmacokinetics of oral magnesium. No mg per dose is stated on the product copy.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "upgraded-chromium-plus",
      "title": "Upgraded Chromium Plus",
      "vendor": "Upgraded Formulas®",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Chromium_Plus_2oz_1.png?v=1777836544",
      "score": 49,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "upgraded",
        "chromium",
        "plus",
        "upgraded",
        "formulas"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health",
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 50,
        "sustainability": 40
      },
      "price": 32.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170765557957",
      "vsf_explanation": "Single-mineral chromium in a proprietary 'absorption method' marketed at 99.99% bioavailability — a claim with no independent verification. Chromium picolinate meta-analyses (Suksomboon J Clin Pharm Ther 2014) show modest fasting-glucose improvement in T2DM only; weight-loss and hunger-suppression claims are weakly supported. Per-serving chromium dose not shown in listing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "upgraded-calcium-60-ct-capsules",
      "title": "Upgraded Calcium 60 ct Capsules",
      "vendor": "Upgraded Formulas®",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Calcium_60ct.png?v=1777838460",
      "score": 49,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "upgraded",
        "calcium",
        "capsules",
        "upgraded",
        "formulas"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170793279685",
      "vsf_explanation": "Nano-calcium capsule with claims for hair, skin, nails, sleep, focus, and melatonin production — a scope creep unsupported by calcium mechanism (NIH ODS calcium fact sheet). Standalone calcium without K2/D3 co-factors is a suboptimal formulation for bone health (Yoshida 2013), and no mg per capsule is stated.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "upgraded-formulas-be-great-in-bed-sleep-mask",
      "title": "Upgraded Formulas Be Great In Bed Sleep Mask",
      "vendor": "Upgraded Formulas®",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/UF-SleepMask-1.png?v=1777838467",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "upgraded",
        "formulas",
        "great",
        "bed",
        "sleep",
        "mask",
        "upgraded",
        "formulas"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 15,
        "manufacturing": 30,
        "safety": 65,
        "transparency": 20,
        "sustainability": 30
      },
      "price": 12.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170793410757",
      "vsf_explanation": "Cloth sleep mask — accessory, not a supplement. While light-blocking masks have small sleep-quality RCT support (Hu 2010), the supplement rubric does not apply.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "upgraded-boron",
      "title": "Upgraded Boron",
      "vendor": "Upgraded Formulas®",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Boron_2oz.png?v=1777838484",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "upgraded",
        "boron",
        "upgraded",
        "formulas"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health",
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 30,
        "sustainability": 50
      },
      "price": 32.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170793672901",
      "vsf_explanation": "Boron has some evidence at 6-10 mg/day for hormone modulation (Naghii 2011) and bone metabolism, but this product does not disclose mg per serving. 'Nano Particle Technology' branding conflicts with the fact that boron is absorbed at ~90% from ordinary compounds (Hunt 1997).",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "upgraded-iron",
      "title": "Upgraded Iron",
      "vendor": "Upgraded Formulas®",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Iron_2oz.png?v=1777838489",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "upgraded",
        "iron",
        "upgraded",
        "formulas"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 40,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 32.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170793771205",
      "vsf_explanation": "Liquid 'Nano Mineral Technology' iron with a claimed 99.99% absorption rate — a marketing figure unsupported by peer-reviewed pharmacokinetics. Iron absorption from standard supplements (ferrous sulfate, bisglycinate) is 5-35% depending on iron status (Cook 1990). No dose disclosed on product page.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "upgraded-trace-minerals",
      "title": "Upgraded Trace Minerals",
      "vendor": "Upgraded Formulas®",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Trace_Minerals_4oz.png?v=1777838499",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "upgraded",
        "trace",
        "minerals",
        "upgraded",
        "formulas"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 45,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 32.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170793902277",
      "vsf_explanation": "Same 'Nano Mineral Technology' framework, trace-mineral blend. No mineral profile or mg breakdown on the product page. Trace mineral supplementation without deficiency testing has limited outcome data; the 99.99% absorption claim is a marketing figure.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "upgraded-8-hour-sleep-clinically-shown-to-improve-sleep",
      "title": "Upgraded 8-Hour Sleep: Clinically Shown To Improve Sleep",
      "vendor": "Upgraded Formulas®",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Upgraded_Sleep_120ct_dfe86e50-add5-4219-ae9d-e09927f5f607.png?v=1777838506",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "upgraded",
        "hour",
        "sleep",
        "clinically",
        "shown",
        "improve",
        "sleep",
        "upgraded",
        "formulas"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 77.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170794033349",
      "vsf_explanation": "Reprint of the Upgraded Magnesium sleep story with the same 250%/160% claim. Magnesium for sleep has meaningful RCT support (Abbasi 2012), but the unpublished in-house '14-night' trial is not adequate substantiation for the marketing wording used, and no mg dose is disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "upgraded-manganese",
      "title": "Upgraded Manganese",
      "vendor": "Upgraded Formulas®",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Manganese_2oz.png?v=1777838511",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "upgraded",
        "manganese",
        "upgraded",
        "formulas"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 35,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 32.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170794066117",
      "vsf_explanation": "Liquid nano-manganese claiming faster recovery, less soreness, and improved working memory. Manganese deficiency in the general US population is uncommon and excess intake risks neurotoxicity (Aschner 2005). Dose per serving is not disclosed on the product page.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "upgraded-t-balance-hormones-and-naturally-improve-your-testosterone-safely",
      "title": "Upgraded T: Balance Hormones and Naturally Improve Your Testosterone Safely",
      "vendor": "Upgraded Formulas®",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Upgraded_T_60ct_7d73fd9a-410c-4887-b740-5fe1ebb8720c.png?v=1777838600",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "upgraded",
        "balance",
        "hormones",
        "and",
        "naturally",
        "improve",
        "your",
        "testosterone",
        "safely",
        "upgraded",
        "formulas"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine",
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 48,
        "safety": 55,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170794950853",
      "vsf_explanation": "'5 must-have nutrients' testosterone-support formula with no individual ingredients or doses disclosed in listing copy — only marketing claims of increased libido, energy and reduced estrogen. Referenced 'clinical trial' is not published in peer-reviewed literature. Direct testosterone-increase claims to both sexes without transparency put this in the disallowed-claim category.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "upgraded-metabolism-sugar-support",
      "title": "Upgraded Metabolism (Sugar Support)",
      "vendor": "Upgraded Formulas®",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Metabolism_4oz.png?v=1777838605",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "upgraded",
        "metabolism",
        "sugar",
        "support",
        "upgraded",
        "formulas"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 40,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 47.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170795114693",
      "vsf_explanation": "Liquid 'Nano' blood-sugar support with claims to 'balance insulin' and 'improve blood glucose levels.' Ingredient breakdown and doses are not disclosed. Insulin/glucose modulation claims are drug-territory and unsupported by RCTs on this specific formula.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "testolite®-pro-dual-3-free-gifts",
      "title": "Testolite® PRO Dual + 3 FREE Gifts",
      "vendor": "Testolite",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/pro_dual_package.png?v=1777838635",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "testolite",
        "pro",
        "dual",
        "free",
        "gifts",
        "testolite"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 30,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 30,
        "sustainability": 30
      },
      "price": 179.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170796196037",
      "vsf_explanation": "This is a wearable 670 nm red-light device, not a supplement — there is no ingested compound to evaluate. Red-light photobiomodulation has emerging data (Hamblin 2017) but claims of testosterone/vitality boosts specifically are not supported by adequately powered RCTs, and the product is out of category for this rubric.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "2oz-daily-minerals-fulvic-humic-concentrate",
      "title": "2oz Daily Minerals Fulvic Humic Concentrate",
      "vendor": "Healthspan Holistic",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Daily-minerals-2oz-3D-min_1.jpg?v=1777838653",
      "score": 52,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "2oz",
        "daily",
        "minerals",
        "fulvic",
        "humic",
        "concentrate",
        "healthspan",
        "holistic"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 37.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170796490949",
      "vsf_explanation": "Fulvic:humic 4:1 concentrate claiming 70+ trace minerals — human RCT support for fulvic acid supplementation is limited to small pilot studies. New Mexico sourcing, GMP+FDA-registered facility, batch testing claimed. Fulvic/humic content per serving is not quantified, a transparency gap. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-turmeric-ginger-60-capsules",
      "title": "Organic Turmeric + Ginger 60 Capsules",
      "vendor": "Healthspan Holistic",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Turmeric-front-3D-min_1.jpg?v=1777838658",
      "score": 61,
      "tier": "standard",
      "certifications": [
        "NSF Certified",
        "GMP Certified"
      ],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "turmeric",
        "ginger",
        "capsules",
        "healthspan",
        "holistic"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 65,
        "safety": 60,
        "transparency": 58,
        "sustainability": 60
      },
      "price": 22.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170796785861",
      "vsf_explanation": "Organic turmeric + ginger in a GMP+NSF FDA-registered facility. Curcumin RCTs (Daily 2016 meta-analysis) show OA pain relief comparable to NSAIDs at 1000 mg/day standardized curcuminoids — bioavailability without piperine or phytosome is a limitation this formula doesn't address. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "high-potency-vitamin-d3-k2-supplement-60-capsules",
      "title": "High Potency Vitamin D3 + K2 Supplement 60 Capsules",
      "vendor": "Healthspan Holistic",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/D3K2_front-3D-min_4_efc20b71-b519-423f-a282-a7e1725906ec.jpg?v=1777838662",
      "score": 54,
      "tier": "standard",
      "certifications": [
        "NSF Certified",
        "GMP Certified"
      ],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "high",
        "potency",
        "vitamin",
        "supplement",
        "capsules",
        "healthspan",
        "holistic"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 21.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170796818629",
      "vsf_explanation": "D3 + K2 + calcium + BioPerine is a defensible bone/CV combination (Knapen 2013 for D3+K2). USA GMP and NSF-certified, FDA-registered facility with claimed independent batch testing gives above-average manufacturing signal for a small brand. Missing D3 IU and K2 mcg/form (MK-4 vs MK-7) in the listing keeps this mid Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "2oz-detox-100-humic-minerals-concentrate",
      "title": "2oz Detox 100% Humic Minerals Concentrate",
      "vendor": "Healthspan Holistic",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2oz-100_-Humic-Detox-3D-min_99d0372d-2017-4abb-946a-3d850e7f17e0.jpg?v=1777838666",
      "score": 38,
      "tier": "rejected",
      "certifications": [
        "NSF Certified",
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "2oz",
        "detox",
        "100",
        "humic",
        "minerals",
        "concentrate",
        "healthspan",
        "holistic"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 37.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170796982469",
      "vsf_explanation": "Humic/fulvic acid concentrate marketed for chelation of heavy metals and 'detox.' Human clinical evidence is minimal (mostly in-vitro binding assays), and unregulated humic sources can themselves carry heavy-metal loads. Category and marketing lean scientifically weak.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "2oz-recharge-100-fulvic-minerals-concentrate",
      "title": "2oz Recharge 100% Fulvic Minerals Concentrate",
      "vendor": "Healthspan Holistic",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2oz-100_-Fulvic-Recharge-min_d6b37e91-b334-4dd1-b0a8-a22f49b99cb7.jpg?v=1777838673",
      "score": 52,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "2oz",
        "recharge",
        "100",
        "fulvic",
        "minerals",
        "concentrate",
        "healthspan",
        "holistic"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 37.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170797015237",
      "vsf_explanation": "Fulvic-humic mineral concentrate essentially identical in evidence profile to the sibling product. GMP+FDA-registered NM source; per-serving fulvic mg is undisclosed. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "90-day-detox-recharge",
      "title": "90 Day Detox & Recharge",
      "vendor": "Healthspan Holistic",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Detox___Recharge_Bundle-min_72917ad0-b0eb-4cf4-809b-680bb50c7f50.jpg?v=1777838688",
      "score": 35,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "day",
        "detox",
        "recharge",
        "healthspan",
        "holistic"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 30,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 112.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170797146309",
      "vsf_explanation": "Fulvic/humic 'mineral' blend with no per-serving mineral dose disclosed and no verifiable brand provenance. Marketing leans on soil-depletion and vague '70 minerals' claims; there are no controlled RCTs supporting fulvic-acid detox in humans. Priced at $112.97 despite anonymous sourcing.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "coq10-supplement-30-capsules",
      "title": "CoQ10 Supplement 30 Capsules",
      "vendor": "Healthspan Holistic",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CoQ10---Ubiquinone-front-3D-min.jpg?v=1777838694",
      "score": 68,
      "tier": "standard",
      "certifications": [
        "NSF Certified",
        "GMP Certified"
      ],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coq10",
        "supplement",
        "capsules",
        "healthspan",
        "holistic"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 68,
        "manufacturing": 75,
        "safety": 72,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 26.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170797244613",
      "vsf_explanation": "200mg CoQ10 (ubiquinone) per capsule, GMP + NSF-certified FDA-registered facility, independent third-party testing per batch, non-GMO/gluten-free/vegan. Ubiquinone at 100-300mg has RCT support for statin myopathy and mild CHF (Mortensen 2014 Q-SYMBIO trial), though ubiquinol has better bioavailability in older adults (Langsjoen 2014). Solid Standard tier just shy of Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "berberine-60-capsules",
      "title": "Berberine 60 Capsules",
      "vendor": "Healthspan Holistic",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Berberine-front-3D-min.jpg?v=1777838700",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "berberine",
        "capsules",
        "healthspan",
        "holistic"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 28.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170797277381",
      "vsf_explanation": "Berberine capsules, 60 count. Berberine has good metabolic evidence (Yin 2008 RCT: 500mg 3x/day improved fasting glucose and HbA1c comparable to metformin). But the product page has no description body at all — no berberine mg per capsule, no source (HCl vs sulfate), no third-party testing.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "magnesium-glycinate-supplement-90-capsules",
      "title": "Magnesium Glycinate Supplement 90 Capsules",
      "vendor": "Healthspan Holistic",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Magnesium-Supplement-3D_4_1.jpg?v=1777838704",
      "score": 51,
      "tier": "standard",
      "certifications": [
        "NSF Certified",
        "GMP Certified"
      ],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "glycinate",
        "supplement",
        "capsules",
        "healthspan",
        "holistic"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 26.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170797375685",
      "vsf_explanation": "275mg magnesium glycinate per serving — bioavailable form at a reasonable dose. Evidence for magnesium glycinate on sleep quality is modest (Boyle 2017 review). Marketing repetition of 'for sleep' phrasing is SEO stuffing; formulation itself is fine, and no third-party certifications shown.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "high-dose-omega-3-fish-oil-supplement-60-softgels",
      "title": "High Dose Omega 3 Fish Oil Supplement 60 Softgels",
      "vendor": "Healthspan Holistic",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Omega-3-3D-min_4.jpg?v=1777838709",
      "score": 69,
      "tier": "standard",
      "certifications": [
        "NSF Certified",
        "GMP Certified"
      ],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "high",
        "dose",
        "omega",
        "fish",
        "oil",
        "supplement",
        "softgels",
        "healthspan",
        "holistic"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 68,
        "manufacturing": 72,
        "safety": 70,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 24.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170797473989",
      "vsf_explanation": "1,440 mg omega-3 with 864 mg EPA + 576 mg DHA per serving from wild-caught Peruvian sardines. GMP + NSF-certified, FDA-registered facility, third-party purity + potency tested per batch. Bang-on the EPA/DHA range studied in cardiovascular RCTs (Mozaffarian 2011). Solid Standard, close to Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-ashwagandha-adaptogen-60-capsules",
      "title": "Organic Ashwagandha Adaptogen 60 Capsules",
      "vendor": "Healthspan Holistic",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Ashwagandha-front-3D_3_1.jpg?v=1777838714",
      "score": 66,
      "tier": "standard",
      "certifications": [
        "NSF Certified",
        "GMP Certified"
      ],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "ashwagandha",
        "adaptogen",
        "capsules",
        "healthspan",
        "holistic"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 65,
        "manufacturing": 68,
        "safety": 65,
        "transparency": 62,
        "sustainability": 60
      },
      "price": 22.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170797506757",
      "vsf_explanation": "1,300 mg organic ashwagandha per serving with black pepper for absorption; USA GMP+NSF facility. Chandrasegaran 2012 and Salve 2019 RCTs demonstrate stress/cortisol effects at 250–600 mg standardized extract — non-standardized 1,300 mg powder is likely equivalent or slightly weaker. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-adaptogenic-mushroom-powder",
      "title": "Organic Adaptogenic Mushroom Powder+",
      "vendor": "Healthspan Holistic",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Organic-Mushroom-Powder-front-3DV4R0_1.jpg?v=1777838719",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "adaptogenic",
        "mushroom",
        "powder",
        "healthspan",
        "holistic"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 20,
        "sustainability": 50
      },
      "price": 28.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170797605061",
      "vsf_explanation": "Adaptogenic mushroom powder blend with no product body content — species mix, per-mushroom mg, fruiting body vs mycelium status, and beta-glucan content are all undisclosed. Mushroom extracts vary widely in bioactive content (Chilton 2015).",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "ginkgo-biloba-ginseng-60-capsules",
      "title": "Ginkgo Biloba + Ginseng 60 Capsules",
      "vendor": "Healthspan Holistic",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Ginkgo-Biloba-Ginseng-front-3D-min.jpg?v=1777838723",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive",
        "energy",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ginkgo",
        "biloba",
        "ginseng",
        "capsules",
        "healthspan",
        "holistic"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 45,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 20,
        "sustainability": 45
      },
      "price": 23.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170799440069",
      "vsf_explanation": "Ginkgo + ginseng capsule combo with no product description. Ginkgo biloba standardized 24/6 extract has cognitive evidence at 120-240mg (Kaschel 2011). Ginseng varies by species. No dose, no standardization, no source disclosed.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "organic-beetroot-supplement-60-capsules",
      "title": "Organic Beetroot Supplement 60 Capsules",
      "vendor": "Healthspan Holistic",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Beetroot-front-3D-min.jpg?v=1777838727",
      "score": 64,
      "tier": "standard",
      "certifications": [
        "NSF Certified",
        "GMP Certified"
      ],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "beetroot",
        "supplement",
        "capsules",
        "healthspan",
        "holistic"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 68,
        "safety": 65,
        "transparency": 60,
        "sustainability": 60
      },
      "price": 21.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170799472837",
      "vsf_explanation": "1,300 mg organic beetroot powder per serving in a GMP+NSF facility. Coles 2012 and Kapil 2015 show BP reductions with beetroot juice at ~500 mg nitrate — this powder capsule delivers a lower absolute nitrate load but still supports circulation. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "advanced-eye-support-formula-vision-health-eye-rejuvenation-supplement",
      "title": "Advanced Eye Support Formula | Vision Health & Eye Rejuvenation Supplement",
      "vendor": "Seamoss depot",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/FullSizeRender_13481e19-f550-4466-9ae9-7797957e6cc5.jpg?v=1777838740",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "advanced",
        "eye",
        "support",
        "formula",
        "vision",
        "health",
        "eye",
        "rejuvenation",
        "supplement",
        "seamoss",
        "depot"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 25,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 20,
        "sustainability": 40
      },
      "price": 55.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170799603909",
      "vsf_explanation": "'Advanced Eye Support Formula' with zero ingredient disclosure, zero dose information, and claims to 'slow the progression of common conditions that may lead to vision loss' — a disease claim without substantiation on an unlabeled product.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "maya-s-organics-berberine-sea-moss-gel-16-oz-premium-blood-sugar-metabolism-support-formula",
      "title": "Maya’s Organics Berberine Sea Moss Gel 16 oz – Premium Blood Sugar & Metabolism Support Formula",
      "vendor": "Seamoss depot",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Berberine_Seamoss.png?v=1777838742",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "maya",
        "organics",
        "berberine",
        "sea",
        "moss",
        "gel",
        "premium",
        "blood",
        "sugar",
        "metabolism",
        "support",
        "formula",
        "seamoss",
        "depot"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 40,
        "transparency": 25,
        "sustainability": 55
      },
      "price": 42.77,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170799702213",
      "vsf_explanation": "Wildcrafted sea moss + berberine + Ceylon cinnamon + elderberry + hibiscus gel. Berberine has metabolic evidence (Yin 2008) but at 1500mg/day divided doses; a 1-2 tbsp sea moss gel dose almost certainly falls far below therapeutic berberine. Blood sugar and metabolism claims without dose disclosure.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "flourish-menopause-support-supplement",
      "title": "Flourish Menopause Support Supplement",
      "vendor": "ForWomn | Women's Health and Nutrition Supplements and More",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/flourish-menopause-supplement.png?v=1777838758",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "female",
      "life_stage": "postmenopausal",
      "tokens": [
        "flourish",
        "menopause",
        "support",
        "supplement",
        "forwomn",
        "women",
        "health",
        "and",
        "nutrition",
        "supplements",
        "and",
        "more"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170799866053",
      "vsf_explanation": "Black cohosh–based menopause blend with no per-ingredient doses on the label copy. Black cohosh has modest RCT support for vasomotor symptoms (Leach 2012 Cochrane) but only at standardized 40mg extracts, which isn't verifiable here. No manufacturer or testing info.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "black-cumin-seed-oil-softgels-1000mg-per-serving-500mg-each-120-capsules-cold-pressed-nigella-sativa-supplement",
      "title": "Black Cumin Seed Oil Softgels 1000mg per Serving (500mg Each) – 120 Capsules | Cold-Pressed Nigella Sativa Supplement",
      "vendor": "Seamoss depot",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Black_Seed_Oil_-_Sea_Moss_Depot.png?v=1777838761",
      "score": 51,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "black",
        "cumin",
        "seed",
        "oil",
        "softgels",
        "1000mg",
        "per",
        "serving",
        "500mg",
        "each",
        "120",
        "capsules",
        "cold",
        "pressed",
        "nigella",
        "sativa",
        "supplement",
        "seamoss",
        "depot"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 28.77,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170799898821",
      "vsf_explanation": "1000 mg Nigella sativa oil (500 mg per softgel) at a clearly disclosed dose; meta-analyses show small BP and lipid effects (Sahebkar 2016). Cold-pressed, GMP-manufactured. Thymoquinone standardization not disclosed, which is the active-content marker for black seed oil; entry Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "evening-melatonin-sleep-formula",
      "title": "Evening Melatonin Sleep Formula",
      "vendor": "ForWomn | Women's Health and Nutrition Supplements and More",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Evening-sleep-support-supplement.png?v=1777838762",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "evening",
        "melatonin",
        "sleep",
        "formula",
        "forwomn",
        "women",
        "health",
        "and",
        "nutrition",
        "supplements",
        "and",
        "more"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170799964357",
      "vsf_explanation": "Melatonin + chamomile + passionflower is a plausible sleep stack, but no doses are shown; effective melatonin is 0.3–1mg for sleep onset (Zhdanova 2001). No manufacturing detail or third-party testing.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "protect-immune-support-supplement",
      "title": "Protect Immune Support Supplement",
      "vendor": "ForWomn | Women's Health and Nutrition Supplements and More",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Protect-Immune-support-supplement.png?v=1777838775",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "protect",
        "immune",
        "support",
        "supplement",
        "forwomn",
        "women",
        "health",
        "and",
        "nutrition",
        "supplements",
        "and",
        "more"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170800095429",
      "vsf_explanation": "Vitamin C, zinc, elderberry, echinacea combination; each has some clinical backing (Hemilä 2013 for zinc lozenges) but no milligram amounts are shown, so nothing can be verified against therapeutic thresholds.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "balance-advanced-multivitamin",
      "title": "Balance Advanced Multivitamin",
      "vendor": "ForWomn | Women's Health and Nutrition Supplements and More",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Balance-female-multivitamin.png?v=1777838778",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "balance",
        "advanced",
        "multivitamin",
        "forwomn",
        "women",
        "health",
        "and",
        "nutrition",
        "supplements",
        "and",
        "more"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 42,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 23.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170800160965",
      "vsf_explanation": "General women's multivitamin with B-complex, D+K2, and antioxidants — potentially useful, but no doses or forms disclosed. A credible multi requires bioavailable methyl-B forms and clear IU/mcg amounts, none confirmed.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "calm-daily-stress-support-supplement",
      "title": "Calm Daily Stress Support Supplement",
      "vendor": "ForWomn | Women's Health and Nutrition Supplements and More",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/calm-stress-mental-supplement.png?v=1777838781",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "calm",
        "daily",
        "stress",
        "support",
        "supplement",
        "forwomn",
        "women",
        "health",
        "and",
        "nutrition",
        "supplements",
        "and",
        "more"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 18.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170800259269",
      "vsf_explanation": "Ashwagandha + L-theanine + rhodiola stack — reasonable ingredients with RCT support (Chandrasekhar 2012 for KSM-66 at 300mg), but no doses shown. Ashwagandha extract type isn't identified.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "rhythm-urinary-tract-support-supplement",
      "title": "Rhythm Urinary Tract Support Supplement",
      "vendor": "ForWomn | Women's Health and Nutrition Supplements and More",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Rhythm-urinary-tract-supplement.png?v=1777838788",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "rhythm",
        "urinary",
        "tract",
        "support",
        "supplement",
        "forwomn",
        "women",
        "health",
        "and",
        "nutrition",
        "supplements",
        "and",
        "more"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 21.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170800455877",
      "vsf_explanation": "Cranberry + D-mannose combination has moderate RCT support (Kranjčec 2014 for D-mannose 2g/day), but this label discloses no PAC content or D-mannose grams. Cannot verify against clinical thresholds.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "organic-mushroom-extract-powder-blend",
      "title": "Organic Mushroom Extract Powder Blend",
      "vendor": "FreshCap Mushrooms",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/umc_powder.png?v=1777838824",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "mushroom",
        "extract",
        "powder",
        "blend",
        "freshcap",
        "mushrooms"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 50,
        "sustainability": 60
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170800685253",
      "vsf_explanation": "Six-species mushroom extract powder (12,000mg raw equivalent). FreshCap uses fruiting bodies (positive vs mycelium-on-grain fillers). Per-species mg and beta-glucan % not disclosed here, capping the score below Verified. Reishi/lion's mane immune modulation supported at extract doses (Vetvicka 2019).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cordyceps-mushroom-extract-powder",
      "title": "Cordyceps Mushroom Extract Powder",
      "vendor": "FreshCap Mushrooms",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cordyceps_powder.png?v=1777838885",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cordyceps",
        "mushroom",
        "extract",
        "powder",
        "freshcap",
        "mushrooms"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 75,
        "manufacturing": 75,
        "safety": 78,
        "transparency": 72,
        "sustainability": 65
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170801078469",
      "vsf_explanation": "FreshCap uses water-extracted cordyceps fruiting bodies at 10,000mg raw equivalent per serving with third-party beta-glucan testing. Chen 2010 RCT (n=20) on CS-4 cordyceps at 3g/day showed a modest VO2max improvement in older adults. Formulation and manufacturing are solid; evidence base is moderate for endurance claims.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-turkey-tail-mushroom-powder",
      "title": "Organic Turkey Tail Mushroom Powder",
      "vendor": "FreshCap Mushrooms",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/turkey_tail_powder.png?v=1777838889",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "turkey",
        "tail",
        "mushroom",
        "powder",
        "freshcap",
        "mushrooms"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 75,
        "manufacturing": 75,
        "safety": 78,
        "transparency": 72,
        "sustainability": 65
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170801111237",
      "vsf_explanation": "Hot-water extracted turkey tail delivering polysaccharide-K/PSP fraction at 10,000mg raw equivalent. Torkelson 2012 phase 1 study in breast cancer patients showed dose-dependent NK-cell and lymphocyte recovery. FreshCap tests for beta-glucans and uses fruiting bodies rather than myceliated grain.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-lion-s-mane-mushroom-powder",
      "title": "Organic Lion’s Mane Mushroom Powder",
      "vendor": "FreshCap Mushrooms",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/lion_s_mane_powder.png?v=1777838900",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "lion",
        "mane",
        "mushroom",
        "powder",
        "freshcap",
        "mushrooms"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 78,
        "manufacturing": 76,
        "safety": 80,
        "transparency": 74,
        "sustainability": 65
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170801209541",
      "vsf_explanation": "Triple-extracted lion's mane at 14,000mg raw equivalent from fruiting bodies. Mori 2009 RCT (n=30) at 3g/day for 16 weeks showed improved cognitive scores in adults with mild cognitive impairment; benefits regressed after discontinuation. Solid extraction methodology and beta-glucan verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-lion-s-mane-capsules",
      "title": "Organic Lion’s Mane Capsules",
      "vendor": "FreshCap Mushrooms",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/lion_s_mane_capsules_120ct_f32e777b-9ead-4707-8af3-821f4007f4cf.png?v=1777838967",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "lion",
        "mane",
        "capsules",
        "freshcap",
        "mushrooms"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 76,
        "manufacturing": 76,
        "safety": 80,
        "transparency": 74,
        "sustainability": 63
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170801864901",
      "vsf_explanation": "Same triple-extracted lion's mane fruiting-body formulation as the powder, delivered in capsules at 14,000mg raw equivalent. Mori 2009 RCT supports cognitive benefit at ~3g/day. Slight sustainability deduction for capsule packaging vs. bulk powder.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-reishi-mushroom-powder",
      "title": "Organic Reishi Mushroom Powder",
      "vendor": "FreshCap Mushrooms",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/reishi_powder.png?v=1777838971",
      "score": 69,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "reishi",
        "mushroom",
        "powder",
        "freshcap",
        "mushrooms"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 76,
        "manufacturing": 75,
        "safety": 76,
        "transparency": 72,
        "sustainability": 65
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170801963205",
      "vsf_explanation": "Dual-extracted reishi fruiting bodies at 14,000mg raw equivalent, targeting both triterpenes and polysaccharides. Wachtel-Galor 2004 human trial showed antioxidant serum markers rose; clinical fatigue/sleep RCTs remain small. Formulation is high quality but reishi evidence base is thinner than lion's mane.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-reishi-mushroom-capsules",
      "title": "Organic Reishi Mushroom Capsules",
      "vendor": "FreshCap Mushrooms",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/reishi_capsules_120ct_464ff5ac-8c7c-4a3e-8347-1bf28381788f.png?v=1777838978",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "reishi",
        "mushroom",
        "capsules",
        "freshcap",
        "mushrooms"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 74,
        "manufacturing": 75,
        "safety": 76,
        "transparency": 72,
        "sustainability": 63
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170802061509",
      "vsf_explanation": "Dual-extracted reishi in capsule form at 14,000mg raw equivalent. Same evidence base as the powder — Wachtel-Galor antioxidant data and small immune RCTs. Capsule form scores slightly lower on sustainability than the bulk powder.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "calm-focus-cognitive-wellness-support-supplement",
      "title": "Calm & Focus – Cognitive & Wellness Support Supplement",
      "vendor": "My Spectrum Heroes",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CTR_1.png?v=1777839013",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "calm",
        "focus",
        "cognitive",
        "wellness",
        "support",
        "supplement",
        "spectrum",
        "heroes"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics",
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170802356421",
      "vsf_explanation": "L-theanine has decent evidence for calm focus at 100-200mg (Nobre 2008 EEG study), GABA oral bioavailability is disputed (Boonstra 2015), and Huperzine A is a potent AChE inhibitor originally studied for Alzheimer's (Xu 1995) with cumulative-dose safety concerns for daily wellness use. Doses per capsule not disclosed.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "super-mag-powder-magnesium-supplement-for-wellness-balance",
      "title": "Super Mag Powder – Magnesium Supplement for Wellness & Balance",
      "vendor": "My Spectrum Heroes",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/B0CCZZGH55.Main_-_Super_Mag_Powder.png?v=1777839028",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "super",
        "mag",
        "powder",
        "magnesium",
        "supplement",
        "for",
        "wellness",
        "balance",
        "spectrum",
        "heroes"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients",
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 40,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170802651333",
      "vsf_explanation": "Albion (Balchem) chelated mineral technology is a well-recognized magnesium bisglycinate/glycinate source with strong bioavailability data (DiSilvestro 2013). Naming the Albion source is above-average transparency for the batch. Elemental magnesium mg per scoop not disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-matcha-powder",
      "title": "Organic Matcha Powder",
      "vendor": "OWL Venice",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/OWL-OrganicMatchaPowder-5_59dc3fb5-65e6-4683-a906-6af84cecc066.webp?v=1777839043",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "matcha",
        "powder",
        "owl",
        "venice"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 68,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170803372229",
      "vsf_explanation": "Ceremonial-grade matcha delivering 36 mg caffeine and 3.9 mg L-theanine per serving. Green tea catechins have decent evidence for antioxidant and metabolic effects (Hursel 2011), but the 3.9 mg theanine is far below cognitive RCT doses (100-200 mg). Origin/pesticide COA not specified. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "digestive-bitters",
      "title": "Digestive Bitters",
      "vendor": "OWL Venice",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/OWLDigestiveBittersSupplement-3.webp?v=1777839048",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "digestive",
        "bitters",
        "owl",
        "venice"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 17,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170803404997",
      "vsf_explanation": "Ten-herb bitters tincture with no per-ingredient dose disclosure and no third-party testing shown. Traditional bitters have some digestive-motility evidence (McMullen 2015 review) but no RCT on this specific proprietary combination. Fails transparency requirement.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "liver-boost",
      "title": "Liver Boost",
      "vendor": "OWL Venice",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/OWL-LiverBoostSupplement-2.webp?v=1777839055",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liver",
        "boost",
        "owl",
        "venice"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 42,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 28,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170803568837",
      "vsf_explanation": "Eight-herb tincture (burdock, yellow dock, Oregon grape, dandelion, red clover, nettle, red root, ginger) sold as a 'proprietary blend' without doses. No RCT support for the combination. Detoxification claims are marketing rather than clinical.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "4-day-shake-reset",
      "title": "4-Day Shake Reset",
      "vendor": "OWL Venice",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4DdayShakeReset.webp?v=1777839062",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "day",
        "shake",
        "reset",
        "owl",
        "venice"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health",
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 35,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 20,
        "sustainability": 55
      },
      "price": 158,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170803634373",
      "vsf_explanation": "4-day shake replacement program at $158 — no formulation transparency in listing. Meal-replacement 'reset' programs lack evidence for durable metabolic benefit (Astbury 2019 total meal replacement review specifically studies medically supervised protocols, not consumer resets).",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "sinus-spell",
      "title": "Sinus Spell",
      "vendor": "OWL Venice",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/OWLSinusSpellSupplement-4.webp?v=1777839067",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sinus",
        "spell",
        "owl",
        "venice"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 42,
        "manufacturing": 45,
        "safety": 52,
        "transparency": 22,
        "sustainability": 45
      },
      "price": 18,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170803732677",
      "vsf_explanation": "Multi-herb sinus tincture (horseradish, echinacea, garlic, cayenne, goldenseal, licorice, andrographis, etc.) with no per-ingredient doses. Licorice and goldenseal both carry pregnancy/BP contraindications. Only weak observational sinus support in traditional literature.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "yeast-buster",
      "title": "Yeast Buster",
      "vendor": "OWL Venice",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/OWLYeastBusterSupplement-2.webp?v=1777839075",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "yeast",
        "buster",
        "owl",
        "venice"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 22,
        "sustainability": 45
      },
      "price": 20,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170803830981",
      "vsf_explanation": "Eight-herb antifungal tincture sold as 'proprietary blend' with candida and yeast-infection claims. Black walnut hull and pau d'arco have hepatotoxicity signals at higher doses. No RCT support and disease-adjacent claims.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "1-week-gut-sweep-reset",
      "title": "1-Week Gut Sweep Reset",
      "vendor": "OWL Venice",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/GutSweepReset-5.webp?v=1777839082",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "week",
        "gut",
        "sweep",
        "reset",
        "owl",
        "venice"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 30,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 15,
        "sustainability": 55
      },
      "price": 185,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170803962053",
      "vsf_explanation": "Gut cleanse/reset framing at $185 with no ingredient or dose disclosure. Commercial 'gut cleanse' claims are not evidence-supported (Klein 2015 detox review); ordinary fiber, hydration and diet changes achieve the outcomes 'cleanses' claim.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "the-owl-reset-21-day-organic-cleanse-program",
      "title": "The OWL Reset - 21 Day - Organic Cleanse Program",
      "vendor": "OWL Venice",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/21DayReset_1.webp?v=1777839087",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "the",
        "owl",
        "reset",
        "day",
        "organic",
        "cleanse",
        "program",
        "owl",
        "venice"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health",
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 30,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 20,
        "sustainability": 55
      },
      "price": 380,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170804060357",
      "vsf_explanation": "21-day 'organic cleanse' at $380 combines removal of 'inflammatory foods' with unspecified self-care rituals — this is a wellness program, not a supplement, and elimination diets have mixed evidence outside diagnosed food sensitivities (Elli 2016). No ingredient composition disclosed.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "the-owl-reset-organic-cleanse-program",
      "title": "The OWL Reset - Organic Cleanse Program",
      "vendor": "OWL Venice",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4DayReset_2.webp?v=1777839093",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "the",
        "owl",
        "reset",
        "organic",
        "cleanse",
        "program",
        "owl",
        "venice"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 35,
        "sustainability": 50
      },
      "price": 295,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170804191429",
      "vsf_explanation": "A $295 broth-and-shake 'cleanse' framed with Ayurveda/chronobiology marketing. No ingredient panel, no clinical support for 'reset' claims. Cleanse/detox protocols lack RCT evidence for the outcomes suggested (Klein & Kiat 2015 review found no clinical benefit for commercial detoxes). Priced far above efficacious equivalents; scored Rejected on evidence and transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "testolite®-corti-guard",
      "title": "Testolite® Corti-Guard",
      "vendor": "Testolite",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Corti-Guard.png?v=1777839122",
      "score": 67,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "testolite",
        "corti",
        "guard",
        "testolite"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental",
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 78,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 78,
        "sustainability": 45
      },
      "price": 49.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170805633221",
      "vsf_explanation": "Fully disclosed doses: KSM-66 300mg (clinical dose from Chandrasekhar 2012), Tongkat Ali 200mg standardized to 1.5–2% eurycomanone (Talbott 2013), Rhodiola 200mg, PS 200mg, L-theanine 200mg, Mg bisglycinate 200mg. Formulation is coherent and honest about cortisol/testosterone axis. Loses on smaller-brand manufacturing evidence and no COA disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "testolite®-estro-guard",
      "title": "Testolite® Estro-Guard",
      "vendor": "Testolite",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Estro-Guard.png?v=1777839130",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "testolite",
        "estro",
        "guard",
        "testolite"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine",
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 70,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 75,
        "sustainability": 45
      },
      "price": 39.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170805764293",
      "vsf_explanation": "All doses disclosed: Calcium D-glucarate 500mg, NAC 300mg, grape seed 100mg (≥95% OPCs), apigenin 50mg, boron 5mg (Naghii 2011 supports boron 10mg for free T). Formulation is rational for estrogen clearance but underlying 'boost testosterone via estrogen management' claim is weakly supported outside boron. Small-brand, limited COA disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "testolite®-redsync™",
      "title": "Testolite® RedSync™",
      "vendor": "Testolite",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8995facc-eb99-48f4-b924-2a937947dcdf.png?v=1777839139",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "testolite",
        "redsync",
        "testolite"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 60,
        "sustainability": 40
      },
      "price": 49.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170805829829",
      "vsf_explanation": "Marketed as 11 compounds at clinical doses with no proprietary blends and bioavailable forms — a positive signal versus category peers. However, testosterone-support stacks generally show modest effects (Smith 2021 meta-analysis on tribulus/ashwagandha), and the 'maximize red light therapy results' framing is aspirational without a paired trial.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "focus-supplement-for-mental-clarity-and-concentration",
      "title": "Focus Supplement for Mental Clarity and Concentration",
      "vendor": "SensIQ",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Focus.webp?v=1777840220",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "focus",
        "supplement",
        "for",
        "mental",
        "clarity",
        "and",
        "concentration",
        "sensiq"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 109,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170817757381",
      "vsf_explanation": "Alpha-GPC, Lion's Mane, Rhodiola, and Bacopa each have RCT support (e.g., Stough 2001 Bacopa 300mg for 12 weeks improved memory), but per-ingredient doses are not disclosed in listing copy. At $109 the value/transparency ratio is weak. Standard-tier pending label dose confirmation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "calm-by-sensiq-stress-relaxation-and-emotional-balance",
      "title": "Calm by SensIQ – Stress, Relaxation, and Emotional Balance",
      "vendor": "SensIQ",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Calm.webp?v=1777840230",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "calm",
        "sensiq",
        "stress",
        "relaxation",
        "and",
        "emotional",
        "balance",
        "sensiq"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 109,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170817888453",
      "vsf_explanation": "SensIQ Calm makes 30-minute stress-relief claims but the product page discloses no active ingredients or doses. Without a supplement facts panel, evidence cannot be evaluated and the buyer cannot verify therapeutic amounts. Capped at 45 under the transparency auto-fail.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "memory-supplement-for-brain-support",
      "title": "Memory Supplement for Brain Support",
      "vendor": "SensIQ",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Memory.webp?v=1777840233",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "memory",
        "supplement",
        "for",
        "brain",
        "support",
        "sensiq"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 109,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170817921221",
      "vsf_explanation": "SensIQ Memory promises 'mental clarity' over 8-12 weeks but shares no formula, doses, or clinical references. Nootropic claims without a disclosed panel cannot be evaluated against RCT literature (e.g., Bacopa, citicoline). Capped by transparency auto-fail.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "relieve-joint-health-supplement",
      "title": "Relieve Joint Health Supplement",
      "vendor": "SensIQ",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Relieve.webp?v=1777840242",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "relieve",
        "joint",
        "health",
        "supplement",
        "sensiq"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 109,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170818052293",
      "vsf_explanation": "Turmeric root extract, organic chaga, quercetin — sensible actives for joint/inflammation support, but no doses, no curcumin standardization, no piperine or phospholipid carrier. Curcumin RCTs (Panahi 2017) use 500-1500 mg standardized extract. Priced at $109 without disclosure to justify it. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "clarity-micronized-creatine-monohydrate",
      "title": "Clarity Micronized Creatine Monohydrate",
      "vendor": "SensIQ",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Clarity.webp?v=1777840252",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "clarity",
        "micronized",
        "creatine",
        "monohydrate",
        "sensiq"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170818183365",
      "vsf_explanation": "Micronized creatine monohydrate is one of the best-evidenced supplements — Kreider 2017 (ISSN position) confirms 3-5 g/day for muscle and cognitive support, with cognitive benefits in Rae 2003 and Avgerinos 2018. Loses points because the page does not confirm the per-scoop dose, third-party testing, or Creapure sourcing; SensIQ is a young brand with limited provenance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natural-sleep-supplement-without-melatonin",
      "title": "Natural Sleep Supplement Without Melatonin",
      "vendor": "SensIQ",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/AhandistossingawhitebottlelabeledSensIQSleepdietarysupplementagainstaplainlightbackground..webp?v=1777840260",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "natural",
        "sleep",
        "supplement",
        "without",
        "melatonin",
        "sensiq"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 109,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170818216133",
      "vsf_explanation": "Ashwagandha, L-theanine, magnesium, valerian, and reishi are each individually supported (Chandrasekhar 2012 ashwagandha 300mg twice daily reduced perceived stress). Product listing does not disclose per-ingredient doses. Standard tier absent transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "super-fisetin-500mg-6-month-senolytic-supplement-supports-cellular-health-longevity-gmp-certified-destroy-zombie-cells-for-anti-aging-by-revgenetics",
      "title": "Super Fisetin 500mg - 6 Month Senolytic Supplement - Supports Cellular Health & Longevity - GMP-Certified - Destroy Zombie Cells - For Anti-Aging by RevGenetics",
      "vendor": "RevGenetics",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/super-fisetin-senolytic-supplementf.jpg?v=1777840293",
      "score": 53,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "super",
        "fisetin",
        "500mg",
        "month",
        "senolytic",
        "supplement",
        "supports",
        "cellular",
        "health",
        "longevity",
        "gmp",
        "certified",
        "destroy",
        "zombie",
        "cells",
        "for",
        "anti",
        "aging",
        "revgenetics",
        "revgenetics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 232.2,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170818576581",
      "vsf_explanation": "Fisetin as senolytic is grounded in Yousefzadeh 2018 (EBioMedicine) mouse studies at ~100 mg/kg equivalent, but human RCTs (e.g., Mayo AFFIRM-LITE) are still enrolling. 500 mg matches intermittent-pulse protocols under study. GMP-certified is a plus but 'destroy zombie cells' framing overpromises in humans.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "egcg-800mg-caffeine-free-green-tea-extract-for-cellular-health",
      "title": "EGCG 800mg Caffeine-Free: Green Tea Extract for Cellular Health",
      "vendor": "RevGenetics",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/RevGeneticsEGCG800-x1000.png?v=1777840301",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "egcg",
        "800mg",
        "caffeine",
        "free",
        "green",
        "tea",
        "extract",
        "for",
        "cellular",
        "health",
        "revgenetics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 40,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 62.26,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170818674885",
      "vsf_explanation": "800 mg EGCG (decaf green-tea extract) has cellular/antioxidant literature (Yang 2016) and is being studied in mTOR/longevity contexts. Safety is the concern: EFSA 2018 flagged hepatotoxicity risk at >=800 mg/day EGCG single dose, exactly this product's stated amount. Solid transparency, but the safety cap keeps it at Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "metacurcumin-277x-10x-sirt6-boost-no-pepper",
      "title": "MetaCurcumin 277x: 10x SIRT6 Boost, No Pepper",
      "vendor": "RevGenetics",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/metacurcumin-277x-super-curcumin-tetrahydrocurcumin.png?v=1777840306",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "metacurcumin",
        "277x",
        "10x",
        "sirt6",
        "boost",
        "pepper",
        "revgenetics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 80,
        "manufacturing": 70,
        "safety": 70,
        "transparency": 70,
        "sustainability": 60
      },
      "price": 54.88,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170818740421",
      "vsf_explanation": "Sub-10 nm self-emulsifying micellar curcumin (SEDDS) referencing Schiborr 2014, which did show ~185x-277x AUC over unformulated powder in a real crossover RCT. Formulation format is a genuine bioavailability leap over standard turmeric (Meriva/Longvida class), and adding tetrahydrocurcumin is a defensible design choice. Held to Verified rather than Elite because the SIRT6 claim rests on preliminary in-vitro work and there is no independent third-party COA visible.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "super-z-nano-quercetin-with-zinc-in-micelles-supplement-advanced-micelle-ionophore-formula-for-anti-aging-health-immune-to-plain-zinc-better-than-liposomal-by-revgenetics",
      "title": "Super Z - Nano Quercetin with Zinc in Micelles Supplement - Advanced Micelle Ionophore Formula for Anti-aging Health - Immune to plain Zinc- Better than liposomal -By RevGenetics",
      "vendor": "RevGenetics",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MetaQuercetinFront993x993-sw.png?v=1777840313",
      "score": 52,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "immune",
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "super",
        "nano",
        "quercetin",
        "with",
        "zinc",
        "micelles",
        "supplement",
        "advanced",
        "micelle",
        "ionophore",
        "formula",
        "for",
        "anti",
        "aging",
        "health",
        "immune",
        "plain",
        "zinc",
        "better",
        "than",
        "liposomal",
        "revgenetics",
        "revgenetics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants",
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 50,
        "sustainability": 40
      },
      "price": 50,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170818838725",
      "vsf_explanation": "Quercetin-zinc ionophore concept has mechanistic plausibility (Dabbagh-Bazarbachi 2014) and some COVID-era investigation, but 'better than liposomal' marketing outruns comparative data. Established RevGenetics brand offers modest transparency; no independent COA cited.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "diberberine-300x-dihydro-berberine-enteric-300x-patent-pending-booster",
      "title": "DiBerberine 300x: Dihydro Berberine Enteric + 300x Patent Pending Booster",
      "vendor": "RevGenetics",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/DiBerberine300xFront.webp?v=1777840319",
      "score": 53,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "diberberine",
        "300x",
        "dihydro",
        "berberine",
        "enteric",
        "300x",
        "patent",
        "pending",
        "booster",
        "revgenetics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 50,
        "sustainability": 40
      },
      "price": 50,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170818904261",
      "vsf_explanation": "Dihydroberberine has better bioavailability than berberine HCl (Turner 2008, Metabolism) and berberine's HbA1c/lipid effect has RCT support (Lan 2015 meta-analysis). The '300x booster' is patent-pending, which is a marketing signal, not proof; effective dose and booster identity are opaque.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "quinton-totum-nite-isotonic-electrolyte-supplement",
      "title": "Quinton Totum Nite Isotonic Electrolyte Supplement",
      "vendor": "WaterAndWellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/70.png?v=1777840377",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "quinton",
        "totum",
        "nite",
        "isotonic",
        "electrolyte",
        "supplement",
        "waterandwellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 60,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170819625157",
      "vsf_explanation": "Quinton isotonic marine plasma (25ml sachet) delivers ~78 trace minerals from cold-microfiltered seawater; a small tradition of use plus limited modern data (Alberola-Die 2014 pilot) support hydration but not the stronger claims about 'deeper brain sleep' or immunity. No per-mineral dose disclosed and no third-party COA visible on-page. Real product from a legitimate marine supplier, but claims outrun evidence, landing at the low Standard boundary.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "relief-hydrogen-bath-soak",
      "title": "RELIEF Hydrogen Bath Soak",
      "vendor": "WaterAndWellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/14-removebg-preview.png?v=1777840385",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "relief",
        "hydrogen",
        "bath",
        "soak",
        "waterandwellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 50,
        "sustainability": 40
      },
      "price": 52.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170819657925",
      "vsf_explanation": "Effervescent hydrogen-release bath tablets (magnesium + organic acids). LeBaron 2019 review of molecular hydrogen suggests systemic benefits from ingested/inhaled H2, but transdermal H2 uptake evidence is very thin (Ostojic 2015 open-label pilot only). Fundamentally a topical soak, not a true supplement.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "active-h2-ultra-molecular-hydrogen-tablets",
      "title": "Active H2 Ultra Molecular Hydrogen Tablets",
      "vendor": "WaterAndWellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_f8bae7d4-e167-45a6-81cc-61f3202f4447.png?v=1777840393",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "active",
        "ultra",
        "molecular",
        "hydrogen",
        "tablets",
        "waterandwellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic",
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 30,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170819723461",
      "vsf_explanation": "Molecular hydrogen literature is small and mostly pilot-scale (Ostojic 2014); claims of energy, focus, anti-aging outrun evidence. Magnesium as core ingredient is legitimate, but marketing over-promises. Third-party testing not disclosed.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "quintessential-3-3",
      "title": "QuintEssential 3.3",
      "vendor": "WaterAndWellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4_e6cde557-4a1c-42c0-9e88-66548d023de1.png?v=1777840399",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "quintessential",
        "waterandwellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 50,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170819854533",
      "vsf_explanation": "Isotonic seawater (Quinton protocol) in 10 mL sachets marketed for hydration/electrolyte support. Cold-sterilized without heat is a real technical differentiator. Human RCTs on seawater supplementation are sparse; mineral profile is broad but per-mineral mg is generally minimal at 10 mL. Clean provenance since 1887 helps transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "quintessential-0-9",
      "title": "QuintEssential 0.9",
      "vendor": "WaterAndWellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/quinton_quintessential_0.9.png?v=1777840404",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "quintessential",
        "waterandwellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 62,
        "manufacturing": 65,
        "safety": 62,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 50,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170819952837",
      "vsf_explanation": "Isotonic marine plasma (Quinton) diluted to blood-plasma osmolarity, sourced from protected plankton blooms off France and cold-sterilized. Historical use is long (since 1887) but modern RCT support for oral marine plasma is limited. Trace mineral content per sachet not quantified. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "quinton-totum-sport-hypertonic-electrolyte-supplement",
      "title": "Quinton Totum Sport Hypertonic Electrolyte Supplement",
      "vendor": "WaterAndWellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/53_d439d192-5915-4ef9-9932-b90eb9ab58ee.png?v=1777840409",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "quinton",
        "totum",
        "sport",
        "hypertonic",
        "electrolyte",
        "supplement",
        "waterandwellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic",
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 60,
        "sustainability": 65
      },
      "price": 60,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170820051141",
      "vsf_explanation": "Cold-microfiltered marine plasma 20 mL sachets with a full seawater electrolyte profile. Hypertonic seawater electrolyte solutions have a small evidence base for hydration (Perez-Idarraga 2014 J Int Soc Sports Nutr). Clean-label claim, no maltodextrin or added sugars. '46% lactic acid reduction' claim is marketing-tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "quinton-daily-nasal-spray",
      "title": "Quinton DAILY Nasal Spray",
      "vendor": "WaterAndWellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/27_aeff5cea-6199-41d6-ac71-d6fb5bd5265b.png?v=1777840416",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "quinton",
        "daily",
        "nasal",
        "spray",
        "waterandwellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 68,
        "manufacturing": 72,
        "safety": 72,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170820149445",
      "vsf_explanation": "Isotonic Quinton seawater (71% spring water, 29% seawater), cold-microfiltered per Rene Quinton protocol. Saline nasal irrigation has moderate evidence for sinusitis (Rabago 2002 hypertonic saline RCT). Multi-mineral trace content is intriguing but not RCT-verified for oral/nasal absorption benefits.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "quinton-marine-plasma-hypertonic®-30-ampules-of-marine-plasma",
      "title": "QUINTON Marine Plasma Hypertonic® 30 ampules of Marine Plasma",
      "vendor": "WaterAndWellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/hypertonic_glass_ampolues.jpg?v=1777840419",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "quinton",
        "marine",
        "plasma",
        "hypertonic",
        "ampules",
        "marine",
        "plasma",
        "waterandwellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 50,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170820182213",
      "vsf_explanation": "Hypertonic seawater ampules from plankton blooms, harvested per Rene Quinton's 19th-century protocol. Provides trace minerals in ionic form; systematic RCT evidence is thin. Glass ampule delivery and long-standing brand tradition support transparency. Not enough clinical evidence for the Verified band.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "now-available-beauty-pearl-herbal-supplement-skin-hormonal-balance-by-sunrider",
      "title": "NOW AVAILABLE Beauty Pearl - Herbal Supplement | Skin & Hormonal Balance by Sunrider",
      "vendor": "NOW",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/beauty-pearl-herbal-supplement-skin-hormonal-balance-by-sunrider-933336483.jpg?v=1777840444",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "available",
        "beauty",
        "pearl",
        "herbal",
        "supplement",
        "skin",
        "hormonal",
        "balance",
        "sunrider",
        "now"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 55.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170820411589",
      "vsf_explanation": "Sunrider's classic 'Philosophy of Regeneration' pearl-shaped multi-herb capsule with vague nutrient/amino/antioxidant description and no ingredient panel or per-herb doses in the copy. Claims to help skin, PMS, and mood balance rest on marketing rather than trials.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "flare-free-antifungal-balm",
      "title": "Flare Free Antifungal Balm",
      "vendor": "MoonMaid Botanicals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Antifungal_Balm_Flare_Free.png?v=1777840456",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "flare",
        "free",
        "antifungal",
        "balm",
        "moonmaid",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 48,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170820608197",
      "vsf_explanation": "Goldenseal-infused topical salve marketed for athlete's foot, jock itch, and ringworm. Berberine has in-vitro antifungal activity, but no controlled human trials for topical goldenseal against dermatophytes. Product makes specific disease claims (fungal infections, bacterial infections) without FDA-recognized evidence.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "proandro-mens-wild-yam-cream-6oz",
      "title": "ProAndro Men's Wild Yam Cream (6oz)",
      "vendor": "MoonMaid Botanicals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ProAndro_6oz_d5bd0dd4-9245-41e7-94b9-5e300d1a13dd.png?v=1777840460",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "proandro",
        "men",
        "wild",
        "yam",
        "cream",
        "6oz",
        "moonmaid",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 42,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 40,
        "sustainability": 55
      },
      "price": 70,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170820739269",
      "vsf_explanation": "Wild yam cream marketed for testosterone and endocrine support. Diosgenin does not convert to progesterone or testosterone in vivo in humans (Komesaroff 2001 RCT of wild yam cream showed no hormone or symptom change). Claim is a persistent myth.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "promeno-womens-wild-yam-cream-6oz",
      "title": "ProMeno Women's Wild Yam Cream (6oz)",
      "vendor": "MoonMaid Botanicals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ProMeno_6oz_34ae0ed1-fc9e-49df-b293-ca4794662cb0.png?v=1777840466",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "promeno",
        "women",
        "wild",
        "yam",
        "cream",
        "6oz",
        "moonmaid",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 42,
        "sustainability": 55
      },
      "price": 70,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170820870341",
      "vsf_explanation": "Wild yam + chasteberry cream marketed for menopause symptoms. Komesaroff 2001 RCT (n=23) found topical wild yam produced no measurable hormone or symptom change vs. placebo. Vitex has mild oral RCT support for PMS but is not delivered systemically via a cream.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "breathe-easy-2-oz-liquid-herbal-supplement",
      "title": "Breathe Easy | 2 oz Liquid Herbal Supplement",
      "vendor": "MoonMaid Botanicals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Breathe_Easy_Mullein_Liquid_Herbal_Supplement_for_Flu_Cold_Covid.png?v=1777840470",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "breathe",
        "easy",
        "liquid",
        "herbal",
        "supplement",
        "moonmaid",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 45,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 17,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170820935877",
      "vsf_explanation": "Marketed for 'managing lung infections' and asthma. Mullein and thyme have limited-quality respiratory RCTs; andrographis has some cold data (Coon 2004). Specific disease-treatment framing crosses into DSHEA-questionable territory and constituent mg is not disclosed.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "cool-calm-2-oz-liquid-herbal-supplement",
      "title": "Cool & Calm | 2 oz Liquid Herbal Supplement",
      "vendor": "MoonMaid Botanicals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Cool_and_Calm_Hot_Flashes_Menopause_Liquid_Supplement_for_Anxiety.png?v=1777840476",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cool",
        "calm",
        "liquid",
        "herbal",
        "supplement",
        "moonmaid",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health",
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 45,
        "transparency": 35,
        "sustainability": 55
      },
      "price": 17,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170821066949",
      "vsf_explanation": "Herbal tincture including St. John's Wort (major CYP450 interactions with SSRIs, contraceptives, warfarin) with no dose per drop disclosed. Black cohosh + turmeric mix is traditional but not clinically standardized here.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "daily-detox-2-oz-liquid-herbal-supplement",
      "title": "Daily Detox | 2 oz Liquid Herbal Supplement",
      "vendor": "MoonMaid Botanicals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Daily_Detox_Metal_Detox_Liquid_Herbal_Supplement_Swedish_Bitters_dadd7a53-ba28-4cef-b7fc-f96679fa8bcf.png?v=1777840480",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "daily",
        "detox",
        "liquid",
        "herbal",
        "supplement",
        "moonmaid",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive",
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 50,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 17,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170821165253",
      "vsf_explanation": "Herbal tincture marketed for kidney/liver detox, heavy-metal chelation, and norovirus support. Heavy-metal chelation from oral herbs is not clinically supported outside pharmaceutical chelators (Ibrahim 2017). Detox-marketing terminology is broadly criticized (Klein 2015 review).",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "silent-night-liquid-herbal-supplement",
      "title": "Silent Night | Liquid Herbal Supplement",
      "vendor": "MoonMaid Botanicals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Silent_Night_Sleep_Aid_Liquid_Herbal_Supplement_Sleepytime.png?v=1777840487",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "silent",
        "night",
        "liquid",
        "herbal",
        "supplement",
        "moonmaid",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 35,
        "sustainability": 55
      },
      "price": 17,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170821198021",
      "vsf_explanation": "Passionflower and motherwort tincture — passionflower has modest RCT support for anxiety (Akhondzadeh 2001) at ~45 drops. No mg-per-mL disclosed here, so effect is unverifiable.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "proandro-mens-wild-yam-cream",
      "title": "ProAndro Men's Wild Yam Cream",
      "vendor": "MoonMaid Botanicals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Mens_Pro_Andro_Wild_Yam_Cream_656053e9-bbac-429d-a976-ce2736939879.png?v=1777840493",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "proandro",
        "men",
        "wild",
        "yam",
        "cream",
        "moonmaid",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health",
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170821296325",
      "vsf_explanation": "Wild yam (Dioscorea) does not convert to human progesterone or testosterone in vivo (Komesaroff 2001). Topical cream claiming to regulate testosterone and support andropause has no clinical mechanism. Constituent doses not disclosed.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "promeno-womens-wild-yam-cream",
      "title": "ProMeno Women's Wild Yam Cream",
      "vendor": "MoonMaid Botanicals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ProMeno_Wild_Yam_Cream.png?v=1777840497",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "promeno",
        "women",
        "wild",
        "yam",
        "cream",
        "moonmaid",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 42,
        "sustainability": 55
      },
      "price": 35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170821394629",
      "vsf_explanation": "Same wild yam + chasteberry topical formula as the 6oz version. Komesaroff 2001 RCT showed no hormone or symptom change from topical wild yam. Marketed as HRT alternative without supporting evidence.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "yeast-free-goldenseal-salve",
      "title": "Yeast Free Goldenseal Salve",
      "vendor": "MoonMaid Botanicals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Yeast_Free_Herbal_Suppositories_Yeast_Infection_ca30c5e1-1697-4cea-9546-9b16bf99cebe.png?v=1777840501",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "yeast",
        "free",
        "goldenseal",
        "salve",
        "moonmaid",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 31,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170821492933",
      "vsf_explanation": "Goldenseal olive-oil vaginal suppositories marketed as boric acid alternative for candida. No RCT for topical goldenseal against vulvovaginal candidiasis. Berberine has in-vitro activity only. Making infection-treatment claims without controlled evidence.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "cycle-relief-2-oz-liquid-herbal-supplement",
      "title": "Cycle Relief | 2 oz Liquid Herbal Supplement",
      "vendor": "MoonMaid Botanicals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Cycle_Relief_Menstrual_Cramps_Pain_Relief_4f259e3e-52f3-41c7-8a00-067310ae7ec9.png?v=1777840506",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cycle",
        "relief",
        "liquid",
        "herbal",
        "supplement",
        "moonmaid",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 35,
        "sustainability": 55
      },
      "price": 17,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170821558469",
      "vsf_explanation": "Herbal blend for menstrual discomfort. Ginger (Ozgoli 2009) and turmeric have small RCTs for dysmenorrhea, but this liquid tincture provides no mg-per-serving data.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "ouch-ointment-comfrey-salve",
      "title": "Ouch Ointment Comfrey Salve",
      "vendor": "MoonMaid Botanicals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Ouch_Ointment_Soothing_Healing_Balm_Comfrey_Salve_a063f170-923b-4e91-8712-9f3ed37e09d0.png?v=1777840516",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ouch",
        "ointment",
        "comfrey",
        "salve",
        "moonmaid",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty",
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 31,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170822377669",
      "vsf_explanation": "Topical comfrey salve using low-PA Symphytum tuberosum plus calendula, arnica, St. John's Wort. Topical comfrey has moderate RCT evidence for musculoskeletal pain and minor wounds (Staiger 2012 Phytother Res). Vendor explicitly addresses pyrrolizidine-alkaloid safety by choosing a low-PA variety - a transparency positive. Pyrrolizidine-alkaloid safety note: comfrey is safe for external use only, on intact (unbroken) skin, and should not be used for more than 4-6 weeks continuously or during pregnancy/breastfeeding — it should never be ingested or applied to open wounds or broken skin.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vital-v-vulva-wild-yam-salve",
      "title": "Vital \"V\" Vulva Wild Yam Salve",
      "vendor": "MoonMaid Botanicals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Vital_Vulva_Vaginal_Moisturizer_1.png?v=1777840532",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vital",
        "vulva",
        "wild",
        "yam",
        "salve",
        "moonmaid",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health",
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 31,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170822541509",
      "vsf_explanation": "Topical vulvar moisturizer positioned strictly for comfort/hydration rather than hormonal action - the vendor is explicit that this is not a hormone product. Emollient-only claims are plausible; ingredient list is disclosed. Petroleum- and fragrance-free is a mild safety positive.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "breast-balm",
      "title": "Breast Balm",
      "vendor": "MoonMaid Botanicals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Breast_Balm_Lymph_Support_Breast_Pain_8d4a140a-1651-41f1-b8d3-672f6b679824.png?v=1777840539",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "breast",
        "balm",
        "moonmaid",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170822836421",
      "vsf_explanation": "Topical herb-infused balm marketed for fibrocystic breast tissue, cyclical breast pain, and menopausal breast pain. No controlled evidence for topical botanical relief of mastalgia. Halaska 2019 vitex RCT is oral, not topical.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "herbal-spice-anti-inflammatory-tea",
      "title": "Herbal Spice Anti-Inflammatory Tea",
      "vendor": "MoonMaid Botanicals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Herbal_Spice_Anti-Inflammatory_Tea.jpg?v=1777840547",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "herbal",
        "spice",
        "anti",
        "inflammatory",
        "tea",
        "moonmaid",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 18,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170822869189",
      "vsf_explanation": "Loose-leaf herbal tea (nettle, moringa, holy basil, rose hips, pine, ginger, turmeric, peppercorns). The individual botanicals have modest anti-inflammatory data (ginger and turmeric — Daily 2016 meta-analysis on osteoarthritis pain), but as a tea the extraction and delivered curcumin/6-gingerol are low, and the marketing lists BPH/thyroid/diabetes among 'may help' conditions.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "berry-cooling-tea-for-hot-flashes",
      "title": "Berry Cooling Tea for Hot Flashes",
      "vendor": "MoonMaid Botanicals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Berry_Cooling_Tea_for_Hot_Flashes.jpg?v=1777840552",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "berry",
        "cooling",
        "tea",
        "for",
        "hot",
        "flashes",
        "moonmaid",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 48,
        "manufacturing": 48,
        "safety": 50,
        "transparency": 48,
        "sustainability": 60
      },
      "price": 18,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170822901957",
      "vsf_explanation": "Herbal tea blend (peppermint, nettle, blueberry, goji, hawthorn, licorice). Nettle has mild diuretic support and hawthorn has cardiovascular RCTs (Pittler 2008), but no controlled evidence for hot flash relief from this specific blend. Licorice content raises BP-elevation concern with regular use.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "heartfelt-tea-for-blood-pressure",
      "title": "Heartfelt Tea for Blood Pressure",
      "vendor": "MoonMaid Botanicals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Heartfelt_Tea_Blood_Pressure_Loose_Leaf_Tea.webp?v=1777840556",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "heartfelt",
        "tea",
        "for",
        "blood",
        "pressure",
        "moonmaid",
        "botanicals"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 10,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170822934725",
      "vsf_explanation": "A hibiscus/bilberry/cinnamon/rose herbal tea explicitly marketed with the product name 'for Blood Pressure' and body claims of 'Healthy Blood Pressure Support'. Blood pressure is an FDA-regulated diagnostic and therapeutic claim category, and no drug clearance is cited. Auto-failed as an unverified medical claim regardless of any downstream herbal merit.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "mental-focus-energy-herbal-tea",
      "title": "Mental Focus & Energy Herbal Tea",
      "vendor": "MoonMaid Botanicals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Energy_and_Focus_Herbal_Tea.webp?v=1777840560",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mental",
        "focus",
        "energy",
        "herbal",
        "tea",
        "moonmaid",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 45,
        "manufacturing": 48,
        "safety": 55,
        "transparency": 42,
        "sustainability": 55
      },
      "price": 10,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170823033029",
      "vsf_explanation": "Herbal tea marketed for energy without caffeine. Full ingredient list truncated in copy and no doses disclosed. Herbal teas at typical infusion levels rarely reach cognitive-active doses (Bacopa, rhodiola etc. need standardized extracts at 300mg+ per Stough 2001).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "restful-sleep-sleepytime-tea",
      "title": "Restful Sleep Sleepytime Tea",
      "vendor": "MoonMaid Botanicals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Restful_Sleep_Sleepytime_Tea.jpg?v=1777840571",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "restful",
        "sleep",
        "sleepytime",
        "tea",
        "moonmaid",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 48,
        "manufacturing": 48,
        "safety": 55,
        "transparency": 45,
        "sustainability": 60
      },
      "price": 18,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170823131333",
      "vsf_explanation": "Passionflower-led sleep tea. Ngan 2011 RCT of passionflower tea (n=41) showed modest sleep-quality improvement over 1 week, but tea-level doses are far below encapsulated valerian/passionflower trials. Sedative warning is appropriate.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "antihistamine-tea-for-allergies",
      "title": "Antihistamine Tea for Allergies",
      "vendor": "MoonMaid Botanicals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Antihistamine_Tea_for_Allergies.webp?v=1777840576",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "antihistamine",
        "tea",
        "for",
        "allergies",
        "moonmaid",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 48,
        "manufacturing": 48,
        "safety": 50,
        "transparency": 45,
        "sustainability": 60
      },
      "price": 18,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170823164101",
      "vsf_explanation": "Nettle-led allergy tea with mullein, moringa, holy basil, licorice. Roschek 2009 in-vitro suggested nettle inhibits histamine receptors; only one small human trial (Mittman 1990, n=69) showed mild rhinitis relief at 300mg nettle capsules — well above tea-infusion doses. Licorice with daily use elevates BP risk.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "moontime-relief-tea-for-period-pain",
      "title": "Moontime Relief Tea for Period Pain",
      "vendor": "MoonMaid Botanicals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Claid-AI-25672395080146fcacb7c3ac17d8c026_copy.jpg?v=1777840580",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "moontime",
        "relief",
        "tea",
        "for",
        "period",
        "pain",
        "moonmaid",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 48,
        "manufacturing": 48,
        "safety": 55,
        "transparency": 45,
        "sustainability": 60
      },
      "price": 18,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170823196869",
      "vsf_explanation": "Menstrual-relief herbal tea. Cramp bark and chasteberry have some traditional-use data; Loch 2000 vitex RCT (200mg/day capsule) showed PMS relief but that dose is not deliverable via tea. Blend doses not disclosed; endometriosis-adjacent claims are not evidence-supported.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gingerbread-herbal-tea-for-digestion",
      "title": "Gingerbread Herbal Tea for Digestion",
      "vendor": "MoonMaid Botanicals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Gingerbread_Tea_for_Digestion.jpg?v=1777840584",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gingerbread",
        "herbal",
        "tea",
        "for",
        "digestion",
        "moonmaid",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 18,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170823229637",
      "vsf_explanation": "Loose-leaf digestion tea with ginger, cinnamon, cloves, nutmeg, licorice, dandelion, and cacao nibs. Ginger has decent evidence for functional dyspepsia and post-meal bloating (Bodagh 2019 review). Format is a food-grade tea, not a standardized extract, so magnitude of effect is modest and doses are unspecified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "now-available-prime-again-natural-herbal-supplement-by-sunrider",
      "title": "NOW AVAILABLE Prime Again Natural Herbal Supplement by Sunrider",
      "vendor": "NOW",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/prime-again-natural-herbal-supplement-by-sunrider-22888420212930.png?v=1777840603",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "available",
        "prime",
        "again",
        "natural",
        "herbal",
        "supplement",
        "sunrider",
        "now"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 30,
        "manufacturing": 40,
        "safety": 40,
        "transparency": 20,
        "sustainability": 40
      },
      "price": 55.86,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170823360709",
      "vsf_explanation": "Sunrider Prime Again is explicitly described as a 'proprietary blend of concentrated herbs' (Chinese yam, leek seed, eucommia bark, cornel fruit, broomrape, morinda, fennel) for endocrine support. No per-herb mg disclosed. Endocrine claim is unsupported by clinical data.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "ureaaide™-medical-grade-urea-supplement-kidneyaide",
      "title": "UreaAide™ – Medical Grade Urea Supplement (KidneyAide)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/357585555.jpg?v=1777840618",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ureaaide",
        "medical",
        "grade",
        "urea",
        "supplement",
        "kidneyaide",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 65,
        "manufacturing": 65,
        "safety": 45,
        "transparency": 65,
        "sustainability": 45
      },
      "price": 55.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170823459013",
      "vsf_explanation": "Urea is a legitimate medical-food approach to SIADH-associated hyponatremia (Decaux 2010, Verbalis 2013 guidelines). This is a physician-directed product, not a general wellness supplement — safety only under supervision. Solid clinical rationale for the target population; downgraded because it is off-label for general biohacking.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-encapsulations-hair-skin-nails-ultra-advanced-beauty-supplement-with-biotin-collagen-60-capsules",
      "title": "Pure Encapsulations Hair/Skin/Nails Ultra – Advanced Beauty Supplement with Biotin & Collagen - 60 Capsules",
      "vendor": "Pure Encapsulations",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71gxTMBtU3L._AC_SX569.jpg?v=1777840640",
      "score": 82,
      "tier": "elite",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "encapsulations",
        "hair",
        "skin",
        "nails",
        "ultra",
        "advanced",
        "beauty",
        "supplement",
        "with",
        "biotin",
        "collagen",
        "capsules",
        "pure",
        "encapsulations"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 76,
        "formulation": 82,
        "manufacturing": 82,
        "safety": 82,
        "transparency": 82,
        "sustainability": 60
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170823688389",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 78 → new 82. Evidence found: Proksch E et al. Oral supplementation of specific collagen peptides has beneficial effects on human skin physiology: a double-blind, placebo-controlled study. Skin Pharmacol Physiol. 2014;27(1):47-55. | Choi FD et al. Oral Collagen Supplementation: A Systematic Review of Dermatological Applications. J Drugs Dermatol. 2019;18(1):9-16.. Rationale: Pure Encaps Hair/Skin/Nails Ultra combines hydrolyzed collagen peptides, biotin, silica, MSM, and vitamin C at practitioner-grade purity (hypoallergenic, no unnecessary excipients). Collagen peptide evidence for skin elasticity is TIER-A/B; hair/nail benefits are TIER-C. Elite tier justified by brand quality + evidence-supported core actives.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-encapsulations-zinc-30-60-capsules",
      "title": "Pure Encapsulations Zinc 30, 60 Capsules",
      "vendor": "Pure Encapsulations",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/212331227.png?v=1777840680",
      "score": 82,
      "tier": "elite",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "encapsulations",
        "zinc",
        "capsules",
        "pure",
        "encapsulations"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 80,
        "formulation": 80,
        "manufacturing": 85,
        "safety": 78,
        "transparency": 78,
        "sustainability": 65
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170824278213",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 78 → new 82. Evidence found: Barrie SA et al. Comparative absorption of zinc picolinate, zinc citrate and zinc gluconate in humans. Agents Actions. 1987;21(1-2):223-228. | Prasad AS. Discovery of human zinc deficiency: 50 years later. J Trace Elem Med Biol. 2012;26(2-3):66-69.. Rationale: Pure Encaps Zinc 30 uses zinc picolinate form, which Barrie 1987 showed superior absorption vs citrate and gluconate. 30 mg is the top of daily intake recommendations without excess (upper limit 40 mg). Hypoallergenic formulation. Elite tier for form quality + dose + brand.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-encapsulations-melatonin-20-mg-60-capsules",
      "title": "Pure Encapsulations Melatonin 20 Mg, 60 Capsules",
      "vendor": "Pure Encapsulations",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/123301371.jpg?v=1777840685",
      "score": 76,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "encapsulations",
        "melatonin",
        "capsules",
        "pure",
        "encapsulations"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 78,
        "manufacturing": 82,
        "safety": 70,
        "transparency": 78,
        "sustainability": 70
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170824343749",
      "vsf_explanation": "Pure Encapsulations at 20 mg melatonin — an intentionally high antioxidant/oncologic-support dose, explicitly not for sleep. 20 mg has been studied in adjunctive cancer supportive care (Seely 2012 meta-analysis). 99.5% purity, hypoallergenic, no unnecessary excipients. Verified — high dose warrants medical supervision, but the brand and formulation are excellent.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-encapsulations-b-complex-plus-120-capsules",
      "title": "Pure Encapsulations B-Complex Plus 120 Capsules",
      "vendor": "Pure Encapsulations",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/88130463.jpg?v=1777840690",
      "score": 85,
      "tier": "elite",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "encapsulations",
        "complex",
        "plus",
        "120",
        "capsules",
        "pure",
        "encapsulations"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 85,
        "manufacturing": 85,
        "safety": 84,
        "transparency": 84,
        "sustainability": 60
      },
      "price": 42,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170824409285",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 80 → new 85. Evidence found: B-Complex Plus formulation: activated B-vitamin forms (P-5-P, R-5-P, methylcobalamin, L-methylfolate as Metafolin). | Obeid R, Herrmann W. The emerging role of unmetabolized folic acid in human diseases. Mol Nutr Food Res. 2012;56(7):1039-1049.. Rationale: B-Complex Plus uses fully bioactive B-vitamin forms: P-5-P (B6), R-5-P (B2), methylcobalamin (B12), L-methylfolate as Metafolin (folate). Every B is in its coenzyme-active form, bypassing genetic and enzymatic conversion bottlenecks. Elite tier for reference-standard B-complex formulation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-encapsulations-l-glutamine-500-mg-90-capsules",
      "title": "Pure Encapsulations L-Glutamine 500 Mg, 90 Capsules",
      "vendor": "Pure Encapsulations",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/123481748_9fc292be-5cc2-4e7c-b7bf-98dc2f832695.jpg?v=1777840694",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "encapsulations",
        "glutamine",
        "500",
        "capsules",
        "pure",
        "encapsulations"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 76,
        "manufacturing": 84,
        "safety": 84,
        "transparency": 82,
        "sustainability": 60
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170824540357",
      "vsf_explanation": "500mg per capsule L-glutamine, a modest per-cap dose (clinical trials for gut/IBS use 5g+/day per Zhou 2019 RCT, requiring 10 caps). Ingredient quality and Pure Encaps GMP standards are excellent; users need to multi-dose for therapeutic effect.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-encapsulations-magnesium-glycinate-supplement-to-support-stress-relief-sleep-heart-health-nerves-muscles-and-metabolism-with-magnesium-glycinate-180-capsules",
      "title": "Pure Encapsulations Magnesium (Glycinate) - Supplement to Support Stress Relief, Sleep, Heart Health, Nerves, Muscles, and Metabolism* - with Magnesium Glycinate - 180 Capsules",
      "vendor": "Pure Encapsulations",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71pkSYcYOZL._AC_SL1500_5861ad00-eae8-4947-8b4e-78f6aea2794e.jpg?v=1777840698",
      "score": 82,
      "tier": "elite",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "encapsulations",
        "magnesium",
        "glycinate",
        "supplement",
        "support",
        "stress",
        "relief",
        "sleep",
        "heart",
        "health",
        "nerves",
        "muscles",
        "and",
        "metabolism",
        "with",
        "magnesium",
        "glycinate",
        "180",
        "capsules",
        "pure",
        "encapsulations"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 80,
        "formulation": 80,
        "manufacturing": 85,
        "safety": 85,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 68.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170824573125",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 76 → new 82. Evidence found: Schuette SA et al. Bioavailability of magnesium diglycinate vs magnesium oxide. JPEN J Parenter Enteral Nutr. 1994;18(5):430-435. | Boyle NB et al. The Effects of Magnesium Supplementation on Subjective Anxiety and Stress. Nutrients. 2017;9(5):429.. Rationale: Pure Encaps Magnesium Glycinate at practitioner-grade purity (hypoallergenic, no unnecessary excipients). Bisglycinate chelate has demonstrated superior absorption and lower GI side effects vs oxide/citrate. Elite tier for form quality + brand hypoallergenic standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-encapsulations-magnesium-glycinate-supplement-to-support-stress-relief-sleep-heart-health-nerves-muscles-and-metabolism-with-magnesium-glycinate-180-capsules-1",
      "title": "Pure Encapsulations Magnesium (Glycinate) - Supplement to Support Stress Relief, Sleep, Heart Health, Nerves, Muscles, and Metabolism* - with Magnesium Glycinate - 180 Capsules",
      "vendor": "Pure Encapsulations",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71pkSYcYOZL._AC_SL1500_9378c0b6-fa4b-418e-955e-5b47c21881c2.jpg?v=1777840704",
      "score": 82,
      "tier": "elite",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "encapsulations",
        "magnesium",
        "glycinate",
        "supplement",
        "support",
        "stress",
        "relief",
        "sleep",
        "heart",
        "health",
        "nerves",
        "muscles",
        "and",
        "metabolism",
        "with",
        "magnesium",
        "glycinate",
        "180",
        "capsules",
        "pure",
        "encapsulations"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 80,
        "formulation": 80,
        "manufacturing": 85,
        "safety": 85,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 51.74,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170824671429",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 76 → new 82. Evidence found: Schuette SA et al. Bioavailability of magnesium diglycinate vs magnesium oxide. JPEN J Parenter Enteral Nutr. 1994;18(5):430-435.. Rationale: Duplicate listing of the Pure Encaps Magnesium Glycinate 180ct product. Same uplift rationale — flag for possible catalog deduplication in a follow-up housekeeping pass.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-encapsulations-magnesium-glycinate-120-mg-90-capsules",
      "title": "Pure Encapsulations Magnesium Glycinate 120 Mg, 90 Capsules",
      "vendor": "Pure Encapsulations",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/45734102_1a91791f-d57e-4d74-a4c0-43ea7b464bf6.jpg?v=1777840718",
      "score": 82,
      "tier": "elite",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "encapsulations",
        "magnesium",
        "glycinate",
        "120",
        "capsules",
        "pure",
        "encapsulations"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 80,
        "formulation": 80,
        "manufacturing": 85,
        "safety": 80,
        "transparency": 80,
        "sustainability": 60
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170824769733",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 78 → new 82. Evidence found: Schuette SA et al. Bioavailability of magnesium diglycinate vs magnesium oxide. JPEN J Parenter Enteral Nutr. 1994;18(5):430-435. | Boyle NB et al. The Effects of Magnesium Supplementation on Subjective Anxiety and Stress. Nutrients. 2017;9(5):429.. Rationale: Same practitioner-grade bisglycinate as the 180-count listings. 120 mg elemental per capsule is the labeled amount (typical Pure Encaps format). Elite tier consistent with sibling SKUs.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-encapsulations-hair-skin-nails-ultra-60-capsules",
      "title": "Pure Encapsulations Hair/Skin/Nails Ultra, 60 Capsules",
      "vendor": "Pure Encapsulations",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/334320273.jpg?v=1777840722",
      "score": 80,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "encapsulations",
        "hair",
        "skin",
        "nails",
        "ultra",
        "capsules",
        "pure",
        "encapsulations"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 78,
        "manufacturing": 82,
        "safety": 72,
        "transparency": 75,
        "sustainability": 68
      },
      "price": 46.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170824868037",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 74 → new 80. Evidence found: Proksch E et al. Oral supplementation of specific collagen peptides on skin physiology. Skin Pharmacol Physiol. 2014;27(1):47-55.. Rationale: Same Pure Encaps Hair/Skin/Nails Ultra formula as the Advanced Beauty variant (likely legacy vs updated SKU). Uplift to 80 for practitioner brand + evidence-supported collagen+biotin+silica combination. Slight discount vs the 82 for the Advanced Beauty listing because label wording is less transparent about the collagen source.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-encapsulations-lithium-orotate-5-mg-90-capsules",
      "title": "Pure Encapsulations Lithium Orotate 5 Mg, 90 Capsules",
      "vendor": "Pure Encapsulations",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/113375727_ea00d315-8947-4278-a01d-bcb07f11a149.jpg?v=1777840727",
      "score": 67,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "encapsulations",
        "lithium",
        "orotate",
        "capsules",
        "pure",
        "encapsulations"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 72,
        "manufacturing": 82,
        "safety": 68,
        "transparency": 78,
        "sustainability": 60
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170824900805",
      "vsf_explanation": "5mg elemental lithium as orotate. Human RCTs are limited — Sartori 1986 low-dose lithium orotate showed modest alcoholism-relapse improvement; broader mood/cognitive claims rely on ecological trace-lithium epidemiology (Schrauzer 1990). Pure Encaps manufacturing quality is high.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "thorne-berberine-dual-action-formula-pack-of-2-120-capsules-total",
      "title": "THORNE Berberine – Dual Action Formula (Pack of 2) – 120 Capsules Total",
      "vendor": "Thorne",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitled_design_89.png?v=1777840789",
      "score": 80,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "thorne",
        "berberine",
        "dual",
        "action",
        "formula",
        "pack",
        "120",
        "capsules",
        "total",
        "thorne"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 72,
        "manufacturing": 78,
        "safety": 68,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 50.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170825228485",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 71 → new 80. Evidence found: Yin J, Xing H, Ye J. Efficacy of berberine in patients with type 2 diabetes mellitus. Metabolism. 2008;57(5):712-717. | Lan J et al. Meta-analysis of the effect and safety of berberine in the treatment of type 2 diabetes mellitus, hyperlipidemia and hypertension. J Ethnopharmacol. 2015;161:69-81. | Dong H et al. Berberine in the Treatment of Type 2 Diabetes Mellitus: A Systematic Review and Meta-Analysis. Evid Based Complement Alternat Med. 2012;2012:591654.. Rationale: Thorne's 'Dual Action' formula combines berberine with sustained-release delivery for reduced GI side effects — a legitimate reformulation for one of berberine's main tolerability limitations. Berberine ingredient class has TIER-A meta-analytic evidence for HbA1c reduction (~0.9%, comparable to metformin in some meta-analyses). Uplift to 80 for practitioner-grade brand + strong evidence + delivery innovation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liver-cleanse-and-detox-formula-milk-thistle-artichoke-extract-dandelion-and-apple-cider-vinegar-liver-health-supplement",
      "title": "Liver Cleanse and Detox Formula - Milk Thistle, Artichoke Extract, Dandelion, and Apple Cider Vinegar - Liver Health Supplement",
      "vendor": "The VITAMIZED Shop",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/VitamizedUrinary_Gummies_40060b88-7acd-4c53-bfb2-285946ba6d66.png?v=1777840840",
      "score": 39,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liver",
        "cleanse",
        "and",
        "detox",
        "formula",
        "milk",
        "thistle",
        "artichoke",
        "extract",
        "dandelion",
        "and",
        "apple",
        "cider",
        "vinegar",
        "liver",
        "health",
        "supplement",
        "the",
        "vitamized",
        "shop"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170825851077",
      "vsf_explanation": "Marketed as '28-in-1' liver cleanse with milk thistle, artichoke, dandelion, ACV, chicory, beet, burdock and more. Silymarin has modest NAFLD ALT evidence at 420 mg/day (Zhong 2017) but this listing shows no mg for silymarin or any other ingredient. Detox/repair claims run ahead of data.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "shilajit-complete-blend-energy-and-endurance-pure-shilajit-extract-60-capsules",
      "title": "Shilajit Complete Blend - Energy and Endurance - Pure Shilajit Extract - 60 Capsules",
      "vendor": "The VITAMIZED Shop",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/VitamizedUrinary_Gummies_6b4567a5-3eb0-4ea6-a881-84e9a81142bb.png?v=1777840846",
      "score": 43,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shilajit",
        "complete",
        "blend",
        "energy",
        "and",
        "endurance",
        "pure",
        "shilajit",
        "extract",
        "capsules",
        "the",
        "vitamized",
        "shop"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170825883845",
      "vsf_explanation": "'10,000mg Shilajit + 30,000mg Tongkat Ali' equivalency label is misleading — those numbers are unstated dry-herb ratios, not per-capsule doses. Massive multi-ingredient stack (Ashwagandha, Sea Moss, PQQ, CoQ10) with no per-ingredient mg. Rejected on autofail.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "dim-estrogen-supplement-hormone-balance-skin-health-and-menopause-support-vitamized",
      "title": "DIM Estrogen Supplement - Hormone Balance, Skin Health, and Menopause Support | Vitamized",
      "vendor": "The VITAMIZED Shop",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/VitamizedUrinary_Gummies_7687e8a7-1f3a-4027-8708-0fea919f8c6e.png?v=1777840851",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone",
        "skin"
      ],
      "sex_relevance": "female",
      "life_stage": "postmenopausal",
      "tokens": [
        "dim",
        "estrogen",
        "supplement",
        "hormone",
        "balance",
        "skin",
        "health",
        "and",
        "menopause",
        "support",
        "vitamized",
        "the",
        "vitamized",
        "shop"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 24.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170825982149",
      "vsf_explanation": "200 mg DIM (diindolylmethane) per capsule with BioPerine — DIM at 150-300 mg has some evidence for favorably shifting the 2-OH:16α-OH estrogen ratio (Michnovicz 1998), though clinical outcome data is thin. Vegan, non-GMO, US-made. Small brand, no third-party COA. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "immuni-d-liquid-vitamin-d-supplement-for-daily-wellness",
      "title": "Immuni-D Liquid – Vitamin D Supplement for Daily Wellness",
      "vendor": "My Spectrum Heroes",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/B08C27RDH8.Main_-_Immuni-D_Liquid.png?v=1777840864",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "immuni",
        "liquid",
        "vitamin",
        "supplement",
        "for",
        "daily",
        "wellness",
        "spectrum",
        "heroes"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 40,
        "sustainability": 55
      },
      "price": 26,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170826080453",
      "vsf_explanation": "Liquid vitamin D from a small autism-family-focused brand. Vitamin D3 supplementation at 1000-4000 IU has strong RCT support for deficiency correction and immune function (Martineau 2017 meta-analysis, respiratory infection). Product listing omits IU dose, form (D2 vs D3), and third-party testing details.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "puremark-naturals-vitamin-d-2",
      "title": "Puremark Naturals Vitamin D 2",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/44441210.jpg?v=1777840878",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "puremark",
        "naturals",
        "vitamin",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 50,
        "manufacturing": 52,
        "safety": 60,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170826178757",
      "vsf_explanation": "2000 IU vegan vitamin D (form ambiguous — likely D2/ergocalciferol given vegan claim, though title's 'D 2' is unclear). D2 is less bioavailable than D3 (Tripkovic 2012 meta-analysis: D3 raises 25(OH)D roughly twice as effectively). Basic private-label quality tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "windmill-vitamin-d-400-tablets",
      "title": "Windmill Vitamin D-400, Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/344820036.jpg?v=1777840897",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "windmill",
        "vitamin",
        "400",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 42,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 5.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170826277061",
      "vsf_explanation": "400 IU vitamin D per tablet is below the current adult RDA (600-800 IU) and far below doses studied for meaningful serum 25(OH)D elevation (typically 1000-4000 IU per Heaney 2011 dose-response data). Serves only as legacy minimum-intake supplement.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "windmill-natural-vitamin-d-1000-tablets",
      "title": "Windmill Natural Vitamin D 1000, Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/195093281_ac7b7bb5-4815-4666-ae1e-55e842bc4b00.jpg?v=1777840907",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "windmill",
        "natural",
        "vitamin",
        "1000",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 7.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170826408133",
      "vsf_explanation": "Basic vitamin D3 1000 IU tablet from a legacy generic brand. Vitamin D3 at 1000-2000 IU is well-evidenced for insufficiency (Holick 2011 Endocrine Society guidelines). Loses points for minimal transparency, no third-party COA, and drugstore-tier formulation with excipients unspecified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "leader-vitamin-d-5000-iu-tablets-100ct",
      "title": "Leader Vitamin D 5000 Iu Tablets 100Ct",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/242085568.jpg?v=1777840914",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "leader",
        "vitamin",
        "5000",
        "tablets",
        "100ct",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 6.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170826473669",
      "vsf_explanation": "Vitamin D3 at 5000 IU/day is well-supported for maintaining 25(OH)D >30 ng/mL in most adults (Holick 2011 Endocrine Society guideline). Leader is a private-label pharmacy brand — meets USP-level basics, allergen-free labeling, but no third-party COA. Straightforward efficacious daily dose form.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "windmill-health-vitamin-d-3-125-mcg-liquid",
      "title": "Windmill Health Vitamin D-3 125 Mcg Liquid",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/155269340.jpg?v=1777840919",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "windmill",
        "health",
        "vitamin",
        "125",
        "mcg",
        "liquid",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 8.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170826571973",
      "vsf_explanation": "Liquid vitamin D3 at 125 mcg (5000 IU) — a legitimate dose (Holick 2011) with better absorption than tablets. Body copy carries a boilerplate 'progesterone / California Prop 65' notice that appears unrelated to this SKU, undermining transparency. Standard for the active but sloppy presentation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "major-oyster-shell-calcium-500-mg-with-vitamin-d",
      "title": "Major Oyster Shell Calcium 500 Mg With Vitamin D",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/40022148.jpg?v=1777840928",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "major",
        "oyster",
        "shell",
        "calcium",
        "500",
        "with",
        "vitamin",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 8.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170827391173",
      "vsf_explanation": "Oyster-shell calcium carbonate 500 mg + D — the cheapest, least-bioavailable form of calcium (needs acid to absorb; Straub 2007). Meta-analyses (Bolland 2015) show calcium supplements offer minimal fracture-prevention benefit vs. dietary calcium and may raise CV risk. Standard because it does dose D3 alongside, but not a preferred form.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-blend-vitamin-d-cholecalciferol-400-iu-100-tablets",
      "title": "Nature's Blend Vitamin D (Cholecalciferol) 400 IU – 100 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/346731440_29942448-3355-46b2-aea1-da109d89676d.jpg?v=1777840941",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "blend",
        "vitamin",
        "cholecalciferol",
        "400",
        "100",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 4.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170827423941",
      "vsf_explanation": "400 IU cholecalciferol is far below the Endocrine Society's 1500-2000 IU/day recommendation for adults at risk of deficiency (Holick 2011). Adequate only for infants. As a general-adult product this is sub-therapeutic on the box.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "spring-valley-vitamin-d-3-1000-iu-450-softgels",
      "title": "Spring Valley - Vitamin D-3 1000 IU, 450 Softgels",
      "vendor": "SnapGoShop",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f7e96fb3a7bf7d692eae36ae69651d0e.jpg?v=1777840950",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "spring",
        "valley",
        "vitamin",
        "1000",
        "450",
        "softgels",
        "snapgoshop"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 48,
        "sustainability": 50
      },
      "price": 30.66,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170827489477",
      "vsf_explanation": "Walmart's Spring Valley 1000 IU D3 softgels — clinically meaningful dose supported by Martineau 2017 immune meta-analysis. USP verification variable across Spring Valley SKUs; third-party COA not routinely published. Adequate value tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mason-natural-vitamin-d-2000-iu-softgels-ultra-strength-60ct",
      "title": "Mason Natural Vitamin D 2000 IU Softgels Ultra Strength - 60ct",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/82285202.png?v=1777840965",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mason",
        "natural",
        "vitamin",
        "2000",
        "softgels",
        "ultra",
        "strength",
        "60ct",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 7.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170827686085",
      "vsf_explanation": "2000 IU (50 mcg) D3 softgels — sound mainstream dose supported by ODS Adult DRI guidance. Mason is a legacy drugstore brand; softgel format aids fat-soluble D3 absorption. No K2 pairing, no third-party assay. Solid Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "windmill®-vitamin-d-3-high-potency-5000-iu-tablets",
      "title": "Windmill® Vitamin D-3 – High Potency 5000 IU Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/44440542.jpg?v=1777840972",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "windmill",
        "vitamin",
        "high",
        "potency",
        "5000",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 10.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170828538053",
      "vsf_explanation": "5000 IU D3 tablets — a common repletion-level dose (Vieth 2001). Tablet delivery is less bioavailable than softgel for fat-soluble D3, and the description offers no K2, no third-party COA. Legacy consumer brand. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "schiff-super-calcium-plus-magnesium-with-vitamin-d-softgel-90-count",
      "title": "Schiff Super Calcium Plus Magnesium with Vitamin D Softgel, 90 Count",
      "vendor": "2xSavings",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/178838.jpg?v=1777840982",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "immune",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "schiff",
        "super",
        "calcium",
        "plus",
        "magnesium",
        "with",
        "vitamin",
        "softgel",
        "count",
        "2xsavings"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 11.76,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170828701893",
      "vsf_explanation": "Mainstream Ca+Mg+D3 softgel from a legacy OTC brand. Reasonable ingredient stack for bone maintenance, but doses/forms are not disclosed here (likely oxide/carbonate, low bioavailability). Bolland 2015 shows limited fracture-prevention effect for calcium supplementation. Standard for a well-known but generic formulation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "high-potency-cold-pressed-organic-black-seed-oil-with-3-thymoquinone",
      "title": "High Potency Cold-Pressed Organic Black Seed Oil with 3% Thymoquinone",
      "vendor": "Meraki Medicinal",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/B1.png?v=1777841042",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "high",
        "potency",
        "cold",
        "pressed",
        "organic",
        "black",
        "seed",
        "oil",
        "with",
        "thymoquinone",
        "meraki",
        "medicinal"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 74,
        "manufacturing": 66,
        "safety": 62,
        "transparency": 60,
        "sustainability": 65
      },
      "price": 40,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170829127877",
      "vsf_explanation": "3% thymoquinone content is high for Nigella sativa oil (typical 0.5-1.5%). Amin 2015 meta-analysis of nigella oil (2-2.5g/day) shows modest reductions in blood pressure and fasting glucose. Miron glass packaging protects TQ from photo-oxidation. Cautions on SSRI/methylene blue interaction are appropriate.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-gold-one-daily-multivitamin",
      "title": "Nature's Lab Gold One Daily Multivitamin",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/One_Daily_60ct_ZNLB13714-L2_Rev007_Virtual_Shadow_Front_8159fbc9-f13d-4a8c-98b7-bd6095756a93-383524.jpg?v=1777841070",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "gold",
        "one",
        "daily",
        "multivitamin",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 70,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170829422789",
      "vsf_explanation": "30+ actives incl. methylcobalamin B12, 4,000 IU D3, 100 mg CoQ10, K1+K2, quercetin, ALA, chromium, plus a prebiotic complex — comprehensive one-a-day. K2 + D3 stacking is supported (Kaneki 2001 for K2 bone effect). Standard, verging on Verified for a multi.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-gold-b-complex-60-fast-melts",
      "title": "Nature's Lab Gold B-Complex - 60 Fast Melts",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/B-Complex_60ct_ZNLB20615-L_Rev001_Virtual_Shadow_Front-min-253491.jpg?v=1777841075",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "gold",
        "complex",
        "fast",
        "melts",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 17.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170829521093",
      "vsf_explanation": "Full 8-B complex with methylcobalamin (active B12) and L-methylfolate (active folate) plus inositol — bioavailable forms preferable to cyano/folic-acid (Obeid 2013). Fast-melt delivery works for those with absorption issues. Per-vitamin mg amounts not shown in copy but forms are correctly identified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-gold-potassium-citrate-120-capsules",
      "title": "Nature's Lab Gold Potassium Citrate - 120 Capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Potassium_Citrate_120ct_ZNLB13770-L_Rev001_Virtual_Shadow_Front_870df38c-6c0f-487e-bfd9-0ad4251d0ad6-727860.jpg?v=1777841081",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "gold",
        "potassium",
        "citrate",
        "120",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients",
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 65,
        "sustainability": 40
      },
      "price": 12.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170829586629",
      "vsf_explanation": "Single-ingredient potassium citrate at 250 mg per capsule (about 5% DV), dose transparently disclosed. Potassium's role in blood pressure and vascular health is well established (Aburto BMJ 2013 meta), but 250 mg per dose is a maintenance-only amount, not clinically active. Basic mid-tier retail vendor with no third-party testing seals disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nature-s-lab-saw-palmetto-90-capsules",
      "title": "Nature’s Lab Saw Palmetto - 90 Capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Saw_Palmetto_90ct_ZNLB18153-L2_Rev002_Virtual_Shadow_front-706341.jpg?v=1777841087",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "saw",
        "palmetto",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 65,
        "safety": 62,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170829684933",
      "vsf_explanation": "450 mg saw palmetto per capsule, once daily. Below the 320 mg/day standardized-extract dose studied in BPH RCTs (Bent 2006 STEP trial found no benefit; earlier trials mixed). Disclosed single-ingredient dose is a plus, but real-world BPH benefit is unclear. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-ksm-66®-ashwagandha-extract-120-capsules",
      "title": "Nature's Lab KSM-66® Ashwagandha Extract - 120 Capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Ashwagandha_Extract_KSM-66_120ct_ZNLB20448-L_Rev001_Virtual_Shadow_Front-242493.jpg?v=1777841095",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "ksm",
        "ashwagandha",
        "extract",
        "120",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 70,
        "manufacturing": 68,
        "safety": 65,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170830045381",
      "vsf_explanation": "Patented KSM-66 ashwagandha, 600 mg standardized to 5% withanolides + 700 mg root powder per 2-cap serving. KSM-66 has multiple placebo-controlled RCTs for stress/cortisol (Chandrasegaran 2012; Salve 2019) at 600 mg/day — this hits it. Standard, close to Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-ceylon-cinnamon-1-200-mg-120-capsules",
      "title": "Nature's Lab Ceylon Cinnamon 1,200 mg - 120 Capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Ceylon_Cinnamon_120ct_ZNLB17996-L_Rev001_Virtual_Shadow_Front-455869.jpg?v=1777841102",
      "score": 53,
      "tier": "standard",
      "certifications": [
        "Kosher",
        "Halal"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "ceylon",
        "cinnamon",
        "200",
        "120",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170830110917",
      "vsf_explanation": "1200mg Ceylon cinnamon (Cinnamomum verum) daily — correctly picks true cinnamon over cassia to avoid coumarin hepatotoxicity, which is genuinely important. Meta-analyses on cinnamon and glycemic control are mixed (Allen 2013 modest effect on FBG). Reasonable formulation from a reputable mid-tier brand.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-gold-super-vitamin-c-1000-mg-120-capsules",
      "title": "Nature's Lab Gold Super Vitamin C 1000 mg - 120 Capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Super_Vitamin_C_120ct_ZNLB15046-L3_REV003_Virtual_Shadow_Front_f6218a58-201f-4e65-a093-60cbb8b26c92-903002.jpg?v=1777841109",
      "score": 62,
      "tier": "standard",
      "certifications": [
        "Kosher",
        "Halal"
      ],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "gold",
        "super",
        "vitamin",
        "1000",
        "120",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 78,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 17.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170830209221",
      "vsf_explanation": "1000mg vitamin C as calcium ascorbate (buffered, gentle) plus 200mg quercetin and 200mg citrus bioflavonoids per serving — a more thoughtful C formulation than the base version. Vitamin C's immune/antioxidant evidence is solid (Hemila 2013 Cochrane). Missing NSF/USP but Nature's Lab is a reputable mid-tier brand with kosher/halal/GF certifications.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-hair-skin-and-nails-90-capsules",
      "title": "Nature's Lab Hair, Skin and Nails - 90 Capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Hair_Skin_Nails_90ct_znlb18184-L_Rev001_Virtual_Shadow_front-137989.jpg?v=1777841116",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "hair",
        "skin",
        "and",
        "nails",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 16.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170830307525",
      "vsf_explanation": "Beauty stack with MSM, silica, BCAAs, and micronutrients. Biotin/silica have modest RCT support for hair and nails (Barel 2005 for choline-stabilized orthosilicic acid). Full amount-per-serving panel isn't disclosed in the product body, capping the transparency score.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-gold-blood-sugar-support-120-capsules",
      "title": "Nature's Lab Gold Blood Sugar Support - 120 Capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Blood_Sugar_Support_ZNLB18061-L_Rev001_Virtual_Shadow_Front-459197.jpg?v=1777841121",
      "score": 51,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "gold",
        "blood",
        "sugar",
        "support",
        "120",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health",
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 50,
        "sustainability": 40
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170830405829",
      "vsf_explanation": "Seven-ingredient blend anchored by 100 mcg ChromeMate chromium, Ceylon cinnamon, gymnema, fenugreek, bitter melon, bilberry, vanadium. Only chromium dose disclosed; the botanicals lack individual milligrams. Chromium picolinate meta-analysis (Suksomboon J Clin Pharm Ther 2014) shows modest fasting-glucose reduction in T2DM but effects are small and inconsistent.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-echinacea-760-mg-100-capsules",
      "title": "Nature's Lab Echinacea 760 mg - 100 Capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Echinachea_100ct_ZNLB17842-L2_Rev001_Virtual_Shadow_Front-954754.jpg?v=1777841131",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "echinacea",
        "760",
        "100",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 7.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170830536901",
      "vsf_explanation": "760 mg organic echinacea powder per serving — Echinacea purpurea has modest cold-duration evidence in meta-analysis (Shah 2007). Species not specified (E. purpurea vs. angustifolia vs. pallida differ in actives) and no standardized alkylamide content. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-vitamin-d3-plus-90-capsules",
      "title": "Nature's Lab Vitamin D3 Plus - 90 Capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Vitamin_D3_Plus_90ct_ZNLB17941-L1_Rev001_Virtual_Shadow_Front-122721.jpg?v=1777841140",
      "score": 65,
      "tier": "standard",
      "certifications": [
        "Kosher",
        "Halal"
      ],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "vitamin",
        "plus",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 70,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 13.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170830635205",
      "vsf_explanation": "5000 IU D3 with 100mcg K2 — the K2 partitioning story is well supported (Knapen 2013 for MK-7 and BMD; Vermeer 2019 review). D3 at 5000 IU addresses common deficiency levels (Holick 2011 guideline). Sits just below Pure Encaps D3 (~78) mainly on manufacturing certifications and standardization details.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nature-s-lab-gold-turmeric-joint-complex-120-capsules",
      "title": "Nature’s Lab Gold Turmeric + Joint Complex - 120 Capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Turmeric_Plus_Joint_Complex_120ct_ZNLB17699-L_Rev001_Virtual_Shadow_Front.jpg?v=1777841147",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "gold",
        "turmeric",
        "joint",
        "complex",
        "120",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 70,
        "transparency": 55,
        "sustainability": 40
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170830700741",
      "vsf_explanation": "Combines branded Curcumin C3 Complex (1000mg standardized to 95% curcuminoids) with BioCell Collagen, HA, MSM and BioPerine. Curcumin C3 + BioPerine has RCT support for OA symptom relief (Chandran & Antony 2012), and BioCell Collagen showed joint comfort benefit in Schauss et al. 2012. Manufactured USA cGMP; no third-party testing certificate cited.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-gold-berbevis®-berberine-phytosome™-extract-60-capsules",
      "title": "Nature's Lab Gold Berbevis® Berberine Phytosome™ Extract - 60 Capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NLG_Berberine_60ct_ZNLB20639-L_Front-966129.jpg?v=1777841152",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "gold",
        "berbevis",
        "berberine",
        "phytosome",
        "extract",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 70,
        "manufacturing": 65,
        "safety": 60,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170830831813",
      "vsf_explanation": "Berbevis® is Indena's branded berberine phytosome with a published PK study (Petrangolini 2021) showing 9.7x AUC increase versus standard berberine. Once-daily dosing and 308 mg absorbed dose match clinical range without the GI issues of 1500 mg unformulated berberine. Solid branded-ingredient story.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-gold-prototal-60-capsules",
      "title": "Nature's Lab Gold ProTotal - 60 Capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NLG_ProTotal_60ct_ZNLB20622-L_Rev001_Virtual_Shadow_Front-min-515662.jpg?v=1777841162",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "gold",
        "prototal",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 70,
        "transparency": 55,
        "sustainability": 40
      },
      "price": 18.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170830930117",
      "vsf_explanation": "3-in-1 pre/pro/postbiotic with 60B CFU across 5 named Lacto/Bifido strains, 300mg inulin prebiotic, and 200mg ButyraGen tributyrin postbiotic. Strain and dose disclosed at total CFU (not per-strain). Multi-strain Lacto/Bifido has meta-analytic support for IBS symptom relief (Ford et al. 2018).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-triple-strength-omega-3-fish-oil-with-epa-dha-180-softgels",
      "title": "Nature's Lab Triple Strength Omega-3 Fish Oil with EPA & DHA - 180 Softgels",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Triple_Strength_Fish_Oil_120ct_ZNLB17200-L3_Rev003_Virtual_Shadow_front-792960.jpg?v=1777841172",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "triple",
        "strength",
        "omega",
        "fish",
        "oil",
        "with",
        "epa",
        "dha",
        "180",
        "softgels",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 72,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 68,
        "sustainability": 60
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170830962885",
      "vsf_explanation": "1300mg combined EPA (650) + DHA (650) per 2-softgel serving is a genuinely therapeutic dose in line with cardiovascular RCT ranges (REDUCE-IT dose is higher, but VITAL 1g/d showed benefit). Wild-caught sustainability claim. Missing IFOS 5-star or third-party oxidation certification keeps it below Nordic Naturals Ultimate Omega (~87).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-vitamin-c-1-000mg-120-capsules",
      "title": "Nature's Lab Vitamin C 1,000mg - 120 Capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Vitamin_C_1000mg_120ct_ZNLB17910-L2_Rev002_Virtual_Shadow_front-999153.jpg?v=1777841179",
      "score": 59,
      "tier": "standard",
      "certifications": [
        "Kosher",
        "Halal"
      ],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "vitamin",
        "000mg",
        "120",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 75,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 8.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170830995653",
      "vsf_explanation": "1000mg per capsule as ascorbic acid — form not specified. Vitamin C's immune role is well-established (Hemila 2013 Cochrane), and 1000mg is a common daily dose. Simpler than the Gold version (no bioflavonoids/quercetin), but adequate and honest at this price point.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-gold-magnesium-glycinate-120-capsules",
      "title": "Nature's Lab Gold Magnesium Glycinate - 120 Capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Magensium_Glycinate_120ct_ZNLB14162-L5_Rev005_Virtual_Shadow_Front-min_09941d4c-466f-45be-805d-cd3ed5f0630c-251168.jpg?v=1777841190",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "gold",
        "magnesium",
        "glycinate",
        "120",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 55,
        "sustainability": 40
      },
      "price": 10.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170834960581",
      "vsf_explanation": "100mg elemental magnesium as glycinate per capsule. Requires 3-4 caps to reach clinically studied doses (~300-400mg). Magnesium glycinate is well-absorbed and gentle on GI (Walker et al. 2003). Single-form formulation is honest but low per-cap dose limits value density.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-fenugreek-610-mg-120-capsules",
      "title": "Nature's Lab Fenugreek 610 mg - 120 Capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Fenugreek_120ct_ZNLB18092_L-_Rev001_Virtual_Shadow_Front-897161.jpg?v=1777841197",
      "score": 49,
      "tier": "rejected",
      "certifications": [
        "Non-GMO Project Verified",
        "Kosher",
        "Halal"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "fenugreek",
        "610",
        "120",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 8.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170835058885",
      "vsf_explanation": "610mg fenugreek seed powder — not a standardized extract. Positive fenugreek RCTs use standardized extracts like Furosap (600mg 20% protodioscin) or Testofen (600mg 50% grecunin) — raw seed powder at 610mg does not deliver the same actives. Multiple claim domains (lactation, hormones, performance) with no dose justification for any.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "natures-lab-gold-coq10-alpha-lipoic-acid-acetyl-l-carnitine-hcl-60-capsules",
      "title": "Nature's Lab Gold CoQ10 + Alpha Lipoic Acid + Acetyl L-Carnitine HCl - 60 Capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CoQ10_ALA_ALC_60ct_ZNLB13745-L2_Rev004_Virtual_Shadow_Front-257495.jpg?v=1777841206",
      "score": 60,
      "tier": "standard",
      "certifications": [
        "Kosher",
        "Halal"
      ],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "gold",
        "coq10",
        "alpha",
        "lipoic",
        "acid",
        "acetyl",
        "carnitine",
        "hcl",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic",
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46769427316933",
      "vsf_explanation": "Three ingredients with real mitochondrial evidence: CoQ10 (Mortensen 2014 Q-SYMBIO trial), ALA, and ALCAR (Malaguarnera 2007 for fatigue). Rational stack for cellular energy. Copy references distinct pathways but per-ingredient mg not shown here.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-coq10-200-mg-60-capsules",
      "title": "Nature's Lab CoQ10 200 mg - 60 Capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CoQ10_200MG_60ct_ZNLB15206-L2_Rev002_Virtual_Shadow_Front-529127.jpg?v=1777841212",
      "score": 59,
      "tier": "standard",
      "certifications": [
        "Kosher",
        "Halal"
      ],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "coq10",
        "200",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 17.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170835288261",
      "vsf_explanation": "200mg CoQ10 per capsule sits at the upper end of statin-user replacement RCT range (Q-SYMBIO 300mg/d Mortensen 2014 showed HF mortality benefit). Form (ubiquinone vs. ubiquinol) is not specified — ubiquinol absorption is meaningfully better in older adults, so this omission matters. Good baseline product.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-gold-turmeric-extract-with-curcumin-c3-and-bioperine-60-capsules",
      "title": "Nature's Lab Gold Turmeric Extract with Curcumin C3 and BioPerine - 60 capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Turmeric_Extract_Curcumin_BioPerine_60ct_ZNLB13738-L4_Rev004_Virtual_Shadow_Front-991612.jpg?v=1777841220",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "gold",
        "turmeric",
        "extract",
        "with",
        "curcumin",
        "and",
        "bioperine",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 55,
        "sustainability": 40
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170835386565",
      "vsf_explanation": "Standardized Curcumin C3 Complex (95% curcuminoids) with BioPerine for absorption. Curcumin + piperine RCTs show 2000% bioavailability boost (Shoba et al. 1998) and anti-inflammatory effects. Reasonable single-ingredient design, though dose per serving not shown in excerpt.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-tart-cherry-500-mg-180-capsules",
      "title": "Nature's Lab Tart Cherry 500 mg - 180 Capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Tart_Cherry_180ct_ZNLB16272-L2_Rev002_Virtual_Shadow_Front-324495.jpg?v=1777841225",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "tart",
        "cherry",
        "500",
        "180",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 70,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170835419333",
      "vsf_explanation": "500mg Montmorency tart cherry powder — species-correct choice for the anthocyanin/muscle-recovery evidence (Bell 2014 for cycling recovery, Howatson 2012 for marathon). Powder equivalence to the concentrate doses used in trials is imperfect, but the ingredient identity and dose are honest.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-gold-vital-testosterone-90-capsules",
      "title": "Nature's Lab Gold Vital Testosterone - 90 Capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Vital_Testosterone_ZNLB20691_L-Rev001_Main_Image1-min.png?v=1777841232",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "gold",
        "vital",
        "testosterone",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 68,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 59.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170835517637",
      "vsf_explanation": "Stack of three branded extracts with legitimate small RCTs — LJ100 tongkat ali (Tambi 2012), Furosap 300mg 20% protodioscin fenugreek (Maheshwari 2017), Shoden ashwagandha (Lopresti 2019) — plus zinc bisglycinate. Formulation is credible; the disclosed standardization is uncommon in this category. Ceiling limited by category evidence and no NSF/USP.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-gold-vital-bones-90-capsules",
      "title": "Nature's Lab Gold Vital Bones - 90 Capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Vital_Bones_90ct_ZNLB20608-L_Rev001_Virtual_Shadow_Front_b273f00c-320d-470c-be75-b16ae011b922-247400.jpg?v=1777841256",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "gold",
        "vital",
        "bones",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 55,
        "sustainability": 42
      },
      "price": 17.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170835845317",
      "vsf_explanation": "600mg Aquamin (marine algae calcium) + 100mcg (4000 IU) D3 + K2 + bamboo silica. Aquamin has RCT support for bone turnover markers (Frestedt et al. 2008). Calcium form is well-selected but 600mg total is a supplementary top-off, not a full RDA replacement.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-zinc-picolinate-50mg-100-capsules",
      "title": "Nature's Lab Zinc Picolinate 50mg - 100 Capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Zinc_Picolinate_100ct_ZNLB17958-L1_Rev002_Virtual_Shadow_Front-418678.jpg?v=1777841260",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "zinc",
        "picolinate",
        "50mg",
        "100",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 55,
        "sustainability": 40
      },
      "price": 7.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170835878085",
      "vsf_explanation": "50mg zinc as picolinate exceeds the IOM tolerable upper intake of 40mg for adults; chronic use can suppress copper absorption and impair immunity (Fischer et al. 1984). Picolinate is a bioavailable form, but the dose is too high for daily long-term use and no copper is co-formulated to offset.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-gentle-sleep-aid-60-capsules",
      "title": "Nature's Lab Gentle Sleep Aid - 60 Capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Gentle_Sleep_Aid_60ct_ZNLB17897_L-Rev001_Virtual_Shadow_Front-873463.jpg?v=1777841265",
      "score": 53,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "gentle",
        "sleep",
        "aid",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 40
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170835976389",
      "vsf_explanation": "GABA + L-Theanine + valerian + 6mg melatonin. 6mg melatonin is roughly 10-20x the physiologic sleep-onset dose (0.3-1mg per Zhdanova 2005) and can cause next-day grogginess. Oral GABA has poor blood-brain-barrier penetration. L-theanine + valerian have modest sleep-quality evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-prostate-formula-180-capsules",
      "title": "Nature's Lab Prostate Formula - 180 Capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Prostate_Formula_180ct_ZNLB14421_L-Rev002_Virtual_Shadow_Front-131614.jpg?v=1777841271",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "prostate",
        "formula",
        "180",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 62,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170836009157",
      "vsf_explanation": "Zinc (L-OptiZinc) + selenium at 100% DV + pumpkin seed oil 100mg + lycopene: reasonable prostate support with modest evidence (Chen 2019 meta on lycopene). Notable that saw palmetto is absent — the most-studied prostate botanical (Wilt 1998) is missing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nature-s-lab-super-antioxidant-support-120-capsules",
      "title": "Nature’s Lab Super Antioxidant Support - 120 capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Super_Antioxidant_120ct_ZNLB18177-L_Rev_001_Virtual_Shadow_front-371597.jpg?v=1777841331",
      "score": 53,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "super",
        "antioxidant",
        "support",
        "120",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 55,
        "sustainability": 40
      },
      "price": 17.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170836828357",
      "vsf_explanation": "Berry-polyphenol blend (acai, goji, mangosteen, pomegranate, noni, resveratrol, Vitaberry). Systemic antioxidant benefits from oral fruit polyphenols in humans remain equivocal (Hollman et al. 2011). Reasonable ingredient list but doses per component not visible in excerpt.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-gold-magnesium-ashwagandha-with-l-theanine-60-capsules",
      "title": "Nature's Lab Gold Magnesium + Ashwagandha with L-Theanine - 60 Capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Mag_Ash_LTheanine_60ct_ZNLB20714-L_Rev001_Main_Image1-min.png?v=1777841344",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "cognitive",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "gold",
        "magnesium",
        "ashwagandha",
        "with",
        "theanine",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 68,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 60,
        "sustainability": 42
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170837057733",
      "vsf_explanation": "150mg magnesium glycinate + 60mg Shoden ashwagandha (standardized 35% glycowithanolides) + 200mg L-theanine. Shoden ashwagandha has RCT support for stress and sleep (Langade et al. 2021), and 200mg L-theanine matches the dose used in Kimura et al. 2007 for calm alertness. Best-formulated product in the Nature's Lab line.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-gold-immuneshield-90-capsules",
      "title": "Nature's Lab Gold ImmuneShield - 90 Capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ImmuneShield_ZNLB18078_L_Rev001_Benefits_Image2_Main_Image1.png?v=1777841352",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "gold",
        "immuneshield",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 70,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 62,
        "sustainability": 45
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170837156037",
      "vsf_explanation": "Doses disclosed: 500mg Liposomal PureWay-C, L-OptiZinc 11mg, selenium 55mcg, NAC 500mg, Quercefit 250mg, green tea 250mg, beta-glucan 200mg, elderberry 100mg. Comprehensive, dose-honest immune stack with branded ingredients backed by studies (Quercefit bioavailability, Beta-glucan Talbott 2013).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-gold-urinaguard-90-capsules",
      "title": "Nature's Lab Gold UrinaGuard - 90 Capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/UrinaGuard_ZNLB20677-L2_Rev002_Main_Image1-min.png?v=1777841359",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "gold",
        "urinaguard",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 70,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 65,
        "sustainability": 48
      },
      "price": 28.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170837188805",
      "vsf_explanation": "Cranberex 36mg PACs is the clinically studied threshold (Howell 2010) for UTI prevention; D-mannose 1g and green tea 400mg add complementary mechanisms (Kranjčec 2014 D-mannose 2g/day trial). cGMP double 3rd-party tested USA facility. One of the better UTI formulas in this batch.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-astareal-astaxanthin-6-mg-60-softgels",
      "title": "Nature's Lab AstaREAL Astaxanthin 6 mg - 60 Softgels",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Astaxanthin_60ct_ZNLB17101-L2_Rev003_Virtual_Shadow_Front-793434.jpg?v=1777841366",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "astareal",
        "astaxanthin",
        "softgels",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 68,
        "manufacturing": 55,
        "safety": 70,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 18.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170837287109",
      "vsf_explanation": "6mg natural astaxanthin from Haematococcus pluvialis using the AstaReal branded extract — the exact form and dose used in most human RCTs (Tominaga 2012 skin, Nakagawa 2011 oxidative stress). Branded raw-material sourcing is transparent. Solid mid-tier antioxidant SKU.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-l-theanine-200-mg-60-capsules",
      "title": "Nature's Lab L-Theanine 200 mg - 60 Capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/L_Theanine_60ct_ZNLB14025_L-Rev003_Virtual_Shadow_Front-698733.jpg?v=1777841371",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "cognitive",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "theanine",
        "200",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 75,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170837385413",
      "vsf_explanation": "200mg L-theanine per capsule matches most acute anxiolysis/attention RCTs (Kimura 2007, Higashiyama 2011). Clean single-ingredient product at a fair dose. Would score higher with Suntheanine branding or explicit third-party verification; the form isn't stated.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-perfect-iron-25mg-180-capsules",
      "title": "Nature's Lab Perfect Iron 25mg - 180 Capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Perfect_Iron_180ct_ZNLB17637_L-Rev001_Virtual_Shadow_Front-345079.jpg?v=1777841379",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "perfect",
        "iron",
        "25mg",
        "180",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients",
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 72,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 16.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170837483717",
      "vsf_explanation": "Iron bisglycinate chelate at 25 mg is a preferred low-GI form for repletion (Milman 2014 showed bisglycinate at 25 mg matched ferrous sulfate 50 mg with fewer GI effects). Well-chosen form and reasonable maintenance dose. Approaches Verified but lacks third-party assay disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-dim-300-mg-120-capsules",
      "title": "Nature's Lab DIM 300 mg - 120 Capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/DIM_120ct_ZNLB18139-L_Rev001_Virtual_Shadow_Front-944270.jpg?v=1777841384",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "dim",
        "300",
        "120",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170837516485",
      "vsf_explanation": "300mg DIM plus BioPerine to boost absorption — DIM's evidence for shifting estrogen metabolite ratios is real but the clinical significance is modest (Thomson 2017 pilot). BioPerine addition is the right formulation move given DIM's poor oral bioavailability. Structure/function claims are appropriate, no drug-level claims.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-apple-cider-vinegar-with-chromium-120-capsules",
      "title": "Nature's Lab Apple Cider Vinegar with Chromium - 120 Capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Apple_Cider_Vinegar_120ct_ZNLB20486-L_Rev001_Virtual_Shadow_Front-245003.jpg?v=1777841388",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "apple",
        "cider",
        "vinegar",
        "with",
        "chromium",
        "120",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 40
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170837778629",
      "vsf_explanation": "1200mg ACV powder + 1000mcg chromium picolinate per 2-cap serving. Chromium 1000mcg is 5x the AI of 200mcg — long-term high chromium picolinate has raised safety flags (Stearns et al. 1995 DNA effects in vitro). ACV weight-loss evidence is weak and mostly derived from liquid ACV not encapsulated powder.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-quercetin-bromelain-120-capsules",
      "title": "Nature's Lab Quercetin Bromelain - 120 Capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Quercetin_Bromelain_120ct_ZNLB17682-L_Rev001_Virtual_Shadow_Front-313361.jpg?v=1777841393",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "quercetin",
        "bromelain",
        "120",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 70,
        "transparency": 55,
        "sustainability": 40
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170837811397",
      "vsf_explanation": "Quercetin + bromelain co-formulation is a well-known stack for immune/allergy support; bromelain enhances quercetin absorption. Quercetin doses in RCTs range 500-1000mg (Li et al. 2016). Excerpt does not disclose per-cap dose, limiting transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-iron-plus-vitamin-c-fast-melt-tablets-120-tablets",
      "title": "Nature's Lab Iron Plus Vitamin C Fast Melt Tablets - 120 Tablets",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Iron_Plus_Vitamin_C_120ct_ZNLB17781-L2_Rev002_Virtual_Shadow_front-190377.jpg?v=1777841398",
      "score": 61,
      "tier": "standard",
      "certifications": [
        "Kosher"
      ],
      "goal_tags": [
        "immune",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "iron",
        "plus",
        "vitamin",
        "fast",
        "melt",
        "tablets",
        "120",
        "tablets",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 60,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 16.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170839875781",
      "vsf_explanation": "Carbonyl iron + vitamin C in a dissolvable fast-melt; carbonyl iron is gentler on GI vs. ferrous sulfate (Devasthali 1991) and vitamin C boosts non-heme absorption (Cook 2001). Gluten-free/Kosher certified. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-hyaluronic-acid-with-biocell-collagen®-msm-60-capsules",
      "title": "Nature's Lab Hyaluronic Acid with BioCell Collagen® & MSM - 60 Capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Hyaluronic_Acid_60ct_ZNLB13790-L2_Rev002_Virtual_Shadow_Front-331358.jpg?v=1777841405",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "hyaluronic",
        "acid",
        "with",
        "biocell",
        "collagen",
        "msm",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective",
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170841579717",
      "vsf_explanation": "BioCell Collagen (hydrolyzed type II + HA + chondroitin) has RCT support for joint pain (Schauss 2012) and skin (Schwartz 2012). Adding MSM is redundant with existing OA data (Kim 2006). Solid mid-tier formulation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-gold-mushroom-7-90-capsules",
      "title": "Nature's Lab Gold Mushroom 7 - 90 Capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Mushroom_7_90ct_ZNLB14650-L3_Rev003_Virtual_Shadow_Front_8d2d72b9-b122-4fe4-9226-1995a520bc4b-889985.jpg?v=1777841411",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "gold",
        "mushroom",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 70,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170841776325",
      "vsf_explanation": "7-mushroom blend (Reishi, Agaricus blazei, Maitake, Lion's Mane, Shiitake, Fu Ling, Turkey Tail) grown on organic brown rice — mycelium-on-grain products can be high in starch filler and lower in beta-glucans vs fruiting-body extracts. No beta-glucan % or dual-extraction disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-gold-six-daily-advanced-multivitamin-180-capsules",
      "title": "Nature's Lab Gold Six Daily Advanced Multivitamin - 180 Capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Six_Daily_180ct_ZNLB17194-L3_rev003_Virtual_Shadow_Front_d4fa5df4-aa27-4ad1-8463-49c467d0ee4f-418822.jpg?v=1777841417",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "gold",
        "six",
        "daily",
        "advanced",
        "multivitamin",
        "180",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 55,
        "sustainability": 40
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170842136773",
      "vsf_explanation": "Broad 90+ ingredient multi with 100mg CoQ10, mushroom complex, fermented superfoods, magnesium and antioxidants at 6 caps/day. Ingredient breadth is respectable; forms of individual vitamins (methylated B12/folate?) not confirmed in excerpt, and multivitamin RCT evidence for hard endpoints is mixed (PHS-II Sesso 2012).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-green-tea-extract-500-mg-90-capsules",
      "title": "Nature's Lab Green Tea Extract 500 mg - 90 Capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Green_Tea_Extract_90ct_ZNLB13899-L2-Rev003_Virtual_Shadow_Front-763532.jpg?v=1777841423",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "green",
        "tea",
        "extract",
        "500",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants",
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 55,
        "sustainability": 48
      },
      "price": 13.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170843545797",
      "vsf_explanation": "500mg standardized green tea extract with EGCG. Metabolism effect is modest (Hursel 2011 meta ~1kg over 12 weeks). Note: high-dose EGCG (>800mg/day) has raised hepatotoxicity flags (EFSA 2018), so 500mg per capsule warrants caution if user doubles up.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-dhea-supplement-50-mg-300-capsules",
      "title": "Nature's Lab DHEA Supplement 50 mg - 300 Capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/DHEA_300ct_ZNLB14568-L_Rev003_Virtual_Shadow_Front-201693.jpg?v=1777841776",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "dhea",
        "supplement",
        "300",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 40,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170849804485",
      "vsf_explanation": "50mg DHEA is on the higher end — Baulieu 2000 used 50mg with mixed benefit; typical safe daily is 25mg. DHEA can raise estrogen/androgens and is banned by most sports orgs. Cognitive/mood claims outrun evidence. Legitimate ingredient but safety-flagged dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-enzym-balance-180-capsules",
      "title": "Nature's Lab EnZym Balance - 180 Capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/EnZym_Balance_180ct_ZNLB14414-L2-Rev002_Virtual_Shadow_Front-322906.jpg?v=1777841782",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "enzym",
        "balance",
        "180",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170849935557",
      "vsf_explanation": "Herbal-enzyme digestive blend with 100mg each of aloe leaf, ginger, turmeric and 100mg enzyme blend. Doses are sub-therapeutic vs. typical digestive-enzyme dosing (e.g., 400+ mg pancreatin). Turmeric 100mg is far below RCT levels (>500mg curcumin).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-hyaluronic-acid-with-biocell-collagen®-optimsm®-120-capsules",
      "title": "Nature's Lab Hyaluronic Acid with BioCell Collagen® & OptiMSM® - 120 Capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Hyaluronic_Acid_120ct_ZNLB13660_L2_Rev005_Virtual_Shadow_Front-606792.jpg?v=1777841863",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "hyaluronic",
        "acid",
        "with",
        "biocell",
        "collagen",
        "optimsm",
        "120",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective",
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 66,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170850525381",
      "vsf_explanation": "Same BioCell Collagen + HA + chondroitin base as the 60-cap, but upgraded to branded OptiMSM (Bergstrom pharmaceutical-grade). Slightly better manufacturing pedigree; RCT support from Schauss 2012 for joint pain.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-lab-gold-turmeric-extract-with-curcumin-c3-complex-and-bioperine-120-capsules",
      "title": "Nature's Lab Gold Turmeric Extract with Curcumin C3 Complex and BioPerine  - 120 Capsules",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Tumeric_Extract_ZNLB14261_L3-Rev003_Benefits_Main-Image1-min.jpg?v=1777841868",
      "score": 64,
      "tier": "standard",
      "certifications": [
        "Non-GMO Project Verified",
        "Kosher",
        "Halal"
      ],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "lab",
        "gold",
        "turmeric",
        "extract",
        "with",
        "curcumin",
        "complex",
        "and",
        "bioperine",
        "120",
        "capsules",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 70,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170850656453",
      "vsf_explanation": "Curcumin C3 Complex is the most-studied standardized curcuminoid (95% curcuminoids) with dozens of RCTs across inflammation, joint pain (Kuptniratsaikul 2014 for knee OA), and mood. Paired with BioPerine, which boosts curcumin bioavailability up to 20x (Shoba 1998). Textbook formulation — held below Verified by no NSF/USP and unlisted dose per capsule.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "stonehenge-health-dynamic-brain-supplement-new-formula-with-bacomind-for-memory-acquisition-retention-recall-with-40-unique-nootropic-choline-phosphatidylserine-and-huperzine-a",
      "title": "Stonehenge Health Dynamic Brain Supplement – New Formula with BacoMind for Memory Acquisition, Retention, & Recall with 40 Unique Nootropic: Choline, Phosphatidylserine, and Huperzine A",
      "vendor": "Lululiner",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71eROdzdUVL._AC_SL1500_de3b54cb-0d7c-442c-b321-c1144431652b.jpg?v=1777841904",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "stonehenge",
        "health",
        "dynamic",
        "brain",
        "supplement",
        "new",
        "formula",
        "with",
        "bacomind",
        "for",
        "memory",
        "acquisition",
        "retention",
        "recall",
        "with",
        "unique",
        "nootropic",
        "choline",
        "phosphatidylserine",
        "and",
        "huperzine",
        "lululiner"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 58,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170851082437",
      "vsf_explanation": "Includes BacoMind (branded, clinically-studied Bacopa monnieri extract — Morgan 2010 RCT showed memory improvement at 300 mg/day), plus phosphatidylserine, huperzine A, choline. cGMP US manufacture, 3rd-party tested. Per-ingredient mg not shown in this description; sold via 3rd-party reseller. Upper-Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nordic-naturals-ultimate-omega-2x-high-potency-fish-oil-2150-mg-epa-dha-lemon-flavor-120-softgels",
      "title": "Nordic Naturals Ultimate Omega 2X – High-Potency Fish Oil | 2150 mg EPA & DHA | Lemon Flavor, 120 Softgels",
      "vendor": "Nordic Naturals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/61SHf0A_ENL_4d21bcb4-59f3-48c0-9250-1388277754a8.jpg?v=1777841922",
      "score": 87,
      "tier": "elite",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nordic",
        "naturals",
        "ultimate",
        "omega",
        "high",
        "potency",
        "fish",
        "oil",
        "2150",
        "epa",
        "dha",
        "lemon",
        "flavor",
        "120",
        "softgels",
        "nordic",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 88,
        "formulation": 90,
        "manufacturing": 90,
        "safety": 88,
        "transparency": 88,
        "sustainability": 78
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170851410117",
      "vsf_explanation": "2150mg EPA+DHA in triglyceride form (superior absorption vs. ethyl ester per Dyerberg 2010). Nordic Naturals is IFOS/Friend of the Sea certified with published COAs. REDUCE-IT trial (Bhatt 2019) validates high-dose omega-3 CV benefit. Sold by 3rd-party reseller Lululiner but product identity is Nordic Naturals — anchor Elite.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "purehealth-research-lymph-system-support-supplement-lymphatic-drainage-supplement-with-dandelion-extract-cleavers-burdock-powder-reduce-swelling-and-cleanse-lymph-1-bottle-brown-1",
      "title": "PUREHEALTH RESEARCH Lymph System Support Supplement - Lymphatic Drainage Supplement with Dandelion Extract, Cleavers, Burdock Powder - Reduce Swelling and Cleanse Lymph - 1 Bottle, Brown",
      "vendor": "Lululiner",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71lgDJIT1oL.jpg?v=1777841933",
      "score": 50,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "purehealth",
        "research",
        "lymph",
        "system",
        "support",
        "supplement",
        "lymphatic",
        "drainage",
        "supplement",
        "with",
        "dandelion",
        "extract",
        "cleavers",
        "burdock",
        "powder",
        "reduce",
        "swelling",
        "and",
        "cleanse",
        "lymph",
        "bottle",
        "brown",
        "lululiner"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170851508421",
      "vsf_explanation": "8-herb 'lymphatic drainage' blend (dandelion, cleavers, burdock, echinacea, rutin, bromelain, etc.). 'Lymph cleanse' framing lacks credible RCT support, and per-herb doses aren't given. GMP US-made. Sold via reseller. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "neurohacker-collective-qualia-mind-doctor-formulated-nootropic-to-fuel-focus-concentration-1",
      "title": "NEUROHACKER COLLECTIVE Qualia Mind | Doctor-Formulated Nootropic to Fuel Focus & Concentration",
      "vendor": "Lululiner",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71RgN-XDO7L.jpg?v=1777841954",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "neurohacker",
        "collective",
        "qualia",
        "mind",
        "doctor",
        "formulated",
        "nootropic",
        "fuel",
        "focus",
        "concentration",
        "lululiner"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 65,
        "safety": 55,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 79.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170851803333",
      "vsf_explanation": "Qualia Mind (Neurohacker Collective) is a 28-ingredient nootropic stack with disclosed doses on the manufacturer label — good for transparency, but a 'kitchen sink' composition with sub-clinical doses of individual actives (e.g., Bacopa 300 mg, huperzine 50 mcg). Safety concern from combined stimulants (caffeine + theobromine + N-acetyl-tyrosine). Sold here through a third-party reseller, which weakens provenance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "onnit-alpha-brain-nootropic-brain-supplement-for-men-women-memory-mental-clarity-cognitive-improvement-focus-capsules-with-l-theanine-vitamin-b6-phosphatidylserine-90-count",
      "title": "ONNIT Alpha Brain Nootropic Brain Supplement for Men & Women | Memory, Mental Clarity & Cognitive Improvement | Focus Capsules with L-Theanine, Vitamin B6 & Phosphatidylserine (90 Count)",
      "vendor": "Lululiner",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/81RY2G78HBL_9b890caa-85b8-4cb2-923a-6c195984213d.jpg?v=1777841967",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "cognitive",
        "mood"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "onnit",
        "alpha",
        "brain",
        "nootropic",
        "brain",
        "supplement",
        "for",
        "men",
        "women",
        "memory",
        "mental",
        "clarity",
        "cognitive",
        "improvement",
        "focus",
        "capsules",
        "with",
        "theanine",
        "vitamin",
        "phosphatidylserine",
        "count",
        "lululiner"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 59.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170852032709",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 58 → new 70. Evidence found: Solomon TM et al. A randomized, double-blind, placebo controlled, parallel group, efficacy study of alpha BRAIN administered orally. Hum Psychopharmacol Clin Exp. 2016;31(2):135-143. | Bonaventura J et al. Onnit Alpha BRAIN safety and cognitive effects follow-up (industry-sponsored replication).. Rationale: The Solomon 2016 RCT (N=63, 6 weeks) tested the exact commercial Alpha BRAIN formula and found significant improvements in verbal memory and executive function vs placebo. Uplift to 70 reflects the +12 boost for having a brand-specific product RCT while retaining a discount for proprietary blend opacity (individual doses within Focus/Fuel/Flow blends not disclosed). This SKU has no autofail flag, so uplift applies cleanly.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "upwellness-ultra-liver-support-tmg-nac-milk-thistle-formula-for-liver-and-gallbladder-health-60-capsules",
      "title": "UpWellness Ultra Liver Support – TMG, NAC & Milk Thistle Formula for Liver and Gallbladder Health (60 Capsules)",
      "vendor": "Lululiner",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitled_design_2_2a4239b8-01e8-4057-8dd9-34ea3491d20a.jpg?v=1777844042",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "upwellness",
        "ultra",
        "liver",
        "support",
        "tmg",
        "nac",
        "milk",
        "thistle",
        "formula",
        "for",
        "liver",
        "and",
        "gallbladder",
        "health",
        "capsules",
        "lululiner"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive",
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170873725125",
      "vsf_explanation": "TMG, NAC, and milk thistle (silymarin) each have moderate evidence at specific doses (NAC 600-1800 mg/day, silymarin 420 mg/day per Salmi 1982), but this listing exposes no per-ingredient mg. Third-party seller further clouds provenance.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "now-available-evergreen-liquid-chlorophyll-herbal-beverage-by-sunrider",
      "title": "NOW AVAILABLE Evergreen | Liquid Chlorophyll Herbal Beverage by Sunrider",
      "vendor": "NOW",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/now-available-evergreen-liquid-chlorophyll-herbal-beverage-by-sunrider-41337277546753.webp?v=1777844187",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "available",
        "evergreen",
        "liquid",
        "chlorophyll",
        "herbal",
        "beverage",
        "sunrider",
        "now"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 50,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 54.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170874970309",
      "vsf_explanation": "Sunrider Evergreen is copper chlorophyllin + peppermint oil + zinc + iron. Chlorophyllin has limited human evidence beyond mild internal deodorant use (Nahata 1983). Actual mg of copper chlorophyllin, zinc, and iron per bottle are not disclosed on this listing.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "now-available-ese-sleep-relaxation-herbal-food-supplement-by-sunrider",
      "title": "NOW AVAILABLE Ese | Sleep, Relaxation Herbal Food Supplement by Sunrider",
      "vendor": "NOW",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/single-bottle-now-available-ese-sleep-relaxation-herbal-food-supplement-by-sunrider-586963494.png?v=1777844188",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "available",
        "ese",
        "sleep",
        "relaxation",
        "herbal",
        "food",
        "supplement",
        "sunrider",
        "now"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 42,
        "manufacturing": 48,
        "safety": 50,
        "transparency": 42,
        "sustainability": 45
      },
      "price": 87.34,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170875003077",
      "vsf_explanation": "5-herb Sunrider sleep formula (gou teng/uncaria, ji tsau, valerian, Japanese sophora, peucedanum). Valerian sleep RCTs (Bent 2006 meta) show modest, inconsistent effects at 400-900 mg. Multi-herb capsule format hides individual doses; anxiety/insomnia claims stray into disease territory.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "now-available-chinese-goldenseal-root-natural-herbal-food-supplement-by-sunrider",
      "title": "NOW AVAILABLE Chinese Goldenseal Root | Natural Herbal Food Supplement by Sunrider",
      "vendor": "NOW",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/chinese-goldenseal-root-natural-herbal-food-supplement-by-sunrider-28606366023874.jpg?v=1777844188",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "available",
        "chinese",
        "goldenseal",
        "root",
        "natural",
        "herbal",
        "food",
        "supplement",
        "sunrider",
        "now"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 40,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 59.76,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170875068613",
      "vsf_explanation": "Coptis chinensis (Chinese goldenseal). Contains berberine and coptisine. Product page claims it 'contains antibiotic, anti-inflammatory' properties and 'has been used to help reduce fevers' — direct disease-treatment language. Single-herb capsule, no dose disclosed.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "now-available-dandelion-root-natural-herbal-food-supplement-by-sunrider",
      "title": "NOW AVAILABLE Dandelion Root | Natural Herbal Food Supplement by Sunrider",
      "vendor": "NOW",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/now-available-dandelion-root-natural-herbal-food-supplement-by-sunrider-40571935817985.jpg?v=1777844188",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "available",
        "dandelion",
        "root",
        "natural",
        "herbal",
        "food",
        "supplement",
        "sunrider",
        "now"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 42.2,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170875101381",
      "vsf_explanation": "Single-herb dandelion root capsule. Traditional digestive/diuretic use, some in-vitro data, minimal human RCT evidence. Product body does not disclose extract vs whole-root, standardization, or mg per capsule. Safe but sub-therapeutic dose likely.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "now-available-herb-cal-tab-chewable-calcium-by-sunrider",
      "title": "NOW AVAILABLE Herb Cal Tab | Chewable Calcium by Sunrider",
      "vendor": "NOW",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/out-of-stock-pre-order-herb-cal-tab-chewable-coral-calcium-by-sunrider-7193624150105.png?v=1777844188",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "available",
        "herb",
        "cal",
        "tab",
        "chewable",
        "calcium",
        "sunrider",
        "now"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 26.64,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170875134149",
      "vsf_explanation": "Chewable delivering 250 mg calcium from carbonate/citrate/gluconate blend + vitamin D2 and herbal extracts. Dose is disclosed and the multi-salt approach is reasonable, but vitamin D2 is less bioavailable than D3 (Tripkovic 2012 meta-analysis) and there is no K2 co-factor. Fossilized ocean source is a plus vs oyster-shell lead risk.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "now-available-assimilaid-natural-herbal-food-supplement-by-sunrider",
      "title": "NOW AVAILABLE Assimilaid Natural Herbal Food Supplement by Sunrider",
      "vendor": "NOW",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/out-of-stock-pre-order-assimilaid-natural-herbal-food-supplement-by-sunrider-7153845796953.png?v=1777844188",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "available",
        "assimilaid",
        "natural",
        "herbal",
        "food",
        "supplement",
        "sunrider",
        "now"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 25,
        "sustainability": 50
      },
      "price": 52.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170875166917",
      "vsf_explanation": "Sunrider Assimilaid digestive herbal blend with Panax ginseng, atractylodes, pinella, fennel, and orange peel described explicitly as a 'proprietary blend of concentrated herbs.' MLM/network-marketed product; no per-herb doses disclosed. Traditional TCM use ≠ clinical efficacy.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "now-available-dong-quai-traditonal-tonic-for-women-by-sunrider",
      "title": "NOW AVAILABLE Dong Quai Traditonal Tonic for Women | by Sunrider",
      "vendor": "NOW",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/now-available-dong-quai-traditonal-tonic-for-women-by-sunrider-40571936309505.jpg?v=1777844188",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "now",
        "available",
        "dong",
        "quai",
        "traditonal",
        "tonic",
        "for",
        "women",
        "sunrider",
        "now"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 40,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 59.32,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170875199685",
      "vsf_explanation": "Angelica sinensis (dong quai) marketed to 'decrease the symptoms and severity of hot flashes' and 'alleviate PMS.' The only rigorous RCT (Hirata 1997, 12-week n=71) found no benefit over placebo for menopausal symptoms. Also has coumarin/warfarin interaction risk not flagged on the page.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "quinary-total-body-balancing-by-sunrider",
      "title": "Quinary - Total Body Balancing | by Sunrider",
      "vendor": "Herb's Fortune",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/out-of-stock-pre-order-100-capsules-out-of-stock-pre-order-quinary-total-body-balancing-by-sunrider-13581744439385.jpg?v=1777844188",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "quinary",
        "total",
        "body",
        "balancing",
        "sunrider",
        "herb",
        "fortune"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 55.13,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170875232453",
      "vsf_explanation": "Combines five other Sunrider proprietary blends (Alpha 20C, Assimilaid, Conco, Lifestream, Prime Again) into one 'five-system balancer' with no individual herb doses shown anywhere. The 'balance the body's systems' framing is not supported by peer-reviewed trials.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "now-available-fibertone-digestive-herbal-food-supplement-by-sunrider",
      "title": "NOW AVAILABLE Fibertone | Digestive Herbal Food Supplement by Sunrider",
      "vendor": "NOW",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fibertone-digestive-herbal-food-supplement-by-sunrider-953549203.jpg?v=1777844188",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "available",
        "fibertone",
        "digestive",
        "herbal",
        "food",
        "supplement",
        "sunrider",
        "now"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 40,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 29.31,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170875461829",
      "vsf_explanation": "Sunrider Fibertone is a 'proprietary blend' of oat bran + psyllium seed + tora seed (Cassia obtusifolia). Psyllium has strong constipation evidence (McRorie 2015) but tora seed is a stimulant laxative with warnings noted on the product page itself (do not use with diarrhea/loose stools/abdominal pain).",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "now-available-ci-wu-jia-eleuthero-adaptogenic-herbal-food-supplement-by-sunrider",
      "title": "NOW AVAILABLE Ci Wu Jia (Eleuthero) | Adaptogenic Herbal Food Supplement by Sunrider",
      "vendor": "NOW",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ci-wu-jia-eleuthero-adaptogenic-herbal-food-supplement-by-sunrider-1032606223.jpg?v=1777844188",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "available",
        "jia",
        "eleuthero",
        "adaptogenic",
        "herbal",
        "food",
        "supplement",
        "sunrider",
        "now"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 48,
        "safety": 55,
        "transparency": 45,
        "sustainability": 48
      },
      "price": 46.77,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170875527365",
      "vsf_explanation": "Single-ingredient Eleutherococcus senticosus (Siberian ginseng). Kuo 2010 RCT (800 mg eleuthero) showed modest fatigue improvement; Panossian 2010 review supports adaptogen category. Standardization (eleutheroside E %) and per-cap mg not disclosed. Sunrider has long manufacturing history but no third-party testing callouts.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "korean-white-ginseng-panax-ginseng-adaptogen-by-sunrider",
      "title": "Korean White Ginseng (Panax Ginseng) Adaptogen | by Sunrider",
      "vendor": "Herb's Fortune",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/korean-white-ginseng-panax-ginseng-adaptogen-by-sunrider-1259625471.jpg?v=1777844188",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "korean",
        "white",
        "ginseng",
        "panax",
        "ginseng",
        "adaptogen",
        "sunrider",
        "herb",
        "fortune"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics",
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 55,
        "sustainability": 40
      },
      "price": 80.66,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170875494597",
      "vsf_explanation": "Single-ingredient Panax ginseng at 525 mg per capsule, not standardized to ginsenoside content. Panax ginseng shows modest cognitive and fatigue benefits (Reay Hum Psychopharmacol 2010 with G115 extract) but this product lacks extract standardization. No third-party testing or GMP language disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "now-available-energy-plus-antioxidant-supplement-by-sunrider",
      "title": "NOW AVAILABLE Energy Plus | Antioxidant Supplement by Sunrider",
      "vendor": "NOW",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/now-available-energy-plus-antioxidant-supplement-by-sunrider-41193202909441.webp?v=1777844192",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "available",
        "energy",
        "plus",
        "antioxidant",
        "supplement",
        "sunrider",
        "now"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 32,
        "manufacturing": 45,
        "safety": 48,
        "transparency": 30,
        "sustainability": 42
      },
      "price": 65.53,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170875625669",
      "vsf_explanation": "Vitamin E softgel with explicit \"proprietary blend of herbs\" (Korean white ginseng, bee pollen, wheat germ oil, iron 4% DV). Proprietary blend hides all herb doses. Vitamin E supplementation showed no CVD benefit in large trials (HOPE 2000, Physicians' Health Study II 2008) and may increase hemorrhagic stroke.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "quinary-powder-total-body-balancing-by-sunrider",
      "title": "Quinary Powder | Total Body Balancing by Sunrider",
      "vendor": "Herb's Fortune",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/bulk-container-60-servings-300g-now-available-quinary-powder-total-body-balancing-by-sunrider-40699424178433.jpg?v=1777844196",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "quinary",
        "powder",
        "total",
        "body",
        "balancing",
        "sunrider",
        "herb",
        "fortune"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 55.13,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170875658437",
      "vsf_explanation": "Powder form of the same Quinary five-system proprietary stack. Same lack of per-herb dose transparency and same absence of clinical trials on the specific formula.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "now-available-citric-c-tab-chewable-vitamin-c-rose-hips-by-sunrider",
      "title": "NOW AVAILABLE Citric C Tab | Chewable Vitamin C + Rose Hips by Sunrider",
      "vendor": "NOW",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/citric-c-tab-chewable-vitamin-c-rose-hips-by-sunrider-29570304934082.png?v=1777844197",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "available",
        "citric",
        "tab",
        "chewable",
        "vitamin",
        "rose",
        "hips",
        "sunrider",
        "now"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 26.64,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170875822277",
      "vsf_explanation": "Chewable vitamin C 125 mg with rose hips and green tea extracts. Dose is disclosed. Vitamin C for immune support is well established (Hemilä 2013 Cochrane review). Herbal side of the tab uses a 'proprietary blend' framing but the core vitamin C dose is transparent, so this stays in Standard rather than being auto-failed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "urolithin-a-supplement-2800-mg-liquid-drops-with-trans-resveratrol-collagen-peptides-pomegranate-extract-hyaluronic-acid-vitamin-e-c",
      "title": "Urolithin A Supplement 2800 mg Liquid Drops | with Trans-Resveratrol, Collagen Peptides, Pomegranate Extract, Hyaluronic Acid, Vitamin E & C",
      "vendor": "FreshDrinkUS - Natural and Premium Herbal Tea",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_40a0c264-fc97-4ced-af4e-f6a44d75b24d.jpg?v=1777845033",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint",
        "longevity",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "urolithin",
        "supplement",
        "2800",
        "liquid",
        "drops",
        "with",
        "trans",
        "resveratrol",
        "collagen",
        "peptides",
        "pomegranate",
        "extract",
        "hyaluronic",
        "acid",
        "vitamin",
        "freshdrinkus",
        "natural",
        "and",
        "premium",
        "herbal",
        "tea"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170881196229",
      "vsf_explanation": "Liquid Urolithin A blend claiming 2800mg total with resveratrol, collagen, pomegranate extract, HA, and vitamins E/C. Urolithin A mitophagy evidence exists (Andreux 2019 Mitopure trial at 500mg), but Amazenous/no-body listing suggests the 2800mg is a total blend weight, not Urolithin A dose. No per-ingredient breakdown.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "berberine-hcl-supplement-60-capsules",
      "title": "Berberine HCL Supplement - 60 Capsules",
      "vendor": "4Well",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2_1_V1_UPD_Barberine_MAN_Sleep_and_Relaxation_2.jpg?v=1777846137",
      "score": 52,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "berberine",
        "hcl",
        "supplement",
        "capsules",
        "4well"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 25.58,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170902429893",
      "vsf_explanation": "Berberine + ACV + green tea extract — berberine has meaningful glucose/lipid RCT evidence at 500 mg 2-3x/day (Yin 2008; Dong 2013), but 4Well provides no mg per capsule for any active. cGMP US, 3rd-party purity claim. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "resveratrol-supplement-1800mg-complex-180-capsules",
      "title": "Resveratrol Supplement 1800mg Complex - 180 Capsules",
      "vendor": "4Well",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/B0DP596CGK_0.jpg?v=1777846137",
      "score": 51,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "longevity",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "resveratrol",
        "supplement",
        "1800mg",
        "complex",
        "180",
        "capsules",
        "4well"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 36.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170902462661",
      "vsf_explanation": "1,800 mg resveratrol 'complex' with quercetin, CoQ10, vitamin E, C — but 'complex' means actual trans-resveratrol content is unclear, and oral resveratrol has poor bioavailability (Walle 2004). High-dose resveratrol claims typically overstate the human evidence. Standard, borderline.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nad-plus-supplement-1400mg-with-nicotinamide-riboside-collagen-180-capsules",
      "title": "NAD Plus Supplement 1400mg with Nicotinamide Riboside, Collagen - 180 Capsules",
      "vendor": "4Well",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/B0DP59QDY8_0.jpg?v=1777846137",
      "score": 45,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "skin",
        "joint",
        "longevity",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nad",
        "plus",
        "supplement",
        "1400mg",
        "with",
        "nicotinamide",
        "riboside",
        "collagen",
        "180",
        "capsules",
        "4well"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 46.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170902495429",
      "vsf_explanation": "Marketed as 1400 mg blend combining NAD+, nicotinamide riboside and collagen, but the individual NR dose is not disclosed — a critical omission since NR clinical trials (Martens Nat Commun 2018) used 500-1000 mg standalone. Oral NAD+ itself is poorly absorbed. Amazon-tier 4Well vendor with no third-party testing.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "nad-plus-supplement-1400mg-with-nicotinamide-riboside-collagen-60-capsules",
      "title": "NAD Plus Supplement 1400mg with Nicotinamide Riboside, Collagen - 60 Capsules",
      "vendor": "4Well",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_4well_NAD__2025_1080_copy.jpg?v=1777846142",
      "score": 45,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "skin",
        "joint",
        "longevity",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nad",
        "plus",
        "supplement",
        "1400mg",
        "with",
        "nicotinamide",
        "riboside",
        "collagen",
        "capsules",
        "4well"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 29.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170902593733",
      "vsf_explanation": "Same 1400 mg NAD+/NR/collagen blend as the 180-count SKU with no individual doses disclosed. NR trials (Martens Nat Commun 2018) used 500-1000 mg standalone; no way to verify therapeutic dosing here. Amazon-tier 4Well vendor with no third-party testing.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "improved-complex-saw-palmetto-for-men-900-mg",
      "title": "Improved Complex Saw Palmetto for Men 900 mg",
      "vendor": "4Well",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/B0DNKJ1GHX_0.jpg?v=1777846143",
      "score": 50,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "improved",
        "complex",
        "saw",
        "palmetto",
        "for",
        "men",
        "900",
        "4well"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 45,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 19.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170902626501",
      "vsf_explanation": "900 mg saw palmetto (RCT-effective doses are 320 mg standardized extract — the 900 mg here may be crude powder, not extract, based on the wording). Includes DHEA (a hormone that requires medical oversight — regulated as OTC in the US but not appropriate for casual use) and ashwagandha. DHEA raises safety flag. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "improved-complex-saw-palmetto-for-women-900-mg",
      "title": "Improved Complex Saw Palmetto for Women 900 mg",
      "vendor": "4Well",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/B0DMP92Y3K_0.jpg?v=1777846143",
      "score": 41,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "improved",
        "complex",
        "saw",
        "palmetto",
        "for",
        "women",
        "900",
        "4well"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health",
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 42,
        "manufacturing": 45,
        "safety": 40,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 19.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170902560965",
      "vsf_explanation": "900 mg blend of saw palmetto + DHEA + collagen with no individual doses disclosed. DHEA is a precursor steroid hormone that requires transparent dosing and warnings for women (androgenic side-effects, drug interactions) — none provided. Saw palmetto's DHT-blocking evidence is limited to BPH in men (Tacklind Cochrane 2012 — no clear benefit), and there are no clinical data supporting it for female pattern hair loss.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "womens-vaginal-health-probiotics",
      "title": "Women's Vaginal Health Probiotics",
      "vendor": "Simpleme.health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MainImage_aee0d1ad-040f-4148-961d-3f34f78809ec.jpg?v=1777846172",
      "score": 55,
      "tier": "standard",
      "certifications": [
        "Kosher"
      ],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "women",
        "vaginal",
        "health",
        "probiotics",
        "simpleme",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health",
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170902855877",
      "vsf_explanation": "6B CFU multi-strain (L. rhamnosus, L. reuteri, L. acidophilus, L. fermentum) + 100mg cranberry. Reid & Bruce 2006 RCTs support L. rhamnosus GR-1 + L. reuteri RC-14 for vaginal flora — but specific strain identifiers aren't disclosed here, so it's plausible but unverifiable.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "10-in-1-daily-power-blend",
      "title": "10 in 1 Daily Power Blend",
      "vendor": "Simpleme.health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Power_Blend_Image_154b66c3-0c0f-4569-bdaa-885f2fe425f9.png?v=1777846172",
      "score": 45,
      "tier": "rejected",
      "certifications": [
        "Kosher"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "daily",
        "power",
        "blend",
        "simpleme",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants",
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170902888645",
      "vsf_explanation": "Ten-superfood blend (sea moss, bladderwrack, burdock, black seed, ashwagandha, turmeric, ACV, dandelion, manuka, maca) with no individual milligrams. Bladderwrack in particular carries iodine load concerns without a disclosed dose. Amazon-tier vendor with kitchen-sink formulation typical of low-quality DTC brands.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "colon-cleanser",
      "title": "Colon Cleanser",
      "vendor": "Simpleme.health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Colon_2.png?v=1777846178",
      "score": 48,
      "tier": "rejected",
      "certifications": [
        "Kosher"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "colon",
        "cleanser",
        "simpleme",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 40,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 12.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170902921413",
      "vsf_explanation": "Contains cascara sagrada and senna leaf — stimulant laxatives that FDA no longer considers GRAS for OTC cleansing use, with potential for dependency and electrolyte disturbance with routine use. No doses disclosed. Safety concern is the primary reject driver.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "daily-armor-immune-support-supplement",
      "title": "DAILY ARMOR Immune Support Supplement",
      "vendor": "THIS LITTLE HOUSE OF MINE ONLINE STORE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Daily_Armor_Immune_Support.svg?v=1777846222",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "daily",
        "armor",
        "immune",
        "support",
        "supplement",
        "this",
        "little",
        "house",
        "mine",
        "online",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 42,
        "manufacturing": 42,
        "safety": 60,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 15.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170903740613",
      "vsf_explanation": "10-ingredient immune stack (Vit C, E, B6, elderberry, echinacea, zinc, etc.) with no doses disclosed. No manufacturer/facility info. Generic marketing lacks the specificity a credible immune formula requires.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "lions-mane-mushroom-supplement-reishi-extract-shiitake-extract-mushrooms-a-perfect-proprietary-blend",
      "title": "Lion's Mane Mushroom Supplement + Reishi Extract, Shiitake Extract Mushrooms, A Perfect Proprietary Blend",
      "vendor": "THIS LITTLE HOUSE OF MINE ONLINE STORE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Lions_Mane_Reishi_Shiitake_Cordyceps_40d0d294-7aa1-4b72-923e-956328a4c8b7.svg?v=1777846222",
      "score": 30,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lion",
        "mane",
        "mushroom",
        "supplement",
        "reishi",
        "extract",
        "shiitake",
        "extract",
        "mushrooms",
        "perfect",
        "proprietary",
        "blend",
        "this",
        "little",
        "house",
        "mine",
        "online",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 25,
        "manufacturing": 30,
        "safety": 55,
        "transparency": 15,
        "sustainability": 30
      },
      "price": 19.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170903806149",
      "vsf_explanation": "Title literally advertises a proprietary blend of 10+ mushrooms; per-species doses are not disclosed and no beta-glucan quantification or extract method is shown. Anonymous marketplace vendor with no verifiable brand identity or COAs.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "b-12-vitamin-complex",
      "title": "B-12 Vitamin Complex",
      "vendor": "THIS LITTLE HOUSE OF MINE ONLINE STORE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/B-12_Complex_Supplement.svg?v=1777846222",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "complex",
        "this",
        "little",
        "house",
        "mine",
        "online",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 18.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170903773381",
      "vsf_explanation": "B-complex delivering 2000 mcg B12 and 1000 mcg biotin plus 6 essential B vitamins — reasonable maintenance doses (B12 form unspecified — methyl vs. cyano matters). No manufacturer/GMP/third-party info. Small no-name brand. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ashwagandha-herbal-supplement",
      "title": "Ashwagandha Herbal Supplement",
      "vendor": "THIS LITTLE HOUSE OF MINE ONLINE STORE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Ashwagandha_Supplement.svg?v=1777846222",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ashwagandha",
        "herbal",
        "supplement",
        "this",
        "little",
        "house",
        "mine",
        "online",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 35,
        "safety": 50,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 14.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170903838917",
      "vsf_explanation": "Generic ashwagandha with no extract standardization (KSM-66? Sensoril? root vs. leaf?), no dose per capsule, no manufacturer named. KSM-66 300-600 mg has RCT support for cortisol/stress (Chandrasekhar 2012, Lopresti 2019) but you cannot claim that support without disclosing which extract. Capped by provenance auto-fail.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "milk-thistle-liver-repair-support-fortified-with-dandelion-beet-root-artichoke",
      "title": "Milk Thistle Liver Repair Support, Fortified With Dandelion, Beet Root, Artichoke",
      "vendor": "THIS LITTLE HOUSE OF MINE ONLINE STORE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Milk_Thistle_Liver_Repair_Supplement_7dc51a14-2f88-4179-a6c6-065b3c42417c.svg?v=1777846223",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "milk",
        "thistle",
        "liver",
        "repair",
        "support",
        "fortified",
        "with",
        "dandelion",
        "beet",
        "root",
        "artichoke",
        "this",
        "little",
        "house",
        "mine",
        "online",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 30,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170903969989",
      "vsf_explanation": "Milk thistle only at 200mg (silymarin studies typically use 420-600mg standardized to 80% silymarin — this dose is likely sub-therapeutic and the standardization is not stated). Zinc is delivered as zinc oxide (poor bioavailability). Remaining herbs are in a 512mg 'proprietary blend'. Small unverifiable brand.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "moringa-capsules-pure-moringa-powder-energy-skin-immune-gut-health-superfood-rich-in-antioxidants-essential-vitamins-amino-acids-natural-green-superfood-supplement-60-count",
      "title": "Moringa Capsules - Pure Moringa Powder, Energy, Skin, Immune & Gut Health Superfood, Rich in Antioxidants, Essential Vitamins & Amino Acids, Natural Green Superfood Supplement - 60 Count",
      "vendor": "THIS LITTLE HOUSE OF MINE ONLINE STORE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Moringa.png?v=1777846223",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "gut",
        "energy",
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "moringa",
        "capsules",
        "pure",
        "moringa",
        "powder",
        "energy",
        "skin",
        "immune",
        "gut",
        "health",
        "superfood",
        "rich",
        "antioxidants",
        "essential",
        "vitamins",
        "amino",
        "acids",
        "natural",
        "green",
        "superfood",
        "supplement",
        "count",
        "this",
        "little",
        "house",
        "mine",
        "online",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 35,
        "safety": 60,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 22.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170903904453",
      "vsf_explanation": "Single-ingredient moringa leaf extract at 800mg. Human RCTs for moringa are small and heterogeneous; no standardization or extract ratio disclosed. Anonymous online-store vendor with no COA, no third-party testing and broad marketing claims spanning energy, skin, immunity and gut.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "rest-melatonin-sweet-sleep-formula",
      "title": "REST Melatonin Sweet Sleep Formula",
      "vendor": "THIS LITTLE HOUSE OF MINE ONLINE STORE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Rest_Melatonin_Magnesium_L-Theanine_Supplement.svg?v=1777846222",
      "score": 27,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "rest",
        "melatonin",
        "sweet",
        "sleep",
        "formula",
        "this",
        "little",
        "house",
        "mine",
        "online",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 20,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 15,
        "sustainability": 30
      },
      "price": 14.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170903871685",
      "vsf_explanation": "Explicit 'Sleep Formula Proprietary Blend 905mg' hides the doses of L-tryptophan, lycium and multiple herbs. Melatonin at 10mg is roughly 10-30x the physiologic sleep-onset dose (Zhdanova 2005), driving next-day grogginess and receptor desensitization risk.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "quercetin-plus-supplement-60-capsules",
      "title": "Quercetin Plus Supplement - 60 Capsules",
      "vendor": "THIS LITTLE HOUSE OF MINE ONLINE STORE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/quercetin_Zinc_Bromelain_Supplement.svg?v=1777846222",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "quercetin",
        "plus",
        "supplement",
        "capsules",
        "this",
        "little",
        "house",
        "mine",
        "online",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 22.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170904002757",
      "vsf_explanation": "800mg quercetin + 200mg bromelain — quercetin at this dose has RCT support (Serban 2016 meta-analysis: modest BP reduction at 500mg+). Bromelain aids quercetin absorption. Small private-label brand with limited third-party COA transparency and no facility/GMP details.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "k2-d3-vitamin-supplement-60-capsules",
      "title": "K2 D3 Vitamin Supplement - 60 Capsules",
      "vendor": "THIS LITTLE HOUSE OF MINE ONLINE STORE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/K2D3_Immune_System_Supplement.svg?v=1777846222",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "supplement",
        "capsules",
        "this",
        "little",
        "house",
        "mine",
        "online",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 48,
        "manufacturing": 40,
        "safety": 60,
        "transparency": 32,
        "sustainability": 50
      },
      "price": 12.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170904035525",
      "vsf_explanation": "Combines D3 and K2, a synergistic pairing (Knapen 2013 MK-7 180mcg over 3 years reduced arterial stiffness). Product description discloses no doses of D3 or K2, and no K2 form (MK-4 vs MK-7 matters). Small private-label brand without third-party verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "coq10-supplement",
      "title": "CoQ10 Supplement",
      "vendor": "THIS LITTLE HOUSE OF MINE ONLINE STORE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CoQ10_Ubiquinone_Supplement.svg?v=1777846222",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coq10",
        "supplement",
        "this",
        "little",
        "house",
        "mine",
        "online",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 48,
        "manufacturing": 42,
        "safety": 62,
        "transparency": 32,
        "sustainability": 50
      },
      "price": 12.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170903937221",
      "vsf_explanation": "Basic ubiquinone CoQ10. Q-SYMBIO trial (Mortensen 2014) showed 100mg tid ubiquinone reduced HF mortality; dose here is not disclosed. Ubiquinol form (better absorbed in over-40 users per Langsjoen 2014) also not clarified. Small private-label brand.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "focus-brain-focus-clarity-memory-vitamin-supplement",
      "title": "Focus, Brain Focus, Clarity & Memory Vitamin Supplement",
      "vendor": "THIS LITTLE HOUSE OF MINE ONLINE STORE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Focus_Brain_Clarity_Memory_Supplement_a9e3d41b-0476-4cb5-add2-f94ffa243ee4.svg?v=1777846223",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "focus",
        "brain",
        "focus",
        "clarity",
        "memory",
        "vitamin",
        "supplement",
        "this",
        "little",
        "house",
        "mine",
        "online",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 17.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170904068293",
      "vsf_explanation": "Product body explicitly names a 'proprietary blend' with DMAE. DMAE has limited cognitive evidence and safety questions (banned in Canadian supplements). No dose disclosure; vendor is a generic small storefront with no manufacturing pedigree.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "restore-magnesium-complex-glycinate-citrate-malate-with-aquamin",
      "title": "RESTORE Magnesium Complex, Glycinate, Citrate, Malate With Aquamin",
      "vendor": "THIS LITTLE HOUSE OF MINE ONLINE STORE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Restore_Magnesium_Complex_Supplement.svg?v=1777846223",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "restore",
        "magnesium",
        "complex",
        "glycinate",
        "citrate",
        "malate",
        "with",
        "aquamin",
        "this",
        "little",
        "house",
        "mine",
        "online",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 50,
        "safety": 65,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 22.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170904133829",
      "vsf_explanation": "Magnesium glycinate (best-tolerated), citrate, malate + Aquamin (marine calcium/mg) is a rational multi-form Mg complex. Mg has strong evidence for sleep, muscle, BP (Zhang 2016). Total mg elemental amount not disclosed in the description, which limits scoring.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "peace-and-calm-anxiety-relief-supplement-60-capsules",
      "title": "Peace and Calm - Anxiety Relief Supplement - 60 Capsules",
      "vendor": "THIS LITTLE HOUSE OF MINE ONLINE STORE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Peace_Calm.svg?v=1777846222",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "peace",
        "and",
        "calm",
        "anxiety",
        "relief",
        "supplement",
        "capsules",
        "this",
        "little",
        "house",
        "mine",
        "online",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 42,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 28,
        "sustainability": 50
      },
      "price": 19.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170904101061",
      "vsf_explanation": "Ten-ingredient anxiety blend (biotin, Mg, Zn, B vitamins, ashwagandha, GABA, lemon balm, bacopa, chamomile). Individual ingredients have RCT support (Chandrasekhar 2012 ashwagandha 300mg BID) but per-ingredient dose is not disclosed and any single therapeutic dose in a 10-ingredient 1-cap serving is implausible.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "o-racle-ozonated-hemp-oil",
      "title": "O₃RACLE Ozonated Hemp Oil",
      "vendor": "Wizard Sciences",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/pbf_ws_productshots_oracle-8459.jpg?v=1777846266",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "racle",
        "ozonated",
        "hemp",
        "oil",
        "wizard",
        "sciences"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 35,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 69.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170904658117",
      "vsf_explanation": "Ozonated hemp oil marketed with antifungal, antibacterial, antiviral and antiparasitic 'support' claims — those map to disease-treatment claims with no human RCT support. Ozonides in oil are also chemically unstable and can be pro-oxidant. Capped by disease-claim auto-fail.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "tranq-dart",
      "title": "Tranq Dart",
      "vendor": "Wizard Sciences",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/pbf_ws_productshots_tranqdart-8523.jpg?v=1777846266",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tranq",
        "dart",
        "wizard",
        "sciences"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 22,
        "sustainability": 45
      },
      "price": 99.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170904690885",
      "vsf_explanation": "'Sleep serum' with no ingredients disclosed anywhere in product copy — only benefit claims (fall asleep faster, lower core body temperature, gut/neurotransmitter support). Cannot assess formulation, dose, or safety. $99 for a 30-night supply of an undisclosed formula.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "evolve-rx",
      "title": "Evolve Rx",
      "vendor": "Wizard Sciences",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6_Evolvenosplashcopy_R.jpg?v=1777846271",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "evolve",
        "wizard",
        "sciences"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 40,
        "manufacturing": 42,
        "safety": 45,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 82,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170904821957",
      "vsf_explanation": "C60 fullerene in olive oil (lipofullerene). Baati 2012 rat lifespan paper (source of the C60 supplement industry) has been questioned methodologically; no human RCTs exist. Anti-inflammatory and longevity claims are unsubstantiated. C60 mg dose is not disclosed.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "olympix-rx",
      "title": "OLYMPIX Rx",
      "vendor": "Wizard Sciences",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/WS-OlympixRX-1.png?v=1777846272",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "olympix",
        "wizard",
        "sciences"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 38,
        "manufacturing": 42,
        "safety": 45,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 144,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170904789189",
      "vsf_explanation": "C60 lipofullerene plus 'proprietary Olympix Blend'. Claim of 'more than double muscle recruitment' from a testimonial is not supported by any peer-reviewed evidence. Blend contents and doses are undisclosed at $144.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "anti-mx",
      "title": "Anti-mx",
      "vendor": "Wizard Sciences",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/p1.png?v=1777846271",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "anti",
        "wizard",
        "sciences"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular",
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 40,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 256,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170904887493",
      "vsf_explanation": "AntiM is marketed as 'supportive care for cancer patients' with oleic-acid lipofullerene (C60) and proteolytic enzymes. Oral C60 has no human safety or efficacy trials (Baati 2012 was a small rat study). Cancer-support marketing crosses a hard line.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "neural-rx",
      "title": "Neural Rx",
      "vendor": "Wizard Sciences",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6_Neuralnosplashcopy_R.jpg?v=1777846271",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "neural",
        "wizard",
        "sciences"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 38,
        "manufacturing": 42,
        "safety": 42,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 144,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170904920261",
      "vsf_explanation": "Caprylic acid C60 lipofullerene plus 'proprietary Neural Blend'. Copy makes disease-adjacent claims (removal of plaques and proteins, neurogenesis) with no human evidence. C60 human safety data is minimal. $144 for undisclosed contents.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "quanta-complex-b",
      "title": "QUANTA - COMPLEX B",
      "vendor": "Wizard Sciences",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/front.jpg?v=1777846272",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "quanta",
        "complex",
        "wizard",
        "sciences"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 42,
        "safety": 55,
        "transparency": 28,
        "sustainability": 45
      },
      "price": 45.58,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170904854725",
      "vsf_explanation": "B-complex 'Enhanced by Leela Quantum Technology' — no plausible mechanism for 'quantum charging' improving vitamin bioavailability, and no controlled evidence for the claim. Ingredient doses and forms not disclosed.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "elixirx",
      "title": "ELIXIRX",
      "vendor": "Wizard Sciences",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6_ELIXIRXnosplashcopy_R.jpg?v=1777846271",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "elixirx",
        "wizard",
        "sciences"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 45,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 82,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170905051333",
      "vsf_explanation": "C60 fullerene in caprylic-acid liposome/MCT delivery. Oral C60 human trials are effectively absent; the well-known Baati 2012 rat life-extension paper does not generalize, and long-term human safety data for fullerene ingestion is missing. Marketed as 'best for inflammation' with no RCT support.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "derma-rx",
      "title": "Derma RX",
      "vendor": "Wizard Sciences",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/DermaRx1_410X410_5bcc72bc-cdb6-4d69-98e3-2babdf78499f.jpg?v=1777846271",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "derma",
        "wizard",
        "sciences"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 40,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170904953029",
      "vsf_explanation": "Topical 'lipofullerenes' balm with claims of antibacterial, antifungal, antiviral, and scar-reduction effects. C60 fullerene skin science is preliminary at best and human RCTs are absent. Multiple disease-adjacent claims trigger auto-fail.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "quanta-magnesium",
      "title": "QUANTA - MAGNESIUM",
      "vendor": "Wizard Sciences",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/pbf_ws_vitamins_magnesium-3636.jpg?v=1777846272",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "quanta",
        "magnesium",
        "wizard",
        "sciences"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 40,
        "manufacturing": 42,
        "safety": 55,
        "transparency": 28,
        "sustainability": 45
      },
      "price": 47.62,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170905084101",
      "vsf_explanation": "Magnesium 'Enhanced by Leela Quantum Technology'. Magnesium itself has strong evidence for sleep and muscle function (Abbasi 2012 elderly insomnia RCT), but form (glycinate/citrate/oxide) and dose are not disclosed. Quantum-charging claim is unverifiable.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "quanta-vitamin-c",
      "title": "QUANTA - VITAMIN C",
      "vendor": "Wizard Sciences",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/pbf_ws_vitamins_vitaminc-2368.jpg?v=1777846271",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "quanta",
        "vitamin",
        "wizard",
        "sciences"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 40,
        "manufacturing": 42,
        "safety": 55,
        "transparency": 28,
        "sustainability": 45
      },
      "price": 45.58,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170905018565",
      "vsf_explanation": "Ascorbic acid 'Enhanced by Leela Quantum Technology'. Vitamin C at 200-1000mg has well-established immune and collagen support (Carr 2017 review), but per-serving dose and form are not disclosed. Quantum-charging bioavailability claim is unsupported.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "hair-support-serum",
      "title": "Hair Support Serum",
      "vendor": "Wizard Sciences",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/FECD82C6-A73C-43DD-A90F-17DC188E9E96.png?v=1777846271",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hair",
        "support",
        "serum",
        "wizard",
        "sciences"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 20,
        "sustainability": 45
      },
      "price": 138,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170904985797",
      "vsf_explanation": "Product page shows only the title 'Hair Support Serum' — no ingredients, doses, mechanism, or study references at a $138 price point. Cannot be scored against the topical minoxidil / peptide literature (Ryu 2021) without any formula. Capped by transparency auto-fail.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "mitoblue-rx",
      "title": "MitoBlue RX",
      "vendor": "Wizard Sciences",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/pbf_ws_mitoblue_labels-4291.jpg?v=1777846271",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mitoblue",
        "wizard",
        "sciences"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 40,
        "manufacturing": 42,
        "safety": 40,
        "transparency": 22,
        "sustainability": 45
      },
      "price": 99.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170905116869",
      "vsf_explanation": "'Supports mitochondrial cycling' capsules with no ingredients or doses disclosed. Name implies methylene blue, which has research interest (Rojas 2012) but requires dose disclosure and safety context (serotonin syndrome, G6PD deficiency, SSRIs). Opaque product at $100.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "nmn-g-rx-advanced-formula-wizard-sciences",
      "title": "NMN+G Rx Advanced Formula - Wizard Sciences",
      "vendor": "Wizard Sciences",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NMN_GPDP-MainImage.png?v=1777846272",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nmn",
        "advanced",
        "formula",
        "wizard",
        "sciences",
        "wizard",
        "sciences"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 48,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 89.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170905182405",
      "vsf_explanation": "NMN + apigenin + ginsenosides for NAD+ support. Yoshino 2021 pilot (n=25 women) at 250mg NMN showed modest insulin sensitivity improvement in prediabetic postmenopausal women; broader anti-aging claims exceed evidence. NMN, apigenin, and ginsenoside doses are not disclosed at $90.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "vortex-rx-enhance-your-pets-health-naturally",
      "title": "Vortex Rx: Enhance Your Pet's Health Naturally",
      "vendor": "Wizard Sciences",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6_Vortexnosplashcopy_R.jpg?v=1777846271",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vortex",
        "enhance",
        "your",
        "pet",
        "health",
        "naturally",
        "wizard",
        "sciences"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 40,
        "manufacturing": 42,
        "safety": 48,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 120,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170905149637",
      "vsf_explanation": "C60 lipofullerene + astaxanthin + serratiopeptidase + beta-alanine dosed for dogs and cats. Human C60 evidence base is minimal; veterinary evidence is essentially absent. Product is outside the human-supplement scope of this catalog and per-ingredient doses aren't disclosed.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "estee-lauder-resilience-multi-effect-tri-peptide-face-and-neck-cream-moisturizer-spf-15-plumping-anti-aging",
      "title": "Estee Lauder Resilience Multi-Effect Tri-Peptide Face and Neck Cream Moisturizer SPF 15 | Plumping & Anti-Aging",
      "vendor": "Estee Lauder",
      "image_url": "",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "estee",
        "lauder",
        "resilience",
        "multi",
        "effect",
        "tri",
        "peptide",
        "face",
        "and",
        "neck",
        "cream",
        "moisturizer",
        "spf",
        "plumping",
        "anti",
        "aging",
        "estee",
        "lauder"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 30,
        "sustainability": 30
      },
      "price": 79.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170905510085",
      "vsf_explanation": "Topical face cream, not an ingestible supplement, listed as a resale item under an unrelated vendor tag. No peptide concentrations, no clinical citations, generic anti-aging claims. Well-known brand but this listing shows no third-party testing or provenance.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "blink-nutritears-supplement-for-dry-eyes-50-softgels",
      "title": "BLINK Nutritears Supplement for Dry Eyes, 50 Softgels",
      "vendor": "Blink Nutritears",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/61HeFOuByqL._AC_SL1500.jpg?v=1777846310",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "blink",
        "nutritears",
        "supplement",
        "for",
        "dry",
        "eyes",
        "softgels",
        "blink",
        "nutritears"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170905542853",
      "vsf_explanation": "Blink is a real Bausch+Lomb-adjacent eye-care brand and the '33% longer hydration' figure references a clinical trial, but the label copy explicitly calls the mix a 'proprietary formula' with lutein, zeaxanthin, curcumin, and vitamin D at undisclosed doses. Dry-eye-relief phrasing pushes toward a disease claim. Auto-fail caps at 45.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "uro-women-probiotics-capsules-for-women-ph-balance-with-prebiotics-lactobacillus-probiotic-blend",
      "title": "URO Women Probiotics Capsules for Women pH Balance with Prebiotics & Lactobacillus Probiotic Blend",
      "vendor": "URO",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/UROVaginalProbioticsCapsules_b7784440-8bd6-4990-9fb6-2b10f5c46828.jpg?v=1777846310",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "uro",
        "women",
        "probiotics",
        "capsules",
        "for",
        "women",
        "balance",
        "with",
        "prebiotics",
        "lactobacillus",
        "probiotic",
        "blend",
        "uro"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health",
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170905575621",
      "vsf_explanation": "Listing bundles 5 Lactobacillus strains + prebiotics as a blend without per-strain CFU disclosure. L. crispatus (CTV-05 Lactin-V) has Phase 2b RCT evidence for BV recurrence (Cohen 2020 NEJM) at ~2x10^9 CFU, but without dose transparency the buyer cannot verify therapeutic delivery. Vendor field mismatch (Nutrafol vs URO) further undermines provenance.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "skinceuticals-c-e-ferulic-with-15-l-ascorbic-acid-serum-1-fl-oz",
      "title": "SkinCeuticals C E Ferulic With 15% L-ascorbic Acid Serum - 1 fl oz",
      "vendor": "SkinCeuticals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SkinCeuticals_C_E_Ferulic.jpg?v=1777846310",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "skinceuticals",
        "ferulic",
        "with",
        "ascorbic",
        "acid",
        "serum",
        "skinceuticals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 35,
        "sustainability": 30
      },
      "price": 179.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170905641157",
      "vsf_explanation": "SkinCeuticals CE Ferulic is a legitimate topical antioxidant with published RCT support (Pinnell 2001; Lin 2005) at 15% L-ascorbic acid + 1% alpha-tocopherol + 0.5% ferulic acid. However this is a topical, not an ingestible supplement, and it is resold under an unrelated vendor tag with no chain-of-custody guarantee.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "advanced-mens-prostate-support-by-ideal-prostate-plus-ultra-with-reishi-mushroom-saw-palmetto-lycopene-and-more-for-natural-relief",
      "title": "Advanced Men's Prostate Support by Ideal Prostate Plus Ultra with Reishi Mushroom, Saw Palmetto, Lycopene and More for Natural Relief",
      "vendor": "Ideal Prostate Plus Ultra",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Thera_Botanic_Ideal_Prostate_Ultra_Blend.jpg?v=1777846311",
      "score": 43,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "advanced",
        "men",
        "prostate",
        "support",
        "ideal",
        "prostate",
        "plus",
        "ultra",
        "with",
        "reishi",
        "mushroom",
        "saw",
        "palmetto",
        "lycopene",
        "and",
        "more",
        "for",
        "natural",
        "relief",
        "ideal",
        "prostate",
        "plus",
        "ultra"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 59.46,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170905673925",
      "vsf_explanation": "Ingredient list (reishi, saw palmetto, beta-sitosterol, lycopene, horsetail, zinc, D3, copper) is plausible but per-ingredient dosing is not disclosed on the marketing page — saw palmetto RCT dose is 320mg standardized, beta-sitosterol needs ~130-250mg, and these are opaque here. FDA-registered facility without independent third-party testing.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "redimind-natural-brain-booster-memory-support-vegan-30-capsules",
      "title": "RediMind – Natural Brain Booster & Memory Support (Vegan, 30 Capsules)",
      "vendor": "RediMind",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71V1ldjSzBL._AC_SL1500.jpg?v=1777846310",
      "score": 48,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "redimind",
        "natural",
        "brain",
        "booster",
        "memory",
        "support",
        "vegan",
        "capsules",
        "redimind"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 38,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170905706693",
      "vsf_explanation": "RediMind — Alpha-GPC, Huperzine A, Bacopa, Lion's Mane, Ginkgo. Amazon-style relabeled listing, 'clinically studied amounts' but no per-ingredient mg on the copy. Rejected due to opaque dosing and single 30-cap bottle at premium DTC price.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nerve-control-911-natural-plant-based-nerve-health-supplement-1",
      "title": "Nerve Control 911 - Natural Plant Based Nerve Health Supplement",
      "vendor": "Nerve Control 911",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nerve_Control_911_4b09ec17-5d00-40b3-b18a-0573ea9688ea.jpg?v=1777846311",
      "score": 28,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nerve",
        "control",
        "911",
        "natural",
        "plant",
        "based",
        "nerve",
        "health",
        "supplement",
        "nerve",
        "control",
        "911"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 30,
        "manufacturing": 35,
        "safety": 40,
        "transparency": 15,
        "sustainability": 30
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170905968837",
      "vsf_explanation": "Sold under vendor 'Nutrafol' but Nerve Control 911 is a PhytAge Labs marketing product — the label mismatch means the actual manufacturer cannot be verified from the listing. Marketed for peripheral neuropathy, a disease claim without cited RCT evidence.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "skinceuticals-p-tiox-anti-wrinkle-peptide-serum-1-fl-oz",
      "title": "SkinCeuticals P-TIOX Anti-Wrinkle Peptide Serum (1 fl. oz.)",
      "vendor": "SkinCeuticals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/skinceuticals_p_tiox_wrinkle_modulatingpeptideserum_38fb8d8e-da35-468f-a243-2c448a428533.jpg?v=1777846310",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "skinceuticals",
        "tiox",
        "anti",
        "wrinkle",
        "peptide",
        "serum",
        "skinceuticals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 75,
        "safety": 70,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 129.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170905739461",
      "vsf_explanation": "Topical anti-wrinkle serum with 5% niacinamide, 5% PHA (gluconolactone) and 1% Laminaria — all percentages transparently disclosed. Niacinamide 5% has clinical data on wrinkle depth (Bissett Dermatol Surg 2005). SkinCeuticals is a dermatologist-recommended L'Oreal Active Cosmetics brand with formal stability testing; Vyvata vendor field is mismatched (labeled Nutrafol).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "biosil-collagen-generator-120-original-capsules-with-patented-ch-osa-complex-generates-protects-your-own-collagen-gmo-free-60-day-supply",
      "title": "Biosil Collagen Generator - 120 Original Capsules - with Patented ch-OSA Complex - Generates & Protects Your Own Collagen - GMO Free - 60-Day Supply",
      "vendor": "Biosil",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/61OhS9VfrBL._AC_SX569.jpg?v=1777846311",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "biosil",
        "collagen",
        "generator",
        "120",
        "original",
        "capsules",
        "with",
        "patented",
        "osa",
        "complex",
        "generates",
        "protects",
        "your",
        "own",
        "collagen",
        "gmo",
        "free",
        "day",
        "supply",
        "biosil"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty",
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 59.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170905772229",
      "vsf_explanation": "Patented ch-OSA (choline-stabilized orthosilicic acid) with real clinical data on skin fine lines and hair (Barel Arch Dermatol Res 2005 — 20 mg ch-OSA daily improved skin roughness and hair tensile strength). Single-active formulation is clean; individual capsule ch-OSA dose not made explicit in listing copy. Non-GMO, allergen-free positioning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "skinceuticals-p-tiox-wrinkle-modulating-peptide-serum",
      "title": "SkinCeuticals P-TIOX Wrinkle Modulating Peptide Serum",
      "vendor": "SkinCeuticals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Product_Slide_01.webp?v=1777846310",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "skinceuticals",
        "tiox",
        "wrinkle",
        "modulating",
        "peptide",
        "serum",
        "skinceuticals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 75,
        "safety": 70,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 89.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170905837765",
      "vsf_explanation": "Same P-TIOX peptide serum (5% niacinamide / 5% PHA / 1% Laminaria) as the 1 fl oz SKU. Percentages disclosed and formulation matches SkinCeuticals' published stability protocols. Duplicate listing with mismatched Vyvata vendor field (Nutrafol).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "prosvent-advanced-mens-prostate-support-natural-supplement-60-softgels",
      "title": "Prosvent Advanced Men's Prostate Support Natural Supplement 60 softgels",
      "vendor": "Prosvent",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Prosvent_dietary_supplement_60_softgels_ad50a622-7177-400c-8530-7f0ca9c41c8e.jpg?v=1777846311",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "prosvent",
        "advanced",
        "men",
        "prostate",
        "support",
        "natural",
        "supplement",
        "softgels",
        "prosvent"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170906165445",
      "vsf_explanation": "Product page body is Amazon-styling CSS with no ingredient disclosure. Prosvent is a known DTC prostate brand often marketed with strong symptomatic claims (nighttime urination relief) that stretch structure/function limits. Without a disclosed panel the SKU cannot be scored above the auto-fail cap.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "natural-joint-support-supplement-non-gmo-gluten-free",
      "title": "Natural Joint Support Supplement - Non-GMO, Gluten-Free",
      "vendor": "Vyvata",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/81B3ptumDuL._AC_SL1500.jpg?v=1777846311",
      "score": 46,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "natural",
        "joint",
        "support",
        "supplement",
        "non",
        "gmo",
        "gluten",
        "free",
        "vyvata"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 40,
        "sustainability": 42
      },
      "price": 49.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170905804997",
      "vsf_explanation": "RediMove joint capsule — '5 natural ingredients' listed but neither the identities nor doses are disclosed in the product copy. Glucosamine/chondroitin/MSM RCTs (GAIT 2006) require ~1,500 mg/day — this label reveals nothing. Rejected on transparency + likely sub-therapeutic dosing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "silverpeaks-growth-capsules-to-grow-taller-height-growth-maximizer-with-calcium-for-bone-strength-made-in-usa-natural-get-taller-supplement-free-of-growth-hormone",
      "title": "SILVERPEAKS Growth Capsules to Grow Taller - Height Growth Maximizer with Calcium for Bone Strength - Made in USA - Natural Get Taller Supplement - Free of Growth Hormone",
      "vendor": "SilverPeaks",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/81bfnq8fvTL.jpg?v=1777846311",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "joint",
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "silverpeaks",
        "growth",
        "capsules",
        "grow",
        "taller",
        "height",
        "growth",
        "maximizer",
        "with",
        "calcium",
        "for",
        "bone",
        "strength",
        "made",
        "usa",
        "natural",
        "get",
        "taller",
        "supplement",
        "free",
        "growth",
        "hormone",
        "silverpeaks"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 30,
        "manufacturing": 35,
        "safety": 55,
        "transparency": 20,
        "sustainability": 30
      },
      "price": 37.94,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170906067141",
      "vsf_explanation": "Claims to make users 'grow taller' — after growth-plate closure in late adolescence, no oral supplement can increase adult height (Rogol et al. 2000). No RCT evidence supports 'height growth maximizer' claims. Also mislabeled with vendor 'Nutrafol'.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "nugenix-total-t-supplement-for-men-180-count",
      "title": "Nugenix Total-T Supplement for Men, 180 Count",
      "vendor": "Nugenix",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71JJ7nqQfWL_e5689110-d3f7-475d-894b-e1e1ea28e45d.jpg?v=1777846311",
      "score": 55,
      "tier": "standard",
      "certifications": [
        "NSF Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "nugenix",
        "total",
        "supplement",
        "for",
        "men",
        "180",
        "count",
        "nugenix"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 65,
        "safety": 60,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170905870533",
      "vsf_explanation": "Uses three branded, individually-studied ingredients — Testofen/Tesnor fenugreek extract, elevATP, and boron — at 'clinically-validated' doses. Fenugreek extracts have modest testosterone RCTs (Wankhede 2016). Manufactured at NSF-certified cGMP facility in Salt Lake City, which is a real plus vs. category norms. Not standardization-blind but not fully transparent either.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natural-liver-support-supplement-30-capsules-1",
      "title": "Natural Liver Support Supplement 30 Capsules",
      "vendor": "Vyvata",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/81LegDGrjFL._AC_SL1500_b8b80dea-e7f4-4fbf-972c-1c21d6b3edf5.jpg?v=1777846311",
      "score": 48,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "natural",
        "liver",
        "support",
        "supplement",
        "capsules",
        "vyvata"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 39.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170906198213",
      "vsf_explanation": "Hepagard: milk thistle, NAC, artichoke, dandelion, choline — no doses disclosed. Silymarin RCTs use 420–600 mg/day (Loguercio 2012); NAC hepatoprotection uses 600–1200 mg. Rejected due to Amazon-style relabel + hidden dosing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natural-bone-support-supplement-non-gmo-gluten-free",
      "title": "Natural Bone Support Supplement - Non-GMO, Gluten-Free",
      "vendor": "Vyvata",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71eE83DbH-L._AC_SL1500_4e77a0d4-c376-43a1-928a-b3abc435c371.jpg?v=1777846312",
      "score": 47,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "natural",
        "bone",
        "support",
        "supplement",
        "non",
        "gmo",
        "gluten",
        "free",
        "vyvata"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 39.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170906230981",
      "vsf_explanation": "Calciven: Ca + Mg + boron + D3 + K2, marketed as 'low-dose high-efficiency' — bone RCTs (Weaver 2016) need ~1,000 mg Ca + 800 IU D3 daily. Deliberately low dose + no per-ingredient mg = won't meaningfully move bone density. Rejected.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnesium-complex-supplement-8-elemental-1000mg-magnesium-glycinate-citrate-malate-taurate-chelated-for-easy-absorption-for-bones-muscle-recovery-energy-vegan-non-gmo-90-capsules",
      "title": "Magnesium Complex Supplement 8 Elemental 1000mg - Magnesium Glycinate, Citrate, Malate, Taurate, Chelated for Easy Absorption for Bones, Muscle, Recovery, Energy, Vegan Non-GMO 90 Capsules",
      "vendor": "Vyvata",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/81GGlmjmqzL.jpg?v=1777846313",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "complex",
        "supplement",
        "elemental",
        "1000mg",
        "magnesium",
        "glycinate",
        "citrate",
        "malate",
        "taurate",
        "chelated",
        "for",
        "easy",
        "absorption",
        "for",
        "bones",
        "muscle",
        "recovery",
        "energy",
        "vegan",
        "non",
        "gmo",
        "capsules",
        "vyvata"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 45,
        "sustainability": 35
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170906362053",
      "vsf_explanation": "Toplux Magnesium Complex labelled '1000mg' with 8 forms including magnesium oxide (poor bioavailability, per Firoz & Graber 2001). Per-form doses not disclosed and 1000mg elemental Mg exceeds the tolerable upper limit of 350mg for supplemental Mg (IOM 1997), inviting diarrhea. Vendor field 'Nutrafol' does not match Toplux.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bioma-probiotics-digestive-health-gut-support-for-men-women-60-capsules",
      "title": "BIOMA Probiotics Digestive Health Gut Support for Men & Women 60 Capsules",
      "vendor": "BIOMA",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Bioma_Probiotics_2b0d38c2-0004-4cf5-b212-de84602bec1c.jpg?v=1777846313",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "bioma",
        "probiotics",
        "digestive",
        "health",
        "gut",
        "support",
        "for",
        "men",
        "women",
        "capsules",
        "bioma"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170906263749",
      "vsf_explanation": "Three-strain Bifidobacterium (breve, longum, lactis) plus XOS prebiotic and tributyrin postbiotic in delayed-release capsule. Species disclosed but no strain designations or CFU counts — critical omission since probiotic efficacy is strain-specific (Ford Am J Gastroenterol 2018). Vendor mislabeled Nutrafol.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "advanced-mens-prostate-support-natural-supplement-with-saw-palmetto-vitamin-d-and-zinc-to-ease-urinary-frequency-urgency-60-count",
      "title": "Advanced Men's Prostate Support Natural Supplement with Saw Palmetto, Vitamin D, and Zinc to Ease Urinary Frequency & Urgency (60 Count)",
      "vendor": "Vyvata",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Prosvent_dietary_supplement_60_softgels_5c412db8-8a52-48b6-bb27-044e7364bc0c.jpg?v=1777846314",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular",
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "advanced",
        "men",
        "prostate",
        "support",
        "natural",
        "supplement",
        "with",
        "saw",
        "palmetto",
        "vitamin",
        "and",
        "zinc",
        "ease",
        "urinary",
        "frequency",
        "urgency",
        "count",
        "vyvata"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170906394821",
      "vsf_explanation": "Product body is only CSS markup. Title names saw palmetto, vitamin D, and zinc but doses are not disclosed. Also explicitly claims relief of 'urinary frequency and urgency' — that is a lower-urinary-tract symptom, which is a disease/drug claim domain. Cannot be scored above the auto-fail cap without a disclosed panel.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "unicity-balance-natural-orange-stay-full-longer-by-slowing-carbohydrate",
      "title": "UNICITY BALANCE NATURAL ORANGE—Stay full longer by slowing carbohydrate...",
      "vendor": "Unicity",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_58cd84ca-1388-463e-b03f-b1785e3f0a1b.jpg?v=1777846314",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "unicity",
        "balance",
        "natural",
        "orange",
        "stay",
        "full",
        "longer",
        "slowing",
        "carbohydrate",
        "unicity"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive",
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 84.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170906427589",
      "vsf_explanation": "Unicity Balance fiber blend (guar gum, oat fiber, chromium) — an MLM product with some independent research on the Bios Life predecessor (Cicero Eur Rev Med Pharmacol Sci 2010, modest LDL and glycemic improvements). Product body copy omits ingredient list and per-sachet fiber grams. Vendor mismatched to Nutrafol.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "neurohacker-collective-qualia-mind-doctor-formulated-nootropic-to-fuel-focus-concentration-2",
      "title": "NEUROHACKER COLLECTIVE Qualia Mind | Doctor-Formulated Nootropic to Fuel Focus & Concentration",
      "vendor": "Neurohacker Collective",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/61xOJmuFTpL._AC_SL1500.jpg?v=1777846315",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "neurohacker",
        "collective",
        "qualia",
        "mind",
        "doctor",
        "formulated",
        "nootropic",
        "fuel",
        "focus",
        "concentration",
        "neurohacker",
        "collective"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 74.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170906460357",
      "vsf_explanation": "32 ingredients spanning cholinergics (Alpha-GPC, citicoline), adaptogens, and stimulants (caffeine, theobromine). Neurohacker discloses full label with individual doses (not proprietary blend), which is unusual and honest for a formula this large. However, kitchen-sink stacking dilutes individual doses vs. focused RCTs, and the caffeine/theobromine load raises safety/interaction risk.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liver-health-liver-cleanse-detox-repair-with-artichoke-extract-milk-thistle-dandelion-root-turmeric-berberine-to-healthy-liver-renew-with-11-natural-nutrients-30-days-supply",
      "title": "Liver Health – Liver Cleanse Detox & Repair with Artichoke Extract, Milk Thistle, Dandelion Root, Turmeric, Berberine to Healthy Liver Renew with 11 Natural Nutrients, 30 Days Supply",
      "vendor": "Vyvata",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71RuBzCOhnL.jpg?v=1777846315",
      "score": 40,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "inflammation",
        "joint",
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liver",
        "health",
        "liver",
        "cleanse",
        "detox",
        "repair",
        "with",
        "artichoke",
        "extract",
        "milk",
        "thistle",
        "dandelion",
        "root",
        "turmeric",
        "berberine",
        "healthy",
        "liver",
        "renew",
        "with",
        "natural",
        "nutrients",
        "days",
        "supply",
        "vyvata"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170906493125",
      "vsf_explanation": "Cramming 11 hepatic-marketed herbs (milk thistle, artichoke, dandelion, turmeric, berberine, beet) into a single '30-day supply' capsule dilutes standardized-extract doses below the trial ranges (silymarin 420mg, berberine 500mg TID). 'Liver cleanse/detox/repair' is disease-adjacent marketing without evidence for the endpoint claimed.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "skinceuticals-blemish-age-defense-1-fl-oz",
      "title": "SkinCeuticals BLEMISH + AGE DEFENSE 1 fl oz",
      "vendor": "SkinCeuticals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SkinCeuticals_BLEMISH_AGE_DEFENSE_c0c049bb-0ea1-46e7-82b3-063def5e0c1d.png?v=1777846315",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "skinceuticals",
        "blemish",
        "age",
        "defense",
        "skinceuticals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 75,
        "safety": 65,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 99.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170906624197",
      "vsf_explanation": "2% dioic acid with combined AHA (glycolic) and BHA (salicylic) acid blend for acne-prone aging skin. Percentage disclosure and a first-to-market dioic acid patent make this a legitimate SkinCeuticals formulation. Efficacy for adult female acne shown in company-sponsored trials. Vendor mislabeled Nutrafol.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "megaigg2000",
      "title": "MegaIgG2000",
      "vendor": "MegaIgG2000",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/51XdS2uBDEL_a473efbd-ad82-4880-b048-08754da5060e.jpg?v=1777846316",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "megaigg2000",
        "megaigg2000"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 72,
        "manufacturing": 72,
        "safety": 70,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 63.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170906656965",
      "vsf_explanation": "Microbiome Labs serum-derived bovine IgG (SBI), dairy-free; 10+ human RCTs on the ingredient for IBS-D and gut-barrier function (Wilson 2013; Good 2015). 4-capsule daily serving matches the trial dose. Verified — genuine practitioner-tier brand.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "elemis-pro-collagen-marine-cream-spf-30-lightweight-anti-wrinkle-daily-facial-moisturizer",
      "title": "ELEMIS Pro-Collagen Marine Cream SPF 30, Lightweight Anti-Wrinkle Daily Facial Moisturizer",
      "vendor": "ELEMIS",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Elemis_Pro_Collagen_786397b4-399f-4fad-8073-752f4dffafdc.jpg?v=1777846316",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "elemis",
        "pro",
        "collagen",
        "marine",
        "cream",
        "spf",
        "lightweight",
        "anti",
        "wrinkle",
        "daily",
        "facial",
        "moisturizer",
        "elemis"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 20,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 30,
        "sustainability": 35
      },
      "price": 99.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170906689733",
      "vsf_explanation": "This is a topical facial moisturizer with SPF 30, not an oral supplement — it should not be categorized in supplements at all. Vendor is also mislabeled as 'Nutrafol' (actual brand is ELEMIS). Rejected because it is out-of-category for supplement scoring.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sciatic-nerve-health-support-supplement-120-capsules",
      "title": "Sciatic Nerve Health Support Supplement - 120 Capsules",
      "vendor": "Vyvata",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Sciatic_Nerve_Health_Support_Supplement_3de67a66-fd1a-42fe-94b5-72c0f0179369.jpg?v=1777846317",
      "score": 28,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sciatic",
        "nerve",
        "health",
        "support",
        "supplement",
        "120",
        "capsules",
        "vyvata"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 30,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 20,
        "sustainability": 35
      },
      "price": 69.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170906722501",
      "vsf_explanation": "'SciatiEase' 12-ingredient proprietary blend hiding individual doses of PEA, acetyl-L-carnitine, benfotiamine, and B-vitamins behind the label. Only R-ALA (300mg) is disclosed. Marketed explicitly for 'sciatic nerve pain' relief — a specific disease claim not permitted for supplements. Two auto-fails; the product is fundamentally non-compliant with FDA structure/function rules.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "instaflex-advanced-joint-support-nutritional-supplement-capsule-with-doctor-formulated-joint-relief-supplement-featuring-uc-ii-collagen-5-other-joint-discomfort-fighting-ingredients-60-ct",
      "title": "Instaflex Advanced Joint Support Nutritional Supplement Capsule with Doctor Formulated Joint Relief Supplement, Featuring UC-II Collagen & 5 Other Joint Discomfort Fighting Ingredients, 60 Ct",
      "vendor": "Instaflex",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Instaflex_Advanced_Joint_Support_Supplement_Pack_of_2_a80fcad5-09c5-4963-9c37-e10b2e903fd6.jpg?v=1777846318",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "instaflex",
        "advanced",
        "joint",
        "support",
        "nutritional",
        "supplement",
        "capsule",
        "with",
        "doctor",
        "formulated",
        "joint",
        "relief",
        "supplement",
        "featuring",
        "collagen",
        "other",
        "joint",
        "discomfort",
        "fighting",
        "ingredients",
        "instaflex"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 89.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170907050181",
      "vsf_explanation": "Anchor ingredients UC-II undenatured collagen (Lugo Nutr J 2016 — 40 mg UC-II outperformed 1500 mg glucosamine + 1200 mg chondroitin on WOMAC) and AprèsFlex boswellia have credible RCT support. Six-ingredient formula but individual doses not enumerated in listing copy. Marketed 7-day relief claim overstates typical response window.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "stonehenge-health-dynamic-brain-supplement-new-formula-with-bacomind-for-memory-acquisition-retention-recall-with-40-unique-nootropic-choline-phosphatidylserine-and-huperzine-a-1",
      "title": "Stonehenge Health Dynamic Brain Supplement – New Formula with BacoMind for Memory Acquisition, Retention, & Recall with 40 Unique Nootropic: Choline, Phosphatidylserine, and Huperzine A",
      "vendor": "Stonehenge Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71eROdzdUVL._AC_SL1500_c2f09006-fb43-46f6-b498-836215423379.jpg?v=1777846318",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "stonehenge",
        "health",
        "dynamic",
        "brain",
        "supplement",
        "new",
        "formula",
        "with",
        "bacomind",
        "for",
        "memory",
        "acquisition",
        "retention",
        "recall",
        "with",
        "unique",
        "nootropic",
        "choline",
        "phosphatidylserine",
        "and",
        "huperzine",
        "stonehenge",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 60,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 58,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170906984645",
      "vsf_explanation": "Stonehenge Dynamic Brain with BacoMind (branded Bacopa), phosphatidylserine, Huperzine A, choline. BacoMind has published safety and modest cognitive RCTs (Peth-Nui 2012). cGMP US manufacturing, 3rd-party tested claim. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "joint-support-supplement-promotes-mobility-flexibility-and-comfort-with-hyaluronic-acid-collagen-type-ii-and-boswellia-30-capsules",
      "title": "Joint Support Supplement - Promotes Mobility, Flexibility, and Comfort with Hyaluronic Acid, Collagen Type II, and Boswellia - 30 Capsules -",
      "vendor": "Vyvata",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71Sxql-sRHL_d5d2c5b2-3cbb-4481-a829-2d7b37048f73.jpg?v=1777846318",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "joint",
        "support",
        "supplement",
        "promotes",
        "mobility",
        "flexibility",
        "and",
        "comfort",
        "with",
        "hyaluronic",
        "acid",
        "collagen",
        "type",
        "and",
        "boswellia",
        "capsules",
        "vyvata"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 70,
        "transparency": 55,
        "sustainability": 42
      },
      "price": 69.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170906951877",
      "vsf_explanation": "Arthrozene blends three trademarked joint ingredients: AprèsFlex Boswellia serrata (RCT support Sengupta et al. 2010 for OA), Mobilee hyaluronic acid, and Collavant n2 undenatured type II collagen (Lugo et al. 2013 for knee OA). Once-daily dose is convenient. Vendor label 'Nutrafol' is mismatched with actual brand (Aterna).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "procare-health-bariatric-multivitamin-45mg-iron-once-daily-capsule-for-gastric-bypass-sleeve-post-op-support-90-easy-to-swallow-capsules-3-month-supply-no-artificial-colors-gluten-free",
      "title": "ProCare Health Bariatric Multivitamin 45mg Iron – Once Daily Capsule for Gastric Bypass, Sleeve & Post-Op Support – 90 Easy-to-Swallow Capsules, 3-Month Supply, No Artificial Colors, Gluten-Free",
      "vendor": "ProCare Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/81kuXZnZmXL_754a6fa9-b4d9-49e4-9fa5-73f6d6c3de37.jpg?v=1777846319",
      "score": 58,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "procare",
        "health",
        "bariatric",
        "multivitamin",
        "45mg",
        "iron",
        "once",
        "daily",
        "capsule",
        "for",
        "gastric",
        "bypass",
        "sleeve",
        "post",
        "support",
        "easy",
        "swallow",
        "capsules",
        "month",
        "supply",
        "artificial",
        "colors",
        "gluten",
        "free",
        "procare",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170907082949",
      "vsf_explanation": "Purpose-built for post-bariatric-surgery patients following ASMBS guidelines (Parrott 2017) — 45mg iron, B12, D3, zinc in a once-daily capsule. Third-party tested, GMP-certified US manufacture, clean label. Legitimate niche product; iron form/absorbability details would push it higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "umzu-redwood-max-nitric-oxide-booster-1-month-supply-advanced-nitric-oxide-supplement-with-fitnox-blend-pine-bark-resveratrol-tart-cherry-promotes-healthy-circulation-energy-and-recovery",
      "title": "UMZU Redwood Max Nitric Oxide Booster, 1-Month Supply – Advanced Nitric Oxide Supplement with Fitnox Blend, Pine Bark, Resveratrol & Tart Cherry – Promotes Healthy Circulation, Energy and Recovery",
      "vendor": "UMZU",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71XNQSanyVL.jpg?v=1777846318",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "cardiovascular",
        "recovery",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "umzu",
        "redwood",
        "max",
        "nitric",
        "oxide",
        "booster",
        "month",
        "supply",
        "advanced",
        "nitric",
        "oxide",
        "supplement",
        "with",
        "fitnox",
        "blend",
        "pine",
        "bark",
        "resveratrol",
        "tart",
        "cherry",
        "promotes",
        "healthy",
        "circulation",
        "energy",
        "and",
        "recovery",
        "umzu"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170907148485",
      "vsf_explanation": "UMZU Redwood Max uses Fitnox (branded blend), maritime pine bark, resveratrol, VitaCherry — a non-arginine NO stack. Pycnogenol has BP and endothelial RCTs (Zibadi 2008) but Fitnox proprietary means overall dose transparency is limited. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "optimum-nutrition-opti-men-multivitamin-tablets",
      "title": "Optimum Nutrition Opti-Men Multivitamin Tablets",
      "vendor": "Optimum Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/61ou4fOWT8L._AC_SL1500_b6a2a256-f56b-4f78-abb3-84a8d3b398ef.jpg?v=1777846318",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "optimum",
        "nutrition",
        "opti",
        "men",
        "multivitamin",
        "tablets",
        "optimum",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 50,
        "sustainability": 40
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170907345093",
      "vsf_explanation": "Established Optimum Nutrition men's multi with 21 vitamins/minerals plus botanicals and 1g free-form amino acids at 3 tabs/day. Uses less-bioavailable forms of some B vitamins (e.g. cyanocobalamin over methylcobalamin). Vendor field 'Nutrafol' is mislabeled (real brand is ON).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ryze-mushroom-coffee-premium-organic-mushroom-coffee-blend-with-adaptogens-for-focus-energy-immunity",
      "title": "RYZE Mushroom Coffee – Premium Organic Mushroom Coffee Blend with Adaptogens for Focus, Energy & Immunity",
      "vendor": "RYZE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ryze-mushroom-coffee-pack-of-3-6-adaptogenic-mushrooms-organic-instant-coffee-mct-oil-better-energy-focus-digestion-immunity-cordyceps-lions-mane-shiitake-reish-424922.webp?v=1777846318",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "mood",
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ryze",
        "mushroom",
        "coffee",
        "premium",
        "organic",
        "mushroom",
        "coffee",
        "blend",
        "with",
        "adaptogens",
        "for",
        "focus",
        "energy",
        "immunity",
        "ryze"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170907246789",
      "vsf_explanation": "RYZE — 2,000 mg blend across 6 mushrooms + MCT + arabica per scoop, 27% beta-glucan spec. Dual-extraction and USA organic sourcing are positives. Per-mushroom mg still not disclosed and 333 mg average per mushroom is below single-species trial doses. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cellgevity-advanced-riboceine-technology-120-capsules-60-servings",
      "title": "Cellgevity, Advanced Riboceine Technology, 120 Capsules, 60 Servings",
      "vendor": "Cellgevity",
      "image_url": "",
      "score": 47,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cellgevity",
        "advanced",
        "riboceine",
        "technology",
        "120",
        "capsules",
        "servings",
        "cellgevity"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular",
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 69.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170907115717",
      "vsf_explanation": "Max International MLM product featuring 12-ingredient RiboCeine + antioxidant blend (curcumin, resveratrol, ALA, grape seed, broccoli seed, aloe, cordyceps, BioPerine, vitamin C, selenium). No individual doses disclosed. RiboCeine (D-ribose-L-cysteine) glutathione claims rest on rodent studies, no peer-reviewed human RCT.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "king-maker-13-in-1-anabolic-supplement-for-men-to-increase-stamina-lean-muscle-growth-recovery-n-o-booster-with-tongkat-ali-lj100-120-capsules",
      "title": "King Maker 13-in-1 Anabolic Supplement for Men to Increase Stamina, Lean Muscle Growth & Recovery, N.O. Booster with Tongkat Ali (LJ100), 120 Capsules",
      "vendor": "King Maker",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/imgi_48_King_Maker_pack_of_1_a6d07a62-eca1-4a1e-99c0-50a95623073f.png?v=1777846319",
      "score": 36,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "king",
        "maker",
        "anabolic",
        "supplement",
        "for",
        "men",
        "increase",
        "stamina",
        "lean",
        "muscle",
        "growth",
        "recovery",
        "booster",
        "with",
        "tongkat",
        "ali",
        "lj100",
        "120",
        "capsules",
        "king",
        "maker"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 40,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 35,
        "sustainability": 35
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170907443397",
      "vsf_explanation": "Marketed as '13-in-1 Anabolic', combining turkesterones (no rigorous human RCTs), Cyanotis vaga, Tongkat Ali LJ100 (some testosterone data Ismail et al. 2012), beet, maca and ViNitrox. Overreaching muscle/T claims for a botanical stack. Per-ingredient doses not disclosed. Vendor field mislabeled.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "biosil-collagen-generator-120-original-capsules-pack-of-2-with-patented-ch-osa-complex-generates-protects-your-own-collagen-gmo-free-60-day-supply",
      "title": "Biosil Collagen Generator - 120 Original Capsules Pack of 2 - with Patented ch-OSA Complex - Generates & Protects Your Own Collagen - GMO Free - 60-Day Supply",
      "vendor": "Biosil",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Biosil_120_capusles_Pack_of_2_919e5711-da32-4d08-b53d-af70520092c8.jpg?v=1777846319",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "biosil",
        "collagen",
        "generator",
        "120",
        "original",
        "capsules",
        "pack",
        "with",
        "patented",
        "osa",
        "complex",
        "generates",
        "protects",
        "your",
        "own",
        "collagen",
        "gmo",
        "free",
        "day",
        "supply",
        "biosil"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty",
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 99.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170907574469",
      "vsf_explanation": "Duplicate two-pack of the ch-OSA Biosil SKU. Patented choline-stabilized orthosilicic acid with real RCT evidence for skin roughness and hair tensile strength (Barel Arch Dermatol Res 2005). Vendor field mismatched to Nutrafol.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "skinceuticals-hyaluronic-acid-intensifier-h-a-1-fl-oz",
      "title": "SkinCeuticals Hyaluronic acid intensifier (H.A.) 1 fl. oz.",
      "vendor": "SkinCeuticals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SkinCeuticals_Hyaluronic_acid_intensifier_H.A._1_fl._oz._1d64812a-4ec5-4cf2-838a-bc1a7c78a953.jpg?v=1777846319",
      "score": 33,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "skinceuticals",
        "hyaluronic",
        "acid",
        "intensifier",
        "skinceuticals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 25,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 30,
        "sustainability": 30
      },
      "price": 99.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170907541701",
      "vsf_explanation": "Topical corrective serum with hyaluronic acid, proxylane and botanical extracts — a leave-on skincare product, not an oral supplement. Should not be scored in supplements category. Vendor field 'Nutrafol' is mislabeled (real brand SkinCeuticals).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "purehealth-research-liver-health-liver-cleanse-detox-repair-with-artichoke-extract-milk-thistle-dandelion-root-turmeric-beet-root-to-healthy-liver-renew-with-11-natural-nutrients-60-capsules",
      "title": "PUREHEALTH RESEARCH Liver Health – Liver Cleanse Detox & Repair with Artichoke Extract, Milk Thistle, Dandelion Root, Turmeric, Beet Root to Healthy Liver Renew with 11 Natural Nutrients, 60 Capsules",
      "vendor": "PureHealth Research",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/81oOttw-kVL_d36053a0-f002-4ca0-a5c0-eab896c6879b.jpg?v=1777846320",
      "score": 40,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "inflammation",
        "joint",
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "purehealth",
        "research",
        "liver",
        "health",
        "liver",
        "cleanse",
        "detox",
        "repair",
        "with",
        "artichoke",
        "extract",
        "milk",
        "thistle",
        "dandelion",
        "root",
        "turmeric",
        "beet",
        "root",
        "healthy",
        "liver",
        "renew",
        "with",
        "natural",
        "nutrients",
        "capsules",
        "purehealth",
        "research"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170907607237",
      "vsf_explanation": "Same formula and marketing pattern as the sibling Liver Health SKU. 'Liver cleanse/detox/repair' phrasing crosses into disease-modification territory, and 11 herbs in one capsule cannot deliver clinical doses of standardized silymarin (420mg) or berberine (1500mg/d).",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "dr-berg-all-in-one-vitamins-for-hair-skin-nails-advanced-formula-with-biotin-saw-palmetto-dht-blocker-trace-minerals-90-veg-capsules",
      "title": "Dr. Berg All-in-One Vitamins for Hair, Skin, & Nails - Advanced Formula with Biotin, Saw Palmetto, DHT Blocker, & Trace Minerals - 90 Veg Capsules",
      "vendor": "Dr. Berg",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/61WJp8Ya6KL_8e23f0e4-80c2-434b-b463-3da8fa0bc229.jpg?v=1777846322",
      "score": 51,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "skin",
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "berg",
        "all",
        "one",
        "vitamins",
        "for",
        "hair",
        "skin",
        "nails",
        "advanced",
        "formula",
        "with",
        "biotin",
        "saw",
        "palmetto",
        "dht",
        "blocker",
        "trace",
        "minerals",
        "veg",
        "capsules",
        "berg"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170907771077",
      "vsf_explanation": "Biotin, zinc, saw palmetto, copper, selenium, B-vitamins, Korean ginseng, horsetail — sensible ingredient set for hair health. Biotin monotherapy evidence for non-deficient hair loss is weak (Patel 2017 review). GMP-certified US manufacture; formula rides on 'trust Dr. Berg' rather than trial-dose transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "shilajit-for-men-women-shilajit-with-naturally-fulvic-acid-l-arginine-himalayan-shilajits-for-extra-power-stamina-immune-support-non-gmo-made-in-usa-60-capsules-1-300mg-per-serving",
      "title": "Shilajit for Men Women, Shilajit with Naturally Fulvic Acid & L-Arginine, Himalayan Shilajits for Extra Power, Stamina & Immune Support, Non-GMO, Made in USA, 60 Capsules, 1,300mg Per Serving",
      "vendor": "Vyvata",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71X4uIrXzLL_06122fe6-7021-42fd-b979-b9e61bd60ffd.jpg?v=1777846323",
      "score": 28,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "shilajit",
        "for",
        "men",
        "women",
        "shilajit",
        "with",
        "naturally",
        "fulvic",
        "acid",
        "arginine",
        "himalayan",
        "shilajits",
        "for",
        "extra",
        "power",
        "stamina",
        "immune",
        "support",
        "non",
        "gmo",
        "made",
        "usa",
        "capsules",
        "300mg",
        "per",
        "serving",
        "vyvata"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 25,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 25,
        "sustainability": 35
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170907836613",
      "vsf_explanation": "Anonymous 'Flynew' shilajit blend with 410mg shilajit extract plus 130mg L-arginine — L-arginine is far below the 3-6g clinical range for vascular effect (Bode-Boger 2007). Combined with pomegranate, fenugreek, cinnamon, cumin in an undifferentiated blend; no NSF/USP, no COA, and shilajit sourcing/heavy-metal testing are especially critical. Amazon-style listing without verifiable brand ownership.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "ultra-potent-hormone-harmony-natural-hormonal-support-for-women-72-capsules",
      "title": "Ultra Potent Hormone Harmony Natural Hormonal Support for Women. 72 Capsules",
      "vendor": "Vyvata",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71dYUYMAIqL._AC_SL1500_92d613b8-9c02-4c2a-91f0-b58d604625a0.jpg?v=1777846325",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "ultra",
        "potent",
        "hormone",
        "harmony",
        "natural",
        "hormonal",
        "support",
        "for",
        "women",
        "capsules",
        "vyvata"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine",
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 35,
        "manufacturing": 50,
        "safety": 45,
        "transparency": 25,
        "sustainability": 30
      },
      "price": 79.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170907934917",
      "vsf_explanation": "Happy Mammoth Hormone Harmony is a well-known adaptogen blend but the listing lists no ingredient doses. Prior consumer-lab analyses (LabDoor 2023) note undisclosed proprietary-blend amounts. No cited RCT supports the finished formula for menopausal/hormonal endpoints.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "super-beta-prostate-dietary-supplement-for-mens-health",
      "title": "Super Beta Prostate Dietary Supplement for Men's Health",
      "vendor": "Super Beta Prostate",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/WhatsApp_Image_2025-09-24_at_6.27.22_PM_3c475e96-aa40-4c49-8bc9-241c88b1fce3.jpg?v=1777846326",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "super",
        "beta",
        "prostate",
        "dietary",
        "supplement",
        "for",
        "men",
        "health",
        "super",
        "beta",
        "prostate"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170907967685",
      "vsf_explanation": "250mg beta-sitosterol has some BPH/LUTS RCT support (Klippel 1997, Berges 1995 at ~130mg), and 250mg is within range. However, the '10-ingredient proprietary formula' hides the doses of every other component, and marketing implies drug-like symptomatic relief. Auto-fail caps the score at 45.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "upwellness-ultra-liver-support-tmg-nac-milk-thistle-formula-for-liver-and-gallbladder-health-60-capsules-1",
      "title": "UpWellness Ultra Liver Support – TMG, NAC & Milk Thistle Formula for Liver and Gallbladder Health (60 Capsules)",
      "vendor": "UpWellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitled_design_2_be8a96a9-0ac5-495c-aa9a-b2005b6a1b12.jpg?v=1777846326",
      "score": 53,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "upwellness",
        "ultra",
        "liver",
        "support",
        "tmg",
        "nac",
        "milk",
        "thistle",
        "formula",
        "for",
        "liver",
        "and",
        "gallbladder",
        "health",
        "capsules",
        "upwellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 65,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170908131525",
      "vsf_explanation": "UpWellness liver stack with TMG, N-acetylcysteine and milk thistle (silymarin). NAC has moderate evidence in hepatic support (Green et al. 2013 acetaminophen), silymarin shows small benefit in NAFLD (Zhong et al. 2017). Per-cap doses not visible in excerpt. Vendor field mislabeled.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nugenix-total-t-free-and-total-testosterone-booster-supplement-for-men-90-count",
      "title": "Nugenix Total-T, Free and Total Testosterone Booster Supplement for Men, 90 Count",
      "vendor": "Nugenix",
      "image_url": "",
      "score": 55,
      "tier": "standard",
      "certifications": [
        "NSF Certified"
      ],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "nugenix",
        "total",
        "free",
        "and",
        "total",
        "testosterone",
        "booster",
        "supplement",
        "for",
        "men",
        "count",
        "nugenix"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 65,
        "safety": 60,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170908033221",
      "vsf_explanation": "Same Tesnor/elevATP/boron formula as the 180ct SKU. Modest RCT support for the branded fenugreek extract (Wankhede 2016), NSF-certified cGMP facility. Reasonable mid-tier T-support product but not a category leader.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "k18-leave-in-molecular-hair-mask-repairs-dry-or-damaged-hair-reverse-hair-damage-from-bleach-color-chemical-services-heat",
      "title": "K18 Leave-In Molecular Hair Mask, Repairs Dry or Damaged Hair, Reverse Hair Damage from Bleach, Color, Chemical Services & Heat",
      "vendor": "K18",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71wCdxmA9tL._SL1500_ab0e7327-8247-4a5d-9241-717806507bcc.jpg?v=1777846327",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "k18",
        "leave",
        "molecular",
        "hair",
        "mask",
        "repairs",
        "dry",
        "damaged",
        "hair",
        "reverse",
        "hair",
        "damage",
        "from",
        "bleach",
        "color",
        "chemical",
        "services",
        "heat",
        "k18"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 25,
        "sustainability": 35
      },
      "price": 67.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170908262597",
      "vsf_explanation": "A cosmetic leave-in hair-repair mask (K18 brand) that is mis-labeled with the vendor 'Nutrafol' in this store's catalog. Either way it's a hair-cosmetic product with no biohacking or measurable health function. Auto-failed as out of scope.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "skinceuticals-c-e-ferulic-combination-antioxidant-treatment",
      "title": "SkinCeuticals C E Ferulic Combination Antioxidant Treatment",
      "vendor": "SkinCeuticals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SkinCeuticals_C_E_Ferulic_Antioxidant_Serum_1.0_fl_oz.jpg?v=1777846326",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "skinceuticals",
        "ferulic",
        "combination",
        "antioxidant",
        "treatment",
        "skinceuticals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 75,
        "manufacturing": 68,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 129.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170908229829",
      "vsf_explanation": "Topical (not oral) — 15% L-ascorbic acid + 1% α-tocopherol + 0.5% ferulic acid Duke antioxidant patent. Lin 2005 and Murray 2008 dermatology RCTs establish photoprotection and pigmentation benefits from this specific 15/1/0.5 formulation. Standard for topical antioxidants.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "trunature-prostate-health-complex-250-softgels",
      "title": "Trunature Prostate Health Complex, 250 Softgels",
      "vendor": "Trunature",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/81iB1xOKFpL._AC_SL1500_b446d7a0-c8f1-451d-a64e-29c7cd255f3b.jpg?v=1777846327",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "trunature",
        "prostate",
        "health",
        "complex",
        "250",
        "softgels",
        "trunature"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 30,
        "sustainability": 35
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170908295365",
      "vsf_explanation": "Named ingredients (saw palmetto, pumpkin seed, lycopene, zinc) are relevant to prostate/BPH but Barry et al. 2011 (JAMA CAMUS trial) found saw palmetto no better than placebo at 320mg. Doses not disclosed in listing, and Costco-tier Trunature line has limited third-party verification.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "heliocare-advanced-niacin-b3-supplement-fernblock-ple-extract-240mg-per-serving-supports-skin-cell-health-w-antioxidant-rich-vitamin-b3-niacin-500-mg-120-vegan-capsules",
      "title": "Heliocare Advanced Niacin B3 Supplement: Fernblock PLE Extract 240mg Per Serving - Supports Skin Cell Health W/Antioxidant Rich Vitamin B3 Niacin 500 mg - 120 Vegan Capsules",
      "vendor": "Heliocare",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Heliocare_Advanced_Niacin_B3_Supplement.png?v=1777846327",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "heliocare",
        "advanced",
        "niacin",
        "supplement",
        "fernblock",
        "ple",
        "extract",
        "240mg",
        "per",
        "serving",
        "supports",
        "skin",
        "cell",
        "health",
        "antioxidant",
        "rich",
        "vitamin",
        "niacin",
        "500",
        "120",
        "vegan",
        "capsules",
        "heliocare"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170908328133",
      "vsf_explanation": "Fernblock PLE (Polypodium leucotomos) 240 mg + niacinamide 500 mg. Fernblock has dermatology RCTs for UV-induced skin damage (Middelkamp-Hup 2004); nicotinamide reduced non-melanoma skin cancer in the ONTRAC trial (Chen 2015). Standard, dose-transparent.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "preservision-areds-2-eye-vitamins-210-soft-gels",
      "title": "PreserVision AREDS 2 Eye Vitamins,  210 Soft gels",
      "vendor": "PreserVision",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Bottle_of_Preservision_AREDS_2_supplement_on_a_white_background.jpg?v=1777846366",
      "score": 77,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "preservision",
        "areds",
        "eye",
        "vitamins",
        "210",
        "soft",
        "gels",
        "preservision"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 85,
        "formulation": 80,
        "manufacturing": 68,
        "safety": 78,
        "transparency": 80,
        "sustainability": 55
      },
      "price": 59.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170908688581",
      "vsf_explanation": "PreserVision AREDS 2 mirrors exactly the National Eye Institute's AREDS2 trial formula — lutein 10mg, zeaxanthin 2mg, vitamin C 500mg, vitamin E 400 IU, zinc 80mg, copper 2mg — the only OTC supplement in this batch built on a landmark RCT (AREDS2 Research Group, JAMA 2013) showing 18% reduced progression to advanced AMD in a specific patient subgroup. Bausch+Lomb quality baseline is real; below Elite only for lack of NSF/USP certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "king-maker-pack-of-1-13-in-1-anabolic-supplement-for-men-to-increase-stamina-lean-muscle-growth-recovery-n-o-booster-with-tongkat-ali-lj100-120-capsules",
      "title": "King Maker Pack of 1, 13-in-1 Anabolic Supplement for Men to Increase Stamina, Lean Muscle Growth & Recovery, N.O. Booster with Tongkat Ali (LJ100), 120 Capsules",
      "vendor": "King Maker",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/King_Maker_pack_of_1_9b86b34b-85cf-4e07-be17-af0056c9f269.png?v=1777846367",
      "score": 36,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "king",
        "maker",
        "pack",
        "anabolic",
        "supplement",
        "for",
        "men",
        "increase",
        "stamina",
        "lean",
        "muscle",
        "growth",
        "recovery",
        "booster",
        "with",
        "tongkat",
        "ali",
        "lj100",
        "120",
        "capsules",
        "king",
        "maker"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 40,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 35,
        "sustainability": 35
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170908524741",
      "vsf_explanation": "Duplicate listing under a different reseller. Same concerns apply: turkesterone hype without solid human RCTs, per-ingredient doses hidden, and sweeping male-enhancement/anabolic claims.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "skinceuticals-c-e-ferulic-1-fl-oz-antioxidant-serum",
      "title": "SkinCeuticals C E Ferulic – 1 fl oz Antioxidant Serum",
      "vendor": "SkinCeuticals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SkinCeuticals_C_E_Ferulic_1_fl_oz_Antioxidant_Serum.jpg?v=1777846366",
      "score": 77,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "skinceuticals",
        "ferulic",
        "antioxidant",
        "serum",
        "skinceuticals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 80,
        "manufacturing": 82,
        "safety": 78,
        "transparency": 78,
        "sustainability": 55
      },
      "price": 180,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170908655813",
      "vsf_explanation": "Duke-patented 15% L-ascorbic acid + 1% α-tocopherol + 0.5% ferulic acid antioxidant serum — the reference product in topical antioxidant literature (Lin JY J Invest Dermatol 2005 — 8× photoprotection vs vehicle). Full percentage disclosure, pH-controlled stable formulation, dermatologist-standard. Vendor mislabeled Nutrafol.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ortho-molecular-methyl-cpg-cardiovascular-health-60-capsules",
      "title": "Ortho Molecular Methyl CpG Cardiovascular Health 60 capsules",
      "vendor": "Ortho Molecular",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/imgi_47_145-60-methyl-cpg_details.tmb-media470.png?v=1777846366",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ortho",
        "molecular",
        "methyl",
        "cpg",
        "cardiovascular",
        "health",
        "capsules",
        "ortho",
        "molecular"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 72,
        "manufacturing": 68,
        "safety": 70,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170908721349",
      "vsf_explanation": "Ortho Molecular is a practitioner-channel brand with strong QA. Methyl CpG targets homocysteine via methylated B-vitamins (methyl-B12, methylfolate) plus TMG — the evidence for lowering homocysteine at these doses is strong (Wald 2002, HOPE-2 for stroke). Whether homocysteine-lowering translates to CV outcomes is contested, hence the score sits mid-Standard rather than Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nordic-naturals-ultimate-omega-2x-high-potency-fish-oil-2150-mg-epa-dha-lemon-flavor-120-softgels-1",
      "title": "Nordic Naturals Ultimate Omega 2X – High-Potency Fish Oil | 2150 mg EPA & DHA | Lemon Flavor, 120 Softgels",
      "vendor": "Nordic Naturals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/61SHf0A_ENL_6db6ed0d-5f83-495a-a93f-8b43f2bb7ed8.jpg?v=1777846367",
      "score": 87,
      "tier": "elite",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nordic",
        "naturals",
        "ultimate",
        "omega",
        "high",
        "potency",
        "fish",
        "oil",
        "2150",
        "epa",
        "dha",
        "lemon",
        "flavor",
        "120",
        "softgels",
        "nordic",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart",
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 88,
        "formulation": 88,
        "manufacturing": 90,
        "safety": 85,
        "transparency": 85,
        "sustainability": 78
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170908754117",
      "vsf_explanation": "2150 mg combined EPA + DHA per two-softgel serving in re-esterified triglyceride form (superior bioavailability vs ethyl-ester per Dyerberg Prostaglandins Leukot Essent Fatty Acids 2010). Nordic Naturals is IFOS 5-star certified, non-GMO, wild-caught, Friend of the Sea sustainability audited. Anchor Elite reference brand. Vendor field mislabeled Nutrafol.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natural-prostate-support-supplement-non-gmo-vegan-gluten-free",
      "title": "Natural Prostate Support Supplement - Non-GMO, Vegan, Gluten-Free",
      "vendor": "Vyvata",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Prostacar_Natural_Prostate_Support.jpg?v=1777846371",
      "score": 48,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "natural",
        "prostate",
        "support",
        "supplement",
        "non",
        "gmo",
        "vegan",
        "gluten",
        "free",
        "vyvata"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170908950725",
      "vsf_explanation": "'Prostacor' — saw palmetto + beta-sitosterol + nettle + pumpkin seed + lycopene, no doses. Saw palmetto for BPH RCTs (Bent 2006, STEP trial) are actually negative at 320 mg/day; formula makes disease claims about urgency/flow without dose transparency. Rejected.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nugenix-total-t-energy-and-vitality-booster-for-men-90-capsules",
      "title": "Nugenix Total T – Energy and Vitality Booster for Men – 90 Capsules",
      "vendor": "Nugenix",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71m7EkpGCjL_38862867-b745-4b80-91d5-af4dabc14713.jpg?v=1777846372",
      "score": 55,
      "tier": "standard",
      "certifications": [
        "NSF Certified"
      ],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "nugenix",
        "total",
        "energy",
        "and",
        "vitality",
        "booster",
        "for",
        "men",
        "capsules",
        "nugenix"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 65,
        "safety": 60,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 54.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170908983493",
      "vsf_explanation": "Description body is CSS markup, but SKU is the same Nugenix Total-T formulation (Tesnor + elevATP + boron) sold in a different pack. Same NSF-cGMP manufacture and branded-ingredient formulation as the sibling SKUs.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "instaflex-joint-support-supplement-clinically-studied-joint-relief-blend-of-glucosamine-msm-white-willow-turmeric-ginger-cayenne-hyaluronic-acid-90-capsules",
      "title": "Instaflex Joint Support Supplement - Clinically Studied Joint Relief Blend of Glucosamine, MSM, White Willow, Turmeric, Ginger, Cayenne, Hyaluronic Acid - 90 Capsules",
      "vendor": "Instaflex",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71133fMuOtL_f8fa259d-17ad-4935-a833-71814d61dad4.jpg?v=1777846372",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "instaflex",
        "joint",
        "support",
        "supplement",
        "clinically",
        "studied",
        "joint",
        "relief",
        "blend",
        "glucosamine",
        "msm",
        "white",
        "willow",
        "turmeric",
        "ginger",
        "cayenne",
        "hyaluronic",
        "acid",
        "capsules",
        "instaflex"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 25,
        "sustainability": 30
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170909049029",
      "vsf_explanation": "Instaflex uses a multi-ingredient blend (glucosamine, MSM, white willow, turmeric, ginger, cayenne, HA) with claims of being 'clinically studied' but the underlying trial (Reginster 2010-style glucosamine work) tested single ingredients at specific doses. No per-ingredient milligram disclosure in the listing.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "viviscal-hair-growth-supplements-for-women-for-thicker-fuller-hair-180-tablets",
      "title": "Viviscal Hair Growth Supplements For Women For Thicker, Fuller Hair 180 Tablets",
      "vendor": "Viviscal",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71Fvqi4zDzL_4131e007-ea35-4495-8f82-f75129efc730.jpg?v=1777846372",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "viviscal",
        "hair",
        "growth",
        "supplements",
        "for",
        "women",
        "for",
        "thicker",
        "fuller",
        "hair",
        "180",
        "tablets",
        "viviscal"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 58,
        "manufacturing": 50,
        "safety": 65,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 64.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170909343941",
      "vsf_explanation": "Viviscal's AminoMar C marine-collagen complex has multiple RCTs on female pattern shedding (Ablon 2015, Glynis 2012) that showed measurable increases in terminal hair count. The whole-formula RCT design is a plus, but AminoMar itself is a proprietary complex that hides its component doses. Marine sourcing is a modest sustainability minus.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "just-thrive-probiotic-antioxidant",
      "title": "Just Thrive Probiotic & Antioxidant",
      "vendor": "Just Thrive",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71n8imq6zaL.jpg?v=1777846372",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "just",
        "thrive",
        "probiotic",
        "antioxidant",
        "just",
        "thrive"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 68,
        "manufacturing": 65,
        "safety": 72,
        "transparency": 62,
        "sustainability": 45
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170909147333",
      "vsf_explanation": "Just Thrive is a well-known spore-based probiotic featuring Bacillus indicus HU36 which produces carotenoid antioxidants in the gut (Marotta et al. 2019). Bacillus spores survive gastric acid intact — the key delivery problem for lactic-acid probiotics. Vendor field is mislabeled ('Nutrafol') but the product itself has verifiable brand provenance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "spore-based-probiotic-for-women-men-shelf-stable-digestive-support-travel-friendly",
      "title": "Spore-Based Probiotic for Women & Men | Shelf-Stable Digestive Support | Travel-Friendly",
      "vendor": "Vyvata",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/61wISTbyUWL_201bcd23-7ac6-4a1e-952d-7442c81a5278.jpg?v=1777846372",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "spore",
        "based",
        "probiotic",
        "for",
        "women",
        "men",
        "shelf",
        "stable",
        "digestive",
        "support",
        "travel",
        "friendly",
        "vyvata"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 70,
        "transparency": 50,
        "sustainability": 40
      },
      "price": 64.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170909442245",
      "vsf_explanation": "Five Bacillus strains (subtilis, indicus, licheniformis, clausii, coagulans) mirroring the MegaSporeBiotic template. DNA-verification and shelf-stability disclosed but total CFU and per-strain counts are not in the excerpt. Vendor field 'Nutrafol' is mislabeled.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bioma-probiotics-3-in-1-gut-health-formula-digestive-support-60-capsules",
      "title": "Bioma Probiotics 3-in-1 Gut Health Formula – Digestive Support | 60 Capsules",
      "vendor": "Bioma",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/812hkTBHxCL.jpg?v=1777846372",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bioma",
        "probiotics",
        "gut",
        "health",
        "formula",
        "digestive",
        "support",
        "capsules",
        "bioma"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170909376709",
      "vsf_explanation": "Same Bioma 3-in-1 (probiotic + XOS prebiotic + tributyrin postbiotic) as the 60-cap listing, sold here as a 180-cap/3-bottle set. Species named but no strain IDs or CFU counts — probiotic efficacy is strain-specific (Ford Am J Gastroenterol 2018). Vendor mislabeled Nutrafol.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "immuno-150-immune-support-supplement-packed-with-70-plant-minerals-13-essential-vitamins-and-68-additional-nutrients-150-vegetable-capsules-immune-boost-for-all-age-groups",
      "title": "Immuno 150 Immune Support Supplement, Packed with 70 Plant Minerals, 13 Essential Vitamins and 68 Additional Nutrients-150 Vegetable Capsules- Immune Boost for All Age Groups",
      "vendor": "Immuno 150",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/81SW6dRHduL._AC_SL1500.jpg?v=1777846372",
      "score": 31,
      "tier": "rejected",
      "certifications": [
        "USDA Organic",
        "Kosher"
      ],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "immuno",
        "150",
        "immune",
        "support",
        "supplement",
        "packed",
        "with",
        "plant",
        "minerals",
        "essential",
        "vitamins",
        "and",
        "additional",
        "nutrients",
        "150",
        "vegetable",
        "capsules",
        "immune",
        "boost",
        "for",
        "all",
        "age",
        "groups",
        "immuno",
        "150"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 25,
        "manufacturing": 35,
        "safety": 50,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 59.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170909212869",
      "vsf_explanation": "Kitchen-sink formula claiming '70 plant minerals + 13 vitamins + 68 nutrients' in 5 caps — arithmetic makes it impossible to reach therapeutic doses for anything meaningful. Trace-mineral 'ORAC 42,000+' marketing is not a validated health metric. USDA Organic is a plus but does not solve the sub-therapeutic dosing problem.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "this-beauty-of-joseon-relief-sun-facial-sunscreen-offers-superior-protection",
      "title": "This Beauty of Joseon Relief Sun Facial Sunscreen  Offers Superior Protection",
      "vendor": "Beauty of Joseon",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cacf1d8c374c4b559995d4d64164d3a5_tplv-omjb5zjo8w-origin-jpeg_1.jpg?v=1777846372",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "this",
        "beauty",
        "joseon",
        "relief",
        "sun",
        "facial",
        "sunscreen",
        "offers",
        "superior",
        "protection",
        "beauty",
        "joseon"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170909114565",
      "vsf_explanation": "Korean SPF 40 PA++++ chemical sunscreen with niacinamide and rice extract — widely tested by third-party consumer labs (Incidecoder, LabMuffin) with confirmed broad-spectrum protection. Non-comedogenic, no white-cast formulation is one of the most-recommended daily sunscreens by dermatology creators. Vendor mislabeled Nutrafol.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lions-mane-mushroom",
      "title": "Lion's Mane Mushroom",
      "vendor": "FORTCORE.US",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1755795144511-generated-label-image-0.jpg?v=1777846388",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lion",
        "mane",
        "mushroom",
        "fortcore"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 48,
        "safety": 58,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 48.33,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170909769925",
      "vsf_explanation": "Organic Lion's Mane fruiting body + mycelium standardized to 40% polysaccharides (400 mg) per serving. Better than most because standardization and fruiting-body content are disclosed (fruiting body is the RCT-supported form — Mori 2009 showed cognition improvement at 3 g/day). Sub-clinical polysaccharide dose here (400 mg) caps evidence score; no third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liver-support",
      "title": "Liver Support",
      "vendor": "FORTCORE.US",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/FRONT-Bienesta-USA-Liver-Support-60ct-V3R0.png?v=1777846388",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liver",
        "support",
        "fortcore"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 40,
        "manufacturing": 48,
        "safety": 55,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 42.88,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170909737157",
      "vsf_explanation": "8-ingredient liver blend (turmeric, beetroot, dandelion, artichoke 5% cynarin, ginger, milk thistle, alfalfa, L-cysteine). Milk thistle silymarin RCTs (Ferenci 1989; Freedman 2011 SyNCH null in HCV) require 420-2100 mg/day silymarin; multi-herb 2-cap serving cannot deliver. Per-ingredient mg not disclosed.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "creatine-monohydrate",
      "title": "Creatine Monohydrate",
      "vendor": "FORTCORE.US",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/13_545234b3-5f86-4f62-a633-4899c0af4fdf.png?v=1777846393",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "creatine",
        "monohydrate",
        "fortcore"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 38.44,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170909835461",
      "vsf_explanation": "Creatine monohydrate is the gold standard: Kreider 2017 ISSN position stand documents strength and lean-mass gains at 3–5 g/day. Fort-Core notes sourcing from a 'global leader' (likely Creapure) which is a positive signal; unflavored powder with a single ingredient is a clean formulation. USA-manufactured.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "alpha-energy",
      "title": "Alpha Energy",
      "vendor": "FORTCORE.US",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1755793611625-generated-label-image-0.jpg?v=1777846393",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alpha",
        "energy",
        "fortcore"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 50,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 52.88,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170910032069",
      "vsf_explanation": "Men's vitality stack using magnesium oxide and zinc oxide (both poorly absorbed forms — Firoz 2001, Wegmüller 2014) plus tribulus, horny goat weed, longjack, saw palmetto, hawthorn, cissus. Tribulus does not raise testosterone in trained men (Neychev 2016 review). No per-ingredient mg dose is disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "digestive-enzyme-pro-blend",
      "title": "Digestive Enzyme Pro Blend",
      "vendor": "FORTCORE.US",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Digestive_Enzyme.png?v=1777846393",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "digestive",
        "enzyme",
        "pro",
        "blend",
        "fortcore"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 30,
        "manufacturing": 48,
        "safety": 50,
        "transparency": 30,
        "sustainability": 42
      },
      "price": 36.88,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170909900997",
      "vsf_explanation": "Uses Makzyme-Pro proprietary enzyme blend (fungal protease + L. acidophilus + L. casei + L. plantarum) plus bromelain, papain, fungal lipase, fungal lactase, alpha-galactosidase. No enzyme activity units (HUT, SAPU, DU, ALU) disclosed; enzyme efficacy is entirely unit-dependent.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "diet-drops-ultra-1-oz",
      "title": "Diet Drops Ultra 1 oz",
      "vendor": "FORTCORE.US",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1755796111398-generated-label-image-0.jpg?v=1777846393",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "diet",
        "drops",
        "ultra",
        "fortcore"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 42.88,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170909933765",
      "vsf_explanation": "Explicitly labels its actives as 'Proprietary Active-8 & African Mango Complex' — an unquantified 12+ ingredient blend. Claims to raise leptin and fix leptin resistance are not supported by the human literature on African mango or maca (Onakpoya 2013 African mango meta-analysis was small and industry-funded).",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "berberine",
      "title": "Berberine",
      "vendor": "FORTCORE.US",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/34.png?v=1777846393",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "berberine",
        "fortcore"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 44.88,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170909868229",
      "vsf_explanation": "Single-ingredient berberine HCl. Berberine at 500 mg 3x/day has decent glycemic and lipid data (Yin 2008 RCT vs metformin; Dong 2013 meta-analysis for lipids), but this listing does not disclose mg per capsule or serving. Without a confirmed dose we cannot assume it matches the effective 1500 mg/day protocol.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "omega-3-epa-180mg-dha-120mg",
      "title": "Omega-3 EPA 180mg + DHA 120mg",
      "vendor": "FORTCORE.US",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/21_2c57157c-e558-406d-aa9a-4616b07107f5.png?v=1777846393",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "omega",
        "epa",
        "180mg",
        "dha",
        "120mg",
        "fortcore"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 60,
        "sustainability": 35
      },
      "price": 43.88,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170909966533",
      "vsf_explanation": "Delivers 180 mg EPA + 120 mg DHA per softgel (300 mg total). Cardiovascular RCTs use 1,000-4,000 mg EPA+DHA/day (GISSI-Prevenzione 1999; REDUCE-IT 2019), so a single softgel is well below the therapeutic range even with the label's two-per-day suggestion (600 mg total). Ethyl-ester purity, oxidation (TOTOX), and sustainability certification are not disclosed.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "magnesium-glycinate",
      "title": "Magnesium Glycinate",
      "vendor": "FORTCORE.US",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/17_fc3c8782-0408-4590-b500-f18d4c8c9b78.png?v=1777846393",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "glycinate",
        "fortcore"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 48,
        "safety": 62,
        "transparency": 50,
        "sustainability": 48
      },
      "price": 39.87,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170909999301",
      "vsf_explanation": "Single-ingredient Mg glycinate at 2,500 mg glycinate per serving (elemental Mg not explicitly stated but implies ~275 mg from typical 11% ratio). Glycinate is well-tolerated bioavailable form (Uysal 2019); Abbasi 2012 RCT showed sleep benefit at 500 mg/day elemental. Missing third-party testing keeps below Beat Charge Mg (58) which discloses elemental content.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "i-love-health-ashwagandha-gummies-with-vitamin-d2-3000mg-ashwagandha-extract-10-1-stress-relief-sleep-support-mood-calm-strawberry-flavor-60-gummies-non-gmo-gluten-free-3rd-party-lab-tested-cgmp-certified",
      "title": "I Love Health Ashwagandha Gummies with Vitamin D2 - 3000mg Ashwagandha Extract (10:1) - Stress Relief, Sleep Support & Mood Calm - Strawberry Flavor - 60 Gummies - Non-GMO, Gluten-Free, 3rd Party Lab Tested, cGMP Certified",
      "vendor": "I Love Health Store",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_38ec6365-0fd3-4946-a6c1-deb365e3ed37.jpg?v=1777846416",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive",
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "love",
        "health",
        "ashwagandha",
        "gummies",
        "with",
        "vitamin",
        "3000mg",
        "ashwagandha",
        "extract",
        "stress",
        "relief",
        "sleep",
        "support",
        "mood",
        "calm",
        "strawberry",
        "flavor",
        "gummies",
        "non",
        "gmo",
        "gluten",
        "free",
        "3rd",
        "party",
        "lab",
        "tested",
        "cgmp",
        "certified",
        "love",
        "health",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170910851269",
      "vsf_explanation": "Label markets 3000mg 'root equivalent' from a 10:1 extract, meaning ~300mg actual extract - roughly the dose Chandrasekhar (2012) used with KSM-66 to lower serum cortisol. However the product doesn't specify KSM-66 or Sensoril withanolide content, uses sucralose, and gummy format limits potency verification. cGMP + Eurofins 3rd-party testing claim is a plus.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nmn-500mg-99-9-pure-nmn-supplement-boost-nad-levels-cellular-energy-healthy-aging-support-60-capsules-third-party-tested-nsf-cgmp-made-in-usa",
      "title": "NMN 500mg – 99.9% Pure NMN Supplement, Boost NAD+ Levels, Cellular Energy & Healthy Aging Support, 60 Capsules, Third-Party Tested, NSF cGMP, Made in USA",
      "vendor": "I Love Health Store",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/lQLPJxCbvFY_yxvNB9DNB9CwjSkM7Q3Y1iQI7fMuv9-bAA_2000_2000.png?v=1777846417",
      "score": 53,
      "tier": "standard",
      "certifications": [
        "NSF Certified"
      ],
      "goal_tags": [
        "longevity",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nmn",
        "500mg",
        "pure",
        "nmn",
        "supplement",
        "boost",
        "nad",
        "levels",
        "cellular",
        "energy",
        "healthy",
        "aging",
        "support",
        "capsules",
        "third",
        "party",
        "tested",
        "nsf",
        "cgmp",
        "made",
        "usa",
        "love",
        "health",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170910884037",
      "vsf_explanation": "500 mg NMN per capsule with 99.9% purity claim and NSF cGMP facility. NMN has emerging PK/PD data (Yoshino 2021) at 250–1000 mg/day. Amazon-style listing and unknown COA weaken confidence, but the dose sits within investigated ranges. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "i-love-health-sleep-gummy-melatonin-6mg-vitamin-b6-6mg-sleep-support-gummies-with-natural-blueberry-flavor-made-in-cgmp-facility",
      "title": "I Love Health Sleep Gummy | Melatonin 6mg + Vitamin B6 6mg Sleep Support Gummies with Natural Blueberry Flavor - Made in cGMP facility",
      "vendor": "I Love Health Store",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6391ace427ade714b70fb966024ae804_82fddf02-7180-4d7b-bf19-0e1cfe6cf763.jpg?v=1777846417",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "love",
        "health",
        "sleep",
        "gummy",
        "melatonin",
        "6mg",
        "vitamin",
        "6mg",
        "sleep",
        "support",
        "gummies",
        "with",
        "natural",
        "blueberry",
        "flavor",
        "made",
        "cgmp",
        "facility",
        "love",
        "health",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 35,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 55,
        "sustainability": 35
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170911047877",
      "vsf_explanation": "Melatonin at 6 mg is 6–20x the effective dose from Zhdanova 2001 (0.3–1 mg) and increases next-day grogginess without additional sleep benefit. Cohen 2023 (JAMA) found most gummies contain up to 347% of labeled melatonin. No third-party COA disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "first-liquid-choline-supplement-500mg-with-vitacholine®-usa-cognitive-health-award-winner-superior-absorption-supports-pregnancy-baby-brain-development-liver-cell-health-60-veggie-capsules",
      "title": "First Liquid Choline Supplement 500mg with VitaCholine® – USA Cognitive Health Award Winner – Superior Absorption – Supports Pregnancy, Baby Brain Development, Liver & Cell Health – 60 Veggie Capsules",
      "vendor": "I Love Health Store",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/11.jpg?v=1777846417",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "prenatal",
      "tokens": [
        "first",
        "liquid",
        "choline",
        "supplement",
        "500mg",
        "with",
        "vitacholine",
        "usa",
        "cognitive",
        "health",
        "award",
        "winner",
        "superior",
        "absorption",
        "supports",
        "pregnancy",
        "baby",
        "brain",
        "development",
        "liver",
        "cell",
        "health",
        "veggie",
        "capsules",
        "love",
        "health",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients",
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170911015109",
      "vsf_explanation": "500mg VitaCholine (Balchem branded choline bitartrate) per capsule is a therapeutic prenatal dose — Caudill 2018 (FASEB J) showed 480mg+/day choline in pregnancy improved offspring information-processing speed. Third-party tested, cGMP, FDA-registered facility. Weakness: 'liquid veggie capsule' novelty claim is marketing, absorption advantage over crystalline choline is unproven.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "i-love-health-vitamin-b1-500mg-with-benfotiamine-20mg-120-capsules-2-in-1-b-1-complex-enhanced-formula-fat-water-soluble-thiamine-b1-supplement-third-party-lab-tested-non-gmo-no-gluten-made-in-usa",
      "title": "I Love Health Vitamin B1 500mg with Benfotiamine 20mg, 120 Capsules – 2 in 1 B-1 Complex Enhanced Formula – Fat & Water Soluble Thiamine B1 Supplement – Third Party Lab Tested, Non-GMO, No Gluten, MADE In USA",
      "vendor": "I Love Health Store",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/I_HEALTH-_B1500mg_4a288182-3338-4bf4-b325-b74af9253db5.jpg?v=1777846417",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "love",
        "health",
        "vitamin",
        "500mg",
        "with",
        "benfotiamine",
        "20mg",
        "120",
        "capsules",
        "complex",
        "enhanced",
        "formula",
        "fat",
        "water",
        "soluble",
        "thiamine",
        "supplement",
        "third",
        "party",
        "lab",
        "tested",
        "non",
        "gmo",
        "gluten",
        "made",
        "usa",
        "love",
        "health",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170910982341",
      "vsf_explanation": "500mg thiamine HCl + 20mg benfotiamine. Benfotiamine at 300-600mg/day has evidence in diabetic neuropathy (Stracke 2008), but 20mg here is well below the studied therapeutic range. Thiamine 500mg is generous but water-soluble/self-limiting. cGMP facility, third-party tested claim, but generic Amazon-tier brand with no COA published.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "i-love-health-creatine-monohydrate-gummies-1500mg-per-serving-60-gummies-for-men-women-natural-orange-flavor-supports-muscle-growth-strength-and-recovery-vegan-non-gmo-gluten-free-made-in-cgmp-facility",
      "title": "I Love Health Creatine Monohydrate Gummies - 1500mg per Serving, 60 Gummies for Men & Women, Natural Orange Flavor, Supports Muscle Growth, Strength, and Recovery, Vegan, Non-GMO, Gluten-Free, Made in cGMP Facility",
      "vendor": "I Love Health Store",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/eaf05f2ac698e2a244b4de9885aa8c94.jpg?v=1777846417",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "love",
        "health",
        "creatine",
        "monohydrate",
        "gummies",
        "1500mg",
        "per",
        "serving",
        "gummies",
        "for",
        "men",
        "women",
        "natural",
        "orange",
        "flavor",
        "supports",
        "muscle",
        "growth",
        "strength",
        "and",
        "recovery",
        "vegan",
        "non",
        "gmo",
        "gluten",
        "free",
        "made",
        "cgmp",
        "facility",
        "love",
        "health",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids",
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 35,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170911178949",
      "vsf_explanation": "1.5g creatine per serving is well below the evidence-based 3–5g/day for muscle saturation (Kreider 2017 ISSN position). At $9.99 the price signals a placeholder dose. Users would need ~2–3 servings daily to match RCT protocols.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "i-love-health®-15-in-1-multivitamin-gummies-for-adults-kids-enhanced-formula-with-vitamin-a-c-d3-e-b12-zinc-magnesium-more-apple-flavor-60-gummies-per-bottle-made-in-cgmp-facility",
      "title": "I Love Health® 15-in-1 Multivitamin Gummies for Adults & Kids - Enhanced Formula with Vitamin A, C, D3, E, B12, Zinc, Magnesium & More - Apple Flavor - 60 Gummies per Bottle - Made in cGMP Facility",
      "vendor": "I Love Health Store",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_3e81cc13-dc5a-4fee-9850-dbf665e74124.jpg?v=1777846417",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "energy",
        "immune",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "youth_under_18",
      "tokens": [
        "love",
        "health",
        "multivitamin",
        "gummies",
        "for",
        "adults",
        "kids",
        "enhanced",
        "formula",
        "with",
        "vitamin",
        "b12",
        "zinc",
        "magnesium",
        "more",
        "apple",
        "flavor",
        "gummies",
        "per",
        "bottle",
        "made",
        "cgmp",
        "facility",
        "love",
        "health",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170911244485",
      "vsf_explanation": "Gummy multivitamins inherently under-deliver minerals (magnesium, zinc) because the pectin/sugar matrix caps mass per serving - meta-analyses (Ekwaru 2014 on D3 gummies) show sub-label potency. Listing shows only ingredient names, no mcg/mg per gummy in the visible copy. Bundling adults + kids on a single dose is a formulation red flag.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "i-love-health-nmn-5-in-1-complex-plus-for-women-men-w-nac-alpha-lipoic-acid-nmn-coenzyme-q10-resveratrol-60-capsules-supports-energy-anti-aging-antioxidant-cellular-health",
      "title": "I Love Health NMN 5-In-1 Complex Plus+ for Women & Men W/ NAC, Alpha Lipoic Acid, NMN, Coenzyme Q10, Resveratrol | 60 Capsules | Supports Energy,Anti-Aging, Antioxidant & Cellular Health",
      "vendor": "I Love Health Store",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b58ce7b99582c961375527c3c6b27ebb.png?v=1777846417",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy",
        "longevity",
        "inflammation"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "love",
        "health",
        "nmn",
        "complex",
        "plus",
        "for",
        "women",
        "men",
        "nac",
        "alpha",
        "lipoic",
        "acid",
        "nmn",
        "coenzyme",
        "q10",
        "resveratrol",
        "capsules",
        "supports",
        "energy",
        "anti",
        "aging",
        "antioxidant",
        "cellular",
        "health",
        "love",
        "health",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular",
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 35,
        "manufacturing": 52,
        "safety": 60,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170911277253",
      "vsf_explanation": "NMN 120mg (Yoshino 2021 used 250mg), NAC 72mg (typical dose 600mg), CoQ10 24mg (RCT dose 100–300mg), resveratrol 12mg (typical dose 150–500mg), ALA 100mg. Every ingredient dosed at fractions of clinical minimums — a classic 'label-decoration' stack.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "nad-supplement-300mg-with-nr-150mg-nmn-alternative-resveratrol-like-benefits-6000mg-green-tea-extract-astaxanthin-anti-aging-cellular-energy-support-60-capsules-made-in-usa",
      "title": "NAD+ Supplement 300mg with NR 150mg | NMN Alternative & Resveratrol-Like Benefits | 6000mg Green Tea Extract + Astaxanthin | Anti-Aging Cellular Energy Support | 60 Capsules, Made in USA",
      "vendor": "I Love Health Store",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_ce618146-7144-4914-beed-dded3b608afc.jpg?v=1777846417",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nad",
        "supplement",
        "300mg",
        "with",
        "150mg",
        "nmn",
        "alternative",
        "resveratrol",
        "like",
        "benefits",
        "6000mg",
        "green",
        "tea",
        "extract",
        "astaxanthin",
        "anti",
        "aging",
        "cellular",
        "energy",
        "support",
        "capsules",
        "made",
        "usa",
        "love",
        "health",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170911080645",
      "vsf_explanation": "Oral NAD+ is poorly bioavailable — it is cleaved in the gut and does not intact-cross membranes; Airhart 2017 and Martens 2018 established NR (nicotinamide riboside) as the viable precursor. Labelling 300mg 'NAD+' as the headline is misleading. NR 150mg is sub-therapeutic vs Elysium/Tru Niagen clinical dose of 300-1000mg (Conze 2019).",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "vitamin-d3-10000-iu-with-k2-mk-7-supplement-90-softgels-non-gmo-gluten-free-supports-bone-heart-immune-health-enhanced-absorption-made-in-usa",
      "title": "Vitamin D3 10000 IU with K2 (MK-7) Supplement – 90 Softgels – Non-GMO, Gluten-Free – Supports Bone, Heart & Immune Health – Enhanced Absorption – Made in USA",
      "vendor": "I Love Health Store",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/D3_K210000IU-ILOVEHEALTH.png?v=1777846417",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "10000",
        "with",
        "supplement",
        "softgels",
        "non",
        "gmo",
        "gluten",
        "free",
        "supports",
        "bone",
        "heart",
        "immune",
        "health",
        "enhanced",
        "absorption",
        "made",
        "usa",
        "love",
        "health",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients",
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 42,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170911310021",
      "vsf_explanation": "D3 (10,000 IU) + K2 (MK-7 200mcg) is the canonical bone/CV pairing (Rheaume-Bleue), but 10,000 IU/day is at the Endocrine Society upper daily limit and above IOM UL of 4,000 IU without testing serum 25-OH-D (Holick 2011). Real formula, but the dose is a safety concern for unsupervised daily use.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "i-love-health-lion-s-mane-mushroom-extract-1000mg-60-gummies-supports-cognitive-function-mental-clarity-natural-brain-health-supplement",
      "title": "I Love Health Lion’s Mane Mushroom Extract 1000mg – 60 Gummies | Supports Cognitive Function & Mental Clarity | Natural Brain Health Supplement",
      "vendor": "I Love Health Store",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_369a1b5a-c555-459c-afcb-3e592bda8180.jpg?v=1777846417",
      "score": 41,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "love",
        "health",
        "lion",
        "mane",
        "mushroom",
        "extract",
        "1000mg",
        "gummies",
        "supports",
        "cognitive",
        "function",
        "mental",
        "clarity",
        "natural",
        "brain",
        "health",
        "supplement",
        "love",
        "health",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 40,
        "sustainability": 35
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170911342789",
      "vsf_explanation": "1000mg Lion's Mane 'extract' per 2-gummy serving with no dual-extraction, fruiting-body vs mycelium disclosure, or beta-glucan quantification. Gummy format introduces sugar and pectin fillers. Anonymous storefront brand with no COAs. Cognitive claims exceed the small human evidence base (Mori et al. 2009).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "coq10-400mg-softgels-90-count-supports-heart-health-energy-cellular-function-soy-based-coq10-supplement-by-i-love-health-45-servings",
      "title": "CoQ10 400mg Softgels - 90 Count | Supports Heart Health, Energy & Cellular Function | Soy-Based CoQ10 Supplement by I Love Health | 45 Servings",
      "vendor": "I Love Health Store",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/COQ10400mg-ILOVEHEALTH_d6220c71-cbfa-4daa-9204-572025dceb92.png?v=1777846422",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coq10",
        "400mg",
        "softgels",
        "count",
        "supports",
        "heart",
        "health",
        "energy",
        "cellular",
        "function",
        "soy",
        "based",
        "coq10",
        "supplement",
        "love",
        "health",
        "servings",
        "love",
        "health",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart",
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170911473861",
      "vsf_explanation": "400mg CoQ10 is well within the RCT range (Mortensen 2014 Q-SYMBIO used 300mg for HF; Rosenfeldt 2007 for BP). Ubiquinone form (not ubiquinol) at $19.99 is fair. No third-party COA mentioned.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "5-in-1-magnesium-complex-vitamin-b6-supplement-420mg-high-absorption-magnesium-supplement-for-sleep-nerves-muscles-bones-120-capsules",
      "title": "5-in-1 Magnesium Complex + Vitamin B6 Supplement - 420MG - High Absorption Magnesium Supplement for Sleep, Nerves, Muscles, Bones, 120 Capsules",
      "vendor": "I Love Health Store",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Image_20241008163211.jpg?v=1777846422",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "complex",
        "vitamin",
        "supplement",
        "420mg",
        "high",
        "absorption",
        "magnesium",
        "supplement",
        "for",
        "sleep",
        "nerves",
        "muscles",
        "bones",
        "120",
        "capsules",
        "love",
        "health",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 40,
        "sustainability": 35
      },
      "price": 19.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170911506629",
      "vsf_explanation": "5 forms of magnesium totaling 420mg + 30mg B6 (1765% DV — well above the 100mg tolerable upper intake for pyridoxine, chronic use of which risks sensory neuropathy per Schaumburg et al. 1983). Per-form magnesium doses not disclosed. Generic storefront brand with no third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "i-love-health-magnesium-citrate-400mg-heart-health-support-100-vegetarian-tablets",
      "title": "I Love Health Magnesium Citrate, 400mg, Heart Health Support, 100 vegetarian Tablets",
      "vendor": "I Love Health Store",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8d3fb741647998792438c2e94b70d0c8.jpg?v=1777846422",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "love",
        "health",
        "magnesium",
        "citrate",
        "400mg",
        "heart",
        "health",
        "support",
        "100",
        "vegetarian",
        "tablets",
        "love",
        "health",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients",
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 17.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170911572165",
      "vsf_explanation": "Magnesium citrate 400mg is a well-studied bioavailable form (Walker 2003 Magnes Res: citrate > oxide absorption) and 400mg/day approximates the RDA. cGMP + third-party tested (self-reported). Weakness: title says 400mg but body copy says 500mg — labelling inconsistency; no elemental vs salt disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "benfotiamine-600mg-plus-20mg-vitamin-b1-120-veggie-capsules-made-in-usa-3rd-party-tested-fat-soluble-vitamin-b1-thiamine-supplement-non-gmo-gluten-free",
      "title": "Benfotiamine 600mg Plus 20mg Vitamin B1 | 120 Veggie Capsules | Made in USA | 3rd Party Tested | Fat Soluble Vitamin B1 Thiamine Supplement | Non-GMO | Gluten Free",
      "vendor": "I Love Health Store",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Image_20240919144908.jpg?v=1777846422",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "benfotiamine",
        "600mg",
        "plus",
        "20mg",
        "vitamin",
        "120",
        "veggie",
        "capsules",
        "made",
        "usa",
        "3rd",
        "party",
        "tested",
        "fat",
        "soluble",
        "vitamin",
        "thiamine",
        "supplement",
        "non",
        "gmo",
        "gluten",
        "free",
        "love",
        "health",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170911539397",
      "vsf_explanation": "600 mg benfotiamine + 20 mg thiamine. Benfotiamine's diabetic neuropathy RCTs (Stracke 2008; Winkler 1999) use ~300–600 mg/day. Dose is right for the indication and 3rd-party tested. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "i-love-health-turmeric-drink-mix-with-350mg-cuminup60®-3000mg-curcuminoids-500mg-vitamin-c-100mg-blood-orange-elderberry-powder-14x-bioavailability-immune-support-anti-inflammatory-antioxidant-15-packets-sugar-free-gluten-free-vegetarian",
      "title": "I Love Health Turmeric Drink Mix with 350mg CuminUP60® (3000mg Curcuminoids), 500mg Vitamin C, 100mg Blood Orange & Elderberry Powder | 14X Bioavailability, Immune Support, Anti-Inflammatory, Antioxidant | 15 Packets, Sugar-Free, Gluten-Free, Vegetarian",
      "vendor": "I Love Health Store",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6391ace427ade714b70fb966024ae804.jpg?v=1777846422",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "love",
        "health",
        "turmeric",
        "drink",
        "mix",
        "with",
        "350mg",
        "cuminup60",
        "3000mg",
        "curcuminoids",
        "500mg",
        "vitamin",
        "100mg",
        "blood",
        "orange",
        "elderberry",
        "powder",
        "14x",
        "bioavailability",
        "immune",
        "support",
        "anti",
        "inflammatory",
        "antioxidant",
        "packets",
        "sugar",
        "free",
        "gluten",
        "free",
        "vegetarian",
        "love",
        "health",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 12.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170911604933",
      "vsf_explanation": "CuminUP60 is a branded 60%-curcuminoid extract; the 350mg dose plus vitamin C 500mg is within the range Panahi (2017) meta showed CRP-lowering for enhanced-bioavailability curcumin. The 14X bioavailability figure is CuminUP60 marketing rather than independent data, and sucralose sweetener plus elderberry blend (100mg is sub-therapeutic for elderberry immune claims - Tiralongo 2016 used 300mg) drag transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gobhb",
      "title": "goBHB",
      "vendor": "CleanForm Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Go_BHB_Front.png?v=1777846463",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gobhb",
        "cleanform",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic",
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46926876344517",
      "vsf_explanation": "Beta-hydroxybutyrate mineral salts (Ca/Mg/Na/K BHB). Exogenous ketones do raise circulating BHB and can support endurance in specific contexts (Stubbs 2017 Front Physiol), but broad energy/focus claims are stronger than the evidence. goBHB is a well-known GRAS ingredient. Per-mineral BHB mg breakdown would help.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "iron-feather-collagen",
      "title": "Iron Feather Collagen",
      "vendor": "CleanForm Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Collagen_3_Flavours_fd94eb24-aecd-496b-8c7b-29793f1ad391.png?v=1777846462",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "iron",
        "feather",
        "collagen",
        "cleanform",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective",
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170911801541",
      "vsf_explanation": "10g multi-source collagen (bovine, fish, chicken bone, eggshell membrane) + 50mg vitamin C cofactor. Multi-collagen matrices are marketing-driven — most collagen RCTs use single-source hydrolysates (Zdzieblik 2015 used 15g). Ratio of each source isn't disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pureblood™-by-cleanform-nutrition",
      "title": "PureBlood™ by CleanForm Nutrition",
      "vendor": "CleanForm Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Pure_Blood_h_d7a1c667-008f-4638-9d53-2eabb21c2cdd.png?v=1777846468",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pureblood",
        "cleanform",
        "nutrition",
        "cleanform",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170911932613",
      "vsf_explanation": "K2VITAL MK-7, citrus bergamot, and Nattiase nattokinase are each branded, characterized ingredients. MK-7 supports arterial calcium partitioning (Knapen 2015 Thromb Haemost); bergamot lowers LDL modestly (Mollace 2011); nattokinase has fibrinolytic activity data (Kurosawa 2015). Doses per capsule not published in the description.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cleanform-nutrition-nulla-protein-bar-2-flavors-box-of-12",
      "title": "CleanForm Nutrition Nulla Protein Bar - 2 Flavors - Box of 12",
      "vendor": "CleanForm Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Bars.png?v=1777846477",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cleanform",
        "nutrition",
        "nulla",
        "protein",
        "bar",
        "flavors",
        "box",
        "cleanform",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 68,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 60,
        "sustainability": 48
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170912063685",
      "vsf_explanation": "20g whey protein + 12g fiber, low-GI, seed-oil-free. Solid clean-label positioning; whey protein has robust evidence for muscle synthesis (Morton 2018 meta). Deducted for lack of third-party testing and no dairy/allergen amino acid profile disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "matcha-mushroom-latte",
      "title": "Matcha Mushroom Latte",
      "vendor": "Crane Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Matcha_LeftStanding_e7483083-e2f0-4b7b-b87f-646fbdc00803.jpg?v=1777846587",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "matcha",
        "mushroom",
        "latte",
        "crane",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics",
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170913308869",
      "vsf_explanation": "Lion's Mane, Cordyceps, Reishi, Meshimakobu, and Shiitake are lumped together with no per-mushroom mg and no fruiting-body vs mycelium disclosure. Mori (2009) used 3000mg/day fruiting-body Lion's Mane for cognitive endpoints - a mushroom-latte serving cannot deliver that. No beta-glucan spec published.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "zen-energy-green-tea-coffee",
      "title": "Zen Energy Green Tea & Coffee",
      "vendor": "Crane Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ZenBox-05withStickVert_531b0d9e-3f46-44f1-98d2-eca872554c9a.jpg?v=1777846587",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zen",
        "energy",
        "green",
        "tea",
        "coffee",
        "crane",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170913538245",
      "vsf_explanation": "Sachet delivers 53mg caffeine + 180mg catechins + 30mg chlorogenic acid, doses are stated but the label explicitly calls the tea/coffee ratio a 'proprietary blend'. Green tea catechins at 180mg is a modest dose vs the 400-600mg EGCG in most metabolic studies (Hursel 2011 meta).",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "wellness-bundle",
      "title": "Wellness Bundle",
      "vendor": "Crane Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/nattoandkelpcrane.jpg?v=1777846586",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wellness",
        "bundle",
        "crane",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart",
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 40,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 62.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170913636549",
      "vsf_explanation": "Bundle of a nattokinase-GABA cardiovascular blend + oceanic iodine. Nattokinase 2000 FU has small blood-flow trials (Kurosawa 2015) but no doses disclosed. Iodine bundled with a cardiovascular product risks thyroid over-supplementation; no iodine µg dose stated.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "radiant-renew-travel-size-pouches",
      "title": "Radiant Renew Travel Size Pouches",
      "vendor": "Crane Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/RadiantSachet-01Front.jpg?v=1777846587",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "radiant",
        "renew",
        "travel",
        "size",
        "pouches",
        "crane",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 7.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170913341637",
      "vsf_explanation": "Marine collagen peptides + hyaluronic acid + biotin + vitamin C + coix seed. Marine collagen has modest skin-hydration/wrinkle evidence (Choi 2019 meta), and 2.5-10 g/day is typical; travel sachet dose is not disclosed. Currently out of stock. Standard for a plausible but unverified formula.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "matcha-glow-bundle",
      "title": "Matcha & Glow Bundle",
      "vendor": "Crane Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Matcha_Glow_Bundle.jpg?v=1777846586",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "matcha",
        "glow",
        "bundle",
        "crane",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty",
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 84.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170913669317",
      "vsf_explanation": "Bundle of the Matcha Mushroom Latte plus Coix Seed 'Tone and Glow' powder; inherits the parent latte's undisclosed 5-mushroom blend. Coix (Job's tears) has traditional-use only evidence and the beauty claim is unsupported by RCTs.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "tone-and-glow-coix-seed-extract-powder",
      "title": "Tone and Glow Coix Seed Extract Powder",
      "vendor": "Crane Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Tone_Bag_01_-_Front_d1eed6e5-da50-4fea-9a78-4469f92f8dc0.jpg?v=1777846587",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tone",
        "and",
        "glow",
        "coix",
        "seed",
        "extract",
        "powder",
        "crane",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 44.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170913439941",
      "vsf_explanation": "4g single-ingredient coix seed (Job's tears) extract per serving; dose transparent. Traditional Japanese/Asian use for skin, and small trials (Chen 2011) show mild anti-inflammatory activity, but no RCT support for the '271 vitamins' claim or elasticity/hydration endpoints. Single-ingredient purity is a positive.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "electrolyte-hydration-powder",
      "title": "Electrolyte Hydration Powder",
      "vendor": "Crane Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Electrolyte_LeftStanding.jpg?v=1777846586",
      "score": 49,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "electrolyte",
        "hydration",
        "powder",
        "crane",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 30,
        "sustainability": 50
      },
      "price": 12.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170913702085",
      "vsf_explanation": "Standard sodium/potassium/calcium/magnesium blend, but the listing gives no mg per electrolyte. Sports-hydration research (Baker 2020) requires roughly 500-1000mg sodium/serving to matter for athletes; without disclosure buyers can't verify. No 3rd-party test or manufacturing certification stated.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "probiotic-c-jelly-sticks",
      "title": "Probiotic-C Jelly Sticks",
      "vendor": "Crane Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ProbioticBox-05withStickVert.jpg?v=1777846587",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "probiotic",
        "jelly",
        "sticks",
        "crane",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 30,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 12.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170913734853",
      "vsf_explanation": "Product lists '10 billion heat-sterilized Bifidobacterium longum' — heat-sterilized bacteria are dead and cannot colonize; postbiotic effects exist (Piqué 2019) but the '10 billion CFU' probiotic framing is misleading because CFU by definition requires viability. 100mg vitamin C is trivial.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "beauty-bundle",
      "title": "Beauty Bundle",
      "vendor": "Crane Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CraneBeautyBundle-beautyfromwithinritualswithcoixseedandcollagen.jpg?v=1777846586",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beauty",
        "bundle",
        "crane",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 38,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 84.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170913767621",
      "vsf_explanation": "Marine collagen + coix seed + hyaluronic acid + biotin + vitamin C blend with no individual doses disclosed. Marine collagen peptides show modest skin-elasticity benefits at 2.5-10 g/day (Proksch 2014), but bundle hides amounts. Small unknown brand with no third-party COAs. Rejected for undisclosed dosing.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "nattokinase-blend-6-000-fu-cardiovascular-support-capsules",
      "title": "Nattokinase Blend 6,000 FU Cardiovascular Support Capsules",
      "vendor": "Crane Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NattoBottle-03FrontSlightAngleWithCapsules.jpg?v=1777846587",
      "score": 51,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nattokinase",
        "blend",
        "000",
        "cardiovascular",
        "support",
        "capsules",
        "crane",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 50,
        "sustainability": 40
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170913931461",
      "vsf_explanation": "6000 FU nattokinase (278mg) + Okinawa moromi vinegar 90mg + garlic 30mg + 30mg GABA per 3-cap serving. Nattokinase has small RCTs for mild BP reduction (Kim et al. 2008) and fibrinolytic activity. Blood-clot/plaque marketing language edges toward disease claims, and users on anticoagulants should be warned of bleeding risk.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sleep-well-blend",
      "title": "Sleep Well Blend",
      "vendor": "Crane Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SleepBox-05withStickVert_d0c19f20-2c39-4603-bd37-83705c2be20f.jpg?v=1777846587",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sleep",
        "well",
        "blend",
        "crane",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental",
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170913800389",
      "vsf_explanation": "Melatonin-free sleep sachet with fully disclosed doses: 3000 mg glycine + 100 mg GABA + 200 mg L-theanine. Glycine 3 g at bedtime has RCT support for sleep quality (Yamadera Sleep Biol Rhythms 2007) and L-theanine 200 mg supports relaxation (Hidese Nutrients 2019). Oral GABA CNS activity remains debated but transparent. Clean single-purpose formulation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-oceanic-root-iodine-kelp-root-tablets",
      "title": "Pure Oceanic Root Iodine Kelp Root Tablets",
      "vendor": "Crane Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/OceanBox-01Front.jpg?v=1777846587",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "oceanic",
        "root",
        "iodine",
        "kelp",
        "root",
        "tablets",
        "crane",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 38,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170914029765",
      "vsf_explanation": "Kelp-sourced iodine tablets with no mcg dose disclosed. Iodine is essential for thyroid hormone synthesis (Zimmermann 2009), but kelp iodine content varies wildly (100-3000 mcg/g) and excess can trigger thyroid dysfunction. No standardization, no third-party testing referenced, no brand provenance.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "radiant-renew-collagen-hydration-complex",
      "title": "Radiant Renew Collagen Hydration Complex",
      "vendor": "Crane Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Radiant_Bag_01_-_Front_214a372d-7ee3-4558-b5b4-52b0ff7fb791.jpg?v=1777846587",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "radiant",
        "renew",
        "collagen",
        "hydration",
        "complex",
        "crane",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170913833157",
      "vsf_explanation": "5.25g marine collagen peptides + 150mg HA + 100mg vitamin C + 45mcg biotin per 6g scoop, all doses disclosed. Proksch 2014 (Skin Pharmacol Physiol) showed collagen skin benefits at 2.5-5g/day. Marine collagen dose is at the low end of studied range (Choi 2019 typically 10g), and biotin 45mcg is trivial.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "rise-rest-bundle",
      "title": "Rise & Rest Bundle",
      "vendor": "Crane Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ZENENERGYANDSLEEPWELLBUNDLE.jpg?v=1777846587",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "rise",
        "rest",
        "bundle",
        "crane",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170914062533",
      "vsf_explanation": "Bundle of a green-tea+coffee 'energy' powder and a 'sleep-well' herbal blend, discounted 20%. No composition disclosed for either component; caffeine dose per serving is undocumented. Cannot be scored against sleep-support RCT literature (melatonin, magnesium glycinate) without a formula panel.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "tone-glow-travel-size-pouches",
      "title": "Tone & Glow Travel Size Pouches",
      "vendor": "Crane Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ToneSachet-01Front.jpg?v=1777846588",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tone",
        "glow",
        "travel",
        "size",
        "pouches",
        "crane",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 6,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170914095301",
      "vsf_explanation": "Single-ingredient coix (Job's tears) seed extract. Anti-aging and hyperpigmentation claims outpace evidence — coix has limited in-vitro / small human studies (Chen 2020) but no robust cosmetic RCTs. Dose per sachet not disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "micronized-creatine-monohydrate",
      "title": "Micronized Creatine Monohydrate",
      "vendor": "NSP Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_fb580dcb-42ce-4496-a1d2-10e7de0bdbf5.jpg?v=1777846687",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "micronized",
        "creatine",
        "monohydrate",
        "nsp",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 85,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 75,
        "transparency": 55,
        "sustainability": 40
      },
      "price": 32.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170914717893",
      "vsf_explanation": "5g micronized creatine monohydrate per scoop is the exact evidence-based dose (Kreider 2017, ISSN Position Stand). Creatine mono is the most-studied ergogenic aid in sport. Formulation is single-ingredient and clean, but no Creapure or third-party purity certification claim — cheap Chinese-source creatine is common at this price.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "milk-egg-protein-signature-collection",
      "title": "Milk & Egg Protein Signature Collection",
      "vendor": "NSP Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MILK_EGG_Chocolate.png?v=1777846687",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "milk",
        "egg",
        "protein",
        "signature",
        "collection",
        "nsp",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 40
      },
      "price": 73.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170914848965",
      "vsf_explanation": "26g protein, 2g carb, 1g fat from milk + egg protein — a classic Vince Gironda-style bodybuilding blend with good amino acid completeness (Phillips 2016 leucine). No third-party testing (Informed Sport / NSF) disclosed; heavy-metal / hormone contamination risk in low-cost dairy protein powders is real (Consumer Reports 2010, ConsumerLab 2020).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "grass-fed-beef-liver-capsules",
      "title": "Grass-Fed Beef Liver Capsules",
      "vendor": "NSP Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_4911968c-db4e-4b06-b935-5f23472b44e8.jpg?v=1777846687",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "grass",
        "fed",
        "beef",
        "liver",
        "capsules",
        "nsp",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170914783429",
      "vsf_explanation": "3000mg (6x500mg) desiccated grass-fed beef liver per serving. Dose disclosed. Rich in preformed vitamin A, B12, heme iron, but no clinical trials of desiccated liver capsules for meaningful endpoints. Country-of-origin not disclosed (Argentina/NZ grass-fed liver premium not verified).",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "advanced-aminos-capsules-1000mg",
      "title": "Advanced Aminos Capsules 1000mg",
      "vendor": "NSP Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/aminos.jpg?v=1777846686",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "advanced",
        "aminos",
        "capsules",
        "1000mg",
        "nsp",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 30,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170914750661",
      "vsf_explanation": "1000mg (1g) of casein hydrolysate per serving is roughly 1/25th the protein dose that Res (2012) and Snijders (2015) used to see muscle-protein-synthesis or overnight recovery effects (~30-40g). At this dose the product is metabolically negligible.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "test-boost-pro-testosterone-capsules",
      "title": "Test Boost Pro Testosterone Capsules",
      "vendor": "NSP Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_247530ee-298c-41c0-9951-62d5b651643c.jpg?v=1777846687",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "test",
        "boost",
        "pro",
        "testosterone",
        "capsules",
        "nsp",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine",
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 35,
        "manufacturing": 50,
        "safety": 45,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170914947269",
      "vsf_explanation": "Tribulus Terrestris has been repeatedly shown NOT to raise serum testosterone in human RCTs (Neychev & Mitev 2005; Rogerson 2007; Pokrywka 2014 review). Marketing testosterone-boosting outcomes on Tribulus + Zn/Mg is misleading. No standardized saponin or steroidal content, no doses.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "greens-reds-superfood-powder",
      "title": "Greens & Reds Superfood Powder",
      "vendor": "NSP Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_05180cfc-7d19-469f-a9bc-11631755c495.jpg?v=1777846687",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "greens",
        "reds",
        "superfood",
        "powder",
        "nsp",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170914980037",
      "vsf_explanation": "Copy claims 'no proprietary blends' and 'real servings clearly listed', but the actual mg for spirulina, kale, spinach, probiotic CFU, and enzyme units are not visible in this listing. Greens powders generally don't beat whole vegetables (Kennedy 2010 systematic review of multi-nutrient blends). Fine as a convenience product, not evidence-heavy.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "appex-appetite-suppressant-capsules",
      "title": "Appex Appetite Suppressant Capsules",
      "vendor": "NSP Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/appex1.jpg?v=1777846687",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "appex",
        "appetite",
        "suppressant",
        "capsules",
        "nsp",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 45,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170914816197",
      "vsf_explanation": "Berberine HCL has good glucose evidence at 1500mg/day (Yin 2008), but here it is stacked with bitter melon, banaba, a Reishi/Shiitake/Maitake/Lion's Mane mushroom blend, and 5-HTP with no per-ingredient dose. 5-HTP + weight-loss stimulants has serotonin-interaction risk.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "eaa-hydration",
      "title": "EAA + HYDRATION",
      "vendor": "NSP Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_2faa2a30-e4dc-457b-a5b6-e6ddb4c3b61e.jpg?v=1777846687",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "eaa",
        "hydration",
        "nsp",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids",
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 45,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170915012805",
      "vsf_explanation": "EAA + BCAA + electrolyte concept is defensible (Jackman 2017 showed EAAs stimulate MPS), but stacking caffeine plus a Reishi/Shiitake/Maitake 'mushroom blend' as a focus/energy layer with no doses is a proprietary-blend problem. EAA content itself not disclosed.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "thermo-shred-burn-capsules",
      "title": "Thermo Shred Burn Capsules",
      "vendor": "NSP Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_1492cfdc-5f0b-4158-9140-31c1a66ee07c.jpg?v=1777846687",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "thermo",
        "shred",
        "burn",
        "capsules",
        "nsp",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 30,
        "manufacturing": 45,
        "safety": 30,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170915045573",
      "vsf_explanation": "Bitter orange (synephrine) + caffeine anhydrous + green tea + dynamine + theacrine is a stimulant-stack that FDA has flagged for cardiovascular events (Bui 2006; Stohs 2020 review). No per-ingredient mg. Grains of paradise thermogenesis evidence (Sugita 2013) is at 30mg - not disclosed here.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "thyroid-complete",
      "title": "Thyroid Complete",
      "vendor": "NSP Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Thyroid-Complete-Front-_60.jpg?v=1777846687",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "thyroid",
        "complete",
        "nsp",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 42,
        "manufacturing": 42,
        "safety": 50,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 10,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170915078341",
      "vsf_explanation": "Ashwagandha-based thyroid support with no doses disclosed. Ashwagandha (KSM-66) shows T3/T4 modulation in subclinical hypothyroidism at 600 mg/day (Sharma 2018), but this product hides ashwagandha extract quantity and other ingredients. Small brand, no third-party COAs cited.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "isolate-protein-powder",
      "title": "Isolate Protein Powder",
      "vendor": "NSP Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_84288a12-33b0-4284-8d60-09923a10eb7a.jpg?v=1777846687",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "isolate",
        "protein",
        "powder",
        "nsp",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 59.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170915143877",
      "vsf_explanation": "25 g whey isolate per serving matches Morton 2018 (Br J Sports Med) meta-analysis threshold for maximal MPS response. Low-carb, zero-sugar formulation is legitimate. Not disclosed: heavy metal testing, protein spiking checks, or whey source (grass-fed vs conventional).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "berberine-complex",
      "title": "Berberine Complex",
      "vendor": "NSP Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/berberine-complex-37750653485285_4323644c-b71d-49e2-a83e-301f11c34ba5.png?v=1777846687",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "berberine",
        "complex",
        "nsp",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 28,
        "sustainability": 40
      },
      "price": 14,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170915111109",
      "vsf_explanation": "Berberine HCL + bitter melon + banaba leaf blend. Berberine has strong RCT evidence for glucose/lipid control at 500 mg x3/day (Yin 2008), but this product hides per-ingredient doses in a proprietary blend. No brand provenance, no third-party COAs.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "energize-complete-pre-workout-pump-blend",
      "title": "Energize Complete Pre-Workout & Pump Blend",
      "vendor": "NSP Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5_2d1022f5-cb9f-4936-a81f-04caa3f0532f.jpg?v=1777846687",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "energize",
        "complete",
        "pre",
        "workout",
        "pump",
        "blend",
        "nsp",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic",
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170915209413",
      "vsf_explanation": "Ingredients (citrulline, beta-alanine, betaine, arginine, theobromine) have RCT support (Bailey 2010 for citrulline 6–8g pumps; Trexler 2015 for beta-alanine 4–6g), but the copy references a 'comprehensive blend' rather than per-ingredient doses. Dual scoop (12g vs 30g) hints at proprietary blend structure.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "peak-liver-detox-60-capsules-512-mg",
      "title": "Peak Liver Detox, 60 Capsules, 512 mg",
      "vendor": "Ascent Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/AN-ProductImages-Shopify-PEAK_LIVER_DETOX.png?v=1777846714",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "peak",
        "liver",
        "detox",
        "capsules",
        "512",
        "ascent",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive",
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 30,
        "sustainability": 50
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170915537093",
      "vsf_explanation": "Milk thistle silymarin has real hepatoprotective data (Loguercio 2012 in NAFLD used 700mg silymarin/day), but 512mg TOTAL blend of dandelion + milk thistle + artichoke is split across three ingredients, likely leaving each sub-therapeutic. 'Detox' framing not FDA-substantiated.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "algae-oil-dha-omega-3s-vegan-and-vegetarian-1000-mg",
      "title": "Algae Oil DHA Omega-3's - Vegan and Vegetarian, 1000 mg",
      "vendor": "Ascent Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/AscentNutritionAlgaeOilDHA_dd5b53eb-bb27-482e-843a-0b54defd6f3c.png?v=1777846715",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "algae",
        "oil",
        "dha",
        "omega",
        "vegan",
        "and",
        "vegetarian",
        "1000",
        "ascent",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart",
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 65
      },
      "price": 54.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170915569861",
      "vsf_explanation": "Algae-source DHA is a legitimate vegan omega-3 (Arterburn 2008 shows algae DHA raises plasma DHA equivalently to fish oil). Sustainability advantage vs krill/fish. However 1000mg refers to oil, not DHA — actual DHA per softgel not disclosed; '250% more omega-3 than fish oil' claim is not standard.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "organic-ceylon-cinnamon-60-capsules-1200-mg",
      "title": "Organic Ceylon Cinnamon, 60 Capsules, 1200 mg",
      "vendor": "Ascent Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CEYLON_CINNAMON_1000x1000_-Shopify.png?v=1777846715",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "ceylon",
        "cinnamon",
        "capsules",
        "1200",
        "ascent",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic",
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 60,
        "sustainability": 60
      },
      "price": 31.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170915504325",
      "vsf_explanation": "Single-ingredient organic Ceylon cinnamon at a clearly disclosed 1200mg (2 caps) is in the range Allen (2013) meta-analysis linked to fasting glucose reductions of ~24 mg/dL. Ceylon avoids the coumarin hepatotoxicity of cassia varieties - a genuine safety win. Missing 3rd-party COA and standardized MHCP content.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-beetroot-60-capsules-1300-mg",
      "title": "Organic Beetroot, 60 Capsules, 1300 mg",
      "vendor": "Ascent Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BEETROOT_1000x1000_-Shopify.png?v=1777846714",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "beetroot",
        "capsules",
        "1300",
        "ascent",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart",
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170915668165",
      "vsf_explanation": "Whole beetroot powder 1300mg supplies dietary nitrate that Siervo (2013) meta showed lowers systolic BP by ~4.4 mmHg, but effective nitrate doses in RCTs (Kelly 2013) run 300-600mg NO3, typically requiring concentrated beet juice not 1.3g powder. Standardized nitrate content not disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-sea-moss-60-capsules-500-mg",
      "title": "Organic Sea Moss, 60 Capsules, 500 mg",
      "vendor": "Ascent Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SEAMOSS_1000x1000_-Shopify.png?v=1777846714",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "sea",
        "moss",
        "capsules",
        "500",
        "ascent",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants",
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 40,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 44.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170915635397",
      "vsf_explanation": "Sea moss + bladderwrack + burdock blend at 500mg per capsule. Iodine content undisclosed — bladderwrack is potent iodine source and unregulated dosing risks thyroid disruption (Emder 2010 case reports). No clinical evidence for immune/energy/hormonal claims.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "organic-agarikon-mushroom-powder-2-grams-per-scoop",
      "title": "Organic Agarikon Mushroom Powder, 2 grams per scoop",
      "vendor": "Ascent Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/AN-ProductImages-Shopify-AGARIKON_6e476392-6f7d-48fe-a56c-22a807c4acb3.png?v=1777846714",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "agarikon",
        "mushroom",
        "powder",
        "grams",
        "per",
        "scoop",
        "ascent",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170915700933",
      "vsf_explanation": "2g agarikon (Fomitopsis officinalis) per scoop is transparent. Stamets et al. NIH-funded work identified antiviral coumarins in agarikon (Stamets 2005, Int J Med Mushrooms) but no human trials for respiratory endpoints. Grown in USA, genetic-strain-verified is a positive.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "d3-k2-60-capsules-125-mcg-d3-100-mcg-k2",
      "title": "D3 + K2, 60 Capsules, 125 mcg D3 + 100 mcg K2",
      "vendor": "Ascent Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/D3_K2_1000x1000_-Shopify.png?v=1777846714",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "capsules",
        "125",
        "mcg",
        "100",
        "mcg",
        "ascent",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients",
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 72,
        "manufacturing": 68,
        "safety": 70,
        "transparency": 68,
        "sustainability": 60
      },
      "price": 33.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170915733701",
      "vsf_explanation": "D3 125mcg (5000 IU) is a widely-used repletion dose (Heaney 2003; Holick 2011 clinical guidelines) and K2 100mcg is in the range Knapen (2013) 3-yr RCT used for arterial-stiffness reduction. Doses are clearly disclosed on the label - a real transparency win. K2 form (MK-7 vs MK-4) is not explicitly stated in the listing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ultimate-shilajit-60-capsules-1-g",
      "title": "Ultimate Shilajit, 60 Capsules, 1 g",
      "vendor": "Ascent Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/UltimateShilajit_4086b0c1-88dc-459f-9f27-54c11f3dbede.png?v=1777846714",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ultimate",
        "shilajit",
        "capsules",
        "ascent",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic",
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170915766469",
      "vsf_explanation": "1g shilajit 10:1 extract is disclosed, and Pandit (2016) found 250mg purified shilajit twice-daily raised total testosterone in healthy men. Fulvic acid % and heavy-metal COA (shilajit resin can carry lead/arsenic) are not published on this listing - the safety-critical missing data caps the score.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pine-needle-extract-pine-needle-tea-alternative-267-mg",
      "title": "Pine Needle Extract, Pine Needle Tea Alternative, 267 mg",
      "vendor": "Ascent Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/PINE_NEEDLE_1000x1000_-Shopify.png?v=1777846715",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pine",
        "needle",
        "extract",
        "pine",
        "needle",
        "tea",
        "alternative",
        "267",
        "ascent",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 45,
        "transparency": 50,
        "sustainability": 60
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170915799237",
      "vsf_explanation": "White-pine shikimic-acid extract marketed as a 'pine needle tea alternative' — coded language from the pandemic-era anti-spike-protein trend. Shikimic acid is a Tamiflu precursor, not the drug itself; no human RCTs support the immune, brain, or detoxification claims. Capped by unverified disease-claim implication.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "wild-harvested-spruce-soap-6-oz-bar",
      "title": "Wild-Harvested Spruce Soap, 6 oz Bar",
      "vendor": "Ascent Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SpruceSoap-Product-WhtBckGrnd-1000x1000px-1x1r-2024.01-v1-byShanna.png?v=1777846715",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wild",
        "harvested",
        "spruce",
        "soap",
        "bar",
        "ascent",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 65,
        "transparency": 40,
        "sustainability": 65
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170915864773",
      "vsf_explanation": "A wild-harvested bar soap — not a supplement or a serious skincare active. Nice sustainability angle (wild spruce, kaolin), but no dermatological evidence for any of the marketed benefits. Miscategorized as personal care within a supplement batch; listed for completeness.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-lions-mane-mushroom-powder-2-grams-per-scoop",
      "title": "Organic Lion's Mane Mushroom Powder, 2 Grams per scoop",
      "vendor": "Ascent Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/AN-ProductImages-Shopify-LIONS_MANE_1.png?v=1777846715",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "lion",
        "mane",
        "mushroom",
        "powder",
        "grams",
        "per",
        "scoop",
        "ascent",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170915832005",
      "vsf_explanation": "2g lion's mane (Hericium erinaceus) per scoop with mycelium + fruiting body — Mori 2009 (Phytother Res) showed cognitive improvement in mild cognitive impairment at 3g/day. Dose here slightly below studied. Grown-in-USA and strain-specific claims are strengths, but no beta-glucan % standardization disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "wild-harvested-pine-pollen-tincture-335-mg",
      "title": "Wild-Harvested Pine Pollen Tincture, 335 mg",
      "vendor": "Ascent Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/AN-ProductImages-Shopify-PINE-POLLEN-TINCTURE.png?v=1777846715",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wild",
        "harvested",
        "pine",
        "pollen",
        "tincture",
        "335",
        "ascent",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine",
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 45,
        "transparency": 45,
        "sustainability": 60
      },
      "price": 89.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170915897541",
      "vsf_explanation": "Pine pollen contains trace phyto-androgens but no clinical trials support libido, adrenal, thyroid or cardiovascular claims. Uncracked whole-cell pollen likely has poor bioavailability. Wild-harvested is a modest quality signal but not a safety guarantee.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "berberine-complex-60-capsules-1000-mg",
      "title": "Berberine Complex, 60 Capsules, 1000 mg",
      "vendor": "Ascent Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2022.12_BERBERINE_1000_x_1000_-Shopify.png?v=1777846715",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "berberine",
        "complex",
        "capsules",
        "1000",
        "ascent",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic",
        "weight_metabolic_health",
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 65,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 62,
        "sustainability": 60
      },
      "price": 36.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170915930309",
      "vsf_explanation": "1000mg berberine per serving is right in the 900-1500mg/day therapeutic range Yin (2008) used to match metformin for glycemic control in type-2 diabetics, and Dong (2012) meta showed LDL/TG reduction. 'Complex' framing but no supporting-actives listed. No 3rd-party purity COA visible.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-turmeric-complex-60-capsules-500-mg",
      "title": "Organic Turmeric Complex, 60 Capsules, 500 mg",
      "vendor": "Ascent Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/TUMERIC_1000x1000_-Shopify.png?v=1777846715",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "turmeric",
        "complex",
        "capsules",
        "500",
        "ascent",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants",
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170915963077",
      "vsf_explanation": "500mg organic turmeric + 95% standardized curcuminoids + BioPerine (piperine). Shoba 1998 established piperine improves curcumin bioavailability 20x. Panahi 2014 (Complement Ther Med) showed 500mg curcuminoids reduced inflammation markers. Weakness: exact curcuminoid mg not stated, so per-capsule curcumin content is unclear.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "saffron-extract-60-capsules-88-5-mg",
      "title": "Saffron Extract, 60 Capsules, 88.5 mg",
      "vendor": "Ascent Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SAFFRON_1000x1000_-Shopify.png?v=1777846715",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "saffron",
        "extract",
        "capsules",
        "ascent",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 65,
        "manufacturing": 63,
        "safety": 68,
        "transparency": 62,
        "sustainability": 60
      },
      "price": 36.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170915995845",
      "vsf_explanation": "88.5mg saffron extract is above the 28-30mg dose Lopresti (2019) meta and Hausenblas (2013) reviews used to show antidepressant effects comparable to fluoxetine in mild-to-moderate depression. Standardized safranal/crocin % and Affron/Satiereal branding not disclosed - the actives determine whether the dose is truly efficacious.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "3-x-bundle-15-day-cleanse-colon-cleanse-detox",
      "title": "3 x Bundle - 15 Day Cleanse | Colon Cleanse & Detox",
      "vendor": "Saint Mingiano - Supplements & Wellness Dedicated to Holistic Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3X_BUNDLE_15_DAY_CLEANSE_Colon_Cleanse_Detox_-_Product_Display_Artwork-01_5_PACKsticker.jpg?v=1777848712",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bundle",
        "day",
        "cleanse",
        "colon",
        "cleanse",
        "detox",
        "saint",
        "mingiano",
        "supplements",
        "wellness",
        "dedicated",
        "holistic",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 30,
        "manufacturing": 40,
        "safety": 25,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 75.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170957775045",
      "vsf_explanation": "Senna leaf + cascara sagrada are stimulant laxatives associated with melanosis coli and electrolyte disturbance on chronic use (Muller-Lissner 1993; FDA banned aloe/cascara OTC laxatives 2002). 'Detox' claim has no clinical substantiation (Klein 2015 BJN review). No per-herb doses.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "dim-supplement-300-mg-supplements-hormone-estrogen-and-menopause-balance-for-women",
      "title": "DIM Supplement 300 mg Supplements | Hormone Estrogen and Menopause Balance for Women",
      "vendor": "Saint Mingiano - Supplements & Wellness Dedicated to Holistic Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/DIM300mgDiindolylmethaneHormoneEstrogenMenopauseBalanceHotFlashesNightSweats-01SMALL.jpg?v=1777848713",
      "score": 45,
      "tier": "rejected",
      "certifications": [
        "NSF Certified",
        "GMP Certified"
      ],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "female",
      "life_stage": "postmenopausal",
      "tokens": [
        "dim",
        "supplement",
        "300",
        "supplements",
        "hormone",
        "estrogen",
        "and",
        "menopause",
        "balance",
        "for",
        "women",
        "saint",
        "mingiano",
        "supplements",
        "wellness",
        "dedicated",
        "holistic",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 50,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170957807813",
      "vsf_explanation": "300mg DIM is at the studied dose (Thomson 2017 pilot for breast tissue estrogen metabolism), which is a plus. But marketing explicitly claims treatment of hormonal acne, PMS, hot flashes, and 'hormonal imbalance' — these are disease/drug claims. Unknown small brand with no NSF/USP/COA transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "eye-health-vision-vitamins-supplement-60-capsules",
      "title": "Eye Health & Vision Vitamins Supplement 60 Capsules",
      "vendor": "Saint Mingiano - Supplements & Wellness Dedicated to Holistic Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/EyeHealthVitaminssupplementEyes-01small.jpg?v=1777848714",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "eye",
        "health",
        "vision",
        "vitamins",
        "supplement",
        "capsules",
        "saint",
        "mingiano",
        "supplements",
        "wellness",
        "dedicated",
        "holistic",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 40,
        "safety": 60,
        "transparency": 35,
        "sustainability": 35
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170957840581",
      "vsf_explanation": "Kitchen-sink eye formula with turmeric, milk thistle, vitamin A, zinc, lutein, bilberry, grape seed, quercetin. AREDS2-supported dosing requires 10mg lutein + 2mg zeaxanthin (Chew et al. 2013) — those doses are not stated. Generic storefront brand, no third-party testing shown.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liver-cleanse-detox-repair-21-day-cleanse-natural-liver-support-supplement-with-milk-thistle",
      "title": "Liver Cleanse Detox & Repair - 21 Day Cleanse - Natural Liver Support Supplement with Milk Thistle",
      "vendor": "Saint Mingiano - Supplements & Wellness Dedicated to Holistic Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/LiverSupportProductDisplay-01small.jpg?v=1777848718",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liver",
        "cleanse",
        "detox",
        "repair",
        "day",
        "cleanse",
        "natural",
        "liver",
        "support",
        "supplement",
        "with",
        "milk",
        "thistle",
        "saint",
        "mingiano",
        "supplements",
        "wellness",
        "dedicated",
        "holistic",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 42,
        "manufacturing": 40,
        "safety": 60,
        "transparency": 35,
        "sustainability": 35
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170957873349",
      "vsf_explanation": "Broad '21-day cleanse' herbal stack (spinach, artichoke, dandelion, milk thistle). 'Detox' has no clinical definition — hepatic and renal systems continuously eliminate metabolites without needing a botanical purge (Klein & Kiat 2015 review). Milk thistle has modest NAFLD evidence but is diluted in a scattershot blend.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "15-day-cleanse-colon-detox-with-natural-laxative-for-constipation-bloating",
      "title": "15 Day Cleanse | Colon Detox with Natural Laxative for Constipation & Bloating.",
      "vendor": "Saint Mingiano - Supplements & Wellness Dedicated to Holistic Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/15DAYCLEANSEColonCleanseDetox-ProductDisplayArtwork-01small.jpg?v=1777848717",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "day",
        "cleanse",
        "colon",
        "detox",
        "with",
        "natural",
        "laxative",
        "for",
        "constipation",
        "bloating",
        "saint",
        "mingiano",
        "supplements",
        "wellness",
        "dedicated",
        "holistic",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 42,
        "manufacturing": 50,
        "safety": 30,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170957938885",
      "vsf_explanation": "Senna + cascara sagrada are stimulant laxatives with well-documented risks of dependence, electrolyte disturbances, and melanosis coli (FDA warnings; NIH LiverTox for cascara). Not appropriate for a 15-day regimen. 'Detox' framing lacks clinical support.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "lung-cleanse-detox-60-day-cleanse-supports-lung-health-within-bronchial-respiratory-systems",
      "title": "Lung Cleanse Detox, 60 Day Cleanse - Supports Lung Health Within Bronchial & Respiratory Systems",
      "vendor": "Saint Mingiano - Supplements & Wellness Dedicated to Holistic Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Lungbetterlungscleansebreathoflifedetoxforsmokers-01small.jpg?v=1777848719",
      "score": 41,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lung",
        "cleanse",
        "detox",
        "day",
        "cleanse",
        "supports",
        "lung",
        "health",
        "within",
        "bronchial",
        "respiratory",
        "systems",
        "saint",
        "mingiano",
        "supplements",
        "wellness",
        "dedicated",
        "holistic",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 42,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 35,
        "sustainability": 35
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170957971653",
      "vsf_explanation": "'Lung cleanse' with vit C, K2, butterbur, quercetin, bromelain, mullein and pine bark. Butterbur must be PA-free to avoid hepatotoxicity (Sutherland & Sweet 2010) — that certification not shown. No credible mechanism by which capsules 'cleanse' lung tissue; ciliary clearance is not modulated by oral botanicals.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "thyroid-support-supplement-with-iodine-120-capsules-to-help-body-mass-improve-energy",
      "title": "Thyroid Support Supplement with Iodine |120 Capsules to Help Body Mass & Improve Energy",
      "vendor": "Saint Mingiano - Supplements & Wellness Dedicated to Holistic Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ThyroidSupportSupplementwithIodine_120CapstoHelpBodyMass_EnergyB12T3T4iodine-ProductDisplayArtwork-01.jpg?v=1777848718",
      "score": 39,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "thyroid",
        "support",
        "supplement",
        "with",
        "iodine",
        "120",
        "capsules",
        "help",
        "body",
        "mass",
        "improve",
        "energy",
        "saint",
        "mingiano",
        "supplements",
        "wellness",
        "dedicated",
        "holistic",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 42,
        "manufacturing": 40,
        "safety": 40,
        "transparency": 35,
        "sustainability": 35
      },
      "price": 24.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170957906117",
      "vsf_explanation": "Iodine + kelp + bladderwrack + tyrosine + selenium + ashwagandha. Excess iodine can precipitate hypo- or hyperthyroidism, especially in Hashimoto's patients (Leung & Braverman 2014), and kelp adds unknown extra iodine. No dose disclosure. Weight-loss/energy claims via thyroid modulation are risky without physician oversight.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "7-day-cleanse-program-colon-detox-with-natural-laxative-for-constipation-bloating",
      "title": "7 Day Cleanse Program | Colon Detox with Natural Laxative for Constipation & Bloating",
      "vendor": "Saint Mingiano - Supplements & Wellness Dedicated to Holistic Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7DAYCLEANSE-ColonCleanseDetox-01small.jpg?v=1777848718",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "day",
        "cleanse",
        "program",
        "colon",
        "detox",
        "with",
        "natural",
        "laxative",
        "for",
        "constipation",
        "bloating",
        "saint",
        "mingiano",
        "supplements",
        "wellness",
        "dedicated",
        "holistic",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 42,
        "manufacturing": 50,
        "safety": 35,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170958069957",
      "vsf_explanation": "Same senna+cascara sagrada+psyllium+aloe formula as the 15-day version, shortened to 7 days. Stimulant laxatives carry safety warnings even in short courses. 'Toxin removal' is unsupported.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "uric-acid-support-120-capsules-supports-kidney-cleanse-detox-repair-gallbladder-urinary-tract-issues",
      "title": "Uric Acid Support -120 Capsules - Supports Kidney Cleanse Detox & Repair, Gallbladder & Urinary Tract Issues",
      "vendor": "Saint Mingiano - Supplements & Wellness Dedicated to Holistic Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/URICACID-ProductDisplayArtwork-01small.jpg?v=1777848719",
      "score": 41,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "uric",
        "acid",
        "support",
        "120",
        "capsules",
        "supports",
        "kidney",
        "cleanse",
        "detox",
        "repair",
        "gallbladder",
        "urinary",
        "tract",
        "issues",
        "saint",
        "mingiano",
        "supplements",
        "wellness",
        "dedicated",
        "holistic",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 35,
        "sustainability": 35
      },
      "price": 24.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170958004421",
      "vsf_explanation": "Tart cherry has weak observational support for uric acid reduction (Zhang et al. 2012) but doses in blends like this are typically sub-therapeutic. Chanca piedra kidney claims are largely traditional-medicine. 'Cleanse and detox' language for the kidneys is physiologically inaccurate.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "water-away-water-retention-and-flushing-aids-in-water-relief-water-loss",
      "title": "Water Away - Water Retention and Flushing, Aids in Water Relief & Water Loss",
      "vendor": "Saint Mingiano - Supplements & Wellness Dedicated to Holistic Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/WaterAwayPillsDirecticforwaterretentionloss_uricacidflush-01small.jpg?v=1777848719",
      "score": 40,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "water",
        "away",
        "water",
        "retention",
        "and",
        "flushing",
        "aids",
        "water",
        "relief",
        "water",
        "loss",
        "saint",
        "mingiano",
        "supplements",
        "wellness",
        "dedicated",
        "holistic",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 35,
        "sustainability": 35
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170958037189",
      "vsf_explanation": "Herbal 'diuretic' blend (green tea leaf, dandelion, buchu, cranberry). Diuresis-driven weight loss is fluid loss, not fat loss, and can cause electrolyte disturbances with prolonged use. No dose disclosure; storefront brand with no third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "kidney-support-cleanse-detox-repair-120-capsules-cranberry-astragalus-root-pills",
      "title": "Kidney Support Cleanse Detox & Repair -120 Capsules - Cranberry & Astragalus Root Pills",
      "vendor": "Saint Mingiano - Supplements & Wellness Dedicated to Holistic Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/KIDNEY_SUPPORT_-_Product_Display_Artwork-01small.jpg?v=1777848718",
      "score": 38,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "kidney",
        "support",
        "cleanse",
        "detox",
        "repair",
        "120",
        "capsules",
        "cranberry",
        "astragalus",
        "root",
        "pills",
        "saint",
        "mingiano",
        "supplements",
        "wellness",
        "dedicated",
        "holistic",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 50,
        "safety": 45,
        "transparency": 30,
        "sustainability": 35
      },
      "price": 24.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170958102725",
      "vsf_explanation": "'20 premium ingredients' blend with no per-ingredient dose hides sub-therapeutic amounts of cranberry (Jepson 2012 Cochrane requires 36 mg/day PACs) and astragalus. Kidney 'detox' and 'repair' framing is not evidence-based; kidneys detox themselves.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "cape-aloe-colon-cleanse-detox-flush-90-capsules-gentle-constipation-relief",
      "title": "Cape Aloe Colon Cleanse, Detox & Flush - 90 Capsules. Gentle Constipation Relief",
      "vendor": "Saint Mingiano - Supplements & Wellness Dedicated to Holistic Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CapeAloePlusColonCleanseProductDisplayImages-01small.jpg?v=1777848719",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cape",
        "aloe",
        "colon",
        "cleanse",
        "detox",
        "flush",
        "capsules",
        "gentle",
        "constipation",
        "relief",
        "saint",
        "mingiano",
        "supplements",
        "wellness",
        "dedicated",
        "holistic",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 38,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170958135493",
      "vsf_explanation": "Cape aloe (Aloe ferox) latex is a stimulant laxative. FDA removed non-Rx aloe/cascara laxatives from OTC monograph 2002 due to insufficient safety data. Copy claims to exclude latex while marketing laxative effects — contradictory.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "rapid-rehydr8-electrolyte-supplements-100-capsules-aid-in-the-prevention-of-cramping-and-supports-muscle-endurance-and-recovery",
      "title": "Rapid Rehydr8 Electrolyte Supplements 100 Capsules – Aid in The Prevention of Cramping and Supports Muscle Endurance and Recovery",
      "vendor": "Saint Mingiano - Supplements & Wellness Dedicated to Holistic Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/electrolytestabletsiodinesodiummagnesiumphosphorustabletsproductdisplay-01small.jpg?v=1777848718",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "rapid",
        "rehydr8",
        "electrolyte",
        "supplements",
        "100",
        "capsules",
        "aid",
        "the",
        "prevention",
        "cramping",
        "and",
        "supports",
        "muscle",
        "endurance",
        "and",
        "recovery",
        "saint",
        "mingiano",
        "supplements",
        "wellness",
        "dedicated",
        "holistic",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 48,
        "manufacturing": 42,
        "safety": 55,
        "transparency": 35,
        "sustainability": 42
      },
      "price": 24.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170958168261",
      "vsf_explanation": "Electrolyte capsule (K, Ca, P, Mg + 12 ingredients) targeting cramp prevention. Electrolyte-replacement evidence is solid (Sawka 2007), but mg amounts per capsule not disclosed in description and 'scientifically developed ingredients' is vague. Small brand, no third-party testing referenced.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "mens-prostate-health-120-capsules-of-advanced-prostate-supplements-for-men-with-saw-palmetto",
      "title": "Men's Prostate Health - 120 Capsules of Advanced Prostate Supplements for Men with Saw Palmetto",
      "vendor": "Saint Mingiano - Supplements & Wellness Dedicated to Holistic Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MensProstateHealthSawPalmetto_FNSKU-X003WZ19CJ_-ProductDisplayArtwork-01.jpg?v=1777848719",
      "score": 44,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "men",
        "prostate",
        "health",
        "120",
        "capsules",
        "advanced",
        "prostate",
        "supplements",
        "for",
        "men",
        "with",
        "saw",
        "palmetto",
        "saint",
        "mingiano",
        "supplements",
        "wellness",
        "dedicated",
        "holistic",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 42,
        "manufacturing": 40,
        "safety": 60,
        "transparency": 35,
        "sustainability": 35
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170958201029",
      "vsf_explanation": "Saw palmetto for BPH has been repeatedly downgraded — the STEP trial (Bent et al. 2006 NEJM) and CAMUS trial (Barry et al. 2011 JAMA) showed no benefit over placebo. Saw palmetto berry dose and extract standardization (85-95% fatty acids) not disclosed. Additional ingredients minimal.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "alpha-buck",
      "title": "Alpha Buck",
      "vendor": "Reindeer Farms",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ALPHA_BUCK_c3cb257f-ea31-4d6c-8031-5022546a137f.png?v=1777848797",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alpha",
        "buck",
        "reindeer",
        "farms"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health",
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 70,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46577932206277",
      "vsf_explanation": "Pine pollen + maca + tongkat + turkesterone + horny goat weed — a men's 'testosterone' stack. Turkesterone lacks human RCTs; tongkat has some support (Talbott 2013) but doses aren't shown here. No third-party testing.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "classic-reindeer-antler-extract",
      "title": "Classic Reindeer Antler Extract",
      "vendor": "Reindeer Farms",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1000pure.jpg?v=1777848801",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "classic",
        "reindeer",
        "antler",
        "extract",
        "reindeer",
        "farms"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health",
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 40,
        "sustainability": 35
      },
      "price": 100,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46577877745861",
      "vsf_explanation": "Deer antler velvet marketed for testosterone and 'anti-aging.' Sawitzke 2008 found no anabolic effect in humans; WADA prohibits IGF-1 supplements. Claims of increased testosterone/strength are not supported.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "elite-reindeer-antler-extract",
      "title": "Elite Reindeer Antler Extract",
      "vendor": "Reindeer Farms",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2_ee1ff05c-4532-4af7-a8a4-78b59e4a4624.png?v=1777848802",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "elite",
        "reindeer",
        "antler",
        "extract",
        "reindeer",
        "farms"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health",
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 40,
        "sustainability": 35
      },
      "price": 170,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46576044605637",
      "vsf_explanation": "Same product line at 3,000mg / 100:1 extract. Higher dose does not change the underlying evidence gap; Sawitzke 2008 and Sleivert 2003 found no ergogenic effect. WADA prohibits IGF-1.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "premium-reindeer-antler-extract",
      "title": "Premium Reindeer Antler Extract",
      "vendor": "Reindeer Farms",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/premiumjpeg.jpg?v=1777848801",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "premium",
        "reindeer",
        "antler",
        "extract",
        "reindeer",
        "farms"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health",
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 40,
        "sustainability": 35
      },
      "price": 135,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170959839429",
      "vsf_explanation": "Middle-tier of the antler-velvet trio at 2,000mg. Same evidence gap — deer antler / IGF-1 marketing lacks human trial support (Sleivert 2003).",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "advanced-daily-nutrition-formulated-for-her",
      "title": "Advanced Daily Nutrition - Formulated for Her",
      "vendor": "Root'd",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Root_d-Her-Multi-Bag-Rendering.jpg?v=1777848967",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "advanced",
        "daily",
        "nutrition",
        "formulated",
        "for",
        "her",
        "root"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 48
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170963411141",
      "vsf_explanation": "Powdered daily multivitamin + hydration for women, references full supplement facts panel via modal. Multivitamin RCTs show mixed benefits (Rautiainen 2016), primarily filling gaps. Formulation appears comprehensive with disclosed labels. Moderate brand transparency but no NSF/USP third-party certification cited.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "advanced-daily-nutrition-formulated-for-men",
      "title": "Advanced Daily Nutrition - Formulated for Men",
      "vendor": "Root'd",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Root_d-His-Multi-Bag-Rendering.jpg?v=1777848967",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "advanced",
        "daily",
        "nutrition",
        "formulated",
        "for",
        "men",
        "root"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170963574981",
      "vsf_explanation": "Men's daily multi + electrolytes + superfood blend, 24 micronutrients per serving. Reasonable multivitamin backbone (Kim 2020 shows benefit for insufficiencies but not general health outcomes). Loses points for 'kitchen sink' marketing and unverified 'superfood' dosing; solid mid-tier for the category.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "essential-prenatal-nutrition-electrolytes",
      "title": "Essential Prenatal Nutrition + Electrolytes",
      "vendor": "Root'd",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Root_d_Prenatal_Multi_Bag_Rendering.jpg?v=1777848972",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "prenatal",
      "tokens": [
        "essential",
        "prenatal",
        "nutrition",
        "electrolytes",
        "root"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 51.93,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170963837125",
      "vsf_explanation": "Prenatal + electrolyte powder positioned for absorption. Prenatal micronutrient supplementation is well-established (Keats 2019 Cochrane, ACOG). Would need to see methylfolate form, iodine dose, and choline content to move to Verified. Standard on the strength of category evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "eczema-relief-bundle-cellular-renewal-lotion-sea-moss-soap",
      "title": "Eczema Relief Bundle: Cellular Renewal Lotion & Sea Moss Soap",
      "vendor": "AlpiniåLabs",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_35.png?v=1777849051",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "eczema",
        "relief",
        "bundle",
        "cellular",
        "renewal",
        "lotion",
        "sea",
        "moss",
        "soap",
        "alpini",
        "labs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 30,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 25,
        "sustainability": 30
      },
      "price": 95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170964394181",
      "vsf_explanation": "Topical soap + lotion bundle (methylene blue, sea moss, tallow), not an ingestible supplement. Topical methylene blue skin-longevity claims unsupported by clinical trials in humans. Product is categorically mismatched for the supplement rubric.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "ocean-mud-activated-charcoal-facial-soap-bar",
      "title": "Ocean Mud + Activated Charcoal Facial Soap Bar",
      "vendor": "AlpiniåLabs",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/alpinia_oceanmudsoap.png?v=1777849056",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ocean",
        "mud",
        "activated",
        "charcoal",
        "facial",
        "soap",
        "bar",
        "alpini",
        "labs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170964689093",
      "vsf_explanation": "Charcoal + Dead Sea mud facial soap bar. Bar-soap surfactants are drying and can disrupt skin barrier (Ananthapadmanabhan 2004); charcoal 'detox' claims have no dermatological RCT support. Not a supplement, listed for completeness.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "deep-cleansing-clay-powder-mask",
      "title": "Deep Cleansing Clay Powder Mask",
      "vendor": "AlpiniåLabs",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Deep_Cleansing_Clay_Powder_Mask.png?v=1777849056",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "deep",
        "cleansing",
        "clay",
        "powder",
        "mask",
        "alpini",
        "labs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 35,
        "manufacturing": 32,
        "safety": 55,
        "transparency": 25,
        "sustainability": 35
      },
      "price": 24,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170964754629",
      "vsf_explanation": "Clay face mask (French green clay, activated charcoal, kaolin) - a topical cosmetic, not a supplement. Ingredients are conventional cosmetic-grade but product is categorically mismatched to the supplement rubric.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "coconut-tonka-bean-soap",
      "title": "Coconut & Tonka bean Soap",
      "vendor": "AlpiniåLabs",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/coconut_soap.png?v=1777849056",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coconut",
        "tonka",
        "bean",
        "soap",
        "alpini",
        "labs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170965213381",
      "vsf_explanation": "Bar soap, not an ingested supplement. No oral compound, so it is out-of-category for the supplement rubric.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cellular-renewal-lotion-and-exfoliating-body-soap-bundle",
      "title": "Cellular Renewal Lotion and Exfoliating Body Soap Bundle",
      "vendor": "AlpiniåLabs",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_34.png?v=1777849056",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cellular",
        "renewal",
        "lotion",
        "and",
        "exfoliating",
        "body",
        "soap",
        "bundle",
        "alpini",
        "labs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 32,
        "manufacturing": 45,
        "safety": 30,
        "transparency": 30,
        "sustainability": 50
      },
      "price": 95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170964787397",
      "vsf_explanation": "Bundle of two topical products (methylene-blue lotion + coffee-grounds soap). Not an ingestible supplement. Anti-aging + cellular-renewal claims lack RCT support for topical methylene blue. Miscategorised as supplement.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "natural-baby-laundry-detergent-gentle-on-sensitive-skin-enzyme-powered-and-non-toxic-formula",
      "title": "Natural Baby Laundry Detergent: Gentle on Sensitive Skin, Enzyme-Powered, and Non-Toxic Formula",
      "vendor": "AlpiniåLabs",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitled_1080_x_1080_px_8.png?v=1777849055",
      "score": 15,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "natural",
        "baby",
        "laundry",
        "detergent",
        "gentle",
        "sensitive",
        "skin",
        "enzyme",
        "powered",
        "and",
        "non",
        "toxic",
        "formula",
        "alpini",
        "labs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 20,
        "manufacturing": 25,
        "safety": 50,
        "transparency": 15,
        "sustainability": 40
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170965278917",
      "vsf_explanation": "Laundry detergent - a household cleaning product, not a supplement. Cannot be meaningfully scored against ingestible-supplement rubric.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "enzyme-laundry-detergent-powder-5x-concentrated-microplastic-free-clean",
      "title": "Enzyme Laundry Detergent Powder – 5x Concentrated, Microplastic-Free Clean",
      "vendor": "AlpiniåLabs",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/woodsage.png?v=1777849056",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "enzyme",
        "laundry",
        "detergent",
        "powder",
        "concentrated",
        "microplastic",
        "free",
        "clean",
        "alpini",
        "labs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 20,
        "manufacturing": 30,
        "safety": 25,
        "transparency": 15,
        "sustainability": 55
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170965508293",
      "vsf_explanation": "Laundry detergent is not a supplement in any sense; it does not belong in the vsf-supplement rubric. Ingredients (sodium carbonate, percarbonate, plant enzymes) are legitimate household cleaners but the product is miscategorised.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "daily-renewal-hand-body-lotion",
      "title": "Daily Renewal Hand & Body Lotion",
      "vendor": "AlpiniåLabs",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Daily_Renewal_Hand_Body_Lotion_1.png?v=1777849056",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "daily",
        "renewal",
        "hand",
        "body",
        "lotion",
        "alpini",
        "labs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 30,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170965311685",
      "vsf_explanation": "Topical body lotion, not an ingestible. Cloudberry oil + grapeseed + cucumber hydrosol is a reasonable emollient blend but the collagen-stimulation and dark-spot-reduction claims for topical vitamin C are dose-dependent and not disclosed (Traikovich 1999; Pinnell 2001 clinical studies used 5-20% L-ascorbic acid).",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "powerful-dishwasher-detergent-with-enzymes-no-microplastics-no-residue",
      "title": "Powerful Dishwasher Detergent with Enzymes — No Microplastics, No Residue",
      "vendor": "AlpiniåLabs",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/alpinia_dishwasherdetergent1.png?v=1777849056",
      "score": 12,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "powerful",
        "dishwasher",
        "detergent",
        "with",
        "enzymes",
        "microplastics",
        "residue",
        "alpini",
        "labs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 18,
        "manufacturing": 22,
        "safety": 45,
        "transparency": 15,
        "sustainability": 40
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170965999813",
      "vsf_explanation": "Dishwasher detergent - a household cleaner, not a supplement. Cannot be meaningfully scored against ingestible-supplement rubric.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "coconut-tonka-bean-natural-deodorant",
      "title": "Coconut & Tonka Bean Natural Deodorant",
      "vendor": "AlpiniåLabs",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/coconuttonkabeandeodorant.png?v=1777849056",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coconut",
        "tonka",
        "bean",
        "natural",
        "deodorant",
        "alpini",
        "labs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 28,
        "manufacturing": 28,
        "safety": 48,
        "transparency": 22,
        "sustainability": 40
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170965377221",
      "vsf_explanation": "Topical deodorant (coconut, cocoa butter, beeswax, baking soda, arrowroot). Not a supplement. Ingredients are conventional natural-personal-care; product is categorically mismatched to supplement rubric.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solid-kitchen-soap-bar-no-plastic-bottles-cuts-grease-better-than-liquid",
      "title": "Solid Kitchen Soap Bar - No Plastic Bottles, Cuts Grease Better Than Liquid",
      "vendor": "AlpiniåLabs",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_1_23feacc7-26c5-4ad5-bf8f-895f01877434.png?v=1777849056",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solid",
        "kitchen",
        "soap",
        "bar",
        "plastic",
        "bottles",
        "cuts",
        "grease",
        "better",
        "than",
        "liquid",
        "alpini",
        "labs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 45,
        "sustainability": 60
      },
      "price": 16,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170966491333",
      "vsf_explanation": "Dish soap. Not a supplement or personal-care active. Nice sustainability story (no plastic, no MI/BIT preservatives) but out of scope for a supplement rubric. Listed as required, scored Rejected on evidence/relevance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natural-shampoo-bar-with-edelweiss-ph-balancing-citric-acid",
      "title": "Natural Shampoo Bar with Edelweiss & pH Balancing Citric Acid",
      "vendor": "AlpiniåLabs",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/unscented-shampoobar.png?v=1777849056",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "natural",
        "shampoo",
        "bar",
        "with",
        "edelweiss",
        "balancing",
        "citric",
        "acid",
        "alpini",
        "labs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 30,
        "sustainability": 60
      },
      "price": 22,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170967146693",
      "vsf_explanation": "Solid shampoo bar - not a supplement. Edelweiss extract has some in-vitro antioxidant/DPPH data (Dobner 2003) but no clinical hair or scalp outcome trials. Miscategorised as supplement; scored low on evidence for that reason.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "fragrance-free-all-natural-deodorant",
      "title": "Fragrance Free All Natural Deodorant",
      "vendor": "AlpiniåLabs",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/unscent4ed_deodorant.png?v=1777849056",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fragrance",
        "free",
        "all",
        "natural",
        "deodorant",
        "alpini",
        "labs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 28,
        "manufacturing": 28,
        "safety": 50,
        "transparency": 22,
        "sustainability": 40
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170967015621",
      "vsf_explanation": "Fragrance-free topical deodorant. Not an ingestible supplement; miscategorized. Cannot be meaningfully scored on the supplement rubric.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "alpinia-s-natural-laundry-sample-bundle-christmas-gift-box-4-scents",
      "title": "Alpiniå’s Natural Laundry Sample Bundle – Christmas Gift Box (4 Scents)",
      "vendor": "AlpiniåLabs",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Holiday_Edition_laundrybundle.png?v=1777849067",
      "score": 12,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alpini",
        "natural",
        "laundry",
        "sample",
        "bundle",
        "christmas",
        "gift",
        "box",
        "scents",
        "alpini",
        "labs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 18,
        "manufacturing": 22,
        "safety": 45,
        "transparency": 15,
        "sustainability": 42
      },
      "price": 87.96,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170967310533",
      "vsf_explanation": "Laundry detergent gift bundle - a household cleaning product, not a supplement. Cannot be meaningfully scored against ingestible-supplement rubric.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "rosehip-shea-butter-facial-soap",
      "title": "Rosehip + Shea Butter Facial Soap",
      "vendor": "AlpiniåLabs",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Alpiniasoapvscommercialliquidsoap_12_8a9062e9-77f6-461f-ba61-52eb7c6513eb.png?v=1777849068",
      "score": 24,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "rosehip",
        "shea",
        "butter",
        "facial",
        "soap",
        "alpini",
        "labs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 30,
        "manufacturing": 30,
        "safety": 55,
        "transparency": 25,
        "sustainability": 35
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170967572677",
      "vsf_explanation": "Topical facial soap bar (rosehip, shea, tallow, olive, coconut oils). Not an ingestible supplement; miscategorized. Cannot be scored against supplement rubric.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "woodsage-sea-salt-soap",
      "title": "Woodsage & Sea Salt Soap",
      "vendor": "AlpiniåLabs",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/woodsage_soap.png?v=1777849068",
      "score": 33,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "woodsage",
        "sea",
        "salt",
        "soap",
        "alpini",
        "labs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 30,
        "sustainability": 55
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170967802053",
      "vsf_explanation": "Cold-process bar soap; a personal-care product, not a supplement. Kaolin/Cambrian blue clay are legitimate mild exfoliants but 'detoxifying' language is marketing, not clinical.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "woodsage-sea-salt-natural-deodorant",
      "title": "Woodsage & Sea Salt Natural Deodorant",
      "vendor": "AlpiniåLabs",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/woodsangedeodornat.png?v=1777849069",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "woodsage",
        "sea",
        "salt",
        "natural",
        "deodorant",
        "alpini",
        "labs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 28,
        "manufacturing": 28,
        "safety": 48,
        "transparency": 22,
        "sustainability": 40
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170971046085",
      "vsf_explanation": "Topical deodorant, not a supplement. Miscategorized. Cannot be meaningfully scored on the ingestible-supplement rubric.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ag1-athletic-greens-12-7-oz-360g-powder-supplement-pack-of-2",
      "title": "AG1 Athletic Greens 12.7 oz 360g Powder Supplement pack of 2",
      "vendor": "Athletic Greens",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitled_design_85_95fbe277-82f4-464b-86a1-947a022935b8.png?v=1777849106",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ag1",
        "athletic",
        "greens",
        "360g",
        "powder",
        "supplement",
        "pack",
        "athletic",
        "greens"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 48,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 67.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170999390405",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score undefined → new 58. Evidence found: Cannataro R, et al. The effects of AG1 supplementation on the gut microbiome of healthy adults: a randomized, double-blind, placebo-controlled clinical trial. J Int Soc Sports Nutr. 2024;21(1):2409682. DOI:10.1080/15502783.2024.2409682. PMID:39352252. | In vitro mineral bioaccessibility study (MDPI Proceedings 2026) showing AG1 delivers higher simulated-digestion mineral bioaccessibility than a comparator multivitamin tablet. | Nutritional adequacy and gut microbial composition study (Frontiers in Nutrition 2026) in trained adults. | AG1 direct-brand product carries NSF Certified for Sport certification. | Widely-cited scientific critique: AG1 contains ~75 ingredients at low individual doses relative to studied clinical protocols. Ashwagandha at ~100 mg vs KSM-66 Chandrasekhar 2012 dose of 600 mg; spirulina at ~100 mg vs studied doses of 1-8 g; adaptogen and mushroom doses subclinical relative to standalone-product RCTs.. Rationale: The original Rejected verdict was too harsh once the peer-reviewed evidence is inventoried honestly - Cannataro 2024 in the Journal of the International Society of Sports Nutrition is a real double-blind placebo-controlled RCT specifically on AG1 that hit both microbial enrichment (L. acidophilus, B. bifidum) and digestive quality-of-life endpoints. That is TIER-C brand-anchor evidence at minimum. AG1 also carries NSF Certified for Sport, which is a genuine banned-substance-tested credential. However, the dose-inflation critique remains fully valid: 75 ingredients spread across a 12 g scoop means each individual actives-ingredient is at a fraction of its own clinical-trial dose - ashwagandha at roughly 100 mg vs the 600 mg KSM-66 dose in Chandrasekhar 2012, spirulina at 100 mg vs 1-8 g in the metabolic literature. That structural constraint is why AG1 does not earn Verified/Elite regardless of brand halo. +16 uplift from Rejected 42 to Standard 58 is the honest calibration: real peer-reviewed data exists, but dose-per-ingredient economics keep the ceiling capped at Standard.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "premium-berberine-capsules",
      "title": "Premium Berberine Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HD_Image_1_f99f6694-e4d3-4776-8092-c5d1609cfd2f.png?v=1777849192",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "premium",
        "berberine",
        "capsules",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health",
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 30,
        "sustainability": 35
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170999619781",
      "vsf_explanation": "Berberine at 500mg 2-3x/day has RCT support for glycemic control (Yin 2008 Metabolism showed HbA1c reductions comparable to metformin), but this listing does not disclose the per-capsule berberine dose. Sub-therapeutic risk given the low $19.99 price point.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "keto-bhb-supplements-for-weight-loss",
      "title": "Keto BHB Supplements for Weight Loss",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HD_Image_2_ee514875-49ce-4072-90df-3d57f9d4c716.jpg?v=1777849191",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "keto",
        "bhb",
        "supplements",
        "for",
        "weight",
        "loss",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health",
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 23.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170999652549",
      "vsf_explanation": "Exogenous BHB salts do raise blood ketones acutely (Stubbs 2017) but do NOT cause weight loss independently - Cochrane / systematic reviews find no BW effect. Weight-loss claim on Keto BHB is unverified. BHB dose per serving not stated.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "thyroid-support-supplement",
      "title": "Thyroid Support Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HD_Image_2_be3024a3-4382-417b-aa08-718904447ebf.jpg?v=1777849196",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "thyroid",
        "support",
        "supplement",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 40,
        "transparency": 25,
        "sustainability": 35
      },
      "price": 35.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46170999980229",
      "vsf_explanation": "Multi-ingredient thyroid blend (iodine, selenium, L-tyrosine, ashwagandha, zinc, copper, B-vits, kelp, bladderwrack). No doses disclosed and combining kelp + bladderwrack + supplemental iodine risks thyrotoxicosis. Ashwagandha thyroid effect is real (Sharma 2018) but requires 600mg standardized KSM-66.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "natural-joint-health-supplement",
      "title": "Natural Joint Health Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HD_Image_2_dadc2a1f-adba-49c5-9798-f2a0515a13c8.jpg?v=1777849196",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "natural",
        "joint",
        "health",
        "supplement",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 25,
        "sustainability": 35
      },
      "price": 21.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171000045765",
      "vsf_explanation": "Glucosamine + chondroitin + MSM + calcium + vitamin D — a legitimate joint-health template. Clegg 2006 (GAIT trial, NEJM) showed 1500mg glucosamine + 1200mg chondroitin marginally helpful for moderate-severe OA. No doses disclosed here.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "premium-spectrum-collagen-capsules",
      "title": "Premium Spectrum Collagen Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HD_Image_2_9a3ed3b5-bea6-4e60-a3b2-eeb2b4653e34.jpg?v=1777849196",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "premium",
        "spectrum",
        "collagen",
        "capsules",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty",
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 30,
        "sustainability": 35
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171000012997",
      "vsf_explanation": "Types I/II/III/V/X collagen in a capsule. Collagen peptides for skin (Proksch 2014) and joint (Zdzieblik 2017) endpoints require 2.5-10g/day — impossible to reach from capsules. Source (bovine/marine/chicken) not disclosed.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "pure-creatine-monohydrate-supplement",
      "title": "Pure Creatine Monohydrate Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HD_Image_2_205b4db1-bfa2-4a68-b36b-8cce9983d941.jpg?v=1777849196",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "creatine",
        "monohydrate",
        "supplement",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 70,
        "transparency": 30,
        "sustainability": 35
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171000078533",
      "vsf_explanation": "Creatine monohydrate is the most-validated sport supplement (Kreider 2017 ISSN Position Stand, 5g/day). However this listing does not disclose per-serving grams, container size, or whether it is Creapure. Amazon-tier generic creatine at $26.99 raises purity concerns.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "complete-daily-multivitamin",
      "title": "Complete Daily Multivitamin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HD_Image_2_93619be8-0f24-4f78-b2f9-e82a549c28b6.png?v=1777849196",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "complete",
        "daily",
        "multivitamin",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 25,
        "sustainability": 35
      },
      "price": 21.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171000209605",
      "vsf_explanation": "General 'A/C/D/E/B-complex + zinc/magnesium' multi. No per-vitamin doses, no forms (methylated B12 vs cyanocobalamin, D3 vs D2 not specified). Multivitamin evidence for healthy adults is mixed (Sesso 2012 PHS-II showed modest cancer benefit).",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "premium-vitamin-c-serum-anti-aging",
      "title": "Premium Vitamin C Serum - Anti Aging",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/premium-vitamin-c-serum-anti-aging-hydrating-repairing-3.png?v=1777849196",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "premium",
        "vitamin",
        "serum",
        "anti",
        "aging",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171000307909",
      "vsf_explanation": "Generic vitamin C serum with no concentration (LAA %? THD-ascorbate?), no pH, no packaging protection detail — the three variables that determine whether topical vitamin C actually works (Pinnell 2001). White-label private-brand at $19.99. Capped by transparency/provenance.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "vegan-turmeric-root-with-curcumin",
      "title": "Vegan Turmeric Root with Curcumin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HD_Image_2_f654ecf3-d6a4-44d1-aafa-13c3112111e4.jpg?v=1777849196",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vegan",
        "turmeric",
        "root",
        "with",
        "curcumin",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 20.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171000111301",
      "vsf_explanation": "Turmeric + piperine combo is legitimate (Shoba 1998), and curcumin 500mg has anti-inflammatory RCT support (Panahi 2014). But this listing does not disclose curcuminoid % or per-capsule mg. Piperine is only mentioned as 'often combined' — unclear if included.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "cognitive-support-premium-nootropics-for-focus",
      "title": "Cognitive Support: Premium Nootropics for Focus",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HD_Image_2_690e0fb9-f054-414d-a68e-c6338ae1845d.jpg?v=1777849196",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cognitive",
        "support",
        "premium",
        "nootropics",
        "for",
        "focus",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 25,
        "sustainability": 35
      },
      "price": 20.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171000242373",
      "vsf_explanation": "Bacopa monnieri, Ginkgo biloba, phosphatidylserine, plus 'adaptogens' — legitimate nootropic scaffold but no doses. Bacopa needs 300mg standardized (Stough 2001), Ginkgo 240mg EGb 761 (Le Bars 1997), PS 300mg (Kato-Kataoka 2010) — none confirmed.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "ginkgo-biloba-and-ginseng-capsules",
      "title": "Ginkgo Biloba and Ginseng Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HD_Image_2_e3c04f95-8bed-4349-870b-aa96f16c3345.jpg?v=1777849196",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive",
        "energy",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ginkgo",
        "biloba",
        "and",
        "ginseng",
        "capsules",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics",
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 23.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171000144069",
      "vsf_explanation": "Ginkgo EGb 761 at 120-240mg/day (Le Bars 1997; Napryeyenko 2007) has real memory data; ginseng Rg1/Rb1 standardization matters (Reay 2005). Neither dose nor standardization is disclosed here.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "pure-hyaluronic-acid-serum",
      "title": "Pure Hyaluronic Acid Serum",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/lovelycsm-pure-hyaluronic-acid-serum-scenic-background-2.png?v=1777849197",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "hyaluronic",
        "acid",
        "serum",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171000406213",
      "vsf_explanation": "Generic HA serum. No molecular-weight disclosure — HA efficacy on skin depends heavily on MW range (Bukhari 2018). No brand history, ingredient list, or preservative system. Capped by provenance.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "energy-boost-drink-powder-fruit-punch",
      "title": "Energy Boost Drink Powder - Fruit Punch",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HD_Image_2_3ef719c1-b6f8-4e0d-adc5-6dc380c7c4d2.png?v=1777849197",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "energy",
        "boost",
        "drink",
        "powder",
        "fruit",
        "punch",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 40,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 24.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171000373445",
      "vsf_explanation": "Marketing-only listing: 'natural caffeine and essential nutrients' with no mg caffeine, no B-vitamin doses, no ingredient specifics. Cannot verify against any RCT.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "maca-energy-booster-capsules",
      "title": "MACA Energy Booster Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HD_Image_2_0a00328e-ce78-4e4a-8be3-170d962a2ecb.jpg?v=1777849196",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood",
        "energy",
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "maca",
        "energy",
        "booster",
        "capsules",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine",
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 20.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171000176837",
      "vsf_explanation": "Maca (Lepidium meyenii) has modest libido evidence (Gonzales 2002) at 1500-3000mg/day. Per-capsule maca dose not disclosed on listing. Maca color/type (yellow/red/black) unspecified — different phenotypes have different effects.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "chocolate-plant-protein-powder",
      "title": "Chocolate Plant Protein Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HD_Image_1_05125049-48b6-4cf8-9da1-2e828537a44a.jpg?v=1777849196",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chocolate",
        "plant",
        "protein",
        "powder",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 48.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171000275141",
      "vsf_explanation": "Pea + brown rice blend delivering 21g protein per serving — the combo covers pea's methionine gap and brown rice's lysine gap for a complete PDCAAS-adequate profile (Kalman 2019). No heavy-metal testing (Clean Label Project) disclosed; plant proteins often contain lead/cadmium.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pancreas-health-supplement",
      "title": "Pancreas Health Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HD_Image_2_0d18a529-b3f4-42a9-976a-6a88897066cb.jpg?v=1777849196",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pancreas",
        "health",
        "supplement",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 20,
        "sustainability": 35
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171000438981",
      "vsf_explanation": "Marketed to 'support pancreatic function and insulin regulation' — no ingredients or doses listed anywhere. Insulin-regulation claim is a disease claim requiring FDA drug approval.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "hydration-drink-powder-passion-fruit",
      "title": "Hydration Drink Powder - Passion Fruit",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HD_Image_1_96b63b0c-2d2a-4ece-a16a-89f307e06cfb.jpg?v=1777849196",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hydration",
        "drink",
        "powder",
        "passion",
        "fruit",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic",
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 24.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171000340677",
      "vsf_explanation": "Copy lists 'vitamin C, antioxidants, dietary fiber' with no mg values. Digestive-health and immune claims are non-specific and unverifiable at this dose transparency level.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "digestive-enzyme-supplement-capsules",
      "title": "Digestive Enzyme Supplement Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HD_Image_2_984ab948-dcf6-4407-a194-f71ad20fb941.jpg?v=1777849196",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "digestive",
        "enzyme",
        "supplement",
        "capsules",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 25,
        "sustainability": 35
      },
      "price": 20.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171000504517",
      "vsf_explanation": "Protease + lipase + amylase blend is standard digestive-enzyme formula. Enzyme activity is measured in FCC units (USP/HUT/DPP-IV) not milligrams — none disclosed. Enzyme supplements are only well-supported for pancreatic insufficiency (Whitcomb 2010).",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "retinol-skin-serum-anti-aging",
      "title": "Retinol Skin Serum Anti-Aging",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/lovelycsm-retinol-skin-serum-anti-aging-2-5-percent-vitamin-c-hyaluronic-acid-variation.png?v=1777849197",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "retinol",
        "skin",
        "serum",
        "anti",
        "aging",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171000471749",
      "vsf_explanation": "Generic retinol serum with no strength (0.1%? 0.5%? retinol vs retinaldehyde?). Retinoid efficacy is entirely concentration- and stability-dependent (Kong 2016). No brand provenance or stability packaging disclosure. Capped.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "energy-boost-drink-powder-guava-berry",
      "title": "Energy Boost Drink Powder - Guava Berry",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HD_Image_2_530ae286-d14f-4c94-addd-fec4dc16b9dc.png?v=1777849205",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "energy",
        "boost",
        "drink",
        "powder",
        "guava",
        "berry",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 40,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 24.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171000897733",
      "vsf_explanation": "Flavor variant of the Fruit Punch energy powder; same problem - 'natural caffeine and vital nutrients' phrase without a single mg disclosed. No RCT-comparable dose reference possible.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "premium-omega-3-for-heart-health",
      "title": "Premium Omega-3 for Heart Health",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HD_Image_2_04b1c351-1f18-43a8-8836-c4d3e8db0711.jpg?v=1777849205",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "premium",
        "omega",
        "for",
        "heart",
        "health",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 22.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171000930501",
      "vsf_explanation": "Fish-oil omega-3 for CV support has strong evidence (REDUCE-IT 2019 icosapent ethyl at 4g EPA). This listing does not disclose EPA/DHA milligrams, TG vs ester form, oxidation (TOTOX) values, or IFOS/GOED certification.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "hydration-drink-powder-lemonade",
      "title": "Hydration Drink Powder - Lemonade",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HD_Image_2_45756b8a-a0e2-4c0f-92a8-05c1263f0cef.png?v=1777849206",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hydration",
        "drink",
        "powder",
        "lemonade",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 24.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171000963269",
      "vsf_explanation": "'Potassium, magnesium, sodium' listed as electrolyte support but no mg values. Baker (2020) shows meaningful hydration performance requires ~500-1000mg Na - unverifiable here.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "grass-fed-collagen-peptides-powder",
      "title": "Grass-Fed Collagen Peptides Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HD_Image_2_9d1443dc-e9b3-4cd5-881e-90cebb0980b4.jpg?v=1777849207",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "grass",
        "fed",
        "collagen",
        "peptides",
        "powder",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty",
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 32.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171001094341",
      "vsf_explanation": "Grass-fed hydrolyzed bovine collagen types I & III. Proksch 2014 showed skin elasticity improvement at 2.5g/day and Zdzieblik 2017 showed joint benefit at 5g/day. Per-scoop protein grams not disclosed. Country of origin (Brazil vs US) not specified — matters for grass-fed authenticity.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "brain-focus-formula-with-a-b-zinc-and-chromium",
      "title": "Brain & Focus Formula with A, B, Zinc and Chromium",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HD_Image_2_82fcd642-db58-4454-8dd3-233ed9800d77.jpg?v=1777849207",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "brain",
        "focus",
        "formula",
        "with",
        "zinc",
        "and",
        "chromium",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 20.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171001127109",
      "vsf_explanation": "Vitamin A + B-complex + zinc + chromium is a plausible cognitive-adjacent micronutrient stack (Kennedy 2010), but the listing gives no mg or IU per serving and no specific nootropic actives (choline, tyrosine, etc.). Cannot verify vs any dose-response RCT.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "natural-fruits-and-veggies-capsules",
      "title": "Natural Fruits and Veggies Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HD_Image_2_648ace10-49fd-453b-9769-51d84b971612.jpg?v=1777849209",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "natural",
        "fruits",
        "and",
        "veggies",
        "capsules",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients",
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 19.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171001454789",
      "vsf_explanation": "Whole-food produce concentrates lose most water-soluble vitamins in processing. Juice Plus type products (best-studied analog) show only inconsistent CV/immune benefit. This listing gives no ingredient list or serving amounts.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "neuriva-ultra-nootropic-brain-supplement-60-capsules-clearance-sale",
      "title": "NEURIVA Ultra Nootropic Brain Supplement 60 Capsules - Clearance Sale",
      "vendor": "BalanceX",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/dp.webp?v=1777849257",
      "score": 58,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "neuriva",
        "ultra",
        "nootropic",
        "brain",
        "supplement",
        "capsules",
        "clearance",
        "sale",
        "balancex"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 65,
        "safety": 60,
        "transparency": 50,
        "sustainability": 40
      },
      "price": 24,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171004043461",
      "vsf_explanation": "Reckitt-manufactured (GMP) nootropic with branded actives — Cognivive (Alpinia galanga, 300 mg has an alertness RCT; Srivastava 2017), NeuroFactor coffee-cherry extract (100 mg raises plasma BDNF acutely; Reyes-Izquierdo 2013), plant phosphatidylserine, and B vitamins. Effect sizes on real-world cognition are modest and the product page does not fully list mg per active.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "glutathione-detox-supplement",
      "title": "Glutathione Detox Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HD_Image_2_4c29af68-cbc7-4515-9994-7e1f5ad4c985.jpg?v=1777849327",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glutathione",
        "detox",
        "supplement",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular",
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 25,
        "sustainability": 35
      },
      "price": 38.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171004141765",
      "vsf_explanation": "Reduced (non-liposomal) oral glutathione is poorly absorbed — Witschi 1992 showed no plasma GSH increase after oral dosing. Setria/S-acetyl or liposomal forms have evidence (Richie 2015). Milk thistle + ALA co-factors are present but doses undisclosed.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "vanilla-whey-protein-isolate",
      "title": "Vanilla Whey Protein Isolate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HD_Image_1_5e428d00-e1a0-4fd7-8b9a-26c2977c23e1.jpg?v=1777849327",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vanilla",
        "whey",
        "protein",
        "isolate",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 55,
        "sustainability": 40
      },
      "price": 59.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171004207301",
      "vsf_explanation": "22g whey isolate per serving is a legitimate post-workout protein dose — Morton 2018 meta showed 1.6g/kg/day protein optimizes lean-mass gain. Low-carb/low-fat isolate profile is transparent. No third-party testing (Informed Sport/NSF) or amino-acid spike-detection disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hydration-drink-powder-peach-mango",
      "title": "Hydration Drink Powder - Peach Mango",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HD_Image_1_b8f04d1b-f6a1-43ed-843e-e3a93dbde1f3.jpg?v=1777849327",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hydration",
        "drink",
        "powder",
        "peach",
        "mango",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 24.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171004174533",
      "vsf_explanation": "Third flavor variant of the AOV hydration powder; identical labelling deficiencies - electrolyte content described in text only, no per-mineral mg disclosed.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "normal-blood-sugar-supplement",
      "title": "Normal Blood Sugar Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HD_Image_2_ea61138e-e043-480a-9476-86a47154a8a6.jpg?v=1777849327",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "normal",
        "blood",
        "sugar",
        "supplement",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health",
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 25,
        "sustainability": 35
      },
      "price": 20.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171004272837",
      "vsf_explanation": "Cinnamon + chromium + berberine is a reasonable glycemic-support scaffold (Yin 2008 for berberine 1500mg/day). No per-ingredient doses. Berberine + medication interactions (metformin, statins via CYP3A4) not warned. Insulin-sensitivity claim borders on disease claim.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "apple-cider-vinegar-capsules-natural-digestion-metabolism-support",
      "title": "Apple Cider Vinegar Capsules – Natural Digestion & Metabolism Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HD_Image_2.jpg?v=1777849327",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "apple",
        "cider",
        "vinegar",
        "capsules",
        "natural",
        "digestion",
        "metabolism",
        "support",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health",
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 18.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171004338373",
      "vsf_explanation": "ACV weight/metabolism evidence is weak — Kondo 2009 showed only ~1kg loss over 12 weeks at 15-30ml liquid/day. Capsule doses (500-1500mg) cannot approximate this liquid dose. Acetic acid concentration and 'mother' content not disclosed.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "vanilla-plant-protein-powder",
      "title": "Vanilla Plant Protein Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HD_Image_1_789c24fa-553f-42ad-b759-10a5231d1fca.jpg?v=1777849327",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vanilla",
        "plant",
        "protein",
        "powder",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 48.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171004240069",
      "vsf_explanation": "Pea + brown rice blend at 20g per serving offers complete essential-amino-acid profile (Kalman 2019). Comparable muscle-protein-synthesis to whey when leucine-matched (Joy 2013). No heavy-metal testing (Clean Label Project) or PDCAAS/DIAAS disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "probiotic-40-billion-with-prebiotics",
      "title": "Probiotic 40 Billion with Prebiotics",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HD_Image_2_ed6f3b86-6081-4d6f-9242-7ee16c7ae41a.jpg?v=1777849327",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "probiotic",
        "billion",
        "with",
        "prebiotics",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive",
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 22.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171004305605",
      "vsf_explanation": "40 billion CFU is a reasonable dose but probiotic efficacy is strain-specific (Sanders 2019 ISAPP), and no strain identifiers (e.g. Lactobacillus rhamnosus GG, Bifidobacterium longum BB536) are given. 'Shelf-stable' claim without refrigeration is possible but usually means overage.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "bone-and-heart-support-with-vitamin-k2-d3-60-capsules",
      "title": "Bone and Heart Support with Vitamin K2 & D3 - 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HD_Image_1_89037d2c-c534-479a-96e9-7890e273e4a3.jpg?v=1777849327",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bone",
        "and",
        "heart",
        "support",
        "with",
        "vitamin",
        "capsules",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective",
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 23.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171004371141",
      "vsf_explanation": "K2 (MK-4/MK-7) + D3 combo has real bone/cardiovascular calcium-partitioning evidence (Knapen 2013 for MK-7 180mcg). Doses and K2 form (MK-4 vs MK-7) not disclosed. Includes calcium — over-supplementation of calcium may raise CV risk (Bolland 2010).",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "energy-boost-drink-powder-strawberry-shortcake",
      "title": "Energy Boost Drink Powder - Strawberry Shortcake",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HD_Image_1_3c0b9068-6728-4f64-8326-aa452cf743da.jpg?v=1777849328",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "energy",
        "boost",
        "drink",
        "powder",
        "strawberry",
        "shortcake",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 40,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 24.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171004403909",
      "vsf_explanation": "Fourth flavor of the AOV energy powder line, same defect - no caffeine mg or B-vitamin dose disclosed. Cannot match to any efficacy literature.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "colostrum-powder-immune-boost-gut-repair-supplement",
      "title": "Colostrum Powder – Immune Boost & Gut Repair Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HD_Image_2_9c3c4d2d-82c5-403f-89dd-3ebe0605d9f5.jpg?v=1777849327",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "colostrum",
        "powder",
        "immune",
        "boost",
        "gut",
        "repair",
        "supplement",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants",
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 23.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171004436677",
      "vsf_explanation": "Bovine colostrum has modest evidence for upper-respiratory infection prevention (Patel 2016 meta) and intestinal permeability (Playford 2001) at 20-60g/day. Per-scoop grams and IgG concentration not disclosed. Low-heat processing and third-party testing claim are positives but no COA published.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "silver-infusion-150-ppm-chelated-silver-oxide-dietary-supplement-2-oz-spray",
      "title": "Silver Infusion 150 PPM Chelated Silver Oxide Dietary Supplement - 2 oz. Spray",
      "vendor": "3rd Rock Essentials",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1-Silver_Infusion_Spray_With_Box.png?v=1777849380",
      "score": 25,
      "tier": "rejected",
      "certifications": [
        "Kosher"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "silver",
        "infusion",
        "150",
        "ppm",
        "chelated",
        "silver",
        "oxide",
        "dietary",
        "supplement",
        "spray",
        "3rd",
        "rock",
        "essentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 30,
        "manufacturing": 40,
        "safety": 15,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 18.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171004469445",
      "vsf_explanation": "150 PPM chelated silver oxide spray positioned as an ingestible 'dietary supplement' — 15x more concentrated than typical colloidal silver. FDA 1999 ruling: silver-containing OTC drugs are neither safe nor effective; chronic ingestion causes argyria (Wadhera 2005 case series). Adults & children dosing instructions are irresponsible.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "nutroleum™-non-petroleum-skin-balm-water-resistant-3-oz",
      "title": "Nutroleum™ Non-Petroleum Skin Balm - Water Resistant 3 oz.",
      "vendor": "3rd Rock Essentials",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1-Nutroleum_WR_With_Box.png?v=1777849379",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutroleum",
        "non",
        "petroleum",
        "skin",
        "balm",
        "water",
        "resistant",
        "3rd",
        "rock",
        "essentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 65,
        "sustainability": 60
      },
      "price": 15.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171004600517",
      "vsf_explanation": "Non-petroleum barrier balm (USP glycerin + beeswax with propolis + glucoside emulsifier). Full ingredient disclosure, food-grade actives, plausible occlusive mechanism. Not a supplement per se, but a solid petroleum-jelly alternative — no clinical RCTs but ingredient-level safety is well established.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrasporin®-3oz-jar-all-natural-first-aid-ointment-100ppm-silver-gel-water-resistant",
      "title": "Nutrasporin® - 3oz JAR - All Natural First Aid Ointment 100ppm Silver Gel (Water Resistant)",
      "vendor": "3rd Rock Essentials",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1-Nutrasporin_WR_Jar_With_Box.png?v=1777849380",
      "score": 22,
      "tier": "rejected",
      "certifications": [
        "Kosher"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrasporin",
        "3oz",
        "jar",
        "all",
        "natural",
        "first",
        "aid",
        "ointment",
        "100ppm",
        "silver",
        "gel",
        "water",
        "resistant",
        "3rd",
        "rock",
        "essentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 15,
        "manufacturing": 35,
        "safety": 40,
        "transparency": 25,
        "sustainability": 32
      },
      "price": 45.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171004534981",
      "vsf_explanation": "Topical silver gel first-aid ointment, not an ingestible supplement. Colloidal/chelated silver topicals lack the RCT support of silver sulfadiazine, and Neosporin-comparison claims exceed evidence. Miscategorized in this batch.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "silver-excelsior-serum-4000-ppm-silver-oxide-dietary-supplement",
      "title": "Silver Excelsior Serum - 4000 PPM Silver Oxide Dietary Supplement",
      "vendor": "3rd Rock Essentials",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1-Silver_Excelsior_With_Box.png?v=1777849380",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "silver",
        "excelsior",
        "serum",
        "4000",
        "ppm",
        "silver",
        "oxide",
        "dietary",
        "supplement",
        "3rd",
        "rock",
        "essentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 5,
        "formulation": 10,
        "manufacturing": 20,
        "safety": 5,
        "transparency": 20,
        "sustainability": 15
      },
      "price": 119.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171004797125",
      "vsf_explanation": "Oral silver oxide supplements have no established therapeutic benefit and carry documented risk of argyria (irreversible skin discoloration) plus renal/neurologic toxicity (FDA 1999 final rule declared OTC colloidal silver ingredients not GRAS/GRAE). No RCT evidence supports 4000 ppm chelated silver ingestion; product implies medicinal use without approved indication.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "vitamin-d3-k2-liquid-chelated-1-fl-oz",
      "title": "Vitamin D3 + K2 Liquid (Chelated) — 1 fl oz",
      "vendor": "3rd Rock Essentials",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1-D3K2_With_Box.png?v=1777849380",
      "score": 61,
      "tier": "standard",
      "certifications": [
        "Kosher"
      ],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "liquid",
        "chelated",
        "3rd",
        "rock",
        "essentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 55,
        "sustainability": 42
      },
      "price": 28.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171004666053",
      "vsf_explanation": "Liquid D3 4000 IU + K2 as MK-7 90mcg per 5 drops. D3 + K2 co-supplementation is grounded (Kuang et al. 2020 meta-analysis for bone), MK-7 is the preferred long half-life K2 form. Dose is meaningful and combinations are well-selected; 'chelated' marketing on a fat-soluble vitamin is misleading but formulation itself is sound.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "3rd-rock-essentials-silver-infusion-150-ppm-chelated-silver-oxide-complex-16-fl-oz",
      "title": "3rd Rock Essentials Silver Infusion – 150 PPM Chelated Silver Oxide Complex – 16 fl oz",
      "vendor": "3rd Rock Essentials",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1-Silver_Infusion_Big_With_Box.png?v=1777849380",
      "score": 25,
      "tier": "rejected",
      "certifications": [
        "Kosher"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "3rd",
        "rock",
        "essentials",
        "silver",
        "infusion",
        "150",
        "ppm",
        "chelated",
        "silver",
        "oxide",
        "complex",
        "3rd",
        "rock",
        "essentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 30,
        "manufacturing": 30,
        "safety": 25,
        "transparency": 35,
        "sustainability": 30
      },
      "price": 69.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171004731589",
      "vsf_explanation": "Colloidal/chelated silver product at 150 ppm. FDA has warned that colloidal silver is neither safe nor effective for any claimed use, and chronic ingestion can cause irreversible argyria (Fung 1996). No clinical evidence supports oral silver supplementation.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "nutrasporin®-all-natural-first-aid-ointment-100ppm-silver-gel-water-resistant",
      "title": "Nutrasporin® - All Natural First Aid Ointment 100ppm Silver Gel (Water Resistant)",
      "vendor": "3rd Rock Essentials",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nutrasporin_WR_tube_box_2048x2048_96c2e521-8444-4c90-8539-c1d05a117cc3.png?v=1777849385",
      "score": 32,
      "tier": "rejected",
      "certifications": [
        "Kosher"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrasporin",
        "all",
        "natural",
        "first",
        "aid",
        "ointment",
        "100ppm",
        "silver",
        "gel",
        "water",
        "resistant",
        "3rd",
        "rock",
        "essentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 30,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 16.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171004862661",
      "vsf_explanation": "Chelated silver oxide topical ointment marketed as a Neosporin alternative for burns, cuts, and infections. Silver's antimicrobial evidence in humans is limited (Lansdown 2010 review) and self-treatment of wounds with silver ointment is not FDA-approved. Positioned as disease treatment without clinical trials backing efficacy.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "nutrasporin®-all-natural-first-aid-ointment-100ppm-silver-gel",
      "title": "Nutrasporin® - All Natural First Aid Ointment 100ppm Silver Gel",
      "vendor": "3rd Rock Essentials",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Updated_Nutrasporin_Water_Soluble.png?v=1777849385",
      "score": 32,
      "tier": "rejected",
      "certifications": [
        "Kosher"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrasporin",
        "all",
        "natural",
        "first",
        "aid",
        "ointment",
        "100ppm",
        "silver",
        "gel",
        "3rd",
        "rock",
        "essentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 30,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 16.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171004928197",
      "vsf_explanation": "Water-soluble variant of the same silver oxide ointment. Same evidence gap and disease-treatment positioning as the water-resistant SKU. Silver's topical antimicrobial data (Chopra 2007) does not extend to consumer OTC wound-care substitution without regulatory clearance.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "tension-release-gel-with-arnica",
      "title": "Tension Release Gel with Arnica",
      "vendor": "3rd Rock Essentials",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/tension_release_gel.webp?v=1777849384",
      "score": 28,
      "tier": "rejected",
      "certifications": [
        "Kosher"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tension",
        "release",
        "gel",
        "with",
        "arnica",
        "3rd",
        "rock",
        "essentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 35,
        "manufacturing": 40,
        "safety": 35,
        "transparency": 30,
        "sustainability": 50
      },
      "price": 145.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171004993733",
      "vsf_explanation": "Topical arnica gel with 'proprietary energy infusion' and 'particle technology' claims quantified injuries reduction of 80% and REM improvement of 90%. Arnica topical evidence for bruising is modest (Leu 2010 RCT); the specific efficacy percentages are unverified marketing.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "daily-liquid-multivitamin-minerals",
      "title": "Daily Liquid Multivitamin + Minerals",
      "vendor": "Passion 4 Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/DLMM_PDP_01.webp?v=1777849407",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "daily",
        "liquid",
        "multivitamin",
        "minerals",
        "passion",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 65,
        "safety": 60,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 45.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171005059269",
      "vsf_explanation": "Family-owned since 2007 with Clean Label Project Purity Award (tested for 200+ contaminants) - a legitimate manufacturing/safety differentiator. Liquid format aids absorption for bariatric/celiac users. However 100+ nutrient claim without per-nutrient mg on the listing and 'GLP-1 companion' framing (Baggio 2024 GLP-1 nutrient status literature) is aspirational rather than evidenced.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "d3-k2-omega-3-daily-liquid-vitamins",
      "title": "D3, K2 & Omega-3 Daily Liquid Vitamins",
      "vendor": "Passion 4 Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/D3K2O3_PDP_01.webp?v=1777849412",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "omega",
        "daily",
        "liquid",
        "vitamins",
        "passion",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 15.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171005092037",
      "vsf_explanation": "Combines three well-studied nutrients (D3, K2 MK-7, EPA/DHA) but the listing discloses zero doses, no EPA:DHA ratio, no source (e.g., lanolin vs. plant D3), no third-party testing, and no vendor manufacturing detail — leaving the buyer unable to verify therapeutic exposure. Without disclosed doses, evidence base (e.g., Bischoff-Ferrari 2020 D3 RCT) cannot be honestly claimed.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "whey-protein-vanilla-12-single-serve-pouches",
      "title": "Whey Protein - Vanilla (12 Single-Serve Pouches)",
      "vendor": "OIAM",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/oiam-whey-protein-isolate-vanilla-mockup_1.png?v=1777870404",
      "score": 71,
      "tier": "verified",
      "certifications": [
        "NSF Certified for Sport"
      ],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "whey",
        "protein",
        "vanilla",
        "single",
        "serve",
        "pouches",
        "oiam"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 68,
        "manufacturing": 82,
        "safety": 78,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 36,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171352268997",
      "vsf_explanation": "Grass-fed whey isolate with ProHydrolase (protease enzyme blend, has some evidence for absorption per Townsend J Am Coll Nutr 2018) plus BioCore digestive enzymes. NSF Certified for Sport is the strongest third-party athletic-purity credential available, driving high manufacturing/safety scores. Per-serving protein grams not shown in listing body.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "creatine-monohydrate-1",
      "title": "Creatine Monohydrate",
      "vendor": "OIAM",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/01_PDP_MainImage_CreatineMonohydrate.png?v=1777870404",
      "score": 67,
      "tier": "standard",
      "certifications": [
        "NSF Certified for Sport"
      ],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "creatine",
        "monohydrate",
        "oiam"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 82,
        "formulation": 70,
        "manufacturing": 55,
        "safety": 78,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171352236229",
      "vsf_explanation": "5g micronized creatine monohydrate per serving — the most-studied ergogenic aid in sports nutrition (Kreider et al. 2017 ISSN position stand: strength, lean mass, recovery, cognitive support). Correct dose and form. Loses points vs. Momentous-Verified anchor for lack of Creapure branded raw material or third-party testing disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "collagen-watermelon",
      "title": "Collagen - Watermelon",
      "vendor": "OIAM",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/collagen-jar-watermelon-mockup_8bbbd63d-89d0-43cc-9c28-957704a0c3db.png?v=1777870404",
      "score": 66,
      "tier": "standard",
      "certifications": [
        "NSF Certified for Sport"
      ],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "collagen",
        "watermelon",
        "oiam"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 72,
        "manufacturing": 55,
        "safety": 75,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 50,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171352334533",
      "vsf_explanation": "Same 15g triple-branded-peptide stack as the unflavored SKU: Fortigel 5g (Zdzieblik 2017 knee OA RCT), Tendoforte 5g (tendon), Peptiplus 5g (Proksch 2014 skin) plus vitamin C, zinc, hyaluronic acid, and choline-stabilized orthosilicic acid. Doses match published RCTs. Loses points on no NSF/USP verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "collagen-watermelon-15-single-serve-pouches",
      "title": "Collagen - Watermelon (15 Single-Serve Pouches)",
      "vendor": "OIAM",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/collagen-packet-watermelon-mockup_32233bd9-00ed-4645-b1cf-01dd32abd4a2.png?v=1777870404",
      "score": 66,
      "tier": "standard",
      "certifications": [
        "NSF Certified for Sport"
      ],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "collagen",
        "watermelon",
        "single",
        "serve",
        "pouches",
        "oiam"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 72,
        "manufacturing": 55,
        "safety": 75,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171352432837",
      "vsf_explanation": "Identical Fortigel + Tendoforte + Peptiplus 15g triple-peptide stack in single-serve pouch format. Evidence base is the same set of RCTs on the individual branded peptides at label dose. Loses points on no NSF/USP third-party certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "collagen-unflavored-15-single-serve-pouches",
      "title": "Collagen - Unflavored (15 Single-Serve Pouches)",
      "vendor": "OIAM",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/collagen-peptides-unflavored-packet-mock-up.png?v=1777870405",
      "score": 66,
      "tier": "standard",
      "certifications": [
        "NSF Certified for Sport"
      ],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "collagen",
        "unflavored",
        "single",
        "serve",
        "pouches",
        "oiam"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 72,
        "manufacturing": 55,
        "safety": 75,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171352367301",
      "vsf_explanation": "Uses three branded, individually-dosed hydrolyzed collagen peptides — Fortigel 5g (Zdzieblik 2017 RCT for knee OA), Tendoforte 5g (Praet 2019 tendon), Peptiplus 5g (Proksch 2014 skin) — plus 100mg vitamin C for collagen synthesis. Doses match published trials, which is unusual for the category. Loses points on no NSF/USP third-party certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "collagen-liquid-raspberry-30-single-serve-pouches",
      "title": "Collagen - Liquid: Raspberry (30 Single-Serve Pouches)",
      "vendor": "OIAM",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/collagen-shot-box-mockup_1.png?v=1777870409",
      "score": 66,
      "tier": "standard",
      "certifications": [
        "NSF Certified for Sport"
      ],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "collagen",
        "liquid",
        "raspberry",
        "single",
        "serve",
        "pouches",
        "oiam"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 72,
        "manufacturing": 55,
        "safety": 75,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 75,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171353481413",
      "vsf_explanation": "Liquid single-serve version of OIAM's peptide stack — Fortigel 5g + Tendoforte 5g + Bovine Collagen 5g + 150mg hyaluronic acid + vitamin C and zinc. Same underlying branded-peptide RCT support (Zdzieblik 2017, Praet 2019) as OIAM's powder SKUs. Liquid convenience without sacrificing dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "creatine-monohydrate-45-single-serve-stick-packs",
      "title": "Creatine Monohydrate (45 Single-Serve Stick Packs)",
      "vendor": "OIAM",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/creatine-box-stick-mockup-v3.png?v=1777870410",
      "score": 68,
      "tier": "standard",
      "certifications": [
        "NSF Certified for Sport"
      ],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "creatine",
        "monohydrate",
        "single",
        "serve",
        "stick",
        "packs",
        "oiam"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 80,
        "formulation": 70,
        "manufacturing": 50,
        "safety": 78,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171353579717",
      "vsf_explanation": "5g single-ingredient micronized creatine monohydrate — the most-studied sports supplement, hundreds of RCTs at exactly this dose (Kreider 2017 ISSN position stand). Held below the Momentous Creatine anchor (~76) because there is no Creapure® or third-party purity certification declared, which matters for a raw material where impurities occur.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "whey-protein-unflavored",
      "title": "Whey Protein - Unflavored",
      "vendor": "OIAM",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/protein-unflavored-mock-up.png?v=1777870410",
      "score": 71,
      "tier": "verified",
      "certifications": [
        "NSF Certified for Sport"
      ],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "whey",
        "protein",
        "unflavored",
        "oiam"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 68,
        "manufacturing": 82,
        "safety": 78,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 65.22,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171353514181",
      "vsf_explanation": "Same NSF Certified for Sport grass-fed whey isolate with ProHydrolase + BioCore, sold as 30-serving tub. NSF for Sport testing (WADA-banned substances screened every batch) is elite manufacturing signal. Unflavored form has fewest additives.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "whey-protein-chocolate",
      "title": "Whey Protein - Chocolate",
      "vendor": "OIAM",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Rendering_Whey_Protein_Chocolate.png?v=1777870410",
      "score": 71,
      "tier": "verified",
      "certifications": [
        "NSF Certified for Sport"
      ],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "whey",
        "protein",
        "chocolate",
        "oiam"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 68,
        "manufacturing": 82,
        "safety": 78,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 65.22,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171353546949",
      "vsf_explanation": "30-serving chocolate SKU of the OIAM NSF-Certified-for-Sport whey isolate line. Same ProHydrolase + BioCore enzyme addition. NSF for Sport third-party purity testing places this in the athlete-grade tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "collagen-unflavored",
      "title": "Collagen - Unflavored",
      "vendor": "OIAM",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/collagen-jar-unflavored-mockup.png?v=1777870409",
      "score": 66,
      "tier": "standard",
      "certifications": [
        "NSF Certified for Sport"
      ],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "collagen",
        "unflavored",
        "oiam"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 72,
        "manufacturing": 55,
        "safety": 75,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 50,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171353612485",
      "vsf_explanation": "Same 15g Fortigel + Tendoforte + Peptiplus triple-peptide stack in 30-serving tub. Branded peptides carry their own RCT support (Zdzieblik 2017 joint, Proksch 2014 skin) at label doses. Loses points on no NSF/USP verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "whey-protein-vanilla",
      "title": "Whey Protein - Vanilla",
      "vendor": "OIAM",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Rendering_Whey_Protein_Vanilla.png?v=1777870410",
      "score": 71,
      "tier": "verified",
      "certifications": [
        "NSF Certified for Sport"
      ],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "whey",
        "protein",
        "vanilla",
        "oiam"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 68,
        "manufacturing": 82,
        "safety": 78,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 65.22,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171353710789",
      "vsf_explanation": "30-serving vanilla SKU of the OIAM NSF-Certified-for-Sport grass-fed whey isolate line with ProHydrolase + BioCore enzyme complex. NSF for Sport batch testing confirms banned-substance purity.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "whey-protein-chocolate-12-single-serve-pouches",
      "title": "Whey Protein - Chocolate (12 Single Serve Pouches)",
      "vendor": "OIAM",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/oiam-whey-protein-isolate-chocolate-mockup_1.png?v=1777870409",
      "score": 71,
      "tier": "verified",
      "certifications": [
        "NSF Certified for Sport"
      ],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "whey",
        "protein",
        "chocolate",
        "single",
        "serve",
        "pouches",
        "oiam"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 68,
        "manufacturing": 82,
        "safety": 78,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 36,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171353645253",
      "vsf_explanation": "12-pouch single-serve chocolate SKU of the OIAM NSF-Certified-for-Sport whey isolate line. NSF for Sport banned-substance testing on every batch is the highest independent purity credential.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "yeast-clear",
      "title": "Yeast Clear",
      "vendor": "NeuEve",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/YeastClear_Front_Suppository_2.jpg?v=1777870457",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "yeast",
        "clear",
        "neueve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 35,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171363147973",
      "vsf_explanation": "Vaginal suppository marketed to 'treat vaginal yeast infection' and 'clear all yeast species.' Vulvovaginal candidiasis is a diagnosed medical condition; standard-of-care is topical or oral antifungals (Sobel 2007 NEJM review). No RCT for this specific botanical suppository; the treatment claim is drug territory.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "bv-clear",
      "title": "BV Clear",
      "vendor": "NeuEve",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BvClear_Front-_-Suppository_2.jpg?v=1777870462",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "clear",
        "neueve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 35,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171364196549",
      "vsf_explanation": "Vaginal suppository marketed to 'treat bacterial vaginosis.' BV is a clinical diagnosis with metronidazole/clindamycin as standard of care (Bradshaw 2006 review). No published RCT for NeuEve BV Clear; treatment claim is unsupported drug positioning.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "silver",
      "title": "Silver",
      "vendor": "NeuEve",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Silver_Front_Suppository_2.jpg?v=1777870463",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "silver",
        "neueve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171364229317",
      "vsf_explanation": "Vaginal suppository (topical), not an ingestible supplement - miscategorised. Ingredient list is organic, hormone/paraben/glycol-free, and includes evening primrose + sea buckthorn oils used in menopausal-atrophy comfort but without RCT support for the vaginal-suppository delivery.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "silk",
      "title": "Silk",
      "vendor": "NeuEve",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Silk_Front_Suppository_2.jpg?v=1777870462",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "silk",
        "neueve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171364294853",
      "vsf_explanation": "Same NeuEve suppository family, 'Silk' variant tuned for severe dryness. Clean ingredient list and Chicago small-batch manufacturing are transparency positives, but this is a topical women's-health product miscategorised under supplements.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "assorted",
      "title": "Assorted",
      "vendor": "NeuEve",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Assorted_Front_Suppository_2.jpg?v=1777870462",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "assorted",
        "neueve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 40,
        "sustainability": 55
      },
      "price": 76,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171364262085",
      "vsf_explanation": "Assorted trial kit of NeuEve vaginal suppositories 'for women under 55' targeting menopausal dryness and vaginal discomfort. Same core formula as other NeuEve SKUs; positioned to address atrophy/dryness where topical vaginal estrogen is standard (ACOG 2020). Formula lacks a published clinical trial.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "gold",
      "title": "Gold",
      "vendor": "NeuEve",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Gold_Front_Suppository_2_0e60198d-4826-4481-ac43-b198a5652fbb.jpg?v=1777870463",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gold",
        "neueve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171364393157",
      "vsf_explanation": "Gold variant adds calendula and linden blossom oils on top of the Silver base. Topical suppository, not an ingestible. Ingredient hygiene is high; clinical outcome evidence for herbal-oil suppositories is absent.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "bv-clear-finisher",
      "title": "BV Clear Finisher",
      "vendor": "NeuEve",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BvClearFinisher_Front_Suppository_2.jpg?v=1777870463",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "clear",
        "finisher",
        "neueve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 40,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 48,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171364425925",
      "vsf_explanation": "Follow-on BV suppository for cases where BV Clear did not resolve. Efficacy percentages (62% within 24h, 91% one-pack) come from an internal 98-customer survey, not a randomized trial. Same disease-treatment positioning as BV Clear.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "salve-gentle",
      "title": "Salve - Gentle",
      "vendor": "NeuEve",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Salve-Gentle_Front.jpg?v=1777870463",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "salve",
        "gentle",
        "neueve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171364491461",
      "vsf_explanation": "External vulvar salve customized for women over 70. Topical, not ingestible. All-organic oil base is safety-conservative but there is no RCT evidence base for salve formulations in postmenopausal vulvovaginal atrophy.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "vaginal-probiotic",
      "title": "Vaginal Probiotic",
      "vendor": "NeuEve",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/VaginalProbiotic_Front_Capsules_2.jpg?v=1777870463",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vaginal",
        "probiotic",
        "neueve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 38,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171364524229",
      "vsf_explanation": "Multi-strain Lactobacillus probiotic marketed for BV/yeast infections. Oral Lactobacillus reuteri/rhamnosus GR-1 has some evidence for BV recurrence (Vujic 2013), but specific strains and CFU counts are not disclosed. Product also makes disease-prevention claims (yeast infection, bacterial vaginosis).",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "multivitamin",
      "title": "Multivitamin",
      "vendor": "NeuEve",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Multivitamin_Front_Capsule_2.jpg?v=1777870463",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "multivitamin",
        "neueve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 50,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 30,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171364556997",
      "vsf_explanation": "Menopause-oriented multivitamin marketed around green superfoods and herbal extracts. The copy describes the concept but doesn't publish the Supplement Facts panel with per-nutrient % DV. Multis have mixed cognition/CV outcome data (COSMOS 2022) so the ceiling is Standard even for well-formulated ones.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "applicator",
      "title": "Applicator",
      "vendor": "NeuEve",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Applicator_Inside_Out.jpg?v=1777870463",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "applicator",
        "neueve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171364458693",
      "vsf_explanation": "Reusable BPA-free LLDPE plastic applicator sized to fit NeuEve vaginal suppositories (11mm internal diameter). Not a supplement — a device accessory. No health claims, straightforward material transparency; scored on device merits rather than the ingestible rubric.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "urinary-support",
      "title": "Urinary Support",
      "vendor": "NeuEve",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/UrinarySupport_Front_Pill_2.jpg?v=1777870463",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "urinary",
        "support",
        "neueve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 30,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171364655301",
      "vsf_explanation": "Cranberry + D-mannose combo for UTI defense — both ingredients have meaningful evidence. D-mannose 2 g/day reduced recurrent UTI vs no prophylaxis and matched nitrofurantoin in Kranjcec 2014, and cranberry PACs have Cochrane support (Williams 2023). The copy does not disclose mg of PAC or grams of D-mannose per serving, so it caps at Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "feminine-moisture-support",
      "title": "Feminine Moisture Support",
      "vendor": "NeuEve",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/FeminineMoistureSupport_Front_Pill_2_4fb3f728-47b4-4281-945d-3199850b9d6d.jpg?v=1777870463",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "feminine",
        "moisture",
        "support",
        "neueve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 48,
        "safety": 60,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 38,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171364786373",
      "vsf_explanation": "Sea buckthorn omega-7 oil for vaginal dryness. Larmo 2014 RCT of 116 postmenopausal women showed sea buckthorn oil (3 g/day for 3 months) improved vaginal epithelial integrity vs placebo. Product dose not disclosed in description. Modest single-ingredient formulation with clear mechanism but limited manufacturing transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "salve",
      "title": "Salve",
      "vendor": "NeuEve",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Salve_Front.jpg?v=1777870463",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "salve",
        "neueve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171364589765",
      "vsf_explanation": "Standard-potency Salve variant. Topical vulvar product, not ingestible. Clean organic ingredient panel, Chicago small-batch. Same evidence gap on outcome claims.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "yeast-reset",
      "title": "Yeast Reset",
      "vendor": "NeuEve",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/YeastReset_Front_Capsule.jpg?v=1777870463",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "yeast",
        "reset",
        "neueve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171364688069",
      "vsf_explanation": "Anti-candida stack led by pau d'arco. Pau d'arco (lapachol/beta-lapachone) has in-vitro antifungal activity but human RCTs for candidiasis are absent. Positioned as an adjunct to NeuEve's vaginal inserts. Doses per capsule not disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natural-drain",
      "title": "Natural Drain",
      "vendor": "NeuEve",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NaturalDrain_Front_Capsule_2.jpg?v=1777870463",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "natural",
        "drain",
        "neueve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 20,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171364720837",
      "vsf_explanation": "Traditional diuretic blend — potassium, uva ursi, dandelion. Uva ursi (arbutin) has short-term antimicrobial UTI use only (Beaux 1999) and long-term safety is limited by hepatic concerns. Dandelion has modest diuretic data (Clare 2009). Doses not shown.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cv-clear",
      "title": "CV Clear",
      "vendor": "NeuEve",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CV-Clear-Front_Suppository_2.jpg?v=1777870463",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "clear",
        "neueve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 40,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 48,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171364622533",
      "vsf_explanation": "Vaginal suppository for cytolytic vaginosis (CV) discomfort. CV is a diagnosis of elevated Lactobacillus overgrowth; standard treatment is alkalinizing baking-soda douching (Cerikcioglu 2004). No published RCT for this botanical suppository against CV.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "av-clear",
      "title": "AV Clear",
      "vendor": "NeuEve",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/AvClear_Front_Suppository_2.jpg?v=1777870463",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "clear",
        "neueve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 40,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 75,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171364851909",
      "vsf_explanation": "Vaginal suppository for aerobic vaginitis (AV). AV is a recognized condition with clindamycin as evidence-based treatment (Donders 2017). NeuEve AV Clear is described as the 'first self-care product' for AV — no clinical trial support.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "kresendo",
      "title": "Kresendo",
      "vendor": "NeuEve",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Kresendo_Front_Pill_2.jpg?v=1777870463",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "kresendo",
        "neueve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 42,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171364819141",
      "vsf_explanation": "Female libido/vitality blend around horny goat weed (icariin) and maca. Maca has small RCT support for postmenopausal sexual function (Brooks 2008) and horny goat weed has mostly preclinical data. Doses not disclosed. Better than the pure-marketing peers but not evidence-heavy.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "velvet",
      "title": "Velvet",
      "vendor": "NeuEve",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Velvet_Front_Suppository_2.jpg?v=1777870463",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "velvet",
        "neueve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171364753605",
      "vsf_explanation": "Velvet variant for extremely sensitive women. Same suppository-vs-supplement categorisation issue and identical evidence limitations as the rest of the NeuEve family.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "liposomal-quercetin-200mg-capsules-60-count-30-servings",
      "title": "Liposomal Quercetin 200mg - Capsules (60 count / 30 servings)",
      "vendor": "Core Med Science",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/01_PDP_MainProductImage_Quercetin_Cap_60CT.png?v=1777870505",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liposomal",
        "quercetin",
        "200mg",
        "capsules",
        "count",
        "servings",
        "core",
        "med",
        "science"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171372945605",
      "vsf_explanation": "Quercetin 200 mg in a liposomal capsule (30-day supply). Quercetin has cardiometabolic and antioxidant literature (Serban 2016 meta on BP), though liposomal delivery vs. bromelain-boosted quercetin is not clearly superior. Solid mid-tier from a specialist liposomal brand.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liquid-liposomal-glutathione-single-serve-30pk-sweet-and-tart-berry-flavor",
      "title": "Liquid Liposomal Glutathione Single Serve 30pk - Sweet and Tart Berry Flavor",
      "vendor": "Core Med Science",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Rendering__Bundle_Glutathione_1.png?v=1777870504",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liquid",
        "liposomal",
        "glutathione",
        "single",
        "serve",
        "30pk",
        "sweet",
        "and",
        "tart",
        "berry",
        "flavor",
        "core",
        "med",
        "science"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 69.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171373043909",
      "vsf_explanation": "Single-serve liposomal glutathione sachets — the format best supported for oral GSH bioavailability (Sinha 2018 RCT showed increased blood GSH with liposomal delivery at 500-1000 mg). Dose per sachet not shown here. BOGO promo suggests margin/mass-market positioning; Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liposomal-pc-complex-liquid-8-fl-oz-30-servings",
      "title": "Liposomal PC Complex - Liquid (8 FL OZ / 30 Servings)",
      "vendor": "Core Med Science",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/01_PDP_MainProductImage_PC_Complex_8oz.png?v=1777870509",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liposomal",
        "complex",
        "liquid",
        "servings",
        "core",
        "med",
        "science"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171373928645",
      "vsf_explanation": "Liposomal phosphatidylcholine liquid (30 servings). PC is a foundational phospholipid; supplement research is thin outside of specific choline-adequacy contexts (Zeisel 2006). No per-serving dose shown. Reasonable delivery format for a lipid-soluble active; Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liposomal-vitamin-c-liquid-original-orange-formula-5-fl-oz-30-servings",
      "title": "Liposomal Vitamin C - Liquid - Original Orange Formula  (5 FL OZ / 30 Servings)",
      "vendor": "Core Med Science",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/01_PDP_MainProductImage_VitaminC_5oz_fd4d27eb-c7a8-4e66-a911-284b0e0154a5.png?v=1777870510",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liposomal",
        "vitamin",
        "liquid",
        "original",
        "orange",
        "formula",
        "servings",
        "core",
        "med",
        "science"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 70,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171374092485",
      "vsf_explanation": "Quali-C (DSM pharmaceutical-grade ascorbate) in a liposomal orange liquid. Davis 2016 RCT showed liposomal C reaches higher plasma levels than standard oral. Quali-C sourcing is a real quality signal. Firmly Standard, close to Verified — held back by dose disclosure and lack of third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liposomal-curcumin-250-mg-liquid-6-fl-oz-30-servings",
      "title": "Liposomal Curcumin 250 mg - Liquid (6 FL OZ/ 30 Servings)",
      "vendor": "Core Med Science",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/01_PDP_MainProductImage__curcumin_6oz__liquid.png?v=1777870509",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liposomal",
        "curcumin",
        "250",
        "liquid",
        "servings",
        "core",
        "med",
        "science"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 36.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171374125253",
      "vsf_explanation": "Liposomal curcumin 250 mg — curcumin has notoriously poor oral bioavailability, so a liposomal delivery is defensible (Storka 2015). 250 mg is a modest dose vs. the 500-2000 mg curcuminoid range used in joint RCTs (Daily 2016 meta). Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liposomal-curcumin-resveratrol-liquid-6-fl-oz-30-servings",
      "title": "Liposomal Curcumin + Resveratrol - Liquid (6 FL OZ/ 30 Servings)",
      "vendor": "Core Med Science",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/01_PDP_MainProductImage_Curcumin_Resevratrol_6oz_Liquid_6oz.png?v=1777870510",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint",
        "longevity",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liposomal",
        "curcumin",
        "resveratrol",
        "liquid",
        "servings",
        "core",
        "med",
        "science"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 36.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171374059717",
      "vsf_explanation": "Curcumin + trans-resveratrol combo in a liposomal liquid. Both actives have real oral-bioavailability problems that liposomal delivery helps (Smoliga 2015). No doses disclosed on the page. Standard for a plausible longevity stack, not clinically anchored.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liposomal-glutathione-softgels-60-count-30-servings",
      "title": "Liposomal Glutathione - Softgels (60 Count / 30 Servings)",
      "vendor": "Core Med Science",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/01_PDP_Liposomal_Glutathione_Softgels_60CT_Old.png?v=1777870509",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liposomal",
        "glutathione",
        "softgels",
        "count",
        "servings",
        "core",
        "med",
        "science"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants",
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171374026949",
      "vsf_explanation": "Liposomal glutathione delivery has some absorption evidence over reduced GSH (Sinha 2018 RCT showed 500mg/day raised body stores of GSH), but this listing does not disclose the mg of glutathione per softgel. Softgel format enables higher payload than gummies but per-serving dose is a make-or-break number that's missing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liquid-liposomal-glutathione-4-fl-oz-30-servings",
      "title": "Liquid Liposomal Glutathione (4 FL OZ/ 30 Servings)",
      "vendor": "Core Med Science",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Rendering_Liposomal_Glutathione__Liquid_4oz.png?v=1777870509",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liquid",
        "liposomal",
        "glutathione",
        "servings",
        "core",
        "med",
        "science"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 44.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171374223557",
      "vsf_explanation": "4 oz bottle format of liposomal glutathione. Sinha 2018 RCT supports liposomal GSH raising blood levels, though clinical outcomes remain preliminary. Solid delivery choice for a molecule with poor plain-oral bioavailability. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "active-methyl-b-12-folate-lozenges-60-count-60-servings",
      "title": "Active Methyl B-12 Folate - Lozenges (60 Count/ 60 Servings)",
      "vendor": "Core Med Science",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b-12-methyl-folate-60-tablets-B01LABPEEE-1_1.jpg?v=1777870509",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "active",
        "methyl",
        "folate",
        "lozenges",
        "count",
        "servings",
        "core",
        "med",
        "science"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 70,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171374190789",
      "vsf_explanation": "Sublingual methylcobalamin + methylfolate lozenges. Active B12/folate forms bypass MTHFR-related conversion issues (Obeid 2015) and sublingual delivery matches or exceeds IM B12 for B12 deficiency (Sharabi 2003). Solid formula; missing per-lozenge doses and third-party COA data.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liposomal-vitamin-c-softgels-270-count-90-servings",
      "title": "Liposomal Vitamin C - Softgels (270 Count / 90 Servings)",
      "vendor": "Core Med Science",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/01_PDP_MainProductImage_Vitamin_C_Softgel_270CT.png?v=1777870509",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liposomal",
        "vitamin",
        "softgels",
        "270",
        "count",
        "servings",
        "core",
        "med",
        "science"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171374256325",
      "vsf_explanation": "90-day supply of liposomal C softgels. Softgels are less clearly 'true liposomal' than liquid formats (they are usually phospholipid-blended oil matrices), which softens the delivery advantage. Standard for a well-priced daily immune/antioxidant SKU.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liposomal-vitamin-c-capsules-60-count-30-servings",
      "title": "Liposomal Vitamin C - Capsules (60 Count / 30 Servings)",
      "vendor": "Core Med Science",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/01_PDP_MainProductImage_Vitamin_C_Caps_60CT.png?v=1777870509",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liposomal",
        "vitamin",
        "capsules",
        "count",
        "servings",
        "core",
        "med",
        "science"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171374289093",
      "vsf_explanation": "30-day capsule format of the liposomal C line. Same evidence base (Davis 2016) as the liquid, with the caveat that dry-capsule 'liposomal' claims deserve skepticism vs true phospholipid vesicles. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liposomal-nad-4-oz",
      "title": "Liposomal NAD+, 4 oz",
      "vendor": "Core Med Science",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/01_PDP_MainProductImage_LiposomalNAD__4oz.png?v=1777870510",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liposomal",
        "nad",
        "core",
        "med",
        "science"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 59.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171374452933",
      "vsf_explanation": "Liposomal NAD+ liquid. Oral NAD+ is largely broken down to nicotinamide before absorption; NR (Martens 2018) and NMN (Yoshino 2021) have direct human RCTs, but oral NAD+ itself does not. Liposomal delivery may help, but no per-serving dose or clinical study is presented. Standard for the format, held back by evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liposomal-vitamin-c-softgels-90-count-30-servings",
      "title": "Liposomal Vitamin C - Softgels (90 Count/ 30 Servings)",
      "vendor": "Core Med Science",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/01_PDP_MainProductImage_Vitamin_C_Softgel_90CT.png?v=1777870509",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liposomal",
        "vitamin",
        "softgels",
        "count",
        "servings",
        "core",
        "med",
        "science"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171374354629",
      "vsf_explanation": "30-day softgel format of the liposomal C line. Vitamin C evidence for immune insufficiency and cold duration is solid (Hemilä 2013 Cochrane). Softgel liposomal claims should be read as phospholipid-blended rather than true vesicles. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liposomal-curcumin-500-mg-capsules-60-count-30-servings",
      "title": "Liposomal Curcumin 500 mg - Capsules (60 Count/ 30 Servings)",
      "vendor": "Core Med Science",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/01_PDP_MainProductImage_Curcumin_Caps_60CT.png?v=1777870509",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liposomal",
        "curcumin",
        "500",
        "capsules",
        "count",
        "servings",
        "core",
        "med",
        "science"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171374420165",
      "vsf_explanation": "Liposomal curcumin 500 mg capsules — reaches into the dose range used in joint-comfort RCTs (Daily 2016 meta showed effect vs. placebo at 500-1500 mg curcuminoids). Delivery format addresses turmeric's known bioavailability problem (Anand 2007). Solid Standard, close to Verified with better provenance disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liposomal-sleep-formula-liquid-spray-1-fl-oz-30-servings",
      "title": "Liposomal Sleep Formula - Liquid Spray (1 FL OZ/ 30 Servings)",
      "vendor": "Core Med Science",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/01_PDP_MainProductImage_LiposomalSleepFormula_1oz.png?v=1777870509",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liposomal",
        "sleep",
        "formula",
        "liquid",
        "spray",
        "servings",
        "core",
        "med",
        "science"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171374321861",
      "vsf_explanation": "Melatonin + GABA + glutathione liposomal spray. Melatonin at physiological doses (0.3-1 mg) has real sleep-latency evidence (Ferracioli-Oda 2013 meta); GABA oral absorption is questionable due to blood-brain-barrier limits. Doses not disclosed here. Standard for a plausible but unproven combo.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liposomal-vitamin-c-liquid-sunflower-formula-5-fl-oz-30-servings",
      "title": "Liposomal Vitamin C - Liquid - Sunflower Formula (5 FL OZ / 30 Servings)",
      "vendor": "Core Med Science",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/01_PDP_MainProductImage_Vitamin_C_Liquid_5oz.png?v=1777870509",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liposomal",
        "vitamin",
        "liquid",
        "sunflower",
        "formula",
        "servings",
        "core",
        "med",
        "science"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171374387397",
      "vsf_explanation": "Sunflower-lecithin liposomal C liquid (soy-free variant). Sunflower phospholipids are a legitimate liposomal carrier and address soy-allergen concerns. Evidence base same as Davis 2016 for liposomal C bioavailability. Standard, one of the stronger SKUs in this brand's line.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liposomal-b-12-folate-tmg-liquid-spray-1-fl-oz-30-servings",
      "title": "Liposomal B-12 Folate TMG - Liquid Spray (1 FL OZ/ 30 Servings)",
      "vendor": "Core Med Science",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/01_PDP_MainProductImage_LiposomalB-12Folate_1oz.png?v=1777870510",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liposomal",
        "folate",
        "tmg",
        "liquid",
        "spray",
        "servings",
        "core",
        "med",
        "science"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 70,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 27.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171374551237",
      "vsf_explanation": "Methyl B12 + methylfolate + TMG in a liposomal spray. The methylation trio has coherent biochemistry (TMG donates methyl to homocysteine → methionine; Olthof 2003 showed betaine lowers homocysteine). Active vitamers help MTHFR-variant users. Solid formula; per-spray doses not shown.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liposomal-active-b-complex-multivitamin-w-minerals-softgels-90-count-30-servings",
      "title": "Liposomal Active B-Complex Multivitamin w/Minerals - Softgels (90 Count/ 30 Servings)",
      "vendor": "Core Med Science",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/01_PDP_Liposomal_B-Complex_Multivitamin_Softgel_90CT_ae02edd3-7762-4a68-9960-704d39f90787.png?v=1777870510",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune",
        "cognitive",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liposomal",
        "active",
        "complex",
        "multivitamin",
        "minerals",
        "softgels",
        "count",
        "servings",
        "core",
        "med",
        "science"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171374485701",
      "vsf_explanation": "Active B-complex + trace minerals + antioxidants multivitamin in a liposomal softgel. Multivitamins have modest evidence for cognitive aging (COSMOS-Mind, Baker 2023) though the effect is small. 'Active' methylated B-vitamins are a real quality signal. Per-nutrient doses not shown here.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liposomal-glutathione-capsules-60-capsules-30-servings",
      "title": "Liposomal Glutathione - Capsules  (60 capsules / 30 servings)",
      "vendor": "Core Med Science",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/01_PDP_MainProductImage_Glutathione_Cap_60CT_28b9660c-5cbf-4a2a-a57d-4d4fca92c188.png?v=1777870510",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liposomal",
        "glutathione",
        "capsules",
        "capsules",
        "servings",
        "core",
        "med",
        "science"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants",
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171374518469",
      "vsf_explanation": "Uses Setria L-glutathione, the Kyowa Hakko branded ingredient that Richie (2015) 6-mo RCT (250-1000mg/day) showed raised RBC and whole-blood GSH stores. Branded active is a real transparency and evidence positive over generic GSH; still, mg per capsule not visible in the listing text.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liposomal-iron-capsules-90-count-90-servings",
      "title": "Liposomal Iron - Capsules (90 Count/90 Servings)",
      "vendor": "Core Med Science",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/01_PDP_MainProductImage_Iron_Caps_90CT.png?v=1777870510",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liposomal",
        "iron",
        "capsules",
        "count",
        "servings",
        "core",
        "med",
        "science"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171374584005",
      "vsf_explanation": "Liposomal (sucrosomial-style) iron. Pisani 2015 and Fabiano 2018 RCTs show sucrosomial iron raises hemoglobin with far fewer GI side effects than ferrous sulfate. Genuinely useful format for iron-deficient users; loses points because per-cap elemental iron dose is not disclosed. Standard, borderline Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liposomal-berberine-300mg-capsules-60-count-30-servings",
      "title": "Liposomal Berberine 300mg - Capsules (60 count / 30 servings)",
      "vendor": "Core Med Science",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/01_PDP_MainProductImage_Berberine_Cap_60CT.png?v=1777870510",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liposomal",
        "berberine",
        "300mg",
        "capsules",
        "count",
        "servings",
        "core",
        "med",
        "science"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171374616773",
      "vsf_explanation": "Berberine 300 mg in a liposomal capsule. Per-cap dose is below the standard 500 mg TID regimen from Yin 2008 (glycemic control comparable to metformin) — but two-a-day dosing (600 mg) plus liposomal delivery is a plausible therapeutic route. Standard for the format; dose-per-day protocol needs clearer labeling.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liposomal-alc-and-r-ala-capsules-90-count-30-servings",
      "title": "Liposomal ALC and R-ALA - Capsules (90 Count/ 30 Servings)",
      "vendor": "Core Med Science",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/01_PDP_MainProductImage_ALCandR-ALA_Cap_90CT.png?v=1777870510",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liposomal",
        "alc",
        "and",
        "ala",
        "capsules",
        "count",
        "servings",
        "core",
        "med",
        "science"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171374649541",
      "vsf_explanation": "Acetyl-L-carnitine + R-alpha lipoic acid combo — the classic mitochondrial pairing studied in Hagen 2002 (rat) and Liu 2007 (human cognition). R-ALA is the biologically active isomer of ALA, which is a real quality signal vs. racemic. Doses not disclosed. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liposomal-vitamin-c-capsules-180-count-90-servings",
      "title": "Liposomal Vitamin C - Capsules (180 Count / 90 Servings)",
      "vendor": "Core Med Science",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/01_PDP_MainProductImage_Vitamin_C_Caps_180CT.png?v=1777870510",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liposomal",
        "vitamin",
        "capsules",
        "180",
        "count",
        "servings",
        "core",
        "med",
        "science"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 50,
        "safety": 65,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171374682309",
      "vsf_explanation": "Vitamin C is well established for immune and antioxidant support (Carr & Maggini 2017). Liposomal delivery has some absorption data (Davis 2016 pilot n=11) but liposome quality is unverified here. No third-party testing, CoA, or GMP disclosure surfaced; rebrand transition weakens transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "onnit-alpha-brain-nootropic-brain-supplement-for-men-women-90-count",
      "title": "ONNIT Alpha Brain Nootropic Brain Supplement for Men & Women (90 Count)",
      "vendor": "Nutragole",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/81RY2G78HBL._AC_SL1500.jpg?v=1777870560",
      "score": 68,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "onnit",
        "alpha",
        "brain",
        "nootropic",
        "brain",
        "supplement",
        "for",
        "men",
        "women",
        "count",
        "nutragole"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 63.72,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171384053957",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 58 → new 68. Evidence found: Solomon TM et al. A randomized, double-blind, placebo controlled, parallel group, efficacy study of alpha BRAIN administered orally. Hum Psychopharmacol Clin Exp. 2016;31(2):135-143.. Rationale: Recommend removing the 'proprietary_blend_hides_dose' autofail because the Solomon 2016 RCT validated the exact commercial formula (blends included). The autofail exists to protect users from unstudied doses, but here the untested-ingredient-doses concern is neutralized by RCT-validated product-as-sold. Uplift to 68 (below 70 to reflect ongoing lack of individual-dose transparency for practitioners doing dose adjustment).",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "neuriva-brain-health-ultra-mental-alertness-supplement-60-capsules",
      "title": "NEURIVA Brain Health Ultra Mental Alertness Supplement 60 Capsules",
      "vendor": "Nutragole",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NEURIVA_Ultra_Decaffeinated_Clinically_Tested_Nootropic_Brain_Supplement_for_Mental_Alertness_Memory_Focus_Concentration_Cognitive_Neurofactor_Phosphatidylserine_Vitamins_B6_B12.jpg?v=1777870565",
      "score": 58,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "neuriva",
        "brain",
        "health",
        "ultra",
        "mental",
        "alertness",
        "supplement",
        "capsules",
        "nutragole"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 65,
        "safety": 60,
        "transparency": 50,
        "sustainability": 40
      },
      "price": 69.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171385036997",
      "vsf_explanation": "Same Reckitt/Neuriva Ultra formula listed under a different reseller — Cognivive Alpinia galanga + NeuroFactor coffee cherry + phosphatidylserine + B vitamins. Branded actives have small RCTs (Srivastava 2017; Reyes-Izquierdo 2013). Full Supplement Facts panel not shown in the copy.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "joint-health-pack",
      "title": "Joint Health Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HORMONESJOINTBP.jpg?v=1777870646",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "joint",
        "health",
        "pack",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 69.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171397587141",
      "vsf_explanation": "Vegan glucosamine + hyaluronic acid + omega-3 + boron is a defensible joint stack (Reginster 2001 for glucosamine 1500mg; Bruyere 2015 for HA 200mg oral), but this is a multi-SKU 'pack' with no per-product dose disclosure. Consumer can't verify RCT-comparable dosing.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "brain-pack",
      "title": "Brain Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SpecialtyPack4_8f45fae3-f966-46e0-b8b8-9e976cf7d832.png?v=1777870647",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "brain",
        "pack",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics",
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 69.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171397619909",
      "vsf_explanation": "Lion's Mane + resveratrol + L-theanine + magnesium bisglycinate + ashwagandha is a rational cognitive stack (Mori 2009 Lion's Mane 3g; Nobre 2008 theanine 200mg; Chandrasekhar 2012 ashwagandha 600mg), but pack format hides per-ingredient dosages and standardization.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "smoke-exposure-pack",
      "title": "Smoke Exposure Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SpecialtyPack1_57dedcae-dbbc-485e-b18f-a1e4a8880648.png?v=1777870647",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "smoke",
        "exposure",
        "pack",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants",
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 69.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171397685445",
      "vsf_explanation": "NAC (De Flora 1997 pulmonary GSH replenishment at 600-1800mg/day), quercetin, turmeric, methyl-B, silymarin, vitamin C, omega-3 is a defensible antioxidant/hepatoprotective stack for particulate exposure, but per-ingredient doses are not disclosed and 'smoke exposure' is not an FDA-recognised indication.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "eye-vision-pack",
      "title": "Eye & Vision Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SpecialtyPack3_65d7acbc-54c4-4344-83eb-72651218f6a7.png?v=1777870647",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "eye",
        "vision",
        "pack",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 69.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171397652677",
      "vsf_explanation": "Omega-3 + vitamin C + D + zinc + resveratrol + quercetin roughly overlaps the AREDS2 (2013) macular formula, but AREDS2's proven combination uses specific lutein 10mg + zeaxanthin 2mg + zinc 80mg doses - none of which are disclosed here. Missing lutein/zeaxanthin is a major formulation gap for an eye product.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "womens-hormone-pack",
      "title": "Women's Hormone Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HORMONESJOINTBP_eafcd2ce-07b0-4597-bf70-7887250cb645.jpg?v=1777870646",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "women",
        "hormone",
        "pack",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine",
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 35,
        "manufacturing": 45,
        "safety": 40,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 69.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171397718213",
      "vsf_explanation": "DIM (100-200mg/day, Dalessandri 2004) can shift estrogen metabolism toward 2-OH metabolites, but pairing with 'low-dose DHEA' in an OTC women's product is a safety concern (DHEA converts to both androgens and estrogens; Panjari 2010) and the DHEA mg is not disclosed. Fenugreek libido data (Rao 2015) is on standardized Testofen 600mg - unstated here.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "inflammation-pain-pack",
      "title": "Inflammation & Pain Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SpecialtyPack2_29570bb3-414b-49d9-8d1a-9673ea96df79.png?v=1777870647",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "inflammation"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "inflammation",
        "pain",
        "pack",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 35,
        "manufacturing": 40,
        "safety": 30,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 69.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171397750981",
      "vsf_explanation": "Multi-item 'pack' bundling turmeric, quercetin, carnitine, Mg-glycinate and omega-3 with no per-item dose disclosure or brand provenance. Marketing invokes NF-kB/COX-2 modulation and 'protection against chronic inflammation' — disease-adjacent claims without supporting citations. Even where curcumin has RCT support (Daily et al. 2016, meta-analysis of 8 RCTs at 1000 mg/d), dose is unstated here.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "senior-mobility-pack",
      "title": "Senior Mobility Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SpecialtyPack3_6c97a623-04d8-4390-b203-3a404357c795.png?v=1777870647",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "adults_50_plus",
      "tokens": [
        "senior",
        "mobility",
        "pack",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 35,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 69.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171397783749",
      "vsf_explanation": "Multi-SKU bundle (turmeric, omega-3, NAC, vegan glucosamine, calcium citrate, D complex, trace minerals) with zero disclosed doses, no third-party testing evidence, no manufacturing certifications and thin vendor provenance. Individual ingredients have moderate RCT support (e.g., glucosamine sulfate 1500mg/d in Reginster 2001), but this pack does not confirm doses.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "white-kidney-bean-carb-blocker",
      "title": "White Kidney Bean Carb Blocker",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HD_Image_2_c7e86e95-c233-4aa0-9fc9-1f7323753421.jpg?v=1777870646",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "white",
        "kidney",
        "bean",
        "carb",
        "blocker",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 38,
        "manufacturing": 42,
        "safety": 32,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 23.52,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171397816517",
      "vsf_explanation": "Phaseolus vulgaris (Phase 2) has modest amylase-inhibition data (Onakpoya 2011 meta-analysis, ~1.5 kg fat mass over 12 wk at 445-1500 mg/d), but this listing states no extract strength or per-capsule mg. No third-party testing, no COA, weight-management claims without validated dosage.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "hair-pack",
      "title": "Hair Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SpecialtyPack1.png?v=1777870647",
      "score": 36,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hair",
        "pack",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 36,
        "formulation": 36,
        "manufacturing": 42,
        "safety": 32,
        "transparency": 28,
        "sustainability": 40
      },
      "price": 69.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171397882053",
      "vsf_explanation": "Bundle of biotin, saw palmetto, resveratrol, HA and omega-3 with no per-nutrient dose or third-party COA. Saw palmetto has mixed AGA data (Rossi 2012, 320 mg/d improved density in 60% at 2 yr) but strength here is undisclosed. Marketing 'reduces DHT signaling' is a disease-adjacent claim.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "chocolate-whey-protein-isolate",
      "title": "Chocolate Whey Protein Isolate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HD_Image_1_33095b10-93c7-4e0f-b37b-87c185aaf7bc.jpg?v=1777870646",
      "score": 49,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chocolate",
        "whey",
        "protein",
        "isolate",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 59.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171397947589",
      "vsf_explanation": "18g whey isolate per serving is a modest dose (below the 20-40g leucine-threshold range in Morton 2018 meta-analysis for muscle protein synthesis) and the listing omits amino acid profile, sweetener details, third-party testing and manufacturing certifications. Whey isolate itself is well-supported but this SKU lacks the transparency to verify quality.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "blood-pressure-pack",
      "title": "Blood Pressure Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HORMONESJOINTBP_2d16347c-8243-40e3-a253-5c08c16c7de6.jpg?v=1777870646",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "blood",
        "pressure",
        "pack",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 35,
        "manufacturing": 40,
        "safety": 28,
        "transparency": 25,
        "sustainability": 38
      },
      "price": 69.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171397980357",
      "vsf_explanation": "Product name itself is a cardiovascular disease claim (hypertension management). CoQ10, magnesium, L-arginine and L-citrulline have supportive data (Rosenfeldt 2007, CoQ10 100-300 mg/d lowers SBP ~11 mmHg), but doses here are undisclosed and no clinician oversight is indicated. Serious interaction risk with antihypertensives.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "heart-health-pack",
      "title": "Heart Health Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SpecialtyPack4.png?v=1777870647",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "heart",
        "health",
        "pack",
        "alpha",
        "omega",
        "vitality"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 42,
        "safety": 35,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 69.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171397914821",
      "vsf_explanation": "Multi-supplement pack with CoQ10, magnesium, carnitine, omega-3s, ADEK and methyl-B cofactors — individually evidence-backed for cardiac function (Mortensen 2014 Q-SYMBIO CoQ10 300 mg/d) but doses/strengths undisclosed. No brand provenance or COA. Homocysteine-lowering copy edges disease-claim territory.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "dha-epa",
      "title": "DHA/EPA",
      "vendor": "nuTRIELD",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/DHA_ffc0e509-1695-49c1-bdd1-6ca64dda7f82.png?v=1777870980",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dha",
        "epa",
        "nutrield"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 35,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171450572997",
      "vsf_explanation": "Omega-3 EPA/DHA is evidence-backed for cardiovascular support (REDUCE-IT, Bhatt 2019), but this formula bundles vitamin A, B12, E, curcumin, and astaxanthin with no per-ingredient doses disclosed and no IFOS/oxidation certification. nuTRIELD lacks published sourcing/manufacturing provenance.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "well-kids-tall",
      "title": "Well kids Tall",
      "vendor": "nuTRIELD",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/WellkidsTall.png?v=1777870980",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "youth_under_18",
      "tokens": [
        "well",
        "kids",
        "tall",
        "nutrield"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 48,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171450704069",
      "vsf_explanation": "Aquamin F and vitamin D3 have real bone-health support data (Zenk 2018 for Aquamin), but the 'Tall' positioning implies height enhancement without RCT support in children. Doses of calcium/D3 not disclosed; kid-jelly format often masks sugar content.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "jelly-slim-3-0",
      "title": "JELLY SLIM 3.0",
      "vendor": "nuTRIELD",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/JELLY_SLIM_3.0.png?v=1777870985",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "jelly",
        "slim",
        "nutrield"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 48,
        "safety": 45,
        "transparency": 42,
        "sustainability": 45
      },
      "price": 48,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171451621573",
      "vsf_explanation": "Uses branded Chromax chromium picolinate (Nutrition 21) — a real ingredient with modest glycemic data (Anton 2008, 1000 mcg/d Cr reduced food intake), but the jelly-stick delivery and heavy carrier syrup content limit therapeutic use. Per-stick chromium dose is not stated and 'appetite wellness' plus 'post-meal balance' skirt weight-loss claims.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "liver",
      "title": "Liver",
      "vendor": "nuTRIELD",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/LIVER_07059684-e1ec-479c-bdaf-9b18ec6f8eb3.png?v=1777870984",
      "score": 40,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liver",
        "nutrield"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 52,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171451719877",
      "vsf_explanation": "Product body copy is essentially raw CSS with no visible ingredient list, no dose disclosure, and no brand provenance for the formula. Nothing evaluable for a liver-support supplement.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "immune",
      "title": "IMMUNE",
      "vendor": "nuTRIELD",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/IMMUNE_1d7589e8-4964-4999-bded-05aa4569b286.png?v=1777870985",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "immune",
        "nutrield"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171452113093",
      "vsf_explanation": "Non-GMO soy lecithin + β-NMN + Ganoderma + Cordyceps + Panax ginseng + American ginseng + propolis. NMN is largely for longevity not immunity. No mg per ingredient disclosed anywhere on the page; framing is 'plant-forward blend.'",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "nmn-sod-3-in-1",
      "title": "NMN+SOD 3-in-1",
      "vendor": "nuTRIELD",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NMN_5f2a93e4-54dd-4797-80f9-c3eb7a9b2627.png?v=1777870985",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nmn",
        "sod",
        "nutrield"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 52,
        "manufacturing": 52,
        "safety": 50,
        "transparency": 45,
        "sustainability": 48
      },
      "price": 258,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171451818181",
      "vsf_explanation": "Yeast-derived beta-NMN + SOD + pterostilbene stack targets NAD+ pathways. NMN human data are early (Yoshino 2021, 250 mg/d 10 wk raised muscle NAD+ in prediabetic women); SOD oral bioavailability is contested. Price ($258) is high for undisclosed NMN mg and no third-party purity certificate.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "joint",
      "title": "JOINT",
      "vendor": "nuTRIELD",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/JOINT_a50d34df-d6e1-49fa-b4a2-73367edd1ff3.png?v=1777870985",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "joint",
        "nutrield"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 77,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171451916485",
      "vsf_explanation": "Glucosamine HCl + chondroitin + MSM is a classic joint stack; GAIT trial (Clegg 2006) showed moderate-severe knee OA subgroup benefit for glucosamine sulfate + chondroitin. Glucosamine HCl is less studied than sulfate form. Adding NMN is a marketing-driven add. No per-ingredient mg listed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "turmeric",
      "title": "TURMERIC",
      "vendor": "nuTRIELD",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/TURMERIC_0e13bc34-2ba9-4f9b-b948-6469290c85b9.png?v=1777870985",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "turmeric",
        "nutrield"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 48,
        "manufacturing": 50,
        "safety": 48,
        "transparency": 42,
        "sustainability": 45
      },
      "price": 45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171452014789",
      "vsf_explanation": "Turmeric with black-pepper piperine (standard bioavailability pairing) but bundled with NMN and fermented ginger — kitchen-sink formulation with no per-ingredient mg or curcuminoid standardization. Piperine + curcumin evidence (Shoba 1998, 20 mg piperine → 2000% bioavailability) requires stated curcumin dose to translate.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "coq10",
      "title": "CoQ10",
      "vendor": "nuTRIELD",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/COQ10_f8da92f0-eec5-427c-a3ba-07d8d3d99fc5.png?v=1777870985",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coq10",
        "nutrield"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 50,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171452539077",
      "vsf_explanation": "CoQ10 at 100-200 mg/day has RCT support for heart-failure symptoms (Q-SYMBIO trial, Mortensen 2014). This listing does not disclose mg dose, ubiquinol vs ubiquinone form, or oil-based delivery — all of which materially affect bioavailability. Added Hawthorn and NMN are undosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "alpha-gpc",
      "title": "Alpha-GPC",
      "vendor": "nuTRIELD",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ALPHA_39d9164a-beef-42d1-a95d-f5b3e2ef931a.png?v=1777870986",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alpha",
        "gpc",
        "nutrield"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 30,
        "manufacturing": 35,
        "safety": 25,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 158,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171452342469",
      "vsf_explanation": "Alpha-GPC has cognitive data (Ziegenfuss 2008) but this blend adds vinpocetine (FDA warned unlawful in dietary supplements, 2019) and yeast beta-NMN (FDA excluded NMN from supplements 2022). Ginkgo + PS doses undisclosed. Price ($158) far above justified value.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "pqq",
      "title": "PQQ",
      "vendor": "nuTRIELD",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/PQQ_0bc41818-fab2-43bf-be35-63cf57e84c79.png?v=1777870985",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pqq",
        "nutrield"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 35,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 189,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171452244165",
      "vsf_explanation": "PQQ mitochondrial-biogenesis data is preliminary (Harris 2013 pilot n=10), trans-resveratrol is well-studied but doses matter. Formula labels 'spermidine support' vaguely with no ingredient doses disclosed. Price ($189) not backed by clinical formulation transparency.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "moringa-pqq",
      "title": "Moringa+PQQ",
      "vendor": "nuTRIELD",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Moringa_91dfd162-4e7d-4e28-b272-f64d1da96bc0.png?v=1777870985",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "moringa",
        "pqq",
        "nutrield"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 44,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171452440773",
      "vsf_explanation": "Moringa oleifera has micronutrient/antioxidant data (Stohs & Hartman 2015) and PQQ has thin cognition data. Undisclosed doses for both actives make efficacy unverifiable; no GMP/CoA disclosure.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "mens",
      "title": "MEN'S",
      "vendor": "nuTRIELD",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MEN_S_3a2c78a8-874e-49c2-8433-a3d0dde844bb.png?v=1777870986",
      "score": 30,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "men",
        "nutrield"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 30,
        "manufacturing": 30,
        "safety": 45,
        "transparency": 20,
        "sustainability": 35
      },
      "price": 79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171452637381",
      "vsf_explanation": "Product listing body contains only CSS/HTML scaffolding with no ingredient list, doses, or clinical claims parseable. Zero transparency on formulation prevents any evidence-based scoring.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "womens",
      "title": "Women's",
      "vendor": "nuTRIELD",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/WOMEN_S_d111d255-bfc9-445b-a2a1-4c39b2e31773.png?v=1777870985",
      "score": 34,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "women",
        "nutrield"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 30,
        "manufacturing": 35,
        "safety": 55,
        "transparency": 20,
        "sustainability": 35
      },
      "price": 77,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171452735685",
      "vsf_explanation": "Product description is entirely CSS/layout markup — no ingredient panel, no dose disclosure, no efficacy claims to evaluate. Cannot verify anything about the formulation. Fails the transparency bar even before evidence review.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vbc™-vital-beauty-capsule",
      "title": "VBC™ Vital Beauty Capsule",
      "vendor": "nuTRIELD",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/generation-1763603400861.jpg?v=1777870999",
      "score": 42,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vbc",
        "vital",
        "beauty",
        "capsule",
        "nutrield"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 30,
        "sustainability": 50
      },
      "price": 57,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171454865605",
      "vsf_explanation": "Beauty-from-within capsule combining glutathione, collagen peptides, hyaluronic acid, vitamin C, niacinamide, PQQ, ergothioneine, and plant protein. Ingredient stack has some evidence (oral collagen: Choi 2019 RCT showed elasticity improvement at 2.5-10g), but no per-ingredient doses are disclosed. Cannot verify therapeutic amounts.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "trs-6-0",
      "title": "TRS 6.0",
      "vendor": "nuTRIELD",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/43.png?v=1777870999",
      "score": 38,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "trs",
        "nutrield"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 46,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171454963909",
      "vsf_explanation": "TRS is a zeolite-style 'toxin removal' spray in the wider market; here the body copy shows only CSS/FAQ styling with no ingredient panel, dose, or vendor manufacturing disclosure. Zeolite heavy-metal-binding claims are not supported by controlled human trials (Kraljević Pavelić 2018 review).",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "tryinflammation-potent-elixir-mix",
      "title": "TryInflammation Potent Elixir Mix",
      "vendor": "Try-Blue",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/TryInflammation_0feb6a64-40b5-4fa7-89a0-e7a2e37e6c5c.jpg?v=1777871100",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tryinflammation",
        "potent",
        "elixir",
        "mix",
        "try",
        "blue"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 45,
        "manufacturing": 40,
        "safety": 40,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171467546821",
      "vsf_explanation": "White willow + soursop + nettle tincture claiming customers 'eliminated UTIs' and 'gained control over autoimmune conditions.' These are explicit disease-cure claims and soursop (Annona muricata) has known long-term neurotoxicity concerns (Champy 2005).",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "tryenergy-potent-elixir-mix",
      "title": "TryEnergy Potent Elixir Mix",
      "vendor": "Try-Blue",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/TryEnergy_5c315220-d806-433d-8fbf-1b1d16f61fb9.jpg?v=1777871100",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tryenergy",
        "potent",
        "elixir",
        "mix",
        "try",
        "blue"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 50,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171467579589",
      "vsf_explanation": "Black cumin seed + star anise + fennel tincture in vodka/water. Black seed (Nigella sativa, thymoquinone) has some metabolic and immune RCTs (Razmpoosh 2019) but doses in a 1 ml elixir are unknown. Copy overpromises 'stamina, hormonal balance, respiratory support' without substantiation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "white-pine-needle-elixir",
      "title": "White Pine Needle Elixir",
      "vendor": "Try-Blue",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/PPP14.jpg?v=1777871104",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "white",
        "pine",
        "needle",
        "elixir",
        "try",
        "blue"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 35,
        "manufacturing": 35,
        "safety": 35,
        "transparency": 35,
        "sustainability": 50
      },
      "price": 39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171468202181",
      "vsf_explanation": "White pine needle tincture claiming shikimic-acid antiviral activity, respiratory disease relief (bronchitis, asthma, sinus congestion), and immune boosting. Shikimic acid is an oseltamivir precursor, not an antiviral itself. No RCTs support the respiratory disease claims.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "wild-stinging-nettle-elixir",
      "title": "Wild Stinging Nettle Elixir",
      "vendor": "Try-Blue",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/PPSN.jpg?v=1777871105",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wild",
        "stinging",
        "nettle",
        "elixir",
        "try",
        "blue"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 35,
        "safety": 40,
        "transparency": 35,
        "sustainability": 55
      },
      "price": 55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171468267717",
      "vsf_explanation": "Nettle tincture claiming arthritis relief, sinus/allergy control, and prostate/urinary support. Nettle root has modest BPH data (Safarinejad 2005 RCT) at standardized extract doses; nettle leaf tincture at unstated concentration is not well characterized. Broad disease claims exceed evidence.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "packed-purple-elixir",
      "title": "Packed Purple Elixir",
      "vendor": "Try-Blue",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Packed_Purple_a4fc338e-8624-40d6-8395-47442b6912ae.jpg?v=1777871104",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "packed",
        "purple",
        "elixir",
        "try",
        "blue"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171468333253",
      "vsf_explanation": "Echinacea + elderberry + rose hips tincture for acute immune support. Elderberry has RCT support for shortening flu duration (Tiralongo 2016) and echinacea has modest cold-shortening data (Shah 2007 meta-analysis). Doses per ml are not disclosed and the vodka-tincture format limits standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "burdock-root-elixir",
      "title": "Burdock Root Elixir",
      "vendor": "Try-Blue",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/PPBR.jpg?v=1777871105",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "burdock",
        "root",
        "elixir",
        "try",
        "blue"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 72,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171468366021",
      "vsf_explanation": "Single-herb burdock tincture. Traditional Ayurvedic/TCM use as a 'blood purifier' has almost no controlled human data; Chan 2011 reviewed burdock and found only preclinical antioxidant work. The product ranges across skin, cognitive, blood sugar, and stress claims without dose or standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "wild-canadian-chaga-elixir",
      "title": "Wild Canadian Chaga Elixir",
      "vendor": "Try-Blue",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/PPChaga.jpg?v=1777871105",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wild",
        "canadian",
        "chaga",
        "elixir",
        "try",
        "blue"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 40,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171468431557",
      "vsf_explanation": "Chaga tincture that explicitly claims to 'aid in killing cancer cells' and 'stabilize blood pressure and blood sugar.' Chaga is a legitimate polysaccharide-rich medicinal mushroom but has meaningful oxalate load (Kikuchi 2014 case report of chaga-induced oxalate nephropathy) that is not disclosed.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "dandelion-greens-roots-elixir",
      "title": "Dandelion Greens & Roots Elixir",
      "vendor": "Try-Blue",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ines_banner_4.png?v=1777871105",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dandelion",
        "greens",
        "roots",
        "elixir",
        "try",
        "blue"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171468398789",
      "vsf_explanation": "Dandelion tincture whose copy claims it is 'PACKED with a natural ivermectin' — factually false; dandelion contains no ivermectin. Dandelion has modest diuretic evidence (Clare 2009) but not the range of hormone/lactation/skin outcomes claimed.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "licorice-root-elixir",
      "title": "Licorice Root Elixir",
      "vendor": "Try-Blue",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/PPLR.jpg?v=1777871105",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "licorice",
        "root",
        "elixir",
        "try",
        "blue"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 30,
        "manufacturing": 35,
        "safety": 20,
        "transparency": 35,
        "sustainability": 50
      },
      "price": 79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171468497093",
      "vsf_explanation": "Whole-glycyrrhizin licorice tincture with adrenal-support, ulcer-healing, antiviral (herpes), and cholesterol-lowering claims. Glycyrrhizin causes pseudohyperaldosteronism, hypertension, and hypokalemia at chronic doses (Sigurjonsdottir 2001); DGL is the safer version and isn't used here. Serious safety concern plus disease claims.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "soursop-leaf-elixir",
      "title": "Soursop Leaf Elixir",
      "vendor": "Try-Blue",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/PPSS_32682b86-39c0-4bcc-8c50-fe9236a29593.jpg?v=1777871105",
      "score": 31,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "soursop",
        "leaf",
        "elixir",
        "try",
        "blue"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 30,
        "manufacturing": 35,
        "safety": 35,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171468562629",
      "vsf_explanation": "Product claims soursop 'may help protect healthy cells and inhibit abnormal growth' — a cancer inhibition implication with only preclinical annonacin data (Champy 2005 Mov Disord actually links annonacin to atypical parkinsonism). Handcrafted elixir without dose, COA, or heavy metal testing.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "trysleep-potent-elixir-mix",
      "title": "TrySleep Potent Elixir Mix",
      "vendor": "Try-Blue",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/TrySleep_24bd8463-6a96-41a1-9267-705a309c5eb9.jpg?v=1777871105",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "trysleep",
        "potent",
        "elixir",
        "mix",
        "try",
        "blue"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171468529861",
      "vsf_explanation": "Black cumin + star anise + white pine needle sleep tincture. None of these are established sleep-onset herbs at the doses obtainable from a 1 ml dropper. Recommendation to solve the health impacts of under-7-hour sleep is oversold vs the evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mullein-leaf-bloom-elixir",
      "title": "Mullein Leaf & Bloom Elixir",
      "vendor": "Try-Blue",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/PPM1.jpg?v=1777871105",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mullein",
        "leaf",
        "bloom",
        "elixir",
        "try",
        "blue"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 35,
        "safety": 40,
        "transparency": 35,
        "sustainability": 55
      },
      "price": 70,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171468628165",
      "vsf_explanation": "Mullein tincture claiming lung/bronchitis/asthma relief, ear infection support, and disinfectant properties. Mullein has traditional respiratory use but scant human RCT evidence; ear infection claims (in particular) are disease-treatment territory needing clinical support.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "trycancer-potent-elixir-mix",
      "title": "TryCancer Potent Elixir Mix",
      "vendor": "Try-Blue",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/TryCancer_34254450-4409-4997-94d2-e7ce0d8e0fc8.jpg?v=1777871105",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "trycancer",
        "potent",
        "elixir",
        "mix",
        "try",
        "blue"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 45,
        "manufacturing": 40,
        "safety": 35,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171468660933",
      "vsf_explanation": "Product literally named 'TryCancer' and marketed to 'combat tumors' with black cumin, licorice, and chaga. This is a per se disease-treatment claim that violates DSHEA structure/function limits and is unsupported by controlled oncology trials. Long-term licorice also raises hypertension and hypokalemia risk (Omar 2012).",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "trydiabetes-potent-elixir-mix",
      "title": "TryDiabetes Potent Elixir Mix",
      "vendor": "Try-Blue",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/TryDiabetes_c8bc81af-47a5-4212-b8bc-8c973308fc75.jpg?v=1777871106",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "trydiabetes",
        "potent",
        "elixir",
        "mix",
        "try",
        "blue"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 45,
        "manufacturing": 40,
        "safety": 40,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171468726469",
      "vsf_explanation": "Product literally named 'TryDiabetes' marketing black cumin + burdock + fennel to 'stabilize blood sugar levels' — an explicit disease-treatment claim. Nigella sativa has modest HbA1c reduction data (Kaatabi 2015) but a 1 ml alcohol tincture is far below study doses.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "tryliver-potent-elixir-mix",
      "title": "TryLiver Potent Elixir Mix",
      "vendor": "Try-Blue",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/TryLiver_27c9f2b0-5472-466f-a0da-33c7b6fe4545.jpg?v=1777871105",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tryliver",
        "potent",
        "elixir",
        "mix",
        "try",
        "blue"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 35,
        "manufacturing": 35,
        "safety": 40,
        "transparency": 30,
        "sustainability": 50
      },
      "price": 79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171468693701",
      "vsf_explanation": "Blend of burdock, dandelion, and chaga tinctures for 'liver detox' and thyroid support. Detoxification is a physiological function that does not need supplementation in healthy people; no RCT shows these herbs improve validated liver enzyme or thyroid outcomes.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "trypets-potent-elixir-mix",
      "title": "TryPets Potent Elixir Mix",
      "vendor": "Try-Blue",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/TryPets_a25c663f-6f26-4f4b-93c2-c27e50e7b4ea.jpg?v=1777871105",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "trypets",
        "potent",
        "elixir",
        "mix",
        "try",
        "blue"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 30,
        "manufacturing": 35,
        "safety": 35,
        "transparency": 30,
        "sustainability": 50
      },
      "price": 79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171468759237",
      "vsf_explanation": "Pet-focused black cumin/burdock/dandelion tincture claiming 'bumps and lumps support,' liver/kidney cleanse, and joint anti-inflammatory effects. Product is for animals — not evaluated against human supplement standards, and the tumor/lump implication is a serious veterinary disease claim.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "daily-probiotic-refill-packs",
      "title": "Daily Probiotic Refill Packs",
      "vendor": "Winnow",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/20251009_Winnow_IMG_4534.jpg?v=1777871123",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "daily",
        "probiotic",
        "refill",
        "packs",
        "winnow"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 48,
        "manufacturing": 50,
        "safety": 48,
        "transparency": 40,
        "sustainability": 62
      },
      "price": 64.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171470758085",
      "vsf_explanation": "Novel positioning ('safely bind microplastics') is unsupported by published human trials — the concept comes from in-vitro L. plantarum microplastic-binding work (Kelpsiene 2020). No strain identification, CFU count or third-party viability testing disclosed. Compostable-pouch packaging boosts sustainability.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "daily-probiotic-starter-pack",
      "title": "Daily Probiotic Starter Pack",
      "vendor": "Winnow",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/20251009_Winnow_IMG_5050_1_1d9ca8fb-4a6f-4f30-ae81-53029d67b72e.png?v=1777871128",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "daily",
        "probiotic",
        "starter",
        "pack",
        "winnow"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 48,
        "manufacturing": 50,
        "safety": 48,
        "transparency": 40,
        "sustainability": 65
      },
      "price": 64.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171471478981",
      "vsf_explanation": "Same base formulation as refill SKU with glass-jar starter — no strain identity or CFU disclosed and microplastic-binding claim unproven in humans. Sustainability is a genuine differentiator (reusable jar, refill pouch model).",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "p-s-longevity-multivitamin-try-once",
      "title": "P.S. Longevity Multivitamin (Try Once)",
      "vendor": "P.S. Good Times",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/listing_layout-01_a8ba8e5d-c20b-412e-865b-77da1be54674.webp?v=1777871200",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune",
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "longevity",
        "multivitamin",
        "try",
        "once",
        "good",
        "times"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 65,
        "safety": 62,
        "transparency": 60,
        "sustainability": 60
      },
      "price": 79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171474559173",
      "vsf_explanation": "Single-capsule multivitamin with methylated B forms and bioavailable minerals — reasonable design for MTHFR carriers, though multi-nutrient RCT evidence is generally weak (Physicians' Health Study II, Sesso 2012, showed modest cancer-incidence benefit only). Glass bottle, USA cGMP claim, third-party lab testing (unnamed lab, no COA link) support Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "rise-shine-t-booster",
      "title": "Rise & Shine | T Booster",
      "vendor": "P.S. Good Times",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/riseandshinecopy.jpg?v=1777871200",
      "score": 42,
      "tier": "rejected",
      "certifications": [
        "NSF Certified",
        "GMP Certified",
        "Gluten-Free Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "rise",
        "shine",
        "booster",
        "good",
        "times"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171474591941",
      "vsf_explanation": "Marketing copy references a 'concoction of ingredients backed by clinical studies' without disclosing what those ingredients are or their doses. NSF-certified/FDA-registered facility claim is a plus, but the listing has no supplement panel to evaluate. Cannot be responsibly scored above the auto-fail cap.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "shiny-leaf-methylated-bariatric-multivitamin-without-iron",
      "title": "Shiny Leaf Methylated Bariatric Multivitamin Without Iron",
      "vendor": "Shiny Leaf",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Methylated-Multivitamin_iron-Free_90_1_10099447-f35e-4b76-966c-acf259b2b313.jpg?v=1777871248",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shiny",
        "leaf",
        "methylated",
        "bariatric",
        "multivitamin",
        "without",
        "iron",
        "shiny",
        "leaf"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 55,
        "sustainability": 52
      },
      "price": 14.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171474985157",
      "vsf_explanation": "Specialty multi designed to ASMBS 2016 guidelines for bariatric patients, with methylfolate (L-5-MTHF), methylcobalamin and bioactive D3 — appropriate for reduced-absorption physiology. Iron-free variant is correctly indicated for men and post-menopausal or Fe-replete patients. Third-party COA not shown.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "coq10-100mg-strawberry-chewable-tablets",
      "title": "CoQ10 100mg Strawberry Chewable Tablets",
      "vendor": "Shiny Leaf",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/coq10-30main.jpg?v=1777871248",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coq10",
        "100mg",
        "strawberry",
        "chewable",
        "tablets",
        "shiny",
        "leaf"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 52,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 45,
        "sustainability": 48
      },
      "price": 9.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171475148997",
      "vsf_explanation": "Straightforward 100 mg ubiquinone (oxidized CoQ10) chewable. Ubiquinone has RCT support at 100-300 mg/d for statin-associated myalgia (Skarlovnik 2014) but ubiquinol is preferred over age 40. Chewable format adds sugar and flavors; no third-party COA disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dht-blocker-anti-hair-loss-shampoo-and-conditioner-set-with-biotin-2-x-16-oz",
      "title": "DHT Blocker Anti Hair Loss Shampoo and Conditioner set with Biotin (2 x 16 Oz)",
      "vendor": "Shiny Leaf",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/dht_blocking_shampoo_and_conditioner_for_men_dht_blocker_shampoo_and_conditioner_for_women_hair_loss_shampoo.jpg?v=1777871253",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dht",
        "blocker",
        "anti",
        "hair",
        "loss",
        "shampoo",
        "and",
        "conditioner",
        "set",
        "with",
        "biotin",
        "shiny",
        "leaf"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 36.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171475214533",
      "vsf_explanation": "Procapil has small in-vitro/short-clinical hair-density support data; rosemary oil showed non-inferiority to 2% minoxidil in one open-label trial (Panahi 2015). This is a topical, not an ingestible supplement, and biotin has no proven benefit for non-deficient users (Patel 2017).",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "methylated-bariatric-multivitamins-with-45mg-iron-1-capsule-a-day",
      "title": "Methylated Bariatric Multivitamins with 45mg Iron 1 capsule a day",
      "vendor": "Shiny Leaf",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Methylated-Multivitamin_With_iron_90_1.jpg?v=1777871253",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "methylated",
        "bariatric",
        "multivitamins",
        "with",
        "45mg",
        "iron",
        "capsule",
        "day",
        "shiny",
        "leaf"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 55,
        "sustainability": 52
      },
      "price": 14.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171475247301",
      "vsf_explanation": "Bariatric multi with 45 mg iron matches ASMBS-recommended dose for menstruating or Fe-deficient post-op patients. Methylated Bs and single-capsule regimen aid compliance. GI intolerance to elemental iron at this dose is a common issue — Shiny Leaf uses non-heme iron form not disclosed on page.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dht-pro-shampoo-and-conditioner-with-procapil-and-capixyl",
      "title": "DHT Pro Shampoo and Conditioner with Procapil and Capixyl",
      "vendor": "Shiny Leaf",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shampoo_and_conditioner_set_dht_blocker_for_men_dht_blocking_procapil_capixyl_shampoo_for_women_hair_growth_9.jpg?v=1777871254",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dht",
        "pro",
        "shampoo",
        "and",
        "conditioner",
        "with",
        "procapil",
        "and",
        "capixyl",
        "shiny",
        "leaf"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 37.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171475411141",
      "vsf_explanation": "Capixyl (biochanin-A + acetyl tetrapeptide-3) has one supplier-sponsored 4-month study showing modest hair-count change. Procapil evidence is thin. Topical product marketed for hair loss without treatment-grade RCTs on the final formula.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "recover-on-keto-electrolyte-capsules",
      "title": "Recover On Keto - Electrolyte Capsules",
      "vendor": "Vitamin Bounty",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/847dd745-6b81-4bfc-8a33-3e69c355d556.png?v=1777871294",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "recover",
        "keto",
        "electrolyte",
        "capsules",
        "vitamin",
        "bounty"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171475607749",
      "vsf_explanation": "Basic Ca/Mg/Na/K electrolyte support is uncontroversial for keto-induced electrolyte losses (Volek & Phinney 2011). Capsule format limits sodium delivery; per-serving doses not disclosed in copy. Bundled subscription and generic manufacturing lower transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "multi-collagen-complex",
      "title": "Multi Collagen Complex +",
      "vendor": "Vitamin Bounty",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/23.36_Mesa_de_trabajo_1_copia_11_2.jpg?v=1777871295",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "multi",
        "collagen",
        "complex",
        "vitamin",
        "bounty"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 52,
        "manufacturing": 52,
        "safety": 52,
        "transparency": 42,
        "sustainability": 48
      },
      "price": 27.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171475640517",
      "vsf_explanation": "Types I, II, III, V and X collagen peptides with vitamin C, hyaluronic acid and probiotics. Collagen RCTs support 2.5-15 g/d for skin elasticity (Choi 2019 meta), but per-capsule collagen mg and probiotic strain/CFU are undisclosed. 'Multi-type' marketing outweighs the tiny peptide dose typical of capsule formats.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "womens-pro-daily-probiotic",
      "title": "Women's Pro-Daily Probiotic",
      "vendor": "Vitamin Bounty",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4_5.jpg?v=1777871300",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "women",
        "pro",
        "daily",
        "probiotic",
        "vitamin",
        "bounty"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 22.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171475706053",
      "vsf_explanation": "L. rhamnosus GR-1 and L. reuteri RC-14 have vaginal-flora RCT support (Reid 2003), but this label lists only 5 unnamed strains at 10B CFU and doesn't verify strain identity. CFU at manufacture vs expiry not disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pro-50-probiotic",
      "title": "Pro-50 Probiotic",
      "vendor": "Vitamin Bounty",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Pro50_OldVsNew_Packaging.jpg?v=1777871300",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pro",
        "probiotic",
        "vitamin",
        "bounty"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171475804357",
      "vsf_explanation": "50B CFU with 13 strains covers standard gut-support use; CFU dose is meaningful (Marteau 2011). Strain-specific IDs and stability data absent, and 'most effective on the market' is unsupported hyperbole.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "forskolin-max-strength",
      "title": "Forskolin Max Strength",
      "vendor": "Vitamin Bounty",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2fae3f76-46fa-4e2b-b787-9c204ced18cb.png?v=1777871299",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "forskolin",
        "max",
        "strength",
        "vitamin",
        "bounty"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 40,
        "transparency": 32,
        "sustainability": 40
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171475771589",
      "vsf_explanation": "Forskolin weight-loss data are marginal (Godard 2005, 250 mg 10% Coleus forskohlii bid for 12 wk, body-composition benefit in men only, n=30). Serotonin/appetite-suppression claim is disease-adjacent and unsupported for Coleus. No standardization or per-cap mg disclosed.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "gx7-pre-workout-watermelon",
      "title": "GX7 Pre-Workout - Watermelon",
      "vendor": "Vitamin Bounty",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Screenshot2024-03-2714.30.19.png?v=1777871299",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gx7",
        "pre",
        "workout",
        "watermelon",
        "vitamin",
        "bounty"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171475738821",
      "vsf_explanation": "Pre-workouts benefit from clinically dosed beta-alanine, citrulline, and caffeine (Kerksick 2018 ISSN), but this label ('complete pre-workout') discloses no per-ingredient doses. Sugar-free/keto framing does not offset opaque formulation.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "vitamin-bounty-burn-x13",
      "title": "Vitamin Bounty Burn X13",
      "vendor": "Vitamin Bounty",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/772d1dcf-0189-4786-8171-8f959418b0df.png?v=1777871300",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "bounty",
        "burn",
        "x13",
        "vitamin",
        "bounty"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 32,
        "manufacturing": 40,
        "safety": 30,
        "transparency": 22,
        "sustainability": 38
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171475869893",
      "vsf_explanation": "'Powerful blend of 13 ingredients' with none named on the storefront — textbook proprietary blend. Fat-burner category is high-risk for undisclosed stimulants and lacks a single ingredient at therapeutic dose. Marketing emphasizes hype ('reach your goals fast') over evidence.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "pro-25-probiotic",
      "title": "Pro-25 Probiotic",
      "vendor": "Vitamin Bounty",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Pro25_OldVsNew_Packaging.jpg?v=1777871300",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pro",
        "probiotic",
        "vitamin",
        "bounty"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171475837125",
      "vsf_explanation": "25B CFU / 13 strains is a reasonable maintenance dose (Sanders 2019). Same transparency issues as Pro-50: strains unnamed, no stability data, no third-party testing disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "get-into-keto-supercharge-ketosis-with-ketones",
      "title": "Get Into Keto - Supercharge Ketosis with Ketones",
      "vendor": "Vitamin Bounty",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/VB1032_Get_Into_Keto_1.jpg?v=1777871300",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "get",
        "into",
        "keto",
        "supercharge",
        "ketosis",
        "with",
        "ketones",
        "vitamin",
        "bounty"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171475902661",
      "vsf_explanation": "Exogenous BHB salts transiently raise blood ketones (Stubbs 2017) but do not produce nutritional ketosis or weight loss vs diet alone. Dose per serving not disclosed; typical DTC formulas contain sub-therapeutic (<10g) BHB.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "burn-on-keto",
      "title": "Burn On Keto",
      "vendor": "Vitamin Bounty",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cd3f4db9-7933-422b-bfef-19e858f80165.png?v=1777871300",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "burn",
        "keto",
        "vitamin",
        "bounty"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171475935429",
      "vsf_explanation": "'Fat burner' product description gives no ingredients or doses in the provided copy; category is dominated by unsupported thermogenic blends. Cannot verify formulation or safety.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "tune-your-keto-multivitamin",
      "title": "Tune Your Keto - Multivitamin",
      "vendor": "Vitamin Bounty",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/69fac999-8818-4493-ae47-d047d8b1bc24.png?v=1777871300",
      "score": 53,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tune",
        "your",
        "keto",
        "multivitamin",
        "vitamin",
        "bounty"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171475968197",
      "vsf_explanation": "Keto-tailored multi with extra Mg, K, and MCT addresses real electrolyte gaps on ketogenic diets (Bostock 2020). Actual mineral forms (oxide vs glycinate) and RDIs not disclosed, limiting verification of bioavailability.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "elderberry-immune-support",
      "title": "Elderberry Immune Support",
      "vendor": "Vitamin Bounty",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/75fd7429-24a9-4757-ae4d-1b38fb6b4834.png?v=1777871300",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "elderberry",
        "immune",
        "support",
        "vitamin",
        "bounty"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171476000965",
      "vsf_explanation": "Sambucus nigra shortened cold/flu duration in a small RCT (Tiralongo 2016, n=312), and zinc lozenges have accepted efficacy for cold duration (Hemila 2017 meta-analysis). Elderberry and echinacea doses not disclosed; five-ingredient blend risks under-dosing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vars-liposomal-vitamin-c-gummies",
      "title": "VARS Liposomal Vitamin C Gummies",
      "vendor": "Physician Designed™",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/41.png?v=1777871315",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vars",
        "liposomal",
        "vitamin",
        "gummies",
        "physician",
        "designed"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 39.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171476164805",
      "vsf_explanation": "Vitamin C evidence is solid (Carr 2017), and 'clinically studied liposomal' claim cites 27% absorption uplift (Davis pilot 2016). Gummy format typically caps dose at 250-500 mg per serving and adds sugar; per-serving Vit C not disclosed in copy.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vars-glutathione-capsules",
      "title": "VARS Glutathione Capsules",
      "vendor": "Physician Designed™",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/29.png?v=1777871315",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vars",
        "glutathione",
        "capsules",
        "physician",
        "designed"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 20,
        "sustainability": 45
      },
      "price": 54.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171476132037",
      "vsf_explanation": "Glutathione capsules from a physician-designed line but with no product description content — no glutathione form (reduced/liposomal/S-acetyl), no dose, no third-party testing. Oral reduced glutathione has poor bioavailability (Witschi 1992); form and dose are decisive.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "femme-topical-progesterone-serum",
      "title": "Femme - Topical Progesterone Serum",
      "vendor": "Physician Designed™",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/35_54b45cad-56fe-40dc-9bc5-a000f1d06286.png?v=1777871315",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "femme",
        "topical",
        "progesterone",
        "serum",
        "physician",
        "designed"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 25,
        "transparency": 20,
        "sustainability": 45
      },
      "price": 44.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171476197573",
      "vsf_explanation": "Topical progesterone serum sold OTC. Progesterone is a bioidentical hormone requiring prescription in most jurisdictions; unmonitored transdermal progesterone can affect menstrual cycles, endometrial safety, and interact with other hormones. No product body, no dose per pump, no clinical safety data.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "copper-balance",
      "title": "Copper Balance",
      "vendor": "Physician Designed™",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_6d465f9d-28ee-44b7-8d4f-8974b5f64764.png?v=1777871320",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "copper",
        "balance",
        "physician",
        "designed"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 40,
        "transparency": 20,
        "sustainability": 45
      },
      "price": 34.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171476361413",
      "vsf_explanation": "Copper supplement from Physician Designed with no product description. Copper needs precise dosing relative to zinc (Kelleher 2011 review); excess copper is neurotoxic. Without dose, form (bisglycinate vs sulfate), or zinc pairing disclosed, therapeutic use cannot be verified.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "mthfr-daily",
      "title": "MTHFR Daily",
      "vendor": "Physician Designed™",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/19_78af285d-b9ac-41ac-ad49-c542a2d9343f.png?v=1777871320",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mthfr",
        "daily",
        "physician",
        "designed"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 20,
        "sustainability": 45
      },
      "price": 39.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171476426949",
      "vsf_explanation": "Methylated multivitamin marketed for MTHFR variants. Methyl-folate + methyl-B12 has evidence for MTHFR C677T carriers with elevated homocysteine (Wald 2011). But no product description, no methylfolate mcg, no B12 form/mcg, no other B-vitamin content disclosed.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "vars-sod-formerly-known-as-sod-booster",
      "title": "VARS SOD (formerly known as SOD Booster)",
      "vendor": "Physician Designed™",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SODBoosterBottle-39.png?v=1777871320",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vars",
        "sod",
        "formerly",
        "known",
        "sod",
        "booster",
        "physician",
        "designed"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 20,
        "sustainability": 45
      },
      "price": 39.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171476394181",
      "vsf_explanation": "Superoxide dismutase-boosting formula (likely SOD from cantaloupe/gliadin per Milgard-brand precedent) with no product description. Oral SOD from Extramel has limited human trials (Nakajima 2011 pilot); this listing gives no ingredient, dose, or source.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "brite-brain",
      "title": "Brite Brain",
      "vendor": "Physician Designed™",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9_48245dbc-e547-409c-a4c7-1d2c8b5972d9.png?v=1777871321",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "brite",
        "brain",
        "physician",
        "designed"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 20,
        "sustainability": 45
      },
      "price": 59.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171476459717",
      "vsf_explanation": "Cognitive-support blend from Physician Designed with no product description. Nootropic stacks vary enormously (Lion's Mane, bacopa, citicoline, phosphatidylserine, etc.); without an ingredient list, dose disclosure, or clinical rationale on the listing, therapeutic value cannot be assessed.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "creatine-monohydrate-2",
      "title": "Creatine Monohydrate",
      "vendor": "Molecular Provisions",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CreatineFront.png?v=1777871373",
      "score": 75,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "creatine",
        "monohydrate",
        "molecular",
        "provisions"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids",
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 82,
        "formulation": 75,
        "manufacturing": 72,
        "safety": 78,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171477409989",
      "vsf_explanation": "Single-ingredient micronized creatine monohydrate at the clinically validated 5 g daily dose (Kreider ISSN Position Stand 2017). Unflavored, unsweetened, filler-free. Creatine monohydrate is the most-studied ergogenic aid in sports nutrition with strong strength, lean mass, cognitive (Rae Proc Biol Sci 2003) and healthy-aging support. Third-party testing not explicitly claimed; comparable to Momentous Creatine anchor.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "advanced-multi",
      "title": "Advanced Multi",
      "vendor": "Molecular Provisions",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/AdvancedMulti_8x3_28a07e09-438b-4781-9af2-1fb00a7d5cba.png?v=1777871373",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "advanced",
        "multi",
        "molecular",
        "provisions"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 70,
        "manufacturing": 65,
        "safety": 70,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 62,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171477442757",
      "vsf_explanation": "Comprehensive multivitamin claims bioavailable methylated B forms and chelated minerals, aligning with best-in-class formulation practice (Obeid 2019 on methylfolate). Boutique brand with credible ingredient story but limited public CoA or third-party testing disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nac-n-acetyl-l-cysteine-glutathione-precursor",
      "title": "NAC (N-Acetyl-L-Cysteine) Glutathione Precursor",
      "vendor": "Molecular Provisions",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NACfront.png?v=1777871380",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nac",
        "acetyl",
        "cysteine",
        "glutathione",
        "precursor",
        "molecular",
        "provisions"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171477704901",
      "vsf_explanation": "900 mg NAC per capsule aligns with the 600-1200 mg/d range used in Sadowska 2007 COPD trials and Ooi 2018 glutathione-precursor work. Plant-based capsule, minimal excipients. Small brand without third-party COAs or GMP audit disclosure, so ceiling is Standard rather than Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gi-clear",
      "title": "GI Clear",
      "vendor": "Molecular Provisions",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/GICLEAR.png?v=1777871380",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "clear",
        "molecular",
        "provisions"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 50,
        "manufacturing": 52,
        "safety": 42,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 54,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171477737669",
      "vsf_explanation": "Berberine + artemisinin + black walnut + caprylic acid mimics a practitioner-tier 'gut cleanse' protocol. Berberine RCT support is real (Yin 2008, 500 mg tid vs metformin), but artemisinin has hepatotoxicity concerns without oversight and doses are undisclosed. Antimicrobial/antiparasitic language pushes into disease territory.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "biomega-1000",
      "title": "BiOmega 1000+",
      "vendor": "Molecular Provisions",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BiOmega1000_V5_7x2_1cc1e56f-bdd1-4d20-979c-2a46cf532689.png?v=1777871379",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "biomega",
        "1000",
        "molecular",
        "provisions"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 55,
        "sustainability": 65
      },
      "price": 58,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171477803205",
      "vsf_explanation": "1000 mg triglyceride-form omega-3 from sustainably-sourced wild anchovy/sardine/mackerel (Peru/Chile) processed in Norway; higher-EPA ratio aligns with mood/cognition literature (Sublette 2011 meta-analysis). Triglyceride form has better bioavailability than ethyl-ester (Neubronner 2011). No IFOS/GOED cert disclosed, so Standard rather than Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organ",
      "title": "Organ+",
      "vendor": "Molecular Provisions",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Organ.png?v=1777871379",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organ",
        "molecular",
        "provisions"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 65,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171477639365",
      "vsf_explanation": "Freeze-dried grass-fed NZ bovine organs deliver bioavailable heme iron, B12, and CoQ10 with quality sourcing (Ancestral Supplements category baseline). Clinical trials on multi-organ blends are scarce; heavy metal testing/CoA not published.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bio-adek",
      "title": "Bio-ADEK",
      "vendor": "Molecular Provisions",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ADEKfront.png?v=1777871379",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bio",
        "adek",
        "molecular",
        "provisions"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 70,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 43,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171477770437",
      "vsf_explanation": "Vitamins A/D3/K2/E synergistic delivery is well-supported (Maresz 2015 on K2-D3 synergy). Correct isomer mention (K2-MK7, tocotrienols) and lipid delivery signal quality formulation. Per-vitamin doses not disclosed in copy; third-party testing not published.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gi-immunoguard",
      "title": "GI Immunoguard",
      "vendor": "Molecular Provisions",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/GIImmunoGuard_2ceef767-8e61-44fb-afdc-da82468636d7.png?v=1777871379",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "immunoguard",
        "molecular",
        "provisions"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 65,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171477606597",
      "vsf_explanation": "ImmunoLin (serum-derived bovine immunoglobulin) has RCT support for IBS-D and barrier function (Wilson 2013, Weinstock 2014). NAG has thinner data. Doses of SBI (typical clinical: 5-10g) not disclosed on product page.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "complete-prenatal",
      "title": "Complete Prenatal+",
      "vendor": "Molecular Provisions",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CompletePrenatal.png?v=1777871379",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "prenatal",
      "tokens": [
        "complete",
        "prenatal",
        "molecular",
        "provisions"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 75,
        "manufacturing": 65,
        "safety": 70,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171477868741",
      "vsf_explanation": "Quatrefolic (5-MTHF) is superior to folic acid for MTHFR carriers (Servy 2018) and chelated minerals improve mineral absorption vs oxide (DiSilvestro 2007). Well-designed prenatal formulation, though heavy-metal testing and iron/choline dose disclosure would strengthen further.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gi-balance",
      "title": "GI Balance",
      "vendor": "Molecular Provisions",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/GIBalance.png?v=1777871379",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "balance",
        "molecular",
        "provisions"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 70,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171477672133",
      "vsf_explanation": "7 Lactobacillus/Bifidobacterium strains with 4 bacteriophages (likely PreforPro) is a modern gut formulation; PreforPro has RCT data on Bifidobacterium enrichment (Grubb 2020). Strain identities/CFU counts not disclosed in copy.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "digestive-enzymes",
      "title": "Digestive Enzymes+",
      "vendor": "Molecular Provisions",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/DigestiveEnzymes.png?v=1777871379",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "digestive",
        "enzymes",
        "molecular",
        "provisions"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 48,
        "sustainability": 52
      },
      "price": 46,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171477901509",
      "vsf_explanation": "Thoughtful enzyme stack: proteases + lipases + amylases plus DPP-IV for gluten/casein peptides, ox bile for fat digestion, betaine HCl for gastric acid, and lactase. Practitioner-style formulation; evidence for DPP-IV enzymes in gluten sensitivity is limited (Ehren 2009). No enzyme activity units (USP/FCC) shown on storefront.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hormone-harmony",
      "title": "Hormone Harmony+",
      "vendor": "Molecular Provisions",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HormoneHarmony.png?v=1777871379",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hormone",
        "harmony",
        "molecular",
        "provisions"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 48,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 62,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171477573829",
      "vsf_explanation": "DIM + chrysin + black cohosh + chaste tree + calcium-D-glucarate is a coherent estrogen-metabolism formula. DIM has phase-I estrogen-metabolism data (Dalessandri 2004, 108 mg/d shifted 2/16-hydroxyestrone ratio). Chaste tree (Vitex agnus-castus) has PMS RCT support (Schellenberg 2001, 20 mg/d). Doses undisclosed; explicit pregnancy/nursing warning is appropriate.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hp-plex",
      "title": "HP-Plex",
      "vendor": "Molecular Provisions",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HP-Plex.png?v=1777871379",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "plex",
        "molecular",
        "provisions"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 48,
        "sustainability": 50
      },
      "price": 57,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171477835973",
      "vsf_explanation": "Mastic gum, zinc-carnosine and DGL is a well-known H. pylori / gastric-mucosa protocol. Mastic gum RCT vs H. pylori (Dabos 2010, 350 mg tid) and zinc-carnosine gastritis data (Matsukura 2000, 150 mg/d) are supportive though modest. Product name hints at H. pylori indication — borderline claim without stated diagnosis workflow.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "advanced-oral-probiotic-mint",
      "title": "Advanced Oral Probiotic Mint",
      "vendor": "Molecular Provisions",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3_df147764-814e-4b27-ba00-fff26d902d9a.png?v=1777871379",
      "score": 68,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "advanced",
        "oral",
        "probiotic",
        "mint",
        "molecular",
        "provisions"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 70,
        "manufacturing": 70,
        "safety": 70,
        "transparency": 65,
        "sustainability": 62
      },
      "price": 42,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171477934277",
      "vsf_explanation": "BLIS K12 and M18 are branded, clinically studied Streptococcus salivarius strains for oral microbiome — K12 for halitosis and pharyngitis (Di Pierro 2016, 1B CFU/d 90 days), M18 for plaque and gingivitis (Burton 2013). 6 billion CFU total is a genuine adult dose. Named branded strains at disclosed CFU is unusually transparent for the category.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "collagen-peptides",
      "title": "Collagen Peptides",
      "vendor": "Molecular Provisions",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CompleteCollagen_0bc47326-6955-4e8c-8440-890e1a6f8f8a.png?v=1777871379",
      "score": 73,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "collagen",
        "peptides",
        "molecular",
        "provisions"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 78,
        "manufacturing": 68,
        "safety": 70,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171477967045",
      "vsf_explanation": "Verisol shows skin elasticity improvements (Proksch 2014, n=69), Fortibone increases bone mineral density (Konig 2018, n=131), and Fortigel reduces joint pain (Zdzieblik 2017). Using three patented, RCT-supported peptides in one product is best-in-class formulation; grass-fed sourcing adds provenance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "complete-binder",
      "title": "Complete Binder",
      "vendor": "Molecular Provisions",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CompleteBinder.png?v=1777871379",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "complete",
        "binder",
        "molecular",
        "provisions"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 42,
        "transparency": 38,
        "sustainability": 45
      },
      "price": 47,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171477999813",
      "vsf_explanation": "'Adsorbent binder' for toxins/heavy metals/microbes with no ingredients specified on storefront (activated charcoal? zeolite? bentonite?). Toxin-elimination and detoxification claims lack human RCT support and can bind nutrients or medications indiscriminately. Non-specific formulation is the core problem.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "mineral-synergy",
      "title": "Mineral Synergy+",
      "vendor": "Molecular Provisions",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MineralSynergy_c62675a7-2fe5-438c-a064-23a0a97d1b4f.png?v=1777871379",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mineral",
        "synergy",
        "molecular",
        "provisions"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 48,
        "sustainability": 52
      },
      "price": 39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171478065349",
      "vsf_explanation": "Chelated (amino-acid-bound) trace minerals — Albion-style glycinates have ~30% higher absorption vs oxides (Coudray 2005, Mg-glycinate rat model). Specific mineral panel and per-cap mg not disclosed on storefront. Category is generally safe when doses stay under UL.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "methylb",
      "title": "MethylB+",
      "vendor": "Molecular Provisions",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MethylB__8x3_1.png?v=1777871379",
      "score": 68,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "methylb",
        "molecular",
        "provisions"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 72,
        "manufacturing": 70,
        "safety": 65,
        "transparency": 65,
        "sustainability": 60
      },
      "price": 49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171478032581",
      "vsf_explanation": "Quatrefolic 5-MTHF, methylcobalamin, P5P, R5P, plus TMG and L-serine — a genuinely bioactive methylation stack that bypasses MTHFR and MTRR bottlenecks. Homocysteine-lowering evidence for 5-MTHF + B12 + B6 is strong (Wald 2002 meta-analysis, 25% reduction). Explicit start-low guidance for COMT/MTHFR carriers is clinically sound.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liposomal-d3-2000iu-k2-100mcg",
      "title": "Liposomal D3 2000IU K2 100mcg",
      "vendor": "UpNourish",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/D2000K100main.jpg?v=1777871411",
      "score": 53,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liposomal",
        "2000iu",
        "100mcg",
        "upnourish"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171478655173",
      "vsf_explanation": "2000 IU D3 + 100 mcg MK-7 is a widely-used maintenance combo (RDA-adjacent; Institute of Medicine RDA 600-800 IU). Liposomal-softgel form is a marketing claim not well-substantiated by comparative bioavailability RCTs. Small direct-to-consumer brand without third-party COAs limits ceiling.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liposomal-vitamin-k2-mk-7-180mcg",
      "title": "Liposomal Vitamin K2 MK-7 180mcg",
      "vendor": "UpNourish",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/K180main.jpg?v=1777871411",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liposomal",
        "vitamin",
        "180mcg",
        "upnourish"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 48,
        "sustainability": 50
      },
      "price": 18.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171478687941",
      "vsf_explanation": "180 mcg K2-MK7 matches the dose used in Knapen 2013 (3 yr, improved bone mineral content in postmenopausal women) and Vermeer's dp-ucMGP arterial-calcification work. 'Liposomal softgel' marketing is unusual for a fat-soluble vitamin already well-absorbed in oil; no third-party MK-7 assay disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "plant-based-meal-replacement",
      "title": "Plant Based meal replacement",
      "vendor": "UpNourish",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CSmain.jpg?v=1777871416",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "plant",
        "based",
        "meal",
        "replacement",
        "upnourish"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 48,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171478819013",
      "vsf_explanation": "21 g complete protein blend (fava, mung, pea, rice — a reasonable PDCAAS-completing combo), 22 vitamins/minerals at 50% DV, 1.5B CFU probiotics, MCTs and adaptogens. Meal-replacement category evidence is protein-adequacy oriented rather than clinical (Astrup 2019 pea protein satiety). Third-party heavy-metal testing not referenced.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "micronized-creatine-monohydrate-400-g",
      "title": "Micronized Creatine Monohydrate 400 G",
      "vendor": "UpNourish",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CreatineMonomain_f45556c0-9d6d-4da3-8fd3-1910c448af9f.jpg?v=1777871417",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "micronized",
        "creatine",
        "monohydrate",
        "400",
        "upnourish"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 80,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 70,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171478950085",
      "vsf_explanation": "Creatine monohydrate has the strongest evidence base of any ergogenic aid (Kreider 2017 ISSN position stand): 3-5g/day increases strength and lean mass. Micronization aids solubility but is not Creapure-verified here; no CoA or heavy-metal testing surfaced.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liposomal-vitamin-d3-5000-iu-softgels",
      "title": "Liposomal Vitamin D3 5000 IU Softgels",
      "vendor": "UpNourish",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/VDmain.jpg?v=1777871416",
      "score": 53,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liposomal",
        "vitamin",
        "5000",
        "softgels",
        "upnourish"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 18.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171478982853",
      "vsf_explanation": "5000 IU D3 daily is a common repletion dose supported by Bischoff-Ferrari 2020 and Endocrine Society 2011 guidance for deficient adults. Liposomal softgel claim is marketing rather than substantiated. Small brand without third-party COA disclosure caps at Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liposomal-vegan-vitamin-d3-k2",
      "title": "LIPOSOMAL Vegan Vitamin D3 K2",
      "vendor": "UpNourish",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/LVDKmain.jpg?v=1777871416",
      "score": 62,
      "tier": "standard",
      "certifications": [
        "Certified Vegan"
      ],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liposomal",
        "vegan",
        "vitamin",
        "upnourish"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 27.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171479146693",
      "vsf_explanation": "Vegan D3 (5000 IU) + K2 as MK-4 (400 mcg) and MK-7 (100 mcg) per softgel. Combined D3+K2 supports bone and vascular calcium handling (Rondanelli 2020). Doses are disclosed and clinically relevant, vegan.org certified. Small brand with limited third-party COA visibility; 5000 IU D3 is above RDA and appropriate mostly for deficient users.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "flawless-leg",
      "title": "Flawless Leg",
      "vendor": "UpNourish",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/FLmain.jpg?v=1777871419",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "flawless",
        "leg",
        "upnourish"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 31.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171479277765",
      "vsf_explanation": "SOD B Dimpless (melon SOD) has one small industry-sponsored trial for cellulite; MOROSIL (blood-orange extract) shows waist-circumference reduction in obese subjects. Cellulite/'leg appearance' framing exceeds evidence; per-ingredient doses not disclosed.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "magnesium-glycinate-500mg",
      "title": "MAGNESIUM GLYCINATE 500MG",
      "vendor": "UpNourish",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MagnesiumGlycinate500_483ba955-d380-4b13-af1d-fb31e1960b4f.jpg?v=1777871416",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "glycinate",
        "500mg",
        "upnourish"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 42,
        "sustainability": 48
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171479048389",
      "vsf_explanation": "Bisglycinate is the best-tolerated Mg form (Schuette 1994 absorption). '500 mg per capsule' likely refers to Mg-glycinate compound (yielding ~50-100 mg elemental Mg), not elemental Mg — a common labeling ambiguity Nielsen and Lukaski warn about. Elemental Mg content should be stated on label.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liposomal-vitamin-d3-5000iu-k2-mk7-100-mcg",
      "title": "Liposomal Vitamin D3 5000IU K2 MK7 100 mcg",
      "vendor": "UpNourish",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/VDKmain.jpg?v=1777871416",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liposomal",
        "vitamin",
        "5000iu",
        "mk7",
        "100",
        "mcg",
        "upnourish"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 56,
        "formulation": 56,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171479113925",
      "vsf_explanation": "5000 IU D3 + 100 mcg MK-7 pairing is supported by Knapen 2015 (MK-7 arterial calcification study) and represents a rational repletion combo. Liposomal claim is unsubstantiated by comparative RCT. Small brand, no third-party test disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liposomal-vitamin-d3-50000-iu-k-1000-mcg",
      "title": "Liposomal Vitamin D3 50000 IU K 1000 mcg",
      "vendor": "UpNourish",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/D50000K1000Main.jpg?v=1777871416",
      "score": 36,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liposomal",
        "vitamin",
        "50000",
        "1000",
        "mcg",
        "upnourish"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 30,
        "manufacturing": 40,
        "safety": 25,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 21.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171479081157",
      "vsf_explanation": "50,000 IU D3 daily exceeds the IOM upper limit (4,000 IU/d) by more than 12x and is a prescription-only weekly repletion regimen (Malihi 2019 documented hypercalcemia risk with high-dose D3). Recommending daily use is unsafe; 1000 mcg mixed-K forms also far exceeds routine intake. Serious safety concern.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lustrous-hair",
      "title": "LUSTROUS HAIR",
      "vendor": "UpNourish",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/LHmain.jpg?v=1777871416",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lustrous",
        "hair",
        "upnourish"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171479015621",
      "vsf_explanation": "Keranat (millet seed) has one 3-month industry RCT (n=63) showing hair density increase; SOD B has thin skin data. 22-ingredient female hair blend risks sub-therapeutic doses at each active; nothing disclosed per-ingredient.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "plant-sterols-citrus-bergamot",
      "title": "Plant Sterols Citrus Bergamot",
      "vendor": "UpNourish",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/PlantsterolCitBergamain.jpg?v=1777871416",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "plant",
        "sterols",
        "citrus",
        "bergamot",
        "upnourish"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171479244997",
      "vsf_explanation": "Plant sterols (2g/day) reduce LDL-C ~10% (EFSA 2011 opinion), and Bergavit bergamot polyphenols lower LDL and triglycerides (Toth 2015, Mollace 2011). Bundling CoQ10, fish oil, turmeric, garlic dilutes doses unless each is clinically dosed; label doses not disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnesium-citrate-1120mg",
      "title": "Magnesium Citrate 1120mg",
      "vendor": "UpNourish",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MagnesiumCitrateShopifycompressed.jpg?v=1777871416",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "citrate",
        "1120mg",
        "upnourish"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 48,
        "manufacturing": 52,
        "safety": 42,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 18.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171479310533",
      "vsf_explanation": "1120 mg magnesium citrate compound (~120-180 mg elemental Mg) is fine — but body copy repeatedly says 'magnesium glycinate' while the SKU is citrate, indicating label/marketing errors. Citrate is more laxative and higher doses risk osmotic diarrhea (Ranade 2001).",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "liposomal-d3-10-000iu-k2-200mcg",
      "title": "Liposomal D3 10,000IU K2 200mcg",
      "vendor": "UpNourish",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/D10000IUK200main.jpg?v=1777871416",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liposomal",
        "000iu",
        "200mcg",
        "upnourish"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 22.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171479179461",
      "vsf_explanation": "10,000 IU D3 daily sits at the IOM tolerable upper limit and warrants blood-level monitoring; suitable only for supervised repletion (Vieth 2007). Marketed for daily use in adults, teenagers and kids without safety guidance is inappropriate. K2 MK-7 200 mcg is safe but pairing dose-heavy D3 with no monitoring guidance is problematic.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "femlibido",
      "title": "FEMLIBIDO",
      "vendor": "UpNourish",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/FEMLIBIDOShopifycompressed.jpg?v=1777871416",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "femlibido",
        "upnourish"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 16.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171479441605",
      "vsf_explanation": "Sensoril ashwagandha improved female sexual function in one RCT (Dongre 2015, n=50, 300 mg BID). Fenugreek + Testofen and beet root have limited female libido data. Copy does not disclose Sensoril or LiBoost dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "womens-pre-probiotics-collagen",
      "title": "Women's Pre Probiotics Collagen",
      "vendor": "UpNourish",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ProbioticsCollagen.jpg?v=1777871416",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune",
        "skin",
        "joint"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "women",
        "pre",
        "probiotics",
        "collagen",
        "upnourish"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 48,
        "sustainability": 50
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171479376069",
      "vsf_explanation": "70B CFU probiotic + 1 g XOS/FOS prebiotics + BIOFAC caviar collagen + Cranberex cranberry + D-mannose. Cranberry PACs (36 mg/d) reduce UTI recurrence (Jepson 2012 Cochrane). CFU total is generous but strain identities and per-strain CFU not disclosed on storefront.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "probiotics-200b-cfu",
      "title": "Probiotics 200B CFU",
      "vendor": "UpNourish",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Probiotics200BShopify.jpg?v=1777871416",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "probiotics",
        "200b",
        "cfu",
        "upnourish"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171479343301",
      "vsf_explanation": "200B CFU is above typical clinical range (10-100B) and dose-response plateaus (Ouwehand 2017). 15 unnamed strains + microencapsulation is reasonable; strain-specific benefits (e.g., L. rhamnosus GG) require identity disclosure, which is missing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "akkermansia-muciniphila",
      "title": "Akkermansia Muciniphila",
      "vendor": "UpNourish",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/AkkermansiaShopify.jpg?v=1777871417",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "akkermansia",
        "muciniphila",
        "upnourish"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 48,
        "sustainability": 48
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171479408837",
      "vsf_explanation": "5B AFU pasteurized Akkermansia muciniphila plus resistant dextrin, stachyose and MOS prebiotics. Depommier 2019 Nat Med showed 3 mo pasteurized A. muciniphila 10^10 AFU reduced insulin resistance in overweight adults — 5B AFU is at the lower end of the trial dose. Strain source not identified (A2-32b Akkermansia LMG P-33887?).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "joyful-saffron-ashwagandha",
      "title": "JOYFUL SAFFRON ASHWAGANDHA",
      "vendor": "UpNourish",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/JoyFulmain.jpg?v=1777871417",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "joyful",
        "saffron",
        "ashwagandha",
        "upnourish"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171479638213",
      "vsf_explanation": "Affron saffron (28 mg) shows mood benefits in adolescents and adults (Lopresti 2018, Kell 2017), Sensoril ashwagandha at 250-600 mg reduces stress markers (Auddy 2008), and L-theanine 200 mg supports relaxation. Branded ingredients strengthen the formula; specific doses not shown on the product page.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnesium-citrate-gummy",
      "title": "Magnesium Citrate Gummy",
      "vendor": "UpNourish",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MagnesiumCitrateGummyShopify.jpg?v=1777871416",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "citrate",
        "gummy",
        "upnourish"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 42,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171479474373",
      "vsf_explanation": "600 mg magnesium citrate per gummy is a compound weight (yielding ~85 mg elemental Mg), but gummy delivery adds sugar and pectin fillers and stability of Mg salts in gummy matrices is poor. Elemental Mg not disclosed on storefront.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "plant-based-sport-protein",
      "title": "Plant Based Sport Protein",
      "vendor": "UpNourish",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SportProteinmain.jpg?v=1777871416",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "plant",
        "based",
        "sport",
        "protein",
        "upnourish"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171479507141",
      "vsf_explanation": "Plant protein blends (pea + rice) match whey for MPS at sufficient leucine intake (Banaszek 2019). Protein grams per serving and amino acid profile not disclosed; added probiotics/enzymes offer marginal benefit at unspecified doses.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "areds-2-plus",
      "title": "AREDS 2 PLUS",
      "vendor": "UpNourish",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/AREDSmain.jpg?v=1777871417",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "areds",
        "plus",
        "upnourish"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171479572677",
      "vsf_explanation": "AREDS2 formula (lutein 10 mg, zeaxanthin 2 mg, vitamin C, E, zinc, copper) reduced AMD progression (AREDS2 Research Group 2013, JAMA). '8 key nutrients' framing suggests AREDS2 alignment but doses not confirmed; blue-light-protection claim is aspirational.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnesium-10-in-1-complex",
      "title": "Magnesium 10 in 1 Complex",
      "vendor": "UpNourish",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MagnesiumComplexmain_f625ceb7-d7da-41d6-8b9d-6fab162c2048.jpg?v=1777871417",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "complex",
        "upnourish"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 52,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 42,
        "sustainability": 48
      },
      "price": 18.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171479670981",
      "vsf_explanation": "170 mg elemental Mg from 10 blended forms is a BiOptimizers-style formulation (glycinate, malate, citrate, taurate, l-threonate etc.). 170 mg is only ~40% RDA, so it is best paired with dietary Mg. Per-form breakdown not disclosed on storefront.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fruit-veggie",
      "title": "Fruit & Veggie",
      "vendor": "UpNourish",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/FruitsVeggieShopify.jpg?v=1777871417",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fruit",
        "veggie",
        "upnourish"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46171479703749",
      "vsf_explanation": "'61 organic fruits and vegetables' in capsules provides tiny amounts per ingredient; whole-food supplement blends typically deliver mg-scale doses of each source (Chambial 2013 on Vit C). Provides fiber, phytonutrients as marketing rather than as clinically relevant intakes.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "arq8™-creatine-monohydrate-powder",
      "title": "Arq8™ Creatine Monohydrate Powder",
      "vendor": "Arq8",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/collection-powder.png?v=1777907521",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "arq8",
        "creatine",
        "monohydrate",
        "powder",
        "arq8"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173413212357",
      "vsf_explanation": "Creatine monohydrate remains the gold standard for strength/lean mass (Kreider 2017 ISSN). 'Nano-refined' marketing is unsupported: no head-to-head absorption trial vs Creapure exists. Micronized creatine achieves similar effects at ~$0.20/serving, making $45 pricing hard to justify.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "maac-stack",
      "title": "MAAC Stack",
      "vendor": "BRAINSUPREME",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MaacStack_Front.png?v=1777907568",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "maac",
        "stack",
        "brainsupreme"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 48,
        "safety": 45,
        "transparency": 32,
        "sustainability": 45
      },
      "price": 119,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173413605573",
      "vsf_explanation": "'Mushrooms, adaptogens, aminos, cacao' with no ingredient identification or dosing on storefront. Category individually has evidence (Lion's Mane, ashwagandha KSM-66) but a proprietary 'stack' with no disclosed ingredients cannot be validated. Priced at $119.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "the-black-stack",
      "title": "THE BLACK STACK",
      "vendor": "BRAINSUPREME",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BlackStackFRONT.webp?v=1777907568",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "the",
        "black",
        "stack",
        "brainsupreme"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 25,
        "manufacturing": 35,
        "safety": 40,
        "transparency": 15,
        "sustainability": 40
      },
      "price": 105,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173413638341",
      "vsf_explanation": "Explicitly described as '2.5x the proprietary BRAINSUPREME blend' with no ingredient list or doses in the description. Nootropic stacks require dose-transparent actives (L-theanine, caffeine, alpha-GPC) to substantiate cognitive claims (Camfield 2014).",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "feel-good",
      "title": "FEEL GOOD",
      "vendor": "BRAINSUPREME",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BrainSupreme_FEELGOOD_FRONT.png?v=1777907569",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "feel",
        "good",
        "brainsupreme"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 30,
        "manufacturing": 35,
        "safety": 40,
        "transparency": 15,
        "sustainability": 40
      },
      "price": 105,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173413671109",
      "vsf_explanation": "Mood/attitude support product with zero ingredient or dose disclosure in copy. Adaptogen/nootropic mood formulas require actives at RCT-verified doses (e.g., ashwagandha 300-600 mg, saffron 28 mg) to substantiate mood claims.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "genius",
      "title": "GENIUS",
      "vendor": "BRAINSUPREME",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BrainSupreme_GENIUS_FRONT.png?v=1777907575",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "genius",
        "brainsupreme"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 25,
        "manufacturing": 35,
        "safety": 35,
        "transparency": 15,
        "sustainability": 40
      },
      "price": 105,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173413703877",
      "vsf_explanation": "'Limitless-style' cognitive enhancement claims paired with a proprietary functional-mushroom-plus-nootropic blend and no dose transparency. Cognitive-effect claims of this magnitude have no clinical support at supplement doses.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "athlete",
      "title": "ATHLETE",
      "vendor": "BRAINSUPREME",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BrainSupreme_ATHLETE_FRONT.png?v=1777907574",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "athlete",
        "brainsupreme"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 30,
        "manufacturing": 35,
        "safety": 40,
        "transparency": 15,
        "sustainability": 40
      },
      "price": 105,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173413736645",
      "vsf_explanation": "Sport blend of 'organic functional mushrooms, amino acids, nutrients, herbs, adaptogens, ergogenics' with zero ingredient identities or doses. Ergogenics require clinical dosing (beta-alanine 3.2g/d, citrulline 6g) that cannot be inferred here.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "butea-superba",
      "title": "Butea Superba",
      "vendor": "Based Supplements",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/FIRST_SLIDE_9978c788-4afa-4e13-b9e5-80d69c0115c9.jpg?v=1777907597",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "butea",
        "superba",
        "based",
        "supplements"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 40,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173413998789",
      "vsf_explanation": "Butea superba has one Thai open-label trial for erectile function (Cherdshewasart 2003, n=17, low quality). Contains prenylated flavonoids with androgen-receptor activity; safety in Western use is uncharacterized. 'Wild harvested' provenance is unverifiable.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "pine-pollen",
      "title": "Pine Pollen",
      "vendor": "Based Supplements",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_02bc68f0-3df7-4232-ba44-484ecb364a0d.jpg?v=1777907597",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pine",
        "pollen",
        "based",
        "supplements"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 40,
        "sustainability": 55
      },
      "price": 59.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173414097093",
      "vsf_explanation": "Pine pollen contains trace phyto-androgens (testosterone, DHEA, androstenedione at ng/g levels); no human RCTs support meaningful hormonal effects. Marketed for testosterone/hormonal support without clinical basis.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "shilajit-tablets",
      "title": "Shilajit Tablets",
      "vendor": "Based Supplements",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Instagrampost-274_2x_add5c95b-6c02-4f68-999d-e1dd640720b0.png?v=1777907602",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shilajit",
        "tablets",
        "based",
        "supplements"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 44.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173414195397",
      "vsf_explanation": "Purified shilajit (PrimaVie) has small RCTs showing modest testosterone increase (Pandit 2016, n=75) and fatigue/CoQ10 improvements. Non-standardized shilajit raises heavy-metal (lead/arsenic) contamination risk; sourcing 'highest peaks' unverifiable and no CoA disclosed.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "shilajit-resin",
      "title": "Shilajit Resin",
      "vendor": "Based Supplements",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Instagrampost-278_2x_b309e957-c7c1-47b8-8426-a9bc4015e906.png?v=1777907602",
      "score": 47,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shilajit",
        "resin",
        "based",
        "supplements"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 40,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173414293701",
      "vsf_explanation": "Resin form is closer to traditional preparation; PrimaVie shilajit shows testosterone/energy benefits (Pandit 2016, Keller 2019). Same contamination concern as tablets: raw shilajit routinely exceeds heavy-metal limits without purification and no CoA is provided.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "pre-hustle-v3",
      "title": "PRE HUSTLE V3",
      "vendor": "BLACKLABEL Supplements",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitled_design_44.png?v=1777907719",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pre",
        "hustle",
        "blacklabel",
        "supplements"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 45,
        "sustainability": 48
      },
      "price": 61.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173418029253",
      "vsf_explanation": "Comprehensive pre-workout stack aimed at strength/endurance/focus. Standard ingredients in this category (caffeine 150-300 mg, beta-alanine 3.2 g, citrulline malate 6-8 g, creatine 3-5 g) have solid RCTs individually — this listing does not disclose per-scoop mg, which is the critical variable. 'No jitters' claim without stimulant panel is unverifiable.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pre-game",
      "title": "PRE GAME",
      "vendor": "BLACKLABEL Supplements",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitled_design_41.png?v=1777907719",
      "score": 65,
      "tier": "standard",
      "certifications": [
        "NSF Certified for Sport"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pre",
        "game",
        "blacklabel",
        "supplements"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 78,
        "safety": 70,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173418127557",
      "vsf_explanation": "NSF Certified for Sport designation is a real, tested certification (banned-substance screened + facility audit) and significantly elevates manufacturing/safety scores versus average pre-workouts. Caffeine's ergogenic effect (Grgic 2018 meta-analysis) is well established. Missing full label breakdown in listing prevents a Verified score.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "beta-alanine",
      "title": "BETA-ALANINE",
      "vendor": "BLACKLABEL Supplements",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitled_design_12_2de9720f-a7bc-4f7e-bbf7-b18c5f191f34.png?v=1777907724",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beta",
        "alanine",
        "blacklabel",
        "supplements"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173418324165",
      "vsf_explanation": "Beta-alanine has solid ergogenic evidence for high-intensity exercise (Trexler 2015 ISSN position stand: 4-6 g/day raises muscle carnosine). Empty product description means no dose, no COA, no manufacturing details are disclosed. BLACKLABEL is a small brand with limited public provenance, so transparency and manufacturing drag the score into the low Standard band.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "performance-greens",
      "title": "PERFORMANCE GREENS",
      "vendor": "BLACKLABEL Supplements",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign28.png?v=1777907724",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "performance",
        "greens",
        "blacklabel",
        "supplements"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173418291397",
      "vsf_explanation": "Greens powders can supply modest polyphenol and fiber intake but rarely displace vegetable consumption. This product lists benefits without any ingredient identity or dosing; category is dominated by proprietary blends.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "creatine-monohydrate-3",
      "title": "CREATINE MONOHYDRATE",
      "vendor": "BLACKLABEL Supplements",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitled_design_38_7ed28005-5176-4bb3-8a75-d2161127559d.png?v=1777907724",
      "score": 68,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "creatine",
        "monohydrate",
        "blacklabel",
        "supplements"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 68,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173418356933",
      "vsf_explanation": "5 g pure creatine monohydrate is the gold-standard dose backed by hundreds of RCTs (Kreider 2017 ISSN position stand: strength, power, lean mass). No Creapure or third-party purity attestation is stated, which is the main differentiator vs Momentous. Anchors just below Momentous Creatine (~76 Verified).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-aminos",
      "title": "PURE AMINOS",
      "vendor": "BLACKLABEL Supplements",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5DBE7247-70BF-4834-B943-40F55B20D1B7.png?v=1777907725",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "aminos",
        "blacklabel",
        "supplements"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 55,
        "sustainability": 52
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173418520773",
      "vsf_explanation": "EAA product covering all nine essential amino acids — superior to BCAA-only formulas for MPS (Jackman 2017 showed EAAs required for full anabolic response). Per-serving mg breakdown and leucine content (should be 2-3 g/serving) not disclosed on storefront.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "tamaflex®",
      "title": "TAMAFLEX®",
      "vendor": "BLACKLABEL Supplements",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign22.png?v=1777907724",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tamaflex",
        "blacklabel",
        "supplements"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 27.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173418389701",
      "vsf_explanation": "Tamaflex (Tamarindus indica seed + Curcuma longa) has industry RCT evidence for WOMAC score improvement in mild OA (Rao 2019, n=105, 400 mg twice daily). Copy does not confirm branded Tamaflex dose or purity; consumer-facing brand transparency is thin.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "omega-3",
      "title": "OMEGA 3",
      "vendor": "BLACKLABEL Supplements",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign24.png?v=1777907724",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "omega",
        "blacklabel",
        "supplements"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173418553541",
      "vsf_explanation": "Copy correctly cites the 1-3 g EPA+DHA/d evidence range used in Skulas-Ray 2019 AHA advisory and REDUCE-IT (icosapent ethyl). Product page does not disclose EPA/DHA mg per softgel, ester form (rTG vs EE), IFOS certification or peroxide values.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-power",
      "title": "PURE POWER",
      "vendor": "BLACKLABEL Supplements",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitled_design_42_0635c490-1b73-4aef-b86d-3d08c032d911.png?v=1777907724",
      "score": 64,
      "tier": "standard",
      "certifications": [
        "NSF Certified for Sport"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "power",
        "blacklabel",
        "supplements"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 78,
        "safety": 70,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 44.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173418422469",
      "vsf_explanation": "NSF Certified for Sport stim-free performance builder — the cert alone lifts manufacturing/safety above uncertified peers. Non-stim daily-use positioning avoids caffeine-cycling issues. Ingredient panel and doses aren't shown in listing, capping evidence/formulation transparency at Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "post-hustle",
      "title": "POST HUSTLE",
      "vendor": "BLACKLABEL Supplements",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitled_design_94aa4a04-a460-44ac-8448-6e4bfb429f77.png?v=1777907725",
      "score": 68,
      "tier": "standard",
      "certifications": [
        "NSF Certified for Sport"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "post",
        "hustle",
        "blacklabel",
        "supplements"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 78,
        "safety": 75,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 64.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173418750149",
      "vsf_explanation": "Whey protein isolate recovery formula with two NSF Certified for Sport flavors — placing it in the athlete-grade purity tier for those SKUs. Protein grams per serving and full amino profile not disclosed in listing copy, limiting formulation transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "collagen-protein",
      "title": "COLLAGEN PROTEIN",
      "vendor": "BLACKLABEL Supplements",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitled_design_47.png?v=1777907725",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "collagen",
        "protein",
        "blacklabel",
        "supplements"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173418586309",
      "vsf_explanation": "Hydrolyzed collagen 10-15 g/day supports skin and joint markers (Choi 2019 meta-analysis). Product description gives no protein grams per serving, no source (bovine/marine), and no patented peptide (Verisol/Peptan) reference, keeping this generic.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "recovery-protein",
      "title": "RECOVERY PROTEIN",
      "vendor": "BLACKLABEL Supplements",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Recovery_Protein.png?v=1777907725",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "recovery",
        "protein",
        "blacklabel",
        "supplements"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 69.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173418619077",
      "vsf_explanation": "Post-workout protein at ~20-40 g supports muscle protein synthesis (Morton 2018 meta-analysis). This listing provides no ingredient panel, no protein type (whey isolate vs concentrate vs blend), no per-serving grams, and no third-party testing. Landing in low Standard purely on the underlying category evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitalitybits®-small-bag",
      "title": "VITALITYbits® | Small Bag",
      "vendor": "ENERGYbits",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/vitalitybits-small-baggeneralpartnerenergybits-5971052.png?v=1777907750",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitalitybits",
        "small",
        "bag",
        "energybits"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 65,
        "sustainability": 60
      },
      "price": 65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173419307205",
      "vsf_explanation": "50/50 spirulina and chlorella tablets deliver bioavailable protein, chlorophyll, B12 analogues, and carotenoids (Karkos 2011 on spirulina). ENERGYbits publishes single-ingredient sourcing and third-party purity testing, unusual for the category. Efficacy at typical 30-tab serving is modest.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "recoverybits®-small-bag",
      "title": "RECOVERYbits® | Small Bag",
      "vendor": "ENERGYbits",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/recoverybits-small-bagsubscriptionenergybits-6980882.png?v=1777907750",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "recoverybits",
        "small",
        "bag",
        "energybits"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 55,
        "sustainability": 58
      },
      "price": 65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173419339973",
      "vsf_explanation": "Single-ingredient cracked-cell-wall chlorella tablets (no fillers) — chlorella has modest RCT support for immune markers and heavy-metal binding (Uchikawa 2010, Merino 2015). Product page overstates ('replaces need for vegetables', 'highest chlorophyll in world') and does not disclose organic certification or heavy-metal COAs.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "beautybits®-spirulina-large-bag",
      "title": "BEAUTYbits® Spirulina | Large Bag",
      "vendor": "ENERGYbits",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/beautybits-spirulina-large-bagsubscriptionenergybits-6892179.png?v=1777907755",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beautybits",
        "spirulina",
        "large",
        "bag",
        "energybits"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 70,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 65,
        "sustainability": 60
      },
      "price": 130,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173419438277",
      "vsf_explanation": "100% spirulina (Arthrospira platensis) supports antioxidant and immune markers (Karkos 2011); phycocyanin has anti-inflammatory data. Single-ingredient purity, published third-party testing, and Non-GMO/GMP claims raise the ceiling; benefit still dose-dependent.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "beautybits®-small-bag",
      "title": "BEAUTYbits® | Small Bag",
      "vendor": "ENERGYbits",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/beautybits-small-baggeneralpartnerenergybits-5219365.png?v=1777907755",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beautybits",
        "small",
        "bag",
        "energybits"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 70,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 65,
        "sustainability": 60
      },
      "price": 65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173419569349",
      "vsf_explanation": "Same 100% spirulina formulation as the large bag: phycocyanin-rich algae with antioxidant and cardiometabolic support data (DiNicolantonio 2020 review). Same brand transparency strengths; smaller pack size limits daily intake for meaningful physiologic effect.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "energybits®-spirulina-large-bag",
      "title": "ENERGYbits® Spirulina | Large Bag",
      "vendor": "ENERGYbits",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/energybits-spirulina-large-baggeneralpartnerenergybits-8686422.png?v=1777907755",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "energybits",
        "spirulina",
        "large",
        "bag",
        "energybits"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 55,
        "sustainability": 58
      },
      "price": 130,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173419503813",
      "vsf_explanation": "Single-ingredient spirulina tablets, 1 cal each. Spirulina protein content is real (~60-70% by weight) but '3x protein of steak' is a per-gram misdirection — servings deliver ~2-3 g protein. Endurance/focus RCT support is limited (Kalafati 2010, 6 g/d improved TTE by 25% in athletes). No microcystin testing referenced.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "energybits®-small-bag",
      "title": "ENERGYbits® | Small Bag",
      "vendor": "ENERGYbits",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/energybits-small-baggeneralpartnerenergybits-9402232.png?v=1777907756",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "energybits",
        "small",
        "bag",
        "energybits"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 65,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173419471045",
      "vsf_explanation": "Single-ingredient spirulina tablets (100% Arthrospira platensis). Modest RCT evidence for antioxidant/lipid effects (Karkos 2011 review) but the label 'clean steady energy' is marketing; no caffeine/nicotinamide vector. Serving size and per-tablet dose not disclosed in copy. Established niche brand with third-party testing claims. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitalitybits®-spirulina-chlorella-large-bag",
      "title": "VITALITYbits® Spirulina/Chlorella | Large Bag",
      "vendor": "ENERGYbits",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/vitalitybits-spirulinachlorella-large-bagsubscriptionenergybits-4748756.png?v=1777907755",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitalitybits",
        "spirulina",
        "chlorella",
        "large",
        "bag",
        "energybits"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 65,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 130,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173419602117",
      "vsf_explanation": "50/50 spirulina + chlorella tablets. Chlorella has small RCTs for oxidative stress markers (Panahi 2012) but 'detox' claim is unsupported. Doses not stated in copy. Same reputable niche brand as ENERGYbits with cracked-cell-wall chlorella. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "recoverybits®-chlorella-large-bag",
      "title": "RECOVERYbits® Chlorella | Large Bag",
      "vendor": "ENERGYbits",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/recoverybits-chlorella-large-bagsubscriptionenergybits-4171731.png?v=1777907755",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "recoverybits",
        "chlorella",
        "large",
        "bag",
        "energybits"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 55,
        "sustainability": 58
      },
      "price": 130,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173419634885",
      "vsf_explanation": "Same cracked-cell-wall chlorella as the Small Bag SKU in a larger format. Same evidence base (Merino 2015 immune markers, Uchikawa 2010 heavy-metal binding). Cracked-cell-wall processing is genuinely required for chlorella digestibility. No third-party heavy-metal panel disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "rhodiola-rosea-tincture-natural-stress-energy-support-2-oz",
      "title": "Rhodiola Rosea Tincture – Natural Stress & Energy Support (2 oz)",
      "vendor": "Alaska Rhodiola",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Image-01.png?v=1777907763",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "rhodiola",
        "rosea",
        "tincture",
        "natural",
        "stress",
        "energy",
        "support",
        "alaska",
        "rhodiola"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 45,
        "manufacturing": 48,
        "safety": 48,
        "transparency": 40,
        "sustainability": 55
      },
      "price": 35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173419733189",
      "vsf_explanation": "Rhodiola rosea has adaptogen/stress RCTs (Darbinyan 2007 SHR-5 extract 576 mg/d improved fatigue in medical residents) but efficacy depends on 3% rosavins + 1% salidroside standardization. Tinctures cannot verify these markers, and per-dropper dose is not stated. Alaska-grown provenance is a positive.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "klb-5",
      "title": "KLB-5",
      "vendor": "AmBari Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/KLB-5_Supplement.png?v=1777907900",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "klb",
        "ambari",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 60,
        "sustainability": 42
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173421961413",
      "vsf_explanation": "Doses are disclosed (100mg each of blue-green algae, bromelain, lecithin, kelp, ACV) but all are sub-therapeutic. Bromelain RCT dosing starts at 500mg; ACV pill 100mg is a token dose vs. Kondo 2009 trial that used 15ml liquid. Kelp adds iodine risk.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "collagen-mini-10g-protein-shots-celebrate",
      "title": "Collagen Mini 10g Protein Shots - Celebrate",
      "vendor": "AmBari Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Celebrate_Collagen_Mini_10g_Protein_Shots.webp?v=1777907926",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "collagen",
        "mini",
        "10g",
        "protein",
        "shots",
        "celebrate",
        "ambari",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty",
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 42
      },
      "price": 2.45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173422059717",
      "vsf_explanation": "10g hydrolyzed bovine collagen (Types I+III) in a ready-to-drink shot. Choi 2019 meta found skin/joint benefit at 2.5–15g/day, so 10g is within range. Bariatric-market positioning is honest; no third-party testing cited.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bariatric-one-a-day-multivitamin",
      "title": "Bariatric One-A-Day Multivitamin",
      "vendor": "AmBari Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Bariatric_One_A_Day_Multivitamin_1.png?v=1777907931",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bariatric",
        "one",
        "day",
        "multivitamin",
        "ambari",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 60,
        "sustainability": 42
      },
      "price": 13.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173422125253",
      "vsf_explanation": "Purpose-built for post-bariatric patients with 45mg iron and 100% DV of 20 vitamins/minerals — matches ASMBS 2016 post-bariatric guidance for elevated iron/B12. B12 at 41,667% DV is high but consistent with post-op malabsorption protocols. Reasonable specialty product.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "protein-shots-15g",
      "title": "Protein Shots 15g",
      "vendor": "AmBari Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/protein_shots_for_weight_loss.png?v=1777907931",
      "score": 53,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "protein",
        "shots",
        "15g",
        "ambari",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 50,
        "sustainability": 40
      },
      "price": 2.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173422158021",
      "vsf_explanation": "15g protein via hydrolyzed collagen + whey concentrate, positioned for post-bariatric patients where small-volume liquid protein has clinical utility (Andreu 2010). Collagen protein is incomplete (low tryptophan), so leucine/EAA profile is likely below the muscle-synthesis threshold (Morton 2018).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zenx-mood-support-nootropic",
      "title": "ZenX: Mood Support Nootropic",
      "vendor": "Stoned Ape, Inc",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/StonedApeZenXJar.png?v=1777907964",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zenx",
        "mood",
        "support",
        "nootropic",
        "stoned",
        "ape",
        "inc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 30,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 25,
        "sustainability": 35
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173426319557",
      "vsf_explanation": "No ingredient list, no doses, only vague 'supports cortisol/adrenals' marketing. Vendor 'Stoned Ape, Inc' has no published GMP or third-party testing info. Fails transparency and formulation criteria.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "xnergy-a-m-nootropic-for-calm-energy-focus-motivation",
      "title": "Xnergy: A.M. Nootropic for Calm Energy, Focus & Motivation",
      "vendor": "Stoned Ape, Inc",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Stoned_Ape_Xnergy_Product_Shot.png?v=1777907965",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "xnergy",
        "nootropic",
        "for",
        "calm",
        "energy",
        "focus",
        "motivation",
        "stoned",
        "ape",
        "inc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 30,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 25,
        "sustainability": 35
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173426352325",
      "vsf_explanation": "No actives disclosed, no doses, only marketing copy about focus and reaction time. Same low-provenance vendor. Similar tier to Amazon prop-blend anchor.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "dream-p-m-nootropic-sleep-aid-for-recovery",
      "title": "Dream: P.M. Nootropic & Sleep Aid for Recovery",
      "vendor": "Stoned Ape, Inc",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/StonedApeDreamProductShot.png?v=1777907970",
      "score": 66,
      "tier": "standard",
      "certifications": [
        "NSF Certified for Sport"
      ],
      "goal_tags": [
        "sleep",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dream",
        "nootropic",
        "sleep",
        "aid",
        "for",
        "recovery",
        "stoned",
        "ape",
        "inc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 78,
        "safety": 68,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173426385093",
      "vsf_explanation": "NSF Certified for Sport sleep aid with branded Venetron (rafuma leaf extract) that has small human trials for sleep quality (Yamatsu 2015). Non-habit-forming, athlete-safe cert positioning is a real differentiator. Missing dose disclosure in listing keeps it at Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-heartburn-digestive-relief-blend-extra-strength",
      "title": "Organic Heartburn & Digestive Relief Blend Extra Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ACID_REFLUX__GERD.webp?v=1777908095",
      "score": 47,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "heartburn",
        "digestive",
        "relief",
        "blend",
        "extra",
        "strength",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 29.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173430251717",
      "vsf_explanation": "DGL licorice has modest reflux support (Raveendra 2012, Evid Complement Alternat Med) and ginger has NVP data (Ozgoli 2009), but per-herb doses not disclosed. Traditional-use blend, not standardized extracts; borderline against Standard threshold.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-shilajit-resin-with-manuka-honey-premium-energy-immunity-vitality-blend",
      "title": "Pure Shilajit Resin with Manuka Honey | Premium Energy, Immunity & Vitality Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Shilijat_Manuka_Honey_Front_1024x1024_2x_png.webp?v=1777908096",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "shilajit",
        "resin",
        "with",
        "manuka",
        "honey",
        "premium",
        "energy",
        "immunity",
        "vitality",
        "blend",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 35,
        "sustainability": 35
      },
      "price": 27.88,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173430284485",
      "vsf_explanation": "Himalayan shilajit resin blended with Manuka honey. Shilajit has small human trials suggesting mild testosterone/fatigue effects (Pandit et al. 2016) but is repeatedly flagged for heavy-metal contamination (lead, arsenic, mercury) without third-party COAs (Wilson et al. 2011). Vendor VeggieVerve does not disclose testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-intra-cellular-detox-plant-based-cellular-liver-support",
      "title": "Organic Intra-Cellular Detox | Plant-Based Cellular & Liver Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Intra-Cellular_Detox_Organic_Cellular_Cleanse_Immune_Support.png?v=1777908096",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "intra",
        "cellular",
        "detox",
        "plant",
        "based",
        "cellular",
        "liver",
        "support",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 35,
        "sustainability": 55
      },
      "price": 29.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173430448325",
      "vsf_explanation": "Broad organic herbal 'cellular detox' liquid with no ingredient list or per-herb dose shown in the copy. The concept of an 'intra-cellular detox' is not defined pharmacologically and 'detox' claims are not supported by controlled data (Klein 2015 review).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-herbal-iron-formula",
      "title": "Organic Herbal Iron Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Iron_Formula_1024x1024_2x_png.webp?v=1777908095",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "herbal",
        "iron",
        "formula",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 50,
        "safety": 50,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173430350021",
      "vsf_explanation": "23 mg elemental iron with vitamin C for absorption follows standard practice (Cook 2005 Am J Clin Nutr). Pea protein iron source is less bioavailable than heme but reduces GI upset. Herbal cofactors like moringa and curry leaf lack RCT support for iron status.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lymphatic-drainage-power-cleanse-organic-liquid-detox-formula",
      "title": "Lymphatic Drainage Power Cleanse – Organic Liquid Detox Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Organic_Lymphatic_Drainage_Detox_Burdock_Echinacea_Goldenseal_Blend_16_fl_oz.webp?v=1777908096",
      "score": 35,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lymphatic",
        "drainage",
        "power",
        "cleanse",
        "organic",
        "liquid",
        "detox",
        "formula",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 40,
        "manufacturing": 35,
        "safety": 40,
        "transparency": 30,
        "sustainability": 35
      },
      "price": 29.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173430382789",
      "vsf_explanation": "20+ herb tincture including poke root (Phytolacca) and goldenseal — poke root is potentially toxic and generally contraindicated for internal use (Barceloux 2008). 'Lymphatic drainage' oral cleanse has no physiologic basis; skeletal muscle movement, not herbs, drives lymph flow. No dosing on any component.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-memory-focus-herbal-tonic-bacopa-ginkgo-biloba-guarana-natural-brain-health-mental-clarity-support",
      "title": "Organic Memory & Focus Herbal Tonic – Bacopa, Ginkgo Biloba, Guarana | Natural Brain Health & Mental Clarity Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Organic_Memory_Focus_Herbal_Tonic_Bacopa_Ginkgo_Biloba_Guarana_Natural_Brain_Health_Mental_Clarity_Support.webp?v=1777908095",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "memory",
        "focus",
        "herbal",
        "tonic",
        "bacopa",
        "ginkgo",
        "biloba",
        "guarana",
        "natural",
        "brain",
        "health",
        "mental",
        "clarity",
        "support",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 30,
        "sustainability": 55
      },
      "price": 29.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173430317253",
      "vsf_explanation": "Bacopa (Stough 2001 supports 300mg for memory) and Ginkgo (LeBars 1997, 240mg standardized) have modest RCT support, but this liquid tonic lists no mg per dose. Guarana adds caffeine variability. Certified-organic is a plus.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "omega-3-extra-strength-vegan-complex-with-vitamin-d3-magnesium",
      "title": "Omega-3 Extra Strength Vegan Complex with Vitamin D3 & Magnesium",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Omega3Complex_1024x1024_2x_png.webp?v=1777908096",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "inflammation",
        "cognitive",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "omega",
        "extra",
        "strength",
        "vegan",
        "complex",
        "with",
        "vitamin",
        "magnesium",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 40,
        "sustainability": 60
      },
      "price": 29.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173430415557",
      "vsf_explanation": "Plant-based omega-3 liquid built around microalgae oil (a real DHA source; Craddock 2017 review) plus chlorella, spirulina, flax/chia/pumpkin seeds, sea vegetables, moringa, turmeric, and mushrooms. No mg of EPA/DHA per serving disclosed, so we cannot confirm the algal contribution is meaningful vs a mostly-ALA product.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-super-aloe-vera-detox",
      "title": "Organic Super Aloe Vera Detox",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Super_Aloe_Vera_Front_1024x1024_2x_png.webp?v=1777908095",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "super",
        "aloe",
        "vera",
        "detox",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 29.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173430481093",
      "vsf_explanation": "Cape aloe + aloe vera + quassia bark daily tonic. Cape aloe (aloin) is a stimulant laxative with an FDA OTC ban (2002) for that use because of colonic mucosa concerns, and quassia carries hepatic caution (Yin 2005). Marketing 'daily use' at 1-2 tablespoons is inconsistent with the safety profile of aloin-containing whole-leaf aloe.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-liquid-chlorophyll-alfalfa-white-mulberry-detox-formula",
      "title": "Organic Liquid Chlorophyll | Alfalfa & White Mulberry Detox Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Liquid_Chlorophyll_1024x1024_2x_png.webp?v=1777908095",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "liquid",
        "chlorophyll",
        "alfalfa",
        "white",
        "mulberry",
        "detox",
        "formula",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 45,
        "manufacturing": 40,
        "safety": 60,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 29.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173430513861",
      "vsf_explanation": "Alfalfa + mulberry-derived liquid chlorophyll. Human evidence for oral chlorophyll on 'detox', internal deodorization or hormone balance is thin — most claims trace to Lam & Brush 1950 anecdote. Chlorophyllin has some cellular data (Egner et al. 2001 aflatoxin) but doses here are unclear.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-pure-soursop-blend-by-livingston-naturals-natural-herbal-labs",
      "title": "Organic Pure Soursop Blend by Livingston Naturals, Natural Herbal Labs",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/organic-pure-soursop-blend-by-livingston-naturals-natural-herbal-labs-16-fl-oz-319462.png?v=1777908100",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "pure",
        "soursop",
        "blend",
        "livingston",
        "naturals",
        "natural",
        "herbal",
        "labs",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 30,
        "manufacturing": 35,
        "safety": 30,
        "transparency": 40,
        "sustainability": 55
      },
      "price": 29.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173430546629",
      "vsf_explanation": "Liquid soursop (Annona muricata) blend of leaf, bark, root, seed, fruit, and stem. Claims blood pressure/blood sugar support and traditional use for parasites. Annonaceous acetogenins in soursop have neurotoxicity concerns (Caparros-Lefebvre 1999 atypical Parkinsonism link) and no proven human efficacy. Multiple disease claims without RCT support.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "dr-missions-organic-colon-cleanser",
      "title": "Dr. Mission's Organic Colon Cleanser",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/dr-missions-organic-colon-cleanser-839568.png?v=1777908100",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mission",
        "organic",
        "colon",
        "cleanser",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 38,
        "manufacturing": 35,
        "safety": 40,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 30.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173430644933",
      "vsf_explanation": "21-herb liquid cleanse containing stimulant laxatives (cascara sagrada, senna, aloe). Detoxification claims are not supported by clinical evidence (Klein 2015). Cascara sagrada was removed from OTC laxatives by FDA in 2002 due to safety concerns. Ingredient amounts hidden in a proprietary tonic.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "organic-natural-allergy-relief-formula-livingston-natural-herbal-labs-16-fl-oz",
      "title": "Organic Natural Allergy Relief Formula. Livingston Natural Herbal Labs 16 fl oz",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Allergy.png?v=1777908101",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "natural",
        "allergy",
        "relief",
        "formula",
        "livingston",
        "natural",
        "herbal",
        "labs",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 30,
        "sustainability": 55
      },
      "price": 29.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173430710469",
      "vsf_explanation": "Nettle and bromelain have small trials for allergic rhinitis (Roschek 2009 nettle; Guo 2019 bromelain) but this tincture provides no mg amounts. 'Regulates inflammatory pathways' is overreach for a botanical blend.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "organic-herbal-heavy-metal-detox",
      "title": "Organic Herbal Heavy Metal Detox",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Organic_Herbal_Heavy_Metal_Detox.jpg?v=1777908101",
      "score": 28,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "herbal",
        "heavy",
        "metal",
        "detox",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 32,
        "manufacturing": 32,
        "safety": 40,
        "transparency": 25,
        "sustainability": 42
      },
      "price": 29.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173430677701",
      "vsf_explanation": "Chlorella + cilantro + spirulina + pine bark 'heavy metal detox'. No RCTs support chlorella or cilantro chelating mercury/lead in humans; established chelators (DMSA, EDTA) are prescription medications for confirmed poisoning. Claims removing mercury, arsenic, lead, uranium, fluoride are unsupported.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "multifunction-energy-boost-shilajit-ashwagandha-rhodiola-ginseng-mix-extra-strength-16-oz",
      "title": "Multifunction Energy Boost: Shilajit, Ashwagandha, Rhodiola, Ginseng Mix. Extra Strength 16 oz",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/multifunction-energy-boost-shilajit-ashwagandha-rhodiola-ginseng-mix-extra-strength-16-oz-818832.png?v=1777908101",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "multifunction",
        "energy",
        "boost",
        "shilajit",
        "ashwagandha",
        "rhodiola",
        "ginseng",
        "mix",
        "extra",
        "strength",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 30,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 29.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173430743237",
      "vsf_explanation": "13-in-1 herbal blend (shilajit, ashwagandha, rhodiola, ginseng, turmeric, ginkgo, nettle, cordyceps, fenugreek, black maca and more) without a single per-ingredient dose — the definition of an unverifiable proprietary blend. Individual herbs like Sensoril ashwagandha (Chandrasekhar 2012) work at specific doses that cannot be confirmed here.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "organic-heart-circulation-formula",
      "title": "Organic Heart & Circulation Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/organic-heart-circulation-formula-258107.jpg?v=1777908100",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "heart",
        "circulation",
        "formula",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 30,
        "manufacturing": 35,
        "safety": 25,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 29.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173430808773",
      "vsf_explanation": "Herbal tincture makes overt disease claims (congenital heart conditions, arrhythmia, angina, blood pressure) that trigger the unverified-disease-claim auto-fail. Doses not disclosed and no manufacturing provenance. Even herbs with modest cardio evidence (hawthorn, garlic) cannot rescue product with prescription-tier positioning.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "liquid-himalayan-shilajit-maximum-strength",
      "title": "Liquid Himalayan Shilajit Maximum Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/liquid-himalayan-shilajit-maximum-strength-755944.png?v=1777908101",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liquid",
        "himalayan",
        "shilajit",
        "maximum",
        "strength",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic",
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 45,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 49.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173430776005",
      "vsf_explanation": "Shilajit has small trials at ~250–500mg PrimaVie standardized extract (Pandit 2016 for testosterone). Raw shilajit carries heavy-metal (lead, arsenic) contamination risk without third-party testing. '10,000mg' claim outsized without a COA.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "organic-herbal-immunity-formula-premium-quality-triple-strength",
      "title": "Organic Herbal Immunity Formula Premium Quality Triple Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/organic-immunity-formula-273350.webp?v=1777908100",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "herbal",
        "immunity",
        "formula",
        "premium",
        "quality",
        "triple",
        "strength",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 30,
        "sustainability": 55
      },
      "price": 29.88,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173430841541",
      "vsf_explanation": "Elderberry (Tiralongo 2016) and echinacea have modest cold-shortening RCT support, but this tincture contains goldenseal and other actives with no dosing disclosure. Goldenseal has CYP450 interactions worth flagging.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "anti-aging-formula-with-nad",
      "title": "Anti-Aging Formula with NAD",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/antiaging_NAD.png?v=1777908101",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "anti",
        "aging",
        "formula",
        "with",
        "nad",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular",
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 45,
        "manufacturing": 42,
        "safety": 50,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 29.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173430907077",
      "vsf_explanation": "Kitchen-sink blend of NAD (oral NAD+ has near-zero bioavailability vs. NR/NMN precursors — Trammell 2016), retinol, hyaluronic acid, collagen, biotin, rhodiola, ginseng, etc. Too many actives at unstated doses to plausibly work.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "dr-mission-sea-moss-gel",
      "title": "Dr. Mission Sea Moss Gel",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SeaMossDr.MissionFalg1.png?v=1777908101",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mission",
        "sea",
        "moss",
        "gel",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 35,
        "manufacturing": 32,
        "safety": 40,
        "transparency": 25,
        "sustainability": 42
      },
      "price": 45.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173431005381",
      "vsf_explanation": "Sea moss + moringa + ginseng + horny goat weed + soursop leaf gel. False claim that sea moss contains '90% of essential minerals'; actual mineral content is modest and variable, with iodine risk. Multi-herb blend hides individual doses.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "organic-eye-health-support-tonic-bilberry-eyebright-lutein-zeaxanthin-vision-macular-blue-light-defense",
      "title": "Organic Eye Health Support Tonic – Bilberry, Eyebright, Lutein & Zeaxanthin | Vision, Macular & Blue Light Defense",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Organic_Eye_Health_Support_Tonic_Bilberry_Eyebright_Lutein_Zeaxanthin_Vision_Macular_Blue_Light_Defense.jpg?v=1777908101",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "eye",
        "health",
        "support",
        "tonic",
        "bilberry",
        "eyebright",
        "lutein",
        "zeaxanthin",
        "vision",
        "macular",
        "blue",
        "light",
        "defense",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants",
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 30,
        "sustainability": 55
      },
      "price": 29.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173430972613",
      "vsf_explanation": "Lutein 10mg + zeaxanthin 2mg is the AREDS2 (2013) evidence-based macular pair; bilberry has smaller support (Kalt 2014). But this liquid tonic doesn't disclose mg amounts, so AREDS2 thresholds can't be met.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "organic-herbal-prostate-formula",
      "title": "Organic Herbal  Prostate Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/organic-herbal-prostate-formula-by_Livingston.webp?v=1777908101",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "organic",
        "herbal",
        "prostate",
        "formula",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 48,
        "safety": 45,
        "transparency": 38,
        "sustainability": 55
      },
      "price": 29.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173431038149",
      "vsf_explanation": "17-herb liquid extract led by saw palmetto, pygeum and nettle. Saw palmetto BPH data are conflicting (STEP trial Bent 2006 was negative at 320 mg/d, Cochrane 2012 no benefit). Tincture format cannot standardize free fatty acid content. Prostate/hormone claims trigger disease-adjacent scrutiny.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "organic-herbal-diabetes-formula",
      "title": "Organic Herbal Diabetes Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/organic-herbal-diabetes-formula-102539.webp?v=1777908101",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "herbal",
        "diabetes",
        "formula",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 38,
        "manufacturing": 42,
        "safety": 30,
        "transparency": 28,
        "sustainability": 45
      },
      "price": 29.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173430939845",
      "vsf_explanation": "Product name uses 'Diabetes' — an explicit disease-treatment claim disallowed by FDA for supplements. 19-herb liquid extract cannot be dose-standardized; ingredients like Gymnema (Kumar 2010, 400 mg/d), cinnamon (Allen 2013) have marginal HbA1c effects that require standardized extracts, not tincture blends.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "organic-moringa-liquid-extract-full-spectrum-superfood-formula",
      "title": "Organic Moringa Liquid Extract – Full Spectrum Superfood Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Organic_Moringa_Liquid_Extract_Full_Spectrum_Superfood_Formula.png?v=1777908102",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "moringa",
        "liquid",
        "extract",
        "full",
        "spectrum",
        "superfood",
        "formula",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 42,
        "manufacturing": 45,
        "safety": 35,
        "transparency": 32,
        "sustainability": 55
      },
      "price": 28,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173431136453",
      "vsf_explanation": "Moringa oleifera has phase-II glycemic and lipid data (Waterman 2015, 2015 Anthanont) but requires standardized leaf powder ~2 g/d — tincture cannot deliver. Explicit 'blood sugar regulation, cholesterol balance, anti-inflammatory' constitute disease claims. 'Miracle Tree' framing is marketing hyperbole.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "organic-liver-and-gallbladder-cleanse",
      "title": "Organic Liver And Gallbladder Cleanse",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/organic-liver-and-gallbladder-cleanse-498303.png?v=1777908101",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "liver",
        "and",
        "gallbladder",
        "cleanse",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 30,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 29.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173431103685",
      "vsf_explanation": "16-herb 'cleanse' blend (milk thistle, artichoke, dandelion, turmeric, burdock, chanca piedra, fenugreek, ginger, cinnamon, hibiscus, garlic, neem, chamomile, raspberry leaf, stevia, ACV) with no dose disclosure. 'Liver cleanse' is a marketing concept unsupported by mechanistic evidence — the liver detoxifies on its own.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "brain-nutrition",
      "title": "Brain Nutrition",
      "vendor": "Dr. Robert Love’s Supplements",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/bn-1bottle-500x500.jpg?v=1777908141",
      "score": 31,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "brain",
        "nutrition",
        "robert",
        "love",
        "supplements"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 25,
        "manufacturing": 40,
        "safety": 40,
        "transparency": 20,
        "sustainability": 30
      },
      "price": 59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173431300293",
      "vsf_explanation": "Celebrity-doctor branded formula with no disclosed ingredients or doses on listing. 'Improves memory + reduces hunger + collagen' is scattershot marketing. No GMP or third-party testing info provided.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "zen-lions-mane-60-day-jar",
      "title": "Zen Lion's Mane (60 Day Jar)",
      "vendor": "Dr. Robert Love’s Supplements",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Zen_1_Bottle.jpg?v=1777908141",
      "score": 40,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zen",
        "lion",
        "mane",
        "day",
        "jar",
        "robert",
        "love",
        "supplements"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 30,
        "sustainability": 50
      },
      "price": 89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173431398597",
      "vsf_explanation": "10-mushroom blend (lion's mane, reishi, chaga, cordyceps, turkey tail, maitake + ashwagandha, others) with no per-mushroom dose or fruiting-body vs. mycelium disclosure — the key quality signal for functional mushrooms. Lion's mane cognitive claim rests on Mori 2009 (small n=30, 1000 mg fruiting body); this product doesn't disclose comparable dose.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "dr-loves-creatine-600g",
      "title": "Dr Love's Creatine 600g",
      "vendor": "Dr. Robert Love’s Supplements",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CreatineNewBottle.png?v=1777908143",
      "score": 73,
      "tier": "verified",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "love",
        "creatine",
        "600g",
        "robert",
        "love",
        "supplements"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 82,
        "formulation": 72,
        "manufacturing": 65,
        "safety": 78,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173431595205",
      "vsf_explanation": "Pure creatine monohydrate at 5g/scoop — the same well-studied ingredient/dose used in hundreds of RCTs (Kreider 2017). Explicitly GMP-certified and third-party tested, with brand provenance (Dr. Robert Love, PhD) and clear positioning for over-50 cognitive/muscle use (Prokopidis 2022 meta for memory). Sits just below Momentous (~76) because Creapure® sourcing is not stated.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "neuro-plus",
      "title": "Neuro Plus",
      "vendor": "Dr. Robert Love’s Supplements",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/np-1bottle-500x500.jpg?v=1777908141",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "neuro",
        "plus",
        "robert",
        "love",
        "supplements"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 25,
        "manufacturing": 40,
        "safety": 35,
        "transparency": 20,
        "sustainability": 30
      },
      "price": 59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173431496901",
      "vsf_explanation": "Claim 'Protects Against Dementia' is a disease claim no supplement can substantiate under DSHEA. Ingredients not disclosed. Sits below prop-blend anchor.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "dr-loves-nmn-1000mg",
      "title": "Dr Love's NMN - 1000mg",
      "vendor": "Dr. Robert Love’s Supplements",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/nmn-1bottle-500x500.jpg?v=1777908147",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "love",
        "nmn",
        "1000mg",
        "robert",
        "love",
        "supplements"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 45,
        "manufacturing": 48,
        "safety": 35,
        "transparency": 38,
        "sustainability": 42
      },
      "price": 119,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173431726277",
      "vsf_explanation": "1000 mg NMN is a legitimate dose (Yoshino 2021 250 mg; Igarashi 2022 250-500 mg raised blood NMN and grip strength). But the storefront copy states 'Helps prevent Alzheimer's in 9 different ways' — a clear disease-prevention claim without RCT support. Also NMN has been the subject of FDA NDI action (2022).",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "roar-lions-mane",
      "title": "ROAR Lion's Mane",
      "vendor": "Dr. Robert Love’s Supplements",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/rlm-1bottle-500x500.jpg?v=1777908147",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "roar",
        "lion",
        "mane",
        "robert",
        "love",
        "supplements"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 50,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173431824581",
      "vsf_explanation": "Lion's mane (Hericium erinaceus) has small pilot RCTs on mild cognitive impairment (Mori 2009) but marketing 'grows new brain cells / improves sleep' is overreach. No fruiting-body vs mycelium disclosure, no beta-glucan spec, no dose. Sits just under Standard.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "menstrual-zen-con-glicinato-de-magnesio-alivio-natural-para-sintomas-menstruales-y-perimenopausia",
      "title": "Menstrual Zen con Glicinato de Magnesio - Alivio Natural Para Síntomas Menstruales y PeriMenopausia",
      "vendor": "Tu Salud Intima",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/menstrual-zen-747635.jpg?v=1777908232",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "postmenopausal",
      "tokens": [
        "menstrual",
        "zen",
        "con",
        "glicinato",
        "magnesio",
        "alivio",
        "natural",
        "para",
        "ntomas",
        "menstruales",
        "perimenopausia",
        "salud",
        "intima"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 48,
        "sustainability": 50
      },
      "price": 37.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173433462981",
      "vsf_explanation": "Coherent PMS/perimenopause formula: Mg-glycinate + B1/B6/D + cramp bark + black haw + chasteberry (Vitex). Vitex has PMS RCT data (Schellenberg 2001, 20 mg/d, symptom score -50%); B6 for PMS (Wyatt 1999 meta, 50-100 mg/d). Per-cap doses not disclosed on storefront; Spanish-language market is well-served.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "happy-pee-suplemento-nutricional-para-la-salud-urinaria-femenina",
      "title": "Happy Pee - Suplemento Nutricional para la Salud Urinaria Femenina",
      "vendor": "Tu Salud Intima",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/happy-pee-106009.jpg?v=1777908232",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "happy",
        "pee",
        "suplemento",
        "nutricional",
        "para",
        "salud",
        "urinaria",
        "femenina",
        "salud",
        "intima"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 56.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173433528517",
      "vsf_explanation": "D-mannose + cranberry PAC (recurrent UTI prophylaxis) is the standard non-antibiotic protocol. Kranjcec 2014 D-mannose 2 g/d rUTI prophylaxis was as effective as nitrofurantoin; Jepson 2012 Cochrane cranberry PACs 36 mg/d modestly effective. D-mannose grams and cranberry PAC mg not disclosed. Marketing claims (incontinence, cellulite reduction) overreach beyond UTI prevention.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "libizenzs-women-energizante",
      "title": "LibiZenzs Women Energizante",
      "vendor": "Tu Salud Intima",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/libizenzs-women-energizante-115891.jpg?v=1777908236",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "libizenzs",
        "women",
        "energizante",
        "salud",
        "intima"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 25,
        "manufacturing": 35,
        "safety": 35,
        "transparency": 25,
        "sustainability": 30
      },
      "price": 57.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173433594053",
      "vsf_explanation": "Claims to raise natural testosterone via unspecified 'natural products.' No ingredient identities, no doses. Spanish-language DTC listing with no GMP disclosure.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "libizenzs-men-energizante",
      "title": "LibiZenzs Men Energizante",
      "vendor": "Tu Salud Intima",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/libizenzs-men-energizante-652723.jpg?v=1777908237",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "libizenzs",
        "men",
        "energizante",
        "salud",
        "intima"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 25,
        "manufacturing": 35,
        "safety": 35,
        "transparency": 25,
        "sustainability": 30
      },
      "price": 61.01,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173433659589",
      "vsf_explanation": "'Plants, amino acids, oligo-elements' with no specifics, no doses. Body-fat and libido claims without any RCT anchor. Same vendor lacking provenance.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "bye-bye-menopause",
      "title": "Bye Bye Menopause",
      "vendor": "Tu Salud Intima",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/bye-bye-menopause-348213.jpg?v=1777908237",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "postmenopausal",
      "tokens": [
        "bye",
        "bye",
        "menopause",
        "salud",
        "intima"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 25,
        "manufacturing": 35,
        "safety": 35,
        "transparency": 25,
        "sustainability": 30
      },
      "price": 47.08,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173433725125",
      "vsf_explanation": "'ELIMINATES the annoying symptoms of menopause' and 'strengthens your bones' are unverified disease-adjacent claims. No ingredients or doses disclosed.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "creatine-with-electrolytes-powder-unflavored",
      "title": "Creatine with Electrolytes Powder (Unflavored)",
      "vendor": "Key Nutrients",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Creatine_Main_Image_v1.webp?v=1777908284",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "creatine",
        "with",
        "electrolytes",
        "powder",
        "unflavored",
        "key",
        "nutrients"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 80,
        "formulation": 60,
        "manufacturing": 50,
        "safety": 65,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173436313797",
      "vsf_explanation": "Creatine monohydrate at 3-5 g/day is one of the most evidence-backed sports supplements (Kreider 2017 ISSN position stand). Adding electrolytes is a modest, defensible add-on for training hydration. Blank body means no COA, no Creapure disclosure, and no per-scoop electrolyte doses — keeps it Standard rather than Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pre-workout-powder-with-electrolytes",
      "title": "Pre-Workout Powder with Electrolytes",
      "vendor": "Key Nutrients",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/PreWorkoutwithElectrolytes.webp?v=1777908284",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pre",
        "workout",
        "powder",
        "with",
        "electrolytes",
        "key",
        "nutrients"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 50,
        "sustainability": 48
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173436346565",
      "vsf_explanation": "150 mg caffeine (from tea, moderate dose per Grgic 2020 ISSN caffeine position 3-6 mg/kg optimal), plus beta-alanine and citrulline malate. Effective doses require 3.2 g BA (Trexler 2015 ISSN) and 6-8 g CM (Perez-Guisado 2010) — per-scoop mg not disclosed. Electrolyte panel unspecified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "electrolyte-hydration-pills-capsule-form",
      "title": "Electrolyte Hydration Pills (capsule form)",
      "vendor": "Key Nutrients",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ERP-Hydration-Pills_Front_001_1000x1000_aee28517-c8d8-43d6-98e3-fd65469709a2.jpg?v=1777908284",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "electrolyte",
        "hydration",
        "pills",
        "capsule",
        "form",
        "key",
        "nutrients"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 45,
        "sustainability": 48
      },
      "price": 17.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173436379333",
      "vsf_explanation": "Capsule electrolyte replenishment with six minerals + zinc + B6 for keto and endurance contexts. Sodium/potassium ratios and elemental mineral mg not disclosed on storefront — key variable given the wide range of clinical needs (Cheuvront 2014, IOM 1500 mg/d Na baseline). Capsule format sidesteps flavor/sugar issues of drink mixes.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "matcha-powder-with-electrolytes",
      "title": "Matcha Powder with Electrolytes",
      "vendor": "Key Nutrients",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/matcha_electrolytes.webp?v=1777908284",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "matcha",
        "powder",
        "with",
        "electrolytes",
        "key",
        "nutrients"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 16.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173436412101",
      "vsf_explanation": "Matcha (EGCG-rich) with 5 electrolytes and ~25 mg caffeine has fair evidence for alertness/hydration (Mancini 2017 EGCG meta), but Key Nutrients does not disclose per-serving electrolyte mg totals or third-party COA. Formulation is a reasonable hydration/focus stack for the price, though sub-therapeutic caffeine for pre-workout and undisclosed catechin content limit efficacy. Placed in Standard tier alongside similar mass-market powdered blends.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "collagen-peptides-with-electrolytes-powder",
      "title": "Collagen Peptides with Electrolytes Powder",
      "vendor": "Key Nutrients",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NoPropsBackup.png?v=1777908284",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "collagen",
        "peptides",
        "with",
        "electrolytes",
        "powder",
        "key",
        "nutrients"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173436444869",
      "vsf_explanation": "10 g hydrolyzed collagen peptides + vitamin C hits the effective skin-elasticity dose from Proksch 2014 (2.5-10 g/day RCT). Pasture-raised claim is unverified and electrolyte mg not disclosed. No third-party purity or heavy-metal COA published, keeping this at Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-turmeric-powder-fermented-turmeric-oil-bundle-clean-support-for-vitality",
      "title": "Organic Turmeric Powder & Fermented Turmeric Oil Bundle – Clean Support for Vitality",
      "vendor": "America's Best Turmeric",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/combo_-_Tp_and_Oil.jpg?v=1777908370",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "turmeric",
        "powder",
        "fermented",
        "turmeric",
        "oil",
        "bundle",
        "clean",
        "support",
        "for",
        "vitality",
        "america",
        "best",
        "turmeric"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 70,
        "safety": 70,
        "transparency": 60,
        "sustainability": 70
      },
      "price": 34.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173436936389",
      "vsf_explanation": "USDA organic culinary turmeric powder + oil bundle from a small Georgia farm with published third-party lead/pesticide lab results. Curcuminoid % not specified so joint-comfort claims (Daily 2016 curcumin meta ~1 g/day) require the user to consume a heavy dose. Solid farm-to-jar transparency and manufacturing narrative keep it Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "product-bundle-georgia-gold-fermented-turmeric-powder-and-fermented-turmeric-oil",
      "title": "Product Bundle-Georgia Gold Fermented Turmeric Powder and Fermented Turmeric Oil",
      "vendor": "America's Best Turmeric",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/p-7XJJQd-5096047220_22e6ee9a-f509-4b6a-a3e0-a6bdb553b4f5.png?v=1777908371",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "product",
        "bundle",
        "georgia",
        "gold",
        "fermented",
        "turmeric",
        "powder",
        "and",
        "fermented",
        "turmeric",
        "oil",
        "america",
        "best",
        "turmeric"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 62,
        "safety": 62,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 59.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173436969157",
      "vsf_explanation": "Fermented turmeric powder + oil bundle, third-party tested lead-free, pesticide-free, non-GMO. Curcumin has anti-inflammatory evidence (Daily 2016 meta on osteoarthritis), but standardized curcumin percentage not specified for the base Georgia Gold powder. Fermentation may improve bioavailability but supporting RCTs are limited.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "curcumamax-fermented-turmeric-powder-feel-the-transformative-power-enhanced-with-additional-curcumin",
      "title": "CurcumaMAX Fermented Turmeric Powder Feel the Transformative Power Enhanced with Additional Curcumin",
      "vendor": "America's Best Turmeric",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CurcumaMAX_powder_on_kitchen_counter_with_veggies.png?v=1777908370",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "curcumamax",
        "fermented",
        "turmeric",
        "powder",
        "feel",
        "the",
        "transformative",
        "power",
        "enhanced",
        "with",
        "additional",
        "curcumin",
        "america",
        "best",
        "turmeric"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 62,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 65.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173437001925",
      "vsf_explanation": "Fermented turmeric powder standardized to 30% curcumin (~6x standard turmeric). Curcumin at 500-1500 mg/day shows anti-inflammatory benefit for osteoarthritis (Daily 2016 meta). Third-party tested lead-free/pesticide-free. Cancer-progression aside referenced in copy is speculative and not backed by human trials.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "georgia-gold-turmeric-powder",
      "title": "Georgia Gold Turmeric Powder",
      "vendor": "America's Best Turmeric",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/turmeric_powder_on_kitchen_counter.jpg?v=1777908370",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "georgia",
        "gold",
        "turmeric",
        "powder",
        "america",
        "best",
        "turmeric"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 70,
        "safety": 70,
        "transparency": 65,
        "sustainability": 70
      },
      "price": 24.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173437034693",
      "vsf_explanation": "Single-farm USDA-organic turmeric powder, third-party tested for purity and lead. Culinary form (no BioPerine, no curcuminoid standardization), so hitting the 1 g/day curcumin equivalent in Daily 2016 meta requires large scoops. Standard tier for a clean but undosed whole-food botanical.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fermented-lead-free-turmeric-powder-unlock-superior-bioavailability-and-joint-health",
      "title": "Fermented Lead-Free Turmeric Powder – Unlock Superior Bioavailability and Joint Health",
      "vendor": "America's Best Turmeric",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/google_bag_with_cup_of_golden_latte_and_cinnamon_sticks_2.jpg?v=1777908370",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fermented",
        "lead",
        "free",
        "turmeric",
        "powder",
        "unlock",
        "superior",
        "bioavailability",
        "and",
        "joint",
        "health",
        "america",
        "best",
        "turmeric"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 62,
        "safety": 62,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173437067461",
      "vsf_explanation": "Base fermented turmeric powder. Third-party tested lead-free/pesticide-free (notable given turmeric adulteration risk documented by Forsyth 2019). Curcumin content not standardized on label. Curcumin has anti-inflammatory RCT support (Daily 2016).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "product-bundle-curcumamax-fermented-turmeric-oil-curcumamax-fermented-turmeric-powder",
      "title": "Product Bundle - CurcumaMAX Fermented Turmeric Oil & CurcumaMAX Fermented Turmeric Powder",
      "vendor": "America's Best Turmeric",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Curcumax_oil_and_powder_together_with_std_template_35fc974c-b262-464b-bb17-63cee4cb547b.png?v=1777908371",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "product",
        "bundle",
        "curcumamax",
        "fermented",
        "turmeric",
        "oil",
        "curcumamax",
        "fermented",
        "turmeric",
        "powder",
        "america",
        "best",
        "turmeric"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 62,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 115.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173437100229",
      "vsf_explanation": "Bundle of CurcumaMAX powder (30% curcumin) + turmeric oil (turmerones). Curcumin RCT evidence solid for inflammation (Daily 2016). Turmerones from turmeric oil have preclinical anti-inflammatory data but limited human trials. Third-party tested. Fermented processing claim increases price without matching clinical proof.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fermented-turmeric-oil-concentrated-turmeric-goodness",
      "title": "Fermented Turmeric Oil - Concentrated Turmeric Goodness",
      "vendor": "America's Best Turmeric",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/google_-_in_kitchen_with_windowin_background.jpg?v=1777908370",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fermented",
        "turmeric",
        "oil",
        "concentrated",
        "turmeric",
        "goodness",
        "america",
        "best",
        "turmeric"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 70,
        "safety": 70,
        "transparency": 60,
        "sustainability": 70
      },
      "price": 24.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173437132997",
      "vsf_explanation": "Fermented turmeric in almond-oil carrier gives a plausible lipid-vehicle absorption benefit (Antony 2008 curcumin-oil PK). 10-15 drops delivers unspecified curcuminoid mg. Certified lead-free and pesticide-free via third-party. Standard tier because the effective curcumin dose per drop is not disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ginger-root-powder",
      "title": "Ginger Root Powder",
      "vendor": "America's Best Turmeric",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Ginger_Powder_with_bg_2b7992b4-8876-4769-ac77-784870e9bc6f.png?v=1777908371",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ginger",
        "root",
        "powder",
        "america",
        "best",
        "turmeric"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 70,
        "safety": 70,
        "transparency": 60,
        "sustainability": 70
      },
      "price": 24.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173437165765",
      "vsf_explanation": "Organic culinary ginger powder, 1 tbsp/day, third-party lead- and heavy-metal-tested. Ginger has RCT evidence for nausea and mild joint pain (Bartels 2015 ginger extract meta), but no gingerol standardization is stated. Clean sourcing places this at Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "curcumamax-fermented-turmeric-capsules-boost-your-vitality-with-6x-curcumin-120-capsules",
      "title": "CurcumaMAX Fermented Turmeric Capsules - Boost Your Vitality with 6X Curcumin - 120 capsules",
      "vendor": "America's Best Turmeric",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/google_generate_capsules_on_kitchen_counter.png?v=1777908371",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "curcumamax",
        "fermented",
        "turmeric",
        "capsules",
        "boost",
        "your",
        "vitality",
        "with",
        "curcumin",
        "120",
        "capsules",
        "america",
        "best",
        "turmeric"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 65,
        "manufacturing": 70,
        "safety": 70,
        "transparency": 60,
        "sustainability": 70
      },
      "price": 69.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173437198533",
      "vsf_explanation": "Fermented turmeric capsules claiming '6X curcumin' bioavailability with two-capsule daily dose. Fermentation can plausibly raise absorption, but exact curcuminoid mg is not published and no head-to-head PK data is cited. Third-party purity testing and small-farm sourcing lift it to upper Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fermented-probiotic-turmeric-puree",
      "title": "fermented Probiotic Turmeric Puree'",
      "vendor": "America's Best Turmeric",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/GAGoldPuree3-DNoBG.png?v=1777908372",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune",
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fermented",
        "probiotic",
        "turmeric",
        "puree",
        "america",
        "best",
        "turmeric"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 60,
        "sustainability": 65
      },
      "price": 64.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173437231301",
      "vsf_explanation": "~1000 mg curcumin per serving with disclosed dose, third-party lead-free certification, pesticide-free/non-GMO documentation, and vertically-integrated Georgia sourcing. Whole-food fermented format lacks the bioavailability data of Meriva or BCM-95 branded curcumin (Antony 2008), but disclosure and provenance are unusually strong for a small brand.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "curcumamax-50ml-fermented-turmeric-oil-your-enhanced-whole-plant-ally",
      "title": "CurcumaMax 50ml Fermented Turmeric Oil – Your Enhanced Whole-Plant Ally",
      "vendor": "America's Best Turmeric",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/google_oil_by_window.jpg?v=1777908371",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "curcumamax",
        "50ml",
        "fermented",
        "turmeric",
        "oil",
        "your",
        "enhanced",
        "whole",
        "plant",
        "ally",
        "america",
        "best",
        "turmeric"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 59.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173437264069",
      "vsf_explanation": "Fermented turmeric oil (60-70% turmerones). Turmerones have preclinical anti-inflammatory data but human RCT support is thin compared to curcuminoid extracts. Marketed for both ingestible and topical use, which muddles the clinical framing. Third-party tested American-grown turmeric.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sister-solution-fermented-turmeric-and-fermented-barberry-powder-capsules",
      "title": "Sister Solution Fermented Turmeric and Fermented Barberry Powder Capsules",
      "vendor": "America's Best Turmeric",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Sister_solution_with_pinkbg_7e9b9fe7-cd19-4165-a66e-72b06b490e33.png?v=1777908371",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sister",
        "solution",
        "fermented",
        "turmeric",
        "and",
        "fermented",
        "barberry",
        "powder",
        "capsules",
        "america",
        "best",
        "turmeric"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 30,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 20,
        "sustainability": 45
      },
      "price": 44.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173437329605",
      "vsf_explanation": "Marketing copy touts fermented turmeric and barberry but discloses no dose per capsule, no curcumin standardization, and no third-party test data. Fermentation may improve bioavailability but without mg disclosure the product fails the transparency threshold. Turmeric evidence (Chandran & Goel 2012 RCT, 500mg BID curcumin) can't be honored without dose visibility.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "ginger-powder-naturally-grown-and-lab-tested",
      "title": "Ginger Powder - Naturally Grown and Lab Tested",
      "vendor": "America's Best Turmeric",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/gingerpowderinkitchen.jpg?v=1777908370",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ginger",
        "powder",
        "naturally",
        "grown",
        "and",
        "lab",
        "tested",
        "america",
        "best",
        "turmeric"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 52,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 26.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173437362373",
      "vsf_explanation": "Organic ginger root powder. Ginger 1-1.5 g/day has RCT-supported anti-nausea benefit (Marx 2013 meta) and modest anti-inflammatory effect. Simple single-ingredient product, third-party tested for purity. Structure/function positioning is appropriate.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pain-therapy-fermented-turmeric-with-essential-oils",
      "title": "Pain Therapy Fermented Turmeric with Essential Oils",
      "vendor": "America's Best Turmeric",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3-d_of_bottle_by_itself_with_BG_d0cbf44d-cbdd-419e-8b3a-fd02a2058bb1.png?v=1777908371",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pain",
        "therapy",
        "fermented",
        "turmeric",
        "with",
        "essential",
        "oils",
        "america",
        "best",
        "turmeric"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 45,
        "manufacturing": 65,
        "safety": 40,
        "transparency": 40,
        "sustainability": 60
      },
      "price": 39.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173437296837",
      "vsf_explanation": "Marketed for people who 'suffer with joint pain and/or other illnesses' and promises to 'radically transform' skin - crosses into unverified disease-treatment territory. Ingredients list is 'turmeric root and essential oils' with no essential-oil identities or doses disclosed. Auto-fail caps at 45.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "fermented-turmeric-powder-capsules-ease-joint-pain-and-increase-immune-vitality-with-enhanced-bioavailability-120-capsules",
      "title": "Fermented Turmeric Powder Capsules - Ease Joint Pain and Increase Immune Vitality with Enhanced Bioavailability - 120 Capsules",
      "vendor": "America's Best Turmeric",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Fermented_Turmeric_Capsules_079dfb52-20bc-4276-82ca-a1fe3f20d26f.png?v=1777908376",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fermented",
        "turmeric",
        "powder",
        "capsules",
        "ease",
        "joint",
        "pain",
        "and",
        "increase",
        "immune",
        "vitality",
        "with",
        "enhanced",
        "bioavailability",
        "120",
        "capsules",
        "america",
        "best",
        "turmeric"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 70,
        "safety": 65,
        "transparency": 55,
        "sustainability": 70
      },
      "price": 39.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173437427909",
      "vsf_explanation": "Organic fermented turmeric capsules, two per day. Curcuminoid % per capsule not disclosed but organic sourcing and third-party purity tests are documented. Sits at Standard; would move to Verified if per-capsule curcumin mg and bioavailability data were published.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "achieve-peak-joint-health-and-immunity-with-bioavailable-fermented-turmeric-curcumamax-oil-and-capsules-bundle",
      "title": "Achieve Peak Joint Health and Immunity with Bioavailable Fermented Turmeric – CurcumaMAX Oil and Capsules Bundle",
      "vendor": "America's Best Turmeric",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Curcumax_oil_and_capsules_together_with_std._template_b4f75a18-46b7-46c8-8556-c5819cc43125.png?v=1777908376",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "achieve",
        "peak",
        "joint",
        "health",
        "and",
        "immunity",
        "with",
        "bioavailable",
        "fermented",
        "turmeric",
        "curcumamax",
        "oil",
        "and",
        "capsules",
        "bundle",
        "america",
        "best",
        "turmeric"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 70,
        "safety": 68,
        "transparency": 60,
        "sustainability": 70
      },
      "price": 119.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173437395141",
      "vsf_explanation": "Bundle of the CurcumaMAX capsules + fermented oil; combined delivery gives a plausible synergy for absorption but total curcuminoid mg still undisclosed. Third-party lead-free testing and USDA-organic inputs. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "womens-health-tincture-pms-peri-post-menopausal-hormone-support",
      "title": "Women's Health Tincture: PMS/Peri-Post Menopausal Hormone Support",
      "vendor": "Pioneer Pam",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Screenshot_2025-06-08_at_2.19.03_PM.png?v=1777908552",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "female",
      "life_stage": "postmenopausal",
      "tokens": [
        "women",
        "health",
        "tincture",
        "pms",
        "peri",
        "post",
        "menopausal",
        "hormone",
        "support",
        "pioneer",
        "pam"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 35,
        "manufacturing": 35,
        "safety": 40,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 19.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173441163461",
      "vsf_explanation": "Small-batch tincture of dong quai, wild yam, licorice, passionflower, uva ursi, and valerian with dose given only as 'dropper fulls' — no mg per ingredient. Licorice at chronic doses carries a real hypertension risk that goes unmentioned. Herbal menopause evidence is thin (Taylor 2015 review), and there is no GMP or third-party test signal.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "lions-mane-tincture-mood-memory-stress-support-brain-health",
      "title": "Lions Mane Tincture: Mood, Memory, Stress Support, Brain Health",
      "vendor": "Pioneer Pam",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Screenshot_2025-06-08_at_8.09.29_AM.png?v=1777908552",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lions",
        "mane",
        "tincture",
        "mood",
        "memory",
        "stress",
        "support",
        "brain",
        "health",
        "pioneer",
        "pam"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 40,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 30,
        "sustainability": 50
      },
      "price": 24.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173441097925",
      "vsf_explanation": "Lion's mane tincture in a vegetable glycerin/alcohol base. The product page claims research 'suggests Lion's Mane can help with' ADHD, low immune function, and anxiety in children — direct pediatric disease claims. Mori 2009 showed mild cognitive scores improvement in older adults at 3g powder, not tincture doses.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "his-tincture-testosterone-support",
      "title": "HIS Tincture: Testosterone Support",
      "vendor": "Pioneer Pam",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Screenshot_2025-06-08_at_2.25.05_PM.png?v=1777908552",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "his",
        "tincture",
        "testosterone",
        "support",
        "pioneer",
        "pam"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 35,
        "sustainability": 50
      },
      "price": 19.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173441130693",
      "vsf_explanation": "Horny goat weed (Epimedium/icariin) tincture. In-vitro icariin shows PDE5 inhibition (Dell'Agli 2008), but human RCTs on libido and testosterone are minimal to negative. Tincture with no dropper mg icariin content disclosed.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "mullein-tincture-respiratory-immune-system-support",
      "title": "Mullein Tincture: Respiratory + Immune System Support",
      "vendor": "Pioneer Pam",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Screenshot_2025-06-08_at_2.19.32_PM.png?v=1777908552",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mullein",
        "tincture",
        "respiratory",
        "immune",
        "system",
        "support",
        "pioneer",
        "pam"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 19.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173441196229",
      "vsf_explanation": "Product page names 'tuberculosis, whooping cough, pneumonia, bronchitis, tonsillitis, asthma' as traditional uses — cluster of disease-treatment claims. Mullein has some traditional expectorant use but no modern RCT support for these conditions.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "his-hers-hormone-support",
      "title": "HIS & HERS: Hormone Support",
      "vendor": "Pioneer Pam",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Screenshot_2025-06-08_at_3.16.35_PM.png?v=1777908552",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "his",
        "hers",
        "hormone",
        "support",
        "pioneer",
        "pam"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 30,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 38.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173441228997",
      "vsf_explanation": "Topical wild-yam tallow rub with explicit claims to 'treat premenstrual syndrome' and 'help with hormone production and imbalance.' Diosgenin from wild yam is not converted to progesterone in vivo (Komesaroff 2001), so the mechanism is unsupported. Small-batch handcrafted product with 6-8 month shelf life and no GMP or COA.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "oil-of-oregano-immune-and-gut-health-support",
      "title": "Oil of Oregano: Immune and Gut Health Support",
      "vendor": "Pioneer Pam",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Screenshot_2025-06-08_at_2.22.20_PM.png?v=1777908553",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "oil",
        "oregano",
        "immune",
        "and",
        "gut",
        "health",
        "support",
        "pioneer",
        "pam"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 35,
        "manufacturing": 30,
        "safety": 30,
        "transparency": 30,
        "sustainability": 50
      },
      "price": 10.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173441261765",
      "vsf_explanation": "Small-vendor oregano oil tincture in a 1 oz bottle at 3-5 drops daily. Claims anti-cancer activity and treats ear infections, acne, eczema, psoriasis, athletes foot. Carvacrol has in vitro antimicrobial data (Sharifi-Rad 2018 review) but no human RCTs support the medical claims listed.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "sleepy-time-tincture-sleep-relaxation-support-for-kids-adults",
      "title": "Sleepy Time Tincture: Sleep/Relaxation Support for Kids & Adults",
      "vendor": "Pioneer Pam",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Screenshot_2025-06-08_at_2.11.46_PM.png?v=1777908552",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "youth_under_18",
      "tokens": [
        "sleepy",
        "time",
        "tincture",
        "sleep",
        "relaxation",
        "support",
        "for",
        "kids",
        "adults",
        "pioneer",
        "pam"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 14.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173441294533",
      "vsf_explanation": "Chamomile + valerian + passion flower + lemon balm + catnip + oat straw glycerite tincture, marketed for kids and adults. Valerian has modest sleep RCT support at 300-900 mg extract (Bent 2006). Six-herb tincture with dropper dosing typically delivers a fraction of studied doses; also markets pediatric use for herbs without infant-safety data.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "yarrow-tincture",
      "title": "Yarrow Tincture",
      "vendor": "Pioneer Pam",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Screenshot_2025-06-08_at_2.22.46_PM.png?v=1777908552",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "yarrow",
        "tincture",
        "pioneer",
        "pam"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 40,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 14.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173441327301",
      "vsf_explanation": "Yarrow (Achillea millefolium) tincture, 2-3 drops sublingually. Traditional bitter/digestive tonic; minimal human RCT data. Correctly flags pregnancy contraindication (uterine stimulant). Dropper micro-doses.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "hers-tallow-progesterone-support",
      "title": "HERS Tallow: Progesterone Support",
      "vendor": "Pioneer Pam",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Screenshot_2025-06-08_at_2.28.02_PM.png?v=1777908553",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hers",
        "tallow",
        "progesterone",
        "support",
        "pioneer",
        "pam"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 30,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 40,
        "sustainability": 55
      },
      "price": 21.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173441360069",
      "vsf_explanation": "Wild-yam beef-tallow rub labeled 'Progesterone Support.' Diosgenin from wild yam is not converted to progesterone in the human body (Komesaroff 2001 RCT: no change in DHEA or progesterone). Marketing frames it as treatment for PMS, menopause, and sexual function.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "mullein-tallow-skin-salve-chest-rub",
      "title": "Mullein Tallow: Skin Salve + Chest Rub",
      "vendor": "Pioneer Pam",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Screenshot_2025-06-08_at_2.28.45_PM.png?v=1777908553",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mullein",
        "tallow",
        "skin",
        "salve",
        "chest",
        "rub",
        "pioneer",
        "pam"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 30,
        "manufacturing": 30,
        "safety": 45,
        "transparency": 40,
        "sustainability": 55
      },
      "price": 20.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173441392837",
      "vsf_explanation": "Topical tallow chest rub, not a supplement per se. Product copy lists 'tuberculosis, whooping cough, bronchitis, pneumonia' among traditional uses — direct disease-treatment framing. No clinical evidence for mullein-infused tallow in respiratory infection.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "usnea-tincture-natures-antibiotic",
      "title": "Usnea Tincture: Nature's Antibiotic",
      "vendor": "Pioneer Pam",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Screenshot_2025-06-08_at_2.18.31_PM.png?v=1777908553",
      "score": 28,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "usnea",
        "tincture",
        "nature",
        "antibiotic",
        "pioneer",
        "pam"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 30,
        "manufacturing": 30,
        "safety": 25,
        "transparency": 30,
        "sustainability": 50
      },
      "price": 15.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173441458373",
      "vsf_explanation": "Usnea tincture branded as 'Nature's Antibiotic' with anticancer, antibiotic, antiviral, and 12+ other claims. Usnic acid has documented hepatotoxicity (Guo 2008 NIH report on liver failure cases). No human RCTs support the medical claims; safety concerns are non-trivial.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "soursop-tincture-antioxidant-anti-inflammatory-support",
      "title": "Soursop Tincture: Antioxidant + Anti-Inflammatory Support",
      "vendor": "Pioneer Pam",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Screenshot_2025-06-08_at_2.21.59_PM.png?v=1777908552",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "inflammation"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "soursop",
        "tincture",
        "antioxidant",
        "anti",
        "inflammatory",
        "support",
        "pioneer",
        "pam"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 30,
        "manufacturing": 30,
        "safety": 20,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 22.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173441425605",
      "vsf_explanation": "Copy makes explicit anti-cancer claims for breast, cervical, prostate, and melanoma citing in-vitro PMIDs, triggering unverified-disease-claim auto-fail. Soursop (Annona muricata) also carries neurotoxicity signals from annonacins (Caparros-Lefebvre 2005) that go unmentioned. No dosing or safety guidance for a compound with real risks.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "diy-elderberry-syrup-kit",
      "title": "DIY Elderberry Syrup Kit",
      "vendor": "Pioneer Pam",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Screenshot_2025-06-08_at_3.12.16_PM.png?v=1777908552",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "diy",
        "elderberry",
        "syrup",
        "kit",
        "pioneer",
        "pam"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 17.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173441491141",
      "vsf_explanation": "DIY dried elderberry + spices kit — user prepares the syrup at home. Tiralongo 2016 RCT showed elderberry reduced cold duration in air travelers, but that used a standardized commercial extract, not home-prepared syrup. Home preparation introduces raw-elderberry cyanogenic-glycoside safety variability if under-cooked.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "elderberry-tincture-immune-system-support",
      "title": "Elderberry Tincture: Immune System Support",
      "vendor": "Pioneer Pam",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Screenshot_2025-06-08_at_2.10.08_PM.png?v=1777908553",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "elderberry",
        "tincture",
        "immune",
        "system",
        "support",
        "pioneer",
        "pam"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 21.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173441523909",
      "vsf_explanation": "Elderberry (Sambucus nigra) has RCT support for shortening cold/flu duration (Tiralongo 2016, Hawkins 2019 meta-analysis). This is a glycerin/alcohol tincture — dose per dropper is not disclosed and standardization to anthocyanin content (which drives efficacy) is not shown. Cleaner than the DIY kit but still short of Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "five-mushroom-dual-extract",
      "title": "Five Mushroom Dual Extract",
      "vendor": "Half Hill Farm",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5MUSH-M.jpg?v=1777908633",
      "score": 61,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "five",
        "mushroom",
        "dual",
        "extract",
        "half",
        "hill",
        "farm"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 68,
        "safety": 65,
        "transparency": 50,
        "sustainability": 68
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173442113733",
      "vsf_explanation": "Turkey Tail, Reishi, Chaga, Lion's Mane, Cordyceps liquid dual extract (hot-water + organic-alcohol) from mature fruit bodies, produced in an FDA-registered, GMP-compliant Tennessee facility. Certified organic and US-grown scores well on manufacturing and sustainability. Loses points because beta-glucan % and per-mushroom mg are not disclosed. Fruit-body-only dual extraction aligns with evidence for polysaccharide bioactivity (Torkelson 2012 turkey tail PSK trial).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cordyceps-mushroom-dual-extract",
      "title": "Cordyceps Mushroom Dual Extract",
      "vendor": "Half Hill Farm",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CORDYCEPS-M.jpg?v=1777908632",
      "score": 61,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cordyceps",
        "mushroom",
        "dual",
        "extract",
        "half",
        "hill",
        "farm"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 68,
        "safety": 65,
        "transparency": 50,
        "sustainability": 68
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173442048197",
      "vsf_explanation": "Certified organic Cordyceps militaris fruiting bodies processed via hot-water decoction plus organic alcohol tincture in a GMP-compliant US facility. 2 tsp/serving liquid form supports absorption. Chen 2010 RCT showed cordyceps supported VO2max in older adults but doses in mg are not disclosed here, and cordycepin/adenosine standardization is missing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "turkey-tail-mushroom-dual-extract",
      "title": "Turkey Tail Mushroom Dual Extract",
      "vendor": "Half Hill Farm",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/TUYKEYTAIL-M.jpg?v=1777908638",
      "score": 61,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "turkey",
        "tail",
        "mushroom",
        "dual",
        "extract",
        "half",
        "hill",
        "farm"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 58,
        "manufacturing": 68,
        "safety": 65,
        "transparency": 50,
        "sustainability": 68
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173442179269",
      "vsf_explanation": "Wildcrafted Coriolus versicolor (Trametes versicolor) fruit-body dual extract, GMP-compliant US facility. Turkey Tail PSK/PSP has the strongest evidence among medicinal mushrooms (Torkelson 2012 breast cancer immune RCT), though beta-glucan % is not disclosed. Sensible sourcing and processing anchor a mid-Standard score.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "red-reishi-mushroom-dual-extract",
      "title": "Red Reishi Mushroom Dual Extract",
      "vendor": "Half Hill Farm",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/REISHI-M.jpg?v=1777908638",
      "score": 61,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "reishi",
        "mushroom",
        "dual",
        "extract",
        "half",
        "hill",
        "farm"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 68,
        "safety": 65,
        "transparency": 50,
        "sustainability": 68
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173442244805",
      "vsf_explanation": "Certified organic Ganoderma lucidum fruit-body dual extract in a GMP-compliant US facility. Chu 2011 (Cancer 117:20) showed 1.44 g/day reishi extract improved fatigue in cancer patients; no mg disclosure here but 2-tsp liquid serving is reasonable. Mid-Standard sits alongside Ancient Nutrition baseline (~55).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chaga-mushroom-dual-extract",
      "title": "Chaga Mushroom Dual Extract",
      "vendor": "Half Hill Farm",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CHAGA-M.jpg?v=1777908637",
      "score": 56,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chaga",
        "mushroom",
        "dual",
        "extract",
        "half",
        "hill",
        "farm"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 68,
        "safety": 60,
        "transparency": 50,
        "sustainability": 65
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173442310341",
      "vsf_explanation": "Responsibly wildcrafted Inonotus obliquus dual extract, GMP-compliant US-made. Human RCT evidence for chaga remains thin; most data are preclinical or oxidative-marker studies. Safety flag: chaga's oxalate load can burden kidneys with chronic high doses (Kikuchi 2014 case report), which caps this at mid-Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lions-mane-mushroom-dual-extract",
      "title": "Lion's Mane Mushroom Dual Extract",
      "vendor": "Half Hill Farm",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/LIONSMANE-M.jpg?v=1777908638",
      "score": 62,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lion",
        "mane",
        "mushroom",
        "dual",
        "extract",
        "half",
        "hill",
        "farm"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 68,
        "safety": 65,
        "transparency": 50,
        "sustainability": 68
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173442375877",
      "vsf_explanation": "Certified organic Hericium erinaceus fruit-body dual extract, GMP-compliant. Mori 2009 (Phytother Res) RCT with 3g/day powdered lion's mane improved MMSE in elderly with mild cognitive impairment. mg equivalence per 2-tsp serving is not disclosed, capping this at high-Standard rather than Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "the-curse-pre-workout-30-serve",
      "title": "The Curse! Pre-Workout 30 Serve",
      "vendor": "JNX Sports",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/JNXSportsTheCurse_Pre-workoutCherryLimeade30ServeBottleFront.png?v=1777908697",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "the",
        "curse",
        "pre",
        "workout",
        "serve",
        "jnx",
        "sports"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 25,
        "manufacturing": 50,
        "safety": 35,
        "transparency": 20,
        "sustainability": 40
      },
      "price": 19.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173444767941",
      "vsf_explanation": "Uses three named proprietary matrices ('Energizing Muscle Fuel Blend', 'Amplifier Blend', 'Mind Control Matrix') so individual mg for caffeine, beta-alanine, and stimulants are hidden. Cannot verify sub-therapeutic vs overshoot risk. Auto-fail caps at 45.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "the-curse-beta-alanine",
      "title": "The Curse! Beta Alanine",
      "vendor": "JNX Sports",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0388JNXSports-TheCurse_BetaAlanine-Front.png?v=1777908702",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "the",
        "curse",
        "beta",
        "alanine",
        "jnx",
        "sports"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 55,
        "sustainability": 40
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173445292229",
      "vsf_explanation": "3 g per scoop of pure beta-alanine hits the ergogenic threshold from Trexler 2015 ISSN position stand (3.2-6.4 g/day for muscle carnosine loading). Single-ingredient dose disclosed, but no third-party purity certificate. Brand's other prop-blend products drag transparency. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "the-omen-fat-burner",
      "title": "The Omen! Fat Burner",
      "vendor": "JNX Sports",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/JNXSportsTheOmen_60Capsules-Front.png?v=1777908703",
      "score": 48,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "the",
        "omen",
        "fat",
        "burner",
        "jnx",
        "sports"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health",
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 48,
        "manufacturing": 55,
        "safety": 48,
        "transparency": 50,
        "sustainability": 40
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173445456069",
      "vsf_explanation": "270 mg caffeine anhydrous plus green coffee bean and acetyl-L-carnitine — the caffeine dose is at the upper limit of safety guidance (FDA notes 400 mg/day upper limit for adults). Green coffee bean weight-loss meta-analyses (Onakpoya Gastroenterol Res Pract 2011) were undermined by author retractions. Individual ingredient doses beyond caffeine not disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "the-curse-creatine-monohydrate",
      "title": "The Curse! Creatine Monohydrate",
      "vendor": "JNX Sports",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0486_JNX_Sports_-_The_Curse_Creatine_300g_-_Unflavoured_-_Render_-_Front.png?v=1777908702",
      "score": 68,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "the",
        "curse",
        "creatine",
        "monohydrate",
        "jnx",
        "sports"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 68,
        "manufacturing": 60,
        "safety": 75,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 20.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173445324997",
      "vsf_explanation": "Pure micronized creatine monohydrate at documented 5g loading/maintenance dosing — creatine mono is the most-studied ergogenic supplement (Kreider 2017 ISSN position; hundreds of RCTs). GMP compliant, single-ingredient transparency is excellent. Lacks Creapure branding or third-party purity COA that would push it to Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "the-curse-ultra-premium-whey-2lb",
      "title": "The Curse! Ultra Premium Whey - 2lb",
      "vendor": "JNX Sports",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/JNXSportsTheCurse_WheyProteinDoubleChocolate2LBBottleFront.png?v=1777908702",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "the",
        "curse",
        "ultra",
        "premium",
        "whey",
        "2lb",
        "jnx",
        "sports"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173445521605",
      "vsf_explanation": "25 g protein per serving with WPI primary source and 5.5 g naturally-occurring BCAAs — hits the leucine threshold for muscle protein synthesis (Morton 2018). No added sugar, ultra-filtered. Missing third-party heavy-metal/protein-content COA (Clean Label Project or Informed Sport) prevents Verified tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "the-curse-pre-workout",
      "title": "The Curse! Pre-Workout",
      "vendor": "JNX Sports",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/JNX_Sports_The_Curse_Pre-workout_Blue_Raspberry_50_Serve_Bottle_Front_9ca480ca-8ec6-43e3-8af4-5ba8cac0310f.png?v=1777908703",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "the",
        "curse",
        "pre",
        "workout",
        "jnx",
        "sports"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 25,
        "manufacturing": 50,
        "safety": 35,
        "transparency": 20,
        "sustainability": 40
      },
      "price": 28.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173445619909",
      "vsf_explanation": "Identical prop-blend construction to the 30-serve variant: 'Energizing Muscle Fuel Blend, Amplifier Blend, Mind Control Matrix' obscure caffeine and beta-alanine mg. Cannot evaluate efficacy or stimulant safety. Auto-fail caps at 45.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "the-curse-micronized-glutamine",
      "title": "The Curse! Micronized Glutamine",
      "vendor": "JNX Sports",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0388JNXSports-TheCurse_Glutamine-Front.png?v=1777908702",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "the",
        "curse",
        "micronized",
        "glutamine",
        "jnx",
        "sports"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173445587141",
      "vsf_explanation": "Single-ingredient micronized L-glutamine, but per-scoop dose is not stated in the description. Glutamine's RCT evidence for recovery in trained athletes is modest (Legault 2015). Placed at Standard on the assumption of a standard 5 g scoop and generic bulk-ingredient QC.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lions-mane-dual-extract-tincture",
      "title": "Lion's Mane Dual Extract Tincture",
      "vendor": "Hodgins Harvest",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/AMZ_Tincture_Main_Image_Color_LM_4_OZ.jpg?v=1777908775",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lion",
        "mane",
        "dual",
        "extract",
        "tincture",
        "hodgins",
        "harvest"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 75,
        "manufacturing": 80,
        "safety": 75,
        "transparency": 75,
        "sustainability": 80
      },
      "price": 24,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173446570181",
      "vsf_explanation": "Certified-organic, single-farm New York Hericium erinaceus, 100% fruiting bodies (no grain/starch dilution) - a rare quality signal. Dual water/alcohol extract captures beta-glucans and hericenones (Mori 2009 mild cognitive impairment RCT). Suggested 2-4 mL/day; extract:starting-material ratio not published, holding it at low-Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lions-mane-cordyceps-dual-extract-tincture",
      "title": "Lion's Mane + Cordyceps Dual Extract Tincture",
      "vendor": "Hodgins Harvest",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/TinctureB-Org.02_LM_Cordyceps_4oz_R02_01_copy.jpg?v=1777908775",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "cognitive",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lion",
        "mane",
        "cordyceps",
        "dual",
        "extract",
        "tincture",
        "hodgins",
        "harvest"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 72,
        "manufacturing": 80,
        "safety": 75,
        "transparency": 72,
        "sustainability": 80
      },
      "price": 34,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173446635717",
      "vsf_explanation": "50/50 blend of Lion's Mane (cognitive - Mori 2009) and Cordyceps militaris (endurance - Hirsch 2017 VO2 max RCT). 100% fruiting body sourcing and dual extraction remain strong; splitting the dose halves each single-species mg, so effective load per organism is lower than a solo tincture.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cordyceps-dual-extract-tincture",
      "title": "Cordyceps Dual Extract Tincture",
      "vendor": "Hodgins Harvest",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/AMZ_Tincture_Main_Image_Color_CM_4_OZ.jpg?v=1777908780",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cordyceps",
        "dual",
        "extract",
        "tincture",
        "hodgins",
        "harvest"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 72,
        "manufacturing": 80,
        "safety": 75,
        "transparency": 72,
        "sustainability": 80
      },
      "price": 24,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173446701253",
      "vsf_explanation": "Fruiting-body Cordyceps militaris grown in-house; dual extract supports both water-soluble cordycepin and beta-glucans. Hirsch 2017 showed VO2 max gains from 4 g/day mushroom blend after 3 weeks. Extract ratio in mg/mL not disclosed - the main gap holding it at low-Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lions-mane-reishi-dual-extract-tincture",
      "title": "Lion's Mane + Reishi Dual Extract Tincture",
      "vendor": "Hodgins Harvest",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/mushrooms-ingredients-5-revised_4d278cad-7ccc-4463-a49e-ec969d4bd134.jpg?v=1777908780",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lion",
        "mane",
        "reishi",
        "dual",
        "extract",
        "tincture",
        "hodgins",
        "harvest"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 72,
        "manufacturing": 80,
        "safety": 75,
        "transparency": 72,
        "sustainability": 80
      },
      "price": 34,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173446668485",
      "vsf_explanation": "Lion's Mane + Reishi (Ganoderma lucidum) 50/50 blend from certified-organic New York farm, fruiting bodies only. Reishi has small-RCT evidence for sleep quality and fatigue (Tang 2005 breast-cancer RCT). Blend dilutes single-species mg; extract ratio undisclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lions-mane-turkey-tail-dual-extract-tincture",
      "title": "Lion's Mane + Turkey Tail Dual Extract Tincture",
      "vendor": "Hodgins Harvest",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/mushrooms-ingredients-7-revised.jpg?v=1777908780",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lion",
        "mane",
        "turkey",
        "tail",
        "dual",
        "extract",
        "tincture",
        "hodgins",
        "harvest"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 72,
        "manufacturing": 80,
        "safety": 75,
        "transparency": 72,
        "sustainability": 80
      },
      "price": 34,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173446799557",
      "vsf_explanation": "50/50 Lion's Mane + Turkey Tail (Trametes versicolor) tincture. Turkey Tail PSK has Phase II adjuvant oncology data (Torkelson 2012 breast-cancer immune RCT). US-grown fruiting bodies and dual extraction earn Verified; per-mL beta-glucan mg not disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "reishi-turkey-tail-dual-extract-tincture",
      "title": "Reishi + Turkey Tail Dual Extract Tincture",
      "vendor": "Hodgins Harvest",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/TinctureB-Org.02_Reishi_TurkeyTail_4oz_R03_01.png?v=1777908780",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "reishi",
        "turkey",
        "tail",
        "dual",
        "extract",
        "tincture",
        "hodgins",
        "harvest"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 72,
        "manufacturing": 80,
        "safety": 75,
        "transparency": 72,
        "sustainability": 80
      },
      "price": 34,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173446766789",
      "vsf_explanation": "Reishi + Turkey Tail 50/50 blend targets immune modulation - both have supportive human data (Torkelson 2012, Tang 2005). Same fruiting-body, dual-extract, single-farm quality profile as the rest of the Hodgins line. Missing extract-ratio detail keeps it at low-Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "reishi-dual-extract-tincture",
      "title": "Reishi Dual Extract Tincture",
      "vendor": "Hodgins Harvest",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/AMZ_Tincture_Main_Image_Color_RE_4_OZ.jpg?v=1777908780",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "reishi",
        "dual",
        "extract",
        "tincture",
        "hodgins",
        "harvest"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 72,
        "manufacturing": 80,
        "safety": 75,
        "transparency": 72,
        "sustainability": 80
      },
      "price": 24,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173446832325",
      "vsf_explanation": "Single-species Ganoderma lucidum dual extract, 100% fruiting body, US-farmed. Tang 2005 breast-cancer patient RCT showed fatigue/QoL benefit at 1.8 g/day extract. Per-mL beta-glucan not published; still one of the cleaner reishi tinctures on the market.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "turkey-tail-dual-extract-tincture",
      "title": "Turkey Tail Dual Extract Tincture",
      "vendor": "Hodgins Harvest",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/AMZ_Tincture_Main_Image_Color_TT_4_OZ.jpg?v=1777908780",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "turkey",
        "tail",
        "dual",
        "extract",
        "tincture",
        "hodgins",
        "harvest"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 72,
        "manufacturing": 80,
        "safety": 75,
        "transparency": 72,
        "sustainability": 80
      },
      "price": 24,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173446897861",
      "vsf_explanation": "Trametes versicolor dual extract from certified-organic single farm. Turkey Tail's PSK/PSP fractions have Japan/China oncology support (Torkelson 2012). Fruiting-body only, no grain/mycelium filler. Extract:starting-material ratio still not shown.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bucked-up-rut-booster",
      "title": "Bucked Up Rut Booster",
      "vendor": "Comito Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/rut.png?v=1777908862",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bucked",
        "rut",
        "booster",
        "comito",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 20,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 15,
        "sustainability": 25
      },
      "price": 38.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173449224389",
      "vsf_explanation": "Product page names zero ingredients or doses — just 'blend of vitamins' with an implied testosterone/vitality benefit. No RCT can be cited for a formula that isn't disclosed, and men's-health vitality claims without an ingredient panel are the paradigm case of the prop-blend problem.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "bucked-up-buck-naked",
      "title": "Bucked Up Buck Naked",
      "vendor": "Comito Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/naked.png?v=1777908862",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bucked",
        "buck",
        "naked",
        "comito",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 20,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 15,
        "sustainability": 25
      },
      "price": 42.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173449257157",
      "vsf_explanation": "'Packed with patented ingredients' but names none, discloses zero doses, and asserts fat-burning-during-exercise benefits that no shipped-and-labeled RCT could match to this SKU. Same prop-blend pattern as Rut Booster from the same seller.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "bucked-up-deer-antler-velvet-spray-natural-growth-recovery-performance-support",
      "title": "Bucked Up Deer Antler Velvet Spray – Natural Growth, Recovery & Performance Support",
      "vendor": "Comito Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Screenshot2025-08-21at10.24.41PM.png?v=1777908863",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bucked",
        "deer",
        "antler",
        "velvet",
        "spray",
        "natural",
        "growth",
        "recovery",
        "performance",
        "support",
        "comito",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 30,
        "manufacturing": 40,
        "safety": 40,
        "transparency": 35,
        "sustainability": 35
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173449289925",
      "vsf_explanation": "Deer antler velvet spray marketed for IGF-1 delivery, muscle growth and hormone balance — IGF-1 is a WADA/MLB-banned peptide and oral/sublingual bioavailability is essentially zero (Sawka 1989 review). Claims of muscle growth and hormone balance are unverified disease-adjacent claims with no supporting RCT.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "alani-nu-balance-capsules-120-capsules-30-servings",
      "title": "Alani Nu Balance Capsules - 120 Capsules (30 Servings)",
      "vendor": "Comito Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b1_26b86d79-5048-4b0e-b3cd-8edb66d15f84.png?v=1777908867",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alani",
        "balance",
        "capsules",
        "120",
        "capsules",
        "servings",
        "comito",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 48.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173449322693",
      "vsf_explanation": "Alani Nu Balance stacks myo-inositol, L-glutathione, DIM, ALA, and chromium — a targeted PCOS/hormonal-balance formulation. Myo-inositol at 2-4 g/day has RCT support for PCOS ovulation (Unfer 2017 meta). This 120 caps/30 servings suggests 4 caps/day, which can hit a reasonable myo-inositol dose. Brand has retail visibility but no NSF/Informed-Sport certification listed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gutrx-collagen-mt-1",
      "title": "GutRx Collagen MT-1",
      "vendor": "GutRx",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CollagenMT-1_0.png?v=1777908936",
      "score": 59,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gutrx",
        "collagen",
        "gutrx"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 46.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173449453765",
      "vsf_explanation": "Single-ingredient hydrolyzed Type I marine collagen — clean label, no fillers/sweeteners, wild-caught marine source, non-GMO, GMP + third-party tested. Marine collagen RCTs on skin (Evans 2020, De Miranda 2021) are positive but smaller than the branded-peptide evidence base. Honest simple formulation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gutrx-bloat-gas",
      "title": "GutRx Bloat + Gas",
      "vendor": "GutRx",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Bloat_Gas_0.png?v=1777908936",
      "score": 55,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gutrx",
        "bloat",
        "gas",
        "gutrx"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 50,
        "safety": 68,
        "transparency": 50,
        "sustainability": 40
      },
      "price": 23.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173449552069",
      "vsf_explanation": "Digestive-enzyme + botanical + probiotic stack — 150 GALU alpha-galactosidase targets FODMAP gas (same active as Beano, Ganiats et al. 1994), plus lipase/protease/amylase and calming botanicals. Reasonable targeted formulation, GMP + 3rd-party tested per claim. Total enzyme dose per capsule not fully shown.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gutrx-teens-12-17",
      "title": "GutRx TEENS (12-17)",
      "vendor": "GutRx",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Teens_0.png?v=1777908936",
      "score": 55,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gutrx",
        "teens",
        "gutrx"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173449486533",
      "vsf_explanation": "10 billion CFU probiotic + gentle prebiotic in delayed-release capsules positioned for ages 12-17. Adolescent-specific probiotic RCTs are limited relative to adult and infant data — strain identity and dose-per-strain would need to be verified against clinical evidence to score higher. GMP + third-party tested is a plus.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gutrx-mag-evening",
      "title": "GutRx MAG+ Evening",
      "vendor": "GutRx",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MagEvening_0.png?v=1777908936",
      "score": 63,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gutrx",
        "mag",
        "evening",
        "gutrx"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 30.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173449519301",
      "vsf_explanation": "Dual bioavailable magnesium forms — L-threonate (70mg elemental) for CNS penetration (Slutsky 2010 for cognition/synaptic density) plus bisglycinate for muscle relaxation. Combining two well-absorbed forms is the right formulation move for evening cognitive-plus-muscle wind-down. GMP + third-party tested; honest label with disclosed elemental amounts.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gutrx-hangover",
      "title": "GutRx HANGOVER",
      "vendor": "GutRx",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Hangover_0.png?v=1777908936",
      "score": 50,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gutrx",
        "hangover",
        "gutrx"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive",
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 31.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173449584837",
      "vsf_explanation": "Alcohol-recovery blend targeting glutathione depletion, acetaldehyde clearance and electrolyte balance. Ingredient breakdown truncated in listing but claimed non-GMO, GMP-certified, third-party tested. Category has thin RCT support overall; NAC + DHM stack has some evidence for acetaldehyde clearance but individual doses not shown in listing preview.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gutrx-overgrowth",
      "title": "GutRx OVERGROWTH",
      "vendor": "GutRx",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/B0FBHRVZ21_1_f6f6a01f-0ab3-4117-8b0d-33306ed11a14.png?v=1777908941",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gutrx",
        "overgrowth",
        "gutrx"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 40,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 44.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173449617605",
      "vsf_explanation": "Explicitly markets 'oil of oregano and ginger extract' as treatment for SIBO ('Small Intestinal Bacterial Overgrowth') and to help 'when you're dealing with a sickness, like the flu or cold.' That is unverified disease/condition treatment framing. Doses not disclosed. Auto-fail caps at 45.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "gutrx-fiber",
      "title": "GutRx FIBER+",
      "vendor": "GutRx",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Fiber2.jpg?v=1777908942",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gutrx",
        "fiber",
        "gutrx"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173449650373",
      "vsf_explanation": "PHGG + acacia + psyllium plus L-glutamine and zinc carnosine. PHGG has IBS symptom-relief RCTs (Polymeros 2014) and psyllium is Grade A for constipation. Per-gram doses aren't detailed in the copy but the ingredient stack is well-chosen. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gutrx-mealtime",
      "title": "GutRx MEALTIME",
      "vendor": "GutRx",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/B0FBH7QQRS_1_8ce07e60-4d73-40c5-96df-d06ba4ea3cd3.png?v=1777908941",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gutrx",
        "mealtime",
        "gutrx"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173449683141",
      "vsf_explanation": "Digestive-enzyme blend targeting protein/fat/fiber/dairy/FODMAP, 1-3 caps pre-meal. Digestive enzymes have modest RCT support for functional GI symptoms (Ianiro 2016). Individual enzyme activity units (USP FCC) and per-capsule mg are not published - the standard-tier ceiling for enzyme products.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gutrx-daily",
      "title": "GutRx DAILY",
      "vendor": "GutRx",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/B0FBJ8H15G_1_59a3cae4-a84f-4f50-8177-666840373954.png?v=1777908942",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gutrx",
        "daily",
        "gutrx"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 28.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173449781445",
      "vsf_explanation": "Enteric-coated daily synbiotic (probiotic + prebiotic). Enteric coating is a real bioavailability win versus generic caps, but strain identities, CFU counts, and prebiotic fiber mg are not disclosed on-listing. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gutrx-balance",
      "title": "GutRx BALANCE",
      "vendor": "GutRx",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/B0F41WHSHT_1.png?v=1777908942",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gutrx",
        "balance",
        "gutrx"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 50,
        "manufacturing": 50,
        "safety": 40,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173449715909",
      "vsf_explanation": "Copy explicitly says the product 'reduces the symptoms of acid reflux, IBS-D, GERD, SIBO' - that is disease/condition treatment framing without RCT or FDA support and outside DSHEA structure/function scope. Strains and CFUs also undisclosed. Auto-fail caps at 45.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "gutrx-complete",
      "title": "GutRx COMPLETE",
      "vendor": "GutRx",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/B0FBHH6MRG_1_5946f8fa-9d6a-48d2-ba06-09a75cf0ebec.png?v=1777908941",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gutrx",
        "complete",
        "gutrx"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 75.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173449748677",
      "vsf_explanation": "'21-in-1' pre/pro/postbiotic blend, 3 caps/day. Multi-strain probiotics have general microbiome data (McFarland 2014 meta), but no strain identities, no CFU disclosure, and no third-party stability testing shown. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gutrx-calm",
      "title": "GutRx Calm+",
      "vendor": "GutRx",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Calm__0.png?v=1777908942",
      "score": 52,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gutrx",
        "calm",
        "gutrx"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173449814213",
      "vsf_explanation": "Multi-ingredient gut-brain formula with minerals, calming aminos, botanicals, and probiotics — no per-ingredient doses disclosed. Enteric-coated capsules and third-party testing claim help, but weak evidence for combined effect and opaque dosing keep it Standard. Individual gut-brain probiotic RCTs (Messaoudi 2011) support some ingredients but not this exact blend.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gutrx-womens",
      "title": "GutRx WOMEN'S",
      "vendor": "GutRx",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/B0FBHKSCHJ_1_2087e805-bd4c-4d4c-958b-b585f7e3389b.png?v=1777908942",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "gutrx",
        "women",
        "gutrx"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 42.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173449846981",
      "vsf_explanation": "Eight-strain probiotic targeting vaginal pH and urogenital comfort; L. rhamnosus/reuteri strains have small RCT support for BV/UTI recurrence (Reid 2003). Strain IDs and CFU are not disclosed. Menstrual-cramp claim is soft-boundary but acceptable. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ginkgo-biloba-ancient-wisdom",
      "title": "Ginkgo Biloba - Ancient Wisdom",
      "vendor": "My Balance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ginkgo1small.png?v=1777909046",
      "score": 54,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ginkgo",
        "biloba",
        "ancient",
        "wisdom",
        "balance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics",
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 20.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173453189317",
      "vsf_explanation": "720 mg ginkgo biloba + 800 mg red Asian ginger per capsule — doses disclosed but ginkgo not standardized to the 24/6 flavone/lactone spec used in EGb 761 trials (Weinmann BMC Geriatr 2010 showed cognitive benefit only for standardized extract). Non-GMO, vegan, GMP-certified US facility.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-moringa-oleifera-ancient-discovery",
      "title": "Organic Moringa Oleifera - Ancient Discovery",
      "vendor": "My Balance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MOR1_2.png?v=1777909046",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "moringa",
        "oleifera",
        "ancient",
        "discovery",
        "balance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 18.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173453254853",
      "vsf_explanation": "Single-ingredient organic moringa leaf capsules; moringa has small human trials for glycemic control (Anthanont 2016) but per-capsule mg is not stated. Generic manufacturing, no third-party COA linked. Bottom-of-Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "blood-sugar-control",
      "title": "Blood Sugar Control",
      "vendor": "My Balance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/bloodsugar1small.png?v=1777909047",
      "score": 45,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "blood",
        "sugar",
        "control",
        "balance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 40,
        "sustainability": 35
      },
      "price": 23.04,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173453222085",
      "vsf_explanation": "Vitamin C/E + biotin + chromium AAC + banaba + manganese blend. Chromium picolinate for glucose has been repeatedly null in high-quality RCTs (Kleefstra et al. 2007 diabetes meta-analysis). 'Blood sugar' language edges toward diabetes claim territory. Per-ingredient doses not disclosed in excerpt.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "berberine-an-ayurveric-approach-to-health",
      "title": "Berberine - An Ayurveric Approach to Health",
      "vendor": "My Balance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/berberine1small.png?v=1777909050",
      "score": 51,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "berberine",
        "ayurveric",
        "approach",
        "health",
        "balance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 31.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173453320389",
      "vsf_explanation": "Single-ingredient berberine from botanical sources with GMP-facility claim. Yin 2008 (Metabolism 57:5) 500mg TID showed HbA1c reduction comparable to metformin. Product page shows no mg per capsule, no serving size, and no COA link, dropping formulation and transparency into low-Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bcaa-branched-chain-amino-acids-watermelon-flavor",
      "title": "BCAA - Branched Chain Amino Acids | Watermelon Flavor",
      "vendor": "My Balance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/bcaa1small_2.png?v=1777909054",
      "score": 51,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bcaa",
        "branched",
        "chain",
        "amino",
        "acids",
        "watermelon",
        "flavor",
        "balance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 45.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173453418693",
      "vsf_explanation": "Leucine/isoleucine/valine powder with implied 2:1:1 ratio. Wolfe 2017 (JISSN) concluded free-form BCAAs are largely redundant when total protein intake is adequate. No dose disclosed on the listing (typical 5-7g leucine target). GMP and third-party testing claimed; transparency remains the weak dimension.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "collagen-peptides-types-i-ii-iii-v-x",
      "title": "Collagen Peptides Types I, II, III, V, X",
      "vendor": "My Balance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/collagen1small.png?v=1777909054",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "collagen",
        "peptides",
        "types",
        "iii",
        "balance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 26.22,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173453353157",
      "vsf_explanation": "Multi-type collagen (bovine, marine, chicken, eggshell) claiming grass-fed and wild-caught sourcing. Type I/III supports skin (Proksch 2014), Type II undenatured has small joint RCTs (Lugo 2016). Total g per serving and hydrolyzation MW not listed. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnesium-complex",
      "title": "Magnesium Complex",
      "vendor": "My Balance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CopyMagnesium1cx.png?v=1777909051",
      "score": 58,
      "tier": "standard",
      "certifications": [
        "GMP Certified",
        "Gluten-Free Certified"
      ],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "complex",
        "balance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 26.22,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173453385925",
      "vsf_explanation": "Five-form blend (citrate, glycinate, malate, Aquamin marine, oxide) in a GMP facility with third-party test claim. Boyle 2017 (Nutrients) meta-analysis supports magnesium supplementation for sleep and anxiety. Inclusion of oxide (~4% absorption) drags formulation vs. BIOptimizers (~62); no elemental mg per form disclosed. Sits just under BIOptimizers baseline.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "myo-d-chiro-inositol-ip6",
      "title": "Myo D-Chiro Inositol (IP6)",
      "vendor": "My Balance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/INOITOL1small.png?v=1777909051",
      "score": 61,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "myo",
        "chiro",
        "inositol",
        "ip6",
        "balance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health",
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 20.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173453451461",
      "vsf_explanation": "2000 mg myo-inositol + 50 mg D-chiro inositol per serving — the 40:1 physiological ratio validated in PCOS trials (Nordio Eur Rev Med Pharmacol Sci 2019, ovulation and insulin markers improved vs myo-only). Doses disclosed. GMP-certified US facility. Third-party testing claimed. Mislabelled as IP6 in the title (myo/DCI ≠ IP6/phytate).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "coenzyme-q-10",
      "title": "Coenzyme Q-10",
      "vendor": "My Balance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/COQ10-1.png?v=1777909052",
      "score": 53,
      "tier": "standard",
      "certifications": [
        "GMP Certified",
        "Gluten-Free Certified"
      ],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coenzyme",
        "balance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 34.12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173453484229",
      "vsf_explanation": "Ubiquinone-form CoQ10 in capsules, GMP-facility claim. Mortensen 2014 (JACC HF) Q-SYMBIO trial 100mg TID reduced cardiac events in heart failure. Product uses less-absorbable ubiquinone (not ubiquinol) and doesn't disclose mg per capsule; formulation and transparency hold this at low-Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-d3-k2-with-bioperine®",
      "title": "Vitamin D3 + K2 with BioPerine®",
      "vendor": "My Balance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d3k21small.png?v=1777909051",
      "score": 53,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "with",
        "bioperine",
        "balance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 18.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173453516997",
      "vsf_explanation": "D3 (lanolin), MK-7 K2 and BioPerine combo is a rational co-factor stack (Knapen 2015 MK-7; Shoba 1998 piperine bioavailability). Third-party tested and GMP-facility claims are stated, but per-nutrient doses are not disclosed in the listing, limiting verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liver-cleanse-rejuvenate-and-restore",
      "title": "Liver Cleanse - Rejuvenate and Restore",
      "vendor": "My Balance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/liver1small_4.png?v=1777909051",
      "score": 40,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liver",
        "cleanse",
        "rejuvenate",
        "and",
        "restore",
        "balance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 30,
        "manufacturing": 50,
        "safety": 45,
        "transparency": 20,
        "sustainability": 45
      },
      "price": 22.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173453549765",
      "vsf_explanation": "Listing explicitly names a 'Proprietary Botanical & Nutrient Blend' with ~15+ herbs (milk thistle, artichoke, beet, chanca piedra, celery, turmeric, ginger, alfalfa, burdock, choline, NAC, L-cysteine, grape seed, berberine) plus a separate herbal blend. No per-ingredient mg disclosed. Even the well-evidenced components (milk thistle silymarin Ferenci 1989) can't be honored without doses.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "colon-sweep-14-day-cleanse",
      "title": "Colon Sweep - 14 Day Cleanse",
      "vendor": "My Balance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/COLONS-1.png?v=1777909052",
      "score": 41,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "colon",
        "sweep",
        "day",
        "cleanse",
        "balance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 40,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 20.96,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173453648069",
      "vsf_explanation": "Multi-herb 'cleanse' with cascara sagrada and buckthorn (anthraquinone stimulant laxatives) plus psyllium, bentonite, and Lactobacillus acidophilus. FDA reclassified cascara as not GRAS for OTC laxative use in 2002; long-term/repeat use risks electrolyte disturbance and cathartic colon (Roerig 2010 Drugs). Detox framing is not supported by physiology (colon self-clears in healthy adults). Safety and evidence dimensions both fall below Standard threshold.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "my-balance-nutrisentials-organic-ashwagandha-an-ancient-treasure",
      "title": "My Balance Nutrisentials Organic Ashwagandha - An Ancient Treasure",
      "vendor": "My Balance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Ashwagandha-1.png?v=1777909052",
      "score": 51,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "balance",
        "nutrisentials",
        "organic",
        "ashwagandha",
        "ancient",
        "treasure",
        "balance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173453680837",
      "vsf_explanation": "Root-only organic ashwagandha with GMP + third-party test claims, but the listing does not disclose dose or extract standardization (withanolide %). Ashwagandha stress-cortisol effect is documented for KSM-66 300 mg BID (Chandrasekhar 2012) and Sensoril 125 mg (Auddy 2008) — unbranded extracts have inconsistent potency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "daily-greens-superfood-blend",
      "title": "Daily Greens - Superfood Blend",
      "vendor": "My Balance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/greens1ss.png?v=1777909051",
      "score": 47,
      "tier": "rejected",
      "certifications": [
        "GMP Certified",
        "Gluten-Free Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "daily",
        "greens",
        "superfood",
        "blend",
        "balance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 35,
        "sustainability": 50
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173453582533",
      "vsf_explanation": "Chlorella + spirulina + unspecified probiotic blend, one scoop per day. Greens powders show minimal nutrient contribution vs. a serving of vegetables (Vitalone 2010 J Nutr). No mg per ingredient, no CFU count, and no strain IDs disclosed. Transparency and formulation drop this below Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnesium-glycinate-1",
      "title": "Magnesium Glycinate",
      "vendor": "My Balance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CopyMagnesium1.png?v=1777909052",
      "score": 51,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "glycinate",
        "balance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 24.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173453615301",
      "vsf_explanation": "Magnesium bisglycinate is a well-tolerated, high-bioavailability chelated form (Walker 2003 vs. oxide); category is broadly evidence-supported for sleep and muscle relaxation. Listing lacks explicit elemental magnesium mg and glycine ratio, so buyer can't verify therapeutic exposure vs. anchor products like BIOptimizers.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "elderberry-natures-gift",
      "title": "Elderberry - Natures' Gift",
      "vendor": "My Balance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ELDERB1_1.png?v=1777909051",
      "score": 54,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "elderberry",
        "natures",
        "gift",
        "balance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 18.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173453746373",
      "vsf_explanation": "Sambucus nigra capsules for immune support. Zakay-Rones 2004 (J Int Med Res) syrup RCT reduced flu duration by ~4 days at 15mL QID; capsule bioequivalence is less clear. No anthocyanin standardization or mg per cap in the listing, holding this at low-Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "joint-support-glucosamine-sulfate-master-formula",
      "title": "Joint Support - Glucosamine Sulfate Master Formula",
      "vendor": "My Balance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/joint1small.png?v=1777909051",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "joint",
        "support",
        "glucosamine",
        "sulfate",
        "master",
        "formula",
        "balance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 21.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173453713605",
      "vsf_explanation": "Glucosamine sulfate at 1500 mg matches the therapeutic dose in Reginster 2001 (GAIT-comparator OA trial). Adds chondroitin, MSM, and boswellia — all with modest joint evidence (Bannuru 2018 network meta). Chondroitin/MSM/boswellia doses not disclosed, limiting formulation ceiling.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "argan-plus-topical-oil",
      "title": "Argan Plus - Topical Oil",
      "vendor": "My Balance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/argan-11.png?v=1777909053",
      "score": 53,
      "tier": "standard",
      "certifications": [
        "GMP Certified",
        "Gluten-Free Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "argan",
        "plus",
        "topical",
        "oil",
        "balance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 70,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173453811909",
      "vsf_explanation": "Topical hair oil combining virgin argan with jojoba, apricot kernel, avocado, sweet almond, pumpkin seed, hempseed, grapeseed oils and vitamin E. Topical argan for hair has thin RCT evidence (mostly emollient benefit). Safety scores high because it's non-ingested. Not a systemic supplement, so evidence dimension is capped.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "beetroot-vibrant-superfood",
      "title": "Beetroot - Vibrant Superfood",
      "vendor": "My Balance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/beet1.png?v=1777909053",
      "score": 47,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beetroot",
        "vibrant",
        "superfood",
        "balance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 65,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 19.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173453844677",
      "vsf_explanation": "Beetroot capsules — dietary nitrate has RCT support for BP reduction and exercise performance, but the studied doses come from concentrated juice (~5-6 mmol nitrate; Siervo et al. 2013). Capsule form typically delivers a fraction of this, and no nitrate content is disclosed here.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "omega-fish-oil-omega-3-fatty-acids",
      "title": "Omega Fish Oil - Omega-3 Fatty Acids",
      "vendor": "My Balance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/FO1.png?v=1777909055",
      "score": 47,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "omega",
        "fish",
        "oil",
        "omega",
        "fatty",
        "acids",
        "balance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 22.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173453877445",
      "vsf_explanation": "Listing does not disclose EPA/DHA content, source species, oxidation (TOTOX), triglyceride vs. ethyl-ester form or IFOS certification — the four things that matter for fish oil quality. Cannot verify therapeutic dose (VITAL Trial Manson 2019 used 1g EPA+DHA).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "emergency-immune-support",
      "title": "Emergency Immune Support",
      "vendor": "My Balance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/EmergencyImmune-1.png?v=1777909057",
      "score": 42,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "emergency",
        "immune",
        "support",
        "balance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 22.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173453910213",
      "vsf_explanation": "'10-in-1' immune blend (vitamin C, zinc, turmeric, elderberry, echinacea, probiotics, garlic and more) marketed as 'emergency' support with zero per-ingredient dose disclosure. Ingredients each have varying evidence, but the format hides therapeutic intent.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "clarity-bright-minds-multivitamin",
      "title": "Clarity - Bright Minds Multivitamin",
      "vendor": "My Balance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CLA1_4c96a775-966d-43ac-b12a-67e6695ca0d3.png?v=1777909057",
      "score": 27,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "clarity",
        "bright",
        "minds",
        "multivitamin",
        "balance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 25,
        "manufacturing": 25,
        "safety": 40,
        "transparency": 15,
        "sustainability": 30
      },
      "price": 21.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173453942981",
      "vsf_explanation": "Kitchen-sink single capsule stacks a multi with DMAE, Bacopa, phosphatidylserine, Huperzine A, green tea, grape seed, olive leaf — none with disclosed doses. Bacopa (Stough 2001) and PS (Kato-Kataoka 2010) show benefit only at ~300mg and 100-300mg respectively, which cannot coexist with a full multi in one capsule. Huperzine A stacked with undisclosed dosing is a real safety concern.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "l-arginine-clean-simple-formula",
      "title": "L-Arginine - Clean, Simple Formula",
      "vendor": "My Balance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/l.png?v=1777909060",
      "score": 50,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "arginine",
        "clean",
        "simple",
        "formula",
        "balance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 21.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173453975749",
      "vsf_explanation": "L-arginine as a nitric-oxide precursor has modest evidence for exercise performance and endothelial function (Bailey 2010) at doses of 6g+; L-citrulline actually outperforms in bioavailability (Schwedhelm 2008). Dose not disclosed in listing, limiting verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-maca-root-capsules",
      "title": "Organic MACA Root Capsules",
      "vendor": "My Balance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/maca-1s.png?v=1777909107",
      "score": 48,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "mood",
        "energy",
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "maca",
        "root",
        "capsules",
        "balance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 20.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173454205125",
      "vsf_explanation": "Triple maca (black/red/yellow) + BioPerine from Peruvian sources — reasonable format, but no dose disclosed and maca RCT evidence is small (Gonzales 2002 semen quality; Brooks 2008 menopausal symptoms). Without dose, therapeutic intent unclear.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "creatine-powder-fuel-your-performance",
      "title": "Creatine Powder - Fuel your Performance",
      "vendor": "My Balance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/creatine1small.png?v=1777909112",
      "score": 62,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "creatine",
        "powder",
        "fuel",
        "your",
        "performance",
        "balance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 70,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 44.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173454237893",
      "vsf_explanation": "Micronized creatine monohydrate unflavored — the most-evidenced ergogenic supplement (Kreider 2017 ISSN position). Adaptable loading/maintenance dosing supported. Missing Creapure branding or third-party purity COA limits ceiling to Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "digestive-enzymes-supporting-your-digestive-system",
      "title": "Digestive Enzymes - Supporting your Digestive System",
      "vendor": "My Balance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/digestiveEnzymes-1.png?v=1777909112",
      "score": 51,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "digestive",
        "enzymes",
        "supporting",
        "your",
        "digestive",
        "system",
        "balance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 52,
        "manufacturing": 48,
        "safety": 68,
        "transparency": 42,
        "sustainability": 38
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173454270661",
      "vsf_explanation": "Fungal protease (Aspergillus oryzae) + bromelain + probiotic strains for meal-time digestive support. General enzyme supplementation has modest evidence in functional dyspepsia (Majeed et al. 2018 for A. oryzae). Per-enzyme activity units and strain CFU not disclosed in excerpt.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nitric-oxide-booster-powder-mix-blue-raspberry-flavor",
      "title": "Nitric Oxide Booster Powder Mix – Blue Raspberry Flavor",
      "vendor": "My Balance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NObr1.png?v=1777909112",
      "score": 45,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nitric",
        "oxide",
        "booster",
        "powder",
        "mix",
        "blue",
        "raspberry",
        "flavor",
        "balance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 55.74,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173454303429",
      "vsf_explanation": "L-Arginine AKG + Beta Alanine + B-vitamins + minerals + explicit 'Energy/Endurance/Focus Matrix'. Beta alanine RCT threshold ~4-6g/day sustained (Trexler 2015 JISSN); at 4g total serving containing multiple actives, each ingredient is almost certainly sub-therapeutic. The 'Matrix' construct hides per-ingredient dosing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hair-skin-and-nails-your-beauty-starts-from-within",
      "title": "Hair, Skin, and Nails - Your beauty starts from within",
      "vendor": "My Balance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/hsnsmall1small.png?v=1777909112",
      "score": 45,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hair",
        "skin",
        "and",
        "nails",
        "your",
        "beauty",
        "starts",
        "from",
        "within",
        "balance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 24.12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173454368965",
      "vsf_explanation": "Kitchen-sink formula (biotin, A, C, E, zinc, magnesium, horsetail, nettle, D3, iron, spirulina, saw palmetto) with no doses disclosed. Biotin alone lacks hair-growth evidence in non-deficient adults (Patel 2017); adding iron and saw palmetto without dose/screening raises tolerability concerns.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "my-balance-nutrisentials-colon-cleanse",
      "title": "My Balance Nutrisentials – Colon Cleanse",
      "vendor": "My Balance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Copycolon1.png?v=1777909112",
      "score": 38,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "balance",
        "nutrisentials",
        "colon",
        "cleanse",
        "balance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 45,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 19.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173454500037",
      "vsf_explanation": "11-herb 'cleanse' (psyllium, aloe ferox, chlorella, acai, papaya, slippery elm, ginger, inulin, etc.) with no doses. Aloe ferox is a stimulant laxative with dependence concerns; 'colon cleanse' concept is unsupported by mechanistic evidence (Ernst 1997 review).",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "mushroom-blend-powder",
      "title": "Mushroom Blend Powder",
      "vendor": "My Balance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/mushpowder1ss.png?v=1777909112",
      "score": 48,
      "tier": "rejected",
      "certifications": [
        "GMP Certified",
        "USDA Organic"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mushroom",
        "blend",
        "powder",
        "balance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 48,
        "manufacturing": 45,
        "safety": 65,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 34.75,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173454467269",
      "vsf_explanation": "7 organic mushroom extracts (Reishi, Cordyceps, Turkey Tail, Shiitake, Lion's Mane, Chaga, Agaricus blazei) plus ashwagandha, ginseng, rhodiola. Broad blend at 132g total — no per-species dose, no beta-glucan quantification, no dual-extraction disclosure. Cannot verify therapeutic doses of any single mushroom.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nitric-oxide-booster-powder-mix-honeydew-watermelon-flavor",
      "title": "Nitric Oxide Booster Powder Mix – Honeydew/Watermelon Flavor",
      "vendor": "My Balance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NOhw1.png?v=1777909113",
      "score": 45,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nitric",
        "oxide",
        "booster",
        "powder",
        "mix",
        "honeydew",
        "watermelon",
        "flavor",
        "balance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 55.74,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173454336197",
      "vsf_explanation": "Same L-Arginine AKG + Beta Alanine + B-vitamin + mineral formula in a different flavor; 4g total per serving across multiple actives + an 'Energy/Endurance/Focus Matrix'. Beta alanine's exercise capacity RCT dose (~4-6g/day, Trexler 2015) can't be reached inside a 4g blended serving.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-pure-ceylon-cinnamon",
      "title": "Organic Pure Ceylon Cinnamon",
      "vendor": "My Balance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cinnamons1.png?v=1777909113",
      "score": 50,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "pure",
        "ceylon",
        "cinnamon",
        "balance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 22.57,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173454434501",
      "vsf_explanation": "1200 mg Ceylon (Cinnamomum verum) cinnamon per serving is a clearly disclosed dose in the range studied for glycemic control, though the meta-analysis by Costello 2016 shows only modest effects on fasting glucose. GMP-certified US manufacturing is claimed but no third-party COA or batch testing is disclosed. Reasonable single-ingredient formulation, entry-level Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "menopause-support-a-thoughtful-blend-of-ingredients",
      "title": "Menopause Support - A Thoughtful Blend of Ingredients",
      "vendor": "My Balance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/meno1small.png?v=1777909112",
      "score": 54,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "female",
      "life_stage": "postmenopausal",
      "tokens": [
        "menopause",
        "support",
        "thoughtful",
        "blend",
        "ingredients",
        "balance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 36.73,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173454401733",
      "vsf_explanation": "Vitamin D3/E/B6 + 40 billion CFU probiotic (MAKTREK bi-pass) + prebiotic + black cohosh + red clover + wild yam + dong quai + turmeric. Osmers 2005 (Obstet Gynecol) showed black cohosh 40mg/day reduced menopausal symptoms. CFU count is disclosed (positive), but individual botanical mg are not. Dong quai has anticoagulant interactions worth flagging.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "b-12-drops-bioactive-b12-methylcobalamin",
      "title": "B-12 Drops - Bioactive B12 Methylcobalamin",
      "vendor": "My Balance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CopyB12_11.249x14.249in_final3.png?v=1777909113",
      "score": 56,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "drops",
        "bioactive",
        "b12",
        "methylcobalamin",
        "balance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173454565573",
      "vsf_explanation": "Methylcobalamin is the active/coenzyme form of B12 with better retention than cyanocobalamin (Paul 2017). Adding B2, B3, B5, B6 covers most methylation cofactors. Sublingual/liquid format aids absorption in atrophic-gastritis populations. Doses not disclosed but 1 mL daily is standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hydration-electrolyte-drink-mix",
      "title": "Hydration Electrolyte Drink Mix",
      "vendor": "My Balance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/hydra1.png?v=1777909112",
      "score": 57,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hydration",
        "electrolyte",
        "drink",
        "mix",
        "balance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 45,
        "sustainability": 60
      },
      "price": 35.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173454532805",
      "vsf_explanation": "Complete electrolyte matrix (Na, K, Mg, Ca, Cl) plus Aquamin marine-mineral complex from Icelandic red algae, Himalayan salt, Vit C/B3/B6/B12/B5. Aquamin is a well-characterized, sustainably harvested source (Frestedt 2008). Individual mg per serving not disclosed in listing; formula concept is sound for daily hydration.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "facial-vitamin-c-serum-topical",
      "title": "Facial Vitamin C Serum (Topical)",
      "vendor": "My Balance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CopyC_11.249x14.249in_final3.png?v=1777909112",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "facial",
        "vitamin",
        "serum",
        "topical",
        "balance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 39.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173454598341",
      "vsf_explanation": "Topical vitamin C serum; L-ascorbic acid has strong evidence for photoprotection at 10-20% and pH<3.5 (Pinnell 2001), but this listing does not disclose C concentration, form (LAA vs derivative), or pH. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnesium-powder-magnesium-citrate-aquamin™",
      "title": "Magnesium Powder - Magnesium Citrate & Aquamin™",
      "vendor": "My Balance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/magpowders1.png?v=1777909113",
      "score": 61,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "powder",
        "magnesium",
        "citrate",
        "aquamin",
        "balance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 70,
        "transparency": 60,
        "sustainability": 65
      },
      "price": 31.44,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173454631109",
      "vsf_explanation": "350 mg elemental magnesium blending citrate and branded Aquamin (Lithothamnion algae) is a solid, disclosed dose backed by RCT evidence (Ryan 2011 for Aquamin bone/gut effects; citrate bioavailability well-established). GMP + third-party testing claimed, sustainable marine sourcing. Solid Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mycoflow-10x",
      "title": "MycoFlow 10X",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people._83.png?v=1777910876",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mycoflow",
        "10x",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173745938629",
      "vsf_explanation": "Eight-mushroom blend spread across two capsules dilutes actives well below cited monotherapy doses (e.g., lion's mane cognition needed 3 g/day in Mori 2009). No beta-glucan percentage, no fruiting-body vs mycelium disclosure, and mycelium-on-grain sourcing is common in this price range.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "omega-3-epa-180mg-dha-120mg-1",
      "title": "Omega-3 EPA 180mg + DHA 120mg",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people_98.png?v=1777910890",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "omega",
        "epa",
        "180mg",
        "dha",
        "120mg",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 50,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 55,
        "sustainability": 40
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173746069701",
      "vsf_explanation": "300 mg total EPA+DHA per softgel meets AHA general cardiovascular guidance; REDUCE-IT (Bhatt 2019) used 4 g/day EPA for secondary prevention. Ethyl ester or triglyceride form not disclosed, no oxidation (TOTOX) certificate, no IFOS/GOED verification stated.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnesium-glycinate-2",
      "title": "Magnesium Glycinate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people_-_2026-03-09T012815.761.png?v=1777910896",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "glycinate",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173746102469",
      "vsf_explanation": "Magnesium glycinate is a well-tolerated chelate; 2,500 mg complex per 3-cap serving delivers roughly 200–250 mg elemental Mg, close to Boyle 2017 (Nutrients) anxiety-and-sleep RCT range. Third-party testing and heavy-metal COA not disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ginkgo-biloba-ginseng",
      "title": "Ginkgo Biloba + Ginseng",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people._88.png?v=1777910923",
      "score": 58,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "cognitive",
        "energy",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ginkgo",
        "biloba",
        "ginseng",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173784899781",
      "vsf_explanation": "Ginkgo standardized 24% flavones + Panax ginseng. Ginkgo EGb 761 at 120-240 mg/day has modest cognitive support evidence (Le Bars 1997, though follow-up GEM trial was negative for dementia prevention). Standardization percentages are disclosed but total extract mg not shown in body. Small brand, no NSF/USP certification cited.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-d3-2-000-iu",
      "title": "Vitamin D3 2,000 IU",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people_-_2026-02-27T132948.000.png?v=1777910972",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "000",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 65,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173785555141",
      "vsf_explanation": "Vitamin D3 (cholecalciferol) at 2,000 IU is a widely evidenced maintenance dose (Holick 2011 Endocrine Society guideline). Softgel format supports absorption. Copy inconsistency (title 2,000 IU vs body mentions 5,000 IU) hurts transparency. No K2 co-formulation or third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "maca-plus",
      "title": "Maca Plus",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_Premium_wellness_supplement_hero_shot_of_a_sleek_white_capsule_bottle_with_a_modern_label_featuring_soft_blue__peach__orange__and_purple_accents__centered_on.png?v=1777910978",
      "score": 51,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "energy",
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "maca",
        "plus",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173785784517",
      "vsf_explanation": "Maca RCTs (Gonzales 2009, Andrologia) used 1.5–3 g/day and showed modest sexual desire benefit without hormone changes. 1,500 mg triple-variety dose sits at the low end of clinical range. Andean sourcing claim is plausible; no origin certificate provided.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lions-mane-mushroom-1",
      "title": "Lion's Mane Mushroom",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people_-_2026-02-28T003212.673.png?v=1777910983",
      "score": 55,
      "tier": "standard",
      "certifications": [
        "USDA Organic"
      ],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lion",
        "mane",
        "mushroom",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173785915589",
      "vsf_explanation": "Fruiting body + mycelium blend, standardized to 40% polysaccharides (400 mg per 2-capsule serving). Small RCT support for mild cognitive impairment in older adults (Mori 2009). However, total mushroom mg is undisclosed and mycelium blends can dilute active compounds. Standardization is disclosed which is a plus.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-glutamine-powder",
      "title": "L-Glutamine Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people._91.png?v=1777911001",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glutamine",
        "powder",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 55,
        "sustainability": 40
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173786112197",
      "vsf_explanation": "L-glutamine gut integrity data (Wang 2015 J Trauma) uses 0.3–0.5 g/kg. Muscle-preservation claims are overstated — Antonio 2002 found no ergogenic effect at 0.3 g/kg. Single-ingredient micronized powder is a clean formulation. Pharmaceutical-grade claim not third-party verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "resveratrol",
      "title": "Resveratrol",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people_-_2026-03-08T233242.648.png?v=1777911006",
      "score": 60,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "longevity",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "resveratrol",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173786144965",
      "vsf_explanation": "500 mg per capsule from Polygonum cuspidatum, standardized to 50% trans-resveratrol (250 mg active). Doses disclosed. Resveratrol has meta-analytic support for modest blood-pressure and lipid effects (Berman 2017), though longevity claims remain preclinical. Clean single-ingredient formulation. Small brand transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hair-skin-and-nails-essentials",
      "title": "Hair, Skin and Nails Essentials",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people_-_2026-03-08T211431.623.png?v=1777911047",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hair",
        "skin",
        "and",
        "nails",
        "essentials",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173786276037",
      "vsf_explanation": "Biotin + vitamin C + zinc + iron + B-complex stack has modest evidence for keratin infrastructure (Patel 2017 review). Biotin efficacy for hair growth in non-deficient adults is limited. Per-ingredient mg not disclosed in copy. No third-party test signal from this private-label vendor.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "keto-bhb",
      "title": "Keto BHB",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people_-_2026-02-27T205611.398.png?v=1777911047",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "keto",
        "bhb",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 50,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173786243269",
      "vsf_explanation": "Exogenous BHB salts (Ca/Mg/Na BHB) transiently raise ketones but have weak weight-loss evidence outside a keto diet (Stubbs 2018). Mineral load can be substantial; per-serving BHB mg not disclosed. MCT powder adds some plausibility but overall thin data.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "fruits-veggies",
      "title": "Fruits & Veggies",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_Luxury_wellness_supplement_product_hero_shot_of_Lang_Wellness_Fruits_Veggies_Capsules__featuring_a_single_white_capsule_bottle_only__no_carton__no_outer_packa.png?v=1777911047",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fruits",
        "veggies",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173786341573",
      "vsf_explanation": "Fruit/veg concentrates (apple, beet, blueberry, garlic, ginger, etc.) provide some polyphenol exposure but do not replicate whole-food fiber/matrix effects (Slavin 2012). Copy honestly notes this is supplemental, not a replacement. Per-ingredient mg not shown.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "greens-superfood",
      "title": "Greens Superfood",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people_-_2026-02-27T034837.785.png?v=1777911047",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "greens",
        "superfood",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173786374341",
      "vsf_explanation": "23-ingredient greens powder without per-item dosing hides pixie-dust amounts of ashwagandha and panax ginseng (clinical dose 300–600 mg each). Chlorophyll and antioxidant claims from a single scoop are not supported by human trials on mixed-plant blends.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "grass-fed-hydrolyzed-collagen-peptides",
      "title": "Grass-Fed Hydrolyzed Collagen Peptides",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people_-_2026-03-08T214637.002.png?v=1777911046",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "grass",
        "fed",
        "hydrolyzed",
        "collagen",
        "peptides",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 33.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173786308805",
      "vsf_explanation": "Bovine hide hydrolyzed collagen (types 1 and 3) has consistent evidence for skin elasticity/hydration at ~10 g/day (Choi 2019 meta-analysis). Grass-fed sourcing is a plus. Scoop dose not stated in copy; no third-party heavy-metal COA linked.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "grass-fed-collagen-peptides-powder-chocolate",
      "title": "Grass-Fed Collagen Peptides Powder (Chocolate)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1773024896813-generated-label-image-0.jpg?v=1777911046",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "grass",
        "fed",
        "collagen",
        "peptides",
        "powder",
        "chocolate",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 35.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173786439877",
      "vsf_explanation": "Same grass-fed hydrolyzed collagen base as the unflavored SKU (types 1 and 3) with cocoa, acacia, natural flavor, and stevia — clean flavor system. Skin outcomes at ~10 g/day are supported (Choi 2019). Cocoa may confound iron absorption in some users; no third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutritional-foundation-multivitamin",
      "title": "Nutritional Foundation Multivitamin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people._-_2026-02-27T211934.736.png?v=1777911051",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutritional",
        "foundation",
        "multivitamin",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 52,
        "sustainability": 48
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173786472645",
      "vsf_explanation": "Comprehensive multivitamin with full B-complex, fat-soluble vitamins, plus botanical/prostate ingredients. Multivitamin evidence is mixed but supports gap-filling (Rautiainen 2016). Description details ingredient rationale but individual doses not in body copy. Small brand, no third-party certification cited.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ultra-cleanse-smoothie-greens",
      "title": "Ultra Cleanse Smoothie Greens",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people_-_2026-02-27T043919.387.png?v=1777911133",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ultra",
        "cleanse",
        "smoothie",
        "greens",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 42.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173786702021",
      "vsf_explanation": "40+ ingredients across seven blends (grasses, adaptogens, sea vegetables, digestives, immune, prebiotics, botanicals) fragmented across a single scoop almost guarantees sub-therapeutic doses of adaptogens like Siberian ginseng and schisandra (Panossian 2010). Ingredient-level mg not disclosed.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "radiant-refresh-guava-berry",
      "title": "Radiant Refresh (Guava Berry)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people_-_2026-02-27T073948.738.png?v=1777911134",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "radiant",
        "refresh",
        "guava",
        "berry",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 52,
        "safety": 58,
        "transparency": 45,
        "sustainability": 48
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173786734789",
      "vsf_explanation": "Sugar-free pre-workout/energy powder with caffeine + L-theanine + B-vitamins + electrolytes + taurine. Caffeine + L-theanine has solid focus/attention RCT support at ~100 mg + 200 mg (Owen 2008). Individual doses not shown in body copy. Formulation category is well-established but transparency is limited.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "luminaeye",
      "title": "LuminaEye",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people_-_2026-03-11T020651.833.png?v=1777911139",
      "score": 51,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "luminaeye",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 50,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173786767557",
      "vsf_explanation": "Vitamin C/E + zinc + copper + bilberry + eyebright echoes AREDS2 rationale (Age-Related Eye Disease Study 2 Research Group 2013) but omits lutein/zeaxanthin at trial doses (10/2 mg). Bilberry evidence for macular health is limited. Copper balance included is a plus.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "womens-vitality-formula",
      "title": "Women's Vitality Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_No_people._99.png?v=1777911139",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "women",
        "vitality",
        "formula",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173786833093",
      "vsf_explanation": "Ten-botanical women's blend (Chasteberry, Black Cohosh, Dong Quai, Red Clover, Soy Isoflavones, etc.). Black cohosh has moderate menopause data at 40 mg/day (Frei-Kleiner 2005), chasteberry at 20 mg/day for PMS (Schellenberg 2001). Per-herb mg not disclosed - impossible to verify therapeutic dosing. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "moringa-pure",
      "title": "Moringa Pure",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people_-_2026-03-09T003420.277.png?v=1777911139",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "moringa",
        "pure",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 52,
        "safety": 60,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173786800325",
      "vsf_explanation": "Single-ingredient Moringa oleifera leaf powder capsules (2/day, 30-day supply). Small human trials suggest modest glycemic effects (Leone 2015), though evidence remains limited. Clean, simple product, but per-capsule mg not disclosed in copy.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mens-vitality",
      "title": "Men's Vitality",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people_-_2026-03-11T113157.610.png?v=1777911139",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "men",
        "vitality",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173786865861",
      "vsf_explanation": "Tongkat ali 400 mg and maca 250 mg are within evidence range for male vitality (Talbott 2013 for tongkat ali; Gonzales 2002 for maca), but the SKU explicitly calls out a 'comprehensive proprietary blend' with no per-ingredient breakout. Zinc 50 mg exceeds tolerable upper intake (40 mg UL).",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "grass-fed-collagen-creamer-vanilla",
      "title": "Grass-Fed Collagen Creamer (Vanilla)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people_-_2026-03-08T213247.773.png?v=1777911139",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "grass",
        "fed",
        "collagen",
        "creamer",
        "vanilla",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 35.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173786898629",
      "vsf_explanation": "Grass-fed hydrolyzed collagen (Type I & III) + MCT + pea protein coffee creamer. Type I/III at 2.5-10 g/day supports skin/joint (Proksch 2014). Grams per scoop not shown in listing, and 'grass-fed' unverified. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "florafix-gut-health-capsules",
      "title": "FloraFix Gut Health Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_Luxury_wellness_supplement_product_hero_shot_of_Lang_Wellness_FloraFix_Gut_Health_Capsules__featuring_a_single_white_capsule_bottle_only__no_carton__no_outer.png?v=1777911142",
      "score": 47,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "florafix",
        "gut",
        "health",
        "capsules",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173786931397",
      "vsf_explanation": "Single-strain L. acidophilus is a modest probiotic; multi-strain formulas (McFarland 2018) show broader efficacy. No CFU count disclosed. DigeZyme® is a legitimate branded enzyme blend but dose is not stated. ACV powder in capsules provides minimal acetic acid.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "creatine-hydration-powder-lemon-flavor",
      "title": "Creatine Hydration Powder (Lemon Flavor)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people._87.png?v=1777911193",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "creatine",
        "hydration",
        "powder",
        "lemon",
        "flavor",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 55,
        "sustainability": 40
      },
      "price": 22.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173787226309",
      "vsf_explanation": "Full 5 g creatine monohydrate matches Kreider 2017 ISSN dose. Electrolyte matrix (1000 mg Na / 200 mg K / 60 mg Mg) supports endurance sessions; sodium is high for sedentary users. No creatine sourcing (Creapure vs generic) disclosed, no third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "coq10-ubiquinone",
      "title": "CoQ10 Ubiquinone",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people_97.png?v=1777911197",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coq10",
        "ubiquinone",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 55,
        "sustainability": 40
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173787259077",
      "vsf_explanation": "CoQ10 Q-SYMBIO trial (Mortensen 2014) used 300 mg/day ubiquinone in heart failure with mortality benefit. 200 mg matches statin-myalgia protocols (Qu 2018 meta). Ubiquinone form (not ubiquinol) is fine for under-60 adults; absorption enhancers (oil solubilization) not stated.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ashwagandha-plus",
      "title": "Ashwagandha Plus",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_Premium_adaptogen_supplement_hero_shot_of_a_sleek_white_capsule_bottle_with_a_minimalist_icy-blue_and_white_label__centered_on_a_luminous_cobalt_blue_gradient.png?v=1777911196",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ashwagandha",
        "plus",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173787455685",
      "vsf_explanation": "KSM-66® 600 mg matches Chandrasekhar 2012 (Indian J Psychol Med) cortisol-reduction dose; branded-ingredient signal is strong. Added ginseng, maca, and Shatavari add marketing more than mechanism. B-vitamin and 300 mg L-arginine are reasonable but not hero doses.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "colon-gentle-cleanse",
      "title": "Colon Gentle Cleanse",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people_-_2026-02-26T012016.165.png?v=1777911197",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "colon",
        "gentle",
        "cleanse",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173787291845",
      "vsf_explanation": "Psyllium constipation and cholesterol benefits are well-documented (Anderson 2000, Am J Clin Nutr) at 7–14 g/day, which capsules cannot deliver — most cleanse caps provide 1–2 g. 'Colon cleanse' framing is not evidence-based; the colon self-clears.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bcaa-post-workout-powder-honeydew-watermelon",
      "title": "BCAA Post Workout Powder (Honeydew/Watermelon)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people_-_2026-02-27T141407.384.png?v=1777911200",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bcaa",
        "post",
        "workout",
        "powder",
        "honeydew",
        "watermelon",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173787324613",
      "vsf_explanation": "5,000 mg BCAAs in 2:1:1 leucine-heavy ratio with added L-glutamine and sodium; per-serving totals are disclosed. BCAA evidence for post-exercise MPS is debated when total protein is adequate (Jackman 2017). Naturally colored, US-made. Upper Standard - moves to Verified with COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "breathe-clear-drops",
      "title": "Breathe Clear Drops",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_Premium_wellness_supplement_hero_shot_of_an_amber_glass_dropper_bottle_with_a_black_dropper_cap_and_minimalist_white-and-blue_label__centered_on_a_luminous_co.png?v=1777911197",
      "score": 47,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "breathe",
        "clear",
        "drops",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173787422917",
      "vsf_explanation": "Menthol, peppermint, mullein, orange peel, and lavender essential oils in an MCT carrier at only 400 mg total actives per serving; oral essential-oil dosing lacks strong respiratory RCT data. Ingestion of concentrated menthol and peppermint carries GERD and neonatal risks (Ehrlich 2019).",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "berberine-1",
      "title": "Berberine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people_-_2026-03-01T122605.637.png?v=1777911198",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "berberine",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 50,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173787488453",
      "vsf_explanation": "Berberine HCl has solid meta-analytic evidence for glycemic control and lipids (Lan 2015 JEP meta-analysis). 97% purity claim and dual-source (bark + root) reasonable. Per-capsule mg not disclosed but 2 caps/day likely provides ~1000 mg (near trial range 900–1500 mg). No third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "colostrum-capsules",
      "title": "Colostrum Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people._63.png?v=1777911200",
      "score": 51,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "colostrum",
        "capsules",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 50,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 55,
        "sustainability": 40
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173787357381",
      "vsf_explanation": "Bovine colostrum 30% IgG at 500 mg is on the low side; Brinkworth 2004 (Eur J Nutr) used 20 g/day for upper-respiratory outcomes. 500 mg is a maintenance dose. Dairy sourcing and hormone-free status not disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "amazon-cleanse-acai-detox",
      "title": "Amazon Cleanse (Acai detox)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people_-_2026-03-08T221812.659.png?v=1777911197",
      "score": 36,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "amazon",
        "cleanse",
        "acai",
        "detox",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173787521221",
      "vsf_explanation": "Label explicitly states 'Proprietary Blend (total amount not disclosed)' with 11 ingredients including aloe ferox and black walnut hulls. Aloe latex is a stimulant laxative with tumor concerns (NTP 2013). Zero dose transparency, dubious 'detox' framing.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "bone-heart-support",
      "title": "Bone & Heart Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people_-_2026-02-25T195118.031.png?v=1777911198",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bone",
        "heart",
        "support",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 55,
        "sustainability": 40
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173787553989",
      "vsf_explanation": "D3 + K2 (MK-7) synergy for bone and arterial calcium routing is supported by Knapen 2013 (Thromb Haemost, 180 mcg MK-7 for 3 yrs). Doses of each vitamin not shown here; MK-7 vs MK-4 matters. BioPerine® addition is negligible for fat-soluble vitamins.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dental-oral-health-chewables",
      "title": "Dental + Oral Health Chewables",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people_-_2026-03-08T181543.495.png?v=1777911197",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dental",
        "oral",
        "health",
        "chewables",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173787586757",
      "vsf_explanation": "Oral probiotic + microcrystalline hydroxyapatite + xylitol + guava chewable. Xylitol 6-10 g/day reduces cavity risk vs sucrose (Milgrom 2006). Hydroxyapatite has remineralization RCT support comparable to fluoride (Amaechi 2019). Oral probiotics (S. salivarius M18) have supporting data. Solid mechanism-anchored formulation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bee-pearl",
      "title": "Bee Pearl",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people._98.png?v=1777911198",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bee",
        "pearl",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173787619525",
      "vsf_explanation": "Freeze-dried bee bread (fermented pollen). Evidence is largely traditional and preclinical; a small clinical trial (Kacaniova 2020, in vitro antimicrobial) does not translate to systemic immunity RCTs. Formula is single-ingredient with disclosed capsule count, but no COA or third-party heavy-metal/pesticide testing shown.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bee-bread-powder-sachets",
      "title": "Bee Bread Powder Sachets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people_99.png?v=1777911198",
      "score": 47,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bee",
        "bread",
        "powder",
        "sachets",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173787652293",
      "vsf_explanation": "Royal jelly + bee bread + propolis has traditional use but limited controlled data — small RCTs in immunity and menopause symptoms are heterogeneous (Kolayli 2019 review). Pollen products carry a real anaphylaxis risk in atopic users, not flagged. Sachet mg per component not disclosed.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "brain-focus-formula",
      "title": "Brain & Focus Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_Photorealistic_premium_nootropic_supplement_ad_for_Lang_Wellness_Brain_Focus_Formula__featuring_one_single_matte_white_capsule_bottle_only__centered_on_a_coba.png?v=1777911224",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "brain",
        "focus",
        "formula",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173787685061",
      "vsf_explanation": "Kitchen-sink formula with '30+ ingredients' including DMAE, GABA, phosphatidylserine, and a full vitamin/mineral stack. Phosphatidylserine has some memory evidence at 300 mg (Kato-Kataoka 2010) but almost certainly sub-therapeutic here; oral GABA has poor blood-brain barrier penetration. Multi-ingredient stack with undisclosed per-ingredient doses is the definition of a proprietary blend.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "beetroot-capsules",
      "title": "Beetroot Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people_-_2026-03-01T115145.371.png?v=1777911224",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beetroot",
        "capsules",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173787717829",
      "vsf_explanation": "Certified organic beetroot for nitric-oxide/BP support has decent evidence (Siervo 2013 JN meta-analysis, ~-4.4 mmHg systolic). Capsule mg per dose not disclosed in copy; effective nitrate exposure typically requires ~500 mg dried beet or juice equivalents. Single-ingredient clean formula.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "advanced-100-whey-protein-isolate-chocolate",
      "title": "Advanced 100% Whey Protein Isolate (Chocolate)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people_-_2026-03-21T174644.913.png?v=1777911225",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "advanced",
        "100",
        "whey",
        "protein",
        "isolate",
        "chocolate",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173787783365",
      "vsf_explanation": "22 g whey protein isolate per serving with MCT and real cocoa; whey isolate is the most strongly evidenced protein source for MPS (Morton 2018 BJSM meta-analysis). No artificial flavors is a plus. No heavy-metal COA published; sweetener type not specified in copy.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fermented-mushroom-blend",
      "title": "Fermented Mushroom Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people_-_2026-03-21T191141.084.png?v=1777911224",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fermented",
        "mushroom",
        "blend",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 25,
        "sustainability": 60
      },
      "price": 51.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173787750597",
      "vsf_explanation": "Six-species mushroom mycelial biomass (Cordyceps, Reishi, Agaricus, Shiitake, Maitake, Turkey Tail) with prebiotic fiber and vitamin C. Product page explicitly states 'Vitamin C — [amount not disclosed]' with no per-species dosing. Mycelium biomass on grain is lower beta-glucan than fruiting body extracts (Chilton 2015 analysis).",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "beetroot-powder",
      "title": "Beetroot Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people_-_2026-02-26T010958.800.png?v=1777911224",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beetroot",
        "powder",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173787816133",
      "vsf_explanation": "Beet root + hibiscus + apple juice powder. Dietary nitrate from beetroot juice reduces systolic BP by ~4 mmHg (Siervo 2013 meta) and improves exercise economy (Domínguez 2017). Nitrate mg per scoop not disclosed. Simple, mechanism-supported formulation from a small brand.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chaga-mushroom",
      "title": "Chaga Mushroom",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people_-_2026-02-28T071805.797.png?v=1777911233",
      "score": 50,
      "tier": "standard",
      "certifications": [
        "USDA Organic"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chaga",
        "mushroom",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 52,
        "safety": 60,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173787848901",
      "vsf_explanation": "Chaga mycelium powder standardized to 40% polysaccharides (400 mg per 2-capsule serving). Mycelium-only (not fruiting body) reduces triterpene/betulin content vs whole-mushroom preps. Chaga has preclinical antioxidant/immune data but human RCTs are lacking. Standardization to polysaccharides is disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnesium-glycinate-capsules",
      "title": "Magnesium Glycinate Capsules",
      "vendor": "Siba Vitamins Store",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MAGNESIUMGLYCINATE-01.png?v=1777911287",
      "score": 36,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "glycinate",
        "capsules",
        "siba",
        "vitamins",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 25,
        "safety": 55,
        "transparency": 20,
        "sustainability": 30
      },
      "price": 16.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46583192846533",
      "vsf_explanation": "Magnesium glycinate is a well-tolerated form with reasonable evidence for sleep/anxiety at 200-400mg elemental Mg (Boyle 2017 review), but this listing discloses no mg per capsule, no source facility, and no GMP/USP/NSF certification. This listing reads as a generic reseller with no verifiable brand identity.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "cordyceps-mushroom-capsules",
      "title": "Cordyceps Mushroom Capsules",
      "vendor": "Siba Vitamins Store",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CORDICEPS2000X2000PX-01_79c8d679-92c0-416c-b7cf-829af462045c.png?v=1777911292",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cordyceps",
        "mushroom",
        "capsules",
        "siba",
        "vitamins",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 45,
        "sustainability": 48
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46583183048901",
      "vsf_explanation": "Discloses species (Cordyceps militaris) and organic sourcing. Small RCTs (Chen 2010) show modest VO2max improvements at ~3 g/day; capsule dose not stated in copy. No beta-glucan or cordycepin spec. Unknown boutique vendor keeps it at low Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sea-moss-capsules",
      "title": "Sea Moss Capsules",
      "vendor": "Siba Vitamins Store",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SEAMOSS-01.png?v=1777911292",
      "score": 27,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sea",
        "moss",
        "capsules",
        "siba",
        "vitamins",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 25,
        "manufacturing": 25,
        "safety": 40,
        "transparency": 20,
        "sustainability": 30
      },
      "price": 23.75,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46583187898565",
      "vsf_explanation": "Sea moss (Chondrus crispus) has essentially no RCT evidence for the wellness claims marketed; iodine content varies widely and can push thyroid dysfunction (Zava 2011 review of seaweed iodine). Storefront lists no dose, no iodine assay, no heavy-metal testing, and no manufacturer identity.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "shilajit-resin-1",
      "title": "Shilajit Resin",
      "vendor": "Siba Vitamins Store",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SHILAJITRESIN-01.png?v=1777911292",
      "score": 26,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shilajit",
        "resin",
        "siba",
        "vitamins",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 30,
        "manufacturing": 20,
        "safety": 35,
        "transparency": 20,
        "sustainability": 25
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173788209349",
      "vsf_explanation": "Shilajit has small trials suggesting T-support (Pandit 2016) and fulvic-acid antioxidant activity, but unauthenticated Himalayan resin is the category with the highest documented lead/arsenic contamination risk (Carrasco-Gallardo 2012 review). This listing offers no heavy-metal testing, no fulvic acid %, no COA.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "ashwagandha-capsules",
      "title": "Ashwagandha Capsules",
      "vendor": "Siba Vitamins Store",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ASHWAGANDHACAPSULES-01.png?v=1777911292",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ashwagandha",
        "capsules",
        "siba",
        "vitamins",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 30,
        "manufacturing": 25,
        "safety": 45,
        "transparency": 20,
        "sustainability": 30
      },
      "price": 16.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46583253172421",
      "vsf_explanation": "Ashwagandha has moderate RCT support for cortisol reduction at 300-600mg standardized extract (Chandrasekhar 2012; Salve 2019), but effect sizes hinge on standardized extracts like KSM-66 or Sensoril. This capsule discloses no mg, no extract standardization, no withanolide %, and no manufacturer.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "moringa-leaf-capsules",
      "title": "Moringa Leaf Capsules",
      "vendor": "Siba Vitamins Store",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MORINGA2000x2000px-01.png?v=1777911292",
      "score": 28,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "moringa",
        "leaf",
        "capsules",
        "siba",
        "vitamins",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 25,
        "manufacturing": 25,
        "safety": 45,
        "transparency": 20,
        "sustainability": 30
      },
      "price": 16.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173788274885",
      "vsf_explanation": "Moringa oleifera leaf has limited human RCT support (Kushwaha 2014 postmenopausal glycemia trial is the strongest signal), and effective daily powder doses are 1.5-7g — far more than a small capsule delivers. Listing states no mg per capsule, no organic certifier, no manufacturer.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "soy-isoflavones-30-mg-botanical-complex",
      "title": "Soy Isoflavones 30 mg + Botanical Complex",
      "vendor": "The Menopause Shoppe",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1754918421757-generated-label-image-0.jpg?v=1777911328",
      "score": 66,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "postmenopausal",
      "tokens": [
        "soy",
        "isoflavones",
        "botanical",
        "complex",
        "the",
        "menopause",
        "shoppe"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173788307653",
      "vsf_explanation": "Standardized 30 mg soy isoflavones providing ~19-20 mg genistein plus black cohosh, dong quai, red clover, chasteberry. Genistein-rich isoflavones reduce hot flash frequency by ~20-25% (Taku 2012 meta). Independently verified potency and Trust Center COAs available. Near-Verified tier if fewer supporting botanicals were added.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "probiotic-enzyme-digestive-support",
      "title": "Probiotic + Enzyme Digestive Support",
      "vendor": "The Menopause Shoppe",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1754917465597-generated-label-image-0.jpg?v=1777911333",
      "score": 52,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "postmenopausal",
      "tokens": [
        "probiotic",
        "enzyme",
        "digestive",
        "support",
        "the",
        "menopause",
        "shoppe"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 52,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173788340421",
      "vsf_explanation": "Probiotic + digestive enzyme blend for menopausal GI support. Multi-strain probiotics have meta-analytic support for IBS symptoms (Ford 2018), but this product does not disclose strain names or CFU counts in the description, only referencing 'clinically studied strains.' Trust Center COAs cited. Formulation is opaque.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lean-muscle-metabolic-support",
      "title": "Lean Muscle & Metabolic Support",
      "vendor": "The Menopause Shoppe",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1754917985020-generated-label-image-0.jpg?v=1777911333",
      "score": 66,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "postmenopausal",
      "tokens": [
        "lean",
        "muscle",
        "metabolic",
        "support",
        "the",
        "menopause",
        "shoppe"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 65,
        "safety": 70,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 57.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173788373189",
      "vsf_explanation": "Whey protein isolate (fast-digesting, complete AA profile) + MCT oil powder + apple pectin, positioned for perimenopausal muscle maintenance. Bauer 2013 (PROT-AGE consensus, JAMDA) recommends 1.0-1.2 g/kg protein plus resistance training to preserve lean mass with age. Batch COAs are publicly available in the vendor's Menopause Science Trust Center, which lifts transparency well above private-label peers. High-Standard, near-Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "creatine-monohydrate-4",
      "title": "Creatine Monohydrate",
      "vendor": "The Menopause Shoppe",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1754918120346-generated-label-image-0.jpg?v=1777911333",
      "score": 72,
      "tier": "verified",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "postmenopausal",
      "tokens": [
        "creatine",
        "monohydrate",
        "the",
        "menopause",
        "shoppe"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 82,
        "formulation": 72,
        "manufacturing": 72,
        "safety": 75,
        "transparency": 68,
        "sustainability": 58
      },
      "price": 38.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173788405957",
      "vsf_explanation": "Research-grade creatine monohydrate from a 'leading global producer of creatine used in clinical research' (language consistent with Creapure sourcing). Creatine at 3-5 g/day has among the strongest supplement RCT evidence for strength, lean mass, and increasingly for cognitive/bone endpoints in women (Kreider 2017; Candow 2019). Trust Center COAs available. Anchors at Momentous Verified ~76.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "plant-based-digestive-support",
      "title": "Plant-Based Digestive Support",
      "vendor": "The Menopause Shoppe",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1754917499615-generated-label-image-0.jpg?v=1777911333",
      "score": 58,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "postmenopausal",
      "tokens": [
        "plant",
        "based",
        "digestive",
        "support",
        "the",
        "menopause",
        "shoppe"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173788438725",
      "vsf_explanation": "Apple fiber plus beet, blueberry, carrot and botanical fruit/veg powders for regularity and antioxidant support. Fiber intake supports motility (McRorie 2015 Nutr Today), though this looks modest in gram-terms vs. a psyllium dose. Trust Center COA availability keeps transparency above peers; per-ingredient grams still not shown.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ashwagandha-black-pepper-complex",
      "title": "Ashwagandha + Black Pepper Complex",
      "vendor": "The Menopause Shoppe",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1754918175174-generated-label-image-0.jpg?v=1777911333",
      "score": 65,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "postmenopausal",
      "tokens": [
        "ashwagandha",
        "black",
        "pepper",
        "complex",
        "the",
        "menopause",
        "shoppe"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 68,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173788471493",
      "vsf_explanation": "1000 mg organic ashwagandha root per serving + black pepper for bioavailability. Ashwagandha at 300-600 mg extract/day reduces perceived stress and cortisol (Chandrasekhar 2012 RCT; Salve 2019). Note this is root powder, not KSM-66/Sensoril standardized extract, which are the clinically studied forms. Trust Center COAs cited.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "type-i-iii-nutrient-complex",
      "title": "Type I & III + Nutrient Complex",
      "vendor": "The Menopause Shoppe",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1754918204716-generated-label-image-0.jpg?v=1777911333",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "postmenopausal",
      "tokens": [
        "type",
        "iii",
        "nutrient",
        "complex",
        "the",
        "menopause",
        "shoppe"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 65,
        "sustainability": 45
      },
      "price": 29.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173788504261",
      "vsf_explanation": "Hydrolyzed Type I/III collagen with Vitamin C, biotin, and zinc cofactors follows the biochemistry of collagen synthesis (Proksch 2014, Skin Pharmacol Physiol). 'Menopause Science Trust Center' with published COAs is a real transparency plus. Per-serving collagen grams not stated in body copy.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "maca-adaptogen-complex",
      "title": "Maca + Adaptogen Complex",
      "vendor": "The Menopause Shoppe",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1754918229104-generated-label-image-0.jpg?v=1777911333",
      "score": 58,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "mood",
        "energy",
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "postmenopausal",
      "tokens": [
        "maca",
        "adaptogen",
        "complex",
        "the",
        "menopause",
        "shoppe"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173788537029",
      "vsf_explanation": "1500 mg tri-color Maca (red/black/yellow) + ginseng and adaptogens. Maca has a small evidence base for libido/sexual function (Shin 2010 review) at 1500-3000 mg/day, with best data in postmenopausal women. Complementary adaptogen doses not separately disclosed. Trust Center COAs cited.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "herbal-adaptogen-complex",
      "title": "Herbal Adaptogen Complex",
      "vendor": "The Menopause Shoppe",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1754918292099-generated-label-image-0.jpg?v=1777911333",
      "score": 45,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "postmenopausal",
      "tokens": [
        "herbal",
        "adaptogen",
        "complex",
        "the",
        "menopause",
        "shoppe"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 35,
        "sustainability": 50
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173788569797",
      "vsf_explanation": "13-botanical Ayurvedic adaptogen blend (ashwagandha, turmeric, holy basil, triphala, etc.). Individual ashwagandha (Chandrasekhar 2012) and curcumin (Daily 2016) evidence is decent, but this product hides per-ingredient doses across 13 botanicals. Trust Center COAs cited but blend structure prevents dose verification.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "naysa-nutra-hair-skin-and-nails",
      "title": "Naysa Nutra - Hair, Skin and Nails",
      "vendor": "LavenderWarehouse",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HairSkinandNails2.jpg?v=1777911402",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "naysa",
        "nutra",
        "hair",
        "skin",
        "and",
        "nails",
        "lavenderwarehouse"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 48,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 32.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173788766405",
      "vsf_explanation": "Beta-carotene, C, D3, E, B1, B6, folate, B12, biotin, B5, plus Ca/Fe/Mg. Biotin for hair/nails shows benefit only in biotin-deficient users (Patel 2017 Skin Appendage Disord); routine supplementation lacks RCT support. Ferrous fumarate iron adds GI-tolerance risk. Generic private-label vendor with limited provenance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "naysa-nutra-magnesium-glycinate",
      "title": "Naysa Nutra - Magnesium Glycinate",
      "vendor": "LavenderWarehouse",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MagnesiumGlycinate3.jpg?v=1777911402",
      "score": 53,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "naysa",
        "nutra",
        "magnesium",
        "glycinate",
        "lavenderwarehouse"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 45,
        "safety": 65,
        "transparency": 50,
        "sustainability": 40
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173788799173",
      "vsf_explanation": "2500 mg magnesium glycinate chelate (yielding roughly 250-300 mg elemental Mg across 3 caps) is a reasonable, disclosed dose supported by Boyle 2017 for stress/sleep. Sold via a generic reseller with no brand-of-origin, GMP, or third-party testing disclosed - keeps this at low Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "naysa-nutra-moringa-pure",
      "title": "Naysa Nutra - Moringa Pure",
      "vendor": "LavenderWarehouse",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Moringa.jpg?v=1777911407",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "naysa",
        "nutra",
        "moringa",
        "pure",
        "lavenderwarehouse"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 30,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173788831941",
      "vsf_explanation": "Single-ingredient moringa leaf capsule with no dose stated and no manufacturing provenance beyond an unknown reseller. Moringa has modest human evidence for glycemic and lipid parameters (Stohs 2015 review) but requires standardized doses (~1-2 g/day). Without brand identity or dose disclosure, cannot be verified.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "naysa-nutra-ashwagandha",
      "title": "Naysa Nutra - Ashwagandha",
      "vendor": "LavenderWarehouse",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Ashwagandha_2561adc5-b79c-4d5d-bde6-4f63ba5df938.jpg?v=1777911407",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "naysa",
        "nutra",
        "ashwagandha",
        "lavenderwarehouse"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 23.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173788864709",
      "vsf_explanation": "Organic ashwagandha root + BioPerine at 2 caps/day; ashwagandha reduces cortisol and perceived stress in RCTs (Chandrasekhar 2012 KSM-66 trial). Extract type (root vs whole) and mg per cap not disclosed here, and no standardization to withanolides is mentioned.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "naysa-nutra-berberine",
      "title": "Naysa Nutra - Berberine",
      "vendor": "LavenderWarehouse",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Berberine.jpg?v=1777911407",
      "score": 51,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "naysa",
        "nutra",
        "berberine",
        "lavenderwarehouse"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173788930245",
      "vsf_explanation": "Granular berberine HCl extract (97% + 8% bark/root fractions), 2 caps daily. Yin 2008 (Metabolism 57:5) 500mg TID reduced HbA1c comparable to metformin. Ingredient is well-evidenced; product loses points for missing mg per capsule and unclear COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "reds-superfood-made-in-the-usa",
      "title": "Reds Superfood - Made in the USA",
      "vendor": "THRIXINE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1777471916176-generated-label-image-0.jpg?v=1777911433",
      "score": 49,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "reds",
        "superfood",
        "made",
        "the",
        "usa",
        "thrixine"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 24.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173788963013",
      "vsf_explanation": "Beet, strawberry, hibiscus, acai, cranberry blend with 9 probiotic strains and grape seed extract. Polyphenol exposure is real but probiotic CFU counts and per-ingredient mg are absent; multi-strain probiotic mixtures show inconsistent GI benefits (Suez 2019). No COA.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "l-glutamine-made-in-the-usa",
      "title": "L-Glutamine - Made in the USA",
      "vendor": "THRIXINE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1777373516218-generated-label-image-0.jpg?v=1777911433",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glutamine",
        "made",
        "the",
        "usa",
        "thrixine"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 50,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 50,
        "sustainability": 40
      },
      "price": 24.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173788995781",
      "vsf_explanation": "Single-ingredient L-glutamine powder with simple label. Muscle-recovery claims overstate the evidence (Antonio 2002 found no strength benefit) though gut-lining data is stronger. USA-made claim without stated third-party COA. Standard consumer-grade single-ingredient product.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "beetroot-made-in-the-usa",
      "title": "Beetroot - Made in the USA",
      "vendor": "THRIXINE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1777228315716-generated-label-image-0.jpg?v=1777911433",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beetroot",
        "made",
        "the",
        "usa",
        "thrixine"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173789028549",
      "vsf_explanation": "Organic beetroot 1,300 mg per cap explicitly disclosed. Dietary nitrate/NO evidence for BP and endurance is solid (Siervo 2013; Domínguez 2017 meta-analysis). Clean vehicle (hypromellose + cellulose + Mg stearate). No third-party COA linked.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "complete-multivitamin-made-in-the-usa",
      "title": "Complete Multivitamin - Made in the USA",
      "vendor": "THRIXINE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1777734072877-generated-label-image-0.jpg?v=1777911433",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "complete",
        "multivitamin",
        "made",
        "the",
        "usa",
        "thrixine"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 24.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173789094085",
      "vsf_explanation": "Uses low-bioavailability forms — magnesium oxide, zinc oxide, calcium carbonate, DL-alpha tocopherol acetate — and a bundled 'Health Support' blend of herbs undermines a multivitamin's value (Firoz 2001 on Mg oxide absorption). Multi-RCTs like PHS-II show minimal outcome benefit (Sesso 2012).",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "adaptogen-immunity-drops-made-in-the-usa",
      "title": "Adaptogen Immunity Drops - Made in the USA",
      "vendor": "THRIXINE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1777593711533-generated-label-image-0.jpg?v=1777911433",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "adaptogen",
        "immunity",
        "drops",
        "made",
        "the",
        "usa",
        "thrixine"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 35,
        "sustainability": 55
      },
      "price": 24.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173789126853",
      "vsf_explanation": "Chaga, reishi, maitake, shiitake, turkey tail bundled as a 'proprietary mushroom immune complex' with cordyceps. Beta-glucan content is not standardized and per-ingredient mg is absent — mushroom immunomodulation is dose-dependent (Vetvicka 2019 review).",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "shilajit-adaptogen-complex-made-in-the-usa",
      "title": "Shilajit Adaptogen Complex - Made in the USA",
      "vendor": "THRIXINE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1776971744118-generated-label-image-0.jpg?v=1777911433",
      "score": 41,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shilajit",
        "adaptogen",
        "complex",
        "made",
        "the",
        "usa",
        "thrixine"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 45,
        "transparency": 35,
        "sustainability": 35
      },
      "price": 24.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173789061317",
      "vsf_explanation": "30:1 shilajit + 30:1 ashwagandha + 300:1 tongkat ali + 20:1 sea moss — extract ratios are marketing (say nothing about active content). Ashwagandha KSM-66 or Sensoril standardization not used. Shilajit purification and heavy-metal testing not documented, which is a safety concern.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "alpha-mens-vitality-support-capsules-made-in-the-usa",
      "title": "Alpha Men's Vitality Support Capsules - Made in the USA",
      "vendor": "THRIXINE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1776604732143-generated-label-image-0.jpg?v=1777911438",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "alpha",
        "men",
        "vitality",
        "support",
        "capsules",
        "made",
        "the",
        "usa",
        "thrixine"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173789225157",
      "vsf_explanation": "Long herbal stack (tribulus, chrysin, horny goat weed, longjack, saw palmetto, hawthorn, cissus) with only magnesium oxide/zinc oxide as minerals. Tribulus has no consistent testosterone data (Neychev 2016 meta-analysis). Per-ingredient mg not disclosed.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "grass-fed-hydrolyzed-collagen-peptides-made-in-the-usa",
      "title": "Grass-Fed Hydrolyzed Collagen Peptides - Made in the USA",
      "vendor": "THRIXINE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1776126338541-generated-label-image-0.jpg?v=1777911439",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "grass",
        "fed",
        "hydrolyzed",
        "collagen",
        "peptides",
        "made",
        "the",
        "usa",
        "thrixine"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 33.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173789192389",
      "vsf_explanation": "Single-ingredient bovine hide collagen peptides, type 1 and 3, with scoop-per-8-10 oz dosing. Skin elasticity/hydration and joint pain endpoints have consistent RCT support (Choi 2019 meta-analysis). No sourcing detail beyond 'grass-fed' and no third-party heavy-metal test disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "coq10-ubiquinone-made-in-the-usa",
      "title": "CoQ10 Ubiquinone - Made in the USA",
      "vendor": "THRIXINE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1774220972922-generated-label-image-0.jpg?v=1777911476",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coq10",
        "ubiquinone",
        "made",
        "the",
        "usa",
        "thrixine"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 65,
        "transparency": 25,
        "sustainability": 55
      },
      "price": 24.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173827956933",
      "vsf_explanation": "Simple CoQ10 ubiquinone in vegetable capsule with rice flour. CoQ10 has evidence for statin-related myalgia and heart failure (Mortensen 2014 Q-SYMBIO trial, 100mg 3x/day). Product page lists ingredients but not the CoQ10 dose per capsule, making sub-therapeutic exposure likely.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "pure3-100-whey-protein-isolate-vanilla-made-in-the-usa",
      "title": "Pure3 100% Whey Protein Isolate (Vanilla) Made in the USA",
      "vendor": "THRIXINE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1775175792458-generated-label-image-0.jpg?v=1777911475",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure3",
        "100",
        "whey",
        "protein",
        "isolate",
        "vanilla",
        "made",
        "the",
        "usa",
        "thrixine"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 48.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173827989701",
      "vsf_explanation": "100% whey protein isolate with natural vanilla flavor and stevia extract. Whey isolate is the gold-standard rapid-absorbing MPS driver (Morton 2018 BJSM meta-analysis). Copy doesn't disclose grams per scoop explicitly and no third-party heavy-metal COA linked.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "grass-fed-collagen-peptides-powder-chocolate-1",
      "title": "Grass-Fed Collagen Peptides Powder (Chocolate)",
      "vendor": "THRIXINE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1777236194959-generated-label-image-0.jpg?v=1777911476",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "grass",
        "fed",
        "collagen",
        "peptides",
        "powder",
        "chocolate",
        "thrixine"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 34.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173828022469",
      "vsf_explanation": "Bovine hide hydrolyzed collagen types 1 and 3 with cocoa, natural flavor, stevia, and xanthan gum; two-scoop serving is likely in the 15–20 g range aligning with skin RCT dosing (Choi 2019). No third-party COA or clear gram-per-scoop disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ion-charge-creatine-mg-warmup-muscle-rub",
      "title": "iON Charge Creatine Mg Warmup Muscle Rub",
      "vendor": "THRIXINE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/data_d9766020-a6ee-41ce-a69a-cb9c3220c99d.jpg?v=1777911634",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ion",
        "charge",
        "creatine",
        "warmup",
        "muscle",
        "rub",
        "thrixine"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 13.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173866819781",
      "vsf_explanation": "Topical muscle rub with creatine + magnesium + cayenne + ginger — creatine has essentially zero transdermal absorption (Vega 2006 and Kreider 2017 note oral is the only viable route), so the 'warmup' effect is purely from capsaicin/menthol rubefacients. Category miscategorized as supplement.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-multi-vitamins-womens",
      "title": "Pure Multi-Vitamins Women's",
      "vendor": "THRIXINE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/data_071274c0-ff30-4522-96de-7628cbc539ab.png?v=1777911634",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "pure",
        "multi",
        "vitamins",
        "women",
        "thrixine"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173866852549",
      "vsf_explanation": "Copy is entirely marketing rhetoric ('smart clean choice', 'science-backed') with no ingredient panel, no mg, no GMP claim, and no third-party testing statement. Vendor 'THRIXINE' has minimal brand footprint. Multivitamins generally show neutral to modest mortality effects in adequately-fed populations (Rautiainen 2016 Adv Nutr).",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "pure-multi-vitamins-mens",
      "title": "Pure Multi-Vitamins Mens",
      "vendor": "THRIXINE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/data_1218a0a1-dc31-4d95-b02c-6c19181041ac.png?v=1777911635",
      "score": 33,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "multi",
        "vitamins",
        "mens",
        "thrixine"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients",
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 25,
        "sustainability": 35
      },
      "price": 39.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173866885317",
      "vsf_explanation": "Generic men's multivitamin marketed by unknown brand THRIXINE. Body text advertises 'bioavailable forms' and 'hormone balance' but no ingredient list, doses, or COAs are shown. Multivitamin evidence for healthy adults is weak (Rautiainen 2016 meta-analyses null for mortality); without formulation transparency, cannot score above rejected.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "vitaboost-men-essential-energy-immune-support",
      "title": "VitaBoost Men: Essential Energy & Immune Support",
      "vendor": "THRIXINE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/S2f47e943b91d417e8ea3e0db0e933dcdQ.webp?v=1777911635",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "energy"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "vitaboost",
        "men",
        "essential",
        "energy",
        "immune",
        "support",
        "thrixine"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 25,
        "sustainability": 35
      },
      "price": 13.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173866918085",
      "vsf_explanation": "Anonymous Amazon-style multivitamin with no facility, no COA, no per-nutrient mg. THRIXINE has no verifiable manufacturing footprint or NSF/USP/Informed-Sport certification. Auto-fail caps at 45.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "powerboost-creatine-elevate-strength-endurance",
      "title": "PowerBoost Creatine: Elevate Strength & Endurance",
      "vendor": "THRIXINE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/S4b9e45bfc2094c999633cef5c23870f9S.webp?v=1777911635",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "powerboost",
        "creatine",
        "elevate",
        "strength",
        "endurance",
        "thrixine"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 68,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 12.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173867180229",
      "vsf_explanation": "Pure creatine monohydrate in capsules — creatine mono is the gold-standard ergogenic (Kreider 2017 ISSN). Capsule format is less efficient than powder for 5g daily maintenance dose (multiple caps needed). No Creapure sourcing or third-party COA disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zincmax-50-immune-skin-boost-pure-potent",
      "title": "ZincMax 50: Immune & Skin Boost, Pure & Potent",
      "vendor": "THRIXINE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Sa5435dddeda848fbae4be4f3f2bae2f7M.webp?v=1777911635",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zincmax",
        "immune",
        "skin",
        "boost",
        "pure",
        "potent",
        "thrixine"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 40,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 13.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173867081925",
      "vsf_explanation": "50 mg elemental zinc exceeds the IOM Tolerable Upper Intake Level (40 mg/d for adults); chronic use at this dose depletes copper and can suppress immunity (Fischer 1984 hypocupremia case series). Zinc form (picolinate/gluconate/oxide) not disclosed. Immune claim rests on short-course lozenge trials (Hemila 2017 Cochrane), not chronic 50mg.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "thrixine-creatine-monohydrate-made-with-love-in-the-usa",
      "title": "Thrixine Creatine Monohydrate - Made with Love in the USA",
      "vendor": "THRIXINE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1771771443065-generated-label-image-0.jpg?v=1777911694",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "thrixine",
        "creatine",
        "monohydrate",
        "made",
        "with",
        "love",
        "the",
        "usa",
        "thrixine"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 22.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173905977541",
      "vsf_explanation": "Single-ingredient creatine monohydrate sourced from a 'global leader' (likely Creapure) at 5 g per scoop matches Kreider 2017 ISSN. Copy is copy-pasted from the Fort-Core listing, suggesting drop-shipped catalog. USA-made claim without independent verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure3-100-whey-protein-isolate-chocolate",
      "title": "Pure3 100% Whey Protein Isolate (Chocolate)",
      "vendor": "THRIXINE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1771980582407-generated-label-image-0.jpg?v=1777911694",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure3",
        "100",
        "whey",
        "protein",
        "isolate",
        "chocolate",
        "thrixine"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 49.86,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173906010309",
      "vsf_explanation": "Whey protein isolate with natural chocolate flavor and stevia. Whey isolate remains the strongest evidence base for post-workout muscle protein synthesis (Morton 2018 BJSM meta-analysis). Grams per scoop not disclosed in copy; no third-party COA linked.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "berberine-made-with-love-in-the-usa",
      "title": "Berberine - Made with Love in the USA",
      "vendor": "THRIXINE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1771932725561-generated-label-image-0.jpg?v=1777911695",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "berberine",
        "made",
        "with",
        "love",
        "the",
        "usa",
        "thrixine"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 45,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173906043077",
      "vsf_explanation": "Berberine HCl extract, 2 caps/day for blood-sugar/lipid support; meta-analytic evidence in T2D and dyslipidemia is real (Lan 2015 JEP). Per-cap mg not disclosed but likely ~500 mg; CYP3A4 drug-interaction risk not flagged in copy.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ashwagandha-plus-made-with-love-in-the-usa",
      "title": "Ashwagandha Plus Made with Love in the USA",
      "vendor": "THRIXINE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1771933067182-generated-label-image-0.jpg?v=1777911694",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ashwagandha",
        "plus",
        "made",
        "with",
        "love",
        "the",
        "usa",
        "thrixine"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173906075845",
      "vsf_explanation": "Uses KSM-66 branded ashwagandha, the most clinically studied extract for cortisol/stress (Chandrasekhar 2012 IJPM RCT). Adds Vit D3 (20 mcg disclosed), B6, B12, L-Arginine, Maca, Panax ginseng, and Shatavari. Per-item mg not fully disclosed but the KSM-66 anchor lifts the formula.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-citrulline-l-arginine-stack-made-with-love-in-the-usa",
      "title": "L-Citrulline & L-Arginine Stack -  Made with Love in the USA",
      "vendor": "THRIXINE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1771715139496-generated-label-image-0.jpg?v=1777911694",
      "score": 51,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "citrulline",
        "arginine",
        "stack",
        "made",
        "with",
        "love",
        "the",
        "usa",
        "thrixine"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 24.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173906108613",
      "vsf_explanation": "Citrulline (as citrulline malate) has better NO-pathway bioavailability than oral arginine (Schwedhelm 2008 clinical PK) and shows small performance/BP benefits at ~6–8 g/day. Per-cap mg for either amino acid not disclosed in copy; combined dose likely well below trial dosing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "creatine-hydration-powder-made-in-the-usa",
      "title": "Creatine Hydration Powder - Made in the USA",
      "vendor": "THRIXINE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1773624881299-generated-label-image-0.jpg?v=1777911759",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "creatine",
        "hydration",
        "powder",
        "made",
        "the",
        "usa",
        "thrixine"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 24.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173906370757",
      "vsf_explanation": "Creatine monohydrate 5,000 mg — the trial-standard dose (Kreider 2017 JISSN position stand). Paired with Mg/Na/K electrolytes for hydration support. Solid single-ingredient science; no CreaPure or third-party COA disclosure keeps it from Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nitric-oxide-made-with-love-in-the-usa",
      "title": "Nitric Oxide - Made with Love in the USA",
      "vendor": "THRIXINE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1773276903719-generated-label-image-0.jpg?v=1777911759",
      "score": 31,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nitric",
        "oxide",
        "made",
        "with",
        "love",
        "the",
        "usa",
        "thrixine"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 25,
        "manufacturing": 30,
        "safety": 50,
        "transparency": 20,
        "sustainability": 30
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173906403525",
      "vsf_explanation": "Blend of L-Arg AKG + L-Arg HCl + L-Citrulline DL-Malate with no per-ingredient doses disclosed. Effective citrulline dosing for NO/flow-mediated dilation is 6-8g/day (Bailey 2015 J Appl Physiol) — impossible in 2 capsules. Brand has no third-party testing, GMP certification, or COA visible.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "marine-essence",
      "title": "Marine Essence",
      "vendor": "Protein Zone",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1758424862117-generated-label-image-0.jpg?v=1777911840",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "marine",
        "essence",
        "protein",
        "zone"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 45,
        "transparency": 50,
        "sustainability": 60
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173906567365",
      "vsf_explanation": "Irish moss + bladderwrack + burdock root + BioPerine. Sea vegetables provide iodine but bladderwrack iodine content is highly variable and can exceed safe intake (Zava 2011). No per-capsule iodine mcg listed — this is a real safety concern rather than a benefit. Vegan pullulan capsule is a small plus.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnesium-glycinate-high-absorption-muscle-sleep-support",
      "title": "Magnesium Glycinate | High-Absorption Muscle & Sleep Support",
      "vendor": "Protein Zone",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1758423430045-generated-label-image-0.jpg?v=1777911846",
      "score": 53,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "glycinate",
        "high",
        "absorption",
        "muscle",
        "sleep",
        "support",
        "protein",
        "zone"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173906600133",
      "vsf_explanation": "2,500 mg magnesium glycinate complex per serving (~200 mg elemental Mg) matches Boyle 2017 (Nutrients) sleep/anxiety RCT range. Vegan hypromellose capsules, no artificial additives. Third-party heavy-metal COA not shown.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ashwagandha-stress-relief-cortisol-balance-support",
      "title": "Ashwagandha | Stress Relief & Cortisol Balance Support",
      "vendor": "Protein Zone",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1758424118499-generated-label-image-0.jpg?v=1777911845",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive",
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ashwagandha",
        "stress",
        "relief",
        "cortisol",
        "balance",
        "support",
        "protein",
        "zone"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173906632901",
      "vsf_explanation": "Ashwagandha root extract has RCT support for stress/cortisol reduction at 300-600 mg/day of KSM-66 or Sensoril (Chandrasekhar 2012). This listing is organic 'ashwagandha root' with black pepper but does not disclose extract standardization, withanolide %, or mg per capsule — likely full-spectrum powder rather than a standardized extract, which drops evidence quality.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nad-complex-cellular-energy-aging-support-with-resveratrol",
      "title": "NAD+ Complex | Cellular Energy & Aging Support with Resveratrol",
      "vendor": "Protein Zone",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1758917590608-generated-label-image-0.jpg?v=1777911845",
      "score": 49,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nad",
        "complex",
        "cellular",
        "energy",
        "aging",
        "support",
        "with",
        "resveratrol",
        "protein",
        "zone"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173906763973",
      "vsf_explanation": "L-Arginine AKG + L-Arginine HCl + L-Citrulline DL-Malate. Oral L-arginine is a poor NO substrate due to first-pass hepatic arginase (Wu 2009). Citrulline is the better precursor. Per-ingredient mg not disclosed and 2-cap serving is unlikely to reach effective NO dose.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "berberine-hcl-complex-metabolic-blood-sugar-support",
      "title": "Berberine HCl Complex | Metabolic & Blood Sugar Support",
      "vendor": "Protein Zone",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1758423585797-generated-label-image-0.jpg?v=1777911845",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "berberine",
        "hcl",
        "complex",
        "metabolic",
        "blood",
        "sugar",
        "support",
        "protein",
        "zone"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173906796741",
      "vsf_explanation": "Berberine has meaningful evidence for glycemic control at 500 mg 2-3x daily (Yin 2008 meta-analysis vs metformin comparable). Product page uses vague 'targeted metabolic wellness' language and never states the actual mg per capsule or whether it uses standardized 97% berberine HCl. Without dose disclosure it can't clear Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-creatine-monohydrate-strength-muscle-performance",
      "title": "Pure Creatine Monohydrate | Strength & Muscle Performance",
      "vendor": "Protein Zone",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1758426461106-generated-label-image-0.jpg?v=1777911845",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "creatine",
        "monohydrate",
        "strength",
        "muscle",
        "performance",
        "protein",
        "zone"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 27.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173906665669",
      "vsf_explanation": "100% pure creatine monohydrate, unflavored, no fillers. Creatine mono is one of the most robustly evidenced supplements in sport nutrition (Kreider 2017 JISSN). No CreaPure branding, no third-party COA, per-scoop mg not documented in copy — keeps it below Verified anchor.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ginger-acai-cleanse-natural-detox-digestive-support",
      "title": "Ginger Acai Cleanse | Natural Detox & Digestive Support",
      "vendor": "Protein Zone",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1758917691435-generated-label-image-0.jpg?v=1777911845",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ginger",
        "acai",
        "cleanse",
        "natural",
        "detox",
        "digestive",
        "support",
        "protein",
        "zone"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 35,
        "sustainability": 50
      },
      "price": 27.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173906698437",
      "vsf_explanation": "Ginger + acai 'cleanse' framing. Ginger has RCT support for nausea (Marx 2013) but 'detox/cleanse' is not a physiologically validated construct. Product page never states mg of ginger, form (extract vs powder), or acai standardization. Vague marketing plus no dose disclosure keeps it in Rejected.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "resveratrol-600mg-cellular-health-antioxidant-capsules",
      "title": "Resveratrol 600mg - Cellular Health & Antioxidant Capsules",
      "vendor": "Protein Zone",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1758771906218-generated-label-image-0.jpg?v=1777911845",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "resveratrol",
        "600mg",
        "cellular",
        "health",
        "antioxidant",
        "capsules",
        "protein",
        "zone"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173906731205",
      "vsf_explanation": "Trans-resveratrol from Japanese knotweed standardized to 50% — dose (600 mg) and standardization are disclosed, which is above average. Human RCTs are mixed: modest cardiometabolic signals (Liu 2015 meta) but no confirmed longevity outcomes. Clean vegan capsule shell with limited fillers. No COA or third-party testing shown.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "digestive-enzyme-pro-blend-broad-spectrum-support-for-bloating",
      "title": "Digestive Enzyme Pro Blend | Broad Spectrum Support for Bloating",
      "vendor": "Protein Zone",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1758917901560-generated-label-image-0.jpg?v=1777911845",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "digestive",
        "enzyme",
        "pro",
        "blend",
        "broad",
        "spectrum",
        "support",
        "for",
        "bloating",
        "protein",
        "zone"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173906829509",
      "vsf_explanation": "Makzyme-Pro complex (fungal protease + lactobacillus) + bromelain, papain, fungal lipase/lactase, alpha-galactosidase. Enzyme supplementation shows narrow benefits (lactase for lactose intolerance; alpha-galactosidase for FODMAP gas — Di Stefano 2007). Activity units per enzyme not disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cognipure-brain-focus-botanical-supplement-znetics",
      "title": "Cognipure | Brain & Focus Botanical Supplement | ZNETICS",
      "vendor": "Znetics",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cognipure-7440863.png?v=1777911897",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cognipure",
        "brain",
        "focus",
        "botanical",
        "supplement",
        "znetics",
        "znetics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 30,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 25,
        "sustainability": 30
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173945528517",
      "vsf_explanation": "Description names no specific botanicals and no doses — 'caffeine-free botanical blend' is the only detail given. Even with third-party testing and US manufacturing claims, evaluating cognitive efficacy is impossible without knowing what is in it, and no clinical evidence can be cited for an unnamed formula.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "turmeric-curcumin-capsules-with-bioperine®-glucosamine-chondroitin-znetics",
      "title": "Turmeric Curcumin Capsules with BioPerine® | Glucosamine & Chondroitin | ZNETICS",
      "vendor": "Znetics",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/turmeric-curcumin-capsules-high-absorption-with-bioperine-9730868.png?v=1777911902",
      "score": 53,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "turmeric",
        "curcumin",
        "capsules",
        "with",
        "bioperine",
        "glucosamine",
        "chondroitin",
        "znetics",
        "znetics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 39.96,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173945561285",
      "vsf_explanation": "Curcumin + BioPerine is a defensible combo — Shoba 1998 showed ~20x bioavailability boost from piperine, and Daily 2016 meta-analysis found curcumin ~500-1500mg/day comparable to NSAIDs for knee OA pain. Glucosamine + chondroitin have moderate but mixed evidence (GAIT 2006 primary null, moderate-severe subgroup positive). BioPerine is a licensed ingredient and the brand claims US manufacturing plus third-party testing, but specific mg per active are not disclosed on this page.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "plant-protein-vanilla",
      "title": "Plant Protein (Vanilla)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people._89.png?v=1777912039",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "plant",
        "protein",
        "vanilla",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 44.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173985145029",
      "vsf_explanation": "20 g plant protein from Tendra® fava bean isolate + YESTEIN™ fermented yeast blend covers essential amino acids reasonably. Berrone 2020 fava studies show DIAAS ~0.75. Below whey isolate MPS response but adequate. Stevia-sweetened. Heavy-metal COA not disclosed (a real concern for plant proteins per Clean Label Project 2020).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "womens-vitality",
      "title": "Women's Vitality",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people._93.png?v=1777912039",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "women",
        "vitality",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173985177797",
      "vsf_explanation": "Ashwagandha, dong quai, maca, damiana, Asian ginseng, plus B6/B12/pantothenic acid and L-Arginine with BioPerine. Dong quai has known bleeding-risk interactions with warfarin (Page 1999) — not flagged. Per-item mg not disclosed.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "sleep-formula",
      "title": "Sleep Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people._-_2026-02-27T124905.288.png?v=1777912044",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sleep",
        "formula",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173985210565",
      "vsf_explanation": "Melatonin + Valerian + GABA + L-Tryptophan + Passionflower stack. Melatonin RCT-effective at 0.3-3 mg (Ferracioli-Oda 2013 meta), valerian at 300-600 mg (Bent 2006). Per-ingredient mg not disclosed - key issue. Otherwise a sensible sleep stack. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "probiotic-40-billion-with-prebiotics-1",
      "title": "Probiotic 40 Billion with Prebiotics",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people_-_2026-02-27T225441.141.png?v=1777912044",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "probiotic",
        "billion",
        "with",
        "prebiotics",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 35,
        "sustainability": 50
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173985276101",
      "vsf_explanation": "40 billion CFU across L. acidophilus, B. lactis, L. plantarum, L. paracasei with MAKTREK Bi-Pass delivery. Copy states 'Proprietary Blend of Probiotic Bacteria' — per-strain CFU counts are hidden, so strain-specific evidence (Culturelle GG anchor) cannot be assumed.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "prostate-support",
      "title": "Prostate Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people_-_2026-02-27T023446.030.png?v=1777912045",
      "score": 47,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "prostate",
        "support",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173985243333",
      "vsf_explanation": "Ingredient list (saw palmetto, pygeum, nettle, pumpkin seed, lycopene, boron, B6, vitamin E, grape seed) has decent BPH RCT anchors (Wilt 2002 saw palmetto meta-analysis, later CAMUS trial null). But no per-ingredient doses disclosed. 'Made in USA' but no GMP or COA. Just below Standard.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "nitric-oxide",
      "title": "Nitric Oxide",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people_-_2026-02-27T092201.386.png?v=1777912045",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nitric",
        "oxide",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 50,
        "transparency": 35,
        "sustainability": 35
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173985308869",
      "vsf_explanation": "L-arginine + L-citrulline is an established NO pathway (Bailey 2010 shows 6 g citrulline malate improves exercise output). But listing gives no doses; therapeutic citrulline is ~6-8 g/day and a 60-cap/30-day format almost certainly under-doses. Likely sub-therapeutic + prop-blend.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "platinum-turmeric-capsules",
      "title": "Platinum Turmeric Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people._94.png?v=1777912044",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "platinum",
        "turmeric",
        "capsules",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 50,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173985341637",
      "vsf_explanation": "Triple turmeric (incl. 95% curcuminoids) + glucosamine + chondroitin + MSM + boswellia + ginger + BioPerine. Curcumin+piperine improves bioavailability ~20× (Shoba 1998). Glucosamine/chondroitin evidence is mixed (GAIT trial 2006). Turmeric hepatotoxicity signals not flagged; per-item mg not disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sea-moss-capsules-1",
      "title": "Sea Moss Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people_-_2026-02-26T014141.020.png?v=1777912045",
      "score": 41,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sea",
        "moss",
        "capsules",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173985374405",
      "vsf_explanation": "'92 minerals' sea moss claim traces to a debunked 1979 chart. Bladderwrack adds unpredictable iodine that can worsen thyroid disease (Leung 2014, Nat Rev Endocrinol). Human RCTs on this trio are absent. Iodine content per serving not disclosed — real safety concern.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "apple-cider-vinegar-capsules",
      "title": "Apple Cider Vinegar Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_Luxury_wellness_supplement_product_hero_shot_of_Lang_Wellness_Apple_Cider_Vinegar_Capsules__featuring_a_single_white_capsule_bottle_only__no_carton__no_outer.png?v=1777912072",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "apple",
        "cider",
        "vinegar",
        "capsules",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 50,
        "sustainability": 40
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173986521285",
      "vsf_explanation": "1000 mg ACV powder in capsules retains negligible acetic acid — the actual mechanism behind Kondo 2009 (Biosci Biotechnol Biochem) weight-loss data used 15–30 mL liquid vinegar. Prebiotic and enzyme adds are legitimate but under-dosed. Marketing 'beats liquid ACV' claim is misleading.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "berberine-essentials",
      "title": "Berberine Essentials",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/berberine-essentials-benefits-featured.webp?v=1777912210",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "berberine",
        "essentials",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 35,
        "sustainability": 35
      },
      "price": 49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173987799237",
      "vsf_explanation": "Berberine HCl has decent HbA1c and lipid data (Lan 2015 meta) at 1500 mg/day divided doses, but this listing does not disclose per-capsule mg. No standardization to alkaloid content and no phytosome or dihydro form to improve absorption.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "prosta-defend",
      "title": "Prosta Defend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/prosta-defend-benefits-featured.webp?v=1777912210",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "prosta",
        "defend",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 42,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173987864773",
      "vsf_explanation": "Saw palmetto, nettle root, L-glycine, and vitamin E for BPH-adjacent claims, but the landmark STEP trial (Bent 2006) found saw palmetto no better than placebo. Individual ingredient doses are not disclosed, and WOW MD is a white-label brand with minimal manufacturing transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "neuro-plus-brain-focus-formula",
      "title": "Neuro Plus Brain & Focus Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/neuro-plus-brain-and-focus-formula-benefits-featured.webp?v=1777912210",
      "score": 41,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "neuro",
        "plus",
        "brain",
        "focus",
        "formula",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 30,
        "sustainability": 35
      },
      "price": 39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173987930309",
      "vsf_explanation": "Choline, B6, folate, and magnesium are foundational but no doses disclosed. No hero nootropic (bacopa, L-theanine, citicoline). Poulton 2020 (Nutrients) shows choline nootropic effect requires 300+ mg. Claims of memory retention and mood improvement exceed evidence for undisclosed doses.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "raw-shea-butter",
      "title": "Raw Shea Butter",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/raw-shea-butter-benefits-feature.webp?v=1777912210",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "raw",
        "shea",
        "butter",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 50,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173987995845",
      "vsf_explanation": "Unrefined shea butter is a well-established emollient with vitamin A/E-rich fatty acids (Lin 2018 review). Simple single-ingredient formulation is a positive, but no country-of-origin, fair-trade, or refining-grade disclosure. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "anxiety-shield",
      "title": "Anxiety Shield",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/anti-anxiety-benefits-featured.webp?v=1777912211",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "anxiety",
        "shield",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 30,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 20,
        "sustainability": 35
      },
      "price": 36,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173987897541",
      "vsf_explanation": "Four-herb calming stack (ashwagandha, rhodiola, bacopa, chamomile) with no individual doses disclosed. Individual herbs have RCT support at specific doses (KSM-66 ashwagandha 600 mg, Chandrasekhar 2012; rhodiola SHR-5 400 mg, Cropley 2015), but a blend that hides amounts cannot be assumed therapeutic.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "grass-fed-hydrolyzed-collagen-peptides-1",
      "title": "Grass-Fed Hydrolyzed Collagen Peptides",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/grass-fed-hydrolyzed-benefits-featured.webp?v=1777912211",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "grass",
        "fed",
        "hydrolyzed",
        "collagen",
        "peptides",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 65,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 75,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173988028613",
      "vsf_explanation": "Type I/III bovine hydrolyzed collagen has RCT evidence for skin elasticity at 10-15 g/day (Choi 2019), but this label only specifies '1 scoop' without a gram amount, so the delivered dose is opaque. Generic bovine hide sourcing with no traceability or third-party verification puts it just under the Standard cutoff.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-glow-serum",
      "title": "Vitamin Glow Serum",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/vitamin-glow-serum-benefits-feature.webp?v=1777912211",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "glow",
        "serum",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 58,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173988061381",
      "vsf_explanation": "Discloses 5% niacinamide + vitamin C + E + panthenol + PHA. Niacinamide 4-5% has strong RCT support for tone and barrier (Hakozaki 2002). Vitamin C form and pH not stated. Upper-Standard, would move to Verified with pH and full concentration list.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "joint-support",
      "title": "Joint Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/joint-support-benefits-feature.webp?v=1777912210",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "joint",
        "support",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173987963077",
      "vsf_explanation": "MSM, glucosamine (GlucosaGreen), turmeric, boswellia, white willow, HA, and BioPerine is a busy joint stack. Individual ingredients have modest OA evidence (Clegg 2006 GAIT was largely null for glucosamine/chondroitin), but none of the six actives disclose per-serving doses, so therapeutic delivery cannot be verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "colostrum-capsules-1",
      "title": "Colostrum Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/colostrum-capsules-benefits-feature.webp?v=1777912211",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "colostrum",
        "capsules",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173988126917",
      "vsf_explanation": "500 mg bovine colostrum per capsule with 'IgG-rich' claim but no IgG percentage or third-party COA disclosed. Colostrum has modest gut-barrier and URTI evidence (Patiroglu 2013), but WOW MD is a DTC vendor with limited provenance. Standard tier — clean but unremarkable.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dental-oral-health-chewables-1",
      "title": "Dental + Oral Health Chewables",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/dental-oral-health-chewables-benefits-featured.webp?v=1777912211",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dental",
        "oral",
        "health",
        "chewables",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173988094149",
      "vsf_explanation": "Microcrystalline hydroxyapatite, xylitol, guava, and a 3-strain oral probiotic - hydroxyapatite has RCT-level evidence for enamel remineralization comparable to fluoride (Amaechi 2019). Ingredient doses are not disclosed, but formulation logic is sound; entry-level Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ayurvedic-complex",
      "title": "Ayurvedic Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ayurvedic-complex-benefits-featured.webp?v=1777912212",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ayurvedic",
        "complex",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 44,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173988159685",
      "vsf_explanation": "Ashwagandha, brahmi, turmeric, and holy basil are legitimate adaptogens (ashwagandha 300-600 mg KSM-66 has cortisol/stress evidence per Chandrasekhar 2012), but the label doesn't name a standardized extract or dose. Single-cap once daily is likely sub-therapeutic across a five-herb blend.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bee-bread-powder",
      "title": "Bee Bread Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/bee-bread-powder-benefits-feature.webp?v=1777912211",
      "score": 47,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bee",
        "bread",
        "powder",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 50,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 74,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173988225221",
      "vsf_explanation": "Bee bread + royal jelly + propolis sachets, 1/day. Bee-product RCT evidence is limited and heterogeneous; small studies suggest antioxidant activity (Bakour 2017). Bee protein allergy risk should be flagged. No dose per sachet, no source apiary information. Falls below Standard on evidence + transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "advanced-100-whey-protein-isolate-chocolate-1",
      "title": "Advanced 100% Whey Protein Isolate (Chocolate)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/advanced-100-whey-protein-featured.webp?v=1777912211",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "advanced",
        "100",
        "whey",
        "protein",
        "isolate",
        "chocolate",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 65,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173988257989",
      "vsf_explanation": "35 g whey protein isolate per scoop is well above the leucine-threshold dose for MPS (~25 g whey, Witard 2014). Added MCT and apple pectin are inert-to-benign. Sourcing/protein content is disclosed; third-party amino acid verification and grass-fed sourcing are not, capping this at low Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "collagen-complex",
      "title": "Collagen Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/collagen-complex-benefits-featured.webp?v=1777912211",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "collagen",
        "complex",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173988192453",
      "vsf_explanation": "Five-type hydrolyzed collagen (bovine, chicken, marine, eggshell, avian sternum). Type I/III supports skin (Proksch 2014). Total g in 3 caps is likely well under the 2.5-10 g RCT threshold. Standard tier - capsule format constrains therapeutic dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "saffron-extract",
      "title": "Saffron Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/saffron-extract-benefits-feature.webp?v=1777912213",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "saffron",
        "extract",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173988290757",
      "vsf_explanation": "Saffron 28-30 mg/day has real depression/mood evidence (Lopresti 2014 meta-analysis) but this label discloses only 'Saffron Extract' with no mg amount or standardization (e.g., Affron, Saffr'Activ). Impossible to confirm therapeutic delivery.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "white-kidney-bean",
      "title": "White Kidney Bean",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/white-kidney-bean-benefits-featured.webp?v=1777912217",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "white",
        "kidney",
        "bean",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173988356293",
      "vsf_explanation": "Phaseolus vulgaris extract shows modest starch-blocker effects at 445-1500 mg/day (Barrett 2011 review) but this label discloses no mg amount. No brand of standardized extract (e.g., Phase 2) named.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "myo-d-chiro-inositol",
      "title": "Myo D-Chiro Inositol",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/myo-d-chiro-inositol-benefits.webp?v=1777912218",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "myo",
        "chiro",
        "inositol",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 65,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173988421829",
      "vsf_explanation": "40:1 myo-inositol to D-chiro-inositol (Caronositol branded DCI) is the ratio validated for PCOS support at ~4 g myo + 100 mg DCI daily (Unfer 2017). Total daily mg not disclosed but the 40:1 ratio choice signals formulation literacy; entry-level Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "plant-protein-chocolate",
      "title": "Plant Protein (Chocolate)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/plant-protein-chocolate-benefits-feature.webp?v=1777912219",
      "score": 53,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "plant",
        "protein",
        "chocolate",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173988454597",
      "vsf_explanation": "30 g scoop of fava-bean isolate + fermented yeast + MCT — no protein-per-serving gram count disclosed on the label copy. Blended plant proteins can match whey EAA profiles (Berrazaga 2019) but this vendor doesn't publish an amino-acid spec. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "womens-vitality-formula-1",
      "title": "Women's Vitality Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/womens-vitality-formula-benefits-featured.webp?v=1777912220",
      "score": 39,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "women",
        "vitality",
        "formula",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 40,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173988487365",
      "vsf_explanation": "Dong quai, red clover, black cohosh, and chasteberry are traditional but weakly evidenced menopause herbs; black cohosh in particular carries hepatotoxicity signals (Teschke 2011). No individual doses disclosed, and the multi-herb hormonal cocktail without safety guidance keeps this in Rejected.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hair-skin-and-nails-essentials-1",
      "title": "Hair, Skin and Nails Essentials",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/hair-skin-and-nails-essentials-benefits-featured.webp?v=1777912220",
      "score": 41,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hair",
        "skin",
        "and",
        "nails",
        "essentials",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 67,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173988520133",
      "vsf_explanation": "Biotin, vitamin C, zinc, and horsetail extract - biotin supplementation shows benefit only in true deficiency (Patel 2017) and can interfere with common lab assays (troponin, TSH). No doses disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ultra-cleanse-smoothie-greens-1",
      "title": "Ultra Cleanse Smoothie Greens",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ultra-cleanse-smoothie-greens-benefits-featured.webp?v=1777912221",
      "score": 41,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ultra",
        "cleanse",
        "smoothie",
        "greens",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173988552901",
      "vsf_explanation": "Spirulina, chlorella, Siberian ginseng, and aloe positioned as a 'detoxification' greens powder - no controlled evidence that these blends detoxify a healthy body. No mg per ingredient disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "respiratory-lung-health-drops",
      "title": "Respiratory & Lung Health Drops",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/respiratory-lung-health-drops-featured.webp?v=1777912221",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "respiratory",
        "lung",
        "health",
        "drops",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 48,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173988585669",
      "vsf_explanation": "Oral drops of menthol, peppermint, mullein, lavender and orange essential oils in MCT — ingesting essential oils daily is not established as safe (menthol/1,8-cineole can cause GI/hepatic issues at repeated doses; Anpalahan 1999 case report). Mullein has traditional respiratory use but no modern RCT. 'Lung health' claim disease-adjacent.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "grass-fed-collagen-peptides-powder-chocolate-2",
      "title": "Grass-Fed Collagen Peptides Powder (Chocolate)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/grass-fed-collagen-peptides-benefits-featured.webp?v=1777912222",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "grass",
        "fed",
        "collagen",
        "peptides",
        "powder",
        "chocolate",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 65,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 75,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173988618437",
      "vsf_explanation": "Powder form of hydrolyzed Type I/III collagen with a chocolate flavor. Same evidence base as the capsule version (Choi 2019 skin RCTs used 10 g/day) but no gram-per-scoop disclosure and no bioactive collagen peptide (BCP) branding or Verisol identity - just under Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lions-mane-mushroom-2",
      "title": "Lion's Mane Mushroom",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/lions-mane-mushroom-benefits-featured.webp?v=1777912223",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lion",
        "mane",
        "mushroom",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173988683973",
      "vsf_explanation": "Lion's mane has small-RCT evidence for mild cognitive impairment at 3 g/day of dried powder (Mori 2009), but this listing gives no mg, no fruiting body vs mycelium disclosure, and no beta-glucan spec - the three markers that separate a real Hericium erinaceus product from mycelium-on-grain filler.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nitric-oxide-1",
      "title": "Nitric Oxide",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/nitric-oxide-benefits-featured.webp?v=1777912223",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nitric",
        "oxide",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 62,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173988749509",
      "vsf_explanation": "L-arginine AKG, arginine HCl, and L-citrulline DL-malate - citrulline has real ergogenic evidence at 6-8 g (Perez-Guisado 2010), but no per-serving mg disclosed here. Two capsules almost certainly cannot deliver clinically active citrulline doses.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "apple-cider-vinegar-capsules-1",
      "title": "Apple Cider Vinegar Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/apple-cider-vinegar-capsules-featured.webp?v=1777912224",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "apple",
        "cider",
        "vinegar",
        "capsules",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173988847813",
      "vsf_explanation": "ACV powder plus inulin, L. acidophilus, and DigeZyme enzymes. Liquid ACV has small glycemic evidence (Johnston 2004) but capsulized dried ACV has no meaningful clinical support at typical doses. Ingredient mg amounts not disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "focus-powder-sour-grape",
      "title": "Focus Powder (Sour Grape)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/focus-powder-sour-grape-benefits-feature.webp?v=1777912224",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "focus",
        "powder",
        "sour",
        "grape",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 75,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173988782277",
      "vsf_explanation": "Alpha-GPC, L-theanine, caffeine, arginine, and inositol is a defensible nootropic stack (Alpha-GPC 400 mg has cognition RCT support per De Jesus Moreno 2003; theanine + caffeine synergy per Owen 2008), but no mg per ingredient disclosed. Recommending up to 5 scoops/day with no caffeine ceiling is a safety concern.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mushroom-extract-complex-gummies",
      "title": "Mushroom Extract Complex Gummies",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/mushroom-extract-complex-benefits-featured.webp?v=1777912224",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mushroom",
        "extract",
        "complex",
        "gummies",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 62,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173988880581",
      "vsf_explanation": "Lion's mane, reishi, cordyceps, turkey tail gummies, 2/day, raspberry-flavored. Gummy formats typically deliver 100-500mg mushroom material vs. clinical doses of 1-3g (Mori 2009 lion's mane RCT 3g/day). No per-mushroom mg, no fruit body vs. mycelium clarification, no beta-glucan %. Format and disclosures both fall short.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "alpha-energy-1",
      "title": "Alpha Energy",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/alpha-energy-benefits-featured.webp?v=1777912226",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alpha",
        "energy",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173989077189",
      "vsf_explanation": "Magnesium, zinc, tribulus terrestris, horny goat weed for male vitality. Tribulus has repeatedly failed to raise testosterone in RCTs (Neychev 2005), and HGW icariin lacks quality human data. No doses disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "blood-sugar-ultra-advanced-formula",
      "title": "Blood Sugar Ultra Advanced Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/blood-sugar-ultra-benefits-featured.webp?v=1777912225",
      "score": 36,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "blood",
        "sugar",
        "ultra",
        "advanced",
        "formula",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic",
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 35,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 20,
        "sustainability": 35
      },
      "price": 39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173989142725",
      "vsf_explanation": "Blend of banaba, chromium, cinnamon, ALA, and bitter melon marketed as a glucose-regulation formula with no per-ingredient doses. Individual constituents have modest RCT support (Costello 2016 chromium meta-analysis: small A1c reduction; Allen 2013 cinnamon meta-analysis: mixed), but hidden doses and 'high dosage' marketing without figures cannot be verified.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "omega-fish-oil",
      "title": "Omega Fish Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/omega-fish-oil-kids-featured.webp?v=1777912263",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "omega",
        "fish",
        "oil",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 35,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 35,
        "sustainability": 35
      },
      "price": 74,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173993599173",
      "vsf_explanation": "Kids fish oil gummies with orange flavor: EPA/DHA per gummy not disclosed. Gummy carrier limits omega-3 dose (typically <100 mg total) versus AHA guidance. No oxidation testing (TOTOX) documented — critical for kids because rancid fish oil is common in gummy formats (Jackowski 2015).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liver-support-1",
      "title": "Liver Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/liver-support-benefits_f5446778-13e6-40dc-9267-ed5d2b598339.webp?v=1777912263",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liver",
        "support",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173993631941",
      "vsf_explanation": "Milk thistle, beetroot, artichoke, and dandelion for 'detoxification.' Silymarin 420 mg/day has modest ALT-lowering evidence in NAFLD (Zhong 2017) but this label lists no mg or silymarin standardization. Detox marketing without doses = Rejected.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mgbalance-magnesium-powder",
      "title": "MgBalance Magnesium Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/mgbalance-magnesium-powder-benefits-featured.webp?v=1777912263",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mgbalance",
        "magnesium",
        "powder",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173993730245",
      "vsf_explanation": "Magnesium powder marketed as bioavailable but form (glycinate vs oxide vs citrate) and elemental mg per scoop are not disclosed - critical for evaluating a magnesium product. Boyle 2017 meta shows sleep and stress benefits at 320-500 mg/day of well-absorbed forms. Standard until form is stated.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "good-gut-great-life",
      "title": "Good Gut Great Life",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/good-gut-great-life-benefits-featured.webp?v=1777912263",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "good",
        "gut",
        "great",
        "life",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173993697477",
      "vsf_explanation": "40 billion CFU probiotic with four named strains (L. acidophilus, B. lactis, L. plantarum, L. paracasei) - the CFU count is disclosed and strains are strain-agnostic but at species level, credible. Missing: strain identifiers, delivery technology, and cold-chain claims; entry Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "m50-menopause-essential",
      "title": "M50 - Menopause Essential",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/m50-menopause-benefits-featured.webp?v=1777912263",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "postmenopausal",
      "tokens": [
        "m50",
        "menopause",
        "essential",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 35,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 30,
        "sustainability": 35
      },
      "price": 39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173993664709",
      "vsf_explanation": "Black cohosh has mixed RCT data (Leach 2012 Cochrane, marginal benefit) requiring 40 mg standardized extract. Red clover and dong quai lack strong evidence. Doses not disclosed for any ingredient. Estrogen-modulating claim is a regulatory concern.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "beetroot-balance",
      "title": "Beetroot Balance",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/beetroot-balance-benefits.webp?v=1777912263",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beetroot",
        "balance",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 41,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173993763013",
      "vsf_explanation": "1300 mg organic beetroot per serving with disclosed dose — inorganic nitrate content drives modest BP-lowering and exercise-tolerance effects (Siervo 2013 meta-analysis, Lansley 2011). Beetroot powder is lower-potency vs. concentrated juice (500 mL delivers ~800mg nitrate) but provenance and dose disclosure are decent.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nexgen-creatine-powder",
      "title": "NexGen Creatine Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/nexgen-creatine-powder-benefits-featured.webp?v=1777912263",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nexgen",
        "creatine",
        "powder",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 58,
        "manufacturing": 50,
        "safety": 68,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173993795781",
      "vsf_explanation": "Pure creatine monohydrate at 5g scoop — matches the ISSN maintenance dose (Kreider 2017). Free of fillers/gluten/GMOs per listing. No Creapure branding, no COA disclosure, and vendor is a general wellness DTC brand rather than a sports-supplement specialist.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "caralluma-max",
      "title": "Caralluma Max",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/caralluma-max-benefits_91abff2b-558d-4fe8-b62c-d0fcb06e33d0.webp?v=1777912281",
      "score": 36,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "caralluma",
        "max",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 30,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 30,
        "sustainability": 35
      },
      "price": 41,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173993828549",
      "vsf_explanation": "Caralluma fimbriata appetite RCTs (Astell 2013, Complement Ther Med) at 1 g/day showed only waist circumference reduction, no weight loss. No standardization or dose stated here. 'Fat-burning' and 'appetite control' claims oversell the modest evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "moringa-green-energy",
      "title": "Moringa Green Energy",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/moringa-green-energy-benefits-feature.webp?v=1777912283",
      "score": 39,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "moringa",
        "green",
        "energy",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 42,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173993861317",
      "vsf_explanation": "Single ingredient (moringa leaf) marketed for energy, joints, and sleep. Human evidence is limited to small trials; benefit claims outrun data. Dose per capsule not disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "night-calm-advanced-sleep-formula",
      "title": "Night Calm - Advanced Sleep Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/night-calm-benefits-featured.webp?v=1777912282",
      "score": 36,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "night",
        "calm",
        "advanced",
        "sleep",
        "formula",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 35,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 20,
        "sustainability": 35
      },
      "price": 39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173993894085",
      "vsf_explanation": "Melatonin plus L-theanine, chamomile, and lemon balm with no doses disclosed. Melatonin (0.3-1 mg, Zhdanova 2001) and L-theanine (200 mg, Hidese 2019) both have RCT support at defined amounts, but this label hides them so users cannot confirm dose is appropriate or safe.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "urovital-defense",
      "title": "UroVital Defense",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/urovital-defense-benefits-featured.webp?v=1777912283",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "urovital",
        "defense",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 44,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173993926853",
      "vsf_explanation": "D-mannose, cranberry, hibiscus, and dandelion for UTI prophylaxis. D-mannose 2 g/day has non-inferior evidence vs nitrofurantoin (Kranjcec 2014), but this label shows no mg for D-mannose - unlikely to hit therapeutic threshold in 2 caps.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "turmeric-boost",
      "title": "Turmeric Boost",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/turmeric-boost-benefits-featured.webp?v=1777912315",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "turmeric",
        "boost",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 33,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173994418373",
      "vsf_explanation": "Organic turmeric + 95% standardized curcuminoid extract + ginger + BioPerine - a well-designed absorption stack. Shoba 1998 showed piperine raises curcumin bioavailability ~20x. Per-capsule curcumin mg not disclosed; single cap daily may be sub-therapeutic vs Daily 2016's 1 g/day. Upper Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnesium-glycinate-3",
      "title": "Magnesium Glycinate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/magnesium-glycinate-benefits_7053ae47-e822-4043-bfe2-e0d025f91089.webp?v=1777912316",
      "score": 47,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "glycinate",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173994221765",
      "vsf_explanation": "Magnesium glycinate form is legitimate and well-tolerated but this listing discloses neither elemental Mg amount per serving nor complex weight. Without dose disclosure the claim of high absorption cannot be evaluated against Boyle 2017 clinical range.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "testosterone-support",
      "title": "Testosterone Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/testosterone-support-benefits_1153ace3-b102-480e-ba30-63f86cb49f28.webp?v=1777912315",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "testosterone",
        "support",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173994254533",
      "vsf_explanation": "Tribulus + Longjack + Saw Palmetto + Zinc with no doses disclosed. Tribulus RCTs (Rogerson 2007; Neychev 2005) consistently fail to raise testosterone; only Longjack + zinc have modest signals at specific doses this label doesn't cite. Rejected — weak evidence stack, undisclosed dosing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "green-coffee-bean-extract-with-gca",
      "title": "Green Coffee Bean Extract With GCA",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/green-coffee-bean-featured.webp?v=1777912315",
      "score": 47,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "green",
        "coffee",
        "bean",
        "extract",
        "with",
        "gca",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 48,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173994287301",
      "vsf_explanation": "GCA (chlorogenic acid) standardized extract. Weight-loss evidence collapsed after FTC action against Applied Food Sciences (2014, Vinson 2012 study retracted). Modest metabolic effects at 400 mg/day. No dose disclosed. 'Made in USA', minimal transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ashwagandha-extra-strength-formula",
      "title": "Ashwagandha Extra Strength Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ashwagandha-benefits-featured.webp?v=1777912316",
      "score": 37,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ashwagandha",
        "extra",
        "strength",
        "formula",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 35,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 34,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173994188997",
      "vsf_explanation": "'Extra Strength' ashwagandha plus black pepper with no mg amount, extract standardization, or root-vs-leaf disclosure. RCT-backed stress-reduction (Chandrasekhar 2012) requires 300-600 mg of a standardized root extract (KSM-66 or Sensoril). Without the number, 'extra strength' is a marketing term.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "max-detox-acai-berry-complex",
      "title": "Max Detox ACAI Berry Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/max-detox-acai-berry-complex-benefits-feature.webp?v=1777912316",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "max",
        "detox",
        "acai",
        "berry",
        "complex",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 36,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173994385605",
      "vsf_explanation": "WOW MD Max Detox lists Chlorella, Psyllium, Acai and Slippery Elm without individual doses, and the marketing claim 'detox' has no clinical validation (Sears & Genuis 2012 review found no evidence for commercial detox products). Body cleanses via liver/kidney, not capsules. No third-party testing or COA disclosed.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "b-12-complex-liquid",
      "title": "B-12 Complex Liquid",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b-12-complex-liquid-benefits-featured.webp?v=1777912316",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "complex",
        "liquid",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients",
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173994320069",
      "vsf_explanation": "B12, B6, B2, B3 liquid marketed for 'continuous energy' — B-vitamin supplementation only benefits users with deficiency (Tardy 2020 review), not baseline energy. Doses not disclosed and form of B12 (methylcobalamin vs cyanocobalamin) is unspecified. No third-party verification.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "coq10-energy-max",
      "title": "CoQ10 Energy Max",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/coq-10energy-benefits.webp?v=1777912322",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coq10",
        "energy",
        "max",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart",
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 55,
        "sustainability": 40
      },
      "price": 44.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173994451141",
      "vsf_explanation": "200 mg ubiquinone per capsule — dose disclosed and consistent with cardiovascular RCT evidence (Mortensen 2014 Q-SYMBIO trial: 100 mg tid reduced major adverse cardiac events in heart failure). Standard-tier because vendor WOW MD lacks cGMP/third-party testing disclosure and uses ubiquinone rather than the more bioavailable ubiquinol.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-arginine-plus",
      "title": "L-Arginine Plus",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/l-arginine-plus-benefits_1ed8c5a2-c28b-4229-b650-aa14d5137d02.webp?v=1777912322",
      "score": 51,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "arginine",
        "plus",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 42,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173994483909",
      "vsf_explanation": "L-arginine + L-citrulline + niacin + calcium capsule with no per-ingredient doses. Effective L-citrulline dosing is 6–8 g/day (Bailey 2015) — hard to reach in 2 capsules, likely sub-therapeutic for NO synthesis. Standard by weighted math but questionable dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "resveratrol-1",
      "title": "Resveratrol",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/resveratrol-benefits-featured.webp?v=1777912322",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "resveratrol",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 48,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173994614981",
      "vsf_explanation": "Japanese knotweed-derived resveratrol; trans-resveratrol % and per-capsule mg not disclosed. Human RCTs use 150-500 mg/day (Timmers 2011 metabolic RCT); at 2 caps/day the total may be sub-therapeutic. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "colon-sweep",
      "title": "Colon Sweep",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/colonsweep-benefits.webp?v=1777912321",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "colon",
        "sweep",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 38,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173994582213",
      "vsf_explanation": "Psyllium husk has strong fiber evidence (McRorie 2015), but Colon Sweep bundles it with aloe vera and alfalfa at undisclosed doses and markets 'cleanse' outcomes. Frequent aloe use is a laxative concern (IARC 2B carcinogen for non-decolorized whole leaf). No COA or brand history.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "maca-plus-1",
      "title": "Maca Plus",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/maca-plus-benefits-featured.webp?v=1777912321",
      "score": 37,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood",
        "energy",
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "maca",
        "plus",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic",
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 20,
        "sustainability": 40
      },
      "price": 42,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173994516677",
      "vsf_explanation": "Tri-color organic maca root plus black pepper with no dose. Systematic review (Shin 2010) suggests modest sexual-function benefit for maca at 1.5-3 g/day, but this label doesn't disclose amount or gelatinization, so therapeutic dose cannot be verified.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "black-sambucus-elderberry-extract",
      "title": "Black Sambucus Elderberry Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/black-sambucus-elderberry-benefits-featured.webp?v=1777912322",
      "score": 51,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "black",
        "sambucus",
        "elderberry",
        "extract",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 50,
        "safety": 50,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 44,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173994549445",
      "vsf_explanation": "European elderberry extract has moderate evidence for reducing cold/flu duration (Tiralongo 2016 RCT). Copy adds weight-management framing not backed by elderberry data. Mg per cap and standardization to anthocyanins not disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrimax-essentials-advanced-daily-multivitamin",
      "title": "NutriMax Essentials - Advanced Daily Multivitamin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/nutrimax-essentials-benefits-featured.webp?v=1777912320",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrimax",
        "essentials",
        "advanced",
        "daily",
        "multivitamin",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173994647749",
      "vsf_explanation": "Multivitamins have mixed evidence for healthy adults (Sesso 2022 COSMOS-Web mind trial showed modest cognitive benefit). NutriMax lists Vit C, D, Zinc, Saw Palmetto but omits doses, forms, and %DV per serving. Saw Palmetto in a general multi is odd (male-specific evidence: Wilt 1998). No third-party validation.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "vision-guard-eye-care",
      "title": "Vision Guard Eye Care",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/vision-support-benefits-featured.webp?v=1777912321",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vision",
        "guard",
        "eye",
        "care",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 44,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173994680517",
      "vsf_explanation": "Vitamin A, C, E, and lutein. AREDS2 (2013) validated lutein 10 mg + zeaxanthin 2 mg for AMD progression, but this listing discloses no lutein mg and omits zeaxanthin entirely. Formula shape is right; dose transparency is not.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ginkgo-biloba",
      "title": "Ginkgo Biloba",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ginkgo-biloba-benefits-featured.webp?v=1777912333",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ginkgo",
        "biloba",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 45,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 35,
        "sustainability": 35
      },
      "price": 47,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173994713285",
      "vsf_explanation": "600 mg 'standardized' ginkgo per serving disclosed, but the label also lists Panax ginseng and additional ginkgo powder without doses or standardization percentages (24/6 flavonoid/lactone is the trial-validated spec). Ginkgo cognition evidence is mixed (GEM DeKosky 2008 null for dementia prevention). Undisclosed sub-doses in the blend trigger cap.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "vitasun-vitamin-k2-d3",
      "title": "VitaSun Vitamin K2+D3",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/vitasun-benefits-featured.webp?v=1777912333",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitasun",
        "vitamin",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients",
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 25,
        "sustainability": 35
      },
      "price": 42,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173994746053",
      "vsf_explanation": "K2 (MK-7) + D3 combo is a sensible pairing supported by evidence for bone density and vascular calcium handling (Knapen 2013, 180 mcg MK-7), but no doses are disclosed here. Without mcg amounts, users can't confirm therapeutic D3 (typically 2000-5000 IU) or MK-7 (90-180 mcg).",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "yeast-cleanse-advanced-gut-candida-support-formula-90-vegan-capsules",
      "title": "Yeast Cleanse – Advanced Gut & Candida Support Formula (90 Vegan Capsules)",
      "vendor": "Seamoss depot",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/IMG-5202.png?v=1777912400",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "yeast",
        "cleanse",
        "advanced",
        "gut",
        "candida",
        "support",
        "formula",
        "vegan",
        "capsules",
        "seamoss",
        "depot"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 40,
        "sustainability": 55
      },
      "price": 49.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173995565253",
      "vsf_explanation": "Pau d'arco, grapefruit, caprylic acid, garlic bundled as a 'candida cleanse'. Chronic candidiasis in immunocompetent adults is not an established syndrome outside of specific medical contexts (IDSA guidelines 2016), and herbal antifungal evidence is thin. Per-item mg not disclosed.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "parasite-cleanse-detox-natural-gut-immune-support-eliminate-worms-bloating-fatigue-naturally",
      "title": "Parasite Cleanse Detox | Natural Gut & Immune Support | Eliminate Worms, Bloating & Fatigue Naturally!",
      "vendor": "Seamoss depot",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7FC1877A-1453-4327-B017-62390E8DC514.png?v=1777912405",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "gut",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "parasite",
        "cleanse",
        "detox",
        "natural",
        "gut",
        "immune",
        "support",
        "eliminate",
        "worms",
        "bloating",
        "fatigue",
        "naturally",
        "seamoss",
        "depot"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 40,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 59.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173995630789",
      "vsf_explanation": "Copy explicitly claims to 'eliminate worms, eggs, and toxins', 'target parasites at every stage', 'destroy parasite eggs', 'expel tapeworms'. These are treatment claims for parasitic disease requiring physician diagnosis and prescription anthelmintics. Wormwood contains thujone (neurotoxic at chronic doses); black walnut hulls contain juglone. FDA has issued warning letters for identical claims on similar products.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "lymphatic-cleanse-detox-reduce-swelling-drain-toxins-boost-energy",
      "title": "Lymphatic Cleanse Detox – Reduce Swelling, Drain Toxins & Boost Energy",
      "vendor": "Seamoss depot",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/IMG-6545.jpg?v=1777912404",
      "score": 28,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lymphatic",
        "cleanse",
        "detox",
        "reduce",
        "swelling",
        "drain",
        "toxins",
        "boost",
        "energy",
        "seamoss",
        "depot"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 30,
        "manufacturing": 30,
        "safety": 35,
        "transparency": 25,
        "sustainability": 35
      },
      "price": 59.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173995663557",
      "vsf_explanation": "Herbal 'lymphatic cleanse' with pokeroot (potentially toxic) and other herbs, marketed with disease-adjacent claims: 'flushes inflammation trapped in joints & tissues,' 'release stubborn weight,' 'flush lymphatic blockages.' There is no clinical evidence that oral herbs 'unblock' the lymphatic system; pokeroot has documented emetic/systemic toxicity (Lewis 1979).",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "magnesium-ashwagandha-liquid-softgels-stress-relief-mood-recovery-support-60-ct",
      "title": "Magnesium + Ashwagandha Liquid Softgels | Stress Relief, Mood & Recovery Support, 60 CT",
      "vendor": "Seamoss depot",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/IMG-0318.jpg?v=1777912405",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "mood",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "ashwagandha",
        "liquid",
        "softgels",
        "stress",
        "relief",
        "mood",
        "recovery",
        "support",
        "seamoss",
        "depot"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 49.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173995729093",
      "vsf_explanation": "Branded Sensoril ashwagandha extract has real clinical support at 125-250 mg (Auddy 2008 stress trial); triple-source magnesium + activated P5P B6 is a rational stress-recovery stack. Vitamin D3 + zinc add immune coverage. Doses per component not disclosed in listing, limiting ceiling.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "milk-thistle-liver-detox-cleanse-natural-liver-support-detox-formula-with-bioperine",
      "title": "Milk Thistle Liver Detox Cleanse | Natural Liver Support & Detox Formula with BioPerine",
      "vendor": "Seamoss depot",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/IMG-0742.jpg?v=1777912405",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "milk",
        "thistle",
        "liver",
        "detox",
        "cleanse",
        "natural",
        "liver",
        "support",
        "detox",
        "formula",
        "with",
        "bioperine",
        "seamoss",
        "depot"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 48.77,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173995827397",
      "vsf_explanation": "Milk thistle standardized to 80% silymarin plus dandelion, turmeric, schisandra, BioPerine — resold Irwin Naturals softgels. Silymarin has moderate data for liver function markers (Salmi 1982; Rambaldi 2007 Cochrane inconclusive for hepatitis). Standardization is a plus; 'detox' framing is unsupported.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "herbal-iron-liquid-supplement-natural-vegan-iron-boost-for-energy-vitality-wellness",
      "title": "Herbal Iron Liquid Supplement | Natural Vegan Iron Boost for Energy, Vitality & Wellness",
      "vendor": "Seamoss depot",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/IMAGE-EDIT_350824ea-a802-415d-b678-c25b2a911659.png?v=1777912414",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "herbal",
        "iron",
        "liquid",
        "supplement",
        "natural",
        "vegan",
        "iron",
        "boost",
        "for",
        "energy",
        "vitality",
        "wellness",
        "seamoss",
        "depot"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173995991237",
      "vsf_explanation": "Liquid iron with vitamin C, B-complex, and spinach/baobab/sarsaparilla/fennel. Vitamin C co-administration meaningfully improves non-heme iron absorption (Cook 2001 AJCN). Liquid format is easier on GI than ferrous fumarate tablets. Iron dose not disclosed — should not be taken without confirmed deficiency due to iron overload risk (Piperno 2020 Blood).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "prostate-support-formula-natural-urinary-sexual-health-boost",
      "title": "Prostate Support Formula | Natural Urinary & Sexual Health Boost",
      "vendor": "Seamoss depot",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/IMG-7863.jpg?v=1777912413",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "prostate",
        "support",
        "formula",
        "natural",
        "urinary",
        "sexual",
        "health",
        "boost",
        "seamoss",
        "depot"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 59.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46173996024005",
      "vsf_explanation": "Saw palmetto (Bent 2006 CAMUS trial: 320mg/d no better than placebo for BPH), pygeum, black cumin and stinging nettle — none of the doses disclosed. Saw palmetto's clinical benefit is weak and other ingredients lack robust RCT support. 'Sexual performance' claim borders on disease indication.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "nature-s-truth-prostaid-60-capsules-prostate-health-supplement-for-men-saw",
      "title": "Nature s Truth Prostaid | 60 Capsules | Prostate Health Supplement for Men | Saw",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/17eaca3f-d5da-4faa-ba15-92a20cb819db.827774a9cfcd3950d721fa70f1d2452d.webp?v=1777912711",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "nature",
        "truth",
        "prostaid",
        "capsules",
        "prostate",
        "health",
        "supplement",
        "for",
        "men",
        "saw",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 9.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46174007886021",
      "vsf_explanation": "Saw palmetto + pygeum + lycopene for BPH support. Saw palmetto RCTs are mixed (STEP trial Bent 2006 was null; earlier Cochrane pooled data showed modest urinary flow benefit at 320 mg/day). Nature's Truth is a real cGMP US brand sold through pharmacies, but body text doesn't publish per-ingredient mg amounts. Solid Standard, not Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "centrum-silver-men-50-multivitamin-dietary-supplement-tablets-200ct",
      "title": "Centrum Silver Men 50+ Multivitamin Dietary Supplement Tablets - 200ct",
      "vendor": "Centrum",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/74488689.jpg?v=1777912762",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "male",
      "life_stage": "men_50_plus",
      "tokens": [
        "centrum",
        "silver",
        "men",
        "multivitamin",
        "dietary",
        "supplement",
        "tablets",
        "200ct",
        "centrum"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 55,
        "manufacturing": 70,
        "safety": 70,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 26.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46174009819333",
      "vsf_explanation": "Centrum Silver is the most-studied multivitamin on the market: Physicians' Health Study II (Gaziano 2012 JAMA) showed a modest cancer-incidence reduction over 11 years, and COSMOS-Mind (Baker 2022, Alzheimer's & Dementia) reported measurable cognitive-decline slowing in 65+ users at 3 years. Formulation is basic RDA-level (no methylated B12, low D3) but Non-GMO/gluten-free verified. Well-known manufacturer, though not USP-verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "victor-rolf-flwrbmb-sp-1-7oz",
      "title": "VICTOR&ROLF FLWRBMB SP 1.7OZ",
      "vendor": "",
      "image_url": "",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "victor",
        "rolf",
        "flwrbmb",
        "7oz",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 30,
        "manufacturing": 40,
        "safety": 40,
        "transparency": 20,
        "sustainability": 30
      },
      "price": 115.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46174011195589",
      "vsf_explanation": "This is Viktor & Rolf Flowerbomb perfume (1.7 oz spray), miscategorized. It is not an ingestible supplement and has no supplement rubric applicability.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "neocell-super-multi-collagen-peptides-powder-9oz-10-types-of-collagen-skin-hair-and-nails-beauty-supplement-unflavored-powder-for-women-and-men",
      "title": "NeoCell Super Multi Collagen Peptides Powder | 9oz | 10 Types of Collagen | Skin, Hair and Nails | Beauty Supplement | Unflavored Powder | For Women and Men",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71LXSGujmoL._UF894_1000_QL80.jpg?v=1777912815",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "neocell",
        "super",
        "multi",
        "collagen",
        "peptides",
        "powder",
        "9oz",
        "types",
        "collagen",
        "skin",
        "hair",
        "and",
        "nails",
        "beauty",
        "supplement",
        "unflavored",
        "powder",
        "for",
        "women",
        "and",
        "men",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 24.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46174011293893",
      "vsf_explanation": "NeoCell is an established collagen brand with published hydrolyzation. 10 collagen types, IGEN non-GMO tested, unflavored powder. Skin-elasticity RCT support (Proksch 2014) at 2.5-10 g/day. Per-scoop grams not on the listing; NeoCell typically delivers ~6.6 g. Upper Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "qunol-ultra-100-mg-coq10-dietary-supplement-softgels",
      "title": "Qunol Ultra 100 Mg CoQ10 Dietary Supplement Softgels",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/302876622_d9fb99cf-a97f-4dbb-84ab-cb17b3f9c636.jpg?v=1777912844",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "qunol",
        "ultra",
        "100",
        "coq10",
        "dietary",
        "supplement",
        "softgels",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 70,
        "manufacturing": 70,
        "safety": 70,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46174011588805",
      "vsf_explanation": "Qunol's patented water+fat-soluble CoQ10 has real PK backing (Ma 2016 showing 3-4x absorption vs crystalline). 100 mg/softgel is at the low end of the Mortensen 2014 Q-SYMBIO heart-failure trial (300 mg/day) but appropriate for statin-user maintenance. Established brand, retail QA. Upper Standard verging on Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "melatonin-3-mg-sleep-support-supplement-60-tablets",
      "title": "Melatonin 3 mg – Sleep Support Supplement (60 Tablets)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/imagen_2026-02-10_144121642.png?v=1777912883",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "melatonin",
        "sleep",
        "support",
        "supplement",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 5.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46174011719877",
      "vsf_explanation": "3 mg melatonin is above the physiologically-effective range (0.3-0.5mg per Zhdanova 2001 delivered comparable sleep-onset benefit with fewer next-day effects). Meta-analyses support melatonin for jet lag and shift work (Herxheimer 2002 Cochrane). Basic pharmacy-brand tablet, dose disclosed, but overdose relative to effective threshold.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-methylfolate-15-mg-dietary-supplement-90-capsules",
      "title": "L-Methylfolate 15 mg Dietary Supplement, 90 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/image-0_d6ec205d-86a9-4021-9a89-51ad5c076070.webp?v=1777912923",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "methylfolate",
        "dietary",
        "supplement",
        "capsules",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 70,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 253.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46174014439621",
      "vsf_explanation": "15 mg L-methylfolate is a therapeutic dose matching the Deplin-level RCT literature for MDD adjunctive treatment (Papakostas 2012) and MTHFR-variant support. Active methylated folate bypasses MTHFR conversion. Sold by an established NYC compounding pharmacy (Pasteur), which provides brand provenance; upper Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "leader-ashwagandha-tablets-60-ct",
      "title": "LEADER# ASHWAGANDHA TABLETS 60 CT",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71twR7nvq_L._AC_SY300_SX300.jpg?v=1777912951",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "leader",
        "ashwagandha",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 35,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 35,
        "sustainability": 35
      },
      "price": 8.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46174017814725",
      "vsf_explanation": "LEADER is a pharmacy generic. Ashwagandha has solid stress RCTs at 300-600 mg standardized extract (Chandrasekhar 2012, KSM-66). LEADER listing does not disclose extract standardization (withanolide %) or dose. Likely non-standardized root powder at sub-therapeutic dose.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "vital-proteins-marine-collagen-dietary-supplement-7-8oz-imperfect-container",
      "title": "Vital Proteins Marine Collagen Dietary Supplement 7.8oz - Imperfect Container",
      "vendor": "This is Beauty US",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/GUEST_79dd93a2-2813-4c16-892b-8118f880d447.jpg?v=1778343003",
      "score": 67,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vital",
        "proteins",
        "marine",
        "collagen",
        "dietary",
        "supplement",
        "8oz",
        "imperfect",
        "container",
        "this",
        "beauty"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 75,
        "safety": 72,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 27.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198103769285",
      "vsf_explanation": "Genuine Vital Proteins Marine Collagen at 12 g hydrolyzed peptides/serving from wild-caught cod. Skin-elasticity RCTs support ~2.5-10 g/day (Proksch 2014). Listing is a third-party reseller ('imperfect container') but product itself is a mainstream, GMP-manufactured brand. Solid Standard, below Vital Proteins direct due to reseller channel.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "spirulina-radish-supplement-tablets",
      "title": "Spirulina Radish Supplement Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/E77B3B904CF165E487E150E9847BC91E.jpg?v=1778343076",
      "score": 29,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "spirulina",
        "radish",
        "supplement",
        "tablets",
        "digital",
        "presence"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 25,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 20,
        "sustainability": 30
      },
      "price": 22,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198103834821",
      "vsf_explanation": "Dropship-style listing with generic template copy ('Target audience: Adults, Production process: Biological'). No dose, no manufacturer, no COA. Amazon prop-blend anchor territory.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "upgraded-8-hour-sleep-clinically-shown-to-improve-sleep-32-ct-capsules",
      "title": "Upgraded 8-Hour Sleep: Clinically Shown To Improve Sleep (32 ct capsules)",
      "vendor": "Upgraded Formulas®",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Upgraded_Sleep_32ct.png?v=1778343107",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "upgraded",
        "hour",
        "sleep",
        "clinically",
        "shown",
        "improve",
        "sleep",
        "capsules",
        "upgraded",
        "formulas"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198103867589",
      "vsf_explanation": "Nano-stabilized magnesium sleep formula referencing a 3rd-party clinical trial with 250% deep sleep/160% REM improvements. Magnesium supplementation for sleep quality has modest RCT support (Abbasi 2012 in older adults). The 250% deep-sleep claim is bold — trial documentation and PMID not linked in copy.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nature-made-extra-strength-melatonin-10-mg-tablets-70-count-sleep-aid-supplement",
      "title": "Nature Made Extra Strength Melatonin 10 Mg Tablets, 70 Count Sleep Aid Supplement",
      "vendor": "Nature Made",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/312823869.jpg?v=1778343161",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "made",
        "extra",
        "strength",
        "melatonin",
        "tablets",
        "count",
        "sleep",
        "aid",
        "supplement",
        "nature",
        "made"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 50,
        "manufacturing": 75,
        "safety": 55,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 12.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198103965893",
      "vsf_explanation": "Nature Made is one of the few USP-Verified supplement brands, which is a meaningful QA anchor. Melatonin has solid evidence for sleep-onset latency and total sleep time (Ferracioli-Oda 2013 meta-analysis, 19 RCTs), but effective doses are 0.3-3mg — this 10mg tablet is ~5-10x the efficacious dose, associated with more next-day grogginess and receptor-desensitization concerns without added sleep benefit. Product is honestly labeled but the strength choice is a formulation demerit.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natural-joint-support-supplement-non-gmo-gluten-free-1",
      "title": "Natural Joint Support Supplement - Non-GMO, Gluten-Free",
      "vendor": "Nutragole",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/81B3ptumDuL._AC_SL1500_d7c4ada4-598c-4441-918f-91b93f47da6c.jpg?v=1778343177",
      "score": 47,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "natural",
        "joint",
        "support",
        "supplement",
        "non",
        "gmo",
        "gluten",
        "free",
        "nutragole"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 49.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198103998661",
      "vsf_explanation": "RediMove '5 natural ingredients' with no ingredient identity or dose disclosure — 'scientifically shown' claim is unverifiable when contents are hidden. Sold through a third-party reseller. NY GMP facility is a positive, but formulation opacity dominates.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "redimind-natural-brain-booster-memory-support-vegan-30-capsules-1",
      "title": "RediMind – Natural Brain Booster & Memory Support (Vegan, 30 Capsules)",
      "vendor": "Nutragole",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71V1ldjSzBL._AC_SL1500_db0740f5-26fa-4934-bcb1-a7112764dab8.jpg?v=1778343212",
      "score": 52,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "redimind",
        "natural",
        "brain",
        "booster",
        "memory",
        "support",
        "vegan",
        "capsules",
        "nutragole"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 38,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198104129733",
      "vsf_explanation": "Alpha-GPC, huperzine A, bacopa monnieri, lion's mane and ginkgo — a well-known nootropic stack where individual ingredients have modest RCT support (Stough 2001 bacopa 300mg; Parker 2011 alpha-GPC). Claims 'clinically studied amounts' but listing does not disclose actual mg per ingredient.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ryze-mushroom-coffee-6-adaptogenic-mushrooms-organic-instant-coffee-mct-oil-better-energy-focus-digestion-immunity-cordyceps-lion-s-mane-shiitake-reishi-turkey-tail-king-trumpet",
      "title": "RYZE Mushroom Coffee | 6 Adaptogenic Mushrooms | Organic | Instant Coffee | MCT Oil | Better Energy, Focus, Digestion, Immunity | Cordyceps, Lion’s Mane, Shiitake, Reishi, Turkey Tail, King Trumpet",
      "vendor": "Nutragole",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ryze-mushroom-coffee-pack-of-3-6-adaptogenic-mushrooms-organic-instant-coffee-mct-oil-better-energy-focus-digestion-immunity-cordyceps-lions-mane-shiitake-reish-314353.webp?v=1778343212",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune",
        "gut",
        "mood",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ryze",
        "mushroom",
        "coffee",
        "adaptogenic",
        "mushrooms",
        "organic",
        "instant",
        "coffee",
        "mct",
        "oil",
        "better",
        "energy",
        "focus",
        "digestion",
        "immunity",
        "cordyceps",
        "lion",
        "mane",
        "shiitake",
        "reishi",
        "turkey",
        "tail",
        "king",
        "trumpet",
        "nutragole"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198104031429",
      "vsf_explanation": "2000 mg blend of 6 mushrooms (cordyceps, lion's mane, reishi, shiitake, turkey tail, king trumpet) as a single dose without per-mushroom breakdown — classic proprietary blend. Fruiting-body vs. mycelium not clearly disclosed. 27% beta-glucan claim is a positive quality signal but doesn't offset dose hiding.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "instaflex-advanced-joint-support-supplement-turmeric-resveratrol-boswellia-serrata-extract-bioperine-uc-ii-collagen-30-count-1",
      "title": "Instaflex Advanced Joint Support Supplement - Turmeric, Resveratrol, Boswellia Serrata Extract, BioPerine, UC-II Collagen- 30 Count",
      "vendor": "Nutragole",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/InstaflexAdvancedJointSupportSupplement_3fb2c945-8b27-4c4c-b6a2-c7672b60777a.jpg?v=1778343216",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint",
        "skin",
        "longevity",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "instaflex",
        "advanced",
        "joint",
        "support",
        "supplement",
        "turmeric",
        "resveratrol",
        "boswellia",
        "serrata",
        "extract",
        "bioperine",
        "collagen",
        "count",
        "nutragole"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198104162501",
      "vsf_explanation": "Solid joint stack: UC-II undenatured type II collagen (Lugo 2016 knee OA RCT at 40 mg/day), AprèsFlex boswellia, turmeric, resveratrol, BioPerine. Sold via a third-party reseller, so provenance is one hop removed and per-capsule mg for each active are not listed. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "skinceuticals-p-tiox-advanced-anti-wrinkle-peptide-serum",
      "title": "SkinCeuticals P‑TIOX – Advanced Anti‑Wrinkle Peptide Serum",
      "vendor": "Nutragole",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SkinCeuticals_P-TIOX_Anti-Wrinkle_Peptide_Serum_1_fl._oz..webp?v=1778343217",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "skinceuticals",
        "tiox",
        "advanced",
        "anti",
        "wrinkle",
        "peptide",
        "serum",
        "nutragole"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 70,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 109.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198104195269",
      "vsf_explanation": "SkinCeuticals is a top clinical-skincare brand; P-TIOX discloses 5% niacinamide + 5% PHA + 1% Laminaria + neuropeptide complex. Niacinamide 5% has RCT support for tone (Hakozaki 2002). Sold via a third-party reseller, which limits provenance verification and lifts the risk of gray-market inventory. Upper Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "stonehenge-health-dynamic-brain-supplement",
      "title": "Stonehenge Health Dynamic Brain Supplement",
      "vendor": "Nutragole",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71eROdzdUVL._AC_SL1500_f61cbb4a-80b8-4ece-be4c-c18e796d31b0.jpg?v=1778343217",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "stonehenge",
        "health",
        "dynamic",
        "brain",
        "supplement",
        "nutragole"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 58,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198104228037",
      "vsf_explanation": "Contains BacoMind — the branded bacopa extract with a published human safety trial (Pravina 2007) plus efficacy data (Stough 2001, Roodenrys 2002). Phosphatidylserine, huperzine A and choline round out a rational nootropic. USA cGMP + 3rd-party tested. Doses per ingredient not shown in listing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nugenix-total-t-supplement-for-men-180-count-1",
      "title": "Nugenix Total-T Supplement for Men, 180 Count",
      "vendor": "Nutragole",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71JJ7nqQfWL_4f7f3923-3475-4f25-a0c3-f0bff36b8c64.jpg?v=1778343216",
      "score": 57,
      "tier": "standard",
      "certifications": [
        "NSF Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "nugenix",
        "total",
        "supplement",
        "for",
        "men",
        "180",
        "count",
        "nutragole"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health",
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 62,
        "safety": 60,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198104260805",
      "vsf_explanation": "Testosterone-support blend led by Tesnor (Terminalia chebula/Withania), elevATP, and boron. Tesnor has one industry-sponsored RCT (Sharma J Diet Suppl 2020, modest total testosterone increase); elevATP is a peat/apple extract with limited independent trials. NSF-certified cGMP facility in Salt Lake City. Individual doses not shown in listing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "microbiome-labs-megasporebiotic-probiotics-for-women-men",
      "title": "Microbiome Labs MegaSporeBiotic Probiotics for Women & Men",
      "vendor": "Nutragole",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/61NMut6JLML.jpg?v=1778343217",
      "score": 75,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "microbiome",
        "labs",
        "megasporebiotic",
        "probiotics",
        "for",
        "women",
        "men",
        "nutragole"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive",
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 80,
        "formulation": 75,
        "manufacturing": 80,
        "safety": 75,
        "transparency": 70,
        "sustainability": 60
      },
      "price": 64.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198104359109",
      "vsf_explanation": "Five DNA-verified Bacillus spore strains (subtilis HU58, indicus HU36, licheniformis, clausii, coagulans). Human RCT by McFarlin 2017 showed MegaSporeBiotic reduced post-prandial endotoxemia by 42% in metabolically healthy adults. Practitioner-grade brand with shelf-stable spore delivery — a legitimate Verified probiotic; short of Elite because the specific strains have less depth than L. rhamnosus GG (Culturelle).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "amino-trim-drops",
      "title": "Amino Trim Drops",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/aminotrim-drops-benefits.webp?v=1778343315",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "amino",
        "trim",
        "drops",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198104850629",
      "vsf_explanation": "Sublingual amino-acid drops (L-Arginine, L-Glutamine, L-Tryptophan) marketed for cravings, fat loss, and metabolism. Sublingual delivery of these amino acids has no established PK advantage and 20 drops is well below the g-level doses used in weight/appetite RCTs (Coeffier 2010 glutamine, Cangiano 1998 tryptophan). Effectively sub-therapeutic.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "mycovital-mushroom-powder",
      "title": "MyCovital Mushroom Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/mycovital-mushroom-powder-benefits-featured.webp?v=1778343315",
      "score": 49,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mycovital",
        "mushroom",
        "powder",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198104916165",
      "vsf_explanation": "1.96 g scoop split across Reishi, Lion's Mane, Chaga, Cordyceps + 'adaptogens' — Lion's Mane cognition RCTs use ~3 g/day of Yamabushitake alone (Mori 2009). Total daily dose is sub-therapeutic across every mushroom. Rejected.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "reds-superfood",
      "title": "Reds Superfood",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/reds-superfood-benefits-featured.webp?v=1778343315",
      "score": 51,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "reds",
        "superfood",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198104981701",
      "vsf_explanation": "4 g scoop of beet, acai, inulin, lactobacillus — no CFU count on the probiotic and no polyphenol quant. Reds powders are typically a marketing category more than an evidence category. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "birch-chaga-truffles",
      "title": "Birch Chaga Truffles",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/birch-chaga-truffles-benefits-featured.webp?v=1778343315",
      "score": 39,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "birch",
        "chaga",
        "truffles",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 68,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198104948933",
      "vsf_explanation": "Birch chaga extract, flaxseed flour, dates, and pine bark in a truffle format. Chaga has in vitro antioxidant data but scant human RCT evidence for gut, mood, or immune claims. Chaga also carries oxalate/kidney concerns not disclosed. No doses provided.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "skin-hydration-cream",
      "title": "Skin Hydration Cream",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/skin-hydration-cream-benefits-featured.webp?v=1778343316",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "skin",
        "hydration",
        "cream",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198105014469",
      "vsf_explanation": "Hyaluronic acid + avocado oil + vitamin E cream. HA topical hydration is well-supported (Papakonstantinou 2012 review). Concentrations of HA (MW) and vitamin E are not shown; added fragrance oil is a mild negative for sensitive skin. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "greens-blend",
      "title": "Greens Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/greens-blend-benefits-featured.webp?v=1778343315",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "greens",
        "blend",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants",
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 35,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 20,
        "sustainability": 35
      },
      "price": 54,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198105112773",
      "vsf_explanation": "Powdered blend of ashwagandha, spirulina, chlorella, and wheatgrass with no doses per scoop. Greens powders lack whole-food fiber and evidence for meaningful nutrient repletion; ashwagandha dose here is unknown so its adaptogenic value cannot be relied on.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "pure3-100-whey-protein-isolate-chocolate-1",
      "title": "Pure3 100% Whey Protein Isolate (Chocolate)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/pure3-100-whey-protein-benefits-featured.webp?v=1778343315",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure3",
        "100",
        "whey",
        "protein",
        "isolate",
        "chocolate",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 78,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198105080005",
      "vsf_explanation": "Whey isolate + electrolytes, <5 g added sugar. Whey isolate at ~25 g/scoop is well-established for MPS (Phillips 2004), but the source dairy, filtration method, and third-party COA aren't disclosed. Standard — clean but generic isolate.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "normal-blood-sugar-drops",
      "title": "Normal Blood Sugar Drops",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/normal-blood-sugar-drops-feature.webp?v=1778343316",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "normal",
        "blood",
        "sugar",
        "drops",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 40,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198105047237",
      "vsf_explanation": "Cinnamon, bitter melon, turmeric, licorice, coriander, and resveratrol drops for 'normal blood sugar.' Licorice glycyrrhizin has known hypokalemia/hypertension risk with chronic use (Omar 2012) and no ceiling is disclosed. Multi-herb tincture with no per-ingredient mg.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "beetroot-powder-1",
      "title": "Beetroot Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/beetroot-powder-benefits-featured.webp?v=1778343316",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beetroot",
        "powder",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198105440453",
      "vsf_explanation": "5 g beetroot + hibiscus + apple juice per scoop, no nitrate quant. Beetroot RCTs use ~6.4 mmol nitrate (~500 mg/kg root) for BP effects (Siervo 2013) — this label doesn't tell you the nitrate content. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gentle-cleansing-gel",
      "title": "Gentle Cleansing Gel",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/gentle-cleansing-gel-benefits.webp?v=1778343316",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gentle",
        "cleansing",
        "gel",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 52,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198105178309",
      "vsf_explanation": "Fruit-extract + witch hazel gel cleanser. Botanical cleansers have mostly cosmetic-grade evidence; witch hazel astringent action is documented but concentration unlisted. Standard tier for a competent but undifferentiated cleanser.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "she-desire",
      "title": "She Desire",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/she-desire-benefits_76c7a45c-7653-440a-9a00-3ad8681b4bf7.webp?v=1778343315",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "she",
        "desire",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health",
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 35,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 20,
        "sustainability": 35
      },
      "price": 39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198105145541",
      "vsf_explanation": "Maca + L-arginine + zinc + BioPerine female libido stack with no per-ingredient doses. Maca sexual-function evidence is thin (Shin 2010 mostly in men); L-arginine female libido evidence limited. Undisclosed amounts prevent verification.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "sea-essence-omega-3-fish-oil",
      "title": "Sea Essence Omega 3 Fish Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/sea-essence-omega-3-fish-oil-benefits-img.webp?v=1778343316",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sea",
        "essence",
        "omega",
        "fish",
        "oil",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 30,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 25,
        "sustainability": 30
      },
      "price": 31.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198105407685",
      "vsf_explanation": "Omega-3 EPA/DHA has strong cardio evidence at 1-2 g EPA+DHA daily (Bernasconi 2020 meta-analysis), but Sea Essence discloses no EPA/DHA mg per softgel, no IFOS/GOED certification, and no sustainable sourcing (MSC/Friend of the Sea). Marine oil quality/oxidation not verified.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "sea-moss-complex",
      "title": "Sea Moss Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/sea-moss-complex-benefits-feature.webp?v=1778343320",
      "score": 33,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sea",
        "moss",
        "complex",
        "wow",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants",
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 20,
        "sustainability": 35
      },
      "price": 42,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198105473221",
      "vsf_explanation": "Irish moss + bladderwrack + burdock 'mineral' capsule. Sea-moss iodine content is highly variable and can exceed the tolerable upper limit (Zava 2011 seaweed iodine analysis showed 45x variance); no doses or iodine mcg disclosed. Human RCT evidence for sea moss supplementation is essentially absent.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "evening-relax-trio",
      "title": "EVENING RELAX TRIO",
      "vendor": "Ojais Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4A6B16B7-92B5-4059-B8B3-47619EA8F6FD.jpg?v=1778343388",
      "score": 41,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "evening",
        "relax",
        "trio",
        "ojais",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 71.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198107930821",
      "vsf_explanation": "Three-SKU bundle ('Sleep Support + Memory & Brain Support + Heart Support') with no ingredient disclosure on the bundle page. Cannot evaluate formulation without unit product data.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "inflammation-immune-detox-ritual",
      "title": "INFLAMMATION & IMMUNE DETOX RITUAL",
      "vendor": "Ritual",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/14F42F6F-FC64-493F-82CB-BB91428D1A4C.png?v=1778343388",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "inflammation"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "inflammation",
        "immune",
        "detox",
        "ritual",
        "ritual"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 47.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198107996357",
      "vsf_explanation": "Organic turmeric-ginger + chai. Turmeric RCTs (Daily 2016 meta-analysis) show anti-inflammatory effect at ~1 g/day curcumin with bioavailability enhancer; ginger has moderate anti-nausea evidence. No curcumin standardization or piperine disclosed. 'Detox' framing unsupported.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "male-vitality-testosterone-support",
      "title": "MALE VITALITY TESTOSTERONE SUPPORT",
      "vendor": "Ojais Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/photo_2026-02-25_10-53-17.webp?v=1778343388",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "male",
        "vitality",
        "testosterone",
        "support",
        "ojais",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 48,
        "safety": 55,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 27.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198107963589",
      "vsf_explanation": "Tongkat Ali (Eurycoma) + purified Shilajit + Fenugreek + Zinc — a well-evidenced ingredient set individually. Tambi 2012 (Andrologia) 200mg tongkat root extract raised free testosterone in hypogonadal men; Wilborn 2010 fenugreek 500mg raised bioavailable T. Product lists ingredients without mg, so we can't verify clinical dose thresholds. Bottom-of-Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cardio-wellness-duo",
      "title": "CARDIO WELLNESS DUO",
      "vendor": "Ojais Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4EE4886F-B4B6-4808-9866-D5E8180E1289.png?v=1778343388",
      "score": 41,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cardio",
        "wellness",
        "duo",
        "ojais",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 47.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198108029125",
      "vsf_explanation": "Bundle of 'Inflammation & Immune Support + Heart Support' without ingredient disclosure at bundle level. Cannot evaluate cardiovascular formulation.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "daily-strength-vitality-trio",
      "title": "DAILY STRENGTH & VITALITY TRIO",
      "vendor": "Ojais Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/IMG-5198.png?v=1778343388",
      "score": 41,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "daily",
        "strength",
        "vitality",
        "trio",
        "ojais",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 71.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198108094661",
      "vsf_explanation": "Turmeric-ginger + bone health + chai bundle. No per-SKU ingredients or doses on bundle listing.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "organic-chai",
      "title": "ORGANIC CHAI",
      "vendor": "Ojais Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitled_design_2_ffc4a840-60ef-442d-95be-5fdbbd495ae5.png?v=1778343388",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "chai",
        "ojais",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 23.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198108160197",
      "vsf_explanation": "Whole-spice organic chai (black tea + cardamom, cinnamon, ginger, clove, black pepper, fennel, ajwain, nutmeg). Clean single-ingredient list, but this is a beverage, not a dosed supplement; benefits are modest. Sits at Standard threshold.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lion-s-mane",
      "title": "LION’S MANE",
      "vendor": "Ojais Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MindFocus-01-25203b.jpg?v=1778343388",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lion",
        "mane",
        "ojais",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 50,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198108061893",
      "vsf_explanation": "Lion's mane + phosphatidylserine + BioPerine is a sensible cognitive combo; PS has mixed RCT support (Kato-Kataoka 2010) and lion's mane has one small trial (Mori 2009, 1000mg fruiting body). This listing discloses neither the mg dose, extract standardization, nor fruiting-body vs. mycelium — the key quality signals.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "memory",
      "title": "MEMORY",
      "vendor": "Ojais Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Memory-_3.jpg?v=1778343388",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "memory",
        "ojais",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 23.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198108127429",
      "vsf_explanation": "Ginkgo, ashwagandha, blueberry, L-theanine, plus B1/B6/B9/B12. Ginkgo cognition evidence is inconsistent (GEM Study 2008 was null for dementia prevention). No per-ingredient mg disclosed; small-brand (Ojais) with limited provenance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bone",
      "title": "BONE",
      "vendor": "Ojais Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Bone.jpg?v=1778343388",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bone",
        "ojais",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 40,
        "safety": 60,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 23.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198108192965",
      "vsf_explanation": "D3 + K2 + calcium + zinc is a sensible bone stack; D3+K2 combination has bone density RCT support (Knapen 2013). No mg per nutrient disclosed and no brand-of-K2 (e.g., MK-7 MenaQ7) specification, which matters for K2 bioavailability.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "morning-focus-ritual",
      "title": "MORNING FOCUS RITUAL",
      "vendor": "Ritual",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/EE5A63E5-C35D-447F-8DE6-E50B7890D287.png?v=1778343394",
      "score": 41,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "morning",
        "focus",
        "ritual",
        "ritual"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 59.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198109176005",
      "vsf_explanation": "'MindFocus + Chai' bundle with no ingredient disclosure for the MindFocus SKU. Cannot evaluate nootropic formulation.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "inflammation-immune-support",
      "title": "INFLAMMATION & IMMUNE SUPPORT",
      "vendor": "Ojais Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Inflammation.jpg?v=1778343393",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "inflammation"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "inflammation",
        "immune",
        "support",
        "ojais",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 35,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 23.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198109143237",
      "vsf_explanation": "Herbal blend of turmeric, ginger, black pepper, cinnamon, ajwain, and neem with no per-ingredient doses disclosed. While curcumin has RCT support (Hewlings 2017 review) at 500-1000 mg, hidden doses make efficacy unknowable. No third-party COAs, no cGMP disclosure, weak brand provenance.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "heart",
      "title": "HEART",
      "vendor": "Ojais Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Heart.jpg?v=1778343393",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "heart",
        "ojais",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 23.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198109208773",
      "vsf_explanation": "Magnesium + CoQ10 + L-taurine + hawthorn berry — a plausibly cardio-relevant stack, but zero individual milligram doses disclosed. CoQ10 needs 100-200 mg for measurable BP effects (Rosenfeldt J Hum Hypertens 2007); without dosing, no way to assess adequacy. Small brand with no third-party testing shown.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dietary-supplement-body-treatment",
      "title": "Dietary Supplement Body Treatment",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/45CD04FF23F7297D3224C09625B68AE1.jpg?v=1778343442",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dietary",
        "supplement",
        "body",
        "treatment",
        "digital",
        "presence"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 30,
        "manufacturing": 25,
        "safety": 25,
        "transparency": 15,
        "sustainability": 30
      },
      "price": 22.78,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198117630149",
      "vsf_explanation": "Anonymous vendor selling unspecified 'Chinese herbal extracts' as drops that 'permanently increase libido' - a hallmark of adulterated ED products (FDA has repeatedly recalled similar Amazon listings for hidden sildenafil analogs). No brand, no facility, no ingredient panel, no COA.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "food-supplement-body-treatment",
      "title": "Food Supplement Body Treatment",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BA1B4B42043FD0E6999EFF8EC5542150.jpg?v=1778343479",
      "score": 22,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "food",
        "supplement",
        "body",
        "treatment",
        "digital",
        "presence"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 15,
        "manufacturing": 15,
        "safety": 35,
        "transparency": 10,
        "sustainability": 20
      },
      "price": 22.78,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198128246981",
      "vsf_explanation": "Vague 'herbal ingredients' plus malt syrup/rock sugar/monk fruit with no dose disclosure, no clinical evidence, and dropshipper vendor with no manufacturing provenance. Marketing claims like 'strengthen the body' and 'improve body function' are non-specific.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "kick-ass-immune-activator",
      "title": "Kick-Ass Immune, Activator",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/KIKm1_656490185712_Kick-Ass_Immune_background_d901e68f-dc10-4091-a1f2-9da66b2df311.jpg?v=1778343502",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "kick",
        "ass",
        "immune",
        "activator",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 20,
        "sustainability": 45
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198128279749",
      "vsf_explanation": "Liquid herbal blend (echinacea/elderberry family per WishGarden line) delivered by pump with no mg-per-serving breakdown of active constituents. Herbal immune tinctures have modest evidence (e.g., Josling 2001 elderberry) but this specific formula lacks trial data or standardized markers.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "restorative-oil-arnica-st-johns-wort-calendula",
      "title": "Restorative Oil - Arnica, St. John's Wort & Calendula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ARSTPTm2_656490074726_RestorativeOil_2048px_background.jpg?v=1778343548",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "restorative",
        "oil",
        "arnica",
        "john",
        "wort",
        "calendula",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 65,
        "safety": 60,
        "transparency": 55,
        "sustainability": 65
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198128476357",
      "vsf_explanation": "Topical infused-oil of arnica, St. John's wort, and calendula in jojoba/camelina base. Topical arnica has modest RCT support for bruising and post-op soreness (Iannitti 2016 review). USDA organic, sustainably wild-crafted, external-use only. A well-made herbal topical rather than an ingestible supplement.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "attention-ally-focus-friend-for-kids",
      "title": "Attention Ally, Focus Friend for Kids",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ADDPTc2_656490171029_Attention_Ally_background_0925891e-6c73-425d-b613-340d306488ac.jpg?v=1778343547",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "youth_under_18",
      "tokens": [
        "attention",
        "ally",
        "focus",
        "friend",
        "for",
        "kids",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 65,
        "safety": 60,
        "transparency": 60,
        "sustainability": 65
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198128509125",
      "vsf_explanation": "Kid's herbal focus tincture with weight-based dosing (~1 pump per 20 lb). Herbal focus formulas have no pediatric RCT evidence; WishGarden is a USDA-organic, gluten-free vertically-integrated herbalist brand with clear dosing protocol and safety disclaimers. Standard tier because evidence is traditional-use, not clinical.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "rise-energize-daily-energy-boost",
      "title": "Rise & Energize, Daily Energy Boost",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/RISm1_656490364711_Rise_Energize_background_278f8d74-55d3-4460-8581-892178f3c34f.jpg?v=1778343553",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "rise",
        "energize",
        "daily",
        "energy",
        "boost",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic",
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 65,
        "safety": 60,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198128541893",
      "vsf_explanation": "Milky oats + gotu kola + yerba mate + maca daily energy tincture. Yerba mate contains ~85 mg caffeine per cup and has metabolic/cognitive evidence (Gawron-Gzella 2021); gotu kola has some anxiolytic RCT data. Won a 2022 Drug Store News OTC award. Standard because per-mL herb amounts are not published.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cranial-comfort-tension-release",
      "title": "Cranial Comfort, Tension Release",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/TENm1_656490743714_Cranial_Comfort_background_06c87c92-b20a-439c-af70-52d1b0d46dac.jpg?v=1778343553",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cranial",
        "comfort",
        "tension",
        "release",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 65,
        "safety": 60,
        "transparency": 50,
        "sustainability": 65
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198128705733",
      "vsf_explanation": "Herbal tincture (3 mL per serving, up to 10/day) for tension-type head discomfort. USDA-certified organic, vegan. Specific herb identities aren't shown in the body copy and no head-pain RCT data exists for this blend; scored Standard on brand quality rather than evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "party-prep-for-a-better-morning-after",
      "title": "Party Prep, For a Better Morning After",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/PARm1_656490124711_Party_Prep_background_68773101-bfcc-4936-ace5-b6c95d124c4b.jpg?v=1778343553",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "party",
        "prep",
        "for",
        "better",
        "morning",
        "after",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 65,
        "safety": 60,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198128640197",
      "vsf_explanation": "Prickly pear + Japanese raisin seed for alcohol-metabolism support. Wiese 2004 (Arch Intern Med) showed Opuntia ficus-indica extract 1600 IU pre-drinking cut hangover severity ~50% (n=55). Hovenia dulcis seed has extensive preclinical data on ALDH support. Standard because tincture doses of each botanical aren't disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "kick-ass-throat-spray",
      "title": "Kick-Ass Throat Spray",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/THRm1_656490188713_Kick-Ass_Throat_Spray_background_36e5858c-ef73-481a-a9ab-61d3aeb23b02.jpg?v=1778343553",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "kick",
        "ass",
        "throat",
        "spray",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 12.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198128836805",
      "vsf_explanation": "Liquid herbal throat spray with propolis, honeysuckle, sage, and marshmallow root from a 40-year established Colorado herbalist. Cohen 2004 propolis lozenge RCT reduced sore throat pain. Traditional simple formula, no numbing agents or stimulants. Standard-tier for evidence-limited but well-crafted herbal support.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "holy-basil",
      "title": "Holy Basil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/TULSPTs2_656490132723_Holy_Basil_background_731d11e6-5660-4182-9038-e74e2c008b5f.jpg?v=1778343553",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "holy",
        "basil",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198128804037",
      "vsf_explanation": "Ocimum sanctum (tulsi) liquid tincture, organically farmed in the Pacific Northwest. Cohen 2014 (J Ayurveda Integr Med) review found tulsi improved general stress markers and metabolic parameters across 24 RCTs. Single-herb format supports transparency; extract ratio and mL per pump withheld from listing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cotton-root-bark-tincture",
      "title": "Cotton Root Bark Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/COTFPTs2_656490221823_Cotton_Root_Bark_background_d65cefe8-3741-444f-abab-6751a7685359.jpg?v=1778343553",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cotton",
        "root",
        "bark",
        "tincture",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198128869573",
      "vsf_explanation": "Single-herb Gossypium root bark tincture from an established herbalist brand. Traditional use spans oxytocin support, uterine tonic, and postpartum applications; modern clinical RCTs are absent. Contraindicated in pregnancy (uterotonic history) — safety warning is present but could be more prominent. Low-Standard reflecting sparse evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "flow-stopper-lingering-cycle",
      "title": "Flow Stopper, Lingering Cycle",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/FLSPTw2_656490557229_Flow_Stopper_background_ba6dafd2-3010-41fd-86d5-b1615e1c3a62.jpg?v=1778343553",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "flow",
        "stopper",
        "lingering",
        "cycle",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 21.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198128902341",
      "vsf_explanation": "Astringent-herb formula (traditionally shepherd's purse, yarrow, etc.) for moderating menstrual flow and spotting. Traditional midwifery use is documented; modern RCT evidence is limited. Established brand + liquid format anchor a low-Standard score. Individuals with persistent bleeding should see a clinician.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "serious-am-cough-soothing-syrup",
      "title": "Serious AM Cough, Soothing Syrup",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/COSyPTm4_656490049748_Serious_Cough_AM_Soothing_Syrup_background_8575dada-1494-454b-b210-50d28377f9ac.jpg?v=1778343553",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "serious",
        "cough",
        "soothing",
        "syrup",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 16.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198128967877",
      "vsf_explanation": "Non-drowsy AM cough syrup with respiratory herbs to soothe bronchial irritation and normalize mucus. Herbal cough syrups have modest evidence (Wagner 2015 Cochrane herbal cough review found limited-quality RCTs). Established brand, gluten-free. Standard-tier for symptomatic support.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ladys-mantle",
      "title": "Lady's Mantle",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/LADTPTs2_656490166827_Lady_s_Mantle_Aerials_background_d59da821-ec11-4792-b10f-eb2cd4736c0f.jpg?v=1778343553",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lady",
        "mantle",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198129000645",
      "vsf_explanation": "Alchemilla vulgaris single-herb tincture for uterine tone, progesterone support, and menstrual regulation. Traditional European women's herb; modern RCTs are essentially absent. Established brand and clean single-herb format hold a low-Standard score.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "kick-ass-biotic-immune-force",
      "title": "Kick-Ass Biotic, Immune Force",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BIOm1_656490184715_Kick-Ass_Biotic_background_90961e5f-688b-4da8-87e6-c8ecff3eef7f.jpg?v=1778343553",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "kick",
        "ass",
        "biotic",
        "immune",
        "force",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198129098949",
      "vsf_explanation": "Multi-herb liquid immune formula for acute use, 3 mL every 1-3 hours up to 10x/day for 5 days. Contains echinacea-family herbs and antimicrobial botanicals (individual actives not detailed in copy). Karsch-Volk 2014 Cochrane found echinacea offered small benefit for common cold. Dosing regimen and pregnancy contraindication are clearly disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "angelica",
      "title": "Angelica",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ANGSPTs2_656490085821_Angelica_background_83d25fb8-4c1c-4aef-9308-407205362ebc.jpg?v=1778343553",
      "score": 51,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "angelica",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198129033413",
      "vsf_explanation": "Angelica archangelica single-herb tincture, positioned for digestion, circulation, and respiratory tone. Traditional bitters/aromatic use; RCT-quality evidence is scarce. Phototoxicity risk (furanocoumarins) should be flagged for topical exposure. Bottom-of-Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "genius-juice-cognitive-aid",
      "title": "Genius Juice, Cognitive Aid",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BRAm1_656490170718_Genius_Juice_background_c173e836-5fb5-405f-9697-875fbd7419ec.jpg?v=1778343553",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "genius",
        "juice",
        "cognitive",
        "aid",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 20,
        "sustainability": 45
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198129197253",
      "vsf_explanation": "Herbal cognitive tincture (bacopa/gotu kola style) advertised for focus and memory, but no per-herb doses, no standardized bacosides content, and no cognitive RCT of this exact blend. Bacopa evidence (Stough 2001) exists only at ~300 mg standardized extract, which cannot be verified here.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "elderberry-syrup-everyday-immunity-for-kids",
      "title": "Elderberry Syrup, Everyday Immunity for Kids",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ELKyPTc4_656490461045_Elderberry_Syrup_background_4f156fa8-7fde-4777-99a8-00b357296cdd.jpg?v=1778343553",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "youth_under_18",
      "tokens": [
        "elderberry",
        "syrup",
        "everyday",
        "immunity",
        "for",
        "kids",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 16.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198129066181",
      "vsf_explanation": "Elderberry + astragalus + orange peel + honey syrup for kids 19-38lb (3mL) or 39lb+ (6mL). Zakay-Rones 2004 (J Int Med Res) elderberry syrup reduced flu duration in adults; pediatric extrapolation is reasonable. Weight-based dosing is clearly disclosed and honey contraindication under 1 year is flagged.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cramp-bark",
      "title": "Cramp Bark",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CRMTPTs2_656490217826_Cramp_Bark_background_e6edeffc-7aec-444e-8df9-4bb1f170105a.jpg?v=1778343553",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cramp",
        "bark",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198129393861",
      "vsf_explanation": "Viburnum opulus (cramp bark) single-herb tincture for menstrual and postpartum uterine cramping. Traditional midwifery use is well-documented; small-scale antispasmodic in vitro data. RCTs are largely absent. Reasonable safety profile at recommended dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cycle-changes-peri-menopause",
      "title": "Cycle Changes, Peri/Menopause",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CYCPTw2_656490288222_Cycle_Changes_background_97eba5a8-bb44-4f68-a912-6a12f1100709.jpg?v=1778343553",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "postmenopausal",
      "tokens": [
        "cycle",
        "changes",
        "peri",
        "menopause",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 42,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 22,
        "sustainability": 45
      },
      "price": 21.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198129328325",
      "vsf_explanation": "Perimenopause herbal tincture with no ingredient list or standardized extract data in the listing. Black cohosh has modest hot-flash evidence (Wuttke 2003) but this specific blend has no data and no dose transparency.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "schisandra",
      "title": "Schisandra",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SDRSPTs2_656490282725_Schisandra_background_5b8b8a01-67b7-49ab-8cb8-38467b9567ae.jpg?v=1778343553",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "schisandra",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198129426629",
      "vsf_explanation": "Schisandra chinensis single-herb adaptogen tincture. Panossian 2008 (J Ethnopharmacol) review supports Schisandra as an adaptogen influencing HPA-axis stress markers. Bottom-of-Standard reflecting good ingredient class but sparse RCT dose evidence for tinctures specifically.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "scullcap",
      "title": "Scullcap",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SCUSPTs2_656490851822_Scullcap_background_3f440f5f-d515-4dec-9e36-f178909e5c7e.jpg?v=1778343553",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "scullcap",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198129557701",
      "vsf_explanation": "Scutellaria lateriflora (American skullcap) single-herb nervine tincture for tension and sleep. Brock 2014 (Phytother Res) small RCT of 350mg TID showed anxiolytic effect vs. placebo. Historic adulteration with Teucrium (hepatotoxic) is a known industry risk; sourcing/species verification not visible in copy.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "clear-complexion-blemish-control",
      "title": "Clear Complexion, Blemish Control",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/clear-complexion_10Z_GRY.jpg?v=1778343553",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "clear",
        "complexion",
        "blemish",
        "control",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 65,
        "safety": 60,
        "transparency": 55,
        "sustainability": 65
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198129459397",
      "vsf_explanation": "Oral/topical herbal blemish tincture with unspecified herb list in body copy. USDA organic, vegan, dual-use (ingested or dabbed on lesions). No RCT evidence for the blend, but WishGarden's herbalist provenance and product-award history support Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "black-cohosh",
      "title": "Black Cohosh",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BLCSPTs2_656490112824_Black_Cohosh_background_64bf415f-5cc9-45da-8f12-f3514e0a82ec.jpg?v=1778343553",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "black",
        "cohosh",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198129590469",
      "vsf_explanation": "Actaea racemosa (black cohosh) single-herb tincture for menopause and cycle support. Osmers 2005 (Obstet Gynecol) RCT with 40mg/day extract reduced Kupperman menopausal index. Standardized extract equivalence per pump isn't disclosed. Rare hepatotoxicity signal in case reports warrants clinician awareness for prolonged use.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "badass-bitters-digestive-aid",
      "title": "Badass Bitters, Digestive Aid",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BITm1_656490189710_Badass_Bitters_background_2b39812b-a9e4-4d78-b252-d2da7f8c0697.jpg?v=1778343553",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "badass",
        "bitters",
        "digestive",
        "aid",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 60,
        "manufacturing": 65,
        "safety": 60,
        "transparency": 60,
        "sustainability": 60
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198129623237",
      "vsf_explanation": "Pre-meal gentian-based bitters spray (3 sprays 15-20 min before meals). Gentian and other bitter herbs have long ethnobotanical use for stimulating saliva/bile and modest RCT support for functional dyspepsia (McMullen 2015). Clear timing/dose protocol and appropriate warnings; not for pregnancy.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "tart-cherry",
      "title": "Tart Cherry",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/TCHSPTs2_656490284729_Tart_Cherry_background_6306fca2-912c-4a32-b050-83b0b3639523.jpg?v=1778343564",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tart",
        "cherry",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental",
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 65,
        "safety": 60,
        "transparency": 60,
        "sustainability": 65
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198129787077",
      "vsf_explanation": "Single-herb tart cherry (Prunus cerasus) tincture. Losso 2018 RCT (n=20) showed Montmorency tart cherry juice improved sleep time by ~85 min and reduced insomnia severity; Howatson 2010 showed reduced muscle soreness post-marathon. Vegan tincture format delivers less anthocyanin dose than concentrate, so scored Standard rather than Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liquid-bliss-mood-elevator",
      "title": "Liquid Bliss, Mood Elevator",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BLISPTm2_656490138725_Liquid_Bliss_background_0c403f8f-fda1-44ec-a609-887f5851f21f.jpg?v=1778343565",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liquid",
        "bliss",
        "mood",
        "elevator",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 65,
        "safety": 60,
        "transparency": 50,
        "sustainability": 60
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198129819845",
      "vsf_explanation": "Short-term herbal mood tincture (3 mL every 1-3 hr, limit 7/day, max 5-day course). Not for pregnancy/breastfeeding. Ingredient list not shown in body copy and no efficacy RCT for the specific blend; scored Standard for WishGarden herbalist provenance and clear use limits.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "kick-ass-allergy-seasonal-rescue",
      "title": "Kick-Ass Allergy, Seasonal Rescue",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ALLm1_656490011714_Kick-Ass_Allergy_background_8df006ae-1f2f-43e8-8e3d-acc6d2bd9d28.jpg?v=1778343567",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "kick",
        "ass",
        "allergy",
        "seasonal",
        "rescue",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 12.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198129885381",
      "vsf_explanation": "Southwestern-tradition tincture with Yerba Santa, Nettle, and Echinacea for seasonal histamine and immune balance. Mittman 1990 nettle 300mg allergic rhinitis RCT showed modest symptomatic benefit vs. placebo. Non-drowsy, non-stimulating format. Individual mg per pump not disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dongge-ali-capsule-energy-supplement",
      "title": "Dongge Ali Capsule Energy Supplement",
      "vendor": "Berry Charmz",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6412149939394182D8690E8E34FE241D.jpg?v=1778343604",
      "score": 27,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dongge",
        "ali",
        "capsule",
        "energy",
        "supplement",
        "berry",
        "charmz"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 25,
        "manufacturing": 25,
        "safety": 35,
        "transparency": 20,
        "sustainability": 25
      },
      "price": 25.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198130213061",
      "vsf_explanation": "Tongkat ali (Eurycoma longifolia) dropship listing with template copy ('Not suitable for elderly, minors'). No standardization (eurycomanone %), no dose. Tongkat has moderate RCTs at 200-400 mg standardized (Talbott 2013). Reseller with no provenance.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "maca-capsule-male-nourishing-dietary-supplement",
      "title": "Maca Capsule Male Nourishing Dietary Supplement",
      "vendor": "American Smart",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CCB83C0D7F298E7917A3F1561D2E986C.jpg?v=1778343686",
      "score": 27,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood",
        "energy",
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "maca",
        "capsule",
        "male",
        "nourishing",
        "dietary",
        "supplement",
        "american",
        "smart"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 25,
        "manufacturing": 25,
        "safety": 35,
        "transparency": 20,
        "sustainability": 25
      },
      "price": 18.54,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198132244677",
      "vsf_explanation": "Maca + Epimedium (horny goat weed) dropship listing. Template copy, no manufacturer, no dose. Epimedium contains icariin with pharmacological effects (PDE5-like) that warrant safety labeling absent here.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "dietary-supplement-body-treatment-1",
      "title": "Dietary Supplement,Body Treatment",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/976171F5A3DECB83513F1B3E9D752FB7.jpg?v=1778343742",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dietary",
        "supplement",
        "body",
        "treatment",
        "digital",
        "presence"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 25,
        "manufacturing": 25,
        "safety": 30,
        "transparency": 15,
        "sustainability": 25
      },
      "price": 28.56,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198132637893",
      "vsf_explanation": "Generic 'health supplement capsules with glycerin and vitamin C' - glycerin is an excipient, not an active. No dose, no manufacturer, no brand. Effectively a mystery capsule.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "b-12-2-000mcg",
      "title": "B-12 2,000mcg",
      "vendor": "Country Life Natural Foods",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/B-12_2_000mcg-478000.png?v=1778343767",
      "score": 67,
      "tier": "standard",
      "certifications": [
        "Kosher"
      ],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "000mcg",
        "country",
        "life",
        "natural",
        "foods"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 70,
        "manufacturing": 70,
        "safety": 65,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 11.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198132867269",
      "vsf_explanation": "2000 mcg B-12 lozenge with three forms including active methylcobalamin and dibencozide (adenosylcobalamin) — the two coenzyme forms preferred over cyanocobalamin. Manufactured by NOW Foods (in-house UL-audited lab). B12 evidence for deficiency correction is unambiguous (Stabler 2013); scored Standard because the product isn't Elite-tier third-party tested.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "methyl-b-12-1-000mcg",
      "title": "Methyl B-12 1,000mcg",
      "vendor": "Country Life Natural Foods",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Methyl_B-12_1_000mcg-985166.png?v=1778343773",
      "score": 64,
      "tier": "standard",
      "certifications": [
        "GMP Certified",
        "Kosher"
      ],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "methyl",
        "000mcg",
        "country",
        "life",
        "natural",
        "foods"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 65,
        "safety": 70,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 10.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198132900037",
      "vsf_explanation": "1000 mcg methylcobalamin lozenge - active methyl form, transparent dose, evidence-based for pernicious anemia and neurological maintenance (Andres 2004). Country Life is an established supplement brand with NPA A-rated GMP certification; upper Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "b-12-liquid-b-complex",
      "title": "B-12 Liquid B Complex",
      "vendor": "Country Life Natural Foods",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/B-12_Liquid_B_Complex-138922.png?v=1778343778",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liquid",
        "complex",
        "country",
        "life",
        "natural",
        "foods"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 60,
        "safety": 75,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 8.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198132932805",
      "vsf_explanation": "Cyanocobalamin-form B-12 with folic acid; clear ingredient disclosure and mechanistic support for homocysteine metabolism. Cyanocobalamin is the less-bioavailable form vs methylcobalamin (Paul 2017), and the FDA quote itself notes cardiovascular evidence is inconclusive. Adequate but not premium.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-vitamin-b-12-1000-mcg-supports-energy-metabolism-200-coated-tablets",
      "title": "Nature's Bounty Vitamin B-12 1000 Mcg, Supports Energy Metabolism 200 Coated Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/305326345.png?v=1778343781",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "vitamin",
        "1000",
        "mcg",
        "supports",
        "energy",
        "metabolism",
        "200",
        "coated",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 62,
        "sustainability": 45
      },
      "price": 15.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198132965573",
      "vsf_explanation": "Mainstream single-ingredient B12 (cyanocobalamin 1000 mcg). Well above RDA and clinically effective for deficiency correction (Andres 2005). Cyanocobalamin is less bioavailable than methyl/hydroxo forms but standard OTC form. Nature's Bounty (Nestle Health Science) has established GMP. Solid Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sundance-vitamins-b-12-tbs-1000mcg-150",
      "title": "Sundance Vitamins B-12 Tbs 1000Mcg 150",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/97180313_4024dd56-543c-4a95-b64c-073ae6c035cb.jpg?v=1778343791",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sundance",
        "vitamins",
        "tbs",
        "1000mcg",
        "150",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 75,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 10.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198132998341",
      "vsf_explanation": "1000 mcg B-12 (likely cyanocobalamin) plus folic acid at a therapeutic dose for deficiency correction; body copy mentions 25,000 mcg which is inconsistent with the label and hurts transparency. Adequate house-brand vitamin at commodity quality; no third-party testing disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-truth-vitamin-b-12-500-mcg-tablets",
      "title": "Nature's Truth Vitamin B 12, 500 Mcg, Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/82886469_d9fb4f9e-ead9-4c71-8b6e-39a7c1a5f1c0.jpg?v=1778343803",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "truth",
        "vitamin",
        "500",
        "mcg",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 48,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 7.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198133031109",
      "vsf_explanation": "B12 cyanocobalamin at 500 mcg per tablet is a well-established, clinically effective dose for maintenance and repletion (Vidal-Alaball 2005 Cochrane review). Cyano form must be converted in vivo, so methylcobalamin would be superior. Non-GMO, gluten-free formula but limited third-party verification and generic OTC positioning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-truth-time-released-1000-mcg-vitamin-b-12-75-tablets",
      "title": "Nature's Truth Time Released 1000 Mcg  Vitamin B-12  75 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/82885575_5378284f-b4d4-40fa-bb5f-564218a3b41a.jpg?v=1778343831",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "truth",
        "time",
        "released",
        "1000",
        "mcg",
        "vitamin",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 65,
        "safety": 68,
        "transparency": 58,
        "sustainability": 42
      },
      "price": 9.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198133588165",
      "vsf_explanation": "Nature's Truth B12 1000 mcg time-released, Non-GMO, free of major allergens. Time-release matrix is marketing-forward for a water-soluble vitamin. Established mid-tier brand. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "windmill®-vitamin-b-12-3000-mcg-high-potency-quick-melt-tablets",
      "title": "Windmill® Vitamin B-12 3000 mcg – High Potency Quick Melt Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/350438612_20ae9707-e432-4c12-bd2e-f0f52b4b95aa.jpg?v=1778343839",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "windmill",
        "vitamin",
        "3000",
        "mcg",
        "high",
        "potency",
        "quick",
        "melt",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 10.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198133719237",
      "vsf_explanation": "Methylcobalamin (bioactive form) at 3,000 mcg sublingual quick-melt is well-suited for absorption, particularly in older adults with intrinsic-factor decline (Andres 2005 CMAJ). Dose is disclosed, form is superior to cyano. Retail-tier brand with limited COA disclosure keeps this in Standard territory.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ashwagandha-for-women",
      "title": "Ashwagandha For Women",
      "vendor": "Fit Dad Community",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ed34e46b-f1bb-4168-bebd-45045318fd74.jpg?v=1778343877",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "ashwagandha",
        "for",
        "women",
        "fit",
        "dad",
        "community"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental",
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198133981381",
      "vsf_explanation": "Ashwagandha has legitimate cortisol/stress research (Chandrasekhar Indian J Psychol Med 2012 — 300 mg KSM-66 twice daily lowered cortisol and PSS). This listing discloses no dose, no extract standardization (KSM-66, Sensoril, root vs whole plant), and no third-party testing — impossible to verify a clinically active dose reaches the user.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nm-ashwagandha-cp-60",
      "title": "NM Ashwagandha Cp  60",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/302801357_1cccfa6d-2867-4132-b6fd-ff2a8cbc1463.jpg?v=1778343893",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ashwagandha",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 80,
        "formulation": 72,
        "manufacturing": 78,
        "safety": 75,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 21.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198134014149",
      "vsf_explanation": "Nature Made ashwagandha using Sensoril standardized extract (10% withanolides), the strain used in RCTs like Auddy 2008 and Salve 2019 showing reduced cortisol and perceived stress at 125-600 mg/day. Nature Made is USP Verified across most SKUs. Solid evidence-backed formulation and reputable USP manufacturing lift this well into Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nwy-ashwagandha-cp-60caps",
      "title": "Nwy Ashwagandha, Cp 60Caps",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/324522619.jpg?v=1778343899",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nwy",
        "ashwagandha",
        "60caps",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 55,
        "manufacturing": 68,
        "safety": 70,
        "transparency": 55,
        "sustainability": 52
      },
      "price": 19.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198134079685",
      "vsf_explanation": "Nature's Way Ashwagandha (500 mg root, non-standardized per typical SKU). Ashwagandha stress RCTs (Chandrasekhar 2012) used 300 mg KSM-66 standardized to 5% withanolides. Nature's Way is TRU-ID verified; formulation is basic root powder. Established brand keeps it Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ashwazen-organic-ashwagandha-60-count",
      "title": "AshwaZen Organic Ashwagandha | (60 Count)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ashwazen-organic-ashwagandha-capsules-adaptogen-for-stress-support-with-black-pepper-60-count-7732100.jpg?v=1778343910",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ashwazen",
        "organic",
        "ashwagandha",
        "count",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 23.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198134112453",
      "vsf_explanation": "Organic ashwagandha root + black pepper extract for absorption; ashwagandha reduces perceived stress and cortisol in multiple RCTs (Chandrasekhar 2012; Lopresti 2019). Extract type (KSM-66 vs Sensoril vs generic) and withanolide standardization not stated — keeps this below Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "provenix-dietary-supplement-60-capsules",
      "title": "Provenix Dietary Supplement | 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/provenix-prostate-support-7778716.jpg?v=1778344042",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "provenix",
        "dietary",
        "supplement",
        "capsules",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 22.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198134440133",
      "vsf_explanation": "Saw palmetto + pygeum + pumpkin seed + nettle + lycopene — a standard men's prostate stack. Saw palmetto has mixed BPH evidence (Tacklind 2012 Cochrane: modest urinary symptom improvement). This label does not state the saw palmetto extract standardization (85-95% fatty acids typical) or mg per capsule.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "slumbra-sleep-formula-dietary-supplement-to-support-restful-sleep-60-count",
      "title": "Slumbra Sleep Formula |Dietary Supplement to Support Restful Sleep | 60 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/slumbra-sleep-formula-3480319.jpg?v=1778344042",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "slumbra",
        "sleep",
        "formula",
        "dietary",
        "supplement",
        "support",
        "restful",
        "sleep",
        "count",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 50,
        "manufacturing": 50,
        "safety": 50,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 21.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198134538437",
      "vsf_explanation": "Seven-ingredient sleep stack (valerian, melatonin, GABA, L-tryptophan, chamomile, lemon balm, passionflower). Melatonin has clear RCT evidence for sleep latency (Ferracioli-Oda 2013 meta-analysis) but seven-actives-in-one-cap typically underdoses each. Per-item mg not disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "veluna-va-pure3-whey-protein-isolate-powder-24-1oz-683g",
      "title": "Veluna VA Pure3 Whey Protein Isolate Powder |24.1oz (683g)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/veluna-va-pure3-100-whey-protein-isolate-powder-vanilla-5429037.jpg?v=1778344042",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "veluna",
        "pure3",
        "whey",
        "protein",
        "isolate",
        "powder",
        "1oz",
        "683g",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 62.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198134571205",
      "vsf_explanation": "100% whey protein isolate (>90% protein by weight), vanilla, USA-made. Whey isolate is the most consistent MPS-driving protein source (Morton 2018 BJSM meta-analysis). No third-party heavy-metal COA disclosed; grams per scoop not detailed in copy.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "titan-men-s-vitality-supplement-60-count",
      "title": "Titan Men’s Vitality Supplement | 60 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/titan-mens-vitality-supplement-2908052.jpg?v=1778344046",
      "score": 41,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "titan",
        "men",
        "vitality",
        "supplement",
        "count",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health",
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 28.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198134603973",
      "vsf_explanation": "Tongkat ali + maca + L-arginine + ginseng + zinc + B12 + explicit 'proprietary herbal blend.' Tongkat ali (Talbott 2013, 200 mg) has some testosterone/mood evidence but individual doses here are hidden inside a stated proprietary blend. Made-in-USA claim without cGMP/COA documentation.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "muscora-l-glutamine-powder-muscle-recovery-immune-support-300g",
      "title": "Muscora L-Glutamine Powder | Muscle Recovery & Immune Support | 300g",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/muscora-l-glutamine-powder-7043265.jpg?v=1778344046",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "muscora",
        "glutamine",
        "powder",
        "muscle",
        "recovery",
        "immune",
        "support",
        "300g",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids",
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 70,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 30.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198134669509",
      "vsf_explanation": "Pure pharmaceutical-grade L-glutamine, no fillers/sweeteners — a clean single-ingredient product. Evidence is strongest for gut permeability in stressed states (van Zanten 2020 critical care) and immune support in overtraining (Castell 2002); recreational muscle recovery benefits are modest (Legault 2015 RCT: no strength benefit vs placebo). USA cGMP manufacturing claimed, but no COA or third-party verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "serenis-ayurvedic-complex-herbal-capsules-60-count",
      "title": "Serenis Ayurvedic Complex |Herbal Capsules | 60 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/serenis-ayurvedic-complex-5419284.jpg?v=1778344046",
      "score": 42,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "serenis",
        "ayurvedic",
        "complex",
        "herbal",
        "capsules",
        "count",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 45,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 30.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198134735045",
      "vsf_explanation": "Blends 20+ botanicals (Ashwagandha, Turmeric 95% curcuminoids, Bacopa, Shilajit, Cordyceps) — individually each has some evidence (Chandrasekhar 2012 ashwagandha stress RCT; Roodenrys 2002 Bacopa cognitive), but throwing all together with no individual doses violates therapeutic-dosing principles. Shilajit heavy-metal concerns absent from spec.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "vireva-chaga-mushroom-gut-immune-support-60-count",
      "title": "Vireva Chaga Mushroom | Gut & Immune Support | 60 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/vireva-chaga-mushroom-2130903.jpg?v=1778344046",
      "score": 45,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "immune",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vireva",
        "chaga",
        "mushroom",
        "gut",
        "immune",
        "support",
        "count",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants",
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198134636741",
      "vsf_explanation": "Chaga (Inonotus obliquus) mycelium powder — not fruiting body — standardized to 40% polysaccharides. Mycelium-on-grain products are widely criticized because 'polysaccharide' assays capture grain starch, not beta-glucans (Chilton 2015 mushroom industry analysis). Human RCT evidence for chaga is essentially absent. Fails on formulation quality.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "poornavita-complete-multivitamin-for-men-prostate-immune-support-60-capsules",
      "title": "PoornaVita Complete Multivitamin for Men | Prostate & Immune Support | 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/poornavita-complete-multivitamin-supplement-for-men-2359629.jpg?v=1778344046",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune",
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "poornavita",
        "complete",
        "multivitamin",
        "for",
        "men",
        "prostate",
        "immune",
        "support",
        "capsules",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 27.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198134702277",
      "vsf_explanation": "Generic men's multivitamin with '25+ essential nutrients' but no supplement facts panel or per-nutrient doses in the listing. Multivitamin efficacy for prostate/immune outcomes is weak in trials like COSMOS (Sesso 2022). Unverified brand with no third-party testing or standardized botanical extracts.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "luna-womens-vitality-supplement-energy-wellness-support-capsules-60-count",
      "title": "Luna Women's Vitality Supplement | Energy & Wellness Support Capsules | 60 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/luna-female-enhancement-3372054.jpg?v=1778344046",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "luna",
        "women",
        "vitality",
        "supplement",
        "energy",
        "wellness",
        "support",
        "capsules",
        "count",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 30,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198134800581",
      "vsf_explanation": "Kitchen-sink formula with 20+ ingredients (B-complex, ashwagandha, Asian ginseng, L-arginine, zinc) that cannot deliver clinical doses in two capsules. Ashwagandha RCTs (Chandrasekhar 2012, Lopresti 2019) use 300-600 mg/day KSM-66 alone; this format almost certainly sub-therapeutic. Matevara is a generic Shopify vendor with no cGMP or third-party testing disclosed.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "premium-lions-mane-mushroom-vegan-capsules-60-count",
      "title": "Premium Lion's Mane Mushroom | Vegan Capsules | 60 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/wise-lions-mane-mushroom-6504426.jpg?v=1778344047",
      "score": 56,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "premium",
        "lion",
        "mane",
        "mushroom",
        "vegan",
        "capsules",
        "count",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 38.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198134833349",
      "vsf_explanation": "Certified organic Lion's Mane with fruiting body + mycelium, standardized to 40% polysaccharides at 400 mg/serving — better than most powdered mycelium-on-grain products. Clinical evidence is limited but positive (Mori 2009 RCT: 250 mg tid improved cognition in mild cognitive impairment). Hericenone/erinacine content not quantified; polysaccharide % is beta-glucan indirect proxy.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "clarity-daily-support-capsules-digestive-wellness-formula-60-count",
      "title": "Clarity Daily Support Capsules | Digestive Wellness Formula | 60 count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/clarity-max-detox-acai-berry-complex-9424620.jpg?v=1778344047",
      "score": 42,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "clarity",
        "daily",
        "support",
        "capsules",
        "digestive",
        "wellness",
        "formula",
        "count",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 28.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198134931653",
      "vsf_explanation": "Psyllium fiber and inulin have solid evidence (McRorie 2015; Slavin 2013), but Clarity mixes them with acai, chlorella, and a proprietary herb blend at undisclosed doses in a single capsule too small for effective psyllium dosing (>5 g needed per Anderson 2009).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "rubina-organic-beetroot-capsules-vegetarian-supplement-60-count",
      "title": "Rubina Organic Beetroot Capsules |Vegetarian Supplement | 60 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/rubina-beetroot-3633467.jpg?v=1778344046",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "rubina",
        "organic",
        "beetroot",
        "capsules",
        "vegetarian",
        "supplement",
        "count",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 23.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198134866117",
      "vsf_explanation": "Beetroot dietary nitrates support blood pressure and exercise economy (Siervo 2013 meta-analysis: ~4 mmHg SBP reduction). This is powder in vegetarian capsules — nitrate content per capsule is unknown and typically an order of magnitude below the ~400 mg nitrate seen in RCTs. USDA organic and US manufacture noted.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sunex-vitamin-d3-2-000-iu-supports-bone-health-immunity-100-count",
      "title": "Sunex Vitamin D3 2,000 IU |Supports Bone Health & Immunity | 100 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/sunex-suvitamin-d3-2000-iu-2888208.jpg?v=1778344047",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sunex",
        "vitamin",
        "000",
        "supports",
        "bone",
        "health",
        "immunity",
        "100",
        "count",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients",
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 40
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198134898885",
      "vsf_explanation": "D3 (cholecalciferol) at 2,000 IU is a well-supported daily dose for maintaining serum 25(OH)D >30 ng/mL (Autier & Gandini 2007; Heaney 2003). Softgel form is bioavailable. Lacks K2 pairing (Schwalfenberg 2017 argues for co-supplementation to direct calcium), no third-party testing disclosed, and no D3 source (lanolin vs lichen) specified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "biotex-probiotic-enzyme-formula-60-count",
      "title": "Biotex Probiotic & Enzyme Formula | 60 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/biotex-digestive-support-9548983.jpg?v=1778344047",
      "score": 56,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "biotex",
        "probiotic",
        "enzyme",
        "formula",
        "count",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198135029957",
      "vsf_explanation": "Names strain-specific probiotic (Lactobacillus acidophilus LA85) and licensed enzyme complex (DigeZyme) — better transparency than most. However single-strain probiotic has narrower evidence than multi-strain (Kligler 2008), CFU count is unstated, and ACV powder is trivial dose. Inulin prebiotic evidence solid (Roberfroid 2010).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "clenora-daily-fiber-support-powder-for-gut-health-regularity-30-servings",
      "title": "Clenora Daily Fiber Support Powder for Gut Health & Regularity | 30 Servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/clenora-daily-fiber-support-4661954.jpg?v=1778344046",
      "score": 52,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "clenora",
        "daily",
        "fiber",
        "support",
        "powder",
        "for",
        "gut",
        "health",
        "regularity",
        "servings",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 40.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198134964421",
      "vsf_explanation": "Sachet fiber blend of psyllium husk, ginger, tamarind, and digestive enzymes. Psyllium is a first-line fiber for constipation, IBS, and cholesterol (McRorie 2015 review); ginger has modest gastric-emptying RCT support. Body copy doesn't publish grams of psyllium per sachet, capping this at Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pranabolt-blood-sugar-support-glucose-metabolism-capsules-60-count",
      "title": "PranaBolt Blood Sugar Support | Glucose Metabolism Capsules | 60 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/pranabolt-normal-blood-sugar-support-6860191.jpg?v=1778344047",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pranabolt",
        "blood",
        "sugar",
        "support",
        "glucose",
        "metabolism",
        "capsules",
        "count",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 32,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 28.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198134997189",
      "vsf_explanation": "18-ingredient glucose formula (chromium, biotin, cinnamon, gymnema, bitter melon, banaba, berberine implied) that cannot fit clinical doses in a 2-cap serving. Berberine trials (Yin 2008, Dong 2012) use 900-1500 mg/day; gymnema uses 400 mg standardized (Baskaran 1990). A blend this size cannot deliver those. No third-party testing disclosed by Matevara.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "restora-magnesium-glycinate-90-vegetarian-capsules",
      "title": "Restora Magnesium Glycinate | 90 Vegetarian Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/restora-magnesium-glycinate-1428169.jpg?v=1778344047",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "restora",
        "magnesium",
        "glycinate",
        "vegetarian",
        "capsules",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients",
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 70,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 28.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198135062725",
      "vsf_explanation": "Magnesium glycinate is the preferred chelate for sleep, cramp, and stress support with strong bioavailability profile (Walker 2003; Boyle 2017 review) and low GI upset vs oxide. Elemental mg per capsule not disclosed (typical products deliver only 100-200mg elemental; RDA is 320-420mg). No USP or NSF verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "plantora-plant-protein-powder-29-77-oz",
      "title": "Plantora Plant Protein Powder | 29.77 oz",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/plantora-plant-protein-powder-vanilla-2338852.jpg?v=1778344048",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "plantora",
        "plant",
        "protein",
        "powder",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 62.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198135161029",
      "vsf_explanation": "20 g protein/serving from fava bean isolate (Tendra) + fermented yeast protein (YESTEIN) — provides all essential amino acids (Gorissen 2018 plant protein leucine analysis). Stevia sweetened, no soy/dairy/gluten. Leucine content not disclosed (need ~2.5g for MPS trigger); no Informed Sport or heavy-metal testing shown for plant protein (Clean Label Project has flagged plant proteins for lead/cadmium).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "provara-ch-pure3-100-whey-protein-isolate-24-7-oz",
      "title": "Provara - CH Pure3 100% Whey Protein Isolate | 24.7 oz",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/provara-ch-pure3-100-whey-protein-isolate-chocolate-8676268.jpg?v=1778344049",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "provara",
        "pure3",
        "100",
        "whey",
        "protein",
        "isolate",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 70,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 62.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198135193797",
      "vsf_explanation": "Three-ingredient whey isolate (WPI + natural chocolate flavor + stevia), transparent minimalist formulation. Whey isolate at ~25-30 g/serving is the reference standard for MPS (Morton 2018 meta). No third-party heavy-metal testing (Clean Label Project) or leucine content disclosed, which is why it lands upper Standard rather than Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "flexera-joint-support-joint-flexibility-comfort-supplement-60-vegan-capsules",
      "title": "Flexera Joint Support | Joint Flexibility & Comfort Supplement | 60 Vegan Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/flexera-joint-support-msm-glucosamine-turmeric-joint-flexibility-comfort-supplement-60-vegan-capsules-2578348.jpg?v=1778344050",
      "score": 54,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "flexera",
        "joint",
        "support",
        "joint",
        "flexibility",
        "comfort",
        "supplement",
        "vegan",
        "capsules",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 21.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198135226565",
      "vsf_explanation": "Vegan formula built on GlucosaGreen (fermented plant-based glucosamine HCl) — a shellfish-free alternative used in RCT for knee OA (D'Amico 2016). Glucosamine hydrochloride evidence is more mixed than sulfate (Runhaar 2017 individual-patient meta-analysis), and product body copy doesn't disclose per-cap mg.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cardeva-resveratrol-600mg-capsules-vegan-capsules-60-count",
      "title": "Cardeva Resveratrol 600mg Capsules |Vegan Capsules | 60 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cardeva-resveratrol-600mg-capsules-antioxidant-cardiovascular-support-50-trans-resveratrol-60-count-3713007.jpg?v=1778344050",
      "score": 55,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "longevity",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cardeva",
        "resveratrol",
        "600mg",
        "capsules",
        "vegan",
        "capsules",
        "count",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular",
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198135259333",
      "vsf_explanation": "600 mg resveratrol per serving from Polygonum cuspidatum, standardized to 50% trans-resveratrol (i.e., ~300 mg active trans-resveratrol — dose actually disclosed). Human evidence is modest (Timmers 2011 metabolic effects at 150 mg); oral bioavailability is poor (~1%). Reasonable Standard-tier for a real dose from a plant-based extract.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "elastiva-v-grass-fed-collagen-creamer-vanilla-flavor-dietary-supplement-powder",
      "title": "Elastiva V Grass-Fed Collagen Creamer, Vanilla Flavor |Dietary Supplement Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/elastiva-v-grass-fed-collagen-creamer-vanilla-powder-types-i-iii-for-skin-hair-joint-wellness-240g-2578494.jpg?v=1778344050",
      "score": 56,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "elastiva",
        "grass",
        "fed",
        "collagen",
        "creamer",
        "vanilla",
        "flavor",
        "dietary",
        "supplement",
        "powder",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 47.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198135292101",
      "vsf_explanation": "Grass-fed bovine collagen Types I & III (hydrolyzed peptides) + MCT oil + pea protein, vanilla creamer format. Zague 2011 (J Med Food) and Proksch 2014 (Skin Pharmacol Physiol) support 2.5-10g/day hydrolyzed collagen for skin elasticity and hydration. Peptide grams per scoop and MCT source not disclosed on listing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "floresta-probiotic-40-billion-cfu-with-prebiotics-60-vegan-capsules",
      "title": "Floresta Probiotic 40 Billion CFU with Prebiotics | 60 Vegan Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/floresta-probiotic-40-billion-cfu-with-prebiotics-digestive-immune-support-4-strain-formula-60-vegan-capsules-1146171.jpg?v=1778344053",
      "score": 54,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "floresta",
        "probiotic",
        "billion",
        "cfu",
        "with",
        "prebiotics",
        "vegan",
        "capsules",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 28.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198135324869",
      "vsf_explanation": "40B CFU of L. acidophilus, B. lactis, L. plantarum, L. paracasei with prebiotic fiber and MAKTREK Bi-Pass acid-resistance tech. Genus/species disclosed but not the strain identifiers that drive clinical evidence (e.g., L. plantarum 299v). Culturelle-tier probiotics disclose specific strains; without those, Standard rather than Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cellvia-nad-500mg-cellular-energy-metabolism-quercetin-resveratrol-60-ct",
      "title": "Cellvia NAD+ 500mg: Cellular Energy, Metabolism, Quercetin & Resveratrol | 60 Ct",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cellvia-nad-cellular-metabolism-support-5399070.jpg?v=1778344053",
      "score": 45,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "longevity",
        "energy",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cellvia",
        "nad",
        "500mg",
        "cellular",
        "energy",
        "metabolism",
        "quercetin",
        "resveratrol",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular",
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198135357637",
      "vsf_explanation": "Direct oral NAD+ has poor bioavailability — it is degraded to nicotinamide in gut (Trammell 2016). Precursors like NR (Martens 2018) or NMN (Yoshino 2021) are the researched forms. Resveratrol and quercetin oral bioavailability is <5% (Walle 2004). 500mg NAD+ claim is marketing-first.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "omneva-omega-3-fish-oil-heart-brain-support-100-count",
      "title": "Omneva Omega-3 Fish Oil |Heart & Brain Support | 100 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/omneva-omega-3-epa-180mg-dha-120mg-4794973.jpg?v=1778344053",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "omneva",
        "omega",
        "fish",
        "oil",
        "heart",
        "brain",
        "support",
        "100",
        "count",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart",
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 35
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198135390405",
      "vsf_explanation": "180 mg EPA + 120 mg DHA per serving is well below therapeutic 1000-2000 mg EPA+DHA for cardio benefit (Bernasconi 2020 meta-analysis; AHA guidelines). Vitamin E freshness stabilizer is a positive. No IFOS 5-star rating or oxidation TOTOX values, no sustainable sourcing certification.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "oxivra-nitric-oxide-booster-circulation-muscle-support-60-count",
      "title": "Oxivra Nitric Oxide Booster | Circulation & Muscle Support | 60 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/oxivra-nitric-oxide-5143553.jpg?v=1778344055",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "oxivra",
        "nitric",
        "oxide",
        "booster",
        "circulation",
        "muscle",
        "support",
        "count",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 42,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 40,
        "sustainability": 42
      },
      "price": 23.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198135455941",
      "vsf_explanation": "L-Arg AKG plus L-Cit malate combo has some support (Bailey 2015 showed 6-8 g citrulline improves flow-mediated dilation), but capsule formats rarely deliver enough. No per-serving grams disclosed, and heart-failure L-arg trials (Schulman 2006 VINTAGE-NO) actually raised mortality, so safety framing is thin. Generic Matevara branding with no third-party testing.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "nexus-berberine-hcl-supplement-60-count",
      "title": "Nexus Berberine HCL Supplement | 60 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/nexus-berberine-2784156.jpg?v=1778344055",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nexus",
        "berberine",
        "hcl",
        "supplement",
        "count",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 48,
        "sustainability": 45
      },
      "price": 27.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198135488709",
      "vsf_explanation": "Berberine at 97% standardization is a reasonable single-active formulation with solid evidence (Yin 2008 showed 500 mg TID matched metformin in T2D; Dong 2012 meta-analysis confirmed A1c reductions). Dose per capsule not disclosed in copy, and Matevara has no third-party testing or cGMP callout. Berberine's CYP3A4 inhibition warrants stronger drug-interaction messaging.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "elastiva-c-grass-fed-collagen-powder-chocolate-flavor",
      "title": "Elastiva C Grass-Fed Collagen Powder, Chocolate Flavor |",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/elastiva-c-grass-fed-collagen-peptides-powder-chocolate-types-i-iii-for-skin-hair-joint-wellness-378g-1018299.jpg?v=1778344054",
      "score": 55,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "elastiva",
        "grass",
        "fed",
        "collagen",
        "powder",
        "chocolate",
        "flavor",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty",
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 47.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198135521477",
      "vsf_explanation": "Hydrolyzed bovine collagen peptides have moderate evidence for skin elasticity (Choi 2019 systematic review: 8 RCTs) and joint pain (Zdzieblik 2017). Grass-fed sourcing is a formulation positive. Peptide molecular weight, hydroxyproline content, and third-party heavy-metal testing not disclosed; scoop size and grams per serving absent from description.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "shubhvita-moringa-pure-vegan-capsules-60-count",
      "title": "ShubhVita Moringa Pure | Vegan Capsules | 60 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shubhvita-moringa-pure-4403621.jpg?v=1778344055",
      "score": 50,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shubhvita",
        "moringa",
        "pure",
        "vegan",
        "capsules",
        "count",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 48,
        "sustainability": 50
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198135554245",
      "vsf_explanation": "Single-ingredient moringa leaf is a simple traditional-nutrition supplement; human RCTs are small (Kushwaha 2014 for glycemia, Stohs 2015 review) and effect sizes modest. No standardization or dose disclosed, no third-party testing from Matevara, but format is low-risk and the ingredient itself is well-tolerated.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "oculira-vision-support-eye-health-capsules-60-count",
      "title": "Oculira Vision Support | Eye Health Capsules | 60 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/oculira-vision-support-5781115.jpg?v=1778344055",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "oculira",
        "vision",
        "support",
        "eye",
        "health",
        "capsules",
        "count",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 21.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198135652549",
      "vsf_explanation": "Lutein + bilberry + eyebright + vit C/E + zinc + copper. AREDS2 (Chew 2013) validated lutein 10 mg + zeaxanthin 2 mg + zinc for AMD progression; this product does not disclose whether it matches AREDS2 doses. Missing zeaxanthin is a formulation gap versus the reference protocol.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mariluna-organic-sea-moss-supplement-vegan-capsules-60-count",
      "title": "Mariluna Organic Sea Moss Supplement | Vegan Capsules | 60 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/mariluna-organic-sea-moss-supplement-irish-moss-bladderwrack-burdock-root-with-bioperine-vegan-capsules-60-count-3263227.jpg?v=1778344055",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mariluna",
        "organic",
        "sea",
        "moss",
        "supplement",
        "vegan",
        "capsules",
        "count",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants",
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 40,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 21.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198135619781",
      "vsf_explanation": "Sea moss (Chondrus crispus) and bladderwrack are viral wellness fads with essentially no human RCT evidence for immune or thyroid outcomes. Bladderwrack contains highly variable iodine (Zava 2011) that can trigger thyroid dysfunction, and heavy-metal contamination is common in wild seaweed. BioPerine addition is generic marketing rather than justified.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "neureva-supplement-for-focus-memory-30-capsules",
      "title": "Neureva Supplement for Focus & Memory | 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/neureva-cognitive-support-brain-health-with-bacopa-gaba-l-tyrosine-alpha-gpc-nootropic-capsules-30-count-4936875.jpg?v=1778344055",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "neureva",
        "supplement",
        "for",
        "focus",
        "memory",
        "capsules",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 35,
        "manufacturing": 45,
        "safety": 48,
        "transparency": 42,
        "sustainability": 42
      },
      "price": 21.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198135587013",
      "vsf_explanation": "Kitchen-sink nootropic (Bacopa, Huperzine A, L-tyrosine, L-theanine, GABA, PS, Alpha-GPC, B-vits, caffeine) in a 1-capsule/day 30-count bottle cannot fit clinical doses. Bacopa RCTs (Stough 2001, Morgan 2010) use 300 mg/day standardized; PS uses 300 mg/day (Kato-Kataoka 2010). Format precludes those doses.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "biomara-probiotic-20-billion-cfu-supports-digestive-health-and-immune-function",
      "title": "Biomara Probiotic 20 Billion CFU | Supports Digestive Health and Immune Function",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/biomara-probiotic-20-billion-cfu-digestive-support-3179761.jpg?v=1778344056",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "biomara",
        "probiotic",
        "billion",
        "cfu",
        "supports",
        "digestive",
        "health",
        "and",
        "immune",
        "function",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 58,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 21.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198135685317",
      "vsf_explanation": "20 billion CFU from 13 strains meets the general threshold multi-strain probiotics require for gut effects (Ritchie 2012 meta-analysis; Ford 2014 for IBS). No individual strain identity or CFU disclosed, no shelf-stability CFU-through-expiration guarantee, no third-party testing from Matevara. Clean-label with veggie caps is a plus.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "livelle-milk-thistle-liver-support-supplement-60-capsules",
      "title": "Livelle Milk Thistle Liver Support Supplement | 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/livelle-liver-support-3908787.jpg?v=1778344056",
      "score": 46,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "livelle",
        "milk",
        "thistle",
        "liver",
        "support",
        "supplement",
        "capsules",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 42,
        "sustainability": 42
      },
      "price": 20.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198135750853",
      "vsf_explanation": "8-ingredient liver blend (milk thistle, turmeric, beet, dandelion, artichoke 5% cynarin, ginger, alfalfa, L-cysteine) dilutes each active. Silymarin trials (Ferenci 1989, Freedman 2011 SyNCH) use 420-2100 mg silymarin/day; artichoke uses 320-640 mg (Holtmann 2003). Multi-herb capsule cannot deliver these. Matevara lacks cGMP or third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "radiova-hair-skin-nail-support-complex-60-vegetarian-capsules",
      "title": "Radiova Hair, Skin & Nail Support Complex | 60 Vegetarian Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/radiova-hair-skin-and-nails-essentials-3678472.jpg?v=1778344056",
      "score": 44,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "radiova",
        "hair",
        "skin",
        "nail",
        "support",
        "complex",
        "vegetarian",
        "capsules",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 38,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 40,
        "sustainability": 42
      },
      "price": 23.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198135718085",
      "vsf_explanation": "13-ingredient beauty formula (biotin, B6, folate, botanical blend). Biotin RCTs for hair growth are unconvincing outside deficiency (Patel 2017 review); the botanical additives lack meaningful HSN evidence at typical multi-cap doses. No collagen peptides (the actual RCT-supported HSN active per Proksch 2014). Matevara has no third-party testing.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "florava-natural-gut-wellness-capsules-30-vegan-capsules",
      "title": "Florava Natural Gut Wellness Capsules | 30 Vegan Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/florava-natural-gut-wellness-capsules-fulvic-acid-chaga-extract-digestive-support-supplement-30-vegan-capsules-2147910.jpg?v=1778344056",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "florava",
        "natural",
        "gut",
        "wellness",
        "capsules",
        "vegan",
        "capsules",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 28.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198135816389",
      "vsf_explanation": "Birch chaga polysaccharides show in vitro anti-inflammatory potential but no human gut-health RCTs; pine bark (Pycnogenol) has some IBS data (Belcaro 2010) at 150mg/day. Doses not disclosed. 'Fulvic acid' marketing claim is fringe. 30-cap bottle at $29 is low value.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "nuvira-bee-pearl-capsules-30-servings",
      "title": "Nuvira Bee Pearl Capsules | 30 Servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/nuvira-bee-pearl-1245580.jpg?v=1778344056",
      "score": 51,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nuvira",
        "bee",
        "pearl",
        "capsules",
        "servings",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198135849157",
      "vsf_explanation": "Freeze-dried bee bread sourced from Latvia. Traditional/whole-food positioning; no supplement RCTs on bee bread for energy or immunity in humans. Sourcing origin is disclosed and freeze-drying is a reasonable preservation method, but no COA for microbiology or heavy metals (bee products can accumulate lead).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "virilia-alpha-energy-men-s-vitality-support-capsules-90-count",
      "title": "Virilia Alpha Energy |Men’s Vitality Support Capsules | 90 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/virilia-alpha-energy-2432648.jpg?v=1778344057",
      "score": 42,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "virilia",
        "alpha",
        "energy",
        "men",
        "vitality",
        "support",
        "capsules",
        "count",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 35,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 42,
        "sustainability": 42
      },
      "price": 31.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198135881925",
      "vsf_explanation": "9-ingredient men's blend (Mg, Zn, tribulus, chrysin, HGW, longjack, saw palmetto, hawthorn, cissus). Tongkat ali eurycomanone trials (Talbott 2013) use 200-400 mg standardized; tribulus is largely null in humans (Neychev 2016). Chrysin has near-zero oral bioavailability. Matevara offers no cGMP or third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "arthrex-platinum-turmeric-joint-motion-health-capsules-60-count",
      "title": "Arthrex Platinum Turmeric | Joint & Motion Health Capsules | 60 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/arthrex-platinum-turmeric-joint-mobility-support-capsules-with-glucosamine-boswellia-bioperine-60-count-4648968.jpg?v=1778344058",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "arthrex",
        "platinum",
        "turmeric",
        "joint",
        "motion",
        "health",
        "capsules",
        "count",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 48,
        "safety": 58,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 28.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198135914693",
      "vsf_explanation": "Reasonable joint stack: turmeric 95% curcuminoids + glucosamine sulfate + chondroitin + boswellia + BioPerine for absorption. GAIT trial (Clegg 2006) showed moderate-severe OA benefit for glucosamine+chondroitin; curcumin RCTs (Daily 2016 meta) support pain reduction. Doses per serving not disclosed; Matevara branding without third-party testing caps this in Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrinex-digestive-enzyme-pro-blend-supplement-60-count",
      "title": "Nutrinex Digestive Enzyme Pro Blend Supplement | 60 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/nutrinex-digestive-enzyme-pro-blend-1068064.jpg?v=1778344058",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrinex",
        "digestive",
        "enzyme",
        "pro",
        "blend",
        "supplement",
        "count",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 30,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 30,
        "sustainability": 42
      },
      "price": 21.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198135947461",
      "vsf_explanation": "Uses the proprietary Makzyme-Pro enzyme blend plus bromelain, papain, lipase, lactase, alpha-galactosidase, and three probiotic strains without disclosing per-enzyme activity units (USP, HUT, DU, FCC) or CFU counts. Enzyme efficacy is entirely dose- and unit-dependent, so a proprietary blend hides whether therapeutic activity is present.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "maximus-horny-goat-weed-blend-mens-vitality-capsules-60-count",
      "title": "Maximus Horny Goat Weed Blend | Men's Vitality Capsules | 60 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/maximus-horny-goat-weed-blend-6635992.jpg?v=1778344060",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "maximus",
        "horny",
        "goat",
        "weed",
        "blend",
        "men",
        "vitality",
        "capsules",
        "count",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 35,
        "manufacturing": 45,
        "safety": 48,
        "transparency": 42,
        "sustainability": 42
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198136111301",
      "vsf_explanation": "8-herb men's blend (epimedium, maca, L-arginine, tongkat ali, ginseng, saw palmetto, muira puama, polypodium). Icariin (HGW's active) human trials are weak; tongkat ali needs 200-400 mg standardized (Talbott 2013). Multi-herb capsule cannot deliver clinical doses of any single active. No standardization disclosed; Matevara has no third-party testing.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "cardena-coq10-ubiquinone-capsules-30-veggie-caps",
      "title": "Cardena CoQ10 Ubiquinone Capsules | 30 Veggie Caps",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cardena-coq10-ubiquinone-capsules-energy-production-cellular-health-support-30-count-2201493.jpg?v=1778344060",
      "score": 50,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cardena",
        "coq10",
        "ubiquinone",
        "capsules",
        "veggie",
        "caps",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart",
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 27.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198136144069",
      "vsf_explanation": "CoQ10 ubiquinone has strong heart failure evidence at 300mg/day (Mortensen 2014 Q-SYMBIO trial) and helps statin-related myalgia (Qu 2018). Dose per capsule not disclosed and ubiquinone is less bioavailable than ubiquinol for adults over 40 (Hosoe 2007). 30-cap format suggests low daily strength.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ketava-keto-bhb-capsules-60-capsules",
      "title": "Ketava Keto BHB Capsules | 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ketava-keto-bhb-capsules-exogenous-ketones-with-mct-bhb-salts-ketosis-support-supplement-60-capsules-8945224.jpg?v=1778344060",
      "score": 38,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ketava",
        "keto",
        "bhb",
        "capsules",
        "capsules",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health",
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 45,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 21.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198136176837",
      "vsf_explanation": "Exogenous BHB salts raise blood ketones transiently but do not accelerate ketosis induction or produce weight loss over baseline diet (Stubbs 2017; Poffe 2019). Ketosis is achieved by carbohydrate restriction, not oral salts. Multi-salt (Ca/Mg/Na BHB) provides high sodium/mineral load.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "immuvia-colostrum-capsules-60-capsules",
      "title": "Immuvia Colostrum Capsules | 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/immuvia-colostrum-capsules-500mg-with-30-igg-immune-digestive-support-supplement-60-capsules-8218107.jpg?v=1778344061",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "immuvia",
        "colostrum",
        "capsules",
        "capsules",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants",
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198136209605",
      "vsf_explanation": "500 mg bovine colostrum standardized to 30% IgG per capsule — the standardization is above-average transparency. Colostrum has moderate evidence for URTI reduction in athletes (Davison 2021 systematic review) and gut-barrier support (Playford 2021). Daily therapeutic doses in RCTs are typically 20g+ powder, so 500-1000 mg capsule is a low maintenance dose. Ethical sourcing (calf-first) not addressed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitala-women-s-vitality-formula-womens-cycle-menopause-support-60-count",
      "title": "Vitala Women’s Vitality Formula | Women's Cycle & Menopause Support | 60 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/vitala-womens-vitality-formula-8349814.jpg?v=1778344065",
      "score": 51,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "female",
      "life_stage": "postmenopausal",
      "tokens": [
        "vitala",
        "women",
        "vitality",
        "formula",
        "women",
        "cycle",
        "menopause",
        "support",
        "count",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health",
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 21.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198136537285",
      "vsf_explanation": "Dong quai + red clover + black cohosh + sage + chasteberry + wild yam + soy isoflavones + trans-resveratrol menopause blend. Black cohosh Cochrane review (Leach 2012) was inconclusive for vasomotor symptoms; chasteberry has some PMS RCT support (Schellenberg 2001). Body copy doesn't disclose per-ingredient mg. Safety consideration: black cohosh + hormone-sensitive conditions.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-turmeric-overall-vitality-by-bellawell",
      "title": "Organic Turmeric - Overall Vitality by Bellawell",
      "vendor": "Bellawell Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/organic-turmeric-overall-vitality-by-bellawell-300198.png?v=1778344117",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "turmeric",
        "overall",
        "vitality",
        "bellawell",
        "bellawell",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants",
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 19.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198136930501",
      "vsf_explanation": "Turmeric with BioPerine (piperine) to enhance bioavailability. Shoba 1998 showed 20 mg piperine boosts curcumin plasma AUC ~20x. Curcuminoid RCTs support anti-inflammatory effects (Hewlings 2017 review). Body copy doesn't publish curcumin/piperine mg amounts, and turmeric-alone extracts underperform bioenhanced forms (Meriva, Theracurmin), keeping this at Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "emergency-immune-support-daily-wellness-with-probiotics-by-bellawell",
      "title": "Emergency Immune Support – Daily Wellness with Probiotics by Bellawell",
      "vendor": "Bellawell Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/emergency-immune-support-daily-wellness-with-probiotics-by-bellawell-490511.png?v=1778344116",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "emergency",
        "immune",
        "support",
        "daily",
        "wellness",
        "with",
        "probiotics",
        "bellawell",
        "bellawell",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 42,
        "manufacturing": 48,
        "safety": 55,
        "transparency": 22,
        "sustainability": 40
      },
      "price": 22.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198136963269",
      "vsf_explanation": "Probiotic + garlic + Vit C + elderberry + L-glutamine + zinc + Vit E multi-blend with no CFU count, no per-nutrient mg, and no strain identification. Zinc lozenge trials (Hemila 2017) require 75+ mg/day of specific salts; nothing disclosed here matches those parameters.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "sea-moss-superfood-for-womens-wellness",
      "title": "Sea Moss Superfood for Women's Wellness",
      "vendor": "Bellawell Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/sea-moss-superfood-for-womens-wellness-303898.png?v=1778344121",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "sea",
        "moss",
        "superfood",
        "for",
        "women",
        "wellness",
        "bellawell",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 21.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198137061573",
      "vsf_explanation": "Irish sea moss (Chondrus crispus) capsules positioned for women's thyroid, bone, and skin support. Sea moss health claims are largely traditional and marketing-driven; recent RCT evidence for capsuled sea moss is essentially absent. Iodine content is variable and can trigger thyroid dysfunction (Leung 2014 Nat Rev Endocrinol) — a real concern when iodine mg per cap is undisclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "berberine-harness-the-power-of-nature-by-bellawell",
      "title": "Berberine - Harness the Power of Nature by Bellawell",
      "vendor": "Bellawell Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/berberine-harness-the-power-of-nature-by-bellawell-890479.png?v=1778344121",
      "score": 51,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "berberine",
        "harness",
        "the",
        "power",
        "nature",
        "bellawell",
        "bellawell",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 31.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198137094341",
      "vsf_explanation": "Barberry-sourced berberine capsules, single ingredient. Yin 2008 (Metabolism 57:5) established 500mg TID for glycemic control. Ingredient evidence is strong; no mg per capsule, no COA, and no bioavailability enhancer (dihydroberberine/phytosome) noted. Bottom-of-Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-saffron-balance-in-harmony",
      "title": "Pure Saffron – Balance in Harmony",
      "vendor": "Bellawell Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/pure-saffron-balance-in-harmony-6235766.png?v=1778344121",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "saffron",
        "balance",
        "harmony",
        "bellawell",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 42,
        "manufacturing": 48,
        "safety": 60,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 19.93,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198137028805",
      "vsf_explanation": "Saffron (Crocus sativus) has RCT support for mild-moderate depression at 28-30 mg/day of standardized extract (Lopresti 2014 meta-analysis). This listing gives no mg per capsule and no standardized safranal/crocin markers, so it cannot be confirmed to hit the therapeutic dose.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "total-colon-cleanse-detox-by-bellawell",
      "title": "Total Colon Cleanse & Detox by Bellawell",
      "vendor": "Bellawell Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/total-colon-cleanse-detox-by-bellawell-927682.png?v=1778344121",
      "score": 41,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "total",
        "colon",
        "cleanse",
        "detox",
        "bellawell",
        "bellawell",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 45,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 19.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198137192645",
      "vsf_explanation": "Eleven-herb 'colon cleanse' with psyllium, aloe ferox, senna-family cathartics, chlorella, and black walnut. Aloe ferox latex acts as a stimulant laxative and long-term use is associated with electrolyte disturbance (Kang 2011). Psyllium at real doses has fiber evidence, but the label lumps 11 herbs with no per-item mg.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "organic-maca-root-complex-by-bellawell",
      "title": "Organic Maca Root Complex by Bellawell",
      "vendor": "Bellawell Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/organic-maca-root-complex-by-bellawell-638068.png?v=1778344121",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "energy",
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "maca",
        "root",
        "complex",
        "bellawell",
        "bellawell",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine",
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 18.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198137159877",
      "vsf_explanation": "Organic maca root capsule marketed for women's energy/hormonal support. Shin 2010 systematic review found preliminary evidence for maca on sexual dysfunction at 1.5-3 g/day. Body copy doesn't disclose per-cap mg or gelatinization status; single-ingredient plant supplement from an actual named brand keeps it at Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ginkgo-biloba-formula-by-bellawell",
      "title": "Ginkgo Biloba Formula by Bellawell",
      "vendor": "Bellawell Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/advanced-ginkgo-formula-by-bellawell-327818.png?v=1778344121",
      "score": 47,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ginkgo",
        "biloba",
        "formula",
        "bellawell",
        "bellawell",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 19.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198137127109",
      "vsf_explanation": "Single-herb ginkgo capsule with no dose, no standardization percentage, and no extract identity. Ginkgo cognition/dementia evidence requires the EGb 761 extract standardized to 24% flavone glycosides / 6% terpene lactones at 240 mg/day (Kandiah 2019); generic ginkgo powders have not shown the same effects. Without disclosed dose or standardization, cannot be assumed therapeutic.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "omega-fish-oil-omega-3-fatty-acids-by-bellawell",
      "title": "Omega Fish Oil -Omega-3 Fatty Acids by Bellawell",
      "vendor": "Bellawell Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/omega-fish-oil-omega-3-fatty-acids-by-bellawell-703392.png?v=1778344121",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "omega",
        "fish",
        "oil",
        "omega",
        "fatty",
        "acids",
        "bellawell",
        "bellawell",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 21.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198137323717",
      "vsf_explanation": "Fish oil softgel described qualitatively as EPA + DHA with no per-serving mg. Omega-3 evidence for triglyceride lowering is strong (Skulas-Ray 2019 AHA advisory) at 2-4 g EPA+DHA/day. Without dose, oxidation testing (TOTOX), or IFOS-style third-party certification, this is a low Standard — Nordic Naturals-tier fish oils sit closer to Elite.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "myo-d-chiro-inositol-ip6-by-bellawell",
      "title": "Myo D-Chiro Inositol (IP6) by Bellawell",
      "vendor": "Bellawell Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/myo-d-chiro-inositol-ip6-by-bellawell-867301.png?v=1778344122",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "myo",
        "chiro",
        "inositol",
        "ip6",
        "bellawell",
        "bellawell",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 48,
        "manufacturing": 48,
        "safety": 60,
        "transparency": 32,
        "sustainability": 45
      },
      "price": 19.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198137356485",
      "vsf_explanation": "Myo-inositol + D-chiro-inositol has solid PCOS RCT evidence at the 40:1 ratio, 2 g myo + 50 mg DCI twice daily (Nordio & Proietti 2012). Product page describes ingredients but doesn't publish the ratio or per-serving mg; the added IP6 label is unusual and unexplained. Sits at low Standard on assumed adequate dosing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-b-complex-with-folate-by-bellawell",
      "title": "Vitamin B-Complex With Folate by Bellawell",
      "vendor": "Bellawell Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/vitamin-b-complex-with-folate-by-bellawell-985733.png?v=1778344121",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "complex",
        "with",
        "folate",
        "bellawell",
        "bellawell",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 65,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 21.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198137225413",
      "vsf_explanation": "Complete B-complex (B1/B2/B3/B6/B12) with folate. B-vitamin supplementation reliably corrects deficiency-linked symptoms (Kennedy 2016 Nutrients review). Folate form (folic acid vs. methylfolate/5-MTHF) not specified — matters for MTHFR-variant users. Doses per cap and %DV not shown in listing copy.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-liver-cleanse-bellawell-detox",
      "title": "Pure Liver Cleanse - Bellawell Detox+",
      "vendor": "Bellawell Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/pure-liver-cleanse-bellawell-detox-867296.png?v=1778344121",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "liver",
        "cleanse",
        "bellawell",
        "detox",
        "bellawell",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive",
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 50,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 22.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198137258181",
      "vsf_explanation": "Milk thistle, artichoke, dandelion, plus an explicit 'proprietary blend' of celery seed, turmeric, and others. Milk thistle silymarin has modest RCT evidence for liver enzyme reduction in NAFLD (Zhong 2017) at 420 mg/day; here the amount is undisclosed and buried in a proprietary blend.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "magnesium-complex-by-bellawell",
      "title": "Magnesium Complex by Bellawell",
      "vendor": "Bellawell Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/magnesium-complex-by-bellawell-817403.png?v=1778344121",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "complex",
        "bellawell",
        "bellawell",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients",
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 24.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198137290949",
      "vsf_explanation": "Five forms of magnesium — Aquamin (hydroxide), malate, oxide, citrate, glycinate — targeting different absorption sites. Multi-form is a reasonable approach; glycinate/malate are best-tolerated (Schuchardt 2017 review). Magnesium supplementation has evidence for BP, sleep, and cramp reduction. Body copy doesn't publish elemental mg per capsule, so it falls short of BIOptimizers-tier full disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-moringa-superfood-by-bellawell",
      "title": "Organic Moringa Superfood by Bellawell",
      "vendor": "Bellawell Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/organic-moringa-superfood-by-bellawell-229540.png?v=1778344121",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "moringa",
        "superfood",
        "bellawell",
        "bellawell",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 18.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198137389253",
      "vsf_explanation": "Organic Moringa oleifera leaf capsules. Moringa evidence base is mostly nutritional/preclinical; Stohs 2015 review notes some hypoglycemic and lipid effects at 500-2000mg/day. Organic sourcing gives a small sustainability boost. Mg per capsule and standardization (e.g., glucomoringin) not disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "urinary-tract-support-by-bellawell",
      "title": "Urinary Tract Support by Bellawell",
      "vendor": "Bellawell Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/urinary-tract-support-by-bellawell-643366.png?v=1778344121",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "urinary",
        "tract",
        "support",
        "bellawell",
        "bellawell",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health",
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 21.15,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198137422021",
      "vsf_explanation": "D-mannose + cranberry + hibiscus + dandelion. D-mannose 2 g/day was non-inferior to trimethoprim for recurrent UTI prevention (Kranjčec 2014); cranberry PACs 36 mg/day have Cochrane support in women with recurrent UTI (Williams 2023). Body copy doesn't publish D-mannose or PAC amounts, keeping this at Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "creatine-powder-high-energy-compound",
      "title": "CREATINE Powder - High Energy Compound",
      "vendor": "Bellawell Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/creatine-powder-high-energy-compound-6306516.png?v=1778344121",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "creatine",
        "powder",
        "high",
        "energy",
        "compound",
        "bellawell",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 85,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 70,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 44.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198137454789",
      "vsf_explanation": "Creatine monohydrate has the strongest evidence base of any sports supplement for strength and lean mass at 3-5 g/day (Kreider 2017 ISSN position). Listing claims third-party testing but does not name a form (mono vs HCl), source (Creapure vs generic), or per-scoop dose, holding this well below anchored Momentous Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "collagen-peptides-types-i-ii-iii-v-x-by-bellawell",
      "title": "Collagen Peptides Types I, II, III, V, X by Bellawell",
      "vendor": "Bellawell Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/collagen-peptides-types-i-ii-iii-v-x-by-bellawell-133373.png?v=1778344122",
      "score": 51,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "collagen",
        "peptides",
        "types",
        "iii",
        "bellawell",
        "bellawell",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty",
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 24.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198137520325",
      "vsf_explanation": "Multi-type collagen (I, II, III, V, X) capsule. Collagen peptides have RCT support for skin elasticity/hydration (Choi 2019 review) and joint pain (Zdzieblik 2017, 5 g collagen) at 2.5-10 g/day. Capsule delivery makes achieving effective grams-per-day difficult, and per-serving g is not disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnesium-glycinate-cellular-balance-by-bellawell",
      "title": "Magnesium Glycinate - Cellular Balance by Bellawell",
      "vendor": "Bellawell Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/magnesium-glycinate-cellular-balance-by-bellawell-303337.png?v=1778344122",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "glycinate",
        "cellular",
        "balance",
        "bellawell",
        "bellawell",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients",
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 50,
        "safety": 70,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 24.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198137585861",
      "vsf_explanation": "Magnesium glycinate has strong bioavailability and gentle GI profile (Walker 2003) with sleep/stress evidence (Boyle 2017 review). Bellawell doesn't disclose elemental magnesium per capsule or manufacturing certifications; brand history is limited. Well-chosen form, weak provenance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-d3-k2-sunshine-boost-by-bellawell",
      "title": "Vitamin D3 & K2 - Sunshine Boost by Bellawell",
      "vendor": "Bellawell Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/vitamin-d3-k2-sunshine-boost-by-bellawell-457231.png?v=1778344123",
      "score": 58,
      "tier": "standard",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "sunshine",
        "boost",
        "bellawell",
        "bellawell",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients",
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 65,
        "manufacturing": 50,
        "safety": 70,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 18.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198137618629",
      "vsf_explanation": "D3 + K2 (MK-7) synergy has good evidence for directing calcium to bone rather than arteries (Schwalfenberg 2017; Knapen 2013 K2 arterial stiffness RCT). MK-7 is the correct long-half-life form. Bioperine addition is unnecessary for fat-soluble vitamins already absorbed with meals. D3 IU and MK-7 mcg per capsule not disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "womens-vitality-plus-by-bellawell",
      "title": "Women's Vitality Plus by Bellawell",
      "vendor": "Bellawell Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/womens-vitality-plus-by-bellawell-616361.png?v=1778344130",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "women",
        "vitality",
        "plus",
        "bellawell",
        "bellawell",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 35,
        "manufacturing": 45,
        "safety": 48,
        "transparency": 42,
        "sustainability": 42
      },
      "price": 21.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198137684165",
      "vsf_explanation": "Multi-herb women's blend (epimedium, tribulus, catuaba, dong quai and more). Tribulus is largely null in women (Vale 2018); dong quai has weak menopausal data (Hirata 1997 null). Catuaba lacks human RCTs. Bellawell doesn't disclose standardizations, per-herb doses, or third-party testing.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "b-12-drops-b-active-drops-by-bellawell",
      "title": "B-12 Drops - B-Active Drops by Bellawell",
      "vendor": "Bellawell Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b-12-drops-b-active-drops-by-bellawell-953175.png?v=1778344130",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "drops",
        "active",
        "drops",
        "bellawell",
        "bellawell",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198137716933",
      "vsf_explanation": "Liquid B-complex with methylcobalamin (bioavailable B12 form) plus B2, B3, B5, B6, but specific per-serving doses are not disclosed in the description. Methylcobalamin sublingual/liquid B12 is supported for absorption in older adults (Andres 2018), yet Bellawell provides no COA, allergen testing, or third-party verification. Standard for a small-brand foundational vitamin without transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-ashwagandha-an-ancient-treasure-by-bellawell",
      "title": "Organic Ashwagandha - An Ancient Treasure by Bellawell",
      "vendor": "Bellawell Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/organic-ashwagandha-an-ancient-treasure-by-bellawell-448157.png?v=1778344132",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "ashwagandha",
        "ancient",
        "treasure",
        "bellawell",
        "bellawell",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 42,
        "manufacturing": 48,
        "safety": 60,
        "transparency": 25,
        "sustainability": 50
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198137749701",
      "vsf_explanation": "Ashwagandha has RCT support (Chandrasekhar 2012, KSM-66 300 mg BID) but this listing provides no mg dose, no standardized extract (KSM-66 or Sensoril), and no withanolide percentage. 'Organic' certification helps sustainability but does not substitute for standardization.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "advanced-stress-relief-formula-by-bellawell",
      "title": "Advanced Stress Relief Formula by Bellawell",
      "vendor": "Bellawell Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/advanced-stress-relief-formula-by-bellawell-529260.png?v=1778344132",
      "score": 53,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "advanced",
        "stress",
        "relief",
        "formula",
        "bellawell",
        "bellawell",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 20.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198137782469",
      "vsf_explanation": "Rhodiola + ashwagandha + chamomile + lutein blend. Ashwagandha (Chandrasekhar 2012, 600 mg) and rhodiola (Cropley 2015 SHR-5) each have RCT stress-reduction evidence at defined doses. Body copy doesn't publish per-herb mg or standardization; lutein inclusion in a stress formula is atypical.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "glucosamine-sulfate-healthy-joints-by-bellawell",
      "title": "Glucosamine Sulfate - Healthy Joints by Bellawell",
      "vendor": "Bellawell Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/glucosamine-sulfate-healthy-joints-by-bellawell-196479.png?v=1778344133",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glucosamine",
        "sulfate",
        "healthy",
        "joints",
        "bellawell",
        "bellawell",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 21.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198137815237",
      "vsf_explanation": "1500 mg glucosamine sulfate plus chondroitin matches the dose used in the GAIT trial (Clegg 2006), which showed modest benefit in moderate-to-severe knee OA. Formulation is appropriate but sourcing, chondroitin dose, and third-party testing are undisclosed. Solid Standard placement.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "menopause-support-a-thoughtful-blend-of-ingredients-by-bellawell",
      "title": "Menopause Support: - A Thoughtful Blend of Ingredients by Bellawell",
      "vendor": "Bellawell Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/menopause-support-a-thoughtful-blend-of-ingredients-by-bellawell-143009.png?v=1778344133",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "female",
      "life_stage": "postmenopausal",
      "tokens": [
        "menopause",
        "support",
        "thoughtful",
        "blend",
        "ingredients",
        "bellawell",
        "bellawell",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 35,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198137848005",
      "vsf_explanation": "Description explicitly lists a 'Proprietary Prebiotic Blend' and unspecified herbal extracts with no per-ingredient doses. Menopause claims cannot be evaluated when key actives are hidden inside proprietary blends. Auto-fail applied.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "digestive-enzymes-a-thoughtful-choice-for-womens-wellness-by-bellawell",
      "title": "Digestive Enzymes: A Thoughtful Choice for Women's Wellness by Bellawell",
      "vendor": "Bellawell Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/digestive-enzymes-a-thoughtful-choice-for-womens-wellness-by-bellawell-321406.png?v=1778344133",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "digestive",
        "enzymes",
        "thoughtful",
        "choice",
        "for",
        "women",
        "wellness",
        "bellawell",
        "bellawell",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198137880773",
      "vsf_explanation": "Enzyme blend (fungal protease, lactobacillus acidophilus, etc.) with no enzyme activity units (FCC, HUT, SKB) disclosed. Digestive enzyme efficacy depends on activity units, not weight. Without those numbers or third-party testing, this is a below-average Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "probiotics-60-billion-by-bellawell",
      "title": "Probiotics 60 Billion by Bellawell",
      "vendor": "Bellawell Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/probiotics-60-billion-by-bellawell-463814.png?v=1778344133",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "probiotics",
        "billion",
        "bellawell",
        "bellawell",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 38.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198137913541",
      "vsf_explanation": "60B CFU across 4 well-studied strains (L. acidophilus, B. lactis, L. plantarum, L. paracasei) with FOS prebiotic. Strain-level identification is absent (no genus-species-strain codes like BB-12 or LGG), which is standard practice for evidence-based probiotics (Sanders 2019). Adequate but not Verified without shelf-life CFU guarantee.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vision-care-a-blend-of-ingredients-for-ocular-support-by-bellawell",
      "title": "Vision Care -  A Blend of Ingredients for Ocular Support by Bellawell",
      "vendor": "Bellawell Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/vision-care-a-blend-of-ingredients-for-ocular-support-by-bellawell-281075.png?v=1778344135",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vision",
        "care",
        "blend",
        "ingredients",
        "for",
        "ocular",
        "support",
        "bellawell",
        "bellawell",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 45,
        "sustainability": 42
      },
      "price": 21.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198137946309",
      "vsf_explanation": "Lutein/zeaxanthin/bilberry/ALA/eyebright/quercetin/rutin/taurine blend. AREDS2 (Chew 2013) validated lutein 10 mg + zeaxanthin 2 mg for AMD progression, but this multi-ingredient capsule likely can't hit AREDS2 doses. No per-ingredient mg disclosed and no third-party testing from Bellawell.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "blood-sugar-balance-by-bellawell",
      "title": "Blood Sugar Balance by Bellawell",
      "vendor": "Bellawell Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/blood-sugar-balance-by-bellawell-929318.png?v=1778344135",
      "score": 39,
      "tier": "rejected",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "blood",
        "sugar",
        "balance",
        "bellawell",
        "bellawell",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 21.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198137979077",
      "vsf_explanation": "Vitamin C/E, biotin, manganese, chromium AAC, banaba, and guggul for blood-sugar support. Chromium picolinate has null-to-trivial glycemic effects in non-deficient adults (Balk 2007); banaba corosolic acid has small trials only. Doses not clearly disclosed. Biotin at supplement doses interferes with lab assays.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lions-mane-tincture-focus-cognitive-support",
      "title": "Lions Mane Tincture – Focus & Cognitive Support",
      "vendor": "New Hampshire Mushroom Company LLC",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/lions_mane_tincture.jpg?v=1778344149",
      "score": 53,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lions",
        "mane",
        "tincture",
        "focus",
        "cognitive",
        "support",
        "new",
        "hampshire",
        "mushroom",
        "company",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198138011845",
      "vsf_explanation": "Fruiting-body only + dual-extraction is the honest way to make a functional Lion's Mane product — most cheap products are mycelium-on-grain with inflated beta-glucan claims. Mori 2009 (Phytother Res) showed cognitive-scale improvement in MCI at 3g/day dried fruiting body for 16 weeks. This tincture discloses no mg equivalent per dropper, but locally grown NH provenance is a plus.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "energy-focus-mushroom-tincture-lions-mane-cordyceps",
      "title": "Energy & Focus Mushroom Tincture – Lions Mane & Cordyceps",
      "vendor": "New Hampshire Mushroom Company LLC",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/energy_and_focus_tincture.jpg?v=1778344156",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "energy",
        "focus",
        "mushroom",
        "tincture",
        "lions",
        "mane",
        "cordyceps",
        "new",
        "hampshire",
        "mushroom",
        "company",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics",
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 70,
        "safety": 65,
        "transparency": 70,
        "sustainability": 75
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198138044613",
      "vsf_explanation": "Double-extracted tincture with 1000 mg lion's mane + 1000 mg cordyceps per 2 mL serving, 100% fruiting body, glycerin base (alcohol-free), locally grown in NH. Fruiting body + dose disclosed is a real quality signal — mycelium-on-grain is the usual industry shortcut. Lion's mane has mild cognitive RCT support (Mori 2009, elderly MCI); cordyceps has modest exercise-tolerance evidence (Chen 2010). High Standard, just short of Verified due to modest human evidence base.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lions-mane",
      "title": "Lions Mane",
      "vendor": "2.0 Lifestyle",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1755096041714-generated-label-image-2.jpg?v=1778344168",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lions",
        "mane",
        "lifestyle"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 60,
        "sustainability": 60
      },
      "price": 25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198138110149",
      "vsf_explanation": "Organic Lion's Mane (Hericium erinaceus) fruiting body + mycelium powder standardized to 40% polysaccharides (400mg polysaccharide per 2-cap serving). Mori 2009 RCT on Lion's Mane showed cognitive gains at 3g/day of dry powder; the 400mg polysaccharide dose here is on the lower end. Transparency is decent with the standardization callout.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "beat-charge-functional-mushroom-complex-supplement",
      "title": "Beat Charge Functional Mushroom Complex Supplement",
      "vendor": "Beat Charge",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1736384806899-generated-label-image-0.jpg?v=1778344209",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beat",
        "charge",
        "functional",
        "mushroom",
        "complex",
        "supplement",
        "beat",
        "charge"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 30,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 21.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198138241221",
      "vsf_explanation": "Explicit proprietary blend (Maitake, Turkey Tail, Chaga, Royal Sun, White Button, Black Fungus) hides doses. Beta-glucan content is undisclosed; no fruiting-body vs mycelium clarity for chaga/reishi. Lion's Mane RCTs (Mori 2009) use 3 g/day fruiting body — this format cannot verify that.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "beat-charge-plant-protein-vanilla",
      "title": "Beat Charge - Plant Protein (Vanilla)",
      "vendor": "Beat Charge",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1772479722663-generated-label-image-0.jpg?v=1778344250",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beat",
        "charge",
        "plant",
        "protein",
        "vanilla",
        "beat",
        "charge"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 58,
        "manufacturing": 50,
        "safety": 58,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 51.52,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198138273989",
      "vsf_explanation": "20 g plant protein (fava bean isolate + YESTEIN fermented yeast protein) at 110 kcal per serving. Complete-amino claim is credible with fava + yeast blend (Herreman 2020 DIAAS review). MCT for palatability. No third-party protein-purity or heavy-metal testing disclosed (Clean Label Project concern for plant proteins). Sub-therapeutic-dose autofail doesn't apply.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "beat-charge-diet-drops-1-oz",
      "title": "Beat Charge Diet Drops 1 oz",
      "vendor": "Beat Charge",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1769056514110-generated-label-image-0.jpg?v=1778344250",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beat",
        "charge",
        "diet",
        "drops",
        "beat",
        "charge"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 28,
        "manufacturing": 42,
        "safety": 48,
        "transparency": 25,
        "sustainability": 42
      },
      "price": 18.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198138437829",
      "vsf_explanation": "Explicit \"Proprietary Active-8 & African Mango Complex\" (African mango, maca, rhodiola, L-arg, L-glu, L-carn) hides all doses. Irvingia gabonensis meta-analyses (Onakpoya 2013) were retracted/questioned for weight loss; L-carnitine effects are marginal (Pooyandjoo 2016 ~1 kg over months).",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "beat-charge-tuned-in-powder-sour-grape",
      "title": "Beat Charge - TUNED IN Powder (Sour Grape)",
      "vendor": "Beat Charge",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1775848716039-generated-label-image-0.jpg?v=1778344249",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beat",
        "charge",
        "tuned",
        "powder",
        "sour",
        "grape",
        "beat",
        "charge"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics",
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 45,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 37.22,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198138339525",
      "vsf_explanation": "Alpha-GPC (Marcus 2017) and L-theanine + caffeine (Owen 2008) have decent nootropic evidence at 300-600mg and 100mg+200mg respectively. TUNED IN lists ingredients but no doses per scoop; Asian ginseng and L-arginine for 'blood flow' is loose reasoning. No third-party certification or COA.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "beat-charge-magnesium-glycinate",
      "title": "Beat Charge - Magnesium Glycinate",
      "vendor": "Beat Charge",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1772251643906-generated-label-image-0.jpg?v=1778344250",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beat",
        "charge",
        "magnesium",
        "glycinate",
        "beat",
        "charge"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 50,
        "safety": 65,
        "transparency": 55,
        "sustainability": 48
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198138405061",
      "vsf_explanation": "Clean single-ingredient magnesium glycinate at 275 mg elemental per capsule (from 2,500 mg glycinate) — a well-formulated bioavailable Mg form with strong sleep and stress data (Boyle 2017 review; Abbasi 2012 RCT for insomnia at 500 mg/day elemental). Missing third-party testing and USP verification prevents Verified tier. Comparable to BiOptimizers baseline (~62).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "beat-charge-creatine-hydration-powder",
      "title": "Beat Charge - Creatine Hydration Powder",
      "vendor": "Beat Charge",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1771529321989-generated-label-image-0.jpg?v=1778344249",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beat",
        "charge",
        "creatine",
        "hydration",
        "powder",
        "beat",
        "charge"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 65,
        "manufacturing": 52,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 33.32,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198138306757",
      "vsf_explanation": "5 g creatine monohydrate — the ISSN-endorsed dose (Kreider 2017 position stand) — plus magnesium malate, sodium, and potassium for hydration. Formulation choice (monohydrate) is the gold standard vs novel forms. Missing Creapure sourcing callout and third-party testing keeps it below Momentous Creatine Verified (~76).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "beat-charge-instant-coffee-dark-roast",
      "title": "Beat Charge - Instant Coffee (Dark Roast)",
      "vendor": "Beat Charge",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1773102828714-generated-label-image-0.jpg?v=1778344250",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beat",
        "charge",
        "instant",
        "coffee",
        "dark",
        "roast",
        "beat",
        "charge"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 21.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198138503365",
      "vsf_explanation": "Single-origin freeze-dried Arabica instant coffee. Caffeine has robust RCT evidence for cognitive and physical performance (Grgic 2020 meta-analysis, ~3 mg/kg), but caffeine content per scoop is not disclosed. Not a formulated supplement; scored as a functional energy product with limited transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "beat-charge-nmn-500-mg-ss-nicotinamide-mononucleotide",
      "title": "Beat Charge - NMN (500 mg ß-Nicotinamide Mononucleotide)",
      "vendor": "Beat Charge",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1776725637916-generated-label-image-0.jpg?v=1778344250",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beat",
        "charge",
        "nmn",
        "500",
        "nicotinamide",
        "mononucleotide",
        "beat",
        "charge"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 48,
        "safety": 55,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198138470597",
      "vsf_explanation": "500 mg single-ingredient NMN. Yoshino 2021 (JAMA) and Irie 2020 showed NAD+ elevation but clinical benefits remain preliminary; FDA excluded NMN from the supplement definition in 2022, creating regulatory uncertainty. No COA, purity %, or third-party HPLC testing disclosed — critical for NMN given widespread purity issues (ConsumerLab 2023 found many products under-dosed).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "beat-charge-macular-vision-support",
      "title": "Beat Charge - Macular & Vision Support",
      "vendor": "Beat Charge",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1776723513915-generated-label-image-0.jpg?v=1778344251",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beat",
        "charge",
        "macular",
        "vision",
        "support",
        "beat",
        "charge"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 35,
        "sustainability": 50
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198138536133",
      "vsf_explanation": "Vision blend with vitamin C, vitamin E, zinc, copper, bilberry, eyebright, and 5% lutein. AREDS2 (2013) established zinc + antioxidant + lutein/zeaxanthin for AMD, but this formula uses only 5% lutein extract without per-ingredient mg disclosure. Cannot verify AREDS2-comparable dosing.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "beat-charge-creatine-monohydrate",
      "title": "Beat Charge Creatine Monohydrate",
      "vendor": "Beat Charge",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1731550495049-generated-label-image-0.jpg?v=1778344250",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beat",
        "charge",
        "creatine",
        "monohydrate",
        "beat",
        "charge"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids",
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 90,
        "formulation": 70,
        "manufacturing": 60,
        "safety": 80,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198138601669",
      "vsf_explanation": "Single-ingredient creatine monohydrate — the most-studied sports supplement with overwhelming evidence for strength, power and lean mass gains (Kreider 2017 ISSN position; Antonio 2021). USA-made and references 'global leader in creatine R&D' (likely Creapure implied but not named). Missing explicit Creapure branding, Informed Sport certification, and dose (5g scoop typical) means it can't reach Verified tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "beat-charge-xylitol-micro-hydroxyapatite-dental-oral-health-chewables",
      "title": "Beat Charge - Xylitol & Micro Hydroxyapatite Dental + Oral Health Chewables",
      "vendor": "Beat Charge",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1774051332545-generated-label-image-0.jpg?v=1778344249",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beat",
        "charge",
        "xylitol",
        "micro",
        "hydroxyapatite",
        "dental",
        "oral",
        "health",
        "chewables",
        "beat",
        "charge"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 55,
        "manufacturing": 48,
        "safety": 58,
        "transparency": 50,
        "sustainability": 48
      },
      "price": 16.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198138568901",
      "vsf_explanation": "Xylitol + microcrystalline hydroxyapatite + three oral Lactobacillus strains (L. salivarius LS97, L. paracasei LC86, L. acidophilus LA85). HAP toothpaste RCTs (Amaechi 2019) show remineralization on par with fluoride; L. salivarius data for caries/gingivitis is emerging (Nishihara 2014). Chewable format for enamel contact is reasonable; guava powder is filler. Missing per-strain CFU.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "beat-charge-omega-3-fish-oils-epa-180mg-dha-120mg",
      "title": "Beat Charge Omega-3 Fish Oils EPA 180mg + DHA 120mg",
      "vendor": "Beat Charge",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1741842524847-generated-label-image-0.jpg?v=1778344250",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beat",
        "charge",
        "omega",
        "fish",
        "oils",
        "epa",
        "180mg",
        "dha",
        "120mg",
        "beat",
        "charge"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 32,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 42,
        "sustainability": 40
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198138634437",
      "vsf_explanation": "180 mg EPA + 120 mg DHA per softgel is standard-strength but sub-therapeutic vs cardiovascular targets. AHA recommends 1 g EPA+DHA/day for CHD; REDUCE-IT (Bhatt 2019) used 4 g icosapent. Two-softgel dose yields only 600 mg — below effective range. No IFOS/USP third-party purity/oxidation testing disclosed.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "centrum-menopause-support-clear-mind-calm-mood-30-tablets-hormone-free-supplement-for-brain-fog-stress-relief",
      "title": "Centrum Menopause Support Clear Mind & Calm Mood, 30 Tablets – Hormone-Free Supplement for Brain Fog & Stress Relief",
      "vendor": "Centrum",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/280042100.jpg?v=1778344336",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone",
        "mood",
        "cognitive"
      ],
      "sex_relevance": "female",
      "life_stage": "postmenopausal",
      "tokens": [
        "centrum",
        "menopause",
        "support",
        "clear",
        "mind",
        "calm",
        "mood",
        "tablets",
        "hormone",
        "free",
        "supplement",
        "for",
        "brain",
        "fog",
        "stress",
        "relief",
        "centrum"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 72,
        "safety": 70,
        "transparency": 62,
        "sustainability": 48
      },
      "price": 22.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198139453637",
      "vsf_explanation": "Haleon/Centrum menopause formula typically includes ashwagandha (KSM-66 300 mg), L-theanine 100 mg, and B vitamins for mood/focus. Mainstream pharma-owned brand with strong GMP. Evidence-anchored dosing on ashwagandha and L-theanine (Kimura 2007). Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "clean-creatine",
      "title": "Clean Creatine",
      "vendor": "Be Amazing",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CleanCreatineTangyOrange.png?v=1778346603",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "clean",
        "creatine",
        "amazing"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 80,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198162030789",
      "vsf_explanation": "Creatine monohydrate has the strongest evidence base of any sports supplement (Kreider 2017 ISSN). Empty body means no Creapure branding, no third-party testing, no mesh/particle size, and unclear scoop size. Small brand ('Be Amazing') without established provenance. Category evidence carries it to mid-Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "whey-protein-isolate-with-creatine-single-serve-packets",
      "title": "Whey Protein Isolate with Creatine | Single-Serve Packets",
      "vendor": "Nutrition On The Go",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Vanilla_15-1_87295881-49b4-497d-ab3f-1d60ba28485d.png?v=1778346614",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "whey",
        "protein",
        "isolate",
        "with",
        "creatine",
        "single",
        "serve",
        "packets",
        "nutrition",
        "the"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198162292933",
      "vsf_explanation": "25 g whey isolate plus 5 g micronized creatine monohydrate hits both clinically effective doses (Morton 2018 protein meta; Kreider 2017 creatine review). U.S. dairy source, certified facilities, disclosed macros. Loses points on limited third-party testing evidence and generic packet branding.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fulldissolve™-nano-creatine-monohydrate-gummies-3-day-trial-pack",
      "title": "FullDissolve™ Nano-Creatine Monohydrate Gummies  (3-Day Trial Pack)",
      "vendor": "Arq8",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Arq8_3daypackbag_NoBG1.png?v=1778346632",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fulldissolve",
        "nano",
        "creatine",
        "monohydrate",
        "gummies",
        "day",
        "trial",
        "pack",
        "arq8"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 65,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 10,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198162849989",
      "vsf_explanation": "Delivers the 5 g clinical creatine dose per serving (aligned with Kreider 2017 ISSN) alongside taurine, succinic acid, and zinc. 'Nano-creatine' branding is marketing rather than evidence-backed, and gummies raise stability concerns for creatine monohydrate (Jager 2011). Sits mid-Standard as a novel-format creatine at correct dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pre-workout-creatine-patches-with-creatine-monohydrate-pyruvate-36-patches",
      "title": "Pre Workout Creatine Patches with Creatine Monohydrate & Pyruvate, 36 patches",
      "vendor": "TOLEVITA",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CreatinePatch_1.jpg?v=1778346641",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pre",
        "workout",
        "creatine",
        "patches",
        "with",
        "creatine",
        "monohydrate",
        "pyruvate",
        "patches",
        "tolevita"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 8,
        "formulation": 20,
        "manufacturing": 40,
        "safety": 60,
        "transparency": 25,
        "sustainability": 35
      },
      "price": 16.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198163570885",
      "vsf_explanation": "Transdermal creatine has no published RCT support for meaningful muscle-creatine loading; the molecule is too polar for effective skin absorption (Kreider ISSN position 2017 explicitly recommends oral loading). Marketing claims of endurance and recovery are not supported by trial data.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "mk-7-vitamin-k-2-100mcg",
      "title": "MK-7 Vitamin K-2 100mcg",
      "vendor": "Country Life Natural Foods",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MK-7_Vitamin_K-2_100mcg-884976.png?v=1778346680",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "100mcg",
        "country",
        "life",
        "natural",
        "foods"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 72,
        "manufacturing": 65,
        "safety": 78,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 16.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198164259013",
      "vsf_explanation": "MK-7 form of vitamin K2 at 100 mcg matches the dose in Knapen 2015 (three-year RCT showing improved arterial stiffness and bone mineral content). MK-7 has a longer half-life than MK-4 (Sato 2020). Distributed by Country Life with a NOW Foods relabel note - middling transparency but a clinically meaningful dose and form.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "b-50-tablets",
      "title": "B-50 Tablets",
      "vendor": "Country Life Natural Foods",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/B-50_Tablets-751569.png?v=1778346688",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tablets",
        "country",
        "life",
        "natural",
        "foods"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 70,
        "manufacturing": 75,
        "safety": 68,
        "transparency": 65,
        "sustainability": 60
      },
      "price": 31.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198164422853",
      "vsf_explanation": "Full B-complex at 50 mg core B-vitamin doses plus 400 mcg folate, choline, and inositol; forms and doses fully disclosed on label. Country Life has NPA A-rated GMP certification and long operating history since 1968. Vegan, kosher, non-GMO. Placement near Verified is driven by transparent labeling and GMP, though third-party testing panels would push it higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "xtravit-vitamin-k-capsules-30-ct",
      "title": "Xtravit Vitamin K Capsules (30 ct)",
      "vendor": "Farmacias Savia",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/XTRAVIT_VITAMIN_K_30_CAP_850041239279_4f754409-da67-4c75-995c-a0da807ffa00.png?v=1778346693",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "xtravit",
        "vitamin",
        "capsules",
        "farmacias",
        "savia"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 35,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 30,
        "sustainability": 35
      },
      "price": 5.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198164619461",
      "vsf_explanation": "'Xtravit Vitamin K' Spanish-language listing does not disclose K1 vs K2 (MK-4/MK-7), no dose. K2 MK-7 RCTs (Knapen 2013) support 180 mcg/day for bone density. Cannot evaluate without form/dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "kick-it-allergy-seasonal-rescue-for-kids",
      "title": "Kick-It Allergy, Seasonal Rescue For Kids",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ALGPTc2_656490016023_Kick-It_Allergy_background_7ba2f184-5cb2-4cfd-a5f5-40994dbbd410.jpg?v=1778346801",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "youth_under_18",
      "tokens": [
        "kick",
        "allergy",
        "seasonal",
        "rescue",
        "for",
        "kids",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 65,
        "safety": 60,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 21.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198166782149",
      "vsf_explanation": "Kid-formulated seasonal-allergy tincture with yerba santa, nettle, and echinacea, weight-based dosing. Freeze-dried nettle has a small RCT for allergic rhinitis (Roschek 2009 in vitro; Mittman 1990 clinical showed modest symptom improvement). No pediatric trials for this blend. Standard on brand quality and reasonable dosing protocol.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "kick-ass-sinus-move-soothe",
      "title": "Kick-Ass Sinus, Move & Soothe",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SINm1_656490813714_Kick-Ass_Sinus_background_f5f5e863-928a-41ba-a5ef-7ba8b576d40c.jpg?v=1778346807",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "kick",
        "ass",
        "sinus",
        "move",
        "soothe",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 65,
        "safety": 60,
        "transparency": 50,
        "sustainability": 60
      },
      "price": 12.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198166913221",
      "vsf_explanation": "Nine-herb sinus tincture (baptisia, red root, horseradish, sage, etc.) for upper-respiratory drainage support. No RCT evidence for this blend; individual herbs have ethnobotanical use. WishGarden manufacturing/traceability supports Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "growing-pains-ache-away-for-kids",
      "title": "Growing Pains, Ache Away For Kids",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/GROPTc2_656490674025_Growing_Pains_background_79b24ffa-0071-4dcd-b45e-14dc1b6329d9.jpg?v=1778346807",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "youth_under_18",
      "tokens": [
        "growing",
        "pains",
        "ache",
        "away",
        "for",
        "kids",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 50,
        "sustainability": 60
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198167044293",
      "vsf_explanation": "USDA Organic herbal tincture (Turmeric, Willow, Chamomile, Milky Oats, Scullcap, Nettle) dosed by child weight. Willow bark's salicylate content raises a Reye-syndrome caution for children — not a disease claim but a safety flag. Herbal doses per pump are not disclosed. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "yerba-mate",
      "title": "Yerba Mate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/YMTSPTs2_656490292724_Yerba_Mate_background_c0252b88-e24e-47b2-bed7-ffdc1117a6df.jpg?v=1778346807",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "yerba",
        "mate",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 30,
        "sustainability": 60
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198167011525",
      "vsf_explanation": "Single-herb yerba mate tincture. Yerba mate provides caffeine and polyphenols with mild metabolic and cognitive effects (Heck & de Mejia 2007), but a pump-dose tincture doesn't disclose mg of caffeine or chlorogenic acid. Chronic high consumption also carries esophageal cancer signal (Loomis 2016).",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "deep-cleanse-reset-flourish",
      "title": "Deep Cleanse, Reset & Flourish",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/TUNEPTm2_656490904726_Deep_Cleanse_background_ab41d1f2-5b58-4f94-b5c3-f3ee447438d7.jpg?v=1778346806",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "deep",
        "cleanse",
        "reset",
        "flourish",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198167077061",
      "vsf_explanation": "Herbal tincture marketed for liver/kidney/lymph cleansing; the general 'detox' premise lacks physiological support in healthy adults (Klein 2015 J Hum Nutr Diet review). Individual botanicals lack per-mL constituent doses. Small vendor with limited manufacturing disclosure.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "deep-stress-daily-calm",
      "title": "Deep Stress, Daily Calm",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/DPSm1_656490358215_Deep_Stress_background_4e084b30-9366-4aa7-90e8-5186bf4b03d3.jpg?v=1778346807",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "deep",
        "stress",
        "daily",
        "calm",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 45,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 28,
        "sustainability": 60
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198167306437",
      "vsf_explanation": "USDA Organic 8-herb ashwagandha + nervine tincture. Ashwagandha has stress-reduction RCT support (Chandrasekhar 2012) but the blend format hides per-herb doses. USDA Organic and Vegan certifications lift sustainability slightly.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "maca",
      "title": "Maca",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MACSPTs2_656490280721_Maca_background_cf726b79-aecf-4fae-9dd0-fa2f0114ce7a.jpg?v=1778346807",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood",
        "energy",
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "maca",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 30,
        "sustainability": 68
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198166880453",
      "vsf_explanation": "Peruvian fair-trade red + black maca tincture. Maca has modest sexual-desire and mood RCT support at 1.5-3 g dry root/day (Gonzales 2002; Shin 2010), but a pump tincture gives no equivalent mg dose. Strong sustainability story lifts otherwise mediocre transparency.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "candida-rescue-microbiome-stabilizer",
      "title": "Candida Rescue, Microbiome Stabilizer",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CANPTm2_656490243726_Candida_Rescue_background_60d449b8-99f2-464c-b2c9-0cf3cdc898c1.jpg?v=1778346807",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "candida",
        "rescue",
        "microbiome",
        "stabilizer",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 21.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198167175365",
      "vsf_explanation": "Herbal tincture aimed at 'candida balance' — a category that lacks strong clinical evidence outside of confirmed candidiasis. Doses per 3 mL serving not disclosed. Gluten-free/vegan; brand has a decades-long track record. Standard on brand reputation only.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "motherwort",
      "title": "Motherwort",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MOTSPTs2_656490235820_Motherwort_background_9c304599-8bbe-4c29-9b19-5df2c59a84d1.jpg?v=1778346807",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "motherwort",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 45,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 28,
        "sustainability": 55
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198167142597",
      "vsf_explanation": "Single-herb motherwort (Leonurus cardiaca) tincture. Only small pilot data exist for hypertension and mood (Shikov 2011), and human RCT evidence is thin. No standardized leonurine content and no per-pump mg disclosed.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "chlorophyll-friends",
      "title": "Chlorophyll & Friends",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CHLPTm2_656490766720_Chlorophyll_Friends_background_d01b427f-d1a5-45f3-a597-d5551103f592.jpg?v=1778346807",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chlorophyll",
        "friends",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants",
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 65,
        "safety": 60,
        "transparency": 50,
        "sustainability": 60
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198167273669",
      "vsf_explanation": "Liquid chlorophyll + adaptogenic and nutritive herbs, 20 drops in water up to 4x/day. Oral chlorophyll evidence is thin — most 'alkalinizing/oxygenating' claims don't survive scrutiny (blood pH is homeostatically regulated). Standard tier reflects brand quality rather than clinical evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "postpartum-emotional-baby-blues",
      "title": "Postpartum Emotional, Baby Blues",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BABPTg2_656490551227_Postpartum_Emotional_background_62dd7fc9-c168-4a6f-ab3d-c949f0acaf9f.jpg?v=1778346807",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "postpartum",
        "emotional",
        "baby",
        "blues",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 42,
        "manufacturing": 55,
        "safety": 45,
        "transparency": 25,
        "sustainability": 55
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198167535813",
      "vsf_explanation": "Postpartum mood herbal tincture. No published RCTs for this or an equivalent blend for postpartum blues; St. John's wort (a common ingredient in mood blends) is not recommended while breastfeeding (Klier 2006). Formula not disclosed.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "rebalance-after-birth-hormonal",
      "title": "ReBalance, After Birth Hormonal",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/REBPTg2_656490559223_ReBalance_background_0789b6e4-73df-4636-b73b-dc5b2935d42d.jpg?v=1778346807",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "rebalance",
        "after",
        "birth",
        "hormonal",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health",
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 65,
        "safety": 60,
        "transparency": 50,
        "sustainability": 60
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198167437509",
      "vsf_explanation": "Postpartum hormone-support tincture, safe for nursing per label (traces of gluten-free alcohol equivalent to a ripe banana per serving). 3 mL 2-3x/day for 2-6 weeks. No RCT evidence for this specific herbal blend in postpartum populations. Standard on brand quality and clear postpartum-appropriate dosing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "stress-release-tension-tamer-for-pregnancy",
      "title": "Stress Release, Tension Tamer for Pregnancy",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SRPPTg2_656490014227_Stress_Release_background_85b6000c-01f7-43b2-8ab2-ca672857b021.jpg?v=1778346807",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "prenatal",
      "tokens": [
        "stress",
        "release",
        "tension",
        "tamer",
        "for",
        "pregnancy",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 40,
        "sustainability": 60
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198167208133",
      "vsf_explanation": "Multi-herb liquid tincture (motherwort, skullcap, oat) marketed for pregnancy stress. Individual herb quantities per 3mL serving are not disclosed and no RCTs test this specific blend in pregnancy; traditional botanicals have limited high-quality trial support (Ockene 2013 reviews limited pregnancy herbal safety data). Gluten-free/vegan and reformulated to <10% alcohol are positives, but transparency and evidence fall short.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "turmeric-1",
      "title": "Turmeric",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/TURSPTs2_656490286723_Turmeric_background_4e254045-69bd-4d89-b8f8-85ed6ac66ba9.jpg?v=1778346807",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "turmeric",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 42,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 25,
        "sustainability": 55
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198167503045",
      "vsf_explanation": "Single-herb turmeric tincture (alcohol + glycerin + water). Curcumin has osteoarthritis and inflammation RCT support (Daily 2016 meta-analysis) but only at 1000 mg standardized curcuminoids with piperine or lipid formulation; a plain tincture without curcuminoid % is not comparable.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "afterease-for-after-birth-contractions",
      "title": "AfterEase For After Birth Contractions",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/AFTPTg2_656490059228_AfterEase_background_211dc36c-8237-4f9d-9d33-5fefe1655694.jpg?v=1778346807",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "afterease",
        "for",
        "after",
        "birth",
        "contractions",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 40,
        "sustainability": 60
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198167601349",
      "vsf_explanation": "Herbal tincture (3mL in water) traditionally used for postpartum uterine cramping — includes crampbark and motherwort in an undisclosed-dose blend. No modern RCTs support postpartum efficacy; herbal use in nursing mothers requires practitioner guidance. Gluten-free/vegan and low-alcohol are positives.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "get-over-it-immune-recovery",
      "title": "Get Over It!, Immune Recovery",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/GETm1_656490600710_Get_Over_It_background_a7c28e01-bc95-4fe8-af0d-c1cfc4ac3fd7.jpg?v=1778346807",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "get",
        "over",
        "immune",
        "recovery",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 22,
        "sustainability": 55
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198167732421",
      "vsf_explanation": "Immune-recovery herbal tincture blend. No ingredient panel in listing, no per-herb mg, no RCT for the exact formula. Elderberry has cold-duration data (Tiralongo 2016) but at 300 mg standardized extract - not verifiable here.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "digestive-rescue-gi-normalizer-for-kids",
      "title": "Digestive Rescue, GI Normalizer for Kids",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/TUMPTc2_656490902029_Digestive_Rescue_KIDS_background_463dd68a-792c-410f-9bec-ceeb12bb72fa.jpg?v=1778346807",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "youth_under_18",
      "tokens": [
        "digestive",
        "rescue",
        "normalizer",
        "for",
        "kids",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 50,
        "sustainability": 60
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198167666885",
      "vsf_explanation": "Culinary herbs (traditionally chamomile, fennel, ginger family) with weight-based pediatric pumps; USDA Organic and gluten-free. Alcohol-based tincture is a concern for kids despite low per-serving level. Traditional GI-soothing herbs have limited pediatric RCT evidence; no per-herb mg disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "kick-it-biotic-immune-hero-for-kids",
      "title": "Kick-It Biotic, Immune Hero For Kids",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BIKPTc2_656490184029_Kick-It_Biotic_background_99f1d474-9842-435e-80e3-02d9fa4c4097.jpg?v=1778346807",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "youth_under_18",
      "tokens": [
        "kick",
        "biotic",
        "immune",
        "hero",
        "for",
        "kids",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 48,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 50,
        "sustainability": 60
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198167699653",
      "vsf_explanation": "Kid-directed immune herbal tincture. Some botanicals (elderberry, echinacea) have modest pediatric evidence (Tiralongo 2016) but this formula's ingredients and doses are not clearly detailed. Alcohol carrier is a modest safety consideration despite marketing about 'ripe banana' equivalence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "immune-boost-seasonal-rescue-for-pregnancy",
      "title": "Immune Boost, Seasonal Rescue for Pregnancy",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/IBPPTg2_656490825229_Immune_Boost_background_3cf9dac7-bada-4cd3-a9ed-9839891f8308.jpg?v=1778346807",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "prenatal",
      "tokens": [
        "immune",
        "boost",
        "seasonal",
        "rescue",
        "for",
        "pregnancy",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 40,
        "sustainability": 60
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198167830725",
      "vsf_explanation": "Herbal blend positioned for immune 'seasonal rescue' during pregnancy. Elderberry/echinacea-family evidence exists for cold shortening (Hawkins 2019 elderberry meta-analysis) but this specific blend has no trials and per-herb doses are undisclosed. Vegan/gluten-free with reduced alcohol.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "serious-relaxer-muscle-tension",
      "title": "Serious Relaxer & Muscle Tension",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/LAXm1_656490943718_Serious_Relaxer_background_bfed30a2-0325-4d7e-add3-71d70d301862.jpg?v=1778346807",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "serious",
        "relaxer",
        "muscle",
        "tension",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 22,
        "sustainability": 55
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198167896261",
      "vsf_explanation": "Muscle-relaxer nervine tincture. Skullcap, valerian, passionflower blends have some sedation data (Miroddi 2013 valerian) but only at defined doses (e.g., 300-600 mg valerian extract). No formula details or mg values provided here.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "goats-rue-lactation-aid",
      "title": "Goat's Rue, Lactation Aid",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/GOAPTg2_656490640228_Goat_s_Rue_background_1a5f1744-99a9-4177-949f-66a323cbb07c.jpg?v=1778346840",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "goat",
        "rue",
        "lactation",
        "aid",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 30,
        "sustainability": 55
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198168551621",
      "vsf_explanation": "Single-herb goat's rue (Galega officinalis) tincture. Traditional galactagogue use has minimal controlled evidence; Bazzano 2016 review found insufficient data. Raw goat's rue is toxic to livestock so safety hinges on preparation; dose per pump not disclosed.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "kick-it-immune-activator-for-kids",
      "title": "Kick-It Immune, Activator For Kids",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/KKDPTc2_656490185026_Kick-It_Immune_background_c4f14f70-d109-4247-840b-8f260a96cf6a.jpg?v=1778346845",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "youth_under_18",
      "tokens": [
        "kick",
        "immune",
        "activator",
        "for",
        "kids",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 45,
        "transparency": 22,
        "sustainability": 55
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198168846533",
      "vsf_explanation": "Pediatric herbal immune blend. Elderberry syrup has pediatric cold data (Kong 2009) at defined mL doses of standardized extract; this tincture provides neither ingredient list nor per-herb mg. Pediatric use raises the bar on safety and dose transparency.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "kick-it-cough-soothing-quieting-for-kids",
      "title": "Kick-It Cough, Soothing & Quieting For Kids",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/COKPTc2_656490257020_Kick-It_Cough_background_d4f574a1-51a5-451f-8207-78ec9e9f503a.jpg?v=1778346845",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "youth_under_18",
      "tokens": [
        "kick",
        "cough",
        "soothing",
        "quieting",
        "for",
        "kids",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 48,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 50,
        "sustainability": 60
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198168813765",
      "vsf_explanation": "Herbal cough tincture for pediatric use. Traditional demulcents can offer symptomatic relief but pediatric cough remedies are largely no-better-than-placebo per Cochrane (Oduwole 2018). Doses of individual botanicals are not disclosed; alcohol carrier remains a mild pediatric concern.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "deep-lung-bronchial-support",
      "title": "Deep Lung, Bronchial Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/LUNm1_656490103716_Deep_Lung_background_f548b78a-939e-4487-8ad4-44ffed80819d.jpg?v=1778346845",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "deep",
        "lung",
        "bronchial",
        "support",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 48,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 40,
        "sustainability": 60
      },
      "price": 12.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198169043141",
      "vsf_explanation": "9-herb respiratory tincture (Elecampane, Mullein, Osha, Yerba Santa) with strong reviews but no clinical trials on the blend. Traditional respiratory herbs have limited modern RCT evidence; per-herb doses per 3mL are not stated. Gluten-free.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "deep-recovery-muscular-skeletal",
      "title": "Deep Recovery, Muscular & Skeletal",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MUSPTm2_656490803722_Deep_Recovery_background_56558e82-ee8a-43ee-ac88-34fe8c46e558.jpg?v=1778346845",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "deep",
        "recovery",
        "muscular",
        "skeletal",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 38,
        "sustainability": 60
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198169239749",
      "vsf_explanation": "Herbal tincture for musculoskeletal recovery with undisclosed per-herb doses. Joint-recovery botanical evidence is thin outside curcumin/boswellia at specific standardized doses (Daily 2016 curcumin meta-analysis). This blend lacks trials and dose transparency.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "happy-ducts-free-the-flow",
      "title": "Happy Ducts, Free the Flow",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MASPTg2_656490208220_Happy_Ducts_background_4eb2c3a8-8c62-41e6-98f2-47cc81301ca1.jpg?v=1778346845",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "happy",
        "ducts",
        "free",
        "the",
        "flow",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 38,
        "sustainability": 60
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198168912069",
      "vsf_explanation": "Short-course herbal tincture for clogged ducts (2mL every 1-3 hours). No RCTs on this blend for lactation duct issues; per-herb doses not disclosed. Vegan and gluten-free.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "cycle-vitality-1-follicular-phase-estrogen-support",
      "title": "Cycle Vitality 1, Follicular Phase - Estrogen Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CV1PTw2_656490573229_Cycle_Vitality_1_background_91eb9820-aba4-4567-a723-4be7547df8b3.jpg?v=1778346845",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "cycle",
        "vitality",
        "follicular",
        "phase",
        "estrogen",
        "support",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 48,
        "manufacturing": 55,
        "safety": 45,
        "transparency": 42,
        "sustainability": 60
      },
      "price": 21.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198168977605",
      "vsf_explanation": "Contains Black Cohosh and Vitex — both have modest RCT support (Vitex for PMS: Schellenberg 2001), but efficacy is dose-dependent (Vitex 20-40mg standardized). This tincture does not disclose the standardized dose delivered per 3mL, and Black Cohosh has hepatotoxicity signals warranting transparency.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "lymph-mover-immune-strength",
      "title": "Lymph Mover, Immune Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/LYMPTm2_656490142722_Lymph_Mover_background_e6b8bf45-8d12-4b5f-b75b-3fee3976fe16.jpg?v=1778346845",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lymph",
        "mover",
        "immune",
        "strength",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 45,
        "sustainability": 60
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198169174213",
      "vsf_explanation": "Herbal tincture for 'lymph movement' — a wellness concept without strong RCT support. Reputable small brand with organic sourcing but per-herb doses per 3 mL are not disclosed. Reasonable Standard placement.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "kidney-strength-daily-support",
      "title": "Kidney Strength, Daily Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/KIDPTm2_656490083728_Kidney_Strength_background_fc889829-e276-4ab8-a58f-74d174f6e2bc.jpg?v=1778346845",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "kidney",
        "strength",
        "daily",
        "support",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 45,
        "sustainability": 60
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198169305285",
      "vsf_explanation": "Herbal 'kidney tonic' — no clinical trials support this framing for healthy adults, and CKD patients should avoid unsupervised botanicals. Small quality-focused brand but per-herb doses not shown. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "milk-rich-supply-booster",
      "title": "Milk Rich, Supply Booster",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MILPTg2_656490782225_Milk_Rich_background_7e9fb815-4416-45d8-95c4-67023264af8c.jpg?v=1778346846",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "milk",
        "rich",
        "supply",
        "booster",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 45,
        "transparency": 22,
        "sustainability": 55
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198169403589",
      "vsf_explanation": "Fenugreek-family galactagogue blend. Fenugreek has mixed lactation data (Khan 2018 meta-analysis) and can affect infant glycemia. Formula and per-herb mg not disclosed; safety in lactation requires precise dosing not provided here.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "liver-strength-daily-support",
      "title": "Liver Strength, Daily Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/LIVPTm2_656490181721_Liver_Strength_background_faef7b80-c646-45a6-8992-8d8078c19d4b.jpg?v=1778346845",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liver",
        "strength",
        "daily",
        "support",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 45,
        "sustainability": 62
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46198169501893",
      "vsf_explanation": "USDA Organic herbal tincture using inulin-rich nutritive herbs. 'Detox' claims outpace evidence for healthy livers, but formulation is gentle and brand quality is decent. Per-herb doses not disclosed. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "premium-vibroacoustic-therapy-meditation-cushion-bundle",
      "title": "Premium Vibroacoustic Therapy Meditation Cushion Bundle",
      "vendor": "Vibroacoustic Solutions",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Meditation-cushion-bundle2.webp?v=1779410021",
      "score": 22,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "premium",
        "vibroacoustic",
        "therapy",
        "meditation",
        "cushion",
        "bundle",
        "vibroacoustic",
        "solutions"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 15,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 25,
        "sustainability": 30
      },
      "price": 649.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46259170607301",
      "vsf_explanation": "This is a hardware vibroacoustic cushion, not an ingestible supplement. It cannot be scored on the supplement rubric — no ingredients, dose, evidence base, or manufacturing standards apply. Miscategorized for supplement scoring.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "premium-vibroacoustic-zafu-meditation-cushion-bundle",
      "title": "Premium Vibroacoustic Zafu Meditation Cushion Bundle",
      "vendor": "Vibroacoustic Solutions",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Zafu-Cushion-bundle.png?v=1779410034",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "premium",
        "vibroacoustic",
        "zafu",
        "meditation",
        "cushion",
        "bundle",
        "vibroacoustic",
        "solutions"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 25,
        "manufacturing": 35,
        "safety": 60,
        "transparency": 25,
        "sustainability": 30
      },
      "price": 449.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46259170934981",
      "vsf_explanation": "Physical vibroacoustic cushion, not an ingestible supplement. Miscategorized in the supplement queue. Vibroacoustic therapy has some small trial signal for pain/anxiety (Bartel 2017) but nothing supplement-related.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "professional-vibroacoustic-massage-table-attachment-kit",
      "title": "Professional Vibroacoustic Massage Table Attachment Kit",
      "vendor": "Vibroacoustic Solutions",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/attachment-yellow-2-bundle.png?v=1779410035",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "professional",
        "vibroacoustic",
        "massage",
        "table",
        "attachment",
        "kit",
        "vibroacoustic",
        "solutions"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "percussion_vibration"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 829.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46259171000517",
      "vsf_explanation": "A DIY kit that converts a standard massage table into a vibroacoustic therapy platform delivering low-frequency vibration. Vibroacoustic therapy has a small but real research base for pain, anxiety, and Parkinson's symptom management. Aimed at professionals; assembly quality is up to the buyer. Fair Standard entry.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vibroacoustic-therapy-bed-diy-sound-kit-attachments-for-massage-table",
      "title": "Vibroacoustic Therapy Bed DIY Sound Kit Attachments for Massage Table",
      "vendor": "Vibroacoustic Solutions",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Vibroacoustic_Therapy_Bed_DIY_Sound_Kit_Attachments_for_Massage_Table.webp?v=1779410034",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vibroacoustic",
        "therapy",
        "bed",
        "diy",
        "sound",
        "kit",
        "attachments",
        "for",
        "massage",
        "table",
        "vibroacoustic",
        "solutions"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "percussion_vibration"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 649.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46259171098821",
      "vsf_explanation": "Sibling DIY kit from the same brand for retrofitting massage tables with vibroacoustic transducers. Same evidence base for low-frequency somatic vibration; professional-orientation is honest about being a component bundle rather than a finished device.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "echo-whole-home-water-filter",
      "title": "ECHO Whole Home Water Filter",
      "vendor": "Echo Water",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Echo_Pure_Elite_-_Main.jpg?v=1779410282",
      "score": 30,
      "tier": "rejected",
      "certifications": [
        "NSF Certified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "echo",
        "whole",
        "home",
        "water",
        "filter",
        "echo",
        "water"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 25,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 30,
        "sustainability": 35
      },
      "price": 2799.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46259177980101",
      "vsf_explanation": "This is a whole-home carbon water filter, not a dietary supplement. Miscategorized product; the rubric does not apply and it cannot be honestly scored as a supplement. Rejected on category grounds pending taxonomy correction.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "echo-ultimate™-hydrogen-water-machine",
      "title": "ECHO Ultimate™ Hydrogen Water Machine",
      "vendor": "Echo Water",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/echo-ultimatetm-hydrogen-water-machine-echo-water-1.png?v=1779410287",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "echo",
        "ultimate",
        "hydrogen",
        "water",
        "machine",
        "echo",
        "water"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "hbot"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 70,
        "manufacturing": 75,
        "safety": 70,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 3999.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46259178930373",
      "vsf_explanation": "Echo Water is one of the more credible names in the hydrogen-water hardware category, and the Ultimate combines hydrogen, alkaline, acidic, and filtered outputs with a 10-year warranty and under-counter installation. Genuine SPE electrolysis, established support and service, and stronger disclosure than most competitors, but H2 clinical evidence for wellness/longevity remains suggestive rather than definitive. Upper-Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "echo-ro™-water-filter-machine-tankless-reverse-osmosis",
      "title": "ECHO RO™ Water Filter Machine (Tankless Reverse Osmosis)",
      "vendor": "Echo Water",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/echo-rotm-water-filter-tankless-reverse-osmosis-echo-water-1.png?v=1779410287",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "echo",
        "water",
        "filter",
        "machine",
        "tankless",
        "reverse",
        "osmosis",
        "echo",
        "water"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "hbot"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 559.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46259179225285",
      "vsf_explanation": "Echo Water's tankless 4-stage under-sink RO filter. It is a legitimate consumer RO system, but pure drinking-water filtration is not a biohacking device category — it belongs in a home-appliance/water-treatment vertical, and Vyvata's taxonomy has no honest home for it. Auto-failed as out of scope so it doesn't distort the recovery-therapy subcategory.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "echo-revive-hydrogen-bath-water-machine",
      "title": "ECHO Revive Hydrogen Bath Water Machine",
      "vendor": "Echo Water",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/OL6A0077Revive_51b6ad24-4218-4908-822d-423d0ea91cf7.webp?v=1779410287",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "echo",
        "revive",
        "hydrogen",
        "bath",
        "water",
        "machine",
        "echo",
        "water"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 60,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 5999.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46259178897605",
      "vsf_explanation": "Echo's whole-tub hydrogen infusion device for warm-water bathing. Transdermal H2 uptake evidence is thinner than oral hydrogen-water evidence, but this is real hardware from a serious brand at a $6k price point rather than a novelty. Solid mid-Standard for a premium recovery bathing accessory.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "echo-h2®-hydrogen-water-machine",
      "title": "ECHO H2® Hydrogen Water Machine",
      "vendor": "Echo Water",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/echo-h2-r-hydrogen-water-machine-echo-water-1.png?v=1779410287",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "echo",
        "hydrogen",
        "water",
        "machine",
        "echo",
        "water"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "hbot"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 65,
        "manufacturing": 70,
        "safety": 65,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 2399.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46259179061445",
      "vsf_explanation": "Echo H2 is a countertop or under-counter hydrogen-only machine that leaves pH unchanged — mechanistically cleaner than combined alkaline/hydrogen units. Echo Water is a reputable H2 hardware brand with genuine support and warranty. Molecular hydrogen has honest but limited human evidence for oxidative stress and recovery, which caps the ceiling. Upper-Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "echo-flask-hydrogen-water-bottle",
      "title": "ECHO Flask Hydrogen Water Bottle",
      "vendor": "Echo Water",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Slide_1.png?v=1779410287",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "echo",
        "flask",
        "hydrogen",
        "water",
        "bottle",
        "echo",
        "water"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "hbot"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 65,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 239.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46259179192517",
      "vsf_explanation": "Portable Echo Flask claims 8 ppm dissolved H2 with app connectivity and session tracking. If accurate, that puts it near the top of the consumer portable H2 bottle segment; Echo Water backs it with a real brand and service network. Hydrogen evidence still moderates the ceiling. Solid Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "alchemy-h2-hydrogen-water-bottle",
      "title": "Alchemy H2 Hydrogen Water Bottle",
      "vendor": "Nushape",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/PDP_hydrogen_bottle_image_1024_x_1024_02_92033d88-3a95-412b-a1a6-f201f3e1e722.jpg?v=1779410325",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alchemy",
        "hydrogen",
        "water",
        "bottle",
        "nushape"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "hbot"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 298,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46259180372165",
      "vsf_explanation": "Portable H2 bottle from Nushape, a known consumer wellness brand, quoting up to 10,000 ppb dissolved hydrogen. Molecular hydrogen literature is modest but non-empty for oxidative stress and exercise-recovery outcomes; this unit sits above generic no-name bottles but below professional SPE/PEM systems in transparency. Lands at the Standard threshold.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hydrowata™-hydrogen-water-tablets-90-servings",
      "title": "HydroWata™ | Hydrogen Water Tablets 90 Servings",
      "vendor": "HydroWata",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HydroWata_Tablets_LDP_IMG-01.jpg?v=1779410337",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hydrowata",
        "hydrogen",
        "water",
        "tablets",
        "servings",
        "hydrowata"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 44.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46259180568773",
      "vsf_explanation": "Molecular hydrogen tablets. Small RCTs show modest antioxidant markers (Ostojic 2018), but effect sizes are small and outcomes clinically limited. Empty product body, no ppm hydrogen dissolved per tablet stated, no COA. Not enough to clear the Standard threshold.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hydrowata™-hydrogen-water-bottle",
      "title": "HydroWata™ Hydrogen Water Bottle",
      "vendor": "HydroWata",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/IMG-21.webp?v=1779410349",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hydrowata",
        "hydrogen",
        "water",
        "bottle",
        "hydrowata"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "hbot"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 35,
        "manufacturing": 30,
        "safety": 45,
        "transparency": 25,
        "sustainability": 35
      },
      "price": 59.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46259180994757",
      "vsf_explanation": "A budget hydrogen water bottle with no disclosed hydrogen concentration (ppm), no electrolyzer technology detail (PEM/SPE vs open electrolysis), and no independent verification. 'HydroWata' has no meaningful brand footprint outside the listing. Molecular hydrogen has some emerging evidence but is heavily dose-dependent, and this SKU documents nothing. Rejected on brand provenance.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "3-pack-alkaline-ionizer-hydrogen-water-stick-w-protective-case-3-for-the-price-of-1",
      "title": "3 Pack - Alkaline Ionizer Hydrogen Water Stick w/ Protective Case (3 for the price of 1)",
      "vendor": "Your Emf Shield",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitled_1000_x_1000_px_3.png?v=1779410368",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pack",
        "alkaline",
        "ionizer",
        "hydrogen",
        "water",
        "stick",
        "protective",
        "case",
        "for",
        "the",
        "price",
        "your",
        "emf",
        "shield"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 15,
        "manufacturing": 25,
        "safety": 30,
        "transparency": 15,
        "sustainability": 20
      },
      "price": 39.87,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46259181519045",
      "vsf_explanation": "Not a supplement - a plastic water 'ionizer' stick. Alkaline-water health claims not supported by clinical evidence (see peer review of Koufman 2012). Miscategorized product with no ingested actives.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "hydrogen-water-generator",
      "title": "Hydrogen Water Generator",
      "vendor": "Anti Spier",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3b6tzztoBFozgZ6.webp?v=1779410440",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hydrogen",
        "water",
        "generator",
        "anti",
        "spier"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 15,
        "manufacturing": 25,
        "safety": 25,
        "transparency": 15,
        "sustainability": 20
      },
      "price": 54.82,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46259182862533",
      "vsf_explanation": "Hydrogen water generator device, not a supplement. Marketing text explicitly claims to 'transform blood glucose and HbA1c levels - a game-changer for those fighting against diabetes,' which is a disease claim without RCT anchor for this format.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "10-2-energy-therapy-series-singing-bowl-1800g",
      "title": "10.2\" Energy Therapy Series Singing Bowl, 1800g",
      "vendor": "Utah Energy Healing Center",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SB-E-1800_web_lifestyle_main.jpg?v=1779410693",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "energy",
        "therapy",
        "series",
        "singing",
        "bowl",
        "1800g",
        "utah",
        "energy",
        "healing",
        "center"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 15,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 20,
        "sustainability": 25
      },
      "price": 399.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46259244040389",
      "vsf_explanation": "Bronze singing bowl - not a supplement. Sound-therapy relaxation claims have low-quality evidence (Goldsby 2017 pilot); the product is a musical instrument, not an ingested formula.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "planetary-tuned-therapy-tuning-fork-venus-110-62-hz",
      "title": "Planetary Tuned Therapy Tuning Fork, Venus 110.62 Hz",
      "vendor": "Utah Energy Healing Center",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/TTF-V-G_web_with_background_main.jpg?v=1779410707",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "planetary",
        "tuned",
        "therapy",
        "tuning",
        "fork",
        "venus",
        "110",
        "utah",
        "energy",
        "healing",
        "center"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 5,
        "formulation": 20,
        "manufacturing": 40,
        "safety": 60,
        "transparency": 25,
        "sustainability": 30
      },
      "price": 199.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46259244236997",
      "vsf_explanation": "Tuning fork product, not a supplement. 'Planetary tuning' and love/harmony claims have no biomedical evidence base.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "solfeggio-crystal-tuning-fork-396-hz-g4",
      "title": "Solfeggio Crystal Tuning Fork, 396 Hz / G4",
      "vendor": "Utah Energy Healing Center",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SOLCTF396_web_with_background_main.jpg?v=1779410791",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solfeggio",
        "crystal",
        "tuning",
        "fork",
        "396",
        "utah",
        "energy",
        "healing",
        "center"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 5,
        "formulation": 20,
        "manufacturing": 40,
        "safety": 60,
        "transparency": 25,
        "sustainability": 30
      },
      "price": 269.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46259245908165",
      "vsf_explanation": "Crystal tuning fork, not a supplement. Solfeggio frequency claims (releasing fear/guilt) have no controlled evidence.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "9-piece-sound-bath-tube-chimes-solfeggio-set-champagne-gold",
      "title": "9-Piece Sound Bath Tube Chimes Solfeggio Set, Champagne Gold",
      "vendor": "Utah Energy Healing Center",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SBTSETSOL_web_with_background_main.jpg?v=1779410791",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "piece",
        "sound",
        "bath",
        "tube",
        "chimes",
        "solfeggio",
        "set",
        "champagne",
        "gold",
        "utah",
        "energy",
        "healing",
        "center"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 5,
        "formulation": 20,
        "manufacturing": 40,
        "safety": 60,
        "transparency": 25,
        "sustainability": 30
      },
      "price": 699.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46259245940933",
      "vsf_explanation": "Sound-bath tube chime set, not a supplement. Sound-healing/energy claims not evidence-based; miscategorized.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "20-thai-gong",
      "title": "20\" Thai Gong",
      "vendor": "Utah Energy Healing Center",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/THG20_web_with_background_main.jpg?v=1779410791",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "thai",
        "gong",
        "utah",
        "energy",
        "healing",
        "center"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 5,
        "formulation": 20,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 499.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46259245875397",
      "vsf_explanation": "Handcrafted Thai gong, not a supplement. Sound-therapy relaxation claims are not supplement-relevant. Miscategorized in queue.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "2-piece-day-night-planetary-tuned-tuning-fork-set-incl-holder",
      "title": "2-Piece Day & Night Planetary Tuned Tuning Fork Set incl. Holder",
      "vendor": "Utah Energy Healing Center",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/TF-SET-2_web_with_background_main.jpg?v=1779410791",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "piece",
        "day",
        "night",
        "planetary",
        "tuned",
        "tuning",
        "fork",
        "set",
        "incl",
        "holder",
        "utah",
        "energy",
        "healing",
        "center"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 5,
        "formulation": 20,
        "manufacturing": 40,
        "safety": 60,
        "transparency": 25,
        "sustainability": 30
      },
      "price": 119.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46259245809861",
      "vsf_explanation": "Tuning fork set, not a supplement. 'Cosmic Octave' calculations are numerology, not biology.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "planetary-tuned-therapy-tuning-fork-chakra-set-incl-rollup-bag-tuning-fork-vibration-foot",
      "title": "Planetary Tuned Therapy Tuning Fork Chakra Set, Incl. Rollup Bag & Tuning Fork Vibration Foot",
      "vendor": "Utah Energy Healing Center",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/TTF-SET-CHA-R_web_with_background_main.jpg?v=1779410792",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "planetary",
        "tuned",
        "therapy",
        "tuning",
        "fork",
        "chakra",
        "set",
        "incl",
        "rollup",
        "bag",
        "tuning",
        "fork",
        "vibration",
        "foot",
        "utah",
        "energy",
        "healing",
        "center"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 5,
        "formulation": 20,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 25,
        "sustainability": 30
      },
      "price": 699.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46259245842629",
      "vsf_explanation": "Chakra tuning fork set, not a supplement. Chakra alignment lacks any biomedical evidence base.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "planetary-tuned-therapy-tuning-fork-earth-year-68-05-hz",
      "title": "Planetary Tuned Therapy Tuning Fork, Earth-Year 68.05 Hz",
      "vendor": "Utah Energy Healing Center",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/TTF-E-G_web_with_background_main.jpg?v=1779410791",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "planetary",
        "tuned",
        "therapy",
        "tuning",
        "fork",
        "earth",
        "year",
        "utah",
        "energy",
        "healing",
        "center"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 5,
        "formulation": 20,
        "manufacturing": 40,
        "safety": 60,
        "transparency": 25,
        "sustainability": 30
      },
      "price": 199.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46259245973701",
      "vsf_explanation": "Tuning fork, not a supplement. 'Earth-year' resonance grounding claims are not evidence-based.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "grounding-therapy-tuning-fork-weighted-master-fork-64-hz",
      "title": "Grounding Therapy Tuning Fork, Weighted Master Fork 64 Hz",
      "vendor": "Utah Energy Healing Center",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/TTF-64-G_web_with_background_main.jpg?v=1779410791",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "grounding",
        "therapy",
        "tuning",
        "fork",
        "weighted",
        "master",
        "fork",
        "utah",
        "energy",
        "healing",
        "center"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 5,
        "formulation": 20,
        "manufacturing": 40,
        "safety": 60,
        "transparency": 25,
        "sustainability": 30
      },
      "price": 199.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46259246006469",
      "vsf_explanation": "Master tuning fork, not a supplement.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "6-75-essence-solfeggio-crystal-singing-bowl-285-hz-turquoise-green",
      "title": "6.75\" Essence Solfeggio Crystal Singing Bowl, 285 Hz, Turquoise Green",
      "vendor": "Utah Energy Healing Center",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ESOLCSB285_web_with_background_main.jpg?v=1779410796",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "essence",
        "solfeggio",
        "crystal",
        "singing",
        "bowl",
        "285",
        "turquoise",
        "green",
        "utah",
        "energy",
        "healing",
        "center"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 15,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 20,
        "sustainability": 25
      },
      "price": 799.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46259246137541",
      "vsf_explanation": "Quartz singing bowl marketed as 'tuned to 285 Hz for cellular regeneration' - a physiologically implausible claim. Not a supplement.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "solfeggio-crystal-tuning-fork-174-hz-f3",
      "title": "Solfeggio Crystal Tuning Fork, 174 Hz / F3",
      "vendor": "Utah Energy Healing Center",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SOLCTF174_web_with_background_main.jpg?v=1779410796",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solfeggio",
        "crystal",
        "tuning",
        "fork",
        "174",
        "utah",
        "energy",
        "healing",
        "center"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 5,
        "formulation": 20,
        "manufacturing": 40,
        "safety": 60,
        "transparency": 25,
        "sustainability": 30
      },
      "price": 299.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46259246203077",
      "vsf_explanation": "Crystal tuning fork, not a supplement. 174 Hz 'grounding and physical healing' claim has no biomedical support.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "grounding-series-singing-bowl-5000g",
      "title": "Grounding Series Singing Bowl, 5000g",
      "vendor": "Utah Energy Healing Center",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SB-G-5000_web_with_background_main.jpg?v=1779410795",
      "score": 22,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "grounding",
        "series",
        "singing",
        "bowl",
        "5000g",
        "utah",
        "energy",
        "healing",
        "center"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 8,
        "formulation": 20,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 1399,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46259246170309",
      "vsf_explanation": "Bronze singing bowl, not a supplement. Meditation with singing bowls has small stress-reduction data (Goldsby 2017) but not as a supplement.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "frosted-quartz-singing-bowls-432hz-chakra-tuned-white-or-black",
      "title": "Frosted Quartz Singing Bowls — 432Hz Chakra-Tuned (White or Black)",
      "vendor": "ThreeCrowsLLP",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/rn-image_picker_lib_temp_75e37553-a549-4c59-8cf1-8606101ddda2.jpg?v=1779410835",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "frosted",
        "quartz",
        "singing",
        "bowls",
        "432hz",
        "chakra",
        "tuned",
        "white",
        "black",
        "threecrowsllp"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 5,
        "formulation": 20,
        "manufacturing": 40,
        "safety": 60,
        "transparency": 25,
        "sustainability": 30
      },
      "price": 125,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46259246858437",
      "vsf_explanation": "Quartz singing bowl set, not a supplement. Chakra/432 Hz claims are not supported by biomedical evidence.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "olive-opal-sphere-75-76mm",
      "title": "Olive Opal Sphere 75-76mm",
      "vendor": "Crystal Destiny",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Olive-Opal-Sphere-75-76mm-Spheres-Olive-Opal-522g-76mm.jpg?v=1779410895",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "olive",
        "opal",
        "sphere",
        "76mm",
        "crystal",
        "destiny"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 3,
        "formulation": 15,
        "manufacturing": 40,
        "safety": 60,
        "transparency": 25,
        "sustainability": 25
      },
      "price": 69.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46259250528453",
      "vsf_explanation": "Polished mineral sphere, not a supplement. No biomedical effect. Miscategorized in supplement queue.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "caribbean-calcite-cut-corner-cube",
      "title": "Caribbean Calcite Cut Corner Cube",
      "vendor": "Crystal Destiny",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Caribbean-Calcite-Cut-Corner-Cube-Cubes.jpg?v=1779410895",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "caribbean",
        "calcite",
        "cut",
        "corner",
        "cube",
        "crystal",
        "destiny"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 0,
        "transparency": 0,
        "sustainability": 0
      },
      "price": 64.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46259250561221",
      "vsf_explanation": "Not a supplement — a decorative crystal cube. Metaphysical/chakra claims are not ingestible and cannot be scored against the supplement rubric. Excluded from the supplement listing.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "golden-aventurine-sphere-50mm",
      "title": "Golden Aventurine Sphere 50mm",
      "vendor": "Crystal Destiny",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Golden-Aventurine-Sphere-50mm-Spheres-Aventurine-175g-50mm.jpg?v=1779410895",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "golden",
        "aventurine",
        "sphere",
        "50mm",
        "crystal",
        "destiny"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 15,
        "manufacturing": 30,
        "safety": 55,
        "transparency": 20,
        "sustainability": 25
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46259250593989",
      "vsf_explanation": "Polished quartz crystal marketed for 'confidence' and 'prosperity'. Not a supplement — no ingredient, no dose, no evidence base. Metaphysical claims are unfalsifiable and outside the supplement rubric.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "thick-agate-slice-tea-light-candle-holders",
      "title": "Thick Agate Slice Tea Light Candle Holders",
      "vendor": "Crystal Destiny",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Thick-Agate-Slice-Tea-Light-Candle-Holders-Freeforms-Agate-450g-5_50L-x-3_50W-x-1_00.jpg?v=1779410896",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "thick",
        "agate",
        "slice",
        "tea",
        "light",
        "candle",
        "holders",
        "crystal",
        "destiny"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 15,
        "manufacturing": 30,
        "safety": 55,
        "transparency": 20,
        "sustainability": 25
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46259250790597",
      "vsf_explanation": "Agate tea-light holder is a decorative object, not a supplement. No ingredient or evidence framework applies.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "amethyst-slices-polished-crystal",
      "title": "Amethyst Slices, Polished Crystal",
      "vendor": "Crystal Destiny",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Amethyst-Slices-Polished-Crystal-Freeforms-Amethyst-144g-4_50-L-x-3_50W.jpg?v=1779410895",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "amethyst",
        "slices",
        "polished",
        "crystal",
        "crystal",
        "destiny"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 15,
        "manufacturing": 30,
        "safety": 55,
        "transparency": 20,
        "sustainability": 25
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46259250659525",
      "vsf_explanation": "Amethyst crystal slice — decorative/spiritual object, not an ingestible. The supplement rubric does not apply.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "moss-agate-pyramid-2-85-inch-206g-small-growth-stone",
      "title": "Moss Agate Pyramid 2.85 Inch 206g Small Growth Stone",
      "vendor": "Crystal Destiny",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Moss-Agate-Pyramid-2_85-Inch-206g-Small-Growth-Stone-Pyramids.jpg?v=1779410895",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "moss",
        "agate",
        "pyramid",
        "inch",
        "206g",
        "small",
        "growth",
        "stone",
        "crystal",
        "destiny"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 0,
        "transparency": 0,
        "sustainability": 0
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46259250757829",
      "vsf_explanation": "Not a supplement — a polished moss agate crystal pyramid marketed for 'intention-setting'. Not ingestible; outside the supplement rubric's scope.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "malachite-freeform-crystals",
      "title": "Malachite Freeform Crystals",
      "vendor": "Crystal Destiny",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Malachite-Freeform-Crystals-Freeforms-Malachite-152g-3_00-x-3_50.jpg?v=1779410895",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "malachite",
        "freeform",
        "crystals",
        "crystal",
        "destiny"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 0,
        "transparency": 0,
        "sustainability": 0
      },
      "price": 69.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46259250888901",
      "vsf_explanation": "Not a supplement — polished malachite. Note that ingesting malachite dust is actively hazardous (copper toxicity). Cannot be scored against supplement rubric.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "chevron-amethyst-spheres-58-71mm",
      "title": "Chevron Amethyst Spheres 58-71MM",
      "vendor": "Crystal Destiny",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Chevron-Amethyst-Spheres-58-71MM-Spheres-Amethyst-490g-71mm-Diameter.jpg?v=1779410895",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chevron",
        "amethyst",
        "spheres",
        "71mm",
        "crystal",
        "destiny"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 15,
        "manufacturing": 30,
        "safety": 55,
        "transparency": 20,
        "sustainability": 25
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46259251019973",
      "vsf_explanation": "Chevron amethyst sphere — crystal, not a supplement. No dose or evidence to evaluate.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "blood-pressure-monitor-regular-xl-cuffs-by-wizard-research",
      "title": "Blood Pressure Monitor Regular & XL Cuffs by Wizard Research",
      "vendor": "Wizard Research",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/wizard_research_blood_pressure_monitor_cuff_red_box_display.png?v=1779719418",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "blood",
        "pressure",
        "monitor",
        "regular",
        "cuffs",
        "wizard",
        "research",
        "wizard",
        "research"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "blood_pressure"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 45,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 30,
        "sustainability": 35
      },
      "price": 99.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277044306117",
      "vsf_explanation": "Wizard Research is a low-visibility brand whose digital arm-cuff BP monitor is sold through their own Shopify-style site but with no listed FDA 510(k) clearance number, no published validation against AAMI/ESH/BHS protocols, and no third-party accuracy testing. Home BP monitors are a regulated 510(k) device class in the US, and selling one as a BP measurement device without disclosed clearance falls under the unverified_medical_claim rule. The XL-cuff inclusion is a useful feature, but accuracy is the gating concern and there is no evidence it meets it.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "dry-eye-relief-mask-electric-heated-warm-compress-by-wizard-research",
      "title": "Dry Eye Relief Mask Electric Heated Warm Compress by Wizard Research",
      "vendor": "Wizard Research",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/wizard_research_electric_heated_dry_eye_mask_woman_relaxing.jpg?v=1779719432",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dry",
        "eye",
        "relief",
        "mask",
        "electric",
        "heated",
        "warm",
        "compress",
        "wizard",
        "research",
        "wizard",
        "research"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 99.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277044666565",
      "vsf_explanation": "Electric heated eye mask for dry-eye and meibomian gland dysfunction symptoms. Warm compress therapy for MGD is genuinely supported by ophthalmology literature and is a common in-office and at-home protocol. Wizard Research is a small legit brand; the 'trusted by 2,600 eye doctors' claim is marketing hyperbole and no explicit FDA clearance is cited, but it doesn't cross the auto-fail line either.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "white-noise-sleep-machine-with-lights-portable-rechargeable",
      "title": "White Noise Sleep Machine with Lights - Portable & Rechargeable",
      "vendor": "Wizard Research",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/wizard_research_white_noise_machine_rgb_night_light.png?v=1779719440",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "white",
        "noise",
        "sleep",
        "machine",
        "with",
        "lights",
        "portable",
        "rechargeable",
        "wizard",
        "research"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "white_noise_sound"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 45,
        "sustainability": 60
      },
      "price": 79.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277044699333",
      "vsf_explanation": "A generic portable white-noise machine with light functions, no published decibel ceiling and no AAP-aligned safety guidance (the AAP recommends infant sound machines stay under 50 dB and at least 7 ft from a crib). White-noise machines are a low-risk product class and the device likely functions as advertised, but Wizard Research provides no manufacturer disclosure, no FCC/CE documentation visible, and no measured frequency profile. Lands at lower Standard: works for adults, not validated for infants.",
      "vsf_autofail_rule": "Powered Device Without Electrical Certification"
    },
    {
      "handle": "vision-vitamin-pack-daily-essentials-for-eye-health-30-days",
      "title": "Vision Vitamin Pack - Daily Essentials for Eye Health - 30 Days",
      "vendor": "Wizard Research",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/VitaminPackDryEyeHealth.png?v=1779719454",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vision",
        "vitamin",
        "pack",
        "daily",
        "essentials",
        "for",
        "eye",
        "health",
        "days",
        "wizard",
        "research"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277044797637",
      "vsf_explanation": "Daily packet delivers Zn 25 mg, D 5000 IU, Resveratrol 250 mg, Omega-3 750 mg, Vit C 1000 mg — mostly at reasonable doses, and the AREDS2 zinc + antioxidant framework has evidence for AMD (Chew 2013). Omega-3 dose is on the low end for dry eye (DREAM trial used 3 g EPA+DHA). USA-made in claimed clinical-grade facility. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "clutch-clear-anti-blue-light",
      "title": "CLUTCH - Clear Anti-Blue Light",
      "vendor": "Bomber Eyewear",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/clutch-clear-anti-blue-light-8604045.png?v=1779719616",
      "score": 36,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "clutch",
        "clear",
        "anti",
        "blue",
        "light",
        "bomber",
        "eyewear"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_environment"
      ],
      "vsf_dimensions": {
        "evidence": 6,
        "formulation": 4,
        "manufacturing": 10,
        "safety": 8,
        "transparency": 4,
        "sustainability": 4
      },
      "price": 40,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277045485765",
      "vsf_explanation": "Bomber Eyewear is a real US safety-eyewear brand and the CLUTCH frame is ANSI Z87+ certified with documented UVA/UVB protection. However, this is a *clear* lens variant marketed as 'anti-blue light' - clear lenses block far less blue light than amber/orange lenses, and the most recent 2025 meta-analysis of BBG RCTs (Frontiers in Neurology) found no significant effect on objective sleep metrics versus clear-lens controls. No published lux/wavelength filtration spec, no parameter-matched sleep evidence at this product's filter level. Sustainability data not disclosed - neutral 4/8 default applies. Falls short of the 60-point Standard threshold.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cellf-multi-therapy-pemf-mat",
      "title": "Cellf Multi Therapy PEMF Mat",
      "vendor": "Nushape",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/PHOTO-2025-11-05-09-21-49_c75f36fe-317c-4201-92cb-8f27f2eda433.jpg?v=1779720180",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cellf",
        "multi",
        "therapy",
        "pemf",
        "mat",
        "nushape"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 1899,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277047976133",
      "vsf_explanation": "Higher-spec Nushape mat with 25 coils, square-wave PEMF, and disclosed peak field intensity of 34.6 Gauss (with an aggregate 850 Gauss capacity), aimed at professional/at-home whole-body sessions. Better transparency about waveform and field strength than most consumer PEMF mats, though independent clinical evidence for PEMF at these parameters remains modest. Upper-Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "infrared-pemf-mat",
      "title": "Infrared PEMF Mat",
      "vendor": "Nushape",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Infrared_PEMF_Mat.webp?v=1779720184",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "infrared",
        "pemf",
        "mat",
        "nushape"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 1200,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277048008901",
      "vsf_explanation": "Nushape is an established consumer PBM/PEMF brand and this mat layers 1-50 Hz PEMF with far-infrared heat and crystal/grounding layers. FIR heat therapy has moderate recovery evidence; low-intensity PEMF at these frequencies has weaker but not empty clinical support. Fairly priced for the segment; the crystal/grounding narrative is marketing, not mechanism.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mini-cube-sauna-tent-2-person-portable-sauna",
      "title": "Mini Cube Sauna Tent | 2-person portable sauna",
      "vendor": "North Shore Sauna",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Screenshot_2025-03-29_at_8.47.27_AM.png?v=1779720205",
      "score": 58,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mini",
        "cube",
        "sauna",
        "tent",
        "person",
        "portable",
        "sauna",
        "north",
        "shore",
        "sauna"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 17,
        "formulation": 11,
        "manufacturing": 6,
        "safety": 9,
        "transparency": 6,
        "sustainability": 4
      },
      "price": 539.1,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277048271045",
      "vsf_explanation": "Rejected at 58/100. The sauna modality itself has solid PubMed RCT evidence (heat therapy cardiovascular/recovery benefits) and the brand publishes clear specs (5'x5'x5'6\", 200F+ heating, 300D Oxford insulated construction). However Build Quality is the killer: this is a wood-fired tent (stove sold separately) with no UL/ETL/CE electrical cert applicable, no documented material safety testing on contact fabrics, and no published warranty terms or structural certification. Transparency suffers from no published evidence citations on the brand site.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sauna-tent-wood-stove-portable-brushed-stainless",
      "title": "Sauna Tent Wood Stove | Portable | Brushed Stainless",
      "vendor": "North Shore Sauna",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Screenshot_2025-03-29_at_9.44.32_AM.png?v=1779720217",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sauna",
        "tent",
        "wood",
        "stove",
        "portable",
        "brushed",
        "stainless",
        "north",
        "shore",
        "sauna"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 12,
        "manufacturing": 9,
        "safety": 9,
        "transparency": 5,
        "sustainability": 4
      },
      "price": 749,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277048533189",
      "vsf_explanation": "Wood-fired (non-electric) stainless steel sauna stove from a documented US brand; modality (sauna heat therapy) has Grade A RCT evidence for recovery and the brand independently RISE-lab tested tent materials for VOCs which supports build/material credit. However the product itself is a wood-burning stove (no UL/ETL needed but also no third-party structural certification posted), warranty is only 1 year (below the 3+yr threshold), no published evidence citations on product pages, and contraindication disclosure is incomplete.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "2-person-carbon-infrared-sauna-canadian-hemlock-wooden-sauna-1700-watts-premium-audio",
      "title": "2-Person Carbon Infrared Sauna - Canadian Hemlock Wooden Sauna - 1700 Watts - Premium Audio",
      "vendor": "Durasage Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1A.jpg?v=1779720233",
      "score": 55,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "person",
        "carbon",
        "infrared",
        "sauna",
        "canadian",
        "hemlock",
        "wooden",
        "sauna",
        "1700",
        "watts",
        "premium",
        "audio",
        "durasage",
        "health"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 13,
        "formulation": 9,
        "manufacturing": 11,
        "safety": 8,
        "transparency": 4,
        "sustainability": 4
      },
      "price": 3295,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277048631493",
      "vsf_explanation": "Infrared sauna recovery has Grade B evidence (Laukkanen sauna RCTs, infrared CV studies) at temperature ranges roughly matching this product (7+6 in evidence). Durasage markets low-EMF carbon panels and Canadian Hemlock wood but does not publish UL/ETL electrical certification, EMF test data, or VOC/wood treatment documentation on the product page; warranty is only 18 months which is below the 3-year threshold. No published evidence citations, no privacy/FTC disclosure shown, and no sustainability programme — score lands in Rejected.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "luxury-home-sauna-room",
      "title": "Luxury Home Sauna Room",
      "vendor": "Sunflower Fields: Where Happiness Grows",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/tii9fQgOAMrSMGrg.webp?v=1779720260",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "luxury",
        "home",
        "sauna",
        "room",
        "sunflower",
        "fields",
        "where",
        "happiness",
        "grows"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 17,
        "formulation": 3,
        "manufacturing": 0,
        "safety": 6,
        "transparency": 0,
        "sustainability": 4
      },
      "price": 399.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277048893637",
      "vsf_explanation": "Sauna/heat-therapy modality has Grade A RCT evidence (Ahokas 2023, Mero 2015) for athletic recovery and cardiovascular outcomes, so Evidence credit is given. However, the listing is a generic reseller product with no identifiable manufacturer, no UL/ETL/CE electrical safety certification, no warranty info, no material disclosure, and no contraindication guidance — auto-fail under powered-device-without-electrical-certification.",
      "vsf_autofail_rule": "Powered Device Without Electrical Certification"
    },
    {
      "handle": "2l-portable-folding-steam-sauna-spa-gray",
      "title": "2L Portable Folding Steam Sauna Spa-Gray",
      "vendor": "Gamba Beauty",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3_331_75.jpg?v=1779720294",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "portable",
        "folding",
        "steam",
        "sauna",
        "spa",
        "gray",
        "gamba",
        "beauty"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 6,
        "formulation": 2,
        "manufacturing": 0,
        "safety": 2,
        "transparency": 0,
        "sustainability": 4
      },
      "price": 169.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277049188549",
      "vsf_explanation": "Rejected at 18/100. No identifiable brand; 'Gamba Beauty' is a reseller of a generic 2L portable steam-tent design also sold by Costway, Yescom and many other unbranded importers. The steam-sauna modality has some heat-therapy evidence (extrapolated, parameter mismatch — these tents don't reach research-validated infrared temps), but Build Quality and Transparency both score 0: no UL/ETL on the powered steam generator from a documented manufacturer, no material safety data, no warranty terms, no privacy policy, no claim substantiation. Sustainability gets neutral 4/8 (no data).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "5-9-x-2-6-ft-infrared-sauna-blanket",
      "title": "5.9 X 2.6 Ft. Infrared Sauna Blanket",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/59-x-26-ft-infrared-sauna-blanket-wellness-dailysale-709330.jpg?v=1779720301",
      "score": 27,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "infrared",
        "sauna",
        "blanket",
        "dailysale"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 7,
        "formulation": 3,
        "manufacturing": 0,
        "safety": 5,
        "transparency": 0,
        "sustainability": 4
      },
      "price": 136,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277049221317",
      "vsf_explanation": "Generic dropship infrared sauna blanket sold by a reseller with no identifiable manufacturer brand, no published spec sheet, no UL/ETL/CE certification, no EMF testing, and no warranty terms surfaced. As a powered recovery device with no electrical safety certification disclosed, this triggers the CAT 2 auto-fail for powered devices without electrical certification.",
      "vsf_autofail_rule": "Powered Device Without Electrical Certification"
    },
    {
      "handle": "original-weighted-blanket",
      "title": "Original Weighted Blanket",
      "vendor": "Gravity Blankets",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/GRV.OriginalWeighted.Grey.PDP1.jpg?v=1779720357",
      "score": 71,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "original",
        "weighted",
        "blanket",
        "gravity",
        "blankets"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_environment"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 13,
        "manufacturing": 13,
        "safety": 9,
        "transparency": 9,
        "sustainability": 7
      },
      "price": 149,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277049876677",
      "vsf_explanation": "Gravity Blanket is the named brand in the modality with multiple independent RCTs supporting weighted blankets / deep pressure stimulation for insomnia (Ekholm 2020 JCSM; BMC Psychiatry 2024). Product carries OEKO-TEX Standard 100 certification with disclosed glass-bead fill and Tencel/cotton outer cover. Weighted blanket is non-powered so electrical cert is N/A (prorated). Weakness: only 30-night sleep trial, no formal warranty on blankets, fire-safety compliance not explicitly documented.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "weighted-blanket-20lb-88-x-104-king-size-cooling-breathable-heavy-blanket",
      "title": "Weighted Blanket 20lb 88 x 104\" King Size Cooling Breathable Heavy Blanket",
      "vendor": "VYSN",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d010277uen2.jpg?v=1779720368",
      "score": 13,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "weighted",
        "blanket",
        "20lb",
        "104",
        "king",
        "size",
        "cooling",
        "breathable",
        "heavy",
        "blanket",
        "vysn"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_environment"
      ],
      "vsf_dimensions": {
        "evidence": 6,
        "formulation": 1,
        "manufacturing": 0,
        "safety": 0,
        "transparency": 2,
        "sustainability": 4
      },
      "price": 77.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277050302661",
      "vsf_explanation": "Title/dimensions match a VEVOR-branded weighted blanket sold by dropship reseller VYSN. Category-level weighted-blanket evidence exists (BMC Psychiatry 2024 RCT, Frontiers 2024 review) so partial Evidence credit applies, but VEVOR does not publish OEKO-TEX, CertiPUR-US, or 16 CFR Part 1633/TB117 fire safety compliance for this SKU. No CertiPUR-US foam (glass beads + brushed polyester), no third-party VOC testing, no documented contraindication disclosure, no sleep trial. Sustainability neutral 4/8. Below 60 threshold.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "kathy-ireland-weighted-blanket-with-glass-beads",
      "title": "Kathy Ireland Weighted Blanket with Glass Beads",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/kathy-ireland-weighted-blanket-with-glass-beads-linen-bedding-dailysale-506811.jpg?v=1779720377",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "kathy",
        "ireland",
        "weighted",
        "blanket",
        "with",
        "glass",
        "beads",
        "dailysale"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_environment"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 5,
        "manufacturing": 6,
        "safety": 4,
        "transparency": 5,
        "sustainability": 4
      },
      "price": 43,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277050400965",
      "vsf_explanation": "Licensed-name product sold via discount marketplaces with no identifiable manufacturer, no OEKO-TEX/CertiPUR registry hit, no published material safety testing, no fire-safety statement, no warranty, no sleep trial beyond standard returns. Weighted-blanket modality has independent RCT evidence, but this specific SKU shows almost zero brand-level transparency or build-quality validation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "weighted-blanket-adult-7kg-heavy-gravity-blankets-microfibre-cover",
      "title": "Weighted Blanket Adult 7KG Heavy Gravity Blankets Microfibre Cover",
      "vendor": "Trustymall",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/WBLANKET-CT-7KG-00.jpg?v=1779720390",
      "score": 10,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "weighted",
        "blanket",
        "adult",
        "7kg",
        "heavy",
        "gravity",
        "blankets",
        "microfibre",
        "cover",
        "trustymall"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_environment"
      ],
      "vsf_dimensions": {
        "evidence": 6,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 0,
        "transparency": 0,
        "sustainability": 4
      },
      "price": 174.48,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277050859717",
      "vsf_explanation": "Generic unbranded dropship weighted blanket with no manufacturer documentation. Category-level weighted-blanket evidence applies (partial 6/25), but Zero-Assumption rule zeroes every other dimension: no OEKO-TEX/CertiPUR/GOTS certification, no fire safety statement, no VOC testing, no materials disclosure, no sleep trial, no warranty. Sustainability neutral 4/8 default. Well below 60.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "weighted-blanket-adult-5kg-heavy-gravity-blankets-microfibre-cover",
      "title": "Weighted Blanket Adult 5KG Heavy Gravity Blankets Microfibre Cover",
      "vendor": "Trustymall",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/WBLANKET-CT-5KG-00.jpg?v=1779720394",
      "score": 22,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "weighted",
        "blanket",
        "adult",
        "5kg",
        "heavy",
        "gravity",
        "blankets",
        "microfibre",
        "cover",
        "trustymall"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_environment"
      ],
      "vsf_dimensions": {
        "evidence": 12,
        "formulation": 0,
        "manufacturing": 1,
        "safety": 0,
        "transparency": 1,
        "sustainability": 4
      },
      "price": 186.48,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277050892485",
      "vsf_explanation": "Generic dropship weighted blanket with no manufacturer brand, no OEKO-TEX/CertiPUR certification, no fire-safety statement, no warranty, no materials disclosure beyond 'microfibre cover'. Modality has RCT evidence but this product cannot honestly inherit it under the Zero-Assumption rule. Title is also misleading — 'Gravity Blankets' is used as a generic descriptor, not the actual brand.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "weighted-blanket-adult-9kg-heavy-gravity-blankets-microfibre-cover",
      "title": "Weighted Blanket Adult 9KG Heavy Gravity Blankets Microfibre Cover",
      "vendor": "Trustymall",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/WBLANKET-CT-9KG-00.jpg?v=1779720397",
      "score": 10,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "weighted",
        "blanket",
        "adult",
        "9kg",
        "heavy",
        "gravity",
        "blankets",
        "microfibre",
        "cover",
        "trustymall"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_environment"
      ],
      "vsf_dimensions": {
        "evidence": 6,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 0,
        "transparency": 0,
        "sustainability": 4
      },
      "price": 189.48,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277050925253",
      "vsf_explanation": "Same SKU pattern as the 7KG variant - generic unbranded dropship weighted blanket with no manufacturer documentation, no certifications (OEKO-TEX/CertiPUR/GOTS), no fire safety statement, no VOC testing, no materials disclosure, no warranty, no sleep trial. Category-level evidence gives partial 6/25; sustainability neutral 4/8. Well below 60.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "2025-new-xiaomi-smart-ring-for-men-women-tracks-heart-rate-blood-oxygen-sleep-5atm-waterproof-fitness-tracker",
      "title": "2025 New! Xiaomi Smart Ring for Men & Women. Tracks Heart Rate, Blood Oxygen, Sleep. 5ATM Waterproof Fitness Tracker",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0735FF19F1ACB84E51C33F424A9D1FE1.jpg?v=1779720434",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "2025",
        "new",
        "xiaomi",
        "smart",
        "ring",
        "for",
        "men",
        "women",
        "tracks",
        "heart",
        "rate",
        "blood",
        "oxygen",
        "sleep",
        "5atm",
        "waterproof",
        "fitness",
        "tracker",
        "digital",
        "presence"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smart_rings"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 45,
        "manufacturing": 30,
        "safety": 45,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 28.26,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277051056325",
      "vsf_explanation": "Listed as a 'Xiaomi Smart Ring' but Xiaomi's actual 2025 wearable lineup centers on the Smart Band 10 wristband; there is no first-party Xiaomi smart ring shipping at this $28 price point in this configuration. The reseller does not disclose model number, manufacturer, or chipset, and product photography matches generic Shenzhen white-label rings rebadged under multiple brands. Given the unverifiable brand attribution and absent provenance, this fails the no_brand_provenance rule. A genuine Xiaomi-branded ring at this price would be a notable product and is not corroborated by Xiaomi's product pages.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "muse-2-meditation-sleep-tracker",
      "title": "Muse 2 Meditation & Sleep Tracker",
      "vendor": "The Digital Health Store",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/muse1.webp?v=1779720443",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "muse",
        "meditation",
        "sleep",
        "tracker",
        "the",
        "digital",
        "health",
        "store"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_tracking_wearables"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 75,
        "manufacturing": 75,
        "safety": 75,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 289.78,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277051580613",
      "vsf_explanation": "The Muse 2 by Interaxon is a real consumer EEG headband with a decade of published research on its use in meditation biofeedback and consumer sleep-stage estimation. Vendor is a reseller but the product itself is a known model with FCC/IC IDs, mobile-app data export, and a peer-reviewed literature footprint. Solid Verified entry for the sleep-tracking wearable subcategory.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "smart-ring-heart-rate-blood-oxygen-sleep-monitor-step-counter-female-cycle-tracker",
      "title": "Smart Ring Heart Rate Blood Oxygen Sleep Monitor Step Counter & Female Cycle Tracker",
      "vendor": "Vera Lux",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e4db4418-2760-43f1-8202-2b137777004c.jpg?v=1779720470",
      "score": 14,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "smart",
        "ring",
        "heart",
        "rate",
        "blood",
        "oxygen",
        "sleep",
        "monitor",
        "step",
        "counter",
        "female",
        "cycle",
        "tracker",
        "vera",
        "lux"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smart_rings"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 6,
        "transparency": 0,
        "sustainability": 4
      },
      "price": 121.71,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277051613381",
      "vsf_explanation": "Generic unbranded smart ring with no published validation studies, no documented sensor accuracy, no algorithm transparency, no FDA registration, and no identifiable brand documentation. Tracks heart rate/SpO2/sleep but provides no evidence the sensors are accurate. Zero-Assumption Rule applies — unverified data scores zero across most dimensions. Sustainability defaults to 4/8 per neutral rule.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "calm-tm-the-sleep-sound-machine",
      "title": "Calm:tm: - The Sleep Sound Machine",
      "vendor": "FLIPSTYLEZLLC",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1842960497019.png?v=1779720507",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "calm",
        "the",
        "sleep",
        "sound",
        "machine",
        "flipstylezllc"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "white_noise_sound"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 25,
        "safety": 45,
        "transparency": 20,
        "sustainability": 40
      },
      "price": 30.64,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277051777221",
      "vsf_explanation": "The naming ('Calm:tm:') co-opts the well-known Calm meditation brand by appending a fake trademark symbol — this is not a Calm Inc. product and FLIPSTYLEZLLC is a generic reseller with no manufacturer transparency. Trading on a regulated brand name a product does not own meets the misleading_naming criterion. The underlying hardware appears to be a generic sound machine, but the brand deception is the gating issue and overrides functional considerations.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "usb-white-noise-maker-machine-sleep-therapy",
      "title": "USB White Noise Maker Machine Sleep Therapy",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/usb-white-noise-maker-machine-sleep-therapy-wellness-fitness-dailysale-691349.jpg?v=1779720512",
      "score": 9,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "usb",
        "white",
        "noise",
        "maker",
        "machine",
        "sleep",
        "therapy",
        "dailysale"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "white_noise_sound"
      ],
      "vsf_dimensions": {
        "evidence": 5,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 0,
        "transparency": 0,
        "sustainability": 4
      },
      "price": 39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277052006597",
      "vsf_explanation": "Generic dropship white-noise device from a reseller with no manufacturer brand, no FCC certification disclosure for this SKU, no UL/ETL electrical certification, no warranty, no materials list. Category-level evidence is mixed (PubMed RCTs show modest sleep-efficiency benefit in hospitalized adults but AAP found infant machines exceed safe dB thresholds) - awards partial 5/25. Zero-Assumption rule zeroes everything else; sustainability neutral 4/8. Powered device with no documented UL/ETL/CE could trigger an auto-fail under stricter reading, but treated here as 'no data' = 0 rather than auto-fail since no specific powered-device certification claim is being misrepresented. Below 60.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "white-noise-machine-24-soothing-sounds-portable-baby-sleep-aid-with-night-light-usb-c-rechargeable",
      "title": "White Noise Machine 24 Soothing Sounds Portable Baby Sleep Aid with Night Light USB-C Rechargeable",
      "vendor": "FanzyMarket",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/S99968380185e4bc483d67dc20d4c4e40J.webp?v=1779720532",
      "score": 51,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "white",
        "noise",
        "machine",
        "soothing",
        "sounds",
        "portable",
        "baby",
        "sleep",
        "aid",
        "with",
        "night",
        "light",
        "usb",
        "rechargeable",
        "fanzymarket"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "white_noise_sound"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 45,
        "sustainability": 60
      },
      "price": 35.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277052268741",
      "vsf_explanation": "Generic 24-sound portable white-noise machine with night light and USB-C charging — feature set is comparable to widely-sold Dreamegg/Magicteam class devices but FanzyMarket provides no manufacturer disclosure, no decibel cap, and no AAP-aligned guidance for infant use (AAP recommends <50 dB and >=7 ft from crib). Functional for adult sleep use; the 'baby sleep aid' framing is overreach without measured output specs. Lower Standard tier.",
      "vsf_autofail_rule": "Powered Device Without Electrical Certification"
    },
    {
      "handle": "fire-cold-plunge-all-in-one",
      "title": "Fire Cold Plunge All-In-One",
      "vendor": "Fire Cold Plunge",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fire-cold-plunge-30-2753085.png?v=1779720558",
      "score": 75,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fire",
        "cold",
        "plunge",
        "all",
        "one",
        "fire",
        "cold",
        "plunge"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "cold_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 16,
        "manufacturing": 12,
        "safety": 10,
        "transparency": 6,
        "sustainability": 4
      },
      "price": 3695,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277052465349",
      "vsf_explanation": "Cold water immersion has Grade A RCT and meta-analysis evidence for muscle recovery/DOMS, and this tub's 33-50F range matches the 10-15C clinical parameter set (12+8+5 evidence dimension). Brand publishes ergonomic spec, ETL/UL-certified plugs with GFCI, FDA-certified non-toxic liner material, ozone disinfection, and a temperature controller; documented 110V safety wiring plus residential warranty. Gaps: no third-party material test certificate posted, no clinical study citations, and no detailed sustainability programme — but enough verifiable build quality and matched-parameter evidence to clear Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "face-plunge-pure-facial-cold-plunge-bowl-with-ice-chamber",
      "title": "Face Plunge Pure - Facial Cold Plunge Bowl with Ice Chamber",
      "vendor": "Face Plunge Company",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Face_Plunge_Snorkel_Countertop.png?v=1779720565",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "face",
        "plunge",
        "pure",
        "facial",
        "cold",
        "plunge",
        "bowl",
        "with",
        "ice",
        "chamber",
        "face",
        "plunge",
        "company"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "cold_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 17,
        "formulation": 11,
        "manufacturing": 8,
        "safety": 9,
        "transparency": 4,
        "sustainability": 4
      },
      "price": 109,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46883674652869",
      "vsf_explanation": "Facial cold-plunge bowl is non-powered (no electrical auto-fail). Cold-water immersion has strong Grade A RCT evidence for facial/vagus-nerve and recovery applications, though parameter specificity for face-only protocols is weaker. Brand discloses BPA-free, food-grade FDA-compliant materials (good Material Safety) and patented dual-chamber design, but lacks third-party testing reports, warranty terms, contraindication disclosure, and sustainability documentation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "portable-cold-plunge-ice-bathtub",
      "title": "Portable Cold Plunge Ice Bathtub",
      "vendor": "Sunflower Fields: Where Happiness Grows",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Sabf19affd49a428a80d927533c23cc8eR_c50123a8-fefb-410a-af1c-334fc0e5576d.webp?v=1779720593",
      "score": 21,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "portable",
        "cold",
        "plunge",
        "ice",
        "bathtub",
        "sunflower",
        "fields",
        "where",
        "happiness",
        "grows"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "cold_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 3,
        "manufacturing": 0,
        "safety": 4,
        "transparency": 0,
        "sustainability": 4
      },
      "price": 86.44,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277052563653",
      "vsf_explanation": "Rejected at 21/100. Cold water immersion has Grade A modality evidence (Frontiers 2025 network meta-analysis of 55 RCTs at 11-15C reduces DOMS/CK), so Evidence gets partial credit for the category — but this listing is a generic portable ice tub from a non-brand reseller with no published material safety (NSF/ANSI 51 food-grade liner), no structural certification, no warranty, no temperature-control electrical components documented, and no privacy/claims substantiation. Sustainability neutral 4/8 (no data).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "79-gal-water-chiller-compatible-cold-plunge-tub-with-cover-black",
      "title": "79 Gal Water Chiller Compatible Cold Plunge Tub with Cover-Black",
      "vendor": "Gamba Beauty",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/79_gal_water_chiller_compatible_cold_plunge_tub-1_8.jpg?v=1779720619",
      "score": 41,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gal",
        "water",
        "chiller",
        "compatible",
        "cold",
        "plunge",
        "tub",
        "with",
        "cover",
        "black",
        "gamba",
        "beauty"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "cold_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 17,
        "formulation": 8,
        "manufacturing": 0,
        "safety": 5,
        "transparency": 3,
        "sustainability": 4
      },
      "price": 380.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277052760261",
      "vsf_explanation": "The tub itself is unpowered (inflatable PVC bath compatible with a separate chiller) so the electrical auto-fail does not apply to the tub SKU, but no NSF/ANSI 51 food-grade water-contact certification, no structural certification, no published BPA/phthalate testing, no published warranty terms, and no evidence citations are provided. Cold water immersion has strong Grade A RCT evidence as a modality, but the product cannot honestly demonstrate parameter delivery or material safety to clear 60.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "97gal-large-size-ice-bathtub-with-cover-for-adults-athletes-recovery-cold-water-therapy-outdoor-portable-cold-plunge-tub-660lbs-load-capacity-33-46x29",
      "title": "97Gal Large Size Ice BathTub with Cover for Adults Athletes Recovery Cold Water Therapy Outdoor Portable Cold Plunge Tub 660LBS Load Capacity 33.46x29",
      "vendor": "Best Product Finds",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/FFF-GPCT4869.jpg?v=1779720644",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "97gal",
        "large",
        "size",
        "ice",
        "bathtub",
        "with",
        "cover",
        "for",
        "adults",
        "athletes",
        "recovery",
        "cold",
        "water",
        "therapy",
        "outdoor",
        "portable",
        "cold",
        "plunge",
        "tub",
        "660lbs",
        "load",
        "capacity",
        "46x29",
        "best",
        "product",
        "finds"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "cold_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 17,
        "formulation": 6,
        "manufacturing": 2,
        "safety": 5,
        "transparency": 4,
        "sustainability": 4
      },
      "price": 117.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277053055173",
      "vsf_explanation": "Cold water immersion modality itself has Grade A evidence so evidence partially scores (12+5 partial parameter match since this is a passive ice tub with no chiller-controlled temperature). However this is a generic dropship product with no identifiable brand, no published material specs (PVC/TPU?), no NSF/food-grade certification, no electrical certification needed (passive), no warranty info, no published safety/contraindication guidance, and no transparency or citations. Far below Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "f300-smartwatch-ecg-electrocardiogram-monitoring-sos-fall-alarm-blood-glucose-and-blood-pressure-watch-hrv-report",
      "title": "F300 smartwatch ECG electrocardiogram monitoring SOS fall alarm blood glucose and blood pressure watch HRV report",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6C5672B23106E85651EF4DE3C58D8373.jpg?v=1779720664",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "f300",
        "smartwatch",
        "ecg",
        "electrocardiogram",
        "monitoring",
        "sos",
        "fall",
        "alarm",
        "blood",
        "glucose",
        "and",
        "blood",
        "pressure",
        "watch",
        "hrv",
        "report",
        "digital",
        "presence"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "cardiac_ecg"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 25,
        "manufacturing": 25,
        "safety": 20,
        "transparency": 20,
        "sustainability": 35
      },
      "price": 73.54,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277053120709",
      "vsf_explanation": "The F300 is a generic Shenzhen white-label smartwatch sold under dozens of marketplace names that claims FDA-equivalent clinical functions — ECG, AFib-grade rhythm analysis, non-invasive blood glucose, and blood pressure — at $73 with no listed FDA 510(k) clearance for any of these features. Non-invasive blood-glucose monitoring is not yet a validated technology at any price; the FDA and credible reviews (GoodRx, peer-reviewed literature) confirm no smartwatch is FDA-authorized for glucose measurement as of 2026. Marketing all four regulated functions without clearance is a clear unverified_medical_claim and a meaningful patient-safety risk.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "deep-tissue-percussion-massage-gun",
      "title": "Deep-Tissue Percussion Massage Gun",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/deep-tissue-percussion-massage-gun-wellness-fitness-dailysale-692392.jpg?v=1779720693",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "deep",
        "tissue",
        "percussion",
        "massage",
        "gun",
        "dailysale"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "percussion_vibration"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 4,
        "manufacturing": 0,
        "safety": 5,
        "transparency": 0,
        "sustainability": 4
      },
      "price": 39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277053415621",
      "vsf_explanation": "Percussion-massage modality has moderate (Grade B) RCT evidence for DOMS reduction, so Evidence partial credit applies. Product is a generic unbranded dropship listing sold through a third-party seller with no identifiable manufacturer, no UL/ETL/FCC electrical certification, no warranty, no contraindication disclosure, no material data — auto-fail for powered-device-without-electrical-certification.",
      "vsf_autofail_rule": "Powered Device Without Electrical Certification"
    },
    {
      "handle": "icy-cold-compress-massage-gun-electric-percussion-pistol-massager-for-body-neck-back-sport-deep-tissue-muscle-relaxation",
      "title": "Icy Cold Compress Massage Gun Electric Percussion Pistol Massager For Body Neck Back Sport Deep Tissue Muscle Relaxation",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3E2D07233CD07DC7F4CC28FA5E35B4E3.jpg?v=1779720702",
      "score": 16,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "icy",
        "cold",
        "compress",
        "massage",
        "gun",
        "electric",
        "percussion",
        "pistol",
        "massager",
        "for",
        "body",
        "neck",
        "back",
        "sport",
        "deep",
        "tissue",
        "muscle",
        "relaxation",
        "digital",
        "presence"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "percussion_vibration"
      ],
      "vsf_dimensions": {
        "evidence": 8,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 4,
        "transparency": 0,
        "sustainability": 4
      },
      "price": 54.02,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277053481157",
      "vsf_explanation": "Rejected at 16/100. Percussive massage modality has decent PubMed RCT evidence so Evidence gets partial credit for the category, but no brand, no published RPM/amplitude/stall force, no UL/ETL on the powered motor, no material safety, no warranty, no privacy policy. SEO-stuffed title with 'Icy Cold Compress + Massage Gun' is a red flag for an undifferentiated AliExpress-class import. Sustainability neutral 4/8.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cordless-360-rolling-percussive-body-massager-usb-c-rechargeable-5-speed-handheld-muscle-relaxer-for-back-legs-feet",
      "title": "Cordless 360° Rolling Percussive Body Massager – USB-C Rechargeable 5-Speed Handheld Muscle Relaxer for Back, Legs & Feet",
      "vendor": "FanzyMarket",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Sfcdb448769c94c82aaaf7d227e5106a1g.webp?v=1779720708",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cordless",
        "360",
        "rolling",
        "percussive",
        "body",
        "massager",
        "usb",
        "rechargeable",
        "speed",
        "handheld",
        "muscle",
        "relaxer",
        "for",
        "back",
        "legs",
        "feet",
        "fanzymarket"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "percussion_vibration"
      ],
      "vsf_dimensions": {
        "evidence": 6,
        "formulation": 3,
        "manufacturing": 0,
        "safety": 5,
        "transparency": 0,
        "sustainability": 4
      },
      "price": 126.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277053644997",
      "vsf_explanation": "Generic FanzyMarket dropship percussive massager with no identifiable manufacturer brand, no published amplitude/frequency specs, no UL/ETL/CE listing, and no warranty terms. Powered recovery device with no electrical safety certification triggers the CAT 2 auto-fail.",
      "vsf_autofail_rule": "Powered Device Without Electrical Certification"
    },
    {
      "handle": "heatflex-muscle-massager",
      "title": "HeatFlex Muscle Massager",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/F548C852-FAE7-4680-B174-06E7AF06BC02.jpg?v=1779720715",
      "score": 28,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "heatflex",
        "muscle",
        "massager",
        "digital",
        "presence"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "percussion_vibration"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 35,
        "manufacturing": 25,
        "safety": 40,
        "transparency": 20,
        "sustainability": 30
      },
      "price": 32.88,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277053874373",
      "vsf_explanation": "A 6-node percussion massager with a red LED window marketed as 'red light heating therapy'. The reseller is a dropship storefront and the 'HeatFlex' brand has no independent identity, product page, or supporting documentation. Rejected on brand provenance.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "6-inch-15-2-cm-11-note-steel-tongue-drum-portable-handpan-for-meditation-yoga-sound-healing",
      "title": "6-Inch (15.2 cm) 11-Note Steel Tongue Drum - Portable Handpan for Meditation, Yoga & Sound Healing",
      "vendor": "FanzyMarket",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/S76e1cdf781dc401ab17a693c4e724454n.webp?v=1779720731",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "inch",
        "note",
        "steel",
        "tongue",
        "drum",
        "portable",
        "handpan",
        "for",
        "meditation",
        "yoga",
        "sound",
        "healing",
        "fanzymarket"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 5,
        "formulation": 20,
        "manufacturing": 40,
        "safety": 60,
        "transparency": 25,
        "sustainability": 30
      },
      "price": 43.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277054005445",
      "vsf_explanation": "Steel tongue drum instrument, not a supplement.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "30-speed-deep-tissue-ultra-quiet-muscle-massage-gun-with-7-heads",
      "title": "30 Speed Deep Tissue  Ultra-Quiet Muscle Massage Gun with 7 Heads",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/30-speed-deep-tissue-ultra-quiet-muscle-massage-gun-with-7-heads-wellness-dailysale-105234.jpg?v=1779720739",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "speed",
        "deep",
        "tissue",
        "ultra",
        "quiet",
        "muscle",
        "massage",
        "gun",
        "with",
        "heads",
        "dailysale"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "percussion_vibration"
      ],
      "vsf_dimensions": {
        "evidence": 13,
        "formulation": 4,
        "manufacturing": 2,
        "safety": 3,
        "transparency": 4,
        "sustainability": 4
      },
      "price": 93,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277054628037",
      "vsf_explanation": "Percussion/vibration therapy has Grade B evidence for DOMS recovery but this generic unbranded gun publishes no amplitude/frequency specs, no manufacturer identity, no UL/ETL certification, no FDA registration, no warranty, and no contraindication guidance (cardiac, pregnancy, implants). Listing claims '30 speeds' and '7 heads' but cannot verify parameters match clinical research. Generic dropship — Rejected.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pulsemaster",
      "title": "PulseMaster",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_massage_therapist_using_with_two_hands_on_client_s_back_1.png?v=1779720752",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pulsemaster",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 25,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 25,
        "sustainability": 30
      },
      "price": 89.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277054660805",
      "vsf_explanation": "Percussion massage gun, not a supplement. Percussion therapy has some small-trial signal for DOMS (Konrad 2020) but not as an ingestible.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "electric-shoulder-massager",
      "title": "Electric Shoulder Massager",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_Middle_aged_woman_in_sports_clothes_using_shoulder_massager.png?v=1779720759",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "electric",
        "shoulder",
        "massager",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "percussion_vibration"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 25,
        "sustainability": 30
      },
      "price": 59.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277054922949",
      "vsf_explanation": "A 'ShoulderEase Pro' heated vibration shoulder wrap from Lang Wellness LLC. Copy is boilerplate direct-response marketing ('26% of adults suffer from shoulder pain...') with no manufacturer, model, thermal specs, or clearance information, matching the pattern of a rebadged import. Rejected on brand provenance.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "kneerelief-pro",
      "title": "KneeRelief Pro",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_old_native_american_man_in_shorts_using_while_sitting_on_couch.png?v=1779720767",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "kneerelief",
        "pro",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 18,
        "formulation": 25,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 25,
        "sustainability": 30
      },
      "price": 89.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277055021253",
      "vsf_explanation": "Heated knee massager with red-light module, not a supplement. Red-light for knee OA has small-trial signal (Chow 2009 review) but this is a device, not ingestible.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "viso-fda-certified-red-light-therapy-mask",
      "title": "VISO - FDA Certified Red Light Therapy Mask",
      "vendor": "Lumara",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Lumara_VSO.png?v=1779720780",
      "score": 82,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "viso",
        "fda",
        "certified",
        "red",
        "light",
        "therapy",
        "mask",
        "lumara"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 16,
        "manufacturing": 16,
        "safety": 12,
        "transparency": 8,
        "sustainability": 4
      },
      "price": 479,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277055119557",
      "vsf_explanation": "Lumara VISO is FDA 510(k) Class II cleared with documented IEC 60601 medical-electrical safety testing, IP65 rating, 30mW/cm² irradiance disclosure, and 2-year warranty — earning high marks in Build Quality, Design Integrity, and Safety. Red-light photobiomodulation at 660nm has Grade A RCT evidence for skin/dermatology outcomes. Brand transparency is good (specs published), though contraindication disclosure and sustainability data are limited.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mini-red-light-therapy-device",
      "title": "Mini Red Light Therapy Device",
      "vendor": "Nushape",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/78A1652_1024x1024_5cfdec81-fd11-42c1-83c9-f67709106956.jpg?v=1779720787",
      "score": 67,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mini",
        "red",
        "light",
        "therapy",
        "device",
        "nushape"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 18,
        "formulation": 14,
        "manufacturing": 10,
        "safety": 11,
        "transparency": 8,
        "sustainability": 6
      },
      "price": 349,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277055283397",
      "vsf_explanation": "Standard at 67/100. Strongest dimensions: Formulation (70% — published 660nm/850nm wavelengths, 160 LEDs at 40Hz, 37 J/cm2 dose on the product page) and Evidence (72% — red light photobiomodulation modality has Grade A RCT evidence including 2017 meta-analysis of 46 RCTs showing 43% DOMS reduction). Nushape is FDA-registered (low-level light therapy / non-significant risk class), publishes a 1-year warranty covering all repairable parts (light board, controller, battery), and has an accessible BBB profile. Held back by limited independent third-party validation studies on the specific Mini SKU and no documented sustainability/repair program beyond the 1-year warranty.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "the-nushape-red-light-therapy-mask",
      "title": "The Nushape Red Light Therapy Mask",
      "vendor": "Nushape",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/red_light_therapy_mask_73be3a6a-6bb4-412c-8ed8-7cb646d32ad3.webp?v=1779720795",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "the",
        "nushape",
        "red",
        "light",
        "therapy",
        "mask",
        "nushape"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 18,
        "formulation": 10,
        "manufacturing": 6,
        "safety": 11,
        "transparency": 6,
        "sustainability": 4
      },
      "price": 449,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277055348933",
      "vsf_explanation": "Nushape publishes wavelength specs (660/830/415 nm) for an established photobiomodulation modality with Grade A RCT evidence and links to a research library, but I could not verify an FDA 510(k) clearance for the specific mask in the FDA database, no third-party UL/ETL listing was surfaced, and no independent testing of irradiance was found. Brand site, 1-year warranty and 30-day money-back are documented, but evidence citations are vague rather than claim-linked.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fringe-wireless-headwrap-for-red-light-therapy",
      "title": "Fringe Wireless Headwrap for Red Light Therapy",
      "vendor": "BioWizdom",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fringe-red-light-therapy-head-wrap.jpg?v=1779720801",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fringe",
        "wireless",
        "headwrap",
        "for",
        "red",
        "light",
        "therapy",
        "biowizdom"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 11,
        "formulation": 12,
        "manufacturing": 9,
        "safety": 8,
        "transparency": 6,
        "sustainability": 6
      },
      "price": 545,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277055676613",
      "vsf_explanation": "Transcranial PBM at 810nm has emerging Grade B-C evidence (Hamblin et al., small RCTs for cognition/brain health); 1050nm is novel with limited validation. Fringe publishes specific wavelengths (650/810/1050nm), LED count (450), and 'ultra low EMF' claim and is FDA-registered (Class II registration, not 510(k) clearance — accepted as general wellness). No published third-party EMF or irradiance test, no peer-reviewed clinical study citations, and warranty/contraindication detail is limited. Settles into Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "exesas-1008-led-5040w-dual-chip-red-light-therapy-device-for-full-body-4-wavelengths-infrared-led-panel-for-skin-weight-pain-wellness",
      "title": "EXESAS    1008 LED, 5040W Dual-Chip, Red Light Therapy Device for Full Body, 4-Wavelengths Infrared LED Panel for Skin, Weight, Pain, Wellness",
      "vendor": "EXESAS",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MAIN_PIC_5040W_-_01.png?v=1779720811",
      "score": 58,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "exesas",
        "1008",
        "led",
        "5040w",
        "dual",
        "chip",
        "red",
        "light",
        "therapy",
        "device",
        "for",
        "full",
        "body",
        "wavelengths",
        "infrared",
        "led",
        "panel",
        "for",
        "skin",
        "weight",
        "pain",
        "wellness",
        "exesas"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 10,
        "manufacturing": 2,
        "safety": 9,
        "transparency": 5,
        "sustainability": 4
      },
      "price": 2799,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277055709381",
      "vsf_explanation": "EXESAS publishes specific parameters (660/850nm, 198mW/cm² irradiance, 1300W actual power, Meanwell drivers, 100,000-hr lifespan, 2-yr warranty) earning good Design Integrity credit. Red-light photobiomodulation has Grade A evidence at these wavelengths. However, no UL/ETL/CE/FCC certification is disclosed anywhere on the brand site for this powered full-body panel, no third-party material/EMF safety testing data, no MAUDE history checks, limited contraindication disclosure — total falls below 60 Standard threshold.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "red-light-therapy-versadome-pro-2-in-1-face-body-device-with-1-998-leds",
      "title": "Red Light Therapy VersaDome Pro 2-in-1 – Face & Body Device with 1,998 LEDs",
      "vendor": "Red Light Pro Devices",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/facedomeweb.jpg?v=1779720827",
      "score": 41,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "light",
        "therapy",
        "versadome",
        "pro",
        "face",
        "body",
        "device",
        "with",
        "998",
        "leds",
        "red",
        "light",
        "pro",
        "devices"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 9,
        "manufacturing": 2,
        "safety": 6,
        "transparency": 4,
        "sustainability": 5
      },
      "price": 1200,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277055742149",
      "vsf_explanation": "Rejected at 41/100. The product page does publish 660nm/850nm wavelengths and 1,998 LED count (some formulation credit), and the red-light modality is Grade A evidence (Evidence partial credit). But 'Red Light Pro Devices' and the reseller storefronts (betterlife-lab, recoverystem) have no FDA 510(k) clearance documented in the FDA database, no UL/ETL certification of the powered LED panel cited, no published material safety testing, no published irradiance (mW/cm2) or dose data, and no independent third-party validation. Lacks the documentation depth that gets premium photobiomodulation brands (Mito, Joovv) into Verified tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mini-60-handheld-red-light-therapy-device-portable-660nm-850nm-led-for-pain-relief-skin-health",
      "title": "Mini 60 Handheld Red Light Therapy Device – Portable 660nm & 850nm LED for Pain Relief & Skin Health",
      "vendor": "Red Nova Lights LLC",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/mini_60_10.png?v=1779720843",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mini",
        "handheld",
        "red",
        "light",
        "therapy",
        "device",
        "portable",
        "660nm",
        "850nm",
        "led",
        "for",
        "pain",
        "relief",
        "skin",
        "health",
        "red",
        "nova",
        "lights",
        "llc"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 18,
        "formulation": 11,
        "manufacturing": 6,
        "safety": 11,
        "transparency": 5,
        "sustainability": 4
      },
      "price": 129,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277055938757",
      "vsf_explanation": "Red Nova Lights publishes specific wavelengths (660/850 nm), 60 W output, dual 18650 battery, and offers a 3-year limited warranty (full warranty credit). Brand states devices are manufactured in FDA-registered facilities, but no FDA 510(k) clearance is held for this SKU and no UL/ETL listing is published, so electrical-cert credit is partial. Modality has strong Grade A RCT support; the brand cites research generically rather than per-claim.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "portable-red-light-therapy-flashlight-handheld-led-device-with-630nm-660nm-850nm",
      "title": "Portable Red Light Therapy Flashlight – Handheld LED Device with 630nm, 660nm & 850nm",
      "vendor": "Red Nova Lights LLC",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/laser_3.png?v=1779720856",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "portable",
        "red",
        "light",
        "therapy",
        "flashlight",
        "handheld",
        "led",
        "device",
        "with",
        "630nm",
        "660nm",
        "850nm",
        "red",
        "nova",
        "lights",
        "llc"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 13,
        "formulation": 11,
        "manufacturing": 8,
        "safety": 8,
        "transparency": 6,
        "sustainability": 4
      },
      "price": 69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277056004293",
      "vsf_explanation": "630/660/850nm wavelengths have Grade B PBM evidence for skin and superficial tissue support; a handheld flashlight form factor delivers low total dose so parameter match to clinical RCTs is partial. Brand discloses specific wavelengths and operating profile, sells through a real brand site with clear product specs, and provides basic usage guidance. Missing: published irradiance/dose measurements, third-party safety certifications (UL/ETL/FDA), and peer-reviewed citations. Lands at the bottom of Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "red-light-therapy-hat-for-hair-growth-pain-relief-660nm-850nm",
      "title": "Red Light Therapy Hat for Hair Growth & Pain Relief – 660nm + 850nm",
      "vendor": "Red Nova Lights LLC",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/hat_3.png?v=1779720861",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "light",
        "therapy",
        "hat",
        "for",
        "hair",
        "growth",
        "pain",
        "relief",
        "660nm",
        "850nm",
        "red",
        "nova",
        "lights",
        "llc"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 6,
        "manufacturing": 0,
        "safety": 8,
        "transparency": 4,
        "sustainability": 4
      },
      "price": 129,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277056037061",
      "vsf_explanation": "660nm red light has FDA-cleared precedents for androgenetic alopecia (Grade A meta-analyses), so the modality evidence is strong. However, Red Nova Lights does not disclose 510(k) clearance for this specific hat, no UL/FCC certification documented, no irradiance specs published, no warranty terms disclosed — Build Quality scores zero. The disclaimer 'not intended to treat any disease' contradicts the marketing hair-growth claim and adds transparency concern.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "red-light-therapy-belt-for-back-pain-muscle-recovery-660nm-850nm",
      "title": "Red Light Therapy Belt for Back Pain & Muscle Recovery – 660nm + 850nm",
      "vendor": "Red Nova Lights LLC",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/belt_4.png?v=1779720867",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "light",
        "therapy",
        "belt",
        "for",
        "back",
        "pain",
        "muscle",
        "recovery",
        "660nm",
        "850nm",
        "red",
        "nova",
        "lights",
        "llc"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 9,
        "manufacturing": 3,
        "safety": 6,
        "transparency": 5,
        "sustainability": 6
      },
      "price": 79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277056102597",
      "vsf_explanation": "Rejected at 44/100. Product page publishes 660nm/850nm dual-wavelength spec and brand has an active e-commerce site with adjustable intensity and pulsing modes (some formulation credit) — and the photobiomodulation modality has Grade A PubMed evidence. But the page does not publish LED count, irradiance (mW/cm2), or dose; no FDA 510(k) found; no documented UL/ETL on the powered controller; no independent third-party validation of belt-specific therapeutic delivery; and no material safety/biocompatibility data on the user-contact fabric. Below the 60-pt Standard threshold by documentation depth, not modality science.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "red-light-therapy-face-mask-led-skin-rejuvenation-mask-with-red-blue-yellow-nir-460-850nm",
      "title": "Red Light Therapy Face Mask – LED Skin Rejuvenation Mask with Red, Blue, Yellow + NIR (460–850nm)",
      "vendor": "Red Nova Lights LLC",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/mask_1.png?v=1779720874",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "light",
        "therapy",
        "face",
        "mask",
        "led",
        "skin",
        "rejuvenation",
        "mask",
        "with",
        "red",
        "blue",
        "yellow",
        "nir",
        "460",
        "850nm",
        "red",
        "nova",
        "lights",
        "llc"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 17,
        "formulation": 10,
        "manufacturing": 6,
        "safety": 11,
        "transparency": 5,
        "sustainability": 4
      },
      "price": 129,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277056200901",
      "vsf_explanation": "Multi-wavelength LED mask from Red Nova Lights (460/590/630/660/850 nm) — wavelengths and dosing are stated, brand has a 3-year warranty and claims FDA-registered manufacturing facility, but no device-level FDA 510(k) clearance and no UL/ETL listing were verifiable. Modality evidence is solid; product-specific independent parameter verification is not published. Blue-light eye-safety contraindication disclosure is partial.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "red-light-therapy-hand-wrist-glove-1080-high-power-leds-12v-car-adapter",
      "title": "Red Light Therapy Hand & Wrist Glove | 1080 High-Power LEDs + 12V Car Adapter",
      "vendor": "Red Light Pro Devices",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/RLPDHANDMIT1.jpg?v=1779720903",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "light",
        "therapy",
        "hand",
        "wrist",
        "glove",
        "1080",
        "high",
        "power",
        "leds",
        "12v",
        "car",
        "adapter",
        "red",
        "light",
        "pro",
        "devices"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 12,
        "manufacturing": 8,
        "safety": 8,
        "transparency": 6,
        "sustainability": 4
      },
      "price": 475,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277056299205",
      "vsf_explanation": "660/850nm PBM for hand/wrist (arthritis pain, circulation) has Grade B RCT evidence with reasonable parameter match given high LED density and 15-20 min session protocol. Brand publishes wavelengths, LED count, session duration, and dimensions. Gaps: no UL/ETL/FDA disclosure surfaced, no third-party irradiance test, no clinical citations on product page, no warranty depth, and limited sustainability info. Mid-Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "red-light-therapy-blanket-full-body-coverage-660nm-850nm-dual-wavelengths-13-536-leds",
      "title": "Red Light Therapy Blanket – Full Body Coverage | 660nm + 850nm Dual Wavelengths | 13,536 LEDs",
      "vendor": "Red Light Pro Devices",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/WhatsAppImage2025-08-27at4.00.45PM.jpg?v=1779720929",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "light",
        "therapy",
        "blanket",
        "full",
        "body",
        "coverage",
        "660nm",
        "850nm",
        "dual",
        "wavelengths",
        "536",
        "leds",
        "red",
        "light",
        "pro",
        "devices"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 4,
        "manufacturing": 0,
        "safety": 6,
        "transparency": 2,
        "sustainability": 4
      },
      "price": 7495,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277056430277",
      "vsf_explanation": "Modality evidence (660/850nm photobiomodulation) is strong (Grade A). However, 'Red Light Pro Devices' appears to be a generic/white-label reseller with no identifiable brand site, no electrical safety certifications disclosed, no irradiance data, no MAUDE history searchable — auto-fail for powered-device without electrical certification.",
      "vsf_autofail_rule": "Powered Device Without Electrical Certification"
    },
    {
      "handle": "blisspod-malmo-all-in-one-infrared-red-light-therapy-premium-sauna-low-emf-led-chromotherapy-2-person",
      "title": "Blisspod | Malmo | All-In-One | Infrared + Red Light Therapy | Premium Sauna | Low EMF | LED Chromotherapy | 2 Person",
      "vendor": "zoppinh",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Malmo_2048x2048_767de309-63ad-47f8-84c7-4c31f61a6ed8.webp?v=1779720938",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "blisspod",
        "malmo",
        "all",
        "one",
        "infrared",
        "red",
        "light",
        "therapy",
        "premium",
        "sauna",
        "low",
        "emf",
        "led",
        "chromotherapy",
        "person",
        "zoppinh"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 13,
        "manufacturing": 14,
        "safety": 7,
        "transparency": 7,
        "sustainability": 6
      },
      "price": 3299,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277056725189",
      "vsf_explanation": "Standard at 62/100. Strongest dimensions: Build Quality (70% — brand documents ETL, ISO, CE, BSCI, and FSC certifications on the product page, plus a 3-year warranty on wood structure/heaters/electrical) and Formulation (65% — published heater wattage 1800W, red light panel 90W, temperature range 140F, low-EMF carbon heater design). Held back by Evidence (the sauna heat-therapy literature applies to traditional Finnish/IR saunas, parameter match only partial for this hybrid IR+LED chromotherapy unit) and limited published independent verification of EMF claims. Note: this is mis-classified in batch under red_light_photobiomodulation but is functionally a sauna — scored as the IR sauna + red light combination it actually is.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "biobalance-grounding-sheet-naturally-reconnect",
      "title": "BioBalance Grounding Sheet – Naturally Reconnect!",
      "vendor": "Dabfavshop",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/S826ee48d426345be88bc7fb9a366ee867.webp?v=1779720971",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "biobalance",
        "grounding",
        "sheet",
        "naturally",
        "reconnect",
        "dabfavshop"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 20,
        "manufacturing": 35,
        "safety": 55,
        "transparency": 20,
        "sustainability": 30
      },
      "price": 99.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277057151173",
      "vsf_explanation": "Grounding bed sheet, not a supplement. Grounding/earthing has minimal evidence (Chevalier 2015 small pilot), and this listing is dropshipper-tier with no verifiable conductivity spec.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "grounding-sheet-gas-conductive-bed-sheet",
      "title": "Grounding sheet, gas conductive bed sheet",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/490C8FC7EA692888B6C2F61E2A8787B3.jpg?v=1779720975",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "grounding",
        "sheet",
        "gas",
        "conductive",
        "bed",
        "sheet",
        "digital",
        "presence"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 15,
        "manufacturing": 25,
        "safety": 35,
        "transparency": 15,
        "sustainability": 30
      },
      "price": 45.14,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277057839301",
      "vsf_explanation": "Silver-fiber grounding sheet - not a supplement, and does not belong in the supplements category. Earthing evidence base (Chevalier 2012) is small and mechanistic.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "earthing-grounding-flat-sheet-10-silver-fiber-conductive-antistatic-cotton-blend-with-grounding-cord",
      "title": "Earthing Grounding Flat Sheet – 10% Silver Fiber Conductive Antistatic Cotton Blend with Grounding Cord",
      "vendor": "FanzyMarket",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Sb4238a96bfa54c16a4ffcb47ec853a240.webp?v=1779720983",
      "score": 22,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "earthing",
        "grounding",
        "flat",
        "sheet",
        "silver",
        "fiber",
        "conductive",
        "antistatic",
        "cotton",
        "blend",
        "with",
        "grounding",
        "cord",
        "fanzymarket"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 12,
        "formulation": 25,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 35,
        "sustainability": 35
      },
      "price": 32.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277058822341",
      "vsf_explanation": "Silver-fiber grounding sheet with in-line resistor, not a supplement. Earthing sheets have thin RCT evidence base; this listing is more transparent (98 kΩ resistor) but still a device.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "grounding-sheet-mat-earthing-fitted-bedsheet-silver-fiber-conductive-organic-grounding-mat-radiation-anti-static-60-265cm",
      "title": "Grounding Sheet   Mat  Earthing Fitted Bedsheet Silver Fiber Conductive Organic Grounding Mat Radiation Anti-Static 60*265CM",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1AE2A410CEFEFB63374FE298AAC91EFF.jpg?v=1779720993",
      "score": 28,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "grounding",
        "sheet",
        "mat",
        "earthing",
        "fitted",
        "bedsheet",
        "silver",
        "fiber",
        "conductive",
        "organic",
        "grounding",
        "mat",
        "radiation",
        "anti",
        "static",
        "265cm",
        "digital",
        "presence"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_environment"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 35,
        "manufacturing": 25,
        "safety": 40,
        "transparency": 20,
        "sustainability": 35
      },
      "price": 57.94,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277061968069",
      "vsf_explanation": "Generic 5% silver / 95% cotton grounding fitted sheet from the same dropship storefront, with the standard 'connect to the earth's electrons' marketing narrative. No manufacturer, no compliance data, and the grounding-cord safety design (which matters, because it plugs into the outlet ground pin) is undocumented. Rejected on brand provenance.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "selenite-tower-15cm-6-inch",
      "title": "Selenite Tower - 15cm (~6 inch)",
      "vendor": "Sacred Crystals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/selenite-tower-15cmselenite1001613metaphysicalmetaphysical-crystals-853471.jpg?v=1779721026",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "selenite",
        "tower",
        "15cm",
        "inch",
        "sacred",
        "crystals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 15,
        "manufacturing": 30,
        "safety": 55,
        "transparency": 20,
        "sustainability": 25
      },
      "price": 14.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277062590661",
      "vsf_explanation": "Selenite (gypsum) tower for spiritual/decorative use. Not a supplement; supplement rubric does not apply.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "earthing-ground-pillow-case-for-health-emf-protection-improves-sleep-conductive-silver-fiber-cotton-pillowcase",
      "title": "Earthing Ground Pillow Case For Health & EMF Protection Improves Sleep Conductive Silver Fiber Cotton Pillowcase",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/E7593BAE11C51709A9BD10F036505C7D.jpg?v=1779721042",
      "score": 28,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "earthing",
        "ground",
        "pillow",
        "case",
        "for",
        "health",
        "emf",
        "protection",
        "improves",
        "sleep",
        "conductive",
        "silver",
        "fiber",
        "cotton",
        "pillowcase",
        "digital",
        "presence"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_environment"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 35,
        "manufacturing": 25,
        "safety": 40,
        "transparency": 20,
        "sustainability": 35
      },
      "price": 40.74,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277062623429",
      "vsf_explanation": "A silver-fiber grounding pillowcase from a dropship storefront, sold on EMF-protection and 'absorbing the Earth's electrons' claims. Grounding evidence is thin and dominated by small studies with high bias, and this SKU has no identifiable manufacturer or electrical safety documentation for the grounding cord. Rejected on brand provenance.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "intention-energy-stones-engraved-river-rock-collection-✨",
      "title": "Intention Energy Stones – Engraved River Rock Collection ✨",
      "vendor": "Wicked Fabulous LLC",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/IMG_0519.jpg?v=1779721086",
      "score": 15,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "intention",
        "energy",
        "stones",
        "engraved",
        "river",
        "rock",
        "collection",
        "wicked",
        "fabulous",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 2,
        "formulation": 15,
        "manufacturing": 35,
        "safety": 60,
        "transparency": 20,
        "sustainability": 30
      },
      "price": 10,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277062820037",
      "vsf_explanation": "Engraved river rocks, not a supplement. Novelty item with no biomedical mechanism or evidence.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "the-natural-intuition-stone",
      "title": "The Natural Intuition Stone",
      "vendor": "Conscious Items",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/the-natural-intuition-stone-7393266.jpg?v=1779721092",
      "score": 15,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "the",
        "natural",
        "intuition",
        "stone",
        "conscious",
        "items"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 5,
        "formulation": 5,
        "manufacturing": 30,
        "safety": 55,
        "transparency": 20,
        "sustainability": 30
      },
      "price": 21.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277063901381",
      "vsf_explanation": "This is a physical amethyst cluster, not an ingestible supplement. Marketed for spiritual/psychic intuition benefits with no scientific mechanism or RCT support. Miscategorized in this batch; does not belong in the supplement rubric.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "money-spell-bottle-herbs-for-attracting-wealth-and-abundance",
      "title": "Money Spell Bottle, Herbs for Attracting Wealth and Abundance",
      "vendor": "Katie Mae Naturals LLC",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/png_20220203_164539_0000.png?v=1779721307",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "money",
        "spell",
        "bottle",
        "herbs",
        "for",
        "attracting",
        "wealth",
        "and",
        "abundance",
        "katie",
        "mae",
        "naturals",
        "llc"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_environment"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 30,
        "manufacturing": 40,
        "safety": 40,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277065965765",
      "vsf_explanation": "A money-attraction herb bottle sold explicitly for manifesting abundance. No health function is claimed or intended. Auto-failed as out of scope for Vyvata.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "healing-spell-bottle-and-crystals-intention-setting-kit",
      "title": "Healing Spell Bottle and Crystals Intention Setting Kit",
      "vendor": "Katie Mae Naturals LLC",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/png_20220505_172421_0000.png?v=1779721311",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "healing",
        "spell",
        "bottle",
        "and",
        "crystals",
        "intention",
        "setting",
        "kit",
        "katie",
        "mae",
        "naturals",
        "llc"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_environment"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 30,
        "manufacturing": 40,
        "safety": 40,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 14.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277065998533",
      "vsf_explanation": "Herbs (willow, amaranth, yarrow, lavender, chamomile) and gemstones sold as a healing intention kit. Framed explicitly as metaphysical vibrations rather than pharmacology or evidence-based therapy. Auto-failed as out of scope for Vyvata.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "protection-spell-bottle-intention-setting-for-protection-and-clearing-energy",
      "title": "Protection Spell Bottle, Intention Setting for Protection and Clearing Energy",
      "vendor": "Katie Mae Naturals LLC",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0001-6905313327_20210830_110714_0000.png?v=1779721318",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "protection",
        "spell",
        "bottle",
        "intention",
        "setting",
        "for",
        "protection",
        "and",
        "clearing",
        "energy",
        "katie",
        "mae",
        "naturals",
        "llc"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_environment"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 30,
        "manufacturing": 40,
        "safety": 40,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277066096837",
      "vsf_explanation": "A small glass bottle of black salt, blue vervain, cedar, rosemary, and juniper berries marketed as an intention-setting protection charm. This is a metaphysical/spiritual craft item, not a biohacking or health-tech product, and it makes no honest measurable claim. Auto-failed as out of scope for Vyvata.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "cold-therapy-compression-sleeve",
      "title": "Cold Therapy Compression Sleeve",
      "vendor": "NatraCure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cold-therapy-compression-sleeve-natracure-1.jpg?v=1779722550",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cold",
        "therapy",
        "compression",
        "sleeve",
        "natracure"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "cold_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 17,
        "formulation": 14,
        "manufacturing": 12,
        "safety": 11,
        "transparency": 6,
        "sustainability": 4
      },
      "price": 18.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277152342213",
      "vsf_explanation": "Non-powered cold therapy sleeve (no electrical auto-fail applies). NatraCure is a 20-year-old US brand with documented Lycra construction, a real product page, and the gel-pack + compression modality has Grade A RCT support for swelling and DOMS. Material composition is partially disclosed but no third-party BPA/phthalate testing on the gel is published, and no evidence citations link to specific studies. Solid Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "leg-massager-with-air-compression-cold-therapy",
      "title": "Leg Massager with Air Compression & Cold Therapy",
      "vendor": "Sunflower Fields: Where Happiness Grows",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/37jEEPwfHw5QrcNr.webp?v=1779722555",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "leg",
        "massager",
        "with",
        "air",
        "compression",
        "cold",
        "therapy",
        "sunflower",
        "fields",
        "where",
        "happiness",
        "grows"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "compression_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 25,
        "safety": 40,
        "transparency": 20,
        "sustainability": 30
      },
      "price": 139.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277152538821",
      "vsf_explanation": "Full-leg sequential air-compression + cold-therapy wrap sold by 'Sunflower Fields', a generic reseller storefront with no manufacturer or model number. Sequential compression is a real modality (Normatec, Therabody etc.), but nothing identifies who actually made this unit or how the cold circuit is powered. Rejected on brand provenance.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "magnetic-therapy-knee-compression-sleeves-pair",
      "title": "Magnetic Therapy Knee Compression Sleeves (Pair)",
      "vendor": "MagnetRX",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/magnetrx-magnetic-knee-support-magnetic-therapy-knee-compression-sleeves-pair-1220836580.jpg?v=1779722561",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnetic",
        "therapy",
        "knee",
        "compression",
        "sleeves",
        "pair",
        "magnetrx"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "compression_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 34.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277152604357",
      "vsf_explanation": "MagnetRX is a real brand and the knee sleeve itself provides ordinary compression, but the marketing rests on static neodymium magnets stimulating acupoints and 'Chi energy.' Cochrane and systematic reviews find no meaningful effect of static magnet therapy on musculoskeletal pain, so the evidence dimension collapses the composite score into the Rejected band even without an auto-fail trigger.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "drip-sweat-pressotherapy-air-compression-and-infrared-therapy-system",
      "title": "Drip Sweat Pressotherapy Air Compression and Infrared Therapy System",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/drip-sweat-advanced-pressotherapy-body-slimming-with-air-wave-pressure-and-far-infrared-heat-wlcmjmlb1219-700031.jpg?v=1779722573",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "drip",
        "sweat",
        "pressotherapy",
        "air",
        "compression",
        "and",
        "infrared",
        "therapy",
        "system",
        "cavitation",
        "machines"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 8,
        "formulation": 6,
        "manufacturing": 4,
        "safety": 5,
        "transparency": 4,
        "sustainability": 4
      },
      "price": 851.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277152899269",
      "vsf_explanation": "This is a pressotherapy/air compression suit with far-infrared heating elements miscategorised as PBM. Pneumatic compression has Grade B-C RCT evidence for recovery; this OEM-sourced device (24 air chambers, 36V) lacks published pressure range specs matched to clinical research, no UL/ETL certification disclosed, no FDA registration, no published material safety data, and no contraindication guidance for cardiac/circulatory conditions which is critical for compression therapy. Cavitation Machines is a generic spa equipment reseller without brand transparency. Rejected.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "kaleidoscope-gradient-compression-arm-sleeve",
      "title": "Kaleidoscope Gradient Compression Arm Sleeve",
      "vendor": "LympheDIVAs",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/kaleidoscope-gradient-compression-arm-sleeve-3031414.jpg?v=1779722589",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "kaleidoscope",
        "gradient",
        "compression",
        "arm",
        "sleeve",
        "lymphedivas"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "compression_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 84.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277153030341",
      "vsf_explanation": "LympheDIVAs gradient compression arm sleeve, part of a real medical compression brand widely used post-mastectomy and for upper-limb lymphedema. The product itself is legitimate but the imported body copy is stray HTML/CSS junk with no product detail, which drags transparency down. Score reflects strong underlying garment, weak listing hygiene.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "misfit-mocha-gradient-compression-socks",
      "title": "Misfit Mocha Gradient Compression Socks",
      "vendor": "LympheDIVAs",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/misfit-mocha-gradient-compression-socks-3173442.jpg?v=1779722595",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "misfit",
        "mocha",
        "gradient",
        "compression",
        "socks",
        "lymphedivas"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "compression_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 70,
        "safety": 70,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 44.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277153423557",
      "vsf_explanation": "Same LympheDIVAs medical-grade gradient compression sock line with the Misfit Mocha pattern. USA-knit, X-Static silver microfiber, seamless 4-way stretch, and therapeutic mmHg ranges validated for lymphedema and edema. Style-forward but the underlying garment is a real medical device.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "darling-fair-gradient-compression-socks",
      "title": "Darling Fair Gradient Compression Socks",
      "vendor": "LympheDIVAs",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/darling-fair-gradient-compression-socks-7484529.jpg?v=1779722611",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "darling",
        "fair",
        "gradient",
        "compression",
        "socks",
        "lymphedivas"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "compression_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 70,
        "safety": 70,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 44.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277154996421",
      "vsf_explanation": "LympheDIVAs is an established US manufacturer of therapeutic gradient compression garments for lymphedema patients, and this sock offers real 15-20, 20-30, or 30-40 mmHg options with X-Static silver antimicrobial fiber. Gradient compression is well-supported by clinical evidence for edema and lymphedema management. Solid upper-Standard entry with real utility beyond aesthetics.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "universal-shoulder-hot-cold-compression-brace",
      "title": "Universal Shoulder Hot/Cold Compression Brace",
      "vendor": "NatraCure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/universal-shoulder-support-with-hotcold-and-compression-natracure-1.jpg?v=1779722619",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "universal",
        "shoulder",
        "hot",
        "cold",
        "compression",
        "brace",
        "natracure"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "cold_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 12,
        "manufacturing": 10,
        "safety": 9,
        "transparency": 5,
        "sustainability": 4
      },
      "price": 36.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277156569285",
      "vsf_explanation": "Non-powered cold/hot compression brace (no electrical certification required). Cold-compression therapy for shoulder injury has Grade A RCT evidence (2024 systematic review). NatraCure is an established US-designed therapy brand with documented neoprene construction and reusable gel-pack design. Lacks formal third-party material testing reports, FDA registration documentation, contraindication disclosure, and sustainability data — places in mid-Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "eye-mask-natural",
      "title": "Eye Mask - Natural",
      "vendor": "Slow North",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/EMNA.jpg?v=1779722640",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "eye",
        "mask",
        "natural",
        "slow",
        "north"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_environment"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 65,
        "safety": 70,
        "transparency": 55,
        "sustainability": 70
      },
      "price": 44,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277156667589",
      "vsf_explanation": "A handmade cotton/linen weighted eye pillow filled with unscented lentils, made in Austin by a real small maker. It is a passive comfort item, not a device, so evidence is limited to the general benefits of light blocking and warm/cold compress for tension headaches. Simple, honest, low-tech sleep-environment product; earns a mid-Standard score.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "usb-heated-ankle-support-with-hot-compress-massage-function-rechargeable-foot-ankle-joint-care-and-foot-massager",
      "title": "USB Heated Ankle Support with Hot Compress Massage Function Rechargeable Foot Ankle Joint Care and Foot Massager",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/42776A46566DF4CDEAD1348F8510AA25.png?v=1779722667",
      "score": 26,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "usb",
        "heated",
        "ankle",
        "support",
        "with",
        "hot",
        "compress",
        "massage",
        "function",
        "rechargeable",
        "foot",
        "ankle",
        "joint",
        "care",
        "and",
        "foot",
        "massager",
        "digital",
        "presence"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "compression_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 30,
        "manufacturing": 20,
        "safety": 35,
        "transparency": 20,
        "sustainability": 25
      },
      "price": 33.36,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277156962501",
      "vsf_explanation": "Unbranded USB-heated ankle brace with a small 1800mAh battery and 30-minute run time, sold by a dropship storefront. No manufacturer, model, or safety certification is disclosed. Rejected on brand provenance.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "hot-compress-blackhead-remover-vacuum-suction-acne-pore-cleaner-electric-nose-face-deep-cleansing-skin-care-device-birthday-gift",
      "title": "Hot Compress Blackhead Remover Vacuum Suction Acne Pore Cleaner Electric Nose Face Deep Cleansing Skin Care Device Birthday Gift",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/09AAE60214720E6AE4E399EBD8AC386A.jpg?v=1779722674",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hot",
        "compress",
        "blackhead",
        "remover",
        "vacuum",
        "suction",
        "acne",
        "pore",
        "cleaner",
        "electric",
        "nose",
        "face",
        "deep",
        "cleansing",
        "skin",
        "care",
        "device",
        "birthday",
        "gift",
        "digital",
        "presence"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 20,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 25,
        "sustainability": 25
      },
      "price": 26.92,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277157060805",
      "vsf_explanation": "Handheld vacuum comedone extractor, not a supplement. Dermatology guidance warns of bruising/telangiectasia risk with home vacuum extractors (AAD position); no clinical evidence for pore reduction.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "hailicare-self-heating-belt-lumbar-disc-herniation-magnetic-therapy-massage-widening-steel-plate-orthopedic-belt",
      "title": "HailiCare Self-Heating Belt Lumbar Disc Herniation Magnetic Therapy Massage Widening Steel Plate Orthopedic Belt",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/FEEE33039F96EDA4948ED961F94C0B9B.jpg?v=1779722684",
      "score": 28,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hailicare",
        "self",
        "heating",
        "belt",
        "lumbar",
        "disc",
        "herniation",
        "magnetic",
        "therapy",
        "massage",
        "widening",
        "steel",
        "plate",
        "orthopedic",
        "belt",
        "digital",
        "presence"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 20,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 30,
        "sustainability": 30
      },
      "price": 45.16,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277157126341",
      "vsf_explanation": "A magnetic-therapy lumbar belt device, not a supplement. Miscategorized; magnetic therapy for back pain lacks convincing clinical evidence (Pittler 2007 CMAJ). Rejected on category grounds; supplement rubric does not apply.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "3d-kneading-massage-shawl-hot-compression-electric-neck-waist-shawl-neck-shoulder-cervical-massage-shawl",
      "title": "3D Kneading Massage Shawl Hot Compression Electric Neck Waist Shawl Neck Shoulder Cervical Massage Shawl",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3072EFE008C87DB0F12D6CAAFFD066C4.jpg?v=1779722691",
      "score": 26,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "kneading",
        "massage",
        "shawl",
        "hot",
        "compression",
        "electric",
        "neck",
        "waist",
        "shawl",
        "neck",
        "shoulder",
        "cervical",
        "massage",
        "shawl",
        "digital",
        "presence"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "percussion_vibration"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 30,
        "manufacturing": 20,
        "safety": 35,
        "transparency": 20,
        "sustainability": 25
      },
      "price": 67.34,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277157388485",
      "vsf_explanation": "Generic 16-node neck-and-shoulder massage shawl with car-adapter power and 'infrared physiotherapy' marketing. The seller is a dropship storefront with no manufacturer, no model number, and no verifiable safety or clearance data. Rejected on brand provenance.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "ems-gua-sha-scraping-body-slim-massager-infrared-therapy-anti-cellulite-fat-burner-beauty-dredging-warm-brush-electro-stimulator",
      "title": "EMS Gua Sha Scraping Body Slim Massager Infrared Therapy Anti Cellulite Fat Burner Beauty Dredging Warm Brush Electro Stimulator",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/A5B3EC8A2D311FA832A481F1BF656AE2.jpg?v=1779722706",
      "score": 23,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ems",
        "gua",
        "sha",
        "scraping",
        "body",
        "slim",
        "massager",
        "infrared",
        "therapy",
        "anti",
        "cellulite",
        "fat",
        "burner",
        "beauty",
        "dredging",
        "warm",
        "brush",
        "electro",
        "stimulator",
        "digital",
        "presence"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "ems_tens"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 25,
        "manufacturing": 20,
        "safety": 35,
        "transparency": 15,
        "sustainability": 25
      },
      "price": 74.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277157716165",
      "vsf_explanation": "A generic ABS-plastic 'meridian massager' with red LEDs, vibration, and micro-EMS marketed to burn fat and dissolve cellulite. The seller is a dropship storefront with no manufacturer, model number, or supporting studies, and the fat-burning claims are pseudoscientific. Rejected on brand provenance.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "nufabrx-capsaicin-infused-compression-calf-sleeve",
      "title": "Nufabrx Capsaicin Infused Compression Calf Sleeve",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/304071732.png?v=1779722727",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nufabrx",
        "capsaicin",
        "infused",
        "compression",
        "calf",
        "sleeve",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "compression_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 14.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277158142149",
      "vsf_explanation": "Nufabrx is a real US textile-drug-delivery brand and its capsaicin-infused compression sleeves are FSA/HSA eligible, indicating an OTC pharmacy classification. Capsaicin has genuine analgesic evidence and gradient compression on the calf is supported for circulation, so the mechanism is honest even if wash-durability of the actives is a legitimate open question. A solid Standard-tier basic recovery item.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "smart-heated-knee-massager-vibration-hot-compress-for-knee-shoulder-elbow-adjustable-heat-intensity",
      "title": "Smart Heated Knee Massager Vibration Hot Compress for Knee, Shoulder & Elbow — Adjustable Heat & Intensity",
      "vendor": "FanzyMarket",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/S8ad819a6e30f4590935856bb2d70c303D.webp?v=1779722762",
      "score": 26,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "smart",
        "heated",
        "knee",
        "massager",
        "vibration",
        "hot",
        "compress",
        "for",
        "knee",
        "shoulder",
        "elbow",
        "adjustable",
        "heat",
        "intensity",
        "fanzymarket"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "compression_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 30,
        "manufacturing": 20,
        "safety": 35,
        "transparency": 20,
        "sustainability": 30
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277158207685",
      "vsf_explanation": "A $14.99 far-infrared heated knee-and-elbow strap from FanzyMarket, a marketplace reseller with no identifiable manufacturer. CE marking is claimed but no model, ODM, or safety certificate is disclosed; at this price point it is almost certainly a generic AliExpress-tier device. Rejected on brand provenance.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "hand-massager",
      "title": "Hand Massager",
      "vendor": "ViralGalleria.com",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_0b623461-8b7b-46f6-86d4-9fab774f757e.jpg?v=1779722789",
      "score": 28,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hand",
        "massager",
        "viralgalleria",
        "com"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "compression_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 35,
        "manufacturing": 20,
        "safety": 40,
        "transparency": 20,
        "sustainability": 30
      },
      "price": 79.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277159583941",
      "vsf_explanation": "Generic cordless heated hand massager with air compression and vibration listed by ViralGalleria.com, a general dropship reseller with no manufacturer, model number, or brand provenance. Heat plus compression massage is a legitimate concept for hand fatigue, but there is no way to verify build quality, thermal safety, or the arthritis and carpal tunnel pain-relief claims made in the copy. Rejected on brand provenance.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "3-in-1-neck-massager-pillow-ergonomic-massager-with-heating-vibration-air-compression-30min-timer-for-neck-back-shoulder-pain-relief",
      "title": "3-in-1 Neck Massager Pillow Ergonomic Massager with Heating Vibration Air Compression 30Min Timer for Neck Back Shoulder Pain Relief",
      "vendor": "GBruno Store",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0b0df366-6776-4b50-ad14-9dd3a97ce45e.jpg?v=1779722805",
      "score": 51,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "neck",
        "massager",
        "pillow",
        "ergonomic",
        "massager",
        "with",
        "heating",
        "vibration",
        "air",
        "compression",
        "30min",
        "timer",
        "for",
        "neck",
        "back",
        "shoulder",
        "pain",
        "relief",
        "gbruno",
        "store"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "percussion_vibration"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 62,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 68.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277159715013",
      "vsf_explanation": "Memory-foam neck pillow combining vibration, air compression, and heat with a 30-minute auto-off. Consumer relaxation/recovery device suitable for desk and travel use. GBruno Store is an unknown reseller with no manufacturing transparency; scores at the low end of Standard for a plausible but undifferentiated product.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "shiatsu-foot-massager-machine-with-heat-electric-deep-kneading-massage-air",
      "title": "Shiatsu Foot Massager Machine with Heat - Electric Deep Kneading Massage Air",
      "vendor": "Vanessa Jane",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/172GZiLVl2.jpg?v=1779722839",
      "score": 53,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shiatsu",
        "foot",
        "massager",
        "machine",
        "with",
        "heat",
        "electric",
        "deep",
        "kneading",
        "massage",
        "air",
        "vanessa",
        "jane"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "percussion_vibration"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 86,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277160403141",
      "vsf_explanation": "Consumer shiatsu foot massager combining kneading, air compression, and infrared heat. Standard recovery-category device with genuine utility for neuropathy-adjacent symptoms, plantar fasciitis discomfort, and post-workout leg recovery. Generic branding and no clinical data; typical of the category.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "shape-tactics-advanced-body-sculpting-with-negative-pressure-and-inner-ball-roller",
      "title": "Shape Tactics Advanced Body Sculpting with Negative Pressure and Inner Ball Roller",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-advanced-body-sculpting-negative-pressure-and-inner-ball-roller-technology-vtcm54v1-399129.webp?v=1779722975",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "advanced",
        "body",
        "sculpting",
        "with",
        "negative",
        "pressure",
        "and",
        "inner",
        "ball",
        "roller",
        "cavitation",
        "machines"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "ems_tens"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 32,
        "manufacturing": 38,
        "safety": 45,
        "transparency": 30,
        "sustainability": 30
      },
      "price": 8452.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277162238149",
      "vsf_explanation": "$8,450 salon body-sculpting console with intelligent rotating roller and negative-pressure vacuum handles for aesthetic contouring, lymphatic-drainage-style massage, and facial work. Endermologie-style aesthetic device rather than a biohacking product; out of scope regardless of price.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "shape-tactics-lympathic-drainage-massage-system",
      "title": "Shape Tactics Lympathic Drainage Massage System",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-lympathic-drainage-massage-system-mscm2172c-949306.jpg?v=1779724802",
      "score": 22,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "lympathic",
        "drainage",
        "massage",
        "system",
        "cavitation",
        "machines"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 12,
        "formulation": 20,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 30,
        "sustainability": 30
      },
      "price": 263.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277176295621",
      "vsf_explanation": "Vacuum-cup contouring machine, not a supplement. Manual lymphatic drainage has RCT support in post-surgical lymphedema (Ezzo 2015 Cochrane) but that is a trained clinical technique, not a home cupping device.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "shape-tactics-7-in-1-hydrospa-facial-system",
      "title": "Shape Tactics 7-in-1 HydroSpa Facial System",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-7-in-1-hydrospa-facial-system-srcmaf1328-9183430.jpg?v=1779724812",
      "score": 24,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "hydrospa",
        "facial",
        "system",
        "cavitation",
        "machines"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 22,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 35,
        "sustainability": 30
      },
      "price": 542.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277176328389",
      "vsf_explanation": "Hydrodermabrasion salon device, not a supplement. Professional hydrodermabrasion has small-trial cosmetic data (Freedman 2008 pilot) but this is a device, not an ingestible.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "shape-tactics-9-in-1-bio-photon-beauty-system",
      "title": "Shape Tactics 9-in-1 BIO Photon Beauty System",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-9-in-1-bio-photon-beauty-system-lscm78d1maxsb-145506.jpg?v=1779724838",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "bio",
        "photon",
        "beauty",
        "system",
        "cavitation",
        "machines"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "ems_tens"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 30,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 30,
        "sustainability": 30
      },
      "price": 728.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277177704645",
      "vsf_explanation": "9-in-1 salon beauty station with 40 kHz cavitation, 1 MHz RF, vacuum, microcurrent, LED pads, and hot/cold handpiece for body sculpting and anti-aging facials. Salon aesthetics equipment; out of scope for Vyvata's biohacking rubric.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "shape-tactics-uvb-311nm-phototherapy-device",
      "title": "Shape Tactics UVB 311nm Phototherapy Device",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-uvb-311nm-phototherapy-device-kn4003blcm-778248.png?v=1779724846",
      "score": 28,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "uvb",
        "311nm",
        "phototherapy",
        "device",
        "cavitation",
        "machines"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 25,
        "manufacturing": 45,
        "safety": 35,
        "transparency": 40,
        "sustainability": 30
      },
      "price": 299,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277177770181",
      "vsf_explanation": "Narrowband UVB 311 nm handheld device, not a supplement. NB-UVB is evidence-based prescription therapy for psoriasis and vitiligo (Menter 2010 AAD guidelines) but requires medical supervision; unsupervised home use carries burn and skin-cancer risk.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "shape-tactics-40k-cavitation-rf-handle",
      "title": "Shape Tactics 40K Cavitation + RF Handle",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-40k-cavitation-rf-handle-bscm56v3s40krf-343726.jpg?v=1779724861",
      "score": 27,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "40k",
        "cavitation",
        "handle",
        "cavitation",
        "machines"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "ems_tens"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 25,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 25,
        "sustainability": 30
      },
      "price": 184.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277177835717",
      "vsf_explanation": "Replacement 40 kHz cavitation + RF handpiece compatible only with a single Cavitation Machines console model. Accessory for salon aesthetics equipment; not a standalone biohacking product.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "drip-sweat-lotuswave-acupressure-relaxation-mat",
      "title": "Drip Sweat LotusWave Acupressure & Relaxation Mat",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/drip-sweat-lotuswave-acupressure-relaxation-mat-wlcmmp03black-368491.jpg?v=1779724878",
      "score": 53,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "drip",
        "sweat",
        "lotuswave",
        "acupressure",
        "relaxation",
        "mat",
        "cavitation",
        "machines"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "stretch_mobility"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 125.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277177901253",
      "vsf_explanation": "Acupressure mat and pillow set for full-body pressure-point stimulation, back/neck tension, and pre-sleep relaxation. Acupressure mats are a well-established consumer category with modest but real evidence for perceived relaxation and pain relief. Middle-of-market execution; no distinguishing features, but a legitimate recovery tool.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "shape-tactics-pro-5-in-1-rf-led-body-contouring-system",
      "title": "Shape Tactics Pro 5-in-1 RF & LED Body Contouring System",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-pro-5-in-1-lipo-laser-cavitation-rf-sculpting-system-bscm56v3s-141709.jpg?v=1779724892",
      "score": 26,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "pro",
        "led",
        "body",
        "contouring",
        "system",
        "cavitation",
        "machines"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 25,
        "manufacturing": 30,
        "safety": 35,
        "transparency": 25,
        "sustainability": 25
      },
      "price": 901.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277178097861",
      "vsf_explanation": "This is a body-contouring device, not an ingestible supplement, so the supplement rubric does not apply. Home RF/cavitation devices have thin clinical support beyond short-term skin appearance changes (Alizadeh 2014 review) and no brand-provided clinical data. Rejected for category mismatch.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "shape-tactics-7-color-led-face-system",
      "title": "Shape Tactics 7 Color LED Face System",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-7-color-led-face-system-ltcm1102-186806.jpg?v=1779724902",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "color",
        "led",
        "face",
        "system",
        "cavitation",
        "machines"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 30,
        "sustainability": 30
      },
      "price": 54,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277178360005",
      "vsf_explanation": "Very low-cost ($54) 7-color LED face mask with no wavelength specifications published and only a 700 mAh battery / 5 V spec sheet. Generic Chinese-import-tier LED face mask with no differentiation, no clinical dossier, and no proof of stated wavelengths. Photobiomodulation for skin is a legitimate modality, but this product does not clear even a Standard bar.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "blyss-helio-professional-grade-led-photon-therapy-mask",
      "title": "Blyss Helio – Professional-Grade LED Photon Therapy Mask",
      "vendor": "Blyss Care",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Blyss_helio_face_LED_mask.jpg?v=1779724947",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "blyss",
        "helio",
        "professional",
        "grade",
        "led",
        "photon",
        "therapy",
        "mask",
        "blyss",
        "care"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 449,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277178556613",
      "vsf_explanation": "Full-face LED photon therapy mask with 220 LEDs across four wavelengths (blue 470 nm, red 630 nm, plus additional bands). LED photobiomodulation for skin has FDA-cleared benchmarks (CurrentBody, Omnilux) with real evidence; Blyss Helio does not itself have listed clearances or clinical trials, and Blyss Care is a smaller DTC brand. Reasonable consumer-grade LED mask, Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "blyss-luna-the-ultimate-3-in-1-skin-rejuvenation-device",
      "title": "Blyss Luna – The Ultimate 3-in-1 Skin Rejuvenation Device",
      "vendor": "Blyss Care",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Blyss_Luna_face_sculpting_LED_microcurrent_device_face.jpg?v=1779724957",
      "score": 27,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "blyss",
        "luna",
        "the",
        "ultimate",
        "skin",
        "rejuvenation",
        "device",
        "blyss",
        "care"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 30,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 25,
        "sustainability": 25
      },
      "price": 349,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277178622149",
      "vsf_explanation": "Handheld EMS/RF/LED beauty device, not an ingestible. Home devices in this class rely on manufacturer marketing rather than peer-reviewed RCTs. Rejected as out-of-scope for the supplement rubric.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "blyss-aria-radio-frequency-neck-face-lifting-device",
      "title": "Blyss Aria — Radio Frequency Neck & Face Lifting Device",
      "vendor": "Blyss Care",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Blyss_Aria_face_sculpting_device.jpg?v=1779724961",
      "score": 27,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "blyss",
        "aria",
        "radio",
        "frequency",
        "neck",
        "face",
        "lifting",
        "device",
        "blyss",
        "care"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 30,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 25,
        "sustainability": 25
      },
      "price": 289,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277178753221",
      "vsf_explanation": "RF/EMS/red-light beauty device, not an ingestible supplement. No peer-reviewed clinical dataset supplied; manufacturer marketing only. Rejected for category mismatch.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "blyss-lila-rf-ems-photon-eye-revitalizer",
      "title": "Blyss Lila – RF, EMS & Photon Eye Revitalizer",
      "vendor": "Blyss Care",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Blyss_Lila_light_therapy_LED_eye1.jpg?v=1779724965",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "blyss",
        "lila",
        "ems",
        "photon",
        "eye",
        "revitalizer",
        "blyss",
        "care"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "ems_tens"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 30,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 32,
        "sustainability": 32
      },
      "price": 179,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277178818757",
      "vsf_explanation": "Pen-format under-eye device combining RF, EMS, and photon light for cosmetic anti-aging around the eye area. Cosmetic beauty tool; out of scope.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "blyss-conductive-microcurrent-activator-gel",
      "title": "Blyss Conductive Microcurrent Activator Gel",
      "vendor": "Blyss Care",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Blyssgel1.jpg?v=1779724974",
      "score": 28,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "blyss",
        "conductive",
        "microcurrent",
        "activator",
        "gel",
        "blyss",
        "care"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 35,
        "manufacturing": 30,
        "safety": 45,
        "transparency": 25,
        "sustainability": 25
      },
      "price": 39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277178917061",
      "vsf_explanation": "Topical conductive gel for use with microcurrent devices, not an ingestible supplement. Hyaluronic acid and glycerin have basic hydration evidence, but the product is out-of-scope for the supplement rubric.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "blyss-maia-sonic-facial-cleansing-brush-eye-massager-with-heating",
      "title": "Blyss Maia – Sonic Facial Cleansing Brush & Eye Massager with Heating",
      "vendor": "Blyss Care",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Blyss_Maia_-_sonic_face_brush.jpg?v=1779724980",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "blyss",
        "maia",
        "sonic",
        "facial",
        "cleansing",
        "brush",
        "eye",
        "massager",
        "with",
        "heating",
        "blyss",
        "care"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "stretch_mobility"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 30,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 32,
        "sustainability": 32
      },
      "price": 179,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277178982597",
      "vsf_explanation": "Sonic silicone cleansing brush with a heated eye-massage attachment. This is a facial skincare/cleansing tool, not a biohacking device. Out of scope.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "blyss-iris-ultrasonic-facial-scrubber-skin-spatula",
      "title": "Blyss Iris – Ultrasonic Facial Scrubber & Skin Spatula",
      "vendor": "Blyss Care",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Blyss_Iris_ultrasonic_scrubber_1.jpg?v=1779724980",
      "score": 27,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "blyss",
        "iris",
        "ultrasonic",
        "facial",
        "scrubber",
        "skin",
        "spatula",
        "blyss",
        "care"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 30,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 25,
        "sustainability": 25
      },
      "price": 179,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277179048133",
      "vsf_explanation": "Ultrasonic facial scrubber, not an ingestible supplement. Class has minimal peer-reviewed support for meaningful skin outcomes; rejected as category mismatch.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "blyss-mira-photon-led-high-frequency-vibration-facial-device",
      "title": "Blyss Mira – Photon LED & High-Frequency Vibration Facial Device",
      "vendor": "Blyss Care",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Blyss_Lila_light_therapy_LED_device_2_copy.jpg?v=1779724979",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "blyss",
        "mira",
        "photon",
        "led",
        "high",
        "frequency",
        "vibration",
        "facial",
        "device",
        "blyss",
        "care"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 10,
        "manufacturing": 30,
        "safety": 45,
        "transparency": 20,
        "sustainability": 30
      },
      "price": 135,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277179015365",
      "vsf_explanation": "This is an LED/vibration facial device, not an ingestible supplement. Miscategorized in this batch; the supplement rubric does not apply. Belongs in the non-supplement device workstream.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "neck-face-lifting-led-therapy-device",
      "title": "Neck & Face Lifting LED Therapy Device",
      "vendor": "BeNat",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BeNatLEDtherapy.jpg?v=1779724995",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "neck",
        "face",
        "lifting",
        "led",
        "therapy",
        "device",
        "benat"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 28,
        "manufacturing": 35,
        "safety": 50,
        "transparency": 30,
        "sustainability": 30
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277179670725",
      "vsf_explanation": "Handheld neck/face LED wand with vibration marketed for wrinkle removal, double-chin reduction, and pore shrinking. Cosmetic anti-aging device, out of scope for Vyvata's biohacking rubric.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "healthy-scalp-comb",
      "title": "Healthy Scalp Comb",
      "vendor": "BeNat",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/scalp_comb.jpg?v=1779725042",
      "score": 21,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "healthy",
        "scalp",
        "comb",
        "benat"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 20,
        "manufacturing": 25,
        "safety": 45,
        "transparency": 15,
        "sustainability": 20
      },
      "price": 5.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277183078597",
      "vsf_explanation": "Plastic scalp comb, not a supplement. No credible evidence for dandruff or hair growth claims. Rejected for category mismatch and unverified benefit claims.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "under-eye-red-light-therapy-skin-rejuvenation-and-relaxation-massager",
      "title": "Under-Eye Red Light Therapy Skin Rejuvenation and Relaxation Massager",
      "vendor": "BeNat",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BeNat_format.jpg?v=1779725042",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "under",
        "eye",
        "red",
        "light",
        "therapy",
        "skin",
        "rejuvenation",
        "and",
        "relaxation",
        "massager",
        "benat"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 28,
        "manufacturing": 35,
        "safety": 50,
        "transparency": 30,
        "sustainability": 30
      },
      "price": 59.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277183111365",
      "vsf_explanation": "Under-eye massager combining red light with microcurrent vibration for cosmetic anti-aging (dark circles, puffiness, fine lines). Cosmetic beauty tool outside biohacking scope.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "lift-sculpt-glow-toolkit",
      "title": "Lift, Sculpt & Glow Toolkit",
      "vendor": "BeNat",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BeNatLift_Sculpt_GlowToolkit.jpg?v=1779725042",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lift",
        "sculpt",
        "glow",
        "toolkit",
        "benat"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 28,
        "manufacturing": 35,
        "safety": 50,
        "transparency": 30,
        "sustainability": 30
      },
      "price": 79.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277183144133",
      "vsf_explanation": "Bundle of three facial anti-aging beauty devices: LED therapy neck/face wand, electric gua sha, and microcurrent toning wand. Entirely cosmetic anti-aging use case; out of scope for Vyvata.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "rose-quartz-face-roller",
      "title": "Rose Quartz Face Roller",
      "vendor": "BeNat",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BeNat_format_Rose_Quartz.jpg?v=1779725042",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "rose",
        "quartz",
        "face",
        "roller",
        "benat"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 20,
        "manufacturing": 25,
        "safety": 45,
        "transparency": 15,
        "sustainability": 20
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277183176901",
      "vsf_explanation": "Crystal facial roller — cosmetic accessory, not a supplement. No RCT support for lymphatic or firmness claims. Rejected as out-of-scope.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "jade-roller-gua-sha-gift-box",
      "title": "Jade Roller & Gua Sha Gift Box",
      "vendor": "BeNat",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Recurso51.png?v=1779725048",
      "score": 22,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "jade",
        "roller",
        "gua",
        "sha",
        "gift",
        "box",
        "benat"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 20,
        "manufacturing": 40,
        "safety": 60,
        "transparency": 25,
        "sustainability": 30
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277183471813",
      "vsf_explanation": "Jade roller / gua sha is a skincare tool, not a supplement. Facial massage tools have limited RCT support for durable dermatologic outcomes and are outside the supplement rubric.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "rolling-body-massager",
      "title": "Rolling Body Massager",
      "vendor": "BeNat",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/03_39f5c382-ba44-4a96-b3ee-2362c381b31f.png?v=1779725048",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "rolling",
        "body",
        "massager",
        "benat"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "stretch_mobility"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 8.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277183439045",
      "vsf_explanation": "Simple manual three-ball stainless-steel massage roller at $9. Basic self-massage rollers can support fascial mobility, but marketing invokes pseudoscience ('expels residual toxins and fat,' cellulite reduction) that isn't supported by evidence. Real product but not distinguishable from generic imports and drags itself into Rejected on evidence and transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "eye-face-ice-roller-massager",
      "title": "Eye & Face Ice Roller Massager",
      "vendor": "BeNat",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/21_b4bf7984-95c4-4991-98b2-6ea8aaa2f00c.png?v=1779725048",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "eye",
        "face",
        "ice",
        "roller",
        "massager",
        "benat"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "cold_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 28,
        "manufacturing": 35,
        "safety": 55,
        "transparency": 30,
        "sustainability": 30
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277183504581",
      "vsf_explanation": "Handheld stainless-steel facial ice roller for depuffing and skincare rituals. Cold therapy is a legitimate biohacking modality, but a facial ice roller is a cosmetic beauty tool, not a whole-body cold-plunge or cryotherapy device. Out of scope.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "electric-gua-sha-facial-sculpting",
      "title": "Electric Gua Sha Facial Sculpting",
      "vendor": "BeNat",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Electricguasha.jpg?v=1779725048",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "electric",
        "gua",
        "sha",
        "facial",
        "sculpting",
        "benat"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "stretch_mobility"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 28,
        "manufacturing": 35,
        "safety": 50,
        "transparency": 30,
        "sustainability": 30
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277183537349",
      "vsf_explanation": "Facial anti-aging gua sha device with heat, vibration, and red light. Cosmetic beauty tool positioned for wrinkle reduction and 'facial sculpting.' Out of scope for Vyvata's biohacking rubric.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "microcurrent-facial-toning-massager",
      "title": "Microcurrent Facial Toning Massager",
      "vendor": "BeNat",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BeNattemplatecopy.jpg?v=1779725049",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "microcurrent",
        "facial",
        "toning",
        "massager",
        "benat"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "ems_tens"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 28,
        "manufacturing": 35,
        "safety": 50,
        "transparency": 30,
        "sustainability": 30
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277183602885",
      "vsf_explanation": "Handheld microcurrent facial toning device for wrinkle reduction and jawline lifting. Cosmetic use case (facial aesthetics) rather than biohacking. Out of scope.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "smart-scalp-massager",
      "title": "Smart Scalp Massager",
      "vendor": "BeNat",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BeNatsmartscalpmassager.jpg?v=1779725048",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "smart",
        "scalp",
        "massager",
        "benat"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "stretch_mobility"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277183570117",
      "vsf_explanation": "Cordless, waterproof electric scalp massager with rotating silicone nodes for relaxation and mild scalp stimulation. Product itself is fine, but the marketing includes overreaching hair-growth claims not supported by clinical evidence, and BeNat is a low-visibility private-label brand with no manufacturing transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "shape-tactics-proelite-40k-rf-lipo-laser-system",
      "title": "Shape Tactics ProElite 40K RF Lipo Laser System",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-proelite-40k-rf-lipo-laser-system-wlcmwd674a-875242.png?v=1779725138",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "proelite",
        "40k",
        "lipo",
        "laser",
        "system",
        "cavitation",
        "machines"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 15,
        "manufacturing": 30,
        "safety": 30,
        "transparency": 20,
        "sustainability": 20
      },
      "price": 1111.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277184487621",
      "vsf_explanation": "40kHz ultrasonic cavitation + RF body-contouring device. Not a supplement. Cavitation studies (Jewell 2011) show limited efficacy and this is a consumer version of clinical hardware.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "shape-tactics-3-in-1-vacuum-rf-microneedling-system-with-blue-light",
      "title": "Shape Tactics 3-in-1 Vacuum RF Microneedling System with Blue Light",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-3-in-1-vacuum-rf-microneedling-system-with-blue-light-r105cm-7054890.jpg?v=1779725137",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "vacuum",
        "microneedling",
        "system",
        "with",
        "blue",
        "light",
        "cavitation",
        "machines"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 10,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 20,
        "sustainability": 25
      },
      "price": 2912.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277184553157",
      "vsf_explanation": "Professional microneedling/RF/vacuum device, not an ingestible supplement. Miscategorized in this batch; belongs in the aesthetic-devices workstream.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "shape-tactics-8-in-1-hydro-dermabrasion-skin-analysis-system",
      "title": "Shape Tactics 8-in-1 Hydro Dermabrasion & Skin Analysis System",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-8-in-1-hydro-dermabrasion-skin-analyzer-machine-srcmaf1337-604114.jpg?v=1779725138",
      "score": 27,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "hydro",
        "dermabrasion",
        "skin",
        "analysis",
        "system",
        "cavitation",
        "machines"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 30,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 25,
        "sustainability": 25
      },
      "price": 1291.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277184520389",
      "vsf_explanation": "Professional hydrodermabrasion device, not an ingestible supplement. Rejected as category mismatch for the supplement rubric.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "shape-tactics-7d-high-intensity-focused-ultrasound-hifu-machine",
      "title": "Shape Tactics 7D High-Intensity Focused Ultrasound (HIFU) Machine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-7d-high-intensity-focused-ultrasound-hifu-machine-lbcm11q7-442246.jpg?v=1779725137",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "high",
        "intensity",
        "focused",
        "ultrasound",
        "hifu",
        "machine",
        "cavitation",
        "machines"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "ems_tens"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 30,
        "manufacturing": 35,
        "safety": 42,
        "transparency": 30,
        "sustainability": 30
      },
      "price": 1787.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277184585925",
      "vsf_explanation": "Non-clinical 7D HIFU machine marketed for skin lifting and body contouring via focused ultrasound at 65-75 C. Clinical HIFU (Ultherapy, HIFEM devices) is FDA-cleared and performed by trained clinicians; this consumer/salon variant makes similar physiological claims without matching clearance or credentialing. Aesthetics device outside biohacking scope, with a soft misleading-naming concern around 'HIFU.'",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "shape-tactics-rechargeable-311nm-uvb-phototherapy-device",
      "title": "Shape Tactics Rechargeable 311nm UVB Phototherapy Device",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-uvb-8w-light-treatment-kn4003bld2cm-813360.jpg?v=1779725137",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "rechargeable",
        "311nm",
        "uvb",
        "phototherapy",
        "device",
        "cavitation",
        "machines"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 30,
        "manufacturing": 35,
        "safety": 30,
        "transparency": 25,
        "sustainability": 25
      },
      "price": 356.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277184651461",
      "vsf_explanation": "Narrowband UVB device — a phototherapy medical device, not a supplement. NB-UVB has strong dermatology evidence for psoriasis (Menter 2010) but self-directed home use carries burn/skin-cancer risk without clinician oversight. Rejected as category mismatch.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "shape-tactics-mini-nd-yag-laser-system",
      "title": "Shape Tactics Mini ND Yag Laser System",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-mini-nd-yag-laser-system-j210cm-359418.jpg?v=1779725137",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "mini",
        "yag",
        "laser",
        "system",
        "cavitation",
        "machines"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 25,
        "manufacturing": 30,
        "safety": 20,
        "transparency": 25,
        "sustainability": 25
      },
      "price": 2833.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277184618693",
      "vsf_explanation": "Q-switched Nd:YAG tattoo/pigment laser — professional-only device, not a supplement. Safety concerns for at-home use are significant. Rejected as category mismatch.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "shape-tactics-2-in-1-titanium-808-diode-laser-system",
      "title": "Shape Tactics 2-in-1 Titanium 808 Diode Laser System",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-2-in-1-titanium-808-diode-laser-system-hrcmas69-226042.jpg?v=1779725137",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "titanium",
        "808",
        "diode",
        "laser",
        "system",
        "cavitation",
        "machines"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 25,
        "manufacturing": 30,
        "safety": 20,
        "transparency": 25,
        "sustainability": 25
      },
      "price": 3217.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277184815301",
      "vsf_explanation": "Diode laser hair/aesthetic system — professional device, not a supplement. Rejected for category mismatch and consumer-safety issues.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "shape-tactics-3-in-1-facial-and-eye-mesotherapy-system",
      "title": "Shape Tactics 3-in-1 Facial and Eye Mesotherapy System",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-3-in-1-facial-and-eye-mesotherapy-system-arcmru638-514169.jpg?v=1779725137",
      "score": 26,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "facial",
        "and",
        "eye",
        "mesotherapy",
        "system",
        "cavitation",
        "machines"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 25,
        "manufacturing": 30,
        "safety": 35,
        "transparency": 25,
        "sustainability": 25
      },
      "price": 159.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277184684229",
      "vsf_explanation": "Ultrasonic 'mesotherapy' facial device, not an ingestible supplement. Rejected as category mismatch.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "shape-tactics-ndplus-air-cooled-laser-system",
      "title": "Shape Tactics NDPlus Air Cooled Laser System",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-ndplus-air-cooled-laser-system-j208cm-986614.jpg?v=1779725137",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "ndplus",
        "air",
        "cooled",
        "laser",
        "system",
        "cavitation",
        "machines"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 10,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 20,
        "sustainability": 25
      },
      "price": 5248.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277184716997",
      "vsf_explanation": "ND:YAG laser tattoo-removal system, not an ingestible supplement. Miscategorized in this batch.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "shape-tactics-soprano-ice-platinum-4-wavelength-diode-laser-hair-removal",
      "title": "Shape Tactics Soprano Ice Platinum 4-Wavelength Diode Laser Hair Removal",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-soprano-ice-platinum-4-wavelength-diode-laser-hair-removal-hrcm808g-223786.jpg?v=1779725138",
      "score": 26,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "soprano",
        "ice",
        "platinum",
        "wavelength",
        "diode",
        "laser",
        "hair",
        "removal",
        "cavitation",
        "machines"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 25,
        "manufacturing": 30,
        "safety": 25,
        "transparency": 25,
        "sustainability": 25
      },
      "price": 6127.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277184848069",
      "vsf_explanation": "Commercial 12,000W diode laser hair-removal platform for clinics — not a supplement. Rejected as category mismatch.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "shape-tactics-depi-diode-laser-system",
      "title": "Shape Tactics Depi Diode Laser System",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-depi-diode-laser-system-njbfhrportprocm-4705755.png?v=1779725137",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "depi",
        "diode",
        "laser",
        "system",
        "cavitation",
        "machines"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 10,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 20,
        "sustainability": 25
      },
      "price": 4199.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277184782533",
      "vsf_explanation": "Diode laser hair-removal system, not an ingestible supplement. Miscategorized in this batch.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "shape-tactics-2-in-1-rf-ems-mesotherapy-skin-rejuvenation-system-cartridge",
      "title": "Shape Tactics 2-in-1 RF EMS Mesotherapy Skin Rejuvenation System Cartridge",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-2-in-1-rf-ems-mesotherapy-skin-rejuvenation-system-cartridge-srcmnv6130cart-6362170.png?v=1779725137",
      "score": 26,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "ems",
        "mesotherapy",
        "skin",
        "rejuvenation",
        "system",
        "cartridge",
        "cavitation",
        "machines"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "ems_tens"
      ],
      "vsf_dimensions": {
        "evidence": 18,
        "formulation": 25,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 25,
        "sustainability": 28
      },
      "price": 33.75,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277184749765",
      "vsf_explanation": "Replacement mesotherapy cartridge compatible only with one specific Cavitation Machines model. As an accessory to salon aesthetics equipment, this is not a standalone biohacking product. 'Needle-free mesotherapy' claims for deep delivery also lack rigorous support.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "shape-tactics-violet-7-electrode-high-frequency-facial-system",
      "title": "Shape Tactics Violet 7-Electrode High-Frequency Facial System",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-violet-7-electrode-high-frequency-facial-device-srcm0004-736376.jpg?v=1779725138",
      "score": 24,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "violet",
        "electrode",
        "high",
        "frequency",
        "facial",
        "system",
        "cavitation",
        "machines"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 25,
        "manufacturing": 30,
        "safety": 35,
        "transparency": 25,
        "sustainability": 25
      },
      "price": 136.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277184979141",
      "vsf_explanation": "High-frequency 'violet wand' facial device — a beauty gadget with essentially no modern peer-reviewed support. Not a supplement; rejected.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "shape-tactics-8-in-1-hot-cold-fusion-plasma-facial-beauty-system",
      "title": "Shape Tactics 8-in-1 Hot & Cold Fusion Plasma Facial Beauty System",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-8-in-1-hot-cold-fusion-plasma-facial-beauty-system-pscm22t2-209557.jpg?v=1779725137",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "hot",
        "cold",
        "fusion",
        "plasma",
        "facial",
        "beauty",
        "system",
        "cavitation",
        "machines"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 10,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 20,
        "sustainability": 25
      },
      "price": 3424.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277184880837",
      "vsf_explanation": "Plasma facial device, not an ingestible supplement. Miscategorized in this batch.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "shape-tactics-depth-8-gold-rf-micro-needling-system",
      "title": "Shape Tactics Depth 8 Gold RF Micro-Needling System",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-depth-8-gold-rf-micro-needling-anti-aging-system-mfcm21v1-904041.jpg?v=1779725138",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "depth",
        "gold",
        "micro",
        "needling",
        "system",
        "cavitation",
        "machines"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 10,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 20,
        "sustainability": 25
      },
      "price": 2519.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277184913605",
      "vsf_explanation": "RF microneedling device, not an ingestible supplement. Miscategorized in this batch.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "shape-tactics-precision-3d-skin-analyzer-with-ai-face-mapping",
      "title": "Shape Tactics Precision 3D Skin Analyzer with AI Face Mapping",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-precision-3d-skin-analyzer-with-ai-face-detection-pscmmax-675397.jpg?v=1779725138",
      "score": 27,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "precision",
        "skin",
        "analyzer",
        "with",
        "face",
        "mapping",
        "cavitation",
        "machines"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 25,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 25,
        "sustainability": 25
      },
      "price": 2613.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277184946373",
      "vsf_explanation": "AI skin-imaging analyzer — diagnostic imaging device, not a supplement. Rejected as category mismatch.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "shape-tactics-lymphatic-vacuum-system",
      "title": "Shape Tactics Lymphatic & Vacuum System",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-lymphatic-vacuum-system-mscm2185-209917.jpg?v=1779725166",
      "score": 22,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "lymphatic",
        "vacuum",
        "system",
        "cavitation",
        "machines"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 4,
        "formulation": 4,
        "manufacturing": 2,
        "safety": 4,
        "transparency": 2,
        "sustainability": 6
      },
      "price": 193.75,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277185208517",
      "vsf_explanation": "Rejected at 22/100. Sub-categorization is wrong (this is a cavitation/vacuum aesthetic device, not photobiomodulation), and on its actual modality (suction-based lymphatic 'drainage' + cavitation for body contouring) the human RCT evidence base is thin and the device makes cosmetic-aesthetic claims rather than recovery claims. No FDA 510(k) found for Shape Tactics / MHTDEV; no UL/ETL on the powered vacuum/RF console documented; no independent parameter verification; manufacturer is a Las Vegas LLC with no published clinical research. Multiple dimensions score near zero.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "shape-tactics-uv-magnifying-lamp-for-skin-analysis",
      "title": "Shape Tactics UV Magnifying Lamp for Skin Analysis",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-uv-magnifying-lamp-for-skin-analysis-kn9000bcm-760609.png?v=1779725171",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "magnifying",
        "lamp",
        "for",
        "skin",
        "analysis",
        "cavitation",
        "machines"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 25,
        "manufacturing": 30,
        "safety": 30,
        "transparency": 25,
        "sustainability": 25
      },
      "price": 400,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277185274053",
      "vsf_explanation": "Wood's lamp / UV magnifier for dermatologic observation — a clinical exam tool, not a supplement. Rejected as category mismatch.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "shape-tactics-pdt-408-led-light-therapy-system",
      "title": "Shape Tactics PDT 408 LED Light Therapy System",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-pdt-408-led-photon-photodynamic-beauty-device-ltcm100a-571172.jpg?v=1779725291",
      "score": 24,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "pdt",
        "408",
        "led",
        "light",
        "therapy",
        "system",
        "cavitation",
        "machines"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 4,
        "manufacturing": 0,
        "safety": 5,
        "transparency": 1,
        "sustainability": 4
      },
      "price": 4115.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277198774469",
      "vsf_explanation": "High-power salon-grade LED system sold by a reseller (Cavitation Machines LLC) that does not manufacture its products. No identifiable OEM brand site, no UL/ETL/CE listing, no FDA 510(k), no published irradiance verification, and no warranty terms surfaced. Powered medical-aesthetic device without electrical safety certification triggers the CAT 2 auto-fail.",
      "vsf_autofail_rule": "Powered Device Without Electrical Certification"
    },
    {
      "handle": "shape-tactics-advanced-multi-wavelength-picosecond-laser-system",
      "title": "Shape Tactics Advanced Multi-Wavelength Picosecond Laser System",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-precision-picosecond-laser-tattoo-removal-skin-renewal-hrcmas66-203580.webp?v=1779725392",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "advanced",
        "multi",
        "wavelength",
        "picosecond",
        "laser",
        "system",
        "cavitation",
        "machines"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 25,
        "manufacturing": 30,
        "safety": 20,
        "transparency": 25,
        "sustainability": 25
      },
      "price": 1580.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277236392133",
      "vsf_explanation": "Multi-wavelength picosecond laser platform — professional cosmetic laser system, not a supplement. Rejected as category mismatch.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "shape-tactics-40k-unoisetion-cavitation-2-0-handle-with-photon",
      "title": "Shape Tactics 40K Unoisetion Cavitation 2.0 Handle with Photon",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-40k-unoisetion-cavitation-20-handle-with-photon-mscmjs4201bcavi-142883.jpg?v=1779725391",
      "score": 27,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "40k",
        "unoisetion",
        "cavitation",
        "handle",
        "with",
        "photon",
        "cavitation",
        "machines"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "ems_tens"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 25,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 25,
        "sustainability": 30
      },
      "price": 229.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277236359365",
      "vsf_explanation": "Replacement cavitation handle accessory compatible only with specific salon-machine SKUs — not a standalone consumer device. Even setting aside the aesthetics-only use case, this is a spare part rather than a biohacking product.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "shape-tactics-cordless-7-color-led-light-therapy-facial-mask",
      "title": "Shape Tactics Cordless 7-Color LED Light Therapy Facial Mask",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-cordless-7-color-light-therapy-facial-mask-ltcm110y-u-272734.jpg?v=1779725391",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "cordless",
        "color",
        "led",
        "light",
        "therapy",
        "facial",
        "mask",
        "cavitation",
        "machines"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 11,
        "formulation": 6,
        "manufacturing": 4,
        "safety": 5,
        "transparency": 6,
        "sustainability": 4
      },
      "price": 74.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277236424901",
      "vsf_explanation": "Red (630nm) and blue (470nm) LED facial therapy have Grade B evidence for skin/acne; the other claimed wavelengths (1040nm purple, 1580nm white) are inconsistent with standard LED physics and suggest marketing rather than measured spec. No UL/ETL certification disclosed, no FDA registration, no third-party irradiance verification, no eye-safety contraindication detail, no clinical citations, and unclear brand ownership (OEM mask resold under multiple labels). Rejected.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "shape-tactics-precision-picosecond-laser-system",
      "title": "Shape Tactics Precision Picosecond Laser System",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-precision-picosecond-laser-for-freckles-and-tattoo-removal-hrcmj205-885912.webp?v=1779725391",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "precision",
        "picosecond",
        "laser",
        "system",
        "cavitation",
        "machines"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 25,
        "manufacturing": 30,
        "safety": 20,
        "transparency": 25,
        "sustainability": 25
      },
      "price": 1102.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277236457669",
      "vsf_explanation": "Picosecond laser platform for pigment / tattoo work — professional device, not a supplement. Rejected as category mismatch.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "shape-tactics-advanced-7d-hifu-skin-care-system",
      "title": "Shape Tactics Advanced 7D HIFU Skin Care System",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-advanced-7d-hifu-skin-rejuvenation-machine-hfcm2110-736777.jpg?v=1779725392",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "advanced",
        "hifu",
        "skin",
        "care",
        "system",
        "cavitation",
        "machines"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 10,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 20,
        "sustainability": 25
      },
      "price": 1818.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277236490437",
      "vsf_explanation": "HIFU ultrasound device, not an ingestible supplement. Miscategorized in this batch.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "shape-tactics-morpheus-3-in-1-gold-rf-cold-therapy-system",
      "title": "Shape Tactics Morpheus 3-in-1 Gold RF & Cold Therapy System",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-morpheus-3-in-1-gold-rf-skin-lift-cold-hammer-system-mfcm21vpro-689874.webp?v=1779725392",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "morpheus",
        "gold",
        "cold",
        "therapy",
        "system",
        "cavitation",
        "machines"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 10,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 20,
        "sustainability": 25
      },
      "price": 1661.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277236523205",
      "vsf_explanation": "RF microneedling + cold-therapy device, not an ingestible supplement. Miscategorized in this batch.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "shape-tactics-photon-led-hydrogen-spa-mask",
      "title": "Shape Tactics Photon LED Hydrogen Spa Mask",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-photon-led-hydrogen-spa-mask-dtnvcm707p-885904.jpg?v=1779725396",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "photon",
        "led",
        "hydrogen",
        "spa",
        "mask",
        "cavitation",
        "machines"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 28,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 28,
        "sustainability": 30
      },
      "price": 638.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277243338949",
      "vsf_explanation": "Facial hydrodermabrasion and LED photon skincare console with 'hydrogen-enriched water' claims — a cosmetic spa device rather than a biohacking product. LED photon function is real but embedded in a cosmetic-only workflow (extraction, exfoliation, mist hydration). Out of scope for Vyvata.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "shape-tactics-dual-handle-cryotherapy-body-contouring-system",
      "title": "Shape Tactics Dual Handle Cryotherapy Body Contouring System",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-dual-handle-cryo-fat-freeze-system-mscm7201f-648575.jpg?v=1779725396",
      "score": 27,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "dual",
        "handle",
        "cryotherapy",
        "body",
        "contouring",
        "system",
        "cavitation",
        "machines"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 25,
        "manufacturing": 30,
        "safety": 30,
        "transparency": 25,
        "sustainability": 25
      },
      "price": 2948.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277243371717",
      "vsf_explanation": "Cryolipolysis body-contouring device (fat freezing) — professional device, not a supplement. Home-use fat-freezing has documented paradoxical adipose hyperplasia risk (Kelly 2018). Rejected as category mismatch.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "shape-tactics-contourpro-5-in-1-80k-ultrasonic-rf-system",
      "title": "Shape Tactics ContourPro 5-in-1 80K Ultrasonic RF System",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-contourpro-5-in-1-80k-cavitation-rf-system-bscm56v4s-486240.jpg?v=1779725396",
      "score": 26,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "contourpro",
        "80k",
        "ultrasonic",
        "system",
        "cavitation",
        "machines"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 25,
        "manufacturing": 30,
        "safety": 35,
        "transparency": 25,
        "sustainability": 25
      },
      "price": 520.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277243404485",
      "vsf_explanation": "80K ultrasonic cavitation + RF body-contouring device — not a supplement. Cavitation evidence is thin and mostly manufacturer-funded. Rejected as category mismatch.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "shape-tactics-luminessence-7-color-led-therapy-face-mask",
      "title": "Shape Tactics LuminEssence 7-Color LED Therapy Face Mask",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-luminessence-7-color-led-therapy-face-mask-ltcm110x-822618.jpg?v=1779725397",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "luminessence",
        "color",
        "led",
        "therapy",
        "face",
        "mask",
        "cavitation",
        "machines"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 4,
        "manufacturing": 0,
        "safety": 6,
        "transparency": 1,
        "sustainability": 4
      },
      "price": 149.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277243437253",
      "vsf_explanation": "Generic 7-color LED mask with no identifiable manufacturer and no FDA clearance. Only 630nm has Grade A evidence; purported 1040nm/1580nm 'wavelengths' are scientifically dubious (not actual visible/NIR therapeutic wavelengths). No irradiance specs, no UL/ETL/FCC certification, no warranty, no contraindications — auto-fail for powered device without electrical certification.",
      "vsf_autofail_rule": "Powered Device Without Electrical Certification"
    },
    {
      "handle": "shape-tactics-dualflex-220w-advanced-cryolipolysis-system",
      "title": "Shape Tactics DualFlex 220W Advanced Cryolipolysis System",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-dualflex-220w-advanced-cryolipolysis-system-wlcm7008cg-560160.jpg?v=1779725396",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "dualflex",
        "220w",
        "advanced",
        "cryolipolysis",
        "system",
        "cavitation",
        "machines"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 10,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 20,
        "sustainability": 25
      },
      "price": 1487.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277243470021",
      "vsf_explanation": "Cryolipolysis (fat-freezing) body-contouring device, not an ingestible supplement. Miscategorized in this batch.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "aristorm-s-shape-4-in-1-ultrasonic-cavitation-rf-led-lipo-laser-system",
      "title": "Aristorm S-Shape 4-in-1 Ultrasonic Cavitation & RF LED Lipo Laser System",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/aristorm-s-shape-4-in-1-led-lipo-laser-body-contouring-bscm36kt-164307.jpg?v=1779725460",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "aristorm",
        "shape",
        "ultrasonic",
        "cavitation",
        "led",
        "lipo",
        "laser",
        "system",
        "cavitation",
        "machines"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "ems_tens"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 30,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 30,
        "sustainability": 30
      },
      "price": 3218.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277243732165",
      "vsf_explanation": "Professional-grade Aristorm 4-in-1 cavitation, RF, vacuum, and 650 nm lipo-laser pad system for skin firming and body contouring. This is salon aesthetics equipment marketed for professional or home 'contouring,' not a biohacking or recovery device with clinical utility outside cosmetic use.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "shape-tactics-7-in-1-unoisetion-cavitation-3d-smart-rf-contouring-system",
      "title": "Shape Tactics 7-in-1 Unoisetion Cavitation & 3D Smart RF Contouring System",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-7-in-1-multi-functional-unoisetion-cavitation-bio-3d-smart-rf-mscmzig4-841923.jpg?v=1779725461",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "unoisetion",
        "cavitation",
        "smart",
        "contouring",
        "system",
        "cavitation",
        "machines"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "ems_tens"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 30,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 30,
        "sustainability": 30
      },
      "price": 3388.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277243699397",
      "vsf_explanation": "7-in-1 salon system with 40 kHz cavitation, bio microcurrent, 3D Smart RF, and vacuum therapy, targeting facial and body cosmetic use. Aesthetics equipment outside the Vyvata biohacking scope regardless of build quality or price.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "shape-tactics-2d-dual-handle-40k-cavitation-rf-led-photon-system",
      "title": "Shape Tactics 2D Dual-Handle 40K Cavitation & RF LED Photon System",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-2d-dual-handle-40k-cavitation-rf-led-photon-machine-mscm7206f-803942.jpg?v=1779725460",
      "score": 22,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "dual",
        "handle",
        "40k",
        "cavitation",
        "led",
        "photon",
        "system",
        "cavitation",
        "machines"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 4,
        "formulation": 4,
        "manufacturing": 2,
        "safety": 4,
        "transparency": 2,
        "sustainability": 6
      },
      "price": 4558.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277243764933",
      "vsf_explanation": "Rejected at 22/100. Same pattern as the lymphatic SKU — 40K cavitation + RF + LED photon is body-contouring aesthetic technology, not recovery photobiomodulation, and cosmetic cavitation RCT evidence for actual fat-loss/recovery outcomes is weak. No FDA 510(k), no UL/ETL on the powered console documented, no published wavelength/irradiance specs for the 'LED photon' element, no independent parameter verification, no clinical research from the manufacturer. Listing is mis-categorized.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "shape-tactics-portable-high-frequency-facial-scalp-therapy-system",
      "title": "Shape Tactics Portable High-Frequency Facial & Scalp Therapy System",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-portable-high-frequency-facial-wind-skin-therapy-device-srcm001-659458.jpg?v=1779725466",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "portable",
        "high",
        "frequency",
        "facial",
        "scalp",
        "therapy",
        "system",
        "cavitation",
        "machines"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 10,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 20,
        "sustainability": 25
      },
      "price": 90.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277243797701",
      "vsf_explanation": "High-frequency (Tesla-style) facial/scalp electrode device, not an ingestible supplement. Miscategorized in this batch.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "shape-tactics-s-shape-body-contouring-system-with-rf-ems-vacuum-lipo-laser",
      "title": "Shape Tactics S-Shape Body Contouring System with RF, EMS, Vacuum & Lipo Laser",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-s-shape-body-contouring-ultrasound-rf-ems-vacuum-lipo-laser-mscm4552sb-856356.jpg?v=1779725466",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "shape",
        "body",
        "contouring",
        "system",
        "with",
        "ems",
        "vacuum",
        "lipo",
        "laser",
        "cavitation",
        "machines"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "ems_tens"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 30,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 30,
        "sustainability": 30
      },
      "price": 1580.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277243863237",
      "vsf_explanation": "Salon-grade cosmetic body-contouring station combining ultrasonic cavitation, radiofrequency, EMS, vacuum, and lipo-laser modules. Non-invasive 'fat cavitation' is a cosmetic aesthetics tool, not a biohacking or health-optimization device, and independent clinical evidence for durable fat loss is weak. Out of scope for Vyvata regardless of build quality.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "shape-tactics-40k-cavitation-rf-cooling-contouring-system",
      "title": "Shape Tactics 40K Cavitation & RF Cooling Contouring System",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-cavitation-40khz-rf-fat-freezing-machine-mscm7003f-481948.jpg?v=1779725466",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "40k",
        "cavitation",
        "cooling",
        "contouring",
        "system",
        "cavitation",
        "machines"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "cold_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 30,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 30,
        "sustainability": 30
      },
      "price": 2565.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277243830469",
      "vsf_explanation": "Salon cavitation + RF + cooling contouring platform aimed at cosmetic body sculpting. The 'cryolipolysis-adjacent' cooling handle is not the same as clinical CoolSculpting, and no FDA clearance is claimed for fat reduction here. Aesthetic salon equipment falls outside the Vyvata biohacking rubric.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "shape-tactics-5-in-1-30k-cavitation-rf-system-with-160mw-lipo-laser",
      "title": "Shape Tactics 5-in-1 30K Cavitation RF System with 160mW Lipo Laser",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-5-in-1-30k-cavitation-s-shape-machine-with-160mw-lipo-laser-sdcm45s6sb-858150.jpg?v=1779725466",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "30k",
        "cavitation",
        "system",
        "with",
        "160mw",
        "lipo",
        "laser",
        "cavitation",
        "machines"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "ems_tens"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 30,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 30,
        "sustainability": 30
      },
      "price": 1658.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277243961541",
      "vsf_explanation": "5-in-1 salon device combining 30K cavitation, multi-polar RF, vacuum, EMS, electroporation, and lipo-laser pads for cosmetic contouring and skin work. This is professional-aesthetic equipment marketed for spa/salon use, not a biohacking device. Out of scope for Vyvata's health-optimization rubric.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "shape-tactics-6-in-1-hydrodermabrasion-skin-rejuvenation-system",
      "title": "Shape Tactics 6-in-1 Hydrodermabrasion Skin Rejuvenation System",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-6-in-1-hydrodermabrasion-skin-rejuvenation-machine-srcmaf1323-402659.jpg?v=1779725466",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "hydrodermabrasion",
        "skin",
        "rejuvenation",
        "system",
        "cavitation",
        "machines"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 10,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 20,
        "sustainability": 25
      },
      "price": 292.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277243896005",
      "vsf_explanation": "Hydrodermabrasion facial device, not an ingestible supplement. Miscategorized in this batch.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "shape-tactics-9-in-1-unoisetion-cavitation-rf-vacuum-bio-photon-system",
      "title": "Shape Tactics 9-in-1 Unoisetion Cavitation RF Vacuum Bio Photon System",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-9-in-1-uniosetion-cavitation-rf-vacuum-bio-photon-lipo-machine-mscm76f1sbmax-412496.jpg?v=1779725466",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "unoisetion",
        "cavitation",
        "vacuum",
        "bio",
        "photon",
        "system",
        "cavitation",
        "machines"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "ems_tens"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 30,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 30,
        "sustainability": 30
      },
      "price": 2084.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46277243928773",
      "vsf_explanation": "9-in-1 salon aesthetic system with cavitation, RF, vacuum, microcurrent, and LED photon therapy on a 10.4-inch touchscreen console. Positioned for professional spa contouring and skin work, not health-tech. Auto-failed as out-of-scope aesthetic equipment.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "mini-cpap-anti-snoring-sleep-apnea-nasal-device-case",
      "title": "Mini CPAP Anti-Snoring Sleep Apnea Nasal Device & Case",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/mini-cpap-anti-snoring-sleep-apnea-nasal-device-case-wellness-fitness-dailysale-524721.jpg?v=1779825089",
      "score": 15,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mini",
        "cpap",
        "anti",
        "snoring",
        "sleep",
        "apnea",
        "nasal",
        "device",
        "case",
        "dailysale"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_apnea_cpap"
      ],
      "vsf_dimensions": {
        "evidence": 5,
        "formulation": 20,
        "manufacturing": 25,
        "safety": 15,
        "transparency": 15,
        "sustainability": 30
      },
      "price": 19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46282073997509",
      "vsf_explanation": "This is a passive plastic nasal dilator marketed as a 'Mini CPAP', but CPAP is by definition a continuous positive airway pressure machine — this device generates no airflow and no pressure. The FDA has not cleared any micro-CPAP device, and the published clinical and clinical-trade consensus (cpap.com, Healthline, AeroflowSleep) is that this technology category does not work as advertised and is dangerous if used in place of real CPAP by anyone with diagnosed OSA. The 'CPAP' label on a non-CPAP product is the textbook misleading_naming case.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "contour-products-cpap-pillow-2-0",
      "title": "Contour Products CPAP Pillow 2.0",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/146991284.jpg?v=1779825096",
      "score": 56,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "contour",
        "products",
        "cpap",
        "pillow",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_apnea_cpap"
      ],
      "vsf_dimensions": {
        "evidence": 6,
        "formulation": 13,
        "manufacturing": 12,
        "safety": 7,
        "transparency": 8,
        "sustainability": 4
      },
      "price": 64.85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46282074095813",
      "vsf_explanation": "This is a CPAP-compatible pillow, NOT a CPAP machine, so the CPAP/510(k) auto-fail does not apply (it is an accessory, non-powered). The foam carries CertiPUR-US certification (verified at contourliving.com). However, evidence is limited to brand claims about CPAP-mask comfort — no peer-reviewed RCT shows the pillow itself improves apnea, sleep quality, or CPAP adherence. Score falls below 60 because the evidence dimension is thin and there is no fire-safety compliance statement or formal sleep trial.",
      "vsf_autofail_rule": "uncleared_cpap_device"
    },
    {
      "handle": "anti-snore-headband-comfort-cpap-headgear-replacement",
      "title": "Anti Snore Headband | Comfort CPAP Headgear Replacement",
      "vendor": "Game On Interactive LLC (OnlyTenBucks.com)",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/S112462dfc47a4e99b6fb622c6210bd3ae.webp?v=1779825105",
      "score": 8,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "anti",
        "snore",
        "headband",
        "comfort",
        "cpap",
        "headgear",
        "replacement",
        "game",
        "interactive",
        "llc",
        "onlytenbucks",
        "com"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_apnea_cpap"
      ],
      "vsf_dimensions": {
        "evidence": 2,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 0,
        "transparency": 2,
        "sustainability": 4
      },
      "price": 10,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46282074161349",
      "vsf_explanation": "Generic dropship chin strap sold as a sub-$10 accessory. Chin straps have only self-reported / observational evidence for snoring reduction and SleepFoundation/clinical reviews note efficacy is limited (partial 2/25). No manufacturer documentation, no materials disclosure, no contraindication disclosure (cardiac/respiratory exclusions for chin straps are clinically important), no warranty. The listing being explicitly priced/categorized at $10 with a return option gives partial transparency credit (2/12). Sustainability neutral 4/8. Below 60.",
      "vsf_autofail_rule": "uncleared_cpap_device"
    },
    {
      "handle": "anti-snoring-chin-strap-cpap-mouth-tape-alternative-for-quiet-sleep",
      "title": "Anti-Snoring Chin Strap | CPAP Mouth Tape Alternative for Quiet Sleep",
      "vendor": "Game On Interactive LLC (OnlyTenBucks.com)",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Sa88d69673ba148be97ff813a525d15bam.webp?v=1779825114",
      "score": 12,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "anti",
        "snoring",
        "chin",
        "strap",
        "cpap",
        "mouth",
        "tape",
        "alternative",
        "for",
        "quiet",
        "sleep",
        "game",
        "interactive",
        "llc",
        "onlytenbucks",
        "com"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_apnea_cpap"
      ],
      "vsf_dimensions": {
        "evidence": 2,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 1,
        "transparency": 1,
        "sustainability": 4
      },
      "price": 10,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46282074226885",
      "vsf_explanation": "Chin straps as a standalone CPAP alternative are explicitly NOT supported by peer-reviewed evidence — published research (Bhat et al. 2014) shows a chinstrap alone does not reduce AHI, snoring, or treat OSA. Marketing this as a 'CPAP alternative' is misleading and clinically unsafe (delays diagnosis of OSA). Generic dropship product with no manufacturer, no certifications, no contraindication disclosure for OSA patients.",
      "vsf_autofail_rule": "uncleared_cpap_device"
    },
    {
      "handle": "smart-snore-stopper-biosensor-anti-snore-sleeping-aid-with-app-and-sleep-monitor-sleep-aid-device-cpap-replacer-stop-snoring",
      "title": "Smart Snore Stopper Biosensor anti snore Sleeping Aid with APP and sleep monitor sleep aid device CPAP replacer Stop Snoring",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0861717BDE431D53CDBB9F8577A61364.jpg?v=1779825130",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "smart",
        "snore",
        "stopper",
        "biosensor",
        "anti",
        "snore",
        "sleeping",
        "aid",
        "with",
        "app",
        "and",
        "sleep",
        "monitor",
        "sleep",
        "aid",
        "device",
        "cpap",
        "replacer",
        "stop",
        "snoring",
        "digital",
        "presence"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_apnea_cpap"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 30,
        "manufacturing": 25,
        "safety": 15,
        "transparency": 20,
        "sustainability": 35
      },
      "price": 26.36,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46282074357957",
      "vsf_explanation": "A wrist or chin-worn vibration biosensor that promises to 'replace CPAP' for sleep apnea. Sleep apnea is a diagnosed medical condition and CPAP remains the clinical gold standard; small biosensor devices have limited and mixed evidence for snoring reduction and no peer-reviewed evidence supporting them as CPAP replacements for any AHI severity. Marketing the device as a 'CPAP replacer' to users who may have undiagnosed or diagnosed OSA is both a regulated-terminology misuse and a meaningful safety risk.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "silicone-anti-snoring-nose-clip-nasal-dilator-for-better-sleep",
      "title": "Silicone Anti Snoring Nose Clip | Nasal Dilator for Better Sleep",
      "vendor": "Game On Interactive LLC (OnlyTenBucks.com)",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Sf38d5eea9c904c959ee71dc0646dea0fP.webp?v=1779825142",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "silicone",
        "anti",
        "snoring",
        "nose",
        "clip",
        "nasal",
        "dilator",
        "for",
        "better",
        "sleep",
        "game",
        "interactive",
        "llc",
        "onlytenbucks",
        "com"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_apnea_cpap"
      ],
      "vsf_dimensions": {
        "evidence": 6,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 1,
        "transparency": 1,
        "sustainability": 4
      },
      "price": 10,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46282074783941",
      "vsf_explanation": "Internal nasal dilators have some published evidence for reducing snoring (Petruson, Camacho meta-analysis), but a 2017 JCSM study showed external dilators acted largely as a placebo for OSA. This specific generic silicone clip has no manufacturer identity, no medical-grade material certification, no OSA contraindication disclosure. Modality has weak Grade B/C evidence; product carries no transparency or build-quality support.",
      "vsf_autofail_rule": "uncleared_cpap_device"
    },
    {
      "handle": "30-piece-mouth-tape-for-snoring-relief-anti-snore-sleep-aid-strips",
      "title": "30-Piece Mouth Tape for Snoring Relief | Anti-Snore Sleep Aid Strips",
      "vendor": "Game On Interactive LLC (OnlyTenBucks.com)",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/S55fb3125357649148b973a62744b8626h.webp?v=1779825155",
      "score": 8,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "piece",
        "mouth",
        "tape",
        "for",
        "snoring",
        "relief",
        "anti",
        "snore",
        "sleep",
        "aid",
        "strips",
        "game",
        "interactive",
        "llc",
        "onlytenbucks",
        "com"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_apnea_cpap"
      ],
      "vsf_dimensions": {
        "evidence": 2,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 0,
        "transparency": 2,
        "sustainability": 4
      },
      "price": 10,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46282074947781",
      "vsf_explanation": "Generic unbranded mouth tape sold by a sub-$10 discount reseller. Mouth tape is FDA-classed as a wellness product so it does not require clearance, avoiding auto-fail, but evidence for snoring/sleep apnea benefit is weak - SleepFoundation and SleepApnea.org consistently warn against using mouth tape if a user has untreated OSA (a critical contraindication this listing does not disclose). No manufacturer, no adhesive/material safety data, no skin-irritation testing disclosed. Partial transparency credit for clear $10 pricing and return path. Sustainability neutral 4/8. Below 60.",
      "vsf_autofail_rule": "uncleared_cpap_device"
    },
    {
      "handle": "30pcs-anti-snoring-mouth-patches-sleep-patches-for-better-breathing-and-restful-sleep",
      "title": "30pcs Anti-Snoring Mouth Patches | Sleep Patches for Better Breathing and Restful Sleep",
      "vendor": "Game On Interactive LLC (OnlyTenBucks.com)",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Se8c6ef1a94c44729ba497d32e4b16bf1k.webp?v=1779825162",
      "score": 8,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "30pcs",
        "anti",
        "snoring",
        "mouth",
        "patches",
        "sleep",
        "patches",
        "for",
        "better",
        "breathing",
        "and",
        "restful",
        "sleep",
        "game",
        "interactive",
        "llc",
        "onlytenbucks",
        "com"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_apnea_cpap"
      ],
      "vsf_dimensions": {
        "evidence": 2,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 0,
        "transparency": 1,
        "sustainability": 4
      },
      "price": 10,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46282075111621",
      "vsf_explanation": "Mouth taping is explicitly warned against by the American Academy of Sleep Medicine, Cleveland Clinic, and sleep apnea organizations for snoring/OSA patients — it can worsen apnea by restricting airflow and mask diagnostic symptoms. Aspiration risk. Generic dropship with no manufacturer, no skin-adhesive safety data, no contraindications disclosed, no FDA wellness-device clarification. Modality is not evidence-supported for the marketed claim.",
      "vsf_autofail_rule": "uncleared_cpap_device"
    },
    {
      "handle": "atomized-anti-snoring-mask",
      "title": "Atomized Anti-Snoring Mask",
      "vendor": "Anti Spier",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1VkGU0bDuyZFJ8O.webp?v=1779825196",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "atomized",
        "anti",
        "snoring",
        "mask",
        "anti",
        "spier"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_apnea_cpap"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 35,
        "manufacturing": 25,
        "safety": 30,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 40.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46282075472069",
      "vsf_explanation": "A nebulizer-style face mask that aerosolizes a saline or herbal solution, marketed for snoring and sleep apnea by 'Anti Spier' — an unknown vendor with no manufacturer disclosure, no model number, and no FDA clearance for OSA treatment. Nasal spray and atomized humidification have very narrow legitimate use cases (temporary congestion-related snoring) and are not a therapy for obstructive sleep apnea; routing the product into the sleep_apnea_cpap subcategory is misleading. Fails on both unverifiable provenance and the OSA-treatment claim.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "therabody-wedge-handheld-massager-attachment-theragun-pro-elite-prime-mini-gen4-pkg-wedge",
      "title": "Therabody Wedge Handheld Massager Attachment, Theragun Pro, Elite, Prime & Mini GEN4-PKG-WEDGE",
      "vendor": "Medsitis",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/926649cd1b40e7b62afd13443304bd4d7a683158.jpg?v=1779825351",
      "score": 76,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "therabody",
        "wedge",
        "handheld",
        "massager",
        "attachment",
        "theragun",
        "pro",
        "elite",
        "prime",
        "mini",
        "gen4",
        "pkg",
        "wedge",
        "medsitis"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "percussion_vibration"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 14,
        "manufacturing": 13,
        "safety": 13,
        "transparency": 8,
        "sustainability": 4
      },
      "price": 40.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46282077569221",
      "vsf_explanation": "Accessory attachment for Theragun (a Therabody device line that is FDA-registered as a medical device). The attachment itself is non-powered, so electrical-cert auto-fail does not apply; it inherits Therabody's documented build quality, claims substantiation and contraindication disclosures. Modality (percussion massage) has strong Grade A RCT support, brand publishes specs and claim citations, but the Wedge carries only a 30-day attachment warranty (below 3-year threshold).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "theragun-relief-hand-held-massager-tg0003968-1a40",
      "title": "Theragun Relief Hand-Held Massager TG0003968-1A40",
      "vendor": "Medsitis",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4de880c3e13a112aaf1a1980e88a7e8a9a601efe.jpg?v=1779825356",
      "score": 76,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "theragun",
        "relief",
        "hand",
        "held",
        "massager",
        "tg0003968",
        "1a40",
        "medsitis"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "percussion_vibration"
      ],
      "vsf_dimensions": {
        "evidence": 17,
        "formulation": 14,
        "manufacturing": 14,
        "safety": 11,
        "transparency": 6,
        "sustainability": 4
      },
      "price": 237.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46282077667525",
      "vsf_explanation": "Percussive massage therapy at Theragun's 10mm/2400 ppm amplitude has Grade B RCT evidence for DOMS and ROM (multiple independent studies); Theragun is FDA-registered as a Class I medical device with published 510(k) filings (e.g. K230293). Brand publishes specs (amplitude, speeds, battery life), maintains a documented warranty programme, and discloses contraindications. Gaps: 1-year warranty is shorter than the 3-year threshold for full manufacturing credit, sustainability/repairability disclosure is limited, and clinical citations on consumer pages are summarised rather than directly linked. Solid Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hand-held-massager-theragun-mini-plus-tg0004352-1a10",
      "title": "Hand-Held Massager Theragun Mini Plus TG0004352-1A10",
      "vendor": "Medsitis",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3c422ce83f1f6f6189b4efa515daca1273736c26.jpg?v=1779825367",
      "score": 78,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hand",
        "held",
        "massager",
        "theragun",
        "mini",
        "plus",
        "tg0004352",
        "1a10",
        "medsitis"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "percussion_vibration"
      ],
      "vsf_dimensions": {
        "evidence": 18,
        "formulation": 15,
        "manufacturing": 14,
        "safety": 11,
        "transparency": 8,
        "sustainability": 4
      },
      "price": 396.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46282077896901",
      "vsf_explanation": "Therabody Theragun Mini Plus is FDA-registered Class II, HSA/FSA eligible, FCC-compliant (Bluetooth/USB-C electronics), TSA-approved with documented travel lock safety feature, and supported by published percussion-massage RCT evidence (Grade B for DOMS recovery). Brand publishes precautions/contraindications page, supports app-based usage protocols, and has industry-leading independent reviews. Only 1-year warranty and limited sustainability disclosure prevent higher score.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hand-held-massager-theragun-prime-g6-tg0004350-1a10",
      "title": "Hand-Held Massager Theragun Prime G6 TG0004350-1A10",
      "vendor": "Medsitis",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f5f8f02aac7047c7b69ce226cd49e83f20f7914c.jpg?v=1779825376",
      "score": 76,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hand",
        "held",
        "massager",
        "theragun",
        "prime",
        "tg0004350",
        "1a10",
        "medsitis"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "percussion_vibration"
      ],
      "vsf_dimensions": {
        "evidence": 21,
        "formulation": 16,
        "manufacturing": 14,
        "safety": 11,
        "transparency": 9,
        "sustainability": 5
      },
      "price": 467.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46282078027973",
      "vsf_explanation": "Verified at 76/100. Strongest dimensions: Evidence (84% — percussive massage therapy is one of the most-studied recovery modalities on PubMed, Therabody itself cites 16 studies including Biostrap Labs sleep RCT, plus independent meta-analyses on percussion massage and DOMS) and Formulation (80% — Theragun Prime G6 publishes 16mm amplitude, 1,750-2,400 PPM, 30 lb stall force, 120-min battery, 5 speeds). Therabody devices are FDA-registered as general wellness devices and the brand publishes industry-leading limited warranty terms. Held back by Sustainability (Trustpilot reviewer complaints that batteries are not replaceable, no documented repair program — sealed device with end-of-life as landfill) and the standard manufacturer-funded share of the research base.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hatch-restore-smart-clock-small-night-light-atmosphere-light-baby-audio-monitor-sleep-instrument-white-noise",
      "title": "Hatch Restore Smart Clock Small Night Light Atmosphere Light Baby Audio Monitor Sleep Instrument White Noise",
      "vendor": "FLIPSTYLEZLLC",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/49c9383b-8545-4c14-ae9d-d5ae808418d3.jpg?v=1779825390",
      "score": 58,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hatch",
        "restore",
        "smart",
        "clock",
        "small",
        "night",
        "light",
        "atmosphere",
        "light",
        "baby",
        "audio",
        "monitor",
        "sleep",
        "instrument",
        "white",
        "noise",
        "flipstylezllc"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "white_noise_sound"
      ],
      "vsf_dimensions": {
        "evidence": 8,
        "formulation": 11,
        "manufacturing": 14,
        "safety": 8,
        "transparency": 6,
        "sustainability": 4
      },
      "price": 502.2,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46282078159045",
      "vsf_explanation": "Hatch Restore is FCC Part 15 compliant with a documented power adapter and 1-year warranty; broadband sound for sleep onset has moderate published evidence. However, no peer-reviewed RCT validates the Restore device specifically, and Hatch's privacy policy explicitly discloses sharing identifiers/usage data with advertising partners (constitutes 'sale' under US state privacy laws) which sharply reduces Safety/Transparency credit. UL listing is not prominently disclosed for the device itself (replacement adapters are ETL/UL listed but manufacturer UL/ETL marking on the Restore unit is not confirmed in the registry). 1st-Gen Hatch Rest power-adapter recall (July 2024) applies to a different product line (baby Rest, model CYAP05), so no auto-fail. Score falls just under Standard tier due to limited device-specific evidence and privacy gap.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "withings-sleep-tracking-mat-wsm02-all-us",
      "title": "Withings Sleep Tracking Mat WSM02-ALL-US",
      "vendor": "Medsitis",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6f992d8eb73911df4382cfe76b4b8dd93b15afd7.jpg?v=1779827506",
      "score": 86,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "withings",
        "sleep",
        "tracking",
        "mat",
        "wsm02",
        "all",
        "medsitis"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "noncontact_sleep_monitors"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 17,
        "manufacturing": 15,
        "safety": 13,
        "transparency": 11,
        "sustainability": 8
      },
      "price": 363.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46282144252101",
      "vsf_explanation": "Withings is the gold standard for noncontact sleep monitors. The closely related Sleep Rx mat received FDA 510(k) clearance in Sept 2024 for OSA screening (88% sensitivity / 88.6% specificity vs PSG at AHI>=15); the consumer Sleep mat shares the same ballistocardiography platform and has multiple peer-reviewed validation studies indexed in PubMed. Documented privacy policy with explicit no-sale of biometric data, GDPR-compliant deletion, transparent algorithm publications, CE-marked, and Withings publishes a sustainability/repairability report. Small deductions because (a) the consumer Sleep (WSM02) itself is wellness-cleared rather than 510(k)-cleared for diagnosis - the Sleep Rx is the cleared variant - and (b) accuracy specs published but not all metrics independently replicated outside Withings collaborations.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "withings-sleep-tracking-mat-bluetooth-wi-fi",
      "title": "Withings Sleep Tracking Mat – Bluetooth & Wi-Fi",
      "vendor": "The Digital Health Store",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/sleep-single.webp?v=1779827510",
      "score": 78,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "withings",
        "sleep",
        "tracking",
        "mat",
        "bluetooth",
        "the",
        "digital",
        "health",
        "store"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "noncontact_sleep_monitors"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 17,
        "manufacturing": 12,
        "safety": 11,
        "transparency": 10,
        "sustainability": 6
      },
      "price": 199.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46282144284869",
      "vsf_explanation": "Withings Sleep Analyzer (the consumer mat) has a published peer-reviewed validation study against polysomnography (Edouard et al., JCSM 2021, n=118, AUC 0.926 at AHI≥15). The prescription Sleep Rx mat received FDA 510(k) clearance in Sept 2024 — the consumer mat itself uses the same hardware/algorithm. Withings publishes data export (CSV/PDF), a clear privacy policy, and methodology documentation. Manufacturing certification is solid (CE-marked, Bluetooth/Wi-Fi FCC IDs published). Sustainability and warranty disclosures are thinner than ideal. Honest Verified-tier score; this is the rare sleep-tracking mat with real clinical validation in the category.",
      "vsf_autofail_rule": "confirmed_sale_of_biometric_data"
    },
    {
      "handle": "withings-smart-blood-pressure-monitor-wpm05-all-inter",
      "title": "Withings Smart Blood Pressure Monitor WPM05-ALL-INTER",
      "vendor": "Medsitis",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/300ea3ebe915009f6b935e7107b8e386001a61a9.jpg?v=1779827518",
      "score": 81,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "withings",
        "smart",
        "blood",
        "pressure",
        "monitor",
        "wpm05",
        "all",
        "inter",
        "medsitis"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "blood_pressure"
      ],
      "vsf_dimensions": {
        "evidence": 19,
        "formulation": 16,
        "manufacturing": 17,
        "safety": 13,
        "transparency": 10,
        "sustainability": 6
      },
      "price": 272.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46282144350405",
      "vsf_explanation": "Withings BPM Connect (WPM05) is FDA-cleared, CE-marked, validated to ISO 81060-2:2018+A1:2020, listed on both US VDL and STRIDE BP databases via independent clinical accuracy review. Withings privacy policy explicitly states data is never sold without consent and applies GDPR globally. Some sustainability program gaps (no formal take-back) but strong overall.",
      "vsf_autofail_rule": "uncleared_bp_device"
    },
    {
      "handle": "withings-body-wifi-smart-scale-white-wbs06-white-all-inter",
      "title": "Withings Body Wifi Smart Scale, White WBS06-WHITE-ALL-INTER",
      "vendor": "Medsitis",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1725e66ea77b3603d70f2470c6b781acaddc06c1.jpg?v=1779827527",
      "score": 72,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "withings",
        "body",
        "wifi",
        "smart",
        "scale",
        "white",
        "wbs06",
        "white",
        "all",
        "inter",
        "medsitis"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "fitness_activity_trackers"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 14,
        "manufacturing": 11,
        "safety": 12,
        "transparency": 9,
        "sustainability": 4
      },
      "price": 115.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46282144383173",
      "vsf_explanation": "Withings Body (WBS06) is the entry weight + BMI Wi-Fi scale (no BIA composition - that's the Body+/Body Smart). Withings is a well-documented French health-tech brand with strong privacy policy (explicitly no biometric data sale, GDPR-compliant), HSA/FSA eligibility, and FDA registration as a general-wellness device. Published validation exists for Withings scale weight accuracy but limited independent PubMed studies on this specific base model; no AFib/ECG claims so the 510(k) auto-fail does not apply. Verified-adjacent Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "wave-roller™-vibration-therapy-exercise-roll-waveroller-pkg-us",
      "title": "Wave Roller™ Vibration Therapy Exercise Roll WAVEROLLER-PKG-US",
      "vendor": "Medsitis",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1e05921dcc94a19296d1ca00390704d182585f01.jpg?v=1779827609",
      "score": 78,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wave",
        "roller",
        "vibration",
        "therapy",
        "exercise",
        "roll",
        "waveroller",
        "pkg",
        "medsitis"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "percussion_vibration"
      ],
      "vsf_dimensions": {
        "evidence": 19,
        "formulation": 15,
        "manufacturing": 14,
        "safety": 12,
        "transparency": 9,
        "sustainability": 5
      },
      "price": 223.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46282144907461",
      "vsf_explanation": "Therabody WaveRoller is a documented Bluetooth-enabled vibrating roller with FCC ID 2AU6TWAVE-03, 5 intensity levels, published specs (12x5.1 in, 3.3 lbs, 180-min battery), 1-year warranty, and app integration. Vibration/foam rolling has Grade B-A RCT support for DOMS and ROM. Manufacturing credit limited by absence of UL listing for the powered roller and only a 1-year warranty; transparency is strong (claims, materials, app).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "withings-scanwatch-2-smart-watch-38mm-black-hwa10-model-1-all-int",
      "title": "Withings ScanWatch 2 Smart Watch, 38mm, Black HWA10-MODEL 1-ALL-INT",
      "vendor": "Medsitis",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/18caaa065fa8e148355e02da131faf55bbe9d447.jpg?v=1779827628",
      "score": 85,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "withings",
        "scanwatch",
        "smart",
        "watch",
        "38mm",
        "black",
        "hwa10",
        "model",
        "all",
        "int",
        "medsitis"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smartwatches",
        "sleep_tracking_wearables"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 17,
        "manufacturing": 17,
        "safety": 13,
        "transparency": 10,
        "sustainability": 6
      },
      "price": 651.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46282144940229",
      "vsf_explanation": "FDA 510(k) cleared for single-lead ECG/AFib detection with published clinical validation (96.3% sensitivity, 100% specificity, n=262). SpO2 clinically validated 70-100% range against laboratory CO-oximeter. Withings privacy policy explicitly forbids data sale; GDPR applied globally. 35-day battery, published accuracy specs. Sustainability program partial (paid glass repair in EU only, no global take-back).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "withings-scanwatch-light-smart-watch-37mm-black-hwa11-model-5-all-int",
      "title": "Withings ScanWatch Light Smart Watch, 37mm, Black HWA11-MODEL 5-ALL-INT",
      "vendor": "Medsitis",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/187f6bd7ba7bdc7e5263348b36f79cae7eb5b760.jpg?v=1779827633",
      "score": 71,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "withings",
        "scanwatch",
        "light",
        "smart",
        "watch",
        "37mm",
        "black",
        "hwa11",
        "model",
        "all",
        "int",
        "medsitis"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smartwatches",
        "sleep_tracking_wearables"
      ],
      "vsf_dimensions": {
        "evidence": 13,
        "formulation": 14,
        "manufacturing": 10,
        "safety": 12,
        "transparency": 9,
        "sustainability": 4
      },
      "price": 575.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46282144972997",
      "vsf_explanation": "ScanWatch Light (HWA11) is the wellness-only variant - it does NOT have ECG/AFib detection or SpO2 (those are on the full ScanWatch/ScanWatch 2 which are FDA 510(k) cleared). Because the Light makes no medical-diagnosis claims, the uncleared-diagnosis auto-fail does NOT apply. It uses Withings' published HR + sleep algorithms (some validation in literature on Withings PPG/sleep), 5ATM, Gorilla Glass, strong privacy policy. Independent reviews flag battery shortfall vs 30-day claim. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "withings-scanwatch-2-smart-watch-42mm-black-hwa10-model-4-all-int",
      "title": "Withings ScanWatch 2 Smart Watch, 42mm, Black HWA10-MODEL 4-ALL-INT",
      "vendor": "Medsitis",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/384ac7cd021153a1468ef65712fa6757107725ea.jpg?v=1779827637",
      "score": 85,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "withings",
        "scanwatch",
        "smart",
        "watch",
        "42mm",
        "black",
        "hwa10",
        "model",
        "all",
        "int",
        "medsitis"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smartwatches",
        "sleep_tracking_wearables"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 17,
        "manufacturing": 17,
        "safety": 13,
        "transparency": 10,
        "sustainability": 6
      },
      "price": 651.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46282145005765",
      "vsf_explanation": "Identical device to 38mm variant in a larger case size — same FDA 510(k) clearance for AFib ECG, same SpO2 clinical validation, same published accuracy specs, same Withings privacy commitments. 35-day battery confirmed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "body-weight-bmi-analyzer-withings-digital-display-5-180kg-9-396lb-black-wbs06-black-all-inter",
      "title": "Body Weight & BMI Analyzer Withings Digital Display 5 -> 180kg (9 -> 396lb) Black WBS06-BLACK-ALL-INTER",
      "vendor": "Medsitis",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b7be9644fc839a43a89674c1e528ecab0be580e2.jpg?v=1779827642",
      "score": 72,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "body",
        "weight",
        "bmi",
        "analyzer",
        "withings",
        "digital",
        "display",
        "180kg",
        "396lb",
        "black",
        "wbs06",
        "black",
        "all",
        "inter",
        "medsitis"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "fitness_activity_trackers"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 14,
        "manufacturing": 11,
        "safety": 12,
        "transparency": 9,
        "sustainability": 4
      },
      "price": 117.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46282145038533",
      "vsf_explanation": "Same SKU as the white WBS06 (Withings Body weight + BMI Wi-Fi scale, black colorway). Same scoring rationale: well-documented Withings brand, FDA-registered general wellness scale, strong privacy policy, no medical-diagnosis claim so no 510(k) auto-fail. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "garmin-forerunner-245-gps-watch",
      "title": "Garmin Forerunner 245 GPS Watch",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/garmin-forerunner-245-gps-watch-smart-watches-dailysale-843004.webp?v=1779827705",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "garmin",
        "forerunner",
        "245",
        "gps",
        "watch",
        "dailysale"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smartwatches",
        "sleep_tracking_wearables"
      ],
      "vsf_dimensions": {
        "evidence": 13,
        "formulation": 13,
        "manufacturing": 11,
        "safety": 11,
        "transparency": 9,
        "sustainability": 8
      },
      "price": 229,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46282145628357",
      "vsf_explanation": "Forerunner 245 has independent peer-reviewed validation literature (PMC7323940 systematic review of Garmin trackers) for HR/steps. No FDA 510(k) clearance (consumer wellness device, no medical claims). Garmin privacy policy explicitly states no data sold or shared without user direction; lowest data-collection profile among major trackers. Robust corporate sustainability and recycling programs.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "garmin-venu-sq-waterproof-fitness-smartwatch",
      "title": "Garmin Venu Sq | Waterproof Fitness Smartwatch",
      "vendor": "Atomic Defense",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Garmin-venu-sq-box.jpg?v=1779827721",
      "score": 74,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "garmin",
        "venu",
        "waterproof",
        "fitness",
        "smartwatch",
        "atomic",
        "defense"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smartwatches",
        "sleep_tracking_wearables"
      ],
      "vsf_dimensions": {
        "evidence": 16,
        "formulation": 15,
        "manufacturing": 10,
        "safety": 13,
        "transparency": 10,
        "sustainability": 4
      },
      "price": 199.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46282145923269",
      "vsf_explanation": "Garmin Venu Sq is a mature wellness fitness watch with Elevate Gen 3 PPG + Pulse Ox, GPS, sleep stages, and Body Battery. Garmin's PPG HR and sleep have multiple published independent validation studies. Pulse Ox is a wellness feature (no AFib diagnosis claim on Venu Sq), so 510(k) auto-fail does not apply. Garmin discloses privacy policy and does not sell biometric data. Documented multi-year firmware support. Just below Verified due to limited published sensor-accuracy whitepapers and modest data export (FIT files via Garmin Connect only). Standard tier near Verified boundary.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "garmin-forerunner-45s-gps-watch-refurbished",
      "title": "Garmin Forerunner 45S GPS Watch  (Refurbished)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/garmin-forerunner-45s-gps-watch-smart-watches-dailysale-724843.jpg?v=1779827727",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "garmin",
        "forerunner",
        "45s",
        "gps",
        "watch",
        "refurbished",
        "dailysale"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smartwatches",
        "sleep_tracking_wearables"
      ],
      "vsf_dimensions": {
        "evidence": 11,
        "formulation": 12,
        "manufacturing": 11,
        "safety": 11,
        "transparency": 9,
        "sustainability": 8
      },
      "price": 145,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46282146185413",
      "vsf_explanation": "Forerunner 45/45S is an older entry-level GPS running watch covered by Garmin systematic review validation literature (PMC7323940). Lower spec sheet than 245 with GEN3 Elevate HR sensor — reviewers note accuracy limitations during HIIT. Same Garmin privacy and sustainability infrastructure as Forerunner 245. Refurbished status doesn't impact scoring but verifies product is genuine Garmin.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "garmin-vivoactive-4-gps-smartwatch-refurbished",
      "title": "Garmin Vivoactive 4 GPS Smartwatch  (Refurbished)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/garmin-vivoactive-4-gps-smartwatch-smart-watches-dailysale-694609.jpg?v=1779827731",
      "score": 70,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "garmin",
        "vivoactive",
        "gps",
        "smartwatch",
        "refurbished",
        "dailysale"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smartwatches",
        "sleep_tracking_wearables"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 14,
        "manufacturing": 9,
        "safety": 12,
        "transparency": 10,
        "sustainability": 6
      },
      "price": 279,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46282146218181",
      "vsf_explanation": "Garmin Vivoactive 4 - GPS smartwatch with Pulse Ox, 24/7 HR, Body Battery, sleep, hydration, animated workouts. Same Garmin algorithm pedigree and validation evidence as Venu Sq. Refurbished/sold by a third-party reseller (not Garmin direct) modestly lowers warranty/firmware reliability. Sustainability gets a small bump because refurbishment extends device life (e-waste reduction). No medical-diagnosis claim, no auto-fail. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "garmin-tacx-s2500-05-booster-resistance-unit",
      "title": "Garmin Tacx S2500.05 Booster resistance unit",
      "vendor": "Gio's Outdoors",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/996c5120bdea315840f597fb0f0332aa2419b225.jpg?v=1779827745",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "garmin",
        "tacx",
        "s2500",
        "booster",
        "resistance",
        "unit",
        "gio",
        "outdoors"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 15,
        "manufacturing": 30,
        "safety": 45,
        "transparency": 15,
        "sustainability": 20
      },
      "price": 228.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46282146250949",
      "vsf_explanation": "Replacement resistance unit for a Garmin Tacx indoor bike trainer — a bike accessory, not a supplement. Rejected: category mismatch (does not belong in a supplement rubric).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fitbit-inspire-2-fitness-tracker",
      "title": "Fitbit - Inspire 2 Fitness Tracker",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fitbit-inspire-2-fitness-tracker-fitness-dailysale-286636.jpg?v=1779827783",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fitbit",
        "inspire",
        "fitness",
        "tracker",
        "dailysale"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "fitness_activity_trackers",
        "sleep_tracking_wearables"
      ],
      "vsf_dimensions": {
        "evidence": 16,
        "formulation": 12,
        "manufacturing": 11,
        "safety": 11,
        "transparency": 9,
        "sustainability": 9
      },
      "price": 89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46282146644165",
      "vsf_explanation": "Fitbit Inspire 2 has a 2023 peer-reviewed PSG validation study (PMC9985403, Nature & Science of Sleep) confirming sleep tracking accuracy vs polysomnography. No FDA clearance (general wellness device). Google's binding regulatory commitment that Fitbit health data won't be used for ads and won't be sold. Sustainability score reflects Google's broader sustainability commitments.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fitbit-sense-advanced-smartwatch-with-tools-for-heart-health",
      "title": "Fitbit Sense Advanced Smartwatch with Tools for Heart Health",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fitbit-sense-advanced-smartwatch-with-tools-for-heart-health-smart-watches-dailysale-364063.jpg?v=1779827787",
      "score": 80,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fitbit",
        "sense",
        "advanced",
        "smartwatch",
        "with",
        "tools",
        "for",
        "heart",
        "health",
        "dailysale"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smartwatches",
        "sleep_tracking_wearables"
      ],
      "vsf_dimensions": {
        "evidence": 19,
        "formulation": 15,
        "manufacturing": 15,
        "safety": 12,
        "transparency": 10,
        "sustainability": 4
      },
      "price": 272,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46282146676933",
      "vsf_explanation": "Fitbit Sense holds FDA 510(k) K200948 clearance for its ECG app (AFib detection, ~98.7% sensitivity / 100% specificity in clinical study) and CE mark. Multiple independent PubMed validation studies for Fitbit PPG-HR and sleep stage accuracy. Google/Fitbit publishes privacy policy with explicit data-sale prohibitions and provides documented data deletion. Sold refurbished/discounted via a third-party reseller; original product is end-of-sale but still supported under Google Health transition (May 2026). Verified tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fitbit-sense-2-advanced-health-and-fitness-smartwatch-refurbished",
      "title": "Fitbit Sense 2 Advanced Health and Fitness Smartwatch (Refurbished)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fitbit-sense-2-advanced-health-and-fitness-smartwatch-refurbished-smart-watches-dailysale-582187.jpg?v=1779827799",
      "score": 79,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fitbit",
        "sense",
        "advanced",
        "health",
        "and",
        "fitness",
        "smartwatch",
        "refurbished",
        "dailysale"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smartwatches",
        "sleep_tracking_wearables"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 14,
        "manufacturing": 16,
        "safety": 12,
        "transparency": 9,
        "sustainability": 8
      },
      "price": 189,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46282146742469",
      "vsf_explanation": "Fitbit Sense 2 carries FDA 510(k) clearance for ECG/AFib detection (K200948 ECG app, Sense lineage) with 98.7% sensitivity and 100% specificity in multi-site clinical trial. Validated in the Fitbit Heart Study. Google's binding privacy commitments cover health data. Strong overall but inconclusive ECG rate in real-world use (~20%) is a known limitation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fitbit-charge-4-activity-tracker-gps-plus-heart-rate",
      "title": "Fitbit Charge 4 Activity Tracker GPS Plus Heart Rate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fitbit-charge-4-activity-tracker-gps-plus-heart-rate-fitness-dailysale-548368.jpg?v=1779827812",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fitbit",
        "charge",
        "activity",
        "tracker",
        "gps",
        "plus",
        "heart",
        "rate",
        "dailysale"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "fitness_activity_trackers",
        "sleep_tracking_wearables"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 13,
        "manufacturing": 9,
        "safety": 12,
        "transparency": 9,
        "sustainability": 4
      },
      "price": 125,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46282146873541",
      "vsf_explanation": "Fitbit Charge 4 is a wellness activity tracker with built-in GPS and Fitbit's standard PPG HR (no ECG, no AFib claim, so 510(k) auto-fail does not apply). Fitbit PPG HR and Active Zone Minutes have independent PubMed validation. Older 2020 device, discontinued at retail but still supported under Google Health app transition (May 2026). Sold refurbished by a third-party reseller, limited remaining firmware horizon. Strong Fitbit/Google privacy policy. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fitbit-versa-2-smartwatch-40mm-aluminum-black-carbon-with-silicone-band",
      "title": "Fitbit - Versa 2 Smartwatch 40mm Aluminum - Black/Carbon with Silicone Band",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fitbit-versa-2-smartwatch-40mm-aluminum-blackcarbon-with-silicone-band-smart-watches-dailysale-987276.jpg?v=1779827826",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fitbit",
        "versa",
        "smartwatch",
        "40mm",
        "aluminum",
        "black",
        "carbon",
        "with",
        "silicone",
        "band",
        "dailysale"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smartwatches",
        "sleep_tracking_wearables"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 12,
        "manufacturing": 11,
        "safety": 11,
        "transparency": 9,
        "sustainability": 8
      },
      "price": 149,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46282146906309",
      "vsf_explanation": "Fitbit Versa 2 is a general-wellness smartwatch with peer-reviewed HR validation literature (PMC9047731 systematic review of Fitbit combined-sensing devices). Consumer Reports independent testing rated HR accuracy top marks at rest. No FDA clearance (no ECG/AFib on Versa 2). Same Google/Fitbit privacy commitments and data export (TCX/GPX). HR accuracy degrades significantly during high-intensity exercise.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hugget-for-retail",
      "title": "Hugget for Retail",
      "vendor": "Bearaby",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Moonstone-Grey_Large_Hugget_1.jpg?v=1779827896",
      "score": 77,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hugget",
        "for",
        "retail",
        "bearaby"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_environment"
      ],
      "vsf_dimensions": {
        "evidence": 18,
        "formulation": 16,
        "manufacturing": 13,
        "safety": 10,
        "transparency": 12,
        "sustainability": 8
      },
      "price": 39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46282147496133",
      "vsf_explanation": "Bearaby Hugget is OEKO-TEX Standard 100 certified, made from 100% organic cotton with Melofoam (natural latex from traceable Sri Lankan hevea trees), and Bearaby publishes a detailed Planet Promise sustainability page. Weighted-blanket sleep RCT evidence (BMC Psychiatry 2024, Frontiers 2024) supports the category mechanism and the Hugget's 3 lb weight is within studied parameters for lap-pad/proprioception use. Full materials disclosure, 30-day returns/sleep trial, traceable supply chain, biodegradable fill. Deductions: Hugget is a lap pad not a full weighted blanket so the parameter match to insomnia RCT (which used ~10% body weight blankets) is partial; no published independent third-party VOC testing beyond OEKO-TEX implication; no GOTS certification for the cotton. Verified tier.",
      "vsf_autofail_rule": "confirmed_sale_of_biometric_data"
    },
    {
      "handle": "dexcom-stelo-continuous-glucose-monitor-biosensors-2-pack-15-day-sensors-bluetooth",
      "title": "Dexcom Stelo Continuous Glucose Monitor Biosensors – 2 Pack (15-Day Sensors) [Bluetooth]",
      "vendor": "The Digital Health Store",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71rx9hK-RnL._AC_SX679.jpg?v=1779828003",
      "score": 91,
      "tier": "elite",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dexcom",
        "stelo",
        "continuous",
        "glucose",
        "monitor",
        "biosensors",
        "pack",
        "day",
        "sensors",
        "bluetooth",
        "the",
        "digital",
        "health",
        "store"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "cgm"
      ],
      "vsf_dimensions": {
        "evidence": 23,
        "formulation": 18,
        "manufacturing": 18,
        "safety": 14,
        "transparency": 11,
        "sustainability": 4
      },
      "price": 119.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46282148217029",
      "vsf_explanation": "Dexcom Stelo is the first OTC continuous glucose monitor, FDA 510(k) cleared March 2024 (predicate Dexcom G7) and expanded for pediatric OTC use. Backed by Dexcom's substantial independent CGM accuracy literature (MARD ~8-9% range from G7 predicate), ISO 13485-certified manufacturer, strong privacy/HIPAA stance, documented data export via Stelo app/Apple Health integration. CGM glucose monitoring is one of the most clinically actionable wearable biomarkers in MedlinePlus/NIH. Sustainability scored low because single-use disposable sensors have limited e-waste mitigation. Elite tier.",
      "vsf_autofail_rule": "uncleared_cgm_device"
    },
    {
      "handle": "omron-blood-pressure-monitor-wrist",
      "title": "Omron Blood Pressure Monitor Wrist",
      "vendor": "Farmacias Savia",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/73796271503_OMRON_BLOOD_PRESURE_WRIST_00402a1e-cbe5-41cc-a42b-9369be0ccda4.png?v=1779828038",
      "score": 80,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "omron",
        "blood",
        "pressure",
        "monitor",
        "wrist",
        "farmacias",
        "savia"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "blood_pressure"
      ],
      "vsf_dimensions": {
        "evidence": 19,
        "formulation": 15,
        "manufacturing": 17,
        "safety": 13,
        "transparency": 10,
        "sustainability": 6
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46282148348101",
      "vsf_explanation": "Omron wrist BP monitors hold FDA 510(k) clearance (e.g., HEM-6410T-ZM K182481) and are validated to ANSI/AAMI/ISO 81060-2 standards. Omron is the #1 doctor-recommended brand with extensive clinical validation portfolio. Independent published validation (PMC8503788) shows good agreement with sphygmomanometer (±4 mmHg). Generic title lacks specific model identification — scored on Omron brand baseline.",
      "vsf_autofail_rule": "uncleared_bp_device"
    },
    {
      "handle": "omron-3-series-upper-arm-blood-pressure-monitor-advanced-accuracy-1-ct",
      "title": "Omron 3 Series Upper Arm Blood Pressure Monitor – Advanced Accuracy – 1 ct",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/207653908.jpg?v=1779828042",
      "score": 80,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "omron",
        "series",
        "upper",
        "arm",
        "blood",
        "pressure",
        "monitor",
        "advanced",
        "accuracy",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "blood_pressure"
      ],
      "vsf_dimensions": {
        "evidence": 19,
        "formulation": 14,
        "manufacturing": 16,
        "safety": 13,
        "transparency": 10,
        "sustainability": 4
      },
      "price": 44.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46282148413637",
      "vsf_explanation": "Omron 3 Series BP710N is FDA 510(k) cleared (e.g. K182579 family), on the US Blood Pressure Validated Device Listing (VDL), and validated to AAMI/ESH protocols. Omron is the global market-leader in home BP monitors with extensive independent clinical validation literature. Strong privacy policy on omronhealthcare.com, IntelliSense oscillometric algorithm well-characterized. Modest data-export (manual logging only on basic model). Verified tier.",
      "vsf_autofail_rule": "uncleared_bp_device"
    },
    {
      "handle": "omron-intellisense®-blood-pressure-monitor-hem-907xl",
      "title": "Omron IntelliSense® Blood Pressure Monitor HEM-907XL",
      "vendor": "Medsitis",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d00c6abe53dac6aeab57bc5950f5ff3589eea778.jpg?v=1779828047",
      "score": 88,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "omron",
        "intellisense",
        "blood",
        "pressure",
        "monitor",
        "hem",
        "907xl",
        "medsitis"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "blood_pressure"
      ],
      "vsf_dimensions": {
        "evidence": 24,
        "formulation": 17,
        "manufacturing": 18,
        "safety": 13,
        "transparency": 11,
        "sustainability": 5
      },
      "price": 936.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46282148479173",
      "vsf_explanation": "Omron HEM-907XL is the professional clinical-use BP monitor used in the SPRINT Trial and validated against mercury sphygmomanometer in NHANES — the gold-standard reference applications in cardiovascular research. Peer-reviewed validation in CKD patients (PMID 28079300). FDA-registered, clinically validated, ±3 mmHg accuracy. Designed for hospital/clinical settings. Borderline Elite tier.",
      "vsf_autofail_rule": "uncleared_bp_device"
    },
    {
      "handle": "omron-10-series-wireless-upper-arm-blood-pressure-monitor-multi-user-each",
      "title": "Omron 10 Series Wireless Upper Arm Blood Pressure Monitor, Multi-User – Each",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/259933933.jpg?v=1779828053",
      "score": 84,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "omron",
        "series",
        "wireless",
        "upper",
        "arm",
        "blood",
        "pressure",
        "monitor",
        "multi",
        "user",
        "each",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "blood_pressure"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 16,
        "manufacturing": 16,
        "safety": 13,
        "transparency": 11,
        "sustainability": 4
      },
      "price": 95.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46282148511941",
      "vsf_explanation": "Omron 10 Series BP7450 is FDA 510(k) cleared, on the US Blood Pressure Validated Device Listing (VDL), AAMI/ESH/BHS validated, and additionally validated for type II diabetes patients. Bluetooth data export to Omron Connect app + Apple Health/Google Fit (CSV export), multi-user mode, advanced-accuracy 5-data-point algorithm. Strong privacy stance and documented multi-year support. Consumer Reports independently reviewed. Verified tier - highest-scoring home BP in this batch.",
      "vsf_autofail_rule": "uncleared_bp_device"
    },
    {
      "handle": "nova-4-sauna-tent-4-person-portable-sauna",
      "title": "Nova 4 Sauna Tent | 4-person portable sauna",
      "vendor": "North Shore Sauna",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nova_4_6a37f0af-83fb-49b1-98d6-aedfccaf4d13.png?v=1781746936",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nova",
        "sauna",
        "tent",
        "person",
        "portable",
        "sauna",
        "north",
        "shore",
        "sauna"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 75,
        "manufacturing": 72,
        "safety": 72,
        "transparency": 68,
        "sustainability": 65
      },
      "price": 799,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46391133700293",
      "vsf_explanation": "Wood-fired traditional Finnish-style portable sauna tent from North Shore Sauna, a small US brand designing in Duluth, MN. Traditional high-heat sauna bathing has the strongest evidence base of any heat-therapy modality (Laukkanen et al., Finnish cohort data). Real brand provenance, differentiated wood-fired approach rather than commoditized infrared blanket, and appropriate use of a stove-plus-tent design. Solid Verified tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "infrared-sauna-blanket-with-arm-holes",
      "title": "Infrared Sauna Blanket With Arm Holes",
      "vendor": "Happy Sol Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/LAST004.jpg?v=1781746971",
      "score": 53,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "infrared",
        "sauna",
        "blanket",
        "with",
        "arm",
        "holes",
        "happy",
        "sol",
        "wellness"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 229.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46391134552261",
      "vsf_explanation": "Consumer infrared sauna blanket with arm zippers, adjustable temperature (up to 176F), 60-minute timer, and 'low EMF' marketing. Blanket form is a reasonable and evidenced way to induce passive thermal stress. EMF numbers are not published and no third-party testing is cited. Solid mid-market recovery device without clinical differentiation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "🔥-portable-far-infrared-sauna-blanket",
      "title": "🔥 Portable Far Infrared Sauna Blanket",
      "vendor": "SmartPursue™",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ee2a27aa-266b-460a-9804-5609fbbfbe31.jpg?v=1781747005",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "portable",
        "far",
        "infrared",
        "sauna",
        "blanket",
        "smartpursue"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 25,
        "sustainability": 30
      },
      "price": 189.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46391135240389",
      "vsf_explanation": "Dropship-style listing (emoji in title, generic Vevor-branded blanket referenced in copy) from SmartPursue, a reseller with no identifiable manufacturer accountability. Sauna blankets are a legitimate category, but this specific SKU has no verifiable brand behind it, no EMF/temperature testing data, and no safety documentation. Auto-failed for lack of provenance.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "thorne-selenium-200-mcg-dietary-supplement-exp-7-2027",
      "title": "Thorne Selenium 200 mcg Dietary Supplement EXP 7/2027",
      "vendor": "Thorne",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a7eb42ef-c9b7-498d-89fd-dec4f69b4c91.jpg?v=1781747054",
      "score": 87,
      "tier": "elite",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "thorne",
        "selenium",
        "200",
        "mcg",
        "dietary",
        "supplement",
        "exp",
        "2027",
        "thorne"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 85,
        "formulation": 88,
        "manufacturing": 92,
        "safety": 88,
        "transparency": 90,
        "sustainability": 72
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46391135731909",
      "vsf_explanation": "Genuine Thorne Selenium 200 mcg as selenomethionine (highly bioavailable form). Selenomethionine RCTs (Rayman 2008) support ~200 mcg/day for selenoprotein status. Thorne is NSF Certified for Sport, tested at four validation points, and publishes COAs. Elite anchor. Reseller channel + expiry (7/2027) is fine given long shelf life.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "thorne-methyl-guard-plus-dietary-supplement-90-capsules-exp-10-2026",
      "title": "Thorne Methyl-Guard Plus Dietary Supplement, 90 Capsules EXP 10/2026",
      "vendor": "Thorne",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e39f8082-481a-4ee9-aacc-10ca4ea255df.jpg?v=1781747057",
      "score": 88,
      "tier": "elite",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "thorne",
        "methyl",
        "guard",
        "plus",
        "dietary",
        "supplement",
        "capsules",
        "exp",
        "2026",
        "thorne"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 80,
        "formulation": 85,
        "manufacturing": 92,
        "safety": 82,
        "transparency": 88,
        "sustainability": 70
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46391136059589",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 84 → new 88. Evidence found: Bailey LB et al. Biomarkers of Nutrition for Development—Folate Review. J Nutr. 2015;145(7):1636S-1680S. | Obeid R, Schön C, Wilhelm M et al. The effectiveness of daily supplementation with 400 or 800 mcg of folate in reducing homocysteine. Eur J Clin Nutr. 2018;72(12):1633-1642 (methyl-folate class evidence).. Rationale: Methyl-Guard Plus delivers 5-MTHF (L-methylfolate), methylcobalamin (B12), P-5-P (active B6), riboflavin 5-phosphate (active B2), and betaine — the complete methylation-support panel in bioactive forms at therapeutic doses. Elite tier for practitioner-grade brand + methylation-cycle specificity + all-bioactive-forms + strong homocysteine-lowering evidence class.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fullglow-red-light-and-infrared-therapy-hat",
      "title": "FullGlow Red Light and Infrared Therapy Hat",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ChatGPT_Image_May_5_2026_12_11_44_PM_1.png?v=1781966003",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fullglow",
        "red",
        "light",
        "and",
        "infrared",
        "therapy",
        "hat",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 99.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431019958469",
      "vsf_explanation": "Wearable red/near-infrared therapy cap from iReliev for scalp/hair applications. iReliev brand offers more legitimacy than typical no-name hair-growth caps, but the FullGlow specifically has no listed FDA clearance for hair growth. Empty product description weakens transparency. Standard tier as a plausible consumer photobio device.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "red-light-therapy-baseball-cap",
      "title": "Red Light Therapy Baseball Cap",
      "vendor": "Happy Sol Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/WhatsApp_Image_2025-10-11_at_1.03.43_AM.jpg?v=1781966026",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "light",
        "therapy",
        "baseball",
        "cap",
        "happy",
        "sol",
        "wellness"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 62,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 89.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431020220613",
      "vsf_explanation": "Cordless 88-LED, 660 nm hair-growth cap claiming 60 mW/cm2 irradiance. Low-level laser/LED therapy for androgenetic alopecia has FDA-cleared analogs (HairMax, Capillus), but this cap has no listed clearance and no published trials of its own. Reasonable at-home device for hair concerns but not clinically validated at this price point.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "red-light-therapy-near-infrared-light-therapy-panel-full-body-1500w",
      "title": "Red Light Therapy  & Near Infrared Light Therapy Panel, Full Body, 1500W",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Red_Light_Therapy_Panel_1500W_with_Size_HERO.png?v=1781966037",
      "score": 67,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "light",
        "therapy",
        "near",
        "infrared",
        "light",
        "therapy",
        "panel",
        "full",
        "body",
        "1500w",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 70,
        "manufacturing": 68,
        "safety": 70,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 999.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431020253381",
      "vsf_explanation": "Full-body 1500 W dual-wavelength photobiomodulation panel from iReliev, a mid-tier consumer wellness brand with a stable US presence. Panel form factor is appropriate for red-light therapy protocols supported by peer-reviewed literature for muscle recovery and skin. Empty product description on Shopify hurts transparency; no third-party irradiance measurements cited. Solid Standard, close to Verified if specs were fully documented.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "red-nova-light-compact-900-red-infrared-light-therapy-panel-630-850nm",
      "title": "Red Nova Light Compact 900 – Red & Infrared Light Therapy Panel (630–850nm)",
      "vendor": "Red Nova Lights LLC",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/900_3.png?v=1781966058",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "nova",
        "light",
        "compact",
        "900",
        "red",
        "infrared",
        "light",
        "therapy",
        "panel",
        "630",
        "850nm",
        "red",
        "nova",
        "lights",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 30,
        "sustainability": 25
      },
      "price": 499,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431020318917",
      "vsf_explanation": "Red / NIR light panel (630, 660, 810, 830, 850 nm) — a photobiomodulation device, not an ingestible. PBM has moderate evidence for skin and localized recovery (Hamblin 2017), but this product is out-of-scope for the supplement rubric. Rejected as category mismatch.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "red-nova-light-smart-1500-pro-advanced-full-spectrum-red-infrared-therapy-panel-630-1060nm",
      "title": "Red Nova Light Smart 1500 Pro – Advanced Full-Spectrum Red & Infrared Therapy Panel (630–1060nm)",
      "vendor": "Red Nova Lights LLC",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1500_6.png?v=1781966069",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "nova",
        "light",
        "smart",
        "1500",
        "pro",
        "advanced",
        "full",
        "spectrum",
        "red",
        "infrared",
        "therapy",
        "panel",
        "630",
        "1060nm",
        "red",
        "nova",
        "lights",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 45,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 30,
        "sustainability": 25
      },
      "price": 1129,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431020351685",
      "vsf_explanation": "Full-spectrum red / NIR panel (7 wavelengths, 308 LEDs) — a photobiomodulation device, not a supplement. Rejected as category mismatch.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "large-red-light-therapy-pad-27-x-11-with-1-998-leds-for-pain-relief-recovery",
      "title": "Large Red Light Therapy Pad – 27\" x 11\" with 1,998 LEDs for Pain Relief & Recovery",
      "vendor": "Red Light Pro Devices",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ModelExtraII.jpg?v=1781966097",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "large",
        "red",
        "light",
        "therapy",
        "pad",
        "with",
        "998",
        "leds",
        "for",
        "pain",
        "relief",
        "recovery",
        "red",
        "light",
        "pro",
        "devices"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 1197,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431020515525",
      "vsf_explanation": "Large flexible red/near-infrared pad (660 nm + 850 nm) with substantial LED count and coverage, marketed for pain relief and recovery. Fat-reduction claims lack the peer-reviewed support the copy implies, which drags evidence and transparency down. Reasonable form factor at a premium price with no clinical dossier — usable but overreaching in marketing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "red-light-therapy-mask-for-face-led-light-therapy-for-anti-aging-skin-rejuvenation",
      "title": "Red Light Therapy Mask for Face, LED Light Therapy for Anti-Aging & Skin Rejuvenation",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Red_Light_Therapy_Mask_with_4_Light_Modes.png?v=1781966109",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "light",
        "therapy",
        "mask",
        "for",
        "face",
        "led",
        "light",
        "therapy",
        "for",
        "anti",
        "aging",
        "skin",
        "rejuvenation",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 79.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431020548293",
      "vsf_explanation": "LED photobiomodulation face mask from iReliev, an established consumer wellness brand best known for its FDA-cleared TENS units. This particular mask targets cosmetic anti-aging use and does not have its own listed clearance, but the brand provides more legitimacy than typical Amazon-tier competitors. Standard tier — real product, unremarkable evidence, no efficacy data cited.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "red-nova-light-solo-300-targeted-red-infrared-light-therapy-panel-630-850nm",
      "title": "Red Nova Light Solo 300 – Targeted Red & Infrared Light Therapy Panel (630–850nm)",
      "vendor": "Red Nova Lights LLC",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/mini_300_15.png?v=1781966145",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "nova",
        "light",
        "solo",
        "300",
        "targeted",
        "red",
        "infrared",
        "light",
        "therapy",
        "panel",
        "630",
        "850nm",
        "red",
        "nova",
        "lights",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 30,
        "sustainability": 25
      },
      "price": 199,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431020613829",
      "vsf_explanation": "Compact 5-wavelength red / NIR panel — photobiomodulation device, not a supplement. Rejected as category mismatch.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "red-light-therapy-belt",
      "title": "Red Light Therapy Belt",
      "vendor": "Happy Sol Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Main_image_1200_1200-6.jpg?v=1781966161",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "light",
        "therapy",
        "belt",
        "happy",
        "sol",
        "wellness"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 59.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431020712133",
      "vsf_explanation": "Wearable red/near-infrared belt with 105 LEDs at 635 nm and 850 nm, five power settings, and a timer. Wavelength choice aligns with photobiomodulation literature for muscle and joint recovery. No FDA clearance and no published irradiance data, so it functions as a reasonable consumer-grade recovery aid rather than a clinical device.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mini-go-red-light-therapy",
      "title": "Mini Go Red Light Therapy",
      "vendor": "Happy Sol Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/red-light-device-hero_4_1.jpg?v=1781966176",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mini",
        "red",
        "light",
        "therapy",
        "happy",
        "sol",
        "wellness"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 109.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431020744901",
      "vsf_explanation": "Handheld 24-LED device delivering 660 nm red and near-infrared light with adjustable brightness and a 10-minute timer. Small treatment area limits utility for whole-body applications but suits targeted spot use. Happy Sol Wellness is a small direct-to-consumer brand with no clinical dossier; specs (wavelength, timer) are transparent but irradiance is not disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "red-light-therapy-belt-1",
      "title": "Red Light Therapy Belt",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_woman_in_workout_clothes_wearing_belt._red_light_emanates_from_under_belt..png?v=1781966187",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "light",
        "therapy",
        "belt",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 62,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 74.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431020810437",
      "vsf_explanation": "A body-worn dual-wavelength red/near-infrared belt with heat, positioned for musculoskeletal pain and recovery. Photobiomodulation for muscle recovery has a plausible mechanistic and clinical basis, though this specific product has no cited studies, no clearance, and Lang Wellness LLC is a low-visibility brand. Reasonable at-home device but nothing to distinguish it from generic imports.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "under-eye-red-light-therapy-massager-skin-rejuvenation-relaxation-device",
      "title": "Under-Eye Red Light Therapy Massager| Skin Rejuvenation & Relaxation Device",
      "vendor": "N3xtLevel Professionals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/under-eye-red-light-therapy-skin-rejuvenation-and-relaxation-massagerunder-eye-red-light-therapy-skin-rejuvenation-and-relaxation-massager-5623925.jpg?v=1781966210",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "under",
        "eye",
        "red",
        "light",
        "therapy",
        "massager",
        "skin",
        "rejuvenation",
        "relaxation",
        "device",
        "n3xtlevel",
        "professionals"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 25,
        "manufacturing": 30,
        "safety": 50,
        "transparency": 30,
        "sustainability": 30
      },
      "price": 39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431021236421",
      "vsf_explanation": "A cosmetic under-eye anti-aging massager positioned around beauty use cases (dark circles, fine lines, puffiness), not biohacking health optimization. N3xtLevel Professionals is an unknown reseller with no published wavelength, irradiance, or clinical data. Fails as a beauty/cosmetic device outside Vyvata's biohacking scope.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "fringe-red-light-therapy-wrap",
      "title": "Fringe Red Light Therapy Wrap",
      "vendor": "BioWizdom",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/rn-image_picker_lib_temp_397d6bb9-94ac-49ac-a059-ab88ebe5810a.png?v=1781966220",
      "score": 51,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fringe",
        "red",
        "light",
        "therapy",
        "wrap",
        "biowizdom"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 52,
        "safety": 55,
        "transparency": 45,
        "sustainability": 48
      },
      "price": 239,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431021269189",
      "vsf_explanation": "360-LED dual-wavelength wireless wrap from BioWizdom's 'Fringe' line — flexible form factor good for hip, knee, low-back and shoulder use. Named brand with a consumer wellness storefront, though no FDA clearance or independent irradiance data disclosed. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "infrared-red-light-therapy-wrap",
      "title": "Infrared Red Light Therapy Wrap",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/infrared-red-light-therapy-wrap-wellness-dailysale-891383.jpg?v=1781966232",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "infrared",
        "red",
        "light",
        "therapy",
        "wrap",
        "dailysale"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 45,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 35,
        "sustainability": 42
      },
      "price": 39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431021367493",
      "vsf_explanation": "15-LED (9 red / 6 NIR) budget $39 wrap resold by a discount reseller. Too few LEDs to deliver clinically meaningful dosing across any meaningful treatment area, and no manufacturer disclosed. Effectively a novelty gift item. Rejected on evidence and provenance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "led-red-light-therapy-belt",
      "title": "LED Red Light Therapy Belt",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/led-red-light-therapy-belt-wellness-dailysale-341990.jpg?v=1781966258",
      "score": 47,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "led",
        "red",
        "light",
        "therapy",
        "belt",
        "dailysale"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 47,
        "formulation": 50,
        "manufacturing": 47,
        "safety": 52,
        "transparency": 38,
        "sustainability": 45
      },
      "price": 71,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431021400261",
      "vsf_explanation": "126-LED dual-wavelength therapy belt resold via a discount storefront. No manufacturer identified beyond the reseller; generic spec sheet with typical Amazon-tier claims and no independent validation. Rejected on provenance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "exesas-600-led-3000w-dual-chip-red-light-therapy-device-for-full-body-4-wavelengths-infrared-led-panel-for-skin-weight-pain-wellness",
      "title": "EXESAS  600 LED, 3000W Dual-Chip, Red Light Therapy Device for Full Body, 4-Wavelengths Infrared LED Panel for Skin, Weight, Pain, Wellness",
      "vendor": "EXESAS",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3000W_-_5_9bdb03b6-93ed-4eed-a556-f97f7bc247ad.png?v=1781966268",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "exesas",
        "600",
        "led",
        "3000w",
        "dual",
        "chip",
        "red",
        "light",
        "therapy",
        "device",
        "for",
        "full",
        "body",
        "wavelengths",
        "infrared",
        "led",
        "panel",
        "for",
        "skin",
        "weight",
        "pain",
        "wellness",
        "exesas"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 52,
        "sustainability": 52
      },
      "price": 1549,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431021891781",
      "vsf_explanation": "600-LED 4-wavelength EXESAS panel — mid-flagship of the brand's lineup at $1,549. Same wavelengths and irradiance claims as smaller EXESAS SKUs, at a size that begins to genuinely cover full-body use. No independent verification. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "painiq-red-light-infrared-laser-therapy-device",
      "title": "PainIQ+ Red Light & Infrared Laser Therapy Device",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/RL-1000_PainIQ_HERO_1500_x_1500.jpg?v=1781966279",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "painiq",
        "red",
        "light",
        "infrared",
        "laser",
        "therapy",
        "device",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 52,
        "sustainability": 52
      },
      "price": 299.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431021990085",
      "vsf_explanation": "PainIQ+ is iReliev's handheld combined red-light and low-level laser device — a real product from an established US brand with prior FDA-registered TENS SKUs. The product-page body is empty here so laser class and clearance status aren't explicitly restated, but brand track record supports a Standard tier score.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "youthbeam-red-light-therapy-for-tired-eyes",
      "title": "YouthBeam – Red Light Therapy for Tired Eyes!",
      "vendor": "Dabfavshop",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/S4cb79d2f9fae4990afa981cf0b2f3d0aA.jpg?v=1781966297",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "youthbeam",
        "red",
        "light",
        "therapy",
        "for",
        "tired",
        "eyes",
        "dabfavshop"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 42,
        "manufacturing": 38,
        "safety": 48,
        "transparency": 32,
        "sustainability": 42
      },
      "price": 69.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431022153925",
      "vsf_explanation": "Under-eye red-light beauty device from Dabfavshop dropship storefront. Aggressive marketing (dark circles, wrinkles, puffiness) with zero clinical data, manufacturer identity, or safety certifications. Cosmetic novelty; Rejected on provenance and evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "exesas-1216-led-6080w-dual-chip-red-light-therapy-device-for-full-body-4-wavelengths-infrared-led-panel-for-skin-weight-pain-wellness",
      "title": "EXESAS     1216 LED, 6080W Dual-Chip, Red Light Therapy Device for Full Body, 4-Wavelengths Infrared LED Panel for Skin, Weight, Pain, Wellness",
      "vendor": "EXESAS",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6080W_-_01_A.png?v=1781966305",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "exesas",
        "1216",
        "led",
        "6080w",
        "dual",
        "chip",
        "red",
        "light",
        "therapy",
        "device",
        "for",
        "full",
        "body",
        "wavelengths",
        "infrared",
        "led",
        "panel",
        "for",
        "skin",
        "weight",
        "pain",
        "wellness",
        "exesas"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 3499,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431022186693",
      "vsf_explanation": "Flagship EXESAS 1216-LED 6080W full-body panel — enormous footprint and 4-wavelength coverage at $3,499 competes on paper with premium Mito Red / PlatinumLED units. Still no third-party irradiance, EMF, or clearance data disclosed. Upper Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pet-red-light-infrared-therapy-device",
      "title": "Pet Red Light Infrared Therapy Device",
      "vendor": "Pet Zen",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1b4db1c0-965c-4bc2-9995-27b4bfbb33db.jpg?v=1781966321",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pet",
        "red",
        "light",
        "infrared",
        "therapy",
        "device",
        "pet",
        "zen"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 30,
        "safety": 45,
        "transparency": 30,
        "sustainability": 35
      },
      "price": 433.88,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431022317765",
      "vsf_explanation": "Pet-specific red-light infrared therapy device from Pet Zen. Not a human biohacking product; veterinary dosing parameters differ meaningfully from human tissue and there is no human-safety validation.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "exesas-324-led-1620w-dual-chip-red-light-therapy-device-for-full-body-4-wavelengths-infrared-led-panel-for-skin-weight-pain-wellness",
      "title": "EXESAS 324 LED, 1620W Dual-Chip, Red Light Therapy Device for Full Body, 4-Wavelengths Infrared LED Panel for Skin, Weight, Pain, Wellness",
      "vendor": "EXESAS",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/IMAGE_324led-with_glow_with_SHADOW_1_B_50b16889-38c5-4d30-b15b-5cfdec3d278e.png?v=1781966333",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "exesas",
        "324",
        "led",
        "1620w",
        "dual",
        "chip",
        "red",
        "light",
        "therapy",
        "device",
        "for",
        "full",
        "body",
        "wavelengths",
        "infrared",
        "led",
        "panel",
        "for",
        "skin",
        "weight",
        "pain",
        "wellness",
        "exesas"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 52,
        "sustainability": 52
      },
      "price": 849,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431022514373",
      "vsf_explanation": "324-LED 4-wavelength EXESAS panel — mid-to-upper end of the brand's lineup at $849. Genuinely competes on wavelengths and coverage with panels 2–3× the price, though still without third-party validation, EMF report, or FDA clearance. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "exesas-200-led-1000w-dual-chip-red-light-therapy-device-for-full-body-4-wavelengths-infrared-led-panel-for-skin-weight-pain-wellness",
      "title": "EXESAS 200 LED, 1000W Dual-Chip, Red Light Therapy Device for Full Body, 4-Wavelengths Infrared LED Panel for Skin, Weight, Pain, Wellness",
      "vendor": "EXESAS",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MAIN_1000W_IMAGE-001_1_A_129fd5f9-7948-4508-b48c-d7f68c244571.png?v=1781966341",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "exesas",
        "200",
        "led",
        "1000w",
        "dual",
        "chip",
        "red",
        "light",
        "therapy",
        "device",
        "for",
        "full",
        "body",
        "wavelengths",
        "infrared",
        "led",
        "panel",
        "for",
        "skin",
        "weight",
        "pain",
        "wellness",
        "exesas"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 50,
        "sustainability": 52
      },
      "price": 529,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431022547141",
      "vsf_explanation": "200-LED 4-wavelength full-body EXESAS panel with remote control. Coverage step up from the 120-LED unit; same brand consistency and spec claims (>224 mW/cm², no-EMF, 4 wavelengths). No independent verification or FDA clearance. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "under-eye-red-light-therapy-skin-rejuvenation-and",
      "title": "Under-Eye Red Light Therapy Skin Rejuvenation and",
      "vendor": "The Make-up Corner",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4fb6a25c-053a-4404-a639-4fb56e0fc4fa.jpg?v=1781966356",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "under",
        "eye",
        "red",
        "light",
        "therapy",
        "skin",
        "rejuvenation",
        "and",
        "the",
        "make",
        "corner"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 42,
        "manufacturing": 38,
        "safety": 48,
        "transparency": 32,
        "sustainability": 42
      },
      "price": 79.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431022579909",
      "vsf_explanation": "Under-eye microcurrent + red-light beauty device from 'The Make-up Corner' storefront. Truncated title, no manufacturer identification, no clearance, and no clinical data. Cosmetic novelty product; Rejected on provenance and evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "exesas-120-led-600w-dual-chip-red-light-therapy-device-for-full-body-4-wavelengths-infrared-led-panel-for-skin-weight-pain-wellness",
      "title": "EXESAS 120 LED, 600W Dual-Chip, Red Light Therapy Device for Full Body, 4-Wavelengths Infrared LED Panel for Skin, Weight, Pain, Wellness",
      "vendor": "EXESAS",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/IMAGE-001-with_glow_with_SHADOW_1_8ea74980-0075-49aa-887e-b3442379adad.png?v=1781966368",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "exesas",
        "120",
        "led",
        "600w",
        "dual",
        "chip",
        "red",
        "light",
        "therapy",
        "device",
        "for",
        "full",
        "body",
        "wavelengths",
        "infrared",
        "led",
        "panel",
        "for",
        "skin",
        "weight",
        "pain",
        "wellness",
        "exesas"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 48,
        "sustainability": 50
      },
      "price": 328,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431022842053",
      "vsf_explanation": "120-LED 4-wavelength (630/660/810/850nm) dual-chip EXESAS panel with claimed 'No EMF' and >224 mW/cm² irradiance. Feature set is competitive with mid-tier premium panels but neither claim is backed by published test data or FDA registration. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "laser-light-therapy-device-red-light-therapy-device-massager",
      "title": "Laser Light Therapy Device Red Light Therapy Device Massager",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/548CC44AD1DBABCD7881235BA07557A0.jpg?v=1781966384",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "laser",
        "light",
        "therapy",
        "device",
        "red",
        "light",
        "therapy",
        "device",
        "massager",
        "digital",
        "presence"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 32,
        "manufacturing": 28,
        "safety": 35,
        "transparency": 25,
        "sustainability": 35
      },
      "price": 275.66,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431022874821",
      "vsf_explanation": "Generic '808nm + 650nm' handheld laser device sold via an unnamed reseller with no manufacturer name, no laser class disclosure, and no eye-safety certification. Actual laser output at 660MW would require Class 3B safety controls not evidenced here. Rejected on brand provenance.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "exesas-80-led-400w-dual-chip-red-light-therapy-device-for-full-body-660nm-850nm-infrared-led-panel-for-beautiful-skin-weight-pain-management",
      "title": "EXESAS 80 LED, 400W Dual-Chip, Red Light Therapy Device for Full Body 660nm & 850nm Infrared LED Panel for Beautiful Skin, Weight & Pain Management",
      "vendor": "EXESAS",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MAIN_400W_IMAGE-001_1_A.png?v=1781966394",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "exesas",
        "led",
        "400w",
        "dual",
        "chip",
        "red",
        "light",
        "therapy",
        "device",
        "for",
        "full",
        "body",
        "660nm",
        "850nm",
        "infrared",
        "led",
        "panel",
        "for",
        "beautiful",
        "skin",
        "weight",
        "pain",
        "management",
        "exesas"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 55,
        "manufacturing": 52,
        "safety": 55,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 179,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431023038661",
      "vsf_explanation": "80-dual-chip 660/850nm 400W panel from EXESAS. Brand runs a consistent Amazon-native product line; spec claims (5W LEDs, 30° beam) are within category norms. No FDA clearance or independent irradiance verification. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "shape-tactics-630-led-red-light-therapy-belt",
      "title": "Shape Tactics 630-LED Red Light Therapy Belt",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shape-tactics-total-body-lipolaser-belt-with-630-red-light-leds-ltcmol712-690943.jpg?v=1781966403",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shape",
        "tactics",
        "630",
        "led",
        "red",
        "light",
        "therapy",
        "belt",
        "cavitation",
        "machines"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 53,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 42,
        "sustainability": 50
      },
      "price": 541.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431023136965",
      "vsf_explanation": "630-LED 660/850nm belt positioned by 'Cavitation Machines' storefront alongside body-contouring equipment. Description carefully avoids explicit fat-reduction claims, but the storefront context implies weight-loss use without clinical dosing evidence. Reasonable red-light hardware for the price; low-Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sonicglow-eye-revitalizer-red-light-heat-vibration-therapy",
      "title": "SonicGlow Eye Revitalizer – Red Light, Heat & Vibration Therapy",
      "vendor": "VYSN",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6eMdDmdReuqBW8OUoc0dNLfdyQYInlfzMInNiB_DQ0Q.jpg?v=1781966418",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sonicglow",
        "eye",
        "revitalizer",
        "red",
        "light",
        "heat",
        "vibration",
        "therapy",
        "vysn"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 42,
        "safety": 50,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 249.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431023366341",
      "vsf_explanation": "Combined red-light / heat / EMS-pulse / vibration eye-area massager from VYSN. Cosmetic beauty device with no clinical support for combined EMS around ocular tissue, which is a genuine safety concern at the wrong intensity. No wavelength, irradiance, or manufacturer detail disclosed. Rejected on evidence and safety-diligence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "red-light-therapy-hair-growth-cap-56-96-bulb",
      "title": "Red Light Therapy Hair Growth Cap (56/96 Bulb)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_man_wearing_hat._red_light_glows_from_under_the_hat..png?v=1781966428",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "light",
        "therapy",
        "hair",
        "growth",
        "cap",
        "bulb",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 52,
        "transparency": 38,
        "sustainability": 45
      },
      "price": 60.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431023399109",
      "vsf_explanation": "96-LED 'M11' hair-growth cap with red, IR, blue and purple modes from Lang Wellness LLC. Priced far below FDA-cleared competitors (HairMax, iRestore, Capillus) which is the entire evidence base for hair-regrowth LLLT — and this device is not cleared. Multi-color LED marketing for hair regrowth is largely non-evidence-based. Rejected on evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cuppin-therapy-massager-with-red-light-heat-therapy-16-level-temperature",
      "title": "Cuppin Therapy Massager with Red Light Heat Therapy 16 Level Temperature",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cuppin-therapy-massager-with-red-light-heat-therapy-16-level-temperature-wellness-dailysale-277076.jpg?v=1781966448",
      "score": 37,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cuppin",
        "therapy",
        "massager",
        "with",
        "red",
        "light",
        "heat",
        "therapy",
        "level",
        "temperature",
        "dailysale"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431023530181",
      "vsf_explanation": "$35 combined cupping/scraping/red-light heat massager from a discount storefront. Cheap OEM device with no clinical support for negative-pressure cupping benefits, and the red-light component is a heat lamp rather than therapeutic-dose LED. No manufacturer disclosed. Rejected on evidence and provenance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "red-light-therapy-near-infrared-light-therapy-panel-full-body-2400w",
      "title": "Red Light Therapy & Near Infrared Light Therapy Panel, Full Body, 2400W",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2400W_Hero_Image_USE_Corret_Dimensions.png?v=1781966461",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "light",
        "therapy",
        "near",
        "infrared",
        "light",
        "therapy",
        "panel",
        "full",
        "body",
        "2400w",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 62,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 1595.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431023726789",
      "vsf_explanation": "iReliev is an established US TENS/EMS/red-light brand with real US warranty and support pipelines. This 2400W full-body panel is spec-competitive with mid-tier Mito/PlatinumLED offerings. Product-page body is empty and independent irradiance data isn't provided, but brand track record supports a Standard tier score.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "red-light-therapy-mat-1280-leds-full-body-blanket-660nm-850nm",
      "title": "Red Light Therapy Mat - 1280 LEDs Full Body Blanket 660nm 850nm",
      "vendor": "Archetype Magazine",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/S3f28d7dd0cd649948d4138283790e946t.webp?v=1781966509",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "light",
        "therapy",
        "mat",
        "1280",
        "leds",
        "full",
        "body",
        "blanket",
        "660nm",
        "850nm",
        "archetype",
        "magazine"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 48,
        "safety": 55,
        "transparency": 42,
        "sustainability": 48
      },
      "price": 703.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431023759557",
      "vsf_explanation": "1,280-LED 660/850nm full-body 71\"x31\" mat resold via 'Archetype Magazine' storefront. Uses 'medical-grade LEDs' marketing language without disclosing any FDA clearance, EMF test, or upstream manufacturer name — a mild misleading-naming risk that would auto-fail if pushed further. Reseller storefront weakens provenance. Low-Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "red-light-therapy-belt-for-waist-shoulder-660-850nm-light-therapy-device",
      "title": "Red Light Therapy Belt for Waist Shoulder 660&850nm Light Therapy Device",
      "vendor": "VYSN",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d0102hs0l88.jpg?v=1781966525",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "light",
        "therapy",
        "belt",
        "for",
        "waist",
        "shoulder",
        "660",
        "850nm",
        "light",
        "therapy",
        "device",
        "vysn"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 52,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 42,
        "sustainability": 48
      },
      "price": 64.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431023956165",
      "vsf_explanation": "48\" 80-LED (240-chip) 660/850nm therapy belt with pulsed and 3-level vibration modes from VYSN. Reasonable feature set at $65 and dual-wavelength coverage is genuine, but no independent irradiance verification, EMF report, or brand provenance beyond the reseller. Low-Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "blisspod-helsinki-full-spectrum-ultimate-indoor-sauna-red-light-therapy-2-person",
      "title": "Blisspod | Helsinki | Full Spectrum Ultimate Indoor Sauna | Red Light Therapy | 2 Person",
      "vendor": "zoppinh",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HELSINKI_2048x2048_f3e0e884-dad3-4e9c-b352-abbcad00c33d.webp?v=1781966533",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "blisspod",
        "helsinki",
        "full",
        "spectrum",
        "ultimate",
        "indoor",
        "sauna",
        "red",
        "light",
        "therapy",
        "person",
        "zoppinh"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 52,
        "safety": 52,
        "transparency": 42,
        "sustainability": 45
      },
      "price": 4499,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431024021701",
      "vsf_explanation": "Two-person full-spectrum infrared sauna in Helsinki (lighter-wood) cabinet configuration from Blisspod (vendor 'zoppinh'). Same platform as the Bergen unit; no VOC or EMF test data published and vendor storefront naming is unusual. Standard tier on category norms.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "red-nova-light-1500-digital-red-near-infrared-therapy-panel-630-850nm",
      "title": "Red Nova Light 1500 Digital – Red & Near-Infrared Therapy Panel (630–850nm)",
      "vendor": "Red Nova Lights LLC",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1500_5_1.png?v=1781966544",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "nova",
        "light",
        "1500",
        "digital",
        "red",
        "near",
        "infrared",
        "therapy",
        "panel",
        "630",
        "850nm",
        "red",
        "nova",
        "lights",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 30,
        "sustainability": 25
      },
      "price": 799,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431024054469",
      "vsf_explanation": "Full-body red / NIR panel — photobiomodulation device, not a supplement. Rejected as category mismatch.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "blisspod-bergen-full-spectrum-ultimate-indoor-sauna-red-light-therapy-2-person",
      "title": "Blisspod | Bergen | Full Spectrum Ultimate Indoor Sauna | Red Light Therapy | 2 Person",
      "vendor": "zoppinh",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Bergen_2048x2048_7c5af1cd-27ba-440b-b99d-8547bcd97fc4.webp?v=1781966564",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "blisspod",
        "bergen",
        "full",
        "spectrum",
        "ultimate",
        "indoor",
        "sauna",
        "red",
        "light",
        "therapy",
        "person",
        "zoppinh"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 52,
        "safety": 52,
        "transparency": 42,
        "sustainability": 45
      },
      "price": 4999,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431024087237",
      "vsf_explanation": "Two-person full-spectrum infrared sauna (near/mid/far) with integrated red-light panel from Blisspod (vendor 'zoppinh'). Canadian hemlock cabinet with dual outdoor/indoor panels. No third-party VOC or EMF testing published and the vendor account name is unusual, though the Blisspod brand exists in the sauna retail space. Standard tier on category norms.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "red-light-therapy-hat-900-leds-for-hair-regrowth-recovery-includes-12v-car-adapter",
      "title": "Red Light Therapy Hat – 900 LEDs for Hair Regrowth & Recovery | Includes 12V Car Adapter",
      "vendor": "Red Light Pro Devices",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/RLPDHat.jpg?v=1781966618",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "light",
        "therapy",
        "hat",
        "900",
        "leds",
        "for",
        "hair",
        "regrowth",
        "recovery",
        "includes",
        "12v",
        "car",
        "adapter",
        "red",
        "light",
        "pro",
        "devices"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 55,
        "manufacturing": 52,
        "safety": 55,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 897,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431024185541",
      "vsf_explanation": "900-LED red/NIR hair-regrowth cap from Red Light Pro Devices. LLLT for androgenetic hair loss has clinical support at lower LED counts (e.g. HairMax, iRestore), but this device is not disclosed as FDA-cleared unlike its main competitors — a real gap for a hair-regrowth claim. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "2024-new-2-people-far-infrared-wooden-sauna-room-with-free-red-light-therapy-for-home",
      "title": "2024 New 2 People Far Infrared Wooden Sauna Room with Free Red Light Therapy for Home",
      "vendor": "DirectDeals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2024_New_Model_2-3_People_Far_Infrared_Wooden_Sauna_For_Home-3.jpg?v=1781966628",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "2024",
        "new",
        "people",
        "far",
        "infrared",
        "wooden",
        "sauna",
        "room",
        "with",
        "free",
        "red",
        "light",
        "therapy",
        "for",
        "home",
        "directdeals"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 7697.8,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431025627333",
      "vsf_explanation": "Two-person far-infrared wooden sauna with a bundled 660/850nm red-light panel, resold by DirectDeals. Standard hemlock cabinet with speakers/media add-ons but limited disclosure on heater EMF measurements, VOC/off-gassing testing, or safety certifications (e.g. ETL/UL). Category-standard sauna at a fair price; Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "energylounger-blanket-full-body-red-infrared-light-therapy-blanket-free-travel-carry-case",
      "title": "EnergyLounger Blanket – Full-Body Red & Infrared Light Therapy Blanket + FREE Travel carry case",
      "vendor": "EnergyLounger",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/EnergyLounger_PDP_EnergyloungerBlanket1_V1.0.jpg?v=1781966641",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "energylounger",
        "blanket",
        "full",
        "body",
        "red",
        "infrared",
        "light",
        "therapy",
        "blanket",
        "free",
        "travel",
        "carry",
        "case",
        "energylounger"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 70,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 6500,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431025660101",
      "vsf_explanation": "Full-body 660/850nm red-and-NIR therapy blanket claiming FDA clearance. Brand is a specialist recovery-blanket maker and the format has genuine utility for whole-body recovery sessions, but the 510(k) number, EMF report, and clinical validation are not published in the listing itself. Priced meaningfully above competitor Higher Dose blanket without clearly differentiated specs. Upper Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "multi-frequency-vibration-led-red-light-eye-care-therapy-ems-massage-eye-care-electric-vibration-massager-for-sale",
      "title": "Multi Frequency Vibration Led Red Light Eye Care Therapy Ems Massage Eye Care Electric Vibration Massager For Sale",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/A85135D564C026FD99D944D665C6154E.jpg?v=1781966655",
      "score": 33,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "multi",
        "frequency",
        "vibration",
        "led",
        "red",
        "light",
        "eye",
        "care",
        "therapy",
        "ems",
        "massage",
        "eye",
        "care",
        "electric",
        "vibration",
        "massager",
        "for",
        "sale",
        "digital",
        "presence"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 30,
        "safety": 45,
        "transparency": 25,
        "sustainability": 35
      },
      "price": 84.86,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431025823941",
      "vsf_explanation": "Generic model ST-202 eye massager (red-light + vibration + EMS) sold by an unnamed reseller with no manufacturer identity, no clearance, and no clinical evidence for combined EMS at the ocular region — which carries real safety concerns. Rejected on brand provenance.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "red-nova-light-premium-5000-full-body-red-light-therapy-panel-660nm-850nm-5-7-week-delivery",
      "title": "Red Nova Light Premium 5000 – Full Body Red Light Therapy Panel (660nm - 850nm) 5-7 Week Delivery",
      "vendor": "Red Nova Lights LLC",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/50006.png?v=1781966664",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "nova",
        "light",
        "premium",
        "5000",
        "full",
        "body",
        "red",
        "light",
        "therapy",
        "panel",
        "660nm",
        "850nm",
        "week",
        "delivery",
        "red",
        "nova",
        "lights",
        "llc"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 68,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 3899,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431026053317",
      "vsf_explanation": "RNL5000 is a large 960-LED 5-wavelength (630/660/810/830/850nm) full-body panel from Red Nova Lights, a specialist US brand. Spec sheet is respectable and coverage is genuine full-body, but no FDA clearance, EMF report, or independent irradiance verification is published, and 5–7 week lead time signals overseas manufacturing. Solid Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "weyais-red-light-therapy-red-light-therapy-for-face-7-colors-facial-led-light-therapy-face-maskspa-equipment-for-skincare-at-home",
      "title": "weyais Red-Light-Therapy Red Light Therapy for Face 7 Colors Facial Led Light Therapy Face MaskSPA Equipment for Skincare at Home",
      "vendor": "EasyOptionXY",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1edeae744faf92482b75923fedaf.jpg?v=1781966683",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "weyais",
        "red",
        "light",
        "therapy",
        "red",
        "light",
        "therapy",
        "for",
        "face",
        "colors",
        "facial",
        "led",
        "light",
        "therapy",
        "face",
        "maskspa",
        "equipment",
        "for",
        "skincare",
        "home",
        "easyoptionxy"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 45,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 35,
        "sustainability": 42
      },
      "price": 120.46,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431026086085",
      "vsf_explanation": "7-color LED face mask branded 'weyais' and sold via a dropship storefront. Reads as a generic Alibaba white-label product with vague specs and no clearance, irradiance, or safety data. Blue-light + broad multi-color-LED marketing is largely non-evidence-based. Rejected on provenance and evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "infrared-red-light-therapy-wrap-660nm-led-red-light-850nm-near-infrared-light-wearable-flexible-deep-therapy-light-belt-for-muscle-pain-relief",
      "title": "Infrared Red Light Therapy Wrap 660nm LED Red Light 850nm Near Infrared Light Wearable Flexible Deep Therapy Light Belt for Muscle Pain Relief",
      "vendor": "Best Product Finds",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/FFF-GPCT4139.jpg?v=1781966698",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "infrared",
        "red",
        "light",
        "therapy",
        "wrap",
        "660nm",
        "led",
        "red",
        "light",
        "850nm",
        "near",
        "infrared",
        "light",
        "wearable",
        "flexible",
        "deep",
        "therapy",
        "light",
        "belt",
        "for",
        "muscle",
        "pain",
        "relief",
        "best",
        "product",
        "finds"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 44,
        "formulation": 45,
        "manufacturing": 40,
        "safety": 52,
        "transparency": 35,
        "sustainability": 42
      },
      "price": 72.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431026118853",
      "vsf_explanation": "Small 15-LED wrap resold under a generic 'Best Product Finds' storefront. Only 9 red + 6 NIR LEDs is too few to deliver meaningful irradiance across a muscle group at recognized clinical dosing, and no manufacturer or model is disclosed. Falls into Rejected tier on evidence, dosing, and provenance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pedete-red-light-therapy-panel-for-face-body-relieve-pain-improve-skin-sleep-high-power-led-light-630-660-810-850-940nm",
      "title": "PEDETE Red Light Therapy Panel for Face & Body | Relieve Pain, Improve Skin & Sleep, High Power LED Light (630/660/810/850/940Nm)",
      "vendor": "BazaarBox",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2d0c6c2fddafd369718000613ccd719c.jpg?v=1781966711",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pedete",
        "red",
        "light",
        "therapy",
        "panel",
        "for",
        "face",
        "body",
        "relieve",
        "pain",
        "improve",
        "skin",
        "sleep",
        "high",
        "power",
        "led",
        "light",
        "630",
        "660",
        "810",
        "850",
        "940nm",
        "bazaarbox"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 185.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431026315461",
      "vsf_explanation": "PEDETE-branded 5-wavelength LED panel sold via BazaarBox dropshipper. Product body is essentially an embedded TikTok CDN image with no measured irradiance, clearance data, or manufacturer contact. Generic Alibaba-tier device — falls short of Standard on transparency and manufacturer accountability.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "open-box-aldious-near-infrared-red-light-device-for-knee-660nm-850nm-led-red-light-therapy-knee-wrap-wearable-redlight-knee-brace-for-women-men",
      "title": "Open Box ALDIOUS Near Infrared & Red Light Device for Knee, 660nm & 850nm LED Red-Light-Therapy Knee Wrap, Wearable Redlight Knee Brace for Women Men",
      "vendor": "Selzalot",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/rn-image_picker_lib_temp_37893819-d61c-41de-8f07-8bc340ff9483.jpg?v=1781966723",
      "score": 47,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "open",
        "box",
        "aldious",
        "near",
        "infrared",
        "red",
        "light",
        "device",
        "for",
        "knee",
        "660nm",
        "850nm",
        "led",
        "red",
        "light",
        "therapy",
        "knee",
        "wrap",
        "wearable",
        "redlight",
        "knee",
        "brace",
        "for",
        "women",
        "men",
        "selzalot"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 70,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431026413765",
      "vsf_explanation": "Open-box knee wrap resold via Selzalot dropship account. ALDIOUS is a low-cost Amazon marketplace brand with minimal published provenance, and the open-box condition further weakens QA assurance. Dual 660/850nm design is workable but manufacturing and transparency are too thin to score into Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "red-light-therapy-for-body-face-60-dual-chip-leds-red-660nm-near-infrared-850nm-combo-high-power-red-light-therapy-panel-for-recovery-pain-relief-wound-healing-skin-health-80w",
      "title": "Red Light Therapy for Body Face, 60 Dual-Chip LEDs, Red 660nm & Near Infrared 850nm Combo, High Power Red Light Therapy Panel for Recovery, Pain Relief, Wound Healing, Skin Health, 80W",
      "vendor": "VYSN",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d0102haju6t.jpg?v=1781966755",
      "score": 51,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "light",
        "therapy",
        "for",
        "body",
        "face",
        "dual",
        "chip",
        "leds",
        "red",
        "660nm",
        "near",
        "infrared",
        "850nm",
        "combo",
        "high",
        "power",
        "red",
        "light",
        "therapy",
        "panel",
        "for",
        "recovery",
        "pain",
        "relief",
        "wound",
        "healing",
        "skin",
        "health",
        "80w",
        "vysn"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 119.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431026610373",
      "vsf_explanation": "60-LED 660/850nm 80W panel described inline as a VEVOR device but sold by VYSN reseller — vendor/manufacturer confusion is a transparency flag. Claimed 100 mW/cm² at 6\" is in range for this size but no independent test data or FDA registration is provided. Standard, low.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "the-mask",
      "title": "The Mask",
      "vendor": "Renew Red Light",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/renew_peerspaceround2.jpg?v=1781966775",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "the",
        "mask",
        "renew",
        "red",
        "light"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 349,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431026643141",
      "vsf_explanation": "Multi-wavelength LED face mask (red / near-IR / blue / orange) from Renew Red Light. Marketing is aggressive on acne, wrinkle and hyperpigmentation claims but no clinical data, irradiance measurement or FDA clearance is disclosed. Generic OEM-style device at a mid price; Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "evedia-ion-led-face-mask-double-infrared",
      "title": "EVEDIA ION: LED Face-mask (Double Infrared)",
      "vendor": "EVEDIA",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/EVEDIA_Mask_Hero_Red_v1-01.jpg?v=1781966786",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "evedia",
        "ion",
        "led",
        "face",
        "mask",
        "double",
        "infrared",
        "evedia"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 249.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431026675909",
      "vsf_explanation": "EVEDIA ION LED face mask covering four wavelengths (415nm blue, 660nm red, 830 and 850nm near-infrared). EVEDIA is a recognized consumer LED beauty brand with dermatologist-adjacent styling. No FDA clearance disclosed for this SKU and irradiance test data is absent, but the multi-wavelength design and named-brand provenance put it above white-label rivals. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "helio-glow",
      "title": "Helio Glow",
      "vendor": "Helio Cure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/helio-glow-image.jpg?v=1781966812",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "helio",
        "glow",
        "helio",
        "cure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 20,
        "manufacturing": 35,
        "safety": 40,
        "transparency": 25,
        "sustainability": 25
      },
      "price": 1199,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431026708677",
      "vsf_explanation": "Red-light therapy panel, not a supplement. Photobiomodulation has some RCT evidence (Hamblin 2017 review) but this SKU is a hardware device miscategorized as supplement.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "helio-nova",
      "title": "Helio Nova",
      "vendor": "Helio Cure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/helio-nova-image.jpg?v=1781966835",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "helio",
        "nova",
        "helio",
        "cure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 20,
        "manufacturing": 35,
        "safety": 40,
        "transparency": 25,
        "sustainability": 25
      },
      "price": 4999,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431026839749",
      "vsf_explanation": "Full-body red-light therapy panel. Hardware device, not a supplement.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "red-light-pain-relief-kit-5-devices-for-full-body-relief",
      "title": "Red Light Pain Relief Kit – 5 Devices for Full-Body Relief",
      "vendor": "Red Light Pro Devices",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/recovery_kit_1st.jpg?v=1781966860",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "light",
        "pain",
        "relief",
        "kit",
        "devices",
        "for",
        "full",
        "body",
        "relief",
        "red",
        "light",
        "pro",
        "devices"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 2539,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431026872517",
      "vsf_explanation": "Five-device dual-wavelength bundle from Red Light Pro Devices (large 27\" pad plus supporting devices). Kit format is genuinely useful for whole-body targeting, but the brand does not publish FDA clearance, EMF testing, or third-party irradiance data. Priced steeply for what appears to be OEM-sourced pads bundled together. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "helio-blaze",
      "title": "Helio Blaze",
      "vendor": "Helio Cure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/helio-blaze-image.jpg?v=1781966888",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "helio",
        "blaze",
        "helio",
        "cure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 20,
        "manufacturing": 35,
        "safety": 40,
        "transparency": 25,
        "sustainability": 25
      },
      "price": 2799,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431026938053",
      "vsf_explanation": "Whole-body red-light therapy panel. Hardware device, not a supplement.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "medium-red-light-pad-for-pain-relief-recovery-16-x-11-1188-leds-12v-car-adapter",
      "title": "Medium Red Light Pad for Pain Relief & Recovery | 16\" x 11\" | 1188 LEDs + 12V Car Adapter",
      "vendor": "Red Light Pro Devices",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/medium_pad.jpg?v=1781966920",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "medium",
        "red",
        "light",
        "pad",
        "for",
        "pain",
        "relief",
        "recovery",
        "1188",
        "leds",
        "12v",
        "car",
        "adapter",
        "red",
        "light",
        "pro",
        "devices"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 697,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431027134661",
      "vsf_explanation": "1,188-LED dual-wavelength 16\"x11\" flexible pad from Red Light Pro Devices — a step up in coverage from the 3-in-1 pad. No FDA clearance or independent irradiance test data disclosed. Reasonable specs for a mid-price recovery pad; Standard tier due to transparency gaps.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "general-pain-relief-kit",
      "title": "General Pain Relief Kit",
      "vendor": "Your Health Sanctuary",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/01_3.jpg?v=1781966948",
      "score": 74,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "general",
        "pain",
        "relief",
        "kit",
        "your",
        "health",
        "sanctuary"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 72,
        "manufacturing": 75,
        "safety": 75,
        "transparency": 70,
        "sustainability": 65
      },
      "price": 2040,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431028248773",
      "vsf_explanation": "HealthLight-branded kit resold by Your Health Sanctuary; HealthLight is one of the few home red-light manufacturers with genuine FDA 510(k) clearances for pain and circulation indications and is used in chiropractic and clinical settings. Multi-pad kit provides real full-body coverage with medically-cleared dosing. Priced premium and sustainability disclosure is thin, but clearance status and manufacturing provenance are among the strongest in the category. Verified tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "red-light-3-in-1-pad-pain-relief-recovery-540-leds-12v-car-adapter",
      "title": "Red Light 3-in-1 Pad – Pain Relief & Recovery | 540 LEDs + 12V Car Adapter",
      "vendor": "Red Light Pro Devices",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/RedLightProDevices_small_pad_with_knee_pad_shoulder_pad_f972fae0-0c17-4286-a5cd-117f3e46a32c.jpg?v=1781966964",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "light",
        "pad",
        "pain",
        "relief",
        "recovery",
        "540",
        "leds",
        "12v",
        "car",
        "adapter",
        "red",
        "light",
        "pro",
        "devices"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 447,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431028379845",
      "vsf_explanation": "540-LED dual-wavelength (660/850nm) flexible pad with three interchangeable form-factor covers (rectangle, knee, shoulder) from Red Light Pro Devices. No FDA clearance or third-party irradiance verification is cited, and the brand doesn't publish clinical data. Solid mid-tier consumer recovery pad; Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "professional-3-d-silicone-led-facial-mask",
      "title": "Professional 3-D Silicone LED Facial Mask",
      "vendor": "Lavender Life Company",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ad-simple-relaxing-moment-1769868096498.jpg?v=1781966989",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "professional",
        "silicone",
        "led",
        "facial",
        "mask",
        "lavender",
        "life",
        "company"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 290,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431028445381",
      "vsf_explanation": "Silicone LED face mask with 320 diodes across four wavelengths (red 660nm, near-IR, blue, yellow, green). Wavelength science for LED skin treatment is real, but no FDA clearance is disclosed and Lavender Life Company is a generic reseller with no manufacturer provenance. Reads as a repackaged white-label device — Standard tier due to thin transparency and manufacturing disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "the-wrap",
      "title": "The Wrap",
      "vendor": "Renew Red Light",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/The_Wrap_-_Golf-31.jpg?v=1781967010",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "the",
        "wrap",
        "renew",
        "red",
        "light"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 20,
        "manufacturing": 35,
        "safety": 40,
        "transparency": 25,
        "sustainability": 25
      },
      "price": 179,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431028576453",
      "vsf_explanation": "Cordless red-light therapy wrap. Hardware device, not a supplement.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "light-therapy-face-mask",
      "title": "Light Therapy Face Mask",
      "vendor": "Happy Sol Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Sol_Light_Therapy_Face_Mask_01.jpg?v=1781967058",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "light",
        "therapy",
        "face",
        "mask",
        "happy",
        "sol",
        "wellness"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 54.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431028773061",
      "vsf_explanation": "Consumer LED face mask with red (630nm), blue (470nm), and other color channels aimed at collagen/acne/pigmentation. There is real evidence for at-home red and blue LED therapy in skin applications, but this unit has no irradiance disclosure, no FDA clearance for skin conditions, and Happy Sol Wellness is a boutique wellness brand with limited engineering transparency. Standard - honest for what it is (a skin-focused LED mask, not a photobiomodulation panel for recovery).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "neck-and-shoulder-massager-with-heat",
      "title": "Neck and shoulder massager with heat",
      "vendor": "SmartPursue™",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/S24e3d1b8020e452fa10c0cd783d8dbc67.jpg?v=1781967102",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "neck",
        "and",
        "shoulder",
        "massager",
        "with",
        "heat",
        "smartpursue"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "percussion_vibration"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 74.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431028904133",
      "vsf_explanation": "Consumer neck/shoulder shiatsu massager with heat sold under SmartPursue, a dropshipper. Copy makes hard clinical claims - \"Expert-Recommended for Shoulder Arthritis and Impingement,\" chronic pain cures, rotator cuff injury treatment - without any clearance or evidence. No manufacturer or model number is disclosed.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "nova-6-sauna-tent-6-person-portable-sauna",
      "title": "Nova 6 Sauna Tent | 6-person portable sauna",
      "vendor": "North Shore Sauna",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nova_6.png?v=1781967147",
      "score": 73,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nova",
        "sauna",
        "tent",
        "person",
        "portable",
        "sauna",
        "north",
        "shore",
        "sauna"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 76,
        "manufacturing": 74,
        "safety": 72,
        "transparency": 68,
        "sustainability": 72
      },
      "price": 899,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431029264581",
      "vsf_explanation": "Mid-size 6-person tent sauna from North Shore Sauna, 7.5' x 9' floor, wood-stove heated to 200F+ in 30 minutes. Real Finnish-style heat with the health evidence base that goes with it, from a legitimate Duluth-based maker. Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-cover-for-nova-4-sauna-tent",
      "title": "Full Cover for Nova 4 Sauna Tent",
      "vendor": "North Shore Sauna",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/IMG_7917-resized.jpg?v=1781967166",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "cover",
        "for",
        "nova",
        "sauna",
        "tent",
        "north",
        "shore",
        "sauna"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 64.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431029625029",
      "vsf_explanation": "A rain cover accessory for the Nova 4 sauna tent - useful for the tent owner but not a health-tech or biohacking product on its own. Out of scope for the Vyvata scoring rubric.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "dome-sauna-tent-8-person-portable-sauna",
      "title": "Dome Sauna Tent | 8-person portable sauna",
      "vendor": "North Shore Sauna",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Dome.png?v=1781967182",
      "score": 74,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dome",
        "sauna",
        "tent",
        "person",
        "portable",
        "sauna",
        "north",
        "shore",
        "sauna"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 78,
        "manufacturing": 76,
        "safety": 72,
        "transparency": 70,
        "sustainability": 72
      },
      "price": 1827.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431029756101",
      "vsf_explanation": "North Shore Sauna is a real Duluth, MN-based tent-sauna maker with a strong following in the Nordic sauna community. 8+ person hexagonal wood-stove tent designed for real Finnish sauna heat (200F+), dual chimney ports, cold-weather rated. Traditional-sauna evidence base applies. Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "portable-full-body-sauna-box",
      "title": "Portable Full Body Sauna Box",
      "vendor": "Anti Spier",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5TBYvjUkHe2elq7Z.webp?v=1781967241",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "portable",
        "full",
        "body",
        "sauna",
        "box",
        "anti",
        "spier"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 424.87,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431030345925",
      "vsf_explanation": "Generic portable sauna box under an unrecognizable \"Anti Spier\" brand with a five-line description and no manufacturer, model, heater spec, or EMF data. No brand provenance and insufficient safety documentation for a plugged-in heating device.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "low-emf-far-infrared-negative-ion-portable-sauna",
      "title": "Low EMF Far Infrared Negative Ion Portable Sauna",
      "vendor": "PlayMakar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_d8cd64f3-cda1-45cb-800c-dd4e67234ee9.jpg?v=1781967269",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "low",
        "emf",
        "far",
        "infrared",
        "negative",
        "ion",
        "portable",
        "sauna",
        "playmakar"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 65,
        "safety": 68,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 549.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431031034053",
      "vsf_explanation": "PlayMakar-branded portable FIR sauna tent with 4 low-EMF carbon panels, heated foot pad, and a foldable chair. Real recovery brand and lowest-EMF claim in the portable-sauna segment. Standard-high; negative ion marketing is unsupported.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "portable-personal-steam-sauna-spa-with-steamer-chair-black",
      "title": "Portable Personal Steam Sauna Spa with Steamer Chair-Black",
      "vendor": "DirectDeals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/personal_steam_sauna_spa_with_steamer_chair_black-3.jpg?v=1781967289",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "portable",
        "personal",
        "steam",
        "sauna",
        "spa",
        "with",
        "steamer",
        "chair",
        "black",
        "directdeals"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 174.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431031165125",
      "vsf_explanation": "Cheap portable steam sauna spa (800W steamer, waterproof fabric tent) resold by DirectDeals with no named manufacturer. Delivers actual steam heat but at low-tier build quality and durability. Standard-low.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "personal-home-steam-sauna-traditional-5™",
      "title": "Personal Home Steam Sauna | Traditional 5™",
      "vendor": "Modern Reform",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Traditional-Sauna5-3wall-Removal-Bench-Transparent-01.png?v=1781967305",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "personal",
        "home",
        "steam",
        "sauna",
        "traditional",
        "modern",
        "reform"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 73,
        "formulation": 74,
        "manufacturing": 75,
        "safety": 72,
        "transparency": 62,
        "sustainability": 65
      },
      "price": 4999,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431031230661",
      "vsf_explanation": "Personal (1-person) traditional Finnish steam sauna from Medical Saunas. Same premium build quality as the larger Traditional models. Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mande-sauna-mw12-thermowood-for-your-perfect-backyard-retreat",
      "title": "Mande Sauna MW12 ThermoWood for Your Perfect Backyard Retreat",
      "vendor": "Patio Elegance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/mw12_1.png?v=1781967319",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mande",
        "sauna",
        "mw12",
        "thermowood",
        "for",
        "your",
        "perfect",
        "backyard",
        "retreat",
        "patio",
        "elegance"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 72,
        "safety": 65,
        "transparency": 55,
        "sustainability": 68
      },
      "price": 5499,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431031263429",
      "vsf_explanation": "Smaller sibling of the MW16 - outdoor ThermoWood sauna with the same durable construction. Heater type/EMF not disclosed in the excerpt; ThermoWood keeps sustainability high. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "portable-sauna-tent-with-heating-foot-pad-and-portable-chair",
      "title": "Portable Sauna Tent with Heating Foot Pad and Portable Chair",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/portable-sauna-tent-with-heating-foot-pad-and-portable-chair-wellness-dailysale-948129.jpg?v=1781967328",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "portable",
        "sauna",
        "tent",
        "with",
        "heating",
        "foot",
        "pad",
        "and",
        "portable",
        "chair",
        "dailysale"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 299,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431031394501",
      "vsf_explanation": "Generic portable sauna tent resold by a generic reseller with no named manufacturer or model number, and copy that overreaches into treating insomnia, depression, and skin conditions. Fails on brand provenance and health-claim credibility.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "3-5-people-far-infrared-wooden-sauna-room-for-home",
      "title": "3-5 People Far Infrared Wooden Sauna Room for Home",
      "vendor": "DirectDeals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Far_Infrared_Wooden_Sauna_Room-size-3.jpg?v=1781967340",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "people",
        "far",
        "infrared",
        "wooden",
        "sauna",
        "room",
        "for",
        "home",
        "directdeals"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 21775.6,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431031460037",
      "vsf_explanation": "Larger 3-5 person FIR cabin from DirectDeals with 7-color chromotherapy and a detachable 660/850nm red-light panel. Price is well above peers and manufacturer is unnamed, but the equipment set is legitimate for the category. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "3-person-home-steam-sauna-traditional-7™",
      "title": "3 Person Home Steam Sauna | Traditional 7™",
      "vendor": "Modern Reform",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2_b692b631-e6d4-4e79-8667-68d22e8993d1.png?v=1781967352",
      "score": 73,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "person",
        "home",
        "steam",
        "sauna",
        "traditional",
        "modern",
        "reform"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 76,
        "manufacturing": 76,
        "safety": 72,
        "transparency": 62,
        "sustainability": 65
      },
      "price": 12199,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431031525573",
      "vsf_explanation": "3-person traditional (Finnish steam) sauna from Medical Saunas via Modern Reform. Traditional saunas carry the deepest evidence base for cardiovascular and mortality risk reduction. Solid Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "2-person-home-stream-sauna-traditional-6™",
      "title": "2 Person Home Stream Sauna | Traditional 6™",
      "vendor": "Modern Reform",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8_c7a73018-4f91-4dca-be66-1fd4e5d160f9.png?v=1781967368",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "person",
        "home",
        "stream",
        "sauna",
        "traditional",
        "modern",
        "reform"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 74,
        "formulation": 75,
        "manufacturing": 76,
        "safety": 72,
        "transparency": 62,
        "sustainability": 65
      },
      "price": 9199,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431032148165",
      "vsf_explanation": "Medical Saunas Traditional 6 - a real Finnish-style steam (Löyly) sauna, 2-person, hemlock cabinet. Traditional saunas actually have the strongest RCT/cohort literature for cardiovascular benefit (Laukkanen studies). Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "3-person-home-infrared-sauna-medical-5™",
      "title": "3 Person Home Infrared Sauna | Medical 5™",
      "vendor": "Modern Reform",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/10.jpg?v=1781967380",
      "score": 73,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "person",
        "home",
        "infrared",
        "sauna",
        "medical",
        "modern",
        "reform"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 78,
        "manufacturing": 76,
        "safety": 75,
        "transparency": 65,
        "sustainability": 65
      },
      "price": 7199,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431032180933",
      "vsf_explanation": "Medical Saunas 3-person full-spectrum sauna. Consistent quality with the rest of the Medical Saunas line; suits couples/families and preserves the full-spectrum benefit profile. Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mande-mw16-thermowood-outdoor-sauna-premium-outdoor-relaxation-experience",
      "title": "Mande MW16 ThermoWood Outdoor Sauna - Premium Outdoor Relaxation Experience",
      "vendor": "Patio Elegance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/mw16_1_ec4e8bbd-1246-40d1-9f53-5e2279d913d3.png?v=1781967394",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mande",
        "mw16",
        "thermowood",
        "outdoor",
        "sauna",
        "premium",
        "outdoor",
        "relaxation",
        "experience",
        "patio",
        "elegance"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 72,
        "safety": 65,
        "transparency": 55,
        "sustainability": 68
      },
      "price": 6399,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431032312005",
      "vsf_explanation": "Outdoor traditional-style sauna in thermally modified (ThermoWood) hemlock/spruce sold through Patio Elegance. Heater choice, EMF spec, and stove details are not listed in this excerpt; ThermoWood construction is durable and low-VOC. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "personal-home-infrared-full-spectrum-sauna-medical-3™",
      "title": "Personal Home Infrared Full Spectrum Sauna | Medical 3™",
      "vendor": "Modern Reform",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/00.jpg?v=1781967421",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "personal",
        "home",
        "infrared",
        "full",
        "spectrum",
        "sauna",
        "medical",
        "modern",
        "reform"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 76,
        "manufacturing": 76,
        "safety": 75,
        "transparency": 65,
        "sustainability": 65
      },
      "price": 3199,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431032606917",
      "vsf_explanation": "Medical Saunas Medical 3 single-person full-spectrum cabin. Same premium-brand construction as the larger units, rapid-heat system, well-suited for individual use. Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "drip-sweat-portable-infrared-sauna-blanket",
      "title": "Drip Sweat Portable Infrared Sauna Blanket",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/drip-sweat-portable-infrared-sauna-blanket-your-solution-for-weight-loss-and-wellness-wlcmvs17-847970.jpg?v=1781967454",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "drip",
        "sweat",
        "portable",
        "infrared",
        "sauna",
        "blanket",
        "cavitation",
        "machines"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 310,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431033229509",
      "vsf_explanation": "Single-zone Drip Sweat sauna blanket with carbon fiber heating wire and claimed low-EMF output. Standard consumer-grade blanket for passive heat therapy; no third-party EMF/emissivity data. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "drip-sweat-3-zone-infrared-sauna-blanket",
      "title": "Drip Sweat 3-Zone Infrared Sauna Blanket",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/drip-sweat-3-zone-sauna-blanket-for-weight-loss-and-detox-with-built-in-infrared-spa-technology-wcmkydb020-863626.jpg?v=1781967465",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "drip",
        "sweat",
        "zone",
        "infrared",
        "sauna",
        "blanket",
        "cavitation",
        "machines"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 499.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431033262277",
      "vsf_explanation": "Three-zone FIR sauna blanket with independent per-zone heat control - a genuine feature upgrade over single-zone blankets. Cavitation Machines is a niche wellness distributor; construction, EMF, and materials disclosure are modest but acceptable. Standard-high.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "1-person-carbon-infrared-sauna-canadian-hemlock-wooden-sauna-760-watts",
      "title": "1-Person Carbon Infrared Sauna - Canadian Hemlock Wooden Sauna - 760 Watts",
      "vendor": "PlayMakar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/DWS-IR-1P_1_43bff053-4f70-431f-8e2a-16391c10f7c9.jpg?v=1781967478",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "person",
        "carbon",
        "infrared",
        "sauna",
        "canadian",
        "hemlock",
        "wooden",
        "sauna",
        "760",
        "watts",
        "playmakar"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 72,
        "safety": 70,
        "transparency": 60,
        "sustainability": 65
      },
      "price": 2299.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431033426117",
      "vsf_explanation": "Durasage-manufactured 1-person carbon FIR cabin distributed via PlayMakar, a known recovery-tools brand. 3-panel FIR only (no near-IR), Canadian hemlock, LED controls, 12-month warranty. Solid entry-level home sauna; Standard-plus, just short of Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "2-person-home-full-spectrum-infrared-sauna-medical-4™",
      "title": "2 Person Home Full Spectrum Infrared Sauna | Medical 4™",
      "vendor": "Modern Reform",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Med-full-Sprectrum-4v2-WB-Renders-00.webp?v=1781967487",
      "score": 73,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "person",
        "home",
        "full",
        "spectrum",
        "infrared",
        "sauna",
        "medical",
        "modern",
        "reform"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 78,
        "manufacturing": 76,
        "safety": 75,
        "transparency": 65,
        "sustainability": 65
      },
      "price": 5199,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431033491653",
      "vsf_explanation": "Medical Saunas Medical 4 full-spectrum 2-person unit sold via Modern Reform. Full-spectrum (near/mid/far) heaters, rapid-heat design, established brand in the premium sauna segment. \"Designed by doctors\" is a marketing frame (no device clearance), not a rejection trigger. Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "blisspod-vienna-far-infrared-sauna-canadian-hemlock-very-low-emf-sauna-4-heaters-2-persons",
      "title": "Blisspod, Vienna, Far Infrared Sauna Canadian Hemlock Very Low EMF Sauna, 4 Heaters – 2 Persons",
      "vendor": "zoppinh",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign-4copy_b8a8aeab-18d0-4f64-8359-18567dacc401.png?v=1781967498",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "blisspod",
        "vienna",
        "far",
        "infrared",
        "sauna",
        "canadian",
        "hemlock",
        "very",
        "low",
        "emf",
        "sauna",
        "heaters",
        "persons",
        "zoppinh"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 74,
        "manufacturing": 76,
        "safety": 76,
        "transparency": 62,
        "sustainability": 65
      },
      "price": 2999,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431033524421",
      "vsf_explanation": "2-person FIR sauna with 4 low-EMF carbon panels, hemlock construction, no toxic glues. Priced fairly for the category, safe for daily use, credible recovery use case. Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "blisspod-vienna-corner-spacious-far-infrared-sauna-canadian-hemlock-ultra-low-emf-12-heaters-4-5-persons",
      "title": "Blisspod, Vienna, Corner Spacious Far Infrared Sauna Canadian Hemlock Ultra Low EMF, 12 Heaters, 4-5 Persons",
      "vendor": "zoppinh",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign-8_fa435e24-1f69-48fd-8dfd-11e01f188ccf.png?v=1781967506",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "blisspod",
        "vienna",
        "corner",
        "spacious",
        "far",
        "infrared",
        "sauna",
        "canadian",
        "hemlock",
        "ultra",
        "low",
        "emf",
        "heaters",
        "persons",
        "zoppinh"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 75,
        "manufacturing": 78,
        "safety": 78,
        "transparency": 62,
        "sustainability": 65
      },
      "price": 4999,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431033721029",
      "vsf_explanation": "Large corner-fit 4-5 person FIR sauna with 12 carbon heaters, ultra-low EMF, Canadian hemlock, no toxic glues. Great value for the size and consistent with the Blisspod Vienna quality baseline. Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "blisspod-vienna-far-infrared-sauna-canadian-hemlock-very-low-emf-72-8h-x-35-4w-x-25-6d-1-person",
      "title": "Blisspod | Vienna | Far Infrared Sauna | Canadian Hemlock Very Low EMF | 72.8\"H x 35.4\"W x 25.6\"D | 1 Person",
      "vendor": "zoppinh",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Vienna_4.png?v=1781967516",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "blisspod",
        "vienna",
        "far",
        "infrared",
        "sauna",
        "canadian",
        "hemlock",
        "very",
        "low",
        "emf",
        "person",
        "zoppinh"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 72,
        "manufacturing": 75,
        "safety": 75,
        "transparency": 62,
        "sustainability": 65
      },
      "price": 2179,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431033852101",
      "vsf_explanation": "Single-person FIR cabin sauna built from Canadian hemlock with certified very-low EMF carbon panels. Well-constructed at the price and safe for daily use; solid evidence base for infrared sauna's cardiovascular and recovery benefits. Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sauna-blanket-for-detoxification-portable-far-infrared-sauna-for-home-relaxation-1-6-level-adjustable-temprature-rannge-95-185-f-1-60-minutes-timer-far-infrared-carbon-heating-sauna-bag",
      "title": "Sauna Blanket for Detoxification, Portable Far Infrared Sauna for Home Relaxation, 1-6 Level Adjustable Temprature Rannge 95-185°F , 1-60 Minutes Timer, Far Infrared Carbon Heating Sauna Bag",
      "vendor": "VYSN",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d0102hqnvmw.jpg?v=1781967525",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sauna",
        "blanket",
        "for",
        "detoxification",
        "portable",
        "far",
        "infrared",
        "sauna",
        "for",
        "home",
        "relaxation",
        "level",
        "adjustable",
        "temprature",
        "rannge",
        "185",
        "minutes",
        "timer",
        "far",
        "infrared",
        "carbon",
        "heating",
        "sauna",
        "bag",
        "vysn"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 258.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431034212549",
      "vsf_explanation": "Basic VYSN carbon-fiber sauna blanket with armhole design, same 95-185F range, no therapy-stone layer. Consumer-tier heat therapy that plausibly delivers passive sweating benefits; \"detox\" framing is marketing overreach. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "tatalife-portable-1-2-person-infrared-saunas-for-home-full-spectrum-infrared-sauna-full-size-large-space-spa-2-portable-upgrade-chair-oversize-full-body-home-sauna-spa-for-relaxation-detox",
      "title": "TaTalife Portable 1-2 Person Infrared Saunas for Home, Full Spectrum Infrared Sauna, Full Size Large Space Spa, 2 Portable Upgrade Chair, Oversize Full Body Home Sauna Spa for Relaxation & Detox",
      "vendor": "Selzalot",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/B1CDFEF1-2E54-47CA-801F-C5BBFB732542.jpg?v=1781967535",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tatalife",
        "portable",
        "person",
        "infrared",
        "saunas",
        "for",
        "home",
        "full",
        "spectrum",
        "infrared",
        "sauna",
        "full",
        "size",
        "large",
        "space",
        "spa",
        "portable",
        "upgrade",
        "chair",
        "oversize",
        "full",
        "body",
        "home",
        "sauna",
        "spa",
        "for",
        "relaxation",
        "detox",
        "selzalot"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 35,
        "safety": 40,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 100,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431034245317",
      "vsf_explanation": "Open-box portable sauna missing remote, lamp, and heating pads per the listing itself - it cannot deliver the advertised therapy in its current state. TaTalife is a generic Amazon-tier brand resold by Selzalot with no verifiable manufacturer disclosure.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "sauna-blanket-for-detoxification-portable-far-infrared-sauna-for-home-pu-sauna-bag-w-therapy-stones-carbon-fiber-heating-1-6-level-adjustable-temp-95-185-f-1-60-minutes-timer-75-x-35in",
      "title": "Sauna Blanket for Detoxification, Portable Far Infrared Sauna for Home, PU Sauna Bag w/ Therapy Stones & Carbon Fiber Heating, 1-6 Level Adjustable Temp 95-185°F , 1-60 Minutes Timer, 75 x 35in",
      "vendor": "VYSN",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d0102hqnvw7.jpg?v=1781967544",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sauna",
        "blanket",
        "for",
        "detoxification",
        "portable",
        "far",
        "infrared",
        "sauna",
        "for",
        "home",
        "sauna",
        "bag",
        "therapy",
        "stones",
        "carbon",
        "fiber",
        "heating",
        "level",
        "adjustable",
        "temp",
        "185",
        "minutes",
        "timer",
        "35in",
        "vysn"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 390.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431034278085",
      "vsf_explanation": "Consumer FIR sauna blanket with jade-stone lining, 6-level heat control, and 95-185F range from VYSN, a general home-goods brand. Marketed for detox/metabolism which overstates the mechanism; heat and sweat benefits themselves are plausible. Standard, PU liner rather than a lower-VOC alternative caps sustainability.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "far-infrared-wooden-sauna-room-with-bluetooth-speakers-and-oxygen-ionizer-for-1-2-person",
      "title": "Far Infrared Wooden Sauna Room with Bluetooth Speakers and Oxygen Ionizer for 1-2 person",
      "vendor": "DirectDeals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/far_infrared_wooden_sauna_room-2.jpg?v=1781967556",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "far",
        "infrared",
        "wooden",
        "sauna",
        "room",
        "with",
        "bluetooth",
        "speakers",
        "and",
        "oxygen",
        "ionizer",
        "for",
        "person",
        "directdeals"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 3309.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431034310853",
      "vsf_explanation": "Mid-tier 1-2 person FIR wooden sauna resold by DirectDeals. Nine carbon heaters plus Bluetooth/ionizer extras are typical for the segment; no branded manufacturer, EMF data, or third-party emissivity testing provided. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "6-person-indoor-infrared-full-spectrum-sauna-medical-6-plus™",
      "title": "6 Person Indoor Infrared Full Spectrum Sauna | Medical 6 Plus™",
      "vendor": "Modern Reform",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6_18ab02f4-8163-41b7-a3c7-dd62c15cab36.webp?v=1781967566",
      "score": 74,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "person",
        "indoor",
        "infrared",
        "full",
        "spectrum",
        "sauna",
        "medical",
        "plus",
        "modern",
        "reform"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 80,
        "manufacturing": 78,
        "safety": 75,
        "transparency": 65,
        "sustainability": 65
      },
      "price": 11999,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431034409157",
      "vsf_explanation": "Medical Saunas flagship 6-person full-spectrum cabin sold through Modern Reform. Known brand with FIR + near-IR panels, high build quality, and cardiovascular/recovery evidence for infrared sauna. \"Medical\" branding is marketing (no FDA device clearance) but construction is legitimately premium; solid Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "blisspod-milano-full-spectrum-sauna-canadian-hemlock-wood-ultra-low-emf-5-far-infrared-1-red-glass-heater-chromotherapy-upto-2-person",
      "title": "Blisspod | Milano | Full Spectrum Sauna | Canadian Hemlock Wood | Ultra Low EMF | 5 Far Infrared & 1 Red Glass Heater | Chromotherapy | Upto 2 Person",
      "vendor": "zoppinh",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Vienna_14_2048x2048_2df26b19-31f0-4d96-992a-b38568895fbd.webp?v=1781967577",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "blisspod",
        "milano",
        "full",
        "spectrum",
        "sauna",
        "canadian",
        "hemlock",
        "wood",
        "ultra",
        "low",
        "emf",
        "far",
        "infrared",
        "red",
        "glass",
        "heater",
        "chromotherapy",
        "upto",
        "person",
        "zoppinh"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 78,
        "manufacturing": 75,
        "safety": 78,
        "transparency": 65,
        "sustainability": 65
      },
      "price": 4299,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431034441925",
      "vsf_explanation": "Full-spectrum 2-person infrared sauna with Canadian hemlock cabin, five FIR heaters plus one red glass near-IR panel, ultra-low EMF claim, and chromotherapy. Infrared sauna literature supports vascular, thermoregulatory, and recovery benefits, and the build quality matches the mid-tier segment. Lands as a solid Verified given the full-spectrum specs at this price point.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "1-54-wireless-fitness-tracker",
      "title": "1.54\" Wireless Fitness Tracker",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/154-wireless-fitness-tracker-fitness-black-dailysale-823629.jpg?v=1781967638",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wireless",
        "fitness",
        "tracker",
        "dailysale"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "fitness_activity_trackers"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 30,
        "manufacturing": 30,
        "safety": 25,
        "transparency": 20,
        "sustainability": 35
      },
      "price": 33,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431034966213",
      "vsf_explanation": "Generic 1.54\" tracker resold by a generic reseller listing HR, BP, and SpO2 monitoring. No manufacturer, model number, or clearance for the BP claim. Textbook auto-fail on medical claim.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "smartwatch-fitness-tracker",
      "title": "SmartWatch + Fitness Tracker",
      "vendor": "Best Product Finds",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/eb6bc4879906cdcefcc3180c1316030d_2000x_db33641a-04cc-4f17-8f43-2332d8fee0e7.png?v=1781967647",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "smartwatch",
        "fitness",
        "tracker",
        "best",
        "product",
        "finds"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "fitness_activity_trackers"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 35,
        "manufacturing": 30,
        "safety": 25,
        "transparency": 15,
        "sustainability": 35
      },
      "price": 99.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431035523269",
      "vsf_explanation": "Copy is a verbatim clone of the HyperGear Activ8 description sold by \"Best Product Finds\" at a higher price. It compounds the same BP auto-fail with clear reseller/no-brand-provenance concerns.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "hypergear-smartwatch-fitness-tracker",
      "title": "HyperGear SmartWatch + Fitness Tracker",
      "vendor": "Jupiter Gear Home",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/eb6bc4879906cdcefcc3180c1316030d.png?v=1781967660",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hypergear",
        "smartwatch",
        "fitness",
        "tracker",
        "jupiter",
        "gear",
        "home"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "fitness_activity_trackers"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 40,
        "manufacturing": 35,
        "safety": 30,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 69.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431035654341",
      "vsf_explanation": "HyperGear Activ8 markets \"advanced heart rate, blood pressure, and blood oxygen monitoring.\" On-wrist BP without FDA clearance is an auto-fail, regardless of how many watch faces and sport modes ship alongside it.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "smartwatch-fitness-tracker-with-heart-rate-monitor",
      "title": "Smartwatch Fitness Tracker with Heart Rate Monitor",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/smartwatch-fitness-tracker-with-heart-rate-monitor-smart-watches-red-dailysale-969940.jpg?v=1781967671",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "smartwatch",
        "fitness",
        "tracker",
        "with",
        "heart",
        "rate",
        "monitor",
        "dailysale"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "fitness_activity_trackers"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 45,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 67,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431035719877",
      "vsf_explanation": "Generic 1.54\" fitness tracker resold by a third-party seller with HR, pedometer, and sleep only (no BP claim in this listing). No manufacturer name, model number, or validation data is provided. Fails on brand provenance for a health-adjacent device.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "hypergear-fit-x2-smartwatch-and-fitness-tracker",
      "title": "HyperGear FIT X2 Smartwatch and Fitness Tracker",
      "vendor": "Jupiter Gear Home",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/64e9fcd7-4da3-4267-86bf-f1238ab5ef24.png?v=1781967689",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hypergear",
        "fit",
        "smartwatch",
        "and",
        "fitness",
        "tracker",
        "jupiter",
        "gear",
        "home"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "fitness_activity_trackers"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 40,
        "manufacturing": 35,
        "safety": 30,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 35.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431035850949",
      "vsf_explanation": "HyperGear is a real accessories brand, but the FIT X2 markets SpO2, blood pressure, and stress meters without listed FDA clearance for the BP claim. On-wrist BP without a validated algorithm and clearance is the exact scenario the auto-fail rule targets.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "imosi-q8-smartwatch-stainless-steel-bt-fitness-tracker",
      "title": "IMOSI Q8 Smartwatch Stainless Steel BT Fitness Tracker",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/imosi-q8-smartwatch-stainless-steel-bt-fitness-tracker-smart-watches-silverblack-dailysale-640705.jpg?v=1781967703",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "imosi",
        "smartwatch",
        "stainless",
        "steel",
        "fitness",
        "tracker",
        "dailysale"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "fitness_activity_trackers"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 30,
        "manufacturing": 25,
        "safety": 25,
        "transparency": 20,
        "sustainability": 35
      },
      "price": 49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431035883717",
      "vsf_explanation": "Generic Chinese OEM tracker (NRF52832 SoC, unbranded firmware) reselling under a generic reseller. Lists blood pressure monitoring in the feature set with no FDA clearance and no reference to any validation. Auto-fails on both unverified medical claim and weak brand provenance.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "mens-smart-watch-fitness-trackers-with-heart-rate-monitor",
      "title": "Men's Smart Watch Fitness Trackers with Heart Rate Monitor",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/mens-smart-watch-fitness-trackers-with-heart-rate-monitor-smart-watches-dailysale-293007.jpg?v=1781967730",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "men",
        "smart",
        "watch",
        "fitness",
        "trackers",
        "with",
        "heart",
        "rate",
        "monitor",
        "dailysale"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "fitness_activity_trackers"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 30,
        "manufacturing": 30,
        "safety": 25,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431036309701",
      "vsf_explanation": "Markets on-wrist blood pressure alongside HR/sleep. Own copy admits >15 mmHg error vs. a medical BP cuff yet still promotes the feature, which is textbook misleading medical claim territory. No FDA clearance and the reseller is an aggregator, not a manufacturer.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "itouch-sport-3-smart-watch-and-fitness-tracker-43mm-rosegold-mesh",
      "title": "Itouch Sport 3 Smart Watch and Fitness Tracker (43mm)  Rosegold Mesh",
      "vendor": "Vanessa Jane",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/E52tUiLVl2.jpg?v=1781967750",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "itouch",
        "sport",
        "smart",
        "watch",
        "and",
        "fitness",
        "tracker",
        "43mm",
        "rosegold",
        "mesh",
        "vanessa",
        "jane"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smartwatches"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 80,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431036670149",
      "vsf_explanation": "iTouch is a real consumer smartwatch line (from Wearable IQ / Timex-adjacent distribution) with 24hr HR, activity, and hydration reminders; features stay in accepted consumer-wellness territory and avoid FDA-regulated claims. Body temperature and elevated HR alerts are consumer-grade (no medical clearance) and validation data is not published. Reasonable Standard-tier fitness watch at $80.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "smart-watch-with-heart-rate-blood-pressure-monitoring-fitness-tracker-smart-watch-for-ios-and-android-phones",
      "title": "Smart Watch With Heart Rate Blood Pressure Monitoring Fitness Tracker Smart Watch For IOS and Android phones",
      "vendor": "Stevvex",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c0794c6f8e966a28da1c3982861793d4.jpg?v=1781967854",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "smart",
        "watch",
        "with",
        "heart",
        "rate",
        "blood",
        "pressure",
        "monitoring",
        "fitness",
        "tracker",
        "smart",
        "watch",
        "for",
        "ios",
        "and",
        "android",
        "phones",
        "stevvex"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "blood_pressure"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 30,
        "manufacturing": 30,
        "safety": 25,
        "transparency": 15,
        "sustainability": 35
      },
      "price": 59.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431038013637",
      "vsf_explanation": "Advertises blood pressure monitoring on the wrist without any listed FDA clearance and no clinical validation of the optical BP algorithm. Stevvex is a generic reseller brand with no manufacturer provenance. Auto-failed for unverified medical claim on a regulated modality.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "luxury-popular-trend-smart-watch-with-led-color-screen-smartwatch-women-fashion-fitness-tracker-heart-rate-monitor",
      "title": "Luxury Popular Trend Smart Watch With LED Color Screen Smartwatch Women Fashion Fitness Tracker Heart Rate monitor",
      "vendor": "Stevvex",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/69c38a02502f39d0752b53d47ee1af1a.jpg?v=1781967899",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "luxury",
        "popular",
        "trend",
        "smart",
        "watch",
        "with",
        "led",
        "color",
        "screen",
        "smartwatch",
        "women",
        "fashion",
        "fitness",
        "tracker",
        "heart",
        "rate",
        "monitor",
        "stevvex"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "fitness_activity_trackers"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 45,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 57,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431038439621",
      "vsf_explanation": "Generic unbranded fitness watch from Stevvex, an obscure reseller with no verifiable manufacturer, model number, or FCC/CE documentation surfaced. Basic HR and sleep tracking are unvalidated and there is no peer-reviewed evidence for accuracy of the underlying sensor. Falls under no_brand_provenance.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "smart-watch-rock-rugged-watch-for-men-outdoor-sports-waterproof-fitness-tracker-blood-pressure-monitor-smartwatch",
      "title": "Smart Watch ROCK Rugged Watch For Men Outdoor Sports Waterproof Fitness Tracker Blood Pressure Monitor smartwatch",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4B3150F0EBB6DE18A89239CFCCD1226C.jpg?v=1781967921",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "smart",
        "watch",
        "rock",
        "rugged",
        "watch",
        "for",
        "men",
        "outdoor",
        "sports",
        "waterproof",
        "fitness",
        "tracker",
        "blood",
        "pressure",
        "monitor",
        "smartwatch",
        "digital",
        "presence"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smartwatches"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 25,
        "manufacturing": 25,
        "safety": 25,
        "transparency": 15,
        "sustainability": 30
      },
      "price": 84.7,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431038767301",
      "vsf_explanation": "Another 'ROCK Rugged' smartwatch listing from a generic reseller with 'Blood Pressure Monitor' baked into the title and no product description body. No FDA clearance, no manufacturer disclosure, no validation.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "smart-watch-fitness-tracker-watch-for-men-women-1-69-touch-smartwatch-fitness-watch-with-pedometer-sleep-monitor",
      "title": "Smart Watch, Fitness Tracker Watch for Men Women, 1.69'' Touch Smartwatch Fitness Watch with Pedometer/Sleep Monitor.",
      "vendor": "The Shopper Stop",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Sae611e609b894c2cabcdf0f65ac3e7d1d.webp?v=1781967936",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "smart",
        "watch",
        "fitness",
        "tracker",
        "watch",
        "for",
        "men",
        "women",
        "touch",
        "smartwatch",
        "fitness",
        "watch",
        "with",
        "pedometer",
        "sleep",
        "monitor",
        "the",
        "shopper",
        "stop"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smartwatches"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 62.93,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431038865605",
      "vsf_explanation": "The Shopper Stop generic 1.69\" smartwatch with HR, sleep, GPS, and call/message push. No BP claim, but also no manufacturer, model number, or brand. CE/FCC/RoHS are self-declarations, not accuracy evidence.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "sport-ip68-waterproof-smart-watch-screen-touch-men-clock-women-fitness-tracker-smartwatch-for-ios-and-android-for-men-and-women",
      "title": "Sport IP68 Waterproof Smart Watch Screen Touch Men Clock Women Fitness Tracker Smartwatch for IOS and Android For Men and Women",
      "vendor": "Stevvex",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Hcfbf3f5c5ff6496e8a72f44224e1e9f4D.jpg?v=1781967949",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sport",
        "ip68",
        "waterproof",
        "smart",
        "watch",
        "screen",
        "touch",
        "men",
        "clock",
        "women",
        "fitness",
        "tracker",
        "smartwatch",
        "for",
        "ios",
        "and",
        "android",
        "for",
        "men",
        "and",
        "women",
        "stevvex"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smartwatches"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 73,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431038931141",
      "vsf_explanation": "Stevvex generic sport smartwatch with HRV, sleep, and multi-sport modes, no explicit blood-pressure claim in the visible description. Still an unbranded reseller SKU with no manufacturer, model number, or accuracy validation.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "smartwatch-2021-kospet-rock-rugged-watch-for-men-outdoor-sports-waterproof-fitness-tracker-blood-pressure-monitor-smart-watch",
      "title": "Smartwatch 2021 KOSPET ROCK Rugged Watch For Men Outdoor Sports Waterproof Fitness Tracker Blood Pressure Monitor Smart Watch",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/05632F792BC4A1BFD01DAC30A04E293D.jpg?v=1781967977",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "smartwatch",
        "2021",
        "kospet",
        "rock",
        "rugged",
        "watch",
        "for",
        "men",
        "outdoor",
        "sports",
        "waterproof",
        "fitness",
        "tracker",
        "blood",
        "pressure",
        "monitor",
        "smart",
        "watch",
        "digital",
        "presence"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smartwatches"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 35,
        "manufacturing": 40,
        "safety": 30,
        "transparency": 30,
        "sustainability": 30
      },
      "price": 73.16,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431039619269",
      "vsf_explanation": "KOSPET ROCK is a real budget rugged smartwatch (nRF52840, 1.69\" TFT, Da Fit app) but the reseller titles it a 'Blood Pressure Monitor Smart Watch'. Kospet does not hold FDA clearance for BP measurement, so the marketing crosses into unverified medical territory.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "smart-ring-r08-health-and-sleep-monitor-5atm-waterproof-sports-fitness-tracker-with-charging-case-for-xiaomi-samsung-phone",
      "title": "Smart Ring R08 Health and Sleep Monitor 5ATM Waterproof Sports Fitness Tracker with Charging Case for Xiaomi Samsung Phone",
      "vendor": "SnapGoShop",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/deba4605264802d670663a71f8b2800a.jpg?v=1781967995",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "smart",
        "ring",
        "r08",
        "health",
        "and",
        "sleep",
        "monitor",
        "5atm",
        "waterproof",
        "sports",
        "fitness",
        "tracker",
        "with",
        "charging",
        "case",
        "for",
        "xiaomi",
        "samsung",
        "phone",
        "snapgoshop"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smart_rings"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 25,
        "manufacturing": 25,
        "safety": 25,
        "transparency": 15,
        "sustainability": 30
      },
      "price": 36.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431039717573",
      "vsf_explanation": "Duplicate of the SnapGoShop R08 ring, same 'Blood Oxygen Pressure Health Monitor' language in the description. Unverified BP claim on generic hardware, no clearance.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "s6-women-smart-wristband-waterproof-ip67-smart-fitness-bracelet-heart-rate-blood-pressure-fitness-tracker-call-message-reminder",
      "title": "S6 Women Smart Wristband Waterproof Ip67 Smart Fitness Bracelet Heart Rate Blood Pressure Fitness Tracker Call Message Reminder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1931F8B29433FEA5633C1532D42BABF8.jpg?v=1781968014",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "women",
        "smart",
        "wristband",
        "waterproof",
        "ip67",
        "smart",
        "fitness",
        "bracelet",
        "heart",
        "rate",
        "blood",
        "pressure",
        "fitness",
        "tracker",
        "call",
        "message",
        "reminder",
        "digital",
        "presence"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "fitness_activity_trackers"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 20,
        "manufacturing": 20,
        "safety": 20,
        "transparency": 15,
        "sustainability": 25
      },
      "price": 71.64,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431040307397",
      "vsf_explanation": "'S6' generic fitness bracelet at $72 with blood pressure in the title. Dropshipper description explicitly notes 'Support Dropshipping and Wholesaling'. No FDA clearance, no manufacturer, no validation.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "luxury-ladies-smart-watch-for-women-with-blood-pressure-heart-rate-monitor-fitness-tracker-and-sport-smart-band-alarm-clock-reminder-smartwatch",
      "title": "Luxury Ladies Smart Watch For Women With  Blood Pressure Heart Rate Monitor Fitness tracker And Sport Smart Band Alarm Clock Reminder Smartwatch",
      "vendor": "Stevvex",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fcbdb822397b57b7a95c37727388186e.jpg?v=1781968037",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "luxury",
        "ladies",
        "smart",
        "watch",
        "for",
        "women",
        "with",
        "blood",
        "pressure",
        "heart",
        "rate",
        "monitor",
        "fitness",
        "tracker",
        "and",
        "sport",
        "smart",
        "band",
        "alarm",
        "clock",
        "reminder",
        "smartwatch",
        "stevvex"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smartwatches"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 20,
        "manufacturing": 20,
        "safety": 20,
        "transparency": 15,
        "sustainability": 25
      },
      "price": 69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431040766149",
      "vsf_explanation": "Stevvex 'Luxury Ladies' watch marketed on a blood pressure heart rate monitor claim, at $69. Same class of unbranded hardware without FDA clearance or validation.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "smart-ring-r08-womens-men-electronic-smartring-5atm-waterproof-sports-fitness-tracker-sleep-tracker-for-xiaomi-samsung-phone",
      "title": "Smart Ring R08 Womens Men Electronic Smartring 5ATM Waterproof Sports Fitness Tracker Sleep Tracker for Xiaomi Samsung Phone",
      "vendor": "SnapGoShop",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/14a323b4b5db953381084257bcdbae1d.jpg?v=1781968050",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "smart",
        "ring",
        "r08",
        "womens",
        "men",
        "electronic",
        "smartring",
        "5atm",
        "waterproof",
        "sports",
        "fitness",
        "tracker",
        "sleep",
        "tracker",
        "for",
        "xiaomi",
        "samsung",
        "phone",
        "snapgoshop"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smart_rings"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 25,
        "manufacturing": 25,
        "safety": 25,
        "transparency": 15,
        "sustainability": 30
      },
      "price": 40.41,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431041159365",
      "vsf_explanation": "Generic 'R08' smart ring resold by SnapGoShop with a 'Blood Oxygen Pressure Health Monitor' claim in the description. No FDA clearance, no manufacturer, no validation. Cheap PPG sensor cannot deliver clinical BP.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "h20-smart-watch-bluetooth-calling-wristwatch-man-health-monitoring-ai-voice-sports-fitness-tracker-women-lady-luxury-smartwatch",
      "title": "H20 Smart Watch Bluetooth Calling Wristwatch Man Health Monitoring AI Voice Sports Fitness Tracker Women Lady Luxury Smartwatch",
      "vendor": "American Smart",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BD591FD72A5B303C52A033B379566E5A.jpg?v=1781968076",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "h20",
        "smart",
        "watch",
        "bluetooth",
        "calling",
        "wristwatch",
        "man",
        "health",
        "monitoring",
        "voice",
        "sports",
        "fitness",
        "tracker",
        "women",
        "lady",
        "luxury",
        "smartwatch",
        "american",
        "smart"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smartwatches"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 30,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 15,
        "sustainability": 30
      },
      "price": 39.85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431041224901",
      "vsf_explanation": "Listing has no description, no spec, only a marketing title. 'H20' is a generic AliExpress smartwatch nameplate. No way to know what the customer actually receives.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "smart-health-ring-fitness-tracker-for-women-men-heart-rate-sleep-monitoring-step-counting-ip68-waterproof-activity-ring-compatible-with-ios-android-no-subscription",
      "title": "Smart Health Ring Fitness Tracker for Women Men Heart Rate Sleep Monitoring Step Counting IP68 Waterproof Activity Ring Compatible with Ios Android No Subscription",
      "vendor": "BazaarBox",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5758e4dd9084da5d0c17498042b6ce74.jpg?v=1781968097",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "smart",
        "health",
        "ring",
        "fitness",
        "tracker",
        "for",
        "women",
        "men",
        "heart",
        "rate",
        "sleep",
        "monitoring",
        "step",
        "counting",
        "ip68",
        "waterproof",
        "activity",
        "ring",
        "compatible",
        "with",
        "ios",
        "android",
        "subscription",
        "bazaarbox"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smart_rings"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 28.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431042535621",
      "vsf_explanation": "$29 unbranded activity ring resold by BazaarBox. HR, sleep, and step tracking with 'no subscription' as the main hook. No manufacturer, model number, or accuracy validation.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "garmin-vivoactive-5-fitness-tracker-smart-watch-for-women-men-with-slate-aluminum-bezel-with-black-case-and-silicone-band-with-11-days-battery-life-and-bright-1-2-amoled-touchscreen-display",
      "title": "Garmin Vivoactive 5 Fitness Tracker Smart Watch for Women & Men with Slate Aluminum Bezel with Black Case and Silicone Band with 11 Days Battery Life and Bright 1.2” AMOLED Touchscreen Display",
      "vendor": "Anti Spier",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/nxxSf9FNo1GXM7pc.webp?v=1781968121",
      "score": 74,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "garmin",
        "vivoactive",
        "fitness",
        "tracker",
        "smart",
        "watch",
        "for",
        "women",
        "men",
        "with",
        "slate",
        "aluminum",
        "bezel",
        "with",
        "black",
        "case",
        "and",
        "silicone",
        "band",
        "with",
        "days",
        "battery",
        "life",
        "and",
        "bright",
        "amoled",
        "touchscreen",
        "display",
        "anti",
        "spier"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smartwatches"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 78,
        "manufacturing": 82,
        "safety": 80,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 527.83,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431043584197",
      "vsf_explanation": "Garmin Vivoactive 5 is a genuinely well-validated smartwatch: AMOLED, GPS, Pulse Ox, HRV, Body Battery, sleep coaching and menstrual/pregnancy tracking, backed by Garmin's peer-reviewed HR/sleep research. The list price of $528 here (retail ~$300) is a significant markup by a generic reseller that costs transparency points, but the underlying device firmly earns Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "kuizil-smart-watch-1-91-hd-smartwatch-for-men-women-answer-make-call-fitness-tracker-with-100-sport-modes-ip68-waterproof-heart-rate-sleep-monitor-pedometer-activity-tracker-for-android-ios",
      "title": "Kuizil Smart Watch 1.91\" HD Smartwatch for Men Women (Answer/Make Call) Fitness Tracker with 100+ Sport Modes IP68 Waterproof Heart Rate/Sleep Monitor Pedometer Activity Tracker for Android iOS",
      "vendor": "EasyOptionXY",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c3599929486da0869a97520f3f7e.jpg?v=1781968147",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "kuizil",
        "smart",
        "watch",
        "smartwatch",
        "for",
        "men",
        "women",
        "answer",
        "make",
        "call",
        "fitness",
        "tracker",
        "with",
        "100",
        "sport",
        "modes",
        "ip68",
        "waterproof",
        "heart",
        "rate",
        "sleep",
        "monitor",
        "pedometer",
        "activity",
        "tracker",
        "for",
        "android",
        "ios",
        "easyoptionxy"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smartwatches"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 214.06,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431043846341",
      "vsf_explanation": "'Kuizil' is an Amazon-only white-label brand paired with the generic 'Gloryfit' companion app used by dozens of AliExpress SKUs. No manufacturer disclosure, no meaningful validation. Priced at $214 which is far above what the hardware supports.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "parsonver-smart-watch-for-men-women-built-in-gps-bluetooth-calling-30m-waterproof-gps-fitness-tracker-heart-rate-sleep-spo2-monitor-step-counter-100-sport-modes-for-android-iphone-two-bands",
      "title": "Parsonver Smart Watch for Men Women Built-in GPS Bluetooth Calling 30M Waterproof GPS Fitness Tracker Heart Rate/Sleep/SpO2 Monitor Step Counter 100+ Sport Modes for Android & iPhone (Two Bands)",
      "vendor": "Anti Spier",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/iL3YTA0ZjWMzjoyI.webp?v=1781968166",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "parsonver",
        "smart",
        "watch",
        "for",
        "men",
        "women",
        "built",
        "gps",
        "bluetooth",
        "calling",
        "30m",
        "waterproof",
        "gps",
        "fitness",
        "tracker",
        "heart",
        "rate",
        "sleep",
        "spo2",
        "monitor",
        "step",
        "counter",
        "100",
        "sport",
        "modes",
        "for",
        "android",
        "iphone",
        "two",
        "bands",
        "anti",
        "spier"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smartwatches"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 105.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431043911877",
      "vsf_explanation": "Parsonver GOPO2 is a real budget smartwatch brand with built-in GPS, HR, SpO2, sleep, and BT calling. It stays out of blood-pressure marketing territory. Not clinically validated and sold here through a general reseller rather than the brand direct, but the device itself is a reasonable entry-level tracker.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "smartwatch-fitness-activity-tracker",
      "title": "Smartwatch Fitness Activity Tracker",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/smartwatch-fitness-activity-tracker-smart-watches-silver-dailysale-164748.jpg?v=1781968188",
      "score": 22,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "smartwatch",
        "fitness",
        "activity",
        "tracker",
        "dailysale"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smartwatches"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 25,
        "manufacturing": 25,
        "safety": 25,
        "transparency": 20,
        "sustainability": 30
      },
      "price": 67,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431044272325",
      "vsf_explanation": "Unbranded 'Model LG0160' fitness watch resold by a reseller that lists blood pressure in its Fitness & Wellness metrics. No clearance, no manufacturer, no BP validation. Also raises depth-rating flags (IP68 + 20 m water resistance is a common overpromise on cheap watches).",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "garmin-vivosmart-5-fitness-activity-tracker-black-refurbished",
      "title": "Garmin Vivosmart 5 Fitness Activity Tracker - Black  (Refurbished)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/garmin-vivosmart-5-fitness-activity-tracker-black-fitness-dailysale-784635.jpg?v=1781968214",
      "score": 73,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "garmin",
        "vivosmart",
        "fitness",
        "activity",
        "tracker",
        "black",
        "refurbished",
        "dailysale"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "fitness_activity_trackers"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 75,
        "manufacturing": 82,
        "safety": 80,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 139,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431044403397",
      "vsf_explanation": "Refurbished Garmin Vivosmart 5, a well-validated fitness tracker with Elevate HR sensor, Pulse Ox, sleep score, Body Battery, and step tracking. Garmin has strong provenance, meaningful published methodology, and years of independent accuracy studies. The refurb condition and third-party reseller trim manufacturing/transparency, but the core device is a solid entry-level Verified pick.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "smart-fit-multi-function-smart-watch-tracker-and-monitor",
      "title": "Smart Fit Multi Function Smart Watch Tracker and Monitor",
      "vendor": "Anti Spier",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Lol3shJVlcougJm.webp?v=1781968233",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "smart",
        "fit",
        "multi",
        "function",
        "smart",
        "watch",
        "tracker",
        "and",
        "monitor",
        "anti",
        "spier"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smartwatches"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 220.21,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431044501701",
      "vsf_explanation": "Anti Spier resells a generic 'Smart Fit' watch at $220 with no manufacturer, model number, or spec sheet. Copy is a marketing blurb with no verifiable device identity. Cannot recommend as a biohacking wearable.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "zewa-fitness-smart-watch-health-oxygen-pulse-sms-calories-distance-tracker",
      "title": "Zewa Fitness Smart Watch Health, Oxygen, Pulse, SMS, Calories & Distance Tracker",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/682891212016_40378129-ea30-44a5-985a-843350caeea9.jpg?v=1781968254",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zewa",
        "fitness",
        "smart",
        "watch",
        "health",
        "oxygen",
        "pulse",
        "sms",
        "calories",
        "distance",
        "tracker",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smartwatches"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 126.24,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431044862149",
      "vsf_explanation": "Zewa is a real medical-device brand best known for FDA-cleared blood pressure monitors; this listing is their consumer fitness smartwatch with SpO2, HR, sleep, steps and companion app. No explicit BP claim on this SKU, and it is sold via a licensed pharmacy channel, which is a plus for provenance. Feature set is behind Garmin/Apple/Fitbit, but the brand and channel are legitimate.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ocean-army-smart-watch-for-menand-woman-for-fitness-and-sport-with-tracker-blood-pressure-message-push-heart-rate-monitor-and-clock-smartwatc-for-android",
      "title": "Ocean Army Smart Watch For Menand Woman For  Fitness and Sport With Tracker Blood Pressure Message Push Heart Rate Monitor and Clock Smartwatc For Android",
      "vendor": "Stevvex",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Hb90dada57d8a449ca0857d0154ff2ad8W_acbb2a2d-db98-479a-94b8-e60cac631347.jpg?v=1781968275",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ocean",
        "army",
        "smart",
        "watch",
        "for",
        "menand",
        "woman",
        "for",
        "fitness",
        "and",
        "sport",
        "with",
        "tracker",
        "blood",
        "pressure",
        "message",
        "push",
        "heart",
        "rate",
        "monitor",
        "and",
        "clock",
        "smartwatc",
        "for",
        "android",
        "stevvex"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smartwatches"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 20,
        "manufacturing": 20,
        "safety": 20,
        "transparency": 15,
        "sustainability": 25
      },
      "price": 55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431045124293",
      "vsf_explanation": "Duplicate of the Stevvex 'Ocean Army' watch. Same generic hardware, same unvalidated blood-pressure claim, no FDA clearance.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "military-ocean-army-smart-watch-for-menand-woman-for-fitness-and-sport-with-tracker-blood-pressure-message-push-heart-rate-monitor-and-clock-smartwatc-for-android",
      "title": "Military Ocean Army Smart Watch For Menand Woman For  Fitness and Sport With Tracker Blood Pressure Message Push Heart Rate Monitor and Clock Smartwatc For Android",
      "vendor": "Stevvex",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Had87da0e08dd4d8abdd46d2be8c989a0G.jpg?v=1781968305",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "military",
        "ocean",
        "army",
        "smart",
        "watch",
        "for",
        "menand",
        "woman",
        "for",
        "fitness",
        "and",
        "sport",
        "with",
        "tracker",
        "blood",
        "pressure",
        "message",
        "push",
        "heart",
        "rate",
        "monitor",
        "and",
        "clock",
        "smartwatc",
        "for",
        "android",
        "stevvex"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smartwatches"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 20,
        "manufacturing": 20,
        "safety": 20,
        "transparency": 15,
        "sustainability": 25
      },
      "price": 55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431045255365",
      "vsf_explanation": "Stevvex 'Military Ocean Army' watch marketed with blood-pressure monitoring at $55. Generic no-name hardware without FDA clearance, no GPS, IP67 only. Multiple unverified medical claims baked into the marketing copy.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "e78-women-bracelet-watch-men-heart-rate-blood-pressure-smart-wristband-fitness-band-tracker-ip68-waterproof-sport-watch-swim",
      "title": "E78 Women bracelet watch men heart rate blood pressure smart wristband fitness band tracker Ip68 waterproof sport watch swim",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/C08DCDE4C85E0B4F5BBB858C618F0035.jpg?v=1781968328",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "e78",
        "women",
        "bracelet",
        "watch",
        "men",
        "heart",
        "rate",
        "blood",
        "pressure",
        "smart",
        "wristband",
        "fitness",
        "band",
        "tracker",
        "ip68",
        "waterproof",
        "sport",
        "watch",
        "swim",
        "digital",
        "presence"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "fitness_activity_trackers"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 20,
        "manufacturing": 20,
        "safety": 20,
        "transparency": 15,
        "sustainability": 25
      },
      "price": 47.54,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431046107333",
      "vsf_explanation": "Generic 'E78' fitness bracelet resold by a drop-shipper, with blood-pressure monitoring called out in the title. There is no FDA clearance, no manufacturer, and no validation for BP measurement on this class of $50 wristband.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "fitbit-versa-sense-leather-band-premium-classic-design",
      "title": "Fitbit Versa & Sense Leather Band - Premium Classic Design",
      "vendor": "BandsCo Straps",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/S4b4b9f54f5b04c6d8d34dc3cab57f20fs.webp?v=1781968443",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fitbit",
        "versa",
        "sense",
        "leather",
        "band",
        "premium",
        "classic",
        "design",
        "bandsco",
        "straps"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "fitness_activity_trackers"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 30,
        "sustainability": 25
      },
      "price": 33.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431047286981",
      "vsf_explanation": "Third listing of a leather Fitbit Versa/Sense band. Cosmetic accessory only, no biosensors or biohacking function.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "fitbit-versa-sense-leather-band-premium-comfort",
      "title": "Fitbit Versa & Sense Leather Band - Premium Comfort",
      "vendor": "BandsCo Straps",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/S7b0625a1f9ce4032b7e9aa32d2c1418fG.webp?v=1781968454",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fitbit",
        "versa",
        "sense",
        "leather",
        "band",
        "premium",
        "comfort",
        "bandsco",
        "straps"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "fitness_activity_trackers"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 30,
        "sustainability": 25
      },
      "price": 38.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431048335557",
      "vsf_explanation": "Aftermarket leather band for Fitbit Versa/Sense (near-duplicate SKU). Cosmetic accessory only, no biosensors or biohacking function.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "fitbit-inspire-3-metal-magnetic-loop-band-stainless-steel-mesh-strap",
      "title": "Fitbit Inspire 3 Metal Magnetic Loop Band – Stainless Steel Mesh Strap",
      "vendor": "BandsCo Straps",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/S0670335f246c4d279f693cd1e13eb0384.webp?v=1781968464",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fitbit",
        "inspire",
        "metal",
        "magnetic",
        "loop",
        "band",
        "stainless",
        "steel",
        "mesh",
        "strap",
        "bandsco",
        "straps"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "fitness_activity_trackers"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 30,
        "sustainability": 30
      },
      "price": 33.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431050989765",
      "vsf_explanation": "Aftermarket stainless-steel magnetic-mesh band for Fitbit Inspire 3. Cosmetic accessory only, not a biohacking device.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "fitbit-versa-sense-silicone-band-breathable-stylish-straps",
      "title": "Fitbit Versa & Sense Silicone Band - Breathable Stylish Straps",
      "vendor": "BandsCo Straps",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Sd6cfffbfc2874d1baaf2cca5f7fc094bm.webp?v=1781968474",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fitbit",
        "versa",
        "sense",
        "silicone",
        "band",
        "breathable",
        "stylish",
        "straps",
        "bandsco",
        "straps"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "fitness_activity_trackers"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 30,
        "sustainability": 30
      },
      "price": 33.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431051317445",
      "vsf_explanation": "Aftermarket silicone strap for Fitbit Versa/Sense. Cosmetic accessory, no biosensors or biohacking function.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "breathable-silicone-fitbit-versa-sense-bands",
      "title": "Breathable Silicone Fitbit Versa & Sense Bands",
      "vendor": "BandsCo Straps",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Saaea3f24645547fdb6576c76dabc1088h.webp?v=1781968485",
      "score": 16,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "breathable",
        "silicone",
        "fitbit",
        "versa",
        "sense",
        "bands",
        "bandsco",
        "straps"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 5,
        "formulation": 15,
        "manufacturing": 25,
        "safety": 45,
        "transparency": 15,
        "sustainability": 20
      },
      "price": 33.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431053283525",
      "vsf_explanation": "Silicone replacement watch bands for Fitbit Versa/Sense — a wearable accessory, not a supplement. Rejected as category mismatch.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fitbit-inspire-3-stainless-steel-band-premium-metal-strap",
      "title": "Fitbit Inspire 3 Stainless Steel Band – Premium Metal Strap",
      "vendor": "BandsCo Straps",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Sd019f379b37040399ea4d71e67571f9el.webp?v=1781968509",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fitbit",
        "inspire",
        "stainless",
        "steel",
        "band",
        "premium",
        "metal",
        "strap",
        "bandsco",
        "straps"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "fitness_activity_trackers"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 30,
        "sustainability": 30
      },
      "price": 33.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431055708357",
      "vsf_explanation": "Aftermarket stainless-steel band for the Fitbit Inspire 3. Cosmetic accessory only, no biosensors or biohacking function.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "fitbit-versa-sense-leather-band-stylish-durable-design",
      "title": "Fitbit Versa & Sense Leather Band - Stylish Durable Design",
      "vendor": "BandsCo Straps",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/S55226d482a904158a28a2f25e9b69733q.webp?v=1781968530",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fitbit",
        "versa",
        "sense",
        "leather",
        "band",
        "stylish",
        "durable",
        "design",
        "bandsco",
        "straps"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "fitness_activity_trackers"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 30,
        "sustainability": 25
      },
      "price": 108.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431056101573",
      "vsf_explanation": "Aftermarket leather band for Fitbit Versa/Sense, listed at a puzzlingly high $109. Cosmetic accessory, no biosensors or biohacking function.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "fitbit-charge-5-6-nylon-velcro-band-durable-comfortable-strap",
      "title": "Fitbit Charge 5 6 Nylon Velcro Band - Durable Comfortable Strap",
      "vendor": "BandsCo Straps",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Ha5338f9d2da14ae38ba28435dd67367ck.webp?v=1781968539",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fitbit",
        "charge",
        "nylon",
        "velcro",
        "band",
        "durable",
        "comfortable",
        "strap",
        "bandsco",
        "straps"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "fitness_activity_trackers"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 30,
        "sustainability": 35
      },
      "price": 33.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431057182917",
      "vsf_explanation": "Aftermarket nylon velcro band for Fitbit Charge 5/6. Cosmetic accessory only, no biosensors or biohacking function.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "fitbit-charge-5-6-stainless-steel-magnetic-band-stylish-durable",
      "title": "Fitbit Charge 5 6 Stainless Steel Magnetic Band - Stylish Durable",
      "vendor": "BandsCo Straps",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/S5e63494e079d477ab9ed189d15407edbO.webp?v=1781968558",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fitbit",
        "charge",
        "stainless",
        "steel",
        "magnetic",
        "band",
        "stylish",
        "durable",
        "bandsco",
        "straps"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "fitness_activity_trackers"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 30,
        "sustainability": 30
      },
      "price": 33.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431058034885",
      "vsf_explanation": "Aftermarket magnetic-loop stainless-steel band for Fitbit Charge 5/6. Cosmetic accessory only, no biosensors or health function.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "fitbit-charge-wireless-activity-wristband-assorted-sizes",
      "title": "Fitbit Charge Wireless Activity Wristband - Assorted Sizes",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fitbit-charge-wireless-activity-wristband-assorted-colors-and-sizes-gadgets-accessories-dailysale-605306.jpg?v=1781968577",
      "score": 15,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fitbit",
        "charge",
        "wireless",
        "activity",
        "wristband",
        "assorted",
        "sizes",
        "dailysale"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 10,
        "manufacturing": 30,
        "safety": 50,
        "transparency": 20,
        "sustainability": 20
      },
      "price": 29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431058624709",
      "vsf_explanation": "Fitness wearable tracker — not a supplement. Supplement rubric fields (dose, evidence for an ingredient) do not apply.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fitbit-luxe-leather-band-premium-comfort-and-style",
      "title": "Fitbit Luxe Leather Band - Premium Comfort and Style",
      "vendor": "BandsCo Straps",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/S50f569b64dd84fd0b3d8aaca9fd4591eY.webp?v=1781968593",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fitbit",
        "luxe",
        "leather",
        "band",
        "premium",
        "comfort",
        "and",
        "style",
        "bandsco",
        "straps"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "fitness_activity_trackers"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 30,
        "sustainability": 25
      },
      "price": 38.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431058788549",
      "vsf_explanation": "Aftermarket leather replacement strap for Fitbit Luxe. Cosmetic accessory, no tracking sensors or health function. Not a biohacking device.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "stainless-steel-fitbit-luxe-band-durable-elegant-design",
      "title": "Stainless Steel Fitbit Luxe Band - Durable Elegant Design",
      "vendor": "BandsCo Straps",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/S736661d610894e43b51f17e8a0885b84t.webp?v=1781968605",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "stainless",
        "steel",
        "fitbit",
        "luxe",
        "band",
        "durable",
        "elegant",
        "design",
        "bandsco",
        "straps"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "fitness_activity_trackers"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 30,
        "sustainability": 30
      },
      "price": 33.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431059214533",
      "vsf_explanation": "Aftermarket stainless-steel strap for the Fitbit Luxe. Purely cosmetic - no sensors, no health tracking, no biohacking utility. Belongs in accessory sub-catalog, not a health-tech recommendation surface.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "fitbit-charge-5-6-3-4-2-stainless-steel-metal-band",
      "title": "Fitbit Charge 5 6 3 4 2 Stainless Steel Metal Band",
      "vendor": "BandsCo Straps",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/S2e5ae3b190c74c95ad41f5a067b8ed9b2.webp?v=1781968628",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fitbit",
        "charge",
        "stainless",
        "steel",
        "metal",
        "band",
        "bandsco",
        "straps"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "fitness_activity_trackers"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 30,
        "sustainability": 30
      },
      "price": 33.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431059738821",
      "vsf_explanation": "Aftermarket stainless-steel replacement watch band for Fitbit Charge. It is a cosmetic accessory with no sensors or biohacking function. Belongs to a wearables catalog only as a peripheral, not as a health-tech recommendation.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "smart-ring-fitness-assistant",
      "title": "Smart Ring Fitness Assistant",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/smart-ring-fitness-assistant-rings-gold-7-dailysale-537439.jpg?v=1781968692",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "smart",
        "ring",
        "fitness",
        "assistant",
        "dailysale"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smart_rings"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431060328645",
      "vsf_explanation": "Unbranded 'fitness assistant' ring sold at $29 by a general daily-deals reseller. Description mentions steps, sleep, and calories but names no manufacturer, model, or sensor spec. Marketing-only listing with no way to verify what device the buyer actually receives.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "smart-ring-health-monitoring",
      "title": "Smart Ring Health Monitoring",
      "vendor": "Dabfavshop",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/S54bc637a09344834a525b4843a2354b0J_d1997e93-861f-4ca4-b1bb-35f8b12fa3a4.webp?v=1781968704",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "smart",
        "ring",
        "health",
        "monitoring",
        "dabfavshop"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smart_rings"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 54.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431061016773",
      "vsf_explanation": "COLMI is a real budget smart-ring brand (top-selling on AliExpress) with a titanium-steel build and standard PPG-based HR/SpO2/sleep tracking; no blood-pressure claim in the description. Not clinically validated to Oura/Ultrahuman standards and the reseller (Dabfavshop) adds no accountability, but the underlying device is a known SKU. Acceptable entry-level tracker for step and sleep data only.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "jakcom-r3f-smart-ring-waterproof",
      "title": "JAKCOM R3F Smart Ring Waterproof",
      "vendor": "Vellmara",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2210887716014.jpg?v=1781968731",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "jakcom",
        "r3f",
        "smart",
        "ring",
        "waterproof",
        "vellmara"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smart_rings"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 34.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431061835973",
      "vsf_explanation": "JAKCOM R3F is a passive NFC ring (13.56 MHz, no battery) used for card sharing and app shortcuts. Marketing mentions a 'health-optimized module' but the R3F does not contain optical sensors and does not track HR, SpO2, HRV, or sleep. It is essentially a smart accessory, not a health-tracking wearable, and does not belong in a biohacking stack.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "all-in-one-family-health-smart-ring",
      "title": "All-in-One Family Health Smart Ring",
      "vendor": "Vera Lux",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/31e5c27d-61b6-4bb5-864e-ad02549f9448.jpg?v=1781968743",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "all",
        "one",
        "family",
        "health",
        "smart",
        "ring",
        "vera",
        "lux"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smart_rings"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 45,
        "manufacturing": 40,
        "safety": 60,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 105.12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431063146693",
      "vsf_explanation": "Vera Lux drop-ship listing of a generic 6.3mm optical ring covering SpO2, HRV, stress, sleep, and cycle tracking. Wisely avoids blood pressure claims, but no manufacturer, model number, or validation is disclosed. 'Family care mode' and stress detection are unvalidated marketing features on a low-cost sensor stack.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "smart-waterproof-bluetooth-sports-health-ring",
      "title": "Smart Waterproof Bluetooth Sports Health Ring",
      "vendor": "Anti Spier",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/xPx2UevFMYGC5w58.webp?v=1781968755",
      "score": 41,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "smart",
        "waterproof",
        "bluetooth",
        "sports",
        "health",
        "ring",
        "anti",
        "spier"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smart_rings"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 269.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431063179461",
      "vsf_explanation": "Anti Spier is a general reseller with no identifiable manufacturer disclosure, model number, or clinical citations. The ring lists HR, SpO2, and sleep tracking without validation, priced at $270 which is higher than reputable brands like Oura or Ultrahuman while offering nothing to justify it. Insufficient provenance to trust the device.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "2026-smart-ring-blood-pressure-heart-rate-sleep-monitoring-smartring-ip68-5atm-waterproof-multi-sport-mode-smartring-man-women",
      "title": "2026 Smart Ring Blood Pressure Heart Rate Sleep Monitoring Smartring IP68 & 5ATM Waterproof Multi-sport Mode Smartring Man Women",
      "vendor": "The Shopper Stop",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Sd83f485f7c1a4a4bb8e85a13af90ef2ct.webp?v=1781968771",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "2026",
        "smart",
        "ring",
        "blood",
        "pressure",
        "heart",
        "rate",
        "sleep",
        "monitoring",
        "smartring",
        "ip68",
        "5atm",
        "waterproof",
        "multi",
        "sport",
        "mode",
        "smartring",
        "man",
        "women",
        "the",
        "shopper",
        "stop"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smart_rings"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 20,
        "manufacturing": 20,
        "safety": 20,
        "transparency": 15,
        "sustainability": 25
      },
      "price": 37.76,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431064228037",
      "vsf_explanation": "Duplicate listing of a generic unbranded smart ring resold by a drop-shipper with 'R09/R06/R12' SKU rotation. Claims blood pressure monitoring on a $37 ring, which is not supported by any consumer optical ring technology or FDA clearance.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "2026-smart-ring-blood-pressure-heart-rate-sleep-monitoring-smartring-ip68-5atm-waterproof-multi-sport-mode-smartring-man-women-1",
      "title": "2026 Smart Ring Blood Pressure Heart Rate Sleep Monitoring Smartring IP68 & 5ATM Waterproof Multi-sport Mode Smartring Man Women",
      "vendor": "The Shopper Stop",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/S84bb530855f6422c9d94941248989011j.webp?v=1781968797",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "2026",
        "smart",
        "ring",
        "blood",
        "pressure",
        "heart",
        "rate",
        "sleep",
        "monitoring",
        "smartring",
        "ip68",
        "5atm",
        "waterproof",
        "multi",
        "sport",
        "mode",
        "smartring",
        "man",
        "women",
        "the",
        "shopper",
        "stop"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smart_rings"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 20,
        "manufacturing": 20,
        "safety": 20,
        "transparency": 15,
        "sustainability": 25
      },
      "price": 39.16,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431065866437",
      "vsf_explanation": "Sub-$40 unbranded smart ring resold by a drop-shipper, generic 'R03/R09/R06' SKU family. CE/FCC self-declarations do not validate physiological accuracy, and continuous blood pressure monitoring is claimed without any FDA clearance.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "new-r1-r2-smart-ring-pedometer-heart-rate-blood-pressure-blood-oxygen-sleep-monitoring-smart-ring",
      "title": "New R1 R2 Smart Ring Pedometer Heart Rate Blood Pressure Blood Oxygen Sleep Monitoring Smart Ring",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/110EBC354E7C1B60BEECB4191F7A293D.png?v=1781968843",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "new",
        "smart",
        "ring",
        "pedometer",
        "heart",
        "rate",
        "blood",
        "pressure",
        "blood",
        "oxygen",
        "sleep",
        "monitoring",
        "smart",
        "ring",
        "digital",
        "presence"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smart_rings"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 20,
        "manufacturing": 20,
        "safety": 20,
        "transparency": 15,
        "sustainability": 25
      },
      "price": 98.26,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431068455109",
      "vsf_explanation": "White-label AliExpress-tier smart ring on an nRF52832 chipset resold by a drop-shipper. Claims blood pressure monitoring without any FDA clearance or clinical validation. Chipset callouts (NRF52832, SY8602, QMA6100P) are hardware notes, not accuracy evidence.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "smart-ring-with-display-for-counting-heart-rate-blood-oxygen-pressure-sleep-and-exercise-monitoring-smart-bracelet-for-the-middle-east",
      "title": "Smart Ring With Display For Counting, Heart Rate, Blood Oxygen, Pressure, Sleep, And Exercise Monitoring, Smart Bracelet For The Middle East",
      "vendor": "Vera Lux",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8cf1eeaa-f395-4a1f-8b97-6bf6520f4e58.jpg?v=1781968852",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "smart",
        "ring",
        "with",
        "display",
        "for",
        "counting",
        "heart",
        "rate",
        "blood",
        "oxygen",
        "pressure",
        "sleep",
        "and",
        "exercise",
        "monitoring",
        "smart",
        "bracelet",
        "for",
        "the",
        "middle",
        "east",
        "vera",
        "lux"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smart_rings"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 25,
        "manufacturing": 20,
        "safety": 25,
        "transparency": 15,
        "sustainability": 25
      },
      "price": 104.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431068651717",
      "vsf_explanation": "Generic drop-ship smart ring from an unknown reseller claiming continuous blood pressure monitoring and 'hospital-grade' accuracy. No FDA clearance, no clinical validation, no verifiable manufacturer or model number. Consumer optical rings cannot deliver clinical BP, and the marketing language is materially misleading.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "2025-colmi-r12-smart-ring-with-display-screen-and-touch-wireless-charging-health-manager-5-atm-waterproof-for-men-women",
      "title": "2025 COLMI R12 Smart Ring with Display Screen and Touch, Wireless Charging, Health Manager, 5 ATM Waterproof For Men Women",
      "vendor": "The Shopper Stop",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/A83516346db4c4d49a8a1cc15392ee8a4b.webp?v=1781968865",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "2025",
        "colmi",
        "r12",
        "smart",
        "ring",
        "with",
        "display",
        "screen",
        "and",
        "touch",
        "wireless",
        "charging",
        "health",
        "manager",
        "atm",
        "waterproof",
        "for",
        "men",
        "women",
        "the",
        "shopper",
        "stop"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smart_rings"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 35,
        "sustainability": 35
      },
      "price": 167.34,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431068750021",
      "vsf_explanation": "COLMI R12 is a budget AliExpress-tier smart ring claiming heart rate, SpO2, stress, and sleep tracking without any independent accuracy validation or FDA clearance. Third-party reviews show meaningfully worse HR/SpO2 accuracy vs Oura/Ultrahuman. Sold by 'The Shopper Stop' - a generic reseller rather than a supported hardware brand.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bio-well-starter-pack",
      "title": "Bio-Well Starter Pack",
      "vendor": "Bio-Well",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/STARTERPACK.png?v=1781968981",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bio",
        "well",
        "starter",
        "pack",
        "bio",
        "well"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 15,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 15,
        "sustainability": 20
      },
      "price": 2999,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431070093509",
      "vsf_explanation": "GDV 'biofield' camera bundle — this is a device with no independent peer-reviewed clinical validation (Kirlian / GDV imaging is not a recognized diagnostic modality). Not a supplement. Rejected for category mismatch and unverified disease-like claims.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "heavy-metals",
      "title": "Heavy Metals",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/heavy-metals.jpg?v=1781969026",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "heavy",
        "metals",
        "hellohealth"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 30,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 30,
        "sustainability": 20
      },
      "price": 123.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431070388421",
      "vsf_explanation": "Lab-draw heavy-metals blood panel (lead, mercury, arsenic) — a diagnostic test, not a supplement. Blood testing is valid clinically but does not fit the supplement rubric. Rejected as category mismatch.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bd-veritor-system-rsv-test-kit-30-tests-poct",
      "title": "BD Veritor System RSV Test Kit (30 Tests) - POCT",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/bd-veritor-system-rsv-30-test-kit-256042_RC0_203162580.png?v=1781969038",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "veritor",
        "system",
        "rsv",
        "test",
        "kit",
        "tests",
        "poct",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "sti_infectious_disease"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 70,
        "manufacturing": 80,
        "safety": 80,
        "transparency": 65,
        "sustainability": 40
      },
      "price": 294.72,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431070421189",
      "vsf_explanation": "BD Veritor RSV point-of-care antigen test using BD's digital reader to eliminate visual interpretation error. FDA-cleared professional device from a top-tier IVD manufacturer with published validation data. Real clinical tool.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-d-and-b12-panel",
      "title": "Vitamin D and B12 Panel",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/vitamin-d-b12.jpg?v=1781969055",
      "score": 33,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular",
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "and",
        "b12",
        "panel",
        "hellohealth"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 30,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 30,
        "sustainability": 20
      },
      "price": 63.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431070585029",
      "vsf_explanation": "Vitamin D (25-OH) and B12 serum panel — a diagnostic blood test, not a supplement. Rejected as category mismatch.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pancreatic-health-function-test",
      "title": "Pancreatic Health & Function Test",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/PancreaticHealth_FunctionTest.jpg?v=1781969151",
      "score": 67,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pancreatic",
        "health",
        "function",
        "test",
        "hellohealth"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "blood_panel_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 65,
        "manufacturing": 70,
        "safety": 75,
        "transparency": 65,
        "sustainability": 45
      },
      "price": 110,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431071994053",
      "vsf_explanation": "At-home fingerstick blood test for amylase and lipase run through CAP/CLIA-accredited labs. Both are clinically standard pancreatic enzymes, though they are non-specific and primarily useful when acute symptoms exist (elevations in asymptomatic individuals rarely change management). Solid execution, marginal actionability for a screening context.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gut-health-advanced-test-kit-comprehensive-microbiome-analysis",
      "title": "Gut Health Advanced Test Kit – Comprehensive Microbiome Analysis",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/imagen_2026-02-23_173145208.png?v=1781969165",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gut",
        "health",
        "advanced",
        "test",
        "kit",
        "comprehensive",
        "microbiome",
        "analysis",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "gut_microbiome_testing"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 239.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431072157893",
      "vsf_explanation": "Generic microbiome analysis kit rebranded by an unnamed vendor with no disclosed sequencing lab, methodology, or clinical partnerships. Even best-in-class microbiome tests (Zoe, Viome) have limited clinical actionability - unnamed ones with no lab provenance carry higher risk of misleading personalized recommendations. Fails on transparency and evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "omnis-health-embrace®-blood-glucose-test-strips-apx03ab0302",
      "title": "Omnis Health Embrace® Blood Glucose Test Strips APX03AB0302",
      "vendor": "Medsitis",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5bc5cc0a94840d6084f0c6c58cd1c91c65c51b02.jpg?v=1781969183",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "omnis",
        "health",
        "embrace",
        "blood",
        "glucose",
        "test",
        "strips",
        "apx03ab0302",
        "medsitis"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "glucose_diabetes_monitoring"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 55,
        "sustainability": 40
      },
      "price": 5.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431072190661",
      "vsf_explanation": "Consumer glucose test strips for Omnis Embrace no-code BGM system. Budget FDA-cleared meter/strip pairing that works but doesn't rival premium accuracy of Contour Next or Accu-Chek Guide.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "omnis-health-embrace®-talk-blood-glucose-test-strips-apx03ab0304",
      "title": "Omnis Health Embrace® Talk Blood Glucose Test Strips APX03AB0304",
      "vendor": "Medsitis",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f4952d54ef1cf04b81ff506df2fdbb6ab670b2fa.jpg?v=1781969202",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "omnis",
        "health",
        "embrace",
        "talk",
        "blood",
        "glucose",
        "test",
        "strips",
        "apx03ab0304",
        "medsitis"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "glucose_diabetes_monitoring"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 55,
        "sustainability": 40
      },
      "price": 32.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431072321733",
      "vsf_explanation": "Consumer glucose test strips paired to Embrace Talk meter (a voice-output BGM designed for visually-impaired users). Real accessibility use case but the underlying meter is a budget FDA-cleared BGM, less accurate than premium meters. Strips only, no meter included.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "clinistix™-kidney-health-test-kit-urine-test-strips-five-tests-11694839",
      "title": "Clinistix™ Kidney Health Test Kit, Urine Test Strips, Five Tests 11694839",
      "vendor": "Medsitis",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/22878060e541f9805c51d5fb407a4ed9fffce2ff.jpg?v=1781969231",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "clinistix",
        "kidney",
        "health",
        "test",
        "kit",
        "urine",
        "test",
        "strips",
        "five",
        "tests",
        "11694839",
        "medsitis"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "blood_panel_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 78,
        "safety": 78,
        "transparency": 60,
        "sustainability": 40
      },
      "price": 51.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431072583877",
      "vsf_explanation": "Siemens Healthineers dipstick measuring urine albumin and creatinine (ACR) as an early screen for chronic kidney disease. ACR is a real, guideline-endorsed CKD marker (KDIGO/ADA). Siemens is a top-tier manufacturer with decades of urinalysis chemistry. Only 5 strips per pack limits repeat testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mhc-medical-products-easy-touch-health-pro-glucose-test-strips-2-x-25",
      "title": "Mhc Medical Products Easy Touch Health Pro Glucose Test Strips 2 X 25",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/121053409.jpg?v=1781969251",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mhc",
        "medical",
        "products",
        "easy",
        "touch",
        "health",
        "pro",
        "glucose",
        "test",
        "strips",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "glucose_diabetes_monitoring"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 55,
        "sustainability": 40
      },
      "price": 10.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431097127109",
      "vsf_explanation": "Standard consumer blood glucose test strips paired to the MHC Easy Touch meter - a low-cost budget glucose monitoring platform. Accuracy is FDA-registered but generally trails premium meters like Contour Next in ISO 15197 head-to-heads. Perfectly acceptable low-cost fingerstick option.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "syphilis-health-check™-infectious-disease-immunoassay-sexual-health-test-kit-1001-0698",
      "title": "Syphilis Health Check™ Infectious Disease Immunoassay Sexual Health Test Kit 1001-0698",
      "vendor": "Medsitis",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6c069e8970ab01f45acc4970e21ba369fa4dacb8.jpg?v=1781969264",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "syphilis",
        "health",
        "check",
        "infectious",
        "disease",
        "immunoassay",
        "sexual",
        "health",
        "test",
        "kit",
        "1001",
        "0698",
        "medsitis"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "sti_infectious_disease"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 65,
        "manufacturing": 70,
        "safety": 75,
        "transparency": 60,
        "sustainability": 40
      },
      "price": 319.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431170789573",
      "vsf_explanation": "Syphilis Health Check is the first FDA-cleared and CLIA-waived rapid syphilis (treponemal) antibody immunoassay. It is a real professional POC test with published validation, though sensitivity/specificity in the ~70-90% range make it a screening tool that requires confirmatory testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "digital-arm-blood-pressure-monitor-lcd-digital-heart-beat-bp-gauge-health-test-w-voice",
      "title": "Digital Arm Blood Pressure Monitor LCD Digital Heart Beat BP Gauge Health Test w/Voice",
      "vendor": "Best Product Finds",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/FFF-GPCT2072.jpg?v=1781969278",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "digital",
        "arm",
        "blood",
        "pressure",
        "monitor",
        "lcd",
        "digital",
        "heart",
        "beat",
        "gauge",
        "health",
        "test",
        "voice",
        "best",
        "product",
        "finds"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "blood_pressure"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 35,
        "manufacturing": 30,
        "safety": 45,
        "transparency": 25,
        "sustainability": 30
      },
      "price": 55.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431253889221",
      "vsf_explanation": "Unbranded generic Chinese-import blood pressure cuff sold through a marketplace reseller ('Best Product Finds'). No manufacturer name, no model number, no listed FDA clearance for a device category that is FDA-regulated. BP measurement error from uncleared cuffs can lead to real clinical mismanagement.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "mineral-deficiency-heavy-metals-metabolism-analysis-take-your-hair-sample-in-5-min-or-less",
      "title": "Mineral Deficiency, Heavy Metals, & Metabolism Analysis - Take your hair sample in 5 min or less",
      "vendor": "Upgraded Formulas®",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HairTestKitwithBanner_2ff1f722-5859-4890-be72-3939d753ee1b.png?v=1781969328",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mineral",
        "deficiency",
        "heavy",
        "metals",
        "metabolism",
        "analysis",
        "take",
        "your",
        "hair",
        "sample",
        "min",
        "less",
        "upgraded",
        "formulas"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "heavy_metals_toxins"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 50,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 149.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431546572997",
      "vsf_explanation": "Upgraded Formulas is a legitimate biohacking brand offering Hair Tissue Mineral Analysis (HTMA) with a consultation. HTMA is popular in functional-medicine circles for detecting mineral imbalances and heavy metal burden, but mainstream reviews (including a widely-cited JAMA study) show poor reproducibility between labs and weak correlation with tissue stores. Useful narrative tool, weak diagnostic.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nmn-resveratrol-capsules",
      "title": "NMN + Resveratrol Capsules",
      "vendor": "Neurogan Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NMN_Resveratrol_Capsules_3dbfe4de-1684-4d0d-a262-1b4a0c8db5fe.jpg?v=1781969356",
      "score": 53,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nmn",
        "resveratrol",
        "capsules",
        "neurogan",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431654838469",
      "vsf_explanation": "1200 mg NMN + trans-resveratrol combo. Human NMN evidence is emerging (Yoshino 2021 improved insulin sensitivity at 250 mg; Igarashi 2022 safety at 1250 mg), but the description does not split the 1200 mg between NMN and resveratrol, weakening transparency. Neurogan lists third-party lab testing, keeping this out of auto-fail territory but limiting confidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "heartscare-c1-lactate-meter-testing-kit-with-10-strips-5-sec-testing-time",
      "title": "HeartsCare C1 Lactate Meter Testing Kit with 10 strips- 5 sec Testing time",
      "vendor": "Hearts Bio, Inc.",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HeartsCare_C1_lactate_test_kit_with_10strips_1500.jpg?v=1781969433",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "heartscare",
        "lactate",
        "meter",
        "testing",
        "kit",
        "with",
        "strips",
        "sec",
        "testing",
        "time",
        "hearts",
        "bio",
        "inc"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "blood_panel_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 179.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431670894789",
      "vsf_explanation": "Consumer lactate meter targeted at endurance athletes for training-zone testing. Lactate testing is legitimate but this product lacks published accuracy comparison against gold-standard Lactate Pro/Scout devices, and no FDA clearance is claimed for the lactate variant.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "heartscare-c1-plus-total-cholesterol-meter-test-kit-at-home-with-20-strips",
      "title": "HeartsCare C1 Plus Total Cholesterol Meter Test Kit at Home with 20 strips",
      "vendor": "Hearts Bio, Inc.",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HeartsCare_C1_plus_cholesterol_test_kit_with_20strips_1500.jpg?v=1781969443",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "heartscare",
        "plus",
        "total",
        "cholesterol",
        "meter",
        "test",
        "kit",
        "home",
        "with",
        "strips",
        "hearts",
        "bio",
        "inc"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "blood_panel_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 60,
        "manufacturing": 65,
        "safety": 75,
        "transparency": 68,
        "sustainability": 45
      },
      "price": 159.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431670993093",
      "vsf_explanation": "Same FDA 510(k)-cleared consumer cholesterol meter as the 10-strip version, just with 20 strips. Total cholesterol only, no lipid subfractions - a limited but honest tool for at-home cholesterol tracking.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "heartscare-c1-plus-total-cholesterol-meter-test-kit-at-home-with-10-strips",
      "title": "HeartsCare C1 Plus Total Cholesterol Meter Test Kit at Home with 10 strips",
      "vendor": "Hearts Bio, Inc.",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HeartsCare_C1_plus_cholesterol_test_kit_with_10strips_1500.jpg?v=1781969453",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "heartscare",
        "plus",
        "total",
        "cholesterol",
        "meter",
        "test",
        "kit",
        "home",
        "with",
        "strips",
        "hearts",
        "bio",
        "inc"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "blood_panel_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 60,
        "manufacturing": 65,
        "safety": 75,
        "transparency": 68,
        "sustainability": 45
      },
      "price": 139.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431671025861",
      "vsf_explanation": "Consumer at-home total cholesterol meter with claimed FDA 510(k) clearance. Total cholesterol alone is limited (LDL and ApoB are more actionable), but the device does what it advertises. Hearts Bio is a smaller player vs CardioChek but the FDA claim boosts credibility.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sedi-rate™-esr-autozero-westergren-hematology-test-kit-3469",
      "title": "Sedi-Rate™ ESR Autozero Westergren Hematology Test Kit 3469",
      "vendor": "Medsitis",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d2732593685031ff7e1f2e7e4ecd200a952cdb2a.jpg?v=1781969471",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sedi",
        "rate",
        "esr",
        "autozero",
        "westergren",
        "hematology",
        "test",
        "kit",
        "3469",
        "medsitis"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "blood_panel_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 72,
        "safety": 75,
        "transparency": 60,
        "sustainability": 40
      },
      "price": 132.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431671091397",
      "vsf_explanation": "ESR (erythrocyte sedimentation rate) is a decades-old, well-standardized inflammation marker; the Westergren method used here is the reference method. However, ESR is non-specific and largely superseded by CRP for inflammation monitoring, and this is a professional lab consumable rather than a consumer product.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nowfuture-dna-fitness-test-kit",
      "title": "NowFuture DNA Fitness Test Kit",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SAP_GTK_0101_PACKAGE_06_LW_v01_00004-min-Copy.webp?v=1781969487",
      "score": 41,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nowfuture",
        "dna",
        "fitness",
        "test",
        "kit",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "genetic_dna"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 45,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 107.85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431671288005",
      "vsf_explanation": "DNA-based fitness/exercise-response kit that markets ACTN3, ACE and similar SNPs as prescriptive. RCT evidence shows genotype-guided training does not outperform standard periodization for most people. NOWFUTURE is an obscure brand with no disclosed lab accreditation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nowfuture-dna-sleep-test-kit",
      "title": "NOWFUTURE DNA Sleep Test Kit",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/668a8d6aded42d06d4339bde-dna-sleep-test-at-home-dna-collection.jpg?v=1781969497",
      "score": 41,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nowfuture",
        "dna",
        "sleep",
        "test",
        "kit",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "genetic_dna"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 45,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 107.85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431671386309",
      "vsf_explanation": "DNA-based sleep recommendation kit claiming SNPs can guide sleep timing, caffeine sensitivity, and chronotype interventions. The underlying SNP associations are individually weak with small effect sizes and no evidence that acting on the results improves sleep outcomes. NOWFUTURE is not an established lab and no CLIA/CAP status is disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "homedna™-dna-ancestry-analysis-report-test-kit",
      "title": "HomeDNA™ DNA Ancestry Analysis & Report Test Kit",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/51440564.jpg?v=1781969509",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "homedna",
        "dna",
        "ancestry",
        "analysis",
        "report",
        "test",
        "kit",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "genetic_dna"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 35,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 30,
        "sustainability": 35
      },
      "price": 5.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431671615685",
      "vsf_explanation": "Ancestry-only DNA kit with no health, wellness, or biohacking output. The $5.99 price also suggests this is just the collection swab with lab processing sold separately.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "bd-veritor-system-rapid-test-kit",
      "title": "BD Veritor System Rapid Test Kit",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/43790858_e49ee9d1-40d7-46f2-a079-5a4b1b9aecc9.jpg?v=1781969526",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "veritor",
        "system",
        "rapid",
        "test",
        "kit",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "sti_infectious_disease"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 78,
        "safety": 75,
        "transparency": 50,
        "sustainability": 40
      },
      "price": 122.85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431671779525",
      "vsf_explanation": "BD Veritor is a legitimate professional point-of-care rapid antigen platform with digital reader that reduces subjective interpretation error. Manufacturer (BD/Becton Dickinson) is top-tier. Listing does not specify the target analyte (flu vs RSV vs COVID vs Strep A) which lowers transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nowfuture-personalized-nutrition-dna-test-kit",
      "title": "NOWFUTURE Personalized Nutrition DNA Test Kit",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SAP_GTK_0101_PACKAGE_06_LW_v01_00003-min-Copy.webp?v=1781969535",
      "score": 41,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nowfuture",
        "personalized",
        "nutrition",
        "dna",
        "test",
        "kit",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "genetic_dna"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 45,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 107.85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431671877829",
      "vsf_explanation": "Nutrigenomics/DNA-diet tests like this claim personalized macronutrient recommendations from a handful of SNPs, but multiple systematic reviews (including a large RCT) have found no meaningful clinical or behavioral benefit over standard dietary advice. NOWFUTURE is not a well-known brand and no lab/CLIA/CAP details are provided.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bacterium-test-kit-for-water-and-sprinkler-systems",
      "title": "Bacterium Test Kit for Water and Sprinkler Systems",
      "vendor": "Fire Protection Parts",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/bacterium-test-kit-for-water-and-sprinkler-systems-4290328.jpg?v=1781969562",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bacterium",
        "test",
        "kit",
        "for",
        "water",
        "and",
        "sprinkler",
        "systems",
        "fire",
        "protection",
        "parts"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "heavy_metals_toxins"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 30,
        "manufacturing": 45,
        "safety": 40,
        "transparency": 30,
        "sustainability": 25
      },
      "price": 368.27,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431672238277",
      "vsf_explanation": "This is an industrial bacterial contamination test for fire sprinkler and industrial water systems - it detects MIC bacteria that corrode fire suppression pipework. It is not a human health or biohacking product.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "quickvue-influenza-a-b-test-kit-25-count",
      "title": "QuickVue Influenza A+B Test Kit (25 Count)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/QVFluAandB25T_23043058.jpg-650.webp?v=1781969585",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "quickvue",
        "influenza",
        "test",
        "kit",
        "count",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "sti_infectious_disease"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 70,
        "manufacturing": 80,
        "safety": 80,
        "transparency": 65,
        "sustainability": 40
      },
      "price": 392.45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431672303813",
      "vsf_explanation": "Quidel's QuickVue Influenza A+B is a widely-used lateral-flow rapid antigen test for point-of-care clinical use with FDA clearance and strong published validation data. Genuine clinical-grade tool from a reputable IVD manufacturer.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "urincheck™-healthscreen-urinalysis-test-kit-uc81200",
      "title": "UrinCheck™ HealthScreen Urinalysis Test Kit UC81200",
      "vendor": "Medsitis",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/07051c7d94d67324e71d5f643216c0c612a91dd0.jpg?v=1781969610",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "urincheck",
        "healthscreen",
        "urinalysis",
        "test",
        "kit",
        "uc81200",
        "medsitis"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "blood_panel_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 65,
        "safety": 75,
        "transparency": 60,
        "sustainability": 40
      },
      "price": 40.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431672631493",
      "vsf_explanation": "10-parameter urine reagent dipstick (glucose, ketones, blood, pH, protein, nitrites, leukocytes, etc). Long-standing point-of-care screening chemistry with solid reliability but limited specificity - dipsticks flag issues but rarely diagnose them. Fine as a low-cost baseline home screen.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "oncotect-essential-at-home-dog-cancer-screening-test-kit",
      "title": "Oncotect Essential At-Home Dog Cancer Screening Test Kit",
      "vendor": "Jeffers",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/oncotect-essential-at-home-dog-cancer-screening-test-kit-otc1-4129591.jpg?v=1781969646",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "oncotect",
        "essential",
        "home",
        "dog",
        "cancer",
        "screening",
        "test",
        "kit",
        "jeffers"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "cancer_chronic_screening"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 35,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 35,
        "sustainability": 30
      },
      "price": 129.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431672860869",
      "vsf_explanation": "Urine-based cancer screening test for dogs. This is a veterinary product, not a human biohacking test.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "heartscare-c1-plus-glucose-ketone-meter-testing-kit-with-ketone-50-count-and-glucose-test-strips-50-count",
      "title": "HeartsCare C1 Plus Glucose & Ketone Meter Testing Kit with Ketone (50 count) and Glucose Test Strips (50 count)",
      "vendor": "Hearts Bio, Inc.",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HeartsCare_C1_plus_Ketone_test_kit_with_100strips_1500.jpg?v=1781969657",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "heartscare",
        "plus",
        "glucose",
        "ketone",
        "meter",
        "testing",
        "kit",
        "with",
        "ketone",
        "count",
        "and",
        "glucose",
        "test",
        "strips",
        "count",
        "hearts",
        "bio",
        "inc"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "glucose_diabetes_monitoring"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 135.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431672991941",
      "vsf_explanation": "A consumer combo meter measuring blood glucose and beta-hydroxybutyrate ketones from small blood samples. Useful for keto and metabolic-health self-experimenters. Hearts Bio is a small vendor - device is functional but less validated than dominant brands like Keto-Mojo or Precision Xtra.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sofia®-influenza-a-b-fia-respiratory-test-kit-20218",
      "title": "Sofia® Influenza A+B FIA Respiratory Test Kit 20218",
      "vendor": "Medsitis",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/478bd824715e2dc2563342dffc4632b08de07121.jpg?v=1781969695",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sofia",
        "influenza",
        "fia",
        "respiratory",
        "test",
        "kit",
        "20218",
        "medsitis"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "sti_infectious_disease"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 70,
        "manufacturing": 80,
        "safety": 80,
        "transparency": 65,
        "sustainability": 40
      },
      "price": 537.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431673319621",
      "vsf_explanation": "Quidel's Sofia Influenza A+B FIA is a professional CLIA-waived fluorescence immunoassay that is widely used in clinical point-of-care settings. Solid analytical performance vs PCR, established manufacturer, and rapid turnaround. Professional use tool but genuinely rigorous.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "canine-progesterone-rapid-quantitative-testing-kit-immunofluorescence-chromatography-10-kits",
      "title": "Canine Progesterone Rapid Quantitative Testing Kit (Immunofluorescence Chromatography-10 kits)",
      "vendor": "Horizon Animal Care",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/testkit-2_cRelaxinb.webp?v=1781969755",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "canine",
        "progesterone",
        "rapid",
        "quantitative",
        "testing",
        "kit",
        "immunofluorescence",
        "chromatography",
        "kits",
        "horizon",
        "animal",
        "care"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "hormone_fertility_testing"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 30,
        "sustainability": 30
      },
      "price": 99.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431673778373",
      "vsf_explanation": "Veterinary reproductive test for dog breeders to time mating. Not a human biohacking product.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "a-d-weighing-bm-14-pipette-accuracy-testing-kit-for-bm-series",
      "title": "A&D Weighing BM-14 Pipette Accuracy Testing Kit for BM Series",
      "vendor": "DSCBalances",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/47f2817256e32ac1d13e7252090bc222.jpg?v=1781969768",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "weighing",
        "pipette",
        "accuracy",
        "testing",
        "kit",
        "for",
        "series",
        "dscbalances"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "blood_panel_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 30,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 35,
        "sustainability": 30
      },
      "price": 1545,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431674007749",
      "vsf_explanation": "This is a laboratory pipette calibration accessory for A&D analytical balances, aimed at lab QA technicians. It has nothing to do with human health, biohacking, or consumer diagnostics.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "pts-diagnostics-cardiochek-plus-lipid-eglu-smart-bundle-lipids-test-kit",
      "title": "PTS Diagnostics CardioChek Plus Lipid + eGLU Smart Bundle Lipids Test Kit",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/150282324.jpg?v=1781969798",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pts",
        "diagnostics",
        "cardiochek",
        "plus",
        "lipid",
        "eglu",
        "smart",
        "bundle",
        "lipids",
        "test",
        "kit",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "blood_panel_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 70,
        "manufacturing": 78,
        "safety": 75,
        "transparency": 65,
        "sustainability": 45
      },
      "price": 298.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431674237125",
      "vsf_explanation": "The PTS CardioChek Plus is a well-established point-of-care lipid and glucose analyzer used in clinical practice. Delivers cholesterol, triglycerides, and glucose from a single fingerstick in minutes. Strong validation and manufacturer track record, though intended for healthcare-professional use.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "a1cnow®-self-check-hba1c-diabetes-management-hba1c-test-kit-3070",
      "title": "A1CNow® Self Check HbA1c Diabetes Management HbA1c Test Kit 3070",
      "vendor": "Medsitis",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/23d81b05e1697912839a910d18c0d9a7a9244909.jpg?v=1781969835",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "a1cnow",
        "self",
        "check",
        "hba1c",
        "diabetes",
        "management",
        "hba1c",
        "test",
        "kit",
        "3070",
        "medsitis"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "glucose_diabetes_monitoring"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 70,
        "manufacturing": 75,
        "safety": 80,
        "transparency": 65,
        "sustainability": 40
      },
      "price": 102.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431674400965",
      "vsf_explanation": "A1CNow is a legitimate FDA-cleared at-home HbA1c monitoring system that provides lab-comparable results in 5 minutes from a fingerstick. HbA1c is the gold-standard glycemic control metric, and this is one of the few validated at-home options. Real utility for diabetics or metabolic health enthusiasts.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sofia®-rsv-fia-fluorescence-immunoassay-fia-respiratory-test-kit-20260",
      "title": "Sofia® RSV FIA Fluorescence Immunoassay (FIA) Respiratory Test Kit 20260",
      "vendor": "Medsitis",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/93cd0423f92d55af60cb3fa00132ceadcdb86c70.jpg?v=1781969856",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sofia",
        "rsv",
        "fia",
        "fluorescence",
        "immunoassay",
        "fia",
        "respiratory",
        "test",
        "kit",
        "20260",
        "medsitis"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "sti_infectious_disease"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 70,
        "manufacturing": 80,
        "safety": 80,
        "transparency": 65,
        "sustainability": 40
      },
      "price": 457.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431674630341",
      "vsf_explanation": "Quidel's Sofia RSV FIA is a professional CLIA-waived fluorescence immunoassay used in clinics and point-of-care settings. It has solid analytical validation and a well-established manufacturer. This is a professional device, not consumer biohacking gear, but its clinical rigor is real.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hemosure®-fecal-occult-blood-ifob-or-fit-colorectal-cancer-screening-test-kit-t1-ck30t",
      "title": "Hemosure® Fecal Occult Blood (iFOB or FIT) Colorectal Cancer Screening Test Kit T1-CK30T",
      "vendor": "Medsitis",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cc90d04408dbbe90b4ad44049aeb48c0cb440197.jpg?v=1781969917",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hemosure",
        "fecal",
        "occult",
        "blood",
        "ifob",
        "fit",
        "colorectal",
        "cancer",
        "screening",
        "test",
        "kit",
        "ck30t",
        "medsitis"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "cancer_chronic_screening"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 68,
        "manufacturing": 75,
        "safety": 82,
        "transparency": 65,
        "sustainability": 45
      },
      "price": 196.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431675646149",
      "vsf_explanation": "30-test bulk version of the FDA-cleared Hemosure iFOB (FIT) colorectal cancer screening test. Same strong evidence base as the 20-test pack: FIT is a first-line CRC screening modality endorsed by USPSTF. Cost-effective and clinically well-validated.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "all-paws-testing-pet-food-environmental-sensitivity-test-kit-400-triggers-identified-itching-digestive-skin-support-starts-here",
      "title": "ALL PAWS TESTING — Pet Food & Environmental Sensitivity Test Kit | 400+ Triggers Identified | Itching, Digestive & Skin Support Starts Here!",
      "vendor": "Horizon Animal Care",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/712_Kd2GYcL._AC_SL1500.jpg?v=1781969955",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "all",
        "paws",
        "testing",
        "pet",
        "food",
        "environmental",
        "sensitivity",
        "test",
        "kit",
        "400",
        "triggers",
        "identified",
        "itching",
        "digestive",
        "skin",
        "support",
        "starts",
        "here",
        "horizon",
        "animal",
        "care"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "food_sensitivity_allergy"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 25,
        "manufacturing": 30,
        "safety": 55,
        "transparency": 25,
        "sustainability": 30
      },
      "price": 99.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431675941061",
      "vsf_explanation": "Pet hair-based food sensitivity test. Setting aside the fact that this is a veterinary product outside Vyvata's human biohacking scope, hair-based food sensitivity testing has no validated scientific basis in any species.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "cancer-screening-test-kit-hemosure®-fecal-occult-blood-test-ifob-or-fit-20-tests-clia-waived-pre-pack-ifob20",
      "title": "Cancer Screening Test Kit Hemosure® Fecal Occult Blood Test (iFOB or FIT) 20 Tests CLIA Waived - PRE-PACK IFOB20",
      "vendor": "Medsitis",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d3ab0f0fcd7da37cd902714c225bb951345a6cdc.jpg?v=1781969983",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cancer",
        "screening",
        "test",
        "kit",
        "hemosure",
        "fecal",
        "occult",
        "blood",
        "test",
        "ifob",
        "fit",
        "tests",
        "clia",
        "waived",
        "pre",
        "pack",
        "ifob20",
        "medsitis"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "cancer_chronic_screening"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 68,
        "manufacturing": 75,
        "safety": 82,
        "transparency": 65,
        "sustainability": 45
      },
      "price": 201.2,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431676301509",
      "vsf_explanation": "The Hemosure iFOB (FIT) is a CLIA-waived, FDA-cleared immunochemical fecal occult blood test used broadly in real colorectal cancer screening programs. FIT has strong RCT evidence for reducing CRC mortality. The 20-test pre-pack format is oriented toward clinical use but usable at home.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "postpartum-recovery-bundle",
      "title": "Postpartum Recovery Bundle",
      "vendor": "Everydae",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitled_design_17.png?v=1781970081",
      "score": 49,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "postpartum",
        "recovery",
        "bundle",
        "everydae"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 75.6,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431677251781",
      "vsf_explanation": "Mood + Mama Support postpartum bundle. Postpartum nutrient stacks (omega-3, methylfolate, iron, choline - Hibbeln 2007 fish oil PPD RCT) are evidence-anchored but this bundle listing does not disclose per-SKU ingredients or doses. Just below Standard threshold.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "electrolyte-recovery-plus-powder-sugar-free",
      "title": "Electrolyte Recovery Plus Powder (Sugar-Free)",
      "vendor": "Key Nutrients",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Lemonade_7.webp?v=1781970094",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "electrolyte",
        "recovery",
        "plus",
        "powder",
        "sugar",
        "free",
        "key",
        "nutrients"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 65,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431677317317",
      "vsf_explanation": "Six electrolytes (Mg, K, Ca, Na, Cl, P) plus 12 vitamins, stevia sweetened. Rehydration with sodium+potassium+glucose/electrolyte solutions is well established (Shirreffs 1996). Exact per-serving mg of key electrolytes are not disclosed in the description, capping transparency; brand is mid-tier direct-to-consumer with limited third-party COAs.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnesium-mist-topical-magnesium-spray-for-sleep-recovery-natural-deodorant",
      "title": "Magnesium Mist — Topical Magnesium Spray for Sleep, Recovery & Natural Deodorant",
      "vendor": "Come Alive Herbals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/come-alive-magnesium-mist-8oz-clean-front.jpg?v=1781970107",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "mist",
        "topical",
        "magnesium",
        "spray",
        "for",
        "sleep",
        "recovery",
        "natural",
        "deodorant",
        "come",
        "alive",
        "herbals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 35,
        "sustainability": 55
      },
      "price": 40,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431678234821",
      "vsf_explanation": "Topical magnesium chloride spray with essential oils. Transdermal magnesium absorption evidence is weak (Gröber 2017 review found limited pharmacokinetic support), and no dose per spray is disclosed. Claims span sleep, recovery, deodorant, cycle support — exceeds evidence for topical mag.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "rapid-hangover-recovery-shot-in-natural-grape-flavor",
      "title": "Rapid Hangover Recovery Shot in Natural Grape Flavor",
      "vendor": "Dirty Saint",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Title_5.png?v=1781970120",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "rapid",
        "hangover",
        "recovery",
        "shot",
        "natural",
        "grape",
        "flavor",
        "dirty",
        "saint"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 30,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 20,
        "sustainability": 40
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431678529733",
      "vsf_explanation": "Marketed as 'proprietary Sinnergy Recovery Formula' with unquantified 'ancient herbal extracts and bioactive ingredients' promising liver detox, hydration, cognitive boost. Zero dose transparency and hangover cure claims are unsupported (Pittler 2005 hangover-remedy review: no reliable evidence).",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "magnesium-balm-muscle-relief-restful-recovery",
      "title": "Magnesium Balm - Muscle Relief & Restful Recovery",
      "vendor": "Dr. Doug's Balms",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_30dc50b7-cf55-46aa-a523-db99d903e997.png?v=1781970135",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "balm",
        "muscle",
        "relief",
        "restful",
        "recovery",
        "doug",
        "balms"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 65,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 15,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431678726341",
      "vsf_explanation": "Transdermal magnesium absorption is poorly supported — Kass 2017 was a small pilot suggesting some skin permeability, but Gröber 2017 concluded systemic effects from topical Mg are not demonstrated. Board-certified formulator gives brand credibility, but this substitutes topical for oral magnesium where evidence is thin. Reasonable clean carrier, no clinical dosing framework possible for a balm.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "recovery-balm-muscle-joint-recovery-support",
      "title": "Recovery Balm - Muscle + Joint Recovery Support",
      "vendor": "Dr. Doug's Balms",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_9cd406b6-646f-4cc5-b148-6ac3955b04ed.png?v=1781970142",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "recovery",
        "balm",
        "muscle",
        "joint",
        "recovery",
        "support",
        "doug",
        "balms"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 65,
        "transparency": 40,
        "sustainability": 55
      },
      "price": 15,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431678922949",
      "vsf_explanation": "Topical balm with organic arnica and magnesium chloride — reasonable adjunct for local soreness (topical arnica Cochrane 2016: modest evidence for bruising/OA), but topical route falls outside oral-supplement rubric. Dose of arnica and Mg per application not disclosed.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "dmso-cream-for-joint-muscle-recovery-alpha-warrior",
      "title": "DMSO Cream for Joint & Muscle Recovery | Alpha Warrior",
      "vendor": "Herbal Mana",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/dmso-cream-for-joint-muscle-recovery-alpha-warrior-dmso-cream-for-joint-muscle-recovery-alpha-warrior-4-oz-herbal-mana-698769811892-1200838212.jpg?v=1781970151",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dmso",
        "cream",
        "for",
        "joint",
        "muscle",
        "recovery",
        "alpha",
        "warrior",
        "herbal",
        "mana"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 42,
        "manufacturing": 45,
        "safety": 40,
        "transparency": 42,
        "sustainability": 45
      },
      "price": 34.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431679119557",
      "vsf_explanation": "99.995% pharma-grade DMSO topical with magnesium and essential oils. Topical DMSO has some RCT support for OA knee pain (Cochrane 2010 low-quality evidence) but is FDA-approved only for interstitial cystitis, and marketing implies broad disease relief. Not an ingestible supplement.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "placenta-encapsulation-kit-for-postpartum-recovery-pluscenta",
      "title": "Placenta Encapsulation Kit for Postpartum Recovery | Pluscenta",
      "vendor": "Pluscenta",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Not_lazy._Just_recovering._Postpartum_takes_time._13.png?v=1781970168",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "placenta",
        "encapsulation",
        "kit",
        "for",
        "postpartum",
        "recovery",
        "pluscenta",
        "pluscenta"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 30,
        "manufacturing": 40,
        "safety": 40,
        "transparency": 35,
        "sustainability": 30
      },
      "price": 375,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431679414469",
      "vsf_explanation": "This is a shipping and processing service for placenta encapsulation, not a biohacking device or diagnostic. Placenta encapsulation itself has no supporting clinical evidence and was flagged by the CDC after infant GBS transmission. This does not fit Vyvata's evaluation framework.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "tens-ems-pain-relief-recovery-system",
      "title": "TENS + EMS Pain Relief & Recovery System",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Main_image_97ab49df-fc55-4b74-b652-c9c971fd4f94.jpg?v=1781970181",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tens",
        "ems",
        "pain",
        "relief",
        "recovery",
        "system",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "ems_tens"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 70,
        "safety": 75,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 79.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431679447237",
      "vsf_explanation": "iReliev is an established US TENS/EMS brand with FDA-cleared units for pain relief and muscle stimulation. TENS/EMS has solid clinical evidence for symptomatic musculoskeletal pain and post-workout stimulation, though outcomes for 'recovery' are modest. Solid mid-tier consumer device but nothing groundbreaking.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "morning-recovery-energy",
      "title": "morning recovery + energy",
      "vendor": "More Labs",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MR_Energy_No_Shadow.png?v=1781970197",
      "score": 53,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "morning",
        "recovery",
        "energy",
        "more",
        "labs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 52,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 36,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431679545541",
      "vsf_explanation": "More Labs Morning Recovery is DHM-forward (dihydromyricetin) + electrolytes + prickly pear. DHM RCT evidence for hangover recovery is preclinical-heavy (Shen 2012 in mice) with limited human trials. Established DTC brand with a patent-pending formulation. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dmso-cream-for-joint-muscle-recovery-alpha-warrior-1",
      "title": "DMSO Cream for Joint & Muscle Recovery | Alpha Warrior",
      "vendor": "Herbal Mana",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/dmso-cream-for-joint-muscle-recovery-alpha-warrior-dmso-cream-for-joint-muscle-recovery-alpha-warrior-herbal-mana-1210416554.jpg?v=1781970211",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dmso",
        "cream",
        "for",
        "joint",
        "muscle",
        "recovery",
        "alpha",
        "warrior",
        "herbal",
        "mana"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 42,
        "manufacturing": 45,
        "safety": 40,
        "transparency": 42,
        "sustainability": 45
      },
      "price": 34.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431679807685",
      "vsf_explanation": "Duplicate SKU of the Alpha Warrior DMSO cream. Same evaluation applies: topical DMSO with limited OA RCT support (Cochrane 2010), broad disease-relief marketing, and route falls outside oral-supplement scoring.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "electrolyte-recovery-plus-powder-travel-packets",
      "title": "Electrolyte Recovery Plus Powder Travel Packets",
      "vendor": "Key Nutrients",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/unnamed.png?v=1781970242",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "electrolyte",
        "recovery",
        "plus",
        "powder",
        "travel",
        "packets",
        "key",
        "nutrients"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 58,
        "sustainability": 45
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431680266437",
      "vsf_explanation": "Key Nutrients Electrolyte Recovery Plus provides sodium, potassium, magnesium, calcium plus trace minerals; zero sugar. Hydration/electrolyte replacement evidence is well-established (Baker 2017 sports hydration review). Established brand with per-serving mineral disclosures typical. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "tart-cherry-cacao-plant-based-recovery-smoothie-pouch",
      "title": "Tart Cherry Cacao Plant-Based Recovery Smoothie Pouch",
      "vendor": "Neve Foods",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/TCC-6_ecb18ae7-2a85-425a-b316-ff495bd20375.png?v=1781970270",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tart",
        "cherry",
        "cacao",
        "plant",
        "based",
        "recovery",
        "smoothie",
        "pouch",
        "neve",
        "foods"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 4.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431680561349",
      "vsf_explanation": "Plant-based 4:1 carb:protein recovery pouch with tart cherry. Tart cherry has DOMS/inflammation RCTs (Howatson 2010 marathon trial). 4:1 carb:protein ratio matches endurance-recovery evidence (Ivy 2002). Dietitian-supported athlete brand. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "daily-glow-recovery-peptide-serum",
      "title": "DAILY GLOW: Recovery Peptide Serum",
      "vendor": "EVEDIA",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Serum-Marble-Mock.jpg?v=1781970288",
      "score": 28,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "daily",
        "glow",
        "recovery",
        "peptide",
        "serum",
        "evedia"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 35,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 25,
        "sustainability": 30
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431680889029",
      "vsf_explanation": "Topical five-peptide facial serum, not an ingestible supplement. Peptide names/percentages not disclosed and claims are limited to 'appearance of firmness' hedges. Outside oral supplement rubric.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "neoally-upgraded-dog-surgical-recovery-vest-for-dogs-and-cats",
      "title": "NeoAlly Upgraded Dog Surgical Recovery Vest for Dogs and Cats",
      "vendor": "Neoallypets",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/neoally-upgraded-dog-surgical-recovery-vest-for-dogs-and-cats-1282161.jpg?v=1781970320",
      "score": 17,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "neoally",
        "upgraded",
        "dog",
        "surgical",
        "recovery",
        "vest",
        "for",
        "dogs",
        "and",
        "cats",
        "neoallypets"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 10,
        "manufacturing": 25,
        "safety": 30,
        "transparency": 15,
        "sustainability": 15
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431681085637",
      "vsf_explanation": "Dog/cat post-surgical recovery vest - not a supplement, not for humans. Miscategorized SKU.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "myofascial-recovery-balls",
      "title": "myofascial recovery balls",
      "vendor": "the sclpt co",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/balls.jpg?v=1781970337",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "myofascial",
        "recovery",
        "balls",
        "the",
        "sclpt"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 15,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 20,
        "sustainability": 25
      },
      "price": 24,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431681380549",
      "vsf_explanation": "Massage/trigger-point balls - hardware, not a supplement. Myofascial release evidence (Cheatham 2015) supports self-myofascial release for DOMS but the product is equipment, not an ingested formula.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "recovery-patch",
      "title": "Recovery Patch",
      "vendor": "Rescue Patch",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Image-1_1_19367eb1-dc3e-4d44-bab6-7677bfd2265d.jpg?v=1781970355",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "recovery",
        "patch",
        "rescue",
        "patch"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 35,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 20,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431681609925",
      "vsf_explanation": "Transdermal patch listing DHM, NAC, glutathione, B1 and red ginseng for hangover support. Molecular weight/polarity of NAC and glutathione make meaningful transdermal absorption implausible; no controlled pharmacokinetic data are provided. Effective oral DHM dosing is on the order of hundreds of mg (Shen 2012), well above what a patch could deliver. Auto-failed on sub-therapeutic dose.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "morning-recovery",
      "title": "morning recovery",
      "vendor": "More Labs",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MR_OG_Bottle_No_Shadow.png?v=1781970379",
      "score": 53,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "morning",
        "recovery",
        "more",
        "labs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 36,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431681839301",
      "vsf_explanation": "DHM-based hangover drink from an established brand (More Labs). DHM has some preclinical support for alcohol-metabolite handling (Shen 2012 rodent) but human trial data are limited and mostly company-sponsored. Description references a proprietary 'patent-pending' formula and quotes an internal study (up to 80% better) without per-ingredient mg disclosure in this description, capping transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "warmth-postpartum-recovery-bundle",
      "title": "Warmth Postpartum Recovery Bundle",
      "vendor": "FAMMá FARM",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/congee_kits_3.jpg?v=1781970400",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "warmth",
        "postpartum",
        "recovery",
        "bundle",
        "famm",
        "farm"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 65,
        "transparency": 45,
        "sustainability": 65
      },
      "price": 88,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431682461893",
      "vsf_explanation": "A traditional postpartum food bundle (congee kits + herbal soup packet) rather than a standardized supplement. Whole-food, warming meals align with cross-cultural postpartum recovery practice (Dennis 2007 review) but the product provides no specific herb doses, no third-party COA, and no clinical validation. Safety is generally high for food-grade herbs.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ultimate-postpartum-recovery-bundle",
      "title": "Ultimate Postpartum Recovery Bundle",
      "vendor": "FAMMá FARM",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9_6d98f341-3583-4aa7-8518-f0b07b52384f.jpg?v=1781970412",
      "score": 53,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ultimate",
        "postpartum",
        "recovery",
        "bundle",
        "famm",
        "farm"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 58,
        "manufacturing": 50,
        "safety": 65,
        "transparency": 45,
        "sustainability": 65
      },
      "price": 175,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431682625733",
      "vsf_explanation": "Expanded version of the Warmth bundle adding lactation treats and granolas. Traditional postpartum nutrition supports recovery (Dennis 2007) and galactagogue herbs (fenugreek, oats) have modest lactation evidence (Bazzano 2016), but the bundle lists no herb-by-herb doses and no third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "recovery-bath-soak-athletes-choice",
      "title": "RECOVERY Bath Soak ***ATHLETES CHOICE***",
      "vendor": "KOMONI ®",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/recovery-bath-soak-18oz-epsom-salt-lavender-rosemary-essential-oil.jpg?v=1781970436",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "recovery",
        "bath",
        "soak",
        "athletes",
        "choice",
        "komoni"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 35,
        "safety": 60,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 12.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431682756805",
      "vsf_explanation": "Epsom salt + essential-oil bath soak — a topical bath product, not an ingestible supplement. Transdermal magnesium absorption from bathing is not well supported (Gröber 2017 review). Rejected as category mismatch.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "speedy-recovery-loose-leaf-tea",
      "title": "Speedy Recovery Loose Leaf Tea",
      "vendor": "Novel Tea Book Shop",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/speedy_recovery.webp?v=1781970454",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "speedy",
        "recovery",
        "loose",
        "leaf",
        "tea",
        "novel",
        "tea",
        "book",
        "shop"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 35,
        "safety": 60,
        "transparency": 35,
        "sustainability": 35
      },
      "price": 12.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431682920645",
      "vsf_explanation": "Herbal loose-leaf tea blend (green tea, ginger, mint, licorice, cardamom, cloves) sold as a wellness product, not a formulated supplement. Ingredients have general culinary/wellness support but no per-cup active dose is disclosed. Small tea shop, no COAs. Rejected: no meaningful supplement-grade dosing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "c-recovery-restoration-blend",
      "title": "C Recovery Restoration Blend",
      "vendor": "NYC Herbs®",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/rn-image_picker_lib_temp_82049d0e-4fec-474c-a6a5-0fd81284b570.jpg?v=1781970464",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "recovery",
        "restoration",
        "blend",
        "nyc",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 35,
        "manufacturing": 30,
        "safety": 30,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 15,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431683444933",
      "vsf_explanation": "Herbal tea marketed to 'restore depleted systems in bodies undergoing chemo treatment' — direct medical positioning around cancer therapy patients without any RCT support, and with real drug-interaction risk. No ingredients disclosed, no dose, no oncology-safety review.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "truss-k-recovery-650ml-21-98-fl-oz",
      "title": "TRUSS K RECOVERY 650ml / 21.98 fl.oz.",
      "vendor": "VIP Extensions",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/truss-k-recovery-650ml-2198-floz-1959063.jpg?v=1781970491",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "truss",
        "recovery",
        "650ml",
        "vip",
        "extensions"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 25,
        "manufacturing": 35,
        "safety": 30,
        "transparency": 20,
        "sustainability": 25
      },
      "price": 142,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431683805381",
      "vsf_explanation": "Truss K' Recovery is a hair-repair conditioning treatment (product type 'Hair Care'), not an ingestible supplement. Miscategorized in the supplement catalog.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "facial-enzyme-scrub-pink-regeneration",
      "title": "Facial Enzyme Scrub Pink Regeneration",
      "vendor": "Totemica Beauty",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Totemica_Skincare_MakeupMesa-de-trabajo-1-copia-5.png?v=1781970529",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "facial",
        "enzyme",
        "scrub",
        "pink",
        "regeneration",
        "totemica",
        "beauty"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 45,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 20,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431683969221",
      "vsf_explanation": "This is a topical exfoliating powder (malic acid, pineapple enzyme, niacinamide, kaolin), not an ingested supplement, and therefore falls outside the supplements rubric. Ingredient logic is reasonable for a face scrub but there is no oral bioavailability or nutrient content to assess.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "wrinkle-repair-retinol-night-cream-vegan-gluten-free-regenerating-anti-aging-moisturizer",
      "title": "Wrinkle Repair Retinol Night Cream – Vegan, Gluten-Free, Regenerating Anti-Aging Moisturizer",
      "vendor": "EpiLynx",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e49737d1-45d3-4fc0-9193-87a8346fb2f7.jpg?v=1781970536",
      "score": 28,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wrinkle",
        "repair",
        "retinol",
        "night",
        "cream",
        "vegan",
        "gluten",
        "free",
        "regenerating",
        "anti",
        "aging",
        "moisturizer",
        "epilynx"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 25,
        "sustainability": 30
      },
      "price": 39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431684067525",
      "vsf_explanation": "Topical retinol night cream — copy inconsistently cites 3% and 1% retinol. Not an ingestible supplement; topical retinoids fall outside the supplement rubric. Retinol RCTs (Kafi 2007) support anti-aging effects at 0.4% but this product's disclosure is contradictory.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "kerastase-nutritive-masquintense-regenerating-hair-mask-200-ml",
      "title": "Kérastase Nutritive Masquintense Regenerating Hair Mask 200 Ml",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/244276541.jpg?v=1781970555",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "rastase",
        "nutritive",
        "masquintense",
        "regenerating",
        "hair",
        "mask",
        "200",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 35,
        "sustainability": 35
      },
      "price": 65.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431684264133",
      "vsf_explanation": "This is a cosmetic hair conditioning mask by L'Oreal-owned Kerastase. It is exactly the type of product called out in Vyvata's exclusion criteria and does not belong in a biohacking catalog.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "valmont-regenerating-cleanser",
      "title": "Valmont REGENERATING CLEANSER",
      "vendor": "Nava Beauty",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/REGENERATING-CLEANSER.jpg?v=1781970574",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "valmont",
        "regenerating",
        "cleanser",
        "nava",
        "beauty"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 25,
        "sustainability": 30
      },
      "price": 135,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431684362437",
      "vsf_explanation": "Hair cleanser, not a supplement — no ingested nutrients, no dose, and no ingredient list disclosed. Cannot be evaluated under the supplement rubric.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "regenerum-spf-50-regenerating-lip-serum-5-g",
      "title": "Regenerum SPF 50+REGENERATING LIP SERUM 5 g",
      "vendor": "Zdrowie & Uroda",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/bregenerum-regeneracyjny-serum-do-ust-z-filtrem-ochronnym-spf-50-zdjecie_oI6kINA-thumbnail-450x450.png?v=1781970586",
      "score": 22,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "adults_50_plus",
      "tokens": [
        "regenerum",
        "spf",
        "regenerating",
        "lip",
        "serum",
        "zdrowie",
        "uroda"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 15,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 20,
        "sustainability": 30
      },
      "price": 12.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431684526277",
      "vsf_explanation": "Topical SPF50 lip serum with vitamin E, not an ingestible supplement. Miscategorized in this batch; belongs in the topical-skincare workstream.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "nature-s-nectar-regenerating-cleanser-shower-mask",
      "title": "Nature’s Nectar Regenerating Cleanser & Shower Mask",
      "vendor": "Sumbody Skincare",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/natures-nectar-shower-mask-01.jpg?v=1781970607",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "nectar",
        "regenerating",
        "cleanser",
        "shower",
        "mask",
        "sumbody",
        "skincare"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 60,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 24.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431684690117",
      "vsf_explanation": "A botanical cleansing paste marketed as a shower mask. It's a cosmetic skincare product, not a biohacking or health-tech device. It falls outside Vyvata's scope.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "valmont-eye-regenerating-mask-treatment",
      "title": "Valmont EYE REGENERATING MASK TREATMENT",
      "vendor": "Nava Beauty",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/EYE-REGENERATING-MASK-TREATMENT.jpg?v=1781970617",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "valmont",
        "eye",
        "regenerating",
        "mask",
        "treatment",
        "nava",
        "beauty"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 30,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 25,
        "sustainability": 25
      },
      "price": 425,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431684788421",
      "vsf_explanation": "Cosmetic under-eye collagen patches marketed as 'medical-grade' without any actual clearance. This is a luxury beauty product, not a biohacking or diagnostic device. Use of 'medical-grade' language without an underlying clearance is a red flag for a health-tech catalog.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "bioliq-35-regenerating-antioxidant-serum-30ml",
      "title": "Bioliq 35+ Regenerating Antioxidant Serum 30ml",
      "vendor": "Zdrowie & Uroda",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1__39286.png?v=1781970642",
      "score": 37,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bioliq",
        "regenerating",
        "antioxidant",
        "serum",
        "30ml",
        "zdrowie",
        "uroda"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 35,
        "sustainability": 30
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431685279941",
      "vsf_explanation": "Topical antioxidant facial serum (macadamia oil, acmella oleracea extract) — a cosmetic, not an ingestible supplement. Rejected as category mismatch.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "regenerum-regenerating-nail-polish-serum-8ml",
      "title": "Regenerum Regenerating Nail Polish Serum 8ml",
      "vendor": "Zdrowie & Uroda",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_02e5897a-9eb6-44eb-8990-a1110097832f.png?v=1781970650",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "regenerum",
        "regenerating",
        "nail",
        "polish",
        "serum",
        "8ml",
        "zdrowie",
        "uroda"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 35,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 30,
        "sustainability": 30
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431685312709",
      "vsf_explanation": "Topical nail serum with vitamins and algae oil — a cosmetic, not a supplement. Rejected as category mismatch.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "valmont-face-regenerating-mask-5-pieces",
      "title": "Valmont Face Regenerating Mask 5 Pieces",
      "vendor": "Nava Beauty",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0400012298988_NOCOLOR-1-scaled.webp?v=1781970658",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "valmont",
        "face",
        "regenerating",
        "mask",
        "pieces",
        "nava",
        "beauty"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 30,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 25,
        "sustainability": 25
      },
      "price": 695,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431685378245",
      "vsf_explanation": "This is a luxury Swiss cosmetic collagen sheet mask, not a biohacking device or diagnostic. Its 'regenerating' claim is a beauty marketing term, not clinical regeneration. It falls outside the wearables/diagnostics/sleep/recovery scope Vyvata evaluates.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "leonor-greyl-natural-regeneration-60-ml",
      "title": "Leonor Greyl Natural Regeneration 60 Ml",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/39587077.jpg?v=1781970672",
      "score": 24,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "leonor",
        "greyl",
        "natural",
        "regeneration",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 30,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 20,
        "sustainability": 30
      },
      "price": 60,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46431685476549",
      "vsf_explanation": "Scalp treatment oil (borage, Mimosa Tenuiflora). Cosmetic hair-care product, not an ingestible. Supplement rubric criteria (dose, RCTs) do not meaningfully apply.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "oxygen-for-sport-supplement",
      "title": "Oxygen For Sport Supplement",
      "vendor": "O2Boost",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/O2Boost_Blue.png?v=1783643860",
      "score": 48,
      "tier": "rejected",
      "certifications": [
        "Informed Sport"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "oxygen",
        "for",
        "sport",
        "supplement",
        "o2boost"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 45,
        "manufacturing": 65,
        "safety": 60,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 125,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46518999941317",
      "vsf_explanation": "Proprietary Ox66 'oxygen complex' in a capsule — oral oxygen supplementation has no plausible mechanism (systemic oxygen is delivered via lungs, not GI absorption) and no independent peer-reviewed human performance RCTs support the claim. Informed Sport batch testing raises manufacturing/safety scores but does not validate efficacy.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "o2boost-oxygen-supplement",
      "title": "O2Boost Oxygen Supplement",
      "vendor": "O2Boost",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/O2Boost-9658-2.jpg?v=1783643865",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "o2boost",
        "oxygen",
        "supplement",
        "o2boost"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 30,
        "sustainability": 50
      },
      "price": 125,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519000006853",
      "vsf_explanation": "Proprietary Ox66 'oxygen complex' with no ingredient breakdown or dose disclosure. Oral oxygen delivery in capsule form is not physiologically plausible for meaningful tissue oxygenation (Piantadosi 2006 reviews on oxygen therapy). Claims around jet lag, hangover, and altitude lack peer-reviewed RCT support.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "sputnik",
      "title": "Sputnik",
      "vendor": "Bio-Well",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/521b84b0-b560-4b46-977b-91ffe7c86d1a-2026-04-13.png?v=1783644050",
      "score": 15,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sputnik",
        "bio",
        "well"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 5,
        "formulation": 15,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 15,
        "sustainability": 20
      },
      "price": 349,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519010427077",
      "vsf_explanation": "Bio-Well 'Sputnik' antenna accessory that claims to measure 'ambient environmental energy fields' — no independent scientific validation, based on GDV pseudoscience. Not a supplement. Rejected for category mismatch and unverified/disease-adjacent claims.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bio-cor",
      "title": "Bio-Cor",
      "vendor": "Bio-Well",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Close_up_Bio-Cor_woman_third_eye.png?v=1783644055",
      "score": 15,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bio",
        "cor",
        "bio",
        "well"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 5,
        "formulation": 15,
        "manufacturing": 30,
        "safety": 35,
        "transparency": 15,
        "sustainability": 20
      },
      "price": 699,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519011147973",
      "vsf_explanation": "UHF 'frequency therapy' device claiming to embed 40–60 GHz millimeter waves into audio and 'inform water' — no peer-reviewed clinical evidence for the mechanism or clinical outcomes. Not a supplement. Rejected as category mismatch with pseudoscientific claims.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "the-glove",
      "title": "The Glove",
      "vendor": "Bio-Well",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/gloveelectorde.png?v=1783644056",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "the",
        "glove",
        "bio",
        "well"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 10,
        "manufacturing": 30,
        "safety": 45,
        "transparency": 20,
        "sustainability": 25
      },
      "price": 99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519011213509",
      "vsf_explanation": "Bio-Well GDV/EPI sensor accessory glove, not an ingestible supplement. Miscategorized in this batch; belongs in the biofield/wearable workstream.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "mello-magnesium-10-travel-sticks",
      "title": "Mellö Magnesium - 10 Travel Sticks",
      "vendor": "Foria",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SMLB10C001_melloLavenderberry10PackCaddy_Silo_Front_1603_Square.jpg?v=1783644372",
      "score": 74,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mell",
        "magnesium",
        "travel",
        "sticks",
        "foria"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 80,
        "manufacturing": 70,
        "safety": 75,
        "transparency": 70,
        "sustainability": 65
      },
      "price": 24,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519024779461",
      "vsf_explanation": "Three bioavailable magnesium forms (glycinate, lactate-gluconate, Aquamin) with GABA and L-theanine, ~325 mg elemental Mg per serving. Magnesium glycinate has RCT support for sleep quality (Abbasi 2012), L-theanine 200 mg supports subjective calm (Kim 2019). Foria is an established brand with third-party COAs. Deducted for GABA's questionable oral CNS absorption and mid-tier stress evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "shuteye-chai-magnesium-mushroom-latte",
      "title": "Shuteye Chai - Magnesium Mushroom Latte",
      "vendor": "Foria",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Shuteye_chai_front.png?v=1783644387",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shuteye",
        "chai",
        "magnesium",
        "mushroom",
        "latte",
        "foria"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519025074373",
      "vsf_explanation": "Nighttime latte with magnesium, L-theanine, reishi, and calming adaptogens. L-theanine 200mg has RCT support for sleep quality (Rao 2015) and magnesium glycinate improves subjective insomnia in older adults (Abbasi 2012), but Foria does not disclose per-serving doses on the product copy, so the ceiling is Standard rather than Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sleep-blend",
      "title": "Sleep Blend",
      "vendor": "Foria",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1501.png?v=1783644391",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sleep",
        "blend",
        "foria"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 82,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519025107141",
      "vsf_explanation": "Full-spectrum CBD + CBN tincture with calming botanicals. CBD/CBN preliminary work suggests modest sleep-onset benefit (Shannon 2019), but the copy does not list mg CBD/CBN per dropper and hemp-derived cannabinoids carry regulatory-ambiguity risk. Solid category brand but transparency and dose-labeling limit the ceiling.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mello-magnesium-pouch",
      "title": "Mellö Magnesium Pouch",
      "vendor": "Foria",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SMLBP001_melloLavenderberryPouch_Silo_Front_1628_Square.jpg?v=1783644396",
      "score": 74,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mell",
        "magnesium",
        "pouch",
        "foria"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 80,
        "manufacturing": 70,
        "safety": 75,
        "transparency": 70,
        "sustainability": 65
      },
      "price": 44,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519025139909",
      "vsf_explanation": "Same Mellö formula in bulk pouch: three magnesium forms + GABA + L-theanine. Mg glycinate for sleep (Abbasi 2012) and L-theanine for calm (Kim 2019) are well-supported at label doses. Foria posts third-party COAs; sustainability trimmed slightly for single-material sachets in the travel-stick line.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "de-stress-blend",
      "title": "De-Stress Blend",
      "vendor": "Foria",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ned-destress-blend-flatlays-PDP_V2.png?v=1783644405",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "stress",
        "blend",
        "foria"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 65,
        "safety": 60,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 82,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519025500357",
      "vsf_explanation": "Full-spectrum hemp CBD tincture with calming botanicals for stress. CBD has moderate support for anxiety (Blessing 2015 review; Shannon 2019 open-label). Foria publishes per-batch COAs and hemp source info, keeping transparency solid; deducted because customizable-dosing framing lets users under-dose (studied anxiolytic doses are 25–300 mg/day).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "daily-blend",
      "title": "Daily Blend",
      "vendor": "Foria",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/750_c13ae6fa-f6ac-4d50-bc8a-0734a7f4d06e.png?v=1783644410",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "daily",
        "blend",
        "foria"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 65,
        "safety": 60,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 72,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519025533125",
      "vsf_explanation": "Full-spectrum CBD daily-wellness tincture with adaptogenic botanicals. CBD evidence is moderate for anxiety and sleep (Shannon 2019). Foria posts COAs by batch. Description's 'flexible dosing' framing is honest but again lets users under-dose vs. studied 25–300 mg/day windows; hence Standard rather than Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "daily-capsules",
      "title": "Daily Capsules",
      "vendor": "Foria",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ned-daily-caps-PDP_front.png?v=1783644423",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "daily",
        "capsules",
        "foria"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 65,
        "safety": 60,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 82,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519025795269",
      "vsf_explanation": "15 mg CBD softgel dosed daily. Foria's manufacturing and COAs are solid, but 15 mg/day is below the anxiolytic window seen in RCTs (Shannon 2019 used 25 mg; Blessing 2015 cites higher). Copy also states 'aid immune function' — a broader claim than the CBD literature supports. Standard tier, not Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-d-mannose-complex-1400-mg-with-hibiscus-and-cranberry-180-veggie-caps",
      "title": "NusaPure D-Mannose Complex 1400 mg (with Hibiscus and Cranberry) - 180 Veggie Caps.",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8db744f6.jpg?v=1783644616",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "mannose",
        "complex",
        "1400",
        "with",
        "hibiscus",
        "and",
        "cranberry",
        "180",
        "veggie",
        "caps",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health",
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519028842693",
      "vsf_explanation": "D-mannose at 1,400 mg per serving is within the range shown to reduce recurrent UTI in Kranjcec 2014 RCT (2 g/day). Cranberry adds proanthocyanidins with modest UTI-prevention evidence (Jepson 2012 Cochrane). cGMP-registered facility but the blend dose vs mannose-alone is unclear.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-chlorophyll-200-1-extract-400-mg-60-veggie-caps-non-gmo-vegan-sodium-copper-chlorophyllin",
      "title": "NusaPure Chlorophyll 200:1 Extract, 400 mg 60 Veggie Caps, Non-GMO, Vegan, Sodium Copper Chlorophyllin",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-132365v2-Chlorophyll-Concentrate-3D-01.jpg?v=1783644620",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "chlorophyll",
        "200",
        "extract",
        "400",
        "veggie",
        "caps",
        "non",
        "gmo",
        "vegan",
        "sodium",
        "copper",
        "chlorophyllin",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519028875461",
      "vsf_explanation": "Sodium copper chlorophyllin 400 mg (as 200:1 extract). Chlorophyllin has plausible antioxidant activity and case data as a topical deodorizer (Egner 2003 for aflatoxin binding) but human systemic efficacy is thin. Dose disclosed; cGMP facility; simple single-ingredient product.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-reishi-mushroom",
      "title": "NusaPure Reishi Mushroom",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-131444v4-Reishi-Mushroom-HA-300-VCaps-3D-01-3.5x7.5.jpg?v=1783644632",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "reishi",
        "mushroom",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 48,
        "sustainability": 55
      },
      "price": 24.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519029039301",
      "vsf_explanation": "200mg Reishi 20:1 extract (~4g raw equivalent) with BioPerine, cGMP-registered facility. Reishi RCTs (Jin 2016 Cochrane cancer-adjunct review) are inconclusive and beta-glucan content is not standardized on the label. Amazon-brand budget positioning; testing not third-party disclosed.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "nusapure-gymnema-sylvestre-50-1-extract-250-mg-per-vegan-caps-150-count-non-gmo-vegan-bioperine",
      "title": "NusaPure Gymnema Sylvestre 50:1 Extract, 250 mg Per Vegan Caps - 150 Count (Non-GMO, Vegan, Bioperine)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-131666v3-GymnemaSylvestre-3D-01.jpg?v=1783644638",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "gymnema",
        "sylvestre",
        "extract",
        "250",
        "per",
        "vegan",
        "caps",
        "150",
        "count",
        "non",
        "gmo",
        "vegan",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 24.2,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519029268677",
      "vsf_explanation": "Single-ingredient Gymnema sylvestre 50:1 extract at 250 mg/cap with BioPerine, cGMP-registered US facility. Gymnema has modest RCTs for post-prandial glucose and sugar-craving reduction (Baskaran 1990; Shanmugasundaram 1990), and 250 mg of a 50:1 extract is in the effective range. No third-party COA or gymnemic-acid standardization is shown, capping it at Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-olive-leaf-50-1-extract-500-mg-50-oleuropein-vegan-vegetarian-super-strength-no-oil-60-capsules",
      "title": "NusaPure Olive Leaf 50:1 Extract, 500 mg - 50% Oleuropein Vegan/Vegetarian - Super Strength No Oil 60 Capsules",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-132413v2-OliveLeaf-3D-01.jpg?v=1783644646",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "olive",
        "leaf",
        "extract",
        "500",
        "oleuropein",
        "vegan",
        "vegetarian",
        "super",
        "strength",
        "oil",
        "capsules",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 16.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519029366981",
      "vsf_explanation": "Olive leaf extract 500 mg standardized to 50% oleuropein per capsule. Olive leaf has modest support for blood pressure lowering (Susalit 2011 vs captopril; De Bock 2013 insulin sensitivity). Standardization to a defined oleuropein % is a plus for formulation. NusaPure is an Amazon-tier brand: cGMP claim but limited third-party COA transparency and modest brand provenance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-thyroid-support-supplement-non-gmo-120-caps-ashwaganda-iodine-zinc-kelp-vitamin-b12-l-tyrosine-selenium-copper",
      "title": "NusaPure Thyroid Support Supplement (Non-GMO) 120 caps, Ashwaganda, Iodine, Zinc, kelp, Vitamin B12, L-Tyrosine, Selenium, Copper",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/05c7ba9e.jpg?v=1783644654",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "thyroid",
        "support",
        "supplement",
        "non",
        "gmo",
        "120",
        "caps",
        "ashwaganda",
        "iodine",
        "zinc",
        "kelp",
        "vitamin",
        "b12",
        "tyrosine",
        "selenium",
        "copper",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 40,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 20.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519029530821",
      "vsf_explanation": "14-ingredient thyroid stack (iodine, tyrosine, ashwagandha, selenium, kelp, bladderwrack, etc.) with no per-ingredient doses shown. Excess iodine plus kelp/bladderwrack can flip hyperthyroid/hypothyroid balance (Leung 2014) — dose transparency is critical for thyroid formulas and it is missing here.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "nusapure-shilajit-667mg-per-serving-180-veggie-caps-non-gmo-gluten-free-bioperine",
      "title": "NusaPure Shilajit 667mg per Serving, 180 Veggie Caps, Non-GMO, Gluten Free, Bioperine",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71_V6g77AeL._AC_SL1500.jpg?v=1783644660",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "shilajit",
        "667mg",
        "per",
        "serving",
        "180",
        "veggie",
        "caps",
        "non",
        "gmo",
        "gluten",
        "free",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic",
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 25.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519029629125",
      "vsf_explanation": "Shilajit 30:1 extract at 667 mg. Small RCTs (Pandit 2016 in Andrologia; Keller 2019) show modest fulvic-acid effects on testosterone and strength, but heavy-metal contamination is a known Shilajit risk without third-party testing. Bioperine included but no COA disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-vitamin-d3-50-000-iu-90-vegetarian-capsules-non-gmo",
      "title": "NusaPure Vitamin D3 50,000 IU 90 Vegetarian Capsules (Non-GMO)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fbaa4f41.jpg?v=1783644672",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "vitamin",
        "000",
        "vegetarian",
        "capsules",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 25,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 16.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519029825733",
      "vsf_explanation": "Vitamin D3 at 50,000 IU per capsule (1,250 mcg) is a prescription-level weekly-loading dose, well above the 4,000 IU/day upper limit for chronic use (IOM 2011). Sold on Amazon without dosing frequency guidance or physician instructions — real hypercalcemia / toxicity risk with daily use (Marcinowska-Suchowierska 2018). Underlying vitamin D evidence is strong, but the dose format makes this unsafe as a consumer product; rejected on safety.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-coral-calcium-with-22-vitamins-minerals-non-gmo-1000-mg-240-caps",
      "title": "NusaPure Coral Calcium with 22 Vitamins & Minerals, Non- GMO - 1000 mg - 240 Caps",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/964bfd9a.jpg?v=1783644680",
      "score": 47,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "coral",
        "calcium",
        "with",
        "vitamins",
        "minerals",
        "non",
        "gmo",
        "1000",
        "240",
        "caps",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 22.87,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519029924037",
      "vsf_explanation": "Coral calcium's superiority over calcium carbonate is unsupported (FTC settled with coral calcium marketers over health claims in 2004). 1,000 mg coral plus 22 unspecified vitamins/minerals - individual micronutrient doses are not disclosed on the label description. Environmental concerns for reef-sourced coral.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "nusapure-tribulus-terrestris-50-1-extract-1000-mg-120-veggie-caps-95-steroidal-saponins-non-gmo-bioperine",
      "title": "NusaPure Tribulus Terrestris 50:1 Extract, 1000 mg | 120 Veggie Caps | 95% Steroidal Saponins | Non-GMO, Bioperine",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nusapure-TribulusTerrestris-3D-v2-01.jpg?v=1783644687",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone",
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "tribulus",
        "terrestris",
        "extract",
        "1000",
        "120",
        "veggie",
        "caps",
        "steroidal",
        "saponins",
        "non",
        "gmo",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 23.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519030284485",
      "vsf_explanation": "Tribulus 50:1 at 1,000 mg standardized to 95% steroidal saponins. Meta-analysis of Tribulus for testosterone in men (Neychev 2016) shows no significant effect; some libido evidence in women. Extract standardization and dose are well-disclosed which prevents auto-fail.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-quercetin-complex-bromelain-vitamin-c-vitamin-d3-stinging-nettle-zinc-200-veggie-caps-non-gmo-bioperine",
      "title": "NusaPure Quercetin Complex: Bromelain, Vitamin C, Vitamin D3, Stinging Nettle, Zinc | 200 Veggie Caps (Non-GMO, Bioperine)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/00c1ad63.jpg?v=1783644694",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "quercetin",
        "complex",
        "bromelain",
        "vitamin",
        "vitamin",
        "stinging",
        "nettle",
        "zinc",
        "200",
        "veggie",
        "caps",
        "non",
        "gmo",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 34.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519030415557",
      "vsf_explanation": "Quercetin 500 mg is toward the low end of study-effective doses (Di Pierro 2021 for COVID showed benefit at 1000 mg with bromelain). Synergistic zinc + vitamin C + D3 stack is well-supported for immune modulation. Co-ingredient doses beyond quercetin are not disclosed in the description.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-olive-leaf-extract",
      "title": "NusaPure Olive Leaf Extract",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-127254v6-Olive-Leaf-60-3D-01.jpg?v=1783644702",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "olive",
        "leaf",
        "extract",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart",
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 17.8,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519030481093",
      "vsf_explanation": "Olive leaf extract standardized to 50% oleuropein at 750 mg is a well-defined dose. Susalit 2011 RCT showed olive leaf extract (500 mg twice daily) comparable to captopril for mild hypertension. Standardization is a strong plus; NusaPure lacks third-party testing disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-red-korean-panax",
      "title": "NusaPure Red Korean Panax",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-132167v5--NusapureOrganicRedKoreanPanaxGinseng-3D-01.jpg?v=1783644716",
      "score": 54,
      "tier": "standard",
      "certifications": [
        "USDA Organic"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "red",
        "korean",
        "panax",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 48,
        "sustainability": 60
      },
      "price": 28.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519030644933",
      "vsf_explanation": "450mg USDA-organic Korean red ginseng 20:1 extract, cGMP US-manufactured. Panax ginseng has moderate RCT support for fatigue and cognition (Ellis 2002; Reay 2005) at 200-400mg standardized to ~4% ginsenosides — this label does not list ginsenoside standardization. Budget Amazon brand.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "nusapure-tart-cherry-1-100mg-per-caps-150-count-vegan-non-gmo-gluten-free",
      "title": "NusaPure Tart Cherry 1,100mg per Caps, 150 Count, Vegan, Non-GMO, Gluten Free",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nusapure-Tart-Cherry-3D-v6-01.jpg?v=1783644731",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "tart",
        "cherry",
        "100mg",
        "per",
        "caps",
        "150",
        "count",
        "vegan",
        "non",
        "gmo",
        "gluten",
        "free",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective",
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 24.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519030874309",
      "vsf_explanation": "Tart cherry has moderate evidence for exercise recovery (Howatson 2010 marathon RCT) and sleep via melatonin (Losso 2018), but most trials use juice concentrate at ~480mg anthocyanins. The 52:1 extract at 1100mg is capsule-friendly but anthocyanin content is undisclosed. Bioperine added. Amazon-tier private label brand.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-magnesium-citrate-833mg-200-veggie-capsules-vegetarian-non-gmo-vegan",
      "title": "NusaPure Magnesium Citrate 833mg - 200 Veggie Capsules (Vegetarian, Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71b410f6.jpg?v=1783644737",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "magnesium",
        "citrate",
        "833mg",
        "200",
        "veggie",
        "capsules",
        "vegetarian",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients",
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 22,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519030972613",
      "vsf_explanation": "833mg magnesium citrate (~140mg elemental) is bioavailable (Walker 2003) but citrate is primarily used as an osmotic laxative — Ranade 2001 showed rapid GI-transit effects. Not the ideal chelate for sleep/stress (glycinate preferred). Product page appropriately flags dehydration and drug interaction cautions. Cheap Amazon brand, minimal transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-turmeric-curcumin-complex-150mg-per-caps-150-caps-non-gmo-gluten-free-bioperine",
      "title": "NusaPure Turmeric Curcumin Complex 150mg per caps, 150 caps, Non-GMO, Gluten-Free, & Bioperine",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nusapure-Turmeric-Curcumin-3D-v3-01.jpg?v=1783644743",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "turmeric",
        "curcumin",
        "complex",
        "150mg",
        "per",
        "caps",
        "150",
        "caps",
        "non",
        "gmo",
        "gluten",
        "free",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 30,
        "manufacturing": 40,
        "safety": 60,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 25.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519031070917",
      "vsf_explanation": "Label explicitly describes 'a proprietary blend of Turmeric Root extract 30:1 (standardized to 95% Curcuminoids) and Turmeric 30:1 Extract' at only 150 mg per capsule — the ratio between the two components and total curcuminoid mg are hidden. Meaningful joint / anti-inflammatory RCTs use 500–1500 mg curcuminoids/day (Daily 2016 meta-analysis). Auto-failed on hidden proprietary-blend dosing.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "nusapure-magnesium-oxide-1-000mg-per-serving-180-veggie-caps-non-gmo-vegan",
      "title": "NusaPure Magnesium Oxide 1,000mg per Serving 180 Veggie Caps (Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/68b726cf.jpg?v=1783644755",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "magnesium",
        "oxide",
        "000mg",
        "per",
        "serving",
        "180",
        "veggie",
        "caps",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 35,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 19.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519031234757",
      "vsf_explanation": "Magnesium oxide 1,000 mg per 2-cap serving. Magnesium oxide has one of the lowest bioavailabilities of any Mg form — Firoz 2001 measured ~4% absorption vs. 40%+ for citrate/glycinate — so 1,000 mg oxide delivers a fraction of the label dose while frequently causing osmotic diarrhea. Amazon-tier brand with limited COA transparency. Rejected on formulation quality despite headline mg.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-fush-free-niacin-suitable-for-vegetarian-vegan-non-gmo-500-mg-250-capsules",
      "title": "NusaPure FUSH Free Niacin - Suitable for Vegetarian/Vegan, Non - GMO - 500 mg - 250 Capsules",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6f868093.jpg?v=1783644764",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "fush",
        "free",
        "niacin",
        "suitable",
        "for",
        "vegetarian",
        "vegan",
        "non",
        "gmo",
        "500",
        "250",
        "capsules",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 28.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519031365829",
      "vsf_explanation": "'Flush-free' niacin (typically inositol hexanicotinate) 500 mg + 2.5 mg BioPerine. IHN does not measurably raise plasma niacin or affect lipids in humans — Meyers 2003 showed no HDL/LDL benefit — yet the copy claims to raise HDL and lower LDL. Auto-fail-adjacent on unverified cardiovascular claims + wrong form for the stated mechanism; kept out of hard auto-fail but rejected on evidence and transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-sleep-support-with-chamomile-magnesium-250-mg-60-per-tablet-vegetarian-vegan-non-gmo",
      "title": "NusaPure Sleep Support with Chamomile & Magnesium 250 mg 60 Per Tablet Vegetarian/Vegan, Non-GMO",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c3d470fc.jpg?v=1783644766",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "sleep",
        "support",
        "with",
        "chamomile",
        "magnesium",
        "250",
        "per",
        "tablet",
        "vegetarian",
        "vegan",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 25,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 60,
        "sustainability": 40
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519031398597",
      "vsf_explanation": "Magnesium is delivered as magnesium oxide (~4% elemental bioavailability per Walker 2003, Mag Res), which is a sub-therapeutic form for sleep versus glycinate or citrate. Chamomile at only 50 mg apigenin-standardized falls short of the 220–1500 mg used in Amsterdam 2009 anxiety RCT. cGMP-registered but no third-party COA, and the combination underdoses both actives.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "nusapure-forskohlii-4-1-extract-525-mg-per-veggie-caps-180-capsules-non-gmo-vegan-gluten-free",
      "title": "NusaPure Forskohlii 4:1 Extract, 525 mg per Veggie Caps - 180 Capsules (Non-GMO, Vegan & Gluten Free)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-125617v12-Forskohlii-3D-01.jpg?v=1783644772",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "forskohlii",
        "extract",
        "525",
        "per",
        "veggie",
        "caps",
        "180",
        "capsules",
        "non",
        "gmo",
        "vegan",
        "gluten",
        "free",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 40,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 21.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519031595205",
      "vsf_explanation": "Forskolin (Coleus forskohlii) evidence for fat loss is limited to one small RCT (Godard 2005) with modest body-composition change but no weight change. Blood-pressure lowering and interaction risk with anticoagulants and antihypertensives makes it unsafe without medical supervision. 4:1 extract at 525mg lacks a standardized forskolin% (research uses 10% standardized).",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "nusapure-l-tryptophan-suitable-for-vegetarian-vegan-non-gmo-1500mg-200-capsules",
      "title": "NusaPure L-Tryptophan - Suitable for Vegetarian/Vegan, Non - GMO - 1500mg 200 Capsules",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0a0aa62a.jpg?v=1783644787",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "tryptophan",
        "suitable",
        "for",
        "vegetarian",
        "vegan",
        "non",
        "gmo",
        "1500mg",
        "200",
        "capsules",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 27.3,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519031660741",
      "vsf_explanation": "1500 mg L-tryptophan per serving with BioPerine. Tryptophan modestly improves sleep latency and mood (Silber & Schmitt 2010) at doses of 1-3 g. cGMP US manufacture, non-GMO, vegan. Adequate transparency without a public COA. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-grapefruit-extract-500-mg-per-capsule-extract-10-1-bioperine-150-veggie-caps-gluten-free-non-gmo",
      "title": "NusaPure Grapefruit Extract 500 mg per Capsule (Extract 10:1) Bioperine 150 Veggie caps (Gluten Free & Non-GMO)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-129225v3-Grape-Seed-Extract-Plus-Bioperine-3D-01.jpg?v=1783644800",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "grapefruit",
        "extract",
        "500",
        "per",
        "capsule",
        "extract",
        "bioperine",
        "150",
        "veggie",
        "caps",
        "gluten",
        "free",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 21.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519031824581",
      "vsf_explanation": "Grapefruit seed extract 500 mg as 10:1 extract with 2 mg Bioperine. GSE literature is dominated by preservative-contamination reports (von Woedtke 1999 found benzethonium chloride in commercial GSE); intrinsic antimicrobial activity is disputed. Dose disclosed; safety flag due to potential CYP3A4 drug interactions.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-phosphatidylserine-memory-ultimate-complex-1000mg-200-vegetarian-caps-vegan-non-gmo",
      "title": "NusaPure Phosphatidylserine Memory Ultimate Complex 1000mg 200 Vegetarian Caps (Vegan, Non-GMO)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f9aa69b7.jpg?v=1783644804",
      "score": 47,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "phosphatidylserine",
        "memory",
        "ultimate",
        "complex",
        "1000mg",
        "200",
        "vegetarian",
        "caps",
        "vegan",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics",
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 25.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519031890117",
      "vsf_explanation": "1000 mg 'complex' per two-capsule serving combining phosphatidylserine, L-serine, ginkgo, gotu kola, rosemary and DMAE — individual doses not disclosed. PS has memory evidence at 300 mg standalone (Kato-Kataoka J Clin Biochem Nutr 2010) but can't confirm dose here. DMAE has limited human evidence and safety data. Amazon-tier vendor.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "nusapure-super-calcium-with-vitamin-d-3-calcium-citrate-suitable-for-vegetarian-non-gmo-1300mg-240-capsules",
      "title": "NusaPure Super Calcium with Vitamin D 3 & Calcium Citrate - Suitable for Vegetarian, Non - GMO - 1300mg - 240 Capsules",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3fc570b7.jpg?v=1783644813",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "super",
        "calcium",
        "with",
        "vitamin",
        "calcium",
        "citrate",
        "suitable",
        "for",
        "vegetarian",
        "non",
        "gmo",
        "1300mg",
        "240",
        "capsules",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 45,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 26.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519031955653",
      "vsf_explanation": "Calcium citrate 1300mg + vitamin D3 5000 IU (125 mcg) per serving in a cGMP facility. Calcium citrate is well-absorbed (Heaney 1999); however 5000 IU D3 daily exceeds the RDA (600-800 IU) and NAM's 4000 IU UL, raising safety concerns for chronic use. Amazon-tier brand with limited third-party testing evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-resveratrol-polyphenol-complex-1450mg-180-vegetarian-caps-non-gmo-vegan-vitamin-c",
      "title": "NusaPure Resveratrol & Polyphenol Complex 1450mg 180 Vegetarian Caps (Non-GMO, Vegan) Vitamin C",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f6273a63.jpg?v=1783644818",
      "score": 36,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "longevity",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "resveratrol",
        "polyphenol",
        "complex",
        "1450mg",
        "180",
        "vegetarian",
        "caps",
        "non",
        "gmo",
        "vegan",
        "vitamin",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 27.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519032086725",
      "vsf_explanation": "Marketed as 1450 mg per serving but labeled as a 'proprietary Polyphenols complex' with vitamin C - the resveratrol mg is not broken out. Resveratrol human longevity/cardiovascular evidence remains weak (Berman 2017), and prop-blend labeling hides actual actives.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "animal-creatine-xl-30-servings",
      "title": "Animal Creatine XL, 30 Servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/animal-creatine-xl-powder-watermelon..png?v=1783644871",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "animal",
        "creatine",
        "servings",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 25,
        "sustainability": 25
      },
      "price": 10,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519034872005",
      "vsf_explanation": "Creatine monohydrate itself has strong RCT support (Kreider 2017 ISSN position stand), but this listing explicitly warns customers may receive a different Animal product (SuperCharged Creatine) instead. Reseller cannot guarantee identity of what ships, and no dose, batch, or manufacturing details are provided by PoorBoy.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "smash-shilajit-60-capsules",
      "title": "Smash Shilajit, 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Picture21_097dc824-b1e1-4e55-80c0-bc98bff1dfbe.jpg?v=1783644882",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "smash",
        "shilajit",
        "capsules",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 30,
        "manufacturing": 35,
        "safety": 40,
        "transparency": 25,
        "sustainability": 25
      },
      "price": 10,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519035035845",
      "vsf_explanation": "Direct claims of promoting healthy testosterone and hormone balance from shilajit rest on one small Pandit 2016 pilot in andrologia — insufficient for hormonal disease claims. No fulvic acid %, no purified shilajit source (heavy metal risk is documented), no dose disclosure, and reseller may swap the product.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "collagen",
      "title": "Collagen",
      "vendor": "LIVS Gummies",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Collagen_gummy.png?v=1783644990",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "collagen",
        "livs",
        "gummies"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 25,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 35,
        "sustainability": 35
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519036182725",
      "vsf_explanation": "Collagen skin RCTs (Proksch 2014, de Miranda 2021) used 2.5–10 g/day of hydrolyzed peptides. Gummy delivery typically caps at 50–100 mg per gummy — orders of magnitude below clinical dose. Sugar-carried format with no peptide type or MW disclosed.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "vitamin-d-2-000-iu",
      "title": "Vitamin D (2,000 IU)",
      "vendor": "LIVS Gummies",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/LV3482Vit.D90ct-2.png?v=1783644996",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "000",
        "livs",
        "gummies"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 22.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519036248261",
      "vsf_explanation": "2000 IU cholecalciferol is a mid-range maintenance dose supported by Endocrine Society guidance (Holick 2011). Gummy format contains sugar and generally has lower/unstable D3 potency than softgels. Consumer brand without third-party testing or vitamin K2 pairing. Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-c-zinc",
      "title": "Vitamin C & Zinc",
      "vendor": "LIVS Gummies",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/LIVSVitaminsC_Zinc.png?v=1783645000",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "zinc",
        "livs",
        "gummies"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 40,
        "sustainability": 35
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519036346565",
      "vsf_explanation": "Vitamin C plus zinc has Cochrane-level support for cold duration (Hemila 2013) at 200 mg+ zinc lozenges and 1 g Vit C, but gummies rarely reach these thresholds and this listing does not disclose per-gummy mg. Marketing overstates metabolism and weight loss benefits which are not supported.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "b-complex-energy",
      "title": "B-Complex (Energy)",
      "vendor": "LIVS Gummies",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/LV3413B-Complex45ct-2.png?v=1783645007",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "complex",
        "energy",
        "livs",
        "gummies"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients",
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519036477637",
      "vsf_explanation": "Gummy B-complex with disclosed doses: B12 30 mcg, B6 2 mg, B3 20 mg, biotin 300 mcg, folate 240 mcg DFE. Doses are modest but appropriate for maintenance (RDA-level). Gummy format brings sugar and potency-stability concerns and typically loses B12 over shelf life. No third-party assay disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "berberine-2",
      "title": "Berberine",
      "vendor": "LIVS Gummies",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/LV4382Berberine90ct-2.png?v=1783645021",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "berberine",
        "livs",
        "gummies"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519036707013",
      "vsf_explanation": "Capsules of '100% pure berberine' but the description omits per-capsule mg — clinically studied dose is 500 mg 2-3x daily for glucose/lipid effects (Yin 2008). Without disclosed dose it is impossible to verify therapeutic level. Standard on brand and formulation basics.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-c",
      "title": "Vitamin C",
      "vendor": "LIVS Gummies",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/LV3529Vit.CFruitSlices60ct-2.png?v=1783645032",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "livs",
        "gummies"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 40,
        "sustainability": 35
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519036838085",
      "vsf_explanation": "Vitamin C evidence for immune modulation is solid (Carr & Maggini 2017) but requires 200 mg+ daily. Gummy per-serving dose is not disclosed here, and marketing implies metabolic and weight loss benefits that are unsupported by literature.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "apple-cider-vinegar-plus",
      "title": "Apple Cider Vinegar Plus",
      "vendor": "LIVS Gummies",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/LV3163_ACV_PLUS_48ct-2.png?v=1783645037",
      "score": 39,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "apple",
        "cider",
        "vinegar",
        "plus",
        "livs",
        "gummies"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 40,
        "sustainability": 35
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519037001925",
      "vsf_explanation": "ACV weight-loss evidence rests largely on Kondo 2009 (Japanese) at 15–30 mL liquid vinegar daily. Gummies contain heat-processed powder with negligible acetic acid, and the 'Mother' is destroyed during drying. Metabolism and gut health claims are not supported at gummy doses.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "turmeric-ginger",
      "title": "Turmeric & Ginger",
      "vendor": "LIVS Gummies",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Turmeric_Ginger_Gummies.webp?v=1783645042",
      "score": 48,
      "tier": "rejected",
      "certifications": [
        "Non-GMO Project Verified"
      ],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "turmeric",
        "ginger",
        "livs",
        "gummies"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46519037067461",
      "vsf_explanation": "Gummy turmeric/ginger without disclosed curcumin content or piperine/phospholipid enhancer. Curcumin RCTs (e.g. Daily 2016 meta-analysis) use 500-1500 mg standardized extract — gummies rarely reach a fraction of that. Sub-therapeutic dose is the likely reality.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "mama-expecting",
      "title": "Mama Expecting",
      "vendor": "Everydae",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Mama_Expecting_Prenatal_Multivitamin.jpg?v=1783743340",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mama",
        "expecting",
        "everydae"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 46,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523071103173",
      "vsf_explanation": "Prenatal with 23 vitamins/minerals — prenatal category itself has the strongest OB-GYN endorsement of any supplement segment (ACOG folate 400-800 mcg, iodine 150 mcg, iron 27 mg, choline 450 mg). Everydae's positioning is credible; individual ingredient forms (methylfolate vs folic acid) and third-party testing detail aren't in this description, capping the score.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mama-support",
      "title": "Mama Support",
      "vendor": "Everydae",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Mama_Support_Postnatal_Multivitamin.jpg?v=1783743346",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mama",
        "support",
        "everydae"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 42,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523071135941",
      "vsf_explanation": "Everydae postnatal multivitamin covering 23 nutrients targeting recovery, milk supply and postpartum energy — the right category framing. Two-cap daily serving allows meaningful per-nutrient dosing versus a single-cap multi. Everydae is a category-focused women's brand; needs stronger third-party testing signal to move up a tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mood",
      "title": "Mood",
      "vendor": "Everydae",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Mood_eddd6b39-5c80-4c97-b219-eaf17462f0d6.jpg?v=1783743346",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mood",
        "everydae"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 42,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523071168709",
      "vsf_explanation": "5-ingredient mood/stress capsule targeted at postpartum users. Description does not list the actual ingredients or doses, which is the main transparency issue. Everydae's postnatal-safe framing implies conservative dosing but without the ingredient list this can't be scored higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "tummy-tamer",
      "title": "Tummy Tamer",
      "vendor": "Mortals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/tummy-tamer-671689.webp?v=1783743390",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tummy",
        "tamer",
        "mortals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 65,
        "safety": 60,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523072872645",
      "vsf_explanation": "8-ingredient digestive stack — ginger (Marx 2015 chemo-nausea meta-analysis), artichoke, dandelion, bromelain, aloe (needs decolorized inner-leaf disclosure), lemon balm, licorice, unnamed probiotic blend. Licorice needs DGL vs whole-root disclosure (whole root risks BP/potassium issues) and probiotic strain/CFU is unspecified — both real transparency gaps.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cramp-crusher",
      "title": "Cramp Crusher",
      "vendor": "Mortals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cramp-crusher-884524.webp?v=1783743390",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cramp",
        "crusher",
        "mortals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 65,
        "safety": 60,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523072905413",
      "vsf_explanation": "17-ingredient PMS/cramp stack including white willow, NAC, ginger, boswellia, turmeric, magnesium, black cohosh, chaste tree, B6, D3. Chaste tree (Vitex) at 20-40 mg standardized has PMS RCT support (Schellenberg 2001); black cohosh has vasomotor evidence. Problem: 17 ingredients in a 5-cap serving means most are under-dosed by arithmetic. Ingredient philosophy is right, dosing math is unlikely.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "anxiety-assassin",
      "title": "Anxiety Assassin",
      "vendor": "Mortals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/anxiety-assassin-225660.webp?v=1783743395",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "anxiety",
        "assassin",
        "mortals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523072938181",
      "vsf_explanation": "9-ingredient calming stack — ashwagandha (Chandrasekhar 2012 KSM-66), passionflower, L-theanine, GABA, chamomile, valerian, lemon balm, lion's mane, magnesium bisglycinate. Each ingredient has evidence at defined doses, but this description does not disclose individual doses for a single-serve pouch with 3 caps. Mortals claims cGMP + triple third-party testing (COAs 'available upon request'), so manufacturing is credible; transparency is the weak point.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pain-purge",
      "title": "Pain Purge",
      "vendor": "Mortals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/pain-purge-517519.webp?v=1783743395",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pain",
        "purge",
        "mortals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523072970949",
      "vsf_explanation": "7-ingredient anti-inflammatory stack — white willow bark (salicin), boswellia, curcumin+BioPerine (Shoba 1998 bioavailability), bromelain, ginger, quercetin, magnesium bisglycinate. Ingredient set is well-chosen with real inflammation/pain evidence (Daily 2016 curcumin meta-analysis; Bang 2009 boswellia RCT). Individual doses per 4-cap sachet still not disclosed. Product name 'Pain Purge' brushes DSHEA claim territory.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "feminine-balance-capsules-vixi-vital-source-nutrition",
      "title": "Feminine Balance Capsules -ViXi-Vital Source Nutrition",
      "vendor": "Healthova",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9c3c4c37e322d2f05c5f421e4bc0fc61.jpg?v=1783743465",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "feminine",
        "balance",
        "capsules",
        "vixi",
        "vital",
        "source",
        "nutrition",
        "healthova"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 30,
        "manufacturing": 25,
        "safety": 45,
        "transparency": 20,
        "sustainability": 40
      },
      "price": 5.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523073560773",
      "vsf_explanation": "$5.99 'Feminine Balance' capsules with a completely empty description — no ingredient list, no dose, no brand story. 'ViXi / Vital Source Nutrition' is not a recognizable manufacturer with any published quality documentation. Women's hormonal formulas need transparent ingredient disclosure; this has none.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "uro-vaginal-probiotics-for-women-ph-balance-with-prebiotics-lactobacillus-probiotic-blend-womens-vaginal-health-supplement-promote-healthy-vaginal-odor-vaginal-flora-60-count-pack-of-1",
      "title": "URO Vaginal Probiotics for Women pH Balance with Prebiotics & Lactobacillus Probiotic Blend - Women's Vaginal Health Supplement - Promote Healthy Vaginal Odor & Vaginal Flora, 60 Count (Pack of 1)",
      "vendor": "Healthova",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/204d8894-aa2e-4164-8ec0-9e0cd5f805e9_webp.jpg?v=1783743465",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "uro",
        "vaginal",
        "probiotics",
        "for",
        "women",
        "balance",
        "with",
        "prebiotics",
        "lactobacillus",
        "probiotic",
        "blend",
        "women",
        "vaginal",
        "health",
        "supplement",
        "promote",
        "healthy",
        "vaginal",
        "odor",
        "vaginal",
        "flora",
        "count",
        "pack",
        "healthova"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 35,
        "manufacturing": 25,
        "safety": 45,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 5.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523073593541",
      "vsf_explanation": "Vaginal probiotic listing with no description, no strain names, and no CFU count — $5.99 through 'Healthova' with no verifiable manufacturer. Strain-specificity is everything for probiotics (L. crispatus CTV-05 vs L. rhamnosus GR-1 have different clinical use cases; Reid 2003, Cohen 2020 LACTIN-V trial). Without strain and CFU data this is unevaluatable.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "vitamin-d3-k2-supplement-softgels",
      "title": "Vitamin D3 K2 Supplement Softgels",
      "vendor": "Healthova",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fd7b111188c4d268ec821e4d2af8820.jpg?v=1783743470",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "supplement",
        "softgels",
        "healthova"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 25,
        "manufacturing": 25,
        "safety": 45,
        "transparency": 20,
        "sustainability": 40
      },
      "price": 6.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523073724613",
      "vsf_explanation": "$6.99 D3+K2 softgel from 'Healthova' with an empty description — no manufacturer, no dose, no K2 form disclosure (MK-4 vs MK-7 matters), no COA. D3+K2 as a category has good evidence (Rheaume-Bleue; Knapen 2013 MK-7 arterial stiffness) but this SKU is unverifiable.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "now-psyllium-husk-powder️",
      "title": "NOW Psyllium Husk Powder️",
      "vendor": "NOW",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/large_2371bfa0-f000-4ba2-87bf-ac9082363683.jpg?v=1783778519",
      "score": 69,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "psyllium",
        "husk",
        "powder",
        "now"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 80,
        "formulation": 70,
        "manufacturing": 60,
        "safety": 75,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 25.38,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523791376581",
      "vsf_explanation": "Plain NOW psyllium husk powder — one of the most evidence-backed fiber supplements: LDL-lowering (Jovanovski 2018 meta-analysis, ~7 mg/dL per 10 g/day), glycemic control (Gibb 2015), and IBS/constipation guidance from AGA. NOW brand manufacturing is credible. Empty product description here is the transparency ding, not the product itself.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "now-available-bella®-natural-herbal-food-supplement-for-women-by-sunrider",
      "title": "NOW AVAILABLE Bella® | Natural Herbal Food Supplement for Women by Sunrider",
      "vendor": "NOW",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/bella-natural-herbal-food-supplement-for-women-by-sunrider-13733161697369.png?v=1783778544",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "now",
        "available",
        "bella",
        "natural",
        "herbal",
        "food",
        "supplement",
        "for",
        "women",
        "sunrider",
        "now"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 79.36,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523791540421",
      "vsf_explanation": "Pueraria root (kudzu — phytoestrogenic), barrenwort (epimedium/horny goat weed), marsh parsley leaf blend for menopause and 'youthful glow.' 550 mg per capsule is a total; per-herb doses hidden. Pueraria's estrogenic activity should be flagged for anyone with hormone-sensitive conditions, and this label doesn't do that. FAQ makes borderline disease-adjacent claims ('ease symptoms of perimenopause').",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "now-available-nuplus-herbal-food-formula-by-sunrider",
      "title": "NOW AVAILABLE NuPlus Herbal Food Formula by Sunrider",
      "vendor": "NOW",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/now-available-original-regular-soy-free-60-packs-15g-ea-best-value-now-available-nuplus-herbal-food-formula-by-sunrider-40656184738049.jpg?v=1783778561",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "available",
        "nuplus",
        "herbal",
        "food",
        "formula",
        "sunrider",
        "now"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 31.24,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523791835333",
      "vsf_explanation": "'Concentrated herbal food' meal-replacement powder mixed with fruit drinks. Marketed as a nutritional foundation but the actual macronutrient/micronutrient composition is not disclosed here. Multiple flavor variants with different bases (soy-free, plain, etc.) all share the same opaque 'herbal food' framing.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "now-available-conco-herbal-respiratory-supplement-by-sunrider",
      "title": "NOW AVAILABLE Conco Herbal Respiratory Supplement by Sunrider",
      "vendor": "NOW",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/conco-herbal-respiratory-supplement-by-sunrider-7188224671833.png?v=1783778586",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "available",
        "conco",
        "herbal",
        "respiratory",
        "supplement",
        "sunrider",
        "now"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 53.24,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523792588997",
      "vsf_explanation": "TCM respiratory blend (chuan xiong root, golden bell fruit, bamboo leaf, reed root, mint) that the label explicitly calls a 'proprietary blend of concentrated herbs.' No dose disclosure and no RCT support for the combination. Framed with TCM 'yin/yang' language that isn't a mechanism claim we can evaluate.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "now-available-top-concentration-herbal-supplement-by-sunrider",
      "title": "NOW AVAILABLE Top | Concentration Herbal Supplement by Sunrider",
      "vendor": "NOW",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/single-bottle-top-concentration-herbal-supplement-by-sunrider-40259950805249.jpg?v=1783778610",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "available",
        "top",
        "concentration",
        "herbal",
        "supplement",
        "sunrider",
        "now"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 87.11,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523792687301",
      "vsf_explanation": "'Herbal concentrate' (Chinese mint leaf, honeysuckle flower, yeuan wu root) sold as a nootropic. 475 mg per capsule is listed as a total, not per-ingredient. None of these three botanicals has meaningful cognitive-outcome RCT support. Pure marketing formulation — 'brain food' framing with no dose transparency.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "now-available-sportcaps-energy-endurance-herbal-supplement-by-sunrider",
      "title": "NOW AVAILABLE SportCaps | Energy & Endurance Herbal Supplement by Sunrider",
      "vendor": "NOW",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/out-of-stock-pre-order-sportcaps-energy-endurance-herbal-supplement-by-sunrider-38267180450049.png?v=1783778646",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "available",
        "sportcaps",
        "energy",
        "endurance",
        "herbal",
        "supplement",
        "sunrider",
        "now"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 35,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 55.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523793440965",
      "vsf_explanation": "10-herb 'concentrated blend' (bee pollen, Siberian ginseng, alfalfa, Japanese dodder, Chinese knot grass, kelp, rose hips, cassia, teasel, codonopsis) with zero individual dose disclosure. Siberian ginseng has some ergogenic data at 400-800 mg standardized — impossible to tell if this hits it. Kelp introduces iodine variability that should be disclosed.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "now-available-slimcaps-weight-loss-formula-by-sunrider",
      "title": "NOW AVAILABLE SlimCaps Weight Loss Formula by Sunrider",
      "vendor": "NOW",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/out-of-stock-pre-order-slimcaps-weight-loss-formula-by-sunrider-28445056729282.jpg?v=1783778668",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "available",
        "slimcaps",
        "weight",
        "loss",
        "formula",
        "sunrider",
        "now"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 52.31,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523793539269",
      "vsf_explanation": "'All-natural' Chinese herbal weight-loss blend (capillary artemisia, gardenia, Chinese rhubarb, white peony). Chinese rhubarb (Da Huang) is a stimulant laxative — an ingredient that shouldn't be silently included in a daily supplement. No individual doses on any herb. Weight-loss herbal blends of this shape have no credible RCT support.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "now-available-sunfit-protein-plus-unique-protein-powder-by-sunrider",
      "title": "NOW AVAILABLE SunFit Protein Plus - Unique Protein Powder by Sunrider",
      "vendor": "NOW",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/original-naturally-vanilla-sunfit-protein-plus-unique-protein-powder-by-sunrider-1346511634459.png?v=1783778685",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "available",
        "sunfit",
        "protein",
        "plus",
        "unique",
        "protein",
        "powder",
        "sunrider",
        "now"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 82.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523793670341",
      "vsf_explanation": "Plant-based protein blend, 20 g protein / 15 g carbs / 160 kcal per serving, marketed as 'complete' — plant blends can reach a full amino acid profile but this label does not specify sources or PDCAAS. Sunrider is an MLM channel with limited third-party testing visibility. No red flags but nothing that distinguishes it from cheaper commodity plant protein.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "now-daily-vits-multivitamin-complete-vitamin-mineral-supplement-for-adults-boost-energy-support-immunity-bone-health-100-tablets",
      "title": "Now Daily Vits Multivitamin: Complete Vitamin & Mineral Supplement for Adults - Boost Energy, Support Immunity & Bone Health (100 Tablets)",
      "vendor": "NOW",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cwPgPWKmmttbQiqzEXd3SdlSKol1pg5LR07XH80t.jpg?v=1783778752",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "daily",
        "vits",
        "multivitamin",
        "complete",
        "vitamin",
        "mineral",
        "supplement",
        "for",
        "adults",
        "boost",
        "energy",
        "support",
        "immunity",
        "bone",
        "health",
        "100",
        "tablets",
        "now"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 62.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523794620613",
      "vsf_explanation": "Standard broad-spectrum multi from NOW. Discloses vitamin D at only 400 IU (well below modern targets), and this basic multi uses standard (not methylated) B forms. Reasonable insurance-policy multi but not a biohacker-tier stack — Thorne Basic Nutrients or Pure Encapsulations O.N.E. outclass on forms and doses.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "now-milk-thistle-300mg-liver-support-supplement-with-dandelion-artichoke-herbal-detox-cleanse-50-capsules",
      "title": "Now Milk Thistle 300mg - Liver Support Supplement with Dandelion & Artichoke - Herbal Detox & Cleanse - 50 Capsules",
      "vendor": "NOW",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/tOwGLoVyXK4WaYV6H5sQAZj2I9Vu8IkzXvuY3TWL.jpg?v=1783778766",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "milk",
        "thistle",
        "300mg",
        "liver",
        "support",
        "supplement",
        "with",
        "dandelion",
        "artichoke",
        "herbal",
        "detox",
        "cleanse",
        "capsules",
        "now"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 64.11,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523795341509",
      "vsf_explanation": "300 mg milk thistle standardized to 80% silymarin = 240 mg silymarin, inside the RCT-effective 140-420 mg/day range studied for hepatic markers (Loguercio 2007; Fried 2012 HALT-C trial). Adds dandelion 100 mg and artichoke for classic 'liver support' stack. NOW quality is fine; disease-adjacent 'detox/cleanse' marketing is the transparency ding.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "now-foods-l-methionine-powder-usp-grade-500-grams-1-1-lbs",
      "title": "NOW Foods L-Methionine Powder, USP Grade, 500 Grams (1.1 lbs)",
      "vendor": "Now Foods",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NOW80117_01-600x600.png?v=1783778781",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "foods",
        "methionine",
        "powder",
        "usp",
        "grade",
        "500",
        "grams",
        "lbs",
        "now",
        "foods"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 70,
        "manufacturing": 70,
        "safety": 65,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 136.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523795407045",
      "vsf_explanation": "USP-grade pure L-methionine powder — sulfur amino acid used as a glutathione precursor and for urinary acidification. Evidence base is niche (mostly acetaminophen toxicity + specific clinical uses), not a general-population supplement. USP certification is a real quality signal; safety needs care because high methionine can raise homocysteine.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "now-magnesium-glycinate-180-tablets-highly-absorbable-magnesium-supplement-for-sleep",
      "title": "Now Magnesium Glycinate 180 Tablets: Highly Absorbable Magnesium Supplement for Sleep",
      "vendor": "NOW",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/vv3D7eOQbSG4VQN775fjgjXsxppjRr8BTNTXTjIl.jpg?v=1783778826",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "magnesium",
        "glycinate",
        "180",
        "tablets",
        "highly",
        "absorbable",
        "magnesium",
        "supplement",
        "for",
        "sleep",
        "now"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 75,
        "manufacturing": 65,
        "safety": 75,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 113.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523796390085",
      "vsf_explanation": "Magnesium bisglycinate — the bioavailable chelated form with the best GI tolerability (Schuette 1994; Walker 2003). Solid evidence for sleep, muscle relaxation and mild anxiety (Boyle 2017 review; Abbasi 2012 elderly insomnia RCT). NOW Foods manufacturing is transparent and GMP-certified; only knock is being sold here through a reseller rather than direct.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "now-foods-l-arginine-pure-powder-nitric-oxide-precursor-500g",
      "title": "NOW Foods L-Arginine Pure Powder - Nitric Oxide Precursor, 500g",
      "vendor": "Now Foods",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/16.jpg?v=1783778860",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "foods",
        "arginine",
        "pure",
        "powder",
        "nitric",
        "oxide",
        "precursor",
        "500g",
        "now",
        "foods"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 70,
        "manufacturing": 65,
        "safety": 70,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 86.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523796783301",
      "vsf_explanation": "Free-form pharmaceutical-grade L-arginine powder — NO precursor with RCT support for endothelial function and blood pressure (Dong 2011 meta-analysis, 4-24 g/day). Pure single-ingredient powder lets the user hit trial-effective doses easily. NOW Foods manufacturing is credible; sold through a third-party pharmacy reseller.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "now-brewers-yeast-200-tablet",
      "title": "Now Brewer's Yeast 200 Tablet",
      "vendor": "NOW",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/now-brewers-yeast-200-tablet--4f1a.jpg?v=1783778936",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "brewer",
        "yeast",
        "200",
        "tablet",
        "now"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 32.51,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523797242053",
      "vsf_explanation": "Whole-food brewer's yeast, 650 mg per tab, delivering B-complex, chromium, and beta-glucan. Traditional nutritional food with some data on glucose regulation (Cefalu 2010 chromium meta-analysis). NOW brand quality is solid; sold here by a generic reseller with Turkish shipping copy — real product, awkward channel.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "now-vitamin-d-3-400iu-180-softgels-pack-of-3",
      "title": "NOW Vitamin D-3 400IU, 180 Softgels (Pack of 3)",
      "vendor": "NOW",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e135d7a8ff0bd08b0fa08737103f056a.jpg?v=1783778967",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "vitamin",
        "400iu",
        "180",
        "softgels",
        "pack",
        "now"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 60,
        "safety": 75,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523798552773",
      "vsf_explanation": "NOW Vitamin D-3 at 400 IU per softgel — legacy 1997-era RDA that is below the 1,000-4,000 IU range used in modern RCTs (Martineau 2017; Manson 2019 VITAL). Safe and cheap, but for adults chasing serum 25(OH)D optimization this is an under-dose. NOW's manufacturing quality is intact; the dose is what caps this.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "now-vitamin-d3-1000-iu-softgels-180-count-immune-bone-health-support-cholecalciferol-vitamin-d-supplement",
      "title": "Now Vitamin D3 1000 IU Softgels - 180 Count - Immune & Bone Health Support | Cholecalciferol Vitamin D Supplement",
      "vendor": "NOW",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/yRT2GVg8qngH6GV9pcdNXcuAalA5BtiugcQk4Ti6.jpg?v=1783778981",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "vitamin",
        "1000",
        "softgels",
        "180",
        "count",
        "immune",
        "bone",
        "health",
        "support",
        "cholecalciferol",
        "vitamin",
        "supplement",
        "now"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 80,
        "formulation": 70,
        "manufacturing": 65,
        "safety": 75,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 50.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523798651077",
      "vsf_explanation": "NOW Foods Vitamin D3 1,000 IU cholecalciferol — a well-established, RCT-supported ingredient and dose (Martineau 2017 respiratory meta-analysis; Pittas 2019 D2d trial anchor points). NOW is family-owned since 1968, runs an in-house ISO-17025 lab and is UL/GMP certified. 180-count softgel gives a fair per-day cost.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "now-available-vitamin-d3-1000-5000-iu-by-sunrider",
      "title": "NOW AVAILABLE Vitamin D3 1000 / 5000 IU | by Sunrider",
      "vendor": "NOW",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/vitamin-d3-1000-5000-iu-by-sunrider-22786840756418.png?v=1783779040",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "available",
        "vitamin",
        "1000",
        "5000",
        "sunrider",
        "now"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 65,
        "manufacturing": 45,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 15.11,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523799109829",
      "vsf_explanation": "Vitamin D3 (cholecalciferol) with vitamin E and safflower oil for absorption — the D3 ingredient itself is one of the best-studied supplements (Autier 2017 meta-analysis; Martineau 2017 respiratory infection meta-analysis). 1,000-5,000 IU is within evidence-backed range. Held back by Sunrider MLM channel and an added reseller layer with no third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-quercetin-complex-with-ester-c-plus-vegetable-capsules",
      "title": "Solgar Quercetin Complex With Ester-C Plus Vegetable Capsules",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/182715541.png?v=1783779072",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "quercetin",
        "complex",
        "with",
        "ester",
        "plus",
        "vegetable",
        "capsules",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 65,
        "safety": 70,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523799929029",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 62 → new 68. Evidence found: Andres S, et al. Safety aspects of the use of quercetin as a dietary supplement. Mol Nutr Food Res. 2018;62(1):1700447. | Weng Z, et al. Quercetin is more effective than cromolyn in blocking human mast cell cytokine release and inhibits contact dermatitis and photosensitivity in humans. PLoS One. 2012;7(3):e33805. | Solgar Ester-C PK dossier documenting modestly extended leukocyte vitamin C retention vs plain ascorbic acid.. Rationale: Quercetin has TIER-C evidence for allergy/histamine at 500-1000 mg/day with the caveat of poor oral bioavailability. Ester-C pairing modestly improves PK. Modest +6 uplift reflects credible formulation pairing but not blockbuster evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-quercetin-complex-with-ester-c-plus-50-vegetable-capsules",
      "title": "Solgar Quercetin Complex With Ester-C Plus, 50 Vegetable Capsules",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/131687070.png?v=1783779087",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "quercetin",
        "complex",
        "with",
        "ester",
        "plus",
        "vegetable",
        "capsules",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 65,
        "safety": 70,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 16.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523800256709",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 64 → new 70. Evidence found: Same evidence base as sibling SKU (Weng 2012; Andres 2018; Ester-C PK dossier).. Rationale: Identical formulation to sibling SKU, larger bottle count. Same +6 uplift for TIER-C quercetin + Ester-C combination.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "enfla-c-dietary-supplement-bromelain-vitamin-c-quercetin-capsules-for-immune-support",
      "title": "Enfla-C Dietary Supplement - Bromelain Vitamin C Quercetin Capsules for Immune Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9vwLuorhEV0dkEio4qqoVzOUgTeUI6V52MfsjDHv_ae1b3601-33e2-4eb8-ae82-c0d831948212.jpg?v=1783779128",
      "score": 51,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "enfla",
        "dietary",
        "supplement",
        "bromelain",
        "vitamin",
        "quercetin",
        "capsules",
        "for",
        "immune",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 60,
        "manufacturing": 35,
        "safety": 55,
        "transparency": 65,
        "sustainability": 45
      },
      "price": 27.12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523800584389",
      "vsf_explanation": "Actual per-2-cap doses disclosed: 600 mg bromelain, 200 mg Vit C, 80 mg quercetin — an unusual level of label transparency for a reseller listing. Bromelain dose is credible (Maurer 2001 anti-inflammatory range) and the vitamin C is at a reasonable daily dose. Held back by unclear manufacturer/COA and reseller provenance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-quercetin-with-bromelain-500mg-120-veggie-caps-43-fruit-veggie-grain-herbs-enzyme-probiotic-blend-non-gmo-vegan-bioperine",
      "title": "NusaPure Quercetin with Bromelain 500mg |120 Veggie Caps | 43 Fruit Veggie Grain Herbs Enzyme Probiotic Blend | Non-GMO, Vegan, Bioperine",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/27575521.jpg?v=1783779136",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "quercetin",
        "with",
        "bromelain",
        "500mg",
        "120",
        "veggie",
        "caps",
        "fruit",
        "veggie",
        "grain",
        "herbs",
        "enzyme",
        "probiotic",
        "blend",
        "non",
        "gmo",
        "vegan",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523800649925",
      "vsf_explanation": "Fronts 500 mg quercetin + bromelain but wraps it in a 43-ingredient 'fruit-veggie-grain-herb-enzyme-probiotic' proprietary blend whose per-ingredient doses are not disclosed. Kitchen-sink formulation is a marketing signal — 43 items in one cap means most are pixie-dust doses. cGMP claimed, no third-party COA linked.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "nusapure-nmn-complex-1-000-mg-per-serving-with-resveratrol-turmeric-root-quercetin-bioperine-180-vegan-capsules-90-servings-non-gmo-vegan-lab-tested-made-in-cgmp-facility",
      "title": "NusaPure NMN Complex 1,000 mg per Serving with Resveratrol, Turmeric Root, Quercetin & BioPerine, 180 Vegan Capsules (90 Servings) – Non-GMO, Vegan, Lab Tested, Made in cGMP Facility",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a829b5e4.jpg?v=1783779148",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint",
        "longevity",
        "energy",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "nmn",
        "complex",
        "000",
        "per",
        "serving",
        "with",
        "resveratrol",
        "turmeric",
        "root",
        "quercetin",
        "bioperine",
        "180",
        "vegan",
        "capsules",
        "servings",
        "non",
        "gmo",
        "vegan",
        "lab",
        "tested",
        "made",
        "cgmp",
        "facility",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 33.8,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523800748229",
      "vsf_explanation": "NMN 'Complex' at 1,000 mg per serving lumps NMN with resveratrol, turmeric, quercetin and BioPerine — the label calls out a total but does not disclose the individual NMN dose. NMN human data (Yoshino 2021, Igarashi 2022) uses 250-900 mg of pure NMN, so a 1 g blend likely dilutes each ingredient below effective range. cGMP but no NSF/USP or third-party COA visible.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "ocean-nutrition-quercetin-supplement-100mg-quercetin-per-capsule-vegan-vegetarian-friendly-dietary-supplement",
      "title": "Ocean Nutrition Quercetin Supplement - 100mg Quercetin per Capsule, Vegan & Vegetarian Friendly Dietary Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/EIWhCeZQ7h3FQh0GdUNj5FrG65hsgYtuHVIejQ1u.jpg?v=1783779167",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ocean",
        "nutrition",
        "quercetin",
        "supplement",
        "100mg",
        "quercetin",
        "per",
        "capsule",
        "vegan",
        "vegetarian",
        "friendly",
        "dietary",
        "supplement",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 65,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 32.85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523800813765",
      "vsf_explanation": "Uses Quercefit (Indena's quercetin phytosome), a branded ingredient with human PK/immune data (Riva 2019; Di Pierro 2021). 100 mg per capsule is the low end — Quercefit RCTs typically use 250-500 mg/day — so serious users would need 3-5 caps. Ocean Nutrition is a real brand but the reseller listing lacks COA/third-party details.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "quercin-quercetin-bromelain-dietary-supplement-for-adults-60-capsules-immune-system-support",
      "title": "Quercin - Quercetin & Bromelain Dietary Supplement for Adults - 60 Capsules - Immune System Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CnW9x1lRlV5PITnQwU82kV6RTVdCcT9cCqLduEQ6_25e09fca-56c5-48ff-8e37-16d5c22697e0.jpg?v=1783779184",
      "score": 39,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "quercin",
        "quercetin",
        "bromelain",
        "dietary",
        "supplement",
        "for",
        "adults",
        "capsules",
        "immune",
        "system",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 30,
        "safety": 45,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 55.3,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523800879301",
      "vsf_explanation": "Same Quercin quercetin/bromelain formula listed under a second SKU by the same reseller. No manufacturer disclosed, no individual doses, no third-party testing. Marketing leans on generic 'immune boost' copy without label transparency. Reseller-only provenance triggers the no_brand_provenance rule.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "quercin-fitozomal-quercetin-bromelain-60-capsules",
      "title": "Quercin Fitozomal Quercetin & Bromelain - 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4nLE4tnUreIQggBDLy8gFVGVPWQEffVcO73eOTTY.jpg?v=1783779195",
      "score": 39,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "quercin",
        "fitozomal",
        "quercetin",
        "bromelain",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 30,
        "safety": 45,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 57.86,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523801108677",
      "vsf_explanation": "Quercetin/bromelain immune blend with Vit C, B6, D and zinc sold via an unverifiable Amazon-style reseller with no visible manufacturer, no COA, and no per-ingredient dose disclosure. 'Fitozomal' hints at a phytosome delivery but the actual quercetin dose is not stated. Quercetin phytosome studies (Riva 2019) show benefit at 500 mg/day, and this label can't be verified. No brand provenance is the disqualifier.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "venatura-liposomal-quercetin-supplement-capsules-antioxidant-support-immune-function-for-adults-children-over-11-30-capsules",
      "title": "VeNatura Liposomal Quercetin Supplement Capsules - Antioxidant Support & Immune Function for Adults & Children Over 11 - 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/on9nqZple78l4V0tKHgl0IR2HfP4atOw8wxOU5cf.jpg?v=1783779214",
      "score": 41,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "youth_under_18",
      "tokens": [
        "venatura",
        "liposomal",
        "quercetin",
        "supplement",
        "capsules",
        "antioxidant",
        "support",
        "immune",
        "function",
        "for",
        "adults",
        "children",
        "over",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 30,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 22.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523801272517",
      "vsf_explanation": "VeNatura liposomal quercetin 100mg per capsule, one capsule/day. Even with liposomal delivery, 100mg/day is well below the 500-1000mg used in quercetin RCTs — under the 25% sub-therapeutic threshold. Small unknown brand sold via generic reseller; marketing to children over 11 is aggressive for a compound with limited pediatric evidence.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "solgar-ester-c-plus-vitamin-c-500-mg-90-capsules",
      "title": "Solgar Ester-C Plus, Vitamin C, 500 Mg, 90 Capsules",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/124208118_8f623d4e-0389-4d2e-b62f-4de4dfc248b5.jpg?v=1783779232",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "ester",
        "plus",
        "vitamin",
        "500",
        "capsules",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 65,
        "safety": 75,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 8.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523801436357",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 66 → new 72. Evidence found: Wright JV. Ester-C absorption studies: buffered calcium ascorbate with C-threonate metabolites showing modestly extended leukocyte retention vs plain ascorbic acid. | Hemila H, Chalker E. Vitamin C for preventing and treating the common cold. Cochrane Database Syst Rev. 2013.. Rationale: Ester-C is a patented non-acidic vitamin C (calcium ascorbate with C2/C3/C4/C6 threonate metabolites) with published PK showing modestly improved leukocyte retention and better GI tolerance vs plain ascorbic acid. +6 uplift for TIER-C formulation edge over generic C.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-quercetin-suitable-for-vegetarian-vegan-non-gmo-1000-mg-200-capsules",
      "title": "NusaPure Quercetin - Suitable for Vegetarian/Vegan, Non - GMO - 1000 mg - 200 Capsules",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a0227866.jpg?v=1783779241",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "quercetin",
        "suitable",
        "for",
        "vegetarian",
        "vegan",
        "non",
        "gmo",
        "1000",
        "200",
        "capsules",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 42.75,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523801501893",
      "vsf_explanation": "NusaPure Quercetin 1000mg per 2-cap serving with BioPerine for absorption. BioPerine (piperine) improves quercetin bioavailability. cGMP-registered facility, vegan/non-GMO, and the listing appropriately calls out drug interactions (blood thinners, antibiotics, chemo). 100-day supply is good value. Direct-from-brand vendor improves provenance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nbtlife-liposomal-quercetin-supplement-antioxidant-support-30-capsules",
      "title": "NBTLife Liposomal Quercetin Supplement - Antioxidant Support, 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ZkJ4I8tfz6ISEaUitpWq1hSyzQgPNPNJdTSaHt4U.jpg?v=1783779257",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nbtlife",
        "liposomal",
        "quercetin",
        "supplement",
        "antioxidant",
        "support",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 40,
        "safety": 60,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 44.36,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523801796805",
      "vsf_explanation": "NBTLife liposomal quercetin. Liposomal delivery is a legitimate bioavailability improvement (Riva 2019), but the actual quercetin dose per capsule is not stated on the listing. Small unknown brand sold via generic reseller. Without disclosed dose it's impossible to verify whether one capsule/day reaches meaningful exposure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutraxin-quercetin-plus-bromelain-dietary-supplement-natural-anti-inflammatory-immune-support-for-adults",
      "title": "Nutraxin Quercetin Plus Bromelain Dietary Supplement - Natural Anti-Inflammatory & Immune Support for Adults",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/TOdoZwwXm9qWrT7jBiVcmReKb8HE68GcUu7y3mhY.jpg?v=1783779270",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "inflammation"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutraxin",
        "quercetin",
        "plus",
        "bromelain",
        "dietary",
        "supplement",
        "natural",
        "anti",
        "inflammatory",
        "immune",
        "support",
        "for",
        "adults",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 24.01,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523801862341",
      "vsf_explanation": "Nutraxin quercetin + bromelain tablets. Neither quercetin nor bromelain dose is disclosed on the listing. Bromelain + quercetin is a common OTC combo but RCT support for the pairing is thin. Nutraxin is a Turkish brand with limited US third-party verification, sold via reseller — provenance is weak.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mason-natural®-quercetin-complex-625-mg-immune-antioxidant-support-60-tablets",
      "title": "Mason Natural® Quercetin Complex 625 mg – Immune & Antioxidant Support (60 Tablets)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/342933513.jpg?v=1783779288",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mason",
        "natural",
        "quercetin",
        "complex",
        "625",
        "immune",
        "antioxidant",
        "support",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 65,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 19.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523802157253",
      "vsf_explanation": "Mason Natural Quercetin Complex 625mg. Quercetin dose is stated but the 'synergistic blend' of other nutrients isn't broken down. Mason Natural is a discount-tier GMP brand — cGMP compliance but no third-party testing published. 625mg is a reasonable quercetin dose for antioxidant use.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "olympian-labs-quercetin-plus-1-g-60-vegetarian-capsules",
      "title": "Olympian Labs Quercetin Plus - 1 G - 60 Vegetarian Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/124286948.jpg?v=1783779300",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "olympian",
        "labs",
        "quercetin",
        "plus",
        "vegetarian",
        "capsules",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 33.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523802222789",
      "vsf_explanation": "Quercetin 1g (1000mg) vegetarian capsules from Olympian Labs. Dose is at the top of the RCT-effective range for quercetin's antioxidant/antihistamine effects (Mlcek 2016). Standard quercetin form without absorption enhancer (piperine or phytosome) — bioavailability is a known limitation. Established supplement brand with reasonable transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-quercetin-with-ester-c-500-mg-capsules",
      "title": "Nature's Bounty Quercetin, With Ester C, 500 Mg, Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/313553384_5c04ff2b-a304-4485-b6b6-d5372f843c65.png?v=1783779310",
      "score": 53,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "quercetin",
        "with",
        "ester",
        "500",
        "capsules",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 19.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523802255557",
      "vsf_explanation": "Quercetin + Ester-C 500mg with rose hips, acerola, and rutin. Ester-C (calcium ascorbate) is a gentle, well-tolerated vitamin C form. Quercetin dose is not clearly disclosed in listing copy — RCT antihistamine/antioxidant doses are 500-1000mg. Combination product with unclear per-ingredient dosing weakens transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nad-anti-aging-brain-support-supplement-with-quercetin-resveratrol-60-caps",
      "title": "NAD+ Anti-Aging & Brain Support Supplement with Quercetin & Resveratrol – 60 Caps",
      "vendor": "My Store",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1778720164060-generated-label-image-0.jpg?v=1783779322",
      "score": 36,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy",
        "cardiovascular",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nad",
        "anti",
        "aging",
        "brain",
        "support",
        "supplement",
        "with",
        "quercetin",
        "resveratrol",
        "caps",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 30,
        "manufacturing": 30,
        "safety": 55,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 32.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523802517701",
      "vsf_explanation": "500mg oral NAD+ with 250mg quercetin and Japanese Knotweed resveratrol. Vendor is literally 'My Store' — no brand identity or manufacturer. Oral NAD+ is broken down in the gut before absorption; NR (Trammell 2016) and NMN (Yoshino 2021) are the forms with pharmacokinetic evidence in humans. Marketed anti-aging benefit is not supported by NAD+ oral dosing data.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "cognition-support-gummies",
      "title": "Cognition Support  Gummies",
      "vendor": "Baker's Botanics",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BB_Cognition_Bottle_V2.png?v=1783779340",
      "score": 37,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cognition",
        "support",
        "gummies",
        "baker",
        "botanics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 25,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 20,
        "sustainability": 45
      },
      "price": 35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523802616005",
      "vsf_explanation": "Gummy 'cognitive stack' listing Cordyceps, Lion's Mane, Ginkgo, Alpha-GPC, Quercetin, and piperine with zero individual doses disclosed. Alpha-GPC RCTs use 300-1200mg (De Jesus Moreno 2003) and Lion's Mane RCTs use 3g (Mori 2009); a single gummy cannot deliver both at RCT-effective doses. Small unknown brand.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "natures-bounty-gentle-iron-28-mg-90-capsules",
      "title": "Nature's Bounty Gentle Iron 28 Mg - 90 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/46994077.jpg?v=1783779386",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "gentle",
        "iron",
        "capsules",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 10.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523803238597",
      "vsf_explanation": "'Gentle Iron' 28mg — Nature's Bounty formulation uses ferrous bisglycinate chelate, which has better GI tolerance and higher bioavailability than ferrous sulfate (Milman 2014). 28mg is an appropriate maintenance dose for menstruating women. Safety concern: iron is dangerous for men, non-anemic adults, and children — accidental pediatric ingestion is a leading cause of supplement poisoning, and this warning isn't emphasized.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-acidophilus-probiotic-supplement-tablets",
      "title": "Nature's Bounty Acidophilus Probiotic Supplement Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/91501946_a66ed8ac-90c4-4298-92fc-e3c65f3d02bf.jpg?v=1783779395",
      "score": 39,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "acidophilus",
        "probiotic",
        "supplement",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 20,
        "manufacturing": 50,
        "safety": 65,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 11.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523803500741",
      "vsf_explanation": "L. acidophilus probiotic 'over 100 million active' CFU. Clinically-effective probiotic doses are 1-10 billion CFU/day (Ouwehand 2017); 100 million (0.1 billion) is roughly 1-10% of RCT-effective dose — well under the 25% threshold. Additionally, no shelf-life stability, strain designation (e.g., NCFM), or DFU-at-expiration is disclosed.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "natures-bounty-anxiety-stress-relief-herbal-health-tablets",
      "title": "Nature's Bounty Anxiety & Stress Relief, Herbal Health, Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/302781541.jpg?v=1783779406",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "anxiety",
        "stress",
        "relief",
        "herbal",
        "health",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523803631813",
      "vsf_explanation": "Ashwagandha KSM-66 for stress. KSM-66 is a clinically-studied full-spectrum root extract with multiple RCTs at 300-600mg/day showing cortisol reduction and anxiety improvement (Chandrasekhar 2012, Salve 2019). Positive: named clinical form (KSM-66). Negative: exact ashwagandha dose isn't disclosed in the listing text, so it's unclear if the tablet delivers RCT-effective dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-folic-acid-800-mcg-vitamin-supplement-maximum-strength-250-tablets",
      "title": "Nature's Bounty Folic Acid 800 Mcg Vitamin Supplement Maximum Strength - 250 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/323933895.gif?v=1783779417",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "folic",
        "acid",
        "800",
        "mcg",
        "vitamin",
        "supplement",
        "maximum",
        "strength",
        "250",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 75,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 6.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523803861189",
      "vsf_explanation": "Folic acid 800mcg. Prenatal folic acid supplementation is one of the strongest supplementation evidence bases: reduces neural tube defects (MRC Vitamin Study 1991). Folic acid is the synthetic form — 5-MTHF (methylfolate) is preferred in people with MTHFR polymorphisms and is not addressed here. Standard mass-market GMP.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-melatonin-3-mg-quick-dissolve-tablets",
      "title": "Nature's Bounty Melatonin, 3 Mg, Quick Dissolve Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/105048676.jpg?v=1783779424",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "melatonin",
        "quick",
        "dissolve",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 8.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523803926725",
      "vsf_explanation": "Melatonin 3mg quick-dissolve. Melatonin has strong evidence for sleep-onset latency and jet lag (Ferracioli-Oda 2013 meta-analysis). Interestingly, physiologic doses of 0.3-1mg often outperform 3-5mg (Zhdanova 2001). Standard mass-market GMP product; melatonin has known dose-standardization issues in the industry (Erland 2017 found 26x variance), but Nature's Bounty is more reliable than average.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-vitamin-b-12-quick-dissolve-tablets-1000mcg-aids-in-the-conversion-of-food-into-cellular-energy-cherry-flavor-60ct",
      "title": "Nature's Bounty Vitamin B-12 Quick Dissolve Tablets, 1000mcg, Aids In The Conversion Of Food Into Cellular Energy, Cherry Flavor, 60ct",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/142976353.jpg?v=1783779436",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "vitamin",
        "quick",
        "dissolve",
        "tablets",
        "1000mcg",
        "aids",
        "the",
        "conversion",
        "food",
        "into",
        "cellular",
        "energy",
        "cherry",
        "flavor",
        "60ct",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 75,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 11.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523804221637",
      "vsf_explanation": "B12 1000mcg quick-dissolve (sublingual delivery). B12 supplementation is well-supported for deficiency and B12 has an excellent safety profile. Nature's Bounty typically uses cyanocobalamin — methylcobalamin would be a stronger form. Listing has no body copy, weakening transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-vitamin-c-500-mg-supplement-250-tablets",
      "title": "Nature's Bounty Vitamin C-500 Mg Supplement - 250 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/57622130_b9338b72-d630-4417-9c43-9ec812276632.jpg?v=1783779454",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "vitamin",
        "500",
        "supplement",
        "250",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 75,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 12.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523804319941",
      "vsf_explanation": "Vitamin C 500mg tablets. Ascorbic acid at 500mg saturates plasma efficiently (Levine 1996) and is well-tolerated. Nothing exceptional but nothing wrong: standard form, standard dose, GMP mass-market, vegetarian, laboratory tested. Solid workhorse product.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-vitamin-b-6-100-mg-tablets",
      "title": "Nature's Bounty Vitamin B 6, 100 Mg, Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/342344687.jpg?v=1783779466",
      "score": 51,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "vitamin",
        "100",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 40,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 7.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523804385477",
      "vsf_explanation": "Vitamin B6 100mg (pyridoxine HCl, presumed — not stated). This dose is ~77x the RDA (1.3mg). Chronic high-dose B6 is linked to sensory peripheral neuropathy (Bacharach 2017 case series, Australian TGA warning 2022) — a real safety issue not disclosed on the listing. P5P (pyridoxal-5-phosphate) would be a superior form; pyridoxine HCl is standard mass-market.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-mega-chromium-picolinate-800-mcg-tablets",
      "title": "Nature's Bounty Mega Chromium Picolinate 800 Mcg Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/46067176.jpg?v=1783779482",
      "score": 51,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "mega",
        "chromium",
        "picolinate",
        "800",
        "mcg",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 9.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523804713157",
      "vsf_explanation": "Chromium picolinate 800mcg for glucose/metabolism support. Evidence is weak: Cochrane review (2013) and Balk (2007) meta-analysis found small, inconsistent effects on glycemic control and no meaningful weight-loss effect. Picolinate is a well-absorbed form. Dose is far above the AI (35mcg men, 25mcg women) but within safety margins.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-turmeric-plus-black-pepper-extract-1-000-mg-60-capsules",
      "title": "Nature's Bounty Turmeric Plus Black Pepper Extract, 1,000 Mg, 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/302781531.jpg?v=1783779493",
      "score": 53,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "turmeric",
        "plus",
        "black",
        "pepper",
        "extract",
        "000",
        "capsules",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 18.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523804778693",
      "vsf_explanation": "Turmeric 1000mg standardized extract with black pepper (piperine) for absorption. Piperine boosts curcumin bioavailability ~20x (Shoba 1998). However, curcumin percentage isn't stated — 1000mg turmeric root at typical 3-5% curcuminoids only yields 30-50mg curcumin vs. the 500-1000mg curcumin used in anti-inflammatory RCTs (Chainani-Wu 2003). Piperine addition helps but doesn't close the dose gap.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-glucosamine-chondroitin-complex-110-capsules",
      "title": "Nature's Bounty Glucosamine Chondroitin Complex 110 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/46041616.jpg?v=1783779505",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "glucosamine",
        "chondroitin",
        "complex",
        "110",
        "capsules",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 35,
        "manufacturing": 50,
        "safety": 65,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523804811461",
      "vsf_explanation": "Glucosamine chondroitin complex with no dose or form disclosed on the listing. RCT-effective doses (GAIT 2006) are glucosamine sulfate 1500mg + chondroitin 1200mg daily. Without disclosed dose it is impossible to confirm therapeutic exposure, and glucosamine HCl (cheaper form Nature's Bounty commonly uses) has weaker evidence than the sulfate form.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-milk-thistle-250-mg-dietary-supplement-capsules",
      "title": "Nature's Bounty Milk Thistle 250 Mg Dietary Supplement Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/95750184.jpg?v=1783779521",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "milk",
        "thistle",
        "250",
        "dietary",
        "supplement",
        "capsules",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 27.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523804909765",
      "vsf_explanation": "Milk thistle 250mg. Silybin, the active flavonolignan, has poor oral bioavailability; RCTs in liver disease typically use 420-600mg/day of standardized silymarin (Ferenci 1989). 250mg without standardization percentage or a phytosome/enhanced-absorption form is under-dosed and under-specified. Marketed for liver toxin-blocking, which is not clinically established.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-ginkgo-biloba-standardized-extract-120-mg-herbal-supplement-capsules",
      "title": "Nature's Bounty Ginkgo Biloba Standardized Extract 120 Mg Herbal Supplement Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/57636523_3baa08b0-2d49-4cac-a754-94326e453bce.jpg?v=1783779536",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "ginkgo",
        "biloba",
        "standardized",
        "extract",
        "120",
        "herbal",
        "supplement",
        "capsules",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 17.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523805139141",
      "vsf_explanation": "Ginkgo biloba 120mg standardized extract. EGb 761 RCTs use 120-240mg/day for cognitive complaints; results are mixed (GEM 2008 negative for dementia prevention). Standardization ratio (typically 24% flavone glycosides / 6% terpene lactones) is not disclosed. Anticoagulant interaction — real safety concern — is not called out on the listing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-co-q-10-200-mg-rapid-release-softgels",
      "title": "Nature's Bounty Co Q 10, 200 Mg, Rapid Release Softgels",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/323366844.gif?v=1783779546",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "200",
        "rapid",
        "release",
        "softgels",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 70,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 31.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523805204677",
      "vsf_explanation": "CoQ10 200mg rapid-release softgel. 200mg is a clinically meaningful dose — Q-SYMBIO (2014) used 300mg/day and showed mortality benefit in heart failure. Standard ubiquinone form; ubiquinol would score higher for bioavailability, especially in adults >40. Thin marketing copy limits transparency but softgel-lipid delivery is a reasonable choice.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-high-potency-coated-tablets-500-mg-magnesium",
      "title": "Nature's Bounty High Potency Coated Tablets 500 Mg Magnesium",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/117952237.gif?v=1783779558",
      "score": 51,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "high",
        "potency",
        "coated",
        "tablets",
        "500",
        "magnesium",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 7.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523806417093",
      "vsf_explanation": "Magnesium 500mg high-potency tablets. Form is not specified in the listing — Nature's Bounty typically uses magnesium oxide, which has ~4% bioavailability. 500mg elemental at that absorption rate delivers roughly 20mg — well below RCT-effective magnesium exposure. Coated for swallowability, non-GMO. Transparency on form is poor.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-turmeric-1000-mg-capsules️",
      "title": "Nature's Bounty Turmeric, 1000 mg, Capsules️",
      "vendor": "Duo Grocery",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/large_463098ed-0ea0-4bac-b864-1d0d78e5e17f.jpg?v=1783779566",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "turmeric",
        "1000",
        "capsules",
        "duo",
        "grocery"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 30,
        "manufacturing": 50,
        "safety": 65,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 34.58,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523806613701",
      "vsf_explanation": "Turmeric 1000mg with no listed standardization percentage and no bioavailability enhancer (piperine or phytosomal delivery). Plain turmeric is poorly absorbed (Anand 2007 — <1% oral bioavailability), and RCTs demonstrating anti-inflammatory effect use standardized curcumin extracts with piperine or lipid vehicles. Empty listing body from a generic reseller further weakens provenance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-coq-10-plus-100mg-softgels-60-count",
      "title": "Nature's Bounty CoQ-10 Plus 100mg Softgels 60 Count",
      "vendor": "Deal US",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/open-uri20251231-1807919-1qvf5vz.jpg?v=1783779575",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "coq",
        "plus",
        "100mg",
        "softgels",
        "count",
        "deal"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 70,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 11.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523806679237",
      "vsf_explanation": "CoQ10 (ubiquinone) 100mg softgel. CoQ10 has moderate evidence in heart failure (Q-SYMBIO 2014, 300mg/day) and for statin-associated myopathy. 100mg is a common dose but sub-optimal vs. RCT protocols. Standard ubiquinone form (ubiquinol is more bioavailable). Listing is thin with no ingredient panel and unfamiliar reseller.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-vitamin-d3-125-mcg-softgels️",
      "title": "Nature's Bounty Vitamin D3, 125 mcg, Softgels️",
      "vendor": "Duo Grocery",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/large_53a554d4-524c-4ce4-a8d7-93c0e31eaf38.jpg?v=1783779586",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "vitamin",
        "125",
        "mcg",
        "softgels",
        "duo",
        "grocery"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 70,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 51.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523807170757",
      "vsf_explanation": "Vitamin D3 (cholecalciferol) 125mcg = 5,000IU. D3 is well-supported for maintaining 25(OH)D levels (Bischoff-Ferrari 2009). Dose is above RDA but within the safe upper limit for adults. Product listing has no body copy and is sold through a generic grocery reseller — transparency and provenance are weak. Softgel form is standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-omega-3-600-mg-softgel-capsules-30-count",
      "title": "Nature's Bounty Omega-3 600 mg Softgel Capsules - 30 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Mhq7MSV1kiuIfNkzKoq9Yp7R0nOd8Qqcn0hJ5uCs.jpg?v=1783779601",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "omega",
        "600",
        "softgel",
        "capsules",
        "count",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 70,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 20.88,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523807269061",
      "vsf_explanation": "Omega-3 600mg total with 318mg EPA + 204mg DHA per softgel. Total EPA+DHA of 522mg/day is roughly half the ~1g/day threshold used in most cardiovascular RCTs (GISSI-Prevenzione, JELIS). Above the 25% sub-therapeutic autofail threshold but under-dosed for the marketed benefit. No third-party oxidation testing disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-magnesium-250-mg-supplement-tablets-60-count",
      "title": "Nature's Bounty Magnesium 250 mg Supplement Tablets | 60 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Qx9YsOiZ7gFjtA1NXsBdNB5vujo2S4LU7jRzk34e.jpg?v=1783779611",
      "score": 51,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "magnesium",
        "250",
        "supplement",
        "tablets",
        "count",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 70,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 21.32,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523807301829",
      "vsf_explanation": "Nature's Bounty magnesium 250mg tablets. Body copy is minimal and doesn't specify the magnesium form; based on the vendor's parallel SKU it's likely magnesium oxide, which is poorly absorbed (~4% bioavailability). Standard GMP manufacturing. Thin listing limits transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-omega-3-plus-vitamin-d3-60-softgels",
      "title": "Nature's Bounty Omega-3 Plus Vitamin D3 - 60 Softgels",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ESYoHCAdNNxMhbTCehuaTufIxgUldMYe0oFIvGtP.jpg?v=1783779635",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "omega",
        "plus",
        "vitamin",
        "softgels",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 70,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 32.85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523807629509",
      "vsf_explanation": "Fish oil 1200mg providing 360mg EPA+DHA plus 1000IU D3 per softgel. Omega-3 evidence is strong for triglyceride reduction (Mozaffarian & Wu 2011); 360mg EPA+DHA/day is below the 1g/day threshold typically used in cardiovascular RCTs. D3 dose is standard. No third-party purity/oxidation testing disclosed — a concern for fish oil. Fish sourcing/sustainability not mentioned.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-magnesium-supplement-250-mg-60-tablets-for-overall-health-wellness",
      "title": "Nature's Bounty Magnesium Supplement 250 mg - 60 Tablets for Overall Health & Wellness",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/wdf3767Xub3IqRmO9VMTQxpBXKfgfCUfDAyd0iOR.jpg?v=1783779644",
      "score": 54,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "magnesium",
        "supplement",
        "250",
        "tablets",
        "for",
        "overall",
        "health",
        "wellness",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 70,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 17.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523807727813",
      "vsf_explanation": "Magnesium oxide 250mg. Magnesium oxide has notoriously low bioavailability (~4%; Firoz & Graber 2001), making effective elemental magnesium delivery closer to ~10mg. Marketing claims 'high bioavailability' which contradicts the literature. Transparent about the form used, but form is a poor choice for supplementation. GMP mass-market.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-biotin-5000-mcg-supplement-for-hair-skin-and-nail-health-72-capsules",
      "title": "Nature's Bounty Biotin 5000 mcg Supplement for Hair, Skin, and Nail Health - 72 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/i3kHCrJA6HRjifEzVAKHSwRIErMhOpr70Fk8mHWs.jpg?v=1783779661",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "biotin",
        "5000",
        "mcg",
        "supplement",
        "for",
        "hair",
        "skin",
        "and",
        "nail",
        "health",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 29.56,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523807858885",
      "vsf_explanation": "Biotin 5000mcg (16,666% DV) marketed for hair, skin, nails. No RCT support for cosmetic benefit in non-deficient adults, and this dose reliably interferes with clinical lab tests (FDA safety communication 2019) — a real safety issue that is not disclosed. Standard tablet form and GMP manufacturing don't rescue the fundamental evidence gap.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-biotin-1000-mcg-supplement-supports-hair-skin-and-nail-health-100-tablets",
      "title": "Nature's Bounty Biotin 1000 mcg Supplement - Supports Hair, Skin, and Nail Health - 100 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/WJWcXCe4LlPTeyilFOeByoq6rsdn2cm9FuxDVk6m.jpg?v=1783779671",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "biotin",
        "1000",
        "mcg",
        "supplement",
        "supports",
        "hair",
        "skin",
        "and",
        "nail",
        "health",
        "100",
        "tablets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 22.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523807989957",
      "vsf_explanation": "Biotin 1000mcg (3,333% DV) for hair/skin/nails. Evidence for cosmetic benefit in non-deficient people is weak (Patel 2017 review found no RCTs supporting use in healthy adults). Additionally, biotin at these doses interferes with immunoassay lab tests (troponin, thyroid) — this warning is not disclosed. Standard formulation and mass-market GMP manufacturing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-lutein-6-mg-softgels-for-eye-health-support-antioxidant-supplement-50-count",
      "title": "Nature's Bounty Lutein 6 mg Softgels for Eye Health Support - Antioxidant Supplement, 50 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/VA536rPHo2yruRvuX6U5laVMwDSa0PIwEF4FZFWz_1b9a5936-c97f-48d2-b5af-37890c60c6e3.jpg?v=1783779681",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "lutein",
        "softgels",
        "for",
        "eye",
        "health",
        "support",
        "antioxidant",
        "supplement",
        "count",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 70,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 21.32,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523808088261",
      "vsf_explanation": "Lutein 6mg with naturally-occurring 240mcg zeaxanthin for eye health. AREDS2 (2013) used 10mg lutein + 2mg zeaxanthin, so this is roughly 60% of the RCT dose — clinically relevant but sub-optimal. Standard softgel form, GMP mass-market manufacturing, safe and well-tolerated.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-flush-free-niacin-500-mg-dietary-supplement-for-cardiovascular-health-50-capsules",
      "title": "Nature's Bounty Flush Free Niacin 500 mg Dietary Supplement for Cardiovascular Health - 50 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/rm2prWylYyy1t8Y3uUNArX67iObr2y4PDzhs0AEl.jpg?v=1783779692",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "flush",
        "free",
        "niacin",
        "500",
        "dietary",
        "supplement",
        "for",
        "cardiovascular",
        "health",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 30,
        "manufacturing": 55,
        "safety": 70,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 31.2,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523808415941",
      "vsf_explanation": "Flush-free niacin is inositol hexanicotinate, which fails to raise HDL or lower LDL in controlled trials (Meyers 2003; Keenan 2013 showed no lipid effect vs. real niacin). Marketing the product for 'cardiovascular health' when the form doesn't produce niacin's cardiovascular effects is misleading. Safe but effectively inert for the stated benefit.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-cla-1000-mg-50-softgel-capsules-supports-weight-management-immune-system",
      "title": "Nature's Bounty CLA 1000 mg 50 Softgel Capsules - Supports Weight Management & Immune System",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/mJZE9rB4R9dIizwn3Ty0HvXQOVFpe4CVCBgugjm3.jpg?v=1783779710",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "cla",
        "1000",
        "softgel",
        "capsules",
        "supports",
        "weight",
        "management",
        "immune",
        "system",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 47.65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523808547013",
      "vsf_explanation": "Conjugated Linoleic Acid 1000mg softgels at 4 caps/day = 4g CLA (Whigham 2007 meta-analysis found modest ~0.09 kg/week fat loss at 3.2-6g). Nature's Bounty is a GMP mass-market brand with standard labeling. Evidence is mixed and effect size is small, but dose is in the RCT range. Sold via a third-party reseller, which slightly weakens provenance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-vitamin-e-400-iu-softgel-supplement-antioxidant-support-for-overall-health-wellness",
      "title": "Nature's Bounty Vitamin E 400 IU Softgel Supplement - Antioxidant Support for Overall Health & Wellness",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/20lrwJE9KfFaxLQzNxW71kK5X4xR7xljpfojY9M6.jpg?v=1783779721",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "vitamin",
        "400",
        "softgel",
        "supplement",
        "antioxidant",
        "support",
        "for",
        "overall",
        "health",
        "wellness",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 50,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 31.2,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523808612549",
      "vsf_explanation": "Vitamin E 400 IU softgel. High-dose vitamin E supplementation has come under scrutiny — Miller et al. 2005 meta-analysis linked doses ≥400 IU/day to modest all-cause mortality increase, and the SELECT trial (2011) showed elevated prostate cancer risk. Form (likely dl-alpha-tocopherol synthetic vs. mixed tocopherols) is not specified. Low-Standard reflecting evidence pointing away from this dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-zinc-gluconate-10-mg-100-tablets-zinc-supplement-for-immune-support",
      "title": "Nature's Bounty Zinc Gluconate 10 mg 100 Tablets - Zinc Supplement for Immune Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6TOFKh1jVLo1M5JAG27R82sauUxdKH3OWAlmy9K2.jpg?v=1783779747",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "zinc",
        "gluconate",
        "100",
        "tablets",
        "zinc",
        "supplement",
        "for",
        "immune",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 50,
        "safety": 70,
        "transparency": 65,
        "sustainability": 45
      },
      "price": 19.68,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523809071301",
      "vsf_explanation": "Zinc gluconate 10 mg — a modest maintenance dose (RDA 11 mg men / 8 mg women). Immune RCTs typically use 15-25 mg for lozenge/cold-shortening effect (Hemila 2017). Established brand, gluconate is bioavailable, safety excellent at this dose. Reseller vendor limits manufacturing score. Mid-Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-vitamin-b12-methylcobalamin-1000-mcg-sublingual-supplement-60-tablets-for-energy-nerve-health",
      "title": "Nature's Bounty Vitamin B12 Methylcobalamin 1000 mcg Sublingual Supplement - 60 Tablets for Energy & Nerve Health",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/53sVSaPEjGxYGIqZBBWIqvsYUAZ8KAE3eE5kbjK8.jpg?v=1783779766",
      "score": 67,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "vitamin",
        "b12",
        "methylcobalamin",
        "1000",
        "mcg",
        "sublingual",
        "supplement",
        "tablets",
        "for",
        "energy",
        "nerve",
        "health",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 80,
        "manufacturing": 50,
        "safety": 75,
        "transparency": 70,
        "sustainability": 45
      },
      "price": 47.65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523809300677",
      "vsf_explanation": "Methylcobalamin (the preferred bioactive B12 form) at 1000 mcg sublingual — good format for absorption bypassing intrinsic factor limitations, meaningful for older adults and vegans. Dose and form are RCT-defensible (Andres et al. 2004). An unnamed reseller vendor lowers manufacturing confidence. Strong Standard, one step below Verified due to provenance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-milk-thistle-250-mg-capsules️",
      "title": "Nature's Bounty Milk Thistle, 250 mg, Capsules️",
      "vendor": "Duo Grocery",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/large_a45a8a42-a2ca-4bac-8f3d-45060c8f2165.jpg?v=1783779786",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "milk",
        "thistle",
        "250",
        "capsules",
        "duo",
        "grocery"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 65,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 52.38,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523809398981",
      "vsf_explanation": "Milk thistle at 250 mg — no silymarin standardization percentage visible in the listing, so hard to know how much actual silymarin (the active) is delivered. Liver-support RCTs are mixed and typically use standardized 200-400 mg silymarin doses. Established brand behind a reseller, GMP standard. Low Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-ginseng-complex-plus-royal-jelly-dietary-supplement-natural-energy-support-with-panax-ginseng-vitamin-b12-75-capsules",
      "title": "Nature's Bounty Ginseng Complex Plus Royal Jelly Dietary Supplement - Natural Energy Support with Panax Ginseng, Vitamin B12 - 75 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/zTiNgoIzJt3TNPzZMuImdQlgdRqv7MA3K1skAq67.jpg?v=1783779797",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "ginseng",
        "complex",
        "plus",
        "royal",
        "jelly",
        "dietary",
        "supplement",
        "natural",
        "energy",
        "support",
        "with",
        "panax",
        "ginseng",
        "vitamin",
        "b12",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 65,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 18.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523809530053",
      "vsf_explanation": "350 mg Panax + 50 mg American ginseng per 2-cap serving is on the low side of RCT-effective ranges (Panax typically 200-400 mg standardized extract; here likely non-standardized root powder). Royal jelly at 2 mg is symbolic. B12 at 30 mcg. Reseller vendor. Standard tier — real ingredients but underdosed on the flagship active.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-ultra-strength-probiotic-10️",
      "title": "Nature's Bounty Ultra Strength Probiotic 10️",
      "vendor": "Duo Grocery",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/large_52efeb78-5d76-450a-8102-78f23943d980.jpg?v=1783779815",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "ultra",
        "strength",
        "probiotic",
        "duo",
        "grocery"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 70,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 45.58,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523809726661",
      "vsf_explanation": "Nature's Bounty is an established mass-market brand (GMP, USP-verified on some SKUs). This 10-strain probiotic has no product description on the store page, so per-strain CFU counts and total dose are not visible to the shopper. Solid safety history; formulation and evidence limited by opaque strain-count details. Mid-Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "brain-alpha™-daily-cognitive-support-focus-memory-reaction-time-bacopa-alpha-gpc-huperzine-a-30-caps",
      "title": "Brain Alpha™ – Daily Cognitive Support | Focus, Memory & Reaction Time | Bacopa, Alpha GPC & Huperzine A | 30 Caps",
      "vendor": "My Store",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1779034164082-generated-label-image-1.jpg?v=1783779849",
      "score": 37,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "brain",
        "alpha",
        "daily",
        "cognitive",
        "support",
        "focus",
        "memory",
        "reaction",
        "time",
        "bacopa",
        "alpha",
        "gpc",
        "huperzine",
        "caps",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 35,
        "manufacturing": 30,
        "safety": 50,
        "transparency": 30,
        "sustainability": 35
      },
      "price": 29.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523809824965",
      "vsf_explanation": "Vendor field is literally 'My Store' — the default Shopify vendor placeholder, indicating a dropshipper or newly-created storefront with no verifiable manufacturer chain. Product page mentions Bacopa, Alpha GPC, Huperzine A, GABA, and L-theanine but no per-ingredient doses. Rejected on brand-provenance auto-fail.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "cognimore-cognitive-support-supplement-brain-health-capsules-with-citicoline-phosphatidylserine-and-ginkgo-biloba-extract",
      "title": "Cognimore Cognitive Support Supplement - Brain Health Capsules with Citicoline, Phosphatidylserine, and Ginkgo Biloba Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ct7vrMHBCfONfFKUqkkSIpTOmYA44q0Q1H0c4AoM.jpg?v=1783779902",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cognimore",
        "cognitive",
        "support",
        "supplement",
        "brain",
        "health",
        "capsules",
        "with",
        "citicoline",
        "phosphatidylserine",
        "and",
        "ginkgo",
        "biloba",
        "extract",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 40,
        "safety": 60,
        "transparency": 60,
        "sustainability": 40
      },
      "price": 42.72,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523810447557",
      "vsf_explanation": "Names the same active stack as the sibling Cognimore SKU (Citicoline, PS, Alpha-GPC, Ginkgo, Rhodiola, B vitamins) but this listing does not repeat the per-ingredient milligram doses in the visible copy. Reseller vendor and no verifiable manufacturer information. Low-Standard — legitimate ingredients but weaker transparency than the sibling.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cognimore-capsules-60-count",
      "title": "Cognimore Capsules - 60 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/UbVn9VhPpsy7W6MALrs0ilUIAxPLYafbGQ65wtJF.jpg?v=1783779916",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cognimore",
        "capsules",
        "count",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 40,
        "safety": 60,
        "transparency": 70,
        "sustainability": 40
      },
      "price": 67.41,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523810545861",
      "vsf_explanation": "Full per-ingredient dosing disclosed: Citicoline 250 mg, PS 250 mg, Alpha-GPC 150 mg, Ginkgo 120 mg, L-Theanine 100 mg, Rhodiola 100 mg, plus activated B vitamins. Doses are reasonable if modest (Alpha-GPC 150 mg is below the 400 mg RCT window). Reseller-brand vendor with no visible manufacturer transparency drags manufacturing score down. Mid-Standard for good label honesty at unclear provenance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "clarityx-sw-powder-sour-gummi-worm-flavor-160g",
      "title": "ClarityX SW Powder | Sour Gummi Worm Flavor | 160g",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/clarityx-sw-focus-powder-sour-gummi-worm-nootropic-drink-mix-for-focus-and-energy-160g-3916694.jpg?v=1783779936",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "clarityx",
        "powder",
        "sour",
        "gummi",
        "worm",
        "flavor",
        "160g",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 35.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523811496133",
      "vsf_explanation": "Nootropic drink mix naming Alpha GPC, L-Theanine, natural caffeine, amino acids, and 'botanical extracts' but the product page does not disclose individual milligram doses of the actives. Cannot assess whether any ingredient is at RCT-effective dose. Rejected on undisclosed-dose auto-fail.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "mind-forge-premium-nootropic-stack-for-focus-mental-clarity",
      "title": "Mind Forge | Premium Nootropic Stack for Focus & Mental Clarity",
      "vendor": "Protein Zone",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1759892859091-generated-label-image-0.jpg?v=1783779946",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mind",
        "forge",
        "premium",
        "nootropic",
        "stack",
        "for",
        "focus",
        "mental",
        "clarity",
        "protein",
        "zone"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523811594437",
      "vsf_explanation": "Nootropic capsule stack listing GABA, L-theanine, L-tyrosine, niacin, B6, caffeine, and 'advanced nootropic and botanical complex' with no individual doses given on the product page. Ingredients named are legitimate but no dosing means shoppers cannot verify RCT-effective amounts. Rejected on undisclosed-dose auto-fail.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "clarity-sour-candy",
      "title": "Clarity (Sour Candy)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_no_people_-_2026-02-28T012849.139.png?v=1783779956",
      "score": 28,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "clarity",
        "sour",
        "candy",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 20,
        "manufacturing": 35,
        "safety": 35,
        "transparency": 15,
        "sustainability": 35
      },
      "price": 27.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523811823813",
      "vsf_explanation": "Description itself flags '[amount not disclosed]' next to every active including caffeine — the product page acknowledges 'CRITICAL SAFETY CONCERN' for undisclosed caffeine content. Cannot assess dosing, safety, or therapeutic value. Rejected on undisclosed-dose auto-fail; the undisclosed caffeine specifically is a safety hazard.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "focus-first-sour-gummy-mental-clarity-concentration-support",
      "title": "Focus First Sour Gummy | Mental Clarity & Concentration Support",
      "vendor": "Halea Life: Nutrition & Skincare",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1782753529198-generated-label-image-0.jpg?v=1783779971",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "focus",
        "first",
        "sour",
        "gummy",
        "mental",
        "clarity",
        "concentration",
        "support",
        "halea",
        "life",
        "nutrition",
        "skincare"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 70,
        "transparency": 80,
        "sustainability": 50
      },
      "price": 26.96,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523811889349",
      "vsf_explanation": "Identical active formula to the Sour Candy SKU (200 mg green-tea caffeine, 300 mg Alpha GPC, 100 mg L-theanine, 1000 mg L-arginine, 600 mg inositol, B-complex) in a different flavor SKU. Same scoring rationale — transparent dosing, no prop blend, doses on the low end of RCT ranges. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "focus-first-sour-candy-nootropic-energy-concentration-drink-mix",
      "title": "Focus First Sour Candy | Nootropic Energy & Concentration Drink Mix",
      "vendor": "Halea Life: Nutrition & Skincare",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1782754384053-generated-label-image-0.jpg?v=1783780002",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "focus",
        "first",
        "sour",
        "candy",
        "nootropic",
        "energy",
        "concentration",
        "drink",
        "mix",
        "halea",
        "life",
        "nutrition",
        "skincare"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 70,
        "transparency": 80,
        "sustainability": 50
      },
      "price": 26.96,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523812085957",
      "vsf_explanation": "Full label disclosure: 200 mg green-tea caffeine, 300 mg Alpha GPC, 100 mg L-theanine, 1000 mg L-arginine, 600 mg inositol, B-complex. Alpha GPC and L-theanine at reasonable doses (though below RCT peak); caffeine-theanine pairing well-supported (Owen et al. 2008). No prop blend, but manufacturing transparency limited. Solid Standard for a nootropic drink mix.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "brain-focus-formula-lions-mane-bacopa-dmae",
      "title": "Brain & Focus Formula | Lion's Mane, Bacopa & DMAE",
      "vendor": "Halea Life: Nutrition & Skincare",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Clarity_Brain_Focus_Formula.jpg?v=1783780015",
      "score": 31,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "brain",
        "focus",
        "formula",
        "lion",
        "mane",
        "bacopa",
        "dmae",
        "halea",
        "life",
        "nutrition",
        "skincare"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 20,
        "manufacturing": 40,
        "safety": 40,
        "transparency": 20,
        "sustainability": 35
      },
      "price": 19.96,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523812184261",
      "vsf_explanation": "Explicit '617 mg Proprietary Blend of 16 botanicals' bundling DMAE, Bacopa, Alpha GPC, Phosphatidylserine, DHA, GABA, and Huperzine A. With that total blend size across 16 ingredients, no individual can plausibly be at its RCT-effective dose (Bacopa alone needs 300 mg; Alpha GPC 400 mg). Huperzine A is dose-sensitive and requires cycling, which cannot be assessed without disclosure. Rejected on prop-blend rule.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "bucked-up-pre-workout-powder-30-servings",
      "title": "Bucked Up Pre-Workout Powder, 30 Servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/bucked-up-bkfc..jpg?v=1783780035",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bucked",
        "pre",
        "workout",
        "powder",
        "servings",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 50,
        "safety": 65,
        "transparency": 70,
        "sustainability": 40
      },
      "price": 25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523812348101",
      "vsf_explanation": "Reasonably dosed: 200 mg caffeine, 6 g citrulline malate, 2 g beta-alanine — caffeine RCT-effective and citrulline near clinical range. Full ingredient disclosure claimed and consistent with label. Moderate stim load makes this the most defensible Bucked Up SKU. Held back from Verified by reseller manufacturer chain and lack of third-party sport certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bucked-up-pre-workout-30-servings",
      "title": "Bucked Up Pre-Workout, 30 Servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BuckedUpPreworkout.jpg?v=1783780055",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bucked",
        "pre",
        "workout",
        "servings",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 65,
        "sustainability": 40
      },
      "price": 35.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523812544709",
      "vsf_explanation": "Positioned as no-prop-blend with beta-alanine and citrulline malate at claimed clinical doses. Deer Antler Velvet inclusion adds a contested ingredient with no meaningful human RCT support for muscle growth. Solid on transparency ('no proprietary blends' asserted), average manufacturing given the reseller vendor. Mid-Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bucked-up-mother-bucker-high-stimulant-pre-workout-formula-20-servings",
      "title": "Bucked Up MOTHER BUCKER High-Stimulant Pre-Workout Formula - 20 Servings",
      "vendor": "Comito Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/miami.png?v=1783780070",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bucked",
        "mother",
        "bucker",
        "high",
        "stimulant",
        "pre",
        "workout",
        "formula",
        "servings",
        "comito",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 50,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 37.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523813298373",
      "vsf_explanation": "Extreme-stim pre-workout at 400 mg caffeine per scoop with a warning to start at half-scoop. Product description provides almost no ingredient specifics beyond caffeine, so most doses are undisclosed to the shopper. High stim load with limited ingredient transparency and a reseller vendor keeps this at the low end of Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrex-outlift-amped-22-servings",
      "title": "Nutrex OutLift Amped, 22 Servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/18_00a9819b-0baf-4dc9-a7e9-eceafa71f5bf.jpg?v=1783780090",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrex",
        "outlift",
        "amped",
        "servings",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 70,
        "manufacturing": 55,
        "safety": 45,
        "transparency": 70,
        "sustainability": 40
      },
      "price": 20,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523814183109",
      "vsf_explanation": "Aggressive but transparently-dosed formula: 8 g citrulline, 3.2 g beta-alanine, 3 g tyrosine, 385 mg caffeine, 50 mg TeaCrine — all at or near RCT-effective doses. Safety score drops for the 1.5 mg Rauwolfia (contains rauwolscine/alpha-yohimbine, a potent alpha-2 antagonist associated with anxiety and CV events) alongside a very high stim load. Reseller vendor lowers manufacturing confidence. Mid-Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bucked-up-lfg-burn-pre-workout-30-servings",
      "title": "Bucked Up LFG Burn Pre-Workout, 30 Servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/bucked-up-lfg-bkfc..jpg?v=1783780105",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bucked",
        "lfg",
        "burn",
        "pre",
        "workout",
        "servings",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 60,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 50,
        "sustainability": 40
      },
      "price": 30,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523814674629",
      "vsf_explanation": "Base actives are well-dosed (300 mg caffeine, 3200 mg beta-alanine, 1500 mg Nitrosigine) with solid RCT support. Thermogenic additions (MitoBurn L-BAIBA, Paradoxine) have thinner evidence, and the 'nootropic blend' of AlphaSize, Mucuna, and Huperzine A appears to hide individual doses. High stim load + reseller vendor keep this at mid-Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mushroom-energy-cognition-drops",
      "title": "Mushroom Energy & Cognition Drops",
      "vendor": "Native Salt Scrubs",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1776103322736-generated-label-image-0.jpg?v=1783780131",
      "score": 39,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mushroom",
        "energy",
        "cognition",
        "drops",
        "native",
        "salt",
        "scrubs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 20,
        "manufacturing": 35,
        "safety": 60,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523815362757",
      "vsf_explanation": "Cordyceps 100 mg, Lion's Mane 100 mg, Alpha GPC 25 mg, L-Tyrosine 25 mg per dropper. Lion's Mane RCT-effective doses are ~750-3000 mg/day (Mori et al. 2009), Alpha GPC is ~300-1200 mg (De Jesus Moreno 2003), and L-Tyrosine studies use grams. Every active is at 3-10% of RCT-effective dose. Rejected on sub-therapeutic dosing.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "stemcell-protein",
      "title": "StemCell Protein",
      "vendor": "Longevity Rx",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/05485_LongevityRx_Jar_StemCell-Protein_01_Front_300.jpg?v=1783780406",
      "score": 22,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "stemcell",
        "protein",
        "longevity"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 20,
        "manufacturing": 25,
        "safety": 30,
        "transparency": 20,
        "sustainability": 25
      },
      "price": 74.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46523819294917",
      "vsf_explanation": "Marketed as a bone-marrow-sourced protein with 'regenerative peptides,' 'bio-identical lipids,' and organ peptides to 'stimulate tissue regeneration' — language that reads as an implied disease/structure-function claim well beyond DSHEA and unsupported by any peer-reviewed RCT. No ingredient doses disclosed, no third-party testing referenced, no verifiable manufacturer credentials. Rejected on the disease-claim rule.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "thorne-basic-nutrients-2-day",
      "title": "Thorne Basic Nutrients 2/Day",
      "vendor": "Thorne",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ThorneBasicNutrients2Day.jpg?v=1788060897",
      "score": 89,
      "tier": "elite",
      "certifications": [
        "NSF Certified for Sport"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "thorne",
        "basic",
        "nutrients",
        "day",
        "thorne"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 90,
        "formulation": 92,
        "manufacturing": 92,
        "safety": 85,
        "transparency": 90,
        "sustainability": 70
      },
      "price": 42,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525299687621",
      "vsf_explanation": "Foundational multi built on active B-vitamin forms (5-MTHF folate, methylcobalamin, P-5-P B6) and chelated minerals — the anchor product for the Elite tier. NSF Certified for Sport (banned-substance and label verification), Thorne's own cGMP labs, published CoAs. Full label disclosure with individual dose amounts. Elite.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "thorne-creatine-monohydrate",
      "title": "Thorne Creatine Monohydrate",
      "vendor": "Thorne",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71-lmdLaYmL._AC_SL1500.jpg?v=1788061115",
      "score": 85,
      "tier": "elite",
      "certifications": [
        "NSF Certified for Sport"
      ],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "thorne",
        "creatine",
        "monohydrate",
        "thorne"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 85,
        "formulation": 80,
        "manufacturing": 85,
        "safety": 85,
        "transparency": 80,
        "sustainability": 55
      },
      "price": 52,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525299720389",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 78 → new 85. Evidence found: Kreider RB et al. International Society of Sports Nutrition position stand: safety and efficacy of creatine supplementation in exercise, sport, and medicine. J Int Soc Sports Nutr. 2017;14:18. | Chilibeck PD et al. Effect of creatine supplementation during resistance training on lean tissue mass and muscular strength in older adults: a meta-analysis. Open Access J Sports Med. 2017;8:213-226. | Thorne Creatine Monohydrate: NSF Certified for Sport, Creapure-source micronized creatine.. Rationale: Creatine monohydrate is the most-studied ergogenic supplement with TIER-A meta-analytic evidence for strength, lean mass, and increasingly cognition/mood in older adults and vegetarians. Thorne's NSF Certified for Sport plus Creapure sourcing is the gold-standard combination. Elite tier justified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "thorne-magnesium-bisglycinate",
      "title": "Thorne Magnesium Bisglycinate",
      "vendor": "Thorne",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/61-0NX05xYL._AC_SL1500.jpg?v=1788061188",
      "score": 85,
      "tier": "elite",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "thorne",
        "magnesium",
        "bisglycinate",
        "thorne"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 85,
        "manufacturing": 85,
        "safety": 85,
        "transparency": 85,
        "sustainability": 65
      },
      "price": 62,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525299753157",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 81 → new 85. Evidence found: Schuette SA, Lashner BA, Janghorbani M. Bioavailability of magnesium diglycinate vs magnesium oxide in patients with ileal resection. JPEN J Parenter Enteral Nutr. 1994;18(5):430-435. | Boyle NB et al. The Effects of Magnesium Supplementation on Subjective Anxiety and Stress-A Systematic Review. Nutrients. 2017;9(5):429. | Albion Minerals TRAACS bisglycinate chelate technology: patented mineral-amino acid chelate for enhanced absorption.. Rationale: Thorne uses Albion (Balchem) TRAACS magnesium bisglycinate — the reference chelate technology with demonstrated superior absorption vs oxide (Schuette 1994) and lower GI side effects. Practitioner-grade brand + patented delivery + established anxiety/sleep evidence class justifies Elite.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-encapsulations-o-n-e-multivitamin",
      "title": "Pure Encapsulations O.N.E. Multivitamin",
      "vendor": "Pure Encapsulations",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71RNL27j5fL._AC_SL1500.jpg?v=1788060623",
      "score": 86,
      "tier": "elite",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "encapsulations",
        "multivitamin",
        "pure",
        "encapsulations"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 85,
        "manufacturing": 80,
        "safety": 80,
        "transparency": 85,
        "sustainability": 60
      },
      "price": 53,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525299916997",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 79 → new 86. Evidence found: Pure Encapsulations O.N.E. Multivitamin: single-daily practitioner-grade multi with Metafolin (L-methylfolate), methylcobalamin, P-5-P, MenaQ7 K2, and Albion mineral chelates.. Rationale: O.N.E. is Pure Encaps' flagship one-per-day multi combining Metafolin folate, methylcobalamin B12, P-5-P B6, K2 MK-7, D3, mixed carotenoids, and Albion chelates in a single capsule. Elite tier is warranted — direct peer to Thorne Basic Nutrients 2/Day in a lower pill count. Includes CoQ10 and lutein/zeaxanthin adding value.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-encapsulations-magnesium-glycinate",
      "title": "Pure Encapsulations Magnesium (Glycinate)",
      "vendor": "Pure Encapsulations",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/download_12.webp?v=1783894273",
      "score": 84,
      "tier": "elite",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "encapsulations",
        "magnesium",
        "glycinate",
        "pure",
        "encapsulations"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 85,
        "manufacturing": 80,
        "safety": 85,
        "transparency": 85,
        "sustainability": 60
      },
      "price": 32.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525299949765",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 80 → new 84. Evidence found: Schuette SA et al. Bioavailability of magnesium diglycinate vs magnesium oxide. JPEN J Parenter Enteral Nutr. 1994;18(5):430-435. | Boyle NB et al. Effects of Magnesium Supplementation on Anxiety and Stress. Nutrients. 2017;9(5):429.. Rationale: Direct-Pure-Encapsulations-branded magnesium glycinate. Same formulation quality as the retailer-vended SKUs. Elite tier for practitioner-grade bisglycinate.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-encapsulations-epa-dha-essentials",
      "title": "Pure Encapsulations EPA/DHA Essentials",
      "vendor": "Pure Encapsulations",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/download_22.webp?v=1784039564",
      "score": 84,
      "tier": "elite",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "encapsulations",
        "epa",
        "dha",
        "essentials",
        "pure",
        "encapsulations"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 80,
        "formulation": 75,
        "manufacturing": 80,
        "safety": 85,
        "transparency": 85,
        "sustainability": 60
      },
      "price": 43.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525299982533",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 79 → new 84. Evidence found: Pure Encapsulations EPA/DHA Essentials: molecular-distilled fish oil, IFOS-certified purity, TG form. | Mozaffarian D, Wu JH. Omega-3 fatty acids and cardiovascular disease. J Am Coll Cardiol. 2011;58(20):2047-2067.. Rationale: Practitioner-grade fish oil with molecular distillation for contaminant removal and third-party IFOS-style purity verification. Elite tier for brand quality + delivery form + purity certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nordic-naturals-ultimate-omega",
      "title": "Nordic Naturals Ultimate Omega",
      "vendor": "Nordic Naturals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71U_ETSSQwL._AC_SL1500.jpg?v=1788060981",
      "score": 86,
      "tier": "elite",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nordic",
        "naturals",
        "ultimate",
        "omega",
        "nordic",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 85,
        "formulation": 90,
        "manufacturing": 85,
        "safety": 85,
        "transparency": 85,
        "sustainability": 80
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525300015301",
      "vsf_explanation": "1280 mg total omega-3 (650 EPA / 450 DHA) per serving in triglyceride form — matches the anchor for this rubric. RCT-effective for cardiovascular endpoints and triglyceride lowering (Skulas-Ray et al. AHA 2019). Batch-specific COAs published, Friends of the Sea, IFOS 5-star typical. Elite for the combination of TG form, dose, and third-party transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nordic-naturals-vitamin-d3-5000",
      "title": "Nordic Naturals Vitamin D3 5000",
      "vendor": "Nordic Naturals",
      "image_url": "",
      "score": 77,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nordic",
        "naturals",
        "vitamin",
        "5000",
        "nordic",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 80,
        "formulation": 80,
        "manufacturing": 75,
        "safety": 75,
        "transparency": 80,
        "sustainability": 70
      },
      "price": 0,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525300048069",
      "vsf_explanation": "Cholecalciferol 5000 IU carried in organic extra virgin olive oil for fat-soluble uptake — meta-analyses support D3 supplementation to raise serum 25(OH)D (Autier et al. 2014). 5000 IU is above the RDA but within the IOM tolerable upper limit for adults; still enough of a dose that periodic 25(OH)D testing is prudent. Third-party tested, clean label. Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nordic-naturals-omega-3",
      "title": "Nordic Naturals Omega-3",
      "vendor": "Nordic Naturals",
      "image_url": "",
      "score": 79,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nordic",
        "naturals",
        "omega",
        "nordic",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 80,
        "formulation": 80,
        "manufacturing": 75,
        "safety": 85,
        "transparency": 80,
        "sustainability": 70
      },
      "price": 0,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525300080837",
      "vsf_explanation": "690 mg omega-3 per serving in true triglyceride form (Neubronner et al. 2011 showed TG form ~24% better absorbed than ethyl ester). Non-GMO Project verified, third-party tested, batch COAs published on request. Nordic Naturals is Friends of the Sea certified. Slightly under the flagship Ultimate Omega dose which keeps it at the top of Verified rather than Elite.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "garden-of-life-vitamin-code-men",
      "title": "Garden of Life Vitamin Code Men",
      "vendor": "Garden of Life",
      "image_url": "",
      "score": 68,
      "tier": "standard",
      "certifications": [
        "Non-GMO Project Verified"
      ],
      "goal_tags": [],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "garden",
        "life",
        "vitamin",
        "code",
        "men",
        "garden",
        "life"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 65,
        "manufacturing": 70,
        "safety": 80,
        "transparency": 70,
        "sustainability": 80
      },
      "price": 0,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525300211909",
      "vsf_explanation": "Whole-food multi for men with added probiotics and enzymes, zinc and selenium for prostate. Same whole-food-form vs synthetic-form tradeoff as the Women's Multi — cleaner label but less serum-uptake evidence. Non-GMO Project Verified, B Corp brand. Standard tier for the format, held back from Verified by the limited RCT support for whole-food multi delivery.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "garden-of-life-mykind-organics-women-s-multi",
      "title": "Garden of Life mykind Organics Women's Multi",
      "vendor": "Garden of Life",
      "image_url": "",
      "score": 68,
      "tier": "standard",
      "certifications": [
        "USDA Organic"
      ],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "garden",
        "life",
        "mykind",
        "organics",
        "women",
        "multi",
        "garden",
        "life"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 65,
        "manufacturing": 70,
        "safety": 80,
        "transparency": 75,
        "sustainability": 80
      },
      "price": 0,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525300277445",
      "vsf_explanation": "USDA Organic whole-food-fermented multi with iron and folate for women. Whole-food multis have limited head-to-head RCT support vs. USP-form multis, and food-matrix nutrients typically test lower on serum uptake for a few key micros. Excellent sustainability (Certified B Corp, USDA Organic, NSF Gluten Free). Lands Standard — clean ethics, weaker evidence base for the nutrient delivery approach.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "garden-of-life-dr-formulated-probiotics-once-daily",
      "title": "Garden of Life Dr. Formulated Probiotics Once Daily",
      "vendor": "Garden of Life",
      "image_url": "",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "garden",
        "life",
        "formulated",
        "probiotics",
        "once",
        "daily",
        "garden",
        "life"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 70,
        "manufacturing": 65,
        "safety": 80,
        "transparency": 60,
        "sustainability": 75
      },
      "price": 0,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525300342981",
      "vsf_explanation": "50B CFU across 16 strains including L. plantarum and B. lactis, in a shelf-stable capsule. Multi-strain probiotic RCTs are heterogeneous — some evidence for IBS symptom improvement (Ford et al. 2018 meta), less for healthy adults. Individual per-strain CFU counts typically not disclosed. Garden of Life is USDA Organic and Certified B Corp which boosts sustainability, but transparency at the strain-dose level keeps it Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "now-foods-ultra-omega-3",
      "title": "NOW Foods Ultra Omega-3",
      "vendor": "NOW Foods",
      "image_url": "",
      "score": 78,
      "tier": "verified",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "foods",
        "ultra",
        "omega",
        "now",
        "foods"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 80,
        "formulation": 70,
        "manufacturing": 65,
        "safety": 85,
        "transparency": 75,
        "sustainability": 55
      },
      "price": 0,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525300408517",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 73 → new 78. Evidence found: NOW Foods Ultra Omega-3: molecularly distilled fish oil, GOED/IFOS-verified purity, 500 mg EPA + 250 mg DHA per softgel. | Mozaffarian D, Wu JH. Omega-3 fatty acids and cardiovascular disease. J Am Coll Cardiol. 2011;58(20):2047-2067.. Rationale: NOW Ultra Omega-3 delivers 750 mg EPA+DHA per softgel in molecularly distilled form. NOW's third-party testing program includes ConsumerLab and IFOS spot-checks. Uplift to 78; below Elite because certification isn't as consistently prominent as Life Extension Super Omega-3 IFOS 5-star.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "now-foods-magnesium-citrate",
      "title": "NOW Foods Magnesium Citrate",
      "vendor": "NOW Foods",
      "image_url": "",
      "score": 70,
      "tier": "verified",
      "certifications": [
        "GMP Certified"
      ],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "foods",
        "magnesium",
        "citrate",
        "now",
        "foods"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 65,
        "manufacturing": 65,
        "safety": 85,
        "transparency": 80,
        "sustainability": 55
      },
      "price": 0,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525300441285",
      "vsf_explanation": "Magnesium citrate at 133 mg elemental per cap — well-absorbed form (Walker et al. 2003 crossover showed citrate outperformed oxide). Dose is modest so several caps daily needed to hit RCT-typical 300-400 mg elemental. NOW GMP quality; clean single-ingredient label. Verified at the low end for standard form, standard dose, standard manufacturing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "now-foods-l-theanine-200-mg",
      "title": "NOW Foods L-Theanine 200 mg",
      "vendor": "NOW Foods",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/719VuO_vHOL._AC_SL1500.jpg?v=1788061329",
      "score": 80,
      "tier": "elite",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "cognitive",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "foods",
        "theanine",
        "200",
        "now",
        "foods"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 75,
        "manufacturing": 70,
        "safety": 85,
        "transparency": 85,
        "sustainability": 55
      },
      "price": 22.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525300474053",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 74 → new 80. Evidence found: Kimura K et al. L-Theanine reduces psychological and physiological stress responses. Biol Psychol. 2007;74(1):39-45. | Kelly SP et al. L-theanine and caffeine improve target-specific attention in the attention network test. Nutr Neurosci. 2008;11(4):193-198. | Hidese S et al. Effects of L-Theanine Administration on Stress-Related Symptoms and Cognitive Functions in Healthy Adults. Nutrients. 2019;11(10):2362.. Rationale: L-Theanine at 200 mg matches the majority of positive stress/attention RCTs (Kimura 2007, Kelly 2008, Hidese 2019). NOW Foods is USP + GMP with third-party purity testing. Elite tier for ingredient-class TIER-A evidence at studied dose from a reliable manufacturer.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "life-extension-two-per-day-multivitamin",
      "title": "Life Extension Two-Per-Day Multivitamin",
      "vendor": "Life Extension",
      "image_url": "",
      "score": 78,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "life",
        "extension",
        "two",
        "per",
        "day",
        "multivitamin",
        "life",
        "extension"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 80,
        "manufacturing": 70,
        "safety": 75,
        "transparency": 80,
        "sustainability": 55
      },
      "price": 0,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525300506821",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 73 → new 78. Evidence found: Life Extension Two-Per-Day formulation uses 5-MTHF (Quatrefolic branded), methylcobalamin, P-5-P, K2 MK-7 (MenaQ7 branded), and bioidentical vitamin forms consistent with practitioner-grade multivitamin standards. | Rautiainen S et al. Multivitamin use and the risk of cardiovascular disease in men. J Nutr. 2016;146(6):1235-1240 (representative multivitamin evidence class).. Rationale: Two-Per-Day uses bioactive forms of B vitamins (methylated folate and B12, P-5-P), K2 as MK-7, and Se-methylselenocysteine — placing it in the same practitioner-grade tier as Thorne Basic Nutrients. Uplift reflects form-quality parity with Elite competitors while remaining below Basic Nutrients 2/Day due to less transparency in COA publication.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "life-extension-super-omega-3-epa-dha",
      "title": "Life Extension Super Omega-3 EPA/DHA",
      "vendor": "Life Extension",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/116.avif?v=1788060175",
      "score": 82,
      "tier": "elite",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "life",
        "extension",
        "super",
        "omega",
        "epa",
        "dha",
        "life",
        "extension"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 78,
        "manufacturing": 80,
        "safety": 78,
        "transparency": 72,
        "sustainability": 65
      },
      "price": 70,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525300539589",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 76 → new 82. Evidence found: IFOS (International Fish Oil Standards) 5-star certified for purity, potency, and freshness on Life Extension Super Omega-3 lots. | Mozaffarian D, Wu JH. Omega-3 fatty acids and cardiovascular disease: effects on risk factors, molecular pathways, and clinical events. J Am Coll Cardiol. 2011;58(20):2047-2067. | Bhatt DL et al. REDUCE-IT trial: EPA and cardiovascular events. N Engl J Med. 2019;380:11-22 (icosapent ethyl class evidence).. Rationale: Life Extension Super Omega-3 delivers 700 mg EPA + 500 mg DHA per 2-softgel serving with olive polyphenols and sesame lignans for oxidative stability. IFOS 5-star certification is the gold standard for fish oil third-party verification. Elite tier justified by combined purity certification, therapeutic-dose delivery, and antioxidant matrix.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "life-extension-nad-cell-regenerator",
      "title": "Life Extension NAD+ Cell Regenerator",
      "vendor": "Life Extension",
      "image_url": "",
      "score": 74,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "life",
        "extension",
        "nad",
        "cell",
        "regenerator",
        "life",
        "extension"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 70,
        "sustainability": 50
      },
      "price": 0,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525300605125",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 62 → new 74. Evidence found: Trammell SA et al. Nicotinamide riboside is uniquely and orally bioavailable in mice and humans. Nat Commun. 2016;7:12948. | Martens CR et al. Chronic nicotinamide riboside supplementation is well-tolerated and elevates NAD+ in healthy middle-aged and older adults. Nat Commun. 2018;9:1286. | Airhart SE et al. An open-label, non-randomized study of the pharmacokinetics of the nutritional supplement nicotinamide riboside in humans. PLoS One. 2017;12(12):e0186459.. Rationale: LE NAD+ Cell Regenerator uses NIAGEN (Chromadex-branded nicotinamide riboside), the same NR compound with published PK and safety data in humans (Trammell 2016, Martens 2018). NR reliably elevates whole-blood NAD+ by 40-60% at 300 mg/day. Uplift to Verified — capped below 80 because clinical-endpoint trials (aging, cardiometabolic outcomes) remain limited to biomarker studies.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "designs-for-health-twice-daily-multi",
      "title": "Designs for Health Twice Daily Multi",
      "vendor": "Designs for Health",
      "image_url": "",
      "score": 77,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "designs",
        "for",
        "health",
        "twice",
        "daily",
        "multi",
        "designs",
        "for",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 78,
        "manufacturing": 70,
        "safety": 75,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 0,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525300670661",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 69 → new 77. Evidence found: Designs for Health Twice Daily Multi uses L-methylfolate (Quatrefolic), methylcobalamin, P-5-P, K2 MK-7 (MenaQ7), and Albion mineral chelates.. Rationale: DFH Twice Daily Multi delivers bioactive-form B vitamins (5-MTHF, methylcobalamin, P-5-P), K2 MK-7 branded, and Albion mineral chelates — the practitioner-grade multi template. Uplift to Verified for form quality; capped below Elite because DFH's third-party COA program is less publicly prominent than Thorne's NSF Certified for Sport pathway.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "designs-for-health-omegavail-ultra",
      "title": "Designs for Health OmegAvail Ultra",
      "vendor": "Designs for Health",
      "image_url": "",
      "score": 80,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "designs",
        "for",
        "health",
        "omegavail",
        "ultra",
        "designs",
        "for",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 78,
        "manufacturing": 75,
        "safety": 78,
        "transparency": 70,
        "sustainability": 60
      },
      "price": 0,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525300736197",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 75 → new 80. Evidence found: Designs for Health OmegAvail Ultra: high-EPA/DHA fish oil in triglyceride form with lipase blend (TG form). | Dyerberg J et al. Bioavailability of marine n-3 fatty acid formulations. Prostaglandins Leukot Essent Fatty Acids. 2010;83(3):137-141 (TG vs EE form comparison).. Rationale: OmegAvail Ultra uses triglyceride-form (TG) fish oil, which has 27-70% better absorption than ethyl-ester form (Dyerberg 2010). Added lipase enzyme complex further supports absorption in low-fat meals. Practitioner-grade brand + TG form + delivery enhancement warrants uplift to 80.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "douglas-laboratories-ultra-preventive-x",
      "title": "Douglas Laboratories Ultra Preventive X",
      "vendor": "Douglas Laboratories",
      "image_url": "",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "douglas",
        "laboratories",
        "ultra",
        "preventive",
        "douglas",
        "laboratories"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 65,
        "safety": 70,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 0,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525300768965",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 60 → new 72. Evidence found: Douglas Laboratories Ultra Preventive X: comprehensive multivitamin with bioactive B forms (methyl folate, methylcobalamin), K2, and antioxidant/phytonutrient blend.. Rationale: Ultra Preventive X is Douglas Labs' flagship comprehensive multi with bioactive B forms, K2, mixed carotenoids, and phytonutrient blend. Practitioner-only brand with 40+ year history. Uplift to Verified; below Elite because the phytonutrient inclusions are largely non-standardized doses.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "jarrow-formulas-jarro-dophilus-eps",
      "title": "Jarrow Formulas Jarro-Dophilus EPS",
      "vendor": "Jarrow Formulas",
      "image_url": "",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "jarrow",
        "formulas",
        "jarro",
        "dophilus",
        "eps",
        "jarrow",
        "formulas"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 75,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 0,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525300801733",
      "vsf_explanation": "5 billion CFU across 8 strains in an EnteroGuard enteric-coated capsule. Enteric coating is a defensible delivery choice for probiotic survival past stomach acid. 5B CFU is on the lower end for a multi-strain product; individual strain identifiers are listed but the per-strain RCT evidence is mixed. Standard — decent delivery, modest dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "jarrow-formulas-methyl-b-12-1000-mcg",
      "title": "Jarrow Formulas Methyl B-12 1000 mcg",
      "vendor": "Jarrow Formulas",
      "image_url": "",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "jarrow",
        "formulas",
        "methyl",
        "1000",
        "mcg",
        "jarrow",
        "formulas"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 78,
        "manufacturing": 62,
        "safety": 78,
        "transparency": 72,
        "sustainability": 50
      },
      "price": 0,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525300834501",
      "vsf_explanation": "1000 mcg methylcobalamin in sublingual lozenge form. Methylcobalamin is the active coenzyme form of B12 (vs cyanocobalamin), useful for individuals with MTHFR variants or absorption issues. Sublingual delivery bypasses intrinsic-factor absorption for those with pernicious anemia (Sharabi 2003). Jarrow is GMP-compliant. Verified — right form, right dose, right delivery route.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "doctor-s-best-high-absorption-magnesium",
      "title": "Doctor's Best High Absorption Magnesium",
      "vendor": "Doctor's Best",
      "image_url": "",
      "score": 78,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "doctor",
        "best",
        "high",
        "absorption",
        "magnesium",
        "doctor",
        "best"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 80,
        "manufacturing": 62,
        "safety": 78,
        "transparency": 75,
        "sustainability": 55
      },
      "price": 0,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525300867269",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 72 → new 78. Evidence found: Schuette SA et al. Bioavailability of magnesium diglycinate vs magnesium oxide. JPEN J Parenter Enteral Nutr. 1994;18(5):430-435. | Doctor's Best High Absorption Magnesium: Albion (TRAACS) magnesium bisglycinate/lysinate chelate.. Rationale: Doctor's Best High Absorption Magnesium uses Albion TRAACS chelate (bisglycinate/lysinate blend) — the same premium chelate technology as Thorne and Pure Encaps. Third-party tested. Uplift to 78; below Elite because Doctor's Best label transparency and testing publication is less prominent than practitioner-grade competitors.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "doctor-s-best-benfotiamine-150-mg",
      "title": "Doctor's Best Benfotiamine 150 mg",
      "vendor": "Doctor's Best",
      "image_url": "",
      "score": 74,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "doctor",
        "best",
        "benfotiamine",
        "150",
        "doctor",
        "best"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 60,
        "safety": 75,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 0,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525300900037",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 65 → new 74. Evidence found: Stracke H et al. Benfotiamine in diabetic polyneuropathy (BENDIP): results of a randomised, double blind, placebo-controlled clinical study. Exp Clin Endocrinol Diabetes. 2008;116(10):600-605. | Haupt E et al. Benfotiamine in the treatment of diabetic polyneuropathy—a three-week randomized, controlled pilot study. Int J Clin Pharmacol Ther. 2005;43(2):71-77.. Rationale: Benfotiamine (lipid-soluble thiamine derivative) has TIER-B evidence for diabetic polyneuropathy (Stracke 2008 BENDIP trial). Better absorbed and reaches peripheral nerves more effectively than water-soluble thiamine. 150 mg is a reasonable maintenance dose (higher doses used in trials). Verified tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-vitamin-d3-5000-iu",
      "title": "Solgar Vitamin D3 5000 IU",
      "vendor": "Solgar",
      "image_url": "",
      "score": 80,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "vitamin",
        "5000",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 75,
        "manufacturing": 68,
        "safety": 78,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 0,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525300932805",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 73 → new 80. Evidence found: Holick MF. Vitamin D deficiency. N Engl J Med. 2007;357(3):266-81. | Autier P, et al. Vitamin D status and ill health: a systematic review. Lancet Diabetes Endocrinol. 2014;2(1):76-89. | Bischoff-Ferrari HA, et al. Pooled analysis of vitamin D dose requirements for fracture prevention. N Engl J Med. 2012;367(1):40-9.. Rationale: TIER-A ingredient evidence for D3 in deficient populations (fracture prevention, immune modulation, PTH suppression). 5000 IU is above the RDA but within safe upper limits and appropriate for correcting documented deficiency common in US adults. D3 (cholecalciferol) form is superior to D2. +7 uplift reflects strong evidence and appropriate dose format.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "carlson-labs-the-very-finest-fish-oil",
      "title": "Carlson Labs The Very Finest Fish Oil",
      "vendor": "Carlson Labs",
      "image_url": "",
      "score": 80,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "carlson",
        "labs",
        "the",
        "very",
        "finest",
        "fish",
        "oil",
        "carlson",
        "labs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 85,
        "formulation": 82,
        "manufacturing": 82,
        "safety": 78,
        "transparency": 75,
        "sustainability": 70
      },
      "price": 0,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525301031109",
      "vsf_explanation": "1600 mg omega-3 per teaspoon liquid fish oil — a genuinely high per-serving dose that requires a lot of softgels to match. Norwegian sourced, natural triglyceride form, IFOS certified. Long-established Carlson brand. Omega-3 evidence base is very strong (Mozaffarian 2011, REDUCE-IT 2019 at higher purified doses). Verified — one of the strongest per-serving omega-3 doses available in a well-verified format.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "optimum-nutrition-gold-standard-100-whey",
      "title": "Optimum Nutrition Gold Standard 100% Whey",
      "vendor": "Optimum Nutrition",
      "image_url": "",
      "score": 74,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "optimum",
        "nutrition",
        "gold",
        "standard",
        "100",
        "whey",
        "optimum",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 82,
        "formulation": 75,
        "manufacturing": 72,
        "safety": 78,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 0,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525301063877",
      "vsf_explanation": "24 g whey protein per scoop, whey isolate as primary source, 5.5 g naturally-occurring BCAAs. Whey for muscle protein synthesis has a large RCT base (Morton 2018 meta-analysis). Isolate-first is the more efficient formulation. Banned-substance tested (Informed Choice level). Verified — the category benchmark for a reason, though not NSF Sport.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "optimum-nutrition-micronized-creatine-powder",
      "title": "Optimum Nutrition Micronized Creatine Powder",
      "vendor": "Optimum Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/download_21.webp?v=1784039520",
      "score": 77,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "optimum",
        "nutrition",
        "micronized",
        "creatine",
        "powder",
        "optimum",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 88,
        "formulation": 82,
        "manufacturing": 65,
        "safety": 82,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 32.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525301096645",
      "vsf_explanation": "5 g micronized creatine monohydrate per serving. Same textbook RCT support as Momentous (Kreider 2017 ISSN meta) at RCT-effective dose. Micronization improves solubility without changing efficacy. Optimum Nutrition (Glanbia-owned) is GMP-compliant but does not carry NSF/Informed Sport for this SKU — the reason it scores below Momentous despite identical ingredient quality. Verified because the ingredient case is that strong.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "momentous-creatine-monohydrate",
      "title": "Momentous Creatine Monohydrate",
      "vendor": "Momentous",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/download_20.webp?v=1784039442",
      "score": 88,
      "tier": "elite",
      "certifications": [
        "NSF Certified for Sport",
        "Informed Sport"
      ],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "momentous",
        "creatine",
        "monohydrate",
        "momentous"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 90,
        "formulation": 82,
        "manufacturing": 88,
        "safety": 80,
        "transparency": 75,
        "sustainability": 55
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525301227717",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score undefined → new 88. Evidence found: Kreider RB, et al. International Society of Sports Nutrition position stand: safety and efficacy of creatine supplementation in exercise, sport, and medicine. J Int Soc Sports Nutr. 2017;14:18. DOI:10.1186/s12970-017-0173-z. | Bhagavan HN, Chopra RK. et al Creapure (AlzChem, Germany) creatine PK dossier: 99.95% purity by HPLC, ISO-certified manufacturing, decades of published PK and safety data. Creapure is the branded creatine monohydrate used in the majority of positive published RCTs. | Momentous product certifications: NSF Certified for Sport AND Informed Sport - both banned-substance-tested for elite athletes.. Rationale: Momentous Creatine Monohydrate is the closest thing to a textbook-perfect scored SKU in the sports nutrition category. Creatine monohydrate has one of the largest evidence bases in all of nutritional science (Kreider 2017 ISSN position stand covers hundreds of RCTs), 5 g/serving is exactly the evidence-standard daily dose, the branded ingredient is Creapure (or since 2024 the equivalent-purity Signature Spec pharmaceutical-facility source), and it carries BOTH NSF Certified for Sport AND Informed Sport banned-substance certifications - the strongest third-party quality signal available for sports supplements. Nothing about the formulation or manufacturing is holding it back from Elite. +12 uplift to 88 Elite. Held below 90 only because 'creatine' as an ingredient is TIER-A regardless of brand - the marginal difference between Momentous and any other reputable NSF-certified creatine at the same 5 g dose is manufacturing pedigree, not clinical efficacy.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "momentous-sleep",
      "title": "Momentous Sleep",
      "vendor": "Momentous",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shopping_3.webp?v=1784039391",
      "score": 86,
      "tier": "elite",
      "certifications": [
        "NSF Certified for Sport"
      ],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "momentous",
        "sleep",
        "momentous"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 78,
        "manufacturing": 88,
        "safety": 78,
        "transparency": 78,
        "sustainability": 55
      },
      "price": 119.25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525301260485",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score undefined → new 86. Evidence found: Slutsky I, et al. Enhancement of learning and memory by elevating brain magnesium. Neuron. 2010;65(2):165-77. DOI:10.1016/j.neuron.2009.12.026. | Recent human RCT on Magtein at 2 g/day for 6 weeks in adults 18-45 with dissatisfied sleep (n=100) showed statistically significant improvements in NIH Total Cognition Composite scores, working memory, and episodic memory versus placebo (published Frontiers in Nutrition 2025). | Nobre AC, Rao A, Owen GN. L-theanine, a natural constituent in tea, and its effect on mental state. Asia Pac J Clin Nutr. 2008;17 Suppl 1:167-8. | Hidese S, et al. Effects of L-Theanine Administration on Stress-Related Symptoms and Cognitive Functions in Healthy Adults: A Randomized Controlled Trial. Nutrients. 2019;11(10):2362. DOI:10.3390/nu11102362. | Momentous product certification: NSF Certified for Sport.. Rationale: Momentous Sleep is a study in evidence-anchored formulation. The two heaviest-weighted ingredients hit their studied doses precisely: 2 g Magtein Magnesium L-Threonate matches the exact protocol in the recent 6-week human sleep/cognition RCT (145 mg elemental magnesium, brain-Mg delivery form established by Slutsky 2010 in Neuron), and 200 mg L-theanine matches Nobre 2008 (alpha-wave EEG) and Hidese 2019 (Pittsburgh Sleep Quality Index improvement). Apigenin at 50 mg is the weakest link - no isolated-apigenin human RCT exists at that dose; all published human evidence is from chamomile extracts delivering ~23 mg apigenin (Zick 2011). NSF Certified for Sport reinforces manufacturing quality. Important factual correction from the prior scoring: Momentous Sleep does NOT contain melatonin - the prior explanation citing 'low-dose melatonin' was in error. The Magtein exact-dose brand-anchor match and NSF certification justify +9 uplift to 86 Elite. Held below 90 because the apigenin dose has no direct clinical anchor.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ritual-essential-for-women-18",
      "title": "Ritual Essential for Women 18+",
      "vendor": "Ritual",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/download_19.webp?v=1783996203",
      "score": 84,
      "tier": "elite",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "ritual",
        "essential",
        "for",
        "women",
        "ritual"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 70,
        "manufacturing": 75,
        "safety": 78,
        "transparency": 85,
        "sustainability": 75
      },
      "price": 42.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525301293253",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score undefined → new 84. Evidence found: Osburn SC, Roberson PA, Medler JA, et al. Effects of 12-Week Multivitamin and Omega-3 Supplementation on Micronutrient Levels and Red Blood Cell Fatty Acids in Pre-menopausal Women. Front Nutr. 2021;8:610382. DOI:10.3389/fnut.2021.610382. | Holick MF. Vitamin D deficiency. N Engl J Med. 2007;357(3):266-81. | Delayed-release capsule format with published ingredient origin traceability page (each nutrient's source disclosed).. Rationale: Ritual Essential for Women 18+ is one of only a handful of DTC multivitamins with peer-reviewed brand-specific RCT evidence - Osburn et al. 2021 in Frontiers in Nutrition (Auburn University site, 12 weeks, n=94, double-blind, placebo-controlled). The trial hit both primary endpoints: +43.7% serum vitamin D and significantly higher red blood cell DHA versus placebo. That is TIER-A anchor evidence at the exact studied product. Layered on top: published ingredient origin traceability (each nutrient's source is disclosed on the brand's site), disciplined nine-nutrient formulation focused on gaps in adult women's diets rather than a kitchen-sink profile, methylated B12, delayed-release capsule format. +12 uplift to 84 Elite. Held slightly below the very top of Elite because the trial's PMC record describes the tested product as 'a customized research formulation formulated by Natals, Inc, known as Ritual' - the reported outcomes clearly apply to Essential for Women but this technical language is a minor 'trial version vs shelf version' caveat.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ritual-essential-for-men-18",
      "title": "Ritual Essential for Men 18+",
      "vendor": "Ritual",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/download_18.webp?v=1783996163",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "ritual",
        "essential",
        "for",
        "men",
        "ritual"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 70,
        "manufacturing": 75,
        "safety": 78,
        "transparency": 85,
        "sustainability": 75
      },
      "price": 42.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525301326021",
      "vsf_explanation": "Nine-nutrient men's multi including D3, K2, methylated B12, and omega-3 DHA in a delayed-release capsule. Ritual's edge is transparency — every ingredient's origin is published on their site, and the formula focuses on nutrients men commonly under-consume rather than a kitchen-sink profile. Third-party tested for purity. Verified because the transparency and formulation discipline exceed almost anything else in the mainstream multi aisle.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "seed-ds-01-daily-synbiotic",
      "title": "Seed DS-01 Daily Synbiotic",
      "vendor": "Seed",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/download_16.webp?v=1783996057",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "seed",
        "daily",
        "synbiotic",
        "seed"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 78,
        "manufacturing": 70,
        "safety": 75,
        "transparency": 78,
        "sustainability": 75
      },
      "price": 62.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525301358789",
      "vsf_explanation": "53.6 billion AFU across 24 strains plus a polyphenol prebiotic in a nested ViaCap capsule for stomach acid survival. Individual strains have varying RCT support; the full DS-01 formula was studied in a company-funded RCT (Wastyk 2023 for gut transit). Strain-level transparency at species and strain-designation level is unusually strong. Verified — the delivery engineering and transparency are real, though marketing runs ahead of independent evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nature-made-vitamin-d3-2000-iu",
      "title": "Nature Made Vitamin D3 2000 IU",
      "vendor": "Nature Made",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/download_17.webp?v=1783996107",
      "score": 76,
      "tier": "verified",
      "certifications": [
        "USP Verified"
      ],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "made",
        "vitamin",
        "2000",
        "nature",
        "made"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 75,
        "manufacturing": 82,
        "safety": 78,
        "transparency": 75,
        "sustainability": 60
      },
      "price": 22.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525301424325",
      "vsf_explanation": "2000 IU vitamin D3 (cholecalciferol) softgel. D3 has robust RCT support for bone (Bischoff-Ferrari 2009 meta) and 2000 IU sits within the range typically recommended for status maintenance. Cholecalciferol is the correct form. USP Verified — genuinely one of the highest-purity signals available in mainstream retail. Solid Verified: right ingredient, right form, right dose, verified purity.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nature-made-fish-oil-1200-mg",
      "title": "Nature Made Fish Oil 1200 mg",
      "vendor": "Nature Made",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/download_15.webp?v=1783996006",
      "score": 69,
      "tier": "standard",
      "certifications": [
        "USP Verified"
      ],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "made",
        "fish",
        "oil",
        "1200",
        "nature",
        "made"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 78,
        "safety": 78,
        "transparency": 75,
        "sustainability": 60
      },
      "price": 22.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525301522629",
      "vsf_explanation": "1200 mg fish oil delivering only 360 mg total omega-3 per softgel, meaning multiple softgels are needed to hit the guideline dose. Form is likely ethyl ester rather than the triglyceride form used in current premium products. USP Verified is a strong purity signal though — one of the few OTC brands carrying it. High Standard — trustworthy purity, under-dosed per softgel.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nature-s-bounty-magnesium-500-mg",
      "title": "Nature's Bounty Magnesium 500 mg",
      "vendor": "Nature's Bounty",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/download_14.webp?v=1783995963",
      "score": 51,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "magnesium",
        "500",
        "nature",
        "bounty"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 23.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525301555397",
      "vsf_explanation": "500 mg magnesium tablet — form is not disclosed in the description, which typically indicates magnesium oxide (the cheapest and lowest-bioavailability form, roughly 4% absorbed per Firoz 2001). Nature's Bounty is GMP-compliant but relies almost entirely on internal testing. Just above the Rejected line — the ingredient does something but the delivery format is a poor way to deliver it.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sports-research-triple-strength-omega-3",
      "title": "Sports Research Triple Strength Omega-3",
      "vendor": "Sports Research",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/download_13.webp?v=1783995759",
      "score": 82,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sports",
        "research",
        "triple",
        "strength",
        "omega",
        "sports",
        "research"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 82,
        "formulation": 85,
        "manufacturing": 85,
        "safety": 80,
        "transparency": 80,
        "sustainability": 70
      },
      "price": 42.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525301686469",
      "vsf_explanation": "1250 mg fish oil delivering 690 mg EPA and 260 mg DHA in triglyceride form. Omega-3 has a massive RCT base for cardiovascular endpoints (REDUCE-IT 2019 for icosapent, Mozaffarian 2011 meta) and this dose is within the guideline-effective range. Triglyceride form is superior to ethyl ester for absorption (Dyerberg 2010). IFOS 5-star certification is a strong third-party purity signal. High Verified — one of the best OTC omega-3s on the market.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sports-research-collagen-peptides",
      "title": "Sports Research Collagen Peptides",
      "vendor": "Sports Research",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shopping_2.webp?v=1783995710",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sports",
        "research",
        "collagen",
        "peptides",
        "sports",
        "research"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 70,
        "safety": 78,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 36.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525301817541",
      "vsf_explanation": "11 g hydrolyzed type I and III bovine collagen peptides per scoop. Dose sits above the 2.5-5 g used in skin RCTs (Proksch 2014) and near the 10 g used in bone-density trials (König 2018). Grass-fed sourcing, paleo/keto certification. Sports Research has a stronger third-party testing story than Vital Proteins but a lower per-scoop dose. Standard — cleanly formulated but not a category-defining edge.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vital-proteins-collagen-peptides",
      "title": "Vital Proteins Collagen Peptides",
      "vendor": "Vital Proteins",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shopping_1.webp?v=1783995669",
      "score": 67,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vital",
        "proteins",
        "collagen",
        "peptides",
        "vital",
        "proteins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 70,
        "manufacturing": 65,
        "safety": 78,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 47.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525301850309",
      "vsf_explanation": "20 g grass-fed bovine hydrolyzed collagen peptides per serving with added hyaluronic acid and vitamin C. Peptide dose is within the RCT-effective range (Proksch 2014 used 2.5-5 g; higher doses tested in joint studies). Nestlé-owned, GMP-compliant, no NSF/USP verification. High Standard — solid category leader but nothing exceptional beyond scale.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ancient-nutrition-multi-collagen-protein",
      "title": "Ancient Nutrition Multi Collagen Protein",
      "vendor": "Ancient Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shopping.webp?v=1783995619",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ancient",
        "nutrition",
        "multi",
        "collagen",
        "protein",
        "ancient",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 52.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525301883077",
      "vsf_explanation": "Multi-source collagen (bovine, chicken, fish, eggshell membrane) covering five collagen types. Collagen peptide RCTs exist (Proksch 2014 for skin, Zdzieblik 2015 for joint) but the type-specificity claim is not clinically well-supported — hydrolyzed collagen is broken into di- and tri-peptides regardless of source. Ancient Nutrition (Dr. Axe brand) has decent GMP but no NSF/USP. Standard — the mechanism story is oversold but the ingredient category has some evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bioptimizers-magnesium-breakthrough",
      "title": "BIOptimizers Magnesium Breakthrough",
      "vendor": "BIOptimizers",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/download_11.webp?v=1783894229",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bioptimizers",
        "magnesium",
        "breakthrough",
        "bioptimizers"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 70,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525301915845",
      "vsf_explanation": "Seven-form magnesium blend including glycinate, malate, taurate and threonate. The 'seven forms' pitch is largely marketing (elemental Mg is elemental Mg), but the formula does include genuinely bioavailable forms rather than only oxide. Third-party tested per brand claim. Standard — better than mainstream oxide products but the seven-form framing is more clever than clinical.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "quicksilver-scientific-liposomal-vitamin-c",
      "title": "Quicksilver Scientific Liposomal Vitamin C",
      "vendor": "Quicksilver Scientific",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/shopping_4.webp?v=1784039482",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "quicksilver",
        "scientific",
        "liposomal",
        "vitamin",
        "quicksilver",
        "scientific"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 72,
        "manufacturing": 65,
        "safety": 78,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 40.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525302014149",
      "vsf_explanation": "1000 mg liposomal ascorbic acid in phospholipid delivery vehicle. Vitamin C is well-studied broadly; liposomal delivery has some pharmacokinetic support (Davis 2016 showed higher plasma concentrations vs oral ascorbic acid) but hard clinical endpoints are limited. Quicksilver is a legitimate practitioner brand with GMP compliance. Standard — the delivery premise is defensible but not category-transforming.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "metagenics-ultraflora-balance",
      "title": "Metagenics UltraFlora Balance",
      "vendor": "Metagenics",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/download_10.webp?v=1783894192",
      "score": 76,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "metagenics",
        "ultraflora",
        "balance",
        "metagenics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 72,
        "manufacturing": 70,
        "safety": 75,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 52.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525302046917",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 70 → new 76. Evidence found: Ouwehand AC et al. Probiotics: an overview of beneficial effects. Antonie Van Leeuwenhoek. 2002;82(1-4):279-289 (NCFM strain review). | Ringel-Kulka T et al. Probiotic bacteria Lactobacillus acidophilus NCFM and Bifidobacterium lactis Bi-07 versus placebo for the symptoms of bloating in patients with functional bowel disorders. J Clin Gastroenterol. 2011;45(6):518-525.. Rationale: UltraFlora Balance uses two strains with strong strain-specific research: Lactobacillus acidophilus NCFM and Bifidobacterium lactis Bi-07 (Ringel-Kulka 2011 for bloating). Practitioner-grade brand with strain-level transparency (unusual — most probiotics list only species). Uplift to 76.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "integrative-therapeutics-cortisol-manager",
      "title": "Integrative Therapeutics Cortisol Manager",
      "vendor": "Integrative Therapeutics",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/download_9.webp?v=1783894149",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "integrative",
        "therapeutics",
        "cortisol",
        "manager",
        "integrative",
        "therapeutics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 71.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525302079685",
      "vsf_explanation": "Ashwagandha (Sensoril standardized extract), L-theanine, magnolia and epimedium blend. Sensoril has its own cortisol-reduction RCTs (Auddy 2008), and L-theanine has stress/attention RCTs. Practitioner-channel brand under Atrium Innovations, GMP-compliant. Some ingredients (magnolia, epimedium) sit in a proprietary blend on the label. Standard — evidence for individual actives is decent but the blend hides ratios.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gaia-herbs-adrenal-health-daily-support",
      "title": "Gaia Herbs Adrenal Health Daily Support",
      "vendor": "Gaia Herbs",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/download_2.webp?v=1783893751",
      "score": 74,
      "tier": "verified",
      "certifications": [
        "Non-GMO Project Verified"
      ],
      "goal_tags": [
        "mood",
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gaia",
        "herbs",
        "adrenal",
        "health",
        "daily",
        "support",
        "gaia",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 72,
        "safety": 65,
        "transparency": 75,
        "sustainability": 65
      },
      "price": 0,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525302145221",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score undefined → new 74. Evidence found: Panossian A, Wikman G, Sarris J. Rosenroot (Rhodiola rosea): traditional use, chemical composition, pharmacology and clinical efficacy. Phytomedicine. 2010;17(7):481-93. | Chandrasekhar K, et al. A prospective, randomized double-blind, placebo-controlled study of safety and efficacy of a high-concentration full-spectrum extract of ashwagandha root in reducing stress and anxiety in adults. Indian J Psychol Med. 2012;34(3):255-62. | Cohen MM. Tulsi - Ocimum sanctum: A herb for all reasons. J Ayurveda Integr Med. 2014;5(4):251-9. | Gaia Herbs internal 60-day randomized double-blind placebo-controlled study on Adrenal Health Daily Support (unpublished; brand-reported outcomes: perceived stress reduction 86.8% of participants, restorative sleep improvement 53%).. Rationale: The formulation is honest evidence-wise. Rhodiola at 120 mg standardized to 6 mg rosavins is a real dose-form match to Panossian-era trials. Holy basil at 32 mg CO2 extract plus whole-leaf material is defensible. What holds it back from higher scoring is that ashwagandha and schisandra are folded into a proprietary 520 mg herbal blend without individual dose disclosures, so the specific-dose match to Chandrasekhar 2012 (600 mg ashwagandha) cannot be verified from the label. Meet-Your-Herbs lot-level traceability with published purity testing is a real transparency edge that is scarce in the adaptogen aisle. The brand's own 60-day HPA-axis trial exists but is unpublished, so it does not qualify as peer-reviewed anchor evidence. Net +6 uplift to 74 Verified reflects TIER-C ingredient-dose match plus category-leading traceability, without reaching Elite in the absence of a published brand-RCT.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "host-defense-lion-s-mane",
      "title": "Host Defense Lion's Mane",
      "vendor": "Host Defense",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Lion_s_Mane_Capsules_9_c1656fb8-1e0d-495a-bcf1-d5e2f2e29c24.webp?v=1783893766",
      "score": 57,
      "tier": "standard",
      "certifications": [
        "Non-GMO Project Verified"
      ],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "host",
        "defense",
        "lion",
        "mane",
        "host",
        "defense"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 60,
        "safety": 75,
        "transparency": 65,
        "sustainability": 70
      },
      "price": 0,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525302177989",
      "vsf_explanation": "1000 mg organic Lion's Mane mycelium grown on brown rice. Human evidence is limited — Mori 2009 showed cognitive benefit in older adults but at higher doses using fruiting-body extract, not brown-rice mycelium substrate. The mycelium-on-grain format is contested because a large fraction of mass is the substrate, not the mushroom. Non-GMO Project Verified, Paul Stamets brand with strong sustainability posture. Standard — mechanistically plausible but evidence-thin at this format.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "onnit-alpha-brain",
      "title": "Onnit Alpha BRAIN",
      "vendor": "Onnit",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/download.webp?v=1783893673",
      "score": 65,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "onnit",
        "alpha",
        "brain",
        "onnit"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 30,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 25,
        "sustainability": 50
      },
      "price": 79.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525302210757",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 45 → new 65. Evidence found: Solomon TM et al. A randomized, double-blind, placebo controlled, parallel group, efficacy study of alpha BRAIN administered orally. Hum Psychopharmacol Clin Exp. 2016;31(2):135-143.. Rationale: Strongly recommend autofail removal and uplift from Rejected to Verified. The autofail was applied for undisclosed doses in proprietary blends, but the Solomon 2016 RCT specifically validated the commercial Alpha BRAIN formula with those exact blends. The scoring rubric's protective intent (unknown doses = unknown safety/efficacy) is fully satisfied by RCT evidence on the product-as-sold. Uplift to 65 — slightly below the retailer-badged SKUs above to reflect that this direct-Onnit listing may not have added transparency, but the underlying evidence justifies removal from Rejected.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "ancestral-supplements-grass-fed-beef-liver",
      "title": "Ancestral Supplements Grass Fed Beef Liver",
      "vendor": "Ancestral Supplements",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/download_8.webp?v=1783894111",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ancestral",
        "supplements",
        "grass",
        "fed",
        "beef",
        "liver",
        "ancestral",
        "supplements"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 42.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525302243525",
      "vsf_explanation": "Freeze-dried beef liver capsules, 3000 mg per serving. The nutrient profile of liver is real (heme iron, retinol, B12) but no clinical RCTs support desiccated-liver capsules as a delivery vehicle, and marketing leans heavily on ancestral-diet ideology rather than evidence. GMP-compliant but no published third-party COAs, no heavy-metal or contaminant testing publicly disclosed. Rejected because the evidence base for the format is essentially traditional rather than clinical.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "megafood-blood-builder",
      "title": "MegaFood Blood Builder",
      "vendor": "MegaFood",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/download_7.webp?v=1783894066",
      "score": 85,
      "tier": "elite",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "megafood",
        "blood",
        "builder",
        "megafood"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 72,
        "manufacturing": 68,
        "safety": 65,
        "transparency": 72,
        "sustainability": 70
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525302341829",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score undefined → new 85. Evidence found: D'Adamo CR, Novick JS, Feinberg TM, Dawson VJ, Miller LE. A food-derived dietary supplement containing a low dose of iron improved markers of iron status among nonanemic iron-deficient women. J Am Coll Nutr. 2018;37(4):342-349. DOI:10.1080/07315724.2018.1427158. PMID:29533710. | Milman N, et al. Ferrous bisglycinate 25 mg iron is as effective as ferrous sulfate 50 mg iron in the prophylaxis of iron deficiency and anemia during pregnancy. J Perinat Med. 2014;42(2):197-206. | MegaFood glyphosate residue-free certification (third-party); B Corp Certification; Non-GMO Project Verified.. Rationale: Blood Builder is one of a very small number of consumer iron supplements with a peer-reviewed brand-specific RCT anchor - D'Adamo 2018 published in the Journal of the American College of Nutrition. The trial specifically tested this SKU (26 mg iron + food-derived cofactors + vitamin C + folate + B12) and demonstrated both statistically significant ferritin repletion at 8 weeks AND zero GI adverse events, which is the hard tradeoff generic ferrous sulfate cannot match. That is TIER-A brand-anchor evidence at the exact label dose. Combined with B-Corp status, glyphosate residue testing, and Non-GMO certification, the transparency stack is also above category norm. +17 uplift to 85 Elite. Held below 90 because the product does not carry an NSF or USP third-party facility certification on top of the peer-reviewed trial, and because iron supplementation still requires prior blood-work confirmation for safety (both are Elite-ceiling caveats rather than issues with the formulation itself).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "new-chapter-every-man-s-one-daily",
      "title": "New Chapter Every Man's One Daily",
      "vendor": "New Chapter",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/download_6.webp?v=1783894023",
      "score": 56,
      "tier": "standard",
      "certifications": [
        "Non-GMO Project Verified"
      ],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "new",
        "chapter",
        "every",
        "man",
        "one",
        "daily",
        "new",
        "chapter"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 60,
        "sustainability": 65
      },
      "price": 55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525302374597",
      "vsf_explanation": "Once-daily fermented whole-food multivitamin. General-population multivitamin RCTs are weak on hard endpoints (COSMOS-Mind 2023 is a rare positive outlier for cognition). 'Fermented' is more marketing than pharmacology, and a single tablet cannot deliver RCT-scale doses of most nutrients. Non-GMO Project Verified, Procter & Gamble owned with GMP compliance. Standard tier — safe and well-labelled but low-dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "renew-life-ultimate-flora-extra-care",
      "title": "Renew Life Ultimate Flora Extra Care",
      "vendor": "Renew Life",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/download_5.webp?v=1783893983",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "renew",
        "life",
        "ultimate",
        "flora",
        "extra",
        "care",
        "renew",
        "life"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 42.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525302407365",
      "vsf_explanation": "50B CFU, 12-strain probiotic with delayed-release capsule. High CFU and strain count sound impressive but do not correlate with efficacy — meta-analyses (Ritchie & Romanuk 2012) show most benefit is strain-specific, and specific indications for these strains at these doses are not stated. GMP-compliant Clorox-owned brand with basic disclosure. Standard tier — reasonable manufacturing but the 'more strains, more CFU' pitch is marketing-led.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "culturelle-digestive-daily-probiotic",
      "title": "Culturelle Digestive Daily Probiotic",
      "vendor": "Culturelle",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/download_4.webp?v=1783893866",
      "score": 73,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "culturelle",
        "digestive",
        "daily",
        "probiotic",
        "culturelle"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 82,
        "formulation": 75,
        "manufacturing": 65,
        "safety": 80,
        "transparency": 72,
        "sustainability": 50
      },
      "price": 32.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525302440133",
      "vsf_explanation": "Single-strain Lactobacillus rhamnosus GG at 10 billion CFU. LGG is arguably the most-studied probiotic strain in the literature, with RCTs for antibiotic-associated diarrhea (Doron 2005) and pediatric acute gastroenteritis (Szajewska 2013 meta-analysis). CFU at label is within RCT-effective range. GMP-compliant but relies on brand testing rather than USP/NSF. Sits in the middle of the Verified band because evidence and strain identity are unusually strong for the price.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natrol-melatonin-5-mg-fast-dissolve",
      "title": "Natrol Melatonin 5 mg Fast Dissolve",
      "vendor": "Natrol",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/download_3.webp?v=1783893817",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "natrol",
        "melatonin",
        "fast",
        "dissolve",
        "natrol"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 65,
        "sustainability": 45
      },
      "price": 13.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46525302571205",
      "vsf_explanation": "Fast-dissolve melatonin at 5 mg per tablet. Melatonin has abundant sleep-onset RCTs (Ferracioli-Oda 2013 meta-analysis) but the 5 mg dose is well above the 0.3-1 mg range shown to be physiologically optimal in Zhdanova 2001 and similar trials. Natrol is GMP-compliant but not NSF/USP verified, and no COAs are publicly posted. Lands in Standard because the ingredient works but the dose is heavier than the evidence calls for.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ignipeptide-eye-serum™",
      "title": "IgniPeptide Eye Serum™",
      "vendor": "Igniton",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Peptide.jpg?v=1784589635",
      "score": 76,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ignipeptide",
        "eye",
        "serum",
        "igniton"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 82,
        "formulation": 76,
        "manufacturing": 78,
        "safety": 80,
        "transparency": 74,
        "sustainability": 68
      },
      "price": 169.15,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46569487925445",
      "vsf_explanation": "IgniPeptide Eye Serum (product listed as 'Telomere DNA Protection' in the sponsor study) carries a formal clinical evaluation conducted at ALS Beauty and Personal Care (Phoenix AZ), Study #22-090, June 2023. Protocol complies with International Conference of Harmonization Tripartite Guideline on Good Clinical Practice + 21 CFR Parts 11 and 50 (FDA regulations). Design: N=52 healthy female subjects, ages 45-65, 8-week product-usage protocol with baseline + 15-min + week-4 + week-8 measurements. Instrumentation: Corneometer CM 825 (Courage & Khazaka) for hydration, Cutometer MPA 580 for firmness/elasticity, DermaLab Evaporimeter (Cortex Technology) for TEWL barrier function, Canfield VISIA CR clinical photography with expert grading. Results (all statistically significant p<0.05, most p<0.001): Skin hydration +52.03% at week 8 (100% of subjects improved, p<0.001); Skin firmness R0 -5.43% at week 8 (p=0.025); Skin barrier function TEWL -29.92% at 24-hour treated site vs -1.97% untreated control (p<0.001 for treated, between-site difference -34.10% p<0.001); Fine lines/wrinkles (eye area) -3.99% at week 8 by expert VISIA grading (p<0.001); Skin lifting (eye area) -2.66% (p<0.001). Self-assessment: 78-96% favorable responses across texture/smoothness/refreshed/hydration/youthful appearance parameters. Zero adverse events reported. This is well above typical supplement-tier evidence — matches or exceeds many mainstream cosmetic-brand clinical study designs. Score holds at 76 Verified (rather than higher) because (a) topical skincare category sits in a rubric-scope discussion — Vyvata's supplement rubric doesn't perfectly map to topical evaluation; (b) study sponsor is the product manufacturer (ALS is independent CRO but sponsor-funded); (c) small-brand manufacturing/sustainability disclosure could be strengthened. Product deserves the Verified designation and should trigger a broader Vyvata methodology discussion about expanding to supported skincare with a proper topical-testing rubric.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "ignicognition™",
      "title": "IgniCognition™",
      "vendor": "Igniton",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ignicogni_1.png?v=1784589636",
      "score": 74,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ignicognition",
        "igniton"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 76,
        "manufacturing": 72,
        "safety": 78,
        "transparency": 74,
        "sustainability": 68
      },
      "price": 169.15,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46569487990981",
      "vsf_explanation": "IgniCognition is backed by prior Valverde et al. research on enhanced AA compositions for cognitive function: (a) Valverde R, Gavrilova E, Churganov O, Korotkov K (2023). 'Influence of Enhanced Amino Acid Compositions on Human Cognitive Functioning.' HSOA Journal of Alternative, Complementary & Integrative Medicine 9, 377 (DOI 10.24966/ACIM-7562/100377); (b) Valverde R, Gavrilova E, Churganov O, Korotkov K, Starchenko M (2023). 'Influence of enhanced Amino Acid Compositions on Human Cognitive Functions after COVID-19.' Journal of Alternative, Complementary & Integrative Medicine 9(6), 370 (DOI 10.24966/ACIM-7562/100370). Both papers document measurable cognitive-function improvements (memory, reaction speed, attention) with the cold-plasma-enhanced AA approach that IgniCognition is built on. The 2025 IgniLongevity peer-reviewed paper (IJSPsy) references this cognitive-function work as foundational to the platform. Held below Elite by: (a) journal impact tier lower than mainstream nootropic RCTs published in higher-index outlets; (b) internal-not-independent research team; (c) small brand manufacturing profile; (d) formulation detail transparency on product page could be strengthened. Would move to Elite with independent replication in a mainstream indexed journal + published third-party assay COAs.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "ignirem-sleep™",
      "title": "IgniREM Sleep™",
      "vendor": "Igniton",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Sleep.jpg?v=1784589635",
      "score": 78,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ignirem",
        "sleep",
        "igniton"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 85,
        "formulation": 78,
        "manufacturing": 72,
        "safety": 82,
        "transparency": 76,
        "sustainability": 70
      },
      "price": 169.15,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46569487958213",
      "vsf_explanation": "IgniREM Sleep now carries an internally-run but well-designed placebo-controlled RCT (April 2026): 60 subjects (27 men, 33 women), aged 40-76, mean 56.52 ± 9.94 years. Single-blind randomized 2-arm trial (experimental N=30, placebo N=30). 21-day protocol with 7-day baseline observation followed by 14 days of intervention (2 capsules 1 hour before bed). Sleep phases tracked objectively via SmartRing (heart-rate + accelerometer + SmartHealth app determining REM/deep/light/duration/awakenings). Primary endpoint — %REM sleep relative to total sleep — showed: experimental group 21.12% → 26.28% (p<0.001, +24.6% relative improvement), placebo group 20.35% → 18.45% (p<0.01 DECREASE). Between-group comparison p<0.001. 26 of 30 experimental subjects showed individual improvement; 4 were non-responders. Complementary self-report data: sleep duration +0.8 hr/night (6.3 → 7.1), sleep interruptions cut in half (2.6 → 1.2), morning weakness dropped from 81.3% → 6.3%. Holds Verified rather than Elite because: (a) internal-not-independent trial, (b) single-blind rather than double-blind, (c) small brand with unclear published manufacturing standards, (d) SmartRing-based REM detection is validated for research but not gold-standard (polysomnography). Would move to Elite with independent replication + double-blind design + PSG cross-validation.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "ignilongevity™",
      "title": "IgniLongevity™",
      "vendor": "Igniton",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/igniclongevity.png?v=1784589636",
      "score": 80,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ignilongevity",
        "igniton"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 88,
        "formulation": 82,
        "manufacturing": 74,
        "safety": 78,
        "transparency": 80,
        "sustainability": 70
      },
      "price": 169.15,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46569487892677",
      "vsf_explanation": "IgniLongevity now carries a peer-reviewed placebo-controlled RCT: Valverde R, Gavrilova EA, Churganov OA, Korotkov KG (2025). 'Influence of an Amino Acid Composition enhanced with Cold Plasma Radiation on Psychological Stress: A Blood Test, Gas Discharge Visualisation and Biofeedback Approach.' International Journal of Studies in Psychology, 5(1): 28-34 (DOI: 10.38140/ijspsy.v5i1.1616). Study conducted at Concordia University + North-Western Medical University (St. Petersburg) + Biowell Corporation with N=70, 30-day randomized 3-arm trial (enhanced-AA / non-enhanced-AA / placebo). Enhanced-AA group showed statistically significant improvements vs placebo across multiple stress biomarkers: systolic BP -9.7 mmHg (p=0.0003), diastolic BP -7.5 mmHg (p=0.0004), Interleukin-6 -0.51 pg/mL (p=0.01), C-reactive protein -0.59 mg/L (p=0.01), GGT -3.2 U/L (p=0.04), HRV autonomic equilibrium index (p=0.002), HRV stress index (p=0.007), Bio-Well GDV stress index (p<0.001). Formulation: 8 disclosed ingredients (nicotinamide riboside, resveratrol, reduced glutathione, berberine, L-5MTHF calcium salt, PQQ/B14, cycloastragenol, bioperine) all with individual supporting literature cited in the paper. Cold-plasma enhancement is a novel processing approach with published mechanistic hypotheses (tachyon/scalar field, Chiao 1996; Park & Park 1997) — the RCT itself is the empirical anchor regardless of mechanism debate. Held below Elite (85+) by (a) single published RCT vs multi-trial replication; (b) small brand manufacturing profile without published GMP audit / third-party assay COAs on product page; (c) sustainability disclosure not detailed. Would move to Elite with independent replication + published COAs.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "timeline-mitopure-urolithin-a-supplement-softgels",
      "title": "Timeline Mitopure Urolithin A Supplement Softgels",
      "vendor": "Timeline",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71aSN3zExKL._AC_SL1500.jpg?v=1785435224",
      "score": 77,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "timeline",
        "mitopure",
        "urolithin",
        "supplement",
        "softgels",
        "timeline"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 82,
        "formulation": 80,
        "manufacturing": 78,
        "safety": 85,
        "transparency": 82,
        "sustainability": 55
      },
      "price": 110,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46636741394629",
      "vsf_explanation": "Single-active longevity supplement: Mitopure (pure Urolithin A, ~500 mg/day dose per FDA GRAS notice GRN 791). This is the exact form used in the published clinical literature. Evidence base is unusually strong for a supplement: Andreux et al. 2019 (Nature Metabolism) established safety and mitochondrial gene induction; Liu et al. 2022 (Cell Reports Medicine) 4-month double-blind RCT in middle-aged adults reported improved muscle endurance; Singh et al. 2022 (JAMA Network Open) double-blind RCT in older adults reported muscle endurance gains. Amazentis SA (Swiss parent) holds 50+ patents and has sustained R&D. Full dose disclosure, single active, no proprietary blend. Held below Elite by (1) sustainability profile is thin — Timeline describes pomegranate sourcing but public third-party sustainability certifications aren't prominent, and (2) no publicly-posted third-party COA (independent purity/heavy-metals testing) that we could verify at scoring time. Would move to Elite 85+ with published third-party COA, sustainability certification (e.g. Rainforest Alliance / regenerative sourcing audit), or additional independent RCTs in new populations.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "timeline-mitopure-urolithin-a-supplement-gummies",
      "title": "Timeline Mitopure Urolithin A Supplement Gummies",
      "vendor": "Timeline",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/61spSUjgH-L._AC_SL1500.jpg?v=1785435555",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "timeline",
        "mitopure",
        "urolithin",
        "supplement",
        "gummies",
        "timeline"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 68,
        "manufacturing": 78,
        "safety": 82,
        "transparency": 80,
        "sustainability": 55
      },
      "price": 109,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46636752863429",
      "vsf_explanation": "Gummy formulation of Timeline's Mitopure (pure Urolithin A). Same clinically-validated active as the Softgel SKU — Amazentis' Urolithin A holds FDA GRAS status (GRN 791) and has the same underlying RCT base: Andreux et al. 2019 (Nature Metabolism), Liu et al. 2022 (Cell Reports Medicine), Singh et al. 2022 (JAMA Network Open). Scored slightly lower than the softgel form on two specific dimensions: (1) formulation — the published RCT literature used softgel/capsule delivery, not gummies, so gummy delivery introduces sugar/gelatin/pectin binders that can affect absorption kinetics and add non-target ingredients; (2) evidence — the gummy delivery form itself hasn't been directly tested in a published PK or efficacy trial. Still Verified because the active ingredient and typical serving dose match the studied protocol. Path to Elite: published third-party COA, sustainability certification, and ideally a bridging PK study confirming gummy bioavailability equivalence to the softgel form.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "3rd-rock-essentials-vitamin-d3-4000-iu-k2-mk-7-liquid-drops",
      "title": "3rd Rock Essentials Vitamin D3 4000 IU + K2 MK-7 Liquid Drops",
      "vendor": "3rd Rock Essentials",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3rdrock.png?v=1785699640",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "3rd",
        "rock",
        "essentials",
        "vitamin",
        "4000",
        "liquid",
        "drops",
        "3rd",
        "rock",
        "essentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 65,
        "sustainability": 45
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46653104652485",
      "vsf_explanation": "D3 4000 IU + K2 MK-7 in a liquid-drop delivery form. This combination is well-supported by literature — vitamin D3 supplementation at 2,000-5,000 IU/day is broadly evidence-backed for most adults with suboptimal 25-OH-D levels (Holick 2011 clinical review), and K2 MK-7 co-supplementation supports proper calcium partitioning to bone rather than soft tissue (Knapen 2013 on menaquinone-7 for bone). Liquid drops offer good bioavailability and dose flexibility. Held below Verified by (1) manufacturer (3rd Rock Essentials) is a small brand with limited public quality documentation; (2) no third-party purity/potency certifications on record; (3) 4000 IU is on the higher end of daily-use dosing — appropriate for most but should be paired with periodic 25-OH-D monitoring for long-term use; (4) K2 dose disclosure vs the D3:K2 ratio literature is inconsistent across small-brand D3/K2 products. Would move to Verified 70+ with third-party COA verifying D3 IU and K2 mcg content matches label + NSF/USP certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "3rd-rock-essentials-silver-excelsior-serum-4000-ppm-chelated-silver-oxide-liquid-drops-high-potency-concentrate-dilutable-supplement-in-vegetable-glycerin-1-fl-oz",
      "title": "3rd Rock Essentials Silver Excelsior Serum 4000 PPM, Chelated Silver Oxide Liquid Drops, High Potency Concentrate, Dilutable Supplement in Vegetable Glycerin, 1 Fl oz",
      "vendor": "3rd Rock Essentials",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_1_844c4200-3690-47ec-bfb0-63093a7e5e4b.png?v=1785699972",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "3rd",
        "rock",
        "essentials",
        "silver",
        "excelsior",
        "serum",
        "4000",
        "ppm",
        "chelated",
        "silver",
        "oxide",
        "liquid",
        "drops",
        "high",
        "potency",
        "concentrate",
        "dilutable",
        "supplement",
        "vegetable",
        "glycerin",
        "3rd",
        "rock",
        "essentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 30,
        "manufacturing": 40,
        "safety": 15,
        "transparency": 25,
        "sustainability": 30
      },
      "price": 109.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46653109633221",
      "vsf_explanation": "IMPORTANT SAFETY NOTICE: Oral colloidal silver has no established therapeutic benefit and carries real safety risk. The FDA issued a Final Rule in 1999 (21 CFR 310.548) stating that colloidal silver ingredients or silver salts are NOT recognized as safe and effective for OTC oral use. Documented harm includes ARGYRIA — irreversible blue-gray skin discoloration from silver deposition in tissues (McKenna 2003 case series, multiple case reports). At 4000 PPM concentration, this product is roughly 400x the typical colloidal silver concentration and orders of magnitude above any conceivable safe use. Auto-fail: unverified_medical_claim (immune / antimicrobial claims without established efficacy or safety). Vyvata does not recommend oral colloidal silver at any concentration. This product's page carries this warning to inform any shopper who encounters it via search. Would only be re-scoreable if the FDA revised its safety determination — this has not occurred.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "airdoctor-ad5500-air-purifier",
      "title": "AIRDOCTOR AD5500 Air Purifier.",
      "vendor": "AirDoctor",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_3.png?v=1785700389",
      "score": 75,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "airdoctor",
        "ad5500",
        "air",
        "purifier",
        "airdoctor"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_environment"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 78,
        "manufacturing": 75,
        "safety": 80,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 1019,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46653119955141",
      "vsf_explanation": "Top-of-line AirDoctor model. Circulates air in 1,001 sq ft 4×/hour or 2,001 sq ft 2×/hour, dual-action carbon/gas trap plus UltraHEPA, auto-mode air-quality sensor. At room-scale coverage this size, the health-benefit signals from PM2.5 and allergen reduction are strongest (Cui 2018 on cardiovascular benefits of home HEPA use). Best-in-class of the three AirDoctor SKUs. Held below Elite by (1) UltraHEPA sub-HEPA capture claim still AirDoctor-published rather than AHAM-certified; (2) high initial + ongoing filter cost; (3) sustainability profile thin. Would move to Elite 85+ with independent AHAM or equivalent certification of the sub-HEPA capture spec + published third-party CADR verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "airdoctor-ad4000-air-purifier",
      "title": "AIRDOCTOR AD4000 Air Purifier",
      "vendor": "AirDoctor",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_5.png?v=1785700699",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "airdoctor",
        "ad4000",
        "air",
        "purifier",
        "airdoctor"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_environment"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 72,
        "manufacturing": 72,
        "safety": 78,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 699.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46653126541509",
      "vsf_explanation": "Mid-tier model in AirDoctor's UltraHEPA lineup. Larger CADR than AD1000, auto-sensor mode, appropriate for medium-to-large rooms. Same UltraHEPA + carbon/gas trap filtration architecture. Air purification's evidence base for particulate reduction and allergen removal is solid; cardiovascular benefit signals from PM2.5 reduction (Chen 2015, Zhang 2021) apply here at meaningful room sizes. Auto-sensor mode reduces energy consumption and filter wear. Held below Elite by (1) UltraHEPA 0.003-micron claim remains AirDoctor-published rather than independently AHAM-certified; (2) filter replacement cost is ongoing; (3) sustainability data limited. Would move to Elite 85+ with AHAM or ANSI/UL certification of the sub-HEPA capture claim + published third-party performance testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "airdoctor-ad1000-hepa-air-purifier",
      "title": "AIRDOCTOR AD1000 HEPA Air Purifier",
      "vendor": "AirDoctor",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_7.png?v=1785700874",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "airdoctor",
        "ad1000",
        "hepa",
        "air",
        "purifier",
        "airdoctor"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_environment"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 70,
        "safety": 78,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 399.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46653136175301",
      "vsf_explanation": "Entry-level model in AirDoctor's UltraHEPA lineup. AirDoctor's UltraHEPA marketing claim (captures particles 100× smaller than standard HEPA) is based on 0.003 micron capture vs standard HEPA's 0.3 micron rating — an aggressive but technically defensible spec. 3-stage filtration (pre-filter + carbon/gas trap + UltraHEPA). Air purification's health benefits (reduced particulate exposure, allergen reduction, potential cardiovascular benefits per Chen 2015 meta-analysis) are well-established for HEPA-grade purifiers. Held below Verified by (1) AD1000 is the smallest AirDoctor unit with lower CADR (Clean Air Delivery Rate) — appropriate for small rooms only; (2) UltraHEPA claims are AirDoctor-published, not IQAir-Institute-verified or AHAM-certified at the 0.003 micron level; (3) filter replacement cost adds ongoing expense; (4) sustainability profile thin. Would move to Verified 70+ with independent third-party lab verification of the 0.003-micron capture claim.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ovanza-vibration-plate-exercise-machine-999-speeds-whole-body-workout-platform-with-330lbs",
      "title": "Ovanza Vibration Plate Exercise Machine, 999 Speeds Whole Body Workout Platform with 330LBS",
      "vendor": "Ovanza",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_9.png?v=1785701167",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ovanza",
        "vibration",
        "plate",
        "exercise",
        "machine",
        "999",
        "speeds",
        "whole",
        "body",
        "workout",
        "platform",
        "with",
        "330lbs",
        "ovanza"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "percussion_vibration"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 74.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46653151281349",
      "vsf_explanation": "Whole-body vibration (WBV) platform at a budget price point (~$75, 330lb capacity, '999 speeds'). WBV as a modality has real research literature — meta-analyses (Rittweger 2010, Osawa 2013) show modest benefits for muscle strength, balance in older adults, and bone density, though effect sizes are smaller than active exercise and quality varies across trials. Held below Verified by (1) evidence for WBV benefits is real but modest — WBV is a supplement to exercise, not a replacement; (2) 'Ovanza' is a consumer-grade Amazon-tier brand without published specifications on actual amplitude/frequency (professional WBV plates like Power Plate publish these); (3) '999 speeds' is a marketing gimmick — actual therapeutic WBV research uses defined frequency (25-50Hz) and amplitude (2-8mm); (4) no third-party independent testing; (5) at this price point, unit-to-unit consistency and durability are unpredictable. Would move to Verified 70+ with published frequency/amplitude specs matching WBV literature + independent testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "alp-supply-co-peppermint-caffeine-pouches-5-pack-15-pouches-each-includes-50mg-caffeine-per-xl-pouch-peppermint-flavor",
      "title": "ALP Supply Co - Peppermint Caffeine Pouches - 5 Pack, 15 Pouches Each | Includes 50mg Caffeine Per XL Pouch, Peppermint Flavor",
      "vendor": "ALP Supply Co",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_11.png?v=1785701488",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alp",
        "supply",
        "peppermint",
        "caffeine",
        "pouches",
        "pack",
        "pouches",
        "each",
        "includes",
        "50mg",
        "caffeine",
        "per",
        "pouch",
        "peppermint",
        "flavor",
        "alp",
        "supply"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 65,
        "sustainability": 42
      },
      "price": 32.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46653157310661",
      "vsf_explanation": "Flavor variant of ALP Supply Co Caffeine Pouches (see the Spicy Cinnamon SKU for full scoring rationale). Same 50mg caffeine per pouch, same delivery form, same evidence gaps.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "alp-supply-co-coffee-break-caffeine-pouches-5-pack-15-pouches-each-includes-50mg-caffeine-per-xl-pouch-coffee-flavor",
      "title": "ALP Supply Co - Coffee Break Caffeine Pouches - 5 Pack, 15 Pouches Each | Includes 50mg Caffeine Per XL Pouch, Coffee Flavor",
      "vendor": "ALP Supply Co",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_13.png?v=1785701662",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alp",
        "supply",
        "coffee",
        "break",
        "caffeine",
        "pouches",
        "pack",
        "pouches",
        "each",
        "includes",
        "50mg",
        "caffeine",
        "per",
        "pouch",
        "coffee",
        "flavor",
        "alp",
        "supply"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 65,
        "sustainability": 42
      },
      "price": 32.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46653160423621",
      "vsf_explanation": "Flavor variant of ALP Supply Co Caffeine Pouches (see the Spicy Cinnamon SKU for full scoring rationale). Same 50mg caffeine per pouch, same delivery form, same evidence gaps.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "alp-supply-co-spicy-cinnamon-caffeine-pouches-5-pack-15-pouches-each-has-50mg-caffeine-per-xl-pouch-spicy-cinnamon-flavor",
      "title": "ALP Supply Co - Spicy Cinnamon Caffeine Pouches - 5 Pack, 15 Pouches Each | Has 50mg Caffeine Per XL Pouch, Spicy Cinnamon Flavor",
      "vendor": "ALP Supply Co",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_15.png?v=1785701793",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alp",
        "supply",
        "spicy",
        "cinnamon",
        "caffeine",
        "pouches",
        "pack",
        "pouches",
        "each",
        "has",
        "50mg",
        "caffeine",
        "per",
        "pouch",
        "spicy",
        "cinnamon",
        "flavor",
        "alp",
        "supply"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 65,
        "sustainability": 42
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46653164519621",
      "vsf_explanation": "Caffeine pouch (Zyn-style oral pouch, but caffeine instead of nicotine) delivering 50mg caffeine per pouch via buccal/oral mucosal absorption. Caffeine itself is one of the most-studied stimulants in existence and 50mg is a low-moderate dose (roughly half a cup of coffee); the safety profile at this dose is well-established. The novel element is the delivery form: buccal absorption of caffeine bypasses first-pass hepatic metabolism and produces faster onset than oral, but there is no published RCT on caffeine-pouch pharmacokinetics or efficacy that I'm aware of. Held below Verified by (1) no product-specific PK or efficacy trial; (2) delivery-form novelty means real-world dose-response can differ from swallowed caffeine; (3) 5-pack of 15 pouches = 75 total pouches × 50mg = 3,750mg total — moderate daily use is fine but heavy use could exceed recommended daily caffeine limits; (4) no third-party purity testing visible. Would move to Verified 70+ with a published PK study on caffeine-pouch absorption + third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "qualia-nad-supplement",
      "title": "Qualia NAD Supplement",
      "vendor": "Qualia",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_17.png?v=1785702159",
      "score": 73,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "qualia",
        "nad",
        "supplement",
        "qualia"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 78,
        "manufacturing": 72,
        "safety": 78,
        "transparency": 75,
        "sustainability": 50
      },
      "price": 74.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46653169762501",
      "vsf_explanation": "Neurohacker Collective (parent of Qualia) has an unusually strong R&D discipline for the supplement space — they routinely commission and publish their own randomized placebo-controlled trials on Qualia formulations. Qualia NAD+ combines three NAD+ precursors (NR + niacinamide + additional pathway support) at published-trial doses. Two randomized double-blind placebo-controlled trials on Qualia NAD have been publicly referenced by Neurohacker; the underlying NR / NAD+ precursor literature (Martens 2018, Airhart 2017, Trammell 2016) is strong. Held below Elite by (1) the two DB-RCTs referenced are Neurohacker-funded rather than fully independent; (2) three-precursor blend adds formulation complexity vs single-active NR products (Tru Niagen) that have larger independent literature; (3) no publicly-posted third-party COA for NR content; (4) sustainability profile thin. Would move to Elite 85+ with independently-replicated efficacy trial + public COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "avro-energy-orange-tangerine-drink-mix-with-200mg-pharmagaba-10-count",
      "title": "AVRO Energy Orange Tangerine Drink Mix with 200mg PharmaGABA, 10 Count",
      "vendor": "AVRO",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_19.png?v=1785702505",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "avro",
        "energy",
        "orange",
        "tangerine",
        "drink",
        "mix",
        "with",
        "200mg",
        "pharmagaba",
        "count",
        "avro"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 62,
        "sustainability": 42
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46653229990085",
      "vsf_explanation": "Flavor variant of AVRO Energy Drink Mix (see the Fuji Apple SKU for full scoring rationale). Same caffeine + 200mg PharmaGABA formula, same evidence profile. Flavor change does not affect active-ingredient scoring.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "avro-energy-orange-tangerine-drink-mix-with-200mg-pharmagaba-10-count-copy",
      "title": "AVRO Energy Fuji Apple Drink Mix with 200mg PharmaGABA, 10 Count",
      "vendor": "AVRO",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_21.png?v=1785702686",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "avro",
        "energy",
        "fuji",
        "apple",
        "drink",
        "mix",
        "with",
        "200mg",
        "pharmagaba",
        "count",
        "avro"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 62,
        "sustainability": 42
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46653232054469",
      "vsf_explanation": "AVRO Energy pairs caffeine with 200mg PharmaGABA (natural GABA produced via Lactobacillus hilgardii fermentation, made by Pharma Foods Intl / Kikkoman — a real ingredient with published research on stress reduction and alpha-wave EEG effects: Abdou 2006, Yoto 2012). The 'calm energy / no jitters' positioning is plausible given GABAergic + adenosine antagonism combined, but there is no product-specific RCT on the AVRO Energy formulation's caffeine-jitter-reduction claim vs plain caffeine. Held below Verified by (1) product-specific efficacy trial absent; (2) 'calm energy' is marketed effect, not measured effect for this SKU; (3) exogenous GABA's blood-brain-barrier penetration is debated (some crossing occurs at higher doses per Boonstra 2015, but effect size at 200mg is modest); (4) drink-mix format adds sweeteners/flavors. Would move to Verified 70+ with a formulation-specific placebo-controlled crossover trial demonstrating meaningfully lower jitter or higher subjective calm vs caffeine-alone at matched dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bodybio-pc-phosphatidylcholine",
      "title": "BodyBio PC - Phosphatidylcholine",
      "vendor": "BodyBio",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_23.png?v=1785704059",
      "score": 76,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bodybio",
        "phosphatidylcholine",
        "bodybio"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 82,
        "manufacturing": 75,
        "safety": 80,
        "transparency": 78,
        "sustainability": 50
      },
      "price": 64.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46653280485573",
      "vsf_explanation": "BodyBio PC is the reference-quality phosphatidylcholine (PC) supplement in the practitioner space — Patricia Kane's clinical work on membrane lipid replacement therapy (MLR) built this product's reputation. Delivers ~900mg PC per serving in a high-quality lecithin-derived form. Real evidence: phosphatidylcholine is well-studied for hepatoprotection (Lieber's alcoholic-liver studies), membrane repair, and choline-supply for acetylcholine synthesis affecting cognition and memory. Practitioner ecosystem uses it for chronic fatigue, neuroinflammation, and post-toxic-exposure protocols with real published case series. Held below Elite by (1) most product-specific research is observational / case-series rather than double-blind RCTs; (2) sustainability profile thin; (3) no publicly-posted third-party COA. Would move to Elite 85+ with a placebo-controlled RCT on the BodyBio PC formulation specifically for a defined clinical endpoint (cognition, liver function, or neuroinflammation).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bodybio-balance-oil-essential-fatty-acids",
      "title": "BodyBio Balance Oil - Essential Fatty Acids",
      "vendor": "BodyBio",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_25.png?v=1785704230",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bodybio",
        "balance",
        "oil",
        "essential",
        "fatty",
        "acids",
        "bodybio"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 60,
        "manufacturing": 70,
        "safety": 72,
        "transparency": 68,
        "sustainability": 45
      },
      "price": 44.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46653282844869",
      "vsf_explanation": "Balance Oil is a 4:1 omega-6:omega-3 EFA blend based on the Peskin-Kane 'parent essential oils' approach (organic sunflower + flax oils). Contains real linoleic acid + alpha-linolenic acid, both essential fatty acids. Held below Verified by a substantive evidence dispute: the mainstream cardiovascular / anti-inflammatory nutrition literature generally favors LOWER omega-6:3 ratios (2:1 or 1:1) and preformed EPA/DHA from marine sources, whereas the Balance Oil approach argues that parent EFAs (not EPA/DHA directly) are what the body needs. This is a live scientific debate, not settled science — mainstream cardiovascular RCTs (VITAL, REDUCE-IT) used EPA/DHA supplementation, not parent EFAs. BodyBio has practitioner credibility and clean sourcing, but the product's core positioning runs counter to the dominant RCT evidence for cardiovascular endpoints. Would move to Verified 70+ with a Balance-Oil-specific RCT on cardiovascular endpoints outperforming placebo or EPA/DHA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bodybio-resolvin-spms-for-healthy-inflammation-skin-repair-joint-comfort",
      "title": "BodyBio Resolvin SPMs for Healthy Inflammation, Skin Repair & Joint Comfort",
      "vendor": "BodyBio",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_27.png?v=1785704450",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bodybio",
        "resolvin",
        "spms",
        "for",
        "healthy",
        "inflammation",
        "skin",
        "repair",
        "joint",
        "comfort",
        "bodybio"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 68,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 65,
        "sustainability": 45
      },
      "price": 69.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46653285073093",
      "vsf_explanation": "Specialized Pro-Resolving Mediators (SPMs) are omega-3 derived lipid mediators that actively signal the resolution phase of inflammation. The underlying biology is well-established through Charles Serhan's lab at Harvard (Serhan 2014, 2017 in Nature and elsewhere) and multiple mechanism papers exist. Product-side, SPM supplements are an emerging category — Metagenics' SPM Active is the reference product with the most trial literature. Held below Verified by (1) product-specific double-blind RCTs on BodyBio's SPM formulation are limited; (2) SPM concentration per serving vs the studied doses in trial literature is not always clear from labels; (3) SPMs are expensive to manufacture (extracted from fish oil) and third-party COA for actual SPM content per bottle is critical but not publicly visible; (4) claim reach ('skin repair, joint comfort') is broader than the trial-supported endpoints. Would move to Verified 70+ with a formulation-specific RCT and public COA quantifying SPM content.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "biotiquest-sugar-shift-probiotic",
      "title": "BiotiQuest Sugar Shift Probiotic",
      "vendor": "BiotiQuest",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_29.png?v=1785704959",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "biotiquest",
        "sugar",
        "shift",
        "probiotic",
        "biotiquest"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 75,
        "transparency": 65,
        "sustainability": 45
      },
      "price": 59.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46653290414277",
      "vsf_explanation": "Sugar Shift is BiotiQuest's flagship formulation and has more publicly-referenced research than the rest of the BiotiQuest lineup — targeting glucose regulation and sugar-craving reduction via specific probiotic strains that ferment glucose to mannitol. Krishnan and collaborators have published on the underlying mechanism. Held below Verified by (1) the specific product-formulation RCT evidence is still early; (2) 'sugar craving' as an endpoint is subjective and hard to blind; (3) 12B CFU per serving is moderate, and the primary mechanism claim (glucose→mannitol conversion) reduces glucose only in a small % of daily intake; (4) no third-party strain-verification certification. Would move to Verified 70+ with a peer-reviewed placebo-controlled trial on Sugar Shift specifically showing meaningful glucose or HbA1c effect.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "biotiquest-heart-centered-probiotics",
      "title": "BiotiQuest Heart Centered Probiotics",
      "vendor": "BiotiQuest",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_31.png?v=1785705102",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "biotiquest",
        "heart",
        "centered",
        "probiotics",
        "biotiquest"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 75,
        "transparency": 62,
        "sustainability": 45
      },
      "price": 59.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46653292413125",
      "vsf_explanation": "Probiotic marketed for cardiovascular support via gut microbiome pathways. Some probiotic strains have published effects on lipid panels (e.g., L. reuteri NCIMB 30242, Jones et al. 2012 on LDL reduction) but this specific 'Heart Centered' blend does not appear to have product-specific RCTs on cardiovascular endpoints. Krishnan formulation with characterized strains. Held below Verified by (1) the causal chain from probiotic → cardiovascular endpoint is real but effect sizes are modest and product-specific evidence for this blend is not visible; (2) cardiovascular support is a large claim that would ordinarily require blood-panel or blood-pressure RCT data; (3) no third-party certification visible. Would move to Verified 70+ with a product-specific RCT on lipid or blood-pressure endpoints.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "biotiquest-simple-slumber-probiotics",
      "title": "BiotiQuest Simple Slumber Probiotics",
      "vendor": "BiotiQuest",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_33.png?v=1785705252",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "biotiquest",
        "simple",
        "slumber",
        "probiotics",
        "biotiquest"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 75,
        "transparency": 62,
        "sustainability": 45
      },
      "price": 59.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46653294444741",
      "vsf_explanation": "Probiotic marketed for sleep support via the gut-brain axis. The gut-brain axis and probiotic effects on sleep are an emerging research area (Smith et al. 2019, Nishida et al. 2019 on L. gasseri CP2305) but the evidence base is much thinner than for melatonin/magnesium/valerian. Kiran Krishnan formulation, characterized strains, gluten-free. Held below Verified by (1) sleep-specific probiotic evidence is early-stage compared to established sleep aids; (2) no product-specific RCT on this blend's effect on sleep endpoints; (3) 'sleep-focused probiotic' positioning is a stretch vs the direct-acting sleep supplements that dominate the subcategory; (4) no third-party certification visible. Would move to Verified 70+ with a product-specific sleep-endpoint RCT (polysomnography or validated sleep-questionnaire outcomes).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "biotiquest-ideal-immunity-probiotics",
      "title": "BiotiQuest Ideal Immunity Probiotics",
      "vendor": "BiotiQuest",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_35_be3733a1-1d27-44ab-a675-a75382e4e3dc.png?v=1785705394",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "biotiquest",
        "ideal",
        "immunity",
        "probiotics",
        "biotiquest"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 75,
        "transparency": 65,
        "sustainability": 45
      },
      "price": 59.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46653297524933",
      "vsf_explanation": "Multi-strain probiotic (12B CFU per serving) formulated by Kiran Krishnan (research microbiologist behind Just Thrive / MegaSporeBiotic). BiotiQuest formulations use specific characterized strains (a rigor-plus vs generic 'multi-strain' products), disclose strain-level identity, and are non-GMO / gluten-free. Held below Verified by (1) product-specific double-blind trials on this exact 'Ideal Immunity' blend are limited — much of Krishnan's published work is on his other formulations; (2) 'immunity' positioning is generic marketing (all probiotic categories claim it); (3) 12B CFU is on the low-to-moderate end for immune-support claims where 20-50B is more typical in RCT literature; (4) no third-party purity/potency certification visible. Would move to Verified 70+ with product-specific RCT + third-party strain-verification certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bodybio-liposomal-glutathione",
      "title": "BodyBio Liposomal Glutathione",
      "vendor": "BodyBio",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_37.png?v=1785705694",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bodybio",
        "liposomal",
        "glutathione",
        "bodybio"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 80,
        "manufacturing": 70,
        "safety": 80,
        "transparency": 72,
        "sustainability": 50
      },
      "price": 74,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46653301686469",
      "vsf_explanation": "Liposomal delivery of reduced glutathione (GSH), the body's primary intracellular antioxidant. Plain oral GSH has notoriously poor bioavailability (largely broken down before systemic absorption); liposomal encapsulation substantially improves it — Sinha et al. 2018 RCT showed liposomal GSH raised systemic GSH levels significantly better than non-liposomal in healthy adults, and Richie et al. 2015 established the underlying bioavailability case. BodyBio is a practitioner-facing brand (founded on Patricia Kane's clinical work) with a real reputation for clean sourcing. Held below Elite by (1) no publicly-visible third-party COA verifying phospholipid composition and GSH content per bottle; (2) sustainability profile thin; (3) product-specific efficacy trials on BodyBio's exact formulation are limited (literature is on liposomal GSH generally, not this SKU). Would move to Elite 85+ with published COA, a formulation-specific PK/efficacy trial, and third-party manufacturing certification (NSF/USP).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bodyhealth-perfectamino-powder-bcaa-and-eaa-powder-for-pre-and-post-workout-lemon-lime",
      "title": "BodyHealth PerfectAmino Powder - BCAA and EAA Powder for Pre and Post Workout - Lemon Lime",
      "vendor": "BodyHealth",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_39.png?v=1785706149",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bodyhealth",
        "perfectamino",
        "powder",
        "bcaa",
        "and",
        "eaa",
        "powder",
        "for",
        "pre",
        "and",
        "post",
        "workout",
        "lemon",
        "lime",
        "bodyhealth"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 78,
        "manufacturing": 65,
        "safety": 78,
        "transparency": 72,
        "sustainability": 45
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46653319348421",
      "vsf_explanation": "Flavor variant of BodyHealth PerfectAmino Powder (see the Strawberry SKU for the full scoring rationale). Same 8-EAA formula, same per-EAA disclosure, same evidence and manufacturing profile.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bodyhealth-perfectamino-powder-bcaa-and-eaa-powder-for-pre-and-post-workout-mixed-berry",
      "title": "BodyHealth PerfectAmino Powder - BCAA and EAA Powder for Pre and Post Workout - Mixed Berry",
      "vendor": "BodyHealth",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_41.png?v=1785706360",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bodyhealth",
        "perfectamino",
        "powder",
        "bcaa",
        "and",
        "eaa",
        "powder",
        "for",
        "pre",
        "and",
        "post",
        "workout",
        "mixed",
        "berry",
        "bodyhealth"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 78,
        "manufacturing": 65,
        "safety": 78,
        "transparency": 72,
        "sustainability": 45
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46653322395845",
      "vsf_explanation": "Flavor variant of BodyHealth PerfectAmino Powder (see the Strawberry SKU for the full scoring rationale). Same 8-EAA formula, same per-EAA disclosure, same evidence and manufacturing profile. Flavor change is a natural flavoring + stevia-family sweetener addition and does not affect the active-ingredient scoring.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bodyhealth-perfectamino-powder-bcaa-and-eaa-powder-for-pre-and-post-workout-strawberry",
      "title": "BodyHealth PerfectAmino Powder - BCAA and EAA Powder for Pre and Post Workout - Strawberry",
      "vendor": "BodyHealth",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_43.png?v=1785706598",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bodyhealth",
        "perfectamino",
        "powder",
        "bcaa",
        "and",
        "eaa",
        "powder",
        "for",
        "pre",
        "and",
        "post",
        "workout",
        "strawberry",
        "bodyhealth"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 78,
        "manufacturing": 65,
        "safety": 78,
        "transparency": 72,
        "sustainability": 45
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46653327343813",
      "vsf_explanation": "PerfectAmino (BodyHealth, formulated by David Minkoff MD) is an 8-EAA blend at a ratio designed for high nitrogen utilization. Full per-EAA gram disclosure on label (~7.5g total EAAs per serving), which clears the transparency floor most protein powders don't meet. Independent EAA literature (Volek 2017, Jäger 2017 ISSN position stand) supports EAA supplementation for muscle protein synthesis at 6-10g per dose. Held below Verified by (1) evidence for the specific PerfectAmino ratio and '99% utilization' claim rests largely on manufacturer-adjacent sources rather than double-blind independent RCTs; (2) no third-party testing/certifications (NSF, Informed Sport, USP) on the current label to verify purity/label match; (3) sweetened flavored powders add non-EAA ingredients that dilute the pure-EAA positioning. Would move to Verified 70+ with third-party purity certification and an independent RCT on the PerfectAmino ratio specifically.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-b1-thiamine-liquid-metabolic-booster-benfotiamine-250mg-60-servings",
      "title": "Vitamin B1 Thiamine Liquid Metabolic Booster (Benfotiamine 250mg, 60 servings)",
      "vendor": "LIV",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b1hero.jpg?v=1785945434",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "thiamine",
        "liquid",
        "metabolic",
        "booster",
        "benfotiamine",
        "250mg",
        "servings",
        "liv"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 72,
        "manufacturing": 50,
        "safety": 72,
        "transparency": 58,
        "sustainability": 45
      },
      "price": 26,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663346880709",
      "vsf_explanation": "Benfotiamine 250mg liquid. Benfotiamine is a lipid-soluble thiamine (B1) analog with ~5x oral bioavailability vs thiamine HCl — real formulation choice, particularly relevant for diabetic neuropathy research (Stracke 2008 on benfotiamine in DN). 250mg is in the studied range. Held below Verified by (1) no brand identification; (2) no third-party COA; (3) benfotiamine-specific evidence base is smaller than plain thiamine's — most benefits documented for diabetic neuropathy specifically. Would move to Verified 70+ with named manufacturer + third-party testing + clearer indication-specific labeling.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-b12-tri-blend-liquid-energy-booster-5000mcg-60-servings",
      "title": "Vitamin B12 Tri-Blend Liquid Energy Booster (5000mcg, 60 servings)",
      "vendor": "LIV",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b12hero.jpg?v=1785945439",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "b12",
        "tri",
        "blend",
        "liquid",
        "energy",
        "booster",
        "5000mcg",
        "servings",
        "liv"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 72,
        "manufacturing": 50,
        "safety": 72,
        "transparency": 58,
        "sustainability": 45
      },
      "price": 26,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663347404997",
      "vsf_explanation": "B12 tri-blend liquid at 5000mcg — 'tri-blend' typically means methylcobalamin + adenosylcobalamin + hydroxocobalamin (the three bioactive B12 forms). Tri-form B12 is a legitimate formulation-quality choice covering the different cellular B12 metabolic pathways. Liquid + sublingual bioavailability is a plus. Held below Verified by (1) no brand identification; (2) 5000mcg is very high dose (oral absorption plateaus around 1-2mg + 1% passive); (3) no third-party COA. Would move to Verified 70+ with named manufacturer + third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-b3-niacin-liquid-niacinamide-80mg-60-servings",
      "title": "Vitamin B3 Niacin Liquid (Niacinamide 80mg, 60 servings)",
      "vendor": "LIV",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b3hero.jpg?v=1785945450",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "niacin",
        "liquid",
        "niacinamide",
        "80mg",
        "servings",
        "liv"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 50,
        "safety": 72,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 26,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663348355269",
      "vsf_explanation": "Niacinamide (non-flushing B3 form) 80mg liquid. Niacinamide is well-tolerated and appropriate for daily supplementation. 80mg is well below the UL and above the RDA (14-16mg). Held below Verified by (1) no brand identification; (2) niacinamide has weaker lipid-lowering effect vs niacin (nicotinic acid) — form choice matters for indication; (3) no third-party COA. Would move to Verified 70+ with named manufacturer + third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-b9-folic-acid-liquid-5-mthf-5-000mcg-60-servings",
      "title": "Vitamin B9 Folic Acid Liquid (5-MTHF 5,000mcg, 60 servings)",
      "vendor": "LIV",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b9hero.jpg?v=1785945459",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "folic",
        "acid",
        "liquid",
        "mthf",
        "000mcg",
        "servings",
        "liv"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 72,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 26,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663349108933",
      "vsf_explanation": "Liquid 5-MTHF (methylfolate) 5000mcg. 5-MTHF is the bioactive folate form preferred over folic acid — appropriate for MTHFR polymorphism carriers (~40% of the US population) and avoids unmetabolized folic acid accumulation. Liquid delivery + bioactive form is a formulation plus. Held below Verified by (1) 5000mcg is 12.5x the standard folate RDA (400mcg) — very high dose that warrants B12 co-supplementation (high folate can mask B12 deficiency) and blood-level monitoring; (2) no brand identification in product name; (3) no third-party COA. Would move to Verified 70+ with named manufacturer + third-party testing + B12 co-formulation OR label guidance on B12 co-supplementation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nature-made-b-complex-with-c-super-tablets",
      "title": "Nature Made B Complex, With C, Super, Tablets",
      "vendor": "Nature Made",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/302629517.jpg?v=1785945483",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "made",
        "complex",
        "with",
        "super",
        "tablets",
        "nature",
        "made"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 65,
        "manufacturing": 78,
        "safety": 72,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 13.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663351271621",
      "vsf_explanation": "Nature Made Super B-Complex + Vitamin C. Nature Made carries USP Verification on many SKUs — a real manufacturing/purity plus. B-complex evidence for methylation and cardiovascular support (homocysteine reduction) is real. Held below Verified by (1) folate form (folic acid vs 5-MTHF) matters for MTHFR carriers — need to check label; (2) B12 typically cyanocobalamin vs methylcobalamin; (3) USP Verified status per SKU needs confirmation on this specific product. Would move to Verified 70+ with confirmed USP + bioactive folate/B12.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-formula-vm-2000-180-tablets-multinutrient-system",
      "title": "Solgar Formula VM-2000 180 Tablets (Multinutrient System)",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33984011892.png?v=1785945499",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "formula",
        "2000",
        "180",
        "tablets",
        "multinutrient",
        "system",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 72,
        "manufacturing": 78,
        "safety": 72,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 56.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663352287429",
      "vsf_explanation": "Solgar VM-2000 — flagship comprehensive multivitamin with broader spectrum and higher doses than typical mass-market multis. Includes botanicals + amino acids alongside vitamins/minerals. Solgar's manufacturing quality is a plus. Held below Elite by (1) uses folic acid (some Solgar SKUs; check label) vs 5-MTHF; (2) B12 form check needed at label; (3) 'kitchen sink' 100+ ingredient formulations spread individual doses thin — good baseline coverage but not optimal for any specific nutrient at RCT-effective levels; (4) no third-party COA on this SKU. Would move to Elite 85+ with bioactive folate/B12 + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cheers-protect-daily-liver-supplement-for-drinkers-with-l-cysteine-dhm-increase-glutathione-levels-30-doses-cysteine-dihydromyricetin-milk-thistle-prickly-pear-b-vitamins-ginger",
      "title": "Cheers Protect | Daily Liver Supplement for Drinkers with L-Cysteine + DHM | Increase Glutathione Levels | 30 Doses | Cysteine Dihydromyricetin Milk Thistle Prickly Pear B-Vitamins Ginger",
      "vendor": "Anti Spier",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/61VQNKlS8tVzweub.webp?v=1785945521",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cheers",
        "protect",
        "daily",
        "liver",
        "supplement",
        "for",
        "drinkers",
        "with",
        "cysteine",
        "dhm",
        "increase",
        "glutathione",
        "levels",
        "doses",
        "cysteine",
        "dihydromyricetin",
        "milk",
        "thistle",
        "prickly",
        "pear",
        "vitamins",
        "ginger",
        "anti",
        "spier"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 65.81,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663353270469",
      "vsf_explanation": "Cheers Protect combines dihydromyricetin (DHM, from Hovenia dulcis / ampelopsin), L-cysteine, milk thistle, prickly pear, B vitamins, ginger — a hangover/liver-support formulation. DHM has real research (Shen 2012 on alcohol intoxication reduction in mice, some human pilot data). L-cysteine → glutathione is well-established for oxidative stress and alcohol metabolism. Milk thistle (silymarin) has liver-support evidence. Held below Verified by (1) product-specific efficacy RCT on Cheers Protect for hangover/liver-protection endpoints in humans is limited; (2) per-ingredient dose disclosure at label vs the RCT-effective doses for DHM (300-600mg) and NAC/cysteine (600-1200mg); (3) 'protects your liver from drinking' positioning could imply that supplementation offsets alcohol harm — it does not eliminate alcohol's health impact. Would move to Verified 70+ with product-specific RCT + per-ingredient dose disclosure + clearer positioning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-super-b-complex-with-folic-acid-plus-vitamin-c-tablets",
      "title": "Nature's Bounty Super B Complex With Folic Acid Plus Vitamin C Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/46112761_de1c0bd1-4c38-4a45-870a-f5d42bb39ff3.jpg?v=1785945532",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive",
        "mood",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "super",
        "complex",
        "with",
        "folic",
        "acid",
        "plus",
        "vitamin",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 60,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 62,
        "sustainability": 45
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663353827525",
      "vsf_explanation": "Nature's Bounty Super B-Complex with folic acid + vitamin C. Nature's Bounty (Nestlé Health Science) is a mid-tier mass-market brand with real manufacturing scale. B-complex + vitamin C evidence base is well-established. Held below Verified by (1) uses folic acid vs bioactive 5-MTHF — matters for MTHFR polymorphism carriers; (2) B12 form typically cyanocobalamin vs methylcobalamin; (3) not USP-verified; (4) tablet coating ingredients not always disclosed. Would move to Verified 70+ with bioactive B12/folate + USP certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mad-hippie-antioxidant-facial-oil-face-oil-for-women-men-with-organic-argan-oil-non-comedogenic-moisturizer-for-face-with-natural-sources-of-vitamin-c-vitamin-e-oil-for-skin-care-1-02-oz",
      "title": "Mad Hippie Antioxidant Facial Oil - Face Oil For Women/Men With Organic Argan Oil, Non-Comedogenic Moisturizer For Face With Natural Sources Of Vitamin C & Vitamin E Oil For Skin Care, 1.02 Oz -",
      "vendor": "ByBies",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d3433d80img_35SMYVzbu8.jpg?v=1785945550",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "skin"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "mad",
        "hippie",
        "antioxidant",
        "facial",
        "oil",
        "face",
        "oil",
        "for",
        "women",
        "men",
        "with",
        "organic",
        "argan",
        "oil",
        "non",
        "comedogenic",
        "moisturizer",
        "for",
        "face",
        "with",
        "natural",
        "sources",
        "vitamin",
        "vitamin",
        "oil",
        "for",
        "skin",
        "care",
        "bybies"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 75,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 68,
        "sustainability": 65
      },
      "price": 26.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663354646725",
      "vsf_explanation": "Mad Hippie Antioxidant Facial Oil — organic argan oil base with natural vitamin C and vitamin E sources. Mad Hippie is a legitimate clean-beauty brand with EWG-transparency-conscious formulations. Argan oil topical use has real evidence for skin barrier and elasticity (Boucetta 2015 on postmenopausal skin). Natural-source vitamin C is stable and skin-active. Held below Verified by (1) topical vitamin C is more effective in aqueous serum vehicles (L-ascorbic acid at 10-20% pH<3.5) — oil-vehicle vitamin C is less well-absorbed; (2) 'natural sources' vitamin C concentration vs targeted L-ascorbic acid concentration not disclosed; (3) topical antioxidant evidence base is thinner than internal supplement evidence base. Would move to Verified 70+ with quantified vitamin C concentration + a companion aqueous L-ascorbic acid product.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "21st-century-one-daily-mens-50-multivitamin-multimineral-100-tablets",
      "title": "21st Century One Daily, Men's 50+, Multivitamin Multimineral, 100 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/90502280.jpg?v=1785945560",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "21st",
        "century",
        "one",
        "daily",
        "men",
        "multivitamin",
        "multimineral",
        "100",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 70,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 8.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663355269317",
      "vsf_explanation": "Budget mass-market men's 50+ multivitamin. Multivitamin evidence base for men over 50 is real (Physicians' Health Study II). Held below Verified by (1) budget brand uses lowest-cost vitamin forms (folic acid, cyanocobalamin, magnesium oxide, DL-alpha-tocopherol); (2) no bioactive-form use; (3) not USP-verified; (4) formulation choices favor shelf-life over bioavailability. Would move to Verified 70+ with bioactive-form reformulation + USP certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "b-complex-complete-daily-b-vitamin-supplement-16-fl-oz",
      "title": "B Complex–Complete Daily B Vitamin Supplement, 16 fl oz",
      "vendor": "Buried Treasure Liquid Nutrients",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BCC241.jpg?v=1785945574",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "complex",
        "complete",
        "daily",
        "vitamin",
        "supplement",
        "buried",
        "treasure",
        "liquid",
        "nutrients"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 55,
        "manufacturing": 48,
        "safety": 65,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 33.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663355891909",
      "vsf_explanation": "Generic liquid B-complex supplement — no brand identification. B-complex has real evidence for methylation and homocysteine. Liquid format offers better bioavailability. Held below Verified by (1) complete lack of brand transparency (no manufacturer name in product name); (2) per-B-vitamin mg/mcg amounts not visible; (3) B12 form (bioactive vs synthetic) unknown; (4) no third-party testing information. Would move to Verified 70+ with named manufacturer + per-vitamin dose + bioactive forms + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "21st-century-vitamin-b-12-prolonged-release-1000-mcg-tablets",
      "title": "21ST Century Vitamin B-12, Prolonged Release, 1000 mcg, Tablets",
      "vendor": "Duo Grocery",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/large_c1e7ce13-c0e4-4c34-932e-fd7a7db0e382.png?v=1785945623",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "21st",
        "century",
        "vitamin",
        "prolonged",
        "release",
        "1000",
        "mcg",
        "tablets",
        "duo",
        "grocery"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 58,
        "sustainability": 45
      },
      "price": 18.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663358120133",
      "vsf_explanation": "21st Century B12 1000mcg prolonged-release tablets — budget mass-market brand. 1000mcg per tablet is a reasonable oral dose. Prolonged-release formulation attempts to smooth absorption. Held below Verified by (1) 21st Century is a budget brand with limited third-party testing; (2) B12 form (typically cyanocobalamin at this price point) vs methylcobalamin; (3) prolonged-release matrix ingredients not disclosed. Would move to Verified 70+ with methylcobalamin form + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nb-pure-methyl-b-12-spray-1-fl-oz",
      "title": "NB Pure Methyl B-12 Spray, 1 Fl Oz",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/161456314.jpg?v=1785945629",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "methyl",
        "spray",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 70,
        "manufacturing": 58,
        "safety": 72,
        "transparency": 62,
        "sustainability": 45
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663358480581",
      "vsf_explanation": "Methylcobalamin (bioactive B12) sublingual spray from NB Pure. Methylcobalamin is the preferred B12 form (vs cyanocobalamin) for people with methylation polymorphisms. Sublingual spray delivery bypasses gastric intrinsic-factor absorption bottleneck — a real formulation positive vs oral B12 for older adults + those with pernicious anemia. Held below Verified by (1) NB Pure is a small brand without prominent third-party testing; (2) actual delivered mcg per spray not always clearly disclosed; (3) sublingual absorption efficiency claims should be backed by PK data specific to the product. Would move to Verified 70+ with published PK data + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natural-systems-magnesium-citrate-500-mg-capsules-60-ct",
      "title": "Natural Systems Magnesium Citrate 500 mg Capsules (60 ct)",
      "vendor": "Farmacias Savia",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NAT_SYST_MAGNESIUM_CITRA_500MG_646824258069_3419c678-84fb-44e6-8dc7-f3b72ff2382d.png?v=1785945645",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "natural",
        "systems",
        "magnesium",
        "citrate",
        "500",
        "capsules",
        "farmacias",
        "savia"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 68,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 62,
        "sustainability": 45
      },
      "price": 11.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663358841029",
      "vsf_explanation": "Magnesium citrate 500mg from Natural Systems. Magnesium citrate has good bioavailability (Walker 2003 comparing common forms) — 500mg citrate ≈ 80mg elemental magnesium. Citrate form is also mildly osmotic, so higher doses can cause loose stools. Held below Verified by (1) small brand without established quality track record; (2) elemental magnesium content not always clearly disclosed; (3) no third-party COA. Would move to Verified 70+ with elemental mg disclosure + third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "red-rocker-essentials-energy-support",
      "title": "Red Rocker Essentials Energy Support",
      "vendor": "Nature's Lab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Energy_Support_1_hero_dce49524-a84c-4424-aec8-bd5ca5692732.jpg?v=1785945690",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "rocker",
        "essentials",
        "energy",
        "support",
        "nature",
        "lab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 52,
        "manufacturing": 48,
        "safety": 68,
        "transparency": 48,
        "sustainability": 45
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663359299781",
      "vsf_explanation": "Energy support supplement from Red Rocker Essentials — small brand. Energy-support supplements typically combine caffeine, B-vitamins, adaptogens (rhodiola, ginseng). Held below Verified by (1) small brand with limited quality visibility; (2) specific active ingredients and per-ingredient doses not visible in product name; (3) 'energy support' claims require clear active ingredient disclosure to evaluate. Would move to Verified 70+ with full ingredient + dose disclosure + third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nature-made-extra-strength-vitamin-b12-3000-mcg-energy-metabolism-support-softgels-60ct",
      "title": "Nature Made Extra Strength Vitamin B12 3000 Mcg Energy Metabolism Support Softgels - 60ct",
      "vendor": "Nature Made",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/188959095.jpg?v=1785945703",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "made",
        "extra",
        "strength",
        "vitamin",
        "b12",
        "3000",
        "mcg",
        "energy",
        "metabolism",
        "support",
        "softgels",
        "60ct",
        "nature",
        "made"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 68,
        "manufacturing": 78,
        "safety": 75,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 16.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663359692997",
      "vsf_explanation": "Nature Made B12 3000mcg softgels. Nature Made carries USP Verified on many of its SKUs — one of the few mass-market brands that submits to independent testing. B12 has real evidence for deficiency correction and cognitive/energy support in older adults (Smith 2010 on cognitive decline). Held below Elite by (1) B12 form (cyanocobalamin vs methylcobalamin) matters — methylcobalamin is preferred but Nature Made typically uses cyanocobalamin for cost/stability; (2) 3000mcg is high — oral B12 absorption plateaus around 1-2mg with intrinsic factor + 1% passive at higher doses; (3) sustainability profile thin. Would move to Elite 85+ with methylcobalamin reformulation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-vitamin-b6-25-mg-100-tablets",
      "title": "Solgar Vitamin B6 25 mg 100 Tablets",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33984030824.png?v=1785947022",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "vitamin",
        "100",
        "tablets",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 78,
        "safety": 72,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 7.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663404847301",
      "vsf_explanation": "Solgar Vitamin B6 25mg — lower-dose variant of the 50mg SKU. 25mg is more conservative for daily long-term use and has a wider safety margin vs the sensory-neuropathy risk from chronic high-dose B6. Same Solgar quality standards. Held below Verified for the same reasons as the 50mg SKU: pyridoxine HCl form vs bioactive P-5-P, no third-party COA. Would move to Verified 70+ with P-5-P form + third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "energy-patches-natural-energy-metabolism-support-with-b-complex-vitamins-36-patches",
      "title": "Energy Patches Natural Energy & Metabolism Support with B-Complex Vitamins, 36 Patches",
      "vendor": "TOLEVITA",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Energypatches-1.jpg?v=1785947046",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "energy",
        "patches",
        "natural",
        "energy",
        "metabolism",
        "support",
        "with",
        "complex",
        "vitamins",
        "patches",
        "tolevita"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 42,
        "manufacturing": 45,
        "safety": 62,
        "transparency": 40,
        "sustainability": 42
      },
      "price": 18.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663405338821",
      "vsf_explanation": "Transdermal energy patch claiming B-complex delivery through the skin. Transdermal delivery of water-soluble vitamins (B-complex) is not scientifically supported — B vitamins are hydrophilic and don't cross the lipid-bilayer skin barrier efficiently. Real transdermal pharmaceuticals (nicotine, hormones, some pain meds) work because they're lipophilic and formulated with penetration enhancers. B-complex patches deliver essentially no systemic B-vitamin dose based on published transdermal-pharmacokinetics literature. Auto-fail: unverified_medical_claim (transdermal delivery not established for these compounds). Would move to Standard 55+ ONLY with published PK data showing actual systemic B-vitamin blood levels post-patch use — currently no such data exists for consumer B-vitamin patches.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "sundance-vitamins-complete-b-complex-vitamin-c-100-coated-caplets",
      "title": "Sundance Vitamins, Complete B-Complex + Vitamin C, 100 Coated Caplets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/345343260.jpg?v=1785947681",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive",
        "mood",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sundance",
        "vitamins",
        "complete",
        "complex",
        "vitamin",
        "100",
        "coated",
        "caplets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 58,
        "sustainability": 45
      },
      "price": 5.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663429718213",
      "vsf_explanation": "Sundance Vitamins (Rite Aid store brand) B-complex with vitamin C. B-complex is well-established for methylation, energy metabolism, homocysteine reduction. Store-brand quality can vary. Held below Verified by (1) B12 and folate forms (bioactive vs synthetic) not typically disclosed for store-brand products; (2) coated caplet with unknown coating ingredients; (3) no third-party testing. Would move to Verified 70+ with bioactive B12/folate + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mutant-madness-30-servings",
      "title": "Mutant Madness, 30 Servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Picture7_ac3c71fe-4b22-4ee7-834d-c8b1becbe2b4.jpg?v=1785947715",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mutant",
        "madness",
        "servings",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 32,
        "sustainability": 40
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663430144197",
      "vsf_explanation": "Mutant Madness pre-workout. Pre-workout formulas that use proprietary 'Madness Matrix' or similar branded blends typically hide the per-ingredient dosage — a common practice in the pre-workout category that prevents users from evaluating whether ingredients (caffeine, beta-alanine, L-citrulline, creatine) are at RCT-effective doses vs pixie-dust amounts. Auto-fail: proprietary_blend_hides_dose. Held below Standard because dose opacity is the specific auto-fail trigger. Would move to Standard 55+ with per-ingredient mg disclosure at label level; higher tiers require RCT-effective doses of active ingredients (typically 3-6g citrulline, 3.2g beta-alanine, 200-300mg caffeine, 3-5g creatine).",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "rooster-booster-liquid-b-12-plus-vitamin-k-for-all-poultry-supplement-16-oz",
      "title": "Rooster Booster Liquid B-12 Plus Vitamin K for All Poultry Supplement 16 oz.",
      "vendor": "Paw and Tail Supply",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Gemini_Generated_Image_qzfsmhqzfsmhqzfs_72ff2bfa-92a5-47ff-8778-92e96b10e296.png?v=1785947784",
      "score": 15,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "rooster",
        "booster",
        "liquid",
        "plus",
        "vitamin",
        "for",
        "all",
        "poultry",
        "supplement",
        "paw",
        "and",
        "tail",
        "supply"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 15,
        "manufacturing": 30,
        "safety": 10,
        "transparency": 15,
        "sustainability": 20
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663432241349",
      "vsf_explanation": "IMPORTANT: This is a veterinary supplement formulated for chickens/poultry, not humans. It is listed here by import error from the Vyvata catalog feed. B-12 and Vitamin K concentrations, carrier ingredients, and quality controls are formulated for avian gastrointestinal physiology and body weight — safety and efficacy for human use are unstudied and unauthorized. Auto-fail: out_of_scope_for_biohacking. Do not consume. If you're a poultry keeper interested in this product, buy it from a veterinary supply source. Vyvata will unpublish this listing on the next catalog audit. Would only be re-scoreable if a human-formulated equivalent were added under a different SKU.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "added-attention-liquid-supplement-for-kids-with-dha-b-vitamins-phospholipids-brain-friendly-nutrients-in-a-natural-raspberry-flavor-16-oz",
      "title": "Added Attention – Liquid Supplement for Kids with DHA, B Vitamins & Phospholipids | Brain-Friendly Nutrients in a Natural Raspberry Flavor | 16 oz",
      "vendor": "Buried Treasure Liquid Nutrients",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/addedmain.jpg?v=1785947805",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "youth_under_18",
      "tokens": [
        "added",
        "attention",
        "liquid",
        "supplement",
        "for",
        "kids",
        "with",
        "dha",
        "vitamins",
        "phospholipids",
        "brain",
        "friendly",
        "nutrients",
        "natural",
        "raspberry",
        "flavor",
        "buried",
        "treasure",
        "liquid",
        "nutrients"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 70,
        "transparency": 58,
        "sustainability": 45
      },
      "price": 36.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663432470725",
      "vsf_explanation": "Liquid supplement marketed for children's attention/focus with DHA + B vitamins + phospholipids. DHA for pediatric cognitive development is well-evidenced (Colombo 2013 review). B vitamins as cofactors are supportive. Held below Verified by (1) 'Added Attention' name implies ADHD-adjacent claim — DHA and B vitamins are not established ADHD treatments and could be regulatory-scrutinized as implied medical claim; (2) per-ingredient dose disclosure for pediatric formulations should be more granular than typical for adult supplements; (3) small brand without prominent third-party testing; (4) liquid raspberry flavor uses natural flavors + sweeteners. Would move to Verified 70+ with per-ingredient dose + third-party pediatric-safety COA + clearer regulatory positioning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-vitamin-b12-5000-mcg-150-veggie-capsules-non-gmo-vegan-max-strength-vitamin-b12",
      "title": "NusaPure Vitamin B12-5000 MCG 150 Veggie Capsules (Non-GMO, Vegan) - Max Strength Vitamin B12",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9782a3df.jpg?v=1785947824",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "vitamin",
        "b12",
        "5000",
        "mcg",
        "150",
        "veggie",
        "capsules",
        "non",
        "gmo",
        "vegan",
        "max",
        "strength",
        "vitamin",
        "b12",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 26.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663432798405",
      "vsf_explanation": "NusaPure Vitamin B12 5000mcg vegan capsules. High-dose B12 is appropriate for vegans/vegetarians and older adults (declining intrinsic factor). Held below Verified by (1) NusaPure is a small Amazon-tier brand — quality varies vs established manufacturers; (2) B12 form (cyanocobalamin vs methylcobalamin) affects bioavailability — methylcobalamin is preferred, and label form not always clear; (3) no third-party testing visible; (4) 5000mcg is very high — most oral absorption plateaus around 1000-2000mcg regardless of dose. Would move to Verified 70+ with methylcobalamin form + third-party COA + more appropriate dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "centrum®-silver®-women-50-multivitamin-multimineral-supplement",
      "title": "Centrum® Silver® Women 50+ Multivitamin / Multimineral Supplement",
      "vendor": "Centrum",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/170992892_9eba34ff-c79d-49de-a299-43be120e9981.jpg?v=1785947837",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "centrum",
        "silver",
        "women",
        "multivitamin",
        "multimineral",
        "supplement",
        "centrum"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 55,
        "manufacturing": 72,
        "safety": 70,
        "transparency": 62,
        "sustainability": 45
      },
      "price": 26.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663432962245",
      "vsf_explanation": "Centrum Silver Women 50+ multivitamin from Haleon (formerly GSK Consumer). Mass-market brand with real manufacturing standards but formulation choices favor cost + shelf-stability over bioavailability. Multivitamin evidence base for general 50+ women's health is real — Physicians' Health Study II showed modest cancer/cognitive benefit (Grodstein 2013) from a comparable formulation. Held below Verified by (1) uses lowest-cost forms (folic acid vs 5-MTHF, cyanocobalamin vs methylcobalamin, magnesium oxide vs glycinate, DL-alpha-tocopherol vs natural D-alpha-tocopherol) which underdeliver bioavailability; (2) artificial coloring (FD&C dyes); (3) not USP-verified. Would move to Verified 70+ with bioactive-form reformulation + USP certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-vitamin-b6-50mg-100-tablets",
      "title": "Solgar Vitamin B6 50mg 100 Tablets",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33984031005.png?v=1785948853",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "vitamin",
        "50mg",
        "100",
        "tablets",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 78,
        "safety": 65,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 10.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663449542853",
      "vsf_explanation": "Solgar Vitamin B6 (pyridoxine HCl) 50mg. B6 has real evidence for PMS symptoms (Wyatt 1999), morning sickness, and homocysteine reduction. 50mg is well above the RDA (1.3-1.7mg) but well below the UL (100mg/day for adults). Held below Verified by (1) pyridoxine HCl form vs P-5-P (pyridoxal-5-phosphate, the bioactive form) — P-5-P is preferred for people with polymorphisms in B6 activation enzymes; (2) chronic high-dose B6 (>200mg/day for months-years) has been associated with sensory neuropathy (Bacharach 2017) — 50mg is likely safe but daily long-term use warrants monitoring; (3) no third-party testing. Would move to Verified 70+ with P-5-P form + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-gentle-iron-25-mg-180-vegetable-capsules",
      "title": "Solgar Gentle Iron 25 mg 180 Vegetable Capsules",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33984012509.png?v=1785948867",
      "score": 82,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "gentle",
        "iron",
        "180",
        "vegetable",
        "capsules",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 78,
        "manufacturing": 78,
        "safety": 68,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 21.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663449903301",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 72 → new 82. Evidence found: Milman N, et al. Ferrous bisglycinate 25 mg iron is as effective as ferrous sulfate 50 mg iron in the prophylaxis of iron deficiency and anemia during pregnancy. J Perinat Med. 2014;42(2):197-206. | Ferrari P, et al. Treatment of mild non-chemotherapy-induced iron deficiency anemia: oral ferrous bisglycinate chelate vs IV iron sucrose. Biomed Pharmacother. 2012;66(6):414-8. | Albion Minerals patents and PK dossiers documenting bisglycinate chelate absorption and reduced GI side effects vs sulfate.. Rationale: Solgar Gentle Iron is Albion iron bisglycinate chelate (Ferrochel). Milman 2014 head-to-head RCT showed 25 mg bisglycinate matches 50 mg ferrous sulfate for anemia prevention in pregnancy, with significantly better GI tolerance. TIER-B evidence for the specific form. +10 uplift is honest given both efficacy parity at lower dose AND meaningfully reduced constipation/nausea profile.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-magnesium-with-vitamin-b6-250-tablets",
      "title": "Solgar Magnesium With Vitamin B6, 250 Tablets",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/256372088_2d92682d-b3fa-4133-88fa-8df19d843080.jpg?v=1785948872",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "magnesium",
        "with",
        "vitamin",
        "250",
        "tablets",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 68,
        "manufacturing": 78,
        "safety": 75,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 20.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663450034373",
      "vsf_explanation": "Solgar Magnesium with B6. B6 as a cofactor supports magnesium cellular uptake (small but real synergy). Magnesium has broad evidence base — cardiovascular, muscle relaxation, sleep, blood pressure (Zhang 2016 meta-analysis on Mg + BP). Held below Verified by (1) magnesium form (oxide vs glycinate vs citrate) — Solgar's default is often magnesium oxide which has ~4% bioavailability, one of the worst forms; (2) elemental magnesium content not always clearly disclosed at label level; (3) 250 tablets suggests conservative per-tablet dose. Would move to Verified 70+ with magnesium glycinate/citrate form + elemental content disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-vitamin-d3-cholecalciferol-125-mcg-5-000-iu-240-vegetable-capsules",
      "title": "Solgar Vitamin D3 (Cholecalciferol) 125 mcg (5,000 IU) 240 Vegetable Capsules",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33984033146.png?v=1785948880",
      "score": 82,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "vitamin",
        "cholecalciferol",
        "125",
        "mcg",
        "000",
        "240",
        "vegetable",
        "capsules",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 80,
        "formulation": 75,
        "manufacturing": 78,
        "safety": 72,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 36.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663450230981",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 75 → new 82. Evidence found: Holick MF. Vitamin D deficiency. N Engl J Med. 2007;357(3):266-81. | Bischoff-Ferrari HA, et al. Pooled analysis of vitamin D dose requirements for fracture prevention. N Engl J Med. 2012;367(1):40-9.. Rationale: Same TIER-A evidence base as the sibling 5000 IU SKU. Vegetable-capsule 240-count format (typically lichen-derived D3, vegan-appropriate). +7 uplift for TIER-A ingredient evidence at appropriate correction dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-vitamin-c-1000mg-90-tablets",
      "title": "Solgar Vitamin C 1000mg 90 Tablets",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33984032750.jpg?v=1785948890",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "vitamin",
        "1000mg",
        "tablets",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 65,
        "manufacturing": 78,
        "safety": 75,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 13.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663450886341",
      "vsf_explanation": "Solgar Vitamin C 1000mg tablets. Vitamin C has real evidence for immune support (Hemilä 2013 Cochrane review on cold-duration reduction), collagen synthesis, and antioxidant function. 1000mg is a common daily supplemental dose (Padayatty 2003 saturation-kinetics work suggests plasma saturation at 200mg from food sources). Held below Verified by (1) ascorbic acid form is basic — buffered/mineral-ascorbate forms are gentler on the stomach; (2) split dosing (500mg 2x/day) has better bioavailability than 1000mg single dose but not addressed in label guidance; (3) not liposomal (higher-bioavailability form). Would move to Verified 70+ with liposomal or mineral-ascorbate formulation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-resveratrol-250-mg-with-red-wine-extract-30-softgels",
      "title": "Solgar Resveratrol 250 Mg With Red Wine Extract, 30 Softgels",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/148708397.jpg?v=1785948901",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "resveratrol",
        "250",
        "with",
        "red",
        "wine",
        "extract",
        "softgels",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 78,
        "safety": 72,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 30.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663451541701",
      "vsf_explanation": "Solgar trans-resveratrol 250mg plus red wine extract in softgels. Resveratrol has interesting mechanistic literature (Sinclair lab sirtuin activation) but human RCT translation has been mixed — bioavailability is poor (~1% oral), and effect sizes on measurable clinical outcomes are modest. 250mg is a reasonable per-cap dose; softgel + red wine extract synergy is a formulation positive vs plain resveratrol powder. Held below Verified by (1) real-world resveratrol effect sizes in human RCTs are smaller than the mechanistic literature suggests; (2) trans- vs cis-resveratrol ratio and % standardization not always disclosed; (3) no third-party COA. Would move to Verified 70+ with %trans-resveratrol standardization + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-calcium-magnesium-plus-boron-250-tablets",
      "title": "Solgar Calcium Magnesium Plus Boron, 250 Tablets",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/62276162.jpg?v=1785948908",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "calcium",
        "magnesium",
        "plus",
        "boron",
        "250",
        "tablets",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 78,
        "safety": 72,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 22.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663451705541",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 66 → new 72. Evidence found: Tang BM, et al. Use of calcium or calcium in combination with vitamin D supplementation to prevent fractures and bone loss in people aged 50 years and older: a meta-analysis. Lancet. 2007;370(9588):657-66. | Nielsen FH. Update on human health effects of boron. J Trace Elem Med Biol. 2014;28(4):383-7.. Rationale: Cal-Mag combos have TIER-B evidence for reducing bone loss and modest fracture prevention in older adults. Boron addition (1-3 mg typical) has TIER-C evidence for improving Ca/Mg retention and influencing estrogen metabolism. +6 uplift for a reasonable evidence-based bone-support stack.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-l-arginine-500-mg-100-vegetable-capsules",
      "title": "Solgar L-Arginine 500 Mg - 100 Vegetable Capsules",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/181725085.png?v=1785948914",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "arginine",
        "500",
        "100",
        "vegetable",
        "capsules",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 78,
        "safety": 72,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 17.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663451738309",
      "vsf_explanation": "Solgar L-Arginine 500mg. L-arginine has real evidence for nitric oxide precursor use and endothelial function (Bode-Böger 1998) but requires much higher doses (3-6g typically per dose for NO/blood flow effect) than 500mg per capsule provides. Held below Verified by (1) 500mg per cap is well below RCT-effective range — user needs 6-12 caps per dose; (2) L-citrulline (which converts to arginine with much higher bioavailability) is now preferred over L-arginine for NO/vasodilation applications; (3) no third-party testing. Would move to Verified 70+ with higher-dose per-cap OR reformulation to L-citrulline.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-melatonin-10mg-60-tablets",
      "title": "Solgar Melatonin 10mg 60 Tablets",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33984019560.png?v=1785948920",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "melatonin",
        "10mg",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 68,
        "manufacturing": 78,
        "safety": 68,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 19.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663452033221",
      "vsf_explanation": "[Rescored — SAFETY DOWNGRADE via evidence crawl] Previous score 68 → new 60. Evidence found: Zhdanova IV, et al. Melatonin treatment for age-related insomnia. J Clin Endocrinol Metab. 2001;86(10):4727-30 (0.3 mg outperformed 3 mg). | Brzezinski A, et al. Effects of exogenous melatonin on sleep: a meta-analysis. Sleep Med Rev. 2005;9(1):41-50. | Vural EM, et al. Optimal dosages for melatonin supplementation therapy in older adults. Drugs Aging. 2014;31(6):441-51 (recommends 0.3-3 mg).. Rationale: 10 mg is 3-30x above the physiological range shown effective (0.3-3 mg). Higher doses do not improve sleep onset or duration and are associated with next-morning grogginess, tachycardia, and receptor desensitization with chronic use. -8 downgrade (well within -25 cap) reflects a dose-design issue, not an ingredient-quality issue.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-potassium-amino-acid-complex-100-tablets",
      "title": "Solgar Potassium Amino Acid Complex 100 Tablets",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33984007604.jpg?v=1785948926",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "potassium",
        "amino",
        "acid",
        "complex",
        "100",
        "tablets",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 78,
        "safety": 68,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 10.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663452197061",
      "vsf_explanation": "Solgar Potassium amino acid chelate. Potassium supplements are regulated to 99mg or lower per serving in the US (an FDA cap set for arrhythmia risk from potassium supplement overuse — most K deficits should be addressed via diet: 4700mg/day RDA is achievable through fruits/vegetables). Held below Verified by (1) 99mg is a rounding error vs the 4700mg RDA — practical utility for actual potassium repletion is limited; (2) supplementation isn't the primary intervention for hypokalemia; (3) chelate form is a formulation plus vs oxide/chloride, but the per-dose limit constrains impact. Standard tier because the product is safe and correctly manufactured — just constrained by the regulatory dose ceiling.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-ultimate-b-c-complex-60-tablets",
      "title": "Solgar Ultimate B+C Complex 60 Tablets",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33984027718.png?v=1785948933",
      "score": 76,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "ultimate",
        "complex",
        "tablets",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 72,
        "manufacturing": 78,
        "safety": 75,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 18.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663452328133",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 70 → new 76. Evidence found: Kennedy DO. B vitamins and the brain: mechanisms, dose and efficacy - a review. Nutrients. 2016;8(2):68. | Stough C, et al. The effect of 90-day administration of a high-dose vitamin B-complex on work stress. Hum Psychopharmacol. 2011;26(7):470-6.. Rationale: B-complex + C stacks have TIER-B evidence for work-stress management (Stough 2011) and general B-vitamin coverage supports homocysteine control. +6 uplift for a comprehensive high-B formulation with ancillary C.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-coq-10-60mg-60-vegetable-capsules",
      "title": "Solgar CoQ-10 60mg 60 Vegetable Capsules",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33984009363.png?v=1785948946",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "coq",
        "60mg",
        "vegetable",
        "capsules",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 68,
        "manufacturing": 78,
        "safety": 78,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 17.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663452524741",
      "vsf_explanation": "Solgar CoQ-10 60mg vegetable capsules. CoQ-10 (ubiquinone form here) has real evidence for statin-induced myalgia (Skarlovnik 2014), heart failure (Mortensen 2014 Q-SYMBIO trial), and mitochondrial support. Solgar's manufacturing quality is a plus. Held below Verified by (1) 60mg is on the low end — RCT-effective CoQ-10 doses are typically 100-300mg/day; (2) ubiquinone form has lower bioavailability than ubiquinol form (particularly in older adults); (3) not delivered with a fat carrier (softgel with MCT/olive oil) which optimizes absorption. Would move to Verified 70+ with higher dose option + ubiquinol form OR ubiquinone in oil-based softgel.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-folic-acid-800mcg-100-vegetable-capsules",
      "title": "Solgar Folic Acid 800mcg 100 Vegetable Capsules",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33984010918.jpg?v=1785948957",
      "score": 74,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "folic",
        "acid",
        "800mcg",
        "100",
        "vegetable",
        "capsules",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 65,
        "manufacturing": 78,
        "safety": 72,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 10.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663452623045",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 68 → new 74. Evidence found: MRC Vitamin Study Research Group. Prevention of neural tube defects: results of the Medical Research Council Vitamin Study. Lancet. 1991;338(8760):131-7. | Homocysteine Lowering Trialists' Collaboration. Dose-dependent effects of folic acid on blood concentrations of homocysteine: a meta-analysis. Am J Clin Nutr. 2005;82(4):806-12.. Rationale: TIER-A evidence for folic acid at 400-800 mcg for neural tube defect prevention and homocysteine reduction. +6 uplift for well-documented efficacy at the exact dose provided. Caveat: this is folic acid (synthetic), not L-methylfolate - individuals with MTHFR variants may benefit from Solgar's methylfolate SKU instead.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-l-lysine-500-mg-100-vegetable-capsules",
      "title": "Solgar L-Lysine 500 mg 100 Vegetable Capsules",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33984016811.png?v=1785948968",
      "score": 78,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "lysine",
        "500",
        "100",
        "vegetable",
        "capsules",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 68,
        "manufacturing": 78,
        "safety": 78,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 13.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663452786885",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 70 → new 78. Evidence found: Griffith RS, et al. A multicentered study of lysine therapy in Herpes simplex infection. Dermatologica. 1978;156(5):257-67. | McCune MA, et al. Treatment of recurrent herpes simplex infections with L-lysine monohydrochloride. Cutis. 1984;34(4):366-73 (1000-3000 mg/day reduced outbreak frequency and duration).. Rationale: L-lysine has TIER-B evidence for HSV cold sore prophylaxis at 1-3 g/day. 500 mg/capsule means 2-6 capsules to reach studied dose. Amino acid formulation is straightforward. +8 uplift for reasonably strong niche evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nature-made-l-lysine-1000-mg-tablets️",
      "title": "Nature Made L-Lysine 1000 mg Tablets️",
      "vendor": "Nature Made",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/large_4463f304-c904-43f7-a417-02acbc179448.jpg?v=1785948987",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "made",
        "lysine",
        "1000",
        "tablets",
        "nature",
        "made"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 72,
        "manufacturing": 75,
        "safety": 75,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 21.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663454556357",
      "vsf_explanation": "L-Lysine 1000mg from Nature Made — established mainstream brand with USP verification on many SKUs. 1000mg per tablet is in the therapeutic range for HSV suppression (McCune 1984). Nature Made's USP participation is a real manufacturing/purity plus — one of the few mass-market brands that submits to independent testing. Held below Elite by (1) USP verification is per-product — need to confirm this specific L-Lysine SKU carries it; (2) sustainability profile thin; (3) no product-specific efficacy trial. Would move to Elite 85+ with confirmed USP verification on this SKU + published sustainability certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "windmill-l-lysine-hcl-500-mg-tablets-120ct",
      "title": "Windmill L-Lysine HCl 500 Mg Tablets 120ct",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/301622519.jpg?v=1785948995",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "windmill",
        "lysine",
        "hcl",
        "500",
        "tablets",
        "120ct",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 8.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663454654661",
      "vsf_explanation": "L-Lysine 500mg from Windmill. L-lysine has real evidence for herpes simplex outbreak prevention (Griffith 1978 seminal work, McCune 1984 dose-response — 1-3g/day) and moderate evidence as an amino acid supplement. 500mg is a lower per-tablet dose, requires 2-6 tablets/day to hit therapeutic range for HSV suppression. Held below Verified by (1) Windmill is a budget brand without prominent third-party testing; (2) no COA visible; (3) 500mg is on the low end — 1000mg per tablet is more common for supplement use. Would move to Verified 70+ with third-party COA + higher per-tablet dose option.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "muscletech-nitro-tech-100-whey-gold-protein-2240-gr",
      "title": "Muscletech Nitro-Tech 100% Whey Gold Protein 2240 Gr",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/muscletech_nitro_tech_100_whey_gold_protein_2240_gr_62093.jpg?v=1785949062",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "muscletech",
        "nitro",
        "tech",
        "100",
        "whey",
        "gold",
        "protein",
        "2240",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 50,
        "sustainability": 42
      },
      "price": 226.14,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663456817349",
      "vsf_explanation": "Nitro-Tech Whey Gold — mainstream mass-market whey protein blend from Muscletech (Iovate). Whey protein for muscle protein synthesis is one of the most-studied supplements (Jäger 2017 ISSN position stand). Held below Verified by (1) Muscletech has a mixed reputation — the brand has been on Consumer Reports and Labdoor spot-check reports for label-accuracy issues on protein amount vs claim in some SKUs; (2) 'protein blend' formulations often use nitrogen-spiking amino acid additions (glycine, taurine) that inflate the total-protein-by-nitrogen measurement without providing complete protein; (3) artificial flavors + colorings + sweeteners; (4) no NSF Certified for Sport or Informed Sport certification visible. Would move to Verified 70+ with NSF/Informed Sport certification + third-party actual-protein content verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sundance-vitamins-high-absorption-magnesium-glycinate-665-mg-quick-release-capsules",
      "title": "Sundance Vitamins High Absorption Magnesium Glycinate 665 Mg Quick Release Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/130097883.jpg?v=1785949083",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sundance",
        "vitamins",
        "high",
        "absorption",
        "magnesium",
        "glycinate",
        "665",
        "quick",
        "release",
        "capsules",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 75,
        "transparency": 58,
        "sustainability": 45
      },
      "price": 9.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663457374405",
      "vsf_explanation": "Magnesium glycinate 665mg from Sundance Vitamins (Rite Aid store brand). Magnesium glycinate is the best-tolerated, best-absorbed common form — appropriate for sleep, stress, muscle-relaxation use cases (Boyle 2017 review). 665mg glycinate ≈ 65-70mg elemental magnesium per capsule (glycinate is ~10-11% elemental), which is lower than the 200-400mg elemental daily typically studied in RCTs. Held below Verified by (1) store-brand quality varies by lot; (2) elemental magnesium content (the number that matters) not always clearly disclosed at label; (3) no independent third-party COA. Would move to Verified 70+ with elemental mg disclosure + third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "biowizdom-neuronourish-aminos-60-capsules",
      "title": "BioWizdom NeuroNourish Aminos (60 capsules)",
      "vendor": "BioWizdom",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/rn-image_picker_lib_temp_2f21026e-69d6-470b-89de-a01e49bb94b7.png?v=1785949105",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "biowizdom",
        "neuronourish",
        "aminos",
        "capsules",
        "biowizdom"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 52,
        "manufacturing": 45,
        "safety": 65,
        "transparency": 48,
        "sustainability": 45
      },
      "price": 35.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663457931461",
      "vsf_explanation": "Amino acid blend marketed for cognitive support from BioWizdom. Amino acids like L-tyrosine (dopamine/norepinephrine precursor), taurine, L-theanine have real cognitive evidence at RCT-effective doses (500-2000mg range depending on AA). Held below Verified by (1) small brand with limited transparency; (2) per-AA mg disclosure not visible at label level; (3) 'NeuroNourish Aminos' branding is generic vs specific formulation claims. Would move to Verified 70+ with per-AA mg disclosure + third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "biowizdom-holistilax-90-caps",
      "title": "BioWizdom HolistiLax (90 caps)",
      "vendor": "BioWizdom",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/rn-image_picker_lib_temp_0489618f-1d9c-421b-a619-757a3efbb2cc.png?v=1785949113",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "biowizdom",
        "holistilax",
        "caps",
        "biowizdom"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 65,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 36.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663458160837",
      "vsf_explanation": "Herbal laxative blend from BioWizdom. Herbal laxatives (senna, cascara, aloe latex) have real efficacy but also real risks — dependency and colonic melanosis with prolonged use. Held below Standard by (1) small brand with limited testing; (2) 'HolistiLax' branding suggests herbal-blend approach that often includes stimulant laxatives without adequate warnings; (3) ingredient + dose disclosure limited; (4) no clear cycling/duration guidance to prevent dependency issues. Would move to Standard 55+ with full ingredient disclosure + duration/dependency warnings + third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "biospores-probiotics-60-caps",
      "title": "BioSpores Probiotics 60 caps",
      "vendor": "BioWizdom",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/IMAGE-EDIT_59398834-780c-42e8-bc33-b1bb72ff7bc5.png?v=1785949120",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "biospores",
        "probiotics",
        "caps",
        "biowizdom"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 48,
        "safety": 70,
        "transparency": 50,
        "sustainability": 48
      },
      "price": 40.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663458390213",
      "vsf_explanation": "Spore-based probiotic — Bacillus-genus spores (typically B. subtilis, B. coagulans, B. clausii) that survive stomach acid better than typical Lactobacillus/Bifidobacterium probiotics. Real evidence for spore-based probiotics in gut inflammation (McFarlin 2017 on B. subtilis reducing gut permeability). Held below Verified by (1) 'BioSpores' generic branding suggests small unnamed manufacturer; (2) specific Bacillus strain identification (matters for the evidence base) not clearly disclosed; (3) CFU per capsule and strain-specific quantities not visible; (4) no third-party viability testing. Would move to Verified 70+ with strain-level identification + CFU disclosure + third-party viability testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "biowizdom-organic-turmeric-120-caps",
      "title": "BioWizdom Organic Turmeric (120 caps)",
      "vendor": "BioWizdom",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/rn-image_picker_lib_temp_4562d412-0605-461b-89d4-0a31ddc80ff7.png?v=1785949129",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "biowizdom",
        "organic",
        "turmeric",
        "120",
        "caps",
        "biowizdom"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 52,
        "manufacturing": 48,
        "safety": 72,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 37.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663458652357",
      "vsf_explanation": "Organic turmeric capsules from BioWizdom. Organic sourcing is a real plus. See 21st Century Turmeric Complex for the full curcumin bioavailability rationale — 1% oral absorption without a delivery enhancer. Small brand, no visible third-party COA. Would move to Verified 70+ with bioavailability enhancer + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "biowizdom-gluco-radiant-90-capsules",
      "title": "BioWizdom Gluco Radiant 90 capsules",
      "vendor": "BioWizdom",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/rn-image_picker_lib_temp_07d61a24-a8e9-4e5b-99bf-d51492e5ba4e.png?v=1785949136",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "biowizdom",
        "gluco",
        "radiant",
        "capsules",
        "biowizdom"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 65,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 47.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663458848965",
      "vsf_explanation": "Blood-sugar/glucose-focused supplement from small brand BioWizdom. Held below Standard by (1) 'Gluco Radiant' branding is aspirational marketing without a specified clinical endpoint; (2) small brand with no visible third-party testing or independent RCTs; (3) ingredient disclosure and per-ingredient dose transparency limited on the label; (4) blood-glucose supplements are a category with significant unsubstantiated-claims risk under FDA guidance. Would move to Standard 55+ with full ingredient + dose disclosure at label level + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "biodigest-plus-digestive-enzymes-gluten-digestion-90-caps",
      "title": "BioDigest Plus Digestive Enzymes (gluten digestion) 90 caps",
      "vendor": "BioWizdom",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BioDigestPlus.jpg?v=1785949149",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "biodigest",
        "plus",
        "digestive",
        "enzymes",
        "gluten",
        "digestion",
        "caps",
        "biowizdom"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 68,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663459176645",
      "vsf_explanation": "Digestive enzyme blend marketed for gluten digestion. Enzyme evidence for post-meal digestion is real for pancreatic enzyme insufficiency but weaker for general 'digestive support' claims. Gluten-digestion specifically: DPP-IV enzymes (Ehren 2009) have some evidence for accidental gluten exposure, but NOT as a substitute for a gluten-free diet in celiac disease. Held below Verified by (1) small brand without prominent testing; (2) specific enzyme activity units per capsule not clearly disclosed; (3) 'gluten digestion' marketing could mislead celiac users into thinking this makes gluten safe — it does not; (4) no third-party COA. Would move to Verified 70+ with per-enzyme activity-unit disclosure + clear celiac non-use disclaimer + third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "biomag7-magnesium-complex-90-caps",
      "title": "BioMag7 Magnesium Complex 90 caps",
      "vendor": "BioWizdom",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/PSX-20250102_150007.jpg?v=1785949160",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "biomag7",
        "magnesium",
        "complex",
        "caps",
        "biowizdom"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 50,
        "safety": 72,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 36.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663459569861",
      "vsf_explanation": "Magnesium complex capsules from BioMag7 — the '7' typically implies 7 magnesium forms (glycinate, citrate, malate, taurate, orotate, threonate, oxide) in one capsule. Multi-form magnesium can theoretically balance absorption + tissue distribution, but each form ends up at low elemental content when 7 share a single capsule. Held below Verified by (1) small brand without established quality track record; (2) per-form magnesium content not typically disclosed at label level; (3) 7-form blend spreads doses thin — real therapeutic magnesium supplementation typically uses 200-400mg elemental of one preferred form; (4) no third-party COA. Would move to Verified 70+ with per-form mg disclosure + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "new-harvest-turmeric",
      "title": "New Harvest Turmeric",
      "vendor": "World Peaces",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8e825be617dc15a5b1c6210800500143aea6a8a4d11c4d69b9ce04ad45e57639.jpg?v=1785949235",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "new",
        "harvest",
        "turmeric",
        "world",
        "peaces"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 50,
        "manufacturing": 48,
        "safety": 72,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663461535941",
      "vsf_explanation": "Turmeric supplement from New Harvest, small brand. See 21st Century Turmeric Complex for the full category rationale — turmeric bioavailability without an enhancer is poor. Small brand, no visible third-party testing or heavy-metals COA. Would move to Verified 70+ with bioavailability enhancer + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "turmeric-powder",
      "title": "Turmeric Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/TurmericPowderProductShot.jpg?v=1785949246",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "turmeric",
        "powder",
        "kauai",
        "farmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 40,
        "safety": 68,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663461896389",
      "vsf_explanation": "Generic turmeric powder — no brand, no origin disclosure, no third-party testing information. Plain turmeric powder is a culinary ingredient with ~1% oral bioavailability without a delivery enhancer. Held below Standard by (1) complete lack of brand/manufacturer transparency; (2) heavy-metals contamination is a real risk in imported turmeric (Cowell 2017 Consumer Reports found significant lead in some commodity turmeric) — no COA visible; (3) no curcumin standardization disclosure. Would move to Standard 55+ with named manufacturer + heavy-metals COA + curcumin content disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "original-turmeric-latte",
      "title": "Original Turmeric Latte",
      "vendor": "Morning Made",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/original-turmeric-latte-3-pack-3816983.webp?v=1785949255",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "original",
        "turmeric",
        "latte",
        "morning",
        "made"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 36,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663462486213",
      "vsf_explanation": "Turmeric latte blend — culinary product marketed for daily consumption. Latte format (turmeric + coconut milk + black pepper typically) is one of the more sensible ways to use turmeric because it pairs curcumin with fat and piperine for improved absorption. Held below Verified by (1) exact per-serving curcumin content not specified; (2) 'latte blend' formulations often have significant sugar/sweetener content; (3) small brand without prominent third-party testing. Would move to Verified 70+ with curcumin content disclosure + third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "navitas-organics-turmeric-powder",
      "title": "Navitas Organics Turmeric Powder",
      "vendor": "Duo Grocery",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/large_761dbe7b-4b6e-4bf3-8d11-c6d21c6cfd20.png?v=1785949269",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "navitas",
        "organics",
        "turmeric",
        "powder",
        "duo",
        "grocery"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 65,
        "sustainability": 68
      },
      "price": 23.37,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663462977733",
      "vsf_explanation": "USDA Organic turmeric powder from Navitas Organics — a legitimate clean-food brand with real sourcing standards. Turmeric powder is a culinary ingredient more than a therapeutic supplement — the ~1% bioavailability issue means culinary use (with fat + black pepper for absorption) is reasonable but not therapeutic. Organic certification + Navitas quality reputation help. Held below Verified by (1) turmeric powder without a bioavailability enhancer or standardization to curcumin % is inherently low-bioavailability; (2) no per-serving curcumin content disclosure; (3) product is positioned as food, not supplement — user has to add pepper + fat manually. Would move to Verified 70+ with standardized curcumin % + integrated bioavailability enhancer.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "21st-century-turmeric-complex-500mg-capsules-60ct",
      "title": "21st Century Turmeric Complex 500Mg Capsules 60Ct",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/152321109_50b8e290-77f3-4572-adef-e3ff3228fdc1.jpg?v=1785949278",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "21st",
        "century",
        "turmeric",
        "complex",
        "500mg",
        "capsules",
        "60ct",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 6.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46663463207109",
      "vsf_explanation": "Turmeric capsule at 500mg from 21st Century, a budget mass-market brand. Turmeric/curcumin has real anti-inflammatory research (Hewlings & Kalman 2017 review, Daily 2016 meta-analysis on arthritis pain) but curcumin bioavailability without a delivery enhancer (piperine, phospholipid complex, liposomal) is famously poor — plain turmeric powder has ~1% oral absorption. Held below Verified by (1) no bioavailability-enhancer disclosure on the label; (2) 500mg 'turmeric complex' may include filler powder not just standardized curcumin; (3) 21st Century is a budget brand without prominent third-party testing. Would move to Verified 70+ with a bioavailability-enhanced formulation (piperine 5-10mg or phytosome) + third-party curcumin-content COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chief-collagen-protein-powder-unflavoured-100-organic-grass-fed-aussie-beef",
      "title": "Chief. Collagen Protein Powder, Unflavoured, 100% Organic Grass-Fed Aussie Beef",
      "vendor": "Chief",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_45.png?v=1786141614",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint",
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chief",
        "collagen",
        "protein",
        "powder",
        "unflavoured",
        "100",
        "organic",
        "grass",
        "fed",
        "aussie",
        "beef",
        "chief"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 72,
        "manufacturing": 65,
        "safety": 75,
        "transparency": 65,
        "sustainability": 60
      },
      "price": 47.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46675044597957",
      "vsf_explanation": "Unflavored version of Chief. Collagen — cleaner formulation than the vanilla SKU since no sweeteners/flavorings are added. Same grass-fed Australian sourcing and collagen evidence base. Held below Verified by same limitations (no third-party COA, peptide-size disclosure gap). Would move to Verified 70+ with peptide-size disclosure + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chief-collagen-protein-powder-creamy-vanilla-flavour-100-organic-grass-fed-aussie-beef",
      "title": "Chief. Collagen Protein Powder, Creamy Vanilla Flavour, 100% Organic Grass-Fed Aussie Beef",
      "vendor": "Chief",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitled_design_46_8eb851de-78f7-4615-a5a7-df9ad5b16aef.png?v=1786141728",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint",
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chief",
        "collagen",
        "protein",
        "powder",
        "creamy",
        "vanilla",
        "flavour",
        "100",
        "organic",
        "grass",
        "fed",
        "aussie",
        "beef",
        "chief"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 68,
        "manufacturing": 65,
        "safety": 75,
        "transparency": 65,
        "sustainability": 60
      },
      "price": 47.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46675045548229",
      "vsf_explanation": "Collagen protein powder from 100% organic grass-fed Australian beef. Collagen supplementation has real evidence for skin elasticity (Choi 2019 review, Proksch 2014 RCT on skin dryness) and joint comfort (Zdzieblik 2015 on activity-related joint pain), though effect sizes are modest and require sustained 8-12 week use. Grass-fed Australian sourcing is a real quality plus over commodity commercial collagen. Held below Verified by (1) no third-party COA for hydrolyzed peptide content or amino-acid profile per bottle; (2) collagen 'peptide' size (matters for absorption) not fully disclosed; (3) vanilla flavoring adds sweeteners/natural flavors. Would move to Verified 70+ with published peptide-size spec + third-party COA + independent RCT on the Chief. formulation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hermetica-eternity-12-in-1-mushroom-gummies",
      "title": "Hermetica Eternity 12-in-1 Mushroom Gummies",
      "vendor": "Hermetica",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_47.png?v=1786142639",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hermetica",
        "eternity",
        "mushroom",
        "gummies",
        "hermetica"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 35,
        "manufacturing": 45,
        "safety": 68,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 34,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46675088376005",
      "vsf_explanation": "12 medicinal mushrooms combined into one gummy — a marketing-driven kitchen-sink formulation where each ingredient ends up at sub-therapeutic dose. Individual mushroom RCT literature (Lion's Mane at 1000-3000mg/day for cognition, Reishi at 1500-3000mg/day for immune, Cordyceps at 1000-3000mg/day for exercise capacity) requires per-mushroom doses that simply cannot fit into a small gummy alongside 11 others. Auto-fail: sub_therapeutic_dose. Marketing benefits from listing 12 different mushrooms; users get nothing at RCT-effective amounts of any single one. Would move to Standard 55+ with reformulation into 3-4 mushroom blend at RCT-effective per-mushroom doses.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "kunsana-ceramic-infrared-sauna-2-person-indoor-infrared-saunas-for-home",
      "title": "Kunsana Ceramic Infrared Sauna 2 Person, Indoor Infrared Saunas for Home",
      "vendor": "Kunsana",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_48.png?v=1786808977",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "kunsana",
        "ceramic",
        "infrared",
        "sauna",
        "person",
        "indoor",
        "infrared",
        "saunas",
        "for",
        "home",
        "kunsana"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 1525,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46740892451013",
      "vsf_explanation": "2-person cabin infrared sauna with ceramic heaters from Kunsana. Ceramic heating is an older-generation technology than graphene or carbon (higher EMF, less uniform output) — a mild formulation negative. Cabin form matches trial-supported delivery. Held below Verified by (1) 'Kunsana' is an Amazon-tier brand; (2) ceramic heaters historically have higher EMF than newer technologies — no measurements published; (3) no UL/ETL certification. Would move to Verified 70+ with EMF measurements + UL/ETL + heater upgrade to lower-EMF technology.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sauna-doctor-1180w-infrared-sauna-for-home-1-person-indoor-dry-sauna-with-7-graphene-heating-plates-foot-care",
      "title": "Sauna Doctor 1180W Infrared Sauna for Home, 1 Person Indoor Dry Sauna with 7 Graphene Heating Plates & Foot Care",
      "vendor": "Sauna Doctor",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_50.png?v=1786809245",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sauna",
        "doctor",
        "1180w",
        "infrared",
        "sauna",
        "for",
        "home",
        "person",
        "indoor",
        "dry",
        "sauna",
        "with",
        "graphene",
        "heating",
        "plates",
        "foot",
        "care",
        "sauna",
        "doctor"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 1019,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46740908638405",
      "vsf_explanation": "1-person cabin infrared sauna with graphene heating plates. Graphene heaters deliver more uniform infrared emission than carbon panels — a real formulation positive. Cabin form matches trial-supported delivery. Held below Verified by (1) 'Sauna Doctor' brand track record is limited; (2) no published EMF measurements at body-position distance; (3) no UL/ETL certification visible in product listing; (4) sustainability profile thin. Would move to Verified 70+ with published EMF + UL/ETL + heater-specification detail.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "the-pod-company-the-sauna-pod-2-0-dry-sauna-for-recovery-wellness",
      "title": "THE POD COMPANY The Sauna Pod 2.0 Dry Sauna for Recovery & Wellness",
      "vendor": "The Pod Company",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_52.png?v=1786809414",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "the",
        "pod",
        "company",
        "the",
        "sauna",
        "pod",
        "dry",
        "sauna",
        "for",
        "recovery",
        "wellness",
        "the",
        "pod",
        "company"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 625,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46740917780677",
      "vsf_explanation": "Personal dry sauna pod from THE POD COMPANY — a more established brand in the personal-sauna space than the generic Amazon competitors, with more consistent build quality. Sauna evidence base is real (Laukkanen 2018). Held below Verified by (1) 'pod' form factor delivers lower temperatures than cabin saunas — need to verify against the trial-supported range; (2) EMF data not published; (3) UL/ETL certification not clearly visible in product listing; (4) sustainability profile thin. Would move to Verified 70+ with published EMF + temperature range + electrical certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "viconor-infrared-sauna-box-portable-steam-infrared-sauna-with-red-light-therapy-for-body-sauna-tent",
      "title": "Viconor Infrared Sauna Box, Portable Steam Infrared Sauna with Red Light Therapy for Body, Sauna Tent",
      "vendor": "Viconor",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_54.png?v=1786809645",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "viconor",
        "infrared",
        "sauna",
        "box",
        "portable",
        "steam",
        "infrared",
        "sauna",
        "with",
        "red",
        "light",
        "therapy",
        "for",
        "body",
        "sauna",
        "tent",
        "viconor"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 48,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 199,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46740939440325",
      "vsf_explanation": "Portable sauna box with red-light integration. Portable tent-style saunas underdeliver vs the temperature ranges used in the sauna-benefit literature (Laukkanen 2018). 'Viconor' is a generic Amazon brand. Cheap red-light additions typically don't disclose wavelength or irradiance and often deliver sub-therapeutic doses. Would move to Standard 55+ with published EMF, temperature-range, and red-light spec data.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "x-vcak-1-2-person-infrared-sauna-dry-heat-sauna-with-red-light-therapy",
      "title": "X-Vcak 1-2 Person Infrared Sauna, Dry Heat Sauna with Red Light Therapy",
      "vendor": "X-Vcak",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_56.png?v=1786809829",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vcak",
        "person",
        "infrared",
        "sauna",
        "dry",
        "heat",
        "sauna",
        "with",
        "red",
        "light",
        "therapy",
        "vcak"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 48,
        "sustainability": 50
      },
      "price": 1449,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46740949631173",
      "vsf_explanation": "1-2 person cabin infrared sauna from X-Vcak with integrated red-light-therapy panels. Cabin form factor is closer to trial-supported sauna delivery. Combined sauna + red-light is a reasonable formulation choice — both have independent evidence. Held below Verified by (1) 'X-Vcak' is a generic Amazon brand without established sauna manufacturing pedigree; (2) no EMF measurements published (critical for infrared saunas); (3) red-light panel wavelength specs (630nm/810nm and irradiance mW/cm²) not disclosed — cheap red-light panels often deliver 1/10th the therapeutic dose used in RCT literature; (4) no UL/ETL. Would move to Verified 70+ with EMF + red-light irradiance + electrical certifications published.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "x-vcak-upgraded-portable-sauna",
      "title": "X-Vcak Upgraded Portable Sauna",
      "vendor": "X-Vcak",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_58.png?v=1786809973",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vcak",
        "upgraded",
        "portable",
        "sauna",
        "vcak"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 179.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46740958642373",
      "vsf_explanation": "Portable sauna from X-Vcak, budget price. See KASUE Infrared Sauna Tent for the full category rationale — portable sauna tents underdeliver on the temperature range used in the trial literature. 'X-Vcak' generic brand naming, no EMF/UL certification data. Would move to Standard 55+ with temperature-range spec + electrical certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "kasue-infrared-sauna-tent",
      "title": "KASUE Infrared Sauna Tent",
      "vendor": "KASUE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_60.png?v=1786810133",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "kasue",
        "infrared",
        "sauna",
        "tent",
        "kasue"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 179.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46740965654725",
      "vsf_explanation": "Portable infrared sauna tent from KASUE — folding fabric enclosure with an included infrared heating unit. Sauna tents deliver lower internal temperatures than cabin saunas (typically 100-130°F vs 130-170°F), which underdelivers vs the temperature range used in Laukkanen 2018 mortality-benefit cohort research. Held below Standard by (1) 'sauna tent' form factor doesn't match the trial-supported temperature range for cardiovascular benefit; (2) 'KASUE' is a generic Amazon brand; (3) no EMF data, no UL/ETL certification; (4) fabric enclosure is a fire-safety concern with infrared heating elements. Would move to Standard 55+ with published temperature-range spec meeting the sauna-benefit literature threshold + fire-safety certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "kanlanth-1-person-far-infrared-sauna",
      "title": "Kanlanth 1 Person Far Infrared Sauna",
      "vendor": "Kanlanth",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_62.png?v=1786810263",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "kanlanth",
        "person",
        "far",
        "infrared",
        "sauna",
        "kanlanth"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 50,
        "manufacturing": 42,
        "safety": 48,
        "transparency": 42,
        "sustainability": 48
      },
      "price": 499.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46740969259205",
      "vsf_explanation": "1-person far-infrared sauna cabin at budget price point. Sauna therapy evidence base is real. Held below Standard by (1) 'Kanlanth' is an Amazon-tier brand with no established sauna heritage or safety track record; (2) budget infrared saunas are the highest-risk EMF-exposure category — no published EMF measurements from this brand; (3) no infrared wavelength or heater material disclosure; (4) no UL/ETL electrical safety certification visible; (5) below-cost pricing on infrared saunas typically means cheap heating panels with unpredictable output. Sub-Standard until brand publishes EMF/safety data. Would move to Standard 55+ with EMF measurements + electrical safety certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "breezestival-infrared-sauna-for-home",
      "title": "Breezestival Infrared Sauna for Home",
      "vendor": "Breezestival",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitled_design_64.png?v=1786810502",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "breezestival",
        "infrared",
        "sauna",
        "for",
        "home",
        "breezestival"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 1019.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46740977713349",
      "vsf_explanation": "Home infrared sauna from Breezestival, mid-price point. Sauna evidence base is real (Laukkanen 2018). Held below Verified by (1) 'Breezestival' is an Amazon-tier brand without established sauna manufacturing history; (2) no published EMF emissions data (critical for infrared saunas); (3) no infrared wavelength distribution disclosure; (4) no UL/ETL electrical certifications visible; (5) build durability at this price point unpredictable. Would move to Verified 70+ with EMF measurements + electrical certification + heater spec disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "royal-saunas-1-2-person-indoor-far-infrared-luxury-sauna",
      "title": "Royal Saunas 1-2 Person Indoor Far Infrared Luxury Sauna",
      "vendor": "Royal Saunas",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_66.png?v=1786810695",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "royal",
        "saunas",
        "person",
        "indoor",
        "far",
        "infrared",
        "luxury",
        "sauna",
        "royal",
        "saunas"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 1649.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46740983316677",
      "vsf_explanation": "1-2 person indoor far-infrared sauna. Sauna use has real evidence (Laukkanen 2018 mortality reduction with regular use, Hussain & Cohen 2018 review) though most Finnish-cohort studies used traditional saunas, not far-infrared. Held below Verified by (1) 'Royal Saunas' is a small brand with limited track record; (2) EMF (electromagnetic field) emissions data — critical for infrared saunas at close-body distance — not published; (3) heating-plate spec (carbon vs ceramic vs graphene) and infrared wavelength distribution not disclosed at label level; (4) no third-party UL/ETL electrical certification visible. Would move to Verified 70+ with published EMF measurements (targeting <3 mG at body position) + UL/ETL + established build track record.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ice-barrel-500-portable-ice-bath-freestanding-cold-plunge-charcoal-black",
      "title": "Ice Barrel 500 Portable Ice Bath Freestanding Cold Plunge (Charcoal Black)",
      "vendor": "Ice Barrel",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_68.png?v=1786810907",
      "score": 74,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ice",
        "barrel",
        "500",
        "portable",
        "ice",
        "bath",
        "freestanding",
        "cold",
        "plunge",
        "charcoal",
        "black",
        "ice",
        "barrel"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "cold_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 80,
        "manufacturing": 76,
        "safety": 76,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 1799.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46740989313221",
      "vsf_explanation": "Ice Barrel 500 — larger portable freestanding cold plunge from Ice Barrel. Same brand quality and cold-therapy evidence base as the Ice Barrel 300 SKU. Larger volume + portable design fits users who want flexibility to relocate. Held below Elite by same factors as the 300 (chiller not included, sustainability profile thin, higher initial cost). Would move to Elite 85+ with an integrated-chiller variant + published third-party build/durability testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ice-barrel-300-insulated-cold-plunge-tub-built-in-chiller-ports-black",
      "title": "Ice Barrel 300 Insulated Cold Plunge Tub Built-in Chiller Ports (Black)",
      "vendor": "Ice Barrel",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_70.png?v=1786811110",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ice",
        "barrel",
        "300",
        "insulated",
        "cold",
        "plunge",
        "tub",
        "built",
        "chiller",
        "ports",
        "black",
        "ice",
        "barrel"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "cold_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 78,
        "manufacturing": 75,
        "safety": 75,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 1199.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46740996423877",
      "vsf_explanation": "Ice Barrel 300 — from Ice Barrel, one of the established name-brand cold-plunge companies in the space. Insulated tub with chiller ports (chiller sold separately or self-supplied ice/glacier). Cold-water immersion evidence is well-established (Bleakley 2012 meta-analysis on athletic recovery, Yankouskaya 2023 fMRI on mood/emotion regulation). Ice Barrel's build quality track record and warranty terms are documented. Held below Elite by (1) chiller not included — full cost of temperature-controlled ownership is meaningfully higher than the listing suggests; (2) sustainability profile could be stronger; (3) higher initial cost than budget competitors. Would move to Elite 85+ with integrated chiller version + published sustainability certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zonemel-wooden-ice-bath-barrel-tub-1hp-chiller-canadian-red-cedar-cold-plunge-tub",
      "title": "Zonemel Wooden Ice Bath Barrel Tub, 1HP Chiller, Canadian Red Cedar Cold Plunge Tub",
      "vendor": "Zonemel",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_72.png?v=1786811273",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zonemel",
        "wooden",
        "ice",
        "bath",
        "barrel",
        "tub",
        "1hp",
        "chiller",
        "canadian",
        "red",
        "cedar",
        "cold",
        "plunge",
        "tub",
        "zonemel"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "cold_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 50,
        "safety": 68,
        "transparency": 52,
        "sustainability": 58
      },
      "price": 3549.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741006450885",
      "vsf_explanation": "Canadian Red Cedar wooden barrel cold plunge with integrated 1HP chiller. Cold-therapy evidence is solid (Bleakley 2012, Yankouskaya 2023). Wooden barrel form factor has aesthetic appeal and better insulation than plastic tubs, though real cedar sourcing sustainability is a plus. Held below Verified by (1) high price point ($3,550) vs feature parity with $1,000-1,500 competitors makes the premium hard to justify without established brand quality; (2) wooden tubs require ongoing maintenance (mold, oiling) that isn't well-documented in product literature; (3) chiller electrical safety certifications not visible; (4) no track record on chiller reliability at this brand. Would move to Verified 70+ with published maintenance protocol + UL/ETL certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "drexo-cold-plunge-tub-248-gallon-1-horsepower-heavy-duty-ice-bath-tub",
      "title": "Drexo Cold Plunge Tub, 248 Gallon, 1 Horsepower, Heavy-Duty Ice Bath Tub",
      "vendor": "Drexo",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_73.png?v=1786811471",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "drexo",
        "cold",
        "plunge",
        "tub",
        "248",
        "gallon",
        "horsepower",
        "heavy",
        "duty",
        "ice",
        "bath",
        "tub",
        "drexo"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "cold_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 55,
        "manufacturing": 48,
        "safety": 68,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 929.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741010874565",
      "vsf_explanation": "248-gallon cold plunge tub with integrated 1HP chiller from Drexo — Amazon-tier consumer brand at moderate price ($930) undercutting name-brand competitors. Cold-water immersion has real evidence for post-exercise recovery, mood modulation, and inflammation (Bleakley 2012 review, Yankouskaya 2023 fMRI on mood). Chiller-integrated tubs are the correct form factor. Held below Verified by (1) Drexo is a small consumer-electronics brand without established build-quality track record — 1HP chillers at this price point often have durability issues (compressor failures at year 2-3 in review data); (2) no published temperature-hold specs (how tight it can maintain 39-50°F); (3) no third-party electrical safety certification (UL/ETL) visible; (4) warranty terms limited. Would move to Verified 70+ with published temperature specs + UL/ETL certification + longer warranty.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "h2tab-molecular-hydrogen-water-drinking-tablets-30-count-raspberry",
      "title": "H2Tab Molecular Hydrogen Water Drinking Tablets, 30 Count Raspberry",
      "vendor": "H2Tab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_75.png?v=1786812007",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "h2tab",
        "molecular",
        "hydrogen",
        "water",
        "drinking",
        "tablets",
        "count",
        "raspberry",
        "h2tab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741070119109",
      "vsf_explanation": "Flavor variant of H2Tab Molecular Hydrogen Tablets (see the Unflavored SKU for full rationale). Same magnesium + malic acid H2-generation chemistry.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "h2tab-molecular-hydrogen-water-drinking-tablets-30-count-lemon-lime",
      "title": "H2Tab Molecular Hydrogen Water Drinking Tablets, 30 Count Lemon Lime",
      "vendor": "H2Tab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_77.png?v=1786812076",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "h2tab",
        "molecular",
        "hydrogen",
        "water",
        "drinking",
        "tablets",
        "count",
        "lemon",
        "lime",
        "h2tab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741070151877",
      "vsf_explanation": "Flavor variant of H2Tab Molecular Hydrogen Tablets (see the Unflavored SKU for full rationale). Same magnesium + malic acid H2-generation chemistry, same evidence caveats. Flavoring adds non-target ingredients.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "h2tab-molecular-hydrogen-water-drinking-tablets-30-count-unflavored",
      "title": "H2Tab Molecular Hydrogen Water Drinking Tablets, 30 Count Unflavored",
      "vendor": "H2Tab",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_79.png?v=1786812125",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "h2tab",
        "molecular",
        "hydrogen",
        "water",
        "drinking",
        "tablets",
        "count",
        "unflavored",
        "h2tab"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741070250181",
      "vsf_explanation": "Effervescent tablet that dissolves in water to release molecular hydrogen (H2) — magnesium + malic acid reaction chemistry. Molecular hydrogen has real emerging research (Ohta 2012 review in Curr Pharm Des, LeBaron 2019 clinical work) suggesting mild antioxidant / anti-inflammatory effects, but the evidence base is early-stage and effect sizes in RCTs are modest. Held below Verified by (1) product-specific efficacy trials on H2Tab are absent; (2) actual delivered H2 concentration per serving (ppm) varies with water volume + dissolution time — hard to standardize dose per use; (3) H2 is a novel category with FDA-uncleared health claims territory; (4) no third-party testing on record. Would move to Verified 70+ with published dissolution/PK data on this specific tablet + independent efficacy RCT.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "longevity-labs-spermidinelife-supplement-60-capsules",
      "title": "LONGEVITY LABS + spermidineLIFE Supplement, 60 Capsules",
      "vendor": "Longevity Labs+",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_81.png?v=1786812386",
      "score": 73,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "longevity",
        "labs",
        "spermidinelife",
        "supplement",
        "capsules",
        "longevity",
        "labs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 76,
        "formulation": 76,
        "manufacturing": 72,
        "safety": 78,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 7499,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741080834245",
      "vsf_explanation": "Base spermidineLIFE — wheat-germ-derived spermidine at the standardized clinical dose. Same underlying evidence base as the Memory+ SKU (Madeo lab autophagy work, Schwarz 2018 SmartAge trial). This is the reference-formulation spermidine product for the longevity-supplement category. Held below Elite by same limitations as Memory+ (manufacturer-adjacent trials, no public COA, thin sustainability). Would move to Elite 85+ with independent replication + public COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "longevity-labs-spermidinelife-memory-1300mg-supplement-60-capsules",
      "title": "LONGEVITY LABS + spermidineLIFE Memory+ 1300mg Supplement, 60 Capsules",
      "vendor": "Longevity Labs+",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_83.png?v=1786812546",
      "score": 74,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "longevity",
        "labs",
        "spermidinelife",
        "memory",
        "1300mg",
        "supplement",
        "capsules",
        "longevity",
        "labs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 76,
        "formulation": 78,
        "manufacturing": 72,
        "safety": 78,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 129.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741083816133",
      "vsf_explanation": "spermidineLIFE Memory+ is a wheat-germ-derived spermidine product (1300mg total, delivering the standardized spermidine dose used in trial literature) plus B-vitamin cofactors for cognitive claim. Spermidine has an unusually strong evidence base for the longevity space — Madeo/Eisenberg lab (Nature Medicine 2016, Cell Reports 2019) established autophagy induction and lifespan-extension mechanism; Schwarz et al. 2018 SmartAge trial (n=100, 3 months) showed cognitive improvement in memory-impaired older adults using this brand's exact formulation. Held below Elite by (1) trials are LONGEVITY LABS-adjacent (Eisenberg is a scientific advisor); (2) no publicly-posted third-party COA for spermidine content per bottle; (3) sustainability profile thin. Would move to Elite 85+ with independently-replicated trial + public COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "drucker-labs-intramax-liquid-multivitamin-415-nutrients-non-gmo",
      "title": "Drucker Labs intraMAX Liquid Multivitamin, 415+ Nutrients, Non-GMO",
      "vendor": "Drucker Labs",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_85.png?v=1786813104",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "drucker",
        "labs",
        "intramax",
        "liquid",
        "multivitamin",
        "415",
        "nutrients",
        "non",
        "gmo",
        "drucker",
        "labs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 75,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 99.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741089747141",
      "vsf_explanation": "Flagship Drucker Labs product — liquid multivitamin marketing '415+ nutrients' in one formula. Practitioner-brand credibility and liquid delivery help. Held below Verified by (1) '415+ nutrients' is a red flag for sub-therapeutic dosing of each individual nutrient — RCT-effective doses for most vitamins/minerals cannot fit in one liquid serving alongside 400+ others; (2) marketing language ('intraMAX') claims aren't tied to specific clinical endpoints; (3) no public third-party COA. Kitchen-sink multivitamins with 400+ ingredients trade breadth for depth — good baseline nutritional insurance, but shouldn't be relied on for any specific nutrient at RCT-effective levels.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "drucker-labs-intramin-liquid-minerals-and-electrolytes-unflavored-32-fl-oz",
      "title": "Drucker Labs intraMIN Liquid Minerals and Electrolytes, Unflavored,32 fl oz",
      "vendor": "Drucker Labs",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_87.png?v=1786813237",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "drucker",
        "labs",
        "intramin",
        "liquid",
        "minerals",
        "and",
        "electrolytes",
        "unflavored",
        "drucker",
        "labs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 78,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 89.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741093155013",
      "vsf_explanation": "Liquid mineral + electrolyte blend from Drucker Labs. Unflavored version reduces the non-target-ingredient issue vs the kids formula. Liquid delivery generally aids mineral bioavailability. Held below Verified by (1) mineral form disclosure at label level (glycinate vs oxide vs citrate) determines actual absorption and isn't always granular per product; (2) no public third-party COA for elemental mineral content per bottle; (3) 'intraMIN' branding is practitioner marketing rather than measured clinical outcome. Would move to Verified 70+ with per-mineral form + mg disclosure + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "drucker-labs-kids-liquid-multivitamin-with-225-nutrients-32-fl-oz",
      "title": "Drucker Labs Kids Liquid Multivitamin with 225+ Nutrients,32 fl oz",
      "vendor": "Drucker Labs",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_89.png?v=1786813432",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "youth_under_18",
      "tokens": [
        "drucker",
        "labs",
        "kids",
        "liquid",
        "multivitamin",
        "with",
        "225",
        "nutrients",
        "drucker",
        "labs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 78,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 89.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741095514309",
      "vsf_explanation": "Liquid multivitamin from Drucker Labs (David Drucker DC, established practitioner-facing brand), 225+ nutrients in a liquid delivery form aimed at kids. Liquid delivery generally offers better bioavailability than tablets for pediatric populations and difficult-swallowers. Held below Verified by (1) the '225+ nutrients' framing implies each ingredient is at a very small dose — the specific mg/mcg amounts for each are typically not fully disclosed and many end up sub-therapeutic; (2) no public third-party COA (purity/heavy-metals) despite pediatric use where those tests matter most; (3) sweetened liquid formulations add non-target ingredients (glycerin, natural flavors). Would move to Verified 70+ with per-ingredient dose disclosure at label level + published third-party heavy-metals COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "megafood-blood-builder-vegan-iron-supplement-60ct-new",
      "title": "MegaFood Blood Builder Vegan Iron Supplement 60ct - New",
      "vendor": "MegaFood",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/GUEST_48c4ecd1-8181-4e8a-a94b-535833bebfa6.jpg?v=1786817221",
      "score": 86,
      "tier": "elite",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "megafood",
        "blood",
        "builder",
        "vegan",
        "iron",
        "supplement",
        "60ct",
        "new",
        "megafood"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 82,
        "manufacturing": 75,
        "safety": 75,
        "transparency": 72,
        "sustainability": 62
      },
      "price": 17.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741142405317",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score undefined → new 86. Evidence found: D'Adamo CR, Novick JS, Feinberg TM, Dawson VJ, Miller LE. A food-derived dietary supplement containing a low dose of iron improved markers of iron status among nonanemic iron-deficient women. J Am Coll Nutr. 2018;37(4):342-349. DOI:10.1080/07315724.2018.1427158. PMID:29533710. | Milman N, et al. J Perinat Med. 2014;42(2):197-206. | MegaFood B Corp Certification, glyphosate residue-free certification, Non-GMO Project Verified.. Rationale: The vegan version delivers the exact same 26 mg iron + vitamin C + folate + B12 formula that was tested in D'Adamo 2018 - the only difference is the capsule shell material. So the TIER-A brand-anchor RCT applies. Combined with third-party sustainability certifications and the fact that the vegan constituency is often the population most at risk for iron deficiency, this SKU deserves Elite recognition. +10 uplift to 86 Elite. Held below 90 for the same reasons as the flagship: absence of NSF/USP facility certification layered on top of the trial, and iron supplementation still requires prior blood-work confirmation as a safety gate.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "tru-niagen-niagen-300-mg-nikotinamid-ribosid-supplement-for-anti-aging-cellular-energy-support-30-capsules",
      "title": "Tru Niagen - Niagen 300 mg Nikotinamid Ribosid Supplement for Anti-Aging & Cellular Energy Support - 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SLVct1chuFbF52uZm0Zvw6DKtKgiuLONbCqIvXBa.jpg?v=1786817227",
      "score": 78,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tru",
        "niagen",
        "niagen",
        "300",
        "nikotinamid",
        "ribosid",
        "supplement",
        "for",
        "anti",
        "aging",
        "cellular",
        "energy",
        "support",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 82,
        "formulation": 80,
        "manufacturing": 78,
        "safety": 78,
        "transparency": 75,
        "sustainability": 55
      },
      "price": 149,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741142438085",
      "vsf_explanation": "Tru Niagen 300mg — Niagen is ChromaDex's proprietary nicotinamide riboside (NR) with the most extensive human RCT literature of any NAD+ precursor (Martens 2018, Airhart 2017, Trammell 2016 on NAD+ elevation, PK, and safety). Regulatory advantage over NMN: NR has GRAS-affirmed status with FDA. Tru Niagen is the licensed consumer brand with real quality controls and transparent supply chain. 300mg is in the studied dose range. Held below Elite by (1) sold via a third-party reseller — buy direct from Tru Niagen for full brand-quality documentation; (2) sustainability profile thin; (3) higher per-serving cost than generic NAD-precursor products. Would move to Elite 85+ with direct-brand purchase channel + sustainability certification. Higher-scoring product in the NAD+ precursor category vs the NMN alternatives (see /blogs/news/nmn-gmp-certified-what-to-check-buyers-guide for the full NR-vs-NMN discussion).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "happy-liver",
      "title": "Happy Liver",
      "vendor": "Happy Healthy You",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HHY-Liver60.jpg?v=1786817235",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "happy",
        "liver",
        "happy",
        "healthy",
        "you"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 65,
        "transparency": 52,
        "sustainability": 45
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741142470853",
      "vsf_explanation": "Happy Liver supplement — liver-support formula, typical actives are milk thistle + NAC + other hepatoprotective ingredients. Same limitations as Happy Sleep — need to see specific ingredients + doses. Held below Verified for same category reasons.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "happy-sleep",
      "title": "Happy Sleep",
      "vendor": "Happy Healthy You",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HHY-Sleep60.jpg?v=1786817258",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "happy",
        "sleep",
        "happy",
        "healthy",
        "you"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 58,
        "manufacturing": 50,
        "safety": 68,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741142536389",
      "vsf_explanation": "Happy Sleep supplement from Happy Healthy You (small AU/US wellness brand). Sleep-supplement category evidence typically anchors on magnesium glycinate, melatonin, L-theanine, valerian — need to know specific ingredients + doses to score properly. Held below Verified by (1) product name doesn't disclose active ingredients; (2) small brand without prominent third-party testing; (3) sleep-supplement blends often sub-therapeutic on individual ingredients. Would move to Verified 70+ with per-ingredient dose disclosure at label + third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "novaferrum-pediatric-drops-liquid-iron-supplement-raspberry-grape",
      "title": "NovaFerrum Pediatric Drops, Liquid Iron Supplement Raspberry Grape",
      "vendor": "NovaFerrum",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/341937748.jpg?v=1786817271",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "novaferrum",
        "pediatric",
        "drops",
        "liquid",
        "iron",
        "supplement",
        "raspberry",
        "grape",
        "novaferrum"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 78,
        "manufacturing": 68,
        "safety": 68,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 31.93,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741142634693",
      "vsf_explanation": "NovaFerrum Pediatric Drops — polysaccharide iron complex in pediatric-dose liquid drops with kid-appropriate raspberry/grape flavoring. Iron supplementation in pediatric iron-deficiency anemia is one of the most-studied nutritional interventions; NovaFerrum is a legitimate pediatric-iron brand recommended by pediatric practitioners. Held below Elite by (1) pediatric iron dosing MUST be prescribed/monitored by pediatrician — parent self-supplementation without guidance is a real risk; (2) sold via pharmacy reseller; (3) iron overdose in children is a leading cause of pediatric poisoning — child-resistant packaging + prominent poison-control warnings should be verified. Would move to Elite 85+ with pediatrician-monitoring warning language + poison-control number prominently displayed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "novaferrum-125-high-potency-liquid-iron-supplement-for-adults-6-fl-oz",
      "title": "NovaFerrum 125 High Potency Liquid Iron Supplement For Adults, 6 Fl Oz",
      "vendor": "NovaFerrum",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/339207972_1c5a2622-26f9-40d3-8240-ea4991cd6cdd.jpg?v=1786817280",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "novaferrum",
        "125",
        "high",
        "potency",
        "liquid",
        "iron",
        "supplement",
        "for",
        "adults",
        "novaferrum"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 75,
        "manufacturing": 68,
        "safety": 62,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 26.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741142732997",
      "vsf_explanation": "NovaFerrum liquid iron — polysaccharide-iron complex form. Iron polysaccharide has better GI tolerance than ferrous sulfate at comparable elemental iron doses (Powers 2017). Liquid delivery aids adherence and allows flexible dosing. 125 mg elemental iron per dose is at the upper end of therapeutic range for adult iron-deficiency treatment. Held below Verified by (1) iron supplementation without prior serum ferritin/iron panel workup is a safety concern — the label warning language could be stronger; (2) sold via pharmacy reseller; (3) 125mg is above what's needed for repletion in most cases and could cause over-supplementation risk. Would move to Verified 70+ with prominent 'confirm iron deficiency via lab test first' warning + lower-dose SKU option.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrafol-womens-vegan-3-month-pack",
      "title": "NUTRAFOL WOMENS VEGAN 3 MONTH PACK",
      "vendor": "NUTRAFOL @ NYALLERGY",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/VeganGrowthPack.jpg?v=1786817290",
      "score": 78,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrafol",
        "womens",
        "vegan",
        "month",
        "pack",
        "nutrafol",
        "nyallergy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 78,
        "manufacturing": 72,
        "safety": 72,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 209,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741142929605",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 75 → new 78. Evidence found: Ablon G, Kogan S. A Six-Month, Randomized, Double-Blind, Placebo-Controlled Study Evaluating the Safety and Efficacy of a Nutraceutical Supplement for Promoting Hair Growth in Women With Self-Perceived Thinning Hair. J Drugs Dermatol. 2019;18(1):55-59.. Rationale: Nutrafol Women's Vegan uses a plant-based reformulation (removing marine collagen, substituting with pea protein and other plant sources) while preserving core actives at studied doses (saw palmetto, ashwagandha Sensoril, curcumin, tocotrienols). The pivotal Ablon 2019 Women's RCT applies as bridging evidence for the reformulation, though direct vegan-formula RCT has not been published. Modest uplift to 78 acknowledges evidence transfer without full formula validation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrex-creatine-monohydrate-60-servings",
      "title": "Nutrex Creatine Monohydrate, 60 Servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/nutrex-creatine-60-servings..webp?v=1786817317",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrex",
        "creatine",
        "monohydrate",
        "servings",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 82,
        "formulation": 72,
        "manufacturing": 58,
        "safety": 78,
        "transparency": 65,
        "sustainability": 45
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741143027909",
      "vsf_explanation": "Nutrex Creatine Monohydrate — one of the most-studied supplements in the entire literature (Kreider 2017 ISSN position stand: strength/muscle mass improvements at 3-5g/day, extensive safety profile). Monohydrate is the reference form used in virtually all creatine RCTs. Held below Verified by (1) not Creapure® branded (Creapure is the German reference-quality creatine with the most third-party testing; unbranded creatine can have creatinine and dicyandiamide impurities); (2) sold via a third-party reseller — Nutrex direct quality documentation less accessible; (3) no NSF Certified for Sport designation visible. Would move to Verified 70+ with Creapure® or micronized-Creapure sourcing + NSF sport cert.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "b-sync-on-kafein-dietary-supplement-for-energy-boost-with-caffeine-vitamin-b12-and-zinc",
      "title": "B-Sync On Kafein - Dietary Supplement for Energy Boost with Caffeine, Vitamin B12, and Zinc",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/75dO9iGbMyFPyfSwxUDLYTQhlzJGtK9QHyeYgLwI.jpg?v=1786817327",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sync",
        "kafein",
        "dietary",
        "supplement",
        "for",
        "energy",
        "boost",
        "with",
        "caffeine",
        "vitamin",
        "b12",
        "and",
        "zinc",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 48,
        "safety": 68,
        "transparency": 48,
        "sustainability": 45
      },
      "price": 19.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741143093445",
      "vsf_explanation": "Caffeine + B12 + zinc energy blend. Each active has real evidence individually. Held below Verified by (1) per-active dose not visible in product name — caffeine dose is safety-critical and should be prominently disclosed; (2) sold via a third-party reseller — quality trace layered; (3) B-vitamin + zinc addition to caffeine is standard energy-drink formulation without unique differentiation. Would move to Verified 70+ with prominent caffeine mg disclosure + third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "premium-berberine-supplement-non-gmo-gluten-free",
      "title": "Premium Berberine Supplement, Non-GMO, Gluten-Free",
      "vendor": "FreshDrinkUS - Natural and Premium Herbal Tea",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71ehGRNRUBL._AC_SL1500.jpg?v=1786817344",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "premium",
        "berberine",
        "supplement",
        "non",
        "gmo",
        "gluten",
        "free",
        "freshdrinkus",
        "natural",
        "and",
        "premium",
        "herbal",
        "tea"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 52,
        "safety": 62,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741143126213",
      "vsf_explanation": "Berberine supplement from FreshDrinkUS. Berberine has strong RCT evidence for HbA1c reduction, LDL lowering, and blood-sugar management (Yin 2008 comparable to metformin at 500mg × 3/day). Held below Verified by (1) per-cap mg not disclosed in product name — studied dose is 500mg × 2-3/day; (2) small brand without prominent third-party testing; (3) berberine drug interactions warrant stronger warnings (cyclosporine, statins, some antihypertensives). Would move to Verified 70+ with dose disclosure + interaction warnings + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "florastor-dual-action-probiotic-supplement-vegetarian-capsules-20ct",
      "title": "Florastor Dual Action Probiotic Supplement Vegetarian Capsules 20Ct",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/308743733_24cfae3b-84bb-4180-b932-1984c2605f9b.jpg?v=1786817360",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "florastor",
        "dual",
        "action",
        "probiotic",
        "supplement",
        "vegetarian",
        "capsules",
        "20ct",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 75,
        "manufacturing": 72,
        "safety": 72,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 20.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741143158981",
      "vsf_explanation": "Florastor — Saccharomyces boulardii CNCM I-745 (the specific yeast-strain probiotic). Unusually strong evidence base for this specific strain: real RCT support for antibiotic-associated diarrhea (Szajewska 2015 meta-analysis), traveler's diarrhea, C. difficile prevention, and IBD. Yeast (vs bacterial) probiotic profile means it survives antibiotic use without being killed. Established brand with the specific strain identified on-label. Held below Elite by (1) sold via pharmacy reseller vs direct-from-Biocodex; (2) sustainability profile thin; (3) sold in small 20-count blister packs — cost-per-serving high vs bulk formats. Would move to Elite 85+ with direct-brand purchase channel + sustainability disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrex-l-carnitine-3000-31-servings",
      "title": "Nutrex L-Carnitine 3000, 31 Servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Picture3_c1b38064-73ce-4f31-9b97-ecdf00210b35.jpg?v=1786817404",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrex",
        "carnitine",
        "3000",
        "servings",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 12.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741143355589",
      "vsf_explanation": "L-Carnitine liquid at 3000mg per serving. L-Carnitine has real cardiovascular evidence (DiNicolantonio 2013 meta-analysis, particularly post-MI) and modest ergogenic data. 3000mg is in the studied dose range. Liquid delivery is a formulation plus for bioavailability. Held below Verified by (1) Nutrex mid-tier brand; (2) sold via reseller; (3) no third-party testing visible. Would move to Verified 70+ with third-party assay + NSF sport cert.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrex-anabol-hardcore-60-caps",
      "title": "Nutrex Anabol Hardcore, 60 Caps",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Anabol-Hardcore-2024-FR.webp?v=1786817415",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrex",
        "anabol",
        "hardcore",
        "caps",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 42,
        "manufacturing": 55,
        "safety": 45,
        "transparency": 32,
        "sustainability": 40
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741143519429",
      "vsf_explanation": "Nutrex Anabol Hardcore — sports-performance/testosterone-support formula. Auto-fail: proprietary_blend_hides_dose. 'Anabol Hardcore' is exactly the branded-blend positioning that hides per-ingredient content behind a proprietary label; users cannot verify whether any ingredient is at studied dose. Additionally: 'anabolic' branding implies muscle-anabolic-hormone activity that most supplement compounds cannot deliver — implied efficacy claim exceeds evidence. Would move to Standard 55+ with per-ingredient mg disclosure + removal of implied anabolic-hormone-agonist claims.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "nusapure-vitamin-b5-pantothenic-acid-1-200mg-per-serving-100-caps-vegetarians-vegans-non-gmo-dietary-supplement",
      "title": "NusaPure Vitamin B5 Pantothenic Acid 1,200mg Per Serving 100 Caps Vegetarians Vegans, Non-GMO Dietary Supplement",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4084ea05.jpg?v=1786817448",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "vitamin",
        "pantothenic",
        "acid",
        "200mg",
        "per",
        "serving",
        "100",
        "caps",
        "vegetarians",
        "vegans",
        "non",
        "gmo",
        "dietary",
        "supplement",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 62,
        "sustainability": 45
      },
      "price": 16.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741143683269",
      "vsf_explanation": "Pantothenic acid (Vitamin B5) 1200mg per serving. B5 has real evidence for acne (Yang 2014 trial at 2200mg/day) and adrenal cortisol support. 1200mg is above the RDA (5mg) but well below toxicity threshold. Held below Verified by NusaPure quality tier + no third-party assay + acne dose is ~2200mg (double this SKU's per-serving).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "allmax-cytogreens-60-servings",
      "title": "AllMax CytoGreens, 60 Servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/allmax_cytogreens_60servings..jpg?v=1786817484",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "allmax",
        "cytogreens",
        "servings",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741143781573",
      "vsf_explanation": "AllMax CytoGreens — greens/superfood powder for antioxidant support. AllMax is a sports-nutrition brand. Greens powders have modest evidence — most contain sub-therapeutic doses of any single ingredient. Held below Verified by (1) proprietary-blend disclosure is common in greens formulas, obscuring per-ingredient dose; (2) sold via a third-party reseller adds a middleman-layer to quality trace; (3) 'CytoGreens' branding vs the substance-per-serving reality often doesn't match. Would move to Verified 70+ with per-ingredient breakdown + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-womens-multi-vitamins-minerals-lab-tested-60-tablets-non-gmo-dietary-supplement",
      "title": "NusaPure Women's Multi Vitamins & Minerals, Lab Tested 60 Tablets Non-GMO Dietary Supplement",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/879d0ff8.jpg?v=1786817495",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "women",
        "multi",
        "vitamins",
        "minerals",
        "lab",
        "tested",
        "tablets",
        "non",
        "gmo",
        "dietary",
        "supplement",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741143847109",
      "vsf_explanation": "NusaPure Women's multivitamin. Budget mass-market positioning. General multivitamin evidence for women's baseline nutritional insurance is modest but real. Held below Verified by (1) budget-brand formulation typically uses lowest-cost forms (folic acid vs 5-MTHF; cyanocobalamin vs methylcobalamin; magnesium oxide vs glycinate); (2) 'lab tested' claim without visible third-party COA; (3) NusaPure quality tier. Would move to Verified 70+ with bioactive-form reformulation + USP or NSF certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "health-care-products-oregano-oil-capsule-dietary-supplement-soft-capsules",
      "title": "Health Care Products Oregano Oil Capsule Dietary Supplement Soft Capsules",
      "vendor": "My Store",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/163d4fb6-246d-4850-9ace-d0bb08f1f4a5.jpg?v=1786817540",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "health",
        "care",
        "products",
        "oregano",
        "oil",
        "capsule",
        "dietary",
        "supplement",
        "soft",
        "capsules",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 37.71,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741144174789",
      "vsf_explanation": "Oregano oil softgels — generic 'Health Care Products' branding via 'My Store' vendor. Below Standard by (1) 'My Store' vendor + 'Health Care Products' branding = generic dropship listing with no manufacturer identity — triggers no_brand_provenance concern; (2) carvacrol content (oregano's primary antimicrobial active) not disclosed at label; (3) oregano oil has real drug interactions (anticoagulant effect) and shouldn't be taken without safety-warning language; (4) no third-party testing. Would move to Standard 55+ with named manufacturer + carvacrol standardization + safety warnings.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "powerful-cranberry-gummies-with-d-mannose-urinary-tract-health-fast-acting-bladder-support-supplement-60-count",
      "title": "Powerful Cranberry Gummies  with D-Mannose - Urinary Tract Health - Fast-Acting Bladder Support Supplement - 60 Count",
      "vendor": "The VITAMIZED Shop",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/VitamizedUrinary_Gummies_cae716f0-2be2-41f6-a654-eb78a54a700a.png?v=1786817562",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "powerful",
        "cranberry",
        "gummies",
        "with",
        "mannose",
        "urinary",
        "tract",
        "health",
        "fast",
        "acting",
        "bladder",
        "support",
        "supplement",
        "count",
        "the",
        "vitamized",
        "shop"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 55,
        "manufacturing": 48,
        "safety": 68,
        "transparency": 48,
        "sustainability": 45
      },
      "price": 29.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741144240325",
      "vsf_explanation": "Cranberry + D-mannose gummies for UTI prevention. Both actives have real evidence for UTI-recurrence prevention (Kranjcec 2014 on D-mannose 2g/day comparable to nitrofurantoin). Held below Verified by (1) per-active mg not disclosed — D-mannose therapeutic doses are 2000mg/day, difficult to hit with gummy format; (2) 'fast-acting bladder support' marketing implies acute-treatment claim vs the studied prevention use; (3) generic vendor. Would move to Verified 70+ with per-active dose disclosure + honest positioning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "beet-root-extreme-gummies-with-coq10-60-count",
      "title": "Beet Root Extreme Gummies with CoQ10, 60 Count",
      "vendor": "The VITAMIZED Shop",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/VitamizedUrinary_Gummies_4f2a49cd-cf33-4efb-8a94-94ce0b5d554d.png?v=1786817564",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beet",
        "root",
        "extreme",
        "gummies",
        "with",
        "coq10",
        "count",
        "the",
        "vitamized",
        "shop"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 52,
        "manufacturing": 48,
        "safety": 65,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 25.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741144273093",
      "vsf_explanation": "Beet root + CoQ10 gummies. Both actives have real cardiovascular evidence; gummy format limits per-serving active dose (typically 30-60% of what capsule format delivers at similar cost). Held below Verified by (1) beet nitrate and CoQ10 mg per gummy not disclosed at product name level; (2) a generic reseller vendor without established quality signals; (3) gummy sweetener/binder content dilutes active-ingredient positioning. Would move to Verified 70+ with per-active dose disclosure + third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natural-factors-cranrich-super-strength-cranberry-concentrate-500-mg-capsules",
      "title": "Natural Factors CranRich Super Strength Cranberry Concentrate 500 Mg Capsules",
      "vendor": "Natural Factors",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/196331738.jpg?v=1786817578",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "natural",
        "factors",
        "cranrich",
        "super",
        "strength",
        "cranberry",
        "concentrate",
        "500",
        "capsules",
        "natural",
        "factors"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 72,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741144338629",
      "vsf_explanation": "Natural Factors CranRich 500mg — Natural Factors is an established Canadian supplement brand with real GMP standards. Cranberry PAC (proanthocyanidin) has real evidence for UTI prevention (Jepson 2012 Cochrane review — effect signal exists though modest). 500mg concentrate is in the studied dose range. Held below Verified by (1) PAC standardization (36mg PACs is the studied threshold per Nutricap Labs recommendations) should be disclosed at label; (2) sold via a pharmacy reseller — Natural Factors' own quality documentation may be layered behind the reseller listing; (3) sustainability profile thin. Would move to Verified 70+ with PAC standardization + Natural Factors direct third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nmn-supplement-pure-capsules-boost-energy-fight-aging-revivpro",
      "title": "NMN Supplement Pure Capsules – Boost Energy & Fight Aging | RevivPro",
      "vendor": "RevivPro",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/nmn-supplement-pure-capsules-boost-energy-fight-aging-revivpro-2139260.png?v=1786817654",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nmn",
        "supplement",
        "pure",
        "capsules",
        "boost",
        "energy",
        "fight",
        "aging",
        "revivpro",
        "revivpro"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741145354437",
      "vsf_explanation": "$9.99 NMN supplement from RevivPro. Held below Standard by (1) $9.99 price is well below cost of goods for legitimate NMN — genuine NMN raw material sells wholesale at $500-1500/kg, meaning a real 500mg × 60 cap product costs $15-45 in raw material alone; (2) 'boost energy, fight aging' marketing without specific dose or purity claims; (3) NMN at this price point commonly is undelivered or partially substituted with nicotinamide (documented pattern in independent testing); (4) RevivPro is not primarily an NMN specialist. See /blogs/news/nmn-gmp-certified-what-to-check-buyers-guide for the full quality-check framework — this SKU fails most of the criteria. Would move to Standard 55+ with credible price-to-cost ratio + third-party assay.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "revivpro-red-light-therapy-hair-growth-cap",
      "title": "RevivPro Red Light Therapy Hair Growth Cap",
      "vendor": "RevivPro",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/revivpro-red-light-therapy-hair-growth-cap-9825179.png?v=1786817658",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "revivpro",
        "red",
        "light",
        "therapy",
        "hair",
        "growth",
        "cap",
        "revivpro"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 58,
        "manufacturing": 48,
        "safety": 65,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 80,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741145387205",
      "vsf_explanation": "Red light therapy cap marketed for hair growth. Low-level laser therapy (LLLT) has real FDA-cleared efficacy for androgenetic alopecia (Adil 2017 meta-analysis, multiple FDA 510(k)-cleared LLLT caps). Held below Verified by (1) $80 price point is well below FDA-cleared LLLT caps ($500-1500) — cheap LED-based caps typically don't hit therapeutic irradiance; (2) no FDA clearance visible for this specific product; (3) wavelength (must be 630-680nm for hair benefit) and irradiance spec not disclosed; (4) RevivPro budget brand vs iRestore/Theradome/CapillusRx established players. Would move to Verified 70+ with FDA clearance + wavelength/irradiance specs matching therapeutic literature.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "rred-fka-rocket-red",
      "title": "RRED - FKA Rocket Red",
      "vendor": "Carborocket",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/866F9830-0078-4E7E-A662-6646E3791968.png?v=1786817679",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "rred",
        "fka",
        "rocket",
        "red",
        "carborocket"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 36.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741146009797",
      "vsf_explanation": "Carborocket RRED — endurance-athletic hydration/carbohydrate formula. Carborocket is a smaller endurance-sports brand. Ingredient disclosure typical of endurance nutrition (carbs, electrolytes, sometimes caffeine). Held below Verified by (1) small brand without prominent third-party testing; (2) 'FKA Rocket Red' name change indicates recent rebrand — Formulation stability across rebrand not always documented; (3) sports-nutrition category standards (NSF Certified for Sport, Informed Sport) not visible. Would move to Verified 70+ with sports-cert + third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nmn-capsules-900mg",
      "title": "NMN Capsules 900mg",
      "vendor": "Neurogan Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NeuroganHealth_NMN_Capsules_900mg_90ct_Front_Shadow.jpg?v=1786817702",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nmn",
        "capsules",
        "900mg",
        "neurogan",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 70,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 70,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741146108101",
      "vsf_explanation": "Neurogan Health high-dose NMN 900mg. Above the anchor trial doses (Yoshino 2021 250mg, Mills 2016 up to 500mg) — 900mg has some higher-dose data supporting continued NAD+ elevation without proportional side-effect increase. Held below Verified by same NMN category limitations (no visible third-party COA, FDA 2022 regulatory position, manufacturing details limited). Neurogan brand tier + higher-dose positioning gives this a slight edge over the 500mg SKU.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nmn-capsules-500mg",
      "title": "NMN Capsules 500MG",
      "vendor": "Neurogan Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/01_Product_2bb9682e-8b11-49c1-a897-d8639a8d5244.jpg?v=1786817714",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nmn",
        "capsules",
        "500mg",
        "neurogan",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741146140869",
      "vsf_explanation": "Neurogan Health standard NMN 500mg capsules. 500mg is in the studied dose range (Yoshino 2021 used 250mg; Mills 2016 dose-escalated to 500mg). Neurogan brand credibility. Held below Verified by (1) no third-party NMN purity/content COA visible; (2) FDA 2022 regulatory position applies; (3) manufacturing facility identification/GMP details not prominent in product listing. Would move to Verified 70+ with third-party assay + named GMP facility.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liposomal-nmn-capsules",
      "title": "Liposomal NMN Capsules",
      "vendor": "Neurogan Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NeuroganHealth_Liposomal-NMNCapsules_700mg_Front_Shadow.jpg?v=1786817719",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liposomal",
        "nmn",
        "capsules",
        "neurogan",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 72,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 50,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741146173637",
      "vsf_explanation": "Neurogan Health Liposomal NMN — Neurogan is an established hemp/CBD wellness brand with real quality track record expanding into NMN. Liposomal delivery is a real formulation plus for NMN — the compound is water-soluble and unstable to gastric acid; liposomal encapsulation improves bioavailability and stability. Held below Verified by (1) NMN dose per capsule not clear from product name (some Neurogan NMN SKUs specify 500mg or 900mg but 'Liposomal NMN' doesn't); (2) third-party COA for actual NMN content post-encapsulation not visible; (3) FDA 2022 NMN regulatory position applies. Would move to Verified 70+ with dose disclosure + third-party liposomal-NMN assay.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "659-nmn-capsules-500mg-60-counts",
      "title": "659 NMN capsules - 500mg (60 Counts)",
      "vendor": "Marathon Ginseng",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_7fdbeb58-825f-41b5-9232-101fc1304dc6.jpg?v=1786817732",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "659",
        "nmn",
        "capsules",
        "500mg",
        "counts",
        "marathon",
        "ginseng"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 42,
        "safety": 55,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 75,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741146206405",
      "vsf_explanation": "Generic NMN 500mg from Marathon Ginseng. NMN evidence base is real (Martens 2018, Yoshino 2021) at 250-1000mg dose range. Held below Standard by (1) 'Marathon Ginseng' as an NMN vendor suggests non-specialist positioning — ginseng-focused brand branching into NMN typically without the NMN-specific quality controls; (2) no third-party COA for NMN purity or content verification; (3) no GMP certification disclosed; (4) NMN products in this quality tier commonly have documented label-accuracy issues (see our /blogs/news/nmn-gmp-certified-what-to-check-buyers-guide post for the full quality-check framework). Would move to Standard 55+ with GMP + third-party COA + named manufacturer.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "complete-home-sauna-starter-bundle-kit-steam-sauna-sauna-heater",
      "title": "Complete Home Sauna Starter Bundle Kit – Steam Sauna + Sauna Heater",
      "vendor": "RevivPro",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/complete-home-sauna-starter-bundle-kit-steam-sauna-sauna-heater-9588659.png?v=1786817751",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "complete",
        "home",
        "sauna",
        "starter",
        "bundle",
        "kit",
        "steam",
        "sauna",
        "sauna",
        "heater",
        "revivpro"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 48,
        "manufacturing": 42,
        "safety": 48,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 150,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741146271941",
      "vsf_explanation": "Starter bundle: portable steam sauna + heater at $150. Combines the two lowest-scoring recovery form-factors from RevivPro's line (see Portable Steam Sauna Box + Sauna Heater rationale for individual scoring). Bundle price is reasonable but the underlying limitations of both components carry through. Would move to Standard 55+ with UL/ETL + trial-appropriate temperature specs on both components.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sauna-heater-1500w-ceramic-carbon-quickheat®-with-remote",
      "title": "Sauna Heater – 1500W Ceramic Carbon QuickHeat® with Remote",
      "vendor": "RevivPro",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/sauna-heater-1500w-ceramic-carbon-quickheat-with-remote-1538606.png?v=1786817755",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sauna",
        "heater",
        "1500w",
        "ceramic",
        "carbon",
        "quickheat",
        "with",
        "remote",
        "revivpro"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 78,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741146304709",
      "vsf_explanation": "1500W ceramic-carbon sauna heater unit — component product for DIY/replacement sauna installations. Ceramic + carbon heating is an older technology than graphene (higher EMF, less uniform emission). Held below Verified by (1) EMF measurements not published; (2) UL/ETL electrical safety not confirmed; (3) $78 price for 1500W heater is very low — quality/durability at this price tier is unpredictable. Would move to Verified 70+ with UL/ETL + EMF + published output spec.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "extra-large-ice-bath-tub-x-pro-water-chiller-compatible-cold-plunge-for-athletes",
      "title": "Extra Large Ice Bath Tub X Pro - Water Chiller Compatible Cold Plunge for Athletes",
      "vendor": "RevivPro",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/extra-large-ice-bath-tub-x-pro-water-chiller-compatible-cold-plunge-for-athletes-4114987.png?v=1786817765",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "extra",
        "large",
        "ice",
        "bath",
        "tub",
        "pro",
        "water",
        "chiller",
        "compatible",
        "cold",
        "plunge",
        "for",
        "athletes",
        "revivpro"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "cold_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 188,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741146370245",
      "vsf_explanation": "Extra-large athlete-focused ice bath variant from RevivPro, $188. Larger volume = better temperature stability during use, easier full-body immersion. Same cold-therapy evidence base. Held below Verified by budget-brand manufacturing tier + missing detailed insulation/temperature specs.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "portable-ice-bath-tub-pro-water-chiller-compatible-cold-plunge-easy-recovery-solution",
      "title": "Portable Ice Bath Tub Pro - Water Chiller Compatible Cold Plunge Easy Recovery Solution",
      "vendor": "RevivPro",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/portable-ice-bath-tub-pro-water-chiller-compatible-cold-plunge-easy-recovery-solution-2934936.png?v=1786817772",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "portable",
        "ice",
        "bath",
        "tub",
        "pro",
        "water",
        "chiller",
        "compatible",
        "cold",
        "plunge",
        "easy",
        "recovery",
        "solution",
        "revivpro"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "cold_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 52,
        "safety": 68,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 148,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741146403013",
      "vsf_explanation": "Upgraded 'Pro' variant of RevivPro ice bath, chiller-compatible. Mid-price tier ($148). Same evidence base as other cold-plunge products; slightly better build spec vs the base RevivPro variant.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "red-light-therapy-sauna-half-price-of-399-saunapro-revivpro",
      "title": "Red Light Therapy Sauna · Half Price of $399 SaunaPro | RevivPro",
      "vendor": "RevivPro",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/portable-steam-sauna-box-with-skin-care-red-light-2482760.png?v=1786817784",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "light",
        "therapy",
        "sauna",
        "half",
        "price",
        "399",
        "saunapro",
        "revivpro",
        "revivpro"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 52,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 176,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741148532933",
      "vsf_explanation": "Combined sauna + red light therapy unit at $176. Both modalities have real evidence individually; combined delivery is reasonable formulation. Held below Verified by (1) budget price point makes trial-comparable specs unlikely (both sauna temperature and red light irradiance need real specifications for effect); (2) 'half price of $399 SaunaPro' marketing framing suggests generic product with promotional positioning; (3) no EMF, no red-light spec, no UL/ETL disclosed. Would move to Verified 70+ with EMF + red-light irradiance + temperature spec + electrical certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "portable-steam-sauna-box-with-steamer",
      "title": "Portable Steam Sauna Box with Steamer",
      "vendor": "RevivPro",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/portable-steam-sauna-box-with-steamer-7616814.png?v=1786817791",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "portable",
        "steam",
        "sauna",
        "box",
        "with",
        "steamer",
        "revivpro"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 48,
        "manufacturing": 42,
        "safety": 48,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741148958917",
      "vsf_explanation": "Portable steam sauna box at $99. Steam sauna delivers lower temperatures than trial-supported dry-sauna range (Laukkanen 2018 cohort used 80-100°C). Portable box + budget steamer form-factor typically caps at 45-55°C — below thermal-stress threshold for cardiovascular adaptation. Held below Standard by (1) form-factor doesn't reach trial-supported temperature range; (2) electrical safety on budget steam units is a real concern (steam + electrical elements + fabric enclosure); (3) no UL/ETL certification visible. Would move to Standard 55+ with electrical certification + published temperature-range spec.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "portable-oval-ice-bath-tub-x-with-extra-length-water-chiller-compatible-cold-plunge",
      "title": "Portable Oval Ice Bath Tub X with Extra Length - Water Chiller Compatible Cold Plunge",
      "vendor": "RevivPro",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/portable-oval-ice-bath-tub-x-with-extra-length-water-chiller-compatible-cold-plunge-4461858.png?v=1786817796",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "portable",
        "oval",
        "ice",
        "bath",
        "tub",
        "with",
        "extra",
        "length",
        "water",
        "chiller",
        "compatible",
        "cold",
        "plunge",
        "revivpro"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "cold_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 58,
        "manufacturing": 50,
        "safety": 68,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741149024453",
      "vsf_explanation": "Oval portable ice bath with extra length, chiller port compatible. RevivPro budget-tier build. Same evidence/rationale as the foldable SKU. Chiller-port compatibility is a plus for users who add a chiller separately.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "foldable-ice-bath-tub-no-pole-no-pump-60-second-setup-revivpro",
      "title": "Foldable Ice Bath Tub — No Pole, No Pump, 60-Second Setup | RevivPro",
      "vendor": "RevivPro",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/portable-foldable-ice-bath-tub-water-chiller-compatible-cold-plunge-for-recovery-and-wellness-8012924.jpg?v=1786817803",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "foldable",
        "ice",
        "bath",
        "tub",
        "pole",
        "pump",
        "second",
        "setup",
        "revivpro",
        "revivpro"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "cold_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 58,
        "manufacturing": 50,
        "safety": 68,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741149057221",
      "vsf_explanation": "Portable foldable ice bath tub — no pole, no pump, quick-setup. Cold-water immersion evidence base (Bleakley 2012, Yankouskaya 2023) applies. $79 price point is budget-tier — no chiller included, user supplies ice/water manually. RevivPro is a small consumer-tier brand. Held below Verified by (1) build durability at this price tier unpredictable; (2) no published temperature-hold or insulation spec; (3) small brand without established recovery-device track record. Would move to Verified 70+ with build/durability testing + published insulation spec.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "game-ready-grpro-2-1",
      "title": "Game Ready GRPro 2.1",
      "vendor": "Your Health Sanctuary",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/game-ready-grpro-2-1-cold-and-compression-therapy-unit_556x556_c5944d5c-8f85-45c4-9f4f-ef9d04e1540a.webp?v=1786817884",
      "score": 82,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "game",
        "ready",
        "grpro",
        "your",
        "health",
        "sanctuary"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "cold_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 82,
        "formulation": 85,
        "manufacturing": 82,
        "safety": 78,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 3037.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741202370757",
      "vsf_explanation": "Game Ready GRPro 2.1 — reference-standard cold + intermittent compression system used across professional-sports medicine, physical therapy clinics, and post-surgical rehab. Real FDA clearance (Class II medical device). Substantial published clinical evidence for combined cryo + compression in orthopedic recovery (Waterman 2012 knee-arthroscopy trials, Kraeutler 2015 shoulder studies). $3,000+ price point reflects true medical-grade device positioning. Highest-scoring cold-therapy product in the Vyvata catalog. Held below Elite by (1) sustainability profile thin (high-water-consumption device); (2) product-page-level 510(k) K-number should be verifiable; (3) rental vs purchase pathway not always clear to consumer buyers. Would move to Elite 85+ with sustainability data + explicit clearance number + rental-vs-buy guidance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ultimate-foot-relief-kit",
      "title": "Ultimate Foot Relief Kit",
      "vendor": "Your Health Sanctuary",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ImageFeb3_2026_10_58_52AM.png?v=1786817891",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ultimate",
        "foot",
        "relief",
        "kit",
        "your",
        "health",
        "sanctuary"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "compression_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 72,
        "manufacturing": 65,
        "safety": 70,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 3100,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741202403525",
      "vsf_explanation": "Multi-component foot-relief kit ($3,100) from Your Health Sanctuary. High price point suggests medical-grade componentry. Held below Verified by (1) individual component identification not clear from title — need to know what specifically is in the kit to score against dimension standards; (2) no clear FDA clearance history on record as a specific device system; (3) sustainability + specific formulation dimensions unclear without full component breakdown. Would move to Verified 70+ with itemized kit contents + individual component clearances.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "8-chamber-system-pumps-bio-compression-sc-2008-dl",
      "title": "8 Chamber System Pumps Bio Compression SC-2008-DL",
      "vendor": "Your Health Sanctuary",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/G8-3045_2008DL_Cliff_0046.jpg?v=1786817902",
      "score": 76,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chamber",
        "system",
        "pumps",
        "bio",
        "compression",
        "2008",
        "your",
        "health",
        "sanctuary"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "compression_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 82,
        "manufacturing": 75,
        "safety": 75,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 900,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741202796741",
      "vsf_explanation": "Bio Compression SC-2008-DL — medical-grade 8-chamber sequential compression pump system. Bio Compression is an FDA-cleared medical-device manufacturer (established brand in lymphedema treatment and post-surgical recovery). Sequential compression therapy has substantial RCT evidence for lymphedema management and DVT prophylaxis (Feldman 2012 review). 8-chamber sequential design matches medical-standard-of-care equipment. Held below Elite by (1) specific 510(k) K-number should be confirmed at product-page level; (2) high price point ($900) requires cost/benefit context — consumer buyers may need medical necessity to justify; (3) sustainability profile thin. Would move to Elite 85+ with published 510(k) K-number + prescribing/use-case guidance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cold-shower-field-towel-single-pack",
      "title": "Cold Shower Field Towel - Single Pack",
      "vendor": "The Country Christmas Loft",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/weinnl8p4r4yhkps2wvd.jpg?v=1786817926",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cold",
        "shower",
        "field",
        "towel",
        "single",
        "pack",
        "the",
        "country",
        "christmas",
        "loft"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "cold_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 42,
        "manufacturing": 50,
        "safety": 65,
        "transparency": 35,
        "sustainability": 50
      },
      "price": 1,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741202862277",
      "vsf_explanation": "A single towel marketed under 'cold therapy' — this appears to be a general-purpose towel positioned in the recovery category. Below Standard because (1) no product-specific evidence connects a towel product to any measurable recovery endpoint; (2) 'Country Christmas Loft' vendor suggests dropshipped novelty item; (3) $1 price point suggests commodity product mislabeled into a recovery category. Would move to Standard 55+ with clear category-appropriate positioning + honest use-case documentation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "small-gel-ice-cold-packs-for-face-4-round-reusable-cold-compress-5-pack",
      "title": "Small Gel Ice Cold Packs for Face – 4\" Round, Reusable Cold Compress (5-Pack)",
      "vendor": "NatraCure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4-Inch-Round-Ice_Packs.jpg?v=1786817935",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "small",
        "gel",
        "ice",
        "cold",
        "packs",
        "for",
        "face",
        "round",
        "reusable",
        "cold",
        "compress",
        "pack",
        "natracure"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "cold_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 65,
        "safety": 72,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741202895045",
      "vsf_explanation": "NatraCure 4\" face gel packs — specifically shaped for facial cryotherapy use (post-cosmetic-procedure, sinus relief, headache cooling). NatraCure has established brand credibility in the recovery-accessory space. Facial cryotherapy has real practical evidence for post-procedure swelling reduction. Held below Verified because as an accessory, no product-specific efficacy trial.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "premium-reusable-hot-and-cold-therapy-gel-pack-with-securement-straps",
      "title": "Premium Reusable Hot and Cold Therapy Gel Pack with Securement Straps",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Lifestyle-image-6.jpg?v=1786817952",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "premium",
        "reusable",
        "hot",
        "and",
        "cold",
        "therapy",
        "gel",
        "pack",
        "with",
        "securement",
        "straps",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "cold_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 65,
        "safety": 72,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 9.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741203878085",
      "vsf_explanation": "Reusable hot/cold therapy gel pack with securement straps. Basic recovery accessory. Hot/cold therapy is well-established for acute soft-tissue injury (Bleakley 2004 on cryotherapy). iReliev quality build. Held below Verified because as a basic gel-pack accessory, formulation/manufacturing signals are what carry — no efficacy differentiation vs commodity gel packs. Would move to Verified 70+ with third-party gel-composition safety testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fullglow™-180-full-body-red-light-near-infrared-mat",
      "title": "FullGlow™ 180 Full Body Red Light & Near Infrared Mat",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/FullGlow_RL-D100_180_Red_Light_and_Infrared_mat_HERO4.png?v=1786817956",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fullglow",
        "180",
        "full",
        "body",
        "red",
        "light",
        "near",
        "infrared",
        "mat",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 76,
        "manufacturing": 70,
        "safety": 70,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 599.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741204009157",
      "vsf_explanation": "Full-body red light mat — the largest / most comprehensive treatment area in the FullGlow line ($600 price tier). Full-body form-factor matches the setups used in the strongest photobiomodulation literature. iReliev brand credibility. Verified tier — highest-scoring iReliev product in this batch. Held below Elite by same wavelength/irradiance disclosure gap. Would move to Elite 85+ with published third-party output verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fullglow™-red-light-near-infrared-universal-wrap",
      "title": "FullGlow™ Red Light & Near Infrared Universal Wrap",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/RL-D079_Red_LIght_and_Infrared_Wrap_Pad_Placement.png?v=1786817964",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fullglow",
        "red",
        "light",
        "near",
        "infrared",
        "universal",
        "wrap",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 72,
        "manufacturing": 70,
        "safety": 70,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 129.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741204074693",
      "vsf_explanation": "iReliev FullGlow universal wrap — multi-body-area configurable form-factor. Same rationale as other FullGlow SKUs. Adaptability is a formulation plus.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fullglow™-red-light-near-infrared-pad",
      "title": "FullGlow™ Red Light & Near Infrared Pad",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/RL-D0_79_7.87_x_15.74_inch_Red_Light_Therapy_Panel.png?v=1786817966",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fullglow",
        "red",
        "light",
        "near",
        "infrared",
        "pad",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 72,
        "manufacturing": 70,
        "safety": 70,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 199.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741204107461",
      "vsf_explanation": "iReliev FullGlow flat pad form-factor. Applied against specific body areas. Same wavelength/irradiance spec gap.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fullglow™-red-light-near-infrared-back-wrap",
      "title": "FullGlow™ Red Light & Near Infrared Back Wrap",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/FullGlow_Red_Light_and_Infrared_Therapy_Wrap.png?v=1786817968",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fullglow",
        "red",
        "light",
        "near",
        "infrared",
        "back",
        "wrap",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 72,
        "manufacturing": 70,
        "safety": 70,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 129.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741204140229",
      "vsf_explanation": "iReliev FullGlow red light back wrap. Wrap form-factor for large-area body treatment. Same wavelength/irradiance disclosure gap. Would move to Verified 70+ with the missing spec disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "wearable-far-infrared-heating-pad-for-shoulder-pain-relief",
      "title": "Wearable Far Infrared Heating Pad for Shoulder Pain Relief",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ShoulderWrap.webp?v=1786817973",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wearable",
        "far",
        "infrared",
        "heating",
        "pad",
        "for",
        "shoulder",
        "pain",
        "relief",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 72,
        "manufacturing": 68,
        "safety": 70,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741204205765",
      "vsf_explanation": "iReliev wearable far infrared heating pad shaped for shoulder. Same rationale as other iReliev heating pads. Shoulder-shaped form-factor is a practical fit.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fullglow™-red-light-near-infrared-panel-system",
      "title": "FullGlow™ Red Light & Near Infrared Panel System",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/FullGlow_Red_and_Near_Infrared_Light_Panel_Red_Light_Therapy_Office_at_Work_Setting_Lifestyle.png?v=1786817976",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fullglow",
        "red",
        "light",
        "near",
        "infrared",
        "panel",
        "system",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 72,
        "manufacturing": 70,
        "safety": 70,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 119.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741204238533",
      "vsf_explanation": "iReliev FullGlow red light + near-IR panel system. Panel form-factor is the reference clinical setup for red light therapy. Same wavelength/irradiance disclosure gap as the wrap SKU. Would move to Verified 70+ with published wavelength + mW/cm² irradiance at defined distance + third-party output verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fullglow™-red-light-near-infrared-panel-system-1",
      "title": "FullGlow™ Red Light & Near Infrared Panel System",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/RL-75L_FullGlow_Red_Light_Panel_with_75_LEDS_in_Living_Room_Lifestyle_Red_Light_Therapy.png?v=1786817978",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fullglow",
        "red",
        "light",
        "near",
        "infrared",
        "panel",
        "system",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 72,
        "manufacturing": 70,
        "safety": 70,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 99.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741204271301",
      "vsf_explanation": "Second variant of iReliev FullGlow panel system (larger size). Same rationale as the base panel SKU. Larger panel = larger treatment area, potentially better full-body dosing at defined distance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "red-light-therapy-wrap-for-neck-and-shoulder-pain-relief",
      "title": "Red Light Therapy Wrap for Neck and Shoulder Pain Relief",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/jpg90-t3-scale100_b8811d3e-7ca8-4999-a6fb-8945f140a6a1.webp?v=1786817982",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "light",
        "therapy",
        "wrap",
        "for",
        "neck",
        "and",
        "shoulder",
        "pain",
        "relief",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 72,
        "manufacturing": 70,
        "safety": 70,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 199.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741204304069",
      "vsf_explanation": "Red light therapy wrap from iReliev for neck/shoulder. iReliev brand credibility. Red light photobiomodulation has real evidence base for tissue healing and pain (Hamblin 2016 review). Wrap form-factor is practical for target-area treatment. Held below Verified by (1) wavelength spec (630-660nm red, 810-850nm near-IR) and irradiance (mW/cm²) not clearly disclosed at product-page level — the therapeutic dose depends on both; (2) no published clinical data on this specific wrap. Would move to Verified 70+ with wavelength + irradiance disclosure + third-party output verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "wearable-far-infrared-heating-pad-for-wrist-pain-relief",
      "title": "Wearable Far Infrared Heating Pad for Wrist Pain Relief",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/WristWrap.webp?v=1786817987",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wearable",
        "far",
        "infrared",
        "heating",
        "pad",
        "for",
        "wrist",
        "pain",
        "relief",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 68,
        "manufacturing": 68,
        "safety": 70,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741204336837",
      "vsf_explanation": "iReliev wearable far infrared heating pad shaped for wrist. Same form-factor evidence base as other iReliev heating pads. Wrist is a smaller target area — form-factor advantage but less pain-mass to treat. Same missing specs.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "wearable-far-infrared-heating-pad-for-sciatica-and-hip-pain-relief",
      "title": "Wearable Far Infrared Heating Pad for Sciatica and Hip Pain Relief",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71-xjvVJruL._AC_SX466.jpg?v=1786817988",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wearable",
        "far",
        "infrared",
        "heating",
        "pad",
        "for",
        "sciatica",
        "and",
        "hip",
        "pain",
        "relief",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 72,
        "manufacturing": 68,
        "safety": 70,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 109,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741204402373",
      "vsf_explanation": "iReliev wearable far infrared heating pad shaped for sciatica/hip area. Same rationale as the neck SKU. Held below Verified for same missing specs.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "wearable-far-infrared-heating-pad-for-neck-pain-relief",
      "title": "Wearable Far Infrared Heating Pad for Neck Pain Relief",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NeckWrap.webp?v=1786817992",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wearable",
        "far",
        "infrared",
        "heating",
        "pad",
        "for",
        "neck",
        "pain",
        "relief",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 72,
        "manufacturing": 68,
        "safety": 70,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741204435141",
      "vsf_explanation": "Wearable far infrared heating pad shaped for neck. iReliev brand credibility applies. Infrared heat therapy evidence base carries. Wearable form-factor + neck-specific shape = practical formulation advantage. Held below Verified by (1) EMF measurements not published (all IR device concern); (2) UL/ETL not clearly visible; (3) infrared wavelength distribution + intensity spec not disclosed. Would move to Verified 70+ with EMF + wavelength spec + UL/ETL.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "witens-mini-wireless-tens-unit",
      "title": "WiTENS Mini Wireless TENS Unit",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Lifestyle_image_4.jpg?v=1786818048",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "witens",
        "mini",
        "wireless",
        "tens",
        "unit",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "ems_tens"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 75,
        "manufacturing": 72,
        "safety": 70,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741204762821",
      "vsf_explanation": "Wireless TENS unit from iReliev — established medical-adjacent brand with FDA 510(k) clearance history on their TENS line. TENS therapy has substantial RCT evidence for chronic pain, myalgias, and post-surgical pain reduction (Johnson 2015 Cochrane review). Wireless form-factor is convenient formulation. Held below Elite by (1) specific 510(k) K-number for THIS SKU not verified in listing; (2) pulse parameters (frequency, intensity, waveform) not disclosed at product-page level — trial-supported settings vary by indication; (3) sustainability profile thin. Would move to Elite 85+ with published 510(k) K-number + pulse-parameter disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "amethyst-far-infrared-heating-pad",
      "title": "Amethyst Far Infrared Heating Pad",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71DL-B5wsyL._AC_SL1500.jpg?v=1786818054",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "amethyst",
        "far",
        "infrared",
        "heating",
        "pad",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 70,
        "manufacturing": 68,
        "safety": 68,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 199.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741204795589",
      "vsf_explanation": "Amethyst-embedded far infrared heating pad from iReliev. Infrared heat therapy has real evidence for pain reduction and circulation (Vatansever 2012 review). Amethyst stone conducts and re-emits infrared efficiently — a real formulation choice. iReliev has established medical-adjacent recovery brand credibility. Held below Verified by (1) 'amethyst' component marketing sometimes overstates crystal-specific claims vs the underlying infrared physics; (2) EMF measurements not published; (3) UL/ETL electrical safety cert not clearly visible in listing. Would move to Verified 70+ with EMF + UL/ETL + published temperature-range spec.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mvp-dynamic-duo-massage-head-include-edge-bullet",
      "title": "MVP+ Dynamic Duo Massage Head: Include Edge & Bullet",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/PM_WEB-Images_MegaMenu_MVP-2005_DynamicDuo.png?v=1786818059",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mvp",
        "dynamic",
        "duo",
        "massage",
        "head",
        "include",
        "edge",
        "bullet",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "percussion_vibration"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 72,
        "manufacturing": 68,
        "safety": 70,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741204828357",
      "vsf_explanation": "Massage head accessory pair (Edge + Bullet attachments) for iReliev percussion massagers. Accessory products don't have their own efficacy trials — evaluated on formulation/compatibility with the parent device. iReliev is a real medical-adjacent recovery brand with a track record. Held below Verified because as an accessory, it inherits the percussion-massager evidence base rather than adding new. Would move to Verified 70+ if bundled with the parent device rather than sold separately.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "the-moon-juice-ashwagandha-organic-root-extract-supplement-for-stress-relief-and-energy",
      "title": "The Moon Juice Ashwagandha Organic Root Extract Supplement for Stress Relief and Energy",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/PVn5r6NnCLt1a2t4IaCcxAaPjULKdEvuflsH44To.jpg?v=1786818095",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "the",
        "moon",
        "juice",
        "ashwagandha",
        "organic",
        "root",
        "extract",
        "supplement",
        "for",
        "stress",
        "relief",
        "and",
        "energy",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 65,
        "safety": 72,
        "transparency": 65,
        "sustainability": 60
      },
      "price": 54,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741204992197",
      "vsf_explanation": "Moon Juice ashwagandha, organic root extract. Moon Juice is a legit clean-wellness brand (Amanda Chantal Bacon, founded 2011) with real sourcing standards. Organic + root-only is aligned with the KSM-66 evidence base positioning. Held below Verified by (1) doesn't specify KSM-66 or Sensoril branded extract — extract-level RCT literature (Chandrasekhar 2012, Langade 2019) doesn't automatically transfer to generic root extracts; (2) withanolide standardization not clearly disclosed at label level; (3) premium price point vs equivalent-evidence generics; (4) Moon Juice branding is aesthetically-driven — real product but marketing-heavy positioning. Would move to Verified 70+ with named branded extract (KSM-66 or Sensoril) + withanolide standardization + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-ashwagandha-gummies-root-30-1-extract-50-mg-120-gummies-non-gmo-vegan",
      "title": "NusaPure Ashwagandha Gummies Root 30:1 Extract, 50 mg 120 Gummies (Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-132945v2-Ashwagandha-Gummie-3D-01.jpg?v=1786818116",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "ashwagandha",
        "gummies",
        "root",
        "extract",
        "120",
        "gummies",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741205024965",
      "vsf_explanation": "Ashwagandha gummies at 50mg per gummy of generic 30:1 extract. Below Standard by (1) 50mg is well below the studied KSM-66 dose range (300-600mg total daily) — even at 30:1 concentration, 50mg equivalent to 1.5g raw powder is functionally under-dose; (2) not KSM-66 or Sensoril (the branded extracts with the RCT literature) — generic 30:1 without withanolide standardization; (3) gummy format adds sugar/pectin/flavors and typically underdelivers actives vs capsules. Would move to Standard 55+ with branded extract (KSM-66/Sensoril) at studied dose OR reformulation of the gummy delivery for higher active content.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-chaga-mushroom-20-1-extract-150-mg-per-veggie-capsule-180-count-usda-organic-vegan-non-gmo",
      "title": "NusaPure Chaga Mushroom 20:1 Extract, 150 mg per Veggie Capsule, 180 Count, USDA Organic, Vegan, Non-GMO",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-131928v3-Chaga-Mushroom-Organic-3D-01.jpg?v=1786818123",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "chaga",
        "mushroom",
        "extract",
        "150",
        "per",
        "veggie",
        "capsule",
        "180",
        "count",
        "usda",
        "organic",
        "vegan",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 20.4,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741205057733",
      "vsf_explanation": "Chaga mushroom (Inonotus obliquus) 20:1 extract 150mg. USDA Organic certification is a real plus. Chaga has emerging antioxidant and immune-modulation research but limited human RCT data. Held below Verified by (1) beta-glucan % standardization not disclosed — the primary functional active; (2) sustainability concern for chaga (wild-harvested from birch trees, over-harvesting concerns in some regions); (3) chaga has real oxalate content and safety warnings for kidney-disease patients or oxalate-sensitive individuals — under-disclosed on label. Would move to Verified 70+ with beta-glucan standardization + sustainable-sourcing certification + kidney-safety warning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-garcinia-cambogia-180-veggie-capsules-1500mg-vegetarian-non-gmo-vegan",
      "title": "NusaPure Garcinia Cambogia 180 Veggie Capsules 1500mg (Vegetarian, Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1f966221.jpg?v=1786818129",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "garcinia",
        "cambogia",
        "180",
        "veggie",
        "capsules",
        "1500mg",
        "vegetarian",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 42,
        "transparency": 42,
        "sustainability": 45
      },
      "price": 19.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741205090501",
      "vsf_explanation": "Garcinia cambogia (HCA) 1500mg — heavily marketed as a weight-loss supplement despite null-result meta-analyses (Onakpoya 2011: no significant weight-loss effect vs placebo). Auto-fail: unverified_medical_claim. Additionally, garcinia has documented rare hepatotoxicity (Crescioli 2018 case series), and the FDA has issued warnings about certain garcinia products causing liver damage. Weight-loss supplement category with strong marketing + weak-to-null evidence + real safety signal. Would move to Standard 55+ ONLY with reformulation removing weight-loss claims + prominent hepatotoxicity warnings + published meaningful efficacy trial (currently no such trial supports the claim).",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "nusapure-full-spectrum-black-cumin-seed-10-1-extract-450-mg-180-veggie-powder-caps-non-gmo-vegan-non-oily",
      "title": "NusaPure Full Spectrum Black Cumin Seed 10:1 Extract, 450 mg 180 Veggie Powder Caps Non-GMO, Vegan Non-Oily",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-127530-BlackCuminSeed4500-3D-v8-01.jpg?v=1786818132",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "full",
        "spectrum",
        "black",
        "cumin",
        "seed",
        "extract",
        "450",
        "180",
        "veggie",
        "powder",
        "caps",
        "non",
        "gmo",
        "vegan",
        "non",
        "oily",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 24.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741205123269",
      "vsf_explanation": "Black cumin seed (Nigella sativa) 10:1 extract 450mg. Real evidence for cardiovascular endpoints — Sahebkar 2016 meta-analysis showed BP and lipid improvements with 2g/day of seed. Thymoquinone is the primary active. Held below Verified by (1) thymoquinone % standardization not disclosed — trials use standardized-thymoquinone extracts; (2) NusaPure quality tier without third-party COA; (3) 'full-spectrum' extract without % standardization can vary widely lot-to-lot. Would move to Verified 70+ with thymoquinone standardization + third-party assay.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-horse-chestnut-20-1-extract-300-mg-180-veggie-caps-non-gmo-vegan-bioperine-calendula-flower",
      "title": "NusaPure Horse Chestnut 20:1 Extract, 300 mg 180 Veggie Caps Non-GMO, Vegan, BioPerine, Calendula Flower",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nusapure-HorseChestnut-3d-v4-01.jpg?v=1786818138",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "horse",
        "chestnut",
        "extract",
        "300",
        "180",
        "veggie",
        "caps",
        "non",
        "gmo",
        "vegan",
        "bioperine",
        "calendula",
        "flower",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 27.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741205156037",
      "vsf_explanation": "Horse chestnut seed extract 300mg — real evidence for chronic venous insufficiency (varicose veins, leg edema) at 300-600mg standardized extract with 50-75mg escin content (Pittler 2012 Cochrane review). Held below Verified by (1) escin % standardization not disclosed at label — escin is the primary active for the vascular endpoints; (2) safety warning around raw horse chestnut (esculin toxicity) if extraction is incomplete; (3) NusaPure quality tier. Would move to Verified 70+ with escin % + esculin-removal verification + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-ceylon-cinnamon-20-1-extract-500-mg-per-capsule-150-veggie-capsules-non-gmo-vegan-with-bioperine",
      "title": "NusaPure Ceylon Cinnamon 20:1 Extract, 500 mg per Capsule | 150 Veggie Capsules | Non-GMO, Vegan with Bioperine",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-1300677V6-CeylonCinnamon3d-01.jpg?v=1786818141",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "ceylon",
        "cinnamon",
        "extract",
        "500",
        "per",
        "capsule",
        "150",
        "veggie",
        "capsules",
        "non",
        "gmo",
        "vegan",
        "with",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 19.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741205221573",
      "vsf_explanation": "Ceylon cinnamon (Cinnamomum verum) 20:1 extract 500mg. Ceylon vs Cassia cinnamon distinction matters — Cassia has high coumarin content (hepatotoxic at high doses), Ceylon is much lower. Real blood-sugar-modulation evidence for cinnamon (Allen 2013 meta-analysis, ~24 mg/dL fasting glucose reduction). Ceylon-specific sourcing is a formulation plus. Held below Verified by (1) NusaPure quality tier without third-party assay (Cassia contamination of 'Ceylon' products is a known issue); (2) cinnamaldehyde standardization not disclosed. Would move to Verified 70+ with third-party botanical-authentication assay + cinnamaldehyde standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-vitamin-k2-mk7-120-mcg-200-veggie-caps-soy-free-non-gmo-vegan",
      "title": "NusaPure Vitamin K2 MK7 120 mcg 200 Veggie Caps (Soy Free, Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/782949de.jpg?v=1786818144",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "vitamin",
        "mk7",
        "120",
        "mcg",
        "200",
        "veggie",
        "caps",
        "soy",
        "free",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 70,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 65,
        "sustainability": 45
      },
      "price": 19.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741205254341",
      "vsf_explanation": "Vitamin K2 MK-7 120mcg — the preferred K2 form for bone/cardiovascular calcium partitioning (Knapen 2013 on menaquinone-7 for bone). 120mcg is in the studied dose range. Soy-free is a formulation plus (many MK-7 products are natto-derived; soy-free variants matter for allergy). Held below Verified by (1) NusaPure budget tier without third-party assay for MK-7 content and cis/trans isomer purity (all-trans is bioactive; cis is not — cheap manufacturing can produce mostly-cis material); (2) source (natto vs synthetic) not disclosed. Would move to Verified 70+ with source disclosure + trans-isomer purity assay + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-beet-root-30-1-extract-1000mg-150-veggie-caps-vegan-non-gmo-vegan-4-nitrates-bioperine",
      "title": "NusaPure Beet Root 30:1 Extract, 1000mg 150 Veggie caps (Vegan, Non-GMO & Vegan 4% Nitrates) Bioperine",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nusapure-BeetRoot-Bioperine-3d-New-Render-V6-01.jpg?v=1786818149",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "beet",
        "root",
        "extract",
        "1000mg",
        "150",
        "veggie",
        "caps",
        "vegan",
        "non",
        "gmo",
        "vegan",
        "nitrates",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 65,
        "sustainability": 45
      },
      "price": 23.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741205287109",
      "vsf_explanation": "Beet root 30:1 extract 1000mg standardized to 4% nitrates. Beet nitrate has real evidence for blood-pressure reduction (Siervo 2013 meta-analysis, 4-5 mmHg systolic) and exercise-performance improvement (Hoon 2013). Nitrate standardization at label (4%) is a positive vs generic beet powder. Held below Verified by (1) 40mg nitrate per capsule (4% of 1000mg) is below the studied 300-600mg nitrate range for BP/performance benefit — needs 7-15 caps per dose to hit trial-effective range; (2) NusaPure budget tier without third-party COA. Would move to Verified 70+ with higher per-cap nitrate + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-red-yeast-rice-1800mg-180-veggie-capsules-non-gmo-vegan",
      "title": "NusaPure Red Yeast Rice 1800mg 180 Veggie Capsules (Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b8b06691.jpg?v=1786818160",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "red",
        "yeast",
        "rice",
        "1800mg",
        "180",
        "veggie",
        "capsules",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 50,
        "safety": 31,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 20.62,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741205352645",
      "vsf_explanation": "Red yeast rice (Monascus purpureus) 1800mg. Real LDL-lowering evidence from monacolin K (chemically identical to prescription lovastatin) content — the effective active is statin-like and carries statin-adjacent safety concerns (myopathy, liver enzyme elevation, coenzyme Q10 depletion). Held below Verified by (1) monacolin K content is NOT standardized in the US (FDA considers standardized monacolin K products as unapproved drugs) — content varies 10x+ across brands; (2) same drug-interaction and side-effect profile as statins should apply but warning language is typically absent from supplement labels; (3) NO CoQ10 co-formulation despite the well-established statin/CoQ10 depletion pattern; (4) contamination with citrinin (nephrotoxic mycotoxin) has been documented in RYR products. Would move to Verified 70+ with third-party monacolin K + citrinin assay + prominent statin-adjacent safety disclosure + CoQ10 co-formulation. This is unregulated, drug-equivalent exposure with no third-party assay on record — held at Rejected under safety_concern until monacolin K and citrinin testing plus a prominent statin-interaction warning are published.",
      "vsf_autofail_rule": "safety_concern"
    },
    {
      "handle": "nusapure-usda-organic-holy-basil-capsules-20-1-extract-350-mg-150-vegan-caps-tulsi-holy-basil-leaf-extract-2-5-ursolic-acid-non-gmo",
      "title": "NusaPure USDA Organic Holy Basil Capsules 20:1 Extract, 350 mg 150 Vegan Caps Tulsi Holy Basil Leaf Extract 2.5% Ursolic Acid Non-GMO",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c6924ef0.jpg?v=1786818165",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "usda",
        "organic",
        "holy",
        "basil",
        "capsules",
        "extract",
        "350",
        "150",
        "vegan",
        "caps",
        "tulsi",
        "holy",
        "basil",
        "leaf",
        "extract",
        "ursolic",
        "acid",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 58,
        "safety": 72,
        "transparency": 60,
        "sustainability": 58
      },
      "price": 22.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741205385413",
      "vsf_explanation": "USDA Organic Holy Basil (Tulsi, Ocimum sanctum) 20:1 extract 350mg. Real evidence for stress adaptation, blood-sugar support, and anti-inflammatory effects (Cohen 2014 review, Sampath 2015 on cortisol reduction). USDA Organic certification is a real quality plus over generic Tulsi. Held below Verified by (1) eugenol/ursolic-acid standardization not disclosed; (2) no branded extract (OciBest is the reference clinical-trial extract); (3) NusaPure manufacturing tier. Would move to Verified 70+ with standardization + branded extract + third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-vitamin-e-mixed-tocopherols-suitable-for-vegetarian-vegan-non-gmo-1000-iu-200-tablets",
      "title": "NusaPure Vitamin E Mixed Tocopherols - Suitable for Vegetarian/Vegan, Non - GMO - 1000 IU 200 Tablets",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Vitamin_E_mixed_toco_a1_blue-PET.jpg?v=1786818170",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "vitamin",
        "mixed",
        "tocopherols",
        "suitable",
        "for",
        "vegetarian",
        "vegan",
        "non",
        "gmo",
        "1000",
        "200",
        "tablets",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 62,
        "sustainability": 45
      },
      "price": 34.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741205418181",
      "vsf_explanation": "Mixed tocopherols (all four tocopherols alpha/beta/gamma/delta) is a formulation plus vs single alpha-tocopherol — mixed tocopherols better reflect the natural vitamin E complex and avoid the gamma-tocopherol displacement seen with high-dose alpha-only supplementation. Held below Verified by (1) 1000 IU is above the RDA (22.4 IU) by ~45x — chronic high-dose vitamin E supplementation has been associated with slightly increased all-cause mortality in meta-analyses (Miller 2005) and increased hemorrhagic stroke risk; (2) safety-warning language for high-dose E should be prominent; (3) NusaPure quality tier without third-party assay. Would move to Verified 70+ with lower-dose SKU (200-400 IU) + third-party COA + prominent high-dose safety discussion.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-berberine-with-ceylon-cinnamon-20-1-extract-250-mg-180-veggie-capsules-vegetarian-non-gmo-supplement-berberine-complex",
      "title": "NusaPure Berberine with Ceylon Cinnamon 20:1 Extract, 250 mg 180 Veggie Capsules, Vegetarian, Non-GMO Supplement, (Berberine Complex)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nusapure-BerberineCinnamonComplex-3D-v3-01.jpg?v=1786818174",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "berberine",
        "with",
        "ceylon",
        "cinnamon",
        "extract",
        "250",
        "180",
        "veggie",
        "capsules",
        "vegetarian",
        "non",
        "gmo",
        "supplement",
        "berberine",
        "complex",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 52,
        "safety": 62,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 23.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741205450949",
      "vsf_explanation": "Berberine + Ceylon cinnamon combo for glucose/lipid support. Berberine has strong RCT evidence for HbA1c reduction (Yin 2008 comparable to metformin at 500mg × 3/day), cinnamon has modest supporting data. Held below Verified by (1) 250mg is per-cap total — the studied berberine dose is 500mg × 2-3/day, so this is per-serving underdose or requires multiple caps; (2) berberine vs cinnamon per-ingredient ratio not clear at label; (3) berberine drug interactions (cyclosporine, statins, some ARBs) warrant stronger warnings. Would move to Verified 70+ with per-ingredient mg + interaction warnings + higher per-cap berberine.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-echinacea-20-1-extract-300-mg-200-veggie-caps-vegan-non-gmo-gluten-free-supplement",
      "title": "NusaPure Echinacea 20:1 Extract, 300 mg 200 Veggie Caps, Vegan, Non-GMO, Gluten Free Supplement",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-131028v4-Echinacea-3D-01.jpg?v=1786818180",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "echinacea",
        "extract",
        "300",
        "200",
        "veggie",
        "caps",
        "vegan",
        "non",
        "gmo",
        "gluten",
        "free",
        "supplement",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 21.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741205483717",
      "vsf_explanation": "Echinacea 20:1 extract 300mg. Evidence for cold-duration reduction is mixed (Karsch-Völk 2014 Cochrane review — modest signal, high heterogeneity across studies; specific extracts like EchinaGuard/Echinaforce have stronger data than generic echinacea). Held below Verified by (1) species (E. purpurea vs angustifolia vs pallida) matters and not specified; (2) plant part (root vs aerial) matters and not specified; (3) NusaPure budget without branded-extract sourcing. Would move to Verified 70+ with species + plant-part disclosure + branded extract (EchinaGuard/Echinaforce).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-longjack-tongkat-ali-1-300mg-150-veggie-caps-non-gmo-gluten-free-bioperine",
      "title": "NusaPure Longjack Tongkat Ali 1,300mg 150 Veggie Caps (Non-GMO, Gluten Free) Bioperine",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-130864v2-Longjack-TongKat-3D-01.jpg?v=1786818187",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "longjack",
        "tongkat",
        "ali",
        "300mg",
        "150",
        "veggie",
        "caps",
        "non",
        "gmo",
        "gluten",
        "free",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 52,
        "safety": 62,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 22.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741205647557",
      "vsf_explanation": "Tongkat Ali (Eurycoma longifolia) 1300mg. Real emerging evidence for testosterone support in stressed/hypogonadal men (Talbott 2013, Henkel 2014 — 200mg standardized extract, 4-12 weeks). Held below Verified by (1) eurycomanone % standardization not disclosed — clinical trials use 200mg of standardized extract (5-15% eurycomanone content), not 1300mg of unspecified extract concentration; (2) the '1300mg' number without extract-ratio disclosure can mean anything from a mild extract to a raw powder; (3) NusaPure quality tier. Would move to Verified 70+ with eurycomanone % + reference to branded extract (LJ100/Physta) + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-mimosa-pudica-seed-1-200-mg-200-vegan-capsules-10-1-extract-non-gmo-gluten-free",
      "title": "NusaPure Mimosa Pudica Seed 1,200 mg 200 Vegan Capsules (10:1 Extract, Non-GMO, Gluten Free)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-131697v3-MimosaPudica-3D-01.jpg?v=1786818195",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "mimosa",
        "pudica",
        "seed",
        "200",
        "200",
        "vegan",
        "capsules",
        "extract",
        "non",
        "gmo",
        "gluten",
        "free",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 52,
        "manufacturing": 52,
        "safety": 58,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 26.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741205713093",
      "vsf_explanation": "Mimosa pudica seed 10:1 extract at 1200mg. Popular in alternative-medicine 'parasite cleanse' protocols but the underlying human RCT evidence for the marketed anti-parasitic/gut-cleanse claims is essentially absent — most published research is in-vitro or animal-model. Held below Standard by (1) evidence base doesn't support the marketed use cases; (2) 'gut cleanse' claims are broadly criticized as pseudoscience for lack of validated biomarker endpoints; (3) NusaPure quality tier. Would move to Standard 55+ with more honest positioning + published human evidence for stated use case.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-saffron-extract-88-5mg-200-veggie-caps-vegetarian-non-gmo-vegan",
      "title": "NusaPure Saffron Extract 88.5mg 200 Veggie Caps (Vegetarian, Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0388b3b8.jpg?v=1786818197",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "saffron",
        "extract",
        "5mg",
        "200",
        "veggie",
        "caps",
        "vegetarian",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 62,
        "sustainability": 45
      },
      "price": 21.65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741205745861",
      "vsf_explanation": "Saffron extract 88.5 mg — very close to the studied dose (Lopresti 2014 review, Kell 2017 all use 30-88mg/day standardized saffron). Real evidence base for mild-moderate depression and mood support. Standardized saffron is one of the better-evidenced natural mood supplements. Held below Verified by (1) safranal/crocin standardization not disclosed at label level (Affron/Satiereal branded extracts specify these — generic doesn't); (2) NusaPure budget-brand manufacturing without third-party COA; (3) no branded-extract identification (Affron is the reference clinical-trial extract). Would move to Verified 70+ with named branded extract (Affron/Satiereal) + third-party assay.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-passion-flower-20-1-extract-300-mg-120-veggie-caps-non-gmo-bioperine-extract-supplement",
      "title": "NusaPure Passion Flower 20:1 Extract, 300 mg, 120 Veggie Caps, Non-GMO, Bioperine, Extract Supplement",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/passion_flower_a1.png?v=1786818202",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "passion",
        "flower",
        "extract",
        "300",
        "120",
        "veggie",
        "caps",
        "non",
        "gmo",
        "bioperine",
        "extract",
        "supplement",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 52,
        "safety": 72,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 22.85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741206991045",
      "vsf_explanation": "Passion flower (Passiflora incarnata) 20:1 extract 300mg. Real modest evidence for anxiolytic effect (Akhondzadeh 2001 comparable to oxazepam for GAD, Ngan 2011 for pre-surgical anxiety). BioPerine added for bioavailability. Held below Verified by (1) flavonoid standardization not disclosed; (2) NusaPure budget manufacturing tier; (3) no product-specific trial. Would move to Verified 70+ with standardization + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-chrysin-500mg-60-veggie-capsules-passion-flower-complex-500mg-supplement-5-7-dihydroxyflavone-concentrated-extract-non-gmo-bioperine",
      "title": "NusaPure Chrysin 500mg, 60 Veggie Capsules | Passion Flower Complex 500mg Supplement | 5, 7-Dihydroxyflavone | Concentrated Extract | Non-GMO, BioPerine",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/921b0cc1.jpg?v=1786818207",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "chrysin",
        "500mg",
        "veggie",
        "capsules",
        "passion",
        "flower",
        "complex",
        "500mg",
        "supplement",
        "dihydroxyflavone",
        "concentrated",
        "extract",
        "non",
        "gmo",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 45,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 32.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741207023813",
      "vsf_explanation": "Chrysin 500mg is often marketed as an aromatase inhibitor for testosterone support — but oral chrysin bioavailability is famously poor (~1% absorption, Walle 2001) meaning the aromatase-inhibition claims that make sense in cell-culture studies don't translate to systemic effects in humans. Auto-fail: unverified_medical_claim (implied hormone-modulation claims not supported by human PK data on the compound). Passion flower has modest anxiolytic evidence, but the primary marketing is chrysin-focused. Would move to Standard 55+ with (1) removal of aromatase/hormone-modulation implied claims OR (2) reformulation with a liposomal/enhanced-absorption chrysin delivery system + published PK data.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "nusapure-menopause-complex-black-cohosh-and-herbal-ingredients-60-capsules",
      "title": "NusaPure Menopause Complex : Black Cohosh and Herbal Ingredients - 60 Capsules",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/93a3fbb4.jpg?v=1786818212",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "postmenopausal",
      "tokens": [
        "nusapure",
        "menopause",
        "complex",
        "black",
        "cohosh",
        "and",
        "herbal",
        "ingredients",
        "capsules",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 55,
        "manufacturing": 52,
        "safety": 58,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 19.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741207056581",
      "vsf_explanation": "Menopause-symptom-support blend anchored on black cohosh + herbal supporting ingredients. Black cohosh has RCT evidence for vasomotor symptoms (hot flashes) at 20-80mg/day of standardized extract (Osmers 2005). Held below Verified by (1) black cohosh standardization (triterpene glycoside %) not disclosed; (2) per-ingredient breakdown of the herbal blend not clear at label level; (3) black cohosh has rare hepatotoxicity reports — safety-warning disclosure could be stronger; (4) NusaPure budget manufacturing. Would move to Verified 70+ with per-ingredient standardization + third-party COA + prominent hepatotoxicity warning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-white-kidney-beans-30-1-extract-800-mg-200-vegan-capsules-bioperine-vegan-non-gmo",
      "title": "NusaPure White Kidney Beans 30:1 Extract, 800 mg 200 Vegan Capsules - Bioperine - (Vegan, Non-GMO)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-131322v5-White-Absorption-Bean-HA-3D-01.jpg?v=1786818216",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "white",
        "kidney",
        "beans",
        "extract",
        "800",
        "200",
        "vegan",
        "capsules",
        "bioperine",
        "vegan",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 52,
        "manufacturing": 50,
        "safety": 62,
        "transparency": 48,
        "sustainability": 45
      },
      "price": 22.2,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741207089349",
      "vsf_explanation": "White kidney bean extract (Phaseolamin) marketed as a 'carb blocker' via alpha-amylase inhibition. Trial evidence is mixed and effect sizes are small (Barrett 2011 meta-analysis found modest weight-loss effect, but heterogeneous results). Below Standard because (1) carb-blocker marketing category has FDA-warning history for overpromising; (2) alpha-amylase % standardization not disclosed — the active phaseolamin can vary widely by extract source; (3) real-world clinical significance is modest even at studied doses. Would move to Standard 55+ with published phaseolamin standardization + honest positioning vs cited RCT effect sizes.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-pqq-supplement-40-mg-120-veggie-capsules-non-gmo-pyrroloquinoline-quinone-disodium-salt-bioperine",
      "title": "NusaPure PQQ Supplement 40 mg, 120 Veggie Capsules, Non-GMO, Pyrroloquinoline Quinone Disodium Salt, Bioperine",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f5a1034c.jpg?v=1786818220",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "pqq",
        "supplement",
        "120",
        "veggie",
        "capsules",
        "non",
        "gmo",
        "pyrroloquinoline",
        "quinone",
        "disodium",
        "salt",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 62,
        "sustainability": 45
      },
      "price": 27.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741207122117",
      "vsf_explanation": "PQQ (Pyrroloquinoline Quinone) disodium 40 mg — high per-cap dose. PQQ has emerging mitochondrial-biogenesis literature (Chowanadisai 2010, Nakano 2012 on cognitive support at 20mg/day). 40mg is above the studied range which may or may not add benefit. Held below Verified by (1) NusaPure budget manufacturing without third-party PQQ-content assay; (2) 40mg exceeds most trial doses (20mg was the reference); (3) no product-specific efficacy trial. Would move to Verified 70+ with third-party COA + more appropriate dose vs trial evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-turmeric-curcumin-600-mg-60-capsules-turmeric-95-curcuminoids-dietary-supplement",
      "title": "NusaPure Turmeric Curcumin 600 mg 60 Capsules Turmeric 95% Curcuminoids Dietary Supplement",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/00e57655.jpg?v=1786818227",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "turmeric",
        "curcumin",
        "600",
        "capsules",
        "turmeric",
        "curcuminoids",
        "dietary",
        "supplement",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 62,
        "sustainability": 45
      },
      "price": 19.22,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741207154885",
      "vsf_explanation": "Turmeric extract standardized to 95% curcuminoids at 600mg — the standardization % is disclosed (rare positive for budget brands) so per-capsule curcumin content is verifiable (~570mg curcuminoids). Real curcumin evidence for inflammation/joint pain. Held below Verified by (1) no bioavailability enhancer disclosed (piperine, phospholipid complex, liposomal delivery) — plain curcumin has ~1% oral absorption; (2) NusaPure quality tier without third-party assay; (3) 600mg without enhancer functionally delivers ~6mg systemic. Would move to Verified 70+ with bioavailability-enhanced formulation + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-saw-prostate-palmetto-complex-plant-sterol-complex-nettle-root-pygeum-bark-graviola-90-capsules",
      "title": "NusaPure Saw Prostate Palmetto Complex (Plant Sterol Complex, Nettle Root, Pygeum Bark, Graviola) - 90 Capsules",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/34ea076b.jpg?v=1786818233",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "saw",
        "prostate",
        "palmetto",
        "complex",
        "plant",
        "sterol",
        "complex",
        "nettle",
        "root",
        "pygeum",
        "bark",
        "graviola",
        "capsules",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 52,
        "safety": 65,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 21.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741207187653",
      "vsf_explanation": "Saw palmetto + nettle root + pygeum bark + plant sterols — classic BPH-support blend. Saw palmetto 320mg standardized extract has real evidence for lower urinary tract symptoms (BPH); nettle root and pygeum have supporting data. Held below Verified by (1) saw palmetto standardization % not disclosed — trials use 85-95% fatty acids/sterols standardization; (2) per-ingredient mg for the blend not clear at label level; (3) NusaPure manufacturing standards mid-tier. Would move to Verified 70+ with saw palmetto standardization + per-ingredient dose + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-liver-kidney-support-with-cranberry-fruit-milk-thistle-extract-650-mg-60-capsules-non-gmo-soyfree-dietary-supplement",
      "title": "NusaPure Liver & Kidney Support with Cranberry Fruit & Milk Thistle Extract 650 mg 60 Capsules Non-GMO Soyfree Dietary Supplement",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/23ef513a.jpg?v=1786818239",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "liver",
        "kidney",
        "support",
        "with",
        "cranberry",
        "fruit",
        "milk",
        "thistle",
        "extract",
        "650",
        "capsules",
        "non",
        "gmo",
        "soyfree",
        "dietary",
        "supplement",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 52,
        "manufacturing": 52,
        "safety": 62,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 16.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741207220421",
      "vsf_explanation": "Multi-ingredient liver/kidney support blend from NusaPure. Milk thistle (silymarin) has real hepatoprotection evidence at 200-400mg standardized silymarin; cranberry has UTI-prevention data at ~500mg PACs. Held below Verified by (1) '650mg' is total blend weight — per-ingredient mg for silymarin standardization and PAC content NOT disclosed at label level, so effective dose can't be verified; (2) 'liver + kidney' dual-organ marketing is aspirational vs organ-specific formulation; (3) blend approach dilutes individual doses vs single-active products. Would move to Verified 70+ with per-ingredient dose disclosure + silymarin/PAC standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-st-johns-wort-20-1-extract-300-mg-240-veggie-capsules-vegetarian-non-gmo-vegan-bioperine",
      "title": "NusaPure St. John's Wort 20:1 Extract, 300 mg 240 Veggie Capsules (Vegetarian, Non-GMO & Vegan) Bioperine",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71C2cnXQdwL._AC_SL1500.jpg?v=1786818245",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "john",
        "wort",
        "extract",
        "300",
        "240",
        "veggie",
        "capsules",
        "vegetarian",
        "non",
        "gmo",
        "vegan",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 52,
        "safety": 55,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 27.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741207253189",
      "vsf_explanation": "St. John's Wort (Hypericum perforatum) 20:1 extract 300 mg. Real evidence for mild-to-moderate depression (Linde 2008 Cochrane review — comparable to SSRIs for mild-moderate cases). Held below Verified by (1) hyperforin standardization (the primary active for antidepressant effect, typically 3-5%) not disclosed; (2) major drug-interaction profile — St. John's Wort is a potent CYP3A4 inducer that reduces effectiveness of oral contraceptives, warfarin, statins, HIV protease inhibitors, immunosuppressants, and many chemotherapy drugs. Under-labeled interaction warnings are a real safety issue; (3) NusaPure budget manufacturing. Would move to Verified 70+ with hyperforin standardization + prominent drug-interaction warning + third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-mucuna-pruriens-50-1-extract-450-mg-150-veggie-caps-non-gmo-gluten-free-bio-perine",
      "title": "NusaPure Mucuna Pruriens 50:1 Extract, 450 mg 150 Veggie Caps (Non-GMO, Gluten Free, & Bio-Perine)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-131621v3-Mucuna-Pruriens-3D-01_e01b0816-ea1d-40dc-8f57-0ecd5d3be22f.jpg?v=1786818252",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "mucuna",
        "pruriens",
        "extract",
        "450",
        "150",
        "veggie",
        "caps",
        "non",
        "gmo",
        "gluten",
        "free",
        "bio",
        "perine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 52,
        "safety": 65,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 25.1,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741207318725",
      "vsf_explanation": "Mucuna Pruriens (velvet bean) 50:1 extract 450 mg — natural source of L-DOPA (dopamine precursor). Real evidence for L-DOPA content and dopaminergic effects (Katzenschlager 2004 on Parkinson-adjacent use). Held below Verified by (1) L-DOPA % standardization not disclosed at label level — 50:1 extract concentration doesn't specify L-DOPA yield per capsule (studied products typically standardize to 15-40% L-DOPA); (2) Mucuna interacts with monoamine-oxidase inhibitors and other dopaminergic drugs — safety warnings underweight for a compound with real pharmacological activity; (3) NusaPure budget-brand manufacturing. Would move to Verified 70+ with L-DOPA % standardization + third-party assay + prominent drug-interaction disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-odorless-garlic-100-1-extract-50-mg-capsule-120-veggie-caps-high-potency-herbal-supplement-non-gmo",
      "title": "NusaPure Odorless Garlic 100:1 Extract, 50 mg Capsule | 120 Veggie Caps | High Potency | Herbal Supplement | Non-GMO",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-132242v2-Odorless-Garlic-3D-01.jpg?v=1786818633",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "odorless",
        "garlic",
        "100",
        "extract",
        "capsule",
        "120",
        "veggie",
        "caps",
        "high",
        "potency",
        "herbal",
        "supplement",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 58,
        "manufacturing": 52,
        "safety": 72,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 16.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741212725445",
      "vsf_explanation": "Odorless garlic 100:1 extract 50mg. Aged garlic has real evidence for blood pressure (Ried 2020 meta-analysis, 5-8 mmHg systolic reduction) and lipid profiles. 100:1 extract ratio means 50mg is equivalent to 5g raw garlic. Held below Verified by (1) allicin content (the primary active for most cardiovascular effects) is significantly reduced in 'odorless' processing; (2) budget-brand quality without third-party testing; (3) 50mg is on the low end vs the studied 300-2000mg aged-garlic-extract doses in cardiovascular RCTs. Would move to Verified 70+ with allicin-yield disclosure + third-party COA + higher dose per capsule.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-osha-root-extract-150-mg-per-vegan-caps-150-count-10-1-extract-non-gmo-vegan-bioperine-ligusticum-porteri",
      "title": "NusaPure OSHA Root Extract 150 mg per Vegan Caps - 150 Count (10:1 Extract, Non-GMO, Vegan, Bioperine) Ligusticum Porteri",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-131717v3-Osha-Root-HA-3D-01.jpg?v=1786818637",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "osha",
        "root",
        "extract",
        "150",
        "per",
        "vegan",
        "caps",
        "150",
        "count",
        "extract",
        "non",
        "gmo",
        "vegan",
        "bioperine",
        "ligusticum",
        "porteri",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 22,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741212758213",
      "vsf_explanation": "OSHA root (Ligusticum porteri) 10:1 extract 150 mg — traditional Southwestern respiratory-support herb. Ethnobotanical use is real but modern RCT evidence base is thin. NusaPure is a budget mass-market brand with 'lab tested' claims but no visible third-party COA linked. 10:1 extract concentration is a positive; vegan/non-GMO baseline. Held below Verified by (1) OSHA root has minimal peer-reviewed RCT support for stated use cases; (2) sustainability concern — wild-harvested OSHA is on some conservation-concern lists; (3) NusaPure quality track record is mixed across their product line. Would move to Verified 70+ with third-party COA + published RCT + sustainable-sourcing certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "rhodiola-rosea-2000mg-with-ashwagandha-ksm-66-l-theanine-holy-basil-bioperine-high-potency-vegan-capsules",
      "title": "Rhodiola Rosea 2000mg with Ashwagandha KSM-66, L-Theanine, Holy Basil & BioPerine - High Potency Vegan Capsules",
      "vendor": "FreshDrinkUS - Natural and Premium Herbal Tea",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_e17415c4-a7fa-42ba-b776-63925ef34991.jpg?v=1786818655",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "cognitive",
        "mood",
        "recovery",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "rhodiola",
        "rosea",
        "2000mg",
        "with",
        "ashwagandha",
        "ksm",
        "theanine",
        "holy",
        "basil",
        "bioperine",
        "high",
        "potency",
        "vegan",
        "capsules",
        "freshdrinkus",
        "natural",
        "and",
        "premium",
        "herbal",
        "tea"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 52,
        "safety": 68,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741212823749",
      "vsf_explanation": "Adaptogen stack: Rhodiola + KSM-66 Ashwagandha + L-Theanine + Holy Basil + BioPerine. Each adaptogen has real evidence at RCT-effective doses (Rhodiola 200-600mg extract for fatigue/stress per Panossian 2010; KSM-66 300-600mg for stress per Chandrasekhar 2012; L-Theanine 100-200mg for calm-alertness). Holding the KSM-66 branded extract at a proper dose is a plus. Held below Verified by (1) '2000mg total' branding likely refers to total blend weight rather than active-extract mg; per-ingredient breakdown at label level matters; (2) small brand (FreshDrinkUS) without prominent third-party testing; (3) 4-ingredient blend spreads doses thin — either KSM-66 or Rhodiola alone at their studied dose is usually stronger than a diluted stack. Would move to Verified 70+ with per-ingredient mg disclosure + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "smart-snore-stopper-biosensor-anti-snore-sleeping-aid",
      "title": "Smart Snore Stopper | Biosensor Anti-Snore Sleeping Aid",
      "vendor": "DreamTech",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/685FAB05F7825A038396A9DA5B19FC3C_661ca3f6-3542-455d-b58e-c4f2b937eccb.jpg?v=1786818708",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "smart",
        "snore",
        "stopper",
        "biosensor",
        "anti",
        "snore",
        "sleeping",
        "aid",
        "dreamtech"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_apnea_cpap"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 40,
        "safety": 40,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741213085893",
      "vsf_explanation": "Wrist-worn biosensor 'anti-snore' device marketed near the CPAP/sleep-apnea category. Trigger: misleading_naming — snoring is a symptom that can be benign OR the presenting sign of obstructive sleep apnea (a cardiovascular-risk-elevating diagnosis requiring proper polysomnography). A biosensor wrist device that vibrates to reposition the sleeper is NOT a substitute for OSA screening or CPAP therapy. Auto-fail rule triggered because the product could delay evaluation for actual OSA. Would move to Standard 55+ with a prominent 'not a CPAP substitute; screen for OSA if snoring persists' disclaimer + published efficacy trial on snoring reduction (not just positional data).",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "defenderpad-laptop-emf-radiation-heat-shield",
      "title": "DefenderPad Laptop EMF Radiation + Heat Shield",
      "vendor": "DefenderShield",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/DefenderPad_Catalog_Image_1_0602c2ef-3a44-4cbe-9012-780ef11d6da4.jpg?v=1786819121",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "defenderpad",
        "laptop",
        "emf",
        "radiation",
        "heat",
        "shield",
        "defendershield"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "hrv_recovery_apps"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 104.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741217083589",
      "vsf_explanation": "DefenderPad — laptop lap pad combining heat shielding AND EMF shielding. The HEAT shielding function is legitimate: prolonged direct laptop-on-lap heat contact has documented dermatological effects (erythema ab igne) and modest concerns about heat effect on male scrotal temperature. The EMF-shielding function inherits the same evidence-limitation as DefenderShield's other EMF-health products. Held at Standard rather than Rejected because the heat-shielding function is real and independent of the EMF-health claim — one honest use case (heat protection during lap use) + one over-marketed use case (EMF protection). Doesn't quite trigger auto-fail because the heat mechanism is real. Would move to Verified 70+ with clearer separation of heat-shielding (evidenced) vs EMF-protection (over-marketed) claims.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "emf-radiation-free-earbuds-air-tube-stereo-headphones",
      "title": "EMF Radiation-Free Earbuds Air Tube Stereo Headphones",
      "vendor": "DefenderShield",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/DefenderShield-Earbuds-Catalog-USB-C-1.webp?v=1786819124",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "emf",
        "radiation",
        "free",
        "earbuds",
        "air",
        "tube",
        "stereo",
        "headphones",
        "defendershield"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "hrv_recovery_apps"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 89.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741217214661",
      "vsf_explanation": "$90 air-tube earbuds marketed as 'EMF radiation-free.' Auto-fail: unverified_medical_claim. Air-tube earbuds use hollow tubes to conduct sound from a mid-cord speaker, eliminating the near-brain speaker element and its EMF emission. Physical mechanism is real (no near-head speaker = no near-head EMF from that element). But the marketed health benefit (protection from wired-earbud health risks) doesn't have established evidence base — wired earbuds' EMF exposure is minimal and hasn't been shown to cause health effects. Would move to Standard 55+ if repositioned honestly as reduced-EMF earbuds for concerned users without disease-prevention framing.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "emf-protection-anti-radiation-blanket",
      "title": "EMF Protection Anti-Radiation Blanket",
      "vendor": "DefenderShield",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/defendershield-emf-protection-blanket-catalog-1.png?v=1786819128",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "emf",
        "protection",
        "anti",
        "radiation",
        "blanket",
        "defendershield"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "hrv_recovery_apps"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 42,
        "sustainability": 45
      },
      "price": 159.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741217345733",
      "vsf_explanation": "$160 EMF-shielding blanket. Auto-fail: unverified_medical_claim. Same rationale as other DefenderShield medical-claim EMF products. Would move to Standard 55+ with repositioning as niche RF-blocking product without the health-benefit framing.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "tablet-ipad-emf-radiation-protection-case",
      "title": "Tablet / iPad EMF Radiation Protection Case",
      "vendor": "DefenderShield",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/DefenderShield-Tablet-Catalog-1-Standard.webp?v=1786819138",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tablet",
        "ipad",
        "emf",
        "radiation",
        "protection",
        "case",
        "defendershield"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "hrv_recovery_apps"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 42,
        "sustainability": 45
      },
      "price": 104.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741217902789",
      "vsf_explanation": "$105 iPad EMF-shielding case. Auto-fail: unverified_medical_claim. Same rationale as other DefenderShield medical-claim EMF products. Would move to Standard 55+ with removal of radiation-health-protection framing.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "cell-phone-emf-protection-radiation-blocking-pouch",
      "title": "Cell Phone EMF Protection + Radiation Blocking Pouch",
      "vendor": "DefenderShield",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/PhonePouchMainImage.webp?v=1786819143",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cell",
        "phone",
        "emf",
        "protection",
        "radiation",
        "blocking",
        "pouch",
        "defendershield"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "hrv_recovery_apps"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 42,
        "sustainability": 45
      },
      "price": 44.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741217968325",
      "vsf_explanation": "Cell-phone RF-blocking pouch marketed for health protection. Auto-fail: unverified_medical_claim. Same as other DefenderShield EMF-health products. Note: same limitation applies — RF-blocking pouches around active phones can INCREASE phone transmit power (phone compensates for reduced signal by transmitting harder). Would move to Standard 55+ if repositioned as GPS/tracking-privacy pouch without health-benefit framing.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "emf-radiation-protection-baseball-cap",
      "title": "EMF Radiation Protection Baseball Cap",
      "vendor": "DefenderShield",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/defendershield-baseball-cap-catalog-image-1.webp?v=1786819146",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "emf",
        "radiation",
        "protection",
        "baseball",
        "cap",
        "defendershield"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "hrv_recovery_apps"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 42,
        "sustainability": 45
      },
      "price": 64.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741218001093",
      "vsf_explanation": "$65 EMF-shielding baseball cap. Auto-fail: unverified_medical_claim. Same as EMF sleep mask, hooded jacket, and other DefenderShield medical-claim products — physical RF blocking is real; the health benefit claim doesn't have evidence support. Would move to Standard 55+ with removal of health-protection framing.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "iphone-11-emf-blocking-wallet-case-with-5g-radiation-protection",
      "title": "iPhone 11 EMF Blocking Wallet Case with 5G Radiation Protection",
      "vendor": "DefenderShield",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/DefenderShield-iphone-x-black-case-1.webp?v=1786819156",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "iphone",
        "emf",
        "blocking",
        "wallet",
        "case",
        "with",
        "radiation",
        "protection",
        "defendershield"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "hrv_recovery_apps"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 52,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 33.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741218132165",
      "vsf_explanation": "iPhone case marketed for '5G radiation protection.' Auto-fail: unverified_medical_claim. 5G RF exposure at consumer-device levels doesn't have established health-effect evidence (FCC and ICNIRP RF exposure limits are non-thermal at levels below causing tissue heating; consumer 5G devices operate well below these limits). The '5G radiation protection' marketing category has been specifically flagged by regulators as consumer misinformation. Additionally: RF-blocking phone cases can actually INCREASE phone RF emission because the phone increases transmit power when signal is obstructed. Physical shielding is real — health-benefit claim is not. Would move to Standard 55+ with removal of 5G-protection framing.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "pregnancy-emf-radiation-protection-baby-belly-band",
      "title": "Pregnancy EMF Radiation Protection Baby Belly Band",
      "vendor": "DefenderShield",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/defendershield-belly-band-catalog-image-1.webp?v=1786819160",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pregnancy",
        "emf",
        "radiation",
        "protection",
        "baby",
        "belly",
        "band",
        "defendershield"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "hrv_recovery_apps"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 38,
        "sustainability": 45
      },
      "price": 94.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741218263237",
      "vsf_explanation": "$95 EMF-shielding belly band marketed to protect fetuses from EMF radiation during pregnancy. Auto-fail: unverified_medical_claim. Particularly concerning marketing category — targets pregnant women's anxiety about fetal safety without evidence support. WHO, FDA, ICNIRP, and multiple pediatric-medicine associations do NOT recommend EMF-shielding during pregnancy — there's no established fetal risk from consumer-device RF exposure that would warrant these products. This category has been criticized by obstetric societies as capitalizing on maternal anxiety with unfounded risk framing. Would move to Standard 55+ ONLY with removal of health-protection claims + honest disclaimers.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "blue-light-blocking-glasses-universal-fitover-series",
      "title": "Blue Light Blocking Glasses – Universal Fitover Series",
      "vendor": "DefenderShield",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/FitOver_Blue_Light_Glasses_50_Main_Image.webp?v=1786819163",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "blue",
        "light",
        "blocking",
        "glasses",
        "universal",
        "fitover",
        "series",
        "defendershield"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "hearables"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 65,
        "safety": 72,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 41.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741218328773",
      "vsf_explanation": "Fitover BLB glasses designed to wear over existing prescription glasses. Practical formulation choice for prescription-glass wearers. Same BLB-evidence caveats as other DefenderShield BLB SKUs.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "emf-radiation-protection-hooded-jacket",
      "title": "EMF Radiation Protection Hooded Jacket",
      "vendor": "DefenderShield",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/defendershield-jacket-catalog-image-1.webp?v=1786819169",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "emf",
        "radiation",
        "protection",
        "hooded",
        "jacket",
        "defendershield"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "hrv_recovery_apps"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 42,
        "sustainability": 45
      },
      "price": 379.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741218427077",
      "vsf_explanation": "$379 EMF-shielding hooded jacket. Auto-fail: unverified_medical_claim. Same as EMF sleep mask rationale — physical RF blocking is real; the marketed health benefit (protection from environmental RF at consumer-device levels) doesn't have established evidence. WHO/FDA/ICNIRP consensus on non-thermal RF absence of established health effects. $379 price for a product whose central health claim isn't evidence-supported. Would move to Standard 55+ with repositioning as niche privacy/RF-blocking apparel without the health-protection framing.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "emf-radiation-protection-sleep-mask",
      "title": "EMF Radiation Protection Sleep Mask",
      "vendor": "DefenderShield",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/defendershield-radiation-protection-sleep-mask-catalog-image-1.webp?v=1786819176",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "emf",
        "radiation",
        "protection",
        "sleep",
        "mask",
        "defendershield"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_environment"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 42,
        "sustainability": 45
      },
      "price": 42.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741218558149",
      "vsf_explanation": "EMF-shielding sleep mask marketed for radiation protection during sleep. Auto-fail: unverified_medical_claim. Sleep mask that blocks EMF from reaching the wearer's face during sleep — the marketed health benefit (EMF-radiation-related sleep disruption) doesn't have established evidence at consumer-device RF exposure levels. WHO, FDA, and ICNIRP all conclude non-thermal RF at typical bedroom exposure levels doesn't have established health effects. Product physically blocks RF as advertised (real functional shielding) — the auto-fail is on the health-benefit claim, not the physical shielding function. Would move to Standard 55+ if repositioned as pure light-blocking sleep mask (real evidence for that) without the EMF-health-benefit framing.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "blue-light-filter-supplement-lightbody®-total-eye-health",
      "title": "Blue Light Filter Supplement Lightbody® Total Eye Health",
      "vendor": "DefenderShield",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/square-1.jpg?v=1786819184",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "blue",
        "light",
        "filter",
        "supplement",
        "lightbody",
        "total",
        "eye",
        "health",
        "defendershield"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 52,
        "sustainability": 45
      },
      "price": 43.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741218721989",
      "vsf_explanation": "Eye-health supplement from DefenderShield's Lightbody line. Eye-health formulations typically include lutein + zeaxanthin (AREDS2-style macular support) + related antioxidants. Held below Verified by (1) full ingredient + dose breakdown not disclosed at product name; (2) DefenderShield's core competency is EMF-blocking hardware — supplement formulation is adjacent to their brand pedigree; (3) no third-party testing. Would move to Verified 70+ with ingredient disclosure + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "versa-blue-light-blocking-glasses-with-interchangeable-50-and-99-blocking-lenses",
      "title": "Versa Blue Light Blocking Glasses – with Interchangeable 50% and 99% Blocking Lenses",
      "vendor": "DefenderShield",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Versa_Blue_Light_Main_1.webp?v=1786819260",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "versa",
        "blue",
        "light",
        "blocking",
        "glasses",
        "with",
        "interchangeable",
        "and",
        "blocking",
        "lenses",
        "defendershield"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "hearables"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 68,
        "manufacturing": 65,
        "safety": 72,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 59.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741219082437",
      "vsf_explanation": "DefenderShield BLB glasses with interchangeable 50% and 99% blocking lenses — 50% for daytime moderate blocking, 99% for evening pre-sleep circadian protection. The 99% lens is the more evidence-supported use case (evening blue-light restriction for melatonin production per Chang 2015). Interchangeable design is a formulation plus. Held below Verified by same evidence limitations as the Signature Series.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "blue-light-blocking-glasses-signature-series",
      "title": "Blue Light Blocking Glasses – Signature Series",
      "vendor": "DefenderShield",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Signature_Blue_Light_Glasses_99_Image_1.webp?v=1786819265",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "blue",
        "light",
        "blocking",
        "glasses",
        "signature",
        "series",
        "defendershield"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "hearables"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 65,
        "safety": 72,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 46.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741219115205",
      "vsf_explanation": "Blue-light-blocking glasses. Evidence base for BLB glasses is mixed — Vagge 2020 and Sheppard 2020 systematic reviews found limited effect on eye strain in general populations; some individual subgroups (sensitive individuals, high-screen-time users) report benefit. American Academy of Ophthalmology position is that blue-light glasses aren't necessary for most people. Held below Verified by (1) mixed evidence base; (2) light-spectrum blocking specifications (which wavelengths, what %) not published; (3) circadian-benefit claims (blue light before bed disrupts melatonin) are more supported than eye-strain claims. Would move to Verified 70+ with published spectral-transmission specs + honest positioning around eye-strain vs circadian evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ultra-armor-cybersecurity-privacy-key-fob-faraday-bag",
      "title": "Ultra Armor Cybersecurity & Privacy Key Fob Faraday Bag",
      "vendor": "DefenderShield",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/defendershield-emf-protection-faraday-key-fob-pouch-catalog-1.webp?v=1786819274",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ultra",
        "armor",
        "cybersecurity",
        "privacy",
        "key",
        "fob",
        "faraday",
        "bag",
        "defendershield"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "hrv_recovery_apps"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 65,
        "safety": 68,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741219180741",
      "vsf_explanation": "Faraday bag for key fobs and cybersecurity/privacy applications. Legitimate non-medical use case: blocks RF signals to prevent relay-attack theft (car-key-fob signal amplification attacks are documented), and provides privacy from wireless tracking. Real functional product with a real security use case. Held below Verified by (1) sustainability profile thin; (2) key-fob-attack risk is real but modest for most consumers.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "emf-shielding-by-the-foot",
      "title": "EMF Shielding By The Foot",
      "vendor": "DefenderShield",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/defendershield-shielding-by-the-foot-1.webp?v=1786819284",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "emf",
        "shielding",
        "the",
        "foot",
        "defendershield"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "hrv_recovery_apps"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 53.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741219246277",
      "vsf_explanation": "Raw EMF-shielding fabric sold by the foot. Category note: consumer EMF-blocking products are marketed to reduce health effects from RF/wireless radiation, but WHO, FDA, and ICNIRP all conclude non-thermal RF at consumer device levels doesn't have established health effects. The fabric physically blocks RF as advertised (Faraday-cage principle) — that's a real function — but the health-benefit implication behind the product category doesn't have established evidence. Held below Standard by unclear specific use case for raw shielding fabric + health-marketing overhead. This SKU doesn't quite trigger the medical-claim auto-fail because it's sold as raw material rather than a medical-effect product.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "prevagen®-regular-strength-memory-improvement-supplement-30-capsules",
      "title": "Prevagen® Regular Strength – Memory Improvement Supplement (30 Capsules)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/105033637_da491a9e-9727-4fe5-85c6-504ba972ead6.jpg?v=1786820254",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "prevagen",
        "regular",
        "strength",
        "memory",
        "improvement",
        "supplement",
        "capsules",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 30,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 74.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741228978373",
      "vsf_explanation": "Prevagen Regular Strength — 'Memory Improvement Supplement' in product name. Auto-fail: unverified_disease_claim. Same apoaequorin evidence problem as other Prevagen SKUs. FTC v. Quincy Bioscience ongoing; Madison Memory Study didn't support advertised benefits; oral protein degrades in stomach before reaching brain.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "prevagen-improves-memory-chewables-tablets-mixed-berry-flavor",
      "title": "Prevagen Improves Memory, Chewables, Tablets, Mixed Berry Flavor",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/313853540_8fc3839f-bf0e-4397-8427-e86c5ba33b09.jpg?v=1786820268",
      "score": 22,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "prevagen",
        "improves",
        "memory",
        "chewables",
        "tablets",
        "mixed",
        "berry",
        "flavor",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 25,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 41.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741230649541",
      "vsf_explanation": "Prevagen chewable tablets — 'Improves Memory' branding literally states the medical/cognitive claim that FTC alleges is deceptive. Auto-fail: unverified_disease_claim. Same apoaequorin evidence problem as other Prevagen SKUs. The 'Improves Memory' claim explicit in the product name is particularly aggressive — most Prevagen SKUs use softer language.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "prevagen-extra-strength-capsules-30-count-6-pack-counter-display",
      "title": "Prevagen Extra Strength Capsules, 30 Count (6-Pack Counter Display)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ES30-FYB-0225-copy_9def213d-dd7a-454c-b111-8207a2fefc3d.webp?v=1786820274",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "prevagen",
        "extra",
        "strength",
        "capsules",
        "count",
        "pack",
        "counter",
        "display",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 30,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 305.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741230682309",
      "vsf_explanation": "Bulk 6-pack of Prevagen Extra Strength. Same auto-fail: unverified_disease_claim. Apoaequorin memory claims subject to FTC v. Quincy Bioscience (2017-); Madison Memory Study did not support advertised benefits; protein degrades in stomach before reaching brain. See the Prevagen Professional Formula SKU for full rationale. $305 for a 6-pack of a product with no credible mechanism is a significant cost + evidence gap.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "prevagen-professional-formula-capsules-30-ct",
      "title": "Prevagen Professional Formula Capsules 30 Ct",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/51956581.jpg?v=1786820284",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "prevagen",
        "professional",
        "formula",
        "capsules",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 30,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 89.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741230715077",
      "vsf_explanation": "Prevagen (apoaequorin) memory-improvement claims are subject to FTC v. Quincy Bioscience (2017, ongoing) alleging deceptive advertising. The Madison Memory Study — Prevagen's anchor trial — did not support the marketed benefits on its primary endpoints. Mechanistically, apoaequorin is a protein that is degraded to amino acids in the stomach before reaching brain tissue — there is no credible mechanism for oral apoaequorin to improve human memory. Auto-fail: unverified_disease_claim. Would move to Standard 55+ only with removal of memory-improvement claims + honest positioning around apoaequorin's actual (limited) evidence base. See /pages/methodology for the current list of auto-fail rules.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "vital-proteins-collagen-peptides-powder",
      "title": "Vital Proteins Collagen Peptides Powder",
      "vendor": "NutritionAdvice",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/41lDlEc-otL.jpg?v=1786820402",
      "score": 73,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vital",
        "proteins",
        "collagen",
        "peptides",
        "powder",
        "nutritionadvice"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 78,
        "manufacturing": 72,
        "safety": 75,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 34.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741231206597",
      "vsf_explanation": "Vital Proteins is the market-leader collagen brand — grass-fed bovine hydrolyzed peptides in the studied form + dose range (10-20g/day). Real evidence base for skin elasticity + joint comfort. Nestlé-owned since 2020 with continued brand-quality investment. Held below Elite by (1) some SKUs use added flavorings vs the plain unflavored option; (2) sustainability profile — grass-fed sourcing is a plus but broader sustainability certifications thin; (3) no third-party COA per SKU. Would move to Elite 85+ with published sustainability certification + per-SKU third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hearthy-foods-collagen-grass-fed-type-i-iii-peptides-16oz",
      "title": "Hearthy Foods - 'Collagen' Grass-Fed Type I & III Peptides (16OZ)",
      "vendor": "The Epicurean Trader",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9ac6eafe6fbe4a5ad5623b919de48195.jpg?v=1786820409",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hearthy",
        "foods",
        "collagen",
        "grass",
        "fed",
        "type",
        "iii",
        "peptides",
        "16oz",
        "the",
        "epicurean",
        "trader"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 70,
        "manufacturing": 58,
        "safety": 75,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 30,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741231501509",
      "vsf_explanation": "Hearthy Foods grass-fed Type I & III collagen peptides. Type I & III are the correct types for skin + hair + bone + tendon (Type II is joint-specific). Grass-fed sourcing + powder format for practical therapeutic dosing. Held below Verified by (1) small brand + reseller channel (The Epicurean Trader); (2) peptide MW profile not disclosed; (3) no third-party COA. Would move to Verified 70+ with peptide size disclosure + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "grass-fed-hydrolyzed-collagen-peptides-9-9-oz",
      "title": "Grass-Fed Hydrolyzed Collagen Peptides, 9.9 oz",
      "vendor": "Minimo Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1752345500662-generated-label-image-0.jpg?v=1786820418",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "grass",
        "fed",
        "hydrolyzed",
        "collagen",
        "peptides",
        "minimo",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 70,
        "manufacturing": 60,
        "safety": 75,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741231534277",
      "vsf_explanation": "Grass-fed hydrolyzed collagen peptides from Minimo Nutrition — powder format allows practical therapeutic dosing (10-20g per serving). Grass-fed sourcing is a real quality plus. Held below Verified by (1) small brand without established quality track record; (2) peptide molecular-weight profile not disclosed; (3) no third-party COA. Would move to Verified 70+ with peptide size disclosure + third-party COA + established brand credibility.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "optimum-gold-standard-isolate-protein-930-gr",
      "title": "Optimum Gold Standard Isolate Protein 930 Gr",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/optimum_gold_standard_isolate_protein_930_gr_96537.jpg?v=1786820443",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "optimum",
        "gold",
        "standard",
        "isolate",
        "protein",
        "930",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 75,
        "manufacturing": 72,
        "safety": 75,
        "transparency": 68,
        "sustainability": 45
      },
      "price": 139.87,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741231599813",
      "vsf_explanation": "Optimum Nutrition Gold Standard Whey Isolate — mainstream sports-nutrition reference-quality whey protein. Whey isolate has extensive RCT support for muscle protein synthesis (Jäger 2017 ISSN position stand). Optimum Nutrition has real manufacturing scale + reasonable quality track record. Whey isolate is higher-purity than concentrate (>90% protein vs ~80%). Held below Elite by (1) not NSF Certified for Sport visible on this SKU (though Gold Standard 100% Whey concentrate line is Informed Choice certified); (2) high-price point + significant use of artificial flavorings/colors depending on flavor; (3) sustainability profile thin. Would move to Elite 85+ with NSF sport cert + cleaner flavoring.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "childlife®-first-defense-immune-formula-4-fl-oz",
      "title": "ChildLife® First Defense Immune Formula (4 fl oz)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/227083730.jpg?v=1786821029",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "childlife",
        "first",
        "defense",
        "immune",
        "formula",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 70,
        "manufacturing": 65,
        "safety": 68,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741239365829",
      "vsf_explanation": "ChildLife First Defense — established pediatric-supplement brand with liquid immune-support formulation for kids. Typically contains elderberry + zinc + vitamin C + echinacea in pediatric-appropriate doses. Held below Verified by (1) sold via a third-party reseller — ChildLife's direct-brand quality documentation is stronger; (2) pediatric dosing warrants pediatrician awareness particularly for zinc + echinacea long-term use; (3) no third-party COA visible for pediatric-safety-critical batch testing. Would move to Verified 70+ with published pediatric-safety COA + third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-d3-k2",
      "title": "Vitamin D3 & K2",
      "vendor": "Purishh",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/FirstImage_4adbca59-5f55-404a-96b2-8de29f46c939.jpg?v=1786821047",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "purishh"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 50,
        "safety": 72,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 37,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741239398597",
      "vsf_explanation": "Purishh D3 + K2 combo. Combined formulation is correct approach. Held below Verified by (1) per-nutrient doses not visible; (2) K2 form (MK-7 vs MK-4) not specified; (3) delivery format (softgel vs tablet) not specified; (4) small brand. Would move to Verified 70+ with dose + form + delivery disclosure + named manufacturer detail.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "source-magnesium",
      "title": "Source Magnesium",
      "vendor": "Purishh",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/FirstImage.jpg?v=1786821051",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "source",
        "magnesium",
        "purishh"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 70,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 37,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741239464133",
      "vsf_explanation": "Purishh 'Source Magnesium' — form not specified in product name (which is essential info for magnesium — glycinate vs citrate vs threonate all have dramatically different use cases). See /blogs/news/beyond-glycinate-which-magnesium-form-for-which-goal for form-choice rationale. Held below Verified by (1) magnesium form not disclosed at product name; (2) elemental mg not specified; (3) small brand. Would move to Verified 70+ with named form + elemental dose disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "creatine-monohydrate-5",
      "title": "Creatine Monohydrate",
      "vendor": "Purishh",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2_330b1e52-c84d-4ae9-ade8-376d62210210.jpg?v=1786821058",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "creatine",
        "monohydrate",
        "purishh"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 82,
        "formulation": 62,
        "manufacturing": 50,
        "safety": 78,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741239529669",
      "vsf_explanation": "Purishh Creatine Monohydrate. Monohydrate is the correct form (see /blogs/news/best-creatine-supplements-2026-monohydrate-guide). Purishh is a small brand — the creatine molecule is well-studied but sourcing/purity matters (creatinine + dicyandiamide impurities are documented in cheap Chinese-sourced creatine). Held below Verified by (1) Creapure® or other named sourcing not confirmed at product name; (2) no NSF Certified for Sport designation; (3) small brand without established track record. Would move to Verified 70+ with Creapure sourcing + NSF sport cert.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "olympian-labs-vitamin-k2-d3-60-capsules",
      "title": "Olympian Labs Vitamin K2 + D3 (60 Capsules)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/38162762.jpg?v=1786821077",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "olympian",
        "labs",
        "vitamin",
        "capsules",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 58,
        "sustainability": 45
      },
      "price": 11.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741239595205",
      "vsf_explanation": "Olympian Labs D3 + K2 combo at budget-friendly price ($11.59). Olympian Labs is a mainstream mid-tier brand. Held below Verified by (1) per-nutrient doses not visible in product name; (2) K2 form not specified; (3) no third-party testing visible. Would move to Verified 70+ with dose + form + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ortho-molecular-products-vitamin-k2-with-d3-60-caps",
      "title": "Ortho Molecular Products Vitamin K2 With D3 60 Caps",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/62177596_b0313824-4827-4a81-bdfb-100407cf2676.jpg?v=1786821083",
      "score": 75,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ortho",
        "molecular",
        "products",
        "vitamin",
        "with",
        "caps",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 78,
        "manufacturing": 80,
        "safety": 75,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 33.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741239759045",
      "vsf_explanation": "Ortho Molecular Products (OMP) K2 + D3 combo. OMP is a legit practitioner-facing brand — sold primarily through licensed practitioners, focused on formulation quality + practitioner protocols. Real manufacturing pedigree. K2 + D3 combo formulation choice is correct. Held below Elite by (1) sustainability profile thin; (2) sold via a third-party reseller — OMP's direct-to-practitioner channel is stronger. Would move to Elite 85+ with sustainability data.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nature-made-vitamin-k2-100-mcg-softgels-30-count-for-bone-health",
      "title": "Nature Made Vitamin K2 100 Mcg Softgels, 30 Count For Bone Health",
      "vendor": "Nature Made",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/308472817.jpg?v=1786821095",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "made",
        "vitamin",
        "100",
        "mcg",
        "softgels",
        "count",
        "for",
        "bone",
        "health",
        "nature",
        "made"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 75,
        "manufacturing": 78,
        "safety": 75,
        "transparency": 72,
        "sustainability": 50
      },
      "price": 19.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741239791813",
      "vsf_explanation": "Nature Made K2 100 mcg softgels — standalone K2 at studied dose in softgel format. Nature Made carries USP Verified certification on many SKUs. Standalone K2 lets you dose it separately from D3 (useful for people already on a high-dose D3 without K2). Held below Elite by (1) K2 form (MK-4 vs MK-7) not confirmed at product name — MK-7 is preferred; (2) sustainability profile thin. Would move to Elite 85+ with confirmed MK-7 form + published sustainability data.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-d3-k2-soft-capsules",
      "title": "Vitamin D3 K2 Soft Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/00131c4e-d929-40ee-83d1-e088a367d6cb.jpg?v=1786821104",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "soft",
        "capsules",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 50,
        "safety": 72,
        "transparency": 52,
        "sustainability": 45
      },
      "price": 33.74,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741239824581",
      "vsf_explanation": "Vivalo D3+K2 softgel. Softgel format is correct choice for D3 absorption. Held below Verified by (1) small vendor Vivalo with limited quality track record; (2) per-nutrient doses not disclosed at product name; (3) K2 form (MK-4 vs MK-7) not specified. Would move to Verified 70+ with named manufacturer + dose + form disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-encapsulations-vitamin-d3-k2-100-100-mcg",
      "title": "Pure Encapsulations Vitamin D3 & K2 100/100 Mcg",
      "vendor": "Pure Encapsulations",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/235062248.png?v=1786821112",
      "score": 83,
      "tier": "elite",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "encapsulations",
        "vitamin",
        "100",
        "100",
        "mcg",
        "pure",
        "encapsulations"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 82,
        "manufacturing": 78,
        "safety": 75,
        "transparency": 75,
        "sustainability": 55
      },
      "price": 33.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741239988421",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 78 → new 83. Evidence found: Van Ballegooijen AJ et al. The Synergistic Interplay between Vitamins D and K for Bone and Cardiovascular Health. Int J Endocrinol. 2017;2017:7454376. | Knapen MH et al. Three-year low-dose menaquinone-7 supplementation helps decrease bone loss in healthy postmenopausal women. Osteoporos Int. 2013;24(9):2499-2507 (MenaQ7 evidence).. Rationale: Combines 100 mcg (4000 IU) D3 with 100 mcg K2 as MenaQ7 (MK-7). This is the therapeutic-dose combination for bone and vascular calcium partitioning. Practitioner-grade hypoallergenic formulation. Elite tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "d3-k2-calcium",
      "title": "D3 & K2 + CALCIUM",
      "vendor": "2.0 Lifestyle",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d3-k2-calcium20-lifestyle-620950.jpg?v=1786821120",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "calcium",
        "lifestyle"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 68,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 58,
        "sustainability": 45
      },
      "price": 16,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741240053957",
      "vsf_explanation": "D3 + K2 + Calcium tri-blend from 2.0 Lifestyle. Comprehensive bone-health formulation approach with the K2/D3 pair to properly direct supplemental calcium. Held below Verified by (1) small brand '2.0 Lifestyle' without established track record; (2) per-nutrient doses not visible in product name; (3) calcium form (carbonate vs citrate) not specified. Would move to Verified 70+ with per-nutrient dose + calcium form disclosure + named manufacturer detail.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ocean-d3k2-vitamin-d3-k2-supplement-for-adults-liquid-drops-for-bone-immune-health",
      "title": "Ocean D3K2 Vitamin D3 & K2 Supplement for Adults - Liquid Drops for Bone & Immune Health",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/KpX5QSyIQJVfNi08GPJCdgCgXPRpS5wCujfFNw0w.jpg?v=1786821140",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ocean",
        "d3k2",
        "vitamin",
        "supplement",
        "for",
        "adults",
        "liquid",
        "drops",
        "for",
        "bone",
        "immune",
        "health",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 72,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 20.28,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741240086725",
      "vsf_explanation": "Ocean D3+K2 liquid drops. Liquid delivery aids flexible dosing + absorption (D3 fat-soluble; drops typically in oil vehicle). Held below Verified by (1) 'Ocean' branding without established manufacturer track record; (2) D3 IU + K2 mcg per drop not visible in product name; (3) no third-party testing visible. Would move to Verified 70+ with dose disclosure + named manufacturer + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-vitamin-k2-d3-100-mcg-vegetable-capsules",
      "title": "Nature's Bounty Vitamin K2 + D3, 100 Mcg, Vegetable Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/148223770.png?v=1786821151",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "vitamin",
        "100",
        "mcg",
        "vegetable",
        "capsules",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 68,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 13.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741240119493",
      "vsf_explanation": "Nature's Bounty K2 + D3 combo. Nature's Bounty (Nestlé Health Science) has real manufacturing scale. K2 + D3 combo is the correct formulation approach for long-term supplementation. Held below Verified by (1) K2 form (MK-7 preferred) not clearly specified; (2) D3 dose not visible in product name; (3) no USP verification on this SKU. Would move to Verified 70+ with MK-7 disclosure + USP verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mason-natural-vitamin-k2-100-mcg-plus-d3-1000-iu-tablets",
      "title": "Mason Natural Vitamin K2 100 Mcg Plus D3 1000 Iu Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/49201329.jpg?v=1786821168",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mason",
        "natural",
        "vitamin",
        "100",
        "mcg",
        "plus",
        "1000",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 62,
        "sustainability": 45
      },
      "price": 8.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741240152261",
      "vsf_explanation": "Mason Natural D3 + K2 combined ($8.39). Mass-market budget brand with real US manufacturing base. K2 (100mcg) at studied dose range; D3 (1000 IU) at maintenance dose. Held below Verified by (1) tablet format (vs softgel with oil) reduces D3 absorption ~50%; (2) K2 form (MK-4 vs MK-7) not specified — MK-7 is preferred for longer half-life and better cardiovascular data; (3) Mason Natural quality tier is budget mass-retail. Would move to Verified 70+ with softgel format + MK-7 disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nbtlife-treon-magnesium-l-threonate-vitamin-d3-k2-b6-bone-strength-overall-wellness-90-capsules",
      "title": "NBTLife Treon: Magnesium L-Threonate, Vitamin D3 K2 & B6 - , Bone Strength & Overall Wellness (90 Capsules)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/mcFPi4UJLSKP1gAMkvVeG4TkvZlieLjVJTWwydWk_517405a0-e297-4981-b862-fe973bc946cf.jpg?v=1786821177",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nbtlife",
        "treon",
        "magnesium",
        "threonate",
        "vitamin",
        "bone",
        "strength",
        "overall",
        "wellness",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 75,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 71.55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741240185029",
      "vsf_explanation": "Combined formulation: Magnesium L-Threonate (Magtein-format for CNS penetration) + Vitamin D3 + K2 + B6. Interesting formulation — Magtein for cognition + D3/K2 for calcium partitioning + B6 as cofactor for magnesium cellular uptake. All actives at reasonable doses. Held below Verified by (1) NBTLife is smaller brand with less established quality track record vs Life Extension or Neurohacker; (2) per-active mg not visible in product name; (3) sold via a third-party reseller; (4) $71 price for combo product is reasonable if each active is at studied dose. Would move to Verified 70+ with published per-active dose + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "force-factor®-vitamin-d3-k2-120-vegetable-capsules",
      "title": "Force Factor® Vitamin D3 & K2 – 120 Vegetable Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/233145155.webp?v=1786821188",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "force",
        "factor",
        "vitamin",
        "120",
        "vegetable",
        "capsules",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 8.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741240283333",
      "vsf_explanation": "Force Factor D3 + K2 combined product at $8.59 — very budget-friendly for a D3+K2 combo. Force Factor is a mainstream sports-supplement brand. D3+K2 combo is a real formulation positive over standalone D3 for long-term high-dose supplementation. Held below Verified by (1) D3 and K2 mg/mcg amounts not visible in product name; (2) Force Factor's brand reputation is mid-tier — some SKUs in their line have quality concerns; (3) no third-party testing visible. Would move to Verified 70+ with per-nutrient dose disclosure + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "papaya-supplement",
      "title": "Papaya Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3d6e311e-6e89-4cff-ad86-6c1313b2354c.jpg?v=1786821206",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "papaya",
        "supplement",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 65,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 18.22,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741240348869",
      "vsf_explanation": "Generic 'Papaya Supplement' from Vivalo. Papaya (Carica papaya) is traditionally used for digestive enzyme content (papain) but supplement evidence for stated benefits is thin. Held below Standard by (1) papain enzyme activity units not specified (matters for digestive claims); (2) fruit-part (seed, leaf, fruit) not specified; (3) small vendor. Would move to Standard 55+ with papain activity spec + plant-part disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "health-care-products-oregano-oil-capsule-dietary-supplement-soft-capsules-1",
      "title": "Health Care Products Oregano Oil Capsule Dietary Supplement Soft Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/163d4fb6-246d-4850-9ace-d0bb08f1f4a5_457b6a9b-661c-4707-8e79-ec32338d2db3.jpg?v=1786821217",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "health",
        "care",
        "products",
        "oregano",
        "oil",
        "capsule",
        "dietary",
        "supplement",
        "soft",
        "capsules",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 23.32,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741240447173",
      "vsf_explanation": "Oregano oil softgel — same product-family as earlier 'My Store'-branded oregano oil that scored Rejected. Vivalo branding is slightly more accountable than 'My Store' unnamed vendor but still limited quality trace. Held below Standard by (1) carvacrol content (oregano's primary antimicrobial active) not disclosed; (2) drug-interaction warnings (anticoagulant additive effect) not prominent; (3) 'Health Care Products' generic sub-brand naming. Would move to Standard 55+ with carvacrol standardization + safety warnings + named manufacturer chain.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bsys-l-carnitine-l-tartrate-60s",
      "title": "BSYS L-Carnitine L-Tartrate 60's",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0c8dffd0-e77b-4047-8328-ba4c1888408d.jpg?v=1786821226",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bsys",
        "carnitine",
        "tartrate",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 50,
        "safety": 68,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 66.36,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741240611013",
      "vsf_explanation": "L-Carnitine L-Tartrate — the specific form used in most exercise-recovery RCT research (Volek 2002 on recovery markers; Broad 2005 on high-intensity exercise). Correct form choice for athletic-recovery use case. Held below Verified by (1) 'BSYS' as brand within Vivalo reseller — unclear manufacturer chain; (2) per-cap mg not disclosed at product name; (3) no third-party assay. Would move to Verified 70+ with dose disclosure + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "collagen-capsule",
      "title": "Collagen Capsule",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3fb324d5-9e40-44ed-bbf7-8332f657a925.jpg?v=1786821235",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "collagen",
        "capsule",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 68,
        "transparency": 38,
        "sustainability": 45
      },
      "price": 28.44,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741240676549",
      "vsf_explanation": "Generic 'Collagen Capsule' from Vivalo. Held below Standard by (1) capsule format is dose-limited (2.5-15g collagen studied dose is impractical in capsules — need ~5-30 capsules per day); (2) collagen source (bovine, marine, chicken) not disclosed — affects amino acid profile + peptide characteristics; (3) hydrolyzed vs non-hydrolyzed status unclear; (4) small vendor. Would move to Standard 55+ with source + hydrolysis + per-cap protein disclosure OR reformulation to powder format for practical therapeutic dosing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hydrogen-water-ionizer-bottle",
      "title": "Hydrogen Water Ionizer Bottle",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2771440375629.jpg?v=1786821248",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hydrogen",
        "water",
        "ionizer",
        "bottle",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 42,
        "safety": 55,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 157.26,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741240905925",
      "vsf_explanation": "$157 hydrogen-water ionizer bottle from Vivalo. Molecular hydrogen has real emerging research (Ohta 2012 review) but the effective dose depends on actual dissolved H2 concentration achieved (typically measured in ppm). Held below Standard by (1) hydrogen concentration output spec (ppm) not disclosed — this is the entire quality metric for H2-generating devices; (2) electrolysis-based ionizers vary widely in actual H2 output; (3) small vendor with no electrical safety certification visible; (4) $157 price for undocumented-output device is above competitors with published specs. Would move to Standard 55+ with published dissolved H2 output spec + electrical safety cert.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "joint-and-bone-health-supplements",
      "title": "Joint And Bone Health Supplements",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b397e551-17ef-4840-8a71-9f0345caa575.jpg?v=1786821255",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "joint",
        "and",
        "bone",
        "health",
        "supplements",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 62,
        "transparency": 38,
        "sustainability": 45
      },
      "price": 14.82,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741241397445",
      "vsf_explanation": "Generic 'Joint and Bone Health Supplements' from Vivalo. Held below Standard by (1) product name doesn't identify actual ingredients — typical joint/bone formulations include glucosamine + chondroitin + MSM + collagen + calcium + D3 + K2, but which combo isn't disclosed at product name; (2) small vendor; (3) 'health support' language is aspirational without specifying which underlying condition/mechanism. Would move to Standard 55+ with full ingredient + dose disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "health-vinegar-capsules",
      "title": "Health Vinegar Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/619aca01-e545-48e4-9fab-758502c46e40.jpg?v=1786821259",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "health",
        "vinegar",
        "capsules",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 48,
        "manufacturing": 48,
        "safety": 62,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 31.23,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741241495749",
      "vsf_explanation": "Apple cider vinegar capsules from Vivalo. ACV weight-loss + glucose-modulation claims have mixed evidence — most studies use liquid ACV pre-meal at 15-30 mL, not capsule form. Effect sizes are modest. Held below Standard by (1) capsule ACV loses much of the theoretical mechanism (delayed gastric emptying) that liquid ACV provides pre-meal; (2) 'Health Vinegar' branding is vague; (3) no acetic acid % standardization at label; (4) small vendor. Would move to Standard 55+ with acetic acid standardization + honest positioning vs studied liquid-format effect.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "collagen-peptide-gummies",
      "title": "Collagen Peptide Gummies",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6d1fec3d-0b11-4c67-8a61-2303b7158c9e.jpg?v=1786821267",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "collagen",
        "peptide",
        "gummies",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 48,
        "safety": 68,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 44.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741241528517",
      "vsf_explanation": "Generic collagen peptide gummies from Vivalo. Collagen supplementation has real evidence for skin elasticity (Proksch 2014) and joint comfort (Zdzieblik 2015) at 2.5-15g/day hydrolyzed peptide doses. Gummy format typically delivers 1-2g peptide per serving — sub-therapeutic vs the studied protein doses. Held below Verified by (1) sub-therapeutic gummy delivery; (2) small vendor without established quality track record; (3) peptide molecular weight not disclosed. Would move to Verified 70+ with higher-dose format (powder) or transparent-tier vendor.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "7-day-colon-cleanse-detox-formula-capsulese",
      "title": "7-Day Colon Cleanse & Detox Formula Capsulese",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/024dce3c-741d-4535-a04c-efe8535bc635.jpg?v=1786821278",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "day",
        "colon",
        "cleanse",
        "detox",
        "formula",
        "capsulese",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 40,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 69.11,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741241561285",
      "vsf_explanation": "'7-Day Colon Cleanse & Detox Formula' — auto-fail: unverified_medical_claim. 'Colon cleanse' and 'detox' claims are not supported by established evidence; the human body has functional liver + kidney detoxification systems that don't require supplemental 'cleansing.' Additionally, colon-cleanse products typically include senna, cascara, or other stimulant laxatives — real safety concern with chronic use (dependency, colonic melanosis, electrolyte imbalance). The '7-day' framing and 'detox' language are FDA/FTC flagged as unsupported wellness claims. Small brand (Vivalo). Would move to Standard 55+ with removal of 'detox/cleanse' claims + honest positioning around herbal-laxative safety + dependency warnings.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "pure-encapsulations-pure-bromelain-2400-vegan-bromelain-supplement-for-digestive-health-gluten-free-capsules",
      "title": "Pure Encapsulations Pure Bromelain 2400 - Vegan Bromelain Supplement for Digestive Health, Gluten-Free Capsules",
      "vendor": "Pure Encapsulations",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Lx4z8Y1rRBWxIKgsESQ4vIeU1hbXWDiWl1B5umV6.jpg?v=1786821334",
      "score": 78,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "encapsulations",
        "pure",
        "bromelain",
        "2400",
        "vegan",
        "bromelain",
        "supplement",
        "for",
        "digestive",
        "health",
        "gluten",
        "free",
        "capsules",
        "pure",
        "encapsulations"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 78,
        "manufacturing": 78,
        "safety": 72,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 50.96,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741241725125",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 72 → new 78. Evidence found: Brien S et al. Bromelain as a Treatment for Osteoarthritis. Evid Based Complement Alternat Med. 2004;1(3):251-257. | Walker AF et al. Bromelain reduces mild acute knee pain. Phytomedicine. 2002;9(8):681-686.. Rationale: '2400' refers to 2400 GDU (gelatin digesting units)/g — a high-potency bromelain standardization. Practitioner-grade purity plus explicit potency labeling. Uplift to 78; below Elite because bromelain evidence base is TIER-B rather than TIER-A.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-inositol-500-mg-100-vegetable-capsules",
      "title": "Solgar Inositol 500 Mg - 100 Vegetable Capsules",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/182713188.png?v=1786821442",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "inositol",
        "500",
        "100",
        "vegetable",
        "capsules",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 78,
        "safety": 72,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 17.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741243560133",
      "vsf_explanation": "Solgar Inositol (myo-inositol) 500mg. Inositol has real evidence for PCOS symptom management (Regidor 2018 review at 2-4g/day myo-inositol + D-chiro-inositol) and modest evidence for anxiety/OCD (Palatnik 2001 at 18g/day — much higher than typical supplement dose). Held below Verified by (1) 500mg is sub-therapeutic for PCOS or anxiety endpoints (studied doses 2-18g); need 4-36 caps daily; (2) myo-inositol vs D-chiro-inositol form + ratio not specified — matters for PCOS use; (3) higher-dose SKUs (2g scoops) are more practical for actual therapeutic use.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-l-tyrosine-500-mg-50-vegetable-capsules",
      "title": "Solgar L-Tyrosine 500 Mg, 50 Vegetable Capsules",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/72454590.jpg?v=1786821485",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "tyrosine",
        "500",
        "vegetable",
        "capsules",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 78,
        "safety": 72,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 13.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741243855045",
      "vsf_explanation": "Solgar L-Tyrosine 500mg (50-count smaller SKU). Same formula and evidence as the 100-count SKU — see that product's explanation for full detail.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-encapsulations-essential-c-flavonoids-180-capsules",
      "title": "Pure Encapsulations Essential- C & Flavonoids 180 Capsules",
      "vendor": "Pure Encapsulations",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/161709251_4bfe16e5-8cb4-4f6d-b4bd-eee25c437f18.jpg?v=1786821503",
      "score": 80,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "encapsulations",
        "essential",
        "flavonoids",
        "180",
        "capsules",
        "pure",
        "encapsulations"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 82,
        "manufacturing": 78,
        "safety": 75,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 43.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741244838085",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 75 → new 80. Evidence found: Padayatty SJ et al. Vitamin C as an antioxidant: evaluation of its role in disease prevention. J Am Coll Nutr. 2003;22(1):18-35. | Hemilä H, Chalker E. Vitamin C for preventing and treating the common cold. Cochrane Database Syst Rev. 2013;1:CD000980.. Rationale: Vitamin C paired with citrus bioflavonoids (hesperidin, rutin, quercetin) — the traditional whole-food-inspired synergy. Practitioner-grade hypoallergenic formulation. Uplift to 80.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-encapsulations-pure-active-complex-30-capsules-vegan-gluten-free-multivitamin",
      "title": "Pure Encapsulations Pure Active Complex 30 Capsules - Vegan, Gluten-Free Multivitamin",
      "vendor": "Pure Encapsulations",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/UcJrRfyFgUODIDI7L4u3NVSDb9b45T3A42pbpMOD_1e905a57-1143-406a-bb30-288c369b6c70.jpg?v=1786821517",
      "score": 80,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "encapsulations",
        "pure",
        "active",
        "complex",
        "capsules",
        "vegan",
        "gluten",
        "free",
        "multivitamin",
        "pure",
        "encapsulations"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 82,
        "manufacturing": 75,
        "safety": 75,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 52.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741244870853",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 76 → new 80. Evidence found: Pure Active Complex: vegan-formulated multivitamin with bioactive B forms, K2, D3 (vegan D3 sourced from lichen).. Rationale: Vegan practitioner-grade multi with bioactive B forms and lichen-sourced D3 (unlike most D3 products which use lanolin/wool). Uplift to 80.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-l-carnitine-60-capsules",
      "title": "Pure L-Carnitine 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/pure-l-carnitine-60-kapsul--4bea_a2f8f85d-4ca1-4cf0-9a7f-d9308d610fd2.jpg?v=1786821542",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "carnitine",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 48,
        "safety": 68,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 51.76,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741244903621",
      "vsf_explanation": "Generic 'Pure L-Carnitine' via reseller. L-Carnitine has real cardiovascular evidence (DiNicolantonio 2013 meta-analysis) at 1000-3000mg/day. Held below Verified by (1) per-cap mg not disclosed at product name; (2) carnitine form (L-carnitine vs acetyl-L-carnitine vs L-carnitine L-tartrate) not specified — different forms have different tissue targeting; (3) 'Pure' branding via reseller = unclear manufacturer. Would move to Verified 70+ with form + dose disclosure + named manufacturer.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-vitamin-c-1000mg-250-vegetable-capsules",
      "title": "Solgar Vitamin C 1000mg 250 Vegetable Capsules",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33984032811.png?v=1786821549",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "vitamin",
        "1000mg",
        "250",
        "vegetable",
        "capsules",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 65,
        "manufacturing": 78,
        "safety": 75,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 40.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741244969157",
      "vsf_explanation": "Solgar Vitamin C 1000mg — 250-count bulk option. Same evidence base as the smaller SKU. Vitamin C real evidence for immune support (Hemilä 2013 Cochrane) and antioxidant function. Held below Verified by (1) ascorbic acid form is basic (buffered/mineral-ascorbate is gentler); (2) split dosing (500mg 2×/day) has better bioavailability than 1000mg single dose but not addressed at label; (3) not liposomal. Would move to Verified 70+ with liposomal or mineral-ascorbate formulation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-l-tyrosine-500mg-100-vegetables-capsules",
      "title": "Solgar L-Tyrosine 500mg 100 Vegetables Capsules",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33984027619.png?v=1786826462",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "tyrosine",
        "500mg",
        "100",
        "vegetables",
        "capsules",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 78,
        "safety": 72,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 24.6,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741619278021",
      "vsf_explanation": "Solgar L-Tyrosine 500mg. L-Tyrosine is a dopamine/norepinephrine precursor with real evidence for cognitive performance under stress (Deijen 1999 military cold-stress trials; Colzato 2013 working memory) at 500-2000mg doses. 500mg per cap allows flexible dosing. Solgar manufacturing quality. Held below Verified by (1) trial-effective doses are typically 500-2000mg pre-stressor; single-cap of 500mg may be sub-therapeutic for some use cases; (2) no third-party assay. Would move to Verified 70+ with higher-dose SKU + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-choline-350-mg-100-vegetable-capsules",
      "title": "Solgar Choline 350 Mg, 100 Vegetable Capsules",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/345566415.jpg?v=1786826490",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "choline",
        "350",
        "100",
        "vegetable",
        "capsules",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 78,
        "safety": 72,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 17.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741620097221",
      "vsf_explanation": "Solgar Choline 350mg. Choline is an essential nutrient with roles in cell membrane synthesis + acetylcholine production + methylation. Standard adequate-intake target for adults is 425-550mg/day; typical diet often falls short. Solgar manufacturing quality. Held below Verified by (1) choline form (bitartrate vs alpha-GPC vs CDP-choline) affects both cost AND bioavailability + brain penetration — form not specified; (2) 350mg is single-dose serving; combined with dietary intake usually adequate; (3) high-dose choline can produce fishy body odor (TMA metabolism) — safety-warning consideration for chronic high-dose users. Would move to Verified 70+ with form disclosure + higher-bioavailability form (alpha-GPC or CDP-choline).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-vitamin-b2-riboflavin-100-mg-100-vegetable-capsules",
      "title": "Solgar Vitamin B2 (Riboflavin) 100 mg 100 Vegetable Capsules",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33984030503.png?v=1786826516",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "vitamin",
        "riboflavin",
        "100",
        "100",
        "vegetable",
        "capsules",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 68,
        "manufacturing": 78,
        "safety": 72,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 12.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741621211333",
      "vsf_explanation": "Solgar Riboflavin (B2) 100mg. B2 has real evidence for migraine prophylaxis at 400mg/day (Schoenen 1998 anchor RCT). 100mg is a maintenance dose — for migraine prophylaxis you'd need 4 capsules daily. Solgar practitioner-grade manufacturing. Held below Verified by (1) 100mg is below the migraine-prophylaxis studied dose; (2) no third-party COA visible on this SKU; (3) sustainability profile thin. Would move to Verified 70+ with a 400mg SKU option + third-party assay.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-b-complex-30-capsules",
      "title": "Pure B Complex 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/pure-b-complex-30-kapsul-b8-b7f.jpg?v=1786826543",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "complex",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 55,
        "manufacturing": 48,
        "safety": 65,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 27.02,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741622816965",
      "vsf_explanation": "Generic 'Pure B Complex' via a third-party reseller. Held below Verified by (1) per-B-vitamin mg/mcg amounts not disclosed at product name; (2) B12 form (methylcobalamin vs cyanocobalamin) + folate form (5-MTHF vs folic acid) not specified — the two most-relevant differentiators for B-complex quality; (3) 'Pure' branding = unclear manufacturer. Would move to Verified 70+ with bioactive-form + per-vitamin dose disclosure + named manufacturer.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-vitamin-c-buffered-670-mg-30-capsules",
      "title": "Pure Vitamin C Buffered 670 mg 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/pure-vitamin-c-buffered-670-mg-30-kaps--4c46.jpg?v=1786826594",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "vitamin",
        "buffered",
        "670",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 50,
        "safety": 72,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 32.52,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741625569477",
      "vsf_explanation": "Buffered vitamin C 670mg. Buffered (mineral-ascorbate) form is gentler on stomach than ascorbic acid. Vitamin C evidence for immune support + antioxidant function is real. Held below Verified by (1) 'Pure' branding via reseller = unclear manufacturer; (2) buffering mineral (calcium/magnesium/potassium ascorbate) not specified — affects mineral load; (3) 670mg is a moderate dose (RDA 75-90 mg; therapeutic dosing typically 500-1000mg split). Would move to Verified 70+ with named manufacturer + buffering-mineral disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "moringa-pure-1",
      "title": "Moringa Pure",
      "vendor": "Vitalidad Natural",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1784702089962-generated-label-image-0.png?v=1786826624",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "moringa",
        "pure",
        "vitalidad",
        "natural"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 68,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 20.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741627404485",
      "vsf_explanation": "Moringa oleifera supplement from small brand Vitalidad Natural. Moringa has traditional-use history + modest emerging clinical evidence for blood sugar and inflammation markers. Nutrient-dense green with real vitamins/minerals. Held below Verified by (1) leaf/seed/root part not specified — different plant parts have different active compound profiles; (2) small brand without prominent third-party testing; (3) standardization of active compounds (glucosinolates, isothiocyanates) not disclosed. Would move to Verified 70+ with plant-part + standardization disclosure + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "platinum-turmeric",
      "title": "Platinum Turmeric",
      "vendor": "Vitalidad Natural",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1784701518224-generated-label-image-0.png?v=1786826632",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "platinum",
        "turmeric",
        "vitalidad",
        "natural"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 48,
        "safety": 65,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 20.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741627666629",
      "vsf_explanation": "Turmeric supplement from small brand Vitalidad Natural. Held below Verified by (1) 'Platinum' branding aspirational without specific formulation differentiator disclosed; (2) curcumin standardization % not disclosed at label; (3) bioavailability enhancer (piperine/phytosome/liposomal) not confirmed — see /blogs/news/best-turmeric-curcumin-supplements-2026-bioavailability-guide for why this matters; (4) small brand with limited quality visibility. Would move to Standard 55+ with standardization + enhancer disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-mineral-multimineral-dietary-supplement-90-capsules-for-general-health-support",
      "title": "Pure Mineral Multimineral Dietary Supplement - 90 Capsules for General Health Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/uDDIaIhkFWc2KsCvQMEysxLXkpzAx8Rt6RjnBfRc.jpg?v=1786826670",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "mineral",
        "multimineral",
        "dietary",
        "supplement",
        "capsules",
        "for",
        "general",
        "health",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 45,
        "manufacturing": 48,
        "safety": 62,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 65.74,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741628584133",
      "vsf_explanation": "Generic 'Pure Mineral Multimineral' via reseller. Held below Standard by (1) no per-mineral mg disclosure in product name; (2) mineral forms (chelated vs oxide vs sulfate) not specified — dramatic bioavailability differences; (3) 'Pure' branding via reseller = unclear manufacturer; (4) $65 for undisclosed-composition multimineral is above equivalent-quality named-manufacturer products. Would move to Standard 55+ with per-mineral + form disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-grape-seed-extract-100-mg-60-vegetable-capsules",
      "title": "Solgar Grape Seed Extract, 100 Mg, 60 Vegetable Capsules",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/131694101.png?v=1786826714",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "grape",
        "seed",
        "extract",
        "100",
        "vegetable",
        "capsules",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 78,
        "safety": 72,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 27.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741630288069",
      "vsf_explanation": "Grape seed extract (OPCs — oligomeric proanthocyanidins) 100mg. Real evidence for endothelial function and blood pressure at 150-300mg/day (Ras 2013 meta-analysis). 100mg is below the trial-effective range for measurable cardiovascular endpoints. Solgar manufacturing is a plus. Held below Verified by (1) 100mg is sub-therapeutic vs studied doses; (2) OPC % standardization not specified at label; (3) no third-party polyphenol assay. Would move to Verified 70+ with higher per-cap dose OR standardization + third-party assay.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "olly-berry-verbena-goodbye-stress-42-gummies",
      "title": "Olly Berry Verbena  Goodbye Stress 42 Gummies",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/313524202.jpg?v=1786826761",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "olly",
        "berry",
        "verbena",
        "goodbye",
        "stress",
        "gummies",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 65,
        "safety": 72,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741633073349",
      "vsf_explanation": "Olly Goodbye Stress gummies containing GABA, L-theanine, and lemon balm typically. Olly is a real consumer-facing wellness brand (Unilever-owned) with established quality controls. GABA + L-theanine have modest stress-reduction evidence (Yoto 2012 on L-theanine). Held below Verified by (1) per-active mg dose disclosure often lacking on gummy formats; (2) gummy delivery adds sugar/pectin/coloring; (3) oral GABA blood-brain-barrier penetration is debated at typical supplemental doses; (4) 'Goodbye Stress' branding is aspirational vs the modest measured effect sizes for the underlying ingredients.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-curcumin-500mg-turmeric-extract-supplement-with-bioperine-for-enhanced-absorption-natural-anti-inflammatory-joint-health-30-capsules",
      "title": "Pure Curcumin: 500mg Turmeric Extract Supplement with BioPerine for Enhanced Absorption - Natural Anti-Inflammatory & Joint Health - 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/RihKVg5wgkWkB6LUYHhLNgQQzOyIvIGySulwrzCl.jpg?v=1786826799",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "curcumin",
        "500mg",
        "turmeric",
        "extract",
        "supplement",
        "with",
        "bioperine",
        "for",
        "enhanced",
        "absorption",
        "natural",
        "anti",
        "inflammatory",
        "joint",
        "health",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 52,
        "safety": 72,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 96.74,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741634449605",
      "vsf_explanation": "Curcumin 500mg + BioPerine (piperine) enhancement — good formulation choice (~20× bioavailability boost per Shoba 1998). Held below Verified by (1) 'Pure' branding via reseller = unclear manufacturer; (2) curcumin standardization % (95% is the reference) not confirmed at label; (3) $97 price for what appears to be a standard-formulation product significantly above equivalent-quality competitors (Nature's Lab Gold Turmeric with same C3 Complex + BioPerine at ~$25). Would move to Verified 70+ with 95% curcuminoid standardization confirmation + named manufacturer + credible pricing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-msm-methylsulfonylmethane-1-000-mg-120-tablets",
      "title": "Solgar MSM (Methylsulfonylmethane), 1,000 Mg, 120 Tablets",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/257443324.jpg?v=1786826827",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "msm",
        "methylsulfonylmethane",
        "000",
        "120",
        "tablets",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 78,
        "safety": 72,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 17.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741635334341",
      "vsf_explanation": "Solgar MSM 1000 mg. MSM (methylsulfonylmethane) has modest evidence for osteoarthritis pain reduction (Kim 2006, Debbi 2011 — small effect sizes at 1500-6000 mg/day). Solgar manufacturing quality is a plus. Held below Verified by (1) 1000 mg is on the lower end of studied dose range — most trials use 1500-3000 mg/day, so multiple tablets needed for therapeutic use; (2) MSM efficacy signal is modest even at proper doses; (3) no third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-daily-probiotic-supplement-30-vegan-probiotic-capsules-for-digestive-health-immune-system-support",
      "title": "Pure Daily Probiotic Supplement - 30 Vegan Probiotic Capsules for Digestive Health & Immune System Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/z4KZ1DEqsjxzztjsIDxjmMcdQ1HXLU28ctdlSc2J.jpg?v=1786826860",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "daily",
        "probiotic",
        "supplement",
        "vegan",
        "probiotic",
        "capsules",
        "for",
        "digestive",
        "health",
        "immune",
        "system",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 42,
        "manufacturing": 48,
        "safety": 62,
        "transparency": 38,
        "sustainability": 45
      },
      "price": 59.18,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741636645061",
      "vsf_explanation": "Generic 'Pure Daily Probiotic' via a third-party reseller. Held below Standard by (1) NO strain-level identification at product name/label — probiotic evidence is strain-specific (see our /blogs/news/best-probiotic-supplements-2026-strain-specific-guide); without knowing which strains, the RCT literature can't be applied to this product; (2) CFU count not disclosed at product level; (3) refrigeration requirements/expiration-CFU-guarantee unclear; (4) 'Pure' branding via a reseller = unclear manufacturer. Would move to Standard 55+ with strain-level identification + CFU-at-expiration guarantee.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-magnesium-supplement",
      "title": "Pure magnesium supplement",
      "vendor": "NutritionAdvice",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71pkSYcYOZL._AC_SL1500_d73c4956-5a30-4e92-8117-78b22ab18371.jpg?v=1786826898",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "magnesium",
        "supplement",
        "nutritionadvice"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 42,
        "manufacturing": 40,
        "safety": 62,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 114.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741638152389",
      "vsf_explanation": "Generic 'Pure magnesium supplement' at $114.89 — no form disclosure in product name (glycinate vs citrate vs oxide vs threonate — all have dramatically different clinical fit + bioavailability). Held below Standard by (1) no magnesium form disclosed at label level; (2) elemental content not specified; (3) $114.89 pricing for undisclosed-form magnesium is significantly above premium branded competitors (Thorne Magnesium Bisglycinate ~$25); (4) generic, unbranded vendor listing. Would move to Standard 55+ with named form + elemental mg disclosure + credible price-to-value ratio.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-selenium-200-mcg-30-capsules",
      "title": "Pure Selenium 200 mcg 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/pure-selenium-200-mcg-30-kapsul-2a8-42.jpg?v=1786826936",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "selenium",
        "200",
        "mcg",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 52,
        "safety": 55,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 22.78,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741641363653",
      "vsf_explanation": "Selenium 200 mcg via a third-party reseller. Selenium has real evidence for thyroid support (particularly Hashimoto's thyroiditis at 200 mcg selenomethionine) and antioxidant function. 200 mcg is at the upper end of daily supplementation range — Tolerable Upper Intake Level is 400 mcg/day for adults. Held below Verified by (1) selenium form (selenomethionine vs sodium selenite vs selenocysteine) not specified — matters for bioavailability; (2) 'Pure' brand via a reseller = unclear manufacturer; (3) chronic 200 mcg + baseline dietary selenium can approach UL in high-Se-soil regions. Would move to Verified 70+ with form disclosure + named manufacturer.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-metabolic-dietary-supplement-for-weight-management-with-green-coffee-bean-extract-alpha-lipoic-acid-and-resveratrol",
      "title": "Pure Metabolic - Dietary Supplement for Weight Management with Green Coffee Bean Extract, Alpha-Lipoic Acid, and Resveratrol",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/D0RbLzAXS35NRaIkM6AW6F7cRBxHnAXmOsKQW200_14b9fcf0-8abe-4c50-8ab9-5c54ca7d8fd1.jpg?v=1786826976",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "metabolic",
        "dietary",
        "supplement",
        "for",
        "weight",
        "management",
        "with",
        "green",
        "coffee",
        "bean",
        "extract",
        "alpha",
        "lipoic",
        "acid",
        "and",
        "resveratrol",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 42,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 42,
        "sustainability": 45
      },
      "price": 108.34,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741642248389",
      "vsf_explanation": "Weight-management formulation anchored on green coffee bean extract (GCB), ALA, and resveratrol. Auto-fail: unverified_medical_claim. Green coffee bean extract for weight loss has been formally litigated by the FTC (Applied Food Sciences case, 2014 — $3.5M FTC settlement over false weight-loss claims based on the retracted Vinson 2012 study). GCB weight-loss claims are not supported by credible RCT evidence and are explicitly on FTC's weight-loss-false-claims list. ALA + resveratrol have their own evidence bases but not for weight loss at typical supplemental doses. High price point ($108) for a formulation whose central claim isn't evidence-supported. Would move to Standard 55+ ONLY with removal of weight-loss claims + repositioning on individual ingredient evidence (which is modest).",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "nutrof-total-dietary-supplement-for-eye-health-antioxidant-support-30-capsules",
      "title": "Nutrof Total Dietary Supplement for Eye Health & Antioxidant Support - 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2BrLm8wJgEJrCRueQ1SQpPJvRRq08xc8rCHE9rZ9.jpg?v=1786827023",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrof",
        "total",
        "dietary",
        "supplement",
        "for",
        "eye",
        "health",
        "antioxidant",
        "support",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 34.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741644181701",
      "vsf_explanation": "Nutrof Total — an eye-health formulation from Théa Pharma (European ophthalmic-focused brand). Formulation typically includes lutein + zeaxanthin (AREDS2-style macular support) + vitamin C + E + zinc + copper + omega-3. AREDS2 formulation has real RCT evidence for age-related macular degeneration progression prevention. Held below Verified by (1) sold via a third-party reseller — Théa's own quality documentation less accessible through this channel; (2) exact ingredient breakdown vs AREDS2 studied doses not always aligned; (3) marketing 'antioxidant support' is broader than the AMD-specific evidence base.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-zinc-15mg-zinc-supplement-capsules-for-immune-system-support-30-count",
      "title": "Pure Zinc - 15mg Zinc Supplement Capsules for Immune System Support - 30 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9yOBIYaqNL3YhrHdiOYaWjLQSwMqYf8sdhHeSFvn.jpg?v=1786827053",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "zinc",
        "15mg",
        "zinc",
        "supplement",
        "capsules",
        "for",
        "immune",
        "system",
        "support",
        "count",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 58,
        "manufacturing": 50,
        "safety": 65,
        "transparency": 52,
        "sustainability": 45
      },
      "price": 32.84,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741645689029",
      "vsf_explanation": "Zinc 15 mg via a third-party reseller channel. Zinc has real immune-support evidence at 15-40 mg elemental daily; 15 mg is appropriate maintenance. Held below Verified by (1) 'Pure' branding via a reseller doesn't identify actual manufacturer — no third-party quality signal visible; (2) zinc form (picolinate/citrate/gluconate/oxide) not specified — matters for bioavailability; (3) chronic zinc supplementation without copper co-supplementation can cause copper deficiency (long-term). Would move to Verified 70+ with named manufacturer + form disclosure + copper-co-supplementation guidance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bluebonnet-nutrition-vitamins-biotin-1000-mg-90-vegetable-capsules",
      "title": "Bluebonnet Nutrition Vitamins Biotin 1000 mg - 90 Vegetable Capsules",
      "vendor": "Bluebonnet",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Capturadepantalla2023-09-15ala_s_11.31.44a.m..jpg?v=1786827125",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bluebonnet",
        "nutrition",
        "vitamins",
        "biotin",
        "1000",
        "vegetable",
        "capsules",
        "bluebonnet"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 68,
        "manufacturing": 70,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 11.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741648310469",
      "vsf_explanation": "Biotin 1000 mcg (NOT 1000 mg — the product title appears to have a mg/mcg unit error, actual biotin doses are always mcg) from Bluebonnet. Biotin evidence for hair/nail growth in non-deficient adults is weak — biotin deficiency is rare and biotin doesn't cause hair loss reversal above baseline. High-dose biotin (5000-10000 mcg) can also interfere with common lab tests (troponin, TSH) causing false readings. Held below Verified by (1) modest evidence for cosmetic hair/nail claims in non-deficient individuals; (2) potential lab-test interference not disclosed on label; (3) mg/mcg unit ambiguity in product title. Would move to Verified 70+ with lab-interference warning + honest positioning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bluebonnet-nutrition-liquid-calcium-magnesium-citrate-plus-vitamin-d3-natural-16-oz",
      "title": "Bluebonnet Nutrition, Liquid Calcium Magnesium Citrate Plus Vitamin D3 Natural 16.Oz",
      "vendor": "Bluebonnet",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/61ZNnQtYG0L._AC_SL1500.jpg?v=1786827186",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "immune",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bluebonnet",
        "nutrition",
        "liquid",
        "calcium",
        "magnesium",
        "citrate",
        "plus",
        "vitamin",
        "natural",
        "bluebonnet"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 72,
        "manufacturing": 70,
        "safety": 72,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741651783877",
      "vsf_explanation": "Bluebonnet liquid Cal/Mag citrate + D3. Bluebonnet is a legit practitioner-facing brand with real quality standards. Citrate form for both calcium AND magnesium is a formulation plus — better absorption than carbonate/oxide alternatives. Liquid delivery aids compliance for people who can't swallow tablets. Held below Verified by (1) no K2 co-formulation; (2) sustainability profile thin; (3) elemental content of Cal + Mg per serving needs prominent label disclosure. Would move to Verified 70+ with K2 addition.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-vitamin-d3-25-mcg-1000-iu-250-rapid-release-softgels",
      "title": "Nature's Bounty Vitamin D3, 25 Mcg (1000 IU), 250 Rapid Release Softgels",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/53145323.jpg?v=1786827234",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "vitamin",
        "mcg",
        "1000",
        "250",
        "rapid",
        "release",
        "softgels",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 72,
        "manufacturing": 68,
        "safety": 75,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 12.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741653160133",
      "vsf_explanation": "Nature's Bounty D3 1000 IU softgels. Softgel with oil vehicle = ~2-3× absorption vs dry tablets. 1000 IU is appropriate maintenance dose for adults with adequate baseline 25-OH-D. Nature's Bounty (Nestlé Health Science) has real manufacturing scale. Held below Verified by (1) no USP verification visible on this SKU (Nature Made carries USP on many D3 SKUs — a differentiator); (2) 1000 IU is maintenance-only, insufficient for correcting deficiency; (3) no K2 co-formulation for long-term high-dose supplementation. Would move to Verified 70+ with USP verification + higher-dose SKU option + K2 co-formulation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-calcium-magnesium-with-vitamin-d3-150-tablets",
      "title": "Solgar Calcium Magnesium with Vitamin D3 150 Tablets",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33984005181.jpg?v=1786827254",
      "score": 74,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "immune",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "calcium",
        "magnesium",
        "with",
        "vitamin",
        "150",
        "tablets",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 78,
        "safety": 72,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 18.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741654044869",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 66 → new 74. Evidence found: Tang BM, et al. Use of calcium or calcium in combination with vitamin D supplementation to prevent fractures and bone loss. Lancet. 2007;370(9588):657-66. | Bischoff-Ferrari HA, et al. Pooled analysis of vitamin D dose requirements for fracture prevention. N Engl J Med. 2012;367(1):40-9.. Rationale: Calcium + magnesium + D3 is the evidence-backed bone-support triad. TIER-B evidence for reducing fractures in older adults (Tang 2007, Bischoff-Ferrari 2012). +8 uplift because this SKU adds the D3 that the Cal-Mag-Boron SKU omitted - making it a more complete standalone bone formula.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "21st-century®-ginkgo-biloba-extract-standardized-vegetarian-capsules",
      "title": "21st Century® Ginkgo Biloba Extract – Standardized Vegetarian Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/342257290.jpg?v=1786827339",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "21st",
        "century",
        "ginkgo",
        "biloba",
        "extract",
        "standardized",
        "vegetarian",
        "capsules",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 8.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741656404165",
      "vsf_explanation": "Standardized Ginkgo biloba extract from 21st Century (budget mass-market brand). Ginkgo has mixed evidence — Cochrane reviews on cognitive impairment show limited signal (Birks 2009); some evidence for age-related cognitive support at 120-240 mg/day standardized to 24% flavone glycosides + 6% terpene lactones (the EGb 761 formulation used in most European trials). Held below Verified by (1) standardization % not specified at label — matters heavily for ginkgo efficacy; (2) 21st Century budget-tier manufacturing without third-party testing; (3) real drug-interaction profile (anticoagulants, SSRIs, seizure threshold) warrants stronger warnings. Would move to Verified 70+ with EGb 761-equivalent standardization + drug-interaction disclosure + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "qunol-ultra-coq10-100-mg-dietary-supplement-softgels",
      "title": "Qunol Ultra CoQ10 100 Mg Dietary Supplement Softgels",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/77081194_2c848e0a-d0ec-4f46-ba3b-7b321ec0b2f6.jpg?v=1786827396",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "qunol",
        "ultra",
        "coq10",
        "100",
        "dietary",
        "supplement",
        "softgels",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 78,
        "manufacturing": 70,
        "safety": 75,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 29.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741658239173",
      "vsf_explanation": "Qunol Ultra CoQ10 100mg — variant SKU of the Ultra line. Same formulation quality + evidence as sister SKU. See sibling product for full rationale on Qunol's hybrid-solubility delivery format.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nature-made-co-q10-200-mg-softgels-value-size",
      "title": "Nature Made Co Q10, 200 Mg, Softgels, Value Size",
      "vendor": "Nature Made",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/307299144.jpg?v=1786827402",
      "score": 73,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "made",
        "q10",
        "200",
        "softgels",
        "value",
        "size",
        "nature",
        "made"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 76,
        "manufacturing": 78,
        "safety": 75,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 40.85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741658599621",
      "vsf_explanation": "Nature Made CoQ10 200 mg ubiquinone softgel. Same Pharmavite facility and brand disclosure as the 100 mg and 400 mg Nature Made CoQ10s, so manufacturing 78 / transparency 68 / sustainability 50 are copied, not re-invented. 200 mg sits in the statin-myalgia and general cardiovascular range. No piperine (unlike the 100 mg SKU) so formulation is 76 rather than 78 — a delivery extra, not a brand-quality gap. A higher milligram count inside the studied CoQ10 range is not a safety or formulation penalty. Held below Elite by no confirmed USP mark on this SKU and no Kaneka source.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-ubiquinol-200-mg-reduced-coq-10-30-softgels",
      "title": "Solgar Ubiquinol 200 mg (Reduced CoQ-10) 30 Softgels",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33984026421.png?v=1786827407",
      "score": 88,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "ubiquinol",
        "200",
        "reduced",
        "coq",
        "softgels",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 82,
        "manufacturing": 78,
        "safety": 75,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 49.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741658763461",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 78 → new 88. Evidence found: Langsjoen PH, Langsjoen AM. Supplemental ubiquinol in patients with advanced congestive heart failure. Biofactors. 2008;32(1-4):119-28. | Mortensen SA, et al. Q-SYMBIO trial. JACC Heart Fail. 2014;2(6):641-9. | Kaneka ubiquinol PK dossier (published bioavailability studies showing ubiquinol raises plasma CoQ10 2-4x more efficiently than ubiquinone in older adults with impaired ubiquinone reductase).. Rationale: Ubiquinol is the reduced (active) form of CoQ10 and is typically Kaneka-sourced (the only major published ubiquinol PK/RCT program). TIER-B evidence for improved plasma CoQ10 elevation in adults 60+ whose ubiquinone reductase activity has declined. Langsjoen 2008 showed benefits in advanced heart failure with 450 mg/day ubiquinol after non-response to standard CoQ10. +10 uplift is well within cap; product is the highest-evidence CoQ10 format Solgar sells.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-coq10-400mg-100-veggie-caps-vegan-non-gmo-coenzyme-q10-supplement-antioxidant-coq-10-enzyme-coq-10",
      "title": "NusaPure CoQ10 400mg 100 Veggie Caps (Vegan, Non-GMO) Coenzyme Q10 Supplement, Antioxidant COQ-10 Enzyme, Coq 10",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c39667cb.jpg?v=1786827414",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "coq10",
        "400mg",
        "100",
        "veggie",
        "caps",
        "vegan",
        "non",
        "gmo",
        "coenzyme",
        "q10",
        "supplement",
        "antioxidant",
        "coq",
        "enzyme",
        "coq",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741658894533",
      "vsf_explanation": "NusaPure CoQ10 400mg in vegetable capsule format. NusaPure is a budget Amazon-native brand. Vegan-friendly + non-GMO positioning. Held below Verified by (1) 400mg is outlier dose without narrow-indication justification (100-200mg is standard); (2) vegetable capsule format has significantly worse CoQ10 absorption vs oil-vehicle softgel — 400mg dry-cap may deliver less systemic CoQ10 than 200mg softgel; (3) no absorption enhancer; (4) no Kaneka sourcing; (5) NusaPure's Amazon-native brand quality track record less established than practitioner-tier brands. Would move to Verified 70+ with softgel format + Kaneka sourcing + honest dose positioning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "leader®-coenzyme-q10-coq10-100-mg-30-softgels",
      "title": "Leader® Coenzyme Q10 (CoQ10) – 100 mg (30 Softgels)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/imagen_2026-02-10_192211111.png?v=1786827418",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "leader",
        "coenzyme",
        "q10",
        "coq10",
        "100",
        "softgels",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 8.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741659156677",
      "vsf_explanation": "Leader CoQ10 100mg softgel (Leader is a US pharmacy-cooperative private label). Softgel format for CoQ10 absorption = correct. 100mg standard dose. Held below Verified by (1) private-label store brand — underlying manufacturer not disclosed; (2) no Kaneka sourcing; (3) no absorption enhancer; (4) no third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mitocore®",
      "title": "MitoCORE®",
      "vendor": "O Body + Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/mitocore-117060896058cb-0135-42b7-8891-f87399e8d9e7.webp?v=1786827426",
      "score": 78,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mitocore",
        "body",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 82,
        "manufacturing": 78,
        "safety": 75,
        "transparency": 75,
        "sustainability": 55
      },
      "price": 54,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741659451589",
      "vsf_explanation": "MitoCORE by Ortho Molecular Products — comprehensive mitochondrial-support formulation containing NAC (glutathione precursor) + Alpha-Lipoic Acid + Acetyl-L-Carnitine + CoQ10 + resveratrol + green tea EGCG + quercetin + broad B-vitamin complex (methylated). Sophisticated formulation targeting mitochondrial biogenesis + electron-transport-chain support + antioxidant defense across multiple pathways. Ortho Molecular Products (OMP) is a legit practitioner-facing brand with real manufacturing quality (sold primarily through licensed practitioners, focused on formulation quality + protocol integration). Held below Elite by (1) sold via O Body + Wellness reseller (OMP direct-to-practitioner channel is stronger); (2) per-active mg disclosure not at product name (label has full breakdown); (3) sustainability profile thin. Would move to Elite 85+ with published sustainability + Elite-tier third-party certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-alpha-lipoic-acid-200mg-50-vegetable-capsules",
      "title": "Solgar Alpha Lipoic Acid 200mg 50 Vegetable Capsules",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33984000582.jpg?v=1786827437",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "alpha",
        "lipoic",
        "acid",
        "200mg",
        "vegetable",
        "capsules",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 70,
        "manufacturing": 78,
        "safety": 72,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 20.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741659746501",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 68 → new 72. Evidence found: Ziegler D, et al. Oral treatment with alpha-lipoic acid improves symptomatic diabetic polyneuropathy: the SYDNEY 2 trial. Diabetes Care. 2006;29(11):2365-70 (used 600 mg/day). | Mijnhout GS, et al. Alpha lipoic acid for symptomatic peripheral neuropathy in patients with diabetes: a meta-analysis. Int J Endocrinol. 2012;2012:456279.. Rationale: ALA has TIER-B evidence for diabetic peripheral neuropathy at 600 mg/day. 200 mg is 1/3 the studied dose; may still help mild oxidative stress but subclinical for neuropathy. +4 uplift acknowledges ingredient evidence at scale but flags the dose gap.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "coq10-ubiquinone-1",
      "title": "COQ10 UBIQUINONE",
      "vendor": "APACHE STAR",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1782461773824-generated-label-image-1.jpg?v=1786827489",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coq10",
        "ubiquinone",
        "apache",
        "star"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 48,
        "manufacturing": 45,
        "safety": 65,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741661450437",
      "vsf_explanation": "APACHE STAR CoQ10 ubiquinone — generic-brand product with no established quality track record. Held below Standard by (1) no per-cap mg disclosure at product name — cannot verify dose adequacy; (2) delivery format unclear; (3) unfamiliar brand with no visible quality documentation; (4) no Kaneka sourcing; (5) no third-party COA. Would move to Standard 55+ with dose + form disclosure + named manufacturer + basic quality documentation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "venatura-pqq-ala-coq10-30-capsules",
      "title": "VeNatura PQQ + ALA + CoQ10 - 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cA1vE481r66vXa8gcXPKbLEAomNPBAQCqdMcQkBb.jpg?v=1786827498",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "venatura",
        "pqq",
        "ala",
        "coq10",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 52,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 38.65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741661647045",
      "vsf_explanation": "VeNatura PQQ + Alpha-Lipoic Acid + CoQ10 mitochondrial-support combo. Interesting formulation: PQQ (10-20mg typical) supports mitochondrial biogenesis, ALA is a cofactor for mitochondrial enzymes + antioxidant, CoQ10 is the electron-transport-chain shuttle. Three synergistic mitochondrial-support actives. Held below Verified by (1) per-active mg not disclosed at product name — each of PQQ, ALA, CoQ10 has its own dose-response curve; (2) Turkish brand via reseller; (3) combo product opacity; (4) capsule format for the fat-soluble CoQ10 component.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-megasorb-coq-10-200-mg-60-softgels",
      "title": "Solgar Megasorb CoQ-10 200 mg 60 Softgels",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33984009684.png?v=1786827504",
      "score": 86,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "megasorb",
        "coq",
        "200",
        "softgels",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 78,
        "manufacturing": 78,
        "safety": 75,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 44.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741661843653",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 76 → new 86. Evidence found: Bhagavan HN, Chopra RK. Plasma coenzyme Q10 response to oral ingestion of coenzyme Q10 formulations. Mitochondrion. 2007;7 Suppl:S78-88. | Mortensen SA, et al. Q-SYMBIO trial: 300 mg/day CoQ10 reduced cardiovascular mortality in chronic heart failure. JACC Heart Fail. 2014;2(6):641-9. | Solgar Megasorb patent references for lipid-suspension softgel matrix.. Rationale: Megasorb lipid-carrier CoQ10 has TIER-B evidence for absorption advantage over dry powder (Bhagavan & Chopra 2007). 200 mg is within the clinically-studied range (100-300 mg) for statin repletion and general cardiac support. +10 uplift for proprietary formulation edge at an evidence-based dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "coenzyme-q10-gc-200mg-30-sfg",
      "title": "COENZYME Q10 GC 200MG 30 SFG",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/28.jpg?v=1786827508",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coenzyme",
        "q10",
        "200mg",
        "sfg",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 70,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 15.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741661974725",
      "vsf_explanation": "Generic pharmacy CoQ10 200mg softgel (unclear branding — 'GC' likely a generic-code product). Softgel + 200mg = correct format + dose choices. Held below Verified by (1) unclear brand/manufacturer identity — even 'store brand' has more accountability than fully-generic pharmacy codes; (2) no Kaneka sourcing; (3) no absorption enhancer; (4) no third-party assay; (5) transparency floor at 45 for essentially anonymous manufacturer chain.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "suda-vitamin-coenzyme-q10-1000mg-capsules-for-heart-health-energy-support-antioxidant-dietary-supplement-for-adults",
      "title": "Suda Vitamin Coenzyme Q10 1000mg Capsules for Heart Health & Energy Support - Antioxidant Dietary Supplement for Adults",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/TUuxfjhtMnKVnWGuWeGLjGaEYTH6dogpSU25D41d_40488d29-d39b-4bd5-a0c4-2be6b2dd3df6.jpg?v=1786827529",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "suda",
        "vitamin",
        "coenzyme",
        "q10",
        "1000mg",
        "capsules",
        "for",
        "heart",
        "health",
        "energy",
        "support",
        "antioxidant",
        "dietary",
        "supplement",
        "for",
        "adults",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 35,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 28.96,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741662826693",
      "vsf_explanation": "Suda Vitamin '1000mg' Coenzyme Q10. Auto-fail: misleading_naming. A single-capsule 1000mg CoQ10 dose is far outside normal supplement industry practice (100-200mg standard, up to 300-600mg for specific indications). Either: (1) the '1000mg' is the total capsule/matrix weight with much smaller actual CoQ10 content — which is misleading label practice; OR (2) it truly is 1000mg CoQ10 — which is an outlier dose with no established indication and creates unnecessarily-high plasma CoQ10 given saturation kinetics (Bhagavan 2010 showed plasma plateaus above ~200mg). Neither interpretation supports honest labeling. Turkish import via a reseller with no third-party assay to distinguish claim from actual content. Would move to Standard 55+ with (a) honest label distinguishing capsule weight from CoQ10 content OR (b) third-party assay confirming actual CoQ10 amount + honest dose positioning.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "coq10-ubiquinone-30-ct",
      "title": "CoQ10 Ubiquinone, 30 ct.",
      "vendor": "Minimo Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1752342140339-generated-label-image-0.jpg?v=1786827556",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coq10",
        "ubiquinone",
        "minimo",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741664006341",
      "vsf_explanation": "Minimo Nutrition CoQ10 ubiquinone (small brand). Explicit ubiquinone-form labeling. Held below Verified by (1) per-cap mg not disclosed at product name; (2) delivery format not clear; (3) small brand without established quality track record; (4) no Kaneka sourcing; (5) no third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-advanced-vital-heart-60-rapid-release-softgels",
      "title": "Nature's Bounty Advanced Vital Heart -- 60 Rapid Release Softgels",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71nDuMd-ZvL._UF1000_1000_QL80.jpg?v=1786827563",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "advanced",
        "vital",
        "heart",
        "rapid",
        "release",
        "softgels",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 68,
        "safety": 68,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 34.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741664202949",
      "vsf_explanation": "Nature's Bounty 'Advanced Vital Heart' cardiovascular combo softgel. Held below Verified by (1) 'Vital Heart' branding without ingredient breakdown at product name — combo cardiovascular products can span dramatically different formulations (fish oil, CoQ10, garlic, hawthorn, D3, K2, etc.); can't assess evidence without ingredient list; (2) 'Advanced' + 'Rapid Release' marketing framing without specific formulation differentiator; (3) proprietary blend concerns unclear without label review; (4) transparency floor at 45 for undisclosed multi-ingredient composition. Would move to Verified 70+ with full ingredient + per-active dose disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nature-made-coq10-100-mg-with-black-pepper-extract-softgels",
      "title": "Nature Made CoQ10 100 Mg With Black Pepper Extract Softgels",
      "vendor": "Nature Made",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/96596256.jpg?v=1786827582",
      "score": 73,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "made",
        "coq10",
        "100",
        "with",
        "black",
        "pepper",
        "extract",
        "softgels",
        "nature",
        "made"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 78,
        "manufacturing": 78,
        "safety": 75,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 18.45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741664923845",
      "vsf_explanation": "Nature Made CoQ10 100 mg ubiquinone softgel with black-pepper (piperine) extract. Softgel lipid delivery plus piperine is the only SKU-specific formulation plus versus the 200 mg and 400 mg Nature Made CoQ10 softgels. Class-level CoQ10 evidence (statin myalgia; Q-SYMBIO 300 mg/day heart-failure adjunct) applies to the whole line. Manufacturing 78, transparency 68, and sustainability 50 are locked to the shared Pharmavite Nature Made CoQ10 line — not re-scored per bottle. Held below Elite by no confirmed USP Verified mark on this SKU and no Kaneka source disclosed. 100 mg is a studied maintenance dose; use more than one softgel if targeting Q-SYMBIO-range daily totals.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-coq10-400mg-maximum-strength-heart-health-support-39-rapid-release-softgels",
      "title": "Nature's Bounty CoQ10 400mg, Maximum Strength Heart Health Support, 39 Rapid Release Softgels",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/57634107.jpg?v=1786827606",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "coq10",
        "400mg",
        "maximum",
        "strength",
        "heart",
        "health",
        "support",
        "rapid",
        "release",
        "softgels",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 68,
        "safety": 68,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 49.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741666169029",
      "vsf_explanation": "Nature's Bounty CoQ10 400mg 'Maximum Strength' softgel. 400mg is an outlier dose — 100-200mg is standard cardiovascular/statin-adjacent range; 400mg+ has narrow indications (heart failure adjunct at 300mg/day per Q-SYMBIO trial, fertility protocols). 'Maximum Strength' marketing implies more is universally better which isn't true — plasma CoQ10 shows dose-saturation above ~200mg single-dose (Bhagavan 2010). Held below Verified by (1) outlier dose without narrow-indication rationale; (2) 'Maximum Strength' marketing framing; (3) no Kaneka sourcing; (4) no absorption enhancer to justify high per-dose. Would move to Verified 70+ with honest positioning around when 400mg is/isn't appropriate + Kaneka sourcing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "windmill®-natural-source-coq10-200-mg-cardiovascular-amp-energy-support-capsules",
      "title": "Windmill® Natural Source CoQ10 200 mg – Cardiovascular &amp; Energy Support (Capsules)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/160269793.jpg?v=1786827615",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "windmill",
        "natural",
        "source",
        "coq10",
        "200",
        "cardiovascular",
        "amp",
        "energy",
        "support",
        "capsules",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 25.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741666398405",
      "vsf_explanation": "Windmill Natural Source CoQ10 200mg. 200mg is the cardiovascular/statin-adjacent studied dose. 'Natural Source' branding implies yeast-fermentation-derived CoQ10 (which is the standard commercial source — this isn't unique). Windmill is a mainstream pharmacy brand. Held below Verified by (1) capsule vs softgel format not clear at product name; (2) no Kaneka sourcing; (3) mid-tier brand; (4) no absorption enhancer.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "venatura-coenzyme-q10-200mg-30-soft-capsules",
      "title": "VeNatura Coenzyme Q10 200mg - 30 Soft Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/oAr2tRgscm49UZ5MpXaZAxI5xx8OP5pH2arNhyxF.jpg?v=1786827634",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "venatura",
        "coenzyme",
        "q10",
        "200mg",
        "soft",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 31.6,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741666824389",
      "vsf_explanation": "VeNatura CoQ10 200mg soft capsule (Turkish brand sold via a reseller). 200mg + softgel format = correct choices. Held below Verified by Turkish-brand reseller-channel opacity + no Kaneka sourcing + no absorption enhancer + no third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "coenzyme-q10-cp-50-mg-45",
      "title": "Coenzyme Q10 Cp 50 Mg 45",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/121076115.jpg?v=1786827644",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coenzyme",
        "q10",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 70,
        "transparency": 42,
        "sustainability": 45
      },
      "price": 10.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741667086533",
      "vsf_explanation": "Generic pharmacy CoQ10 50mg 'CP' product. Held below Standard by (1) 50mg is below the typical studied dose range (100mg is standard maintenance) — sub-therapeutic for cardiovascular endpoints without taking 2 caps daily; (2) fully-generic branding with no manufacturer accountability; (3) delivery format (softgel vs tablet) unclear; (4) no Kaneka sourcing; (5) no third-party COA. Would move to Standard 55+ with 100mg+ dose OR clear per-dose value proposition + named manufacturer.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "i̇muneks-farma-coenzyme-q10-supplement-200mg-antioxidant-support-for-heart-health-energy-production",
      "title": "İmuneks Farma Coenzyme Q10 Supplement 200mg - Antioxidant Support for Heart Health & Energy Production",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ElZJ40WkKSmCQyptGYmmxnLl9NF2Av9Ar41h7voQ.jpg?v=1786827661",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "muneks",
        "farma",
        "coenzyme",
        "q10",
        "supplement",
        "200mg",
        "antioxidant",
        "support",
        "for",
        "heart",
        "health",
        "energy",
        "production",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 36.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741667807429",
      "vsf_explanation": "İmuneks Farma CoQ10 200mg (Turkish pharma brand sold via a reseller). 200mg cardiovascular/statin-adjacent dose. Held below Verified by (1) Turkish import via reseller; (2) delivery format (softgel vs capsule) not clear at product name; (3) no Kaneka sourcing confirmed; (4) no absorption enhancer; (5) no third-party English-market quality documentation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "coq10-ubiquinone-200mg-capsules",
      "title": "CoQ10 Ubiquinone 200mg Capsules",
      "vendor": "Halea Life: Nutrition & Skincare",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CoQ10_Ubiquinone_Capsules_200mg-0.jpg?v=1786827682",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coq10",
        "ubiquinone",
        "200mg",
        "capsules",
        "halea",
        "life",
        "nutrition",
        "skincare"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 52,
        "safety": 68,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 15.96,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741668298949",
      "vsf_explanation": "Halea Life CoQ10 ubiquinone 200mg capsule (small brand). 200mg cardiovascular-appropriate dose. Explicit ubiquinone-form labeling (transparent about form). Held below Verified by (1) capsule vs softgel format reduces absorption; (2) small brand without established quality track record; (3) no Kaneka sourcing; (4) no absorption enhancer; (5) no third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bluebonnet-coq10-100-mg-30-vegetarian-softgels",
      "title": "Bluebonnet CoQ10 100 mg 30 Vegetarian Softgels",
      "vendor": "Bluebonnet",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Capturadepantalla2023-09-15ala_s_11.38.11a.m..jpg?v=1786827700",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bluebonnet",
        "coq10",
        "100",
        "vegetarian",
        "softgels",
        "bluebonnet"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 75,
        "manufacturing": 72,
        "safety": 75,
        "transparency": 70,
        "sustainability": 60
      },
      "price": 12.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741668757701",
      "vsf_explanation": "Bluebonnet CoQ10 100mg in vegetarian softgel — practitioner-facing brand with real formulation quality. Vegetarian softgel is a real differentiator (most CoQ10 softgels use bovine/porcine gelatin). 100mg maintenance dose. Held below Elite by (1) Kaneka sourcing not confirmed at product name; (2) no third-party COA per SKU; (3) 30-count SKU expensive per capsule vs bulk options. Would move to Elite 85+ with Kaneka sourcing + third-party assay + larger-count SKU option.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "geri-care-coq10-100mg-strong-antioxidant-heart-health-support-100mg-120ct",
      "title": "Geri Care CoQ10 100mg Strong Antioxidant Heart Health Support 100mg 120ct",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/32a9f799-d615-40ee-a8ab-8451e49c940f.cb6a0fceb34671d51fe610cc5c16c7e9.webp?v=1786827714",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "geri",
        "care",
        "coq10",
        "100mg",
        "strong",
        "antioxidant",
        "heart",
        "health",
        "support",
        "100mg",
        "120ct",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 6.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741669281989",
      "vsf_explanation": "Geri Care CoQ10 100mg (institutional/long-term-care market brand). 120-count bulk = good value. Held below Verified by (1) delivery format (softgel vs capsule) not clear at product name; (2) institutional-market brand focused on cost-effective bulk pharmacy — quality tier is functional but not premium; (3) no Kaneka sourcing; (4) no absorption enhancer; (5) no third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "doctors-best-100mg-heart-energy-support-coq10-120-softgels",
      "title": "DOCTOR'S BEST: 100Mg | Heart & Energy Support – CoQ10 | 120 Softgels",
      "vendor": "Doctor's Best",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/753950001831_C1N1.jpg?v=1786827745",
      "score": 80,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "doctor",
        "best",
        "100mg",
        "heart",
        "energy",
        "support",
        "coq10",
        "120",
        "softgels",
        "doctor",
        "best"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 78,
        "manufacturing": 72,
        "safety": 75,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 30.14,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741670527173",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 75 → new 80. Evidence found: Mortensen SA et al. The effect of coenzyme Q10 on morbidity and mortality in chronic heart failure: results from Q-SYMBIO. JACC Heart Fail. 2014;2(6):641-649. | Bhagavan HN, Chopra RK. Coenzyme Q10: absorption, tissue uptake, metabolism and pharmacokinetics. Free Radic Res. 2006;40(5):445-453.. Rationale: Doctor's Best CoQ10 softgel (oil-based delivery for improved absorption of lipophilic ubiquinone). Q-SYMBIO trial (Mortensen 2014) established CoQ10 for heart failure at 300 mg/day — brand-agnostic ingredient class. Uplift to 80.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "qunol-ultra-coq10-100mg-softgels-60ct",
      "title": "Qunol Ultra CoQ10 100Mg  Softgels 60Ct",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/313573191.jpg?v=1786827775",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "qunol",
        "ultra",
        "coq10",
        "100mg",
        "softgels",
        "60ct",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 78,
        "manufacturing": 70,
        "safety": 75,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 26.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741671870661",
      "vsf_explanation": "Qunol Ultra CoQ10 100mg — Qunol's water-and-fat-soluble hybrid delivery format is designed to bypass the fat-soluble absorption limitation of standard CoQ10. Cardiologist-endorsed brand in mass market. Real absorption-differentiating formulation approach. Held below Elite by (1) no independent bioavailability comparison vs plain softgel CoQ10 published per SKU (Qunol markets \"3x better absorbed\" — this is their proprietary claim, not independently verified for this SKU); (2) sustainability profile thin; (3) no third-party COA per SKU.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "new-life-coenz-qh-30-capsules-ubiquinol-coq10",
      "title": "New Life Coenz QH 30 Capsules - Ubiquinol CoQ10",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SxAGiUjBbAFsiyBo5WR1q02WPNDuXKVqDZmroH6t_71dd8352-cb08-46bd-8172-6bcadf4371c1.jpg?v=1786827800",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "new",
        "life",
        "coenz",
        "capsules",
        "ubiquinol",
        "coq10",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 68,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 50.26,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741672919237",
      "vsf_explanation": "New Life Coenz QH ubiquinol CoQ10 (Turkish brand via reseller). 'QH' explicitly signals Kaneka QH ubiquinol trademark — likely the actual sourcing, which is a plus if confirmed. Ubiquinol form for adults over 40. Held below Verified by capsule format + reseller-channel opacity + no third-party assay + per-cap dose not stated at product name.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-blend-s-coenzyme-q10-100-mg-30-capsules",
      "title": "Nature's Blend S Coenzyme Q10 100 Mg 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/204809989.jpg?v=1786827823",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "blend",
        "coenzyme",
        "q10",
        "100",
        "capsules",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 16.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741673410757",
      "vsf_explanation": "Nature's Blend CoQ10 100mg capsule (US pharmacy private-label brand). Held below Verified by capsule format + private-label manufacturer opacity + no Kaneka sourcing + no absorption enhancer.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrafarm-coenzyme-q10-100mg-capsules-antioxidant-supplement-for-heart-health-energy",
      "title": "Nutrafarm Coenzyme Q10 100mg Capsules - Antioxidant Supplement for Heart Health & Energy",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0jwqGoApGD2fh8FsDyL5F0mjurxZrSYi101h3kzd.jpg?v=1786827846",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrafarm",
        "coenzyme",
        "q10",
        "100mg",
        "capsules",
        "antioxidant",
        "supplement",
        "for",
        "heart",
        "health",
        "energy",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 52,
        "safety": 68,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 35.12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741674197189",
      "vsf_explanation": "Nutrafarm CoQ10 100mg capsule (sold via a reseller). Standard maintenance dose. Capsule format (vs softgel) reduces CoQ10 absorption. Held below Verified by (1) capsule format; (2) unclear manufacturing origin; (3) no Kaneka sourcing; (4) no absorption enhancer; (5) no third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dynavit-coenzyme-q10-200mg-supplement-antioxidant-support-for-heart-health-30-capsules",
      "title": "Dynavit Coenzyme Q10 200mg Supplement - Antioxidant Support for Heart Health, 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/RZeZsUR1xjRGJ3R2JblKhEgli1y9CERG5EbUa2SM.jpg?v=1786827891",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dynavit",
        "coenzyme",
        "q10",
        "200mg",
        "supplement",
        "antioxidant",
        "support",
        "for",
        "heart",
        "health",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 69.62,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741676294341",
      "vsf_explanation": "Dynavit CoQ10 200mg capsule (Turkish brand sold via a reseller). 200mg is the cardiovascular/statin-adjacent studied dose. Capsule format reduces absorption vs softgel. Turkish brand with limited English-market quality documentation. Held below Verified by capsule format + reseller-channel opacity + no Kaneka sourcing + no absorption enhancer.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty®-coq10-100-mg-rapid-release-gelcap-sfg-45-ea",
      "title": "Nature's Bounty® CoQ10 100 mg Rapid-Release Gelcap SFG, 45 EA",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/57627603.jpg?v=1786827925",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "coq10",
        "100",
        "rapid",
        "release",
        "gelcap",
        "sfg",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 68,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 26.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741677932741",
      "vsf_explanation": "Nature's Bounty CoQ10 100mg rapid-release gelcap. Nature's Bounty (Nestlé Health Science) has real manufacturing scale. Gelcap softgel format for absorption. Held below Verified by (1) no Kaneka sourcing confirmed; (2) no absorption enhancer; (3) no USP verification visible on this SKU (Nature Made carries USP on some CoQ10 SKUs — a differentiator); (4) mass-market tier vs practitioner-grade brands. Would move to Verified 70+ with Kaneka sourcing + absorption enhancer OR USP verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "doctors-best-coenzyme-q10-supplement-120-mg-antioxidant-support-for-heart-health-energy-production-30-capsules",
      "title": "Doctor's Best Coenzyme Q10 Supplement, 120 mg - Antioxidant Support for Heart Health & Energy Production - 30 Capsules",
      "vendor": "Doctor's Best",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/LE2Nu1BEd4EVHNeP6CvCLIu2S9j6sxSoHE9NxSwm.jpg?v=1786827940",
      "score": 76,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "doctor",
        "best",
        "coenzyme",
        "q10",
        "supplement",
        "120",
        "antioxidant",
        "support",
        "for",
        "heart",
        "health",
        "energy",
        "production",
        "capsules",
        "doctor",
        "best"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 75,
        "manufacturing": 72,
        "safety": 75,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 63.81,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741678719173",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 72 → new 76. Evidence found: Mortensen SA et al. Q-SYMBIO trial: CoQ10 in chronic heart failure. JACC Heart Fail. 2014;2(6):641-649.. Rationale: Standard Doctor's Best CoQ10 120 mg. Same ingredient class as the 100 mg softgel variant with slightly higher per-capsule dose. Uplift to 76. Note the small 30-count bottle (1-month supply) makes this more of a trial/starter pack.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ocean-nutrition-coenzyme-q10-supplement-100mg-ubiquinol-antioxidant-support-for-heart-health-energy-30-capsules",
      "title": "Ocean Nutrition Coenzyme Q10 Supplement - 100mg Ubiquinol, Antioxidant Support for Heart Health & Energy - 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/57fLsXb3OHfAyE1UPIEyxAKLGFjlVJLhlvVUkU9K_9ddd6214-f0d8-4625-8f33-7761b7622ef6.jpg?v=1786827977",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ocean",
        "nutrition",
        "coenzyme",
        "q10",
        "supplement",
        "100mg",
        "ubiquinol",
        "antioxidant",
        "support",
        "for",
        "heart",
        "health",
        "energy",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 68,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 36.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741680357573",
      "vsf_explanation": "Ocean Nutrition CoQ10 100mg UBIQUINOL (reduced active form). Ubiquinol form is a real formulation plus for adults over 40 or with reduced conversion capacity. 100mg is standard maintenance. Held below Verified by (1) Turkish brand sold via a reseller — limited quality documentation; (2) Kaneka QH sourcing not confirmed (Kaneka QH is essentially the only pharma-grade ubiquinol raw material — unclear if this product uses it); (3) capsule format vs oil-vehicle softgel.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-truth-400mg-coq10-plus-black-pepper-extract-40-softgels-each",
      "title": "Nature's Truth 400mg CoQ10 Plus Black Pepper Extract 40 Softgels Each",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/73527234.jpg?v=1786828005",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "truth",
        "400mg",
        "coq10",
        "plus",
        "black",
        "pepper",
        "extract",
        "softgels",
        "each",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 65,
        "safety": 68,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 45.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741682323653",
      "vsf_explanation": "Nature's Truth 400mg CoQ10 + Black Pepper Extract softgel. 400mg dose is outlier for typical use (100-200mg is standard); softgel format + piperine enhancement are correct formulation choices. Nature's Truth is a mainstream mass-market brand. Held below Verified by (1) outlier dose without narrow-indication framing; (2) no Kaneka sourcing; (3) 400mg + piperine amplifies absorption — for most users this creates unnecessarily-high plasma CoQ10 vs the studied dose ranges. Would move to Verified 70+ with honest positioning of when 400mg is indicated + Kaneka sourcing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "doctors-best-high-absorb-coq10-200mg-60vc-supports-heart-energy",
      "title": "DOCTOR'S BEST: High Absorb CoQ10 200mg, 60vc |Supports Heart & Energy",
      "vendor": "Doctor's Best",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/753950001114_C1N1.jpg?v=1786828024",
      "score": 82,
      "tier": "elite",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "doctor",
        "best",
        "high",
        "absorb",
        "coq10",
        "200mg",
        "60vc",
        "supports",
        "heart",
        "energy",
        "doctor",
        "best"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 82,
        "manufacturing": 75,
        "safety": 75,
        "transparency": 75,
        "sustainability": 55
      },
      "price": 28.68,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741683077317",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 78 → new 82. Evidence found: Mortensen SA et al. Q-SYMBIO trial. JACC Heart Fail. 2014;2(6):641-649. | Shoba G et al. Piperine bioavailability enhancement. Planta Med. 1998;64(4):353-356.. Rationale: 200 mg 'High Absorb' CoQ10 with BioPerine — hits the higher effective dose range (approaching Q-SYMBIO's 300 mg/day with one capsule) with bioavailability enhancement. Elite tier for dose adequacy + delivery technology.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "coq10-ubiquinone-2",
      "title": "CoQ10 Ubiquinone",
      "vendor": "Condor Golf",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1747362264426-generated-label-image-0.jpg?v=1786828075",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coq10",
        "ubiquinone",
        "condor",
        "golf"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 45,
        "manufacturing": 42,
        "safety": 65,
        "transparency": 38,
        "sustainability": 45
      },
      "price": 36.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741684945093",
      "vsf_explanation": "'Condor Golf' branded CoQ10 ubiquinone — vendor naming ('Condor Golf') has no logical connection to supplement manufacturing which is a red flag for private-label rebrand quality. Held below Standard by (1) unrelated brand identity (golf-branded supplement); (2) no dose disclosure at product name; (3) delivery format unclear; (4) no visible manufacturer or quality documentation; (5) no third-party COA. Would move to Standard 55+ with legitimate supplement-brand identity + dose + form disclosure + manufacturer accountability.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "force-factor-red-yeast-rice-coq10-120-vegetable-capsules",
      "title": "Force Factor Red Yeast Rice + CoQ10, 120 Vegetable Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/251909261.jpg?v=1786828116",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "force",
        "factor",
        "red",
        "yeast",
        "rice",
        "coq10",
        "120",
        "vegetable",
        "capsules",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 22,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 11.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741686878405",
      "vsf_explanation": "Force Factor Red Yeast Rice + CoQ10 combo veggie cap. Same category rationale as the Kyolic RYR combo — natural monacolin K for LDL modulation + CoQ10 to offset statin-mechanism CoQ10 depletion. Held below Verified by (1) monacolin K content not disclosed at label; (2) veggie cap format reduces CoQ10 absorption; (3) Force Factor is a mainstream sports-supplement brand with mid-tier quality reputation; (4) statin-interaction risk not prominently disclosed. Would move to Verified 70+ with monacolin K content disclosure + statin-interaction warnings + softgel or lipid-vehicle format for CoQ10 absorption. This is unregulated, drug-equivalent exposure with no third-party assay on record — held at Rejected under safety_concern until monacolin K and citrinin testing plus a prominent statin-interaction warning are published.",
      "vsf_autofail_rule": "safety_concern"
    },
    {
      "handle": "venatura-l-arginine-coenzyme-q10-herbal-extract-supplement-60-tablets-for-cardiovascular-health-energy-support",
      "title": "VeNatura L-Arginine, Coenzyme Q10 & Herbal Extract Supplement - 60 Tablets for Cardiovascular Health & Energy Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/qKsv0PklqfarGjoktgFJed5ceYa3Vk4JgPdpAgmA.jpg?v=1786828133",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "venatura",
        "arginine",
        "coenzyme",
        "q10",
        "herbal",
        "extract",
        "supplement",
        "tablets",
        "for",
        "cardiovascular",
        "health",
        "energy",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 65,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 32.84,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741688615109",
      "vsf_explanation": "VeNatura L-Arginine + CoQ10 + unspecified herbal extract combo tablet. Cardiovascular positioning is reasonable — L-arginine is a nitric-oxide precursor (some endothelial-function evidence at 3-6g/day), CoQ10 is a mitochondrial shuttle. Held below Verified by (1) 'herbal extract' unspecified — which herb, what dose, what standardization; (2) per-active mg not disclosed at product name; (3) tablet format = worst for CoQ10 absorption (vs softgel); (4) 60 tablets suggests dose splitting — need actual per-tablet content to assess whether L-arginine is at effective 3-6g/day range; (5) Turkish brand via reseller.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "voonka-coq10-100mg-softgels-30-count",
      "title": "Voonka CoQ10 100mg Softgels - 30 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/qhJj3fIlBjVVIIIyNqsOytgazqcpMlWWMPVA33Cn.jpg?v=1786828176",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "voonka",
        "coq10",
        "100mg",
        "softgels",
        "count",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 19.28,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741690843333",
      "vsf_explanation": "Voonka CoQ10 100mg softgel (Turkish brand sold via a reseller). Voonka is a legit Turkish supplement brand with real manufacturing operations. Softgel format correct. Held below Verified by same limitations as sibling Turkish-brand SKUs — quality documentation less accessible via reseller channel; no Kaneka sourcing confirmed; no third-party COA published in English.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutraxin-coq10-100mg-supplement-boost-energy-support-heart-health-30-softgels",
      "title": "Nutraxin CoQ10 100mg Supplement: Boost Energy & Support Heart Health - 30 Softgels",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/x91kCYZsY8IDBfTKwTrqjFriTU9wkoXOLDS4dmbF.jpg?v=1786828192",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutraxin",
        "coq10",
        "100mg",
        "supplement",
        "boost",
        "energy",
        "support",
        "heart",
        "health",
        "softgels",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 31.07,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741691564229",
      "vsf_explanation": "Nutraxin CoQ10 100mg softgel (Turkish brand sold via a reseller). Softgel format correct for CoQ10 absorption. 100mg standard maintenance dose. Held below Verified by (1) Turkish brand with limited third-party quality documentation accessible in English-language channels; (2) Kaneka sourcing not confirmed; (3) reseller channel.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sundance-absorbable-coq10-plus-quick-release-softgels-200-mg-60-tabs",
      "title": "Sundance, Absorbable CoQ10 Plus Quick Release Softgels, 200 mg, 60 Tabs",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4901bd56-1887-480e-be78-ef886a918284.7dff827142114af852dc1870411c3f9c.jpg?v=1786828219",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sundance",
        "absorbable",
        "coq10",
        "plus",
        "quick",
        "release",
        "softgels",
        "200",
        "tabs",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 24.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741692121285",
      "vsf_explanation": "Sundance 'Absorbable CoQ10 Plus' quick-release 200mg softgel. Softgel + 200mg cardiovascular-appropriate dose. 'Absorbable' + 'Quick Release' are marketing claims — the standard softgel-with-oil format already delivers reasonable absorption; specific technology beyond standard softgel not documented. Sundance is a mainstream pharmacy brand. Held below Verified by (1) 'Absorbable' claim not substantiated with published bioavailability comparison; (2) no Kaneka sourcing; (3) mid-tier brand quality.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "i̇muneks-q10-antioxidant-with-beta-glucan-coenzyme-q10-30-capsules",
      "title": "İmuneks Q10 - Antioxidant with Beta Glucan & Coenzyme Q10 - 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/C8hV0p3eEkL4elUpx06snuqfaZl3tMKusPs26XRg_e1a66dfe-6d02-4554-a4a5-e42b5efb559c.jpg?v=1786828232",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "muneks",
        "q10",
        "antioxidant",
        "with",
        "beta",
        "glucan",
        "coenzyme",
        "q10",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 52,
        "safety": 68,
        "transparency": 52,
        "sustainability": 50
      },
      "price": 49.2,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741692448965",
      "vsf_explanation": "İmuneks CoQ10 + Beta Glucan combo capsule. Beta-glucan has real immune-support evidence (Vetvicka 2019 review). Combo formulation is interesting but held below Verified by (1) per-active mg not disclosed at product name — beta-glucan efficacy is dose-dependent (typically 100-500 mg); (2) Turkish brand via reseller with limited quality documentation; (3) capsule format for CoQ10.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "good-neighbor-pharmacy-gnp-coq10-100-mg-30-caps",
      "title": "Good Neighbor Pharmacy GNP CoQ10 100 Mg 30 Caps",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/225698648.png?v=1786828269",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "good",
        "neighbor",
        "pharmacy",
        "gnp",
        "coq10",
        "100",
        "caps",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 58,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 4.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741694251205",
      "vsf_explanation": "Good Neighbor Pharmacy (GNP) store-brand CoQ10 100mg capsule. Store-brand pharmacy quality — private label with unclear underlying manufacturer. 100mg standard maintenance dose. Held below Verified by (1) capsule vs softgel format (reduces absorption for fat-soluble CoQ10); (2) private-label store brand — manufacturer chain not disclosed; (3) no absorption enhancer; (4) no Kaneka sourcing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nano-coq10",
      "title": "Nano CoQ10",
      "vendor": "Leaders Beauty & Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/nanoq10.png?v=1786828300",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nano",
        "coq10",
        "leaders",
        "beauty",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 42,
        "safety": 62,
        "transparency": 32,
        "sustainability": 45
      },
      "price": 74,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741695135941",
      "vsf_explanation": "'Nano CoQ10' from a small, unbranded storefront. Auto-fail: misleading_naming. 'Nano' delivery-technology claims require substantiation: (1) actual particle-size specification (typically 100-1000 nm range); (2) documented bioavailability comparison vs standard CoQ10; (3) manufacturing process description (nano-emulsion, liposomal, solid-lipid nanoparticles, etc.). None of these are documented at product level. 'Nano' framing without substantiation is a marketing device rather than a formulation differentiator. CoQ10 particle-size reduction CAN improve absorption but requires demonstrated methodology. Would move to Standard 55+ with published particle-size spec + independent bioavailability comparison OR removal of 'nano' framing.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "kyolic-aged-garlic-extract-red-yeast-rice-plus-coq10-75-capsules",
      "title": "KYOLIC: Aged Garlic Extract Red Yeast Rice Plus CoQ10, 75 capsules",
      "vendor": "Smart Greens",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/023542114417_C1N1.jpg?v=1786828322",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "kyolic",
        "aged",
        "garlic",
        "extract",
        "red",
        "yeast",
        "rice",
        "plus",
        "coq10",
        "capsules",
        "smart",
        "greens"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 68,
        "manufacturing": 65,
        "safety": 12,
        "transparency": 38,
        "sustainability": 55
      },
      "price": 24.8,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741696086213",
      "vsf_explanation": "Kyolic Aged Garlic Extract + Red Yeast Rice (RYR) + CoQ10 combo — cardiovascular-support formulation. Aged garlic extract has real BP-reduction evidence (Ried 2013 meta-analysis at ~4g/day AGE). Red Yeast Rice contains naturally-occurring monacolin K (structurally identical to lovastatin) — with modest LDL-reduction evidence at 2-10mg monacolin K/day. CoQ10 addition is a smart pairing since RYR's monacolin K, like statins, can deplete CoQ10. Held below Verified by (1) monacolin K content variability across RYR products is a documented ConsumerLab issue — some 'RYR' products have near-zero monacolin K, others have statin-equivalent doses without oversight; (2) monacolin K = pharmaceutical drug in FDA's position (2007), making high-monacolin RYR products a legally gray area; (3) safety score reduced due to real drug-interaction risk (RYR should NOT be combined with prescription statins → additive myopathy/rhabdomyolysis risk). Would move to Verified 70+ with published monacolin K content + prominent statin-interaction warnings. This is unregulated, drug-equivalent exposure with no third-party assay on record — held at Rejected under safety_concern until monacolin K and citrinin testing plus a prominent statin-interaction warning are published.",
      "vsf_autofail_rule": "safety_concern"
    },
    {
      "handle": "ocean-koenzim-q10-100-mg-antioxidant-support-vegetarian-capsules",
      "title": "Ocean Koenzim Q10 100 mg - Antioxidant Support, Vegetarian Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/zPFggpwLRI8J7eesdHUwMlgOPssBvfKdVWFiW76d.jpg?v=1786828385",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ocean",
        "koenzim",
        "q10",
        "100",
        "antioxidant",
        "support",
        "vegetarian",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 52,
        "safety": 68,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 26.34,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741697986757",
      "vsf_explanation": "Ocean Koenzim Q10 100mg vegetarian capsule (Turkish brand sold via a reseller). 100mg is standard maintenance dose. Vegetarian capsule is a formulation positive but reduces absorption vs oil-vehicle softgel for fat-soluble CoQ10. Held below Verified by (1) Turkish import via reseller — limited quality documentation accessible; (2) no absorption enhancer to compensate for vcap format; (3) no Kaneka sourcing confirmed. Would move to Verified 70+ with softgel format OR absorption enhancer + named raw-material sourcing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-l-carnitine-500mg-60-tablets",
      "title": "Solgar L-Carnitine 500mg 60 Tablets",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33984005716.jpg?v=1786828457",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "carnitine",
        "500mg",
        "tablets",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 78,
        "safety": 72,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 32.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741699952837",
      "vsf_explanation": "Solgar L-Carnitine 500mg tablet. L-Carnitine has real cardiovascular evidence (DiNicolantonio 2013 meta-analysis at 2-3g/day for post-MI outcomes) and exercise-recovery evidence (particularly L-carnitine L-tartrate form per Volek 2002). Solgar practitioner-grade manufacturing quality. Held below Verified by (1) L-carnitine form not specified — L-carnitine vs acetyl-L-carnitine (brain penetration) vs L-carnitine L-tartrate (exercise recovery) have different tissue targeting; (2) 500mg tablet is moderate dose — cardiovascular protocols use 2-3g/day (4-6 tablets); (3) tablet format vs liquid/softgel for absorption. Would move to Verified 70+ with form disclosure + higher-dose SKU option.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty®-l-carnitine-500-mg-tablet-30-ea",
      "title": "Nature's Bounty® L-Carnitine 500 mg Tablet, 30 EA",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/203276199.jpg?v=1786828461",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "carnitine",
        "500",
        "tablet",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 60,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 20.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741700083909",
      "vsf_explanation": "Nature's Bounty L-Carnitine 500mg tablet. Nature's Bounty (Nestlé Health Science) has real manufacturing scale. Same category considerations as Solgar L-Carnitine — 500mg is moderate dose; form not specified. Held below Verified by (1) L-carnitine form (L-carnitine vs ALCAR vs tartrate) not specified; (2) tablet format; (3) no third-party testing visible; (4) 30ct is very small quantity for practical use (30 days at 1 tablet daily; cardiovascular protocols need 4-6/day = 5-8 days per bottle).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-physicians-choice-probiotics-60-billion-cfu-10",
      "title": "Organic Physician's Choice Probiotics 60 Billion CFU - 10",
      "vendor": "NutritionAdvice",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/51Wf96dDUDL.jpg?v=1786828479",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "physician",
        "choice",
        "probiotics",
        "billion",
        "cfu",
        "nutritionadvice"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 70,
        "manufacturing": 65,
        "safety": 72,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 39.07,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741700935877",
      "vsf_explanation": "Physician's Choice Probiotics 60 Billion CFU — established Amazon-native probiotic brand. 10-strain formulation at 60 billion CFU total (each strain sits at ~6 billion CFU, above single-strain therapeutic threshold for most endpoints). Multi-strain approach broadens gut coverage. Held below Verified by (1) 'Physician's Choice' branding without actual physician panel review; (2) strain-level identifiers (e.g., Lactobacillus acidophilus LA-14 vs generic L. acidophilus) not disclosed at product name — probiotic evidence is strain-specific per /blogs/news/best-probiotic-supplements-2026-strain-specific-guide; (3) CFU-at-expiration (vs at-manufacture) guarantee not clarified; (4) delayed-release capsule (survivability past stomach acid) not confirmed. Would move to Verified 70+ with strain-level identifiers + CFU-at-expiration guarantee + published third-party CFU assay.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nad-regen",
      "title": "NAD Regen",
      "vendor": "BioStack",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NAD_Regen_-_Primary_front.jpg?v=1786837227",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nad",
        "regen",
        "biostack"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 77,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741875884229",
      "vsf_explanation": "BioStack NAD Regen — BioStack is an established longevity-focused supplement brand with real formulation research investment. 'NAD Regen' branding suggests NAD-precursor + cofactor stack for enhanced NAD+ biosynthesis (typical stack includes NR or NMN + TMG for methyl-donor support + niacin as fallback pathway). Held below Verified by (1) actual active molecule (NR vs NMN vs combo) not disclosed at product name; (2) per-active mg breakdown not visible; (3) sourcing (Niagen NR, Uthever NMN) not confirmed at product name; (4) no third-party COA published. Would move to Verified 70+ with per-active mg disclosure + named raw-material sourcing + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nad-resveratrol-capsules",
      "title": "NAD + Resveratrol Capsules",
      "vendor": "Neurogan Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NeuroganHealth_NAD_Resveratrol_Capsules_600mg_54000mg_90ct_Front_Shadow_ff764a26-e270-49b6-a348-c45e75740944.jpg?v=1786837242",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nad",
        "resveratrol",
        "capsules",
        "neurogan",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 60,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741875949765",
      "vsf_explanation": "Neurogan Health NAD + Resveratrol combo capsule. Neurogan Health is an established brand (originally CBD-focused, now expanded into longevity/wellness). Combo formulation aligns with Sinclair-style NAD+ precursor + SIRT-activator pairing theory. Held below Verified by (1) 'NAD' labeling ambiguity — unclear if the active is actual NAD+ (mechanism problem — see other NAD+ SKU explanations), NR, NMN, or niacinamide; (2) per-active mg not disclosed at product name; (3) resveratrol form (trans-resveratrol % standardization) not specified; (4) NR/NMN sourcing (Niagen for NR; Uthever/other for NMN) not confirmed. Would move to Verified 70+ with clarity on actual actives + doses + sourcing + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "creatine",
      "title": "Creatine",
      "vendor": "1776 Sports Nutrition LLC",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/25AAC516-A1AD-4686-924C-404D3B84EF40.jpg?v=1786837295",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "creatine",
        "1776",
        "sports",
        "nutrition",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 82,
        "formulation": 55,
        "manufacturing": 48,
        "safety": 78,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 20,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741877719237",
      "vsf_explanation": "1776 Sports Nutrition Creatine. Creatine has the strongest evidence base of any sports-nutrition supplement (see /blogs/news/best-creatine-supplements-2026-monohydrate-guide) — evidence dimension high independent of brand quality. Held below Verified by (1) form not specified — monohydrate is the studied form; creatine HCl, ethyl ester, buffered are marketing variants without better evidence; (2) Creapure® or other named-sourcing not confirmed (Creapure is the reference-quality German-manufactured creatine monohydrate used in most trials); (3) no NSF Certified for Sport designation; (4) small brand without established quality track record; (5) per-scoop mg not disclosed at product name. Would move to Verified 70+ with monohydrate + Creapure sourcing + NSF sport cert.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "intestinal-health-compound",
      "title": "Intestinal Health Compound",
      "vendor": "1776 Sports Nutrition LLC",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BFC39C25-8FE8-4E8E-A2D2-E490C2E0AEBD.png?v=1786837309",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "intestinal",
        "health",
        "compound",
        "1776",
        "sports",
        "nutrition",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 48,
        "manufacturing": 48,
        "safety": 62,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741877817541",
      "vsf_explanation": "1776 Sports Nutrition 'Intestinal Health Compound' — generic gut-health combo. Held below Standard by (1) 'Compound' naming without ingredient disclosure = proprietary blend concern; (2) probiotic strains, prebiotic fibers, digestive enzymes, or gut-lining nutrients not clarified — gut-health formulations vary dramatically in what they target; (3) 1776 Sports Nutrition is a small brand without established quality track record; (4) no per-active mg disclosure; (5) no third-party COA. Would move to Standard 55+ with full ingredient + dose disclosure + named manufacturer accountability + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liposomal-nicotinamide-riboside-900mg-resveratrol-quercetin-nad-supplement-plus-for-anti-aging-cellular-energy-improve-health-80-capsules",
      "title": "Liposomal Nicotinamide Riboside 900mg Resveratrol & Quercetin – NAD Supplement Plus for Anti Aging, Cellular Energy & Improve Health- 80 Capsules",
      "vendor": "KARONDA RENE LEWIS",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fad5cefbd058f0a5195696a88208b4b9.jpg?v=1786837318",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liposomal",
        "nicotinamide",
        "riboside",
        "900mg",
        "resveratrol",
        "quercetin",
        "nad",
        "supplement",
        "plus",
        "for",
        "anti",
        "aging",
        "cellular",
        "energy",
        "improve",
        "health",
        "capsules",
        "karonda",
        "rene",
        "lewis"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 48,
        "safety": 60,
        "transparency": 42,
        "sustainability": 45
      },
      "price": 5.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741878276293",
      "vsf_explanation": "Liposomal nicotinamide riboside 900mg combined with resveratrol + quercetin. Liposomal delivery is a real formulation plus for NR (improves bioavailability + tissue delivery). The three-actives combo aligns with the Sinclair-style longevity stack theory (NAD+ precursor + SIRT-activator + senolytic). Held below Verified by (1) 900mg NR is 2-4× the typical studied dose (250-500mg/day per Martens 2018, Dellinger 2017); no clear indication requires 900mg; (2) 'KARONDA RENE LEWIS' vendor naming suggests Amazon-native personal-brand / private-label with no established quality track record; (3) NR sourcing not disclosed — ChromaDex Niagen is essentially the only pharma-grade NR raw material with published clinical trial data; unclear if this product uses Niagen or a generic Chinese-sourced NR; (4) resveratrol dose + form (trans-resveratrol %) not disclosed at product name; (5) no third-party COA published. Would move to Verified 70+ with ChromaDex Niagen sourcing + honest positioning of 900mg dose + third-party COA + resveratrol standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nad-nicotinamide-riboside-nucleosides",
      "title": "NAD Nicotinamide Riboside Nucleosides",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fb81d6f1-05a0-4595-8f76-6ef26abed64d.jpg?v=1786837328",
      "score": 50,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nad",
        "nicotinamide",
        "riboside",
        "nucleosides",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 52,
        "manufacturing": 48,
        "safety": 62,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 41.85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741878341829",
      "vsf_explanation": "Vivalo NAD Nicotinamide Riboside product. NR (nicotinamide riboside) is a real NAD+ precursor with published clinical bioavailability data (Martens 2018 showed dose-dependent blood NAD+ elevation; Dellinger 2017 human safety trial). NR does raise blood NAD+ reliably. Held below Verified by (1) 'Nucleosides' plural suggests unclear composition — pure NR vs NR + NMN + other nucleosides not clarified; (2) ChromaDex Niagen (essentially the only pharma-grade NR raw material used in published RCTs) sourcing not confirmed; (3) per-cap NR dose not disclosed; (4) small brand Vivalo. Would move to Verified 70+ with Niagen sourcing + honest single-active labeling + dose disclosure + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nad-capsules",
      "title": "NAD Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4b868b0a-aa1f-49ed-bd89-b7268cbbab6b.jpg?v=1786837334",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nad",
        "capsules",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 38,
        "sustainability": 45
      },
      "price": 25.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741878374597",
      "vsf_explanation": "Vivalo 'NAD Capsules' — generic naming with same structural mechanism concern as other oral NAD+ products (NAD+ doesn't cross gut wall intact; effective supplementation uses NR or NMN precursors). Held below Standard by (1) actual active molecule unclear from product name — could be NAD+, NR, NMN, niacinamide; (2) small vendor Vivalo with limited quality documentation; (3) no per-cap dose disclosed at product name; (4) no sourcing information. Would move to Standard 55+ with active-molecule clarity + dose + sourcing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "60-capsules-nicotinamide-single-nucleotide-capsules",
      "title": "60 Capsules Nicotinamide Single Nucleotide Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f2992fab-7bae-4c5a-90b4-8e435e9f3c88.jpg?v=1786837373",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "capsules",
        "nicotinamide",
        "single",
        "nucleotide",
        "capsules",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 42,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 20.78,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741878505669",
      "vsf_explanation": "'Nicotinamide Single Nucleotide' — auto-fail: misleading_naming. The correct name of the NAD+ precursor commonly supplemented is Nicotinamide MONOnucleotide (NMN). 'Single Nucleotide' is either (a) a translation error masking that the product is NMN — in which case honest relabeling as NMN is straightforward, OR (b) a distinct compound that doesn't have the NMN research base — in which case using NMN-adjacent naming is misleading. Either way, the ambiguity conceals what the buyer is actually getting. Small brand (Vivalo, same pattern as previous batches). Held below Standard by naming ambiguity + no per-cap dose disclosure + no sourcing information. Would move to Standard 55+ with corrected labeling (NMN, if that's the actual active) + dose + sourcing.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "female-skin-anti-aging-supplement",
      "title": "Female Skin Anti-Aging Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3af74ffc-29b4-4d46-9514-ad4a4300a2d9.jpg?v=1786837383",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "skin"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "female",
        "skin",
        "anti",
        "aging",
        "supplement",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 62,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 16.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741878603973",
      "vsf_explanation": "Generic 'Female Skin Anti-Aging Supplement' from Vivalo. Held below Standard by (1) ingredient list + doses not disclosed at product name — skin anti-aging formulations can include collagen, hyaluronic acid, vitamin C, biotin, astaxanthin, silica, resveratrol — without disclosure the evidence base can't be applied; (2) 'Female' framing implies gender-specific formulation without mechanism justification (most skin anti-aging ingredients aren't sex-specific); (3) 'Anti-Aging' health claim is aspirational and hard to substantiate for topical/oral products in blinded trials; (4) small brand Vivalo without quality track record. Would move to Standard 55+ with full ingredient + dose disclosure + honest positioning of what specific skin endpoints (elasticity, hydration, wrinkle depth) the formulation targets.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-d3-2-000-iu-1",
      "title": "Vitamin D3 2,000 IU",
      "vendor": "Muscle Faktor",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/vitamin-d3-hero.png?v=1786837409",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "000",
        "muscle",
        "faktor"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 50,
        "safety": 72,
        "transparency": 52,
        "sustainability": 45
      },
      "price": 19.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741878636741",
      "vsf_explanation": "Muscle Faktor Vitamin D3 2000 IU. 2000 IU is a moderate maintenance-to-repletion dose. D3 has strong immune + bone-health evidence. Held below Verified by (1) small brand 'Muscle Faktor' without established quality track record; (2) delivery format (softgel with oil vs dry tablet) not clear at product name — matters heavily for fat-soluble D3 absorption; (3) no K2 co-formulation for long-term supplementation; (4) no USP verification. Would move to Verified 70+ with softgel format + K2 co-formulation + USP verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "muscle-faktor-neuro-fluency-brain-focus-support-capsules",
      "title": "Muscle Faktor NEURO-FLUENCY Brain & Focus Support Capsules",
      "vendor": "Muscle Faktor",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/neuro-fluency-brain.png?v=1786837466",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "muscle",
        "faktor",
        "neuro",
        "fluency",
        "brain",
        "focus",
        "support",
        "capsules",
        "muscle",
        "faktor"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 50,
        "safety": 62,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 39.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741878735045",
      "vsf_explanation": "Muscle Faktor 'NEURO-FLUENCY' nootropic combo capsule. Held below Verified by (1) ingredient list + per-active doses not disclosed at product name — nootropic combos span dramatically different formulations (bacopa, lion's mane, alpha-GPC, L-theanine, caffeine, huperzine A, phosphatidylserine); (2) small brand 'Muscle Faktor' without established quality track record; (3) 'NEURO-FLUENCY' branding is aspirational without specific mechanism differentiator; (4) proprietary blend concerns without label review. Would move to Standard 55+ with full ingredient + dose disclosure + named manufacturer + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nad-cellular-vitality-capsules-500-mg",
      "title": "NAD+ Cellular Vitality Capsules 500 mg",
      "vendor": "Halea Life: Nutrition & Skincare",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1779820028368-generated-label-image-1.jpg?v=1786837539",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nad",
        "cellular",
        "vitality",
        "capsules",
        "500",
        "halea",
        "life",
        "nutrition",
        "skincare"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 24.96,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741878833349",
      "vsf_explanation": "Halea Life NAD+ 500mg. Oral NAD+ has poor systemic bioavailability — most gets broken down to nicotinamide before absorption; direct NAD+ elevation in humans requires precursors (NR/NMN) or IV administration. Halea Life is a small brand with no visible clinical validation or third-party purity testing. The 500mg claim exceeds any studied oral NAD+ dose. Would move to Standard 62+ if reformulated as NR (Niagen) at 300mg or NMN with clear stability data.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "anti-aging-dietary-supplements-resveratrol-nicotinamid-mononucleotide-liposomal-nmn-capsules-nad-capsules",
      "title": "Anti-aging Dietary Supplements Resveratrol Nicotinamid Mononucleotide liposomal NMN capsules Nad Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/A1F25DDA6AF21BE00408A20DCB344636.jpg?v=1786837554",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "anti",
        "aging",
        "dietary",
        "supplements",
        "resveratrol",
        "nicotinamid",
        "mononucleotide",
        "liposomal",
        "nmn",
        "capsules",
        "nad",
        "capsules",
        "digital",
        "presence"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 30,
        "manufacturing": 25,
        "safety": 40,
        "transparency": 25,
        "sustainability": 30
      },
      "price": 20.8,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741878866117",
      "vsf_explanation": "Same anonymous-reseller listing pattern — anonymous marketplace SKU stacking multiple longevity buzzwords (liposomal NMN, NAD capsules, resveratrol). 'Liposomal' claims without particle-size or encapsulation verification are unverifiable. No brand identity, no manufacturing accountability chain, no COA. Autofailed on no brand provenance.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "n-m-n-capsules-anti-aging-capsules-nicotinamide-mononucleotide-capsules",
      "title": "N.M.N Capsules Anti aging Capsules Nicotinamide Mononucleotide Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/AFC38B4E9278427E375379D17D4DD98E.jpg?v=1786837592",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "capsules",
        "anti",
        "aging",
        "capsules",
        "nicotinamide",
        "mononucleotide",
        "capsules",
        "digital",
        "presence"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 30,
        "manufacturing": 25,
        "safety": 40,
        "transparency": 25,
        "sustainability": 30
      },
      "price": 24.46,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741878931653",
      "vsf_explanation": "Anonymous listing from an unnamed reseller — a marketplace listing pattern typical of Alibaba/AliExpress-sourced NMN with no accountability chain. NMN raw material purity is a real problem in the Chinese-supply channel with multiple third-party purity failures documented. No brand identity, no per-cap mg, no COA. Cannot verify basic identity, safety, or purity of the product. Autofailed on no brand provenance.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "fitbit-charge-6-fitness-tracker-black-new",
      "title": "Fitbit Charge 6 Fitness Tracker, Black (New)",
      "vendor": "Price Is Right Miami",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/61ZtqtvoD2L._AC_SL1500.jpg?v=1786837672",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fitbit",
        "charge",
        "fitness",
        "tracker",
        "black",
        "new",
        "price",
        "right",
        "miami"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 35,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 45,
        "sustainability": 35
      },
      "price": 159,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741879062725",
      "vsf_explanation": "Fitbit Charge 6 is a current-generation Fitbit fitness tracker. Hardware, not a supplement. Not scoreable on the supplement VSF rubric. Would score competitively on a wearables/quantified-self rubric given its HR/SpO2/ECG capabilities, but that isn't this scoring context.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "fitbit-inspire-3-2-1-hr-nylon-band-breathable-strap",
      "title": "Fitbit Inspire 3, 2, 1, HR Nylon Band - Breathable Strap",
      "vendor": "BandsCo Straps",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/S526901a7947b4c68b52237e230d91ee2J.webp?v=1786837679",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fitbit",
        "inspire",
        "nylon",
        "band",
        "breathable",
        "strap",
        "bandsco",
        "straps"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 25,
        "manufacturing": 40,
        "safety": 60,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 33.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741879193797",
      "vsf_explanation": "Replacement nylon band accessory for Fitbit devices. Not a health product in any biohacking sense — just an accessory strap. Not scoreable on any rubric relevant to Vyvata's health-product catalog.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "fitbit-charge-hr-wireless-activity-wristband",
      "title": "Fitbit Charge HR Wireless Activity Wristband",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/11008_b.jpg?v=1786837749",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fitbit",
        "charge",
        "wireless",
        "activity",
        "wristband",
        "dailysale"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 30,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 40,
        "sustainability": 30
      },
      "price": 50,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741879816389",
      "vsf_explanation": "Fitbit Charge HR is a legacy (discontinued) fitness tracker. Hardware, not a supplement. Not scoreable on the supplement VSF rubric. Aged product no longer supported by Fitbit; even under a wearables rubric this would score low due to end-of-life status.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "woojer-mat",
      "title": "Woojer MAT",
      "vendor": "Woojer",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Woojer_Mat_R-00-D.webp?v=1786837800",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "woojer",
        "mat",
        "woojer"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 65,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 849,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741879849157",
      "vsf_explanation": "Woojer MAT is a haptic vibration mat for gaming/audio immersion. Hardware, not a supplement — cannot be scored on the supplement VSF rubric. Would need a nervous-system/wearable rubric to score meaningfully.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "woojer-mat-pillow",
      "title": "Woojer MAT | Pillow",
      "vendor": "Woojer",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MAT-Pillow-4-t.webp?v=1786837815",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "woojer",
        "mat",
        "pillow",
        "woojer"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 65,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741879881925",
      "vsf_explanation": "Woojer MAT Pillow is a haptic vibration pillow attachment. Hardware, not a supplement — cannot be scored on the supplement VSF rubric. Woojer is legit for gaming/immersion haptics; whether haptic stimulation has biohacking-relevant sleep/relaxation effects would need a separate wearable/nervous-system rubric.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "ultra-armor-laptop-tablet-faraday-bag-cybersecurity-privacy-emp-attack-shield-fits-up-to-16-5-laptops",
      "title": "Ultra Armor Laptop & Tablet Faraday Bag – Cybersecurity, Privacy & EMP Attack Shield (Fits up to 16.5\" Laptops)",
      "vendor": "DefenderShield",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Faraday-Laptop-Sleeve-Catalog-Picture-1.webp?v=1786837855",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ultra",
        "armor",
        "laptop",
        "tablet",
        "faraday",
        "bag",
        "cybersecurity",
        "privacy",
        "emp",
        "attack",
        "shield",
        "fits",
        "laptops",
        "defendershield"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 30,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 229.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741879947461",
      "vsf_explanation": "DefenderShield Faraday bag with 'EMP attack shield' framing. The EMF/EMP-health-protection category is exactly the autofail case named in the VSF rubric — no credible science supports that consumer-grade non-ionizing EMF (from Wi-Fi, cell phones, laptops) causes health harm at exposure levels those signals reach, and 'EMP attack' framing is speculative. Autofailed on unverified medical claim regardless of the product's utility for signal-blocking as a data-security accessory.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "einstar-vega-wireless-all-in-one-3d-scanner",
      "title": "EINSTAR VEGA-Wireless All-In-One 3D Scanner",
      "vendor": "Einstar-US",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Titanium_Gray_1_cf703fd3-4d3f-4f74-999c-79d99878d1c0.png?v=1786837909",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "einstar",
        "vega",
        "wireless",
        "all",
        "one",
        "scanner",
        "einstar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 25,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 1999,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741880012997",
      "vsf_explanation": "EINSTAR VEGA is a wireless 3D scanner for industrial/design use. Not a biohacking or health product in any meaningful sense — this SKU doesn't belong in a supplement (or arguably any Vyvata health-product) catalog.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "body-scale-cs20w",
      "title": "Body Scale CS20W",
      "vendor": "Arboleaf",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CS20W-Main.png?v=1786837999",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "body",
        "scale",
        "cs20w",
        "arboleaf"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 35,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 36.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741880045765",
      "vsf_explanation": "Arboleaf CS20W is a smart BIA scale variant. Hardware, not a supplement. Not scoreable on the supplement VSF rubric. Should be evaluated on a diagnostics rubric.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "segmental-smart-scale-cs10p",
      "title": "Segmental Smart Scale CS10P",
      "vendor": "Arboleaf",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CS10P.png?v=1786838006",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "segmental",
        "smart",
        "scale",
        "cs10p",
        "arboleaf"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 38,
        "manufacturing": 48,
        "safety": 60,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 119.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741880111301",
      "vsf_explanation": "Arboleaf CS10P is an 8-electrode segmental BIA scale — the higher-end category of consumer scales, closer to InBody-style multi-frequency devices. Hardware, not a supplement. Not scoreable on the supplement VSF rubric. Would score meaningfully on a diagnostics/BIA rubric.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "body-scale-cs20g",
      "title": "Body Scale CS20G",
      "vendor": "Arboleaf",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CS20G-Main_9e10c545-4316-47a3-96fb-2209934763f9.png?v=1786838015",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "body",
        "scale",
        "cs20g",
        "arboleaf"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 35,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 35.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741880471749",
      "vsf_explanation": "Arboleaf CS20G is a smart BIA scale with app integration. Arboleaf is a legitimate small consumer-health hardware brand. This is hardware — not a supplement — so it cannot be scored on the supplement VSF rubric. Should be evaluated on a diagnostics rubric for BIA accuracy vs DEXA gold standard.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "smart-body-composition-scale-fat-monitor-digital-app-scale-bmi-health-analyzer",
      "title": "Smart Body Composition Scale Fat Monitor Digital APP Scale BMI Health Analyzer",
      "vendor": "LJGDeals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/gemgear_HG_Tool_BodyCompositionScale_GPCT745_01_Hero.png?v=1786838058",
      "score": 28,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "smart",
        "body",
        "composition",
        "scale",
        "fat",
        "monitor",
        "digital",
        "app",
        "scale",
        "bmi",
        "health",
        "analyzer",
        "ljgdeals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 30,
        "manufacturing": 35,
        "safety": 55,
        "transparency": 30,
        "sustainability": 35
      },
      "price": 59.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741880537285",
      "vsf_explanation": "Generic Chinese-import BIA scale sold by LJGDeals (deal-site reseller). Hardware — not a supplement — so not scoreable under the supplement VSF rubric. Consumer BIA scales have well-documented accuracy limits vs DEXA. Would need a diagnostics/wearables rubric to score meaningfully.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "aura-strap-2-compatible-w-apple-watch-45-49-mm-44-42mm-coal-black-refurbished",
      "title": "AURA Strap 2 Compatible w Apple Watch (45/49 mm (44/42mm), Coal Black)  (Refurbished)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/aura-strap-2-compatible-w-apple-watch-4549-mm-4442mm-coal-black-smart-watches-dailysale-409771.jpg?v=1786838098",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "aura",
        "strap",
        "compatible",
        "apple",
        "watch",
        "42mm",
        "coal",
        "black",
        "refurbished",
        "dailysale"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 30,
        "manufacturing": 40,
        "safety": 60,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 149,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741880832197",
      "vsf_explanation": "AURA Strap 2 is a body-composition-measuring smartwatch band (BIA sensors). This is a wearable device — not a supplement — and cannot be scored under the supplement VSF rubric. Refurbished consumer electronics reseller channel. Should be scored under a diagnostics/wearables rubric if listed on Vyvata.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "berberine-3",
      "title": "Berberine",
      "vendor": "NeuEve",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Barberine.jpg?v=1786838377",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "berberine",
        "neueve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 52,
        "sustainability": 50
      },
      "price": 42,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741884993733",
      "vsf_explanation": "NeuEve Berberine — small brand (NeuEve is primarily known for feminine-health products). Held below Verified by (1) per-cap mg not disclosed at product name; (2) berberine standardization % not disclosed; (3) NeuEve's brand pedigree is not primarily in metabolic/glucose products; (4) no third-party assay published. Would move to Verified 70+ with dose + standardization + third-party COA + focused metabolic-supplement quality positioning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-berberine-hci-20-1-extract-225-mg-200-veggie-caps-vegetarian-non-gmo-vegan",
      "title": "NusaPure Berberine HCI 20:1 Extract, 225 mg - 200 Veggie Caps - (Vegetarian, Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71NtV0scv_L.jpg?v=1786838382",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "berberine",
        "hci",
        "extract",
        "225",
        "200",
        "veggie",
        "caps",
        "vegetarian",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 70,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 23.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741885026501",
      "vsf_explanation": "NusaPure Berberine HCl 20:1 extract 225mg. '20:1' extract ratio (20 units raw plant per 1 unit extract) is an unusual berberine specification — most berberine supplements list % standardization of berberine hydrochloride directly (95-97% HPLC). '20:1' language is more common for whole-plant herbal extracts than isolated berberine, creating label ambiguity. 225mg per cap is significantly below the studied 500mg TID dose — 6+ caps daily would be needed for the therapeutic protocol. NusaPure is an Amazon-native budget brand. Held below Verified by (1) atypical extract labeling for berberine category; (2) sub-therapeutic per-cap dose relative to studied protocols; (3) veggie cap format (fine, but no absorption enhancer); (4) no third-party assay. Would move to Verified 70+ with % berberine standardization + higher per-cap dose + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "berberine-hcl",
      "title": "Berberine HCL",
      "vendor": "2.0 Lifestyle",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/berberine-hcl20-lifestyle-407400.jpg?v=1786838386",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "berberine",
        "hcl",
        "lifestyle"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 52,
        "safety": 70,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 20,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741885059269",
      "vsf_explanation": "2.0 Lifestyle Berberine HCl — small brand appearing across previous batches with pattern of generic combo products (D3+K2+Ca, NAD+). HCl form is the standard studied form. Held below Verified by (1) per-cap mg not disclosed at product name; (2) berberine standardization % not disclosed; (3) small vendor without established quality track record; (4) no absorption enhancer; (5) no third-party assay. Would move to Verified 70+ with dose + standardization + third-party COA + established manufacturer accountability.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nm-berberine-phytosom-cp-550mg-60",
      "title": "NM Berberine Phytosom Cp 550Mg 60",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/282851027.jpg?v=1786838390",
      "score": 74,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "berberine",
        "phytosom",
        "550mg",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 82,
        "manufacturing": 68,
        "safety": 75,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 46.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741885092037",
      "vsf_explanation": "Berberine Phytosome 550mg — likely Indena's Berberine Phytosome (Meriva-style) sold under 'NM' generic-pharmacy naming. Phytosome technology binds berberine to phosphatidylcholine, creating a lipid-conjugated complex that improves oral bioavailability 2-3x vs standard berberine HCl (Petrangolini 2021). This is a real formulation-driven differentiator. 550mg phytosome per capsule at 2/day matches studied protocols. Held below Elite by (1) 'NM' brand identity unclear — potentially private-label; (2) Indena Berberine Phytosome sourcing not explicitly confirmed at product name; (3) no third-party assay published. Would move to Elite 85+ with confirmed Indena sourcing + published bioavailability comparison + established brand identity.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "thorne-berberine-dietary-supplement-1000-mg-60-capsules",
      "title": "Thorne Berberine Dietary Supplement 1000 mg 60 Capsules",
      "vendor": "Thorne",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/sf800__vd424273289116ed602cb97bcef5ca314e2b9ff03.png?v=1786838416",
      "score": 85,
      "tier": "elite",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "thorne",
        "berberine",
        "dietary",
        "supplement",
        "1000",
        "capsules",
        "thorne"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 82,
        "formulation": 82,
        "manufacturing": 82,
        "safety": 75,
        "transparency": 78,
        "sustainability": 55
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741885124805",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 80 → new 85. Evidence found: Yin J, Xing H, Ye J. Efficacy of berberine in patients with type 2 diabetes mellitus. Metabolism. 2008;57(5):712-717. | Lan J et al. Meta-analysis of berberine for type 2 diabetes, hyperlipidemia, hypertension. J Ethnopharmacol. 2015;161:69-81.. Rationale: 1000 mg berberine per serving hits the therapeutic dose window (usually split as 500 mg BID or 500 mg TID with meals). Thorne practitioner-grade sourcing + therapeutic dose + TIER-A meta-analytic evidence for HbA1c and lipids warrants Elite.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mason-vitamins-inc-natural-berberine-ceylon-cinnamon-complex-60-veggie-capsules",
      "title": "Mason Vitamins INC Natural Berberine Ceylon Cinnamon Complex 60 Veggie Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Mason-Natural-Berberine-Ceylon-Cinnamon-Complex-supports-glucose-metabolism-cardiovascular-health-and-weight-management-60-Veggie-Capules_dedfb937-bdcd-4b5e-bc93-83d52b142ebd.9f563bfc.jpg?v=1786838421",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mason",
        "vitamins",
        "inc",
        "natural",
        "berberine",
        "ceylon",
        "cinnamon",
        "complex",
        "veggie",
        "capsules",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 68,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 13.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741885157573",
      "vsf_explanation": "Mason Vitamins Berberine + Ceylon Cinnamon combo. The pairing has mechanistic rationale — Ceylon cinnamon (Cinnamomum verum, distinct from Cassia cinnamon which has hepatotoxic coumarin) has modest glucose-modulation evidence at 1-3g/day (Allen 2013 meta-analysis showed small HbA1c effect). Ceylon vs Cassia distinction is important (labeled Ceylon = positive signal). Held below Verified by (1) per-active mg not disclosed at product name — for combo products this is essential; (2) berberine + cinnamon combo therapeutic doses would require multiple caps to reach both active-ingredient studied doses; (3) mainstream mass-market brand tier; (4) no third-party assay.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "berberine-hcl-800mg-capsules",
      "title": "Berberine HCl 800mg Capsules",
      "vendor": "Halea Life: Nutrition & Skincare",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Advanced_Berberine_Complex_Capsules_800mgimage-0.jpg?v=1786838428",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "berberine",
        "hcl",
        "800mg",
        "capsules",
        "halea",
        "life",
        "nutrition",
        "skincare"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 68,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 17.96,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741885255877",
      "vsf_explanation": "Halea Life Berberine HCl 800mg per capsule. 800mg is a moderate-high dose per cap; 2/day matches the studied 500mg TID → 1500mg total daily protocol (Yin 2008, Dong 2012). HCl form is the standard studied form. Held below Verified by (1) small brand without established quality track record; (2) berberine standardization % not disclosed at product name (should be >95% via HPLC); (3) no absorption enhancer; (4) no third-party assay published. Would move to Verified 70+ with standardization + third-party COA + established manufacturer.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "goodday-berberina-berberine-supplement-blood-sugar-support-antioxidant-supplement-60-capsules-natural-health-products",
      "title": "Goodday Berberina Berberine Supplement - Blood Sugar Support, Antioxidant Supplement, 60 Capsules - Natural Health Products",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/k8Om0DGsszzc6Zv5ZoDMyq6HNrERIcGAKT62FYgz.jpg?v=1786838435",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "goodday",
        "berberina",
        "berberine",
        "supplement",
        "blood",
        "sugar",
        "support",
        "antioxidant",
        "supplement",
        "capsules",
        "natural",
        "health",
        "products",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 58,
        "manufacturing": 52,
        "safety": 68,
        "transparency": 52,
        "sustainability": 50
      },
      "price": 50.26,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741885288645",
      "vsf_explanation": "Goodday Berberina berberine (Turkish/foreign brand via a third-party reseller). Held below Verified by (1) per-cap mg not disclosed at product name; (2) berberine standardization % not disclosed; (3) Turkish import via reseller with limited quality documentation accessible; (4) no absorption enhancer; (5) no third-party assay. Would move to Verified 70+ with dose + standardization + third-party COA + established manufacturer accountability.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "venatura-berberis-vulgaris-natural-berberine-supplement-for-enhanced-wellness-dietary-support-60-easy-to-swallow-capsules",
      "title": "VeNatura Berberis Vulgaris: Natural Berberine Supplement for Enhanced Wellness & Dietary Support - 60 Easy-to-Swallow Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/DcR5zQnL8Ckkh4QeDJKZC5QJ6QNe5oaU4izHRyu2.jpg?v=1786838446",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "venatura",
        "berberis",
        "vulgaris",
        "natural",
        "berberine",
        "supplement",
        "for",
        "enhanced",
        "wellness",
        "dietary",
        "support",
        "easy",
        "swallow",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 52,
        "sustainability": 50
      },
      "price": 52.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741885354181",
      "vsf_explanation": "VeNatura Berberis Vulgaris berberine supplement (Turkish brand via a third-party reseller). Berberis vulgaris (barberry) is a traditional botanical source of berberine — but whole-plant extract vs standardized berberine hydrochloride is a real quality distinction: standardized isolated berberine has published pharmacokinetic + clinical evidence; whole-plant Berberis vulgaris extract has traditional-use history but less RCT evidence at supplemental doses. Held below Verified by (1) whole-plant extract vs isolated berberine ambiguity; (2) berberine content per cap not disclosed at product name; (3) Turkish import via reseller with limited quality documentation; (4) no third-party assay.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nac",
      "title": "NAC",
      "vendor": "NeuEve",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NAC.jpg?v=1786838455",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nac",
        "neueve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 58,
        "manufacturing": 50,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 38,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741885386949",
      "vsf_explanation": "NAC (N-acetylcysteine) has strong RCT support across respiratory (Grandjean 2000), hepatic (Prescott 1977), PCOS (Salehpour 2007), and mental-health indications. NeuEve is a small women's-wellness brand primarily known for vaginal-health products; NAC extension isn't their core competency. Per-cap mg and manufacturing details not visible. Would move to Verified 70+ with 600mg per-cap dosing (standard RCT dose) and third-party purity testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "anti-berbevital-60-capsules",
      "title": "Anti Berbevital 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/berbevital-60-kapsul-c1b-bb.jpg?v=1786838469",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "anti",
        "berbevital",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 52,
        "safety": 65,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 35.08,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741885518021",
      "vsf_explanation": "'Anti Berbevital' — Turkish/foreign brand supplement, likely a berberine + vitamin combo based on the 'Berbevital' compound name. Held below Verified by (1) 'Anti' prefix + 'Berbevital' compound name = unclear what the product actually contains; (2) berberine content + other actives not disclosed at product name; (3) Turkish import via a third-party reseller; (4) marketing framing lacks specificity; (5) no third-party assay. Would move to Verified 70+ with full ingredient + dose disclosure + honest positioning + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-chromium-picolinate-200-mcg-90-vegetable-capsules",
      "title": "Solgar Chromium Picolinate 200 Mcg 90 Vegetable Capsules",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/345774639_6d3e8010-c4d0-4b6a-aa83-4f95b8db4f22.jpg?v=1786838481",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "chromium",
        "picolinate",
        "200",
        "mcg",
        "vegetable",
        "capsules",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 78,
        "safety": 70,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 11.25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741885583557",
      "vsf_explanation": "Solgar Chromium Picolinate 200mcg. Chromium (as picolinate) has modest insulin-sensitivity evidence in insulin-resistant populations (Anton 2008 review; Suksomboon 2014 meta-analysis showed modest HbA1c effect at 200-1000mcg/day). Picolinate form has higher bioavailability than chromium chloride or trivalent chromium alone. Solgar practitioner-grade manufacturing. Held below Verified by (1) 200mcg is at the lower end of the studied dose range (200-1000mcg/day) — 500-1000mcg protocols show more measurable effect in RCTs; (2) picolinate has been debated for potential DNA-damage concerns at very high chronic doses (though evidence remains inconclusive; Vincent 2010 review); (3) modest effect size for glucose endpoints — chromium isn't a substitute for berberine or metformin. Would move to Verified 70+ with higher-dose SKU option + published third-party assay.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "21st-century-glp-1-60-vegetarian-capsules",
      "title": "21st Century GLP-1 60 Vegetarian Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8_daeb5e1c-fb14-42a7-9d05-4bea9616574c.jpg?v=1786838487",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "21st",
        "century",
        "glp",
        "vegetarian",
        "capsules",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 22.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741885649093",
      "vsf_explanation": "21st Century 'GLP-1' branded supplement. Auto-fail: unverified_medical_claim. 'GLP-1' is the specific active pharmaceutical mechanism of prescription drugs like semaglutide (Ozempic, Wegovy) and tirzepatide (Mounjaro) — these are injectable peptides that directly agonize the glucagon-like peptide-1 receptor. NO oral supplement can produce meaningful GLP-1 receptor agonism at supplement doses — the peptide-mimetic action requires the specific molecular structure of the pharmaceutical drugs. Using 'GLP-1' as a product name implies mechanistic equivalence to Ozempic/Wegovy that isn't supported by any RCT evidence. This category (OTC 'GLP-1 alternatives') is under active FTC scrutiny for deceptive marketing. Whatever herbal/nutrient combination is inside the capsule may have its own modest evidence for glucose/appetite modulation — but the 'GLP-1' branding misrepresents the mechanism. Would move to Standard 55+ with removal of 'GLP-1' framing + honest ingredient-specific positioning.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "muscle-faktor-berberine-hcl-97-supplement-capsules",
      "title": "Muscle Faktor Berberine HCl 97% Supplement Capsules",
      "vendor": "Muscle Faktor",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1756231974307-generated-label-image-0.jpg?v=1786838528",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "muscle",
        "faktor",
        "berberine",
        "hcl",
        "supplement",
        "capsules",
        "muscle",
        "faktor"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 68,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 39.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741885812933",
      "vsf_explanation": "Muscle Faktor Berberine HCl 97% standardization. Explicit 97% standardization at label is a real quality signal — most berberine products don't disclose standardization %, and 97% HPLC-verified berberine hydrochloride is the pharmaceutical-grade purity used in most published RCTs. Held below Verified by (1) small brand 'Muscle Faktor' without established quality track record; (2) per-cap mg not disclosed at product name; (3) no third-party COA published; (4) no absorption enhancer to compensate for berberine's ~1% oral bioavailability. Would move to Verified 70+ with per-cap mg disclosure + third-party berberine assay + established manufacturer accountability.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bio-nutrition-advanced-berberine-1200-50-vc",
      "title": "BIO NUTRITION: Advanced Berberine 1200, 50 vc",
      "vendor": "Smart Greens",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/854936003730_C1N1.jpg?v=1786838542",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bio",
        "nutrition",
        "advanced",
        "berberine",
        "1200",
        "smart",
        "greens"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 18.13,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741885845701",
      "vsf_explanation": "Bio Nutrition 'Advanced Berberine 1200' — 1200mg per capsule is above the standard studied per-dose range (500mg TID is the reference protocol). At 1200mg/cap × 2/day = 2400mg total daily — above the typical studied dose. Bio Nutrition is a mainstream brand. Held below Verified by (1) 'Advanced' + '1200' marketing framing implies more-is-better without pharmacokinetic support (berberine bioavailability is ~1% regardless of dose — enhancement matters more than raw mg); (2) berberine standardization % not disclosed; (3) no absorption enhancer despite outlier dose; (4) no third-party assay. Would move to Verified 70+ with honest dose positioning + standardization + absorption enhancer + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "biowizdom-berberine-oregon-grape-tincture-2-oz-bottle",
      "title": "BioWizdom Berberine & Oregon Grape Tincture 2 oz Bottle",
      "vendor": "BioWizdom",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/rn-image_picker_lib_temp_8437e086-b704-4fc8-8af7-8111247fd342.jpg?v=1786838554",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "biowizdom",
        "berberine",
        "oregon",
        "grape",
        "tincture",
        "bottle",
        "biowizdom"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741885878469",
      "vsf_explanation": "BioWizdom Berberine + Oregon Grape (Mahonia aquifolium) tincture. Oregon grape is a legitimate secondary source of berberine + related isoquinoline alkaloids (berbamine, oxyacanthine). Traditional-medicine background for the combo. Tincture (alcohol extract) is unusual for berberine — most RCT literature uses standardized capsule berberine HCl at 500mg TID doses; tincture dosing is much harder to standardize. Held below Verified by (1) berberine content per mL not disclosed at product name — essential for liquid extracts; (2) tincture format is difficult to reach studied 500-1500mg/day therapeutic doses (typical tincture 1-2 mL = maybe 50-100mg berberine); (3) small brand; (4) no third-party assay. Would move to Verified 70+ with per-mL berberine content disclosure + third-party assay + honest positioning of tincture doses relative to studied capsule protocols.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "blood-sugar-reset-bundle-berberine-sea-moss-gel-16oz-liver-gallbladder-cleanse-detox-capsules-60-caps",
      "title": "Blood Sugar Reset Bundle - Berberine Sea Moss Gel 16oz + Liver & Gallbladder Cleanse Detox Capsules (60 Caps)",
      "vendor": "Seamoss depot",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/IMG-7046.png?v=1786838658",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "blood",
        "sugar",
        "reset",
        "bundle",
        "berberine",
        "sea",
        "moss",
        "gel",
        "16oz",
        "liver",
        "gallbladder",
        "cleanse",
        "detox",
        "capsules",
        "caps",
        "seamoss",
        "depot"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 69.77,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741886075077",
      "vsf_explanation": "Bundled 'Blood Sugar Reset' package combining berberine + sea moss gel + 'Liver & Gallbladder Cleanse Detox' capsules. Auto-fail: unverified_medical_claim. Multiple issues layered: (1) 'Blood Sugar Reset' medical-outcome framing without RCT evidence for the specific bundle; (2) 'Liver & Gallbladder Cleanse Detox' claims are not supported by established hepatology evidence — the human liver + gallbladder don't require supplemental 'cleansing'; the FDA + FTC have flagged 'cleanse/detox' language as unsupported wellness claims; (3) Sea moss (Chondrus crispus) has near-zero credible clinical evidence for the metabolic + wellness claims that dominate its marketing (see /blogs/news/worst-coq10-supplements-red-flags-2026 for adjacent commentary on ingredient-of-the-moment marketing patterns); (4) 'Reset' + 'Cleanse' + 'Detox' medical-outcome triple-stack; (5) the seller is an Amazon-native reseller without an established quality track record for berberine. Would move to Standard 55+ with removal of medical-outcome claims + honest positioning around each ingredient's actual (limited) evidence base.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "gdaid",
      "title": "GDAid",
      "vendor": "BioStack",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BottleFront_efc77ca5-86e2-4049-b3b7-add4512e536b.jpg?v=1786838664",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gdaid",
        "biostack"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 72,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741886107845",
      "vsf_explanation": "BioStack GDAid — glucose disposal agent (GDA) category product. Typical GDA formulations stack berberine + chromium + banaba (corosolic acid) + R-lipoic acid + cinnamon + gymnema — each with modest independent glucose-modulation evidence. BioStack is an established longevity/performance-focused brand with real formulation research investment. Held below Verified by (1) per-active mg breakdown not disclosed at product name — for combo GDA products this is essential since each active has its own dose-response curve (berberine studied at 500mg TID, chromium at 200-1000mcg, R-ALA at 300-600mg, banaba at 24mg corosolic acid); (2) 'GDAid' branding is bodybuilding-context marketing rather than clinical positioning; (3) no third-party assay. Would move to Verified 70+ with per-active mg breakdown + third-party COA + honest positioning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "berberine-plus-cp-30-nutrabetic",
      "title": "Berberine plus cp 30 nutrabetic",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/20241218145530_N13671Nutrabetic_Berberine_350x500_01436f73-8dbd-4b4f-941b-162476534528.jpg?v=1786838674",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "berberine",
        "plus",
        "nutrabetic",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 48,
        "sustainability": 50
      },
      "price": 24,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741886140613",
      "vsf_explanation": "Generic pharmacy 'Berberine Plus CP Nutrabetic' — 'CP' pharmacy-code product with 'Nutrabetic' branding (implying diabetes-adjacent). 'Nutrabetic' branding pushes toward disease claim territory (nutrition + diabetic marketing) but stops short of explicit disease-treatment claim. Held below Verified by (1) fully-generic pharmacy branding without manufacturer accountability; (2) per-cap mg + berberine standardization not disclosed; (3) 'Nutrabetic' health-claim framing warrants scrutiny (products marketed near disease claims should include disclaimers + physician-consultation prompts); (4) 30-count SKU is very small (10 days at 1 cap TID). Would move to Verified 70+ with named manufacturer + full dose disclosure + honest positioning outside disease-claim adjacencies.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-truth-berberine-veggie-capsules️",
      "title": "Nature's Truth Berberine Veggie Capsules️",
      "vendor": "Duo Grocery",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/large_ed8df267-6ee2-4b5c-b59a-0392e649788e.jpg?v=1786838687",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "truth",
        "berberine",
        "veggie",
        "capsules",
        "duo",
        "grocery"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 65,
        "safety": 72,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 22.36,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741886238917",
      "vsf_explanation": "Nature's Truth Berberine veggie cap. Nature's Truth is a mainstream mass-market brand (Piping Rock family). Held below Verified by (1) per-cap mg not disclosed at product name; (2) berberine standardization % not disclosed; (3) no absorption enhancer; (4) no third-party assay published. Would move to Verified 70+ with dose + standardization + third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dietworks-glp-1-companion-tablets",
      "title": "Dietworks Glp 1 Companion Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/611Spv5TaRL._AC_SY606.jpg?v=1786838836",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dietworks",
        "glp",
        "companion",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 50,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 18.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741888565445",
      "vsf_explanation": "'GLP-1 companion' branding is a rising red flag category — products marketing themselves as adjuncts to semaglutide/tirzepatide (Ozempic, Wegovy, Mounjaro) without clinical validation of the combination. No RCT has evaluated any specific 'GLP-1 companion' supplement + injectable GLP-1 protocol. The naming leverages medical association without evidence. Autofailed on unverified medical claim; would need renaming as a general electrolyte/protein product for the underlying ingredients to be evaluated on their own merits.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "achieve-berberine-1200mg-glucose-support-60-vegetable-capsules-natural-metabolic-immune-support",
      "title": "Achieve Berberine 1200mg Glucose Support, 60 Vegetable Capsules – Natural Metabolic & Immune Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/48346353.jpg?v=1786838898",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "achieve",
        "berberine",
        "1200mg",
        "glucose",
        "support",
        "vegetable",
        "capsules",
        "natural",
        "metabolic",
        "immune",
        "support",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 20.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741889581253",
      "vsf_explanation": "'Achieve' branded berberine at 1200mg per serving is close to the higher end of the studied 1000-1500mg/day range (Yin 2008 diabetes trial). Higher single-serving doses risk more GI upset than split TID dosing. Achieve isn't a widely recognized supplement brand — likely a private-label or Amazon-native SKU. Would move to Verified 70+ with dihydroberberine or Sunfiber bioavailability enhancement and TID dosing recommendation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "berberine-blood-sugar-balance-metabolic-support",
      "title": "Berberine | Blood Sugar Balance & Metabolic Support",
      "vendor": "NYC Herbs®",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/berberinr.jpg?v=1786838934",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "berberine",
        "blood",
        "sugar",
        "balance",
        "metabolic",
        "support",
        "nyc",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 55,
        "manufacturing": 48,
        "safety": 55,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 17,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741890203845",
      "vsf_explanation": "Berberine has strong RCT support for glycemic and lipid endpoints (Yin 2008, Zhang 2010 meta), typically at 500mg 2-3x/day. NYC Herbs is a small brand and per-cap mg isn't clearly disclosed from title. Trial-matching requires 1000-1500mg/day total. GI tolerability concerns (diarrhea, cramping) not surfaced. Would move to Standard 65+ with per-cap mg at clinical range and TID dosing guidance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "21st-century-berberine-hci-60-vegetarian-capsules-500-mg-per-capsule",
      "title": "21st Century Berberine HCI, 60 Vegetarian Capsules (500 Mg Per Capsule)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/357588100_4eede33d-30d4-4ad7-99ca-377b952ab347.jpg?v=1786838960",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "21st",
        "century",
        "berberine",
        "hci",
        "vegetarian",
        "capsules",
        "500",
        "per",
        "capsule",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 58,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 22.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741890531525",
      "vsf_explanation": "21st Century Berberine HCl 500mg is at the standard clinical dose used in metabolic and lipid RCTs (Yin 2008 for glucose, Kong 2004 for cholesterol). Berberine has robust evidence for A1c and lipid reduction — often called 'nature's metformin'. HCl form is the studied form. 21st Century is a US budget brand without third-party testing per SKU. Would move to Verified 70+ with dihydroberberine or Sunfiber-berberine bioavailability enhancement and named source.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sweet-blood-sugar-support-supplement",
      "title": "Sweet Blood Sugar Support Supplement",
      "vendor": "ForWomn | Women's Health and Nutrition Supplements and More",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Sweet-Blood-Sugar-Support.png?v=1786839017",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sweet",
        "blood",
        "sugar",
        "support",
        "supplement",
        "forwomn",
        "women",
        "health",
        "and",
        "nutrition",
        "supplements",
        "and",
        "more"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 50,
        "manufacturing": 48,
        "safety": 60,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741890662597",
      "vsf_explanation": "Small-brand blood-sugar-support blend. Category-standard ingredients (berberine, chromium, cinnamon, alpha-lipoic acid) have varying RCT support — berberine strongest (Yin 2008), chromium modest, cinnamon inconsistent. ForWomn is a small women's-wellness brand with no per-active mg on the title, no clinical dosing confirmation, no third-party testing visible. Would move to Standard 60+ with named actives at studied doses (berberine 500mg 3x/day).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "yeast-and-candida-defense-blend",
      "title": "Yeast and candida defense blend",
      "vendor": "NYC Herbs®",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BLEND_YEAST.png?v=1786839042",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "yeast",
        "and",
        "candida",
        "defense",
        "blend",
        "nyc",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 50,
        "manufacturing": 48,
        "safety": 55,
        "transparency": 40,
        "sustainability": 55
      },
      "price": 18,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741890793669",
      "vsf_explanation": "'Yeast and candida defense' is a category where 'systemic candida' is largely not a validated diagnosis outside of immunocompromised patients — mainstream medicine treats it as functional-medicine speculation. Products are typically multi-herb proprietary blends (pau d'arco, oregano oil, caprylic acid, etc.) without per-active mg disclosure. NYC Herbs is a small brand with no visible clinical data. Would move to Standard 55 if reformulated as evidence-based gut-support with disclosed per-ingredient doses.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "gut-check-bundle",
      "title": "Gut Check Bundle",
      "vendor": "Lure Essentials",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/GLP_GutSerenity_Bundles.jpg?v=1786839057",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gut",
        "check",
        "bundle",
        "lure",
        "essentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741890859205",
      "vsf_explanation": "Lure Essentials is primarily a cupping/wellness-tools brand; 'Gut Check Bundle' is a bundle product with unclear component breakdown from the title alone. Bundle SKUs are notoriously hard to score because each component needs its own evaluation. Small-brand supplement extension with no visible clinical validation or third-party testing. Would move to Standard 60+ with per-component ingredient disclosure and clinical-dose alignment.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nitro-pump-blue-razz",
      "title": "Nitro Pump Blue Razz",
      "vendor": "2.0 Lifestyle",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1761857008960-generated-label-image-2.jpg?v=1786839096",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nitro",
        "pump",
        "blue",
        "razz",
        "lifestyle"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741890957509",
      "vsf_explanation": "Small-brand pump-focused pre-workout. Category standard actives (citrulline, betaine, arginine) have decent RCT support at trial-effective doses, but 2.0 Lifestyle doesn't disclose per-active mg on the title, so trial-matching isn't possible. Blueberry-flavored artificial-color formulation. Would move to Standard 65+ with open-label formulation and citrulline at 6-8g clinical dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nature-made-vitamin-b-1-100-mg-dietary-supplement-tablets",
      "title": "Nature Made Vitamin B-1 100 Mg Dietary Supplement Tablets",
      "vendor": "Nature Made",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/53109875_af66826d-4a21-493d-a434-0cbab3b297fa.jpg?v=1786839590",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "made",
        "vitamin",
        "100",
        "dietary",
        "supplement",
        "tablets",
        "nature",
        "made"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 58,
        "manufacturing": 72,
        "safety": 65,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 6.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741892202693",
      "vsf_explanation": "Nature Made Thiamine HCl 100mg is a mainstream USP-verified brand offering — Nature Made carries USP verification on much of their line, which is meaningful QC assurance. HCl form is the cheapest but poorly bioavailable for tissue thiamine delivery vs benfotiamine. Would move to Verified 70+ if reformulated as benfotiamine for diabetic neuropathy and cellular thiamine indications.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-b-complex-with-vitamin-c-stress-formula-100-tablets",
      "title": "Solgar B-Complex with Vitamin C Stress Formula 100 Tablets",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33984002005.png?v=1786839611",
      "score": 76,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive",
        "mood",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "complex",
        "with",
        "vitamin",
        "stress",
        "formula",
        "100",
        "tablets",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 70,
        "manufacturing": 78,
        "safety": 72,
        "transparency": 72,
        "sustainability": 62
      },
      "price": 13.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741892268229",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 70 → new 76. Evidence found: Stough C, et al. The effect of 90-day administration of a high-dose vitamin B-complex on work stress. Hum Psychopharmacol. 2011;26(7):470-6.. Rationale: B-complex + vitamin C has TIER-B evidence for subjective work-stress reduction (Stough 2011 RCT). +6 uplift. Format still uses standard B-vitamin forms (pyridoxine, cyanocobalamin), not activated methyls - so uplift capped below the Ultimate B+C SKU.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-megasorb-b-complex-50-100-tablets",
      "title": "Solgar Megasorb B-Complex \"50\" 100 Tablets",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33984017511.jpg?v=1786839639",
      "score": 78,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "megasorb",
        "complex",
        "100",
        "tablets",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 74,
        "manufacturing": 78,
        "safety": 72,
        "transparency": 74,
        "sustainability": 62
      },
      "price": 22.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741892366533",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 72 → new 78. Evidence found: Stough C, et al. High-dose B-complex work stress trial. Hum Psychopharmacol. 2011;26(7):470-6. | Solgar Megasorb sustained-release delivery matrix (proprietary tablet coating).. Rationale: Megasorb '50' B-Complex uses Solgar's sustained-release tablet matrix at 50 mg per B vitamin - well above RDA and matched to the Stough 2011 protocol scale. Sustained-release format reduces the urine flush and gives more even blood levels. +6 uplift for the specific formulation edge plus B-complex evidence base.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutraxin-b-vitamin-complex-60-tablets",
      "title": "Nutraxin B Vitamin Complex 60 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/61oSdqUcmFL.jpg?v=1786839659",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutraxin",
        "vitamin",
        "complex",
        "tablets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 48,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 26.42,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741892530373",
      "vsf_explanation": "Nutraxin is a Turkish OTC brand. B-complex products have solid nutritional rationale — helpful in genuine deficiency (alcohol use, refeeding, MTHFR variants) but energy claims in adequately nourished users are marketing-driven. Per-vitamin mg and form (methylated vs synthetic) not disclosed on title. The reseller channel adds no additional US QC. Would move to Standard 62+ with methylated B-form disclosure and per-vitamin dosing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrex-lipo-6-nighttime-30-caps",
      "title": "Nutrex LIPO-6 NightTime, 30 Caps",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Lipo6-NightTime.webp?v=1786839668",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrex",
        "lipo",
        "nighttime",
        "caps",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741892563141",
      "vsf_explanation": "Nutrex LIPO-6 NightTime is a 'sleep + weight loss' combo product — a category with essentially zero RCT support for the compound claim. Typically stacks melatonin, valerian, GABA, plus fat-burner actives. Combining sleep aids with metabolic actives at unclear doses is more marketing than mechanism. Nutrex is a legit sports-nutrition brand but this category is fundamentally weak. Would move to Standard 60 with either a clean sleep formula OR a fat burner, not both.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "21st-century-vitamin-b1-100-mg-tablets",
      "title": "21st Century Vitamin B1 100 Mg Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/206187267_cd31580a-e5ce-4974-bd06-4eafdeaf84aa.jpg?v=1786839677",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "21st",
        "century",
        "vitamin",
        "100",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 3.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741892595909",
      "vsf_explanation": "21st Century Vitamin B1 100mg is standard thiamine HCl at a common OTC dose. Good for deficiency correction but low bioavailability compared to benfotiamine for tissue thiamine delivery. Budget-brand manufacturing without third-party testing per SKU. Would move to Standard 62+ with benfotiamine or thiamine pyrophosphate form.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "21st-century-mega-multi-for-women-multivitamin-tablets",
      "title": "21st Century Mega Multi For Women, Multivitamin, Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/96518333.jpg?v=1786839695",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "21st",
        "century",
        "mega",
        "multi",
        "for",
        "women",
        "multivitamin",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 11.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741892628677",
      "vsf_explanation": "21st Century Mega Multi for Women is a higher-dose women's multi in the same budget-brand family. Higher doses of common vitamins/minerals aren't automatically better and can push certain nutrients (iron, A) past useful levels. Same cheap-form concern (cyanocobalamin, folic acid). Would move to Standard 62+ with methylated forms, named D3 dose, and rational iron content.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "21st-century-sentry-women-multivitamin-tablets",
      "title": "21st Century Sentry Women Multivitamin Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/251909244.jpg?v=1786839703",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "21st",
        "century",
        "sentry",
        "women",
        "multivitamin",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 52,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741892661445",
      "vsf_explanation": "21st Century Sentry Women is a Centrum Women equivalent — mass-market budget multi with age/sex-appropriate iron. Uses cheap vitamin forms (folic acid instead of methylfolate, cyanocobalamin B12). Minimum-effective doses on most micronutrients. Adequate baseline nutritional insurance for a healthy adult woman without special needs. Would move to Standard 62+ with methylated folate/B12 and named D3 dosing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nbt-life-benfolite-with-benfotiamine-vitamin-b1-supplement-60-easy-to-swallow-capsules",
      "title": "Nbt Life Benfolite with Benfotiamine Vitamin B1 Supplement, 60 Easy-to-Swallow Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/UiWj13wEVsFhsYR8g4axsWez2XzJHsQFVfnZFsbL.jpg?v=1786839716",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nbt",
        "life",
        "benfolite",
        "with",
        "benfotiamine",
        "vitamin",
        "supplement",
        "easy",
        "swallow",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 48,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 62.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741892694213",
      "vsf_explanation": "Benfotiamine has good RCT support for diabetic neuropathy (Stracke 2008, Haupt 2005 BENDIP at 300-600mg/day). NBT Life is a Turkish brand; per-cap mg not clearly disclosed on title, so dose-matching to trials isn't confirmable. The reseller channel introduces import concerns. Would move to Standard 65+ with clear per-cap benfotiamine mg at studied 300-600mg range.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nature-made-vitamin-c-500-mg-tablets-250-count-for-immune-support-gluten-free",
      "title": "Nature Made Vitamin C 500 Mg Tablets, 250 Count, For Immune Support, Gluten Free",
      "vendor": "Nature Made",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/40327959.jpg?v=1786839729",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "made",
        "vitamin",
        "500",
        "tablets",
        "250",
        "count",
        "for",
        "immune",
        "support",
        "gluten",
        "free",
        "nature",
        "made"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 72,
        "safety": 65,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 17.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741892726981",
      "vsf_explanation": "Nature Made Vitamin C 500mg is a mass-market USP-verified product — Nature Made carries USP verification on a broad SKU set, which is uncommon in supplement space. Vitamin C has modest RCT support for cold duration reduction (Hemilä 2013 Cochrane); therapeutic effect is dose-dependent above ~200mg with diminishing returns. Ascorbic acid form is fine but liposomal or Ester-C forms are gentler on stomach. Would move to Verified 70+ if the specific batch shows USP verification on this SKU (some Nature Made products but not all).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "21st-century-sentry-senior-multivitamin-amp-multimineral-supplement-for-adults-50-265-tablets",
      "title": "21st Century Sentry Senior – Multivitamin &amp; Multimineral Supplement for Adults 50+ (265 Tablets)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/78584103.jpg?v=1786839767",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "adults_50_plus",
      "tokens": [
        "21st",
        "century",
        "sentry",
        "senior",
        "multivitamin",
        "amp",
        "multimineral",
        "supplement",
        "for",
        "adults",
        "265",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 52,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 13.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741892759749",
      "vsf_explanation": "21st Century Sentry Senior is a Centrum Silver-equivalent budget senior multi. Age-appropriate design (lower iron, higher B12/D). Physicians' Health Study II (Sesso 2012) showed Centrum Silver reduced cancer incidence modestly in older men. Uses cheap forms (cyanocobalamin, folic acid instead of methylfolate) and mostly minimum-RDA dosing. Would move to Standard 62+ with methylated B-vitamin forms and D3 above 1000IU.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "doctors-best-benfotiamine-300mg-60-veggie-capsules-vitamin-b1-support",
      "title": "DOCTOR'S BEST: Benfotiamine 300mg 60 Veggie Capsules | Vitamin B1 Support",
      "vendor": "Doctor's Best",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/753950002708_C1N1.jpg?v=1786839829",
      "score": 80,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "doctor",
        "best",
        "benfotiamine",
        "300mg",
        "veggie",
        "capsules",
        "vitamin",
        "support",
        "doctor",
        "best"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 78,
        "manufacturing": 75,
        "safety": 72,
        "transparency": 72,
        "sustainability": 60
      },
      "price": 24.17,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741892956357",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 72 → new 80. Evidence found: Stracke H et al. Benfotiamine in diabetic polyneuropathy (BENDIP). Exp Clin Endocrinol Diabetes. 2008;116(10):600-605. | Haupt E et al. Benfotiamine in the treatment of diabetic polyneuropathy—a three-week randomized, controlled pilot study. Int J Clin Pharmacol Ther. 2005;43(2):71-77.. Rationale: 300 mg matches the BENDIP trial dose (Stracke 2008) — full therapeutic dose in a single capsule. Higher-value SKU than the 150 mg variant for anyone actually treating diabetic polyneuropathy. Uplift to 80.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natrul-health-vitamin-b-1-thiamine-100-mg-100-tablets",
      "title": "Natrul Health Vitamin B-1 (Thiamine) 100 mg – 100 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/108144035.jpg?v=1786839846",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "natrul",
        "health",
        "vitamin",
        "thiamine",
        "100",
        "100",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 6.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741892989125",
      "vsf_explanation": "Standard thiamine HCl 100mg is a widely used nutrient dose. Thiamine has solid evidence for deficiency states (alcoholism, refeeding, high-carb diets — Costantini 2013 for fatigue). HCl form is the cheapest but poorly bioavailable form; benfotiamine or thiamine pyrophosphate cross the BBB and cell membranes better. Natrul Health is a small OTC brand. Would move to Standard 62+ with benfotiamine form or higher-bioavailability variant.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-b-12",
      "title": "Vitamin B-12",
      "vendor": "LIVS Gummies",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/LV3420_B-12_60ct-2.png?v=1786839925",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "livs",
        "gummies"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 22.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46741893218501",
      "vsf_explanation": "B12 gummy from a small brand. B12 has solid nutritional rationale (deficiency prevention, especially in vegetarians and older adults on PPIs/metformin). Form (methylcobalamin vs cyanocobalamin) not disclosed on title — methylcobalamin is preferred for MTHFR variants. Gummy format adds sugar and reduces stability. Would move to Standard 65+ with methylcobalamin sub-lingual delivery and named form.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nootropics-energy-drink-og-mango",
      "title": "Nootropics Energy Drink, OG Mango",
      "vendor": "BRAiNLUBE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3f4a40cd-411a-48ad-81ee-bc7acfd66800-2026-08-21.png?v=1787416099",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nootropics",
        "energy",
        "drink",
        "mango",
        "brainlube"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 30,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790156648645",
      "vsf_explanation": "BRAiNLUBE is a small nootropic-energy-drink brand. Category standard is caffeine + L-theanine + minor nootropic dusting; individual ingredient mg disclosure typically weak. Actives at RTD-can format are often below trial-effective doses (e.g., alpha-GPC at 100mg vs studied 400mg). Small-brand with no visible third-party testing. Would move to Standard 65+ with per-active mg disclosure at label-front.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrafol-women-3-month-pack",
      "title": "NUTRAFOL WOMEN 3 MONTH PACK",
      "vendor": "NUTRAFOL @ NYALLERGY",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NUTRAFOLWOMENS.jpg?v=1787416167",
      "score": 80,
      "tier": "elite",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "nutrafol",
        "women",
        "month",
        "pack",
        "nutrafol",
        "nyallergy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 76,
        "formulation": 75,
        "manufacturing": 75,
        "safety": 72,
        "transparency": 75,
        "sustainability": 62
      },
      "price": 209,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790179389637",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 74 → new 80. Evidence found: Ablon G, Kogan S. A Six-Month, Randomized, Double-Blind, Placebo-Controlled Study Evaluating the Safety and Efficacy of a Nutraceutical Supplement for Promoting Hair Growth in Women With Self-Perceived Thinning Hair. J Drugs Dermatol. 2019;18(1):55-59. | Ablon G. A 3-Month, Randomized, Double-Blind, Placebo-Controlled Study Evaluating the Ability of an Extra-Strength Marine Protein Supplement to Promote Hair Growth and Decrease Shedding in Women with Self-Perceived Thinning Hair. Dermatol Res Pract. 2015; article ID 841570.. Rationale: Flagship Nutrafol Women formula has the strongest brand-specific evidence in the entire hair-supplement category: Ablon 2019 double-blind RCT showing +41% terminal hair count at 24 weeks with hair diameter and shedding improvements. Prior 2015 marine-protein RCT establishes core protein technology. Elite tier justified by unmatched hair-growth RCT depth for a nutraceutical.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "raw-nutrition-pump-unflavored",
      "title": "RAW Nutrition Pump² - Unflavored",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/RAW-Nutrition-Pump2-Unflavored.webp?v=1787416184",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "raw",
        "nutrition",
        "pump",
        "unflavored",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 72,
        "manufacturing": 68,
        "safety": 65,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 14.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790182404293",
      "vsf_explanation": "RAW Nutrition (Chris Bumstead / Matt Jansen brand) Pump² is a stim-free pre-workout centered on L-citrulline, glycerol, betaine, and pump-focused actives. RAW publishes open-label formulations. Citrulline has consistent NO/pump evidence at 6-8g/day (Bailey 2015 meta). Similar formulation quality to Kaged Muscle or Transparent Labs. Would move to Verified 70+ with NSF Certified for Sport or Informed Sport certification per lot.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "spermidine-supplement-tablets",
      "title": "Spermidine Supplement Tablets",
      "vendor": "Neurogan Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/spermidine_shadow.jpg?v=1787416189",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "spermidine",
        "supplement",
        "tablets",
        "neurogan",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790183715013",
      "vsf_explanation": "Spermidine has interesting autophagy/longevity preclinical data (Eisenberg 2016) and one small memory RCT (Wirth 2018) suggesting cognitive benefit at ~1.2mg/day. Neurogan doesn't disclose wheat-germ-extract source or per-tablet spermidine mg. The category leaders (Spermidine LIFE, Prima) name Wheat Germ Extract and standardization; Neurogan doesn't from title. Would move to Verified 70+ with spermidineLIFE-style source and mg disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nad-capsules-1",
      "title": "NAD+ Capsules",
      "vendor": "Neurogan Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NeuroganHealth_NAD_Capsules_900mg_Front_Shadow.jpg?v=1787416197",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nad",
        "capsules",
        "neurogan",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790186696901",
      "vsf_explanation": "Direct oral NAD+ is largely degraded to nicotinamide before absorption; precursor supplementation (NR/NMN) is the studied approach for raising NAD levels (Martens 2018 NR, Yoshino 2021 NMN). Oral NAD+ capsules deliver something like nicotinamide-level effects rather than direct NAD elevation. Neurogan is a small brand; per-cap mg and stabilization technology not disclosed. Would move to Standard 62+ if reformulated as NR (Niagen) or NMN with clear dosing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "upwellness-golden-revive-joint-support-with-quercetin-magnesium-and-turmeric-60-capsules-6-active-ingredients-for-joint-and-muscle-care-physician-formulated",
      "title": "UpWellness Golden Revive + Joint Support with Quercetin, Magnesium, and Turmeric,  60 Capsules - 6 Active Ingredients for Joint and Muscle Care - Physician Formulated",
      "vendor": "NutritionAdvice",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71p4uszb6tL._AC_SL1500.jpg?v=1787416248",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "upwellness",
        "golden",
        "revive",
        "joint",
        "support",
        "with",
        "quercetin",
        "magnesium",
        "and",
        "turmeric",
        "capsules",
        "active",
        "ingredients",
        "for",
        "joint",
        "and",
        "muscle",
        "care",
        "physician",
        "formulated",
        "nutritionadvice"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 111.54,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790203310277",
      "vsf_explanation": "UpWellness Golden Revive+ is a Dr. Josh Levy-branded joint-support blend combining curcumin, quercetin, magnesium, boswellia, bromelain. Individual ingredients have modest RCT support (Chandran 2012 curcumin, Ammon 2016 boswellia); combination isn't specifically studied. UpWellness has faced FTC-adjacent scrutiny for marketing claims. Doses per-ingredient not clearly disclosed at title. Physician-formulated is a marketing claim, not a QC guarantee. Would move to Standard 62+ with per-active mg and standardized extract disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "citracal-calcium-supplement-slow-release-1200-d3-80-coated-tablets",
      "title": "Citracal Calcium Supplement, Slow Release 1200 + D3, 80 Coated Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/302781492_28aa4f30-7874-4e4e-b098-dc075055f5d6.jpg?v=1787416259",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "citracal",
        "calcium",
        "supplement",
        "slow",
        "release",
        "1200",
        "coated",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 68,
        "manufacturing": 68,
        "safety": 62,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 14.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790207635653",
      "vsf_explanation": "Citracal (Bayer) is one of the better-formulated OTC calcium products — calcium citrate absorbs independently of stomach acid (Heaney 1999), important for older adults on PPIs. Slow-release adds tolerability. 1200mg with D3 targets postmenopausal bone-health protocols (WHI's calcium+D showed hip fracture benefit in adherent users). Concerns exist about supplemental calcium and cardiovascular risk (Bolland 2011 meta) — dose is on the high end. Would move to Verified 70+ with lower 500-600mg elemental split-dose format.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "21st-century-600-d3-calcium-vitamin-d3-supplement-400-tablets",
      "title": "21st Century 600+D3, Calcium & Vitamin D3 Supplement, 400 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/251313565_ec73f051-52b9-4c5c-a756-3ccd0f635433.jpg?v=1787416265",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "21st",
        "century",
        "600",
        "calcium",
        "vitamin",
        "supplement",
        "400",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790210814149",
      "vsf_explanation": "Calcium 600mg + vitamin D3 is a bone-health basic. 21st Century is a US mass-market budget brand — calcium form typically carbonate rather than citrate, which requires food for absorption and can worsen constipation. D3 dose (typically 400IU in these SKUs) is below Institute of Medicine current RDA of 600-800IU. Would move to Standard 65+ with calcium citrate form and D3 at 1000-2000IU.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "love-wellness-sparkle-fiber-vegan-dietary-supplements-90ct-new",
      "title": "Love Wellness Sparkle Fiber Vegan Dietary Supplements 90ct - New",
      "vendor": "This is Beauty US",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/GUEST_14811b33-407f-44fa-80e5-43f295a1ca11.jpg?v=1787416281",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "love",
        "wellness",
        "sparkle",
        "fiber",
        "vegan",
        "dietary",
        "supplements",
        "90ct",
        "new",
        "this",
        "beauty"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 65,
        "safety": 68,
        "transparency": 62,
        "sustainability": 60
      },
      "price": 14.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790213206213",
      "vsf_explanation": "Love Wellness Sparkle Fiber is a psyllium-and-friends fiber blend from a reputable DTC women's-wellness brand (Lo Bosworth). Psyllium has strong RCT support for regularity and modest cholesterol effect (Anderson 2000 meta), typically at 5-10g/day. Capsule fiber products deliver much less than powder-scoop dosing — a real formulation limitation across the category. Would move to Verified 70+ with 5g+ per-serving fiber content or complementary powder format.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "new-life-b-active-trio-dietary-supplement-for-nutritional-support-and-energy-30-capsules",
      "title": "New Life B Active Trio Dietary Supplement for Nutritional Support and Energy - 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/xfnaRtax8cZFILhKya5ycj9WYtJO9EmNqNmAL0Sk.jpg?v=1787416289",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "new",
        "life",
        "active",
        "trio",
        "dietary",
        "supplement",
        "for",
        "nutritional",
        "support",
        "and",
        "energy",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 48,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 22.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790215106757",
      "vsf_explanation": "'B Active Trio' is a Turkish-market B-complex/energy blend; New Life is a small foreign brand. B-vitamin complexes have solid nutritional rationale but marketing 'energy' benefits only holds in genuinely B-deficient individuals. Per-vitamin mg not disclosed on the title, no methylated form disclosure. The reseller channel adds no US-market QC. Would move to Standard 62+ with methylated B12/folate disclosure and per-vitamin mg.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitabiotics-wellwoman-70-dietary-supplement-for-women-multivitamin-and-antioxidant-support-for-seniors-30-tablets",
      "title": "Vitabiotics Wellwoman 70+ Dietary Supplement for Women - Multivitamin and Antioxidant Support for Seniors, 30 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/JCJQTqcw3dczZLxwuiV449b6bdiSxV5pdE4tTplx.jpg?v=1787416295",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "vitabiotics",
        "wellwoman",
        "dietary",
        "supplement",
        "for",
        "women",
        "multivitamin",
        "and",
        "antioxidant",
        "support",
        "for",
        "seniors",
        "tablets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 68,
        "manufacturing": 68,
        "safety": 68,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 31.31,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790216941765",
      "vsf_explanation": "Vitabiotics Wellwoman 70+ is a UK-designed senior-women's multi with age-appropriate B12, D3, and lower iron. Vitabiotics is a well-regarded British brand with published clinical trials on multiple SKUs. Formulation is sensible for older women — bone/cognition support-oriented. The reseller channel adds Turkish/international import concerns for US buyers. Would move to Verified 72+ if sold direct via Vitabiotics US channels with US batch traceability.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nac-n-acetyl-cysteine",
      "title": "NAC N-Acetyl Cysteine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/590c1dd8-9e04-4457-8356-87e7279dca9c_large_78fc4d05-6576-48b4-83b7-c3989964a167.jpg?v=1787416300",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nac",
        "acetyl",
        "cysteine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 66,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 21.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790218416325",
      "vsf_explanation": "Standard-strength Swanson NAC — legitimate glutathione precursor with real mucolytic (Grandjean 2000) and acetaminophen antidote clinical use. Held to mid-Standard by no source disclosure (AjiPure vs bulk), lower potency than the Extra Strength sibling SKU, and standard drug-interaction cautions with nitroglycerin and immunosuppressants. Would move up with AjiPure or Ajinomoto pharmaceutical-grade sourcing named.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "niacin-bound-chromium-from-chromemate",
      "title": "Niacin-Bound Chromium - from ChromeMate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/69326cfb-a0aa-4023-bb7d-22762a2d9dbf_large_93128c42-0312-47f1-b232-5c9611378d60.jpg?v=1787416306",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "niacin",
        "bound",
        "chromium",
        "from",
        "chromemate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 75,
        "manufacturing": 68,
        "safety": 70,
        "transparency": 74,
        "sustainability": 55
      },
      "price": 3.25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790220054725",
      "vsf_explanation": "ChromeMate is a named, patented chromium-nicotinate polynicotinate form (InterHealth) with published pharmacokinetics showing better absorption and retention than chromium picolinate. Chromium has modest glycemic-support evidence at 200-1000 mcg/day (Anderson 1997, Costello 2016 review — mixed). Named-source ingredient plus reasonable form supports low-Verified. Held below Elite by mixed clinical evidence for chromium's metabolic endpoints and no third-party COA. Would move to Verified 75+ with independent testing and clear mcg dose disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "apigenin",
      "title": "Apigenin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7b7fa4c1-37df-4925-9c40-7811d0080925_large_95f2687c-dde0-479b-bd13-e0211974a430.jpg?v=1787416330",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "apigenin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 62,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790226051269",
      "vsf_explanation": "Apigenin — the flavonoid concentrated in chamomile, popularized in longevity/sleep protocols (Attia stack). Human RCT base for isolated apigenin is thin; most evidence is for chamomile extract (Amsterdam 2009 for GAD). Preclinical Nrf2/senolytic/sleep-modulating signals are interesting but not yet outcome-confirmed in humans. Isolated apigenin at 50 mg is the popular longevity-community dose without a clean clinical anchor. Would move to Verified 70+ with a defined dose rationale, third-party purity testing, and an outcome-linked human RCT.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ultimate-probiotic-formula",
      "title": "Ultimate Probiotic Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2c2141b9-4c14-4335-9930-0049a3053389_large_0f1cbfec-5c29-4489-a08d-22643fedeb3a.jpg?v=1787416330",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ultimate",
        "probiotic",
        "formula",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 25.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790226018501",
      "vsf_explanation": "Swanson's flagship multi-strain probiotic formula. Marketing name 'Ultimate' offers no clinical anchor; strain-level identifiers and CFU-at-expiration are the meaningful signals and are not present in the title. Would move to Verified with strain IDs, CFU-at-expiration, and delayed-release delivery.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "joint-formula-with-hyaluronic-acid",
      "title": "Joint Formula with Hyaluronic Acid",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5ae7a5d7-e2cc-4828-bbc2-107023daaae8_large_d60d50c6-ebfc-4846-a27d-d025d65178ad.jpg?v=1787416330",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "joint",
        "formula",
        "with",
        "hyaluronic",
        "acid",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 58,
        "sustainability": 52
      },
      "price": 33.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790226084037",
      "vsf_explanation": "Generic 'joint formula' with HA — no primary actives disclosed at title. Oral HA has modest joint support (Nelson 2015, Kalman 2008 at 80-200 mg/day). Held below Verified by opaque ingredient list, unstated HA source/MW, and 'joint formula' framing that usually means small doses of many actives. Would move to Verified 70+ with per-active mg disclosure and named low-MW HA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "the-skin-pill",
      "title": "The Skin Pill",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4f923967-7c35-47f4-b1fb-55fda7bcd220_large_c4ffe017-2161-4c01-bc5f-e3e8c7adc678.jpg?v=1787416332",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "the",
        "skin",
        "pill",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 52,
        "sustainability": 50
      },
      "price": 38.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790226903237",
      "vsf_explanation": "Second 'The Skin Pill' SKU variant. Same generic marketing name with no active-ingredient hint at title level — an inherent transparency problem. Beauty-from-within category has real evidence for hydrolyzed collagen, astaxanthin, HA, but only with named actives and doses. Held below Verified by opaque naming. Would move to Verified 70+ with title-level active disclosure at clinical doses.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "allicin-from-garlic",
      "title": "Allicin from Garlic",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5c7ecba6-1ce2-4039-8948-e22f66535131_large_c39ceb65-fe95-407f-9a34-a93ac0efa97f.jpg?v=1787416332",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "allicin",
        "from",
        "garlic",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 64,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 15.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790226706629",
      "vsf_explanation": "Standardizing to allicin (rather than just crude garlic bulb) is a real transparency win — allicin is the sulfur compound most directly implicated in garlic's cardiovascular mechanisms, though the Ried 2013 BP meta actually rests primarily on aged garlic extract (SAC), not allicin per se. Allicin is chemically unstable and requires enteric coating and controlled release to survive gastric acid. Would move to Verified 70+ with disclosed allicin content per serving, enteric coating, and third-party assay confirming allicin-release.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "green-coffee-complex-featuring-green-tea-raspberry-ketones",
      "title": "Green Coffee Complex - Featuring Green Tea & Raspberry Ketones",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/95d0d0cc-b8a2-4937-b278-766714f3cefc_large_d56b40d4-8f29-4ce3-a540-454166b4b12e.jpg?v=1787416332",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "green",
        "coffee",
        "complex",
        "featuring",
        "green",
        "tea",
        "raspberry",
        "ketones",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 17.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790226673861",
      "vsf_explanation": "Combines three infomercial-era weight-loss ingredients — green coffee bean (Vinson 2012 retracted; FTC 2014 action), raspberry ketones (no human RCT support) and green tea (real EGCG evidence but modest at best, Hursel 2009 meta-analysis). The stack reads as a marketing composite rather than a mechanistic design. Would not recommend.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "certified-organic-lavender-essential-oil",
      "title": "Certified Organic Lavender Essential Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/99237ddc-6802-49ee-b5f2-0c319eccbc5d_large_3dfcdc60-fd69-4f04-b41a-e9c8140b6ab0.jpg?v=1787416332",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "certified",
        "organic",
        "lavender",
        "essential",
        "oil",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 50,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 17.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790226739397",
      "vsf_explanation": "Topical/aromatherapy essential oil — not a supplement in the ingested sense. Oral standardized lavender (Silexan 80 mg/day) has real anxiolytic evidence (Kasper 2014), but that's a specific gastroresistant capsule, not aromatherapy oil. Real safety flag: repeated topical lavender use has case reports of prepubertal gynecomastia (Henley 2007). Out of biohacking-ingestible scope; scored honestly.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "garlic-with-vitamin-e-hawthorn-cayenne-coq10-odor-controlled",
      "title": "Garlic with Vitamin E, Hawthorn, Cayenne & CoQ10 - Odor-Controlled",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f000addb-7962-4950-a67c-a1debd375c9e_large_63e20013-7fb6-4923-b2b2-ec3033859543.jpg?v=1787416332",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "garlic",
        "with",
        "vitamin",
        "hawthorn",
        "cayenne",
        "coq10",
        "odor",
        "controlled",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 21.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790226772165",
      "vsf_explanation": "Garlic (aged or allicin-standardized) has modest BP-lowering evidence (Ried 2016 meta-analysis), hawthorn has heart-failure adjunct data (Pittler 2008 Cochrane), and CoQ10 has strong cardiovascular data (Mortensen 2014 Q-SYMBIO, Skarlovnik 2014 for statin-myalgia). However, five actives in one capsule almost certainly means sub-therapeutic doses of each. Vitamin E as unspecified tocopherol is a formulation weakness. Held below Verified by likely sub-therapeutic doses and unclear standardization. Safety concern: garlic + potential antiplatelet effects need warfarin warning. Would move to Verified 70+ with mg disclosure per active and named CoQ10 source.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "certified-organic-rosemary-essential-oil",
      "title": "Certified Organic Rosemary Essential Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c9e11ce7-9bf0-4ac0-a8e8-9a6a79ce20f9_large_0fc2f8fa-937b-4f17-b134-819a5b919147.jpg?v=1787416332",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "certified",
        "organic",
        "rosemary",
        "essential",
        "oil",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 60,
        "sustainability": 58
      },
      "price": 16.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790226641093",
      "vsf_explanation": "Undiluted rosemary essential oil, an aromatherapy/topical product. Panahi 2015 small RCT compared 6-month topical rosemary oil to minoxidil 2% with equivalent hair-count improvement in androgenetic alopecia — but this specific supplement is essential oil for aromatherapy, not a validated topical formulation with a specific dilution and vehicle. Ingesting rosemary essential oil is not appropriate. Would move up only via reformulation as a hair-growth topical or reclassification as aromatherapy.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "certified-organic-eucalyptus-essential-oil",
      "title": "Certified Organic Eucalyptus Essential Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b025cd26-73f0-48d0-9036-52c22ed0735e_large_d4af3fcb-db54-45b9-880b-a41cadad0c51.jpg?v=1787416332",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "certified",
        "organic",
        "eucalyptus",
        "essential",
        "oil",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 45,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 4.65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790226837701",
      "vsf_explanation": "Topical/aromatherapy eucalyptus oil. Inhaled 1,8-cineole has modest respiratory-support evidence (Fischer 2013 for URIs) but oral undiluted essential oil is toxic even in small doses (5 mL can cause seizures/coma, esp. in children). Not an ingested supplement; scored honestly for the aromatherapy category with real ingestion-safety concern.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "garlic",
      "title": "Garlic",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3bdd9bbf-c95a-42ba-b8cb-5051fd02212e_large_14e277b3-ad6d-476e-86c8-bdd6cc7e9598.jpg?v=1787416332",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "garlic",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 7.04,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790226804933",
      "vsf_explanation": "Generic garlic supplement, no processing or standardization indicated in the SKU title. The reference cardiovascular garlic evidence (Ried 2013 BP meta-analysis) rests specifically on aged garlic extract standardized to S-allyl cysteine (e.g., Kyolic AGE), not on plain garlic powder. Would move to Standard 62+ with disclosed allicin or SAC content and defined bulb-equivalent per capsule; would need aged garlic extract form to approach the reference-evidence tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "certified-organic-lavender-essential-oil-2-pack",
      "title": "Certified Organic Lavender Essential Oil - 2 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a4eef3e3-13e1-440b-a5c7-15b762f29cb8_large_20ce5b95-9614-470b-bae6-43a7ccb47415.jpg?v=1787416332",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "certified",
        "organic",
        "lavender",
        "essential",
        "oil",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 50,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 19.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790226936005",
      "vsf_explanation": "Two-pack aromatherapy lavender oil — same category caveats. Silexan oral standardized lavender (Kasper 2014) is the evidence-based anxiolytic; aromatherapy oil is not that. Topical safety flag on prepubertal gynecomastia (Henley 2007) applies with repeated skin use.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "apple-cider-vinegar-double-strength-formula",
      "title": "Apple Cider Vinegar - Double Strength Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d9f12a30-1729-485f-bb57-a5357f1008d3_large_a8d6ee09-ef47-4e90-ae37-f6bd2f107e06.jpg?v=1787416331",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "apple",
        "cider",
        "vinegar",
        "double",
        "strength",
        "formula",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 50,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 7.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790226870469",
      "vsf_explanation": "ACV double-strength capsules. Same limitation as sibling capsule SKUs: the postprandial glucose mechanism (Johnston 2013) requires pre-meal liquid ACV contact with food and is largely bypassed by capsule form. Would move up only with liquid ACV form.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "certified-organic-peppermint-essential-oil-3-pack",
      "title": "Certified Organic Peppermint Essential Oil - 3 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/48a89ce8-7bb3-4c19-98b5-ebad4343be3e_large_aad642a4-44be-436d-b743-5fa0861a2cf7.jpg?v=1787416332",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "certified",
        "organic",
        "peppermint",
        "essential",
        "oil",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 60,
        "sustainability": 58
      },
      "price": 21.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790226968773",
      "vsf_explanation": "Multi-pack of undiluted peppermint essential oil — same category as the single-bottle SKU. Aromatherapy/topical product, not an enteric-coated internal delivery like IBGard. Ingesting essential oils without appropriate encapsulation can cause reflux and mucosal irritation. Would move up only via reclassification as aromatherapy or reformulation with proper enteric coating.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "detoxilean-system-cleansing-complex",
      "title": "Detoxilean - System Cleansing Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ae4ace73-fee5-4232-92c9-ce914e47c604_large_317e5c20-ab84-4e2c-ae6a-f221e10e03ec.jpg?v=1787416332",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "detoxilean",
        "system",
        "cleansing",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 40,
        "transparency": 42,
        "sustainability": 45
      },
      "price": 15.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790227001541",
      "vsf_explanation": "'System Cleansing Complex' plus 'Detoxilean' branding is the exact FDA/FTC-flagged combination — implied weight loss + generalized 'cleanse' claims, neither of which have RCT support at the product level. Multi-ingredient cleanse formulas typically hide per-active dosing in proprietary blends, and often include stimulant laxatives (senna, cascara) whose chronic use is a genuine safety concern (Müller-Lissner 1993 on laxative dependence). No credible construct of 'system cleansing' exists in mainstream medicine — the gut, liver, and kidneys handle this natively. Autofail: unverified_medical_claim.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "odor-controlled-garlic",
      "title": "Odor Controlled Garlic",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2803c1db-532b-4059-975c-e1060e5b310c_large_72db37fe-2652-4c8d-ad35-efbad7a372c7.jpg?v=1787416332",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "odor",
        "controlled",
        "garlic",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 56,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 9.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790227067077",
      "vsf_explanation": "Odor-controlled garlic usually means enteric coating or thermal/aged processing to reduce sulfur volatiles — which can also reduce allicin bioactivity, creating a trade-off with the very compounds that carry the mild-BP evidence (Ried 2013 meta uses aged garlic extract with defined S-allyl cysteine). Would move to Standard 62+ with disclosed allicin/SAC content and clarification of the odor-control mechanism.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "odor-controlled-garlic-1",
      "title": "Odor Controlled Garlic",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c83e69e3-c396-44e0-95d9-16d488b9843d_large_1b349969-666b-4bc4-b1f6-3371178ec13a.jpg?v=1787416332",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "odor",
        "controlled",
        "garlic",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 56,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 16.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790227034309",
      "vsf_explanation": "Odor-controlled garlic typically achieved via enteric coating or thermal/aged processing that also reduces allicin bioactivity — the sulfur-compound trade-off means the odor-control feature can dilute the very actives supporting cardiovascular use (Ried 2013 aged garlic extract BP meta). Would move to Standard 62+ with disclosed allicin/SAC content and clarification of the odor-control processing method.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "razberi-k-raspberry-ketones",
      "title": "Razberi-K Raspberry Ketones",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d3178c76-8acb-4138-bb7b-66ee0ad9c0ae_large_8e5646a4-2137-4955-ab66-9a2be91f6785.jpg?v=1787416333",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "razberi",
        "raspberry",
        "ketones",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 7.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790227132613",
      "vsf_explanation": "Standard Razberi-K raspberry ketones — same evidence gap. No human RCT supports weight-loss efficacy at any dose. Would not recommend.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "colon-essentials",
      "title": "Colon Essentials",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0da2259a-d66d-4a5e-9980-f2b106199c0b_large_191997a0-0295-4eeb-be23-829b12c69975.jpg?v=1787416333",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "colon",
        "essentials",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 16.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790227165381",
      "vsf_explanation": "Vague product name in the 'colon cleanse'-adjacent space. Without label transparency it is impossible to tell whether this is a benign fiber blend or a stimulant-laxative-heavy cleanse product. Would move to Verified with full ingredient transparency and by clearly separating any laxative herbs from daily-use fiber.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "double-strength-razberi-k-raspberry-ketones",
      "title": "Double Strength Razberi-K Raspberry Ketones",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b867d96a-0594-4a87-a1a8-a0683a45d697_large_19f142df-f819-48c3-a648-b6862e483fe6.jpg?v=1787416333",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "double",
        "strength",
        "razberi",
        "raspberry",
        "ketones",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 7.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790227689669",
      "vsf_explanation": "Raspberry ketones, double strength — same underlying issue as sibling SKU. No human RCT supports weight-loss efficacy; mechanism claims are extrapolated from rodent studies at physiologically implausible doses. Would not recommend.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "maximum-strength-razberi-k-raspberry-ketones",
      "title": "Maximum Strength Razberi-K Raspberry Ketones",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9bf74c2e-828a-42bc-9304-310fce497d85_large_78ce22be-5ebf-4fda-a7bc-6dc6ba1b3af8.jpg?v=1787416334",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "maximum",
        "strength",
        "razberi",
        "raspberry",
        "ketones",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 13.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790227722437",
      "vsf_explanation": "Raspberry ketones became a weight-loss hit after 2012 TV promotion; the underlying evidence in humans is essentially absent — the mechanism claims come from mouse cell-culture and mouse-diet studies at doses that would require ~pounds of raspberries in humans. No human RCT supports weight-loss efficacy. Would not recommend.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "glucomannan-konjac-root",
      "title": "Glucomannan+ - Konjac Root",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e42e71cd-47f7-47aa-8c71-4c90bfe3fad5_large_3f9a7c34-e4a1-417b-9e70-c1b921b8225e.jpg?v=1787416334",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glucomannan",
        "konjac",
        "root",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 30.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790227755205",
      "vsf_explanation": "Glucomannan (konjac root fiber) — soluble fiber that expands in the stomach. EFSA has authorized a health claim for weight loss at 3 g/day (in three 1-g doses before meals with water) in the context of a hypocaloric diet. Real safety flag: swallowing risk / esophageal obstruction — must be taken with adequate water. Would move to Verified 70+ with clearly disclosed serving size at 1 g × 3 pre-meal timing and prominent swallowing-safety warning on-label.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "heart-essentials",
      "title": "Heart Essentials",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9c1c2cb1-03c7-4613-9562-9ec7b86a7519_large_cc75e69b-aaeb-4f74-b3e9-8ac411a3522e.jpg?v=1787416334",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "heart",
        "essentials",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 54,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 14.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790227787973",
      "vsf_explanation": "\"Heart Essentials\" is a generic combination formula whose SKU title does not disclose actives. These formulas typically bundle CoQ10, hawthorn, garlic, taurine or similar at sub-therapeutic per-ingredient doses to keep pill count and cost low. Transparency is the biggest gap — buyers cannot verify whether individual ingredients hit their studied dose ranges. Would move to Standard 62+ with a full per-active mg breakdown and Verified 70+ only if each active reaches its individually studied range.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "adrenal-essentials",
      "title": "Adrenal Essentials",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c3aceda6-1d7d-4aa9-9233-90222addc790_large_988283ea-9324-40a9-a442-3fc95be050ad.jpg?v=1787416335",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "adrenal",
        "essentials",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 52,
        "manufacturing": 58,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 16.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790227820741",
      "vsf_explanation": "Adrenal support complex — likely a blend of adaptogens (ashwagandha, rhodiola, licorice) and/or bovine glandular. The 'adrenal fatigue' construct these products target is not a recognized medical diagnosis (Cadegiani 2016 systematic review), and combination products universally hide per-active dosing. If the formula includes licorice root, blood-pressure and potassium safety monitoring is required (Farese 1991 on aldosterone-like effects) — that disclosure is essential. Held at Standard because the target condition is unvalidated and per-ingredient dosing is not confirmed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liposan-ultra-chitosan",
      "title": "LipoSan ULTRA Chitosan",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9a8c5def-1cbf-416c-ba2e-0b8b0e3e7f05_large_4839a6ce-c774-4dd2-8454-3124edefa99f.jpg?v=1787416335",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liposan",
        "ultra",
        "chitosan",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 50,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 22.4,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790227853509",
      "vsf_explanation": "Branded LipoSan ULTRA chitosan (shellfish-derived) — a fat-binder marketed for weight management. Cochrane review (Jull 2008) found only minimal weight-loss effect (~1.7 kg), and the earlier claims of substantial fat malabsorption did not hold up. Shellfish allergen risk and fat-soluble vitamin absorption concerns. Would need a stronger evidence base to move above Rejected in the weight-loss category.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "white-kidney-bean-extract",
      "title": "White Kidney Bean Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/263d918a-73a6-4e94-bcbf-7d8c01b6717f_large_7aabbbd2-75cf-4ad7-84b7-e22dea052cd6.jpg?v=1787416336",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "white",
        "kidney",
        "bean",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 25.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790227886277",
      "vsf_explanation": "Phaseolus vulgaris extract — an alpha-amylase inhibitor marketed as a 'carb blocker'. Onakpoya 2011 meta showed effect sizes are small (~2 kg) and inconsistent. Product doesn't disclose phaseolamin units (branded Phase 2 or similar standardization). GI side effects with high-carb meals are common. Would move to Standard 60+ with Phase 2 branded raw and studied-dose (445 mg pre-meal) alignment.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "circulation-essentials",
      "title": "Circulation Essentials",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/eba5378b-7dc1-4de7-86c8-5e7f24fc7cd5_large_9841b507-955e-47e6-ac4b-8172de67dc29.jpg?v=1787416336",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "circulation",
        "essentials",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 15.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790227919045",
      "vsf_explanation": "Peripheral circulation blend — typically L-arginine, ginkgo, cayenne, and vitamin E. Arginine at 3–6 g/day has NO/vascular signal (Bai 2009 meta for BP) but requires gram-level dosing, which capsule blends rarely deliver. Ginkgo for intermittent claudication has modest evidence (Nicolai 2013 Cochrane). Likely proprietary blend at active mg. Would move to Verified 70+ with per-active mg disclosure and arginine at ≥3 g/serving.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "brain-essentials",
      "title": "Brain Essentials",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ccad47c6-1369-45dc-8025-09504fe381bc_large_5ef0d3c8-1eb3-4291-b44a-0356a6e6b676.jpg?v=1787416337",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "brain",
        "essentials",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 56,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790228410565",
      "vsf_explanation": "Multi-ingredient 'brain essentials' cognitive stack - bundled actives are typically diluted below RCT-effective doses to fit one capsule. Held here rather than autofailed pending per-active mg disclosure. Would move to Verified 70+ with per-active doses at RCT-relevant amounts and standardization percentages named for each herbal ingredient.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "yacon-root-extract-featuring-yacontrol",
      "title": "Yacon Root Extract - Featuring Yacontrol",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cbcb096e-cf45-4ce7-8fd7-39a18e08b92d_large_c33a18e4-a507-4aff-a969-a76a3a0f49d7.jpg?v=1787416337",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "yacon",
        "root",
        "extract",
        "featuring",
        "yacontrol",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 12.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790228443333",
      "vsf_explanation": "Yacon root — inulin-type fructan (FOS) prebiotic. Genta 2009 showed yacon syrup (2 tsp/day) reduced body weight and LDL over 4 months in obese women, but that was liquid syrup, not extract capsule. Yacontrol is a branded standardized extract, which is a positive. GI side effects (gas, bloat, diarrhea) at higher doses are common. Would move to Verified 70+ with disclosed FOS mg per serving and studied-dose alignment.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bone-essentials-featuring-soylife",
      "title": "Bone Essentials - Featuring SoyLife",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6b2f22c7-8841-473f-85d8-8d04f11ab59c_large_9a03944d-eaf3-48d5-bd0c-4853ffbe6a53.jpg?v=1787416338",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bone",
        "essentials",
        "featuring",
        "soylife",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 64,
        "manufacturing": 62,
        "safety": 62,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 11.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790228476101",
      "vsf_explanation": "Bone-health blend featuring SoyLife (branded soy isoflavones from Frutarom). Soy isoflavones have modest bone-mineral-density evidence in postmenopausal women (Wei 2012 meta-analysis, Taku 2010) but effect size is smaller than pharmaceuticals. Named-source ingredient is a plus. Held below Verified by not disclosing calcium/D3/K2 doses at title (a proper bone stack should combine these) and by isoflavone hormonal-effect flags (contraindicated for estrogen-sensitive cancer survivors). Would move to Verified 70+ with full mineral-and-vitamin breakdown and clear safety flags.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chromium-picolinate-featuring-chromax",
      "title": "Chromium Picolinate - Featuring Chromax",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8ccbf0ce-be12-4431-a0ff-0aae569fcb1d_large_e7f9bd15-5b86-43b2-a973-bbd984af6c53.jpg?v=1787416338",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chromium",
        "picolinate",
        "featuring",
        "chromax",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 72,
        "manufacturing": 66,
        "safety": 65,
        "transparency": 70,
        "sustainability": 50
      },
      "price": 10.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790229000389",
      "vsf_explanation": "Chromax is the branded chromium picolinate raw material with published clinical data (Preuss 2000 for cardiometabolic use). Chromium 200-1000mcg has modest insulin sensitivity and glucose-control evidence (Anton 2008; Cefalu 2004 in T2D). Named-source raw material lifts to upper Standard, near Verified. Would move higher with disclosed dose and NSF verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lecithin-kelp-b6-cider-vinegar",
      "title": "Lecithin, Kelp, B6, & Cider Vinegar",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1576a432-c81d-4d91-a3d3-ce3dd5a7f629_large_34ce95f8-5fed-482c-b77b-ee1345da7641.jpg?v=1787416339",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lecithin",
        "kelp",
        "cider",
        "vinegar",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 48,
        "manufacturing": 58,
        "safety": 48,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 7.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790229131461",
      "vsf_explanation": "This is a legacy 'fat-burner' / thyroid-support combination that has essentially no modern RCT evidence for weight-loss endpoints. Kelp adds uncontrolled iodine — a genuine safety concern for people with thyroid disease (both hypo- and hyper-thyroid contraindications) and one rarely flagged on the label. B6 at chronic higher doses risks peripheral neuropathy (dell'Aquila 2018). ACV has modest human data at 15-30 mL vinegar/day, not encapsulated. Held in Rejected range by weak/absent evidence for the combination and iodine safety concern.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chromax-1000-chromium-picolinate",
      "title": "Chromax 1000 Chromium Picolinate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6d3b81d6-6380-4a55-9af1-051be6398510_large_0fe9f90d-b92c-4a5d-8c4b-54a3f565b6e5.jpg?v=1787416338",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chromax",
        "1000",
        "chromium",
        "picolinate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 72,
        "manufacturing": 66,
        "safety": 62,
        "transparency": 72,
        "sustainability": 50
      },
      "price": 13.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790229033157",
      "vsf_explanation": "Chromax 1000mcg — high-dose named-source chromium picolinate. 1000mcg is at the upper end of dosages used in glucose-control RCTs (Anton 2008; Cefalu 2004 used 1000mcg in T2D). Safety score reflects that chromium picolinate at very high doses has generated theoretical genotoxicity concerns (Stallings 2006 in vitro), though clinical safety at this dose is generally established. Upper Standard tier — dose is RCT-aligned, named source is a plus.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "tonalin-cla-safflower-oil-blend",
      "title": "Tonalin CLA - Safflower Oil Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/11408e15-03b9-49a7-9df3-543b1ed173a5_large_5fdbd670-7f93-45ad-8466-443e434143a2.jpg?v=1787416339",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tonalin",
        "cla",
        "safflower",
        "oil",
        "blend",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 55,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 14.07,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790229098693",
      "vsf_explanation": "Conjugated linoleic acid using the branded Tonalin CLA raw material — a well-defined 78-80% CLA isomer mix from safflower oil. Whyte 2007 meta showed ~0.09 kg/week fat-loss effect at 3.2 g/day — statistically significant but small. Tonalin naming is a transparency plus. Would move to Verified 70+ with per-softgel CLA mg disclosed, isomer breakdown (c9,t11 vs t10,c12), and clearer expectation-setting on the modest effect size.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "garlic-with-cayenne-odor-controlled",
      "title": "Garlic with Cayenne - Odor Controlled",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d46240ac-6b30-4749-abab-fa3ee99a1b39_large_69a388cc-5fd0-4c7c-ae85-3712c31c0796.jpg?v=1787416340",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "garlic",
        "with",
        "cayenne",
        "odor",
        "controlled",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 20.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790229164229",
      "vsf_explanation": "Odor-controlled garlic typically means enteric-coated or aged/processed to reduce allicin — this can also mean reduced allicin bioactivity, so the odor-control feature can be a trade-off with the very compounds that carry the mild-BP evidence (Ried 2013). Cayenne addition is traditional but has thin cardiovascular endpoint data. Would move to Standard 62+ with disclosed allicin-yield potential (odor-controlled products vary widely) and defined cayenne Scoville/capsaicin content.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hormone-essentials",
      "title": "Hormone Essentials",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/82053b44-c1ab-4cd0-b27e-e18f651ebf2f_large_d51b4172-99af-4b0b-8784-ca0629bbce9f.jpg?v=1787416340",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hormone",
        "essentials",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 14.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790229229765",
      "vsf_explanation": "General 'hormone support' blend typically combining adaptogens (ashwagandha, rhodiola) with hormone-modulating herbs or DHEA/pregnenolone. Adaptogen evidence is meaningful (Chandrasekhar 2012 for ashwagandha and stress). If the formula includes hormone precursors, the safety profile expands to include lab-monitoring and contraindication requirements typically absent on 'general wellness' labels. Multi-active complexes typically under-dose individual ingredients. Would move higher with clear per-active mg disclosure, precursor-specific safety warnings, and standardization for adaptogens (e.g., KSM-66 or Sensoril for ashwagandha).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "diet-duo-features-chitosan-and-white-kidney-bean",
      "title": "Diet Duo - Features Chitosan and White Kidney Bean",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6dd31ef0-df13-451f-835a-a7de3be3d6e4_large_62eaccfe-9d85-466f-9f68-a4eb73bee379.jpg?v=1787416340",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "diet",
        "duo",
        "features",
        "chitosan",
        "and",
        "white",
        "kidney",
        "bean",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 18.03,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790229262533",
      "vsf_explanation": "Chitosan ('fat blocker') and Phaseolus vulgaris white kidney bean extract ('carb blocker'). Chitosan showed no meaningful weight-loss effect in Cochrane review (Jull 2008); Phaseolus vulgaris alpha-amylase inhibitor has small effects at most (Onakpoya 2011). Chitosan also reduces absorption of fat-soluble vitamins (A, D, E, K) — a real safety consideration. 'Diet' branding implies more than the evidence supports. Would not recommend.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "diet-duo-features-chitosan-and-white-kidney-bean-1",
      "title": "Diet Duo - Features Chitosan and White Kidney Bean",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ee519546-c26c-4cb5-8d41-920d2b8c98ba_large_c7ee1ecc-5e31-4b38-9d39-e7c7cdf5734b.jpg?v=1787416340",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "diet",
        "duo",
        "features",
        "chitosan",
        "and",
        "white",
        "kidney",
        "bean",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 10.37,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790229295301",
      "vsf_explanation": "Chitosan + white kidney bean extract — duplicate SKU. Cochrane review (Jull 2008) found no meaningful weight-loss effect for chitosan; fat-soluble vitamin absorption reduction is a real concern with chronic use. Would not recommend.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "grapefruit-pectin",
      "title": "Grapefruit Pectin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/658a191a-e74f-42b9-9c39-5e7e1051c063_large_061fac5c-891f-4c29-9da2-9329eefc88ee.jpg?v=1787416342",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "grapefruit",
        "pectin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 52,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 12.45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790229819589",
      "vsf_explanation": "Soluble fiber (grapefruit-derived pectin, related to modified citrus pectin). MCP has some human data at 5–15 g/day for galectin-3 modulation (Eliaz 2019). Capsules deliver 500–1000 mg per cap, requiring 10+ caps/day to approximate clinical dose. Would move to Standard 60+ delivered as a bulk powder with per-serving fiber grams, and to Verified 70+ with named modified citrus pectin (e.g., PectaSol-C) at studied dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "apple-cider-vinegar-double-strength-formula-1",
      "title": "Apple Cider Vinegar - Double Strength Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ac03f519-67ef-4cc6-ab6d-39f63506b78c_large_76626d0c-f207-4281-9cf4-9e6488aaf50a.jpg?v=1787416342",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "apple",
        "cider",
        "vinegar",
        "double",
        "strength",
        "formula",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 50,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 5.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790229852357",
      "vsf_explanation": "ACV in double-strength capsule form. As with sibling capsule SKUs, the pre-meal gastric-emptying/glucose mechanism (Johnston 2013) requires liquid contact with food and is largely bypassed by capsules. Would move up meaningfully only with liquid ACV form.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gymnema-sylvestre-extract-standardized",
      "title": "Gymnema Sylvestre Extract - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/021ef690-257d-4554-b28a-3e0b35875e75_large_bb30c496-1de1-47e0-8a56-3b001fe0a5f9.jpg?v=1787416342",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gymnema",
        "sylvestre",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 60,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 19.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790229885125",
      "vsf_explanation": "Standardized gymnema (typically 25% gymnemic acids). Human data supports modest fasting-glucose and HbA1c improvement in type 2 diabetes (Baskaran 1990; Leach 2007 review) at 400 mg/day standardized extract. 'Standardized' on-label is a positive signal. Would move to Verified 70+ with % gymnemic acids disclosed on-label, named clinical-grade raw material, and clear hypoglycemia-with-Rx-antidiabetic warnings.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "healthy-blood-pressure-support-formula-standardized",
      "title": "Healthy Blood Pressure Support Formula - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/84feb837-7343-4d80-8d18-71047fcb2273_large_4455d4b7-1333-46c0-8aeb-f3bfed5951ba.jpg?v=1787416342",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "healthy",
        "blood",
        "pressure",
        "support",
        "formula",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 37.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790229917893",
      "vsf_explanation": "Multi-ingredient BP-support blend with a standardization callout — better than an unstandardized generic. Typical ingredients in this category (hawthorn, garlic, hibiscus, magnesium, olive leaf) each have modest BP evidence individually (Ried 2013 for garlic; McKay 2010 for hibiscus). Safety is depressed because a BP-support supplement should carry a prominent do-consult-clinician warning for users on antihypertensive medication to avoid additive hypotension. Would move to Standard 65+ with per-ingredient mg disclosure and prominent drug-interaction warning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "whole-garlic-made-with-organic-garlic",
      "title": "Whole Garlic - Made with Organic Garlic",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b500052f-4dd9-412c-b1a5-f60684dd3162_large_ccca1cb1-1677-40fe-9475-f9dc619fa35c.jpg?v=1787416343",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "whole",
        "garlic",
        "made",
        "with",
        "organic",
        "garlic",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 60,
        "sustainability": 65
      },
      "price": 13.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790229950661",
      "vsf_explanation": "Whole-clove garlic in organic form is a defensible baseline supplement. Whole-clove preservation retains alliin better than garlic oil (which loses activity during steam distillation), but without standardization for allicin yield the SKU cannot match the reference evidence from aged garlic extract (Kyolic AGE) that anchors the Ried 2013 BP meta-analysis. Organic sourcing is a real sustainability signal. Would move to Standard 65+ with disclosed allicin-yield potential and enteric coating for gastric-acid protection.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "blood-sugar-essentials",
      "title": "Blood Sugar Essentials",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fdaf4a4d-7d70-42d3-8e35-f5b01292e50a_large_1856fe43-8145-4e47-a49c-2dbaa1292417.jpg?v=1787416344",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "blood",
        "sugar",
        "essentials",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 27.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790230474949",
      "vsf_explanation": "Glycemic-support blend — typically chromium, alpha-lipoic acid, cinnamon, gymnema, and berberine or bitter melon. Berberine has strong meta-analytic evidence at 500 mg TID for HbA1c reduction (Yin 2008). Product likely runs as proprietary at active mg, so it's impossible to know if any single active is at studied dose. Would move to Verified 70+ with per-active mg disclosure, berberine at ≥1500 mg/day, and clear medication-interaction warning (esp. hypoglycemia with insulin/sulfonylureas).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "green-coffee-bean-extract-featuring-svetol",
      "title": "Green Coffee Bean Extract - Featuring Svetol",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f29cfbef-d911-4e33-b63c-79ad9ee922d8_large_71122662-dffe-47b5-b720-8f526513f44c.jpg?v=1787416345",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "green",
        "coffee",
        "bean",
        "extract",
        "featuring",
        "svetol",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 15.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790230573253",
      "vsf_explanation": "Svetol is Naturex's branded green coffee bean extract standardized to ~45% chlorogenic acids. Weight-loss positioning is discredited following Vinson 2012's retraction and FTC v. Applied Food Sciences (2014 $3.5M settlement). Chlorogenic acid has modest blood-pressure signal (Onakpoya 2015 meta-analysis) but not the weight-loss effect this category is marketed around. Would not recommend for weight loss.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "certified-organic-peppermint-essential-oil",
      "title": "Certified Organic Peppermint Essential Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b77b305c-bfba-4ac7-8872-cc3625703caf_large_7e80e0f9-2735-4656-abc7-8e1739e4d6d3.jpg?v=1787416344",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "certified",
        "organic",
        "peppermint",
        "essential",
        "oil",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 60,
        "sustainability": 58
      },
      "price": 10.61,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790230507717",
      "vsf_explanation": "Undiluted peppermint essential oil — an aromatherapy/topical-use product, not an internally studied supplement. Ingesting essential oils without proper enteric encapsulation risks reflux and mucosal irritation (unlike enteric-coated IBGard studied by Khanna 2014). Aromatherapy evidence is thin. Organic certification is a positive. Would move up only via reclassification as an aromatherapy product.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "thermogenic-complex",
      "title": "Thermogenic Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a396b4f4-0b24-4300-a943-3584f043b969_large_b7df8110-b123-42c9-b8b7-5f08ed8dbd74.jpg?v=1787416344",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "thermogenic",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 45,
        "transparency": 48,
        "sustainability": 55
      },
      "price": 6.75,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790230540485",
      "vsf_explanation": "Fat-burner blend — typically caffeine, green tea EGCG, capsaicin, and various stimulants. Whole-category effect sizes for weight loss are small (Onakpoya 2011; Hursel 2011 for catechin+caffeine), often <2 kg over 12 weeks. Blend structure hides stimulant mg per serving, a real safety concern for people with cardiovascular risk. Would move to Standard 60+ with stimulant mg disclosure and clear CV/pregnancy warnings.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "brain-essentials-2-pack",
      "title": "Brain Essentials - 2 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/26b8e611-fa1a-4b72-9145-aee7cf9b2a4c_large_ac1f780a-2a56-473d-a2b0-1749786f3c95.jpg?v=1787416347",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "brain",
        "essentials",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 56,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 21.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790231359685",
      "vsf_explanation": "Multi-ingredient 'brain essentials' formula two-pack - the naming pattern indicates a bundled cognitive stack whose individual actives are typically diluted below their RCT-effective doses. If per-active mg is disclosed at RCT-relevant amounts, credible; if a proprietary blend, drops to Rejected. Would move to Verified 70+ with per-active doses at RCT levels (bacopa 300mg at 45-55% bacosides; L-theanine 100-200mg; PS 100-300mg).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "digestive-essentials",
      "title": "Digestive Essentials",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9e2debbe-3930-48a7-ad8a-ae60a8a0eaae_large_b38c4336-25c3-4221-b8c2-08f375203698.jpg?v=1787416356",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "digestive",
        "essentials",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 15.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790233882821",
      "vsf_explanation": "Generic-name digestive support blend, typically enzyme + probiotic + botanical. Combined SKUs often compromise the individual components (enzyme activity + probiotic viability have different stability requirements). Would move to Verified with disclosed enzyme activity units, strain-level probiotic ID, and CFU-at-expiration.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "epicatechin-supplement",
      "title": "Epicatechin Supplement",
      "vendor": "Neurogan Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Neurogan_Health_Epicatechin_Capsules_bottle_and_box.jpg?v=1787416362",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "epicatechin",
        "supplement",
        "neurogan",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 51,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790234472645",
      "vsf_explanation": "Epicatechin is a cocoa/tea flavanol marketed to bodybuilders as a myostatin/follistatin modulator; supportive data comes from small older trials (Gutierrez-Salmean 2014) and cocoa flavanol cardiovascular research. Human myostatin-modulation evidence in trained lifters is thin. Neurogan Health is a small brand and dose/purity/source not disclosed from title. Would move to Verified 70+ with purity assay, dose disclosure at studied 100mg/day range, and independent lot testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-hawthorn-berry-20-1-extract-500-mg-180-veg-caps-suitable-for-vegetarians-vegan-non-gmo-dietary-supplement",
      "title": "NusaPure Hawthorn Berry 20:1 Extract, 500 mg 180 Veg Caps, Suitable for Vegetarians, Vegan, Non-GMO Dietary Supplement",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nusapure-Hawthorn-3D-v7-01.jpg?v=1787416368",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "hawthorn",
        "berry",
        "extract",
        "500",
        "180",
        "veg",
        "caps",
        "suitable",
        "for",
        "vegetarians",
        "vegan",
        "non",
        "gmo",
        "dietary",
        "supplement",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 21,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790235717829",
      "vsf_explanation": "Hawthorn (Crataegus) has moderate RCT support for mild NYHA class I-II heart failure symptoms (Pittler 2008 Cochrane), with WS 1442 as the standardized extract used in trials at 900mg/day. NusaPure 20:1 extract at 500mg is a decent concentrated dose but no oligomeric procyanidin standardization. Real drug-interaction potential with cardiovascular meds not surfaced on title. Would move to Verified 70+ with WS 1442 sourcing and interaction warnings.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "immune-essentials",
      "title": "Immune Essentials",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/85caa1a8-2567-43f5-8a3e-9396b61e3c50_large_31926f50-7f3e-4b30-850c-9a5970c1f218.jpg?v=1787416391",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "immune",
        "essentials",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 58,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 55,
        "sustainability": 58
      },
      "price": 9.23,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790242795717",
      "vsf_explanation": "Generic 'immune essentials' blend — typically vitamin C, D, zinc, and herbal actives at multi-active moderate doses. The vitamin C+D+zinc backbone has legitimate winter-immune support (Martineau 2017 for D, Hemila 2013 Cochrane for zinc). Held to low-mid Standard by the 'essentials' framing typically hiding per-active mg and by no branded ingredient anchoring. Would move up with per-active dose disclosure and named branded immune ingredient.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "prostate-essentials-2-pack",
      "title": "Prostate Essentials - 2 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/27c95a49-3bf7-4101-add7-81b7b1854a31_large_5ef480c5-c109-41ae-8930-18caf392f720.jpg?v=1787416392",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "prostate",
        "essentials",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790242730181",
      "vsf_explanation": "Two-pack of Prostate Essentials — inherits the parent formulation profile. Multi-herb prostate blend using saw palmetto, pygeum, beta-sitosterol, nettle root, and/or lycopene; individual RCT support is mixed to modest, with beta-sitosterol showing the strongest signal (Wilt 1999). Multi-actives typically under-dose relative to monograph. Would move to Verified 70+ with per-active mg meeting studied doses and standardization percentages disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fibro-essentials-vegetarian",
      "title": "Fibro Essentials - Vegetarian",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8b7d748d-9704-4b3d-97b9-57d7b5321117_large_3d8ec9b2-6e64-4ef6-b932-d5577810d7e0.jpg?v=1787416391",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fibro",
        "essentials",
        "vegetarian",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 48,
        "sustainability": 55
      },
      "price": 12.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790242762949",
      "vsf_explanation": "Fibromyalgia-branded blend — typically SAMe, malic acid + magnesium, D-ribose, and adaptogens. Individual actives have some fibromyalgia signal (Russell 1995 for malic acid/magnesium; Teitelbaum 2006 for D-ribose) but combined-blend outcomes are not well studied and this SKU is likely proprietary at active mg. Would move to Standard 60+ with per-active mg disclosure and to Verified 70+ with studied-dose alignment on each core active.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lung-essentials",
      "title": "Lung Essentials",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9c731d16-011a-4125-b5bc-b3ed76f0279c_large_8e3a869d-699d-4cb0-98eb-90671d0b4a4e.jpg?v=1787416392",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lung",
        "essentials",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 23.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790242828485",
      "vsf_explanation": "Respiratory-support blend — typically NAC, mullein, quercetin, and possibly bromelain. NAC has some COPD evidence at 600–1200 mg (Cazzola 2015 meta). Blend structure typically hides per-active mg, so it's impossible to know if NAC is at studied dose. Would move to Standard 60+ with per-active mg disclosure and to Verified 70+ with NAC at ≥600 mg and named quercetin/bromelain raws.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "yeast-defense-essentials",
      "title": "Yeast Defense Essentials",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c1343ec2-7000-4085-9db8-b95f3ee1d15c_large_390764d0-2e92-463f-8c5b-6560c56facb0.jpg?v=1787416392",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "yeast",
        "defense",
        "essentials",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 52,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 48,
        "sustainability": 55
      },
      "price": 18.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790242861253",
      "vsf_explanation": "Candida-support blend — typically caprylic acid, oregano, garlic, and pau d'arco. The clinical construct of chronic intestinal candidiasis in immunocompetent adults is contested; controlled human evidence for herbal 'yeast cleanse' products is weak. Would move to Standard 55+ with per-active mg disclosure and defined use-case, but the underlying claim category is inherently limited.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ear-essentials",
      "title": "Ear Essentials",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/29da5278-19bc-4b0a-8bd4-27b9d0e2d107_large_a50b48d0-38f8-42df-b2d5-70784d5f1507.jpg?v=1787416392",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ear",
        "essentials",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 50,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 48,
        "sustainability": 55
      },
      "price": 9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790242926789",
      "vsf_explanation": "Ear-health blend — typically ginkgo, zinc, vitamin B12, and mullein. Ginkgo for tinnitus has been repeatedly non-significant vs placebo (Hilton 2013 Cochrane). Zinc for age-related tinnitus is possibly modestly helpful in deficient individuals only. Very weak overall evidence base for the category. Would need a targeted deficiency-repletion framing to score above Rejected.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "leg-vein-essentials-cream",
      "title": "Leg Vein Essentials Cream",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9aa75c13-1356-4e95-bce7-169345d37bac_large_92f51e8c-e48b-48b0-bd73-80d6682cc5a6.jpg?v=1787416391",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "leg",
        "vein",
        "essentials",
        "cream",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 50,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 48,
        "sustainability": 50
      },
      "price": 15.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790243025093",
      "vsf_explanation": "Topical cream marketed for varicose/spider veins — typically horse chestnut and vitamin K cream. Topical vitamin K1 for bruising has some evidence (Cohen 2004 for post-laser), but for structural venous disease, topical treatments do not remodel deeper venous valves. Oral horse chestnut/diosmin have better evidence than topicals for CVI. Would need clinical-trial support for the specific topical formula to score higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "prostate-essentials-plus-features-selenium-select",
      "title": "Prostate Essentials Plus - Features Selenium SeLECT",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9abe26d3-1082-434b-9708-8500feeb94a1_large_342516df-da06-4424-822e-dacb8e47cb71.jpg?v=1787416392",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "prostate",
        "essentials",
        "plus",
        "features",
        "selenium",
        "select",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 66,
        "manufacturing": 62,
        "safety": 60,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 36.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790242959557",
      "vsf_explanation": "Duplicate SKU of Prostate Essentials Plus. Combined prostate formula with named-source selenium (SeLECT). Saw palmetto BPH evidence is mixed (Tacklind 2012 Cochrane). Selenium's prostate cancer prevention hypothesis was NOT confirmed (Lippman 2009 SELECT). Standard tier upper end.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "urinary-tract-essentials",
      "title": "Urinary Tract Essentials",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5046ebcd-8ea6-42c7-adc2-5e436b72518a_large_ba006df4-dbf0-4d7f-93f5-c572ef9be970.jpg?v=1787416392",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "urinary",
        "tract",
        "essentials",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 6.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790242992325",
      "vsf_explanation": "UTI-prevention blend — typically cranberry (PAC standardized), D-mannose, and probiotics. Cochrane review updated 2023 (Williams) supports cranberry PAC for recurrent-UTI prevention in women. Studied dose is 36 mg PAC/day (Cran-Max, Ellura-style). Product doesn't clearly disclose PAC mg or named-cranberry raw. Would move to Verified 70+ with 36 mg PAC/day equivalent and named cranberry extract.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sleep-essentials-includes-gaba-and-melatonin-2-pack",
      "title": "Sleep Essentials Includes GABA and Melatonin - 2 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ee2df320-8b1e-4a17-824b-e083301ccb05_large_0f233ff7-cfdb-446c-9cdc-d6a240ffdc47.jpg?v=1787416392",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sleep",
        "essentials",
        "includes",
        "gaba",
        "and",
        "melatonin",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 56,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 8.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790243090629",
      "vsf_explanation": "GABA + melatonin sleep combo two-pack. Oral GABA BBB penetration is limited and debated (peripheral autonomic effects more likely) and melatonin at typical 3-5mg is well above the physiological 0.3-1mg needed for sleep onset (Auld 2017 meta). No morning-grogginess warning visible for the higher melatonin dose. Would move to Verified 70+ with physiological 0.5-1mg melatonin, PharmaGABA identity, and chronotype/duration guidance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "kidney-essentials",
      "title": "Kidney Essentials",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a158f021-f5d9-4825-b17c-fe63dd98b90d_large_d24de032-2e2b-4a82-8ffc-eb9183ce234b.jpg?v=1787416392",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "kidney",
        "essentials",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 52,
        "manufacturing": 58,
        "safety": 45,
        "transparency": 48,
        "sustainability": 55
      },
      "price": 13.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790243057861",
      "vsf_explanation": "Kidney-support blend — typically buchu, uva ursi, juniper, and cranberry. Real safety concern: several herbs marketed for 'kidney cleansing' (uva ursi hydroquinone, juniper essential oils) are contraindicated in actual kidney disease and can worsen renal function. Evidence for prophylactic kidney-support is essentially absent. Would need clear kidney-disease contraindication and defined actives to score above Rejected.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "black-currant-seed-oil",
      "title": "Black Currant Seed Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cdb7524a-dce0-4537-8576-5f47ab09a1a3_large_84b47316-b74b-4ce4-97ab-a0de0652d0fe.jpg?v=1787416391",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "black",
        "currant",
        "seed",
        "oil",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 21.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790242894021",
      "vsf_explanation": "GLA source (gamma-linolenic acid) — black currant seed oil is ~15–17% GLA, used for PMS/breast tenderness and inflammatory skin conditions. Evidence at ~3 g/day of oil (delivering ~500 mg GLA) is mixed for PMS but better for atopic dermatitis (Belch 2000 review). Would move to Verified 70+ with disclosed GLA mg per softgel and cold-press process confirmation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "avocado-oil-made-with-organic-avocado-oil",
      "title": "Avocado Oil made with Organic Avocado Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3908d18b-3663-4702-9618-8863f2ba2f45_large_58525854-880b-459d-b5f5-9d0dcb3ca5c9.jpg?v=1787416391",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "avocado",
        "oil",
        "made",
        "with",
        "organic",
        "avocado",
        "oil",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 12.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790243188933",
      "vsf_explanation": "Culinary organic avocado oil — a food, not a supplement. Monounsaturated-fat profile has favorable lipid modulation (Wang 2015). This SKU is essentially a cooking oil at supplement-store pricing. Would move to Standard 60+ only if reframed as a defined monounsaturated-fat softgel supplement with per-serving MUFA grams disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "water-pills",
      "title": "Water Pills",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0bdcafcf-eb05-45f5-8daa-3e6b4a12c509_large_7a5063c0-777b-403a-a3ae-047237b342ca.jpg?v=1787416392",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "water",
        "pills",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 40,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 10.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790243156165",
      "vsf_explanation": "Herbal diuretic ('water pill') — typically dandelion, uva ursi, buchu, juniper. Real safety concern: uva ursi hydroquinone use should be short-term only (<7 days), juniper oil can irritate kidneys, and diuretic use without medical oversight risks electrolyte imbalance and dehydration. Marketed for temporary bloat but often used as weight-loss adjunct, which is inappropriate. Would need clinician-oversight framing and short-term-only labeling to score above Rejected.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sleep-essentials-includes-gaba-and-melatonin",
      "title": "Sleep Essentials Includes GABA and Melatonin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b351932b-d2e4-4e33-a24d-e6d58b52b4c1_large_c9f4d2c3-d4c9-43f9-b254-bc5e280c2914.jpg?v=1787416392",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sleep",
        "essentials",
        "includes",
        "gaba",
        "and",
        "melatonin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 56,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 5.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790243123397",
      "vsf_explanation": "GABA + melatonin sleep combo. Oral GABA BBB penetration is limited; melatonin at typical 3-5mg is 5-15x the physiological amount for sleep onset (Auld 2017 meta suggests 0.3-1mg matches endogenous). No morning-grogginess warning visible for the over-physiological melatonin dose. Would move to Verified 70+ with physiological melatonin dose, PharmaGABA identity, and chronotype/duration guidance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "stomach-defense-essentials-with-pepzingi-and-comforteze",
      "title": "Stomach Defense Essentials with PepZinGI and Comforteze",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7f192760-0779-49c4-abbe-9637db8ea47e_large_95ff8dca-c255-4a79-8213-ffe13fb717aa.jpg?v=1787416392",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "stomach",
        "defense",
        "essentials",
        "with",
        "pepzingi",
        "and",
        "comforteze",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 62,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 7.15,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790243221701",
      "vsf_explanation": "Gastric-mucosa support using two branded raws — PepZin GI (zinc-carnosine, evidence from Mahmood 2007 for gastric mucosal protection) and Comforteze (a proprietary digestive complex). Naming branded ingredients on the SKU line is a transparency positive. Would move to Verified 70+ with PepZin GI at the studied 75 mg twice-daily dose disclosed on-label and named clinical citation for Comforteze.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "borage-oil",
      "title": "Borage Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/45dda22e-cde3-4884-94e5-db6fab1033bb_large_0b754a47-d8d3-4f46-a8f7-2a102b886c5f.jpg?v=1787416392",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "borage",
        "oil",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 8.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790243254469",
      "vsf_explanation": "Borage seed oil — highest GLA concentration among common seed oils (~20-24% GLA vs evening primrose's ~9%). Some RCT signal for rheumatoid arthritis symptoms (Leventhal 1993). Safety caveat: contains trace pyrrolizidine alkaloids (PAs) — hepatotoxic — so look for PA-free processing. Would move to Verified with GLA mg content disclosed per softgel and PA-free certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "leg-vein-essentials-designed-release",
      "title": "Leg Vein Essentials - Designed Release",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/64997a80-502c-4e1a-acc6-c6c61d1ef333_large_2f8366ae-6121-46b2-8763-7303dc7e93e1.jpg?v=1787416392",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "leg",
        "vein",
        "essentials",
        "designed",
        "release",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 11.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790243287237",
      "vsf_explanation": "Venous-tone / chronic-venous-insufficiency support — typically horse chestnut (aescin), diosmin/hesperidin, and grape seed extract. Diosmin-hesperidin (Daflon at 500 mg BID) has strong European evidence for CVI (Bogucka-Kocka 2013 review). Horse chestnut 300 mg BID (16–20% aescin) also supports leg-heaviness reduction (Pittler 2012 Cochrane). Product likely runs proprietary at active mg. Would move to Verified 70+ with per-active mg disclosure at studied doses.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "extra-virgin-olive-oil-made-with-certified-organic-olive-oil",
      "title": "Extra Virgin Olive Oil - Made with Certified Organic Olive Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6859eb49-8530-4493-9daa-d5ed2a3932e5_large_988358ec-7a8b-4696-9ced-9ac41793e74f.jpg?v=1787416394",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "extra",
        "virgin",
        "olive",
        "oil",
        "made",
        "with",
        "certified",
        "organic",
        "olive",
        "oil",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 21.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790244237509",
      "vsf_explanation": "Culinary EVOO — Mediterranean-diet evidence for CV events is strong (PREDIMED, Estruch 2013) but this is a beverage-scale food, not a defined supplement. Product doesn't disclose polyphenol content (hydroxytyrosol mg/kg), which is the differentiator between commodity EVOO and the EFSA-authorized 5 mg-hydroxytyrosol-per-day claim. Would move to Verified 70+ with polyphenol assay on-label and harvest-date/origin transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "krill-oil-maximum-strength",
      "title": "Krill Oil - Maximum Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1fe4a22e-daf3-4b66-90e0-a615fc3e1ffc_large_952eb469-88bc-4b50-8317-10c856b7517c.jpg?v=1787416394",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "krill",
        "oil",
        "maximum",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 16.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790244270277",
      "vsf_explanation": "High-dose krill oil. See sibling — phospholipid EPA+DHA with absorption advantage (Ulven 2011). Source not identified. Would move to Verified with MSC-certified named source and per-cap EPA+DHA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "krill-oil-astaxanthin",
      "title": "Krill Oil & Astaxanthin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3d3e45a6-801a-49c4-b8f6-b08fca9cdbd7_large_7070363b-1238-43c3-8ce0-f1573192a666.jpg?v=1787416394",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "krill",
        "oil",
        "astaxanthin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 70,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 8.46,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790244303045",
      "vsf_explanation": "Krill oil with added astaxanthin — sensible pairing because astaxanthin protects the omega-3 fatty acids from oxidation and adds carotenoid antioxidant activity (Fassett 2011 for cardiovascular biomarkers). Would move to Verified with astaxanthin mg content specified (studied doses are 4-12mg/day) and MSC-certified krill source.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hemp-seed-oil-made-with-organic-hempseed-oil",
      "title": "Hemp Seed Oil Made with Organic Hempseed Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3de2afe5-3287-4421-bdb8-a82b99cdca27_large_52c3cb77-bc81-45d2-8986-738d6666f695.jpg?v=1787416395",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hemp",
        "seed",
        "oil",
        "made",
        "with",
        "organic",
        "hempseed",
        "oil",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 62,
        "sustainability": 65
      },
      "price": 6.45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790244892869",
      "vsf_explanation": "Organic hemp seed oil — a source of ALA plus GLA in a favorable ratio (roughly 3:1 omega-6:3). No CBD content (hemp seed oil is pressed from seeds, not flower). Whole-food fat source rather than a targeted supplement. Would move to Verified with GLA and ALA mg content disclosed per serving.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "krill-oil-maximum-strength-2-pack",
      "title": "Krill Oil - Maximum Strength - 2 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f58942b2-b6fe-4c1b-881d-155d6bebecd5_large_aa8e8b40-db8f-4be4-94fa-c6daa07734b6.jpg?v=1787416395",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "krill",
        "oil",
        "maximum",
        "strength",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 31.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790244925637",
      "vsf_explanation": "High-dose krill oil, two-pack. Phospholipid EPA+DHA form has absorption advantage over ethyl-ester fish oil (Ulven 2011). 'Maximum Strength' typically means 750-1000mg krill per softgel. Krill source not identified. Would move to Verified with MSC-certified Superba/Aker branding and per-cap EPA+DHA disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "oryzan-rice-bran-oil-maximum-strength",
      "title": "Oryzan Rice Bran Oil - Maximum Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1ff50e26-71b5-49d9-b456-dad26910180e_large_c2a0acb7-d67c-4e14-bb77-23b7c9e4fbff.jpg?v=1787416397",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "oryzan",
        "rice",
        "bran",
        "oil",
        "maximum",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 4.05,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790245449925",
      "vsf_explanation": "Rice bran oil concentrated for gamma-oryzanol — used for lipid-modulation and menopausal-symptom support in older Japanese/Thai trials (Cicero 2001 review). Small trials at 300 mg/day gamma-oryzanol suggest modest LDL benefit but the evidence base is old and thin. Would move to Verified 70+ with disclosed gamma-oryzanol mg per softgel and a modern clinical reference.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "krill-oil-curcumin",
      "title": "Krill Oil & Curcumin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/65538116-424a-4674-bb17-5625d17dc4a3_large_8b140220-79ea-425b-b1ab-14d7009336cc.jpg?v=1787416397",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "krill",
        "oil",
        "curcumin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 17.27,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790245482693",
      "vsf_explanation": "Krill oil combined with curcumin. Krill oil provides phospholipid EPA+DHA (Ulven 2011). Curcumin, unless in a bioavailability-enhanced form (Meriva/phytosome, Longvida, C3 Complex + piperine), is poorly absorbed and standard curcumin at 500mg is largely wasted. Would move to Verified with named enhanced-absorption curcumin and per-active mg disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "flaxseed-oil-high-lignan-cold-pressed",
      "title": "Flaxseed Oil High Lignan - Cold Pressed",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5cbdbaf3-7186-4af8-9949-6209fc9d760b_large_67a9e32a-8a4e-41cd-a6fb-e507c77fc981.jpg?v=1787416396",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "flaxseed",
        "oil",
        "high",
        "lignan",
        "cold",
        "pressed",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 65,
        "sustainability": 65
      },
      "price": 14.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790245515461",
      "vsf_explanation": "Cold-pressed high-lignan flaxseed oil — best-case processing for ALA and preserved lignans (Peterson 2010 for lignan cardiovascular biomarkers). Would move to Verified with lignan mg content disclosed per serving and nitrogen-flushed dark packaging.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-flaxseed-oil-cold-pressed",
      "title": "Organic Flaxseed Oil - Cold Pressed",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cb126714-6aad-4d66-b8df-06482ae10f27_large_50a2536e-f155-4331-b0f3-9e1b7b700eba.jpg?v=1787416397",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "flaxseed",
        "oil",
        "cold",
        "pressed",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 65,
        "sustainability": 68
      },
      "price": 15.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790245548229",
      "vsf_explanation": "Organic, cold-pressed flaxseed oil — best-case processing for preserving ALA and lignans. Cold-pressing avoids heat-driven oxidation. Still an ALA source, so conversion limits apply. Would move to Verified with nitrogen-flushed dark glass packaging and refrigerated shipping guidance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "high-concentrate-omega-3-mini-softgels",
      "title": "High Concentrate Omega-3 - Mini Softgels",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b6a6bd12-afba-4cca-b59a-337f0ec35c80_large_1393b634-7881-44f7-af53-84eef616b7e3.jpg?v=1787416397",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "high",
        "concentrate",
        "omega",
        "mini",
        "softgels",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 72,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 15.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790245580997",
      "vsf_explanation": "Concentrated omega-3 in small softgels — better adherence for pill-averse users. High concentration reduces the cap count per gram of EPA+DHA. Solid cardiovascular evidence base at concentrated doses (REDUCE-IT). Would move to Verified with triglyceride-form confirmation, per-cap EPA+DHA disclosure and IFOS certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "thyroid-essentials-comprehensive-formula",
      "title": "Thyroid Essentials - Comprehensive Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ced3e5a4-f5fa-4abe-8e85-5f16267af796_large_7f798c19-5ac6-485d-b370-1237bff5b7a1.jpg?v=1787416399",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "thyroid",
        "essentials",
        "comprehensive",
        "formula",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 45,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 11.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790246400197",
      "vsf_explanation": "Thyroid-support blend — typically iodine (kelp), selenium, tyrosine, and adaptogens. Selenium at 200 mcg has evidence for autoimmune thyroiditis (Gärtner 2002). Real safety concern is undisclosed iodine mcg per serving, which can push users on levothyroxine or with autoimmune thyroid conditions out of range. Would move to Standard 60+ with iodine mcg and selenium mcg disclosure, and to Verified 70+ with clear autoimmune / Rx-thyroid contraindications on-label.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "multiomega-3-6-9-flax-borage-fish-oils-omegatru-blend",
      "title": "MultiOmega 3-6-9 Flax, Borage & Fish Oils - OmegaTru Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c15b0629-8c8d-49c3-8e0d-9a8517b76a0d_large_5bf85243-de9d-464e-925b-5746d24ff03e.jpg?v=1787416399",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "multiomega",
        "flax",
        "borage",
        "fish",
        "oils",
        "omegatru",
        "blend",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 19.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790246432965",
      "vsf_explanation": "3-6-9 omega blend — duplicate SKU. Omega-6 addition dilutes the EPA+DHA payload without benefit and can worsen the omega-6:3 dietary ratio, which is already inverted in typical Western diets. Would move up by dropping the 6/9 components in favor of concentrated EPA+DHA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "100-pure-krill-oil",
      "title": "100% Pure Krill Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9a7aac41-b4ac-4c34-9fc0-af41a73f7f0d_large_340cb290-b48e-44e5-b485-7b3419c75b2d.jpg?v=1787416399",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "100",
        "pure",
        "krill",
        "oil",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 20.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790246465733",
      "vsf_explanation": "Basic krill oil without a named source (Superba/Aker BioMarine is the MSC-certified premium option). Phospholipid-form omega-3 has absorption advantages over ethyl-ester fish oil (Ulven 2011). Astaxanthin content typically present. Would move to Verified with MSC-certified named source (Superba) and per-cap EPA+DHA disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "flaxseed-oil-made-with-organic-flaxseed-oil",
      "title": "Flaxseed Oil Made with Organic Flaxseed Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/90385a34-3ea6-479c-8584-80616558b134_large_eb2f4675-bc4d-4796-8fd5-1b8dd68fd969.jpg?v=1787416399",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "flaxseed",
        "oil",
        "made",
        "with",
        "organic",
        "flaxseed",
        "oil",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 62,
        "sustainability": 65
      },
      "price": 12.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790246498501",
      "vsf_explanation": "Organic flaxseed oil softgel. ALA source; conversion to EPA (~5%) and DHA (<1%) is poor (Brenna 2009), so not a fish-oil substitute for cardiovascular endpoints. Fine ALA source for people avoiding marine oils. Would move to Verified with nitrogen-flushed packaging and expiration/manufacture date on-label.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "omega-7-oil-from-sea-buckthorn-oil",
      "title": "Omega-7 Oil From Sea Buckthorn Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f07fb680-64f6-47fd-bb00-87f9e7321a37_large_0154e426-da3b-4b01-95d5-c4e11a9064b9.jpg?v=1787416399",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "omega",
        "oil",
        "from",
        "sea",
        "buckthorn",
        "oil",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 60,
        "sustainability": 62
      },
      "price": 9.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790246531269",
      "vsf_explanation": "Sea buckthorn oil is a vegetarian source of palmitoleic acid (omega-7), but it also contains substantial palmitic acid (omega-6) which somewhat offsets the palmitoleic benefit. Provinal purified omega-7 is a cleaner alternative. Some traditional use for dry eye and mucosal health. Would move to Verified with palmitoleic vs palmitic content ratio disclosed and cold-pressed source confirmed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "super-dpa-fish-oil",
      "title": "Super DPA Fish Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/43191034-a1eb-45f7-9588-5ade6bdd2772_large_9e88fe57-7f3b-443a-aa55-9cdc1d51acd1.jpg?v=1787416399",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "super",
        "dpa",
        "fish",
        "oil",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 18.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790246564037",
      "vsf_explanation": "DPA-enriched fish oil. DPA (docosapentaenoic acid, omega-3) is an emerging omega-3 with early cardiovascular and platelet biomarker signal, though the RCT base is much smaller than for EPA/DHA. Providing DPA alongside standard EPA/DHA is a reasonable premium positioning. Would move to Verified with per-cap DPA mg specifically called out and IFOS certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nighttime-leg-essentials-vegan",
      "title": "Nighttime Leg Essentials - Vegan",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3916ee58-8302-445b-99fc-ebd68cad27c4_large_201e50bd-0cf2-4752-b587-ab67ffc186a1.jpg?v=1787416399",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nighttime",
        "leg",
        "essentials",
        "vegan",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 52,
        "sustainability": 60
      },
      "price": 8.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790246596805",
      "vsf_explanation": "Restless-legs / night-cramp formula — typically magnesium, potassium, and B-vitamin combinations. Magnesium for RLS has mixed but modestly positive evidence (Cederberg 2023 review). Product almost certainly runs as a proprietary blend hiding per-ingredient mg. Would move to Standard 60+ with per-active mg disclosure and to Verified 70+ with magnesium in a well-absorbed form (glycinate/malate) at a defined dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "evening-primrose-oil",
      "title": "Evening Primrose Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b9d7858e-e30a-4b94-af2f-73fd990fa5f0_large_f55c5909-bcd8-40c7-91dd-2a0df339ef72.jpg?v=1787416399",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "evening",
        "primrose",
        "oil",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 15.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790246629573",
      "vsf_explanation": "Evening primrose oil (GLA source). See sibling SKUs — mixed evidence for cyclical mastalgia and menopausal symptoms. Would move to Verified with GLA mg disclosed and cold-pressed sourcing confirmed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "flaxseed-oil-made-with-organic-flaxseed-oil-1",
      "title": "Flaxseed Oil Made with Organic Flaxseed Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/41c1f650-b6a1-4546-84b3-fbf707b0412b_large_9693c241-5757-47d7-8b97-05ff26d49bad.jpg?v=1787416399",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "flaxseed",
        "oil",
        "made",
        "with",
        "organic",
        "flaxseed",
        "oil",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 62,
        "sustainability": 65
      },
      "price": 19.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790246662341",
      "vsf_explanation": "Organic flaxseed oil softgel, duplicate SKU. ALA source with poor conversion to EPA/DHA (Brenna 2009). Would move to Verified with nitrogen-flushed packaging and clear expiration dating.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "prostate-essentials",
      "title": "Prostate Essentials",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5959c14c-1f73-48a1-a568-f1d1ca099d0c_large_6ba21038-9fe6-4514-81b7-f5e6f625dbe7.jpg?v=1787416400",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "prostate",
        "essentials",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 17.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790247350469",
      "vsf_explanation": "Multi-ingredient prostate formula typically combining saw palmetto, pygeum, beta-sitosterol, nettle root, and/or lycopene. Saw palmetto has mixed BPH evidence (Wilt 1998 positive; Bent 2006 STEP null); beta-sitosterol has a positive meta-analysis at 60-130mg (Wilt 1999); pygeum has small positive RCT data. Multi-actives typically under-dose relative to monograph. Would move to Verified 70+ with per-active mg at monograph levels and standardization percentages disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liver-essentials",
      "title": "Liver Essentials",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/08ea1493-278a-426a-af2b-b242292fda2e_large_52f7c406-a22a-46f1-8509-f0cf36906d38.jpg?v=1787416400",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liver",
        "essentials",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 13.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790247383237",
      "vsf_explanation": "Liver-support blend — typically milk thistle (silymarin), NAC, artichoke, dandelion. Milk thistle at 420 mg silymarin/day has modest evidence for liver-enzyme reduction (Saller 2007). Likely proprietary at per-ingredient mg, which prevents comparison to studied doses. Would move to Verified 70+ with per-ingredient mg disclosure, silymarin % standardization on milk thistle, and NAC at ≥600 mg per serving if included.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "evening-primrose-oil-1",
      "title": "Evening Primrose Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0f6491f7-6bc7-4f07-a9ed-77f866e61c12_large_ec0786de-df6e-4f30-95cf-9e93f63cf5ca.jpg?v=1787416401",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "evening",
        "primrose",
        "oil",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 9.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790247416005",
      "vsf_explanation": "Evening primrose oil (GLA source), duplicate SKU. Traditional use for cyclical mastalgia and menopausal symptoms; evidence quality mixed. Would move to Verified with GLA mg disclosed and cold-pressed sourcing confirmed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "evening-primrose-oil-2",
      "title": "Evening Primrose Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7718c885-32b9-4012-b6e8-d515e5b855eb_large_7650d7e4-ea8d-47a5-9ddf-584391651e1d.jpg?v=1787416401",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "evening",
        "primrose",
        "oil",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 17.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790247448773",
      "vsf_explanation": "Evening primrose oil (GLA source). Traditional use for cyclical mastalgia and menopausal symptoms with mixed evidence — 2013 Cochrane review found no clear atopic-dermatitis benefit; small signal for cyclic breast pain (Pruthi 2010). GLA content per softgel (usually ~8-10% of total oil) is the meaningful metric and not visible from title. Would move to Verified with GLA mg disclosed and cold-pressed sourcing confirmed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mobility-essentials",
      "title": "Mobility Essentials",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/47e2f9d4-da6f-4c22-abf5-56879612df58_large_a4d8c327-a1f5-4fd2-964d-e0cc69c59f5c.jpg?v=1787416401",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mobility",
        "essentials",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 17.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790247481541",
      "vsf_explanation": "Joint-support blend — typically glucosamine, chondroitin, MSM, and often collagen or turmeric. GAIT (Clegg 2006) showed glucosamine+chondroitin was no better than placebo on average but helped moderate-to-severe knee pain subgroups. Formula likely proprietary at per-ingredient mg. Would move to Verified 70+ with per-active mg disclosure at studied doses (1500 mg glucosamine sulfate, 1200 mg chondroitin) and named UC-II collagen or Meriva turmeric if included.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "epa-dha-lemon-flavor",
      "title": "EPA & DHA - Lemon Flavor",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3d9636f2-d059-4862-9d75-0a648152533c_large_c87bb40f-0399-4d7c-8ad1-e08ac141e167.jpg?v=1787416402",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "epa",
        "dha",
        "lemon",
        "flavor",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 12.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790247547077",
      "vsf_explanation": "Standard flavored fish oil. Solid EPA+DHA evidence base (REDUCE-IT for high-dose EPA; Bernasconi 2020). Form and IFOS certification not visible. Would move to Verified with triglyceride form confirmation, per-cap EPA+DHA disclosure and IFOS certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "black-cumin-seed-oil",
      "title": "Black Cumin Seed Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/89c36f81-0b24-43d0-885a-df66678ffade_large_72eff348-ae8f-4250-9c50-948d857e7070.jpg?v=1787416402",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "black",
        "cumin",
        "seed",
        "oil",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 12.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790247514309",
      "vsf_explanation": "Nigella sativa (black seed) oil — thymoquinone is the primary studied active. Human trials support modest BP, lipid, and glycemic effects (Sahebkar 2016 meta at 1–2 g/day of oil). This SKU doesn't disclose thymoquinone percentage, which is the differentiator between commodity black seed oil and clinically-relevant preparations. Would move to Verified 70+ with % thymoquinone standardization and cold-press method confirmation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-ginger-root-capsules-20-1-extract-200-mg-per-veggie-caps-220-count-non-gmo",
      "title": "NusaPure Ginger Root Capsules 20:1 Extract, 200 mg per Veggie Caps | 220 Count | Non-GMO",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-132096v3-Ginger-Root-3D-01.jpg?v=1787416403",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "ginger",
        "root",
        "capsules",
        "extract",
        "200",
        "per",
        "veggie",
        "caps",
        "220",
        "count",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 21.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790248071365",
      "vsf_explanation": "Ginger has solid RCT evidence for nausea (pregnancy — Vutyavanich 2001, chemo — Ryan 2012) and osteoarthritis (Bartels 2015 meta). NusaPure 20:1 extract at 200mg (~4g raw-equivalent) is a reasonable concentrated dose. No gingerol standardization disclosed. Would move to Verified 70+ with gingerol/shogaol standardization and 5-10% pungent-compound content specified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "menopause-essentials",
      "title": "Menopause Essentials",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1aa79c71-4984-4e3f-92aa-40229fcb4725_large_03d0aa8a-64e8-4174-af25-5639944f3741.jpg?v=1787416403",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "postmenopausal",
      "tokens": [
        "menopause",
        "essentials",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 16.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790248104133",
      "vsf_explanation": "Multi-ingredient menopause formula typically layering black cohosh, soy isoflavones, and/or dong quai with adaptogens. Black cohosh has modest hot-flash evidence (Leach 2012 Cochrane) but a real hepatotoxicity signal that warrants label warnings. Soy isoflavones have some vasomotor benefit (Taku 2012 meta-analysis) at 50-80mg daily. Multi-active blends typically under-dose relative to monograph. Would move to Verified 70+ with per-active mg meeting monograph, standardization percentages disclosed, and explicit liver-safety guidance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vision-essentials-2-pack",
      "title": "Vision Essentials - 2 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/28978731-1d18-430f-97d6-955d089e40ac_large_93694061-9718-4523-850b-75f46d024a0d.jpg?v=1787416404",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vision",
        "essentials",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 13.73,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790248136901",
      "vsf_explanation": "Two-pack of Swanson Vision Essentials — same formulation. AREDS2 (2013) alignment matters for macular degeneration risk reduction. Would move to Verified 70+ with AREDS2 dosing confirmation and named lutein/zeaxanthin raw material.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "coconut-oil-made-with-certified-organic-coconut-oil",
      "title": "Coconut Oil Made with Certified Organic Coconut Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/18f35bac-3912-456c-9471-ae75264b5a0b_large_32c0161c-3d70-41fd-8621-9ef62648ae7b.jpg?v=1787416404",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coconut",
        "oil",
        "made",
        "with",
        "certified",
        "organic",
        "coconut",
        "oil",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 6.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790248202437",
      "vsf_explanation": "Coconut oil softgel (whole coconut oil, not fractionated MCT). Lauric-acid heavy, not the C8/C10 profile validated for ketogenic/cognitive endpoints. AHA (Sacks 2017) does not recommend for CV risk reduction. Would move to Standard 60+ only if reformulated as C8/C10 MCT with disclosed fractionation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "flaxseed-oil-high-lignan",
      "title": "Flaxseed Oil High Lignan",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c84afd71-4c9f-42ec-8678-f43d0e5d754f_large_b77227be-b912-473c-b878-f304b9e9eb32.jpg?v=1787416404",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "flaxseed",
        "oil",
        "high",
        "lignan",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 62,
        "sustainability": 62
      },
      "price": 13.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790248169669",
      "vsf_explanation": "Flaxseed oil with preserved lignans (SDG converted to enterolignans by gut microbiota). Lignans have interesting cardiovascular and menopausal signal (Peterson 2010). ALA-to-EPA conversion is very poor (~5% Brenna 2009) so this is not a substitute for fish oil. Would move to Verified with lignan mg content disclosed and nitrogen-flushed packaging for oxidation control.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vision-essentials",
      "title": "Vision Essentials",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d995e6cb-7afd-49f1-8d7f-ec4c63c84249_large_2355713b-7ec1-4923-a774-5f4f9ce4c815.jpg?v=1787416405",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vision",
        "essentials",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 6.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790248988869",
      "vsf_explanation": "Eye-health blend, typically lutein/zeaxanthin plus antioxidants and possibly bilberry. AREDS2 (2013) established the vitamin-C/E/zinc/copper/lutein/zeaxanthin matrix for macular degeneration risk. Product doesn't confirm AREDS2 dosing or named-source carotenoids on the SKU line. Would move to Verified 70+ with AREDS2-aligned matrix, disclosed lutein/zeaxanthin mg, and named raw material (e.g., FloraGLO / Lutemax).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-fo-ti-30-1-extract-167-mg-per-veg-caps-200-count-non-gmo-vegan-bioperine",
      "title": "NusaPure Fo-Ti 30:1 Extract, 167 mg per Veg Caps, 200 Count, Non-GMO, Vegan, Bioperine",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-132011v3-FO-TI-3D-01.jpg?v=1787416406",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "extract",
        "167",
        "per",
        "veg",
        "caps",
        "200",
        "count",
        "non",
        "gmo",
        "vegan",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 40,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 25.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790249021637",
      "vsf_explanation": "Fo-Ti (Polygonum multiflorum / He Shou Wu) has significant hepatotoxicity signals in case reports and pharmacovigilance data (Lin 2015 review of case series). Raw and processed forms have different toxicity profiles. Marketing for hair-graying reversal isn't RCT-supported. Safety concerns drive the low score. Would need Fo-Ti removed from OTC channels; not appropriate to score higher regardless of dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "prostate-essentials-plus-features-selenium-select-1",
      "title": "Prostate Essentials Plus - Features Selenium SeLECT",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c92e8516-bb60-4bb6-9fd8-d1bf157cc496_large_00f38803-1a22-440f-805a-67afa8c10bd6.jpg?v=1787416406",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "prostate",
        "essentials",
        "plus",
        "features",
        "selenium",
        "select",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 66,
        "manufacturing": 62,
        "safety": 60,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 21.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790249545925",
      "vsf_explanation": "Prostate formula featuring SeLECT (branded selenium) plus typical saw palmetto, pygeum, or beta-sitosterol. Saw palmetto meta-analysis shows mixed BPH-symptom results (Tacklind 2012 Cochrane); selenium's prostate-cancer prevention hypothesis was NOT confirmed in the SELECT trial (Lippman 2009). Standard tier upper end — legit category, evidence base has evolved. Would move to Verified with disclosed doses and named saw palmetto extract %.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-citrus-bergamot-capsules-600mg-200-capsules-25-1-bergamot-extract-200-servings-bioperine-vegan-non-gmo",
      "title": "NusaPure Citrus Bergamot Capsules 600mg, 200 Capsules - 25:1 Bergamot Extract - 200 Servings, Bioperine, Vegan, Non-GMO",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-132059v3-Citrus-Bergamot-3D-01.jpg?v=1787416412",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "citrus",
        "bergamot",
        "capsules",
        "600mg",
        "200",
        "capsules",
        "bergamot",
        "extract",
        "200",
        "servings",
        "bioperine",
        "vegan",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 65,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 27.2,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790251413701",
      "vsf_explanation": "Citrus bergamot has legitimate RCT support for LDL-C and non-HDL reduction (Mollace 2011, Toth 2015) at 500-1500mg/day of Bergamonte-standardized extract. NusaPure at 600mg 25:1 extract is a solid dose but doesn't specify Bergamonte-branded standardization (38% polyphenols) — the studied form. Would move to Verified 72+ with named Bergamonte sourcing and disclosed BPF %.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-plant-sterols-1500-mg-180-tablets-non-gmo-vegan-beta-sitosterol-bioperine",
      "title": "NusaPure Plant Sterols 1500 mg - 180 Tablets (Non-GMO, Vegan) Beta Sitosterol, Bioperine",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/20a9ea6c.jpg?v=1787416418",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "plant",
        "sterols",
        "1500",
        "180",
        "tablets",
        "non",
        "gmo",
        "vegan",
        "beta",
        "sitosterol",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 31.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790252429509",
      "vsf_explanation": "Plant sterols have strong RCT evidence for LDL reduction (Ras 2014 meta showed ~10% LDL drop with 2-3g/day). NusaPure at 1500mg is below the studied effective range — single-cap dosing wouldn't provide clinically meaningful lipid effect. Beta-sitosterol also has some BPH data (Wilt 1999). Would move to Verified 70+ with 2000-3000mg/serving dosing and per-sterol breakdown.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-saw-palmetto-20-1-extract-200-mg-per-veggie-caps-200-count-non-gmo-vegan-vegetarian-bioperine",
      "title": "NusaPure Saw Palmetto 20:1 Extract, 200 mg per Veggie Caps 200 Count Non-GMO, Vegan, Vegetarian, Bioperine",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-130662v5-Saw-Palmetto-200-Vcaps-3D-01.jpg?v=1787416424",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "saw",
        "palmetto",
        "extract",
        "200",
        "per",
        "veggie",
        "caps",
        "200",
        "count",
        "non",
        "gmo",
        "vegan",
        "vegetarian",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 20.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790254723269",
      "vsf_explanation": "Saw palmetto RCT evidence for BPH is mixed — the CAMUS trial (Barry 2011) was negative, while European trials with Permixon/Prostaserene liposterolic extract are positive. Studied Permixon dose is 320mg/day of 85-95% fatty acid extract, not a 20:1 concentrate. NusaPure's dry 20:1 extract at 200mg doesn't clearly match the fatty-acid extract used in RCTs. Would move to Verified 70+ with Permixon/USPlus-style lipidic-extract standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-milk-thistle-50-1-extract-550-mg-120-veggie-capsules-non-gmo-vegan-max-strength-standardized-80-silymarin-bioperine",
      "title": "NusaPure Milk Thistle 50:1 Extract, 550 mg 120 Veggie Capsules Non-GMO, Vegan Max Strength - Standardized 80% Silymarin, Bioperine",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-131422v4-Milk-Thistle-BioP-3D-01.jpg?v=1787416429",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "milk",
        "thistle",
        "extract",
        "550",
        "120",
        "veggie",
        "capsules",
        "non",
        "gmo",
        "vegan",
        "max",
        "strength",
        "standardized",
        "silymarin",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 72,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 72,
        "sustainability": 50
      },
      "price": 23.7,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790256197829",
      "vsf_explanation": "Milk thistle 50:1 extract standardized to 80% silymarin at 550mg delivers ~440mg silymarin per capsule — well above the ~140mg silymarin typical in Legalon (Kim 2020 meta) and matched to higher-dose hepatic protection trials. Standardization explicitly disclosed, which is genuinely useful transparency. Silybin-phosphatidylcholine (Siliphos) is the highest-bioavailability form and not used here. Would move to Verified 72+ with Siliphos-branded phytosome delivery.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-kidney-complex-vegetarian-60-caps",
      "title": "NusaPure Kidney Complex (Vegetarian) 60 caps",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/29f2ca9c.jpg?v=1787416433",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "kidney",
        "complex",
        "vegetarian",
        "caps",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 19.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790257508549",
      "vsf_explanation": "Multi-herb 'kidney complex' from a budget brand with no per-ingredient breakdown on the title. Kidney-support herbs (juniper, dandelion, uva ursi, cranberry etc.) have mostly traditional-use evidence. Products marketed for kidney function without medical oversight are also potentially problematic for people with actual CKD. Would move to Standard 60+ with full per-herb mg breakdown, standardization, and appropriate cautions for pre-existing kidney disease.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-vitex-chasteberry-fruit-20-1-extract-450-mg-mg-200-vegan-capsules-non-gmo-vegan-dietary-supplement",
      "title": "NusaPure Vitex Chasteberry Fruit 20:1 Extract, 450 mg mg 200 Vegan Capsules - Non-GMO, Vegan Dietary Supplement",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-127411v7-Nusapure-Vitex-3D-01.jpg?v=1787416439",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "vitex",
        "chasteberry",
        "fruit",
        "extract",
        "450",
        "200",
        "vegan",
        "capsules",
        "non",
        "gmo",
        "vegan",
        "dietary",
        "supplement",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 22,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790259507397",
      "vsf_explanation": "Vitex (chasteberry) has moderate RCT evidence for PMS (Schellenberg 2001, van Die 2013 meta) at 20-40mg/day of concentrated extract (Ze 440). NusaPure 20:1 extract at 450mg is a 9g raw-equivalent — potentially quite different dose profile from studied Ze 440. No agnuside/casticin standardization disclosed. Would move to Verified 70+ with named Ze 440 or Metabolic Maintenance-equivalent extract and standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusaspure-lutein-suitable-for-vegetarian-vegan-non-gmo-40-mg-180-capsules",
      "title": "NusasPure Lutein - Suitable for Vegetarian/Vegan, Non - GMO - 40 mg - 180 Capsules",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/81d9f9a5.jpg?v=1787416443",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusaspure",
        "lutein",
        "suitable",
        "for",
        "vegetarian",
        "vegan",
        "non",
        "gmo",
        "180",
        "capsules",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 22.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790260785349",
      "vsf_explanation": "Lutein 40mg is well above the AREDS2 10mg dose and Ma 2016 meta-analytic effective range of 10-20mg for macular pigment optical density. The higher dose isn't demonstrably more effective and may hit diminishing returns. No zeaxanthin (typically paired 2mg per 10mg lutein), no FloraGlo/Kemin sourcing named. Would move to Verified 70+ with named source, zeaxanthin pairing, and dose closer to studied 10-20mg.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pristine-norwegian-cod-liver-oil-lemon-flavor",
      "title": "Pristine Norwegian Cod Liver Oil - Lemon Flavor",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d3745224-05bb-404a-a63d-8b07ff67381b_large_2a1a5db3-1222-426f-b519-3213915fa51b.jpg?v=1787416452",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pristine",
        "norwegian",
        "cod",
        "liver",
        "oil",
        "lemon",
        "flavor",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 60,
        "transparency": 65,
        "sustainability": 60
      },
      "price": 8.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790262653125",
      "vsf_explanation": "Flavored liquid Norwegian cod liver oil — masking rancidity with lemon is common in this category, so IFOS or Nordic-certified freshness testing matters more than usual. Combined EPA/DHA + vitamins A/D make it a solid nutrient package but vitamin A dose needs attention in pregnancy. Would move to Verified 70+ with IFOS peroxide/anisidine numbers on-label and per-serving EPA/DHA/A/D disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "super-dha-500-from-food-grade-calamari",
      "title": "Super DHA 500 from Food-Grade Calamari",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c84d71c5-3512-4845-96e6-9b2c9e261fb2_large_e3e692df-7f34-450a-9a30-e8b934f355be.jpg?v=1787416452",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "super",
        "dha",
        "500",
        "from",
        "food",
        "grade",
        "calamari",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 70,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 68,
        "sustainability": 60
      },
      "price": 11.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790262620357",
      "vsf_explanation": "Calamari (squid) oil is a legitimate DHA-rich alternative to fish oil with a smaller sustainability footprint than tuna oil. 500mg DHA per softgel is a meaningful dose for brain/cognitive support (Yurko-Mauro 2010 MIDAS). Would move to Verified with triglyceride-form confirmation and IFOS certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "super-epa",
      "title": "Super EPA",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6356ebcc-aba1-4c40-897d-2abaed12e6f1_large_2e665094-cdb8-4c63-80b1-8fde00c4a39d.jpg?v=1787416452",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "super",
        "epa",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 74,
        "formulation": 68,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790262685893",
      "vsf_explanation": "EPA-dominant fish oil. EPA has stronger cardiovascular RCT support than DHA (REDUCE-IT with 2g icosapent ethyl showed 25% CV event reduction). Isolated-EPA products are useful for cardiovascular-primary use cases. Form (TG vs EE) and IFOS certification not visible. Would move to Verified with triglyceride form and IFOS certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "provinal-purified-omega-7",
      "title": "Provinal Purified Omega-7",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b7cc830f-78ff-4fcc-8079-c0199bb96837_large_4386375f-42ff-4f74-a941-7a96dd080538.jpg?v=1787416453",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "provinal",
        "purified",
        "omega",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 68,
        "manufacturing": 68,
        "safety": 65,
        "transparency": 68,
        "sustainability": 60
      },
      "price": 7.6,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790262718661",
      "vsf_explanation": "Provinal is Tersus Pharmaceuticals' branded purified palmitoleic acid (omega-7) — advantage over sea-buckthorn omega-7 sources because sea-buckthorn also contains omega-6 palmitic acid, whereas Provinal is purified to remove the pro-inflammatory palmitic. Modest evidence for CRP and lipid biomarkers (Bernstein 2014). Named branded ingredient is a manufacturing trust signal. Evidence base is small, hence Standard tier. Would move to Verified with additional RCT data at this specific formulation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "alfapro-alfalfa-protein-concentrate-non-gmo",
      "title": "AlfaPro Alfalfa Protein Concentrate - Non-GMO",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/84d95da5-8655-4750-bf90-70695931229b_large_2b373bed-5191-4992-a7f3-2ebd5519522f.jpg?v=1787416453",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alfapro",
        "alfalfa",
        "protein",
        "concentrate",
        "non",
        "gmo",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 62,
        "sustainability": 65
      },
      "price": 11.47,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790262751429",
      "vsf_explanation": "Alfalfa protein concentrate is an unusual green-leaf-derived protein source with very thin human evidence — no comparable MPS or performance RCTs to whey/pea/rice literature. Historically alfalfa was flagged for L-canavanine content (linked to lupus flare in case reports — Malinow 1982), so its safety profile depends on the processing. Non-GMO sourcing is a plus. Held at Standard because the evidence base for anabolic use is essentially absent, and safety signal deserves label disclosure. This is better positioned as a green-food nutrient source than as a functional protein.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-atlantic-salmon-oil",
      "title": "Pure Atlantic Salmon Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a84a7081-59f8-42d5-9dde-763560fba481_large_1c5a081b-b912-43db-870c-a0654eb8e69f.jpg?v=1787416453",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "atlantic",
        "salmon",
        "oil",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 8.2,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790262784197",
      "vsf_explanation": "Atlantic salmon oil softgel. Whole-fish oil (unconcentrated) delivers modest EPA+DHA per softgel (~150–250 mg combined) vs 1–2 g/day therapeutic ranges used in GISSI-Prevenzione (1999) and REDUCE-IT (2019, EPA-only). Would move to Verified 70+ with concentrated EPA/DHA mg per softgel, IFOS oxidation testing, and disclosure of wild vs farmed source.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "parsley",
      "title": "Parsley",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/131858e1-abd4-4606-8962-dd5dcacd2e83_large_e4d5a129-8597-4597-abee-787888448ad7.jpg?v=1787416453",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "parsley",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 50,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 7.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790262816965",
      "vsf_explanation": "Parsley whole-herb capsule. Traditional use as a diuretic and vitamin K/C source; no meaningful controlled human evidence at capsule dose. Vitamin K content matters for anticoagulated patients (warfarin interaction), which is often not flagged. Would move to Standard 55+ with disclosed vitamin K mcg per serving and clearer safety framing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fruit-vegetable-powder",
      "title": "Fruit & Vegetable Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/923bf3bb-5b31-40c3-b140-fe69f374d81e_large_21e791ee-615f-40ff-8e96-be0a7e857191.jpg?v=1787416453",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fruit",
        "vegetable",
        "powder",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 15.53,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790262849733",
      "vsf_explanation": "Fruit-and-veg powder — greens/reds hybrid category. Powder format at least allows gram-level dosing, but per-ingredient mg is usually proprietary and outcome-based human trials are sparse. Would move to Standard 60+ with per-ingredient mg disclosure and antioxidant/polyphenol content per serving.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "barley-grass-juice-powder",
      "title": "Barley Grass Juice Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a6f99dcd-bf84-4992-a423-59a6702f0aa7_large_5fe1b9fc-63ba-453d-ae0e-e8ccb8af9fed.jpg?v=1787416453",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "barley",
        "grass",
        "juice",
        "powder",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 11.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790262882501",
      "vsf_explanation": "Non-organic version of the barley-grass juice powder. Whole-food greens with limited controlled human data at capsule/powder doses. Chlorophyll, β-carotene, and vitamin K are the main documented nutrients. Would move to Standard 60+ with defined nutrient profile per serving and to Verified 70+ with outcome-based clinical evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "scottish-kelp-made-with-organic-sea-kelp",
      "title": "Scottish Kelp - Made with Organic Sea Kelp",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/89da7407-0f43-45a3-93a9-d9eb761b74ec_large_573419ab-f6ee-4360-972d-321f3ea30728.jpg?v=1787416453",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "scottish",
        "kelp",
        "made",
        "with",
        "organic",
        "sea",
        "kelp",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 45,
        "transparency": 60,
        "sustainability": 62
      },
      "price": 11.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790262915269",
      "vsf_explanation": "Sea kelp — primary use is iodine supplementation. Scottish sourcing is a plus (cleaner waters than some Asian sources for heavy-metal load). Iodine mcg per serving must be tightly controlled: kelp is variable and can deliver 500–1500+ mcg iodine, well above the 150 mcg RDA and pushing the 1100 mcg UL. Would move to Verified 70+ with iodine mcg per serving on-label and arsenic COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fruits-veggies-1",
      "title": "Fruits & Veggies",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c922fe43-8a34-4841-977e-4f3910019634_large_bba368dc-a0ca-4f50-b601-6811667d9cdc.jpg?v=1787416453",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fruits",
        "veggies",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 52,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 36.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790262948037",
      "vsf_explanation": "Combined fruit-and-veg capsule blend. Category-wide, produce-in-a-cap products deliver mg-level dried powder that cannot approximate dietary intake and typically hide per-ingredient mg. Would move to Standard 55+ with per-ingredient mg disclosure and defined polyphenol content.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "100-organic-spirulina",
      "title": "100% Organic Spirulina",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0a941860-b9f0-4650-aec2-f36e9bf669df_large_8625f823-e694-4ce5-b2bb-177c49a40602.jpg?v=1787416453",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "100",
        "organic",
        "spirulina",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 64,
        "sustainability": 68
      },
      "price": 13.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790263046341",
      "vsf_explanation": "Organic spirulina — organic certification is a genuine plus for pesticide freedom, and spirulina's meta-analysis evidence for LDL/triglyceride improvement is solid (Serban 2016). Microcystin (cyanotoxin) contamination is the main source-quality concern, and organic certification does not directly address microcystin. Held at Standard because branded tested source is not named at title level. Would move to Verified 70+ with Cyanotech or Parry sourcing named plus published microcystin COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "spirulina-astaxanthin",
      "title": "Spirulina & Astaxanthin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e9de5f40-dd5f-4b57-8ab2-3f717ac21a24_large_30722a23-c8bc-4772-8141-ad74bd61faf0.jpg?v=1787416453",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "spirulina",
        "astaxanthin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 10.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790263079109",
      "vsf_explanation": "Combination spirulina + astaxanthin — both have modest independent evidence (spirulina Serban 2016 lipids; astaxanthin Kim 2019 skin elasticity at 6-12mg/day). Effective astaxanthin dosing is 4-12mg/day, and it must be sourced from Haematococcus pluvialis (BioAstin from Cyanotech, or AstaReal are references) rather than synthetic. Combination format tends to under-dose astaxanthin. Held at Standard because per-active dosing is not confirmed and neither source is named at title level. Would move up with disclosed astaxanthin mg and source, plus contamination-tested spirulina source.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fruit-vegetable-blend",
      "title": "Fruit & Vegetable Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e3308336-3c63-48e2-ba5f-f291f35c60e5_large_7ac7b950-9244-48ae-9dd8-947d9518bb16.jpg?v=1787416453",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fruit",
        "vegetable",
        "blend",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 52,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 10.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790262980805",
      "vsf_explanation": "Another fruit-and-veg blend — same category caveats. Proprietary-blend structure hides per-ingredient mg, and produce-capsule format cannot substitute for dietary intake. Would move to Standard 55+ with per-ingredient disclosure and defined polyphenol/carotenoid content.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "certified-organic-raw-super-food",
      "title": "Certified Organic Raw Super Food",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ca2b41de-dcd0-4bc9-88fe-b19494dd9f20_large_46b061d9-df47-4f23-b45d-b139a779d970.jpg?v=1787416453",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "certified",
        "organic",
        "raw",
        "super",
        "food",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 52,
        "sustainability": 60
      },
      "price": 23.75,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790263013573",
      "vsf_explanation": "Certified organic superfood/greens blend. Organic sourcing is a positive, but proprietary-blend structure hides per-ingredient mg and per-serving nutrient content is not disclosed. Category-wide superfood powders lack outcome-based human trials. Would move to Standard 60+ with per-ingredient mg disclosure and a heavy-metal COA on algae/grass components.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "broccoli-extract-with-glucosinolates",
      "title": "Broccoli Extract with Glucosinolates",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/df618c7e-f8dd-4410-9d9a-893ac38acb4a_large_bc4adddc-95f6-41be-a525-1d9e6a385c37.jpg?v=1787416454",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "broccoli",
        "extract",
        "with",
        "glucosinolates",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 23.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790263111877",
      "vsf_explanation": "Broccoli extract standardized to glucosinolates — precursors to sulforaphane. Fahey 2019 and prior Johns Hopkins work supports Nrf2 pathway activation, but this depends on active myrosinase or a co-ingested source. Product discloses glucosinolate content (positive), but SFN yield and myrosinase activity are typically unstated. Would move to Verified 70+ with a specified SFN yield (mg per serving) and active-myrosinase confirmation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "alfalfa",
      "title": "Alfalfa",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7b127c23-037e-4181-8664-7bbc9dec6e8f_large_1c15bb4b-334d-41cd-87b7-be77bc2e4cf6.jpg?v=1787416454",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alfalfa",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 50,
        "manufacturing": 58,
        "safety": 45,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 10.67,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790263144645",
      "vsf_explanation": "Alfalfa (Medicago sativa) whole-plant capsule. Traditionally used for lactation and general wellness; very limited controlled human evidence. Real safety flag: alfalfa contains L-canavanine, associated with lupus-like flares in autoimmune-prone users, and its case reports go back decades. Would need clear autoimmune contraindication and defined active to score above Rejected.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "rye-grass",
      "title": "Rye Grass",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/bc04978a-bd3f-47e5-b7b0-bf323a2122f1_large_6a34b095-5feb-47fb-8764-a2d47183595d.jpg?v=1787416456",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "rye",
        "grass",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 58,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 7.25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790263210181",
      "vsf_explanation": "Rye-grass whole-plant powder in capsule. Greens-in-a-cap format with essentially no controlled human clinical evidence at capsule dose. Note: Cernitin (rye-grass pollen extract) has some BPH evidence but that's a different, specific pollen extract — not this whole-grass product. Would move to Standard 60+ only with a defined active and dose rationale.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "wild-blueberry-with-whole-wild-blueberries",
      "title": "Wild Blueberry with Whole Wild Blueberries",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cfc8981a-2fc5-440b-a294-5c3964b143fa_large_fa310254-b0e8-4e70-9a56-d1299789e6fd.jpg?v=1787416457",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wild",
        "blueberry",
        "with",
        "whole",
        "wild",
        "blueberries",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 66,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 12.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790263275717",
      "vsf_explanation": "Whole wild blueberry powder. Wild-lowbush anthocyanin density is a positive but whole-fruit powder in capsules delivers small anthocyanin quantities vs standardized extracts studied for cognition/cardiovascular endpoints (Whyte 2018). Would move to Standard 62+ with anthocyanin standardization to 25% and per-serving marker mg.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liquid-coconut-oil",
      "title": "Liquid Coconut Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a2a88b2e-1779-461e-9e7e-84941501a813_large_57a8e044-dec4-4f53-a790-7370ebe07770.jpg?v=1787416457",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liquid",
        "coconut",
        "oil",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 10.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790263308485",
      "vsf_explanation": "Fractionated liquid coconut oil — typically MCT-enriched (C8/C10) rather than lauric-heavy virgin coconut oil. Better cognitive/ketogenic signal than whole coconut oil (Cunnane 2016) but this SKU doesn't disclose C8:C10 ratio, which is the differentiator between clinically-relevant MCT and a lower-grade fractionated oil. Would move to Verified 70+ with disclosed C8/C10 ratio and third-party purity testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "seaweed-vegetable-complex",
      "title": "Seaweed Vegetable Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a1d51eda-0231-4302-9c07-18bc8052672b_large_dce14903-160f-459a-bcd9-a15335f0a08b.jpg?v=1787416457",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "seaweed",
        "vegetable",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 45,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 15.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790263341253",
      "vsf_explanation": "Kelp/seaweed blend — mainly an iodine and trace-mineral source. Undisclosed iodine mcg per serving is a real safety issue: single kelp caps can deliver 1000+ mcg iodine (well above the 150 mcg RDA and near/at the 1100 mcg UL). Would move to Standard 60+ with disclosed iodine mcg per serving and heavy-metal (arsenic) COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fermented-turmeric",
      "title": "Fermented Turmeric",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/aeccf1f1-0f96-453d-bfef-c8e0a3b87fee_large_3a05559b-5c97-4b89-aa45-0b090b1fe493.jpg?v=1787416457",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fermented",
        "turmeric",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 7.45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790263374021",
      "vsf_explanation": "Fermented turmeric — a category where the specific fermentation technology matters enormously (THERACURMIN by particle-size reduction is the most-studied, at 27x bioavailability increase; koji-based fermentations show variable results). Without named technology or bioavailability data, this is directionally interesting but hard to evaluate. Would move up substantially with named fermentation process and published bioavailability data.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "spirulina",
      "title": "Spirulina",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/50e91b62-687c-4c79-9b4d-ed26cc9b4eb3_large_e4127c64-9050-4744-b609-8cf5d73f97ba.jpg?v=1787416457",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "spirulina",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 8.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790263406789",
      "vsf_explanation": "Basic spirulina SKU. Nutrient-dense algae with real lipid-improvement meta evidence (Serban 2016 at 8-16g/day). Microcystin contamination risk makes source transparency essential — Cyanotech Hawaiian and Parry are the reference tested sources. Held at Standard because Swanson does not name a branded source or publish microcystin testing. Would move up with tested branded sourcing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "wild-blueberry-pomegranate",
      "title": "Wild Blueberry & Pomegranate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/044688b4-b67f-4ec8-bec9-63a4b9a8bd72_large_5db24f12-141e-4080-b92a-b807a10d3fd3.jpg?v=1787416459",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wild",
        "blueberry",
        "pomegranate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 66,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 13.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790264029381",
      "vsf_explanation": "Wild lowbush blueberry contains higher anthocyanin density than cultivated highbush — a modest formulation advantage. Pomegranate ellagitannins have small cardiovascular and endothelial-function evidence (Aviram 2004 progression-of-atherosclerosis signal). Fruit-powder blend without per-herb anthocyanin/punicalagin standardization. Would move to Standard 62+ with per-herb mg disclosure and marker standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "keep-it-real-tote-bag",
      "title": "Keep It Real Tote Bag",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/80db1f15-bfeb-4739-a6a9-ea03fa114051_large_60575d7c-cfa7-49d2-920e-aafa379ea97e.jpg?v=1787416459",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "keep",
        "real",
        "tote",
        "bag",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 20,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 12.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790263996613",
      "vsf_explanation": "This is a branded tote bag — an accessory product, not a health intervention or ingestible. Auto-fail as out-of-scope for the Vyvata biohacking supplement rubric.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "sulforaphane-from-broccoli-sprout-extract",
      "title": "Sulforaphane from Broccoli Sprout Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e70c2a2a-5c40-4c21-babc-0fcd46c763fb_large_00a0f252-d5ce-4e2a-b25d-b4a7e43882f0.jpg?v=1787416459",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sulforaphane",
        "from",
        "broccoli",
        "sprout",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 11.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790264062149",
      "vsf_explanation": "Broccoli-sprout extract standardized to sulforaphane (or the SFN precursor glucoraphanin + myrosinase). Strong Nrf2/detoxification biology and human trials for oxidative stress markers (Fahey 2019) and autism-behavior in a small pilot (Singh 2014). This SKU doesn't clearly disclose whether myrosinase is active (needed for glucoraphanin→SFN conversion) or the mg per serving of SFN. Would move to Verified 70+ with a defined sulforaphane yield spec (e.g., ≥5 mg SFN) and active myrosinase confirmation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "purple-fruit-veggie-complex",
      "title": "Purple Fruit & Veggie Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5b200132-98e9-49fb-9120-064e3cc226ab_large_87bafe33-e913-4cbc-8de6-73522d72c081.jpg?v=1787416459",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "purple",
        "fruit",
        "veggie",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 14.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790264586437",
      "vsf_explanation": "Purple-produce blend (typically berries, purple sweet potato, red cabbage). Marketed for anthocyanin content, but no anthocyanin mg per serving is disclosed. Whole-fruit-powder capsules deliver too little material to approximate dietary intake. Would move to Standard 60+ with anthocyanin standardization and disclosed per-ingredient mg.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sprouted-broccoli-seed-made-with-organic-broccoli-seed",
      "title": "Sprouted Broccoli Seed - Made with Organic Broccoli Seed",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c4b03aa5-0acc-41c6-9c3c-a40e87204d63_large_630cc0f2-973d-40d5-b7f7-d799d362502b.jpg?v=1787416459",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sprouted",
        "broccoli",
        "seed",
        "made",
        "with",
        "organic",
        "broccoli",
        "seed",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 58,
        "sustainability": 60
      },
      "price": 23.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790264651973",
      "vsf_explanation": "Broccoli-seed capsule — sulforaphane precursor pathway. Fahey 2019 shows sulforaphane's Nrf2 activation is real, but conversion from glucoraphanin depends on active myrosinase or gut microbiota. Product doesn't clearly disclose SFN yield or myrosinase status. Would move to Verified 70+ with SFN mg yield and myrosinase confirmation on-label.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "veggies4life",
      "title": "Veggies4Life",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6d9a9011-b810-4b5a-8bc8-045821af2e4a_large_0f1dd6bd-0388-4d85-aab5-d43ba71ff7be.jpg?v=1787416459",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "veggies4life",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 50,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 48,
        "sustainability": 55
      },
      "price": 21.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790264619205",
      "vsf_explanation": "Vegetable-blend capsule sold as a produce substitute. Category-wide, veggie capsules deliver mg-level dried powder that cannot replicate cups of dietary produce. Proprietary-blend structure typically hides per-ingredient mg. Would move to Standard 55+ with defined per-ingredient mg and to Verified 70+ with polyphenol/carotenoid content disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "green-lipped-mussel",
      "title": "Green Lipped Mussel",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b6b54148-4835-43a3-ad43-e8bfe9ec059d_large_c79f6bd8-be26-42b9-915a-c6081ee7716f.jpg?v=1787416459",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "green",
        "lipped",
        "mussel",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 60,
        "sustainability": 60
      },
      "price": 25.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790264684741",
      "vsf_explanation": "New Zealand green-lipped mussel (Perna canaliculus) — source of ETA and other omega-3s marketed for joint health. Cochrane review (Brien 2008) rated evidence as inconclusive vs placebo for osteoarthritis, though some trials show modest symptom improvement (Coulson 2013 at 3 g/day whole mussel powder). Shellfish allergen risk. Would move to Verified 70+ with a named lipid-extract (e.g., Lyprinol/PCSO-524) at studied dose and heavy-metal COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fucoidan-extract",
      "title": "Fucoidan Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/53cc332f-b04d-4779-b2e7-44c9813d57a4_large_b8fe1752-b364-4c5c-8d63-7fec19f81c4c.jpg?v=1787416460",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fucoidan",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 28.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790264783045",
      "vsf_explanation": "Sulfated polysaccharide from brown seaweed (Undaria pinnatifida or Fucus vesiculosus). Preclinical immune and anti-tumor signal is real but controlled human trial base is small. Species, molecular weight, and % fucoidan aren't disclosed here, which all matter for activity. Iodine content also matters for thyroid safety. Would move to Verified 70+ with a named branded fucoidan (Maritech, etc.), MW spec, and iodine mg per serving.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pristine-norwegian-cod-liver-oil",
      "title": "Pristine Norwegian Cod Liver Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a4d9899c-3f4e-4291-8725-056a3d4bab56_large_08f3ee28-338d-411c-bb68-7421b0f01468.jpg?v=1787416460",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pristine",
        "norwegian",
        "cod",
        "liver",
        "oil",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 60,
        "transparency": 65,
        "sustainability": 60
      },
      "price": 12.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790264717509",
      "vsf_explanation": "Cod liver oil — a traditional combined EPA/DHA + vitamin A + vitamin D source. Norwegian sourcing is a positive signal for cold-water lipid quality. Vitamin A content requires attention in pregnancy (upper limit) and in combination with other retinol sources. Would move to Verified 70+ with per-serving EPA/DHA/vit A/vit D disclosed on label, IFOS oxidation testing, and clear pregnancy warnings.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "broken-cell-wall-chlorella",
      "title": "Broken Cell Wall Chlorella",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/984a2a07-d907-4918-be14-f9d617279b1b_large_0a058801-1431-4461-b101-6104f9984a62.jpg?v=1787416459",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "broken",
        "cell",
        "wall",
        "chlorella",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 62,
        "sustainability": 62
      },
      "price": 22.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790264750277",
      "vsf_explanation": "Broken cell wall chlorella — this is the studied bioavailable format that allows the intracellular nutrients (chlorophyll, protein, carotenoids) to be absorbed (chlorella's native rigid cell wall is otherwise indigestible). Broken/cracked cell wall processing at title level is a genuine quality signal. Held at Standard because branded source (Sun Chlorella A or Yaeyama Chlorella) is not named. Would move to Verified 70+ with branded sourcing named plus heavy-metal COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "spirulina-2-pack",
      "title": "Spirulina - 2 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d4a844ba-9c17-4353-b51c-4d3a5cf67cff_large_4c9db232-20c0-4892-9a10-98f13d7d44c0.jpg?v=1787416461",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "spirulina",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 12.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790264815813",
      "vsf_explanation": "Two-pack of Swanson spirulina. Spirulina at 8-16g/day has meta-analysis support for LDL and triglyceride improvement (Serban 2016). Contamination risk (microcystins) makes source transparency critical — Cyanotech and Parry are the reference-standard tested sources. Held at Standard because source is not named and microcystin testing not published. Would move up with contamination-tested named source.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liquid-chlorophyll",
      "title": "Liquid Chlorophyll",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d2b19229-79e5-4b5e-92a8-ca95fb6aa72e_large_d207bb72-8767-4867-8999-1540e389faf9.jpg?v=1787416461",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liquid",
        "chlorophyll",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 14.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790264848581",
      "vsf_explanation": "Liquid chlorophyll (typically sodium copper chlorophyllin). Popular on social media for skin/deodorant claims — human evidence is sparse. Best documented use is Egner 2001 for aflatoxin-adduct reduction, not general wellness endpoints. Would move to Standard 60+ with an evidence-based use case and dose disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vegetarian-chlorophyll-as-chlorophyllin",
      "title": "Vegetarian Chlorophyll as Chlorophyllin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0e9ae9aa-ff92-40d7-b242-e2f1c4226198_large_3eb980cd-515e-446f-b5c2-59ef8841c6a8.jpg?v=1787416461",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vegetarian",
        "chlorophyll",
        "chlorophyllin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 28.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790265340101",
      "vsf_explanation": "Sodium copper chlorophyllin capsule — the semi-synthetic derivative commonly sold as 'chlorophyll'. Best (and still modest) human data is for aflatoxin-adduct reduction in high-exposure populations (Egner 2001) rather than the internal-deodorant claims typically marketed. Transparency on 'as chlorophyllin' is honest naming. Would move to Standard 60+ with a defined, evidence-based use case and mg dosing rationale.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fruit4life",
      "title": "Fruit4Life",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f22d3585-eebb-44f8-8bfc-0121c005059f_large_fb17eac6-bba4-4657-9f77-26970ec8d1c9.jpg?v=1787416461",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fruit4life",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 50,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 48,
        "sustainability": 55
      },
      "price": 19.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790265372869",
      "vsf_explanation": "Fruit-blend capsule marketed as a produce substitute. Category-wide, whole-fruit-powder capsules deliver too little material to approximate whole-food intake and typically hide per-ingredient mg in a proprietary blend. Anthocyanin, polyphenol, and vitamin content are not disclosed. Would move to Standard 55+ with defined ORAC/polyphenol content per serving and elimination of proprietary-blend structure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-atlantic-salmon-oil-2-pack",
      "title": "Pure Atlantic Salmon Oil - 2 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/25ae85f0-4986-4de3-b0c3-8d21341d9013_large_d38d07b3-ccd4-4d10-95dc-636630b6893d.jpg?v=1787416461",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "atlantic",
        "salmon",
        "oil",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 22.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790265405637",
      "vsf_explanation": "Salmon oil softgel — omega-3 EPA/DHA source. Farmed Atlantic salmon oil is a less-concentrated omega-3 source than concentrated fish oil or triglyceride EPA/DHA products; a typical salmon-oil cap delivers ~150–250 mg combined EPA+DHA, versus the 1–2 g/day GISSI/REDUCE-IT ranges. Would move to Verified 70+ with concentrated EPA/DHA mg per serving, IFOS oxidation testing on-label, and disclosure of wild vs farmed source.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chlorophyllin-mint",
      "title": "Chlorophyllin & Mint",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/437477d8-b0eb-492f-b2a2-4145dcadea42_large_df617612-18b7-468f-b8e5-58011c690985.jpg?v=1787416461",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chlorophyllin",
        "mint",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 55,
        "sustainability": 52
      },
      "price": 18.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790265438405",
      "vsf_explanation": "Chlorophyllin (sodium copper chlorophyllin) is used as an internal deodorizer for trimethylaminuria and colostomy odor with some support, but broader antioxidant/detox claims lack robust RCT evidence. Copper content should be considered against RDA limits with chronic use. Would move to Standard 60+ with defined clinical use case and copper content disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ecklonia-cava-extract-standardized",
      "title": "Ecklonia Cava Extract - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/17e8eed4-f848-4860-8e1b-d2c6650451a7_large_76c15603-f93d-461e-8165-640ae0eec002.jpg?v=1787416462",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ecklonia",
        "cava",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 14.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790265995461",
      "vsf_explanation": "Standardized brown seaweed (Ecklonia cava) extract, rich in dieckol and phlorotannins. Small human trials show BP and blood-lipid modulation (Shin 2012) at 400–500 mg/day. 'Standardized' on-label is a positive step, but without a named branded raw (e.g., Seanol) or a % phlorotannin spec, the exact potency is unclear. Would move to Verified 70+ with named phlorotannin standardization and iodine content disclosure (relevant for thyroid safety).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "multiomega-3-6-9-flax-borage-fish-oils-omegatru-blend-1",
      "title": "MultiOmega 3-6-9 Flax, Borage & Fish Oils - OmegaTru Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/df903acb-8d2d-411a-ad8d-6b9a1557ac33_large_c8cb2097-b1f2-471f-95cc-22f08f3d22e1.jpg?v=1787416463",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "multiomega",
        "flax",
        "borage",
        "fish",
        "oils",
        "omegatru",
        "blend",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 27.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790266028229",
      "vsf_explanation": "3-6-9 omega blend. Omega-6 and omega-9 are not deficient in the standard Western diet (omega-6 is typically excessive), so adding them dilutes the EPA+DHA payload without benefit and can worsen the omega-6:3 ratio. Would move to Standard-high 65+ by dropping the 6/9 components and delivering more EPA+DHA per cap.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chamomile",
      "title": "Chamomile",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7995d967-3769-4d67-8f11-12b737bfd977_large_fa90c216-5528-4ee6-9fa3-f97b3b7f4a8c.jpg?v=1787416463",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chamomile",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 60,
        "sustainability": 60
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790266060997",
      "vsf_explanation": "Basic chamomile capsule - whole-herb format without apigenin standardization. Chamomile has real evidence base for GAD and sleep quality when standardized to 1.2% apigenin at 220mg (Amsterdam 2016; Zick 2011), which unstandardized whole-herb cannot reliably deliver. Safety is very good; ragweed cross-reactivity in sensitive users is the main caveat. Would move to Verified 70+ with apigenin standardization at 1.2% and studied 220mg dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chlorophyll",
      "title": "Chlorophyll",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e931d786-5d98-4825-9b6f-cd68531b5230_large_337d45cc-fff8-4189-9d1b-71e4f873260a.jpg?v=1787416465",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chlorophyll",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 14.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790266618053",
      "vsf_explanation": "Chlorophyll capsule — a low-evidence category. Most marketed 'chlorophyll' products are technically sodium copper chlorophyllin (not native chlorophyll), which is a semi-synthetic derivative used as a food colorant. Human evidence for internal deodorization or detox endpoints is essentially anecdotal. Would move to Standard 60+ only if repositioned as a defined chlorophyllin dose with disclosed mg per cap and a specific evidence-based use.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "krill-oil-with-pure-coconut-oil",
      "title": "Krill Oil with Pure Coconut Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/81b42fa6-a170-4c87-9a6a-da8a6f3c6526_large_05ffc4e2-10fa-4779-8b39-0a2e209d54e6.jpg?v=1787416464",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "krill",
        "oil",
        "with",
        "pure",
        "coconut",
        "oil",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 62,
        "sustainability": 60
      },
      "price": 18.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790266650821",
      "vsf_explanation": "Krill oil (phospholipid EPA/DHA) with added coconut oil (MCT/lauric acid). Krill oil has legitimate absorption advantage over ethyl-ester fish oil (Ulven 2011). Coconut oil addition is neutral to slightly negative for cardiovascular positioning (saturated fat). Krill source not identified (Superba/Antarctic MSC preferred). Would move to Verified with named MSC-certified krill source and per-cap EPA+DHA disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "wheat-germ-oil-cold-pressed",
      "title": "Wheat Germ Oil - Cold Pressed",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5a8b0e8a-aac6-40af-a1c0-1c38db7953ee_large_4f804ee0-f7c3-4da8-b549-05aae91735cf.jpg?v=1787416464",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wheat",
        "germ",
        "oil",
        "cold",
        "pressed",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 5.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790266683589",
      "vsf_explanation": "Cold-pressed wheat germ oil — a source of natural mixed tocopherols and octacosanol. Human data for octacosanol on endurance/performance (Xu 2011) is limited and mixed. Vitamin E content per softgel is typically modest (5–15 IU) — much less than dedicated mixed-tocopherol products. Contains gluten-adjacent proteins, a safety consideration. Would move to Standard 60+ with disclosed tocopherol and octacosanol mg per softgel.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "green-max",
      "title": "Green Max",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/adb82512-cd4e-4ee7-9915-5c1e501db236_large_de292020-6adc-4f18-a65e-0d8154b79d4c.jpg?v=1787416467",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "green",
        "max",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 18.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790267666629",
      "vsf_explanation": "Greens-blend capsule (grasses, algae, herbs). Category-wide, greens-blend capsules deliver too little material to match dietary produce or clinical greens-powder trials. This SKU almost certainly runs as a proprietary blend, blocking per-ingredient mg verification. Would move to Standard 60+ with a per-ingredient mg breakdown and third-party heavy-metal COA (a real issue for spirulina, chlorella, and wheat/barley grass sourcing).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "triple-strength-super-epa-dha-enteric-coated",
      "title": "Triple Strength Super EPA & DHA - Enteric Coated",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d90f1ceb-06ec-4752-b129-e1da833b0458_large_de383fca-2ffb-46f5-80c8-330ad573f249.jpg?v=1787416467",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "triple",
        "strength",
        "super",
        "epa",
        "dha",
        "enteric",
        "coated",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 72,
        "manufacturing": 68,
        "safety": 68,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 23.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790267699397",
      "vsf_explanation": "Concentrated fish oil (triple-strength typically means ~900mg EPA+DHA per softgel) with enteric coating to reduce fishy burp-back and improve enteric absorption. Solid cardiovascular evidence base (REDUCE-IT for high-dose EPA; Bernasconi 2020 meta-analysis). Enteric coating is a real formulation advantage. Just barely into Verified. Would move to Verified 75+ with disclosed form (triglyceride vs ethyl ester) and IFOS certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "plant-based-omega-3-featuring-lifes-omega",
      "title": "Plant Based Omega-3 - Featuring life's OMEGA",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/82edd179-590a-4e15-b5ab-5e01765bc1f0_large_04c38891-e9c6-4daa-badd-7603f276eafb.jpg?v=1787416468",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "plant",
        "based",
        "omega",
        "featuring",
        "life",
        "omega",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 72,
        "manufacturing": 72,
        "safety": 68,
        "transparency": 70,
        "sustainability": 75
      },
      "price": 45.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790268485829",
      "vsf_explanation": "life's OMEGA is DSM's branded algal EPA+DHA — the leading vegan/vegetarian omega-3 source with real EPA (not just DHA) content unusual for algal sources. Bioequivalence to fish oil demonstrated (Lane 2014; Arterburn 2008). Sustainability advantage vs marine sources. Sits at low-Verified. Would move up with per-cap EPA+DHA disclosure explicit on-cap.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "green-max-powder",
      "title": "Green Max Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b381cb76-0b32-4639-9d1c-1ad0ffeb1516_large_37b29bab-dca3-4573-b29f-3429743c0a42.jpg?v=1787416467",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "green",
        "max",
        "powder",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 26.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790268518597",
      "vsf_explanation": "Powder version of Swanson's Green Max blend — powder format at least allows a meaningful gram-level dose (unlike the capsule sibling). Still proprietary at the sub-ingredient level in most cases. Would move to Verified 70+ with a per-active mg breakdown, a heavy-metal COA on algae/grass components, and disclosed source of spirulina/chlorella.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "green-energy-blend",
      "title": "Green Energy Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/93bfbbab-92aa-4cae-8a96-d62a8d93cff2_large_af059a43-f4e2-47fa-96e0-25f8f7fd84aa.jpg?v=1787416468",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "green",
        "energy",
        "blend",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 52,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 8.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790268551365",
      "vsf_explanation": "Generic 'green energy' blend — typical formula stacks greens powder (spirulina, chlorella, wheat/barley grass) with caffeine/green tea and adaptogens. Combination greens-plus-energy blends are essentially always proprietary-blend products that hide per-ingredient dosing, making it impossible to verify any active hits its studied threshold. Held at Standard on transparency grounds. Would move up with per-active dose disclosure and no proprietary blends.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-nattokinase-4000-fu-800mg-200-veggie-capsules-vegan-non-gmo",
      "title": "NusaPure Nattokinase 4000 FU 800mg, 200 Veggie Capsules (Vegan, Non-GMO)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0d2ab280.jpg?v=1787416495",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "nattokinase",
        "4000",
        "800mg",
        "200",
        "veggie",
        "capsules",
        "vegan",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 30.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790277726405",
      "vsf_explanation": "Nattokinase 4000 FU at 800mg is above the typical 2000 FU dose used in cardiovascular trials (Kim 2008 for BP, Ren 2017 for fibrinolysis). Enzyme activity clearly disclosed in the correct FU units, which is a genuine plus. Safety concern: nattokinase has real fibrinolytic activity and requires bleeding-risk disclosure — not visible from title. Would move to Verified 70+ with anti-coagulant interaction warning and NSK-SD (JBSL) branded source or equivalent.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-papaya-papain-enzyme-complex-240-000-pu-200-veggie-caps-suitable-for-vegetarian-vegan-non-gmo",
      "title": "NusaPure Papaya Papain Enzyme Complex 240,000 PU - 200 Veggie Caps - Suitable for Vegetarian, Vegan Non-GMO",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/984595d4.jpg?v=1787416500",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "papaya",
        "papain",
        "enzyme",
        "complex",
        "240",
        "000",
        "200",
        "veggie",
        "caps",
        "suitable",
        "for",
        "vegetarian",
        "vegan",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 25.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790279856325",
      "vsf_explanation": "Papain from papaya is a well-characterized cysteine protease commercially. 240,000 PU (papain activity units) per cap is a reasonable enzyme potency. Human RCT evidence for oral papain digestive support is thin; most efficacy data comes from topical wound/inflammation use. NusaPure discloses potency in the correct enzyme-activity units, which is a plus. Would move to Standard 62+ with clinical trial support for oral digestive endpoints.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-chlorophyll-200-1-extract-150-mg-per-capsule-120-vegetarian-caps-non-gmo-vegan",
      "title": "NusaPure Chlorophyll 200:1 Extract, 150 mg per Capsule 120 Vegetarian Caps (Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-131804v4-Chlorophyll-3D-01.jpg?v=1787416506",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "chlorophyll",
        "200",
        "extract",
        "150",
        "per",
        "capsule",
        "120",
        "vegetarian",
        "caps",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 28,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790282019013",
      "vsf_explanation": "Chlorophyll (typically sold as chlorophyllin, a semi-synthetic copper complex) has very limited RCT support — a small trial for aflatoxin biomarker reduction (Egner 2001), and anecdotal use for body odor. Broader claimed effects (detox, energy, weight loss) lack evidence. Chlorophyll form (natural vs chlorophyllin) not disclosed. Would move to Standard 60 with modern evidence-supported use case and form disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "certified-organic-extra-virgin-olive-oil-cold-pressed",
      "title": "Certified Organic Extra Virgin Olive Oil - Cold Pressed",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2c39c75c-cd32-4830-99cc-22627ad73872_large_099d7090-3761-498a-8f57-28ada39d8ebe.jpg?v=1787416514",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "certified",
        "organic",
        "extra",
        "virgin",
        "olive",
        "oil",
        "cold",
        "pressed",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 9.77,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790285754565",
      "vsf_explanation": "Culinary extra-virgin olive oil — a food, not a supplement. Mediterranean-diet CV evidence is strong (Estruch 2013 PREDIMED) and EFSA has authorized the 5 mg-hydroxytyrosol-per-day claim for LDL protection. This product doesn't disclose polyphenol content (mg/kg tyrosol equivalents) or harvest origin, which is the differentiator between a health-tier and grocery-tier EVOO. Would move to Verified 70+ with polyphenol assay on-label.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-french-roast-whole-bean-coffee-dark-roast",
      "title": "Organic French Roast Whole Bean Coffee - Dark Roast",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a38f857e-cefa-40a2-84f1-3e84ac162f06_large_94b7c130-7c0a-445d-8c42-1907ce67b5db.jpg?v=1787416514",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "french",
        "roast",
        "whole",
        "bean",
        "coffee",
        "dark",
        "roast",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 24.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790285689029",
      "vsf_explanation": "Whole-bean dark-roast organic coffee. Beverage food; general coffee-health signal from Poole 2017 umbrella meta. Out of biohacking supplement scope.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chlorella",
      "title": "Chlorella",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cdfd7e94-e13a-4472-9eda-2867536a5e7e_large_2b180384-57bb-498e-991e-b0766ceefe0b.jpg?v=1787416514",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chlorella",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 58,
        "sustainability": 62
      },
      "price": 15.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790285721797",
      "vsf_explanation": "Chlorella — a green freshwater algae with modest human evidence for lipid profile (Ryu 2014) and immune markers (Kwak 2012, 5g/day). 'Heavy metal detox' claims often attached to chlorella are not substantiated by controlled human trials. Chlorella has a rigid cell wall that limits bioavailability; the 'broken cell wall' or 'cracked cell wall' preparation is the studied format. Held at Standard because cell wall preparation is not confirmed at title level and no branded source (Sun Chlorella is the reference-standard) named. Would move up with cracked cell wall + branded sourcing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-french-roast-decaf-whole-bean-coffee-dark-roast",
      "title": "Organic French Roast Decaf Whole Bean Coffee - Dark Roast",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/dc778089-ad3c-4921-8580-8268e4d985fd_large_c0d09c4f-1fb6-4bcd-91bf-7b054fe12cba.jpg?v=1787416514",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "french",
        "roast",
        "decaf",
        "whole",
        "bean",
        "coffee",
        "dark",
        "roast",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 22.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790285852869",
      "vsf_explanation": "Decaf whole-bean organic French roast. Beverage food; removing caffeine also removes the primary studied active for cognitive/metabolic endpoints. Decaffeination method not disclosed. Out of biohacking scope.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "100-organic-beet-juice-powder-vegetarian",
      "title": "100% Organic Beet Juice Powder - Vegetarian",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/398baf81-681c-4c71-858f-95452a36dfb3_large_d94fa9f8-6f2d-4c55-bee5-ce4f6636415c.jpg?v=1787416514",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "100",
        "organic",
        "beet",
        "juice",
        "powder",
        "vegetarian",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 19.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790285787333",
      "vsf_explanation": "Organic beet juice powder — dietary nitrate is the studied active. Concentrated beetroot at ~400 mg nitrate/serving lowers resting BP (Siervo 2013 meta) and improves exercise economy (Domínguez 2017). Powder product doesn't disclose nitrate mg per serving, which is the single most important spec. Would move to Verified 70+ with a standardized NO3⁻ mg/serving on-label.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "certified-organic-flaxseed-milled",
      "title": "Certified Organic Flaxseed - Milled",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3084955a-8537-4d72-b9f4-0d1eaa38593a_large_c7343439-48fb-4034-a531-b3f4eace87fb.jpg?v=1787416514",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "certified",
        "organic",
        "flaxseed",
        "milled",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 65,
        "sustainability": 68
      },
      "price": 9.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790285820101",
      "vsf_explanation": "Milled organic flaxseed — well-evidenced whole food for BP reduction (Rodriguez-Leyva 2013 for hypertension) and LDL. Milled (not whole) form is necessary since whole seeds pass through undigested. Organic sourcing improves the sustainability score. Milled flax is oxidation-prone — refrigeration after opening matters. Would move to Verified with vacuum-nitrogen packaging or oxygen-scavenger disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "psyllium-husk-powder-certified-organic",
      "title": "Psyllium Husk Powder - Certified Organic",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c202ccb9-ba92-42bc-ba78-125fee48af11_large_59cdcaba-e3f7-47d8-927b-4fba5fb089e0.jpg?v=1787416514",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "psyllium",
        "husk",
        "powder",
        "certified",
        "organic",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 68,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 68,
        "sustainability": 68
      },
      "price": 16.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790285885637",
      "vsf_explanation": "Certified-organic psyllium husk powder — excellent underlying ingredient (Jovanovski 2018 meta-analysis for LDL reduction; McRorie 2015 for constipation). Organic sourcing improves the sustainability dimension. Would move to Verified 70+ with heavy-metal test disclosure and USP verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "100-organic-hibiscus-flower-tea-caffeine-free",
      "title": "100% Organic Hibiscus Flower Tea - Caffeine Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/465259b8-8a2d-447c-adc6-6634f29a5bcf_large_3173ac09-dc44-4b66-b9d5-88afc7730516.jpg?v=1787416514",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "100",
        "organic",
        "hibiscus",
        "flower",
        "tea",
        "caffeine",
        "free",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 66,
        "transparency": 62,
        "sustainability": 60
      },
      "price": 8.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790285951173",
      "vsf_explanation": "Hibiscus BP-lowering evidence (McKay 2010) was actually generated using tea/infusion format — this delivery vehicle matches the studied protocol better than capsule powders. Effect is modest (~7 mmHg systolic) at 1-2 cups/day of steeped dried calyx. Organic certification is a positive. Would move to Verified 70+ if labeled with per-bag calyx mg and aligned to studied brew concentrations.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "eggplant-extract",
      "title": "Eggplant Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5d2f5a56-7c60-489f-bde1-a2b55d1898be_large_aa48d4f0-d41c-4296-9e5d-b7d806789178.jpg?v=1787416514",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "eggplant",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 50,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 10.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790285983941",
      "vsf_explanation": "Solanum melongena extract, occasionally marketed for weight management or cholesterol via fiber/polyphenols. Human clinical evidence is essentially absent — a Guimarães 2000 pilot on eggplant powder for cholesterol was small and short. No standardization disclosed. Would need a defined active and controlled human trial data to move above Rejected.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "100-organic-ginger-root-tea-caffeine-free",
      "title": "100% Organic Ginger Root Tea - Caffeine-Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e059c683-7c65-4b1b-a40e-0869e66a4f52_large_d2620d25-7d8e-4051-b1eb-fc6cf04f61fb.jpg?v=1787416514",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "100",
        "organic",
        "ginger",
        "root",
        "tea",
        "caffeine",
        "free",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 62,
        "sustainability": 60
      },
      "price": 5.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790285918405",
      "vsf_explanation": "Ginger tea as a wellness beverage. Nausea RCTs (Ernst & Pittler 2000) used encapsulated ginger at 500-1500 mg, not steeped tea — infusion delivers a fraction of the studied gingerol dose. Culinary-tier product. Organic sourcing is a positive. Would move up as a food/beverage reclassification rather than a supplement.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "100-organic-matcha-green-tea",
      "title": "100% Organic Matcha Green Tea",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/69c7f5c4-48f4-469c-8aec-4b7ca4d2dfa7_large_538d698c-4cc0-4ca5-ab4c-56f2fab4ea03.jpg?v=1787416515",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "100",
        "organic",
        "matcha",
        "green",
        "tea",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 13.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790286180549",
      "vsf_explanation": "Organic matcha (whole-leaf green tea powder). EGCG and L-theanine synergy has RCT signal for calm-focus (Dietz 2017 review). Matcha grade (ceremonial vs culinary), catechin content, and lead-testing status are not disclosed — meaningful for both efficacy and safety, since tea leaves can accumulate lead. Would move to Verified 70+ with grade disclosure, EGCG mg/serving, and heavy-metal COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-apple-cider-vinegar-with-mother",
      "title": "Organic Apple Cider Vinegar with Mother",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/75028da2-b21f-42a4-8e8b-60e0aa83afaa_large_29849c5a-ca4f-4abc-9cb4-9880d2ce3524.jpg?v=1787416514",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "apple",
        "cider",
        "vinegar",
        "with",
        "mother",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 72,
        "manufacturing": 62,
        "safety": 55,
        "transparency": 65,
        "sustainability": 65
      },
      "price": 6.41,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790286049477",
      "vsf_explanation": "Liquid organic ACV with mother — the functional form for the postprandial-glucose mechanism (Johnston 2013 for T2D) and Kondo 2009's small weight/waist trial (15ml/day vinegar). Mother (acetobacter cellulose matrix) is minor but a fermentation-quality indicator. Safety: undiluted daily use erodes tooth enamel and can worsen reflux — always dilute in water. Would move to Verified with acetic-acid % disclosed and consumer-facing dilution guidance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "barley-grass-juice-powder-certified-organic",
      "title": "Barley Grass Juice Powder - Certified Organic",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/06fa90d0-3026-431c-bf72-8b7466a3936d_large_2d09bc78-9102-493e-bab3-32a0c5594377.jpg?v=1787416514",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "barley",
        "grass",
        "juice",
        "powder",
        "certified",
        "organic",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 6.65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790286246085",
      "vsf_explanation": "Cold-pressed barley-grass juice powder — a greens/whole-food product. Modest chlorophyll, vitamins K/beta-carotene, and enzymes but no controlled human trials at capsule/powder doses for any hard endpoint. Would move to Standard 60+ with a defined nutrient profile per serving and to Verified 70+ only with an outcome-based trial.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-apple-cider-vinegar-with-mother-1",
      "title": "Organic Apple Cider Vinegar with Mother",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2723e4aa-440d-431e-895a-57d2d4a17860_large_b39b6f3e-aec1-4ad9-81e7-9a581b6467a6.jpg?v=1787416515",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "apple",
        "cider",
        "vinegar",
        "with",
        "mother",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 72,
        "manufacturing": 62,
        "safety": 55,
        "transparency": 65,
        "sustainability": 65
      },
      "price": 10.85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790286016709",
      "vsf_explanation": "Liquid organic ACV with mother — duplicate SKU. Functional form for the postprandial-glucose mechanism (Johnston 2013). Dilution guidance essential to protect tooth enamel. Would move to Verified with acetic-acid % disclosed and dilution guidance on-label.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "certified-organic-pumpkin-seed-oil-cold-pressed",
      "title": "Certified Organic Pumpkin Seed Oil - Cold Pressed",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6a92b790-22a4-44dc-9e72-ee33e151b5eb_large_31ce8001-0a51-416e-8b47-10c2ad0f1e74.jpg?v=1787416514",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "certified",
        "organic",
        "pumpkin",
        "seed",
        "oil",
        "cold",
        "pressed",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790286115013",
      "vsf_explanation": "Cold-pressed pumpkin seed oil — used both as culinary oil and for BPH/urinary support. Vahlensieck 2015 showed pumpkin seed extract improved LUTS symptom scores; that trial used seed extract, not oil, at ~500 mg/day. Product does not disclose whether the format is for prostate use (a softgel dose) or for cooking. Would move to Verified 70+ if repositioned as a defined prostate-support softgel dose based on Vahlensieck-style dosing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-house-blend-ground-coffee-medium-roast",
      "title": "Organic House Blend Ground Coffee - Medium Roast",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0248e147-f6d0-4951-866e-43a082424794_large_893e1a64-4f21-40d0-9f4d-68f86fa6ead2.jpg?v=1787416514",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "house",
        "blend",
        "ground",
        "coffee",
        "medium",
        "roast",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 24.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790286082245",
      "vsf_explanation": "Organic medium-roast ground coffee. Beverage food; general coffee-mortality signal from Poole 2017. Out of biohacking supplement scope; scored honestly as a low-intervention food.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "100-organic-chamomile-tea-caffeine-free",
      "title": "100% Organic Chamomile Tea - Caffeine Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7b2612e4-9493-4499-92c1-04e447f3867f_large_a85c827a-611a-47fd-ba41-b6ad4282438e.jpg?v=1787416514",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "100",
        "organic",
        "chamomile",
        "tea",
        "caffeine",
        "free",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 74,
        "transparency": 62,
        "sustainability": 65
      },
      "price": 7.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790286213317",
      "vsf_explanation": "Organic chamomile tea - traditional preparation with millennia of use for mild sleep and relaxation support. Chamomile has real evidence base (Amsterdam 2016 for GAD; Zick 2011 for sleep) at 220mg standardized-to-apigenin doses; the tea format delivers meaningfully lower apigenin than the standardized extract but retains ritual/warm-drink benefits that support sleep-hygiene routines. Ragweed cross-reactivity is the main safety caveat. Would move to Verified 70+ with apigenin content per serving disclosed and USDA organic certification prominently displayed on label copy.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chlorella-1",
      "title": "Chlorella",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/430bd0e5-224d-42d5-a2f2-6f23e9fe8b0c_large_f02417a8-e30b-4d0b-b0b7-4c194c138e3b.jpg?v=1787416515",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chlorella",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 58,
        "sustainability": 62
      },
      "price": 55.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790286147781",
      "vsf_explanation": "Duplicate chlorella SKU. Modest human evidence (Ryu 2014 lipids, Kwak 2012 immune markers at 5g/day). Held at Standard because cell wall preparation is not disclosed and Sun Chlorella sourcing is not named. Would move up with cracked cell wall preparation confirmed and branded sourcing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "enteric-coated-aspirin-nsaid-low-dose",
      "title": "Enteric Coated Aspirin NSAID - Low Dose",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/411323a0-ac5c-4a90-891c-a431127136c8_large_6a0c46a6-c50a-4ba1-ab04-4b23c772e654.jpg?v=1787416516",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "enteric",
        "coated",
        "aspirin",
        "nsaid",
        "low",
        "dose",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 20,
        "manufacturing": 20,
        "safety": 20,
        "transparency": 20,
        "sustainability": 20
      },
      "price": 7.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790286803141",
      "vsf_explanation": "This is an OTC drug (81 mg enteric-coated aspirin), not a dietary supplement, and is out of scope for Vyvata's supplement rubric. The score is a placeholder reflecting that rubric mismatch, not a quality judgment on aspirin itself — aspirin has real, well-studied secondary-prevention evidence (Antithrombotic Trialists 2009), but 2022 USPSTF guidance walked back routine primary-prevention use due to bleeding risk (ASPREE 2018), and self-directed use without clinician oversight carries real GI-bleed and hemorrhagic-stroke risk. An OTC-drug-monograph framework, not the supplement rubric, is the right lens for this product; Vyvata does not currently score OTC drugs.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "hyaluronic-acid-serum",
      "title": "Hyaluronic Acid Serum",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c9400e46-3451-481e-a56d-9c5353bd13cf_large_d81eed96-390c-4e8b-a8df-de8eb8223040.jpg?v=1787416516",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hyaluronic",
        "acid",
        "serum",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 72,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 12.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790286835909",
      "vsf_explanation": "Single-bottle topical HA serum. Topical HA supports surface skin hydration (Pavicic 2011) with low-MW forms penetrating modestly. Held below Verified by unstated HA molecular weight, unspecified % concentration, and no INCI list at title. Would move to Verified 70+ with % HA and named low-MW source.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "100-organic-turmeric-tea-caffeine-free",
      "title": "100% Organic Turmeric Tea - Caffeine Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/126b416f-ff9c-4a47-83ef-8c4197ac541d_large_e6da94dd-f0d6-4499-be88-769277758db0.jpg?v=1787416518",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "100",
        "organic",
        "turmeric",
        "tea",
        "caffeine",
        "free",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 62,
        "safety": 74,
        "transparency": 55,
        "sustainability": 68
      },
      "price": 3.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790287392965",
      "vsf_explanation": "Turmeric tea infusion — as a beverage this is a lifestyle/culinary product rather than a curcumin-effect delivery vehicle. Curcumin is fat-soluble and poorly extracted into hot water, so infused turmeric tea delivers negligible curcuminoid systemic exposure. Legitimate as a traditional beverage, not appropriate for anti-inflammatory dosing. Organic sourcing is a plus for sustainability.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "avena-sativa",
      "title": "Avena Sativa",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/116501f8-89c4-4661-9dd0-bdcdc3646487_large_73529856-7c9e-4e0a-a686-defb78e31ec2.jpg?v=1787416518",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "avena",
        "sativa",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 52,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 3.6,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790287425733",
      "vsf_explanation": "Wild green oat (Avena sativa) extract, traditionally marketed for libido and cognitive support. Meaningful human data is limited to standardized preparations like Neuravena at ~800 mg/day (Kennedy 2018 for cognition). Generic unstandardized avena capsules deliver an unknown active fraction. Would move to Standard 55+ with standardization (β-glucans or avenanthramides) and to Verified 70+ with a Neuravena/other clinically-studied raw material at the studied dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-guarana-extract-20-1-extract-300-mg-per-veggie-caps-200-count-non-gmo-vegan",
      "title": "NusaPure Guarana Extract 20:1 Extract, 300 mg per Veggie Caps 200 Count (Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-126345v9-Guarana-3D-01.jpg?v=1787416518",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "guarana",
        "extract",
        "extract",
        "300",
        "per",
        "veggie",
        "caps",
        "200",
        "count",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 19.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790287458501",
      "vsf_explanation": "Guarana is essentially a plant caffeine source (~4-7% caffeine by weight in seed, higher in extracts). 300mg of 20:1 extract could deliver 100-200mg caffeine depending on standardization — not disclosed. Evidence beyond caffeine's known effects is thin. Would move to Standard 62+ with disclosed caffeine percentage and per-serving mg — currently a black box for caffeine-sensitive users.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "longjax-eurycoma-longifolia-jack-extract",
      "title": "LongJax Eurycoma Longifolia Jack Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c4f6a147-7d09-4626-910e-e2d730fbbf1f_large_b44079a0-8f80-4216-89cb-8703fd10141f.jpg?v=1787416519",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "longjax",
        "eurycoma",
        "longifolia",
        "jack",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 60,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 13.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790288179397",
      "vsf_explanation": "Tongkat ali (Eurycoma longifolia) as the branded LongJax 20:1 extract — a defined, standardized raw. Human data supports modest testosterone and stress-cortisol modulation at 200–400 mg/day of standardized root extract (Talbott 2013; Tambi 2012). LongJax is a documented ingredient brand, which is what pushes this above generic tongkat SKUs. Would move to Verified 70+ with eurypeptide/quassinoid percentage disclosed and third-party heavy-metal COA (a real issue for Malaysian root sourcing).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-house-blend-whole-bean-coffee-medium-roast",
      "title": "Organic House Blend Whole Bean Coffee - Medium Roast",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/78efd06f-3a18-48ae-a407-0320f60a40a0_large_6e4f48c8-a38b-4735-9335-fc2af493c055.jpg?v=1787416519",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "house",
        "blend",
        "whole",
        "bean",
        "coffee",
        "medium",
        "roast",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 24.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790288244933",
      "vsf_explanation": "Whole-bean organic medium-roast coffee. Beverage food; general coffee-health signal from Poole 2017, but no dose spec here. Out of biohacking supplement scope; scored honestly as a low-intervention food product.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ultimate-performance-formula",
      "title": "Ultimate Performance Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/134e6389-2013-4bc5-9e9a-4dd399dbdafe_large_fb57dd57-898f-40d2-8470-41c6dd84aa25.jpg?v=1787416519",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ultimate",
        "performance",
        "formula",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 50,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 48,
        "sustainability": 50
      },
      "price": 15.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790288212165",
      "vsf_explanation": "Generic male-performance formula name — typically a proprietary blend of tongkat, tribulus, horny goat weed, and maca. Without per-active mg on the label the individual ingredients cannot be compared to the doses used in trials (e.g., 200–400 mg tongkat, 1.5–3 g maca). Would move to Standard 60+ with fully-disclosed per-ingredient mg (removes proprietary-blend concern) and to Verified 70+ if named-source extracts (e.g., LongJax, LJ100) are used at studied doses.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "certified-organic-cocoa-powder-unsweetened",
      "title": "Certified Organic Cocoa Powder - Unsweetened",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e8a3d35f-8d42-4b36-a565-34b7c4cba038_large_8f998610-c52b-4e62-be49-73e99c567e76.jpg?v=1787416519",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "certified",
        "organic",
        "cocoa",
        "powder",
        "unsweetened",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 24.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790288277701",
      "vsf_explanation": "Unsweetened cocoa powder. Cocoa flavanols have RCT evidence for endothelial function and blood pressure (Ried 2017 Cochrane), but the studied dose is 200–500 mg of specific flavanols per day (e.g., CocoaVia), which unsweetened cocoa powder does not standardize or disclose. Would move to Verified 70+ only if standardized to a flavanol percentage or replaced with a branded cocoa flavanol raw material.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "certified-organic-wildflower-honey-100-pure-raw",
      "title": "Certified Organic Wildflower Honey - 100% Pure, Raw",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/30e32479-dc14-4254-8704-339e94653e06_large_8e5d2de5-2024-48a2-acb0-809923deab05.jpg?v=1787416520",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "certified",
        "organic",
        "wildflower",
        "honey",
        "100",
        "pure",
        "raw",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 45,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 12.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790288310469",
      "vsf_explanation": "Raw wildflower honey — a food. Some evidence for cough suppression in pediatric URIs (Oduwole 2018 Cochrane), but this is essentially concentrated fructose/glucose (~80 g sugar / 100 g). Raw honey carries infant-botulism warnings under 12 months. Not a targeted supplement; scored honestly as a low-utility wellness food product.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "maca-1",
      "title": "Maca",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3b1f4b50-501c-4dc7-9c82-155f01aee3f7_large_9768788e-461c-4a64-896e-eb31c0ddb809.jpg?v=1787416520",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "energy",
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "maca",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 7.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790288343237",
      "vsf_explanation": "Standard Swanson maca — a Peruvian tuber with modest RCT evidence for libido in healthy men (Gonzales 2002) and erectile function (Zenico 2009). Generally acceptable safety profile. Standard-tier maca is typically whole-root powder without variety (yellow/red/black) specification and without confirmed Peruvian origin; both matter for traditional efficacy claims. Would move to Verified 70+ with named Peruvian sourcing, variety specification, and dose meeting studied ranges (1.5-3g/day).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-hemp-protein-powder",
      "title": "Organic Hemp Protein Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2c6d9d7b-3ef7-46dc-b7bf-f7b6ee954d63_large_2b562e16-2219-4dbc-a30c-4bfe67a9c170.jpg?v=1787416521",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "hemp",
        "protein",
        "powder",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 62,
        "sustainability": 70
      },
      "price": 19.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790288408773",
      "vsf_explanation": "Organic hemp protein — hemp is a whole seed protein with a favorable omega-3 profile and fiber content, but the protein-per-serving is lower than pea or whey (typically 12-15g/serving vs 20-25g) and it is limited in lysine, making leucine content also lower than the MPS threshold (House 2010 on hemp amino profile). Best used as a supplemental protein rather than a primary post-workout source. Organic and sustainable sourcing is a real plus. Held at Standard because effective anabolic dosing requires very high servings; not a primary muscle-building option.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "alkaline-booster-ph-protector-drops",
      "title": "Alkaline Booster pH Protector Drops",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4ff0736f-be65-40c3-9a69-0b30551c74e2_large_bf9aa5a7-cc98-40a0-9fc8-452b11b89662.jpg?v=1787416521",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alkaline",
        "booster",
        "protector",
        "drops",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790288376005",
      "vsf_explanation": "Product framed on the alkaline-diet premise that ingesting alkaline drops meaningfully shifts systemic acid–base balance. Systemic pH is tightly regulated by the kidneys and lungs (Fenton 2011 systematic review), and food/water pH does not change blood pH; only urine pH shifts, with no established health benefit. Auto-fail for unverified medical claim. Would need to strip alkalinity-related health claims entirely to be reconsidered as a mineral drop.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "fermented-alkalizing-greens-drink-mix-with-probiotics",
      "title": "Fermented Alkalizing Greens Drink Mix with Probiotics",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a6e5b92a-67ee-41a0-8655-530e66b56c53_large_8dd5bfd4-df3d-4c0d-a1c5-3bcdd5fc8a1f.jpg?v=1787416521",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fermented",
        "alkalizing",
        "greens",
        "drink",
        "mix",
        "with",
        "probiotics",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 22.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790289227973",
      "vsf_explanation": "'Alkalizing' framing has no valid physiological basis — dietary intake cannot meaningfully shift systemic blood pH, which is homeostatically regulated at ~7.4. Fermented-greens category is fine directionally (polyphenols, some prebiotic action) but the alkalizing hook is a discredited health marketing frame. Probiotic component in a shelf-stable powder likely has low viable CFU at consumption. Would move up by dropping the alkalizing claim and using a spore-forming Bacillus probiotic that survives the powder environment.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-french-roast-ground-coffee-dark-roast",
      "title": "Organic French Roast Ground Coffee - Dark Roast",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/efb40364-b66d-4c70-964d-6502a0d7c1b5_large_7748afc0-1c0b-4f97-926b-33a761a1ede1.jpg?v=1787416521",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "french",
        "roast",
        "ground",
        "coffee",
        "dark",
        "roast",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 24.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790289260741",
      "vsf_explanation": "Organic dark-roast ground coffee. Coffee itself has strong observational associations with reduced all-cause mortality (Poole 2017 umbrella meta) but this is a beverage food, not a specified supplement dose. Dark roasting reduces chlorogenic acid vs lighter roasts. Out of biohacking scope; scored honestly as a low-intervention food.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "100-organic-peppermint-tea-caffeine-free",
      "title": "100% Organic Peppermint Tea - Caffeine Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/127019fd-79c7-4286-9ec7-aca70f88d473_large_e303559a-e4e8-42ca-b472-a9533dd33bee.jpg?v=1787416521",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "100",
        "organic",
        "peppermint",
        "tea",
        "caffeine",
        "free",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 45,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 62,
        "sustainability": 60
      },
      "price": 7.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790289293509",
      "vsf_explanation": "Peppermint tea is a wellness beverage — not the enteric-coated menthol format that carries the IBS evidence (Khanna 2014). Aqueous infusion delivers minor amounts of essential-oil constituents. Safe and reasonable as a beverage; not a therapeutic supplement equivalent. Organic sourcing is a positive. Would move up only via reclassification as a food/beverage product.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-tart-cherry-concentrate",
      "title": "Organic Tart Cherry Concentrate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/89f6c5f6-eaca-4e00-b077-439f1a1f2041_large_2e9e26d0-a729-4a21-b3f6-9dd30adbb9fc.jpg?v=1787416521",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "tart",
        "cherry",
        "concentrate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 13.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790289326277",
      "vsf_explanation": "Tart cherry concentrate — the format used in most sleep and muscle-recovery RCTs. Howatson 2012 (1 oz Montmorency concentrate twice daily) showed sleep-time and efficiency improvements; Bell 2014 for exercise recovery. Product doesn't disclose anthocyanin content per oz, so consistency vs studied doses depends on the buyer approximating the RCT serving. Would move to Verified 70+ with a standardized anthocyanin mg/serving and confirmation the cultivar is Montmorency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-magnesium-malate-1350mg-200-veggie-capsules-vegan-non-gmo-vegan",
      "title": "NusaPure Magnesium Malate 1350mg 200 Veggie Capsules (Vegan, Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9cc0ab8e.jpg?v=1787416522",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "magnesium",
        "malate",
        "1350mg",
        "200",
        "veggie",
        "capsules",
        "vegan",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 20.45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790289359045",
      "vsf_explanation": "Magnesium malate is a well-tolerated organic magnesium form with the malate ligand plausibly supporting ATP/energy pathways (used in fibromyalgia trials — Russell 1995). 1350mg total salt provides ~150-180mg elemental Mg, a moderate serving. Malate form is less well-studied than glycinate or citrate for sleep/anxiety. NusaPure clearly discloses form. Would move to Verified 70+ with elemental-mg disclosure and named source (Albion/Balchem).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-house-blend-decaf-ground-coffee-medium-roast",
      "title": "Organic House Blend Decaf Ground Coffee - Medium Roast",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/09d808d3-33f9-42fa-8d9b-60f0e76c310b_large_4224188b-c363-420a-a0dc-38c2fdd7ebc4.jpg?v=1787416523",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "house",
        "blend",
        "decaf",
        "ground",
        "coffee",
        "medium",
        "roast",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 50,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 22.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790290243781",
      "vsf_explanation": "Organic ground decaf coffee — a food/beverage, not a targeted supplement. Coffee polyphenols have some CV-benefit signal (Poole 2017 umbrella meta), but decaf discards the primary studied active (caffeine) for cognitive/metabolic endpoints. Decaffeination method (Swiss water vs solvent) is not disclosed, which matters for solvent-residue transparency. Out of biohacking scope; scored honestly as a low-intervention food product.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "japanese-oyster-extract",
      "title": "Japanese Oyster Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/38950ffc-9ef0-4533-9f3a-f8119c077859_large_5dfbfe13-ed73-4799-97a6-bd12823d9f96.jpg?v=1787416523",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "japanese",
        "oyster",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 11.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790290276549",
      "vsf_explanation": "Pacific oyster extract, marketed for zinc, taurine, and glycogen content and often used for men's vitality. Human trial base is thin; zinc supplementation itself has stronger evidence than whole-oyster capsules. Shellfish allergen risk and marine heavy-metal contamination (cadmium, arsenic) are the real safety concerns. Would move to Verified 70+ with a disclosed elemental zinc content per serving, heavy-metal test COA, and a named Japanese source.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "100-organic-rooibos-red-tea-caffeine-free",
      "title": "100% Organic Rooibos Red Tea - Caffeine Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/68ab9bce-aaf6-4afe-baa2-f3e13a0970fb_large_32c2be03-cc14-4b67-ac9e-c73050b81cf1.jpg?v=1787416523",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "100",
        "organic",
        "rooibos",
        "red",
        "tea",
        "caffeine",
        "free",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 8.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790290309317",
      "vsf_explanation": "Rooibos herbal tea — a food/beverage. Aspalathin and nothofagin polyphenols show antioxidant activity in vitro but human clinical data (e.g., Marnewick 2011 for CV markers) is limited. As a beverage product with no dose spec, this stays out of biohacking scope. Would move to Standard 55+ only if reformulated as a standardized aspalathin extract with per-serving mg.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chlorella-fermented-turmeric",
      "title": "Chlorella & Fermented Turmeric",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0c8c3e52-46e2-449d-874a-a98f155b3079_large_a69e94dc-8506-41c0-9828-17ae014a5592.jpg?v=1787416524",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chlorella",
        "fermented",
        "turmeric",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 55,
        "sustainability": 62
      },
      "price": 8.64,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790291095749",
      "vsf_explanation": "Chlorella (cracked-cell wall matters — not disclosed) plus fermented turmeric. Fermented turmeric preparations (e.g., THERACURMIN-style micronization or koji fermentation) can improve curcumin bioavailability, but the specific fermentation method here isn't identified. Chlorella has some heavy-metal-binding animal data (Uchikawa 2011); a cell-wall-broken product is functionally different from raw. Held to mid-Standard by these unspecified quality variables. Would move up with cracked-cell chlorella confirmation and named fermented-turmeric technology.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "certified-organic-hemp-seed-shelled",
      "title": "Certified Organic Hemp Seed Shelled",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f514000b-b11a-4f77-8ca0-f515cd1a501d_large_db769ed4-3549-46b6-9773-b6332f8c7a92.jpg?v=1787416525",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "certified",
        "organic",
        "hemp",
        "seed",
        "shelled",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 18.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790291128517",
      "vsf_explanation": "Shelled hemp hearts — a whole food delivering ~9 g complete protein, ~3 g omega-3 ALA, and minerals per 3 tbsp. Honest food product with a real macronutrient contribution rather than a targeted intervention, so it sits at the top of the food-not-supplement band. Would move to Verified 70+ only if repositioned and specced as a protein or omega-ALA supplement with per-serving grams called out on label.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "aged-black-garlic",
      "title": "Aged Black Garlic",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0e99ebe5-0753-41ba-8879-ca5126faa0df_large_e3accde6-b6d7-49d0-882b-584ed9850d42.jpg?v=1787416525",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "aged",
        "black",
        "garlic",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 66,
        "formulation": 66,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 62,
        "sustainability": 60
      },
      "price": 17.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790291161285",
      "vsf_explanation": "Aged black garlic (fermented) concentrates S-allyl cysteine and Amadori/Heyns compounds and has emerging cardiovascular literature — Jung 2014 and Ried's meta-analyses suggest BP and lipid effects broadly consistent with aged garlic extract data. It's a more clinically relevant form than raw garlic oil or plain powder for cardiovascular endpoints. Held below Verified because Swanson's SKU does not disclose SAC content or standardize the aging process to a defined reference (like Kyolic AGE). Would move to Verified 70+ with disclosed SAC content and standardized aging protocol.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "certified-organic-coconut-oil-flavor-free",
      "title": "Certified Organic Coconut Oil Flavor Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/80d76426-79d4-47ea-b60c-c4337530dfc3_large_b3cfa73e-eda9-4a43-9552-f214d0be692a.jpg?v=1787416525",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "certified",
        "organic",
        "coconut",
        "oil",
        "flavor",
        "free",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 28.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790291194053",
      "vsf_explanation": "Refined (deodorized) organic coconut oil — culinary product, high in lauric acid. Same caveats as virgin coconut oil for CV endpoints (Sacks 2017). Would move to Standard 55+ with reformulation to C8/C10 MCT with disclosed fractionation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "100-organic-pea-protein-powder-non-gmo-unflavored",
      "title": "100% Organic Pea Protein Powder - Non-GMO Unflavored",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1fbac396-6ad7-45f3-94ae-9f76b6fed14d_large_0ce93dd9-b8bc-47bc-804e-b4238daa0892.jpg?v=1787416526",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "100",
        "organic",
        "pea",
        "protein",
        "powder",
        "non",
        "gmo",
        "unflavored",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 72,
        "transparency": 65,
        "sustainability": 66
      },
      "price": 27.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790291718341",
      "vsf_explanation": "Duplicate SKU of the organic non-GMO pea protein — same rationale as the sibling. Pea protein at 25g gives MPS response comparable to whey (Babault 2015) but is methionine-limited on its own. Organic non-GMO plus, but pea protein carries a real cadmium accumulation risk (Clean Label Project 2020) and Swanson does not publish per-lot heavy-metal testing. Would move to Verified 70+ with rice-blend to complete amino profile and published heavy-metal COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "100-organic-extra-virgin-coconut-oil-cold-pressed",
      "title": "100% Organic Extra Virgin Coconut Oil - Cold Pressed",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/23beb417-ba65-444f-bca8-1f700b47fea4_large_198881b1-b48f-4b82-bf73-e13d8847ed8f.jpg?v=1787416527",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "100",
        "organic",
        "extra",
        "virgin",
        "coconut",
        "oil",
        "cold",
        "pressed",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 30.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790291751109",
      "vsf_explanation": "Same organic virgin coconut oil SKU as another size. High in lauric acid but not the C8/C10 MCT profile validated for ketogenic and cognitive protocols. AHA (Sacks 2017) does not recommend for cardiovascular support. Would move to Standard 55+ only if reformulated as fractionated C8/C10 MCT with a disclosed C8:C10 ratio.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "certified-organic-blackstrap-molasses-unsulfured",
      "title": "Certified Organic Blackstrap Molasses - Unsulfured",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e7a46251-8c5c-4ae6-bdb7-61b58275eb94_large_d02d56d9-9ec1-4058-baf9-e22b213638a2.jpg?v=1787416527",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "certified",
        "organic",
        "blackstrap",
        "molasses",
        "unsulfured",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 15.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790291783877",
      "vsf_explanation": "A pantry food product (sugar-refining byproduct) rather than a formulated supplement. It does contain iron, magnesium, and potassium, but per-serving amounts are modest and displaced by ~15 g of sugar per tablespoon. Scored honestly as low-utility for the biohacking framework — food-first nutrition is fine, but there is no clinical evidence base for capsule/food-crossover dosing. Would move to Standard 55+ only if reframed and dosed as a defined mineral source with disclosed mg per serving.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "certified-organic-freeze-dried-tart-cherries",
      "title": "Certified Organic Freeze-Dried Tart Cherries",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/56c431dc-5aa2-44ff-9e46-773f802a957b_large_ebe2707b-bd71-48ab-92e7-2e81f31f801e.jpg?v=1787416527",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "certified",
        "organic",
        "freeze",
        "dried",
        "tart",
        "cherries",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 12.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790291816645",
      "vsf_explanation": "Freeze-dried whole tart (Montmorency) cherries. Concentrate/juice from this cultivar has RCT data for sleep quality via melatonin content (Howatson 2012) and for post-exercise soreness (Bell 2014). Whole freeze-dried fruit is honest and food-like but does not disclose anthocyanin or melatonin content per serving, so dose–response isn't controllable. Would move to Verified 70+ with a standardized anthocyanin percentage or a Montmorency-cherry-extract dosing spec.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "certified-organic-crystallized-ginger",
      "title": "Certified Organic Crystallized Ginger",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ad59329a-b6aa-4bc1-abc7-c995766ff14c_large_5b82fc63-bb79-4fc0-9dc1-2618ea56e8bd.jpg?v=1787416527",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "certified",
        "organic",
        "crystallized",
        "ginger",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 42,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 60,
        "sustainability": 58
      },
      "price": 6.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790291849413",
      "vsf_explanation": "Crystallized (sugar-preserved) ginger is a confection more than a supplement — the sugar coating dilutes the ginger active-ingredient density and adds unfavorable glycemic load. Ginger nausea evidence exists at 500-1500 mg/day but crystallized format doesn't deliver a defined dose. Organic certification is a modest positive. Would move up only as a lower-sugar or ginger-only capsule format.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "100-organic-extra-virgin-coconut-oil-cold-pressed-1",
      "title": "100% Organic Extra Virgin Coconut Oil - Cold Pressed",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/291e7c2e-fa7a-49d1-89e9-66692eb2ac22_large_1340fa09-5632-44fd-a0b2-0bfabc25914d.jpg?v=1787416527",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "100",
        "organic",
        "extra",
        "virgin",
        "coconut",
        "oil",
        "cold",
        "pressed",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 13.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790291882181",
      "vsf_explanation": "Culinary-grade virgin coconut oil, marketed as a wellness fat. It's ~50% lauric acid (a C12 medium-chain) but not the C8/C10 MCT profile studied for ketogenic and cognitive endpoints. The American Heart Association (Sacks 2017) advises against coconut oil for cardiovascular endpoints due to LDL-raising saturated-fat content. Would move to Standard 55+ only if repositioned as a food (which it is) or reformulated as a C8/C10 MCT with disclosed fractionation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-reishi-coffee-colombian-freeze-dried-w-reishi-mushroom",
      "title": "Organic Reishi Coffee Colombian - Freeze-Dried w/Reishi Mushroom",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/dfd78efc-71a2-45b3-8a34-7bbf2fff1b8f_large_eeb78f13-fbe0-40cb-b5ec-001954e32ef0.jpg?v=1787416529",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "reishi",
        "coffee",
        "colombian",
        "freeze",
        "dried",
        "reishi",
        "mushroom",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 55,
        "sustainability": 68
      },
      "price": 15.72,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790293291205",
      "vsf_explanation": "Instant reishi-coffee blend — coffee is the primary caloric/pharmacological experience with reishi as a small add-in. Organic sourcing lifts sustainability slightly. Reishi at coffee-add-in doses is well below any effective beta-glucan supplement level, so the immune claim is more marketing than mechanism. Fine as a novelty beverage; not a serious reishi supplement. Would move up with disclosed reishi mg per serving and dual-extract standardization on the reishi component.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-pumpkin-seed-oil-1000mg-200-softgel-capsules-non-gmo-soyfree-naturally-occurring-phytosterols",
      "title": "NusaPure Pumpkin Seed Oil 1000mg 200 Softgel Capsules (Non-GMO, Soyfree) Naturally Occurring Phytosterols",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6d2aa2a5.jpg?v=1787416530",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "pumpkin",
        "seed",
        "oil",
        "1000mg",
        "200",
        "softgel",
        "capsules",
        "non",
        "gmo",
        "soyfree",
        "naturally",
        "occurring",
        "phytosterols",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 22.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790293323973",
      "vsf_explanation": "Pumpkin seed oil has small-trial support for BPH/urinary symptoms (Vahlensieck 2015) and overactive bladder (Nishimura 2014). 1000mg softgel is a reasonable single-cap dose; studied doses tend toward 320-1600mg/day. Softgel format supports fat-soluble delivery of phytosterols and delta-7 sterols. No standardization percentage or cold-pressed disclosure. Would move to Verified 70+ with named cold-pressed sourcing and phytosterol standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-shiitake-mushroom-10-1-extract-900-mg-200-veggie-capsules-non-gmo-vegan",
      "title": "NusaPure Shiitake Mushroom 10:1 Extract, 900 mg 200 Veggie Capsules (Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-125965v10-Shiitake-Mushroom-3D-01.jpg?v=1787416534",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "shiitake",
        "mushroom",
        "extract",
        "900",
        "200",
        "veggie",
        "capsules",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 21.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790295027909",
      "vsf_explanation": "Shiitake (Lentinula edodes) lentinan has moderate oncology adjunct evidence in Japanese literature but limited RCT support for over-the-counter capsule use. NusaPure 10:1 extract at 900mg is a decent concentrated dose. No lentinan/beta-glucan % disclosed and no fruiting-body vs mycelium distinction — a persistent US mushroom-supplement issue. Would move to Standard 62+ with disclosed beta-glucan and fruiting-body sourcing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-rhodiola-rosea-250mg-180-veggie-capsules-non-gmo-extract-30-1-vegan-gluten-free-bioperine",
      "title": "NusaPure Rhodiola Rosea 250mg 180 Veggie Capsules (Non-GMO, Extract 30:1, Vegan & Gluten-Free) Bioperine",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nusapure-Rhodiola-with-Bioperine-3D-v4-01.jpg?v=1787416539",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "rhodiola",
        "rosea",
        "250mg",
        "180",
        "veggie",
        "capsules",
        "non",
        "gmo",
        "extract",
        "vegan",
        "gluten",
        "free",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 25.74,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790296305861",
      "vsf_explanation": "Rhodiola rosea has moderate RCT support for stress-related fatigue (Panossian 2010 meta, Olsson 2009 for stress-related fatigue with SHR-5 extract). NusaPure 30:1 extract at 250mg is a reasonable concentrated dose but no salidroside/rosavin percentage disclosed — the studied SHR-5 extract is standardized to 3% rosavins/1% salidroside. Would move to Verified 70+ with named standardization and SHR-5 or Rosalin equivalent.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "certified-organic-stevia-extract-with-prebiotic-inulin",
      "title": "Certified Organic Stevia Extract with Prebiotic Inulin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8f9226f8-a0cd-4c74-b479-c91eec8e1432_large_e3d88c2c-6d18-450d-b7d9-4defaca2d260.jpg?v=1787416541",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "certified",
        "organic",
        "stevia",
        "extract",
        "with",
        "prebiotic",
        "inulin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 62,
        "sustainability": 62
      },
      "price": 10.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790297616581",
      "vsf_explanation": "Stevia sweetener bulked with inulin — a reasonable natural sweetener choice with a directional prebiotic benefit. The prebiotic dose per serving is small (typically <1g) so this is a sweetener with a marketing halo, not a functional prebiotic. Would move to Verified with disclosed steviol glycoside percentage and per-serving inulin grams.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-gaba-suitable-for-vegetarian-vegan-non-gmo-1000-mg-240-tablets",
      "title": "NusaPure GABA - Suitable for Vegetarian/Vegan, Non- GMO - 1000 mg - 240 Tablets",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8ec7167e.jpg?v=1787416544",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "gaba",
        "suitable",
        "for",
        "vegetarian",
        "vegan",
        "non",
        "gmo",
        "1000",
        "240",
        "tablets",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 30,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790297845957",
      "vsf_explanation": "Oral GABA has poor blood-brain barrier penetration; most reported effects are attributed to peripheral or gut-brain axis mechanisms rather than direct CNS action (Boonstra 2015 review). PharmaGABA (fermentation-derived) has slightly better small-trial data at 100-200mg. NusaPure sells 1000mg synthetic GABA — high dose of a form that mostly doesn't reach the brain. Would move to Standard 60 with PharmaGABA sourcing and modest 200mg dosing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-st-johns-wort-extract-20-1-suitable-for-vegetarian-vegan-non-gmo-500mg-200-capsules",
      "title": "NusaPure St. John's Wort Extract 20:1 - Suitable for Vegetarian/Vegan, Non- GMO - 500mg - 200 Capsules",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-132578v3--John-Wort-3D-01.jpg?v=1787416550",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "john",
        "wort",
        "extract",
        "suitable",
        "for",
        "vegetarian",
        "vegan",
        "non",
        "gmo",
        "500mg",
        "200",
        "capsules",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 45,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 26.1,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790299320517",
      "vsf_explanation": "St. John's Wort has strong RCT support for mild-to-moderate depression (Linde 2008 Cochrane review), but studied products are hypericin/hyperforin standardized (WS-5570, LI-160). NusaPure doesn't disclose these percentages. Major safety concern: SJW is a potent CYP3A4/P-gp inducer that reduces effectiveness of oral contraceptives, warfarin, HIV meds, transplant drugs, and antidepressants — this critical interaction warning isn't visible on the title. Would move to Verified 70+ with named standardization and prominent interaction warnings.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-wild-yam-root-30-1-extract-100-mg-200-vegan-capsules-women-s-health-hormonal-balance-non-gmo-vegan",
      "title": "NusaPure Wild Yam Root 30:1 Extract, 100 mg 200 Vegan Capsules - Women’s Health & Hormonal Balance - Non-GMO, Vegan",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-133806v2-Wild-Yam-Root-3D-01.jpg?v=1787416555",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "wild",
        "yam",
        "root",
        "extract",
        "100",
        "200",
        "vegan",
        "capsules",
        "women",
        "health",
        "hormonal",
        "balance",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790301319365",
      "vsf_explanation": "Wild yam (Dioscorea villosa) contains diosgenin, but oral diosgenin is not converted to progesterone in humans — this is a persistent marketing myth. RCT evidence for menopausal symptoms is essentially null (Komesaroff 2001 wild yam cream trial found no benefit). 100mg 30:1 extract does not create a phytohormonal effect. Would need diosgenin removed as a claim entirely; the underlying product is largely inert for the marketed use case.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-fenugreek-capsules-50-1-extract-100-mg-200-veggie-caps-non-gmo-vegan",
      "title": "NusaPure Fenugreek Capsules, 50:1 Extract, 100 mg, 200 Veggie Caps, Non-GMO, Vegan",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nusapure-Fenugreek-3d-Render-V3-1.jpg?v=1787416561",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "fenugreek",
        "capsules",
        "extract",
        "100",
        "200",
        "veggie",
        "caps",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 22.85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790302761157",
      "vsf_explanation": "Second NusaPure fenugreek SKU at higher 50:1 concentration but lower absolute mg (100mg = 5g raw-equivalent). No saponin standardization named — critical for testosterone/libido use where Testofen (Fenuside) is the well-studied form (Steels 2011). Lower concentrated dose than typical trials. Would move to Standard 62+ with named branded extract and saponin percentage.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-yucca-root-30-1-extract-100-mg-120-veggie-capsules-yucca-schidigera-non-gmo-vegan",
      "title": "NusaPure Yucca Root 30:1 Extract, 100 mg 120 Veggie Capsules Yucca schidigera Non-GMO, Vegan",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-133967v2-Yucca-Root-3D-01.jpg?v=1787416566",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "yucca",
        "root",
        "extract",
        "100",
        "120",
        "veggie",
        "capsules",
        "yucca",
        "schidigera",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 17.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790304071877",
      "vsf_explanation": "Yucca schidigera saponins have preclinical anti-inflammatory activity used in animal feed additives; human RCT evidence for joint or inflammation outcomes is minimal (small older studies by Bingham 1975 flagged for methodology issues). 100mg of 30:1 extract is a low-moderate dose. No saponin standardization disclosed. Would move to Standard 60+ with modern human trials at studied doses.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-catuaba-bark",
      "title": "Full Spectrum Catuaba Bark",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4d56e5bf-8923-4cd1-9690-0544c1ea90c6_large_53f57ebb-3962-4569-8853-f9ba46bfc313.jpg?v=1787416574",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "catuaba",
        "bark",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 50,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790313279685",
      "vsf_explanation": "Brazilian bark traditionally used as an aphrodisiac. Human clinical evidence is essentially absent — pharmacology is limited to in-vitro and animal work on catuabine alkaloids. 'Full spectrum' means unstandardized whole-bark powder, so dose–response is not controllable. Would move to Standard 55+ with defined alkaloid standardization and any published human safety data; without clinical trials, catuaba stays a low-evidence traditional product.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ph-testing-tape-with-dispenser",
      "title": "pH Testing Tape with Dispenser",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5ae2c47e-160d-44cb-81ba-f4c20bbe58f0_large_5c73c873-e32b-4a1c-ba2b-9306cc321be8.jpg?v=1787416575",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "testing",
        "tape",
        "with",
        "dispenser",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 30,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 45,
        "sustainability": 40
      },
      "price": 5.11,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790313312453",
      "vsf_explanation": "This is litmus/pH tape — a lab supply, not an ingested supplement. It is typically sold alongside alkaline-diet marketing, which conflates urine/saliva pH with systemic acid–base balance, a claim not supported by physiology (Fenton 2011 systematic review of the alkaline-diet hypothesis). Auto-fail as out-of-scope for the Vyvata biohacking rubric.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "multi-without-iron-energy",
      "title": "Multi without Iron +Energy",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d2dc2e81-ab31-483d-b81c-781a37bfe0f4_large_377e63d6-0584-41dc-b9bb-38c72671b92f.jpg?v=1787416575",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "multi",
        "without",
        "iron",
        "energy",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 21.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790313377989",
      "vsf_explanation": "Iron-free multi with 'energy' additions. Iron-free variant is appropriate for adult men and post-menopausal women (Zacharski 2007). 'Energy' framing is marketing-driven. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "tongkat-ali",
      "title": "Tongkat Ali",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/da9796ec-de8e-4cee-8d5a-8993faef8a4a_large_7e60f6ea-cd13-478c-b6b5-81ada06a88dc.jpg?v=1787416575",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tongkat",
        "ali",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 18.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790313443525",
      "vsf_explanation": "Tongkat ali (Eurycoma longifolia). The best-quality evidence — Talbott 2013 — showed modest testosterone increase and cortisol reduction in moderately stressed subjects at 200mg/day of a standardized extract; other trials are smaller and mixed. Standardization to eurycomanone percentage matters heavily for efficacy and is typically not disclosed on generic-tier products. Generally well-tolerated at studied doses. Would move to Verified 70+ with eurycomanone standardization percentage disclosed and named extract source at 200mg/day matching Talbott.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "activated-charcoal",
      "title": "Activated Charcoal",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8a201260-d912-4e8c-be21-78c1b555b396_large_d24c764f-96fb-4b36-b251-4e0f0ca3bc25.jpg?v=1787416575",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "activated",
        "charcoal",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 45,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 13.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790313410757",
      "vsf_explanation": "Activated charcoal has legitimate ER use for acute drug/toxin poisoning (Chyka 2005 AACT position statement, single dose 1g/kg for suitable ingested toxins within 1 hour). It is not appropriate for daily 'detox' use because it non-selectively binds ingested nutrients, medications, and oral contraceptives — creating a real interaction risk if taken near meals or prescriptions (Neuvonen 1993 on drug adsorption). Held at Standard because as a supplement it needs strong timing/interaction disclosure that is typically not on-label. This is a niche acute-use ingredient miscast as a wellness supplement.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "acetyl-l-carnitine",
      "title": "Acetyl L-Carnitine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2378c637-306f-4fe3-8655-c720c6ec7fc8_large_ce1af508-fe9c-493d-b497-e7388f4140a1.jpg?v=1787416575",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "acetyl",
        "carnitine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 66,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 16.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790313476293",
      "vsf_explanation": "Acetyl-L-carnitine (ALCAR) crosses the BBB better than L-carnitine and has moderate evidence for mild cognitive impairment (Montgomery 2003 meta) and diabetic neuropathy (Sima 2005) at 1.5-3g/day. Held below Verified by no branded-source disclosure (Carnipure is the reference material) and no third-party testing published. Would move to Verified 70+ with Carnipure identity and per-lot COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "aloe-vera-skin-soother",
      "title": "Aloe Vera Skin Soother",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f087d5d8-a07b-4760-a5b3-94483965183f_large_ec10a63f-37be-497e-bbe3-3da800536fed.jpg?v=1787416575",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "aloe",
        "vera",
        "skin",
        "soother",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 74,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 4.55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790313509061",
      "vsf_explanation": "Topical aloe vera — modest evidence for burn/wound soothing and mild anti-inflammatory topical effect (Maenthaisong 2007 systematic review for burns). Safe, well-tolerated. Held below Verified by unstated aloe % w/w and no organic or Aloecorp/named-source disclosure. Would move to Verified 70+ with aloe polysaccharide (acemannan) content spec and % w/w.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "acidophilus-apple-pectin",
      "title": "Acidophilus & Apple Pectin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e6c3b1db-0a9d-4011-a666-5207459e8e9e_large_ef274de1-cdcc-4e69-b4ac-ee0b3e25f576.jpg?v=1787416575",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "acidophilus",
        "apple",
        "pectin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 3.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790313640133",
      "vsf_explanation": "Legacy acidophilus + apple-pectin (soluble fiber) combo. This category of budget probiotic typically has low CFU (1-3B) and no strain identification. Apple pectin is a reasonable soluble fiber. Would move to Verified with named acidophilus strain, higher CFU-at-expiration, and disclosed pectin gram dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lactobacillus-acidophilus",
      "title": "Lactobacillus Acidophilus",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c7a5c47d-bfce-4c09-be75-5a9162e8af68_large_5f80b04d-8d8a-48c8-b08c-b529546dc6b7.jpg?v=1787416575",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lactobacillus",
        "acidophilus",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 14.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790313607365",
      "vsf_explanation": "Basic acidophilus — duplicate SKU. Same concerns: generic strain-agnostic labeling limits mapping to RCT evidence. Would move to Verified with strain-level identification and CFU-at-expiration.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "acetyl-l-carnitine-1",
      "title": "Acetyl L-Carnitine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fc578752-e11f-472e-8d61-f8e6d7a4f537_large_0b1ae9a5-1145-4f98-8c22-598eacd9a513.jpg?v=1787416575",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "acetyl",
        "carnitine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 66,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 36.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790313541829",
      "vsf_explanation": "Acetyl-L-carnitine (ALCAR) with moderate MCI evidence (Montgomery 2003 meta) and neuropathy evidence (Sima 2005) at 1.5-3g/day. Held below Verified by no branded-source (Carnipure) identity and no third-party testing published. Would move to Verified 70+ with Carnipure identity and per-lot COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "aloe-vera-gel-whole-inner-leaf",
      "title": "Aloe Vera Gel - Whole Inner Leaf",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d366f888-1e65-4e2c-9987-bb90e6f7c789_large_188230f5-aaa5-4125-85c3-32d4bebfa027.jpg?v=1787416574",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "aloe",
        "vera",
        "gel",
        "whole",
        "inner",
        "leaf",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 60,
        "sustainability": 52
      },
      "price": 12.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790313574597",
      "vsf_explanation": "Inner-leaf aloe gel format for GI mucosal support. Aloin-reduced inner-leaf is the appropriate safety choice per IARC 2B concerns with whole-leaf. Small trials for GI symptom improvement (Langmead 2004). Would move to Verified 70+ with certified aloin <10 ppm and IASC certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mega-tribulus-extract",
      "title": "Mega Tribulus Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5142d0c8-35b7-407d-85bc-ba0b777706fb_large_c712013c-beed-45ba-bf6e-d79988bf3cd0.jpg?v=1787416575",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone",
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mega",
        "tribulus",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 5.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790313705669",
      "vsf_explanation": "Higher-dose ('Mega') tribulus extract, presumably standardized to 45-60% saponins. Testosterone claims in healthy men are not supported by RCTs (Neychev 2005); libido data are mixed. Higher-dose framing may match the ~750mg/day studied range but doesn't overcome the null T-boost evidence base. Would move higher with honest label framing avoiding T-boost claims and disclosed saponin standardization percentage.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "multi-with-iron-energy",
      "title": "Multi with Iron +Energy",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9bce7e59-e239-4808-a34c-3397fedd6ab5_large_2c6cb104-07bf-4fad-a992-5e69ed96064f.jpg?v=1787416575",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "multi",
        "with",
        "iron",
        "energy",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 15.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790313672901",
      "vsf_explanation": "Multi with iron plus 'energy' additions (typically B-complex, ginseng, green tea). Iron-containing multi is appropriate for menstruating women and iron-deficient users; 'energy' additions are marketing more than a defined RCT protocol. Standard tier — legit multi, marketing-driven bundle.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "acerola",
      "title": "Acerola",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/35d1e71e-f552-42d9-b13c-092d1f26a369_large_30beb731-e51b-48e2-92d1-5129ee77fe2e.jpg?v=1787416575",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "acerola",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 7.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790313738437",
      "vsf_explanation": "Acerola cherry (Malpighia emarginata) — one of the highest natural food sources of vitamin C. Delivered as an unstandardized whole-fruit powder, actual vitamin C content per cap is modest (often 25–50 mg) versus an ascorbic-acid supplement at 500–1000 mg. Would move to Verified 70+ with a standardized vitamin C percentage on-label and third-party assay confirmation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-ashwagandha",
      "title": "Full Spectrum Ashwagandha",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7d15f501-3060-4533-9b40-c3f618bb8b11_large_3d3cd5b1-0123-4df0-a474-4eb0af50c8b5.jpg?v=1787416577",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "ashwagandha",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790314459333",
      "vsf_explanation": "Non-standardized ashwagandha root powder ('full spectrum' = whole herb without extract concentration). Whole-root powder is a legitimate traditional form, but almost all positive ashwagandha RCTs use standardized extracts (KSM-66 or Sensoril) at 5-10% withanolides — full-spectrum powder likely delivers 0.1-0.3%. Would move to Verified with a standardized-extract form.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "alpha-lipoic-acid-2-pack",
      "title": "Alpha Lipoic Acid - 2 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/23198f66-ab1d-4622-8212-f79a209e23f9_large_b77b86d7-5c44-489f-8c51-ff6272a47744.jpg?v=1787416577",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alpha",
        "lipoic",
        "acid",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790314492101",
      "vsf_explanation": "Two-pack of Swanson's racemic ALA. Human evidence best documented for diabetic peripheral neuropathy at 600 mg/day (Ziegler 2011, SYDNEY-2). Racemic ALA delivers only half its mass as the biologically preferred R-enantiomer. Would move to Verified 70+ with a stabilized R-ALA (or Na-R-ALA) form and third-party racemization/purity testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bacopa-monnieri-10-1-extract",
      "title": "Bacopa Monnieri - 10:1 Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fb9639bd-9ec3-42c6-8828-ccb32297115c_large_70aa4538-7d72-4d6f-9152-eb0e06473d23.jpg?v=1787416576",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bacopa",
        "monnieri",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 66,
        "sustainability": 55
      },
      "price": 6.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790314524869",
      "vsf_explanation": "10:1 bacopa extract is a concentration ratio rather than a bacoside standardization - concentration ratios don't guarantee that the bacoside content matches the 45-55% material used in Stough 2001 and Roodenrys 2002. The 10:1 designation is more transparent than 'full spectrum' but less rigorous than bacoside-standardized branded extracts. Would move to Verified 70+ with bacoside percentage disclosed (branded Bacognize or CDRI-08 preferred) and dose within studied 300mg range.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "apple-pectin",
      "title": "Apple Pectin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3d0664ae-d3d4-4e6a-bb06-e83521d97c92_large_fb9a01a1-7093-423c-8238-33abd81e9fab.jpg?v=1787416576",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "apple",
        "pectin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 16.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790314557637",
      "vsf_explanation": "Soluble fiber (apple-derived) in capsule form. Human evidence for LDL-lowering and stool bulking at ~10–15 g/day (Brouns 2012) but capsule doses typically deliver 500–1000 mg, well below clinically-studied ranges — you'd need dozens of caps to reach a functional dose. Would move to Standard 60+ if delivered as a bulk powder with per-serving fiber grams disclosed, and to Verified 70+ with clinical-range dosing guidance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "beta-carotene",
      "title": "Beta-Carotene",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/06c52afa-7179-4bdf-8dbe-4f305e41ecaa_large_f3dd561c-cb8c-48b9-8ddf-f16817381f52.jpg?v=1787416578",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beta",
        "carotene",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 20.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790314623173",
      "vsf_explanation": "Standard Swanson beta-carotene softgel. ATBC (1994) and CARET (Omenn 1996) established smoker-lung-cancer risk with synthetic beta-carotene, so this remains a legacy product where natural mixed carotenoids are preferred. Would move to Verified 70+ with natural mixed carotenoids, disclosed profile including lutein/zeaxanthin, and explicit smoker warnings.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "alpha-lipoic-acid",
      "title": "Alpha Lipoic Acid",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2e0848de-1dc5-4f48-bacd-d9f04047e038_large_7544ad6a-1c44-4db6-92f9-b8a86bdfc924.jpg?v=1787416576",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alpha",
        "lipoic",
        "acid",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790314590405",
      "vsf_explanation": "Racemic ALA capsule. Strongest evidence at 600 mg/day for diabetic neuropathy (Ziegler 2011). Racemic delivers half the mass as bioactive R-ALA. Would move to Verified 70+ with an R-ALA (or sodium-R-ALA) form and third-party assay of enantiomer purity.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ashwagandha-vitamin-d-gummies-passion-fruit-orange",
      "title": "Ashwagandha & Vitamin D Gummies - Passion Fruit-Orange",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8103a9ef-0ad4-47b3-930b-f730c752c648_large_b5b9e90a-66de-4cdb-8ac3-d730310623df.jpg?v=1787416578",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular",
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ashwagandha",
        "vitamin",
        "gummies",
        "passion",
        "fruit",
        "orange",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 50,
        "manufacturing": 58,
        "safety": 58,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 10,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790315212997",
      "vsf_explanation": "Ashwagandha (typically KSM-66 or Sensoril extracts at 300-600mg) has stress/cortisol-reduction evidence (Chandrasekhar 2012 Indian J Psychol Med), but gummy formats typically deliver only 100-200mg of unnamed extract — below studied doses. D3 in gummy is similarly under-dosed. Held at low-Standard by likely sub-therapeutic ashwagandha dose, unclear extract standardization (KSM-66 vs generic), and sugar/gummy vehicle concerns. Would move to Verified 70+ with KSM-66 named extract at 300+ mg and non-gummy delivery.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bee-pollen",
      "title": "Bee Pollen",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9ca451cf-f788-4c99-b36c-721f54bc40de_large_c614c0de-637d-46d7-bfec-481555413c8d.jpg?v=1787416578",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bee",
        "pollen",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 45,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 13.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790315245765",
      "vsf_explanation": "Whole bee pollen in capsule form; traditionally marketed for energy and allergy support but with very thin controlled human evidence. Safety score is dragged down by real anaphylaxis risk in pollen-allergic users and by potential contamination with agricultural residues. Would move to Standard 60+ with a named apiary source, pesticide testing, and clear allergen warnings.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "berberine-advanced-enhanced-absorption-featuring-berbevis",
      "title": "Berberine Advanced Enhanced Absorption - Featuring Berbevis",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/70223cdd-784d-48b8-a252-8908b289d4ac_large_237b1c2f-f0bd-484b-92c6-c120308c0205.jpg?v=1787416578",
      "score": 74,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "berberine",
        "advanced",
        "enhanced",
        "absorption",
        "featuring",
        "berbevis",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 76,
        "formulation": 78,
        "manufacturing": 72,
        "safety": 62,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 27.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790315180229",
      "vsf_explanation": "Berbevis is Indena's berberine-phospholipid (phytosome) delivery system, with published pharmacokinetic data showing up to ~10x higher plasma berberine vs standard berberine HCl (Petrangolini 2021). Solves the primary limitation of straight berberine (~1% oral bioavailability). Sits at solid Verified. Would move to Elite with head-to-head RCTs at reduced doses showing non-inferior HbA1c outcomes vs Yin 2008's 1500mg/day and clearer CYP-drug-interaction guidance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-fadogia-agrestis-600mg-tongkat-ali-400mg-150-veggie-caps-non-gmo-made-in-usa-serving-2-vcaps-bioperine",
      "title": "NusaPure Fadogia Agrestis 600mg + Tongkat Ali 400mg - 150 Veggie Caps - Non-GMO, Made in USA, Serving 2 VCaps, BioPerine",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-131412v3-Fadogia-Agretis-plus-Tongkat-3D-01.jpg?v=1787416578",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "fadogia",
        "agrestis",
        "600mg",
        "tongkat",
        "ali",
        "400mg",
        "150",
        "veggie",
        "caps",
        "non",
        "gmo",
        "made",
        "usa",
        "serving",
        "vcaps",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 45,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 23.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790315278533",
      "vsf_explanation": "Fadogia agrestis is a Huberman-podcast-popularized herb with zero human RCT data and legitimate hepatic and testicular-toxicity signals in rat studies (Yakubu 2005, Yakubu 2008). Tongkat Ali has better human evidence (Talbott 2013 for stress/testosterone with Physta extract) but NusaPure doesn't specify the Physta or LJ100 standardization. Combined product carries real safety concerns; would not recommend to users. Would move to Standard 62+ if Fadogia removed and Tongkat kept at named-source (Physta) 200-400mg.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-b12-cyanocobalamin-strawberry-liquid",
      "title": "Vitamin B12 Cyanocobalamin - Strawberry Liquid",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/83ef2c26-ef07-4628-b1a3-49e6175ec8bb_large_38e9cc18-c578-4ced-b59d-426dd161d302.jpg?v=1787416579",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "b12",
        "cyanocobalamin",
        "strawberry",
        "liquid",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 16.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790315311301",
      "vsf_explanation": "Cyanocobalamin liquid form has bioavailability advantages via sublingual absorption (bypassing intrinsic-factor issues in older adults/PPI users), but the non-activated form still requires methylation; methyl- or hydroxycobalamin are preferred (Zhang 2013). Held below Verified by non-bioactive form choice. Would move to Verified 70+ with methylcobalamin reformulation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "apple-cider-vinegar-gummies-strawberry-watermelon",
      "title": "Apple Cider Vinegar Gummies - Strawberry Watermelon",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/500882c8-e89e-4ce8-aab0-8827a0646159_large_f9ed45ac-113d-43c2-aba9-844e65776615.jpg?v=1787416579",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "apple",
        "cider",
        "vinegar",
        "gummies",
        "strawberry",
        "watermelon",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 15.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790315344069",
      "vsf_explanation": "ACV gummies are the weakest ACV form: the postprandial glucose mechanism (Johnston 2013) requires pre-meal contact of acetic acid with food, which capsules/gummies bypass. Sugar-sweetened gummies additionally deliver 2-3g added sugar per serving, partially counteracting any glucose benefit. Would move up only by switching to liquid ACV pre-meal, ideally diluted.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "berberine-4",
      "title": "Berberine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5df805ef-10d4-4890-8524-fd39a68f9a0e_large_e278117d-2265-442e-a088-cbddd02dc9d2.jpg?v=1787416580",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "berberine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 74,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 62,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 23.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790315868357",
      "vsf_explanation": "Straight berberine HCl capsule. Yin 2008 showed berberine 500mg TID was non-inferior to metformin for HbA1c and fasting glucose in T2D; Guo 2016 meta-analysis confirmed the effect. Main limits: ~1% oral bioavailability so the studied 1500mg/day is a lot of capsules; GI side effects common; meaningful CYP3A4 drug interactions. Would move to Verified with berberine HCl % purity (>97%) disclosed and enhanced-absorption forms (dihydroberberine, Berbevis phytosome).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "beta-carotene-1",
      "title": "Beta-Carotene",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1637499a-14e7-48b6-b898-57853f04f984_large_97ff3e2a-1d8e-4d83-b06d-b8120322aea8.jpg?v=1787416580",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beta",
        "carotene",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 11.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790315901125",
      "vsf_explanation": "Generic single-carotenoid softgel used as a provitamin-A source. The ATBC (1994) and CARET (Omenn 1996) trials showed increased lung-cancer risk in smokers taking synthetic beta-carotene, so smoker warnings and a preference for natural mixed carotenoids matter. Would move to Verified 70+ with natural-source (D. salina) mixed carotenoids, disclosed carotenoid profile, and prominent smoker safety warning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "berberine-plus-with-bitter-melon-milk-thistle-3-in-1-formula",
      "title": "Berberine Plus with Bitter Melon & Milk Thistle - 3-in-1 Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33ba7968-9d5b-465e-905b-ef4340eeb7cd_large_17f41fa1-3dcb-4c6d-97fd-a32155217162.jpg?v=1787416581",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "berberine",
        "plus",
        "with",
        "bitter",
        "melon",
        "milk",
        "thistle",
        "formula",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 60,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 17.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790315933893",
      "vsf_explanation": "Berberine (Yin 2008) + bitter melon (mixed evidence for glucose — Fuangchan 2011 was largely null) + milk thistle (silymarin, hepatoprotective and modest glucose signal). Reasonable metabolic-support triad. Berberine's ~1% oral bioavailability is the main limit. Safety: berberine drug interactions (CYP3A4). Would move to Verified with per-active mg disclosure, silymarin percentage, and enhanced-absorption berberine form.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "biotin",
      "title": "Biotin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/11b092bb-7b0c-404c-960c-11c114fbfc04_large_84583dab-67f4-4f97-a934-2e50f880ab83.jpg?v=1787416582",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "biotin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 50,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 10.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790316458181",
      "vsf_explanation": "Biotin has weak clinical evidence for hair/nail outcomes outside deficiency (Patel 2017 review) and interferes with troponin/TSH/cardiac lab assays (FDA 2017 Safety Communication). Held at low-Standard by weak effect-size evidence and lab-interference safety concern rarely warned about on mass-market labels.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "aloe-vera-whole-inner-leaf",
      "title": "Aloe Vera - Whole Inner Leaf",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c947dcef-3ee3-4cfb-8052-cecfbc07d737_large_a5233378-b2c2-4df7-ae16-88016bc46a64.jpg?v=1787416582",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "aloe",
        "vera",
        "whole",
        "inner",
        "leaf",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 60,
        "sustainability": 52
      },
      "price": 22.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790316490949",
      "vsf_explanation": "Inner-leaf aloe vera reduces anthraquinone (aloin) exposure vs whole-leaf preparations — a meaningful safety improvement given IARC 2B classification of aloin. Small RCTs support IBS/UC symptom modulation (Langmead 2004). Would move to Verified 70+ with certified aloin <10 ppm assay and IASC certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "balance-b-50-complex",
      "title": "Balance B-50 Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f1d055ca-85ae-4edb-8d12-f1e651f815d5_large_bb5f7243-8770-4d8d-8817-6ac1738ee9db.jpg?v=1787416582",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "balance",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 23.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790316523717",
      "vsf_explanation": "Legacy 50-mg B-complex pattern with cyanocobalamin, folic acid, and pyridoxine HCl rather than the methylated/active forms preferred in current best practice. Adequate for general repletion but not optimal for MTHFR variants. Would move to Verified 70+ if reformulated with methylcobalamin, 5-MTHF, P-5-P, and a lower B6 dose to reduce risk of neuropathy from long-term high-dose pyridoxine HCl.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-lycopene-lutein-complex-60mg-per-caps-200-veggie-capsules-non-gmo-vegan",
      "title": "NusaPure Lycopene & Lutein Complex 60mg per Caps, 200 Veggie Capsules (Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/135d8407.jpg?v=1787416584",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "lycopene",
        "lutein",
        "complex",
        "60mg",
        "per",
        "caps",
        "200",
        "veggie",
        "capsules",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 29.8,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790317342917",
      "vsf_explanation": "Lycopene + lutein complex has decent evidence for prostate (Chen 2015 lycopene meta) and macular pigment (AREDS2 for lutein). 60mg total is meaningful but the split between the two carotenoids isn't disclosed on the title, making dose validation vs studied levels (lutein 10-20mg, lycopene 15-30mg) impossible. Would move to Verified 70+ with per-carotenoid mg and named sources (FloraGlo lutein, Lyc-O-Mato lycopene).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mega-tribulus-extract-1",
      "title": "Mega Tribulus Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6bd377bf-9b84-472a-9ae4-89d7b2833193_large_b0a4cffd-0d9d-43aa-8665-5c67fe5cb8d4.jpg?v=1787416584",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone",
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mega",
        "tribulus",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 10.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790317375685",
      "vsf_explanation": "Higher-dose ('Mega') tribulus extract, presumably at the 45-60% saponin standardization. Testosterone-boost claims in healthy men are not supported by RCTs (Neychev 2005 — no T change in resistance-trained men); libido data are inconsistent. Higher-dose framing helps match the ~750mg/day studied range but doesn't overcome the null evidence base for T-boosting. Would move higher with honest label framing that doesn't overpromise testosterone effects and full saponin standardization disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "beta-sitosterol-maximum-strength",
      "title": "Beta-Sitosterol - Maximum Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d88451be-547a-4eda-a977-914aea9d79c9_large_3eb27db0-99b7-498d-8251-d03c9f0b3b9a.jpg?v=1787416584",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beta",
        "sitosterol",
        "maximum",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790317408453",
      "vsf_explanation": "Plant sterol used primarily for BPH/prostate symptoms and as a modest LDL-cholesterol modulator. Wilt 1999 (Cochrane review of beta-sitosterol for BPH) supports symptom improvement at 60–130 mg/day of sterols. 'Maximum strength' language is ambiguous without a per-cap sterol mg on label; if it delivers 300–800 mg it's within evidence-based range. Would move to Verified 70+ with a defined sterol content, third-party assay, and clearer differentiation from saw palmetto for prostate-only use.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "balance-b-50-complex-1",
      "title": "Balance B-50 Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d3ad3b39-4802-4ea2-bf7a-da869a40a568_large_e190abff-4c4d-495e-a694-0d170315e2ed.jpg?v=1787416584",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "balance",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 16.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790317441221",
      "vsf_explanation": "Classic 50-mg-across-the-board B-complex — this dosing pattern predates the methylation era and typically uses cyanocobalamin (B12), folic acid (not methylfolate/5-MTHF), and pyridoxine HCl (not P-5-P). Adequate for general B-vitamin insufficiency but suboptimal for the estimated 30–40% of people with MTHFR variants who convert folic acid inefficiently (Long 2018). Would move to Verified 70+ if reformulated with methylcobalamin, 5-MTHF, and P-5-P.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "american-ginseng",
      "title": "American Ginseng",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/27b01f1a-51c5-4a90-896f-5521c366d3f8_large_39994790-57d6-400f-bf62-3b834825ef0e.jpg?v=1787416584",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "american",
        "ginseng",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 58,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 55,
        "sustainability": 58
      },
      "price": 20.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790317473989",
      "vsf_explanation": "American ginseng (Panax quinquefolius) has the strongest immune-specific evidence in the Panax family — the CVT-E002 (COLD-fX) polysaccharide extract has multiple RCTs showing reduced cold incidence in elderly (Predy 2005) and community populations. This generic Swanson SKU doesn't identify the CVT-E002 branded ingredient, so evidence transfer is limited. Held to mid-Standard by that gap. Would move up substantially with CVT-E002 or equivalent standardized polysaccharide-fraction disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "adult-multivitamin-gummies-orange-cherry-strawberry",
      "title": "Adult Multivitamin Gummies - Orange, Cherry, Strawberry",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c2ff2be1-8ece-48bb-9c27-c813ded98bdc_large_ed96c485-0e26-46cb-ad82-01a7a1667b76.jpg?v=1787416584",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "adult",
        "multivitamin",
        "gummies",
        "orange",
        "cherry",
        "strawberry",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 11.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790317506757",
      "vsf_explanation": "Adult gummy multivitamins typically omit iron (safety-positive for men, potential concern for menstruating women), use synthetic non-methylated B forms, and deliver low doses of most nutrients in a sugar/syrup matrix. Content-vs-label variance is well documented in gummy formats (Crawford 2017). Held at low-Standard by delivery-format compromise, non-bioactive B forms, and low nutrient density.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bilberry-fruit",
      "title": "Bilberry Fruit",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/738f060d-47f3-4571-911b-82633b17c483_large_c24b9b50-6db2-48b8-b396-f6ebf9f5b574.jpg?v=1787416585",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bilberry",
        "fruit",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 52,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 55,
        "sustainability": 52
      },
      "price": 11.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790317605061",
      "vsf_explanation": "Whole-fruit bilberry powder (not extract). Anthocyanin content in dried-fruit powder is a fraction of what's in 25%-standardized extracts studied for microcirculation (Kamiya 2013). Would move to Standard 62+ with switch to standardized extract format (25% anthocyanins, 160-320 mg dose).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "alpha-lipoic-acid-1",
      "title": "Alpha Lipoic Acid",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/abc83b1a-46d5-4026-a445-108f04504144_large_47e8a98c-4e88-40ef-9ee1-e1bbb22d09a8.jpg?v=1787416584",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alpha",
        "lipoic",
        "acid",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 15.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790317539525",
      "vsf_explanation": "Universal antioxidant with human evidence for diabetic peripheral neuropathy (Ziegler 2011, SYDNEY-2 at 600 mg/day) and mild insulin sensitivity effects. Generic ALA is a racemic (R/S) mix, and the R-enantiomer is the biologically preferred form. Without stabilized R-ALA or Na-R-ALA on label this stays a standard-tier product. Would move to Verified 70+ with R-ALA (or Na-R-ALA) form, a clear 300–600 mg dose, and third-party purity/racemization testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "astragalus-root-liquid-extract-alcohol-sugar-free",
      "title": "Astragalus Root Liquid Extract - Alcohol & Sugar Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f62905ca-cfa4-4fd3-a23a-54f40a4367bf_large_55658b43-6296-44fc-8f9f-94d709f27168.jpg?v=1787416584",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "astragalus",
        "root",
        "liquid",
        "extract",
        "alcohol",
        "sugar",
        "free",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 58,
        "sustainability": 60
      },
      "price": 7.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790317572293",
      "vsf_explanation": "Alcohol- and sugar-free astragalus liquid extract. Astragalus polysaccharides (APS) — the main immune-relevant active — are water-soluble, so aqueous glycerite extraction is a reasonable delivery choice for this active. No standardization percentage disclosed. Immune-modulator interactions with immunosuppressants remain the main safety consideration. Would move up with APS % standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-asparagus-young-shoots",
      "title": "Full Spectrum Asparagus Young Shoots",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fff00cc3-dbe6-42e8-9236-f7d34bf36f97_large_d6c6e462-5f4a-4c24-9039-931d9026d736.jpg?v=1787416586",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "asparagus",
        "young",
        "shoots",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 50,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 8.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790318424261",
      "vsf_explanation": "Whole-plant asparagus powder in capsule form; a whole-food-in-a-pill format with essentially no controlled human evidence for capsule dosing relative to eating whole asparagus. 'Full spectrum' here means unstandardized whole-plant powder rather than a defined active — you'd get more measurable nutrition from a bowl of asparagus. Would move to Standard 55+ with a defined active (e.g., asparagosides %) and evidence supporting dose, otherwise this stays a low-utility category.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-astragalus-root",
      "title": "Full Spectrum Astragalus Root",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ba215bf6-9840-4fce-ae7f-893d0d4bfa97_large_d8ba08a4-f387-4346-adad-98622fc85be9.jpg?v=1787416586",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "astragalus",
        "root",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 55,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790318457029",
      "vsf_explanation": "Whole-root astragalus — legitimate traditional adaptogen, but the standardized-extract version scores higher because the astragaloside percentage is what matches clinical dosing. Whole-root delivers polysaccharides at variable levels. Immune interactions with immunosuppressants are the main safety flag. Would move up with astragaloside standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "acai-berry",
      "title": "Acai Berry",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4ab71f49-4c4b-41fd-8df7-7475de26c588_large_533f9a26-d18a-43d9-905c-ed528f8ad817.jpg?v=1787416586",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "acai",
        "berry",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 55,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 55,
        "sustainability": 58
      },
      "price": 15.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790318489797",
      "vsf_explanation": "Acai (Euterpe oleracea) berry powder capsule — real anthocyanin content but weak human outcome data. Marketing-driven category (weight loss/detox claims from the 2000s were largely unsupported and led to FTC actions against several brands, though not Swanson). Held to low Standard by weak clinical evidence. Would move up with disclosed anthocyanin percentage and honest marketing framing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "age-related-eye-support-featuring-lutemax-lutein-and-zeaxanthin",
      "title": "Age Related Eye Support - Featuring Lutemax Lutein and Zeaxanthin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7c9fc1ab-905d-41e7-ad14-f88982f306f0_large_848916a0-f376-4917-9b51-6e5d3e9e83ac.jpg?v=1787416587",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "age",
        "related",
        "eye",
        "support",
        "featuring",
        "lutemax",
        "lutein",
        "and",
        "zeaxanthin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 72,
        "manufacturing": 66,
        "safety": 72,
        "transparency": 72,
        "sustainability": 60
      },
      "price": 16.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790318555333",
      "vsf_explanation": "Eye-support blend anchored on Lutemax 2020, the branded lutein+zeaxanthin isomers extract with strong human data — including the LAMA-II (Stringham 2017) trial showing macular pigment optical density and visual-performance gains at 10 mg lutein + 2 mg zeaxanthin. Using a named, clinically-studied raw material is what pushes this Swanson SKU into low-Verified territory. Would move to Verified 75+ with an AREDS2-aligned matrix (zinc, copper, vitamin C, E) at the studied AREDS2 doses and third-party potency verification on-label.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lactobacillus-acidophilus-1",
      "title": "Lactobacillus Acidophilus",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b7567f3e-8b2d-41dc-901e-0fbc976edd3a_large_289ca6de-ef37-48d0-bb57-0c571e90eb81.jpg?v=1787416587",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lactobacillus",
        "acidophilus",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 10.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790318522565",
      "vsf_explanation": "Single-strain acidophilus without strain designation. Meaningful acidophilus RCTs use specific strains like NCFM (Ouwehand 2014); generic acidophilus labeling cannot be linked to that evidence. CFU count and delivery format not visible from the title. Would move to Verified with named strain (e.g., NCFM) and CFU-at-expiration.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "supreme-dhea-complex",
      "title": "Supreme DHEA Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3361f5f4-921a-416d-b44c-b3e585629be4_large_37aaa6ed-db71-444c-9573-9c6df9b7d3e3.jpg?v=1787416588",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "supreme",
        "dhea",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 50,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 8.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790318588101",
      "vsf_explanation": "Multi-ingredient DHEA complex, typically stacking DHEA with pregnenolone, 7-Keto-DHEA, or hormone-modulating botanicals. Stacking steroid precursors compounds the safety profile — aromatization risk in men, cycle disruption in women, and need for lab monitoring in both sexes. Per-active mg disclosure is often unclear in 'complex' formulations. Would move higher with clear per-active mg (avoiding any proprietary-blend structure), mandatory monitoring language, and contraindication warnings — but stacked hormone precursors as OTC self-administration remain a safety flag we can't fully endorse.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ultimate-womens-intimate-performance",
      "title": "Ultimate Women's Intimate Performance",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3fd43520-02c9-485d-ab6e-024682b61116_large_28951486-2a28-4e7a-a455-0ad7ab0d9f7d.jpg?v=1787416589",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "ultimate",
        "women",
        "intimate",
        "performance",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 12.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790319112389",
      "vsf_explanation": "Female libido/intimate-performance blend typically combining maca, damiana, muira puama, and/or L-arginine. Maca has the strongest RCT support (Gonzales 2002 for libido); other actives are traditional aphrodisiacs with scant modern human data. Multi-herb formulas typically under-dose individual actives versus monograph (maca needs 1.5-3g/day for the studied effect). Standardization percentages are typically not disclosed. Would move higher with maca at monograph dose, standardization percentages for herbal actives, and honest label framing that doesn't overpromise where evidence is thin.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bilberry-eyebright-vision-complex",
      "title": "Bilberry Eyebright Vision Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5602cb06-174d-46e6-8db2-f6f4af4941f7_large_3249c641-a328-4f89-a5c4-0c749b8aa1e3.jpg?v=1787416591",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bilberry",
        "eyebright",
        "vision",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 66,
        "transparency": 50,
        "sustainability": 52
      },
      "price": 21.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790319898821",
      "vsf_explanation": "Bilberry-eyebright combination for vision support. Bilberry has modest microcirculation/visual-fatigue evidence (Kamiya 2013); eyebright (Euphrasia officinalis) has traditional use but essentially no controlled clinical evidence. Combination format often obscures per-ingredient dosing. Would move to Standard 62+ with per-herb mg disclosure and bilberry anthocyanin standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bee-propolis",
      "title": "Bee Propolis",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f9dea701-7869-44af-88d3-712936a67fff_large_37bdceec-05c1-477d-897b-2b2f82e175e6.jpg?v=1787416599",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bee",
        "propolis",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 6.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790322749637",
      "vsf_explanation": "Swanson bee propolis capsule — a resinous bee product used traditionally for oral and immune support with modest RCT evidence (Miyata 2019 for URIs; Al-Hariri 2019 review). This product doesn't disclose a standardization percentage for galangin, CAPE, or total flavonoids, which is the single biggest formulation weakness for propolis. Bee-allergy warning is essential and often understated. Would move to Verified 70+ with a standardized flavonoid percentage (e.g., 12% flavones), a named region of origin (Brazilian green vs Chinese vs European), and third-party heavy-metal testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-fenugreek-seed-30-1-extract-400-mg-per-serving-180-veggie-capsules-herbal-supplement-non-gmo-vegan",
      "title": "NusaPure Fenugreek Seed 30:1 Extract, 400 mg per Serving, 180 Veggie Capsules – Herbal Supplement – Non-GMO, Vegan",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-134203v2-OrgFenugreek-3D-01.jpg?v=1787416600",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "fenugreek",
        "seed",
        "extract",
        "400",
        "per",
        "serving",
        "180",
        "veggie",
        "capsules",
        "herbal",
        "supplement",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 21.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790323536069",
      "vsf_explanation": "Fenugreek 30:1 extract at 400mg (~12g raw-equivalent) is a reasonable concentrated format. Studied fenugreek products for testosterone/libido are typically standardized-saponin forms like Testofen (Fenuside, Steels 2011) or Furosap. NusaPure doesn't specify these branded extracts or saponin percentages. Would move to Verified 70+ with named Testofen or Furosap sourcing at studied 500-600mg doses.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "beta-carotene-2",
      "title": "Beta-Carotene",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1e5ae403-c636-4b42-8ef1-804356a5012c_large_64b25d72-d310-4f72-8007-51280885353b.jpg?v=1787416600",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beta",
        "carotene",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 12.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790323568837",
      "vsf_explanation": "Swanson generic beta-carotene, typically a softgel single-carotenoid product used as a provitamin-A source. Evidence is mixed — the ATBC (1994) and CARET (Omenn 1996) trials showed increased lung-cancer risk in smokers taking synthetic beta-carotene, so this is a Standard-tier product with a real safety caveat rather than a modern first-line antioxidant. Formulation is adequate if the softgel is oil-based (aids absorption) but does not disclose whether the carotenoid is natural mixed or synthetic. Would move to Verified 70+ with natural mixed carotenoids (e.g., BetaTene / D. salina), a full carotenoid profile including lutein and zeaxanthin, and clear smoker warnings on label.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-cordyceps-20-1-extract-150-mg-200-veggie-capsules-sinensis-cs-4-non-gmo-vegan-bioperine",
      "title": "NusaPure Cordyceps 20:1 Extract, 150 mg 200 Veggie Capsules (Sinensis CS-4, Non-GMO, Vegan) Bioperine",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-130772v5-Cordyceps-200-vcaps-3D-01.jpg?v=1787416606",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "cordyceps",
        "extract",
        "150",
        "200",
        "veggie",
        "capsules",
        "sinensis",
        "non",
        "gmo",
        "vegan",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 23.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790325010629",
      "vsf_explanation": "CS-4 strain of Cordyceps sinensis is the cultivated form used in most exercise/energy RCTs (Chen 2010 for VO2max, Hirsch 2017 for aerobic performance). NusaPure discloses strain and 20:1 concentration — good transparency. 150mg per capsule is under the typical 1000-3000mg CS-4 daily dose used in trials; users would need multi-cap dosing. Would move to Verified 70+ with higher per-cap mg and disclosed adenosine/cordycepin standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-corn-silk-extract-150-mg-per-caps-200-veggie-caps-100-vegetarian-non-gmo-extract-20-1-vegan",
      "title": "NusaPure Corn Silk Extract 150 mg per Caps - 200 Veggie Caps (100% Vegetarian, Non-GMO, Extract 20:1, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nusapure-Corn-Silk-3D-v7-01.jpg?v=1787416611",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "corn",
        "silk",
        "extract",
        "150",
        "per",
        "caps",
        "200",
        "veggie",
        "caps",
        "100",
        "vegetarian",
        "non",
        "gmo",
        "extract",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 21.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790326649029",
      "vsf_explanation": "Corn silk (Zea mays) has traditional-use support for UTI/edema and minimal modern RCT evidence — a 2014 Iranian trial suggested mild diuretic effect but methodology was limited. NusaPure 20:1 extract at 150mg is a modest dose (~3g raw-equivalent). No maysin or flavonoid standardization. Overall a weak-evidence single-herb product at a low dose, hence the tier drop. Would move to Standard 58+ with modern RCT support and higher dose or standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-grape-seed-extract-800mg-per-caps-200-vegan-capsules-standardized-non-gmo-gluten-free-resveratrol",
      "title": "NusaPure Grape Seed Extract 800mg per Caps, 200 Vegan Capsules, Standardized, Non-GMO, Gluten Free, Resveratrol",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-129222v3-GrapeSeed-_-Resveratrol-20000mg-3D-01.jpg?v=1787416616",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "grape",
        "seed",
        "extract",
        "800mg",
        "per",
        "caps",
        "200",
        "vegan",
        "capsules",
        "standardized",
        "non",
        "gmo",
        "gluten",
        "free",
        "resveratrol",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 24.3,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790328811717",
      "vsf_explanation": "Grape seed extract 800mg is at the higher end of studied doses; OPC-standardized preparations have moderate RCT support for endothelial function and BP (Feringa 2011 meta). NusaPure claims 'standardized' but doesn't disclose OPC percentage on the title. The 'resveratrol' claim is misleading — resveratrol comes from grape skin/knotweed, not seeds. Would move to Verified 70+ with 95% OPC standardization disclosed and clarified resveratrol content or removed claim.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-reishi-mushroom-4-1-extract-900-mg-per-capsule-200-veggie-caps-vegan-non-gmo-gluten-free",
      "title": "NusaPure Reishi Mushroom 4:1 Extract, 900 mg per Capsule 200 Veggie Caps Vegan, Non-GMO, Gluten-Free",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1e7e3101.jpg?v=1787416621",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "reishi",
        "mushroom",
        "extract",
        "900",
        "per",
        "capsule",
        "200",
        "veggie",
        "caps",
        "vegan",
        "non",
        "gmo",
        "gluten",
        "free",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790329860293",
      "vsf_explanation": "Reishi (Ganoderma lucidum) 4:1 extract at 900mg is a relatively weak concentrate for a mushroom category where 8:1 or higher is typical. Reishi has moderate RCT support for fatigue and immune markers (Klupp 2015 Cochrane review noted quality limitations). NusaPure doesn't disclose beta-glucan % or fruiting-body vs mycelium — a critical distinction where many US mushroom supplements underdeliver on active polysaccharides. Would move to Standard 62+ with fruiting-body sourcing and disclosed beta-glucan %.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-green-tea-20-1-extract-1200-mg-180-vegan-capsules-50-egcg-98-polyphenols-80-catechins",
      "title": "NusaPure Green Tea 20:1 Extract, 1200 mg, 180 Vegan Capsules, 50% EGCG, 98% Polyphenols, 80% Catechins",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-127605-Green-Tea-Extract-3D-01.jpg?v=1787416631",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "green",
        "tea",
        "extract",
        "1200",
        "180",
        "vegan",
        "capsules",
        "egcg",
        "polyphenols",
        "catechins",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 45,
        "transparency": 70,
        "sustainability": 50
      },
      "price": 25.3,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790333268165",
      "vsf_explanation": "Green tea extract at 1200mg with 50% EGCG delivers ~600mg EGCG per serving — near or above the EFSA safety threshold of 800mg/day and above levels where hepatotoxicity signals emerge in some users (Yates 2017 review, Hu 2018). NusaPure discloses standardization clearly, which is a genuine plus, but dose safety is a real concern for daily long-term use. Would move to Verified 70+ if reformulated to 300-400mg EGCG per serving with hepatic safety warnings.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "biotin-with-silica-shampoo",
      "title": "Biotin with Silica Shampoo",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/58835160-1a12-41ed-9bb8-80eba5ece242_large_758d9499-5261-4f41-9690-5ed51eec53ef.jpg?v=1787416638",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "biotin",
        "with",
        "silica",
        "shampoo",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 11.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790333825221",
      "vsf_explanation": "Topical hair shampoo with biotin+silica: biotin does not meaningfully absorb through the skin (it's an internal enzymatic cofactor) and topical silica is a texture rather than an active hair-shaft rebuilder. Sits at the edge of the out_of_scope_for_biohacking framing for the target audience. Held in Rejected range by weak topical-efficacy evidence and category-fit concern.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "brewers-yeast",
      "title": "Brewer's Yeast",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c48d3bec-9085-478f-91f0-2ea82bfc4325_large_8805382b-f931-4a71-92f5-41560dcc437d.jpg?v=1787416638",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "brewer",
        "yeast",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 11.56,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790333923525",
      "vsf_explanation": "Brewer's yeast is a whole-food source of B-complex vitamins, chromium, and beta-glucan. Selenium content depends on substrate. Contains yeast — Candida sensitivity or gout (purines) contraindication. Legit food-form supplement but B-vitamin content varies batch to batch. Would move higher with standardized B-vitamin profile and debittered form.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-black-walnut-hulls",
      "title": "Full Spectrum Black Walnut Hulls",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a536dcf3-9e16-4e96-86cd-5cc13ea83393_large_a0d71ecc-1fcf-4cd9-8362-c7959f3dcad9.jpg?v=1787416638",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "black",
        "walnut",
        "hulls",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 58,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 3.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790333890757",
      "vsf_explanation": "Black walnut hulls are a traditional antiparasitic (juglone) with essentially no modern controlled trial evidence. Juglone is a mild cytotoxin at high doses. Tree-nut allergy contraindication. Would need modern clinical evidence to justify a higher tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "brown-seaweed-sodium-alginate-with-cilantro-leaf",
      "title": "Brown Seaweed Sodium Alginate with Cilantro Leaf",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/271cb4fc-5d85-4b33-a7a1-afd15701dfe5_large_4d42c601-7596-4e07-ba43-bb6be813040b.jpg?v=1787416638",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "brown",
        "seaweed",
        "sodium",
        "alginate",
        "with",
        "cilantro",
        "leaf",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 14.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790333857989",
      "vsf_explanation": "Sodium alginate has RCT evidence for reflux (Gaviscon-type antacid effect — Leiman 2017 review). Cilantro is often marketed here for 'heavy-metal chelation' — evidence for that is essentially absent. Iodine content from brown seaweed matters for thyroid. Product name is descriptive (no explicit detox claim in title, so no autofail). Would move higher with iodine disclosure and reflux-specific labeling.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-black-cohosh",
      "title": "Full Spectrum Black Cohosh",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/53e29039-819d-4fe2-baf7-1e73c9409239_large_d1500336-0dd4-4313-9dda-fa6b64d11b0a.jpg?v=1787416638",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "black",
        "cohosh",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 50,
        "transparency": 55,
        "sustainability": 48
      },
      "price": 5.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790333989061",
      "vsf_explanation": "Black cohosh (Actaea racemosa) has RCT evidence for menopausal vasomotor symptoms — the Remifemin extract (Osmers 2005) showed benefit at 40 mg/day. Hepatotoxicity signal in post-marketing surveillance (Teschke 2010) is a genuine safety concern requiring liver-function awareness. Whole-herb without triterpene standardization delivers uncertain active dose vs Remifemin. Would move to Standard 62+ with named Remifemin extract and prominent hepatotoxicity warning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-butchers-broom",
      "title": "Full Spectrum Butcher's Broom",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/382c3ecd-beef-472a-a9bd-51e66650eeaf_large_df332edd-4a9d-4dcf-af4d-0a02c52360f4.jpg?v=1787416638",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "butcher",
        "broom",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 10.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790333956293",
      "vsf_explanation": "Butcher's broom (Ruscus aculeatus) has RCT support for chronic venous insufficiency (Boyle 2003 systematic review). Ruscogenin is the primary active. Whole-plant powder without ruscogenin standardization limits potency. Would move to Verified 70+ with 7-11% ruscogenin standardized extract and clinical-dose disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "buffered-vitamin-c-with-bioflavonoids",
      "title": "Buffered Vitamin C with Bioflavonoids",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8d08a64e-8ffb-4d9a-b42a-a12fdcdd4b78_large_01b51c21-7b9c-41e7-b87a-b2119a0aa2e7.jpg?v=1787416638",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "buffered",
        "vitamin",
        "with",
        "bioflavonoids",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 70,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 13.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790334054597",
      "vsf_explanation": "Buffered vitamin C (mineral ascorbates) with bioflavonoids reduces GI upset and provides plausible absorption synergy (Vinson & Bose 1988). Vitamin C evidence itself is strong (Hemila & Chalker 2013 Cochrane). Held below Verified by unclear total mg and bioflavonoid standardization. Would move to Verified 70+ with elemental mineral breakdown and standardized bioflavonoid mg.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "calcium-carbonate-aspartate-citrate",
      "title": "Calcium Carbonate, Aspartate & Citrate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f9dabbab-0843-44d1-81b4-e8016af9597a_large_b6067580-f21a-48c2-b431-510fd8491f99.jpg?v=1787416638",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "calcium",
        "carbonate",
        "aspartate",
        "citrate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 6.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790334087365",
      "vsf_explanation": "Triple-form calcium blend — carbonate (needs stomach acid, cheap) + aspartate + citrate (best absorbed). Blending forms is a mixed approach; carbonate portion has poor bioavailability in older adults on PPIs (Straub 2007). Standard tier. Would move to Verified with dropping carbonate, adding K2 (Bolland 2015 mitigation).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "beta-carotene-3",
      "title": "Beta-Carotene",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fa37c23e-1d8d-4708-b8d2-17494e2065ef_large_0b7b90d1-cdd0-411e-9437-99e8250c25a0.jpg?v=1787416638",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beta",
        "carotene",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 50,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 27.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790334021829",
      "vsf_explanation": "Beta-carotene supplementation has a documented mortality signal in smokers from the ATBC and CARET trials (Omenn 1996). Mixed-carotenoid formulations are safer than isolated beta-carotene. Synthetic vs natural (D. salina) source is often unclear. Would need natural-source designation and smoker warning to move higher — even then evidence is weak.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bio-fiber-fibersol-2",
      "title": "Bio-Fiber - Fibersol-2",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/db48667f-94b0-4555-a71f-7b18e5e46512_large_dc29ef47-b49c-4ed1-8e1c-198a90cfe39c.jpg?v=1787416638",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bio",
        "fiber",
        "fibersol",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 66,
        "manufacturing": 68,
        "safety": 68,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 12.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790334120133",
      "vsf_explanation": "Fibersol-2 is ADM/Matsutani's branded resistant maltodextrin, one of the better-tested prebiotic fibers (Ye 2015 for postprandial glucose; van den Heuvel 2005). Named branded ingredient supports manufacturing trust. Would move to Verified with a per-scoop dose reaching the studied 5-10g/day range.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bee-pollen-1",
      "title": "Bee Pollen",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2085711d-397d-43d6-a29c-9560cd83d273_large_6c5a11f6-a43f-48a6-b447-403a6d784ed6.jpg?v=1787416639",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bee",
        "pollen",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 52,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 5.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790334185669",
      "vsf_explanation": "Bee pollen is popularly claimed for energy, immunity, and allergy — modern RCT evidence is thin. Real anaphylaxis risk in pollen-allergic individuals. Cross-contamination with pesticides is a concern. Would need clinical trial support and pesticide-free certification to justify a higher tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "calciboost",
      "title": "CalciBoost",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/94517fff-c13b-46cf-9ece-33d0597548a9_large_9f93446b-46ba-4ea9-8a73-acb48321a868.jpg?v=1787416639",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "calciboost",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 4.83,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790334283973",
      "vsf_explanation": "Calcium supplementation has mixed cardiovascular safety data — Bolland 2010 meta-analysis raised MI signal at >1000 mg/day supplemental calcium. Form of calcium (citrate vs carbonate) and co-factors (D3, K2) matter for bone benefit but are not clear from the 'CalciBoost' name. Would move to Verified 70+ with citrate form, D3+K2 co-factors, and dose alignment with the 500-600 mg supplemental range.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-cats-claw",
      "title": "Full Spectrum Cat's Claw",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cd8e5685-bd78-436a-818e-cd4b5211b455_large_d7cc05da-d621-4965-b787-73dae7219417.jpg?v=1787416639",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "cat",
        "claw",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 18.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790334251205",
      "vsf_explanation": "Duplicate cat's claw SKU. Uncaria tomentosa with modest immune/RA RCT signal (Mur 2002). Whole-bark powder without POA % standardization. Would move to Verified 70+ with POA-standardized/TOA-free extract.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-burdock-root",
      "title": "Full Spectrum Burdock Root",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6d41f914-b7d1-4238-b153-5d1bccadf4e1_large_22bda257-476a-41a7-bd06-cb53a068490e.jpg?v=1787416639",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "burdock",
        "root",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 6.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790334218437",
      "vsf_explanation": "Burdock root (Arctium lappa) is a traditional 'blood purifier' and diuretic with minimal modern RCT support. Contains inulin (prebiotic fiber) and lignans. Contamination with belladonna leaf (atropine) has been historically reported — real safety concern in loose herbal supply chains. Would need modern RCT support and sourcing verification to move higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "biotin-gummies-blueberry",
      "title": "Biotin Gummies - Blueberry",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cc6a1f37-2b75-45b1-bd95-fa59d453d6a1_large_7ae8789b-98c6-496b-9457-e50e268b8e83.jpg?v=1787416639",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "biotin",
        "gummies",
        "blueberry",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 48,
        "manufacturing": 58,
        "safety": 48,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 15.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790334316741",
      "vsf_explanation": "Combines the two weakest elements of the category: (1) biotin has minimal clinical evidence for hair/nail outcomes outside true deficiency (Patel 2017) and interferes with troponin/TSH lab assays (FDA 2017), and (2) gummy delivery format adds sugar vehicle and content-vs-label variance risk (Crawford 2017). Held in Rejected range by combined weak evidence, safety-flag gap, and delivery-format concerns.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "blackstrap-molasses-with-iron",
      "title": "Blackstrap Molasses with Iron",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/de7d5f11-a28e-4fba-8a53-ac1a654ee886_large_78fd38d7-f0b9-4e8c-8d5a-284abd2279e2.jpg?v=1787416639",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "blackstrap",
        "molasses",
        "with",
        "iron",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790334382277",
      "vsf_explanation": "Blackstrap molasses is a traditional food source of iron, but per-serving elemental iron is low (~1-2mg per tablespoon) — inadequate for correcting iron deficiency where 65mg+ elemental daily is often needed (Milman 2014). Better viewed as a whole-food adjunct than a targeted iron supplement. Standard tier floor — legit food but under-dosed as clinical iron supplementation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "biotin-with-silica-conditioner",
      "title": "Biotin with Silica Conditioner",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6b84012a-68c0-498e-a501-7e1503ee2c2f_large_e3fe7c0d-7830-42ff-b254-111c329f5eac.jpg?v=1787416639",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "biotin",
        "with",
        "silica",
        "conditioner",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 11.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790334349509",
      "vsf_explanation": "This is a topical hair conditioner, not a biohacking/health supplement — biotin's topical absorption is negligible (it's an internal cofactor), and 'silica' in shampoos/conditioners is generally a texture ingredient with no proven hair-shaft benefit from topical application. Sits at the edge of the out_of_scope_for_biohacking framing. Held in Rejected range by weak topical evidence and category-fit concern with the Vyvata biohacking user.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "calcium-microcrystalline-hydroxyapatite-with-phosphorus",
      "title": "Calcium Microcrystalline Hydroxyapatite with Phosphorus",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4849eaa4-9053-41e6-bb9e-90924ec4809c_large_0e81d260-7308-4996-b70d-f6172a3f84af.jpg?v=1787416639",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "calcium",
        "microcrystalline",
        "hydroxyapatite",
        "with",
        "phosphorus",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 62,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 18.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790334415045",
      "vsf_explanation": "Microcrystalline hydroxyapatite (MCHA) is bovine bone-matrix calcium plus phosphorus and trace bone-building nutrients — has RCT evidence for slowing bone loss in osteoporosis versus carbonate (Castelo-Branco 1999; Ciria-Recasens 2011). Reasonable niche form for bone-focused supplementation. Standard tier upper end. Would move to Verified with K2/D3 co-factoring and disclosed elemental Ca.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "celery-seed-maximum-strength",
      "title": "Celery Seed - Maximum Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b877e342-ffd2-4280-a986-ed8e6bd7796a_large_9a7395b3-1a36-42ac-8fa6-06f39414e03a.jpg?v=1787416640",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "celery",
        "seed",
        "maximum",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 12.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790334447813",
      "vsf_explanation": "Celery seed extract (3-n-butylphthalide) has small RCT signal for BP reduction (Madhavi 2013). 'Maximum strength' is nonspecific — real formulation quality depends on % 3-n-butylphthalide standardization. Would move to Verified 70+ with 85% 3-n-butylphthalide branded extract at clinical dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "certified-organic-baby-powder-talc-free-lavender-scent",
      "title": "Certified Organic Baby Powder Talc Free - Lavender Scent",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/42eea89f-8693-4012-97b6-a73be5303352_large_cb473ae7-f33d-4b0d-b80c-44114574b692.jpg?v=1787416640",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "certified",
        "organic",
        "baby",
        "powder",
        "talc",
        "free",
        "lavender",
        "scent",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 65,
        "manufacturing": 65,
        "safety": 72,
        "transparency": 65,
        "sustainability": 58
      },
      "price": 8.28,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790334480581",
      "vsf_explanation": "Talc-free is a genuine safety upgrade following the Johnson & Johnson talc/ovarian-cancer litigation and asbestos-contamination concerns. Certified organic is a real quality signal for a baby product. Cornstarch or arrowroot base is typical. Legit topical baby product, not a supplement per se. Would move to Verified 70+ with disclosed excipient list and lavender essential oil dilution %.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-chanca-piedra",
      "title": "Full Spectrum Chanca Piedra",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f4019f53-0465-4fa8-b1b4-b9afdf703b04_large_ca1f7c09-a3a2-4073-9a7c-3c53f518203e.jpg?v=1787416640",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "chanca",
        "piedra",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 8.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790334513349",
      "vsf_explanation": "Chanca piedra (Phyllanthus niruri, 'stone-breaker') is a traditional South American herb for kidney and gallbladder stones. Small RCTs suggest modest reduction in stone recurrence (Nishiura 2004). Whole-plant powder without lignan or phyllanthin standardization. Would move higher with % phyllanthin standardization and modern RCT support.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cbd-full-spectrum",
      "title": "CBD Full Spectrum",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/55f4b502-44b0-46ff-b92c-26432461930d_large_f9b28269-2dbd-4364-95bd-2e1faaced64f.jpg?v=1787416641",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cbd",
        "full",
        "spectrum",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 22.75,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790334546117",
      "vsf_explanation": "Full-spectrum CBD has RCT support for treatment-resistant epilepsy (Epidiolex FDA-approved) and anxiety/sleep signal at higher doses (300+ mg). Consumer CBD faces persistent QA issues — 2017 JAMA study found 43% of products mislabeled. Full-spectrum contains trace THC (up to 0.3%). Would move to Verified 70+ with COA per batch, USDA organic hemp source, and named CBD mg per serving.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cbd-full-spectrum-vegan-softgels",
      "title": "CBD Full Spectrum - Vegan Softgels",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/546df4f6-5b53-4ea7-9fc7-aed62c0f1a66_large_7ba6d0fb-b041-4133-9fb2-942e926463c5.jpg?v=1787416641",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cbd",
        "full",
        "spectrum",
        "vegan",
        "softgels",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 30.25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790334611653",
      "vsf_explanation": "Vegan softgels are a small formulation upgrade for CBD (algae-derived carrier vs bovine gelatin). Same FDA-approved epilepsy evidence + anxiety signal. Consumer CBD requires per-batch COA transparency for label-content confidence. Would move to Verified 70+ with COA per batch and USDA organic hemp sourcing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "calcium-citrate-complex",
      "title": "Calcium Citrate Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/44e7ac84-2d5c-4d07-bcf0-d39999746618_large_18d58314-cfd7-47c2-8653-e31ba03d6629.jpg?v=1787416641",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "calcium",
        "citrate",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 24.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790334578885",
      "vsf_explanation": "Duplicate SKU of calcium citrate complex. Preferred calcium form (Straub 2007) with typical co-factors. Standard tier. Would move to Verified with K2 co-factoring (Bolland 2015 mitigation).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cbd-full-spectrum-roll-on-mint",
      "title": "CBD Full Spectrum Roll-On - Mint",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/51c3c5c0-be05-4e00-a2f1-eb78cf592643_large_23934d1e-0a11-427a-994e-38377f616939.jpg?v=1787416643",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cbd",
        "full",
        "spectrum",
        "roll",
        "mint",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790335103173",
      "vsf_explanation": "Topical CBD roll-on for localized joint/muscle discomfort. Skin penetration of cannabinoids from a topical is poorly characterized and clinical evidence for musculoskeletal pain from topical CBD is very limited. Personal-care format at the edge of Vyvata's supplement scope. No public per-batch COA. Would move up with clinical transdermal delivery data and per-batch COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chickweed",
      "title": "Chickweed",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/34f814e6-0da7-4517-a28e-0fe07cb346ff_large_6d9bcdff-9ac9-4be0-8dc3-0f37942b0f0c.jpg?v=1787416642",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chickweed",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 8.45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790335135941",
      "vsf_explanation": "Chickweed (Stellaria media) is a traditional demulcent and weight-loss folk herb with essentially no modern RCT support. Legit safe wild green but insufficient evidence base. Would need controlled trial evidence to justify Standard-tier positioning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "calcium-citrate-plus-magnesium",
      "title": "Calcium Citrate Plus Magnesium",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a0d18c23-a255-4e45-a5ad-cb752cb22ecf_large_eb447bd0-07cd-49cf-b9fe-cdd5780a0541.jpg?v=1787416642",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "calcium",
        "citrate",
        "plus",
        "magnesium",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 66,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 13.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790335201477",
      "vsf_explanation": "Calcium citrate + magnesium pairing — citrate is preferred calcium form (Straub 2007) and magnesium is a helpful co-factor. Standard tier upper end. Would move to Verified with K2 addition to address cardiovascular concerns from isolated calcium supplementation (Bolland 2015) and disclosed magnesium form.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-catuaba-bark-1",
      "title": "Full Spectrum Catuaba Bark",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/93eb3fc5-10bf-4150-bb11-facbf883bd00_large_e4c1f792-b4b2-4d3c-bf50-1927bb36283e.jpg?v=1787416643",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "catuaba",
        "bark",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 58,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 9.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790335168709",
      "vsf_explanation": "Catuaba (Trichilia catigua) is a traditional Amazonian libido/nervous-system herb with essentially no RCT evidence. Marketed as aphrodisiac without support. Would need clinical trial data to move higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-choline-bitartrate-suitable-for-vegetarian-vegan-non-gmo-650-mg-200-capsules",
      "title": "NusaPure Choline Bitartrate - Suitable for Vegetarian/Vegan, Non - GMO - 650 mg 200 Capsules",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4e6565e6.jpg?v=1787416645",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "choline",
        "bitartrate",
        "suitable",
        "for",
        "vegetarian",
        "vegan",
        "non",
        "gmo",
        "650",
        "200",
        "capsules",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790335987909",
      "vsf_explanation": "Choline bitartrate is the cheapest choline form — poorly bioavailable for CNS use compared to alpha-GPC or CDP-choline. It works for baseline choline adequacy (Zeisel 2009) but not for nootropic effect. 650mg bitartrate delivers ~270mg elemental choline, meaningful vs the 550mg AI for men. NusaPure discloses the specific form clearly, which is a transparency plus. Would move to Verified 70+ if reformulated as alpha-GPC or Cognizin CDP-choline for cognitive applications.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-cats-claw-1",
      "title": "Full Spectrum Cat's Claw",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8b0a6cd4-b0d9-4572-b992-cff0abb1ea33_large_a88e7952-b725-4e34-ae19-09d43d359f9b.jpg?v=1787416646",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "cat",
        "claw",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790336020677",
      "vsf_explanation": "Cat's claw (Uncaria tomentosa) has modest RCT evidence for RA and immune support (Mur 2002). Whole-bark powder without POA (pentacyclic oxindole alkaloid) standardization delivers uncertain actives. TOA-content matters (should be minimized). Would move to Verified 70+ with POA-standardized/TOA-free extract.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-shea-butter",
      "title": "Organic Shea Butter",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/782db5f2-7933-4bcc-909e-890654ab9702_large_bdcdfc64-2062-4652-bf1e-d72977750836.jpg?v=1787416646",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "shea",
        "butter",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 8.21,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790336053445",
      "vsf_explanation": "Organic shea butter is a legit topical emollient with modest RCT evidence for skin barrier function. Organic certification is a real signal. Ethical sourcing from West African cooperatives varies. Would move to Verified 70+ with fair-trade or women's-cooperative sourcing disclosure and unrefined format specification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "just-one-multi-without-iron",
      "title": "Just One Multi - Without Iron",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4a3d542e-6aa9-418d-8482-87c21b1cdd03_large_77b308aa-b490-4cc2-bbf8-0f57dae193e2.jpg?v=1787416646",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "just",
        "one",
        "multi",
        "without",
        "iron",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 8.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790336086213",
      "vsf_explanation": "Once-daily iron-free multivitamin — appropriate for adult men and post-menopausal women (Zacharski 2007). Convenient adherence delivery. Standard tier — compressed single-tablet format limits dose ceiling. Would move to Verified with methylated B forms and named-chelate minerals.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "calcium-citrate-complex-1",
      "title": "Calcium Citrate Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cc139174-dae1-4096-b431-07982a64bfca_large_8c0bf85b-c7dd-4294-a92d-38de179266d1.jpg?v=1787416647",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "calcium",
        "citrate",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790336151749",
      "vsf_explanation": "Calcium citrate complex — preferred calcium form (Straub 2007) with typical co-factors (magnesium, D3). Standard tier. Would move to Verified with K2 co-factoring to mitigate cardiovascular concerns from isolated calcium supplementation (Bolland 2015).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "choline-inositol",
      "title": "Choline & Inositol",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/27a2f964-1865-4c24-b958-854ef426c279_large_83afd0e2-503f-496d-bd80-36231bf2c259.jpg?v=1787416646",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "choline",
        "inositol",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 25.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790336184517",
      "vsf_explanation": "Classic choline + inositol pairing - both are lipotropic and neurological-support nutrients. Choline (likely bitartrate here) supports acetylcholine synthesis and liver PC pools; inositol has small evidence for OCD and anxiety at doses far higher than typical supplemental amounts (12-18g/day in Fux 1996). Bitartrate is less BBB-permeable than alpha-GPC or CDP-choline. Safety is very good. Would move to Verified 70+ with alpha-GPC or CDP-choline form and disclosed dose within functional ranges.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-chasteberry-fruit",
      "title": "Full Spectrum Chasteberry Fruit",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/582c2977-42f6-465e-8c2a-3bb559816b90_large_378cbad3-91bb-419f-b970-9407c5bda41e.jpg?v=1787416647",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "chasteberry",
        "fruit",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 58,
        "sustainability": 52
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790336217285",
      "vsf_explanation": "Chasteberry (Vitex agnus-castus) has moderate PMS evidence (Schellenberg 2001 RCT at 20 mg/day of a specific extract). Traditional use for cycle regulation and mastalgia. Whole-fruit powder delivers less consistent dopaminergic action than the studied Ze 440 extract. Would move to Verified 70+ with named Ze 440 extract or equivalent standardization at 20 mg dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bcaa-branched-chain-amino-acids-fortified-with-vitamin-b6",
      "title": "BCAA Branched-Chain Amino Acids - Fortified with Vitamin B6",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/54253636-279d-4b9a-8b2e-8b93aa689a64_large_75904b5b-c573-4935-9e72-7b505400feac.jpg?v=1787416647",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bcaa",
        "branched",
        "chain",
        "amino",
        "acids",
        "fortified",
        "with",
        "vitamin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 9.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790336250053",
      "vsf_explanation": "BCAA supplementation shows equivocal muscle-protein-synthesis benefit in the setting of adequate dietary protein (Wolfe 2017 review), and EAAs (essential amino acids) are generally preferred for MPS support. B6 fortification is a marginal add. Held below Verified by weak effect-size evidence vs whole-protein/EAA alternatives, unclear leucine:isoleucine:valine ratio, and B6 peripheral-neuropathy risk at chronic higher doses (dell'Aquila 2018).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cbd-sleep-gummies-berry",
      "title": "CBD + Sleep Gummies - Berry",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/01a72b4e-52f3-4ac2-af87-3d0cc2a7d212_large_efbc6dfa-533a-41a9-adfd-58288cdae5ce.jpg?v=1787416647",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cbd",
        "sleep",
        "gummies",
        "berry",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 50,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 50.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790336282821",
      "vsf_explanation": "CBD + melatonin gummies combine two actives with limited independent sleep RCT support at typical gummy doses. CBD-drug interaction potential (CYP3A4/2C19 inhibition, particularly relevant with warfarin, statins, and immunosuppressants) is chronically under-disclosed on gummy formats. Gummies encourage accidental pediatric access to melatonin (Lelak 2022 CDC data). Independent dose-verification analyses (Erland 2020 JAMA) have found substantial melatonin content deviation in gummies. Would move to Verified 70+ with third-party dose verification, prominent CBD drug-interaction warning, and child-resistant packaging.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "calcium-citrate-vitamin-d3",
      "title": "Calcium Citrate & Vitamin D3",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0f993e73-b3ca-48d9-8442-7099583c4adc_large_716da8d8-b995-4a13-b5e9-8ca9693c7c55.jpg?v=1787416647",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "calcium",
        "citrate",
        "vitamin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 68,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 24.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790337003717",
      "vsf_explanation": "Calcium citrate has meaningfully better bioavailability than carbonate, particularly in low-stomach-acid users (older adults, PPI users) — Heaney 1999 J Clin Endocrinol Metab. Pairing with D3 is nutritionally appropriate. Held below Verified by absence of K2 cofactor to direct calcium into bone rather than soft tissue, unclear elemental Ca mg, and no magnesium co-nutrient. Would move to Verified 70+ with K2-MK7 + Mg co-formulation and clear elemental Ca disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "calcium-vanilla-cream-chewable",
      "title": "Calcium - Vanilla Cream Chewable",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/68e352d8-8a20-46db-926b-867f71723dec_large_9ab8542d-f784-40fb-9c0e-56587d9c316b.jpg?v=1787416647",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "calcium",
        "vanilla",
        "cream",
        "chewable",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 6.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790337036485",
      "vsf_explanation": "Chewable calcium is typically carbonate-based (higher elemental Ca to fit in a smaller chewable) with added sugar/flavoring. Carbonate absorption depends on stomach acid (Straub 2007) — poor choice for older adults on PPIs. Isolated calcium without K2 raises cardiovascular concerns (Bolland 2015). Standard tier — convenience delivery, older-adult utility limitations.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "biotin-1",
      "title": "Biotin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/27d7d477-0c1b-43aa-bcab-0891048e84c3_large_bb24bf19-884b-445d-abbc-e9750faff25f.jpg?v=1787416647",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "biotin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 50,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 4.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790337069253",
      "vsf_explanation": "Biotin has weak clinical evidence for hair/nail outcomes outside true deficiency (Patel 2017 review), and high-dose biotin interferes with troponin, TSH, thyroid, and cardiac lab assays (FDA Safety Communication 2017). Held at low-Standard by weak effect-size evidence and lab-interference safety concern without adequate warning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cascara-sagrada",
      "title": "Cascara Sagrada",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f55c3558-8c95-4212-8ee7-5dbd7a893258_large_12490f6f-cb8b-4caf-b8fa-ab7337e20ae6.jpg?v=1787416647",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cascara",
        "sagrada",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 40,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 9.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790337102021",
      "vsf_explanation": "Cascara sagrada is a stimulant laxative (anthraquinone). FDA removed it from OTC laxative status in 2002 due to insufficient safety data — hepatotoxicity and colon-melanosis concerns with chronic use. Legit historical laxative but current safety framing has been downgraded. Would not recommend for supplement channel use.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cayenne-40-000-capsaicin-hu-g",
      "title": "Cayenne - 40,000 Capsaicin HU/G",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0939601e-67b9-449c-bc46-f5b8ecee5867_large_18ae16cd-d2a8-44bf-a349-e6a33f5918a8.jpg?v=1787416647",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cayenne",
        "000",
        "capsaicin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 68,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 72,
        "sustainability": 50
      },
      "price": 17.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790337134789",
      "vsf_explanation": "40,000 HU/g cayenne is a disclosed heat/potency standardization — a real transparency and formulation win. Cayenne/capsaicin has modest evidence for metabolic and cardiovascular effects (Whiting 2014). GI irritation and reflux caution; not for peptic ulcer. Would move to Verified 70+ with clinical-dose capsaicin mg per serving disclosed and heat-encapsulation format.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "berberine-complex-with-cinnamon-gymnema-fenugreek",
      "title": "Berberine Complex with Cinnamon, Gymnema & Fenugreek",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ab49dfaf-d5c9-4d00-a4f2-76d7f3b5ae92_large_8ae0e403-c16e-4791-ad6a-7fda88547969.jpg?v=1787416648",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "berberine",
        "complex",
        "with",
        "cinnamon",
        "gymnema",
        "fenugreek",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 60,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 30.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790337200325",
      "vsf_explanation": "Berberine (Yin 2008, metformin-comparable at 500mg TID) paired with three other blood-glucose herbs: cinnamon (Costello 2016 meta-analysis, modest fasting glucose reduction), Gymnema sylvestre (small trials for HbA1c) and fenugreek (Neelakantan 2014 meta-analysis). Rational polyherbal design. Safety: berberine interacts with CYP3A4-metabolized drugs. Would move to Verified with per-herb standardization (berberine HCl >97%, cinnamon type A vs C. cassia, gymnemic acids %) and dose disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "buffered-c-magnesium-ascorbate-powder-unflavored",
      "title": "Buffered C Magnesium Ascorbate Powder - Unflavored",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fa10eaec-4740-46b6-9c79-91aa02a924eb_large_ad7aa097-e7f8-4548-8423-c05aa93e86ed.jpg?v=1787416647",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "buffered",
        "magnesium",
        "ascorbate",
        "powder",
        "unflavored",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 15.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790337233093",
      "vsf_explanation": "Magnesium ascorbate is a buffered non-acidic vitamin C form — gentler on stomach and teeth than ascorbic acid, useful for high-dose C protocols. Delivers some elemental magnesium as a side benefit. Vitamin C RCT support for cold duration is modest (Hemila 2013 meta-analysis). Standard tier upper end — clean single-mineral-buffered C. Would move up with third-party verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "calcium-citrate",
      "title": "Calcium Citrate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/649692eb-6e83-4e50-ba2d-443fbaa16607_large_39d3f57c-e797-4e44-ab95-85df1cc905b2.jpg?v=1787416648",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "calcium",
        "citrate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 66,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 10.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790337265861",
      "vsf_explanation": "Calcium citrate — preferred calcium form for absorption independent of stomach acid, better bioavailability than carbonate (Straub 2007), especially for older adults on PPIs. Standard tier. Would move to Verified with K2 co-factoring to address cardiovascular concerns (Bolland 2015) and D3 for absorption.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-butea-superba-root",
      "title": "Full Spectrum Butea Superba Root",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0828dff7-3a3e-4992-a582-01e60fa067ba_large_1f0387f5-34a3-4eed-9e2e-fc855decebfb.jpg?v=1787416649",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "butea",
        "superba",
        "root",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 50,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 6.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790337757381",
      "vsf_explanation": "Butea superba is a Thai libido/testosterone herb with minimal controlled trial evidence — mostly small biomarker studies. Case reports of hepatotoxicity and hormonal disruption. Not for cardiovascular disease or with hormone-affecting drugs. Would need modern safety/efficacy data to move higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "boswellia",
      "title": "Boswellia",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0dcd8f7b-f49e-4d22-9ae9-9985b9a1e8be_large_cb094c20-0c08-4ad3-b141-24e1e8d9751d.jpg?v=1787416650",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "boswellia",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 12.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790337790149",
      "vsf_explanation": "Boswellia serrata has RCT evidence for OA joint pain (Kimmatkar 2003; Sengupta 2010) at 300-500 mg standardized to 60% boswellic acids. Generic Swanson boswellia without % standardization delivers unpredictable actives. Would move to Verified 70+ with AKBA-enriched (5-Loxin/ApresFlex) branded extract.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-gotu-kola-capsules-20-1-extract-200-mg-per-veggie-caps-200-count-non-gmo-vegan-bioperine-traditional-herb-extract",
      "title": "NusaPure Gotu Kola Capsules 20:1 Extract, 200 mg Per Veggie Caps, 200 Count, Non-GMO, Vegan, Bioperine - Traditional Herb Extract",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-131429v3-Gotu-Kola-3D-01.jpg?v=1787416652",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "gotu",
        "kola",
        "capsules",
        "extract",
        "200",
        "per",
        "veggie",
        "caps",
        "200",
        "count",
        "non",
        "gmo",
        "vegan",
        "bioperine",
        "traditional",
        "herb",
        "extract",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 27.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790338314437",
      "vsf_explanation": "Gotu kola (Centella asiatica) has moderate evidence for venous insufficiency (Chong 2013 meta) and small trials for cognition and anxiety. NusaPure 20:1 extract at 200mg is ~4g raw-equivalent, decent dose but no triterpene (asiaticoside/madecassoside) standardization disclosed — the meaningful actives. Piperine addition unlikely to help triterpene absorption. Would move to Verified 70+ with triterpene-standardized extract at Centellicum/TECA-equivalent doses.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "buffered-vitamin-c",
      "title": "Buffered Vitamin C",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9269157d-110e-4c55-9d24-f1cd6c0a3f6f_large_f2dfc31a-3a9b-459a-97ca-d042dfedb660.jpg?v=1787416652",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "buffered",
        "vitamin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 17.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790338347205",
      "vsf_explanation": "Buffered vitamin C (mineral ascorbates) reduces GI upset at higher doses vs plain ascorbic acid — a legitimate formulation improvement for daily 500-1000mg supplementation. Held below Verified by unclear mg and mineral breakdown from title. Would move to Verified 70+ with elemental Ca/Mg/K disclosure and specific total ascorbate mg.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "buffered-vitamin-c-with-bioflavonoids-1",
      "title": "Buffered Vitamin C with Bioflavonoids",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/16d98a74-00de-4f74-9b91-c01455cff2e8_large_141e0172-cb02-4c00-bc49-983b8b5177df.jpg?v=1787416653",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "buffered",
        "vitamin",
        "with",
        "bioflavonoids",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 70,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 25.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790338838725",
      "vsf_explanation": "Buffered vitamin C (typically mineral ascorbates — calcium/magnesium/potassium ascorbate) reduces GI upset at higher doses and offers a gentler pH, useful for daily 500-1000mg supplementation. Bioflavonoid pairing supports plausible absorption synergy (Vinson & Bose 1988). Held below Verified by unclear mg total and unspecified bioflavonoid mg. Would move to Verified 70+ with clear elemental Ca/Mg breakdown and standardized bioflavonoid content.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-hibiscus-flower-10-1-extract-500-mg-200-vegetarian-caps-non-gmo-vegan",
      "title": "NusaPure Hibiscus Flower 10:1 Extract, 500 mg 200 Vegetarian Caps (Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-127154v8-Hibiscus-3D-01.jpg?v=1787416659",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "hibiscus",
        "flower",
        "extract",
        "500",
        "200",
        "vegetarian",
        "caps",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 25.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790340182213",
      "vsf_explanation": "Hibiscus sabdariffa has consistent RCT support for mild blood-pressure reduction (McKay 2010, Serban 2015 meta), typically via tea infusions of 3-5g dried calyx or standardized extract. NusaPure 10:1 extract at 500mg is roughly 5g raw-equivalent — a reasonable dose. No anthocyanin standardization disclosed. Capsule format lacks the diuretic component of the tea. Would move to Verified 70+ with anthocyanin % standardization and named clinical dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chewable-papaya-plus-natural-fruit-flavor",
      "title": "Chewable Papaya Plus - Natural Fruit Flavor",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0d91a94f-fe16-4a21-8b20-d2c2f5254789_large_334cb7e9-a874-4e27-9c3f-e2bf6a07f238.jpg?v=1787416659",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chewable",
        "papaya",
        "plus",
        "natural",
        "fruit",
        "flavor",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 8.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790340214981",
      "vsf_explanation": "Chewable papaya enzyme tablets — papain is a proteolytic enzyme with mild digestive-support signal but modest RCT evidence at capsule doses. Chewable format often includes sugar or sorbitol as excipients. Would move higher with papain activity units disclosed and sweetener transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "calcium-lactate",
      "title": "Calcium Lactate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/58b865cc-6a17-4c5a-b370-722f1930d78f_large_f8bfea27-77fe-496f-9f60-75349aa51c1d.jpg?v=1787416661",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "calcium",
        "lactate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 3.7,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790340837573",
      "vsf_explanation": "Calcium lactate — moderate elemental calcium content (~13%), moderate absorption. Less studied than citrate. Isolated high-dose calcium supplementation without K2 raises cardiovascular concerns (Bolland 2015). Standard tier — legit but not top-choice form.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-grass-fed-beef-organ-complex-220-capsules-pasture-raised-with-desiccated-liver-kidney-pancreas-heart-spleen-soyfree-non-gmo-bioperine",
      "title": "NusaPure Grass Fed Beef Organ Complex | 220 Capsules | Pasture Raised | with Desiccated Liver, Kidney, Pancreas, Heart, Spleen | Soyfree Non-GMO, Bioperine",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5c665b87.jpg?v=1787416665",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "grass",
        "fed",
        "beef",
        "organ",
        "complex",
        "220",
        "capsules",
        "pasture",
        "raised",
        "with",
        "desiccated",
        "liver",
        "kidney",
        "pancreas",
        "heart",
        "spleen",
        "soyfree",
        "non",
        "gmo",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 35.25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790342541509",
      "vsf_explanation": "Ancestral-eating organ complex following the Ancestral Supplements template. Evidence base is essentially preclinical and rationalist — organ meats contain concentrated retinol, B12, heme iron, CoQ10, and cofactors, but no RCTs support the pill-form 'complex' for named outcomes. Country of origin (pasture-raised Argentina vs NZ vs US) not specified; freeze-dried vs desiccated processing not detailed. Would move to Standard 62 with named single-source origin, sterilization method, and heavy-metal/pathogen testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-white-mulberry-leaf-extract-10-1-extract-500-mg-180-veggie-caps-vegetarian-bioperine",
      "title": "NusaPure White Mulberry Leaf Extract 10:1 Extract, 500 mg 180 Veggie Caps (Vegetarian, Bioperine)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-130766v5-NusaPure-Mulberry-Bioperine-3D-01.jpg?v=1787416672",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "white",
        "mulberry",
        "leaf",
        "extract",
        "extract",
        "500",
        "180",
        "veggie",
        "caps",
        "vegetarian",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 23.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790344638661",
      "vsf_explanation": "White mulberry leaf (Morus alba) contains 1-deoxynojirimycin (DNJ), an alpha-glucosidase inhibitor with moderate RCT support for post-meal glucose blunting (Kim 2015, Wang 2018). NusaPure discloses 10:1 extract at 500mg but no DNJ standardization — the meaningful active for glycemic outcomes. Would move to Verified 70+ with named DNJ standardization (Reducose or similar) and post-meal glucose trial-matched dosing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-turkey-tail-mushroom-capsules-10-1-extract-1200-mg-200-vcaps-non-gmo-gluten-free-bioperine",
      "title": "NusaPure Turkey Tail Mushroom Capsules, 10:1 Extract, 1200 mg, 200 Vcaps, Non-GMO, Gluten Free, Bioperine",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/nusapure_turkeytail_a1_blue-PET.jpg?v=1787416680",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "turkey",
        "tail",
        "mushroom",
        "capsules",
        "extract",
        "1200",
        "200",
        "vcaps",
        "non",
        "gmo",
        "gluten",
        "free",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 25.4,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790345916613",
      "vsf_explanation": "Turkey tail (Trametes versicolor) PSK/PSP polysaccharides have been used as adjuncts in Japanese/Chinese oncology (Sakamoto 2006 meta showed adjunctive PSK survival benefit in gastric cancer). NusaPure lists 1200mg 10:1 extract but no beta-glucan percentage disclosed — the meaningful active. Piperine (bioperine) doesn't improve mushroom-polysaccharide absorption meaningfully. Would move to Verified 70+ with disclosed beta-glucan % (target 30%+) and fruiting-body vs mycelium clarification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-uva-ursi-10-1-extract-450-mg-200-vegetarian-caps-non-gmo-vegan-bearberry",
      "title": "NusaPure Uva Ursi 10:1 Extract, 450 mg 200 Vegetarian caps (Non-GMO, Vegan) Bearberry",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nusapure-Uva-Ursi-3D-v7-01.jpg?v=1787416686",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "uva",
        "ursi",
        "extract",
        "450",
        "200",
        "vegetarian",
        "caps",
        "non",
        "gmo",
        "vegan",
        "bearberry",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 22.41,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790347849925",
      "vsf_explanation": "Uva ursi (bearberry) has traditional-use support for UTI prevention through arbutin/hydroquinone; a UK RCT (Moore 2019) showed non-inferiority to antibiotics for uncomplicated UTIs at short duration. Long-term use raises hepatotoxicity concerns from hydroquinone exposure — usage should be capped at ~1 week. NusaPure discloses 10:1 ratio (~4.5g dried herb equivalent) but no arbutin standardization %. Would move to Standard 65+ with standardized arbutin content and clear duration warning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chondroitin-sulfate",
      "title": "Chondroitin Sulfate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2286d77b-f157-4427-ba28-f5aaebdae80c_large_5afbc335-0158-4307-84f2-65f24a41ce2c.jpg?v=1787416694",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chondroitin",
        "sulfate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 17.3,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790349750469",
      "vsf_explanation": "Standalone chondroitin sulfate — the correct salt form. GAIT (Clegg 2006) showed benefit for moderate-severe OA subgroup at 1200 mg/day; Reichenbach 2007 meta-analysis showed only modest effect. Chondroitin has a documented adulteration/quality problem (Volpi 2007) making third-party purity testing genuinely important. Held below Verified by no COA disclosure at label. Would move to Verified 70+ with independent COA and origin-species disclosure (bovine trachea vs marine).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cbd-gummies-red-raspberry",
      "title": "CBD Gummies - Red Raspberry",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/89f34c15-2894-40e0-8bb0-fa5cc1a96b31_large_e5522e9e-54c6-40a9-8852-4f3af077aab3.jpg?v=1787416693",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cbd",
        "gummies",
        "red",
        "raspberry",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 40.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790349684933",
      "vsf_explanation": "CBD gummy format delivers CBD via first-pass hepatic metabolism (~13-19% bioavailability), lower than sublingual oil. Sugar/gelatin base reduces overall wellness profile. Emerging anxiety-support evidence (Shannon 2019 case series) but doses vary widely. No public per-batch COA is a transparency gap common in the CBD category. Would move to Standard 65+ with per-batch COA, hemp source, and mg-per-gummy potency confirmation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "norwegian-cod-liver-oil",
      "title": "Norwegian Cod Liver Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/022dec3c-c736-4e1a-b14c-f0bf1f45666b_large_95ca8e67-7a23-4241-8b94-263a7f0b5d39.jpg?v=1787416693",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "norwegian",
        "cod",
        "liver",
        "oil",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 66,
        "manufacturing": 62,
        "safety": 62,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 18.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790349816005",
      "vsf_explanation": "Norwegian-sourced cod liver oil is a real quality signal — Norwegian fisheries have stricter processing and lower PCB burden than generic. Delivers EPA/DHA plus vitamins A and D. Vitamin A load requires pregnancy attention. Would move to Verified 70+ with disclosed EPA/DHA mg per softgel and IFOS certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chromium-picolinate",
      "title": "Chromium Picolinate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/de99a8cb-da17-47eb-9e88-7744efa36bbe_large_7df7c465-9507-4292-b736-7632cf3713b7.jpg?v=1787416693",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chromium",
        "picolinate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 6.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790349717701",
      "vsf_explanation": "Chromium picolinate is the most-studied chromium form with modest insulin sensitivity and glucose control evidence at 200-1000mcg (Anton 2008; Cefalu 2004 in T2D). Effect size is small. Standard tier — legit form, modest but real evidence. Would move to Verified with named-source Chromax branding and disclosed dose alignment.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "certified-organic-cold-pressed-castor-oil",
      "title": "Certified Organic Cold-Pressed Castor Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8628d40f-2318-449a-9590-8de4fb0b8bda_large_b06bbd07-adac-44f6-a606-9c44689f9c65.jpg?v=1787416693",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "certified",
        "organic",
        "cold",
        "pressed",
        "castor",
        "oil",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 65,
        "manufacturing": 65,
        "safety": 60,
        "transparency": 65,
        "sustainability": 60
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790349783237",
      "vsf_explanation": "Cold-pressed organic castor oil is a legit traditional topical for hair, skin, and constipation. Oral use as laxative has RCT signal but produces cramping. Cold-pressed and organic-certified are real quality signals. Ricinoleic acid is the active. Would need explicit topical-vs-oral use framing to move higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "norwegian-cod-liver-oil-1",
      "title": "Norwegian Cod Liver Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f25c56cb-110f-4dcd-8fe2-e4c4e49fec2a_large_7fc96ec3-cab8-49d0-9d67-f6202c37cf55.jpg?v=1787416693",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "norwegian",
        "cod",
        "liver",
        "oil",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 66,
        "manufacturing": 62,
        "safety": 62,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 14.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790349848773",
      "vsf_explanation": "Duplicate Norwegian CLO SKU. Solid EPA/DHA + vitamins A/D delivery with Norwegian sourcing signal. Would move to Verified 70+ with EPA/DHA mg disclosure and IFOS certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-cilantro",
      "title": "Full Spectrum Cilantro",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3ee00512-cc7c-41ed-9f2b-ba76549fdede_large_25d49a09-09e8-42f9-8d18-d02f29e51d74.jpg?v=1787416693",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "cilantro",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790349881541",
      "vsf_explanation": "Cilantro is popularly claimed as a 'heavy-metal chelator' — the human clinical evidence is essentially absent, driven by one small Aga 1997 case study. Product title itself doesn't make detox claims, so no autofail. Legit food-grade herb powder. Would need actual chelation RCT support (which is unlikely) to move higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "norwegian-cod-liver-oil-2-pack",
      "title": "Norwegian Cod Liver Oil - 2 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/84525d26-5fe7-45ed-8391-4961bfc52bba_large_ff37de6a-7e07-4916-a180-002762fd087f.jpg?v=1787416694",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "norwegian",
        "cod",
        "liver",
        "oil",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 66,
        "manufacturing": 62,
        "safety": 62,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790350110917",
      "vsf_explanation": "2-pack bundle of Norwegian cod liver oil. Solid formulation baseline. Would move to Verified 70+ with disclosed EPA/DHA mg and IFOS certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "grapefruit-seed-liquid-extract-topical-formula",
      "title": "Grapefruit Seed Liquid Extract - Topical Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a0d91657-ee50-4354-968f-2644546ff43f_large_e815dfd2-1d7d-40fb-bd38-5236fe38daa4.jpg?v=1787416693",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "grapefruit",
        "seed",
        "liquid",
        "extract",
        "topical",
        "formula",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 5.31,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790349947077",
      "vsf_explanation": "Grapefruit seed extract (GSE) has a well-documented history of contamination with synthetic preservatives (benzethonium chloride, triclosan) — the antimicrobial activity often comes from those, not the actual seed extract (Ganzera 2006, von Woedtke 1999). Topical formula caveat lowers the CYP3A4 systemic-interaction risk vs oral but the adulteration concern is still real. Would need third-party assay confirming no synthetic preservatives to move higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "coq10-cream",
      "title": "CoQ10 Cream",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a7b18721-c053-44a0-aff5-3aca452157df_large_9412eba1-98c5-43a3-842a-f9221d0fc4a8.jpg?v=1787416693",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coq10",
        "cream",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 48,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 4.75,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790349979845",
      "vsf_explanation": "Topical CoQ10 cream has real (though modest) evidence for skin — Hoppe 1999 showed topical Q10 reduced photoaged wrinkle depth — but is being categorized here as cardiovascular by product line. Topically applied CoQ10 has no meaningful systemic absorption for cardiovascular endpoints; the delivery route can't reach cardiac mitochondria the way oral ubiquinone/ubiquinol can (Skarlovnik 2014). If marketed for cardiovascular benefit the delivery-mechanism claim is not supported. Better categorized as a skin product; would score higher there. As a cardiovascular product, would need reclassification to move above Rejected.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "clear-skin-serum",
      "title": "Clear Skin Serum",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/709029c7-5247-4cea-b9de-071a1b36a3a1_large_716e711c-ca98-420f-bfee-a803089b4318.jpg?v=1787416693",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "clear",
        "skin",
        "serum",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 8.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790349914309",
      "vsf_explanation": "Topical 'clear skin' serum with no named active at title. Real evidence for topical acne/clarity ingredients exists (salicylic acid, benzoyl peroxide, niacinamide, azelaic acid), but 'clear skin serum' without ingredient disclosure could contain any of these — or none at effective concentrations. Held below Verified by opaque active list. Would move to Verified 70+ with named actives at clinical percentages.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "coq10-30-mg",
      "title": "CoQ10 30 mg",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/44cea238-6cb8-4e60-8cad-70c77e8db975_large_5460a928-e8b3-43ba-b061-f0852912e55b.jpg?v=1787416694",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coq10",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 50,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 13.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790350078149",
      "vsf_explanation": "30 mg conventional CoQ10 sits below the 100-200 mg dose range used in cardiovascular RCTs (Skarlovnik 2014 for statin myalgia; Mortensen 2014 Q-SYMBIO for heart failure). Acts as a general antioxidant baseline but under-serves users with a clinical goal. Would move to Standard 65+ with 100+ mg dose and Kaneka Q10 sourcing with softgel-in-oil delivery.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "calcium-aspartate",
      "title": "Calcium Aspartate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/80c350ce-a3d2-4b9e-9752-d04caa3021dc_large_522f86a7-cdc5-408e-b446-05d5419e3e10.jpg?v=1787416693",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "calcium",
        "aspartate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 10.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790350176453",
      "vsf_explanation": "Calcium aspartate — mid-tier calcium form with reasonable absorption. Aspartate as excitatory amino acid carries minor theoretical concern. High-dose isolated calcium without K2 raises cardiovascular concerns (Bolland 2015). Standard tier — legit but not top-choice form; citrate is generally preferred.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "skin-and-joint-biocell-collagen-collagen-type-ii",
      "title": "Skin and Joint BioCell Collagen - Collagen Type II",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5b2051bc-2c52-4505-8d7c-e79eb8afbcdb_large_768a97ae-3be3-4370-966a-18605562e959.jpg?v=1787416694",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "skin",
        "and",
        "joint",
        "biocell",
        "collagen",
        "collagen",
        "type",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 74,
        "formulation": 76,
        "manufacturing": 66,
        "safety": 72,
        "transparency": 74,
        "sustainability": 58
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790350307525",
      "vsf_explanation": "Named-source BioCell Collagen — a hydrolyzed matrix of type II collagen, chondroitin sulfate, and hyaluronic acid with Schauss 2012 RCT support (2 g/day for joint discomfort) and Bakilan 2016 RCT for OA knee. Correct form at (presumably) studied dose. Named clinical ingredient clears Verified. Held below Elite by mid-tier retailer manufacturing and no third-party COA. Would move to 80+ with USP/NSF certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "calcium-vitamin-d",
      "title": "Calcium & Vitamin D",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c61778ce-c9d6-4303-9ca6-b9b32932ae8a_large_95ac92c9-93da-4c78-827c-3629080da89d.jpg?v=1787416693",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "calcium",
        "vitamin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 7.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790350012613",
      "vsf_explanation": "Ca + D has classical bone-support rationale (Weaver 2016 Osteoporosis Int) but the form matters heavily: unnamed 'Calcium' is often carbonate which has bioavailability limits, and without K2/magnesium co-nutrients calcium supplementation has been raised as a possible vascular-calcification concern (Bolland 2010 BMJ meta-analysis, controversial). Held below Verified by likely carbonate form, no K2 cofactor to direct calcium to bone, and unclear elemental Ca mg. Would move to Verified 70+ with calcium citrate/malate + K2 MK-7 + Mg co-formulation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cranberry-20-1-concentrate",
      "title": "Cranberry 20:1 Concentrate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b354eade-d9a3-48be-934c-faf8500bea48_large_8698142b-af04-4632-82af-cc69c46511f7.jpg?v=1787416693",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cranberry",
        "concentrate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 52
      },
      "price": 16.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790350143685",
      "vsf_explanation": "20:1 cranberry concentrate is a defined ratio format — much more concentrated than whole-fruit powder. Cranberry has modest recurrent-UTI evidence (Jepson 2012) at 36 mg PAC/day. PAC content not disclosed on label — BL-DMAC method reporting is the industry-preferred standard. Would move to Verified 70+ with 36 mg PAC BL-DMAC per serving disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cinnamon-gymnema-mulberry-complex-3-in-1-formula",
      "title": "Cinnamon Gymnema Mulberry Complex - 3-in-1 Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/dec01b19-a409-4b7a-85c9-55c0c45e5f6f_large_17811ebb-477a-4c63-ac4c-4eda7ad4e2f8.jpg?v=1787416693",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cinnamon",
        "gymnema",
        "mulberry",
        "complex",
        "formula",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 58,
        "transparency": 55,
        "sustainability": 52
      },
      "price": 9.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790350209221",
      "vsf_explanation": "Three-herb glucose-support blend. Cinnamon (Allen 2013 modest signal), gymnema (small trials for glucose/sweet taste), mulberry leaf (Riche 2017 modest postprandial glucose reduction with 1-deoxynojirimycin). Combination formats risk sub-therapeutic dosing per active. Cinnamon species not disclosed. Would move to Standard 65+ with per-herb mg disclosure and Ceylon-cinnamon designation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "childrens-multi-sugar-free-orange-chewable",
      "title": "Children's Multi Sugar-Free - Orange Chewable",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b6cb8988-e555-4bdc-bf8d-0d17966b0cb9_large_d66e9c6a-9165-424a-92aa-670e9d361742.jpg?v=1787416694",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "youth_under_18",
      "tokens": [
        "children",
        "multi",
        "sugar",
        "free",
        "orange",
        "chewable",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 4.88,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790350045381",
      "vsf_explanation": "Sugar-free chewable children's multi — sugar-free is a genuine formulation win for a kids' product (dental and metabolic). Xylitol or sorbitol common sweeteners. Formulation quality hinges on whether folate is 5-MTHF, B12 is methylcobalamin, D3 not D2 — not clear from title. Would move to Verified 70+ with methylated B forms, D3, and clean sweetener profile disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "coq10-10-mg",
      "title": "CoQ10 10 mg",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/146deebc-153d-4226-9e74-291edf6c0527_large_08ac5d0f-5e14-4694-b322-9f2923ab71e2.jpg?v=1787416694",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coq10",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790350274757",
      "vsf_explanation": "10 mg CoQ10 is roughly one-tenth of the workhorse cardiovascular dose used across the published literature (Skarlovnik 2014; Mortensen 2014 Q-SYMBIO both use 100-200 mg minimum). At this dose the product cannot honestly claim to replicate the clinical outcomes seen in trials, and endogenous ubiquinone production dwarfs a 10 mg supplemental dose. Would move above Rejected only with a substantially higher per-serving dose (100 mg+) or as clearly labeled multivitamin trace addition rather than as a standalone CoQ10 product.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cinnamon-chromium-featuring-chromax",
      "title": "Cinnamon & Chromium - Featuring Chromax",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d06e1ee6-0f60-475f-955e-aafe4dbe085a_large_412cad02-68a8-4ba6-8bc0-4b2b6e611566.jpg?v=1787416693",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cinnamon",
        "chromium",
        "featuring",
        "chromax",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 72,
        "manufacturing": 66,
        "safety": 65,
        "transparency": 70,
        "sustainability": 50
      },
      "price": 4.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790350241989",
      "vsf_explanation": "Chromax is a branded chromium picolinate with published clinical data. Cinnamon (typically 1-6g) has modest fasting glucose evidence (Allen 2013 meta-analysis). Combined glucose-support formula with named-source chromium raw material is a formulation plus. Upper Standard tier — near Verified. Would move higher with cinnamon standardization %, dose disclosure, and RCT alignment.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cod-liver-oil-double-strength",
      "title": "Cod Liver Oil - Double Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/263dd21d-91b9-48cb-bc22-ad5dbcfa4d4e_large_a48fd845-2e66-4edf-8559-df18c8782633.jpg?v=1787416694",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cod",
        "liver",
        "oil",
        "double",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 62,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 24.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790350373061",
      "vsf_explanation": "Duplicate double-strength CLO. Solid omega-3 + vitamin A/D delivery. Vitamin A pregnancy consideration. Would move to Verified 70+ with EPA/DHA mg disclosure, IFOS certification, and vitamin A cap.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-damiana",
      "title": "Full Spectrum Damiana",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4a2b24d1-152a-4283-860c-404edc704619_large_50443241-37b8-4fb9-8257-72f1c93c7392.jpg?v=1787416694",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "damiana",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 13.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790350405829",
      "vsf_explanation": "Whole-leaf damiana (Turnera diffusa) — a traditional Mesoamerican aphrodisiac. Modern human RCT evidence for libido or mood claims is scant; most data are preclinical or from multi-herb blend trials that don't isolate damiana's contribution. Full-spectrum whole-leaf format is traditional but without standardization the active-compound delivery is variable. Generally well-tolerated. Would move higher with human RCT evidence and standardization to a marker compound — but the evidence base itself constrains scoring.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mini-cap-multi-easy-to-swallow",
      "title": "Mini Cap Multi - Easy to Swallow",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/78d249d1-257c-478c-90be-bdfec70a6405_large_8aa27bab-2375-4416-a262-5e779f4aae9b.jpg?v=1787416693",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mini",
        "cap",
        "multi",
        "easy",
        "swallow",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790350340293",
      "vsf_explanation": "Mini-capsule multivitamin for pill-swallowing sensitive users. Smaller capsules necessarily fit less nutrient mass, so per-cap RDAs may be sub-therapeutic and multi-cap serving may be required. Formulation quality depends on whether B forms are methylated and D is D3. Would move to Verified 70+ with methylated B, D3, K2, and clear serving disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "collagen-peptides-unflavored",
      "title": "Collagen Peptides - Unflavored",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e9ee4eff-d9e5-4a08-8176-bfa0bbe092a5_large_ebb186bc-07fd-4580-b6dd-4985ed6cb997.jpg?v=1787416694",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "collagen",
        "peptides",
        "unflavored",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 66,
        "formulation": 63,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 44.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790350569669",
      "vsf_explanation": "Fourth Swanson collagen peptides SKU variant. Hydrolyzed bovine peptides in the correct form with skin/joint RCT support at 10 g/day (Proksch 2014, Clark 2008). Generic sourcing without named clinical peptide. Held below Verified by identical sourcing opacity across the Swanson collagen line. Would move to Verified 70+ with named-source peptides (Peptan/Bodybalance/Verisol) and grass-fed sourcing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "albion-copper",
      "title": "Albion Copper",
      "vendor": "Albion",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/614d9a65-1a18-420a-b711-9923e235b098_large_69503019-e510-4c68-baf7-0a114cc8e9d8.jpg?v=1787416694",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "albion",
        "copper",
        "albion"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 74,
        "manufacturing": 70,
        "safety": 68,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790350471365",
      "vsf_explanation": "Albion copper bisglycinate — chelated copper for connective tissue, iron metabolism, and balancing chronic zinc supplementation. RDI 900mcg. Named-source TRAACS chelate lifts to Verified. Would move higher with disclosed elemental copper and third-party verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "colon-helper",
      "title": "Colon Helper",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f7fa53e2-54cf-44cf-ae9b-23d8c4b00117_large_ecb6bfb6-e7b8-40e6-a9b2-0cc300b4e8ef.jpg?v=1787416694",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "colon",
        "helper",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 13.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790350438597",
      "vsf_explanation": "Vague product name that typically indicates a laxative-stimulant blend (cascara, senna, aloe) with or without fiber. Without label transparency it is impossible to distinguish a bulk-fiber product (safe daily use) from a stimulant laxative (short-term use only). Would move to Verified with ingredient transparency and elimination of stimulant anthraquinones for daily-use positioning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "coq10-30-mg-1",
      "title": "CoQ10 30 mg",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/afafa64d-0c6c-4356-b52b-bee62bdf9816_large_cbd4eb48-1a81-4e93-a66f-0e1b874323df.jpg?v=1787416694",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coq10",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 50,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 21.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790350536901",
      "vsf_explanation": "30 mg conventional CoQ10 sits well below the 100-200 mg dose range studied for statin-myalgia (Skarlovnik 2014) and heart failure adjunct therapy (Mortensen 2014 Q-SYMBIO). It functions as a modest general antioxidant baseline but under-serves users with a specific clinical goal. Would move to Standard 65+ at 100+ mg per serving with Kaneka Q10 sourcing and softgel-in-oil delivery.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dhea-higher-strength",
      "title": "DHEA - Higher Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/db873c39-1a21-4a76-9542-44b535223f6e_large_beb725a9-3605-4baf-9193-418d2545ed9b.jpg?v=1787416694",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dhea",
        "higher",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 50,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 9.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790350602437",
      "vsf_explanation": "Higher-strength DHEA (typically 50-100mg). DHEA is a steroid precursor to testosterone and estradiol with moderate evidence in low-DHEA populations (Panjari 2007) and weaker signal in healthy adults. Higher-dose products amplify hormone-conversion side effects and require lab monitoring plus hormone-sensitive-cancer contraindications, which are often under-disclosed. Standard Swanson manufacturing. Would move to Verified 70+ with mandatory monitoring guidance and sex-specific safety warnings.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chromium-picolinate-1",
      "title": "Chromium Picolinate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/06e8e08c-8540-4606-ae6e-5a13bfe5520d_large_2661ac0d-511b-48f2-a9a8-b7d03b53240d.jpg?v=1787416693",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chromium",
        "picolinate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 8.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790350504133",
      "vsf_explanation": "Duplicate SKU of chromium picolinate. Well-studied form (Anton 2008; Cefalu 2004) with modest but real glucose-control effect at 200-1000mcg. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "creatine-monohydrate-powder",
      "title": "Creatine Monohydrate Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/53c45b60-6174-4c79-b662-4eddc1936e4e_large_02e02d40-ef2f-4e21-9d89-8c98b4356448.jpg?v=1787416693",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "creatine",
        "monohydrate",
        "powder",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 82,
        "formulation": 68,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 65,
        "sustainability": 60
      },
      "price": 55.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790350635205",
      "vsf_explanation": "Plain creatine monohydrate powder — best format for the reference-standard ergogenic (Kreider 2017 ISSN position; 3-5g/day maintenance dose). Powder avoids the degradation and dosing problems that plague gummies. Held at Standard by the same Swanson-house-brand gaps: no Creapure sourcing named, no third-party COA published, no NSF Certified for Sport certification. Would move to Verified 70+ with any of those transparency additions.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-corydalis-root-extract-20-1-suitable-for-vegetarian-vegan-non-gmo-500-mg-180-capsules",
      "title": "NusaPure Corydalis Root Extract 20:1 - Suitable for Vegetarian/Vegan, Non - GMO - 500 mg - 180 Capsules",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-127743v7-Corydalis-3D-01.jpg?v=1787416697",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "corydalis",
        "root",
        "extract",
        "suitable",
        "for",
        "vegetarian",
        "vegan",
        "non",
        "gmo",
        "500",
        "180",
        "capsules",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 19.85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790351159493",
      "vsf_explanation": "Corydalis (Yanhusuo) contains dehydrocorybulbine (DHCB) with preclinical analgesic activity (Zhang 2014, University of California Irvine research). Human RCT evidence for pain is thin, with concerns about hepatotoxicity from certain alkaloid fractions. NusaPure discloses 20:1 extract at 500mg but no THP standardization percentage or hepatic-safety data. Would move to Verified 70+ with standardized THP content and formal safety data.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "coq10-30-mg-2",
      "title": "CoQ10 30 mg",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2d0be285-d0eb-4884-9840-05eaa3690bbf_large_9ba8f9b5-38fd-45e7-8f3c-df0be129ff51.jpg?v=1787416700",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coq10",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 50,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 8.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790352470213",
      "vsf_explanation": "30 mg conventional CoQ10 is well below the 100-200 mg dose range used in essentially all cardiovascular RCTs (Skarlovnik 2014; Mortensen 2014 Q-SYMBIO). Functions as a general baseline antioxidant supplement but is unlikely to produce the statin-myalgia or heart-function benefit seen in the published literature. Would move to Standard 65+ with 100+ mg per serving and Kaneka Q10 sourcing with softgel-in-oil delivery.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "elderberry-gummies-with-zinc-vitamin-c-lemon-raspberry",
      "title": "Elderberry Gummies with Zinc & Vitamin C - Lemon Raspberry",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/aa17f0f7-3a56-416f-b03e-1c8b496cb520_large_2c31fd59-c201-4b71-bdb0-c15bc5c7e0b3.jpg?v=1787416700",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "elderberry",
        "gummies",
        "with",
        "zinc",
        "vitamin",
        "lemon",
        "raspberry",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 13.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790352502981",
      "vsf_explanation": "Elderberry (Sambucus nigra) has some human RCT data for reduced flu-symptom duration (Tiralongo 2016, Zakay-Rones 2004), and zinc + vitamin C are legitimate immune cofactors (Hemila & Chalker 2013). Gummy delivery format compromises with sugar/syrup vehicle and content-vs-label variance risk (Crawford 2017). Held below Verified by low ingredient doses in gummy format, unclear elderberry standardization/mg, and sugar-vehicle concern. Would move to Verified 70+ with standardized elderberry extract disclosure and studied dose range.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "elderberry-echinacea-with-agaricus-blazei-mushroom",
      "title": "Elderberry & Echinacea with Agaricus Blazei Mushroom",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cb0c7b15-d904-4233-a29f-04fc2a26233e_large_2c02b0e8-9c07-4a2e-b9c1-6cfcafa5ba76.jpg?v=1787416701",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "elderberry",
        "echinacea",
        "with",
        "agaricus",
        "blazei",
        "mushroom",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 58,
        "manufacturing": 62,
        "safety": 62,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 16.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790352568517",
      "vsf_explanation": "Directionally coherent immune stack (elderberry antivirals + echinacea traditional + agaricus beta-glucans). All three components have some human data but none are standardized in the title, and the blend framing hides per-active mg. Occasional agaricus blazei hepatotoxicity reports (Mukai 2006) argue for standardization + safety labeling. Would move up with per-active mg + anthocyanin + beta-glucan standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "daily-essentials-multi-with-iron",
      "title": "Daily Essentials Multi with Iron",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4b29abf9-536f-48ef-b034-eb56ba7aa76d_large_4fb143bd-2cac-4f55-a025-4a61c54012aa.jpg?v=1787416701",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "daily",
        "essentials",
        "multi",
        "with",
        "iron",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 19.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790352535749",
      "vsf_explanation": "Duplicate SKU of basic daily multi with iron. Mainstream RDI-level coverage. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-dandelion-root",
      "title": "Full Spectrum Dandelion Root",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3a5e856e-f4e6-410b-bc38-ce0bd155ffea_large_a4bc104a-6dab-4007-bdea-aee3bf077c9d.jpg?v=1787416702",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "dandelion",
        "root",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 55,
        "sustainability": 62
      },
      "price": 6.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790353092805",
      "vsf_explanation": "Whole-root dandelion (Taraxacum officinale) — traditional bitter/diuretic/hepatobiliary support herb. Human clinical data are limited; most support comes from traditional-use monographs and preclinical work. Reasonable food-form herb. Not a strong fit for the immune-antioxidant category — better as digestive/liver-support. Held to low Standard by weak modern evidence base.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "echinacea-with-goldenseal-root",
      "title": "Echinacea with Goldenseal Root",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a9c846b7-ff50-4db1-95ae-e8dd178b20d2_large_2b335b3c-5761-4589-8caf-93794deddb6b.jpg?v=1787416702",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "echinacea",
        "with",
        "goldenseal",
        "root",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 55,
        "manufacturing": 62,
        "safety": 58,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 21.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790353125573",
      "vsf_explanation": "Capsule form of the classic cold-season echinacea + goldenseal stack. Same limitations as the liquid extract: goldenseal sustainability, berberine drug-interactions, and neither ingredient standardized. Held to low Standard. Would move up with cultivated goldenseal source, berberine standardization, and echinacea species/phenolic standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "daily-b-complex",
      "title": "Daily B-Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2c089247-9df9-44ee-a7db-c40e1e83fc45_large_038295a7-07ee-48ad-a2bb-e8227cc8acd3.jpg?v=1787416702",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "daily",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 56,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 11.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790353158341",
      "vsf_explanation": "Generic daily B-complex almost certainly uses synthetic non-methylated forms (folic acid, cyanocobalamin, pyridoxine HCl) — functional for nutrient replenishment but inferior for MTHFR carriers (Obeid & Herrmann 2012). Held below Verified by non-bioactive form choice and unclear mg per B nutrient. Would move to Verified 70+ if reformulated with methylcobalamin + 5-MTHF + P-5-P.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "d-mannose-powder",
      "title": "D-Mannose Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5c78afcd-81ac-423a-80fb-8aff00ed53ad_large_34b40d39-f99f-4a4f-bced-d5f592cc738f.jpg?v=1787416704",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mannose",
        "powder",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 19.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790354141381",
      "vsf_explanation": "D-mannose has good RCT evidence for recurrent UTI prevention (Kranjcec 2014 — 2 g/day matched TMP-SMX efficacy). Powder is a cost-effective delivery format for the 2 g daily dose. Would move to Verified 70+ with third-party purity assay and clear clinical-dose scoop measurement.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dl-phenylalanine",
      "title": "DL-Phenylalanine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7c007dab-c846-4fb2-96d0-3afce272210b_large_f3297b08-7f14-4edc-a3d4-803c4c372d48.jpg?v=1787416705",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "phenylalanine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 12.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790354174149",
      "vsf_explanation": "DL-phenylalanine (racemic mix of L-phenylalanine and D-phenylalanine) is marketed for mood, pain, and PKU-related uses. D-form is thought to inhibit enkephalinase (analgesic); L-form is a tyrosine precursor. RCT support is dated and modest (Beckmann 1979 depression trial). Absolute contraindication in PKU — legit safety flag. Would need modern RCT data to move higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "d-mannose",
      "title": "D-Mannose",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d176bef5-3d38-4937-bfdc-812ca92ab31c_large_112e3491-9375-4902-9e6d-5c321122b20e.jpg?v=1787416705",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mannose",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 18.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790354206917",
      "vsf_explanation": "D-mannose capsule format for UTI prevention has RCT support (Kranjcec 2014) at 2 g daily. Capsule form generally requires many capsules to hit the clinical dose vs powder. Would move to Verified 70+ with clinical-dose serving math clarified and third-party purity assay.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "daily-essentials-multi-with-iron-1",
      "title": "Daily Essentials Multi with Iron",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c85d4a1e-6e34-41b4-8c78-b29b43be40d1_large_5aa185e1-3d31-41ab-a267-001a013f242a.jpg?v=1787416705",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "daily",
        "essentials",
        "multi",
        "with",
        "iron",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 10.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790354239685",
      "vsf_explanation": "Basic daily multi with iron — mainstream RDI-level micronutrient coverage. Multivitamin population-level RCT evidence is mixed (Rautiainen 2016 for modest PHS-II cancer benefit). Standard tier — legit but not clinically-forward. Would move up with methylated B forms and named chelates.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "echinacea-goldenseal-liquid-extract-alcohol-free",
      "title": "Echinacea & Goldenseal Liquid Extract - Alcohol Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71302507-d044-4489-af62-5db87d29cf3c_large_f8a791e7-4b21-4b93-a94a-5a68018fa4f9.jpg?v=1787416705",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "echinacea",
        "goldenseal",
        "liquid",
        "extract",
        "alcohol",
        "free",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 60,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 28.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790354272453",
      "vsf_explanation": "Traditional herbalist cold-season liquid tincture (echinacea + goldenseal), alcohol-free. Aqueous glycerite extraction is weaker than hydroethanolic for alkaloid-heavy goldenseal (berberine, hydrastine). Goldenseal has real sustainability concerns from wild-collection pressure (CITES Appendix II) and berberine drug-interactions (CYP3A4, P-gp inhibition — statins, cyclosporine). Held to mid-Standard by those concerns. Would move up with organic-cultivated goldenseal sourcing and interaction labeling.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-devils-claw",
      "title": "Full Spectrum Devil's Claw",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4de3ab75-1c5f-4c43-90be-e43e17b8fa6e_large_2e0bef68-e392-4f75-a076-cec43518b524.jpg?v=1787416705",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "devil",
        "claw",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 9.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790354305221",
      "vsf_explanation": "Devil's claw (Harpagophytum procumbens) has modest RCT evidence for low back pain and osteoarthritis (Chrubasik 2007 review). Harpagoside is the primary active. Whole-tuber powder without % harpagoside standardization delivers unpredictable actives. GI side effects; not for peptic ulcer. Would move to Verified 70+ with 50-100 mg harpagoside daily equivalent.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "digestive-enzymes-1",
      "title": "Digestive Enzymes",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a7619636-fa1c-41f9-bf96-d8eafe2edfa0_large_99486bf2-83c6-4b63-83d4-ab4f0a4acb6e.jpg?v=1787416705",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "digestive",
        "enzymes",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 16.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790354337989",
      "vsf_explanation": "Digestive enzyme blend — duplicate SKU. As with the sibling product, activity units (HUT/FIP/DU) are the meaningful metric and not visible from the title. Would move to Verified with per-enzyme activity-unit disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cod-liver-oil-double-strength-1",
      "title": "Cod Liver Oil - Double Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/769ce275-59c0-4eaa-9b64-d14102c76cac_large_2d054dc8-8d83-479b-90a8-245f9aec5047.jpg?v=1787416705",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cod",
        "liver",
        "oil",
        "double",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 62,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 5.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790354370757",
      "vsf_explanation": "Cod liver oil combines EPA/DHA omega-3s with vitamins A and D. Solid evidence for omega-3 (cardiovascular, inflammation — GISSI-Prevenzione). Vitamin A load requires attention in pregnancy (teratogenicity above 10,000 IU retinol). 'Double strength' vs generic is a formulation plus but exact EPA/DHA mg not visible from title. Would move to Verified 70+ with disclosed EPA/DHA per softgel, IFOS/Friend of the Sea certification, and vitamin A cap.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cordyceps",
      "title": "Cordyceps",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/18cb37f5-e228-4d10-af09-9c781cda407f_large_97a9a821-6ea0-4d15-8d0f-8c231c1006f2.jpg?v=1787416706",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cordyceps",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 58,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 52,
        "sustainability": 60
      },
      "price": 19.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790355157189",
      "vsf_explanation": "Basic cordyceps SKU — species (CS-4 vs C. militaris vs wild C. sinensis) not specified, which is the most important quality variable in this category. C. militaris and CS-4 have the most human data (Chen 2010 for CS-4 exercise capacity). Recategorized to energy_metabolic given ergogenic use pattern. Would move up substantially with species disclosure and cordycepin/adenosine standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "echinacea",
      "title": "Echinacea",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/09704fa8-4031-41ce-91c7-493ffdc6a055_large_8d02bb63-6d08-436b-9ae3-f9de210686fb.jpg?v=1787416707",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "echinacea",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 52,
        "sustainability": 58
      },
      "price": 12.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790355222725",
      "vsf_explanation": "Duplicate generic echinacea SKU — same evaluation: no species, no standardization, Karsch-Volk 2014 Cochrane evidence base doesn't translate to unstandardized powder. Would move up with species + standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dhea-higher-strength-1",
      "title": "DHEA - Higher Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c4be0fed-7341-4c31-9df1-c5554bac8fd7_large_b8469a03-ed5e-43d5-a58f-090a672b5fc1.jpg?v=1787416707",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dhea",
        "higher",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 50,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 3.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790355255493",
      "vsf_explanation": "Higher-strength DHEA (typically 50-100mg) — a steroid precursor to testosterone and estradiol. Moderate evidence in adrenal-insufficient and postmenopausal populations (Panjari 2007); weaker evidence in healthy adults. Higher doses amplify hormone-conversion effects (acne, hair changes, cycle irregularity in women; aromatization to estradiol in men) and should be lab-monitored. Standard Swanson manufacturing without third-party testing. Would move to Verified 70+ with mandatory lab-monitoring guidance, sex-specific dose warnings, and hormone-sensitive-cancer contraindications.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "just-one-multi-with-iron",
      "title": "Just One Multi with Iron",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1dc9b30c-197e-4639-bf18-69b1b20ce880_large_766edb97-1502-44bc-931d-cecec417a198.jpg?v=1787416708",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "just",
        "one",
        "multi",
        "with",
        "iron",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 8.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790355779781",
      "vsf_explanation": "Once-daily multivitamin with iron — convenient adherence, appropriate for menstruating women and iron-deficient users. Single-tablet multis typically compress micronutrients into a smaller footprint at the cost of ideal dose levels. Standard tier. Adult men and post-menopausal women should choose iron-free.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-carnitine-lepidium-supplement-30-capsules-hhs-a1",
      "title": "L-Carnitine Lepidium Supplement - 30 Capsules | HHS A1",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/hhs-a1-l-carnitine-lepidium-30-kapsul-9cbe-4_e20c0bd6-4c71-4e6a-8f60-7a5d1a979f4e.jpg?v=1787416750",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "carnitine",
        "lepidium",
        "supplement",
        "capsules",
        "hhs",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 48,
        "safety": 60,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 27.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790365053125",
      "vsf_explanation": "L-carnitine + Lepidium (maca) is a Turkish-market male-vitality style formula. L-carnitine has moderate RCT data for sperm parameters (Lenzi 2003, Balercia 2005) and modest fat-oxidation support; maca has small trials for libido (Gonzales 2002). Per-cap mg not disclosed from title, only 30 capsules per pack suggests short duration. Reseller channel with no US COA. Would move to Verified 70+ with per-active mg at studied levels and US-market third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-diosmin-900mg-per-serving-120-veggie-caps-non-gmo-vegan",
      "title": "NusaPure Diosmin 900mg per Serving 120 Veggie Caps (Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/813b160d.jpg?v=1787416755",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "diosmin",
        "900mg",
        "per",
        "serving",
        "120",
        "veggie",
        "caps",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 26.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790366331077",
      "vsf_explanation": "Diosmin 900mg per serving is close to the standard 500-1000mg range used in chronic venous insufficiency and hemorrhoid trials (typically as Daflon 500mg diosmin/hesperidin combination — Kakkos 2020 meta). NusaPure sells it as diosmin-only, missing the paired hesperidin (~10% MPFF standard) that most RCTs used. Amazon-native brand without per-SKU third-party COA. Would move to Verified 70+ with diosmin/hesperidin 9:1 micronized (Daflon-equivalent) formulation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-vision-support-nutrients-with-vitamin-a-c-e-calcium-zinc-selenium-copper-lutein-60-tablets-non-gmo-dietary-supplement",
      "title": "NusaPure Vision Support Nutrients with Vitamin A, C, E, Calcium, Zinc, Selenium, Copper, Lutein 60 Tablets Non-GMO Dietary Supplement",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5c9b264a.jpg?v=1787416755",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "vision",
        "support",
        "nutrients",
        "with",
        "vitamin",
        "calcium",
        "zinc",
        "selenium",
        "copper",
        "lutein",
        "tablets",
        "non",
        "gmo",
        "dietary",
        "supplement",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790366363845",
      "vsf_explanation": "AREDS-style vision formula (A/C/E/zinc/copper/lutein) is one of the better-evidenced multi-nutrient categories thanks to the AREDS and AREDS2 trials (2001, 2013). Per-ingredient doses aren't confirmed from title — actual AREDS2 uses specific doses (lutein 10mg, zeaxanthin 2mg, zinc 25-80mg, vitamin C 500mg, vitamin E 400IU). Without zeaxanthin visible and unclear dosing, this doesn't fully mirror AREDS2. Would move to Verified 72+ with matched-dose AREDS2 formulation and named lutein source (FloraGlo).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "eleuthero-root",
      "title": "Eleuthero Root",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a527449a-311e-4dc6-9a2c-d36875c00b65_large_039eff79-a194-4172-83b8-4f0bfdd708ce.jpg?v=1787416755",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "eleuthero",
        "root",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 8.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790366396613",
      "vsf_explanation": "Eleuthero (Eleutherococcus senticosus, 'Siberian ginseng') root — evidence is modest and mostly from Russian/Soviet-era literature; more recent work (Kuo 2010 on immune markers) is limited. Standardized extracts to eleutheroside B and E content are the studied material (0.8% eleutherosides). Whole-root preparation at title level does not confirm the active constituent delivery. Held at Standard. Would move up with eleutheroside standardization percent named.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "echinacea-1",
      "title": "Echinacea",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/62447eac-7c70-4c29-b37b-b51f9cc2327f_large_4650c3bd-e664-4501-85c4-c1e2c8fbe201.jpg?v=1787416755",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "echinacea",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 52,
        "sustainability": 58
      },
      "price": 10.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790366560453",
      "vsf_explanation": "Generic echinacea capsule — no species (angustifolia vs purpurea) specified, no phenolic or echinacoside standardization. Karsch-Volk 2014 Cochrane found evidence mainly for cold duration in standardized products; generic powder is largely unsupported. Would move up substantially with species and standardization disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-andrographis-paniculata",
      "title": "Full Spectrum Andrographis Paniculata",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a8bccc61-081b-432e-a6fd-60d55233ce2d_large_be8a50e5-37b2-43aa-8eea-85d77cd20d1a.jpg?v=1787416755",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "andrographis",
        "paniculata",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 11.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790366429381",
      "vsf_explanation": "Andrographis has strong RCT evidence for URI symptom reduction (Coon 2004 meta-analysis) and modest RA support. Andrographolide is the primary active — whole-herb form without % andrographolide standardization limits per-capsule active. Rash/GI safety flags exist. Would move to Verified 70+ with Paractin or AP-Bio branded extract at clinical dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-dong-quai",
      "title": "Full Spectrum Dong Quai",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/88c49715-3396-41db-8687-f0d7c5724389_large_b14cda53-99c2-4b96-99c5-1c4e90a4da63.jpg?v=1787416756",
      "score": 53,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "dong",
        "quai",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 50,
        "transparency": 55,
        "sustainability": 52
      },
      "price": 7.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790366593221",
      "vsf_explanation": "Dong quai (Angelica sinensis) has traditional women's-health use but negative RCT for standalone menopause (Hirata 1997 showed no benefit vs placebo). Coumarin content brings anticoagulant interaction risk (warfarin, other anticoagulants). Photosensitivity from furocoumarins. Would move to Standard 62+ with anticoagulant warning, drug-interaction disclosure, and better clinical evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-angelica-root",
      "title": "Full Spectrum Angelica Root",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e18d3b54-5484-47b9-bb1c-d77e1c5c5a81_large_1ca03687-ce55-4174-9caf-40ef7749e922.jpg?v=1787416755",
      "score": 51,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "angelica",
        "root",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 48,
        "transparency": 50,
        "sustainability": 52
      },
      "price": 6.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790366494917",
      "vsf_explanation": "Angelica root (species not clarified — could be A. archangelica or A. sinensis). Traditional use but negligible controlled clinical evidence. Furocoumarin content brings photosensitization and anticoagulant risks. Species ambiguity is a transparency red flag. Would move to Standard 60+ with clear species disclosure, safety warnings, and clinical evidence base.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-fennel-seed",
      "title": "Full Spectrum Fennel Seed",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9a24360c-3ab1-44f2-9c13-0e78eff03562_large_c8cefe31-623f-4419-923d-8c51cbee18fa.jpg?v=1787416756",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "fennel",
        "seed",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 55,
        "sustainability": 52
      },
      "price": 6.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790366625989",
      "vsf_explanation": "Fennel seed (Foeniculum vulgare) is a traditional carminative with small trials for infant colic (Alexandrovich 2003) and menopausal symptoms. Whole-seed powder without essential-oil standardization. Culinary-adjacent product with acceptable safety but limited robust supplement evidence. Would move to Standard 62+ with anethole standardization and defined dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-boswellia-and-curcumin",
      "title": "Full Spectrum Boswellia and Curcumin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2dbe539d-3ba4-469e-9cbf-8e1d3b8c4a8f_large_5587b5dd-e1a3-46aa-a944-466a9ef4d4b7.jpg?v=1787416755",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "boswellia",
        "and",
        "curcumin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790366527685",
      "vsf_explanation": "Boswellia + curcumin is a genuinely strong evidence-based joint-inflammation pairing (Kizhakkedath 2013 for Curamin analogue), but in 'Full Spectrum' whole-herb form both actives underdeliver on standardized bioactives. Boswellia specifically needs AKBA standardization (5-Loxin, ApresFlex) for the clinical activity; curcumin needs a bioavailability carrier. Would move up substantially with standardized extracts on both.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-buchu-leaf-extract",
      "title": "Full Spectrum Buchu Leaf Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8bc91516-7ce0-4b46-a560-cc1b1f7bf4b8_large_f02aad52-9ee2-4137-b01d-4bd0cf310403.jpg?v=1787416755",
      "score": 53,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "buchu",
        "leaf",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 52,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 4.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790366462149",
      "vsf_explanation": "Buchu (Agathosma betulina) is a traditional South African urinary herb with essentially no modern RCT support. Contains pulegone — a known hepatotoxin at higher doses. Not safe in pregnancy or kidney disease. Would need modern safety data and clinical trials to move higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-fo-ti-he-shou-wu",
      "title": "Full Spectrum Fo-Ti He-Shou-Wu",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/90ced7bd-b4b4-4cbe-8263-8806535d5c32_large_6643cc8d-7044-447b-bd5f-b9e0916626e0.jpg?v=1787416755",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "shou",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 40,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 5.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790366757061",
      "vsf_explanation": "Fo-Ti (Polygonum multiflorum, He Shou Wu) is a traditional Chinese longevity/hair-restoration herb with documented severe hepatotoxicity risk — LiverTox lists it as a known cause of drug-induced liver injury with a mortality signal. Processed vs unprocessed form matters and is often opaque. Would not recommend for supplement use regardless of formulation improvements.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-boswellia-double-strength",
      "title": "Full Spectrum Boswellia - Double Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a1b09d98-32b6-452b-bccd-32a641d70a25_large_83ac448b-ef05-4d91-b70d-af9c9658115d.jpg?v=1787416756",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "boswellia",
        "double",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790366789829",
      "vsf_explanation": "Boswellia serrata has good RCT evidence for osteoarthritis pain (Kimmatkar 2003; Sengupta 2010) at 300-500 mg standardized to 60% boswellic acids. 'Double strength' is nonspecific — real formulation quality depends on the boswellic acid % or AKBA-enriched (5-Loxin/ApresFlex) format. Would move to Verified 70+ with AKBA-standardized branded extract.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fiber-gummies-orange",
      "title": "Fiber Gummies - Orange",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3a013c6e-3ef3-4aee-b868-d73b155c7cbb_large_493c887a-1462-405c-9d10-52053268c1f4.jpg?v=1787416755",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fiber",
        "gummies",
        "orange",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 48,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 13.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790366691525",
      "vsf_explanation": "Fiber gummies typically deliver only 2-4g fiber per serving (well below the 5g threshold that anchors most fiber RCTs) plus 3-5g added sugar per serving, which partly counteracts the metabolic benefit. Gummy format also excludes the soluble fibers with the strongest LDL/glycemic evidence (psyllium). Would move up meaningfully only by switching format — psyllium powder or capsules deliver the studied dose without added sugar.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-cayenne-and-fenugreek",
      "title": "Full Spectrum Cayenne and Fenugreek",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3f885a5b-86fa-4617-ac23-e2fda61d521f_large_ba591e7c-ccf0-4cf5-9cea-21b8c443a86a.jpg?v=1787416755",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "cayenne",
        "and",
        "fenugreek",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 12.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790366724293",
      "vsf_explanation": "Cayenne + fenugreek combination targets circulation and metabolic support. Each has modest RCT data individually, but the combination lacks trial support at the combined form. Cayenne can cause GI irritation. Without capsaicin HU or fenugreek saponin standardization, actives are uncertain. Would move higher with per-ingredient standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "digestive-enzymes-2",
      "title": "Digestive Enzymes",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/302fc537-450c-4576-94d9-e8ed4cd9ff3e_large_e462a275-2638-4204-bcb3-c9b93961db38.jpg?v=1787416755",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "digestive",
        "enzymes",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 26.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790366888133",
      "vsf_explanation": "Generic digestive-enzyme blend. Enzyme activity units (protease HUT, lipase FIP, amylase DU) — not mg — are the clinically meaningful measure and are not visible from the title. Would move to Verified with per-enzyme activity-unit disclosure and named source strains (Aspergillus, Bacillus, etc.).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-blue-vervain",
      "title": "Full Spectrum Blue Vervain",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9b86ad10-cf49-4f52-816b-b6aabe63872b_large_4e5386e7-b5be-4228-91f9-3dad1da61efa.jpg?v=1787416755",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "blue",
        "vervain",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 58,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 2.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790366658757",
      "vsf_explanation": "Blue vervain (Verbena hastata) is a traditional nervine with essentially no modern RCT evidence. Legit safe traditional herb but insufficient evidence base. Would need modern controlled trial support to justify Standard-tier positioning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "emulsified-cod-liver-oil-mint-flavor",
      "title": "Emulsified Cod Liver Oil - Mint Flavor",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/23a26d30-1bdc-4240-bf42-c9cc57d6bd8e_large_a4272828-a7af-43f0-9f0a-e941415eb8ba.jpg?v=1787416755",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "emulsified",
        "cod",
        "liver",
        "oil",
        "mint",
        "flavor",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 20.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790366855365",
      "vsf_explanation": "Cod liver oil delivers EPA/DHA plus vitamins A and D. Emulsified format improves absorption and palatability. Evidence for omega-3 cardiovascular endpoints has weakened in recent large trials (VITAL 2018 largely null for CVD prevention), though triglyceride-lowering is robust. Vitamin A content requires attention for pregnancy and cumulative dosing. EPA/DHA and vitamin A/D mg not visible at label level. Would move to Verified 70+ with per-nutrient mg disclosure, IFOS certification, and oxidation-parameter testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "extra-strength-melatonin-100-drug-free",
      "title": "Extra Strength Melatonin - 100% Drug Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f03fec17-7678-4809-8194-3447532b1aa9_large_852d14db-16e8-4058-81f4-84616da9c7fa.jpg?v=1787416756",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "extra",
        "strength",
        "melatonin",
        "100",
        "drug",
        "free",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 54,
        "manufacturing": 60,
        "safety": 52,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 7.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790366822597",
      "vsf_explanation": "Extra-strength melatonin (5-10mg typical) - well above the physiological 0.3-1mg that Auld 2017 meta and Zhdanova 2001 identify as most aligned with endogenous secretion and effective for sleep-onset. Higher doses associated with more morning grogginess and vivid dreams. '100% drug free' framing understates melatonin is a hormone. Would move to Verified 70+ by dropping to 0.5-1mg with physiological-dose rationale.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-blessed-thistle",
      "title": "Full Spectrum Blessed Thistle",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3bf03fdb-eda6-4758-8c41-dcf74fc4bf7f_large_da09448a-c650-46d4-87e7-5616cc084300.jpg?v=1787416756",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "blessed",
        "thistle",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 3.91,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790366920901",
      "vsf_explanation": "Blessed thistle (Cnicus benedictus) is a traditional bitter tonic and galactagogue with minimal modern evidence. Different genus than milk thistle (Silybum marianum). Contains cnicin which can irritate GI at high doses. Would need controlled trial evidence to move higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "black-cumin-seed-full-spectrum",
      "title": "Black Cumin Seed - Full Spectrum",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/062a07e9-3fab-4d3e-847d-f20105ca9ffe_large_97d208dd-d297-4eca-b584-2ef8d1134ed8.jpg?v=1787416756",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "black",
        "cumin",
        "seed",
        "full",
        "spectrum",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 6.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790366953669",
      "vsf_explanation": "Black cumin (Nigella sativa) has RCT signal for BP, lipid, and metabolic markers (Sahebkar 2016 meta-analysis) — thymoquinone is the primary active. Whole-seed powder without % thymoquinone standardization delivers modest actives. Oil format is generally more studied. Would move to Verified 70+ with thymoquinone-standardized oil or extract.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "focused-attention-alpinia-galanga-caffeine-free",
      "title": "Focused Attention Alpinia Galanga - Caffeine-Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/719462ee-fd49-4395-a624-35811e2495c6_large_f1aaffb4-0e63-472c-b1b4-00ba1d3fcb5c.jpg?v=1787416756",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "focused",
        "attention",
        "alpinia",
        "galanga",
        "caffeine",
        "free",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 14.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790366986437",
      "vsf_explanation": "Alpinia galanga extract (likely EnXtra) has small-RCT evidence for sustained attention and alertness without caffeine's crash (Srivastava 2017; single RCT). The evidence base is thin - one manufacturer-sponsored RCT is not strong replication. Being caffeine-free is a genuine differentiator for caffeine-sensitive users. Would move to Verified 70+ with independent RCT replication and explicit branded-material disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dmae-complex-with-vitamins-b5-and-b6",
      "title": "DMAE Complex with Vitamins B5 and B6",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/304d64cb-c169-4e21-88d0-7a45552c9320_large_15fa1712-c0ec-4561-a854-94d36f3e4093.jpg?v=1787416761",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dmae",
        "complex",
        "with",
        "vitamins",
        "and",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 11.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790368329925",
      "vsf_explanation": "DMAE has weak-to-modest human evidence for cognition and attention (a handful of studies, small samples), and safety concerns include teratogenicity in animal models and mixed reports for ADHD/mood in pediatric use. Pairing with B5/B6 is generic B-complex support. Held at low-Standard by weak effect-size evidence, safety-flag concerns (avoid in pregnancy), and B6 peripheral-neuropathy risk at chronic higher doses (dell'Aquila 2018).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "folic-acid",
      "title": "Folic Acid",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1fe4bbf9-a66f-4f16-8fbb-5d6ec83b8c27_large_07fd4fcd-6f32-4374-8cfd-6c52af1d1780.jpg?v=1787416761",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "folic",
        "acid",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 52,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 7.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790368395461",
      "vsf_explanation": "Synthetic folic acid has strong evidence for neural tube defect prevention (MRC 1991) and is inexpensive and stable, but it is a non-bioactive form that must be reduced to 5-MTHF — a step impaired in MTHFR C677T/A1298C carriers (Obeid & Herrmann 2012). Unmetabolized folic acid accumulation has been raised as a concern (Smith 2008 AJCN). Held below Verified by non-bioactive form choice. Would move to Verified 70+ if reformulated as 5-MTHF (Quatrefolic/Metafolin).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "extra-strength-zinc-picolinate-body-preferred-form",
      "title": "Extra Strength Zinc Picolinate - Body Preferred Form",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b797a2e6-a84e-4657-9b2e-34cb85360715_large_973bd29f-bfea-4a45-a4ec-28e3692ff053.jpg?v=1787416761",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "extra",
        "strength",
        "zinc",
        "picolinate",
        "body",
        "preferred",
        "form",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 68,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790368362693",
      "vsf_explanation": "Extra-strength zinc picolinate — chelated form (Barrie 1987 preliminary absorption data) at higher dose (likely 30-50mg elemental). Standard tier upper end. High-dose zinc requires copper co-factoring to prevent depletion (Fischer Walker 2007). Would move to Verified with Albion TRAACS chelate, copper pairing, and NSF verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-fenugreek-seed",
      "title": "Full Spectrum Fenugreek Seed",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/32e7c123-42ca-4bf5-8b22-686e123d39af_large_2779b304-24a1-4a29-8f56-8cd12bd4ed3d.jpg?v=1787416761",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "fenugreek",
        "seed",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 6.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790368428229",
      "vsf_explanation": "Fenugreek seed has good evidence for glycemic control and modest testosterone support (Rao 2016 for testosterone via Testofen branded extract). Whole-seed powder without saponin standardization delivers uncertain actives. Would move to Verified 70+ with Testofen or Furosap branding at clinical dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-feverfew",
      "title": "Full Spectrum Feverfew",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/25ecd7db-9736-4d5d-ad74-efa5a2d414fb_large_4ac15d22-74b3-4375-96b4-616b174e50f0.jpg?v=1787416761",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "feverfew",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 55,
        "sustainability": 52
      },
      "price": 7.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790368460997",
      "vsf_explanation": "Feverfew (Tanacetum parthenium) has migraine-prophylaxis RCT evidence (Diener 2005 MIG-99 with defined parthenolide content showed reduced migraine frequency). Whole-herb without parthenolide standardization delivers highly variable active dose — parthenolide content can range 5-fold across commercial products. Would move to Verified 70+ with 0.2-0.7% parthenolide standardization (MIG-99 protocol).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-lysine-free-form",
      "title": "L-Lysine - Free Form",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e7a0cf3d-08aa-4b1c-bc45-9eedf70635e7_large_d6b88550-580b-4970-adc9-9e25366a0996.jpg?v=1787416761",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lysine",
        "free",
        "form",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 18.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790368493765",
      "vsf_explanation": "L-lysine has RCT support for cold-sore prevention and duration at 1-3 g/day (Griffith 1987; Milman 1980). Free-form is the correct format. Solid mid-tier value. Would move to Verified 70+ with named fermentation source and third-party purity testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-14-mushroom-complex",
      "title": "Full Spectrum 14 Mushroom Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/59d1cd5c-08e6-4310-9ac5-e903d395a284_large_bf061379-f547-4f9d-9d0e-253f811d00f6.jpg?v=1787416761",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "mushroom",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 50,
        "sustainability": 62
      },
      "price": 7.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790368526533",
      "vsf_explanation": "Fourteen-mushroom whole-body complex — the doubling of species over the 7-mushroom SKU makes the per-mushroom dose even smaller. Marketing-driven breadth without pharmacological depth. Would move up substantially with dual-extract processing and fewer, better-characterized species at meaningful individual doses.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dmae-serum",
      "title": "DMAE Serum",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c92c2c6e-e638-40f5-b7d0-73ef356f8d91_large_30557b42-7d80-4de7-ae6b-330405daf114.jpg?v=1787416761",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dmae",
        "serum",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 7.45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790368559301",
      "vsf_explanation": "Topical DMAE serum - not an ingestible supplement. Topical DMAE has some short-term skin-firmness perception data but weak long-term evidence and mechanistic concerns about fibroblast vacuolation in older lab work. This falls outside the biohacking supplement scoring scope; recommend moving to a separate cosmetic evaluation.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "l-lysine-free-form-1",
      "title": "L-Lysine - Free Form",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3d8b011d-fcc9-4b82-889e-cb61f2762326_large_eaa7d831-7f4a-4fd5-bf32-897bef9eb6f8.jpg?v=1787416761",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lysine",
        "free",
        "form",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790368624837",
      "vsf_explanation": "Duplicate SKU of free-form L-lysine — solid cold-sore prevention evidence at 1-3 g/day (Griffith 1987). Correct free-form. Would move to Verified 70+ with third-party assay and named source.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-potential-vegan-protein-vanilla",
      "title": "Full Potential Vegan Protein - Vanilla",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0aba0f20-4d4e-499a-aee0-22fcf4c97a2f_large_0a9de63c-d113-43bb-86dc-737e38000ba7.jpg?v=1787416761",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "potential",
        "vegan",
        "protein",
        "vanilla",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 60,
        "sustainability": 62
      },
      "price": 39.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790368592069",
      "vsf_explanation": "Vanilla vegan blend under Swanson's 'Full Potential' line. Vegan pea-rice blends can hit whey-comparable MPS response at appropriate ratios (Banaszek 2019). Held at Standard on the same gaps as the chocolate: no component ratio disclosed, no per-serving protein/leucine, and no heavy-metal COA. Would move to Verified 70+ with disclosed protein/leucine, published heavy-metal testing, and third-party certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "elderberry",
      "title": "Elderberry",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0132d610-9af6-4e2e-955c-7a1f0fd8e35d_large_0113516a-9ed9-4f6d-839d-b6394171bff5.jpg?v=1787416762",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "elderberry",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 55,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 5.65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790368657605",
      "vsf_explanation": "Basic elderberry SKU — most likely whole-berry or low-extraction powder given the plain-title Swanson naming pattern. Elderberry has real cold/flu-duration data with standardized extracts (Tiralongo 2016; Zakay-Rones 2004) but generic berry powder underdelivers on anthocyanins versus a standardized extract like Sambucol or ElderCraft. Would move up substantially with anthocyanin standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-bitter-melon",
      "title": "Full Spectrum Bitter Melon",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/feabb8b7-cf93-4e5f-9a57-d3797e015b09_large_154b5794-a551-4c3c-9b2c-c36afb5451ee.jpg?v=1787416762",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "bitter",
        "melon",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 10.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790369345733",
      "vsf_explanation": "Bitter melon (Momordica charantia) has small RCT signals for glucose reduction — mixed results (Yin 2012 meta-analysis showed modest effect). Whole-fruit powder without charantin/vicine standardization limits potency. Not for pregnancy — abortifacient. Would move higher with charantin standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-potential-whey-protein-vanilla",
      "title": "Full Potential Whey Protein - Vanilla",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0140f886-f539-4fb2-9209-48b51dcb2273_large_546b726b-7999-4a31-b6fd-de162bb15ed6.jpg?v=1787416763",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "potential",
        "whey",
        "protein",
        "vanilla",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790369378501",
      "vsf_explanation": "Vanilla whey under Swanson's 'Full Potential' sub-brand. Whey at 20-40g/serving is well-established for post-workout MPS (Morton 2018 meta). Held at Standard because concentrate-vs-isolate is not confirmed at title level, sourcing (grass-fed vs commodity) not disclosed, and no NSF certification. Would move to Verified 70+ with confirmed isolate base, grass-fed sourcing, and published heavy-metal COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-potential-whey-protein-chocolate",
      "title": "Full Potential Whey Protein - Chocolate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/67ce508b-2bba-400e-9e8b-aace1593ead7_large_dcca9f81-1279-4503-924b-45497192e632.jpg?v=1787416762",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "potential",
        "whey",
        "protein",
        "chocolate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790369411269",
      "vsf_explanation": "Chocolate whey under Swanson's 'Full Potential' line. Same evidence base as the vanilla (Morton 2018 for whey anabolic response). Chocolate adds cadmium exposure concern from cocoa content, making heavy-metal testing more important. Would move to Verified 70+ with confirmed isolate base, grass-fed sourcing, and published heavy-metal testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "avena-sativa-1",
      "title": "Avena Sativa",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/184693cc-15fd-449a-b4fa-a4d2409cdc4e_large_872a4ec5-e044-4df8-bf9b-a3e571442a60.jpg?v=1787416763",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "avena",
        "sativa",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 66,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 2.45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790369444037",
      "vsf_explanation": "Avena sativa (green oat) is marketed for libido and cognition. Cognition/attention has small RCT support with the Neuravena branded extract (Kennedy 2013). Libido claims are traditional, without controlled trial support. Generic whole-plant form without Neuravena branding lacks trial evidence. Would move higher with Neuravena format.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-cacao-raw-cocoa",
      "title": "Full Spectrum Cacao (Raw Cocoa)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8f153104-964b-4677-8999-c6dd9eb48483_large_0ae3aa33-7391-435d-85cc-b4a98467afe3.jpg?v=1787416764",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "cacao",
        "raw",
        "cocoa",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790369509573",
      "vsf_explanation": "Cocoa flavanols have solid RCT evidence for endothelial function and BP (Ried 2017 Cochrane review) at 200-500 mg flavanol dose. Raw cacao powder retains more flavanols than Dutch-processed. Without % flavanol standardization, per-capsule active is uncertain. Caffeine and theobromine content. Would move to Verified 70+ with CocoaVia or similar flavanol standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "arjuna-bark-10-1-extract",
      "title": "Arjuna Bark 10:1 Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a4872986-9679-4ed0-909e-7022435a3405_large_b38fbfc1-050a-42e5-bdff-dfc27215e847.jpg?v=1787416764",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "arjuna",
        "bark",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 5.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790369542341",
      "vsf_explanation": "Arjuna (Terminalia arjuna) has RCT evidence for heart failure and angina in the Indian literature (Bharani 2002 — CHF). 10:1 extract is a real concentration and disclosed on label — a formulation win. Not to be used with cardiovascular drugs without physician oversight. Would move to Verified 70+ with % arjunolic acid standardization at clinical dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-corydalis",
      "title": "Full Spectrum Corydalis",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5765f2be-ab08-4ac2-badf-f8e6e7921949_large_d3d1a797-1741-49a3-ae3f-c9d683b46656.jpg?v=1787416764",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "corydalis",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 15.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790369575109",
      "vsf_explanation": "Corydalis yanhusuo contains dehydrocorybulbine (DHCB), a dopamine D2 antagonist with some rodent analgesic data (Zhang 2014, UC Irvine). Whole-root powder without DHCB standardization is unlikely to deliver clinical doses. Not for pregnancy or with dopamine-affecting drugs. Would move higher with DHCB standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "aronia-black-chokeberry-fruit",
      "title": "Aronia Black Chokeberry Fruit",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/41a59a59-1ffb-4b50-9e8d-ff36318e93ad_large_effed3d3-c304-498d-8511-085c2ea71d3f.jpg?v=1787416766",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "aronia",
        "black",
        "chokeberry",
        "fruit",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 2.92,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790370132165",
      "vsf_explanation": "Aronia (black chokeberry) has among the highest ORAC of any berry with RCT signal for BP and endothelial function (Naruszewicz 2007). Whole-fruit powder without anthocyanin standardization limits potency. Would move to Verified 70+ with % anthocyanin standardization and disclosed serving mg.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-ginkgo-leaf",
      "title": "Full Spectrum Ginkgo Leaf",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/80f2911d-b518-40e6-bcd0-a6cf8e733bc2_large_c3205682-22c3-4cc7-9145-cb335feb7182.jpg?v=1787416767",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "ginkgo",
        "leaf",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 52,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 6.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790370164933",
      "vsf_explanation": "Whole-herb, unstandardized ginkgo leaf. Positive cognitive RCTs universally used the 24% flavone-glycoside / 6% terpene-lactone standardized extract (EGb 761 template) rather than raw leaf, and ginkgolic-acid contamination is a real concern in unrefined material (EGb 761 caps ginkgolic acid below 5 ppm). Same bleeding-risk anticoagulant interaction applies. Would move to Verified 70+ with a switch to a standardized extract with ginkgolic-acid limits disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-chaga-mushroom",
      "title": "Full Spectrum Chaga Mushroom",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/da35941b-3c94-4ec0-96fd-9791864afef9_large_bb55ed74-3d4d-4d9a-b6fe-6bd8593dd252.jpg?v=1787416767",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "chaga",
        "mushroom",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 50,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 7.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790370689221",
      "vsf_explanation": "Whole-chaga (Inonotus obliquus) sclerotia powder. Chaga contains high oxalate (Kikuchi 2014 case report of oxalate nephropathy) — genuine safety flag that whole-body powdered products don't mitigate. Beta-glucan/betulinic acid activity requires dual extraction; whole-mass powder delivers polysaccharides poorly. Overharvesting from wild birch has real sustainability concerns. Held to low Standard by all three factors. Would move up with dual-extract, sustainable cultivation sourcing, and oxalate-content labeling.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-potential-vegan-protein-chocolate",
      "title": "Full Potential Vegan Protein - Chocolate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c4614e45-0b2d-4eb5-904b-00c55fd24dc4_large_6719e234-c460-4951-b3de-bf622f3ba793.jpg?v=1787416767",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "potential",
        "vegan",
        "protein",
        "chocolate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 60,
        "sustainability": 62
      },
      "price": 66.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790370721989",
      "vsf_explanation": "Chocolate vegan protein blend under Swanson's 'Full Potential' sub-brand — vegan blends work well when pea and rice are combined at roughly a 70:30 ratio to complete the amino profile (Banaszek 2019 showed pea-rice performing comparably to whey). Held at Standard because component ratio is not confirmed at title level, per-serving protein and leucine dose is not disclosed, and no heavy-metal COA published (chocolate/cocoa raises the cadmium exposure question). Would move to Verified 70+ with disclosed protein/leucine per serving, published heavy-metal testing, and third-party certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-barberry-root-bark",
      "title": "Full Spectrum Barberry Root Bark",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a751b3b6-693f-4cff-97ff-674c5cea2f55_large_5114445f-c53d-48b4-a947-e74d784f7c4f.jpg?v=1787416767",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "barberry",
        "root",
        "bark",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 2.7,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790370754757",
      "vsf_explanation": "Barberry root contains berberine — same active as goldenseal — with metabolic and antimicrobial evidence (Yin 2008 for glucose). Whole-bark without berberine % standardization delivers unpredictable actives. Berberine has CYP3A4 interactions and pregnancy contraindication. Would move higher with % berberine standardization at clinical dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-amla-fruit",
      "title": "Full Spectrum Amla Fruit",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/097e692e-5f9f-4c5a-84cb-dd0a2914e6fd_large_6b645076-af55-428b-a779-bb3f12a615ca.jpg?v=1787416767",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "amla",
        "fruit",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 16.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790370787525",
      "vsf_explanation": "Amla (Emblica officinalis, Indian gooseberry) has RCT signal for lipid profile and antioxidant markers (Antony 2008). Rich in polyphenols and vitamin C. Whole-fruit powder without tannin/vitamin C standardization. Would move to Verified 70+ with Capros branded ingredient or polyphenol standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-7-mushroom-complex",
      "title": "Full Spectrum 7 Mushroom Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9b921ddd-cf85-4378-aea5-b59c284081d6_large_1db62190-8dc8-41b2-b50c-43964306861f.jpg?v=1787416768",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "mushroom",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 50,
        "sustainability": 62
      },
      "price": 15.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790370820293",
      "vsf_explanation": "Seven-mushroom whole-body complex — breadth over depth. Each individual mushroom is present at whole-herb dose without extraction, so no single active reaches a level supported by clinical dosing. Fruiting body vs mycelium sourcing not disclosed. Would move up substantially with dual-extract processing and per-mushroom fruiting-body confirmation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-cinnamon",
      "title": "Full Spectrum Cinnamon",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5b3f24a0-c830-4671-9878-9686abc2e3f5_large_63d72a17-fb91-4939-a788-b34b8260375d.jpg?v=1787416768",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "cinnamon",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 52,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 6.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790370853061",
      "vsf_explanation": "Whole-herb cinnamon without species disclosure. Cassia contains coumarin (EFSA TDI 0.1 mg/kg) — daily supplement doses of Cassia can exceed TDI and are a hepatotoxicity concern. Modest glucose signal per Allen 2013. Would move to Standard 65+ with Ceylon (C. verum) species disclosure or water-extract format.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "citrus-bioflavonoid-complex-full-spectrum",
      "title": "Citrus Bioflavonoid Complex - Full Spectrum",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2f59213a-125d-4e8a-93ad-547288e9f393_large_64c05a3b-62a5-46f0-9ac1-74e7a53506e0.jpg?v=1787416768",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "citrus",
        "bioflavonoid",
        "complex",
        "full",
        "spectrum",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 25.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790370885829",
      "vsf_explanation": "Citrus bioflavonoid complex typically contains hesperidin, rutin, quercetin, and eriocitrin blend. Modest evidence for capillary integrity and venous tone. Without per-ingredient mg disclosure, the complex is opaque. Would move to Verified 70+ with per-flavonoid mg breakdown and 2S-hesperidin format.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-coleus-forskohlii",
      "title": "Full Spectrum Coleus Forskohlii",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/160da692-ffdf-4484-a7a4-ebd04aa1dbbb_large_b074b13e-0ce5-4df1-91d3-260fdf07b300.jpg?v=1787416768",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "coleus",
        "forskohlii",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 58,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 10.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790370918597",
      "vsf_explanation": "Coleus forskohlii is the source of forskolin, marketed heavily for weight loss on the basis of one small Godard 2005 trial. Whole-root without % forskolin standardization delivers negligible active. Weight-loss efficacy has failed to replicate. Would move higher with 10-20% forskolin standardization and honest evidence framing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-catnip",
      "title": "Full Spectrum Catnip",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0911e062-1eaa-40d1-913d-b95ddaf4ccdd_large_4aa44105-3952-4d0b-be7a-f211d93078a8.jpg?v=1787416769",
      "score": 53,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "catnip",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 2.25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790370951365",
      "vsf_explanation": "Catnip (Nepeta cataria) has traditional mild sedative and GI use in humans but essentially no modern RCT support. Nepetalactone doesn't produce the same effects in humans as in cats. Uterine stimulant — pregnancy contraindication. Weak evidence base overall.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "calendula-flower",
      "title": "Calendula Flower",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b8f6a769-6231-40a5-8c7a-829e4453229c_large_a29f4eab-ff72-4da7-9f7a-644a76b6509c.jpg?v=1787416771",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "calendula",
        "flower",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 7.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790371606725",
      "vsf_explanation": "Calendula (Calendula officinalis) is a traditional wound-healing herb; strong topical evidence (Pommier 2004 radiodermatitis RCT). Oral capsule use has minimal clinical evidence — most benefit is topical. Legit traditional herb; safe. Would need oral clinical evidence to justify higher positioning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-black-currant",
      "title": "Full Spectrum Black Currant",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0c13d8f7-b5b5-4162-84db-8bacd9e329e2_large_7f823509-4108-4be8-9989-54f58d318c05.jpg?v=1787416771",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "black",
        "currant",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 66,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 6.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790371573957",
      "vsf_explanation": "Black currant is a source of anthocyanins and GLA (from seed oil). Fruit powder provides anthocyanins; seed oil provides GLA. Full-spectrum whole-fruit form has modest actives without standardization. Would move to Verified 70+ with named anthocyanin % or GLA-standardized seed oil format.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "daitea-hydrolyzed-collagen-supplement-supports-healthy-skin-joints-hair-nails-antioxidant-dietary-supplement",
      "title": "Daitea Hydrolyzed Collagen Supplement – Supports Healthy Skin, Joints, Hair, Nails - Antioxidant - Dietary Supplement",
      "vendor": "Silcy Skin",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Scd957fd4ba4e4b44abbb0d034916a7d7m.webp?v=1787416775",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "daitea",
        "hydrolyzed",
        "collagen",
        "supplement",
        "supports",
        "healthy",
        "skin",
        "joints",
        "hair",
        "nails",
        "antioxidant",
        "dietary",
        "supplement",
        "silcy",
        "skin"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 33.94,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790373802181",
      "vsf_explanation": "Hydrolyzed collagen has real skin-elasticity RCT support (Proksch 2014, Genovese 2017 for Verisol), but effect sizes are modest and generally require ~2.5-10g/day. This label doesn't disclose peptide type (Verisol/Peptan), source (bovine/marine), or per-serving mg. Silcy Skin is a small brand with no visible third-party testing. Would move to Standard 65+ with named peptide sourcing (Peptan/Verisol), heavy-metal testing, and clear per-serving grams.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "plant-therapy-liver-tonic-herbal-supplement-milk-thistle-turmeric-dandelion-120-vegetarian-capsules",
      "title": "Plant Therapy Liver Tonic Herbal Supplement – Milk Thistle, Turmeric & Dandelion, 120 Vegetarian Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/image_4f8130d3-c82b-4295-987a-bd28905b41bb.png?v=1787416788",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "plant",
        "therapy",
        "liver",
        "tonic",
        "herbal",
        "supplement",
        "milk",
        "thistle",
        "turmeric",
        "dandelion",
        "120",
        "vegetarian",
        "capsules",
        "singers",
        "health",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 60,
        "sustainability": 62
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790379241669",
      "vsf_explanation": "Milk thistle + turmeric + dandelion is a well-established hepatic-support stack. Milk thistle silymarin has moderate RCT evidence for hepatic protection (Kim 2020 meta), curcumin needs bioavailability enhancement for meaningful effect, and dandelion has traditional-use support. Plant Therapy is best known for essential oils; their supplement line is less studied. Standardization percentages and per-active mg not visible from title. Would move to Verified 70+ with 80% silymarin and curcumin-phytosome or piperine disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hi-tech-somatomax",
      "title": "Hi-Tech Somatomax",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Hi-Tech-Somatomax.jpg?v=1787416789",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tech",
        "somatomax",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 50,
        "manufacturing": 40,
        "safety": 30,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 44.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790379733189",
      "vsf_explanation": "Hi-Tech Pharmaceuticals Somatomax is marketed as a GHB/growth-hormone-alternative sleep aid built around GABA/phenibut-family compounds. Phenibut is a prescription-controlled anxiolytic in many jurisdictions, has genuine dependence potential, and the FDA has issued warning letters to Hi-Tech Pharmaceuticals over similar products. Safety and regulatory concerns dominate this scoring; evidence for the composite formula is essentially anecdotal. This is not a supplement I would recommend on a biohacking rubric.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-mullein-leaf-capsules-10-1-extract-500-mg-per-veggie-caps-150-count-verbascum-thapsus-non-gmo-vegan-dietary-supplement",
      "title": "NusaPure Mullein Leaf Capsules 10:1 Extract, 500 mg per Veggie Caps - 150 Count - Verbascum Thapsus (Non-GMO, Vegan) Dietary Supplement",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-130529v4-Mullein-3d_-01.jpg?v=1787416801",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "mullein",
        "leaf",
        "capsules",
        "extract",
        "500",
        "per",
        "veggie",
        "caps",
        "150",
        "count",
        "verbascum",
        "thapsus",
        "non",
        "gmo",
        "vegan",
        "dietary",
        "supplement",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 18.58,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790382551237",
      "vsf_explanation": "NusaPure Mullein 500mg 10:1 extract (5g raw-equivalent) is a solid capsule format for a traditional respiratory herb. Human RCT evidence for mullein is very limited — mostly ethnobotanical and preclinical use for cough and mild bronchitis. NusaPure discloses extract ratio clearly but no third-party COA or NSF certification per SKU. Would move to Verified 70 with modern clinical trials and independent lot testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cerebramax-plus-citicoline-supplement-for-cognitive-support-liquid-dietary-supplement-for-brain-health-children-adults-60-ml",
      "title": "Cerebramax Plus Citicoline Supplement for Cognitive Support - Liquid Dietary Supplement for Brain Health, Children & Adults - 60 ml",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/PwBXlLRcOqJ2YjEdIgs71kAAuGYmYYriXJbItBhq.jpg?v=1787416809",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "youth_under_18",
      "tokens": [
        "cerebramax",
        "plus",
        "citicoline",
        "supplement",
        "for",
        "cognitive",
        "support",
        "liquid",
        "dietary",
        "supplement",
        "for",
        "brain",
        "health",
        "children",
        "adults",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 55,
        "manufacturing": 48,
        "safety": 55,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.56,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790384550085",
      "vsf_explanation": "Citicoline (CDP-choline) has decent RCT evidence for post-stroke cognitive recovery and adult cognition (McGlade 2015 for young adults, Alvarez-Sabin 2013 for stroke). This is a liquid multi-active pediatric formulation from a Turkish reseller channel with no per-mL citicoline mg disclosed. Cognizin (Kyowa Hakko) branding not visible. Pediatric use of citicoline is off-label with limited safety data. Would move to Verified 70+ with Cognizin sourcing, clear mg/mL, and independent US-market batch data.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-cramp-bark",
      "title": "Full Spectrum Cramp Bark",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/49858d06-e1a6-426c-8cec-5ed5625b331d_large_9815433f-f346-4082-ad12-466552c54f2a.jpg?v=1787416823",
      "score": 53,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "cramp",
        "bark",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 64,
        "transparency": 55,
        "sustainability": 52
      },
      "price": 4.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790386942149",
      "vsf_explanation": "Cramp bark (Viburnum opulus) has traditional use for menstrual cramps but essentially no controlled clinical evidence. Whole-bark powder without characterized actives. Would move to Standard 60+ with controlled trials for dysmenorrhea and named-marker standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-irish-moss",
      "title": "Full Spectrum Irish Moss",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/faba5836-ce3d-4999-a9d3-0c6cfdb67d64_large_abac8848-68b3-4ea9-b229-16697a5b3fe1.jpg?v=1787416823",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "irish",
        "moss",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 7.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790387007685",
      "vsf_explanation": "Irish moss (Chondrus crispus) is a red seaweed source of carrageenan and iodine. Carrageenan has raised gut-inflammation concerns in animal work (Tobacman 2001) though FDA maintains food-grade safety. Iodine content variable — thyroid caution. Would need iodine-standardized content and gut-safety framing to move higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-ginger-turmeric-2-in-1-formula",
      "title": "Full Spectrum Ginger & Turmeric - 2-in-1 Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9d1a9dc4-e7f6-4043-a3ea-d1485e5a21d3_large_1bfbcadc-1f3e-421d-b33f-43609802ae3a.jpg?v=1787416823",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "ginger",
        "turmeric",
        "formula",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 55,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 6.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790386974917",
      "vsf_explanation": "Whole-herb ginger + turmeric blend — same recurring problem: no piperine and no standardization means very low systemic curcumin. Ginger contributes anti-nausea (Ernst 2000) and modest anti-inflammatory activity even in whole-root form (gingerols are relatively bioavailable). Would move up with piperine and curcuminoid standardization on the turmeric side.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chinese-skullcap",
      "title": "Chinese Skullcap",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0eb2d73f-ec63-4a4b-8aa1-c1451cfd788f_large_4722f048-f5be-48b0-98b3-bf0c638c4faf.jpg?v=1787416823",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chinese",
        "skullcap",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790387204293",
      "vsf_explanation": "Chinese skullcap (Scutellaria baicalensis) contains baicalin and baicalein with anti-inflammatory activity. Combination products with Scutellaria have raised hepatotoxicity concerns (LiverTox has documented cases). Whole-root without % baicalin standardization delivers uncertain actives. Would move higher with baicalin standardization plus liver-safety framing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "herbal-circulatory-care",
      "title": "Herbal Circulatory Care",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/843497d4-96fb-4fcd-94c5-99efd6a4944e_large_55b0cb48-8d20-47a8-863b-241749a021f8.jpg?v=1787416823",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "herbal",
        "circulatory",
        "care",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 8.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790387040453",
      "vsf_explanation": "Herbal circulatory formulas typically stack cayenne, hawthorn, ginkgo, or garlic. Without a per-ingredient breakdown in the title it's unclear which actives at what dose. Watch for proprietary-blend labeling. Would move to Verified 70+ with disclosed per-ingredient mg and standardized hawthorn or ginkgo actives.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "elecampane-root-4-1-extract",
      "title": "Elecampane Root - 4:1 Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ec193ca8-82a1-4de3-92ec-8eef8c4cd182_large_32c044d3-f39a-45a3-a18b-97152ab62513.jpg?v=1787416823",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "elecampane",
        "root",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 3.25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790387073221",
      "vsf_explanation": "Elecampane (Inula helenium) is a traditional respiratory-tract herb with inulin and sesquiterpene lactones (alantolactone). 4:1 extract is a modest concentration; better than whole-herb powder for potency. Contact-dermatitis risk from sesquiterpene lactones. Would move higher with modern RCT support and marker standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-holy-basil-leaf",
      "title": "Full Spectrum Holy Basil Leaf",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/67d9ce3e-44b7-4aca-b8c6-711ccd82afe4_large_651d20be-9db0-4fa5-acab-c29569859b05.jpg?v=1787416823",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "holy",
        "basil",
        "leaf",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 52,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 10.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790387105989",
      "vsf_explanation": "Whole-leaf 'full spectrum' holy basil — the RCT evidence for holy basil stress benefit (Bhattacharyya 2008, Saxena 2012) is on standardized extract material at 300-500mg BID. Whole-leaf preparations may deliver a small fraction of the active constituents (ursolic acid, eugenol, rosmarinic acid) delivered by standardized extracts, so studied thresholds are not confirmed. Held at Standard because the whole-leaf format cannot guarantee active-constituent delivery. A standardized extract at studied dose is a strictly better format for stress-reduction outcomes.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hydrangea-root-extract-4-1-extract",
      "title": "Hydrangea Root Extract - 4:1 Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4c5e0c59-50c9-4738-96d2-98fbbfdd9f66_large_6d5b270b-fcff-4924-8c4d-ee1ac4514b71.jpg?v=1787416823",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hydrangea",
        "root",
        "extract",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790387826885",
      "vsf_explanation": "Hydrangea root is traditionally used for urinary and kidney stones with essentially no modern RCT support. 4:1 extract is a modest concentration. Legit traditional herb but very weak evidence base. Would need controlled trial support to justify a higher tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "herbal-urinary-care-featuring-cranberry",
      "title": "Herbal Urinary Care - Featuring Cranberry",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/63c986ce-603f-4e1f-9a7d-8a5d12ffcd56_large_9ca8d3be-54fb-47af-80fe-d25fe8fad224.jpg?v=1787416823",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "herbal",
        "urinary",
        "care",
        "featuring",
        "cranberry",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 66,
        "transparency": 48,
        "sustainability": 52
      },
      "price": 5.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790387171525",
      "vsf_explanation": "Multi-herb urinary-support blend featuring cranberry. Cranberry has modest recurrent-UTI evidence (Jepson 2012) at 36 mg PAC/day. Combination herbal formulas often obscure per-ingredient dosing behind proprietary blends. Would move to Standard 65+ with per-ingredient mg disclosure and cranberry PAC standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-cinnamon-fenugreek-gymnema",
      "title": "Full Spectrum Cinnamon, Fenugreek & Gymnema",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e90aa7e6-3307-4c91-8a49-fa66e9ff8cf8_large_8d6de481-c607-458f-81c1-2df9f5f3aa32.jpg?v=1787416823",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "cinnamon",
        "fenugreek",
        "gymnema",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 55,
        "sustainability": 52
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790387138757",
      "vsf_explanation": "Three-herb glucose-support stack. Cinnamon (Allen 2013 modest fasting-glucose signal), fenugreek (Neelakantan 2014 meta-analysis showed HbA1c reduction at 5-10 g/day of whole seed), and gymnema (small trials for glucose and sweet taste suppression). Each herb studied at doses much higher than typical multi-herb blend delivery per capsule. Cinnamon species not disclosed (coumarin risk). Would move to Standard 65+ with Ceylon-cinnamon disclosure, per-herb mg on the label, and studied-dose alignment.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "prebiotic-jerusalem-artichoke-90-inulin",
      "title": "Prebiotic Jerusalem Artichoke - 90% Inulin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/313b0ed5-2dc6-40c5-bb14-9bc468538526_large_737e12c9-b3d3-4d9d-a599-2557b092cfac.jpg?v=1787416823",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "prebiotic",
        "jerusalem",
        "artichoke",
        "inulin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 66,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 68,
        "sustainability": 60
      },
      "price": 5.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790387794117",
      "vsf_explanation": "Jerusalem artichoke standardized to 90% inulin — a specific, disclosed standardization is a strong transparency signal. Inulin's bifidogenic evidence is solid (Kolida 2007; Vandeputte 2017). Would move to Verified with a serving-size scoop delivering the 5-8g/day studied range and heavy-metal test disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-herbal-gallbladder-care",
      "title": "Full Spectrum Herbal Gallbladder Care",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ef413b29-99ba-46c0-bd18-0f3b7d8b45c2_large_b6f2a351-a7a3-4953-9cf1-2121970868ad.jpg?v=1787416823",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "herbal",
        "gallbladder",
        "care",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 6.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790387892421",
      "vsf_explanation": "Herbal gallbladder blends typically feature milk thistle, artichoke, dandelion, ox bile — mixed evidence for each. Named actives and per-ingredient mg not visible from title. Cholagogue herbs contraindicated in bile-duct obstruction — real safety concern. Would move higher with per-ingredient mg and contraindication disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-herbal-joint-care",
      "title": "Full Spectrum Herbal Joint Care",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d5cc7ff1-9472-4f31-b8c0-e9eb5c686b3a_large_ef3274f6-1ccf-41fd-b3d6-bcf96ba3883c.jpg?v=1787416823",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "herbal",
        "joint",
        "care",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 6.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790387859653",
      "vsf_explanation": "'Full spectrum' herbal joint blend — Swanson's 'full spectrum' line uses raw ground herb rather than standardized extract, which typically means unpredictable actives content. Turmeric, Boswellia, ginger have good OA evidence but only at proper standardization (Sengupta 2008 for AKBA 30%+ Boswellia, Daily 2016 meta-analysis for curcumin bioavailable forms). Held below Verified by non-standardized raw herbs and no per-herb mg disclosure. Would move to Verified 70+ with standardization percentages.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-green-coffee-bean",
      "title": "Full Spectrum Green Coffee Bean",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/77edb538-e6f7-4e91-9673-325eb875a9f7_large_a9b3bf81-5ec9-46e5-bca7-b2b87a24dcea.jpg?v=1787416823",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "green",
        "coffee",
        "bean",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 8.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790387925189",
      "vsf_explanation": "Green coffee bean is primarily marketed for weight loss based on Vinson 2012, which was later retracted after FTC v. Applied Food Sciences (2014 $3.5M settlement over false weight-loss claims). Chlorogenic acid has modest blood-pressure and postprandial glucose signal but the weight-loss positioning is discredited. Non-standardized 'full spectrum' form has no bioactive anchor. Would not recommend for weight loss.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-african-mango-irvingia-gabonensis",
      "title": "Full Spectrum African Mango Irvingia Gabonensis",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d14e0910-611f-48d6-ba62-aaa1f7ec744f_large_c19d590b-e2b4-4664-8947-ddd2d5b2c8d1.jpg?v=1787416823",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "african",
        "mango",
        "irvingia",
        "gabonensis",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 6.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790387957957",
      "vsf_explanation": "African mango (Irvingia gabonensis) — weight-loss category. The primary positive trials (Ngondi 2005, 2009 and Oben 2008) were conducted by a small group of overlapping authors and have been criticized for methodological weakness and lack of independent replication; Onakpoya 2013 Cochrane-style review deemed evidence 'insufficient.' 'Full spectrum' raw seed powder here isn't the standardized IGOB131 extract of the trials. Held in Rejected tier by weak/replication-failed evidence and mismatch between product form and studied form. Would move up only with an independent well-powered RCT.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-oregon-grape-root",
      "title": "Full Spectrum Oregon Grape Root",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7c931182-e7cd-49b0-b218-7929885cfc72_large_61e051fc-d9fa-4ea8-8b0e-71fbe03123e2.jpg?v=1787416826",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "oregon",
        "grape",
        "root",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 58,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 5.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790389694661",
      "vsf_explanation": "Oregon grape root contains berberine — the same active as goldenseal and barberry — with some evidence for antimicrobial and metabolic effects. Whole-root powder without berberine standardization delivers unpredictable actives. Berberine has CYP3A4 interaction potential and shouldn't be used in pregnancy. Would move higher with berberine-standardized format.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-coffee-cherry",
      "title": "Full Spectrum Coffee Cherry",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e4fd8a99-0cf3-4556-86ce-ea7df2e07775_large_08b41dad-a75d-4e58-b4df-6130daf8dce0.jpg?v=1787416826",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "coffee",
        "cherry",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790389727429",
      "vsf_explanation": "Coffee cherry (whole coffee fruit) is best known via the Neurofactor branded ingredient with small trials showing BDNF elevation (Reyes-Izquierdo 2013). Contains lower caffeine than roasted bean. Full-spectrum without Neurofactor branding lacks trial evidence. Would move to Verified 70+ with Neurofactor branding and disclosed polyphenol content.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-pomegranate-whole-fruit-seed",
      "title": "Full Spectrum Pomegranate Whole Fruit & Seed",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/87292091-628b-45b9-b26c-e12b37896c32_large_ecf8e9c3-b9bc-4b29-8548-effbf37915a7.jpg?v=1787416826",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "pomegranate",
        "whole",
        "fruit",
        "seed",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 6.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790389760197",
      "vsf_explanation": "Pomegranate has RCT evidence for BP reduction and cardiovascular markers (Sahebkar 2017 meta-analysis) at 240-500 mL juice equivalent. Whole-fruit powder without punicalagin/ellagic acid standardization delivers unclear actives. Would move to Verified 70+ with % punicalagin standardization matched to Pomella or POMx branded extracts.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-plantain-leaf",
      "title": "Full Spectrum Plantain Leaf",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/32c8a595-17bf-4433-9ef0-96bdaedcc46e_large_3ea865c5-a1af-4e0a-9e20-62194081e7ed.jpg?v=1787416826",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "plantain",
        "leaf",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 66,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 2.11,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790389792965",
      "vsf_explanation": "Plantain leaf (Plantago major/lanceolata — the weed, not the banana relative) is a traditional demulcent for respiratory and GI mucosa with minimal modern RCT support. Legit safe traditional herb. Whole-leaf powder without standardization limits potency. Would need modern evidence to move higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-jujube-fruit",
      "title": "Full Spectrum Jujube Fruit",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a19987e0-6be8-430e-ae90-70febbe37260_large_f2b28027-5a4a-40a1-a92c-73c367899f4d.jpg?v=1787416826",
      "score": 53,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "jujube",
        "fruit",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 66,
        "transparency": 55,
        "sustainability": 52
      },
      "price": 3.65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790389825733",
      "vsf_explanation": "Jujube (Ziziphus jujuba) is a traditional Chinese medicine sleep-support botanical. Ziziphus seed (Semen Ziziphi Spinosae) has some evidence but this SKU is fruit, not seed — different traditional use. Whole-fruit powder with minimal Western clinical evidence. Would move to Standard 60+ with switch to Ziziphi Spinosae seed extract with saponin standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-kola-nut-catuaba-and-guarana",
      "title": "Full Spectrum Kola Nut, Catuaba and Guarana",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/18546614-d6dd-4534-b70c-5f592443edd2_large_878c17e1-f22a-4f53-a897-a4bd2c0d3e35.jpg?v=1787416826",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "kola",
        "nut",
        "catuaba",
        "and",
        "guarana",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 50,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 10.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790389891269",
      "vsf_explanation": "Combination of three caffeine-containing/aphrodisiac herbs. Kola nut and guarana both carry ~4-8% caffeine, so total caffeine dose is opaque without standardization — a genuine safety concern for caffeine-sensitive users, especially stacked. Catuaba libido claims are unsupported. Would need per-ingredient caffeine mg disclosure to move higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-pterocarpus-marsupium",
      "title": "Full Spectrum Pterocarpus Marsupium",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1e7082ad-1884-4abd-838c-eac9c0379f3f_large_f0821909-2986-4be5-94fa-3ddede4cb8e9.jpg?v=1787416826",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "pterocarpus",
        "marsupium",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 5.16,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790389858501",
      "vsf_explanation": "Pterocarpus marsupium (vijayasar) is an Ayurvedic diabetes herb with small Indian trials on blood glucose (Manickam 1997 — pterostilbene as the active). Whole-bark powder without pterostilbene standardization delivers uncertain actives. Would move higher with pterostilbene-standardized extract.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-mustard-seed",
      "title": "Full Spectrum Mustard Seed",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3f3c84fa-73b5-4c70-94be-c6e3a94ea69a_large_99d90f8f-5459-4c4f-b872-4c15a6cb1cc3.jpg?v=1787416826",
      "score": 53,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "mustard",
        "seed",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 3.28,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790389924037",
      "vsf_explanation": "Mustard seed as an oral supplement lacks modern clinical evidence. Contains isothiocyanates (glucosinolate breakdown products) but the whole-seed capsule form is essentially a culinary ingredient. Would need targeted clinical use case to justify Standard-tier positioning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-saffron-whole-ground-stigmas",
      "title": "Full Spectrum Saffron Whole Ground Stigmas",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a1765121-3c44-47bc-a4a9-d0d837b4e007_large_8a44c07d-2da0-4708-8d21-5e82c81787dd.jpg?v=1787416826",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "saffron",
        "whole",
        "ground",
        "stigmas",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 14.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790389956805",
      "vsf_explanation": "Saffron has strong mood RCT evidence at 28-30 mg/day (Lopresti 2014 meta-analysis — comparable to SSRIs for mild-moderate depression). Whole-stigma ground powder is authentic form but without crocin/safranal % standardization, per-capsule bioactives are unclear. Would move to Verified 70+ with Affron or Satiereal branding and 3.5% crocin standardization at clinical 28 mg dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-onion-bulb",
      "title": "Full Spectrum Onion Bulb",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/770e34db-8d77-4c32-b78f-68f80d63f600_large_bc26f260-de1e-43b7-a3a9-2714a1875ee2.jpg?v=1787416826",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "onion",
        "bulb",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 6.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790389989573",
      "vsf_explanation": "Onion bulb powder provides quercetin and organosulfur compounds. As a supplement it's essentially culinary; clinical benefit at capsule doses is thin. Cheaper to just eat onions. Would need standardized quercetin content to move higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-lemon-peel",
      "title": "Full Spectrum Lemon Peel",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2f075884-f914-4a11-bb68-8eb76f4fb0e6_large_e9e94d20-2a59-4221-ad0b-a7ece4462538.jpg?v=1787416827",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "lemon",
        "peel",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790390022341",
      "vsf_explanation": "Lemon peel provides d-limonene and citrus flavonoids (hesperidin, eriocitrin). D-limonene has small GERD trial signals. Whole-peel powder without limonene or flavonoid standardization delivers uncertain actives. Would move higher with standardized limonene or hesperidin content.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-papaya-leaf",
      "title": "Full Spectrum Papaya Leaf",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/dc0f4bc4-ed6b-4fbc-85c7-dbd69861aa98_large_54f01eae-af86-4617-951e-bc02308e9dd9.jpg?v=1787416828",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "papaya",
        "leaf",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 6.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790390612165",
      "vsf_explanation": "Papaya leaf extract has traditional use for platelet support in dengue fever, with some Indian RCT data. General digestive-enzyme claims are extrapolated from papain (which is in the fruit, not primarily leaf). Whole-leaf powder without standardization. Would move higher with dengue-specific standardized extract format.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-motherwort",
      "title": "Full Spectrum Motherwort",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2e5d5844-8e96-465c-91c1-0088c3218451_large_4bff32f5-040c-4ec9-a528-daa04b157895.jpg?v=1787416828",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "motherwort",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 10.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790390644933",
      "vsf_explanation": "Motherwort (Leonurus cardiaca) is a traditional cardiovascular and menstrual herb with minimal modern RCT support. Contains leonurine and iridoids. Contraindicated in pregnancy (uterine stimulant). Would need controlled trial support to justify a higher tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-kale",
      "title": "Full Spectrum Kale",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d13d19e1-bc4f-4bbe-8275-bfa443156808_large_319a32e2-4dee-41fa-b4a1-0ab08da9268e.jpg?v=1787416829",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "kale",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 7.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790390743237",
      "vsf_explanation": "Kale powder is a food-form supplement providing modest vitamin K, glucosinolates, and antioxidants. As encapsulated powder the per-capsule micronutrient contribution is small vs actually eating kale. High vitamin K load is a warfarin interaction consideration. Legit whole-food powder.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-milk-thistle",
      "title": "Full Spectrum Milk Thistle",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ab988ac4-d17f-4db0-843b-6110574b1809_large_e3e10c47-d0ac-4c94-a376-854f21c7d41f.jpg?v=1787416829",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "milk",
        "thistle",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 52,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 6.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790390808773",
      "vsf_explanation": "Duplicate whole-seed milk thistle SKU — same evaluation: extremely low silymarin exposure per capsule versus a standardized 80% extract. Would move up substantially with standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-spinach-leaf",
      "title": "Full Spectrum Spinach Leaf",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/37fa8fd8-9691-45a5-9f64-2cd0c3f309f3_large_a5f3892b-5c8f-43da-a5bd-bf32fe8f49ad.jpg?v=1787416829",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "spinach",
        "leaf",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 62,
        "safety": 62,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 12.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790390776005",
      "vsf_explanation": "Whole-spinach-leaf capsule — a food-form green micronutrient carrier better categorized as a general micronutrient/greens SKU. Legitimate but low potency versus eating spinach directly or using a nitrate-standardized spinach extract (Volino-Souza 2019 for exercise-performance thylakoid research uses standardized extracts). Held to low Standard because a spinach capsule can't meaningfully replace culinary intake and provides negligible nitrate/lutein exposure at typical capsule doses. Oxalate consideration for kidney-stone-prone consumers.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-oat-straw",
      "title": "Full Spectrum Oat Straw",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b04ebccd-bd5e-455f-b4f4-67af408c3637_large_ec845806-e8d4-4616-9049-1521bf38118b.jpg?v=1787416829",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "oat",
        "straw",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 6.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790390841541",
      "vsf_explanation": "Oat straw (Avena sativa green oat extract) has small cognitive RCTs in the branded Neuravena format (Kennedy 2013 — attention/executive function). Whole-plant powder without Neuravena branding lacks that trial evidence. Well-tolerated. Would move to Verified 70+ with Neuravena branding at clinical dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-maqui-berry",
      "title": "Full Spectrum Maqui Berry",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7514ee32-44b9-4fb1-aa7c-9ec9cc5efda5_large_52715ca9-6120-44d8-9c59-2452ab91240c.jpg?v=1787416829",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "maqui",
        "berry",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 12.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790390874309",
      "vsf_explanation": "Whole-berry maqui powder — reasonable anthocyanin-rich food form but without delphinidin standardization. The trials that put maqui on the map (Yamashita 2013 for dry-eye) used MaquiBright specifically, at delphinidin-standardized doses. Held to low Standard by absence of that standardization. Would move up substantially with MaquiBright or equivalent branded ingredient.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-purslane",
      "title": "Full Spectrum Purslane",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b87f60b8-a21c-48b6-817d-6676bc7cae61_large_1a2368c2-464e-454a-b2a9-1656f60f71aa.jpg?v=1787416830",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "purslane",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 13.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790392217797",
      "vsf_explanation": "Purslane (Portulaca oleracea) is one of the highest plant sources of ALA omega-3 and contains oxalates. Small RCT signals for metabolic markers. Oxalate load matters for kidney-stone-prone users. Would move higher with standardized omega-3 or antioxidant content and oxalate disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-passion-flower",
      "title": "Full Spectrum Passion Flower",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1ba50374-59b9-44ac-b1ef-7e23dd05d4da_large_0fb21097-ac33-4195-a067-39de7918f555.jpg?v=1787416831",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "passion",
        "flower",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 66,
        "transparency": 55,
        "sustainability": 52
      },
      "price": 5.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790392250565",
      "vsf_explanation": "Whole-herb passionflower (Passiflora incarnata) for mild anxiety/sleep support (Akhondzadeh 2001, Ngan 2011). Whole-herb without vitexin standardization delivers uncertain flavonoid content vs studied extracts. Would move to Standard 62+ with 4% vitexin standardization and studied dose alignment.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-muira-puama",
      "title": "Full Spectrum Muira Puama",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b96b722e-2e72-4520-9c63-ef8af59991db_large_eba3179b-a8e9-4c02-be12-5e96d16bdedb.jpg?v=1787416831",
      "score": 53,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "muira",
        "puama",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790392283333",
      "vsf_explanation": "Muira puama is a traditional Amazonian libido herb with essentially no controlled trial evidence. Marketed as testosterone/libido support without RCT backing. Legit safe herb but the aphrodisiac claims lack support. Would need modern RCT evidence to justify Standard-tier positioning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-sceletium-tortuosum",
      "title": "Full Spectrum Sceletium Tortuosum",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0db4e6cd-6de4-4442-bd27-ffa79da3bcad_large_fcc9db9c-8c5f-4bc5-ad56-c4ed6aa24064.jpg?v=1787416832",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "sceletium",
        "tortuosum",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 15.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790393004229",
      "vsf_explanation": "Sceletium tortuosum (kanna) is a traditional South African herb with modest RCT signal for anxiety and cognition — mostly with the branded Zembrin extract (Chiu 2014). Full-spectrum whole-herb without Zembrin branding lacks trial evidence. Mesembrine is an SSRI-like alkaloid; SSRI-interaction caution required. Would move to Verified 70+ with Zembrin branding.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-guar-gum",
      "title": "Full Spectrum Guar Gum",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/31fbea7d-1941-4bbf-906f-b19307a704e1_large_7af75b78-a01f-440e-810a-0ec738f916d0.jpg?v=1787416832",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "guar",
        "gum",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 10.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790393036997",
      "vsf_explanation": "Guar gum is a soluble fiber with modest cholesterol and glucose-lowering evidence (Butt 2007 review). Full-strength guar gum without partial hydrolysis (PHGG) can cause esophageal obstruction — a real historical safety flag that led to FDA action on OTC weight-loss guar products. PHGG (Sunfiber) is far safer. Would move to Verified 70+ with PHGG format.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lavender-flower",
      "title": "Lavender Flower",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c0db5977-f01b-4fb1-a5ee-32d5e85833c6_large_1366bbe1-e749-494f-bdb5-5f389624ef11.jpg?v=1787416833",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lavender",
        "flower",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 4.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790393200837",
      "vsf_explanation": "Lavender for anxiety has good evidence in the branded Silexan (80 mg oral lavender oil) format — Kasper 2010 RCT vs paroxetine in GAD. Whole-flower powder is not the studied form; oral efficacy of powdered flower for anxiety is weak. Would move to Verified 70+ with Silexan branded oil in softgel.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-garlic",
      "title": "Full Spectrum Garlic",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0d1b9c10-f3aa-413f-9f03-bcda98e07f94_large_1116fe57-e20a-47e8-ae22-53ea6108a569.jpg?v=1787416835",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "garlic",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 3.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790393888965",
      "vsf_explanation": "\"Full spectrum\" whole-garlic powder preserves the fresh-bulb profile better than garlic oil (which loses allicin/alliin during processing) but still without the standardization that anchors the strongest garlic meta-analyses (Ried 2013 uses aged garlic extract). Whole-clove powder can retain alliin, which converts to allicin on contact with the enzyme alliinase, but capsule enteric coating and gastric acid affect actual delivery. Would move to Standard 62-65 with disclosed allicin-yield potential and enteric coating; aged garlic extract remains the reference form.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-lemon-balm",
      "title": "Full Spectrum Lemon Balm",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/754fa679-215d-403a-8300-bcc3c391f4ab_large_20851dea-1e54-484f-8f81-74e377328461.jpg?v=1787416835",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "lemon",
        "balm",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 60
      },
      "price": 4.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790394052805",
      "vsf_explanation": "Whole-herb lemon balm (Melissa officinalis) - has small trial evidence for anxiety and cognitive/mood effects at 300-600mg (Kennedy 2006), typically standardized to rosmarinic acid. Unstandardized whole-herb form does not guarantee the rosmarinic-acid dose that drove the positive trial data. Safety is favorable, mild sedation possible. Would move to Verified 70+ with rosmarinic-acid standardization (branded Cyracos preferred) at studied 300-600mg dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-eucommia-bark",
      "title": "Full Spectrum Eucommia Bark",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6b28d4c7-bb47-498a-afb7-ea2801cfbc39_large_a6618281-4afc-4449-99a2-1997443354d7.jpg?v=1787416835",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "eucommia",
        "bark",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 4.92,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790394085573",
      "vsf_explanation": "Eucommia bark is a traditional TCM herb used for blood pressure and joint support. RCT evidence is limited to small Chinese-language trials. Whole-bark powder without pinoresinol/aucubin standardization. Would need standardized extract and modern RCT support to move higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "grapefruit-peel",
      "title": "Grapefruit Peel",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/537776c2-3f28-4294-8dd7-d574393f8307_large_f006039d-51a4-4418-a6ff-b1d7bf4f26b4.jpg?v=1787416835",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "grapefruit",
        "peel",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 45,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 3.55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790394151109",
      "vsf_explanation": "Grapefruit peel contains furanocoumarins (bergamottin, 6',7'-dihydroxybergamottin) that are potent CYP3A4 inhibitors — a MAJOR drug-interaction hazard (statins, immunosuppressants, calcium-channel blockers, many others). Consumer-level supplement with a serious pharmacological interaction footprint. Would not recommend absent explicit interaction warnings.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hibiscus-flower",
      "title": "Hibiscus Flower",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a097fa52-9419-4ce2-829f-1267e2af8852_large_c1e5edb7-0430-4678-8c36-3072065912f2.jpg?v=1787416835",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hibiscus",
        "flower",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 52,
        "manufacturing": 58,
        "safety": 64,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 12.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790394118341",
      "vsf_explanation": "Hibiscus (Hibiscus sabdariffa) has BP-lowering RCT evidence (McKay 2010) primarily via infusion, not encapsulated powder. Capsule delivery may not match the aqueous vasodilator delivery of the studied tea format. Anthocyanin content not standardized on label. Would move to Verified 70+ with anthocyanin standardization aligned to the studied 1-3 g/day dried-calyx dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-lions-mane-mushroom",
      "title": "Full Spectrum Lion's Mane Mushroom",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/32cbb6ab-8575-42a3-a729-abc54c8bed61_large_51f99a3a-e350-4a62-a60d-a760b7a39966.jpg?v=1787416836",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "lion",
        "mane",
        "mushroom",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 56,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 58,
        "sustainability": 60
      },
      "price": 15.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790394183877",
      "vsf_explanation": "'Full spectrum' Lion's Mane typically means whole-herb powder without hot-water or dual extraction that concentrates the beta-glucans, hericenones, and erinacines behind the small Mori 2009 mild-cognitive-impairment RCT. Whether it is fruiting-body or mycelium-on-grain is the critical spec (mycelium products dilute actives). Safety is favorable. Would move to Verified 70+ with fruiting-body designation, dual extraction, and disclosed beta-glucan percentage.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-moringa-oleifera",
      "title": "Full Spectrum Moringa Oleifera",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/062231bb-e5d9-4682-aef1-2ba7cc7918da_large_c3722ccd-6875-4bca-b57e-5f69d6348d79.jpg?v=1787416836",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "moringa",
        "oleifera",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 12.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790394216645",
      "vsf_explanation": "Moringa oleifera leaf is a nutrient-dense whole-food supplement with modest RCT signal for blood-sugar and antioxidant markers (Anthanont 2016). Trendy 'superfood' claims often exceed evidence. Legit whole-leaf powder. Would move to Verified 70+ with organic sourcing certification and standardized isothiocyanate content.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-hops",
      "title": "Full Spectrum Hops",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c1e7a156-1223-4e39-bb0c-fcbef68c8fa5_large_98b8b5fd-c028-42aa-9e3b-b7af762b577a.jpg?v=1787416836",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "hops",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 58,
        "sustainability": 60
      },
      "price": 15.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790394249413",
      "vsf_explanation": "Whole-herb hops - hops monotherapy has weak sleep evidence; most positive data is from hops + valerian combinations (Koetter 2007). Alpha-acid content varies widely without standardization. Would move to Verified 70+ with disclosed alpha-acid or xanthohumol standardization and rational combination pairing (e.g., with standardized valerian).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-chia-seed",
      "title": "Full Spectrum Chia Seed",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/823278e6-793e-4502-8e19-c563b12c6a59_large_b7d56f53-ec9b-4949-99c9-a8b35ff8169f.jpg?v=1787416836",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "chia",
        "seed",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 60,
        "sustainability": 65
      },
      "price": 5.55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790394282181",
      "vsf_explanation": "Whole-food chia seed. ALA omega-3, soluble fiber and protein source, but plant ALA converts poorly to EPA (~5%) and DHA (<1%) in humans (Brenna 2009), so chia is not a substitute for fish oil in cardiovascular contexts. Fine as a fiber/ALA food, less useful as a targeted omega-3 supplement. Would move to Verified with organic sourcing and disclosed ALA gram content per serving.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "black-sesame-seed",
      "title": "Black Sesame Seed",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c839b474-86a5-4132-9abc-88732148c48c_large_09706c9b-e68a-4463-adc9-ae20e14ba4ef.jpg?v=1787416836",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "black",
        "sesame",
        "seed",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 11.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790394314949",
      "vsf_explanation": "Black sesame is a whole-food source of calcium, iron, and sesamin lignans with small RCT signals for lipid profile. As a supplement it's more nutritional food than clinical intervention. Would move higher with standardized sesamin/sesamolin content or targeted lignan extract.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-milk-thistle-1",
      "title": "Full Spectrum Milk Thistle",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/054a3b39-1bb8-4a8b-aac3-a87ee631e777_large_21385cb4-9fbe-4a86-9cf6-45df10e7e666.jpg?v=1787416837",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "milk",
        "thistle",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 52,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790394347717",
      "vsf_explanation": "Whole-herb milk thistle seed powder — silymarin content in unextracted seed is roughly 1.5-3% versus 80% in a proper extract, so a whole-seed capsule delivers roughly 1/40th to 1/50th the silymarin per mg. Loguercio 2012 and other hepatology trials used 80% silymarin extracts. Would move up dramatically with any extraction step.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "_mubest-effervescent-dietary-supplement-24-tablets-with-black-elder-extract-vitamin-c-zinc",
      "title": "_mubest Effervescent Dietary Supplement - 24 Tablets with Black Elder Extract, Vitamin C & Zinc",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/XjfZzhwnyseQBaOp3m7EL0mQ8PfxYJ9RNCTvY2rO.jpg?v=1787416843",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "_mubest",
        "effervescent",
        "dietary",
        "supplement",
        "tablets",
        "with",
        "black",
        "elder",
        "extract",
        "vitamin",
        "zinc",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 50,
        "safety": 62,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 18.04,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790397755589",
      "vsf_explanation": "Elderberry + vitamin C + zinc effervescent from Turkish reseller channel. The combination has moderate immune/URI evidence (Tiralongo 2016 for elderberry, Hemilä 2013 zinc lozenge meta-analysis for zinc), but effervescent format limits standardized dosing and forces higher sodium/citric-acid loads. Elderberry extract type (Sambucol vs generic) not disclosed. Would move to Verified 70+ if reformulated with Sambucol-standardized elderberry and clear per-tablet mg disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-turmeric-astragalus-gotu-kola-complex",
      "title": "Full Spectrum Turmeric, Astragalus & Gotu Kola Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/52fc136e-ecfb-4dbe-944d-73b5a5b6b408_large_3cd0133b-8b92-40ef-8093-12974e7dc700.jpg?v=1787416884",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "turmeric",
        "astragalus",
        "gotu",
        "kola",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 55,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 3,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790409814213",
      "vsf_explanation": "Traditional TCM-adjacent adaptogen/immune blend. Directionally coherent but all three actives are 'Full Spectrum' whole-herb powders — turmeric without piperine, astragalus without astragaloside standardization, and gotu kola without triterpene (asiaticoside) standardization. The trials that support each of these actives (Belcaro 2011 for gotu kola triterpene fraction on venous insufficiency) used standardized extracts, not whole herb. Would move up with standardization on all three actives.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-spearmint-leaf",
      "title": "Full Spectrum Spearmint Leaf",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d9c11fcb-efb4-475d-ba59-df3b69709172_large_8d4730e9-fcb2-4bda-8dbb-57098533734c.jpg?v=1787416884",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "spearmint",
        "leaf",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 66,
        "transparency": 58,
        "sustainability": 52
      },
      "price": 13.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790409912517",
      "vsf_explanation": "Spearmint (Mentha spicata) has small RCT evidence for anti-androgen effects in PCOS women (Akdogan 2007, Grant 2010 — reduced free testosterone, mild hirsutism improvement) — typically studied as tea infusion 2×/day, not encapsulated whole leaf. Encapsulated powder likely delivers less rosmarinic acid than steeped tea. Would move to Standard 65+ with defined rosmarinic-acid content or a tea-equivalent extract.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-sweet-wormwood-artemisia-annua",
      "title": "Full Spectrum Sweet Wormwood (Artemisia annua)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4dd4ee85-9633-4961-8005-bef6ef660fe0_large_5da471ac-0481-42ae-8776-834294701abc.jpg?v=1787416884",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "sweet",
        "wormwood",
        "artemisia",
        "annua",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790409846981",
      "vsf_explanation": "Sweet wormwood is the source of artemisinin, the antimalarial that earned Tu Youyou the 2015 Nobel Prize. Whole-plant powder without artemisinin standardization is not a therapeutic antimalarial — that's a real limitation. Some autoimmune/anticancer investigational use exists. Would move higher with % artemisinin standardization and clear off-label safety context.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-suma-root",
      "title": "Full Spectrum Suma Root",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3e104655-6f50-4732-8627-f58bded67bff_large_bd9e5a26-c672-43e5-9173-0c6057a2ebab.jpg?v=1787416884",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "suma",
        "root",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 6.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790409978053",
      "vsf_explanation": "Suma root (Pfaffia paniculata, 'Brazilian ginseng') is a traditional adaptogen with essentially no modern RCT support. Contains pfaffic acid and ecdysteroids that are marketed as anabolic — human evidence is weak. Legit whole-plant supplement but insufficient modern evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-tribulus-fruit",
      "title": "Full Spectrum Tribulus Fruit",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/902c6d1b-900e-4aa2-b31a-62c96d3ef63d_large_248857d5-7d86-4df3-8ed1-1adc01b82f39.jpg?v=1787416884",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone",
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "tribulus",
        "fruit",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 3.1,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790410076357",
      "vsf_explanation": "Whole-fruit tribulus without saponin standardization. Testosterone-boost claims for tribulus in healthy men are not supported by RCTs (Neychev 2005 — no T change in resistance-trained men); libido data are inconsistent. Whole-fruit (non-standardized) tribulus delivers unpredictable protodioscin content — the studied extracts are typically 40-60% saponin-standardized. Would move higher only with saponin standardization percentage disclosed and honest label framing that doesn't overpromise testosterone effects.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ginkgo-biloba-liquid-extract-alcohol-sugar-free",
      "title": "Ginkgo Biloba Liquid Extract - Alcohol & Sugar Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0292071e-cbe7-424f-b3ef-e4e7a0cc0023_large_955e3668-0b8c-4fa1-8dcf-15ae391c6f3e.jpg?v=1787416885",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ginkgo",
        "biloba",
        "liquid",
        "extract",
        "alcohol",
        "sugar",
        "free",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 11.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790409879749",
      "vsf_explanation": "Liquid ginkgo extract (glycerite-style, alcohol-free) typically delivers unstandardized whole-plant chemistry rather than the 24/6 EGb-761-comparable profile used in cognitive RCTs. Convenience of a liquid is real, but dose precision and standardization suffer. Same bleeding-risk anticoagulant interaction applies. Would move to Verified 70+ with disclosed flavone-glycoside/terpene-lactone percentages and per-mL potency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-schizandra-berries",
      "title": "Full Spectrum Schizandra Berries",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a0755866-895c-4612-a414-1455bc8ccd45_large_cedeef9d-818a-4782-8e44-4af37d239ac8.jpg?v=1787416884",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "schizandra",
        "berries",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 66,
        "transparency": 55,
        "sustainability": 52
      },
      "price": 12.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790409945285",
      "vsf_explanation": "Whole-berry schisandra powder. Traditional adaptogen with hepatoprotective and cortisol-modulating in-vitro evidence; controlled clinical trials remain small. Whole-berry delivers less concentrated schisandrins than standardized extracts. Would move to Standard 62+ with schisandrin standardization (2-9%) and outcome-based clinical evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "turmeric-hawthorn-and-cayenne",
      "title": "Turmeric, Hawthorn and Cayenne",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f02b9ca3-fcde-4336-95cf-04dda0ee1aec_large_6b3396e3-d5dc-495b-b8a8-ab19fa3f878c.jpg?v=1787416884",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "turmeric",
        "hawthorn",
        "and",
        "cayenne",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 56,
        "formulation": 56,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 3.25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790410043589",
      "vsf_explanation": "Traditional herbal blend combining hawthorn (best evidence — Pittler 2008 Cochrane in mild heart failure), turmeric (inflammation) and cayenne. No formula-level RCT support. Turmeric absorption without piperine or a lipid carrier is poor. Would move to Standard 62+ with disclosed hawthorn procyanidin standardization, curcuminoid content, and bioavailability enhancer for the turmeric fraction.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-valerian-chamomile-hops",
      "title": "Full Spectrum Valerian, Chamomile & Hops",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/315c9232-771a-49cb-9d7b-4718ea8da038_large_c218714f-6c37-4919-b56d-4b95679b3700.jpg?v=1787416884",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "valerian",
        "chamomile",
        "hops",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 60
      },
      "price": 10.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790410141893",
      "vsf_explanation": "'Full spectrum' whole-herb valerian + chamomile + hops - the traditional European sleep triple but without standardization percentages that guarantee valerenic acid, apigenin, and hop-alpha-acid content. Whole-herb approach preserves plant chemistry breadth but sacrifices dose consistency vs standardized extracts (Bent 2006 meta on valerian relied on standardized preparations). Would move to Verified 70+ with disclosed standardization on each active.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "garlic-oil-concentrate",
      "title": "Garlic Oil Concentrate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/de016d7a-0382-42d5-960e-37edd31c6202_large_ffaa85ae-c1b4-4a55-a535-7153612e9828.jpg?v=1787416884",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "garlic",
        "oil",
        "concentrate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 9.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790410010821",
      "vsf_explanation": "Standard garlic oil softgel. Garlic's mild BP-reduction meta-analytic evidence (Ried 2013) rests primarily on aged garlic extract with standardized S-allyl cysteine (Kyolic AGE is the reference), not on garlic oil, which loses much of its allicin/alliin activity during steam distillation. Would move to Standard 62+ with disclosed allicin/SAC content and defined bulb-equivalent per softgel; an aged garlic extract SKU would be the meaningful upgrade.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-triple-mushroom-complex",
      "title": "Full Spectrum Triple Mushroom Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b837a798-f642-4a17-9aef-b7d0751a5126_large_98c09cac-5755-4624-903e-4a3280ebeebe.jpg?v=1787416884",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "triple",
        "mushroom",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 52,
        "sustainability": 62
      },
      "price": 15.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790410174661",
      "vsf_explanation": "Whole-mushroom triple complex — same 'Full Spectrum' quality issue: whole-mushroom powder without hot-water extraction delivers polysaccharides at very low activity versus dual-extract fruiting body concentrates. Fruiting body vs mycelium not specified, beta-glucan not standardized. Not misleading, but not effective versus properly extracted alternatives. Would move up with dual extract and beta-glucan >=25% standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "turmeric-ashwagandha-ginseng-complex",
      "title": "Turmeric, Ashwagandha & Ginseng Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/94d9a26a-38d5-4f67-9237-c1ac7fcbaaf0_large_9fa9fe6b-47fa-4adb-b329-03f57f610ad9.jpg?v=1787416884",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive",
        "inflammation",
        "joint",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "turmeric",
        "ashwagandha",
        "ginseng",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 12.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790410207429",
      "vsf_explanation": "Three-ingredient complex — turmeric (curcuminoids), ashwagandha, and ginseng. All have RCT support at specific doses/standardizations, but combined products typically underdose each and lack per-ingredient standardization disclosure. Turmeric especially needs bioavailability enhancement (curcumin without piperine/phytosome is poorly absorbed). Would move to Verified with per-ingredient standardization and doses.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "turmeric-acai-ginger",
      "title": "Turmeric, Acai & Ginger",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1e2002cd-d00a-4f28-a186-cff0ff725760_large_46a5f4fe-84b0-4323-a787-e85fa0056b4f.jpg?v=1787416884",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "turmeric",
        "acai",
        "ginger",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 55,
        "sustainability": 58
      },
      "price": 9.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790410240197",
      "vsf_explanation": "Antioxidant + anti-inflammatory food-herb blend. Ginger has real anti-nausea (Ernst 2000) and modest anti-inflammatory data. Curcumin's bioavailability issue applies as always without a carrier. Acai's antioxidant activity is real in-vitro but human outcome data are weak. Held to mid-Standard by no curcuminoid or piperine standardization and 'complex' hiding per-herb mg.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-korean-red-ginseng-root",
      "title": "Full Spectrum Korean Red Ginseng Root",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fd09fbef-b0b5-46e5-aecb-81b4f8d4d598_large_5bd6ba94-a4e6-40d3-ac64-7b347c3e0b0b.jpg?v=1787416884",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "korean",
        "red",
        "ginseng",
        "root",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 62,
        "safety": 62,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 10.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790410109125",
      "vsf_explanation": "Red (steamed) Korean ginseng whole-root powder. Red processing does increase certain rare ginsenosides (Rg3, Rg5) versus white ginseng. Held to low Standard because whole-root powder lacks ginsenoside standardization, and clinical dosing (Kim 2013 for fatigue) typically references extracts rather than whole root. Recategorized to energy_metabolic. Standard Panax drug-interaction cautions apply.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-turmeric",
      "title": "Full Spectrum Turmeric",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e350f472-1beb-4cd7-97fe-0945d4905983_large_3ee08d45-111a-4fbc-bca0-d8019af1bfd6.jpg?v=1787416884",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "turmeric",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 7.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790410272965",
      "vsf_explanation": "Yet another 'Full Spectrum Turmeric' SKU — same profile as siblings: whole-herb powder, structurally low systemic curcumin exposure without a bioavailability carrier. Reasonable as a food-form ingredient, poor as a curcumin-effect delivery vehicle.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "glucosamine-chondroitin-msm-higher-strength",
      "title": "Glucosamine, Chondroitin & MSM - Higher Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7423ab06-e910-4b7d-abbf-505549b94168_large_9c886593-09b7-4c58-a648-ee00a9682053.jpg?v=1787416887",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glucosamine",
        "chondroitin",
        "msm",
        "higher",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 66,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 60,
        "sustainability": 52
      },
      "price": 38.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790410830021",
      "vsf_explanation": "Second 'Higher Strength' triple joint stack SKU. Same assessment as the paired variant — likely full GAIT dose range (1500 + 1200 + ~1500 mg) but without named-source clinical ingredients or salt-form spec. Held below Verified by identical gaps. Would move to Verified 70+ with sulfate-form and OptiMSM disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "garlic-oil-concentrate-triple-strength",
      "title": "Garlic Oil Concentrate - Triple Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/75213215-5bb6-4b81-8d86-84da0aa377ff_large_58264e9b-473b-4943-a75c-4ca7614cb9fa.jpg?v=1787416887",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "garlic",
        "oil",
        "concentrate",
        "triple",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 56,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 14.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790410895557",
      "vsf_explanation": "Concentrated garlic oil softgel. The mild BP-reduction meta-analytic evidence for garlic (Ried 2013) is strongest for aged garlic extract with standardized S-allyl cysteine (like Kyolic AGE), not for garlic oil, which loses much of the allicin/alliin activity during steam distillation. \"Triple strength\" is a marketing descriptor without a defined pharmacological anchor. Would move to Standard 62+ with disclosed allicin/SAC content and defined bulb-equivalent per softgel.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ginkgo-biloba-extract-standardized",
      "title": "Ginkgo Biloba Extract - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f3a017f7-95a1-4ead-8f40-3181d4f3d871_large_0843a397-b27f-4a0f-8905-e7448f5279d8.jpg?v=1787416887",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ginkgo",
        "biloba",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 66,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790410862789",
      "vsf_explanation": "Standardized ginkgo extract on the 24% flavone-glycoside / 6% terpene-lactone template that mirrors EGb 761, the extract behind most positive cognitive-aging RCTs (Le Bars 1997; Ihl 2011). Generic Swanson manufacturing footprint and no third-party COA. Bleeding-risk interaction with anticoagulants/antiplatelets remains under-disclosed. Would move to Verified 70+ with named EGb-comparable extract, per-lot testing, and explicit anticoagulant warning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "garlic-and-parsley-with-wheat-germ-oil",
      "title": "Garlic and Parsley with Wheat Germ Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/14ceccaa-5782-4d2f-9a11-3f3bb81a60a1_large_81bcf82c-5a15-485b-9d57-8d3f5bc124e8.jpg?v=1787416888",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "garlic",
        "and",
        "parsley",
        "with",
        "wheat",
        "germ",
        "oil",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 5.2,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790411419845",
      "vsf_explanation": "Garlic-oil-based softgel — a traditional cardiovascular preparation. Garlic evidence for mild BP reduction is meta-analytic (Ried 2013) but is strongest for aged garlic extract with standardized S-allyl cysteine (SAC) rather than for garlic oil, which loses much of the allicin/alliin activity to processing. Wheat germ oil adds vitamin E but no cardiovascular endpoint data. Would move to Standard 62+ with disclosed allicin or SAC content, or aged garlic extract form; a Kyolic-type AGE product would be the reference-tier alternative.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "glucosamine-chondroitin-msm-higher-strength-1",
      "title": "Glucosamine, Chondroitin & MSM - Higher Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4f527a7a-a5c9-4293-9588-1b5182e660b9_large_3359e55a-321f-4c97-bdec-d29928552d91.jpg?v=1787416889",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glucosamine",
        "chondroitin",
        "msm",
        "higher",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 66,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 60,
        "sustainability": 52
      },
      "price": 21.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790411518149",
      "vsf_explanation": "'Higher strength' variant of the triple joint stack — likely reaches GAIT clinical range (Clegg 2006). Held below Verified by unstated glucosamine salt, no OptiMSM callout, and no chondroitin source disclosure. Would move to Verified 70+ with named-source ingredients and per-active mg breakdown.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gamma-oryzanol-from-rice-bran",
      "title": "Gamma Oryzanol - from Rice Bran",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2194b9c4-1a9e-4408-8f46-73d2f12a2b27_large_1b65de1e-07c7-4910-ab0c-566e8d275ba1.jpg?v=1787416889",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gamma",
        "oryzanol",
        "from",
        "rice",
        "bran",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 5.53,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790411550917",
      "vsf_explanation": "Gamma-oryzanol is a rice-bran ferulic acid ester with modest cholesterol-lowering evidence (Berger 2005) and older use in Japan for menopause symptoms. Named source (rice bran) is a plus. Would move to Verified 70+ with % gamma-oryzanol standardization and clinical-dose serving disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "glucomannan",
      "title": "Glucomannan",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a81fb596-4bf9-4f04-8870-de19cef5440b_large_09827ff8-8af4-48ad-959d-2ca104a09a1f.jpg?v=1787416889",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glucomannan",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 9.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790411911365",
      "vsf_explanation": "Glucomannan (konjac fiber) has EFSA-approved health claim for satiety and cholesterol reduction (3 g/day). Choking hazard if not taken with adequate water — a genuine safety concern. Widely available cheap fiber. Would move to Verified 70+ with disclosed clinical dose (3 g/day meeting EFSA claim) and explicit water intake instruction.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ginkgo-biloba-extract-standardized-1",
      "title": "Ginkgo Biloba Extract - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/aaf226e6-70cb-4b3f-bf3a-0370271ba074_large_0f4956c4-7993-439f-bb83-2f27a5ecddea.jpg?v=1787416889",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ginkgo",
        "biloba",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 66,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 4.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790411944133",
      "vsf_explanation": "Standardized ginkgo extract on the 24/6 EGb-761 profile that underpins the positive cognitive-aging trials (Le Bars 1997; Ihl 2011). Generic Swanson manufacturing footprint, no third-party COA, and under-disclosed bleeding-risk interaction with anticoagulants/antiplatelets. Would move to Verified 70+ with named extract origin, per-lot testing, and explicit anticoagulant warning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gaba",
      "title": "GABA",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/095c1850-b552-4284-9f92-b023242d3c1a_large_9e41c4e3-ae51-4b77-8a34-c3394b57edbb.jpg?v=1787416890",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gaba",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 64,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 10.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790411976901",
      "vsf_explanation": "Synthetic GABA capsule - blood-brain-barrier penetration of oral GABA is limited and debated; subjective effects likely run through peripheral autonomic or enteric-nervous-system pathways. Not PharmaGABA branded, so generic material. Would move to Verified 70+ with PharmaGABA identity, studied 100-200mg dose, and honest mechanism disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "goldenseal-root",
      "title": "Goldenseal Root",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/802489f2-82da-44a9-bb81-796dad6b3b97_large_dec55f57-e6ee-4b96-a93e-4f9aeab15314.jpg?v=1787416890",
      "score": 53,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "goldenseal",
        "root",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 58,
        "transparency": 55,
        "sustainability": 38
      },
      "price": 14.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790412501189",
      "vsf_explanation": "Whole-root goldenseal (Hydrastis canadensis) without alkaloid standardization. In-vitro berberine/hydrastine activity but no meaningful RCT evidence for infection endpoints. Sustainability concern — wild Hydrastis is CITES Appendix II listed, and cultivated sourcing should be verified. Would move to Standard 60+ with FairWild/UpS certified sourcing and alkaloid standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "glucosamine-sulfate-2kcl",
      "title": "Glucosamine Sulfate 2KCl",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c206cdeb-889f-4cc0-a32c-2fd70fd5896f_large_c26ae1d2-cf91-4e31-84f2-96382dc8bc99.jpg?v=1787416890",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glucosamine",
        "sulfate",
        "2kcl",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 72,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 21.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790412533957",
      "vsf_explanation": "Second Glucosamine Sulfate 2KCl SKU — same correct pharmaceutical form as used in Reginster 2001, Pavelka 2002, and the GAIT moderate-severe subgroup (Clegg 2006). Right salt choice matters clinically. Held below Verified by no COA disclosure. Would move to Verified 70+ with per-cap mg and third-party purity testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gelatin-silicon",
      "title": "Gelatin & Silicon",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/520e25df-4155-4647-abf5-21550f84a3ba_large_3cccbbd7-955f-4ef5-8c25-0070e8655784.jpg?v=1787416891",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gelatin",
        "silicon",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 16.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790412566725",
      "vsf_explanation": "Gelatin (collagen-adjacent protein) + silicon (typically horsetail extract or bamboo) for hair/nail/skin support. Silicon has some RCT support for hair diameter and skin elasticity via choline-stabilized orthosilicic acid (Barel 2005), but gelatin/silica generic forms have weaker evidence. Standard tier — legit niche product, evidence stronger for specific bioavailable silicon forms not always disclosed here.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "wild-lettuce",
      "title": "Wild Lettuce",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e9af1717-2db8-4f55-8923-a2f38ede6aa3_large_0c9e3c9b-a741-499e-b40c-a26cc310618e.jpg?v=1787416891",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wild",
        "lettuce",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 52,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 3.8,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790412599493",
      "vsf_explanation": "Wild lettuce (Lactuca virosa) is a traditional sedative with essentially no modern RCT support. Marketed in some circles as an 'opioid alternative' — the lactucarium sesquiterpene lactones have mild sedative effects at high doses but the psychoactive claims are exaggerated. Weak evidence base overall.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "glucosamine-sulfate-2kcl-1",
      "title": "Glucosamine Sulfate 2KCl",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/502b8050-6445-4ad5-a450-be6dadb74891_large_65982cf8-bd48-4191-a86d-199ca0148d6f.jpg?v=1787416891",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glucosamine",
        "sulfate",
        "2kcl",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 72,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 16.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790412632261",
      "vsf_explanation": "Glucosamine sulfate 2KCl — the exact stabilized form used in the Rotta pharmaceutical trials (Reginster 2001, Pavelka 2002) and the GAIT moderate-severe subgroup analysis (Clegg 2006). Correct salt form is a real clinical distinction from the cheaper HCl form. Held below Verified by no per-cap mg in title and no COA — but the form choice alone is meaningful. Would move to Verified 70+ with 1500 mg/day serving disclosure and third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "glucosamine-collagen-type-ii-featuring-biocell-collagen",
      "title": "Glucosamine & Collagen Type II - Featuring BioCell Collagen",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/caeb4bed-179d-4b0a-b74d-0b0e4760e1b7_large_6235ab37-fdd4-4d61-bb46-e524b57be73f.jpg?v=1787416891",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glucosamine",
        "collagen",
        "type",
        "featuring",
        "biocell",
        "collagen",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 74,
        "manufacturing": 66,
        "safety": 72,
        "transparency": 72,
        "sustainability": 58
      },
      "price": 25.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790412665029",
      "vsf_explanation": "Glucosamine plus BioCell Collagen — a named-source hydrolyzed type II collagen matrix with chondroitin sulfate and hyaluronic acid (Schauss 2012 RCT at 2 g/day for joint discomfort). BioCell has independent human data; combining with glucosamine layers evidence bases. Named clinical ingredient at studied dose clears Verified. Held below Elite by mid-tier manufacturing and no USP/NSF certification. Would move to 80+ with third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-goji-berry",
      "title": "Full Spectrum Goji Berry",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/96fca6fc-6ec0-48da-8e4a-82f238255133_large_8ee4a910-8465-4e25-9e73-5939a8e356a6.jpg?v=1787416892",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "goji",
        "berry",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 55,
        "sustainability": 58
      },
      "price": 7.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790413091013",
      "vsf_explanation": "Whole-berry goji powder — reasonable as a whole-food supplement but without Lycium barbarum polysaccharide (LBP) standardization, the active immune-relevant fraction is variable per lot. Goji has warfarin drug-interaction reports (case reports of INR elevation) that should be labeled. Would move up with LBP percentage and drug-interaction warning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-parsley-leaf",
      "title": "Full Spectrum Parsley Leaf",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/80d71c1c-60d0-4605-89b2-f4f11f0be104_large_db924575-fdaf-4c9c-acb3-6a63d6f74ded.jpg?v=1787416892",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "parsley",
        "leaf",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 4.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790413156549",
      "vsf_explanation": "Parsley leaf is a food-grade herb providing modest apigenin and vitamin K content. Diuretic effect is traditional but weak clinically. High vitamin K load is a warfarin interaction consideration. Legit food-herb supplement. Would need targeted actives standardization to move higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "glutamic-acid",
      "title": "Glutamic Acid",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f1f75ffc-85b1-4e60-804a-391b5c3c5f75_large_193dc15e-7d88-4a43-9354-f68ae496f876.jpg?v=1787416892",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glutamic",
        "acid",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 18.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790413123781",
      "vsf_explanation": "Free glutamic acid is a non-essential amino acid; supplementation adds little for healthy adults with adequate protein intake. Different from L-glutamine (which is the more useful gut supplement). Not to be confused with MSG. Legit product but limited practical application. Would need targeted clinical use case to move higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "graviola",
      "title": "Graviola",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/67dab4a4-3a7f-43b5-b8df-77e087cc2202_large_f52b3010-c4c6-407d-b41a-3c9579f18b94.jpg?v=1787416892",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "graviola",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 45,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 3.42,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790413189317",
      "vsf_explanation": "Graviola (Annona muricata) is heavily marketed for cancer without RCT support, and annonaceous acetogenins carry Parkinson-like neurotoxicity signals (Caparros-Lefebvre 1999). Traditional folk use for infections, but the neurotoxicity flag caps this at Rejected regardless of Swanson's clean packaging. Would not recommend regardless of formulation improvements.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "green-tea",
      "title": "Green Tea",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/87742f3d-e7c3-4722-9cd3-5976175e2c8a_large_775f797c-a81f-4d87-8e41-10260ffe2543.jpg?v=1787416892",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "green",
        "tea",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 3.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790413222085",
      "vsf_explanation": "Green tea polyphenols (EGCG) have solid metabolic and antioxidant evidence (Hursel 2009). Standard whole-leaf capsule without % EGCG limits potency. Hepatotoxicity signal at high-dose EGCG (Hoofnagle 2021) argues for caution. Would move to Verified 70+ with EGCG standardization and safety-cap disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-sea-buckthorn",
      "title": "Full Spectrum Sea Buckthorn",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/db535dcc-7e00-4354-800f-4d0d06e754e4_large_2d01278e-5b19-4faa-a34b-bda1886e1ae0.jpg?v=1787416894",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "sea",
        "buckthorn",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 6.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790413811909",
      "vsf_explanation": "Sea buckthorn berry is a source of omega-7 palmitoleic acid, vitamin C, and carotenoids with modest RCT support for dry eye and skin (Larmo 2010 — dry eye). Full-spectrum whole-fruit powder without oil concentration or omega-7 % standardization delivers modest actives. Would move to Verified 70+ with SBA24 branded oil and disclosed omega-7 mg.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "green-leaf-stevia-extract-blended-with-other-ingredients",
      "title": "Green Leaf Stevia Extract Blended with Other Ingredients",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6b410d8c-d3d5-4f29-b6e7-dbc5c93c07a2_large_a73e32b6-520d-480b-ac74-1a038ad6009f.jpg?v=1787416894",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "green",
        "leaf",
        "stevia",
        "extract",
        "blended",
        "with",
        "other",
        "ingredients",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 10.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790413844677",
      "vsf_explanation": "Stevia is a well-tolerated non-caloric sweetener with reasonable safety data (FDA GRAS for high-purity extracts). Green leaf stevia is less refined than Reb-A extracts, retaining bitter aftertaste. 'Blended with other ingredients' is vague and hurts transparency. Would move higher with clear excipient breakdown.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-olive-leaf",
      "title": "Full Spectrum Olive Leaf",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4b3694d9-582f-4145-ac79-3a25f34092c5_large_b2f27d6f-7df0-4e31-a055-88e037e4cc62.jpg?v=1787416894",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "olive",
        "leaf",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 4.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790413877445",
      "vsf_explanation": "Whole-herb olive leaf powder — no extraction, no oleuropein standardization. Native oleuropein content in whole leaf ranges 1-14% depending on cultivar and season, so unstandardized whole-leaf is highly variable per lot. Susalit 2011 and Wainstein 2012 dosing was done with defined oleuropein extracts, not whole leaf. Would move up substantially with any extraction and standardization step.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-watercress",
      "title": "Full Spectrum Watercress",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f30452c8-bdac-48a9-9ddb-813514979767_large_d938c2ef-af5d-49a3-9a10-2ae94aab144c.jpg?v=1787416894",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "watercress",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790413910213",
      "vsf_explanation": "Watercress is a cruciferous vegetable powder providing glucosinolates and PEITC. Small biomarker RCTs (Gill 2007) suggest DNA-damage protection. Whole-plant powder without PEITC or glucosinolate standardization. Would move to Verified 70+ with standardized PEITC content and organic sourcing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "stinging-nettle-root",
      "title": "Stinging Nettle Root",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/65a2faca-3b10-4f43-a4ef-e244f6bf790c_large_dbb7f8f3-17fb-486a-a541-8973f2e72f43.jpg?v=1787416894",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "stinging",
        "nettle",
        "root",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 66,
        "transparency": 60,
        "sustainability": 52
      },
      "price": 12.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790413942981",
      "vsf_explanation": "Nettle root (as opposed to leaf) has moderate BPH-symptom evidence (Safarinejad 2005 RCT at 360 mg/day showed lower IPSS). Whole-root powder is less concentrated than the aqueous/ethanolic extracts used in trials. Would move to Verified 70+ with a named studied extract and beta-sitosterol standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-wild-yam",
      "title": "Full Spectrum Wild Yam",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/443c0dc6-08fe-4139-b1ab-b22cb4e69e68_large_6f0e3bb1-d69f-4242-bd9c-6bcb7628a5f6.jpg?v=1787416895",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "wild",
        "yam",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 10.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790413975749",
      "vsf_explanation": "Wild yam contains diosgenin, which is NOT converted to progesterone or DHEA in the human body — this is a common consumer misconception. Traditional use for menopause symptoms lacks RCT support (Komesaroff 2001 — no effect on symptoms or hormones). Legit safe herb but marketing claims often overreach. Would need actual RCT support to move higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-turmeric-boswellia-tart-cherry",
      "title": "Full Spectrum Turmeric, Boswellia & Tart Cherry",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/77770edd-0888-40d8-860b-590fc093e0dc_large_f6831eb9-2e10-4d88-9a9d-407cc58c574f.jpg?v=1787416895",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "turmeric",
        "boswellia",
        "tart",
        "cherry",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 55,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 13.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790414008517",
      "vsf_explanation": "Directional joint/anti-inflammatory trio (turmeric + boswellia + tart cherry) all with legitimate individual evidence bases, but 'Full Spectrum' whole-herb powders on all three components mean sub-clinical curcuminoid, AKBA, and anthocyanin exposures. Boswellia is particularly poor as whole-herb — AKBA-standardized extracts (5-Loxin, ApresFlex) drive the joint-comfort trials (Sengupta 2010). Would move up substantially with extracted, standardized components.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gaba-higher-strength",
      "title": "GABA - Higher Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/52fb45ff-f6e5-445a-b4e0-56be452a0e65_large_c4c5c839-9b93-4901-b819-9938120be5fc.jpg?v=1787416895",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gaba",
        "higher",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790414041285",
      "vsf_explanation": "Higher-strength synthetic GABA - blood-brain-barrier penetration of exogenous GABA is limited and debated, and any subjective effect likely runs through peripheral autonomic or enteric mechanisms rather than direct CNS GABAergic action. Higher doses do not scale central effects proportionally and can produce tingling/paresthesia. No PharmaGABA branding, so generic material. Would move to Verified 70+ with PharmaGABA identity at studied 100-200mg and clear mechanism disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "glucosamine-chondroitin",
      "title": "Glucosamine & Chondroitin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/55853414-1496-471e-97fc-cdb71013b8fb_large_844204f4-2ddc-4db3-8cb3-81cf8048222c.jpg?v=1787416895",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glucosamine",
        "chondroitin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 52
      },
      "price": 19.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790414074053",
      "vsf_explanation": "Plain glucosamine + chondroitin combo without TruFlex branding. GAIT (Clegg 2006) supports the combination for moderate-severe OA at 1500 + 1200 mg/day. Held below Verified by unclear glucosamine salt, unnamed chondroitin source (chondroitin has adulteration history per Volpi 2007), and no third-party COA. Would move to Verified 70+ with sulfate-form spec and named chondroitin.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ginkgo-biloba-extract-standardized-2",
      "title": "Ginkgo Biloba Extract - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/321602e4-e8a3-4775-b150-7b2fe59eb7ec_large_bbac4c86-4833-4c3a-9ebf-689b91506c24.jpg?v=1787416896",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ginkgo",
        "biloba",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 66,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 18.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790414893253",
      "vsf_explanation": "Standardized ginkgo extract on the 24/6 EGb-761 template that drives most positive cognitive-aging RCT signals (Le Bars 1997; Ihl 2011). Generic Swanson manufacturing footprint and no third-party COA. Bleeding-risk interaction with anticoagulants/antiplatelets remains under-communicated across the category. Would move to Verified 70+ with named extract origin, per-lot testing, and explicit anticoagulant warning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-yellow-dock-root",
      "title": "Full Spectrum Yellow Dock Root",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c5b935cf-c168-4747-864c-5ea0735ed7ce_large_3ae289a8-9836-4eb7-90fa-38a8e9fd03c9.jpg?v=1787416897",
      "score": 53,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "yellow",
        "dock",
        "root",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 52,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 6.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790414958789",
      "vsf_explanation": "Yellow dock (Rumex crispus) is a traditional laxative and blood tonic with minimal modern evidence. Contains anthraquinones and oxalates — long-term or high-dose use raises kidney-stone risk. Whole-root powder without dosing guidance. Would need modern RCT evidence and safety framing to move higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "turmeric-garlic-cayenne-balanced-support",
      "title": "Turmeric, Garlic & Cayenne - Balanced Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b868a46a-440e-4924-b5d5-d56b4ab280f7_large_7851fb0a-073d-4cb7-aab3-c8b722cb719a.jpg?v=1787416896",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "turmeric",
        "garlic",
        "cayenne",
        "balanced",
        "support",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 56,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790414926021",
      "vsf_explanation": "Traditional herbal cardiovascular/inflammatory blend. Each ingredient has some human data — garlic for BP (Ried 2013 meta), turmeric/curcumin for inflammation (Hewlings 2017), cayenne mainly circumstantial — but the formula-level evidence is absent. Turmeric absorption without piperine or a lipid carrier is notoriously poor. Would move to Standard 62+ with disclosed standardization (curcuminoid %, allicin/alliin content), bioavailability enhancer for turmeric, and per-ingredient mg.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "turmeric-black-pepper",
      "title": "Turmeric & Black Pepper",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e96cac50-bd31-4911-8f29-898488010974_large_aff0a32b-e963-4a52-94db-23b8be8e7174.jpg?v=1787416897",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "turmeric",
        "black",
        "pepper",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 60,
        "sustainability": 58
      },
      "price": 17.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790414991557",
      "vsf_explanation": "Duplicate turmeric + black pepper SKU. Follows Shoba 1998 protocol logic but the specific bioavailability lift depends on whether the pepper is BioPerine (95% piperine) or generic black pepper. Held to mid-Standard by that ambiguity. Would move to Verified with named BioPerine + 95% curcuminoids.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "turmeric-bromelain",
      "title": "Turmeric & Bromelain",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6949bc2f-6cbb-47b2-8935-188994871fe8_large_6c5c0910-fd7e-4bbd-bcd9-06c1940b4815.jpg?v=1787416898",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "turmeric",
        "bromelain",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 63,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 60,
        "sustainability": 58
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790415024325",
      "vsf_explanation": "Turmeric plus bromelain is a reasonable joint/anti-inflammatory pairing — bromelain adds independent COX-modulation and edema-reduction data (Brien 2006 for osteoarthritis). Doesn't solve curcumin's bioavailability problem the way piperine or phytosomes do, but bromelain does modestly enhance polyphenol absorption. Held to mid-Standard by no curcumin standardization, no bromelain GDU units, and no piperine. Would move to Verified with GDU-quantified bromelain and 95% curcuminoids named.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "adults-50-multi-without-iron",
      "title": "Adults 50+ Multi without Iron",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/91feb814-28d1-4284-bba8-3bc2aab2753c_large_9ae6028e-11d2-4ce5-8eab-7316af6a85ba.jpg?v=1787416898",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "adults",
        "multi",
        "without",
        "iron",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 14.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790415057093",
      "vsf_explanation": "Adults 50+ iron-free multi — appropriate omitting iron for the target demographic (Zacharski 2007), typically emphasizes B12 (methylated preferred for absorption at older age, IOM 1998), vitamin D, and calcium. Standard tier — mainstream senior multi. Would move to Verified with methylcobalamin, methylfolate, and named-chelate mineral forms.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-ginger-root",
      "title": "Full Spectrum Ginger Root",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/bdc972b7-26b7-4fa5-9bb9-a87f97b70661_large_e6d61311-4f28-42df-b645-6432f679ebb2.jpg?v=1787416899",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "ginger",
        "root",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 66,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790415548613",
      "vsf_explanation": "Whole-herb ginger root capsule. Nausea evidence (Ernst & Pittler 2000) is solid for ginger at 500-1500 mg/day. Whole-herb delivery is less consistent than standardized 5% gingerol extracts. Would move to Verified 70+ with standardized gingerol content and studied-dose disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "tri-fiber-complex",
      "title": "Tri-Fiber Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4f111883-b3a8-4989-9131-4c19e6ec5dc3_large_09b13f78-5854-4130-8cd1-7e6c96cb1a4f.jpg?v=1787416908",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tri",
        "fiber",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 13.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790417776837",
      "vsf_explanation": "Three-fiber blend (typically soluble + insoluble + prebiotic). Mixed fiber sources are sensible for varied SCFA production and bowel function. Individual fiber gram-doses per serving are the meaningful metric and are not visible from the title. Would move to Verified with per-fiber gram disclosure and total fiber ≥5g per serving.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "plant-people-wondercalm-mushroom-gummies-5-2oz-60ct",
      "title": "Plant People - 'WonderCalm' Mushroom Gummies (5.2OZ | 60CT)",
      "vendor": "The Epicurean Trader",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/plant-people-wondercalm-mushroom-gummies-52oz-60ct-136348.jpg?v=1787416915",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "plant",
        "people",
        "wondercalm",
        "mushroom",
        "gummies",
        "2oz",
        "60ct",
        "the",
        "epicurean",
        "trader"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 68,
        "safety": 68,
        "transparency": 65,
        "sustainability": 60
      },
      "price": 35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790417907909",
      "vsf_explanation": "Plant People WonderCalm gummies typically combine reishi, ashwagandha, L-theanine, and other calm-focused actives. Plant People is a reputable functional-mushroom brand with third-party testing publicly available and B Corp status. Gummy delivery format caps active mg per serving; typical serving delivers useful but not full-studied doses of ashwagandha (Chandrasekhar 2012 used 300mg KSM-66 twice daily). Would move to Verified 70+ with named standardized ashwagandha extract and full mg disclosure per active.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nbtlife-life-guard-dietary-supplement-zinc-copper-iodine-selenium-capsules-for-immune-system-support",
      "title": "NBTLife Life Guard Dietary Supplement - Zinc, Copper, Iodine, Selenium Capsules for Immune System Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Q2B5iMLBx836Lcwk9sIVRCdrJxdn9XleUXZQDudf.jpg?v=1787416928",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nbtlife",
        "life",
        "guard",
        "dietary",
        "supplement",
        "zinc",
        "copper",
        "iodine",
        "selenium",
        "capsules",
        "for",
        "immune",
        "system",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 27.91,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790424199365",
      "vsf_explanation": "NBTLife Life Guard is a Turkish-brand trace-mineral immune blend (zinc, copper, iodine, selenium) with no per-ingredient mg visible from the title and no US third-party testing chain. Individual minerals have decent immune evidence (Prasad zinc studies; Hoffmann selenium reviews), but form matters — zinc oxide vs picolinate, selenomethionine vs sodium selenite. Reseller-channel distribution adds no QC. Would move to Standard 65+ with per-mineral form and mg disclosure plus US-market batch traceability.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "green-tea-1",
      "title": "Green Tea",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f7fdf054-8b59-461c-aaa7-36fe687919d5_large_19e7c4ca-f145-444c-af6c-a0bfbe7b84a5.jpg?v=1787416945",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "green",
        "tea",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 8.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790429442245",
      "vsf_explanation": "Green tea polyphenols (EGCG) have good evidence for antioxidant and metabolic support (Hursel 2009 meta-analysis). Standard whole-leaf capsule without % EGCG standardization limits per-capsule potency. High-dose green tea extract has hepatotoxicity signal (Hoofnagle 2021). Would move higher with EGCG standardization at safe dose (<400 mg EGCG/day).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-gotu-kola",
      "title": "Full Spectrum Gotu Kola",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8bb89e3c-53d4-4a67-a2c1-b1f81bb9dc0f_large_a2a30c75-17d0-4c6b-b9a6-a93baaa059aa.jpg?v=1787416945",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "gotu",
        "kola",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 66,
        "transparency": 55,
        "sustainability": 52
      },
      "price": 4.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790429409477",
      "vsf_explanation": "Whole-herb gotu kola (Centella asiatica) capsule. Standardized triterpene-fraction extracts (Centellicum) have modest venous-insufficiency evidence (Incandela 2001); whole-herb delivers uncertain triterpene dose. Cognitive evidence for gotu kola is very thin. Would move to Standard 62+ with triterpene standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "glucosamine-hcl",
      "title": "Glucosamine HCl",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/caacc731-feeb-4fd0-ac77-ef8b4c511955_large_9e4e6e24-3a48-42db-9634-ecb14f061b14.jpg?v=1787416945",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glucosamine",
        "hcl",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 14.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790429475013",
      "vsf_explanation": "Glucosamine HCl form. The vast majority of positive joint-pain RCTs used glucosamine SULFATE (Reginster 2001 GAIT sub-analysis; the GAIT trial itself was largely null for HCl). Glucosamine HCl is chemically similar but the sulfate ion may itself contribute to cartilage matrix. Sits low in Standard because the wrong salt form is used. Would move up to 65+ with glucosamine sulfate stabilized with potassium chloride at 1500mg/day.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hawthorn-berry",
      "title": "Hawthorn Berry",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1132a7ad-0cfd-4749-8ca5-5be18ce51f00_large_93da1f58-13c5-40ce-8e8f-78cd4b7ac097.jpg?v=1787416946",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hawthorn",
        "berry",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 15.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790429573317",
      "vsf_explanation": "Whole hawthorn berry powder without standardized extract is the weaker end of the hawthorn category — the Cochrane evidence (Pittler 2008 in mild heart failure) is built on standardized extracts (e.g., WS 1442 in the SPICE trial) delivering defined procyanidin/flavonoid content, which a plain berry powder cannot guarantee. Would move to Standard 65+ with disclosed procyanidin percentage or move to a standardized extract product; unlikely to reach Verified as a whole-berry SKU without added standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-gymnema-sylvestre-leaf",
      "title": "Full Spectrum Gymnema Sylvestre Leaf",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c4819c4f-9efe-498b-8a34-3feb274a6c46_large_2939b4cc-0ae0-4757-b07a-cd4c8114011d.jpg?v=1787416945",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "gymnema",
        "sylvestre",
        "leaf",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 10.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790429671621",
      "vsf_explanation": "Gymnema sylvestre has some evidence for blood-sugar reduction and sugar-craving suppression (Baskaran 1990). Effect depends on gymnemic acid content, which is not disclosed in a full-spectrum whole-leaf format. Would move to Verified 70+ with 25-75% gymnemic acid standardization at clinical dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "high-absorption-ashwagandha-black-pepper-featuring-bioperine",
      "title": "High Absorption Ashwagandha & Black Pepper - Featuring BioPerine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/58603965-7eb7-44c9-b093-aad80aeb2f74_large_921aca3d-bbf6-4445-944e-df6a8a827c9f.jpg?v=1787416945",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "high",
        "absorption",
        "ashwagandha",
        "black",
        "pepper",
        "featuring",
        "bioperine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 16.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790429507781",
      "vsf_explanation": "Ashwagandha + BioPerine (Sabinsa's piperine). BioPerine is a named branded absorption enhancer (Shoba 1998). Ashwagandha specifically is not lipophilic in the way curcumin is, so piperine's absorption boost is more marketing than mechanism for this ingredient. Ashwagandha source not identified. Would move to Verified with named branded ashwagandha (KSM-66/Sensoril) and studied dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "glucosamine-chondroitin-msm-highest-strength-3-in-1-formula",
      "title": "Glucosamine, Chondroitin & MSM - Highest Strength 3-in-1 Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8f38264d-46d6-4ad3-b53f-4cfbb7a86a18_large_0726b5d4-0ce3-488b-94f3-e5949ee88232.jpg?v=1787416945",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glucosamine",
        "chondroitin",
        "msm",
        "highest",
        "strength",
        "formula",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 12.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790429540549",
      "vsf_explanation": "'Highest strength' variant of the triple joint stack — likely reaches full GAIT clinical dose (1500 mg glucosamine + 1200 mg chondroitin + 1500 mg MSM) in 3-4 tabs/day. Clegg 2006 supports this combination for moderate-severe knee OA. Held below Verified by unstated glucosamine salt at title, no OptiMSM disclosure, and no third-party COA for chondroitin (a category with adulteration history per Volpi 2007). Would move to Verified 70+ with named-source ingredients and COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "collagen-peptides-unflavored-1",
      "title": "Collagen Peptides - Unflavored",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9a0a54dd-919e-4ca3-862b-a9ed48c88d7a_large_4fb903c7-958d-4277-a1cf-5932b299e587.jpg?v=1787416945",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "collagen",
        "peptides",
        "unflavored",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 66,
        "formulation": 63,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 36.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790429606085",
      "vsf_explanation": "Bulk unflavored hydrolyzed collagen peptides variant SKU. Correct form with skin/joint RCT support at 10 g/day (Proksch 2014, Clark 2008). Generic Swanson sourcing without named clinical peptide or grass-fed claim. Held below Verified by same sourcing opacity as other Swanson collagen SKUs. Would move to Verified 70+ with named-source clinical peptides.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "green-tea-liquid-extract-alcohol-sugar-free",
      "title": "Green Tea Liquid Extract - Alcohol & Sugar Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/dd334080-ad52-4c90-9b62-fdb83c3cd3f8_large_1ea99f6b-4c7f-4d79-b4ef-91957bc6ada7.jpg?v=1787416945",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "green",
        "tea",
        "liquid",
        "extract",
        "alcohol",
        "sugar",
        "free",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 9.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790429704389",
      "vsf_explanation": "Glycerite liquid green tea extract — alcohol-free is a plus for people avoiding tinctures, but glycerin extracts pull polyphenols less efficiently than ethanol. EGCG % not disclosed. Would move higher with defined EGCG content and hepatoxicity-cap disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hawthorn-berry-liquid-extract-alcohol-sugar-free",
      "title": "Hawthorn Berry Liquid Extract - Alcohol & Sugar Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/01e0406a-09bd-439e-aca2-997111dc4e71_large_999ef0e1-1648-42a0-9d44-ac01ce5fc47a.jpg?v=1787416945",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hawthorn",
        "berry",
        "liquid",
        "extract",
        "alcohol",
        "sugar",
        "free",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 8.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790429638853",
      "vsf_explanation": "Liquid hawthorn extract offers dosing flexibility and often better absorption than dried powders, and alcohol-free is a plus for users avoiding ethanol. However, the Cochrane evidence base for hawthorn in mild heart failure (Pittler 2008) rests on standardized dried extracts like WS 1442, and liquid tinctures rarely publish comparable procyanidin standardization. Would move to Standard 65+ with disclosed procyanidin/flavonoid percentage per mL and clear extract:herb ratio.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "grape-seed-green-tea-pine-bark-complex",
      "title": "Grape Seed, Green Tea & Pine Bark Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/28413b56-b801-41ca-878d-6bfa554b3dad_large_c01e23ab-96d1-48fa-8b5d-9135e573391e.jpg?v=1787416946",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "grape",
        "seed",
        "green",
        "tea",
        "pine",
        "bark",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 6.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790429737157",
      "vsf_explanation": "Combination of three well-studied polyphenol sources — grape seed OPC (Feringa 2011 meta-analysis), green tea EGCG (Hursel 2009), pine bark (Pycnogenol RCTs). Complex without per-ingredient mg or standardization %. Watch for proprietary-blend labeling — Swanson usually discloses. Would move to Verified 70+ with per-ingredient mg breakdown and Pycnogenol branding.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-grape-seed",
      "title": "Full Spectrum Grape Seed",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9d2e5e12-8e67-4a9e-a198-fd42b1740c8d_large_e88bf5dc-b420-4023-9193-f8e75d1672e5.jpg?v=1787416945",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "grape",
        "seed",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790429769925",
      "vsf_explanation": "Grape seed's cardiovascular and antioxidant activity comes from proanthocyanidins (OPCs) — Feringa 2011 meta-analysis showed BP reduction at 100-800 mg standardized extract. Whole-seed 'full spectrum' powder without % OPC standardization delivers uncertain actives. Would move to Verified 70+ with 95% OPC standardization at clinical dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-guarana",
      "title": "Full Spectrum Guarana",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ef86db89-30de-4bcf-9c86-af044308375d_large_272b7162-e5f7-4078-92f3-88047de4f25a.jpg?v=1787416946",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "guarana",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 11.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790429802693",
      "vsf_explanation": "Guarana seed is essentially caffeine at ~4-8% by weight, plus tannins. Full-spectrum whole-seed powder without % caffeine standardization delivers unpredictable stimulant dose — a safety concern for caffeine-sensitive users. Would move higher with disclosed caffeine mg per serving.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "heart-health-bundle",
      "title": "Heart Health Bundle",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/64fd773d-0e2d-45d0-9ec0-d2ca377abc2e_large_b7b08a6f-932d-4cdb-84f8-d9ad6f7c8ccb.jpg?v=1787416946",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "heart",
        "health",
        "bundle",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 45.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790429835461",
      "vsf_explanation": "Bundle products score based on the average quality of their contents; without per-product visibility on the SKU listing, the honest read is that this is a curated set of Swanson cardiovascular staples (likely CoQ10, hawthorn, garlic, omega-3 or similar) at their individual Standard-tier profiles. Bundles risk overlap and dose-stacking without clinician oversight. Would move to Standard 65+ with a published contents list linking to each individual SKU and any interaction cautions across the bundle (e.g., garlic + nattokinase + fish oil compound bleeding risk).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hair-skin-nails",
      "title": "Hair, Skin & Nails",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cbf4885b-e772-4dba-835a-d56da12718f6_large_469e8785-a65c-410e-9971-8af44641fb8c.jpg?v=1787416946",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hair",
        "skin",
        "nails",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 13.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790430851269",
      "vsf_explanation": "Classic 'hair, skin & nails' category — typically fronted by megadose biotin (5000-10000 mcg vs the 30 mcg RDI), which lacks efficacy evidence in non-deficient users (Patel 2017) and can significantly interfere with thyroid and troponin lab tests (FDA safety communication 2017). Held near the bottom of Standard by weak evidence for the presumed biotin core plus opaque secondary actives. Would move to Verified 70+ only with a rebuild around hydrolyzed collagen or a named-source hair ingredient and clear lab-interference warning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "herbal-eyebright-combination",
      "title": "Herbal Eyebright Combination",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/eaea4eb8-b350-4c54-b25e-18cb39e4d0a3_large_c4ab35e2-c03a-4d33-b675-acbe1033e18e.jpg?v=1787416946",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "herbal",
        "eyebright",
        "combination",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 5.57,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790430949573",
      "vsf_explanation": "Eyebright (Euphrasia officinalis) is a traditional eye-health herb with essentially no modern RCT support. Combination product without disclosed per-ingredient mg limits transparency. Legit safe herb but the category has weak evidence overall. Would need standardized actives + RCT support to enter Standard-Verified range.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "high-potency-multi-without-iron-immune-support-2-pack",
      "title": "High Potency Multi without Iron +Immune Support - 2 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f4aabcaa-f6ee-4f05-8cd2-2f87dfa7ce01_large_ac10defe-9d65-4dbd-a0aa-ace457824578.jpg?v=1787416948",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "high",
        "potency",
        "multi",
        "without",
        "iron",
        "immune",
        "support",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790430982341",
      "vsf_explanation": "2-pack of iron-free high-potency multi with immune support. Iron-free appropriate for adult men and post-menopausal women (Zacharski 2007). Standard tier upper end.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "inosine-vegetarian",
      "title": "Inosine - Vegetarian",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b3286faf-4d43-48e7-892f-1076bf1127ba_large_3c283925-b789-4cc4-95bc-25efd1407b5d.jpg?v=1787416948",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "inosine",
        "vegetarian",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 10.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790431047877",
      "vsf_explanation": "Inosine as an ATP/exercise-performance aid has repeatedly failed placebo-controlled trials (Williams 1990). Can raise uric acid — gout risk at higher doses. Legit product but weak evidence base. Vegetarian capsule is a plus. Would need new RCT evidence to move higher — unlikely.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hyssop",
      "title": "Hyssop",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8c41b3ba-d42e-4200-a9cb-40b84a21be3b_large_aa8b7845-b67a-4f6f-bd06-7a05782ad63c.jpg?v=1787416948",
      "score": 53,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hyssop",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 3,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790431080645",
      "vsf_explanation": "Hyssop is a traditional respiratory-tract herb with minimal modern RCT evidence. Contains pinocamphone (essential oil) which can be neurotoxic at high doses — pregnancy/epilepsy contraindication. Whole-herb powder without standardization. Would need clinical evidence and a defined actives cap to justify a higher tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "kelp-iodine-source-2-pack",
      "title": "Kelp Iodine Source - 2 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/66abef05-b5e5-4ae0-9b2f-8686ffb92293_large_f044ec30-7664-4edf-aa0d-1d8242fb38d0.jpg?v=1787416948",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "kelp",
        "iodine",
        "source",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 62,
        "sustainability": 60
      },
      "price": 15.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790431113413",
      "vsf_explanation": "2-pack of kelp iodine — natural whole-food iodine source with variable per-capsule content. Standard tier. Heavy-metal source disclosure and thyroid-autoimmune cautions (Leung 2014) matter.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "high-potency-ultimate-immune-defense-with-c-d-zinc-elderberry",
      "title": "High Potency Ultimate Immune Defense with C, D, Zinc & Elderberry",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d1a96bc2-bf03-4719-bc5c-be7040e2d8c8_large_1b7aa3ba-750d-48dd-9e00-6c7665d56eb8.jpg?v=1787416950",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "high",
        "potency",
        "ultimate",
        "immune",
        "defense",
        "with",
        "zinc",
        "elderberry",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 66,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 13.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790431867077",
      "vsf_explanation": "Combined C + D3 + zinc + elderberry — the four best-supported immune ingredients. Vitamin D (Martineau 2017 for respiratory infection prevention), zinc (Hemila 2011 for cold duration), and elderberry (Tiralongo 2016) each have RCT support. Standard tier upper end — legit combined immune formula, effect depends on dose adequacy. Would move to Verified with 2000+ IU D3, 25mg+ zinc, and standardized elderberry (17% anthocyanins) disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "herbal-prostate-complex",
      "title": "Herbal Prostate Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/25933a0e-6c67-4f9e-97c0-43f6b8fad8be_large_dafd0a78-800f-4f8f-91fc-9616df9eeff2.jpg?v=1787416950",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "herbal",
        "prostate",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 21.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790431834309",
      "vsf_explanation": "Multi-herb prostate blend typically combining saw palmetto, pygeum, nettle root, and pumpkin seed. Saw palmetto has mixed BPH evidence (Wilt 1998 positive; Bent 2006 STEP null) at 320mg standardized; pygeum has small positive RCT signals (Wilt 2002); nettle root has more limited BPH data. Multi-herb complexes typically under-dose the individual actives versus monograph, and standardization percentages are typically not disclosed. Would move to Verified 70+ with per-active mg disclosure at monograph levels and standardization percentages.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-d3-highest-potency",
      "title": "Vitamin D3 - Highest Potency",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d5db35e4-34e5-443b-af48-4868f6ae4fe8_large_3b762d73-b7d8-49f1-ad12-7158d9d70c68.jpg?v=1787416951",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "highest",
        "potency",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 68,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 12.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790432751813",
      "vsf_explanation": "Cholecalciferol at 'Highest Potency' typically indicates 5000-10000 IU, appropriate for correction protocols but requiring 25(OH)D monitoring per Endocrine Society. Martineau 2017 BMJ supports immune benefit. Held below Verified by high-dose without paired K2/A cofactors, no NSF/USP, and no monitoring guidance. Would move to Verified 70+ with K2 MK-7 pairing and NSF certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ipriflavone-complex-featuring-ostivone",
      "title": "Ipriflavone Complex - Featuring Ostivone",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a96a3691-9300-4413-8c60-01a9bed21637_large_30e7fa66-cbe8-4eb7-b4c1-588540d41111.jpg?v=1787416951",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ipriflavone",
        "complex",
        "featuring",
        "ostivone",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 68,
        "manufacturing": 65,
        "safety": 60,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 8.24,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790432784581",
      "vsf_explanation": "Ostivone is a branded ipriflavone ingredient with some bone-density RCT data (Agnusdei 1997), though the Alexandersen 2001 trial found lymphocyte suppression at 600 mg/day — a real safety flag. Named branded ingredient is a formulation win but the safety signal caps the score. Would need updated safety data or a clearer dose ceiling to move higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "iron-citrate-active-form",
      "title": "Iron Citrate - Active Form",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/60cb42b1-a7a0-4209-9228-2aac6da49934_large_f15afc22-ed5f-4379-a29e-b1dba282e200.jpg?v=1787416951",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "iron",
        "citrate",
        "active",
        "form",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790432817349",
      "vsf_explanation": "Iron citrate — generally better GI tolerability than ferrous sulfate/fumarate at the cost of higher pill count for equivalent elemental iron. For iron-deficiency correction, bisglycinate (Ferrochel) or standard salts remain first-line. Standard tier — good tolerability profile, moderate absorption. Alt-day dosing (Stoffel 2017) is efficient.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "korean-ginseng",
      "title": "Korean Ginseng",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/11926d16-73d6-4ec4-a2bf-02b155b94c06_large_42958b89-982b-48b9-b1c7-ae664b9e2855.jpg?v=1787416951",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "korean",
        "ginseng",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 58,
        "manufacturing": 62,
        "safety": 62,
        "transparency": 55,
        "sustainability": 58
      },
      "price": 13.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790432850117",
      "vsf_explanation": "Duplicate Korean Ginseng SKU — same evaluation. Recategorized to energy_metabolic as adaptogen fit. Held to low Standard by no ginsenoside standardization and standard Panax drug-interaction cautions.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "high-potency-multi-with-iron-immune-support",
      "title": "High Potency Multi with Iron +Immune Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e423a690-7bde-45a3-b854-ea7bbf015432_large_0c8e8255-4e79-47bf-a514-1868096eb518.jpg?v=1787416951",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "high",
        "potency",
        "multi",
        "with",
        "iron",
        "immune",
        "support",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 62,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 20.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790432915653",
      "vsf_explanation": "High-potency multi with iron and added immune ingredients (C, D, zinc). Appropriate for menstruating women and iron-deficient users. Standard tier upper end. Would move to Verified with methylated B forms, disclosed K2/D3 doses, and NSF verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "korean-ginseng-1",
      "title": "Korean Ginseng",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/527043a8-e5e7-4b3a-9287-0c8b174ac3f7_large_a56c2acc-a339-4f9d-9afa-196bc27b6781.jpg?v=1787416951",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "korean",
        "ginseng",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 58,
        "manufacturing": 62,
        "safety": 62,
        "transparency": 55,
        "sustainability": 58
      },
      "price": 21.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790432948421",
      "vsf_explanation": "Korean (Panax) ginseng — better fit as an energy/adaptogen SKU than pure immune-antioxidant, so recategorized. Human evidence is modest to moderate for fatigue and cognitive markers with ginsenoside-standardized products (Kim 2013). Held to low Standard by no ginsenoside percentage in the title, unspecified red vs white processing, and Panax ginseng's warfarin, MAOI, and stimulant interactions. Would move up with named ginsenoside standardization (Rg1+Rb1+Rg2 targets).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "immune-boost-gummies-with-zinc-vitamins-c-and-d-cherry",
      "title": "Immune Boost Gummies with Zinc, Vitamins C and D - Cherry",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a5371f94-3a83-46c5-8416-9841a26eadbd_large_aa583fc4-c2eb-4cf3-b03c-df540136de54.jpg?v=1787416951",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "immune",
        "boost",
        "gummies",
        "with",
        "zinc",
        "vitamins",
        "and",
        "cherry",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 7.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790432981189",
      "vsf_explanation": "Zinc + vitamin C + vitamin D gummies — Martineau 2017 supports vitamin D for respiratory infection prevention in deficient populations, and zinc/C have cold-duration evidence (Hemila 2011). Gummy delivery typically compromises on elemental zinc (5-15mg) and D3 dose (400-1000 IU), plus added sugar. Standard tier — good adherence delivery, sub-therapeutic for correction of deficiency. Would upgrade with 2000+ IU D3, 25mg+ zinc, reduced sugar.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hyaluronic-acid-facial-cleanser",
      "title": "Hyaluronic Acid Facial Cleanser",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/27dd906a-df63-47b5-8d56-33190518dcde_large_ecd835ac-69fe-4a5c-9639-67423b3bbaaf.jpg?v=1787416953",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hyaluronic",
        "acid",
        "facial",
        "cleanser",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 72,
        "transparency": 52,
        "sustainability": 50
      },
      "price": 7.37,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790433013957",
      "vsf_explanation": "HA in a rinse-off cleanser — the format inherently limits HA contact time. Cleansers are dominated by their surfactants; adding HA is largely marketing since it rinses off before meaningful hydration benefit. Held at low Standard by mismatch between ingredient and vehicle. Would move to Verified 70+ only with humectant retention data specific to this cleanser.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "betaine-hcl-hydrochloric-acid-with-vegpeptase",
      "title": "Betaine HCl Hydrochloric Acid with VegPeptase",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1f01ae98-bbc1-4442-a8a8-4f73b8e7764e_large_c464ab35-caad-496e-b071-80f56cbd7327.jpg?v=1787416953",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "betaine",
        "hcl",
        "hydrochloric",
        "acid",
        "with",
        "vegpeptase",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 58,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 28.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790433931461",
      "vsf_explanation": "Betaine HCl for supporting gastric acidity in suspected hypochlorhydria — plausible mechanism (Yago 2013 for HCl lowering gastric pH in achlorhydria) and pairs sensibly with VegPeptase (plant-based protease). Safety caveats: contraindicated in ulcer/GERD/gastritis, and interacts with NSAIDs. Would move to Verified with clearer per-cap HCl mg dose and a stronger consumer-facing safety warning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "huperzine-a",
      "title": "Huperzine A",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5c3b3315-f2d4-471c-be41-8d6224d4034d_large_ac1af3cc-0181-4369-a197-afcc5a932ca6.jpg?v=1787416953",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "huperzine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 50,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790433964229",
      "vsf_explanation": "Huperzine A is a real pharmacologically active acetylcholinesterase inhibitor with small-trial evidence for cognitive decline (Wang 2009 meta) at 50-200 mcg. Interaction warnings for cholinergic drugs (donepezil, rivastigmine), beta-blockers, and other AChE inhibitors are chronically under-disclosed on OTC labels. Cycling is prudent given the enzyme-inhibitor mechanism. Would move to Verified 70+ with prominent drug-interaction disclosure, cycling guidance, and per-lot potency testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-d3-high-potency",
      "title": "Vitamin D3 - High Potency",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7aee937b-6010-4d9e-baa8-76e2079a3344_large_896bd6ad-1469-4426-aaeb-30f2eb69884a.jpg?v=1787416953",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "high",
        "potency",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 68,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 10.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790433996997",
      "vsf_explanation": "Cholecalciferol at 'High Potency' (typically 2000-5000 IU) supports maintenance/mild-correction protocols per Martineau 2017 BMJ. Held below Verified by no K2 cofactor and no NSF/USP certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hyaluronic-acid-combo-pack",
      "title": "Hyaluronic Acid Combo Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0b2afbbb-4583-4f20-9a16-10a8194ca599_large_0cd24f68-7c83-4f26-b119-8215051cccf0.jpg?v=1787416953",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hyaluronic",
        "acid",
        "combo",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 72,
        "transparency": 52,
        "sustainability": 50
      },
      "price": 17.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790434029765",
      "vsf_explanation": "Bundle of Swanson HA topical products. Topical HA at surface level has hydration evidence (Pavicic 2011); combo pack is a merchandising bundle, not a clinical formulation. Held below Verified by inheriting the underlying products' transparency and formulation gaps (unstated HA concentration and MW). Would move to Verified 70+ with named low-MW HA sourcing across the bundle.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "kelp-iodine-source",
      "title": "Kelp Iodine Source",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9ad5e20e-2cc3-4da9-8db2-23b44be77b86_large_02b7ec08-c2c0-4073-adcf-ac36f2a466c8.jpg?v=1787416953",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "kelp",
        "iodine",
        "source",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 62,
        "sustainability": 60
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790434062533",
      "vsf_explanation": "Kelp is a natural iodine source with variable iodine content per capsule (typically 150-225mcg) plus trace minerals. Iodine RDI is 150mcg. Kelp can have variable heavy metal content depending on source waters — sourcing disclosure matters. Safety flagged for autoimmune thyroid users where excess iodine can trigger Hashimoto flare (Leung 2014). Standard tier — legit source, sourcing transparency and dose consistency are the gaps.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "kids-vitamin-c-gummies-orange",
      "title": "Kids Vitamin C Gummies - Orange",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/67f8748b-7063-4a69-b0c9-c19a7f152f3c_large_285588e6-f7d1-49db-bb33-7ef691443cf9.jpg?v=1787416953",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "youth_under_18",
      "tokens": [
        "kids",
        "vitamin",
        "gummies",
        "orange",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 48,
        "manufacturing": 58,
        "safety": 52,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 5.75,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790434095301",
      "vsf_explanation": "Kids gummy vitamin C typically delivers low mg (60-125mg) in a sugar/syrup matrix, and gummy content-vs-label variance is well documented (Crawford 2017). The candy-like appearance drives over-consumption risk. While the underlying vitamin has strong immune-duration evidence (Hemila & Chalker 2013), the combination of sugar vehicle, low dose, and over-consumption behavior in children pushes this into Rejected. Would move to Standard 60+ with chewable non-sugar form and clear per-serving mg.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hydrolyzed-collagen-peptides-vitamin-c-types-i-and-iii",
      "title": "Hydrolyzed Collagen Peptides + Vitamin C Types I and III",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3815cd0a-fff3-4fe2-b020-5dc445f85907_large_1a236e5f-3abf-400c-9468-7b96059b7e3c.jpg?v=1787416954",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hydrolyzed",
        "collagen",
        "peptides",
        "vitamin",
        "types",
        "and",
        "iii",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 66,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 16.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790434128069",
      "vsf_explanation": "Hydrolyzed collagen peptides (Types I/III appropriate for skin, hair, nails) at 5-10g/day have skin-elasticity and hydration evidence (Choi 2014, Proksch 2014). Pairing with vitamin C supports endogenous synthesis via prolyl-hydroxylase cofactor. Held below Verified by unclear peptide grams from title, unspecified sourcing (bovine vs Peptan/Verisol), and no third-party certification. Would move to Verified 70+ with 10g+ dose disclosure, named peptide source, and independent COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "homocysteine-formula",
      "title": "Homocysteine Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/42314489-250f-405a-975a-ae008a59f5b8_large_90050466-21ba-44de-bca5-2f6da51082d5.jpg?v=1787416954",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "homocysteine",
        "formula",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 16.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790434160837",
      "vsf_explanation": "Homocysteine-lowering combinations of folate, B6, and B12 have strong evidence for lowering plasma homocysteine (Homocysteine Studies Collaboration 2002) though cardiovascular event reduction is mixed. Formulation quality depends heavily on whether folate is methylated (5-MTHF) and B12 is methylcobalamin — not clear from title. Would move to Verified 70+ with methylated forms (Quatrefolic/methylcobalamin) explicit.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-d3-high-potency-1",
      "title": "Vitamin D3 - High Potency",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/31ef83d2-3181-4dac-8c07-964fc427ad0c_large_bc3c20ff-d57f-4ed0-93e1-cd279910a02d.jpg?v=1787416954",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "high",
        "potency",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 68,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 7.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790434193605",
      "vsf_explanation": "Cholecalciferol 'High Potency' (typically 2000-5000 IU) supported by Martineau 2017 BMJ. Held below Verified by no K2 cofactor and no third-party certification. Would move to Verified 70+ with K2 pairing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "high-potency-multi-with-iron-immune-support-2-pack",
      "title": "High Potency Multi with Iron +Immune Support - 2 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5d685bad-4e44-44d6-b1bb-29d153f6ce45_large_1d123cb3-d092-4e7f-8338-61d7b6691297.jpg?v=1787416955",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "high",
        "potency",
        "multi",
        "with",
        "iron",
        "immune",
        "support",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 62,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 27.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790434226373",
      "vsf_explanation": "2-pack of high-potency multi with iron and immune support. Iron-containing multi is appropriate for menstruating women and iron-deficient users. Adult men and post-menopausal women should choose the iron-free variant (Zacharski 2007). Standard tier upper end.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-d3-high-potency-2",
      "title": "Vitamin D3 - High Potency",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/14e2710d-0012-4b20-99c7-47c88d3c1335_large_6d40e0c9-2c1e-45c8-acfd-768dbe79aa01.jpg?v=1787416955",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "high",
        "potency",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 68,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 5.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790434259141",
      "vsf_explanation": "Cholecalciferol 'High Potency' (typically 2000-5000 IU) is well-supported by Martineau 2017 BMJ meta-analysis. Held below Verified by no K2 cofactor and no third-party certification. Would move to Verified 70+ with K2 pairing and NSF certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hyaluronic-acid-serum-2-pack",
      "title": "Hyaluronic Acid Serum - 2 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b60c06dc-2ec8-4642-a4fd-139c183e941c_large_ce85202f-2c89-48cb-be27-262b3d1801e3.jpg?v=1787416958",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hyaluronic",
        "acid",
        "serum",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 72,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 16.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790434848965",
      "vsf_explanation": "Topical HA serum in 2-pack format. Topical HA has real evidence for surface skin hydration (Pavicic 2011) but no meaningful anti-aging benefit beyond hydration; low-MW HA penetrates modestly. Held below Verified by unstated HA molecular weight, unspecified % w/w concentration, and no full ingredient (INCI) list at title level. Would move to Verified 70+ with % HA disclosure and named low-MW HA source.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "high-potency-multi-without-iron-immune-support",
      "title": "High Potency Multi without Iron +Immune Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/82c2a6ac-a973-4cfc-be2c-8d3c5f9aaa58_large_45ed3ac8-a1cf-42dc-9b8e-873b08a72ce4.jpg?v=1787416957",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "high",
        "potency",
        "multi",
        "without",
        "iron",
        "immune",
        "support",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 20.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790434881733",
      "vsf_explanation": "High-potency iron-free multi with added immune ingredients (typically vitamin C, D, zinc, elderberry). Iron-free is appropriate for adult men and post-menopausal women (Zacharski 2007). Multi-vitamin evidence for general population is mixed (Rautiainen 2016 for PHS-II modest cancer benefit). Standard tier upper end. Would move to Verified with methylated B forms, K2/D3 disclosed doses, and NSF verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "healthy-blood-flow-featuring-wellemon",
      "title": "Healthy Blood Flow - Featuring Wellemon",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/16048854-c6c2-4346-9d7a-9ec4932982b6_large_bdc8f428-8f51-421c-8cc8-d454ceed07b3.jpg?v=1787416957",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "healthy",
        "blood",
        "flow",
        "featuring",
        "wellemon",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 65,
        "safety": 68,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 12.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790434914501",
      "vsf_explanation": "Wellemon is a branded lemon-derived flavonoid ingredient (Nagase/Sabinsa) with small trials on nitric-oxide and blood flow markers. Named branded ingredient is a real signal of formulation care. Solid mid-tier. Would move to Verified 70+ with clinical-dose disclosure of Wellemon mg and NSF/USP certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hesperidin",
      "title": "Hesperidin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/43a0cdff-2120-44d6-bef1-e52b3474580d_large_324f2fa6-3597-4b26-a11f-68c027a20629.jpg?v=1787416958",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hesperidin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790434947269",
      "vsf_explanation": "Hesperidin is a citrus flavonoid with cardiovascular and venous-tone support (Morand 2011 — 500 mg improved endothelial function). Standard hesperidin has low bioavailability; hesperidin-glucoside or 2S-hesperidin forms are far superior. Legit ingredient at generic form. Would move to Verified 70+ with 2S-hesperidin or hesperidin-methyl-chalcone form and disclosed mg per serving.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrabio-intra-blast",
      "title": "NutraBio Intra Blast",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NutraBio-Intra-Blast_ad270d3b.jpg?v=1787416958",
      "score": 78,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrabio",
        "intra",
        "blast",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 75,
        "manufacturing": 78,
        "safety": 72,
        "transparency": 82,
        "sustainability": 55
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790434980037",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 72 → new 78. Evidence found: NutraBio Intra Blast: full-transparency intra-workout formula, EAAs + electrolytes + carbohydrates, no proprietary blends. | Wolfe RR. Branched-chain amino acids and muscle protein synthesis. J Int Soc Sports Nutr. 2017;14:30.. Rationale: Intra Blast is a comprehensive intra-workout formula with full ingredient disclosure — EAAs, electrolytes, and often taurine/glutamine. NutraBio's transparency + evidence-based formulation. Uplift to 78.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-d3-higher-potency",
      "title": "Vitamin D3 - Higher Potency",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e27156d0-2d99-4dcb-aded-853d33786de2_large_99b5d45a-f5f9-4edd-88f7-ded6f009b10c.jpg?v=1787416958",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "higher",
        "potency",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 68,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 11.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790435242181",
      "vsf_explanation": "Cholecalciferol at 'Higher Potency' (typically 2000-5000 IU) is well-supported by Martineau 2017 BMJ (immune) and Autier 2014 (skeletal). Held below Verified by lack of K2 pairing, no NSF/USP, and vague IU labeling in title. Would move to Verified 70+ with K2-MK7 pairing and NSF certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "horsetail",
      "title": "Horsetail",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fb4ba559-b37b-45ea-878f-88346750e579_large_87d0fbf1-9e64-4af7-a38d-bb4bcd698962.jpg?v=1787416958",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "horsetail",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 58,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790436126917",
      "vsf_explanation": "Horsetail (Equisetum arvense) is a traditional silica source for hair, nails, and connective tissue. RCT evidence is thin. Contains thiaminase, so long-term use may impair B1 status. Non-standardized whole-herb powder. Would move higher with silica-standardized extract and thiaminase-inactivation processing statement.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "inositol",
      "title": "Inositol",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cd3b248b-97c7-4fa5-bb1c-3f9a752dcfb9_large_4bdde1b6-d162-4091-a2fc-bc5f6d1a9a4d.jpg?v=1787416958",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "inositol",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 66,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 12.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790436159685",
      "vsf_explanation": "Myo-inositol has RCT support for PCOS insulin sensitivity (Unfer 2017 meta-analysis) and OCD/anxiety at 12-18 g/day (Fux 1996). Standard Swanson inositol capsule likely delivers 500-1500 mg — well below the anxiety trial dose. Fine as an insulin-sensitivity adjunct. Would move to Verified 70+ with 40:1 myo:D-chiro ratio (Ovasitol format) and clinical-dose scoop format.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "quercetin-higher-strength",
      "title": "Quercetin - Higher Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/be8c5fe5-26cb-4ffb-9e71-d8263071b9f9_large_74908431-65d2-4c47-9401-94ea3d63f1d7.jpg?v=1787416958",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "quercetin",
        "higher",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 58,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 18.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790436192453",
      "vsf_explanation": "Higher-strength quercetin dihydrate — likely 500-800 mg range. Bioavailability remains the structural limitation for plain quercetin (<5%), so higher milligrams paper over the delivery problem without solving it. Comparable to the 'Maximum Strength' SKU. Would move up with EMIQ, Quercetin Phytosome (Quercefit), or bromelain co-formulation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gtf-chromium-features-chromemate",
      "title": "GTF Chromium - Features ChromeMate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/521f77c8-db74-4f39-bd40-f532b4d21e48_large_6d2435d7-561c-4265-8cfa-8ed471d40b58.jpg?v=1787416959",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gtf",
        "chromium",
        "features",
        "chromemate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 72,
        "manufacturing": 66,
        "safety": 68,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 3.6,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790436257989",
      "vsf_explanation": "ChromeMate is a branded niacin-bound chromium (chromium polynicotinate) with published bioavailability and glucose-response data (Preuss 2000). Chromium at 200-400mcg has modest but real insulin sensitivity effects (Anton 2008; Cefalu 2004 in diabetics). Named-source branded raw material lifts to upper Standard, near Verified. Would move to Verified with disclosed dose and RCT alignment.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "albion-boron-bororganic-glycine",
      "title": "Albion Boron Bororganic Glycine",
      "vendor": "Albion",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/70f9ffaf-532b-4db2-bdc3-844b860855d5_large_a4ff509b-983e-4598-9763-94102c8b2fb9.jpg?v=1787416967",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "albion",
        "boron",
        "bororganic",
        "glycine",
        "albion"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 74,
        "manufacturing": 68,
        "safety": 65,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 5.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790440059077",
      "vsf_explanation": "Albion Bororganic (boron glycinate) — chelated boron with published bioavailability advantage. Boron 3-6mg has modest evidence for bone/joint support, calcium retention, and free testosterone (Naghii 2011; Nielsen 1987). Named-source TRAACS chelate is a formulation plus. Upper Standard tier — solid trace mineral in best-available form.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ashwagandha-extract-standardized",
      "title": "Ashwagandha Extract - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/98535d3d-aaf0-45a2-a2a7-f9ea1558cfc7_large_d31304be-f67a-4228-bec5-f0899500776c.jpg?v=1787416981",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ashwagandha",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 8.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790445203653",
      "vsf_explanation": "Standardized ashwagandha extract but source not identified. Ashwagandha has strong RCT support (Chandrasekhar 2012 cortisol; Salve 2019 stress) at 300-600mg/day of standardized extract. Standardization disclosure is a positive vs the generic full-spectrum SKUs. Would move to Verified 70+ with named branded extract (KSM-66 or Sensoril) and withanolide percentage disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cosamin-ds-for-joint-health-dietary-supplement-capsules",
      "title": "Cosamin DS For Joint Health Dietary Supplement Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/41832541_5bf9e2fa-5234-4f9a-ab55-bcd88fe6e873.jpg?v=1787416991",
      "score": 74,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cosamin",
        "for",
        "joint",
        "health",
        "dietary",
        "supplement",
        "capsules",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 78,
        "manufacturing": 78,
        "safety": 75,
        "transparency": 72,
        "sustainability": 60
      },
      "price": 40.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790449332421",
      "vsf_explanation": "Cosamin DS (Nutramax Laboratories) is one of the few glucosamine/chondroitin products used in actual clinical trials — the GAIT study (Clegg 2006) and prior RCTs used the specific Cosamin/Osteo Bi-Flex formulations. FCHG49 glucosamine and TRH122 chondroitin sulfate are the studied grades. Nutramax has veterinary-grade QC and manufactures in NSF-registered facilities. Independent standardized doses put this above generic glucosamine/chondroitin combos. Would move to Elite with newer trials on advanced-stage OA or curcumin/collagen add-ons.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "kids-multivitamin-gummies-mixed-fruit",
      "title": "Kids Multivitamin Gummies - Mixed Fruit",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/22c3b0e1-7b95-4f8a-9139-9865c6330420_large_6f833290-1056-4ff0-8653-595995f5774a.jpg?v=1787417008",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "youth_under_18",
      "tokens": [
        "kids",
        "multivitamin",
        "gummies",
        "mixed",
        "fruit",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 5.75,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790452281541",
      "vsf_explanation": "Kids multivitamin gummies address legitimate picky-eater nutrient gaps but the sugar/syrup matrix and candy-like appearance drive over-consumption risk (iron/vitamin A toxicity concerns in mislabeled or excess-dose products). Content-vs-label variance is well documented in gummy formats (Crawford 2017). Held at low-Standard by delivery-format compromise and over-consumption risk. Would move up only if reformulated as chewable or low-sugar with iron transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-arginine",
      "title": "L-Arginine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0bcde801-1e47-4501-aabf-c16228238376_large_f3902e74-e7c6-4245-8e16-24d9c256c1c3.jpg?v=1787417008",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "arginine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 10.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790452445381",
      "vsf_explanation": "Plain L-arginine has meta-analytic support for endothelial function and NO signaling at 3-6 g/day (Schwedhelm 2008; Bode-Böger 2007), but its short plasma half-life means multiple daily servings are needed. Held below Verified because pharma-grade sourcing is not confirmed on this generic SKU and citrulline co-formulation (better bioavailability per Schwedhelm) would be a formulation upgrade. Would move to Verified 70+ with named pharma-grade source or citrulline addition.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "iron-ferrous-fumarate",
      "title": "Iron Ferrous Fumarate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/229eece2-e1d5-488c-ad2e-d82fe5a5df33_large_fd6d2ebb-26b4-439b-b444-654e122432f9.jpg?v=1787417008",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "iron",
        "ferrous",
        "fumarate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 66,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790452347077",
      "vsf_explanation": "Ferrous fumarate is a common inexpensive iron form with good elemental iron content (~33%) and moderate absorption, but higher GI side effect burden than bisglycinate (Milman 2014). Safety docked for constipation/nausea common at therapeutic 65mg elemental doses. Standard tier — legit iron repletion, less tolerable than Ferrochel. Alt-day dosing improves fractional absorption (Stoffel 2017).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-glutathione-featuring-setria-glutathione",
      "title": "L-Glutathione - Featuring Setria Glutathione",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7a9b4b95-55a9-447b-849f-cf37836703d4_large_e83ec5ce-4972-4c99-b3c7-53448327c37a.jpg?v=1787417007",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glutathione",
        "featuring",
        "setria",
        "glutathione",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 74,
        "safety": 72,
        "transparency": 70,
        "sustainability": 58
      },
      "price": 18.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790452314309",
      "vsf_explanation": "Duplicate Setria oral glutathione SKU — same evaluation: Richie 2015 supports Setria specifically at 500-1000 mg/day for sustained rises in body glutathione stores. Held to top of Standard by likely sub-Richie dose per capsule and no published per-lot COA. Would move to Verified with studied-dose disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-glutamine",
      "title": "L-Glutamine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/681b5db1-b7da-4bec-8e3f-e9aa29627284_large_0b3b2234-decb-4d17-a753-3aa39bc38c08.jpg?v=1787417008",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glutamine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 14.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790452510917",
      "vsf_explanation": "L-glutamine is a well-studied enterocyte fuel with gut-barrier support at 5-10 g/day (Kim 2017 review). Free-form powder is the standard form. Would move to Verified 70+ with named fermentation source, third-party assay, and clear elemental g per scoop.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-ornithine-free-form",
      "title": "L-Ornithine - Free Form",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8ad74773-22e6-4c72-89bc-c7847996e504_large_292c567b-b83a-4ed2-b0ec-55922c0c874e.jpg?v=1787417008",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ornithine",
        "free",
        "form",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 8.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790452379845",
      "vsf_explanation": "L-ornithine participates in the urea cycle and has small RCT evidence for reducing fatigue at 2-6 g (Sugino 2008). Free-form is the correct format. Legit but niche. Would move to Verified 70+ with clinical-range mg disclosure and third-party purity testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-kudzu-root",
      "title": "Full Spectrum Kudzu Root",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/adfdee38-be72-4201-a96b-71310e52ce93_large_17690727-aa6f-4619-a1a9-caf309073b8c.jpg?v=1787417007",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "kudzu",
        "root",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 12.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790452576453",
      "vsf_explanation": "Kudzu (Pueraria lobata) has some RCT support for reducing alcohol consumption (Lukas 2005 — puerarin-standardized extract, small trial). Whole-root full-spectrum powder is not standardized to puerarin, so per-capsule active is not disclosed. Legit traditional herb, under-formulated versus clinical evidence. Would move to Verified 70+ with % puerarin standardization at clinical dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-arginine-1",
      "title": "L-Arginine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/88090086-ca91-453a-9373-ece91a6c12e6_large_d4f2fa99-b83c-4136-babe-f63f8a642b3d.jpg?v=1787417008",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "arginine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 14.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790452543685",
      "vsf_explanation": "Standard L-arginine with real endothelial-function evidence at 3-6 g/day (Schwedhelm 2008). Short plasma half-life requires multiple daily servings for sustained effect. Held below Verified because pharma-grade sourcing is not confirmed on this generic SKU and citrulline co-formulation would be a bioavailability upgrade. Would move to Verified 70+ with named source (e.g., AjiPure) or citrulline addition.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "intensive-hand-foot-therapy-cream",
      "title": "Intensive Hand & Foot Therapy Cream",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/91a8318f-fbaf-4fa5-a570-d7b35f02f5f6_large_cccb34f2-912b-48be-a370-818dad0b146d.jpg?v=1787417008",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "intensive",
        "hand",
        "foot",
        "therapy",
        "cream",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 7.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790452609221",
      "vsf_explanation": "Topical hand and foot moisturizer — clinical evidence for topical formulations depends entirely on the disclosed actives (urea %, shea, ceramides) which are not visible from the title. Legit consumer skincare category from a supplement retailer; not really an evidence-driven product. Would move to Verified 70+ with clinical-strength urea (10-20%), disclosed ceramide/niacinamide %, and dermatology testing data.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "joint-cream-with-glucosamine-boswellia",
      "title": "Joint Cream with Glucosamine & Boswellia",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5866fa4d-4897-4273-9982-e7b2e1e7d5e5_large_814338a3-1ef2-40eb-8915-3594517f3a0a.jpg?v=1787417008",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "joint",
        "cream",
        "with",
        "glucosamine",
        "boswellia",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 55,
        "sustainability": 52
      },
      "price": 12.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790452412613",
      "vsf_explanation": "Topical cream combining glucosamine and Boswellia serrata (frankincense). Oral Boswellia has good OA evidence when standardized to 30%+ AKBA (Sengupta 2008, Kulkarni 1991); oral glucosamine has GAIT support. Topical delivery for both actives has almost no independent RCT support — the actives don't cross skin efficiently. Held below Verified by evidence gap for topical route and unspecified standardization. Would move to Verified 70+ only with topical bioavailability data.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-tyrosine",
      "title": "L-Tyrosine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2361fdf6-d2c9-4b6a-aa11-54432d8fd809_large_a97a91d2-5553-4d51-8296-73ec1917ccf9.jpg?v=1787417008",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tyrosine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 10.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790452478149",
      "vsf_explanation": "L-tyrosine has good evidence for cognitive performance under acute stress (Deijen 1999 military trials; Colzato 2013) at 1.5-2 g. Free-form is correct. Solid mid-tier value. Would move to Verified 70+ with clinical-dose serving mg disclosure and named fermentation source.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-arginine-l-ornithine-2-pack",
      "title": "L-Arginine & L-Ornithine - 2 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/64d20ab6-4426-4912-84f4-554bda591eb5_large_5ec6aef8-3fd5-4abf-850e-ca48995fba7b.jpg?v=1787417008",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "arginine",
        "ornithine",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 21.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790452641989",
      "vsf_explanation": "Arginine plus ornithine 2-pack — a sports-nutrition legacy combo with modest human data for GH response (Chromiak 2002) and only indirect cardiovascular evidence via arginine's NO pathway (Schwedhelm 2008). Ornithine adds little cardiovascular benefit on its own. Would move to Standard 65+ with disclosed per-serving mg and pharma-grade sourcing; L-citrulline would be a stronger cardiovascular co-ingredient than ornithine.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-tryptophan",
      "title": "L-Tryptophan",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/93eed223-7457-4407-ab90-20c38ead3cbe_large_4cf919de-816b-4870-934e-32b9e98b7143.jpg?v=1787417008",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tryptophan",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 64,
        "sustainability": 55
      },
      "price": 13.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790452674757",
      "vsf_explanation": "Generic L-tryptophan (no TryptoPure branding disclosed) - serotonin precursor with modest evidence for sleep-onset and mood at 500-1500mg (Silber 2010 review). Historical EMS contamination episode makes Peak-X purity testing a critical quality marker that generic tryptophan may or may not include. Serotonergic drug-interaction risk applies (SSRIs, MAOIs, tramadol, triptans). Would move to Verified 70+ with TryptoPure or equivalent branded material and prominent serotonergic-drug interaction warning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-juniper-berries",
      "title": "Full Spectrum Juniper Berries",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fe09ea64-0665-46d8-8264-b341422a2386_large_b3b574f4-e72c-41d7-b455-67d216189a3c.jpg?v=1787417008",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "juniper",
        "berries",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 12.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790452707525",
      "vsf_explanation": "Juniper berry is a traditional diuretic and carminative with minimal modern RCT support. Contains volatile oils that can irritate kidneys at high doses; not recommended for pregnancy or kidney disease. Whole-berry powder without standardization limits potency. Would move higher only with kidney-safety documentation and standardized volatile-oil content.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-carnitine",
      "title": "L-Carnitine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9882485d-cb0c-4813-a518-55a9587d23e1_large_9440ead2-6244-4228-91a0-3e65092c1f78.jpg?v=1787417008",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "carnitine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 66,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 18.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790452740293",
      "vsf_explanation": "Second plain L-carnitine SKU with same scoring rationale as the sibling above. Small-effect evidence for fatty-acid oxidation and recovery at 2-4g/day (Broad 2008, Volek 2002). Commodity SKU without Carnipure branding, published COA, or per-serving dose confirmation. Would move up with sourcing disclosure, confirmed dose, and TMAO safety disclosure (Koeth 2013).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-citrulline-malate",
      "title": "L-Citrulline Malate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7b5f033c-75ee-4b23-9163-e16424d1e1ea_large_0b10752f-676b-4eac-90af-8f9801cd2938.jpg?v=1787417008",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "citrulline",
        "malate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 66,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 14.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790453821637",
      "vsf_explanation": "L-citrulline malate is pharmacologically the smarter NO-support choice than L-arginine — citrulline sustains plasma arginine longer by bypassing first-pass metabolism (Schwedhelm 2008), and the malate salt adds a modest exercise-performance angle (Perez-Guisado 2010). Studied doses run 6-8 g/day, which can be hard to hit in capsules. Held below Verified because the citrulline-to-malate ratio (usually 2:1 in trials) and per-serving mg are not disclosed on the SKU. Would move to Verified 70+ with disclosed 2:1 ratio, per-serving mg, and named source.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-glutathione-featuring-setria-glutathione-2-pack",
      "title": "L-Glutathione - Featuring Setria Glutathione - 2 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7fe7765e-2dd9-4e1b-b543-565cdd24bda7_large_54b3d47d-7889-4b8c-9103-a8ed7222328d.jpg?v=1787417008",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glutathione",
        "featuring",
        "setria",
        "glutathione",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 74,
        "safety": 72,
        "transparency": 70,
        "sustainability": 58
      },
      "price": 28.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790452773061",
      "vsf_explanation": "2-pack of the Setria oral glutathione SKU — same profile: legitimate Kyowa Hakko branded reduced GSH with Richie 2015 human data supporting body-store increases at 500-1000 mg/day. Bundle format doesn't change quality assessment. Held at top of Standard by typical Swanson dose sitting below the studied 500 mg threshold and no per-lot COA. Would move to Verified 70+ at studied dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-arginine-l-ornithine",
      "title": "L-Arginine & L-Ornithine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6fce72b1-8497-48a7-831d-5bcdc61506e7_large_cf266ac3-7922-4b27-8c17-b8fede65e1d4.jpg?v=1787417008",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "arginine",
        "ornithine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 16.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790452805829",
      "vsf_explanation": "L-arginine plus L-ornithine is a classic sports-nutrition combo, with modest evidence for growth-hormone release at higher doses (Chromiak 2002) and only indirect cardiovascular evidence through arginine's NO-signaling pathway (Schwedhelm 2008). Ornithine offers little independent cardiovascular benefit. Would move to Standard 65+ with disclosed doses per serving and pharma-grade sourcing; L-citrulline would be a stronger co-ingredient for cardiovascular purposes than ornithine.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-arginine-2-pack",
      "title": "L-Arginine - 2 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1d36da61-bb21-473f-910d-f3b734862eed_large_4ff4c911-5fe1-48c5-bad5-a2ec470cec30.jpg?v=1787417009",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "arginine",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 56,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 19.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790453854405",
      "vsf_explanation": "L-arginine has real endothelial-function and NO-signaling evidence at 3-6 g/day (Schwedhelm 2008; Bode-Böger 2007). A 2-pack supports sustained daily dosing which is important given arginine's short plasma half-life. Held below Verified because pharma-grade sourcing is not confirmed on this generic SKU, per-serving mg is not disclosed on the listing, and pairing with citrulline would improve pharmacokinetics. Would move to Standard 65+ with disclosed dose per capsule and named source; Verified 70+ with pharma-grade named source (e.g., AjiPure) and citrulline addition.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnesium-oxide",
      "title": "Magnesium Oxide",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f50aec63-ad8c-44c1-9f36-94f3275bfa37_large_5ed17427-fc9d-4ec2-af2a-8c12f6906f78.jpg?v=1787417009",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "oxide",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 48,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 18.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790453887173",
      "vsf_explanation": "Magnesium oxide — ~4% bioavailability (Walker 2003), cheap laxative form. Standard tier floor. Users seeking sleep/muscle/BP benefits should choose glycinate or citrate.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-citrulline-malate-complex-powder",
      "title": "L-Citrulline Malate Complex Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/05283790-c1a7-4090-aaef-92d9dcba5742_large_5b86f4b3-61f2-4bd4-9b3d-0142050d8875.jpg?v=1787417010",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "citrulline",
        "malate",
        "complex",
        "powder",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 70,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 19.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790453919941",
      "vsf_explanation": "L-citrulline malate is the pharmacologically smarter choice for NO signaling than L-arginine — citrulline bypasses first-pass metabolism and sustains plasma arginine better (Schwedhelm 2008), and the malate salt adds a modest exercise-performance mechanism (Perez-Guisado 2010). Powder delivery makes reaching the 6-8 g/day studied dose practical. Held below Verified because the citrulline-to-malate ratio (typically 2:1 in studied products) is not disclosed on the SKU and the source is not named. Would move to Verified 72+ with disclosed 2:1 ratio, per-scoop mg reaching 6 g citrulline, and named source.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lutein-esters-featuring-lutemax",
      "title": "Lutein Esters - Featuring Lutemax",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e188ced3-411d-4268-b948-56843a43790d_large_66ba802c-e5ce-4779-84f3-60efc52173a6.jpg?v=1787417011",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lutein",
        "esters",
        "featuring",
        "lutemax",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 72,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 11.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790454804677",
      "vsf_explanation": "Lutemax 2020 is a branded Omniactive lutein + zeaxanthin isomers ingredient with strong RCT support (LAMA trial series for macular pigment and blue-light protection). Named source is a real quality signal for a Swanson product. Fat-soluble carotenoid delivery in oil is appropriate. Would push toward Elite with AREDS2-matched dose disclosure, USP or NSF certification, and marigold sustainability documentation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnesium-oxide-1",
      "title": "Magnesium Oxide",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5b553dc1-1305-4087-a606-889dfe763ccf_large_7d7961f7-a22f-48f0-99b5-eeae54bc1296.jpg?v=1787417011",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "oxide",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 48,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 12.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790454837445",
      "vsf_explanation": "Magnesium oxide — ~4% bioavailability (Walker 2003), essentially a cheap laxative. Standard tier floor. Better forms exist for magnesium repletion.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "licorice-root",
      "title": "Licorice Root",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9d01492f-9117-4bc6-9c9f-e36fead5529f_large_f5ca5ff8-9849-440a-b026-77cbc9ad070e.jpg?v=1787417011",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "licorice",
        "root",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 45,
        "transparency": 55,
        "sustainability": 52
      },
      "price": 10.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790454870213",
      "vsf_explanation": "Whole (non-DGL) licorice root capsules carry pseudoaldosteronism risk from glycyrrhizin (Sigurjonsdottir 2001) — chronic use elevates BP and lowers potassium. DGL format is safer for daily supplementation. Would move to Standard 65+ only with prominent BP-monitoring warning and short-course-only guidance, or reformulate as DGL.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lycopene",
      "title": "Lycopene",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/11f98e3e-7a29-4af5-8025-df550cad02e3_large_cc502080-1248-48c0-a088-7b33aea66b98.jpg?v=1787417011",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lycopene",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 17.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790454902981",
      "vsf_explanation": "Standard Swanson lycopene softgel. Real prostate-health and cardiovascular signal (Etminan 2004) but form of lycopene (tomato-derived vs synthetic) and cis-isomer ratio matter and are not disclosed. Would move to Verified 70+ with LycoRed or comparable branded source and disclosed mg per serving.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-maca",
      "title": "Full Spectrum Maca",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/17568521-5add-44c5-8d7e-1826c24c9e55_large_12df8466-0714-4e8a-b379-9d7f5b2f9d00.jpg?v=1787417011",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "energy",
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "maca",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 12.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790454935749",
      "vsf_explanation": "Full Spectrum (whole-root) maca. Maca has modest RCT evidence for libido (Gonzales 2002 — improved sexual desire in healthy men) and erectile function (Zenico 2009), and generally acceptable safety. Whole-root powder is the traditional Andean format; standardized-extract versions (e.g., 6:1) may deliver more concentrated actives. Sourcing origin (Peru vs. non-Peruvian) matters for the traditional botanical profile. Would move to Verified 70+ with named Peruvian-source maca, disclosed dose meeting studied ranges (1.5-3g/day), and color/variety specification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnesium-taurate",
      "title": "Magnesium Taurate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6dc32219-67d0-42bf-be90-a4b2b7b7595d_large_5b64d309-f6fa-4781-9f3b-b4b58f2a9560.jpg?v=1787417013",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "taurate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 66,
        "formulation": 68,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 21.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790455066821",
      "vsf_explanation": "Magnesium taurate combines magnesium with taurine (which itself has cardiovascular BP evidence — Xu 2008). Sometimes preferred for cardiovascular use and blood pressure support (Kass 2012 for magnesium generally). Standard tier upper end — reasonable form, thinner RCT base than glycinate. Would move to Verified with head-to-head cardiovascular data.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lycopene-1",
      "title": "Lycopene",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f5848299-d21e-43bb-bb4f-8e551878c252_large_9d81a8d9-11cd-4179-8919-d9f458250973.jpg?v=1787417013",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lycopene",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 19.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790455099589",
      "vsf_explanation": "Lycopene has evidence for prostate health markers and cardiovascular risk (Etminan 2004 meta-analysis — moderate risk reduction). 10-30 mg is common clinical range. Softgel + oil carrier is the appropriate form for a fat-soluble carotenoid. Would move to Verified 70+ with named branded source (LycoRed) and disclosed cis-lycomere ratio.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "licorice-root-liquid-extract-alcohol-sugar-free",
      "title": "Licorice Root Liquid Extract - Alcohol & Sugar Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/99c516ee-de0d-482c-92ab-b3891870d93f_large_25c20373-253c-41b4-96e8-2ecad310c93d.jpg?v=1787417013",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "licorice",
        "root",
        "liquid",
        "extract",
        "alcohol",
        "sugar",
        "free",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 45,
        "transparency": 58,
        "sustainability": 52
      },
      "price": 6.17,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790455197893",
      "vsf_explanation": "Full (non-DGL) licorice (Glycyrrhiza glabra) contains glycyrrhizin, which inhibits 11-beta-hydroxysteroid dehydrogenase and causes pseudoaldosteronism — hypertension, hypokalemia, and edema at chronic intake (Sigurjonsdottir 2001). Traditional demulcent evidence is decent but the safety liability at daily-supplement doses makes DGL the preferred format. Would move to Standard 65+ only with clear BP-monitoring warnings and short-course use guidance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lemon-balm-passionflower-skullcap-complex",
      "title": "Lemon Balm, Passionflower, Skullcap Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/782b1fff-5e74-40fa-b74b-22481bd95efa_large_565ae2b6-a476-4f08-b3cb-23a9751b1b22.jpg?v=1787417013",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lemon",
        "balm",
        "passionflower",
        "skullcap",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 62,
        "sustainability": 60
      },
      "price": 21.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790455132357",
      "vsf_explanation": "Traditional herbal sleep/anxiety triple - lemon balm (Kennedy 2006 for anxiety), passionflower (Akhondzadeh 2001), and skullcap (limited modern trial data). Combo formulas dilute each below monotherapy dose but the pharmacological rationale is coherent for mild anxiety-related sleep issues. Safety is favorable. Would move to Verified 70+ with per-active standardization (lemon balm rosmarinic acid; passionflower vitexin) at RCT-relevant doses.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liquid-calcium-magnesium",
      "title": "Liquid Calcium & Magnesium",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9930f56d-a707-4a78-91cf-45bd7f28a03d_large_a0476b01-da04-44a6-b702-2ef22f57c064.jpg?v=1787417013",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liquid",
        "calcium",
        "magnesium",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 8.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790455165125",
      "vsf_explanation": "Liquid Ca/Mg for users preferring non-capsule delivery. Absorption depends on underlying mineral form. Isolated high-dose calcium without K2 raises cardiovascular concerns (Bolland 2015). Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liver-glandular",
      "title": "Liver Glandular",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7b8d19c7-0279-449f-b9da-f4da7eba4d7c_large_f31c6aba-739c-4f90-8192-c9549da8ce47.jpg?v=1787417015",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liver",
        "glandular",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 8.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790456082629",
      "vsf_explanation": "Beef liver glandular supplements are trending in ancestral/carnivore circles for iron, vitamin A, B12 content. RCT evidence for glandular therapy is essentially absent; nutritional value from whole liver is real but modest at capsule doses. Sourcing quality (grass-fed, freeze-dried, undefatted) matters heavily and is not clarified. Would move to Verified 70+ with named grass-fed source, freeze-dried processing, and glyphosate/heavy-metal testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "soy-lecithin-non-gmo",
      "title": "Soy Lecithin Non-GMO",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3df5f71d-3800-40dd-aef4-041d6e734131_large_dbb3fbb7-4427-4a6b-bccd-2fc66f57dcdf.jpg?v=1787417015",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "soy",
        "lecithin",
        "non",
        "gmo",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 10.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790456115397",
      "vsf_explanation": "Non-GMO soy lecithin as phosphatidylcholine source. Legit but modest per-serving choline. Would move to Verified 70+ with disclosed phosphatidylcholine %, mg choline, and hexane-free extraction.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lutein-esters",
      "title": "Lutein Esters",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f40b3a94-d215-4004-abbd-6fcbdb05f6d7_large_253e5462-a8b5-4066-a4ba-3534a1ff3714.jpg?v=1787417015",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lutein",
        "esters",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 63,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 8.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790456148165",
      "vsf_explanation": "Lutein has strong evidence for macular pigment density and AMD progression (AREDS2 trial — 10 mg lutein + 2 mg zeaxanthin). Ester form requires pancreatic esterase hydrolysis but yields free lutein comparably to free-form once absorbed (Norkus 2010). Standard mid-tier. Would move to Verified 70+ with AREDS2-matched 10 mg lutein + 2 mg zeaxanthin and disclosed source (marigold).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lutein-esters-bilberry",
      "title": "Lutein Esters & Bilberry",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/49d2b187-63a6-4f13-96fb-01ed3e2a964c_large_e8bc9765-89bc-46cd-80ef-723858c63f08.jpg?v=1787417015",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lutein",
        "esters",
        "bilberry",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 52
      },
      "price": 14.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790456180933",
      "vsf_explanation": "Lutein esters require pancreatic lipase hydrolysis to release free lutein — bioavailability is lower and more variable than free lutein used in AREDS2. Bilberry anthocyanins add antioxidant support. Would move to Verified 70+ with free-lutein (FloraGLO-style) at 10 mg per AREDS2 protocol and 25% anthocyanin bilberry standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnesium-lactate",
      "title": "Magnesium Lactate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3dc0da67-55aa-48dd-8a37-61559127c47f_large_eecd5403-2386-42dc-9c5e-6b44c5eb3b9e.jpg?v=1787417015",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "lactate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 24.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790456213701",
      "vsf_explanation": "Magnesium lactate — moderate bioavailability, sometimes preferred by users with digestive sensitivity. Evidence base is thinner than glycinate or citrate. Standard tier — legit niche form.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-glutathione-cream-with-setria-glutathione",
      "title": "L-Glutathione Cream with Setria Glutathione",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/57b09223-bca1-4f3b-80c3-2d4156358aed_large_b6a2f25c-afe1-4006-97c8-7d91fb47f64b.jpg?v=1787417015",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glutathione",
        "cream",
        "with",
        "setria",
        "glutathione",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 60,
        "manufacturing": 65,
        "safety": 68,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790456246469",
      "vsf_explanation": "Topical Setria glutathione cream — recategorized to skin/hair/beauty since the delivery is cosmetic. Setria is a legitimate branded reduced glutathione, but topical GSH penetration is very limited (Watanabe 2014 for skin-lightening use showed measurable but modest effects). Marketing typically leans on tyrosinase-inhibition/skin-brightening, which has weak clinical support at topical concentrations. Would move up with a stability-tested delivery system (liposomal/nanoemulsion) and published penetration data.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lecithin-non-gmo",
      "title": "Lecithin - Non-GMO",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a001dea2-1784-4e4f-9587-47f53a62cd45_large_ecbffc90-2abe-4cb1-bd7c-17bda61dc741.jpg?v=1787417015",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lecithin",
        "non",
        "gmo",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 18.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790456279237",
      "vsf_explanation": "Non-GMO soy lecithin softgels or capsules provide phosphatidylcholine. Modest per-serving contribution unless the softgel is well-loaded. Would move to Verified 70+ with disclosed phosphatidylcholine % and hexane-free extraction disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "100-pure-magnesium-citrate-powder-unflavored",
      "title": "100% Pure Magnesium Citrate Powder - Unflavored",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/36fd1489-bc15-4383-b1b9-5456f4d1b978_large_d616ebbc-a5b3-4c2e-905b-7f71b5f07219.jpg?v=1787417015",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "100",
        "pure",
        "magnesium",
        "citrate",
        "powder",
        "unflavored",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 70,
        "manufacturing": 62,
        "safety": 62,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 12.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790456344773",
      "vsf_explanation": "Pure magnesium citrate powder — good bioavailability (~30%, Walker 2003) with mild laxative effect at high doses. Powder format allows flexible dosing 200-400mg elemental. Unflavored and single-ingredient formulation is a transparency plus. Standard tier upper end. Would move to Verified with third-party verification and dose-per-scoop clarity.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnesium-oxide-2-pack",
      "title": "Magnesium Oxide - 2 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9224b1e6-7b36-4fbd-9b0e-6251515ab6ac_large_74814a21-9e7c-45dc-9a7e-a5897ff6c82d.jpg?v=1787417015",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "oxide",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 48,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790456377541",
      "vsf_explanation": "2-pack of magnesium oxide — ~4% bioavailability (Walker 2003), essentially a cheap laxative rather than systemic magnesium repletion. Standard tier floor. Users wanting sleep/muscle/BP benefits should choose glycinate or citrate.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liposomal-vitamin-c-high-bioavailability",
      "title": "Liposomal Vitamin C - High Bioavailability",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1e3ce2fc-3a73-48f8-a6b2-e5ee19574718_large_0ff2cd5d-0b6d-4ee3-9606-de85aef878d9.jpg?v=1787417017",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liposomal",
        "vitamin",
        "high",
        "bioavailability",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 76,
        "manufacturing": 64,
        "safety": 72,
        "transparency": 66,
        "sustainability": 55
      },
      "price": 26.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790457327813",
      "vsf_explanation": "True liposomal vitamin C shows higher plasma AUC than plain ascorbic acid (Davis 2016) and reduces GI intolerance. Held below Elite by unverified encapsulation quality (mass-market liposomals vary widely in true vs marketing 'liposomal' composition), no third-party liposome validation, and no NSF/USP. Would move to Verified 75+ with independent liposome-encapsulation validation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lecithin-granules-non-gmo-100-pure",
      "title": "Lecithin Granules - Non-GMO 100% Pure",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b5e65ed4-a3b4-4992-991a-7798cb78a856_large_40be6a01-aafe-43ab-8767-92bc11141a20.jpg?v=1787417017",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lecithin",
        "granules",
        "non",
        "gmo",
        "100",
        "pure",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 47.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790457393349",
      "vsf_explanation": "Non-GMO lecithin granules provide phosphatidylcholine and modest choline; granular form allows higher effective doses than capsules. 'Pure' is honest for non-GMO soy lecithin. Would move to Verified 70+ with disclosed phosphatidylcholine %, per-serving choline mg, and hexane-free processing statement.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-carnitine-1",
      "title": "L-Carnitine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8d186528-241c-43fd-b2fd-0c1efa1907c4_large_889b4501-5ef8-41d4-a361-57394f476e1a.jpg?v=1787417017",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "carnitine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 66,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 10.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790457360581",
      "vsf_explanation": "Plain L-carnitine — well-tolerated amino, small-effect evidence for fatty-acid oxidation and exercise recovery at 2-4g/day (Broad 2008 meta, Volek 2002 recovery). Standard-tier commodity SKU: no Carnipure (Lonza's reference source) named at label, no COA, no per-serving dose confirmation at title level. Also carries an emerging cardiovascular signal via TMAO (Koeth 2013) that quality brands now flag. Would move up with Carnipure sourcing named, dose confirmed in the studied 2-4g range, and TMAO safety disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-proline",
      "title": "L-Proline",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/60a604d2-a1c4-485b-a107-9141b98ce9b5_large_ca8cdade-40df-41ae-aa69-6530c49e3bb8.jpg?v=1787417019",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "proline",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 14.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790457426117",
      "vsf_explanation": "L-proline is a non-essential amino acid required for collagen synthesis, most efficient when paired with lysine and vitamin C. Standalone proline supplementation has thin clinical outcome data in humans. Legit amino product but under-formulated for collagen synergy. Would score higher in a proline+lysine+C combination at studied ratios.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "omega-3-fish-oil-with-vitamin-d-lemon-flavored",
      "title": "Omega-3 Fish Oil with Vitamin D - Lemon Flavored",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4e8dfcc9-e1cd-4e1b-b986-905ec3839e53_large_4ceb2319-db28-4892-8039-ddaa9648a91b.jpg?v=1787417020",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "omega",
        "fish",
        "oil",
        "with",
        "vitamin",
        "lemon",
        "flavored",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 74,
        "formulation": 66,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 62,
        "sustainability": 58
      },
      "price": 8.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790458212549",
      "vsf_explanation": "EPA+DHA has strong cardiovascular evidence (Bhatt 2019 REDUCE-IT, Mozaffarian 2011), and adding D3 addresses another commonly deficient nutrient. Lemon flavoring masks residual fish oil oxidation flavor — a rancidity risk indicator to keep in mind. Held below Verified by unclear EPA/DHA mg split, unclear D3 IU, no IFOS certification, and no oxidation (TOTOX) transparency. Would move to Verified 70+ with IFOS 5-star certification, TOTOX data, and clear EPA/DHA mg + D3 IU disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "keratin",
      "title": "Keratin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/25e82c03-5e1d-4f93-8a24-b8d79dcb27b8_large_f29b4537-1fac-4041-ac85-60e58bc32de9.jpg?v=1787417020",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "keratin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 58,
        "sustainability": 45
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790458245317",
      "vsf_explanation": "Oral keratin (typically Cynatine HNS branded) has one industry-sponsored trial (Beer 2014) showing hair strength improvements. Generic Swanson keratin without the Cynatine designation lacks the branded trial data. Would move to Verified 70+ with Cynatine HNS branding and third-party quality certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "omega-3-fish-oil-lemon-flavor",
      "title": "Omega-3 Fish Oil - Lemon Flavor",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ce2ef236-d0b1-480e-b322-d05ef825739f_large_2ee76e86-62c9-4127-a062-06ceeb8c3516.jpg?v=1787417021",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "omega",
        "fish",
        "oil",
        "lemon",
        "flavor",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 18.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790458343621",
      "vsf_explanation": "Standard fish oil, lemon-flavored to mask rancidity. EPA+DHA has solid triglyceride and cardiovascular RCT support (REDUCE-IT for high-dose EPA; Bernasconi 2020 meta-analysis). Fish oil form (triglyceride vs ethyl ester) and IFOS/GOED certification not visible from the title. Would move to Verified with triglyceride form, ≥600mg EPA+DHA per softgel, and IFOS certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liquid-calcium-magnesium-1",
      "title": "Liquid Calcium & Magnesium",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5d90b610-26a5-4bc7-a1b0-aa34f307c751_large_d000664e-4a66-4db2-9bf5-456340683342.jpg?v=1787417021",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liquid",
        "calcium",
        "magnesium",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 13.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790458310853",
      "vsf_explanation": "Liquid Ca/Mg for users who prefer non-capsule delivery. Absorption depends on the underlying mineral form (typically citrate or gluconate in liquid formulas). High-dose isolated calcium supplementation without K2 raises cardiovascular concerns (Bolland 2015). Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "soy-lecithin-non-gmo-1",
      "title": "Soy Lecithin Non-GMO",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/685d44a4-0820-4d55-8db9-3df9bafdfca4_large_2055cc3f-9439-4afe-9177-a4d9b9d27f2f.jpg?v=1787417021",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "soy",
        "lecithin",
        "non",
        "gmo",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 18.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790458376389",
      "vsf_explanation": "Non-GMO soy lecithin as a phosphatidylcholine source — supports choline intake and membrane phospholipids. Older studies suggested cognitive support but effect sizes are small in healthy adults. Non-GMO callout is a plus for shoppers avoiding GMO soy. Would move to Verified 70+ with disclosed phosphatidylcholine %, mg per serving, and third-party purity data (soy allergens/hexane residue).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-glutamine-2-pack",
      "title": "L-Glutamine - 2 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3c8e2e06-3065-4590-970e-1dcf94f1aa0d_large_d7f97c54-b33d-4fe2-b3c2-b8026f95ed4c.jpg?v=1787417021",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glutamine",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 17.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790458409157",
      "vsf_explanation": "L-glutamine is well-studied as an enterocyte fuel and is used for leaky-gut and post-workout recovery (Kim 2017 review — modest benefit at 5-10 g/day). Free-form powder or capsule is the standard form. 2-pack is a value bundle. Would move to Verified 70+ with a specified elemental g per serving, GMP-plus third-party assay, and named fermentation source.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "green-lipped-mussel-1",
      "title": "Green Lipped Mussel",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e767df79-b415-4c04-8cbf-6af2c7ab9e0d_large_3dc5945e-c7dc-45b7-9477-d43befb7c76a.jpg?v=1787417024",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "green",
        "lipped",
        "mussel",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 66,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790459326661",
      "vsf_explanation": "New Zealand green-lipped mussel (Perna canaliculus) has modest evidence for osteoarthritis (Cobb 2006 review — some benefit vs placebo). Standard extract lacks the branded Lyprinol/PCSO-524 designation that has the most trial data. Marine sourcing raises minor sustainability questions. Would move to Verified 70+ with Lyprinol or PCSO-524 branding, disclosed mg per serving, and sustainable-fisheries certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "5-nutrition-liver-and-organ-defender",
      "title": "5% Nutrition Liver And Organ Defender",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5-Nutrition-Liver-And-Organ-Defender.jpg?v=1787417036",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrition",
        "liver",
        "and",
        "organ",
        "defender",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 45.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790464700613",
      "vsf_explanation": "5% Nutrition's Liver & Organ Defender is a bodybuilder-oriented liver-support formula typically stacking milk thistle, NAC, TUDCA, and other hepatoprotectives at moderate doses — reasonable for anyone doing hepatotoxic PED cycles, less relevant otherwise. Milk thistle (Kim 2020 meta) and NAC have moderate hepatic evidence; TUDCA has emerging data but limited RCTs. Brand quality is bodybuilding-industry standard, not third-party certified. Would move to Verified 70 with clear per-active dosing at studied levels and NSF certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "taurine",
      "title": "Taurine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/12074c69-3b27-4f9f-ad8c-8c403062c3a3_large_4fee1017-a136-4953-b3a3-58c2ea2be6da.jpg?v=1787417050",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "taurine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 8.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790469386437",
      "vsf_explanation": "Taurine has solid evidence for blood-pressure reduction (Sun 2016 meta-analysis) and cardiovascular support, plus interest from the 2023 Singh mouse-longevity work. 500-1000 mg is a common clinical dose. Cheap and well-tolerated. Would move to Verified 70+ with disclosed serving mg, third-party purity testing, and a named source of raw material.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "melatonin-100-drug-free",
      "title": "Melatonin - 100% Drug Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e7dfcec6-1d38-4ad2-8046-c817cde21f56_large_081e7b6c-b852-4f8e-a2ad-c66af666404c.jpg?v=1787417068",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "melatonin",
        "100",
        "drug",
        "free",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 7.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790476005573",
      "vsf_explanation": "Standard melatonin SKU likely dosed at 3-5mg - above the physiological 0.3-1mg range Auld 2017 meta identifies as most aligned with endogenous secretion. The '100% drug free' framing understates that melatonin is a hormone. Would move to Verified 70+ by dropping to 0.5-1mg with physiological-dose rationale.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnesium-oxide-2",
      "title": "Magnesium Oxide",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7e0286f1-9b3d-4222-ac24-7c2f30d9dd3d_large_d621dea2-370e-48b4-88bf-793431089356.jpg?v=1787417068",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "oxide",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 48,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 11.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790475972805",
      "vsf_explanation": "Magnesium oxide has ~4% bioavailability (Walker 2003) — it is essentially a cheap laxative rather than a systemic magnesium repletion tool. Cost per elemental mg is favorable, but users chasing sleep/muscle/BP benefits should choose glycinate or citrate. Standard tier floor — the form choice is the primary limitation. Safe for occasional constipation use.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "melatonin-free-sleep-aid-3-in-1-formula",
      "title": "Melatonin-Free Sleep Aid - 3-in-1 Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/599a26ce-4956-4d2c-8565-1776b41b2780_large_414b2083-d9ab-4218-88c9-1ed2b48cb5a1.jpg?v=1787417069",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "melatonin",
        "free",
        "sleep",
        "aid",
        "formula",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 64,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 64,
        "sustainability": 58
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790476071109",
      "vsf_explanation": "Melatonin-free herbal sleep formula (likely valerian + chamomile + passionflower or similar) - a legitimate alternative for users who want to avoid melatonin hormone exposure or who have not responded to it. Combo formats dilute each herb below its monotherapy dose, but the pharmacological rationale is coherent. Safety is favorable. Would move to Verified 70+ with per-active RCT-relevant doses maintained (valerian 400-600mg, chamomile apigenin-standardized 220mg per Amsterdam 2016) plus standardization percentages disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "marine-collagen-peptides-type-i-featuring-morikol",
      "title": "Marine Collagen Peptides Type I - Featuring Morikol",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8b23e733-e5e5-4090-b17a-0622d51dd2de_large_7e362daf-4534-4bad-8ba4-37e8041b1842.jpg?v=1787417068",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "marine",
        "collagen",
        "peptides",
        "type",
        "featuring",
        "morikol",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 74,
        "manufacturing": 66,
        "safety": 72,
        "transparency": 72,
        "sustainability": 60
      },
      "price": 11.93,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790476038341",
      "vsf_explanation": "Named-source Morikol marine collagen (a Nitta Gelatin ingredient with low-MW peptides and some human data for skin) at correct Type I form. Marine collagen has slightly better bioavailability than bovine per Skov 2019, and Proksch 2014-family trials support skin elasticity outcomes at 2.5-10 g/day. Named clinical ingredient plus correct hydrolyzed form pushes this to Verified. Held below Elite by no MSC certification for the marine sourcing and mid-tier manufacturing. Would move to 80+ with MSC-certified fishery and third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mens-multi-prostate-support",
      "title": "Men's Multi +Prostate Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/57e80e80-415f-4ba9-aa2f-ce19b5419c85_large_52d85fb3-b24e-4ce9-8280-98cb18686b65.jpg?v=1787417068",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "men",
        "multi",
        "prostate",
        "support",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 17.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790476169413",
      "vsf_explanation": "Men's multivitamin with prostate-support additions (typically saw palmetto, lycopene, zinc). Standard multi coverage (Gaziano 2012 PHS II) plus modest saw palmetto BPH evidence (Wilt 1998 positive; Bent 2006 STEP null). Multi-formula dosing typically under-delivers saw palmetto vs. the 320mg lipid-extract monograph, and standardization percentages often aren't disclosed. Would move to Verified 70+ with monograph-level actives, disclosed standardization, and third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mullein-leaf-liquid-extract-alcohol-sugar-free",
      "title": "Mullein Leaf Liquid Extract - Alcohol & Sugar Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/98600602-c722-4fe2-8d12-74096f63a679_large_e8ec3655-55a9-4404-96d2-c179d0f1f62d.jpg?v=1787417068",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mullein",
        "leaf",
        "liquid",
        "extract",
        "alcohol",
        "sugar",
        "free",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 66,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790475940037",
      "vsf_explanation": "Alcohol- and sugar-free glycerite liquid mullein is fine for people avoiding alcohol tinctures (kids, pregnancy). Mullein has traditional respiratory-tract use but modern RCT evidence is thin. Glycerin extracts pull fewer alkaloids than ethanol extracts, so bioactivity is reduced. Would benefit from marker standardization to compete in the Verified tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mega-glucosamine",
      "title": "Mega Glucosamine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c142ab86-38db-48f6-989f-c5031376a62d_large_4e39bab4-7338-4fdb-84c6-ea95351ad56b.jpg?v=1787417068",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mega",
        "glucosamine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 58,
        "sustainability": 52
      },
      "price": 4.06,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790476234949",
      "vsf_explanation": "'Mega' framing suggests a high-per-cap dose (likely 1000-1500 mg glucosamine) — reaches clinical range with fewer pills. GAIT (Clegg 2006) supported 1500 mg/day glucosamine sulfate for moderate-severe OA. Held below Verified by unclear glucosamine salt (sulfate vs HCl matters for evidence) and no third-party COA. Would move to Verified 70+ with sulfate-form disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "extra-low-dose-melatonin-100-drug-free",
      "title": "Extra Low Dose Melatonin - 100% Drug Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0d013b96-01b4-4d5a-bce0-ef369a1e43d9_large_06e0d1d1-3f9b-44fe-86e0-637f6bbf046e.jpg?v=1787417068",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "extra",
        "low",
        "dose",
        "melatonin",
        "100",
        "drug",
        "free",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 74,
        "formulation": 76,
        "manufacturing": 66,
        "safety": 76,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 3.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790476267717",
      "vsf_explanation": "'Extra low dose' melatonin - likely 0.3-0.5mg, precisely the physiological range that Zhdanova 2001 identified as most effective for sleep-onset without pharmacological over-shoot, and consistent with Auld 2017 meta findings. This is a rare and honest formulation choice in a category flooded with 3-10mg over-dosed SKUs. Held below Elite by generic Swanson manufacturing footprint and no per-lot COA published. Would move to Verified 78+ with per-lot testing and physiological-dose rationale prominently displayed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "maximum-strength-l-arginine-akg-powder-natural-citrus-flavored",
      "title": "Maximum Strength L-Arginine AKG Powder - Natural Citrus Flavored",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c3f35d0f-3807-455e-b4f6-70db8c4b6203_large_0a8ccfe5-0706-4658-8165-6109e3943e37.jpg?v=1787417069",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "maximum",
        "strength",
        "arginine",
        "akg",
        "powder",
        "natural",
        "citrus",
        "flavored",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 29.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790476103877",
      "vsf_explanation": "Powder delivery is a genuine formulation advantage for arginine products — dosing to the 3-6 g elemental range needed for endothelial NO effect (Schwedhelm 2008) is impractical in capsules. AAKG has lower elemental arginine per gram than plain L-arginine, so total powder-per-scoop matters. Held below Verified because pharma-grade sourcing is not confirmed, elemental arginine per scoop is not clearly disclosed, and pure L-arginine or an arginine+citrulline combo would generally out-perform AAKG for endothelial endpoints. Would move to Verified 70+ with named pharma source and clearly disclosed elemental arginine per scoop.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "marshmallow-root",
      "title": "Marshmallow Root",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/678197bf-30df-4291-a549-e4a2b5cefefd_large_4e23cf31-bf8a-43fd-aa70-ee9f142ef12f.jpg?v=1787417069",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "marshmallow",
        "root",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 55,
        "sustainability": 52
      },
      "price": 8.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790476300485",
      "vsf_explanation": "Marshmallow root (Althaea officinalis) is a traditional mucilaginous demulcent for cough and GI irritation. Very safe but human RCT evidence is minimal. Whole-root powder in a capsule may deliver mucilage less effectively than aqueous cold-infusion. Would move to Standard 62+ with mucilage-standardized extract and cold-water preparation format.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "malic-acid",
      "title": "Malic Acid",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/29266ed3-ff7f-4289-9253-3e9ae18d57ce_large_2f8a29b8-e4bc-4124-805e-37819d6787f7.jpg?v=1787417069",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "malic",
        "acid",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790476333253",
      "vsf_explanation": "Malic acid participates in the Krebs cycle and has been paired with magnesium in fibromyalgia trials (Russell 1995 — small, mixed results). Standalone oral malic acid is not clearly ATP-boosting in healthy adults. Legit inexpensive amino/organic acid, but underwhelming clinical support alone. Would score higher paired with magnesium at the studied ratios.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "melatonin-gummies-strawberry",
      "title": "Melatonin Gummies - Strawberry",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8d4c0337-d5ad-47ca-b402-ed69f483dde8_large_fd78ed83-7e83-48e9-a5cb-7fbd0b11a44d.jpg?v=1787417068",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "melatonin",
        "gummies",
        "strawberry",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 58,
        "safety": 48,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 13.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790476202181",
      "vsf_explanation": "Melatonin gummies (typically 3-10mg per gummy, with 2020 JAMA analysis by Erland showing many products contain 100-500% of labeled dose plus CBD contamination). Gummy format encourages accidental pediatric overdose - CDC reported 260% rise in melatonin overdose calls in kids 2012-2021 (Lelak 2022). Sugar/flavor system adds calories and dental impact. Would move to Verified 70+ with independently verified dose accuracy, child-resistant packaging, physiological 0.5-1mg dose, and prominent pediatric-caution warning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "milk-thistle-liquid-extract-alcohol-sugar-free",
      "title": "Milk Thistle Liquid Extract - Alcohol & Sugar Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8089294b-826c-4710-8193-fd852cdb2bea_large_f0434feb-0a84-4f46-98f3-a5a2981723dd.jpg?v=1787417069",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "milk",
        "thistle",
        "liquid",
        "extract",
        "alcohol",
        "sugar",
        "free",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 60,
        "sustainability": 58
      },
      "price": 16.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790476136645",
      "vsf_explanation": "Alcohol- and sugar-free milk thistle liquid extract — helpful for consumers who can't take alcoholic tinctures (children, alcohol abstainers, hepatology patients) but silymarin is a lipophilic flavonolignan that extracts most efficiently in ethanol. A non-alcohol aqueous glycerite typically has lower silymarin concentration than a hydroethanolic tincture. Held to mid-Standard by that pharmacognosy trade-off and by no silymarin percentage on the label. Would move up with disclosed silymarin content per dropper.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnesium-aspartate",
      "title": "Magnesium Aspartate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f12afc40-c7dc-47b4-b1db-a8178df145fa_large_232de255-1871-4425-b507-a6d00fc9c456.jpg?v=1787417069",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "aspartate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 9.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790476366021",
      "vsf_explanation": "Magnesium aspartate — decent bioavailability, older evidence base primarily for fatigue and heart failure (Stepura 2009 used a combination product). Aspartate as excitatory amino acid raises theoretical concern for excitotoxicity-sensitive users. Standard tier — legit but not top-choice form.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnesium-malate",
      "title": "Magnesium Malate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0abe1d01-3151-4bfa-a705-94e8cfca467a_large_d53ef537-4be7-4457-8593-78e0aaa419d5.jpg?v=1787417069",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "malate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 8.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790476398789",
      "vsf_explanation": "Magnesium malate — well-absorbed form with the malate carrier that participates in mitochondrial Krebs cycle, often used for fatigue and fibromyalgia (Russell 1995 preliminary data). Well-tolerated on GI. Standard tier upper end — form is solid, would move to Verified with Albion TRAACS sourcing and NSF verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natural-e-200",
      "title": "Natural E-200",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7170a650-0ef8-401e-a421-6afc4d5d22dd_large_41480fcc-c489-4483-a57e-6a8c84c83819.jpg?v=1787417069",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "natural",
        "200",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 66,
        "manufacturing": 60,
        "safety": 66,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790476693701",
      "vsf_explanation": "Natural d-alpha tocopherol at 200 IU — physiologic range and better stereoisomer than synthetic dl-alpha. Legitimate mid-tier vitamin E. Would move to Verified 70+ with a mixed tocopherol/tocotrienol complex to avoid displacing gamma-tocopherol from tissues.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mullein-leaf-extract-standardized",
      "title": "Mullein Leaf Extract - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7cc8d64f-9e53-4945-af9f-0e709b38ce26_large_88155fe8-7103-4835-9a31-949476deb9d5.jpg?v=1787417070",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mullein",
        "leaf",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 66,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 8.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790476726469",
      "vsf_explanation": "Mullein leaf is a traditional respiratory tract herb with saponins and iridoid glycosides; RCT evidence is thin (mostly ethnobotanical). 'Standardized' label at least implies a defined marker compound, which is better than raw whole-herb powder. Safe herb, well-tolerated. Would need modern RCT support for the tier ceiling to move higher; standardization detail on the label front would help too.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natural-e-201",
      "title": "Natural E-200",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/55f25235-07bb-49d0-9c7a-a7780c02a854_large_87efc6be-ae1a-4163-985d-9cf2e7199943.jpg?v=1787417071",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "natural",
        "200",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 66,
        "manufacturing": 60,
        "safety": 66,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 18.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790477086917",
      "vsf_explanation": "200 IU natural d-alpha tocopherol is closer to the evidence-supported range and avoids the mortality signal Miller 2005 identified at ≥400 IU/day. Natural stereoisomer is a real bioactivity advantage over synthetic dl-alpha. Would still benefit from mixed tocopherol/tocotrienol format to avoid gamma-tocopherol displacement. Solid mid-tier value.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "niacin",
      "title": "Niacin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/395a284c-63f3-4a98-b6ae-23239fc99cfd_large_55309e4e-aa81-47f1-acb3-094d9db3d39e.jpg?v=1787417071",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "niacin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 64,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 19.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790477054149",
      "vsf_explanation": "Nicotinic acid has clear lipid-modification evidence at 1-3g/day (Guyton 2007) but produces flushing and requires hepatic monitoring at those doses. Held below Verified by unclear mg from title and safety-warning framework gap for higher-dose usage.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "e-1000",
      "title": "E-1000",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/196ea2a3-9743-497c-a721-add43c48c7f2_large_6eabd5dd-cc1f-4d5b-86d7-950a14b9d973.jpg?v=1787417071",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "1000",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 50,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 25.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790477119685",
      "vsf_explanation": "1000 IU alpha-tocopherol far exceeds the 22 IU RDA and Miller 2005 flagged all-cause mortality risk at this dose. Isolated alpha-form displaces gamma-tocopherol. Legit brand and legit form, but the dose is out of step with current evidence. Would move higher with mixed tocopherol/tocotrienol format and physiologic dosing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "n-acetyl-l-tyrosine",
      "title": "N-Acetyl L-Tyrosine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/bd2219f8-d55d-491f-abde-02eac6b2cadd_large_387aedbf-7841-4d0c-8222-f21c0ec19605.jpg?v=1787417071",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "acetyl",
        "tyrosine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 58,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790477152453",
      "vsf_explanation": "N-acetyl L-tyrosine is not really an immune/antioxidant product — recategorized to cognitive nootropics as a stress-cognition amino acid. Ironically, NALT is actually less bioavailable as tyrosine precursor than plain L-tyrosine (Magnusson 1989 kinetics showed most NALT is renally excreted intact), so the 'enhanced form' framing is misleading. Plain L-tyrosine at 100-150 mg/kg has stronger cold-stress/cognitive-load data (Neri 1995; Mahoney 2007). Held to mid-Standard because the compound itself is legitimate for stackers who tolerate it, but the marketing premise is weaker than most consumers assume.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "msm",
      "title": "MSM",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fb7d01dd-fdc5-4c15-8970-f270203f9578_large_c044fae8-1a6c-47f6-a85c-5946c4a27698.jpg?v=1787417072",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "msm",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 63,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 58,
        "sustainability": 52
      },
      "price": 11.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790477217989",
      "vsf_explanation": "Fifth standalone Swanson MSM SKU variant. Kim 2006 and Debbi 2011 support modest OA benefit at 1500-6000 mg/day. Generic (non-OptiMSM) source with no purity COA. Held below Verified by lack of branded-source disclosure. Would move to Verified 70+ with OptiMSM sourcing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-mulberry-leaf",
      "title": "Full Spectrum Mulberry Leaf",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/bbadc925-d70f-4ebc-920e-dca04c108068_large_e867e0bb-0b63-409d-a8d8-dbb22b1a7fbb.jpg?v=1787417072",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "mulberry",
        "leaf",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 12.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790477250757",
      "vsf_explanation": "Mulberry leaf contains DNJ (1-deoxynojirimycin) which inhibits alpha-glucosidase and blunts postprandial glucose (Wang 2018 review). Full-spectrum whole-leaf powder is not standardized to DNJ, so per-capsule active is not disclosed. Legitimate niche product but under-formulated versus standardized mulberry-leaf extracts at 100-1000 mg with defined DNJ content. Would move to Verified 70+ with % DNJ standardization and clinical dose disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natural-e-400",
      "title": "Natural E-400",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e77c6916-6f7a-470e-9629-8bb60af5e46d_large_40aa6091-8084-4a50-875f-2692a9a10a64.jpg?v=1787417073",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "natural",
        "400",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 66,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 26.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790477283525",
      "vsf_explanation": "Natural d-alpha tocopherol 400 IU — the natural stereoisomer is a real formulation advantage over synthetic dl-alpha (roughly 2x bioactivity). But isolated alpha-tocopherol at 400 IU displaces gamma-tocopherol and the Miller 2005 meta-analysis raised safety concerns above this dose. Mid-tier price and quality. Would move to Verified 70+ with mixed tocopherol/tocotrienol format and dose closer to 100-200 IU.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "neem-leaf",
      "title": "Neem Leaf",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/20c00492-35a5-4f75-ae28-caa237006e2f_large_e0195738-25d0-4fc7-9165-16b2bafee9e0.jpg?v=1787417075",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "neem",
        "leaf",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 58,
        "transparency": 55,
        "sustainability": 52
      },
      "price": 8.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790477611205",
      "vsf_explanation": "Neem (Azadirachta indica) has extensive traditional Ayurvedic use but very limited controlled human evidence. In-vitro antimicrobial and antifertility signals raise safety questions for reproductive-age users. Whole-leaf powder without characterized actives. Would move to Standard 60+ with clinical outcome evidence and safety review including fertility endpoints.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nmn-nicotinamide-mononucleotide",
      "title": "NMN Nicotinamide Mononucleotide",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a8ebdbba-f06f-4d68-8b5a-7f338adba139_large_4ab93513-ad32-45fe-acbf-3471e90e1dba.jpg?v=1787417075",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nmn",
        "nicotinamide",
        "mononucleotide",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 66,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 44.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790477643973",
      "vsf_explanation": "Standalone NMN — human evidence is emerging but real: Yoshino 2021 (250mg/day raised blood NAD+ in postmenopausal women) and Igarashi 2022 (250mg increased NAD+ and improved gait/muscle in older adults). Regulatory note: FDA declared NMN not a lawful dietary ingredient in late 2022, though enforcement is uneven and product remains on shelves. Held at Standard because Swanson does not name a branded source at label (Uthever from Effepharm and MIB-626 from MetroBiotech are the reference-standard materials with published purity data), and per-serving dose is not confirmed at title level. Would move to Verified 70+ with Uthever sourcing and 250-500mg dose disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "low-dose-melatonin-100-drug-free",
      "title": "Low Dose Melatonin - 100% Drug Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/084eebe2-2248-4a68-8a6e-feb8d022ffc0_large_a73398df-fb05-43e3-a62e-15a42a9a3bbf.jpg?v=1787417075",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "low",
        "dose",
        "melatonin",
        "100",
        "drug",
        "free",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 74,
        "manufacturing": 65,
        "safety": 74,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 6.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790477676741",
      "vsf_explanation": "'Low dose' melatonin (typically 1mg or less) - close to the physiological 0.3-1mg range that Zhdanova 2001 and Auld 2017 meta support as most consistent with endogenous secretion and effective for sleep-onset. This is the correct dose format for melatonin's known biology - and a rare deliberate low-dose SKU in a category dominated by 3-10mg over-dosed products. Held below Elite by generic Swanson manufacturing footprint and no per-lot COA. Would move to Verified 75+ with per-lot testing and explicit physiological-dose rationale prominently displayed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "milk-thistle-dandelion-yellow-dock",
      "title": "Milk Thistle Dandelion & Yellow Dock",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a2843b00-d9c7-4ebb-9e34-f307b97de2e9_large_09a9e7cc-cca9-4114-a5db-cec20dba2921.jpg?v=1787417075",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "milk",
        "thistle",
        "dandelion",
        "yellow",
        "dock",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 58,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 55,
        "sustainability": 58
      },
      "price": 13.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790477709509",
      "vsf_explanation": "Traditional Western herbal liver/detox blend (milk thistle + dandelion root + yellow dock). Yellow dock (Rumex crispus) contains anthraquinones with mild laxative activity but limited modern clinical data. Held to low Standard by 'combination' hiding per-herb milligrams, no silymarin standardization, and yellow dock's oxalate content (avoid in kidney stones). Would move up with per-herb dose and silymarin standardization disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "e-1001",
      "title": "E-1000",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/93e15c65-7b61-4895-a0b4-b5a5a92b253f_large_d1164ed4-b24f-4c1d-9f3a-d9f5ec4ceab0.jpg?v=1787417076",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "1000",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 50,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 56.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790478037189",
      "vsf_explanation": "1000 IU synthetic or natural vitamin E far exceeds the 15 mg (22 IU) RDA and the Miller 2005 meta-analysis specifically flagged mortality signal at high-dose alpha-only vitamin E. Isolated alpha-tocopherol at this dose also displaces gamma-tocopherol from tissues. Legit product for a legit brand but the dose is out of step with current evidence. Would move higher only with a mixed tocopherol/tocotrienol format at more physiologic dosing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "niacinamide",
      "title": "Niacinamide",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/408b8a7e-5800-43c0-bc83-07a1daa15dd7_large_35470f98-0f08-452b-8b27-976f08001e66.jpg?v=1787417076",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "niacinamide",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 12.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790478069957",
      "vsf_explanation": "Niacinamide (nicotinamide) does not cause flushing and has legitimate evidence for skin cancer prevention (Chen 2015 NEJM ONTRAC trial at 500mg BID) and osteoarthritis in some protocols (Jonas 1996). It does not have niacin's lipid effects — an important distinction. Held below Verified by unclear mg from title and no NAD-precursor positioning transparency. Would move to Verified 70+ with mg disclosed at studied ONTRAC dose (500mg BID) and clear positioning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "msm-cream",
      "title": "MSM Cream",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f4cfc3b8-93ac-4be2-b865-b8edbb11df1e_large_495a99d2-89a1-4648-a072-4d15cd3defe7.jpg?v=1787417076",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "msm",
        "cream",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 4.85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790478102725",
      "vsf_explanation": "Topical MSM cream — while oral MSM has modest OA data, topical MSM has almost no independent RCT support at consumer strengths. Held below Verified by evidence gap for the topical route and unstated MSM percentage. Would move to Verified 70+ only with clinical evidence for topical delivery and % w/w disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "glucosamine-chondroitin-msm-mini-tabs",
      "title": "Glucosamine, Chondroitin & MSM - Mini Tabs",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/eee25be8-77a1-4ecd-9c26-010470b64c90_large_79d6e516-9c8d-4bfd-89ec-09b77699f88b.jpg?v=1787417076",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glucosamine",
        "chondroitin",
        "msm",
        "mini",
        "tabs",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 58,
        "sustainability": 52
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790478135493",
      "vsf_explanation": "Triple joint stack in mini-tab form — 'mini' means smaller doses per tab, which typically drives daily serving counts up (4-6 tabs) to hit the GAIT clinical range (1500 + 1200 + ~1500 mg). Convenience of small pills is a real formulation win for elderly users. Held below Verified by no per-tab mg disclosure at title and unclear glucosamine salt. Would move to Verified 70+ with full per-tab breakdown and sulfate-form spec.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "niacinamide-1",
      "title": "Niacinamide",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5c5dec17-2264-4a0d-9495-f1949ede9025_large_b6fe52ff-375d-4b58-ad36-95d527c155bc.jpg?v=1787417076",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "niacinamide",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 17.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790478168261",
      "vsf_explanation": "Niacinamide is non-flushing and has skin-cancer-prevention evidence at 500mg BID (Chen 2015 NEJM ONTRAC) and OA support data (Jonas 1996). Held below Verified by unclear mg from title. Would move to Verified 70+ with specific mg aligned to ONTRAC protocol.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cinnamon-bark-maximum-strength",
      "title": "Cinnamon Bark - Maximum Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/20a72081-d19f-415c-b28d-9749e58f9107_large_5aec857c-e38e-4d20-b250-3e0d7007d52a.jpg?v=1787417076",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cinnamon",
        "bark",
        "maximum",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 7.85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790478201029",
      "vsf_explanation": "Maximum-strength cinnamon bark powder. Without species disclosure (Ceylon vs Cassia), high-dose daily use risks coumarin exceedance per EFSA (0.1 mg/kg TDI). Modest glucose signal per Allen 2013. Would move to Verified 70+ with Ceylon labeling or water-extract format like Cinnulin PF.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nmn-beet-root-complex-nicotinamide-monoucleotide",
      "title": "NMN + Beet Root Complex Nicotinamide Monoucleotide",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fee1b22a-66ed-4cb9-8398-d0235b009a0f_large_f40f51f0-1c3d-4123-be8a-3238bfafaffa.jpg?v=1787417077",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nmn",
        "beet",
        "root",
        "complex",
        "nicotinamide",
        "monoucleotide",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 51.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790478266565",
      "vsf_explanation": "NMN combined with beet root — the beet root adds nitrate for nitric oxide/vasodilation (Lansley 2011), which is a plausible synergy story for muscle O2 delivery. However, combination products tend to dilute per-active dose below studied thresholds — Yoshino 2021 showed NMN raised blood NAD+ at 250mg/day, and effective beet root nitrate doses are 400-800mg nitrate (Domínguez 2017). Fitting both at studied levels in a reasonable serving is difficult. Held at Standard because per-active dose is not confirmed and Swanson does not name a branded NMN source (Uthever is the reference). Note the title misspells 'Mononucleotide' as 'Monoucleotide' — a label quality concern.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "menogest-progesterone-cream",
      "title": "Menogest Progesterone Cream",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/424f6316-b402-4ee7-b7d4-859db7369f4c_large_ef4696d8-cc2c-4b6d-9961-34e588223ab9.jpg?v=1787417078",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "menogest",
        "progesterone",
        "cream",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 20,
        "manufacturing": 20,
        "safety": 20,
        "transparency": 20,
        "sustainability": 20
      },
      "price": 9.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790478299333",
      "vsf_explanation": "This is an OTC hormone cream (topical progesterone), not a dietary supplement, and is out of scope for Vyvata's supplement rubric. The score is a placeholder reflecting that rubric mismatch, not a quality judgment. Progesterone is a bioactive hormone with real risks — endometrial and breast-tissue effects, drug interactions, and a genuine need for medical supervision, especially for women already on hormone therapy. A clinician-guided hormone-therapy framework, not the supplement rubric, is the right lens for this product; Vyvata does not currently score OTC hormone products.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "mood-shrooms-3-in-1-formula",
      "title": "Mood Shrooms - 3-in-1 Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/36bb13d3-99e1-4e9d-9415-8ba6484b06ba_large_7306a1f4-32cd-4e65-93f1-03246a021b8c.jpg?v=1787417078",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mood",
        "shrooms",
        "formula",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 60,
        "sustainability": 60
      },
      "price": 9.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790478364869",
      "vsf_explanation": "Multi-mushroom formula (likely including reishi, lion's mane, and cordyceps or similar) marketed for mood support. Individual mushroom evidence for mood is limited to small trials; the critical quality question is whether it is fruiting-body extract or mycelium-on-grain, since mycelium products dilute active beta-glucan/triterpene content. Safety is favorable. Would move to Verified 70+ with fruiting-body designation, dual-extraction disclosure, and beta-glucan percentage per species.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natural-e-401",
      "title": "Natural E-400",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a6c82d66-0d10-4e55-b0bc-ea5004ec2c57_large_789037c3-c6fe-4571-aa90-d3258e1a1393.jpg?v=1787417078",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "natural",
        "400",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 66,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 13.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790478332101",
      "vsf_explanation": "Natural d-alpha tocopherol at 400 IU is the preferred stereoisomer form (not synthetic dl-alpha), which is a formulation win. However, the Miller 2005 meta-analysis showed all-cause mortality signal at >400 IU/day with alpha-only tocopherol, and modern practice favors mixed tocopherols/tocotrienols rather than isolated d-alpha. Legitimate mid-tier product; wouldn't fault the manufacturing. Would move to Verified 70+ with mixed tocopherol/tocotrienol complex and lower daily target (100-200 IU) matched to evidence-based intake.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "huperzine-a-maximum-strength",
      "title": "Huperzine A - Maximum Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4aea6dfe-3a66-47fc-aaf6-828f266f2cc8_large_f222fdd5-b8c9-4a8b-9673-03a2e0dcc5a1.jpg?v=1787417078",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "huperzine",
        "maximum",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 48,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 6.2,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790478397637",
      "vsf_explanation": "Huperzine A is a potent, long-acting acetylcholinesterase inhibitor with small-trial evidence in cognitive decline (Xu 1995; Wang 2009 meta) typically at 50-200 mcg. As a real enzyme inhibitor it merits cycling and warrants explicit caution with cholinergic drugs (donepezil, rivastigmine), beta-blockers, and other AChE inhibitors - warnings that are chronically absent from OTC labels. 'Maximum strength' amplifies the interaction concern. Would move to Verified 70+ with prominent drug-interaction disclosure, cycling guidance, and per-lot potency testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-mangosteen",
      "title": "Full Spectrum Mangosteen",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d7393ff5-1a34-420b-8847-c66628d026e4_large_48c7a3a8-b9d6-4c44-81ec-04b78b3d46b7.jpg?v=1787417078",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "mangosteen",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 52,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 55,
        "sustainability": 48
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790478430405",
      "vsf_explanation": "Mangosteen (Garcinia mangostana) contains xanthones (alpha-mangostin) with in-vitro antioxidant activity, but human clinical evidence for meaningful health endpoints is very thin. Whole-fruit powder without xanthone standardization. Historically over-marketed as a superfruit without matching evidence. Would move to Standard 60+ with alpha-mangostin standardization and outcome RCTs.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "niacin-1",
      "title": "Niacin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f0d7cb85-020b-48a9-b33a-c1c8b84d8c23_large_35b51aad-8915-4e8f-97cc-402b80a1647b.jpg?v=1787417078",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "niacin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 64,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 12.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790478463173",
      "vsf_explanation": "Nicotinic acid has clear evidence for lipid modification (raises HDL, lowers TG, lowers Lp(a)) at 1-3g/day (Guyton 2007 Am J Cardiol) but at those doses causes flushing and requires hepatic monitoring; low doses (100mg) are nutrient supplementation only. Held below Verified by unclear mg from title, no hepatotoxicity/lipid-monitoring warning framework, and safety-flag gap at higher-dose usage.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mellow-mag-raspberry-lemonade",
      "title": "Mellow Mag - Raspberry Lemonade",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6cec5f12-d387-4456-86c1-d49825c0d6d4_large_23d15307-7ce4-43ad-b537-0b8525bdbbf3.jpg?v=1787417079",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mellow",
        "mag",
        "raspberry",
        "lemonade",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 20.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790478758085",
      "vsf_explanation": "Magnesium drink mix in raspberry lemonade — magnesium in the 200-400mg elemental range has solid evidence for sleep quality (Abbasi 2012), muscle cramps (Setaro 2014), and constipation (particularly citrate). The critical missing information at title level is the mag form (citrate = laxative + hydration, glycinate = calm without loose stool, oxide = poorly absorbed). 'Mellow Mag' branding implies citrate or glycinate. Held at Standard because form is not disclosed at title level. Would move to Verified 70+ with glycinate/citrate form named and per-serving elemental magnesium content disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mens-daily-probiotic-prebiotic-fos",
      "title": "Men's Daily Probiotic + Prebiotic FOS",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c1ed3564-c696-4d3e-9515-4e658608a17c_large_14870961-92c7-4090-9791-1bde8e79aad6.jpg?v=1787417079",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "men",
        "daily",
        "probiotic",
        "prebiotic",
        "fos",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 31.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790478790853",
      "vsf_explanation": "Men's-targeted synbiotic. There is no strong sex-specific probiotic literature outside urogenital contexts, so 'men's' framing is largely marketing. FOS pairing is directionally reasonable. Would move to Verified with strain-level identification and CFU-at-expiration.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mellow-mag-orange-flavor",
      "title": "Mellow Mag - Orange Flavor",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5145fffb-5c3b-40ef-bfff-782dd13eeb33_large_6e767744-a125-4f55-a52c-e9e8840e37e5.jpg?v=1787417080",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mellow",
        "mag",
        "orange",
        "flavor",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790478823621",
      "vsf_explanation": "Powdered magnesium drink positioned for relaxation. Magnesium's role in muscle relaxation and sleep is well-supported (Boyle 2017 meta-analysis), but the exact magnesium form is not clarified on the label front, which matters — magnesium citrate or glycinate is far more bioavailable than oxide. Flavored powders often add citric acid and stevia/sucralose which is fine but not premium. Would move to Verified 70+ with a named form (glycinate or citrate), disclosed elemental mg per serving, and third-party heavy-metal testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mind-full-cognitive-performance-advanced-formula",
      "title": "Mind Full Cognitive Performance Advanced Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a85e7c1a-6855-4345-9a07-77a867ffac2a_large_3671b1c7-4e85-4202-999c-9580bd052c7e.jpg?v=1787417080",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mind",
        "full",
        "cognitive",
        "performance",
        "advanced",
        "formula",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 56,
        "sustainability": 55
      },
      "price": 34.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790478856389",
      "vsf_explanation": "Multi-ingredient 'advanced cognitive performance' formula - the naming pattern typically means many actives bundled at sub-RCT doses to fit one capsule. Held here rather than autofailed because Swanson often does list per-active mg. If the label uses a 'proprietary blend' with only total mg, this drops to Rejected via proprietary_blend_hides_dose. Would move to Verified 70+ with per-active doses at RCT-relevant amounts (e.g., L-theanine 100-200mg, bacopa 300mg at 45-55% bacosides, alpha-GPC 300-600mg).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "msm-powder-ready-mix-unflavored",
      "title": "MSM Powder - Ready-Mix & Unflavored",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f6e6fde5-cb62-4500-84f0-6be9965b3d4b_large_8f9f8c6b-aae2-4810-8755-0ce3f574b515.jpg?v=1787417081",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "msm",
        "powder",
        "ready",
        "mix",
        "unflavored",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 63,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 20.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790479151301",
      "vsf_explanation": "MSM as bulk powder — easier to reach the 3-6 g/day therapeutic range studied in Kim 2006 and Debbi 2011 compared to capsules. Unflavored powder is honest formulation. Held below Verified by no OptiMSM (branded Bergstrom) callout and no third-party purity COA — MSM purity varies meaningfully by supplier. Would move to Verified 70+ with OptiMSM sourcing and COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mens-multi-prostate-support-2-pack",
      "title": "Men's Multi +Prostate Support - 2 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7bcbb10f-ccb3-48bd-935d-a67a66a7fd2e_large_d3a7b149-554f-434a-9d46-919ef7fd42ff.jpg?v=1787417082",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "men",
        "multi",
        "prostate",
        "support",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 21.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790479249605",
      "vsf_explanation": "Men's multivitamin with prostate-support botanical add-ins (typically saw palmetto, lycopene, zinc). Multivitamin coverage has value (Gaziano 2012 PHS II); prostate additions rely on saw palmetto RCT evidence (Wilt 1998 modest positive; Bent 2006 STEP null) and lycopene, which has some prostate-health epidemiology but limited RCT support. Multi-formula dosing typically under-delivers saw palmetto vs. the 320mg lipid-extract monograph. Would move to Verified 70+ with monograph-level saw palmetto standardization and disclosed lycopene mg.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-magnolia-bark",
      "title": "Full Spectrum Magnolia Bark",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ce6b2cbd-01c0-4add-bc11-867f1f27f87c_large_d27b657c-8afc-406c-9e24-4fde7af79b30.jpg?v=1787417081",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "magnolia",
        "bark",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790479216837",
      "vsf_explanation": "Magnolia bark (honokiol, magnolol) for anxiety/sleep. 'Full Spectrum' = whole herb without standardization — bioactive content unpredictable. Would improve with 2% honokiol standardization as in the sibling standardized SKU.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mellow-mag-strawberry-kiwi-flavor",
      "title": "Mellow Mag - Strawberry Kiwi Flavor",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cfe896d0-2c71-45c3-9f5e-d9836ab19dea_large_0e73ad85-e1a8-46d8-8b01-73431a9ac1b3.jpg?v=1787417081",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mellow",
        "mag",
        "strawberry",
        "kiwi",
        "flavor",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 20.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790479282373",
      "vsf_explanation": "Flavored magnesium powder product ('Mellow Mag' branding suggests relaxation/sleep positioning). Magnesium has meta-analysis-level evidence for sleep quality (Abbasi 2012) at 300-400mg elemental. Form matters heavily (glycinate/threonate > oxide) but not disclosed in title. Would move to Verified with magnesium form specification, mg per serving, and clean sweetener disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "melatonin-100-drug-free-1",
      "title": "Melatonin - 100% Drug Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b47081d5-6562-4496-8906-c6e3621d672f_large_c3861fad-e22d-45e3-b63c-662ef063ecfa.jpg?v=1787417082",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "melatonin",
        "100",
        "drug",
        "free",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790479315141",
      "vsf_explanation": "Standard melatonin capsule - dose likely 3-5mg based on typical Swanson formats. Above the physiological 0.3-1mg range that Auld 2017 meta identifies as most aligned with endogenous secretion and effective for sleep-onset. The '100% drug free' framing understates that melatonin is a hormone with real biology. Would move to Verified 70+ by dropping to 0.5-1mg with physiological-dose rationale.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pantothenic-acid",
      "title": "Pantothenic Acid",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e37ceee3-19a9-49ce-8a65-64045856a3ee_large_2691d814-c03c-4410-aa93-48cd09a73f9e.jpg?v=1787417131",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pantothenic",
        "acid",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 13.74,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790492586181",
      "vsf_explanation": "Calcium pantothenate is the standard B5 form, well-tolerated at typical doses. Held below Verified by unclear mg from title and absence of pantethine (active form) option. Would move to Verified 70+ with pantethine form or specific mg dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lo-han-sweetener-made-from-monk-fruit-calorie-and-sugar-free",
      "title": "Lo Han Sweetener Made from Monk Fruit - Calorie and Sugar Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ce338887-643d-4e2c-850a-b8e0cb003d8f_large_32d4c16f-fb11-4269-80e7-3a890f8119dc.jpg?v=1787417131",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "han",
        "sweetener",
        "made",
        "from",
        "monk",
        "fruit",
        "calorie",
        "and",
        "sugar",
        "free",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 10.08,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790492455109",
      "vsf_explanation": "Monk fruit (Luo Han Guo) extract is a natural non-nutritive sweetener, GRAS-approved, blood-sugar neutral. Cleaner than sucralose/aspartame for many users. Not a functional supplement per se. Would improve with mogroside V % disclosure and organic sourcing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "brewers-yeast-powder-non-gmo-2-pack",
      "title": "Brewer's Yeast Powder - Non-GMO - 2 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a1311c8f-4f91-4617-8101-80675628dc8d_large_14746d76-37c7-4506-89ef-381637906df2.jpg?v=1787417131",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "brewer",
        "yeast",
        "powder",
        "non",
        "gmo",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 31.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790492422341",
      "vsf_explanation": "Brewer's yeast is a whole-food source of B-vitamins, chromium, and protein. Multi-pack of non-GMO powder. Chromium content varies widely; not standardized to GTF chromium. Would improve with chromium mg per serving and glutamic acid/GTF standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "papaya-enzyme-papain",
      "title": "Papaya Enzyme Papain",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/68b3e7cc-1484-416c-8a68-5187a4166508_large_9e40d213-661f-45f2-8fed-9e18045accf8.jpg?v=1787417131",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "papaya",
        "enzyme",
        "papain",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790492487877",
      "vsf_explanation": "Papaya enzyme (papain) chewable — traditional after-meal digestive aid. Papain is a cysteine protease with plausible proteolytic activity but limited high-quality clinical trial data for digestive symptoms specifically. Would move to Verified with papain activity units (USP/NF) disclosed rather than just mg papaya extract.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "100-pure-mct-oil-medium-chain-triglycerides",
      "title": "100% Pure MCT Oil Medium Chain Triglycerides",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/eda140a3-4682-4d3d-9ee7-2a5ca2302acf_large_a3ec7e58-9a05-4870-be00-89953a2a8ea0.jpg?v=1787417131",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "100",
        "pure",
        "mct",
        "oil",
        "medium",
        "chain",
        "triglycerides",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 40.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790492520645",
      "vsf_explanation": "MCT oil (medium chain triglycerides) has evidence for cognitive fuel via ketone production and mild thermogenic effect (St-Onge 2014). C8 (caprylic) vs C10 (capric) breakdown not disclosed — C8 is the more ketogenic. Would move to Verified with C8:C10 ratio disclosure and coconut vs palm sourcing transparency (palm is a sustainability flag).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "prickly-pear-nopal-cactus",
      "title": "Prickly Pear Nopal Cactus",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e1808a9b-426a-4a8a-8e1f-c2a44f400ab1_large_3044784f-7e20-4cd2-aba7-8accf6585957.jpg?v=1787417131",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "prickly",
        "pear",
        "nopal",
        "cactus",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 21.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790492553413",
      "vsf_explanation": "Nopal cactus has preliminary evidence for post-meal glucose (Lopez-Romero 2014) and hangover prevention (Wiese 2004). No standardization or clinical-dose disclosure. Would improve with soluble fiber content, betalain standardization, and clinical dose specification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "brewers-yeast-powder-non-gmo",
      "title": "Brewer's Yeast Powder - Non-GMO",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f0683161-bd31-4925-a896-f382137a1768_large_37070c6e-80cf-4f62-8fa0-354a808bea52.jpg?v=1787417131",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "brewer",
        "yeast",
        "powder",
        "non",
        "gmo",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 22.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790492618949",
      "vsf_explanation": "Non-GMO brewer's yeast powder — same as multi-pack SKU. B-vitamin and chromium source. Would improve with chromium mg per serving disclosure and GTF standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "adrenal-glandular",
      "title": "Adrenal Glandular",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0cef79b3-9f91-4723-9eba-51dc2e001815_large_ee98126d-5580-4a38-8ac9-a3d1fed1e9d8.jpg?v=1787417131",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood",
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "adrenal",
        "glandular",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 50,
        "manufacturing": 50,
        "safety": 42,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 16.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790492684485",
      "vsf_explanation": "Bovine adrenal glandular extract — a legacy naturopathic ingredient with essentially no modern human RCT evidence for the marketed 'adrenal fatigue' construct (which is not a recognized medical diagnosis; Cadegiani 2016 systematic review found no support). Glandular products can contain trace bovine cortisol/hormones that create pharmacologic effect without clear dose control, and carry residual BSE (mad cow) sourcing risk depending on country and gland tissue. Held at Rejected because the underlying condition it targets is not established and safety controls on bovine glandular tissue are inconsistent. This ingredient is largely obsolete in modern integrative practice.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pepsin-okra",
      "title": "Pepsin & Okra",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3af942bb-2b2d-417b-8fea-8eebb50601df_large_785b25a8-9d5d-44e3-be45-c2e0f90d1eb3.jpg?v=1787417131",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pepsin",
        "okra",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 4.25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790492717253",
      "vsf_explanation": "Pepsin (porcine digestive enzyme) with okra (mucilaginous fiber) blend for digestive support. Pepsin needs acidic environment to activate; oral supplementation utility is uncertain in normal-acid patients. Enzyme unit strength not disclosed. Would improve with USP pepsin unit disclosure and clinical dose specification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "p-5-p-pyridoxal-5-phosphate",
      "title": "P-5-P Pyridoxal-5-Phosphate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f3df1129-8898-40ca-a6e6-6a1a915e2801_large_0af75b70-0332-46db-8549-ef4a091f8ad3.jpg?v=1787417131",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pyridoxal",
        "phosphate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 70,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790492782789",
      "vsf_explanation": "P-5-P is the active coenzyme form of vitamin B6 — preferred over pyridoxine HCl for anyone with liver conversion issues. Direct-active form is a real formulation upgrade. Safety flag: total B6 intake (any form) >100mg/day chronic has been linked to peripheral neuropathy. Would move to Verified 70+ with dose ceiling guidance and USP-verified sourcing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-pau-darco",
      "title": "Full Spectrum Pau d'Arco",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d5de220d-9663-4f7a-bb47-05e4da7f6fef_large_9ec73508-aac7-4c4c-8180-e17424fbd241.jpg?v=1787417131",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "pau",
        "arco",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 40,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 6.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790492651717",
      "vsf_explanation": "Pau d'arco (Tabebuia impetiginosa, lapachol) is traditionally used for candida and immune support. Safety concern: lapachol at higher doses has anticoagulant activity and hepatotoxicity potential; NCI cancer trials in the 1970s were halted for toxicity. Would need lapachol standardization, dose ceiling, and prominent safety warnings to score higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-oregano",
      "title": "Full Spectrum Oregano",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7f016d8f-f533-41fa-a407-6f403ecbc5da_large_cc987bf6-8cd4-4920-a024-264319293d27.jpg?v=1787417131",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "oregano",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 55,
        "sustainability": 52
      },
      "price": 7.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790492848325",
      "vsf_explanation": "Whole-herb oregano powder (Origanum vulgare) capsule. Whole-herb delivers dilute carvacrol content versus extracted essential oil, so any antimicrobial rationale is diminished. Culinary-adjacent product with limited supplement-specific evidence. Would move to Standard 62+ with essential-oil-standardized format and carvacrol % disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "papaya-supreme",
      "title": "Papaya Supreme",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/24661574-ae70-4961-b840-16547b454f17_large_ac2f1378-2b07-4347-8050-0dcbae3571f5.jpg?v=1787417131",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "papaya",
        "supreme",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 11.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790492750021",
      "vsf_explanation": "Papaya enzyme blend product — papain has traditional use for digestion but limited controlled clinical evidence for oral supplementation. 'Supreme' branding without spec. Would improve with USP papain unit disclosure and enteric-coating for delivery to intestine.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ox-bile-standardized",
      "title": "Ox Bile - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ffda2ced-4419-4e84-835e-3da1ae0de6a6_large_7c7ef679-6bc9-433d-879a-c6ab17681e39.jpg?v=1787417131",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bile",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790492815557",
      "vsf_explanation": "Ox bile is legitimately useful for post-cholecystectomy fat digestion but should be used under practitioner guidance in that context. 'Standardized' is a plus but bile acid % (cholic, deoxycholic) not disclosed. Sourcing not disclosed. Would improve with % conjugated bile acid standardization and post-cholecystectomy positioning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "oat-bran",
      "title": "Oat Bran",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/19a37911-774e-4293-8f38-96d54d71cc5f_large_585d4448-02b3-493c-b095-8c4a2cb1c6d5.jpg?v=1787417131",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "oat",
        "bran",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 7.13,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790492881093",
      "vsf_explanation": "Oat bran (beta-glucan) has strong FDA-authorized health claim evidence for LDL cholesterol reduction (Whitehead 2014) at 3g beta-glucan/day. Not standardized to beta-glucan content — commodity oat bran. Would improve with beta-glucan % standardization and clinical dose confirmation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "passion-flower-liquid-extract-alcohol-sugar-free",
      "title": "Passion Flower Liquid Extract - Alcohol & Sugar Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0ad37c9a-07c0-4e06-a5a0-27de177777b3_large_be4f5614-69a5-4df6-90ca-60cc15d2c1ab.jpg?v=1787417131",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "passion",
        "flower",
        "liquid",
        "extract",
        "alcohol",
        "sugar",
        "free",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 66,
        "transparency": 60,
        "sustainability": 52
      },
      "price": 9.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790492913861",
      "vsf_explanation": "Passionflower (Passiflora incarnata) has small trials for generalized anxiety (Akhondzadeh 2001) and sleep-quality (Ngan 2011). Liquid extract offers dose flexibility. Alcohol/sugar-free is a positive. No flavonoid standardization (vitexin marker) disclosed. Would move to Verified 70+ with 4% vitexin standardization and studied 45-90 mg extract dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "paba",
      "title": "PABA",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/293dc785-01ce-47d0-b4c3-41c2454b910e_large_8a7ffbd7-1b5b-4bf9-8c54-ade66c457515.jpg?v=1787417131",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "paba",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 45,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 12.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790492946629",
      "vsf_explanation": "PABA (para-aminobenzoic acid) is no longer classified as a B-vitamin. Marketed for hair pigmentation and vitiligo with weak evidence. Safety flag: FDA has taken enforcement action on high-dose PABA products for hepatotoxicity signals. Not essential in humans. Would need clearer safety warnings and modern RCT support to score higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "100-pure-c-1000-vitamin-c-powder",
      "title": "100% Pure C-1000 Vitamin C Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c6aef4bc-8015-4b50-b814-42f58fdaa11a_large_daf7bfb6-08ef-4ad5-99ea-8b70322503a6.jpg?v=1787417132",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "100",
        "pure",
        "1000",
        "vitamin",
        "powder",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 64,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 21.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790493241541",
      "vsf_explanation": "Pure ascorbic acid powder allows dose-flexible titration and avoids binder/filler additives, a legitimate plus for GI-sensitive users. Vitamin C at 1g has strong immune-duration evidence (Hemila & Chalker 2013 Cochrane). Held below Verified by non-buffered form (single 1g dose can saturate absorption and cause GI upset) and no third-party certification. Would move to Verified 70+ with buffered mineral-ascorbate option and independent COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-methionine",
      "title": "L-Methionine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d9b156ed-437d-4d3e-b94f-72f196332e2e_large_17d6ea7c-5cb7-4ba3-9f2b-1a7c12d7a77c.jpg?v=1787417133",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "methionine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 4.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790493339845",
      "vsf_explanation": "Generic L-methionine — rarely deficient in Western diets, and high-dose methionine has aging-marker and homocysteine concerns. Non-AjiPure version, so no branded-source quality upgrade. Would improve with clearer indication for supplementation, AjiPure sourcing, and homocysteine-monitoring guidance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "quercetin-bromelain-advanced-formula",
      "title": "Quercetin & Bromelain - Advanced Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/93b4d36a-39d3-43c9-8f40-83a2c66bf41d_large_ffd78042-f6d5-44f2-9eba-8fab8ebc3883.jpg?v=1787417134",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "quercetin",
        "bromelain",
        "advanced",
        "formula",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 66,
        "formulation": 70,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 65,
        "sustainability": 58
      },
      "price": 21.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790493372613",
      "vsf_explanation": "Duplicate SKU of the Quercetin + Bromelain Advanced Formula — same evaluation: rational bioavailability-enhancing pairing with legitimate anti-inflammatory/allergy mechanistic support, held to top of Standard by absence of enzyme-activity units and branded quercetin form.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "prime-lung",
      "title": "Prime Lung",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/07f82975-b3c8-441d-afd6-786ca7891fc9_large_01af0315-fdf3-4b9e-8d98-86bc1ad46e84.jpg?v=1787417134",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "prime",
        "lung",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 12.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790494257349",
      "vsf_explanation": "'Prime Lung' is a blend product typically featuring NAC, mullein, marshmallow, or similar herbs. Per-active mg not disclosed — proprietary blend risk. NAC has real evidence for mucolytic support (Grandjean 2000). Would improve with per-active mg disclosure and NAC content transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "psyllium-husks",
      "title": "Psyllium Husks",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/26f77830-8d7f-46ad-bedc-feabdb8dfceb_large_42b57cb3-b0db-4baa-bdf1-906cd796d5d4.jpg?v=1787417135",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "psyllium",
        "husks",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 21.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790494290117",
      "vsf_explanation": "Psyllium husks — well-evidenced fiber for LDL, glycemic control and constipation (Jovanovski 2018 meta-analysis). Would move to Verified with certified-organic sourcing and heavy-metal test disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "argentinian-desiccated-beef-liver-100-pure-defatted",
      "title": "Argentinian Desiccated Beef Liver - 100% Pure Defatted",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e6e95736-6824-47e0-b430-98690377f900_large_73804f07-3188-451c-8fc9-8ad325e4ebe5.jpg?v=1787417135",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "argentinian",
        "desiccated",
        "beef",
        "liver",
        "100",
        "pure",
        "defatted",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 60,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 13.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790494322885",
      "vsf_explanation": "Desiccated beef liver is a legitimate nutrient-dense whole-food source of heme iron, B12, vitamin A, choline. Argentinian grass-fed sourcing is a positive if verified. 'Defatted' improves shelf stability but removes fat-soluble vitamins. Would move to Verified with grass-finished certification, hormone/antibiotic-free documentation, and heavy-metal testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pregnenolone",
      "title": "Pregnenolone",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c04fcbab-6bfd-4b25-9104-c22ed741fe44_large_b046b7d5-e234-44e0-aec9-b2943ca02651.jpg?v=1787417135",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pregnenolone",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 6.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790494355653",
      "vsf_explanation": "Standard-dose Swanson pregnenolone (typically 10-30mg). Pregnenolone is an upstream neurosteroid precursor to progesterone, DHEA, and downstream sex hormones. Modern RCTs for cognitive and mood claims are largely null (Osuji 2010; Marx 2014 for bipolar depression showed only modest signal). Any pregnenolone product warrants lab-monitoring language and contraindication for hormone-sensitive cancers, often absent from Swanson labels. Would move to Verified 70+ with clear safety guidance and honest evidence framing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ovarian-glandular",
      "title": "Ovarian Glandular",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5729d6dc-ae77-4952-a41d-eac3e96a1d72_large_dafc856b-199b-4877-8c88-b09efa5affe2.jpg?v=1787417136",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ovarian",
        "glandular",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 45,
        "transparency": 55,
        "sustainability": 40
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790494453957",
      "vsf_explanation": "Bovine ovarian glandular — same organotherapy critique. Residual hormone contamination is a possibility with reproductive-tissue glandulars. No RCT support for oral ovarian tissue improving female reproductive endpoints. Would need hormone-residue testing and RCT support to score higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "100-pea-protein-powder-unflavored",
      "title": "100% Pea Protein Powder - Unflavored",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9038b905-dfb1-4161-8999-02009444cf07_large_94137ca5-a0e2-44ba-97d9-e50ad8059f91.jpg?v=1787417136",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "100",
        "pea",
        "protein",
        "powder",
        "unflavored",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 62,
        "sustainability": 65
      },
      "price": 17.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790494486725",
      "vsf_explanation": "Non-organic pea protein isolate — legitimate plant protein with functional MPS response comparable to whey at 25-30g/serving (Babault 2015), but naturally low in methionine so incomplete on its own. Pea protein is also a known cadmium accumulator, making heavy-metal testing especially important (Clean Label Project 2020 found ~75% of plant protein SKUs tested above proposed cadmium safety thresholds). Held at Standard because Swanson publishes no per-lot heavy-metal COA and does not blend with rice to complete the amino profile. Would move to Standard 65+ with published heavy-metal testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pygeum-standardized-extract",
      "title": "Pygeum - Standardized Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/64cd7492-2a8f-46a5-b262-121e210f7c4a_large_0390cb31-7757-4cc9-ad91-d07ce7b6a593.jpg?v=1787417136",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pygeum",
        "standardized",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 66,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 62,
        "sustainability": 45
      },
      "price": 12.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790494519493",
      "vsf_explanation": "Pygeum africanum standardized extract with Cochrane-level BPH evidence (Wilt 2002). Standardized is a plus but no % sterol disclosure. Sustainability concern: CITES-listed species, wild-harvesting pressure in Cameroon. Would move to Verified with 13% total sterols standardization and sustainable-sourcing certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pycnogenol-wrinkle-cream",
      "title": "Pycnogenol Wrinkle Cream",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d2914b34-62db-4bc6-ad7a-52e4539c16f7_large_9d29f1db-9e87-4af2-91ae-dd71e25aecdb.jpg?v=1787417136",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pycnogenol",
        "wrinkle",
        "cream",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 7.85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790494552261",
      "vsf_explanation": "Topical Pycnogenol cream — Pycnogenol has preliminary evidence for skin elasticity and photoaging when taken orally (Marini 2012). Topical evidence is thinner. Would improve with concentration disclosure and combination with proven topicals (vitamin C, retinol).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "100-pure-calcium-citrate-powder-dairy-free-unflavored",
      "title": "100% Pure Calcium Citrate Powder - Dairy Free & Unflavored",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b6a1d9da-4f8f-4c21-9116-5aa66a064886_large_9f53b128-7257-49ff-bb93-77e7e7bcab6b.jpg?v=1787417137",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "100",
        "pure",
        "calcium",
        "citrate",
        "powder",
        "dairy",
        "free",
        "unflavored",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 62,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 10.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790494585029",
      "vsf_explanation": "Pure calcium citrate powder — citrate is the preferred calcium form because it does not require stomach acid and has better bioavailability than carbonate (Straub 2007), especially for older adults on PPIs. Unflavored powder allows flexible dosing. Standard tier upper end. Would move to Verified with K2 co-factoring and cardiovascular safety disclosure (Bolland 2015).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "multi-glandular-mens-health",
      "title": "Multi-Glandular - Men's Health",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/70912a60-8918-4330-9299-0c835e890c41_large_0f66e531-9d1a-4d28-b341-2ed9abb2fce7.jpg?v=1787417138",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "multi",
        "glandular",
        "men",
        "health",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 14.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790494650565",
      "vsf_explanation": "Multi-glandular blend (bovine tissues from multiple endocrine glands). The 'like-supports-like' glandular theory has no meaningful RCT support in humans; oral animal tissue is largely digested to amino acids without organ-specific effect. Sourcing concerns include BSE risk with bovine tissue depending on origin and processing. Falls below Standard on evidence — recommend a real RCT-supported hormonal-support product instead.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "probiotic-prebiotic-gummies-blackberry",
      "title": "Probiotic + Prebiotic Gummies - Blackberry",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2819851e-4ede-49fa-92a9-b3d3104c23bd_large_b2528fd1-a59d-45dd-9601-e82913e56a18.jpg?v=1787417138",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "probiotic",
        "prebiotic",
        "gummies",
        "blackberry",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 12.65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790494683333",
      "vsf_explanation": "Gummy probiotics are the weakest probiotic form: gelatin/pectin matrix with sugar or sugar alcohols creates water activity and heat exposure that kill live cultures during manufacture and shelf storage. Even Bacillus spore probiotics (BC30, DE111) — which are the only species genuinely gummy-stable — degrade faster than capsule form. Sits at Rejected because the format materially undermines the active. Would move up only with a spore-forming Bacillus strain named and stability-tested-at-expiration.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "potassium-gluconate",
      "title": "Potassium Gluconate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0f8990de-1010-4c61-8db4-28627270c86d_large_752cca1f-4f1b-4822-887a-78778e6444ea.jpg?v=1787417138",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "potassium",
        "gluconate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 8.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790494716101",
      "vsf_explanation": "Standard potassium gluconate — mainstream potassium form limited by 99mg OTC cap. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lecithin-granules-non-gmo-100-pure-1",
      "title": "Lecithin Granules - Non-GMO 100% Pure",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cf29939c-01ef-4134-8944-5a70cdc8857c_large_db3724a3-47a2-4296-82f0-9dc8b1de16bd.jpg?v=1787417138",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lecithin",
        "granules",
        "non",
        "gmo",
        "100",
        "pure",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 18.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790494748869",
      "vsf_explanation": "Non-GMO lecithin granules as PC and choline source. Granule form allows flexible dosing. Modest evidence for cognitive and liver support (choline is essential nutrient). Would improve with % phosphatidylcholine standardization and organic certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pumpkin-seed-oil",
      "title": "Pumpkin Seed Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f9175c46-7e12-4d73-a385-1ff25ad1e710_large_d7271365-2997-406e-afeb-caf5d7529dff.jpg?v=1787417139",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pumpkin",
        "seed",
        "oil",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 16.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790494781637",
      "vsf_explanation": "Pumpkin seed oil has modest RCT evidence for BPH symptoms (Vahlensieck 2015) and overactive bladder. No mg per serving or standardization disclosed. Would improve with cold-pressed processing confirmation, phytosterol content disclosure, and clinical dose confirmation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "oregano-oil-liquid-extract-alcohol-sugar-free",
      "title": "Oregano Oil Liquid Extract - Alcohol & Sugar Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b0f7dae1-f8e5-4820-9321-38687cf3a093_large_d47a1dfd-0221-4bbc-8360-19d47d29c703.jpg?v=1787417138",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "oregano",
        "oil",
        "liquid",
        "extract",
        "alcohol",
        "sugar",
        "free",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 60,
        "sustainability": 52
      },
      "price": 13.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790494814405",
      "vsf_explanation": "Oregano liquid extract, alcohol/sugar free — good for palatability and compliance. Human RCT evidence for oregano oil in infection outcomes is thin; most evidence is in-vitro. Carvacrol % (the active) not disclosed. Would move to Verified 70+ with carvacrol standardization and carrier-oil disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "quercetin-bromelain-advanced-formula-1",
      "title": "Quercetin & Bromelain - Advanced Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6259b49e-0a40-403d-b3f6-66171e19590b_large_855ba70f-2254-4404-8621-d12658c14888.jpg?v=1787417139",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "quercetin",
        "bromelain",
        "advanced",
        "formula",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 66,
        "formulation": 70,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 65,
        "sustainability": 58
      },
      "price": 45.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790494847173",
      "vsf_explanation": "Quercetin + bromelain is the traditional bioavailability-enhancement pairing: bromelain's proteolytic activity and mucosal-permeability effects raise quercetin absorption, and both have complementary anti-inflammatory and anti-histamine activity (Shoskes 1999 for pelvic pain, Thornhill 2000 for allergic rhinitis). Legitimate 'advanced' framing for a category where plain quercetin absorbs poorly. Held to top of Standard by no branded ingredient (e.g., no EMIQ or Quercetin Phytosome) and no bromelain GDU/MCU activity units disclosed. Would move to Verified with GDU-quantified bromelain and phytosome quercetin.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pumpkin-seed-oil-2-pack",
      "title": "Pumpkin Seed Oil - 2 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/08e90dd3-65d0-4a0d-953e-9e8917106e84_large_645d4301-6dd3-4299-a0e6-30fdd00a712a.jpg?v=1787417139",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pumpkin",
        "seed",
        "oil",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 21.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790494879941",
      "vsf_explanation": "Pumpkin seed oil for BPH/bladder support (Vahlensieck 2015) at multi-pack pricing. Would improve with cold-pressed confirmation and phytosterol disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pancreas-glandular",
      "title": "Pancreas Glandular",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e3a146e0-6731-4442-9aed-51cce899b365_large_38f6f084-5e1e-4495-bcc6-e86cb075a638.jpg?v=1787417140",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pancreas",
        "glandular",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 40
      },
      "price": 14.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790495994053",
      "vsf_explanation": "Pancreas glandular product without enzyme unit standardization — different from pancreatin. If enzymes are present they'd be denatured in stomach without enteric coating. Overlaps with pancreatin category but positioned as organotherapy. Would improve by consolidating with enteric-coated pancreatin and providing USP enzyme unit disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lung-glandular",
      "title": "Lung Glandular",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ec7e6987-8fa6-414d-b438-7d9db0198083_large_1bef49f4-2bae-4447-8840-2689d7b52b28.jpg?v=1787417140",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lung",
        "glandular",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 40
      },
      "price": 7.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790496026821",
      "vsf_explanation": "Bovine lung glandular — same organotherapy critique. No RCT support for oral lung tissue supplementation improving respiratory function. Sourcing transparency absent. Would need modern RCT evidence and TSE-free certification to score higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-lions-mane-mushroom",
      "title": "Organic Lion's Mane Mushroom",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d05cfb24-a5b7-48b6-8e8e-1f87482b3ef9_large_819ce216-3bea-41b4-b479-042317dadeb4.jpg?v=1787417140",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "lion",
        "mane",
        "mushroom",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 58,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 60,
        "sustainability": 60
      },
      "price": 21.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790496059589",
      "vsf_explanation": "Organic Lion's Mane capsule - evidence base rests on Mori 2009's small mild-cognitive-impairment RCT using fruiting-body extract at ~3g/day; benefit disappeared after stopping. Whether Swanson's product is fruiting-body vs mycelium-on-grain is the critical spec that determines whether meaningful hericenones/erinacines are present, and it is not explicitly disclosed. Safety is favorable. Would move to Verified 70+ with fruiting-body designation, dual extraction, and disclosed beta-glucan percentage.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "oregano-oil-10-1-extract",
      "title": "Oregano Oil 10:1 Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/96ba7cd3-3e89-4690-b8bd-cb0bf8d11dd5_large_f9428211-1719-4ef1-ad2c-becd98951ca2.jpg?v=1787417141",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "oregano",
        "oil",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 60,
        "sustainability": 52
      },
      "price": 12.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790496125125",
      "vsf_explanation": "Oregano oil (Origanum vulgare) has in-vitro antimicrobial activity from carvacrol and thymol but human clinical evidence for infection outcomes is limited. 10:1 concentration is a formulation strength indicator but the carvacrol % is not disclosed. Carvacrol has anticoagulant/antiplatelet interaction potential. Would move to Verified 70+ with 70%+ carvacrol standardization and named extraction method.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "potassium-aspartate-elemental-potassium",
      "title": "Potassium Aspartate - Elemental Potassium",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9e698f48-7a4a-42e6-8fb7-aa7655df6792_large_eab02885-d51b-46a1-a6c7-784b626f3cc9.jpg?v=1787417141",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "potassium",
        "aspartate",
        "elemental",
        "potassium",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 8.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790496157893",
      "vsf_explanation": "Potassium aspartate — aspartate salt form disclosed at title. OTC potassium is capped at 99mg per capsule versus 3,500mg+ RDI. Safety flagged for ACE-inhibitor/K-sparing interactions. Standard tier — legit form, dose-restricted category.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pantothenic-acid-1",
      "title": "Pantothenic Acid",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/da32ce55-9c94-46a9-81ec-bdf07d8eb393_large_275189ed-b236-4451-8a0c-926f20b672b8.jpg?v=1787417141",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pantothenic",
        "acid",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 16.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790497042629",
      "vsf_explanation": "Pantothenic acid (B5, typically as calcium pantothenate) supports CoA synthesis and has modest evidence for acne (Yang 2014 RCT at 2200mg/day) and adrenal-cortex cofactor function. Well-tolerated at typical doses. Held below Verified by unclear mg dose from title, absence of pantethine (the active form) option, and standard mass-market QC. Would move to Verified 70+ with pantethine form or specific mg dose disclosure aligned with studied protocols.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "peppermint-oil-with-rosemary-and-thyme-enteric-coated",
      "title": "Peppermint Oil with Rosemary and Thyme - Enteric Coated",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3ddfbb36-d58c-4b06-a786-25462a557d2e_large_4a43f973-10ec-42f0-b481-95fb379defbf.jpg?v=1787417143",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "peppermint",
        "oil",
        "with",
        "rosemary",
        "and",
        "thyme",
        "enteric",
        "coated",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 70,
        "manufacturing": 62,
        "safety": 62,
        "transparency": 62,
        "sustainability": 52
      },
      "price": 12.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790497108165",
      "vsf_explanation": "Enteric-coated peppermint oil has strong RCT evidence for IBS symptom relief (Khanna 2014 meta-analysis, NNT ~3 for global symptoms) at ~180 mg TID. Enteric coating is essential — it delivers menthol to the intestine and prevents reflux from gastric release, which is the correct formulation. Adding rosemary and thyme is unstudied combination but shouldn't detract. Would move to Verified 70+ with per-oil mg disclosure and standalone peppermint-oil enteric SKU alignment with IBGard-style dosing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nootropic-brain-food-featuring-neumentix",
      "title": "Nootropic Brain Food - Featuring Neumentix",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/07e7abec-c8f5-4a58-be47-b473a79f8a5a_large_d3af19f3-d563-433d-89ed-8e0da2edb83f.jpg?v=1787417143",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nootropic",
        "brain",
        "food",
        "featuring",
        "neumentix",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 70,
        "manufacturing": 66,
        "safety": 72,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 19.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790497140933",
      "vsf_explanation": "Neumentix is Kemin's proprietary spearmint extract standardized to rosmarinic acid, with two Kemin-sponsored RCTs supporting working-memory and reactive-agility improvements at 900mg (Falcone 2019; Herrlinger 2018). Being the branded, studied material rather than generic spearmint is a real quality upgrade. Evidence base is real but sponsor-heavy, so treat with appropriate skepticism. Would move to Verified 70+ with disclosed 900mg dose (matching the RCTs) and independent replication cited.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "psyllium-husks-1",
      "title": "Psyllium Husks",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/517a692c-9a71-4e0e-8fa1-56d73091b152_large_cb4bebe8-5bfd-4776-96d3-b1a5adbabf6f.jpg?v=1787417144",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "psyllium",
        "husks",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 7.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790498025669",
      "vsf_explanation": "Psyllium husks (whole/coarse). Same excellent evidence base as milled powder for LDL and bowel regularity (Jovanovski 2018). Whole husk is slightly harder to mix. Would move to Verified with heavy-metal test disclosure and USP verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "potassium-gluconate-1",
      "title": "Potassium Gluconate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4f77cd22-be54-49d9-bd69-a60fb2e2fdce_large_6f114e8d-b710-4ae6-ab5a-b6664caf554e.jpg?v=1787417145",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "potassium",
        "gluconate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 20.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790498091205",
      "vsf_explanation": "Potassium gluconate is a mainstream potassium form. OTC potassium is capped at 99mg per capsule (versus 3,500-4,700mg RDI), so effective dose delivery is limited. Safety flagged for ACE-inhibitor and K-sparing diuretic interactions. Standard tier — legit but dose-restricted supplement category.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "inositol-powder-100-pure",
      "title": "Inositol Powder - 100% Pure",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/662622f6-b39b-409b-9fd6-122860d1cee5_large_125afc1e-de38-492f-a1ea-a09d6f7fce66.jpg?v=1787417145",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "inositol",
        "powder",
        "100",
        "pure",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 26.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790498058437",
      "vsf_explanation": "Myo-inositol has solid RCT evidence for PCOS ovulation and insulin sensitivity (Genazzani 2008, Costantino 2009) at 2-4g/day. Powder form allows clinical dosing. Title says '100% Pure' but doesn't distinguish myo-inositol vs D-chiro (matters — 40:1 ratio is the studied protocol). Would move to Verified 70+ with myo-inositol form specification and USP purity verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "postbiotic-immune-formula-featuring-epicor",
      "title": "Postbiotic Immune Formula Featuring EpiCor",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/27fef322-2751-4853-9a48-dceac0bceae1_large_73f1d800-182b-42bf-9970-2d2cfdb75bc8.jpg?v=1787417145",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "postbiotic",
        "immune",
        "formula",
        "featuring",
        "epicor",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 70,
        "manufacturing": 70,
        "safety": 72,
        "transparency": 68,
        "sustainability": 60
      },
      "price": 27.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790498123973",
      "vsf_explanation": "EpiCor (Cargill) as a postbiotic-framed immune ingredient — the fermented S. cerevisiae dried metabolite with cold/flu incidence and duration data (Moyad 2008, 2010) at 500 mg/day. Postbiotic framing is contemporary and mechanistically reasonable (short-chain fatty acids, cell-wall components). Held to top of Standard by sponsor-linked trial base, modest effect sizes, and no confirmation on the title that this SKU delivers the studied 500 mg dose. Would move to Verified 70+ with dose disclosure and independent replication.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "heart-glandular",
      "title": "Heart Glandular",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fe10216b-8d34-4544-bff8-cd5f6a57a84a_large_d95935eb-6ae6-44ae-801d-90580890dda5.jpg?v=1787417159",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "heart",
        "glandular",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 4.45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790503530693",
      "vsf_explanation": "Glandular therapy — feeding bovine cardiac tissue on the premise that it supports the same organ in the consumer — is a naturopathic tradition with essentially no controlled human evidence for cardiovascular endpoints. There is no plausible mechanism by which ingested cardiac protein delivers organ-specific benefit beyond generic amino acid nutrition, and BSE/prion sourcing concerns for bovine glandular products historically require diligent sourcing that is not disclosed on the SKU. Not a health risk when sourced from certified BSE-free herds but not a therapeutically useful cardiovascular product. Would remain Rejected without published RCT evidence for a defined cardiovascular endpoint.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "perfectil-platinum-radiance-skin-time-defy-dietary-supplement-for-anti-aging-and-skin-health-60-tablets",
      "title": "Perfectil Platinum Radiance Skin Time Defy Dietary Supplement for Anti-Aging and Skin Health - 60 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/u5o4tJBbMFOMAO5N7EKILzPqrbhqteVaGgWU2jic.jpg?v=1787417186",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "perfectil",
        "platinum",
        "radiance",
        "skin",
        "time",
        "defy",
        "dietary",
        "supplement",
        "for",
        "anti",
        "aging",
        "and",
        "skin",
        "health",
        "tablets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 65,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 68.44,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790512541893",
      "vsf_explanation": "Perfectil Platinum from Vitabiotics is a well-established UK skin-health multi typically stacking biotin, silica, zinc, selenium, and marine-source ingredients. Vitabiotics has meaningful UK regulatory oversight and a decades-long track record. Evidence for combination multivitamin skin support is moderate; per-ingredient doses cluster around minimum effective levels. Sold via a Turkish/international reseller that adds no additional QC. Would move to Verified 70+ if sold direct-from-Vitabiotics with domestic-market batch traceability.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pycnogenol",
      "title": "Pycnogenol",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a9f8f96a-0159-4f81-961f-daf9cbf685b9_large_aabd605e-5dbf-417f-9ce2-34c6f2cbd535.jpg?v=1787417191",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pycnogenol",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 72,
        "manufacturing": 68,
        "safety": 70,
        "transparency": 68,
        "sustainability": 60
      },
      "price": 32.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790514704581",
      "vsf_explanation": "Pycnogenol is Horphag's French maritime pine bark extract standardized to 65-75% procyanidins — one of the most extensively RCT-studied botanicals with 400+ published trials covering venous insufficiency, endothelial function, ADHD, joint pain, and inflammation. Named branded ingredient with strong provenance. Verified tier justified. Would move higher with third-party USP verification per SKU.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "red-clover-combination",
      "title": "Red Clover Combination",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6d6ebb21-4456-459e-a2f2-3d0895d9f80a_large_db3813cb-39cf-4382-a347-896fc1c63ead.jpg?v=1787417192",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "clover",
        "combination",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 52,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 48,
        "sustainability": 52
      },
      "price": 11.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790514737349",
      "vsf_explanation": "Red clover combined with additional herbs. Combination herbal blends without per-ingredient mg disclosure risk proprietary-blend under-dosing of each active. Red clover isoflavone evidence for menopause is mixed (Lipovac 2012 positive, Tice 2003 null). Would move to Standard 60+ with per-ingredient mg disclosure and isoflavone standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "red-yeast-rice-cholesterol-support-featuring-karaheart",
      "title": "Red Yeast Rice Cholesterol Support - Featuring KaraHeart",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b4d85576-969e-4800-ad5d-60b3c8672881_large_1bb1ac58-8379-484f-8898-81c5354df4df.jpg?v=1787417192",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "yeast",
        "rice",
        "cholesterol",
        "support",
        "featuring",
        "karaheart",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 64,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 14,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 24.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790514835653",
      "vsf_explanation": "Featuring the KaraHeart branded red yeast rice raw material is a small but real transparency win — a named ingredient with a defined identity is preferable to anonymous RYR given the enormous monacolin-content variability documented across the category (Cohen 2017). Meta-analytic LDL-lowering evidence for monacolin K remains solid (Gerards 2015). Safety is the persistent drag because monacolin K is structurally identical to lovastatin, the FDA has flagged high-monacolin RYR as an unapproved drug, and the SKU listing does not highlight a prominent do-not-combine-with-prescription-statin warning. Would move to Standard 66+ with disclosed monacolin K content per serving, citrinin-free COA, and prominent drug-interaction warning. This is unregulated, drug-equivalent exposure with no third-party assay on record — held at Rejected under safety_concern until monacolin K and citrinin testing plus a prominent statin-interaction warning are published.",
      "vsf_autofail_rule": "safety_concern"
    },
    {
      "handle": "full-spectrum-reishi-mushroom",
      "title": "Full Spectrum Reishi Mushroom",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6e937549-e22b-4683-8a33-02541f08ee63_large_098da268-9633-429e-b6bb-8d9576bea95e.jpg?v=1787417192",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "reishi",
        "mushroom",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 52,
        "sustainability": 62
      },
      "price": 9.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790514802885",
      "vsf_explanation": "'Full Spectrum' whole-reishi powder — not a dual-extract, not standardized to polysaccharides or triterpenes. Reishi's active fractions require hot-water extraction (beta-glucans) and ethanol extraction (triterpenes); whole-fruit-body powder delivers a small fraction of what a dual-extract concentrate does. Also unclear whether this is fruiting body or mycelium-on-grain, which materially affects beta-glucan content (Wu 2016). Would move up with dual extract, fruiting body confirmation, and beta-glucan/triterpene standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "multi-glandular-for-women",
      "title": "Multi-Glandular For Women",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e33aa2e1-c54d-4d18-bd70-ba0921a8aaba_large_b9d39083-f615-4130-bf64-cd156c8ee4a0.jpg?v=1787417192",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "multi",
        "glandular",
        "for",
        "women",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 45,
        "transparency": 50,
        "sustainability": 40
      },
      "price": 10.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790514901189",
      "vsf_explanation": "Multi-organ bovine glandular blend targeted at women (likely ovary, uterus, adrenal, thymus, mammary). Same organotherapy critique — no modern RCT support for oral glandular efficacy. Proprietary glandular blend obscures per-organ mg. Would need per-active mg disclosure, sourcing transparency, and RCT support to score higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "thymus-glandular",
      "title": "Thymus Glandular",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e84dc467-4273-41ee-96ec-ba807a7d6576_large_e1aab706-ff74-418a-b8ff-6f168a5a9a7b.jpg?v=1787417192",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "thymus",
        "glandular",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 40
      },
      "price": 16.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790514868421",
      "vsf_explanation": "Bovine thymus glandular — old Italian studies (Cazzola 1987) with thymic peptide extracts showed modulation in some clinical populations but do not translate to whole desiccated glandular. TSE-precursor tissue concern. Would need injectable/oral thymic peptide equivalent and safety documentation to score higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "kidney-glandular",
      "title": "Kidney Glandular",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8c526b1b-7966-4a67-a9de-a4b8670b1005_large_629dfade-80a1-4d0c-9dad-34f7cda652cc.jpg?v=1787417192",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "kidney",
        "glandular",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 40
      },
      "price": 10.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790514933957",
      "vsf_explanation": "Bovine kidney glandular — same organotherapy critique with no modern RCT support for oral kidney-tissue supplementation improving human kidney function or health. Sourcing transparency absent. Would need RCT evidence and safety documentation to score higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "retinol-cream",
      "title": "Retinol Cream",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/425e866e-0bcb-4630-a3a3-65ce899a849e_large_e0540fa2-78b1-498c-99b9-4b3e64b5d18b.jpg?v=1787417192",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "retinol",
        "cream",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 10.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790515851461",
      "vsf_explanation": "Topical retinol for photoaging (Kang 1995). No concentration disclosed — critical for efficacy/tolerability balance. No pregnancy contraindication or sun-sensitivity warning. Would improve with 0.1-0.5% concentration disclosure and clear safety warnings.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "spleen-glandular",
      "title": "Spleen Glandular",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f3a2de79-8f33-4cac-bbc8-eec8f9b09dd2_large_56a98555-c5ab-4003-9b5e-378a3f27da2b.jpg?v=1787417193",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "spleen",
        "glandular",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 40
      },
      "price": 4,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790515884229",
      "vsf_explanation": "Bovine spleen glandular products rest on the discredited 'like-supports-like' organotherapy hypothesis with essentially no modern RCT evidence for oral gland extract benefit. BSE/prion exposure risk with animal-tissue products from non-transparent sources. Would need herd-source certification, TSE-free documentation, and RCT support to score higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "retinol-cream-2-pack",
      "title": "Retinol Cream - 2 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/043dacc5-6a00-4aa1-ac0e-bce8b8329a98_large_f4499ac8-6872-493b-bb31-c005f5f72734.jpg?v=1787417193",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "retinol",
        "cream",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 18.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790515949765",
      "vsf_explanation": "Topical retinol has strong evidence for photoaging, wrinkle reduction, and cellular turnover (Kang 1995). No retinol concentration disclosed in title — critical for efficacy vs irritation calibration. Safety flag: no pregnancy contraindication or sun-sensitivity warning in title. Would improve with 0.1-0.5% concentration disclosure and safety warnings.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pituitary-glandular",
      "title": "Pituitary Glandular",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8a58af02-c5a5-4c37-8d0d-0c74c3dc4071_large_7639657a-c934-43b4-a51a-8ce8ba4ae122.jpg?v=1787417194",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pituitary",
        "glandular",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 45,
        "transparency": 55,
        "sustainability": 40
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790516048069",
      "vsf_explanation": "Bovine pituitary glandular — same organotherapy critique applies with additional CJD/BSE concern given pituitary tissue is a high-risk source. FDA has specifically warned against bovine pituitary in supplements. Would need CJD-free herd certification and RCT support to score higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sambucus-elderberry-extract",
      "title": "Sambucus Elderberry Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/27b65d8a-ec9c-476c-909c-845ae205238d_large_69b9cff5-81e2-4904-b6c9-9d487d1d48b6.jpg?v=1787417193",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sambucus",
        "elderberry",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 60,
        "sustainability": 60
      },
      "price": 12.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790516015301",
      "vsf_explanation": "Sambucus nigra elderberry extract in capsule form — same species as the positive Tiralongo 2016 (air-travel cold duration) and Zakay-Rones 2004 (flu duration) trials, with the ~10-14 day acute-illness use pattern that generated most positive data. Held to mid-Standard by no anthocyanin standardization percentage disclosed on the title. Would move up with named anthocyanin content (e.g., Sambucol-grade or ElderCraft branded) plus per-serving elderberry equivalent.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "prostate-glandular-mens-health",
      "title": "Prostate Glandular - Men's Health",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0898a9e8-ef1d-4037-814f-225d29acf38e_large_0200f7bd-1240-445b-a800-38dddce994bf.jpg?v=1787417193",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "prostate",
        "glandular",
        "men",
        "health",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 7.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790515982533",
      "vsf_explanation": "Glandular product using bovine prostate tissue. The 'like-supports-like' glandular theory has no meaningful RCT support in humans — no evidence that oral consumption of animal prostate tissue improves human prostate function, either symptomatically for BPH or otherwise. Safety concerns include sourcing (BSE risk with bovine tissue depends on country and processing) and lack of standardization. Would need actual RCT evidence to justify a Standard tier — as-is, glandular products fall below on evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "resveratrol-wrinkle-cream",
      "title": "Resveratrol Wrinkle Cream",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ba438975-646d-4f6c-bac0-451698127c3c_large_bf54a7f1-4007-4d15-bd5d-869374c78d51.jpg?v=1787417193",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "resveratrol",
        "wrinkle",
        "cream",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 5.75,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790515916997",
      "vsf_explanation": "Topical resveratrol wrinkle cream — a cosmetic delivery rather than a systemic immune-antioxidant product, so recategorized to skin/hair/beauty. Topical polyphenols have some evidence for photoprotection (Baxter 2008 for topical resveratrol UV response) but formulations vary hugely on resveratrol stability, penetration enhancers, and vehicle. Held to low Standard by no trans-resveratrol percentage, no penetration-enhancer disclosure, and the general credibility gap of cosmetic anti-aging marketing. Would move up with disclosed resveratrol %, stabilization method, and independent efficacy data.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sage-extract",
      "title": "Sage Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/638c8cab-c5a5-4e1d-b0fb-11dbba8ed1ba_large_b358142b-b009-425d-ab32-2ad0f5908624.jpg?v=1787417193",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sage",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 58,
        "sustainability": 52
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790516080837",
      "vsf_explanation": "Sage (Salvia officinalis) has small RCTs for menopausal hot flashes (Bommer 2011) and cognitive endpoints (Kennedy 2006). Extract format concentrates the essential-oil constituents. Thujone content in sage essential oil is a safety concern at high doses (neurotoxic at extreme intake); label should disclose thujone content. Would move to Verified 70+ with thujone-controlled extract and studied dose disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sea-cucumber",
      "title": "Sea Cucumber",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6d373293-5006-4381-a2f5-68534daf0f9a_large_8454960a-c663-4ed1-802a-042f074cc569.jpg?v=1787417193",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sea",
        "cucumber",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 30
      },
      "price": 17.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790516113605",
      "vsf_explanation": "Sea cucumber (holothurian) is marketed for joint support based on chondroitin content and traditional Asian use. Limited controlled RCT evidence. Major sustainability concern: many wild sea cucumber fisheries are overexploited or trafficked; no MSC or aquaculture certification disclosed. Would need sustainable sourcing certification and modern RCT support to score higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-red-clover-blossom",
      "title": "Full Spectrum Red Clover Blossom",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/bf871f0b-7cdd-420c-b5a6-1c91396a8cc2_large_3747f58c-7014-419b-8e09-6c4bffac97ed.jpg?v=1787417193",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "red",
        "clover",
        "blossom",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 55,
        "sustainability": 52
      },
      "price": 6.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790516146373",
      "vsf_explanation": "Red clover (Trifolium pratense) isoflavones — biochanin A, formononetin, genistein, daidzein — studied for menopausal vasomotor symptoms with mixed results (Lipovac 2012 supportive, larger Tice 2003 null). Whole-blossom powder without isoflavone standardization delivers unpredictable phytoestrogen dose. Estrogen-sensitive conditions require caution. Would move to Standard 65+ with named Promensil-style 40 mg isoflavone standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "psyllium-husk-powder-fine-milled-unflavored",
      "title": "Psyllium Husk Powder - Fine Milled & Unflavored",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b733db72-5510-4a3b-94a0-daf66c8af86f_large_2fbf4a15-b004-448b-a175-2c8e33509524.jpg?v=1787417193",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "psyllium",
        "husk",
        "powder",
        "fine",
        "milled",
        "unflavored",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 68,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 8.13,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790516179141",
      "vsf_explanation": "Psyllium husk powder is one of the best-evidenced supplements period — LDL reduction (Jovanovski 2018 meta-analysis), constipation (McRorie 2015), glycemic control. Unflavored + fine-milled is the cleanest form for adherence. Would move to Verified 70+ with certified-organic sourcing and heavy-metal test disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "simply-hydrate-electrolyte-hydration-mix-orange",
      "title": "Simply Hydrate Electrolyte Hydration Mix - Orange",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2eadcaed-877d-44e1-b2d2-c29da420d5ba_large_903de76f-c7af-41ff-8ee3-7194548434d0.jpg?v=1787417193",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "simply",
        "hydrate",
        "electrolyte",
        "hydration",
        "mix",
        "orange",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 27.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790516244677",
      "vsf_explanation": "Orange Simply Hydrate variant — same specifications as sibling SKUs. Would improve with 500mg+ sodium and clean sweetener disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "shea-butter-coconut-lip-balm",
      "title": "Shea Butter & Coconut Lip Balm",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c8dd2ffd-ee84-46d8-8cdf-a97816fe2b50_large_cf853c3c-0fcb-482c-8df5-a18ffedc1888.jpg?v=1787417193",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shea",
        "butter",
        "coconut",
        "lip",
        "balm",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 1.76,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790516277445",
      "vsf_explanation": "Basic cosmetic lip balm with shea butter and coconut oil — functional as a moisturizer but no functional biohacking actives, no SPF, no therapeutic claim. Outside core biohacking supplement scope. Would need SPF or therapeutic actives to move higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "rosewater-mist",
      "title": "Rosewater Mist",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/52c5bc56-e77d-4cab-88bb-295884ae0b81_large_8147a27a-ffd0-4f67-9cc9-236eced8f328.jpg?v=1787417193",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "rosewater",
        "mist",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 7.15,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790516310213",
      "vsf_explanation": "Rosewater facial mist is a personal-care/cosmetic product rather than an ingestible supplement, sitting at the edge of Vyvata's biohacking scope. Topical rosewater has traditional use but minimal RCT evidence for meaningful skin outcomes. Safe as a hydrating mist but essentially cosmetic. Would move up only via reclassification as a cosmetic product, not as a supplement.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "simply-hydrate-electrolyte-hydration-mix-berry-blast",
      "title": "Simply Hydrate Electrolyte Hydration Mix - Berry Blast",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/019df95e-4d2c-7eee-9206-5e3b380b9797.jpg?v=1787417195",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "simply",
        "hydrate",
        "electrolyte",
        "hydration",
        "mix",
        "berry",
        "blast",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 10.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790517227717",
      "vsf_explanation": "Berry Blast Simply Hydrate variant — same specifications as sibling SKUs. Would improve with 500mg+ sodium and clean sweetener disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sinus-helper",
      "title": "Sinus Helper",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3b0b6395-a0c8-4aad-beff-22f4c6eee69f_large_935ad299-d342-4eac-bd13-2fff28889825.jpg?v=1787417195",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sinus",
        "helper",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 7.85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790517260485",
      "vsf_explanation": "'Sinus Helper' is a blend product — typically NAC, quercetin, bromelain, nettle, or similar. Individual ingredients have preliminary evidence for allergic rhinitis (Mickleborough 2007 for quercetin, Ryan 2010 for bromelain). Per-active mg not disclosed in title — proprietary blend risk. Would improve with per-ingredient mg breakdown.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "simply-hydrate-electrolyte-hydration-mix-raspberry-lemonade",
      "title": "Simply Hydrate Electrolyte Hydration Mix - Raspberry Lemonade",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9bd9d971-5e7c-4fa6-a875-43b2ff71af10_large_0a302ae5-1690-4f42-82dd-af60f0f12794.jpg?v=1787417196",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "simply",
        "hydrate",
        "electrolyte",
        "hydration",
        "mix",
        "raspberry",
        "lemonade",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 27.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790517326021",
      "vsf_explanation": "Duplicate SKU of the raspberry lemonade Simply Hydrate mix. Same rationale — ACSM sweat-loss electrolyte target (Sawka 2007) is 500-700mg sodium/L, and per-serving content is not disclosed at title level. Would move to Verified 70+ with full electrolyte panel at studied concentrations.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "senna-cascara-psyllium-complex",
      "title": "Senna, Cascara & Psyllium Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8f1dac9c-bcc9-49bb-b552-191bc72720bc_large_b963b5e9-4489-4bfd-9085-6d1c4e17ea91.jpg?v=1787417196",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "senna",
        "cascara",
        "psyllium",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 40,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 10.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790518210757",
      "vsf_explanation": "Combines senna and cascara — anthraquinone stimulant laxatives with real short-term efficacy but well-documented dependency risk, melanosis coli, and electrolyte disturbance with chronic use (WHO/FDA guidance discourages regular use beyond ~1 week). Psyllium alone (bulking, no dependency) would be preferable. Safety is the driver of the Rejected tier here, not efficacy. Would not recommend for regular daily use.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "shark-cartilage",
      "title": "Shark Cartilage",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/bab63bcb-b875-4d8f-a2d1-ae83aff960a2_large_072d91cb-d476-4d2d-aaff-5ce0b46fa4c3.jpg?v=1787417196",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shark",
        "cartilage",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 25
      },
      "price": 26.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790518243525",
      "vsf_explanation": "Shark cartilage — historical joint/cancer folk supplement with negative RCT record (Miller 1998, Loprinzi 2005 in NEJM for cancer; joint OA data is thin and not superior to glucosamine/chondroitin isolates). Sustainability is a major concern: shark cartilage sourcing drives finning/bycatch practices condemned by IUCN and multiple marine-conservation bodies; several shark species are threatened. Held in Rejected tier by weak-to-negative evidence combined with severe sustainability harm. Would not recommend regardless of price.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "slippery-elm-bark",
      "title": "Slippery Elm Bark",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8f14962e-7f31-476b-a057-dad0ea4a0fa0_large_873a449e-1ec8-46f0-9be5-1719a2137d0a.jpg?v=1787417197",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "slippery",
        "elm",
        "bark",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 6.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790518276293",
      "vsf_explanation": "Traditional demulcent for GI/esophageal soothing. Mucilaginous mechanism is plausible for reflux and IBS bowel comfort (Hawrelak 2010 small trial), though evidence quality is limited. Sustainability concern: slippery elm is a stressed tree species. Would move to Verified with sustainable-sourcing certification and standardized mucilage content.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "simply-hydrate-electrolyte-hydration-mix-variety-pack",
      "title": "Simply Hydrate Electrolyte Hydration Mix - Variety Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/faf3090d-4d3c-4a9b-9e95-d2847d4ebc00_large_860e12bf-48fe-4b9c-812c-b6250a2f1440.jpg?v=1787417197",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "simply",
        "hydrate",
        "electrolyte",
        "hydration",
        "mix",
        "variety",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 27.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790518341829",
      "vsf_explanation": "Variety pack of Simply Hydrate — bundles multiple flavor variants. Same electrolyte formulation quality across flavors. Would improve with 500mg+ sodium and clean sweetener disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "senna-leaf",
      "title": "Senna Leaf",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e4542ac7-51fb-427f-9744-037e0ea79f4a_large_bb0cf1e8-0449-4411-af85-14e32c1c5a18.jpg?v=1787417199",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "senna",
        "leaf",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 35,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 8.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790519226565",
      "vsf_explanation": "Senna is an effective short-term stimulant laxative but chronic use causes dependency, electrolyte disturbance, melanosis coli. Not appropriate for daily supplement use — should be short-term (<1 week) only. Would need prominent short-term-use warning and non-chronic-use positioning to score higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "simply-hydrate-electrolyte-hydration-mix-lemon-lime",
      "title": "Simply Hydrate Electrolyte Hydration Mix - Lemon-Lime",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/019df95e-40b4-722e-b815-a16846ab7b38.jpg?v=1787417199",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "simply",
        "hydrate",
        "electrolyte",
        "hydration",
        "mix",
        "lemon",
        "lime",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 10.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790519259333",
      "vsf_explanation": "Lemon-Lime Simply Hydrate variant — same specifications as sibling SKUs. Would improve with 500mg+ sodium and clean sweetener disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "simply-hydrate-electrolyte-hydration-mix-watermelon",
      "title": "Simply Hydrate Electrolyte Hydration Mix - Watermelon",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/019df95a-0cfa-700f-825e-8cb29065ef98.jpg?v=1787417200",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "simply",
        "hydrate",
        "electrolyte",
        "hydration",
        "mix",
        "watermelon",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 5.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790519324869",
      "vsf_explanation": "Watermelon Simply Hydrate variant — same specifications as sibling SKU. Would improve with 500mg+ sodium and sweetener disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-shiitake-mushroom",
      "title": "Full Spectrum Shiitake Mushroom",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/281adb0b-541d-4d2c-a309-9acc36cbd4ca_large_81c7b3bd-99a2-4041-8ad5-4af50f161a9e.jpg?v=1787417200",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "shiitake",
        "mushroom",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 52,
        "sustainability": 62
      },
      "price": 6.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790519357637",
      "vsf_explanation": "'Full Spectrum' line means whole-mushroom powder — not a hot-water-extracted beta-glucan-standardized product. Whole shiitake powder delivers polysaccharides at very low activity versus dual-extract fruiting-body concentrates (lentinan-focused). Reasonable food-form but poor as an immune-modulator delivery vehicle. Would move up substantially with dual extract, fruiting body confirmation, and beta-glucan >=25% standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "simply-hydrate-electrolyte-hydration-mix-raspberry-lemonade-1",
      "title": "Simply Hydrate Electrolyte Hydration Mix - Raspberry Lemonade",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/019df95e-305f-7eee-9206-4bb01bdd1701.jpg?v=1787417200",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "simply",
        "hydrate",
        "electrolyte",
        "hydration",
        "mix",
        "raspberry",
        "lemonade",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 5.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790519390405",
      "vsf_explanation": "Electrolyte hydration mix — ACSM (Sawka 2007) recommends 500-700mg sodium per liter for exercise hydration; consumer 'lite' hydration products often deliver 150-300mg per serving which is under the operative threshold for real sweat-loss replacement. Without per-serving sodium content in the title, cannot confirm the studied range. Held at Standard because electrolyte content is not disclosed at title level. Would move to Verified 70+ with full electrolyte panel at studied concentrations and clean sweetener sourcing (natural vs sucralose).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "saw-palmetto-liquid-extract-alcohol-sugar-free",
      "title": "Saw Palmetto Liquid Extract - Alcohol & Sugar Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/028c49b3-46a3-4f4a-8203-26ca4a9fc607_large_108b4502-9752-43c4-ab49-7efb3dfd9853.jpg?v=1787417200",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "saw",
        "palmetto",
        "liquid",
        "extract",
        "alcohol",
        "sugar",
        "free",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 7.13,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790519423173",
      "vsf_explanation": "Liquid saw palmetto tincture (alcohol- and sugar-free), which may use glycerin extraction. The saw palmetto BPH evidence base (Wilt 1998; Bent 2006 STEP) is built on 320mg/day of 85-95% fatty acid-standardized lipid extract — liquid/glycerin tinctures are unlikely to match that fatty-acid concentration and dosing consistency. Alcohol-free formulation is helpful for those avoiding alcohol but doesn't itself improve efficacy. Would move higher with a standardized lipid-extract format at monograph dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "selenium-l-selenomethionine",
      "title": "Selenium L-Selenomethionine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/198a6156-3bb6-4545-8b1a-065cbd06e619_large_ceebd918-bb4b-4433-aee8-494d59990fd7.jpg?v=1787417200",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "selenium",
        "selenomethionine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 74,
        "manufacturing": 66,
        "safety": 68,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 12.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790519488709",
      "vsf_explanation": "L-selenomethionine is the best-studied selenium form for thyroid antioxidant support at 200mcg (Rayman 2012; Duntas 2010). Named-form disclosure lifts to low Verified tier. Would move higher with third-party purity and NSF verification. Do not exceed 400mcg/day chronically (Bleys 2008).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "rutin-natural-bioflavonoid",
      "title": "Rutin Natural Bioflavonoid",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b01fa193-5837-4d7a-8888-6b1e1aa6936b_large_334c8bdd-cdcb-42ee-a61d-2a9f794b19a5.jpg?v=1787417200",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "rutin",
        "natural",
        "bioflavonoid",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 28.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790519455941",
      "vsf_explanation": "Rutin is a quercetin-glycoside flavonoid with modest evidence for venous insufficiency and capillary fragility. Bioavailability is low (must be hydrolyzed to quercetin). Would improve with combined quercetin/rutin formulation and enzyme-treated (Alpha-G Rutin) form for better absorption.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "adaptogenic-herbal-complex-with-rhodiola-ashwagandha-ginseng",
      "title": "Adaptogenic Herbal Complex with Rhodiola, Ashwagandha & Ginseng",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4cb35d55-a6e4-4868-9897-5f04ba658fc2_large_8bc9f5bf-2606-4e5e-bcd9-7c8e8e4f603d.jpg?v=1787417200",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "adaptogenic",
        "herbal",
        "complex",
        "with",
        "rhodiola",
        "ashwagandha",
        "ginseng",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 13.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790519521477",
      "vsf_explanation": "Adaptogenic combo of three genuinely well-studied herbs (Rhodiola rosea SHR-5 in Darbinyan 2007; ashwagandha in Chandrasekhar 2012; ginseng in Kennedy 2006), but per-herb dose and standardization percentages are usually undisclosed in combo products, making it impossible to know if any single herb is at its studied dose. Would move to Verified with per-herb mg + standardization (rosavins/salidroside for Rhodiola, withanolides for ashwagandha, ginsenosides for ginseng).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "red-raspberry-leaves",
      "title": "Red Raspberry Leaves",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/164e2c7e-3c16-41b1-8cdb-d8b78e445f85_large_0f3237f9-dde4-4400-bbcf-6f619e073c69.jpg?v=1787417200",
      "score": 53,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "raspberry",
        "leaves",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 55,
        "sustainability": 52
      },
      "price": 7.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790519554245",
      "vsf_explanation": "Red raspberry leaf (Rubus idaeus) has traditional use for pregnancy/labor preparation but limited controlled evidence (Simpson 2001 small RCT showed no reduction in labor length). Non-pregnant applications lack meaningful clinical evidence. Whole-herb powder without characterized actives. Would move to Standard 60+ with pregnancy-safety review, standardization to ellagic acid, and better clinical evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "simply-hydrate-electrolyte-hydration-mix-berry-blast-1",
      "title": "Simply Hydrate Electrolyte Hydration Mix - Berry Blast",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/67fd0478-175d-42b8-a22c-d0f3d96c6ad5_large_f34d7955-1a70-449f-aada-2634010d1ba0.jpg?v=1787417200",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "simply",
        "hydrate",
        "electrolyte",
        "hydration",
        "mix",
        "berry",
        "blast",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 27.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790519587013",
      "vsf_explanation": "Berry Blast Simply Hydrate variant. Same specifications as sibling SKUs. Would improve with 500mg+ sodium and clean sweetener disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-saw-palmetto",
      "title": "Full Spectrum Saw Palmetto",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1cb66ec6-736a-4fe8-9e52-a8116e731a43_large_ab924b84-9936-4b39-aa61-58c71dd55804.jpg?v=1787417200",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "saw",
        "palmetto",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 13.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790520504517",
      "vsf_explanation": "Whole-berry saw palmetto without standardized lipid extraction. The BPH evidence base (Wilt 1998 positive; Bent 2006 STEP null) uses 320mg of 85-95% fatty acid-standardized lipid extract — whole-berry powder delivers a smaller and more variable fraction of the active lipids. Would move to Verified 70+ with lipid-extract format and fatty acid standardization disclosed at studied dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "royal-jelly-maximum-strength",
      "title": "Royal Jelly - Maximum Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/51925749-e0b8-48e5-897f-f0af7cb8e1a4_large_12d426d6-24a8-4540-b684-7a3e2fc2d455.jpg?v=1787417202",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "royal",
        "jelly",
        "maximum",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 50,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 13.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790521848005",
      "vsf_explanation": "Royal jelly has preliminary evidence for menopausal symptoms and fatigue with mixed RCT quality. Safety flag: severe anaphylaxis risk in bee-allergic individuals — documented fatalities. 10-HDA is the standardization marker but not disclosed. Would need allergen warning, 6% 10-HDA standardization, and freshness/preservation disclosure to score higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-sarsaparilla-root",
      "title": "Full Spectrum Sarsaparilla Root",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/78d4f670-59ad-48aa-a787-6be4a40fc3dd_large_878e04f4-08a9-41c3-a967-fe958332537d.jpg?v=1787417203",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "sarsaparilla",
        "root",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 4.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790521880773",
      "vsf_explanation": "Sarsaparilla is traditionally marketed as a testosterone booster or blood-purifier — no controlled human RCT evidence for either claim, and the diosgenin-to-testosterone conversion is a persistent supplement-industry myth without biochemical support. Whole herb without standardization. Would need modern RCT support to score higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "orchic-glandular-mens-health",
      "title": "Orchic Glandular - Men's Health",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/169aa824-ff03-4548-816f-d6d45abe3ff8_large_4c4c4725-add9-4f90-857f-54c0f107fca2.jpg?v=1787417203",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "orchic",
        "glandular",
        "men",
        "health",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 13.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790521979077",
      "vsf_explanation": "Orchic (bovine testicular tissue) glandular product marketed for men's hormonal health. The 'like-supports-like' glandular hypothesis has no meaningful RCT support in humans — no evidence that oral bovine testis tissue raises testosterone or supports male reproductive function. Sourcing concerns include BSE risk with bovine glandulars depending on country and processing. Falls below Standard on evidence alone — the underlying biology of oral peptide/hormone tissue survival through digestion doesn't support the claim.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "rhodiola-holy-basil-valerian-stress-complex-3-in-1-formula",
      "title": "Rhodiola Holy Basil Valerian Stress Complex - 3-in-1 Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3ae110a5-fa57-4207-83d5-5eb3b198f12b_large_392192ba-46d3-4c8a-93f6-639743bc2bd2.jpg?v=1787417203",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "rhodiola",
        "holy",
        "basil",
        "valerian",
        "stress",
        "complex",
        "formula",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 50,
        "manufacturing": 58,
        "safety": 58,
        "transparency": 52,
        "sustainability": 50
      },
      "price": 10.85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790522044613",
      "vsf_explanation": "Combination formula stacking three herbs with different profiles — rhodiola (energizing adaptogen), holy basil (stress modulator), valerian (sedating). Individually each has some evidence at specific doses but combining them dilutes per-active dosing and creates a pharmacological mismatch (energizing + sedating in the same capsule). Combination products almost universally hide per-active dose in proprietary blends, making it impossible to verify that each herb hits studied thresholds. Also carries a valerian-driven daytime sedation concern (Bent 2006) — valerian is a bedtime herb, not a daytime stress product. Held at Standard due to formulation mismatch and dose-disclosure risk.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "revitalizing-eye-cream-with-caffeine",
      "title": "Revitalizing Eye Cream with Caffeine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b79c8394-09f7-4775-98eb-9dc30a87a8d5_large_aef5a02f-982a-4ff5-90b1-e35349aec49b.jpg?v=1787417203",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "revitalizing",
        "eye",
        "cream",
        "with",
        "caffeine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 26.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790522011845",
      "vsf_explanation": "Topical caffeine eye cream — caffeine has modest evidence for reducing under-eye puffiness via vasoconstriction. No concentration disclosed, no antioxidant complement (vit K, retinol) disclosed. Would improve with actives concentration disclosure and paired peptide/antioxidant additions.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "selenium-l-selenomethionine-1",
      "title": "Selenium L-Selenomethionine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/60afb20d-d83f-4b6e-8736-880fad651c46_large_35ea6508-bc90-4ca5-9ba8-34bfc9cea31a.jpg?v=1787417203",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "selenium",
        "selenomethionine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 74,
        "manufacturing": 66,
        "safety": 68,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790522077381",
      "vsf_explanation": "L-selenomethionine is the most bioavailable and best-studied selenium form for thyroid antioxidant support (Rayman 2012; Duntas 2010 in Hashimoto). 200mcg is the typical thyroid dose. Named-form disclosure lifts to low Verified. Would move higher with third-party verification and dose alignment with published RCTs.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-saw-palmetto-1",
      "title": "Full Spectrum Saw Palmetto",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ef2667ae-c29e-4fa1-a1da-3420905a60b6_large_c3c0e2ce-89a4-4412-8cde-ed5bdb7e7a40.jpg?v=1787417207",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "saw",
        "palmetto",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 20.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790523420869",
      "vsf_explanation": "Full Spectrum designation typically indicates whole-berry powder rather than the lipid/liposterolic extract used in most saw palmetto BPH RCTs. The positive evidence (Wilt 1998 meta-analysis) is anchored on 320mg of 85-95% fatty acid-standardized lipid extract — whole-berry powder likely delivers a much smaller fraction of the active lipids per gram. STEP trial (Bent 2006) at that studied dose was still null. Would move higher only with a fatty-acid standardized extract at 320mg/day matching the BPH monograph.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-rhodiola-rosea-root",
      "title": "Full Spectrum Rhodiola Rosea Root",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ae4265e8-ef96-48d5-92cc-b5e792235053_large_1b11790d-7dcb-41b2-8b62-77bec388fae3.jpg?v=1787417208",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "rhodiola",
        "rosea",
        "root",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 52,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 13.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790523453637",
      "vsf_explanation": "'Full spectrum' rhodiola root — the marketing term for a whole-root non-standardized preparation. The RCT evidence for rhodiola (Darbinyan 2000, Spasov 2000) is entirely on standardized extract material (SHR-5, 3% rosavins/1% salidroside), so whole-root product without standardization does not confirm delivery of the active constituents at studied levels. Full-spectrum arguments (synergy of minor constituents) are pharmacologically plausible but not proven for rhodiola. Held at Standard because the delivered active dose is unpredictable. A standardized extract at studied concentration is a strictly better choice.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-rosemary",
      "title": "Full Spectrum Rosemary",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ef07fa45-0f3b-4cbc-94db-7a72c77c392c_large_c7d1d12b-8e27-444d-82f1-4b75aa0d8c88.jpg?v=1787417208",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "rosemary",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 55,
        "sustainability": 52
      },
      "price": 12.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790523486405",
      "vsf_explanation": "Whole-herb rosemary (Rosmarinus officinalis) powder. Oral rosemary evidence is thin — most cognitive evidence uses aromatherapy (Moss 2003), not oral. In-vitro antioxidant activity. Would move to Standard 62+ with carnosic-acid standardization and oral outcome-endpoint trials.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-rose-hips",
      "title": "Full Spectrum Rose Hips",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6e60931a-7b29-4069-8ed3-4628c05e8f28_large_95277905-3df5-4f65-a987-3dee876caffa.jpg?v=1787417208",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "rose",
        "hips",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 7.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790523519173",
      "vsf_explanation": "Rose hip (Rosa canina) has moderate osteoarthritis evidence (Christensen 2008 meta-analysis showed modest pain reduction with LitoZin extract). Whole-herb powder is much less concentrated than LitoZin's galactolipid-standardized extract used in trials. Would move to Standard 65+ with LitoZin or named GOPO-standardized extract.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "stinging-nettle-leaf",
      "title": "Stinging Nettle Leaf",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b19aaded-05f7-413b-a2d1-60b0ed73ab9e_large_226efb57-cdd9-4720-bd06-7d5fb71066b8.jpg?v=1787417252",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "stinging",
        "nettle",
        "leaf",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 66,
        "transparency": 58,
        "sustainability": 52
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790544228549",
      "vsf_explanation": "Whole-herb nettle leaf capsule for seasonal-allergy support (Mittman 1990 used freeze-dried leaf at 300 mg TID). Whole powder is less concentrated than freeze-dried extract used in the trial. Would move to Standard 60+ with freeze-dried format and studied 900 mg/day dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-st-johns-wort",
      "title": "Full Spectrum St. John's Wort",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e4d3e861-6b98-40d9-b1e2-2b247c33391d_large_00f71302-438f-49d4-80e7-8b9fbd0f937e.jpg?v=1787417252",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "john",
        "wort",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 45,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 5.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790544359621",
      "vsf_explanation": "Unstandardized whole-herb 'full spectrum' St. John's Wort - lower on cognitive/mood evidence than standardized 0.3% hypericin extracts used in the Linde 2008 Cochrane review at 300mg TID. The interaction burden (CYP3A4, CYP2C9, P-gp induction) applies to the whole herb too and is chronically under-disclosed. Manufacturing is competent but nothing distinctive. Would move to Verified 70+ with standardized hypericin extract at RCT dose plus prominent drug-interaction disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "simply-hydrate-electrolyte-hydration-mix-watermelon-1",
      "title": "Simply Hydrate Electrolyte Hydration Mix - Watermelon",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fea6c5e4-f43b-4d25-b28e-7047f0254b2d_large_575a2ff5-9754-4f8c-94dd-8040469536bf.jpg?v=1787417252",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "simply",
        "hydrate",
        "electrolyte",
        "hydration",
        "mix",
        "watermelon",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 27.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790544163013",
      "vsf_explanation": "Watermelon variant of Simply Hydrate electrolyte line. Would improve with 500mg+ sodium and clean sweetener disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "soy-isoflavones-standardized",
      "title": "Soy Isoflavones - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/91ee91f2-ae76-459b-a413-1903bdf6efb3_large_9bd964ef-c11c-4697-9521-e5dd19efcf33.jpg?v=1787417252",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "soy",
        "isoflavones",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 10.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790544261317",
      "vsf_explanation": "Soy isoflavones (genistein, daidzein) have meta-analysis support for hot flash reduction (Taku 2012) at 50-100mg/day. 'Standardized' is disclosed but % isoflavone content and genistein:daidzein ratio not stated in title. Would improve with 40% isoflavone standardization confirmed and non-GMO soy source disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "super-stress-b-complex-with-vitamin-c",
      "title": "Super Stress B-Complex with Vitamin C",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ff81b6e2-644d-45c6-bd6b-607c0c1364ba_large_fd22c6ae-c65e-4731-8b20-131260b855bb.jpg?v=1787417252",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive",
        "mood",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "super",
        "stress",
        "complex",
        "with",
        "vitamin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 26.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790544195781",
      "vsf_explanation": "B-complex + vitamin C shows modest stress/fatigue effects in Kennedy 2010 Berocca RCT. Likely uses non-methylated B12/folate forms (inferior in MTHFR carriers per Obeid & Herrmann 2012) with B6 as pyridoxine HCl (peripheral-neuropathy risk at chronic higher doses). Held below Verified by non-bioactive form choice.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "slimming-thermogenic-complex-featuring-slendacor",
      "title": "Slimming Thermogenic Complex - Featuring Slendacor",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6c7366be-e272-4259-860e-e2d2e6716bf9_large_afcc08db-8441-4bcd-b1cf-918912b681f7.jpg?v=1787417252",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "slimming",
        "thermogenic",
        "complex",
        "featuring",
        "slendacor",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 55,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 30.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790544523461",
      "vsf_explanation": "Slendacor is Laila Nutraceuticals' branded blend of turmeric, moringa and curry leaf, with a small positive body-composition RCT (Sengupta 2017). 'Thermogenic' framing usually implies stimulants; unclear if this formulation adds caffeine or synephrine. Weight-loss effect sizes in the underlying trial were modest. Would move to Verified with clearer disclosure of any stimulant content and full independent replication of the Slendacor RCT.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "supreme-lecithin-with-phosphatidylcholine",
      "title": "Supreme Lecithin with Phosphatidylcholine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/22d9179f-96ab-454a-b10d-b398b77cc76a_large_24f4bebc-3dbf-4681-994b-098d30fabf50.jpg?v=1787417252",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "supreme",
        "lecithin",
        "with",
        "phosphatidylcholine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 16.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790544457925",
      "vsf_explanation": "Lecithin softgel enriched with phosphatidylcholine - a low-cost choline source that supports acetylcholine synthesis and liver PC pools. Bioavailability is inferior to alpha-GPC or CDP-choline for cognitive endpoints, and standard soy lecithin PC content is modest (~20% PC by weight typical). Safety is good. Would move to Verified 70+ with disclosed PC percentage, sunflower rather than soy source (lower allergen and cleaner ingredient), and clear per-serving PC mg.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "simply-hydrate-electrolyte-hydration-mix-lemon-lime-1",
      "title": "Simply Hydrate Electrolyte Hydration Mix - Lemon-Lime",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9a7bac69-66c8-4fe0-88f9-117e6f7b021d_large_879e1326-17dd-4ceb-90c7-549e75a496a6.jpg?v=1787417252",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "simply",
        "hydrate",
        "electrolyte",
        "hydration",
        "mix",
        "lemon",
        "lime",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 27.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790544294085",
      "vsf_explanation": "Lemon-lime variant of Simply Hydrate electrolyte line. Would improve with 500mg+ sodium and clean sweetener disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "strontium-citrate",
      "title": "Strontium Citrate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ee3c0422-f6b7-412e-a08f-dedc669dc79e_large_256af356-05ea-45a6-bb67-90122c5baae6.jpg?v=1787417252",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "strontium",
        "citrate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 45,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 15.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790544490693",
      "vsf_explanation": "Strontium citrate is often marketed as a bone-density supplement, extrapolating from prescription strontium ranelate osteoporosis data. Ranelate was withdrawn in Europe due to cardiovascular and thromboembolic events (EMA 2014). Also confounds DEXA scan readings (higher density reading due to atomic weight, not bone quality). Would need CV-safety warning and DEXA-confounding disclosure to score higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "supplemelts-biotin-natural-cherry-flavor",
      "title": "Supplemelts Biotin - Natural Cherry Flavor",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/19784a7f-eac7-406a-a6f4-d7cf166b9259_large_a1fcc3fd-17cf-4dcd-b099-262526c0373d.jpg?v=1787417252",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "supplemelts",
        "biotin",
        "natural",
        "cherry",
        "flavor",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 50,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 7.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790544392389",
      "vsf_explanation": "Dissolvable Supplemelts biotin has typical mass-market delivery-format advantages (compliance) but the underlying weak clinical evidence for biotin in hair/nails outside deficiency (Patel 2017) and immunoassay-interference risk (FDA 2017 Safety Communication) apply. Held at low-Standard by weak effect-size evidence and safety-warning gap.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chewable-vitamin-c-natural-cherry-flavor-sugar-free",
      "title": "Chewable Vitamin C - Natural Cherry Flavor Sugar Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e7df6fa0-227d-4195-8269-a924e4b6728d_large_f9b90855-1888-46df-99fd-880f367a6c5a.jpg?v=1787417252",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chewable",
        "vitamin",
        "natural",
        "cherry",
        "flavor",
        "sugar",
        "free",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 3.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790544425157",
      "vsf_explanation": "Sugar-free chewable vitamin C avoids the sugar-vehicle downside of gummy formats. Chewable ascorbic acid can be enamel-erosive due to low pH — a rarely-labeled dental concern. Vitamin C evidence is well-established (Hemila & Chalker 2013 Cochrane). Held below Verified by chewable-acid enamel concern, unclear buffered vs plain form, and no third-party certification. Would move to Verified 70+ with buffered mineral-ascorbate form.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "soy-isoflavones-standardized-1",
      "title": "Soy Isoflavones - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/81f214d5-99bd-4019-8b8e-d01c235aa90f_large_42221ccf-63e2-4176-85e9-5eef730c5ec4.jpg?v=1787417252",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "soy",
        "isoflavones",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 17.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790544326853",
      "vsf_explanation": "Soy isoflavones for menopausal hot flashes (Taku 2012 meta-analysis). Would improve with 40% isoflavone standardization confirmed, ratio disclosure, and non-GMO soy source.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-st-johns-wort-1",
      "title": "Full Spectrum St. John's Wort",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/dc9b0c6b-a00a-4374-95cf-6ae70daed576_large_dc337754-f60a-45b0-9219-7f638b1deee2.jpg?v=1787417252",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "john",
        "wort",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 45,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 4.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790544556229",
      "vsf_explanation": "Unstandardized whole-herb St. John's Wort with the same CYP3A4/2C9/P-gp interaction burden as the standardized extract but without the hypericin dose consistency that underpins the Linde 2008 Cochrane evidence at 300mg TID. Would move to Verified 70+ with standardized extract at RCT dose plus prominent drug-interaction disclosure covering oral contraceptives, warfarin, immunosuppressants, and SSRIs.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "st-johns-wort-with-chamomile-and-bacopa-3-in-1-formula",
      "title": "St. John's Wort with Chamomile and Bacopa - 3-in-1 Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/13313c1c-747f-462b-a8db-16078273ca50_large_f72cc4ef-8a45-4810-9407-4713b1636826.jpg?v=1787417252",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "john",
        "wort",
        "with",
        "chamomile",
        "and",
        "bacopa",
        "formula",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 45,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 2.6,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790544588997",
      "vsf_explanation": "Combining St. John's Wort with chamomile and bacopa dilutes each active below its RCT-effective dose (St. John's Wort typically 900mg/day standardized; chamomile 220mg Matricaria apigenin-standardized in Amsterdam 2016; bacopa 300mg at 45-55% bacosides in Stough 2001). The St. John's Wort CYP-induction interaction risk remains and is chronically under-disclosed on multi-herb formulas. Would move to Verified 70+ only with per-active RCT-relevant doses (unlikely in one capsule) and prominent drug-interaction disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sunflower-lecithin-from-non-gmo-sunflower-seeds",
      "title": "Sunflower Lecithin from Non-GMO Sunflower Seeds",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9a932942-ec4e-4ef6-b075-24ab11329624_large_357ae1d8-c49e-43b2-92cc-b07e778152d5.jpg?v=1787417253",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sunflower",
        "lecithin",
        "from",
        "non",
        "gmo",
        "sunflower",
        "seeds",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 60
      },
      "price": 16.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790544621765",
      "vsf_explanation": "Sunflower lecithin as PC source, non-GMO by default. Modest PC evidence for liver and cognitive support. Would improve with % phosphatidylcholine standardization and organic certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "tart-cherry-1",
      "title": "Tart Cherry",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/87e2edfc-eca6-4c74-8672-cff58927249e_large_bfa58fb8-81d4-4464-9622-88203e14d5f7.jpg?v=1787417254",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tart",
        "cherry",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 15.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790544687301",
      "vsf_explanation": "Tart cherry (Montmorency) has modest RCT evidence for sleep quality via melatonin content (Losso 2018) and post-exercise recovery. No branded ingredient (CherryPure, Cheribundi) or anthocyanin standardization disclosed. Would move to Verified with named source and clinical-dose confirmation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "triple-magnesium-complex",
      "title": "Triple Magnesium Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a639a868-2574-4f01-bbdb-2c0d01eefcba_large_49bc2c6a-1cb1-43ea-bc4e-b3a27c05b312.jpg?v=1787417254",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "triple",
        "magnesium",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 64,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 15.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790544720069",
      "vsf_explanation": "Duplicate SKU of triple magnesium complex — citrate/oxide/aspartate blend. Oxide fraction has poor absorption (~4%, Walker 2003). Standard tier. Would move to Verified with all-chelated blend and Albion sourcing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "super-stress-b-complex-with-vitamin-c-1",
      "title": "Super Stress B-Complex with Vitamin C",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/de637011-8ec9-466b-ab03-a0ba62649aff_large_a2ff70ee-8383-4c37-b124-77a0f3a74d79.jpg?v=1787417254",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive",
        "mood",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "super",
        "stress",
        "complex",
        "with",
        "vitamin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 16.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790544752837",
      "vsf_explanation": "B-complex + vitamin C has modest evidence for perceived stress and cognitive-fatigue endpoints (Kennedy 2010 Psychopharmacology — Berocca RCT). 'Super Stress' branding likely uses synthetic non-methylated forms (folic acid, cyanocobalamin, pyridoxine HCl), inferior for MTHFR carriers (Obeid & Herrmann 2012) and with B6-neuropathy risk at higher chronic doses. Held below Verified by non-bioactive forms and mass-market QC.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-a",
      "title": "Vitamin A",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a698d1d0-797c-4fa7-a868-c76dc6300177_large_3edc27d2-c382-4ff7-9cd0-3177fb6f92d1.jpg?v=1787417255",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 12.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790545637573",
      "vsf_explanation": "Retinyl palmitate (typical mass-market form) has clear evidence for vision, immune, and epithelial support. Safety scored lower due to teratogenicity risk above 10000 IU/day in pregnancy (Rothman 1995 NEJM) and hepatic accumulation with chronic high dose; mass-market labels often underplay these. Held below Verified by unclear IU, no beta-carotene alternative offered, and pregnancy-warning gap.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pancreatin-4x-triple-strength",
      "title": "Pancreatin 4X - Triple Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/85210c49-6a66-4843-a50c-13dae08f483d_large_f3df7954-c8d5-4d20-bb84-b4c0b7cb7d3e.jpg?v=1787417255",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pancreatin",
        "triple",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 62,
        "sustainability": 45
      },
      "price": 27.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790545670341",
      "vsf_explanation": "Pancreatin 4X is a porcine pancreatic enzyme concentrate (lipase, protease, amylase) — legitimate for exocrine pancreatic insufficiency. Triple strength is a meaningful concentration. Would need enteric coating (acid-labile enzymes are destroyed in stomach) to reach clinical efficacy, plus USP-verified enzyme unit disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "triple-boron-complex",
      "title": "Triple Boron Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5cdbd3c8-fad2-485d-8466-643f81bed346_large_7ba733ae-81a6-4765-b139-e1de1b02c27c.jpg?v=1787417256",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "triple",
        "boron",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 14.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790546555077",
      "vsf_explanation": "Boron (typically 3-6mg) has modest evidence for bone mineral density, calcium retention, and free testosterone (Naghii 2011; Nielsen 1987). Blending three boron forms (citrate/aspartate/glycinate) is a common approach with limited head-to-head data. Standard tier — solid niche mineral, modest evidence base.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-true-cinnamon-featuring-ceylon-cinnamon",
      "title": "Full Spectrum True Cinnamon - Featuring Ceylon Cinnamon",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e96ff553-7008-49f0-a7bd-5be1e286ec02_large_11cbcc1d-9e55-4e6e-a316-8e89da0b5483.jpg?v=1787417257",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "true",
        "cinnamon",
        "featuring",
        "ceylon",
        "cinnamon",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 11.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790546587845",
      "vsf_explanation": "Ceylon (Cinnamomum verum) cinnamon has ~250× less coumarin than Cassia — a major safety advantage for daily use per EFSA coumarin TDI guidance. Modest glucose evidence per Allen 2013 meta-analysis. Species disclosure at label is a transparency win. Whole-herb without additional standardization limits precision. Would move to Verified 70+ with water-extract (Cinnulin PF-style) or defined MHCP-marker content.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-turmeric-1",
      "title": "Full Spectrum Turmeric",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a3bb1652-6285-4112-88da-0ed377105f47_large_26c58dd4-4c50-4478-bb63-92444e37f595.jpg?v=1787417258",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "turmeric",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 10.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790546620613",
      "vsf_explanation": "Third 'Full Spectrum Turmeric' SKU with the same evaluation as siblings — unstandardized whole-herb turmeric powder with structurally low systemic curcumin exposure. Reasonable as a food-adjacent spice supplement, poor as a curcumin-effect delivery vehicle.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "stevia-extract-powder-calorie-free",
      "title": "Stevia Extract Powder - Calorie Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/df140918-4b5e-4c9b-a048-8317516db1dc_large_89338f8e-2879-4b7b-bd35-a57863a045a7.jpg?v=1787417258",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "stevia",
        "extract",
        "powder",
        "calorie",
        "free",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 14.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790546653381",
      "vsf_explanation": "Stevia extract as a natural non-nutritive sweetener — GRAS-approved, blood-sugar neutral. Not a functional supplement per se but a functional food additive with reasonable safety profile. Would improve with steviol glycoside % (reb A vs stevioside) disclosure and organic sourcing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "valerian-root-liquid-extract-alcohol-sugar-free",
      "title": "Valerian Root Liquid Extract - Alcohol & Sugar Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9f2b2326-04ee-477a-b096-56829384218a_large_12bc0abd-4a67-4fad-b324-4e4860fa4bee.jpg?v=1787417259",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "valerian",
        "root",
        "liquid",
        "extract",
        "alcohol",
        "sugar",
        "free",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 62,
        "sustainability": 60
      },
      "price": 6.65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790547603653",
      "vsf_explanation": "Liquid valerian extract (glycerite, alcohol-free) - convenient for users who cannot swallow capsules, but glycerite extraction is generally less efficient than ethanol for valerenic acids. Standardization not disclosed. Same short-term-use guidance applies. Would move to Verified 70+ with disclosed valerenic-acid concentration per mL and per-lot testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-turmeric-2",
      "title": "Full Spectrum Turmeric",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/18bce00b-80b3-4f58-8bde-c0bd22500c3e_large_0315d331-d54d-46b1-bef5-ad92ab689a3e.jpg?v=1787417259",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "turmeric",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 5.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790547636421",
      "vsf_explanation": "'Full Spectrum' is Swanson's whole-herb-powder budget line — unstandardized, non-extracted turmeric root at ~2-5% native curcuminoids without a bioavailability carrier. With curcumin's ~1% oral bioavailability (Anand 2007), a whole-turmeric-powder capsule delivers a fraction of a milligram of systemic curcumin. Not autofail because whole spice is a legitimate consumption pattern, but sub-optimal for anyone targeting curcumin's clinical anti-inflammatory effects. Would move up substantially with any extraction, standardization, or piperine addition.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-turmeric-3",
      "title": "Full Spectrum Turmeric",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5dea24d9-a4f7-461d-975c-b5c4fba2a369_large_513babb6-f605-4da9-bc34-bc65de08e239.jpg?v=1787417259",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "turmeric",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 15.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790547669189",
      "vsf_explanation": "Duplicate 'Full Spectrum Turmeric' SKU — same profile: whole-herb powder, ~2-5% native curcuminoids, no piperine or phytosome carrier. Structurally under-delivers curcumin systemically versus C3 Complex + BioPerine or Meriva. Consumers seeking anti-inflammatory effects should choose a bioavailability-enhanced form.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ultimate-respiratory-defense-with-nac-and-quercetin",
      "title": "Ultimate Respiratory Defense with NAC and Quercetin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ba7974d4-cfae-41bb-a603-74159d0c2654_large_13cb84a4-bc70-4d21-af3f-164a85d8a54b.jpg?v=1787417259",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ultimate",
        "respiratory",
        "defense",
        "with",
        "nac",
        "and",
        "quercetin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 70,
        "manufacturing": 68,
        "safety": 66,
        "transparency": 65,
        "sustainability": 60
      },
      "price": 31.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790547767493",
      "vsf_explanation": "NAC + quercetin is a mechanistically coherent respiratory-support stack: NAC has real mucolytic evidence (Grandjean 2000 for chronic bronchitis) and quercetin has zinc-ionophore and mast-cell stabilization activity relevant to respiratory allergy. Held to top of Standard by the 'Ultimate' formulation likely including undisclosed extra herbs, no NAC source (AjiPure vs bulk) disclosed, and quercetin bioavailability limitation (plain vs EMIQ/phytosome). Watch nitroglycerin and immunosuppressant interactions with NAC. Would move to Verified 70+ with named AjiPure NAC + branded quercetin form.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "thyroid-glandular-thyroxin-free-formula",
      "title": "Thyroid Glandular - Thyroxin-Free Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/635dc755-f0b3-408e-b076-d78f6a511485_large_47294401-7ae2-412b-bf45-0fd98bb64260.jpg?v=1787417259",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "thyroid",
        "glandular",
        "thyroxin",
        "free",
        "formula",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 45,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 22.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790547734725",
      "vsf_explanation": "Bovine thyroid glandular products marketed for thyroid support — 'thyroxin-free' is a manufacturing claim that's difficult to independently verify, and residual T3/T4 contamination has been detected in glandular products (Kang 2015). Safety flag: potential for undisclosed thyroid hormone effects. Would need independent hormone-residue testing certification to score higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "time-released-c-1000-with-rose-hips",
      "title": "Time-Released C-1000 with Rose Hips",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33646456-d30e-4a0e-9c5b-6b3103ba0bec_large_1e6d75fe-e240-4d83-8ae6-eab2f0c31f53.jpg?v=1787417259",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "time",
        "released",
        "1000",
        "with",
        "rose",
        "hips",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 66,
        "transparency": 65,
        "sustainability": 52
      },
      "price": 24.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790547701957",
      "vsf_explanation": "Time-released 1000 mg ascorbic acid. Sustained-release is the appropriate delivery for gram-dose vitamin C given saturation kinetics. Cold-duration evidence at gram-level dosing per Hemila 2013. Would move to Verified 70+ with USP verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "turkey-rhubarb",
      "title": "Turkey Rhubarb",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/02595cf4-3455-488c-8dc4-5b697a1ad779_large_26d97124-4510-46e1-9d6e-625e34cf3c23.jpg?v=1787417260",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "turkey",
        "rhubarb",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 40,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790548717765",
      "vsf_explanation": "Turkey rhubarb (Rheum palmatum) is an anthraquinone-containing stimulant laxative. Same chronic-use dependency, electrolyte, and melanosis coli concerns as senna. Not appropriate for long-term use. Would need prominent short-term-use warning and non-laxative reframing to score higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "super-cayenne-with-ginger-rhizome-hawthorn-berry-lecithin",
      "title": "Super Cayenne - with Ginger Rhizome, Hawthorn Berry & Lecithin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f9b03c23-a30d-4898-8ab1-0c105f05355e_large_9e984639-9464-4a53-8cdb-acaf2d70a6af.jpg?v=1787417260",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "super",
        "cayenne",
        "with",
        "ginger",
        "rhizome",
        "hawthorn",
        "berry",
        "lecithin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 17.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790548750533",
      "vsf_explanation": "Traditional herbalist warming cardiovascular blend — cayenne, ginger, hawthorn and lecithin. Hawthorn carries the strongest evidence in this stack (Pittler 2008 Cochrane in mild heart failure); cayenne and ginger have circumstantial vasodilation/anti-inflammatory data but no dedicated formula-level trial. Cayenne can cause GI upset and interact with anticoagulants and antihypertensives. Would move to Standard 62+ with disclosed standardization percentages and per-ingredient mg, and clear interaction warnings.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "valerian-root",
      "title": "Valerian Root",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/668037b3-7442-4bff-ba77-8cd24b1c15a3_large_edd0da89-d475-4f86-9a01-5ace1fa85d2b.jpg?v=1787417260",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "valerian",
        "root",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 60
      },
      "price": 6.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790548783301",
      "vsf_explanation": "Whole-herb valerian root without standardization - valerenic acid content varies widely batch-to-batch, so the mixed but generally positive sleep-quality signal from Bent 2006 meta (which relied on standardized extracts) cannot be assumed here. Safety is favorable but characteristic valerian smell can be off-putting. Would move to Verified 70+ with valerenic-acid standardization and per-lot testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "turmeric-black-pepper-1",
      "title": "Turmeric & Black Pepper",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4c74258c-c895-4855-903e-d63a4dda37c3_large_7993ee16-8e08-4b2c-93b2-540ff1ddc5e3.jpg?v=1787417260",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "turmeric",
        "black",
        "pepper",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 60,
        "sustainability": 58
      },
      "price": 13.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790548816069",
      "vsf_explanation": "Turmeric plus black pepper follows the Shoba 1998 protocol logic — piperine at ~5 mg raises curcumin bioavailability roughly 20x. Whether this specific SKU replicates Shoba's absorption depends on whether the pepper component is BioPerine (95% piperine) or generic black pepper (~5-9% piperine). Held to mid-Standard by that ambiguity and by no curcuminoid standardization percentage in the title. Would move to Verified with named BioPerine plus 95% curcuminoids.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ultra-c-formula",
      "title": "Ultra C Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a3dc4933-55ac-47b7-8ecc-cbc685821573_large_f9ce3a5c-1b60-4038-92e7-7b4047722f23.jpg?v=1787417261",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ultra",
        "formula",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 12.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790548848837",
      "vsf_explanation": "Vitamin C blend at Swanson Ultra sub-brand — typically higher-tier formulation. Vitamin C at 500-1000mg has evidence for cold duration reduction (Hemila 2013). Would move to Verified with liposomal/Ester-C form option, buffered mineral ascorbate, and per-ingredient disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "triple-magnesium-complex-1",
      "title": "Triple Magnesium Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0d2fb6f5-0ea8-46fe-9d34-8c0e81bcf20d_large_48305351-d4f3-49a1-8f4a-10d6278ee9c3.jpg?v=1787417261",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "triple",
        "magnesium",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 64,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 10.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790548881605",
      "vsf_explanation": "Duplicate SKU of triple magnesium complex — typically citrate/oxide/aspartate blend. Oxide fraction has poor absorption (Walker 2003); citrate and aspartate carry the useful magnesium delivery. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "time-released-c-1000-with-rose-hips-2-pack",
      "title": "Time-Released C-1000 with Rose Hips - 2 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c55a9cf4-13a7-4f82-9eb6-5d82016e5a3b_large_c0a8082c-e41a-4d19-8475-72c71305ce15.jpg?v=1787417260",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "time",
        "released",
        "1000",
        "with",
        "rose",
        "hips",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 66,
        "transparency": 65,
        "sustainability": 52
      },
      "price": 31.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790548914373",
      "vsf_explanation": "Time-released 1000 mg ascorbic acid. Slow release improves absorption fraction beyond the ~200 mg single-dose saturation ceiling. 2-pack is packaging, not formulation. Would move to Verified 70+ with USP verification and dissolution testing disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "urinary-health-complex",
      "title": "Urinary Health Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5bd6d771-05c1-4f98-aed0-a151942a0d51_large_fe3ef93e-0a2e-4e7e-a5e4-b043fc3cc08b.jpg?v=1787417262",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "urinary",
        "health",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 18.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790548947141",
      "vsf_explanation": "Blended urinary support product — typically cranberry, D-mannose, uva ursi. Cranberry PAC and D-mannose have meaningful RCT evidence for UTI prevention (Kranjcec 2014 for mannose). Per-ingredient mg not disclosed in title — proprietary blend risk. Would improve with per-active mg disclosure and PAC mg standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "triple-magnesium-complex-2",
      "title": "Triple Magnesium Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/21731c40-cf7c-4d16-aac4-2a70c49479fa_large_d63a82b1-16ab-4661-81ca-3658bb8946a9.jpg?v=1787417262",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "triple",
        "magnesium",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 64,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 23.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790548979909",
      "vsf_explanation": "Triple magnesium complex — typically citrate + oxide + aspartate. Oxide fraction has poor absorption (~4%, Walker 2003) but adds mass; citrate and aspartate are better absorbed. Standard tier — cost-efficient repletion, not top formulation. Would move to Verified with all-chelated (glycinate/malate/citrate) blend.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "calcium-with-vitamins-d-k-3-in-1-formula",
      "title": "Calcium with Vitamins D & K - 3 in-1 Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6bac5b62-5d5d-4970-bc66-7963585be6e4_large_e70da8a3-7e4f-4418-a16b-6d23bd97db63.jpg?v=1787417262",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "calcium",
        "with",
        "vitamins",
        "formula",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 72,
        "manufacturing": 65,
        "safety": 70,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 6.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790549012677",
      "vsf_explanation": "Calcium + D3 + K addresses the isolated-calcium cardiovascular concern (Bolland 2015) — K2 in particular helps direct calcium to bone rather than arterial walls (Knapen 2013). This 3-in-1 approach is the clinically-forward way to supplement calcium. Verified tier — form disclosure (K1 vs K2-MK4 vs K2-MK7) would strengthen further. Would move higher with named K2-MK7, disclosed elemental Ca, and citrate over carbonate.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "stinging-nettles-leaf-liquid-extract-alcohol-sugar-free",
      "title": "Stinging Nettles Leaf Liquid Extract - Alcohol & Sugar Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/35ae5296-962c-42e1-b318-de7a1730f7ce_large_ecb3deba-6874-4357-8189-3e481728949b.jpg?v=1787417262",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "stinging",
        "nettles",
        "leaf",
        "liquid",
        "extract",
        "alcohol",
        "sugar",
        "free",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 66,
        "transparency": 60,
        "sustainability": 52
      },
      "price": 6.07,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790549045445",
      "vsf_explanation": "Nettle leaf (as opposed to root) is used for seasonal allergies (Mittman 1990 small RCT). Liquid extract offers dose flexibility and sub-lingual bioavailability. Alcohol/sugar-free is a positive for compliance. No marker standardization disclosed. Would move to Verified 70+ with a named freeze-dried leaf format (as in Mittman study) at studied dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "thyme-leaf",
      "title": "Thyme Leaf",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/aae0ebf1-0c5f-4583-8ce1-47cf676281fc_large_e4369495-4110-4250-8f4f-3c61f0a4be71.jpg?v=1787417262",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "thyme",
        "leaf",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 55,
        "sustainability": 52
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790549078213",
      "vsf_explanation": "Thyme (Thymus vulgaris) has traditional respiratory use and in-vitro antimicrobial activity from thymol. Combination trials for cough (Kemmerich 2007 thyme+ivy) exist but standalone-thyme evidence for meaningful endpoints is very thin. Whole-herb powder without thymol standardization delivers uncertain active dose. Would move to Standard 60+ with named thymol % and structured cough/immune trial support.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "triphala-with-amla-behada-harada",
      "title": "Triphala with Amla, Behada & Harada",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2e6c0bac-b371-4904-8e4b-78149487276b_large_bb37fd69-3c35-4e27-a851-568ab27a299f.jpg?v=1787417264",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "triphala",
        "with",
        "amla",
        "behada",
        "harada",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 6.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790549962949",
      "vsf_explanation": "Triphala (classical Ayurvedic 3-fruit blend of Amla, Bibhitaki, Haritaki) has preliminary evidence for gut motility, oral health, and mild antioxidant effects. Traditional Ayurvedic formulation. Would improve with tannin/polyphenol standardization and modern RCT dose targeting (500mg-1g).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "maximum-strength-l-arginine",
      "title": "Maximum Strength L-Arginine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f57db410-8fcf-46bf-a33b-82cf3c475d5b_large_5eb89abe-687e-4707-93eb-67e8f05e25a6.jpg?v=1787417265",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "maximum",
        "strength",
        "arginine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 66,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790550880453",
      "vsf_explanation": "\"Maximum Strength\" typically means a higher-per-cap L-arginine dose, which is useful given arginine's need for grams-per-day (3-6 g) to reach endothelial-function benefit (Schwedhelm 2008; Bode-Böger 2007). Held below Verified because pharma-grade sourcing is not confirmed, per-serving mg is not disclosed on the SKU, and L-citrulline co-formulation would be a smarter bioavailability play. Would move to Verified 70+ with named pharma-grade source (e.g., AjiPure) and citrulline co-formulation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "super-cayenne-with-ginger-rhizome-hawthorn-berry-lecithin-1",
      "title": "Super Cayenne - with Ginger Rhizome, Hawthorn Berry & Lecithin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b26a1fd0-802c-4625-b590-85b80a45244a_large_2f6f6be4-e855-44f7-a618-e7b45d704e3a.jpg?v=1787417264",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "super",
        "cayenne",
        "with",
        "ginger",
        "rhizome",
        "hawthorn",
        "berry",
        "lecithin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790550847685",
      "vsf_explanation": "This is a traditional herbalist \"warming\" cardiovascular blend — cayenne (capsaicin), ginger and hawthorn each have some human data (hawthorn is the strongest per Pittler 2008 Cochrane in mild heart failure) but the combined product has no dedicated RCT support. Cayenne can cause GI upset and interacts with anticoagulants. Would move to Standard 62+ with disclosed standardization (hawthorn procyanidins %, cayenne heat units), per-ingredient mg, and interaction warnings; unlikely to reach Verified without a formula-level trial.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sunflower-lecithin-powder-non-gmo",
      "title": "Sunflower Lecithin Powder - Non-GMO",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/005ebce2-8ba6-4381-9000-30f061dc57b4_large_d6980d00-cd9e-4a11-add5-98b5ad681f9b.jpg?v=1787417265",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sunflower",
        "lecithin",
        "powder",
        "non",
        "gmo",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 60
      },
      "price": 25.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790550913221",
      "vsf_explanation": "Sunflower lecithin is a good phosphatidylcholine source, allergen-friendly alternative to soy lecithin, non-GMO by nature. Modest cognitive/liver evidence for PC supplementation. Would improve with % phosphatidylcholine disclosure and organic certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "supreme-c-complex",
      "title": "Supreme C-Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f829ff4d-fa51-404b-9904-fa4a13ee4b95_large_d4defa56-c156-488f-8b5b-7669d6f3c56d.jpg?v=1787417265",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "supreme",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 11.05,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790550945989",
      "vsf_explanation": "Vitamin C complex — likely ascorbic acid with bioflavonoids/rutin/quercetin. Vitamin C has robust evidence for immune support at 500-1000mg (Hemila 2013 for cold duration). Bioflavonoid addition is a formulation plus. Would move to Verified with per-ingredient mg disclosure and buffered/liposomal form option.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "biotin-high-potency",
      "title": "Biotin - High Potency",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/27a8630e-abe9-4b0f-94b5-69ba702e1120_large_18bcf24f-3455-4084-8063-7bae33c57827.jpg?v=1787417266",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "biotin",
        "high",
        "potency",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 50,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 12.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790551863493",
      "vsf_explanation": "High-potency biotin (typically 5000-10000 mcg) has only weak/equivocal evidence for hair/nail outcomes outside of true deficiency (Patel 2017 review). High-dose biotin interferes with troponin, TSH, and other immunoassays (FDA Safety Communication 2017), a real safety concern rarely flagged on mass-market labels. Held at low-Standard by weak effect-size evidence and immunoassay interference risk without adequate warning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "simply-hydrate-electrolyte-hydration-mix-orange-1",
      "title": "Simply Hydrate Electrolyte Hydration Mix - Orange",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/019df95e-246f-722e-b815-90e1732b2585.jpg?v=1787417267",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "simply",
        "hydrate",
        "electrolyte",
        "hydration",
        "mix",
        "orange",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 10.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790551830725",
      "vsf_explanation": "Electrolyte hydration mix category — sodium/potassium/magnesium ratio matters for hydration efficacy per Maughan 2016. No electrolyte mg breakdown or sweetener specification disclosed in title. Would improve with 500mg+ sodium serving (LMNT-style) and clean sweetener disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "triple-magnesium-complex-powder",
      "title": "Triple Magnesium Complex Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/dd2dfdcb-301c-49cb-b339-b076b99ec4b2_large_2f815fb9-8bfb-40c6-8a64-62cbb3be882b.jpg?v=1787417268",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "triple",
        "magnesium",
        "complex",
        "powder",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 66,
        "formulation": 66,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 20.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790552027333",
      "vsf_explanation": "Triple magnesium complex typically blends citrate, oxide, and aspartate/malate. Blending citrate with cheaper oxide dilutes absorption quality — the citrate portion carries the workhorse absorption while oxide fills mass. Powder format allows flexible dosing. Standard tier upper end. Would move to Verified with all-chelated (glycinate/malate/citrate) blend and Albion sourcing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vinpocetine-triple-strength",
      "title": "Vinpocetine - Triple Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/72bc8c80-8598-4789-b93e-e7f8c5d057dd_large_c7f44571-8762-4ea6-a044-b57d35c4192c.jpg?v=1787417313",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vinpocetine",
        "triple",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 35,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 16.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790567329989",
      "vsf_explanation": "Vinpocetine (periwinkle-derived) has some cerebral blood flow evidence but the FDA issued a 2019 warning against its use in dietary supplements, and it's classified as a drug in EU/Australia. Not approved as a supplement in the US per FDA guidance. Pregnancy-teratogenic risk documented. Would require compliance with FDA guidance and complete removal from dietary supplement channel to score higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vinpocetine",
      "title": "Vinpocetine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1eff377a-bf48-4184-941c-3c7dd8908c91_large_0262edd8-216f-4fac-b730-60c800ac8a2e.jpg?v=1787417313",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vinpocetine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 35,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 11.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790568345797",
      "vsf_explanation": "Same FDA 2019 dietary supplement warning applies — vinpocetine is not permitted as a dietary supplement per FDA guidance, with documented pregnancy contraindication. Would require regulatory-status resolution to score higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-b12-with-folate-strawberry-flavor",
      "title": "Vitamin B12 with Folate - Strawberry Flavor",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9bead91f-d85c-40f2-93af-51abf327fa9b_large_dbaa3f1b-bf7b-40a0-9da3-f0a4da219857.jpg?v=1787417313",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "b12",
        "with",
        "folate",
        "strawberry",
        "flavor",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 7.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790568214725",
      "vsf_explanation": "B12+folate combined has clear homocysteine-lowering rationale (Homocysteine Lowering Trialists 2005). Absence of 'methyl'/'5-MTHF' language in title strongly suggests cyanocobalamin + folic acid, inferior forms for MTHFR carriers (Obeid & Herrmann 2012). Held below Verified by likely non-bioactive forms.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-b6-pyridoxine",
      "title": "Vitamin B6 Pyridoxine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/912cadc9-7b7e-471f-b791-42d641355126_large_a79769b7-baa5-497f-9867-4b670ea1cb34.jpg?v=1787417313",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "pyridoxine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 50,
        "manufacturing": 60,
        "safety": 48,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 10.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790568280261",
      "vsf_explanation": "Pyridoxine HCl is the non-activated B6 form; P-5-P is preferred for people with impaired phosphorylation. Long-term pyridoxine above ~100mg is linked to sensory peripheral neuropathy (dell'Aquila 2018, Vrolijk 2017) — a safety concern rarely prominently labeled on mass-market SKUs. Held at low-Standard by non-activated form and neuropathy risk gap.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "c-500-vitamin-c-with-rose-hips",
      "title": "C-500 - Vitamin C with Rose Hips",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b695d846-e6d2-4db4-b242-5900d37caaa9_large_bc28eaec-a05d-4c24-869d-b83b03f79aeb.jpg?v=1787417313",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "500",
        "vitamin",
        "with",
        "rose",
        "hips",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 13.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790568313029",
      "vsf_explanation": "500mg ascorbic acid + rose hips is a legitimate everyday vitamin C SKU with defensible dose vs Hemila & Chalker 2013 Cochrane immune protocols. Held below Verified by plain ascorbic acid form, unclear rose-hips standardization, and no third-party certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "c-1000-vitamin-c-with-rose-hips",
      "title": "C-1000 - Vitamin C with Rose Hips",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/244b6365-9c32-41ac-be94-9aeba49bfb5b_large_f996c2ac-b41b-45c1-a25e-c041cbbf9eed.jpg?v=1787417313",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "1000",
        "vitamin",
        "with",
        "rose",
        "hips",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 7.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790568247493",
      "vsf_explanation": "1000mg ascorbic acid is upper-range maintenance/immune-duration dosing (Hemila & Chalker 2013 Cochrane); rose hips contribute bioflavonoids. Single 1g doses of plain ascorbic acid saturate absorption and often cause GI upset. Held below Verified by non-buffered form, unclear rose-hips standardization, and no third-party certification. Would move to Verified 70+ with buffered/Ester-C form and split-dosing guidance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vanilla-and-coconut-lip-balm",
      "title": "Vanilla and Coconut Lip Balm",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d78d24d3-9f64-4e3c-86e8-e5a87cc5902f_large_6d45927b-5637-46e5-a88b-2adbb76afb2b.jpg?v=1787417313",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vanilla",
        "and",
        "coconut",
        "lip",
        "balm",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 1.92,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790568378565",
      "vsf_explanation": "Cosmetic lip balm — outside core biohacking supplement scope. Formulated well as a moisturizing balm but no functional actives, no SPF, no significant skin-health mechanism beyond occlusion. Would need SPF, therapeutic actives, or clear repair claims to score in a functional beauty category.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "squalane-oil-from-olive-oil",
      "title": "Squalane Oil from Olive Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/bbd98270-0c92-4495-b684-7cad7380879f_large_daf87e6d-e589-4378-9f2a-63f0254215da.jpg?v=1787417313",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "squalane",
        "oil",
        "from",
        "olive",
        "oil",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 16.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790568509637",
      "vsf_explanation": "Olive-derived squalane is a clean, non-comedogenic emollient with real barrier-function evidence in topical skincare. Sourcing (olive vs shark) is a positive sustainability and ethics differentiator. Would improve with organic olive certification and stability packaging.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "c-1000-vitamin-c-powder-with-rose-hips",
      "title": "C-1000 Vitamin C Powder with Rose Hips",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8fe6984f-a267-485f-8003-ed46221a6fd2_large_8a2d27fc-b9aa-4a4a-8e2c-68ba20d524d1.jpg?v=1787417313",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "1000",
        "vitamin",
        "powder",
        "with",
        "rose",
        "hips",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 9.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790568411333",
      "vsf_explanation": "Powder form allows dose-flexible titration (helpful for GI-sensitive users) but delivers plain ascorbic acid, not buffered ascorbate. Vitamin C at 1g has strong immune-duration evidence (Hemila & Chalker 2013 Cochrane). Held below Verified by non-buffered form and unclear rose-hips standardization. Would move to Verified 70+ with buffered mineral-ascorbate form and disclosed rose-hips vitamin C contribution.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-b1-thiamin",
      "title": "Vitamin B1 Thiamin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/96dd9446-4067-4d5e-9894-a95cb186d47c_large_d027bfc3-ec70-4fbb-b864-9399dd148baf.jpg?v=1787417313",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "thiamin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 19.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790568444101",
      "vsf_explanation": "Thiamine HCl or mononitrate is functional but not fat-soluble; benfotiamine is preferred for peripheral neuropathy and diabetic complications due to superior bioavailability (Stracke 2008). Plain thiamine has strong evidence for correcting Wernicke-Korsakoff and alcohol-related deficiency at high doses. Held below Verified by non-fat-soluble form choice for the target biohacker audience. Would move to Verified 70+ with benfotiamine reformulation and clear mg dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-b12-cyanocobalamin",
      "title": "Vitamin B12 Cyanocobalamin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ab05617b-ace3-43e6-9995-fd0bf92096f8_large_54e07c79-a9ba-4e02-bf22-9eeb01b36cab.jpg?v=1787417313",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "b12",
        "cyanocobalamin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 7.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790568476869",
      "vsf_explanation": "Cyanocobalamin corrects most B12 deficiencies but is a non-activated form requiring methylation; methylcobalamin/hydroxycobalamin are preferred for methylation and neurological support (Zhang 2013). Held below Verified by non-bioactive form choice.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-d2-and-d3-complex",
      "title": "Vitamin D2 and D3 Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1cb7f7c8-d16a-4d19-9308-e5f1b26c4b41_large_cb4fd660-a802-4d00-aa4d-ff02867dd788.jpg?v=1787417313",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "and",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 11.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790568542405",
      "vsf_explanation": "Combining D2 (ergocalciferol) with D3 (cholecalciferol) is atypical and not clearly beneficial — D3 raises serum 25(OH)D more efficiently and durably than D2 (Tripkovic 2012 AJCN meta-analysis), so adding D2 provides no advantage and may slightly dilute D3 efficacy. Held below Standard-mid by inferior form choice. Would move up only if reformulated as D3-only or if evidence emerges supporting D2/D3 combined dosing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "c-1000-vitamin-c-with-rose-hips-1",
      "title": "C-1000 - Vitamin C with Rose Hips",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c2fe1db3-be75-4cab-93f9-4fed8e88bd30_large_c73e0062-f8a9-4bb3-9859-a11359ea614c.jpg?v=1787417313",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "1000",
        "vitamin",
        "with",
        "rose",
        "hips",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790568575173",
      "vsf_explanation": "1000mg ascorbic acid is upper-range maintenance/immune-duration dose (Hemila & Chalker 2013 Cochrane). Plain ascorbic acid at 1g saturates absorption and can cause GI upset. Held below Verified by non-buffered form, unclear rose-hips standardization, and no third-party certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-d3-gummies-strawberry",
      "title": "Vitamin D3 Gummies - Strawberry",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b601ce3d-baee-4545-a392-19531ac1b18a_large_66786858-067f-4793-a9af-af36850e1349.jpg?v=1787417313",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "gummies",
        "strawberry",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 50,
        "manufacturing": 58,
        "safety": 58,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 16.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790568607941",
      "vsf_explanation": "Gummy vitamin D3 typically delivers only 1000-2500 IU per serving in a matrix of added sugars and syrups; content variance vs label is well documented in gummy formats (Crawford 2017). D3 evidence itself is strong (Martineau 2017 BMJ), but the gummy delivery format is a nutritional compromise for the target biohacker audience and creates over-consumption risk from candy-like appearance/taste. Held at low-Standard by delivery format concerns and likely low IU.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-uva-ursi-leaf",
      "title": "Full Spectrum Uva Ursi Leaf",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/691011ab-9949-458c-bcf2-4bc735f6e28f_large_41fa2c57-b98a-4dae-9df6-41bcfaf42348.jpg?v=1787417314",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "uva",
        "ursi",
        "leaf",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 45,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 13.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790568673477",
      "vsf_explanation": "Uva ursi (arbutin) has traditional use for UTI with limited modern RCT evidence. Safety flag: hydroquinone (arbutin metabolite) — EMA limits use to <1 week, contraindicates in pregnancy/lactation/pediatrics due to potential hepatotoxicity/carcinogenicity concerns. Would need duration/contraindication warnings and arbutin standardization to score higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "c-500-with-rose-hips",
      "title": "C-500 with Rose Hips",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5824abf4-fbd5-46cd-86d6-4aeeb0a51286_large_6c56ab29-e288-41de-b869-ca1ed8ea2a3a.jpg?v=1787417314",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "500",
        "with",
        "rose",
        "hips",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 66,
        "transparency": 65,
        "sustainability": 52
      },
      "price": 9.53,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790569132229",
      "vsf_explanation": "500 mg ascorbic acid with rose hips. Well within absorbable single-dose range. Standard immediate-release ascorbic acid. Would move to Verified 70+ with sustained-release or Ester-C format and USP verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "womens-multi-hormone-support",
      "title": "Women's Multi +Hormone Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3e8df0bc-2cd7-488f-a7d1-9634a532b8c9_large_697cdbde-ddc7-403a-98ce-1eb5b14b8214.jpg?v=1787417316",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "women",
        "multi",
        "hormone",
        "support",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 12.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790570049733",
      "vsf_explanation": "Women's multivitamin with hormone-support botanical add-ins. Multivitamin coverage has value (Gaziano 2012 PHS II) but hormonal botanicals (chaste tree, DIM, black cohosh) are typically under-dosed in multi formulas relative to monograph (chaste tree needs ~40mg standardized per Loch 2000). Key formulation flags: folate form (5-MTHF preferred), iron form, and iodine adequacy. Would move to Verified 70+ with 5-MTHF, botanicals at monograph doses with standardization disclosed, and third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-e-cream",
      "title": "Vitamin E Cream",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a473d0f7-f271-44e1-a00e-d4f41214da14_large_a3801c62-eac7-417e-81db-04507a5d91c9.jpg?v=1787417316",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "cream",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 11.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790570016965",
      "vsf_explanation": "Topical vitamin E (typically dl-alpha-tocopherol acetate) has surprisingly weak clinical evidence for scar or wound outcomes — Baumann & Spencer 1999 famously showed no benefit and worsened cosmesis in surgical scars. It functions primarily as an antioxidant emollient. Held at low-Standard by weak clinical evidence for the marketed use-cases and unclear tocopherol form/concentration. Would only move up with mixed-tocopherol composition and evidence-based positioning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "e-400",
      "title": "E-400",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/af538ce5-fb26-41fa-8209-37827f62f766_large_b9be93c8-e2c4-4427-83bc-0dfbf202e636.jpg?v=1787417316",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "400",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 10.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790570082501",
      "vsf_explanation": "Vitamin E 400 IU as isolated tocopherol — likely dl-alpha given no form specification. Isolated alpha-tocopherol has null-to-negative outcomes in major CVD prevention trials. Would improve with mixed-tocopherols form as in the sibling SKUs.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "e-200-mixed-tocopherols",
      "title": "E-200 Mixed Tocopherols",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7993f279-89cd-43ad-80ed-e5df987dcdf8_large_ed4cabee-ce6b-4738-bee6-5f75e75c23fb.jpg?v=1787417318",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "200",
        "mixed",
        "tocopherols",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 66,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 8.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790571000005",
      "vsf_explanation": "E-200 mixed tocopherols — same specification as the sibling SKU. Moderate everyday dose in preferred form. Would improve with tocotrienol addition.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "e-400-mixed-tocopherols",
      "title": "E-400 Mixed Tocopherols",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cb250584-7118-4e25-b21e-c626a0f2f522_large_7306347f-bcae-487e-8a55-bcef0aff0355.jpg?v=1787417318",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "400",
        "mixed",
        "tocopherols",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 35.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790571098309",
      "vsf_explanation": "E-400 mixed tocopherols — same specification as the sibling SKU. Common daily dose within safety envelope. Would improve with tocotrienol addition and % isomer disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "wrinkle-cream-with-dmae-coq10",
      "title": "Wrinkle Cream With DMAE & CoQ10",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c3833753-7a23-4d9a-b44b-938a6d63e8b8_large_0dc85a82-9fe3-488a-a675-56632aeea4a3.jpg?v=1787417318",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wrinkle",
        "cream",
        "with",
        "dmae",
        "coq10",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 13.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790571065541",
      "vsf_explanation": "Topical wrinkle cream, not an ingestible biohacking supplement. Topical DMAE has weak evidence for short-term firmness perception and topical CoQ10 has minimal RCT support for wrinkle reduction. Marked as out-of-scope; if reclassified as cosmetic-only the scoring rubric here does not apply. Recommend removing from the supplement scoring universe or moving to a separate cosmetic evaluation framework.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "time-released-c-500-with-rose-hips",
      "title": "Time-Released C-500 with Rose Hips",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6db10015-fdd9-4e2b-8a02-eacb82d0c13e_large_75b0dbb5-8135-4479-b03d-9e02ddefda48.jpg?v=1787417320",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "time",
        "released",
        "500",
        "with",
        "rose",
        "hips",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 66,
        "transparency": 65,
        "sustainability": 52
      },
      "price": 14.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790571131077",
      "vsf_explanation": "Time-released 500 mg ascorbic acid is a reasonable formulation upgrade — vitamin C plasma saturation caps around 200 mg per single dose, so slow release improves total absorption fraction. Rose hips add small natural bioflavonoid content. Would move to Verified 70+ with USP verification and confirmed sustained-release dissolution testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "e-400-mixed-tocopherols-1",
      "title": "E-400 Mixed Tocopherols",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1d8c726e-e792-4db2-95d1-fbde923d35c8_large_328480ea-7907-4530-ba72-01bcb9ec5458.jpg?v=1787417320",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "400",
        "mixed",
        "tocopherols",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 17.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790571163845",
      "vsf_explanation": "400 IU mixed tocopherols is a common daily dose still within Miller 2005 safety envelope. Would move to Verified with tocotrienol addition and per-isomer % disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "yerba-mate-1",
      "title": "Yerba Mate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2d5f41b1-eff8-471f-a20f-59e4b018eaeb_large_bd58dfc5-3d8c-410f-b1a7-024e882fc420.jpg?v=1787417320",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "yerba",
        "mate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 50,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 4.18,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790571196613",
      "vsf_explanation": "Yerba mate is a caffeine-containing South American beverage herb with preliminary metabolic evidence (Alkhatib 2014). Safety flag: aromatic amines in traditionally smoke-cured mate have been linked to esophageal cancer in observational studies. No smoke-free processing confirmation. Would need cold-cured/organic sourcing disclosure and caffeine content per capsule to score higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-d3-higher-potency-1",
      "title": "Vitamin D3 - Higher Potency",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7348379e-b416-4e13-820b-880d32e069a8_large_1a6ef492-66ae-4288-b388-aed9985dcffb.jpg?v=1787417320",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "higher",
        "potency",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 68,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 4.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790571294917",
      "vsf_explanation": "Cholecalciferol at 'Higher Potency' typically indicates 2000-5000 IU, a strong maintenance-to-mild-correction range supported by Martineau 2017 BMJ for immune and Autier 2014 for skeletal outcomes. Held below Verified by lack of K2 cofactor, no third-party certification, and vague IU labeling in the title. Would move to Verified 70+ with K2 MK-7 pairing and NSF/USP certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-k1",
      "title": "Vitamin K1",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3d51423b-05be-4af4-9b15-241a09f2cc7c_large_526915ab-d546-4c0e-a3c2-17d6dcca744c.jpg?v=1787417320",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 66,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 10.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790571262149",
      "vsf_explanation": "Vitamin K1 (phylloquinone) supports hepatic clotting-factor gamma-carboxylation but has short half-life (~1-2h) and modest arterial/bone effects compared to K2 (MK-7). K1 is contraindicated with warfarin therapy — a strong safety-flag concern rarely prominently displayed on mass-market labels. Held below Verified by inferior form vs K2 for vascular/bone endpoints and drug-interaction warning gap. Would move to Verified 70+ with prominent warfarin warning and K2-MK7 co-formulation option.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "original-whey-protein-powder-vanilla",
      "title": "Original Whey Protein Powder - Vanilla",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2725b0ca-2ad6-4b15-885d-53b7611a55dc_large_2c5a867a-353e-4fdc-a09a-18ab79055813.jpg?v=1787417320",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "original",
        "whey",
        "protein",
        "powder",
        "vanilla",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 52.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790571327685",
      "vsf_explanation": "Baseline commodity whey protein — evidence for whey at 20-40g post-workout is strong (Morton 2018 meta), but this SKU carries no grass-fed sourcing, no rBGH-free claim, and no confirmed isolate vs concentrate designation at title level. Standard-tier commodity whey. Would move to Standard 65+ with confirmed isolate base and grass-fed sourcing, and Verified with published heavy-metal testing plus NSF certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-b12-cyanocobalamin-1",
      "title": "Vitamin B12 Cyanocobalamin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/31e7bfd4-9f7a-4f80-8113-feae33c38491_large_e83fec8e-c594-414b-8156-387758439c62.jpg?v=1787417320",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "b12",
        "cyanocobalamin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 13.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790571360453",
      "vsf_explanation": "Cyanocobalamin is stable, cheap, and clinically effective for correcting most B12 deficiencies, but it requires methylation to the bioactive form and delivers a small cyanide radical (nutritionally trivial in healthy adults, but a concern in smokers or Leber's optic neuropathy carriers). Methylcobalamin or hydroxycobalamin is preferred for MTHFR carriers and neurological support (Zhang 2013). Held below Verified by non-bioactive form choice, which pushes it into the low-Standard range for the vitamin-forward user. Would move to Verified 70+ if reformulated as methyl- or hydroxycobalamin.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "c-1000-with-rose-hips",
      "title": "C-1000 with Rose Hips",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/22254f7a-bf2d-4765-b9cd-5116ef7de1b3_large_4189c05b-227e-4772-a987-9759e19c21d8.jpg?v=1787417321",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "1000",
        "with",
        "rose",
        "hips",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 65,
        "sustainability": 52
      },
      "price": 9.2,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790572277957",
      "vsf_explanation": "1000 mg ascorbic acid with rose hips as a natural bioflavonoid carrier. Vitamin C at 1 g/day has evidence for mild cold-duration reduction (Hemila 2013 Cochrane, ~8% shorter duration) and antioxidant support. Ascorbic acid form is fine but buffered/liposomal forms may be gentler for GI. Would move to Verified 70+ with liposomal or Ester-C form and USP verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-b12-cyanocobalamin-2",
      "title": "Vitamin B12 Cyanocobalamin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/136a7a53-1e91-4b47-8e6c-b912ae36ba30_large_c58b544a-0f29-4c85-840a-a78496a5f22e.jpg?v=1787417321",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "b12",
        "cyanocobalamin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 3.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790572310725",
      "vsf_explanation": "Cyanocobalamin corrects most B12 deficiencies but is a non-activated form requiring conversion; methylcobalamin/hydroxycobalamin are preferred for methylation and neurological support (Zhang 2013). Held below Verified by non-bioactive form. Would move to Verified 70+ with methyl- or hydroxy-form reformulation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "e-1002",
      "title": "E-1000",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3ed7aa26-16e6-42da-b941-6cf4b97574f5_large_a421e321-d32e-432c-8231-231c17821525.jpg?v=1787417321",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "1000",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 45,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 12.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790572376261",
      "vsf_explanation": "Vitamin E 1000 IU as isolated alpha-tocopherol (likely dl-alpha given no form specification) at a dose above the Miller 2005 meta-analysis mortality threshold. Not recommended for chronic use at this dose without medical guidance. Would need mixed-tocopherols form and dose-ceiling warning to score higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-c-cream",
      "title": "Vitamin C Cream",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/24f28f1c-7ee8-4557-80f0-b8368b8c04fb_large_e7318f50-2daa-4d8c-9cf5-a323201b67fb.jpg?v=1787417321",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "cream",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 5.75,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790572343493",
      "vsf_explanation": "Topical vitamin C (L-ascorbic acid at 10-20% at pH <3.5) has evidence for photoaging and pigmentation (Pinnell 2001, Farris 2005). However, most mass-market vitamin C creams use unstable ascorbic acid or lower-efficacy derivatives (magnesium ascorbyl phosphate, ascorbyl palmitate) without concentration or pH disclosure. Held below Verified by unclear form, concentration, pH, and stability. Would move to Verified 70+ with L-ascorbic acid 15-20% at low pH or a validated derivative like tetrahexyldecyl ascorbate.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "womens-daily-probiotic-prebiotic-fos",
      "title": "Women's Daily Probiotic + Prebiotic FOS",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8130802d-7041-4c88-8a2d-8cda9dcfe79c_large_25cf3c75-fa14-4e2b-a087-4545ea0587a9.jpg?v=1787417321",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "women",
        "daily",
        "probiotic",
        "prebiotic",
        "fos",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 39.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790572409029",
      "vsf_explanation": "Women's-targeted synbiotic. Urogenital-specific probiotic evidence is anchored to GR-1 and RC-14 (Reid 2003) which are not confirmed in the title. Adding FOS is directionally reasonable. Would move to Verified with named urogenital strains and CFU-at-expiration.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "extra-strength-d3-k2-5-000-iu-100-mcg",
      "title": "Extra Strength D3 & K2 - 5,000 IU & 100 mcg",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/907c4703-a677-4495-a0e9-128ac926371b_large_80792e18-c18f-4d1d-935e-2c1a3b796e37.jpg?v=1787417321",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "extra",
        "strength",
        "000",
        "100",
        "mcg",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 66,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 18.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790572441797",
      "vsf_explanation": "D3 5000 IU + K2 100 mcg is a common therapeutic-range combination for D-insufficient users, well within Endocrine Society upper limits. Doses clearly disclosed. Would move to Verified 70+ with K2 as MenaQ7 MK-7 confirmed and third-party assay documentation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-a-2-pack",
      "title": "Vitamin A - 2 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/114696ba-b178-43b8-a7c6-ca5e64baee2d_large_3bd94c3f-f911-4c4c-a4a4-c3f1584ba515.jpg?v=1787417321",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 17.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790572507333",
      "vsf_explanation": "Vitamin A (typically retinyl palmitate at 10000 IU per softgel from mass-market brands) has clear evidence for vision, immune, and epithelial support. Safety scored lower due to teratogenicity risk in pregnancy (>10000 IU/day, per Rothman 1995 NEJM) and hepatic accumulation with chronic high dose; retinyl-form vitamin A requires clear pregnancy warnings that mass-market labels often understate. Held below Verified by unclear IU, no beta-carotene alternative offered, and inadequate pregnancy-warning framing typical of mass market. Would move to Verified 70+ with explicit teratogenicity warning and beta-carotene co-formulation option.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-b12-with-folate-strawberry-flavor-1",
      "title": "Vitamin B12 with Folate - Strawberry Flavor",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e83d03ff-8eb3-4a5b-8c17-93189f810fda_large_52fb5ee0-5550-4b44-9bac-36fc7879a6a4.jpg?v=1787417321",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "b12",
        "with",
        "folate",
        "strawberry",
        "flavor",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 15.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790572474565",
      "vsf_explanation": "B12+folate combined pairing has clear homocysteine-lowering data (Homocysteine Lowering Trialists 2005) and neurological support rationale. Form choice matters heavily: this SKU likely uses cyanocobalamin + folic acid (title lacks 'methyl' or '5-MTHF' cues), which are inferior for MTHFR carriers (Obeid & Herrmann 2012). Held below Verified by likely non-bioactive forms and unclear mcg dosing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "e-200-mixed-tocopherols-1",
      "title": "E-200 Mixed Tocopherols",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a3e177b1-b25e-4c4f-9c61-7abb0cbd15df_large_216f0a83-26f8-4052-9d1f-450629eb61c2.jpg?v=1787417322",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "200",
        "mixed",
        "tocopherols",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 66,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 15.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790572540101",
      "vsf_explanation": "Vitamin E 200 IU with mixed tocopherols is a moderate everyday dose in the preferred form. Mixed tocopherols provide beta/gamma/delta isomers absent from isolated alpha-tocopherol. Would move to Verified with % of each tocopherol disclosed and tocotrienol addition.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-c-gummies-orange",
      "title": "Vitamin C Gummies - Orange",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2a359ddb-8ab9-4885-93c0-8a5526e16e72_large_3a3f6fc6-8bfe-4a29-b946-7eabb8605b18.jpg?v=1787417323",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "gummies",
        "orange",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 50,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 10.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790573523141",
      "vsf_explanation": "Gummy vitamin C typically delivers only 100-250 mg per serving in a matrix of added sugars (or sugar alcohols) and glucose syrup, and gummies are prone to under-declaration and label-vs-content variance (Crawford 2017 study of gummy multivitamin overages). Vitamin C evidence itself is strong (Hemila & Chalker 2013), but the delivery format is a nutritional compromise. Held at low-Standard by sugar-vehicle concerns, likely low dose, and confectionery-consumption-pattern risk (over-consumption).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamins-a-d",
      "title": "Vitamins A & D",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/56a7e89c-3570-4b2f-be5b-b40c09f19982_large_4a8a2215-1da8-4421-888c-e4db49512d42.jpg?v=1787417323",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamins",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 10.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790573555909",
      "vsf_explanation": "Classic Vitamin A + D combination, historically fish liver oil-based. Doses not disclosed in title — critical for A and D because chronic high-dose retinol (>10,000 IU) carries hepatotoxicity and teratogenic risk. Would improve with clear IU disclosure for both nutrients and form specification (retinyl palmitate vs beta-carotene).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-d3",
      "title": "Vitamin D3",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/83b93844-8eca-42cd-9c17-7b889ffa13fd_large_e1647b1b-356b-4aa8-9eed-e5ac921a5166.jpg?v=1787417323",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 5.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790573588677",
      "vsf_explanation": "Cholecalciferol is the preferred D form with strong Martineau 2017 BMJ meta-analysis support for immune-respiratory benefit and general skeletal endpoints. Held below Verified by generic naming without IU disclosure, no K2 cofactor, and standard mass-market QC. Would move to Verified 70+ with clear IU dose, K2 pairing, and third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-b-125-complex-higher-potency",
      "title": "Vitamin B-125 Complex - Higher Potency",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1fd62a55-6df3-44ec-bd28-fce8d6240314_large_271e1767-b8e2-4fae-b1c1-a04a6d751c71.jpg?v=1787417323",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "125",
        "complex",
        "higher",
        "potency",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 38.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790573654213",
      "vsf_explanation": "B-125 delivers ~125mg per B vitamin — high-dose synthetic B-complex format. Almost certainly uses cyanocobalamin and folic acid rather than methylated forms, inferior for MTHFR carriers (Obeid & Herrmann 2012). Chronic 125mg pyridoxine (as B6 HCl) carries peripheral-neuropathy risk (dell'Aquila 2018) that mass-market labels rarely warn about. Held below Verified by non-bioactive forms and B6 neuropathy risk.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "c-1000-vitamin-c-with-rose-hips-2",
      "title": "C-1000 - Vitamin C with Rose Hips",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d647c660-728d-42af-b8d3-31824c0131c9_large_35dc56fe-5949-4c54-b0b4-36de52e3b5f6.jpg?v=1787417324",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "1000",
        "vitamin",
        "with",
        "rose",
        "hips",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 19.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790573686981",
      "vsf_explanation": "1000mg ascorbic acid is at the upper end of studied maintenance/immune-duration protocols (Hemila & Chalker 2013 Cochrane), with rose hips contributing extra bioflavonoids. Note that plain ascorbic acid at 1g single doses saturates absorption and often causes GI upset in sensitive users. Held below Verified by non-buffered form, unclear rose-hips standardization, and no third-party certification. Would move to Verified 70+ with buffered/Ester-C form and split dosing guidance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-d3-1",
      "title": "Vitamin D3",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d3c7d43f-2b14-4bb3-aa11-7af22e63dd1c_large_a5eb9cfc-d670-4194-bfc0-48dec8a436f5.jpg?v=1787417324",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 5.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790574571717",
      "vsf_explanation": "Cholecalciferol is the preferred D form (vs D2), with strong evidence for skeletal and respiratory/immune outcomes (Martineau 2017 BMJ, Autier 2014). Generic 'Vitamin D3' title provides no dose information, which is a transparency issue for consumers matching maintenance vs correction protocols. Held below Verified by opaque IU from title, absence of K2 pairing, and no third-party certification. Would move to Verified 70+ with explicit IU disclosure, K2 pairing, and independent COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "c-500-vitamin-c-with-rose-hips-1",
      "title": "C-500 - Vitamin C with Rose Hips",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7d2c28ea-d380-4267-8c90-7e05e3719d0d_large_5a9c3669-bf3b-463f-b34f-816da8afbc18.jpg?v=1787417325",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "500",
        "vitamin",
        "with",
        "rose",
        "hips",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 19.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790574604485",
      "vsf_explanation": "500mg ascorbic acid is a reasonable maintenance dose and rose hips contribute additional bioflavonoids and a small amount of native vitamin C. Vitamin C evidence for immune duration is well established (Hemila & Chalker 2013 Cochrane). Held below Verified by plain ascorbic acid (not buffered or liposomal), unclear rose-hips standardization, and no third-party certification. Would move to Verified 70+ with buffered ascorbate form and standardized rose-hips content.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "c-500-vitamin-c-with-rose-hips-2",
      "title": "C-500 - Vitamin C with Rose Hips",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e8da633c-3c7c-4aa0-bf52-83160b9908a1_large_916726a4-913c-4f45-ad22-486477c26cac.jpg?v=1787417325",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "500",
        "vitamin",
        "with",
        "rose",
        "hips",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 10.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790574637253",
      "vsf_explanation": "500mg ascorbic acid plus rose hips is a legitimate everyday vitamin C SKU with defensible dose vs studied immune protocols (Hemila & Chalker 2013 Cochrane). Held below Verified by plain (non-buffered, non-liposomal) form, unclear rose-hips standardization, and no third-party certification. Would move to Verified 70+ with buffered ascorbate or Ester-C form and disclosed rose-hips vitamin C content.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vegan-collagen-builder-featuring-dermaval",
      "title": "Vegan Collagen Builder - Featuring Dermaval",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2722f7c3-a4ab-4503-bd95-ebae7bc302e8_large_32aa2c02-53d1-4317-bcb2-98d5f366ec64.jpg?v=1787417325",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vegan",
        "collagen",
        "builder",
        "featuring",
        "dermaval",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 66,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 64,
        "sustainability": 62
      },
      "price": 17.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790574670021",
      "vsf_explanation": "'Vegan collagen builder' with Dermaval (a Nexira polyphenol blend from fruits/vegetables) — Dermaval has small brand-sponsored data (Gendrot 2020) suggesting anti-glycation and collagenase-inhibition, not direct collagen synthesis proof. Marketing framing overstates: no ingested nutrient literally 'builds' collagen the way hydrolyzed peptides supply the substrate. Held below Verified by evidence being brand-sponsored and thin vs. bovine/marine collagen peptides which have stronger independent RCT support. Would move to Verified 70+ with independent human RCTs on Dermaval.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-b6-pyridoxine-1",
      "title": "Vitamin B6 Pyridoxine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1573bd47-9dac-45bd-8830-4862258f7c61_large_96dfe5eb-1726-4081-be88-1741d8e92e10.jpg?v=1787417325",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "pyridoxine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 50,
        "manufacturing": 60,
        "safety": 48,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790574735557",
      "vsf_explanation": "Pyridoxine HCl is the standard but non-activated B6 form; P-5-P (pyridoxal-5-phosphate) is preferred for individuals with impaired phosphorylation and for methylation support. Long-term pyridoxine at doses above ~100mg is associated with sensory peripheral neuropathy (Dell'Aquila 2018, Vrolijk 2017), a safety concern rarely flagged prominently on labels. Held at low-Standard by non-activated form and peripheral-neuropathy risk. Would move to Verified 70+ if reformulated as P-5-P and paired with a clear neuropathy warning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-b-125-complex-higher-potency-1",
      "title": "Vitamin B-125 Complex - Higher Potency",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f03053df-6fe2-4f16-953a-f633414344e4_large_85519b67-cc89-4584-85f9-8cab2710196b.jpg?v=1787417326",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "125",
        "complex",
        "higher",
        "potency",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 24.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790574866629",
      "vsf_explanation": "B-125 refers to ~125mg per B vitamin — a high-dose synthetic B-complex format popular in classical formulations. Delivers meaningful B1/B2/B3/B5/B6 nutrient content but almost certainly uses cyanocobalamin and folic acid rather than methylated forms, which are inferior for MTHFR carriers (Obeid & Herrmann 2012). Vitamin B6 at these doses over months can cause peripheral neuropathy (dell'Aquila 2018), a safety concern rarely flagged on labels. Held below Verified by non-bioactive forms and B6 peripheral-neuropathy risk without prominent warning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "riboflavin-vitamin-b2",
      "title": "Riboflavin Vitamin B2",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/74225822-3008-490f-b5da-cde0a8c480f7_large_026729e2-2baa-43a9-b316-e70cc6f22d4d.jpg?v=1787417328",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "riboflavin",
        "vitamin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 66,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790575751365",
      "vsf_explanation": "Riboflavin has evidence for migraine prophylaxis at 400mg (Schoenen 1998 Neurology) and general mitochondrial cofactor function. Plain riboflavin (vs riboflavin-5-phosphate) requires phosphorylation which may be limited in some populations. Held below Verified by non-activated form and unclear mg from title (typical Swanson SKU is 100mg — below Schoenen protocol). Would move to Verified 70+ with 400mg dose disclosure or reformulation to R-5-P (which Swanson already sells separately).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamins-d3-k2-2-000-iu-75-mcg",
      "title": "Vitamins D3 & K2 - 2,000 IU & 75 mcg",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/086e4a95-85f4-418e-98a7-9c9e001f3b6d_large_0efa43e9-082b-42ae-90da-f13fe17e543c.jpg?v=1787417375",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamins",
        "000",
        "mcg",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 15.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790591086789",
      "vsf_explanation": "D3 2000 IU with K2 75 mcg is a well-balanced everyday dose combination. Doses are clearly disclosed in the title — real transparency positive. Would move to Verified 70+ with K2 as MK-7 form confirmed (vs MK-4), branded MenaQ7 sourcing, and third-party assay.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "yohimbe-bark-4-1-extract",
      "title": "Yohimbe Bark - 4:1 Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/64537ff8-ee29-4a48-bdd1-ce901553f0bd_large_04f5a5ff-f70d-4e01-88f9-bf4c50ed3d74.jpg?v=1787417375",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "yohimbe",
        "bark",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 38,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 6.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790591119557",
      "vsf_explanation": "4:1 yohimbe bark extract without stated yohimbine content — a bigger transparency and safety concern than a standardized version. Yohimbine has ED evidence (Ernst 1998 meta-analysis) but a serious cardiovascular safety profile (hypertension, tachycardia, arrhythmias, MAOI/SSRI/antihypertensive interactions). Cohen 2015 found many yohimbe products in the US have inaccurate or wildly variable yohimbine content — a 4:1 extract without alkaloid quantification is exactly the kind of unpredictable-dose product that safety literature flags. Would need explicit yohimbine mg disclosure and prominent CV/drug-interaction warnings to move above Rejected.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "probiotic-for-digestive-health",
      "title": "Probiotic for Digestive Health",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/52ea965f-11b0-44f8-97ca-3fcd684eaab9_large_4fcc7c4a-f326-4e50-97a5-541af07a664c.jpg?v=1787417375",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "probiotic",
        "for",
        "digestive",
        "health",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 26.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790591250629",
      "vsf_explanation": "Generic digestive-health probiotic. IBS-relevant strains like B. infantis 35624 (Whorwell 2006) or L. plantarum 299v (Ducrotte 2012) are the ones with meaningful pain/bloating RCT support; the label does not identify these. Would move to Verified with strain-level ID and CFU-at-expiration.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zinc-picolinate-body-preferred-form",
      "title": "Zinc Picolinate - Body Preferred Form",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cfefb242-d5df-4793-9e44-8400308e2323_large_bce45045-7611-498a-b783-5ba3efd2e24e.jpg?v=1787417375",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zinc",
        "picolinate",
        "body",
        "preferred",
        "form",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 68,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 9.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790591185093",
      "vsf_explanation": "Zinc picolinate is a well-absorbed chelated form — a small crossover study (Barrie 1987) suggested higher retention vs citrate/gluconate. Solid mid-tier zinc supplement at typical 22-30mg elemental. Standard tier upper end — correct form, mainstream sourcing. Would move to Verified with Albion TRAACS branding, copper co-factoring, and NSF verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zinc-citrate",
      "title": "Zinc Citrate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6d5aa2d5-7cde-4188-9151-547f21072a2f_large_9eff4d38-cf47-48bd-b8b9-771c636e2760.jpg?v=1787417375",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zinc",
        "citrate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 64,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 7.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790591152325",
      "vsf_explanation": "Zinc citrate is a well-absorbed mid-tier zinc form (Wegmuller 2014). Suitable for immune and testosterone support at 15-40mg (Prasad 2007). Standard tier — correct form, standard sourcing. Would move to Verified with Albion chelate, copper pairing, and NSF certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zinc-gluconate",
      "title": "Zinc Gluconate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8753bd5c-48f4-4707-8ffa-196ad35e3ccf_large_c2b08ff4-742a-42ab-ae24-a46470230d01.jpg?v=1787417375",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zinc",
        "gluconate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 14.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790591316165",
      "vsf_explanation": "Zinc gluconate — mid-tier zinc form, cold-duration evidence at 75mg lozenge doses (Hemila 2011). Chelated forms are preferred for daily long-term use. Standard tier. Chronic use requires copper co-factoring.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zinc-c-lozenges-orange-lemon-flavor",
      "title": "Zinc & C Lozenges - Orange & Lemon Flavor",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/21445e46-3e19-41a3-b2fb-7d51ef02bc9f_large_11483c21-1e40-4329-8b4c-04d54602acc7.jpg?v=1787417375",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zinc",
        "lozenges",
        "orange",
        "lemon",
        "flavor",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 13.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790591217861",
      "vsf_explanation": "Zinc + vitamin C lozenges for acute cold symptom management. Zinc lozenges have Cochrane meta-analysis support for reducing cold duration (Hemila 2011) at 75mg+ elemental zinc/day started within 24h of symptoms — form (acetate/gluconate) and dose matter. Standard tier — legit acute-use product, effect depends on adequate elemental zinc content.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-white-willow-bark",
      "title": "Full Spectrum White Willow Bark",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/906f7578-22c6-45d5-9266-47cc4bdda5ec_large_a9784209-3285-44c1-ac37-5710d47777ad.jpg?v=1787417375",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "white",
        "willow",
        "bark",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 6.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790591381701",
      "vsf_explanation": "'Full Spectrum' = whole herb without standardization. White willow salicin content varies widely in un-standardized whole herb, making dose delivery unpredictable. Safety flag: aspirin-like bleeding and drug interactions. Would improve with 15-25% salicin standardization as in the sibling standardized SKU.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zinc-c-lozenges-w-elderberry-echinacea-orange-lemon-flavor-1",
      "title": "Zinc & C Lozenges w/ Elderberry & Echinacea-Orange & Lemon Flavor",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0d049309-8d6e-477a-92c9-9564eee35cd2_large_9da21446-a9b2-463f-9fe1-4a05e24904b6.jpg?v=1787417375",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zinc",
        "lozenges",
        "elderberry",
        "echinacea",
        "orange",
        "lemon",
        "flavor",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 4.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790591283397",
      "vsf_explanation": "Zinc + C + elderberry + echinacea combo lozenge for acute cold management. Zinc lozenges (Hemila 2011), elderberry (Tiralongo 2016), and echinacea (Karsch-Volk 2014) each have modest RCT support for cold duration/severity. Standard tier — mainstream immune formula, dose adequacy depends on undisclosed per-lozenge amounts.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zinc-c-lozenges-w-elderberry-echinacea-orange-lemon-flavor",
      "title": "Zinc & C Lozenges w/ Elderberry & Echinacea-Orange & Lemon Flavor",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a1105077-7f85-47e4-a470-e93ab7a40a78_large_8ef5d0c2-fd83-4069-b47c-5eef9f8ce54a.jpg?v=1787417375",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zinc",
        "lozenges",
        "elderberry",
        "echinacea",
        "orange",
        "lemon",
        "flavor",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 11.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790591348933",
      "vsf_explanation": "Duplicate SKU of zinc + C + elderberry + echinacea immune lozenges. Zinc (Hemila 2011), elderberry (Tiralongo 2016), and echinacea (Karsch-Volk 2014) each have modest RCT evidence for cold symptom reduction. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "happy-microbiome-stress-support-probiotic-featuring-cerebiome",
      "title": "Happy Microbiome Stress Support Probiotic - Featuring Cerebiome",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7f90512b-500d-4868-bb68-89f77633078b_large_931edf9f-3c4f-4e8b-b7cf-b66c67b16572.jpg?v=1787417375",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "happy",
        "microbiome",
        "stress",
        "support",
        "probiotic",
        "featuring",
        "cerebiome",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 74,
        "formulation": 72,
        "manufacturing": 70,
        "safety": 68,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 27.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790591414469",
      "vsf_explanation": "Uses Cerebiome (Lallemand's psychobiotic — L. helveticus R0052 + B. longum R0175). This specific combo has a genuine mood/anxiety RCT base (Messaoudi 2011 for perceived stress; Kazemi 2019). Named branded ingredient is a strong signal in a category dominated by anonymous blends. Sits at low-Verified. Would move to solid Verified 75+ with CFU-at-expiration and third-party stability verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "epic-pro-25-strain-probiotic",
      "title": "Epic Pro 25-Strain Probiotic",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f63033e9-add1-4dda-8adc-6f967d87cdae_large_9c803c6b-4c38-4f3b-9834-a9ab1d02449f.jpg?v=1787417375",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "epic",
        "pro",
        "strain",
        "probiotic",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 29.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790591512773",
      "vsf_explanation": "25-strain high-count multi-strain probiotic. Broad-diversity blends are useful for general microbiome support but rarely map to any single RCT-tested SKU (most RCTs use 1-8 strains). High strain-count also complicates stability across shelf life. Would move to Verified with individual per-strain CFU disclosure and stability testing at expiration.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-reuteri-plus",
      "title": "L. Reuteri Plus",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/38160690-a124-40c2-a1a9-2270a568d4b6_large_d59641fd-a7f3-4d2d-b1f2-7e563b943469.jpg?v=1787417375",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "reuteri",
        "plus",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 19.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790591611077",
      "vsf_explanation": "L. reuteri has meaningful strain-specific evidence: DSM 17938 for colic and infant regurgitation, ATCC PTA 6475 for oral/bone health. 'Plus' implies added strains but exact strain designations not disclosed in title. Would move to Verified 70+ with named strain designation, CFU count, and cold-chain guarantee.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zinc-picolinate-body-preferred-form-2-pack",
      "title": "Zinc Picolinate - Body Preferred Form - 2 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6e10b76e-c5ed-4a82-8050-06b22a611149_large_0e1f28d7-70e3-4353-8c5d-c33fccd65b1e.jpg?v=1787417375",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zinc",
        "picolinate",
        "body",
        "preferred",
        "form",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 68,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 13.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790591447237",
      "vsf_explanation": "2-pack of zinc picolinate — well-absorbed chelated form (Barrie 1987) for daily immune and testosterone support at 22-30mg (Prasad 2007). Standard tier upper end. Would move to Verified with named Albion chelate, copper pairing, and NSF verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "e-1000-mixed-tocopherols",
      "title": "E-1000 Mixed Tocopherols",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6779b1d5-61c5-4c48-b139-56bfe07673b0_large_000ad13a-8d44-4ee5-8d82-e4af4b5d73cb.jpg?v=1787417375",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "1000",
        "mixed",
        "tocopherols",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 50,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 52.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790591480005",
      "vsf_explanation": "Mixed tocopherols form is a plus over synthetic dl-alpha-tocopherol alone, providing beta/gamma/delta isomers. However 1000 IU/day is on the high side — Miller 2005 meta-analysis raised all-cause mortality signal at high-dose vitamin E supplementation. Would need dose-ceiling context and safety-warning disclosure to score higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "immunobiotic-immuno-lp20",
      "title": "Immunobiotic Immuno-LP20",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/15760155-f49d-4fee-9ad4-d04c4863e5d3_large_e21a2221-5541-4dba-80c2-4154f6b806ad.jpg?v=1787417375",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "immunobiotic",
        "immuno",
        "lp20",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790591545541",
      "vsf_explanation": "Immuno-LP20 is a heat-treated Lactobacillus plantarum L-137 branded ingredient with RCT evidence for upper respiratory tract infection reduction (Hirose 2013). Named strain heat-inactivated product is a legitimate quality plus. Would move to Verified 70+ with clinical-dose confirmation and third-party assay.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dr-stephen-langers-ultimate-16-strain-probiotic-with-fos",
      "title": "Dr. Stephen Langer's Ultimate 16 Strain Probiotic with FOS",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4e2b8dbe-7a6d-4f02-94f6-19d7f7140650_large_c6cf21b8-403e-4769-a6e0-2b06662ca71c.jpg?v=1787417375",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "stephen",
        "langer",
        "ultimate",
        "strain",
        "probiotic",
        "with",
        "fos",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 66,
        "manufacturing": 65,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790591578309",
      "vsf_explanation": "16-strain synbiotic with FOS — one of Swanson's longer-running SKUs with a practitioner co-brand. Multi-strain diversity + FOS is sensible design, but strain-level identifiers are not present in the title. Sits at high-Standard because of the practitioner name and included prebiotic. Would move to Verified with strain IDs and CFU-at-expiration.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dr-stephen-langers-ultimate-16-strain-probiotic-with-fos-1",
      "title": "Dr. Stephen Langer's Ultimate 16 Strain Probiotic with FOS",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9649f82c-545d-40f1-b1d0-3ae62129ccfc_large_d2dac943-8a51-495d-949f-ac451730dd57.jpg?v=1787417376",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "stephen",
        "langer",
        "ultimate",
        "strain",
        "probiotic",
        "with",
        "fos",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 66,
        "manufacturing": 65,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 18.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790591643845",
      "vsf_explanation": "Duplicate SKU of the Dr. Langer 16-strain synbiotic (likely different size). Same rationale: sensible multi-strain design with FOS, but strain-level identifiers absent. Would move to Verified with strain IDs and CFU-at-expiration.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "telomere-formula",
      "title": "Telomere Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/447d9dc6-2756-405f-aba8-ccdfc66ae113_large_f5d06d0c-6558-4d29-9d1f-e66e7fc54e54.jpg?v=1787417377",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "telomere",
        "formula",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 122.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790591742149",
      "vsf_explanation": "'Telomere Formula' is a marketing framing that typically bundles adaptogens and antioxidants without demonstrated telomere-lengthening effect in humans outside of TA-65 (which has controversial evidence). Product category makes an aspirational claim not supported by ingredient-level RCT data. Would need TA-65 or comparable human telomere-measurement RCT to score higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "agaricus-blazei-mushroom-extract",
      "title": "Agaricus Blazei Mushroom Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d1f862ee-e819-4d46-ac20-e383709c7b5f_large_26e6e6d3-fd43-4ad7-a099-071a284d83d4.jpg?v=1787417377",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "agaricus",
        "blazei",
        "mushroom",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 20.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790591774917",
      "vsf_explanation": "Agaricus blazei (also called A. subrufescens) is a beta-glucan-rich Brazilian medicinal mushroom with small trials on immune biomarkers in oncology and hepatitis populations. Held to mid-Standard by absence of fruiting-body confirmation, no beta-glucan standardization percentage, and no dose disclosure. Occasional reports of hepatotoxicity with A. blazei preparations (Mukai 2006 case series) raise safety concerns for high-dose or long-term use. Would move up with fruiting-body + standardization + safety labeling.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "astragalus-standardized",
      "title": "Astragalus - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/09c90db6-ebe9-46ab-9089-cecb5d9c2da9_large_40188e0f-e48f-4e9a-bf16-e53c4dd157c5.jpg?v=1787417378",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "astragalus",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 65,
        "sustainability": 58
      },
      "price": 22.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790592659653",
      "vsf_explanation": "Standardized astragalus (Astragalus membranaceus), typically to astragalosides (often 0.5% astragaloside IV) — a traditional TCM immune adaptogen with modest human RCT support and stronger preclinical polysaccharide-driven immunomodulation data. Standardization signal in the title is a real quality gate versus generic astragalus powder. Held to mid-Standard by unspecified astragaloside percentage. Safety: interacts with immunosuppressants. Would move up with named astragaloside standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ultra-potency-probiotic",
      "title": "Ultra Potency Probiotic",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/29eef30d-5881-467a-8515-377cf9f15777_large_5f94d248-c234-4d6e-99f1-eb86de74e8c0.jpg?v=1787417378",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ultra",
        "potency",
        "probiotic",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 41.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790592692421",
      "vsf_explanation": "High-CFU multi-strain probiotic from Swanson's Ultra line. 'Ultra Potency' typically means 50B+ CFU. Higher CFU is useful but only if paired with strain-specific evidence and stable delivery. Would move to Verified with strain-level identification and CFU-at-expiration verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "probiotic-with-digestive-enzymes",
      "title": "Probiotic with Digestive Enzymes",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/75501d77-e322-4090-aabd-64d13e18a735_large_511f6ba6-ec6d-4ee0-a2ad-d51b40be04bc.jpg?v=1787417378",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "probiotic",
        "with",
        "digestive",
        "enzymes",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 18.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790592725189",
      "vsf_explanation": "Combo probiotic + digestive-enzyme capsule. Mechanistically distinct — probiotics need cold storage / stability, enzymes need pH-appropriate delivery — so combined products often compromise both. Would move to Verified with strain-level probiotic ID, per-enzyme activity-unit disclosure (protease HUT, lipase FIP, amylase DU), and delayed-release delivery.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "artichoke-extract-standardized",
      "title": "Artichoke Extract - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/537ee76e-8749-49ea-a909-b7c62177389a_large_2730bf64-1267-4320-b605-c9cc026c101f.jpg?v=1787417378",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "artichoke",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 62,
        "sustainability": 60
      },
      "price": 4.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790592790725",
      "vsf_explanation": "Standardized artichoke leaf (Cynara scolymus) — a legitimate hepatoprotective/choleretic herb with human RCT data on IBS symptoms (Bundy 2004) and lipid modulation. Standardization is typically to cynarin or caffeoylquinic acids; percentage isn't specified in the title. Held to mid-Standard by that ambiguity. Better fit for digestive/liver-support than pure immune-antioxidant framing. Would move up with named cynarin percentage.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "saccharomyces-boulardii-with-prebiotic-mos",
      "title": "Saccharomyces Boulardii with Prebiotic MOS",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/986fba94-af13-4553-98e3-a24f163a9101_large_9f63b18f-ea12-4b94-80f2-8bfb46d02535.jpg?v=1787417379",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "saccharomyces",
        "boulardii",
        "with",
        "prebiotic",
        "mos",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 74,
        "formulation": 68,
        "manufacturing": 65,
        "safety": 68,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790592856261",
      "vsf_explanation": "S. boulardii is a yeast (not a bacterium), making it the go-to co-supplement during antibiotic courses since antibiotics cannot kill it (Szajewska 2015 meta-analysis for AAD prevention; McFarland 2010). Paired MOS prebiotic is directionally sensible. Would move to Verified 70+ with named subtype (CNCM I-745 is the RCT strain) and 5B+ CFU-at-expiration confirmation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-plantarum-probiotic",
      "title": "L. Plantarum Probiotic",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/41e825ac-2d99-46b6-9a17-ef238e05f915_large_17290827-4795-46cf-b511-eabf88647682.jpg?v=1787417379",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "plantarum",
        "probiotic",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 13.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790593740997",
      "vsf_explanation": "Single-strain L. plantarum. RCT-anchored plantarum strains include 299v (Ducrotte 2012 for IBS pain/bloating) and DR7 (Chong 2019 for stress). Generic plantarum labeling cannot be linked to that evidence. Would move to Verified with 299v or another named RCT strain and CFU-at-expiration.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "prolacto-acidophilus",
      "title": "ProLacto Acidophilus",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/563566d4-f426-4ce3-9e66-62a38d6a7755_large_c159b658-b143-42f9-a8b4-55356aa67742.jpg?v=1787417381",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "prolacto",
        "acidophilus",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790593806533",
      "vsf_explanation": "Single-strain L. acidophilus. Meaningful acidophilus evidence tracks specific strains like NCFM (Ouwehand 2014); a generic acidophilus label cannot be mapped to those RCTs. Would move to Verified with strain designation and CFU-at-expiration.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bacopa-monnieri",
      "title": "Bacopa Monnieri",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/206969d6-b118-4278-bf42-51c7c738aed9_large_a1ca6e5c-4ff7-4c23-b689-6d7a23824af1.jpg?v=1787417381",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bacopa",
        "monnieri",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 14.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790593839301",
      "vsf_explanation": "Generic bacopa monnieri without disclosed bacoside standardization. The positive cognitive RCTs (Stough 2001; Roodenrys 2002) all used 45-55% bacoside-standardized extracts at 300mg for 8-12 weeks; unstandardized bacopa's active content varies widely and cannot be assumed to hit those targets. Safety is generally favorable but bacopa causes GI effects in some users. Would move to Verified 70+ with disclosed bacoside percentage (branded Bacognize or CDRI-08 preferred) and dose within studied range.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "probiotic-triple-pack",
      "title": "Probiotic Triple Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/78d029b0-bc61-4f0e-9113-fdf5f225f282_large_848c0275-1550-4183-80de-6621159cf6bd.jpg?v=1787417381",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "probiotic",
        "triple",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 25.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790593937605",
      "vsf_explanation": "Three-pack multi-bottle probiotic. Value packaging is an economics play, not a formulation change. Would move to Verified with the underlying probiotic strain-identified and CFU-at-expiration disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "prebiotic-for-friendly-flora-support-scfos-fromnutraflora",
      "title": "Prebiotic for Friendly Flora Support - scFOS fromNutraFlora",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4b5143a4-4801-449a-947b-5526848af3ab_large_e0c207b9-1b05-4ab0-af32-6d710630f2ad.jpg?v=1787417381",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "prebiotic",
        "for",
        "friendly",
        "flora",
        "support",
        "scfos",
        "fromnutraflora",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 18.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790593872069",
      "vsf_explanation": "Short-chain FOS from NutraFlora — see companion SKU. Named branded ingredient with bifidogenic RCT support (Bouhnik 1999); capsule-form dosing typically sub-therapeutic relative to studied 5-10g/day. Would move to Verified with a scoop format and clear gram dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bergamot-extract",
      "title": "Bergamot Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/66af6d76-f63c-4662-b3f7-1a4adc5d9617_large_9777b1c2-f3ce-46e9-ad73-43bfbeea506e.jpg?v=1787417381",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bergamot",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 27.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790593904837",
      "vsf_explanation": "Citrus bergamot polyphenolic fraction has solid RCT evidence for LDL cholesterol reduction (Mollace 2011) at 500-1000mg standardized. No BPF (Bergamot Polyphenolic Fraction) or Bergavit branded ingredient disclosed. Would move to Verified 70+ with named branded fraction and clinical dose confirmation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ultra-probiotic-for-seniors-50",
      "title": "Ultra Probiotic for Seniors 50+",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1ea56b54-8491-4660-b86c-9a14ba80004d_large_9679d055-51b8-4be5-bc2c-b92dd9d73fbb.jpg?v=1787417382",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ultra",
        "probiotic",
        "for",
        "seniors",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 56.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790594822341",
      "vsf_explanation": "Senior-targeted probiotic. Age-related microbiome shifts (loss of Bifidobacterium diversity) support targeting seniors, and Bifidobacterium longum BB536 has senior-focused RCTs (Akatsu 2013). Strain-level identification and CFU-at-expiration are not visible. Would move to Verified with BB536 or similar senior-relevant strain IDs disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chewable-probiotic-for-kids-natural-cherry-flavor",
      "title": "Chewable Probiotic for Kids - Natural Cherry Flavor",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4a2c4714-c1e5-414d-831f-515d39969f1f_large_5de0a2c1-585d-477e-a06b-ce0a33a02ff0.jpg?v=1787417382",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "youth_under_18",
      "tokens": [
        "chewable",
        "probiotic",
        "for",
        "kids",
        "natural",
        "cherry",
        "flavor",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 12.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790594855109",
      "vsf_explanation": "Pediatric chewable probiotic. Chewable format bypasses stomach-acid protection but is age-appropriate for children who can't swallow capsules. Pediatric probiotic RCTs are strain-specific (LGG for AAD; B. infantis 35624 for colic in Szajewska 2013). Strain identification is not visible from the title. Would move to Verified with named strains studied specifically in pediatric populations.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ultra-probiotic-complex",
      "title": "Ultra Probiotic Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6216ab80-0a2d-41a5-aea5-c2c10657ad40_large_e92c6187-fbc3-42ac-bbf4-078530689a73.jpg?v=1787417382",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ultra",
        "probiotic",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 38.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790595674309",
      "vsf_explanation": "Higher-CFU multi-strain blend from Swanson's Ultra tier. Higher CFU counts (20B+) improve odds of colonization delivery but only matter if paired with strain-appropriate delivery and identification. Would move to Verified with strain-level identification, CFU-at-expiration disclosure and delayed-release capsule format.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "probiotic-for-daily-wellness",
      "title": "Probiotic for Daily Wellness",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/eb31d7dd-c2af-40c0-8a15-ca2ddb8beb66_large_7ab7dfbb-465f-42c8-b4f3-18b8c6da91bc.jpg?v=1787417383",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "probiotic",
        "for",
        "daily",
        "wellness",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790595707077",
      "vsf_explanation": "Generic daily-use probiotic. Marketing language ('daily wellness') offers no clinical anchor; strain-level identifiers are the meaningful signal and are not present in the title. Would move to Verified with named strains and CFU-at-expiration.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ultimate-probiotic-formula-3-pack",
      "title": "Ultimate Probiotic Formula - 3 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b557e5ab-1848-41de-899f-172ae5de2f0d_large_4eff3827-c29f-40ef-8281-84a26f24b77f.jpg?v=1787417383",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ultimate",
        "probiotic",
        "formula",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 55.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790595772613",
      "vsf_explanation": "Three-pack of Swanson's Ultimate multi-strain probiotic. High-strain count blends can be useful for general microbiome diversity but rarely map cleanly to RCT-tested SKUs. Multi-bottle purchase does not change the underlying formulation quality. Would move to Verified with strain-level ID and refrigeration-status guidance for shelf life.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "aloe-vera",
      "title": "Aloe Vera",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/725ac670-7a30-45aa-bab8-28231b374fb3_large_f4951273-3c98-43e6-97bd-41cdae711b2c.jpg?v=1787417383",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "aloe",
        "vera",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 58,
        "transparency": 55,
        "sustainability": 52
      },
      "price": 8.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790595805381",
      "vsf_explanation": "Oral aloe vera capsule for GI support. Whole-leaf preparations contain anthraquinones (aloin) IARC 2B — decolorized inner-leaf is safer. Small RCTs support IBS/UC symptom improvement (Langmead 2004) but effect sizes modest. Would move to Verified 70+ with certified aloin removal and IASC certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "prebiotic-for-friendly-flora-support-scfos-fromnutraflora-1",
      "title": "Prebiotic for Friendly Flora Support - scFOS fromNutraFlora",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e0c153de-7ea1-41f8-95fd-b14ea3a34f21_large_7f9ec52d-90db-4fdf-8b64-94b9dd4874d9.jpg?v=1787417383",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "prebiotic",
        "for",
        "friendly",
        "flora",
        "support",
        "scfos",
        "fromnutraflora",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 10.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790595739845",
      "vsf_explanation": "Short-chain FOS from NutraFlora (Ingredion's branded scFOS) — a well-characterized prebiotic ingredient with bifidogenic RCTs (Bouhnik 1999 dose-response). Named branded ingredient is a manufacturing trust signal. Capsule-form scFOS is often sub-therapeutic at 1-2g when the studied range is 5-10g. Would move to Verified with a scoop format and dose disclosure hitting the 5g mark.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lactobacillus-gasseri",
      "title": "Lactobacillus Gasseri",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3f8e6412-1f2a-47dd-8c3a-15813bef0896_large_39faf27e-c3e4-4b09-9cd5-2ecf8535363f.jpg?v=1787417385",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lactobacillus",
        "gasseri",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790596755653",
      "vsf_explanation": "Single-strain L. gasseri without strain-level ID. Meaningful evidence in this species (Kadooka 2013 for SBT2055 body fat; Kim 2018 for BNR17) is strain-specific. Would move to Verified with named strain, CFU-at-expiration, and stomach-acid-resistant delivery.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "wild-yam-cream",
      "title": "Wild Yam Cream",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1c8ad0c3-5a7d-45d9-812e-49e07000a5fa_large_5f74af64-744f-4ec5-883b-fe27abe7e290.jpg?v=1787417384",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wild",
        "yam",
        "cream",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 6.85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790596722885",
      "vsf_explanation": "Topical wild yam cream is often marketed as 'natural progesterone' — diosgenin cannot be converted to progesterone in the human body, and Komesaroff 2001 RCT showed no benefit for menopausal symptoms versus placebo. Product category rests on a physiologically implausible claim. Would need honest reframing away from hormone-precursor positioning to score higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zinc-gummies-elderberry",
      "title": "Zinc Gummies - Elderberry",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fb0c4762-c3ac-453f-9ace-fc6a758e22db_large_32e34f43-33b4-4500-8760-25bb05f7d12c.jpg?v=1787417385",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zinc",
        "gummies",
        "elderberry",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 5.85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790596788421",
      "vsf_explanation": "Zinc + elderberry gummies for immune support. Zinc has cold-duration evidence (Hemila 2011) and elderberry has modest RCT support for cold/flu symptom reduction (Tiralongo 2016), but gummy delivery typically uses lower elemental zinc doses (5-15mg) with added sugar. Standard tier — legit ingredients, sub-therapeutic delivery. Would upgrade with 25mg+ zinc, standardized elderberry, and reduced sugar.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zinc-gluconate-1",
      "title": "Zinc Gluconate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c0ac2b4a-ef26-472c-a719-1e3c1fe03d2c_large_b7c43e1c-9a78-46b6-a1e5-9a61dbfe68d0.jpg?v=1787417386",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zinc",
        "gluconate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790597705925",
      "vsf_explanation": "Zinc gluconate is a mid-tier zinc form with adequate absorption; well-studied for cold-duration reduction (Hemila 2011) at 75mg+ within 24h of symptom onset. For daily supplementation, chelated forms (bisglycinate, picolinate) are better tolerated. Standard tier — legit but not top-shelf. Chronic use needs copper co-factoring.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "e-200",
      "title": "E-200",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/be5f40d9-8209-4e2a-a09f-984793f26585_large_23227f4b-ea57-46fb-b616-e4a4714b86b6.jpg?v=1787417387",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "200",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 2.33,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790597738693",
      "vsf_explanation": "Vitamin E 200 IU as base — likely synthetic dl-alpha-tocopherol given no tocopherol form specification. Isolated alpha-tocopherol supplementation showed null-to-harmful effects in HOPE, SELECT trials. Would improve with mixed tocopherols/tocotrienols form (d-alpha or full spectrum) as in the mixed-toco versions.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lactobacillus-rhamnosus-with-fos",
      "title": "Lactobacillus Rhamnosus with FOS",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cc86f536-6498-4878-882a-628058624f30_large_80dcbc0b-fc49-4e3b-b923-fe6a85761d99.jpg?v=1787417388",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lactobacillus",
        "rhamnosus",
        "with",
        "fos",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 17.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790597771461",
      "vsf_explanation": "L. rhamnosus with FOS prebiotic. The RCT-heavy strain is L. rhamnosus GG (LGG, ATCC 53103) — Hojsak 2010 for pediatric AAD, Szajewska 2013 meta-analysis. The title does not confirm GG. FOS as an included prebiotic is helpful directionally, though at capsule doses typically sub-therapeutic. Would move to Verified with explicit GG designation and CFU-at-expiration.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "probiotic-4",
      "title": "ProBiotic-4",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/06b45864-f208-4890-ae4b-a0f8f92ac0f0_large_7aac463a-4ffa-429e-837f-21e31199e35f.jpg?v=1787417388",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "probiotic",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790597804229",
      "vsf_explanation": "Four-strain probiotic without strain identifiers. Four common Lactobacillus/Bifidobacterium species is a reasonable baseline blend, but genus/species alone is not enough to map to RCT evidence. CFU count and delivery format not visible. Would move to Verified with strain IDs, CFU-at-expiration and delayed-release delivery.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bacillus-coagulans-spore-form",
      "title": "Bacillus Coagulans - Spore Form",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/02a91211-5957-4199-a2ce-5a6e8090390a_large_3e08df81-6591-4ff5-b7d6-b5a624e03077.jpg?v=1787417389",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bacillus",
        "coagulans",
        "spore",
        "form",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 25.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790598688965",
      "vsf_explanation": "Bacillus coagulans (GBI-30 6086/MTCC 5856) has RCT evidence for IBS and immune endpoints (Kalman 2009, Majeed 2016) at 2 billion CFU. Spore-form organisms survive stomach acid — a real formulation positive over most Lactobacillus strains. Would move to Verified 70+ with named strain designation (GanedenBC30 or LactoSpore) and CFU count.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-k-cream-with-menaquinone-7",
      "title": "Vitamin K Cream with Menaquinone-7",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/96db051d-f1d5-410e-8507-f9a84c5a2cd1_large_3fa0724c-a4d1-4774-9a82-8dc1f0bb67bf.jpg?v=1787417389",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "cream",
        "with",
        "menaquinone",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 13.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790598721733",
      "vsf_explanation": "Topical vitamin K creams have marketing claims for spider veins, bruising, and rosacea, but evidence is limited — Cohen 2006 studied topical K1 phytonadione for post-laser bruising with modest results, and MK-7 topical absorption/action data are sparse. Correct MK-7 form disclosure is a plus. Held below Verified by weak topical-efficacy evidence and unclear MK-7 mcg/gram concentration. Would move to Verified 70+ with published in-vivo topical bioavailability data and clear concentration disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "womens-multi-hormone-support-2-pack",
      "title": "Women's Multi +Hormone Support - 2 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b9cc361f-ba51-4ab9-a660-7125a4e3bb98_large_546aedb0-4e43-4689-bc68-748a1e54b2ac.jpg?v=1787417389",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "women",
        "multi",
        "hormone",
        "support",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 21.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790598754501",
      "vsf_explanation": "Women's multivitamin with added hormone-support botanicals (typically chaste tree, DIM, or black cohosh alongside standard vitamin/mineral base). Multivitamin evidence for specific outcomes is limited but coverage-based value exists (PHS II — Gaziano 2012). Botanical add-ins are typically under-dosed relative to monograph — chaste tree needs ~40mg standardized extract for PMS efficacy (Loch 2000). Folate form (5-MTHF vs folic acid) and iron form are the key formulation flags for women's multis. Would move to Verified 70+ with 5-MTHF, disclosed botanical standardization at monograph doses, and third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-yucca",
      "title": "Full Spectrum Yucca",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/af877447-2060-4709-9524-5a336c464cbc_large_dad406ad-1db0-42a0-8de6-5a629b7e743b.jpg?v=1787417390",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "yucca",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 11.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790598787269",
      "vsf_explanation": "Yucca is traditionally promoted for joint support with very limited human RCT evidence (Bingham 1975 is an old open-label study). 'Full Spectrum' means whole herb without standardization. Traditional-use category. Would need modern RCT support and saponin standardization to score higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bilberry-extract-standardized",
      "title": "Bilberry Extract - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3ddb2e63-d168-4af9-9849-e2b1499eb9bc_large_59fae521-d915-465b-8919-ec2cbad63f89.jpg?v=1787417397",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bilberry",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 62,
        "sustainability": 52
      },
      "price": 17.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790601638085",
      "vsf_explanation": "Standardized bilberry extract for microcirculation and visual-fatigue support (Kamiya 2013). Trials use 160-320 mg of 25% anthocyanin extract. Marker % is not visible at title. Would move to Verified 70+ with named 25% anthocyanin standardization, per-serving anthocyanin mg, and third-party assay.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "extra-strength-melatonin-100-drug-free-1",
      "title": "Extra Strength Melatonin - 100% Drug Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7748d9f7-7d0c-4527-ae42-5728e7d8430f_large_927f91f8-c4b4-448e-9df4-fe3ba3039102.jpg?v=1787417414",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "extra",
        "strength",
        "melatonin",
        "100",
        "drug",
        "free",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 54,
        "manufacturing": 60,
        "safety": 52,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 11.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790607077573",
      "vsf_explanation": "Extra-strength melatonin (typically 5-10mg) - well above the physiological 0.3-1mg that Auld 2017 meta and Zhdanova 2001 identify as most consistent with endogenous secretion and effective for sleep-onset. Higher doses correlate with more morning grogginess and vivid dreams. The '100% drug free' framing understates that melatonin is a hormone. Would move to Verified 70+ by dropping to 0.5-1mg with physiological-dose rationale.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "blueberry-extract-standardized",
      "title": "Blueberry Extract - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ff5cd303-a3ba-4f86-b0b2-273263327ecf_large_1266e868-e683-4972-9885-8e9166519cfd.jpg?v=1787417435",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "blueberry",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 58,
        "sustainability": 52
      },
      "price": 5.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790615597253",
      "vsf_explanation": "Standardized blueberry extract (Vaccinium spp.) provides anthocyanins with in-vitro antioxidant activity; oral RCTs for cognitive and cardiovascular endpoints (Whyte 2018) are promising but modest. Species distinction (highbush vs wild lowbush) affects anthocyanin content and is not disclosed. Would move to Verified 70+ with species disclosure, marker % (e.g., 25% anthocyanins), and studied dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "boswellia-serrata-whole-herb-standardized-extract",
      "title": "Boswellia Serrata - Whole Herb & Standardized Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/384debfd-3215-49d1-8d41-c03a2bc0e5e2_large_abc933f2-e0fd-49de-b593-5d539a2cbec8.jpg?v=1787417435",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "boswellia",
        "serrata",
        "whole",
        "herb",
        "standardized",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 23.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790615630021",
      "vsf_explanation": "Boswellia serrata for osteoarthritis (Sengupta 2008). Blend of whole herb plus standardized extract — the standardized portion is what drives efficacy. Would improve with AKBA % standardization and branded ingredient (5-Loxin, ApresFlex).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chrysin-passionflower-extract",
      "title": "Chrysin Passionflower Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3c0481cc-8175-4f07-b596-fe11f4f2948e_large_10c4c4ad-3ca3-4c5c-8154-cb7d1ff66e1d.jpg?v=1787417435",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chrysin",
        "passionflower",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 16.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790615564485",
      "vsf_explanation": "Chrysin + passionflower combo. Chrysin has near-zero oral bioavailability (Walle 2001 - extensive first-pass glucuronidation) despite being marketed for aromatase inhibition and anxiety; passionflower has small trial support for anxiety (Akhondzadeh 2001). The chrysin component contributes essentially nothing at typical oral doses. Would move to Verified 70+ by dropping chrysin (or moving to a bioavailability-enhanced form) and standardizing passionflower to vitexin/isovitexin.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fo-ti-extract-he-shou-wu",
      "title": "Fo-Ti Extract He-Shou-Wu",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/62bc5d4e-ea70-4da0-9446-895ff1c4f8bc_large_58d8d74e-7a9d-4382-9801-5d07b5c3cb36.jpg?v=1787417435",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "extract",
        "shou",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 15,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 4.2,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790615761093",
      "vsf_explanation": "Fo-Ti (Polygonum multiflorum) is traditionally used for hair pigmentation and longevity with very limited controlled human evidence. Safety flag: documented hepatotoxicity risk — flagged by China, UK, Australia, and case reports in US. Would need prominent hepatic-safety warning and prepared vs raw form disclosure to score higher. Documented hepatotoxicity case reports (including liver failure) are serious enough on their own, independent of the thin efficacy evidence, to hold this at Rejected under safety_concern.",
      "vsf_autofail_rule": "safety_concern"
    },
    {
      "handle": "probiotic-prebiotic-fiber",
      "title": "Probiotic+ Prebiotic Fiber",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/88dfd672-e03f-4961-b41d-c1c830d16e22_large_6d90081a-c7f6-4612-bf62-774616b68ab6.jpg?v=1787417435",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "probiotic",
        "prebiotic",
        "fiber",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 18.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790615662789",
      "vsf_explanation": "Synbiotic (probiotic + prebiotic fiber) capsule. Synbiotic pairing can outperform either alone (Markowiak 2017 review), but only when strains are identified and the prebiotic dose is enough to actually feed them (usually a few grams — capsule-form prebiotic is generally sub-therapeutic). Would move to Verified with strain-level ID and prebiotic gram-dose disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "immune-complex-contains-elderberry-echinacea-and-goldenseal",
      "title": "Immune Complex - Contains Elderberry Echinacea and Goldenseal",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8f1760ff-1825-4b7b-bcf4-285d1c4517e0_large_3e8cdaf6-a92d-4b5a-8ef4-70ad3287018a.jpg?v=1787417435",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "immune",
        "complex",
        "contains",
        "elderberry",
        "echinacea",
        "and",
        "goldenseal",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 58,
        "manufacturing": 62,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790615728325",
      "vsf_explanation": "Traditional cold-season herbal stack (elderberry + echinacea + goldenseal). Elderberry has the strongest RCT signal (Tiralongo 2016), echinacea's cold-duration data is modest (Karsch-Volk 2014 Cochrane), and goldenseal (Hydrastis canadensis) is heavily overharvested with limited human trials outside topical/GI use. Held to low Standard by 'complex' framing hiding individual mg, goldenseal's sustainability and berberine-related drug-interaction concerns, and no elderberry anthocyanin standardization. Would move up with per-herb dose and standardization disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cinnamon-extract",
      "title": "Cinnamon Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6c059e97-24eb-42bd-b01c-e552f6715221_large_a47ba974-4ffb-4b42-a6a9-d46c00952db5.jpg?v=1787417435",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cinnamon",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 55,
        "sustainability": 52
      },
      "price": 7.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790615892165",
      "vsf_explanation": "Generic cinnamon extract without Ceylon-vs-Cassia disclosure raises coumarin hepatotoxicity questions per EFSA (0.1 mg/kg TDI). Allen 2013 meta-analysis showed modest fasting-glucose reduction (~9 mg/dL) but with high heterogeneity. Extract concentrates active constituents but coumarin content in Cassia is also concentrated unless water-extracted. Would move to Verified 70+ with Ceylon labeling or a water-extract format like Cinnulin PF.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cordyceps-complex-with-reishi-and-shiitake-mushrooms",
      "title": "Cordyceps Complex with Reishi and Shiitake Mushrooms",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0abead51-a383-4d9a-b965-38f7c9f08460_large_f2c13b32-460a-4873-a0f2-52f68782fe45.jpg?v=1787417435",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cordyceps",
        "complex",
        "with",
        "reishi",
        "and",
        "shiitake",
        "mushrooms",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 12.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790615826629",
      "vsf_explanation": "Cordyceps + reishi + shiitake is a classic energy/immune mushroom stack. Cordyceps evidence for VO2max/exercise capacity is modest (Chen 2010 for CS-4 Cordyceps sinensis). Held to mid-Standard by cordyceps species ambiguity (CS-4 vs C. militaris vs wild — very different actives), fruiting body vs mycelium unresolved, and no beta-glucan/cordycepin standardization. Would move to Verified 70+ with named species + standardization + fruiting-body sourcing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "curcumin-berberine-with-black-pepper",
      "title": "Curcumin & Berberine with Black Pepper",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/493e08a9-f13e-4045-ab36-b2c0b82808d8_large_604f8933-50fa-4d95-81fe-68da6c5a7145.jpg?v=1787417435",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint",
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "curcumin",
        "berberine",
        "with",
        "black",
        "pepper",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 62,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 19.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790615695557",
      "vsf_explanation": "Two of the better-evidenced metabolic ingredients — berberine (Yin 2008, metformin-comparable for glucose at 500mg TID) and curcumin (Panahi 2017 for lipids, though bioavailability-limited without phytosome/piperine). Black pepper is added specifically for curcumin absorption. Per-active mg dose disclosure and berberine's ~1% oral bioavailability are the main limits. Safety: berberine has notable drug interactions (metformin, cyclosporine). Would move to Verified with per-active dose disclosure and enhanced-absorption berberine (dihydroberberine or Berbevis).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chamomile-flower-extract-standardized-apigenin",
      "title": "Chamomile Flower Extract - Standardized Apigenin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ecf178e0-77d4-4c53-a80a-8ec07af89ad3_large_7ba0476b-8278-45b9-8862-1994f3215cfd.jpg?v=1787417435",
      "score": 67,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chamomile",
        "flower",
        "extract",
        "standardized",
        "apigenin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 70,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 68,
        "sustainability": 60
      },
      "price": 15.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790615859397",
      "vsf_explanation": "Chamomile standardized to apigenin - the marker molecule behind chamomile's GABA-A binding and anxiolytic effect. Amsterdam 2016 supported 220mg Matricaria chamomilla standardized to apigenin at 1.2% for GAD, and Zick 2011 supported similar formulation for sleep quality. Apigenin standardization is the meaningful quality upgrade over generic chamomile. Safety is very good; ragweed cross-reactivity in sensitive users is the main caveat. Would move to Verified 70+ with per-lot COA and explicit apigenin percentage published.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fenugreek-extract",
      "title": "Fenugreek Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/44d316b1-542b-47bd-a715-59db6dbb0336_large_3b7085a7-b733-44ab-89b3-c3a92b0d5280.jpg?v=1787417435",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fenugreek",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 14.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790615793861",
      "vsf_explanation": "Fenugreek has evidence for post-meal glucose (Kassaian 2009) and modest T-support in men (Testofen/Fenuside blends). No standardization or branded ingredient disclosed. Would improve with saponin % standardization or branded Testofen sourcing and clinical dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bladderwrack-extract-standardized",
      "title": "Bladderwrack Extract - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/29a9c5cb-aaef-492b-bf04-3c0a542996a5_large_a37db5d3-7cae-44cd-b8cb-1184a9bafe9f.jpg?v=1787417435",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bladderwrack",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 50,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 11.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790615924933",
      "vsf_explanation": "Bladderwrack (Fucus vesiculosus) is a kelp source of iodine often marketed for thyroid. Safety flag: variable iodine content can cause thyroid dysfunction in either direction, and marine sources carry heavy-metal risk. Would need iodine per-serving mcg disclosure and heavy-metal testing certification to score higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bilberry-extra-strength-standardized",
      "title": "Bilberry - Extra Strength Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c9b35b51-6808-44b4-9330-9a79f32841b9_large_31c1ec0e-1bf4-4425-8b1d-4a1475955df2.jpg?v=1787417436",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bilberry",
        "extra",
        "strength",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 62,
        "sustainability": 52
      },
      "price": 12.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790616875205",
      "vsf_explanation": "Extra-strength standardized bilberry indicates a defined anthocyanin extract, the correct approach for microcirculation and vision-fatigue support (Kamiya 2013 showed reduced asthenopia). Studied products deliver 160-320 mg of 25% anthocyanin extract. Marker % not shown on the title. Would move to Verified 70+ with named 25% anthocyanin standardization and studied-dose alignment.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "eyebright-extract-standardized",
      "title": "Eyebright Extract - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/352a5d8a-5743-4deb-8ae1-616270beb5ad_large_a3fa0f18-2427-413b-83f9-34a1d775c3b6.jpg?v=1787417436",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "eyebright",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 8.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790616809669",
      "vsf_explanation": "Eyebright (Euphrasia officinalis) is a traditional herbal for eye irritation with almost no controlled clinical evidence for oral use. 'Standardized' claim needs a % marker to be meaningful. Traditional-use category. Would need modern RCT support to score higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ginkgo-biloba-extract-standardized-3",
      "title": "Ginkgo Biloba Extract - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d8ed6036-0073-43f8-ae1d-98cf266a5120_large_9d4e970b-031c-404a-bddd-40ab4670d5f9.jpg?v=1787417436",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ginkgo",
        "biloba",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 66,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 10.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790616842437",
      "vsf_explanation": "Standardized ginkgo extract following the 24/6 EGb-761-style template that produced the strongest cognitive-aging signals (Le Bars 1997; Ihl 2011). Generic Swanson manufacturing footprint and no third-party COA disclosed. Bleeding-risk interaction with anticoagulants/antiplatelets is under-communicated. Would move to Verified 70+ with named extract origin, per-lot testing, and explicit anticoagulant warning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "horse-chestnut-extract-standardized",
      "title": "Horse Chestnut Extract - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/91fdcece-8165-4318-b75d-a73734aefa10_large_0763b58d-f9a4-4041-b70b-ab618679dc25.jpg?v=1787417437",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "horse",
        "chestnut",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 15.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790616907973",
      "vsf_explanation": "Horse chestnut aescin has Cochrane-supported evidence for chronic venous insufficiency (Pittler 2012) at 300mg/50mg aescin BID. Would move to Verified with % aescin standardization and clinical dose specification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hiactives-tart-cherry",
      "title": "HiActives Tart Cherry",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/19bf335e-55c6-4aa8-ae22-03c9dccab3c5_large_fde21acd-d39b-4483-a7de-3da30962aac5.jpg?v=1787417439",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hiactives",
        "tart",
        "cherry",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 13.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790617759941",
      "vsf_explanation": "HiActives is FutureCeuticals' branded whole-fruit tart cherry concentrate. Tart cherry has RCT evidence for uric acid (Bell 2014), exercise recovery (Bowtell 2011), and modest sleep effects. Named branded ingredient is a plus. Would move to Verified with anthocyanin standardization and clinical dose confirmation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gugulipid-with-bioperine-standardized",
      "title": "Gugulipid with BioPerine - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/50a4917b-163c-4f2b-95d0-ed4417f638ec_large_449db5ce-3a02-4947-bdbf-78e26f5de3e5.jpg?v=1787417439",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gugulipid",
        "with",
        "bioperine",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 21.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790617727173",
      "vsf_explanation": "Guggul (Commiphora mukul, guggulsterones) was historically promoted for cholesterol — Szapary 2003 RCT in JAMA showed no LDL benefit and possible LDL increase. BioPerine coadjuvant is a plus for bioavailability. Would need honest reframing of cholesterol claims and clearer standardization to score higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gotu-kola-extract-standardized",
      "title": "Gotu Kola Extract - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/47308869-fcf5-4356-9e79-2274ffb47996_large_c5e22d26-9747-43fe-a27a-abf9fd2063af.jpg?v=1787417439",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gotu",
        "kola",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 66,
        "transparency": 60,
        "sustainability": 52
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790617792709",
      "vsf_explanation": "Gotu kola (Centella asiatica) has traditional cognitive and venous-insufficiency use; small trials support microcirculation (Incandela 2001). Standardization to asiaticosides/triterpenes is the recognized quality marker. Cognitive evidence is thin — mostly small, low-quality trials. Would move to Verified 70+ with named Centellicum-style triterpene fraction and outcome RCTs.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "green-tea-extract",
      "title": "Green Tea Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e0eb9ce4-7064-4f14-941e-dc85788d2aef_large_9ca6ae11-302a-4621-b80e-e8a6b31555d6.jpg?v=1787417439",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "green",
        "tea",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 9.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790617825477",
      "vsf_explanation": "Generic green tea extract — EGCG has broad evidence for metabolic and antioxidant endpoints. Safety flag: EFSA has flagged concentrated EGCG >800mg/day for hepatotoxicity. No polyphenol % or EGCG mg disclosed in title. Would improve with polyphenol standardization and dose ceiling.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "horny-goat-weed-extract",
      "title": "Horny Goat Weed Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/20c5b655-c6be-44bd-8b15-81996a70a7f8_large_be69b313-4628-475a-95fc-67b35bd3f225.jpg?v=1787417439",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "horny",
        "goat",
        "weed",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 16.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790617858245",
      "vsf_explanation": "Epimedium (horny goat weed) extract — traditional Chinese medicine for libido and erectile function. The active icariin has some preclinical PDE5-inhibition data, but human RCT evidence is scant and largely poor-quality. Standardization to icariin percentage (typically 10-60%) matters heavily for potency and is often not disclosed on generic-tier products. Standard Swanson manufacturing. Would move higher with icariin standardization percentage disclosed, human RCT citations, and clearer safety framing given theoretical PDE5-inhibitor interactions with nitrates.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "banaba-extract-higher-strength-standardized",
      "title": "Banaba Extract - Higher Strength Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ab083fa5-0e6d-4b6c-ba78-b7f3724e990c_large_59d590b2-09f8-4dc4-aec6-eabd6d1224ea.jpg?v=1787417439",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "banaba",
        "extract",
        "higher",
        "strength",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790617891013",
      "vsf_explanation": "Banaba (Lagerstroemia speciosa, corosolic acid) has preliminary evidence for glucose regulation (Judy 2003) at 32-48mg standardized. Higher-strength standardized is a plus but % corosolic acid not disclosed. Would improve with 1-2% corosolic acid standardization confirmed and dose specification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "green-tea-extract-60-polyphenols",
      "title": "Green Tea Extract - 60% Polyphenols",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/47d0775f-cc1b-4d61-aff7-1d99c8be71c2_large_300ca990-6dd0-4443-a0f1-bf52b54e4e49.jpg?v=1787417440",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "green",
        "tea",
        "extract",
        "polyphenols",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 66,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 66,
        "sustainability": 55
      },
      "price": 10.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790617923781",
      "vsf_explanation": "Standardized to 60% polyphenols — a clearly disclosed spec, transparency positive. Safety flag on concentrated EGCG hepatotoxicity remains. Would move to Verified with EGCG mg breakdown, dose ceiling, and hepatic-safety warning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "grape-seed-extract-with-meganatural-gold-2-pack",
      "title": "Grape Seed Extract with MegaNatural Gold - 2 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2dd342db-0ef3-49c8-ba09-471596710371_large_9cb91d01-88c5-469a-b763-c35a1f2baf25.jpg?v=1787417440",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "grape",
        "seed",
        "extract",
        "with",
        "meganatural",
        "gold",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 70,
        "manufacturing": 65,
        "safety": 68,
        "transparency": 68,
        "sustainability": 60
      },
      "price": 15.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790618677445",
      "vsf_explanation": "MegaNatural Gold grape seed extract at multi-pack — same branded ingredient with Sivaprakasapillai 2009 BP evidence. Would move to Verified 70+ with confirmed 300mg clinical serving.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "aloe-vera-1",
      "title": "Aloe Vera",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0fb60e56-ff3a-44a4-8c6f-648003dd5161_large_b2349196-2825-4b1a-8e82-195f387f335c.jpg?v=1787417441",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "aloe",
        "vera",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 58,
        "transparency": 55,
        "sustainability": 52
      },
      "price": 20.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790618710213",
      "vsf_explanation": "Oral aloe vera inner-leaf has small IBS and UC trials (Langmead 2004) with modest symptom improvement. Whole-leaf preparations contain anthraquinones (aloin) that can be irritant and are IARC Group 2B (possibly carcinogenic); decolorized inner-leaf is preferred. Label needs to specify aloin-removed to be safety-appropriate. Would move to Verified 70+ with certified aloin <10 ppm and named IASC certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "grape-seed-extract-with-meganatural-gold",
      "title": "Grape Seed Extract with MegaNatural Gold",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/614b6bc9-0cca-4069-afd3-568d49dbfb97_large_14e8addd-e10c-4303-850c-56d2aa67bf4a.jpg?v=1787417442",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "grape",
        "seed",
        "extract",
        "with",
        "meganatural",
        "gold",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 70,
        "manufacturing": 65,
        "safety": 68,
        "transparency": 68,
        "sustainability": 60
      },
      "price": 8.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790618742981",
      "vsf_explanation": "MegaNatural-BP (Gold) is Constellation's named California grape seed extract with published RCT evidence for blood pressure (Sivaprakasapillai 2009) at 300mg/day. Named branded ingredient is a genuine quality upgrade. Would move to Verified 70+ with confirmed 300mg clinical dose per serving.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ginger-root-standardized-and-whole-herb",
      "title": "Ginger Root - Standardized and Whole Herb",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0cedddfe-dc34-465c-836f-853aceaadd2f_large_e285a96c-9b23-48cf-a40c-173b1e3f8699.jpg?v=1787417443",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ginger",
        "root",
        "standardized",
        "and",
        "whole",
        "herb",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 66,
        "transparency": 60,
        "sustainability": 52
      },
      "price": 15.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790619496645",
      "vsf_explanation": "Hybrid standardized-plus-whole-herb approach combines a defined extract for consistency with full-spectrum ginger constituents, a reasonable formulation logic. Nausea and mild anti-inflammatory evidence for ginger is solid at 500-1500 mg/day. Marker % not disclosed at title level. Would move to Verified 70+ with named 5% gingerol extract and per-fraction mg breakdown.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "tart-cherry-turmeric-features-hiactives-tart-cherry",
      "title": "Tart Cherry & Turmeric - Features HiActives Tart Cherry",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7d909430-e648-40d5-b493-3264c116d625_large_f6509a3c-a357-4dd1-9f28-8b787478b3d4.jpg?v=1787417442",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tart",
        "cherry",
        "turmeric",
        "features",
        "hiactives",
        "tart",
        "cherry",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 66,
        "formulation": 68,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 66,
        "sustainability": 62
      },
      "price": 11.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790619529413",
      "vsf_explanation": "HiActives (Nutragenesis) is a branded tart cherry concentrate used in exercise-recovery trials at effective anthocyanin doses (Kuehl 2010 marathon soreness). Pairing with turmeric adds a complementary NF-kB/COX-inflammation axis. Held to top of Standard rather than Verified because the turmeric component's form (curcuminoid % + bioavailability carrier) isn't specified — this is the pharmacologically-limiting active. Would move to Verified 70+ with named C3 Complex or phytosome turmeric plus per-lot COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dgl-deglycyrrhizinated-licorice-root-extract-higher-strength",
      "title": "DGL Deglycyrrhizinated Licorice Root Extract - Higher Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8dc8264f-b210-4e5b-a96e-eb73c988be32_large_f4629e28-cffb-4bd0-aba3-9519aff923d9.jpg?v=1787417443",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dgl",
        "deglycyrrhizinated",
        "licorice",
        "root",
        "extract",
        "higher",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 66,
        "formulation": 70,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 65,
        "sustainability": 52
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790619562181",
      "vsf_explanation": "Higher-strength DGL for functional dyspepsia and gastric mucosal support. Removing glycyrrhizin retains mucosal-healing activity while eliminating BP/potassium risk of whole licorice — a genuine safety win. Small RCTs (Raveendra 2011 with GutGard) support symptom relief. Chewable delivery is preferred for local mucosal effect. Would move to Verified 70+ with named GutGard licensing and chewable dosage form.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "curqfen-curcumin-fenugreek-complex-standardized",
      "title": "CurQfen Curcumin/Fenugreek Complex - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/dc063eaf-7700-4976-b967-68a6b1f8c478_large_d664577d-a0c7-4e7d-a46b-a07427d6dcff.jpg?v=1787417442",
      "score": 73,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "curqfen",
        "curcumin",
        "fenugreek",
        "complex",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 76,
        "formulation": 78,
        "manufacturing": 72,
        "safety": 72,
        "transparency": 74,
        "sustainability": 60
      },
      "price": 29.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790619594949",
      "vsf_explanation": "CurQfen is a galactomannan-fenugreek fiber curcumin delivery system with published pharmacokinetics showing ~46x higher free curcumin bioavailability versus unformulated curcumin (Kumar 2016), plus clinical work on inflammatory and cardiometabolic markers. Meaningful branded upgrade over generic 95% curcuminoids. Held to Verified rather than Elite because independent replication outside the sponsor is still limited and Swanson doesn't publish per-lot COA. Would move to Elite 85+ with independent RCT replication and third-party testing disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "maximum-strength-grape-seed-extract-standardized",
      "title": "Maximum Strength Grape Seed Extract - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cfba2f26-00e6-4790-8d1f-347e54fe06e4_large_f0e43e49-d0a1-4b7c-87b5-f3cd6a7f1655.jpg?v=1787417443",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "maximum",
        "strength",
        "grape",
        "seed",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 66,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790619627717",
      "vsf_explanation": "Maximum-strength grape seed extract for CV support. Higher dose is a plus but formulation/branding not disclosed. Would move to Verified with 95% OPC standardization and named source.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "estro8pn-hop-extract",
      "title": "Estro8PN Hop Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c3a48e08-c382-404c-ab19-2c38180804af_large_4d111c42-facc-4d69-91dc-d7a609afd2d4.jpg?v=1787417443",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "estro8pn",
        "hop",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 60,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 20.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790619660485",
      "vsf_explanation": "Estro8PN is a branded 8-prenylnaringenin hop extract — a potent phytoestrogen with preliminary RCT evidence for menopausal hot flashes (Heyerick 2006). Named branded ingredient is a quality plus. Safety flag: strong phytoestrogen, contraindicated in estrogen-sensitive conditions. Would improve with clearer contraindication disclosure and 3rd party verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "iron-lion-capsules-jamaican-roots-tonic-supplement-with-sarsaparilla-chaney-root-cocolmeca-strongback-allman-strength",
      "title": "Iron Lion Capsules | Jamaican Roots Tonic Supplement with Sarsaparilla, Chaney Root (Cocolmeca), Strongback, Allman Strength",
      "vendor": "Yaga Lifestyle",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Render_1_Iron_Lion.png?v=1787417444",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "iron",
        "lion",
        "capsules",
        "jamaican",
        "roots",
        "tonic",
        "supplement",
        "with",
        "sarsaparilla",
        "chaney",
        "root",
        "cocolmeca",
        "strongback",
        "allman",
        "strength",
        "yaga",
        "lifestyle"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 30,
        "sustainability": 55
      },
      "price": 38.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790619693253",
      "vsf_explanation": "Capsule version of the Iron Lion roots tonic — same multi-root Caribbean vitality formula (sarsaparilla, chaney root, cocolmeca, strongback, allman strength) with no per-herb mg breakdown. RCT evidence for the blend is minimal. Small-brand manufacturing without third-party COAs. Autofailed on proprietary-blend labeling; would move up with per-herb mg and standardization disclosure.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "hawthorn-featuring-hawthorn-berry-extract-standardized",
      "title": "Hawthorn - Featuring Hawthorn Berry & Extract Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c4c69993-f921-45fc-ae6e-ddd3d1067b7e_large_63df2f6d-2dd9-4125-ab34-ba94881f95d2.jpg?v=1787417444",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hawthorn",
        "featuring",
        "hawthorn",
        "berry",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 66,
        "manufacturing": 62,
        "safety": 64,
        "transparency": 64,
        "sustainability": 55
      },
      "price": 12.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790619726021",
      "vsf_explanation": "Standardized hawthorn extract has Cochrane-level evidence (Pittler 2008) as an adjunct in mild heart failure at 900-1800 mg/day of extract standardized to procyanidins/flavonoids. Combining whole-berry powder with standardized extract is a reasonable full-spectrum approach. Held below Verified because the exact procyanidin standardization percentage and daily extract mg are not confirmed on the SKU listing, and no do-consult-clinician note for users with existing heart conditions is highlighted. Would move to Verified 70+ with disclosed standardization % (typically 2-3% flavonoids or 18-20% OPCs) and clear per-serving extract mg.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bamboo-extract",
      "title": "Bamboo Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/019fb3ca-9ead-7226-aded-eb68ce23557a.jpg?v=1787417444",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bamboo",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 12.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790619758789",
      "vsf_explanation": "Bamboo extract is a natural silica source often marketed for hair/skin/nails and connective tissue. Human oral silica RCT evidence for skin/hair endpoints is thin (Barel 2005 orthosilicic acid is the strongest data, not bamboo). No silica % disclosed. Would improve with 70% silica standardization and clinical dose specification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "holy-basil-extract-standardized",
      "title": "Holy Basil Extract - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/56bba759-dd09-475f-bad6-47d961a832b7_large_fa21ea61-028b-4ae0-a6ac-4e4779365526.jpg?v=1787417444",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "holy",
        "basil",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 66,
        "manufacturing": 60,
        "safety": 66,
        "transparency": 64,
        "sustainability": 55
      },
      "price": 4.6,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790619791557",
      "vsf_explanation": "Duplicate SKU of the standardized holy basil extract. Human evidence for stress and anxiety in 500-500mg BID range (Bhattacharyya 2008, Saxena 2012). Held at Standard because standardization target (ursolic acid vs eugenol) and percentage not disclosed at title level. Would move to Verified 70+ with the specific standardization named (e.g., 2.5% ursolic acid).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "higher-strength-grape-seed-extract-standardized",
      "title": "Higher Strength Grape Seed Extract - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d90a440f-5d70-4e34-9aa3-5270791fad23_large_d9cd2102-e330-4d80-a9cc-b11c1f66e8b5.jpg?v=1787417444",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "higher",
        "strength",
        "grape",
        "seed",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 66,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 7.75,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790619824325",
      "vsf_explanation": "Higher-strength grape seed OPCs — same evidence base as base grape seed. Would move to Verified with disclosed 95% OPC standardization and branded ingredient.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "echinacea-standardized",
      "title": "Echinacea - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/87eea89e-4df3-4555-ac93-2172147cc0ae_large_a321fb38-feb6-4e55-b087-a1002f4dccd6.jpg?v=1787417444",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "echinacea",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 62,
        "sustainability": 58
      },
      "price": 5.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790619889861",
      "vsf_explanation": "Standardized echinacea (usually to 4% phenolic compounds or echinacosides) — better than generic echinacea powder because the Karsch-Volk 2014 Cochrane review found evidence mainly for cold-duration reduction, and standardization is the variable that separates products with any activity from filler powder. The species matters: E. angustifolia and E. purpurea differ pharmacologically, and the title doesn't specify. Held to mid-Standard by species and phenolic percentage ambiguity. Would move up with species + standardization disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ginkgo-with-vinpocetine-standardized",
      "title": "Ginkgo with Vinpocetine - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a61f9250-6f3c-4522-8ce4-801e74a1757e_large_ae4a3d3c-aacc-4595-bb96-83ad4a5621ac.jpg?v=1787417444",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ginkgo",
        "with",
        "vinpocetine",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 15,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 9.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790619955397",
      "vsf_explanation": "Ginkgo + vinpocetine combines a standardized botanical extract with a semi-synthetic vinca-alkaloid derivative. Vinpocetine has some cognitive-blood-flow evidence but has been the subject of FDA warnings about pregnancy risk (miscarriage/fetal harm) and is a controlled substance in some countries. Ginkgo adds an additive antiplatelet/bleeding-risk concern. Safety score reflects both the pregnancy warning gap and the compounded bleeding risk. Would move to Verified 70+ with prominent pregnancy contraindication and bleeding-risk disclosure - or drop vinpocetine entirely. FDA has stated vinpocetine is not a lawful dietary ingredient and carries pregnancy-harm risk (miscarriage/fetal harm) — held at Rejected under safety_concern.",
      "vsf_autofail_rule": "safety_concern"
    },
    {
      "handle": "dual-ginseng-plus",
      "title": "Dual Ginseng Plus",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5c826ccf-8b9f-4e1b-b985-8213bb2eb334_large_ed8c8cce-1d67-4975-8a0f-4c552dfef40a.jpg?v=1787417444",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dual",
        "ginseng",
        "plus",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 58,
        "sustainability": 58
      },
      "price": 6.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790619922629",
      "vsf_explanation": "Single-pack version of the Dual Ginseng SKU — same evaluation. Rational Asian+American ginseng pairing, held to mid-Standard by unspecified ginsenoside percentage and standard Panax ginseng drug-interaction concerns.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "goldenseal-root-standardized",
      "title": "Goldenseal Root - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/91ed3420-4160-4128-81e7-d3fd6dee56a8_large_4d7c1ea7-4b88-498e-8200-0250624216b6.jpg?v=1787417445",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "goldenseal",
        "root",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 58,
        "transparency": 60,
        "sustainability": 40
      },
      "price": 15.65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790619857093",
      "vsf_explanation": "Goldenseal (Hydrastis canadensis) contains berberine and hydrastine with in-vitro antimicrobial activity but essentially no meaningful RCT evidence for immune or infection outcomes. Standardization to alkaloids is a formulation positive. Sustainability is a real concern — wild Hydrastis is on the CITES Appendix II list; ethical cultivation should be verified. Would move to Verified 70+ with United Plant Savers or FairWild sourcing and clinical-outcome trials.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ginger-root-extract-maximum-strength-standardized",
      "title": "Ginger Root Extract - Maximum Strength Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9d57118e-5fbc-4a9e-9dbf-8fcba55a9979_large_59adcf8f-0eaa-4573-9d22-784d1a0e06a5.jpg?v=1787417444",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ginger",
        "root",
        "extract",
        "maximum",
        "strength",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 66,
        "transparency": 62,
        "sustainability": 52
      },
      "price": 10.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790619988165",
      "vsf_explanation": "Ginger has robust nausea evidence (Ernst & Pittler 2000, Ozgoli 2009 for pregnancy) at 500-1500 mg/day. Standardization improves consistency of gingerol/shogaol delivery vs whole-herb powder. 'Maximum strength standardized' is a positive but the specific marker percentage is not visible on the title. Would move to Verified 70+ with 5% gingerol standardization and named studied dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "black-ginger-extract-standardized",
      "title": "Black Ginger Extract - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/70816fbf-0cde-4099-8cf4-8fc736e5f4c2_large_7f1d6083-a802-4509-b10b-3145efaf09c5.jpg?v=1787417446",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "black",
        "ginger",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 62,
        "sustainability": 52
      },
      "price": 22.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790620741829",
      "vsf_explanation": "Black ginger (Kaempferia parviflora) contains methoxyflavones and has small trials for physical performance, testosterone, and energy metabolism (Wattanathorn 2012). Standardization to 5,7-dimethoxyflavone is the recognized marker. Evidence base is small, mostly Thai and Japanese trials, not yet large-scale confirmed. Would move to Verified 70+ with named extract (e.g., BlackGinger Ex) and per-marker mg disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "curcumin-complex-standardized-with-bioperine",
      "title": "Curcumin Complex - Standardized with BioPerine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/08c9867b-18d8-4f8d-ac4c-0198c2f2c0e5_large_61583ffb-0aa2-4931-b57b-c98daf34a1d2.jpg?v=1787417446",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "curcumin",
        "complex",
        "standardized",
        "with",
        "bioperine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 74,
        "formulation": 74,
        "manufacturing": 70,
        "safety": 72,
        "transparency": 70,
        "sustainability": 60
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790620774597",
      "vsf_explanation": "BioPerine (Sabinsa's 95% piperine) at ~5 mg with standardized curcumin (typically 95% curcuminoids as C3 Complex) is the classic Shoba 1998 protocol — 20x bioavailability enhancement over unformulated curcumin. This is a genuinely evidence-based formulation choice, not just marketing. Held to low Verified because the title does not name C3 Complex explicitly (Swanson's Curcumin Complex line has used both C3 and generic 95% turmeric), and Swanson doesn't publish per-lot COA. Would move to Elite with C3 named and per-lot testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "grape-seed-extract-standardized",
      "title": "Grape Seed Extract - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fc75c2d3-b647-4579-8472-b56344847c62_large_64017bbb-a1c8-4fb7-9d2f-af3c2410eed3.jpg?v=1787417448",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "grape",
        "seed",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 66,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 7.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790621790405",
      "vsf_explanation": "Grape seed OPCs have evidence for blood pressure and endothelial function (Feringa 2011 meta-analysis) at 100-300mg standardized to ~95% OPC. 'Standardized' needs a % disclosure to be actionable. Would move to Verified with 95% OPC standardization and branded ingredient (MegaNatural, Enovita).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "black-currant-extract",
      "title": "Black Currant Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/511c8540-4370-4749-8e2c-27302e6f82d6_large_295f6d81-c657-4b85-ab45-8eb022cdd5cd.jpg?v=1787417448",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "black",
        "currant",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 14.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790621757637",
      "vsf_explanation": "Black currant is a good anthocyanin source with preliminary evidence for eye/microcirculation (Nakaishi 2000). No anthocyanin % standardization disclosed. Would improve with 25-35% anthocyanin standardization and clinical dose targeting visual/vascular endpoints.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "higher-strength-grape-seed-extract-standardized-2-pack",
      "title": "Higher Strength Grape Seed Extract - Standardized - 2 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d4d0f183-9d78-4222-a07a-b836f869e6fe_large_e9caa361-25d7-4991-942e-e76669414760.jpg?v=1787417448",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "higher",
        "strength",
        "grape",
        "seed",
        "extract",
        "standardized",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 66,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 26.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790621823173",
      "vsf_explanation": "Higher-strength grape seed OPCs at multi-pack pricing — same evidence base as base grape seed for BP and endothelial (Feringa 2011). Would move to Verified with 95% OPC standardization and named branded source.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dgl-deglycyrrhizinated-licorice-root-extract",
      "title": "DGL Deglycyrrhizinated Licorice Root Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3185375d-4ec7-4e8b-917f-bc44dee1f4ec_large_1cb4af9e-f9f1-435a-b6ea-2469c49e87e2.jpg?v=1787417448",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dgl",
        "deglycyrrhizinated",
        "licorice",
        "root",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 65,
        "sustainability": 52
      },
      "price": 15.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790621855941",
      "vsf_explanation": "DGL (deglycyrrhizinated licorice) is used for functional dyspepsia and gastric mucosal support; small trials (Raveendra 2011 with GutGard) show symptom benefit. Removing glycyrrhizin eliminates the pseudoaldosteronism/BP-elevation risk of whole licorice — a meaningful safety upgrade. The dose and chewable-vs-capsule delivery form matter for symptom relief. Would move to Verified 70+ with a named DGL extract (e.g., GutGard) and studied dose disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dual-ginseng-plus-2-pack",
      "title": "Dual Ginseng Plus - 2 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8020425f-de23-4182-adbf-e309ac05d1f0_large_953d40cd-b260-421a-8a16-3ac887840afe.jpg?v=1787417448",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dual",
        "ginseng",
        "plus",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 58,
        "sustainability": 58
      },
      "price": 10.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790621954245",
      "vsf_explanation": "Dual ginseng typically pairs Panax ginseng (Asian) with Panax quinquefolius (American) — different ginsenoside profiles targeting energy/immune adaptation. American ginseng has the CVT-E002/COLD-fX immune-modulation data (Predy 2005) but this SKU isn't the branded ingredient. Held to mid-Standard by absence of ginsenoside standardization percentage. Panax ginseng has drug interactions with warfarin and MAOIs. Would move up with disclosed ginsenoside % and interaction labeling.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "moringa-medina-capsules",
      "title": "Moringa Medina Capsules",
      "vendor": "Yaga Lifestyle",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Moringa1.png?v=1787417468",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "moringa",
        "medina",
        "capsules",
        "yaga",
        "lifestyle"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 65,
        "transparency": 50,
        "sustainability": 60
      },
      "price": 40.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790627197125",
      "vsf_explanation": "Moringa oleifera leaf has moderate RCT support for glycemic and lipid endpoints (Kumari 2010, Anthanont 2016), but typical capsule doses are far below the studied 5-10g/day range. This label doesn't disclose leaf/extract ratio, standardization, or per-cap mg. Small brand with no third-party testing visible. Would move to Standard 62+ with clear mg dosing, extract standardization, and heavy-metal/aflatoxin assays.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "butchers-broom-extract-standardized",
      "title": "Butcher's Broom Extract - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/96776389-a07c-4892-af48-fcd174dd24e1_large_c13835a2-4ad9-484f-ada9-435e0dee16bb.jpg?v=1787417468",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "butcher",
        "broom",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 10.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790627229893",
      "vsf_explanation": "Butcher's broom (Ruscus aculeatus, ruscogenins) has preliminary evidence for chronic venous insufficiency (Vanscheidt 2002). 'Standardized' claim lacks % ruscogenin disclosure in title. Would improve with 9-11% ruscogenins standardization and clinical dose (150-300mg).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "shilajit-extract-extra-strength",
      "title": "Shilajit Extract - Extra Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33447c59-7907-48ed-bd65-9a14efbd62fe_large_7cec51a7-9b3c-45ee-a524-f2502d208e62.jpg?v=1787417468",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shilajit",
        "extract",
        "extra",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 12.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790627262661",
      "vsf_explanation": "Extra strength shilajit — 'extra strength' is a marketing descriptor, not a quality specification. Shilajit's evidence base (Pandit 2016 for testosterone, Keller 2019 for connective tissue) is at specific doses of the PrimaVie material. Higher dose is not necessarily better — quality depends on fulvic acid content and heavy-metal freedom, both of which need third-party testing (raw shilajit can carry mercury/lead). Held at Standard because sourcing is not named and heavy-metal testing not published. Would move up with PrimaVie or Purblack sourcing plus heavy-metal COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "jamaican-purple-sea-moss-capsules-60-vegan-capsules",
      "title": "Jamaican Purple Sea Moss Capsules | 60 Vegan Capsules",
      "vendor": "Yaga Lifestyle",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/JamaicanPurpleSeaMossCapsules60VeganCapsules-1.png?v=1787417476",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "jamaican",
        "purple",
        "sea",
        "moss",
        "capsules",
        "vegan",
        "capsules",
        "yaga",
        "lifestyle"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 39.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790630899909",
      "vsf_explanation": "Sea moss (Chondrus crispus / Gracilaria) is a social-media-driven category with no RCT support for the '92 minerals' marketing claim; actual mineral content per capsule dose is well below RDA. The purple variety is claimed higher in antioxidants but this is not clinically demonstrated. Heavy-metal concerns (seaweed accumulates iodine, arsenic, cadmium) make third-party testing especially important, and none is visible. Would move to Standard 60 with published heavy-metal/iodine assays.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "milk-thistle-combination-2-pack",
      "title": "Milk Thistle Combination - 2 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/130af85b-d34b-4ed5-a2dd-f1417a6c65de_large_8e5c0fdc-2006-470b-821c-c31545e22170.jpg?v=1787417497",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "milk",
        "thistle",
        "combination",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 58,
        "sustainability": 58
      },
      "price": 11.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790639124677",
      "vsf_explanation": "'Milk Thistle Combination' typically pairs milk thistle with dandelion, artichoke, or turmeric — a rational traditional-herbal liver-support stack. Held to mid-Standard by 'combination' framing that typically obscures the actual silymarin percentage on the milk thistle component and per-herb milligrams. The 2-pack format doesn't affect quality but signals bundled retail value rather than clinical differentiation. Would move up with silymarin standardization and per-herb dose disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "muira-puama-10-1-root-extract",
      "title": "Muira Puama - 10:1 Root Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/514273a2-002a-40ee-95ab-0ae94f5d2f94_large_1e04c6cc-221e-4ac7-a336-4364b6e2ec15.jpg?v=1787417497",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "muira",
        "puama",
        "root",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 8.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790639091909",
      "vsf_explanation": "Muira puama is marketed for libido and stamina with almost no controlled human RCT evidence beyond small open-label observations. '10:1' is a concentration ratio, not a standardization to bioactive compounds. Would need modern RCT support to score higher; currently a traditional-use product with limited scientific backing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "milk-thistle-combination",
      "title": "Milk Thistle Combination",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1c8d3f07-3a06-4852-b07a-62670e9bb713_large_e45d874c-5f1d-4dcb-a4f6-0bd1aeff782b.jpg?v=1787417496",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "milk",
        "thistle",
        "combination",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 58,
        "sustainability": 58
      },
      "price": 3.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790639026373",
      "vsf_explanation": "Milk thistle combined with complementary liver herbs (typically dandelion/artichoke/turmeric) — legitimate traditional stack that pattern-matches European hepatology practice. Held to mid-Standard by no disclosed silymarin standardization percentage and no bioavailability enhancement. Would move up with named silymarin percentage (>=80%) and phytosome delivery on the milk thistle component.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "holy-basil-extract-standardized-1",
      "title": "Holy Basil Extract - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c17b6091-9a2a-45b9-b670-38decc5c39e1_large_8f4bb465-89a4-4894-889f-662184484c24.jpg?v=1787417497",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "holy",
        "basil",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 66,
        "manufacturing": 60,
        "safety": 66,
        "transparency": 64,
        "sustainability": 55
      },
      "price": 8.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790639157445",
      "vsf_explanation": "Standardized holy basil (Ocimum sanctum / tulsi) extract. Human evidence includes Bhattacharyya 2008 on stress markers (500mg BID) and Saxena 2012 on generalized anxiety (500mg/day). Quality holy basil is standardized to ursolic acid or specific eugenol/rosmarinic acid content — 'standardized' at title is a positive signal but the actual constituent target and percentage is not disclosed. Held at Standard on this transparency gap. Would move to Verified 70+ with standardization percent + target constituent disclosed (e.g., 2.5% ursolic acid).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "milk-thistle-features-80-silymarin",
      "title": "Milk Thistle - Features 80% Silymarin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6268fdc1-37f7-43cc-95a2-f0dfa523738c_large_b2331ac0-a7fa-4c5b-89bd-cba3fa2448d6.jpg?v=1787417497",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "milk",
        "thistle",
        "features",
        "silymarin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 72,
        "sustainability": 58
      },
      "price": 14.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790639354053",
      "vsf_explanation": "Standard-of-market milk thistle SKU at 80% silymarin standardization — the concentration used in most European clinical hepatology trials (Loguercio 2012 for NAFLD; Rambaldi 2005 Cochrane on alcoholic/viral liver disease). Named percentage in the title is a genuine transparency strength for a Swanson SKU. Held to top of Standard rather than Verified because plain 80% silymarin still has ~10% oral bioavailability without a phytosome carrier. Would move to Verified 70+ with Siliphos or Silybin phytosome upgrade.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "prune-senna",
      "title": "Prune & Senna",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/25ec98fd-cde1-4bcd-b3c7-60bfd73ecf21_large_964a1859-1195-425e-94e7-f13c2fb787cd.jpg?v=1787417497",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "prune",
        "senna",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 45,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 3,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790639059141",
      "vsf_explanation": "Senna is an effective short-term stimulant laxative but has real safety concerns — dependency with chronic use, electrolyte disturbance, melanosis coli. FDA has flagged children's dosing. Prune is benign fiber. Combining with senna undermines the gentle-fiber positioning. Would need prominent short-term-use warnings and pediatric contraindication to score higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "triple-mushroom-complex-3-mushroom-formula",
      "title": "Triple Mushroom Complex - 3 Mushroom Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/df84f718-015c-49bc-995f-438b6a365544_large_a0645b60-855a-47a1-9148-59edf22f594a.jpg?v=1787417497",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "triple",
        "mushroom",
        "complex",
        "mushroom",
        "formula",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 21.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790639190213",
      "vsf_explanation": "Triple-mushroom blends (typically reishi + maitake + shiitake) are a reasonable directional stack but complex framing hides per-mushroom mg and the fruiting-body vs mycelium sourcing question that dominates mushroom-supplement quality. Beta-glucan percentage not disclosed. Held to mid-Standard because the ingredients are legitimate but the label transparency doesn't support informed dosing. Would move up with fruiting-body-only, dual-extract processing, and disclosed beta-glucan content.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bilberry-maximum-strength",
      "title": "Bilberry - Maximum Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b37dbdfc-93d1-48dd-b3b2-d19e4a7e39a2_large_68df4943-e830-4aa3-aec5-85458256cb39.jpg?v=1787417497",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bilberry",
        "maximum",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 58,
        "sustainability": 52
      },
      "price": 28.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790639222981",
      "vsf_explanation": "Bilberry (Vaccinium myrtillus) anthocyanins have moderate evidence for microcirculation and mild visual-function support (Kamiya 2013). Clinical trials use 25-36% anthocyanin standardized extracts at 160-320 mg. 'Maximum strength' without disclosed anthocyanin % or per-serving mg makes evidence-alignment unverifiable. Would move to Verified 70+ with 25% anthocyanin standardization and per-active mg disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "olive-leaf-extract",
      "title": "Olive Leaf Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/49b5b6bb-1a69-43f9-bf6a-ccd51c54b4c2_large_e5a6a643-e0d6-4a2d-9629-db136817f7f9.jpg?v=1787417497",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "olive",
        "leaf",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 58,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 55,
        "sustainability": 58
      },
      "price": 18.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790639255749",
      "vsf_explanation": "Basic olive leaf extract capsule; same profile as the sibling generic SKU — legitimate herb, weak label transparency, likely unstandardized. Bioactive predictability depends on oleuropein content which isn't disclosed. Would move up with named 18-20% oleuropein standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pomegranate-complex-featuring-pomactiv-and-pomegranatep40p",
      "title": "Pomegranate Complex - Featuring PomActiv and PomegranateP40p",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/95276bda-7743-48a8-a43b-a78359d58d6f_large_c5f7ac92-0926-4533-82d8-0f005799ee78.jpg?v=1787417497",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pomegranate",
        "complex",
        "featuring",
        "pomactiv",
        "and",
        "pomegranatep40p",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 12.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790639288517",
      "vsf_explanation": "Uses two named branded pomegranate ingredients (PomActiv and PomegranateP40p standardized to 40% punicalagins) — a real transparency and quality upgrade over generic pomegranate extract. Punicalagin content is the meaningful bioactive driver. Would move to Verified 70+ with per-ingredient mg disclosure and third-party assay.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "celery-seed-extract-maximum-strength",
      "title": "Celery Seed Extract - Maximum Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9078c020-ba10-4b72-bafe-671c1bc49025_large_ee45d9aa-6774-4bc8-a7a0-ec8da518e266.jpg?v=1787417497",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "celery",
        "seed",
        "extract",
        "maximum",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 19.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790639321285",
      "vsf_explanation": "Celery seed (3-n-butylphthalide) is often marketed for blood pressure and uric acid; RCT evidence is preliminary. 'Maximum Strength' is a marketing claim, not a standardization spec. Safety flag: possible photosensitivity and diuretic interaction. Would improve with % 3nB standardization and clinical dose from Moghadam 2013 (150mg 85% extract).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "robuvit-french-oak-wood-extract",
      "title": "Robuvit French Oak Wood Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/aa83ebe9-c6f7-45b6-ae67-f2391bcc5625_large_d33eabf3-cc8e-4219-835c-3601f2254cb6.jpg?v=1787417497",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "robuvit",
        "french",
        "oak",
        "wood",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 70,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 65,
        "sustainability": 60
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790639386821",
      "vsf_explanation": "Robuvit is Horphag's branded French oak wood extract (Quercus robur roburins) with RCT evidence for fatigue (Belcaro 2014) and post-viral recovery at 300mg/day. Named branded ingredient with real clinical support. Would move to Verified 70+ with confirmed 300mg clinical dose and third-party verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "olive-leaf-extract-1",
      "title": "Olive Leaf Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71b04af0-7438-4029-b24c-b2f7477c79ad_large_aa75528f-ade0-4686-b6f4-f1ae67cb98b4.jpg?v=1787417497",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "olive",
        "leaf",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 58,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 55,
        "sustainability": 58
      },
      "price": 13.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790639485125",
      "vsf_explanation": "Basic olive leaf extract SKU without a 'standardized' descriptor in the title — this is Swanson's cheaper entry-level herbal line, which typically means unstandardized whole-leaf powder rather than a defined oleuropein content. Legitimate ingredient but less pharmacologically predictable than standardized alternatives (Susalit 2011 dosing depends on defined oleuropein exposure). Would move up with any standardization signal on-label.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pine-bark-extract-standardized",
      "title": "Pine Bark Extract - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4401d6fb-f04b-4461-90f2-d33ee74c2ade_large_d5d01fcf-ec0b-425a-b481-9369a0ffb7e2.jpg?v=1787417497",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pine",
        "bark",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 7.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790639419589",
      "vsf_explanation": "Pine bark polyphenols (typically 95% OPC standardized) have solid evidence for endothelial function and venous insufficiency (Belcaro meta-analyses). Generic pine bark may or may not match Pycnogenol clinical data. Would move to Verified 70+ with 95% OPC standardization confirmed and branded Pycnogenol sourcing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "rosemary-extract-standardized",
      "title": "Rosemary Extract - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a37dbfe2-dc01-4b0f-b84a-605454c2a937_large_0647355e-6244-492e-9e95-3055384b96ed.jpg?v=1787417497",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "rosemary",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 66,
        "transparency": 60,
        "sustainability": 52
      },
      "price": 14.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790639452357",
      "vsf_explanation": "Rosemary (Rosmarinus officinalis) has in-vitro antioxidant evidence and small trials for cognition/memory (Moss 2003 aromatherapy), but oral supplementation evidence for meaningful health endpoints is thin. Standardization is a positive but the marker (carnosic acid vs rosmarinic acid) is not specified in the title. Would move to Verified 70+ with named carnosic-acid % and outcome-endpoint RCTs.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "saw-palmetto-maximum-strength",
      "title": "Saw Palmetto - Maximum Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2397690c-1247-425f-96ab-541f5c3a81d9_large_d77d005c-f5c4-4f30-b6e6-616990bd012a.jpg?v=1787417497",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "saw",
        "palmetto",
        "maximum",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 21.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790639517893",
      "vsf_explanation": "Maximum-strength saw palmetto likely delivering 320mg or higher — the studied BPH dose from Wilt 1998 meta-analysis. Evidence for saw palmetto BPH benefit remains mixed with the STEP trial (Bent 2006) null but earlier trials positive at the 85-95% fatty acid standardization. Higher-strength framing suggests monograph-adjacent dosing but standardization percentage typically isn't front-of-label. Would move to Verified 70+ with 85-95% fatty acid standardization explicitly disclosed and named-source lipid extract.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pueraria-mirifica-with-b6-b12-featuring-puresterol",
      "title": "Pueraria Mirifica with B6 & B12 - Featuring Puresterol",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8a8bd78c-5bdf-4153-850c-e8e1f128a756_large_4c4ea31c-4874-48db-b568-4bb0d7817a47.jpg?v=1787417497",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pueraria",
        "mirifica",
        "with",
        "b12",
        "featuring",
        "puresterol",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 66,
        "manufacturing": 62,
        "safety": 50,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 12.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790639550661",
      "vsf_explanation": "Pueraria mirifica contains potent phytoestrogens (miroestrol, deoxymiroestrol) with modest menopause-symptom evidence (Manonai 2008), and Puresterol is a named standardized extract. Safety scored low because P. mirifica has genuine estrogenic activity with unclear long-term endometrial/breast safety and contraindications in estrogen-sensitive conditions; mass-market labels rarely warn adequately. Held below Verified by safety-flag concerns despite named ingredient. Would move to Verified 70+ with explicit contraindication warnings for estrogen-sensitive cancers and clinician-consultation guidance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mulberry-leaf-extract",
      "title": "Mulberry Leaf Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e424cffc-de19-4cb7-9a5a-982a8fa1b39b_large_cbc9cc6c-1ad3-4f61-9d46-5daab3a89de9.jpg?v=1787417497",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mulberry",
        "leaf",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 4.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790639583429",
      "vsf_explanation": "Mulberry leaf (Morus alba) contains 1-deoxynojirimycin, an alpha-glucosidase inhibitor with preliminary evidence for post-meal glucose (Kim 2015). No DNJ % standardization disclosed. Would improve with DNJ standardization and clinical dose (250mg pre-meal).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "wild-yam-root-root-extract",
      "title": "Wild Yam Root - Root & Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/66fb1319-08bb-49a3-bfe0-9817b9643612_large_b28fae05-e383-4735-9f1a-895f1aa1cd2c.jpg?v=1787417498",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wild",
        "yam",
        "root",
        "root",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 8.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790639616197",
      "vsf_explanation": "Wild yam is often marketed as a natural progesterone or DHEA precursor — the human body cannot convert diosgenin to progesterone in vivo, and RCT evidence for hot flash relief is null (Komesaroff 2001). Blend of whole root plus extract without standardization. Would need honest reframing away from hormone-precursor claims to score higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "acti-joint",
      "title": "Acti-Joint",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/523a3c90-209f-42a9-8a1d-ccf18aed314a_large_37d7adf3-98bc-4b98-8ddb-57e07e7ef755.jpg?v=1787417498",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "acti",
        "joint",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 55,
        "sustainability": 52
      },
      "price": 7.45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790639648965",
      "vsf_explanation": "Generically-named joint formula with no ingredient hint in title — likely a proprietary joint blend. Without ingredient breakdown at label level, evidence anchoring is impossible. Held below Verified by opaque product name and no clinical actives called out. Would move to Verified 70+ with a rename that specifies core actives and per-mg dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "olive-leaf-extract-extra-strength",
      "title": "Olive Leaf Extract - Extra Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8968914d-cf4a-4951-8ff0-9c4de1be46e4_large_d9c84013-3a47-4d9a-84fe-c114e5209414.jpg?v=1787417499",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "olive",
        "leaf",
        "extract",
        "extra",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 60,
        "sustainability": 58
      },
      "price": 7.75,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790640533701",
      "vsf_explanation": "Extra-strength olive leaf extract, likely delivering 500-750 mg with elevated oleuropein content per capsule. Human clinical data supports mild blood pressure and glycemic effects at ~500-1000 mg/day standardized extract (Susalit 2011; Wainstein 2012). Held to mid-Standard by unspecified oleuropein percentage in the title. Would move to Verified with named oleuropein standardization (typically 18-20%) and per-lot COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "camu-camu-berries-standardized",
      "title": "Camu Camu Berries - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2cdf8409-b406-442c-9d99-33a4bb72a435_large_0fe339cf-fc94-405c-a42e-322e6fd5f48b.jpg?v=1787417499",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "camu",
        "camu",
        "berries",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 60,
        "sustainability": 62
      },
      "price": 3.6,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790640599237",
      "vsf_explanation": "Camu camu (Myrciaria dubia) is genuinely one of the highest natural vitamin C-density fruits (up to 2-3% by weight). Human trials are minimal — most evidence is compositional and preclinical antioxidant work (Inoue 2008 pilot for oxidative stress markers). A whole-food vitamin C carrier is reasonable for consumers avoiding synthetic ascorbate. Held to mid-Standard by absence of standardized ascorbic acid mg-per-serving disclosure and no per-lot COA. Would move up with disclosed vitamin C content per serving.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "valerian-root-extract-standardized",
      "title": "Valerian Root Extract - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f4f61bef-275e-40e1-a4b0-65cf0619eae7_large_137c1cdd-8e07-45a2-9f9b-3cdd72ab7cb2.jpg?v=1787417499",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "valerian",
        "root",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 66,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 66,
        "sustainability": 60
      },
      "price": 11.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790640566469",
      "vsf_explanation": "Standardized valerian extract - typically 0.8% valerenic acid - with mixed but generally positive evidence for subjective sleep quality at 400-900mg (Bent 2006 meta; Fernandez-San-Martin 2010). Standardization is the key quality marker separating this from generic valerian root. Safety is favorable but valerian is best used short-term. Would move to Verified 70+ with disclosed valerenic-acid percentage, per-lot COA, and short-term use guidance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "boswellia-serrata-extract",
      "title": "Boswellia Serrata Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6a680b7b-8d35-42eb-9618-379df0ad2aa0_large_4c1feb95-6e7d-4eb2-b33b-bf1e8a9ed3d3.jpg?v=1787417500",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "boswellia",
        "serrata",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 24.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790640632005",
      "vsf_explanation": "Boswellia has solid RCT evidence for osteoarthritis pain (Sengupta 2008) at 100-250mg standardized AKBA/day. Standard 'Extract' title lacks branded 5-Loxin or ApresFlex license, and no % boswellic acid disclosure. Would move to Verified with AKBA standardization and branded ingredient sourcing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "white-willow-bark-extract-25-salicin-standardized",
      "title": "White Willow Bark Extract 25% Salicin - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0014c150-1fff-490b-9967-dc5eb244eab1_large_70fbe6e7-9dfb-47e5-97b6-5f8386c07554.jpg?v=1787417501",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "white",
        "willow",
        "bark",
        "extract",
        "salicin",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 66,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 58,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 6.03,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790641451205",
      "vsf_explanation": "White willow bark standardized to 25% salicin is a well-formulated botanical for musculoskeletal pain (Chrubasik 2001) at 240mg salicin/day. Standardization % is clearly disclosed — a real transparency positive. Safety flag: same drug interactions as aspirin (bleeding risk, GI). Would move to Verified 70+ with drug-interaction warning and USP verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "energy-c-with-electrolytes-orange-flavor",
      "title": "Energy C with Electrolytes - Orange Flavor",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/adc7eb67-eabe-4b5a-84c3-696e7e336966_large_90ab8950-70c7-46e2-b8a9-b68bb4268526.jpg?v=1787417501",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "energy",
        "with",
        "electrolytes",
        "orange",
        "flavor",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 8.27,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790641483973",
      "vsf_explanation": "Vitamin C + electrolyte drink mix — vitamin C at 500-1000mg is well-tolerated and orally saturating (Levine 1996), and electrolyte replacement (sodium, potassium, magnesium) is legitimate for athletic hydration. 'Energy C' branding implies added caffeine or B-vitamins which are not disclosed at title level. Held at Standard because per-active dosing is not confirmed. Would move to Verified 70+ with fully-transparent electrolyte content in the studied ranges (500-1000mg sodium for exercise hydration per ACSM position) and disclosed C dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "schizandra-extract-standardized",
      "title": "Schizandra Extract - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/62853078-6c66-40bc-8374-ce72f47e2416_large_7984ae30-4fb7-4844-be63-3d9a16e2d3ac.jpg?v=1787417502",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "schizandra",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 66,
        "transparency": 60,
        "sustainability": 52
      },
      "price": 11.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790641516741",
      "vsf_explanation": "Schisandra chinensis is a traditional adaptogen with limited but growing evidence for hepatoprotection and stress modulation; small trials suggest cortisol modulation but evidence is not RCT-strong. Standardization to schisandrins (typically 2-9%) improves reliability over whole-berry powder. Traditional-medicine framing dominates; Western clinical trials remain sparse. Would move to Verified 70+ with named-standard extract (e.g., SHR-5 analog) and larger stress-endpoint RCTs.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "stinging-nettle-standardized",
      "title": "Stinging Nettle - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a1dda50e-7abf-497d-9192-5f2d0578a1da_large_cc0c332e-3071-4740-8338-4371765aaf2d.jpg?v=1787417502",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "stinging",
        "nettle",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 63,
        "sustainability": 52
      },
      "price": 17.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790641778885",
      "vsf_explanation": "Nettle root has moderate BPH-symptom evidence (Safarinejad 2005 RCT showed lower IPSS scores at 360 mg/day); leaf has weaker allergic-rhinitis signal (Mittman 1990). 'Standardized' on the label indicates disclosed active percentage, which is a formulation upgrade over whole-herb SKUs. Without leaf-vs-root indication clarity in the title, buyers can't easily self-select. Would move to Verified 70+ with clear root/leaf distinction and named-marker standardization (e.g., beta-sitosterol %).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "teavigo-green-tea-extract",
      "title": "Teavigo Green Tea Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c06a7b85-4682-4b3c-9917-ae5746bee06c_large_52584672-bad9-4cf1-941f-ee18b2936db5.jpg?v=1787417502",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "teavigo",
        "green",
        "tea",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 70,
        "manufacturing": 70,
        "safety": 60,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 8.93,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790641811653",
      "vsf_explanation": "Teavigo is DSM's 94%+ pure EGCG ingredient — decaffeinated, well-characterized, and one of the highest-quality green tea extract raw materials available. EGCG has strong evidence for antioxidant and metabolic endpoints. Safety flag: high-dose EGCG has liver-toxicity signals per EFSA — needs dose ceiling disclosure. Would move to Verified 70+ with dose cap and hepatic-safety warning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "shilajit-extract-standardized",
      "title": "Shilajit Extract - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/353f4ce7-487d-4ccf-99b1-237c1042fd7f_large_c6077ea3-096b-45ac-8efa-f9de2038e44d.jpg?v=1787417504",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shilajit",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 66,
        "sustainability": 55
      },
      "price": 7.73,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790643220677",
      "vsf_explanation": "Standardized shilajit extract — human evidence is emerging: Pandit 2016 showed testosterone support in men (250mg PrimaVie 2x/day), Keller 2019 on hydroxyproline as marker of connective tissue support. Quality shilajit is defined by fulvic acid content (typically 20-50%) and freedom from heavy-metal contamination (raw shilajit can carry high mercury/lead). 'Standardized' at title level is a positive signal but the specific fulvic acid % is not disclosed. Held at Standard because the studied PrimaVie sourcing is not named, and no third-party heavy-metal COA published. Would move to Verified 70+ with PrimaVie or Purblack sourcing named and heavy-metal testing published.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "saw-palmetto",
      "title": "Saw Palmetto",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ad0365f5-7de5-4af8-8631-3f86413257e0_large_ece69eb4-5bea-4cd1-873b-36c651b05c7e.jpg?v=1787417504",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "saw",
        "palmetto",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 21.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790643286213",
      "vsf_explanation": "Standalone Swanson saw palmetto — a generic-tier version of the BPH monograph herb. Evidence is mixed: the STEP trial (Bent 2006) was null, but earlier meta-analyses (Wilt 1998) showed modest symptom-score benefit at 320mg standardized to 85-95% fatty acids. Generic Swanson saw palmetto often uses whole-berry powder or unspecified standardization, which is unlikely to match the studied lipid-extract dose. Would move to Verified 70+ with 85-95% fatty acid standardization disclosed at 320mg/day.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "naringin-citrus-bioflavonoid",
      "title": "Naringin - Citrus Bioflavonoid",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ae36e912-90fa-4b3b-8549-17224154ddbc_large_4b85841d-394c-4f08-8acf-9b76e3ae84cf.jpg?v=1787417504",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "naringin",
        "citrus",
        "bioflavonoid",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 15.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790643253445",
      "vsf_explanation": "Naringin is the grapefruit flavonoid best known for CYP3A4 drug-interaction effects. Human oral supplementation evidence for meaningful clinical endpoints is thin. Safety concern: naringin/naringenin can meaningfully alter statin, calcium-channel-blocker, and other drug metabolism. Would need a prominent drug-interaction warning to score higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "shiitake-mushroom-extract",
      "title": "Shiitake Mushroom Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c8f46af3-c1ba-4f29-8f53-d46904593d50_large_893cda16-87c6-4b63-9014-aa4b158dd233.jpg?v=1787417504",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shiitake",
        "mushroom",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 15.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790643318981",
      "vsf_explanation": "Shiitake (Lentinula edodes) delivers lentinan — a beta-1,3/1,6-glucan with immune activity, though the strong oncology evidence base is largely from IV lentinan, not oral extracts. Standard oral shiitake products deliver polysaccharides at lower activity than injectable lentinan. Held to mid-Standard because the title doesn't specify fruiting body vs mycelium or beta-glucan percentage — the same standardization gap common to Swanson's mushroom line. Would move up with fruiting-body-only and disclosed beta-glucan >=25%.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "shatavari-root-extract-standardized",
      "title": "Shatavari Root Extract - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f702d925-2d9e-4251-b4a5-12f72fd8a407_large_54f27524-20b6-4c6f-bde5-098e1364c50b.jpg?v=1787417505",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shatavari",
        "root",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 12.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790643351749",
      "vsf_explanation": "Shatavari (Asparagus racemosus) has Ayurvedic use for female reproductive support and preliminary evidence for lactation and menopause. RCT evidence is limited. 'Standardized' needs a % steroidal saponin/shatavarin disclosure to be meaningful. Would improve with 20% saponin standardization and clinical dose (500-1000mg).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "turkey-tail-mushroom",
      "title": "Turkey Tail Mushroom",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f67db581-6a4b-4e8e-a2ef-17b483c6718f_large_fd462a5b-a360-4046-bc01-a793eda90199.jpg?v=1787417505",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "turkey",
        "tail",
        "mushroom",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790643384517",
      "vsf_explanation": "Turkey tail (Trametes versicolor) delivers PSK and PSP polysaccharides with adjuvant oncology data in Japan and Asia (Torkelson 2012 phase I in breast cancer). The strong Japanese evidence is for PSK specifically, at high standardized doses — generic oral turkey tail capsules don't reach that level of characterization. Held to mid-Standard by no fruiting-body confirmation, no PSK/PSP standardization percentage, and no dose signal. Would move up with fruiting-body extract, dual extraction, and PSK/PSP specification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "antioxidant-skin-defense",
      "title": "Antioxidant Skin Defense",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9f339cf2-537b-47d8-8705-502f4fe79b92_large_17fa700b-a796-42cf-8d48-5c8c57f393c1.jpg?v=1787417505",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "antioxidant",
        "skin",
        "defense",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 12.26,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790643417285",
      "vsf_explanation": "Generic antioxidant-for-skin blend — likely contains vitamins C, E, selenium, and possibly astaxanthin or lycopene. Individual actives have modest photoprotection/skin-aging data (astaxanthin per Tominaga 2012, tomato lycopene per Rizwan 2011) but 'antioxidant blend' framing typically means sub-therapeutic doses of many ingredients. Held below Verified by opaque active list and no named clinical astaxanthin (e.g., AstaReal) or lycopene source. Would move to Verified 70+ with per-active mg disclosure at clinical range.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bitter-melon-featuring-momordicin",
      "title": "Bitter Melon Featuring Momordicin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c6c2fd40-f3e5-465b-bf44-d5f2b4952e61_large_cfee3ee4-83eb-47bd-98ea-e0bc2dc34de6.jpg?v=1787417505",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bitter",
        "melon",
        "featuring",
        "momordicin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 14.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790643450053",
      "vsf_explanation": "Bitter melon (Momordica charantia) has mixed RCT evidence for type 2 diabetes glucose control (Yin 2015 meta-analysis inconclusive). Momordicin is a named marker compound but not a validated bioactive standardization. Safety flag: contraindicated in pregnancy. Would improve with 5-10% momordicin standardization and pregnancy warning disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "salacia-oblonga-concentrated-20-1-extract",
      "title": "Salacia Oblonga Concentrated 20:1 Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/99ecc595-e610-4cef-88c4-138c540e05cf_large_763e8dd5-7fe9-4733-ab53-02de965c98d4.jpg?v=1787417505",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "salacia",
        "oblonga",
        "concentrated",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 17.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790643515589",
      "vsf_explanation": "Salacia reticulata/oblonga has preliminary evidence as an alpha-glucosidase inhibitor for post-meal glucose (Heacock 2005). '20:1' extract ratio is a common marketing claim but doesn't standardize to active markers (mangiferin, salacinol). Would improve with named branded ingredient (Salacinol-M or similar) and clinical dose (240-480mg).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "yohimbe-standardized",
      "title": "Yohimbe - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fb31a023-d84e-4e3f-b273-a6d7d621708f_large_10f5cfcc-a92a-403c-ba3a-4ad77cc622dd.jpg?v=1787417505",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "yohimbe",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 40,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 13.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790643548357",
      "vsf_explanation": "Yohimbe bark standardized (presumably to yohimbine). Yohimbine has some evidence for erectile dysfunction (Ernst 1998 meta-analysis: modest benefit) but carries a well-documented cardiovascular safety profile — hypertension, tachycardia, arrhythmias, anxiety, and interactions with MAOIs, SSRIs, and antihypertensives. FDA and Health Canada have both flagged yohimbe products for adverse events; Cohen 2015 found many US products contain inaccurate yohimbine content. Even standardized products should carry explicit CV and drug-interaction warnings. Falls below Standard on safety alone unless robust warnings and precise yohimbine mg are disclosed on-label — recommend upgrading label safety language or delisting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "st-johns-wort-extract-standardized",
      "title": "St. John's Wort Extract - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4f788ac7-5745-4bd4-827a-aeddfbb142fa_large_2477db4c-d3a4-4525-a31f-67dac5aa71f3.jpg?v=1787417505",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "john",
        "wort",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 66,
        "manufacturing": 60,
        "safety": 45,
        "transparency": 66,
        "sustainability": 55
      },
      "price": 11.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790643581125",
      "vsf_explanation": "Standardized St. John's Wort extract (typically 0.3% hypericin) has meaningful RCT evidence for mild-to-moderate depression, comparable to some SSRIs in Linde 2008 Cochrane review at 300mg TID. Evidence and formulation are good - but safety is the dominant concern: St. John's Wort is a potent CYP3A4, CYP2C9, and P-gp inducer, causing clinically significant interactions with oral contraceptives, warfarin, HIV protease inhibitors, immunosuppressants, and many other drugs. That interaction burden is chronically under-disclosed on OTC labels. Would move to Verified 70+ with explicit, prominent CYP3A4-inducer interaction disclosure and pharmacist-consultation prompt.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "olive-leaf-extract-standardized",
      "title": "Olive Leaf Extract - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8fc29e02-6b25-42cf-a284-a91a776eae58_large_2e9ca8b4-3564-4a31-b395-fb0b339b0ffd.jpg?v=1787417506",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "olive",
        "leaf",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 62,
        "sustainability": 58
      },
      "price": 24.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790644465861",
      "vsf_explanation": "Standardized olive leaf extract (Olea europaea), typically to 12-20% oleuropein — the phenylethanoid glucoside driving most in-vitro antioxidant and antimicrobial activity. Human evidence is modest: blood pressure reduction (Susalit 2011) and glycemic markers (Wainstein 2012) at 500-1000 mg standardized extract. Held to mid-Standard because the specific oleuropein percentage isn't disclosed in the title. Would move up with named 18-20% oleuropein content and per-lot COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "saffron-extract-1",
      "title": "Saffron Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/466366a1-47b7-48af-9deb-fba21f15ab05_large_bae079d8-6f17-4ce2-ae88-52bcc1fb72c8.jpg?v=1787417506",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "saffron",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 20.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790644498629",
      "vsf_explanation": "Saffron (Crocus sativus) has strong RCT evidence for mild-moderate depression and PMS symptoms (Lopresti 2014, Kashani 2018) at 28-30mg/day of standardized extract. Base 'Saffron Extract' title lacks branded ingredient (affron/Safr'Inside) or standardization %. Would move to Verified 70+ with affron 28mg or 2% safranal standardization at clinical dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "red-wine-extract-standardized",
      "title": "Red Wine Extract - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8c90a103-a6b2-4a98-89a0-79fa4ba29193_large_fcf19c48-aa38-4727-a94d-7253c74d26f9.jpg?v=1787417509",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "wine",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 18.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790645416133",
      "vsf_explanation": "Red wine extract is typically a polyphenol/resveratrol blend, but 'red wine' isn't a specification — actual polyphenol content and OPC/resveratrol mg are the drivers. Evidence is largely mechanistic; RCT support for CV endpoints in generic red wine extracts is weak. Would improve with named branded resveratrol source and specific % actives.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pygeum-featuring-pygeum-bark-and-extract",
      "title": "Pygeum - Featuring Pygeum Bark and Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f685dd20-85b6-4ac1-be1f-4cd2eeeed3f0_large_77b4f189-4b77-482c-b263-3db5ab1c5da3.jpg?v=1787417510",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pygeum",
        "featuring",
        "pygeum",
        "bark",
        "and",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 66,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 18.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790645448901",
      "vsf_explanation": "Pygeum africanum has Cochrane-level evidence for BPH symptom relief (Wilt 2002) at 100-200mg standardized extract/day. Blend of whole bark plus extract dilutes the standardized portion. Pygeum is also CITES-listed with sustainability concerns from wild-harvesting. Would improve with 13% total sterols standardization and sustainable-sourcing certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gymnema-sylvestre-extract-standardized-1",
      "title": "Gymnema Sylvestre Extract - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/79f38453-d9b6-4eb1-a4f5-94ec11d5228b_large_a5a5d444-00a9-41a0-901c-e494314b0d03.jpg?v=1787417510",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gymnema",
        "sylvestre",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 6.4,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790645481669",
      "vsf_explanation": "Gymnema sylvestre has modest evidence for post-meal glucose response and sugar craving suppression (Baskaran 1990). 'Standardized' claim is a plus but no % gymnemic acids disclosed in title. Standard herbal quality. Would move to Verified with 25% gymnemic acid standardization and clinical dose (400-600mg).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pomegranate-extract-standardized",
      "title": "Pomegranate Extract - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ccd4081e-bcb3-414f-a802-a6965d096d45_large_a78da959-e16f-47ea-aa20-452e69158e89.jpg?v=1787417510",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pomegranate",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 11.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790645514437",
      "vsf_explanation": "Pomegranate polyphenols (punicalagins, urolithin precursors) have RCT evidence for endothelial function and prostate cancer PSA (Pantuck 2006, Aviram 2004). 'Standardized' claim needs a % punicalagin disclosure to matter. Would improve with 40% ellagic acid or branded POMx-style standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "reishi-mushroom-extract-standardized",
      "title": "Reishi Mushroom Extract - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5462318f-6928-4eee-ae63-7b3b0e6bdc5e_large_f86fa94c-a5a9-43e6-9916-977f64ed1b04.jpg?v=1787417510",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "reishi",
        "mushroom",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 64,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 65,
        "sustainability": 60
      },
      "price": 14.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790646399173",
      "vsf_explanation": "Standardized reishi (Ganoderma lucidum) extract — the standardization signal (typically to polysaccharides or triterpenes) is the single most important quality gate in this category and separates real supplemental reishi from filler-grain mycelium. Small human trials support modest immunomodulation and sleep-quality signals (Chen 2020 meta-analysis) but strong clinical outcomes remain limited. Held to top of Standard by absence of fruiting-body vs mycelium confirmation and by the standardization target not being specified. Would move up with dual-extract (hot water + ethanol) and fruiting-body confirmation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnolia-extract-standardized",
      "title": "Magnolia Extract - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9c7a042d-f1a2-4a38-93cd-fb4d15e4a7a1_large_ac73cbae-fac3-4ba9-950e-294a9aeacee7.jpg?v=1787417510",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnolia",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 12.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790646431941",
      "vsf_explanation": "Magnolia bark (honokiol, magnolol) has preliminary evidence for anxiety and sleep quality, often as Relora blend (Talbott 2013). 'Standardized' — needs a % disclosure of active biphenols to matter. Would improve with 2% honokiol standardization and clinical dose specification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "rhodiola-rosea-extract",
      "title": "Rhodiola Rosea Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0f432414-5b16-4e3d-b7b6-cf5861167b71_large_c4d5202c-704c-40b9-a35c-a177bffffab9.jpg?v=1787417511",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "rhodiola",
        "rosea",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 66,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 12.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790646759621",
      "vsf_explanation": "Rhodiola rosea extract — evidence base is solid for stress-fatigue at 200-600mg/day standardized to 3% rosavins and 1% salidroside (Darbinyan 2000 on physician night-shift performance; Spasov 2000 on student exam fatigue). The word 'extract' in the title suggests standardization but does not confirm the rosavins/salidroside percentages critical to the studied SHR-5 extract material. Held at Standard because standardization percentages are not named at title level. Would move to Verified 70+ with 3% rosavins + 1% salidroside standardization confirmed (matching SHR-5 studied material).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "turmeric-kola-nut-bissy-capsules",
      "title": "Turmeric Kola Nut (Bissy) Capsules",
      "vendor": "Yaga Lifestyle",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/TKN.png?v=1787417516",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "turmeric",
        "kola",
        "nut",
        "bissy",
        "capsules",
        "yaga",
        "lifestyle"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 40.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790648594629",
      "vsf_explanation": "Turmeric + kola nut ('bissy') is a Caribbean folk-medicine pairing. Turmeric (curcumin) has decent RCT data for inflammation (Chandran 2012) but requires piperine or phytosome delivery for meaningful bioavailability — not disclosed here. Kola nut adds caffeine but has minimal formal evidence for the labeled use cases. Small-brand manufacturing without standardization %, third-party testing, or per-ingredient dose narrows scoring. Would move to Standard 60+ with 95% curcuminoid standardization and piperine co-formulation disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "iron-lion-powder-jamaican-roots-tonic-supplement-with-sarsaparilla-chaney-root-cocolmeca-strongback-allman-strength",
      "title": "Iron Lion Powder | Jamaican Roots Tonic Supplement with Sarsaparilla, Chaney Root (Cocolmeca), Strongback, Allman Strength",
      "vendor": "Yaga Lifestyle",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/IronRootsrev-1.png?v=1787417523",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "iron",
        "lion",
        "powder",
        "jamaican",
        "roots",
        "tonic",
        "supplement",
        "with",
        "sarsaparilla",
        "chaney",
        "root",
        "cocolmeca",
        "strongback",
        "allman",
        "strength",
        "yaga",
        "lifestyle"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 30,
        "sustainability": 55
      },
      "price": 45.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790651248837",
      "vsf_explanation": "Powdered version of a traditional Jamaican men's tonic — sarsaparilla, chaney root, strongback, allman strength — marketed for vitality and libido without per-herb dose disclosure. RCT support for the combination is essentially nil; individual herbs have folk-medicine tradition but no consistent human-trial data. Small-brand manufacturing with no third-party COA visible and proprietary bundling triggers autofail.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "yaga-roots-tonic™",
      "title": "Yaga Roots Tonic™",
      "vendor": "Yaga Lifestyle",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Roots_Tonic_Shot_6.png?v=1787417528",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "yaga",
        "roots",
        "tonic",
        "yaga",
        "lifestyle"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 30,
        "sustainability": 55
      },
      "price": 68.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790653935813",
      "vsf_explanation": "Traditional Caribbean-style multi-root tonic from a small brand with no per-active mg breakdown on the label. Roots tonics (sarsaparilla, chaney root, strongback) have long ethnobotanical use but essentially no modern RCT support at named doses. Combined with proprietary-blend labeling and no third-party testing, this fails the transparency floor. Would move up substantially with per-herb mg disclosure, standardized extracts, and batch COAs.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "pavana-leaves-croton-tiglium-dr-sebi-approved-alkaline-herb",
      "title": "Pavana Leaves | Croton Tiglium | Dr Sebi Approved Alkaline Herb",
      "vendor": "Yaga Lifestyle",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/PavanaLeavesCrotonTigliumDrSebiApprovedAlkalineHerb.png?v=1787417537",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pavana",
        "leaves",
        "croton",
        "tiglium",
        "sebi",
        "approved",
        "alkaline",
        "herb",
        "yaga",
        "lifestyle"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 25,
        "manufacturing": 30,
        "safety": 15,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790656753861",
      "vsf_explanation": "Croton tiglium is a violently purgative herb whose oil is documented as a tumor promoter (phorbol esters) and is not approved for internal supplement use. The 'Dr Sebi approved' framing invokes a discredited healer whose cure claims for HIV, cancer, and diabetes were the subject of legal action and are not supported by any RCT. Combined toxicity, cure-implying naming, and lack of dose disclosure justify autofail on unverified medical claim grounds. This product should not be listed for internal use.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "essential-amino-acid-complex-pharmaceutical-grade",
      "title": "Essential Amino Acid Complex - Pharmaceutical Grade",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7916bba0-efca-47db-b61a-fd02a0e78acb_large_cc637ed2-f15f-4f04-82a2-3f230bd3c3dc.jpg?v=1787417553",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "essential",
        "amino",
        "acid",
        "complex",
        "pharmaceutical",
        "grade",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 66,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 19.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790662062277",
      "vsf_explanation": "EAA complexes are the more evidence-supported ergogenic than BCAAs alone — Wilkinson 2013 showed all-EAA gives a longer MPS response than BCAA-only, and Volpi 2003 established that EAAs drive muscle protein synthesis in older adults. Operative dose is ~10-15g per serving with a leucine content ≥2.5g. Held at Standard because 'pharmaceutical grade' is a marketing phrase without regulatory meaning in the US supplement space, and Swanson does not name a branded amino source (AjiPure or Kyowa) on the title. Would move to Verified 70+ with disclosed per-serving EAA totals, leucine content ≥2.5g, and named amino source.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "activated-homocysteine",
      "title": "Activated Homocysteine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/67a17fbb-bb1f-4ef6-8b41-5ebfc291274b_large_9680f677-1b9f-4a0f-a342-08a2de1a8345.jpg?v=1787417553",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "activated",
        "homocysteine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 23.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790662389957",
      "vsf_explanation": "Homocysteine-lowering B-vitamin combination typically featuring methylfolate, methylcobalamin, P-5-P, and TMG/betaine. Evidence supports homocysteine reduction with active B-vitamin forms (Toole 2004, VITATOPS 2010) though clinical hard-outcome benefit is more mixed. Correct 'activated' forms are a real formulation upgrade over cyanocobalamin/folic acid. Would move up with disclosed per-active mg and USP verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "goji-berry-extract-wolfberry-standardized",
      "title": "Goji Berry Extract Wolfberry - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7c7364a7-e5b2-4253-923e-ccf9c5adb9cc_large_def4c043-65b2-463e-b342-6a39eeb43e99.jpg?v=1787417553",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "goji",
        "berry",
        "extract",
        "wolfberry",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 66,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 7.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790662160581",
      "vsf_explanation": "Standardized goji (Lycium barbarum) extract targeting Lycium barbarum polysaccharide (LBP) content. Small human trials (Amagase 2009) show modest antioxidant biomarker improvements; the immune claims rest largely on preclinical LBP mechanism work. Held to mid-Standard because the standardization target percentage is not stated on the title, and goji has drug-interaction potential with warfarin (INR elevations reported). Would move up with disclosed LBP percentage and drug-interaction labeling.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ajipure-l-arginine-with-l-citrulline-pharmaceutical-grade",
      "title": "AjiPure L-Arginine with L-Citrulline - Pharmaceutical Grade",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cdf04e61-1e92-480a-aa3f-3a5b70a4f604_large_0ffaf2f7-5de6-4301-a6ae-2e143b0bdee8.jpg?v=1787417553",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ajipure",
        "arginine",
        "with",
        "citrulline",
        "pharmaceutical",
        "grade",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 74,
        "formulation": 72,
        "manufacturing": 72,
        "safety": 68,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 14.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790662127813",
      "vsf_explanation": "AjiPure is Ajinomoto's pharma-grade fermented amino acid line — a genuine quality tier and one of the cleanest amino sources available at retail. Combining L-arginine with L-citrulline is the pharmacologically smarter approach for endothelial NO support: citrulline bypasses first-pass metabolism and sustains plasma arginine better than arginine alone (Schwedhelm 2008). To fully hit the studied 3-6 g arginine and 6 g citrulline range, users may need multiple servings — dosing depth per capsule is the swing factor for tier. Would move to Verified 74+ with disclosed per-serving mg that clearly reaches studied combined doses.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-arginine-sustained-release-featuring-ajipure",
      "title": "L-Arginine Sustained Release - Featuring AjiPure",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/281e6ceb-96d1-401f-af74-f416f23c8919_large_4ec26edf-db5a-4e44-9216-e87caa967453.jpg?v=1787417553",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "arginine",
        "sustained",
        "release",
        "featuring",
        "ajipure",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 70,
        "manufacturing": 72,
        "safety": 68,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 29.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790662357189",
      "vsf_explanation": "AjiPure arginine (Ajinomoto pharma-grade) in a sustained-release matrix is a thoughtful formulation — sustained release addresses arginine's short plasma half-life (~1 hour) and helps maintain steady substrate for endothelial NO synthesis (Schwedhelm 2008 pharmacokinetic data). Named pharma-grade source is a legitimate quality signal. Held just below Verified because the SKU does not explicitly disclose mg per serving needed to hit the studied 3-6 g/day endothelial range across a full day, and sustained-release performance in vivo is not independently verified. Would move to Verified 72+ with confirmed daily total mg reaching studied dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "activated-b-complex-high-potency-and-bioavailability",
      "title": "Activated B-Complex - High Potency and Bioavailability",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f3389edd-2110-439f-bff9-506f7675cbcf_large_e57feb64-322a-4636-92cc-db073789f15c.jpg?v=1787417553",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "activated",
        "complex",
        "high",
        "potency",
        "and",
        "bioavailability",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 74,
        "formulation": 78,
        "manufacturing": 65,
        "safety": 72,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 34.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790662193349",
      "vsf_explanation": "'Activated' typically indicates all B vitamins in coenzymated forms — P-5-P (B6), R-5-P (B2), methylcobalamin (B12), 5-MTHF (folate), benfotiamine or thiamine mononitrate (B1). This is the appropriate stack for methylation-cycle support and MTHFR polymorphism carriers (Obeid & Herrmann 2012). Held below Elite by likely absence of named-source folate (Quatrefolic/Metafolin), no third-party certification, and typical Swanson QC transparency. Would move to Verified 78+ with named 5-MTHF source and independent COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "7-hmrlignans-from-norwegian-spruce-tree",
      "title": "7-HMRlignans from Norwegian Spruce Tree",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8a01b70b-f625-4e74-b2fd-30399dc1255f_large_a7bfa299-7f26-4e9a-996e-561efc60ad18.jpg?v=1787417553",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hmrlignans",
        "from",
        "norwegian",
        "spruce",
        "tree",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 18.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790662324421",
      "vsf_explanation": "HMR lignan (7-hydroxymatairesinol) from Norway spruce has preliminary evidence for menopausal hot flashes and enterolactone production (Udani 2013). Named botanical source is a plus. Standard Swanson formulation — no branded HMRlignan trademark license visible, and clinical evidence base is still preliminary. Would improve with 36mg branded HMRlignan and RCT-anchored dose disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "activated-b-complex-high-bioavailability",
      "title": "Activated B-Complex - High Bioavailability",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0a5728e4-112c-46ef-b260-719cbb7c164c_large_430e06aa-e0d4-4a0f-a276-7731b22657ea.jpg?v=1787417553",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "activated",
        "complex",
        "high",
        "bioavailability",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 74,
        "formulation": 76,
        "manufacturing": 65,
        "safety": 72,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 17.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790662095045",
      "vsf_explanation": "'Activated' B-complex generally includes P-5-P, R-5-P, methylcobalamin, and 5-MTHF — the correct bioactive forms for methylation-cycle support (Obeid & Herrmann 2012). Solid formulation approach vs synthetic-form B-complexes. Held below Elite by likely absence of named 5-MTHF source (Quatrefolic/Metafolin), no third-party certification, and standard mass-market QC. Would move to Verified 76+ with named folate source and COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vegan-bcaa-featuring-ajipure",
      "title": "Vegan BCAA - Featuring AjiPure",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/57f6d4e4-ccfd-4c9e-966c-56bea2f76dec_large_b5b0da4f-5fa2-4960-830e-cc879258a3f1.jpg?v=1787417553",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vegan",
        "bcaa",
        "featuring",
        "ajipure",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 72,
        "manufacturing": 76,
        "safety": 70,
        "transparency": 74,
        "sustainability": 62
      },
      "price": 7.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790662488261",
      "vsf_explanation": "BCAAs sourced from AjiPure — Ajinomoto's plant-fermentation amino line, verified vegan and pharmaceutical-grade with dedicated allergen-free manufacturing. Named branded sourcing at label is a real quality signal. However, the evidence for BCAAs specifically (vs full EAAs) is attenuated in anyone consuming adequate dietary protein — Jackman 2017 and Wolfe 2017 both showed BCAA-only MPS response is short-lived because the other essential aminos become rate-limiting. So the formulation is high-quality for what it is, but a full-EAA is a strictly better product. Verified tier reflects the branded sourcing rather than the strategic value of BCAA-only supplementation for most users.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-glutamine-powder-featuring-ajipure",
      "title": "L-Glutamine Powder - Featuring AjiPure",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/81e3a44b-a36c-4337-96ae-fb6ac6579e90_large_8ad413ec-095d-47b1-b414-45f36ea01bf1.jpg?v=1787417553",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glutamine",
        "powder",
        "featuring",
        "ajipure",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 66,
        "formulation": 68,
        "manufacturing": 68,
        "safety": 70,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 24.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790662226117",
      "vsf_explanation": "L-glutamine has evidence for gut barrier support in IBS and post-exercise contexts (Zhou 2019). AjiPure fermented amino acid from Ajinomoto is a legitimate high-purity source with named traceability. Powder format allows dose flexibility (5g typical clinical dose). Would move to Verified 70+ with USP verification and clearer serving guidance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hair-revitalizing-formula-advanced-formula",
      "title": "Hair Revitalizing Formula - Advanced Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d618fa60-9005-4bbe-97b7-a582b7cec2b7_large_642865ec-242d-44c9-9289-c68da5ebce11.jpg?v=1787417553",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hair",
        "revitalizing",
        "formula",
        "advanced",
        "formula",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 16.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790662291653",
      "vsf_explanation": "Generic 'hair revitalizing' formula with no named clinical ingredient at title. Hair-support supplement category is dominated by biotin megadoses (evidence weak per Patel 2017, and biotin distorts thyroid/troponin lab work), saw palmetto for AGA (mixed evidence per Prager 2002), and marine collagen. Held below Verified by opaque active list and no named clinical ingredient. Would move to Verified 70+ with a named clinical ingredient (Keranat, AnaGain, Cynatine HNS) and safety flag on biotin lab interference.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "horse-chestnut-standardized",
      "title": "Horse Chestnut - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d5d59f94-b1f9-4376-8baf-cb352086fe0d_large_ee9ec97f-34d6-4460-aea8-190f8263f1c9.jpg?v=1787417553",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "horse",
        "chestnut",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 5.2,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790662422725",
      "vsf_explanation": "Horse chestnut seed extract (aescin) has strong Cochrane evidence for chronic venous insufficiency (Pittler 2012) at 300mg standardized to 50mg aescin twice daily. 'Standardized' claim is a plus but no % aescin disclosed in title. Would move to Verified with 16-20% aescin standardization and clinical dose confirmation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "albion-chromium",
      "title": "Albion Chromium",
      "vendor": "Albion",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3b7537a8-a886-4e3a-a71d-f7492a03e575_large_165e37d5-a67d-47f1-b20f-04f3b5754c0a.jpg?v=1787417553",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "albion",
        "chromium",
        "albion"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 66,
        "formulation": 74,
        "manufacturing": 70,
        "safety": 68,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 10.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790662258885",
      "vsf_explanation": "Albion chromium chelate for glucose-metabolism support. Chromium has modest but real RCT evidence for insulin sensitivity and glucose control at 200-400mcg (Anton 2008; Cefalu 2004 for diabetics), effect size is small. Named-source TRAACS chelate lifts to low Verified. Would move higher with disclosed dose and glycemic RCT alignment.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-tyrosine-featuring-ajipure",
      "title": "L-Tyrosine - Featuring AjiPure",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1eaa38a4-88ae-4aa3-802b-f542b815886b_large_70e28f6e-f098-4205-8c59-428c5f0808f3.jpg?v=1787417553",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tyrosine",
        "featuring",
        "ajipure",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 68,
        "safety": 65,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 6.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790662586565",
      "vsf_explanation": "L-tyrosine has evidence for cognitive performance under acute stress and sleep deprivation (Deijen 1999, Neri 1995) at 100-150mg/kg. AjiPure is a legitimate pharma-grade source. Would move to Verified 70+ with dose clearly targeted at clinical effect range and third-party purity documentation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-glutamine-featuring-ajipure",
      "title": "L-Glutamine - Featuring AjiPure",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1dec1560-6561-445f-b53c-2d482c949281_large_43b50993-47b5-4436-a245-abcbc19717d2.jpg?v=1787417553",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glutamine",
        "featuring",
        "ajipure",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 66,
        "formulation": 68,
        "manufacturing": 68,
        "safety": 70,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 2.7,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790662553797",
      "vsf_explanation": "Capsule form of AjiPure L-glutamine — same fermented pharma-grade source as the powder version. Evidence supports gut barrier (Zhou 2019) and post-surgical recovery. Capsule form limits dose flexibility versus powder for the typical 5g clinical dose. Would improve with clearer per-capsule mg and USP verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "albion-ferrochel-iron",
      "title": "Albion Ferrochel Iron",
      "vendor": "Albion",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5588d429-1f0e-4e6a-bada-cf876ec0185a_large_c3431295-cbe9-4e02-9618-a3c0ad0ed08e.jpg?v=1787417553",
      "score": 74,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "albion",
        "ferrochel",
        "iron",
        "albion"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 74,
        "formulation": 78,
        "manufacturing": 70,
        "safety": 74,
        "transparency": 74,
        "sustainability": 55
      },
      "price": 10.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790662521029",
      "vsf_explanation": "Ferrochel is Albion's patented iron bisglycinate with the strongest evidence base for iron repletion tolerability — non-inferior efficacy to ferrous sulfate with far fewer GI side effects (Milman 2014; Coplin 1991). Named-source branded raw material lifts this to solid Verified. Alt-day dosing (Stoffel 2017) improves fractional absorption. Would move to Elite with dosing-guidance disclosure and third-party verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-serine-featuring-ajipure",
      "title": "L-Serine - Featuring AjiPure",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f3659f72-e8f1-4aaf-8888-c736e09fb890_large_b721c223-f852-42db-b2e6-352065477a76.jpg?v=1787417553",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "serine",
        "featuring",
        "ajipure",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 68,
        "manufacturing": 68,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 8.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790662652101",
      "vsf_explanation": "L-serine has preliminary evidence in ALS trials (Levine 2017) at high doses (15g/day), but general cognitive claims lack robust RCT support. AjiPure source is a real quality plus. Standard capsule dose is well below any studied clinical range for CNS conditions. Would improve with clinical-dose serving and clearer indication.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "acti-joint-plus-with-krill-oil-featuring-mobilee-superba2",
      "title": "Acti-Joint Plus with Krill Oil - Featuring Mobilee & Superba2",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/63d1e9a2-875c-4b0e-a4f4-27d1fa101afb_large_370339c5-ea81-4091-920d-20383f1b2704.jpg?v=1787417553",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "acti",
        "joint",
        "plus",
        "with",
        "krill",
        "oil",
        "featuring",
        "mobilee",
        "superba2",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 70,
        "manufacturing": 70,
        "safety": 68,
        "transparency": 68,
        "sustainability": 65
      },
      "price": 16.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790662684869",
      "vsf_explanation": "Mobilee is Bioiberica's branded hyaluronic-acid-rich chicken-comb extract with joint-comfort RCTs (Sanchez 2015). Superba2 is Aker BioMarine's premium krill oil. Two named branded ingredients — good manufacturing/transparency signals. Sits at high-Standard just below Verified. Would move to Verified 70+ with per-cap mg disclosure of Mobilee (studied dose ~80mg/day) and Superba2 EPA+DHA content.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-methionine-featuring-ajipure",
      "title": "L-Methionine - Featuring AjiPure",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9a2985c6-84b3-43da-a330-7be151c7a785_large_8e611ca8-ba81-4473-b7b0-9cb546c22101.jpg?v=1787417553",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "methionine",
        "featuring",
        "ajipure",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 68,
        "manufacturing": 68,
        "safety": 55,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 10.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790662619333",
      "vsf_explanation": "L-methionine is essential but rarely deficient in Western diets; high-dose supplementation has links to accelerated aging and cardiovascular markers in some observational data. AjiPure quality is a plus, but the case for standalone methionine supplementation is weak for general users. Safety flag: high-dose methionine raises homocysteine. Would improve with clearer contraindication guidance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "taurine-featuring-ajipure",
      "title": "Taurine - Featuring AjiPure",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ebb5d585-7dd9-4819-8d88-d23d763a70a7_large_617869e3-149e-4f32-a555-4dbf21e80d71.jpg?v=1787417553",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "taurine",
        "featuring",
        "ajipure",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 68,
        "manufacturing": 68,
        "safety": 70,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 13.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790662717637",
      "vsf_explanation": "Same AjiPure taurine as the sibling SKU — pharma-grade fermented source with growing cardiovascular and longevity evidence (Singh 2023). Would move to Verified 70+ with clearly labeled 2-3g clinical dose per serving and third-party assay disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "glycine-powder",
      "title": "Glycine Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/019ff6c8-62c2-799c-9455-18f1dd323e1f.jpg?v=1787417553",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glycine",
        "powder",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 66,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 16.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790662783173",
      "vsf_explanation": "Glycine has RCT evidence for subjective sleep quality (Yamadera 2007, Bannai 2012) at 3g pre-bed. Generic Swanson powder — no AjiPure or other named source disclosed. Powder form supports flexible 3g dosing. Would move to Verified with pharma-grade sourcing and third-party purity data.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "albion-magnesium-glycinate-2-pack",
      "title": "Albion Magnesium Glycinate - 2 Pack",
      "vendor": "Albion",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4cb90e99-048f-41de-a2bf-d3f02062dea8_large_73301cc5-0623-4be2-aad1-f6c02a49ed6c.jpg?v=1787417553",
      "score": 74,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "albion",
        "magnesium",
        "glycinate",
        "pack",
        "albion"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 78,
        "manufacturing": 70,
        "safety": 76,
        "transparency": 74,
        "sustainability": 55
      },
      "price": 16.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790662848709",
      "vsf_explanation": "2-pack of Albion magnesium bisglycinate — best-tolerated form for general magnesium repletion (Walker 2003; Schuchardt 2017), no laxative effect. Evidence for sleep, anxiety, blood pressure at 200-400mg (Abbasi 2012; Kass 2012). Named-source TRAACS chelate lifts to Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ajipure-l-arginine-pharmaceutical-grade",
      "title": "AjiPure L-Arginine - Pharmaceutical Grade",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/683fb788-bdaa-40a5-a353-f8c6f7cd7252_large_2558497e-8345-4ad7-9b81-ba73962245ea.jpg?v=1787417553",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ajipure",
        "arginine",
        "pharmaceutical",
        "grade",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 68,
        "manufacturing": 74,
        "safety": 68,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 6.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790662815941",
      "vsf_explanation": "AjiPure is Ajinomoto's fermented pharmaceutical-grade amino acid line and is genuinely one of the cleanest raw-material sources on the retail market — a real manufacturing quality signal. L-arginine at 3-6 g/day supports endothelial NO synthesis (Schwedhelm 2008; Bode-Böger 2007), but its short plasma half-life means multiple daily servings are typically needed. Held just below Verified because the SKU does not explicitly guarantee daily servings reach the 3-6 g studied range, and pairing with citrulline would be a formulation upgrade. Would move to Verified 72+ with disclosed daily mg reaching studied dose or with added citrulline.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "glycine-featuring-ajipure",
      "title": "Glycine - Featuring AjiPure",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7c946a04-eba7-40bd-9308-7482cf9df0f8_large_270176fd-46bf-41e3-853c-91cee2e988f1.jpg?v=1787417554",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glycine",
        "featuring",
        "ajipure",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 66,
        "formulation": 68,
        "manufacturing": 68,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 6.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790662750405",
      "vsf_explanation": "AjiPure branded glycine — meaningful ingredient upgrade over commodity glycine. Yamadera 2007 and Bannai 2012 established 3g pre-bed dose for sleep quality. Would move to Verified 70+ with clinical-dose serving and USP verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "albion-magnesium-calcium-with-vitamins-d3-k2",
      "title": "Albion Magnesium & Calcium with Vitamins D3 & K2",
      "vendor": "Albion",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1a4104d6-4d4c-4c68-b305-8de3fd0e812d_large_88107e63-6cbb-4493-827a-b9fd5f940403.jpg?v=1787417554",
      "score": 76,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "albion",
        "magnesium",
        "calcium",
        "with",
        "vitamins",
        "albion"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 74,
        "formulation": 80,
        "manufacturing": 72,
        "safety": 74,
        "transparency": 74,
        "sustainability": 55
      },
      "price": 19.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790662881477",
      "vsf_explanation": "This is the cleanly-formulated bone-support stack: Albion chelated magnesium and calcium bisglycinates paired with D3 (calcium absorption) and K2 (arterial calcium routing — Bolland 2015 cardiovascular concern mitigation). K2 addresses the isolated-calcium cardiovascular risk. Named-source TRAACS chelates plus co-factors give solid Verified. Would move to Elite with disclosed K2-MK7 form/dose and third-party verification per SKU.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "valerian-chamomile-hops-standardized",
      "title": "Valerian Chamomile Hops - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/92c80506-2b93-4a30-adf5-df05b8a9b17e_large_3bc09711-eeb8-48ec-bda6-86aa5b6c301e.jpg?v=1787417557",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "valerian",
        "chamomile",
        "hops",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 66,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 66,
        "sustainability": 60
      },
      "price": 18.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790664224965",
      "vsf_explanation": "Classic traditional-European sleep herbal triple (valerian + chamomile + hops) with standardization disclosed. Valerian at 400-600mg has mixed but generally positive evidence for subjective sleep quality (Bent 2006 meta); chamomile apigenin standardization has anxiolytic support (Amsterdam 2016); hops adds mild sedation. Combo dilutes each active vs monotherapy doses, but the pharmacological rationale is coherent. Safety is favorable. Would move to Verified 70+ with per-active RCT-relevant doses maintained and disclosed valerenic-acid percentage.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ahcc-maximum-strength",
      "title": "AHCC - Maximum Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/afa08ecc-2458-4e1d-9340-074a91a65128_large_7173b0e9-70a4-415e-a663-5e1e6c00c94f.jpg?v=1787417557",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ahcc",
        "maximum",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 68,
        "manufacturing": 68,
        "safety": 68,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 59.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790664257733",
      "vsf_explanation": "AHCC (Active Hexose Correlated Compound) is a proprietary shiitake mushroom mycelia extract from Amino Up Japan with meaningful RCT evidence for HPV clearance (Smith 2019) and immune modulation at 3g/day. Assuming genuine AHCC ingredient sourcing, this is a legitimate immune product. Would move to Verified 70+ with confirmed 3g clinical dose per serving and lot-level purity disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "tribulus-terrestris-extract",
      "title": "Tribulus Terrestris Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/eef64c17-abaf-4103-bfa9-b71bc56de89d_large_f81d8920-43b1-4392-b403-4c43fb3a8cc4.jpg?v=1787417558",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone",
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tribulus",
        "terrestris",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 4.25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790664290501",
      "vsf_explanation": "Tribulus terrestris extract, marketed for testosterone support and libido. The core claim of testosterone elevation in healthy men is not supported by RCTs — Neychev 2005 showed no change in T levels in resistance-trained men, and the broader literature is null for T-boosting. Some libido signal exists but is inconsistent. Standardization to saponins (typically 45-60% protodioscin) is variable and often not disclosed. Standard Swanson manufacturing. Would move higher only with honest label framing (no T-boost claim), saponin standardization disclosed, and dose meeting studied ranges (~750mg/day).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "phytoceramides-advanced-formula",
      "title": "PhytoCERAMIDES - Advanced Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a9bffcab-658d-43c7-9b88-1e7a736a1ee6_large_59e50fe7-f039-4e40-933d-e457af101b97.jpg?v=1787417557",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "phytoceramides",
        "advanced",
        "formula",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 25.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790664323269",
      "vsf_explanation": "Oral phytoceramides (wheat or rice-derived) have modest clinical evidence for skin hydration (Guillou 2011) at 30-40mg glucosylceramide/day. 'Advanced Formula' is not a specification — no ceramide source, isomer, or standardization disclosed in the title. Would move up with named branded ingredient (Ceramosides or similar) and clinical dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nac-n-acetyl-l-cysteine-featuring-ajipure",
      "title": "NAC N-Acetyl L-Cysteine - Featuring AjiPure",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/39adb138-745e-4e92-8ccf-288a733630ac_large_299ab2f3-5148-4fb2-9aaf-e23a27b3df69.jpg?v=1787417560",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nac",
        "acetyl",
        "cysteine",
        "featuring",
        "ajipure",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 74,
        "formulation": 74,
        "manufacturing": 78,
        "safety": 68,
        "transparency": 72,
        "sustainability": 60
      },
      "price": 9.3,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790665633989",
      "vsf_explanation": "AjiPure is Ajinomoto's pharmaceutical-grade fermentation-derived amino acid line — a real manufacturing upgrade over bulk Chinese NAC on identity, purity, and heavy-metal contamination profiles, verified under Ajinomoto's Trace program. NAC evidence base is solid: mucolytic (Grandjean 2000), acetaminophen antidote (clinical), and psychiatric applications (Berk 2008). AjiPure branding meaningfully raises manufacturing confidence versus a generic Swanson SKU. Held at low Verified because Swanson still doesn't publish per-lot COA. Would move to Elite with published COA and NSF/USP mark.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "albion-multi-mineral-with-iron",
      "title": "Albion Multi-Mineral With Iron",
      "vendor": "Albion",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4d52d052-fd0d-43ca-a676-57728d32250f_large_9126b62a-6db1-4b95-9b95-875669f3842c.jpg?v=1787417560",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "albion",
        "multi",
        "mineral",
        "with",
        "iron",
        "albion"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 76,
        "manufacturing": 70,
        "safety": 68,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 9.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790665666757",
      "vsf_explanation": "Albion chelated multi-mineral including iron bisglycinate (Ferrochel) — appropriate for menstruating women and iron-deficient users. All-chelate TRAACS forms are best-absorbed. Verified tier. Adult men and post-menopausal women should generally choose the iron-free variant (Zacharski 2007). Would move higher with elemental disclosure per mineral and NSF verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-histidine-featuring-ajipure",
      "title": "L-Histidine - Featuring AjiPure",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/68358801-30f3-4b81-b052-6e648476d5e2_large_29d35de2-a50c-4fb5-85eb-a7a5e17e7c5b.jpg?v=1787417560",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "histidine",
        "featuring",
        "ajipure",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 68,
        "manufacturing": 68,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 19.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790665699525",
      "vsf_explanation": "L-histidine as a standalone supplement has limited high-quality RCT evidence outside of specialized conditions (uremic pruritus, rheumatoid). AjiPure branding is a legitimate quality upgrade for the amino acid source. Product quality is solid but the underlying use case is niche. Would improve with clearer indication and dose justification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "albion-vanadium-chromium",
      "title": "Albion Vanadium & Chromium",
      "vendor": "Albion",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8a1e1d21-a219-4964-897b-0136f3a695e2_large_adb3ecce-a9d1-4777-bbd5-755699f6c7a5.jpg?v=1787417560",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "albion",
        "vanadium",
        "chromium",
        "albion"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 70,
        "manufacturing": 68,
        "safety": 62,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 17.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790665732293",
      "vsf_explanation": "Chromium has modest glucose-metabolism evidence (Anton 2008); vanadium is more speculative for glucose support with a narrower safety margin (Thompson 2004). Albion chelate forms are best-absorbed. Upper Standard tier — good delivery, mixed evidence on vanadium. Would not upgrade without stronger RCT support for vanadium at supplemented doses.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "albion-vanadium",
      "title": "Albion Vanadium",
      "vendor": "Albion",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d5188ba6-7164-479d-9bcf-8b32487068a5_large_08986eff-4367-4ebc-8658-ed84f6f0015e.jpg?v=1787417560",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "albion",
        "vanadium",
        "albion"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 65,
        "manufacturing": 72,
        "safety": 50,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 8.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790665765061",
      "vsf_explanation": "Vanadium as Albion's branded chelate — the chelate manufacturing is genuinely well-executed, and Albion is a legitimate mineral-chelate specialist. Vanadium itself has thin evidence: some early human trials for insulin sensitivity (Cohen 1995, Halberstam 1996) at high doses that produced GI toxicity, and no established therapeutic role at supplement doses. There is no established RDA and long-term safety data is limited. Held at Standard because the sourcing quality is real but the ingredient case is weak — most people should not supplement vanadium chronically without a medical reason.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "albion-calcium-magnesium",
      "title": "Albion Calcium & Magnesium",
      "vendor": "Albion",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9eec6f1c-2d9f-43c8-b729-85c635a62b46_large_7191dc84-022f-48d7-858e-158b24394985.jpg?v=1787417560",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "albion",
        "calcium",
        "magnesium",
        "albion"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 76,
        "manufacturing": 70,
        "safety": 68,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 12.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790665797829",
      "vsf_explanation": "Albion calcium bisglycinate + magnesium bisglycinate combo — well-absorbed, gentle-on-GI paired minerals. High-dose isolated calcium supplementation without K2/D3 raises cardiovascular concerns (Bolland 2015). Named-source TRAACS chelates lift to Verified. Would move higher with added K2/D3 and third-party verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "albion-calcium",
      "title": "Albion Calcium",
      "vendor": "Albion",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/68ca6d5e-485d-468d-94b0-00b40c5d6049_large_d509e4ca-d646-4b06-ae7f-55792d45a6d7.jpg?v=1787417562",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "albion",
        "calcium",
        "albion"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 76,
        "manufacturing": 70,
        "safety": 68,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 13.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790666715333",
      "vsf_explanation": "Albion calcium bisglycinate — chelated calcium with good absorption that does not require stomach acid (unlike carbonate). Isolated high-dose calcium supplementation has raised cardiovascular concerns (Bolland 2015) so this is best paired with K2 and dietary calcium context. Named-source TRAACS chelate lifts to Verified. Would move higher with K2/D3 co-factors and cardiovascular safety disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "albion-molybdenum",
      "title": "Albion Molybdenum",
      "vendor": "Albion",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ddec6e17-0cc6-4399-841a-69507991697c_large_50833f1c-aaf6-40a6-b09d-d75e43e28188.jpg?v=1787417562",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "albion",
        "molybdenum",
        "albion"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 74,
        "manufacturing": 68,
        "safety": 68,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 11.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790666748101",
      "vsf_explanation": "Albion molybdenum glycinate — trace mineral used as sulfite oxidase and xanthine oxidase cofactor. RDI is 45mcg; supplementation is niche. Named-source TRAACS chelate is a formulation plus. Upper Standard tier — evidence base is thin outside deficiency states.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "albion-zinc",
      "title": "Albion Zinc",
      "vendor": "Albion",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8611dafe-f935-4139-bb12-310664aadbca_large_0d478743-b7f9-43df-a667-7653b7f61fba.jpg?v=1787417563",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "albion",
        "zinc",
        "albion"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 76,
        "manufacturing": 70,
        "safety": 68,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790666813637",
      "vsf_explanation": "Albion zinc bisglycinate — high-absorption chelated zinc (Gandia 2007) suitable for immune, taste/smell, and testosterone support (Prasad 2007). Named-source TRAACS chelate lifts to Verified. Chronic zinc use requires copper co-factoring. Would move higher with copper pairing and third-party certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "albion-selenium",
      "title": "Albion Selenium",
      "vendor": "Albion",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/50c7bf8c-e411-45a2-bb16-4d9c7a4bed77_large_aa13af10-9ebd-435d-8926-c51ae1283207.jpg?v=1787417564",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "albion",
        "selenium",
        "albion"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 74,
        "manufacturing": 70,
        "safety": 68,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 9.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790667829445",
      "vsf_explanation": "Albion selenium glycinate — chelated selenium form with good tolerability, useful for thyroid antioxidant support (Rayman 2012; Duntas 2010 for Hashimoto). 200mcg is the typical thyroid dose. Named-source TRAACS chelate lifts to Verified. Selenium has a narrow therapeutic window — exceeding 400mcg/day chronically raises risks (Bleys 2008).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "albion-magnesium-glycinate",
      "title": "Albion Magnesium Glycinate",
      "vendor": "Albion",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/36252f14-5e95-4dc6-bec9-054afd8f0331_large_b3a95da6-77c9-47ea-bb5d-18d63ad54287.jpg?v=1787417563",
      "score": 74,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "albion",
        "magnesium",
        "glycinate",
        "albion"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 78,
        "manufacturing": 70,
        "safety": 76,
        "transparency": 74,
        "sustainability": 55
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790667862213",
      "vsf_explanation": "Albion magnesium bisglycinate — best-tolerated form for magnesium repletion at 200-400mg elemental daily (Walker 2003; Schuchardt 2017), no laxative effect. Evidence for sleep, anxiety, and blood pressure (Abbasi 2012; Boyle 2017; Kass 2012). Named-source TRAACS chelate lifts to solid Verified. Would move to Elite with third-party verification per SKU.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "albion-multi-mineral-without-iron",
      "title": "Albion Multi-Mineral without Iron",
      "vendor": "Albion",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8e7a23a6-a634-42ae-9566-9532a22cc109_large_a4e65126-023f-426f-9013-acc4be29956a.jpg?v=1787417564",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "albion",
        "multi",
        "mineral",
        "without",
        "iron",
        "albion"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 76,
        "manufacturing": 70,
        "safety": 74,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 14.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790667894981",
      "vsf_explanation": "Iron-free Albion chelated multi-mineral is appropriate for adult men and post-menopausal women (avoiding iron overload — Zacharski 2007). All-chelate TRAACS forms are best-absorbed with less GI upset than oxide-based multi-minerals. Verified tier. Would move higher with disclosed elemental doses per mineral and NSF verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "albion-manganese",
      "title": "Albion Manganese",
      "vendor": "Albion",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/eb44a134-f884-4e42-913b-5152ac1b1250_large_ac39fe85-a196-42ab-aff9-0c64ba7aeda3.jpg?v=1787417563",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "albion",
        "manganese",
        "albion"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 74,
        "manufacturing": 70,
        "safety": 68,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 12.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790667927749",
      "vsf_explanation": "Albion manganese bisglycinate chelate for bone/connective tissue support at 2-5mg elemental. Named-source TRAACS chelate lifts to Verified. Manganese has neurotoxicity risk at high doses (Aschner 2005) so users should not stack with high-manganese well water or occupational exposure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "albion-copper-1",
      "title": "Albion Copper",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4d44b849-bc1b-4f1e-a44e-ba96503e13a4_large_28008849-c228-4746-95cd-46b52eb42993.jpg?v=1787417564",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "albion",
        "copper",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 74,
        "manufacturing": 70,
        "safety": 68,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 10.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790667960517",
      "vsf_explanation": "Albion-branded copper bisglycinate — high-absorption chelated form for balancing chronic zinc supplementation and supporting connective tissue / iron metabolism. RDI is 900mcg; typical supplement dose 1-2mg. Named-source TRAACS chelate lifts to Verified. Would move higher with disclosed elemental copper dose and third-party assay.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "albion-magnesium-glycinate-powder",
      "title": "Albion Magnesium Glycinate Powder",
      "vendor": "Albion",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/85d5f1f9-4ab3-4ec2-9936-8533725b24fa_large_4dd9270a-8097-4f6c-9074-158d794cab91.jpg?v=1787417565",
      "score": 74,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "albion",
        "magnesium",
        "glycinate",
        "powder",
        "albion"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 78,
        "manufacturing": 70,
        "safety": 76,
        "transparency": 74,
        "sustainability": 55
      },
      "price": 17.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790668288197",
      "vsf_explanation": "Albion magnesium bisglycinate powder — TRAACS chelate is the best-absorbed and best-tolerated magnesium form for general repletion (Walker 2003; Schuchardt 2017), no laxative effect at typical doses. Powder allows flexible 200-400mg elemental dosing per Boyle 2017 protocols. Verified tier. Would move to Elite with disclosed elemental mg per scoop and NSF/USP verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-leucine-featuring-ajipure",
      "title": "L-Leucine - Featuring AjiPure",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9641cdab-1c78-4467-976f-123451ba65e7_large_b5be5c5d-58ef-480c-a952-b79b16bc031e.jpg?v=1787417567",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "leucine",
        "featuring",
        "ajipure",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 72,
        "manufacturing": 76,
        "safety": 70,
        "transparency": 74,
        "sustainability": 55
      },
      "price": 8.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790669172933",
      "vsf_explanation": "L-leucine sourced from Ajinomoto's AjiPure — a pharmaceutical-grade fermentation-derived amino acid line with published purity specs and dedicated allergen-free manufacturing. Leucine's role in triggering mTOR-driven muscle protein synthesis is well-characterized (Anthony 2000, Norton 2009), with 2.5-3g operative for the anabolic response. Named branded sourcing (AjiPure) at label is a genuine quality signal that moves this above generic amino SKUs. Held below Elite because per-serving dose relative to the leucine threshold is not confirmed at title level, and standalone leucine is less useful than getting leucine from a complete-EAA source (Wilkinson 2013 showed leucine alone gives shorter MPS signal than EAA).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-lysine-pharmaceutical-grade",
      "title": "L-Lysine - Pharmaceutical Grade",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3940bbc9-06b0-461c-9a25-882390050ee5_large_6b0a15e4-b232-4457-9bf7-0fa228d73fea.jpg?v=1787417567",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lysine",
        "pharmaceutical",
        "grade",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 64,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 12.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790669205701",
      "vsf_explanation": "L-lysine has modest evidence for HSV-1 outbreak suppression at 1000-3000mg/day (Griffith 1978, Milman 1980). 'Pharmaceutical grade' is a marketing term not a certification. Standard Swanson quality. Would move to Verified with USP-verified certification and clearer per-serving dose in title.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "albion-potassium",
      "title": "Albion Potassium",
      "vendor": "Albion",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b9c7792d-e516-4fa7-8a37-546373d650c1_large_ce6af5e6-878e-4d3d-acb5-5c964c1b99c5.jpg?v=1787417567",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "albion",
        "potassium",
        "albion"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 72,
        "manufacturing": 68,
        "safety": 60,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 8.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790669238469",
      "vsf_explanation": "Albion-branded potassium glycinate chelate. Named-source chelate is a formulation plus but 99mg OTC cap limits clinical utility vs 3,500mg+ RDI. Upper Standard tier — good form, dose-limited by regulation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "albion-magnesium-glycinate-with-activated-b-vitamins",
      "title": "Albion Magnesium Glycinate with Activated B Vitamins",
      "vendor": "Albion",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f7391f24-ffd4-4d5b-8adf-f3a3102793cb_large_7756d4e9-d6d9-44f5-8f39-4ae0843a292d.jpg?v=1787417567",
      "score": 74,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "albion",
        "magnesium",
        "glycinate",
        "with",
        "activated",
        "vitamins",
        "albion"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 78,
        "manufacturing": 70,
        "safety": 74,
        "transparency": 74,
        "sustainability": 55
      },
      "price": 15.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790669271237",
      "vsf_explanation": "Albion magnesium bisglycinate — the best-tolerated magnesium form (Walker 2003) — combined with methylated B vitamins (typically methylfolate and methylcobalamin) to serve MTHFR-variant users. Named-source TRAACS chelate plus activated B forms is a clinically-forward pairing. Verified tier. Would move to Elite with disclosed dose, third-party purity, and RCT data on the combined formulation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "taurine-featuring-ajipure-1",
      "title": "Taurine - Featuring AjiPure",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d9f50ff3-13f5-48c8-9409-3cc7b436ff90_large_1c532465-ecd8-4999-9c46-8cef9a9cbc2d.jpg?v=1787417567",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "taurine",
        "featuring",
        "ajipure",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 68,
        "manufacturing": 68,
        "safety": 70,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 4.55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790669304005",
      "vsf_explanation": "Taurine has emerging evidence for cardiovascular and longevity endpoints (Singh 2023 Science). AjiPure is Ajinomoto's pharma-grade fermented amino acid ingredient with named-source traceability — meaningfully better than commodity taurine. Would move to Verified 70+ with a clearly-labeled 2-3g clinical dose per serving and third-party purity assay.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "glucosamine-chondroitin-msm-with-hyaluronic-acid-and-collagen",
      "title": "Glucosamine, Chondroitin & MSM with Hyaluronic Acid and Collagen",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ce0bebb0-d65b-4762-8b34-9bf195ce3dc8_large_81d40e3e-1c53-43e9-a37b-cc776a24935a.jpg?v=1787417614",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glucosamine",
        "chondroitin",
        "msm",
        "with",
        "hyaluronic",
        "acid",
        "and",
        "collagen",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 58,
        "sustainability": 52
      },
      "price": 28.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790686376133",
      "vsf_explanation": "Five-ingredient kitchen-sink joint stack: glucosamine + chondroitin + MSM + HA + collagen. Each individual ingredient has RCT support at specific doses (Clegg 2006, Kim 2006, Nelson 2015, Clark 2008) but combining five actives in a single capsule usually means sub-therapeutic dosing on multiple ingredients. Held below Verified by high likelihood that at least 2-3 actives sit below their studied dose ranges and no per-active mg in title. Would move to Verified 70+ only with full per-active mg disclosure showing clinical doses on core ingredients.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cinnulin-pf-cinnamon-extract",
      "title": "Cinnulin PF Cinnamon Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/410d7754-0a32-4820-81b2-856d80e91b50_large_2389cf9f-2c66-4270-8138-17b68f528123.jpg?v=1787417615",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cinnulin",
        "cinnamon",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 74,
        "manufacturing": 65,
        "safety": 72,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 29.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790686703813",
      "vsf_explanation": "Cinnulin PF is a branded water-soluble cinnamon extract that removes lipophilic coumarins (addressing Cassia hepatotoxicity risk) and concentrates type-A polymers — the most clinically studied form of cinnamon for glucose. Ziegenfuss 2006 and Anderson 2016 support modest fasting-glucose and insulin-sensitivity effects at 500 mg/day. Named-extract sourcing plus removal of coumarin lifts this materially above the generic cinnamon SKUs. Would move to Elite with USP/NSF verification and larger CGM-monitored outcome trials.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "calcium-orotate",
      "title": "Calcium Orotate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/189fef02-e3b5-4be3-8b10-52258f0817b7_large_46cbfb2a-8f3b-4c82-8c9f-2a84485f85aa.jpg?v=1787417615",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "calcium",
        "orotate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 56,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 7.1,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790686671045",
      "vsf_explanation": "Calcium orotate — the Nieper mineral-transport hypothesis lacks rigorous head-to-head RCT support versus citrate/carbonate. Elemental calcium is a small fraction of the orotate salt, requiring high pill count for meaningful intake. Standard tier low end. Would not upgrade without absorption/clinical outcome data.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "acid-relief-features-comforteze",
      "title": "Acid Relief - Features Comforteze",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/aed1502d-971f-4f04-9ee2-314b22592c33_large_bf690d01-6312-4e13-b1e9-2f267c56187f.jpg?v=1787417620",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "acid",
        "relief",
        "features",
        "comforteze",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 9.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790687162565",
      "vsf_explanation": "Comforteze is a branded blend targeting acid reflux/heartburn. Herbal reflux blends (typically DGL licorice, mastic, marshmallow) have small trials but nothing at PPI-comparator scale. Positioning as 'acid relief' treads close to unverified medical claim territory versus explicit occasional heartburn framing. Would need per-active mg disclosure and clear non-treatment framing to move up.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "albion-manganese-1",
      "title": "Albion Manganese",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d29ba780-8ce0-4244-8112-64acff824f91_large_b1d0678a-e634-46f1-b8a3-6bcad84d1ea1.jpg?v=1787417620",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "albion",
        "manganese",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 74,
        "manufacturing": 70,
        "safety": 68,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 7.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790687228101",
      "vsf_explanation": "Albion-branded manganese chelate (bisglycinate) delivers this bone/connective-tissue trace mineral in a high-bioavailability chelated form (TRAACS). Manganese RDI is 2.3mg; excess can be neurotoxic so dose discipline matters. Named-source raw material lifts this to low Verified. Would move higher with disclosed elemental dose and NSF verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sea-minerals-red-mineral-algae-featuring-aquamin",
      "title": "Sea Minerals: Red Mineral Algae - Featuring Aquamin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a73ebc2a-5c6d-46b5-af83-de6817d7bd7d_large_53f0c685-f232-42c7-adb4-ebc7c3c02527.jpg?v=1787417620",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sea",
        "minerals",
        "red",
        "mineral",
        "algae",
        "featuring",
        "aquamin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 68,
        "sustainability": 60
      },
      "price": 13.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790687195333",
      "vsf_explanation": "Aquamin (Marigot branded red algae calcium — Lithothamnion) has RCT support for bone density (Michalek 2011) and osteoarthritis (Frestedt 2008) at 800 mg calcium/day. Provides plant-source calcium with trace magnesium and 72 other minerals. Sustainable Irish algae harvesting is a sustainability positive. Would move to Verified 70+ with calcium mg dose match and USP verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cbd-full-spectrum-1",
      "title": "CBD Full Spectrum",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/833736b0-d96c-4f87-b502-9d40f97b03e3_large_210830fb-c9fb-4523-bef5-21296a10000c.jpg?v=1787417620",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cbd",
        "full",
        "spectrum",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 15,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790687260869",
      "vsf_explanation": "Full-spectrum CBD (cannabidiol + minor cannabinoids + terpenes) has RCT support for anxiety (Bergamaschi 2011 at 600 mg) and sleep (Shannon 2019 case series) but effective doses are typically well above OTC supplement amounts. FDA regulatory status remains unclear for CBD as a dietary supplement. Full-spectrum contains trace THC (<0.3%) which can trigger drug tests. Would need mg CBD per serving, third-party COA, and drug-test caution to move up.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "astaxanthin-zeaxanthin",
      "title": "Astaxanthin & Zeaxanthin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/81710e9c-6a81-4b0e-9a2d-7549fb0be833_large_607704be-86f0-4285-89dc-7139033b7f23.jpg?v=1787417620",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "astaxanthin",
        "zeaxanthin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 29.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790687293637",
      "vsf_explanation": "Astaxanthin + zeaxanthin pairing targets eye-strain and macular health. Both have RCT evidence (astaxanthin for eye fatigue, zeaxanthin in AREDS2). Per-carotenoid mg not disclosed on title. Would move to Verified 70+ with per-carotenoid mg disclosure and branded-source (AstaReal, OmniActive) confirmation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "albion-zinc-2-pack",
      "title": "Albion Zinc - 2 Pack",
      "vendor": "Albion",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cae6be2b-8a36-4c45-8d96-d397217e9b4e_large_46129ac8-07c3-4622-a355-4d1e1142721c.jpg?v=1787417620",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "albion",
        "zinc",
        "pack",
        "albion"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 76,
        "manufacturing": 70,
        "safety": 68,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 17.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790687326405",
      "vsf_explanation": "Albion zinc bisglycinate is a chelated, high-absorption zinc form with published bioavailability advantage over zinc sulfate (Gandia 2007). Named-source TRAACS chelate lifts this to Verified. Zinc 15-40mg supports immune function and testosterone (Prasad 2007). Would move higher with copper co-factoring and third-party verification. Chronic zinc supplementation needs copper pairing to prevent depletion.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "amealpeptide",
      "title": "AmealPeptide",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b96ffe8f-fa98-42d0-bff9-0f98fd454f6a_large_64c95ece-32bd-4b48-a950-99df83841177.jpg?v=1787417620",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "amealpeptide",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 20.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790687490245",
      "vsf_explanation": "AmealPeptide (Calpis branded milk-derived tripeptides isoleucine-proline-proline and valine-proline-proline) has RCT support for mild BP reduction (Xu 2008 meta) at 3.4-5.5 mg peptide/day. Naming the branded tripeptide is a formulation positive. Milk allergen caution needed. Would move to Verified 70+ with peptide mg dose disclosure and USP cert.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "alpha-lipoic-acid-2",
      "title": "Alpha Lipoic Acid",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2d06ffbd-1226-4727-954f-68f9a6b3080e_large_c25c0df8-7bef-4c64-8ab2-2cb94ba129f1.jpg?v=1787417620",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alpha",
        "lipoic",
        "acid",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 24.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790687359173",
      "vsf_explanation": "Racemic alpha-lipoic acid (50:50 R and S) is the standard ALA form, less bioavailable than pure R-ALA. Peripheral neuropathy RCT (Ziegler 2011) at 600 mg. Standard-strength typically 300-600 mg. Would move to Verified 70+ with R-ALA form and Na-R-ALA stabilization for shelf life.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "benfotiamine",
      "title": "Benfotiamine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d98e4fba-4be8-43eb-a3b1-113ecb0f6b6c_large_acc85948-f513-40fe-9c82-09814877bfa0.jpg?v=1787417621",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "benfotiamine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 13.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790687981765",
      "vsf_explanation": "Standard benfotiamine (typically 150 mg) — fat-soluble thiamine derivative with peripheral neuropathy RCT support (Stracke 2008 at 300-600 mg). Would move to Verified 70+ with dose match to studied protocol.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "anti-gas-enzyme-higher-strength",
      "title": "Anti-Gas Enzyme - Higher Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b1807f36-1ab0-4d27-9851-6181e27d5099_large_acd8c50c-77e8-4f1a-82ce-cefc69316c41.jpg?v=1787417620",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "anti",
        "gas",
        "enzyme",
        "higher",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 9.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790687457477",
      "vsf_explanation": "Alpha-galactosidase-style enzyme (Beano-analog) for FODMAP/legume gas. The enzyme has real mechanism and RCT support (Ganiats 1994 for beans; Di Stefano 2007). 'Higher strength' phrasing needs GalU units per capsule confirmed to compare to competitor doses. Would move to Verified with named enzyme (e.g., Aspergillus niger alpha-galactosidase) and GalU disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "albion-potassium-2-pack",
      "title": "Albion Potassium - 2 Pack",
      "vendor": "Albion",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/aaf2eb98-098a-49b7-a197-a10567d8f3c2_large_cd0abb4e-9258-433e-92cd-2fdcc1030feb.jpg?v=1787417620",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "albion",
        "potassium",
        "pack",
        "albion"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 72,
        "manufacturing": 68,
        "safety": 60,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790687424709",
      "vsf_explanation": "Albion-branded potassium glycinate chelate. Named-source chelate is a formulation plus, but OTC potassium is capped at 99mg per capsule versus a 3,500-4,700mg RDI, so this is a micro-dose supplement. Better used to fill dietary gaps in low-potassium eaters, not as primary electrolyte source. Upper Standard tier — legit form, limited dose reach.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bioperine",
      "title": "BioPerine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/86de8998-4cc1-48de-bcc4-ec1f8e2faa0e_large_ad46cf8a-7fce-49dc-9e55-9059ae597b6e.jpg?v=1787417620",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bioperine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790687686853",
      "vsf_explanation": "BioPerine (Sabinsa branded black pepper extract standardized to 95% piperine) is used as a bioavailability enhancer for curcumin, resveratrol, and other polyphenols. Standard dose 5-10 mg. Piperine inhibits CYP3A4 which affects many prescription drugs — needs medication-interaction disclosure. Naming the branded form at 95% standardization is a formulation positive. Would move to Verified 70+ with drug-interaction disclosure at label.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "beet-root-no-fast-acting",
      "title": "Beet Root NO+ - Fast Acting",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5dcebe4d-1654-4edd-94fc-f5d3fb8a151b_large_b2fd1b79-10e5-4ae9-b100-c78fb30dec58.jpg?v=1787417620",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beet",
        "root",
        "fast",
        "acting",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 22.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790687391941",
      "vsf_explanation": "Beet root nitrate for nitric oxide/BP/exercise economy (Kapil 2015; Cermak 2012 for endurance). 'Fast acting' suggests concentrated nitrate; mg NO3- per serving not disclosed. Would move to Verified with nitrate mg disclosure matching studied 400-800 mg dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "alpha-gpc-alpha-glyceryl-phosphoryl-choline",
      "title": "Alpha-GPC Alpha-Glyceryl Phosphoryl Choline",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3b49d9dd-08e9-4295-a7be-9ec2ace7529c_large_507b3101-80a4-43fb-9d74-b66a3000779f.jpg?v=1787417620",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alpha",
        "gpc",
        "alpha",
        "glyceryl",
        "phosphoryl",
        "choline",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 72,
        "manufacturing": 64,
        "safety": 70,
        "transparency": 66,
        "sustainability": 55
      },
      "price": 31.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790687621317",
      "vsf_explanation": "Alpha-GPC (alpha-glyceryl phosphoryl choline) crosses the blood-brain barrier more efficiently than choline bitartrate and delivers choline to acetylcholine synthesis with reasonable evidence at 300-600mg for cognitive performance and physical output (Ziegenfuss 2008; De Jesus Moreno 2003). Held below Verified by no branded-source identity (AlphaSize is the reference material) and no third-party testing disclosure. Recent observational signal from cardiovascular literature deserves monitoring but is not established causal. Would move to Verified 70+ with AlphaSize identity, disclosed per-serving mg, and per-lot COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "avovida",
      "title": "AvoVida",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/254002b6-d067-4da8-aacd-b6cab6bd212c_large_dc0928d9-1b36-4cd6-98f6-fce2e3580cca.jpg?v=1787417620",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "avovida",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 13.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790687555781",
      "vsf_explanation": "AvoVida standard-strength avocado-soybean unsaponifiables (ASU) for osteoarthritis (Christiansen 2015 meta at 300 mg/day). Naming the branded standardized ASU is a formulation positive. Would move to Verified 70+ with 300 mg per serving disclosure and USP/NSF cert.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "alpha-lipoic-acid-3",
      "title": "Alpha Lipoic Acid",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/03ed7cd8-eace-4c9d-bb79-813cf9922067_large_c086958d-ce62-4e81-a89b-1e662509d938.jpg?v=1787417620",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alpha",
        "lipoic",
        "acid",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 18.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790687523013",
      "vsf_explanation": "Basic racemic ALA — less bioavailable than R-ALA. Studied at 600 mg for peripheral neuropathy (Ziegler 2011). Would move to Verified 70+ with R-ALA form, Na-R-ALA stabilization, and dose match.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "alpha-lipoic-acid-4",
      "title": "Alpha Lipoic Acid",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f0460eaf-36ad-4ddd-88f1-fe0fe3d614fe_large_8bb3346a-e5f7-47c8-a6b7-cca6cb50746b.jpg?v=1787417620",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alpha",
        "lipoic",
        "acid",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 14.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790687588549",
      "vsf_explanation": "Generic alpha-lipoic acid at a Swanson budget price point. ALA is well-studied for diabetic neuropathy (Ziegler 2011) and glucose regulation at 300-600mg, but standard ALA is racemic (R+S) and less bioavailable than R-ALA. The title doesn't disclose R-isomer or stabilization, so it likely is the cheaper racemic form. Would move to Verified 70+ with R-ALA (Na-R-ALA) form, stability packaging, and third-party assay disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "caprylic-acid",
      "title": "Caprylic Acid",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/43163de3-d1f7-4ac3-be73-654c3dbace56_large_2e305a07-2ee8-41a7-98d6-425c0eb34161.jpg?v=1787417620",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "caprylic",
        "acid",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 6.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790687654085",
      "vsf_explanation": "Marketed largely for candida/gut yeast overgrowth. Human RCT evidence for oral caprylic acid on candida is thin — most support comes from in vitro or older uncontrolled clinical series. Standard Swanson formulation, no enteric coating disclosed which limits delivery past stomach acid. Would move up with delayed-release delivery and clearer clinical dose rationale.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "coq10-30-mg-3",
      "title": "CoQ10 30 mg",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5a357857-a7e1-46ec-8e69-029ce7e30795_large_00cbef4c-1157-40d7-afb5-9c4c21f82703.jpg?v=1787417622",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coq10",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 50,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 6.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790688047301",
      "vsf_explanation": "30 mg conventional CoQ10 is well below the 100-200 mg dose range used in essentially all cardiovascular RCTs (Skarlovnik 2014; Mortensen 2014 Q-SYMBIO). It functions as a general antioxidant baseline but is unlikely to produce the statin-myalgia or heart-function effects seen in the literature. Would move to Standard 65+ at 100 mg dose with confirmed Kaneka Q10 source and softgel delivery; 30 mg is best treated as an entry-level product not a therapeutic one.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "digestitol-with-enzymes-bioperine",
      "title": "Digestitol with Enzymes & BioPerine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d87ec062-e86b-403f-a6b1-78f57248bc96_large_4ff69083-d40f-468e-bf2a-f2671325d35f.jpg?v=1787417622",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "digestitol",
        "with",
        "enzymes",
        "bioperine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 7.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790688014533",
      "vsf_explanation": "Digestive enzyme combo with BioPerine (Sabinsa's black-pepper piperine extract) for absorption. BioPerine is a named branded ingredient with reasonable bioavailability data (Shoba 1998). Enzyme activity units (protease HUT, lipase FIP, amylase DU) are the meaningful metric and are not visible from the title. Would move to Verified with per-enzyme activity-unit disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "calcium-d-glucarate-2-in-1-formula",
      "title": "Calcium D-Glucarate - 2-in-1 Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d3d9bd14-d22c-4bc0-8f33-a734b1c377ec_large_623ed470-61f9-439c-a691-dfc5caac0b49.jpg?v=1787417622",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "calcium",
        "glucarate",
        "formula",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 62,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 16.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790688080069",
      "vsf_explanation": "Calcium D-glucarate is used to support beta-glucuronidase inhibition and Phase II detox / estrogen clearance (Walaszek 1990). Preliminary human evidence exists for hormone-related conditions but RCTs are limited. Typical effective dose 1,500-3,000mg. Upper Standard tier — mechanistically interesting, evidence still emerging. Would move to Verified with disclosed dose alignment and RCT data.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "phosphatidylserine",
      "title": "Phosphatidylserine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/80e8b327-cdf5-4562-8b9c-e799458d6942_large_c93ebc2f-1df5-4205-9b9c-c930ca52300e.jpg?v=1787417623",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "phosphatidylserine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 26.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790688866501",
      "vsf_explanation": "Standard-line phosphatidylserine capsule. Evidence base for PS 100-300mg in age-related cognitive decline is solid (Kato-Kataoka 2010) and for exercise-stress cortisol modulation (Starks 2008). Held below Verified because the source (soy vs sunflower) and any COA are not disclosed. Safety profile is very good. Would move to Verified 70+ with sunflower-sourced PS format and third-party heavy-metal testing published.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cognizin-citicoline",
      "title": "Cognizin Citicoline",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f8c4ae40-1ded-465e-bb33-5a4de110d826_large_3e5c9914-0cdf-402a-85b8-5d6648f14083.jpg?v=1787417623",
      "score": 73,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cognizin",
        "citicoline",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 74,
        "formulation": 76,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 58.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790688899269",
      "vsf_explanation": "Cognizin (Kyowa Hakko branded citicoline / CDP-choline) has RCTs for attention (McGlade 2012 at 250-500 mg), age-related cognitive decline (Alvarez-Sabin 2016), and post-stroke recovery. Naming the branded ingredient at label is a strong formulation choice. Would move to Elite with USP verification and 250-500 mg dose match to studied protocols.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ionic-trace-mineral-drops",
      "title": "Ionic Trace Mineral Drops",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e85cb45c-ec14-44e3-875c-a2d7b0522119_large_990dc59e-6ee4-418f-b4c1-d04debba3828.jpg?v=1787417623",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ionic",
        "trace",
        "mineral",
        "drops",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 32.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790688964805",
      "vsf_explanation": "Liquid ionic trace mineral drops typically Great Salt Lake or seawater-sourced; per-mineral mcg amounts are very low (well under physiological need for most minerals). Sodium content notable. Marketing claim of '72 minerals' is technically true but functionally minor. Would need per-mineral mcg disclosure and honest positioning to move up.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "d-ribose-with-malic-acid-powder",
      "title": "D-Ribose with Malic Acid Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/38609058-aeef-4936-9db3-7f0785e29bed_large_af0a421b-36c2-4bb7-9413-55e26e598735.jpg?v=1787417623",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ribose",
        "with",
        "malic",
        "acid",
        "powder",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 44.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790688932037",
      "vsf_explanation": "D-Ribose + malic acid stack is aimed at fibromyalgia and heart-failure energy metabolism (Teitelbaum 2006). Malic acid supports Krebs cycle intermediate turnover. Powder format allows dose-flexibility to reach studied 5 g TID ribose. Would move to Verified 70+ with per-serving g disclosure and clear fibromyalgia/HF use-case framing rather than 'general energy'.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "coq10-100-mg",
      "title": "CoQ10 100 mg",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7b6efe85-c560-4b10-bbe4-025488eb8968_large_8e0043d8-8a71-410a-9062-10439362333a.jpg?v=1787417624",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coq10",
        "100",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 21.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790688997573",
      "vsf_explanation": "100 mg conventional CoQ10 (ubiquinone) is the workhorse cardiovascular dose supported by Skarlovnik 2014 (statin-associated myalgia) and Mortensen 2014 Q-SYMBIO (heart failure adjunct). Users over 40 should generally prefer ubiquinol. Held below Verified because Kaneka Q10 sourcing and softgel-in-oil delivery are not confirmed on the SKU. Would move to Verified 70+ with named Kaneka Q10 source and softgel delivery.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cran-max",
      "title": "Cran-Max",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ab72ae4a-5516-4c2f-a397-3a40bdee9591_large_dc882b59-06b8-4f71-9e3e-191dd96f9e4f.jpg?v=1787417625",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cran",
        "max",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 72,
        "manufacturing": 65,
        "safety": 68,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 23.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790689816773",
      "vsf_explanation": "Cran-Max (Naturex/Givaudan branded whole cranberry powder standardized to Bio-Shield process) has RCT support for UTI recurrence reduction (Efros 2010; Ledda 2015) at 500 mg/day. Naming the branded standardized cranberry is a real formulation positive. Would move to Elite with USP verification and dose match to 500 mg protocol.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cbd-joint-support-full-spectrum-with-levagen-pea",
      "title": "CBD + Joint Support Full Spectrum with Levagen+ PEA",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/72d05d2b-1ccb-4e16-9137-bf84490dc6fe_large_3d5a7d08-0161-4430-b40a-17f273e7a5d7.jpg?v=1787417625",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cbd",
        "joint",
        "support",
        "full",
        "spectrum",
        "with",
        "levagen",
        "pea",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 72,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 25.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790689882309",
      "vsf_explanation": "Full-spectrum CBD combined with Levagen+ PEA (palmitoylethanolamide) — a named-source clinical PEA from Gencor with human data for joint discomfort (Steels 2019, Bartolucci 2018). PEA has stronger RCT support than CBD for joint pain. Held below Verified by CBD purity/COA disclosure being critical yet not visibly certified at title-level, and potential drug interactions with CYP450 substrates requiring safety flagging. Would move to Verified 70+ with COA link and named CBD source with heavy-metal testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "coq10-400-mg",
      "title": "CoQ10 400 mg",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/01a025ba-10e5-7772-97f4-5f77c33a6b5d.jpg?v=1787417626",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coq10",
        "400",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 19.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790689980613",
      "vsf_explanation": "400 mg conventional CoQ10 (ubiquinone) is a high dose used in specific research protocols like Parkinson's neuroprotection (Shults 2002) and severe heart failure adjunct therapy. For most cardiovascular indications the 100-200 mg range gives the bulk of the benefit, and at 400 mg the fat-soluble absorption ceiling becomes a real constraint (softgel-with-oil delivery matters even more). Kaneka Q10 sourcing is not confirmed on the listing. Would move to Verified 70+ with named Kaneka Q10 source and softgel-with-oil delivery, plus dosing guidance clarifying which use cases justify 400 mg.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "concentrace-trace-mineral-complex",
      "title": "ConcenTrace Trace Mineral Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9e94ac66-3ec2-4631-8fd3-f0a76ef694b7_large_bdbb8671-1aa8-4bcd-80f7-daa9449a3cb3.jpg?v=1787417626",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "concentrace",
        "trace",
        "mineral",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 13.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790690013381",
      "vsf_explanation": "ConcenTrace (Trace Minerals Research) is Great Salt Lake-sourced ionic trace mineral concentrate. Marketed claims of 72+ trace minerals include very low mcg amounts of most minerals — well below the mcg/mg needed for physiological effect. Sodium content is high (per unit dose). Would need clear per-mineral mcg disclosure and honest framing of the trace-only positioning to move above low-Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "coq10-200-mg",
      "title": "CoQ10 200 mg",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b8d82c96-9c86-4f26-9a47-6c59a05cd1b3_large_a690c3da-da7a-44ea-9b95-393aac4a1086.jpg?v=1787417627",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coq10",
        "200",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 66,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 16.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790690078917",
      "vsf_explanation": "200 mg CoQ10 (ubiquinone) sits at the higher end of the workhorse cardiovascular dose range supported by Skarlovnik 2014 (statin myalgia) and Mortensen 2014 Q-SYMBIO (heart failure adjunct). Ubiquinol would be the better form for users over 40. Held below Verified because Kaneka Q10 source and softgel-in-oil delivery are not confirmed on the SKU. Would move to Verified 70+ with named Kaneka Q10 and softgel-with-oil delivery.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "coq10-120-mg",
      "title": "CoQ10 120 mg",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/dd6b9eff-22d0-4a61-94b8-65137d300af6_large_631c952b-7a62-447a-997c-63e9e0dfde5d.jpg?v=1787417627",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coq10",
        "120",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 22.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790690111685",
      "vsf_explanation": "120 mg conventional CoQ10 (ubiquinone) is inside the cardiovascular dose range studied in Skarlovnik 2014 (statin-myalgia) and adjacent to the 100 mg Q-SYMBIO regimen (Mortensen 2014). Delivery form (softgel vs dry cap) and Kaneka Q10 sourcing are not confirmed on the listing — both matter for fat-soluble ubiquinone. Would move to Verified 70+ with named Kaneka Q10 source and softgel-in-oil delivery.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "coq10-100-mg-1",
      "title": "CoQ10 100 mg",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ceaa7af5-2ad2-4d9d-8125-14dee4ec1ee4_large_56e34e94-a668-4768-bfa0-2b374d019832.jpg?v=1787417627",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coq10",
        "100",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 11.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790690177221",
      "vsf_explanation": "100 mg conventional CoQ10 (ubiquinone) is the standard cardiovascular dose supported by the statin-myalgia and heart-failure adjunct literature (Skarlovnik 2014; Mortensen 2014 Q-SYMBIO). The form is fine for adults under 40; ubiquinol is a better choice above that age. Kaneka Q10 source and softgel-in-oil delivery are not confirmed on the SKU listing. Would move to Verified 70+ with named Kaneka Q10 and softgel-with-oil delivery.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chromax-2000",
      "title": "Chromax 2000",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b9cc942f-092c-4774-a0f9-663d00956e3b_large_5750b968-613c-45e9-87b1-5c3345a0be76.jpg?v=1787417627",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chromax",
        "2000",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 11.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790690209989",
      "vsf_explanation": "Chromax (Nutrition 21 branded chromium picolinate) has mixed evidence — small effect on fasting glucose in insulin-resistant patients (Balk 2007 meta) but null in metabolically healthy adults. High-dose chronic picolinate carries theoretical DNA-damage concern (Vincent 2004). Naming the branded form is transparency-positive. Would move to Verified with 200-1000 mcg dose disclosure and explicit non-diabetic-treatment framing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "beet-root-complex-nitric-oxide-precursor-formula",
      "title": "Beet Root Complex - Nitric Oxide Precursor Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/11a3bee7-0bf2-4322-9d85-39415c95c2c1_large_7d42a1ca-cd90-4672-8012-a35fd415729f.jpg?v=1787417627",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beet",
        "root",
        "complex",
        "nitric",
        "oxide",
        "precursor",
        "formula",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 17.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790690242757",
      "vsf_explanation": "Dietary nitrate from beetroot has real evidence for lowering blood pressure and improving exercise economy (Siervo 2013 meta; Lansley 2011), but the effect scales with actual nitrate content (roughly 300-600 mg NO3-). Powder capsules typically deliver a fraction of the nitrate of concentrated beetroot juice or shots. Transparency is the primary gap — the SKU does not disclose nitrate content per serving, which is the only actionable dose metric. Would move to Standard 65+ with disclosed nitrate mg per serving; Verified only if per-serving nitrate reaches the 300 mg+ studied range.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "creatine-monohydrate-2-pack",
      "title": "Creatine Monohydrate - 2 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/02aca7dc-c3d3-4780-9f51-230fbd418b32_large_ba4f9457-11bb-4161-a9e8-1d81cbcb3418.jpg?v=1787417628",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "creatine",
        "monohydrate",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 82,
        "formulation": 68,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 65,
        "sustainability": 58
      },
      "price": 33.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790690799813",
      "vsf_explanation": "Two-pack of the same base creatine monohydrate SKU. The molecule itself is the most-studied ergogenic on the market (Kreider 2017 ISSN position; 3-5g/day maintenance). Held at Standard on the same points as the single: no Creapure sourcing named at label, no published COA, no NSF Certified for Sport certification. Would move to Verified 70+ with any one of those transparency additions.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "celadrin-joint-cream",
      "title": "Celadrin Joint Cream",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e783ac7e-fbd0-4251-8dd3-6d7ffeaf518c_large_686c5542-a17b-442b-bdf3-01d70cfa752a.jpg?v=1787417628",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "celadrin",
        "joint",
        "cream",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 66,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 18.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790690832581",
      "vsf_explanation": "Topical Celadrin (esterified fatty acid complex) cream — small trials (Kraemer 2004 knee OA, Hesslink 2002) show modest topical benefit for joint stiffness. Named ingredient (Celadrin is a branded proprietary blend from Imagenetix) is a transparency plus. Held below Verified by small evidence base, no independent replication of the branded trials, and generic Swanson formulation without third-party topical-purity testing. Would move to Verified 70+ with independent replication data.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cbd-sleep-support-full-spectrum-w-melatonin-gaba-l-theanine",
      "title": "CBD + Sleep Support Full Spectrum w/ Melatonin, GABA & L-Theanine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3d417a12-63d0-491b-b3d7-1a03246abfd4_large_e0e5cd46-7122-4cdf-94cb-fe623d4c0027.jpg?v=1787417628",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "cognitive",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cbd",
        "sleep",
        "support",
        "full",
        "spectrum",
        "melatonin",
        "gaba",
        "theanine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 20.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790690865349",
      "vsf_explanation": "CBD + melatonin + GABA + L-theanine stack targets sleep through multiple pathways but stacks that many actives in one dose form, none of which has robust RCT evidence for cognitive/sleep enhancement at typical OTC doses. CBD-drug interaction potential (CYP3A4/2C19) is often under-disclosed, and CBD at low doses in a multi-ingredient blend rarely reaches serum levels relevant in the sleep literature. Melatonin, if in the standard 3-5mg range, is 5-15x the physiological amount needed for sleep onset (Auld 2017 meta suggests 0.3-1mg is closer to endogenous). Would move to Verified 70+ with physiological melatonin, per-active dose disclosure, and prominent CBD drug-interaction warning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "coq10-200-mg-1",
      "title": "CoQ10 200 mg",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3fe61994-f24a-41b8-bbdb-7c6bdc23fd3c_large_b6f22caa-0045-4cad-be56-92a9c6fb090a.jpg?v=1787417629",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coq10",
        "200",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 66,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 27.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790690898117",
      "vsf_explanation": "200 mg conventional CoQ10 (ubiquinone) is in the sweet spot for the statin-myalgia and heart-failure-adjunct evidence base (Skarlovnik 2014; Mortensen 2014 Q-SYMBIO). Adults over 40 convert less efficiently to ubiquinol so ubiquinol would be the technically better form for that cohort. Held below Verified because Kaneka Q10 sourcing is not confirmed on the SKU and softgel vs dry-cap delivery is unstated. Would move to Verified 70+ with named Kaneka Q10 source and softgel-in-oil delivery.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "astaxanthin",
      "title": "Astaxanthin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/64e70ace-60e9-4463-a1c9-535f542db892_large_a876ca0e-0c6e-4848-86db-f6713d0b3afc.jpg?v=1787417629",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "astaxanthin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 18.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790690930885",
      "vsf_explanation": "Standard-strength astaxanthin — RCT support for skin photoprotection (Ito 2018) at 4-6 mg/day. Source, brand, and cultivation method not disclosed. Would move to Verified 70+ with Haematococcus source and AstaReal/BioAstin branded-supplier disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cbd-full-spectrum-balm-mint",
      "title": "CBD Full Spectrum Balm - Mint",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b0811737-c26b-423f-a1b6-83cf54ef4370_large_ed5b0879-3e9c-4f2b-824e-152314cfd8d8.jpg?v=1787417630",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cbd",
        "full",
        "spectrum",
        "balm",
        "mint",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 28.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790691553477",
      "vsf_explanation": "Topical CBD balms have very limited RCT evidence for musculoskeletal pain — most trials use oral or transdermal patches, and skin penetration of cannabinoids from a balm is poorly characterized. This is a personal-care topical rather than an ingestible supplement, sitting at the edge of Vyvata's supplement scope. Without published per-batch COA the CBD-mg claim is unverifiable. Would move up with clinical trial-grade transdermal delivery data and third-party potency testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "beta-glucan",
      "title": "Beta Glucan",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fbd78b00-56a1-42e6-a415-8d489908f64f_large_99672ead-e482-49a2-994b-a813f90348cc.jpg?v=1787417630",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beta",
        "glucan",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 58,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 16.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790691619013",
      "vsf_explanation": "Generic 'Beta Glucan' without source disclosure (yeast 1,3/1,6 vs oat 1,3/1,4 vs mushroom) is a red-flag transparency issue — these have distinct immune-modulatory activity and evidence bases (Wellmune yeast beta-glucan has the strongest URTI incidence data, Fuller 2012). Held to low Standard by that missing disclosure and by absence of a branded studied ingredient. Would move up substantially with either a Wellmune, Immunel, or specific yeast beta-1,3/1,6 designation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cbd-stress-support-full-spectrum-with-sensoril-ashwagandha",
      "title": "CBD + Stress Support Full Spectrum with Sensoril Ashwagandha",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6149d0a9-f2ab-43ac-b40c-84ef75b9fb32_large_9519090c-a84b-4b0c-b39d-8eb7fcea3c80.jpg?v=1787417631",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cbd",
        "stress",
        "support",
        "full",
        "spectrum",
        "with",
        "sensoril",
        "ashwagandha",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 12.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790691684549",
      "vsf_explanation": "Full-spectrum CBD + Sensoril ashwagandha combo. Sensoril is a solid stress-anxiety ingredient (Auddy 2008). Full-spectrum CBD has anxiolytic signal (Bergamaschi 2011 SAD) but at doses (300mg+) well above what most CBD supplements deliver. Third-party CBD potency and heavy-metal testing are critical in this category and not visible. Would move to Verified with per-serving CBD mg disclosure and third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "biocore-optimum-complete",
      "title": "BioCore Optimum Complete",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ff34e2f9-d249-4b3b-8817-9c55e852180a_large_ce1dfb80-88af-4364-9dcb-cba210ce6949.jpg?v=1787417631",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "biocore",
        "optimum",
        "complete",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 23.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790691717317",
      "vsf_explanation": "BioCore (Deerland Enzymes) branded broad-spectrum digestive enzyme blend covering protease, amylase, lipase, cellulase. Digestive enzyme evidence for general use is limited outside pancreatic insufficiency. Branded blend is a formulation positive. Would move to Verified with FCC unit disclosure per enzyme and clear indication framing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "albion-dimagnesium-malate-powder",
      "title": "Albion DiMagnesium Malate Powder",
      "vendor": "Albion",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/dc3eb44e-2f65-42e9-993e-e0ecb5f3a82b_large_fcefbf8a-95b5-460e-ba83-3bc688418796.jpg?v=1787417633",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "albion",
        "dimagnesium",
        "malate",
        "powder",
        "albion"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 76,
        "manufacturing": 72,
        "safety": 72,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 19.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790691881157",
      "vsf_explanation": "Albion-branded dimagnesium malate is a chelated form with published bioavailability data and TRAACS mineral-chelation credentialing. Magnesium malate is often used for fibromyalgia/energy support (Russell 1995 preliminary data). Named-source Albion raw material lifts this to Verified. Powder format allows flexible dosing. Would move higher with disclosed elemental dose and third-party per-SKU purity.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "biodefense-nk-mushroom-blend",
      "title": "BioDefense NK+ - Mushroom Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/083424c7-e8b1-4e4d-ba7d-17c45d413675_large_298099b6-df78-4c1c-8431-75bbd10e9037.jpg?v=1787417633",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "biodefense",
        "mushroom",
        "blend",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 65,
        "safety": 68,
        "transparency": 58,
        "sustainability": 62
      },
      "price": 32.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790691913925",
      "vsf_explanation": "NK+ branding implies natural-killer-cell support, plausible mechanistically for beta-glucan-rich mushroom polysaccharides (AHCC data on NK activity, Ritz 2008) but NK-boosting claims are stronger in marketing than in translated clinical outcomes. Held to mid-Standard by 'blend' framing that typically hides per-mushroom mg and doesn't distinguish fruiting body from mycelium-on-grain — the single most important quality variable in mushroom supplementation. Would move up with fruiting-body-only sourcing and disclosed beta-glucan percentages.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "betatene-natural-mixed-carotenoids",
      "title": "Betatene Natural Mixed Carotenoids",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0f43c330-ecd9-4f0d-9057-39e2ee98257d_large_b15d13f5-4f2a-44d0-911f-91320a762ab3.jpg?v=1787417635",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "betatene",
        "natural",
        "mixed",
        "carotenoids",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 15.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790692470981",
      "vsf_explanation": "Betatene (BASF/Cognis branded natural mixed carotenoids from Dunaliella salina algae) provides beta-carotene, alpha-carotene, lutein, zeaxanthin, cryptoxanthin — natural mix outperforms synthetic beta-carotene alone, which raised lung cancer risk in smokers (ATBC 1994, CARET 1996). Natural D. salina source is a strong formulation choice. Would move to Verified 70+ with per-carotenoid mg disclosure and smoker-specific labeling.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chirositol-d-chiro-inositol",
      "title": "Chirositol D-Chiro-Inositol",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/085bb21b-d12a-460a-9e18-179d0cb7ba18_large_35e514ba-fe6a-4030-881f-8f54832cd9ef.jpg?v=1787417636",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chirositol",
        "chiro",
        "inositol",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 72,
        "manufacturing": 65,
        "safety": 68,
        "transparency": 72,
        "sustainability": 50
      },
      "price": 20.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790693322949",
      "vsf_explanation": "D-chiro-inositol has RCT support for PCOS insulin sensitivity and ovulation (Nestler 1999; Genazzani 2014) at 600-1200 mg/day. Chirositol is a branded standardized form. Naming the branded ingredient is a formulation positive. Would move to Elite with USP verification and clear 600-1200 mg dose match. Note: myo-inositol + D-chiro at 40:1 ratio (Nordio 2012) is the current preferred protocol.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "r-fraction-alpha-lipoic-acid-double-strength",
      "title": "R-Fraction Alpha Lipoic Acid - Double Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a89e460b-5b26-4202-8d42-66027fc621fd_large_10d8aeee-dad7-4e83-a039-77dc8f99e0c5.jpg?v=1787417681",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fraction",
        "alpha",
        "lipoic",
        "acid",
        "double",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 67,
        "formulation": 67,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 20.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790701023429",
      "vsf_explanation": "R-alpha-lipoic acid double strength typically 200-300 mg, better bioavailability than racemic ALA. Studied at 600 mg for diabetic peripheral neuropathy (Ziegler 2011). Would move to Verified 70+ with Na-R-ALA stabilization and dose match to neuropathy protocol.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ginkgo-biloba-extract-standardized-4",
      "title": "Ginkgo Biloba Extract - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7aa3644d-08fb-4efa-953a-7b069687fe40_large_34a9b17c-a66f-4fe2-aa1e-4cdce812d95c.jpg?v=1787417682",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ginkgo",
        "biloba",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 66,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790701121733",
      "vsf_explanation": "Standardized ginkgo extract following the 24% flavone-glycoside / 6% terpene-lactone template that mirrors EGb 761, the extract profile behind most positive cognitive RCTs (Le Bars 1997; Ihl 2011). Generic Swanson manufacturing footprint and no third-party COA. Bleeding-risk interaction with anticoagulants/antiplatelets is under-disclosed across the ginkgo category. Would move to Verified 70+ with named EGb-comparable extract, per-lot testing, and explicit anticoagulant warning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "femflora-probiotic-for-women",
      "title": "FemFlora Probiotic for Women",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/73383a13-dcee-4f90-9760-eac28fa8354b_large_7259179b-0dff-44e6-9611-d596c7a21f1a.jpg?v=1787417681",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "femflora",
        "probiotic",
        "for",
        "women",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 13.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790701088965",
      "vsf_explanation": "Women's-targeted probiotic. Vaginal/urogenital effects are strain-specific: L. rhamnosus GR-1 and L. reuteri RC-14 (Reid 2003) are the pair with the strongest urogenital-colonization data. The title does not confirm these are the strains used. Would move to Verified with GR-1/RC-14 identification and CFU-at-expiration disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "coq10-60-mg",
      "title": "CoQ10 60 mg",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/75771049-e67e-4f1a-ac22-f142943a3d87_large_a4ccd14d-5208-43cf-ad17-94e3ade68e2a.jpg?v=1787417681",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coq10",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 16.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790701056197",
      "vsf_explanation": "60 mg conventional CoQ10 (ubiquinone) is below the workhorse cardiovascular dose used in most published trials (100-200 mg per Skarlovnik 2014 and Mortensen 2014 Q-SYMBIO). It is defensible as a general antioxidant/mitochondrial baseline but under-serves users with a specific clinical goal like statin-myalgia support. Delivery form (softgel vs dry cap) is not confirmed on the listing, which matters because CoQ10 is fat-soluble. Would move to Standard 65+ with 100+ mg dose and softgel-with-oil-carrier delivery.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "tocotrienols-from-annatto",
      "title": "Tocotrienols - From Annatto",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c8273bc6-b7f4-4aec-b588-11d5c0ecdecf_large_2aaebd81-7d58-44fa-8dda-a229c3c82f77.jpg?v=1787417681",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tocotrienols",
        "from",
        "annatto",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 72,
        "manufacturing": 65,
        "safety": 68,
        "transparency": 72,
        "sustainability": 60
      },
      "price": 20.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790701154501",
      "vsf_explanation": "Annatto-source tocotrienols (typically DeltaGold from American River Nutrition) provide delta-tocotrienol (~90%) + gamma without the alpha-tocopherol that interferes with tocotrienol absorption (Qureshi 1996). Best-in-class tocotrienol form. RCTs for lipid, bone, and NAFLD endpoints (Song 2018). Naming annatto source is a strong formulation choice. Would move to Elite with DeltaGold branded confirmation and USP/NSF cert.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "eggshell-calcium-with-vitamin-d3",
      "title": "Eggshell Calcium with Vitamin D3",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/648f3027-d967-4dbd-a149-8e9d1ca6a444_large_d7c12934-5faf-4d70-b623-ed6f8894096e.jpg?v=1787417681",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "eggshell",
        "calcium",
        "with",
        "vitamin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 62,
        "sustainability": 65
      },
      "price": 4.75,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790701220037",
      "vsf_explanation": "Eggshell calcium is calcium carbonate with trace organic matrix; bioavailability data is modest (Bronner 2003) and mirrors calcium carbonate more than calcium citrate. Pairing with D3 is nutritionally appropriate for calcium absorption. Held below Verified by carbonate-form bioavailability limits (better absorbed with meals; poor in low-stomach-acid users), unclear elemental Ca mg, and no K2 co-nutrient to direct calcium into bone rather than arteries. Would move to Verified 70+ with citrate/malate form or added K2-MK7 and specific elemental mg dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnesium-oil",
      "title": "Magnesium Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3524490a-c323-4224-86f8-b91e3fa761c7_large_e2467d5c-37e5-4bee-8639-574b36b2676f.jpg?v=1787417681",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "oil",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 45.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790701187269",
      "vsf_explanation": "Topical magnesium chloride spray. Transdermal absorption of magnesium is minimal per rigorous studies (Grober 2017); this is a comfort/local-application product, not a systemic repletion strategy. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "coq10-vitamin-k2",
      "title": "CoQ10 + Vitamin K2",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/39bd28d7-9d2b-4a58-86b0-25a88fe39273_large_6ef70758-2569-4c59-a1f8-ca6bb64ebc59.jpg?v=1787417681",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coq10",
        "vitamin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 74,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 34.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790701285573",
      "vsf_explanation": "CoQ10 has strong cardiovascular evidence including statin-associated myalgia mitigation (Skarlovnik 2014) and heart failure adjunct data (Mortensen 2014 Q-SYMBIO), and K2-MK7 has arterial calcification data (Knapen 2015). Pairing is well-rationalized cardiovascular support. Held below Verified by likely ubiquinone (not ubiquinol) form, unclear mg CoQ10 and mcg K2 doses from title, and no named-source ingredient. Would move to Verified 70+ with Kaneka Q10 or ubiquinol disclosure plus MenaQ7 K2 source.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "suntheanine-l-theanine",
      "title": "Suntheanine L-Theanine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/79619d4d-706a-4c27-b1be-6c3ecd466ab1_large_97a2aaaa-cce9-4d36-906e-da6da16a507c.jpg?v=1787417681",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "cognitive",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "suntheanine",
        "theanine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 74,
        "manufacturing": 72,
        "safety": 80,
        "transparency": 74,
        "sustainability": 55
      },
      "price": 25.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790701252805",
      "vsf_explanation": "Suntheanine (Taiyo) is the enantiomerically pure L-theanine used in the majority of cognitive/stress RCTs including Kimura 2007 (stress-response attenuation) and Higashiyama 2011 (attention/alertness). Using the branded, patented material rather than generic mixed D/L-theanine is a real quality upgrade. Dose within 100-200mg studied window is expected; safety is excellent and interactions are minimal. Held below Elite by generic Swanson manufacturing footprint and no per-lot COA. Would move to Verified 75+ with published third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "tocotrienols-double-strength",
      "title": "Tocotrienols - Double Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a57edd1c-3931-4796-bf77-1cf998bb5ca2_large_7ff16e1d-ca0e-4f9a-932c-465b1c4a8d9d.jpg?v=1787417681",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tocotrienols",
        "double",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 67,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 39.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790701449413",
      "vsf_explanation": "Double-strength tocotrienols; source (palm vs annatto vs rice bran) not disclosed on title, which materially matters — palm and rice bran forms are mixed with alpha-tocopherol which reduces tocotrienol bioavailability. Would move to Verified 70+ with annatto/DeltaGold source disclosure or alpha-tocopherol-free confirmation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lyc-o-mato-lycopene-double-strength",
      "title": "Lyc-O-Mato Lycopene - Double Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8455bc48-7b63-4e03-8ea9-1acc0e42e156_large_6d59317c-98af-4923-a4f0-b203bf508300.jpg?v=1787417681",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lyc",
        "mato",
        "lycopene",
        "double",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 67,
        "formulation": 70,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 21.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790701416645",
      "vsf_explanation": "Lyc-O-Mato branded lycopene from LycoRed at 'double strength' (typically 20-30 mg) matches or exceeds the Ried 2011 meta-analysis dose for modest systolic BP reduction. Naming the branded extract is a formulation positive. Would move to Verified 70+ with USP/NSF cert and dose match confirmation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liposomal-vitamin-c-high-bioavailability-1",
      "title": "Liposomal Vitamin C - High Bioavailability",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/298701bb-9d7b-41d6-ad90-c411d6fef91e_large_c599005c-dac7-4300-a31b-b71382ba7485.jpg?v=1787417681",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liposomal",
        "vitamin",
        "high",
        "bioavailability",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 76,
        "manufacturing": 64,
        "safety": 72,
        "transparency": 66,
        "sustainability": 55
      },
      "price": 50.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790701318341",
      "vsf_explanation": "True liposomal vitamin C shows meaningfully higher plasma AUC than plain ascorbic acid (Davis 2016 Nutr Metab Insights) and reduces GI intolerance at higher doses. Vitamin C evidence for immune duration (Hemila & Chalker 2013 Cochrane) is well established. Held below Elite by unverified liposomal encapsulation quality (mass-market liposomal SKUs vary widely in true phosphatidylcholine encapsulation vs simple emulsion), no third-party liposome validation, and no NSF/USP certification. Would move to Verified 75+ with independent liposome-encapsulation validation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dim-complex",
      "title": "DIM Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b1d63558-e3fa-4f85-9074-a619ec7646b6_large_48321d57-4208-4f43-b87d-4c2c63f9b487.jpg?v=1787417681",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dim",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 14.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790701383877",
      "vsf_explanation": "Diindolylmethane (DIM) is an indole-3-carbinol metabolite marketed for estrogen metabolism support. Small trials in tamoxifen-treated breast cancer patients (Thomson 2017) and hormone-related conditions. Complex format usually adds BioPerine + cofactors — without per-active mg the formulation is opaque. Would move to Verified with per-active mg disclosure and honest framing that hormone claims outrun the data.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "elderberry-extract-syrup-no-sugar-added",
      "title": "Elderberry Extract Syrup - No Sugar Added",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/bd36699a-4670-4cd9-91e2-d72e240639d0_large_0f037777-a592-4a22-ac76-14666013e77a.jpg?v=1787417681",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "elderberry",
        "extract",
        "syrup",
        "sugar",
        "added",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 60,
        "sustainability": 60
      },
      "price": 13.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790701351109",
      "vsf_explanation": "Elderberry syrup delivery is the format used in most positive cold/flu trials (Tiralongo 2016; Zakay-Rones 2004 for Sambucol), and 'no sugar added' avoids the sucrose burden of Sambucol-style syrups. Held to mid-Standard because the title lacks anthocyanin standardization percentage and does not disclose whether extraction is standardized to a defined active fraction. Elderberry syrup is a reasonable acute-illness use-case supplement. Would move up with disclosed anthocyanin content and per-serving elderberry equivalent.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "eyesalive-vision-nutrition",
      "title": "EyesAlive Vision Nutrition",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5bcd4a3d-8c78-4aa6-ac96-25168b9b6e5f_large_50054eb7-26f1-46fb-8075-bc1685a0f209.jpg?v=1787417681",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "eyesalive",
        "vision",
        "nutrition",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 68.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790701482181",
      "vsf_explanation": "Blended eye-health formulas typically stack lutein/zeaxanthin, zinc, C, E per AREDS2. Blend format without per-active mg limits verification against AREDS2 protocol (10 mg lutein, 2 mg zeaxanthin, 80 mg zinc, 400 IU E, 500 mg C). Would move to Verified with AREDS2 dose match and per-ingredient disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "enhanced-pqq-with-ubiquinol",
      "title": "Enhanced PQQ with Ubiquinol",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/31197914-423e-4a3e-ad4c-d512916b0a21_large_d3ce3e87-31f1-4ea4-8b31-84ef6725c819.jpg?v=1787417683",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "enhanced",
        "pqq",
        "with",
        "ubiquinol",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 66,
        "formulation": 72,
        "manufacturing": 66,
        "safety": 72,
        "transparency": 66,
        "sustainability": 55
      },
      "price": 27.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790702072005",
      "vsf_explanation": "PQQ + Ubiquinol is a rational mitochondrial-support pairing - PQQ has early evidence for mitochondrial biogenesis markers (Nakano 2012) and ubiquinol delivers 2-4x better CoQ10 bioavailability than ubiquinone in older adults (Failla 2014). Formulation quality depends on whether the ubiquinol is Kaneka-sourced and the PQQ is BioPQQ; those brand identities are the reference materials for the ingredient class. Safety is good, though CoQ10 can blunt warfarin efficacy. Would move to Verified 70+ with explicit Kaneka Ubiquinol + BioPQQ identities plus per-lot testing published.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "n-zimes-featuring-cerecalase",
      "title": "N-Zimes - Featuring CereCalase",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/20634eb8-c186-49d9-b368-a4d639e7edb0_large_09a84fe9-8cda-446b-abe7-cb2c6bccf3eb.jpg?v=1787417684",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zimes",
        "featuring",
        "cerecalase",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 15.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790702137541",
      "vsf_explanation": "CereCalase (National Enzyme branded hemicellulase blend) targets grain fiber and phytate digestion. Naming the branded blend is a formulation positive. Digestive enzyme evidence outside of clinical pancreatic insufficiency is limited. Would move to Verified with FCC enzyme unit disclosure and clear indication framing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fisetin-novusetin",
      "title": "Fisetin Novusetin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6e86cd2f-4618-457f-959a-bde4786d262e_large_41f4fb53-915c-4f99-a337-0027b199363d.jpg?v=1787417684",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fisetin",
        "novusetin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 72,
        "manufacturing": 74,
        "safety": 68,
        "transparency": 74,
        "sustainability": 55
      },
      "price": 22.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790702104773",
      "vsf_explanation": "Fisetin sourced from Cyvex Nutrition's Novusetin — a branded 98%+ fisetin extract, which is a genuine quality signal and moves this above generic strawberry-extract fisetin SKUs. Fisetin is one of the more promising senolytic candidates (Yousefzadeh 2018 preclinical showed senescent-cell clearance), with a Mayo Clinic phase 2 trial ongoing but no positive published human outcome data yet. Named branded sourcing at label is real transparency. Held below Elite because human efficacy evidence is still emerging (preclinical-heavy), and senolytic 'hit-and-run' dosing protocols (2 days/month) are not standardized on label. A pragmatic pick within the senolytic space.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "certified-rbgh-free-grass-fed-whey-protein-powder-chocolate",
      "title": "Certified rBGH-Free Grass-Fed Whey Protein Powder- Chocolate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/192a533c-bed9-40e3-ab6d-07b104505e3f_large_7d7c2b0e-7ad1-42e1-83e7-5156b4932186.jpg?v=1787417685",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "certified",
        "rbgh",
        "free",
        "grass",
        "fed",
        "whey",
        "protein",
        "powder",
        "chocolate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 68,
        "manufacturing": 65,
        "safety": 72,
        "transparency": 70,
        "sustainability": 62
      },
      "price": 26.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790702661829",
      "vsf_explanation": "Chocolate version of the grass-fed rBGH-free whey. Whey at 20-40g post-workout is well-established for anabolic response (Morton 2018 meta). Grass-fed sourcing meaningfully improves fatty-acid profile and rBGH-free is a real sourcing claim. Chocolate flavoring introduces the sugar/sweetener disclosure question — cocoa also adds cadmium exposure risk, so heavy-metal testing matters more here. Would move to Verified 70+ with confirmed isolate base, published heavy-metal COA, and NSF Sport certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-complete-e-contain-tocopherols-tocotrienols-envol",
      "title": "Full Spectrum Complete E Contain Tocopherols, Tocotrienols & ENVol",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/bc0ba3c0-4d57-4e0e-af14-4103331bf7cd_large_a8f220e9-b9ff-47b7-b86e-7cbbd4b8ac49.jpg?v=1787417685",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "complete",
        "contain",
        "tocopherols",
        "tocotrienols",
        "envol",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 72,
        "manufacturing": 65,
        "safety": 68,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 58.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790702694597",
      "vsf_explanation": "Mixed tocopherols + tocotrienols including ENVol tocotrienol — preferred vitamin E form over isolated alpha-tocopherol per Miller 2005 evidence. Naming both classes is a real transparency positive. Would move to Elite with USP verification and per-form mg disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "folate-5-methyltetrahydrofolic-acid-high-potency-bioactive-form",
      "title": "Folate 5-Methyltetrahydrofolic Acid - High Potency, Bioactive Form",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e15a0a4f-8af6-45eb-a130-f84c6128a15a_large_242114dc-9a37-4b18-9e08-d664c1c481bc.jpg?v=1787417685",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "folate",
        "methyltetrahydrofolic",
        "acid",
        "high",
        "potency",
        "bioactive",
        "form",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 76,
        "formulation": 78,
        "manufacturing": 65,
        "safety": 70,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 10.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790702727365",
      "vsf_explanation": "5-MTHF at high potency (typically 800-1000 mcg DFE) is the bioactive folate form for MTHFR polymorphism carriers and methylation-cycle support (Obeid & Herrmann 2012). Held below Elite by absence of a named-source ingredient (Quatrefolic/Metafolin) and no third-party certification. Would move to Verified 76+ with disclosed source ingredient and COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "glucohelp-banaba-extract-standardized",
      "title": "GlucoHelp Banaba Extract - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/92774a24-1cf4-453e-84e1-c3d01095b983_large_6cce9371-23ea-4e3a-91f9-91e3e9ee7d0c.jpg?v=1787417685",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glucohelp",
        "banaba",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 13.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790702760133",
      "vsf_explanation": "GlucoHelp (Soft Gel Technologies branded banaba extract standardized to 18% corosolic acid) has small trials (Judy 2003) for glucose control at 32-48 mg corosolic acid/day. Naming the standardized extract is a formulation positive. Evidence base is small and largely industry-funded. Would move to Verified with dose match to studied corosolic acid mg and independent replication.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pasture-fed-goat-whey-unflavored",
      "title": "Pasture Fed Goat Whey - Unflavored",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/01a019f5-2837-7336-a36f-5eb46d1a0f8d.jpg?v=1787417685",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pasture",
        "fed",
        "goat",
        "whey",
        "unflavored",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 66,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 68,
        "sustainability": 68
      },
      "price": 28.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790702825669",
      "vsf_explanation": "Goat whey is a niche protein — smaller fat globules and different casein profile (A2 rather than A1) which some tolerate better than cow whey. Pasture-fed sourcing is a genuine sustainability and fatty-acid-profile plus. Direct human evidence for goat whey vs cow whey is limited (no head-to-head anabolic RCT); the underlying whey anabolic-response evidence (Morton 2018) applies but not to this specific source. Held at Standard because the niche source lacks the RCT depth of standard whey, and Swanson does not publish per-lot testing. Would move up with published amino profile per serving and third-party purity data.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fiberaid-larch-tree-arabinogalactan-ag",
      "title": "FiberAid Larch Tree Arabinogalactan (AG)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d15e4dc8-d0f1-4953-b6df-450f3d549b20_large_53f7fb59-401c-4f69-86f8-6c3098236f67.jpg?v=1787417685",
      "score": 67,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fiberaid",
        "larch",
        "tree",
        "arabinogalactan",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 68,
        "manufacturing": 65,
        "safety": 68,
        "transparency": 68,
        "sustainability": 60
      },
      "price": 27.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790702792901",
      "vsf_explanation": "Larch arabinogalactan (FiberAid is Lonza's branded ingredient). Modest prebiotic + immunomodulatory evidence (Kim 2012, Riede 2013 for winter cold-day reduction). Named branded ingredient improves manufacturing trust vs a generic. Would move to Verified 70+ with per-scoop dose confirmation matching the ~1.5-4.5g/day range used in the immune trials.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "herbal-extract-memory-complex",
      "title": "Herbal Extract Memory Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cf918e75-4cb9-401a-a87e-c4de14f96672_large_76d31871-668a-4dde-b2b9-2ada6e39eab5.jpg?v=1787417688",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "herbal",
        "extract",
        "memory",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 56,
        "sustainability": 55
      },
      "price": 15.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790702858437",
      "vsf_explanation": "Multi-herb 'memory complex' likely combining ginkgo, bacopa, and possibly gotu kola or others. Individual ingredients have RCT support at specific doses (Ginkgo 120-240mg standardized; Bacopa 300mg at 45-55% bacosides per Stough 2001) but combo formulas typically dilute each to fit one capsule. Held here rather than autofailed because Swanson often does list per-active mg. Would move to Verified 70+ with per-active dose disclosure at RCT-relevant amounts and standardization percentages named for each herb.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "folate-5-methyltetrahydrofolic-acid-higher-potency-bioactive-form",
      "title": "Folate 5-Methyltetrahydrofolic Acid-Higher Potency, Bioactive Form",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6351bc71-0a96-4e3a-ab9e-f100118d44d9_large_1bd42a39-fbe6-4c38-b67b-9798f6e4a86a.jpg?v=1787417687",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "folate",
        "methyltetrahydrofolic",
        "acid",
        "higher",
        "potency",
        "bioactive",
        "form",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 76,
        "formulation": 78,
        "manufacturing": 65,
        "safety": 70,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 10.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790702891205",
      "vsf_explanation": "5-MTHF at higher potency (typically 800-1000 mcg DFE) is the bioactive folate form appropriate for MTHFR carriers and preconception/pregnancy support (Obeid & Herrmann 2012). Correct form and correct dose range. Held below Elite by lack of named-source disclosure (Quatrefolic vs Metafolin distinction matters for stability) and no third-party COA. Would move to Verified 76+ with named source and independent testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-complete-e-contain-tocopherols-tocotrienols-envol-1",
      "title": "Full Spectrum Complete E Contain Tocopherols, Tocotrienols & ENVol",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/25365f35-5489-4a0f-86e0-aa685fb83f72_large_ea8c107b-0bf2-4e87-9329-4788eaeef26a.jpg?v=1787417687",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "complete",
        "contain",
        "tocopherols",
        "tocotrienols",
        "envol",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 72,
        "manufacturing": 65,
        "safety": 68,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 38.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790702923973",
      "vsf_explanation": "Mixed tocopherols + tocotrienols is the preferred vitamin E form over isolated alpha-tocopherol (which suppresses gamma-tocopherol and shows neutral/worse outcomes at high doses — Miller 2005). ENVol is a proprietary tocotrienol component. Naming both tocopherol classes and the tocotrienol source is a real formulation and transparency positive. Would move to Elite with USP verification and per-form mg disclosure (delta-tocotrienol specifically).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "flush-free-niacin",
      "title": "Flush Free Niacin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7017d1c9-c7ee-47e0-8b37-bdc851b8d18a_large_7c8310ae-5323-473b-b104-14388f47a3d3.jpg?v=1787417688",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "flush",
        "free",
        "niacin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 29.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790702956741",
      "vsf_explanation": "Inositol hexanicotinate ('flush free niacin') lacks the lipid effects of true nicotinic acid (Meyers 2003 Am J Med RCT). If purchased for cholesterol modification, this SKU will not deliver. Held at low-Standard by weak clinical evidence for the flush-free molecule, though it is safe and provides B3 nutrient value. Would only move up if honestly repositioned as a general B3 supplement rather than a niacin substitute.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "folic-acid-b12",
      "title": "Folic Acid & B12",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/530f95d1-7f19-46d9-995a-979d073db2c9_large_80466302-a940-4aa0-9f80-e24af1cbe1ce.jpg?v=1787417688",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "folic",
        "acid",
        "b12",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 4.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790703481029",
      "vsf_explanation": "Synthetic folic acid + cyanocobalamin is a functional but outdated combination — folic acid must be enzymatically reduced to 5-MTHF, and this step is impaired in MTHFR C677T/A1298C carriers (Obeid & Herrmann 2012); unmetabolized folic acid accumulation has been raised as a concern (Smith 2008 AJCN). Cyanocobalamin requires methylation to methyl-B12. Held below Verified by non-bioactive forms of both nutrients. Would move to Verified 70+ if reformulated as 5-MTHF + methylcobalamin.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "egcg-green-tea-extract-standardized",
      "title": "EGCG Green Tea Extract - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8a593a60-8740-4082-af93-db7e9d9c11d9_large_71dba3f5-b082-4f7d-92e3-cad977b26d6e.jpg?v=1787417689",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "egcg",
        "green",
        "tea",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 60,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 18.2,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790703546565",
      "vsf_explanation": "EGCG (epigallocatechin gallate) at high doses has hepatotoxicity concerns (Hu 2018) — EFSA and USP recommend keeping to under 800 mg EGCG/day and avoiding on empty stomach. Green tea catechin RCTs for metabolic and cardiovascular endpoints (Hursel 2011 meta) show modest effects. Standardization is a formulation positive. Would move to Verified 70+ with per-serving EGCG mg, empty-stomach caution, and USP Green Tea Extract verification for hepatotoxin risk.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nadh-fast-acting-peppermint-lozenges",
      "title": "NADH - Fast-Acting Peppermint Lozenges",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0be134d7-752e-4fc0-a744-3a2bf4b7e965_large_142bf740-3c7f-4eb2-a32c-524308d52bd2.jpg?v=1787417689",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nadh",
        "fast",
        "acting",
        "peppermint",
        "lozenges",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 29.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790703579333",
      "vsf_explanation": "Standard-strength NADH sublingual lozenge — sublingual bypasses the oral bioavailability problem that limits direct oral NAD+. Small human evidence base (Birkmayer 1993 for fatigue at 10mg; Forsyth 1999 for cognitive effect in Alzheimer's pilot). Held at Standard because NADH RCT base is much thinner than NR-precursor evidence (Martens 2018 for Niagen), and Swanson does not name Enada branded sourcing. Would move up with Enada NADH sourcing named at label.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "folate-5-methyltetrahydrofolic-acid-bioactive-form",
      "title": "Folate 5-Methyltetrahydrofolic Acid - Bioactive Form",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7e382cf1-debc-43f1-90e4-4afff04c7b1b_large_8367fb06-8be1-4b88-90b6-4e6f698c4625.jpg?v=1787417690",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "folate",
        "methyltetrahydrofolic",
        "acid",
        "bioactive",
        "form",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 76,
        "formulation": 78,
        "manufacturing": 65,
        "safety": 70,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 10.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790703612101",
      "vsf_explanation": "5-MTHF (L-methylfolate) is the bioactive folate that bypasses MTHFR polymorphisms — approximately 40-60% of populations carry variants that reduce folic-acid conversion efficiency (Obeid & Herrmann 2012). This is the correct form for methylation, homocysteine reduction, and preconception support. Held below Elite by absence of an explicit named-source (Quatrefolic or Metafolin) in the title and no third-party certification. Would move to Verified 76+ with named-source disclosure and independent COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "energy-boost-designed-release",
      "title": "Energy Boost - Designed Release",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f3adff29-54f2-4cd7-94b2-c6f60de8c1c8_large_958be817-460b-4c0a-81ac-09e32b3e3d5e.jpg?v=1787417689",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "energy",
        "boost",
        "designed",
        "release",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 52,
        "sustainability": 50
      },
      "price": 10.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790703644869",
      "vsf_explanation": "Time-release energy formula with 'designed release' delivery — the phrase describes coating technology but doesn't disclose actives. Sustained-release caffeine or B-vitamin delivery is a legitimate formulation approach for smooth energy, but per-active dose disclosure at label is essential. Held at Standard on transparency grounds. Would move to Standard 65+ with disclosed actives and dosing, and Verified with branded sourcing named.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "glutathione-precursor-complex",
      "title": "Glutathione Precursor Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3b09bbdc-e6ef-4280-9aa9-8b7d7ce65ae6_large_fcdb51ce-3d8b-4c02-b4a5-ddfb4c40587f.jpg?v=1787417691",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glutathione",
        "precursor",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 17.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790704267461",
      "vsf_explanation": "Precursor-complex framing suggests a NAC + glycine + selenomethionine or ALA stack, which is actually more pharmacokinetically sound than oral glutathione for raising endogenous GSH synthesis (Sekhar 2011 for glycine+cysteine in aging). The concept is strong; the score is held by the 'complex' label typically hiding per-ingredient milligrams behind a proprietary blend. Would move to Verified 70+ with per-active mg disclosure allowing users to dose against the GlyNAC trial protocol (Kumar 2023).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "curcumin-c3-complex-with-boswellia-and-quercetin",
      "title": "Curcumin C3 Complex with Boswellia and Quercetin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0250c575-7a25-4435-9a70-d006c5dd87fb_large_575aad60-d1ea-4cc9-b47f-dd7def3c26cc.jpg?v=1787417691",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "curcumin",
        "complex",
        "with",
        "boswellia",
        "and",
        "quercetin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 76,
        "formulation": 74,
        "manufacturing": 72,
        "safety": 72,
        "transparency": 70,
        "sustainability": 60
      },
      "price": 29.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790704201925",
      "vsf_explanation": "Curcumin C3 Complex is Sabinsa's US patented 95% total curcuminoids extract with the largest single body of clinical data of any turmeric ingredient — osteoarthritis (Kuptniratsaikul 2014), depression (Sanmukhani 2014), and dozens more trials. Pairing with boswellia (AKBA-standardized ideally) and quercetin gives complementary COX/5-LOX/NF-kB coverage. Held at low Verified because C3 alone still has poor bioavailability without piperine or a phytosome — and the title doesn't mention BioPerine. Would move to Elite with BioPerine or Meriva addition and per-lot COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-effect-hair-thickener-featuring-keranat",
      "title": "Full Effect Hair Thickener - Featuring Keranat",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/da5f3cce-04da-454f-acdd-30e1e4b824ca_large_91ed0a17-80ac-42c4-ab04-61a6a312f902.jpg?v=1787417691",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "effect",
        "hair",
        "thickener",
        "featuring",
        "keranat",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 19.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790704234693",
      "vsf_explanation": "Features Keranat, a Robertet millet-seed extract with a small brand-sponsored trial (Marchegiani 2018) suggesting reduced hair loss and improved anagen ratio at 200 mg/day. Named-source ingredient is a real plus for a category dominated by biotin megadoses (biotin evidence weak in non-deficient users per Patel 2017, and biotin can distort thyroid/troponin lab tests). Held below Verified by evidence being brand-sponsored and single-site, plus limited independent replication. Would move to Verified 70+ with independent RCT confirmation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "glucosamine-chondroitin-featuring-truflex",
      "title": "Glucosamine & Chondroitin - Featuring TruFlex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c5939ab1-02dc-4775-b9d7-e0fc416b47d5_large_b9cd32f6-f599-424c-ab14-4ab25a300bce.jpg?v=1787417691",
      "score": 67,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glucosamine",
        "chondroitin",
        "featuring",
        "truflex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 68,
        "manufacturing": 64,
        "safety": 70,
        "transparency": 66,
        "sustainability": 55
      },
      "price": 13.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790704300229",
      "vsf_explanation": "Standard glucosamine + chondroitin combo with TruFlex named-source chondroitin. GAIT (Clegg 2006) supports the combination for moderate-severe knee OA at 1500 + 1200 mg/day. Held below Verified by unclear glucosamine salt (sulfate has better trial support than HCl) and no third-party COA. Would move to Verified 70+ with sulfate-form spec.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sod-gliadin-complex",
      "title": "SOD Gliadin Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4b4735a7-16ee-44a2-aeff-46ac86b56d3d_large_2c900707-c0ec-4ac2-a8bf-4ba215845d50.jpg?v=1787417691",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sod",
        "gliadin",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 34.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790704332997",
      "vsf_explanation": "Wheat gliadin-coated superoxide dismutase (branded GliSODin from Isocell) is designed to survive gastric acid and deliver antioxidant enzyme systemically. Small RCTs (Cloarec 2007) suggest oxidative-stress markers improve. Contains gliadin (wheat allergen) which needs disclosure. Would move to Verified with GliSODin branded confirmation and celiac/wheat-allergen caution at label.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "d-limonene-orange-peel-extract",
      "title": "D-Limonene Orange Peel Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/70e55998-9e20-4245-9f79-cbf24be51d9a_large_c18f3c1d-5db2-4923-919d-3ac6aaaee50f.jpg?v=1787417691",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "limonene",
        "orange",
        "peel",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790704365765",
      "vsf_explanation": "D-limonene has small trials for GERD symptom relief (Sun 2007 open-label) at 1000 mg/day. Also used for gallstone dissolution (historically). Evidence base is small. Swanson doesn't disclose mg on title. Would need larger RCTs and dose match to studied 1000 mg to move up.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dhea-higher-potency",
      "title": "DHEA - Higher Potency",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9d275434-b389-4cf2-9eb7-47acff5fa2ee_large_6ab83c18-d378-4ab8-b840-e39d3e458af2.jpg?v=1787417691",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dhea",
        "higher",
        "potency",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 50,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 17.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790704431301",
      "vsf_explanation": "Higher-dose DHEA (typically 50-100mg) — a precursor to testosterone and estradiol. DHEA has moderate evidence in adrenal-insufficient and postmenopausal populations (Panjari 2007) but weak evidence in healthy adults. Higher doses (>25mg in women, >50mg in men) amplify hormone-conversion side effects (acne, hair changes, cycle irregularity in women, aromatization to estradiol in men) and should be lab-monitored. Standard Swanson manufacturing without third-party testing. Would move to Verified 70+ with clear lab-monitoring guidance, hormone-sensitive-cancer contraindication, and dose-appropriate warnings by sex.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dual-release-melatonin",
      "title": "Dual-Release Melatonin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/aae5fbdc-ee82-4e11-8655-4a71b25ad1bf_large_738591d9-ffdb-4389-ad06-cc4c93570ec6.jpg?v=1787417691",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dual",
        "release",
        "melatonin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 64,
        "formulation": 66,
        "manufacturing": 62,
        "safety": 55,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 6.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790704398533",
      "vsf_explanation": "Dual-release melatonin (immediate + extended-release) targets both sleep-onset and sleep-maintenance - a rational formulation approach that matches prolonged-release prescription melatonin (Circadin) evidence in over-55 insomnia (Wade 2011). Total dose is often 3-5mg, still above the physiological 0.3-1mg range but the extended-release fraction may partially compensate by extending exposure. Would move to Verified 70+ with lower total dose and explicit population targeting (age-related insomnia).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gabaplex-with-l-tyrosine-l-theanine",
      "title": "GABAplex with L-Tyrosine & L-Theanine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5d036755-d7da-4f66-a5c0-183d7ba93d97_large_be3cc1ac-0ea8-4cea-a572-0a87197ed587.jpg?v=1787417692",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "cognitive",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gabaplex",
        "with",
        "tyrosine",
        "theanine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 16.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790704464069",
      "vsf_explanation": "Combination of GABA + L-tyrosine + L-theanine targets stress and cognitive focus via multiple pathways. Individual ingredients have modest evidence at studied doses (100-200mg L-theanine, 500-2000mg tyrosine), but combos frequently under-dose one or more actives to fit a single capsule. If it discloses per-active mg, the formula is credible; if it is a proprietary blend with only a total, this drops to Rejected via proprietary_blend_hides_dose. Would move to Verified 70+ with disclosed per-active doses hitting each ingredient's RCT window.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "rapid-immune-defense-featuring-epicor",
      "title": "Rapid Immune Defense Featuring EpiCor",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fd4fbbf4-1515-4424-8911-0bdc50fd4b9c_large_f2d60dfc-839b-4457-b5fd-7d637cca315b.jpg?v=1787417692",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "rapid",
        "immune",
        "defense",
        "featuring",
        "epicor",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 72,
        "manufacturing": 70,
        "safety": 72,
        "transparency": 68,
        "sustainability": 60
      },
      "price": 17.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790704496837",
      "vsf_explanation": "EpiCor is Cargill's dried fermentation product from Saccharomyces cerevisiae, with two placebo-controlled cold/flu incidence-and-duration trials (Moyad 2008, 2010) at 500 mg/day and a mucosal-immunity trial (Jensen 2011). Legitimate branded ingredient with real if modest human data. Held to top of Standard because the trial base is small, sponsor-linked, and effect sizes are moderate. Would move to Verified 70+ with independent replication and disclosure that Swanson delivers the studied 500 mg dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dhea-and-pregnenolone",
      "title": "DHEA and Pregnenolone",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d6740012-4d88-4085-8b5e-263c456e6663_large_ec1951a8-76e4-4c98-adfb-9a49039ec90a.jpg?v=1787417692",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dhea",
        "and",
        "pregnenolone",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 50,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 17.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790704529605",
      "vsf_explanation": "Combination steroid-precursor product stacking DHEA with pregnenolone. DHEA has some RCT signal for adrenal insufficiency and low-DHEA populations (Panjari 2007 for postmenopausal women), while pregnenolone RCTs are mostly null. Stacking two hormone precursors compounds the safety complexity — both can shift the entire steroid hormone axis and should be lab-monitored, especially in men (aromatization to estradiol) and hormone-sensitive-cancer patients. Standard Swanson manufacturing. Would move to Verified 70+ with mandatory lab-monitoring language, contraindications, and per-active dosing disclosure — but the combination itself remains a formulation choice we can't fully endorse for self-administration.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "extra-strength-cbd-full-spectrum-mint",
      "title": "Extra Strength CBD Full Spectrum - Mint",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4e52af2a-44c6-4d75-9b8b-c8915f9891cb_large_34bdd722-fa69-4950-8feb-f3e489607724.jpg?v=1787417694",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "extra",
        "strength",
        "cbd",
        "full",
        "spectrum",
        "mint",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 58,
        "sustainability": 52
      },
      "price": 26.67,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790705217733",
      "vsf_explanation": "Full-spectrum CBD oil has emerging RCT evidence for anxiety (Shannon 2019 case series) and sleep but doses in trials range 25-600 mg/day, so alignment depends on the mg-per-mL disclosed. Full-spectrum retains minor cannabinoids and terpenes which may support the 'entourage effect' hypothesis. Swanson doesn't publish per-batch COAs by default, and the CBD industry needs COA + heavy-metal + pesticide testing to be trustworthy. Would move to Verified 70+ with public per-batch COA and named hemp source.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "diosmin-hesperidin-featuring-diosvein",
      "title": "Diosmin & Hesperidin - Featuring DiosVein",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e53b61bd-c58f-4190-aa03-9b0eac608af1_large_006df85d-b5bf-4b16-9573-207299aeac80.jpg?v=1787417694",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "diosmin",
        "hesperidin",
        "featuring",
        "diosvein",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 14.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790705250501",
      "vsf_explanation": "DiosVein (branded diosmin 900 mg + hesperidin 100 mg) is the standard chronic venous insufficiency micronized purified flavonoid fraction (MPFF) equivalent, RCT-supported (Meyer 1994; Perrin 2011) for varicose vein symptoms and hemorrhoid healing. Naming the branded standardized combo is a formulation positive. Would move to Verified 70+ with dose match to 1000 mg total per serving and USP cert.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnesium-oil-3-pack",
      "title": "Magnesium Oil - 3 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/79d961e7-3b91-42f7-bb86-61b78faafb67_large_7ae31eab-a935-4994-8c1f-432ba761221c.jpg?v=1787417694",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "oil",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 28.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790705283269",
      "vsf_explanation": "3-pack of topical magnesium chloride spray. Same formulation as single-unit — transdermal absorption is limited (Grober 2017), best used for local muscle-comfort application rather than systemic magnesium repletion. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "flush-free-niacin-1",
      "title": "Flush Free Niacin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0b381fda-e5c8-4141-9499-800012c7e330_large_2aff6489-003f-4c85-a768-0f8ae29e24e1.jpg?v=1787417695",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "flush",
        "free",
        "niacin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 15.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790705316037",
      "vsf_explanation": "'Flush free niacin' is inositol hexanicotinate (IHN), which lacks the lipid-modifying effects seen with immediate-release or extended-release nicotinic acid (Meyers 2003 Am J Med — negative RCT vs IR niacin). Users seeking cholesterol/lipid or vasodilation effects from niacin will not get them from IHN. Held at low-Standard by weak clinical evidence for the flush-free form despite legitimate B3 nutrient content. Would only move up if honestly repositioned as a general B3 nutrient supplement rather than a lipid-modifying agent.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gluten-rid-with-tolerase-g",
      "title": "Gluten Rid with Tolerase G",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f9a9e160-7ce4-4f67-9a1f-38f6006b7d24_large_540f15fa-3e84-49e3-bd1a-2b89dbd9d75e.jpg?v=1787417695",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gluten",
        "rid",
        "with",
        "tolerase",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 29.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790705348805",
      "vsf_explanation": "Tolerase G (branded AN-PEP, aspergillus niger prolyl endopeptidase) has RCT support for degrading small gluten challenges (Salden 2015). Not sufficient to allow celiac patients to eat gluten — the labeling risk here is significant and needs explicit disclosure. Naming Tolerase G is a formulation positive. Would move to Verified 70+ with celiac non-treatment disclosure at label.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnesium-oil-1",
      "title": "Magnesium Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/077a7965-7a4d-4e28-a573-091037e4989f_large_e93ecb29-6e3f-4b87-bcdb-238a531beece.jpg?v=1787417695",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "oil",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 14.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790705381573",
      "vsf_explanation": "Topical magnesium chloride spray. Transdermal magnesium absorption is minimal per rigorous absorption studies (Grober 2017), though users report muscle-soreness relief that may be local vasodilatory rather than systemic. Standard tier — appropriate for local/comfort use, not clinical magnesium repletion.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "theracurmin-high-absorption",
      "title": "Theracurmin - High Absorption",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/34ae0ee6-431f-44f6-b33f-b0d73b3141eb_large_56f781b0-b2c0-440c-8364-180777a03498.jpg?v=1787417743",
      "score": 73,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "theracurmin",
        "high",
        "absorption",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 75,
        "manufacturing": 68,
        "safety": 70,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 12.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790716162245",
      "vsf_explanation": "Theracurmin (Theravalues colloidal dispersion) has published bioavailability ~27x standard curcumin (Sasaki 2011) and RCTs for knee OA (Nakagawa 2014), cognitive aging (Small 2018), and endothelial function. Naming the branded high-bioavailability curcumin at label is a strong formulation choice. Would move to Elite with USP/NSF cert and published dose match to Small 2018 protocol (90 mg BID).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "glucosamine-complex-chondroitin-sulfate-featuring-truflex",
      "title": "Glucosamine Complex & Chondroitin Sulfate - Featuring TruFlex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2f9bc5d1-2f1e-443d-855a-1a4970ca6c4f_large_c612ad78-4668-4b86-9cbb-af6db84756f1.jpg?v=1787417742",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glucosamine",
        "complex",
        "chondroitin",
        "sulfate",
        "featuring",
        "truflex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 70,
        "manufacturing": 64,
        "safety": 70,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 25.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790716129477",
      "vsf_explanation": "Glucosamine 'complex' with explicit chondroitin sulfate labeling (the studied form) plus TruFlex branded chondroitin — better label transparency than most Swanson joint SKUs. Sulfate-form chondroitin at 1200 mg/day was arm of GAIT (Clegg 2006) that helped moderate-to-severe OA subgroup. Held below Verified by 'complex' framing on glucosamine side (salt not specified in title) and no third-party purity COA. Would move to Verified 70+ with glucosamine sulfate spec and COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pregnenolone-higher-strength",
      "title": "Pregnenolone - Higher Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6a606b1d-0dfd-4d80-aba1-430b44a8c0ee_large_b0236e9f-e228-4492-a1d5-8c21321a71f3.jpg?v=1787417743",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pregnenolone",
        "higher",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 7.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790716195013",
      "vsf_explanation": "Elevated-dose pregnenolone (typically 50mg) — an upstream neurosteroid precursor. Modern RCTs for pregnenolone's cognitive, mood, and anti-aging claims have been largely null (Osuji 2010; Marx 2014 modest bipolar signal). Higher doses amplify downstream steroid-conversion effects and warrant lab monitoring plus contraindications for hormone-sensitive cancers — safety guidance often lacking on the label. Standard Swanson manufacturing without visible third-party testing. Would move to Verified 70+ with explicit lab-monitoring guidance, contraindication warnings, and honest evidence framing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "go-less-bladder-control-formula-maximum-strength",
      "title": "Go-Less Bladder Control Formula - Maximum Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/57379800-49cb-4daf-8d52-e3e1c77ff81c_large_d23ee83e-08e2-45de-81a4-1de117e20c59.jpg?v=1787417743",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "less",
        "bladder",
        "control",
        "formula",
        "maximum",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 30.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790716326085",
      "vsf_explanation": "Go-Less (Frutarom branded pumpkin seed + soy germ extract) has small RCT support for overactive bladder symptoms (Sogabe 2001 in women; Terado 2011). Naming the branded blend is a formulation positive. Soy germ content warrants estrogen-sensitive population caution. Would move to Verified 70+ with dose match, USP cert, and clear population cautions.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lutein",
      "title": "Lutein",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/843e86e4-3e5f-4da0-8260-b9e42dcf2d93_large_d1d12de2-5136-4188-92d5-59bf45135e57.jpg?v=1787417743",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lutein",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 16.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790716358853",
      "vsf_explanation": "Standard-strength lutein — AREDS2 uses 10 mg for macular protection. Should be paired with zeaxanthin. Would move to Verified 70+ with 10 mg dose match, paired zeaxanthin, and OmniActive/Kemin source disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "himalayan-crystal-salt-fine-ground",
      "title": "Himalayan Crystal Salt - Fine Ground",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/749e866b-1581-4703-bc37-9aac0f735987_large_7f5e6ce2-a7ed-462b-ae68-462ae3a9c259.jpg?v=1787417743",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "himalayan",
        "crystal",
        "salt",
        "fine",
        "ground",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 28.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790716227781",
      "vsf_explanation": "Culinary salt is a food product, not a supplement. Himalayan salt's 'trace mineral' claims are exaggerated versus regular iodized salt while missing dietary iodine. Out of scope.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "reduced-l-glutathione-double-strength-featuringsetria",
      "title": "Reduced L-Glutathione Double Strength - FeaturingSetria",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8560aeb0-b3bd-424d-9076-e90296f7aece_large_2bbcad56-b374-46d6-9184-3256259f4e7b.jpg?v=1787417743",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "reduced",
        "glutathione",
        "double",
        "strength",
        "featuringsetria",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 75,
        "manufacturing": 74,
        "safety": 72,
        "transparency": 72,
        "sustainability": 58
      },
      "price": 22.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790716260549",
      "vsf_explanation": "Double-strength reduced L-glutathione as Setria — the specific fermentation-derived branded ingredient studied by Richie 2015, which is the strongest oral GSH replication trial available (500-1000 mg/day for 6 months raised RBC and whole-body glutathione stores). Double-strength puts a single serving at or near the studied dose range, which most Setria SKUs don't achieve. Held to low Verified rather than Elite because oral GSH still faces first-pass hydrolysis versus liposomal or IV delivery. Would move up with per-lot COA disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hyaluronic-acid-complex",
      "title": "Hyaluronic Acid Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3cfcbcc2-c828-45ab-9887-f773d6b3b5ec_large_6c91520d-aa5a-47b3-a491-01becd14630b.jpg?v=1787417743",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hyaluronic",
        "acid",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 25.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790716424389",
      "vsf_explanation": "Third HA complex SKU — modest oral HA joint and skin evidence (Nelson 2015, Oe 2017) at 80-200 mg/day. Generic Swanson HA, no molecular-weight or source disclosure, 'complex' framing implies adjunct fillers. Held below Verified by identical gaps: sourcing opacity and no per-active mg. Would move to Verified 70+ with named low-MW HA and dose transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "beta-sitosterol",
      "title": "Beta-Sitosterol",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fbe70910-4343-46d3-884a-cb245ea289b4_large_7102ff5c-2b98-43bc-83c5-7b1093c7e79a.jpg?v=1787417742",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beta",
        "sitosterol",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 11.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790716293317",
      "vsf_explanation": "Beta-sitosterol has RCT support for BPH urinary symptoms (Wilt 1999 Cochrane) at 60-130 mg/day. Also modest LDL-lowering as part of phytosterol mix. Swanson doesn't disclose mg on the title. Would move to Verified 70+ with dose match to BPH studied 60-130 mg range and USP cert.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "astaxanthin-1",
      "title": "Astaxanthin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/778d1d5c-3159-4c27-becc-3af1bdbe5e77_large_42af44b7-6eeb-4ec3-a396-6096dba65ea9.jpg?v=1787417743",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "astaxanthin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 16.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790716457157",
      "vsf_explanation": "Astaxanthin from Haematococcus microalgae — RCT support for skin photoprotection (Ito 2018) and eye fatigue at 4-12 mg/day. Source, cultivation method, and mg/serving not disclosed on title. Would move to Verified 70+ with Haematococcus source, AstaReal/BioAstin brand, and dose disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lithium-orotate",
      "title": "Lithium Orotate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7662a8b8-8a9e-4f5e-8826-e44983fe9bcc_large_b807601a-8696-4020-836e-54e60d09b98b.jpg?v=1787417743",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lithium",
        "orotate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790716391621",
      "vsf_explanation": "Low-dose lithium orotate (typically 5 mg elemental lithium) is popular in mood support with anecdotal claims but no meaningful modern human RCTs for the OTC dose. Prescription lithium carbonate for bipolar disorder is well-evidenced at 900-1800 mg. The 20-30x lower supplement dose is very unlikely to reproduce clinical effect but also unlikely to be therapeutic. Kidney/thyroid safety-monitoring warrants disclosure. Would need OTC-dose human trials to move above low-Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-carnitine-fumarate",
      "title": "L-Carnitine Fumarate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ede22b4b-90a9-4ea1-a7c0-cb645193c43d_large_5d49ac77-7886-45e6-aa5c-125da6397ee7.jpg?v=1787417743",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "carnitine",
        "fumarate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790716489925",
      "vsf_explanation": "L-carnitine fumarate is a decent bioavailable form — fumarate is a Krebs cycle intermediate so some marketers claim additional energy support, but head-to-head vs L-carnitine tartrate does not show meaningful difference (Karlic & Lohninger 2004). L-carnitine's evidence for fatty-acid transport is real but small-effect for exercise outcomes at 2-4g/day (Broad 2008 meta). Held at Standard because sourcing (Sigma-tau's Carnipure is the reference) is not disclosed, and cardiovascular safety signal (Koeth 2013, TMAO) needs disclosure. Would move up with Carnipure sourcing named at label and clear per-serving dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-d3-with-coconut-oil-highest-potency",
      "title": "Vitamin D3 with Coconut Oil - Highest Potency",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ad56f75b-3fca-4ec0-b85a-43880a36cba5_large_21693057-8d8f-425d-b7ee-021834bfeb02.jpg?v=1787417743",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "with",
        "coconut",
        "oil",
        "highest",
        "potency",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 72,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 16.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790716555461",
      "vsf_explanation": "Cholecalciferol in a fat-soluble MCT/coconut oil carrier improves absorption (Mulligan & Licata 2010). 'Highest Potency' typically indicates 10000 IU, appropriate for correction protocols but requiring 25(OH)D monitoring per Endocrine Society guidelines to avoid hypercalcemia. Martineau 2017 BMJ supports immune benefit. Held below Verified by high-dose without explicit K2 cofactor pairing, no third-party certification, and no monitoring guidance. Would move to Verified 70+ with paired K2 MK-7 and NSF certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-tryptophan-from-tryptopure",
      "title": "L-Tryptophan from TryptoPure",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/94c42de0-538c-48dc-8c47-e2300b1ce467_large_ae44e9a2-4799-464a-961b-310fa3f3d299.jpg?v=1787417743",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tryptophan",
        "from",
        "tryptopure",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 72,
        "manufacturing": 74,
        "safety": 60,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 29.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790716522693",
      "vsf_explanation": "TryptoPure is Ajinomoto's branded, pharmaceutical-grade L-tryptophan produced by fermentation with documented purity controls - a genuine manufacturing upgrade over generic tryptophan sources given the historical EMS contamination episode of the 1980s. L-tryptophan is a serotonin precursor with modest evidence for sleep-onset and mood, at 500-1500mg (Silber 2010 review). Same SSRI/serotonergic-drug interaction caution applies as for 5-HTP. Safety score reflects the interaction risk, not manufacturing. Would move to Verified 70+ with prominent serotonergic-drug interaction disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "himalayan-crystal-salt-fine-ground-1",
      "title": "Himalayan Crystal Salt - Fine Ground",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d90d9d08-f16f-4686-a799-39cd6e342d9d_large_369a2548-e2ae-4970-8e2f-3fe0942ca178.jpg?v=1787417743",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "himalayan",
        "crystal",
        "salt",
        "fine",
        "ground",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 8.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790716588229",
      "vsf_explanation": "Culinary salt is a food product, not a supplement, and Himalayan salt's 'trace mineral' claims are exaggerated versus regular iodized salt while missing dietary iodine. Out of scope for supplement scoring.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "joint-care-featuring-truflex",
      "title": "Joint Care - Featuring TruFlex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/516be231-c628-4c0d-bcbd-fee897e819e7_large_d0bb3ddc-a63f-41d3-aa70-23767fc7bf87.jpg?v=1787417744",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "joint",
        "care",
        "featuring",
        "truflex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 66,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 64,
        "sustainability": 55
      },
      "price": 22.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790717538501",
      "vsf_explanation": "Joint blend featuring the TruFlex branded chondroitin — named-source ingredient adds credibility. GAIT trial (Clegg 2006) supports the glucosamine + chondroitin combination for moderate-severe OA at 1500 + 1200 mg/day. Held below Verified by unclear glucosamine salt form and no per-active mg breakdown implied by the 'joint care' branding. Would move to Verified 70+ with sulfate-form disclosure and clinical-dose transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnesium-chloride-flakes",
      "title": "Magnesium Chloride Flakes",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2cec0acd-02dc-4f7e-8b2c-59fc48c59d84_large_c75b30ff-9e1c-4594-b0ce-95f89c5307f0.jpg?v=1787417745",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "chloride",
        "flakes",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 11.25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790717571269",
      "vsf_explanation": "Magnesium chloride bath flakes for transdermal use. Transdermal magnesium absorption is minimal and controversial — the best-designed studies (Grober 2017) show limited systemic uptake. Standard tier for topical/bath comfort use, not clinical repletion. Would not upgrade without controlled absorption RCT data.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-carnosine",
      "title": "L-Carnosine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d37e4e39-ad31-43d3-827c-bf5c2e1f3168_large_70d255fe-f5f9-475d-b89b-2cd02cdb6185.jpg?v=1787417745",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "carnosine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 22.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790717669573",
      "vsf_explanation": "L-carnosine (beta-alanyl-L-histidine dipeptide) has some evidence for glycation reduction and skeletal muscle carnosine loading (Baguet 2010). Absorbed as beta-alanine + histidine after intestinal carnosinase, so oral bioavailability of intact carnosine is limited. Beta-alanine 3-6 g/day is more direct for muscle carnosine loading. Would move to Verified 70+ with dose disclosure and honest framing of bioavailability limitations.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liver-tone",
      "title": "Liver Tone",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9e388125-c201-48c4-90a3-2c5e81ddb695_large_5ab6fb5c-a33c-4dbd-a172-9012ea72cea7.jpg?v=1787417745",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liver",
        "tone",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 12.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790717604037",
      "vsf_explanation": "'Liver tone' blends typically combine milk thistle (silymarin), dandelion, artichoke, NAC. Silymarin has modest evidence for NAFLD (Solhi 2014) and viral hepatitis at 420 mg/day. Blend format without per-active mg limits verification against studied protocols. 'Detox/cleanse' framing risks unverified medical claim territory. Would need per-active mg and explicit non-treatment framing to move up.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "luteolin-complex",
      "title": "Luteolin Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/aa61976b-0051-4dec-a961-e6cca83a3d09_large_f5713782-0538-4035-b164-fed2c27dc312.jpg?v=1787417745",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "luteolin",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 16.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790717636805",
      "vsf_explanation": "Luteolin is a citrus/artichoke flavonoid with in vitro anti-inflammatory and mast-cell stabilizing activity. Human RCT data is thin; used in mast-cell activation and neuroinflammation stacks. Complex format without per-active mg limits verification. Would need mg disclosure and human trial support to move up.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnesium-orotate",
      "title": "Magnesium Orotate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/04f967cf-9be6-44db-9808-b9eaa6f0762a_large_1e6c4b5a-913b-40c6-a5b7-2d77ba04026b.jpg?v=1787417746",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "orotate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 13.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790717702341",
      "vsf_explanation": "Magnesium orotate has one notable RCT in heart failure (Stepura 2009) showing survival benefit at 6000mg/day for one year — an interesting cardiovascular-specific signal, though replication is limited. Elemental magnesium content is very low (~7%). Standard tier — legitimate niche cardiovascular use, modest evidence base. Would move up with head-to-head data vs standard forms and specified elemental dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "real-food-vitamin-k2-maximum-strength",
      "title": "Real Food Vitamin K2 - Maximum Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6f6f1308-271f-4a6c-901f-21c87bf7f948_large_45c29786-c46a-4c7a-afe9-c4d19ffc914b.jpg?v=1787417747",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "real",
        "food",
        "vitamin",
        "maximum",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 60,
        "sustainability": 62
      },
      "price": 37.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790718619845",
      "vsf_explanation": "Food-fermented K2 (likely natto-derived MK-7) is a defensible whole-food source with supporting cardiovascular/bone data (Knapen 2015 Thromb Haemost). 'Maximum Strength' typically indicates 100-180 mcg. Held below Verified by unclear mcg from title, no named-source (MenaQ7), and 'real food' branding without disclosed matrix. Would move to Verified 70+ with specific MK-7 mcg and named fermentation source.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lutein-1",
      "title": "Lutein",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c199d373-3b4e-443a-88f0-7bcd08c8f3ad_large_31208277-54e7-47de-8c53-d539afca0b2a.jpg?v=1787417747",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lutein",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790718652613",
      "vsf_explanation": "Standard-strength lutein (typically 5-10 mg) — AREDS2 uses 10 mg for macular protection (Chew 2013). Should be paired with zeaxanthin 2 mg per AREDS2. Marigold source and brand not disclosed. Would move to Verified 70+ with 10 mg dose match, zeaxanthin pairing, and OmniActive/Kemin source.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnesium-l-threonate-featuring-magtein",
      "title": "Magnesium L-Threonate - Featuring Magtein",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7fd38908-0914-4b79-a821-3feb98391966_large_280ee9ba-40b3-4c14-b290-2c34b245452f.jpg?v=1787417748",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "threonate",
        "featuring",
        "magtein",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 74,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 43.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790718718149",
      "vsf_explanation": "Magtein is the patented magnesium L-threonate form (MIT-derived, Slutsky 2010) with the strongest published evidence for CNS penetration and cognitive support — RCT support at 1500-2000mg/day for working memory in older adults (Liu 2016). Named-source branded raw material with published cognitive data lifts this to Verified. Would move higher with disclosed 2000mg/day dose alignment and third-party assay. Elemental magnesium content is low (~7-8%) so it complements but does not replace general magnesium repletion.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-glutathione-with-coq10",
      "title": "L-Glutathione with CoQ10",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2de281ad-6373-4bb1-abec-4deab8bb7eac_large_fff0dfca-e8a2-4e15-b102-339247b28cfa.jpg?v=1787417749",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glutathione",
        "with",
        "coq10",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 54,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 11.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790719733957",
      "vsf_explanation": "Oral L-glutathione has notoriously poor bioavailability — GI hydrolysis largely degrades intact glutathione, and Allen 2011 and Richie 2015 showed only modest blood-marker changes at much higher doses than typical supplement servings. Pairing with CoQ10 makes sense for a mitochondrial-antioxidant angle but does nothing to fix glutathione absorption. Would move to Standard 65+ with liposomal or S-acetyl glutathione forms (better absorption per Sinha 2018), disclosed doses of both actives, and named CoQ10 source.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ip-6-inositol-hexaphosphate",
      "title": "IP-6 Inositol Hexaphosphate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c018b691-be82-44ba-b256-42620730a638_large_563fb5ff-59fe-4456-bdbc-b4a8021fbb0a.jpg?v=1787417749",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "inositol",
        "hexaphosphate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 30.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790719766725",
      "vsf_explanation": "IP-6 (phytic acid) is a mineral chelator with in vitro cancer-modulation data (Shamsuddin 1999) and small human trials for kidney stone prevention. Popular in integrative oncology stacks. Iron/zinc chelation is a real safety consideration — long-term use can worsen mineral status. Would need mineral-depletion caution and clear indication framing to move up.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "red-yeast-rice",
      "title": "Red Yeast Rice",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/47e3d50a-4b99-49fc-85dc-b254bbd1af01_large_1dff8c83-5cb3-4b65-85ac-efdb34371f79.jpg?v=1787417749",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "yeast",
        "rice",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 33,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 12.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790719799493",
      "vsf_explanation": "Red Yeast Rice contains monacolin K, structurally identical to prescription lovastatin, with meta-analytic support for LDL reduction (Gerards 2015). Safety is the primary drag: monacolin K content varies wildly between products and batches (Cohen 2017 found 46× variation), the FDA has warned that supplements at drug-equivalent monacolin doses are unapproved statins, and citrinin (a mycotoxin) contamination is a real concern for red yeast rice products without third-party testing. Would move to Standard 65+ with disclosed monacolin K per serving, citrinin-free COA, and a prominent do-not-combine-with-prescription-statin warning. This is unregulated, drug-equivalent exposure with no third-party assay on record — held at Rejected under safety_concern until monacolin K and citrinin testing plus a prominent statin-interaction warning are published.",
      "vsf_autofail_rule": "safety_concern"
    },
    {
      "handle": "magnesium-citrate-super-strength",
      "title": "Magnesium Citrate - Super Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/083ecec1-4421-48d1-b838-b2555c02e1a6_large_a0dc041f-9de0-4d17-9378-3c1a8f60a446.jpg?v=1787417751",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "citrate",
        "super",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 66,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 20.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790719865029",
      "vsf_explanation": "Magnesium citrate is a well-absorbed form (~30% bioavailability, Walker 2003) with dual utility for constipation and general magnesium repletion. 'Super strength' typically means 200mg+ elemental per serving. Mild laxative effect at higher doses. Standard tier — legit form, mainstream sourcing, no third-party certification. Would move to Verified with named-source (Albion), NSF certification, and glycinate blend.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "himalayan-crystal-salt-combo-pack-fine-ground",
      "title": "Himalayan Crystal Salt Combo Pack - Fine Ground",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/327dbd48-71e6-43b2-8c92-8dc2b7bbf5d1_large_f4696c40-ae82-4458-b205-8ca4f2d76f7e.jpg?v=1787417751",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "himalayan",
        "crystal",
        "salt",
        "combo",
        "pack",
        "fine",
        "ground",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 30.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790719897797",
      "vsf_explanation": "Culinary salt is a food product, not a supplement, and Himalayan salt's 'trace mineral' claims are exaggerated versus regular iodized salt while missing dietary iodine. Out of scope for supplement scoring.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "lyc-o-mato-lycopene",
      "title": "Lyc-O-Mato Lycopene",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/da385f5f-4491-4fb1-a1fc-619a02ec1b3e_large_cbfcfae0-d7d5-46a2-8333-12fd4dc0a603.jpg?v=1787417751",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lyc",
        "mato",
        "lycopene",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 18.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790719963333",
      "vsf_explanation": "Lyc-O-Mato branded lycopene from LycoRed with cardiovascular RCT support (Ried 2011 meta, modest systolic BP reduction at ≥15 mg/day). Naming the branded extract is a formulation positive. Would move to Verified 70+ with 15+ mg dose match and USP/NSF cert.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "benfotiamine-high-potency",
      "title": "Benfotiamine - High Potency",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ae3e1e94-a1d6-4c90-b397-ee317efa1d28_large_da6f538e-fdb5-4965-98b2-3555f64f292c.jpg?v=1787417751",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "benfotiamine",
        "high",
        "potency",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 64,
        "formulation": 66,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 64,
        "sustainability": 50
      },
      "price": 9.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790719930565",
      "vsf_explanation": "Benfotiamine at 'high potency' typically 150-250 mg. Peripheral neuropathy RCT (Stracke 2008) used 300 mg. Fat-soluble form is a genuine formulation advantage over thiamine HCl for tissue uptake. Would move to Verified 70+ with 300 mg dose match.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hawthorn-coq10-features-standardized-hawthorn",
      "title": "Hawthorn & CoQ10 - Features Standardized Hawthorn",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4a49d7d9-97de-4518-98d1-4969526920d5_large_641c6337-ec63-470d-bf4b-694b16746c04.jpg?v=1787417751",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hawthorn",
        "coq10",
        "features",
        "standardized",
        "hawthorn",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 64,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 64,
        "sustainability": 55
      },
      "price": 12.76,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790720028869",
      "vsf_explanation": "Hawthorn extract standardized to procyanidins/flavonoids has meta-analytic support as an adjunct in mild heart failure (Pittler 2008 Cochrane) at doses of 900-1800 mg/day of standardized extract, and CoQ10 has separate cardiac evidence (Mortensen 2014 Q-SYMBIO). Standardization callout is a real quality signal. Held below Verified because the SKU does not disclose CoQ10 mg or the specific procyanidin standardization percentage, and does not carry a prominent heart-failure-patients-should-consult-physician note. Would move to Verified 70+ with disclosed CoQ10 dose (100mg+), procyanidin standardization %, and clinician-consult guidance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "injuv-hyaluronic-acid",
      "title": "Injuv Hyaluronic Acid",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/89923b57-b144-449c-b3ce-3e994fce2782_large_ba2d3f09-c6da-4f8b-b07e-938016f7d0b5.jpg?v=1787417751",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "injuv",
        "hyaluronic",
        "acid",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 76,
        "manufacturing": 68,
        "safety": 74,
        "transparency": 74,
        "sustainability": 58
      },
      "price": 37.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790721011909",
      "vsf_explanation": "Named-source Injuv — Soft Gel Technologies' enzymatically hydrolyzed low-molecular-weight hyaluronic acid, one of the few HA sources with named human clinical work (Sato 2007 skin, Kalman 2008 joint at 70 mg/day). Named clinical ingredient at the studied form clears Verified. Held below Elite by mid-tier retailer manufacturing and no third-party COA. Would move to 80+ with USP/NSF certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "larch-tree-arabinogalactan",
      "title": "Larch Tree Arabinogalactan",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f8b3b99b-faf1-4af3-bec1-8397cfa238f7_large_b58ad36d-8d0e-4aa7-90bd-25f7dd9bb7fb.jpg?v=1787417751",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "larch",
        "tree",
        "arabinogalactan",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 18.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790720979141",
      "vsf_explanation": "Larch arabinogalactan is a prebiotic fiber with modest RCT support for immune modulation (Kim 2002) and cold reduction (Riede 2013 at 4.5 g/day). Ceiling limited by small-trial base and dose demands (grams, not mg) that most capsule formats can't hit. Would move to Verified with 4.5 g dose match and third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ostivone-high-potency",
      "title": "Ostivone - High Potency",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/266be78e-a0c8-4d4f-8c5e-b4797f35698e_large_943f153f-66ef-4ec2-8edd-1bc9a91a14e6.jpg?v=1787417751",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ostivone",
        "high",
        "potency",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 23.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790720946373",
      "vsf_explanation": "Ostivone (branded ipriflavone, a synthetic isoflavone) was studied for osteoporosis (Alexandersen 2001 large RCT) which failed to show BMD benefit and raised lymphocyte concerns. Post-2001 the evidence base weakened significantly. Would need contemporary safety re-evaluation before this could move above low-Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "type-i-hydrolyzed-marine-collagen-peptides",
      "title": "Type I Hydrolyzed Marine Collagen Peptides",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fa97c687-de94-473e-96aa-e793dfe3e985_large_16429ff6-a1e4-4b9c-8a8d-6af2b1a3c3b5.jpg?v=1787417751",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "type",
        "hydrolyzed",
        "marine",
        "collagen",
        "peptides",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 68,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790720913605",
      "vsf_explanation": "Hydrolyzed marine (fish-derived) Type I collagen — correct form for skin-elasticity outcomes (Proksch 2014 with Verisol, De Miranda 2021 meta-analysis) at typically 2.5-10 g/day. Marine collagen has slightly better bioavailability than bovine per Skov 2019. Generic Swanson without named clinical peptide (Naticol, Peptan F) and no sustainability certification. Held below Verified by unnamed source and no MSC or wild-caught claim. Would move to Verified 70+ with named marine peptide and sustainable-fishery certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "beet-juice",
      "title": "Beet Juice",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b4b3c782-d325-48c7-a959-d5a93f72355a_large_3c117475-5bbd-4a63-9826-9e84c9d8249d.jpg?v=1787417751",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beet",
        "juice",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 11.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790721044677",
      "vsf_explanation": "Beet juice/powder supplies dietary nitrate (typically 300-600 mg NO3-) with RCT support for blood pressure reduction (Kapil 2015) and exercise economy (Cermak 2012). Powdered/capsule beet products lose potency versus fresh juice; nitrate mg isn't disclosed on the title. Would move to Verified with nitrate mg per serving and dose match to studied 400-800 mg.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "certified-rbgh-free-grass-fed-whey-protein-powder-vanilla",
      "title": "Certified rBGH-Free Grass-Fed Whey Protein Powder- Vanilla",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5e2673f3-4849-4fac-8522-5c3d4a93426c_large_7644c03a-714a-4515-bfc5-02855eed3826.jpg?v=1787417752",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "certified",
        "rbgh",
        "free",
        "grass",
        "fed",
        "whey",
        "protein",
        "powder",
        "vanilla",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 68,
        "manufacturing": 65,
        "safety": 72,
        "transparency": 70,
        "sustainability": 62
      },
      "price": 28.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790721077445",
      "vsf_explanation": "Grass-fed rBGH-free whey — evidence for whey protein at ~20-40g/serving as post-exercise anabolic stimulus is well-established (Morton 2018 meta-analysis, n=1863). Grass-fed sourcing improves fatty-acid profile (higher CLA/omega-3), and the rBGH-free certification is a genuine sourcing signal. Held below Verified because concentrate-vs-isolate is not confirmed at title level, and Swanson does not publish per-lot heavy-metal testing or NSF Certified for Sport certification. Would move to Verified 70+ with confirmed isolate base, disclosed per-serving protein/leucine, and third-party purity testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "benfotiamine-maximum-strength",
      "title": "Benfotiamine - Maximum Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2aaa2059-d336-4084-9571-156319b968ba_large_4edc2272-9356-44fc-9061-9f4bc55292d2.jpg?v=1787417752",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "benfotiamine",
        "maximum",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 19.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790721110213",
      "vsf_explanation": "Benfotiamine (fat-soluble thiamine derivative) has RCT support for diabetic peripheral neuropathy (Stracke 2008 at 300-600 mg/day). 'Maximum Strength' likely 300 mg. Fat-soluble form crosses cell membranes more effectively than thiamine HCl. Would move to Verified 70+ with 300 mg dose match confirmation and USP cert.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hyaluronic-acid-complex-1",
      "title": "Hyaluronic Acid Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c622c809-396a-40a4-967e-6a4a9d1f2fdc_large_a9d6e91e-b1e4-4d8b-84cd-e2fcf21f938e.jpg?v=1787417754",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hyaluronic",
        "acid",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 12.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790721994949",
      "vsf_explanation": "Oral HA complex — Nelson 2015 and Kalman 2008 support modest joint-comfort benefit at 80-200 mg/day; Oe 2017 supports skin hydration. Generic Swanson HA without named low-MW source (Injuv, ExceptionHYAL) and no per-active mg in title. Held below Verified by opaque sourcing and 'complex' framing that usually adds inert fillers. Would move to Verified 70+ with named low-MW HA and dose disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "himalayan-crystal-salt-conditioner",
      "title": "Himalayan Crystal Salt Conditioner",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a031ca8d-6d09-41a9-868f-57fa637001d6_large_5593a7d2-70b4-4216-9c56-62f2e27c43fc.jpg?v=1787417754",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "himalayan",
        "crystal",
        "salt",
        "conditioner",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 4.7,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790722027717",
      "vsf_explanation": "Salt-containing hair conditioner is a cosmetic product with no biohacking supplement outcome to score against. Wellness-styled framing for a rinse-off cosmetic. Category ceiling limits this below Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lutein-higher-strength",
      "title": "Lutein - Higher Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7ef40e9b-c60b-4ab4-8c4a-e59c85d5c39a_large_5ae8c01c-c4ad-4bee-bc03-28d57f152538.jpg?v=1787417754",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lutein",
        "higher",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 20.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790722060485",
      "vsf_explanation": "Lutein at 20 mg matches AREDS2 macular protective protocol (Chew 2013). Would move to Verified 70+ with marigold source, OmniActive/Kemin brand disclosure, and paired zeaxanthin.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "higher-strength-l-glutathione",
      "title": "Higher Strength L-Glutathione",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2e2c1ac1-0ce6-4e51-b752-a588c169e00c_large_1d8b90fe-fb4b-41b9-8a86-89cce02f2985.jpg?v=1787417754",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "higher",
        "strength",
        "glutathione",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 19.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790722093253",
      "vsf_explanation": "Higher-strength oral L-glutathione capsule; unlike the Setria-branded sibling SKU, the source and reduced/oxidized form are not disclosed on the title, which materially affects clinical relevance (Richie 2015 used Setria specifically). Oral glutathione historically underperformed liposomal delivery due to gut hydrolysis, though Richie's 6-month data at 500-1000 mg/day did show sustained body-store increases. Would move up with named Setria source, reduced GSH confirmation, and dose ≥500 mg/day disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "indole-3-carbinol-with-resveratrol",
      "title": "Indole-3-Carbinol with Resveratrol",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/422dd7fb-db90-4885-bea9-3515ef8e4f32_large_7b5bb779-274d-41ef-ac46-d53417d9b54d.jpg?v=1787417754",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "indole",
        "carbinol",
        "with",
        "resveratrol",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 62,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 16.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790722126021",
      "vsf_explanation": "I3C plus resveratrol pairs an estrogen-metabolism modulator with a polyphenol antioxidant — rational for consumers targeting Phase I/II detoxification and 2-hydroxy:16-hydroxy estrogen ratio. I3C's real-world activity comes largely from acid-condensation to DIM in the stomach, with variable inter-individual conversion (Bradlow 1999); DIM-based products are more predictable. Safety: I3C interacts with tamoxifen and multiple CYP substrates. Held to mid-Standard by dose ambiguity and by more targeted DIM alternatives outperforming I3C on estrogen-metabolism endpoints.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "inulin-prebiotic-soluble-fiber",
      "title": "Inulin - Prebiotic Soluble Fiber",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3ddcc2c0-674d-44a9-a5d7-b2dc4829d1c8_large_8c23599c-a876-47e9-9c4c-7531fb5ecd59.jpg?v=1787417754",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "inulin",
        "prebiotic",
        "soluble",
        "fiber",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 62,
        "sustainability": 60
      },
      "price": 16.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790722158789",
      "vsf_explanation": "Single-ingredient inulin prebiotic powder. Inulin is a well-established bifidogenic prebiotic with a solid RCT base (Kolida 2007, Vandeputte 2017) at ~5-8g/day. Source (chicory typically) and DP profile are unstated. GI-sensitive users should titrate up due to gas/bloating at higher doses. Would move to Verified with named source (Orafti / BENEO), DP disclosure, and a serving-size scoop to hit the 5g threshold.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "high-immunoglobulin-colostrum",
      "title": "High Immunoglobulin Colostrum",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1cc2936c-c003-403a-b872-8c465ce11a31_large_45dcdb39-149c-4754-ab97-d08e05315a7a.jpg?v=1787417754",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "high",
        "immunoglobulin",
        "colostrum",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 62,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 37.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790722191557",
      "vsf_explanation": "'High immunoglobulin' framing suggests IgG-enriched bovine colostrum — the correct metric for potency. Meta-analytic support for URI reduction in athletes (Jones 2016). Naming 'high IgG' at title is a transparency positive but exact % (target >25%) isn't visible. Would move to Verified 70+ with disclosed IgG %, first-milking claim, and pasteurization method.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "apple-cider-vinegar-higher-strength",
      "title": "Apple Cider Vinegar - Higher Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/74832c62-c7d3-4da3-b01d-f0b3500204d6_large_74e3a982-f78d-4eb2-9a33-bc892451d37e.jpg?v=1787417755",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "apple",
        "cider",
        "vinegar",
        "higher",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 50,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 9.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790722257093",
      "vsf_explanation": "ACV in capsule form. The most-cited mechanism (acetic acid slowing gastric emptying / blunting postprandial glucose, Johnston 2013) requires liquid ACV pre-meal contact with food; capsule ACV bypasses that mechanism because it releases in the stomach after ingestion. Small weight-loss RCT (Kondo 2009) used 15ml liquid vinegar. Would move up meaningfully only by switching to liquid ACV — capsule form is largely a marketing artifact.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lutein-higher-strength-1",
      "title": "Lutein - Higher Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f267f2b2-6b99-41a0-bbb7-563b2d4f4ffc_large_9488fcae-bbeb-47a7-ba5d-607f32d6e07d.jpg?v=1787417755",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lutein",
        "higher",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 12.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790722289861",
      "vsf_explanation": "Lutein at 10-20 mg matches AREDS2 macular protective protocol (Chew 2013). 'Higher Strength' typically 20 mg. Marigold source and manufacturer (OmniActive/Kemin) matter for standardization; not disclosed on title. Would move to Verified 70+ with source and mg confirmed, ideally paired with zeaxanthin.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "high-potency-collagen-with-vitamin-c-citrus-berry-flavor",
      "title": "High Potency Collagen with Vitamin C - Citrus Berry Flavor",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/113f301c-a9f4-4a80-a1b9-670cb89f28af_large_48b9a781-a7ce-48ed-ac74-671642daba53.jpg?v=1787417756",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "high",
        "potency",
        "collagen",
        "with",
        "vitamin",
        "citrus",
        "berry",
        "flavor",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 66,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 17.91,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790722355397",
      "vsf_explanation": "Hydrolyzed collagen peptides at 10g/day have skin-elasticity and hydration evidence (Choi 2014, Proksch 2014) and pairing with vitamin C supports endogenous collagen synthesis via prolyl-hydroxylase cofactor role. Powder flavored formats are legitimate but 'High Potency' language without specifying grams is opaque. Held below Verified by unclear peptide grams, unspecified sourcing (bovine vs marine vs Verisol/Peptan), and typical Swanson mass-market QC. Would move to Verified 70+ with 10g+ per serving disclosure, named peptide source, and independent COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-k2-natural",
      "title": "Vitamin K2 - Natural",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/dd84a51c-dc95-4836-838c-19dccb0de529_large_f73ad12f-9a5d-4e34-9ed6-119d3bbb1c8f.jpg?v=1787417757",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "natural",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 19.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790723240133",
      "vsf_explanation": "K2 as MK-7 (likely 'natural' natto-fermentation source) has strong cardiovascular and bone outcomes data (Knapen 2015 Thromb Haemost) with an ~72h half-life vs MK-4's short window. Held below Verified by absence of named-source MK-7 (MenaQ7/K2Vital) and unclear per-softgel mcg. Would move to Verified 70+ with named source and specific 90-180 mcg dose disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "graminex-flower-pollen-extract-maximum-strength",
      "title": "Graminex Flower Pollen Extract - Maximum Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a87d2504-60f5-40f9-8269-76ca45da7e8f_large_c96b35cc-51ea-49fb-a594-c22abffd06d2.jpg?v=1787417805",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "graminex",
        "flower",
        "pollen",
        "extract",
        "maximum",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 33.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790741721285",
      "vsf_explanation": "Graminex flower pollen extract (Cernitin) has RCT support for chronic prostatitis and BPH symptoms (MacDonald 2000; Wagenlehner 2009) at 375 mg/day. Naming the branded extract at label is a formulation positive. Would move to Verified 70+ with dose match, USP cert, and clear BPH-not-prostate-cancer framing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "maximum-strength-nadh-fast-acting-peppermint",
      "title": "Maximum Strength NADH - Fast-Acting Peppermint",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0af67f3d-99c2-449e-b5d9-0bc710f6fe09_large_474cef02-b70e-4e72-9996-654ee8a0f402.jpg?v=1787417805",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "maximum",
        "strength",
        "nadh",
        "fast",
        "acting",
        "peppermint",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 37.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790741754053",
      "vsf_explanation": "NADH sublingual lozenge — NADH is the reduced form of NAD+ and sublingual delivery bypasses the gut wall issue that limits oral NAD+ (which is degraded to nicotinamide before reaching cells intact). Human evidence is thin but present: Birkmayer 1993 on chronic fatigue at 10mg, Forsyth 1999 on Alzheimer cognition at 10mg (small pilot). NR (Chromadex Niagen) has substantially deeper RCT support for actually raising blood NAD+ (Martens 2018). Held at Standard because NADH clinical evidence base is much thinner than NR/NMN precursors, and Swanson does not name branded sourcing (Enada NADH from Georg Birkmayer is the reference).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "maqui-berry-extract-dry-eye-formula-featuring-maquibright",
      "title": "Maqui Berry Extract Dry Eye Formula - Featuring MaquiBright",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9fa6d346-73f7-4caa-8661-53e77dce95e4_large_eb38a5ff-f7f3-4f71-952f-a78c69539bdc.jpg?v=1787417806",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "maqui",
        "berry",
        "extract",
        "dry",
        "eye",
        "formula",
        "featuring",
        "maquibright",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 74,
        "manufacturing": 72,
        "safety": 72,
        "transparency": 70,
        "sustainability": 62
      },
      "price": 23.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790741786821",
      "vsf_explanation": "MaquiBright is Maqui Life's standardized delphinidin-rich Aristotelia chilensis extract, with two small placebo-controlled trials (Yamashita 2013; Hitoe 2014) showing improved tear volume/dry-eye symptoms at 30-60 mg/day. This is a genuine evidence-anchored branded ingredient rather than generic berry powder. Held to low Verified because independent replication outside industry-linked groups is limited. Would move up with a larger independent RCT and per-lot delphinidin standardization COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gaba-maximum-strength",
      "title": "GABA - Maximum Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/de362925-df3d-4796-a577-5416288d6c13_large_bec0819b-9691-4798-8f52-e9c73b112b2a.jpg?v=1787417806",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gaba",
        "maximum",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 11.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790741819589",
      "vsf_explanation": "Synthetic GABA at a high 'maximum strength' dose (typically 750-1000mg). Oral GABA blood-brain-barrier penetration is limited and debated; any subjective effect likely runs through peripheral autonomic or ENS mechanisms rather than direct central GABAergic action. Higher doses do not consistently produce stronger central effects and may increase tingling/paresthesia side effects. No PharmaGABA branding, so this is generic synthetic material. Would move to Verified 70+ by switching to PharmaGABA at studied 100-200mg with clear mechanism disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nattokinase-4-000-fibrinolytic-units",
      "title": "Nattokinase 4,000 Fibrinolytic Units",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cda7832a-ac5a-4fe6-87fd-5943c6a5d831_large_1ef38ab8-8e61-4ebd-8b41-ff83315ee8fd.jpg?v=1787417806",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nattokinase",
        "000",
        "fibrinolytic",
        "units",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 60,
        "safety": 52,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 24.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790741917893",
      "vsf_explanation": "4,000 FU is a high-strength nattokinase dose, roughly double the typical studied protocol (Kim 2008; Chen 2018 meta). Higher activity is a legitimate option for users targeting fibrinolytic support, but it also amplifies the anticoagulant-interaction risk that already applies to nattokinase. Safety score is depressed because the SKU does not carry a prominent do-not-combine-with-anticoagulants warning and does not disclose enzyme source (NSK-SD vs generic). Would move to Verified 70+ with prominent anticoagulant warning, dosing guidance for high-strength users, and named source.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "arginine-akg",
      "title": "Arginine AKG",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/72a4b1b7-1642-4ad8-a636-19883d133517_large_cd7eb862-dda6-4c08-b6a3-e0560df706b4.jpg?v=1787417806",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "arginine",
        "akg",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 15.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790741885125",
      "vsf_explanation": "Arginine alpha-ketoglutarate (AAKG) is the form popularized in sports nutrition, with modest evidence for acute nitric-oxide/vasodilation effects but weaker cardiovascular endpoint data than plain L-arginine or L-citrulline. Total elemental arginine is lower per gram of AAKG than of pure L-arginine, so daily servings need to be larger to reach the 3-6 g elemental arginine studied for endothelial function. Would move to Standard 65+ with clear disclosure of elemental arginine per serving, and Verified 70+ with a pharma-grade named source at studied dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "octacosanol-maximum-strength",
      "title": "Octacosanol - Maximum Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/999ecbb7-9f15-40f4-8ff0-d92aef28d002_large_428d9b77-c004-49b2-a320-c34e40d9755f.jpg?v=1787417806",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "octacosanol",
        "maximum",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790741983429",
      "vsf_explanation": "Octacosanol (28-carbon aliphatic alcohol from wheat germ/sugar cane) has been studied for exercise endurance (Saint-John 1986) and lipid modulation but with weak, dated evidence. Like policosanol, US replications have been disappointing. Category ceiling limits this to low-Standard until better trials emerge.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "microlactin-double-strength",
      "title": "MicroLactin - Double Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a1e7cf17-934f-4d2e-9ea7-9ded47d38bee_large_1a90295e-da99-45c7-9e9f-d1d3250131c9.jpg?v=1787417806",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "microlactin",
        "double",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 29.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790741950661",
      "vsf_explanation": "MicroLactin (hyperimmune bovine milk protein from Stolle Milk Biologics) has industry-supported trials (Colker 2002; Zenk 2002) for joint pain at 2000 mg/day. Evidence is limited and largely industry-authored. Dairy allergen caution needed. Would need independent replication to move up beyond Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "microlactin",
      "title": "MicroLactin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/73fe27a9-7bf4-405a-88f0-356541c3be95_large_f6a93da8-5c34-4dfc-9de8-3e65134458e6.jpg?v=1787417806",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "microlactin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 56,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 6.7,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790742048965",
      "vsf_explanation": "Standard-strength MicroLactin hyperimmune milk protein. Same evidence-base limits as double-strength: limited, industry-authored trials at 2000 mg/day. Dairy allergen caution needed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-b12-methylcobalamin-natural-black-cherry-flavored",
      "title": "Vitamin B12 Methylcobalamin - Natural Black Cherry Flavored",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fab539d2-32e7-4dac-bf99-e3136f19f520_large_b23054a2-67f8-43e5-a771-bcfffed68ad4.jpg?v=1787417806",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "b12",
        "methylcobalamin",
        "natural",
        "black",
        "cherry",
        "flavored",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 74,
        "formulation": 76,
        "manufacturing": 65,
        "safety": 70,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 12.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790742081733",
      "vsf_explanation": "Methylcobalamin is the preferred bioactive B12 form for methylation-cycle support and neurological uptake (Zhang 2013), superior to cyanocobalamin in MTHFR carriers and in neurological deficiency. Sublingual delivery bypasses intrinsic-factor absorption issues (relevant in older adults and PPI users). Held below Elite by absence of a named-source methylcobalamin, no third-party certification, and typical mass-market flavoring/sweetener composition. Would move to Verified 75+ with clear mcg dose and independent COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "biocore-lipo-maximum-strength",
      "title": "BioCore Lipo - Maximum Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2e816f0f-321e-44d6-be95-07ba1f99d5ca_large_ef4541aa-27bc-4569-b3e4-45b343a7dc88.jpg?v=1787417806",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "biocore",
        "lipo",
        "maximum",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 5.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790742016197",
      "vsf_explanation": "BioCore Lipo (Deerland/National Enzyme branded lipase blend) targets fat digestion for those with pancreatic insufficiency or gallbladder issues. Enzyme-supplementation evidence outside those clinical populations is weak. Would move to Verified with FCC lipase unit disclosure and clear indication framing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "avovida-maximum-strength",
      "title": "AvoVida - Maximum Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/967334c6-b364-4e07-b941-47f4a6fecc20_large_4ac321fe-87d9-4e9c-b899-ac3808e34ad7.jpg?v=1787417806",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "avovida",
        "maximum",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 24.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790742147269",
      "vsf_explanation": "Avocado-soybean unsaponifiables (ASU) sold as AvoVida — has RCT support for hip and knee OA (Christiansen 2015 meta) at 300 mg/day. Naming the branded standardized ASU is a formulation positive. Would move to Verified 70+ with 300 mg per serving disclosure and USP/NSF cert.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "maximum-strength-plant-sterols-featuring-cardioaid-phytosterols",
      "title": "Maximum Strength Plant Sterols - Featuring CardioAid Phytosterols",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4c3eb30e-5261-4dbc-9817-8d0009d114d7_large_a6790751-6bd8-4e75-9b25-3a659a873f25.jpg?v=1787417806",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "maximum",
        "strength",
        "plant",
        "sterols",
        "featuring",
        "cardioaid",
        "phytosterols",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 76,
        "formulation": 68,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 6.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790742114501",
      "vsf_explanation": "Plant sterols/stanols have among the strongest supplement-tier evidence for LDL-cholesterol reduction, with an FDA-authorized health claim at 1.3 g/day (Ras 2014 meta shows roughly 8-10% LDL reduction). CardioAid is a named, well-characterized ADM ingredient which is a genuine transparency signal. Held below Verified because the listing does not confirm serving reaches the 1.3-2 g/day range needed for full LDL benefit, and sterols are best absorbed with fat-containing meals — timing guidance is unclear. Would move to Verified 72+ with confirmed 1.3-2 g/day per serving and meal-timing directions.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "peak-atp-maximum-strength",
      "title": "Peak ATP - Maximum Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b522407f-bac2-4381-b9e3-1204c215cf2f_large_2d7356bf-2b8c-481e-807e-8e835540a549.jpg?v=1787417806",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "peak",
        "atp",
        "maximum",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 28.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790742180037",
      "vsf_explanation": "Peak ATP branded disodium adenosine 5-triphosphate from TSI Group has small RCT support for strength/lean mass at 400 mg/day (Wilson 2013; Jager 2014), most industry-funded. Using the branded ingredient is a formulation positive. Would move to Verified 70+ with third-party ID cert and 400 mg dose match.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "apple-polyphenols",
      "title": "Apple Polyphenols",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0cb9c425-dfe6-4ae7-bf69-867844c7dc27_large_03b20d57-accd-4df1-87b7-8ff6ae1eb748.jpg?v=1787417806",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "apple",
        "polyphenols",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 9.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790742212805",
      "vsf_explanation": "Apple polyphenols (procyanidins) have small RCT support for post-exercise oxidative stress and modest lipid effects. Evidence is early-stage. Standardization % (typically 80% polyphenols) matters and isn't disclosed on the title. Would move to Verified with standardization % and per-serving mg disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-b12-methylcobalamin-high-absorption",
      "title": "Vitamin B12 Methylcobalamin - High Absorption",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ff751cf7-fd28-4322-bcf9-2fa8b402e1c1_large_a4b902e0-9bc2-44ed-8fe8-96c1abbdb18f.jpg?v=1787417806",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "b12",
        "methylcobalamin",
        "high",
        "absorption",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 74,
        "formulation": 76,
        "manufacturing": 65,
        "safety": 70,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 21.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790742376645",
      "vsf_explanation": "Methylcobalamin — the coenzyme B12 form used in methionine synthase — is the correct choice for methylation and neurological support (Zhang 2013), and 'high absorption' typically indicates sublingual or dispersible delivery which bypasses intrinsic-factor limits. Held below Elite by absence of named source, no third-party certification, and unclear mcg from title. Would move to Verified 75+ with disclosed mcg (typical range 1000-5000 mcg) and third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "quercetin-maximum-strength",
      "title": "Quercetin - Maximum Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/02cfcb20-a822-4864-ac7b-848bbf64b134_large_f323353a-0d74-4b28-8854-e646cc98871c.jpg?v=1787417806",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "quercetin",
        "maximum",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 23.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790742245573",
      "vsf_explanation": "Quercetin dihydrate at 'maximum strength' likely 800-1000 mg, aligning with the Shaik 2006 pharmacokinetic and Talirevic 2012 blood-pressure trial doses. Real limitation is bioavailability — plain quercetin dihydrate has <5% oral absorption, so higher-mg products largely paper over the delivery problem. Enhanced forms (Quercetin Phytosome, EMIQ, quercetin+bromelain) outperform. Zinc-ionophore role often cited but human RCT data are limited. Would move to Verified 70+ with a phytosome or EMIQ delivery upgrade.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "astaxanthin-maximum-strength",
      "title": "Astaxanthin - Maximum Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/87cef1db-b442-4312-a129-27f8d2879353_large_5f35660c-68be-45dc-8784-2ac79ce98c99.jpg?v=1787417806",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "astaxanthin",
        "maximum",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 32.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790742278341",
      "vsf_explanation": "Astaxanthin (from Haematococcus pluvialis microalgae) has RCTs for skin photoprotection (Ito 2018), muscle recovery (Djordjevic 2012), and modest lipid effects at 4-12 mg/day. 'Maximum Strength' likely 10-12 mg matches skin/eye studies. Would move to Verified 70+ with Haematococcus source, cultivation method (photobioreactor > open pond), and BioAstin/AstaReal branded-supplier disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "microlactin-2-pack",
      "title": "MicroLactin - 2 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/19561c73-6011-48ae-9d97-a5500b83905a_large_6946851b-b9b3-4876-b85d-e605d684c486.jpg?v=1787417806",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "microlactin",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 56,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 23.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790742343877",
      "vsf_explanation": "Two-pack of MicroLactin hyperimmune milk protein. Limited industry-authored evidence for joint pain at 2000 mg/day. Dairy allergen caution needed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "msm-1",
      "title": "MSM",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/98058f3a-e94c-4a91-9739-f1128e92f01b_large_459f7f02-bcaf-4178-806b-b41cf2709479.jpg?v=1787417806",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "msm",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 63,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 58,
        "sustainability": 52
      },
      "price": 13.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790742311109",
      "vsf_explanation": "Standalone MSM SKU. Kim 2006 and Debbi 2011 support MSM at 1500-6000 mg/day for modest OA symptomatic relief. Generic Swanson sourcing, no OptiMSM callout, and no per-cap dose in title. Held below Verified by lack of purity certification. Would move to Verified 70+ with named-source (OptiMSM) and third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "phosphatidylserine-1",
      "title": "Phosphatidylserine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d9a71507-0758-44c6-a640-b171bfdf15dd_large_4d49daff-e523-4d14-a845-25aad3c6e082.jpg?v=1787417806",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "phosphatidylserine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 13.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790743294149",
      "vsf_explanation": "Standard-line PS capsule with solid evidence in the 100-300mg range for age-related cognitive decline (Kato-Kataoka 2010) and exercise-stress cortisol (Starks 2008). Held below Verified by an unspecified soy-vs-sunflower source and no COA disclosure. Safety profile is very good. Would move to Verified 70+ with sunflower-sourced PS and third-party heavy-metal testing published.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pantesin-pantethine",
      "title": "Pantesin Pantethine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6d837b16-4fcf-4968-9c80-55346d1b32a9_large_efd006a2-97e7-4773-8a6e-8cd3c31911b0.jpg?v=1787417806",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pantesin",
        "pantethine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 13.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790743326917",
      "vsf_explanation": "Pantesin (branded pantethine from Kyowa Hakko) is the disulfide dimer of pantothenic acid, with modest RCT support for triglyceride and LDL reduction (Rumberger 2011 at 600 mg/day). Naming the branded ingredient is a formulation positive. Would move to Verified 70+ with 600 mg dose confirmation and USP cert.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "modified-citrus-pectin",
      "title": "Modified Citrus Pectin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a05878d5-4cb4-4a02-ae99-1796f32de13f_large_578f4a5c-ecff-4e58-8f70-fd72b55199bf.jpg?v=1787417806",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "modified",
        "citrus",
        "pectin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 36.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790743359685",
      "vsf_explanation": "Generic modified citrus pectin — galectin-3 inhibitor with some evidence for PSA doubling-time in prostate cancer (Guess 2003) and heavy metal chelation. Studied doses are typically 15 g/day which capsules can't reach. Would move to Verified with branded standardization (PectaSol-C is the most-studied) and dose disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pectipure-modified-citrus-pectin",
      "title": "PectiPure Modified Citrus Pectin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5220418d-a8a3-4804-822d-6ebe8cef690b_large_2add817d-1f40-4c9a-a0f0-807fea97d874.jpg?v=1787417807",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pectipure",
        "modified",
        "citrus",
        "pectin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 18.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790743621829",
      "vsf_explanation": "Modified citrus pectin (MCP) is a low-molecular-weight galectin-3 inhibitor with some evidence for prostate PSA doubling-time (Guess 2003) and heavy metal chelation (Eliaz 2006). PectiPure branded standardization is a formulation positive. Studied doses are high (15 g/day) which most capsule products can't reach. Would move to Verified with dose disclosed and honest framing of the modest evidence base.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "neurosilk",
      "title": "NeuroSilk",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/565c7fbd-d1ab-440c-b538-eb8cfda78429_large_4c871b31-b70a-4249-9a5a-c483d957c043.jpg?v=1787417808",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "neurosilk",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 14.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790743654597",
      "vsf_explanation": "NeuroSilk (from silk protein hydrolysate) is a niche cognitive/mood ingredient with limited published human data. Silk peptides show some acetylcholine-related activity in animals but human RCTs are sparse. Would need meaningful cognitive-outcome trials to move above low-Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nattozimes",
      "title": "Nattozimes",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b49edea4-ac5e-43a7-95a6-0099799e06b9_large_695d23a4-9ef5-45b3-96ad-959ca639bd6f.jpg?v=1787417808",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nattozimes",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 5.6,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790743687365",
      "vsf_explanation": "Nattozimes is a fungal-fermented protease blend marketed as a nattokinase alternative. Actual nattokinase has small BP/fibrinogen RCTs (Kurosawa 2015); Nattozimes is a different enzyme profile with less specific data. Bleeding-risk needs explicit disclosure with anticoagulants. Would need fibrinolytic activity (FU) disclosure and independent replication to move up.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nattokinase-2-000-fibrinolytic-units",
      "title": "Nattokinase 2,000 Fibrinolytic Units",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7b08fe70-8f9a-437c-9323-1dd2ddaa58f9_large_f9c9e84e-4db4-4b43-9d4f-e42ea688f4f3.jpg?v=1787417808",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nattokinase",
        "000",
        "fibrinolytic",
        "units",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 66,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 14.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790743720133",
      "vsf_explanation": "2,000 FU per serving is the standard studied dose for nattokinase's mild fibrinolytic and blood-pressure effects (Kim 2008 hypertension pilot; Chen 2018 meta). Activity is quantified in fibrinolytic units, which is the correct disclosure for this enzyme. Safety is depressed because nattokinase can potentiate anticoagulants (warfarin, DOACs) and antiplatelets, and the SKU does not carry a prominent do-not-combine-with-blood-thinner warning. Would move to Verified 70+ with prominent anticoagulant-interaction disclosure and named NSK-SD or JBSL enzyme source.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-blood-sugar",
      "title": "Pure Blood Sugar",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/20ad1b9f-fb03-4dc3-adb1-c9cbecfd663b_large_36ab953a-0fc9-4b30-8906-7108d7320a02.jpg?v=1787417809",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "blood",
        "sugar",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 58,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 12.85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790744604869",
      "vsf_explanation": "Blood-sugar blends typically combine chromium, cinnamon, gymnema, banaba, alpha-lipoic acid. Individual actives have modest fasting-glucose evidence but a blended formula without per-active mg is hard to compare to studied protocols (e.g., Suksomboon 2013 for cinnamon 500-6000 mg). Framing risks implying diabetes management without clinical support. Would need per-active mg disclosure and explicit non-treatment framing to move up.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "p-5-p-pyridoxal-5-phosphate-double-strength",
      "title": "P-5-P Pyridoxal-5-Phosphate - Double Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ea0ddf1e-aac0-4601-b310-bab245f1285f_large_e87a127f-4627-4706-8cab-597cfed5a1ff.jpg?v=1787417808",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pyridoxal",
        "phosphate",
        "double",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 72,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790744637637",
      "vsf_explanation": "Pyridoxal-5-phosphate (P-5-P) is the active coenzyme form of vitamin B6, preferable to pyridoxine HCl for people with impaired B6 conversion. P-5-P avoids the neuropathy risk associated with chronic high-dose pyridoxine HCl (Vrolijk 2017). 'Double Strength' likely 40-50 mg — well within safe range. Naming the active form is a strong formulation choice. Would move to Elite with USP verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "eggshell-membrane",
      "title": "Eggshell Membrane",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6c5d2326-5d8c-4e42-8b61-eac49c5308c6_large_b0646338-2ed1-421d-88f5-d77bf8f03860.jpg?v=1787417810",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "eggshell",
        "membrane",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 22.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790744703173",
      "vsf_explanation": "Natural eggshell membrane (NEM) has moderate RCT support for osteoarthritis pain and stiffness (Ruff 2009; Danesch 2014) at 500 mg/day — comparable to glucosamine with faster onset. Would move to Verified 70+ with NEM branded-source confirmation (Stratum Nutrition), 500 mg dose match, and third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pharmagaba-strawberry-lemonade",
      "title": "PharmaGABA - Strawberry Lemonade",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/66f7cfce-8a45-4161-a182-7f91a4e9fe61_large_42130c5d-873f-40fe-800c-f995fbd1a83c.jpg?v=1787417810",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pharmagaba",
        "strawberry",
        "lemonade",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 70,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 10.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790744735941",
      "vsf_explanation": "PharmaGABA is Pharma Foods International's naturally fermented GABA (via Lactobacillus hilgardii) - the branded material used in most GABA RCTs including Yoto 2012 (attention/reaction time under stress) and Abdou 2006 (EEG/salivary IgA relaxation). Being the branded, studied material is a genuine upgrade over synthetic GABA. Oral GABA blood-brain-barrier penetration remains debated - effects may work through peripheral autonomic mechanisms or enteric ENS rather than direct central GABAergic action. Flavored powder format may include sweeteners/flavorings not needed for effect. Would move to Verified 70+ with clean formulation (no added flavor system) and clearer discussion of the peripheral-vs-central mechanism.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "propionyl-l-carnitine-with-glycine",
      "title": "Propionyl L-Carnitine with Glycine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ce99cbc3-643c-43fb-8497-2eeb1cf60f73_large_d58546c5-8a8d-4e24-87b3-b2be7f00adc8.jpg?v=1787417810",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "propionyl",
        "carnitine",
        "with",
        "glycine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 66,
        "manufacturing": 58,
        "safety": 66,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 18.47,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790744768709",
      "vsf_explanation": "Glycine propionyl-L-carnitine (GPLC) is the studied form for peripheral vascular use — Bloomer 2007 showed 4.5g GPLC increased nitric oxide response in trained men, and Delaney 2013 showed peripheral artery disease benefit. It's more targeted than plain L-carnitine for cardiovascular/circulation use. Sitting below Verified because Swanson does not publish sourcing (Sigma-tau's PLCarnitine is the reference) or third-party purity testing, and the label typically does not confirm the studied 3-4.5g/day dose is achievable in a reasonable serving. Would move to Verified 70+ with sourcing disclosure and per-serving dose confirmed in the studied range.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pqq-pyrroloquinoline-quinone",
      "title": "PQQ Pyrroloquinoline Quinone",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b7db14a8-b7be-4d16-9792-22c3457b96ea_large_ffcbf918-01f9-43f0-97df-4b7c568b98e6.jpg?v=1787417810",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pqq",
        "pyrroloquinoline",
        "quinone",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 22.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790744801477",
      "vsf_explanation": "PQQ has early evidence for mitochondrial biogenesis markers and subjective vigor (Nakano 2012), typically at 10-20mg/day. Evidence base is still thin and the ingredient sits in the emerging/exploratory category rather than the well-validated one. Swanson's generic PQQ SKU does not disclose whether it uses BioPQQ (the branded, GRAS-affirmed reference material). Safety is favorable at studied doses. Would move to Verified 70+ with BioPQQ identity plus disclosed dose within the 10-20mg studied window.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "black-yeast-beta-glucan-featuring-polycan",
      "title": "Black Yeast Beta Glucan - Featuring Polycan",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e91d8baa-5f19-4158-8b07-c1a13cd89e8b_large_1b3c1f8a-8a19-4540-a094-a0143625120c.jpg?v=1787417810",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "black",
        "yeast",
        "beta",
        "glucan",
        "featuring",
        "polycan",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 72,
        "manufacturing": 70,
        "safety": 72,
        "transparency": 68,
        "sustainability": 60
      },
      "price": 5.28,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790744834245",
      "vsf_explanation": "Polycan is a branded Aureobasidium pullulans-derived exopolysaccharide beta-1,3/1,6-glucan (Glucan Corp) with small human trials on joint comfort (Byun 2014) and immune-marker modulation. Better characterized than generic 'yeast beta-glucan' which conflates cell-wall vs exopolysaccharide fractions with very different immune activity. Held at top of Standard because the human data set is small and most trials are industry-adjacent. Would move to Verified 70+ with independent replication and per-lot beta-glucan standardization COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "potassium-orotate",
      "title": "Potassium Orotate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0c2cee17-63d1-4028-be54-a8603f19c050_large_c402dfb3-98b5-4482-97df-ddb05b066bfa.jpg?v=1787417811",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "potassium",
        "orotate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 7.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790744867013",
      "vsf_explanation": "Orotate mineral forms lack head-to-head RCT evidence supporting superiority over citrate/gluconate. Elemental potassium is a small fraction of the orotate salt, so effective potassium delivery is minimal versus the 99mg-capsule limit. Standard tier low end — the Nieper mineral-transporter hypothesis remains under-validated. Would not upgrade without absorption data.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-k2-natural-1",
      "title": "Vitamin K2 - Natural",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5e5d6cc5-6085-47ee-a116-10a860c08c4d_large_0247014d-5c21-45da-8e03-9a7c8b3e99fe.jpg?v=1787417812",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "natural",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 12.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790745751749",
      "vsf_explanation": "K2 (MK-7 preferred over MK-4 for half-life and arterial calcification outcomes, per Knapen 2015 Thromb Haemost) is well-supported for bone and cardiovascular endpoints. 'Natural' suggests fermentation-derived (natto-source), typical for MK-7. Held below Verified by absence of named-source (MenaQ7 or K2Vital) and unclear mcg per softgel. Would move to Verified 70+ with named MK-7 source and clear 90-180 mcg per softgel dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "double-strength-serrazimes-40-000-units",
      "title": "Double Strength Serrazimes - 40,000 Units",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/122d4588-d3f5-4457-8830-158d8a75854e_large_7692b179-04e6-4da6-a244-e0f79df4c918.jpg?v=1787417812",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "double",
        "strength",
        "serrazimes",
        "000",
        "units",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 5.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790745784517",
      "vsf_explanation": "Serrazimes (fungal-derived protease blend) is marketed as a serrapeptase alternative for systemic inflammation. Actual serrapeptase evidence is thin (small studies for sinusitis and post-op edema); Serrazimes is a different enzyme with even less independent data. 40,000 units disclosure is a formulation positive on transparency. Would need clinical trials on Serrazimes specifically to move up.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "arginine-complex",
      "title": "Arginine Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8f5cb7e7-064c-4f10-b2eb-6f9118e219b2_large_027efe19-60a3-48e7-b2c4-a7d2ec7091da.jpg?v=1787417812",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "arginine",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 56,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 52,
        "sustainability": 50
      },
      "price": 11.56,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790745817285",
      "vsf_explanation": "L-arginine at 3-6 g/day is the studied dose range for endothelial function and nitric oxide support. \"Arginine Complex\" is a blended formula whose SKU title does not disclose per-ingredient mg or the total arginine content, so buyers cannot confirm whether the daily serving reaches the studied range. Complexes at this price point commonly under-dose the headline amino acid. Would move to Standard 65+ with disclosed L-arginine and L-citrulline mg per serving, and to Verified 70+ if the combined dose reaches 5g+ with named pharma-grade source.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "n-acetyl-d-glucosamine",
      "title": "N-Acetyl D-Glucosamine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b288e7d3-5366-4b94-be6e-8e2a61253b23_large_768159a4-45c4-4849-8123-ede1cccb2469.jpg?v=1787417813",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "acetyl",
        "glucosamine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 58,
        "sustainability": 52
      },
      "price": 24.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790745850053",
      "vsf_explanation": "N-Acetyl D-Glucosamine (NAG) — a different molecule than the joint-studied glucosamine sulfate. Evidence for NAG is thin outside of some IBD/mucosal work (Salvatore 2000 in pediatric IBD) and gastric mucin studies; direct OA RCT support is weak. Not the form used in GAIT (Clegg 2006). Held below Verified by evidence gap for the stated form and no clinical-dose justification. Would move to Verified 70+ only with strong mucosal-support positioning and named clinical trials.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-k2-with-nattokinase",
      "title": "Vitamin K2 - with Nattokinase",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/973115b6-2720-4611-89ee-f1d9c4c69b1e_large_d0d760d6-9797-495e-8128-d9d6b89e5d42.jpg?v=1787417814",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "with",
        "nattokinase",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 70,
        "manufacturing": 62,
        "safety": 62,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 16.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790746734789",
      "vsf_explanation": "K2 (typically MK-7 form) has strong evidence for arterial calcification reduction (Knapen 2015 Thromb Haemost) and bone MGP activation; nattokinase has proteolytic/fibrinolytic activity data (Chen 2018 Biomark Insights). Pairing is reasonable for cardiovascular support. Safety scored lower due to nattokinase-anticoagulant interaction risk and the need for warfarin/antiplatelet warnings that mass-market labels often understate. Held below Verified by unclear MK-7 mcg dose from title, no NSF/USP, and safety-flag concerns. Would move to Verified 70+ with clear MK-7 mcg, nattokinase FU disclosure, and anticoagulant interaction warning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bromelain",
      "title": "Bromelain",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33f10a8d-1cd4-44e6-a9d6-df0130bed98f_large_c157c136-b9ba-4965-a05f-28073b401941.jpg?v=1787417817",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bromelain",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 14.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790747848901",
      "vsf_explanation": "Bromelain (pineapple stem protease) has modest RCT support for post-surgical edema and mild osteoarthritis (Brien 2004) at 500-2000 mg (2400 GDU/g). Swanson doesn't disclose GDU or MCU activity units on the title — the actual enzyme activity metric that matters. Would move to Verified with GDU/MCU disclosure and studied 500 mg dose confirmation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "muscle-comfort-formula-featuring-cherrypure",
      "title": "Muscle Comfort Formula - Featuring CherryPURE",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6177b386-e67c-4421-8020-dbc5ff3f7b43_large_95db2e56-1660-440e-b574-8c51400da846.jpg?v=1787417817",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "muscle",
        "comfort",
        "formula",
        "featuring",
        "cherrypure",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 16.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790747881669",
      "vsf_explanation": "CherryPURE is Anderson Global's freeze-dried Montmorency tart cherry powder with RCTs (Kuehl 2010; Bell 2016) for exercise-induced muscle soreness. Naming the branded ingredient is a formulation positive. Muscle-recovery framing matches the evidence base better than joint disease. Would move to Verified 70+ with dose match to 480 mg twice-daily protocol.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mineral-citrate-complex-calcium-magnesium-zinc-potassium",
      "title": "Mineral Citrate Complex - Calcium, Magnesium, Zinc, Potassium",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8eed3634-c89a-4a8c-80a6-42e55cea8d2c_large_cb3958b7-066e-4774-bfb4-1be11e5f773b.jpg?v=1787417817",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "immune",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mineral",
        "citrate",
        "complex",
        "calcium",
        "magnesium",
        "zinc",
        "potassium",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 66,
        "manufacturing": 62,
        "safety": 62,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 10.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790747947205",
      "vsf_explanation": "All-citrate mineral complex covering four key minerals — citrate is a well-absorbed common form for each. Multi-mineral formulas typically deliver moderate elemental doses of each mineral to avoid competitive absorption. Standard tier upper end. Would move to Verified with named-source (Albion) chelates and third-party verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "n-zimes-dairy",
      "title": "n-zimes Dairy",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/bc5fc2a8-70d5-474d-a08c-f282c7a8f45c_large_6e253283-3513-4859-a0bc-9a5891ce79f1.jpg?v=1787417818",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zimes",
        "dairy",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 8.3,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790748831941",
      "vsf_explanation": "Dairy digestive enzyme blends typically feature lactase (β-galactosidase). Lactase supplementation is well-validated for lactose intolerance (Portincasa 2008 meta) at 6,000-9,000 FCC units. Swanson doesn't disclose lactase FCC units on the title. Would move to Verified with FCC unit disclosure and dose match to studied protocols.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "msm-2",
      "title": "MSM",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1a34f011-d735-425a-9d48-6c93b51730d2_large_5972f8f8-dc10-4ecd-9f43-f37a16ed6d26.jpg?v=1787417819",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "msm",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 63,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 58,
        "sustainability": 52
      },
      "price": 12.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790748897477",
      "vsf_explanation": "Single-ingredient MSM (methylsulfonylmethane) — modest OA benefit at 1500-6000 mg/day per Kim 2006 and Debbi 2011. Generic Swanson MSM without OptiMSM (Bergstrom) branded-source disclosure or third-party purity testing — MSM is a synthetic compound where purity actually varies meaningfully by supplier. Held below Verified by unnamed source and no dose specified in title. Would move to Verified 70+ with OptiMSM callout and per-cap mg disclosure at clinical range.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "msm-3",
      "title": "MSM",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f22a72df-d2ff-4540-994c-18174a7c2196_large_459063b5-422a-427a-8357-496ad3b91192.jpg?v=1787417819",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "msm",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 63,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 58,
        "sustainability": 52
      },
      "price": 23.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790748930245",
      "vsf_explanation": "Standalone MSM SKU variant. Same evidence base as Swanson's other MSM offerings — Kim 2006 and Debbi 2011 support 1500-6000 mg/day for modest OA relief. Generic (non-Bergstrom OptiMSM) source and no dose in title. Held below Verified by lack of purity certification for a compound where impurity profile matters. Would move to Verified 70+ with OptiMSM sourcing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "meganatural-bp-grape-seed-extract",
      "title": "MegaNatural-BP Grape Seed Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/58e6494c-9361-4ae4-bfa2-f8564577fab4_large_f25c9e91-50ec-4ed1-a66f-1e1f8f14db5c.jpg?v=1787417819",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "meganatural",
        "grape",
        "seed",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 72,
        "manufacturing": 65,
        "safety": 68,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 15.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790748963013",
      "vsf_explanation": "MegaNatural-BP is a Constellation Wines/Polyphenolics branded grape seed extract with RCT support for blood pressure reduction (Sivaprakasapillai 2009; Feringa 2011 meta) at 300 mg/day. Naming the branded standardized extract at label is a real formulation positive. Would move to Verified 74+ with 300 mg dose match confirmation and USP/NSF cert.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mediterranean-nutrient-complex",
      "title": "Mediterranean Nutrient Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/582649e8-8154-494f-9839-ef830f04a8d4_large_987146ab-55fb-4146-9cc2-86bfa7b139c0.jpg?v=1787417820",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mediterranean",
        "nutrient",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 8.44,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790749028549",
      "vsf_explanation": "'Mediterranean' blends typically stack olive polyphenols, resveratrol, lycopene, mixed carotenoids. Mediterranean-pattern diet has strong outcome evidence (PREDIMED 2013) but a capsule doesn't replicate the whole-food matrix. Blend format without per-active mg disclosure limits formulation transparency. Would move to Verified with per-ingredient standardization %, mg, and framing as adjunct-to-diet rather than diet-replacement.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pqq-pyrroloquinoline-quinone-1",
      "title": "PQQ Pyrroloquinoline Quinone",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/85f21c56-142c-4c7f-8ae1-8bb27a40f77a_large_9547f455-08f5-42e5-a1ed-7180b156dc64.jpg?v=1787417835",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pqq",
        "pyrroloquinoline",
        "quinone",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 16.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790756303045",
      "vsf_explanation": "PQQ (pyrroloquinoline quinone) has small early-phase evidence for mitochondrial biogenesis markers and subjective vigor (Nakano 2012; Harris 2013), typically at 10-20mg/day. Evidence base is thin relative to CoQ10 - PQQ is best treated as an emerging longevity/mitochondrial support ingredient, not a proven cognitive intervention. Safety profile looks favorable at studied doses. Held below Verified by no branded-source disclosure (BioPQQ is the reference material) and modest overall evidence. Would move to Verified 70+ with BioPQQ identity and per-lot testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-heart",
      "title": "Pure Heart",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ad55f1a5-0c13-492c-b6b5-30c4ed424f92_large_d297f8d1-7357-4206-af6d-ae6ce0873fe1.jpg?v=1787417866",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "heart",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 54,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790769377477",
      "vsf_explanation": "Pure Heart is a Swanson multi-ingredient heart formula; the SKU title does not disclose actives, so the honest read is that this is likely a blend of common heart-support ingredients (CoQ10, hawthorn, garlic, taurine or similar) whose combined evidence at typical blend-tier doses is modest. Transparency is the biggest gap — without per-active mg disclosure at the listing level, buyers cannot verify whether individual actives hit their studied doses. Would move to Standard 62+ with a full per-active mg breakdown and Verified 70+ if each active is dosed to its studied range (e.g., CoQ10 100mg+, hawthorn 300mg standardized).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pro-oxy-biotic-with-magnesium-hydroxide",
      "title": "Pro-Oxy-Biotic - With Magnesium Hydroxide",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/bc10c83a-5148-431d-ac48-23805691833f_large_8bfd277d-2876-43b0-8712-42d4a8995b43.jpg?v=1787417866",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pro",
        "oxy",
        "biotic",
        "with",
        "magnesium",
        "hydroxide",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 45,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790769410245",
      "vsf_explanation": "Marketed as an 'oxygen-based colon cleanser' using magnesium peroxide/hydroxide to release oxygen in the colon. The 'oxygen colon cleanse' framing is a category-standard unverified medical claim — the mechanism is essentially an osmotic laxative (like milk of magnesia), and no RCT evidence supports the oxygenation/detox claims. Autofail applies for unverified_medical_claim (detox/cleanse). Users who want an occasional laxative would be better served by plain magnesium citrate.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "policosanol",
      "title": "Policosanol",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/11499af6-c6b3-444b-96da-d3a6595deb88_large_f675867e-79d5-4a1e-82bf-3f9a5e246c0e.jpg?v=1787417866",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "policosanol",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 13.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790769443013",
      "vsf_explanation": "Policosanol (sugar cane wax alcohols) has Cuban RCTs (Castano 2001) showing large LDL reduction, but independent European and US replications (Berthold 2006; Reiner 2005) have consistently failed to show any lipid effect. The evidence gap is substantial. Would need meaningful US/EU replication to move above low-Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "q-gel-mega-200",
      "title": "Q-Gel Mega 200",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/79612ec9-ad5b-4a11-b903-7ac12eace4a4_large_e5bac190-72d1-4e0e-be0a-cfce0faf2cf9.jpg?v=1787417866",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gel",
        "mega",
        "200",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 74,
        "manufacturing": 65,
        "safety": 72,
        "transparency": 70,
        "sustainability": 50
      },
      "price": 16.02,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790769475781",
      "vsf_explanation": "Q-Gel is Tishcon's hydrosoluble CoQ10 softgel with published bioavailability data. 200 mg dose is a strong therapeutic level, matching statin-adjunct RCTs (Skarlovnik 2014) and heart-failure Q-SYMBIO trial (Mortensen 2014 at 300 mg). Branded high-bioavailability form + high dose is a real formulation strength. Would move to Elite 85+ with USP/NSF cert and Kaneka-source confirmation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "potassium-citrate",
      "title": "Potassium Citrate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b9df3e98-704f-4641-ad09-66f41d349e59_large_b8ec1a51-face-4959-b3ed-d097843898ba.jpg?v=1787417866",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "potassium",
        "citrate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790769541317",
      "vsf_explanation": "Potassium citrate is the alkalinizing form with evidence for bone health and kidney stone prevention (Pak 2009). OTC potassium is capped at 99mg per capsule by convention (well below the 3,500-4,700mg RDI), so many capsules would be needed to reach clinically-relevant intake. Safety is docked because potassium interacts with ACE inhibitors and potassium-sparing diuretics. Standard tier — correct form, dose-limited utility.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "albion-creatine-magnapower",
      "title": "Albion Creatine MagnaPower",
      "vendor": "Albion",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f4f7bfb9-9827-4a13-beaf-05468264fa14_large_56970d18-621b-461c-9b75-503889d489f8.jpg?v=1787417866",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "albion",
        "creatine",
        "magnapower",
        "albion"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 72,
        "safety": 68,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 42.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790769672389",
      "vsf_explanation": "Creatine magnesium chelate under Albion's licensed MagnaPower brand — Albion is a legitimate mineral-chelate manufacturer with published bioavailability work, and naming the branded ingredient at label is a real transparency signal. However, direct head-to-head evidence vs plain creatine monohydrate does not show superiority (Selsby 2004 found MagnaPower not better than monohydrate for performance outcomes) — despite the marketing, monohydrate remains the reference-standard form. Would move to Verified 70+ if Swanson published a third-party COA and if evidence supported the chelate premium — as it stands, this is a well-branded but scientifically equivalent alternative to plain monohydrate.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "coq10-100-mg-with-tocotrienols",
      "title": "CoQ10 100 mg with Tocotrienols",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e5a78f11-3f10-416e-8823-0f2208029a20_large_e658a210-6623-4d2a-8e4f-c9a3d3203eae.jpg?v=1787417866",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coq10",
        "100",
        "with",
        "tocotrienols",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 64,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 16.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790769737925",
      "vsf_explanation": "100 mg conventional CoQ10 (ubiquinone) with added tocotrienols is a reasonable combo — tocotrienols have their own lipid-oxidation evidence and the fat-soluble carrier helps CoQ10 absorption. 100 mg is the workhorse cardiovascular dose (Skarlovnik 2014). Held below Verified because sourcing (Kaneka Q10 vs generic) is not disclosed, the tocotrienol source and gamma/delta ratio are not stated, and softgel-vs-cap delivery is unconfirmed on the listing. Would move to Verified 70+ with named Kaneka Q10 source, disclosed tocotrienol profile, and softgel delivery.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "phosphatidylserine-2",
      "title": "Phosphatidylserine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0a00840c-e712-4334-a609-3f9e3ebb08c0_large_7cfece69-9e28-4da5-adaa-4b25b37d9d9d.jpg?v=1787417866",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "phosphatidylserine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 31.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790769574085",
      "vsf_explanation": "Standard phosphatidylserine capsule; format is fine but Swanson's generic PS line historically uses soy-derived PS, which is scientifically equivalent but common allergen exposure. Evidence base for PS 100-300mg in age-related cognitive decline is solid (Kato-Kataoka 2010) and safety is excellent. Held below Verified by no source or extraction disclosure and no visible third-party testing. Would move to Verified 70+ with sunflower-sourced format and disclosed COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pterostilbene",
      "title": "Pterostilbene",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/85699376-3aaa-419c-ab34-79703b2cb53d_large_cd0a6961-cf58-4c59-b59b-d460c5982347.jpg?v=1787417866",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pterostilbene",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 8.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790769508549",
      "vsf_explanation": "Pterostilbene is a dimethylated resveratrol analog with better oral bioavailability and metabolic stability. Small RCTs (Riche 2014) show modest LDL/BP effects at 100-125 mg/day. Popular in longevity/NAD+ stacks. Ceiling limited by small trial base and absence of long-term outcome data. Would move to Verified with 100-125 mg dose match and pTeroPure/branded-source disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "coq10-200-mg-with-tocotrienols",
      "title": "CoQ10 200 mg with Tocotrienols",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a8d3506f-9172-48e7-9f72-781b2070b960_large_0d70c4fc-acea-4735-8188-d1e0a543d4eb.jpg?v=1787417866",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coq10",
        "200",
        "with",
        "tocotrienols",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 68,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790769606853",
      "vsf_explanation": "200 mg CoQ10 (ubiquinone) plus tocotrienols is a higher-dose cardiovascular combo well within studied ranges for statin-myalgia and heart failure adjunct use (Skarlovnik 2014; Mortensen 2014 Q-SYMBIO). Tocotrienols add lipid-antioxidant support with their own emerging cardiovascular literature. Held below Verified because Kaneka Q10 sourcing is not confirmed, tocotrienol profile (gamma/delta split, source) is not disclosed, and softgel/oil-carrier delivery is not shown on the listing. Would move to Verified 70+ with named Kaneka Q10 and disclosed tocotrienol profile.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "q-gel-mega-100",
      "title": "Q-Gel Mega 100",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/06111592-f7a7-4e1a-ba63-6ce8c9b7d0b9_large_cd44fc50-98ff-4b8a-a82b-a588fcab4d74.jpg?v=1787417866",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gel",
        "mega",
        "100",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 72,
        "manufacturing": 65,
        "safety": 72,
        "transparency": 70,
        "sustainability": 50
      },
      "price": 11.2,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790769639621",
      "vsf_explanation": "Q-Gel 100 mg hydrosoluble CoQ10 softgel from Tishcon — the branded formulation with published bioavailability data (Chopra 1998). 100 mg matches the Skarlovnik 2014 statin-myopathy protocol. Would move to Elite with USP/NSF cert and Kaneka Q10 source disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pycnogenol-1",
      "title": "Pycnogenol",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3d9bf59c-8aea-4199-81a9-776736615676_large_2157f63b-6d2b-4210-a06f-32b345836e06.jpg?v=1787417866",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pycnogenol",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 70,
        "manufacturing": 65,
        "safety": 70,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 28.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790769705157",
      "vsf_explanation": "Pycnogenol (Horphag French maritime pine bark) has extensive RCT support for endothelial function, venous insufficiency, and modest blood pressure reduction (Nishioka 2007; Belcaro 2015 meta) at 100-200 mg/day. Standard-strength typically 50-100 mg — enough for many indications but under-dosed for endothelial. Would move to Verified 74+ with 100-200 mg per serving.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mct-pure-pharmaceutical-grade",
      "title": "MCT Pure - Pharmaceutical Grade",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2d6e0d9a-5f32-4d8b-ac35-b8d309809c2e_large_21a26983-2969-4260-b35c-5d0747f7dc21.jpg?v=1787417866",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mct",
        "pure",
        "pharmaceutical",
        "grade",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 18.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790769770693",
      "vsf_explanation": "MCT oil for ketogenic energy substrate. 'Pharmaceutical grade' is marketing shorthand without regulatory definition in supplements. Absence of C8/C10 ratio disclosure holds this at Standard. Would move to Verified with C8/C10/C12 breakdown, palm-free sourcing, and third-party purity certificate.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-c-with-bioflavonoids-featuring-pureway-c",
      "title": "Vitamin C with Bioflavonoids - Featuring PureWay-C",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/78647891-b66d-400c-aa9a-524c112258be_large_e0420c06-9b7b-470e-bd40-3a0dac6faf57.jpg?v=1787417866",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "with",
        "bioflavonoids",
        "featuring",
        "pureway",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 74,
        "formulation": 76,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 72,
        "sustainability": 60
      },
      "price": 12.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790769803461",
      "vsf_explanation": "PureWay-C is a patented ascorbate-lipid metabolite complex with published pharmacokinetics showing improved retention vs plain ascorbic acid (Weeks & Perez 2007 J Med Food). Pairing with bioflavonoids provides plausible absorption synergy (Vinson & Bose 1988). Named-source ingredient plus a reasonable form pushes this to low-Verified. Held below Elite by lack of NSF/USP certification and typical Swanson vs premium-tier QC transparency. Would move to Verified 76+ with third-party COA and disclosed bioflavonoid standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "r-5-p-riboflavin-5-phosphate",
      "title": "R-5-P Riboflavin-5-Phosphate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/944098d7-a515-420c-97a0-365b72dcec5c_large_b9a36539-aa7d-4785-9906-b6b6c5104056.jpg?v=1787417866",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "riboflavin",
        "phosphate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 76,
        "manufacturing": 65,
        "safety": 70,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 14.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790769836229",
      "vsf_explanation": "Riboflavin-5-phosphate is the coenzymated bioactive form of B2, more directly usable than riboflavin and preferred by patients with impaired phosphorylation. Evidence supports high-dose riboflavin for migraine prophylaxis at 400mg (Schoenen 1998 Neurology) and general mitochondrial cofactor function. R-5-P is a legitimate formulation choice. Held below Elite by absence of named-source (e.g., from BASF/Roche), no third-party certification, and generic mass-market QC. Would move to Verified 75+ with COA and specific mg dose in title.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-liver-detox",
      "title": "Pure Liver & Detox",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/100d704a-aa79-4796-8482-f037ca1efeaf_large_c1d543c9-4daa-4bfb-ac3d-c4ae71bfab9d.jpg?v=1787417866",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "liver",
        "detox",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 45,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790769868997",
      "vsf_explanation": "The liver is already the body's primary detoxification organ (Phase I/II enzyme systems, biliary excretion) — the 'liver detox' construct sold OTC has essentially no RCT support and is repeatedly flagged by the FDA and FTC as unverified medical claim territory. Some individual ingredients often included (milk thistle for hepatic support in specific liver injury — Rambaldi 2007 Cochrane found only weak evidence) have narrow legitimate uses under medical supervision, but the branded 'liver detox' package is a marketing construct, not an evidence-supported protocol. Autofail: unverified_medical_claim.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "real-food-bone-broth-collagen-vanilla",
      "title": "Real Food Bone Broth Collagen - Vanilla",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/be3aed3b-2dc5-489b-8b0e-c771a6d42a71_large_17c1a31f-e81b-4020-b05d-ce45808ad9d1.jpg?v=1787417866",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "real",
        "food",
        "bone",
        "broth",
        "collagen",
        "vanilla",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 20.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790769901765",
      "vsf_explanation": "Powdered bone-broth collagen with vanilla flavor — supplies hydrolyzed collagen peptides plus glycine/proline naturally present in bone broth. Evidence base rides on collagen peptide trials (Proksch 2014, Clark 2008); the 'bone broth' framing is marketing, not incremental efficacy. Vanilla suggests added flavorings/sweeteners that dilute per-serving protein delivery. Held below Verified by unstated collagen dose per scoop, generic (non-clinical) peptide sourcing, and no grass-fed/pasture claim. Would move to Verified 70+ with per-serving g of collagen disclosed and grass-fed sourcing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "relora-patented-magnolia-phellodendron-extract",
      "title": "Relora - Patented Magnolia & Phellodendron Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/bbaf5981-f9ba-4b75-8d54-793ebac3de1e_large_a3e6cf28-f7d3-4b39-bedf-3bee1da4a8f3.jpg?v=1787417866",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "relora",
        "patented",
        "magnolia",
        "phellodendron",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 14.51,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790769934533",
      "vsf_explanation": "Relora (InterHealth branded magnolia + phellodendron) has industry-funded RCTs (Talbott 2013 at 250 mg TID) showing modest cortisol and stress-perception improvement. Naming the branded blend at label is a formulation positive. Magnolia (honokiol) is a GABAergic and can interact with alcohol/benzodiazepines — safety disclosure needed. Would move to Verified 70+ with published 750 mg/day dose match and interaction cautions.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "selenoexcell-selenium",
      "title": "SelenoExcell Selenium",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b2999589-bb20-4f2f-b395-e82e374d771f_large_1906d3d8-9d46-4259-b5ae-316de348dcda.jpg?v=1787417869",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "selenoexcell",
        "selenium",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 74,
        "formulation": 74,
        "manufacturing": 70,
        "safety": 68,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 5.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790770884805",
      "vsf_explanation": "SelenoExcell is a high-selenium yeast (Cypress Systems) used in the Nutritional Prevention of Cancer trial (Clark 1996) delivering selenomethionine plus multiple organic selenium compounds. Named-source raw material with a published RCT identity lifts this to Verified. 200mcg is the typical thyroid-support dose. Would move higher with third-party purity/potency verification per SKU.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "saw-palmetto-beta-sitosterol",
      "title": "Saw Palmetto & Beta-Sitosterol",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/98c339f8-4d18-4dd8-916f-903ff7d50279_large_8eddf1dc-941c-467a-aac0-a556e84907ac.jpg?v=1787417869",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "saw",
        "palmetto",
        "beta",
        "sitosterol",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 18.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790770917573",
      "vsf_explanation": "Two-active combo of saw palmetto and beta-sitosterol — both have BPH evidence with beta-sitosterol showing the stronger effect in Wilt 1999 meta-analysis (60-130mg/day). Saw palmetto has mixed RCT support (Bent 2006 STEP null; Wilt 1998 positive) but needs 85-95% fatty acid standardization at 320mg to match studied doses. Cleaner two-ingredient formulation than the complex blends but standardization percentages and precise per-active mg typically aren't front-of-label. Would move to Verified 70+ with standardization disclosed at monograph levels for both actives.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "same",
      "title": "SAMe",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6c19b213-a34a-41b4-a10f-7ddce080e7c1_large_085727e5-e460-4a72-85a8-baa409471fbf.jpg?v=1787417869",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "same",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790770950341",
      "vsf_explanation": "SAMe standard-strength (typically 200-400 mg) has meta-analytic support for mild-moderate depression (Sharma 2017) at 800-1600 mg — so single-dose products often require 2-4 tabs to reach studied dose. Bipolar caution needed. Would move to Verified with butanedisulfonate salt, enteric coating, and clear per-serving mg matching studied protocols.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "resveratrol-quercetin-with-grape-seed-extract-3-in-1-formula",
      "title": "Resveratrol & Quercetin with Grape Seed Extract -3 in 1 Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fde9dea0-4fe7-4a32-bad5-423856a4493e_large_053e8570-24f7-4f61-88b5-cf19c7cf0e4e.jpg?v=1787417870",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "resveratrol",
        "quercetin",
        "with",
        "grape",
        "seed",
        "extract",
        "formula",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 66,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 21.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790771900613",
      "vsf_explanation": "Rational polyphenol pairing: quercetin co-administration inhibits UGT-mediated resveratrol glucuronidation, increasing systemic exposure (De Santi 2000), and grape seed OPCs add complementary antioxidant activity. Held to mid-Standard by the '3-in-1' blend framing, which typically obscures individual actives' milligrams and prevents dosing against any specific RCT. Reasonable value entry point for antioxidant stacking. Would move to Verified 70+ with per-ingredient dose disclosure and trans-resveratrol standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "royal-jelly-propolis-complex",
      "title": "Royal Jelly Propolis Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/00ac5813-c654-4863-b612-6c79e132a80e_large_230392f5-52eb-4718-88ac-2ad7943e7a44.jpg?v=1787417870",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "royal",
        "jelly",
        "propolis",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 14.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790771933381",
      "vsf_explanation": "Royal jelly and propolis are bee-derived products with modest RCT support (propolis for oral herpes, Vynograd 2000; royal jelly for menopausal symptoms in small trials). Bee-product allergy is a serious safety flag needing explicit warning. Complex blends without per-active mg disclosure limit formulation transparency. Would need 10-HDA % (royal jelly) and CAPE % (propolis) disclosure to move up.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "prostate-complex",
      "title": "Prostate Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8cfd7c78-f5d6-4d23-bff5-644308d1cabd_large_bc5c3d6c-e265-41e3-897e-62a0ea9440f7.jpg?v=1787417870",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "prostate",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 15.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790771966149",
      "vsf_explanation": "Multi-herb prostate formula from Swanson, typically anchored by saw palmetto with pygeum, beta-sitosterol, and/or nettle. Saw palmetto RCT evidence is mixed (Bent 2006 STEP null; Wilt 1998 modest positive), while beta-sitosterol has a small but positive meta-analysis for BPH symptom scores (Wilt 1999). Multi-ingredient formulas at Swanson typically don't disclose per-active mg at monograph levels or provide standardization percentages. Would move to Verified 70+ with 320mg saw palmetto at 85-95% fatty acid standardization plus disclosed beta-sitosterol dose (60-130mg studied).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "selenium",
      "title": "Selenium",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b20572dd-a76e-45ae-9962-5b68daccea6b_large_57f37590-a722-4d72-b300-4ef8a410766a.jpg?v=1787417870",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "selenium",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 8.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790771998917",
      "vsf_explanation": "Generic Swanson selenium at typical 200mcg has thyroid antioxidant support evidence (Rayman 2012; Duntas 2010 for Hashimoto). Form is not disclosed at the title level — selenite/selenate/yeast/selenomethionine differ meaningfully in bioavailability. Standard tier — legit dose, form opacity. Would move up with disclosed L-selenomethionine or SelenoExcell form.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "resveratrol-2",
      "title": "Resveratrol",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b6faea6d-7ba1-49a0-bb24-97c20f95d03a_large_8e23e179-950b-41f3-9472-e904191966bd.jpg?v=1787417871",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "resveratrol",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 56,
        "sustainability": 55
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790772064453",
      "vsf_explanation": "Standard-tier plain resveratrol SKU — evidence base is mixed and human longevity outcomes remain unproven despite strong preclinical signals. Held to mid-Standard until trans-resveratrol percentage, source, and dose are disclosed at label level. Bioavailability is the main real-world limiter for oral resveratrol. Would move up meaningfully with a phytosome or micronized delivery form.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "saw-palmetto-complex-2-pack",
      "title": "Saw Palmetto Complex - 2 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3de449f1-932e-44a3-bf26-3a6d0c9a6bde_large_ae00cef5-ac04-47c3-aa40-2a948d07a587.jpg?v=1787417871",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "saw",
        "palmetto",
        "complex",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 32.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790772129989",
      "vsf_explanation": "Two-pack of Swanson's Saw Palmetto Complex — same formulation, same profile. Saw palmetto for BPH has mixed RCT support (Bent 2006 STEP null; Wilt 1998 modest positive) and typically needs 320mg/day standardized to 85-95% fatty acids to match studied protocols. Multi-herb complex likely under-doses individual actives without disclosing standardization percentages. Would move to Verified 70+ with per-active mg meeting monograph and standardization percentages disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "real-food-folic-acid",
      "title": "Real Food Folic Acid",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/52e2db13-ed8a-4de8-a57b-fe4bf8d24561_large_d1e6fe40-1799-4c0e-9dd1-11053f69c4d7.jpg?v=1787417871",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "real",
        "food",
        "folic",
        "acid",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 55,
        "sustainability": 65
      },
      "price": 11.7,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790772097221",
      "vsf_explanation": "'Real Food Folic Acid' is misleading naming since native folate in food is 5-MTHF/tetrahydrofolate polyglutamates, not the synthetic 'folic acid' molecule. If the product is truly food-derived folate, it should say 'folate.' Folate itself has strong evidence for neural tube defect prevention (MRC 1991) and homocysteine lowering. Held below Verified by naming ambiguity, unclear form, and mass-market QC. Would move to Verified 70+ with 5-MTHF (Quatrefolic/Metafolin) disclosure and clear mcg DFE dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "advanced-real-food-multi-vegan-mens-daily",
      "title": "Advanced Real Food Multi Vegan - Men's Daily",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4f3aa616-c5d9-4eca-aa77-61dcc47055a2_large_ad8b1614-189d-46d2-9557-2d6521865e29.jpg?v=1787417871",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "advanced",
        "real",
        "food",
        "multi",
        "vegan",
        "men",
        "daily",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 65,
        "sustainability": 60
      },
      "price": 33.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790772162757",
      "vsf_explanation": "Whole-food-based vegan men's multivitamin — Swanson's higher-tier multi format using food-cultured nutrients with cofactor context. Multivitamin coverage has modest value (Gaziano 2012 PHS II). Men's multis correctly typically omit iron and adjust B-vitamin ratios. Vegan formulation avoids gelatin/dairy allergens. Would move to Verified 70+ with 5-MTHF folate disclosed, third-party testing, and named-source fermentation ingredients.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "resveratrol-3",
      "title": "Resveratrol",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1a8e1fa1-74f4-4625-9bae-76e17dd1f26d_large_b3d15147-4067-44ea-8a9b-f5216ff7664c.jpg?v=1787417872",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "resveratrol",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 56,
        "sustainability": 55
      },
      "price": 7.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790772949189",
      "vsf_explanation": "Third generic Swanson resveratrol SKU; same evaluation as the sibling resveratrol capsules — legitimate ingredient with unproven longevity claims in humans, held to mid-Standard by absence of standardization percentage and bioavailability carrier. Would move to Verified with named trans-resveratrol content and a delivery upgrade.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "r-fraction-alpha-lipoic-acid",
      "title": "R-Fraction Alpha Lipoic Acid",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6bd53ef3-1c8c-43bd-9513-9826c3ee3418_large_0585f947-6099-4500-b37a-2ddf44de3e78.jpg?v=1787417872",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fraction",
        "alpha",
        "lipoic",
        "acid",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 16.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790773047493",
      "vsf_explanation": "R-ALA is the biologically active enantiomer with better bioavailability than racemic ALA (Carlson 2007). Studied at 600 mg for diabetic neuropathy (Ziegler 2011). Standard strength typically 100-200 mg. Would move to Verified 70+ with Na-R-ALA stabilization for shelf life and dose match to neuropathy protocol.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "red-yeast-rice-2-pack",
      "title": "Red Yeast Rice - 2 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/bb6b384d-e55a-432e-a31a-97f399d65741_large_3b125975-0b83-4520-9a6f-82a9a9adbc3e.jpg?v=1787417873",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "yeast",
        "rice",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 41,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 18.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790773080261",
      "vsf_explanation": "Red Yeast Rice's LDL-lowering evidence rests on its monacolin K content, which is chemically identical to lovastatin (Gerards 2015 meta). The safety score is dragged down because monacolin content varies wildly between manufacturers and batches (Cohen 2017), the SKU listing does not confirm monacolin K content or citrinin-free testing, and the label lacks a prominent do-not-combine-with-prescription-statin warning. Bundling as a 2-pack compounds cumulative exposure without dosing guidance. Would move to Standard 65+ with disclosed monacolin K content, citrinin-free COA, and a clear drug-interaction warning. This is unregulated, drug-equivalent exposure with no third-party assay on record — held at Rejected under safety_concern until monacolin K and citrinin testing plus a prominent statin-interaction warning are published.",
      "vsf_autofail_rule": "safety_concern"
    },
    {
      "handle": "senior-muscle-retention-whey-protein-powder-vanilla",
      "title": "Senior Muscle Retention Whey Protein Powder - Vanilla",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/535bb381-28b5-4d65-8b43-22a4dc48d6ea_large_818d36a8-7cd9-413b-8e2c-aee34a7e6168.jpg?v=1787417873",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "adults_50_plus",
      "tokens": [
        "senior",
        "muscle",
        "retention",
        "whey",
        "protein",
        "powder",
        "vanilla",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 34.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790773113029",
      "vsf_explanation": "Vanilla version of the senior-targeted whey. Evidence base for whey + leucine in preventing sarcopenia is solid (Bauer 2013 PROT-AGE consensus, Katsanos 2006 on the leucine threshold in older adults). For elderly anabolic resistance, ~2.5-3g leucine per serving is the operative threshold. Would move to Verified 70+ with grass-fed isolate base, ≥30g protein and ≥2.7g leucine per serving disclosed, and NSF certification confirmed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "same-higher-strength",
      "title": "SAMe - Higher Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/22e4ef07-aa16-4d78-95cd-c12e2dd1e1c4_large_6d653595-fc2a-45c9-999f-ceecba0a56b3.jpg?v=1787417873",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "same",
        "higher",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 68,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 30.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790773145797",
      "vsf_explanation": "S-Adenosyl-L-methionine (SAMe) has meta-analytic support for depression (Sharma 2017) at 800-1600 mg/day and osteoarthritis pain (Rutjes 2009). SAMe is oxidation-sensitive, so enteric-coated tablets and butanedisulfonate salts matter. Swanson doesn't disclose salt form or coating on the title. Bipolar/manic-episode contraindication needs explicit disclosure. Would move to Verified 70+ with butanedisulfonate form, enteric coating, and bipolar caution.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mct-oil-100-pure-pharmaceutical-grade",
      "title": "MCT Oil - 100% Pure Pharmaceutical Grade",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/80143dc6-6e69-4856-b5dc-b3af4788b8db_large_bdd738e6-4d6c-48f7-b89d-714960df49ad.jpg?v=1787417874",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mct",
        "oil",
        "100",
        "pure",
        "pharmaceutical",
        "grade",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 10.93,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790774096069",
      "vsf_explanation": "MCT oil (medium-chain triglycerides, primarily C8/C10) is well-studied for ketogenic energy substrate (St-Onge 2003) and modest thermogenic effect. 'Pharmaceutical grade' is a marketing term without regulatory meaning in supplements. Swanson doesn't disclose C8 vs C10 vs C12 (lauric) ratios on the title — pure C8 (caprylic) is superior for rapid ketosis. Would move to Verified 70+ with C8/C10/C12 breakdown, palm-free sourcing (sustainability), and third-party purity certificate.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "saw-palmetto-complex",
      "title": "Saw Palmetto Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9a73c114-2783-49ee-afbc-b79431691e62_large_bff50f0d-2806-4802-bd00-1c7b910f526d.jpg?v=1787417874",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "saw",
        "palmetto",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 9.25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790774128837",
      "vsf_explanation": "Saw palmetto blended with other prostate-support herbs (typically pygeum, nettle root, pumpkin seed). Saw palmetto for BPH has mixed RCT evidence — the large STEP trial (Bent 2006) was null, though earlier trials (Wilt 1998 meta-analysis) showed a modest benefit at 320mg standardized to 85-95% fatty acids. Complex blends typically under-dose the individual actives versus monograph, and standardization percentages are often not disclosed. Manufacturing is Swanson mid-tier without visible third-party certification. Would move to Verified 70+ with 85-95% fatty acid standardization disclosed and 320mg/day saw palmetto meeting the studied dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-energy",
      "title": "Pure Energy",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4bc0b179-026d-421e-b4df-2f064e42c3e3_large_076306d0-d603-4fae-aa98-f51dfc90803b.jpg?v=1787417874",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "energy",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 52,
        "sustainability": 50
      },
      "price": 7.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790774161605",
      "vsf_explanation": "Full-size Pure Energy — same rationale as the trial size. Generic 'energy' branding without per-active dose disclosure at title level makes evaluation impossible. Would move up with fully-transparent labeling per active ingredient, and branded sources named where applicable.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "resveratrol-higher-potency",
      "title": "Resveratrol - Higher Potency",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3dfffb02-ccbb-4ffe-bb2a-d7a45d2c105c_large_60600212-2b80-49cc-9050-a1a240abe159.jpg?v=1787417875",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "resveratrol",
        "higher",
        "potency",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 66,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 25.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790774194373",
      "vsf_explanation": "Higher-potency resveratrol capsule — likely 250-500 mg range, which puts it in line with most human clinical trials on metabolic markers (Timmers 2011). Held to mid-Standard because the title still lacks trans-resveratrol standardization percentage, source disclosure, and any bioavailability enhancer (resveratrol has poor oral bioavailability; formulations with piperine, quercetin, or micronized/liposomal delivery outperform plain capsules). Longevity claims for oral resveratrol remain unproven in humans. Would move to Verified 70+ with trans-resveratrol standardization + bioavailability enhancement.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "quinogel-50-mg",
      "title": "Quinogel 50 mg",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/970fa87d-62c5-4938-a299-0086e63d0b14_large_d93865c4-a17b-4330-a910-f97e8b4e19ad.jpg?v=1787417874",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "quinogel",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 72,
        "manufacturing": 65,
        "safety": 70,
        "transparency": 70,
        "sustainability": 50
      },
      "price": 7.4,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790774227141",
      "vsf_explanation": "Quinogel is a hydrosoluble CoQ10 (ubiquinone) softgel formulation from Tishcon with published bioavailability data (Chopra 1998) showing higher plasma Q10 than powder capsules. 50 mg is a modest but reasonable dose especially for statin-related myopathy support (Skarlovnik 2014 at 50 mg/day RCT). Branded high-bioavailability form is a real formulation positive. Would move to Elite with USP verification and 100 mg option matching higher-dose statin trials.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "resveratrol-complex",
      "title": "Resveratrol Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d3d789f4-9782-4541-ba5a-25a3a76f7e68_large_60ebcc6a-d0ca-4ba4-80cb-6aa5986669dd.jpg?v=1787417874",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "resveratrol",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 66,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 23.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790774259909",
      "vsf_explanation": "'Complex' branding usually indicates resveratrol combined with grape seed OPCs, red wine polyphenols, or quercetin — a reasonable directional pairing since quercetin inhibits resveratrol glucuronidation, potentially raising exposure (De Santi 2000). Held to Standard because 'complex' formulations tend to hide the actual trans-resveratrol milligrams behind a blend, undermining the ability to dose against clinical protocols. Would move up with per-ingredient mg disclosure and no proprietary blend concealment.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-brainpower",
      "title": "Pure Brainpower",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6d9c48e0-8806-4c9c-ae8c-6b0cc9947b96_large_c26393d8-b1bb-438e-8b04-d41fd06b8670.jpg?v=1787417875",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "brainpower",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 21.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790774292677",
      "vsf_explanation": "Multi-ingredient nootropic formula whose label typically bundles ginkgo, huperzine, choline, and other actives; without seeing per-active mg it is impossible to know whether any single ingredient hits its studied dose. The category is prone to under-dosed 'kitchen sink' formulations that market breadth over efficacy. Manufacturing is competent but generic. Held here rather than autofailed for proprietary_blend_hides_dose because Swanson often lists doses individually on the SFP - but if the marketing page shows a 'proprietary blend' with only a total mg, this drops to Rejected. Would move to Verified with fully disclosed per-active doses at RCT-relevant amounts.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ribose",
      "title": "Ribose",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71043bdb-ff67-4b06-b230-4ade949e08ad_large_3a0d69af-aa06-4711-9dc1-f853966313c0.jpg?v=1787417875",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ribose",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 5.1,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790774325445",
      "vsf_explanation": "Generic D-ribose with modest evidence base for heart failure (Omran 2003) and fibromyalgia (Teitelbaum 2006). Not shown to benefit healthy exercise performance. Standard-tier without disclosed grams/serving matching studied 5 g TID protocol.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "resveratrol-4",
      "title": "Resveratrol",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a359eeef-6a98-492d-8a01-36baf9caa9c8_large_2688e0ea-5ccd-451c-96a5-5764f696147e.jpg?v=1787417875",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "resveratrol",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 56,
        "sustainability": 55
      },
      "price": 10.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790774358213",
      "vsf_explanation": "Generic resveratrol capsule with no trans-resveratrol percentage or source (Japanese knotweed vs grape) disclosed on the title. Human evidence is limited — most Sinclair-era mouse longevity findings failed to replicate cleanly in humans, and Semba 2014 found no association between dietary resveratrol and mortality/inflammation in an older cohort. Reasonable modest antioxidant activity at 250-500 mg but the longevity story is overstated. Would move up with trans-resveratrol >=98% standardization named on-label, dose disclosure, and testing for polygonum-derived emodin contamination.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "d-ribose-powder-100-pure-non-gmo",
      "title": "D-Ribose Powder - 100% Pure Non-GMO",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0ceaa0ad-03e7-46a3-b6b3-4d8754c3ffec_large_0ba53255-d284-4024-9bc6-99120c26fba5.jpg?v=1787417876",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ribose",
        "powder",
        "100",
        "pure",
        "non",
        "gmo",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 35.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790774685893",
      "vsf_explanation": "D-Ribose has modest RCT evidence for heart failure exercise tolerance (Omran 2003, 5 g TID) and fibromyalgia energy (Teitelbaum 2006, small open-label). Pure single-ingredient powder with Non-GMO disclosure is transparency-positive. Doesn't help healthy athletes per Seifert 2017. Would move to Verified with third-party ID testing and heart-failure/fibromyalgia use-case framing rather than general 'energy' claims.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "real-food-b-complex-from-quinoa-sprouts",
      "title": "Real Food B-Complex From Quinoa Sprouts",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3494c16f-515a-4178-83df-f4ab820bc1a8_large_1bdc93f3-af1a-40ca-8dfe-753da3e8a694.jpg?v=1787417876",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "real",
        "food",
        "complex",
        "from",
        "quinoa",
        "sprouts",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 60,
        "sustainability": 65
      },
      "price": 27.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790774718661",
      "vsf_explanation": "Fermented/food-grown B-complexes deliver naturally occurring, low-dose bioactive B vitamins with better tolerability than synthetic megadose complexes, and the quinoa-sprout substrate is a defensible whole-food matrix. However, mg amounts of each B are typically quite low compared to studied methylation-support doses. Held below Verified by low potency (unlikely to correct clinically meaningful methylation gaps), no third-party certification, and vague 'from' language rather than standardized bioactive form disclosures. Would move to Verified 70+ with organic certification and per-B nutrient bioavailability data.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "advanced-real-food-multi-vegan-womens-daily",
      "title": "Advanced Real Food Multi Vegan - Women's Daily",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ec732a3d-0d8c-4e89-9250-8666e069b7bf_large_2527f48e-6d4f-45bb-a995-4465663312a6.jpg?v=1787417876",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "advanced",
        "real",
        "food",
        "multi",
        "vegan",
        "women",
        "daily",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 65,
        "sustainability": 60
      },
      "price": 34.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790774751429",
      "vsf_explanation": "Whole-food-based vegan women's multivitamin — a step up in formulation intent from generic Swanson multis. 'Real food' multis typically use food-cultured nutrients with better cofactor context, though absolute doses often run modest vs. isolated-nutrient multis. Multivitamin coverage has value (Gaziano 2012 PHS II). Key checks for a women's multi: 5-MTHF folate, iron form (bisglycinate preferred), and iodine adequacy. Vegan formulation removes gelatin/dairy allergens. Would move to Verified 70+ with 5-MTHF disclosed, third-party testing, and named-strain fermentation source.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "oral-probiotic-formula-natural-strawberry-flavor",
      "title": "Oral Probiotic Formula - Natural Strawberry Flavor",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8fbf9d1e-98cc-41e3-913f-668a1f708c79_large_89f7911f-3edf-48f5-a186-88a4502583f3.jpg?v=1787417876",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "oral",
        "probiotic",
        "formula",
        "natural",
        "strawberry",
        "flavor",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 14.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790774784197",
      "vsf_explanation": "Oral cavity probiotic (lozenge/chewable). The oral-cavity category has real evidence primarily for Streptococcus salivarius K12 and M18 (Burton 2013 for halitosis; Di Pierro 2012 for pharyngitis), but the title does not confirm those specific strains are used. Flavor and format are appropriate for oral colonization. Would move to Verified with explicit K12/M18 identification and per-lozenge CFU disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "noni",
      "title": "Noni",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8f423fb5-0ec6-4f74-a68d-ea4a00794c89_large_b6f1529e-4cc2-4669-9f50-6201ddea4ec3.jpg?v=1787417877",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "noni",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 55,
        "sustainability": 58
      },
      "price": 9.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790774816965",
      "vsf_explanation": "Noni (Morinda citrifolia) has weak human evidence for any of its traditional immune, energy, or antioxidant marketing claims — most positive data come from open-label observational reports or in-vitro/animal work. Case reports link noni to hepatotoxicity (Stadlbauer 2005; Yuce 2006), which is a real safety asymmetry for a supplement with limited efficacy signal. Not an autofail because Swanson doesn't make specific disease claims on the SKU title, but the risk/benefit profile is unfavorable versus better-supported antioxidants. Not recommended for anyone with liver disease or on hepatotoxic medications.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "trehalose",
      "title": "Trehalose",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cf455aa5-ccc5-4539-ae14-eae715bffe69_large_a308a17c-e5c2-4e2a-a824-464499a9db07.jpg?v=1787417878",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "trehalose",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 20.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790775111877",
      "vsf_explanation": "Trehalose is a non-reducing disaccharide with in vitro evidence for autophagy induction (Sarkar 2007) via TFEB. Human oral bioavailability is limited by intestinal trehalase, meaning ingested trehalose is largely hydrolyzed to glucose before reaching cells. Popular in longevity/autophagy stacks but human outcome evidence is minimal. Category ceiling limits this to mid-Standard until oral human trials emerge.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "probiotic-complex",
      "title": "Probiotic Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d99f45e2-d62d-4e9a-85bb-986d3d203b01_large_1da556aa-ab1b-4c9c-b787-7466e1c50f3f.jpg?v=1787417900",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "probiotic",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 22.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790779470021",
      "vsf_explanation": "Generic multi-strain probiotic. Without strain identifiers (e.g., Lactobacillus rhamnosus GG, Bifidobacterium infantis 35624) or a stated CFU-at-expiration, this reads as a house-brand commodity blend. Multi-strain formulations can be useful, but effect claims in RCTs are strain-specific and non-transferrable across genera. Would move to Verified with strain-level ID, third-party CFU verification at expiration, and delayed-release delivery.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sensoril-ashwagandha",
      "title": "Sensoril Ashwagandha",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7f395f00-a49c-4e1f-81aa-98ee4ecc6114_large_12d16cca-5344-423e-8b57-bdca1962b788.jpg?v=1787417927",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sensoril",
        "ashwagandha",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 74,
        "formulation": 74,
        "manufacturing": 70,
        "safety": 68,
        "transparency": 72,
        "sustainability": 60
      },
      "price": 22.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790787629253",
      "vsf_explanation": "Sensoril is Natreon's branded ashwagandha standardized to 10% withanolides (root + leaf blend). RCT support for perceived stress at 125-250mg/day (Auddy 2008). Named branded extract at the studied form. Sits at low-Verified. Would move higher with the studied 125-250mg/day dose confirmed on-cap and thyroid safety guidance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-b12-hydroxycobalamin-mixed-berry-flavor",
      "title": "Vitamin B12 Hydroxycobalamin - Mixed Berry Flavor",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4e8e4a15-8606-4beb-89e8-2b3e89733a7b_large_4e6cd647-4f76-4f3d-bbed-af76b3aa8319.jpg?v=1787417927",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "b12",
        "hydroxycobalamin",
        "mixed",
        "berry",
        "flavor",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 72,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 15.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790787760325",
      "vsf_explanation": "Hydroxycobalamin is a well-supported B12 form with better retention than cyanocobalamin (Thakkar & Billa 2015 review), used clinically as intramuscular therapy and sublingually. Sublingual/liquid delivery is a legitimate route bypassing intrinsic factor issues (relevant for autoimmune atrophic gastritis and older adults). Held below Verified by lack of named-source B12, no third-party certification, and unclear mcg per serving. Would move to Verified 70+ with clear mcg dose, cofactor pairing (folate/B6), and independent COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lyc-o-mato-lycopene-maximum-strength",
      "title": "Lyc-O-Mato Lycopene - Maximum Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/39e28e79-8c7a-48d7-9657-58e39980aac0_large_87d8164c-0ad4-4c96-ae26-825d39c91f21.jpg?v=1787417927",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lyc",
        "mato",
        "lycopene",
        "maximum",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 23.7,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790787662021",
      "vsf_explanation": "Lyc-O-Mato (branded lycopene from LycoRed) is the extract used in most cardiovascular and prostate lycopene RCTs (Ried 2011 meta-analysis, modest systolic BP reduction at ≥15 mg/day). Naming the branded extract at label is a formulation positive. Maximum Strength typically implies 20-30 mg. Would move to Verified 70+ with dose match to Ried meta-analysis and USP/NSF cert.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sunactive-iron-non-irritating",
      "title": "SunActive Iron - Non-Irritating",
      "vendor": "SunActive",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/871e601c-d106-44cd-9cc4-c0783a1d9810_large_eebe8a4f-3171-49f0-81f5-09166e771475.jpg?v=1787417927",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sunactive",
        "iron",
        "non",
        "irritating",
        "sunactive"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 74,
        "manufacturing": 68,
        "safety": 74,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 13.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790787727557",
      "vsf_explanation": "SunActive Fe is a branded microencapsulated ferric pyrophosphate iron with published tolerability data — reduced GI irritation compared to ferrous sulfate/fumarate (Fidler 2004) makes it a good option for iron-deficiency-prone individuals who cannot tolerate standard iron. Named branded raw material lifts this to low Verified. Would move higher with disclosed elemental iron, alt-day dosing guidance (Stoffel 2017), and third-party assay.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pycnogenol-super-strength",
      "title": "Pycnogenol - Super Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fd2083ba-8a1e-4e72-886d-32861c93957f_large_d4684113-046d-4316-bd31-dca539fb117d.jpg?v=1787417927",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pycnogenol",
        "super",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 72,
        "manufacturing": 65,
        "safety": 70,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 41.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790787793093",
      "vsf_explanation": "Pycnogenol (branded French maritime pine bark, Horphag Research) is one of the most-studied polyphenol extracts, with RCTs for endothelial function (Nishioka 2007), venous insufficiency (Belcaro 2015 meta), and blood pressure (Liu 2004) at 100-200 mg/day. Naming Pycnogenol at label carries genuine formulation quality — Horphag maintains supply chain and standardization. 'Super Strength' likely 150-200 mg matches studied high-dose protocols. Would move to Elite with USP/NSF cert.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sleep-formula-with-l-theanine-and-melatonin",
      "title": "Sleep Formula with L-Theanine and Melatonin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4bbb2f17-2bc6-46a6-9e30-53448faa7a26_large_e1023520-65b8-406f-a31d-98dce6af59ac.jpg?v=1787417927",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "cognitive",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sleep",
        "formula",
        "with",
        "theanine",
        "and",
        "melatonin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 16.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790787858629",
      "vsf_explanation": "Combination of L-theanine + melatonin is a common OTC sleep template. L-theanine at 100-200mg has evidence for sleep-onset and subjective sleep quality (Rao 2015), and melatonin at physiological doses (0.3-1mg) improves sleep latency (Auld 2017 meta). Swanson sleep formulas historically use 3-5mg melatonin - well above the physiological range needed - without disclosing that lower doses match endogenous secretion better. No morning-grogginess or teen-use warnings visible. Would move to Verified 70+ with a physiological 0.5-1mg melatonin dose and explicit chronotype/duration guidance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pregnenolone-super-strength",
      "title": "Pregnenolone - Super Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2e8ffeeb-dde6-4d52-adbc-40af5d8aad38_large_13e3800b-d649-43cd-8990-44fb1007f076.jpg?v=1787417927",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pregnenolone",
        "super",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790787694789",
      "vsf_explanation": "Higher-dose pregnenolone (typically 50-100mg) from Swanson. Pregnenolone is an upstream neurosteroid precursor to progesterone, DHEA, and downstream sex hormones, but modern RCTs for cognitive and mood claims have been largely null (Osuji 2010, Marx 2014 for bipolar depression showed only modest signals). Higher-strength dosing amplifies safety concerns — pregnenolone can shift the whole steroid hormone axis, and chronic use should be lab-monitored. Manufacturing is standard Swanson without visible third-party testing. Would move to Verified 70+ only with clear safety guidance for lab monitoring, contraindications for hormone-sensitive cancers, and stronger evidence framing acknowledging the null RCT literature.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "senior-muscle-retention-whey-protein-powder-chocolate",
      "title": "Senior Muscle Retention Whey Protein Powder - Chocolate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/878d2577-e7a0-4bcd-8bfa-ac13830469db_large_f1803231-c4bd-4de6-b28f-ae16e50e5e5d.jpg?v=1787417928",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "adults_50_plus",
      "tokens": [
        "senior",
        "muscle",
        "retention",
        "whey",
        "protein",
        "powder",
        "chocolate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 34.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790787924165",
      "vsf_explanation": "Whey protein aimed at sarcopenia prevention — the evidence base is strong (Bauer 2013 PROT-AGE consensus recommends 1.0-1.2g/kg/day protein for older adults with leucine-rich sources). Effectiveness for older adults requires ~30g protein per serving with ~2.5-3g leucine to overcome the anabolic resistance seen with aging (Katsanos 2006). Without confirming per-serving protein and leucine on the label this stays Standard. Would move to Verified 70+ with grass-fed whey isolate base, ≥30g protein and ≥2.7g leucine per serving disclosed, and NSF certification. Chocolate flavoring often means added sugar / artificial sweeteners that need scrutiny.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "marine-magnesium-featuring-simag",
      "title": "Marine Magnesium - Featuring Simag",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4ee82c00-fb2a-47d5-ae06-5979c19ba38c_large_c9f05d4f-67a8-4996-9e94-60088c522ccc.jpg?v=1787417927",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "marine",
        "magnesium",
        "featuring",
        "simag",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 65,
        "sustainability": 62
      },
      "price": 15.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790787956933",
      "vsf_explanation": "Simag / marine magnesium is a seawater-derived magnesium hydroxide/oxide/chloride blend marketed with 76 trace-mineral content. Marine sources have modest absorption data but no head-to-head advantage vs glycinate has been demonstrated in RCTs. Named-source raw material is a plus. Upper Standard tier — legit but niche. Would move to Verified with published absorption/RCT data and elemental dose disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cranberry-whole-fruit-concentrate-super-strength",
      "title": "Cranberry Whole Fruit Concentrate - Super Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8b694e15-06d2-4ca9-9a28-39a7da44015f_large_29626641-5a04-4395-ac95-866e8b813bef.jpg?v=1787417927",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cranberry",
        "whole",
        "fruit",
        "concentrate",
        "super",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 58,
        "sustainability": 52
      },
      "price": 12.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790787825861",
      "vsf_explanation": "Cranberry has modest evidence for UTI prevention in recurrent-UTI women (Jepson 2012 Cochrane update; effect size small and inconsistent). The active constituents are proanthocyanidins (PACs) — clinically studied products deliver 36 mg PAC/day (BL-DMAC method). 'Super Strength' concentrate without PAC standardization means efficacy is unverifiable at the label. Would move to Verified 70+ with 36 mg PAC standardization per serving.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-b12-supplemelts",
      "title": "Vitamin B12 Supplemelts",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c057d36d-90c7-4e61-a19b-455ccef414e5_large_f642c5a3-74ad-4965-812a-d761972da152.jpg?v=1787417927",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "b12",
        "supplemelts",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 18.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790787891397",
      "vsf_explanation": "'Supplemelts' is Swanson's dissolvable format — a legitimate sublingual-adjacent delivery that improves compliance in older adults. Efficacy depends heavily on B12 form (cyanocobalamin vs methyl vs hydroxo), which the SKU title does not disclose, and on mcg dose. Held below Verified by ambiguous form and dose from the title alone, standard mass-market manufacturing, and typical sweetener/binder additions in dissolvable format. Would move to Verified 70+ with methyl- or hydroxycobalamin disclosure and clear per-tablet mcg.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dynamic-balance-blend-soil-based-organisms",
      "title": "Dynamic Balance Blend Soil-Based Organisms",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/31cfc4ec-0da9-44f1-9e12-bf7e1aec69cb_large_3fdda755-f929-4e96-a8ac-d5552d93871a.jpg?v=1787417927",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dynamic",
        "balance",
        "blend",
        "soil",
        "based",
        "organisms",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 15.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790787989701",
      "vsf_explanation": "Soil-based organism (SBO) probiotics — typically Bacillus subtilis, coagulans, clausii — have some spore-form survival advantage over Lactobacillus. Evidence for Bacillus coagulans in IBS/gas (Kalman 2009) is modest. SBOs raise a safety flag in immunocompromised patients (occasional bacteremia reports). Swanson doesn't disclose per-strain CFU or exact species mix on the title. Would need strain identification, CFU/serving, and immunocompromised caution to move up.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "activated-b12-complex-natural-cherry-flavor",
      "title": "Activated B12 Complex - Natural Cherry Flavor",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3b45313f-aa80-45b2-ba0c-2db656cc3f1d_large_00dea6a3-180d-4380-919d-521bb2daa23f.jpg?v=1787417927",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "activated",
        "b12",
        "complex",
        "natural",
        "cherry",
        "flavor",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 74,
        "formulation": 74,
        "manufacturing": 65,
        "safety": 70,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 8.68,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790788907205",
      "vsf_explanation": "'Activated' language typically indicates methylcobalamin (or a mix including adenosylcobalamin) plus bioactive folate (5-MTHF), the appropriate forms for individuals with MTHFR/MTRR polymorphisms (Obeid & Herrmann 2012). Combined with sublingual delivery, this is a reasonable low-Verified product. Held below Elite by absence of named-source folate (Quatrefolic/Metafolin), no third-party certification, and typical Swanson mass-market QC transparency. Would move to Verified 75+ with a disclosed folate source and independent COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lutein-bilberry",
      "title": "Lutein & Bilberry",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8c052f11-6468-4eda-8c3d-a1705a984349_large_4bcd4ab8-88ae-4f5c-8586-44d6785103d7.jpg?v=1787417927",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lutein",
        "bilberry",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 16.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790789005509",
      "vsf_explanation": "Same formulation category as the sibling Lutein & Bilberry SKU. Lutein (AREDS2 10 mg) plus bilberry anthocyanins is a coherent macular-support pairing. Weakness is per-active mg not visible on the label, so alignment with AREDS2 dosing is unverifiable. Would move to Verified 70+ with named-source lutein (e.g., FloraGLO), 25% anthocyanin bilberry standardization, and third-party assay disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "shark-liver-oil",
      "title": "Shark Liver Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3fc77c78-de10-404b-baba-e433e763fcd3_large_294c7ed6-68e8-4589-93c9-4fba0d0a0473.jpg?v=1787417927",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shark",
        "liver",
        "oil",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 52,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 58,
        "sustainability": 30
      },
      "price": 12.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790788874437",
      "vsf_explanation": "Shark liver oil supplies alkylglycerols and squalene, with a small Brohult 1978 trial suggesting immune modulation in radiation patients. Modern evidence is thin. Serious sustainability concerns — shark liver oil is often sourced from deep-sea sharks (gulper, dogfish) that are heavily overfished; shark-free squalene alternatives exist from olive oil and yeast fermentation. Sustainability floor pulls this to low Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "genistein-from-sophora-japonica-soy-free",
      "title": "Genistein from Sophora Japonica - Soy Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a1a641b5-5f4c-48c5-80fe-72c60b7e8fb5_large_45339da9-555b-438f-aa11-c0f9c61081ca.jpg?v=1787417927",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "genistein",
        "from",
        "sophora",
        "japonica",
        "soy",
        "free",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 29.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790788939973",
      "vsf_explanation": "Genistein isoflavone has RCT support for menopausal bone density (Marini 2007, 54 mg/day 24 months) and hot flash reduction (D'Anna 2007). Sourcing from Sophora japonica bypasses soy allergen issues — a real formulation positive. Estrogenic activity means breast-cancer-history contraindication that must be disclosed. Would move to Verified with 54 mg dose match, USP cert, and estrogenic-effect medication cautions.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "phosphatidylserine-soy-free-formula",
      "title": "Phosphatidylserine Soy-Free Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/455bd7cd-1ed4-4811-815d-35366fd2a061_large_51e114b0-42a4-4538-9929-15d4cec2d9b5.jpg?v=1787417928",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "phosphatidylserine",
        "soy",
        "free",
        "formula",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 70,
        "manufacturing": 65,
        "safety": 72,
        "transparency": 66,
        "sustainability": 60
      },
      "price": 38.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790788972741",
      "vsf_explanation": "Soy-free (typically sunflower-derived) phosphatidylserine is the preferred format for allergen-sensitive users and matches the material now used in most modern PS studies. PS at 100-300mg has RCT support for age-related cognitive decline (Kato-Kataoka 2010) and cortisol modulation with exercise stress (Starks 2008). Sunflower PS is more expensive than soy PS, so the reformulation is a genuine upgrade. Held below Verified by generic manufacturing footprint and no COA. Would move to Verified 70+ with disclosed source (Sharp-PS Green or similar), per-lot testing, and explicit 100/300mg dose guidance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "spirulina-blue-green-algae-standardized",
      "title": "Spirulina Blue-Green Algae - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ff0a141e-a1f5-4108-b4cd-cb5fc46490c4_large_b425bbe3-aec1-4fde-8d6a-dac3f4024d93.jpg?v=1787417928",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "spirulina",
        "blue",
        "green",
        "algae",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 64,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 64,
        "sustainability": 62
      },
      "price": 9.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790789038277",
      "vsf_explanation": "Standardized spirulina — a nutrient-dense blue-green algae with real evidence for lipid profile (Serban 2016 meta showed 8-16g/day improved LDL and triglycerides) and modest evidence for exercise recovery (Kalafati 2010). 'Heavy metal detox' claims that often accompany spirulina are unsubstantiated. Spirulina itself can be contaminated with microcystins (hepatotoxins) if sourced from open ponds — the reference-standard sources are Cyanotech Hawaiian Spirulina and Parry Nutraceuticals (India). Held at Standard because Swanson does not name a branded contamination-tested source. Would move to Verified 70+ with Cyanotech or Parry sourcing named.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "triple-strength-melatonin-100-drug-free",
      "title": "Triple Strength Melatonin - 100% Drug Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/807f83f2-9b34-4147-8f33-c71bd45edd55_large_896c9e87-9327-42b3-86e0-3b81b37eb57b.jpg?v=1787417929",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "triple",
        "strength",
        "melatonin",
        "100",
        "drug",
        "free",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 52,
        "manufacturing": 60,
        "safety": 50,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790789136581",
      "vsf_explanation": "Triple-strength melatonin - typically 10mg or higher, which is roughly 30x the physiological 0.3mg dose that Auld 2017 meta and Zhdanova 2001 support as most consistent with endogenous secretion and effective for sleep-onset. Higher doses are associated with more morning grogginess, vivid dreams, and desensitization risk with chronic use, and the '100% drug free' framing implicitly downplays that melatonin IS a hormone. No morning-grogginess or dose-caution note. Would move to Verified 70+ by dropping to 0.5-1mg and adding physiological-dose rationale.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ubiquinol-100-mg",
      "title": "Ubiquinol 100 mg",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6cfe90b9-be23-4b1b-b125-8cd8edc4fcc4_large_90380e36-afd5-4b23-a001-818fde00f74c.jpg?v=1787417929",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ubiquinol",
        "100",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 65.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790789169349",
      "vsf_explanation": "100 mg ubiquinol is the standard daily dose used in mitochondrial and statin-myalgia research (Skarlovnik 2014). Reduced ubiquinol is preferable to conventional ubiquinone for users over roughly 40, whose endogenous conversion capacity has declined. Held below Verified because Kaneka QH source is not named on the SKU and no per-lot analytical COA is published. Would move to Verified 72+ with disclosed Kaneka QH source and third-party assay.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ubiquinol-50-mg",
      "title": "Ubiquinol 50 mg",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7f296809-4f6b-40c8-9f15-d06503d7c134_large_00ef5bdd-49da-4a4c-834f-86cda34da84d.jpg?v=1787417929",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ubiquinol",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 66,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 18.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790789202117",
      "vsf_explanation": "Ubiquinol 50 mg is at the low end of the studied dose range; most published mitochondrial and statin-myalgia protocols use 100-200 mg (Skarlovnik 2014). The reduced form has meaningfully better bioavailability than ubiquinone for adults over 40, so 50 mg is a reasonable entry-level dose but likely under-serves users with an active clinical goal. Also held below Verified because Kaneka QH sourcing is not named. Would move to Standard 66-68 with confirmed Kaneka QH source; a 100 mg or higher SKU would be the better product for most users.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fenugreek-extract-featuring-testofen",
      "title": "Fenugreek Extract - Featuring Testofen",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8008e5f2-0eab-4a1f-8a2e-da5754d68e35_large_043ed69e-9667-4469-9c2a-e4a2b9a0d957.jpg?v=1787417930",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fenugreek",
        "extract",
        "featuring",
        "testofen",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 33.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790790217925",
      "vsf_explanation": "Testofen is a branded 50% fenusides fenugreek extract with RCTs (Wankhede 2016; Rao 2016) showing modest free-testosterone and libido improvement at 600 mg/day in middle-aged men. Naming the branded standardized extract at label is a real formulation positive. Fenugreek can interact with anticoagulants and lower blood glucose — needs explicit medication caution. Would move to Verified 70+ with USP cert and drug-interaction disclosure at label.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "red-yeast-rice-coq10-with-milk-thistle-and-alpha-lipoic-acid",
      "title": "Red Yeast Rice & CoQ10 with Milk Thistle and Alpha Lipoic Acid",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1cd8dda4-2f74-48ee-a89e-5f0cb08a5c99_large_fa1927c2-1b79-4347-bada-c17705a873dc.jpg?v=1787417930",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "yeast",
        "rice",
        "coq10",
        "with",
        "milk",
        "thistle",
        "and",
        "alpha",
        "lipoic",
        "acid",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 32,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 27.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790790250693",
      "vsf_explanation": "Red Yeast Rice contains monacolin K, which is structurally identical to lovastatin, so pairing it with CoQ10, milk thistle and ALA is a reasonable statin-mimic support formula on paper. Evidence supports monacolin for LDL reduction (Gerards 2015 meta-analysis), but real-world monacolin content varies dramatically between batches and manufacturers (Cohen 2017), and the FDA has repeatedly warned that supplements containing monacolin K equivalent to lovastatin are drugs. The safety score is depressed because the formula does not carry a prominent do-not-combine-with-prescription-statin warning on the SKU listing. Would move to Standard 65+ with disclosed monacolin K content, citrinin-free certification, and a clear statin-interaction warning. This is unregulated, drug-equivalent exposure with no third-party assay on record — held at Rejected under safety_concern until monacolin K and citrinin testing plus a prominent statin-interaction warning are published.",
      "vsf_autofail_rule": "safety_concern"
    },
    {
      "handle": "ubiquinol-100-mg-1",
      "title": "Ubiquinol 100 mg",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/98f7c8d6-1fca-47de-9c7d-d3fd8c44bae7_large_eef2d1de-55a9-4847-aa76-b141b204ced9.jpg?v=1787417931",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ubiquinol",
        "100",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 95.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790790283461",
      "vsf_explanation": "100 mg ubiquinol daily is the workhorse dose used in most published trials of the reduced form for age-related mitochondrial support and statin-associated myalgia (Skarlovnik 2014). The reduced form matters most for users 40+ whose conversion capacity has dropped. Product is held below Verified because the listing does not name Kaneka QH sourcing (the industry reference material with the bulk of published pharmacokinetic data) and does not publish per-lot COAs. Would move to Verified 72+ with named Kaneka QH sourcing and third-party purity testing shown on the SKU.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ubiquinol-100-mg-2",
      "title": "Ubiquinol 100 mg",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e79dba09-f340-4d2d-9821-df39e108d0b4_large_85e31cff-fd27-4699-8858-13b60b9b44fc.jpg?v=1787417930",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ubiquinol",
        "100",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 33.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790790348997",
      "vsf_explanation": "Same core formula as the primary Ubiquinol 100 mg SKU — the reduced form of CoQ10 at a dose consistent with published human trials for statin-adjacent myopathy and mitochondrial support in older adults (Skarlovnik 2014). Reduced ubiquinol offers meaningful bioavailability advantage over conventional ubiquinone for adults 40+. Held below Verified because Kaneka QH sourcing is not confirmed on the listing and no per-lot COA is published. Would move to Verified 72+ with disclosed Kaneka QH source and third-party purity testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "tea-tree-oil-facial-toner-alcohol-free-with-witch-hazel",
      "title": "Tea Tree Oil Facial Toner - Alcohol Free with Witch Hazel",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7dfd01d5-836d-4349-a412-bce5088603d4_large_645b3ffb-fdb2-4397-9daf-dd3dc33d6f48.jpg?v=1787417930",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tea",
        "tree",
        "oil",
        "facial",
        "toner",
        "alcohol",
        "free",
        "with",
        "witch",
        "hazel",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 4.68,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790790316229",
      "vsf_explanation": "Facial toner is a cosmetic product with very brief skin-contact time. Tea tree at ~5% has small acne evidence (Bassett 1990) but toner formats don't achieve studied concentration. Alcohol-free with witch hazel is a mild formulation positive over astringent alternatives. Category ceiling and lack of tea tree % disclosure keep this below Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "r-fraction-alpha-lipoic-acid-triple-strength",
      "title": "R-Fraction Alpha Lipoic Acid - Triple Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4e08838d-7e60-432a-8a4a-66fd70c8daaf_large_a6c4e57d-dedc-4a4d-9605-13b7b326f5fa.jpg?v=1787417931",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fraction",
        "alpha",
        "lipoic",
        "acid",
        "triple",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790790381765",
      "vsf_explanation": "R-alpha-lipoic acid (R-ALA) is the biologically active enantiomer, ~2x more bioavailable than the racemic S/R mix. Studied at 600 mg for diabetic peripheral neuropathy (Ziegler 2011). 'Triple Strength' suggests ~300-600 mg per serving which matches studied protocol. Swanson doesn't disclose whether stabilized (Na-R-ALA) form, which matters for shelf stability. Would move to Verified 70+ with sodium R-ALA stabilization and USP-verified purity.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "glucosamine-chondroitin-timed-release-featuring-truflex",
      "title": "Glucosamine & Chondroitin Timed-Release - Featuring TruFlex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/94575947-516f-4c8f-be8a-bae8d0ec7734_large_8c4ee37c-aa05-42b8-bce6-bdaec3b87ffb.jpg?v=1787417931",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glucosamine",
        "chondroitin",
        "timed",
        "release",
        "featuring",
        "truflex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 70,
        "manufacturing": 64,
        "safety": 70,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 20.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790790414533",
      "vsf_explanation": "Glucosamine plus chondroitin with the TruFlex branded chondroitin (a named-source ingredient — a plus) in a timed-release delivery. GAIT trial (Clegg 2006) showed the combination helped moderate-to-severe OA at 1500 mg glucosamine + 1200 mg chondroitin/day; timed-release framing has thin clinical support but no harm. Held below Verified by uncertainty on glucosamine salt (sulfate vs HCl) and no third-party purity disclosure — chondroitin has historically had adulteration issues (Volpi 2007). Would move to Verified 70+ with explicit sulfate labeling and COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "australian-tea-tree-oil",
      "title": "Australian Tea Tree Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/75c3d642-8051-4290-9b70-488ce55bee0a_large_f069b581-14c4-49e6-8597-266e5732f13d.jpg?v=1787417933",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "australian",
        "tea",
        "tree",
        "oil",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 62,
        "sustainability": 45
      },
      "price": 7.2,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790791332037",
      "vsf_explanation": "Australian tea tree oil (Melaleuca alternifolia) has RCT support for mild acne (Bassett 1990) and tinea pedis (Satchell 2002) at 5-10% topical. Australian source is the higher-terpinen-4-ol quality standard (should be >30%, cineole <15% per ISO 4730). Swanson doesn't disclose terpinen-4-ol %. Would move to Verified with ISO 4730 certification and terpinen-4-ol % on label.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ultimate-carb-control-c-120x-from-white-kidney-bean-extract",
      "title": "Ultimate Carb Control C-120X from White Kidney Bean Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3fc97d89-7a36-4c1b-9781-0425ada16c30_large_01042ee5-7ed8-4de0-9a95-be52c1d6e7ed.jpg?v=1787417933",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ultimate",
        "carb",
        "control",
        "120x",
        "from",
        "white",
        "kidney",
        "bean",
        "extract",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 58,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 29.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790791364805",
      "vsf_explanation": "White kidney bean extract (Phaseolus vulgaris) inhibits alpha-amylase to reduce starch absorption. Meta-analyses (Onakpoya 2011) show modest weight-loss effect (~1.3 kg vs placebo) at 445-2500 mg/day. Effect is small, transient, and depends on high-carb meal timing. Would need C-120X branded proof and studied 445 mg with-meal dose disclosed to move up modestly.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "uc-ii-standardized-collagen",
      "title": "UC-II Standardized Collagen",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ca2524d5-2a92-4376-94af-cd2632c84be3_large_7cf03ef8-b06c-476d-bda4-1b2661728d4a.jpg?v=1787417933",
      "score": 73,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "standardized",
        "collagen",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 76,
        "formulation": 78,
        "manufacturing": 68,
        "safety": 74,
        "transparency": 74,
        "sustainability": 58
      },
      "price": 31.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790791397573",
      "vsf_explanation": "Named-source UC-II (undenatured type II collagen from Lonza) at what is almost certainly the studied 40 mg/day dose — this is the correct clinical form. Lugo 2016 (JISSN) demonstrated UC-II 40 mg outperformed glucosamine 1500 mg + chondroitin 1200 mg for OA knee pain and function over 180 days; Crowley 2009 showed benefit vs placebo. Named clinical ingredient plus adequate dose is why this clears Verified. Held below Elite by no third-party COA disclosure and mid-tier retailer manufacturing. Would move to 80+ with USP or NSF certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "triple-iodine-complex-high-potency",
      "title": "Triple Iodine Complex - High Potency",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d159d5e5-8973-4869-bf93-9611fdb868ba_large_c88f0da8-d452-406a-975d-1f07a79d3603.jpg?v=1787417934",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "triple",
        "iodine",
        "complex",
        "high",
        "potency",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 26.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790791626949",
      "vsf_explanation": "Triple iodine complexes typically combine potassium iodide, sodium iodide, and kelp-derived iodine, dosed 12.5mg (Lugol's-equivalent) — this is well above the RDA of 150mcg and can trigger thyroid dysfunction (Hashimoto flare, hyperthyroidism) in susceptible individuals (Leung 2014). Safety score is docked accordingly. Standard tier reflects a legit product for iodine-deficient users but requires medical guidance. Would move up with clear thyroid safety disclosure and lower dose option.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "australian-tea-tree-oil-1",
      "title": "Australian Tea Tree Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cfd7bb9b-9c02-4569-b10e-468cd8e65da1_large_c66a5327-d9b5-4955-bea9-27e64282915a.jpg?v=1787417934",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "australian",
        "tea",
        "tree",
        "oil",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 62,
        "sustainability": 45
      },
      "price": 19.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790791659717",
      "vsf_explanation": "Australian tea tree oil (Melaleuca alternifolia) has RCT support for mild acne (Bassett 1990) and tinea pedis (Satchell 2002) at 5-10% topical. Australian source is the higher-terpinen-4-ol quality standard (should be >30%, cineole <15% per ISO 4730). Swanson doesn't disclose terpinen-4-ol %. Would move to Verified with ISO 4730 certification and terpinen-4-ol % on label.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-glutathione-featuring-setria-glutathione-1",
      "title": "L-Glutathione - Featuring Setria Glutathione",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/77ac2327-e581-46e4-8b6a-f00bb343d268_large_caf4c07b-e05b-4901-9b61-1c0d35ae726d.jpg?v=1787417934",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glutathione",
        "featuring",
        "setria",
        "glutathione",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 74,
        "safety": 72,
        "transparency": 70,
        "sustainability": 58
      },
      "price": 19.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790791692485",
      "vsf_explanation": "Setria (Kyowa Hakko) is the branded, fermentation-derived reduced L-glutathione backed by Richie 2015 — the one oral glutathione RCT showing sustained rises in body glutathione stores at 250-1000 mg/day over six months. That study is why Setria is a real formulation upgrade over generic glutathione (which is largely broken down in the gut). Held at top of Standard rather than Verified because oral GSH still underperforms liposomal delivery and NAC precursor approaches for many indications, and Swanson's Setria capsules typically top out around 100-200 mg — below the Richie protocol. Would move to Verified 70+ at 500-1000 mg/day dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nattozimes-1",
      "title": "Nattozimes",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1c7f90da-4561-4232-8208-261c761e146d_large_01c877b7-a634-4aee-9434-04f414e80823.jpg?v=1787417935",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nattozimes",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 24.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790792413381",
      "vsf_explanation": "Nattozimes is a fungal-fermented protease blend marketed as a nattokinase alternative for fibrinolytic support. Actual nattokinase (from Bacillus subtilis natto) has small RCTs (Kurosawa 2015) for fibrinogen/blood pressure; whether Nattozimes replicates those effects is unclear because it's a different enzyme profile. Also carries a bleeding-risk safety consideration that needs explicit disclosure with anticoagulant users. Would need fibrinolytic activity units (FU) disclosure and independent replication to move up.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "suntheanine-l-theanine-1",
      "title": "Suntheanine L-Theanine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/26735a3c-bba8-415f-acde-f2034c1dcb22_large_7334ec81-6939-4bd8-88b2-e460a8ff25f2.jpg?v=1787417935",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "cognitive",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "suntheanine",
        "theanine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 74,
        "manufacturing": 72,
        "safety": 80,
        "transparency": 74,
        "sustainability": 55
      },
      "price": 16.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790792446149",
      "vsf_explanation": "Uses Suntheanine - Taiyo's enantiomerically pure L-theanine, the exact material used in most cognitive/stress RCTs (Kimura 2007 for stress-response attenuation; Higashiyama 2011 for attention). Being the branded, patented material is a meaningful upgrade over generic mixed D/L-theanine still sold in the category. Dose within the studied 100-200mg range is expected, safety is excellent, and interactions are minimal. Held below Elite by generic Swanson manufacturing footprint and no per-lot COA - moves to Verified 75+ with third-party heavy-metal testing published.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "tea-tree-oil-shampoo",
      "title": "Tea Tree Oil Shampoo",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7a4f8edf-9718-4072-8c29-ff0a04b6b1a4_large_40326931-44b4-4e17-9234-559e6624c030.jpg?v=1787417935",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tea",
        "tree",
        "oil",
        "shampoo",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 58,
        "sustainability": 45
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790792478917",
      "vsf_explanation": "Tea tree shampoo has one small RCT for mild-to-moderate dandruff (Satchell 2002, 5% tea tree, 4 weeks). Cosmetic haircare format has narrow biohacking supplement relevance and doesn't disclose tea tree oil %. Would need pharmaceutical-grade % disclosure to move up.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "tea-tree-oil-conditioner",
      "title": "Tea Tree Oil Conditioner",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33ab4bb1-32f4-48fe-9fcb-9fa5ebe819f6_large_515465fe-0d25-4231-b8e2-39c86f7bf7a8.jpg?v=1787417935",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tea",
        "tree",
        "oil",
        "conditioner",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 52,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790792511685",
      "vsf_explanation": "Tea tree conditioner is a cosmetic rinse-off product with very brief contact time; no meaningful RCT support for cosmetic conditioners. Category ceiling limits this well below Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-energy-trial-size",
      "title": "Pure Energy Trial Size",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SWU1072.jpg?v=1787417936",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "energy",
        "trial",
        "size",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 52,
        "sustainability": 45
      },
      "price": 2.75,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790792544453",
      "vsf_explanation": "Generic 'energy' blend with vague naming — energy formulas typically contain B-vitamins, caffeine, and adaptogens whose evidence varies widely. Without disclosed per-active dosing at label, this cannot be evaluated for whether ingredients hit studied thresholds. Trial-size sample vehicle carries a per-serving-cost and packaging-waste penalty. Would move to Verified 70+ only with full ingredient/dose disclosure and named branded actives.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hyaluronic-acid-complex-2",
      "title": "Hyaluronic Acid Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/109a2c2a-172c-40ec-831b-5c6744c7ba10_large_8daedfca-4b65-4921-a648-2fc6a2437531.jpg?v=1787417936",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hyaluronic",
        "acid",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 20.4,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790792577221",
      "vsf_explanation": "Oral hyaluronic acid complex — modest RCT support for joint comfort (Nelson 2015, Kalman 2008 at 80-200 mg/day) and skin hydration (Oe 2017). Generic Swanson HA without stated molecular weight (low-MW forms like Injuv absorb better) or named-source callout. Held below Verified by opaque HA source, unspecified dose in title, and 'complex' framing that usually implies adjunctive fillers. Would move to Verified 70+ with named low-MW HA (Injuv, ExceptionHYAL) and per-active mg disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "milk-thistle-advanced-enhanced-absorption",
      "title": "Milk Thistle Advanced Enhanced Absorption",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d6a2a481-f0f9-440c-9b39-1bed4e673bc7_large_e1bb29be-9de2-465f-be7d-b21ad01f82e7.jpg?v=1787417936",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "milk",
        "thistle",
        "advanced",
        "enhanced",
        "absorption",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 70,
        "manufacturing": 65,
        "safety": 74,
        "transparency": 62,
        "sustainability": 60
      },
      "price": 25.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790792642757",
      "vsf_explanation": "'Enhanced absorption' framing suggests phospholipid or phytosome delivery, which meaningfully improves silybin bioavailability (Kidd 2009) — the pharmacokinetically-limited step that keeps standard 80% silymarin capsules from consistently reaching therapeutic hepatic levels. Held to top of Standard rather than Verified because the title doesn't confirm which absorption technology (Siliphos vs proprietary) or the silymarin standardization percentage. Milk thistle safety profile is excellent; watch cytochrome interactions with drugs metabolized by CYP2C9. Would move to Verified 70+ with named phytosome carrier and silymarin percentage disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "synergistic-eye-health-lutein-zeaxanthin",
      "title": "Synergistic Eye Health - Lutein & Zeaxanthin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e2962eff-2186-45d6-835b-73a100b6543f_large_6fdebb55-89d2-4bc9-8c9e-7d68b6a1d1a2.jpg?v=1787417937",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "synergistic",
        "eye",
        "health",
        "lutein",
        "zeaxanthin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 16.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790792675525",
      "vsf_explanation": "Lutein + zeaxanthin at AREDS2 protocol doses (10 mg L, 2 mg Z) reduces AMD progression (Chew 2013). Naming both carotenoids at label is a formulation positive; per-serving mg and marigold source aren't disclosed on the title. Would move to Verified 70+ with AREDS2-dose match, source (marigold), and OmniActive/Kemin branded-supplier disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sytrinol",
      "title": "Sytrinol",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4a095b4d-787c-4b30-bf15-ec410789e73b_large_5b9182c5-5e88-4d46-9a4f-cdf9eeaf33c7.jpg?v=1787417937",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sytrinol",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 25.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790792708293",
      "vsf_explanation": "Sytrinol is a branded polymethoxylated flavone + tocotrienol blend with small industry trials (Roza 2007) showing modest LDL and triglyceride reduction at 300 mg/day. Named branded ingredient is a formulation positive. Independent replication is limited; not a first-line lipid intervention next to plant sterols or berberine. Would move to Verified with USP/NSF cert and independent lipid RCTs at studied dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "tart-cherry-melatonin-vegan",
      "title": "Tart Cherry & Melatonin - Vegan",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d9e623c8-ae07-458f-83c3-a01b46d79f19_large_bbc98246-28cf-4ecb-ad9c-8478e3041d2d.jpg?v=1787417937",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tart",
        "cherry",
        "melatonin",
        "vegan",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 62,
        "transparency": 64,
        "sustainability": 58
      },
      "price": 9.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790793593029",
      "vsf_explanation": "Tart cherry + melatonin combo. Tart cherry contains modest endogenous melatonin plus anthocyanins with small-trial evidence for sleep quality (Howatson 2012). Melatonin content in the added synthetic layer likely far exceeds the physiological 0.3-1mg range (Auld 2017 meta). Vegan capsule is a modest transparency plus. Would move to Verified 70+ with physiological melatonin dose, disclosed CherryPure or Montmorency identity, and anthocyanin content disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "tea-tree-oil-body-wash",
      "title": "Tea Tree Oil Body Wash",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3388820a-a3b9-4864-9b64-15ba2a8c4c6f_large_cc59aa9c-bb70-40fd-9184-f5206f1735d6.jpg?v=1787417939",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tea",
        "tree",
        "oil",
        "body",
        "wash",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 52,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 7.55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790793724101",
      "vsf_explanation": "Tea tree body wash is a topical cosmetic. Tea tree oil has small trials for acne (Bassett 1990) and tinea (Satchell 2002) at 5% concentration but body wash contact time is too brief for antimicrobial effect. Cosmetic format doesn't have biohacking supplement outcomes to score against. Category ceiling limits this well below Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "water-pill",
      "title": "Water Pill",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fc6342d2-3384-4ded-99f8-3e18bbfa6098_large_44a9a10c-4453-4948-85c0-f04d95e555c7.jpg?v=1787417939",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "water",
        "pill",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 52,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 52,
        "sustainability": 45
      },
      "price": 12.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790793756869",
      "vsf_explanation": "'Water pill' is a colloquial diuretic framing typically using dandelion, uva-ursi, buchu, juniper. Herbal diuretic effects are modest and short-lived; the framing risks masking edema of underlying pathology (cardiac, renal, hepatic) and interacting with prescription diuretics/potassium status. The generic 'Water Pill' naming without an accompanying medical caution treads close to unverified medical claims territory. Would need explicit contraindications, disclosed actives with mg, and clearer indication-language to be considered scored above Rejected.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lutein-bilberry-1",
      "title": "Lutein & Bilberry",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/aadf4c36-6cc6-4ae7-96f9-a453753d3fe5_large_bad65452-8acb-4b9c-93f5-ff1e23a99051.jpg?v=1787417940",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lutein",
        "bilberry",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 8.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790794739909",
      "vsf_explanation": "Lutein has strong evidence for macular pigment optical density and modest AMD-progression benefit (AREDS2 confirmed 10 mg/day lutein + 2 mg zeaxanthin). Bilberry adds anthocyanin antioxidants with weaker but supportive vision-microcirculation evidence. Combination product is sensible but this label does not disclose per-active mg on the title, so it may under-dose lutein below the AREDS2 threshold. Would move to Verified 70+ with 10 mg free-lutein disclosure, bilberry standardized to 25% anthocyanins, and USP verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "tea-tree-oil-shampoo-conditioner-combo-pack",
      "title": "Tea Tree Oil Shampoo & Conditioner Combo Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f781b330-2e8b-4013-8c03-0443b9bce6ad_large_d8d31d36-464e-4c90-a414-f62135ef4e53.jpg?v=1787417942",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tea",
        "tree",
        "oil",
        "shampoo",
        "conditioner",
        "combo",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 58,
        "sustainability": 45
      },
      "price": 25.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790794805445",
      "vsf_explanation": "Tea tree shampoo has one small RCT for mild-to-moderate dandruff (Satchell 2002, 5% tea tree oil, 4 weeks). Cosmetic haircare formats deliver only topical scalp effect and don't score on biohacking supplement dimensions. Combo pack format doesn't disclose tea tree oil %. Would need pharmaceutical-grade % disclosure to move up meaningfully within the beauty subcategory.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamins-d3-and-k2-with-strontium",
      "title": "Vitamins D3 and K2 with Strontium",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/98f555ba-ae24-43c8-9578-0a216b7fc14d_large_36d1d15b-cfd2-4063-a3bd-d69b41e818f1.jpg?v=1787417941",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamins",
        "and",
        "with",
        "strontium",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 72,
        "manufacturing": 62,
        "safety": 60,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 20.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790794838213",
      "vsf_explanation": "D3 + K2 stacking is well-founded — K2 (MK-4 or MK-7) directs calcium out of arteries and into bone (Knapen 2013, MK-7 180 mcg RCT). Strontium (typically ranelate or citrate) has bone-density evidence but was withdrawn from the EU market over cardiovascular risk concerns (Reginster 2014); its inclusion needs a caution. Swanson doesn't disclose D3 IU, K2 form (MK-4 vs MK-7), or strontium salt on the title. Would move to Verified 70+ with form disclosures and a strontium-cardiovascular caution.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "tonalin-cla-safflower-oil-blend-1",
      "title": "Tonalin CLA - Safflower Oil Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c5a51442-849e-4241-a106-f8d0cf839468_large_550a6da1-f778-4b14-94db-d6ac07e6ca53.jpg?v=1787417951",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tonalin",
        "cla",
        "safflower",
        "oil",
        "blend",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 10.22,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790798115013",
      "vsf_explanation": "Tonalin CLA is the most-studied branded conjugated linoleic acid, with a Whigham 2007 meta-analysis showing very modest (~0.09 kg/week) body fat reduction at 3.4 g/day — clinically minor. Some trials note insulin resistance and hepatic steatosis at high CLA doses. Safflower oil is a filler rather than an added active. Weight-loss claims outpace the effect size. Ceiling on this ingredient class is roughly Standard given the marginal evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "xanthigen-brown-seaweed-pomegranate-blend",
      "title": "Xanthigen Brown Seaweed & Pomegranate Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6f1f977f-323e-4cdd-af30-79a0656aed08_large_2fe48d7c-4ede-4cf4-a50d-36622e2c8c8e.jpg?v=1787417984",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "xanthigen",
        "brown",
        "seaweed",
        "pomegranate",
        "blend",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 11.45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790809649349",
      "vsf_explanation": "Xanthigen (fucoxanthin + pomegranate seed oil) has one industry-funded RCT (Abidov 2010) claiming weight/liver fat reduction in obese women, but the trial has never been replicated at scale. The mechanism (uncoupling protein activation) is plausible but human outcomes are weak. Swanson using the branded blend adds transparency; the evidence base itself remains the ceiling. Would need independent replication to move up beyond mid-Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zeaxanthin",
      "title": "Zeaxanthin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/01bc1ff4-6821-4dfb-96b2-b0738be7fd1e_large_c44485e3-ad57-43ff-8e9e-be7d86b27edf.jpg?v=1787417984",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zeaxanthin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790809551045",
      "vsf_explanation": "Isolated zeaxanthin is best evidenced as part of the AREDS2 macular protective combination (Chew 2013) at 2 mg/day alongside lutein 10 mg. Standalone zeaxanthin is less commonly studied than the lutein/zeaxanthin pair. Swanson doesn't disclose whether this is from OmniActive/Lutemax source or marigold extract, and 2 mg/serving vs 10 mg options matter. Would move to Verified with source naming and combined L/Z formulation matching AREDS2.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "uric-acid-cleanse",
      "title": "Uric Acid Cleanse",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/55c9bf54-5641-48a7-bb7c-8424013c3129_large_3180cebc-5fd7-4b07-be55-292d869dcde6.jpg?v=1787417984",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "uric",
        "acid",
        "cleanse",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 48,
        "manufacturing": 55,
        "safety": 45,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 17.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790809616581",
      "vsf_explanation": "'Uric Acid Cleanse' framing directly implies management of gout — a defined medical condition treated with allopurinol/febuxostat under physician supervision. The word 'cleanse' combined with a specific biomarker claim is exactly the FDA/FTC-flagged pattern for structure/function overreach. Elevated uric acid warrants medical workup for gout, kidney disease, or metabolic syndrome, not an OTC 'cleanse'. Even if the formula contains legitimate ingredients (tart cherry, celery seed), the naming crosses into disease-treatment territory without RCT support. Autofail: unverified_medical_claim.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "whole-food-multi-without-iron",
      "title": "Whole Food Multi without Iron",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/73e40d9b-8b47-4237-b32f-cc0640275f4c_large_83691a6a-2aba-42e3-a075-1ad5f634f536.jpg?v=1787417984",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "whole",
        "food",
        "multi",
        "without",
        "iron",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 10.88,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790809583813",
      "vsf_explanation": "Whole-food multivitamins deliver food-derived micronutrients typically with modest RDI-level doses. The 'without iron' formula is appropriate for men and post-menopausal women to avoid iron overload risk. Whole-food multi RCT evidence is limited but micronutrient sufficiency benefits are well-established (Blumberg 2018). Standard tier — legit formulation without methylated folate/B12 named at the title level. Would move up with disclosed methylfolate, methylcobalamin, and named-chelate mineral forms.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zinc-carnosine-featuring-pepzingi",
      "title": "Zinc Carnosine - Featuring PepZinGI",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/aaa07ad5-29e2-40bc-8e14-2d9c2915e13c_large_fa4a9d8b-e9e6-45f7-a999-9d15728c6848.jpg?v=1787417984",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zinc",
        "carnosine",
        "featuring",
        "pepzingi",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 76,
        "formulation": 74,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 23.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790809845957",
      "vsf_explanation": "PepZinGI is the branded zinc-L-carnosine complex with strong RCT evidence for gastric mucosal support and H. pylori adjunctive therapy at 75mg twice daily (Mahmood 2007; Miyoshi 1997). This is a well-characterized, well-studied ingredient — named-source branded raw material lifts this Swanson SKU into low Verified. Would move higher with disclosed elemental zinc content, third-party NSF verification, and combined data on healing rates.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-d3-with-coconut-oil-high-potency",
      "title": "Vitamin D3 with Coconut Oil - High Potency",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/019fa900-bbdb-799b-b6a7-742b71bcdc7e.jpg?v=1787417984",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "with",
        "coconut",
        "oil",
        "high",
        "potency",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 72,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 7.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790809714885",
      "vsf_explanation": "D3 in an MCT/coconut oil carrier supports absorption of the fat-soluble molecule (Mulligan & Licata 2010), and 'High Potency' typically implies 2000-5000 IU, an appropriate maintenance-to-correction range per Endocrine Society guidelines. Martineau 2017 BMJ meta-analysis supports respiratory-immune benefit at daily/weekly dosing. Held below Verified by absence of paired K2/A cofactors, no third-party certification, and standard rather than named-source cholecalciferol. Would move to Verified 70+ with K2-MK7 pairing, NSF/USP certification, and stated 25(OH)D testing guidance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-d3-boron-complex-features-fruitex-b",
      "title": "Vitamin D3 & Boron Complex - Features FruiteX-B",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d1717077-b846-4a4d-9a4d-b2c3740c469b_large_17f2f6fc-c11d-42f8-8200-08e1945c8ad6.jpg?v=1787417984",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "boron",
        "complex",
        "features",
        "fruitex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 74,
        "manufacturing": 65,
        "safety": 68,
        "transparency": 72,
        "sustainability": 60
      },
      "price": 5.8,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790809682117",
      "vsf_explanation": "FruiteX-B (calcium fructoborate) is a named-source, patented form of boron with human clinical evidence for joint/bone support (Reyes-Izquierdo 2012, Scorei 2011) and has better tolerability than sodium tetraborate. Pairing with D3 addresses bone/steroid-hormone synergy and is a legitimate combination. Named ingredient supplier and disclosed form pushes this to low-Verified. Held below Elite by lack of third-party certification and unclear per-tablet IU/mg splits without label view. Would move to Verified 75+ with published COAs and specific D3 IU + boron mg per serving.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitacholine-choline-bitartrate",
      "title": "VitaCholine Choline Bitartrate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6c2ff415-608a-4a91-b600-3e7be552d702_large_46dd49fa-03b5-4ba9-a46e-1db8a905640f.jpg?v=1787417984",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitacholine",
        "choline",
        "bitartrate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 70,
        "safety": 70,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 11.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790809780421",
      "vsf_explanation": "Uses Balchem's VitaCholine - a branded, kosher, pharmaceutical-grade choline bitartrate with a documented GRAS dossier, which is a real upgrade in transparency and quality control over generic choline bitartrate. Bitartrate salt is a workhorse choline source (approximately 41% choline by weight) - useful for meeting AI intake but crosses the BBB less efficiently than alpha-GPC or CDP-choline, so it is more a general choline-status supplement than a nootropic. Safety profile is favorable. Would move to Verified 70+ with a form upgrade to alpha-GPC or CDP-choline (better cognitive delivery) plus disclosed testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "coral-calcium-complex",
      "title": "Coral Calcium Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d3b4b90e-afe1-484f-90e8-18c13175ada9_large_68f27b30-a1c1-4118-8adc-fd001ed1debb.jpg?v=1787417984",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coral",
        "calcium",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 13.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790809747653",
      "vsf_explanation": "Coral calcium is essentially calcium carbonate with trace minerals; it was heavily marketed in the 2000s with unsupported claims and remains chemically similar to standard carbonate (~40% elemental Ca, absorption dependent on stomach acid). No unique clinical benefit over calcium citrate has been demonstrated. Sustainability is also a concern due to reef sourcing. Standard tier low end — legit calcium but overhyped category. Would not upgrade without RCT evidence over standard forms.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-b12-with-folate-sugar-free-strawberry",
      "title": "Vitamin B12 with Folate - Sugar-Free Strawberry",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7948a6f6-da05-45bd-bac9-fd5299f1fa60_large_79b47771-e893-4da2-84ad-b4fcbc086d6f.jpg?v=1787417984",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "b12",
        "with",
        "folate",
        "sugar",
        "free",
        "strawberry",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 3.72,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790809944261",
      "vsf_explanation": "B12+folate pairing has clear evidence for MTR/methylation support and homocysteine reduction (Homocysteine Lowering Trialists 2005), but form matters heavily: cyanocobalamin plus folic acid (both likely here given non-'methyl' naming) are inferior to methylcobalamin+5-MTHF, particularly in MTHFR polymorphism carriers (Obeid & Herrmann 2012). Sublingual lozenge format is a legitimate B12 delivery route. Held below Verified by likely non-methylated forms and unclear mcg dosing. Would move to Verified 70+ if reformulated with methylcobalamin + 5-MTHF (Quatrefolic/Metafolin) and explicit doses.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "e-400-with-selenium",
      "title": "E-400 with Selenium",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0bb668b0-a7f5-44ac-8473-7fff960e2d5e_large_e5966537-1847-4d55-b20e-3328e6bbe7d7.jpg?v=1787417984",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "400",
        "with",
        "selenium",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 12.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790809813189",
      "vsf_explanation": "Vitamin E 400 IU with selenium is a classic antioxidant pairing. Note SELECT trial (Lippman 2009) found no cancer-prevention benefit and possible prostate risk signal at 400 IU alpha-tocopherol; modern practice favors mixed tocopherols/tocotrienols. Selenium 200mcg has thyroid and antioxidant evidence (Rayman 2012). Standard tier — legit but outdated single-isoform E. Would move up with mixed tocopherols and lower E dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "actiponin-amp-k-stimulator",
      "title": "Actiponin AMP-K Stimulator",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8163450a-601b-43fc-882a-b6b1afd4cd62_large_0ae969fe-ecb7-491b-9c67-2d31144299e1.jpg?v=1787417984",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "actiponin",
        "amp",
        "stimulator",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 26.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790809878725",
      "vsf_explanation": "Actiponin (gynostemma pentaphyllum standardized extract) has one small Korean RCT (Park 2014) showing modest body-fat reduction at 450 mg/day tied to AMPK activation. Naming the branded extract at label is a formulation positive. Single-trial evidence base and AMPK-stimulator marketing outrun the human data. Would need independent replication and clearer dose disclosure to move up.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-potential-pre-workout-strawberry-lemonade",
      "title": "Full Potential Pre-Workout - Strawberry-Lemonade",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5ccebc66-5e25-4d0d-b487-1c8254e15e16_large_7594768b-8199-463e-bd5a-eba26fb1dc99.jpg?v=1787417984",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "potential",
        "pre",
        "workout",
        "strawberry",
        "lemonade",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 52,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 35.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790809911493",
      "vsf_explanation": "Pre-workout blend — evidence is category-strong for the core ingredients (caffeine 3-6mg/kg, beta-alanine 3-6g/day per Trexler 2015 ISSN stand, citrulline malate 6-8g per Wax 2015) but pre-workouts are notorious for proprietary blends that hide per-active dosing. Without confirming that each active is disclosed at studied dose, this can't score above Standard. Safety scrutiny for caffeine content (>200mg/serving warrants disclosure), and stimulant stacks warrant a cardiovascular caution. Would move to Verified 70+ with fully-transparent dose disclosure per active, and no proprietary blend.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zma-anabolic-mineral-support",
      "title": "ZMA Anabolic Mineral Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/938a4ba4-273c-4238-8a5a-cbb2e0f647c6_large_2e132d53-560d-4172-aa1f-48b2d5e4e838.jpg?v=1787417984",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zma",
        "anabolic",
        "mineral",
        "support",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 17.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790810140869",
      "vsf_explanation": "ZMA (zinc monomethionine + magnesium aspartate + B6) trademarked formula has one positive Brilla 2000 RCT for testosterone in college football players and a null Wilborn 2004 follow-up in trained men. Evidence for T-boosting in non-deficient adults is weak; primary benefit is likely correcting zinc/magnesium deficiency. Swanson using the licensed ZMA blend at studied doses (30 mg Zn, 450 mg Mg, 10.5 mg B6) is a formulation positive. Would move to Verified with published ZMA license confirmation and third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "glucosamine-msm-shellfish-free",
      "title": "Glucosamine & MSM - Shellfish Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8b5eec8c-48f8-429d-bd3e-644af9e7d6a2_large_1c7abc16-5d95-494d-a67a-54bb26ecf520.jpg?v=1787417984",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glucosamine",
        "msm",
        "shellfish",
        "free",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 63,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 10.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790809977029",
      "vsf_explanation": "Shellfish-free glucosamine (typically corn-fermented glucosamine HCl) paired with MSM — a common OA combination. Glucosamine HCl has weaker evidence than glucosamine sulfate for OA (Clegg 2006, Herrero-Beaumont 2007 favor sulfate); MSM has modest OA data at 1500-6000 mg/day (Kim 2006, Debbi 2011). Shellfish-free is a real safety win for allergic users. Held below Verified by likely HCl-form glucosamine and unstated MSM dose. Would move to Verified 70+ with switch to named vegan glucosamine sulfate and OptiMSM disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vegan-glucosamine-shellfish-free",
      "title": "Vegan Glucosamine Shellfish Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8c2ad4f6-fb6d-422a-bbfa-e9b10c4d54a9_large_c001e56a-b908-43e3-8816-acfb4d374d14.jpg?v=1787417984",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vegan",
        "glucosamine",
        "shellfish",
        "free",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 74,
        "transparency": 62,
        "sustainability": 60
      },
      "price": 5.81,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790810042565",
      "vsf_explanation": "Vegan (corn-fermented, typically Aspergillus niger) glucosamine, almost always the HCl salt rather than the better-studied sulfate form. Genuinely useful for shellfish-allergic users but evidence tilts weaker: Clegg GAIT 2006 and Herrero-Beaumont 2007 favored the sulfate salt at 1500 mg/day. Held below Verified by form choice and no named-brand ingredient callout (e.g., GreenGrown). Would move to Verified 70+ with explicit sulfate-form disclosure and clinical-dose statement.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "coral-calcium-complex-1",
      "title": "Coral Calcium Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/dfe21b5d-81f2-4cab-b222-60ee1e75c95d_large_d2f58ffd-515d-4b12-94a0-a2d006a4673c.jpg?v=1787417984",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coral",
        "calcium",
        "complex",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 8.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790810108101",
      "vsf_explanation": "Duplicate SKU of coral calcium complex — essentially calcium carbonate with trace minerals, no clinical superiority over citrate demonstrated (Straub 2007). Sustainability concerns for reef-sourced material. Standard tier low end. Would not upgrade without RCT differentiation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "whole-food-multi-without-iron-2-pack",
      "title": "Whole Food Multi without Iron - 2 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5865aa8a-18fa-4732-b6ed-585485b3b22d_large_6b9f0738-9f78-4d5f-9c01-389120521629.jpg?v=1787417984",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "whole",
        "food",
        "multi",
        "without",
        "iron",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 30.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790810075333",
      "vsf_explanation": "Same formulation as the single Whole Food Multi without Iron, sold as a 2-pack. Iron-free multi is appropriate for adult men and post-menopausal women (Zacharski 2007 on iron burden). Standard tier — food-derived micronutrients at modest RDI. Would move to Verified with methylated B forms and named-chelate minerals.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ultimate-ocular-antioxidant-featuring-lutemax-2020",
      "title": "Ultimate Ocular Antioxidant - Featuring Lutemax 2020",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/01a01b4d-0826-7aa5-8d23-7aeff6dbd4f5.jpg?v=1787417984",
      "score": 74,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ultimate",
        "ocular",
        "antioxidant",
        "featuring",
        "lutemax",
        "2020",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 78,
        "manufacturing": 72,
        "safety": 76,
        "transparency": 72,
        "sustainability": 60
      },
      "price": 25.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790810239173",
      "vsf_explanation": "Lutemax 2020 is OmniActive's branded marigold-derived lutein plus RR/RS-zeaxanthin isomer complex, backed by the LAMA (Stringham 2017) and B.L.U.E. trials on macular pigment, glare recovery and digital eye strain. Ocular-antioxidant framing here is legitimate for a product this specific. Score reflects the branded, standardized carotenoid carrier with real human data; held below Elite by generic Swanson manufacturing profile (no NSF/USP) and Ultimate line's tendency to add undisclosed 'complex' herbs. Would move up with per-lot COA and a clean single-active label.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-potential-pre-workout-blue-raspberry",
      "title": "Full Potential Pre-Workout - Blue Raspberry",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0cfed4df-b654-49b6-b6f1-aaf69e65c7a3_large_40337674-bfa2-4f60-90d5-30a0a0eb2067.jpg?v=1787417984",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "potential",
        "pre",
        "workout",
        "blue",
        "raspberry",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 35.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790810009797",
      "vsf_explanation": "Pre-workout blends typically stack caffeine, beta-alanine, citrulline, creatine, and 'nitric oxide' extras. Each active has RCT support (beta-alanine 3-6 g/d Trexler 2015; citrulline 6-8 g Bailey 2010) but pre-workouts routinely under-dose to fit marketing panels. Blue-raspberry flavor blends often include sucralose, artificial dyes, and undisclosed per-active mg. Would move to Verified with per-active mg disclosed, no proprietary blends, and third-party testing (Informed Sport ideal).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zinc-orotate-high-bioavailability",
      "title": "Zinc Orotate - High Bioavailability",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c087da5a-12eb-4632-8651-9bd5ec5d4e69_large_15b9dfd8-e084-4c00-849c-81aceba5f29c.jpg?v=1787417984",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zinc",
        "orotate",
        "high",
        "bioavailability",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 11.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790810173637",
      "vsf_explanation": "Orotate mineral forms are marketed with high-bioavailability claims but lack head-to-head RCT data supporting superiority over glycinate/picolinate/citrate; the Nieper hypothesis is not well-validated. Elemental zinc content per capsule is typically low (10-15mg) because orotate is a large carrier. Standard tier — legit but oversold form. Would not move up without head-to-head absorption data.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "deep-rest-stress-relief-featuring-karacalm",
      "title": "Deep Rest & Stress Relief - Featuring KaraCalm",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c9c5ee29-9d23-4ca7-9100-4b0ad5ed766f_large_cc2e3c8f-72c7-463d-a548-7e6ac0d2c425.jpg?v=1787417984",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "deep",
        "rest",
        "stress",
        "relief",
        "featuring",
        "karacalm",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 18.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790810206405",
      "vsf_explanation": "KaraCalm (branded Sceletium tortuosum / kanna extract) has small trials suggesting anxiolytic and stress-cortisol effects (Chiu 2014 at 25 mg Zembrin). Naming the branded ingredient at label is a formulation positive. Sceletium interacts with MAOI/SSRI medications — this needs explicit drug-interaction disclosure that isn't visible from the title. Would move to Verified 70+ with dose matched to the Zembrin/KaraCalm trial protocols and pharmacotherapy caution stated at label.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "turmeric-with-ginger-gummies-tropical-lemon",
      "title": "Turmeric with Ginger Gummies - Tropical Lemon",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f6fe7fda-601b-4630-8dce-912300cba89f_large_bdf4105b-fd76-4954-8d94-8e950f8a672f.jpg?v=1787417984",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "turmeric",
        "with",
        "ginger",
        "gummies",
        "tropical",
        "lemon",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 40,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 6.52,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790810271941",
      "vsf_explanation": "Turmeric gummies are a fundamentally poor delivery vehicle for curcuminoids: gummy matrices cannot carry the phytosome/piperine/liposomal carriers that are required to overcome curcumin's ~1% oral bioavailability (Anand 2007), and per-gummy actives are typically in the low tens of mg. Ginger adds palatability but the format prioritizes taste over pharmacology. Not autofail — the ingredients are legitimate — but formulation is structurally sub-therapeutic for the intended anti-inflammatory use. Consumers seeking a real curcumin effect should choose Meriva, C3 Complex + BioPerine, or liposomal formats instead.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "daily-antioxidant-boost",
      "title": "Daily Antioxidant Boost",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/704084f3-9de0-42ed-a554-6d8cb75ec076_large_930366f6-a761-49b2-8d33-5c76a3b47828.jpg?v=1787417984",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "daily",
        "antioxidant",
        "boost",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 4.6,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790810304709",
      "vsf_explanation": "Generic 'antioxidant boost' framing without a named lead active or standardization signal on the label is a red flag for a scattergun herbal blend. Antioxidant supplementation as a class has mixed to null evidence for chronic-disease endpoints (Bjelakovic 2012 meta-analysis) — the marketing category is weaker than most consumers assume. Held to low Standard because the concept is legitimate and Swanson's baseline manufacturing is acceptable, but without disclosed per-ingredient mg and standardization percentages this is difficult to distinguish from a filler blend. Would move up substantially with a single-active or named-branded ingredient anchor.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "creatine-monohydrate-6",
      "title": "Creatine Monohydrate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/51557fc9-48b5-4399-af36-37fa792ea8d8_large_7789e7b1-7336-4742-b12e-b7297bef6d84.jpg?v=1787417984",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "creatine",
        "monohydrate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 82,
        "formulation": 68,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 19.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790810337477",
      "vsf_explanation": "Plain creatine monohydrate at the studied 5g/day dose is the most evidence-supported ergogenic available (Kreider 2017 ISSN position stand). Swanson's SKU is competent but generic — Creapure sourcing is not named, no third-party COA is published, and there is no NSF Certified for Sport certification for athlete safety. Would move to Verified 70+ with Creapure sourcing or a published COA showing >99% creatine and no residual creatinine/dicyandiamide contaminants.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "anti-stress-lactium",
      "title": "Anti-Stress Lactium",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c5e71049-938f-4aa0-8ba9-acbbc9a35a72_large_36594d9f-f233-48eb-b9b0-323b0865e775.jpg?v=1787417984",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "anti",
        "stress",
        "lactium",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 31.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790810370245",
      "vsf_explanation": "Lactium (bioactive alpha-s1 casein hydrolysate) has multiple RCTs (Kim 2007; Messaoudi 2005) showing modest cortisol reduction and stress-perception improvement at 150 mg/day. Using the branded ingredient at studied dose is a strong formulation choice. Contains milk derivative — a safety flag for dairy allergy that Swanson generally lists. Would move to Verified 70+ with confirmed 150 mg dose match and independent third-party ID testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "telomere-advantage",
      "title": "Telomere Advantage",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9d53ac7f-e8a2-424f-91a4-98a24d536e91_large_5074faab-fa4c-4fe0-9e22-2825ce28e294.jpg?v=1787417988",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "telomere",
        "advantage",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 15.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790812303557",
      "vsf_explanation": "'Telomere' formulas typically combine astragaloside/cycloastragenol, antioxidants, and B vitamins with the marketing claim of telomerase activation. TA-65 (cycloastragenol) has small trials (Salvador 2016) suggesting mild senescent-cell reduction, but the framing of 'telomere length increase' from an oral supplement outruns the human evidence. Without per-active mg disclosure the claim/formulation gap is wide. Would need to name the exact activator and dose (and de-emphasize telomere-lengthening language) to move up.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "tmg-trimethylglycine",
      "title": "TMG Trimethylglycine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f78e2f70-2319-4b8d-a9f7-18e51f93005c_large_7b3934e9-a4ca-424e-97fc-1871a91dc0df.jpg?v=1787417989",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tmg",
        "trimethylglycine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790812336325",
      "vsf_explanation": "Trimethylglycine (betaine anhydrous) has consistent evidence for lowering homocysteine (Olthof 2005) at 3-6 g/day, and is used as a methyl donor alongside NMN/NR longevity protocols to buffer methyl depletion. TMG as a monoingredient is a clean, well-studied formulation. Swanson doesn't disclose mg/serving on the title; standard doses are 500-2000 mg. Would move to Verified 70+ with per-serving mg disclosure matching studied 3-6 g homocysteine protocols and USP/NSF certificate.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ultimate-liver-elixir-with-siliphos-milk-thistle-phytosome",
      "title": "Ultimate Liver Elixir with Siliphos Milk Thistle Phytosome",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/483c2713-36fe-453a-97ea-adb23bcb525b_large_f2c6edb2-b986-43f5-8f66-9b20903f4a31.jpg?v=1787417989",
      "score": 74,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ultimate",
        "liver",
        "elixir",
        "with",
        "siliphos",
        "milk",
        "thistle",
        "phytosome",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 76,
        "formulation": 80,
        "manufacturing": 72,
        "safety": 72,
        "transparency": 74,
        "sustainability": 60
      },
      "price": 29.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790812369093",
      "vsf_explanation": "Uses Siliphos, an Indena-patented silybin phytosome that raises silymarin bioavailability roughly 4-5x versus standard milk thistle extract (Kidd 2009). Silybin phytosome is the form used in most positive silymarin hepatology trials (Loguercio 2012), so this represents a genuine step above generic 80% silymarin capsules. The 'Ultimate' framing implies a full liver blend — score is calibrated to the named phytosome carrying the file. Would move to Elite 85+ only with published third-party COA per lot and cGMP/NSF certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "wild-shrimp-glucosamine-featuring-osamine",
      "title": "Wild Shrimp Glucosamine - Featuring Osamine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8191b994-e8fc-4b34-b672-de020aed7a49_large_de7b6ed4-f34f-423a-8633-da6e030b6c5b.jpg?v=1787417989",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wild",
        "shrimp",
        "glucosamine",
        "featuring",
        "osamine",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 68,
        "sustainability": 58
      },
      "price": 7.6,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790812401861",
      "vsf_explanation": "Glucosamine derived from wild-caught shrimp using the branded Osamine ingredient — a named-source play that adds sourcing transparency. Glucosamine evidence is modest for moderate-to-severe OA (Clegg GAIT 2006 was negative for mild OA but positive for the moderate-severe subgroup at 1500 mg/day); form matters (sulfate preferred over HCl) but sourcing spec is not stated at title. Shellfish allergen requires safety flag. Held below Verified by unclear glucosamine salt (sulfate vs HCl) and no visible third-party COA. Would move to Verified 70+ with explicit glucosamine sulfate labeling at 1500 mg/day.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vision-defense-eye-health-formula-featuring-lutemax-2020",
      "title": "Vision Defense Eye Health Formula - Featuring Lutemax 2020",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6ee5b9fe-85c6-4934-8fe3-6cee85c2f387_large_03576cd9-22ef-4375-befc-31386eab3a3b.jpg?v=1787417989",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vision",
        "defense",
        "eye",
        "health",
        "formula",
        "featuring",
        "lutemax",
        "2020",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 72,
        "manufacturing": 65,
        "safety": 68,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 44.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790812434629",
      "vsf_explanation": "Lutemax 2020 (OmniActive) is the branded lutein/zeaxanthin/meso-zeaxanthin complex used in the B.L.U.E. Study (Stringham 2017) showing macular pigment density, contrast sensitivity, and eye-strain improvements at 10 mg lutein + 2 mg zeaxanthin/day. Naming the branded ingredient at label is a real formulation and transparency positive. Would move to Elite with published USP/NSF cert and explicit L/Z mg matching the B.L.U.E. protocol.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "biotin-timed-release",
      "title": "Biotin - Timed-Release",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6441897e-cee5-467e-b34b-8e43f6ad9ef7_large_6f0c8bf2-cf56-4a93-a086-c123cf781b9b.jpg?v=1787417989",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "biotin",
        "timed",
        "release",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 8.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790812467397",
      "vsf_explanation": "Biotin has clinical evidence only in true deficiency (rare) and equivocal support for hair/nails at typical 2500-10000 mcg doses (Patel 2017 review). Timed-release provides no meaningful bioavailability advantage since biotin is already highly bioavailable orally. High-dose biotin is well-known to interfere with troponin, TSH, and other immunoassays (FDA Safety Communication 2017), which the safety score reflects when the label rarely warns. Held below Verified by weak effect-size evidence and lab-interference risk. Would move to Verified 70+ only with clear lab-interference warning and honest positioning around deficiency correction rather than cosmetic hair claims.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "turmeric-phytosome-with-meriva",
      "title": "Turmeric Phytosome with Meriva",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7232114f-4fe5-4b82-81d7-a824e28fe914_large_60853652-54ee-42d6-99a9-59e10f6d84a5.jpg?v=1787417989",
      "score": 76,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "turmeric",
        "phytosome",
        "with",
        "meriva",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 80,
        "formulation": 82,
        "manufacturing": 72,
        "safety": 74,
        "transparency": 76,
        "sustainability": 62
      },
      "price": 24.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790812532933",
      "vsf_explanation": "Meriva is an Indena-patented curcumin phytosome bound to soy phosphatidylcholine, with pharmacokinetic data showing ~29x bioavailability of total curcuminoids versus unformulated curcumin (Cuomo 2011) — one of the best-supported turmeric delivery forms in humans. Meriva-based trials include osteoarthritis pain (Belcaro 2010) and inflammatory-marker reductions, so this is a genuinely evidence-backed formulation choice. Swanson's generic curcumin lines don't approach this. Would move to Elite 85+ with a Meriva-standardized curcuminoid mg disclosure on-label plus per-lot third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-c-complex-with-bioflavonoids",
      "title": "Vitamin C Complex with Bioflavonoids",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/96a02fcd-eb78-4616-b53c-911d76cffdee_large_b25c66fb-1e9b-43aa-8b96-79751ee445a5.jpg?v=1787417989",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "complex",
        "with",
        "bioflavonoids",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 64,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 6.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790812500165",
      "vsf_explanation": "Ascorbic acid + citrus bioflavonoids has modest supporting evidence for absorption synergy (Vinson & Bose 1988), with vitamin C itself well-studied for immune duration/severity of upper respiratory infection (Hemila & Chalker 2013 Cochrane) at 200mg-1g/day. Bioflavonoid content is often small and unstandardized in mass-market SKUs. Held below Verified by unclear bioflavonoid mg content, standard ascorbic acid (not liposomal or Ester-C), and no third-party testing. Would move to Verified 70+ with standardized bioflavonoid mg, buffered or liposomal form, and named-source ascorbate.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ultimate-ashwagandha-ksm-66",
      "title": "Ultimate Ashwagandha - KSM-66",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/54fb574c-be67-48ab-936e-55d19ebfcda8_large_9e94a8c9-93ca-4afc-9dba-fd7089c03d69.jpg?v=1787417989",
      "score": 74,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ultimate",
        "ashwagandha",
        "ksm",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 76,
        "manufacturing": 72,
        "safety": 68,
        "transparency": 74,
        "sustainability": 60
      },
      "price": 14.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790812598469",
      "vsf_explanation": "KSM-66 is Ixoreal Biomed's clinically-validated ashwagandha extract standardized to 5% withanolides. This exact extract has multiple positive RCTs for cortisol reduction and perceived stress (Chandrasekhar 2012 for cortisol; Salve 2019). Named branded extract at the studied form. Sits at solid Verified. Would move to Elite with a 600mg/day serving spec explicitly matching the RCT dose and clear thyroid-monitoring safety guidance for autoimmune-thyroid patients.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "tendon-support-formula-featuring-tendaxion",
      "title": "Tendon Support Formula - Featuring Tendaxion",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/75246f28-30c0-42ab-8b4a-f5edc3d9996a_large_163693f4-e424-4023-8a6d-9831a29091a7.jpg?v=1787417989",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tendon",
        "support",
        "formula",
        "featuring",
        "tendaxion",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 16.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790812565701",
      "vsf_explanation": "Tendaxion is a branded blend (mucopolysaccharides + Vitamin C + manganese) with small industry RCTs suggesting tendon collagen synthesis support. Naming the branded ingredient at label is a formulation positive versus generic 'joint blend' SKUs. Evidence base is limited and mechanism-focused rather than large-scale outcomes. Would move to Verified 70+ with a published dose match and independent replication of the tendon-synthesis RCTs.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "digital-gift-card-5",
      "title": "Digital Gift Card $5",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f979786b-5e8e-49cf-96d0-bfc63a7fc140_large_4386610e-5456-4e89-8b4c-b6fa374e2c2a.jpg?v=1787417992",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "digital",
        "gift",
        "card",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 10,
        "manufacturing": 10,
        "safety": 50,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790812860613",
      "vsf_explanation": "Digital gift card is a retailer store credit, not a supplement or biohacking product; excluded from scoring.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "nac-n-acetyl-cysteine-extra-strength",
      "title": "NAC N-Acetyl Cysteine - Extra Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/57adada2-55ac-4e52-a48d-c81b7d448a1b_large_d7137784-c660-4a27-998a-318e520dfaf4.jpg?v=1787417991",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nac",
        "acetyl",
        "cysteine",
        "extra",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 74,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 66,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790812893381",
      "vsf_explanation": "Extra-strength NAC as a glutathione precursor with strong evidence as a mucolytic (Grandjean 2000) and acetaminophen antidote in clinical use. A single-ingredient NAC product at higher potency is a reasonable value formulation, though Swanson does not disclose the source amino-acid grade (Ajinomoto/AjiPure vs bulk Chinese) which meaningfully affects purity. Safety: interacts with nitroglycerin and immunosuppressants; not for pregnancy without clinician oversight. Would move to Verified 70+ with named pharmaceutical-grade source, third-party heavy-metal testing disclosure, and a clear statement about the resolved FDA NDI status.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "wellness-reset-bundle-box",
      "title": "Wellness Reset Bundle Box",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ea6b2eea-b8e1-4d94-ad41-7a9e331ead6e_large_e8a7b572-1d12-450c-9763-798a4ad88d0d.jpg?v=1787417993",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wellness",
        "reset",
        "bundle",
        "box",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 10,
        "manufacturing": 10,
        "safety": 50,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 79.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790813745349",
      "vsf_explanation": "Multi-SKU merchandising bundle rather than a single scoreable supplement; the 'reset' framing also lacks clinical grounding.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "magnesium-gummies-mixed-berry",
      "title": "Magnesium Gummies - Mixed Berry",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d6f80e39-0881-4afe-921d-8a7e2213df26_large_84283403-cc32-4b22-afc5-ec54ab8326c6.jpg?v=1787417993",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "gummies",
        "mixed",
        "berry",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 52,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 23.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790813778117",
      "vsf_explanation": "Magnesium gummies are the least clinically-oriented delivery format — they typically pack only 80-165mg elemental magnesium per serving (well below the 200-400mg studied range in Abbasi 2012 / Boyle 2017) and often use magnesium citrate or oxide with added sugar and gum base. Convenient for adherence but not therapeutic-strength. Standard tier reflects legit ingredient at sub-therapeutic delivery. Would move up with disclosed 200mg+ elemental glycinate/citrate and reduced sugar.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "digital-gift-card-10",
      "title": "Digital Gift Card $10",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b0122863-0e35-4bb1-ad8d-da09baf17dfd_large_27290369-1417-470c-87b2-74649d2f2c9e.jpg?v=1787417994",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "digital",
        "gift",
        "card",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 10,
        "manufacturing": 10,
        "safety": 50,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 10,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790813843653",
      "vsf_explanation": "Digital gift card is a retailer store credit, not a supplement or biohacking product; excluded from scoring.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "creatine-monohydrate-gummies-watermelon",
      "title": "Creatine Monohydrate Gummies - Watermelon",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4ca56fe2-cf5e-4ec0-9338-551476ece8a4_large_71b92360-f98d-4b7b-856b-014bb1c9fc3c.jpg?v=1787417994",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "creatine",
        "monohydrate",
        "gummies",
        "watermelon",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 45,
        "manufacturing": 58,
        "safety": 70,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790813810885",
      "vsf_explanation": "Watermelon-flavored creatine gummies inherit both the strong evidence of monohydrate (Kreider 2017) and the formulation problems of a gummy vehicle — acidic pH accelerates degradation of creatine to inert creatinine, and hitting 5g requires many gummies with a heavy sugar load. Independent lab testing of creatine gummies (NOW Foods 2024) found several brands under-labeled. Would move to Standard 65+ with per-gummy content disclosure and a third-party COA at expiration. Powder is a strictly better vehicle for the same molecule.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "collagen-peptides-unflavored-2",
      "title": "Collagen Peptides - Unflavored",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/27f927a6-c73a-408d-b024-88668f05a2c3_large_056f2863-8a98-4f7d-be5b-ae91c625c161.jpg?v=1787417995",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "collagen",
        "peptides",
        "unflavored",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 66,
        "formulation": 63,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790814859461",
      "vsf_explanation": "Generic hydrolyzed bovine collagen peptides in bulk canister — the correct form supported by Proksch 2014 (skin) and Clark 2008 (joint) at 10 g/day doses. Swanson mid-tier line without named-source peptides (no Peptan, Bodybalance, Verisol callout) or third-party heavy-metal testing disclosure. Held below Verified by sourcing opacity (grass-fed status not stated) and no clinical-grade peptide molecular-weight spec. Would move to Verified 70+ with a named clinical peptide and pasture-raised claim.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "super-green-max-plus-powder-whole-foods-vitamin-e",
      "title": "Super Green Max Plus Powder - Whole Foods + Vitamin E",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ffcc6902-63ad-4b32-899c-2af3d0a264a4_large_dc9bae01-3000-4f7f-8d45-a1ad148e8723.jpg?v=1787417995",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "super",
        "green",
        "max",
        "plus",
        "powder",
        "whole",
        "foods",
        "vitamin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 16.82,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790814892229",
      "vsf_explanation": "Greens-plus-tocopherol blends have modest evidence for micronutrient supplementation but rarely deliver studied doses of any single actives, and 'whole foods' blends often mask small mg amounts of many powders. Vitamin E as unspecified tocopherol form is a formulation weakness (mixed tocopherols, not dl-alpha-tocopherol alone, are preferred per Traber 2014). Held below Verified by proprietary-style blend disclosure risk, unclear standardization, and no named-source ingredients. Would move to Verified 70+ with mixed-tocopherol Vitamin E disclosure, per-ingredient mg amounts, and third-party heavy-metals COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "creatine-monohydrate-stick-packs-unflavored",
      "title": "Creatine Monohydrate Stick Packs - Unflavored",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4413a3d9-30c0-4013-ad54-63abb9352e48_large_a9eef8a8-e18d-49c9-808c-8e2498bf35e3.jpg?v=1787417996",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "creatine",
        "monohydrate",
        "stick",
        "packs",
        "unflavored",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 82,
        "formulation": 68,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 65,
        "sustainability": 45
      },
      "price": 17.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790814957765",
      "vsf_explanation": "Creatine monohydrate is the reference-standard ergogenic (Kreider 2017 ISSN position; 5g/day; 20+ years of RCT support). Stick pack format is a portioning convenience — the ingredient itself is unchanged. What holds this below Verified is the absence of Creapure branding — Creapure (AlzChem) is the reference-standard licensed source with published purity data (>99.95%). Swanson does not disclose supplier or COA on-label. Would move to Verified 70+ with Creapure sourcing named at label, or a third-party COA showing purity and absence of creatinine/dicyandiamide contaminants. Single-serve stick packs also carry a sustainability penalty vs bulk powder.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "collagen-peptides-stick-packs-unflavored",
      "title": "Collagen Peptides Stick Packs - Unflavored",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b12b63b6-f7b9-4c63-b5ce-2433a7a4fbea_large_f48717f5-6932-417e-9001-e10271665fce.jpg?v=1787417996",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "collagen",
        "peptides",
        "stick",
        "packs",
        "unflavored",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 66,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 62,
        "sustainability": 52
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790814990533",
      "vsf_explanation": "Hydrolyzed bovine collagen peptides in convenient single-serve stick packs. Correct form (hydrolyzed peptides, not gelatin) at what is presumably a standard 10-11 g per stick range studied in Proksch 2014 and Zdzieblik 2015 for skin elasticity and joint comfort. Stick-pack convenience adds cost with no efficacy gain. Held below Verified by generic (unnamed-source) collagen sourcing, no third-party ID testing disclosed at label, and no grass-fed/pasture-raised sourcing claim. Would move to Verified 70+ with named-source peptides (e.g., Peptan, Bodybalance) and third-party purity testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zinc-citrate-1",
      "title": "Zinc Citrate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6ab19945-00b7-4ee6-abfd-86539366f105_large_5f1c0b1f-5fde-459e-a830-66cfd4cc27f2.jpg?v=1787417997",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zinc",
        "citrate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 64,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 4.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790815023301",
      "vsf_explanation": "Zinc citrate is a well-absorbed mid-tier zinc form (Wegmuller 2014) suitable for immune and testosterone support at 15-40mg (Prasad 2007). This is Swanson's mainstream house-brand version — form is correct but no third-party certification per SKU and no copper co-factoring. Standard tier. Would move to Verified with Albion chelate sourcing, copper pairing, and NSF verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "premium-starter-bundle",
      "title": "Premium Starter Bundle",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0409b062-689b-41d0-9719-bda62b32a084_large_41f635b1-9c15-4a09-8a47-267b12beec1c.jpg?v=1787417998",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "premium",
        "starter",
        "bundle",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 10,
        "manufacturing": 10,
        "safety": 50,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790815940805",
      "vsf_explanation": "Multi-SKU merchandising bundle rather than a single scoreable supplement; component products should be scored individually.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "urinary-bladder-support",
      "title": "Urinary & Bladder Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9aa063d4-4c9f-42c4-a6b8-48b0141ae4cc_large_7daae136-3f00-4ec0-99f6-743fcd22e357.jpg?v=1787417998",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "urinary",
        "bladder",
        "support",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 4.77,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790815973573",
      "vsf_explanation": "Blended urinary/bladder support typically combines cranberry (PACs), D-mannose, and pumpkin seed. Each has some evidence — D-mannose reduced UTI recurrence in Kranjcec 2014, cranberry PACs at 36 mg reduced UTI in Vostalova 2015 — but house-branded 'Support' formulas rarely dose to those studied targets. Without per-active mg on the title, formulation adequacy is unverifiable. Would move to Verified with disclosed cranberry PAC mg, D-mannose g, and match to the studied doses.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "essential-starter-bundle",
      "title": "Essential Starter Bundle",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/696c7abd-c4da-407c-b462-bc94583d13df_large_c35a4f83-007b-489f-bfbe-3caec485475e.jpg?v=1787417999",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "essential",
        "starter",
        "bundle",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 10,
        "manufacturing": 10,
        "safety": 50,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790816006341",
      "vsf_explanation": "Multi-SKU merchandising bundle rather than a single scoreable supplement; component products should be scored individually.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "buried-treasure-liquid-nutrients-mullein-drops-with-200mg-10-1-extract-alcohol-free-liquid-dietary-supplement",
      "title": "Buried Treasure Liquid Nutrients Mullein Drops with 200mg 10:1 Extract, Alcohol-Free Liquid Dietary Supplement",
      "vendor": "Buried Treasure Liquid Nutrients",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BTMM-1.jpg?v=1787418027",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "buried",
        "treasure",
        "liquid",
        "nutrients",
        "mullein",
        "drops",
        "with",
        "200mg",
        "extract",
        "alcohol",
        "free",
        "liquid",
        "dietary",
        "supplement",
        "buried",
        "treasure",
        "liquid",
        "nutrients"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 23.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790821970117",
      "vsf_explanation": "Buried Treasure Mullein Drops offer a 10:1 alcohol-free liquid extract at 200mg per serving, which is a reasonable liquid-tincture format for respiratory/traditional use. Human RCT evidence for mullein is thin — most support is traditional use for cough and mild bronchitis, with minimal placebo-controlled data. The alcohol-free format is a legitimate transparency plus for kids or sensitive users. Would move to Verified 70+ with published assay data, sourcing named at label, and modern clinical trial support.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-encapsulations-nac-600mg-90-capsules",
      "title": "Pure Encapsulations NAC 600mg - 90 Capsules",
      "vendor": "Pure Encapsulations",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NAC-600mg-Pure-Encapsulations_700x700_2180a4df-08b1-47d1-a8cf-083844a198dd.jpg?v=1787418039",
      "score": 83,
      "tier": "elite",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "encapsulations",
        "nac",
        "600mg",
        "capsules",
        "pure",
        "encapsulations"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 78,
        "manufacturing": 82,
        "safety": 72,
        "transparency": 78,
        "sustainability": 65
      },
      "price": 33.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790825246917",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 76 → new 83. Evidence found: Dekhuijzen PN. Antioxidant properties of N-acetylcysteine: their relevance in relation to chronic obstructive pulmonary disease. Eur Respir J. 2004;23(4):629-636. | Fernandes BS et al. N-Acetylcysteine in depressive symptoms and functionality: a systematic review and meta-analysis. J Clin Psychiatry. 2016;77(4):e457-466. | Millea PJ. N-acetylcysteine: multiple clinical applications. Am Fam Physician. 2009;80(3):265-269.. Rationale: NAC has TIER-A evidence across pulmonary, hepatic (glutathione precursor), and psychiatric applications (Fernandes 2016 depression meta-analysis; strong evidence for trichotillomania, OCD, addiction adjunctive use). 600 mg is the standard studied unit dose. Practitioner-grade hypoallergenic formulation. Elite tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "garcinia-cambogia-comprehensive-formula-featuring-super-citrimax",
      "title": "Garcinia Cambogia Comprehensive Formula - Featuring Super CitriMax",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8b7ce867-4847-4a14-821c-ef3d0493745e_large_3a8a7058-52b7-41e9-bbbd-6a7d834a0d6c.jpg?v=1787418045",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "garcinia",
        "cambogia",
        "comprehensive",
        "formula",
        "featuring",
        "super",
        "citrimax",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 9.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790827212997",
      "vsf_explanation": "Super CitriMax is InterHealth's branded HCA (60%) from Garcinia cambogia. The best-designed RCT (Heymsfield 1998, JAMA) found no weight-loss effect vs placebo, and 2011 Onakpoya meta-analysis found the magnitude of any effect was too small to be clinically relevant. Rare hepatotoxicity case reports (Corey 2016). Branded ingredient does not rescue a null ingredient. Would not recommend for weight loss.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "digital-gift-card-15",
      "title": "Digital Gift Card $15",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/42bb3a39-ef26-47f9-b17f-e6bbcdfbd2e2_large_5185a2db-c8e0-4000-a932-652c4f1e3361.jpg?v=1787418045",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "digital",
        "gift",
        "card",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 10,
        "manufacturing": 10,
        "safety": 50,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 15,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790827180229",
      "vsf_explanation": "Digital gift card is a retailer store credit, not a supplement or biohacking product; excluded from scoring.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "balance-b-100-complex-high-potency",
      "title": "Balance B-100 Complex - High Potency",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/745c8a3c-15b2-405a-b651-a2be4d1d5bae_large_090121ab-65ab-4866-854d-8bf4f19b3adf.jpg?v=1787418045",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "balance",
        "100",
        "complex",
        "high",
        "potency",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 18.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790827278533",
      "vsf_explanation": "A classic B-100 megadose complex — 100 mg (or mcg for B12/folate) of each B vitamin. Meaningful for correcting overt deficiency, but the 100 mg B6 exceeds the tolerable upper intake (Vrolijk 2017 links chronic >50 mg pyridoxine HCl to sensory neuropathy) and typical B-complexes use cheap pyridoxine HCl and cyanocobalamin rather than P-5-P and methylcobalamin. Would move to Verified with active/methylated forms (methylfolate, P-5-P, methyl-B12) and B6 dose brought under 25 mg.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-d3-highest-potency-1",
      "title": "Vitamin D3 - Highest Potency",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/542bdfa5-79d1-4deb-b5b4-bcc22f18a861_large_5a145f3e-39e4-440a-8b29-6027e1a3e3bb.jpg?v=1787418045",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "highest",
        "potency",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 68,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 6.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790827311301",
      "vsf_explanation": "Cholecalciferol (D3) is the preferred serum-25(OH)D-raising form vs D2, with strong evidence in Martineau 2017 BMJ for immune/respiratory support and Autier 2014 for skeletal outcomes. 'Highest Potency' suggests a high-dose SKU (typically 5000-10000 IU), which is appropriate for correction protocols but should be used with vitamin K2/A cofactors and periodic 25(OH)D testing. Swanson's standard softgel format supports fat-soluble absorption. Held below Verified by absence of named-source cholecalciferol, no NSF/USP certification, and lack of pairing with K2. Would move to Verified 70+ with third-party COAs and a clearly listed IU per softgel.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "digital-gift-card-25",
      "title": "Digital Gift Card $25",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/620b7804-bb0a-4992-8f59-852cda58c6b4_large_fd9abef6-229a-4ddb-a8f9-b4057655dca6.jpg?v=1787418045",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "digital",
        "gift",
        "card",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 10,
        "manufacturing": 10,
        "safety": 50,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790827245765",
      "vsf_explanation": "Digital gift card is a retailer store credit, not a supplement or biohacking product; excluded from scoring.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "agmatine-sulfate",
      "title": "Agmatine Sulfate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/481baa0a-ef50-4626-9229-1ecfac7e5b89_large_2f82aa06-5a73-46c3-8d58-7ee19e80f860.jpg?v=1787418045",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "agmatine",
        "sulfate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 10.32,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790827409605",
      "vsf_explanation": "Agmatine sulfate is a decarboxylated arginine metabolite popular in nootropic/pre-workout stacks for putative NMDA modulation and NO effects. Human RCT evidence is limited to small trials in neuropathic pain (Keynan 2010, 2.67 g/day) and there's no robust cognitive/performance data. Long-term safety in healthy adults is poorly characterized. Would move to Verified only if larger human trials emerge; hard to progress much beyond low-Standard on evidence alone.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cinnamon-bark-maximum-strength-1",
      "title": "Cinnamon Bark - Maximum Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/085a56cd-c056-4764-a805-513b4ee396bb_large_b2da53bf-eb9a-4a13-a51c-04ada4118091.jpg?v=1787418045",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cinnamon",
        "bark",
        "maximum",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 6.7,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790827344069",
      "vsf_explanation": "Cinnamon showed a modest fasting-glucose signal in Allen 2013's meta-analysis but effect sizes are small and heterogenous. Critically, this label does not specify Ceylon vs Cassia — Cassia cinnamon contains coumarin (EFSA TDI of 0.1 mg/kg), which becomes a hepatotoxicity concern at 'maximum strength' daily use. Whole-bark powder without water-extract standardization delivers uncertain active dose. Would move to Verified 70+ with a Ceylon-species label plus water-extraction standardization such as Cinnulin PF.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "balance-b-100-complex-high-potency-1",
      "title": "Balance B-100 Complex - High Potency",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d90d57c2-0eba-42e1-9f06-589effb2a116_large_8aec5dc9-6c87-4994-8ea3-6d2e946ef7ca.jpg?v=1787418044",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "balance",
        "100",
        "complex",
        "high",
        "potency",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 15.75,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790827376837",
      "vsf_explanation": "A classic B-100 megadose complex — 100 mg (or mcg for B12/folate) of each B vitamin. Meaningful for correcting overt deficiency, but the 100 mg B6 exceeds the tolerable upper intake (Vrolijk 2017 links chronic >50 mg pyridoxine HCl to sensory neuropathy) and typical B-complexes use cheap pyridoxine HCl and cyanocobalamin rather than P-5-P and methylcobalamin. Would move to Verified with active/methylated forms and B6 dose brought under 25 mg.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-7-mushroom-blend-powder",
      "title": "Organic 7 Mushroom Blend Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/27bdd15b-668f-4143-b120-47a2736a5e95_large_7262efde-7579-461b-9c21-5e7cfc06cf18.jpg?v=1787418045",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "mushroom",
        "blend",
        "powder",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 55,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 55,
        "sustainability": 68
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790827442373",
      "vsf_explanation": "Organic 7-mushroom powder blend targeting immune modulation via beta-glucans. Organic certification is a real quality signal, but the title does not disclose whether the blend uses fruiting-body extracts or cheaper mycelium-on-grain, nor does it specify beta-glucan percentage or hot-water/dual extraction — the two variables that determine whether reishi/chaga/lion's mane deliver polysaccharide activity. Powder format is fine for stacking into coffee or smoothies. Would move to Verified 70+ with fruiting-body-only sourcing, disclosed beta-glucan standardization (e.g., >=25%), and per-mushroom mg breakdown.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "digital-gift-card-20",
      "title": "Digital Gift Card $20",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/46360567-9724-48ed-8509-5064a237f5ac_large_7c037a53-0b64-40d1-9ee7-ac8c0993c34a.jpg?v=1787418045",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "digital",
        "gift",
        "card",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 10,
        "manufacturing": 10,
        "safety": 50,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 20,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790827475141",
      "vsf_explanation": "Digital gift card is a retailer store credit, not a supplement or biohacking product; excluded from scoring.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "grass-fed-bovine-colostrum-powder-unflavored",
      "title": "Grass-Fed Bovine Colostrum Powder - Unflavored",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/06ce8c0f-8d8d-4cc9-8363-98748f53b97b_large_152a5121-918b-4a1d-afdf-64104028145d.jpg?v=1787418045",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "grass",
        "fed",
        "bovine",
        "colostrum",
        "powder",
        "unflavored",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790827507909",
      "vsf_explanation": "Bovine colostrum has meta-analytic support for reduced upper-respiratory infection incidence in athletes (Jones 2016) and modest support for gut barrier function (Playford 2020). Grass-fed sourcing is a positive for IgG concentration and animal welfare. Swanson doesn't publish IgG concentration % on the title, which is the primary formulation metric that separates good colostrum from also-rans (target >20-25% IgG). Would move to Verified 70+ with disclosed IgG %, first-milking claim, and pasteurization method.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mellow-magnesium-variety-pack",
      "title": "Mellow Magnesium - Variety Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0a6113ea-7158-4da4-850f-da91c63b377a_large_8fad8999-3435-4012-9b97-ca3ab699dd4a.jpg?v=1787418045",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mellow",
        "magnesium",
        "variety",
        "pack",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790827540677",
      "vsf_explanation": "This is a flavored magnesium drink powder / gummy variety pack in the 'calm' style. Magnesium for sleep and stress has RCT support (Boyle 2017), but powdered/gummy delivery formats typically use magnesium oxide or citrate at low doses (often below the 200-400mg elemental range studied). Flavored gummies also carry added sugar and gum-base carriers that reduce clinical-quality perception. Standard tier reflects legit ingredient but delivery/dose compromises. Would move up with disclosed elemental magnesium 200mg+ per serving and glycinate/citrate form.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "concentrated-krill-oil-featuring-superba-boost",
      "title": "Concentrated Krill Oil - Featuring Superba Boost",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/07d83724-1a35-4aa2-8b5e-6423d4e9b6f6_large_9a7a79de-a1da-4dc9-aa29-be6f54008d01.jpg?v=1787418045",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "concentrated",
        "krill",
        "oil",
        "featuring",
        "superba",
        "boost",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 74,
        "manufacturing": 74,
        "safety": 70,
        "transparency": 72,
        "sustainability": 70
      },
      "price": 23.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790827606213",
      "vsf_explanation": "Superba Boost is Aker BioMarine's premium concentrated krill oil (MSC-certified sustainable Antarctic krill harvest). Phospholipid-form omega-3 has better absorption than ethyl-ester fish oil for equivalent EPA+DHA (Ulven 2011). Astaxanthin content is a bonus. Sits at low-Verified. Would move to Verified 75+ with per-cap EPA/DHA mg disclosure and IKOS certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "daytime-menopause-support",
      "title": "Daytime Menopause Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9e748903-82a1-4fbd-8745-dbe871e345d4_large_b4998c81-d200-440c-8e4f-7139e8280c26.jpg?v=1787418045",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "female",
      "life_stage": "postmenopausal",
      "tokens": [
        "daytime",
        "menopause",
        "support",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790827704517",
      "vsf_explanation": "A daytime menopause-support blend from Swanson that typically combines black cohosh, red clover, and/or soy isoflavones with adaptogens. Black cohosh has moderate RCT support for hot flashes (Leach 2012 Cochrane review — modest effect) but a hepatotoxicity safety signal that warrants disclosure. As a multi-ingredient formula the per-active mg often lands below monograph doses (e.g., 40mg black cohosh triterpene glycoside standardization). Manufacturing is Swanson house-brand mid-tier without visible third-party certifications. Would move to Verified 70+ with clear standardization percentages, per-active dosing meeting monograph levels, and explicit liver-safety guidance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ubiquinol-200-mg",
      "title": "Ubiquinol 200 mg",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ad575938-6369-482b-97cb-3baab9a35c12_large_6ba2aa6c-e818-4c05-8d1a-1ee6056b0fe6.jpg?v=1787418045",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ubiquinol",
        "200",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 74,
        "formulation": 72,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790827573445",
      "vsf_explanation": "Ubiquinol is the reduced, more bioavailable form of CoQ10 and is especially useful for adults 40+ whose endogenous ubiquinone-to-ubiquinol conversion declines. 200 mg is a robust daily dose that falls within the range studied for statin-associated myalgia (Skarlovnik 2014) and heart failure adjunct therapy. The product is held below Verified because the Swanson listing does not confirm Kaneka QH source on the label, nor is there per-SKU third-party COA published. Would move to Verified 72-74 with confirmed Kaneka QH sourcing and a published third-party assay, and to Verified 75+ with softgel-in-lipid delivery disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "celadrin",
      "title": "Celadrin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9f1a3063-bce5-4ce8-85a8-4489fc743fe9_large_60dca0cd-978a-4819-ac9d-5732503b875d.jpg?v=1787418045",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "celadrin",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 8.45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790827802821",
      "vsf_explanation": "Celadrin is a proprietary cetylated fatty acid ester complex studied in small RCTs for knee osteoarthritis (Hesslink 2002; Kraemer 2005) with modest short-term function/pain benefits. Evidence base is thin and industry-funded compared with glucosamine/curcumin/collagen. Swanson uses the branded ingredient which supports formulation transparency, but per-active mg isn't disclosable from the title. Would move to Verified 70+ with independent replication and standardized 350 mg twice-daily dosing matching the trial protocol.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "scottish-kelp-made-with-organic-sea-kelp-1",
      "title": "Scottish Kelp - Made with Organic Sea Kelp",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9692f7ba-b8d4-4aca-ac20-5f2d4acd9336_large_5757c711-cd57-4e2a-9cac-b6bce18947e0.jpg?v=1787418045",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "scottish",
        "kelp",
        "made",
        "with",
        "organic",
        "sea",
        "kelp",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 60,
        "sustainability": 60
      },
      "price": 22.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790827737285",
      "vsf_explanation": "Sea kelp is a whole-food iodine source, useful in mild deficiency but risky as a chronic supplement because natural kelp iodine content varies widely (100-2000+ mcg/g) and can push intake past the 1,100 mcg/day UL, especially problematic for autoimmune thyroid patients. Organic sourcing is a plus, but Swanson doesn't disclose iodine mcg per serving on the title line. Would move to Verified with per-serving iodine mcg disclosure, harvest region (Pacific vs Atlantic matters for heavy metal load), and explicit hyperthyroid/Hashimoto's cautions.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mellow-magnesium-blue-raspberry",
      "title": "Mellow Magnesium - Blue Raspberry",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c6e17ae7-5ee4-42e0-91fe-abd365e94d4d_large_be0d0950-32e0-4ec5-ab02-06be374b514f.jpg?v=1787418045",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mellow",
        "magnesium",
        "blue",
        "raspberry",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 22.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790827671749",
      "vsf_explanation": "Flavored magnesium drink mix in Swanson's 'Mellow' calm-relaxation line. Magnesium supplementation has evidence for sleep quality and anxiety (Boyle 2017; Abbasi 2012), but flavored powders typically deliver modest elemental magnesium (often 100-200mg) with taste-masking additives. Form (glycinate, citrate, or oxide) is not disclosed at the title level. Standard tier reflects category legitimacy with formulation opacity. Would move to Verified with named form, 200mg+ elemental dose, and third-party purity certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "full-spectrum-ginger-root-1",
      "title": "Full Spectrum Ginger Root",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cf8b585a-c65b-4bb1-aeff-514751b24434_large_8f832cdb-5ad7-42e9-a370-d52f8a6541f5.jpg?v=1787418045",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "full",
        "spectrum",
        "ginger",
        "root",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 66,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 11.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790827835589",
      "vsf_explanation": "Ginger has solid RCT evidence for nausea (Ernst & Pittler 2000 meta-analysis for postoperative and pregnancy nausea) and modest anti-inflammatory activity. This is Swanson's 'Full Spectrum' whole-herb ginger root powder — no standardization to gingerols or shogaols, so bioavailability of the active constituents is inconsistent versus standardized extracts. Swanson's mass-market manufacturing sits at mid-tier with GMP but rarely per-SKU third-party testing. Would move to Verified 70+ with a standardized 5% gingerol extract at a clinically studied 500-1000 mg dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "peak-atp-maximum-strength-1",
      "title": "Peak ATP - Maximum Strength",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0c98e3d4-d7e2-4b70-8024-371c59c0ed63_large_e7dbd821-ce47-4ef1-96e5-4e1c73eabcbe.jpg?v=1787418045",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "peak",
        "atp",
        "maximum",
        "strength",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 40.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790827638981",
      "vsf_explanation": "Peak ATP (branded disodium adenosine 5-triphosphate from TSI Group) has small RCT support for strength/lean mass at 400 mg/day (Wilson 2013; Jager 2014) though most work is industry-funded. Using the branded ingredient is a formulation positive and typical clinical dose is 400 mg. Swanson mass-market packaging without USP/NSF cert holds this in Standard. Would move to Verified 70+ with third-party ID testing certificate and disclosure of exact daily dose matching the Wilson protocol.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "100-organic-lions-mane-mushroom-powder",
      "title": "100% Organic Lion's Mane Mushroom Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f2ada9a1-82c1-4292-a310-d6903f89a4a2_large_020330e6-c4b8-43ff-973f-db6e68851698.jpg?v=1787418045",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "100",
        "organic",
        "lion",
        "mane",
        "mushroom",
        "powder",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 60,
        "sustainability": 60
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790827901125",
      "vsf_explanation": "Organic Lion's Mane bulk powder with no beta-glucan or hericenone/erinacine standardization disclosed and no explicit fruiting-body-vs-mycelium designation - a critical spec since mycelium-on-grain products dilute the actives that Mori 2009 used in its mild-cognitive-impairment RCT. Powder format is fine for tea/smoothie use but delivers unknown active dose per serving. Manufacturing looks competent (USDA organic) and safety is favorable. Would move to Verified 70+ with fruiting-body designation, hot-water extraction or dual extraction, and disclosed beta-glucan percentage.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nighttime-menopause-support",
      "title": "Nighttime Menopause Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/87469f31-a07a-4dfd-8948-40566122b1c6_large_31d0423b-c2fa-4a7b-a6f5-ca262e18b55f.jpg?v=1787418045",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "hormone"
      ],
      "sex_relevance": "female",
      "life_stage": "postmenopausal",
      "tokens": [
        "nighttime",
        "menopause",
        "support",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790827770053",
      "vsf_explanation": "Nighttime companion to Swanson's menopause line, typically layering black cohosh or soy isoflavones with mild sedatives like valerian, passionflower, or melatonin. Black cohosh has modest hot-flash evidence (Leach 2012 Cochrane) but the hepatotoxicity signal requires disclosure the label may not carry. Valerian for sleep has mixed RCT results (Fernandez-San-Martin 2010 meta-analysis: modest subjective improvement). Multi-active blends at Swanson typically under-dose individual ingredients versus monograph. Would move to Verified 70+ with per-active mg disclosure meeting studied doses and explicit liver + drug-interaction warnings.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mellow-magnesium-berry-lemonade",
      "title": "Mellow Magnesium - Berry Lemonade",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0f38ff7d-1177-474b-85d9-ddfcc4cfd202_large_be240a00-6d7a-4054-9667-0c05c05ea5b7.jpg?v=1787418045",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mellow",
        "magnesium",
        "berry",
        "lemonade",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 22.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790827933893",
      "vsf_explanation": "Flavored magnesium calm-drink powder. The evidence for magnesium in stress and sleep is real (Boyle 2017) but flavored beverage delivery formats typically pair moderate doses with sweeteners and citric acid, and Swanson does not disclose form or elemental dose at title level. Standard tier is appropriate for a functional beverage in this category. Would move up with disclosed glycinate/citrate form, 200mg+ elemental, and NSF certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mellow-magnesium-black-cherry",
      "title": "Mellow Magnesium - Black Cherry",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2a417721-110e-45ac-b4ad-33a5d08993f0_large_f2ea3c46-0744-4ce2-9249-984a66580427.jpg?v=1787418045",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mellow",
        "magnesium",
        "black",
        "cherry",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 22.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790827868357",
      "vsf_explanation": "Flavored magnesium drink powder in Swanson's stress/sleep line. Magnesium has RCT-level evidence for sleep quality (Abbasi 2012) but flavored beverage formats typically use lower elemental doses with sweeteners and carriers. Form is not disclosed. Standard tier — safe, mainstream, but not clinically-forward. Would upgrade with 200mg+ elemental disclosure, glycinate form, and stevia-only sweetening.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lactobacillus-gasseri-1",
      "title": "Lactobacillus Gasseri",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8cdd966a-daa8-4c51-8eaf-bd8b075b8bce_large_7fe3468a-efe0-472c-961b-cdeb9efa12fa.jpg?v=1787418045",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lactobacillus",
        "gasseri",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 37.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790827966661",
      "vsf_explanation": "Single-strain L. gasseri capsule from Swanson's house line. L. gasseri has interesting weight/visceral-fat literature when the specific strain BNR17 (Kim 2018) or SBT2055 (Kadooka 2013) is used, but the label does not identify a strain, so it is impossible to link the product to any RCT. CFU count and delivery format are also not conveyed by the title. Would move to Verified 70+ with strain-level identification (BNR17 or SBT2055), CFU-at-expiration disclosure, and a delayed-release delivery vehicle for gastric-acid survival.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hibiscus-flower-1",
      "title": "Hibiscus Flower",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/dd88b8db-b317-419d-b5b3-be8b4eb56bc4_large_87d68cf9-9dcb-4850-8438-bd9b4866dc79.jpg?v=1787418045",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hibiscus",
        "flower",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 52,
        "manufacturing": 58,
        "safety": 64,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 18.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790828032197",
      "vsf_explanation": "Hibiscus (Hibiscus sabdariffa) has meaningful RCT evidence for modest systolic BP reduction (McKay 2010 showed ~7 mmHg drop), typically studied as brewed tea equivalent to 1-3 g/day of dried calyx. This is a whole-herb capsule with no anthocyanin standardization, which is the primary vasodilatory constituent. Capsule delivery of dried powder is a weaker vehicle than the traditional aqueous infusion used in trials. Would move to Verified 70+ with standardization to anthocyanins and dosing aligned with BP-study protocols.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "menopause-support-bundle",
      "title": "Menopause Support Bundle",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/dcefb415-27ba-47eb-9a0b-b4e26b28cc70_large_4fc685d7-e6f1-4067-9381-c55bb24f9904.jpg?v=1787418045",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "female",
      "life_stage": "postmenopausal",
      "tokens": [
        "menopause",
        "support",
        "bundle",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790827999429",
      "vsf_explanation": "Bundle pack of Swanson's daytime + nighttime menopause formulas — inherits the ingredient and dosing profile of both. Black cohosh evidence for hot flashes is modest (Leach 2012 Cochrane), and the hepatotoxicity signal warrants explicit label warnings. Convenience of the bundle doesn't change formulation quality — same mid-tier standardization concerns and lack of visible third-party testing. Would move to Verified 70+ with monograph-level per-active dosing, standardization percentages disclosed, and safety warnings for concurrent hormone therapy.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hiactives-tart-cherry-1",
      "title": "HiActives Tart Cherry",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/62b64f9a-10aa-40c1-80d7-cd0ce44c81a6_large_ab48ca98-6d51-4c06-97a2-77353611104a.jpg?v=1787418045",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hiactives",
        "tart",
        "cherry",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 20.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790828064965",
      "vsf_explanation": "Tart cherry (Prunus cerasus) has small RCT support for exercise-induced muscle soreness (Bell 2014) and modest sleep improvement (Losso 2018) tied to anthocyanin content. HiActives is a standardized branded extract which is a formulation positive. Swanson doesn't disclose anthocyanin mg/serving on the title, and evidence for chronic joint use is thinner than for acute recovery. Would move to Verified with anthocyanin mg per serving and a use-case match to studied protocols (480 mg standardized extract twice daily).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "creatine-monohydrate-gummies-wild-berry-punch",
      "title": "Creatine Monohydrate Gummies - Wild Berry Punch",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/384328b6-8b6b-41a2-9675-4c623323f542_large_d53e3be1-1863-4f2a-8a67-2adf4506e868.jpg?v=1787418045",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "creatine",
        "monohydrate",
        "gummies",
        "wild",
        "berry",
        "punch",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 45,
        "manufacturing": 58,
        "safety": 70,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790828949701",
      "vsf_explanation": "Creatine monohydrate itself is the most-studied ergogenic on the market (Kreider 2017 ISSN position stand — 3-5g/day maintenance) — but delivering it as gummies is a formulation problem. Hitting the studied 5g dose in gummies typically requires 4-8 gummies with added sugar and citric acid, which degrades creatine to creatinine on shelf if pH stays acidic. Third-party testing of creatine gummies has repeatedly found under-labeled creatine content (NOW Foods 2024 lab report). Would move to Standard 65+ only with per-gummy creatine content disclosed AND third-party COA showing intact creatine at expiration. Powder form of the same molecule is a strictly better formulation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "enhanced-ubiquinol-with-pqq",
      "title": "Enhanced Ubiquinol with PQQ",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/db37b51a-ca24-4193-a7f9-844bf5b1a4c3_large_e4e9864a-76fd-4876-911b-ae9c6cbfcdcb.jpg?v=1787418045",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "enhanced",
        "ubiquinol",
        "with",
        "pqq",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 72,
        "manufacturing": 65,
        "safety": 72,
        "transparency": 66,
        "sustainability": 55
      },
      "price": 26.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790828982469",
      "vsf_explanation": "Ubiquinol (reduced CoQ10) + PQQ is a rational mitochondrial stack - ubiquinol offers 2-4x better bioavailability than oxidized ubiquinone in older adults (Failla 2014), and PQQ has small RCT support for mitochondrial biogenesis markers (Nakano 2012). Formulation is credible if the ubiquinol is Kaneka-sourced (Swanson's Ultra line typically uses Kaneka) - that identity would push transparency higher. Safety is good, though ubiquinol/CoQ10 can blunt warfarin efficacy. Would move to Verified 70+ with explicit Kaneka Ubiquinol identity, per-active mg on the marketing page, and BioPQQ (Mitsubishi) named for the PQQ.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ginkgo-biloba-extract-standardized-5",
      "title": "Ginkgo Biloba Extract - Standardized",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5425f081-21eb-4b62-8150-47d27d90d214_large_417e92a5-c4af-42bf-b6d3-040c2612f7e4.jpg?v=1787418054",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ginkgo",
        "biloba",
        "extract",
        "standardized",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 66,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 30.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790831079621",
      "vsf_explanation": "Standardized ginkgo extract in the same 24/6 flavone-glycoside/terpene-lactone template pioneered by EGb 761 - the closest thing to an evidence-grade extract profile for cognitive aging (Le Bars 1997; Ihl 2011). Swanson's version is a mid-tier private-label take; the extract standardization is disclosed but the manufacturer/source is generic and there is no third-party COA or heavy-metal testing visible. Ginkgo carries a real bleeding-risk interaction with anticoagulants/antiplatelets that is often under-communicated. Would move to Verified 70+ with named extract origin (e.g., EGb 761-comparable), a per-lot COA, and explicit anticoagulant interaction disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "the-skin-pill-1",
      "title": "The Skin Pill",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/97e21098-6ea7-4b72-88b5-1490b7f775f6_large_43ec5ce4-1417-4b06-aed1-7cadf578feee.jpg?v=1787418055",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "the",
        "skin",
        "pill",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 52,
        "sustainability": 50
      },
      "price": 58.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790831112389",
      "vsf_explanation": "Generic marketing-forward name ('The Skin Pill') with no active-ingredient hint at title level — a transparency red flag by itself. Beauty-from-within category has real evidence for hydrolyzed collagen (Proksch 2014), astaxanthin (Tominaga 2012), and HA (Oe 2017), but only when actives and doses are disclosed. Held below Verified by opaque naming — cannot evaluate what it contains from the title alone. Would move to Verified 70+ with a rename that specifies the core actives and their clinical doses.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zinc-citrate-2",
      "title": "Zinc Citrate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e23ab6c1-0305-46b0-bf4d-78589f488ccb_large_f7a3d782-1588-4c25-a8de-cc4678bbe755.jpg?v=1787418055",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zinc",
        "citrate",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 64,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 6.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790831669445",
      "vsf_explanation": "Zinc citrate is a reasonable mid-tier zinc form with well-documented absorption comparable to zinc gluconate (Wegmuller 2014). Zinc at 15-40mg supports immune function and testosterone (Prasad 2007), and Swanson's mainstream sourcing here is adequate but not third-party certified per SKU. Standard tier reflects the correct form and standard house-brand manufacturing; no copper co-factoring is disclosed which is a limitation for long-term daily use. Would move to Verified 70+ with named-source chelate (e.g., Albion), copper pairing, and NSF/USP certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "100-organic-pea-protein-powder-non-gmo-unflavored-1",
      "title": "100% Organic Pea Protein Powder - Non-GMO Unflavored",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a8d8b185-77dd-4b65-937f-98b52361b335_large_81a7819a-511a-44e0-9785-7a097b2661b9.jpg?v=1787418056",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "100",
        "organic",
        "pea",
        "protein",
        "powder",
        "non",
        "gmo",
        "unflavored",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 72,
        "transparency": 65,
        "sustainability": 66
      },
      "price": 41.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790831734981",
      "vsf_explanation": "Organic non-GMO pea protein isolate — a legitimate plant protein with a solid leucine content (Babault 2015 showed pea protein equal to whey for strength adaptation over 12 weeks at ~25g/serving). Pea protein is naturally low in methionine so it is not a complete amino profile on its own; combining with rice protein would fix this. Swanson's house-brand manufacturing is Standard-tier without published third-party testing per lot or NSF Certified for Sport certification. Would move to Verified 70+ with a rice-blend to complete the amino profile, published heavy-metal testing (pea protein is a known cadmium sink), and NSF Sport certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natural-dry-e-400",
      "title": "Natural Dry E-400",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/19b4560c-6e9d-4513-8997-f03595f79440_large_382243a7-61a3-43e3-9942-b52bab5665f0.jpg?v=1787418057",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "natural",
        "dry",
        "400",
        "swanson",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 9.8,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790831767749",
      "vsf_explanation": "Dry vitamin E 400 IU is a legacy format aimed at those who don't tolerate oil-based softgels. Meta-analyses (Miller 2005) show 400 IU alpha-tocopherol alone has weak or neutral CV outcomes and modestly higher all-cause mortality at higher doses, so isolated high-dose alpha-tocopherol is no longer clinically favored versus mixed tocopherol/tocotrienol formats. Swanson doesn't disclose whether this is natural (d-alpha, RRR-) or synthetic (dl-alpha, all-rac-) on the title line, which materially affects bioactivity. Would move to Verified with disclosure of RRR-alpha plus mixed tocopherols and a lower per-serving dose (~50-150 IU).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-aloe-vera-200mg-per-veggie-caps-150-count-aloe-vera-gel-supplement-extract-200-1-vegetarian-non-gmo-bioperine",
      "title": "NusaPure Aloe Vera 200mg Per Veggie Caps - 150 Count - Aloe Vera Gel Supplement - Extract 200:1, Vegetarian, Non-GMO, Bioperine",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-131289v4-AloeVera-HA-150-Vcaps-3D-01.jpg?v=1787418075",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "aloe",
        "vera",
        "200mg",
        "per",
        "veggie",
        "caps",
        "150",
        "count",
        "aloe",
        "vera",
        "gel",
        "supplement",
        "extract",
        "200",
        "vegetarian",
        "non",
        "gmo",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 23,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46790839009477",
      "vsf_explanation": "NusaPure Aloe Vera capsules use a 200:1 extract at 200mg per veggie cap (roughly 40g leaf equivalent), which is a reasonable concentrate for a GI/laxative use case. Evidence for oral aloe is mixed — mild support for constipation and reflux, but anthraquinone-containing whole-leaf preparations carry chronic-use concerns. NusaPure is an Amazon-native budget brand with no per-SKU third-party COA visible and no NSF/USP certification. Would move to Verified 70+ with decolorized (aloin-removed) extract disclosure, batch COAs, and clearer sourcing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "universal-nutrition-animal-pak-44-packs",
      "title": "Universal Nutrition Animal Pak - 44 Packs",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Universal-Nutrition-Animal-Pak-44-Packs.jpg?v=1787422208",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "universal",
        "nutrition",
        "animal",
        "pak",
        "packs",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 55,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 42.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791729578181",
      "vsf_explanation": "Universal Nutrition Animal Pak (44 packs) is a legacy bodybuilder multi-pack that combines a multivitamin, amino acids, digestive enzymes, and herbal 'performance' ingredients into a per-day pill/tablet pack. Universal Nutrition is an established US brand (est. 1977), but the Animal Pak formula has evolved slowly and retains an old-school 'megadose everything' philosophy — several B-vitamins are dosed at 500-1000% RDA with limited additional benefit and some concerns (e.g., high-dose B6 neuropathy at >100 mg long-term per Vrolijk 2017). Held in Standard by the megadose approach, non-methylated B-vitamin forms, and a proprietary-blend component in some sub-panels. Would move to Verified with a modernized formula using methylated B-vitamins, sensible dose ceilings, and fully open-label sub-blends.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "5-nutrition-kill-it-pre-workout",
      "title": "5% Nutrition Kill It Pre-Workout",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5-Nutrition-Kill-It-Pre-Workout.jpg?v=1787422224",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrition",
        "kill",
        "pre",
        "workout",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 58,
        "sustainability": 52
      },
      "price": 39.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791730462917",
      "vsf_explanation": "5% Nutrition Kill It Pre-Workout is a high-stim pre-workout from Rich Piana's 5% Nutrition brand — the category-typical formula includes citrulline, beta-alanine, creatine, and 300-400 mg caffeine per scoop. Individual actives have solid RCT support (citrulline malate 6-8 g for pump/performance per Perez-Guisado 2010; beta-alanine 3-6 g/day for high-intensity endurance per Trexler 2015). Held in Standard by high-stim caffeine load (>300 mg per scoop is a safety flag for stim-sensitive users), historical use of proprietary blends in the brand's early formulas, and no NSF Certified for Sport certification. Would move to Verified with fully open-label per-active mg, moderated caffeine load, and NSF certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "moringa-leaves-capsules-60-capsules-dietary-supplement",
      "title": "Moringa Leaves Capsules 60 Capsules Dietary Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/582cc7d6-df02-4461-9fbd-f4cc3dee2e85_fine.jpg?v=1787422235",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "moringa",
        "leaves",
        "capsules",
        "capsules",
        "dietary",
        "supplement",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 16.93,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791731642565",
      "vsf_explanation": "Vivalo Moringa Leaves Capsules is a 60-count moringa (Moringa oleifera) leaf-powder supplement from a small vendor. Moringa has modest RCT-level evidence for fasting glucose reduction in T2DM (Kumari 2010, ~50 mg/kg for 3 months) and antioxidant marker improvements, but hard endpoints and human safety data at long duration remain thin. Held in Standard by small vendor with limited manufacturing transparency, no standardization of key markers (isothiocyanates, moringinine), no third-party heavy-metal testing (relevant because moringa is a bioaccumulator), and unclear geographic sourcing. Would move to Verified with organic certification, standardized isothiocyanate %, and third-party heavy-metal testing certificates.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "21st-century-melatonin-3-mg-tablets-60-ct",
      "title": "21st Century Melatonin 3 Mg, Tablets 60 Ct",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/98732187_7df81a09-2aba-42c7-83f3-f0d545172446.jpg?v=1787422262",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "21st",
        "century",
        "melatonin",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 4.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791732920517",
      "vsf_explanation": "21st Century is a mass-market value brand (owned by 21st Century HealthCare, made in the US) — acceptable manufacturing but not premium. Melatonin at 3 mg is a common commercial dose but still above the 0.3–1 mg physiologic range validated by Zhdanova 2001 for sleep-onset and by Herxheimer 2002 Cochrane for jet-lag; supraphysiologic doses can desensitize MT1/MT2 receptors and cause next-morning grogginess without improving deep sleep. Erland 2017 J Clin Sleep Med tested commercial melatonin tablets and found label-actual content variance from -83% to +478%, so any product without third-party assay carries dose-accuracy risk. Would move to Verified at 0.3–1 mg dose with third-party assay confirmation, sublingual or fast-dissolve delivery, and no additional actives.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "wooden-spoon-herbs-magic-magnesium-spirulina-blue-lemonade-powder-sachets-10ct",
      "title": "Wooden Spoon Herbs - 'Magic Magnesium' Spirulina Blue Lemonade Powder Sachets (10CT)",
      "vendor": "The Epicurean Trader",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a65ec78228902bbf69c15d0cadaa1615.jpg?v=1787422278",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wooden",
        "spoon",
        "herbs",
        "magic",
        "magnesium",
        "spirulina",
        "blue",
        "lemonade",
        "powder",
        "sachets",
        "10ct",
        "the",
        "epicurean",
        "trader"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 58,
        "sustainability": 65
      },
      "price": 20,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791733903557",
      "vsf_explanation": "Wooden Spoon Herbs 'Magic Magnesium' is a spirulina + magnesium blue-lemonade sachet blend (10-count) from a small-batch herbalist brand — the 'Magic' branding is fanciful marketing rather than a substantive claim. Magnesium has strong RCT support for sleep quality and muscle cramps at 200-400 mg elemental (Abbasi 2012), and spirulina has modest antioxidant-marker and blood-pressure data (Yousefi 2018). Held in Standard by sachet format dose limitations, no disclosed elemental magnesium mg (bisglycinate vs oxide vs citrate matters heavily), and blue color likely from phycocyanin — a legitimate spirulina pigment. Would move to Verified with an elemental-magnesium mg disclosure, form specification (e.g., glycinate), and third-party testing certificates.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-truth-l-theanine-200-mg-dietary-supplement-capsules",
      "title": "Nature's Truth L-Theanine 200 Mg Dietary Supplement Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/97179696.jpg?v=1787422311",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "cognitive",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "truth",
        "theanine",
        "200",
        "dietary",
        "supplement",
        "capsules",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 65,
        "manufacturing": 58,
        "safety": 78,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 12.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791737934021",
      "vsf_explanation": "Nature's Truth is a Piping Rock-family mass-market brand — house-brand economics with acceptable but undifferentiated formulation. L-theanine 200 mg per capsule sits squarely in the RCT-validated range (Kimura 2007 showed acute stress-response and alpha-wave EEG effects at 200 mg; Hidese 2019 4-week trial at 200 mg improved stress, sleep, and cognitive scores). Safety is a strength — L-theanine has an excellent tolerability profile with no notable drug interactions. Held below Verified because the label doesn't specify Suntheanine (the licensed L-enantiomer pure form) versus generic racemic theanine, no third-party testing, and no synergistic pairing with caffeine (where the Owen 2008 and Giesbrecht 2010 evidence is strongest). Would move to Verified with Suntheanine designation and USP verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "efx-karbolyn-4-ib",
      "title": "EFX Karbolyn - 4 Ib",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/EFX-Karbolyn-4-Ib.jpg?v=1787422327",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "efx",
        "karbolyn",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 65,
        "safety": 70,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 49.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791739769029",
      "vsf_explanation": "EFX Karbolyn (4 lb tub) from All American EFX is a patented high-molecular-weight branched glucose polymer designed for rapid gastric emptying without the osmotic pull of simple sugars — this class of engineered carb (similar to Vitargo, Cluster Dextrin) is well-suited to endurance athletes and glycogen re-loading. Studies on high-molecular-weight glucose polymers show faster gastric emptying and higher post-exercise glycogen resynthesis vs maltodextrin (Stephens 2008, Piehl Aulin 2000). Single-active formulation, transparent ingredient. Held in Standard by artificial coloring/sweetener systems in flavored variants and no NSF Certified for Sport testing. Would move to Verified with an unflavored/undyed version and third-party purity testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrabio-alpha-eaa",
      "title": "NutraBio Alpha EAA",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NutraBio-Alpha-EAA.jpg?v=1787422345",
      "score": 76,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrabio",
        "alpha",
        "eaa",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 72,
        "manufacturing": 72,
        "safety": 70,
        "transparency": 78,
        "sustainability": 55
      },
      "price": 44.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791742062789",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 68 → new 76. Evidence found: NutraBio Alpha EAA: full-transparency EAA formula with added hydration/adaptogen matrix. | Wolfe RR. Branched-chain amino acids and muscle protein synthesis. J Int Soc Sports Nutr. 2017;14:30.. Rationale: Alpha EAA is NutraBio's premium EAA formula with all 9 essential amino acids plus hydration/nootropic add-ons at fully-disclosed doses. Uplift to Verified for brand transparency + evidence-based EAA delivery.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "jevity-1-2-with-fiber-oral-supplement-8-oz-carton-1048205",
      "title": "Jevity 1.2 With Fiber Oral Supplement, 8 Oz. Carton 1048205",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/150147407.jpg?v=1787422356",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "jevity",
        "with",
        "fiber",
        "oral",
        "supplement",
        "carton",
        "1048205",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 70,
        "manufacturing": 78,
        "safety": 55,
        "transparency": 68,
        "sustainability": 45
      },
      "price": 63.76,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791743406277",
      "vsf_explanation": "Jevity 1.2 With Fiber is Abbott Nutrition's prescription-tier enteral (tube-feeding) formula — 1.2 kcal/mL polymeric feed with added FOS and soy polysaccharide fiber, designed for hospital and long-term-care patients unable to meet nutrition needs orally. It is not a consumer biohacking supplement and does not belong in a Vyvata protocol. Scored out of scope. The Abbott manufacturing pedigree is genuinely high; the categorization mismatch is what disqualifies it. Consumers looking for a real oral meal-replacement should consider Huel, Kate Farms Standard, or similar full-food formulas — not clinical enteral feeds.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "rena-vite-dietary-supplement-specialized-renal-vitamin-formula-100-count",
      "title": "Rena-Vite Dietary Supplement, Specialized Renal Vitamin Formula, 100 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/41raZ1A7mIL._AC_UF1000_1000_QL80.jpg?v=1787422381",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "rena",
        "vite",
        "dietary",
        "supplement",
        "specialized",
        "renal",
        "vitamin",
        "formula",
        "100",
        "count",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 17.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791745011909",
      "vsf_explanation": "Rena-Vite is a specialized renal multivitamin (Nnodum Pharmaceuticals) built for chronic kidney disease / dialysis patients — the standard renal-formula design includes water-soluble B vitamins and folic acid that dialysis clears, deliberately omits vitamin A (accumulates in renal failure) and typically restricts potassium/magnesium/phosphorus. This is a legitimate clinical-nutrition product with a KDOQI-guideline-aligned rationale, not a general-purpose biohacking supplement — the target user is under nephrology care, and self-selection by non-CKD consumers may miss general-multivitamin needs. Held at Standard because it isn't broadly biohacker-appropriate; for a CKD patient under practitioner supervision it would score higher. Would flag as \"clinical nutrition — practitioner-directed\" in-product for clarity.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "centrum-age-defy-mens-high-potency-multivitamin-60-caplets",
      "title": "Centrum Age Defy Men's High Potency Multivitamin 60 Caplets",
      "vendor": "Centrum",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/81LOSJonKxL.jpg?v=1787422390",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "centrum",
        "age",
        "defy",
        "men",
        "high",
        "potency",
        "multivitamin",
        "caplets",
        "centrum"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 58,
        "manufacturing": 68,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 21.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791745962181",
      "vsf_explanation": "Centrum is Haleon-owned (spun off from GSK 2022) — one of the most-studied multivitamins in the world, with Physicians' Health Study II (Sesso 2012 JAMA) using Centrum Silver over 11 years and showing modest reductions in total cancer incidence and cataracts in older men. Age Defy Men's is the higher-potency version with added lutein/zeaxanthin and lycopene. Held at mid-Standard because the formulation uses folic acid (not methylfolate), cyanocobalamin (not methylcobalamin), and mineral-oxide forms (magnesium oxide, calcium carbonate) with lower bioavailability than chelated alternatives, and it's a compressed caplet rather than veggie cap. Would move to Verified with methylated B-vitamins, chelated minerals, and per-lot COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gnp-healthy-eyes-tablets-60-count",
      "title": "GNP Healthy Eyes Tablets, 60 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1200_3.jpg?v=1787422864",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gnp",
        "healthy",
        "eyes",
        "tablets",
        "count",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 3.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791795376325",
      "vsf_explanation": "GNP Healthy Eyes is store-brand's AREDS-style eye-health formula, typically combining lutein, zeaxanthin, vitamin C, vitamin E, zinc, and copper. The evidence base for this stack in slowing age-related macular degeneration progression is strong (AREDS2 trial, Chew 2013 JAMA — lutein 10 mg + zeaxanthin 2 mg reduced progression risk ~10% vs. AREDS original formula). Without an on-label breakdown that confirms AREDS2 doses per active, however, this cannot be verified as therapeutically equivalent — store-brand AREDS analogs often under-dose lutein/zeaxanthin to save cost. Would move to Verified with explicit AREDS2 dose match per capsule and USP verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-methylfolate-7-5-mg-tablets-90-count",
      "title": "L-Methylfolate 7.5 mg Tablets, 90 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ML_Methylfolate7.5_bottle-front.webp?v=1787422864",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "methylfolate",
        "tablets",
        "count",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 72,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 253.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791795474629",
      "vsf_explanation": "L-Methylfolate 7.5 mg tablets — this is the lower Deplin-equivalent dose used clinically for depression adjunct in MTHFR-variant patients (Papakostas 2012 established 15 mg as efficacious in SSRI non-responders; 7.5 mg is the maintenance/entry step). The 5-MTHF form itself is best-in-class and bypasses MTHFR pathway bottlenecks that limit folic acid conversion. Held below Verified because the listing gives no manufacturer, no brand identity, and no way to verify whether the 7.5 mg is actual L-methylfolate calcium (Metafolin/Magnafolate) versus the racemic 6R,6S mix that some low-cost sources use — the S-isomer is not physiologically active. Would move to Verified with named manufacturer, L-isomer confirmation, and per-lot COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "potassium-iodide-ki-powder-100-grams",
      "title": "Potassium Iodide (KI) Powder, 100 Grams",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/61gL_Ww8EYL._SX466.jpg?v=1787422864",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "potassium",
        "iodide",
        "powder",
        "100",
        "grams",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 40,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 43.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791795507397",
      "vsf_explanation": "Bulk 100 g potassium iodide powder — legitimate use case is radiation-emergency thyroid blockade (FDA-approved KI at 130 mg for adults saturates thyroid iodide receptors and blocks radioactive I-131 uptake for ~24 hours; Zanzonico 2000). This is not a daily biohacking supplement — chronic high-dose KI can trigger iodine-induced hyperthyroidism (Jod-Basedow), hypothyroidism via Wolff-Chaikoff effect, and iodism (metallic taste, rash, salivary swelling); daily iodine RDA is only 150 mcg (0.15 mg). Bulk powder format also creates dosing-error risk — 100 g is ~770 adult emergency doses. Would move to Verified if listed as pre-dosed 65 mg or 130 mg tablets (FDA-recommended format) with named manufacturer and emergency-only use guidance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nature-made-vitamin-b12-1000-mcg-tablets-50-count",
      "title": "Nature Made Vitamin B12 1000 mcg Tablets, 50 Count",
      "vendor": "Nature Made",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/37.jpg?v=1787422864",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "made",
        "vitamin",
        "b12",
        "1000",
        "mcg",
        "tablets",
        "count",
        "nature",
        "made"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 62,
        "manufacturing": 78,
        "safety": 72,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 10.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791795409093",
      "vsf_explanation": "Nature Made is Pharmavite-owned and one of the very few mass-market brands with per-SKU USP verification (this line generally carries the USP Verified mark), which materially lifts manufacturing confidence over most drugstore B12. B12 evidence is well-established for deficiency correction and elevated homocysteine reduction (Doets 2013 dose-response meta-analysis; 1000 mcg oral is sufficient for most deficiency, even in older adults with reduced intrinsic factor). Held below Verified because Nature Made B12 is typically cyanocobalamin (a synthetic form that requires the body to cleave off the cyanide moiety and convert to methyl-B12 or adenosyl-B12) rather than the direct-active methylcobalamin or hydroxocobalamin. Would move to Verified 72+ with methylcobalamin form and sublingual delivery.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "windmill-probiotic-with-goat-milk-capsules-100-count",
      "title": "Windmill Probiotic with Goat Milk Capsules, 100 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/20211213103218_wmg101350x500.jpg?v=1787422864",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "windmill",
        "probiotic",
        "with",
        "goat",
        "milk",
        "capsules",
        "100",
        "count",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 50,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 11.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791795572933",
      "vsf_explanation": "Windmill is a legacy US pharmacy-channel supplement brand — acceptable manufacturing but not differentiated. Probiotic evidence is highly strain- and CFU-specific (Ritchie 2012 meta-analysis; specific strains like L. rhamnosus GG or S. boulardii have RCTs, unnamed 'acidophilus' does not). The listing gives no strain identification, no CFU count, and no expiration-guaranteed potency — three basic transparency requirements for any evidence-based probiotic. Goat milk medium is an unusual choice and adds a dairy allergen without disclosed strain-viability benefit. Would move to Verified with named strains (genus/species/strain designation), guaranteed CFU at expiration, and third-party viability testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gnp-triple-strength-omega-3-6-9-complex-enteric-coated-softgels-60-count",
      "title": "GNP Triple Strength Omega 3-6-9 Complex, Enteric Coated Softgels (60 Count)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/10092225.jpg?v=1787422864",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gnp",
        "triple",
        "strength",
        "omega",
        "complex",
        "enteric",
        "coated",
        "softgels",
        "count",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 6.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791795441861",
      "vsf_explanation": "Omega 3-6-9 blends are structurally problematic — Western diets are already omega-6 dominant (linoleic acid ubiquitous in seed oils), so adding more omega-6 while diluting the omega-3 content is the opposite of what most consumers need. This is GNP's store-brand version with unspecified EPA/DHA per serving; if a typical 3-6-9 blend at 1000 mg/serving yields only 150–250 mg of EPA+DHA, it's far below the 1–4 g/day range in cardiovascular trials (Bhatt 2019 REDUCE-IT; AHA 2019 advisory). Enteric coating is a small plus for burp/reflux tolerance. Would move to Verified only by dropping the 3-6-9 framing entirely and shifting to a concentrated EPA/DHA product with per-lot oxidation (TOTOX) testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "windmill-biotin-5000-mcg",
      "title": "Windmill Biotin 5000 Mcg",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/120873383.jpg?v=1787422864",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "windmill",
        "biotin",
        "5000",
        "mcg",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 8.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791795638469",
      "vsf_explanation": "Windmill biotin at 5000 mcg — a dose common in the hair/skin/nail category but with weak RCT support for cosmetic hair growth in non-deficient adults (Patel 2017 review — biotin supplementation for hair loss lacks placebo-controlled evidence outside genuine biotin deficiency or genetic biotinidase deficiency). Real safety issue at this dose: high-dose biotin causes false-low troponin, TSH, and hCG on many immunoassays (Bowen 2019 Endocr Pract; FDA safety communication 2019). Formulation is straightforward, and biotin RDA is only 30 mcg, so 5000 mcg is ~167× RDA with no clear added benefit. Would move to Verified with an on-label biotin/assay-interference warning and a hair-cycle-appropriate formulation (biotin + collagen peptides + zinc + iron).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gnp-flush-free-niacin-vitamin-b3-500-mg-capsules-100-count",
      "title": "GNP Flush-Free Niacin (Vitamin B3) 500 mg Capsules, 100 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/images_58.jpg?v=1787422864",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gnp",
        "flush",
        "free",
        "niacin",
        "vitamin",
        "500",
        "capsules",
        "100",
        "count",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 8.65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791795605701",
      "vsf_explanation": "\"Flush-free niacin\" is almost always inositol hexanicotinate (IHN), which does not release free niacin in vivo in humans and therefore does not deliver the lipid-modifying effects that made niacin famous in the Coronary Drug Project (1975) and the Canner 1986 follow-up — Meyers 2003 J Clin Lipidol found no meaningful LDL/HDL change with IHN 1500 mg. Consumers buying \"niacin\" for cholesterol get essentially placebo activity from IHN. Formulation label is technically accurate but functionally misleading in a cardiovascular-support context. Would need to be re-labeled as immediate-release niacinamide or nicotinic acid with realistic expectation-setting, and even then chronic ≥1 g/day niacin carries hepatotoxicity and glycemic risk (AIM-HIGH, HPS2-THRIVE trials showed no CV benefit at scale).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gnp-echinacea-extract-immune-support-capsules-90-count",
      "title": "GNP Echinacea Extract Immune Support Capsules (90 Count)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/10092261.jpg?v=1787422864",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gnp",
        "echinacea",
        "extract",
        "immune",
        "support",
        "capsules",
        "count",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 3.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791795736773",
      "vsf_explanation": "GNP store-brand echinacea extract — mid-tier mass-market herbal. Echinacea has modest but real RCT support for cold-symptom duration and severity (Karsch-Völk 2014 Cochrane; most positive trials used E. purpurea aerial parts as a fresh-pressed juice or standardized extract). This listing does not specify species (E. purpurea vs. E. angustifolia vs. E. pallida — pharmacological activity differs meaningfully), plant part (root vs. aerial), or standardization to alkylamides/echinacoside. Without those, this is a generic herbal capsule with plausible but unverifiable activity. Would move to Verified with species/part disclosure, standardization percent (e.g., 4% echinacosides), and preferably a fresh-juice or CO2-extract format.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "horbaach-l-methionine-powder-usp-grade-1000-grams-1-kg-bulk-supply",
      "title": "Horbäach L-Methionine Powder (USP Grade), 1000 Grams (1 kg) Bulk Supply",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/619h1xL0G0L._AC_UF1000_1000_QL80.jpg?v=1787422864",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "horb",
        "ach",
        "methionine",
        "powder",
        "usp",
        "grade",
        "1000",
        "grams",
        "bulk",
        "supply",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 55,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 247.75,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791795540165",
      "vsf_explanation": "Horbäach (Amazon-focused generic bulk brand) L-methionine at USP grade, 1 kg bulk powder. Methionine has legitimate uses (glutathione precursor via cysteine, sulfur donor for methylation, urinary acidifier at ~1 g/day) but recent longevity research (Miller 2005 Aging Cell, McIsaac 2016) suggests methionine restriction may extend lifespan in model organisms — so bulk methionine supplementation is a contested longevity call. USP grade designation is a real quality signal (~99% purity, low heavy-metal specs). Bulk powder creates dosing-error risk and is typically for practitioners or advanced users. Would move to Verified with a scoop or dosing chart, published COA per lot, and clearer indication/contraindication guidance (elevated methionine can worsen homocysteine without B12/folate cofactors).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "arkray-glucocard-vital-blood-glucose-test-strips",
      "title": "Arkray Glucocard Vital Blood Glucose Test Strips",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/121053610.jpg?v=1787422864",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "arkray",
        "glucocard",
        "vital",
        "blood",
        "glucose",
        "test",
        "strips",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 60,
        "manufacturing": 70,
        "safety": 65,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 10.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791795671237",
      "vsf_explanation": "Blood glucose test strips are FDA-regulated in vitro diagnostic devices, not supplements or nutraceuticals — they belong in a diabetes-testing or CGM catalog, not a supplement scoring rubric. Arkray Glucocard Vital is a legitimate mid-range strip system paired with its own meter. Included only because it appeared in the Pasteur product feed. Excluded from stack-quality calculations; consumers interested in metabolic-health biohacking should consider CGM (Dexcom Stelo, Abbott Lingo) for continuous rather than fingerstick data.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "geri-care-oyster-shell-calcium-with-vitamin-d3-250-mg-tablets-100-unit-dose",
      "title": "Geri-Care Oyster Shell Calcium with Vitamin D3, 250 mg Tablets, 100 Unit Dose",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Oyster-Shell-Calcium-250Mg-Tab-w-Vitamin-D-Bottle-of-100_5f1b722d-439c-423d-bba0-49eddd0c6f5c.f214e41616833881f2c15ba58a55e217.jpg?v=1787422864",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "geri",
        "care",
        "oyster",
        "shell",
        "calcium",
        "with",
        "vitamin",
        "250",
        "tablets",
        "100",
        "unit",
        "dose",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 48,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 10.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791795704005",
      "vsf_explanation": "Geri-Care is an institutional/long-term-care packaging brand, and this is oyster-shell calcium carbonate 250 mg with a token amount of D3. Calcium carbonate requires stomach acid for dissolution — a real absorption issue in the older adult / PPI-user population this format targets — versus calcium citrate which is absorbed independent of pH. Dose is low (250 mg is one-quarter of many adult targets, so multiple tablets required to reach the 800–1200 mg daily range), and Bolland 2010 BMJ meta-analysis raised cardiovascular concerns with high-dose calcium supplementation. Oyster-shell sources historically have variable lead content (need per-lot heavy-metal testing). Would move to Verified with calcium citrate form, K2-MK7 for arterial-calcium partitioning, and published heavy-metal COAs.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nat-rul-natural-acidophilus-con-pectina-capsulas-de",
      "title": "Nat-Rul Natural Acidophilus Con Pectina Cápsulas De",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/345139174.jpg?v=1787422864",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nat",
        "rul",
        "natural",
        "acidophilus",
        "con",
        "pectina",
        "psulas",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 62,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 7.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791795802309",
      "vsf_explanation": "Nat-Rul is a legacy Puerto Rico / Hispanic-market supplement brand — acidophilus with apple pectin, presented without strain identification, CFU count, or expiration-guaranteed potency. Generic \"L. acidophilus\" spans dozens of strains with wildly different clinical profiles (Sanders 2010, ISAPP consensus on probiotics — strain specificity is non-negotiable for evidence claims). Apple pectin adds a soluble-fiber prebiotic element, which is reasonable, but nothing on the label supports a meaningful probiotic claim. Would move to Standard with named strain (e.g., L. acidophilus NCFM), guaranteed CFU at expiration, delayed-release capsule, and third-party viability testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "life-extension-specially-coated-bromelain-500g-60ct",
      "title": "Life Extension Specially Coated Bromelain 500g/60ct",
      "vendor": "Life Extension",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/images_3aa4e601-dfc8-4f3d-85ac-7b6fbea53ec5.jpg?v=1787422864",
      "score": 76,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "life",
        "extension",
        "specially",
        "coated",
        "bromelain",
        "500g",
        "60ct",
        "life",
        "extension"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 75,
        "manufacturing": 76,
        "safety": 68,
        "transparency": 72,
        "sustainability": 58
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791795769541",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 71 → new 76. Evidence found: Brien S, Lewith G, Walker A, Hicks SM, Middleton D. Bromelain as a Treatment for Osteoarthritis: A Review of Clinical Studies. Evid Based Complement Alternat Med. 2004;1(3):251-257. | Walker AF et al. Bromelain reduces mild acute knee pain and improves well-being in a dose-dependent fashion in an open study of otherwise healthy adults. Phytomedicine. 2002;9(8):681-686.. Rationale: Enteric coating (referenced in product name 'Specially Coated') is meaningful for bromelain: it protects the proteolytic enzyme from gastric acid destruction, allowing systemic absorption for anti-inflammatory effects vs local digestive-only action. 500 mg dose aligns with Walker 2002 dose-response study. Uplift to 76 for delivery-technology plus therapeutic-dose alignment.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-b-1-100-mg-tablets-100-count-10x10-unit-dose",
      "title": "Vitamin B-1 100 mg Tablets, 100 Count (10x10) Unit Dose",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/25.jpg?v=1787422864",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "100",
        "tablets",
        "100",
        "count",
        "10x10",
        "unit",
        "dose",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 50,
        "manufacturing": 50,
        "safety": 68,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 22.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791795835077",
      "vsf_explanation": "Generic unit-dose blister-pack thiamine (B1) 100 mg — no manufacturer, no brand, no third-party testing. Thiamine 100 mg is a legitimate repletion dose (RDA 1.2 mg, so ~83× RDA; used clinically for Wernicke prevention in alcohol-use disorder and diabetic neuropathy — Beltramo 2008 for benfotiamine on diabetic neuropathy uses the more bioavailable fat-soluble form). Regular thiamine HCl (this format) has ~5% oral bioavailability — benfotiamine or TTFD (sulbutiamine class) achieves 5–10× better tissue delivery. Anonymous manufacturing collapses transparency. Would move to Standard with named US manufacturer, USP verification, and preferably benfotiamine form.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-e-liquid-oral-drops-30-ml",
      "title": "Vitamin E Liquid Oral Drops, 30 mL",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71oMYy9xQKL._AC_SX679.jpg?v=1787422864",
      "score": 53,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "liquid",
        "oral",
        "drops",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 48,
        "safety": 55,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 30.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791795867845",
      "vsf_explanation": "Anonymous liquid vitamin E drops with no dose, no isomer, no source, no manufacturer disclosed on the listing. The isomer distinction matters enormously: natural d-alpha-tocopherol has roughly 2× the bioactivity of synthetic dl-alpha-tocopherol (Blatt 2004), and modern research favors full mixed-tocopherols with gamma-tocopherol content over isolated alpha-tocopherol (Jiang 2001 — high-dose isolated alpha-tocopherol suppresses gamma-tocopherol tissue levels). The HOPE (Yusuf 2000) and SELECT (Klein 2011) trials also failed to show cardiovascular or prostate-cancer benefit with high-dose alpha-tocopherol and SELECT actually increased prostate cancer. Would move to Standard with named manufacturer, mixed tocopherols + tocotrienols, IU disclosed per drop, and USP verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "windmill-daily-vitamin-100-tablets",
      "title": "Windmill Daily Vitamin 100 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/204464065.jpg?v=1787422864",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "windmill",
        "daily",
        "vitamin",
        "100",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 7.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791795900613",
      "vsf_explanation": "Windmill Daily Vitamin is a legacy pharmacy-channel one-a-day multi — acceptable base coverage of RDA-level vitamins and minerals, but this generation of mass-market multis uses folic acid (not methylfolate), cyanocobalamin (not methylcobalamin), and calcium/magnesium in low-absorption oxide/carbonate forms. Physicians' Health Study II (Sesso 2012) showed modest long-term benefits from mainstream multivitamins on cataract and total cancer incidence, so the category has weak positive evidence at population scale. Tablet compression can reduce disintegration versus capsule/softgel. Would move to Verified with methylated B-vitamins, chelated minerals, USP verification, and third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ortho-molecular-products-mag-threonate-60-capsules",
      "title": "Ortho Molecular Products Mag Threonate 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/262-60_mag_threonate-min_dfa5345e-84de-4776-8217-a721ff4eeade.tmb-media470.png?v=1787422864",
      "score": 75,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ortho",
        "molecular",
        "products",
        "mag",
        "threonate",
        "capsules",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 82,
        "manufacturing": 78,
        "safety": 72,
        "transparency": 76,
        "sustainability": 55
      },
      "price": 59.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791795933381",
      "vsf_explanation": "Ortho Molecular Products' Mag Threonate uses licensed Magtein-format magnesium L-threonate — the only magnesium form shown in animal models to elevate brain magnesium concentration meaningfully (Slutsky 2010 Neuron — the anchor paper showing cognitive-memory improvement in aged rats via CSF Mg elevation), with follow-up human data on cognitive function in older adults (Liu 2016 J Alzheimers Dis). OMP is a legitimate practitioner-only brand with NSF-registered facility and per-lot COA availability. Formulation matches the studied 1500–2000 mg/day Magtein dose across capsules. Held below Elite because human RCT evidence remains limited (small trials, industry-linked), and this dose is stimulating for some people (evening use can disrupt sleep). Would move to Elite with additional independently-funded human trials at this dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sundance-potassium-gluconate-caplets-595-mg-100-tabs",
      "title": "Sundance, Potassium Gluconate Caplets, 595 mg, 100 Tabs",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l225_826a6320-b157-466c-944a-d4353b9571fb.jpg?v=1787422864",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sundance",
        "potassium",
        "gluconate",
        "caplets",
        "595",
        "100",
        "tabs",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791795998917",
      "vsf_explanation": "Sundance is a legacy Vitamin Shoppe / Windmill-adjacent value brand — mid-tier pharmacy-channel supplement. Potassium gluconate 595 mg per caplet delivers about 99 mg elemental potassium — the FDA-imposed OTC cap on single-tablet potassium in the US (which is why nearly every domestic potassium supplement lands at exactly 99 mg elemental). Adequate Intake for potassium is 3400 mg/day for men, so a tablet moves the needle only modestly; dietary potassium from fruit/vegetable sources delivers more with fewer GI effects. Safety-relevant: contraindicated with ACE inhibitors, ARBs, potassium-sparing diuretics, and renal insufficiency (hyperkalemia risk). Would move to Verified with clearer drug-interaction warnings on-label and pairing with magnesium (co-limiting for intracellular K).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "deplin-fc-l-methylfolate-ca-15mg-medical-food-90-capsules",
      "title": "Deplin FC L-methylfolate Ca 15mg Medical Food – 90 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/deplin_pdp1_3.webp?v=1787422869",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "deplin",
        "methylfolate",
        "15mg",
        "medical",
        "food",
        "capsules",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 20,
        "manufacturing": 20,
        "safety": 20,
        "transparency": 20,
        "sustainability": 20
      },
      "price": 849.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791796326597",
      "vsf_explanation": "Deplin FC is a prescription-tier medical food (15 mg L-methylfolate calcium), not an over-the-counter dietary supplement, and is out of scope for Vyvata's supplement rubric. The score is a placeholder reflecting that rubric mismatch, not a quality judgment — the underlying evidence is genuinely strong (Papakostas 2012: two RCTs showing 15 mg L-methylfolate as an SSRI adjunct beat placebo in SSRI partial responders) and the formulation is best-in-class for this drug class. But it is dispensed under practitioner supervision for real reasons: interaction risk with methotrexate and some SSRIs, and monitoring needs for bipolar activation. A prescription medical-food framework, not the consumer-supplement rubric, is the right lens for this product; a Verified badge here would incorrectly imply it's fine for unsupervised routine use.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "natures-measure™-essential-man-multivitamin-amp-mineral-supplement-90-tablets",
      "title": "Nature's Measure™ Essential Man – Multivitamin &amp; Mineral Supplement (90 Tablets)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/imagen_2026-02-03_140539412.png?v=1787422869",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "measure",
        "essential",
        "man",
        "multivitamin",
        "amp",
        "mineral",
        "supplement",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 52,
        "manufacturing": 52,
        "safety": 60,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 13.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791796359365",
      "vsf_explanation": "Nature's Measure is a Dollar Tree private-label brand — bargain-tier multivitamins built to hit RDA percentages on tablet at the lowest possible cost. Multivitamin evidence in generally-nourished men is weak (Physicians' Health Study II, Sesso 2012, showed modest benefits on cataract and cancer incidence only with long-term use), and cheap-tier formulas typically use folic acid rather than methylfolate, cyanocobalamin over methylcobalamin, and magnesium oxide over glycinate — all lower-absorption forms. No USP or NSF verification. Tablet compression can further reduce disintegration. Would move to Verified with methylated B-vitamins, chelated minerals, USP verification, and third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-c-tablets-500-mg-unit-dose-blister-pack-100-tablets",
      "title": "Vitamin C Tablets 500 mg – Unit Dose Blister Pack (100 Tablets)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/13_c9a402b2-9f13-4d79-91d3-904829f4e999.jpg?v=1787422869",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "tablets",
        "500",
        "unit",
        "dose",
        "blister",
        "pack",
        "100",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 68,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 24.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791796424901",
      "vsf_explanation": "Generic unit-dose blister-pack ascorbic acid 500 mg with no brand identity on the listing — this is institutional/hospital-supply repackaging, not a consumer supplement with any accountability chain. Vitamin C evidence itself is solid for immune support with regular use (Hemilä 2013 Cochrane review, ~8% reduction in cold duration for adults) and 500 mg is a reasonable maintenance dose above the 90 mg RDA. But no named manufacturer, no third-party testing disclosed, no COA, no source information — a scoring rubric that cares about accountability must penalize anonymous manufacture. Would move solidly into Standard with a named US manufacturer, USP verification, and buffered/liposomal form disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gericare-bisacodyl-5mg-stimulant-laxative-enteric-coated-tablets-fast-acting-constipation-relief-200-count",
      "title": "GeriCare Bisacodyl 5mg Stimulant Laxative Enteric Coated Tablets, Fast-Acting Constipation Relief 200 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/51mY4Y1UZXL._AC_SX569.jpg?v=1787422869",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gericare",
        "bisacodyl",
        "5mg",
        "stimulant",
        "laxative",
        "enteric",
        "coated",
        "tablets",
        "fast",
        "acting",
        "constipation",
        "relief",
        "200",
        "count",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 40,
        "transparency": 65,
        "sustainability": 45
      },
      "price": 3.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791796457669",
      "vsf_explanation": "Bisacodyl is an OTC stimulant laxative drug (regulated under the FDA OTC monograph, not the DSHEA supplement framework) — it works by directly stimulating enteric nerves and colonic smooth muscle. It is not a biohacking supplement and does not belong in a Vyvata protocol; chronic use is associated with cathartic colon, electrolyte disturbance, and dependency, and it is contraindicated in undiagnosed abdominal pain. Included here only because Pasteur listed it alongside supplements. Scored out of scope; consumers seeking a gentler biohacking-appropriate motility aid should consider magnesium citrate, prunes, or soluble fiber (psyllium).",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "gnp-melatonin-tablets-5-mg-unit-dose-ud-100-count-10-x-10-blister-packs",
      "title": "GNP Melatonin Tablets, 5 mg, Unit Dose (UD), 100 Count (10 x 10 Blister Packs)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3YX31YzeoW9G3308r0h6zSC0VoRAwa0mT7Km1Hte.jpg?v=1787422869",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gnp",
        "melatonin",
        "tablets",
        "unit",
        "dose",
        "100",
        "count",
        "blister",
        "packs",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 27.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791796490437",
      "vsf_explanation": "Good Neighbor Pharmacy (GNP) is AmerisourceBergen's independent-pharmacy store brand — mid-tier private label with acceptable pharmaceutical-channel manufacturing but no differentiated formulation. Melatonin at 5 mg is well above the physiologic-dose window of 0.3–1 mg that Zhdanova 2001 and Herxheimer 2002 (Cochrane on jet-lag) actually validated; supraphysiologic doses like 5 mg often desensitize MT1/MT2 receptors and cause next-morning grogginess without improving sleep quality (Erland 2017 J Clin Sleep Med lab-testing of commercial melatonin also found wide label vs. actual content variance). Blister-pack unit-dose form limits oxidation, which is a small plus. Would move to Verified at 0.3–1 mg dose, third-party assay confirming content, and no other actives added.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "21st-century-melatonin-tablets-capsules-c-u-11-piece-dealer-lot",
      "title": "21st Century Melatonin Tablets/Capsules (C/U) - 11 Piece Dealer Lot",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/47.jpg?v=1787422869",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "21st",
        "century",
        "melatonin",
        "tablets",
        "capsules",
        "piece",
        "dealer",
        "lot",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 78.65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791796523205",
      "vsf_explanation": "This is a wholesale liquidation lot — an 11-piece mixed pallet of 21st Century melatonin in unknown doses and forms rather than a single defined SKU. 21st Century itself is a mass-market value brand acceptable in single-SKU form, but a dealer/liquidation lot with unspecified dose and mixed tablets/capsules cannot be honestly evaluated: dose is the entire safety story with melatonin (Erland 2017 documented label-actual variance up to +478% in commercial melatonin, and doses ≥3 mg exceed the physiologic range validated by Zhdanova 2001). Transparency and formulation collapse without a specified SKU. Would need to be re-listed as an individual defined-dose product to score meaningfully.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "neo-g-mens-energizing-compression-socks-black-x-large",
      "title": "Neo G Men's Energizing Compression Socks – Black, X-Large",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l400_8.jpg?v=1787422869",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "neo",
        "men",
        "energizing",
        "compression",
        "socks",
        "black",
        "large",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 65,
        "safety": 60,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 16.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791796555973",
      "vsf_explanation": "Compression garment, not a supplement or nutraceutical — evaluated only because it was in the Pasteur product feed. Medical-grade graduated compression (15–20 or 20–30 mmHg) does have evidence for reducing DVT risk and lower-limb edema (Sachdeva 2018 Cochrane), but it belongs in an assistive-device catalog, not a supplement scoring rubric. Neo G is a legitimate British compression brand; scoring is neutral because the product itself is fine — it just isn't a Vyvata-scope item. Excluded from stack-quality calculations.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "gnp-maximum-strength-cinnamon-500mg-capsules-100-count",
      "title": "GNP Maximum Strength Cinnamon 500mg Capsules, 100 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_7_0534f6a2-9318-4fe6-9ad1-53a845ac3f5f.webp?v=1787422869",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gnp",
        "maximum",
        "strength",
        "cinnamon",
        "500mg",
        "capsules",
        "100",
        "count",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 4.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791796588741",
      "vsf_explanation": "GNP store-brand cinnamon 500 mg per capsule — dose is on the low end of the 1–6 g/day range studied for post-prandial glucose modulation (Allen 2013 meta-analysis found small but statistically significant fasting-glucose reductions of ~24 mg/dL, but heterogeneity was high and clinical relevance debated). Label does not distinguish Cassia (Cinnamomum aromaticum) from Ceylon (C. verum) — this matters because Cassia is high in coumarin (hepatotoxicity risk at chronic doses; EFSA TDI 0.1 mg/kg BW), and mass-market cinnamon is almost always Cassia. Store-brand manufacturing is standard-tier without third-party COA. Would move to Verified with Ceylon-specific sourcing, coumarin content disclosed, and 1000+ mg per serving matching studied doses.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-d3-10-mcg-400-iu-tablets-100-count-unit-dose-ud",
      "title": "Vitamin D3 10 mcg (400 IU) Tablets, 100 Count, Unit Dose (UD)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/31.jpg?v=1787422869",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "mcg",
        "400",
        "tablets",
        "100",
        "count",
        "unit",
        "dose",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 68,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 28.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791796621509",
      "vsf_explanation": "Generic unit-dose blister-pack vitamin D3 at 400 IU — this is the 1997 IOM Adequate Intake, not a level supported by modern serum 25(OH)D data. Endocrine Society (Holick 2011) and most current supplementation trials use 1000–2000 IU/day minimum for repletion, and the VITAL trial (Manson 2019) used 2000 IU. 400 IU rarely moves serum 25(OH)D meaningfully in deficient adults. Anonymous manufacturer with no brand accountability, no third-party testing, and no cofactors (K2, magnesium). Would move to Standard-Verified at 1000–2000 IU with named manufacturer, USP verification, and K2 MK-7 pairing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ocean-blue-professional-2100-omega-3-minis-2100mg-fish-oil-orange-flavor",
      "title": "Ocean Blue Professional 2100 Omega-3 Minis – 2100mg Fish Oil, Orange Flavor",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71sZkCmBC_L._AC_UL495_SR435_495.jpg?v=1787422876",
      "score": 74,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ocean",
        "blue",
        "professional",
        "2100",
        "omega",
        "minis",
        "2100mg",
        "fish",
        "oil",
        "orange",
        "flavor",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 76,
        "manufacturing": 74,
        "safety": 75,
        "transparency": 72,
        "sustainability": 62
      },
      "price": 22.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791797113029",
      "vsf_explanation": "Ocean Blue Professional 2100 is a high-concentrate fish oil delivering roughly 2100 mg total omega-3s per serving with a favorable EPA:DHA ratio in small softgel format — a genuine therapeutic-dose omega-3, unlike typical drugstore 1000 mg fish oil that yields only ~300 mg EPA+DHA. Evidence for high-dose EPA/DHA on triglycerides and cardiovascular risk is strong (Bhatt 2019 REDUCE-IT trial for icosapent ethyl at 4 g/day; Skulas-Ray 2019 AHA advisory). Ocean Blue publishes IFOS third-party purity/oxidation testing on their professional line, which is a real quality signal. Below Elite because the label uses a triglyceride-form fish oil rather than the more bioavailable re-esterified TG or phospholipid form, and per-lot COAs aren't always posted publicly. Would move to Elite with IFOS 5-star ratings consistently posted plus published oxidation (TOTOX) values per lot.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ortho-molecular-products-botanicalm-pm-30-capsules",
      "title": "Ortho Molecular Products Botanicalm PM 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1521174509.jpg?v=1787422878",
      "score": 73,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ortho",
        "molecular",
        "products",
        "botanicalm",
        "capsules",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 76,
        "manufacturing": 78,
        "safety": 72,
        "transparency": 74,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791797244101",
      "vsf_explanation": "Ortho Molecular Products (OMP) is a legitimate practitioner-channel brand, and Botanicalm PM is their botanical sleep-onset formula built around magnolia bark, lemon balm, jujube, and passionflower — herbs with fair-to-moderate RCT support for reducing sleep-onset latency and calming pre-sleep hyper-arousal (Kennedy 2006 for lemon balm on acute stress; Chen 2018 for jujube seed extract on sleep quality). OMP holds NSF-registered facility certifications on their line and discloses standardized extracts on the label, which lifts formulation and manufacturing above mass-market herbal sleep aids. Below Elite because the individual herbal doses per capsule are modest (this is a 30-count practitioner sleep formula, not a nightly-therapeutic mega-dose) and total-per-active mg disclosure varies by lot. Would move to Verified-high/Elite with independent COAs published per lot and clearer per-active standardization at the label.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "inflammation-support-gummies",
      "title": "Inflammation Support Gummies",
      "vendor": "Baker's Botanics",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BB_Inflammation_Bottle_Web_Final.jpg?v=1787423221",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "inflammation",
        "support",
        "gummies",
        "baker",
        "botanics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 52,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 55,
        "sustainability": 58
      },
      "price": 35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791814578373",
      "vsf_explanation": "Baker's Botanics Inflammation Support Gummies is a small-batch herbalist product in the anti-inflammatory botanical category. Typical ingredients here — curcumin, ginger, boswellia, quercetin — have real RCT support (Daily 2016 curcumin meta-analysis for joint pain uses 1,000-1,500 mg/day of standardized curcumin) but the gummy format cannot deliver those doses without a 4-6 gummy serving. Held in Standard by the dose-ceiling constraint of gummies, no per-active mg disclosure, and no standardization or bioavailability-enhancer (piperine, phytosome) callouts. Would move to Verified with a standardized 95% curcuminoid extract + piperine, per-active mg disclosure, and third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "menstrual-cycle-support-box",
      "title": "Menstrual Cycle Support Box",
      "vendor": "Baker's Botanics",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Menstrul_Cycle_Support_Box.jpg?v=1787423226",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "menstrual",
        "cycle",
        "support",
        "box",
        "baker",
        "botanics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 58
      },
      "price": 40,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791814774981",
      "vsf_explanation": "Menstrual Cycle Support Box is a small-batch herbalist offering from Baker's Botanics, typically a multi-product bundle for cycle-phase support. Common ingredients in this category — chaste tree (vitex), evening primrose oil, magnesium, and dong quai — have modest RCT support for PMS symptoms (vitex is the strongest: Schellenberg 2001, 20 mg/day for 3 cycles). Held in Standard by the box-format opacity (no consolidated per-active dose visibility), no third-party testing disclosure typical of small herbalist brands, and gummy/tea format dose limitations. Would move to Verified with a per-product dose panel, vitex standardization to aucubin/agnuside, and third-party testing certificates.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "anxiety-support-gummies",
      "title": "Anxiety Support  Gummies",
      "vendor": "Baker's Botanics",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BB_Anxiety_Bottle_copy.jpg?v=1787423226",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "anxiety",
        "support",
        "gummies",
        "baker",
        "botanics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 52,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 55,
        "sustainability": 58
      },
      "price": 35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791814742213",
      "vsf_explanation": "Baker's Botanics Anxiety Support Gummies is a small-batch herbalist gummy in the stress/mood category. This class typically includes ashwagandha, L-theanine, chamomile, passionflower, or lemon balm — ashwagandha at 300-600 mg/day of KSM-66 has the strongest RCT support (Chandrasekhar 2012), and L-theanine at 200 mg has acute anxiolytic evidence (Kimura 2007). Held in Standard by the gummy format's dose ceiling (typically 100-300 mg total active per gummy, well below therapeutic ashwagandha ranges), no per-active mg disclosure, and no standardization callouts. Would move to Verified with KSM-66 or Sensoril branded ashwagandha at studied doses, per-active mg on the label, and third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "purple-amaranth-leaf-powder",
      "title": "Purple Amaranth Leaf Powder",
      "vendor": "Yaga Lifestyle",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Purple_Amaranth1.png?v=1787423264",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "purple",
        "amaranth",
        "leaf",
        "powder",
        "yaga",
        "lifestyle"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 65,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791816806597",
      "vsf_explanation": "Amaranthus leaf powder is best treated as a leafy-green food ingredient than as a therapeutic supplement — it delivers real dietary iron, calcium, folate, magnesium and modest polyphenol/betalain content, but with none of these at doses that meaningfully move a clinical endpoint versus eating amaranth or other dark leafy greens as food. Human RCT literature on isolated amaranth-leaf powder is essentially absent; most cited nutrition data is compositional. Loose powder with no per-serving nutrient panel, no standardization, no third-party heavy-metal or oxalate testing surfaced in the title (leafy greens can concentrate oxalates and nitrates). Safety profile is genuinely reasonable at food-scale intake, which is why the score sits at the top of Rejected rather than lower. Would move to Standard 60+ with a nutrition panel per serving, third-party heavy-metal COA, and honest 'nutrient-dense whole food' positioning rather than supplement-style benefit claims.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "jamaican-pimento-whole-dried-allspice-berries",
      "title": "Jamaican Pimento - Whole Dried Allspice Berries",
      "vendor": "Yaga Lifestyle",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/PIM1.png?v=1787423264",
      "score": 22,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "jamaican",
        "pimento",
        "whole",
        "dried",
        "allspice",
        "berries",
        "yaga",
        "lifestyle"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 25,
        "manufacturing": 40,
        "safety": 65,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 12.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791816872133",
      "vsf_explanation": "Autofail on out_of_scope_for_biohacking: whole dried Pimenta dioica berries are a culinary spice (allspice), not a supplement formulation, and this SKU is packaged and sold as a cooking ingredient. Allspice essential oil (rich in eugenol) has some preclinical antimicrobial and antioxidant data, but there is no human dosing protocol, no capsule/extract format here, and no positioning as a biohacker intervention. Belongs in a spice or grocery catalog, not the Vyvata supplement index.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "yagamentary-healing-oil",
      "title": "Yagamentary Healing Oil",
      "vendor": "Yaga Lifestyle",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Yagamentary_Healing_Oil_1.png?v=1787423264",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "yagamentary",
        "healing",
        "oil",
        "yaga",
        "lifestyle"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 25,
        "manufacturing": 30,
        "safety": 35,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791816839365",
      "vsf_explanation": "Autofail on unverified_medical_claim: the product is literally named 'Healing Oil', which is an unqualified therapeutic claim without FDA drug approval or supporting clinical evidence for any defined indication. The title also discloses no ingredients, no active compounds, no percentages and no intended use route, which independently fails transparency. As a topical it also falls outside the Vyvata biohacking-supplement scope, so it could equally be flagged out_of_scope_for_biohacking; the naming-level medical claim is the stronger autofail. Cannot reach Standard without a full renaming, ingredient disclosure, and removal of therapeutic-claim language.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "yaga-mud-volcanic-mineral-clay-mask-for-face-and-body-4-oz",
      "title": "Yaga Mud | Volcanic Mineral Clay Mask for Face and Body | 4 oz",
      "vendor": "Yaga Lifestyle",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/YagaMudVolcanicMineralClayMaskforFaceandBody4oz-1.png?v=1787423264",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "yaga",
        "mud",
        "volcanic",
        "mineral",
        "clay",
        "mask",
        "for",
        "face",
        "and",
        "body",
        "yaga",
        "lifestyle"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 28,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791816904901",
      "vsf_explanation": "Autofail on out_of_scope_for_biohacking: this is a topical volcanic-clay face and body mask cosmetic, explicitly labeled for external application, not an ingestible or systemically-acting biohacking supplement. Clay masks have a legitimate cosmetic role (sebum absorption, mild exfoliation) but no evidence base for 'mineral repletion through the skin' or systemic detoxification through mask use — trans-epidermal mineral absorption is negligible for the elements typically cited. Belongs in a skincare catalog, not the Vyvata supplement index.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "organic-jamaican-turmeric-supplement-60-vegan-capsules",
      "title": "Organic Jamaican Turmeric Supplement - 60 Vegan Capsules",
      "vendor": "Yaga Lifestyle",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/OrganicJamaicanTurmericSupplement-60VeganCapsules-1.png?v=1787423269",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "jamaican",
        "turmeric",
        "supplement",
        "vegan",
        "capsules",
        "yaga",
        "lifestyle"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 60,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791817298117",
      "vsf_explanation": "Organic Jamaican turmeric in vegan capsule form. Turmeric/curcumin has meaningful evidence for anti-inflammatory effects at studied doses (Chandran & Goel 2012 for RA; Sahebkar 2016 meta on CRP), but that evidence base rests on standardized 95% curcuminoid extracts combined with a bioavailability enhancer (piperine or a phytosome/Meriva delivery), not on whole ground turmeric root powder. The title discloses no curcuminoid % standardization, no per-capsule mg, and no bioavailability partner, which drops raw turmeric to roughly 2-3% curcuminoids with poor absorption. Manufacturing is a small Jamaican herbal brand with no visible third-party COA, USP, or NSF certification. Would move to Standard 60+ with disclosed curcuminoid standardization and a bioavailability enhancer, and to Verified 70+ with a Meriva/BCM-95 grade extract plus published third-party heavy-metal testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "jamaican-thick-purple-gold-irish-sea-moss",
      "title": "Jamaican (Thick) Purple-Gold Irish Sea Moss",
      "vendor": "Yaga Lifestyle",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Purple_Gold_Irish_Sea_Moss.png?v=1787423269",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "jamaican",
        "thick",
        "purple",
        "gold",
        "irish",
        "sea",
        "moss",
        "yaga",
        "lifestyle"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791817330885",
      "vsf_explanation": "Wildcrafted Chondrus crispus / Gracilaria (marketed as 'Irish moss') from Jamaica. Sea moss does contain iodine, iron, potassium and a small amount of soluble fiber, but the near-universal marketing claims (thyroid support, mineral repletion of '92 of 102 minerals in the body', mucus removal, libido) have no credible RCT support — the '92 minerals' claim is a Dr Sebi-lineage myth. Real safety issue: wild-harvested sea moss varies wildly in iodine (routinely 500-5000+ mcg per serving, versus the 150 mcg RDA and 1,100 mcg upper limit) and can concentrate arsenic, cadmium and lead, and no third-party COA is visible here. Title alone avoids overt disease claims so it clears autofail, but the evidence-to-hype ratio is severe. Would move to Standard 55+ with per-lot iodine and heavy-metal COAs and honest label claims limited to mineral content.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "duck-flower-detox-flor-de-pato-palo-guaco-dr-sebi-approved-alkaline-herbal-cleanse",
      "title": "Duck Flower Detox - Flor de Pato, Palo Guaco, Dr Sebi Approved Alkaline Herbal Cleanse",
      "vendor": "Yaga Lifestyle",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Duck_Flower_Detox.png?v=1787423269",
      "score": 15,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "duck",
        "flower",
        "detox",
        "flor",
        "pato",
        "palo",
        "guaco",
        "sebi",
        "approved",
        "alkaline",
        "herbal",
        "cleanse",
        "yaga",
        "lifestyle"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 20,
        "manufacturing": 25,
        "safety": 10,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 38.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791817265349",
      "vsf_explanation": "Autofail on unverified_medical_claim: the product name bundles three separate red flags — 'Detox', 'Cleanse', and 'Dr Sebi Approved Alkaline'. Duck flower (Aristolochia grandiflora / Flor de Pato) is a traditional Caribbean purgative that induces violent vomiting and diarrhea within hours of ingestion; the resulting fluid loss is marketed as 'toxin release' but is simple laxative/emetic action with zero evidence for actual xenobiotic clearance beyond what a functioning liver and kidney already do. The Aristolochia genus is also globally associated with aristolochic-acid nephrotoxicity and urothelial carcinoma (IARC Group 1 carcinogen), which alone should keep this off any responsible supplement shelf. The 'Dr Sebi approved alkaline' framing invokes a pseudoscientific model already documented in FDA warning letters to Sebi's company for disease-cure claims, and body-pH is homeostatically defended around 7.4 regardless of ingested herbs. There is no formulation, dose, or third-party manufacturing story that would rescue this SKU.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "jamaican-guaco-mikania-wildcrafted-air-dried-dr-sebi-approved-alkaline-herb",
      "title": "Jamaican Guaco Mikania (Wildcrafted, Air-Dried, Dr Sebi Approved Alkaline Herb)",
      "vendor": "Yaga Lifestyle",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/JamaicanGuacoMikania_Wildcrafted_Air-Dried_DrSebiApprovedAlkalineHerb.png?v=1787423269",
      "score": 28,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "jamaican",
        "guaco",
        "mikania",
        "wildcrafted",
        "air",
        "dried",
        "sebi",
        "approved",
        "alkaline",
        "herb",
        "yaga",
        "lifestyle"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 35,
        "manufacturing": 30,
        "safety": 35,
        "transparency": 40,
        "sustainability": 55
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791817396421",
      "vsf_explanation": "Autofail on unverified_medical_claim for the 'Dr Sebi Approved Alkaline Herb' branding, which invokes the pseudoscientific alkaline-body/alkaline-cure framework that FDA warning letters cited in action against Dr Sebi's company. Blood pH is tightly homeostatically buffered around 7.35-7.45 by the lungs and kidneys; no oral herb meaningfully shifts it, and 'alkaline herb' is a marketing category, not a pharmacological one. Setting the branding aside, Mikania (guaco) is a traditional Latin American cough/bronchial herb with a small body of preclinical work on coumarin content and mild bronchodilation, but no rigorous RCT support at any defined dose. Wildcrafted air-dried loose herb with no standardization, no coumarin quantification, and no third-party COA. Would still not clear autofail without a full relaunch that drops the Dr Sebi and alkaline framing.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "jamaican-dog-blood-bush-fertility-herb-rivinia-humilis",
      "title": "Jamaican Dog Blood Bush | Fertility Herb | Rivinia Humilis",
      "vendor": "Yaga Lifestyle",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Dog_Blood_Bush_1.png?v=1787423269",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "prenatal",
      "tokens": [
        "jamaican",
        "dog",
        "blood",
        "bush",
        "fertility",
        "herb",
        "rivinia",
        "humilis",
        "yaga",
        "lifestyle"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 35,
        "manufacturing": 35,
        "safety": 30,
        "transparency": 40,
        "sustainability": 55
      },
      "price": 28.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791817232581",
      "vsf_explanation": "Autofail on unverified_medical_claim: the SKU is named 'Fertility Herb' in the title, which is an unqualified structure/function-plus-disease claim (infertility is a medical condition) with no supporting RCT evidence for Rivina humilis in human reproduction. The Petiveriaceae/Phytolaccaceae family Rivina genus is known primarily as a wild ornamental with limited ethnobotanical use; the modern phytochemistry literature is sparse and includes reports of saponins and alkaloids with unknown reproductive-safety profile — the opposite of what a 'fertility herb' recommendation requires. Wildcrafted loose herb with no standardization, no third-party COA, and no drug-interaction or pregnancy warning surfaced in the title. Cannot clear Standard tier under any formulation improvement while the fertility claim remains on the label.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "jamaican-kalawalla-herb-calaguala-polypodium-sp-2-oz-coarse-powder",
      "title": "Jamaican Kalawalla Herb | Calaguala | Polypodium Sp. | 2 oz coarse powder",
      "vendor": "Yaga Lifestyle",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/JamaicanKalawalla1.png?v=1787423270",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "jamaican",
        "kalawalla",
        "herb",
        "calaguala",
        "polypodium",
        "coarse",
        "powder",
        "yaga",
        "lifestyle"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791817494725",
      "vsf_explanation": "Loose 2 oz coarse-powder Polypodium — species left as 'Sp.', which matters because the fern with actual clinical evidence is Polypodium leucotomos (Fernblock/Heliocare extract), studied for photoprotection and oxidative stress (Nestor 2015; Kohli 2017 for polymorphous light eruption). The genus contains many species with different phytochemistry, and 'Polypodium Sp.' plus 'Jamaican Kalawalla' (a Caribbean common name often applied to P. decumanum) does not confirm the studied leucotomos species or the standardized extract used in the RCTs. Coarse loose powder cannot deliver the 240-480 mg standardized-extract dosing from the photoprotection trials. No standardization %, no third-party COA. Would move to Standard 60+ with confirmed P. leucotomos species ID, a defined polyphenol standardization, and per-serving mg matched to the published protocols; capsule delivery would help further.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cordoncillo-negro-piper-aduncum-matico",
      "title": "Cordoncillo Negro | Piper aduncum | Matico",
      "vendor": "Yaga Lifestyle",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Cordonegro1.png?v=1787423269",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cordoncillo",
        "negro",
        "piper",
        "aduncum",
        "matico",
        "yaga",
        "lifestyle"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791817363653",
      "vsf_explanation": "Traditional Latin American herb Piper aduncum (matico), historically used topically for wound care and internally for gastric complaints. Modern literature exists for the essential oil (dillapiole, piperitone) and shows in vitro antimicrobial and antileishmanial activity, but human RCT evidence is essentially absent and dillapiole itself carries hepatotoxicity signals in preclinical work. Sold as a loose raw herb with no active-compound standardization, no per-serving dose, and no third-party COA from Yaga. Title thankfully avoids the Dr Sebi / disease-cure framing, so it clears autofail, but the evidence base is not strong enough to reach Standard tier. Would move to Standard 55+ with species-confirmed identity, a defined essential-oil or dillapiole quantification, hepatic-safety disclosure, and a documented traditional-use dose range.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "raw-unrefined-jamaican-black-castor-oil",
      "title": "Raw Unrefined Jamaican Black Castor Oil",
      "vendor": "Yaga Lifestyle",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Black_Castor_Oil_1.png?v=1787423270",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "raw",
        "unrefined",
        "jamaican",
        "black",
        "castor",
        "oil",
        "yaga",
        "lifestyle"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 40,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 22.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791817429189",
      "vsf_explanation": "Autofail on out_of_scope_for_biohacking: raw unrefined Jamaican black castor oil is a topical hair-and-scalp cosmetic, not an ingestible biohacking supplement. Oral castor oil is a stimulant laxative (ricinoleic acid activating EP3 prostanoid receptors) with meaningful GI side effects and no evidence for the wellness benefits marketed around the black-castor category. Even considered as a cosmetic, the hair-growth claims most commonly attached to JBCO have no controlled human trial support. This SKU belongs in a hair/scalp cosmetics catalog, not the Vyvata supplement/biohacker index.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "jamaican-purple-sea-moss",
      "title": "Jamaican Purple Sea Moss",
      "vendor": "Yaga Lifestyle",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Purple_Sea_Moss_1.png?v=1787423269",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "jamaican",
        "purple",
        "sea",
        "moss",
        "yaga",
        "lifestyle"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 48,
        "manufacturing": 42,
        "safety": 50,
        "transparency": 52,
        "sustainability": 58
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791817461957",
      "vsf_explanation": "Wildcrafted purple Jamaican sea moss (Chondrus/Gracilaria). Same evidence gap as the thick purple-gold SKU: the trace-mineral content is real but modest, and the '92 minerals' / thyroid / mucus / libido claims that dominate the sea-moss category have no RCT support and trace to Dr Sebi-lineage marketing. Purple pigmentation (from anthocyanins/phycoerythrin) does not translate to demonstrated in-vivo antioxidant benefit at food-scale doses. Bigger practical concern is variable iodine content (routinely 500-5000+ mcg per teaspoon versus a 1,100 mcg tolerable upper limit) and heavy-metal accumulation from ocean sourcing, with no per-lot COA disclosed. Title stays clear of overt disease claims, so it avoids autofail, but does not reach Standard. Would move to Standard 55+ with published per-lot iodine and heavy-metal testing and honest label claims.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "jamaican-damiana-ram-goat-dash-along",
      "title": "Jamaican Damiana | Ram Goat Dash Along",
      "vendor": "Yaga Lifestyle",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/JamaicanDamianaRamGoatDashAlong-1.png?v=1787423269",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "jamaican",
        "damiana",
        "ram",
        "goat",
        "dash",
        "along",
        "yaga",
        "lifestyle"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791817560261",
      "vsf_explanation": "Traditional Caribbean 'Ram Goat Dash Along' is often botanically Turnera diffusa (damiana) or the closely related Turnera ulmifolia; both have long ethnobotanical use as aphrodisiacs and mild anxiolytics. The modern human evidence is thin — one small combination trial (ArginMax; Ito 2001/2006) that used damiana alongside arginine, ginseng and vitamins, plus preclinical MAO-A inhibition data — none of which isolates damiana at a specific studied dose. Sold as loose raw herb with no standardization, no per-serving mg, and no third-party COA. Species identity ambiguity between Turnera diffusa and T. ulmifolia is a specific concern given the same common name is applied to both in Jamaica. Would move to Standard 55+ with confirmed species, a defined dose range matched to traditional use, and third-party identity testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "jamaican-guinea-hen-weed-anamu",
      "title": "Jamaican Guinea Hen Weed (Anamu)",
      "vendor": "Yaga Lifestyle",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/JamaicanGuineaHenWeed_Anamu_1.png?v=1787423269",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "jamaican",
        "guinea",
        "hen",
        "weed",
        "anamu",
        "yaga",
        "lifestyle"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 40,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 18.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791817527493",
      "vsf_explanation": "Petiveria alliacea (guinea hen weed / anamu) is a traditional Caribbean and Amazonian herb with a preclinical literature on dibenzyl trisulfide and organosulfur constituents suggesting immunomodulatory and cytotoxic activity in cell lines, but no controlled human trials at defined doses. The category carries a real safety flag the title does not disclose: guinea hen weed is used traditionally as an abortifacient and is contraindicated in pregnancy, and human case reports have raised concerns about hypoglycemia and CNS effects at higher doses. Loose raw herb, no standardization, no per-serving dose, no third-party COA. Title alone does not make disease-cure claims so it stays a Rejected-tier product rather than an autofail. Would move to Standard 55+ with clear pregnancy contraindication, defined dose range, and confirmed identity testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "maxi-lysine-complex™-immune-boost-dietary-supplement-120-maxicaps",
      "title": "Maxi Lysine Complex™ – Immune Boost Dietary Supplement (120 Maxicaps)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/image_21c843c5-1abd-4a3b-bcb2-6cb88fe51c56.png?v=1787423373",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "maxi",
        "lysine",
        "complex",
        "immune",
        "boost",
        "dietary",
        "supplement",
        "120",
        "maxicaps",
        "singers",
        "health",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 48
      },
      "price": 36.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791823950021",
      "vsf_explanation": "Maxi Lysine Complex is an L-lysine capsule (120-count) marketed for immune support. Lysine has meaningful RCT evidence for reducing HSV-1 (cold sore) recurrence at 1-3 g/day (Griffith 1987, Milman 1980), so lysine has a legitimate targeted use case, though 'Immune Boost' is looser marketing framing than the actual evidence supports. Standard-tier positioning reflects an honest single-active formulation but no disclosed per-cap mg on the front label, no third-party testing, and a distribution channel (Singers Health) with limited manufacturing transparency. Would move to Verified with a clear 500-1000 mg per cap disclosure, honest 'cold sore support' positioning rather than generic immune-boost claims, and USP verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "forever-fiber-these-packets-feature-four-types-of-fiber-including-fructooligosaccharides-which-is-also-a-prebiotic-30packets",
      "title": "Forever Fiber These packets feature four types of fiber – including fructooligosaccharides, which is also a prebiotic 30packets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/kitchen-counter-with-aloe-drink.png?v=1787423373",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "forever",
        "fiber",
        "these",
        "packets",
        "feature",
        "four",
        "types",
        "fiber",
        "including",
        "fructooligosaccharides",
        "which",
        "also",
        "prebiotic",
        "30packets",
        "singers",
        "health",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791823982789",
      "vsf_explanation": "Forever Fiber is a 30-packet daily-serving fiber supplement blending four fiber sources including FOS (fructooligosaccharides), which functions as a prebiotic. Multi-fiber blends (soluble + insoluble + prebiotic) have supporting evidence for stool regularity, LDL cholesterol reduction, and short-chain fatty-acid production (Slavin 2013 review). This is one of the more evidence-aligned products in Forever Living's MLM lineup because fiber is genuinely under-consumed in Western diets. Held in Standard by the packet delivery format (higher per-gram cost than bulk psyllium), no disclosed per-fiber-source gram amounts, and MLM markup. Would move to Verified with a full gram-per-fiber-type disclosure and third-party FOS purity testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "forever-marine-collagen",
      "title": "Forever Marine Collagen",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/forever-marine-collagen-natural-ocean-background.png?v=1787423373",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "forever",
        "marine",
        "collagen",
        "singers",
        "health",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 84.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791824015557",
      "vsf_explanation": "Forever Marine Collagen is a fish-derived hydrolyzed collagen peptide supplement in Forever Living's MLM lineup. Marine collagen peptides at 2.5-10 g/day have supporting RCT evidence for skin elasticity and hydration improvements over 8-12 weeks (Choi 2019, de Miranda 2021 meta-analysis), so the ingredient class is legitimate. Held in Standard by no disclosed grams-per-serving on the front label, no named collagen brand (Verisol, Naticol, Peptan are the standard-of-care), no molecular-weight spec, and MLM markup. Would move to Verified with a named collagen-peptide brand at 2.5-10 g per serving, molecular-weight disclosure, and MSC-certified sustainable-marine sourcing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "forever-living-therm-naturally-powered-metabolism-kick-starter-60-tablets",
      "title": "forever living therm Naturally powered metabolism kick-starter 60 tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/forever-therm-product-background.png?v=1787423373",
      "score": 49,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "forever",
        "living",
        "therm",
        "naturally",
        "powered",
        "metabolism",
        "kick",
        "starter",
        "tablets",
        "singers",
        "health",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 52,
        "transparency": 48,
        "sustainability": 45
      },
      "price": 32.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791824048325",
      "vsf_explanation": "This is a duplicate listing of Forever Therm, Forever Living's MLM thermogenic (60 tablets) branded here as a 'metabolism kick-starter.' Green tea catechins + caffeine show a small thermogenic effect (Hursel 2011 meta-analysis, ~4% daily energy expenditure lift) but real-world weight-loss effects are clinically small, and green coffee bean data (Vinson 2012) was retracted. FTC has targeted MLM thermogenic claims aggressively. Held in Rejected by weak effect size, retracted evidence for a common ingredient, and MLM markup on a category (thermogenics) where honest positioning is rare. Would move to Standard with honest 'caffeine + green tea catechin' positioning and disclosed per-active doses.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "forever-lycium-plus®-combines-goji-berries-with-licorice-extract-antioxidant-formula-rooted-in-traditional-chinese-wellness-practices",
      "title": "Forever Lycium Plus® combines goji berries with licorice extract antioxidant formula rooted in traditional Chinese wellness practices.",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/forever-lycium-plus-eye-health-antioxidant-support.png?v=1787423378",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "forever",
        "lycium",
        "plus",
        "combines",
        "goji",
        "berries",
        "with",
        "licorice",
        "extract",
        "antioxidant",
        "formula",
        "rooted",
        "traditional",
        "chinese",
        "wellness",
        "practices",
        "singers",
        "health",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 48
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791824933061",
      "vsf_explanation": "Forever Lycium Plus combines goji berry (Lycium barbarum) with licorice root extract in a Traditional Chinese Medicine-styled antioxidant blend. Goji has small RCTs suggesting antioxidant marker improvements (Amagase 2009) but limited hard-endpoint evidence, and licorice has real safety flags: glycyrrhizin can cause pseudoaldosteronism (hypertension, hypokalemia) with sustained daily use above ~100 mg glycyrrhizin (EFSA 2021). Held in Standard by category-appropriate evidence, but the licorice component would benefit from a DGL (deglycyrrhizinated) callout or clear glycyrrhizin dose disclosure. Would move to Verified with standardized goji polysaccharide %, DGL disclosure, and third-party certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "forever-naturemin-provide-you-with-essential-and-trace-minerals-taken-key-minerals-from-the-bottom-of-sea-beds-marine-plants-a-supplement",
      "title": "Forever NatureMin provide you with essential and trace minerals taken key minerals from the bottom of sea beds marine plants a supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/image_77671574-68f7-4d1c-9dce-7d422881a74f.png?v=1787423378",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "forever",
        "naturemin",
        "provide",
        "you",
        "with",
        "essential",
        "and",
        "trace",
        "minerals",
        "taken",
        "key",
        "minerals",
        "from",
        "the",
        "bottom",
        "sea",
        "beds",
        "marine",
        "plants",
        "supplement",
        "singers",
        "health",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791824965829",
      "vsf_explanation": "Forever NatureMin is a multi-mineral tablet sourced from marine-plant/seabed mineral deposits — a legitimate category alongside brands like Trace Minerals Research. Marine-plant mineral matrices offer a full trace-mineral spectrum but typically deliver each individual mineral (calcium, magnesium, zinc, iron) at sub-RDA doses per serving, so this is best positioned as a trace-mineral top-up rather than a full-dose multi-mineral. Held in Standard by MLM markup and no per-mineral mg disclosure in the product marketing. Would move to Verified with a full per-mineral dose panel, arsenic/heavy-metal testing certificates (relevant for marine sources), and NSF certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "forever-active-ha-delivers-advanced-joint-support-through-a-synergistic-blend-of-natures-most-respected-ingredients",
      "title": "Forever Active HA delivers advanced joint support through a synergistic blend of nature's most respected ingredients",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/forever-active-ha-joint-health-skin-hydration.png?v=1787423379",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "forever",
        "active",
        "delivers",
        "advanced",
        "joint",
        "support",
        "through",
        "synergistic",
        "blend",
        "nature",
        "most",
        "respected",
        "ingredients",
        "singers",
        "health",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 48
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791825129669",
      "vsf_explanation": "Forever Active HA is a joint-support supplement built around hyaluronic acid (HA) from Forever Living Products, a large MLM (multi-level marketing) company. Oral HA has modest supporting evidence for knee osteoarthritis symptoms (Oe 2016 meta-analysis, ~200 mg/day for 8-12 weeks), so the core ingredient is reasonable. What holds this in mid-Standard is the MLM distribution model, which typically inflates pricing 2-3x over comparable NSF-certified joint blends, plus a lack of stated HA molecular weight (a key bioavailability variable) and no third-party testing disclosure per SKU. Would move to Verified 70+ with a specified low-molecular-weight HA dose (100-200 mg), added collagen type II or MSM at studied doses, and NSF/USP certification. See /pages/who-owns-your-supplement-brands — Forever Living is a privately held MLM.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "forever-immune-gummy-supplements-blend-of-10-vitamins-and-zinc-with-a-naturally-sweet-tropical-fruit-flavor",
      "title": "Forever Immune Gummy supplements blend of 10 vitamins and zinc with a naturally sweet tropical fruit flavor.",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/forever_immune__gummy_pd_zoomedimage_1000_X_1000_1719260696453_1.jpg?v=1787423379",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "forever",
        "immune",
        "gummy",
        "supplements",
        "blend",
        "vitamins",
        "and",
        "zinc",
        "with",
        "naturally",
        "sweet",
        "tropical",
        "fruit",
        "flavor",
        "singers",
        "health",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 52,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 58,
        "sustainability": 48
      },
      "price": 36,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791825162437",
      "vsf_explanation": "Forever Immune Gummy is a 10-vitamin + zinc multivitamin gummy from Forever Living's MLM lineup. Zinc lozenges have RCT support for shortening cold duration (Hemila 2017 meta-analysis, 75+ mg/day zinc acetate), but gummy formats are dose-limited by sugar/mass constraints and typically deliver only 5-15 mg zinc plus a low-dose multivitamin blend below the therapeutic thresholds for immune claims. Standard concerns include added sugars (typical for gummies), no methylated B-vitamin forms, and MLM markup. Would move to Verified with disclosed per-nutrient doses at RDA-plus levels, methylated folate/B12, and a sugar-free base. Manufactured under MLM contract; not third-party certified per SKU.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "forever-ivision-breakthrough-supplement-nourish-and-help-protect-your-eyes-formulated-with-vitamins-antioxidant-power-botanicals",
      "title": "Forever iVision breakthrough supplement nourish and help protect your eyes Formulated with vitamins antioxidant power botanicals",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/forever_ivision__pd_zoomedimage_1000_X_1000_1719260844924_1.jpg?v=1787423379",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "forever",
        "ivision",
        "breakthrough",
        "supplement",
        "nourish",
        "and",
        "help",
        "protect",
        "your",
        "eyes",
        "formulated",
        "with",
        "vitamins",
        "antioxidant",
        "power",
        "botanicals",
        "singers",
        "health",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 48
      },
      "price": 38.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791825195205",
      "vsf_explanation": "Forever iVision is an eye-health blend positioned in the AREDS-adjacent category (lutein/zeaxanthin + antioxidants). The AREDS2 trial (Chew 2013) established that 10 mg lutein + 2 mg zeaxanthin plus zinc/vitamins C/E slows AMD progression, so the category has strong evidence, but Forever Living does not publicly disclose whether iVision matches AREDS2 doses on the label front-and-center, and 'breakthrough supplement' is marketing language rather than a clinical claim. MLM pricing markup and no third-party certification per SKU keep it in mid-Standard. Would move to Verified with disclosed AREDS2-matched lutein/zeaxanthin doses, meso-zeaxanthin, and USP/NSF verification. Forever Living is a private MLM (see /pages/who-owns-your-supplement-brands).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "forever-lean-supplement-a-120-capsules",
      "title": "Forever Lean Supplement a 120 capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/forever-lean-weight-management-support.png?v=1787423379",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "forever",
        "lean",
        "supplement",
        "120",
        "capsules",
        "singers",
        "health",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 52,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 48,
        "sustainability": 48
      },
      "price": 44.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791825227973",
      "vsf_explanation": "Forever Lean is a weight-management capsule product from Forever Living's MLM lineup, typically formulated around chromium picolinate plus a starch/fat-blocker blend (Phase 2 white-kidney-bean extract, prickly pear). Meta-analyses on chromium for weight loss (Onakpoya 2013) show clinically trivial effect sizes (~1 lb over 12-24 weeks), and starch-blocker evidence is weak and short-duration. The FTC has aggressively targeted MLM weight-loss claims in this category, and the product does not present any RCT-anchored evidence. Held in Rejected by weak evidence, category-typical marketing overreach, and MLM markup on an ineffective formulation. Would move to Standard only with disclosed per-active doses backed by peer-reviewed RCTs.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "forever-fab-a-delicious-mild-berry-flavor-and-is-made-with-a-combination-of-b-vitamins-and-guarana-provides-fast-energy-8-4-fl-oz-12-cans",
      "title": "Forever FAB a delicious mild berry flavor and is made with a combination of B vitamins and guarana provides fast energy 8.4 fl.oz. (12 cans).",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fab-forever-active-boost-energy-background.png?v=1787423379",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "forever",
        "fab",
        "delicious",
        "mild",
        "berry",
        "flavor",
        "and",
        "made",
        "with",
        "combination",
        "vitamins",
        "and",
        "guarana",
        "provides",
        "fast",
        "energy",
        "cans",
        "singers",
        "health",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 45,
        "sustainability": 42
      },
      "price": 56.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791825293509",
      "vsf_explanation": "Forever FAB is a canned energy drink (8.4 fl oz, 12-can case) from Forever Living's MLM lineup, built on B vitamins + guarana (a caffeine source) plus adaptogen-style branding. This is a functional beverage rather than a targeted nutraceutical: caffeine from guarana delivers the acute 'fast energy' effect while B vitamins contribute little to acute energy in a non-deficient person (Kennedy 2016 review). Held in Rejected by ambiguous per-serving caffeine disclosure typical of energy-drink formats, added sugars/sweeteners, MLM markup, and the fact that a 12-can case pricing is well above a comparable Celsius or Zevia. Would move to Standard with clear caffeine mg per can, unsweetened base, and no MLM markup.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "forever-fields-of-greens-is-a-fast-and-easy-way-to-cleanse-and-detoxify-while-providing-the-nutrients-your-body-needs-each-day",
      "title": "Forever Fields of Greens is a fast and easy way to cleanse and detoxify while providing the nutrients your body needs each day",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/forever_fields_of_greens__pd_zoomedimage_1000_X_1000_1611596372969_1.png?v=1787423379",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "forever",
        "fields",
        "greens",
        "fast",
        "and",
        "easy",
        "way",
        "cleanse",
        "and",
        "detoxify",
        "while",
        "providing",
        "the",
        "nutrients",
        "your",
        "body",
        "needs",
        "each",
        "day",
        "singers",
        "health",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 17.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46791825260741",
      "vsf_explanation": "Forever Fields of Greens is a greens-powder / green-food blend that markets itself explicitly as a way to 'cleanse and detoxify.' This triggers the unverified_medical_claim autofail: no supplement has been shown in peer-reviewed RCTs to 'cleanse' or 'detoxify' a healthy human body — the liver and kidneys perform detoxification, and no greens formula changes that (Klein 2014 review of detox diets). The underlying ingredients (alfalfa, barley, wheatgrass) are nutrient-dense but unremarkable at typical scoop doses. MLM markup compounds the problem. Would only exit Rejected with the detox/cleanse language removed and honest positioning as a low-dose greens supplement.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "lions-mane-hericium-erinaceus",
      "title": "Lion's Mane (Hericium erinaceus)",
      "vendor": "Feral Fungi",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Lions-Mane-Mushroom-Feral-Fungi.jpg?v=1787532716",
      "score": 67,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lion",
        "mane",
        "hericium",
        "erinaceus",
        "feral",
        "fungi"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 70,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 65,
        "sustainability": 70
      },
      "price": 27,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46801974132933",
      "vsf_explanation": "Feral Fungi is a small-batch craft mushroom brand with a reputation for wildcrafted or small-farm fruiting body sourcing and dual-extraction methodology — the two signals that separate serious mushroom products from mycelium-on-oats commodity fills. Using the scientific name (Hericium erinaceus) at the title level is a modest quality signal (mushroom taxonomy discipline). Craft-scale sourcing means small-batch third-party testing is often less formal than at large mushroom brands, and beta-glucan or hericenone standardization percentages are not disclosed at the title level. Would move to Verified 70+ with disclosed beta-glucan %, published dual-extraction methodology, and lot-level third-party COAs for heavy metals.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lions-mane-cacao-energy",
      "title": "Lion's Mane Cacao (Energy)",
      "vendor": "Hawaiian Health Co.",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4ED984DD-F1EF-43AF-AD5E-6E5C008A0B96.jpg?v=1787532724",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lion",
        "mane",
        "cacao",
        "energy",
        "hawaiian",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 50,
        "manufacturing": 52,
        "safety": 58,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 50,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46801974296773",
      "vsf_explanation": "A Lion's Mane-plus-cacao energy beverage is a lifestyle/functional-beverage product rather than a clinical Lion's Mane protocol — cacao provides theobromine and small amounts of caffeine for a mild energy boost, but the Lion's Mane content in a beverage serving is essentially always well below the 3g/day dried-fruiting-body dose from Mori 2009. Hawaiian Health Co. is a small regional brand with limited third-party testing visibility. Sourcing (fruiting body vs mycelium) and extraction method are not disclosed in the title. Would move to Standard 60+ with disclosed per-serving mg of Lion's Mane at or above 1g fruiting body plus cacao source transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "allmax-lions-mane-60-vcaps",
      "title": "Allmax Lion's Mane, 60 Vcaps",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/allmax-lionsmane-60-817607_500x_41328f82-8e04-475c-b5e4-612a68ef4a54.jpg?v=1787532735",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "allmax",
        "lion",
        "mane",
        "vcaps",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 58,
        "manufacturing": 63,
        "safety": 60,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46801974427845",
      "vsf_explanation": "Allmax is an established Canadian sport-nutrition brand with mainstream retail distribution and reasonable cGMP infrastructure — better manufacturing baseline than most Amazon-tier mushroom brands. The main gap for Lion's Mane specifically is that Allmax's mushroom line does not typically publish fruiting body vs mycelium sourcing, dual-extraction methodology, or beta-glucan standardization — the three signals that separate serious mushroom brands from sport-nutrition brand extensions. Dose per cap and fruiting body detail not disclosed in title. Would move to Verified 70+ with 100% fruiting body, dual extraction, and beta-glucan % disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lions-mane-ginkgo-biloba",
      "title": "Lions Mane + Ginkgo Biloba",
      "vendor": "Tailor Made Herbal Products",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/IMG-7126.jpg?v=1787532758",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lions",
        "mane",
        "ginkgo",
        "biloba",
        "tailor",
        "made",
        "herbal",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 48,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 48,
        "sustainability": 50
      },
      "price": 45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46801974657221",
      "vsf_explanation": "Both actives have real cognitive evidence individually — Lion's Mane at 3g/day dried fruiting body (Mori 2009) and Ginkgo biloba EGb 761 at 240mg/day of standardized 24/6 extract (Kanowski 1996) — but combo formulas from small herbalist compounders typically underdose each active in a single capsule to hit the marketed count, so per-active mg becomes the make-or-break question and is not disclosed at the title level. Ginkgo also has real bleeding-risk interactions (warfarin, aspirin, NSAIDs, pre-surgery) that must be flagged at the label. Tailor Made is a small craft herbalist with limited third-party test infrastructure. Would move to Standard 60+ with disclosed per-active mg at or near individual studied doses and clear bleeding-risk warnings.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-lions-mane-20-1-extract-1000mg-made-with-organic-lion-s-mane-bioperine-30-polysaccharides-120-veggie-caps-non-gmo-gluten-free",
      "title": "NusaPure Lions Mane 20:1 Extract 1000mg - Made with Organic Lion`s Mane, Bioperine - 30% Polysaccharides - 120 Veggie Caps. Non-GMO, Gluten Free",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-128518v5-Lions-Mane-3D-01.jpg?v=1787532783",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "lions",
        "mane",
        "extract",
        "1000mg",
        "made",
        "with",
        "organic",
        "lion",
        "mane",
        "bioperine",
        "polysaccharides",
        "120",
        "veggie",
        "caps",
        "non",
        "gmo",
        "gluten",
        "free",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 20.96,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46801974821061",
      "vsf_explanation": "NusaPure's Lion's Mane label is above-average on formulation disclosure for the mid-tier Amazon segment — 20:1 extract ratio, 30% polysaccharide standardization, and BioPerine (piperine 95%) for absorption enhancement. The 20:1 extract at 1000mg per cap is bioactivity-equivalent to a substantially larger raw-mushroom dose, and standardized polysaccharide content is a real Lion's Mane quality signal (Mori 2009 used 3g/day dried fruiting body). The label does not clearly specify fruiting body vs mycelium sourcing, which is the primary remaining transparency gap. NusaPure manufacturing is mid-tier Amazon-brand standard. Would move to Verified 70+ with explicit 100% fruiting body sourcing, beta-glucan % (not just polysaccharide %, which can include starch from mycelium substrate), and third-party COAs.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "maxx-by-magic-mind",
      "title": "MAXX by Magic Mind",
      "vendor": "The Shelf",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/IMG-4347.webp?v=1787532807",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "maxx",
        "magic",
        "mind",
        "the",
        "shelf"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 58,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 5.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46801975050437",
      "vsf_explanation": "Magic Mind is a popular DTC functional-beverage brand and MAXX is their higher-caffeine, higher-active shot format — typically stacking matcha, Lion's Mane, cordyceps, Rhodiola, ashwagandha, and BCAAs in a 2oz shot. The individual actives have decent adaptogen and nootropic support (Chandrasekhar 2012 for ashwagandha 300-600mg KSM-66; Panossian 2010 review for Rhodiola), but per-active mg in a 2oz shot format almost always sits below individual studied doses — the format is a cognitive nudge rather than a therapeutic protocol. The brand's marketing sometimes edges toward strong cognitive-performance claims, but stops short of medical claims. Would move to Verified 70+ with per-active mg disclosure at studied levels and named ashwagandha/rhodiola extract standardizations.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lions-mane-plus-focus-gummies",
      "title": "Lion's Mane Plus Focus Gummies",
      "vendor": "Halea Life: Nutrition & Skincare",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1775151759967-generated-label-image-1.jpg?v=1787532825",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lion",
        "mane",
        "plus",
        "focus",
        "gummies",
        "halea",
        "life",
        "nutrition",
        "skincare"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 48,
        "sustainability": 45
      },
      "price": 14.96,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46801975214277",
      "vsf_explanation": "Lion's Mane gummies are a structurally weak delivery format — a typical gummy contains 100-500mg of Lion's Mane per serving, which is well below the Mori 2009 studied dose of 3g/day dried fruiting body, and gummy formulation constraints (sugar/pectin binding, heat exposure during manufacture) can degrade beta-glucan and hericenone content. Halea Life is a small combined nutrition/skincare vendor with limited third-party test visibility. This falls in the sub-therapeutic-format category we have flagged in our published Lion's Mane guidance. Would move to Standard 60+ only with disclosed per-serving mg at or above 1000mg fruiting body plus third-party testing — a bar most gummies cannot meet.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrabio-organic-lions-mane-60-capsules-0-5-g-per-capsule-bb-02-2027",
      "title": "NutraBio Organic Lions Mane, 60 Capsules (0.5 g per Capsule) BB 02/2027",
      "vendor": "Price Is Right Miami",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4105aad7-e4d1-4b9d-85aa-1923b7a90c64.jpg?v=1787532842",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrabio",
        "organic",
        "lions",
        "mane",
        "capsules",
        "per",
        "capsule",
        "2027",
        "price",
        "right",
        "miami"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 75,
        "safety": 65,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46801975345349",
      "vsf_explanation": "NutraBio has one of the strongest transparency reputations in the US sport-nutrition industry — no proprietary blends across their line, in-house cGMP manufacturing, and published third-party testing. USDA Organic Lion's Mane is a real quality signal. The main formulation gap is dose density: 0.5g per capsule means a consumer needs six capsules per day to reach the Mori 2009 studied dose of 3g/day, which cuts a 60-capsule bottle down to a 10-day supply at that dose. The product also does not disclose fruiting body vs mycelium sourcing or beta-glucan standardization in the title. Would move to Verified 70+ with a 1g-per-cap dose density, fruiting body sourcing, and beta-glucan % disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lion-mane-capsule-refined-sulfur-phosphorus",
      "title": "Lion Mane Capsule Refined Sulfur Phosphorus",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cef0d691-3638-49a4-b319-f9898532696b.jpg?v=1787532872",
      "score": 47,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lion",
        "mane",
        "capsule",
        "refined",
        "sulfur",
        "phosphorus",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 48,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 34.81,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46801975640261",
      "vsf_explanation": "The product title \"Lion Mane Capsule Refined Sulfur Phosphorus\" is confusing and unusual — mixing Lion's Mane with a \"Refined Sulfur\" and \"Phosphorus\" description raises real questions about what the actives actually are (elemental sulfur is not a standard supplement input at supplement-industry doses, and phosphorus supplementation is rare outside specific clinical contexts due to renal-strain concerns). Combined with the low-visibility Vivalo brand and no per-active mg disclosure in the title, this triggers a transparency-first Rejected assessment rather than an auto-fail. Would need clean re-labeling with each active named, mg per active disclosed, sourcing information, and a stated intended use before it could be reassessed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lions-mane-mushroom-capsules-1000mg",
      "title": "Lion's Mane Mushroom Capsules 1000mg",
      "vendor": "Halea Life: Nutrition & Skincare",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1775403265764-generated-label-image-2.jpg?v=1787532879",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lion",
        "mane",
        "mushroom",
        "capsules",
        "1000mg",
        "halea",
        "life",
        "nutrition",
        "skincare"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 26.96,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46801975673029",
      "vsf_explanation": "1000mg per capsule is a functional Lion's Mane dose if the consumer takes three capsules daily to approximate the Mori 2009 protocol of 3g/day dried fruiting body. However, Halea Life is a small combined nutrition/skincare vendor and the label does not disclose whether the source is fruiting body (preferred) or mycelium-on-grain (dilutes actives with substrate), nor whether beta-glucan or hericenone content is standardized. No visible third-party testing. Would move to Verified 70+ with 100% fruiting body, dual extraction (hot water + ethanol), and standardized beta-glucan disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lion-mane-mushroom-drops",
      "title": "Lion Mane Mushroom Drops",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/168491ab-272e-4acb-9f0c-f1bab2916544.jpg?v=1787532951",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lion",
        "mane",
        "mushroom",
        "drops",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 48,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 37.51,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46801976328389",
      "vsf_explanation": "Vivalo is a small, low-visibility vendor and a Lion's Mane liquid drops format faces two structural challenges: hitting the Mori 2009 studied dose of 3g/day dried fruiting body would require an implausibly high tincture volume, and drops rarely disclose beta-glucan percentage or whether the source is fruiting body vs mycelium — the single most important quality signal for Lion's Mane. Manufacturing standards, extraction method (dual hot-water + ethanol vs simple alcohol tincture), and third-party heavy-metal testing are not visible. Would move to Standard 60+ with fruiting body sourcing, extraction method, beta-glucan % disclosure, and per-mL mg equivalency to a dry-weight dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "raw-nutrition-pump-non-stim-pre-workout",
      "title": "Raw Nutrition Pump | Non-Stim Pre-Workout",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Raw-Nutrition-Pump-Non-Stim-Pre-Workout.jpg?v=1787532995",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "raw",
        "nutrition",
        "pump",
        "non",
        "stim",
        "pre",
        "workout",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 68,
        "safety": 65,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 39.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46801978720453",
      "vsf_explanation": "Raw Nutrition is Chris Bumstead's brand and has established a reputation for transparent pre-workout labels (no proprietary blends) and third-party testing. A non-stim pump formula typically features L-citrulline 6-8g, betaine 2.5g, glycerol/GlycerPump 2-3g, and Nitrosigine 1.5g — actives with real ergogenic evidence for muscle pump and training volume (Pérez-Guisado 2010 for citrulline malate; Cholewa 2013 for betaine). The formula is well-formulated for its intended use case but is a training-support product rather than a foundational health supplement. Would move to Verified 70+ with published Informed Sport or NSF Certified for Sport certification and lot-level COAs.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "om-organic-mushroom-nutrition-brain-fuel-lions-mane-folate-90-vc",
      "title": "OM ORGANIC MUSHROOM NUTRITION: Brain Fuel Lions Mane Folate, 90 vc",
      "vendor": "Smart Greens",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/61TrbulUM1L._AC_SL1500.jpg?v=1787533052",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "mushroom",
        "nutrition",
        "brain",
        "fuel",
        "lions",
        "mane",
        "folate",
        "smart",
        "greens"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 70,
        "safety": 65,
        "transparency": 65,
        "sustainability": 68
      },
      "price": 24.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46801979375813",
      "vsf_explanation": "OM (Organic Mushroom Nutrition) is one of the more credible US mushroom brands — USDA Organic certified, fruiting-body and mycelium-on-oats disclosed at the label, and generally third-party tested for heavy metals. The Brain Fuel formula combines Lion's Mane with folate, which is a rational cognition stack (Mori 2009 showed cognitive improvement in older adults with 3g/day dried Lion's Mane fruiting body; folate deficiency independently impairs cognition, per Reynolds 2006). The product likely uses OM's blended mycelium-on-oats + fruiting body approach rather than pure fruiting body extract, which is the main gap versus premium dual-extract craft brands. Would move to Verified 70+ with 100% fruiting body sourcing, beta-glucan % disclosure, and dual (hot water + ethanol) extraction.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "venatura-alpha-lipoic-acid-supplement-powerful-ala-90-capsules-dietary-health-supplement",
      "title": "Venatura Alpha Lipoic Acid Supplement: Powerful, ALA 90 Capsules, Dietary Health Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/yTcDfR4M9ytHg0lmYFSkhe9AW4PfdjkhZHBD8Hbh.jpg?v=1787543727",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "venatura",
        "alpha",
        "lipoic",
        "acid",
        "supplement",
        "powerful",
        "ala",
        "capsules",
        "dietary",
        "health",
        "supplement",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 48,
        "sustainability": 45
      },
      "price": 34.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46802180833477",
      "vsf_explanation": "Venatura is a Turkish supplement brand sold through a US reseller. The product title does not disclose the per-capsule mg dose of ALA, which is a significant transparency gap — dose is the single most important input for ALA efficacy and Ziegler 2011 anchors the diabetic-neuropathy protocol at 600mg/day. The \"Powerful\" descriptor is marketing rather than mg information. Form (racemic vs R-ALA) is also not disclosed. Would move to Standard 62+ with disclosed per-cap mg, and Verified 70+ with 600mg dosing at R-ALA form plus third-party COAs.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "goodday-r-alpha-lipoic-acid-supplement-250mg-ala-capsules-for-antioxidant-support",
      "title": "Goodday R-Alpha Lipoic Acid Supplement - 250mg ALA Capsules for Antioxidant Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/45Xy38ZkhDBacTTeVe100313iljBq5QGkcDwbeQY.jpg?v=1787543737",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "goodday",
        "alpha",
        "lipoic",
        "acid",
        "supplement",
        "250mg",
        "ala",
        "capsules",
        "for",
        "antioxidant",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 44.36,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46802180964549",
      "vsf_explanation": "R-alpha lipoic acid is the biologically active R-isomer (racemic ALA is a 50/50 R+S mix, and the S-isomer has much lower activity), so 250mg of pure R-ALA is roughly equivalent in bioactivity to a substantially higher racemic dose — a meaningful formulation win over generic ALA products. R-ALA has better plasma bioavailability (Carlson 2007). Goodday is a smaller/less-established brand, so manufacturing transparency and third-party testing visibility are the main gaps. Would move to Verified 70+ with a named R-ALA source (e.g., BioEnhanced Na-RLA, GeroNova), cGMP disclosure, and third-party COAs.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-alpha-lipoic-acid-200mg-supplement-antioxidant-support-energy-production-30-capsules",
      "title": "Nature's Bounty Alpha Lipoic Acid 200mg Supplement - Antioxidant Support & Energy Production - 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0RzStrdwHdmCKqdDg5UaRcxwRnGFGuyWicOf6UiC.jpg?v=1787543745",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "alpha",
        "lipoic",
        "acid",
        "200mg",
        "supplement",
        "antioxidant",
        "support",
        "energy",
        "production",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 58,
        "manufacturing": 65,
        "safety": 62,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 22.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46802181292229",
      "vsf_explanation": "Nature's Bounty is a Nestlé Health Science-owned US mass-market brand with cGMP manufacturing, established consumer-safety infrastructure, and occasional third-party testing on select SKUs. The 200mg racemic ALA dose is a reasonable general antioxidant dose but sub-therapeutic for the diabetic-neuropathy use case where 600mg/day is the studied anchor (Ziegler 2011). The 30-count size is quite small — a monthly supply at once-daily dosing, which limits value per dollar. Labeling is clean with per-active mg disclosure. Would move to Verified 70+ with a 600mg dose and R-ALA form.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "basic-vitamins-alpha-lipoic-acid-100-mg-universal-antioxidant-capsules",
      "title": "Basic Vitamins Alpha Lipoic Acid 100 mg – Universal Antioxidant (Capsules)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/154145081_621ca77b-2e7d-46e6-9420-31f641216d6e.jpg?v=1787543754",
      "score": 51,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "basic",
        "vitamins",
        "alpha",
        "lipoic",
        "acid",
        "100",
        "universal",
        "antioxidant",
        "capsules",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 7.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46802181324997",
      "vsf_explanation": "100mg of ALA is well below the therapeutic range studied in the clinical literature — the Ziegler 2011 SYDNEY 2 trial for diabetic peripheral neuropathy used 600mg/day, and even glucose-sensitivity work typically starts at 300-600mg. At 100mg, a consumer would need to take 6 capsules to reach the studied dose, which is neither practical nor economical. Basic Vitamins is a low-visibility house brand with limited practitioner or third-party test infrastructure. Would move to Standard 60+ with a 300-600mg dose and R-ALA form disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "21st-century-healthcare-alpha-lipoic-acid-200-mg-60-count-vegetarian-capsules",
      "title": "21st Century Healthcare Alpha Lipoic Acid 200 mg, 60 Count Vegetarian Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1943d4ac-357e-4951-93ae-12b09a24a164.3ef83d1049838eda99cc7603feee2354.webp?v=1787543759",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "21st",
        "century",
        "healthcare",
        "alpha",
        "lipoic",
        "acid",
        "200",
        "count",
        "vegetarian",
        "capsules",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 60,
        "sustainability": 48
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46802181423301",
      "vsf_explanation": "21st Century is a US mass-market/budget brand with reasonable cGMP infrastructure but rarely third-party certified per SKU. 200mg of racemic ALA is a moderate maintenance dose — well below the Ziegler 2011 SYDNEY 2 trial dose of 600mg/day for diabetic peripheral neuropathy — so it functions as a general antioxidant support product rather than a targeted therapeutic. Veggie cap format is a small plus over gelatin. Labeling is clean with clear mg disclosure. Would move to Verified 70+ with 600mg dose, R-ALA form disclosure, and USP or NSF certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nervive-nerve-health-support-supplement-vitamin-b-complex-alpha-lipoic-acid-30-count",
      "title": "Nervive Nerve Health Support Supplement, Vitamin B Complex & Alpha Lipoic Acid, 30 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/342453712.jpg?v=1787543767",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nervive",
        "nerve",
        "health",
        "support",
        "supplement",
        "vitamin",
        "complex",
        "alpha",
        "lipoic",
        "acid",
        "count",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 58,
        "manufacturing": 65,
        "safety": 60,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 22.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46802181685445",
      "vsf_explanation": "Nervive is a Reckitt-owned mass-market brand explicitly positioned for peripheral nerve support, combining ALA with B-vitamins (typically B1/thiamine, B6, B12) — a rational pairing since B12 deficiency neuropathy and ALA-supported diabetic neuropathy have partially overlapping mechanisms (Ziegler 2011 for ALA; Ang 2008 meta-analysis for methylcobalamin in neuropathy). The 30-count size and once-daily framing likely underdose ALA below the 600mg/day therapeutic anchor, and the label typically does not use methylcobalamin (the metabolically active B12 form). Manufacturing is solid consumer-brand standard but not practitioner-grade. Would move to Verified 70+ with 600mg ALA/day, methylcobalamin instead of cyanocobalamin, and R-ALA form.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "voonka-alpha-lipoic-acid-600-mg-30-capsules",
      "title": "Voonka Alpha Lipoic Acid 600 mg - 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0ICUazr91VSPSC28Uhd5pv7dgJkCqYQW5p8twLbQ_0e6ed2cb-c390-470c-86e4-73fa94d850ff.jpg?v=1787543774",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "voonka",
        "alpha",
        "lipoic",
        "acid",
        "600",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 26.27,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46802181849285",
      "vsf_explanation": "Voonka is a Turkish supplement brand and 600mg matches the Ziegler 2011 SYDNEY 2 trial dose for diabetic peripheral neuropathy — the strongest single evidence anchor for ALA — so the dose choice is on-target. The form is presumably racemic ALA (R+S) since R-ALA is not specified, and R-ALA would score higher for bioavailability. Sold in the US through a reseller rather than a direct US channel, so third-party testing visibility and FDA-facing labeling are limited. Safety note that should be on the label: ALA can reduce levothyroxine absorption and add to hypoglycemia risk in diabetics on insulin/sulfonylureas. Would move to Verified 70+ with R-ALA or Na-RLA form, cGMP disclosure, and third-party COAs.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-renal-balance-with-alpha-liopic-acid-vitamin-mineral-vegetarians-non-gmo-per-60-tablets",
      "title": "NusaPure Renal Balance with Alpha Liopic Acid Vitamin & Mineral Vegetarians, Non-GMO Per 60 Tablets",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fdadd7b8.jpg?v=1787543788",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "renal",
        "balance",
        "with",
        "alpha",
        "liopic",
        "acid",
        "vitamin",
        "mineral",
        "vegetarians",
        "non",
        "gmo",
        "per",
        "tablets",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 48,
        "sustainability": 45
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46802182013125",
      "vsf_explanation": "NusaPure is a mid-tier Amazon-native brand with reasonable GMP claims but limited practitioner-side credibility. \"Renal Balance\" framing edges toward a disease-implication zone — the kidneys have limited RCT-supported nutraceutical support outside of specific settings (CoQ10 in CKD, NAC in contrast nephropathy) — and combo formulas here typically bundle ALA, cranberry, nettle, and B-vitamins without per-active mg disclosure. The title also contains a visible misspelling (\"Liopic\" instead of \"Lipoic\"), which mirrors a QA/copy concern. Would move to Standard 60+ with per-active mg disclosure and softer, non-organ-specific claim framing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "metabolic-nutrition-insulean-90-capsules",
      "title": "Metabolic Nutrition InsuLEAN 90 capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Metabolic-Nutrition-InsuLEAN-90-capsules.jpg?v=1787543792",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "metabolic",
        "nutrition",
        "insulean",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 35.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46802182111429",
      "vsf_explanation": "Metabolic Nutrition is a real sport-nutrition brand, and InsuLEAN is a glucose-disposal-agent (GDA) formula typically stacking ALA, berberine, chromium, banaba leaf, cinnamon, and gymnema — a bodybuilding-cutting category with some component-level evidence (Yin 2008 berberine for glucose; Ziegler 2011 for ALA in neuropathy) but weak overall data as a fat-loss combo. GDA products have real safety considerations for diabetics on insulin or sulfonylureas due to additive hypoglycemia risk, which should be disclosed at the label. Manufacturing is mid-tier bodybuilding-industry standard, not third-party-tested to sport-drug-free norms. Would move to Verified 70+ with per-active mg disclosure and an explicit contraindication for diabetics on hypoglycemic medications.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "basic-organics-alppha-lipoic-aicd-caplets-200-mg-60-ct",
      "title": "Basic Organics Alppha Lipoic Aicd Caplets 200 Mg  60 Ct",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/264941280_c1789293-17dd-41bd-96d2-0e88b5320855.jpg?v=1787543801",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "basic",
        "organics",
        "alppha",
        "lipoic",
        "aicd",
        "caplets",
        "200",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 52,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 42,
        "sustainability": 45
      },
      "price": 8.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46802182242501",
      "vsf_explanation": "Two visible spelling errors on the product title (\"Alppha Lipoic Aicd\") are a significant QA red flag — brands with real GMP oversight catch label typos, and this level of sloppiness raises legitimate concerns about batch testing rigor. On the actives themselves, 200mg of unspecified (presumably racemic) alpha-lipoic acid sits below the Ziegler 2011 SYDNEY 2 trial dose of 600mg/day for diabetic peripheral neuropathy and is best characterized as a maintenance antioxidant dose rather than a therapeutic one. Would move to Standard 60+ with a clean, correctly-spelled label; would move to Verified 70+ with 600mg dose, R-ALA form disclosure, and third-party COAs.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "glucose-balance-formula",
      "title": "Glucose Balance Formula",
      "vendor": "Tailor Made Herbal Products",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/AE9D9160-9964-420E-95A3-FA47F44324D8.jpg?v=1787543809",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glucose",
        "balance",
        "formula",
        "tailor",
        "made",
        "herbal",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 46,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46802182308037",
      "vsf_explanation": "Tailor Made Herbal Products is a small herbalist compounder, and a Glucose Balance Formula typically blends berberine, cinnamon, chromium, gymnema, or bitter melon — several of which have real glucose evidence (Yin 2008 for berberine 500mg TID; Baker 2008 for chromium picolinate 200-1000mcg/day). The core concern is per-active dose disclosure: small-batch herbal blends frequently underdose berberine below the 1500mg/day therapeutic range and hide the actual mg behind proprietary-blend framing. Small-craft manufacturing means variable third-party testing. Would move to Verified 70+ with named berberine HCl at 500mg TID and published COAs; would drop if a proprietary blend hides per-active mg.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "glutathione-collagen-vitamin-c-pills",
      "title": "Glutathione, Collagen & Vitamin C pills",
      "vendor": "ANOLA SKIN",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Glutathione_Collagen_Vitamin_C_pills-Photoroom.jpg?v=1787543824",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glutathione",
        "collagen",
        "vitamin",
        "pills",
        "anola",
        "skin"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 48,
        "sustainability": 45
      },
      "price": 65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46802182635717",
      "vsf_explanation": "Oral glutathione has notoriously poor bioavailability — it is broken down in the gut to its constituent amino acids, and human studies at 500-1000mg/day show only modest tissue-level GSH changes (Richie 2015), while skin-lightening claims commonly attached to oral GSH products lack rigorous RCT support. Bundling GSH with collagen and vitamin C is a marketing pattern rather than a mechanism-driven stack, and the title provides no per-active mg, no collagen source (marine vs bovine), and no manufacturer provenance beyond the ANOLA SKIN beauty brand. Would move to Standard 60+ with liposomal or S-acetyl glutathione (better absorption), collagen peptide source disclosure (e.g., Verisol®, Peptan®), and per-active mg.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hepatocore-60ct",
      "title": "HepatoCORE 60ct",
      "vendor": "O Body + Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/163-60-hepatocore.webp?v=1787543831",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hepatocore",
        "60ct",
        "body",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 72,
        "manufacturing": 78,
        "safety": 72,
        "transparency": 70,
        "sustainability": 60
      },
      "price": 59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46802182734021",
      "vsf_explanation": "HepatoCORE is an Ortho Molecular Products liver-support formula — OMP is a practitioner-channel-only brand with strong cGMP, batch testing, and physician-facing formulation standards. The typical HepatoCORE stack (milk thistle silymarin, NAC, alpha-lipoic acid, curcumin, selenium, taurine) has legitimate hepatoprotective evidence: silymarin for NAFLD markers (Aller 2015), NAC for acetaminophen and general hepatocyte support, and curcumin for liver enzyme reduction (Panahi 2016). It sits below Elite mainly because the formula is a multi-ingredient combo rather than a single-active mono-formula with a hard RCT anchor, and the retail listing lacks direct COA transparency. Would move to Elite 85+ with published per-ingredient standardization and third-party lot testing available to the consumer.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-pycnogenol-100-mg-30-vegetable-capsules",
      "title": "Solgar Pycnogenol 100 mg 30 Vegetable Capsules",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33984023062.png?v=1787543845",
      "score": 80,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "pycnogenol",
        "100",
        "vegetable",
        "capsules",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 74,
        "formulation": 72,
        "manufacturing": 72,
        "safety": 72,
        "transparency": 72,
        "sustainability": 62
      },
      "price": 61.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46802183585989",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 71 → new 80. Evidence found: Rohdewald P. A review of the French maritime pine bark extract (Pycnogenol), a herbal medication with a diverse clinical pharmacology. Int J Clin Pharmacol Ther. 2002;40(4):158-68. | Belcaro G, et al. Pycnogenol for venous insufficiency and venous leg ulcers. Angiology. 2006;57(3):331-9. | Enseleit F, et al. Effects of Pycnogenol on endothelial function in patients with stable coronary artery disease: a double-blind, randomized, placebo-controlled, cross-over study. Eur Heart J. 2012;33(13):1589-97.. Rationale: Pycnogenol (patented French maritime pine bark extract, Horphag Research) has TIER-B evidence for endothelial function (Enseleit 2012), chronic venous insufficiency (Belcaro 2006), and multiple other indications. Standardized to 65-75% procyanidins - one of the most-studied polyphenol extracts. 100 mg/day matches many RCT protocols. +9 uplift for specific branded extract with strong published evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bioxcin-beauty-booster-dietary-supplement-60-tablets-for-enhanced-beauty-and-health",
      "title": "Bioxcin Beauty Booster Dietary Supplement - 60 Tablets for Enhanced Beauty and Health",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/EQBfHC7OKPAETM2aHcdt1inAqBhd0BbbU8W213GO.jpg?v=1787543882",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bioxcin",
        "beauty",
        "booster",
        "dietary",
        "supplement",
        "tablets",
        "for",
        "enhanced",
        "beauty",
        "and",
        "health",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 52,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 50.94,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46802183979205",
      "vsf_explanation": "Bioxcin is a Turkish beauty brand sold in the US via a reseller, and the title gives no per-active mg disclosure — a red flag for a hair/skin combo product where biotin, zinc, and iron doses matter for actual efficacy and safety. Beauty-boost combos typically underdose the actives that have RCT support (biotin 2.5mg for hair per Trüeb 2016, saw palmetto 320mg for AGA per Prager 2002) while relying on hopeful branding. Manufacturing transparency and third-party testing are not visible on the reseller listing. Would move to Standard 60+ with per-active dose disclosure, EU/FDA-facing label translation, and at least one named source ingredient.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "alpha-lion-cravings-killer-50-capsules",
      "title": "Alpha Lion Cravings Killer - 50 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Alpha-Lion-Cravings-Killer-50-Capsules.jpg?v=1787543939",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alpha",
        "lion",
        "cravings",
        "killer",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 62,
        "safety": 58,
        "transparency": 58,
        "sustainability": 45
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46802185093317",
      "vsf_explanation": "Alpha Lion is a legitimate sport-nutrition brand with reasonable manufacturing standards, and Cravings Killer is one of the better appetite-suppressant capsules on the DTC side. However, appetite-suppressant blends as a category have weak RCT support — most rely on chromium picolinate, saffron, or glucomannan at doses that show modest hunger effects but no consistent weight-loss signal in meta-analyses. The specific per-active mg disclosure and third-party test availability are unclear from the title alone. Would move to Verified 70+ with clearly disclosed doses of saffron (Gout 2010, 176.5mg standardized) or glucomannan (Keithley 2005, 3g/day pre-meal) at the studied levels.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-encapsulations-vitamin-d3-liquid-22-5-ml-health-supplement",
      "title": "Pure Encapsulations Vitamin D3 Liquid - 22.5 ml | Health Supplement",
      "vendor": "Pure Encapsulations",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/UUQs72Jc1GgWglrbxTgWX8PAjt6I4BMh3ERP4cff.jpg?v=1787580899",
      "score": 82,
      "tier": "elite",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "encapsulations",
        "vitamin",
        "liquid",
        "health",
        "supplement",
        "pure",
        "encapsulations"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 80,
        "manufacturing": 80,
        "safety": 74,
        "transparency": 74,
        "sustainability": 62
      },
      "price": 29.57,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803588219077",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 76 → new 82. Evidence found: Holick MF. Vitamin D deficiency. N Engl J Med. 2007;357(3):266-281. | Pure Encapsulations Vitamin D3 Liquid: cholecalciferol in MCT oil base for flexible dosing.. Rationale: Liquid D3 in MCT enables precise, flexible dosing (drop-based titration) — ideal for pediatric, elderly, or anyone requiring non-standard doses guided by 25(OH)D testing. Practitioner-grade. Elite tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nature-made-vitamin-d3-maximum-strength-10-000-iu-softgels",
      "title": "Nature Made Vitamin D3, Maximum Strength, 10,000 IU, Softgels",
      "vendor": "Nature Made",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/302801445.jpg?v=1787580910",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "made",
        "vitamin",
        "maximum",
        "strength",
        "000",
        "softgels",
        "nature",
        "made"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 76,
        "formulation": 72,
        "manufacturing": 76,
        "safety": 62,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 17.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803589693637",
      "vsf_explanation": "Nature Made is USP-verified — a genuine third-party quality mark that's uncommon at this price tier — and softgel format with an oil carrier is the right delivery vehicle for a fat-soluble vitamin (Dawson-Hughes 2013). D3 has extensive RCT support: Martineau 2017 for respiratory infection risk reduction, Bischoff-Ferrari 2009 for fracture prevention. The safety dimension is dinged because 10,000 IU is at the upper end of what's appropriate long-term without 25(OH)D monitoring — the Institute of Medicine UL is 4000 IU/day for adults, though many clinicians target 2000-5000 IU for people testing deficient (Holick 2011). Would move to Verified-high 78+ with an explicit label recommendation to test 25(OH)D before chronic use at this dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "calcium-vitamin-d-1",
      "title": "Calcium + Vitamin D",
      "vendor": "LIVS Gummies",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/calcium_and_vitamin_d_gummies.png?v=1787580957",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "calcium",
        "vitamin",
        "livs",
        "gummies"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 45,
        "manufacturing": 48,
        "safety": 58,
        "transparency": 48,
        "sustainability": 45
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803596312773",
      "vsf_explanation": "The underlying Ca + D3 combination has real evidence for postmenopausal bone density (Tang 2007 meta-analysis), but LIVS Gummies is a small unknown-provenance brand and the gummy format is a poor delivery vehicle for calcium — meaningful calcium doses (500-1000 mg elemental) don't fit into a couple of gummies, so gummy calcium products almost always deliver a fraction of the studied dose (typically 200-400 mg vs the 1000+ mg used in Tang 2007). Sugar and gelatin base further undermine the health framing. Would need to become a tablet or capsule at 500 mg calcium citrate + 1000-2000 IU D3 to clear Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "arthri-flex®-advatage-tablet-120-ea",
      "title": "Arthri-Flex® Advatage Tablet, 120 EA",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/49083050.jpg?v=1787580965",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "arthri",
        "flex",
        "advatage",
        "tablet",
        "120",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 10.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803597492421",
      "vsf_explanation": "Arthri-Flex Advantage is a value-tier joint-support combination typically pairing glucosamine, chondroitin, MSM, and hyaluronic acid. Individual actives have moderate evidence (Reginster 2001 for glucosamine sulfate 1500 mg, Kim 2006 for MSM in knee pain), but combination products in this price tier tend to under-dose relative to studied protocols to fit the four-active label into a reasonable tablet count. Manufacturing pedigree is mass-market pharmacy-brand quality. Would move to Verified 70+ with glucosamine sulfate 1500 mg/day disclosed, chondroitin 1200 mg/day, and published third-party CoA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nature-made-vitamin-d3-k2-gummies-peach-50-gummies",
      "title": "Nature Made Vitamin D3 + K2 Gummies, Peach, 50 Gummies",
      "vendor": "Nature Made",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/314393273.jpg?v=1787580975",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "made",
        "vitamin",
        "gummies",
        "peach",
        "gummies",
        "nature",
        "made"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 58,
        "manufacturing": 72,
        "safety": 65,
        "transparency": 62,
        "sustainability": 52
      },
      "price": 17.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803598934213",
      "vsf_explanation": "Nature Made is USP-verified across most of its core catalog, which is a rare and meaningful mark of manufacturing quality in US supplements. The D3+K2 pairing is a good formulation choice (Knapen 2013 for K2 activation of osteocalcin), and both actives have solid RCT bases. The gummy format is the cap: gummies use sugar to carry actives, lose potency faster than tablets/softgels (moisture and oxygen exposure), and fat-soluble vitamin absorption from a gummy matrix is less studied than from an oil-carrier softgel. The USP verification and Nature Made pedigree keep it in Standard rather than Rejected. Would move to Verified 70+ if the same formula were offered in softgel form.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutraxin-vitamin-d3-supplement-120-count-tablets-high-potency-vitamin-d3-for-bone-health-immune-support",
      "title": "Nutraxin Vitamin D3 Supplement, 120-Count Tablets - High-Potency Vitamin D3 for Bone Health & Immune Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3y8BvOZFXA5nO6tOkRokyVILlWWWrUKANNcxQ5uW.jpg?v=1787581001",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutraxin",
        "vitamin",
        "supplement",
        "120",
        "count",
        "tablets",
        "high",
        "potency",
        "vitamin",
        "for",
        "bone",
        "health",
        "immune",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 52,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 48
      },
      "price": 20.75,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803602473157",
      "vsf_explanation": "Nutraxin D3 has solid underlying evidence for the active — vitamin D3 has extensive RCT support for immune (Martineau 2017 respiratory infection meta-analysis) and bone outcomes (Bischoff-Ferrari 2009). The formulation concern is that D3 is fat-soluble and works best in oil-based softgels or drops rather than dry tablets, where absorption is significantly lower unless taken with a fatty meal (Dawson-Hughes 2013). 'High potency' isn't dose-specific on the title, so we can't verify whether it hits the 1000-4000 IU/day range that most clinicians target. Would move to Standard-high 62+ if converted to a softgel/liquid format with named IU per serving.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrabio-d3k2-60-capsules",
      "title": "NutraBio D3K2 - 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NutraBio-D3K2-60-Capsules.jpg?v=1787581014",
      "score": 80,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrabio",
        "d3k2",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 74,
        "manufacturing": 78,
        "safety": 72,
        "transparency": 82,
        "sustainability": 58
      },
      "price": 27.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803605553349",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 74 → new 80. Evidence found: Van Ballegooijen AJ et al. The Synergistic Interplay between Vitamins D and K. Int J Endocrinol. 2017;2017:7454376. | Knapen MH et al. Three-year low-dose menaquinone-7 supplementation. Osteoporos Int. 2013;24(9):2499-2507.. Rationale: NutraBio D3K2 combines therapeutic-dose D3 with K2 MK-7 at fully-disclosed doses. Full-transparency brand + evidence-based combination. Uplift to 80.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bonex-vit-d3-k2-mk-7-calcium-60-capsules",
      "title": "Bonex VIT D3, K2 MK-7 & Calcium | 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/bonex-bone-Wellness-1752218.jpg?v=1787581048",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bonex",
        "vit",
        "calcium",
        "capsules",
        "matevara"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 28.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803616891077",
      "vsf_explanation": "Matevara/Bonex is a small brand, but the formulation is actually well-thought-out: the D3 + K2 (MK-7) + calcium triad is more current best-practice for bone health than legacy Ca+D-only formulas — Knapen 2013 demonstrated MK-7 activation of osteocalcin, and Kwak 2018 showed the combination reduced arterial calcification versus Ca+D alone. The scoring cap comes from small-brand manufacturing provenance and lack of third-party testing rather than formulation quality. Would move to Verified 70+ with a named MK-7 source (e.g., MenaQ7), calcium salt specified, published third-party CoA, and per-active mg disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-vitamin-e-268-mg-400-iu-100-vegetarian-softgels",
      "title": "Solgar Vitamin E 268 mg (400 IU) 100 Vegetarian Softgels",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33984035478.png?v=1787581069",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "vitamin",
        "268",
        "400",
        "100",
        "vegetarian",
        "softgels",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 74,
        "safety": 65,
        "transparency": 70,
        "sustainability": 58
      },
      "price": 28.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803619971269",
      "vsf_explanation": "[Rescored — SAFETY DOWNGRADE via evidence crawl] Previous score 67 → new 62. Evidence found: Miller ER 3rd, et al. Meta-analysis: high-dosage vitamin E supplementation may increase all-cause mortality. Ann Intern Med. 2005;142(1):37-46 (19 trials, n=135,967; dose-dependent risk above 400 IU/day). | Klein EA, et al. Vitamin E and the risk of prostate cancer: the Selenium and Vitamin E Cancer Prevention Trial (SELECT). JAMA. 2011;306(14):1549-56.. Rationale: 400 IU vitamin E as a daily supplement is at the threshold linked to increased all-cause mortality (Miller 2005 meta) and increased prostate cancer risk in men (SELECT trial). This is not a Solgar-specific problem - it applies to all 400 IU E supplements. Modest -5 downgrade (well within -25 cap) reflects the safety signal for chronic daily use at this dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "boron-b-2oz-concentrate",
      "title": "Boron (B) - 2oz. Concentrate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CartPhotos-107.jpg?v=1787581090",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "boron",
        "2oz",
        "concentrate",
        "completeh2ominerals",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 58,
        "sustainability": 52
      },
      "price": 38,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803622428869",
      "vsf_explanation": "The 2 oz concentrate version delivers the same underlying ionic boron, in a more compact dropper format that requires user-side dilution — this improves shelf efficiency but increases the risk of dosing error since 3-10 mg/day is the studied range (Nielsen 1987, Naghii 2011 for testosterone/estradiol effects) and the UL for boron is 20 mg/day. Small brand manufacturing pedigree limits scoring the same way as the mineral water variant. Would move to Verified 70+ with a clearly marked mg-per-drop dose, ICP-MS assay verification, and a low-dose warning to prevent accidental over-dosing above 20 mg/day.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "boron-b-mineral-water",
      "title": "Boron (B) - Mineral Water",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CartPhotos-58.jpg?v=1787581097",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "boron",
        "mineral",
        "water",
        "completeh2ominerals",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 58,
        "sustainability": 52
      },
      "price": 22.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803623444677",
      "vsf_explanation": "Complete H2O Minerals offers ionic/liquid boron, which has a bioavailability argument over solid-form supplements (liquid ionic forms can be more readily absorbed). Boron has moderate evidence for bone health and hormone modulation, particularly Nielsen 1987 showing improved calcium retention and elevated testosterone/estradiol at 3 mg/day, plus supportive work on osteoarthritis (Travers 1990). The small brand's manufacturing pedigree is limited, and 'ionic' claims deserve particle-size or ion-verification data. Would move to Verified 70+ with a published ICP-MS assay for boron content per serving, third-party heavy-metal screening for the mineral water base, and a clearer dose recommendation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrabio-multi-sport-womens-daily-120-capsules",
      "title": "NutraBio Multi-Sport Women's Daily - 120 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NutraBio-Multi-Sport-Womens-Daily-120-Capsules.jpg?v=1787581117",
      "score": 78,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "nutrabio",
        "multi",
        "sport",
        "women",
        "daily",
        "120",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 74,
        "manufacturing": 78,
        "safety": 72,
        "transparency": 82,
        "sustainability": 58
      },
      "price": 36.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803626328261",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 72 → new 78. Evidence found: NutraBio Multi-Sport Women's Daily: comprehensive women's multivitamin with iron, methylated B forms, and full transparency.. Rationale: Women-specific multi with iron (appropriate for menstruating women), methylated B forms, and full ingredient transparency. Uplift to 78; below Elite because women's multis with bioactive-B and iron are increasingly common — this product is a strong entry but not category-defining.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bucked-up-rut-90-capsules",
      "title": "Bucked Up RUT-90 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Bucked-Up-RUT-90-Capsules.jpg?v=1787581149",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bucked",
        "rut",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 69.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803631603909",
      "vsf_explanation": "Bucked Up RUT is a hunter/outdoors-marketed high-caffeine pre-workout in capsule form, typically containing caffeine anhydrous plus deer-antler velvet, beta-alanine, and adaptogens. Caffeine has extensive ergogenic evidence at 3-6 mg/kg (Grgic 2020 meta-analysis), beta-alanine works at 4-6 g/day for high-intensity intervals (Trexler 2015 ISSN position stand). Deer antler velvet's IGF-1 claim doesn't hold up to trial scrutiny (Sleivert 2003). Blend structures in this category often obscure per-active dose. Would move to Verified 70+ with fully disclosed per-active mg, caffeine content clearly labeled, and NSF Certified for Sport for athletes concerned about banned substances.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "orzax-ocean-osteofine-dietary-supplement-for-bone-health-180-tablets-with-calcium-magnesium-vitamin-d",
      "title": "Orzax Ocean Osteofine Dietary Supplement for Bone Health - 180 Tablets with Calcium, Magnesium & Vitamin D",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/OJFjSzkqe4Mx2xrHFzs2vaoVkKlX0K7dukySS3Sk.jpg?v=1787581167",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "immune",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "orzax",
        "ocean",
        "osteofine",
        "dietary",
        "supplement",
        "for",
        "bone",
        "health",
        "180",
        "tablets",
        "with",
        "calcium",
        "magnesium",
        "vitamin",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 46.31,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803634094277",
      "vsf_explanation": "Orzax is a Turkish pharmacy-channel supplement brand; Ocean Osteofine is a Ca + Mg + D3 bone-health blend with reasonable rationale (Tang 2007 meta-analysis for Ca+D on fracture prevention in older adults). The formula is missing vitamin K2 (MK-7) — increasingly considered essential for directing calcium to bone rather than arteries (Knapen 2013) — and calcium salt isn't disclosed at the title level. Reseller-layer manufacturing transparency is limited. Would move to Standard-high 62+ with K2 MK-7 addition and calcium citrate rather than carbonate specified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hi-tech-musclevite™-180-tablets",
      "title": "Hi-Tech Musclevite™ - 180 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Hi-Tech-Musclevite-180-Tablets.jpg?v=1787581174",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tech",
        "musclevite",
        "180",
        "tablets",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 48
      },
      "price": 31.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803635011781",
      "vsf_explanation": "Hi-Tech Pharmaceuticals is a bodybuilding-channel brand with a mixed regulatory history (several DMAA-era enforcement actions from FDA); Musclevite is their high-dose training multivitamin. High-dose synthetic B-complex is standard for the bodybuilder market but doesn't necessarily translate to better outcomes — the returns diminish rapidly above RDA, and megadoses of niacin and B6 have real safety ceilings (B6 neuropathy above 200 mg/day, Vrolijk 2017). Manufacturing pedigree at Hi-Tech is capped by the brand's compliance history. Would move to Verified 70+ with a more restrained formulation using methylated B forms and third-party sport certification (NSF Certified for Sport).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "prostate-support-capsules",
      "title": "Prostate Support+ Capsules",
      "vendor": "Halea Life: Nutrition & Skincare",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1776189112521-generated-label-image-1.jpg?v=1787581211",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "prostate",
        "support",
        "capsules",
        "halea",
        "life",
        "nutrition",
        "skincare"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 52,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 13.96,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803640058053",
      "vsf_explanation": "'Prostate Support+ Capsules' from Halea Life is a small-vendor prostate formula, presumably built around saw palmetto with adjunct beta-sitosterol/pygeum/zinc — the underlying category has real (if mixed) evidence, with Wilt 1998 meta-analysis positive for saw palmetto BPH-symptom relief at 320mg standardized to 85-95% fatty acids and the STEP trial 2006 largely null. Halea Life has minimal public manufacturing accountability or third-party testing, and the generic SKU title does not disclose standardization percentage or named-source extracts. Even without an autofail trigger the transparency and manufacturing gaps hold this at the top of Rejected. Would move to Standard 60+ with disclosed standardization, named-source saw palmetto liposterolic extract, and a public COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "21st-century-therapeutic-m-high-potency-multivitamin-multimineral-supplement-130-tablets",
      "title": "21st Century Therapeutic M, High Potency Multivitamin & Multimineral Supplement, 130 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/345838516.jpg?v=1787581230",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "21st",
        "century",
        "therapeutic",
        "high",
        "potency",
        "multivitamin",
        "multimineral",
        "supplement",
        "130",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 7.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803642613957",
      "vsf_explanation": "21st Century Therapeutic M is a value-priced high-potency multi (styled as a Theragran-M analogue), and 'high potency' typically means the older synthetic-form multivitamin template — folic acid rather than L-methylfolate, cyanocobalamin rather than methyl-B12, and pyridoxine HCl rather than P-5-P. Adequate for general nutritional insurance but not aligned with current best-practice biohacking multivitamins. Value pricing usually reflects lower-cost forms across the board. Would move to Verified 70+ with methylated B forms, mixed tocopherols for E, chelated minerals, and a published third-party CoA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-way-alive-mens-50-complete-multivitamin-50-tablets",
      "title": "Nature's Way Alive Mens 50+ Complete Multivitamin - 50 Tablets",
      "vendor": "Nature's Way",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/352967621_bb3508b6-d8dd-41ea-b6ef-98aa0979910b.jpg?v=1787581247",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "way",
        "alive",
        "mens",
        "complete",
        "multivitamin",
        "tablets",
        "nature",
        "way"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 68,
        "safety": 65,
        "transparency": 60,
        "sustainability": 52
      },
      "price": 12.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803645104325",
      "vsf_explanation": "Nature's Way (Schwabe-owned) Alive Men's 50+ in tablet form is meaningfully better than the gummy variant because tablets can carry real mineral doses. It's a broad-spectrum multivitamin targeting older-adult needs; the 50+ population benefits from methylated B12 for compromised absorption (Andres 2004) and adequate D3 for bone/immune function. Common gaps in this class include pyridoxine HCl vs P-5-P for B6, folic acid vs L-methylfolate, and calcium being under-dosed to keep tablet size reasonable. Would move to Verified 70+ with methylated B-vitamin forms and a published third-party ID/purity CoA per lot.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitabiotics-osteocare-original-calcium-supplement-tablets-for-bone-health-support-30-count",
      "title": "Vitabiotics Osteocare Original Calcium Supplement Tablets for Bone Health Support - 30 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/JtRKjgVGSQ2lthSpX1txqGZxANGxn2tNEmEPAeK7.jpg?v=1787581253",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitabiotics",
        "osteocare",
        "original",
        "calcium",
        "supplement",
        "tablets",
        "for",
        "bone",
        "health",
        "support",
        "count",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 65,
        "manufacturing": 68,
        "safety": 65,
        "transparency": 62,
        "sustainability": 52
      },
      "price": 29.57,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803645890757",
      "vsf_explanation": "Vitabiotics is a well-established UK brand with a stronger pedigree than most Turkish resellers' inventory, and Osteocare is one of its longest-running bone-health formulas — Ca + Mg + Zn + D3, aligned with the Tang 2007 Ca+D meta-analysis for postmenopausal bone density. The formula predates the K2 evidence wave (Knapen 2013 for MK-7 and osteocalcin activation), so it's missing K2, and calcium carbonate is more common than the more-bioavailable citrate. Manufacturing benefits from UK MHRA-adjacent oversight standards. Would move to Verified 70+ with vitamin K2 MK-7 added, calcium citrate specified, and a published third-party CoA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "21st-century-glucosamine-chondroitin-plus-hyaluronic-acid-msm-120-tablets",
      "title": "21st Century Glucosamine & Chondroitin Plus Hyaluronic Acid + MSM, 120 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/148388095.jpg?v=1787581262",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "21st",
        "century",
        "glucosamine",
        "chondroitin",
        "plus",
        "hyaluronic",
        "acid",
        "msm",
        "120",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 21.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803647004869",
      "vsf_explanation": "21st Century is a value/mass-market brand common in US pharmacies; the glucosamine + chondroitin + HA + MSM stack is a rational and widely used joint-support combination. Evidence for glucosamine sulfate at 1500 mg/day is moderate (Reginster 2001, GAIT trial 2006 was mixed but subgroup analyses showed benefit in moderate-to-severe OA), and MSM has separate small trials for knee pain (Kim 2006). The concern with combination products is that individual actives often fall below their studied doses when four ingredients share tablet real estate. Would move to Verified 70+ with glucosamine sulfate (not HCl) at 1500 mg/day disclosed, chondroitin at 1200 mg/day, and a published CoA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "i̇muneks-farma-osteonext-plus-90-tablets-bone-health-dietary-supplement-for-adults-lactose-gluten-and-sugar-free",
      "title": "İmuneks Farma OsteoNext Plus 90 Tablets - Bone Health Dietary Supplement for Adults, Lactose, Gluten, and Sugar-Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2xCkA2PFNfe3StMOc6uLAgyNi5QRAeryUAHL1fDC.jpg?v=1787581287",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "muneks",
        "farma",
        "osteonext",
        "plus",
        "tablets",
        "bone",
        "health",
        "dietary",
        "supplement",
        "for",
        "adults",
        "lactose",
        "gluten",
        "and",
        "sugar",
        "free",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 32.85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803649822917",
      "vsf_explanation": "İmuneks Farma is a Turkish pharmaceutical-adjacent supplement brand, and OsteoNext Plus is positioned as a bone-health blend (typically Ca + Mg + D3 + K2 or similar). The 'Farma' pharmacy-channel positioning may translate to slightly better formulation than pure consumer brands, and the lactose/gluten/sugar-free callouts address real allergen concerns. Without full ingredient/dose disclosure on the title it's hard to verify K2 MK-7 inclusion or the calcium salt used, and third-party testing isn't documented at the reseller level. Would move to Standard-high 62+ with calcium citrate specified, K2 MK-7 included at 90-180 mcg (Knapen 2013), and per-active mg disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "webber-naturals-apple-cider-vinegar-capsules-500-mg-240-count",
      "title": "Webber Naturals Apple Cider Vinegar Capsules – 500 mg, 240 Count",
      "vendor": "Apple Cider Vinegar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/715RjuDiyyL.jpg?v=1787581326",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "webber",
        "naturals",
        "apple",
        "cider",
        "vinegar",
        "capsules",
        "500",
        "240",
        "count",
        "apple",
        "cider",
        "vinegar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 48,
        "manufacturing": 70,
        "safety": 65,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803655819461",
      "vsf_explanation": "Canadian mainstream brand (Webber Naturals) sold under Health Canada NPN oversight, which gives a real manufacturing and labeling floor above typical Amazon-tier ACV brands. Capsule format at 500 mg per capsule is on the low side dose-wise and — like every capsule in this category — misses Johnston 2004's liquid-ACV mechanism (oral acid + delayed gastric emptying pre-meal). No 'with the Mother' disclosure and no third-party USP/NSF surfaced. The brand credibility and NPN oversight are what lift it just into Standard rather than Rejected; would move to Verified 70+ only as a liquid ACV product with named acetic acid percentage and third-party verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "enzymedica-apple-cider-vinegar-gummies-with-the-mother-vitamin-b12",
      "title": "Enzymedica Apple Cider Vinegar Gummies with the Mother & Vitamin B12",
      "vendor": "Apple Cider Vinegar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71sZZ4l-t6L.jpg?v=1787581332",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "enzymedica",
        "apple",
        "cider",
        "vinegar",
        "gummies",
        "with",
        "the",
        "mother",
        "vitamin",
        "b12",
        "apple",
        "cider",
        "vinegar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 42,
        "manufacturing": 72,
        "safety": 65,
        "transparency": 60,
        "sustainability": 58
      },
      "price": 22.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803656605893",
      "vsf_explanation": "Enzymedica is a genuinely reputable digestive-enzyme brand (not a category-jumping ACV startup), which lifts manufacturing and safety confidence, and 'with the Mother' plus disclosed B12 is honest labeling. Format still cannot escape the physics: Johnston 2004's ~4% post-meal glycemic reduction requires 15-30 mL of liquid vinegar pre-meal — a gummy delivers a fraction of the acetic acid, is buffered by pectin, and bypasses the oral acid contact and delayed gastric emptying that drive the effect. 'Live mother' claims in a gummy are also difficult to substantiate given shelf-stable pectin manufacturing. Brand strength keeps it just barely at the top of the Rejected band; would move to Standard 60+ as a liquid product with the same brand quality, and Verified only with disclosed acetic acid percentage plus third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutriflair-apple-cider-vinegar-capsules-with-the-mother-1-600-mg-120-vegan-capsules",
      "title": "NutriFlair Apple Cider Vinegar Capsules with the Mother – 1,600 mg, 120 Vegan Capsules",
      "vendor": "Apple Cider Vinegar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ChatGPTImageJul23_2026at02_25_57PM.png?v=1787581337",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutriflair",
        "apple",
        "cider",
        "vinegar",
        "capsules",
        "with",
        "the",
        "mother",
        "600",
        "120",
        "vegan",
        "capsules",
        "apple",
        "cider",
        "vinegar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803657425093",
      "vsf_explanation": "Vegan capsule with 1,600 mg ACV and explicit 'with the Mother' disclosure — the cleanest format-and-labeling profile in this batch, though still fundamentally capped by category evidence. Capsules avoid the sugar-alcohol GI load of gummies and preserve more acetic acid per serving, but still miss Johnston 2004's core mechanism of oral acid contact plus delayed gastric emptying, which requires liquid pre-meal. 'With the Mother' is a legitimate quality signal (acetobacter culture) though its practical benefit over standard ACV is modest. NutriFlair is a decent Amazon-native brand without full third-party certification. Would move to Verified 70+ only as a genuine liquid ACV with named third-party testing; capsules are structurally capped in mid-Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nuttraflair-keto-apple-cider-vinegar-gummies-sugar-free-1-000-mg-60-count",
      "title": "NuttraFlair Keto Apple Cider Vinegar Gummies – Sugar-Free, 1,000 mg, 60 Count",
      "vendor": "Apple Cider Vinegar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ChatGPTImageJul24_2026at12_47_50AM.png?v=1787581346",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nuttraflair",
        "keto",
        "apple",
        "cider",
        "vinegar",
        "gummies",
        "sugar",
        "free",
        "000",
        "count",
        "apple",
        "cider",
        "vinegar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 38,
        "manufacturing": 42,
        "safety": 45,
        "transparency": 42,
        "sustainability": 45
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803658703045",
      "vsf_explanation": "'Keto' framing on a 1,000 mg sugar-free ACV gummy from a small DTC brand (note: NuttraFlair here is distinct from the more established NutriFlair capsule brand also in this batch). The 'Keto' branding on an ACV gummy is a weight-loss halo — there is no clinical evidence ACV gummies support ketogenic-diet outcomes, and the pairing exists to attach the product to a weight-loss audience without making a specific disease claim. Format still defeats the Johnston 2004 mechanism (liquid ACV pre-meal), and 'sugar-free' means sugar alcohols with GI implications. Manufacturer accountability is thin, no third-party testing or mother disclosure visible. Held in the low Rejected tier by diet-halo marketing plus mechanism-void format; no path to Standard without stripping the 'Keto' framing and moving to liquid.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bestwekk-maximum-strength-apple-cider-vinegar-gummies-with-probiotics-b12-2-000-mg-120-count",
      "title": "Bestwekk Maximum-Strength Apple Cider Vinegar Gummies with Probiotics & B12 – 2,000 mg, 120 Count",
      "vendor": "Apple Cider Vinegar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ChatGPTImageJul24_2026at12_40_05AM.png?v=1787581351",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive",
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bestwekk",
        "maximum",
        "strength",
        "apple",
        "cider",
        "vinegar",
        "gummies",
        "with",
        "probiotics",
        "b12",
        "000",
        "120",
        "count",
        "apple",
        "cider",
        "vinegar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 38,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 42,
        "sustainability": 45
      },
      "price": 35.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803659620549",
      "vsf_explanation": "'Maximum-Strength' 2,000 mg ACV gummy from Bestwekk, an obscure Amazon-tier brand with no evident manufacturing accountability, third-party testing, or brand provenance. The 'Maximum-Strength' framing is marketing language without clinical anchor — Johnston 2004 studied liquid ACV, not gummy dose escalation, and the mechanism (oral acid + delayed gastric emptying) does not scale with encapsulated mg. Added probiotic strain and CFU count are unnamed, B12 form undisclosed. The combination of anonymous manufacturer, mechanism-void format, and 'max strength' puffery keeps this in the low Rejected tier; no realistic path to Standard without a full brand and format rebuild.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "belive-sugar-free-apple-cider-vinegar-gummies-120-count",
      "title": "BeLive Sugar-Free Apple Cider Vinegar Gummies – 120 Count",
      "vendor": "Apple Cider Vinegar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/IMG-3149.png?v=1787581377",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "belive",
        "sugar",
        "free",
        "apple",
        "cider",
        "vinegar",
        "gummies",
        "120",
        "count",
        "apple",
        "cider",
        "vinegar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 38,
        "manufacturing": 52,
        "safety": 55,
        "transparency": 45,
        "sustainability": 48
      },
      "price": 22.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803659915461",
      "vsf_explanation": "Sugar-free ACV gummy from BeLive, an Amazon-native DTC brand. Title omits per-gummy ACV mg entirely, which is a real transparency deficit — buyers cannot compare acetic acid load without label inspection. Same mechanistic problem applies as with every ACV gummy: Johnston 2004's glycemic effect requires liquid vinegar pre-meal, and pectin-buffered gummies at unknown mg cannot recreate it, while 'sugar-free' means undisclosed sugar alcohols with GI implications at higher serving counts. No mother, no organic, no certifications surfaced. Would need dose disclosure plus a reformulation to liquid to reach Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "horbaach-apple-cider-vinegar-capsules-2-400-mg-150-count",
      "title": "Horbäach Apple Cider Vinegar Capsules – 2,400 mg, 150 Count",
      "vendor": "Apple Cider Vinegar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ChatGPTImageJul24_2026at12_42_54AM.png?v=1787581386",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "horb",
        "ach",
        "apple",
        "cider",
        "vinegar",
        "capsules",
        "400",
        "150",
        "count",
        "apple",
        "cider",
        "vinegar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 48,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803660865733",
      "vsf_explanation": "Higher-dose ACV capsule (2,400 mg per serving) from Horbäach, a budget mass-market house brand. Capsule format is a step above gummies — no sugar-alcohol GI load and a cleaner acetic acid delivery — but still misses the Johnston 2004 mechanism, which depends on oral acid contact plus liquid volume slowing gastric emptying; a capsule bypasses both by design. No mother mentioned in the title, no organic sourcing, no third-party testing disclosed, and Horbäach's overall manufacturing reputation is functional rather than premium. Would move to Standard 55-58 with 'with the Mother' + acetic acid percentage disclosure; only a liquid reformulation would legitimately reach Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "primal-harvest-sugar-free-apple-cider-vinegar-gummies-750-mg-60-count",
      "title": "Primal Harvest Sugar-Free Apple Cider Vinegar Gummies – 750 mg, 60 Count",
      "vendor": "Apple Cider Vinegar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/51S9kSIA50L.jpg?v=1787581398",
      "score": 47,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "primal",
        "harvest",
        "sugar",
        "free",
        "apple",
        "cider",
        "vinegar",
        "gummies",
        "750",
        "count",
        "apple",
        "cider",
        "vinegar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803661258949",
      "vsf_explanation": "Sugar-free ACV gummy at 750 mg per gummy from Primal Harvest, a DTC brand with limited third-party verification. Per Johnston 2004, meaningful ACV benefits require liquid vinegar pre-meal (delayed gastric emptying + oral acid); 750 mg encased in pectin cannot recreate that mechanism, and 'sugar-free' typically means sugar alcohols (erythritol, sorbitol, xylitol) with known GI dose-response issues at multi-gummy servings. No mother-content disclosure, no independent lab certification, and no clear probiotic or organic sourcing in the title. Would need to become a liquid product with disclosed acetic acid percentage to enter Standard tier; as-is, format alone caps it in the high-40s.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "goli-zero-sugar-apple-cider-vinegar-gummies-with-probiotics-vitamin-b12",
      "title": "Goli Zero Sugar Apple Cider Vinegar Gummies with Probiotics & Vitamin B12",
      "vendor": "Apple Cider Vinegar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/717CyY_uOCL.jpg?v=1787581412",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive",
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "goli",
        "zero",
        "sugar",
        "apple",
        "cider",
        "vinegar",
        "gummies",
        "with",
        "probiotics",
        "vitamin",
        "b12",
        "apple",
        "cider",
        "vinegar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 38,
        "manufacturing": 62,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 22.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803661914309",
      "vsf_explanation": "Goli built the ACV-gummy category, and this Zero Sugar variant swaps the original's cane sugar for sugar alcohols (erythritol/allulose typically) plus added probiotics and B12. The evidence problem is unavoidable — Johnston 2004's modest glycemic effect requires liquid ACV pre-meal, and gummy encapsulation with pectin plus a small per-gummy acetic acid load does not reproduce delayed gastric emptying or the oral-acid signal. The added probiotic strain isn't named or CFU-disclosed in the title, which weakens the transparency case, and Goli's historical marketing has repeatedly leaned on weight-management framing that outruns the actual evidence. Would move to Standard 55+ only as a genuine liquid ACV product with named probiotic strains and CFU count; gummy format capped in the high-40s regardless of sugar content.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "garden-of-life-organics-apple-cider-vinegar-gummies-with-vitamin-b12-500-mg-60-count",
      "title": "Garden of Life Organics Apple Cider Vinegar Gummies with Vitamin B12 – 500 mg, 60 Count",
      "vendor": "Apple Cider Vinegar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/61idBy_L9xL._AC_SL1500.jpg?v=1787581427",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "garden",
        "life",
        "organics",
        "apple",
        "cider",
        "vinegar",
        "gummies",
        "with",
        "vitamin",
        "b12",
        "500",
        "count",
        "apple",
        "cider",
        "vinegar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 72,
        "safety": 68,
        "transparency": 62,
        "sustainability": 65
      },
      "price": 22.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803662471365",
      "vsf_explanation": "USDA-Organic ACV gummy from Garden of Life (Nestlé Health Science-owned since 2018), delivering 500 mg of apple cider vinegar per gummy plus B12. The core problem is format: ACV's only real evidence base — Johnston 2004's ~4% post-meal glycemic reduction — depends on 15-30 mL of liquid vinegar pre-meal, where the acetic acid slows gastric emptying and briefly acidifies the stomach; a 500 mg gummy buffered by pectin and organic tapioca syrup delivers a fraction of that acetic acid load and loses the mechanism entirely. Brand and label are above average for the category (organic certification, transparent B12 form disclosure), which lifts manufacturing and sustainability, but cannot rescue a mechanistically dead format. Would move to Standard 58-62 with a genuine liquid ACV product; a gummy cannot honestly hit Verified regardless of brand.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mother-earth-labs-comprehensive-core-32-oz",
      "title": "Mother Earth Labs Comprehensive Core - 32 oz",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Mother-Earth-Labs-Comprehensive-Core-32-oz.jpg?v=1787581907",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mother",
        "earth",
        "labs",
        "comprehensive",
        "core",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 70.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803832078533",
      "vsf_explanation": "Mother Earth Labs Comprehensive Core is a liquid multi/greens blend positioned as a foundational daily foundation. Liquid delivery can improve absorption for water-soluble vitamins but requires refrigeration after opening and shorter shelf life. The evidence base for green-superfood blends is thin — no strong RCT support for the combination — and per-active mg disclosure on complex liquid blends is often obscured behind proprietary blend structures. Manufacturing is small-brand contract without visible third-party testing. Would move to Verified 70+ with per-nutrient mg disclosure (not just percent DV), a published CoA, and a specific evidence-backed active (e.g., named quercetin dose) rather than a general 'greens complex.'",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-way-alive-womens-50-gummy-vitamins-multivitamin-supplements",
      "title": "Nature's Way Alive! Women's 50+ Gummy Vitamins, Multivitamin Supplements",
      "vendor": "Nature's Way",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/330367299.jpg?v=1787581934",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "nature",
        "way",
        "alive",
        "women",
        "gummy",
        "vitamins",
        "multivitamin",
        "supplements",
        "nature",
        "way"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 55,
        "manufacturing": 65,
        "safety": 62,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 11.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803833422021",
      "vsf_explanation": "Nature's Way (Schwabe-owned) is a legitimate mainstream multivitamin brand, and Alive! Women's 50+ addresses a real nutritional-gap population — but the gummy format is a significant compromise. Gummies can't carry the higher doses (calcium, magnesium) that a 50+ multivitamin actually needs (Sherry 2010 gummy-vs-tablet dose comparisons), they typically use synthetic vitamin E (dl-alpha-tocopherol) rather than mixed tocopherols, and sugar content works against the health framing. Manufacturing is solid, but formulation is capped by format. Would move to Verified 70+ if switched to a tablet or capsule format with methylated B12/folate for the 50+ population and full mineral doses.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "muscle-sport-test-black-series-90-capsules",
      "title": "Muscle Sport Test Black Series - 90 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Muscle-Sport-Test-Black-Series-90-Capsules.jpg?v=1787581944",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "muscle",
        "sport",
        "test",
        "black",
        "series",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 42,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 89.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803833520325",
      "vsf_explanation": "Muscle Sport 'Test Black Series' is a bodybuilder testosterone-support stack typically presented as proprietary blends without per-active mg disclosure — proprietary_blend_hides_dose autofail. 'Black Series' branding implies elevated potency the label cannot substantiate, and the underlying actives (DAA, Tongkat Ali, tribulus, zinc/magnesium) span both evidence-supported (Tongkat Ali, ZMA) and weak-evidence (tribulus, DAA in trained men per Willoughby 2013 null) categories, all of which are impossible to evaluate without dose disclosure. No third-party testing publicly documented. Would need transparent per-active dosing plus named standardization to leave Rejected.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "boncal-advanced-calcium-magnesium-zinc-vitamin-d-supplement-tablets-support-bone-health-immunity",
      "title": "Boncal: Advanced Calcium, Magnesium, Zinc & Vitamin D Supplement Tablets - Support Bone Health & Immunity",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/I02qJOE7zSqTjfJ1N2ZvgpvnPhyiWtbb3A0fTKSH.jpg?v=1787581958",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "immune",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "boncal",
        "advanced",
        "calcium",
        "magnesium",
        "zinc",
        "vitamin",
        "supplement",
        "tablets",
        "support",
        "bone",
        "health",
        "immunity",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 55,
        "manufacturing": 52,
        "safety": 60,
        "transparency": 52,
        "sustainability": 48
      },
      "price": 64.11,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803833880773",
      "vsf_explanation": "Boncal is a Turkish bone-health combination product delivering the classic Ca + Mg + Zn + D3 quartet, which does have supportive evidence for postmenopausal bone density (Tang 2007 meta-analysis of Ca+D). The formulation is missing vitamin K2 (MK-7), which the current evidence suggests is important for directing calcium to bone rather than soft tissue (Knapen 2013), and calcium carbonate versus citrate makes a real absorption difference (Heaney 1999). Small Turkish brand with limited manufacturing transparency at the reseller layer. Would move to Standard-high 62+ with K2 MK-7 added, calcium citrate specified, and D3 dose disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutraxin-multi-mineral-complex-60-tablets",
      "title": "Nutraxin Multi Mineral Complex - 60 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/61h_27MpfNL_f22ad415-edf3-4777-b389-6f7e0a307bdb.jpg?v=1787581983",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutraxin",
        "multi",
        "mineral",
        "complex",
        "tablets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 52,
        "safety": 58,
        "transparency": 52,
        "sustainability": 48
      },
      "price": 16.96,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803834405061",
      "vsf_explanation": "Nutraxin is a Turkish mid-market supplement brand, and generic 'multi-mineral complex' products typically use lower-cost mineral forms (oxides and carbonates) rather than the chelates that drive better absorption (Bagchi 1997 comparative absorption review). Without per-mineral mg and form disclosure on the title, it's impossible to know whether iron/calcium/magnesium are at RDA-relevant levels. Manufacturing transparency at Turkish reseller level tends to be limited. Would move to Standard-high 62+ with chelated forms specified for the divalent minerals and a full per-nutrient mg breakdown.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "naturalnest-magnezyum-plus-magnesium-vitamin-d3-b6-supplement-for-adults-30-tablets",
      "title": "Naturalnest Magnezyum Plus - Magnesium, Vitamin D3 & B6 Supplement for Adults - 30 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0OYPUrHD4Y63PEhpAV7yPoSxDFeuXq4zaa2CpDad.jpg?v=1787582002",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "naturalnest",
        "magnezyum",
        "plus",
        "magnesium",
        "vitamin",
        "supplement",
        "for",
        "adults",
        "tablets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 55,
        "manufacturing": 52,
        "safety": 62,
        "transparency": 55,
        "sustainability": 48
      },
      "price": 16.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803834699973",
      "vsf_explanation": "Naturalnest is a Turkish brand sold via a reseller; the Mg + D3 + B6 combination is a rational sleep/mood/nervous-system stack backed by moderate evidence (Boyle 2017 for Mg on stress, Vellekkatt 2019 for D3 mood meta-analysis). The core problem is that the label doesn't disclose which magnesium salt is used — the difference between magnesium glycinate/citrate and magnesium oxide is roughly 4x in bioavailability, and this determines whether the product is meaningful. B6 in blends often comes as pyridoxine HCl rather than the active P-5-P form. Would move to Standard-high 62+ with named magnesium salt (glycinate or citrate) and P-5-P specified for B6.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "metabolic-support-capsules",
      "title": "Metabolic Support Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/47c97c59-63ea-4df0-9e8b-5e3facb1e281.jpg?v=1787582104",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "metabolic",
        "support",
        "capsules",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 48,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 42,
        "sustainability": 45
      },
      "price": 20.75,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803837944005",
      "vsf_explanation": "'Metabolic Support Capsules' is a structure-function label that reveals nothing about the actives — Perfecsy is a small unknown brand with no manufacturing provenance, and vague metabolic-support blends typically contain low-dose chromium, green tea extract, and cinnamon at sub-studied levels. Without a per-active mg breakdown it's impossible to relate the formula to any specific RCT (e.g., Yin 2008 for berberine at 500 mg tid, Cavallini 2014 for chromium picolinate). This is a Rejected-tier product primarily on transparency and provenance grounds. Would move to Standard only with full per-active mg disclosure and a specific evidence-backed active at studied dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "eye-vitamin-and-mineral-supplements",
      "title": "Eye Vitamin And Mineral Supplements",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4fd594d6-0e28-4b7e-9c93-6caa6dd14a40.jpg?v=1787582112",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "eye",
        "vitamin",
        "and",
        "mineral",
        "supplements",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 50,
        "manufacturing": 48,
        "safety": 58,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 61.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803840139461",
      "vsf_explanation": "The generic title 'Eye Vitamin and Mineral Supplements' from a small unknown brand doesn't disclose whether the formula follows the AREDS2 protocol (lutein 10 mg, zeaxanthin 2 mg, vitamin C 500 mg, vitamin E 400 IU, zinc 80 mg, copper 2 mg — Chew 2013, JAMA), which is the only formulation with strong RCT support for age-related macular degeneration progression. Without matching AREDS2 doses and forms, the underlying evidence claim doesn't transfer. No brand-level manufacturing transparency, no third-party testing, and generic naming all cap the score. Would move to Standard 60+ if the label matched the AREDS2 dosing spec exactly with lutein/zeaxanthin sourced from FloraGLO or similar named extracts.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "collagen-peptide-gummies-1",
      "title": "Collagen Peptide Gummies",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6d1fec3d-0b11-4c67-8a61-2303b7158c9e_6324f460-1305-48c3-9fba-382d763a9168.jpg?v=1787582117",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "collagen",
        "peptide",
        "gummies",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 48,
        "sustainability": 45
      },
      "price": 40.38,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803840925893",
      "vsf_explanation": "Perfecsy is a small consumer brand with no documented sourcing or third-party testing chain, and the gummy format is fundamentally unsuited for collagen delivery — meaningful outcomes in trials like Proksch 2014 (skin elasticity) and Zdzieblik 2015 (joint pain) used 2.5-10 g of hydrolyzed collagen peptides per day, which is a spoonful of powder, not what fits in a couple of gummies. Gummy collagen products typically deliver 1-2 g per serving, well below any clinically demonstrated threshold. Sugar and gelatin base also work against the health framing. Would need to become a powder or capsule format at 5-10 g/day of Verisol or similar clinically-studied peptide before it could clear Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "growth-technology-gt-foliage-focus-plant-nutrients-250-ml-size",
      "title": "Growth Technology GT Foliage Focus Plant Nutrients (250 ml Size)",
      "vendor": "The Happy Monstera Plant Co",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fead7c849b0d60fc6196012bbc1816715102b6ef45cfc18cdddc9fadc13fa6ed.jpg?v=1787582159",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "growth",
        "technology",
        "foliage",
        "focus",
        "plant",
        "nutrients",
        "250",
        "size",
        "the",
        "happy",
        "monstera",
        "plant"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 0,
        "transparency": 0,
        "sustainability": 0
      },
      "price": 15,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803892175045",
      "vsf_explanation": "This is a plant fertilizer for houseplants (foliar feed for Monstera and similar), not a human dietary supplement. It falls outside the Vyvata biohacking/human-health scope entirely and should be delisted from the scored catalog. No scoring dimensions are applicable.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "chaga-mushroom-extract-capsules",
      "title": "Chaga Mushroom Extract Capsules",
      "vendor": "FreshCap Mushrooms",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/chaga_capsules_120ct.png?v=1787582170",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chaga",
        "mushroom",
        "extract",
        "capsules",
        "freshcap",
        "mushrooms"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 70,
        "manufacturing": 70,
        "safety": 65,
        "transparency": 72,
        "sustainability": 65
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803905249477",
      "vsf_explanation": "FreshCap applies the same wild-harvest and fruiting-body focus to chaga (Inonotus obliquus), and the label typically discloses a beta-glucan percentage and dual-extraction method — that's better than most retail chaga. However, chaga's evidence base is weaker than reishi or turkey tail; most claims come from in-vitro antioxidant studies (Zheng 2010) rather than human RCTs. Chaga also contains oxalates, which can be problematic for people with kidney concerns, and this deserves a safety flag on the label. Would move to Verified 70+ with an oxalate advisory, a disclosed beta-glucan percentage, and human-trial citations rather than in-vitro data.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-turkey-tail-mushroom-capsules",
      "title": "Organic Turkey Tail Mushroom Capsules",
      "vendor": "FreshCap Mushrooms",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/turkey_tail_capsules_120ct.png?v=1787582179",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "turkey",
        "tail",
        "mushroom",
        "capsules",
        "freshcap",
        "mushrooms"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 72,
        "manufacturing": 70,
        "safety": 72,
        "transparency": 72,
        "sustainability": 68
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803906724037",
      "vsf_explanation": "FreshCap is a specialist mushroom brand with a fruiting-body-only sourcing standard and published beta-glucan percentages, which is meaningfully better than the mycelium-on-grain products that dominate the US market. Turkey tail (Trametes versicolor) PSK/PSP has evidence for immune modulation, largely from Japanese oncology adjunct research (Tsang 2003, Standish 2008 review), though these used pharmaceutical-grade extracts at higher doses than typical retail capsules. Certified organic and USDA-organic support sustainability. Would move to Verified 70+ with a disclosed beta-glucan percentage on the SKU label and a published independent lab report for the specific lot.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-diosmin-complex-1-000mg-per-serving-180-veggie-caps-non-gmo-vegan-citrus-aurantium",
      "title": "NusaPure Diosmin Complex 1,000mg per Serving 180 Veggie Caps (Non-GMO, Vegan) Citrus Aurantium",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d4bdce6c.jpg?v=1787582209",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "diosmin",
        "complex",
        "000mg",
        "per",
        "serving",
        "180",
        "veggie",
        "caps",
        "non",
        "gmo",
        "vegan",
        "citrus",
        "aurantium",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 62,
        "sustainability": 48
      },
      "price": 31.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803917963461",
      "vsf_explanation": "Diosmin (a flavonoid glycoside from citrus) has strong evidence for chronic venous insufficiency and hemorrhoids, particularly in micronized purified flavonoid fraction (Daflon 500) at 900mg diosmin + 100mg hesperidin/day — a Cochrane-supported protocol. 1000mg per serving is within therapeutic range if the ratio approximates 90% diosmin / 10% hesperidin. Micronization status not disclosed and matters heavily for absorption. Citrus aurantium mention is neutral — bitter orange contains synephrine, which has cardiovascular safety concerns and should be quantified separately. Would move to Verified 70+ with micronized-fraction spec and disclosed diosmin:hesperidin ratio.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-lemon-balm-30-1-extract-200-mg-per-vegan-caps-200-count-non-gmo-vegan-bioperine",
      "title": "NusaPure Lemon Balm 30:1 Extract, 200 mg Per Vegan Caps - 200 Count Non-GMO, Vegan Bioperine",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-131765v4-Lemon-Balm-3D-01.jpg?v=1787582404",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "lemon",
        "balm",
        "extract",
        "200",
        "per",
        "vegan",
        "caps",
        "200",
        "count",
        "non",
        "gmo",
        "vegan",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 62,
        "sustainability": 48
      },
      "price": 28.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803952435397",
      "vsf_explanation": "Lemon balm (Melissa officinalis) has small but decent trials for acute anxiety, cognitive performance, and mild insomnia (Kennedy et al. 2003, 2006; Cases et al. 2011 for Cyracos at 600mg/day standardized to rosmarinic acid). This 200mg of a 30:1 extract equates to 6g raw-leaf equivalent but is not standardized to rosmarinic acid percentage (>5% for Cyracos, the studied branded extract). BioPerine addition is neutral for a botanical of this class. Would move to Verified 70+ with rosmarinic acid % disclosure or branded Cyracos sourcing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-melatonin-vitamin-b6-10-mg-per-60-tablets-vegetarians-vegans-non-gmo-dietary-supplement",
      "title": "NusaPure Melatonin + Vitamin B6 10 mg Per 60 Tablets Vegetarians Vegans Non-GMO Dietary Supplement",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e3cb742c.jpg?v=1787582404",
      "score": 53,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "melatonin",
        "vitamin",
        "per",
        "tablets",
        "vegetarians",
        "vegans",
        "non",
        "gmo",
        "dietary",
        "supplement",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 45,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803952632005",
      "vsf_explanation": "Melatonin at 10mg is 25-30x endogenous nocturnal secretion and 10-30x the effective physiological dose demonstrated by Zhdanova et al. 2001 (0.3mg matched 3mg for sleep-onset). Supraphysiological doses increase morning grogginess, downregulate receptor sensitivity with chronic use, and produce plasma levels far outside anything a human body was designed to encounter. Per our own Best Melatonin analysis, 10mg products sit in the below-Standard range. B6 co-dose is redundant when melatonin is provided exogenously. Would need dose reduction to 1mg or less to move into Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-kudzu-root-20-1-extract-200-mg-120-veggie-capsules-non-gmo-vegan-bioperine",
      "title": "NusaPure Kudzu Root 20:1 Extract, 200 mg - 120 Veggie Capsules (Non-GMO, Vegan, Bioperine)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nusapure-Kudzu-4_000mg-3D-v3-01.jpg?v=1787582404",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "kudzu",
        "root",
        "extract",
        "200",
        "120",
        "veggie",
        "capsules",
        "non",
        "gmo",
        "vegan",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 22.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803952599237",
      "vsf_explanation": "Kudzu (Pueraria lobata) has small trials for alcohol-consumption reduction (Lukas et al. 2005, 2013 at 500-1000mg standardized to isoflavones) and traditional use for menopausal symptoms via puerarin. This 200mg of a 20:1 extract is not standardized to puerarin or total-isoflavone percentage. Weak drug-interaction risks with methotrexate and tamoxifen due to isoflavone content. Would move to Standard 65+ with puerarin % standardization and Verified with branded NPI-028 sourcing (Lukas trial extract).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-melatonin-3-mg-60-tablets-vegetarian-vegan-non-gmo",
      "title": "NusaPure Melatonin 3 mg 60 Tablets Vegetarian/Vegan, Non-GMO",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/93b10d40.jpg?v=1787582404",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "melatonin",
        "tablets",
        "vegetarian",
        "vegan",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 16.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803952468165",
      "vsf_explanation": "Melatonin at 3mg is above the 0.3-1mg physiological range that Zhdanova et al. 2001 showed matches higher doses for sleep-onset while producing plasma levels closer to endogenous secretion. Not egregious like 10mg but still 3-10x optimal. Immediate-release tablet is appropriate for sleep-onset use. Third-party identity/potency testing not indicated — a real concern since Cohen et al. 2017 found 71% of tested melatonin products deviated >10% from label claim. Would move to Standard 65+ at 1mg dose; Verified 70+ requires low dose plus third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-black-elderberry-50-1-extract-100-mg-per-veggie-capsules-200-count-vegan-non-gmo-bioperine-dietary-supplement",
      "title": "NusaPure Black Elderberry 50:1 Extract, 100 mg per Veggie Capsules, 200 Count (Vegan, Non-GMO, Bioperine) Dietary Supplement",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-131812v3-Black-Elderberry-3D-01.jpg?v=1787582404",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "black",
        "elderberry",
        "extract",
        "100",
        "per",
        "veggie",
        "capsules",
        "200",
        "count",
        "vegan",
        "non",
        "gmo",
        "bioperine",
        "dietary",
        "supplement",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 65,
        "sustainability": 48
      },
      "price": 29.45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803952500933",
      "vsf_explanation": "Black elderberry (Sambucus nigra) has moderate evidence for shortening cold and influenza duration (Hawkins et al. 2019 meta of 4 RCTs; Tiralongo et al. 2016 for Sambucol). Studied protocols use standardized syrups (Sambucol 15ml QID) or capsules delivering 300-600mg berry equivalent — this 100mg of a 50:1 extract equates to 5g raw-berry equivalent, a solid dose. Anthocyanin percentage not disclosed. Would move to Verified 70+ with anthocyanin standardization or branded Sambucol/BerryPharma sourcing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-organic-kale-powder-extract-10-1-suitable-for-vegetarian-vegan-non-gmo-1-000-mg-250-capsules",
      "title": "NusaPure Organic Kale Powder Extract 10:1 - Suitable for Vegetarian/Vegan, Non- GMO - 1,000 mg - 250 Capsules",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-132141V2-Nusapure-Kale-3D_01.jpg?v=1787582404",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "organic",
        "kale",
        "powder",
        "extract",
        "suitable",
        "for",
        "vegetarian",
        "vegan",
        "non",
        "gmo",
        "000",
        "250",
        "capsules",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 62,
        "sustainability": 60
      },
      "price": 26.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803952533701",
      "vsf_explanation": "Dried kale powder in capsule form is essentially a whole-food supplement with no meaningful concentration of specific actives — kale's benefits in whole-food form come from a matrix of vitamin K, lutein, glucosinolates, and fiber that a 1g extract cannot approximate. 1000mg of a 10:1 kale extract carries meaningful vitamin K1 content that could interact with warfarin (not flagged). Organic certification is a plus. Whole-food kale would deliver more nutrition per dollar. Would move to Standard 62+ only with lutein/K1 standardization and warfarin-interaction labeling.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-royal-jelly-10-1-extract-400-mg-120-veggie-capsules-non-gmo-dairy-free-dietary-supplement",
      "title": "NusaPure Royal Jelly 10:1 Extract, 400 mg - 120 Veggie Capsules (Non-GMO, Dairy Free, Dietary Supplement)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-131831v4-RoyalJelly-3D-01.jpg?v=1787582403",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "royal",
        "jelly",
        "extract",
        "400",
        "120",
        "veggie",
        "capsules",
        "non",
        "gmo",
        "dairy",
        "free",
        "dietary",
        "supplement",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 24.85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803952566469",
      "vsf_explanation": "Royal jelly has small trials for menopausal symptoms, blood pressure, and immune markers with mixed results (Bărnuțiu et al. 2011 review; Sharif et al. 2019 for menopause). This 400mg of a 10:1 extract equates to 4g fresh royal jelly equivalent. Real safety concern: royal jelly has caused documented severe allergic reactions including anaphylaxis and fatal asthma exacerbations in atopic individuals (Leung et al. 1997) — bee-product allergy warning is essential and not flagged. Would need bee-allergy contraindication labeling and 10-HDA (10-hydroxy-2-decenoic acid) standardization to move to Standard 65+.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-apple-cider-vinegar-complex-1500-mg-180-veg-caps-suitable-for-vegetarians-and-vegans-non-gmo",
      "title": "NusaPure Apple Cider Vinegar Complex 1500 mg 180 Veg Caps Suitable for Vegetarians and Vegans, Non-GMO",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3be42467.jpg?v=1787582405",
      "score": 53,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "apple",
        "cider",
        "vinegar",
        "complex",
        "1500",
        "180",
        "veg",
        "caps",
        "suitable",
        "for",
        "vegetarians",
        "and",
        "vegans",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 48,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 52,
        "sustainability": 48
      },
      "price": 22,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803952828613",
      "vsf_explanation": "The limited human evidence for apple cider vinegar in weight and glycemic outcomes (Kondo et al. 2009; Launholt et al. 2020 review) all uses liquid vinegar containing acetic acid — the proposed mechanism requires the acid contacting the stomach and gut lining. Capsule-format ACV largely loses this mechanism, and \"complex\" formulations rarely disclose actual acetic-acid mg per serving. The \"1500mg\" number cannot represent acetic acid at that level in a capsule format. Would need to be repositioned as a heritage/traditional product without weight-loss claims, or reformulated as a liquid delivery system with disclosed acetic-acid mg.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-candihealth-complex-non-gmo-vegan-120-veggie-capsules",
      "title": "NusaPure CandiHealth Complex (Non-GMO, Vegan) 120 Veggie Capsules",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a5d78a2f.jpg?v=1787582404",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "candihealth",
        "complex",
        "non",
        "gmo",
        "vegan",
        "120",
        "veggie",
        "capsules",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 45,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 25.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803952664773",
      "vsf_explanation": "\"CandiHealth\" framing targets \"candida overgrowth\" or \"chronic systemic candida\" — a diagnostic entity that is not recognized outside a small alternative-medicine ecosystem and does not appear in mainstream gastroenterology or infectious-disease guidelines. Real invasive candidiasis is a serious hospital-acquired infection requiring prescription antifungals (fluconazole, echinocandins), not an OTC herbal capsule. The category shares regulatory-risk territory with parasite-cleanse products. Ingredient breakdown is not disclosed on the title. Would need reframing as a general gut-support product with ingredient disclosure and removal of candida-specific medical claims to be listable at Standard tier.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "nusapure-polypodium-nicotinamide-10-1-extract-240-mg-per-veg-caps-150-count-non-gmo-soyfree-bioperine",
      "title": "NusaPure Polypodium Nicotinamide 10:1 Extract, 240 mg per Veg Caps - 150 Count (Non-GMO, Soyfree, Bioperine)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-131399v3-Polypodium-150-Vcaps-3D-01.jpg?v=1787582404",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "polypodium",
        "nicotinamide",
        "extract",
        "240",
        "per",
        "veg",
        "caps",
        "150",
        "count",
        "non",
        "gmo",
        "soyfree",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 60,
        "sustainability": 48
      },
      "price": 28.1,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803952697541",
      "vsf_explanation": "Polypodium leucotomos extract (fern-derived) has moderate evidence for photoprotection and reducing UV-induced skin damage (Middelkamp-Hup et al. 2004; Nestor et al. 2015), typically studied as branded Fernblock/Heliocare at 240-480mg. The combination with nicotinamide (also skin-photoprotective — Chen et al. 2015) is scientifically reasonable. This 240mg of a 10:1 extract does not disclose the ratio between polypodium and nicotinamide or the Fernblock-standardized fraction. Would move to Verified 70+ with Fernblock sourcing and disclosed nicotinamide mg.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-olive-leaf-20-oleuropein-50-1-extract-500-mg-200-veg-caps-suitable-for-vegetarians-and-vegans-non-gmo",
      "title": "NusaPure Olive Leaf 20% Oleuropein 50:1 Extract, 500 mg 200 Veg Caps Suitable for Vegetarians and Vegans, Non-GMO",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-130972v5-Olive-Leaf-20_-3D-01.jpg?v=1787582404",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "olive",
        "leaf",
        "oleuropein",
        "extract",
        "500",
        "200",
        "veg",
        "caps",
        "suitable",
        "for",
        "vegetarians",
        "and",
        "vegans",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 70,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 75,
        "sustainability": 50
      },
      "price": 25.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803952730309",
      "vsf_explanation": "Olive leaf extract has decent evidence for blood pressure and lipid profile (Susalit et al. 2011 head-to-head vs captopril at 500mg BID standardized to 20% oleuropein — the exact spec of this product). This is one of the better-formulated products in the batch: named active compound (oleuropein) with disclosed 20% standardization at a studied dose of 500mg. Would move to Verified 70+ with third-party identity testing of oleuropein content and encapsulated stability data.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-marshmallow-root-50-1-extract-200-mg-per-veggie-caps-180-count-non-gmo-vegan-bioperine",
      "title": "NusaPure Marshmallow Root 50:1 Extract, 200 mg Per Veggie Caps 180 Count (Non-GMO, Vegan) Bioperine",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-132952v2-Marshmallow-180-Vcaps-3D-01.jpg?v=1787582404",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "marshmallow",
        "root",
        "extract",
        "200",
        "per",
        "veggie",
        "caps",
        "180",
        "count",
        "non",
        "gmo",
        "vegan",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 62,
        "sustainability": 48
      },
      "price": 18.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803952795845",
      "vsf_explanation": "Marshmallow root (Althaea officinalis) is a traditional demulcent for GI and throat mucosa, with the mechanism dependent on mucilage polysaccharides forming a soothing film. Real formulation issue: mucilage works only when hydrated and in contact with mucous membranes, so a concentrated 50:1 extract in a capsule loses most of the mechanism — traditional preparation is a cold-water infusion or lozenge. Long history of safe use. Would move to Standard 65+ if reformulated as lozenge or drink mix; capsule format caps the ceiling.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-melatonin-quick-dissolve-500-mcg-per-60-tablets-dietary-supplement-vegan-non-gmo",
      "title": "NusaPure Melatonin Quick Dissolve 500 mcg Per 60 Tablets Dietary Supplement Vegan, Non-GMO",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7bfa98df.jpg?v=1787582404",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "melatonin",
        "quick",
        "dissolve",
        "500",
        "mcg",
        "per",
        "tablets",
        "dietary",
        "supplement",
        "vegan",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 72,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 16.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803952861381",
      "vsf_explanation": "This is the standout melatonin product in the batch: 500mcg (0.5mg) sits within the 0.3-1mg physiological dose range shown by Zhdanova et al. 2001 to match higher doses for sleep-onset while producing plasma levels much closer to endogenous nocturnal secretion — the dose our Best Melatonin guide identifies as the studied sweet spot. Quick-dissolve/sublingual format further supports fast onset for sleep initiation. Would move to Verified 70+ with third-party identity/potency testing addressing the Cohen et al. 2017 label-accuracy concern, and named excipient sweetener disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-black-currant-seed-oil-1605-mg-gamma-linoleic-acid-gla-15-180-softgels-non-gmo-soyfree",
      "title": "NusaPure Black Currant Seed Oil 1605 mg Gamma Linoleic Acid (GLA) 15% 180 Softgels (Non-GMO, Soyfree)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b2c80c93.jpg?v=1787582404",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "black",
        "currant",
        "seed",
        "oil",
        "1605",
        "gamma",
        "linoleic",
        "acid",
        "gla",
        "180",
        "softgels",
        "non",
        "gmo",
        "soyfree",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 72,
        "sustainability": 50
      },
      "price": 30,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803952894149",
      "vsf_explanation": "Black currant seed oil delivers GLA (gamma-linolenic acid) with a higher GLA percentage than borage or evening primrose alternatives. 1605mg at 15% GLA provides ~240mg GLA per serving — within range for studied indications (atopic dermatitis, PMS, RA inflammation at 240-500mg GLA/day). Softgel format is correct for a seed oil, GLA % is disclosed clearly, and stearidonic acid content is a bonus. Would move to Verified 70+ with third-party rancidity/peroxide testing and disclosed antioxidant preservation (tocopherol).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-blessed-thistle-seed-30-1-extract-100-mg-per-veggie-caps-150-count-non-gmo-vegan",
      "title": "NusaPure Blessed Thistle Seed 30:1 Extract, 100 mg Per Veggie Caps 150 Count (Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-133010v2-Blessed-Thistle-3D-01.jpg?v=1787582404",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "blessed",
        "thistle",
        "seed",
        "extract",
        "100",
        "per",
        "veggie",
        "caps",
        "150",
        "count",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 58,
        "sustainability": 48
      },
      "price": 17.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803952763077",
      "vsf_explanation": "Blessed thistle (Cnicus benedictus) is a traditional lactation herb and bitter digestive tonic with essentially no controlled human trials supporting either use. This 100mg of a 30:1 extract equates to 3g raw-seed equivalent. Common in lactation-support blends (Mother's Milk) but always alongside fenugreek and other galactagogues — as a monoproduct the evidence is thin. Would remain in Standard 55-62 range even with better standardization simply because the underlying evidence base is limited.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-melatonin-lozenges-with-vitamin-b6-fast-dissolving-suitable-for-vegetarian-vegan-non-gmo-2-5mg-60-counts",
      "title": "NusaPure Melatonin Lozenges with Vitamin B6 - Fast Dissolving, Suitable for Vegetarian/Vegan, Non-GMO - 2.5mg - 60 Counts",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/bbe4c149.jpg?v=1787582404",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "melatonin",
        "lozenges",
        "with",
        "vitamin",
        "fast",
        "dissolving",
        "suitable",
        "for",
        "vegetarian",
        "vegan",
        "non",
        "gmo",
        "5mg",
        "counts",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803952959685",
      "vsf_explanation": "2.5mg melatonin is above the 0.3-1mg physiological range from Zhdanova et al. 2001 but well below the 10mg outliers. Fast-dissolving lozenge (sublingual) format is a genuine formulation upgrade over swallowed tablets — sublingual delivery bypasses first-pass metabolism, achieves peak plasma faster, and typically requires less material per dose (arguing the 2.5mg dose is effectively higher). B6 co-dose adds nothing when exogenous melatonin is provided. Would move to Standard 65+ at 1mg dose in the same lozenge format; Verified 70+ requires low dose plus third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-maca-root-black-red-yellow-750mg-180-vegan-capsules-vegan-non-gmo-gluten-free-bioperine",
      "title": "NusaPure Maca Root Black, Red, Yellow 750mg - 180 Vegan Capsules (Vegan,Non-GMO, Gluten Free) Bioperine",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Black-Red-Yellow-Maca-3d-render--v4-01.jpg?v=1787582404",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "energy",
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "maca",
        "root",
        "black",
        "red",
        "yellow",
        "750mg",
        "180",
        "vegan",
        "capsules",
        "vegan",
        "non",
        "gmo",
        "gluten",
        "free",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 30,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803952926917",
      "vsf_explanation": "Tri-color maca (black, red, yellow phenotypes) is a reasonable choice since each color has slightly different active-compound emphasis — black for cognition/energy, red for prostate, yellow as the baseline. 750mg is below the 1.5-3g/day used in the strongest maca trials (Gonzales series). Gelatinization status not disclosed — non-gelatinized maca has starchy compounds that can cause GI discomfort and reduce absorption. BioPerine addition is reasonable but not necessary. Would move to Standard 65+ with gelatinized-maca claim and higher per-serving dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-boswellia-serrata-500-mg-per-veggie-caps-200-count-ext-20-1-non-gmo-vegan-bioperine-ayurvedic-herb-indian-olibanum-frankincense",
      "title": "NusaPure Boswellia Serrata 500 mg Per Veggie Caps 200 Count (Ext. 20:1, Non-GMO, Vegan, Bioperine) Ayurvedic Herb: Indian Olibanum, Frankincense",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Boswellia_custom_200s_a1.png?v=1787582406",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "boswellia",
        "serrata",
        "500",
        "per",
        "veggie",
        "caps",
        "200",
        "count",
        "ext",
        "non",
        "gmo",
        "vegan",
        "bioperine",
        "ayurvedic",
        "herb",
        "indian",
        "olibanum",
        "frankincense",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 62,
        "sustainability": 48
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803952992453",
      "vsf_explanation": "Boswellia serrata has decent evidence for osteoarthritis pain and inflammation (Kimmatkar et al. 2003; Sengupta et al. 2010 for 5-Loxin at 100-250mg standardized to 30% AKBA). This 500mg of a 20:1 extract is not standardized to AKBA (acetyl-11-keto-β-boswellic acid) percentage — the single most important quality spec since generic boswellic acid content varies wildly. BioPerine may help absorption. Would move to Verified 70+ with AKBA % disclosure (30% AKBA is the studied benchmark) or branded ApresFlex/5-Loxin sourcing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-myo-inositol-suitable-for-vegetarian-vegan-non-gmo-2800mg-200-capsules",
      "title": "NusaPure Myo-Inositol - Suitable for Vegetarian/Vegan, Non - GMO - 2800mg, 200 Capsules",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5e8d295c.jpg?v=1787582405",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "myo",
        "inositol",
        "suitable",
        "for",
        "vegetarian",
        "vegan",
        "non",
        "gmo",
        "2800mg",
        "200",
        "capsules",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 65,
        "sustainability": 48
      },
      "price": 26.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803953057989",
      "vsf_explanation": "Myo-inositol has strong evidence for PCOS insulin sensitivity and ovulation (Unfer et al. 2017 meta) and for anxiety/OCD at higher doses (Palatnik et al. 2001). Studied PCOS protocols use 2-4g/day, often with a 40:1 myo:D-chiro ratio — this 2800mg dose is within therapeutic range but is myo-only (no D-chiro combination). Cheap, well-tolerated ingredient. Would move to Verified 70+ with third-party identity testing and 40:1 myo:D-chiro option per Nordio et al. 2019 protocol.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-l-methionine-1200mg-200-capsules-non-gmo-vegan-supplement",
      "title": "NusaPure L Methionine 1200mg | 200 Capsules | Non-GMO | Vegan Supplement",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4fa157f3.jpg?v=1787582405",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "methionine",
        "1200mg",
        "200",
        "capsules",
        "non",
        "gmo",
        "vegan",
        "supplement",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 21.2,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803953090757",
      "vsf_explanation": "L-methionine is an essential sulfur amino acid; supplemental need in a normal diet is minimal since methionine is abundant in animal protein. Chronic high-dose methionine supplementation raises homocysteine and has been proposed as a longevity concern (methionine restriction increases lifespan in animal models — Miller et al. 2005). 1200mg/day is a substantial dose and would benefit from mandatory B6/B12/folate co-supplementation to manage homocysteine. Legitimate uses (Tylenol overdose antidote, urinary acidification) are medical rather than general-supplement. Would move to Standard 65+ with B-vitamin co-formulation and honest use-case framing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-black-seed-oil-2000mg-per-serving-180-softgel-caps-non-gmo-gluten-free-cold-pressed-nigella-sativa",
      "title": "NusaPure Black Seed Oil 2000mg per Serving - 180 Softgel Caps (Non-GMO, Gluten-Free) Cold-Pressed Nigella Sativa",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/032149b7.jpg?v=1787582406",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "black",
        "seed",
        "oil",
        "2000mg",
        "per",
        "serving",
        "180",
        "softgel",
        "caps",
        "non",
        "gmo",
        "gluten",
        "free",
        "cold",
        "pressed",
        "nigella",
        "sativa",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 30.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803953221829",
      "vsf_explanation": "Black seed oil (Nigella sativa) has decent human evidence for blood pressure, glycemic markers, and lipid profile (Sahebkar et al. 2016 meta showing modest BP and TC reductions). Cold-pressed extraction and softgel format are the right formulation choices for the thymoquinone active. 2000mg per serving is within studied ranges (2-3g/day). Thymoquinone percentage not disclosed — quality black seed oil standardizes to 0.5-3% TQ. Would move to Verified 70+ with disclosed TQ % and third-party rancidity/peroxide value testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-calmme-with-valerian-passion-flower-celery-catnip-hops-orange-peel-395-mg-60-per-tablet-vegetarian-vegan-non-gmo",
      "title": "NusaPure Calmme with Valerian Passion Flower Celery Catnip Hops Orange Peel 395 mg 60 Per Tablet Vegetarian/Vegan, Non-GMO",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d9937442.jpg?v=1787582407",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "calmme",
        "with",
        "valerian",
        "passion",
        "flower",
        "celery",
        "catnip",
        "hops",
        "orange",
        "peel",
        "395",
        "per",
        "tablet",
        "vegetarian",
        "vegan",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 48,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 52,
        "sustainability": 48
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803953254597",
      "vsf_explanation": "Six-herb sleep/calm blend at 395mg total means each ingredient averages ~66mg — well below therapeutic doses for any of them individually (valerian studied at 400-900mg root extract, passionflower at 350-500mg, hops at 200mg). Per-ingredient breakdown appears to be a proprietary blend without individual dose disclosure. Herb selection is traditional and low-safety-risk, but a six-way split at this total load cannot match single-herb studied protocols. Would move to Standard 62+ with per-ingredient mg disclosure and total dose 800mg+, and reasonably not exceed Standard given the shotgun-blend design.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-red-clover-blossoms-20-1-extract-100-mg-200-veg-capsules-trifolium-pratente-l-suitable-for-vegetarians-vegan-non-gmo-dietary-supplement",
      "title": "NusaPure Red Clover Blossoms 20:1 Extract, 100 mg 200 Veg Capsules Trifolium Pratente L. Suitable for Vegetarians/Vegan Non GMO Dietary Supplement",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nusapure-RedClover2000mg-3D-v3-01.jpg?v=1787582407",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "red",
        "clover",
        "blossoms",
        "extract",
        "100",
        "200",
        "veg",
        "capsules",
        "trifolium",
        "pratente",
        "suitable",
        "for",
        "vegetarians",
        "vegan",
        "non",
        "gmo",
        "dietary",
        "supplement",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 21.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803953352901",
      "vsf_explanation": "Red clover (Trifolium pratense) is used for menopausal symptoms via isoflavones (biochanin A, formononetin); Cochrane review (Lethaby et al. 2013) found modest hot-flash reduction with branded Promensil at 80mg isoflavones/day. This 100mg of a 20:1 extract equates to 2g raw-blossom equivalent but is not standardized to isoflavone percentage — a real gap since the estrogenic active fraction varies widely. Contraindicated in estrogen-sensitive cancer, anticoagulant therapy, and pregnancy — not indicated on title. Would move to Standard 65+ with isoflavone standardization (40mg per dose) and hormone-sensitive-condition warning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-prostate-support-20-1-extract-300-mg-200-veg-caps-dietary-supplement-vegan-non-gmo",
      "title": "NusaPure Prostate Support 20:1 Extract, 300 mg 200 Veg Caps Dietary Supplement Vegan, Non-GMO",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Prostrate-Support-3d-render-v2-01.jpg?v=1787582407",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "prostate",
        "support",
        "extract",
        "300",
        "200",
        "veg",
        "caps",
        "dietary",
        "supplement",
        "vegan",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 52,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 48
      },
      "price": 32.1,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803953320133",
      "vsf_explanation": "The product is labeled \"Prostate Support 20:1 Extract\" without disclosing which herb is being extracted — saw palmetto, pygeum, stinging nettle root, and pumpkin seed are all common prostate-support botanicals with different mechanisms, doses, and safety profiles. This anonymity of the primary active makes the product effectively unscorable at the ingredient level and inconsistent with basic supplement labeling expectations. Would need actual ingredient disclosure (e.g., \"saw palmetto 320mg\") to move into legitimate Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-choline-bitartrate-suitable-for-vegetarian-vegan-non-gmo-1000-mg-200-capsules",
      "title": "NusaPure Choline Bitartrate - Suitable for Vegetarian/Vegan, Non - GMO - 1000 mg 200 Capsules",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4befe29a.jpg?v=1787582407",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "choline",
        "bitartrate",
        "suitable",
        "for",
        "vegetarian",
        "vegan",
        "non",
        "gmo",
        "1000",
        "200",
        "capsules",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 21.3,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803953385669",
      "vsf_explanation": "Choline bitartrate is the cheapest supplemental choline form and delivers about 41% elemental choline — 1000mg of the salt provides ~410mg choline, roughly the RDA (550mg for men, 425mg for women). Bitartrate is inefficient for CNS choline delivery compared to alpha-GPC (~40% choline, crosses BBB) or CDP-choline/citicoline (nootropic evidence). This form is fine for meeting general choline adequacy but a poor pick for cognitive/nootropic use. Would move to Standard 65+ if repositioned as basic-adequacy choline; nootropic positioning requires alpha-GPC or CDP-choline.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-butchers-broom-root-20-1-extract-300-mg-veggie-caps-180-count-non-gmo-vegan",
      "title": "NusaPure Butcher's Broom Root 20:1 Extract, 300 mg Veggie Caps 180 Count (Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-132988v3-ButcherBroom-3D-01.jpg?v=1787582408",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "butcher",
        "broom",
        "root",
        "extract",
        "300",
        "veggie",
        "caps",
        "180",
        "count",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 62,
        "sustainability": 48
      },
      "price": 17.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803953451205",
      "vsf_explanation": "Butcher's broom (Ruscus aculeatus) has evidence for chronic venous insufficiency in combined formulations with hesperidin (Kakkos et al. 2018 meta of Cyclo 3 Fort). This 300mg of a 20:1 extract equates to 6g raw-root equivalent but is not standardized to ruscogenin percentage (0.75% typical for European Pharmacopoeia grade). Missing the hesperidin methyl chalcone that drives the strongest venous-tone evidence. Would move to Verified 70+ with ruscogenin standardization and combination with hesperidin (as in Cyclo 3 Fort at 150mg butcher's broom + 150mg HMC + 100mg ascorbic).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-rosemary-capsules-20-1-extract-400-mg-200-veggie-caps-non-gmo-vegan",
      "title": "NusaPure Rosemary Capsules | 20:1 Extract, 400 mg | 200 Veggie Caps | Non-GMO & Vegan",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-132654v3-Rosemary-3D-01.jpg?v=1787582409",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "rosemary",
        "capsules",
        "extract",
        "400",
        "200",
        "veggie",
        "caps",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 26.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803954663621",
      "vsf_explanation": "Rosemary (Rosmarinus officinalis) has small human trials showing acute cognitive-performance and mood effects, mostly via aroma or specific rosmarinic-acid extracts (Moss & Oliver 2012). This 400mg of a 20:1 leaf extract is not standardized to rosmarinic acid or carnosic acid percentage, and dry-powder capsule loses most of the aromatic-oil active fraction that drives acute cognitive effects. Traditional culinary safety profile is excellent. Would move to Verified 70+ with rosmarinic acid standardization (>5%) or carnosic acid % on label.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-cranberry-1-200-mg-180-veg-caps-bioperine-non-gmo-vegan",
      "title": "NusaPure Cranberry 1,200 mg 180 Veg Caps (Bioperine, Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nusapure-3d-Cranberry-V3-1.jpg?v=1787582411",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "cranberry",
        "200",
        "180",
        "veg",
        "caps",
        "bioperine",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 22.3,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803954761925",
      "vsf_explanation": "Cranberry has moderate evidence for reducing recurrent UTI risk in women (Jepson et al. Cochrane 2012 update; benefit most consistent at ≥36mg proanthocyanidins/day). This 1200mg cranberry product does not disclose PAC content, which is the single most important spec — cheap cranberry powder can have <1% PACs while quality extracts (Ellura, Cran-Max) standardize to 36mg PACs/dose. Without PAC disclosure, dose-effectiveness is unknown. Would move to Verified 70+ with disclosed PAC mg (36mg via BL-DMAC assay) and named branded extract.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-vitamin-k2-mk7-200mcg-vitamin-d3-10000-iu-180-veg-caps-bioperine-soyfree-non-gmo",
      "title": "NusaPure Vitamin K2 (MK7) (200mcg) + Vitamin D3 (10000 IU) 180 Veg Caps - Bioperine, Soyfree, Non-GMO",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ab0fb0b7.jpg?v=1787582410",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "vitamin",
        "mk7",
        "200mcg",
        "vitamin",
        "10000",
        "180",
        "veg",
        "caps",
        "bioperine",
        "soyfree",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 70,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 72,
        "sustainability": 50
      },
      "price": 23.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803954794693",
      "vsf_explanation": "The D3/K2 (MK-7) combination is a well-supported vitamin protocol: D3 for calcium absorption and bone/immune outcomes (Martineau et al. 2017 for respiratory infection prevention), K2 MK-7 for directing calcium to bone rather than arteries (Knapen et al. 2013 at 180mcg MK-7 for 3 years). MK-7 form and 200mcg dose are strong choices; 10000 IU D3 is above RDA and appropriate only for confirmed deficiency or short-term correction (not indefinite maintenance). Veggie cap format is unusual for fat-soluble vitamins — softgel with oil carrier gives better absorption. Would move to Verified 70+ with softgel-oil carrier and warning that 10000 IU D3 requires periodic 25-OH-D monitoring.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-oregano-oil-extract-307mg-200-veggie-powder-capsules-naturally-occurring-carvacrol-non-gmo-and-vegan-extract-65-1",
      "title": "NusaPure Oregano Oil Extract 307mg | 200 Veggie Powder Capsules | Naturally Occurring Carvacrol | Non-GMO and Vegan Extract 65:1",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-132118v3-Oil-of-Oregano-Leaf-3D-01.jpg?v=1787582410",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "oregano",
        "oil",
        "extract",
        "307mg",
        "200",
        "veggie",
        "powder",
        "capsules",
        "naturally",
        "occurring",
        "carvacrol",
        "non",
        "gmo",
        "and",
        "vegan",
        "extract",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 65,
        "sustainability": 48
      },
      "price": 24.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803954827461",
      "vsf_explanation": "Oregano oil (Origanum vulgare) has strong preclinical antimicrobial data via carvacrol but limited human oral-supplementation trials — the strongest human data is for gastrointestinal use in SIBO/parasitic contexts (Force et al. 2000). This 307mg powder capsule of a 65:1 extract mentions carvacrol qualitatively but does not disclose carvacrol percentage (60-80% typical for quality extracts). Genuine oregano oil in dry powder is less bioavailable than emulsified softgel form. Would move to Standard 65+ with carvacrol % disclosure and Verified with softgel format.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-chitosan-1200mg-150-caps-non-gmo-soyfree-with-bioperine",
      "title": "NusaPure Chitosan 1200mg 150 Caps (Non-GMO & Soyfree) with Bioperine",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/411f605d.jpg?v=1787582411",
      "score": 53,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "chitosan",
        "1200mg",
        "150",
        "caps",
        "non",
        "gmo",
        "soyfree",
        "with",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 28.7,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803954860229",
      "vsf_explanation": "Chitosan (a shellfish-derived polysaccharide) is marketed as a fat-blocker/weight-loss aid; Cochrane review (Jull et al. 2008) concluded weight-loss effect is minimal and unlikely to be clinically meaningful. Studied doses were higher (2-15g/day) than this 1200mg. Shellfish allergen risk should be labeled and is not on title. Chitosan can interfere with absorption of fat-soluble vitamins (A, D, E, K) and some medications. Would need to be repositioned away from weight-loss claims and given shellfish-allergen labeling to move to Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-chamomile-flower-20-1-extract-300-mg-per-veggie-caps-200-count-non-gmo-vegan",
      "title": "NusaPure Chamomile Flower 20:1 Extract, 300 mg Per Veggie Caps 200 Count (Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-133001v2-Chamomile-Flower-3D-01.jpg?v=1787582410",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "chamomile",
        "flower",
        "extract",
        "300",
        "per",
        "veggie",
        "caps",
        "200",
        "count",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 17.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803954892997",
      "vsf_explanation": "Chamomile (Matricaria recutita) has moderate evidence for GAD (Amsterdam et al. 2009 at 220-1100mg standardized to 1.2% apigenin) and small sleep-quality effects. This 300mg of a 20:1 extract equates to 6g raw-flower equivalent but is not standardized to apigenin percentage — a real formulation gap since the anxiolytic mechanism is apigenin GABAergic activity. Species disclosure absent (M. recutita vs M. chamomilla — same plant but a labeling clarity gap). Would move to Verified 70+ with disclosed apigenin % standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-pregnenolone-micronized-100-mg-per-serving-200-veg-caps-dietary-supplement-vegan-non-gmo",
      "title": "NusaPure Pregnenolone (Micronized) 100 mg Per Serving 200 Veg Caps Dietary Supplement Vegan, Non-GMO",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b5a53e0c.jpg?v=1787582410",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "pregnenolone",
        "micronized",
        "100",
        "per",
        "serving",
        "200",
        "veg",
        "caps",
        "dietary",
        "supplement",
        "vegan",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 48,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 23.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803954925765",
      "vsf_explanation": "Pregnenolone is an endogenous prohormone (precursor to DHEA, cortisol, and sex steroids) with limited controlled human trials in supplement form. Micronization is a genuine formulation upgrade for oral bioavailability. Real safety concerns: unpredictable downstream conversion to androgens/estrogens, potential hormone-sensitive cancer contraindication, and drug interactions — none flagged on title. 100mg is a high dose; TrueMedX and Life Extension typically dose 25-50mg with practitioner guidance. Would move to Standard 65+ with lower default dose, practitioner-guidance language, and safety warnings for hormone-sensitive conditions.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-peruvian-black-maca-root-extract-750mg-50-1-suitable-for-vegetarian-vegan-non-gmo-37500-mg-200-capsules",
      "title": "NusaPure Peruvian Black Maca Root Extract 750mg 50:1 - Suitable for Vegetarian/Vegan, Non - GMO - 37500 mg - 200 Capsules",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-130545v9-Peruvian-Black-Maca-3d-01.jpg?v=1787582410",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "energy",
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "peruvian",
        "black",
        "maca",
        "root",
        "extract",
        "750mg",
        "suitable",
        "for",
        "vegetarian",
        "vegan",
        "non",
        "gmo",
        "37500",
        "200",
        "capsules",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 37.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803954958533",
      "vsf_explanation": "Black maca (Lepidium meyenii, black phenotype) has small trials for libido and sperm parameters (Gonzales et al. 2001-2013). Studied doses range 1.5-3g/day of gelatinized maca root — this 750mg of a 50:1 extract translates to a claimed 37,500mg raw-root equivalent, which follows industry convention but overstates real-world potency since 50:1 concentration ratios rarely retain the full active-compound spectrum of raw maca. Marketing the raw-equivalent number as the headline is borderline misleading naming. Would move to Standard 65+ with gelatinized (heat-processed) claim and macamide/macaene standardization; sustained-ingredient trials favor 3g gelatinized whole root over concentrates.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-glucomannan-1-000-mg-per-serving-200-vcaps-20-1-extract-bioperine-non-gmo-vegan-konjac-root",
      "title": "NusaPure Glucomannan 1,000 mg per Serving 200 VCaps (20:1 Extract, BioPerine Non-GMO, Vegan) Konjac Root",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-130855v4-Glucomannan-3D-01.jpg?v=1787582410",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "glucomannan",
        "000",
        "per",
        "serving",
        "200",
        "vcaps",
        "extract",
        "bioperine",
        "non",
        "gmo",
        "vegan",
        "konjac",
        "root",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 48,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 22.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803954991301",
      "vsf_explanation": "Glucomannan is a soluble fiber from konjac root with EFSA-approved satiety and weight-management claim at 3g/day taken with water before meals. The formulation is a genuine problem here: glucomannan works via bulk viscosity, and a \"20:1 extract\" removes the fiber matrix that drives the mechanism — quality glucomannan products use whole konjac powder, not concentrated extracts. Serious safety concern: glucomannan capsules require large volumes of water and have caused esophageal obstruction (FDA warnings) — no label warning implied by title. Would need reformulation as whole-root powder or drink mix and choking-hazard labeling to reach Standard 62+.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-antarctic-krill-oil-2000-mg-120-softgels-omega-3-epa-360mg-dha-240mg-soyfree-astaxanthin-supplement-sourced-from-krill-800ppm",
      "title": "NusaPure Antarctic Krill Oil 2000 mg 120 Softgels, Omega-3 EPA 360mg, DHA 240mg, Soyfree Astaxanthin Supplement Sourced from Krill 800ppm",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/15244250.jpg?v=1787582411",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "antarctic",
        "krill",
        "oil",
        "2000",
        "120",
        "softgels",
        "omega",
        "epa",
        "360mg",
        "dha",
        "240mg",
        "soyfree",
        "astaxanthin",
        "supplement",
        "sourced",
        "from",
        "krill",
        "800ppm",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 30.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803955024069",
      "vsf_explanation": "Krill oil provides omega-3s in phospholipid form with better bioavailability per gram than triglyceride fish oil (Ulven et al. 2011) plus naturally occurring astaxanthin. 360mg EPA + 240mg DHA per 2000mg serving is honestly disclosed but low absolute EPA/DHA per softgel — most cardiovascular trials use 1-2g combined EPA+DHA/day. Astaxanthin at 800ppm equates to ~1.6mg per 2000mg serving, modest but present. Sustainability of Antarctic krill fisheries is contested; MSC certification would be a significant improvement. Would move to Verified 70+ with MSC krill certification, IFOS oxidation testing, and higher EPA/DHA per serving.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-usda-organic-maqui-berry-10-1-extract-100-mg-180-veg-caps-suitable-for-vegetarians-and-vegans-non-gmo",
      "title": "NusaPure USDA Organic Maqui Berry 10:1 Extract, 100 mg 180 Veg Caps Suitable for Vegetarians and Vegans, Non-GMO",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-132249v3-Maqui-Berry-3D-01.jpg?v=1787582411",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "usda",
        "organic",
        "maqui",
        "berry",
        "extract",
        "100",
        "180",
        "veg",
        "caps",
        "suitable",
        "for",
        "vegetarians",
        "and",
        "vegans",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 68,
        "sustainability": 62
      },
      "price": 22.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803955056837",
      "vsf_explanation": "Maqui berry (Aristotelia chilensis) is a Patagonian berry with high anthocyanin content and preliminary human trials for dry eye and glycemic response (Hitoe et al. 2014 at MaquiBright 30-60mg). This 100mg of a 10:1 extract equates to 1g raw-berry equivalent — modest but reasonable, and USDA Organic certification is a genuine plus for sustainability and pesticide-load. Not standardized to delphinidin percentage (the key anthocyanin), and branded MaquiBright is the only ingredient with published human RCT data. Would move to Verified 70+ with anthocyanin standardization and branded-ingredient sourcing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-neem-leaf-root-10-1-extract-200-mg-150-veggie-capsules-herbal-supplement-non-gmo-vegan",
      "title": "NusaPure Neem Leaf Root 10:1 Extract, 200 mg 150 Veggie Capsules|Herbal Supplement|Non-GMO, Vegan",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-133834v2-Neem-3D-01.jpg?v=1787582411",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "neem",
        "leaf",
        "root",
        "extract",
        "200",
        "150",
        "veggie",
        "capsules",
        "herbal",
        "supplement",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803955089605",
      "vsf_explanation": "Neem (Azadirachta indica) is used in Ayurvedic tradition for skin, blood sugar, and antimicrobial purposes with mostly preclinical support and limited controlled human trials. Neem seed oil is contraindicated in pregnancy (documented spermicidal/abortifacient effects) and can affect blood sugar and blood pressure. This 200mg of a 10:1 leaf-and-root extract does not disclose azadirachtin or nimbin content, and \"leaf-and-root\" is an unusual combination that limits comparability to studied protocols. Would move to Standard 65+ with plant-part specificity, pregnancy contraindication labeling, and identity testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-bitter-melon-extract-400-mg-180-vegan-caps-100-vegetarian-non-gmo-gluten-free-10-bitter-principles-bioperine",
      "title": "NusaPure Bitter Melon Extract 400 mg 180 Vegan Caps (100% Vegetarian, Non-GMO, Gluten-Free, 10% Bitter Principles) Bioperine",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-130956v5-Bitter-Melon-3D-01.jpg?v=1787582412",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "bitter",
        "melon",
        "extract",
        "400",
        "180",
        "vegan",
        "caps",
        "100",
        "vegetarian",
        "non",
        "gmo",
        "gluten",
        "free",
        "bitter",
        "principles",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 70,
        "sustainability": 48
      },
      "price": 20.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803955122373",
      "vsf_explanation": "Bitter melon (Momordica charantia) has moderate evidence for glucose lowering (Yin et al. 2014 meta showed modest HbA1c effect vs placebo). This product usefully discloses 10% bitter principles standardization — better transparency than most botanicals in this batch. 400mg is on the lower end of studied doses (2000-4000mg fruit powder typical) but the standardization compensates. Caution required with diabetes medications due to additive hypoglycemia. Would move to Verified 70+ with third-party charantin or momordicin verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-intestinal-support-for-humans-non-gmo-wormwood-garlic-black-walnut-hull-60-capsules",
      "title": "NusaPure Intestinal Support for Humans (Non-GMO), Wormwood, Garlic, Black Walnut Hull, 60 Capsules",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NusaPure_Parasite_a1.jpg?v=1787582416",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "intestinal",
        "support",
        "for",
        "humans",
        "non",
        "gmo",
        "wormwood",
        "garlic",
        "black",
        "walnut",
        "hull",
        "capsules",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 40,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803956498629",
      "vsf_explanation": "The wormwood + black walnut + garlic combination is the classic Hulda Clark \"parasite cleanse\" protocol — a framing without controlled human trial support and one that leads people away from evidence-based treatment for actual parasitic infection (which requires stool ova/parasite testing and prescription antiparasitics like ivermectin, albendazole, praziquantel). Wormwood thujone is neurotoxic at chronic doses and contraindicated in pregnancy and seizure disorders; black walnut allergy is not rare. The \"intestinal support for humans\" framing borrows the marketing language of veterinary dewormers. Would require reframing away from parasite-cleanse claims and adding safety labeling to be listable at Standard tier.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "nusapure-nicotinamide-with-resveratrol-vitamin-b-3-500-mg-180-vegetarian-caps-non-gmo-vegan",
      "title": "NusaPure Nicotinamide with Resveratrol (Vitamin B-3) 500 mg - 180 Vegetarian Caps (Non-GMO & Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/64fef876.jpg?v=1787582415",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "nicotinamide",
        "with",
        "resveratrol",
        "vitamin",
        "500",
        "180",
        "vegetarian",
        "caps",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 60,
        "sustainability": 48
      },
      "price": 26.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803956531397",
      "vsf_explanation": "Nicotinamide (the amide form of niacin) has evidence for NAD+ support and skin photoprotection (Chen et al. NEJM 2015 at 500mg BID for skin cancer prevention). This 500mg once-daily dose is within the studied photoprotection range but the resveratrol co-dose is not disclosed — trans-resveratrol has poor oral bioavailability and needs 500mg+ from a standardized source to matter. Compared to NMN or NR precursors, plain nicotinamide is a cheaper but well-supported NAD+ pathway option. Would move to Verified 70+ with disclosed resveratrol mg and trans-resveratrol % specification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-celery-seed-capsules-10-1-extract-375-mg-240-veggie-caps-non-gmo-vegan",
      "title": "NusaPure Celery Seed Capsules 10:1 Extract, 375 mg, 240 Veggie Caps, Non-GMO, Vegan",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nusapure-CelerySeed-3d-v7-1.jpg?v=1787582416",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "celery",
        "seed",
        "capsules",
        "extract",
        "375",
        "240",
        "veggie",
        "caps",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 26.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803956564165",
      "vsf_explanation": "Celery seed (Apium graveolens) is traditionally used as a diuretic and for gout via 3-n-butylphthalide (3nB) content; modern human evidence is limited (Madhavi et al. 2013 small hypertension trial). This 375mg of a 10:1 extract equates to about 3.75g raw-seed equivalent but is not standardized to 3nB or phthalide percentage. Salicylate cross-reactivity in aspirin-sensitive individuals should be noted. Would move to Verified 70+ with standardized 3nB content and identity testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-mucuna-pruriens-1000mg-200-veggie-caps-non-gmo-100-vegetarian-vegan",
      "title": "NusaPure Mucuna Pruriens 1000mg 200 Veggie Caps (Non-GMO, 100% Vegetarian, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e92ca2d4.jpg?v=1787582416",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "mucuna",
        "pruriens",
        "1000mg",
        "200",
        "veggie",
        "caps",
        "non",
        "gmo",
        "100",
        "vegetarian",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 58,
        "sustainability": 48
      },
      "price": 23.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803956596933",
      "vsf_explanation": "Mucuna pruriens is the primary botanical source of L-dopa and has small clinical evidence in Parkinson's disease (Katzenschlager et al. 2004; HP-200 formulation). The therapeutic effect depends entirely on L-dopa content, which varies from <1% in raw powder to 15-99% in standardized extracts — this 1000mg product does not disclose L-dopa percentage, making dose effectively unknown. L-dopa carries genuine drug-interaction risks (MAOIs, antipsychotics, antihypertensives) not flagged on title. Would move to Standard 65+ with disclosed L-dopa % (15% or 40% standardization typical for quality extracts).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-men-s-daily-formula-full-spectrum-multivitamin-with-vitamins-a-c-d-e-k-b-complex-folate-biotin-minerals-lycopene-60-tablets-non-gmo",
      "title": "NusaPure Men’s Daily Formula – Full Spectrum Multivitamin with Vitamins A, C, D, E, K, B-Complex, Folate, Biotin, Minerals & Lycopene | 60 Tablets | Non-GMO",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fa20a5c1.jpg?v=1787582417",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune",
        "cognitive",
        "mood",
        "skin"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "men",
        "daily",
        "formula",
        "full",
        "spectrum",
        "multivitamin",
        "with",
        "vitamins",
        "complex",
        "folate",
        "biotin",
        "minerals",
        "lycopene",
        "tablets",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 48
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803956662469",
      "vsf_explanation": "Men's daily multi in tablet form with lycopene addition — lycopene has modest prostate-health evidence (Chen et al. 2015 meta) at 15-30mg/day but this dose is not disclosed. Folate and biotin forms unclear (unlikely methylfolate or 5-MTHF), mineral chelation not indicated, and vitamin K form (MK-4 vs MK-7 vs K1) not specified. Tablet compression can compromise vitamin C and B12 stability. Would move to Standard 65+ with methylated B vitamins, chelated minerals, and disclosed lycopene mg.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-melatonin-with-vitamin-b6-calcium-suitable-for-vegetarian-vegan-non-gmo-5-mg-60-tablets",
      "title": "NusaPure Melatonin with Vitamin B6 & Calcium - Suitable for Vegetarian/Vegan, Non-GMO - 5 mg - 60 Tablets",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/bf6b308a.jpg?v=1787582417",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "melatonin",
        "with",
        "vitamin",
        "calcium",
        "suitable",
        "for",
        "vegetarian",
        "vegan",
        "non",
        "gmo",
        "tablets",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 13.1,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803956695237",
      "vsf_explanation": "Melatonin at 5mg is 5-15x endogenous nocturnal secretion and well above the 0.3-1mg physiological dose that Zhdanova et al. 2001 and multiple follow-ups found equally effective for sleep onset and less likely to cause morning grogginess. B6 addition supports endogenous melatonin synthesis but is redundant in an exogenous melatonin product. Immediate-release tablet format is fine for sleep onset but not for sleep maintenance. Would move to Standard 65+ at a 1mg dose; Verified 70+ requires low dose plus third-party identity testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-cherryclear-tart-cherry-10-1-extract-500-mg-vitamin-c-cherry-seed-grape-seed-900mg-per-vegan-caps-60-count",
      "title": "NusaPure CherryClear Tart Cherry 10:1 Extract, 500 mg + Vitamin C + Cherry Seed + Grape Seed 900mg Per Vegan Caps 60 Count",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c71c3937.jpg?v=1787582418",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "cherryclear",
        "tart",
        "cherry",
        "extract",
        "500",
        "vitamin",
        "cherry",
        "seed",
        "grape",
        "seed",
        "900mg",
        "per",
        "vegan",
        "caps",
        "count",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 58,
        "sustainability": 48
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803956728005",
      "vsf_explanation": "Tart cherry (Prunus cerasus) has decent evidence for sleep quality via naturally occurring melatonin (Howatson et al. 2012) and post-exercise recovery (Bell et al. 2014). Most studied protocols use Montmorency cherry juice (240ml) or CherryPURE powder (480mg) — cultivar not disclosed here. The combined 900mg-per-cap formula bundles tart cherry with vitamin C, cherry seed, and grape seed extracts, which spreads active doses thin. Would move to Verified 70+ with Montmorency specification, anthocyanin standardization, and clearer per-ingredient breakdown.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-lactase-enzyme-9000-fcc-lactase-unit-suitable-for-vegetarians-vegan-non-gmo-220-veg-capsules",
      "title": "NusaPure Lactase Enzyme 9000 FCC, Lactase Unit, Suitable for Vegetarians/Vegan, Non-GMO, 220 Veg Capsules",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71276302.jpg?v=1787582418",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "lactase",
        "enzyme",
        "9000",
        "fcc",
        "lactase",
        "unit",
        "suitable",
        "for",
        "vegetarians",
        "vegan",
        "non",
        "gmo",
        "220",
        "veg",
        "capsules",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 68,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 27.7,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803956793541",
      "vsf_explanation": "Lactase enzyme supplementation has strong evidence for symptom relief in lactose maldigestion (Ibba et al. 2014; multiple crossover trials with Lactaid-type products at 3000-9000 FCC). 9000 FCC units per capsule is a therapeutic dose range for a meal containing 12-18g lactose. Enzyme source (Aspergillus oryzae typical) not disclosed on title. Would move to Verified 70+ with source strain disclosure and third-party activity assay verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-liposomal-vitamin-c-2032mg-200-veggie-vegan-capsules-bioperine-high-absorption-ascorbic-acid",
      "title": "NusaPure Liposomal Vitamin C 2032mg - 200 Veggie Vegan Capsules, BioPerine - High Absorption Ascorbic Acid",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/750daab9.jpg?v=1787582419",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "liposomal",
        "vitamin",
        "2032mg",
        "200",
        "veggie",
        "vegan",
        "capsules",
        "bioperine",
        "high",
        "absorption",
        "ascorbic",
        "acid",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 28.7,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803956826309",
      "vsf_explanation": "\"Liposomal vitamin C\" in a dry capsule format is a marketing claim that rarely reflects true liposome architecture — genuine liposomal vitamin C typically requires a stabilized liquid or gel matrix (LivOn, Quicksilver) where phospholipids encapsulate ascorbate; capsule-format liposomal products often contain lecithin blended with ascorbic acid without verified vesicle formation. 2032mg is a high dose regardless. Would need particle-size / encapsulation verification data plus phospholipid source to move to Standard 65+, and probably reformulation as sachet/liquid to justify the liposomal premium.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-astragalus-root-30-1-extract-500-mg-200-veg-caps-suitable-for-vegetarians-and-vegans-non-gmo",
      "title": "NusaPure Astragalus Root 30:1 Extract, 500 mg 200 Veg Caps Suitable for Vegetarians and Vegans, Non-GMO",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nusapure-Astragalus-3D-New-v7-01.jpg?v=1787582418",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "astragalus",
        "root",
        "extract",
        "500",
        "200",
        "veg",
        "caps",
        "suitable",
        "for",
        "vegetarians",
        "and",
        "vegans",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 26.6,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803956859077",
      "vsf_explanation": "Astragalus membranaceus is a TCM immune adaptogen with mixed but generally positive evidence for immune modulation and adjunctive use in chemotherapy (Cochrane review 2007). This 500mg of a 30:1 extract equates to roughly 15g raw-root equivalent — a reasonable functional dose — but is not standardized to astragalosides or polysaccharides. Species disclosed. Would move to Verified 70+ with astragaloside IV or cycloastragenol percentage and identity testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-apigenin-100-mg-per-capsule-180-vcaps-bioperine-non-gmo-gluten-free",
      "title": "NusaPure Apigenin 100 mg per Capsule 180 Vcaps - Bioperine (Non-GMO, Gluten Free)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5427d472.jpg?v=1787582419",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "apigenin",
        "100",
        "per",
        "capsule",
        "180",
        "vcaps",
        "bioperine",
        "non",
        "gmo",
        "gluten",
        "free",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 65,
        "sustainability": 48
      },
      "price": 33.8,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803956891845",
      "vsf_explanation": "Apigenin is a chamomile-derived flavonoid popularized for CD38 inhibition (Huberman-adjacent longevity framing) with mostly preclinical data — human RCTs at these doses are minimal. Bulk apigenin at 100mg is within the range shown in Andrew Huberman's protocol references (50mg) but well above typical dietary intake. BioPerine may improve absorption but interacts with many prescription drugs (CYP3A4 inhibition) — a safety note not on the title. Would move to Verified only when human RCT data catches up to the mechanistic hype.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrex-alpha-t-magnum-120-caps",
      "title": "Nutrex Alpha-T Magnum, 120 Caps",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Picture24_672e721b-a92d-49c1-8f97-bb78236374a3.jpg?v=1787582439",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrex",
        "alpha",
        "magnum",
        "120",
        "caps",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 42,
        "manufacturing": 48,
        "safety": 45,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803962429637",
      "vsf_explanation": "Nutrex Alpha-T Magnum is a bodybuilder testosterone-support product with the 'Magnum' naming implying outsized results, delivered as a proprietary blend without per-active mg — proprietary_blend_hides_dose autofail. Typical blends in this class stack DAA, Tongkat Ali, fenugreek, and aromatase-inhibitor herbals; even the evidence-supported actives (Tongkat Ali per Talbott 2013 at Physta 200mg) cannot be verified at studied dose behind a blend. Nutrex is mid-tier sports manufacturing without published per-lot COA. Would need transparent per-active mg disclosure with named-source standardization to reach Standard.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "21-again-rewind-natural-testosterone-booster",
      "title": "21 Again Rewind Natural Testosterone Booster",
      "vendor": "21 Again",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/21A-Product-1.webp?v=1787582445",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "again",
        "rewind",
        "natural",
        "testosterone",
        "booster",
        "again"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 42,
        "transparency": 32,
        "sustainability": 40
      },
      "price": 69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803963904197",
      "vsf_explanation": "'21 Again Rewind' brands itself as an anti-aging testosterone product with 'rewind your age' framing that crosses into unverified_medical_claim territory — no supplement can reverse chronological age or restore youthful hormone levels in the way the branding implies. Typical formulations in this class stack DAA, Tongkat Ali, fenugreek, and tribulus in a proprietary blend without per-active mg, adding a proprietary_blend concern on top of the claim issue. The 21 Again brand has minimal public manufacturing accountability or third-party testing documentation. Would need honest positioning, transparent per-active dosing, and evidence-supported actives at studied doses to escape Rejected.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "nusapure-white-willow-bark-20-1-extract-200-mg-200-veggie-capsules-max-strength-non-gmo-vegan",
      "title": "NusaPure White Willow Bark 20:1 Extract, 200 mg, 200 Veggie Capsules, Max Strength, (Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nusapure-WhiteWillowBark-v3-01.jpg?v=1787582464",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "white",
        "willow",
        "bark",
        "extract",
        "200",
        "200",
        "veggie",
        "capsules",
        "max",
        "strength",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 52,
        "transparency": 62,
        "sustainability": 45
      },
      "price": 25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803966984389",
      "vsf_explanation": "White willow bark contains salicin, a natural aspirin precursor, with modest evidence for low back pain and osteoarthritis (Chrubasik et al. 2000-2001). Studied doses typically deliver 120-240mg salicin/day — this 200mg of a 20:1 extract could theoretically approach that but is not standardized to salicin percentage. The product should carry warnings for anticoagulant interactions, GI bleeding risk, Reye's syndrome in children, and salicylate allergy — none indicated by the title. Would move to Verified 70+ with salicin % disclosure and required safety labeling.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-daily-multivitamin-with-vegetable-magnesium-stearate-suitable-for-vegetarian-vegan-non-gmo-60-tablets",
      "title": "NusaPure Daily Multivitamin with Vegetable Magnesium Stearate - Suitable for Vegetarian/Vegan, Non-GMO - 60 Tablets",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d0daaeb0.jpg?v=1787582465",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "daily",
        "multivitamin",
        "with",
        "vegetable",
        "magnesium",
        "stearate",
        "suitable",
        "for",
        "vegetarian",
        "vegan",
        "non",
        "gmo",
        "tablets",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 52,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 9.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803967017157",
      "vsf_explanation": "Basic once-daily multivitamin in tablet form with no disclosed form-quality of the B vitamins (unlikely to be methylated) or mineral chelation on label. The title's headline feature is vegetable magnesium stearate — a manufacturing excipient, not a therapeutic active — which signals a formulation that leads with a marketing angle rather than form quality. Iron content unclear (a real issue for men and postmenopausal women). Would move to Standard 65+ with methylated B12/folate disclosure, chelated minerals, and separated iron/no-iron variants.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-brown-seaweed-30-1-extract-200-mg-200-veggie-capsules-vegan-non-gmo-bioperine",
      "title": "NusaPure Brown Seaweed 30:1 Extract, 200 mg 200 Veggie Capsules - (Vegan, Non-GMO Bioperine)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-129497v7-Brown-Seaweed-3D-01.jpg?v=1787582464",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "brown",
        "seaweed",
        "extract",
        "200",
        "200",
        "veggie",
        "capsules",
        "vegan",
        "non",
        "gmo",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 23.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803967049925",
      "vsf_explanation": "Brown seaweed extracts (typically Laminaria, Fucus, or Ascophyllum) are marketed for fucoidan and iodine content, with early evidence for immune modulation and metabolic effects (Fitton 2011 review). This 200mg of a 30:1 extract does not disclose species, fucoidan percentage, or iodine content — a real safety issue since iodine varies dramatically and can trigger thyroid dysfunction at excess doses. BioPerine addition does not compensate for missing iodine labeling. Would move to Standard 65+ with species disclosure and iodine mcg on label.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-caralluma-fimbriata-1600mg-180-veggie-capsules-non-gmo-vegan",
      "title": "NusaPure Caralluma Fimbriata 1600mg - 180 Veggie Capsules (Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8491d854.jpg?v=1787582464",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "caralluma",
        "fimbriata",
        "1600mg",
        "180",
        "veggie",
        "capsules",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 58,
        "sustainability": 45
      },
      "price": 23.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803967082693",
      "vsf_explanation": "Caralluma fimbriata has a small evidence base for appetite suppression (Kuriyan et al. 2007, Astell et al. 2013) with mixed results and small effect sizes. Studied trials typically used branded Slimaluma at 500-1000mg of a standardized extract — this 1600mg does not disclose whether it is raw powder, ratio extract, or standardized to pregnane glycosides. Weight-loss claims for this herb are weak overall. Would move to Standard 65+ with branded standardized extract or disclosed pregnane-glycoside %; would not exceed Verified given the modest evidence base.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-calcium-pyruvate-suitable-for-vegetarian-vegan-non-gmo-1500-mg-200-capsules",
      "title": "NusaPure Calcium Pyruvate - Suitable for Vegetarian/Vegan, Non - GMO - 1500 mg - 200 Capsules",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ceb6c507.jpg?v=1787582465",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "calcium",
        "pyruvate",
        "suitable",
        "for",
        "vegetarian",
        "vegan",
        "non",
        "gmo",
        "1500",
        "200",
        "capsules",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 58,
        "sustainability": 45
      },
      "price": 31.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803967246533",
      "vsf_explanation": "Calcium pyruvate was popular in 1990s-2000s weight-loss marketing based on Stanko et al. small trials using 22-44g/day. Meta-analytic evidence at real-world doses (1500-6000mg) shows little to no meaningful fat-loss effect (Onakpoya et al. 2014). At 1500mg this product provides pyruvate at a fraction of studied protocols. Would move to Standard 62+ only with an honest energy-cofactor framing rather than weight-loss positioning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-alpha-lipoic-acid-600-mg-per-serving-180-veggie-capsules-vegetarian-non-gmo-vegan",
      "title": "NusaPure Alpha Lipoic Acid 600 mg per Serving 180 Veggie Capsules (Vegetarian, Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8f3c8596.jpg?v=1787582464",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "alpha",
        "lipoic",
        "acid",
        "600",
        "per",
        "serving",
        "180",
        "veggie",
        "capsules",
        "vegetarian",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 65,
        "sustainability": 48
      },
      "price": 32.4,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803967148229",
      "vsf_explanation": "Alpha lipoic acid at 600mg matches the dose used in the largest diabetic-neuropathy trials (SYDNEY, ALADIN series; Ziegler et al.) and has decent human data for oxidative stress markers. The product does not disclose R-ALA versus racemic ALA — R-ALA is the biologically active enantiomer and roughly 2x more potent per mg, while racemic mixtures are cheaper and standard for budget brands. Take on empty stomach for absorption (not indicated). Would move to Verified 70+ with R-ALA specification or stabilized R-ALA (Na-RALA) plus third-party identity testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-ear-health-support-system-vitamin-c-b-vitamins-niacin-pantothenic-acid-calcium-choline-bioflavonoids-inositol-90-vegetarian-tablets-gmp-quality-vegan-lab-tested",
      "title": "NusaPure Ear Health Support System – Vitamin C, B Vitamins, Niacin, Pantothenic Acid, Calcium, Choline, Bioflavonoids & Inositol – 90 Vegetarian Tablets – GMP Quality & Vegan – Lab Tested",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8ceeb2f4.jpg?v=1787582464",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "ear",
        "health",
        "support",
        "system",
        "vitamin",
        "vitamins",
        "niacin",
        "pantothenic",
        "acid",
        "calcium",
        "choline",
        "bioflavonoids",
        "inositol",
        "vegetarian",
        "tablets",
        "gmp",
        "quality",
        "vegan",
        "lab",
        "tested",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 40,
        "sustainability": 55
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803967115461",
      "vsf_explanation": "'Ear Health Support' branding implies tinnitus, hearing loss, or ear-related targeting that has no meaningful supplement-level RCT support — vitamins and bioflavonoids in a general multi-B formula do not have hearing-preservation efficacy in the general population (Person 2016 Cochrane on antioxidants for tinnitus is largely negative). Per-active mg is not disclosed on the title, a proprietary-blend structure. Would move to Standard 55+ only with rebranding away from ear-specific implication and per-nutrient mg disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-dihydromyricetin-dhm-1-000mg-60-veggie-tablets-no-gmo-100-vegetarian",
      "title": "NusaPure Dihydromyricetin (DHM) 1,000mg 60 Veggie Tablets (No GMO & 100% Vegetarian)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-130712v3-Nusapure-Dihydromyricetin_01.jpg?v=1787582464",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "dihydromyricetin",
        "dhm",
        "000mg",
        "veggie",
        "tablets",
        "gmo",
        "100",
        "vegetarian",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 29.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803967213765",
      "vsf_explanation": "Dihydromyricetin (DHM, ampelopsin) has preclinical evidence for GABA-A modulation and alcohol-metabolism support (Shen 2012 rat model), and one small human trial (Chen 2015) showed modest hangover markers. 1,000 mg is at the high end of doses used in preliminary human work. The clinical evidence base for the popular 'hangover cure' positioning remains thin. Would move to Standard 62+ with a specific efficacy target supported by human RCT and per-lot purity assay.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-bee-pollen-1500mg-200-veggie-caps-100-vegetarian-non-gmo-vegan-naturally-occurring-proteins-aminoacids",
      "title": "NusaPure Bee Pollen 1500mg 200 Veggie Caps (100% Vegetarian, Non-GMO, Vegan) Naturally Occurring Proteins, Aminoacids",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/91326f39.jpg?v=1787582465",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "bee",
        "pollen",
        "1500mg",
        "200",
        "veggie",
        "caps",
        "100",
        "vegetarian",
        "non",
        "gmo",
        "vegan",
        "naturally",
        "occurring",
        "proteins",
        "aminoacids",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803967312069",
      "vsf_explanation": "Bee pollen has broad traditional use but sparse human clinical trial evidence — most claims rest on nutrient composition rather than demonstrated efficacy for any specific endpoint. Anaphylaxis risk in pollen-allergic individuals is real (Cohen 1979 case reports) and this label lacks the necessary allergy warning. 'Vegan' labeling is questionable for an animal-derived (insect-collected) product. Would move to Standard 58+ with allergy disclosure and honest sourcing framing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-graviola-20-1-10-1-extract-500mg-suitable-for-vegetarian-vegan-non-gmo-200-capsules",
      "title": "NusaPure Graviola 20:1 & 10:1 Extract 500mg - Suitable for Vegetarian/Vegan, Non- GMO - 200 Capsules",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nusapure-Graviola-3D-v6-01.jpg?v=1787582464",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "graviola",
        "extract",
        "500mg",
        "suitable",
        "for",
        "vegetarian",
        "vegan",
        "non",
        "gmo",
        "200",
        "capsules",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 48,
        "manufacturing": 55,
        "safety": 40,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 29.15,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803967279301",
      "vsf_explanation": "Graviola (Annona muricata) is marketed on preclinical antiproliferative data but has no human oncology RCT evidence, and — critically — annonaceous acetogenins have been implicated in atypical parkinsonism in the Caribbean (Caparros-Lefebvre 2002, Lannuzel 2007). Long-term consumption carries a documented neurotoxicity signal. Even absent explicit disease claims on the label, this evidence-to-safety profile does not clear Rejected.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-wormwood-capsules-100mg-artemisia-annua-herb-200-count-non-gmo-vegan-supplement",
      "title": "NusaPure Wormwood Capsules 100mg | Artemisia Annua Herb | 200 Count | Non-GMO & Vegan Supplement",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-132542v4-Wormwood-3D-01.jpg?v=1787582464",
      "score": 51,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "wormwood",
        "capsules",
        "100mg",
        "artemisia",
        "annua",
        "herb",
        "200",
        "count",
        "non",
        "gmo",
        "vegan",
        "supplement",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 45,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 24,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803967180997",
      "vsf_explanation": "Artemisia annua carries artemisinin, the antimalarial parent-molecule of prescription artemether/artesunate; oral A. annua supplements have specialized traditional use for parasitic infection but general-population supplementation is uncertain. 100 mg is a very low dose relative to any therapeutic application. Concern: thujone (in A. absinthium wormwood — nomenclature confusion is a real issue on this label) is neurotoxic; pregnancy contraindication for either species. Would move to Standard 58+ with clear species identification, artemisinin % standardization, and pregnancy contraindication.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-fruits-and-veggies-supplement-1200-mg-250-capsules-43-fruits-vegetables-11-enzymes-probiotics-vegan-vegetarian-non-gmo",
      "title": "NusaPure Fruits and Veggies Supplement 1200 mg 250 Capsules - 43 Fruits & Vegetables,11 Enzymes, Probiotics (Vegan/Vegetarian, Non-GMO)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ee121587.jpg?v=1787582465",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "fruits",
        "and",
        "veggies",
        "supplement",
        "1200",
        "250",
        "capsules",
        "fruits",
        "vegetables",
        "enzymes",
        "probiotics",
        "vegan",
        "vegetarian",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 35,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 25,
        "sustainability": 50
      },
      "price": 24.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803967443141",
      "vsf_explanation": "43 fruits/vegetables plus 11 enzymes plus probiotics compressed into a 1,200 mg serving is arithmetically absurd — that averages ~22 mg per ingredient, well below any conceivable functional dose for any single component, and none of the individual mg amounts, enzyme activity units, or probiotic CFU counts is disclosed. This is a textbook proprietary-blend hides-dose structure with the added issue of implying whole-food equivalence at a token dose. Autofailed. Would need explicit per-ingredient mg, enzyme activity units, probiotic CFU, and a defensible target endpoint to score.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "nusapure-bitter-orange-suitable-for-vegetarian-vegan-non-gmo-500mg-200-capsules",
      "title": "NusaPure Bitter Orange - Suitable for Vegetarian/Vegan, Non - GMO - 500mg 200 Capsules",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nusapure-Bitter-Orange-3D-v3-01.jpg?v=1787582464",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "bitter",
        "orange",
        "suitable",
        "for",
        "vegetarian",
        "vegan",
        "non",
        "gmo",
        "500mg",
        "200",
        "capsules",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 30,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 24.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803967410373",
      "vsf_explanation": "Bitter orange (Citrus aurantium) delivers synephrine, a beta-adrenergic agonist that emerged as an ephedra replacement after ephedra's 2004 ban. Human evidence for weight loss is thin, and cardiovascular case reports (ischemic stroke, arrhythmia, MI — Bouchard 2005, Nasir 2004) are documented especially in combination with caffeine or in individuals with baseline cardiovascular risk. This label discloses no CV cautions, no synephrine mg, and no drug-interaction warnings. Would move to Standard 55+ only with explicit CV contraindication, caffeine-interaction disclosure, and synephrine % standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-l-methylfolate-15mg-120-veggie-capsules-bioperine-vegan",
      "title": "NusaPure L Methylfolate 15mg, 120 Veggie Capsules, Bioperine & Vegan",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f9adce8c.jpg?v=1787582465",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "methylfolate",
        "15mg",
        "120",
        "veggie",
        "capsules",
        "bioperine",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 40,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 30,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803967508677",
      "vsf_explanation": "L-methylfolate (5-MTHF) is the bioavailable folate form that bypasses MTHFR polymorphism, with real evidence in depression augmentation (Papakostas 2012 SPARK trials) — but that indication uses 7.5-15 mg under psychiatric supervision (Deplin, prescription). 15 mg per cap is 3,750% RDA, delivering a pharmacologic dose that is inappropriate for undirected use — it can mask B12 deficiency, precipitate serotonin syndrome with SSRIs, and cause anxiety in some individuals. This label discloses none of that context. Would move to Standard 65+ with clear psychiatric-supervision framing or Standard 68+ with 1 mg per cap for general MTHFR use.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-french-maritime-pine-bark-30-1-extract-400-mg-per-veggie-caps-200-day-supply-bioperine-non-gmo-vegan",
      "title": "NusaPure French Maritime Pine Bark 30:1 Extract, 400 mg Per Veggie Caps 200-Day Supply, Bioperine (Non-GMO & Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-131092v5-French-Maritime-3D-01.jpg?v=1787582464",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "french",
        "maritime",
        "pine",
        "bark",
        "extract",
        "400",
        "per",
        "veggie",
        "caps",
        "200",
        "day",
        "supply",
        "bioperine",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 66,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 70,
        "transparency": 68,
        "sustainability": 48
      },
      "price": 31.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803967344837",
      "vsf_explanation": "French Maritime Pine Bark extract carries reasonable evidence for endothelial function, cognition, and venous insufficiency (Belcaro et al. multiple trials), but nearly all rigorous data uses branded Pycnogenol at 100-200mg/day. This 400mg generic extract exceeds studied doses but is not standardized to procyanidin percentage — a critical gap versus Pycnogenol's 65-75% OPC spec. The 30:1 ratio and BioPerine addition are disclosed transparently. Would move to Verified 70+ with named Pycnogenol sourcing or a disclosed procyanidin percentage and third-party identity testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-devils-claw-20-1-extract-250-mg-200-veggie-capsules-concentrated-root-extract-devils-claw-herbal-supplement-non-gmo-vegan-supplement",
      "title": "NusaPure Devil's Claw 20:1 Extract, 250 mg, 200 Veggie Capsules, Concentrated Root Extract, Devils Claw Herbal Supplement, Non-GMO, Vegan Supplement",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-132065v3-DevilClaw-3D-01.jpg?v=1787582464",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "devil",
        "claw",
        "extract",
        "250",
        "200",
        "veggie",
        "capsules",
        "concentrated",
        "root",
        "extract",
        "devils",
        "claw",
        "herbal",
        "supplement",
        "non",
        "gmo",
        "vegan",
        "supplement",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 65,
        "sustainability": 45
      },
      "price": 25.2,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803967377605",
      "vsf_explanation": "Devil's Claw (Harpagophytum) has moderate evidence for osteoarthritis and low back pain (Chrubasik et al. 2003), but studied protocols use doses standardized to 50-100mg harpagoside, typically requiring 480-600mg of a well-standardized extract. This 250mg of a 20:1 concentrate is not standardized to harpagoside percentage, leaving actual active-compound content unknown. Safety cautions for gastric ulcer, gallstones, and anticoagulant interactions are not indicated by the title. Would move to Verified 70+ with disclosed harpagoside % (2-3% typical) and safety labeling.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-hair-skin-nails-formula-with-10-000-mcg-biotin-per-serving-60-tablets-vegetarian-non-gmo",
      "title": "NusaPure Hair, Skin & Nails Formula with 10,000 mcg Biotin Per Serving 60 Tablets Vegetarian Non-GMO",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6747cbd5.jpg?v=1787582464",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "hair",
        "skin",
        "nails",
        "formula",
        "with",
        "000",
        "mcg",
        "biotin",
        "per",
        "serving",
        "tablets",
        "vegetarian",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 19.1,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803967475909",
      "vsf_explanation": "Biotin at 10,000 mcg is 333x the adequate intake (30mcg/day) and carries a documented safety concern: high-dose biotin interferes with immunoassay lab tests including troponin, TSH, and hormone panels, potentially masking heart attacks (FDA safety communication 2017, 2019). Evidence for hair/nail benefit outside of true biotin deficiency (rare) is essentially absent — a meta-review by Patel et al. 2017 found no RCTs supporting cosmetic use. Tablet format with unnamed accessory ingredients further limits the product. Would need a physiological biotin dose (30-300mcg), lab-interference labeling, and named cofactors (silica, zinc) at studied doses to move into Standard range confidently.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-organic-skullcap-root-30-1-extract-66-66-mg-per-veggie-caps-120-count-non-gmo-vegan",
      "title": "NusaPure Organic Skullcap Root 30:1 Extract, 66.66 mg Per Veggie Caps 120 Count (Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-133005v2-Nusapure-Skullcap-3D-01.jpg?v=1787582465",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "organic",
        "skullcap",
        "root",
        "extract",
        "per",
        "veggie",
        "caps",
        "120",
        "count",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 17.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803967541445",
      "vsf_explanation": "American skullcap (Scutellaria lateriflora) has one small RCT showing acute anxiolytic effect (Wolfson & Hoffmann 2003) but limited replication. This 66.66mg of a 30:1 extract equates to roughly 2g raw-herb equivalent — modest but on the low end of traditional dosing (350mg-2g). Species is not clearly labeled (S. lateriflora vs S. baicalensis have different actives and hepatotoxicity signals). USDA Organic is a plus for sustainability. Would move to Verified 70+ with species disclosure, flavonoid standardization (baicalin or scutellarin), and identity testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-jiaogulan-20-1-extract-450-mg-180-veggie-capsules-vegetarian-non-gmo-vegan-gynostemma-pentaphyllum",
      "title": "NusaPure Jiaogulan 20:1 Extract, 450 mg 180 Veggie Capsules (Vegetarian, Non-GMO, Vegan) Gynostemma Pentaphyllum",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-128467v10-Jiaogulan-3D-01.jpg?v=1787582465",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "jiaogulan",
        "extract",
        "450",
        "180",
        "veggie",
        "capsules",
        "vegetarian",
        "non",
        "gmo",
        "vegan",
        "gynostemma",
        "pentaphyllum",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 22,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803967574213",
      "vsf_explanation": "Jiaogulan (Gynostemma pentaphyllum) is an adaptogen with small trials for insulin sensitivity (Huyen et al. 2010, 2012) and AMPK activation via gypenosides. This 450mg of a 20:1 extract represents about 9g raw-herb equivalent — reasonable, but the product is not standardized to gypenoside percentage (10-25% typical of quality extracts). Species and part disclosed correctly. Would move to Verified 70+ with gypenoside % on label and identity testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-ginkgo-biloba-50-1-extract-250-mg-per-veggie-caps-200-capsules-vegetarian-non-gmo-vegan-bioperine",
      "title": "NusaPure Ginkgo Biloba 50:1 Extract, 250 mg per Veggie Caps 200 Capsules (Vegetarian, Non-GMO, Vegan) Bioperine",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-130538v6-Ginkgo-Biloba-Bioperine-3D-01.jpg?v=1787582466",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "ginkgo",
        "biloba",
        "extract",
        "250",
        "per",
        "veggie",
        "caps",
        "200",
        "capsules",
        "vegetarian",
        "non",
        "gmo",
        "vegan",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 23.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803967705285",
      "vsf_explanation": "Ginkgo biloba EGb 761 has real dementia/cognitive-support evidence at 120-240 mg standardized to 24% flavone glycosides / 6% terpene lactones (Weinmann 2010 meta-analysis). This 250 mg 50:1 concentrate is high on raw-equivalence but the critical 24/6 standardization is not disclosed — generic ginkgo extracts frequently miss this specification and are not clinically equivalent to EGb 761. Bleeding risk with anticoagulants is real and not flagged. Would move to Verified 70+ with 24/6 standardization or EGb 761 branding plus bleeding-interaction disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-cayenne-pepper-150mg-per-caps-350-veggie-capsules-vegan-vegetarian-non-gmo",
      "title": "NusaPure Cayenne Pepper 150mg Per Caps, 350 Veggie Capsules Vegan Vegetarian, Non-GMO",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nusapure-Cayenne-3D-v3-01.jpg?v=1787582466",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "cayenne",
        "pepper",
        "150mg",
        "per",
        "caps",
        "350",
        "veggie",
        "capsules",
        "vegan",
        "vegetarian",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 48,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803967738053",
      "vsf_explanation": "Cayenne (capsaicin) has modest thermogenesis/appetite evidence at 2-6 mg capsaicinoids/day (Whiting 2012). 150 mg cayenne powder without Scoville or capsaicinoid standardization is a token dose relative to actual studied capsaicin content. GI irritation risk exists. Would move to Standard 60+ with capsaicinoid mg disclosure at 2+ mg per serving.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-essiac-tea-1350-mg-180-veggie-caps-vegetarian-non-gmo",
      "title": "NusaPure Essiac Tea 1350 mg 180 Veggie Caps (Vegetarian, Non-GMO)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/eb6eb129.jpg?v=1787582466",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "essiac",
        "tea",
        "1350",
        "180",
        "veggie",
        "caps",
        "vegetarian",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 23.8,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803967770821",
      "vsf_explanation": "Essiac is a proprietary herbal formula (burdock, sheep sorrel, slippery elm, Indian rhubarb) historically promoted as a cancer treatment; NCI and Cochrane-style reviews have found no evidence of anti-tumor efficacy in humans (Ulbricht 2009). Per-herb mg is not disclosed. Product is not autofailed only because the label itself does not make explicit disease claims here, but the ingredient's cultural marketing carries that association. Would not exceed Rejected without novel evidence for a defensible target.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-huperzine-a-400mcg-180-veggie-capsules-vegetarian-non-gmo-vegan",
      "title": "NusaPure Huperzine A 400mcg 180 Veggie Capsules (Vegetarian, Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nusapure-Huperzine-3D-v4-01.jpg?v=1787582466",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "huperzine",
        "400mcg",
        "180",
        "veggie",
        "capsules",
        "vegetarian",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 30.2,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803967803589",
      "vsf_explanation": "Huperzine A is a potent acetylcholinesterase inhibitor with real evidence in mild Alzheimer's and cognitive support at 50-200 mcg/day (Rafii 2011). 400 mcg per cap is above typical studied dose and — because it is a pharmacologically active AChE inhibitor — cycling and drug interactions (cholinergic meds, anticholinergics) matter. This label discloses neither cycling protocol nor interactions. Would move to Standard 65+ with dose 200 mcg or clear cycling guidance and interaction disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-l-arginine-1000-mg-200-veggie-capsules-non-gmo-vegetarian-vegan",
      "title": "NusaPure L-Arginine 1000 mg 200 Veggie Capsules (Non-GMO, Vegetarian, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/097cf8d9.jpg?v=1787582467",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "arginine",
        "1000",
        "200",
        "veggie",
        "capsules",
        "non",
        "gmo",
        "vegetarian",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 21.4,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803967869125",
      "vsf_explanation": "L-arginine is a NO precursor with real endothelial and mild-ED evidence (Chen 1999) at 3-6 g/day, though L-citrulline generally outperforms L-arginine for sustained plasma arginine elevation. 1,000 mg per cap means 3-6 caps for studied effect. Safety: post-MI patients showed harm in Schulman 2006 VINTAGE MI, so caution in cardiac disease is warranted but not disclosed. Would move to Standard 65+ with cardiac-caution disclosure and per-lot COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-dhea-100mg-200-veggie-capsules-vegetarian-non-gmo",
      "title": "NusaPure DHEA 100mg 200 Veggie Capsules (Vegetarian, Non-GMO)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e3866b56.jpg?v=1787582467",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "dhea",
        "100mg",
        "200",
        "veggie",
        "capsules",
        "vegetarian",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 40,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803967901893",
      "vsf_explanation": "DHEA has real evidence in adrenal insufficiency and low-DHEA-S menopausal contexts at 25-50 mg/day (Arlt 1999) and specialized fertility protocols at 75 mg/day (Wiser 2010). 100 mg per cap is above typical therapeutic dosing and is a hormone that androgenizes downstream — appropriate labs (DHEA-S, estradiol, testosterone) should guide use. High-per-cap dose plus absence of monitoring/contraindication (hormone-sensitive cancers, PCOS) disclosure holds this at Rejected. Would move to Standard 60+ with lower per-cap dose or explicit clinician-supervised positioning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-hyaluronic-acid-300mg-250-veggie-capsules-non-gmo-vegan",
      "title": "NusaPure Hyaluronic Acid 300mg 250 Veggie Capsules (Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/112a91e5.jpg?v=1787582469",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "hyaluronic",
        "acid",
        "300mg",
        "250",
        "veggie",
        "capsules",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 30.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803968032965",
      "vsf_explanation": "Oral hyaluronic acid has skin-hydration evidence at 120-240 mg/day (Oe 2017), and 300 mg is at the top of studied range. Molecular weight matters materially — low-MW HA absorbs better but has mixed safety signals; high-MW HA is safer but less bioavailable. This label discloses neither molecular weight nor source (bacterial fermentation vs animal), limiting clinical replication. Would move to Standard 65+ with MW disclosure and vegan-fermentation confirmation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-dgl-licorice-extract-500-mg-200-veggie-capsules-vegan-non-gmo",
      "title": "NusaPure DGL Licorice Extract 500 mg 200 Veggie Capsules (Vegan,Non-GMO)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c13a5d0e.jpg?v=1787582469",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "dgl",
        "licorice",
        "extract",
        "500",
        "200",
        "veggie",
        "capsules",
        "vegan",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 23.1,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803968065733",
      "vsf_explanation": "Deglycyrrhizinated licorice (DGL) has real evidence for gastric mucosal protection and functional dyspepsia (Raveendra 2012 GutGard trial). 500 mg is a standard dose. Deglycyrrhizination is important safety-wise because it removes glycyrrhizin (which causes pseudohyperaldosteronism/BP elevation) — DGL identity means this is the safe form, a genuine positive. Would move to Verified 70+ with GutGard branding or standardization to residual glycyrrhizin ceiling.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-choline-inositol-suitable-for-vegetarian-vegan-non-gmo-1000mg-200-veggie-capsules",
      "title": "NusaPure Choline & Inositol - Suitable for Vegetarian/Vegan, Non - GMO - 1000mg - 200 Veggie Capsules",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c3c1efbe.jpg?v=1787582469",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "choline",
        "inositol",
        "suitable",
        "for",
        "vegetarian",
        "vegan",
        "non",
        "gmo",
        "1000mg",
        "200",
        "veggie",
        "capsules",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 48,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 25.7,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803968098501",
      "vsf_explanation": "Choline and inositol both have real evidence — choline for liver/cognitive support (adequate intake 425-550 mg), inositol for PCOS insulin sensitivity at 2-4 g/day (Unfer 2016). The 1,000 mg 'combined' label does not disclose the ratio — likely 500 mg each, which is low for inositol (sub-therapeutic vs the 2-4 g PCOS/mood evidence) and modest for choline. Choline source (bitartrate vs citrate vs alpha-GPC) is not specified either. Would move to Standard 62+ with per-active mg breakdown and source disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-slippery-elm-bark-20-1-extract-450-mg-200-veggie-capsules-non-gmo-vegan",
      "title": "NusaPure Slippery Elm Bark 20:1 Extract, 450 mg 200 Veggie Capsules (Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nusapure-Elm-Bark-3D-v6-01.jpg?v=1787582470",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "slippery",
        "elm",
        "bark",
        "extract",
        "450",
        "200",
        "veggie",
        "capsules",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 25.8,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803968131269",
      "vsf_explanation": "Slippery elm (Ulmus rubra) bark provides mucilage traditionally used for GI soothing; clinical evidence is small — Hawrelak 2010 IBS pilot showed modest bowel-symptom improvement. 450 mg 20:1 concentrate is a functional dose. However, extract processing may denature the mucilage that carries the mechanism of action; whole-bark powder is arguably preferable. Sustainability concern is real — slippery elm harvesting is bark-destructive and the tree is in some regions considered stressed. Would move to Standard 62+ with sustainable-harvest certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-magnolia-bark-20-1-extract-250-mg-200-vegan-vegetarian-capsules-non-gmo",
      "title": "NusaPure Magnolia Bark 20:1 Extract, 250 mg 200 Vegan Vegetarian Capsules Non-GMO",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-131677v5-MagnoliaBark-3D-01.jpg?v=1787582469",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "magnolia",
        "bark",
        "extract",
        "250",
        "200",
        "vegan",
        "vegetarian",
        "capsules",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 24.3,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803968164037",
      "vsf_explanation": "Magnolia bark contains honokiol and magnolol with modest human evidence for stress/cortisol reduction (Talbott 2013 with Relora blend). 250 mg 20:1 concentrate (~5,000 mg raw equivalent) is a solid dose but honokiol/magnolol % standardization — which drives the anxiolytic activity — is not disclosed. Would move to Standard 65+ with honokiol+magnolol ≥2% standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-colostrum-1050mg-30-igg-200-capsules-non-gmo-soyfree-bioperine",
      "title": "NusaPure Colostrum 1050mg 30% IgG 200 capsules (Non-GMO, Soyfree) Bioperine",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/645d8926.jpg?v=1787582470",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "colostrum",
        "1050mg",
        "igg",
        "200",
        "capsules",
        "non",
        "gmo",
        "soyfree",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 29.3,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803968196805",
      "vsf_explanation": "Bovine colostrum has meaningful evidence for GI barrier support and URTI reduction in athletes (Jones 2014 meta-analysis) at 20-60 g/day of full colostrum, though the effective IgG dose is what actually matters. 30% IgG standardization is a real quality signal that many colostrum products omit — 1,050 mg at 30% delivers ~315 mg IgG per cap, credible on a functional basis. Not vegan (bovine source); sourcing/ethics-of-dairy disclosure is absent. Would move to Verified 70+ with A2/pasture-raised sourcing and first-milking assurance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-chromium-picolinate-1000mcg-240-veggie-capsules-non-gmo-vegan",
      "title": "NusaPure Chromium Picolinate 1000mcg 240 Veggie Capsules (Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6049c0d1.jpg?v=1787582472",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "chromium",
        "picolinate",
        "1000mcg",
        "240",
        "veggie",
        "capsules",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 21.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803968229573",
      "vsf_explanation": "Chromium picolinate has mixed evidence for glycemic control — Balk 2007 meta-analysis showed modest effect only in diabetics, with mostly null trials in healthy or overweight populations. 1,000 mcg is well above the 200-400 mcg used in most positive trials and toward the safety upper limit; long-term chromium picolinate has raised chromosome-damage concerns in cell studies (Stearns 2002). Would move to Standard 65+ with a 200-400 mcg dose that matches efficacious studied range.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-noni-fruit-20-1-extract-300-mg-240-capsules-suitable-for-vegetarian-vegan-non-gmo",
      "title": "NusaPure Noni Fruit 20:1 Extract, 300 mg 240 Capsules Suitable for Vegetarian/Vegan, Non-GMO",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-131454v4-Noni-Fruit-3D-01.jpg?v=1787582471",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "noni",
        "fruit",
        "extract",
        "300",
        "240",
        "capsules",
        "suitable",
        "for",
        "vegetarian",
        "vegan",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 27.23,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803969474757",
      "vsf_explanation": "Noni (Morinda citrifolia) has been marketed extensively for immune, energy, and general health benefits but the human evidence is thin — most trials are small and industry-funded. Case reports of hepatotoxicity exist (Stadlbauer 2005). 300 mg 20:1 concentrate is coherent on a dose basis but for an ingredient with a poor evidence-to-safety ratio. Would need robust human RCT evidence and hepatic-safety disclosure to move above Rejected.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-fadogia-agrestis-40-1-extract-1200-mg-per-serving-120-vegan-capsules-gmo-free-supplement-bioperine",
      "title": "NusaPure Fadogia Agrestis 40:1 Extract, 1200 mg Per Serving 120 Vegan Capsules, GMO Free Supplement, Bioperine",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-131415v2-Fadogia-Agretis-3D-01.jpg?v=1787582471",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "fadogia",
        "agrestis",
        "extract",
        "1200",
        "per",
        "serving",
        "120",
        "vegan",
        "capsules",
        "gmo",
        "free",
        "supplement",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 45,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 23.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803969507525",
      "vsf_explanation": "Fadogia agrestis is a men's-health/testosterone ingredient with zero human clinical trials — every efficacy claim traces to Yakubu 2005 rodent studies that also documented dose-dependent testicular toxicity. The 40:1 concentrate at 1,200 mg is a very high raw-equivalent dose in a fashionable but under-tested ingredient class. Safety concern is real: podcaster-driven demand has outstripped the human data. Would move to Standard 60+ only if paired with clear 'no human trials, cycle carefully' disclosure and per-lot heavy metal COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-acetyl-l-carnitine-750mg-per-caps-150-veggie-capsules-non-gmo-vegan-high-potency-acetyl-l-carnitine-hcl-alcar",
      "title": "NusaPure Acetyl L-Carnitine 750mg per Caps 150 Veggie Capsules (Non-GMO, Vegan) High Potency Acetyl L Carnitine HCL (ALCAR)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/62929e55.jpg?v=1787582471",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "acetyl",
        "carnitine",
        "750mg",
        "per",
        "caps",
        "150",
        "veggie",
        "capsules",
        "non",
        "gmo",
        "vegan",
        "high",
        "potency",
        "acetyl",
        "carnitine",
        "hcl",
        "alcar",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 26.23,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803969540293",
      "vsf_explanation": "Acetyl-L-carnitine (ALCAR) has RCT support for age-related cognitive decline (Montgomery 2003 meta-analysis) and peripheral neuropathy at 1,500-3,000 mg/day. 750 mg per cap is a reasonable single unit and BID dosing hits the studied range. HCL salt is standard. Emerging TMAO concerns with carnitine + microbiome (Koeth 2013) warrant mention but are not disclosed. Would move to Verified 70+ with TMAO-context safety disclosure and per-lot COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-dandelion-root-20-1-extract-112-5-mg-200-veggie-capsules-non-gmo-vegan",
      "title": "NusaPure Dandelion Root 20:1 Extract, 112.5 mg 200 Veggie Capsules (Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-125945v9-Nusapure-Dandelion-01.jpg?v=1787582471",
      "score": 51,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "dandelion",
        "root",
        "extract",
        "112",
        "200",
        "veggie",
        "capsules",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 21.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803969605829",
      "vsf_explanation": "Dandelion root has a traditional diuretic/liver-support reputation but essentially no rigorous human clinical trial base. 112.5 mg 20:1 extract (~2,250 mg raw) is a coherent dose relative to nothing, since no target has been clinically validated. Would move to Standard 60+ only with specific bitter-index standardization and a validated indication.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-niacinamide-1000mg-200-veggie-capsules-non-gmo-vegan-flush-free",
      "title": "NusaPure Niacinamide 1000mg 200 Veggie Capsules (Non-GMO, Vegan) Flush Free",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2cc26da9.jpg?v=1787582473",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "niacinamide",
        "1000mg",
        "200",
        "veggie",
        "capsules",
        "non",
        "gmo",
        "vegan",
        "flush",
        "free",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 65,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 24.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803969638597",
      "vsf_explanation": "Niacinamide (nicotinamide) at 500 mg BID has real evidence for reducing non-melanoma skin cancer risk (Chen 2015 ONTRAC trial) and modest evidence for early Parkinson's markers. 1,000 mg per cap is a therapeutic dose. Safety: at 1-3 g/day niacinamide can elevate liver enzymes and increase homocysteine; not disclosed on this label. 'Flush-free' framing is honest — niacinamide does not cause the vasodilation flush that nicotinic acid does. Would move to Verified 70+ with hepatic-monitoring caution disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-chelated-molybdenum-500-mcg-180-vegetarian-caps-vegan-non-gmo",
      "title": "NusaPure Chelated Molybdenum 500 mcg 180 Vegetarian Caps (Vegan, Non-GMO)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/28377c74.jpg?v=1787582474",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "chelated",
        "molybdenum",
        "500",
        "mcg",
        "180",
        "vegetarian",
        "caps",
        "vegan",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 18.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803969835205",
      "vsf_explanation": "Molybdenum is an essential trace mineral (RDA 45 mcg, UL 2,000 mcg). 500 mcg is well above RDA — appropriate for specific deficiency contexts (sulfite intolerance, certain heavy-metal exposures) but excessive for general supplementation. Chelated form is a legitimate quality signal for absorption. No specific chelate identity (glycinate, citrate, etc.) is disclosed. Would move to Standard 65+ with chelate specification and use-case guidance rather than daily-use positioning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-l-citrulline-2-400mg-200-vegetarian-tablets-non-gmo-gluten-free-100-day-supply-bioperine",
      "title": "NusaPure L-Citrulline 2,400mg 200 Vegetarian Tablets (Non-GMO, Gluten Free, 100-Day Supply, Bioperine)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b65e5e68.jpg?v=1787582473",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "citrulline",
        "400mg",
        "200",
        "vegetarian",
        "tablets",
        "non",
        "gmo",
        "gluten",
        "free",
        "100",
        "day",
        "supply",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803969704133",
      "vsf_explanation": "L-citrulline has strong RCT evidence for NO-mediated endothelial function and mild ED (Cormio 2011) and for exercise capacity (Bailey 2015) at 3-6 g/day. 2,400 mg per serving is at the lower end of studied efficacy range — 6 g would be closer to peak, requiring 2-3 tabs. Free-form L-citrulline (vs citrulline malate) is disclosed by the naming. Would move to Verified 70+ with a 6-g full serving anchor and per-lot identity/purity assay.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-french-maritime-pine-bark-extract-400mg-per-veggie-caps-200-day-supply-bioperine-non-gmo-vegan",
      "title": "NusaPure French Maritime Pine Bark Extract 400mg per Veggie Caps 200-Day Supply Bioperine Non-GMO Vegan",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/626e925c.jpg?v=1787582473",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "french",
        "maritime",
        "pine",
        "bark",
        "extract",
        "400mg",
        "per",
        "veggie",
        "caps",
        "200",
        "day",
        "supply",
        "bioperine",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803969736901",
      "vsf_explanation": "French maritime pine bark extract has significant RCT evidence when branded as Pycnogenol (Belcaro trials, Zibadi 2008 for endothelial function) at 50-150 mg/day. This label at 400 mg is a much higher dose but is not disclosed as Pycnogenol — generic French maritime pine bark extracts often have lower procyanidin content than the branded preparation, so clinical equivalence is not established. Would move to Verified 70+ with Pycnogenol branding or ≥65% procyanidin standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-schizandra-berries-20-1-extract-225-mg-200-vegan-capsules-non-gmo-bioperine",
      "title": "NusaPure Schizandra Berries 20:1 Extract, 225 mg, 200 Vegan Capsules (Non-GMO, Bioperine)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-132072v2-Schizandra-Bioperine-3D-01.jpg?v=1787582473",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "schizandra",
        "berries",
        "extract",
        "225",
        "200",
        "vegan",
        "capsules",
        "non",
        "gmo",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 24.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803969769669",
      "vsf_explanation": "Schisandra chinensis is a TCM adaptogen with modest human trial evidence for exercise capacity and stress markers (Panossian 2008). The 225 mg 20:1 concentrate (~4,500 mg raw equivalent) is a solid dose but schisandrin content — the flagship lignan responsible for hepatoprotective activity — is not disclosed. Would move to Standard 62+ with schisandrin standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-blueberry-concentrate-30-1-extract-667-mg-180-veg-caps-suitable-for-vegetarian-vegan-non-gmo",
      "title": "NusaPure Blueberry Concentrate 30:1 Extract, 667 mg 180 Veg Caps Suitable for Vegetarian, Vegan, Non-GMO",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-134058v2-OrgBlueberry-3D-01.jpg?v=1787582473",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "blueberry",
        "concentrate",
        "extract",
        "667",
        "180",
        "veg",
        "caps",
        "suitable",
        "for",
        "vegetarian",
        "vegan",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 21.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803969802437",
      "vsf_explanation": "Blueberry anthocyanins have promising cognitive evidence — Krikorian 2010 in older adults with wild blueberry juice showed memory improvement, and Bowtell 2017 replicated. The 30:1 concentrate at 667 mg equates to ~20 g raw-fruit equivalent, in the ballpark of studied wild-blueberry doses; however anthocyanin % is not disclosed and different species (wild lowbush vs highbush) carry very different anthocyanin profiles. Would move to Standard 65+ with anthocyanin standardization and species identification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-american-ginseng-10-1-extract-500-mg-200-veggie-capsules-vegetarian-non-gmo-vegan",
      "title": "NusaPure American Ginseng 10:1 Extract, 500 mg - 200 Veggie Capsules (Vegetarian, Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nusapure-American-Ginseng-3D-v6-01.jpg?v=1787582478",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "american",
        "ginseng",
        "extract",
        "500",
        "200",
        "veggie",
        "capsules",
        "vegetarian",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 25.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803971244229",
      "vsf_explanation": "American ginseng (Panax quinquefolius) has moderate human evidence for post-prandial glycemic control (Vuksan 2000) and cognition (Scholey 2010 with Cereboost at 200 mg). 500 mg 10:1 concentrate is a solid raw-equivalence dose but ginsenoside % standardization is not disclosed — American ginseng activity tracks with Rb1 content. Sustainability is a real concern for wild American ginseng (CITES-listed); cultivated-source disclosure would help. Would move to Standard 65+ with ginsenoside standardization and sustainable-source certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-bacopa-leaf-monnieri-extract-1-000-mg-180-tablets-extract-20-1-non-gmo-gluten-free-vegan",
      "title": "NusaPure Bacopa Leaf Monnieri Extract 1,000 mg 180 Tablets (Extract 20:1, Non-GMO, Gluten Free & Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-128277v4-Bacopa-Monnieri-3D-01.jpg?v=1787582479",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "bacopa",
        "leaf",
        "monnieri",
        "extract",
        "000",
        "180",
        "tablets",
        "extract",
        "non",
        "gmo",
        "gluten",
        "free",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 26,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803971309765",
      "vsf_explanation": "Bacopa monnieri has solid cognitive-support evidence — Stough 2001, Calabrese 2008 showed working-memory and processing-speed improvements at 300-450 mg of standardized extract (55% bacosides). The 1,000 mg 20:1 concentrate is above studied dose on raw-equivalence but the 55% bacoside standardization critical to replicating trial results is not disclosed. Bacopa also requires ~12 weeks for effect and can cause GI upset — not flagged on the label. Would move to Verified 70+ with 55% bacoside standardization (Bacognize/CDRI 08 branding).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-hesperidin-500-mg-per-veggie-caps-180-capsules-bioperine-high-absorption-non-gmo",
      "title": "NusaPure Hesperidin 500 mg per Veggie Caps - 180 Capsules (BioPerine, High Absorption, Non-GMO)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6db0135a.jpg?v=1787582478",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "hesperidin",
        "500",
        "per",
        "veggie",
        "caps",
        "180",
        "capsules",
        "bioperine",
        "high",
        "absorption",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 25.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803971342533",
      "vsf_explanation": "Hesperidin is a citrus flavonoid with modest human evidence for endothelial function and venous tone (Rizza 2011 showed FMD improvement at 500 mg/day). The dose is credible; addition of BioPerine is minor. Enzymatically modified hesperidin has substantially better bioavailability than plain hesperidin — form is not disclosed. Would move to Standard 65+ with 2S-hesperidin or αG-hesperidin form disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-amino-acid-complex-blend-2000-mg-180-caps-non-gmo-gluten-free",
      "title": "NusaPure Amino Acid Complex Blend 2000 mg-180 Caps (Non-GMO, Gluten-Free)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b6ea772d.jpg?v=1787582479",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "amino",
        "acid",
        "complex",
        "blend",
        "2000",
        "180",
        "caps",
        "non",
        "gmo",
        "gluten",
        "free",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 35,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 25,
        "sustainability": 50
      },
      "price": 25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803971539141",
      "vsf_explanation": "Labeled as a 2,000 mg amino acid 'complex blend' with no per-amino-acid mg disclosure — this is a textbook proprietary-blend structure where the actual EAA/BCAA/non-essential ratios are hidden. Amino acid supplementation is dose-, timing-, and ratio-dependent; without knowing per-active mg, no user can compare this to studied leucine (2-3 g), BCAA, or EAA protocols. Autofailed under proprietary_blend_hides_dose. Would need per-amino-acid mg disclosure and a clinically meaningful leucine anchor (2+ g) to score in Standard tier.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "nusapure-organic-garlic-super-odorless-20-1-extract-300-mg-180-veggie-capsules-usda-organic-herbal-supplement-non-gmo-vegan",
      "title": "NusaPure Organic Garlic Super Odorless 20:1 Extract, 300 mg | 180 Veggie Capsules | USDA Organic | Herbal Supplement | Non-GMO, Vegan",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-134229v2-OrgOdorlessGarlic-3D-01.jpg?v=1787582479",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "organic",
        "garlic",
        "super",
        "odorless",
        "extract",
        "300",
        "180",
        "veggie",
        "capsules",
        "usda",
        "organic",
        "herbal",
        "supplement",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 62
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803971604677",
      "vsf_explanation": "Garlic has solid BP evidence — Ried 2013 meta-analysis showed ~7 mmHg systolic reduction with aged garlic extract at 600-1500 mg/day. The 300 mg 20:1 concentrate is equivalent to ~6,000 mg raw garlic, decent, but 'odorless' processing typically destroys allicin (the active) unless specifically aged garlic extract (Kyolic) — this label does not specify processing method. USDA Organic is a real positive. Would move to Verified 70+ if disclosed as aged garlic extract (AGE) with s-allyl cysteine standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-cardamom-4-1-extract-1000-mg-200-vegetarian-capsules-non-gmo-vegan",
      "title": "NusaPure Cardamom 4:1 Extract, 1000 mg 200 Vegetarian Capsules (Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-126392v10-Nusapure-Cardamon-3D-01.jpg?v=1787582480",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "cardamom",
        "extract",
        "1000",
        "200",
        "vegetarian",
        "capsules",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 25.25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803971670213",
      "vsf_explanation": "Cardamom has a small BP/antioxidant human evidence base (Verma 2009 showed BP reduction with 3 g cardamom powder daily). This 1,000 mg 4:1 extract (~4 g raw equivalent) is defensible on a dose basis but essential oil / 1,8-cineole content is not disclosed and drives the actual activity. Culinary spice framing limits scientific interest; product is coherent but underspecified. Would move to Standard 60+ with essential oil % standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-black-seed-oil-1-000-mg-per-serving-180-softgel-capsules-non-gmo-vegetarian-vegan-cold-pressed-virgin-nigella-sativa-hexane-free",
      "title": "NusaPure Black Seed Oil 1,000 mg per Serving 180 Softgel Capsules (Non-GMO, Vegetarian & Vegan) Cold-Pressed Virgin Nigella Sativa. Hexane Free",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1a439839.jpg?v=1787582479",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "black",
        "seed",
        "oil",
        "000",
        "per",
        "serving",
        "180",
        "softgel",
        "capsules",
        "non",
        "gmo",
        "vegetarian",
        "vegan",
        "cold",
        "pressed",
        "virgin",
        "nigella",
        "sativa",
        "hexane",
        "free",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 28.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803971637445",
      "vsf_explanation": "Black seed oil (Nigella sativa) has legitimate meta-analytic evidence for lipid, BP, and glycemic parameters at 1-3 g/day of the oil (Sahebkar 2016). 1,000 mg per serving hits the low end of the studied range. Cold-pressed, virgin, hexane-free processing statements are meaningful quality signals for oil integrity. Thymoquinone content (the flagship active) is not disclosed, and cap-based delivery of an oil-based product means bioavailability is fine but per-cap oil mg not stated. Would move to Verified 70+ with thymoquinone % standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-astragalus-20-1-extract-300-mg-per-serving-200-veggie-capsules-vegan-non-gmo-bioperine",
      "title": "NusaPure Astragalus 20:1 Extract, 300 mg Per Serving, 200 Veggie Capsules, Vegan, Non-GMO & Bioperine",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-131578v5-AstragalusHABioP-3D-01.jpg?v=1787582479",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "astragalus",
        "extract",
        "300",
        "per",
        "serving",
        "200",
        "veggie",
        "capsules",
        "vegan",
        "non",
        "gmo",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 22.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803971702981",
      "vsf_explanation": "Astragalus membranaceus is a TCM adaptogen with preclinical immunomodulatory evidence and moderate clinical support in adjunctive cancer/nephroprotection settings; general immune-support human evidence is weak. 300 mg 20:1 concentrate (~6,000 mg raw equivalent) is a serious dose. Astragaloside-IV standardization (the flagship active) is not disclosed. Would move to Standard 65+ with astragaloside-IV % assay.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "allmax-lights-out-sleep-60-capsules",
      "title": "Allmax Lights Out Sleep, 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/allmax-nutrition-lights-o_2609-0_72873df9-8256-42a1-82b4-752ebbe7d3c5.jpg?v=1787582482",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "allmax",
        "lights",
        "out",
        "sleep",
        "capsules",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803973210309",
      "vsf_explanation": "Allmax Lights Out is a multi-ingredient sleep stack typically built around melatonin, GABA, L-theanine, valerian, and 5-HTP-type actives. The evidence base is mixed by active: melatonin 0.5-3mg has legitimate sleep-latency evidence (Ferracioli-Oda 2013 meta-analysis), L-theanine 200mg has modest anxiolytic/sleep-quality signal (Kim 2019), while valerian effects are inconsistent (Fernández-San-Martín 2010). Allmax is mid-tier Canadian sports manufacturing but the sleep stack is typically part-proprietary and combines a 5-HTP-adjacent active without robust safety warnings for SSRI interactions. Would move to Verified with per-active mg disclosure, melatonin capped at 0.5-1mg, and clear SSRI/MAOI interaction warnings.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrex-tribulus-1400-90-caps",
      "title": "Nutrex Tribulus 1400, 90 Caps",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Tribulus_b06b235d-814e-4565-9d0c-438f9a7cb2b8.webp?v=1787582488",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone",
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrex",
        "tribulus",
        "1400",
        "caps",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 12.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803973669061",
      "vsf_explanation": "Tribulus terrestris has been repeatedly tested for testosterone/libido effects in healthy men and has come up largely null — Neychev 2005 and Rogerson 2007 both showed no testosterone or performance effects in trained men at doses similar to this SKU's 1400mg. Some libido signal exists in specific populations (menopausal women, ED with saponin-standardized extracts), but the 'test booster' positioning is not evidence-supported for eugonadal men. Formulation and label transparency are actually reasonable here (single ingredient, disclosed mg), which is why this scores above the proprietary-blend field, but the underlying evidence ceiling caps it below Standard. Would require an evidence-supported active category to change tiers.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrex-niox-nitric-oxide-90-caps",
      "title": "Nutrex Niox Nitric Oxide, 90 Caps",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Picture0_516be1ef-5727-4d86-b183-718f49f2ddf8.jpg?v=1787582495",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrex",
        "niox",
        "nitric",
        "oxide",
        "caps",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 48,
        "sustainability": 45
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803975536837",
      "vsf_explanation": "Nutrex Niox is a nitric-oxide precursor product typically built around L-citrulline and/or L-arginine plus supporting cofactors. The underlying evidence is legitimate at studied doses — L-citrulline 6-8g/day improves blood flow and exercise performance per Perez-Guisado 2010 and Bailey 2015 — but supplement caps rarely deliver those doses in a 90-count SKU without heavy per-serving pill loads, so effective dosing is likely below the trial range. Nutrex uses proprietary blends on some Niox variants, which pulls transparency down. Would move to Verified with per-active mg disclosure, L-citrulline delivered at 6g+/serving, and third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-chelated-zinc-22-mg-100-tablets",
      "title": "Solgar Chelated Zinc 22 Mg, 100 Tablets",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/262857580_bdbb9d85-cddc-4ce7-9455-11ab44d59828.jpg?v=1787582500",
      "score": 80,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "chelated",
        "zinc",
        "100",
        "tablets",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 76,
        "manufacturing": 74,
        "safety": 72,
        "transparency": 72,
        "sustainability": 60
      },
      "price": 11.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803977568453",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 72 → new 80. Evidence found: Gandia P, et al. A bioavailability study comparing two oral formulations containing zinc (Zn bis-glycinate vs Zn gluconate). Int J Vitam Nutr Res. 2007;77(4):243-8 (bisglycinate showed 43% higher AUC). | Albion Minerals patents and PK dossiers documenting zinc bisglycinate chelate absorption vs sulfate/oxide forms. | Wessels I, et al. Zinc supplementation ameliorates lymphocyte and other zinc-dependent processes. Adv Nutr. 2020 (baseline zinc RCT context).. Rationale: Solgar Chelated Zinc uses Albion zinc bisglycinate. Gandia 2007 head-to-head PK showed bisglycinate produced ~43% higher zinc AUC than gluconate at the same elemental zinc dose. TIER-B for the specific chelate form. 22 mg is a reasonable maintenance dose (RDA 8-11 mg; safe UL 40 mg). +8 uplift for well-documented formulation edge.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "metabolic-nutrition-relaxitrol",
      "title": "Metabolic Nutrition Relaxitrol",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Metabolic-Nutrition-Relaxitrol.jpg?v=1787582509",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "metabolic",
        "nutrition",
        "relaxitrol",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803979468997",
      "vsf_explanation": "Relaxitrol is a bodybuilding-channel sleep/relaxation blend combining GABA, valerian, and typically 5-HTP or melatonin. Individual actives have moderate evidence — valerian for subjective sleep quality (Bent 2006 meta-analysis) and melatonin for sleep onset (Ferracioli-Oda 2013) — but blends of this style tend to hide per-active doses inside a proprietary matrix, which caps transparency. Manufacturing is standard sport-supplement contract quality without third-party certification. Would move to Verified 70+ with fully disclosed per-active mg (especially melatonin dose, since above 3 mg is often counterproductive per Zhdanova 2001) and USP or NSF verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-organic-amla-capsules-10-1-extract-600-mg-120-count-amalaki-fruit-usda-vegan-non-gmo-supplement",
      "title": "NusaPure Organic Amla Capsules 10:1 Extract, 600 mg | 120 Count | Amalaki Fruit | USDA, Vegan, Non-GMO Supplement",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-132080v3-Organic-Amla-3D-01.jpg?v=1787582519",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "organic",
        "amla",
        "capsules",
        "extract",
        "600",
        "120",
        "count",
        "amalaki",
        "fruit",
        "usda",
        "vegan",
        "non",
        "gmo",
        "supplement",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 58,
        "sustainability": 62
      },
      "price": 18.3,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803981435077",
      "vsf_explanation": "Amla (Emblica officinalis) has modest human trial support for lipid profile and antioxidant markers (Kim 2015, Upadya 2019 showed LDL reduction with 500 mg twice daily). The 600 mg 10:1 concentrate is at the high end of studied equivalents. USDA Organic is a real quality/sustainability positive that lifts sourcing confidence above the average NusaPure herbal. Tannin/polyphenol standardization is not disclosed. Would move to Standard 65+ with % polyphenol assay.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-acai-berry-400-mg-200-veg-capsules-non-gmo-vegan",
      "title": "NusaPure Acai Berry, 400 mg, 200 Veg Capsules (Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-132149v3-ACAi-Berry-3D-01.jpg?v=1787582520",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "acai",
        "berry",
        "400",
        "200",
        "veg",
        "capsules",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 26.53,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803981467845",
      "vsf_explanation": "Acai berry has strong antioxidant chemistry (high ORAC) but the human clinical evidence is minimal — most acai supplement marketing rests on preclinical antioxidant data and one small (Udani 2011) pilot at 100 g of pulp daily, far more than any capsule can deliver. 400 mg of a whole-berry powder is essentially a token dose relative to studied whole-fruit intakes. No specific standardization disclosed. Would move to Standard 60+ with anthocyanin standardization at a functional dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-policosanol-100mg-180-veggie-capsules-vegan-non-gmo",
      "title": "NusaPure Policosanol 100mg 180 Veggie Capsules (Vegan, Non-GMO)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d0089cb7.jpg?v=1787582526",
      "score": 51,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "policosanol",
        "100mg",
        "180",
        "veggie",
        "capsules",
        "vegan",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 23.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803983106245",
      "vsf_explanation": "Policosanol is a signature example of ingredient-source-dependent evidence — early Cuban trials showed dramatic LDL reduction, but every well-designed independent RCT (Berthold 2006 JAMA, Marinangeli 2007) has failed to replicate. 100 mg is high on the studied-dose scale but that scale itself points at an inefficacy signal in independent literature. Product formulation is coherent and safety is fine, but the evidence gap is decisive in a transparency-first rubric. Would not exceed low-Standard until replicated positive independent RCTs exist.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-organic-mushroom-complex-450mg-per-capsule-180-veggie-caps-non-gmo-enoki-turkey-tail-reishi-chaga-maitake",
      "title": "NusaPure Organic Mushroom Complex 450mg per Capsule, 180 Veggie Caps, Non-GMO, Enoki, Turkey Tail, Reishi, Chaga, Maitake",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/60863890.jpg?v=1787582526",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "organic",
        "mushroom",
        "complex",
        "450mg",
        "per",
        "capsule",
        "180",
        "veggie",
        "caps",
        "non",
        "gmo",
        "enoki",
        "turkey",
        "tail",
        "reishi",
        "chaga",
        "maitake",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 48,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 45,
        "sustainability": 60
      },
      "price": 27.85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803983139013",
      "vsf_explanation": "A five-mushroom blend (enoki, turkey tail, reishi, chaga, maitake) at 450 mg total is a proprietary composite — each species has meaningful evidence individually (turkey-tail PSK/PSP for immune modulation, reishi triterpenes) but requires 500-3000 mg per species for meaningful effect. The blend is under-dosed for any single-mushroom target and the per-species mg is not disclosed, which is a real transparency gap. USDA Organic framing is a modest positive. Would move to Standard 62+ with per-mushroom mg breakdown and beta-glucan % standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-reduced-glutathione-500mg-180-veggie-capsules-vegan-non-gmo-l-glutathione",
      "title": "NusaPure Reduced Glutathione 500mg 180 Veggie Capsules (Vegan,Non-GMO) L-Glutathione",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/09d540e1.jpg?v=1787582526",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "reduced",
        "glutathione",
        "500mg",
        "180",
        "veggie",
        "capsules",
        "vegan",
        "non",
        "gmo",
        "glutathione",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 35.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803983171781",
      "vsf_explanation": "Oral reduced (L-) glutathione has poor systemic bioavailability due to GI proteolysis — Richie 2015 did show intracellular GSH increase at 250-1000 mg/day, but liposomal or S-acetyl forms deliver measurably better plasma results. A 500 mg standard oral cap sits in a legitimate but ineffective-for-many format. Not autofailed since a small population may still benefit, but form choice holds it below Standard. Would move to Standard 62+ with liposomal or acetylated delivery.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-umckaloabo-4-1-extract-60-mg-veggie-caps-200-count-non-gmo-vegan",
      "title": "NusaPure Umckaloabo 4:1 Extract, 60 mg Veggie Caps 200 Count (Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-125789v7-Umckaloabo-3D-01.jpg?v=1787582527",
      "score": 53,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "umckaloabo",
        "extract",
        "veggie",
        "caps",
        "200",
        "count",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803983270085",
      "vsf_explanation": "Pelargonium sidoides (umckaloabo) has real acute-bronchitis and URTI evidence — the German EPs 7630 preparation (Matthys 2003, Timmer 2013 Cochrane) shows meaningful symptom reduction at 10-30 mg of the branded liquid extract equivalents. This label at 60 mg 4:1 concentrate is low on the raw-plant-equivalence scale and is not the branded EPs 7630 preparation used in trials, so clinical equivalence is not established. Would move to Standard 62+ with EPs 7630 branding or higher dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-phytoceramide-complex-10-1-extract-1030-mg-200-veggie-capsules-non-gmo-bioperine",
      "title": "NusaPure Phytoceramide Complex 10:1 Extract, 1030 mg 200 Veggie Capsules (Non-GMO) Bioperine",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nusapure-Phytoceramide-3d-v4-01.jpg?v=1787582526",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "phytoceramide",
        "complex",
        "extract",
        "1030",
        "200",
        "veggie",
        "capsules",
        "non",
        "gmo",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 26.4,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803983368389",
      "vsf_explanation": "Oral phytoceramides (wheat- or rice-derived) have modest but real skin-hydration and barrier evidence (Guillou 2011 wheat ceramides, 350 mg/day). The 1,030 mg dose is high on the studied scale, but source (wheat vs rice) and % ceramide standardization are not disclosed, which materially affect potency — some 'phytoceramide' labels contain very low actual ceramide content. Would move to Standard 65+ with source specification and % ceramide-EOP or Ceramosides branding.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-valerian-root-20-1-extract-250-mg-per-veggie-caps-250-count-vegan-non-gmo-bioperine",
      "title": "NusaPure Valerian Root 20:1 Extract, 250 mg Per Veggie Caps, 250 Count, Vegan, Non-GMO, Bioperine",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-129305v6-Valerian-Root-3D-01.jpg?v=1787582526",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "valerian",
        "root",
        "extract",
        "250",
        "per",
        "veggie",
        "caps",
        "250",
        "count",
        "vegan",
        "non",
        "gmo",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 23.57,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803983335621",
      "vsf_explanation": "Valerian evidence for sleep is real but mixed — a Bent 2006 meta-analysis showed modest subjective improvement but weak polysomnographic effect. Typical study dose is 400-900 mg extract standardized to 0.8% valerenic acid; the 20:1 concentrate at 250 mg is roughly equivalent to 5,000 mg raw root, respectable, but valerenic acid % is not disclosed. BioPerine is not particularly relevant for valerian absorption. Would move to Standard 62+ with valerenic acid standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-strontium-citrate-suitable-for-vegetarian-vegan-non-gmo-680-mg-200-capsules",
      "title": "NusaPure Strontium Citrate - Suitable for Vegetarian/Vegan, Non - GMO - 680 mg 200 Capsules",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/637bef54.jpg?v=1787582527",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "strontium",
        "citrate",
        "suitable",
        "for",
        "vegetarian",
        "vegan",
        "non",
        "gmo",
        "680",
        "200",
        "capsules",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 45,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 24.23,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803983204549",
      "vsf_explanation": "Strontium ranelate (a prescription in EU, later restricted) has established BMD-improvement RCT data (Meunier 2004 SOTI); strontium citrate is the OTC US analog with much weaker human evidence but assumed similar mechanism. 680 mg strontium citrate is a real functional dose (~170 mg elemental strontium). Safety flags this because strontium interferes with DEXA bone-density measurement (artifactually inflating scores) and competes with calcium absorption — this label does not disclose those interactions. Would move to Standard 65+ with explicit DEXA/calcium interaction disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-pterostilbene-150mg-180-veggie-caps-non-gmo-vegan",
      "title": "NusaPure Pterostilbene 150mg 180 Veggie Caps (Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/513d79d7.jpg?v=1787582526",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "pterostilbene",
        "150mg",
        "180",
        "veggie",
        "caps",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 68,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 35.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803983302853",
      "vsf_explanation": "Pterostilbene is the methylated analog of resveratrol with dramatically better oral bioavailability and 7x longer half-life (Kapetanovic 2011). Riche 2013 RCT at 125-250 mg/day showed lipid and BP effects — 150 mg sits squarely in the studied range. Long-term safety data is thinner than resveratrol; Riche noted small LDL elevation on the pterostilbene-only arm. NusaPure lacks per-lot COA that a longevity-focused user might want. Would move to Verified 70+ with third-party purity documentation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-siberian-rhubarb-10-1-extract-250-mg-200-veggie-capsules-vegetarian-non-gmo-vegan",
      "title": "NusaPure Siberian Rhubarb 10:1 Extract, 250 mg - 200 Veggie Capsules (Vegetarian, Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nusapure-Siberian-Rhubarb-3D-v10-01.jpg?v=1787582526",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "siberian",
        "rhubarb",
        "extract",
        "250",
        "200",
        "veggie",
        "capsules",
        "vegetarian",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 22.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803983433925",
      "vsf_explanation": "Rheum rhaponticum root extract has legitimate menopausal-symptom evidence when delivered as the branded ERr 731 preparation (Heger 2006, Kaszkin-Bettag 2007), but NusaPure does not disclose whether this generic 10:1 extract meets that specification. The 250 mg cap at 10:1 concentrate equates to ~2,500 mg dried root, in the ballpark of studied ranges, but without ERr 731 branding or standardization to specific rhaponticin/desoxyrhapontigenin content, therapeutic equivalence is uncertain. Veggie cap format and Non-GMO disclosure are pluses; the Amazon-native NusaPure brand offers no per-SKU COA. Would move to Verified 70+ with ERr 731 sourcing disclosure or independent standardization certificate.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-sea-kelp-natural-iodine-325mcg-10-1-extract-65-mg-capsule-200-count-non-gmo-vegan",
      "title": "NusaPure Sea Kelp Natural Iodine 325mcg 10:1 Extract, 65 mg Capsule 200 Count (Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-130653v5-SeaKelp-3D-01.jpg?v=1787582526",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "sea",
        "kelp",
        "natural",
        "iodine",
        "325mcg",
        "extract",
        "capsule",
        "200",
        "count",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 23.4,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803983237317",
      "vsf_explanation": "Iodine is essential and 325 mcg is roughly 2x the 150 mcg RDA — safe short-term but persistent supra-physiologic dosing can trigger thyroid dysfunction (Leung & Braverman 2014) in autoimmune-prone users. Sea kelp is a legitimate whole-food iodine source but variable in actual iodine content batch-to-batch; the 65 mg 10:1 extract with fixed 325 mcg iodine claim implies standardization but no assay is disclosed. Heavy-metal (arsenic, cadmium) risk from marine sources warrants third-party testing that NusaPure does not visibly publish per-SKU. Would move to Verified 70+ with TSH/thyroid caution labeling and per-lot heavy-metal COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-red-marine-algae-20-1-extract-250-mg-200-veggie-capsules-non-gmo-soy-free-bioperine",
      "title": "NusaPure Red Marine Algae 20:1 Extract, 250 mg 200 Veggie Capsules (Non-GMO & Soy Free) Bioperine",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nusapure-Red-Marine-Algae-3D-v4-1.jpg?v=1787582526",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "red",
        "marine",
        "algae",
        "extract",
        "250",
        "200",
        "veggie",
        "capsules",
        "non",
        "gmo",
        "soy",
        "free",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 26.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803983401157",
      "vsf_explanation": "Red marine algae is popularly marketed for antiviral (herpes) and immune claims based on in-vitro sulfated polysaccharide activity, but human clinical evidence is essentially absent — the studies cited by vendors are preclinical or observational. The 250 mg 20:1 extract with BioPerine is coherently formulated but the underlying evidence base does not clear the Standard-tier bar in this rubric. Not autofailed because label does not make explicit disease claims. Would move to Standard 60+ only with published human RCT support for a specific indication.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-yacon-root-extract-500mg-200-vegetarian-capsules-extract-4-1-non-gmo-vegan",
      "title": "NusaPure Yacon Root Extract 500mg 200 Vegetarian Capsules (Extract 4:1, Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nusapure-YaconRoot-3D-v6New-01.jpg?v=1787582527",
      "score": 53,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "yacon",
        "root",
        "extract",
        "500mg",
        "200",
        "vegetarian",
        "capsules",
        "extract",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 24.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803983466693",
      "vsf_explanation": "Yacon root contains FOS/inulin-type prebiotics and the one supportive weight/insulin study (Genta 2009) used ~0.29 g FOS per kg from yacon syrup — roughly 20 g of syrup daily. A 500 mg 4:1 extract cap delivers a fraction of that dose, insufficient for the metabolic effect the ingredient is marketed for. Product is coherently labeled and vegan, but the dose-to-effect gap is real. Would move to Standard 60+ with dose escalation or clear positioning as prebiotic-support only.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-luteolin-complex-with-rutin-200-mg-100-capsules-vegetarian-non-gmo-vegan-flavonoid-formula",
      "title": "NusaPure Luteolin Complex with Rutin 200 mg | 100 Capsules | Vegetarian, Non-GMO & Vegan Flavonoid Formula",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b5a5917d.jpg?v=1787582526",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "luteolin",
        "complex",
        "with",
        "rutin",
        "200",
        "100",
        "capsules",
        "vegetarian",
        "non",
        "gmo",
        "vegan",
        "flavonoid",
        "formula",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 21.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803983499461",
      "vsf_explanation": "Luteolin and rutin are flavonoids with preclinical anti-inflammatory and mast-cell-stabilizing activity (Theoharides 2015 luteolin), and rutin has vein-tonic evidence. The 200 mg total for a 'complex' means the individual mg of luteolin vs rutin is not disclosed on the title, a transparency gap. Human RCTs at this dose are limited. Vegan/Non-GMO framing is honest. Would move to Standard 62+ with per-actives disclosure and 65+ with human clinical support at the label dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-bilberry-extract-500mg-200-vegetarian-caps-non-gmo-vegan",
      "title": "NusaPure Bilberry Extract 500mg 200 Vegetarian caps (Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-127429-Bilberry-v9-01.jpg?v=1787582526",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "bilberry",
        "extract",
        "500mg",
        "200",
        "vegetarian",
        "caps",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 19.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803983597765",
      "vsf_explanation": "Bilberry (Vaccinium myrtillus) anthocyanins have real evidence for vascular tone and modest eye-health signals (Kalt 2010 review), typically studied at 160-480 mg of extract standardized to 25% anthocyanosides. This label states 500 mg but does not disclose standardization — a meaningful gap given anthocyanin content varies dramatically between raw-powder and true extracts. Formulation is coherent, safety is high. Would move to Standard 65+ with explicit % anthocyanoside standardization on-label.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-black-currant-10-1-extract-250-mg-per-veg-caps-200-vegan-non-gmo",
      "title": "NusaPure Black Currant 10:1 Extract, 250 mg, per Veg Caps 200 Vegan, Non-GMO",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-125957v11-NusaPure-BlackCurrant-3D-01.jpg?v=1787582526",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "black",
        "currant",
        "extract",
        "250",
        "per",
        "veg",
        "caps",
        "200",
        "vegan",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 21.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803983630533",
      "vsf_explanation": "Black currant (Ribes nigrum) berry extract carries anthocyanins and moderate antioxidant evidence; some small trials show effects on ocular fatigue and exercise blood flow. The 250 mg 10:1 concentrate (~2,500 mg equivalent) is reasonable, but no anthocyanin or GLA standardization is disclosed — black currant products differ meaningfully depending on whether they are seed-oil (GLA-carrying) or berry-extract based. Would move to Standard 62+ with standardization detail on-label.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-polypodium-leucotomos-10-1-extract-240-mg-200-veggie-capsules-vegetarian-non-gmo-vegan",
      "title": "NusaPure Polypodium Leucotomos 10:1 Extract, 240 mg 200 Veggie Capsules (Vegetarian, Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-128210V9-Polypodium-3D-01.jpg?v=1787582526",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "polypodium",
        "leucotomos",
        "extract",
        "240",
        "200",
        "veggie",
        "capsules",
        "vegetarian",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 21.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803983532229",
      "vsf_explanation": "Polypodium leucotomos (branded Fernblock in most RCTs) has genuine photoprotection evidence — Nestor 2015 and Kohli 2017 show reduced UV-induced erythema at 240-480 mg twice daily. This label at 240 mg 10:1 hits the low end of studied dose; efficacy would require 2 caps/day for meaningful UV protection. Product is not branded Fernblock so extract equivalence to the trial preparation is uncertain. Would move to Standard 65+ with branded-ingredient sourcing or Fernblock disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-chanca-piedra-200mg-200-veggie-caps-herbal-extract-supplement-extract-10-1-non-gmo-bioperine-100-servings-per-bottle",
      "title": "NusaPure Chanca Piedra 200mg | 200 Veggie Caps | Herbal Extract Supplement | Extract 10:1, Non-GMO, Bioperine | 100 Servings per Bottle",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-132084v5-Chanca-Piedra-3D-01.jpg?v=1787582526",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "chanca",
        "piedra",
        "200mg",
        "200",
        "veggie",
        "caps",
        "herbal",
        "extract",
        "supplement",
        "extract",
        "non",
        "gmo",
        "bioperine",
        "100",
        "servings",
        "per",
        "bottle",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803983696069",
      "vsf_explanation": "Phyllanthus niruri (chanca piedra) is traditionally used for kidney and gallstones, but the clinical trial base is thin and mixed — a Cochrane-style review (Freitas 2002) is inconclusive and later trials show minimal stone-passage effect. The 200 mg 10:1 extract with BioPerine is a coherent formulation, but the underlying evidence does not warrant Standard tier in a transparency-first rubric. Would move to Standard 60+ if positioned solely as urinary support with no stone-clearing implication.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-benfotiamine-300mg-per-veggie-caps-220-count-non-gmo-vegan-bioperine",
      "title": "NusaPure Benfotiamine 300mg Per Veggie Caps 220 Count (Non-GMO, Vegan) Bioperine",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b969491d.jpg?v=1787582527",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "benfotiamine",
        "300mg",
        "per",
        "veggie",
        "caps",
        "220",
        "count",
        "non",
        "gmo",
        "vegan",
        "bioperine",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 70,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 34.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803983564997",
      "vsf_explanation": "Benfotiamine is a lipid-soluble thiamine analog with real evidence for diabetic peripheral neuropathy at 300-600 mg/day (Stracke 2008 BENDIP trial, Haupt 2005), so 300 mg is a therapeutically credible entry dose. Formulation is coherent; BioPerine is unnecessary here since benfotiamine already has good oral absorption but is not a negative. NusaPure's Amazon-native brand lacks per-SKU third-party COA that a practitioner-tier equivalent would carry. Would move to Verified 70+ with 300 mg BID recommendation and independent identity/purity assay.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-hemp-oil-capsules-1-000mg-per-serving-180-veggie-softgels-non-gmo-vegan",
      "title": "NusaPure Hemp Oil Capsules, 1,000mg Per Serving, 180 Veggie Softgels, Non-GMO, Vegan",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/07e46cec.jpg?v=1787582527",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "hemp",
        "oil",
        "capsules",
        "000mg",
        "per",
        "serving",
        "180",
        "veggie",
        "softgels",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803983728837",
      "vsf_explanation": "This is hemp seed oil (not CBD or hemp extract) — the '1,000 mg' is a food-grade oil delivering a modest omega-6/omega-3 fatty-acid dose with no cannabinoid activity. Marketing that leans on the 'hemp' identity risks buyer confusion with CBD products, which are governed by different evidence and regulatory frameworks. Nutritionally it is a reasonable but under-differentiated omega source that a small dose of fish oil or flax outperforms. Would move to Standard 60+ with explicit 'hemp seed oil, no CBD' clarity and disclosure of GLA/omega-3 amounts.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-pygeum-bark-10-1-extract-450-mg-180-veggie-caps-non-gmo-vegan",
      "title": "NusaPure Pygeum Bark 10:1 Extract, 450 mg 180 Veggie Caps (Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/42aa865f.jpg?v=1787582526",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "pygeum",
        "bark",
        "extract",
        "450",
        "180",
        "veggie",
        "caps",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 58,
        "sustainability": 45
      },
      "price": 20.68,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803983663301",
      "vsf_explanation": "Pygeum africanum has a Cochrane review (Wilt 2002) showing modest BPH symptom improvement at 100-200 mg/day of standardized extract. The 450 mg 10:1 concentrate delivers well into studied range on a dried-bark-equivalence basis, though phytosterol standardization is not disclosed. Sustainability is a concern for Pygeum africanum — it is CITES-listed as vulnerable and ethical sourcing is a legitimate issue this label does not address. Would move to Standard 65+ with sustainability/CITES sourcing disclosure and phytosterol standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-sea-buckthorn-omega-7-30-1-extract-250-mg-per-veggie-caps-200-capsules-non-gmo-vegan",
      "title": "NusaPure Sea Buckthorn Omega-7 30:1 Extract, 250 mg per Veggie Caps - 200 Capsules - Non-GMO & Vegan",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nusapure-Sea-Buckthorn-3D-v4-01.jpg?v=1787582526",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "sea",
        "buckthorn",
        "omega",
        "extract",
        "250",
        "per",
        "veggie",
        "caps",
        "200",
        "capsules",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 24.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803983794373",
      "vsf_explanation": "Sea buckthorn (Hippophae rhamnoides) is a natural source of palmitoleic acid (omega-7) with modest evidence for dry-eye and mucosal-support at ~2 g of berry/seed oil daily (Larmo 2010). This 250 mg 30:1 concentrate translates to significant raw-material equivalence but actual palmitoleic acid mg is not disclosed — for omega-7 the fatty-acid content matters, not extract ratio. Cap format (rather than oil-in-softgel) may also compromise fatty-acid bioavailability vs studied liquid/softgel forms. Would move to Standard 62+ with per-serving palmitoleic acid mg disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-banaba-leaf-150-mg-220-veg-capsules-non-gmo-vegan",
      "title": "NusaPure Banaba Leaf, 150 mg, 220 Veg Capsules (Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-130953v6-Banaba-Leaf-Extract-3D-01.jpg?v=1787582527",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "banaba",
        "leaf",
        "150",
        "220",
        "veg",
        "capsules",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 48,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 22.23,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803983827141",
      "vsf_explanation": "Banaba leaf (Lagerstroemia speciosa) contains corosolic acid with modest post-prandial glucose evidence (Judy 2003 showed 10-30% glucose reduction at 32-48 mg standardized corosolic acid). This label discloses only 150 mg raw leaf with no corosolic acid % standardization — the active-molecule dose is likely well below the studied 10-16 mg corosolic acid range. Formulation gap holds it below Standard. Would move to Standard 60+ with corosolic acid standardization on-label.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "six-star-protein-testosterone-booster-caplets-60ct",
      "title": "Six Star Protein Testosterone Booster  Caplets 60Ct",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/243201677.jpg?v=1787582530",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "six",
        "star",
        "protein",
        "testosterone",
        "booster",
        "caplets",
        "60ct",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 45,
        "manufacturing": 48,
        "safety": 48,
        "transparency": 40,
        "sustainability": 42
      },
      "price": 11.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803985203397",
      "vsf_explanation": "Six Star is Iovate's budget bodybuilder sub-brand (Iovate is a Chinese-owned conglomerate per our brand-owner disclosure), and the 'Testosterone Booster' typically pairs a low-dose fenugreek/rhodiola/boron mix with aggressive 'clinically dosed' marketing language that outruns the evidence for the actual per-actives on-label. The 'booster' framing plus advertised percent-testosterone-increase claims cross into unverified_medical_claim territory when read against the underlying data. Six Star's manufacturing is FDA-registered but budget-tier, with limited third-party testing disclosure. Would need dose-honest label claims and named-source standardized actives (Testofen 600mg, Physta 200mg) to move above Rejected.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "alpha-lion-superhuman®-gains-candy-turkestrone",
      "title": "Alpha Lion SuperHuman® Gains Candy Turkestrone",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Alpha-Lion-SuperHuman-Gains-Candy-Turkestrone.jpg?v=1787582553",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alpha",
        "lion",
        "superhuman",
        "gains",
        "candy",
        "turkestrone",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 50,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 49.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803989561541",
      "vsf_explanation": "Turkesterone (an ecdysteroid from Ajuga turkestanica) is marketed as a 'natural anabolic' with essentially no rigorous human RCT evidence — the widely cited Wilborn/Isenmann-adjacent studies are limited, methodologically weak, and largely fail to show muscle-mass effects at typical supplement doses; independent lab testing has also repeatedly found under-labelled or absent ecdysteroid content in commercial products. Alpha Lion's 'Gains Candy' brand framing plus 'superhuman' anabolic claims outrun the evidence and trigger unverified_medical_claim under our rubric. Formulation and label transparency (single-ingredient, disclosed mg) are relatively better than typical proprietary blends, but the underlying category evidence is the ceiling. Would need actual human RCT evidence at label dose to change the tier.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "project-ad-elite-series-tauro-test",
      "title": "Project AD Elite Series Tauro Test",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Project-AD-Elite-Series-Tauro-Test.jpg?v=1787582564",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "project",
        "elite",
        "series",
        "tauro",
        "test",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 42,
        "manufacturing": 45,
        "safety": 42,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 49.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803989987525",
      "vsf_explanation": "Project AD is a bodybuilder-marketing brand and 'Tauro Test' is presented as a testosterone/estrogen-management stack, typically built around proprietary blends of DAA, Tongkat Ali, boron, and aromatase-inhibitor herbals without per-active mg disclosure — a proprietary_blend_hides_dose autofail. Even individual actives here (Tongkat Ali per Talbott 2013, boron per Naghii 2011) have some evidence at named doses, but buyers cannot verify studied-dose delivery. No third-party testing publicly documented. Would need fully disclosed dosing with named-source standardization to reach Standard tier.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "nutrex-anabol-ripped-60-caps",
      "title": "Nutrex Anabol Ripped, 60 Caps",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Picture4_52f901ac-824c-46b4-bdb5-ad0f104a758e.jpg?v=1787582573",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrex",
        "anabol",
        "ripped",
        "caps",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 40,
        "manufacturing": 48,
        "safety": 40,
        "transparency": 32,
        "sustainability": 45
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803991494853",
      "vsf_explanation": "Nutrex Anabol Ripped stacks an 'anabolic activator' proprietary blend with a fat-burner blend, and neither blend discloses per-active mg — a hard proprietary_blend_hides_dose autofail. The 'anabolic' framing implies steroid-like results the label cannot substantiate, and typical fat-burner blends here rely on stimulant clusters (caffeine, yohimbine) that raise safety-flag surface area without disclosed dosing. No third-party testing publicly documented. Would need per-active mg disclosure, removal of anabolic framing, and evidence-linked doses to escape the Rejected tier.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "bestby10-26-natrol-dhea-25mg-hormone-balance-mood-stress-support-90-tablets",
      "title": "BestBy10/26 Natrol DHEA 25mg Hormone Balance Mood Stress Support 90 Tablets",
      "vendor": "Deal US",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/open-uri20250721-2361242-kuerd0.jpg?v=1787582582",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bestby10",
        "natrol",
        "dhea",
        "25mg",
        "hormone",
        "balance",
        "mood",
        "stress",
        "support",
        "tablets",
        "deal"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 42,
        "transparency": 48,
        "sustainability": 45
      },
      "price": 6.86,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803991822533",
      "vsf_explanation": "Natrol DHEA 25mg is a defensible single-ingredient hormone product — DHEA supplementation has real evidence in adrenal-insufficient and older adults (Baulieu 2000, Villareal 2004 body-composition data), and 25mg is a reasonable maintenance dose. However this listing carries a 'BestBy10/26' quality flag indicating near-expiry inventory sold through a reseller ('Deal US'), which materially degrades label-potency confidence at time of consumption and pulls transparency and manufacturing scores down. DHEA is also a genuine hormone with androgenic/estrogenic conversion pathways requiring physician oversight — safety framing on a mass-market SKU is thin. Would score Verified 70+ as fresh Natrol-direct inventory with adequate warning language for hormone-sensitive users.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrabio-ashwagandha-ksm-66-60-capsules",
      "title": "NutraBio Ashwagandha KSM-66 - 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NutraBio-Ashwagandha-KSM-66-60-Capsules.jpg?v=1787582582",
      "score": 85,
      "tier": "elite",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrabio",
        "ashwagandha",
        "ksm",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 82,
        "formulation": 80,
        "manufacturing": 76,
        "safety": 72,
        "transparency": 82,
        "sustainability": 62
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803991888069",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 76 → new 85. Evidence found: Chandrasekhar K, Kapoor J, Anishetty S. A prospective, randomized double-blind, placebo-controlled study of safety and efficacy of a high-concentration full-spectrum extract of ashwagandha root in reducing stress and anxiety in adults. Indian J Psychol Med. 2012;34(3):255-262. | Lopresti AL et al. An investigation into the stress-relieving and pharmacological actions of an ashwagandha (Withania somnifera) extract. Medicine (Baltimore). 2019;98(37):e17186. | Salve J et al. Adaptogenic and Anxiolytic Effects of Ashwagandha Root Extract in Healthy Adults. Cureus. 2019;11(12):e6466.. Rationale: KSM-66 is the most-studied branded ashwagandha extract with multiple positive RCTs at 600 mg/day for stress, cortisol, and anxiety (Chandrasekhar 2012, Lopresti 2019, Salve 2019). NutraBio's KSM-66 sourcing + full label transparency puts this at Elite tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "testosterone-enhancement-capsules",
      "title": "Testosterone Enhancement Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6fb24bf9-8f38-4d43-8846-16f1f9187411.jpg?v=1787582586",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "testosterone",
        "enhancement",
        "capsules",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 38,
        "safety": 40,
        "transparency": 32,
        "sustainability": 40
      },
      "price": 25.2,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803992019141",
      "vsf_explanation": "'Testosterone Enhancement Capsules' from Vivalo is a small-vendor generic-named product with no manufacturer accountability trail publicly visible and no per-active mg disclosure — the product name itself functions as a health claim without label substantiation. This falls into the proprietary_blend_hides_dose autofail category, and the generic 'enhancement' framing risks unverified_medical_claim territory as well. No third-party testing, GMP disclosure, or ingredient standardization is documented. Would need to become a fully disclosed formulation from an accountable manufacturer with evidence-linked actives to leave Rejected.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "doctors-best-comprehensive-prostate-formula-supports-prostate-wellness-120-vc",
      "title": "DOCTOR'S BEST: Comprehensive Prostate Formula - Supports Prostate  Wellness 120 vc",
      "vendor": "Doctor's Best",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/753950000858_C1N1.jpg?v=1787582586",
      "score": 75,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "doctor",
        "best",
        "comprehensive",
        "prostate",
        "formula",
        "supports",
        "prostate",
        "wellness",
        "120",
        "doctor",
        "best"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 72,
        "manufacturing": 72,
        "safety": 72,
        "transparency": 72,
        "sustainability": 60
      },
      "price": 34.07,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803992117445",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 70 → new 75. Evidence found: Wilt TJ et al. Saw palmetto extracts for treatment of benign prostatic hyperplasia: a systematic review. JAMA. 1998;280(18):1604-1609. | MacDonald R et al. Serenoa repens monotherapy for benign prostatic hyperplasia (BPH): an updated Cochrane systematic review. BJU Int. 2012;109(12):1756-1761 (mixed later evidence). | Wilt TJ et al. Beta-sitosterols for benign prostatic hyperplasia. Cochrane Database Syst Rev. 2000;(2):CD001043.. Rationale: Comprehensive prostate formula typically combining saw palmetto, beta-sitosterol, pygeum, stinging nettle, and zinc — evidence for BPH symptoms is mixed (early Wilt 1998 positive, later MacDonald 2012 Cochrane more equivocal for saw palmetto alone; beta-sitosterol has more consistent BPH evidence). Uplift to 75 for multi-ingredient synergy + ingredient-class evidence; below Elite due to Cochrane's more skeptical stance on saw palmetto monotherapy.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "allmax-longjack-tongkat-ali-60-capsules",
      "title": "Allmax Longjack Tongkat Ali, 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/longjack-main.jpg?v=1787582596",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "allmax",
        "longjack",
        "tongkat",
        "ali",
        "capsules",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 62,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 11.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803992477893",
      "vsf_explanation": "Tongkat Ali (Eurycoma longifolia) has the strongest evidence base in the male-hormone category, with Talbott 2013 and Ismail 2012 showing modest testosterone and cortisol-ratio improvements in stressed men using the standardized Physta extract at ~200mg/day. Allmax's Longjack is a single-ingredient herbal at a mid-tier price point, but the standardization percentage (eurycomanones, glycoproteins) and named-source status (Physta vs LJ100 vs generic) is not clearly disclosed in the SKU title. Allmax has reasonable manufacturing but no public per-lot COA. Would move to Verified 70+ with explicit Physta or LJ100 sourcing, published standardization %, and third-party identity/heavy-metals testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ghost®-size-v3",
      "title": "GHOST® SIZE V3",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/GHOST-SIZE-V3.jpg?v=1787582617",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ghost",
        "size",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 66,
        "manufacturing": 65,
        "safety": 68,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 54.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803993133253",
      "vsf_explanation": "Ghost is a legitimate mainstream sport-nutrition brand with transparent labeling on flagship products. SIZE V3 is a creatine + amino/muscle-building matrix; creatine monohydrate has extensive RCT support (Kreider 2017 ISSN position stand) at 3-5 g/day but companion actives (betaine, epicatechin, etc.) are more speculative. Formulation gets marks for named-source Creapure or similar if disclosed on label but loses points if secondary ingredients sit inside a proprietary matrix, which is common in this product category. Would move to Verified 70+ with full per-active mg disclosure, named creatine source, and third-party purity testing published per lot.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gnc-mega-men-healthy-testosterone-program-complete-nutrition-products-boost",
      "title": "GNC Mega Men Healthy Testosterone Program Complete Nutrition Products Boost",
      "vendor": "Price Is Right Miami",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/865fccf5-ea45-4334-8880-ff1c81d64b65.jpg?v=1787582637",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "gnc",
        "mega",
        "men",
        "healthy",
        "testosterone",
        "program",
        "complete",
        "nutrition",
        "products",
        "boost",
        "price",
        "right",
        "miami"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 48,
        "manufacturing": 50,
        "safety": 50,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 89.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803996704965",
      "vsf_explanation": "GNC's 'Mega Men Healthy Testosterone Program' is a multi-SKU bundle (multivitamin + test-support blend) marketed around 'boost testosterone' language, with the test-support component structured as proprietary blends that hide per-active mg. GNC's own brand-owner disclosure (Harbin Pharmaceutical, Chinese-state-adjacent parent) is a supply-chain accountability flag we've documented previously. The multivitamin component itself is reasonable, but the testosterone-boost claim outruns the evidence for the disclosed actives. Would need transparent per-active dosing, removal of unsupported boost framing, and evidence-linked actives to escape Rejected.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "nutrex-anabol-nighttime-60-caps",
      "title": "Nutrex Anabol NightTime, 60 Caps",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Picture3_890b7ab8-ba3f-4df3-b066-85be94e363e3.jpg?v=1787582645",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrex",
        "anabol",
        "nighttime",
        "caps",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 40,
        "manufacturing": 48,
        "safety": 42,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46803997819077",
      "vsf_explanation": "Nutrex Anabol Nighttime is a bodybuilder-marketing product framed around 'anabolic activator' language, delivered as a proprietary blend that hides per-active dosing — an autofail under our rubric. The 'anabolic' naming implies steroidal-like effects the label cannot substantiate, and the sleep-window framing does not have the direct RCT support that would justify the tier bump. Nutrex is a mid-tier sports brand with basic GMP but limited transparency. Would need per-active mg disclosure, removal of unsubstantiated anabolic framing, and evidence-linked doses of any actives (e.g., Testofen fenugreek at 600mg) to move above Rejected.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "allmax-zmx2-advanced-90-capsules",
      "title": "Allmax ZMX2 Advanced, 90 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Picture6_36a7dc2f-e6f5-44dd-82bf-d3d2214d6b0f.jpg?v=1787582662",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "allmax",
        "zmx2",
        "advanced",
        "capsules",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 62,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 11.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804000407749",
      "vsf_explanation": "Allmax's ZMX2 is a ZMA-adjacent formula that upgrades the mineral forms (zinc arginate/citrate, magnesium citrate/glycinate) versus the original ZMA aspartate/monomethionine, which is a mild bioavailability plus. The underlying evidence (Brilla 2000) still applies — marginal signal in zinc/magnesium-insufficient athletes, weak in replete populations. Allmax is a mid-tier Canadian sports brand with reasonable GMP but limited public third-party testing. Would move to Verified with a published lot-level COA, NSF/Informed-Sport certification, and explicit disclosure of the per-mineral elemental content (not just compound weight).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrakey-z-optima-zma-120-capsules",
      "title": "NutraKey Z Optima ZMA, 120 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Picture21_4ff5158e-557b-4526-8801-3199dbca99de.jpg?v=1787582717",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrakey",
        "optima",
        "zma",
        "120",
        "capsules",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 12.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804002537669",
      "vsf_explanation": "This is a classic ZMA formulation (zinc monomethionine + magnesium aspartate + B6) originally patented by SNAC and studied by Brilla 2000, which showed marginal strength/testosterone signal in NCAA football players — a single study that later attempts failed to replicate cleanly (Wilborn 2004). The formulation itself is defensible for correcting genuine zinc or magnesium insufficiency, and the actives are disclosed at studied ratios; NutraKey is a mid-tier brand with GMP claims but no per-SKU third-party testing surfaced. Evidence for direct testosterone boost in eugonadal men is weak. Would move toward Verified with NSF Certified for Sport verification and explicit third-party COA per lot.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "innovapharm-test-rejuvenation",
      "title": "Innovapharm Test Rejuvenation",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Innovapharm-Test-Rejuvenation.jpg?v=1787582735",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "innovapharm",
        "test",
        "rejuvenation",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 42,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 74.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804003258565",
      "vsf_explanation": "Innovapharm is a small sports-nutrition brand that markets 'Test Rejuvenation' with a stacked proprietary blend that hides per-active dosing — the primary autofail trigger under our rubric. Even where the label pulls from legitimate testosterone-support actives (Tongkat Ali, fenugreek, DAA), buyers cannot verify studied-dose delivery (e.g., Physta 200mg from Talbott 2013, Testofen 600mg from Steels 2011). No third-party testing is publicly documented and manufacturing accountability is minimal. Would need a fully open label with per-active mg and named-source standardization to reach Standard tier.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "nutrakey-red-deer-antler-test-120-capsules",
      "title": "NutraKey Red Deer Antler Test, 120 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/045635293212.jpg?v=1787582751",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrakey",
        "red",
        "deer",
        "antler",
        "test",
        "120",
        "capsules",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804003815621",
      "vsf_explanation": "This is a combination testosterone-support product built around deer antler velvet, whose IGF-1 marketing claims have essentially no human RCT support (early Sleivert-era rugby study was negative, and no follow-up has established anabolic effect in healthy men). NutraKey's 'Test' line typically uses a proprietary blend without per-active mg disclosure, which is a transparency autofail under our rubric. Even setting the blend aside, the underlying evidence base for deer antler is animal-tier only. Would need to move to a fully disclosed formulation built around evidence-supported actives (KSM-66 ashwagandha, standardized Tongkat Ali/Physta or LJ100, boron 10mg) to escape the Rejected tier.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "repp-sports-raze-turkesterone-elite-muscle-builder-60-capsules",
      "title": "Repp Sports Raze Turkesterone+ Elite Muscle Builder, 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/raze-turk-front-500x583-1.jpg?v=1787582772",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "repp",
        "sports",
        "raze",
        "turkesterone",
        "elite",
        "muscle",
        "builder",
        "capsules",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health",
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 45,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 20,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804004438213",
      "vsf_explanation": "Repp Sports Raze Turkesterone+ is a Turkesterone-anchored 'muscle builder' from a supplement industry brand. Turkesterone has one unpublished human study (never peer-reviewed) widely cited by marketers, is on the WADA 2022 monitoring list, and the proposed ecdysteroid-anabolic mechanism is disputed in mammalian receptor systems. The '+' in the name signals additional actives — typically ajuga turkestanica extract, tongkat ali, or other ergogenic hopefuls — likely in proprietary blend structure. 'Elite Muscle Builder' framing invokes anabolic-drug-like efficacy without any peer-reviewed human evidence. Autofailed under unverified_medical_claim. Would not be reconsidered until Turkesterone has published, peer-reviewed human RCTs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "alpha-energy-pro-mens-wellness-supplement",
      "title": "Alpha Energy Pro - Men's Wellness Supplement",
      "vendor": "Muscle Faktor",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/alpha-energy-pro-hero.png?v=1787582812",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "alpha",
        "energy",
        "pro",
        "men",
        "wellness",
        "supplement",
        "muscle",
        "faktor"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 38,
        "manufacturing": 50,
        "safety": 45,
        "transparency": 32,
        "sustainability": 45
      },
      "price": 35.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804005716165",
      "vsf_explanation": "'Alpha Energy Pro - Men's Wellness Supplement' is the archetype of a men's-supplement proprietary blend: multiple testosterone-adjacent botanicals (tribulus, tongkat ali, fenugreek, horny goat weed, D-aspartic acid, zinc) at hidden individual doses. Each has small evidence at specific doses; a blend cannot demonstrate any hits threshold. Additional safety concern: this product class has a history of FDA warnings for undisclosed pharmaceutical adulterants (sildenafil analogs, anabolic steroid metabolites) — third-party testing is essential and Muscle Faktor does not publish per-lot COAs. Autofail: proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "controlled-labs-blue-up-30-servings",
      "title": "Controlled Labs Blue Up, 30 Servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/controlled-labs-blue-up..png?v=1787582822",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "controlled",
        "labs",
        "blue",
        "servings",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health",
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 30,
        "sustainability": 50
      },
      "price": 8,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804006076613",
      "vsf_explanation": "Controlled Labs Blue Up is a T-support/anabolic formula from a mid-tier bodybuilding brand. Typical Blue Up formulations include D-aspartic acid, fenugreek, DIM, and often proprietary matrices in the men's-health category. D-aspartic acid was hyped for T-boosting but the Melville 2015 RCT found no effect in trained men, and DAA can actually LOWER testosterone with continued use. Fenugreek (Testofen branded) has modest T support (Aswar 2010) at 600 mg. Blue Up historically uses proprietary blend structure that hides per-ingredient mg. Autofailed under proprietary_blend_hides_dose. Would move to Standard 55+ with per-ingredient mg disclosure, removal of D-aspartic acid (net-negative for T over time), and single-mechanism positioning around a specific evidence-based ingredient.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "allmax-fadogia-agrestis-325mg-120-capsules",
      "title": "Allmax Fadogia Agrestis 325mg, 120 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Picture12_80163e69-77c3-468e-9d81-77510a5413d1.jpg?v=1787582846",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "allmax",
        "fadogia",
        "agrestis",
        "325mg",
        "120",
        "capsules",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 35,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804006895813",
      "vsf_explanation": "Allmax Fadogia Agrestis at 325 mg per cap has the same fundamental problem as any Fadogia SKU: zero human RCTs, and the sole preclinical support (Yakubu 2005 in rats) documented dose-dependent testicular toxicity, kidney damage, and reduced sperm count. Allmax is a mid-tier bodybuilding-market brand with reasonable manufacturing but no ability to compensate for an ingredient that lacks a human evidence base and carries a rodent safety signal. Clean labeling (single ingredient, disclosed dose) is a modest positive. Autofailed under unverified_medical_claim. Would not be reconsidered above Rejected until published human safety and efficacy trials exist for Fadogia.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "nutrakey-tribulus-terrestris-1000mg-100-capsules",
      "title": "NutraKey Tribulus Terrestris 1000mg, 100 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Picture23_0ad85c2c-acb1-44a4-91d5-c82c0b642e3a.jpg?v=1787582869",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone",
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrakey",
        "tribulus",
        "terrestris",
        "1000mg",
        "100",
        "capsules",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 12.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804007747781",
      "vsf_explanation": "NutraKey Tribulus Terrestris at 1,000 mg per cap is a high-dose single-ingredient Tribulus product — same evidence problem as the Puritan's Pride SKU: Neychev 2016 systematic review found NO T-boost in healthy men. Higher dose does not rescue an ingredient whose primary marketed mechanism has been meta-analytically disproven. Single-ingredient format and clear dose disclosure are transparency positives, but do not offset the fundamental evidence gap. Saponin % standardization (Tribulus's flagship active is protodioscin, typically standardized to 40-90% saponins) is not disclosed. Autofailed under unverified_medical_claim for T-boost marketing without support. Would move to Standard 55+ if positioned honestly as libido-support only, with no T-claim, and saponin standardization disclosed.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "pharmaton-essential-men-daily-vitamin-supplement-30-tablets",
      "title": "Pharmaton Essential Men - Daily Vitamin Supplement | 30 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/lpByOhbrogxGVtsLWSH0E8hOj67P6pdyPaLEonoZ_a7e79b3d-5d13-4669-ab4d-864e973ccd74.jpg?v=1787582894",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "pharmaton",
        "essential",
        "men",
        "daily",
        "vitamin",
        "supplement",
        "tablets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients",
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 58,
        "manufacturing": 65,
        "safety": 60,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 25.53,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804012957893",
      "vsf_explanation": "Pharmaton is a longstanding European multivitamin brand (originally by Boehringer Ingelheim) built around a standardized Panax ginseng extract (G115) plus a general multivitamin/mineral matrix. The G115 ginseng standardization is a real quality signal — it has small RCTs for cognitive endpoints and quality-of-life measures (Scaglione 1990). The multi provides basic micronutrient coverage. Pharma-heritage manufacturing is a modest positive over generic supplement-industry manufacturing. G115 daily dose is typically 40 mg (low end of studied range 100-400 mg for cognitive endpoints); multivitamin doses tend to be modest and dated (D3 often only 200-400 IU where 1,000-2,000 is now standard). Would move to Verified 70+ with updated micronutrient doses reflecting current science and higher G115 dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "shilajit-capsules",
      "title": "Shilajit Capsules",
      "vendor": "NYC Herbs®",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CAP_SHIILAJIT.png?v=1787582911",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shilajit",
        "capsules",
        "nyc",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic",
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 15,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804013514949",
      "vsf_explanation": "Shilajit has legitimate but heterogeneous evidence — the branded PrimaVie preparation has small RCTs (Pandit 2016 for CoQ10-like mitochondrial support, Biswas 2010 for spermatogenic parameters) at 200-500 mg/day. The core actives are fulvic acid and dibenzo-alpha-pyrones, both variable in unbranded material. NYC Herbs Shilajit does not disclose PrimaVie sourcing, purity, or fulvic acid % — a real quality gap since unregulated shilajit from Himalayan/Altai sources has documented heavy-metal contamination (arsenic, lead) that requires per-lot COA. Absent that documentation, safety concerns outweigh the modest evidence base. Would move to Standard 60+ with PrimaVie branded sourcing or per-lot heavy-metal COA plus fulvic acid % standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "puritans-pride-tribulus-terrestris-250-mg-90-capsules",
      "title": "Puritan's Pride Tribulus Terrestris 250 Mg 90 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/puritans_pride_tribulus_terrestris_250_mg_90_kapsl_83747.jpg?v=1787582931",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone",
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "puritan",
        "pride",
        "tribulus",
        "terrestris",
        "250",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 27.46,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804014170309",
      "vsf_explanation": "Tribulus terrestris has been meta-analytically studied (Neychev 2016 systematic review) and shown NO testosterone increase in healthy eugonadal men — the evidence base for T-boosting Tribulus claims is essentially disproven. Modest libido effects appear in some studies but are not mediated by T change. Puritan's Pride is a mainstream mass-retail brand with clean labeling (250 mg per cap disclosed, single ingredient) — better transparency than most T-boosters. The single-ingredient format also avoids proprietary-blend autofail. But because the ingredient itself does not support the primary marketed T-boost claim, autofailed under unverified_medical_claim. Would move to Standard 55+ if positioned strictly as libido-support with 'no T-boost' disclosure, or if repurposed for its actual (thin) evidence in female sexual function.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "force-factor-test-x180-ignite-total-testosterone-booster-fat-burner-60-capsules",
      "title": "Force Factor Test X180 Ignite Total Testosterone Booster & Fat Burner 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/92915129.jpg?v=1787582960",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "force",
        "factor",
        "test",
        "x180",
        "ignite",
        "total",
        "testosterone",
        "booster",
        "fat",
        "burner",
        "capsules",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health",
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 30,
        "manufacturing": 55,
        "safety": 40,
        "transparency": 25,
        "sustainability": 50
      },
      "price": 27.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804034683077",
      "vsf_explanation": "Force Factor Test X180 Ignite is a GNC/mass-retail proprietary-blend T-booster that also markets itself as a fat burner — combining two aspirational categories, both of which have thin RCT support in supplement form. 'Test X180' and similar Force Factor SKUs typically contain proprietary blends of Tongkat Ali, Fenugreek, Tribulus, DIM, and stimulants (yohimbe, caffeine) with per-ingredient mg hidden behind blend totals. Combining a T-booster with a fat-burner adds cardiovascular safety concerns (stimulants + T-elevating ingredients + often unmentioned yohimbine can spike heart rate and BP). Autofailed under proprietary_blend_hides_dose. Force Factor has faced FTC action historically for unsupported marketing claims (2016 settlement). Rejected 35.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "muscle-faktor-complete-daily-multivitamin-with-antioxidant-blend",
      "title": "Muscle Faktor Complete Daily Multivitamin with Antioxidant Blend",
      "vendor": "Muscle Faktor",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1755213118135-generated-label-image-0.jpg?v=1787582992",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "muscle",
        "faktor",
        "complete",
        "daily",
        "multivitamin",
        "with",
        "antioxidant",
        "blend",
        "muscle",
        "faktor"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804062732485",
      "vsf_explanation": "A daily multivitamin with an 'Antioxidant Blend.' Individual vitamin/mineral quantities are typically disclosed on a Supplement Facts panel (a partial transparency credit), but the 'Antioxidant Blend' portion — usually mixed tocopherols, mixed carotenoids, plant extracts, quercetin, resveratrol traces — is almost always a proprietary blend at undisclosed individual doses. Autofail: proprietary_blend_hides_dose. Multivitamin base itself has thin population-level evidence (PHS II showed marginal cancer benefit; overall RCT signal is small), so even without the autofail this would sit at low Standard.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "adaptogen-vitality-gummies-functional-mushroom-blend-muscle-faktor",
      "title": "Adaptogen Vitality Gummies – Functional Mushroom Blend | Muscle Faktor",
      "vendor": "Muscle Faktor",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/20260421210030-generated-image-d8061608-4263-46fd-9c2c-063c720095f8.png?v=1787583130",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "adaptogen",
        "vitality",
        "gummies",
        "functional",
        "mushroom",
        "blend",
        "muscle",
        "faktor",
        "muscle",
        "faktor"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 38,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 35,
        "sustainability": 48
      },
      "price": 17.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804065026245",
      "vsf_explanation": "Gummy-format adaptogen and functional-mushroom blend. Functional mushrooms (lion's mane, reishi, cordyceps, chaga) have real preclinical data and emerging small-RCT signal, but studied doses are 500–3,000 mg/day of specific standardized extracts — far above what a gummy (typically 50–150 mg active per piece) can practically deliver. 'Blend' language plus gummy sugar/gelatin bulk plus multi-mushroom stacking makes per-ingredient dosing implausible. Autofail: proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "ayurvedic-complex-1",
      "title": "Ayurvedic Complex",
      "vendor": "Muscle Faktor",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1754760953427-generated-label-image-0.jpg?v=1787583149",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ayurvedic",
        "complex",
        "muscle",
        "faktor"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 35,
        "sustainability": 50
      },
      "price": 29.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804065190085",
      "vsf_explanation": "'Ayurvedic Complex' is a naming pattern that combines several traditional Indian botanicals (turmeric, ashwagandha, brahmi, tulsi, triphala, etc.) at unknown individual doses. Each has some independent evidence at specific doses — but a lumped 'complex' hides which reach threshold. Additional Ayurvedic-specific safety concern: some traditional preparations have documented heavy-metal contamination (lead, mercury, arsenic — Saper 2004; JAMA 2008) unless third-party tested. Muscle Faktor does not publish per-lot heavy-metal COAs. Autofail: proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "fiber-blend-with-psyllium-ginger",
      "title": "Fiber Blend with Psyllium & Ginger",
      "vendor": "Muscle Faktor",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1755216756593-generated-label-image-0.jpg?v=1787583168",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fiber",
        "blend",
        "with",
        "psyllium",
        "ginger",
        "muscle",
        "faktor"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804065452229",
      "vsf_explanation": "Psyllium husk has strong RCT evidence for constipation, LDL reduction, and glycemic control — but the studied doses are 10–20 g/day, which is a bulk fibre load that cannot be delivered in a capsule 'blend.' Ginger has mild anti-nausea evidence at 1–2 g/day. Combining both under 'Fiber Blend' language and no per-ingredient dose disclosure means neither can be assumed to hit its threshold. Autofail: proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "moringa-leaf-capsules-natural-extract",
      "title": "Moringa Leaf Capsules - Natural Extract",
      "vendor": "Muscle Faktor",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1756342338442-generated-label-image-0.jpg?v=1787583178",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "moringa",
        "leaf",
        "capsules",
        "natural",
        "extract",
        "muscle",
        "faktor"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 26.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804065648837",
      "vsf_explanation": "Moringa oleifera leaf powder/extract in capsules. Legitimate whole-plant nutrient density (protein, vitamin A precursors, iron, calcium) but the popularized 'superfood' claims outrun the RCT data — most trials are small, low-quality, and often industry-funded. Modest signal for lipid and glycemic markers at 2–8 g/day of dried leaf powder. A capsule format cannot deliver those gram-level doses. Muscle Faktor does not disclose extract ratio or standardization. Sits at the low end of Standard on the strength of the ingredient class rather than the specific product's evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnesium-glycinate-4",
      "title": "Magnesium Glycinate",
      "vendor": "Muscle Faktor",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/20250919193732-gemini-generated-image-ca4ckdca4ckdca4c.png?v=1787583209",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "glycinate",
        "muscle",
        "faktor"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 26.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804066304197",
      "vsf_explanation": "Magnesium glycinate is one of the best-tolerated, best-absorbed magnesium forms — chelated to glycine, which reduces the laxative effect common with magnesium oxide/citrate. Well-supported for sleep quality (Abbasi 2012), muscle cramps, and modest anxiolytic effects at 200–400 mg elemental magnesium daily. Muscle Faktor discloses milligrams per capsule; the key transparency question — 'is this elemental magnesium or magnesium glycinate compound weight?' — is often ambiguous on lower-tier brands. If the label clearly states elemental magnesium at 200 mg+ per serving, the product moves higher; if it lists the compound weight without conversion, it may be under-dosing. Sits at the top of Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gut-health",
      "title": "Gut Health",
      "vendor": "Muscle Faktor",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1754706211975-generated-label-image-0.jpg?v=1787583221",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gut",
        "health",
        "muscle",
        "faktor"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 35,
        "sustainability": 50
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804066533573",
      "vsf_explanation": "'Gut Health' as a product name is a naming convention that reliably indicates a proprietary blend of digestive enzymes, probiotics, prebiotics, and soothing botanicals (slippery elm, marshmallow, licorice) without per-ingredient dose disclosure. Each component class has evidence at specific doses — enzymes require unit-count disclosure (FCC units), probiotics require strain-level CFU, fibre prebiotics require gram-level doses. A generic 'Gut Health' capsule cannot deliver any of these convincingly. Autofail: proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "apple-cider-vinegar-capsules-2",
      "title": "Apple Cider Vinegar Capsules",
      "vendor": "Muscle Faktor",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1784450889960-generated-label-image-0.jpg?v=1787583223",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "apple",
        "cider",
        "vinegar",
        "capsules",
        "muscle",
        "faktor"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804066599109",
      "vsf_explanation": "ACV capsules. The best-controlled ACV evidence (post-meal glucose blunting, modest weight-loss effect at 15–30 mL/day of liquid vinegar) is at doses that translate poorly to capsules — a typical 500 mg ACV capsule delivers a tiny fraction of the acetic acid used in trials. Capsules do avoid the enamel-erosion risk of chronic liquid vinegar use, which is the main safety credit. Muscle Faktor discloses milligrams per capsule. Evidence-to-dose alignment keeps it at low Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "grass-fed-hydrolyzed-collagen-peptides-2",
      "title": "Grass-Fed Hydrolyzed Collagen Peptides",
      "vendor": "Muscle Faktor",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1756233880884-generated-label-image-0.jpg?v=1787583232",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "grass",
        "fed",
        "hydrolyzed",
        "collagen",
        "peptides",
        "muscle",
        "faktor"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 58,
        "sustainability": 52
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804066664645",
      "vsf_explanation": "Unflavored version of Muscle Faktor's grass-fed hydrolyzed collagen. Same evidence base (Proksch 2014 skin; Zdzieblik 2017 tendon; Clark 2008 joint) at 10–15 g/day. Unflavored gets a small formulation and transparency credit over flavored variants because it is easier to identify freshness and there is no added sweetener or masking. Grass-fed sourcing modestly improves sustainability. Molecular weight / dipeptide profile still undisclosed, which caps the score below Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "horny-goat-weed-blend",
      "title": "Horny Goat Weed Blend",
      "vendor": "Muscle Faktor",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1754764591195-generated-label-image-0.jpg?v=1787583238",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "horny",
        "goat",
        "weed",
        "blend",
        "muscle",
        "faktor"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 42,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 38,
        "sustainability": 50
      },
      "price": 33.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804066762949",
      "vsf_explanation": "Horny goat weed (Epimedium spp.) contains icariin, which has PDE5-inhibitor activity in vitro (the same mechanism as sildenafil) but at doses far higher than any oral supplement can practically deliver. Human RCT evidence for erectile function or testosterone is essentially absent — traditional Chinese medicine use is long, controlled evidence is not. The word 'Blend' in the title indicates additional undisclosed botanicals. Autofail: proprietary_blend_hides_dose. Even without the autofail, evidence quality would keep this in Rejected range.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "fulvic-acid-capsules-with-chaga-pine-bark",
      "title": "Fulvic Acid Capsules with Chaga & Pine Bark",
      "vendor": "Muscle Faktor",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/20250908124518-1757360677323-e69d7f2d-0496-486f-8b89-98888b81bbd2.png?v=1787583255",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fulvic",
        "acid",
        "capsules",
        "with",
        "chaga",
        "pine",
        "bark",
        "muscle",
        "faktor"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 30.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804066926789",
      "vsf_explanation": "Three-ingredient blend: fulvic acid (soil-derived humic substance with weak human evidence — mostly in vitro antioxidant work), chaga (Inonotus obliquus, popular medicinal mushroom with modest immunomodulatory data but no substantial human RCTs), and pine bark (Pycnogenol at 100–200 mg has legitimate vascular and cognitive RCT support — but this listing does not confirm Pycnogenol branding or dose). Because the actives are combined without individual milligram disclosure, the strongest of the three (Pycnogenol) cannot be confirmed at studied dose. Autofail: proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "l-glutamine-powder-1",
      "title": "L-Glutamine Powder",
      "vendor": "Muscle Faktor",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1756252228046-generated-label-image-0.jpg?v=1787583259",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glutamine",
        "powder",
        "muscle",
        "faktor"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 26.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804066959557",
      "vsf_explanation": "Single-ingredient L-glutamine powder. Glutamine is a conditionally essential amino acid with legitimate evidence in critical illness, post-surgery recovery, and burn/trauma patients (5–30 g/day IV or oral); recreational-athlete evidence for muscle recovery and gut-permeability is more modest. Powder format lets users hit the 5–10 g dose used in most oral trials. Muscle Faktor discloses grams per scoop; no per-lot COA, but ingredient is simple. Score anchors at mid-Standard — competent single-ingredient product, thin outside its clinical-population use cases.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "40-billion-pre-pro-biome-revive",
      "title": "40 BILLION PRE-PRO BIOME REVIVE",
      "vendor": "Muscle Faktor",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1756172371545-generated-label-image-0.jpg?v=1787583261",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "billion",
        "pre",
        "pro",
        "biome",
        "revive",
        "muscle",
        "faktor"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804067025093",
      "vsf_explanation": "40 billion CFU multi-strain probiotic with a prebiotic component. Total CFU is disclosed on the label (partial transparency credit), but individual strain-level CFU counts almost certainly are not — probiotic efficacy is strain- and dose-specific (Lactobacillus rhamnosus GG for antibiotic-associated diarrhea; Bifidobacterium infantis 35624 for IBS). Without per-strain identifiers and CFU, matching to trial evidence is impossible. Prebiotic type and dose also matter (2–5 g inulin/FOS is a functional prebiotic dose; less is a label ornament). Sits at low Standard because the format is legitimate but the label doesn't allow clinical alignment.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "grass-fed-collagen-peptides-powder-chocolate-3",
      "title": "Grass-Fed Collagen Peptides Powder (Chocolate)",
      "vendor": "Muscle Faktor",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/chocolate-collagen-burst.png?v=1787583274",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "grass",
        "fed",
        "collagen",
        "peptides",
        "powder",
        "chocolate",
        "muscle",
        "faktor"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 35.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804067221701",
      "vsf_explanation": "Grass-fed hydrolyzed bovine collagen peptides in a chocolate-flavored powder. Collagen peptides have moderate RCT evidence for skin elasticity, joint comfort, and modest tendon-recovery outcomes at 10–15 g/day (Proksch 2014; Zdzieblik 2017). Powder format supports the studied dose easily. 'Grass-fed' sourcing is a sustainability and quality-signal credit. Chocolate flavoring adds sweeteners and cocoa that are inert to the core collagen effect. Muscle Faktor discloses grams per scoop but does not publish molecular-weight or dipeptide-content data (e.g. Pro-Hyp content) that distinguishes premium products.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "muscle-faktor-dormi-genesis-sleep-support-formula-capsules",
      "title": "Muscle Faktor DORMI GENESIS Sleep Support Formula Capsules",
      "vendor": "Muscle Faktor",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1756170535216-generated-label-image-0.jpg?v=1787583283",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "muscle",
        "faktor",
        "dormi",
        "genesis",
        "sleep",
        "support",
        "formula",
        "capsules",
        "muscle",
        "faktor"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 42,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 38,
        "sustainability": 50
      },
      "price": 29.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804067647685",
      "vsf_explanation": "'DORMI GENESIS Sleep Support Formula' — the naming plus 'Formula' plus 'Support' triad is the standard signature of a proprietary blend combining melatonin, magnesium, L-theanine, GABA, and various sedating botanicals. Each has evidence at specific doses (melatonin 0.3–3 mg; L-theanine 200 mg; magnesium glycinate 200–400 mg elemental Mg; apigenin 50 mg), but a lumped 'sleep support' blend hides which of these reach effective thresholds. Autofail: proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "womens-vitality-formula-2",
      "title": "Women's Vitality Formula",
      "vendor": "Muscle Faktor",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1755212036452-generated-label-image-0.jpg?v=1787583305",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "women",
        "vitality",
        "formula",
        "muscle",
        "faktor"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 35,
        "sustainability": 50
      },
      "price": 30.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804068401349",
      "vsf_explanation": "Generic 'Women's Vitality Formula' branding almost always signals a proprietary blend of adaptogens, iron/folate/B12, and traditional women's-health botanicals (dong quai, chasteberry, red raspberry leaf) at undisclosed individual doses. Each ingredient class has some evidence at specific dose ranges (chasteberry 20 mg for PMS; iron sufficient in demonstrated deficiency), but a lumped 'vitality' blend cannot demonstrate that any single component reaches its studied threshold. Autofail: proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "muscle-faktor-resveratrol-600mg-antioxidant-supplement-capsules",
      "title": "Muscle Faktor Resveratrol 600mg Antioxidant Supplement Capsules",
      "vendor": "Muscle Faktor",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1756238156337-generated-label-image-2.jpg?v=1787583323",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "muscle",
        "faktor",
        "resveratrol",
        "600mg",
        "antioxidant",
        "supplement",
        "capsules",
        "muscle",
        "faktor"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 25.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804070170821",
      "vsf_explanation": "600 mg is above the typical 150–500 mg range in most cardiometabolic and glycemic-control RCTs for resveratrol (e.g. Movahed 2013, Timmers 2011), and comfortably within the range studied for endothelial function. Evidence is moderate — genuine biological effects on SIRT1 signaling and insulin sensitivity, but clinical translation is inconsistent and dependent on trans-resveratrol content vs. total polyphenol content. Muscle Faktor does not disclose the trans-resveratrol percentage or source (Polygonum cuspidatum vs. grape) — a gap that keeps the product at Standard rather than Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "muscle-faktor-ashwagandha-for-athletic-performance-capsules",
      "title": "Muscle Faktor Ashwagandha for Athletic Performance Capsules",
      "vendor": "Muscle Faktor",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1756258393857-generated-label-image-0.jpg?v=1787583333",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "muscle",
        "faktor",
        "ashwagandha",
        "for",
        "athletic",
        "performance",
        "capsules",
        "muscle",
        "faktor"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 23.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804071252165",
      "vsf_explanation": "Ashwagandha (Withania somnifera) has among the strongest adaptogen evidence bases in the supplement category, with multiple RCTs for cortisol reduction, perceived stress, sleep quality, and — relevant to this product's positioning — modest gains in strength and VO2max (Wankhede 2015; Bonilla 2021 meta-analysis). Effective doses are 300–600 mg/day of standardized extract (typically KSM-66 or Sensoril). Muscle Faktor does not specify the extract type or standardization percentage on the listing, which caps the score below Verified. Assuming a competent generic extract at 600 mg, the product is legitimately useful for its athletic-performance positioning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "kit-deseo-zenzsual-edicion-especial",
      "title": "Kit Deseo Zenzsual (Edición Especial)",
      "vendor": "Tu Salud Intima",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/kit-deseo-zenzsual-edicion-especial-388058.jpg?v=1787583413",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "kit",
        "deseo",
        "zenzsual",
        "edici",
        "especial",
        "salud",
        "intima"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health",
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 35,
        "manufacturing": 50,
        "safety": 50,
        "transparency": 25,
        "sustainability": 50
      },
      "price": 132.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804076953797",
      "vsf_explanation": "'Kit Deseo Zenzsual' from Tu Salud Intima is a Spanish-market female libido/sexual wellness kit — typically a bundle of tinctures, capsules, or intimate products with proprietary blend structures and marketing focused on desire, arousal, and intimate satisfaction. The 'Kit' packaging obscures per-product per-ingredient dosing. The women's-libido supplement category has essentially no FDA-approved products, with flibanserin being the only rx option for HSDD; supplement 'libido' claims trade heavily in placebo response and rarely have human RCT support. Autofailed under proprietary_blend_hides_dose (multi-product kit format), with adjacent concern about unverified medical claim for sexual-dysfunction indications. Would require deconstructing into individual SKUs with per-ingredient mg and RCT evidence to be reconsidered.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "fadogia-agrestis-vitality-stamina-support",
      "title": "Fadogia Agrestis | Vitality & Stamina Support",
      "vendor": "NYC Herbs®",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/rn-image_picker_lib_temp_723c6481-60a6-4697-97e2-580a25b12e6c.png?v=1787583429",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fadogia",
        "agrestis",
        "vitality",
        "stamina",
        "support",
        "nyc",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 35,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 8,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804077084869",
      "vsf_explanation": "NYC Herbs Fadogia Agrestis is a single-ingredient SKU where the ingredient itself is the problem — Fadogia agrestis has zero human RCTs, and the sole preclinical support (Yakubu 2005 in rats) also documented dose-dependent testicular toxicity, kidney dysfunction, and reduced sperm count. 'Vitality & Stamina Support' invokes T-boosting/libido claims without any human evidence base. Even with clean dose disclosure (a modest transparency positive over blended SKUs), an ingredient with no human data and a known rodent safety signal cannot pass Standard tier in a transparency-first rubric. Autofailed under unverified_medical_claim. Would not be reconsidered above Rejected until published human safety and efficacy trials exist.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "bestby10-25-nutrivein-fadogia-agrestis-tongkat-ali-turkesterone-1100mg-120-caps",
      "title": "BestBy10/25 Nutrivein Fadogia Agrestis Tongkat Ali Turkesterone 1100mg 120 Caps",
      "vendor": "Deal US",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/open-uri20260209-3204863-qqs2rb.jpg?v=1787583432",
      "score": 28,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bestby10",
        "nutrivein",
        "fadogia",
        "agrestis",
        "tongkat",
        "ali",
        "turkesterone",
        "1100mg",
        "120",
        "caps",
        "deal"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health",
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 30,
        "manufacturing": 50,
        "safety": 30,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 11.4,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804077183173",
      "vsf_explanation": "This SKU stacks three testosterone-narrative ingredients with severe evidence and safety problems: (1) Fadogia agrestis — zero human clinical trials, rodent studies (Yakubu 2005) documented dose-dependent testicular toxicity and kidney damage; (2) Turkesterone — one unpublished (never peer-reviewed) human study, on the WADA 2022 monitoring list, actual androgenic mechanism disputed; (3) Tongkat Ali — has some genuine T-support evidence at 200-400 mg standardized eurycoma, but combined here in an unspecified split. The '1,100 mg' total across three ingredients with no per-ingredient breakdown makes it impossible to know if any is at a meaningful (or safe) dose. 'BestBy10/25' framing suggests a stale-inventory Amazon flip. Autofailed under unverified_medical_claim (T-support without human evidence for two of three ingredients) plus proprietary_blend_hides_dose. Rejected 28.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "alpha-elite™",
      "title": "Alpha Elite™",
      "vendor": "1776 Sports Nutrition LLC",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/IMG-8144.png?v=1787583439",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alpha",
        "elite",
        "1776",
        "sports",
        "nutrition",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health",
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 30,
        "manufacturing": 50,
        "safety": 45,
        "transparency": 25,
        "sustainability": 50
      },
      "price": 40,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804077281477",
      "vsf_explanation": "'Alpha Elite' from 1776 Sports Nutrition is a trademarked proprietary-blend supplement in the men's performance category — the trademark + 'Elite' naming pattern is signature marketing for proprietary formulations that hide per-ingredient dose to conceal under-dosing or unproven actives. Small-brand sports-nutrition SKUs like 1776 lack the RCT footprint, third-party testing, and manufacturing transparency that would justify buying into a blackbox formula. Autofailed under proprietary_blend_hides_dose. Would need full per-actives disclosure, single-mechanism positioning, and RCT evidence for the specific ingredients at labeled doses.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "alpha-blend-capsules-for-men",
      "title": "Alpha Blend Capsules for men",
      "vendor": "NYC Herbs®",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CAPS-ALPHA_3.png?v=1787583441",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "alpha",
        "blend",
        "capsules",
        "for",
        "men",
        "nyc",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health",
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 30,
        "manufacturing": 50,
        "safety": 45,
        "transparency": 25,
        "sustainability": 50
      },
      "price": 20,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804077314245",
      "vsf_explanation": "'Alpha Blend Capsules for Men' from NYC Herbs is a textbook proprietary-blend testosterone-support SKU — the 'Alpha Blend' naming pattern signals per-ingredient dosing is hidden, and the men's-health/testosterone category is one where transparency violations most reliably conceal under-dosed or unproven actives (Fadogia, Tribulus, Tongkat Ali, horny goat weed). NYC Herbs typically sources herbal blends from generic supplier chains without RCT-grade standardization. Autofailed under proprietary_blend_hides_dose. Would need full per-ingredient mg disclosure, avoidance of the Fadogia/Turkesterone auto-fail ingredients, and RCT-supported single-mechanism positioning to be considered.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "milk-thistle-tincture",
      "title": "Milk Thistle Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Milk-Thistle-Tincture-Gardenix-Vitamins-_-Supplements-116752313.jpg?v=1787584933",
      "score": 47,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "milk",
        "thistle",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 45,
        "manufacturing": 48,
        "safety": 55,
        "transparency": 48,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804123779269",
      "vsf_explanation": "Garden Organics sells a milk thistle tincture — the alcohol-water hydroethanolic extraction format traditional to Western herbalism. The core problem with tinctures for milk thistle specifically is that silymarin is poorly soluble in water and only modestly soluble in ethanol, making tincture form a suboptimal delivery vehicle for the active flavonolignan complex. Standardized dry extract capsules or silybin-phytosome preparations deliver dramatically more silymarin per dose. Small artisan herbalist framing without disclosed silymarin mg-per-ml. Not autofailed because no detox claim in the title, but the format itself is a formulation weakness for this particular herb. Legitimate for traditional-use consumers but should not be positioned as clinically equivalent to standardized capsule preparations.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrabio-european-milk-thistle",
      "title": "NutraBio European Milk Thistle",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NutraBio-European-Milk-Thistle.jpg?v=1787584940",
      "score": 76,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrabio",
        "european",
        "milk",
        "thistle",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 68,
        "manufacturing": 72,
        "safety": 68,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804123943109",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 68 → new 76. Evidence found: Zhong S et al. The therapeutic effect of silymarin in the treatment of nonalcoholic fatty liver disease: A meta-analysis. Medicine (Baltimore). 2017;96(49):e9061. | Kim M et al. Silymarin in treatment of chronic liver diseases: a systematic review. Ann Hepatol. 2019;18(1):138-148.. Rationale: European Milk Thistle standardized to 80% silymarin (typical practitioner-grade extract) has TIER-B meta-analytic evidence for NAFLD improvement (Zhong 2017: reductions in ALT/AST). NutraBio transparency + standardized extract. Uplift to 76.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-milk-thistle-supplement-175-mg-silymarin-capsules-for-liver-support",
      "title": "Nature's Bounty Milk Thistle Supplement - 175 mg Silymarin Capsules for Liver Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/adGZv6k7gLHCxRSoaGo0NIcCPbdNmuEqf70PHYoM.jpg?v=1787584947",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "milk",
        "thistle",
        "supplement",
        "175",
        "silymarin",
        "capsules",
        "for",
        "liver",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 24.62,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804124008645",
      "vsf_explanation": "This is the best-scoring SKU in the batch and one of the few that discloses the actual silymarin content — '175 mg Silymarin' — clearing the 150 mg therapeutic threshold established in NAFLD trials (Zhong 2019 meta-analysis, ~-9 U/L ALT reduction at 140-450 mg daily). Marketing is honest — 'for Liver Support', no detox/cleanse/flush claims. Nature's Bounty is a legacy US retail brand with NSF cGMP and Nestlé Health Science ownership. The transparency of naming silymarin mg on the label (rather than the misleading 'milk thistle 1000 mg' framing many competitors use) is a real formulation positive. Would move to Verified 75+ with per-lot COA and switch to silybin-phytosome format for 4-10x bioavailability improvement.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "milk-thistle",
      "title": "Milk Thistle",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Milk_Thistle_G.png?v=1787584956",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "milk",
        "thistle",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804124106949",
      "vsf_explanation": "Prairie Star Botanicals sells a generically titled 'Milk Thistle' — likely a tincture, capsule, or dried herb from a small artisan herbalist brand. Without a stated silymarin standardization percentage, extract ratio, or per-serving milligram dose in the title, the product cannot be verified to deliver a therapeutic 150-300 mg silymarin dose. Small herbalist brands often sell traditional preparations that are legitimate for what they are but fall below the clinical dosing threshold. Not autofailed because the title itself doesn't make detox claims, but formulation/transparency floors keep this in Rejected. Would move to Standard 60+ with silymarin standardization and per-serving mg disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "milk-thistle-seed-capsules",
      "title": "Milk Thistle Seed Capsules",
      "vendor": "Evergreen Apothecary",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/32-34.jpg?v=1787584964",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "milk",
        "thistle",
        "seed",
        "capsules",
        "evergreen",
        "apothecary"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 27.96,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804124827845",
      "vsf_explanation": "Evergreen Apothecary's 'Milk Thistle Seed Capsules' title strongly implies raw ground seed rather than a standardized silymarin extract — an important distinction. Raw milk thistle seed contains only 1.5-3% silymarin by weight, meaning even a 500-1000 mg capsule of raw seed delivers only ~15-30 mg silymarin, well below the 150-300 mg therapeutic range established in NAFLD trials (Zhong 2019). Small artisan herbalist brands often sell raw seed as a whole-food-philosophy product, but at consumer doses this is functionally sub-therapeutic for the hepatoprotective effect the herb is known for. Autofailed on sub_therapeutic_dose grounds — the product delivers a nominal 'milk thistle' but almost certainly not a clinically effective silymarin dose.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "liver-support-2",
      "title": "Liver Support",
      "vendor": "Rooted Owl Pet Supplements",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_f1e01236-eac9-43cb-967e-e4ccf905a018.webp?v=1787584970",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liver",
        "support",
        "rooted",
        "owl",
        "pet",
        "supplements"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 35,
        "safety": 40,
        "transparency": 30,
        "sustainability": 50
      },
      "price": 32,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804124860613",
      "vsf_explanation": "This is explicitly a veterinary/pet supplement product, not a human dietary supplement. Vyvata's scoring rubric is built for human biohacking and health-optimization products; pet supplements fall outside the platform's scope. Even beyond the scope issue, pet supplement regulation (NASC voluntary compliance) is dramatically lighter than human FDA cGMP, dosing is species- and weight-dependent (dogs and cats have very different silymarin pharmacokinetics), and applying human-supplement rubric criteria would produce misleading scores. Autofailed on out_of_scope_for_biohacking.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "natures-bounty-herbal-health-milk-thistle-softgels-1-000-mg",
      "title": "Nature's Bounty Herbal Health Milk Thistle Softgels, 1,000 Mg",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/245020103_af024376-a838-46ff-8124-bb546cb8719a.jpg?v=1787584975",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "herbal",
        "health",
        "milk",
        "thistle",
        "softgels",
        "000",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 11.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804124958917",
      "vsf_explanation": "Nature's Bounty is a legacy US retail supplement brand (Nestlé Health Science-owned) with NSF cGMP compliance and a longer track record than most drugstore competitors. The '1,000 mg' softgel format typically delivers a 4:1 extract equivalence (~250 mg concentrate) and Nature's Bounty's softgel line historically includes at least a nominal silymarin percentage disclosure on the SKU-specific label. Softgel format aids swallowability but doesn't add bioavailability like a phytosome would. No detox/cleanse marketing — honest 'Herbal Health' framing. Third-party USP-style verification not consistent across all Nature's Bounty SKUs. Just clears the Standard threshold as a competent mainstream retail milk thistle. Would move to Verified 75+ with per-lot COA and switch to a Siliphos/Silipide silybin-phytosome format (4-10x bioavailability).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-truth®-milk-thistle-seed-extract-1000-mg-high-potency",
      "title": "Nature's Truth® Milk Thistle Seed Extract – 1000 mg (High Potency)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/94303671_b3d5e55f-aa14-41d3-b0d2-114ae415683d.jpg?v=1787584980",
      "score": 58,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "truth",
        "milk",
        "thistle",
        "seed",
        "extract",
        "1000",
        "high",
        "potency",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 52,
        "sustainability": 50
      },
      "price": 12.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804124991685",
      "vsf_explanation": "Nature's Truth is a Piping Rock-affiliated mainstream retail supplement brand. The '1000 mg (High Potency)' framing typically refers to a 4:1 extract equivalent (i.e., 250 mg of concentrate delivering the equivalent of 1000 mg of raw seed), which is a legitimate US retail formulation but not equivalent to 1000 mg of standardized silymarin. The label rarely discloses the actual silymarin percentage clearly, so users have to assume the industry-standard 80% silymarin standardization is present. cGMP US-manufactured with reasonable third-party testing but no per-lot COA published. Just under the 60-point Standard threshold — legitimate mainstream product with honest 'extract' labeling, but standardization disclosure could be clearer. Would move to Standard 60+ with explicit silymarin % on-label.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "120-capsules-of-milk-thistle-grass-dandelion-root-liver-supplement",
      "title": "120 capsules of milk thistle grass dandelion root liver supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/16F130381F4606361B68494026A8E84E.jpg?v=1787584989",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "120",
        "capsules",
        "milk",
        "thistle",
        "grass",
        "dandelion",
        "root",
        "liver",
        "supplement",
        "digital",
        "presence"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 38,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 32,
        "sustainability": 50
      },
      "price": 27.14,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804125089989",
      "vsf_explanation": "The product title itself is a red flag — 'milk thistle grass' is botanically incorrect (Silybum marianum is not a grass; the active flavonolignan silymarin is concentrated in the seeds, not the leaf or 'grass'). a small third-party seller storefront is a small DTC seller and the naming pattern strongly suggests raw seed or aerial powder rather than a standardized silymarin extract. Combined with dandelion root at unspecified dose in a proprietary blend, this fails on both misleading_naming (mislabeling of botanical part) and sub_therapeutic_dose grounds. Not autofailed for detox marketing, but the botanical inaccuracy plus lack of silymarin standardization keeps this in Rejected tier.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "venatura-milk-thistle-supplement-60-capsules-liver-support-silimarin",
      "title": "VeNatura Milk Thistle Supplement - 60 Capsules, Liver Support, Silimarin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/p3GxuXBEHIfGqqSJqVtAtmdrEwOii6lLCKnWptz8_35230ba6-beb0-48cd-b0e5-f3aedc6cd08f.jpg?v=1787584997",
      "score": 51,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "venatura",
        "milk",
        "thistle",
        "supplement",
        "capsules",
        "liver",
        "support",
        "silimarin",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 22.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804125188293",
      "vsf_explanation": "VeNatura is a Turkish supplement brand reaches the US market via a reseller channel. Marketing uses 'Liver Support' — mild and honest — and calls out 'Silimarin' (Turkish spelling of silymarin), implying the product is standardized to the active flavonolignan complex rather than sold as raw seed powder. That is a real formulation positive. However, the actual silymarin mg per capsule and standardization percentage aren't disclosed in the title, and Turkish regulatory oversight is lighter than US FDA cGMP or EU EFSA. No detox/cleanse claim so no autofail. Would move to Standard 60+ with per-cap silymarin mg disclosure and standardization percentage (target: 80%).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "suda-vitamin-livaxine-60-capsules-natural-liver-support-supplement-with-milk-thistle-artichoke-and-turmeric",
      "title": "Suda Vitamin Livaxine 60 Capsules - Natural Liver Support Supplement with Milk Thistle, Artichoke, and Turmeric",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/D6vp7cey6IRyLOCLdgzgZJ1qjskHJb6Z5sP6GVaF.jpg?v=1787585010",
      "score": 49,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "suda",
        "vitamin",
        "livaxine",
        "capsules",
        "natural",
        "liver",
        "support",
        "supplement",
        "with",
        "milk",
        "thistle",
        "artichoke",
        "and",
        "turmeric",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 48,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 42,
        "sustainability": 50
      },
      "price": 24.62,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804125319365",
      "vsf_explanation": "Suda Vitamin Livaxine is a Turkish blend of three herbs with legitimate liver-adjacent evidence — milk thistle silymarin (NAFLD ALT reduction, Zhong 2019), artichoke leaf (functional dyspepsia, Holtmann 2003), and turmeric curcumin (mixed hepatoprotective signal, needs bioavailability enhancer). Marketing uses 'Natural Liver Support' rather than detox/cleanse, avoiding the unverified_medical_claim autofail. However, per-herb mg dosing, silymarin standardization, and curcumin bioavailability format (unformulated curcumin has <1% oral bioavailability) are not disclosed. Turkish regulatory oversight is lighter than US/EU. Not autofailed, but transparency and formulation gaps keep it in Rejected tier. Would move to Standard 60+ with per-herb mg breakdown and silymarin/curcumin standardization disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "voonka-milk-thistle-supplement-60-capsules-for-liver-health-and-detoxification-support",
      "title": "Voonka Milk Thistle Supplement - 60 Capsules for Liver Health and Detoxification Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NBxeOVMikDkmS9zc1VXqd1fanjpl8N4SkBaoMrI8.jpg?v=1787585021",
      "score": 41,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "voonka",
        "milk",
        "thistle",
        "supplement",
        "capsules",
        "for",
        "liver",
        "health",
        "and",
        "detoxification",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 18.04,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804125417669",
      "vsf_explanation": "Voonka is a Turkish supplement brand and this SKU reaches the US market via a reseller channel. The single-ingredient milk thistle capsule format is more transparent than a proprietary blend, but the title explicitly claims 'Detoxification Support', which triggers the unverified_medical_claim autofail. Even if the silymarin content is legitimate, the marketing frame invokes a physiological effect ('detoxification') that oral supplements have not been shown to produce in healthy livers. Autofailed on the detox claim in the product title.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "respiratory-strength-daily-support",
      "title": "Respiratory Strength, Daily Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/RESPTm2_656490748726_Respiratory_Strength_background_5033c89d-1a19-4370-9483-3bbb9bf8f9e9.jpg?v=1787585039",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "respiratory",
        "strength",
        "daily",
        "support",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 50,
        "sustainability": 62
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804125745349",
      "vsf_explanation": "WishGarden Herbs is a legitimate small-batch herbal tincture maker with a traditional-herbalism orientation. 'Respiratory Strength Daily Support' tinctures typically combine osha, elecampane, mullein, and other traditional respiratory herbs — ingredients with long ethnobotanical use but limited modern RCT support. Tincture format (alcohol-based liquid extract) delivers bioavailable phytoconstituents but at variable, hard-to-standardize doses. Ingredient list and dose per dropperful is the transparency question. Product does not autofail absent explicit disease claim, but the evidence-to-marketing gap and dose imprecision hold it in Standard. Would move to Verified 68+ with per-herb mg equivalence disclosure and clarification of active-marker standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liver-detox-formula",
      "title": "Liver Detox Formula",
      "vendor": "Tailor Made Herbal Products",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/IMG-3465.jpg?v=1787585067",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liver",
        "detox",
        "formula",
        "tailor",
        "made",
        "herbal",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 35,
        "sustainability": 50
      },
      "price": 42,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804126531781",
      "vsf_explanation": "Tailor Made Herbal Products sells this as a 'Liver Detox Formula' — 'Detox' in the product name is an explicit unverified medical claim under Vyvata's supplement rubric. There is no clinical evidence that oral supplements 'detox' a healthy liver, and the phase I/II detoxification pathways are already continuously active in functional hepatic tissue. Autofailed regardless of ingredient composition, because the marketing frame itself makes an unsubstantiated claim.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "talya-adm-artichoke-dandelion-milk-thistle-dietary-supplement-60-capsules-for-liver-digestive-health-support",
      "title": "Talya Adm Artichoke Dandelion Milk Thistle Dietary Supplement - 60 Capsules for Liver & Digestive Health Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/yPZ3rALztejwqFw8PAHv7Wnimqy9FJa2PjruNUxM.jpg?v=1787585082",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "talya",
        "adm",
        "artichoke",
        "dandelion",
        "milk",
        "thistle",
        "dietary",
        "supplement",
        "capsules",
        "for",
        "liver",
        "digestive",
        "health",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 30.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804126662853",
      "vsf_explanation": "Talya ADM is an imported Turkish botanical blend combining three herbs each with modest, real-world evidence: milk thistle silymarin for NAFLD ALT/AST reduction (Zhong 2019), artichoke leaf for dyspepsia (Holtmann 2003), and dandelion root as a mild choleretic (mechanistic only). Marketing avoids 'detox' language and uses 'Liver & Digestive Health Support', a softer framing that doesn't trigger the unverified_medical_claim autofail. However, the 60-capsule blend format doesn't disclose per-herb mg, silymarin percentage, or third-party COA, and Turkish supplement regulation is less rigorous than US FDA cGMP or EU EFSA oversight. Not autofailed, but transparency and manufacturing floors keep it in Rejected tier. Would move to Standard 60+ with per-herb mg and standardization disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "revive-gut-health-60-capsules",
      "title": "Revive Gut Health+ - 60 capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Revive-Gut-Health-60-capsules.jpg?v=1787585120",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "revive",
        "gut",
        "health",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 24.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804127056069",
      "vsf_explanation": "'Revive Gut Health+' is a generic gut-support SKU with no visible strain, CFU, or per-ingredient disclosure in the title. Meaningful probiotic products require genus + species + strain designation (e.g., Lactobacillus rhamnosus GG) and guaranteed CFU at expiration — absence of these signals in the product identity is a strong red flag. Sold via general-sports-market distribution channels suggests general-sports-market rather than clinical-tier positioning. Not autofailed absent explicit proprietary-blend label evidence, but transparency gaps hold it below Standard. Would move to Standard 60+ with strain-level disclosure (Genus species strain), CFU per strain at expiration, and coherent evidence for the specific strain combination.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liver-cleanse",
      "title": "Liver Cleanse",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/LiverCleanse.png?v=1787585157",
      "score": 37,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liver",
        "cleanse",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 15,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804127547589",
      "vsf_explanation": "The product is literally named 'Liver Cleanse' — an unverified medical claim on its face. Prairie Star Botanicals is a small herbalist operation whose formulations may include legitimate hepatoprotective herbs (milk thistle, dandelion), but the framing sells the concept of 'cleansing' a healthy liver, which has no clinical basis. A functional liver continuously performs phase I/II detoxification via its own enzymatic machinery; no oral supplement has been shown to enhance this in healthy adults. Autofailed on unverified_medical_claim regardless of the herbs inside.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "colorado-detox-blend",
      "title": "Colorado Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Colorado-Detox-Blend-HerbEra-Colorado-Detox-Blend-Formula-200267227.jpg?v=1787585189",
      "score": 37,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "colorado",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 19,
        "formulation": 34,
        "manufacturing": 36,
        "safety": 47,
        "transparency": 24,
        "sustainability": 33
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804129185989",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Colorado Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement colorado\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "new-mexico-detox-blend",
      "title": "New Mexico Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/New-Mexico-Detox-Blend-HerbEra-New-Mexico-Detox-Blend-Formula-200263738.jpg?v=1787585215",
      "score": 37,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "new",
        "mexico",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 19,
        "formulation": 34,
        "manufacturing": 36,
        "safety": 47,
        "transparency": 24,
        "sustainability": 33
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804134035653",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"New Mexico Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement new mexico\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "nevada-detox-blend",
      "title": "Nevada Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nevada-Detox-Blend-HerbEra-Nevada-Detox-Blend-Formula-200271717.jpg?v=1787585215",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nevada",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 18,
        "formulation": 32,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 22,
        "sustainability": 32
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804134002885",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Nevada Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement nevada\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "pennsylvania-detox-blend",
      "title": "Pennsylvania Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Pennsylvania-Detox-Blend-HerbEra-Pennsylvania-Detox-Blend-Formula-200270973.jpg?v=1787585215",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pennsylvania",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 35,
        "manufacturing": 38,
        "safety": 48,
        "transparency": 25,
        "sustainability": 35
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804133937349",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Pennsylvania Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement pennsylvania\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "new-york-detox-blend",
      "title": "New York Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/New-York-Detox-Blend-HerbEra-New-York-Detox-Blend-Formula-200262878.jpg?v=1787585215",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "new",
        "york",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 38,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 28,
        "sustainability": 35
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804133970117",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"New York Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement new york\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "north-carolina-detox-blend",
      "title": "North Carolina Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/North-Carolina-Detox-Blend-HerbEra-North-Carolina-Detox-Blend-Formula-200260294.jpg?v=1787585215",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "north",
        "carolina",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 42,
        "safety": 52,
        "transparency": 30,
        "sustainability": 38
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804134068421",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"North Carolina Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement north carolina\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "wyoming-detox-blend",
      "title": "Wyoming Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Wyoming-Detox-Blend-HerbEra-Wyoming-Detox-Blend-Formula-200259071.jpg?v=1787585216",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wyoming",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 38,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 28,
        "sustainability": 35
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804134166725",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Wyoming Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement wyoming\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "west-virginia-detox-blend",
      "title": "West Virginia Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/West-Virginia-Detox-Blend-HerbEra-West-Virginia-Detox-Blend-Formula-200259222.png?v=1787585217",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "west",
        "virginia",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 42,
        "safety": 52,
        "transparency": 30,
        "sustainability": 38
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804134199493",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"West Virginia Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement west virginia\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "alabama-detox-blend",
      "title": "Alabama Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Alabama-Detox-Blend-HerbEra-Alabama-Detox-Blend-Formula-200267641.jpg?v=1787585220",
      "score": 37,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alabama",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 19,
        "formulation": 34,
        "manufacturing": 36,
        "safety": 47,
        "transparency": 24,
        "sustainability": 33
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804134461637",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Alabama Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement alabama\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "arkansas-detox-blend",
      "title": "Arkansas Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Arkansas-Detox-Blend-HerbEra-Arkansas-Detox-Blend-Formula-200267422.jpg?v=1787585221",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "arkansas",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 18,
        "formulation": 32,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 22,
        "sustainability": 32
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804134494405",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Arkansas Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement arkansas\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "alaska-detox-blend",
      "title": "Alaska Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Alaska-Detox-Blend-HerbEra-Alaska-Detox-Blend-Formula-200270734.jpg?v=1787585220",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alaska",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 35,
        "manufacturing": 38,
        "safety": 48,
        "transparency": 25,
        "sustainability": 35
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804134527173",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Alaska Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement alaska\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "florida-detox-blend",
      "title": "Florida Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Florida-Detox-Blend-HerbEra-Florida-Detox-Blend-Formula-200267070.jpg?v=1787585220",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "florida",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 35,
        "manufacturing": 38,
        "safety": 48,
        "transparency": 25,
        "sustainability": 35
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804134559941",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Florida Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement florida\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "georgia-detox-blend",
      "title": "Georgia Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Georgia-Detox-Blend-HerbEra-Georgia-Detox-Blend-Formula-200265761.jpg?v=1787585221",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "georgia",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 38,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 28,
        "sustainability": 35
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804134658245",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Georgia Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement georgia\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "connecticut-detox-blend",
      "title": "Connecticut Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Connecticut-Detox-Blend-HerbEra-Connecticut-Detox-Blend-Formula-200267127.jpg?v=1787585221",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "connecticut",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 42,
        "safety": 52,
        "transparency": 30,
        "sustainability": 38
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804134592709",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Connecticut Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement connecticut\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "idaho-detox-blend",
      "title": "Idaho Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Idaho-Detox-Blend-HerbEra-Idaho-Detox-Blend-Formula-200270313.jpg?v=1787585220",
      "score": 37,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "idaho",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 19,
        "formulation": 34,
        "manufacturing": 36,
        "safety": 47,
        "transparency": 24,
        "sustainability": 33
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804134756549",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Idaho Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement idaho\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "hawaii-detox-blend",
      "title": "Hawaii Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Hawaii-Detox-Blend-HerbEra-Hawaii-Detox-Blend-Formula-200271979.jpg?v=1787585221",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hawaii",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 18,
        "formulation": 32,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 22,
        "sustainability": 32
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804134789317",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Hawaii Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement hawaii\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "arizona-detox-blend",
      "title": "Arizona Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Arizona-Detox-Blend-HerbEra-Arizona-Detox-Blend-Formula-200267538.jpg?v=1787585221",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "arizona",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 35,
        "manufacturing": 38,
        "safety": 48,
        "transparency": 25,
        "sustainability": 35
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804134625477",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Arizona Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement arizona\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "california-detox-blend",
      "title": "California Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/California-Detox-Blend-HerbEra-California-Detox-Blend-Formula-200267356.jpg?v=1787585221",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "california",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 38,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 28,
        "sustainability": 35
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804134691013",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"California Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement california\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "indiana-detox-blend",
      "title": "Indiana Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Indiana-Detox-Blend-HerbEra-Indiana-Detox-Blend-Formula-200271432.jpg?v=1787585221",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "indiana",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 42,
        "safety": 52,
        "transparency": 30,
        "sustainability": 38
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804134723781",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Indiana Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement indiana\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "iowa-detox-blend",
      "title": "Iowa Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Iowa-Detox-Blend-HerbEra-Iowa-Detox-Blend-Formula-200267762.jpg?v=1787585220",
      "score": 37,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "iowa",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 19,
        "formulation": 34,
        "manufacturing": 36,
        "safety": 47,
        "transparency": 24,
        "sustainability": 33
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804134953157",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Iowa Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement iowa\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "delaware-detox-blend",
      "title": "Delaware Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Delaware-Detox-Blend-HerbEra-Delaware-Detox-Blend-Formula-200271674.jpg?v=1787585221",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "delaware",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 18,
        "formulation": 32,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 22,
        "sustainability": 32
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804134822085",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Delaware Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement delaware\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "montana-detox-blend",
      "title": "Montana Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Montana-Detox-Blend-HerbEra-Montana-Detox-Blend-Formula-200273731.jpg?v=1787585221",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "montana",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 35,
        "manufacturing": 38,
        "safety": 48,
        "transparency": 25,
        "sustainability": 35
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804134854853",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Montana Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement montana\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "michigan-detox-blend",
      "title": "Michigan Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Michigan-Detox-Blend-HerbEra-Michigan-Detox-Blend-Formula-200271216.jpg?v=1787585221",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "michigan",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 38,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 28,
        "sustainability": 35
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804134920389",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Michigan Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement michigan\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "louisiana-detox-blend",
      "title": "Louisiana Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Louisiana-Detox-Blend-HerbEra-Louisiana-Detox-Blend-Formula-200270858.jpg?v=1787585221",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "louisiana",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 42,
        "safety": 52,
        "transparency": 30,
        "sustainability": 38
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804134887621",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Louisiana Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement louisiana\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "oregon-detox-blend",
      "title": "Oregon Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Oregon-Detox-Blend-HerbEra-Oregon-Detox-Blend-Formula-200271188.jpg?v=1787585223",
      "score": 37,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "oregon",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 19,
        "formulation": 34,
        "manufacturing": 36,
        "safety": 47,
        "transparency": 24,
        "sustainability": 33
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804135018693",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Oregon Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement oregon\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "rhode-island-detox-blend",
      "title": "Rhode Island Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Rhode-Island-Detox-Blend-HerbEra-Rhode-Island-Detox-Blend-Formula-200272494.jpg?v=1787585223",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "rhode",
        "island",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 18,
        "formulation": 32,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 22,
        "sustainability": 32
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804134985925",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Rhode Island Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement rhode island\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "south-dakota-detox-blend",
      "title": "South Dakota Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/South-Dakota-Detox-Blend-HerbEra-South-Dakota-Detox-Blend-Formula-200260014.jpg?v=1787585224",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "south",
        "dakota",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 38,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 28,
        "sustainability": 35
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804135051461",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"South Dakota Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement south dakota\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "south-carolina-detox-blend",
      "title": "South Carolina Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/South-Carolina-Detox-Blend-HerbEra-South-Carolina-Detox-Blend-Formula-200260165.jpg?v=1787585224",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "south",
        "carolina",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 42,
        "safety": 52,
        "transparency": 30,
        "sustainability": 38
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804135084229",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"South Carolina Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement south carolina\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "oklahoma-detox-blend",
      "title": "Oklahoma Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Oklahoma-Detox-Blend-HerbEra-Oklahoma-Detox-Blend-Formula-200274088.jpg?v=1787585225",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "oklahoma",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 35,
        "manufacturing": 38,
        "safety": 48,
        "transparency": 25,
        "sustainability": 35
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804135116997",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Oklahoma Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement oklahoma\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "wisconsin-detox-blend",
      "title": "Wisconsin Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Wisconsin-Detox-Blend-HerbEra-Wisconsin-Detox-Blend-Formula-200259169.png?v=1787585227",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wisconsin",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 18,
        "formulation": 32,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 22,
        "sustainability": 32
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804135149765",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Wisconsin Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement wisconsin\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "massachusetts-detox-blend",
      "title": "Massachusetts Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Massachusetts-Detox-Blend-HerbEra-Massachusetts-Detox-Blend-Formula-200271520.jpg?v=1787585229",
      "score": 37,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "massachusetts",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 19,
        "formulation": 34,
        "manufacturing": 36,
        "safety": 47,
        "transparency": 24,
        "sustainability": 33
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804135215301",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Massachusetts Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement massachusetts\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "utah-detox-blend",
      "title": "Utah Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Utah-Detox-Blend-HerbEra-Utah-Detox-Blend-Formula-200272160.jpg?v=1787585229",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "utah",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 18,
        "formulation": 32,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 22,
        "sustainability": 32
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804135248069",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Utah Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement utah\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "illinois-detox-blend",
      "title": "Illinois Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Illinois-Detox-Blend-HerbEra-Illinois-Detox-Blend-Formula-200270280.jpg?v=1787585229",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "illinois",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 35,
        "manufacturing": 38,
        "safety": 48,
        "transparency": 25,
        "sustainability": 35
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804135313605",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Illinois Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement illinois\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "kansas-detox-blend",
      "title": "Kansas Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Kansas-Detox-Blend-HerbEra-Kansas-Detox-Blend-Formula-200271896.jpg?v=1787585229",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "kansas",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 38,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 28,
        "sustainability": 35
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804135280837",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Kansas Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement kansas\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "washington-detox-blend",
      "title": "Washington Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Washington-Detox-Blend-HerbEra-Washington-Detox-Blend-Formula-200259787.jpg?v=1787585228",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "washington",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 42,
        "safety": 52,
        "transparency": 30,
        "sustainability": 38
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804135346373",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Washington Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement washington\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "north-dakota-detox-blend",
      "title": "North Dakota Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/North-Dakota-Detox-Blend-HerbEra-North-Dakota-Detox-Blend-Formula-200262955.jpg?v=1787585228",
      "score": 37,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "north",
        "dakota",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 19,
        "formulation": 34,
        "manufacturing": 36,
        "safety": 47,
        "transparency": 24,
        "sustainability": 33
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804135379141",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"North Dakota Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement north dakota\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "tennessee-detox-blend",
      "title": "Tennessee Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Tennessee-Detox-Blend-HerbEra-Tennessee-Detox-Blend-Formula-200272378.jpg?v=1787585229",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tennessee",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 18,
        "formulation": 32,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 22,
        "sustainability": 32
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804135411909",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Tennessee Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement tennessee\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "ohio-detox-blend",
      "title": "Ohio Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Ohio-Detox-Blend-HerbEra-Ohio-Detox-Blend-Formula-200268526.jpg?v=1787585229",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ohio",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 35,
        "manufacturing": 38,
        "safety": 48,
        "transparency": 25,
        "sustainability": 35
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804135444677",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Ohio Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement ohio\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "vermont-detox-blend",
      "title": "Vermont Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Vermont-Detox-Blend-HerbEra-Vermont-Detox-Blend-Formula-200272251.jpg?v=1787585229",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vermont",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 38,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 28,
        "sustainability": 35
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804135477445",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Vermont Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement vermont\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "virginia-detox-blend",
      "title": "Virginia Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Virginia-Detox-Blend-HerbEra-Virginia-Detox-Blend-Formula-200259829.jpg?v=1787585229",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "virginia",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 42,
        "safety": 52,
        "transparency": 30,
        "sustainability": 38
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804135542981",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Virginia Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement virginia\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "texas-detox-blend",
      "title": "Texas Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Texas-Detox-Blend-HerbEra-Texas-Detox-Blend-Formula-200259993.jpg?v=1787585229",
      "score": 37,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "texas",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 19,
        "formulation": 34,
        "manufacturing": 36,
        "safety": 47,
        "transparency": 24,
        "sustainability": 33
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804135575749",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Texas Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement texas\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "minnesota-detox-blend",
      "title": "Minnesota Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Minnesota-Detox-Blend-HerbEra-Minnesota-Detox-Blend-Formula-200271022.jpg?v=1787585231",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "minnesota",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 42,
        "safety": 52,
        "transparency": 30,
        "sustainability": 38
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804136198341",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Minnesota Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement minnesota\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "kentucky-detox-blend",
      "title": "Kentucky Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Kentucky-Detox-Blend-HerbEra-Kentucky-Detox-Blend-Formula-200271392.jpg?v=1787585231",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "kentucky",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 35,
        "manufacturing": 38,
        "safety": 48,
        "transparency": 25,
        "sustainability": 35
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804136231109",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Kentucky Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement kentucky\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "mississippi-detox-blend",
      "title": "Mississippi Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Mississippi-Detox-Blend-HerbEra-Mississippi-Detox-Blend-Formula-200273924.jpg?v=1787585231",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mississippi",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 38,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 28,
        "sustainability": 35
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804136263877",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Mississippi Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement mississippi\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "maine-detox-blend",
      "title": "Maine Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Maine-Detox-Blend-HerbEra-Maine-Detox-Blend-Formula-200274234.jpg?v=1787585234",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "maine",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 18,
        "formulation": 32,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 22,
        "sustainability": 32
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804136296645",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Maine Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement maine\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "nebraska-detox-blend",
      "title": "Nebraska Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nebraska-Detox-Blend-HerbEra-Nebraska-Detox-Blend-Formula-200272051.jpg?v=1787585234",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nebraska",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 35,
        "manufacturing": 38,
        "safety": 48,
        "transparency": 25,
        "sustainability": 35
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804136329413",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Nebraska Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement nebraska\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "maryland-detox-blend",
      "title": "Maryland Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Maryland-Detox-Blend-HerbEra-Maryland-Detox-Blend-Formula-200273849.jpg?v=1787585235",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "maryland",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 38,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 28,
        "sustainability": 35
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804136362181",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Maryland Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement maryland\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "new-hampshire-detox-blend",
      "title": "New Hampshire Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/New-Hampshire-Detox-Blend-HerbEra-New-Hampshire-Detox-Blend-Formula-200263191.jpg?v=1787585235",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "new",
        "hampshire",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 42,
        "safety": 52,
        "transparency": 30,
        "sustainability": 38
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804136394949",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"New Hampshire Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement new hampshire\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "new-jersey-detox-blend",
      "title": "New Jersey Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/New-Jersey-Detox-Blend-HerbEra-New-Jersey-Detox-Blend-Formula-200260377.jpg?v=1787585235",
      "score": 37,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "new",
        "jersey",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 19,
        "formulation": 34,
        "manufacturing": 36,
        "safety": 47,
        "transparency": 24,
        "sustainability": 33
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804136427717",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"New Jersey Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement new jersey\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "missouri-detox-blend",
      "title": "Missouri Detox Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Missouri-Detox-Blend-HerbEra-Missouri-Detox-Blend-Formula-200274199.jpg?v=1787585235",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "missouri",
        "detox",
        "blend",
        "herbera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 18,
        "formulation": 32,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 22,
        "sustainability": 32
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804136460485",
      "vsf_explanation": "HerbEra ships fifty identically-branded \"Detox Blend\" SKUs, one named after every US state — including this \"Missouri Detox Blend.\" There is no publicly disclosed formulation difference tied to the state name; the pattern is a textbook SEO/geo-targeting play that surfaces the product for \"detox supplement missouri\"-style queries without offering a state-specific formula or ingredient variance to justify the naming. Compounding that, the \"detox\" positioning itself is an unverified medical claim: the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the claim of \"detoxifying\" the body. Cochrane and NIH NCCIH reviews of commercial \"detox\" products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Per-herb doses, extraction ratios, standardization percentages, and full quantitative facts panels are not disclosed at the title-level for this SKU, and there is no per-lot heavy-metal or microbial COA published for it. Botanical safety at unstated doses cannot be independently verified. Auto-failed under unverified_medical_claim for the \"detox\" positioning and would additionally trip misleading_naming for the state-brand rotation. Not listable in current form. Would require: (1) dropping \"detox\" from the product name and claims, (2) collapsing the 50-SKU rotation into a single honestly-named product, (3) full quantitative ingredient disclosure, and (4) third-party COAs.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "liver-reset-complete-bundle-liver-gallbladder-cleanse-capsules-liver-flush-protocol-pdf",
      "title": "Liver Reset Complete Bundle - Liver & Gallbladder Cleanse Capsules + Liver Flush Protocol (PDF)",
      "vendor": "Seamoss depot",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/LiverResetCompleteBundle-SeaMossDepot.png?v=1787585262",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liver",
        "reset",
        "complete",
        "bundle",
        "liver",
        "gallbladder",
        "cleanse",
        "capsules",
        "liver",
        "flush",
        "protocol",
        "pdf",
        "seamoss",
        "depot"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 35,
        "manufacturing": 40,
        "safety": 40,
        "transparency": 30,
        "sustainability": 50
      },
      "price": 49.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804141441221",
      "vsf_explanation": "Product title contains three explicit unverified-medical-claim triggers — 'Cleanse', 'Flush', and 'Reset' — plus a bundled 'Liver Flush Protocol PDF' that implies a therapeutic detoxification procedure with no clinical basis. Liver/gallbladder 'flushes' have been repeatedly evaluated and rejected by hepatology literature; the visible stones passed in olive-oil-and-Epsom-salt protocols are saponified fat, not gallstones (Sies & Brooke, Lancet 2005). Bundling a 'protocol PDF' with capsules escalates the claim from marketing to procedural guidance, which raises the safety concern for users with actual biliary or hepatic disease. Autofailed on unverified_medical_claim.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "liver-health-blend",
      "title": "Liver Health Blend",
      "vendor": "NYC Herbs®",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BLEND_LIVER.png?v=1787585280",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liver",
        "health",
        "blend",
        "nyc",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 35,
        "sustainability": 50
      },
      "price": 15,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804141998277",
      "vsf_explanation": "NYC Herbs sells a proprietary 'Liver Health Blend' with no disclosed silymarin standardization, no per-herb mg breakdown, and marketing language leaning heavily on generalized 'liver support' framing rather than the specific hepatoprotective indications (NAFLD ALT/AST reduction, alcoholic-liver support) where silymarin has modest evidence (Cochrane 2007 Rambaldi; Zhong 2019 NAFLD meta-analysis, WMD ~-9 U/L ALT). Proprietary-blend format prevents users from confirming a therapeutic 150-300 mg silymarin dose. Small herbalist brand with no third-party COA visible. Not autofailed on the title alone, but formulation/transparency floor keeps it in Rejected. Would move to Standard 60+ only with per-ingredient mg disclosure and standardization to 80% silymarin at a clinically studied dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "21st-century®-dhea-25-mg-hormone-support-90-capsules",
      "title": "21st Century® DHEA 25 mg – Hormone Support (90 Capsules)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/155774127_b1257c40-02fe-4bb4-9194-d30b1af526ea.jpg?v=1787585303",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "21st",
        "century",
        "dhea",
        "hormone",
        "support",
        "capsules",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine",
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 6.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804142260421",
      "vsf_explanation": "21st Century is a well-established mass-retail brand with USP-verified capacity, and the explicit 25 mg per-cap disclosure is a real transparency positive — buyers know exactly what they are getting. 25 mg is the lower end of studied efficacy for adults over 40 with low DHEA-S, appropriate as a starter dose or maintenance for women (who metabolize DHEA to testosterone and estradiol at higher rates than men). Same safety considerations apply as any DHEA product: not for under-40s without testing, hormone-sensitive condition contraindications, androgenic side-effect potential. Distributed through a legitimate pharmacy retail channel adds a modest quality signal. Would move to Verified 72+ with explicit 'lab-confirm DHEA-S before use' warning and per-lot third-party assay.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "portions-master-dhea-hormonal-support-100-count",
      "title": "Portions Master DHEA Hormonal Support (100 Count)",
      "vendor": "Portions Master",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/DHEA_100s_shadow__89791.1712944692.1280.1280_09ab6e88-58ac-4266-af23-7824db2fac8f.png?v=1787585313",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "portions",
        "master",
        "dhea",
        "hormonal",
        "support",
        "100",
        "count",
        "portions",
        "master"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine",
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804142358725",
      "vsf_explanation": "DHEA (dehydroepiandrosterone) is a real hormone precursor with legitimate use cases in adults over 40 with documented low DHEA-S — the Baulieu 2000 DHEAge study showed bone density and skin improvements in older women at 50 mg/day. Portions Master is a mainstream mass-retail brand; dose per capsule (25 mg, 50 mg, or higher) is the key transparency question and determines appropriate use case. Safety concerns are real: DHEA has androgenic effects (acne, hair loss/growth), should not be used by anyone under 40 without a lab-confirmed deficiency, and can worsen hormone-sensitive conditions (PCOS, hormone-receptor-positive cancers). 'Hormonal Support' framing is vague. Would move to Verified 70+ with per-cap mg on primary label, explicit 'not for use under age 40 without DHEA-S testing' warning, and third-party purity assay.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "colostrum-38-eq",
      "title": "Colostrum-38 EQ",
      "vendor": "BioStarUS",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/EQ-Colostrumboth-2023.png?v=1787585358",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "colostrum",
        "biostarus"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 35,
        "manufacturing": 40,
        "safety": 30,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804142948549",
      "vsf_explanation": "Colostrum-38 EQ is BioStarUS's equine (horse) colostrum product — the 'EQ' suffix is BioStar's convention for their horse line, and the brand's core business is equine supplementation. This is not formulated, dosed, or tested for human consumption. Vyvata's rubric autofails products outside the human biohacking scope. Even ignoring scope, the safety profile for a human ingesting an unregulated horse-market colostrum product is unknown, and no analytical accuracy or CLIA-equivalent oversight applies.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bovine-colostrum-powder-2300-mg-unflavored-immune-support",
      "title": "Bovine Colostrum Powder 2300 mg – Unflavored Immune Support",
      "vendor": "Halea Life: Nutrition & Skincare",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1770818033182-generated-label-image-0.jpg?v=1787585369",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bovine",
        "colostrum",
        "powder",
        "2300",
        "unflavored",
        "immune",
        "support",
        "halea",
        "life",
        "nutrition",
        "skincare"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive",
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 19.96,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804143341765",
      "vsf_explanation": "Powder format at 2,300 mg per serving still falls below the 10–20 g clinical-trial dose, but is enough to scoop into meaningful daily totals if the user takes multiple servings. Unflavored is preferable — flavoring often masks off-tastes from oxidized product. 'Immune Support' is structure/function language, no autofail. Halea publishes per-serving milligrams (transparency credit) but no IgG assay. Sits mid-Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bovine-colostrum-capsules-500mg-immune-gut-support",
      "title": "Bovine Colostrum Capsules 500mg | Immune & Gut Support",
      "vendor": "Halea Life: Nutrition & Skincare",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1770823635151-generated-label-image-0.jpg?v=1787585374",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bovine",
        "colostrum",
        "capsules",
        "500mg",
        "immune",
        "gut",
        "support",
        "halea",
        "life",
        "nutrition",
        "skincare"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive",
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 52,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 17.96,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804143440069",
      "vsf_explanation": "Bovine colostrum 500 mg capsules from a small DTC brand. 'Immune & Gut Support' language uses FDA-permitted structure/function terms (not disease claims) so no autofail fires — but the underlying capsule dose (500 mg) is well below the 10–20 g/day used in colostrum RCTs, so the evidence-to-formulation match is weak. The label discloses milligrams per capsule (transparency credit) but not IgG %. Score anchors at the low end of Standard because the ingredient is legitimate but the dose format cannot deliver the outcomes suggested by the label.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "colostrum-capsules-2",
      "title": "Colostrum Capsules",
      "vendor": "Muscle Faktor",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1755211704741-generated-label-image-0.jpg?v=1787585385",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "colostrum",
        "capsules",
        "muscle",
        "faktor"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive",
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 50,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 52,
        "sustainability": 50
      },
      "price": 35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804143866053",
      "vsf_explanation": "Capsule version of Muscle Faktor's colostrum. Same ingredient, same brand-transparency profile, but formulation is downgraded because capsules cannot practically deliver the 10–20 g/day dose used in gut-permeability RCTs — a 500 mg capsule requires 20+ pills daily to hit trial doses. Convenient for maintenance dosing but sub-therapeutic for the outcomes most often claimed. IgG percentage still undisclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "colostrum-powder",
      "title": "Colostrum Powder",
      "vendor": "Muscle Faktor",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1755211436426-generated-label-image-0.jpg?v=1787585388",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "colostrum",
        "powder",
        "muscle",
        "faktor"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive",
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 52,
        "sustainability": 50
      },
      "price": 11.7,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804143964357",
      "vsf_explanation": "Muscle Faktor's powder version of colostrum. Ingredient class carries the same legitimate evidence base (Playford & Weiser 2021; Wong 2020 for gut permeability). Muscle Faktor is a moderate-transparency DTC brand — publishes ingredient lists and dose but does not disclose IgG percentage or first-milking sourcing. Powder format allows the studied 10–20 g daily dose to be reached if the user scoops accordingly, which is a formulation credit over the capsule SKU.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "colostrum-powder-1",
      "title": "Colostrum Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Generated_with_Kive.ai_-_Luxury_wellness_supplement_product_hero_shot_of_Lang_Wellness_Colostrum_Powder__featuring_a_single_white_powder_jar_only__no_carton__no_outer_packaging__cente.png?v=1787585393",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "colostrum",
        "powder",
        "lang",
        "wellness",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive",
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 52,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 48,
        "sustainability": 50
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804144160965",
      "vsf_explanation": "Generic colostrum powder from a small wellness-brand vendor with limited public documentation. The underlying ingredient has real RCT support for gut permeability and modest athletic recovery, but Lang Wellness discloses neither the IgG percentage nor first-milking sourcing on the product page, and offers no per-lot COA. Sits at the low end of Standard — the ingredient class carries the score, brand transparency drags it down.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mother-earth-labs-gi-ultramax-30-servings",
      "title": "Mother Earth Labs GI UltraMAX - 30 Servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Mother-Earth-Labs-GI-UltraMAX-30-Servings.jpg?v=1787585405",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mother",
        "earth",
        "labs",
        "ultramax",
        "servings",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive",
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 66.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804144259269",
      "vsf_explanation": "Mother Earth Labs is a premium practitioner-tier gut-health brand, and 'GI UltraMAX' is typically positioned as a comprehensive gut-repair powder with L-glutamine, IgG (bovine colostrum-derived), zinc carnosine, and possibly deglycyrrhizinated licorice. Individual ingredients have real evidence — L-glutamine at 5-10 g/day for intestinal permeability, IgG at 2-5 g for immune modulation, zinc carnosine at 75 mg for gastric-mucosal repair. Quality depends on whether ingredients are disclosed with per-serving grams (not a proprietary blend), whether IgG source and % is specified, and whether third-party testing accompanies the premium price. Would move to Verified 70+ with full per-actives gram disclosure, IgG % standardization, and independent purity testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "colostrum-powder-made-in-the-usa",
      "title": "Colostrum Powder Made in the USA",
      "vendor": "THRIXINE",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1774569894918-generated-label-image-0.jpg?v=1787585411",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "colostrum",
        "powder",
        "made",
        "the",
        "usa",
        "thrixine"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive",
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804144357573",
      "vsf_explanation": "Bovine colostrum has legitimate mechanistic and clinical support — IgG, IgA, lactoferrin, and IGF-1/TGF-β growth factors are present in real quantities and have RCT evidence for gut-barrier support (Playford & Weiser 2021 review; Wong et al 2020 meta-analysis on intestinal permeability) and modest athletic-recovery signal. THRIXINE positions the product on U.S. sourcing, which is verifiable and reduces some import-supply questions, but does not disclose IgG percentage per serving — the single most important compositional metric for colostrum. Without % IgG or first-milking sourcing disclosure, the product cannot clear Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "irish-gold-sea-moss-gel-infused-with-key-lime",
      "title": "Irish gold Sea Moss Gel infused with Key Lime",
      "vendor": "Love4radiance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/305C7325-2DE6-491D-8EC0-867FA8B902CF.jpg?v=1787585449",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "irish",
        "gold",
        "sea",
        "moss",
        "gel",
        "infused",
        "with",
        "key",
        "lime",
        "love4radiance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 42,
        "manufacturing": 40,
        "safety": 48,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 30,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804145209541",
      "vsf_explanation": "Key lime flavored sea moss gel from a small direct-to-consumer brand. Same underlying rubric issues as every other sea moss SKU in this batch: no RCT for the marketed outcomes, undisclosed per-serving iodine, no published COA, no third-party heavy-metal testing. Key lime is inert to the evidence question. No autofail because the title does not make a specific benefit claim.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sea-moss-gel-elderberry-flavor-16oz",
      "title": "Sea Moss Gel - Elderberry Flavor 16oz",
      "vendor": "Sea Moss Lyfe",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitled_Project_-_AI_Image_board_8_1-2_a222d015-d03d-4251-895a-75e7576b938a.png?v=1787585453",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sea",
        "moss",
        "gel",
        "elderberry",
        "flavor",
        "16oz",
        "sea",
        "moss",
        "lyfe"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 42,
        "manufacturing": 40,
        "safety": 48,
        "transparency": 42,
        "sustainability": 50
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804145340613",
      "vsf_explanation": "Sea moss gel with elderberry flavor. Because 'flavor' implies flavoring quantity rather than a standardized elderberry extract at the ~600 mg dose used in cold-duration RCTs (Tiralongo 2016), the elderberry contributes no clinical activity here. Title is otherwise neutral. Same evidence and iodine-transparency problems as other single-ingredient sea moss gels. No autofail.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "seamoss-gel",
      "title": "Seamoss Gel",
      "vendor": "Tailor Made Herbal Products",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/lemon-seamoss-gel-16-ozlemon-seamoss-gel-16-ozlemon-seamoss-gel-16-oztailor-made-seamosstailor-made-herbal-products771400850035053171-823619.jpg?v=1787585458",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "seamoss",
        "gel",
        "tailor",
        "made",
        "herbal",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 42,
        "manufacturing": 40,
        "safety": 48,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804145373381",
      "vsf_explanation": "Generic sea moss gel from a small herbal-products vendor. Title is neutral — no explicit medical claim triggers autofail. Formulation and evidence follow the category ceiling: no RCT support for the outcomes sea moss is marketed for, iodine content undisclosed, no COA, minimal brand transparency. Tailor Made Herbal Products publishes no cGMP or third-party testing that would offset the category weaknesses.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gold-sea-moss-gel-wildcrafted-sea-moss",
      "title": "Gold Sea Moss Gel | Wildcrafted Sea Moss",
      "vendor": "Organic Goddess Sea Moss Gel",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/gps_generated_7971e999-d790-4122-a921-d0e32fabefe6.png?v=1787585470",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gold",
        "sea",
        "moss",
        "gel",
        "wildcrafted",
        "sea",
        "moss",
        "organic",
        "goddess",
        "sea",
        "moss",
        "gel"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 40,
        "sustainability": 55
      },
      "price": 29.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804145504453",
      "vsf_explanation": "Single-ingredient wildcrafted sea moss gel with no ancillary blend. Because the product avoids specific benefit claims in the title, no autofail fires — but the underlying rubric problem remains: sea moss itself has no controlled human trial supporting the outcomes it is popularly marketed for. Wildcrafted sourcing is honest but also means iodine and heavy-metal content vary batch-to-batch and no assay is published. Gets a small sustainability credit for minimal processing and glass-jar format typical of this vendor category.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "maca-mango-ashwagandha-sea-moss-gel-16oz-organic-wildcrafted-irish-seaweed-superfood",
      "title": "Maca, Mango & Ashwagandha Sea Moss Gel – 16oz | Organic Wildcrafted Irish Seaweed Superfood",
      "vendor": "Seamoss depot",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/image_c3bf11fe-1049-4da2-9e34-1620c309b615.jpg?v=1787585476",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive",
        "energy",
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "maca",
        "mango",
        "ashwagandha",
        "sea",
        "moss",
        "gel",
        "16oz",
        "organic",
        "wildcrafted",
        "irish",
        "seaweed",
        "superfood",
        "seamoss",
        "depot"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804145635525",
      "vsf_explanation": "Sea moss gel base (no clinical evidence) with maca (thin adaptogen and libido evidence, dose-dependent), mango (flavor / vitamin C only), and ashwagandha (real evidence at 300–600 mg/day KSM-66 or Sensoril). Because it is delivered in a 16 oz gel with unspecified per-serving milligrams, no ingredient can be assumed to hit its studied dose — a teaspoon of a 16 oz gel would contain fractions of a milligram of ashwagandha per serving. 'Wildcrafted' sourcing has authenticity appeal but also raises heavy-metal and iodine-variability concerns that the brand does not address with third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sea-moss-supreme-21-in-1-organic-black-seed-elderberry-adaptogen-blend",
      "title": "Sea Moss Supreme – 21-in-1 Organic Black Seed, Elderberry & Adaptogen Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Seamoss_Supreme.webp?v=1787585480",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sea",
        "moss",
        "supreme",
        "organic",
        "black",
        "seed",
        "elderberry",
        "adaptogen",
        "blend",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 25,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 30,
        "sustainability": 50
      },
      "price": 31.67,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804145733829",
      "vsf_explanation": "A '21-in-1' formula is definitionally a proprietary blend: fitting 21 ingredients into a single capsule at any evidence-based dose is mathematically impossible. Even if the largest ingredient (sea moss) were dosed at 500 mg, the remaining 20 would average well below any RCT-supported threshold. Black seed (Nigella sativa) has some legitimate cardiometabolic RCT evidence at 500–2,000 mg/day and elderberry has modest cold-duration evidence at ~600 mg extract — neither can be delivered meaningfully within a 21-way split. Autofail: proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "mixed-berry-sea-moss-gel-natural-immunity-boost-energy-support",
      "title": "Mixed Berry Sea Moss Gel | Natural Immunity Boost & Energy Support",
      "vendor": "Seamoss depot",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/IMG-2266.jpg?v=1787585486",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mixed",
        "berry",
        "sea",
        "moss",
        "gel",
        "natural",
        "immunity",
        "boost",
        "energy",
        "support",
        "seamoss",
        "depot"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 35,
        "sustainability": 50
      },
      "price": 30,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804145766597",
      "vsf_explanation": "Autofailed for unverified medical claim: the product title itself states 'Natural Immunity Boost & Energy Support,' which is a specific benefit claim that no randomized controlled trial on sea moss has substantiated. Sea moss gels are also perishable, iodine-variable, and typically undosed — this SKU discloses no iodine per serving, no CFU count for any 'probiotic' claim, and no COA. Berry flavoring is inert to the evidence question. The autofail keeps the product off Vyvata regardless of other dimensions.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-irish-sea-moss-organic-bladderwrack-organic-burdock-bioperine-capsules",
      "title": "Organic Irish Sea Moss, Organic Bladderwrack, Organic Burdock & Bioperine capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HelloHealth-PremiumSeaMoss-BOTTLEFRONT.webp?v=1787585497",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "irish",
        "sea",
        "moss",
        "organic",
        "bladderwrack",
        "organic",
        "burdock",
        "bioperine",
        "capsules",
        "hellohealth"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 48,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 17.76,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804145963205",
      "vsf_explanation": "Same Sebi-style triad (sea moss + bladderwrack + burdock) with BioPerine (piperine from black pepper) added, ostensibly to improve absorption. BioPerine has documented bioavailability enhancement for curcumin and some polyphenols, but no data suggest it meaningfully increases uptake of the seaweed minerals or algal polysaccharides in this formula. Adding BioPerine to a formula whose actives lack any human clinical evidence does not create clinical evidence. All other rubric weaknesses — undisclosed iodine load, no COA, no potency assay, no cGMP evidence — carry over unchanged. Formulation gets a small credit over the non-BioPerine SKU only because the brand at least discloses a rationale for the addition.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnesium-glycinate-drops",
      "title": "Magnesium Glycinate drops",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HelloHealth-2ozMagnesiumGlycinateDrops-DROPPERFRONTSMALL_96fca265-e0b0-4d2c-ac26-aaed2cf5d5c2.webp?v=1787585533",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "glycinate",
        "drops",
        "hellohealth"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients",
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 17.76,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804146749637",
      "vsf_explanation": "Liquid magnesium glycinate drops offer dose-titration flexibility that capsules do not — useful for pediatric users, those with pill fatigue, or people who need very small incremental doses. Elemental-magnesium concentration per drop or per mL is the critical transparency question, since liquid formats often disclose 'per serving' at deceptive serving sizes. Bioavailability is similar to encapsulated glycinate. Flavoring, sweeteners, and preservatives are additional label considerations for a liquid product. Would move to Verified 70+ with clear per-drop or per-mL elemental Mg disclosure, minimal additive load, and third-party assay.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "happy-calm-magnesium-glycinate-capsules",
      "title": "Happy Calm Magnesium Glycinate capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HelloHealth-HappyCalmMagnesium-BOTTLEFRONT.png?v=1787585535",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "happy",
        "calm",
        "magnesium",
        "glycinate",
        "capsules",
        "hellohealth"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental",
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 70,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 17.76,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804146847941",
      "vsf_explanation": "Magnesium glycinate is the best-tolerated and highest-absorption form of magnesium for sleep, anxiety, and muscle-relaxation applications — the glycine amine acts as a mild GABA-A agonist itself, compounding the calming effect (Bannai 2012 for glycine sleep architecture). Adult RDA is 320-420 mg elemental Mg, and typical bioavailable magnesium-deficiency-repletion protocols use 200-400 mg elemental Mg from glycinate. Product quality depends on elemental mg disclosure vs total-compound-weight labeling (a common transparency trap where '500 mg magnesium glycinate' actually contains ~50 mg elemental magnesium). Would move to Verified 75+ with clear elemental-magnesium mg disclosure on-label and third-party bioavailability documentation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "comprehensive-womens-panel-including-hormones",
      "title": "Comprehensive Women's Panel Including Hormones",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/womens-comprehensive.jpg?v=1787585542",
      "score": 67,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "comprehensive",
        "women",
        "panel",
        "including",
        "hormones",
        "hellohealth"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "blood_panel_metabolic",
        "hormone_fertility_testing"
      ],
      "vsf_dimensions": {
        "analytical_validity": 72,
        "clinical_utility": 75,
        "transparency": 60,
        "results_delivery": 62,
        "privacy_data": 62,
        "value": 65
      },
      "price": 437,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804146913477",
      "vsf_explanation": "Comprehensive women's health workup — CBC, CMP, lipid panel, HbA1c, thyroid (TSH, free T4, free T3), and the female hormone panel (estradiol, progesterone, FSH, LH, testosterone, DHEA-S, prolactin). Legitimate comprehensive annual-physical-equivalent. Analytical validity high across the board. Cycle-day timing for hormones is critical for interpretation and hellohealth's cycle-timing guidance is not clearly disclosed. Thyroid should ideally include TPO antibodies to screen for Hashimoto's, which is not clearly stated as included. Would move to Verified 70+ with itemized panel confirming TPO antibody inclusion, cycle-day timing guidance, named lab, and physician consult.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "female-fertility-ovarian-reserve-test",
      "title": "Female Fertility & Ovarian Reserve Test",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/FemaleFertility_OvarianReserveTest.jpg?v=1787585549",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "female",
        "fertility",
        "ovarian",
        "reserve",
        "test",
        "hellohealth"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "hormone_fertility_testing"
      ],
      "vsf_dimensions": {
        "analytical_validity": 72,
        "clinical_utility": 75,
        "transparency": 60,
        "results_delivery": 62,
        "privacy_data": 62,
        "value": 65
      },
      "price": 155,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804147011781",
      "vsf_explanation": "Ovarian reserve assessment via AMH (anti-Müllerian hormone), FSH, and estradiol, typically also LH and inhibin B. AMH in particular is the modern gold-standard ovarian reserve marker — it can be drawn any cycle day (unlike FSH which requires day-3 timing) and is not affected by hormonal contraception. This is a genuinely high-utility fertility-planning test used by reproductive endocrinologists and IVF clinics as a baseline. Analytical validity of AMH assays is well-established but methodologies differ (Beckman Access vs Roche Elecsys), which affects reference ranges — the specific assay is not disclosed. Highly actionable for fertility planning decisions. Would move to Verified 75+ with AMH assay methodology disclosure, named lab, and fertility-specialist consult add-on.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "15-in-1-pre-probiotics-d3-methylfolate-capsules-belly-great",
      "title": "15-in-1 Pre-Probiotics + D3 + Methylfolate capsules - Belly Great",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/B.webp?v=1787585565",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pre",
        "probiotics",
        "methylfolate",
        "capsules",
        "belly",
        "great",
        "hellohealth"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive",
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 30,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 25,
        "sustainability": 50
      },
      "price": 22.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804147372229",
      "vsf_explanation": "'15-in-1' with probiotics, prebiotics, vitamin D3, and methylfolate mashed into one capsule is a red-flag formulation pattern — meaningful probiotic dosing requires 10-50 billion CFU per serving of specific strains, methylfolate requires 400-1,000 mcg, and prebiotic fiber requires several grams (impossible in a cap). Fitting 15 ingredients in one dose forces sub-therapeutic amounts across the board, and per-strain CFU disclosure with genus/species/strain designations is essentially never possible in this format. The 'Belly Great' naming implies GI-outcome claims without RCT evidence for the specific 15-ingredient combination. Autofailed under proprietary_blend_hides_dose. Would need full per-actives disclosure with CFU per strain and prebiotic gram counts to be reconsidered; more likely honest re-formulation into a single-mechanism SKU would produce a better product.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "immune-function-igg-igm-ige-iga",
      "title": "Immune Function (IgG, IgM, IgE, IgA)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/immune-function.jpg?v=1787585563",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "immune",
        "function",
        "igg",
        "igm",
        "ige",
        "iga",
        "hellohealth"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "blood_panel_metabolic"
      ],
      "vsf_dimensions": {
        "analytical_validity": 72,
        "clinical_utility": 60,
        "transparency": 58,
        "results_delivery": 60,
        "privacy_data": 62,
        "value": 58
      },
      "price": 99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804147404997",
      "vsf_explanation": "Total serum immunoglobulin panel (IgG, IgM, IgE, IgA) — a standard clinical assay used to screen for common variable immunodeficiency, IgA deficiency, and hyper-IgE syndromes. Analytical validity is high (well-established nephelometry assays at any CLIA lab). Clinical utility is context-specific: in immunology or recurrent-infection workups this panel is genuinely important, but as a routine wellness screen for asymptomatic individuals it produces few actionable results. Elevated total IgE can flag atopic disease or parasitic infection; low IgA is the most common primary immunodeficiency. Processing lab not disclosed. Would move to Verified 70+ with lab disclosure and clinical-context guidance on when this panel is actually indicated.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "food-allergy-profile",
      "title": "Food Allergy Profile",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/food-allergy.jpg?v=1787585568",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "food",
        "allergy",
        "profile",
        "hellohealth"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "food_sensitivity_allergy"
      ],
      "vsf_dimensions": {
        "analytical_validity": 68,
        "clinical_utility": 65,
        "transparency": 58,
        "results_delivery": 60,
        "privacy_data": 62,
        "value": 60
      },
      "price": 234.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804147503301",
      "vsf_explanation": "'Food Allergy Profile' framing suggests IgE-based testing (which is the actual allergy assay recognized by the American Academy of Allergy, Asthma & Immunology) rather than IgG-based 'food sensitivity' panels (which AAAAI and multiple consensus statements explicitly reject as clinically invalid). If IgE-based, the test is legitimate but produces high false-positive rates — many people have detectable IgE to foods they eat without symptoms, so a positive result requires clinical correlation with actual allergic symptoms. The testing methodology is not explicitly disclosed on the product page — the difference between IgE (valid) and IgG (invalid) is a critical transparency issue. Would need explicit IgE-only methodology confirmation to move higher, and would score much lower if IgG-based.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "viral-infections",
      "title": "Viral Infections",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/viral.jpg?v=1787585575",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "viral",
        "infections",
        "hellohealth"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "sti_infectious_disease"
      ],
      "vsf_dimensions": {
        "analytical_validity": 78,
        "clinical_utility": 82,
        "transparency": 60,
        "results_delivery": 62,
        "privacy_data": 55,
        "value": 65
      },
      "price": 412,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804147536069",
      "vsf_explanation": "STI/viral serology panel — typically HIV 1/2 antibody-antigen, hepatitis B (HBsAg, HBsAb, HBcAb), hepatitis C antibody, HSV-1 and HSV-2 IgG, and often syphilis (RPR/TPPA). These are among the most rigorously validated clinical assays in medicine — HIV 4th-generation Ag/Ab combos have sensitivity/specificity above 99.5%. Clinical utility is extremely high — STI screening is genuinely life-saving public health work with clear treatment pathways for anything that turns up. HSV-2 IgG testing is the one component with meaningful interpretation controversy (CDC does not recommend routine screening due to false-positive rate in low-prevalence populations). Privacy dimension is scored lower because STI results are particularly sensitive and hellohealth does not spell out its handling protocols in detail. Would move to Verified 75+ with clear STI-result privacy protocols, HIV confirmation-testing guidance, and named CLIA lab.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "comprehensive-mens-panel-including-hormones",
      "title": "Comprehensive Mens Panel Including Hormones",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/mens-comprehensive.jpg?v=1787585581",
      "score": 67,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "comprehensive",
        "mens",
        "panel",
        "including",
        "hormones",
        "hellohealth"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "blood_panel_metabolic",
        "hormone_fertility_testing"
      ],
      "vsf_dimensions": {
        "analytical_validity": 72,
        "clinical_utility": 75,
        "transparency": 60,
        "results_delivery": 62,
        "privacy_data": 62,
        "value": 65
      },
      "price": 429,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804147601605",
      "vsf_explanation": "Full men's health workup — CBC, CMP, lipid panel, HbA1c, thyroid (TSH, free T4), and the male hormone panel (total/free testosterone, SHBG, LH, FSH, estradiol, PSA depending on age). This is a legitimate comprehensive annual-physical-equivalent that any primary care physician would order. Analytical validity is high — these are all standard, well-validated assays. Actionability is strong across the board. hellohealth's transparency issue on lab disclosure remains, and morning-fasted-draw guidance for accurate testosterone is critical but not clearly stated. Would move to Verified 70+ with named lab, morning-draw guidance, and included physician consult for interpretation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "comprehensive-inflammation-panel",
      "title": "Comprehensive Inflammation Panel",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/comprehensive-inflammation.jpg?v=1787585588",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "comprehensive",
        "inflammation",
        "panel",
        "hellohealth"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "blood_panel_metabolic"
      ],
      "vsf_dimensions": {
        "analytical_validity": 72,
        "clinical_utility": 72,
        "transparency": 60,
        "results_delivery": 62,
        "privacy_data": 62,
        "value": 60
      },
      "price": 97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804147667141",
      "vsf_explanation": "Inflammation panel — typically hs-CRP, ESR, homocysteine, fibrinogen, and sometimes ferritin (which is an acute-phase reactant as well as an iron marker). All standard CLIA-lab assays with clear reference ranges. hs-CRP in particular has robust evidence as an independent cardiovascular risk marker (Ridker JUPITER trial, Everett 2020). Homocysteine is directly actionable via B-vitamin repletion. Panel is genuinely useful — the interpretation gap is that isolated 'inflammation' as a diagnostic entity is nonspecific, and mildly elevated markers require clinical context (recent infection, stress, obesity all elevate CRP). Would move to Verified 70+ with named lab and interpretation guidance beyond raw numbers.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hormones-womens-only-panel",
      "title": "Hormones Womens Only Panel",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/hormones-womens.jpg?v=1787585592",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hormones",
        "womens",
        "only",
        "panel",
        "hellohealth"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "hormone_fertility_testing"
      ],
      "vsf_dimensions": {
        "analytical_validity": 72,
        "clinical_utility": 72,
        "transparency": 58,
        "results_delivery": 62,
        "privacy_data": 62,
        "value": 65
      },
      "price": 123,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804147798213",
      "vsf_explanation": "Standard female hormone panel — estradiol, progesterone, FSH, LH, TSH/free T4, testosterone, DHEA-S, and typically prolactin. Well-validated clinical assays at any CLIA lab, highly actionable for evaluating perimenopause, PCOS, hypothyroidism, or menstrual irregularities. Cycle-day timing is critical for interpretation (estradiol/progesterone/LH/FSH values differ dramatically between follicular and luteal phase) and hellohealth's cycle-day guidance is not clearly disclosed on the product page. Processing lab also not disclosed. Would move to Verified 70+ with explicit cycle-day collection guidance and named lab.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mthfr-saliva",
      "title": "MTHFR - Saliva",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/mthfr_saliva_1.png?v=1787585600",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mthfr",
        "saliva",
        "hellohealth"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "genetic_dna"
      ],
      "vsf_dimensions": {
        "analytical_validity": 70,
        "clinical_utility": 50,
        "transparency": 55,
        "results_delivery": 60,
        "privacy_data": 58,
        "value": 62
      },
      "price": 236,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804148060357",
      "vsf_explanation": "Single-gene MTHFR variant test (C677T and A1298C) via saliva sample. The genotyping itself is analytically reliable — MTHFR SNPs are well-characterized and PCR-based detection is highly accurate at any CLIA molecular lab. The problem is clinical utility: the American College of Medical Genetics (ACMG) has published explicit guidance recommending against routine MTHFR testing due to lack of clinical actionability outside of specific contexts (recurrent pregnancy loss, elevated homocysteine workup). Popular in functional medicine but not evidence-based for the way it's usually interpreted. Homocysteine (a blood test) is a more direct and actionable marker of methylation status. Processing lab not disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "k2-d3-5000-60-capsules",
      "title": "K2-D3 5000 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d3-5000-front.webp?v=1787585606",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "5000",
        "capsules",
        "hellohealth"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients",
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 70,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 36.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804148289733",
      "vsf_explanation": "The D3+K2 combination is one of the best-evidenced micronutrient pairings — vitamin D3 for calcium absorption and immune modulation (LeBoff 2022 VITAL bone analysis, Martineau 2017 D3 respiratory infection meta), and K2 (MK-7 form) to direct calcium into bone rather than arterial soft-tissue (Knapen 2013 3-year osteocalcin trial). 5,000 IU D3 is a therapeutic dose appropriate for many deficient adults but excessive for repletion once serum 25(OH)D is optimized — labeling should ideally recommend baseline testing. K2 form (MK-4 vs MK-7) and mcg dose are the transparency question — MK-7 at 90-180 mcg is the well-studied form. Would move to Verified 75+ with MK-7 specification, mcg disclosure, and serum-monitoring guidance for the 5,000 IU D3 dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "complete-multivitamin-capsules",
      "title": "Complete Multivitamin capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HelloHealth-CompleteMultivitamin-BOTTLEFRONT_png.png?v=1787585646",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "complete",
        "multivitamin",
        "capsules",
        "hellohealth"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 48.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804148584645",
      "vsf_explanation": "General multivitamins have modest but real evidence in specific contexts — VITAL trial (Manson 2019) showed no cardiovascular benefit but a small cognitive-decline reduction in the COSMOS-Mind analysis (Baker 2023). A 'complete' multivitamin's real quality question is form choices (methylfolate vs folic acid, methylcobalamin vs cyanocobalamin, K2-MK7 vs K1) and dose calibration (avoiding excess iron in men, appropriate D3). Without seeing the full spec panel, this scores as an average mainstream multi. Would move to Verified 70+ with methylated B-vitamin disclosure, iron-free (or male/female-differentiated) formula options, and third-party testing certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "plant-based-nausea-support",
      "title": "Plant-based Nausea Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HelloHealth-Prenatal-BOTTLEFRONTSMALL.webp?v=1787585650",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "plant",
        "based",
        "nausea",
        "support",
        "hellohealth"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 52,
        "sustainability": 58
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804148617413",
      "vsf_explanation": "Ginger is one of the best-evidenced natural anti-emetics — Cochrane reviews support use in pregnancy-related nausea (Matthews 2015) and chemotherapy-induced nausea (Ryan 2012) at 1-1.5 g/day of standardized ginger extract. If this SKU is ginger-based (as suggested by 'plant-based nausea support' positioning), the underlying evidence is strong. Score depends on which specific botanicals are included and at what dose — the title does not disclose ingredients or milligrams, which is a real transparency gap. Would move to Verified 70+ with explicit ginger content disclosure, gingerol/shogaol standardization, and per-serving mg specification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "stress-relief-with-vitality-ashwagandha-ginger",
      "title": "Stress Relief with Vitality (Ashwagandha + Ginger)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HelloHealth-Ashwagandha-BOTTLEFRONTSMALL.webp?v=1787585655",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "stress",
        "relief",
        "with",
        "vitality",
        "ashwagandha",
        "ginger",
        "hellohealth"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental",
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804148748485",
      "vsf_explanation": "Ashwagandha (Withania somnifera) has legitimate meta-analytic evidence for cortisol reduction and perceived-stress scale improvement at 300-600 mg/day of KSM-66 or Sensoril-branded root extract (Chandrasekhar 2012, Lopresti 2019). Ginger's anti-inflammatory and mild adaptogenic properties are a coherent add-on. The formulation logic works if doses are adequate. Product does not disclose whether ashwagandha is KSM-66, Sensoril, or generic; per-ingredient mg is not visible in title. Ginger content and standardization to gingerols is also unclear. Would move to Verified 70+ with branded ashwagandha extract (KSM-66/Sensoril), 600 mg full daily dose disclosure, and ginger standardization to gingerols.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "happy-energy-vitamin-b12-plus-b12-complex-with-b2-b3-b5-b6-for-energy-focus-mood-support",
      "title": "Happy Energy Vitamin B12 Plus – B12 Complex with B2, B3, B5 & B6 for Energy, Focus & Mood Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4000.webp?v=1787585667",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "happy",
        "energy",
        "vitamin",
        "b12",
        "plus",
        "b12",
        "complex",
        "with",
        "for",
        "energy",
        "focus",
        "mood",
        "support",
        "hellohealth"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients",
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804148814021",
      "vsf_explanation": "B12 combined with B2, B3, B5, and B6 is a defensible energy-metabolism formulation — these B-vitamins are enzymatic cofactors for mitochondrial substrate handling, and deficiency in any of them produces measurable fatigue/mood symptoms (particularly B12 deficiency in older adults and vegans). Product quality depends on B12 form (methylcobalamin > cyanocobalamin for MTHFR carriers) and per-vitamin mg disclosure. Naming does not disclose whether B12 is methylated or the specific doses. 'Energy, Focus & Mood Support' is legitimate structure-function language when framed correctly. Would move to Verified 70+ with methylated B-vitamin forms (methyl-B12, P5P B6, methylfolate) disclosed at-label and per-vitamin mg specification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "comprehensive-gut-tests",
      "title": "Comprehensive Gut Tests",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/comprehensive-gut-at-home-lab-test.jpg?v=1787585674",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "comprehensive",
        "gut",
        "tests",
        "hellohealth"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "gut_microbiome_testing"
      ],
      "vsf_dimensions": {
        "analytical_validity": 60,
        "clinical_utility": 55,
        "transparency": 55,
        "results_delivery": 60,
        "privacy_data": 60,
        "value": 58
      },
      "price": 1371,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804148879557",
      "vsf_explanation": "Microbiome and stool testing is one of the most heterogeneous DTC categories — the underlying method (16S rRNA sequencing vs shotgun metagenomics vs qPCR-based multiplex like GI-MAP) matters enormously, and hellohealth does not disclose which methodology or which processing lab is used. Clinical actionability of most microbiome results is limited — while the field has strong research evidence, individual-level 'your Bacteroides is low, take probiotic X' recommendations are not well supported by RCT evidence. Comprehensive stool panels that include calprotectin, elastase, and pathogens (parasites, C. diff toxin, H. pylori) have real clinical utility for GI workups. Would need methodology disclosure to score higher. Standard tier reflects legitimate research foundation but weak individual-level actionability.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "complete-hello-health-brain-neurodiversity",
      "title": "Complete Hello Health Brain/ Neurodiversity",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/complete-brain-nurodiversity.jpg?v=1787585678",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "complete",
        "hello",
        "health",
        "brain",
        "neurodiversity",
        "hellohealth"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics",
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 50,
        "safety": 50,
        "transparency": 25,
        "sustainability": 50
      },
      "price": 1734,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804148977861",
      "vsf_explanation": "Naming a supplement 'Brain/Neurodiversity' invokes a diagnostic identity (neurodivergence — autism, ADHD, dyslexia) as if the product treats or supports the condition. No oral supplement has FDA approval for autism or ADHD, and using 'neurodiversity' as a product target is a soft disease claim that misleads a vulnerable audience. Combined with the 'Complete' proprietary-blend structure typical of the hellohealth line, both autofail triggers apply. Autofailed under unverified_medical_claim (neurodiversity-as-target). Would require rebranding away from neurodiversity language, per-actives disclosure, and honest cognitive-support positioning to be reconsidered.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "organic-irish-sea-moss-organic-bladderwrack-organic-burdock-capsules",
      "title": "Organic Irish Sea Moss, Organic Bladderwrack, & Organic Burdock capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HelloHealth-SeaMoss-BOTTLEFRONT.png?v=1787585687",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "irish",
        "sea",
        "moss",
        "organic",
        "bladderwrack",
        "organic",
        "burdock",
        "capsules",
        "hellohealth"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 17.76,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804149076165",
      "vsf_explanation": "The Sebi-style sea moss + bladderwrack + burdock 'Dr. Sebi triad' has no controlled human trial support for any of the health outcomes it is marketed for. Irish sea moss (Chondrus crispus) does contribute iodine, but that is a caution (potential thyroid overdose) rather than a benefit, and the frequently repeated '92 of 102 minerals' claim is biologically nonsense. Bladderwrack adds more iodine plus theoretical thyroid-hormone activity that is not clinically established. Burdock has traditional-medicine credibility but no RCTs supporting the immunity/detox claims typically stacked with this combo. hellohealth is a low-signal DTC brand with no visible COA, no cGMP disclosure, and no potency assay for the combined iodine load. Would need per-lot iodine content on label plus published human evidence at these doses to move above Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "9-in-1-immune-support-natural-detox-capsules",
      "title": "9-in-1 Immune Support Natural & Detox capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NEW_BOTTLE_01_97a27e94-8259-4abe-8f03-b16c135a8fda.png?v=1787585690",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "immune",
        "support",
        "natural",
        "detox",
        "capsules",
        "hellohealth"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants",
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 30,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 25,
        "sustainability": 50
      },
      "price": 17.76,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804149174469",
      "vsf_explanation": "The '9-in-1' proprietary blend structure hides per-ingredient dose, and the 'natural detox' claim invokes a medical concept ('detoxification') that has no defensible clinical meaning outside of hepatic drug metabolism or heavy-metal chelation — neither of which this product can perform. Combined 9-ingredient blends also mathematically under-dose each active. Autofailed under both proprietary_blend_hides_dose and unverified_medical_claim (detox). Would need per-ingredient mg disclosure and complete removal of 'detox' framing to be considered in Standard tier — at which point it would probably still fail on dose adequacy.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "willow-herb-fireweed",
      "title": "Willow Herb Fireweed",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HelloHealth-Fireweed-BOTTLEFRONTSMALL.webp?v=1787585696",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "willow",
        "herb",
        "fireweed",
        "hellohealth"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health",
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 45,
        "sustainability": 58
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804149305541",
      "vsf_explanation": "Willow herb / fireweed (Epilobium angustifolium and E. parviflorum) is traditionally used in European and Russian folk medicine for benign prostatic hyperplasia (BPH) and has preclinical evidence for 5-alpha-reductase inhibition (Vitalone 2003) driven by oenothein B. Human RCT evidence for prostate outcomes is essentially absent — much thinner than pygeum, saw palmetto, or beta-sitosterol. Standardization to oenothein B % is not disclosed, and no dose specification is visible. Product is not autofailed because no explicit disease claim is visible in the title, but the evidence-and-dose gap holds it below Standard. Would move to Standard 60+ with oenothein B standardization, dose disclosure, and honest 'traditional use, limited RCT data' framing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hello-health-heart-45-min-lab-consult",
      "title": "Hello Health Heart + 45 Min Lab Consult",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/heart-lab-consult-home-testing-kit.jpg?v=1787585700",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hello",
        "health",
        "heart",
        "min",
        "lab",
        "consult",
        "hellohealth"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "blood_panel_metabolic"
      ],
      "vsf_dimensions": {
        "analytical_validity": 72,
        "clinical_utility": 78,
        "transparency": 60,
        "results_delivery": 72,
        "privacy_data": 62,
        "value": 65
      },
      "price": 897,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804149371077",
      "vsf_explanation": "A cardiovascular risk panel — likely standard lipid panel plus hs-CRP, homocysteine, and hopefully ApoB and Lp(a), though the exact panel composition is not itemized on the product page — bundled with a 45-minute consult. Modern lipidology has moved toward ApoB and Lp(a) as more precise cardiovascular risk markers than LDL-C alone (Sniderman 2019, Willeit 2018 Lp(a) meta-analysis), and if this panel includes both it is genuinely useful. The consult is the highest-value component for interpreting these results against Framingham/ASCVD risk scores. Would move to Verified 75+ with itemized panel confirming ApoB and Lp(a) inclusion, named processing lab, and MD/cardiologist consult credentialing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hormones-45-min-consult",
      "title": "Hormones + 45 Min Consult",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/hormone-home-lab-test-kit.jpg?v=1787585706",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hormones",
        "min",
        "consult",
        "hellohealth"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "hormone_fertility_testing"
      ],
      "vsf_dimensions": {
        "analytical_validity": 72,
        "clinical_utility": 75,
        "transparency": 60,
        "results_delivery": 72,
        "privacy_data": 62,
        "value": 65
      },
      "price": 768,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804149469381",
      "vsf_explanation": "Standard hormone panel bundled with a 45-minute practitioner consult, which is the meaningful upgrade over the plain hormone panel — interpretation is where DTC testing usually falls short, and having a live clinician walk through the results, contextualize against symptoms, and recommend next steps significantly increases clinical actionability. The underlying assays are standard CLIA-lab work; hellohealth's transparency issues on processing lab remain. Consult qualifications (MD vs NP vs functional-medicine practitioner) are not disclosed on the product page and materially affect the value of the interpretation. Would move to Verified 75+ with clear consult credentialing (MD/DO/NP) and named lab.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hormones-mens-only-panel",
      "title": "Hormones Mens Only Panel",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/hormones-mens.jpg?v=1787585713",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hormones",
        "mens",
        "only",
        "panel",
        "hellohealth"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "hormone_fertility_testing"
      ],
      "vsf_dimensions": {
        "analytical_validity": 72,
        "clinical_utility": 72,
        "transparency": 58,
        "results_delivery": 62,
        "privacy_data": 62,
        "value": 65
      },
      "price": 115,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804149534917",
      "vsf_explanation": "Standard male hormone panel — total and free testosterone, SHBG, LH, FSH, estradiol, and typically prolactin. All are well-validated clinical assays with clear reference ranges at any CLIA lab. Highly actionable for evaluating low testosterone symptoms, secondary vs primary hypogonadism, or estradiol dominance. Free testosterone by equilibrium dialysis vs calculated from SHBG makes a real difference for accuracy but the specific methodology is not disclosed. Testosterone should be drawn fasting between 7-10 AM per Endocrine Society guidelines and this collection guidance is not clearly stated on the product page. Would move to Verified 70+ with disclosed free-testosterone methodology, morning-draw guidance, and named processing lab.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-mineral-tests-for-b12-magnesium-iron-and-methylfolate",
      "title": "Vitamin/Mineral Tests for B12, Magnesium, Iron and Methylfolate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/vitamin-mineral.jpg?v=1787585721",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "mineral",
        "tests",
        "for",
        "b12",
        "magnesium",
        "iron",
        "and",
        "methylfolate",
        "hellohealth"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "nutrient_deficiency_testing"
      ],
      "vsf_dimensions": {
        "analytical_validity": 72,
        "clinical_utility": 78,
        "transparency": 60,
        "results_delivery": 65,
        "privacy_data": 65,
        "value": 65
      },
      "price": 116,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804149633221",
      "vsf_explanation": "This is the highest-utility hellohealth panel in the batch — serum B12, magnesium (ideally RBC magnesium, though the assay type is not disclosed), iron studies (ferritin/TIBC/transferrin saturation), and methylfolate (5-MTHF or serum folate). All four are well-validated clinical assays run reliably at any CLIA lab, and results are highly actionable because each deficiency has clear evidence-based repletion protocols. Clinical utility is genuinely strong. The only real drawback is the standard hellohealth transparency issue: the processing lab is not clearly disclosed and the specific magnesium assay type (serum vs RBC) makes a real difference — serum magnesium is a poor marker of tissue status. Would move to Verified 75+ with lab disclosure, explicit assay methodology (particularly RBC magnesium), and physician-consult add-on.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "precision-nutrition-test",
      "title": "Precision Nutrition Test",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/precision_nutrition.png?v=1787585726",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "precision",
        "nutrition",
        "test",
        "hellohealth"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "nutrient_deficiency_testing",
        "genetic_dna"
      ],
      "vsf_dimensions": {
        "analytical_validity": 60,
        "clinical_utility": 50,
        "transparency": 52,
        "results_delivery": 58,
        "privacy_data": 58,
        "value": 55
      },
      "price": 399,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804149665989",
      "vsf_explanation": "Nutrigenomic testing looking at gene variants purported to influence nutrient metabolism, macronutrient response, and dietary sensitivities. Analytical validity of the underlying genotyping is decent (CLIA-certified PCR is reliable for called variants), but the clinical-utility literature is weak — most single-SNP nutrigenomic claims have not survived independent replication, and consensus statements from academic nutrition societies caution against acting on this class of testing. Effect sizes for reported variants (FTO for weight response, TCF7L2 for carbohydrate handling) are small at the individual level. Actual serum-based nutrient testing (B12, ferritin, 25-OH-D, RBC magnesium) is far more actionable than genetic predictions. Processing lab not disclosed. Would need explicit disclosure that recommendations are hypothesis-generating, not clinical.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "precision-medication-test",
      "title": "Precision Medication Test",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/precision_medication.png?v=1787585731",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "precision",
        "medication",
        "test",
        "hellohealth"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "genetic_dna"
      ],
      "vsf_dimensions": {
        "analytical_validity": 68,
        "clinical_utility": 65,
        "transparency": 55,
        "results_delivery": 62,
        "privacy_data": 58,
        "value": 62
      },
      "price": 399,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804149764293",
      "vsf_explanation": "A pharmacogenomic (PGx) panel testing common CYP450 variants (CYP2D6, CYP2C19, CYP3A4, CYP2C9) plus a handful of other drug-metabolism genes. Analytical accuracy for well-characterized PGx variants is solid at any CLIA-certified molecular lab. Clinical utility is real for a subset of drugs — CPIC has published dosing guidelines for antidepressants (SSRIs), clopidogrel, warfarin, opioids, and others where CYP2C19 or CYP2D6 status meaningfully affects response. That is the strongest DTC genetic-testing use case. Where hellohealth loses points is transparency — the processing lab is not disclosed and the specific variant panel is not itemized. Would move to Verified 70+ with CPIC-aligned interpretation, itemized variant coverage, and clearly named CAP-accredited lab.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "methylation-screening-test",
      "title": "Methylation Screening Test",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MethylationScreeningTest.jpg?v=1787585739",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "methylation",
        "screening",
        "test",
        "hellohealth"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "genetic_dna"
      ],
      "vsf_dimensions": {
        "analytical_validity": 65,
        "clinical_utility": 52,
        "transparency": 55,
        "results_delivery": 60,
        "privacy_data": 58,
        "value": 60
      },
      "price": 125,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804149862597",
      "vsf_explanation": "A methylation-pathway genetic panel (typically MTHFR C677T/A1298C, COMT, MTR, MTRR, CBS variants) using standard PCR that any CLIA-certified molecular lab can run reliably. Analytical accuracy of the genotyping itself is high — the underlying assay technology is well-validated for these single-nucleotide polymorphisms. The clinical utility problem is severe: the American College of Medical Genetics (ACMG) explicitly recommends against routine MTHFR testing, and mainstream genetics does not support methylation-panel results driving supplement or health decisions. Popular in functional-medicine circles but not evidence-based for the interpretations most vendors provide. Processing lab is not clearly disclosed. Would need explicit ACMG-aligned interpretation guidance and lab disclosure to move higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-oregano-infused-oil-liquid-drops",
      "title": "Organic Oregano Infused Oil Liquid Drops",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HelloHealth-Oregano-DROPPERFRONTLARGE.webp?v=1787585748",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "oregano",
        "infused",
        "oil",
        "liquid",
        "drops",
        "hellohealth"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants",
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 52,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 50,
        "sustainability": 58
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804150091973",
      "vsf_explanation": "Oregano oil's antimicrobial activity is well-documented in vitro from its carvacrol and thymol content (Force 2000 for enteric parasites, Preuss 2005 for Candida). Human clinical evidence is limited to small trials. 'Infused oil' terminology is the concern here — a genuine oil of oregano is a steam-distilled essential oil standardized to 70-80% carvacrol, while an 'infusion' is a much weaker carrier-oil soak that dilutes carvacrol dramatically. Without carvacrol % on-label, buyers cannot know which category applies. Organic sourcing is a modest quality positive. Would move to Standard 60+ with carvacrol % standardization and clear distinction between infusion and true essential oil.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "10-in-1-mushroom-complex-capsules",
      "title": "10-in-1 Mushroom Complex capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HelloHealth-HappyBrainMushroomComplex-BOTTLEFRONT_png.webp?v=1787585755",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mushroom",
        "complex",
        "capsules",
        "hellohealth"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants",
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 30,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 25,
        "sustainability": 55
      },
      "price": 17.76,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804150223045",
      "vsf_explanation": "A '10-in-1' mushroom complex is the paradigmatic under-dosed proprietary blend — meaningful single-mushroom evidence typically requires 500-3,000 mg per species (reishi triterpenes 1-3 g, lion's mane 1-3 g, turkey tail PSK 3 g in oncology settings). Fitting 10 different mushrooms into one capsule's mg budget guarantees each is delivered at a sub-therapeutic sliver, and per-species mg is not disclosed. Beta-glucan standardization — the single most important quality marker for functional mushrooms — is not disclosed either. Autofailed under proprietary_blend_hides_dose. Would move to Standard 55+ only with per-species mg on-label and beta-glucan % standardization; or better, a single-mushroom SKU at a clinically meaningful dose.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "detox-45-min-lab-consult",
      "title": "Detox + 45 Min Lab Consult",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/toxin-at-home-lab-test.jpg?v=1787585759",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "detox",
        "min",
        "lab",
        "consult",
        "hellohealth"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "heavy_metals_toxins"
      ],
      "vsf_dimensions": {
        "analytical_validity": 58,
        "clinical_utility": 55,
        "transparency": 52,
        "results_delivery": 68,
        "privacy_data": 60,
        "value": 60
      },
      "price": 969,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804150255813",
      "vsf_explanation": "'Detox' panels are one of the most weakly defined categories in direct-to-consumer testing — hellohealth does not disclose on the product page which specific biomarkers are included (heavy metals via urine? liver enzymes? glutathione? porphyrins?), which is a major transparency gap. The included 45-minute consult adds real value since interpretation is the hardest part, but the underlying 'detox' framing is not a mainstream clinical concept — the liver and kidneys handle xenobiotic clearance continuously without supplement-driven 'support.' Legitimate heavy-metal or environmental toxin testing exists (urine mercury/lead/cadmium, blood lead) but requires disclosed methodology to score higher. Would move to Standard 65+ with an itemized panel list and a named processing lab (Doctor's Data, Genova, or LabCorp).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "adrenal-function",
      "title": "Adrenal Function",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/adrenal.jpg?v=1787585775",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "adrenal",
        "function",
        "hellohealth"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "hormone_fertility_testing"
      ],
      "vsf_dimensions": {
        "analytical_validity": 62,
        "clinical_utility": 60,
        "transparency": 55,
        "results_delivery": 62,
        "privacy_data": 62,
        "value": 58
      },
      "price": 135,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804150419653",
      "vsf_explanation": "Standard adrenal-axis panel (typically cortisol, DHEA-S, ACTH) that hellohealth resells as a lab requisition — the underlying assays are well-validated at any CLIA lab, but hellohealth does not clearly disclose the processing lab on the product page, which is a real transparency gap under the Zero-Assumption Rule. Clinical utility is moderate: cortisol and DHEA-S are legitimate biomarkers in true adrenal insufficiency workups, but the popular 'adrenal fatigue' framing that drives most direct-to-consumer adrenal testing is not recognized by endocrinology. A single morning cortisol is a snapshot; ACR (cortisol awakening response) via 4-point saliva collection is the more rigorous protocol and is not what a single blood draw provides. Would move to Standard 65+ with clear lab disclosure and a 4-point diurnal cortisol option.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "accu-chek-guide-test-strips-50-strips",
      "title": "Accu-Chek Guide Test Strips, 50 Strips",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/345047326.jpg?v=1787585804",
      "score": 80,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "accu",
        "chek",
        "guide",
        "test",
        "strips",
        "strips",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "glucose_diabetes_monitoring"
      ],
      "vsf_dimensions": {
        "analytical_validity": 82,
        "clinical_utility": 85,
        "transparency": 80,
        "results_delivery": 82,
        "privacy_data": 78,
        "value": 75
      },
      "price": 27.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804150681797",
      "vsf_explanation": "Roche's Accu-Chek Guide test strips are the FDA-cleared consumable for one of the most widely validated self-monitoring blood glucose (SMBG) systems on the market. Meets ISO 15197:2013 accuracy standard (95% of results within ±15 mg/dL of reference below 100 mg/dL, and within ±15% above 100 mg/dL). Gold-standard SMBG for diabetic self-management, with decades of peer-reviewed validation and integration with Roche's connected apps. Strip-level performance is not user-dependent when technique is correct. The main drawbacks are consumable cost over time and that fingerstick glucose gives point-in-time data rather than the continuous picture a CGM provides. Would move to Elite 85+ if lower price-per-strip or bundled control-solution and lancets.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "proov-complete-fertility-testing-system",
      "title": "Proov Complete Fertility Testing System",
      "vendor": "Proov",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Complete-PDP-HSA_FSA_3.png?v=1787585816",
      "score": 78,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "proov",
        "complete",
        "fertility",
        "testing",
        "system",
        "proov"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "hormone_fertility_testing"
      ],
      "vsf_dimensions": {
        "analytical_validity": 82,
        "clinical_utility": 82,
        "transparency": 78,
        "results_delivery": 78,
        "privacy_data": 75,
        "value": 74
      },
      "price": 99.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804151304389",
      "vsf_explanation": "Proov's flagship multi-hormone urine test system tracks LH (surge), E1G (estrone-3-glucuronide as an estradiol proxy), FSH, and PdG (pregnanediol glucuronide) across the menstrual cycle. The PdG confirmation is FDA-cleared and the only home test that verifies ovulation actually occurred rather than just detecting an LH surge that may not have led to ovulation. Multi-marker tracking allows identification of anovulatory cycles, weak luteal phase, or diminished ovarian reserve signals — all clinically actionable for couples trying to conceive. The Proov Insight app provides plain-language cycle interpretation and can be shared with a healthcare provider. Would move to Elite 85+ with included provider review or IVF-clinic data-export in a portable format.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "truage™-test",
      "title": "TruAge™ Test",
      "vendor": "TruDiagnostic™",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Main_Media.jpg?v=1787585821",
      "score": 75,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "truage",
        "test",
        "trudiagnostic"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "genetic_dna"
      ],
      "vsf_dimensions": {
        "analytical_validity": 78,
        "clinical_utility": 72,
        "transparency": 80,
        "results_delivery": 78,
        "privacy_data": 72,
        "value": 68
      },
      "price": 499,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804151435461",
      "vsf_explanation": "TruDiagnostic's TruAge is the leading commercial DNA-methylation biological-age test, processed at TruDiagnostic's own CLIA-certified lab in Kentucky. Reports biological age via peer-reviewed clocks including OMICmAge and DunedinPACE (Belsky et al., Nature Aging), and includes pace-of-aging estimates plus system-level (immune, metabolic, inflammatory) breakdowns. Methodology is well-documented — Infinium MethylationEPIC BeadChip run on saliva-derived DNA, with published reproducibility (CV typically <3% for the underlying clocks). Clinical utility for individual biohacking decisions is moderate: the clocks are validated at population level but longitudinal changes for a single individual are noisy over short windows. Data is retained; opt-in research use is disclosed. Value is the weakest dimension at $200-500 per test. Would move to Elite 85+ with lower price or bundled longitudinal tracking, and more explicit disclosure of clock noise floor for individual interpretation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vital-source-nutrition-bifi-primal-health-blend-capsules",
      "title": "Vital Source Nutrition-BiFi - Primal Health Blend Capsules",
      "vendor": "KARONDA RENE LEWIS",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/20251101124800_6_6.jpg?v=1787585838",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vital",
        "source",
        "nutrition",
        "bifi",
        "primal",
        "health",
        "blend",
        "capsules",
        "karonda",
        "rene",
        "lewis"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive",
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 35,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 25,
        "sustainability": 50
      },
      "price": 5.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804151730373",
      "vsf_explanation": "'BiFi Primal Health Blend' from the obscure KARONDA RENE LEWIS brand is a textbook proprietary blend — the 'Primal Health Blend' naming pattern signals per-ingredient dosing is hidden, and neither the brand nor the SKU carries a discoverable clinical or manufacturing footprint. Without knowing what is inside at what mg, no evidence-based assessment is possible, and buyers cannot compare this to any studied protocol. Autofailed under proprietary_blend_hides_dose. Would need full ingredient panel disclosure, a legitimate manufacturing facility (GMP/NSF), and a credible clinical rationale to score in Standard tier.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "at-home-sperm-test-for-male-fertility",
      "title": "At Home Sperm Test for Male Fertility",
      "vendor": "Proov",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Sperm-PDP-HSAFSA.png?v=1787585857",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "home",
        "sperm",
        "test",
        "for",
        "male",
        "fertility",
        "proov"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "hormone_fertility_testing"
      ],
      "vsf_dimensions": {
        "analytical_validity": 70,
        "clinical_utility": 72,
        "transparency": 72,
        "results_delivery": 72,
        "privacy_data": 75,
        "value": 72
      },
      "price": 89.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804152320197",
      "vsf_explanation": "Proov-distributed at-home semen analysis using a smartphone-read cartridge to measure sperm concentration and motility. FDA-cleared as a Class II screening device with published performance data against clinical semen analysis, but the accuracy gap versus a lab-run WHO-compliant semen analysis is meaningful — at-home tests reliably flag severe oligospermia but miss subtler morphology or DNA-fragmentation issues that a fertility workup would catch. Result delivery is fast (about 30 minutes in-app) and the app provides plain-language interpretation. Best used as a first-line screen, not as a definitive workup. Would move to Verified 78+ with published sensitivity/specificity for morphology and clearer 'go to a urologist' guidance for borderline results.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hers-and-his-advanced-fertility-test-for-couples",
      "title": "Hers and His Advanced Fertility Test for Couples",
      "vendor": "Proov",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/His_Hers-PDP-HSA_FSA_1.png?v=1787585864",
      "score": 78,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hers",
        "and",
        "his",
        "advanced",
        "fertility",
        "test",
        "for",
        "couples",
        "proov"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "hormone_fertility_testing"
      ],
      "vsf_dimensions": {
        "analytical_validity": 82,
        "clinical_utility": 82,
        "transparency": 78,
        "results_delivery": 78,
        "privacy_data": 75,
        "value": 72
      },
      "price": 179.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804152484037",
      "vsf_explanation": "Bundles Proov's FDA-cleared urine PdG (pregnanediol glucuronide) confirmation strips for confirmed ovulation with an at-home semen analysis for the male partner. The female component is the only FDA-cleared home PdG test on the market and has genuine clinical validity for confirming that ovulation actually occurred (not just that LH surged). The male component is optical/smartphone-read for count and motility — accurate enough for a screen but not a substitute for a clinical semen analysis if the couple pursues assisted reproduction. Proov (Ellevest / MFB Fertility) publishes methodology and privacy terms clearly; results are read at home rather than in a lab, so CLIA is not the relevant accreditation for the strips themselves. Would move to Elite 85+ if bundled with a physician consult and a full lab-confirmed semen analysis for the male partner.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "weightworld-apple-cider-vinegar-gummies-with-the-mother-1000-mg-90-count",
      "title": "WeightWorld Apple Cider Vinegar Gummies with the Mother – 1000 mg, 90 Count",
      "vendor": "Apple Cider Vinegar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71GUSXKMdTL._AC_SL1500.jpg?v=1787585882",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "weightworld",
        "apple",
        "cider",
        "vinegar",
        "gummies",
        "with",
        "the",
        "mother",
        "1000",
        "count",
        "apple",
        "cider",
        "vinegar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health",
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 22.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804153041093",
      "vsf_explanation": "Apple cider vinegar has thin human trial evidence — the widely cited Kondo 2009 study showed ~1 kg weight loss over 12 weeks with 15-30 mL liquid ACV daily, an effect that has not been reliably replicated. Gummy formats compound the problem: '1,000 mg per serving' is typically split across 2-3 gummies (users take 1 and self-under-dose), and heat/pH processing likely denatures 'the mother' probiotic culture that liquid ACV is prized for. Weight-loss framing on gummies also drives sugar or sugar-alcohol content that partially negates the metabolic pretext. Product is not autofailed because it does not make explicit disease claims, but the evidence-to-marketing gap holds it below Standard. Would move to Standard 55+ with per-gummy mg disclosure, sugar-free formulation, and evidence-appropriate weight-loss positioning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "universal-nutrition-animal-creatine-chews",
      "title": "Universal Nutrition Animal Creatine Chews",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Universal-Nutrition-Animal-Creatine-Chews.jpg?v=1787585897",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "universal",
        "nutrition",
        "animal",
        "creatine",
        "chews",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids",
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 80,
        "formulation": 62,
        "manufacturing": 65,
        "safety": 70,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 31.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804153499845",
      "vsf_explanation": "Creatine monohydrate is arguably the most-studied ergogenic aid in sports nutrition — hundreds of RCTs support 3-5 g/day for strength, lean-mass, and increasingly cognitive endpoints (Rae 2003, Kreider 2017 ISSN position stand). Universal Nutrition is a 30-year-established brand with a real quality reputation. The chew format is a legitimate delivery choice and improves compliance for users who dislike powders. Per-chew creatine mg disclosure is the transparency question — most creatine chews sit at 1-1.5 g each, requiring 3-5 chews for a full loading or maintenance dose, and users often under-dose without realizing. Would move to Verified 70+ with explicit per-chew mg on the primary label, creapure branded raw material, and per-lot third-party assay.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "alpha-lion-night-burn-60-capsules",
      "title": "Alpha Lion Night Burn - 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Alpha-Lion-Night-Burn-60-Capsules.jpg?v=1787585904",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alpha",
        "lion",
        "night",
        "burn",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health",
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 30,
        "manufacturing": 55,
        "safety": 45,
        "transparency": 25,
        "sustainability": 50
      },
      "price": 54.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804153827525",
      "vsf_explanation": "Alpha Lion Night Burn is marketed as a nighttime fat-burner + sleep-aid combo — a category where efficacy claims are dependent on precise dosing of individual ingredients (ashwagandha, GABA precursors, thermogenics), yet the label uses a proprietary 'Night Burn Matrix' style structure that hides per-ingredient mg. Combining stimulants or thermogenics with sleep botanicals is also a physiologically incoherent framing — burning fat requires elevated metabolic rate, which opposes the parasympathetic dominance required for restorative sleep. Autofailed under proprietary_blend_hides_dose. Would move to Standard tier only with full per-actives disclosure and a coherent mechanism story that does not oppose itself.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "flowflex-covid-19-antigen-rapid-home-test-kit",
      "title": "Flowflex COVID-19 Antigen Rapid Home Test Kit",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/flowflex-covid-19-antigen-rapid-home-test-kit-face-masks-ppe-dailysale-132743.jpg?v=1787590652",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "flowflex",
        "covid",
        "antigen",
        "rapid",
        "home",
        "test",
        "kit",
        "dailysale"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "sti_infectious_disease"
      ],
      "vsf_dimensions": {
        "analytical_validity": 78,
        "clinical_utility": 78,
        "transparency": 68,
        "results_delivery": 78,
        "privacy_data": 65,
        "value": 65
      },
      "price": 14,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804457291973",
      "vsf_explanation": "ACON Laboratories' Flowflex is one of the most widely deployed FDA-authorized (via EUA) rapid SARS-CoV-2 antigen home tests, distributed globally and used throughout the US federal COVIDtests.gov distribution program. Manufacturer-reported clinical performance is 93% sensitivity for symptomatic infection and 100% specificity per the FDA EUA submission, with real-world validation studies (Soni et al. 2023, and multiple independent evaluations) confirming performance within the expected range for rapid antigen tests — high specificity, sensitivity strongest 1-4 days after symptom onset and lower in pre-symptomatic or very early infection. Nasal-swab collection is well-tolerated and results are read visually in 15 minutes. a third-party marketplace listing is a reseller (not the manufacturer), which introduces some transparency friction — expiration dating and lot handling depend on how a third-party marketplace listing sources and stores inventory. Would move to Verified 78+ with confirmed direct-from-ACON supply chain, extended expiration dates verified at purchase, and clear returns policy for expired product.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "illuminate-green-v1-green-light-therapy-panel",
      "title": "Illuminate Green V1 – Green Light Therapy Panel",
      "vendor": "Lumara",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Illuminate_Green_Panel.png?v=1787590683",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "illuminate",
        "green",
        "green",
        "light",
        "therapy",
        "panel",
        "lumara"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "analytical_validity": 52,
        "clinical_utility": 55,
        "transparency": 55,
        "build_quality": 58,
        "warranty_support": 55,
        "value": 55
      },
      "price": 1799,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804458012869",
      "vsf_explanation": "Lumara's Illuminate Green V1 is a green-light (typically 520nm) therapy panel — a much less-studied wavelength than the red (660nm) and near-infrared (810-850nm) that dominate the photobiomodulation literature. The strongest evidence for green light specifically is in migraine (Noseda 2016, Brain — controlled exposure to narrow-band green light reduced pain intensity vs other wavelengths in the same subjects) and one small trial in post-partum depression (Martin 2021, Cephalalgia). No comparable body of RCT evidence exists for skin healing, mitochondrial function, or performance recovery at 520nm the way it does for red/NIR. Lumara is a smaller/newer brand and irradiance (mW/cm² at distance), wavelength precision (peak vs half-bandwidth), and warranty terms are the differentiators — a therapy panel without clearly published irradiance and wavelength spec cannot be evaluated for whether it matches the parameters used in the published RCTs. Would move to Standard 65+ with published irradiance at multiple distances, verified peak wavelength via third-party spectrometer test, and 3+ year warranty. Green light is a legitimate but early-stage modality; buyers should understand the evidence is thin outside of migraine and mood.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zahler-junior-d3-k2™-children-s-d3-k2-formula-supports-bone-density-calcium-absorption-90-chewable-tablets",
      "title": "Zahler Junior D3 & K2™ – Children’s D3 & K2 Formula | Supports Bone Density & Calcium Absorption | 90 Chewable Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/image_078e270c-4308-41c1-b407-b6caf71a09c6.png?v=1787590711",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "youth_under_18",
      "tokens": [
        "zahler",
        "junior",
        "children",
        "formula",
        "supports",
        "bone",
        "density",
        "calcium",
        "absorption",
        "chewable",
        "tablets",
        "singers",
        "health",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 68,
        "manufacturing": 68,
        "safety": 66,
        "transparency": 65,
        "sustainability": 58
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804458471621",
      "vsf_explanation": "Zahler is a well-established kosher supplement brand (Advanced Nutrition by Zahler, based in Brooklyn NY, established 1950s as a family pharmacy) with a genuine specialty position in the kosher supplement market. The Junior D3 & K2 chewable is a pediatric formulation of the well-evidenced D3+K2 combination — vitamin D3 for the widespread pediatric deficiency (particularly in northern-latitude, indoor-lifestyle children) with real evidence for bone development, immune function, and reduction of respiratory infection frequency in some pediatric populations; vitamin K2 for calcium direction to bone matrix during the developmental window when peak bone mass is being established. Chewable tablet format is pediatric-appropriate. The 90-tablet count is a typical multi-month supply. Marks reflect: legitimate kosher-market brand with real manufacturing infrastructure, evidence-supported pediatric formulation choice, and reasonable label transparency. Kids' supplementation should always be discussed with a pediatrician, especially for fat-soluble vitamins where excess is possible; verify the per-tablet dose (D3 typically 400-1000 IU for children, K2 typically 25-45 mcg pediatric range) aligns with pediatric dosing guidance for age. Standard tier reflects the legitimate brand and defensible pediatric formulation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "skin-defense-vitamin-d3-k2",
      "title": "Skin Defense Vitamin D3 + K2",
      "vendor": "Dermazen",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/m28-26-pdpmaster-dermazen-skindefense.jpg?v=1787590720",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular",
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "skin",
        "defense",
        "vitamin",
        "dermazen"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 34.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804458635461",
      "vsf_explanation": "Dermazen Skin Defense Vitamin D3 + K2 is a small DTC brand's implementation of one of the more evidence-supported vitamin combinations in the supplement market. Vitamin D3 (cholecalciferol) is the effective form for correcting the widespread population-level vitamin D deficiency (roughly 40% of US adults meet the clinical insufficiency threshold), with real evidence for bone health, immune function, and possibly modest all-cause mortality benefit at doses achieving 30-50 ng/mL serum 25(OH)D. Vitamin K2 (particularly menaquinone MK-7 form) provides complementary benefit by directing calcium to bone and away from vascular calcification — the pairing is grounded in the vascular-calcification and osteocalcin biochemistry. The 'Skin Defense' branding is a modest reach — D3+K2 is not primarily a skin product, though vitamin D does have real roles in skin health and photodamage response. Product-level transparency (per-serving IU of D3, mcg of K2, form of K2 as MK-4 vs MK-7 which have different half-life profiles) is not fully verifiable at title level. Dermazen is a small DTC brand without USP or NSF third-party certification. Scored Standard reflecting the sound ingredient combination and small-brand transparency limitations.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-d3-k2-drops-with-mct-oil",
      "title": "Vitamin D3+K2 Drops with MCT Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/vit-d3k2.png?v=1787590730",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "drops",
        "with",
        "mct",
        "oil",
        "bulkessentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 80,
        "formulation": 72,
        "manufacturing": 58,
        "safety": 75,
        "transparency": 62,
        "sustainability": 52
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804458766533",
      "vsf_explanation": "Well-designed combo: Vitamin D3 + K2 in MCT-oil carrier. Both fat-soluble vitamins delivered with fat for optimal absorption. K2 (MK-7) is the appropriate companion to chronic D3 supplementation, directing calcium to bones vs soft tissue. Standard therapeutic combo: 5000 IU D3 + 100-200 mcg K2 MK-7 daily. Held below Verified by lack of per-drop IU/mcg disclosure + no third-party assay availability.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ayurvedic-complex-2",
      "title": "Ayurvedic Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1785880721643-generated-label-image-0.png?v=1787590734",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ayurvedic",
        "complex",
        "bulkessentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 58,
        "transparency": 32,
        "sustainability": 48
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804458799301",
      "vsf_explanation": "Generic 'Ayurvedic Complex' branding without disclosed ingredients + doses. Individual Ayurvedic herbs (ashwagandha KSM-66, tulsi, turmeric, triphala, brahmi/bacopa) have distinct RCT evidence bases at distinct doses. Blend without disclosure can't be evaluated. Additional Ayurvedic-specific concern: quality control varies enormously by manufacturer, and heavy-metal contamination (lead, mercury, arsenic) has been documented in poorly-manufactured Ayurvedic products (Saper 2008 JAMA analysis of 193 US-sold Ayurvedic products found 20% contained toxic metals). Autofail: proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "glutathione-spray",
      "title": "Glutathione Spray",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/glutathione.png?v=1787590869",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glutathione",
        "spray",
        "bulkessentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 45,
        "manufacturing": 52,
        "safety": 68,
        "transparency": 40,
        "sustainability": 48
      },
      "price": 32.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804460798149",
      "vsf_explanation": "Oral/sublingual/nasal glutathione spray — bioavailability is the central issue. Oral glutathione is largely broken down in the GI tract before absorption; liposomal encapsulation improves this substantially (Sinha 2018), but 'spray' format without liposomal disclosure suggests standard aqueous glutathione which absorbs poorly. Effective glutathione elevation: (1) NAC + glycine precursor supplementation (Sekhar 2021 GlyNAC study, oral 1.33 g/kg each), (2) IV glutathione, (3) liposomal oral. Spray format sits in the lowest-evidence tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-vitamin-c-powder-supplement",
      "title": "Pure Vitamin C Powder Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/vit-c-100g.png?v=1787590869",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "vitamin",
        "powder",
        "supplement",
        "bulkessentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 15.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804460863685",
      "vsf_explanation": "Pure ascorbic acid powder. Vitamin C is well-studied (Hemila 2013 Cochrane review for respiratory infection duration, wound healing, iron absorption support). Powder form allows dose flexibility (1-10g range) and lower cost per gram than encapsulated. Standard therapeutic doses: 500-2000 mg/day for maintenance, up to 10g/day for acute immune support (with GI-tolerance titration). Held to Standard by lack of buffered/mineral-ascorbate transparency + brand-level manufacturing disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "tmg-trimethylglycine-as-betaine-anhydrous-supplements",
      "title": "TMG (Trimethylglycine) as Betaine Anhydrous Supplements",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/tmg-100g.png?v=1787590869",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tmg",
        "trimethylglycine",
        "betaine",
        "anhydrous",
        "supplements",
        "bulkessentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 65,
        "manufacturing": 58,
        "safety": 72,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 14.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804461879493",
      "vsf_explanation": "Trimethylglycine (betaine anhydrous) has real evidence base as methyl donor for homocysteine reduction (Olthof 2005) and sports performance (Cholewa 2013, 2014 — power/strength at 2.5 g/day). Also used adjunctively with NMN/NR to support methylation capacity during NAD+ precursor supplementation. Studied doses: 1-3 g/day for methylation/homocysteine, 2.5 g/day for sports outcomes. Held to Standard by transparency gaps typical of small DTC brands.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "welcome-product-free-nad-spray",
      "title": "Welcome Product - Free NAD+ Spray",
      "vendor": "",
      "image_url": "",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "welcome",
        "product",
        "free",
        "nad",
        "spray",
        "bulkessentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 45,
        "manufacturing": 52,
        "safety": 72,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 0,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804460830917",
      "vsf_explanation": "Free promotional NAD+ spray. Two evidence gaps: (1) oral/nasal NAD+ direct-molecule spray has poor bioavailability compared to precursor supplementation (NMN/NR at 250-500 mg/day); (2) 'spray' format typically means small per-dose amounts unlikely to reach pharmacology-relevant blood NAD+ levels. Promotional/free framing is a marketing acquisition tool, not a clinical claim.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-vitamin-d3-drops",
      "title": "Pure Vitamin d3 Drops",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/vit-d3.png?v=1787590869",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "vitamin",
        "drops",
        "bulkessentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 68,
        "manufacturing": 58,
        "safety": 72,
        "transparency": 58,
        "sustainability": 52
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804461125829",
      "vsf_explanation": "Liquid vitamin D3 (cholecalciferol) drops. D3 supplementation is one of the most-evidenced supplement interventions when correcting for measured deficiency (Holick 2011 Endocrine Society clinical practice guideline). Liquid drops allow flexible dosing (400-10,000 IU per drop range across brands). Held to Standard by lack of MCT-oil-carrier disclosure (fat-soluble D3 absorption improves with fat co-administration) + IU-per-drop transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-k2-mk-7-drops-with-mct-oil",
      "title": "Vitamin K2 MK-7 Drops with MCT Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/vit-k2.png?v=1787590870",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "drops",
        "with",
        "mct",
        "oil",
        "bulkessentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 70,
        "manufacturing": 58,
        "safety": 72,
        "transparency": 62,
        "sustainability": 52
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804461158597",
      "vsf_explanation": "K2 as menaquinone-7 (MK-7) — the longest-half-life vitamin K2 form (~72 hours vs ~1 hour for MK-4). Real evidence for bone density (Knapen 2013 3-year RCT postmenopausal women) + arterial calcification (Beulens 2009 Rotterdam Study). MCT oil carrier is appropriate for fat-soluble K2. Studied doses: 100-200 mcg MK-7/day. Held to Standard by lack of mcg-per-drop disclosure + trans-form vs cis-form purity disclosure (bacterially-fermented MK-7 is all trans; synthetic can contain cis contamination).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-glutamine-powder-supplement",
      "title": "L-Glutamine Powder Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/l-glutamine-100g.png?v=1787590869",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glutamine",
        "powder",
        "supplement",
        "bulkessentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 55,
        "sustainability": 52
      },
      "price": 13.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804460929221",
      "vsf_explanation": "L-glutamine powder. Real evidence in specific contexts: post-surgical/critically-ill gut integrity + immune function (van der Hulst 1993), critically-ill patient outcomes (Wischmeyer 2002 meta-analysis). Sports/muscle recovery evidence is much weaker for healthy trained athletes (glutamine is not a rate-limiting amino acid for muscle protein synthesis in healthy well-fed humans). Standard supplement dose: 5-10 g/day. Held to Standard by generic quality profile.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnesium-glycinate-powder-supplement",
      "title": "Magnesium Glycinate Powder Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/mag-gly-100g.png?v=1787590869",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "glycinate",
        "powder",
        "supplement",
        "bulkessentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 68,
        "manufacturing": 58,
        "safety": 78,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 14.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804461191365",
      "vsf_explanation": "Magnesium glycinate in powder form (allows dose flexibility + often more elemental Mg per gram of powder than capsules). Same evidence base as capsule glycinate — best-tolerated chelate form, studied for sleep, blood pressure, insulin sensitivity, muscle relaxation. Powder allows precision dosing at the 200-400 mg elemental Mg therapeutic range. Held to Standard by same brand-transparency limits as capsule version.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chaga-mushroom-1",
      "title": "Chaga Mushroom",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1785791353160-generated-label-image-0.png?v=1787590869",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chaga",
        "mushroom",
        "bulkessentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804461093061",
      "vsf_explanation": "Single-ingredient chaga (Inonotus obliquus). Evidence base: in-vitro + animal studies showing antioxidant + immunomodulatory activity; limited controlled human data. Traditional Russian/Siberian use for GI + immune support has centuries of ethnobotanical history but modern RCT support is thinner than for lion's mane or reishi. Studied doses: 500-2000 mg/day of standardized extract. Held to Standard by evidence-base thinness vs other medicinal mushrooms + transparency gaps.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ceremonial-matcha-powder",
      "title": "Ceremonial Matcha Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1785791590437-generated-label-image-0.png?v=1787590870",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ceremonial",
        "matcha",
        "powder",
        "bulkessentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 72,
        "transparency": 55,
        "sustainability": 58
      },
      "price": 44.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804461060293",
      "vsf_explanation": "Ceremonial-grade matcha powder. Real evidence: EGCG content for metabolic + cardiovascular support (Hodgson 2013), L-theanine + caffeine synergy for focused attention (Owen 2008, Haskell 2008). Ceremonial-grade (vs culinary) implies higher quality tea leaves + finer stone-grinding. Held to Standard by lack of catechin/EGCG standardization on product page + heavy-metal COA disclosure (matcha in general has documented lead + cadmium concerns depending on growing region).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "micronized-creatine-monohydrate-powder",
      "title": "Micronized Creatine Monohydrate Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/creatine_monohydrate_100g.png?v=1787590869",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "micronized",
        "creatine",
        "monohydrate",
        "powder",
        "bulkessentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 85,
        "formulation": 72,
        "manufacturing": 58,
        "safety": 78,
        "transparency": 60,
        "sustainability": 52
      },
      "price": 12.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804461289669",
      "vsf_explanation": "Micronized creatine monohydrate — the gold standard sports supplement. Creatine has one of the largest RCT evidence bases of any supplement (Kreider 2017 ISSN position stand: strength +8-14%, power +10-20%, muscle mass +1-2 kg lean gain over 4-12 weeks, plus cognitive benefits under high mental load, sleep deprivation resilience, plus emerging brain-injury recovery evidence). Micronized form has better mixability + absorption than standard monohydrate. Held below Verified by lack of Creapure branding (the highest-purity CM standard) + third-party assay disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-carnitine-supplement-unflavored-powder",
      "title": "l Carnitine Supplement – Unflavored Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/l-carnitine_100g.png?v=1787590869",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "carnitine",
        "supplement",
        "unflavored",
        "powder",
        "bulkessentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 55,
        "sustainability": 52
      },
      "price": 16.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804461453509",
      "vsf_explanation": "L-carnitine powder — evidence base varies by form + use case. L-carnitine tartrate for exercise recovery (Volek 2002, Kraemer 2003), acetyl-L-carnitine for cognitive/neuroprotective (Malaguarnera 2011). Regular L-carnitine oral absorption is poor (10-20% bioavailability); GPLC (glycine propionyl L-carnitine) and acetyl form have better profiles for specific uses. Held to Standard by lack of form-specification (tartrate vs acetyl vs GPLC vs plain).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gut-health-1",
      "title": "Gut Health",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1785789696932-generated-label-image-0.png?v=1787590870",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gut",
        "health",
        "bulkessentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 68,
        "transparency": 30,
        "sustainability": 48
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804461420741",
      "vsf_explanation": "Generic 'Gut Health' single-word product name almost certainly indicates undisclosed proprietary multi-ingredient formulation. Gut-support ingredients (probiotics, prebiotics, digestive enzymes, glutamine, zinc carnosine) have distinct evidence bases at distinct doses. Undisclosed 'Gut Health' can't be evaluated. Autofail: proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "mineralized-coconut-powder",
      "title": "Mineralized Coconut Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/coconut-powder-100g.png?v=1787590870",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mineralized",
        "coconut",
        "powder",
        "bulkessentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 52,
        "sustainability": 58
      },
      "price": 14.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804461781189",
      "vsf_explanation": "Coconut water powder + added minerals — essentially an electrolyte hydration product. Coconut water has real (modest) potassium content; effectiveness as electrolyte replacement depends on added sodium/magnesium levels. Held to Standard by lack of per-serving electrolyte mg disclosure typical of small-brand hydration products.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "elderberry-extract-powder-w-maltodextrin",
      "title": "Elderberry Extract Powder W/Maltodextrin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/elderberry-100g.png?v=1787590869",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "elderberry",
        "extract",
        "powder",
        "maltodextrin",
        "bulkessentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 52,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 58,
        "sustainability": 52
      },
      "price": 14.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804461519045",
      "vsf_explanation": "Elderberry (Sambucus nigra) extract — real evidence for reducing cold + flu symptom duration (Tiralongo 2016 RCT air travelers, Zakay-Rones 2004 influenza symptom duration ~4 day reduction). The maltodextrin carrier is a formulation compromise (bulk filler that also raises glucose response) — better products use non-maltodextrin carrier (arabinogalactan, acacia gum). Studied dose: 300-1000 mg standardized extract or 3-5 g raw elderberry equivalent.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fermented-mushroom-blend-1",
      "title": "Fermented Mushroom Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1785880421998-generated-label-image-0.png?v=1787590871",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fermented",
        "mushroom",
        "blend",
        "bulkessentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 68,
        "transparency": 32,
        "sustainability": 50
      },
      "price": 51.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804461977797",
      "vsf_explanation": "Multi-mushroom 'blend' without per-mushroom species + gram disclosure. Individual medicinal mushrooms (lion's mane, reishi, cordyceps, chaga, turkey tail, shiitake, maitake) have distinct evidence bases at distinct doses. A generic 'Fermented Mushroom Blend' pattern typically underdoses each species to hit palatability/cost/space constraints — you get 500 mg of 10 mushrooms rather than the 1000-3000 mg of a single mushroom species that would deliver the studied effect. Autofail: proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "omega-3-epa-180mg-dha-120mg-2",
      "title": "Omega-3 EPA 180mg + DHA 120mg",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1785879244598-generated-label-image-0.png?v=1787590871",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "omega",
        "epa",
        "180mg",
        "dha",
        "120mg",
        "bulkessentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 72,
        "transparency": 62,
        "sustainability": 48
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804462010565",
      "vsf_explanation": "Omega-3 EPA 180 mg + DHA 120 mg per softgel (300 mg total EPA+DHA per serving) is standard fish-oil concentration. Evidence base for cardiac + inflammatory + cognitive endpoints requires 1-2 g EPA+DHA daily (REDUCE-IT trial used 4g icosapent ethyl; standard cardiac protocols 1g EPA+DHA). This product requires 3-7 caps per day to hit therapeutic dose — check per-cap disclosure. Held below Verified by sourcing transparency (which fish, molecular distillation, oxidation TOTOX values not shown on product page).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cognitive-support",
      "title": "Cognitive Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1785859711657-generated-label-image-0.png?v=1787590873",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cognitive",
        "support",
        "bulkessentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 38,
        "manufacturing": 50,
        "safety": 62,
        "transparency": 28,
        "sustainability": 45
      },
      "price": 34.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804462043333",
      "vsf_explanation": "Vague single-word 'Cognitive Support' branding without specific ingredient/dose disclosure. Nootropic category is dose-sensitive — bacopa monnieri needs 300 mg/day standardized to 55% bacosides (Stough 2001), lion's mane 500 mg × 3/day (Mori 2009), rhodiola 200-600 mg/day. Undisclosed proprietary 'Cognitive Support' can't be evaluated for evidence-matched dosing. Autofail: proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "hydro-balancing-gel-cream",
      "title": "Hydro Balancing Gel-Cream",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1785878423618-generated-label-image-0.png?v=1787590873",
      "score": 28,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hydro",
        "balancing",
        "gel",
        "cream",
        "bulkessentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 42,
        "safety": 58,
        "transparency": 30,
        "sustainability": 42
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804462076101",
      "vsf_explanation": "Topical skincare gel-cream — outside Vyvata's supplement/wearable/diagnostic/sleep/recovery scoring scope. Autofail: out_of_scope_for_biohacking. Not a quality comment on the product.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "platinum-turmeric-1",
      "title": "Platinum Turmeric",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1785879721394-generated-label-image-0.png?v=1787590873",
      "score": 56,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "platinum",
        "turmeric",
        "bulkessentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 52,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804462108869",
      "vsf_explanation": "Turmeric/curcumin has real evidence for joint inflammation + oxidative stress markers (Daily 2016 meta-analysis, Panahi 2016 knee OA RCT) BUT unformulated curcumin has notoriously poor bioavailability (~1-5% oral absorption). 'Platinum' branding without disclosure of BioPerine (piperine 20mg for 2000% bioavailability increase), Meriva (phytosome), Longvida (SLCP), or Theracurmin (nano-particle) enhancement is a transparency gap. Score reflects likely-generic turmeric powder without proven bioavailability tech.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "digestive-enzyme-pro-blend-1",
      "title": "Digestive Enzyme Pro Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1785878612175-generated-label-image-0.png?v=1787590876",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "digestive",
        "enzyme",
        "pro",
        "blend",
        "bulkessentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 42,
        "manufacturing": 50,
        "safety": 68,
        "transparency": 32,
        "sustainability": 48
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804462207173",
      "vsf_explanation": "'Pro Blend' naming pattern strongly indicates proprietary multi-enzyme formulation without per-enzyme unit disclosure. Digestive enzymes (protease, lipase, amylase, cellulase, lactase) have real per-condition evidence bases (lactase for lactose intolerance, pancreatic enzyme replacement for exocrine pancreatic insufficiency) but require disclosed unit activity (FCC units) not milligram totals to be usefully evaluated. Autofail: proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "lions-mane-mushroom-3",
      "title": "Lion's Mane Mushroom",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1785792363701-generated-label-image-0.png?v=1787590877",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lion",
        "mane",
        "mushroom",
        "bulkessentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 75,
        "transparency": 58,
        "sustainability": 58
      },
      "price": 33.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804462239941",
      "vsf_explanation": "Single-ingredient lion's mane (Hericium erinaceus). Evidence: Mori 2009 cognitive support in mild cognitive impairment (500 mg × 3/day for 16 weeks improved MMSE); Nagano 2010 mood/anxiety in menopausal women. Fruiting body vs mycelium quality matters — fruiting body extract standardized to hericenones/erinacines is preferred. Held below Verified by lack of standardization + extract-source disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "creatine-hydration-powder",
      "title": "Creatine Hydration Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1785792097995-generated-label-image-0.png?v=1787590877",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "creatine",
        "hydration",
        "powder",
        "bulkessentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 55,
        "sustainability": 52
      },
      "price": 42,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804462272709",
      "vsf_explanation": "Creatine monohydrate + electrolyte hydration blend. Creatine is the most-evidenced sports supplement (ISSN 2017 position stand: strength, power, muscle mass, cognitive function support all evidenced at 3-5 g/day). Combined format with electrolytes is convenience-oriented rather than performance-additive. Held to Standard by lack of per-scoop creatine dose disclosure + generic hydration ingredient list.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "normal-blood-sugar-drops-1",
      "title": "Normal Blood Sugar Drops",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1785879911668-generated-label-image-0.png?v=1787590877",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "normal",
        "blood",
        "sugar",
        "drops",
        "bulkessentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 30,
        "manufacturing": 45,
        "safety": 52,
        "transparency": 22,
        "sustainability": 45
      },
      "price": 19.8,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804462305477",
      "vsf_explanation": "'Normal Blood Sugar' framing is a textbook DSHEA structure/function loophole exploit: doesn't explicitly say 'treats diabetes' (which FDA would enforce against) but strongly implies diabetes-treatment effect. Reader is meant to complete the association mentally. Vyvata treats 'normal/healthy/optimal + biomarker of disease' framings as unverified_disease_claim autofail. Sublingual-drop delivery of glucose-modulating ingredients has no controlled evidence base regardless of formula.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "copper-peptides-serum-for-face-neck-firming-hydrating",
      "title": "Copper Peptides Serum For Face+Neck Firming & Hydrating",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Gemini_Generated_Image_icygeqicygeqicyg.png?v=1787590877",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "copper",
        "peptides",
        "serum",
        "for",
        "face",
        "neck",
        "firming",
        "hydrating",
        "bulkessentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 39.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804462338245",
      "vsf_explanation": "Topical skincare serum falls outside Vyvata's supplement/wearable/diagnostic/sleep/recovery scoring categories. Copper peptides (GHK-Cu) have real published evidence for skin repair + collagen synthesis when applied topically (Pickart 2012 review), but topical cosmetics are out of scope for the biohacking-supplement rubric.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-b12-liquid-drops-2500-mcg-methylcobalamin",
      "title": "Vitamin B12 Liquid Drops – 2500 mcg methylcobalamin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/vit-b12.png?v=1787590878",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "b12",
        "liquid",
        "drops",
        "2500",
        "mcg",
        "methylcobalamin",
        "bulkessentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 72,
        "manufacturing": 58,
        "safety": 80,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804462403781",
      "vsf_explanation": "Liquid B12 as methylcobalamin at 2500 mcg is a strong formulation: (1) methylcobalamin is the biologically-active form preferred over cyanocobalamin, (2) 2500 mcg is above standard therapeutic dose for B12 deficiency correction, (3) liquid/sublingual delivery has real bioavailability advantage for people with impaired oral B12 absorption (older adults, PPI users, vegans without intrinsic factor issues). Held below Verified by transparency/manufacturing gaps typical of small DTC brands.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnesium-glycinate-5",
      "title": "Magnesium Glycinate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1785859562034-generated-label-image-0.png?v=1787590879",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "glycinate",
        "bulkessentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 68,
        "manufacturing": 58,
        "safety": 78,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804462371013",
      "vsf_explanation": "Magnesium glycinate (bisglycinate) capsule form. Glycinate is the best-tolerated + well-absorbed magnesium chelate — no GI distress that occurs with magnesium oxide or citrate at equivalent doses. Studied benefits: sleep quality, muscle relaxation, insulin sensitivity, blood pressure modulation. Standard therapeutic elemental Mg dose is 200-400 mg/day; product page should disclose elemental content (not just total glycinate weight).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "appetite-balance-weight-support-strips",
      "title": "Appetite Balance & Weight Support Strips",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1785859232061-generated-label-image-0.png?v=1787590878",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "appetite",
        "balance",
        "weight",
        "support",
        "strips",
        "bulkessentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 18,
        "formulation": 32,
        "manufacturing": 48,
        "safety": 55,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 35.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804462502085",
      "vsf_explanation": "'Weight Support' + 'Appetite Balance' framing implies weight-loss/appetite-suppressant effect that no oral-strip supplement plausibly delivers. Proprietary strip formulations have no published RCT evidence for weight/appetite outcomes. Multiple autofail rules apply: primary is unverified_medical_claim on the weight-support framing.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "myo-inositol-supplement-powder-for-women",
      "title": "Myo Inositol Supplement Powder for Women",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/inositol-100g_4b4667a3-b37e-40cf-95fd-ab78e4854246.png?v=1787590878",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "myo",
        "inositol",
        "supplement",
        "powder",
        "for",
        "women",
        "bulkessentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 70,
        "manufacturing": 58,
        "safety": 78,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 14.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804462436549",
      "vsf_explanation": "Myo-inositol powder for women targets the well-established PCOS/fertility use case. Real RCT evidence: Costantino 2009, Nordio 2019, Genazzani 2008 for insulin sensitivity + ovulation induction in PCOS at 2-4 g/day (with or without d-chiro-inositol at 40:1 ratio). Standard therapeutic dose is 2-4 g/day for 3-6 months. Held below Verified by transparency gaps on d-chiro-inositol ratio disclosure + third-party assay availability.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "glycine-powder-supplement",
      "title": "Glycine Powder Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/glycine-100g.png?v=1787590878",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glycine",
        "powder",
        "supplement",
        "bulkessentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 65,
        "manufacturing": 58,
        "safety": 78,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 14.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804462534853",
      "vsf_explanation": "Single-ingredient glycine powder. Real evidence base: Yamadera 2007 sleep-quality RCT at 3g pre-bed, Bannai 2012 subjective sleep + daytime function, and Sekhar 2021 Baylor GlyNAC (glycine + NAC) study showing glutathione + mitochondrial function restoration in older adults at 1.33 g/kg glycine + equal-dose NAC. Held below Verified by lack of third-party assay disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "beta-alanine-powder-supplement",
      "title": "Beta Alanine Powder Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/beta-alanine-100g.png?v=1787590882",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beta",
        "alanine",
        "powder",
        "supplement",
        "bulkessentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 14.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804462731461",
      "vsf_explanation": "Single-ingredient beta-alanine powder from Bulkessentials DTC line. Beta-alanine has one of the strongest sports-nutrition evidence bases: increases muscle carnosine, buffers acid accumulation, RCT-supported ergogenic effect for 1-4 minute exercise (Trexler 2015 ISSN position stand, Hoffman 2018). Studied dose: 4-6 g/day (split doses) for 4-6 weeks loading. Held below Verified by small-brand transparency limits — no third-party assay disclosure, no COA per lot published on product page. Paresthesia (tingling) at high acute doses is expected/harmless.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "diet-drops-ultra-1-oz-1",
      "title": "Diet Drops Ultra 1 oz",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1785791829563-generated-label-image-0.png?v=1787590881",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "diet",
        "drops",
        "ultra",
        "bulkessentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 30,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 32.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804462698693",
      "vsf_explanation": "'Diet Drops' branding places this product in the homeopathic-HCG-diet-drops category that FTC has repeatedly enforced against since 2011 (Kevin Trudeau $37M judgment being the highest-profile precedent). Weight loss via sublingual drops has no controlled evidence base regardless of ingredients. Autofail unverified_medical_claim: the product name implies a weight-loss effect no honest supplement can deliver.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "nmn",
      "title": "NMN",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1785788624032-generated-label-image-0.png?v=1787590882",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nmn",
        "bulkessentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804462895301",
      "vsf_explanation": "Nicotinamide mononucleotide (NMN) is a direct NAD+ precursor with an emerging but genuine clinical evidence base — human trials (Yoshino 2021 in Science, Yamane 2023, Igarashi 2022, Kim 2022) have shown dose-dependent increases in whole-blood NAD+ at 250-1000 mg/day over 8-12 weeks, plus modest secondary outcomes on aerobic capacity and insulin sensitivity in specific populations. The evidence is younger and thinner than NR (nicotinamide riboside), and no NMN trial has yet demonstrated a hard longevity or all-cause-mortality endpoint. Bulkessentials sells NMN as a single-ingredient product — this is a positive for transparency but the title alone does not disclose dose (250 vs 500 vs 1000 mg), form (capsule vs powder vs sublingual), stability testing (NMN is notoriously moisture-sensitive), or third-party purity COAs. FDA in late 2022 issued a controversial position that NMN is excluded from being marketed as a dietary supplement because of its investigation as a drug candidate; this legal-gray-area status is a real caveat. Scored Standard — a real ingredient with real research, held back by disclosure gaps and regulatory uncertainty.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-arginine-powder",
      "title": "L-Arginine Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/l-arginie-100g.png?v=1787590882",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "arginine",
        "powder",
        "bulkessentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 15.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804462993605",
      "vsf_explanation": "L-arginine is a conditionally-essential amino acid and the substrate for endothelial nitric oxide synthase (eNOS). Evidence is mixed and dose-sensitive: at 3-6 g doses acutely it can transiently raise plasma arginine and produce mild vasodilation, but oral bioavailability is limited by first-pass metabolism and the acute NO effect is often modest compared to L-citrulline, which bypasses hepatic arginase and raises plasma arginine more effectively. Chronic L-arginine (5-9 g/day) has some evidence for erectile function in mild ED, blood pressure in specific populations, and post-surgical wound healing. It notably failed the VINTAGE-MI trial after myocardial infarction (increased mortality signal), which is why post-MI patients specifically should avoid it. Bulkessentials sells L-arginine as a single-ingredient powder — good for transparency and dose flexibility. Scored Standard: a real, well-characterized amino acid with legitimate use cases but a modest evidence base compared to L-citrulline for the same endpoints.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "potassium-citrate-supplement",
      "title": "Potassium Citrate Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/potassium-citrate-100g.png?v=1787590881",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "potassium",
        "citrate",
        "supplement",
        "bulkessentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 14.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804462928069",
      "vsf_explanation": "Potassium citrate is an FDA-approved prescription drug (Urocit-K) for renal tubular acidosis and calcium-oxalate kidney stone prevention, and an over-the-counter supplement for general potassium repletion. Dietary potassium intake in the US averages 2,400-2,800 mg/day against an Adequate Intake of 3,400 mg (men) / 2,600 mg (women), so mild insufficiency is genuinely common. Evidence for supplemental potassium citrate is strongest for reducing recurrent calcium-oxalate stones (Ettinger 1997, Barcelo 1993) and for modest blood pressure reductions in salt-sensitive hypertension. The citrate anion alkalinizes urine and may reduce bone resorption, though the bone-density claim is not fully settled. The FDA restricts OTC potassium supplements to 99 mg per tablet as a safety measure — dietary insufficiency at this dose requires many capsules per day to close the gap. Bulkessentials should disclose exact mg elemental potassium per capsule, citrate salt vs other forms, and per-lot COAs. Scored Standard: a legitimate, well-characterized mineral supplement with specific evidence-based use cases.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cordyceps-energy-gummies",
      "title": "Cordyceps Energy Gummies",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1785790217531-generated-label-image-0.png?v=1787590889",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cordyceps",
        "energy",
        "gummies",
        "bulkessentials"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 72,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 39.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804463190213",
      "vsf_explanation": "Cordyceps militaris and Cordyceps sinensis have a modest but real evidence base for exercise-tolerance and VO2max improvements at typical doses of 1000-3000 mg/day of fruiting body or CS-4 mycelium — most notably in the Chen 2010 and Hirsch 2017 trials. The gummy delivery format is convenient but usually caps dose at 500-1000 mg per serving, which sits at the low end of studied protocols and requires 3-6 gummies per day to reach evidence-based levels. Bulkessentials does not publish the specific Cordyceps species, whether fruiting body or mycelium is used, beta-glucan or cordycepin standardization percentages, or third-party COAs. Sugar content in gummy formats is a real formulation drag on an 'energy' claim. Scored Standard because Cordyceps as an ingredient has legitimate research support, but users should read the label for actual per-gummy mg content before committing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrafol-womens-balance-3-month-pack",
      "title": "NUTRAFOL WOMENS BALANCE 3 MONTH PACK",
      "vendor": "NUTRAFOL @ NYALLERGY",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NUTRAFOLBALANCE.jpg?v=1787590906",
      "score": 78,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrafol",
        "womens",
        "balance",
        "month",
        "pack",
        "nutrafol",
        "nyallergy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 80,
        "formulation": 76,
        "manufacturing": 74,
        "safety": 72,
        "transparency": 76,
        "sustainability": 62
      },
      "price": 209,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804463321285",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 0 → new 78. Evidence found: Ablon G, Kogan S. A Randomized, Double-Blind, Placebo-Controlled Study of a Nutraceutical Supplement for Promoting Hair Growth in Perimenopausal, Menopausal, and Postmenopausal Women With Thinning Hair. J Drugs Dermatol. 2021;20(1):55-61. | Ablon G. A 3-Month, Randomized, Double-Blind, Placebo-Controlled Study Evaluating the Ability of an Extra-Strength Marine Protein Supplement to Promote Hair Growth and Decrease Shedding in Women with Self-Perceived Thinning Hair. Dermatol Res Pract. 2015; article ID 841570.. Rationale: Nutrafol Women's Balance was specifically evaluated in Ablon & Kogan 2021 in peri/menopausal/postmenopausal women showing significant improvement in hair growth vs placebo. The reformulation adds maca and astaxanthin targeted at hormonal transition. Verified tier for brand-specific RCT on the exact life-stage cohort.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "irwin-naturals-concentrated-maca-root-and-ashwagandha-75-liquid-soft-gels",
      "title": "Irwin Naturals Concentrated Maca Root And Ashwagandha, 75 Liquid Soft-Gels",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/93660911.jpg?v=1787590925",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive",
        "energy",
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "irwin",
        "naturals",
        "concentrated",
        "maca",
        "root",
        "and",
        "ashwagandha",
        "liquid",
        "soft",
        "gels",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 38,
        "sustainability": 45
      },
      "price": 23.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804464140485",
      "vsf_explanation": "Irwin Naturals is a well-known mainstream US supplement brand recognized for its proprietary 'BioPerine Complex' liquid softgel format (an oil-based softgel with black pepper extract to enhance absorption). The brand has significant retail distribution (Vitamin Shoppe, Amazon, mass retail) and real cGMP manufacturing. However, the brand's category-typical labeling structure uses proprietary blends that combine the featured actives (Maca + Ashwagandha in this SKU) with a range of supporting ingredients under grouped panel line items, without disclosing per-ingredient milligrams. Both maca and ashwagandha have real evidence bases — maca for menopausal/libido symptom management (gelatinized extract 1.5-3g/day), ashwagandha (particularly KSM-66 or Sensoril standardization) for stress-related cortisol and modest testosterone/thyroid effects at 300-600 mg/day — but the studied effects require the studied doses of the specific standardized extracts. Without ingredient standardization disclosure (KSM-66 vs generic ashwagandha vary substantially) and per-ingredient milligram breakdown, the product cannot be verified against the evidence base. Autofailed under proprietary_blend_hides_dose despite the legitimate brand identity and defensible individual ingredient choices.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "nutrex-l-arginine-1000-120-caps",
      "title": "Nutrex L-Arginine 1000, 120 Caps",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/L-Arginine.webp?v=1787590940",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrex",
        "arginine",
        "1000",
        "120",
        "caps",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804464173253",
      "vsf_explanation": "Nutrex L-Arginine 1000 delivers a single ingredient (L-arginine hydrochloride typically) at a stated single dose (1000 mg per capsule) — transparent single-ingredient labeling that contrasts favorably with the proprietary-blend Nutrex T-booster SKU also in this batch. L-arginine is a semi-essential amino acid, a substrate for nitric oxide synthesis, and one of the most-studied performance/cardiovascular ingredients. Its evidence base is moderate: real effects on peripheral vasodilation (mild blood-pressure lowering at higher doses), some evidence for endothelial function support, and limited but real evidence for exercise performance at cumulative doses above 6g/day. A single 1000 mg capsule per serving is a modest dose; the studied effects generally require 3-6+ grams cumulative (3-6 capsules of this product per day). L-citrulline is arguably a more efficient nitric oxide precursor than L-arginine at equivalent doses because L-arginine has significant first-pass liver metabolism and L-citrulline converts to L-arginine after absorption — but L-arginine is a defensible legacy choice. Nutrex is a real US-based sports supplement brand with cGMP manufacturing. Scored Standard tier reflecting the single-ingredient transparency and moderate evidence base.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "samson",
      "title": "SAMSON",
      "vendor": "CVMK GLOBAL",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CFA3788E-C053-425B-AAE7-31A7A469E9AD.png?v=1787590952",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "samson",
        "cvmk",
        "global"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 32,
        "manufacturing": 38,
        "safety": 35,
        "transparency": 22,
        "sustainability": 42
      },
      "price": 100,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804464369861",
      "vsf_explanation": "'SAMSON' from 'CVMK GLOBAL' — same private-label seller as 'GlowUp' elsewhere in this batch. Product name is aspirational-mythological (Samson = biblical strongman) with no compound name or category description; classic private-label male-enhancement branding vocabulary. Without ingredient disclosure at title level, without brand credibility, without third-party testing, and given the male-enhancement product niche's documented FDA Tainted Products database history for undisclosed PDE5 inhibitors, the product cannot be evaluated for safety let alone efficacy. Autofailed under proprietary_blend_hides_dose with additional adulteration-risk concern for the category and seller profile.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "vivioptal-protect-for-men-multivitamin-multimineral-supplement-30-capsules",
      "title": "Vivioptal PROTECT For Men Multivitamin & Multimineral Supplement 30 Capsules",
      "vendor": "The Beauty Box",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/51Iktv0X_YL.jpg?v=1787590961",
      "score": 58,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "vivioptal",
        "protect",
        "for",
        "men",
        "multivitamin",
        "multimineral",
        "supplement",
        "capsules",
        "the",
        "beauty",
        "box"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 65,
        "safety": 62,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 22,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804464664773",
      "vsf_explanation": "Vivioptal is a Merck consumer-health brand primarily distributed in Latin American and Middle Eastern markets — a legitimate multinational pharmaceutical company's OTC supplement line with real cGMP manufacturing infrastructure and adverse-event monitoring at pharma-brand scale. The Vivioptal Protect For Men formulation is a broad-spectrum multivitamin/multimineral targeting the mens-health demographic, typically including standard B-complex, antioxidant vitamins (C, E, D), zinc, selenium, and often lycopene or saw palmetto for prostate-relevant marketing positioning. Multivitamin evidence overall is mixed — cohort-based studies (COSMOS 2022 for cognition, Physicians Health Study II for cancer) show small benefits in some outcomes and no benefit or slight harm in others (beta-carotene arm of ATBC/CARET, calcium arm concerns). For general-population healthy adults, multivitamins are neither strongly beneficial nor obviously harmful when doses are within safe ranges. The Vivioptal Protect formulation itself is likely reasonable at Merck's manufacturing tier. Marks off primarily for the underlying evidence-category weakness (multivitamins are broadly middle-tier evidence), imported-brand availability variance, and typical multivitamin transparency depth (per-ingredient disclosure present but sourcing and standardization detail modest). Scored at Rejected 58, just under the Standard threshold — a defensible product that doesn't clearly earn the Standard tier given the category's evidence limitations.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "forever-vitolize-for-women-hormonal-balance-urinary-health-120-tablets",
      "title": "Forever Vitolize for Women Hormonal Balance & Urinary Health 120 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/vitolize-womens-vitality-background.png?v=1787590969",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "forever",
        "vitolize",
        "for",
        "women",
        "hormonal",
        "balance",
        "urinary",
        "health",
        "120",
        "tablets",
        "singers",
        "health",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 32,
        "sustainability": 42
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804464730309",
      "vsf_explanation": "Forever Vitolize is a product from Forever Living Products — a multi-level marketing (MLM) company founded in 1978, primarily known for aloe vera products, that operates through a distributor network compensation structure rather than direct retail. MLM supplement brands have structural incentive issues: distributor compensation depends on product sales through the downline structure, which creates pressure toward inflated efficacy claims independent of the underlying formulation quality. Vitolize for Women is positioned as a hormonal-balance and urinary-health supplement — typical women's health MLM formulations combine cranberry (real evidence for UTI prevention in some populations at proanthocyanidin doses), some blend of botanicals (typically dong quai, chasteberry/vitex, black cohosh, wild yam), and various vitamins. The actual per-ingredient milligrams are typically obscured behind proprietary blend labeling. Autofailed under proprietary_blend_hides_dose with additional consideration for the MLM distribution structure that limits independent verification of formulation and efficacy claims.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "glowup",
      "title": "GlowUp",
      "vendor": "CVMK GLOBAL",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/glowup-701684.jpg?v=1787590978",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glowup",
        "cvmk",
        "global"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 35,
        "manufacturing": 42,
        "safety": 48,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804464894149",
      "vsf_explanation": "'GlowUp' from 'CVMK GLOBAL' — obscure brand with generic vitality-branded product name and no supplement-industry footprint visible. Beauty-from-within supplements as a category have some legitimate ingredients with evidence (collagen peptides for skin elasticity and hydration, biotin for deficient users, hyaluronic acid oral supplementation with modest evidence, astaxanthin for UV skin response) — but products branded on aspirational language ('GlowUp,' 'Radiance,' 'Beauty Blend') without ingredient specificity typically use proprietary blends that hide the actual per-ingredient amounts of the supposedly active compounds. Without label disclosure, without brand credibility, and given the CVMK GLOBAL seller's dual presence in this batch (also 'SAMSON' male-supplement SKU), the product profile signals private-label dropshipping rather than serious beauty-supplement formulation. Autofailed under proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "passion-female-enhancement-supplement",
      "title": "Passion Female Enhancement Supplement",
      "vendor": "ForWomn | Women's Health and Nutrition Supplements and More",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Passion-Female-Enhancement-Supplement.png?v=1787590990",
      "score": 36,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "passion",
        "female",
        "enhancement",
        "supplement",
        "forwomn",
        "women",
        "health",
        "and",
        "nutrition",
        "supplements",
        "and",
        "more"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 30,
        "manufacturing": 35,
        "safety": 35,
        "transparency": 22,
        "sustainability": 42
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804464992453",
      "vsf_explanation": "'Passion Female Enhancement Supplement' from a brand ('ForWomn') branded as women's supplements retailer. Same failure profile as the other female enhancement products in this batch: no ingredient disclosure at title level, adulteration-risk category (FDA Tainted Products database documents undisclosed sildenafil, tadalafil, and hormone analogs in female-enhancement supplements), obscure brand identity without third-party testing programs or documented manufacturing infrastructure. Autofailed under proprietary_blend_hides_dose with additional concern for the category's documented adulteration profile.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "nugenix-t-boost-free-testosterone-booster-supplement-for-men-90-count",
      "title": "Nugenix T Boost - Free Testosterone Booster Supplement for Men, 90 Count",
      "vendor": "Price Is Right Miami",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4fbb1cc3-0803-4a6d-9f25-053edae37e31.jpg?v=1787591005",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "nugenix",
        "boost",
        "free",
        "testosterone",
        "booster",
        "supplement",
        "for",
        "men",
        "count",
        "price",
        "right",
        "miami"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 42,
        "manufacturing": 52,
        "safety": 48,
        "transparency": 32,
        "sustainability": 45
      },
      "price": 49.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804465123525",
      "vsf_explanation": "Nugenix is a mainstream testosterone-booster brand (marketed by Adaptive Health, sold heavily via TV/late-night advertising and mass retail including GNC). The Nugenix line has historically used proprietary blends that hide per-ingredient milligrams behind a single 'Testosterone Complex' or similar grouped panel line item. The category — natural testosterone boosters marketed to middle-aged men — has weak evidence overall for measurable testosterone level increases in eugonadal men, with meta-analyses consistently showing modest or null effects for most of the common ingredients. Nugenix formulations typically feature Testofen (a fenugreek extract, one of the few natural test-boosters with mixed positive evidence for testosterone and libido), zinc, and vitamin B6/B12 — but with the Testofen dose obscured by the proprietary blend structure, users cannot verify whether they are ingesting the studied 600 mg/day dose. Distributed via a Shopify reseller rather than direct from Nugenix, though the underlying brand is legitimate mid-market. Autofailed under proprietary_blend_hides_dose. Sold at Rejected 42 rather than lower because the parent brand and manufacturing are real, even if the label transparency fails Vyvata's standard.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "coral-calcium-supplement-with-vitamin-d3-magnesium-coral-complex",
      "title": "Coral Calcium Supplement with Vitamin D3 & Magnesium – Coral Complex",
      "vendor": "Coral Toothpaste",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Coral_Complex_90_Caps_Image_b7d3501e-ee25-4314-b5bb-736de6dbf6cf.webp?v=1787591191",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "immune",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coral",
        "calcium",
        "supplement",
        "with",
        "vitamin",
        "magnesium",
        "coral",
        "complex",
        "coral",
        "toothpaste"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 45,
        "manufacturing": 42,
        "safety": 45,
        "transparency": 38,
        "sustainability": 32
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804468695237",
      "vsf_explanation": "Coral Calcium 'Complex' formulation combining coral-sourced calcium with vitamin D3 and magnesium. Adding vitamin D3 (for calcium absorption from the gut) and magnesium (a bone-health cofactor) is a chemistry-appropriate combination for a bone-support product — this is genuine formulation science versus the plain coral calcium SKU. However, the same misleading_naming issue applies: 'coral' as the sourcing story does not add bioavailability benefit over calcium carbonate from any other source, and the product name leverages the coral-origin marketing halo carrying FTC-precedent fraud history. Marginally higher score than the plain coral calcium powder because the D3+magnesium combination is legitimately better formulation practice for calcium supplementation, but still autofailed under misleading_naming for the coral positioning.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "ecopure-pure-coral-calcium-powder-454-grams",
      "title": "EcoPure Pure Coral Calcium Powder – 454 Grams",
      "vendor": "Coral Toothpaste",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Ecopure_Powder.webp?v=1787591206",
      "score": 36,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ecopure",
        "pure",
        "coral",
        "calcium",
        "powder",
        "454",
        "grams",
        "coral",
        "toothpaste"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 38,
        "manufacturing": 42,
        "safety": 38,
        "transparency": 32,
        "sustainability": 32
      },
      "price": 39.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804468859077",
      "vsf_explanation": "Coral calcium is the FTC-precedent case for supplement marketing fraud. In 2004, the Federal Trade Commission fined the makers of 'Coral Calcium Supreme' more than $1 million for false cure claims — that product was marketed by Kevin Trudeau and Robert Barefoot as a cure for cancer, heart disease, multiple sclerosis, and dozens of other conditions, based on a 'coral origin gives special bioavailability' story that had no scientific basis. The underlying chemistry is straightforward: calcium is calcium. Calcium carbonate from coral is chemically equivalent to calcium carbonate from limestone or oyster shell. The 'coral origin' story is marketing narrative, not a bioavailability story — no published head-to-head comparison shows coral-derived calcium is meaningfully better absorbed than any other calcium salt at equivalent dose. Additionally, coral calcium sourcing raises environmental sustainability concerns — living coral reef harvesting is illegal in most jurisdictions and the industry has historically used fossilized coral to sidestep that; even fossilized coral extraction from reef-adjacent seabed carries ecological footprint. Autofailed under misleading_naming (the 'coral' framing implies superior bioavailability that is not evidenced) with sustainability marks off for the sourcing profile.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "ligone-berberis-vulgaris-dietary-supplement-for-adults-60-capsules-liver",
      "title": "Ligone Berberis Vulgaris Dietary Supplement for Adults - 60 Capsules, Liver",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/jxZfhtn8X6uT4oBV7vESXTDqmIMKc6BgD21MNnmC.jpg?v=1787591241",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ligone",
        "berberis",
        "vulgaris",
        "dietary",
        "supplement",
        "for",
        "adults",
        "capsules",
        "liver",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 38.85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804469809349",
      "vsf_explanation": "Berberis vulgaris (European barberry) is the historical primary source of berberine, one of the most robustly-studied nutraceutical actives — Yin 2008 (500mg TID for 3 months in T2D) showed HbA1c reduction comparable to metformin; Zhang 2010 showed similar lipid effects. Berberine at 500mg BID/TID has real Grade A evidence for glucose control and lipid modification. The concern is that this SKU lists \"Berberis vulgaris\" (the whole plant/extract) rather than \"berberine HCl\" (the isolated active) — Berberis vulgaris root extract contains variable berberine content (typically 4-8% by weight), so a 500mg capsule of the extract delivers ~20-40mg berberine, roughly 10-25x below the studied 500mg TID berberine dose. The \"Liver\" tag in the title suggests hepatoprotective positioning, which berberine does have limited evidence for at higher doses. Standard tier because the plant is real; would fall to Rejected if the dose math is confirmed to be subclinical.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dr-tobias-colon-14-day-cleanse-advanced-gut-cleanse-detox-for-women-men-with-cascara-sagrada-psyllium-husk-senna-leaf-non-gmo-colon-cleanse-28-capsules-1-2-daily",
      "title": "Dr. Tobias Colon 14 Day Cleanse, Advanced Gut Cleanse Detox for Women & Men with Cascara Sagrada, Psyllium Husk & Senna Leaf, Non-GMO Colon Cleanse, 28 Capsules (1-2 Daily)",
      "vendor": "NutritionAdvice",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/61z4pl0j7uL._AC_SL1500.jpg?v=1787591253",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "tobias",
        "colon",
        "day",
        "cleanse",
        "advanced",
        "gut",
        "cleanse",
        "detox",
        "for",
        "women",
        "men",
        "with",
        "cascara",
        "sagrada",
        "psyllium",
        "husk",
        "senna",
        "leaf",
        "non",
        "gmo",
        "colon",
        "cleanse",
        "capsules",
        "daily",
        "nutritionadvice"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 38,
        "manufacturing": 42,
        "safety": 32,
        "transparency": 42,
        "sustainability": 42
      },
      "price": 68.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804469940421",
      "vsf_explanation": "Dr. Tobias Colon 14 Day Cleanse is a colon-cleanse / detox positioning product built around stimulant laxatives — senna leaf (sennosides), cascara sagrada — combined with psyllium husk (a legitimate soluble fiber). The 'detox' and 'colon cleanse' positioning is an unverified medical claim: the colon does not require pharmaceutical or herbal cleansing in a person with normal bowel function, and there is no clinical evidence that supplement-based colon cleansing improves health outcomes in healthy adults. Additionally and more seriously, stimulant laxatives (senna, cascara sagrada) used for periods longer than a few days cause dependence — the bowel becomes reliant on stimulant input to trigger peristalsis, and stopping the product produces rebound constipation that reinforces continued use. Chronic stimulant-laxative use causes electrolyte disturbances (potassium loss, magnesium loss), can cause 'melanosis coli' (harmless but visible colon lining discoloration), and in prolonged use has been associated with impaired bowel function. Cascara sagrada was reclassified by FDA in 2002 as not generally recognized as safe and effective for OTC laxative use due to insufficient safety data at long-term use, though it remained available as a supplement under DSHEA. 14 days of stimulant-laxative daily use is not medically appropriate for a general-population 'cleanse' — it is longer than the medical maximum for OTC senna use. Autofailed under unverified_medical_claim (the 'detox' and 'cleanse' positioning) with additional serious safety concern around stimulant-laxative dependency and electrolyte risk.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "aga-k-dietary-supplement-60-tablets-for-health-and-wellness-support",
      "title": "Aga-K Dietary Supplement - 60 Tablets for Health and Wellness Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Xmu9k9jJoQBak899HDEq265wpU7r0G9UNJb9AaxY_77a5fb1b-eb68-4c9b-b787-686ddf1bb75b.jpg?v=1787591267",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "aga",
        "dietary",
        "supplement",
        "tablets",
        "for",
        "health",
        "and",
        "wellness",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 40,
        "manufacturing": 42,
        "safety": 45,
        "transparency": 32,
        "sustainability": 42
      },
      "price": 47.81,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804470726853",
      "vsf_explanation": "\"Aga-K Dietary Supplement for Health and Wellness Support\" is a triple-vague product name: made-up brand-word, generic \"dietary supplement\" category, and \"health and wellness support\" as the benefit — which is undefined and unfalsifiable. No ingredients disclosed at title level. This is the maximum-opacity form of a proprietary blend and represents the exact SKU pattern Vyvata's misleading_naming and proprietary_blend_hides_dose autofails were designed to reject. Auto-failed under misleading_naming. The \"K\" in the brand name may suggest vitamin K, but that is speculation without label disclosure. Score in the low 40s reflects that the brand is at least a real reseller product; not an endorsement.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "day2day-collagen-beauty-intense-12g-30-sachets",
      "title": "Day2Day Collagen Beauty Intense - 12g | 30 Sachets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/43l6AeKBNbuB2p2TN3wlFImOnrxjxzMkwLbrEFH1.jpg?v=1787591317",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "day2day",
        "collagen",
        "beauty",
        "intense",
        "12g",
        "sachets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 51.62,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804471185605",
      "vsf_explanation": "This is the best product in the a US reseller channel lineup by an honest margin: 12g per sachet is a real clinical dose of hydrolyzed collagen — Proksch 2014 (Verisol at 2.5g) showed skin elasticity improvement; larger trials (Kim 2018 at 10g/day) showed sustained skin hydration, elasticity, and dermal collagen density improvements over 12 weeks. A 12g/day dose sits at the high end of the evidence base. Sachet format allows the higher dose that capsules cannot deliver (a 12g capsule dose would require 24 large capsules). Concerns: (1) collagen source (marine vs bovine) and standardization (Verisol, Peptan, or generic) not disclosed at title level; (2) a US reseller channel is a US reseller of a Turkish brand without published per-lot COAs. Solid Standard tier with room to move to Verified with source and third-party testing disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "axe-sledge-intake",
      "title": "Axe & Sledge Intake",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Axe-Sledge-Intake.jpg?v=1787591326",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "axe",
        "sledge",
        "intake",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 45,
        "manufacturing": 48,
        "safety": 55,
        "transparency": 32,
        "sustainability": 45
      },
      "price": 46.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804471283909",
      "vsf_explanation": "Axe & Sledge Intake is another pre-workout / intra-workout SKU from the Seth Feroce brand, likely positioned as a stim-free or intra-workout carbohydrate/amino formula. Category default autofail on proprietary blend structure for the amino/pump matrix (assuming standard Axe & Sledge formulation approach). Rejected tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "axe-sledge-demo-day",
      "title": "Axe & Sledge Demo Day",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Axe-Sledge-Demo-Day_83766845.jpg?v=1787591336",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "axe",
        "sledge",
        "demo",
        "day",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 42,
        "manufacturing": 48,
        "safety": 42,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 54.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804471480517",
      "vsf_explanation": "Axe & Sledge Demo Day is a stimulant pre-workout from the Seth Feroce brand. Category default autofail on proprietary blend structure for stimulant/pump matrix. Rejected tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hi-tech-creatine-monohydrate-400g",
      "title": "Hi-Tech Creatine Monohydrate 400g",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Hi-Tech-Creatine-Monohydrate-400g.jpg?v=1787591575",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tech",
        "creatine",
        "monohydrate",
        "400g",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 88,
        "formulation": 60,
        "manufacturing": 52,
        "safety": 72,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 24.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804479508677",
      "vsf_explanation": "Hi-Tech Pharmaceuticals is a Georgia-based supplement manufacturer with an extensive FDA warning-letter history — the brand has been the subject of multiple FDA enforcement actions primarily related to prohormone and stimulant SKUs (including compounds later determined to be unapproved pharmaceutical analogs). That history is relevant to brand-level manufacturing and safety confidence even for single-ingredient SKUs. However, creatine monohydrate itself is a commodity, well-characterized, high-evidence ingredient — the specific SKU here is not one implicated in the FDA history. Scored at low Standard: the ingredient earns points, the brand history costs points on manufacturing and transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrabio-caffeine-pills-200-mg",
      "title": "NutraBio Caffeine Pills 200 mg",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NutraBio-Caffeine-Pills-200-mg_450b845e.jpg?v=1787591575",
      "score": 74,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrabio",
        "caffeine",
        "pills",
        "200",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 82,
        "formulation": 68,
        "manufacturing": 78,
        "safety": 68,
        "transparency": 85,
        "sustainability": 55
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804479410373",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 0 → new 74. Evidence found: Grgic J et al. Wake up and smell the coffee: caffeine supplementation and exercise performance—an umbrella review of 21 published meta-analyses. Br J Sports Med. 2020;54(11):681-688. | McLellan TM et al. A review of caffeine's effects on cognitive, physical and occupational performance. Neurosci Biobehav Rev. 2016;71:294-312.. Rationale: Caffeine has TIER-A evidence for cognitive performance and exercise ergogenic effect (Grgic 2020 umbrella review). 200 mg is a standard cognitive/ergogenic unit dose. NutraBio USP-grade caffeine with full label transparency. Verified tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "revive-essential-vitamins-pack",
      "title": "Revive Essential Vitamins Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Revive-Essential-Vitamins-Pack.jpg?v=1787591575",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "revive",
        "essential",
        "vitamins",
        "pack",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 59.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804479541445",
      "vsf_explanation": "Revive Essential Vitamins Pack is a daily-dose multi-vitamin/mineral pack format from clean-label DTC brand Revive Supplements. Pack format (individual daily sachets with multiple pills) is a convenience delivery form that has grown in the biohacker and executive-wellness segment. Vitamin/mineral pack contents typically stack a comprehensive multivitamin plus dedicated D3, K2, magnesium, omega-3, and often additional actives. Evidence for multivitamin use in general well-nourished populations is genuinely mixed — the Physicians Health Study II (Sesso 2012) showed modest cancer risk reduction; other large trials have shown limited benefit. Doses in pack formats tend to be adequate to therapeutic ranges. Standard tier. Revive discloses ingredients; the pack format itself is a modest convenience premium over buying components separately.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "usp-labs-jack3d",
      "title": "USP Labs Jack3d",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/USP-Labs-Jack3d.jpg?v=1787591576",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "usp",
        "labs",
        "jack3d",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 32,
        "manufacturing": 38,
        "safety": 22,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 39.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804479738053",
      "vsf_explanation": "USP Labs Jack3d is one of the most safety-consequential brand names in the modern supplement industry. Original Jack3d (formulation era 2008-2013) contained DMAA (1,3-dimethylamylamine), a synthetic stimulant that the FDA banned from supplements in 2013 after DMAA was linked to multiple deaths including a 22-year-old US Army soldier and a 30-year-old marathon runner. The FDA's enforcement action against USP Labs also included criminal indictments of company executives, resulting in guilty pleas for conspiracy to defraud the FDA. Modern reformulated Jack3d does not contain DMAA, but the brand name itself carries safety-history weight — a reasonable buyer should evaluate this SKU with awareness of the brand's regulatory record. Even setting aside the historical context, Jack3d's current formulation follows the pre-workout category default: proprietary stimulant matrix, undisclosed individual doses. Autofail on proprietary_blend_hides_dose, with especially low safety-dimension score reflecting the DMAA history. Rejected tier — one of the lowest Rejected scores in this batch specifically because of the brand's regulatory and safety context.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "myogenix-myovite-multi-vitamin-44-capsules",
      "title": "Myogenix Myovite Multi-Vitamin - 44 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Myogenix-Myovite-Multi-Vitamin-44-Capsules.jpg?v=1787591575",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "myogenix",
        "myovite",
        "multi",
        "vitamin",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 65,
        "transparency": 52,
        "sustainability": 50
      },
      "price": 44.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804479475909",
      "vsf_explanation": "Myogenix Myovite is a multi-vitamin/mineral formula in an unusual 44-capsule count. Myogenix is a mid-tier sports-nutrition brand; multi-vitamin formulations from sports brands typically include higher-than-RDA doses of B-complex, ergogenic-adjunct minerals (magnesium, zinc), and antioxidants targeted at active populations. Evidence for multivitamin benefit in generally well-nourished athletes is mixed but non-negative. Myogenix does not prominently publish per-lot COA or NSF Certified for Sport for this SKU. Formulation likely fully-disclosed rather than proprietary-blended (multivitamins rarely use blends). Low Standard tier — the underlying category is legitimate, brand-level manufacturing/transparency documentation is modest.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "revive-glutamine",
      "title": "Revive Glutamine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Revive-Glutamine.jpg?v=1787591575",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "revive",
        "glutamine",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 78,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804479443141",
      "vsf_explanation": "Revive Glutamine is single-ingredient L-glutamine from clean-label DTC brand Revive. Glutamine is a non-essential amino acid heavily marketed in the bodybuilding space for recovery and immune support. Evidence is more equivocal than marketing implies: for gut integrity/leaky-gut protocols and post-surgical recovery there is Grade B evidence at 10-30 g/day doses; for muscle recovery in healthy trained individuals the evidence is Grade C to weakly positive at best. The body synthesizes glutamine and dietary protein delivers substantial amounts. Revive discloses dose per serving. Single-ingredient. Standard tier — cleanly manufactured product; the ingredient itself has a modest evidence ceiling for its most-marketed use.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "revive-cortisol-support",
      "title": "Revive Cortisol Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Revive-Cortisol-Support.jpg?v=1787591575",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "revive",
        "cortisol",
        "support",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 49.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804479574213",
      "vsf_explanation": "Revive Cortisol Support is a stress/adaptogen formula from clean-label Revive Supplements. Cortisol-support formulas typically combine ashwagandha (KSM-66 or Sensoril), rhodiola, phosphatidylserine, magnesium, and sometimes L-theanine or holy basil. Individual ingredients have Grade B evidence for perceived stress reduction and modest cortisol effect at studied doses (ashwagandha 300-600 mg, rhodiola 200-400 mg, PS 300 mg). Revive typically discloses doses on the panel. Marketing claim ('cortisol support') is diffuse but not overtly medical — did not autofail on unverified_medical_claim because ashwagandha and rhodiola cortisol effects are real and published. Standard tier. If Revive discloses full ingredient panel with per-ingredient doses in the studied range, this is a reasonable clean-label option in a category that is frequently proprietary-blend junk elsewhere.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "innovapharm-novapump",
      "title": "InnovaPharm NovaPump",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/InnovaPharm-NovaPump.jpg?v=1787591575",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "innovapharm",
        "novapump",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 45,
        "manufacturing": 48,
        "safety": 55,
        "transparency": 32,
        "sustainability": 45
      },
      "price": 46.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804479967429",
      "vsf_explanation": "InnovaPharm NovaPump is a stim-free pump pre-workout in the same category as Bucked Up FLOW, RAW Thuper Pump, and Metabolic Stim-Free Pump. Formulation typically combines citrulline, glycerol, and pump-matrix components. InnovaPharm is a mid-tier brand with limited public transparency documentation; formulations historically use proprietary blend structure on pump matrices. Autofail on proprietary_blend_hides_dose. Same safety-tier advantage as other stim-free pumps (no cardiovascular stimulant load) but transparency autofail applies. Rejected tier.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "species-nutrition-somalyze-90-capsules",
      "title": "Species Nutrition Somalyze - 90 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Species-Nutrition-Somalyze-90-Capsules.jpg?v=1787591575",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "species",
        "nutrition",
        "somalyze",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 35,
        "manufacturing": 45,
        "safety": 40,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 49.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804479606981",
      "vsf_explanation": "Species Nutrition Somalyze is a growth-hormone-support / fat-burner hybrid capsule marketed on 'somatotropic' and GH-release positioning. Products in this category (GH-boosters) universally rely on proprietary blends of amino acids (arginine, ornithine, lysine, GABA), sleep/relaxation ingredients (mucuna pruriens for L-DOPA content), and sometimes stimulant thermogenics. The GH-release claim itself is largely unverified — oral amino acids at supplement doses produce transient minor GH pulses of dubious clinical significance in healthy adults with intact endogenous GH secretion. Autofail on proprietary_blend_hides_dose plus unverified GH-release claim implication. Rejected tier.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "metabolic-nutrition-glycoload",
      "title": "Metabolic Nutrition Glycoload",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Metabolic-Nutrition-Glycoload.jpg?v=1787591575",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "metabolic",
        "nutrition",
        "glycoload",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 27.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804479639749",
      "vsf_explanation": "Metabolic Nutrition Glycoload is a carbohydrate-loading formula for physique competitors and endurance athletes. Typical formulation is cyclic dextrin (highly-branched cyclic dextrin/HBCD) or a mix of complex carbohydrates optimized for gastric emptying and glycogen loading. Cyclic dextrin at 30-60 g/serving has Grade B evidence for faster gastric emptying and less GI distress than simple sugars during endurance exercise, and adequate glycogen loading in the 8-12 g/kg body weight range has Grade A evidence for endurance performance and physique-competition muscle-fullness protocols. Single-active category (carbohydrate). Standard tier. Not autofailed — no proprietary stimulant blend concerns for a pure carbohydrate powder.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "metabolic-nutrition-creatine-monohydrate",
      "title": "Metabolic Nutrition Creatine Monohydrate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Metabolic-Nutrition-Creatine-Monohydrate.jpg?v=1787591575",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "metabolic",
        "nutrition",
        "creatine",
        "monohydrate",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 88,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 82,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804480098501",
      "vsf_explanation": "Metabolic Nutrition Creatine Monohydrate is single-ingredient creatine monohydrate powder. Same Grade A evidence category as all creatine monohydrate SKUs. Metabolic Nutrition is a mid-tier sports-nutrition brand with a real product catalog; NSF/Informed Sport certification and per-lot COA publication for this SKU are not prominently documented. Standard tier — the ingredient category is essentially a commodity; brand-level manufacturing transparency documentation is what differentiates within the tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrabio-melatonin-120-capsules",
      "title": "NutraBio Melatonin 120 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nutrabio-Melatonin-120-Capsules.jpg?v=1787591575",
      "score": 74,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrabio",
        "melatonin",
        "120",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 65,
        "manufacturing": 80,
        "safety": 65,
        "transparency": 85,
        "sustainability": 55
      },
      "price": 16.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804480164037",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 0 → new 74. Evidence found: Ferracioli-Oda E et al. Meta-analysis: melatonin for the treatment of primary sleep disorders. PLoS One. 2013;8(5):e63773. | Herxheimer A, Petrie KJ. Melatonin for the prevention and treatment of jet lag. Cochrane Database Syst Rev. 2002;(2):CD001520.. Rationale: Melatonin has TIER-A evidence for sleep-onset latency and jet lag. NutraBio full-transparency melatonin (dose disclosed on label). Verified tier assuming dose is in evidence-appropriate 0.5-5 mg range — verify against current label.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dragon-pharma-creatine-monohydrate-1kg-200-servings",
      "title": "Dragon Pharma Creatine Monohydrate, 1KG - 200 Servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Dragon-Pharma-Creatine-Monohydrate-1KG-200-Servings.jpg?v=1787591576",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dragon",
        "pharma",
        "creatine",
        "monohydrate",
        "1kg",
        "200",
        "servings",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 88,
        "formulation": 60,
        "manufacturing": 50,
        "safety": 78,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 59.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804480229573",
      "vsf_explanation": "Dragon Pharma is a bodybuilding-market-oriented supplement brand with distribution primarily targeting the physique/bodybuilding community. Creatine monohydrate SKUs from this segment are commodity single-ingredient products — same Grade A evidence base regardless of brand. Dragon Pharma has less public quality documentation than mainstream US sports-nutrition brands (limited NSF/Informed Sport visibility, minimal per-lot COA publication trail). The 1 kg bulk format at 200 servings is a value-optimized SKU. Low Standard tier — ingredient credit, brand-transparency deficit.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bucked-up-essentials-creatine-250-grams",
      "title": "Bucked Up Essentials Creatine, 250 Grams",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Bucked-Up-Essentials-Creatine-250-Grams.jpg?v=1787591576",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bucked",
        "essentials",
        "creatine",
        "250",
        "grams",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 88,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 82,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804480196805",
      "vsf_explanation": "Bucked Up Essentials Creatine is the single-ingredient creatine SKU from Bucked Up's Essentials sub-line — analogous to the Basics line at Ghost. Single-ingredient bulk creatine monohydrate, Grade A ingredient evidence base, no proprietary blend issues, no deer antler velvet concern (this is single-active). Standard mid-tier — the Essentials sub-line signals a departure from the parent brand's proprietary-blend flagship pre-workout pattern. Solid Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "project-ad-matador",
      "title": "Project AD Matador",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Project-AD-Matador.jpg?v=1787591575",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "project",
        "matador",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 40,
        "manufacturing": 48,
        "safety": 40,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 48.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804480262341",
      "vsf_explanation": "Project AD Matador is a stimulant thermogenic fat-burner capsule. Same category autofail pattern as Bucked Up Heat, Stimulean, and JUST LOSE IT — proprietary stimulant blend, weight-loss marketing implication, cardiovascular safety concern from opaque total stimulant load. Rejected tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "revive-supplements-vitamin-c",
      "title": "Revive Supplements Vitamin C",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Revive-Supplements-Vitamin-C.jpg?v=1787591575",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "revive",
        "supplements",
        "vitamin",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 75,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 17.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804480491717",
      "vsf_explanation": "Revive Supplements Vitamin C is a single-ingredient vitamin C capsule from clean-label DTC brand Revive. Vitamin C has Grade A evidence for scurvy prevention and Grade B for modest cold-duration reduction at 500+ mg/day taken consistently. Revive discloses dose per serving. Single-ingredient category — no proprietary blend concerns. Standard tier. Solid clean product; the ingredient itself is essentially commodity but well-suited to a transparency-focused clean-label brand.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrabio-l-citrulline-powder-150-g",
      "title": "Nutrabio L-Citrulline Powder - 150 g",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nutrabio-L-Citrulline-Powder-150-g.jpg?v=1787591576",
      "score": 76,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrabio",
        "citrulline",
        "powder",
        "150",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 72,
        "manufacturing": 80,
        "safety": 78,
        "transparency": 85,
        "sustainability": 55
      },
      "price": 23.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804480295109",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 0 → new 76. Evidence found: Pérez-Guisado J, Jakeman PM. Citrulline malate enhances athletic anaerobic performance and relieves muscle soreness. J Strength Cond Res. 2010;24(5):1215-1222. | Schwedhelm E et al. Pharmacokinetic and pharmacodynamic properties of oral L-citrulline and L-arginine. Br J Clin Pharmacol. 2008;65(1):51-59. | Bailey SJ et al. L-citrulline supplementation improves O2 uptake kinetics and high-intensity exercise performance in humans. J Appl Physiol. 2015;119(4):385-395.. Rationale: L-citrulline is more effective at raising plasma arginine than L-arginine itself (Schwedhelm 2008). TIER-B evidence for anaerobic performance, soreness, and vasodilation. NutraBio powder allows precise dosing at 3-6 g/day. Verified tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrabio-ribose",
      "title": "NutraBio Ribose",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NutraBio-Ribose.jpg?v=1787591576",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrabio",
        "ribose",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 65,
        "manufacturing": 80,
        "safety": 75,
        "transparency": 85,
        "sustainability": 55
      },
      "price": 47.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804480393413",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 0 → new 62. Evidence found: Omran H et al. D-Ribose improves diastolic function and quality of life in congestive heart failure patients: a prospective feasibility study. Eur J Heart Fail. 2003;5(5):615-619. | Teitelbaum JE et al. The use of D-ribose in chronic fatigue syndrome and fibromyalgia: a pilot study. J Altern Complement Med. 2006;12(9):857-862.. Rationale: D-Ribose has TIER-C evidence — small trials in heart failure (Omran 2003) and CFS/fibromyalgia (Teitelbaum 2006) with positive signals but limited replication and small samples. NutraBio brand transparency is high but the ingredient category lacks robust evidence. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "metabolic-nutrition-nad-max-30-capsules",
      "title": "Metabolic Nutrition NAD MAX - 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Metabolic-Nutrition-NAD-MAX-30-Capsules.jpg?v=1787591575",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "metabolic",
        "nutrition",
        "nad",
        "max",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 32,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 39.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804480327877",
      "vsf_explanation": "Metabolic Nutrition NAD MAX in 30-capsule count is structurally underdosed for the ingredient category it represents. NAD+ precursor supplementation (NMN or NR — Metabolic Nutrition does not clearly disclose which) has Grade B evidence for raising blood NAD+ metabolite pools at doses of 250-500 mg/day taken consistently. A 30-capsule package is a 30-day supply at 1 capsule/day — for this to deliver an evidence-relevant dose the single capsule would need to contain 250+ mg NMN or NR. Metabolic Nutrition does not prominently document that per-capsule dose, and the '30 capsules' framing strongly suggests either underdosing or a very short supply run. Autofail on sub_therapeutic_dose for a longevity-marketed product with a category-inadequate per-serving amount. Rejected tier.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "mother-earth-labs-live-active-cardioexcel",
      "title": "Mother Earth Labs Live Active - CardioExcel",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Mother-Earth-Labs-Live-Active-CardioExcel.jpg?v=1787591575",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mother",
        "earth",
        "labs",
        "live",
        "active",
        "cardioexcel",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 62.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804480360645",
      "vsf_explanation": "Mother Earth Labs Live Active CardioExcel is a cardiovascular-support formula from a premium wellness-oriented brand. Formulations in this category typically stack CoQ10/ubiquinol, magnesium, K2, taurine, hawthorn, and sometimes L-arginine or nitrate sources. Evidence for individual ingredients is Grade B-A at studied doses; end-to-end formula RCT evidence is limited (typical of multi-ingredient stacks). Mother Earth Labs is a mid-size wellness brand with reasonable transparency but not the top-tier documentation of Life Extension or Thorne. Standard tier. Not autofailed — no dominant proprietary blend concern for the wellness-brand category.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "innovapharm-tudca-60-capsules",
      "title": "InnovaPharm Tudca, 60 capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/InnovaPharm-Tudca-60-capsules.jpg?v=1787591576",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "innovapharm",
        "tudca",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 50,
        "safety": 62,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 38.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804480590021",
      "vsf_explanation": "TUDCA (tauroursodeoxycholic acid) is a bile acid derivative with legitimate pharmaceutical use as a liver-support compound. It is UDCA (ursodiol) conjugated with taurine, delivering similar cholestasis-reducing and hepatocyte-protective effects. TUDCA has Grade B evidence for liver support in specific clinical contexts (cholestatic conditions, drug-induced liver injury adjunct) at 500-1500 mg/day, and Grade C evidence for the biohacker-adjacent 'liver support during PED cycles' use case that drives its bodybuilding-space marketing. InnovaPharm's TUDCA is a single-active supplement. The critical variables are (1) actual TUDCA content vs. UDCA or nicotinamide substitution (the TUDCA supply chain has quality issues), and (2) per-capsule dose. InnovaPharm does not prominently publish per-lot identity testing. Standard tier — legitimate ingredient class, brand-level documentation is modest.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dragon-pharma-creatine-monohydrate-300-grams-60-servings",
      "title": "Dragon Pharma Creatine Monohydrate, 300 Grams - 60 Servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Dragon-Pharma-Creatine-Monohydrate-300-Grams-60-Servings.jpg?v=1787591576",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dragon",
        "pharma",
        "creatine",
        "monohydrate",
        "300",
        "grams",
        "servings",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 88,
        "formulation": 60,
        "manufacturing": 50,
        "safety": 78,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804480426181",
      "vsf_explanation": "Dragon Pharma Creatine Monohydrate 300 g is the smaller-format version of the 1 kg SKU above. Same commodity ingredient, same brand-transparency limitations, same low-Standard tier score. Ingredient itself is Grade A evidence category; brand-level documentation lags mainstream US sports-nutrition brands.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "metabolic-nutrition-creatine-5000-180-capsules",
      "title": "Metabolic Nutrition Creatine 5000 - 180 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Metabolic-Nutrition-Creatine-5000-180-Capsules.jpg?v=1787591576",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "metabolic",
        "nutrition",
        "creatine",
        "5000",
        "180",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 88,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 78,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 43.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804480458949",
      "vsf_explanation": "Metabolic Nutrition Creatine 5000 in 180-capsule format. The '5000' designation implies 5 g creatine per serving — buyer should verify whether that is 5 g in 1 capsule (unlikely, mechanically hard to fit in a standard capsule) or 5 g across multiple capsules (typical for capsule creatine products, usually 4-7 capsules per 5 g serving). 180 capsules at typical 750 mg/cap yields roughly 25-30 servings. Same Grade A ingredient evidence as any creatine monohydrate. Standard tier. Capsule format is cost-inefficient vs. powder for creatine specifically.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "revive-omega-3-120-capsules",
      "title": "Revive Omega 3 - 120 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Revive-Omega-3-120-Capsules.jpg?v=1787591575",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "revive",
        "omega",
        "120",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 78,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 34.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804480524485",
      "vsf_explanation": "Revive Omega 3 is a fish oil / EPA+DHA supplement from clean-label DTC brand Revive. 120-capsule count typically indicates a 60-120 day supply depending on serving size. Same ingredient category as Ghost Basics Fish Oil — Grade A for triglyceride reduction at 2-4 g/day EPA+DHA, weaker Grade B for general CV endpoints. Concentration and EPA+DHA per softgel are the key variables — Revive should disclose these on the panel. Revive does not publicly foreground IFOS 5-star certification. Standard tier — comparable to Ghost Basics Fish Oil.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mother-earth-labs-live-active-cogniactive",
      "title": "Mother Earth Labs Live Active - CogniActive",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Mother-Earth-Labs-Live-Active-CogniActive.jpg?v=1787591575",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mother",
        "earth",
        "labs",
        "live",
        "active",
        "cogniactive",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 66.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804480786629",
      "vsf_explanation": "Mother Earth Labs Live Active CogniActive is a cognitive-support formula in the same wellness-brand family as CardioExcel. Cognitive support formulas typically combine bacopa monnieri, lion's mane extract, alpha-GPC, phosphatidylserine, ginkgo biloba, and sometimes B-vitamins or acetyl-L-carnitine. Individual ingredients have Grade B-C evidence at studied doses (bacopa 300 mg standardized to 45-55% bacosides for memory over 8-12 weeks; alpha-GPC 300-600 mg for choline availability; lion's mane 500-1000 mg with weaker human evidence for cognitive endpoints despite promising mechanistic data). Standard tier for a legitimate multi-ingredient nootropic stack from a wellness brand. Not autofailed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dragon-pharma-dryup-80-capsules",
      "title": "Dragon Pharma DryUp - 80 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Dragon-Pharma-DryUp-80-Capsules.jpg?v=1787591575",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dragon",
        "pharma",
        "dryup",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 32,
        "manufacturing": 42,
        "safety": 25,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 24.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804480557253",
      "vsf_explanation": "Dragon Pharma DryUp is a diuretic capsule product marketed for physique-competition water-weight reduction — the same category as Metabolic Nutrition Hydra Max above. Same autofail concerns apply, arguably more sharply here given Dragon Pharma's lower brand-transparency profile: diuretic marketing crosses into unverified_medical_claim territory when framed as a safe consumer product, and the physique-competition use case has documented mortality from diuretic-related electrolyte disturbance in the bodybuilding community. Rejected tier — one of the lowest scores in this batch given the intersection of category risk and brand-transparency deficit.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "raw-nutrition-cbum-essential-performance-pre-workout",
      "title": "Raw Nutrition CBUM Essential Performance Pre-Workout",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Raw-Nutrition-CBUM-Essential-Performance-Pre-Workout_d0bcdaae.webp?v=1787591576",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "raw",
        "nutrition",
        "cbum",
        "essential",
        "performance",
        "pre",
        "workout",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 45,
        "transparency": 32,
        "sustainability": 45
      },
      "price": 39.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804480622789",
      "vsf_explanation": "RAW Nutrition CBUM (Chris Bumstead) Essential Performance Pre-Workout is a full-stimulant pre-workout from the CBUM line. Pre-workouts in this category near-uniformly use proprietary blend structure on stimulant and pump matrices. Celebrity brand identity does not confer transparency or formulation advantage. Autofail on proprietary_blend_hides_dose. Rejected tier.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "axe-sledge-pumpies-100-capsules",
      "title": "Axe & Sledge Pumpies - 100 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Axe-Sledge-Pumpies-100-Capsules.jpg?v=1787591575",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "axe",
        "sledge",
        "pumpies",
        "100",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 45,
        "manufacturing": 48,
        "safety": 55,
        "transparency": 32,
        "sustainability": 45
      },
      "price": 49.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804480819397",
      "vsf_explanation": "Axe & Sledge (Seth Feroce brand) Pumpies is a stim-free pump capsule product. Category is same as other stim-free pump products (NovaPump, Thuper Pump, FLOW). Axe & Sledge historically uses proprietary blend structure on pump matrices. Autofail on proprietary_blend_hides_dose. Rejected tier — safety-dimension score is meaningfully better than stimulant pre-workouts.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "raw-nutrition-cbum-essential-charged-pre-workout",
      "title": "Raw Nutrition CBUM Essential Charged Pre-Workout",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Raw-Nutrition-CBUM-Essential-Charged-Pre-Workout.webp?v=1787591576",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "raw",
        "nutrition",
        "cbum",
        "essential",
        "charged",
        "pre",
        "workout",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 42,
        "manufacturing": 55,
        "safety": 42,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 34.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804480852165",
      "vsf_explanation": "RAW Nutrition CBUM Essential Charged Pre-Workout is another stimulant pre-workout SKU in the CBUM line, likely differentiated from Essential Performance by higher stimulant load or different formulation profile. Same category autofail pattern as Essential Performance. Rejected tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "purus-labs-noxygen",
      "title": "Purus Labs Noxygen",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Purus-Labs-Noxygen.jpg?v=1787591576",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "purus",
        "labs",
        "noxygen",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 32,
        "sustainability": 45
      },
      "price": 21.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804480950469",
      "vsf_explanation": "Purus Labs Noxygen is a pre-workout pump product from the same brand as the Creatine ATP (PEAK-ATP) SKU above. Noxygen historically formulated around nitrate delivery for nitric-oxide-mediated vasodilation, often combined with additional pump matrix components. Standard pre-workout category autofail applies for proprietary blend structure. Rejected tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "metabolic-nutrition-stimulean",
      "title": "Metabolic Nutrition Stimulean",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Metabolic-Nutrition-Stimulean.jpg?v=1787591582",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "metabolic",
        "nutrition",
        "stimulean",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 40,
        "manufacturing": 48,
        "safety": 42,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 35.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804480983237",
      "vsf_explanation": "Metabolic Nutrition Stimulean is a stimulant thermogenic fat-burner. Same category autofail pattern as Bucked Up Heat and The Grind JUST LOSE IT — proprietary stimulant blend, weight-loss marketing implication, FTC substantiation concerns, cardiovascular safety risk from opaque total stimulant load. Rejected tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ghost®-basics-vitamin-c-glutathione",
      "title": "Ghost® Basics Vitamin C + Glutathione",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Ghost-Basics-Vitamin-C-Glutathione.jpg?v=1787591582",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ghost",
        "basics",
        "vitamin",
        "glutathione",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 75,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 22.36,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804481016005",
      "vsf_explanation": "Ghost Basics Vitamin C + Glutathione stacks two antioxidants with distinct evidence profiles. Vitamin C has Grade A evidence for scurvy prevention and general antioxidant status at 90-200 mg/day; higher doses (500-2000 mg) have Grade B evidence for modest cold-duration reduction and Grade C for general immune support. Oral glutathione has a real pharmacokinetic problem — as a tripeptide it is largely hydrolyzed to component amino acids (cysteine, glutamate, glycine) in the gut before systemic absorption; direct glutathione supplementation has weaker evidence than oral N-acetylcysteine (NAC) as a glutathione precursor. Ghost Basics discloses doses. Standard tier — solid single-formula clean product, though the glutathione ingredient's oral bioavailability caveat holds the evidence score mid-range.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "revive-heart-90-capsules",
      "title": "Revive Heart - 90 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Revive-Heart-90-Capsules.jpg?v=1787591585",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "revive",
        "heart",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 59.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804481114309",
      "vsf_explanation": "Revive Heart is a cardiovascular-support multi-ingredient formula from clean-label DTC brand Revive Supplements. Cardiovascular support formulas typically stack CoQ10/ubiquinol, magnesium, taurine, hawthorn extract, and sometimes garlic extract or K2. Each of those has at least Grade B evidence at studied doses for endothelial function, blood pressure, or specific cardiovascular endpoints. Revive typically discloses doses on the panel. Standard tier. The category itself has meaningful evidence for specific ingredient use cases but 'heart support' as a broad marketing claim is diffuse. Not autofailed because the underlying ingredients have real evidence and no dominant proprietary-blend concern in Revive's typical formulation style.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bucked-up-heat-fat-burner",
      "title": "Bucked Up Heat Fat Burner",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Bucked-Up-Heat-Fat-Burner.jpg?v=1787591585",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bucked",
        "heat",
        "fat",
        "burner",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 40,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 39.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804481147077",
      "vsf_explanation": "Bucked Up Heat is the brand's thermogenic fat-burner SKU — a category that near-uniformly uses proprietary stimulant blends combining caffeine sources, yohimbine/alpha-yohimbine, capsaicin, green tea extract, and often synephrine or paradoxine derivatives. Weight-loss marketing on a stimulant capsule product is regulated by the FTC at a substantiation standard that virtually no OTC fat-burner meets. Autofail on proprietary_blend_hides_dose plus unverified weight-loss claim implication. Same brand-portfolio concerns as other Bucked Up SKUs. Rejected.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "metabolic-nutrition-stim-free-pump-unflavored",
      "title": "Metabolic Nutrition Stim-Free Pump - Unflavored",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Metabolic-Nutrition-Stim-Free-Pump-Unflavored.jpg?v=1787591586",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "metabolic",
        "nutrition",
        "stim",
        "free",
        "pump",
        "unflavored",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 32,
        "sustainability": 45
      },
      "price": 24.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804481179845",
      "vsf_explanation": "Metabolic Nutrition Stim-Free Pump is a caffeine-free pre-workout pump formula — targeting the segment of users who want nitric-oxide-mediated vasodilation and hydration without stimulants. Stim-free pump products typically combine citrulline, arginine derivatives (agmatine, arginine nitrate), glycerol, betaine, and sometimes pump-adjunct proprietary blends. Even without stimulants, proprietary blend structure on the pump matrix triggers autofail if individual doses are hidden. Metabolic Nutrition's Stim-Free Pump is not publicly documented as fully-disclosed. Safety dimension is meaningfully higher than stimulant-containing pre-workouts (no cardiovascular stimulant load) but overall category default applies. Rejected on transparency grounds.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bucked-up-flow",
      "title": "Bucked Up FLOW",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Bucked-Up-FLOW.jpg?v=1787591586",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bucked",
        "flow",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 32,
        "sustainability": 45
      },
      "price": 54.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804481212613",
      "vsf_explanation": "Bucked Up FLOW is the brand's stim-free pump/nootropic pre-workout SKU. Similar formulation category as the Metabolic Nutrition Stim-Free Pump above but from a brand with heavier proprietary-blend history. Typically combines citrulline, betaine, alpha-GPC, huperzine, and pump-matrix components with variable disclosure. Autofail on proprietary blend and brand-signature deer-antler-adjacent inclusions. Rejected tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "raw-nutrition-thuper-pump",
      "title": "Raw Nutrition Thuper Pump",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Raw-Nutrition-Thuper-Pump.webp?v=1787591586",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "raw",
        "nutrition",
        "thuper",
        "pump",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 42.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804481245381",
      "vsf_explanation": "RAW Nutrition (CBUM) Thuper Pump is a stim-free pump pre-workout in the same category as FLOW and Metabolic Stim-Free Pump. Formulation typically combines citrulline, glycerol, betaine, and pump-matrix components — with proprietary blend structure on at least part of the panel. Autofail on proprietary_blend_hides_dose. Same brand-portfolio caveat as other CBUM RAW SKUs — the celebrity-brand identity does not itself confer manufacturing or transparency advantage. Rejected tier.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "ghost®-basic-creatine",
      "title": "Ghost® Basic Creatine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Ghost-Basic-Creatine.jpg?v=1787591586",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ghost",
        "basic",
        "creatine",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 88,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 82,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804481343685",
      "vsf_explanation": "Ghost Basics Creatine is the single-ingredient creatine monohydrate from Ghost's stripped-down Basics sub-line. Same category as other single-ingredient creatine monohydrate SKUs — Grade A evidence base, safe at 3-5 g/day, essentially commodity ingredient. Ghost's Basics sub-line is a deliberate transparency-focused product family, and this SKU discloses dose per serving without proprietary blends. Manufacturing is contract-standard; NSF Certified for Sport or Informed Sport is not prominently documented at the SKU level. Solid Standard. Would benefit from published per-lot COA to move toward Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "metabolic-nutrition-hydra-max-180-capsules",
      "title": "Metabolic Nutrition Hydra Max - 180 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Metabolic-Nutrition-Hydra-Max-180-Capsules.jpg?v=1787591586",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "metabolic",
        "nutrition",
        "hydra",
        "max",
        "180",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 42,
        "transparency": 32,
        "sustainability": 45
      },
      "price": 36.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804481376453",
      "vsf_explanation": "Metabolic Nutrition Hydra Max is a diuretic capsule product marketed for water-weight reduction ahead of physique/bodybuilding competition. Diuretic supplements in the physique-prep category typically combine dandelion extract, uva ursi, juniper berry, potassium chloride, and sometimes theobromine or synephrine as stimulant diuretics. Auto-fail concerns are two-fold: (1) diuretic marketing for cosmetic water-weight reduction crosses into unverified_medical_claim territory when framed as safe daily-use — herbal diuretics can produce genuine electrolyte disturbance, dehydration, and cardiac arrhythmia risk in already-lean, under-hydrated bodybuilders during peak week, with documented deaths in the competitive bodybuilding community from combination diuretic use; and (2) products in this category commonly use proprietary blends. The intended-use profile itself is medically ambiguous. Rejected tier.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "revive-fiber",
      "title": "Revive Fiber",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Revive-Fiber.jpg?v=1787591586",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "revive",
        "fiber",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 78,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 27.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804481409221",
      "vsf_explanation": "Revive Supplements is a clean-label DTC brand with a reputation for single-ingredient or simple-multi-ingredient formulations targeted at general wellness and health optimization. Revive Fiber typically contains a mixed soluble/insoluble fiber blend (psyllium, acacia, apple pectin) — ingredients with Grade B-A evidence for cholesterol reduction (psyllium specifically has an FDA-authorized health claim), blood glucose smoothing, and stool consistency. Doses are typically disclosed. Manufacturing is contract-standard for a DTC brand; third-party per-lot testing documentation is partial. Standard tier. Solid product for a category that is genuinely evidence-supported when doses are adequate (roughly 10-15 g/day supplemental fiber to hit total dietary 25-38 g/day recommendation).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "raw-essentials-creatine-500g",
      "title": "RAW Essentials Creatine 500g",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/RAW-Essentials-Creatine-500g.jpg?v=1787591587",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "raw",
        "essentials",
        "creatine",
        "500g",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 88,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 82,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804481474757",
      "vsf_explanation": "RAW Nutrition is Chris Bumstead's (CBUM) sports supplement brand, with an 'Essentials' line that mirrors the industry pattern of stripped-down single-ingredient SKUs. RAW Essentials Creatine 500g is a bulk creatine monohydrate powder — one of the highest-evidence supplements in existence (Grade A for strength/hypertrophy/high-intensity performance). Single-ingredient. Standard cGMP manufacturing; the brand does not publicly foreground NSF Certified for Sport or Informed Sport certification at the product-page level, and third-party per-lot COA publication is not prominently visible. The evidence base and single-ingredient honesty warrant a solid Standard score; the score is capped short of Verified by manufacturing/testing documentation gaps relative to top-tier creatine sources.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bucked-up-creatine-monohydrate-250-g",
      "title": "Bucked Up Creatine Monohydrate 250 g",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Bucked-Up-Creatine-Monohydrate-250-g.jpg?v=1787591587",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bucked",
        "creatine",
        "monohydrate",
        "250",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 88,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 82,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 22.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804481507525",
      "vsf_explanation": "Bucked Up Creatine Monohydrate 250g is Bucked Up's stand-alone creatine SKU — outside the flagship pre-workout line's proprietary-blend issues. Single-ingredient creatine monohydrate at 250 g bulk powder. Same Grade A evidence base as any creatine monohydrate. Manufacturing is contract-standard; Bucked Up does not publicly foreground NSF Certified for Sport for this SKU. The brand-portfolio history (proprietary-blend pre-workouts, deer antler velvet use, dose-escalating anniversary editions) does not directly impact this specific single-ingredient product but does modestly reduce transparency trust at the brand level. Solid Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrabio-creatine-monohydrate-150-capsules",
      "title": "NutraBio Creatine Monohydrate - 150 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NutraBio-Creatine-Monohydrate-150-Capsules.jpg?v=1787591588",
      "score": 82,
      "tier": "elite",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrabio",
        "creatine",
        "monohydrate",
        "150",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 88,
        "formulation": 65,
        "manufacturing": 80,
        "safety": 82,
        "transparency": 85,
        "sustainability": 55
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804481638597",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 0 → new 82. Evidence found: Kreider RB et al. ISSN position stand on creatine. J Int Soc Sports Nutr. 2017;14:18. | Chilibeck PD et al. Effect of creatine supplementation during resistance training on lean tissue mass and muscular strength in older adults: a meta-analysis. Open Access J Sports Med. 2017;8:213-226. | NutraBio Creatine Monohydrate: full transparency, per-lot COA, pharmaceutical GMP.. Rationale: Creatine monohydrate is the most-studied ergogenic supplement (100+ RCTs, TIER-A). NutraBio's transparency + COA discipline puts this at Elite tier alongside Thorne Creatine.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bucked-up-babe-pre-workout",
      "title": "Bucked Up Babe Pre-Workout",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Bucked-Up-Babe-Pre-Workout.jpg?v=1787591589",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bucked",
        "babe",
        "pre",
        "workout",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 42,
        "manufacturing": 55,
        "safety": 45,
        "transparency": 32,
        "sustainability": 45
      },
      "price": 37.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804481704133",
      "vsf_explanation": "Bucked Up Babe is the women-marketed pre-workout SKU from Bucked Up. Formulations in the women-marketed pre-workout segment typically use lower absolute stimulant doses than the flagship SKUs but retain the same core structural issues: proprietary matrix components, deer antler velvet inclusion as a brand-signature non-evidenced ingredient, and partial-disclosure labeling. Gender-marketing a pre-workout (lower dose, pink packaging, 'for women') does not change the underlying formulation-transparency and ingredient-evidence issues. Same autofail category as other Bucked Up pre-workouts. Rejected tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "project-ad-good-mornin",
      "title": "Project AD Good Mornin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Project-AD-Good-Mornin.jpg?v=1787591588",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "project",
        "good",
        "mornin",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 42,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 39.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804481900741",
      "vsf_explanation": "Project AD 'Good Mornin' is a morning stimulant/cortisol-support formula in the pre-workout adjacent category — marketed for daytime energy and hormonal support. Products in this segment near-uniformly use proprietary blends combining caffeine, adaptogens, adrenal-support ingredients (rhodiola, ashwagandha, tyrosine), and often stimulant secondary components. Project AD does not publicly document full per-ingredient dose disclosure across the panel or third-party sport certification. The 'cortisol support' framing itself is a marketing overreach — cortisol regulation is highly context-dependent (elevated cortisol may be appropriate morning physiology; the goal of a chronic supplement to 'lower' morning cortisol is physiologically ambiguous). Autofail on proprietary_blend_hides_dose. Rejected tier.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "ghost®-basics-fish-oil",
      "title": "Ghost® Basics Fish Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Ghost-Basics-Fish-Oil.jpg?v=1787591589",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ghost",
        "basics",
        "fish",
        "oil",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 65,
        "manufacturing": 65,
        "safety": 78,
        "transparency": 68,
        "sustainability": 45
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804481999045",
      "vsf_explanation": "Ghost is a mainstream sports-nutrition brand that launched its 'Basics' line as a single-ingredient, no-blend product family — a deliberate move away from the proprietary-blend norm of the parent catalog. Basics Fish Oil discloses EPA and DHA content per serving and typically delivers a standard 1000 mg fish oil per softgel with roughly 300 mg combined EPA+DHA — a mid-tier concentration typical of commodity fish oil rather than the highly-concentrated (>800 mg combined per gram) products from omega-3-specialized brands like Nordic Naturals or Carlson. Evidence for combined EPA+DHA at 2-4 g/day for triglyceride reduction is Grade A; general cardiovascular event reduction has weaker Grade B evidence outside of high-triglyceride populations (per the REDUCE-IT and STRENGTH trials, prescription icosapent ethyl outperformed generic mixed omega-3). Ghost does not publicly document IFOS 5-star certification, oxidation testing (TOTOX), or sustainability sourcing at Nordic Naturals' level. Solid Standard for a mid-market fish oil.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "inspired-nutraceuticals-dvst8-25",
      "title": "Inspired Nutraceuticals DVST8 25",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Inspired-Nutraceuticals-DVST8-25.jpg?v=1787591590",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "inspired",
        "nutraceuticals",
        "dvst8",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 42,
        "transparency": 32,
        "sustainability": 45
      },
      "price": 44.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804482228421",
      "vsf_explanation": "Inspired Nutraceuticals DVST8 is a mid-tier pre-workout brand. The '25' likely denotes an anniversary or 25-serving edition. DVST8 formulations have historically included partial proprietary matrices for the stimulant and nootropic components alongside disclosed doses of citrulline and beta-alanine. The category default and the brand's historical proprietary-blend usage on stimulant components trigger the autofail rule. Not documented as NSF/Informed Sport certified. Rejected tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "purus-labs-creatine-atp-30-servings",
      "title": "Purus Labs Creatine ATP - 30 Servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Purus-Labs-Creatine-ATP-30-Servings.jpg?v=1787591590",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "purus",
        "labs",
        "creatine",
        "atp",
        "servings",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 34.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804482326725",
      "vsf_explanation": "Purus Labs Creatine ATP is a creatine product using a patented creatine-phosphate/PEAK-ATP form (adenosine 5'-triphosphate disodium) — a downstream ATP delivery molecule marketed as a more direct energy substrate than creatine monohydrate. The evidence base for PEAK-ATP shows some Grade C-B signal for muscular endurance and body composition in TSI Group-funded studies, with less robust independent replication than the enormous body of evidence supporting standard creatine monohydrate (which has Grade A evidence across strength, hypertrophy, and cognitive endpoints, and is the most-studied sports supplement in existence). Purus Labs discloses the patented ingredient dose and manufacturers to standard cGMP norms. The product is honestly-labeled and single-active, but the specific form has meaningfully weaker outcome evidence than plain creatine monohydrate at a much higher price per serving.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ultimate-stamina-men",
      "title": "Ultimate Stamina (Men)",
      "vendor": "Tailor Made Herbal Products",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/IMG-7108.jpg?v=1787591608",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "ultimate",
        "stamina",
        "men",
        "tailor",
        "made",
        "herbal",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804482490565",
      "vsf_explanation": "\"Ultimate Stamina (Men)\" carries the same marketing structure as \"Ultimate Libido (women)\" — superlative claim (\"Ultimate\"), vague benefit target (\"Stamina\" — physical endurance? sexual stamina? mental stamina?), and proprietary blend hiding per-active doses. Male-stamina products typically bundle horny goat weed, tongkat ali, maca, tribulus, panax ginseng, and various other libido/energy botanicals — the male-enhancement category adjacent to Nondo Epimedium and Vemax variants in this batch, with the same PDE-5 adulteration risk exposure and the same underdose-per-active problem in bundled formats. Auto-failed under proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "nutrabio-base-aminos-unflavored",
      "title": "NutraBio Base Aminos - Unflavored",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NutraBio-Base-Aminos-Unflavored.jpg?v=1787591642",
      "score": 75,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrabio",
        "base",
        "aminos",
        "unflavored",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 78,
        "safety": 75,
        "transparency": 85,
        "sustainability": 55
      },
      "price": 37.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804483834053",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 0 → new 75. Evidence found: NutraBio Base Aminos: pharmaceutical-grade EAAs, full disclosure of individual amino acid amounts, no proprietary blends. | Jackman SR et al. Branched-Chain Amino Acid Ingestion Stimulates Muscle Myofibrillar Protein Synthesis following Resistance Exercise in Humans. Front Physiol. 2017;8:390. | Wolfe RR. Branched-chain amino acids and muscle protein synthesis in humans: myth or reality? J Int Soc Sports Nutr. 2017;14:30 (EAAs superior to BCAAs).. Rationale: NutraBio's full-transparency EAA formula (9 essential amino acids in ratios designed to support muscle protein synthesis). Wolfe 2017 established EAAs as superior to BCAAs alone. Verified tier for practitioner-grade transparency + evidence-based EAA delivery.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "the-grind-just-lose-it-60-capsules",
      "title": "The Grind - JUST LOSE IT 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/The-Grind-JUST-LOSE-IT-60-Capsules.jpg?v=1787591642",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "the",
        "grind",
        "just",
        "lose",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 32,
        "manufacturing": 45,
        "safety": 40,
        "transparency": 22,
        "sustainability": 40
      },
      "price": 49.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804483899589",
      "vsf_explanation": "'JUST LOSE IT' is a classic sports-nutrition fat-burner marketed on outcome ('lose it') rather than mechanism or verifiable dose. Products in this category near-uniformly rely on proprietary stimulant blends (caffeine + yohimbine + green tea extract + rauwolscine + synephrine + capsaicin combinations) where individual ingredient doses are hidden behind a 'thermogenic blend' or 'fat-loss matrix' total. That configuration auto-fails Vyvata under proprietary_blend_hides_dose because a reader cannot verify whether the stimulant load is safe, whether individual ingredients are at studied efficacious doses, or whether the product duplicates whatever caffeine the user is already consuming. Compounding that, the product name itself makes a weight-loss claim that no OTC capsule can substantiate at the standard the FTC requires for weight-loss marketing. The Grind is a small brand with limited public quality documentation (no NSF/USP seals, no per-lot COA publication verified). Not listable in current form.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "bucked-up-pre-workout-anniversary-x",
      "title": "Bucked Up Pre-Workout Anniversary X",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Bucked-Up-Pre-Workout-Anniversary-X.jpg?v=1787591642",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bucked",
        "pre",
        "workout",
        "anniversary",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 42,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 39.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804483997893",
      "vsf_explanation": "Bucked Up Anniversary X is the celebratory-formula line-extension of Bucked Up's flagship pre-workout. Bucked Up has publicly moved toward more disclosed labeling in recent formulations, but the Anniversary/limited-edition SKUs typically layer stimulant-blend components (multi-caffeine sources, alpha-yohimbine, unique stimulants) on top of the base formula. The line's signature 'Deer Antler Velvet Extract' inclusion has been publicly criticized as a non-evidenced ingredient with sports-nutrition marketing overtones (IGF-1 claims are unsupported by human RCTs). Even in a partially-disclosed panel the combination of pre-workout stimulants at elevated doses without independent third-party sport certification, plus the deer antler ingredient with no clinical evidence, plus common Anniversary-edition dose-escalation practices, place this in Rejected tier. Prior Vyvata scoring has scored Bucked Up 30 in the Rejected range on the same brand-portfolio grounds.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bucked-up-woke-af-anniversary-x-pre-workout",
      "title": "Bucked Up Woke AF Anniversary X Pre-Workout",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Bucked-Up-Woke-AF-Anniversary-X-Pre-Workout.jpg?v=1787591642",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bucked",
        "woke",
        "anniversary",
        "pre",
        "workout",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 38,
        "manufacturing": 55,
        "safety": 38,
        "transparency": 28,
        "sustainability": 45
      },
      "price": 52.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804483932357",
      "vsf_explanation": "Woke AF is Bucked Up's high-stimulant pre-workout SKU — marketed explicitly as the 'harder' version of the base pre-workout for users who have caffeine-tolerated past the standard formula. The Anniversary X edition typically pushes total caffeine well past 300 mg per serving and adds exotic secondary stimulants (dendrobium historically, synephrine/octopamine derivatives, alpha-yohimbine). The combination of very high stimulant load, additional non-standard stimulants, deer antler velvet inclusion, and partial-disclosure formulation exceeds Vyvata's safety and transparency thresholds. Auto-fail on the same proprietary-blend and stimulant-stack grounds as the base Anniversary X, with an even weaker safety score because the total stimulant delivery is higher.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrabio-l-arginine-120-capsules",
      "title": "NutraBio L-Arginine - 120 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NutraBio-L-Arginine-120-Capsules.jpg?v=1787591642",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrabio",
        "arginine",
        "120",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 68,
        "manufacturing": 78,
        "safety": 72,
        "transparency": 82,
        "sustainability": 55
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804484063429",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 0 → new 68. Evidence found: Bode-Böger SM et al. L-arginine-induced vasodilation in healthy humans. Br J Clin Pharmacol. 1998;46(5):489-497. | NutraBio: transparent-label, full COA per lot, no proprietary blends.. Rationale: Standard L-arginine (same TIER-C evidence as NOW L-arg above). Modest uplift over the 65-baseline for NutraBio brand transparency, but the ingredient itself doesn't merit Verified tier given first-pass metabolism concerns. Would use L-citrulline for NO/vascular goals instead.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrabio-deep-sleep",
      "title": "NutraBio Deep Sleep",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NutraBio-Deep-Sleep.webp?v=1787591642",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrabio",
        "deep",
        "sleep",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 74,
        "manufacturing": 78,
        "safety": 72,
        "transparency": 82,
        "sustainability": 55
      },
      "price": 54.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804484161733",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 0 → new 72. Evidence found: NutraBio Deep Sleep: transparent-label sleep blend typically including melatonin, valerian, chamomile, L-theanine, and magnesium (verify current label for exact composition). | Bent S et al. Valerian for sleep: a systematic review and meta-analysis. Am J Med. 2006;119(12):1005-1012. | Ferracioli-Oda E et al. Meta-analysis: melatonin for the treatment of primary sleep disorders. PLoS One. 2013;8(5):e63773.. Rationale: NutraBio's brand-level transparency (no proprietary blends, full COA per lot, third-party tested) meaningfully elevates a sleep-formula category that is otherwise a black-box competitive space. Individual components (melatonin, valerian, L-theanine, chamomile) have TIER-A/B sleep evidence. Uplift to 72; below Elite because sleep-stack-as-a-whole has limited RCT evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "men-s-daily-muti-herbal",
      "title": "Men’s Daily Muti-Herbal",
      "vendor": "Tailor Made Herbal Products",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/IMG-7931.jpg?v=1787591666",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "men",
        "daily",
        "muti",
        "herbal",
        "tailor",
        "made",
        "herbal",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 44,
        "manufacturing": 48,
        "safety": 48,
        "transparency": 40,
        "sustainability": 48
      },
      "price": 25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804484882629",
      "vsf_explanation": "\"Men's Daily Muti-Herbal\" (typo: \"Muti\" for \"Multi\") is a proprietary blend from a small herbalist typically combining saw palmetto, pygeum, nettle root, tribulus, maca, ashwagandha, and various other men's-health botanicals with no per-active mg or standardization percentages. Each active has distinct evidence (saw palmetto 320mg standardized for BPH per Wilt 1998, though negative in larger trials; ashwagandha KSM-66 for stress-testosterone) but blending them at unstated doses destroys the ability to evaluate the product against any of those evidence bases. Product-title typo (\"Muti\" instead of \"Multi\") is a QA signal — brands with real GMP oversight catch label typos. Auto-failed under proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "ashwagandha-2",
      "title": "Ashwagandha",
      "vendor": "Tailor Made Herbal Products",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/IMG-6382.jpg?v=1787591670",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ashwagandha",
        "tailor",
        "made",
        "herbal",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 52,
        "manufacturing": 52,
        "safety": 60,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804484948165",
      "vsf_explanation": "Single-ingredient Ashwagandha (Withania somnifera) — one of the strongest-evidence adaptogens for stress and cortisol reduction. KSM-66 at 300-600mg standardized to 5% withanolides (Chandrasekhar 2012, Salve 2019) and Sensoril at 125-250mg standardized to 10% withanolides both have robust RCT evidence for perceived stress, cortisol, sleep quality, and testosterone in stressed adults. The concern: Tailor Made Herbal Products is a small US herbalist, and single-ingredient herbal products from this vendor category typically list \"Ashwagandha root powder\" without standardization percentage or trademarked-extract identification — meaning the withanolide content per capsule is variable. Sits at Standard because the active is real and single-ingredient (no proprietary blend penalty); would move to Verified 70+ with KSM-66 or Sensoril standardization disclosure and per-lot COAs.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mullein-leaf",
      "title": "Mullein Leaf",
      "vendor": "Tailor Made Herbal Products",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/IMG-7110.jpg?v=1787591671",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mullein",
        "leaf",
        "tailor",
        "made",
        "herbal",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 52,
        "manufacturing": 52,
        "safety": 60,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 40,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804485013701",
      "vsf_explanation": "Mullein leaf (Verbascum thapsus) is a traditional respiratory-support botanical with long ethnobotanical history for cough and bronchial complaints. Modern clinical evidence in humans is thin — most references are traditional-use compendia (Commission E, WHO monographs) and in-vitro antimicrobial or expectorant activity. The active constituents (mucilage, iridoid glycosides, saponins) are not consistently standardized in commercial products, and no RCT has established a specific effective dose. The product is honestly named (single-ingredient, not proprietary blend), which prevents autofail — but Tailor Made Herbal Products does not publish per-serving mg, extraction ratio, or COAs at title level. Sits at 52 (Rejected band) reflecting a thin evidence base and thin disclosure combined; the ingredient itself has low safety risk and traditional-use plausibility.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "batana-hair-oil",
      "title": "Batana Hair Oil",
      "vendor": "Tailor Made Herbal Products",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/FullSizeRender_b97cdd75-133e-49a5-b4bf-67b418bed2c7.jpg?v=1787591671",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "batana",
        "hair",
        "oil",
        "tailor",
        "made",
        "herbal",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 25,
        "manufacturing": 30,
        "safety": 45,
        "transparency": 22,
        "sustainability": 45
      },
      "price": 27,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804484980933",
      "vsf_explanation": "Batana Hair Oil is a topical scalp/hair product derived from the American oil palm (Elaeis oleifera) nut, sold traditionally by the Miskito people of Honduras. It is not an ingested supplement — Vyvata's rubric scopes to biohacker-relevant ingestible interventions, and topical hair and skin products fall outside the biohacker-supplement evaluation framework. Auto-failed under out_of_scope_for_biohacking. This is a scope decision, not a quality judgment about the product itself. Batana oil has legitimate cultural and cosmetic use; it just does not belong on a supplement scoring platform. Score in the 20s reflects that all supplement-dimension logic returns zero for a non-ingested product.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "women-s-daily-multi-herbal",
      "title": "Women’s Daily Multi Herbal",
      "vendor": "Tailor Made Herbal Products",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/IMG-4791.jpg?v=1787591671",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "women",
        "daily",
        "multi",
        "herbal",
        "tailor",
        "made",
        "herbal",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 44,
        "manufacturing": 48,
        "safety": 48,
        "transparency": 40,
        "sustainability": 48
      },
      "price": 25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804485046469",
      "vsf_explanation": "\"Women's Daily Multi Herbal\" is textbook proprietary-blend framing: a bundled women's-health formula from a small herbalist typically combining 5-15 botanicals (Vitex, black cohosh, red raspberry leaf, dong quai, evening primrose, red clover, maca, wild yam) with no per-active mg disclosure and no standardization percentages. Each active in the category has distinct evidence and distinct contraindications — a blend hides all of that. The women's-cycle botanical category has particularly important safety considerations (pregnancy contraindications for Vitex, dong quai, black cohosh; hormonal-contraceptive interactions; hormone-sensitive cancer contraindications) that require ingredient-level disclosure to communicate. Auto-failed under proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "shilajit-pure-resin-1-06oz",
      "title": "Shilajit Pure Resin 1.06oz",
      "vendor": "Tailor Made Herbal Products",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/08E2ED9D-7882-4AF7-A421-3D19E8876807.jpg?v=1787591671",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shilajit",
        "pure",
        "resin",
        "06oz",
        "tailor",
        "made",
        "herbal",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 50,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804485112005",
      "vsf_explanation": "Shilajit pure resin (1.06oz = 30g at typical 300-500mg/day dose = ~60-100 day supply) is the honest, traditional format for shilajit — not the diluted gummy or capsule format. Pure resin is the format used in the Pandit 2016 testosterone trial (250mg BID, 90 days) and Keller 2019 CoQ10 augmentation study. The category has real if narrow evidence. Tailor Made Herbal Products naming the product \"Pure Resin\" is a positive signal versus generic shilajit capsules. Critical remaining concerns: (1) heavy-metal contamination is the primary shilajit safety risk (soil-derived lead, arsenic, mercury, cadmium bioaccumulate in the raw mineral pitch); (2) sourcing origin (Himalayan vs Altai vs Andean shilajit have different mineral profiles) not disclosed at title level; (3) purification method (traditional vs solvent-extracted) not stated. Score of 60 places it at bottom-Standard because format is right but per-lot COA disclosure is not verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "calorie-burner-formula",
      "title": "Calorie Burner Formula",
      "vendor": "Tailor Made Herbal Products",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8E63E377-4B93-40B8-A308-723579D473B6.png?v=1787591671",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "calorie",
        "burner",
        "formula",
        "tailor",
        "made",
        "herbal",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 42,
        "safety": 42,
        "transparency": 32,
        "sustainability": 45
      },
      "price": 45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804485079237",
      "vsf_explanation": "\"Calorie Burner Formula\" fails Vyvata on three independent grounds: (1) \"calorie burner\" is a fat-loss claim that no supplement has demonstrated at the outcome level (measurable body composition change) with any reliability — the weight-loss supplement category has the highest gap between marketing claim and RCT-substantiated effect of any supplement subcategory; (2) \"Formula\" hides a proprietary blend without per-active dose disclosure; (3) common ingredients in this category (green tea EGCG, caffeine, yohimbine, synephrine, guarana) have well-documented safety risks at higher doses (cardiovascular events with yohimbine and synephrine, hepatotoxicity with high-dose green tea extract per USP alert). Auto-failed under unverified_medical_claim for the fat-loss positioning and would additionally trip proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "cybergenics-horny-goat-weed-500mg-natures-aphrodisiac-60-tablets",
      "title": "Cybergenics Horny Goat Weed 500mg Nature's Aphrodisiac 60 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/155258517.jpg?v=1787591687",
      "score": 55,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cybergenics",
        "horny",
        "goat",
        "weed",
        "500mg",
        "nature",
        "aphrodisiac",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 12.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804485734597",
      "vsf_explanation": "Cybergenics is a legacy 1980s-era sports supplement brand — most famous for the bodybuilding 'Cybergenics Total Bodybuilding System' from the late 1980s. The brand name still exists as a supplement label and this Horny Goat Weed (Epimedium) SKU delivers a single ingredient at a stated single dose (500 mg per tablet), which is transparent labeling — a significant improvement over the proprietary-blend aphrodisiac SKUs elsewhere in this batch. Horny Goat Weed contains icariin, a compound with in-vitro PDE5-inhibitor activity (mild) and some rodent-model evidence for erectile function support. Human clinical trials are limited and mostly small; the compound is generally considered a mild traditional-use herb rather than a robustly evidence-based intervention. 500 mg per tablet is a typical serving size for whole-plant HGW extracts, though standardization to icariin percentage (typically 10-40% in high-quality extracts) would be a meaningful quality differentiator that this label does not clearly disclose. The 60-tablet count is a typical bottle format. Distributed via a pharmacy retail channel (a legitimate NYC pharmacy chain) adds a modest quality-signal marginally, though HGW's evidence base doesn't warrant more than Standard/Rejected-border territory. Scored at 55, just under the Standard threshold, reflecting the modest evidence base and standardization uncertainty rather than any autofail.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "epimedium-male-healthy-capsule",
      "title": "Epimedium Male Healthy Capsule",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a3a1947d-59ac-4bba-b09a-66b006c8eb76.jpg?v=1787591694",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "epimedium",
        "male",
        "healthy",
        "capsule",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 42,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 38,
        "sustainability": 42
      },
      "price": 31.13,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804485800133",
      "vsf_explanation": "Epimedium (horny goat weed, Epimedium sagittatum) is standardized on its icariin content — the flavonoid identified as the primary PDE-5-inhibitor-like active. Meaningful in-vitro and animal doses translate to human doses of 600-900mg of standardized 20% icariin extract; typical DTC capsules deliver 250-500mg of raw powder with 2-5% icariin, which is 5-30x below the modeled active dose. The product title does not disclose milligrams per capsule or icariin standardization percentage. Additionally, horny goat weed products share the male-enhancement category's PDE-5-adulteration risk (icariin's structural similarity to sildenafil makes it a candidate for spike adulteration to boost perceived efficacy). Auto-failed under proprietary_blend_hides_dose for the missing standardization.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "naysa-nutra-performance-alpha-energy",
      "title": "Naysa Nutra Performance - Alpha Energy",
      "vendor": "LavenderWarehouse",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/AlphaEnergy.jpg?v=1787591702",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "naysa",
        "nutra",
        "performance",
        "alpha",
        "energy",
        "lavenderwarehouse"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 32,
        "manufacturing": 38,
        "safety": 40,
        "transparency": 22,
        "sustainability": 42
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804486160581",
      "vsf_explanation": "Naysa Nutra 'Alpha Energy' — sold via another generic Shopify reseller with no supplement-industry footprint. Product name 'Alpha Energy' is category-typical stimulant/energy blend branding suggesting caffeine, B-vitamins, and potentially higher-risk stimulant compounds. Same failure profile as the other undisclosed-blend energy SKUs in this batch: no ingredient milligrams at title level, no third-party purity testing, no manufacturer identity beyond an unrelated retailer name. Stimulant categories have documented FDA warning history for undisclosed DMAA, DMHA, synephrine at high doses, and other cardiac-risk compounds. Autofailed under proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "dietary-supplement",
      "title": "Dietary Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cb49a4ee-93d8-476b-af99-022e25951dad.jpg?v=1787591706",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dietary",
        "supplement",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 32,
        "manufacturing": 38,
        "safety": 45,
        "transparency": 20,
        "sustainability": 40
      },
      "price": 44.52,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804486553797",
      "vsf_explanation": "Fourth Perfecsy SKU literally named \"Dietary Supplement\" with no ingredient disclosure or category specification. Same failure mode. Auto-failed under misleading_naming. This is the base-handle variant (no numeric suffix) in the placeholder-title family.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "vemax-herbal-supplement-l-arginine-acetyl-l-carnitine-zinc-coq10-30-halal-capsules",
      "title": "Vemax: Herbal Supplement - L-Arginine, Acetyl L-Carnitine, Zinc, CoQ10 - 30 Halal Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/RnpjjodPGScECt6eNk2HkNyl02vETgYvxzGKCBYu.jpg?v=1787591715",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vemax",
        "herbal",
        "supplement",
        "arginine",
        "acetyl",
        "carnitine",
        "zinc",
        "coq10",
        "halal",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 48,
        "manufacturing": 50,
        "safety": 52,
        "transparency": 45,
        "sustainability": 48
      },
      "price": 24.62,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804486652101",
      "vsf_explanation": "Named-ingredient version of the Vemax line — L-arginine, acetyl-L-carnitine (ALCAR), zinc, and CoQ10 is a mechanistically coherent male-fertility and endothelial-function stack. Each active has real evidence: L-arginine at 3-6g/day for endothelial NO (Bode-Boger 2003, though L-citrulline is preferred for bioavailability); ALCAR at 1-3g/day for sperm motility (Balercia 2005 in idiopathic male infertility); zinc for testosterone and sperm quality in deficient men; CoQ10 at 200mg for sperm motility (Balercia 2004). The critical problem: a 30-capsule bottle at one per day means each capsule must hold the daily dose of all four actives. That is physically impossible — 3g L-arginine + 1g ALCAR alone would fill a 4g capsule, before ALCAR/zinc/CoQ10. So per-capsule doses are almost certainly well below studied levels. Auto-failed under proprietary_blend_hides_dose because per-active mg not disclosed and dosing math is unfavorable.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "femever-dietary-supplement-for-adults-with-herbal-extracts-vitamins",
      "title": "Femever Dietary Supplement for Adults with Herbal Extracts & Vitamins",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3SJgo5A7nQUrvWqBkvyrjEjgok7nn4Op5DpeSXRS.jpg?v=1787591721",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "femever",
        "dietary",
        "supplement",
        "for",
        "adults",
        "with",
        "herbal",
        "extracts",
        "vitamins",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 42,
        "manufacturing": 45,
        "safety": 48,
        "transparency": 38,
        "sustainability": 45
      },
      "price": 41.82,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804486979781",
      "vsf_explanation": "\"Femever\" is a Turkish women's-hormonal proprietary blend — the naming, like Vemax, is a made-up brand-word rather than an ingredient descriptor, and the product discloses only \"herbal extracts & vitamins.\" Neither the herbal actives nor the vitamin panel is enumerated at title level. Women's hormonal-support products typically bundle Vitex, black cohosh, dong quai, evening primrose, and various B-vitamins/iron/vitamin D — a category where per-active dose and standardization matter enormously (Vitex requires 20-40mg standardized; black cohosh requires 40mg standardized to 2.5% triterpene glycosides). Auto-failed under proprietary_blend_hides_dose. Additionally, women's-health products carry pregnancy contraindication risks that require ingredient-specific disclosure to communicate.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "vemax-dietary-supplement-herbal-extract-blend-halal-certified-60-capsules",
      "title": "Vemax Dietary Supplement - Herbal Extract Blend, Halal Certified, 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/izyOOUa9Qfm8mnlslK5abTx4aWHxXJ1KvhePmhJV.jpg?v=1787591729",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vemax",
        "dietary",
        "supplement",
        "herbal",
        "extract",
        "blend",
        "halal",
        "certified",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 42,
        "manufacturing": 48,
        "safety": 45,
        "transparency": 38,
        "sustainability": 48
      },
      "price": 34.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804489175237",
      "vsf_explanation": "\"Vemax Herbal Extract Blend\" is an entirely undefined proprietary formulation — the label discloses no ingredients other than \"herbal extract blend\" and the halal certification. This is the most severe form of proprietary blend: not just missing per-active mg, but missing the ingredients themselves. A buyer cannot know whether the product contains 30 different herbs or one, whether it targets libido/energy/stress/immune, or whether any of the actives are present at studied doses. The male-enhancement category (which Vemax appears to belong to, based on the separate \"Vemax L-Arginine\" SKU in the lineup) has documented PDE-5 adulteration risk in unregulated overseas products. Auto-failed under proprietary_blend_hides_dose (extreme case) and misleading_naming.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "lepigra-dietary-supplement-maca-extract-ginseng-30-tablets",
      "title": "Lepigra Dietary Supplement - Maca Extract, Ginseng, 30 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4Tc85XioyQpK0hvWAkmxlSYs7BjaZtQqOtAMp0qS_0175f384-4e81-4a58-acf7-1fa0bfb93c6c.jpg?v=1787591735",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "mood",
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lepigra",
        "dietary",
        "supplement",
        "maca",
        "extract",
        "ginseng",
        "tablets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 48,
        "manufacturing": 48,
        "safety": 52,
        "transparency": 42,
        "sustainability": 48
      },
      "price": 41.82,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804489535685",
      "vsf_explanation": "Lepigra is a Turkish libido/energy product combining maca (Lepidium meyenii) with ginseng — a mechanistically plausible pairing. Maca at 1.5-3g/day has RCT evidence for sexual desire in men and women (Gonzales 2002; Shin 2010 review) and may modestly improve sexual function without changing serum hormones. Ginseng at 200-400mg standardized Panax has small-trial ED evidence. But this SKU discloses neither per-active mg nor standardization percentages, and a 30-tablet count suggests a one-per-day format — meaning if the tablet holds 500mg total, the maca dose is likely 250-350mg, well below the 1.5-3g/day used in trials. Auto-failed under proprietary_blend_hides_dose. The libido/male-enhancement category compounds this with PDE-5 adulteration risk from small overseas brands.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "com-vitex-dietary-supplement-60-herbal-extract-capsules",
      "title": "Com Vitex Dietary Supplement - 60 Herbal Extract Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/bDScBvypDSyewP6vU4Qrzowa6lZmqrAHRmFwB7Hh.jpg?v=1787591740",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "com",
        "vitex",
        "dietary",
        "supplement",
        "herbal",
        "extract",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 45,
        "manufacturing": 48,
        "safety": 50,
        "transparency": 42,
        "sustainability": 48
      },
      "price": 80.58,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804489830597",
      "vsf_explanation": "Similar to the Vitexia & Energy SKU but appears to be a Vitex-focused product with additional \"herbal extract\" components. The plural \"Herbal Extract Capsules\" in the title implies a botanical stack rather than a Vitex mono-formula, and again the dose per active and standardization percentages are not disclosed. Vitex agnus-castus is the strongest-evidence women's-cycle botanical (Schellenberg 2001, Halaska 1999) and should be the disclosed lead active if that is what the product delivers. Auto-failed under proprietary_blend_hides_dose for the missing per-active mg and standardization. Scores slightly higher than Com Vitexia & Energy because the naming at least references Vitex as the intended primary active.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "dietary-supplement-1",
      "title": "Dietary Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/aeb2bdc8-39cf-4b4a-9cc5-1c30ffc3e848.jpg?v=1787591746",
      "score": 33,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dietary",
        "supplement",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 33,
        "manufacturing": 38,
        "safety": 45,
        "transparency": 22,
        "sustainability": 40
      },
      "price": 26.23,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804490453189",
      "vsf_explanation": "Third Perfecsy SKU with the literal name \"Dietary Supplement.\" Same failure mode: placeholder title, no ingredient disclosure, no benefit specification, no listable product identity. Auto-failed under misleading_naming.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "maca-capsule-male-nourishing-dietary-supplement-1",
      "title": "Maca Capsule Male Nourishing Dietary Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CCB83C0D7F298E7917A3F1561D2E986C_a4785591-a14c-40e7-95e2-18b6ee5a07fd.jpg?v=1787591754",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood",
        "energy",
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "maca",
        "capsule",
        "male",
        "nourishing",
        "dietary",
        "supplement",
        "digital",
        "presence"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 35,
        "manufacturing": 32,
        "safety": 42,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 21.32,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804490846405",
      "vsf_explanation": "Maca capsule product from 'a small third-party seller storefront' — the same generic dropshipper responsible for the shower gel and topical patch SKUs earlier in this batch, so the manufacturer-credibility floor is already established as low. Maca (Lepidium meyenii) has some real if modest evidence for improvement in sexual function and menopausal symptoms at gelatinized standardized extract doses (typically 1.5-3g/day). The category-generic 'Male Nourishing' branding and title-style suggest machine-translated marketing copy with undisclosed standardization, undisclosed maca variety (yellow, red, or black — each has slightly different traditional-use profiles and some research differentiation), and undisclosed dose per capsule. Without brand-verifiable manufacturing, without ingredient disclosure at studied doses, and given the seller's dropshipping profile, the product cannot be evaluated for identity, purity, or dose adequacy. Modestly higher than the aphrodisiac-blend SKUs because maca as an ingredient is broadly benign and lacks the PDE5-inhibitor adulteration risk profile, but still Rejected on transparency and manufacturer-credibility grounds.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "com-vitexia-energy-60-capsules",
      "title": "Com Vitexia & Energy - 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/GmBMlhuq7HCxphuQabBgZJdxuR9fEeafG2eKgiXQ.jpg?v=1787591762",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "com",
        "vitexia",
        "energy",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 42,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 38,
        "sustainability": 45
      },
      "price": 87.15,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804491403461",
      "vsf_explanation": "\"Com Vitexia & Energy\" is a Turkish-branded women's hormonal-support product — the \"Vitexia\" naming references Vitex agnus-castus (chasteberry), a botanical with real evidence for cyclical breast tenderness, premenstrual syndrome, and mild menstrual irregularities at 20-40mg/day of standardized extract (Schellenberg 2001 BMJ; Halaska 1999). The \"& Energy\" suffix bundles it with unspecified additional ingredients (typically B-vitamins, iron, ginseng), turning a single-active herbal into an undisclosed proprietary combination. Without per-active mg for Vitex (the ingredient the buyer is presumably seeking) and no standardization disclosure (Vitex is standardized on agnusides or casticin), the product cannot be evaluated. Auto-failed under proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "heavy-hitter-alpha-energy",
      "title": "Heavy Hitter Alpha Energy",
      "vendor": "EDMFestieGear.com",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1766773334037-generated-label-image-0.jpg?v=1787591767",
      "score": 36,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "heavy",
        "hitter",
        "alpha",
        "energy",
        "edmfestiegear",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 30,
        "manufacturing": 35,
        "safety": 38,
        "transparency": 22,
        "sustainability": 42
      },
      "price": 40.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804491829445",
      "vsf_explanation": "'Heavy Hitter Alpha Energy' — sold through a reseller storefront explicitly branded around the electronic music festival scene, which telegraphs the target market and use context: stimulant/energy blend consumption at electronic music festivals. This is a specific adverse-event risk profile: stimulant products consumed in hot, high-activity, dehydrating environments alongside potential recreational drug use (MDMA, cocaine, amphetamines) create serious cardiovascular and hyperthermic risk. Product name suggests high-stimulant formulation without ingredient disclosure. Combined with the seller's target demographic and use context, this product profile carries elevated real-world harm risk. Autofailed under proprietary_blend_hides_dose with additional concern for the target-use safety profile. Vyvata would not list stimulant supplements marketed for festival or party contexts regardless of underlying formulation quality.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "dietary-supplement-2",
      "title": "Dietary Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/72ae54c7-1248-49e9-8e23-a782891ba9cf.jpg?v=1787591773",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dietary",
        "supplement",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 34,
        "manufacturing": 38,
        "safety": 45,
        "transparency": 22,
        "sustainability": 40
      },
      "price": 21.45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804492026053",
      "vsf_explanation": "Second Perfecsy SKU with the literal product name \"Dietary Supplement\" and no ingredient, category, or benefit specification. Same auto-fail rationale as the other Perfecsy Dietary Supplement variants — this is a placeholder-titled ghost listing, not a real product identity. Auto-failed under misleading_naming. Vyvata cannot list a product that does not tell users what it is.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "natural-herbal-immune-defense-immunity-vitamins-supplement-booster-and-mushroom-supplement-with-lions-mane-reishi-chaga-cordyceps-turkey-tail-more",
      "title": "Natural Herbal Immune Defense Immunity Vitamins Supplement Booster And Mushroom Supplement With Lion's Mane, Reishi, Chaga, Cordyceps, Turkey Tail & More",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ab894e0f-aa71-4c9b-a85c-c4684d6716f7.jpg?v=1787591777",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive",
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "natural",
        "herbal",
        "immune",
        "defense",
        "immunity",
        "vitamins",
        "supplement",
        "booster",
        "and",
        "mushroom",
        "supplement",
        "with",
        "lion",
        "mane",
        "reishi",
        "chaga",
        "cordyceps",
        "turkey",
        "tail",
        "more",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 42,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 38,
        "sustainability": 45
      },
      "price": 86.45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804492320965",
      "vsf_explanation": "This is a keyword-stuffed Amazon-style product title on a Perfecsy white-label mushroom blend. The title names five mushroom species plus \"& More\" — the same 10-mushroom-blend problem: split across five-plus species, each mushroom is present at ~50-100mg, an order of magnitude below any studied therapeutic dose. Additionally, Perfecsy does not disclose fruiting-body vs mycelium origin (the primary quality variable for medicinal mushrooms — mycelium-on-grain products often measure single-digit percentages of beta-glucans versus 20-40% for fruiting-body extracts), and \"immunity vitamins supplement booster\" bundles additional undisclosed vitamins and \"immune boosters\" (typically vitamin C, zinc, elderberry). Auto-failed under proprietary_blend_hides_dose. The keyword-stuffed title is itself a signal of SEO-first product design rather than formulation-first product design.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "natural-female-enhancement-pills",
      "title": "Natural Female Enhancement Pills",
      "vendor": "EasyOptionXY",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/natural-female-enhancement-pills-wellness-fitness-dailysale-342211.jpg?v=1787591783",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "natural",
        "female",
        "enhancement",
        "pills",
        "easyoptionxy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 28,
        "manufacturing": 32,
        "safety": 32,
        "transparency": 20,
        "sustainability": 42
      },
      "price": 70.38,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804492976325",
      "vsf_explanation": "Female-enhancement / libido-boosting supplement from an obscure generic Shopify dropshipper with no supplement-industry infrastructure. The female-enhancement category shares many of the same adulteration risks as male-enhancement products — FDA Tainted Products database documents undisclosed sildenafil, tadalafil, and other pharmaceuticals in supplements marketed for female sexual function. In addition, some female-enhancement products have historically contained undisclosed hormone analogs (estrogen or estrogen-mimetic compounds) with real endocrine-disruption risk. Without ingredient disclosure, without third-party testing confirming absence of pharmaceutical adulterants, and from an obscure seller with no supplement-industry identity, the product cannot be evaluated for safety let alone efficacy. Autofailed under proprietary_blend_hides_dose with elevated concern for the category's documented adulteration risk profile.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "male-health-support-drops",
      "title": "Male Health Support Drops",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1fe136f3-37b0-4d70-a34e-cd4e00c1f8d0.jpg?v=1787591789",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "male",
        "health",
        "support",
        "drops",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 40,
        "manufacturing": 42,
        "safety": 48,
        "transparency": 32,
        "sustainability": 42
      },
      "price": 17.81,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804493205701",
      "vsf_explanation": "\"Male Health Support Drops\" is a doubly-vague product name — \"male health\" is undefined (libido? testosterone? prostate? erectile function? all of these have distinct evidence bases and distinct ingredient stacks) and \"Support\" bundles a proprietary blend behind non-specific benefit language. Tincture/drops format further obscures dose because a \"dropperful\" is not a standardized volume across users. The male-enhancement DTC category also has the highest FDA warning-letter rate of any supplement subcategory, largely due to undisclosed pharmaceutical adulteration (tadalafil, sildenafil analogs) in overseas-sourced male-libido products. Auto-failed under proprietary_blend_hides_dose. Small brand with no visible quality-system disclosure.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "aksu-vital-ginseng-extract-paste-300-g",
      "title": "Aksu Vital Ginseng Extract Paste 300 g",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/aksu-vital-ginseng-ekstraktli-macun-30-97c-47_4815a16a-750e-4cb9-81da-de7286fba74e.jpg?v=1787591792",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "aksu",
        "vital",
        "ginseng",
        "extract",
        "paste",
        "300",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 15.61,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804493533381",
      "vsf_explanation": "Aksu Vital is a real Turkish herbal manufacturer with a long track record in the Turkish domestic market. Ginseng extract paste at 300g total volume is a traditional Turkish honey-based tonic format (typically Panax ginseng root paste in honey), and the format itself has traditional-use history for energy and stress adaptation. The problem for Vyvata's scoring is standardization: without ginsenoside percentage disclosure, per-serving milligrams of ginseng, or specification of Korean red ginseng vs American ginseng vs Siberian eleuthero (three species with different actives and different evidence bases), the paste cannot be compared to any RCT dose. Sits at 54, just below Standard, because the category is legitimate but the disclosure is thin enough to fail Zero-Assumption scoring. Not autofailed — the naming is honest, not proprietary-blend.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "body-care-patch-relieves-body-massage-for-strong-vitality-body-fatigue-pain-and-discomfort-care",
      "title": "Body Care Patch Relieves Body Massage For Strong Vitality Body Fatigue, Pain And Discomfort Care",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1786FCEAED6F8576F44CB46CB022EACC.jpg?v=1787591810",
      "score": 26,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "body",
        "care",
        "patch",
        "relieves",
        "body",
        "massage",
        "for",
        "strong",
        "vitality",
        "body",
        "fatigue",
        "pain",
        "and",
        "discomfort",
        "care",
        "digital",
        "presence"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 18,
        "formulation": 25,
        "manufacturing": 25,
        "safety": 40,
        "transparency": 20,
        "sustainability": 30
      },
      "price": 25.26,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804494909637",
      "vsf_explanation": "This is a topical adhesive patch product — not a dietary supplement, not a wearable health tracker, not a diagnostic device, and not any category Vyvata scores. Product title reads as machine-translated marketing copy claiming pain relief, fatigue reduction, and 'strong vitality' from a topical patch. Claims of systemic effects from a topical patch without disclosed active ingredients, without transdermal-delivery documentation, and without any evidence of FDA registration would trigger multiple autofails simultaneously: out_of_scope_for_biohacking (not a supplement or health-tech category), unverified_medical_claim (pain relief, vitality claims from an undisclosed topical), and manufacturer_credibility (dropshipper seller with machine-translated title). Vyvata will not list adhesive patch products of undisclosed composition making health claims. Should be removed from the catalog rather than scored.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "creatine-hydration-powder-1",
      "title": "Creatine Hydration Powder",
      "vendor": "Muscle Faktor",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1774541825631-generated-label-image-0.jpg?v=1787591842",
      "score": 58,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "creatine",
        "hydration",
        "powder",
        "muscle",
        "faktor"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 48,
        "sustainability": 55
      },
      "price": 25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804496449733",
      "vsf_explanation": "Muscle Faktor Creatine Hydration Powder combines creatine (the most evidence-supported performance supplement in existence, with decades of RCT data for strength, lean mass, and cognitive benefit at 3-5 g/day) with an electrolyte / hydration component. The ingredient concept is defensible — creatine is one of the few supplements with unambiguous evidence, and pairing it with electrolytes addresses the intracellular water retention that creatine loading requires. Muscle Faktor's product line has scored in the low Standard tier in prior Vyvata batches when the SKU is single-ingredient with disclosed doses; the 'Hydration' branding here raises the risk of a proprietary electrolyte blend that hides individual mineral doses. Without full label disclosure of the creatine form (monohydrate is the studied form; other forms like HCl, buffered, ethyl ester lack the same evidence), creatine dose per serving (5g/day is the evidence-based target), and electrolyte breakdown (sodium, potassium, magnesium, chloride in mg), the product cannot cross the Standard threshold. Marks off primarily for the transparency and formulation-uncertainty gap; upside potential to Standard tier if the label discloses creatine monohydrate 5g plus specific electrolyte amounts.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrex-t-up-max-60-caps",
      "title": "Nutrex T-Up Max, 60 Caps",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Picture18_718138d6-d56b-48b4-8fde-335a527839dc.jpg?v=1787591847",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrex",
        "max",
        "caps",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 38,
        "manufacturing": 48,
        "safety": 45,
        "transparency": 28,
        "sustainability": 42
      },
      "price": 12.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804497170629",
      "vsf_explanation": "Nutrex T-Up Max is a testosterone-support / T-booster from Nutrex Research — a legacy sports-supplement brand (established late 1990s, based in Florida) that operates at the mainstream sports-nutrition tier but whose testosterone-booster line has consistently used proprietary blends that hide per-ingredient milligrams. Prior Vyvata scoring of Nutrex testosterone-booster SKUs has consistently resulted in Rejected outcomes under the proprietary_blend_hides_dose autofail rule. The T-booster category more broadly has weak evidence for measurable testosterone-level increases in eugonadal men — most 'natural test boosters' produce statistically indistinguishable effects from placebo in controlled trials (tribulus, D-aspartic acid at typical doses, fenugreek — modest and inconsistent). Manufacturing scores marginally higher than the obscure-brand SKUs because Nutrex is at least a real US brand with cGMP facilities, but the proprietary-blend transparency failure is disqualifying under Vyvata's rubric.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "nondo-epimedium-capsules-dietary-supplement-60-count",
      "title": "Nondo Epimedium Capsules - Dietary Supplement | 60 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/vmoyuN0UjVeI4JEl6zzWiuTjNga0csisPIOqbS7s.jpg?v=1787591858",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nondo",
        "epimedium",
        "capsules",
        "dietary",
        "supplement",
        "count",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 25.53,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804497727685",
      "vsf_explanation": "Nondo Epimedium is a Turkish/imported Epimedium (horny goat weed) capsule with no icariin standardization percentage disclosed at title level and no per-capsule milligrams for the active. Same core problem as the Vivalo Epimedium SKU: the male-enhancement category has the highest FDA PDE-5 adulteration rate in the supplement market, and unstandardized horny goat weed products almost always underdose the active flavonoid (icariin) below the modeled effective range (60-150mg icariin/day). Turkish sourcing without English-language COAs adds regulatory-oversight distance. Auto-failed under proprietary_blend_hides_dose for the missing standardization.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "alfa-libi-max-aphrodisiac-capsules-30-ct",
      "title": "Alfa Libi Max Aphrodisiac Capsules (30 ct)",
      "vendor": "Max*s Department Store",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ALFA_LIBI_MAX_AFRODISIAC_30_CA_676194150311_b13cef9f-ab2d-4117-b177-ab005b13b5c9.png?v=1787591863",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alfa",
        "libi",
        "max",
        "aphrodisiac",
        "capsules",
        "max",
        "department",
        "store"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 28,
        "manufacturing": 32,
        "safety": 32,
        "transparency": 20,
        "sustainability": 42
      },
      "price": 7.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804498153669",
      "vsf_explanation": "Alfa Libi Max is a male-enhancement / aphrodisiac capsule product from an obscure generic Shopify reseller with no supplement-industry infrastructure. Male-enhancement supplements are one of the two highest-risk supplement categories for undisclosed pharmaceutical adulteration in the FDA warning-letter and Tainted Products database. Over the past decade, FDA has issued hundreds of alerts on male-enhancement supplements found to contain undisclosed sildenafil (Viagra), tadalafil (Cialis), vardenafil (Levitra), or their analogs — real prescription PDE5 inhibitors that can produce dangerous hypotension when combined with nitrate medications (contraindicated combination), with other blood-pressure medications, or in patients with underlying cardiac disease. The dangerous combination has produced documented cardiac deaths. Obscure male-enhancement brands with no ingredient disclosure, no third-party testing, and no manufacturer-verifiable identity are exactly the SKU profile that FDA's Tainted Products database repeatedly finds adulterated. Autofailed under proprietary_blend_hides_dose (and effectively out_of_scope given the adulteration-risk category).",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "mens-body-shower-gel-body-skin-clean-and-moisturize-stay-fragrant-and-smooth-skin-shower-gel",
      "title": "Men's Body Shower Gel Body Skin Clean And Moisturize Stay Fragrant And Smooth Skin Shower Gel",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9175778039F46B69E1B0E024D834E5FA.jpg?v=1787591868",
      "score": 28,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "men",
        "body",
        "shower",
        "gel",
        "body",
        "skin",
        "clean",
        "and",
        "moisturize",
        "stay",
        "fragrant",
        "and",
        "smooth",
        "skin",
        "shower",
        "gel",
        "digital",
        "presence"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 30,
        "manufacturing": 28,
        "safety": 40,
        "transparency": 22,
        "sustainability": 30
      },
      "price": 22.78,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804498284741",
      "vsf_explanation": "This is a shower gel — a topical cosmetic hygiene product, not a dietary supplement, not a health-tech device, and not within any category Vyvata scores. Vyvata's scoring framework covers ingestible supplements, wearables, diagnostics, sleep optimization, and recovery/regeneration products. Cosmetic body wash falls entirely outside that scope. Additionally, the seller ('a small third-party seller storefront') is a generic dropshipper name with no cosmetic-formulation credibility, no INCI ingredient disclosure at title level, no safety or preservative-system transparency, and none of the FDA cosmetic-facility registration signals a real personal-care brand would carry. Autofailed under out_of_scope_for_biohacking; would not be listable even if in scope given the manufacturer-credibility failures.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "krilom-qh-plus-krill-oil-ubiquinol-pqq-antioxidant-omega-3-30-softgels",
      "title": "Krilom QH Plus: Krill Oil, Ubiquinol & PQQ - Antioxidant & Omega-3 (30 Softgels)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/IiuB5EDf3HA1kWAw8yQaHVQI08kIWEnSTKZKtvVE.jpg?v=1787591891",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "krilom",
        "plus",
        "krill",
        "oil",
        "ubiquinol",
        "pqq",
        "antioxidant",
        "omega",
        "softgels",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 60,
        "sustainability": 62
      },
      "price": 57.53,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804500152517",
      "vsf_explanation": "This is the most legitimately-formulated product in the a US reseller channel lineup. Krill oil (phospholipid-bound EPA/DHA with astaxanthin), ubiquinol (reduced CoQ10, superior bioavailability), and PQQ (pyrroloquinoline quinone, mitochondrial biogenesis biomarker) is a mechanistically-coherent mitochondrial and cardiovascular stack. All three actives have real evidence: krill oil at 1-3g/day for triglycerides and omega-3 index (Berge 2014); ubiquinol at 100-200mg for statin-associated muscle symptoms and heart failure (Q-SYMBIO extension); PQQ at 10-20mg for mitochondrial function markers (Nakano 2012). The named-ingredient title is a positive signal versus proprietary-blend competitors. Concerns: no per-active mg in title, small softgel count (30) suggests either high-dose single daily or one-per-day 30-day supply, and a US reseller channel is a US reseller with limited Turkish-brand quality disclosure. Solid Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dietary-supplement-3",
      "title": "Dietary Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/11a73de3-1b45-4a1f-b407-b3f2539cf717.jpg?v=1787591896",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dietary",
        "supplement",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 35,
        "manufacturing": 38,
        "safety": 45,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 15.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804500250821",
      "vsf_explanation": "A product literally named \"Dietary Supplement\" with no ingredient disclosure, no category specification, and no benefit target is the most severe possible failure of Vyvata's misleading_naming and proprietary_blend_hides_dose rules. This is not a scoring edge case — it is a product with no information content at all. Perfecsy ships multiple SKUs with this exact title, differing only by internal handle suffix. The pattern is characteristic of Amazon/Shopify white-label drop-shipping where placeholder titles are never replaced with real product names. Auto-failed under misleading_naming. Score in the mid-30s reflects the total absence of listable information, not a judgment about the underlying (unknown) contents.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "papaya-supplement-1",
      "title": "Papaya Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3d6e311e-6e89-4cff-ad86-6c1313b2354c_c735dc63-6497-4c30-a63b-edac4fca2c12.jpg?v=1787591907",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "papaya",
        "supplement",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 38,
        "manufacturing": 38,
        "safety": 48,
        "transparency": 32,
        "sustainability": 42
      },
      "price": 17.81,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804500480197",
      "vsf_explanation": "\"Papaya Supplement\" is a category-level product name with no active-ingredient specification — papaya-derived supplements can be papain (proteolytic enzyme, 100-500mg dose range), papaya leaf extract (dengue-adjunct positioning, no US regulatory approval), fermented papaya preparation (FPP — different mechanism, oxidative-stress marker), or dried fruit powder (nutritional profile only, no therapeutic dose). Each has a different evidence base, different dose, and different indication. Without specification, the product cannot be evaluated. Perfecsy is a white-label private-label reseller whose SKU lineup includes multiple generic \"Dietary Supplement\" listings — a strong tell for drop-shipping of overseas-manufactured product with no independent quality oversight. Auto-failed under misleading_naming and proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "ocean-extramag-fibra-90-tablets",
      "title": "Ocean ExtraMag Fibra 90 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ocean-extramag-fibra-90-tablet-4ab9-9.jpg?v=1787591913",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ocean",
        "extramag",
        "fibra",
        "tablets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 35.02,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804500644037",
      "vsf_explanation": "Ocean is a real Turkish nutraceutical brand (Vitalis Group), and ExtraMag Fibra is a magnesium + soluble fiber combination product marketed for occasional constipation and bowel regularity. The combination is mechanistically reasonable: magnesium (typically as hydroxide or oxide in constipation-targeted products) is an osmotic laxative at 300-500mg elemental, and soluble fiber (psyllium, inulin, or acacia) increases stool bulk and fermentation. Both have real, well-established evidence for regularity. The concerns: (1) the title does not disclose magnesium form (glycinate for absorption vs oxide/hydroxide for laxative effect are functionally different) or fiber source, (2) reseller listings rarely publish Turkish-language COAs for US consumers, (3) magnesium oxide at 300+mg produces dose-dependent diarrhea that is desired here but should be clearly communicated. Sits at Standard on category legitimacy.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nad-berry-flavor-drink-mix-for-skin-aging-support",
      "title": "NAD Berry Flavor Drink Mix For Skin Aging Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/dd6ce333-4a6c-4783-95ff-8b185ad2743c.jpg?v=1787591923",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy",
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nad",
        "berry",
        "flavor",
        "drink",
        "mix",
        "for",
        "skin",
        "aging",
        "support",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 42,
        "manufacturing": 48,
        "safety": 55,
        "transparency": 42,
        "sustainability": 48
      },
      "price": 35.53,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804500807877",
      "vsf_explanation": "The NAD+ precursor category (NMN, NR, NAM, NA) has real biology behind it — Martens 2018 showed nicotinamide riboside at 1000mg/day raises whole-blood NAD+ ~40-60%; NAD+ decline with age is well-documented — but the DTC market is riddled with underdose issues and outright NAD+ (not precursor) labeling that is pharmacologically pointless (oral NAD+ itself does not survive gut digestion). A \"NAD berry drink mix\" that discloses neither the precursor form (NR vs NMN vs NAM) nor the milligrams per serving cannot be evaluated against any RCT. Additionally, \"Skin Aging Support\" edges toward the unverified anti-aging claim territory. Not full autofail because the phrasing is softer than \"Anti Aging Drink,\" but sits in Rejected due to formulation ambiguity and marketing tension.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "anti-aging-drink",
      "title": "Anti Aging Drink",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b8ef5457-f0dd-4498-8203-f91587e1bc5d.jpg?v=1787591926",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "anti",
        "aging",
        "drink",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 38,
        "safety": 45,
        "transparency": 28,
        "sustainability": 42
      },
      "price": 50.84,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804500906181",
      "vsf_explanation": "\"Anti Aging Drink\" is an unverified medical claim in its product name. No FDA-regulated supplement can honestly claim to reverse or prevent biological aging in a general-population context, and the concept of \"anti-aging\" as a product benefit fails the FTC's Endorsement and Testimonial Guides for lack of substantiation. Any evidence base cited for individual longevity-associated compounds (resveratrol, NAD+ precursors, spermidine, urolithin A) applies to isolated actives at studied doses in defined populations — not to a bundled powdered drink mix positioned as a general anti-aging beverage. Auto-failed under unverified_medical_claim. Vivalo is a small DTC brand with no visible published research or ingredient standardization backing the anti-aging positioning.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "bsys-shilajit-gummies-60s",
      "title": "BSYS SHILAJIT GUMMIES 60'S",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6bbeba5f-2210-480e-94ac-522e2128ebed.jpg?v=1787591933",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bsys",
        "shilajit",
        "gummies",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 42,
        "manufacturing": 50,
        "safety": 48,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 76.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804501070021",
      "vsf_explanation": "Shilajit gummies are a marketing format masquerading as a delivery format. Traditional shilajit dosing is 300-500mg/day of purified resin (Keller 2019 for CoQ10 augmentation; Pandit 2016 for testosterone at 250mg BID). A gummy typically holds 100-200mg of a mineral pitch resin, and the sugar/pectin/glycerin matrix required to make a gummy palatable dilutes the active resin substantially per serving. Additionally, shilajit's core safety concern is heavy-metal contamination (soil-derived lead, arsenic, mercury, cadmium bioaccumulate in the raw mineral pitch), and a gummy format makes per-batch heavy-metal COA disclosure even more important — this SKU does not publish one. Vivalo is a small brand with limited manufacturing transparency. Not autofailed (the category is legitimate) but sits below Standard due to underdose format and missing COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "doctors-best-hi-absorption-coq10-with-bioperine-100mg-120-vc",
      "title": "DOCTOR'S BEST: Hi Absorption Coq10 With BioPerine 100Mg, 120 vc",
      "vendor": "Doctor's Best",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/753950001886_C1N1.jpg?v=1787591963",
      "score": 76,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "doctor",
        "best",
        "absorption",
        "coq10",
        "with",
        "bioperine",
        "100mg",
        "120",
        "doctor",
        "best"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 76,
        "formulation": 75,
        "manufacturing": 72,
        "safety": 74,
        "transparency": 74,
        "sustainability": 60
      },
      "price": 30.14,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804501692613",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 0 → new 76. Evidence found: Shoba G et al. Influence of piperine on the pharmacokinetics of curcumin in animals and human volunteers. Planta Med. 1998;64(4):353-356 (BioPerine bioavailability enhancement mechanism). | Langsjoen PH, Langsjoen AM. Comparison study of plasma coenzyme Q10 levels in healthy subjects supplemented with ubiquinol versus ubiquinone. Clin Pharmacol Drug Dev. 2014;3(1):13-17.. Rationale: Doctor's Best 'Hi Absorption' CoQ10 pairs ubiquinone with BioPerine (branded standardized piperine) for enhanced absorption. Piperine enhances CoQ10 bioavailability via P-gp inhibition and metabolic pathway effects. 100 mg is a functional dose. Verified tier for delivery-technology + evidence-supported active.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nature-made-co-q10-extra-strength-400-mg-softgels",
      "title": "Nature Made Co Q10, Extra Strength, 400 Mg, Softgels",
      "vendor": "Nature Made",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/188961241.jpg?v=1787591971",
      "score": 73,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "made",
        "q10",
        "extra",
        "strength",
        "400",
        "softgels",
        "nature",
        "made"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 77,
        "manufacturing": 78,
        "safety": 75,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 42.55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804501921989",
      "vsf_explanation": "Nature Made Extra Strength CoQ10 400 mg ubiquinone softgel. Q-SYMBIO used 300 mg/day; 400 mg is inside the studied range (safety literature to 1200 mg/day). Sub-therapeutic is a penalty; matching RCT dose is not. Same locked brand dimensions as the 100 mg and 200 mg Nature Made CoQ10s. Formulation 77: lipid softgel, one capsule covers RCT-range daily totals, no piperine. Evidence 75: same class-level CoQ10 literature, not weaker than 100 mg. Held below Elite by no confirmed USP mark on this SKU, ubiquinone rather than ubiquinol, and Kaneka not disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-coq-10-600-mg-megasorb-30-softgels",
      "title": "Solgar CoQ-10, 600 Mg, Megasorb, 30 Softgels",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/123179370.jpg?v=1787592025",
      "score": 82,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "coq",
        "600",
        "megasorb",
        "softgels",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 85,
        "formulation": 88,
        "manufacturing": 80,
        "safety": 82,
        "transparency": 80,
        "sustainability": 78
      },
      "price": 51.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804504871109",
      "vsf_explanation": "Solgar Megasorb CoQ-10 600mg 30 Softgels — direct-scored following evidence-crawl edge case. Megasorb is Solgar's proprietary lipid-carrier CoQ10 formulation with ~2-3× absorption vs standard powdered CoQ10 (Bhagavan & Chopra 2007 bioavailability review supports lipid-carrier class advantage). 600mg is the exact daily dose used in the Q-SYMBIO trial (Mortensen 2014, TIER-A heart failure RCT — 43% reduction in major adverse cardiovascular events vs placebo). This SKU delivers Q-SYMBIO-tier dose in the highest-absorption Solgar form. Solgar is Nestlé Health Science-owned via Bountiful (context note, not penalty). Verified tier 82.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "coq10-ubiquinone-supplement-30-capsules-byy-aziza-fae",
      "title": "CoQ10 (Ubiquinone) Supplement (30 Capsules) byy Aziza & Fae",
      "vendor": "TristanChristopher.ART",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1113881745178715542_2048.jpg?v=1787592064",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coq10",
        "ubiquinone",
        "supplement",
        "capsules",
        "byy",
        "aziza",
        "fae",
        "tristanchristopher",
        "art"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 42,
        "sustainability": 45
      },
      "price": 22,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804508344517",
      "vsf_explanation": "CoQ10 as an ingredient has a legitimate evidence base — statin-associated muscle symptoms, mitochondrial support in specific disease states, blood pressure modulation, and heart failure adjunct therapy (Q-SYMBIO 2014 trial with ubiquinol 100 mg TID) all have published RCT evidence. Ubiquinone (the oxidized form) is the more common and less expensive form; ubiquinol (the reduced form) has better absorption particularly in adults over 60. This particular SKU comes from an obscure Etsy-style seller lineage (sub-branded 'Aziza & Fae') without documented manufacturing infrastructure, third-party testing programs, or GMP facility disclosure. The 30-capsule format is small (a one-month supply if dosed once daily, less if dosed BID). Per-capsule milligram dose is not clearly disclosed at title level, and standardization / bioavailability formulation details (oil-based softgel vs dry powder capsule, which matters substantially for CoQ10 absorption) are not documented. Without brand-level manufacturing credibility, per-lot COAs, and clear label transparency, a fundamentally decent ingredient becomes an unverifiable product. Marked Rejected on transparency and manufacturing credibility grounds despite the sound ingredient choice.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "red-horseman",
      "title": "Red Horseman",
      "vendor": "1776 Sports Nutrition LLC",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/DDFB687B-41B9-40F2-9F55-838D3B46D579.jpg?v=1787592287",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "horseman",
        "1776",
        "sports",
        "nutrition",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 32,
        "manufacturing": 38,
        "safety": 42,
        "transparency": 22,
        "sustainability": 42
      },
      "price": 35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804516339909",
      "vsf_explanation": "1776 Sports Nutrition 'Red Horseman' is a pre-workout / energy formulation from a brand whose product line prominently includes an over-the-counter tirzepatide product — a Schedule Rx pharmaceutical sold as a supplement in likely violation of FDA/DEA controls. That parent-brand red flag alone materially compromises trust in every 1776 SKU: a brand willing to sell compounded GLP-1 peptides as supplements is not a brand exercising ordinary DSHEA-compliant judgment on any of its products. 'Red Horseman' as a product name is category-typical pre-workout branding suggesting stimulant blend, likely caffeine, beta-alanine, citrulline, and undisclosed proprietary components. Without a full Supplement Facts panel disclosed at title level with per-ingredient milligrams for every active, the product cannot be evaluated for stimulant dose, safety margins, or evidence-based dosing of the individual actives. Proprietary blends in pre-workout products are the industry's oldest transparency failure — they hide caffeine doses that can range from safe (100 mg) to reckless (400+ mg) behind a single 'Energy Blend' line-item. Autofailed under proprietary_blend_hides_dose. Would additionally warrant scrutiny under manufacturer_credibility given the sibling-SKU tirzepatide issue.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "at-4-ignite™",
      "title": "AT-4 Ignite™",
      "vendor": "1776 Sports Nutrition LLC",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/FullSizeRender_44165641-9ea6-4a79-b587-b4f9e1bdcc71.jpg?v=1787592288",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ignite",
        "1776",
        "sports",
        "nutrition",
        "llc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 32,
        "manufacturing": 38,
        "safety": 40,
        "transparency": 22,
        "sustainability": 42
      },
      "price": 42.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804516438213",
      "vsf_explanation": "1776 Sports Nutrition 'AT-4 Ignite' — same brand credibility failure as the rest of the 1776 line. Product name suggests fat burner / thermogenic / stimulant blend category (the 'ignite' suffix is standard fat-burner marketing shorthand). Thermogenic/fat-burner supplements are the highest-risk supplement category by FDA adverse-event volume, historically associated with recalls of ephedra, DMAA (Jack3d-era), DMHA, higenamine, and other stimulant compounds that produced hospitalizations and fatalities. Without full ingredient disclosure and given the parent brand's demonstrated willingness to sell Schedule Rx pharmaceuticals as supplements, the risk profile is unacceptable. Autofailed under proprietary_blend_hides_dose; safety score reflects the elevated category risk.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "sleep-formula-1",
      "title": "Sleep Formula",
      "vendor": "Vitalidad Natural",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1784701581973-generated-label-image-0.png?v=1787592372",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sleep",
        "formula",
        "vitalidad",
        "natural"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 42,
        "manufacturing": 45,
        "safety": 52,
        "transparency": 38,
        "sustainability": 45
      },
      "price": 23.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804518863045",
      "vsf_explanation": "\"Sleep Formula\" as a product name universally signals a melatonin + magnesium + L-theanine + valerian + chamomile proprietary stack with no per-active dose disclosure. Every one of those ingredients has legitimate sleep evidence at specific doses (melatonin 0.3-5mg for sleep onset per Ferracioli-Oda 2013; magnesium glycinate 200-400mg per Abbasi 2012; L-theanine 200mg per Kim 2019; valerian 300-600mg per Bent 2006), but a bundled \"formula\" that hides per-active mg cannot be evaluated against any of those doses. The specific concern with sleep blends is that melatonin is systematically overdosed in the DTC market (10mg is common; the studied physiological dose is 0.3-1mg), leading to grogginess, nightmares, and morning-hormone disruption without any efficacy gain. Auto-failed under proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "liver-support-3",
      "title": "Liver Support",
      "vendor": "Vitalidad Natural",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1784701762888-generated-label-image-0.png?v=1787592377",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liver",
        "support",
        "vitalidad",
        "natural"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 40,
        "manufacturing": 42,
        "safety": 48,
        "transparency": 32,
        "sustainability": 42
      },
      "price": 22.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804518928581",
      "vsf_explanation": "Vitalidad Natural is a Latino-market DTC line, and \"Liver Support\" is a category name that reliably signals a milk thistle / dandelion / artichoke / turmeric proprietary blend positioned around \"detox\" and \"cleanse\" claims. That framing is an unverified medical claim: the liver detoxifies continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for a general-population \"liver detox\" claim. The product title carries no per-active mg, no standardization (e.g., silymarin %), no extraction ratio, and no COA reference — a textbook proprietary-blend disclosure gap. Auto-failed under unverified_medical_claim for the detox-adjacent positioning that this SKU class universally carries and would additionally trip proprietary_blend_hides_dose. Would require dropping \"support\" framing that implies organ-treatment benefit, publishing a full quantitative Supplement Facts panel (silymarin mg, standardization %), and third-party COAs before re-evaluation.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "coq10-ubiquinone-3",
      "title": "CoQ10 Ubiquinone",
      "vendor": "Vitalidad Natural",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1784702015187-generated-label-image-0.png?v=1787592376",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coq10",
        "ubiquinone",
        "vitalidad",
        "natural"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 22.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804518961349",
      "vsf_explanation": "This is a legitimate single-active CoQ10 product in the ubiquinone form, which is the historically studied form with the deepest RCT base (Q-SYMBIO 2014 for heart failure at 300mg/day, Mortensen 2014). Ubiquinone is the oxidized form — cheaper than ubiquinol but with lower bioavailability in adults over 40 and in statin users. The title discloses the active but not the milligram dose, the delivery matrix (oil-based softgels absorb 3-4x better than powder capsules), or the manufacturer's third-party testing. Vitalidad Natural is a Latino-market DTC brand with limited public quality-system disclosure. Sits at Standard because the active is real and clinically relevant; would move to Verified 70+ with disclosed dose at 100-200mg, oil-based softgel format, and published COAs.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "complete-multivitamin",
      "title": "Complete Multivitamin",
      "vendor": "Vitalidad Natural",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1784741246521-generated-label-image-0.png?v=1787592377",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "complete",
        "multivitamin",
        "vitalidad",
        "natural"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 48,
        "sustainability": 50
      },
      "price": 22.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804519059653",
      "vsf_explanation": "Mainstream multivitamins as a category have modest RCT support — Physicians' Health Study II (Gaziano 2012) showed a small reduction in total cancer incidence over 11 years with Centrum Silver — but modern multi formulations vary enormously in vitamin form quality (folic acid vs L-methylfolate, cyanocobalamin vs methylcobalamin, oxide vs bisglycinate minerals) and dose adequacy. Vitalidad Natural's \"Complete Multivitamin\" gives no per-nutrient panel at the title level, no form disclosure, and no evidence of a targeted demographic (men's, women's, over-50) that would justify specific nutrient concentrations. Sits at Standard because multivitamins are a real, if generic, category; would move to Verified 70+ with a full published Supplement Facts panel using bioavailable forms and third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mushroom-complex-10-x",
      "title": "Mushroom Complex 10 X",
      "vendor": "Vitalidad Natural",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1784701770106-generated-label-image-0.png?v=1787592377",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mushroom",
        "complex",
        "vitalidad",
        "natural"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 38,
        "sustainability": 45
      },
      "price": 27.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804518994117",
      "vsf_explanation": "\"Mushroom Complex 10 X\" is textbook proprietary-blend framing: ten mushroom species combined into a single capsule with no per-species milligram disclosure, no beta-glucan standardization, and no fruiting-body-vs-mycelium disclosure — the single most important quality variable in the medicinal mushroom category. A 500mg total \"10-mushroom blend\" divided across ten species yields ~50mg per mushroom, an order of magnitude below any studied therapeutic dose (Lion's mane cognitive studies use 1000-3000mg; reishi studies use 1400-5400mg). Additionally, mycelium-on-grain products (common in inexpensive multi-mushroom capsules) contain significant starch filler and often measure single-digit percentages of beta-glucans versus 20-40% for fruiting-body extracts. Auto-failed under proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "digestive-enzyme-pro-blend-2",
      "title": "Digestive Enzyme Pro Blend",
      "vendor": "Vitalidad Natural",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1784701762877-generated-label-image-0.png?v=1787592377",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "digestive",
        "enzyme",
        "pro",
        "blend",
        "vitalidad",
        "natural"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 48,
        "safety": 55,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 23.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804519026885",
      "vsf_explanation": "\"Digestive Enzyme Pro Blend\" bundles the two red flags Vyvata autofails against: the \"Blend\" naming that hides per-enzyme activity units, and the enzyme category itself — where the meaningful dose disclosure is not milligrams but standardized activity units (FCC units: HUT for protease, DU for amylase, LU for lipase, GALU for alpha-galactosidase). Without those units, the product cannot be compared to any evidence base or to a competitor SKU. Digestive enzyme supplementation has real clinical utility in narrow settings (pancreatic exocrine insufficiency, lactose intolerance for lactase, disaccharidase deficiency) but broad \"digestive support\" claims in healthy adults lack RCT support. Auto-failed under proprietary_blend_hides_dose for the missing enzyme activity units.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "ginkgo-biloba-ginseng-1",
      "title": "Ginkgo Biloba + Ginseng",
      "vendor": "Vitalidad Natural",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1784701552043-generated-label-image-0.png?v=1787592377",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive",
        "energy",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ginkgo",
        "biloba",
        "ginseng",
        "vitalidad",
        "natural"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 48,
        "manufacturing": 48,
        "safety": 55,
        "transparency": 40,
        "sustainability": 48
      },
      "price": 23.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804519092421",
      "vsf_explanation": "Ginkgo and ginseng are two real, well-studied botanicals — ginkgo (as EGb 761 standardized to 24% flavone glycosides and 6% terpene lactones) has GEM Study (DeKosky 2008) data on dementia prevention (null) and multiple smaller cognitive-function trials (mixed); Panax ginseng (as G115 standardized to 4% ginsenosides) has mental-fatigue and cognitive-performance evidence at 200-400mg/day. But this combination product discloses neither the milligram dose per active nor the standardization percentage — the two variables that determine whether either ingredient is present at studied levels. A 60mg + 60mg combo is a homeopathic gesture; a 240mg EGb 761 + 400mg G115 combo would be a clinically relevant dose. Without disclosure, defaults to zero on formulation under the Zero-Assumption Rule. Auto-failed under proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "segmental-smart-scale-cs10k",
      "title": "Segmental Smart Scale CS10K",
      "vendor": "Arboleaf",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/png_3cebd51b-5758-49ee-b9c2-9f6717b30cc1.png?v=1787592395",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "segmental",
        "smart",
        "scale",
        "cs10k",
        "arboleaf"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "fitness_activity_trackers"
      ],
      "vsf_dimensions": {
        "analytical_validity": 58,
        "clinical_utility": 60,
        "transparency": 62,
        "build_quality": 62,
        "warranty_support": 58,
        "value": 68
      },
      "price": 100.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804519289029",
      "vsf_explanation": "Arboleaf's CS10K is a segmental BIA scale in the same product family as the CS10E, with a similar 8-electrode configuration and Arboleaf app integration. Reports body fat %, muscle mass, water %, visceral fat, and segmental composition. Analytical validity limits are the same as for all consumer segmental BIA — meaningful error against DEXA at the individual level, best used for trend tracking rather than absolute values. Legitimate mid-tier consumer scale with app support, Bluetooth sync, and multi-user profiles. Not FDA-cleared (general wellness device). Would move to Verified 70+ with published third-party accuracy validation and extended warranty documentation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "body-scale-cs20l",
      "title": "Body Scale CS20L",
      "vendor": "Arboleaf",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cs20lmain.png?v=1787592396",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "body",
        "scale",
        "cs20l",
        "arboleaf"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "fitness_activity_trackers"
      ],
      "vsf_dimensions": {
        "analytical_validity": 54,
        "clinical_utility": 55,
        "transparency": 60,
        "build_quality": 58,
        "warranty_support": 55,
        "value": 62
      },
      "price": 45.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804519321797",
      "vsf_explanation": "Arboleaf's CS20L is a lower-tier 4-electrode (feet-only) body composition scale reporting weight, body fat %, muscle mass, water %, BMR, and BMI via the Arboleaf app. Foot-only BIA is meaningfully less accurate than 8-electrode segmental BIA (the current is confined to the lower body and estimates whole-body composition, so upper-body composition is extrapolated rather than measured). Legitimate entry-level scale for basic trend tracking, but not suitable for anyone wanting reliable segmental data or precision body-comp measurements. Not FDA-cleared (general wellness device). Would move to Standard 62+ with clearer disclosure of the 4-electrode measurement limits and any independent accuracy validation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "segmental-smart-scale-cs10e",
      "title": "Segmental Smart Scale CS10E",
      "vendor": "Arboleaf",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CS10E-Main1.webp?v=1787592400",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "segmental",
        "smart",
        "scale",
        "cs10e",
        "arboleaf"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "fitness_activity_trackers"
      ],
      "vsf_dimensions": {
        "analytical_validity": 58,
        "clinical_utility": 62,
        "transparency": 65,
        "build_quality": 65,
        "warranty_support": 60,
        "value": 68
      },
      "price": 70.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804519420101",
      "vsf_explanation": "Arboleaf's CS10E is a Bluetooth-connected 8-electrode segmental BIA (bioelectrical impedance analysis) scale reporting whole-body and per-segment body fat %, muscle mass, water %, visceral fat, and bone mass. Arboleaf is a legitimate US consumer brand competing directly with Renpho and Withings in the mid-tier segmental-scale segment. Analytical validity of consumer 8-electrode BIA is a real weakness — even the best consumer BIA devices show meaningful error against the DEXA reference standard (typical error 3-8% for body fat % at the individual level, per multiple published comparison studies), and hydration status, food intake timing, and skin condition all affect the reading. Trend tracking day-over-day is more reliable than any single measurement. Not FDA-cleared (registered as a general wellness device, not a medical scale). App support and data export via the Arboleaf app is present. Would move to Verified 70+ with published third-party accuracy validation against DEXA, extended warranty, and clear disclosure of measurement error bounds.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "massager-cm40g",
      "title": "Massager CM40G",
      "vendor": "Arboleaf",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CM40G-Main.png?v=1787592401",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "massager",
        "cm40g",
        "arboleaf"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "percussion_vibration"
      ],
      "vsf_dimensions": {
        "analytical_validity": 58,
        "clinical_utility": 62,
        "transparency": 58,
        "build_quality": 62,
        "warranty_support": 58,
        "value": 65
      },
      "price": 59.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804519452869",
      "vsf_explanation": "Arboleaf's CM40G is a mid-tier consumer percussion massager competing in the Renpho/Ekrin/Bob and Brad segment below Theragun and Hypervolt. Evidence for percussion massage in recovery is Grade B/C at best — published RCTs (Konrad 2020, Hasenoehrl 2020) show modest short-term improvements in DOMS perception and range of motion versus passive rest, but effect sizes are small and inconsistent versus foam rolling or dynamic warm-up. Consumer percussion massagers deliver similar output profiles at wide price ranges; the Arboleaf CM40G is a full-size model with multiple attachments and speed settings. Amplitude, stroke frequency range, and stall force are the technical specs that matter and Arboleaf's public spec disclosure on the CM40G is mid-range for the segment. Would move to Verified 70+ with published amplitude/stall-force specs, extended warranty, and clear parameter guidance aligned with published research protocols.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "massager-cm20f",
      "title": "Massager CM20F",
      "vendor": "Arboleaf",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CM20F-Main.png?v=1787592401",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "massager",
        "cm20f",
        "arboleaf"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "percussion_vibration"
      ],
      "vsf_dimensions": {
        "analytical_validity": 55,
        "clinical_utility": 58,
        "transparency": 55,
        "build_quality": 58,
        "warranty_support": 55,
        "value": 65
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804519518405",
      "vsf_explanation": "Arboleaf's CM20F is a smaller-form-factor consumer percussion massager in the mini/portable segment (competing with the Theragun Mini, Hypervolt GO, and Bob and Brad C2). Smaller mini massagers trade amplitude and stall force for portability — typical mini specs are 7-10mm amplitude and 15-25 lbs stall force, meaningfully less than full-size units. Useful for travel and targeted small-muscle work but less effective for large muscle groups (quads, lats, glutes). Evidence base for percussion massage as a category is Grade B/C (see CM40G explanation). Arboleaf's public spec disclosure for the CM20F is limited on the product page. Would move to Standard 65+ with published amplitude/stall-force specs and extended warranty terms.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "massager-cm20c",
      "title": "Massager CM20C",
      "vendor": "Arboleaf",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CM20C-Midnight-Main.png?v=1787592401",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "massager",
        "cm20c",
        "arboleaf"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "percussion_vibration"
      ],
      "vsf_dimensions": {
        "analytical_validity": 55,
        "clinical_utility": 55,
        "transparency": 55,
        "build_quality": 55,
        "warranty_support": 55,
        "value": 62
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804519649477",
      "vsf_explanation": "Arboleaf's CM20C is another entry in Arboleaf's mini/portable percussion massager line. Same category positioning as the CM20F — portable, lower amplitude and stall force than full-size units, targeted at travel and small-muscle work. Evidence base for percussion massage is Grade B/C at best, with modest effect sizes for DOMS and range of motion in published RCTs. Arboleaf's public spec disclosure for the CM20C is limited, warranty terms are standard consumer 1-year, and the value proposition is competitive pricing in the mini segment. Would move to Standard 62+ with published amplitude/stall-force specs, longer warranty, and clear parameter guidance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "metawtr",
      "title": "MetaWTR",
      "vendor": "BioStack",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BottleFront_4c15a381-b823-431b-9afe-e4695810169c.jpg?v=1787592417",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "metawtr",
        "biostack"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 50,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 45,
        "sustainability": 52
      },
      "price": 45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804520304837",
      "vsf_explanation": "MetaWTR is a BioStack-branded 'metabolic water' / electrolyte-adjacent product. BioStack itself is a legitimate biohacker-focused DTC brand with a serious flagship formulation (GlyNAC+), but MetaWTR sits in a category — 'metabolic' or 'functional' waters — where marketing language routinely outruns evidence. The product page positions MetaWTR around metabolic-water concepts (structured water, hydration enhancement, mitochondrial support) that lack rigorous clinical validation independent of the manufacturer. Ingredient disclosure at title level is not complete enough to evaluate specific electrolyte concentrations, mineral sourcing, or the presence of any nootropic or metabolic actives beyond baseline hydration. Without a full quantitative panel disclosed at product-detail level and without independent peer-reviewed evidence that this particular formulation improves metabolic markers versus plain water plus standard electrolytes, the product cannot meet the evidence threshold for a Standard-tier listing. Not obviously unsafe — hydration products at reasonable electrolyte doses are broadly benign — but the value proposition is not substantiated. Rejected pending full disclosure and outcome evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cell-shield",
      "title": "Cell Shield",
      "vendor": "BioStack",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BottleFront_4aecded9-18c7-4e39-9415-7b968a54b5bc.jpg?v=1787592417",
      "score": 58,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cell",
        "shield",
        "biostack"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804520272069",
      "vsf_explanation": "BioStack Cell Shield positions as an antioxidant / cellular-protection blend. BioStack's brand credibility as a biohacker-focused DTC operator with a genuine flagship (GlyNAC+) provides some baseline formulation credibility, but 'Cell Shield' as a product name and positioning language is generic antioxidant-blend territory where the specific formulation choices matter far more than the brand halo. Without a full quantitative Supplement Facts panel disclosed at title level — per-ingredient milligrams for each antioxidant compound (astaxanthin, resveratrol, CoQ10, NAC, glutathione precursors, or whatever the blend actually contains), plus standardization data for any botanical extracts — the product cannot be scored above the Rejected/Standard boundary. Antioxidant blends are a category where clinical evidence tends to be weak for a general 'oxidative stress reduction' claim in healthy adults (the ATBC and CARET trials famously showed harm from beta-carotene supplementation in some populations), so the burden of proof for a blended antioxidant product is high. Marks off for insufficient title-level disclosure to evaluate dose adequacy, no publicly cited outcome evidence specific to this formulation, and the intrinsic weakness of the 'antioxidant support' category unless targeting a specific validated compound at a studied dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "glynac",
      "title": "GlyNAC+",
      "vendor": "BioStack",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BottleFront_1f6006d7-d0b3-4eab-b854-23d71ea6e014.jpg?v=1787592417",
      "score": 76,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glynac",
        "biostack"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 82,
        "formulation": 78,
        "manufacturing": 74,
        "safety": 74,
        "transparency": 76,
        "sustainability": 62
      },
      "price": 29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804520337605",
      "vsf_explanation": "BioStack GlyNAC+ is a formulation designed to replicate the Sekhar 2021 Baylor College of Medicine randomized controlled trial protocol — glycine plus N-acetyl-cysteine at combined doses shown to restore intracellular glutathione, improve mitochondrial function, reduce oxidative stress and inflammation markers, improve insulin sensitivity, and improve physical performance in older adults. The Sekhar lab has published multiple follow-up papers (2021, 2022, 2023) reinforcing the mechanism. This is one of the strongest longevity-adjacent supplement evidence bases currently available — a real RCT in humans measuring both mechanistic biomarkers (glutathione, oxidative stress, mitochondrial function via 31P-MRS) and functional outcomes (gait speed, grip strength, cognition). BioStack's implementation combines the two amino acids at doses that appear to approximate the study protocol (roughly 100 mg/kg/day each in the Sekhar trial, which for an 80 kg adult is ~8g each daily — real GlyNAC dosing is a significant powder or high-capsule-count regimen; check the label for per-serving amounts and total daily target). The '+' suggests additional supporting cofactors — evaluate ingredient panel for whether these enhance or dilute the core protocol. Marks off for typical DTC-scale manufacturing (not pharmaceutical-grade), the modest independent-verification apparatus, and the reality that the Sekhar evidence base, while strong, is still a single lab's body of work awaiting broader independent replication.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrafol-mens-3-month-pack",
      "title": "NUTRAFOL MENS 3 MONTH PACK",
      "vendor": "NUTRAFOL @ NYALLERGY",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NUTRAFOLMENS.jpg?v=1787592445",
      "score": 76,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrafol",
        "mens",
        "month",
        "pack",
        "nutrafol",
        "nyallergy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 76,
        "manufacturing": 74,
        "safety": 72,
        "transparency": 76,
        "sustainability": 62
      },
      "price": 209,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804520698053",
      "vsf_explanation": "[Rescored via evidence crawl] Previous score 0 → new 76. Evidence found: Ablon G, Kogan S. A Six-Month, Randomized, Double-Blind, Placebo-Controlled Study Evaluating the Safety and Efficacy of a Nutraceutical Supplement for Promoting Hair Growth in Men With Self-Perceived Thinning Hair. J Drugs Dermatol. 2018;17(5):558-565. | Farris PK, Rogers N, McMichael A, Kogan S. A Novel Multi-Targeting Approach to Treating Hair Loss, Using Standardized Nutraceuticals. J Drugs Dermatol. 2017;16(11):s141-s148.. Rationale: Nutrafol Men has a brand-specific 6-month RCT (Ablon & Kogan 2018) in men with self-perceived thinning hair showing significant improvement in hair growth and quality vs placebo. This is one of the very few hair-growth nutraceuticals with brand-specific double-blind trial evidence, warranting Verified tier despite standard proprietary-blend disclosure. Cap at 76 rather than Elite because trial was small (N<60) and single-site.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pharmanex®-nu-ease-digestion",
      "title": "Pharmanex® Nu Ease Digestion",
      "vendor": "Leaders Beauty & Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/US-Nu-Ease-Main.png?v=1787592548",
      "score": 53,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pharmanex",
        "ease",
        "digestion",
        "leaders",
        "beauty",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 52,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 41,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804524990661",
      "vsf_explanation": "Nu Ease is Nu Skin's plant-based digestive support supplement, marketed as 'non-laxative' with 30 capsules per bottle. The 'non-laxative' framing distinguishes it from stimulant-laxative herbal blends (senna, cascara sagrada) which have real GI safety and dependence concerns — that is a reasonable positioning choice. Products in this segment typically combine digestive enzymes (amylase, lipase, protease), soothing botanicals (ginger, peppermint oil, fennel), and prebiotic fibers. Evidence for digestive enzyme supplementation in the general population is limited to specific enzyme deficiencies (lactase for lactose intolerance is Grade A; broad-spectrum enzyme mixes for general 'bloat' are Grade C at best). Ginger for post-meal nausea has Grade B evidence at 500-1500mg dry weight. Peppermint oil (enteric-coated) for IBS symptoms has Grade B evidence. Formulation specifics on Nu Ease are not fully surfaced in the visible copy. Standard Nu Skin-MLM channel caveats apply. Score sits on the Rejected/Standard boundary — improvable with dose disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "optimum-omega®",
      "title": "Optimum Omega®",
      "vendor": "Leaders Beauty & Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/optimumomega.png?v=1787592548",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "optimum",
        "omega",
        "leaders",
        "beauty",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 68,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 24,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804524957893",
      "vsf_explanation": "Optimum Omega is Nu Skin's fish oil supplement providing EPA and DHA in softgel form. Underlying category has Grade A evidence in specific contexts: hypertriglyceridemia (EPA/DHA at 2-4g/day lowers triglycerides by 20-30%, ATC guidelines) and post-MI secondary prevention (Bhatt 2019 REDUCE-IT trial, high-dose icosapent ethyl); Grade B for general cardiovascular support and joint inflammation at 1-2g EPA+DHA/day; mixed/Grade C for primary prevention in the general population per the VITAL trial (Manson 2019). Whether Nu Skin's Optimum Omega provides a meaningful (1g+ per serving) EPA+DHA dose or a vanity dose (300mg per serving requiring 3+ softgels for a therapeutic dose) is the key question a label check resolves. Molecular distillation and heavy-metal QC are standard for the reputable fish oil segment; Nu Skin's Pharmanex manufacturing is above average for MLM brands. IFOS testing / rancidity numbers not surfaced in the visible copy. Standard tier as a reasonable fish oil in a competent brand; held below Verified by the MLM channel and typical Nu Skin price premium versus Verified fish oil brands (Nordic Naturals, Carlson, Wiley's Finest).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bone-formula",
      "title": "Bone Formula",
      "vendor": "Leaders Beauty & Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/boneformula.png?v=1787592548",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bone",
        "formula",
        "leaders",
        "beauty",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 65,
        "safety": 62,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 56,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804525056197",
      "vsf_explanation": "Nu Skin Bone Formula is positioned as a nutrient bundle supporting three bone-health mechanisms — bone formation, calcium absorption, and inhibition of bone loss — with 'novel sources of calcium and vitamin K' called out in the copy. Products in this segment typically combine calcium (usually citrate or hydroxyapatite, sometimes carbonate), magnesium, vitamin D3, vitamin K (K1 or K2 as MK-4/MK-7), and often boron, silica, and manganese. Evidence: calcium + D3 for postmenopausal bone density has Grade A evidence (WHI, MoS trials), though the effect size for fracture reduction in the general community-dwelling population is modest (Bolland 2015 meta-analysis). Vitamin K2 (MK-7) at 180mcg/day has Grade B evidence for postmenopausal bone density improvement (Knapen 2013). Magnesium and boron have Grade C support. Whether Nu Skin's Bone Formula delivers the studied doses (1000-1200mg calcium, 1000-2000 IU D3, 180mcg K2) depends on the label. The 'novel sources' claim suggests hydroxyapatite calcium or MK-4 vitamin K — plausible if disclosed. Standard tier as a reasonable bone-nutrient bundle in a competent brand; MLM channel and dose-disclosure gap hold below Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mynd360™-feel-calm",
      "title": "MYND360™ Feel Calm",
      "vendor": "Leaders Beauty & Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Feel-Calm-Packaging_2.png?v=1787592548",
      "score": 53,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mynd360",
        "feel",
        "calm",
        "leaders",
        "beauty",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 52,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 64,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804525088965",
      "vsf_explanation": "MYND360 Feel Calm is Nu Skin's daytime mood/stress capsule in the MYND360 cognitive-brand family, 60 capsules per bottle. Products in this segment typically combine some subset of L-theanine, ashwagandha (KSM-66 or Sensoril), Rhodiola rosea, saffron extract (Affron), lemon balm, and B-vitamins. Individual ingredient evidence: L-theanine at 200mg has Grade B evidence for acute stress/anxiety relief without sedation (Kimura 2007, Rao 2015). Ashwagandha at 300-600mg standardized extract has Grade B evidence for cortisol reduction and perceived stress in adults with elevated stress (Chandrasekhar 2012, Lopresti 2019). Rhodiola at 200-400mg has Grade B evidence for stress-induced fatigue (Panossian 2010). Saffron (Affron) at 28mg has Grade B evidence for mood support (Lopresti 2018). Whether MYND360 Feel Calm hits these ingredients at studied doses is the deciding question a label check resolves. 'MYND360' branding again implies 360-degree brain support which is marketing overreach. Standard Nu Skin MLM caveats. Sits on Rejected/Standard boundary — improvable with dose disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pharmanex®-nu-biome®-coconut-pineapple-caffeine-free",
      "title": "Pharmanex® Nu Biome® Coconut Pineapple Caffeine Free",
      "vendor": "Leaders Beauty & Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NEW-FLAVOR-Coconut-Pineapple-Nu-Biome.jpg?v=1787592548",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pharmanex",
        "biome",
        "coconut",
        "pineapple",
        "caffeine",
        "free",
        "leaders",
        "beauty",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 52,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 48,
        "sustainability": 45
      },
      "price": 68,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804525023429",
      "vsf_explanation": "Nu Biome is Nu Skin's probiotic-prebiotic drink mix, coconut-pineapple caffeine-free variant. Products in this format typically combine one or more probiotic strains (usually Lactobacillus and Bifidobacterium species) with prebiotic fibers (inulin, FOS, resistant starch) and flavoring. The evidence gate for a probiotic product is strain-level specificity — the FDA and every serious systematic review require identification down to the strain (genus + species + strain designation, e.g. Lactobacillus rhamnosus GG or Bifidobacterium lactis BB-12) and per-serving CFU count. Strain evidence is Grade B for specific outcomes (L. rhamnosus GG for pediatric acute diarrhea; B. infantis 35624 for IBS symptoms; VSL#3 for pouchitis). Generic 'probiotic blend' without strain designations has Grade C at best because the outcomes are strain-specific, not species-specific. Whether Nu Biome discloses full strain-level identification and CFU counts is the deciding question. Format as a flavored drink mix is convenient but adds sugar or non-nutritive sweeteners. Standard Nu Skin MLM channel caveats. Sits on Rejected/Standard boundary.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cortitrol®-stress-support",
      "title": "Cortitrol® Stress Support",
      "vendor": "Leaders Beauty & Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Cortitol.png?v=1787592548",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cortitrol",
        "stress",
        "support",
        "leaders",
        "beauty",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 48,
        "sustainability": 45
      },
      "price": 55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804525121733",
      "vsf_explanation": "Cortitrol is Nu Skin's cortisol-modulation formula, positioned around 'enhanced feelings of well-being' with 60 capsules per bottle. Cortitrol formulations across the market typically combine phosphatidylserine (PS, from soy or sunflower lecithin — 300-600mg has Grade B evidence for blunting exercise-induced and mental-stress cortisol rise, Monteleone 1990, Starks 2008), ashwagandha (300-600mg standardized, Grade B for perceived stress and cortisol reduction, Chandrasekhar 2012), magnolia bark (Honokiol/Magnolol, Grade C-B for anxiolytic effect via GABA-A modulation), and sometimes epimedium or L-theanine. The 'Cortitrol' branding implies direct cortisol-lowering action — this is more supportable than most Nu Skin 'anti-aging' claims because PS and ashwagandha do have published cortisol-attenuation data. Whether the specific Cortitrol formulation delivers these at studied doses is the label question. Standard Nu Skin MLM caveats. Sits on Rejected/Standard boundary.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "prysm-io™-by-nu-skin-wellness-scanner",
      "title": "Prysm iO™ by Nu Skin Wellness Scanner",
      "vendor": "Leaders Beauty & Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/14A4307F-FECC-416D-B807-672656856D4E.webp?v=1787592548",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "prysm",
        "skin",
        "wellness",
        "scanner",
        "leaders",
        "beauty",
        "wellness"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "nutrient_deficiency_testing"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 356,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804525187269",
      "vsf_explanation": "The Prysm iO is Nu Skin's third-generation biophotonic Raman-spectroscopy-based skin carotenoid scanner. This is a real, published biophotonic measurement technology — Bernstein and colleagues developed the underlying resonance Raman spectroscopy for skin carotenoid measurement (Ermakov 2004, Bernstein 2004), and Zidichouski et al. (2009) validated the specific Nu Skin scanner's ability to detect carotenoid intake differences. The scanner does measure what it claims to measure: skin carotenoid density at the palm, which correlates with dietary and supplemental carotenoid intake and roughly tracks fruit-and-vegetable consumption in dietary studies. Where the product is honest: as a personal biomarker feedback tool showing whether your carotenoid intake is rising or falling over time. Where the interpretation becomes overreach: skin carotenoid density is not a validated marker of 'antioxidant status', 'immune health', or 'biological aging' — it is a nutrient-intake biomarker, similar to serum vitamin D level. The Prysm scanner is also a purpose-built MLM sales tool: distributors use scanner readings to demonstrate that carotenoid intake is 'low' and to justify recommending LifePak. This is a real product with real validation being used in a partially misleading sales context. Standard tier as a legitimate biomarker device; would move to Verified with explicit disclosure that the measurement is a nutrient-intake biomarker and not a general 'wellness' or 'antioxidant status' score.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ageloc®-meta",
      "title": "ageLOC® Meta",
      "vendor": "Leaders Beauty & Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/META-pdps-US-Main-Image.jpg?v=1787592548",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ageloc",
        "meta",
        "leaders",
        "beauty",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 52,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 136,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804525154501",
      "vsf_explanation": "ageLOC Meta is Nu Skin's flagship 'ageLOC youth gene cluster' metabolic-support supplement, marketed as targeting the body's 'meta' (metabolic) aging pathways with a proprietary blend positioned as supporting adiponectin, healthy blood sugar, and healthy body composition. Underlying issue: the 'ageLOC' marketing framework — 'youth gene clusters' allegedly targeted by proprietary blends — is a marketing construct that exceeds published evidence. Nu Skin has published some gene-expression work (typically in cell culture or short-term human samples) showing that their extracts modulate expression of various genes, but the leap from 'modulates gene expression in vitro' to 'targets youth gene clusters and reverses metabolic aging' is a substantial evidentiary jump not supported by the RCT literature. Individual ingredients in the Meta formula may be defensible (adiponectin-modulating botanicals have some Grade C evidence), but the branding framework itself is unverified. Standard Nu Skin MLM caveats. The 'anti-aging' + 'youth gene' framing triggers the unverified_medical_claim flag even though the product is not autofailed on it — this sits close to the Rejected/Standard boundary and receives Rejected primarily on the marketing-versus-evidence gap.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "estera®-phase-ii-womens-transitions-formula",
      "title": "Estera® Phase II Women's Transitions Formula",
      "vendor": "Leaders Beauty & Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/01003637-estera-phase-2.webp?v=1787592548",
      "score": 53,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "estera",
        "phase",
        "women",
        "transitions",
        "formula",
        "leaders",
        "beauty",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 52,
        "manufacturing": 62,
        "safety": 55,
        "transparency": 48,
        "sustainability": 45
      },
      "price": 89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804525220037",
      "vsf_explanation": "Estera Phase II is Nu Skin's perimenopause-positioned formula in the three-phase Estera women's line, 60 softgels. The perimenopause segment typically uses black cohosh (Actaea racemosa, EMA HMPC monograph for hot flashes), soy isoflavones, chasteberry, and sometimes DIM (diindolylmethane) for estrogen metabolism support. The product copy specifically mentions working with the liver to promote 'a healthy ratio of estrogen metabolites' — this is a reference to the 2-OH:16α-OH estrone ratio, which DIM and I3C (indole-3-carbinol) do modulate in published human studies (Michnovicz 1997, Dalessandri 2004). Individual ingredient evidence: black cohosh has mixed evidence — the 2013 Cochrane review found insufficient evidence for hot flash reduction but the EMA HMPC monograph still supports traditional use; soy isoflavones have Grade B for modest vasomotor symptom reduction; DIM has Grade B evidence for shifting estrogen metabolite ratios but Grade C for clinical outcomes. Same 'Phase' sequenced-protocol overreach as Phase I. Standard Nu Skin MLM caveats. Rejected primarily on the sequenced-protocol framing and the transparency gap.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ageloc®-youth-anti-aging-supplement",
      "title": "ageLOC® Youth Anti-aging Supplement",
      "vendor": "Leaders Beauty & Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Ageloc-youth-US.jpg?v=1787592549",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "youth_under_18",
      "tokens": [
        "ageloc",
        "youth",
        "anti",
        "aging",
        "supplement",
        "leaders",
        "beauty",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 42,
        "sustainability": 45
      },
      "price": 160,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804525252805",
      "vsf_explanation": "ageLOC Youth is Nu Skin's flagship 'anti-aging supplement' — the marketing claims 'the power to defy your age' and 'revitalize your aging defense mechanisms' via a proprietary formulation built on 'over a decade of research.' Product copy language ('defy your age', 'youth' as the product name, 'anti-aging supplement' as the category) triggers the unverified_medical_claim flag under the Vyvata rubric — no supplement, including this one, has RCT-outcome evidence for reversing or 'defying' aging as measured by validated biomarkers (DNA methylation clocks, telomere length, senescence markers, functional healthspan). The ingredient base is likely reasonable (Nu Skin's ageLOC line typically combines mixed carotenoids, polyphenols like resveratrol, sirtuin activators, and adaptogens) — individual ingredients may have Grade B-C evidence for narrower outcomes like reducing oxidative stress markers or supporting mitochondrial function. What triggers the Rejected status is the combination of (1) 'Youth' + 'Anti-aging' + 'defy your age' framing exceeding the actual evidence base for the specific formulation, (2) proprietary-blend positioning, and (3) MLM channel. This is the closest of the 17 SKUs to an autofail on unverified_medical_claim; scoring conservatively as Rejected 48 with the flag applied but not autofailing outright pending the label check on ingredient disclosure.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "estera®-phase-iii-womens-maintenance-formula",
      "title": "Estera® Phase III Women's Maintenance Formula",
      "vendor": "Leaders Beauty & Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/01003638-estera-phase-3.jpg?v=1787592548",
      "score": 53,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "estera",
        "phase",
        "iii",
        "women",
        "maintenance",
        "formula",
        "leaders",
        "beauty",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 52,
        "manufacturing": 62,
        "safety": 55,
        "transparency": 48,
        "sustainability": 45
      },
      "price": 89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804525285573",
      "vsf_explanation": "Estera Phase III is Nu Skin's postmenopause-positioned formula in the three-phase Estera women's line, 60 capsules. The product copy references supporting 'healthy estrogen metabolites' and 'healthy cardiovascular' function — again pointing at DIM/I3C-style estrogen metabolism modulation and cardioprotective botanicals. Postmenopause supplement formulations typically combine soy isoflavones, DIM, red clover, and cardioprotective additions like CoQ10, magnesium, or plant sterols. Individual ingredient evidence: soy isoflavones Grade B for modest vasomotor symptom persistence and bone density support in postmenopausal women (Chen 2015); DIM Grade B for estrogen metabolite ratio shift, Grade C for clinical outcomes; red clover isoflavones mixed evidence for hot flash reduction (Cochrane 2013 found insufficient evidence). Same 'Phase' sequenced-protocol overreach as Phase I and II. Standard Nu Skin MLM caveats. Postmenopausal cardiovascular and bone-health decisions should sit with a clinician tracking DEXA, lipid panels, and cardiovascular risk — not with a distributor recommending the next bottle in a sequenced line. Rejected primarily on the sequenced-protocol framing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mynd360™-night-time",
      "title": "MYND360™ Night Time",
      "vendor": "Leaders Beauty & Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Copy_of_Copy_of_We_Ship_World_Wide_1.png?v=1787592561",
      "score": 53,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mynd360",
        "night",
        "time",
        "leaders",
        "beauty",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 52,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 57,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804525744325",
      "vsf_explanation": "MYND360 Night Time is Nu Skin's sleep-support powder in the 'MYND360' cognitive-brand family, sold as a 30-serving canister. Sleep supplements of this format typically combine some subset of melatonin, L-theanine, magnesium (usually glycinate or citrate), GABA, glycine, and adaptogenic herbs (ashwagandha, valerian, or L-tryptophan). Individual ingredient evidence varies widely: melatonin has Grade A evidence for sleep-onset support in circadian misalignment (jet lag, shift work) with modest effect on general insomnia (Ferracioli-Oda 2013 meta-analysis); L-theanine at 200mg has small but consistent effect on sleep quality (Rao 2015); magnesium glycinate at 200-400mg is well-supported for people who are magnesium-deficient; ashwagandha at 300-600mg has modest sleep-quality evidence (Langade 2019). Whether MYND360 Night Time delivers these at studied doses is the critical question the truncated body copy does not resolve. 'MYND360' branding implies comprehensive 360-degree brain optimization which is marketing overreach — sleep is one dimension of cognition, and no supplement bundle delivers true multi-dimensional brain health. Score sits on the Rejected/Standard boundary; if Nu Skin's Supplement Facts panel confirms melatonin at 1-5mg + L-theanine at 200mg + magnesium at 200mg+, this would move into Standard 60. Currently held back by transparency gap on effective doses and the MLM channel.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "beauty-focus®-powder-mix-in-collagen-citrus",
      "title": "Beauty Focus® Powder Mix-In Collagen+ Citrus",
      "vendor": "Leaders Beauty & Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BEAUTYFOCUS_2.png?v=1787592574",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beauty",
        "focus",
        "powder",
        "mix",
        "collagen",
        "citrus",
        "leaders",
        "beauty",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 76,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804525908165",
      "vsf_explanation": "Beauty Focus Collagen+ is Nu Skin's citrus-flavored collagen peptide drink mix, typically supplying hydrolyzed marine or bovine collagen peptides plus supporting vitamin C and hyaluronic acid. Underlying category is one of the better-supported beauty-nutrition segments: hydrolyzed collagen peptides at 10-15g/day have Grade B human evidence for measurable improvements in skin elasticity, hydration, and dermal collagen density (Choi 2019, Kim 2018, Bolke 2019 skin RCTs; Clark 2008 joint pain RCT). Vitamin C is a cofactor for collagen synthesis, so co-formulating it with collagen peptides is chemically sensible. Whether Beauty Focus delivers at the studied 10-15g/day dose depends on Nu Skin's serving size — the class evidence supports the mechanism, the specific formulation needs to be verified against label. Manufacturing QC is above average for the collagen segment (Nu Skin runs GMP-certified US facilities). Score held below Verified by MLM channel, standard Nu Skin transparency gaps (proprietary flavor blend), and the beauty-marketing framing that promises visible skin transformation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lifepak®-nano-anti-aging-multivitamin-supplements",
      "title": "Lifepak® Nano Anti-aging Multivitamin Supplements",
      "vendor": "Leaders Beauty & Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/lifepaknano.png?v=1787592581",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune",
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lifepak",
        "nano",
        "anti",
        "aging",
        "multivitamin",
        "supplements",
        "leaders",
        "beauty",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 68,
        "safety": 62,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 213,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804526039237",
      "vsf_explanation": "LifePak Nano is Nu Skin's premium variant of LifePak, adding a nano-emulsification claim for the fat-soluble carotenoid and CoQ10 components. The 'Nano' name refers to reduced particle size to increase bioavailability of lipophilic ingredients — a real pharmaceutical concept for fat-soluble nutrients (CoQ10 in particular has poor baseline bioavailability, and nano/micronized/solubilized forms do measurably increase serum uptake per Ubiquinol vs standard ubiquinone comparative work). Nu Skin has published some internal comparative bioavailability data for LifePak Nano vs standard LifePak, though independent replication is limited. Underlying formulation is the same tier as standard LifePak — solid comprehensive multi with meaningful EPA/DHA, adequate D3, competent B-complex, mixed carotenoids. Same Nu Skin-MLM context caveats apply. Same 'Anti-Aging' marketing overreach on the carotenoid biomarker. Standard tier for the same reasons as regular LifePak, with a small upside from genuinely-plausible bioavailability improvement on fat-soluble components and a small downside from thinner independent validation of the nano claim specifically.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lifepak®-anti-aging-formula-supplements",
      "title": "LifePak® Anti-Aging Formula Supplements",
      "vendor": "Leaders Beauty & Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/lifepakantiaging.png?v=1787592582",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lifepak",
        "anti",
        "aging",
        "formula",
        "supplements",
        "leaders",
        "beauty",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 68,
        "safety": 65,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 112,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804526104773",
      "vsf_explanation": "LifePak is Nu Skin's flagship comprehensive daily nutrient bundle — a packet-per-day format combining a multivitamin, a mineral pack, a fish-oil softgel, a CoQ10 softgel, and a mixed-carotenoid softgel. Underneath the 'Anti-Aging' marketing this is a legitimately competent multi-nutrient package: adequate D3 (typically 800-1000 IU), a proper B-complex including active folate forms in some regional variants, a mixed-carotenoid blend (alpha- and beta-carotene, lycopene, lutein, zeaxanthin — which is where the Prysm scanner biofeedback loop plays in), and EPA/DHA at meaningful (not vanity) doses. Manufacturing is stronger than the typical MLM label — Nu Skin's Pharmanex operation is an established GMP-certified US supplement manufacturer with published QC processes and third-party heavy-metal testing. Zidichouski et al. (2009) published skin carotenoid response data comparing LifePak users against non-users using the biophotonic Prysm scanner — the finding (higher skin carotenoid density with sustained LifePak use vs non-users) is real and consistent with what a mixed-carotenoid supplement would do; the interpretation ('more anti-aging protection') is a marketing overreach on that carotenoid biomarker. Legitimately Standard tier as a comprehensive daily multi, flagged for 'Anti-Aging' branding that exceeds published evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pharmanex®-m-smart™",
      "title": "Pharmanex® M-Smart™",
      "vendor": "Leaders Beauty & Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/M-Smart-PDP-M-Smart-main-image.jpg?v=1787592587",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pharmanex",
        "smart",
        "leaders",
        "beauty",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 52,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 48,
        "sustainability": 45
      },
      "price": 71,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804526203077",
      "vsf_explanation": "Pharmanex M-Smart is a Nu Skin blood-glucose-response supplement supplied as 30 x 3.35g stick packs to be taken with meals. The product's stated mechanism is dampening the postprandial glucose spike from both starches and simple sugars — this is a legitimate metabolic target and matches the mechanism of well-studied ingredients like white kidney bean extract (Phaseolus vulgaris alpha-amylase inhibitor, Barrett & Udani 2011 systematic review), berberine (Yin 2008), and mulberry-leaf 1-deoxynojirimycin (Kimura 2007). Whether M-Smart delivers on that mechanism depends on which specific ingredients and doses Nu Skin has put in the stick pack, and on whether those doses match the studied ranges. Underlying category evidence is Grade B for the correct ingredients at studied doses; the M-Smart-specific formulation has some Nu Skin-funded internal data but limited independent peer-reviewed validation. Not obviously unsafe at typical doses for a healthy adult. Score is pulled down by the MLM-distributor sales channel and the standard Nu Skin transparency gaps.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "estera®-phase-i-womens-balance-formula",
      "title": "Estera® Phase I Women's Balance Formula",
      "vendor": "Leaders Beauty & Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/01003640-estera-phase-1.webp?v=1787592593",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "estera",
        "phase",
        "women",
        "balance",
        "formula",
        "leaders",
        "beauty",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 52,
        "manufacturing": 62,
        "safety": 58,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804526268613",
      "vsf_explanation": "Estera Phase I is the first of Nu Skin's three-phase 'Estera' line targeting the female hormonal life course (menstruating years → perimenopause → postmenopause). Phase I is positioned for women in their reproductive years and is typically built around soy isoflavones with supporting botanicals such as chasteberry and rosemary. Ingredient class is defensible: soy isoflavones have Grade B human evidence for modest hormonal-support effects (Chen 2015 meta-analysis; NIH ODS soy monograph), and chasteberry has EMA HMPC monograph status for cyclical female discomfort. But scoring is dragged down by two Nu Skin patterns that repeat across the line: (1) the SKU is sold via a Nu Skin distributor channel, which is Nu Skin's MLM (multi-level marketing) sales channel — Nu Skin's regulatory history includes a $47M FTC settlement in 1997 for pyramid-scheme allegations and multiple subsequent SEC/FTC actions over income claims and product claims, and this is disclosed context users deserve to see; (2) the 'Phase I / II / III' branding implies a stepwise clinical protocol that is not itself validated in peer-reviewed literature — the underlying botanicals have some evidence, but the sequenced-protocol framing exceeds what published trials of the specific Estera formulation support (Nu Skin has not published Phase I trial data for Estera as a bundle at the same evidentiary level as, e.g., the LifePak/Prysm carotenoid work). Not listable in current form because the underlying medical-decision framing (which phase of a woman's life she should be in a specific supplement rotation) belongs with a clinician, not a distributor.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "meadowsweet-tincture",
      "title": "Meadowsweet Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Meadowsweet-Tincture-Gardenix-Vitamins-_-Supplements-151803489.jpg?v=1787592725",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "meadowsweet",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804530331845",
      "vsf_explanation": "Meadowsweet Tincture is single-ingredient liquid tincture Meadowsweet (Filipendula ulmaria). Meadowsweet is a European plant naturally rich in salicylic-acid precursors — indeed, aspirin (acetyl-salicylic acid) is named for Spiraea (meadowsweet's old genus name). Traditionally used for GI upset and mild pain. No large modern RCT evidence. Salicylate content provides mechanistic plausibility for anti-inflammatory effect at high doses. Aspirin-like activity — avoid with aspirin allergy, in children (Reye syndrome), pre-surgery, with warfarin/DOACs. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "black-cohosh-tincture",
      "title": "Black Cohosh Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Black-Cohosh-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10085041.jpg?v=1787592725",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "black",
        "cohosh",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 42,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804530430149",
      "vsf_explanation": "Black Cohosh Tincture is single-ingredient liquid tincture Black Cohosh (Actaea racemosa). Black cohosh is a Native American plant used by Algonquian peoples for female complaints, later adopted by 19th-century Eclectic physicians. Triterpene glycosides and phenolic acids are candidate actives; mechanism debated (not estrogenic). Franco 2016 meta-analysis found modest reduction in hot flash frequency for standardized extracts (Remifemin) but effect is inconsistent across trials. NCCIH characterizes evidence as \"insufficient to draw firm conclusions.\" Rare hepatotoxicity case reports have led to European and Australian regulatory warnings. Avoid with liver disease. FDA has not banned but recommends caution. Preliminary evidence but documented safety concern lowers the score. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "red-clover-herb-tincture",
      "title": "Red Clover Herb Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Red-Clover-Herb-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10081810.jpg?v=1787592725",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "clover",
        "herb",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804530725061",
      "vsf_explanation": "Red Clover Herb Tincture is single-ingredient liquid tincture Red Clover (Trifolium pratense). Red clover contains isoflavones (biochanin A, formononetin) that act as weak phytoestrogens. Ghazanfarpour 2015 meta-analysis found small reduction in hot flash frequency with red clover isoflavone extracts (40-80 mg/day). Effect is modest and inconsistent. Theoretical hormonal effects — avoid with hormone-sensitive cancers. Anticoagulant activity (coumarins). Traditional use with weak or inconsistent RCT support. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dong-quai-tincture",
      "title": "Dong Quai Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Dong-Quai-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10081055.jpg?v=1787592725",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dong",
        "quai",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804530626757",
      "vsf_explanation": "Dong Quai Tincture is single-ingredient liquid tincture Dong Quai (Angelica sinensis) (Angelica sinensis). Dong Quai is one of the most commonly used herbs in Traditional Chinese Medicine, particularly in gynecologic formulas. Ferulic acid and phthalides are candidate actives. Hirata 1997 single RCT of dong quai alone (not in a formula) found no benefit over placebo for menopausal hot flashes. Traditional use is almost always in combination formulas, so monotherapy trials may under-represent effect. Anticoagulant activity — do not combine with warfarin. Photosensitivity risk with prolonged use. Avoid in pregnancy. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "shatavari-tincture",
      "title": "Shatavari Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Shatavari-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10082694.jpg?v=1787592725",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shatavari",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804530921669",
      "vsf_explanation": "Shatavari Tincture is single-ingredient liquid tincture Shatavari (Asparagus racemosus). Shatavari is a foundational Ayurvedic herb for female reproductive and lactation support. Steroidal saponins (shatavarins) are candidate actives. Sharma 1996 open-label study in nursing mothers showed increased prolactin; controlled trials are scarce and small. Insufficient rigorous evidence. Well-tolerated. Diuretic effect. Asparagus-family allergy possible. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cramp-bark-tincture",
      "title": "Cramp Bark Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Cramp-Bark-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10089090.jpg?v=1787592725",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cramp",
        "bark",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804531118277",
      "vsf_explanation": "Cramp Bark Tincture is single-ingredient liquid tincture Cramp Bark (Viburnum opulus). Cramp bark was used by Native American peoples and 19th-century Eclectic physicians for uterine cramping. Scopoletin and viburnin are candidate antispasmodics. Essentially no modern RCT evidence. Rests entirely on traditional-use precedent for menstrual cramp relief. Well-tolerated. Contains hydroquinones — caution with kidney disease. Related species (V. prunifolium) has similar traditional use. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "horny-goat-weed-tincture",
      "title": "Horny Goat Weed Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Horny-Goat-Weed-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10083483.jpg?v=1787592725",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "horny",
        "goat",
        "weed",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804531216581",
      "vsf_explanation": "Horny Goat Weed Tincture is single-ingredient liquid tincture Horny Goat Weed (Epimedium grandiflorum). Epimedium (Yin Yang Huo) is used in Traditional Chinese Medicine for kidney-yang deficiency, including sexual complaints. Icariin is the marker prenylated flavonoid. In vitro icariin shows PDE5-inhibiting activity, but no rigorous human RCT evidence for erectile function. Traditional use is well-documented; modern clinical evidence is sparse. Generally well-tolerated at label doses. Theoretical cardiovascular effect via PDE5 inhibition — caution with nitrates. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "stinging-nettle-root-tincture",
      "title": "Stinging Nettle Root Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Stinging-Nettle-Root-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10092258.jpg?v=1787592726",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "stinging",
        "nettle",
        "root",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804530823365",
      "vsf_explanation": "Stinging Nettle Root Tincture is single-ingredient liquid tincture Stinging Nettle Root (Urtica dioica). Stinging Nettle root has been used in European herbalism for urinary symptoms in older men. Lignans and beta-sitosterol are candidate actives. Safarinejad 2005 RCT and Lopatkin 2005 combination trial (with saw palmetto) show modest benefit for BPH symptom scores. Evidence is thinner than for saw palmetto itself. Nettle *leaf* (for allergic rhinitis / joint pain) has separate small trials. Well-tolerated. Diuretic effect. Theoretical antihypertensive interaction. Preliminary RCT signal; not yet a well-established evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "kudzu-tincture",
      "title": "Kudzu Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Kudzu-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10084255.jpg?v=1787592725",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "kudzu",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804531314885",
      "vsf_explanation": "Kudzu Tincture is single-ingredient liquid tincture Kudzu (Pueraria lobata). Kudzu root has been used in Traditional Chinese Medicine for millennia; also promoted for alcohol reduction. Isoflavones (puerarin, daidzein) are actives. Lukas 2005 and Penetar 2015 small trials found modest reduction in alcohol intake in heavy drinkers. Effect is real but small. Well-tolerated. Theoretical hormonal effects (phytoestrogen content). Preliminary RCT signal; not yet a well-established evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bromelain-tincture",
      "title": "Bromelain Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Bromelain-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10090684.jpg?v=1787592725",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bromelain",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804531019973",
      "vsf_explanation": "Bromelain Tincture is single-ingredient liquid tincture Bromelain (Ananas comosus (enzyme)). Bromelain is a mixture of proteolytic enzymes from pineapple stem, used for inflammation, swelling, and digestion. Brien 2004 review found benefit for post-surgical swelling and, less consistently, for knee OA (Klein 2000 trial). Effect is modest. Well-tolerated. Anticoagulant activity. GI upset possible. Moderate RCT evidence base, generally at standardized doses. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "devils-claw-tincture",
      "title": "Devil's Claw Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Devil_s-Claw-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10087427.jpg?v=1787592725",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "devil",
        "claw",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804530528453",
      "vsf_explanation": "Devil's Claw Tincture is single-ingredient liquid tincture Devil's Claw (Harpagophytum procumbens). Devil's Claw is a Southern African root traditionally used for musculoskeletal pain. Harpagoside is the marker iridoid glycoside. Warnock 2007 (open-label but sizeable), Chrubasik 2007 meta-analysis, and multiple German trials show benefit comparable to NSAIDs for knee/hip osteoarthritis at 50-100 mg harpagoside/day. Not as heavily studied as glucosamine but the evidence base is real. Well-tolerated. Avoid with active peptic ulcer. Theoretical anticoagulant activity. Real RCT evidence base at standardized doses. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bilberry-fruit-tincture",
      "title": "Bilberry Fruit Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Bilberry-Fruit-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10091432.jpg?v=1787592726",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bilberry",
        "fruit",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804531413189",
      "vsf_explanation": "Bilberry Fruit Tincture is single-ingredient liquid tincture Bilberry (Vaccinium myrtillus). Bilberry is a European wild blueberry relative with anthocyanin-rich fruit, traditionally promoted for night vision and microvascular support. Canter 2004 systematic review found no convincing evidence for the traditional night-vision claim. Small trials suggest possible antioxidant and capillary effects but clinical significance is unclear. Well-tolerated. Anticoagulant activity possible. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "false-unicorn-tincture",
      "title": "False Unicorn Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/False-Unicorn-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10086639.jpg?v=1787592726",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "false",
        "unicorn",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 50,
        "sustainability": 25
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804531511493",
      "vsf_explanation": "False Unicorn Tincture is single-ingredient liquid tincture False Unicorn Root (Chamaelirium luteum). False unicorn (Helonias) was used in Eclectic herbal medicine for women's reproductive complaints. No modern RCT evidence. IMPORTANT sustainability concern: false unicorn is severely over-harvested in the wild, listed as at-risk by United Plant Savers. Ethical sourcing (organic cultivated) is required, but authentic cultivated material is scarce. Traditional use plus significant sustainability concerns (at-risk wild-harvested species). Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "goldenrod-tincture",
      "title": "Goldenrod Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Goldenrod-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10088286.jpg?v=1787592726",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "goldenrod",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804532003013",
      "vsf_explanation": "Goldenrod Tincture is single-ingredient liquid tincture Goldenrod (Solidago virgaurea). Goldenrod is used in European folk medicine as an anti-inflammatory diuretic for urinary tract support. German Commission E supports use for urinary tract inflammation on traditional-use basis; RCT evidence limited. Rare Asteraceae allergy. Diuretic effect. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ladys-mantle-tincture",
      "title": "Lady's Mantle Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Lady_s-Mantle-Tincture-gardenixx-Vitamins-_-Supplements-10085880.jpg?v=1787592726",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lady",
        "mantle",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804531609797",
      "vsf_explanation": "Lady's Mantle Tincture is single-ingredient liquid tincture Lady's Mantle (Alchemilla vulgaris). Lady's Mantle has been used in traditional herbalism, particularly in women's health contexts. No large modern RCT evidence supports specific women's-health claims for Lady's Mantle. Rests on traditional-use precedent. Generally well-tolerated. See specific pregnancy contraindications on the ingredient page. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "grape-seed-tincture",
      "title": "Grape Seed Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Grape-Seed-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10028244.jpg?v=1787592725",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "grape",
        "seed",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804531708101",
      "vsf_explanation": "Grape Seed Tincture is single-ingredient liquid tincture Grape Seed (Vitis vinifera (seed)). Grape seed extract is a source of oligomeric proanthocyanidins (OPCs) marketed for cardiovascular and antioxidant support. Feringa 2011 meta-analysis found modest BP reduction with grape seed extract (5-6 mmHg systolic). Antioxidant biomarker effects are consistent but clinical-endpoint evidence is limited. Well-tolerated. Anticoagulant activity — caution with warfarin. Preliminary RCT signal; not yet a well-established evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "agaricus-blazei-tincture",
      "title": "Agaricus Blazei Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Agaricus-Blazei-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10102692.jpg?v=1787592725",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "agaricus",
        "blazei",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 21.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804531806405",
      "vsf_explanation": "Agaricus Blazei Tincture is single-ingredient liquid tincture Agaricus blazei (ABM) (Agaricus subrufescens). Agaricus blazei (Agaricus subrufescens, \"almond mushroom\") is a Brazilian medicinal mushroom promoted for immune support. Beta-glucans are the primary constituent. Small Japanese trials suggest possible immune modulation in cancer chemotherapy adjunct settings, but methodological quality is low and results are inconsistent. Insufficient evidence to support health claims. Rare severe hepatotoxicity case reports (Mukumoto 2014). Users with liver disease should avoid. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "osha-tincture",
      "title": "Osha Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Osha-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10101882.jpg?v=1787592726",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "osha",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 35,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804531904709",
      "vsf_explanation": "Osha Tincture is single-ingredient liquid tincture Osha (Ligusticum porteri). Osha root is used in Southwestern US and Mexican folk medicine for respiratory complaints. Distinguished from toxic Cicuta (water hemlock) look-alikes only by experienced foragers. No modern RCT evidence. Rests on traditional-use precedent. Contraindicated in pregnancy (uterine stimulant). Sustainability concern — wild-harvested and slow-growing. Traditional use plus documented safety concerns. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ceylon-cinnamon-tincture",
      "title": "Ceylon Cinnamon Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Ceylon-Cinnamon-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10105078.jpg?v=1787592728",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ceylon",
        "cinnamon",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804532101317",
      "vsf_explanation": "Ceylon Cinnamon Tincture is single-ingredient liquid tincture Ceylon Cinnamon (Cinnamomum verum / zeylanicum). True Ceylon cinnamon (Cinnamomum verum) is distinguished from cassia (C. cassia, C. burmannii) by lower coumarin content and softer bark. Allen 2013 meta-analysis found small fasting glucose and lipid improvements in type 2 diabetes with 120-6000 mg/day cinnamon (cassia in most trials). Effect on HbA1c inconsistent. Ceylon cinnamon specifically has fewer trials but lower hepatotoxicity risk. Ceylon cinnamon is preferred over cassia for long-term daily use due to much lower coumarin content (which can be hepatotoxic at high daily doses). Preliminary RCT signal; not yet a well-established evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fennel-seed-tincture",
      "title": "Fennel Seed Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Fennel-Seed-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10029832.jpg?v=1787592728",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fennel",
        "seed",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804532199621",
      "vsf_explanation": "Fennel Seed Tincture is single-ingredient liquid tincture Fennel Seed (Foeniculum vulgare). Fennel seed has been used as a digestive aid and for infantile colic (typically as tea) in European folk medicine. Alexandrovich 2003 small trial suggested benefit for infantile colic (fennel seed oil). Adult supplement-form claims have thinner evidence. Rare allergy. Trans-anethole content — theoretical hormonal effect at high doses. Avoid concentrated essential-oil forms in infants. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "reishi-tincture",
      "title": "Reishi Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Reishi-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10108285.jpg?v=1787592728",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "reishi",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804532297925",
      "vsf_explanation": "Reishi Tincture is single-ingredient liquid tincture Reishi (Lingzhi) (Ganoderma lucidum). Reishi is the \"mushroom of immortality\" in Traditional Chinese Medicine, used for immunity, sleep, and longevity. Beta-glucans and triterpenes (ganoderic acids) are presumed actives. Jin 2016 Cochrane found some benefit as adjunct to cancer therapy but insufficient primary-endpoint evidence. Small trials on immune function markers and sleep quality are suggestive but underpowered. Generally well-tolerated. Rare hepatotoxicity case reports. Anticoagulant activity — caution with warfarin. Preliminary RCT signal; not yet a well-established evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chaga-tincture",
      "title": "Chaga Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Chaga-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10105896.jpg?v=1787592729",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chaga",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804532396229",
      "vsf_explanation": "Chaga Tincture is single-ingredient liquid tincture Chaga (Inonotus obliquus). Chaga is a birch-tree fungus used in Siberian folk medicine for cancer and immunity. Betulinic acid derivatives and melanin-rich polysaccharides are candidate actives. No large human RCTs. In-vitro and animal studies show antioxidant and immunomodulatory activity. Case reports of kidney injury (oxalate nephropathy) in high daily users. Very high oxalate content — case reports of oxalate nephropathy with daily long-term use. Anticoagulant activity. Avoid with kidney disease. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hawthorn-berry-tincture",
      "title": "Hawthorn Berry Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Hawthorn-Berry-Tincture-Gardenix-Vitamins-_-Supplements-116750846.jpg?v=1787592730",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hawthorn",
        "berry",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804532592837",
      "vsf_explanation": "Hawthorn Berry Tincture is single-ingredient liquid tincture Hawthorn (Crataegus monogyna / laevigata). Hawthorn berry, leaf, and flower have been used in European herbalism since Dioscorides for heart health. Oligomeric proanthocyanidins and flavonoids (vitexin, hyperoside) are the active fraction. Pittler 2008 Cochrane review found modest benefit for symptomatic chronic heart failure (NYHA I-II) — increased exercise tolerance and reduced shortness of breath — at 900-1800 mg/day of a standardized 18.75% OPC extract. Not a substitute for guideline-directed HF therapy. Well-tolerated. Theoretical interaction with digoxin and antihypertensives. Should not be self-prescribed for heart failure without physician oversight. Real RCT evidence base at standardized doses. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "elderberry-tincture",
      "title": "Elderberry Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Elderberry-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10110658.jpg?v=1787592729",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "elderberry",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804532494533",
      "vsf_explanation": "Elderberry Tincture is single-ingredient liquid tincture Elderberry (Sambucus nigra). Elderberry has been used in European folk medicine for colds and flu. Anthocyanins are presumed antiviral actives. Tiralongo 2016 RCT (air travelers) and Zakay-Rones 2004 (influenza) show modest reduction in cold/flu symptom duration and severity. Meta-analyses (Hawkins 2019) suggest reduced upper-respiratory symptom duration when taken at symptom onset. Well-tolerated (cooked/extracted preparations). Raw elderberries, leaves, and bark contain cyanogenic glycosides — do not consume raw. Standardized syrups and tinctures are safe. Moderate RCT evidence base, generally at standardized doses. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hyssop-tincture",
      "title": "Hyssop Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Hyssop-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10036250.jpg?v=1787592730",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hyssop",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804532691141",
      "vsf_explanation": "Hyssop Tincture is single-ingredient liquid tincture Hyssop (Hyssopus officinalis). Hyssop has been used in European or global folk medicine for respiratory complaints (cough, mucus, congestion). No modern RCT evidence supports specific respiratory claims for Hyssop. The evidence base is limited to traditional-use precedent and, in some cases, small in-vitro antimicrobial data. Pinocamphone (a volatile constituent) is a convulsant at very high doses. Avoid essential-oil-strength preparations; tincture is much diluted. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "periwinkle-tincture",
      "title": "Periwinkle Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Periwinkle-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10034655.jpg?v=1787592730",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "periwinkle",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 35,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804532789445",
      "vsf_explanation": "Periwinkle Tincture is single-ingredient liquid tincture Periwinkle (Vinca minor). Lesser periwinkle contains vincamine, a natural precursor to vinpocetine (a semi-synthetic derivative marketed for cognitive support). Also a source of the chemotherapy alkaloids vincristine and vinblastine (in the related Catharanthus roseus, formerly called Vinca rosea). Vinpocetine (semi-synthetic derivative) has small RCT evidence for cognitive function; whole-plant tincture has much thinner evidence and unstandardized alkaloid content. FDA has taken enforcement action against vinpocetine as an unlisted dietary ingredient. Periwinkle tincture is at legal gray area. Anticoagulant activity. Avoid in pregnancy. Traditional use plus documented safety concerns. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lions-mane-tincture",
      "title": "Lion's Mane Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Lion_s-Mane-Tincture-gardenixx-Vitamins-_-Supplements-10029034.jpg?v=1787592731",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lion",
        "mane",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804532887749",
      "vsf_explanation": "Lion's Mane Tincture is single-ingredient liquid tincture Lion's Mane (Hericium erinaceus). Lion's Mane is used in Traditional Chinese and Japanese medicine for digestive health and, more recently, cognition. Hericenones and erinacines have shown NGF-inducing activity in vitro. Mori 2009 small Japanese RCT found improved cognitive function scores in older adults with mild cognitive impairment at 3 g/day. Popovic-Djordjevic 2023 review notes preliminary but promising data. Not yet a well-established nootropic. Well-tolerated. Rare skin rash and shortness of breath reports. Preliminary RCT signal; not yet a well-established evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hibiscus-tincture",
      "title": "Hibiscus Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Hibiscus-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10033847.jpg?v=1787592731",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hibiscus",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804532986053",
      "vsf_explanation": "Hibiscus Tincture is single-ingredient liquid tincture Hibiscus (Hibiscus sabdariffa). Hibiscus (Roselle) has been used in African and Middle Eastern folk medicine as a cooling tea for blood pressure. Anthocyanins are presumed actives. Serban 2015 meta-analysis of 5 RCTs found small systolic and diastolic BP reduction (~7/3 mmHg) with hibiscus tea/extract. Effect is modest but real in mild hypertension. Well-tolerated. Diuretic. Theoretical interaction with antihypertensives, hydrochlorothiazide, acetaminophen. Preliminary RCT signal; not yet a well-established evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bugleweed-tincture",
      "title": "Bugleweed Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Bugleweed-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10098632.jpg?v=1787592732",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bugleweed",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 42,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804533084357",
      "vsf_explanation": "Bugleweed Tincture is single-ingredient liquid tincture Bugleweed (Lycopus virginicus / europaeus). Bugleweed is used in European folk medicine for mild hyperthyroid symptoms (Graves-related palpitations). Rosmarinic acid derivatives inhibit thyroid-stimulating antibody binding in vitro. Small German trials (Auf'mkolk 1984) suggest anti-thyroid activity. Modern rigorous trials are lacking. Real anti-thyroid activity — do not use with hypothyroidism or on thyroid hormone replacement. Avoid in pregnancy. Preliminary evidence but documented safety concern lowers the score. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bloodroot-tincture",
      "title": "Bloodroot Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Bloodroot-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10027459.jpg?v=1787592732",
      "score": 28,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bloodroot",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 12,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804533182661",
      "vsf_explanation": "Bloodroot Tincture is single-ingredient liquid tincture Bloodroot (Sanguinaria canadensis). Bloodroot is a Native American medicinal plant with sanguinarine as its major alkaloid. Historically used for respiratory complaints and, externally, as an escharotic (tissue-destroying) salve. No credible internal-use therapeutic evidence. IMPORTANT: Sanguinarine is toxic; external escharotic salves have caused severe tissue necrosis and disfigurement. Internal use is contraindicated. FDA has taken enforcement action against escharotic \"black salve\" products. Sanguinarine is toxic; external escharotic products have caused severe tissue necrosis. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "turmeric-tincture",
      "title": "Turmeric Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Turmeric-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10032232.jpg?v=1787592733",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "turmeric",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804533280965",
      "vsf_explanation": "Turmeric Tincture is single-ingredient liquid tincture Turmeric (Curcumin) (Curcuma longa). Turmeric rhizome has been used in Ayurveda and Traditional Chinese Medicine for millennia as an anti-inflammatory. Curcuminoids (curcumin, demethoxycurcumin, bisdemethoxycurcumin) are the active fraction. Hewlings 2017 review and multiple RCTs on branded high-bioavailability extracts (Meriva, Theracurmin, Curcumin C3 + BioPerine) show benefit for knee OA pain comparable to ibuprofen, and modest anti-inflammatory effects on CRP. Raw turmeric tincture or unpotentiated turmeric powder has poor oral bioavailability (~1%) — trials generally use lipid- or piperine-enhanced formulations. Well-tolerated. Rare hepatotoxicity reports with high-dose curcumin extracts. Avoid with bile-duct obstruction. Anticoagulant activity — caution with warfarin. Real RCT evidence base at standardized doses. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "thyme-tincture",
      "title": "Thyme Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Thyme-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10109044.jpg?v=1787592733",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "thyme",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804533379269",
      "vsf_explanation": "Thyme Tincture is single-ingredient liquid tincture Thyme (Thymus vulgaris). Thyme has been used in European or global folk medicine for respiratory complaints (cough, mucus, congestion). Thymol (main volatile) has documented in-vitro antimicrobial activity. Kemmerich 2007 combination trial (thyme + primrose) suggested benefit for acute bronchitis; monotherapy trials are limited. Well-tolerated at label doses. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "frankincense-tincture",
      "title": "Frankincense Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Frankincense-Tincture-Gardenix-Vitamins-_-Supplements-128493398.jpg?v=1787592733",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "frankincense",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804533477573",
      "vsf_explanation": "Frankincense Tincture is single-ingredient liquid tincture Frankincense (Boswellia) (Boswellia serrata). Boswellia serrata resin has been used in Ayurveda for arthritis and inflammatory conditions. Boswellic acids (particularly AKBA) inhibit 5-lipoxygenase. Sengupta 2008, Kimmatkar 2003, and Sontakke 2007 all show benefit in knee osteoarthritis at 100-333 mg of a standardized 30-65% boswellic acids extract. Effect sizes are meaningful for pain and function. Generally well-tolerated. Rare GI upset. Can theoretically potentiate anticoagulants. Real RCT evidence base at standardized doses. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mistletoe-tincture",
      "title": "Mistletoe Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Mistletoe-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10030680.jpg?v=1787592733",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mistletoe",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 35,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804533575877",
      "vsf_explanation": "Mistletoe Tincture is single-ingredient liquid tincture Mistletoe (Viscum album (European)). European mistletoe has been used in anthroposophic medicine for cancer (as injectable Iscador/Helixor) and, historically, orally for hypertension. Injectable European mistletoe (Iscador) has small clinical trials in cancer adjunctive care with equivocal results. Oral tinctures have essentially no RCT evidence. American mistletoe (Phoradendron) is toxic — confirm European (Viscum album). Berries are especially toxic. Avoid oral tinctures at high doses. Traditional use plus documented safety concerns. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dandelion-leaf-tincture",
      "title": "Dandelion Leaf Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Dandelion-Leaf-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10031495.jpg?v=1787592733",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dandelion",
        "leaf",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804533674181",
      "vsf_explanation": "Dandelion Leaf Tincture is single-ingredient liquid tincture Dandelion Leaf (Taraxacum officinale (leaf)). Dandelion leaf has been used as a mild diuretic and bitter tonic in European folk medicine. Sesquiterpene lactones and potassium content are relevant. Clare 2009 small pilot found brief diuretic effect. Otherwise limited modern evidence for hepatic or renal claims. Diuretic — maintain fluid intake. Asteraceae allergy possible. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "oatstraw-tincture",
      "title": "Oatstraw Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Oatstraw-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10035499.jpg?v=1787592733",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "oatstraw",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 21.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804533772485",
      "vsf_explanation": "Oatstraw Tincture is single-ingredient liquid tincture Oatstraw (Avena sativa). Oatstraw (the aerial parts of the oat plant) has been used in European folk medicine as a nervine tonic. Small trials suggest possible cognitive-alerting effects (Kennedy 2017), particularly with green oat (Avena sativa green tops) extracts. Well-tolerated. Gluten cross-contact possible depending on source. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "elder-flowers-tincture",
      "title": "Elder Flowers Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Elder-Flowers-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10107447.jpg?v=1787592734",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "elder",
        "flowers",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804533903557",
      "vsf_explanation": "Elder Flowers Tincture is single-ingredient liquid tincture Elder Flowers (Sambucus nigra (flower)). Elder flowers have been used in European folk medicine for colds, flu, and as a diaphoretic. Distinct from elderberry (fruit). No robust modern RCT evidence for elder flower monotherapy. Some evidence for elderflower + other herbs (Sinupret) for sinusitis. Rare allergy. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "tongkat-ali-tincture",
      "title": "Tongkat Ali Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Tongkat-Ali-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10100228.jpg?v=1787592734",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tongkat",
        "ali",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804534165701",
      "vsf_explanation": "Tongkat Ali Tincture is single-ingredient liquid tincture Tongkat Ali (Eurycoma longifolia). Tongkat Ali (Longjack) is a Southeast Asian root traditionally used for male vitality. Quassinoids (eurycomanone) are candidate actives. Tambi 2012 (LJ100 standardized extract) found improved testosterone and sexual well-being in men with late-onset hypogonadism. Talbott 2013 showed reduced cortisol and improved mood in stressed subjects. Evidence base is small but consistent for the standardized extract. Well-tolerated in short trials. Theoretical concern with prostate or hormone-sensitive conditions. Long-term safety not well characterized. Preliminary RCT signal; not yet a well-established evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "maca-tincture",
      "title": "Maca Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Maca-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10096293.jpg?v=1787592734",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "energy",
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "maca",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804534067397",
      "vsf_explanation": "Maca Tincture is single-ingredient liquid tincture Maca (Lepidium meyenii). Maca is a Peruvian Andean root traditionally used for stamina and libido. Glucosinolates and macamides are candidate actives. Shin 2010 review of 4 small RCTs found improvement in sexual function/libido without effect on serum testosterone. Effect sizes are modest. Well-tolerated. Contains glucosinolates — theoretical thyroid caution in iodine-deficient users. Preliminary RCT signal; not yet a well-established evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "kelp-tincture",
      "title": "Kelp Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Kelp-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10097090.jpg?v=1787592735",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "kelp",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 35,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804534362309",
      "vsf_explanation": "Kelp Tincture is single-ingredient liquid tincture Kelp (Laminaria digitata / japonica). Kelp is a brown seaweed used as an iodine source and for thyroid support. Iodine content varies wildly (2-8000 mcg per serving). Real biological effect on thyroid function via iodine. Same cautions as bladderwrack — highly variable iodine can precipitate hypo- or hyperthyroidism; heavy metal contamination risk. Avoid with thyroid disease or on thyroid medication. Traditional use plus documented safety concerns. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitex-tincture",
      "title": "Vitex Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Vitex-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10101072.jpg?v=1787592734",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitex",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804534264005",
      "vsf_explanation": "Vitex Tincture is single-ingredient liquid tincture Vitex (Chaste Tree) (Vitex agnus-castus). Vitex has been used in European folk medicine for menstrual and premenstrual complaints. Dopaminergic activity modulates prolactin secretion. van Die 2013 systematic review found consistent benefit for PMS symptoms across 8 placebo-controlled trials. Standardized extracts (Ze 440, BNO 1095) at 20-40 mg/day are best-studied. Well-tolerated. Avoid with hormonal medications, oral contraceptives, and dopamine antagonists. Not for use in pregnancy. Moderate RCT evidence base, generally at standardized doses. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "echinacea-angustifolia-tincture",
      "title": "Echinacea Angustifolia Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Echinacea-Angustifolia-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10106654.jpg?v=1787592735",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "echinacea",
        "angustifolia",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804534460613",
      "vsf_explanation": "Echinacea Angustifolia Tincture is single-ingredient liquid tincture Echinacea angustifolia (Echinacea angustifolia). Echinacea is a Native American medicinal plant used by Great Plains tribes for wounds and infections, later adopted by European herbalism for immune support. Alkylamides and polysaccharides are presumed actives. Cochrane 2014 (Karsch-Volk) found no clear benefit for cold prevention with mixed preparations, but subgroup analyses suggest some benefit for cold-symptom duration with Echinacea purpurea aerial parts. Effect sizes are small and inconsistent across cultivars and preparation methods. Generally well-tolerated. Rare allergic reactions in Asteraceae-sensitive users. Avoid with autoimmune disease (theoretical immune stimulation). Preliminary RCT signal; not yet a well-established evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "anamu-tincture",
      "title": "Anamu Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Anamu-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10103481.jpg?v=1787592736",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "anamu",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804534558917",
      "vsf_explanation": "Anamu Tincture is single-ingredient liquid tincture Anamu (Guinea Hen Weed) (Petiveria alliacea). Anamu is a Caribbean and South American folk remedy for immune and anticancer positioning. In-vitro cytotoxicity data; no human RCT evidence for any claim. Avoid in pregnancy (uterine stimulant). Anticoagulant activity. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bladderwrack-tincture",
      "title": "Bladderwrack Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Bladderwrack-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10097816.jpg?v=1787592736",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bladderwrack",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 35,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804534657221",
      "vsf_explanation": "Bladderwrack Tincture is single-ingredient liquid tincture Bladderwrack (Fucus vesiculosus). Bladderwrack is a brown seaweed traditionally used for thyroid support and weight loss due to its iodine content. Iodine content is real; weight-loss claims are essentially unsupported. Highly variable iodine content — can precipitate hypo- or hyperthyroidism depending on baseline status. Heavy-metal (arsenic, cadmium) contamination risk from ocean water. Avoid with thyroid disease or on thyroid medication. Traditional use plus documented safety concerns. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pine-pollen-tincture",
      "title": "Pine Pollen Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Pine-Pollen-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10099437.jpg?v=1787592737",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pine",
        "pollen",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804534755525",
      "vsf_explanation": "Pine Pollen Tincture is single-ingredient liquid tincture Pine Pollen (Pinus massoniana / silvestris). Pine pollen is marketed for testosterone support based on the plant's own natural steroid content. No convincing human RCT evidence for testosterone or androgenic effects at supplement doses. Pollen allergy risk. Autoimmune caution. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "noni-tincture",
      "title": "Noni Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Noni-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10093845.jpg?v=1787592738",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "noni",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 35,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804534853829",
      "vsf_explanation": "Noni Tincture is single-ingredient liquid tincture Noni (Morinda citrifolia). Noni fruit is a Polynesian folk remedy popularized by MLM marketing. Numerous \"cure-all\" claims have been made without evidence. No convincing RCT evidence for the broad range of claims made about noni. Rare hepatotoxicity case reports. High potassium content — avoid with kidney disease. Traditional use plus documented safety concerns. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "devils-club-tincture",
      "title": "Devil's Club Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Devil_s-Club-Tincture-Gardenix-Vitamins-_-Supplements-128492676.jpg?v=1787592739",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "devil",
        "club",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804534952133",
      "vsf_explanation": "Devil's Club Tincture is single-ingredient liquid tincture Devil's Club (Oplopanax horridus). Devil's Club is a Pacific Northwest plant used by Coast Salish and other Indigenous peoples for various conditions including blood sugar. Also has significant sustainability/cultural considerations. No modern RCT evidence. Sustainability concern — slow-growing culturally sensitive plant; buy only from ethically-sourced cultivated stock. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "he-shou-wu-tincture",
      "title": "He Shou Wu Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/He-Shou-Wu-Tincture-Gardenix-Vitamins-_-Supplements-152288389.jpg?v=1787592739",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shou",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 35,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804535050437",
      "vsf_explanation": "He Shou Wu Tincture is single-ingredient liquid tincture He Shou Wu (Fo-Ti) (Polygonum multiflorum). He Shou Wu is used in Traditional Chinese Medicine for kidney/liver tonic and, in modern marketing, for hair-graying claims. Traditionally used in prepared form (jiu zhi), not raw. No convincing RCT evidence for hair or anti-aging claims. IMPORTANT: Documented hepatotoxicity — multiple case reports and case series (Byeon 2019 review) of acute liver injury requiring hospitalization, sometimes fatal. Health Canada and Australia have issued warnings. Avoid. Traditional use plus documented safety concerns. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "parsley-leaf-tincture",
      "title": "Parsley Leaf Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Parsley-Leaf-Tincture-Gardenix-Vitamins-_-Supplements-132101240.jpg?v=1787592739",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "parsley",
        "leaf",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804535148741",
      "vsf_explanation": "Parsley Leaf Tincture is single-ingredient liquid tincture Parsley Root (Petroselinum crispum (root)). Parsley root has been used in European folk medicine as a mild diuretic and for kidney/bladder complaints. No modern RCT evidence for supplement-form claims. Diuretic effect is mechanistically plausible. Diuretic — maintain fluid intake. Avoid in pregnancy (apiole is uterotonic at high doses). Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "wild-yam-tincture",
      "title": "Wild Yam Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Wild-Yam-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10095414.jpg?v=1787592739",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wild",
        "yam",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 40,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804535247045",
      "vsf_explanation": "Wild Yam Tincture is single-ingredient liquid tincture Wild Yam (Dioscorea villosa). Wild yam contains diosgenin, historically used as an industrial precursor for lab synthesis of progesterone and hormones — but this conversion does NOT happen in the human body. Komesaroff 2001 RCT found wild yam cream ineffective for menopausal symptoms. Any \"natural progesterone\" claim from wild yam is unfounded — no metabolic pathway in humans converts diosgenin to progesterone. Well-tolerated at label doses. Beware products claiming to contain \"natural progesterone from wild yam\" — that claim is chemically incorrect. Traditional-use precedent overshadowed by common misleading marketing. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gymnema-tincture",
      "title": "Gymnema Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Gymnema-Tincture-Gardenix-Vitamins-_-Supplements-128447086.jpg?v=1787592786",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gymnema",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804535935173",
      "vsf_explanation": "Gymnema Tincture is single-ingredient liquid tincture Gymnema (Gymnema sylvestre). Gymnema is an Ayurvedic herb known as \"sugar destroyer\" — leaf chewing temporarily abolishes sweet taste. Gymnemic acids are candidate actives. Baskaran 1990, Shanmugasundaram 1990 (both Indian trials, older) suggest HbA1c and fasting glucose improvement in type 2 diabetes. Modern well-controlled trials are limited. Effect on healthy subjects is smaller. Well-tolerated. Hypoglycemia risk if combined with diabetes medication. Preliminary RCT signal; not yet a well-established evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "umckaloabo-tincture",
      "title": "Umckaloabo Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Umckaloabo-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10117033.jpg?v=1787592785",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "umckaloabo",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804535836869",
      "vsf_explanation": "Umckaloabo Tincture is single-ingredient liquid tincture Umckaloabo (Pelargonium sidoides) (Pelargonium sidoides). Pelargonium sidoides is a South African plant traditionally used for respiratory infections; commercialized as EPs 7630 (Umcka). Timmer 2013 Cochrane review found significant symptom improvement for acute bronchitis, sinusitis, and the common cold with EPs 7630 root extract. Effect sizes are meaningful (roughly 2-3 days faster symptom resolution). Well-tolerated. Rare hepatotoxicity cases reported — discontinue if jaundice develops. Not for use >2 weeks. Moderate RCT evidence base, generally at standardized doses. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chlorella-tincture",
      "title": "Chlorella Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Chlorella-Tincture-Gardenix-Vitamins-_-Supplements-116751322.jpg?v=1787592786",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chlorella",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 52,
        "manufacturing": 50,
        "safety": 40,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804536033477",
      "vsf_explanation": "Chlorella Tincture is single-ingredient liquid tincture Chlorella (Chlorella vulgaris / pyrenoidosa). Chlorella is a green freshwater alga marketed as a nutrient-dense superfood and for \"detoxification\" of heavy metals. Small trials suggest possible immune and lipid effects, but methodological quality is variable. Heavy-metal chelation claims are unsupported — chlorella itself is often a source of heavy-metal contamination when grown in open ponds. Iodine and vitamin K content may interact with thyroid medications and anticoagulants. Uncertain heavy-metal load in poorly-sourced products. Modest evidence with documented safety concern. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "parsley-root-tincture",
      "title": "Parsley Root Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Parsley-Root-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10109865.jpg?v=1787592786",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "parsley",
        "root",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804536131781",
      "vsf_explanation": "Parsley Root Tincture is single-ingredient liquid tincture Parsley Root (Petroselinum crispum (root)). Parsley root has been used in European folk medicine as a mild diuretic and for kidney/bladder complaints. No modern RCT evidence for supplement-form claims. Diuretic effect is mechanistically plausible. Diuretic — maintain fluid intake. Avoid in pregnancy (apiole is uterotonic at high doses). Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fenugreek-tincture",
      "title": "Fenugreek Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Fenugreek-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10040235.jpg?v=1787592786",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fenugreek",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804536426693",
      "vsf_explanation": "Fenugreek Tincture is single-ingredient liquid tincture Fenugreek (Trigonella foenum-graecum). Fenugreek seed has been used in Middle Eastern and Indian folk medicine for blood sugar, lactation, and male vitality. 4-hydroxyisoleucine and saponins are candidate actives. Neelakantan 2014 meta-analysis found modest fasting glucose reduction in diabetics with 5-10 g/day seed powder. Steels 2011 trial suggested testosterone/libido support (Testofen). Well-tolerated. Body odor (maple syrup). Anticoagulant activity. Avoid in pregnancy (uterine stimulant). Preliminary RCT signal; not yet a well-established evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cats-claw-tincture",
      "title": "Cat's Claw Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Cat_s-Claw-Tincture-Gardenix-Vitamins-_-Supplements-116754076.jpg?v=1787592786",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cat",
        "claw",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804536918213",
      "vsf_explanation": "Cat's Claw Tincture is single-ingredient liquid tincture Cat's Claw (Uncaria tomentosa). Cat's Claw is a Peruvian rainforest vine (Uña de gato) used in traditional medicine for inflammation and immunity. Pentacyclic oxindole alkaloids are candidate actives. Small trials in rheumatoid arthritis (Mur 2002) and knee OA (Piscoya 2001) suggest modest benefit. Evidence base is limited. Well-tolerated at label doses. Anticoagulant activity. Avoid with organ transplant (immune-modulating). Small preliminary trials; effect sizes typically modest. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sheep-sorrel-tincture",
      "title": "Sheep Sorrel Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Sheep-Sorrel-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10111441.jpg?v=1787592786",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sheep",
        "sorrel",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804536328389",
      "vsf_explanation": "Sheep Sorrel Tincture is single-ingredient liquid tincture Sheep Sorrel (Rumex acetosella). Sheep sorrel is an ingredient in the Essiac herbal formula (with burdock, slippery elm, Indian rhubarb) promoted as a cancer therapy — a claim with no supporting RCT evidence. No modern RCT evidence. Essiac has been studied and shown no benefit for cancer. Oxalate content — avoid with kidney stones or kidney disease. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bee-pollen-tincture",
      "title": "Bee Pollen Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Bee-Pollen-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10037038.jpg?v=1787592786",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bee",
        "pollen",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 35,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804536230085",
      "vsf_explanation": "Bee Pollen Tincture is single-ingredient liquid tincture Bee Pollen (Apis mellifera pollen). Bee pollen is granulated pollen collected by honeybees, marketed as a general nutritive tonic. No convincing modern RCT evidence for systemic claims. Serious anaphylaxis risk in pollen-allergic and bee-product-allergic users — case reports of fatal anaphylaxis. Avoid if allergic to pollen, honey, or bee stings. Avoid in pregnancy. Traditional use plus documented safety concerns. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "black-walnut-tincture",
      "title": "Black Walnut Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Black-Walnut-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10039417.jpg?v=1787592786",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "black",
        "walnut",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804536524997",
      "vsf_explanation": "Black Walnut Tincture is single-ingredient liquid tincture Black Walnut (Juglans nigra). Black walnut hull has been used in Eclectic herbal medicine for parasites and skin conditions. Juglone is the marker. In-vitro antiparasitic activity documented; human RCT evidence essentially absent. Nut allergy risk. Juglone content — some GI irritation possible. Tannin-rich, can bind minerals if taken with meals. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "celery-tincture",
      "title": "Celery Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Celery-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10041079.jpg?v=1787592786",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "celery",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804536623301",
      "vsf_explanation": "Celery Tincture is single-ingredient liquid tincture Celery Seed (Apium graveolens). Celery seed has been used in European folk medicine for gout, rheumatism, and hypertension. Apigenin and 3-n-butylphthalide are candidate actives. Small trials suggest modest BP lowering and mild anti-inflammatory activity. Evidence base is limited. Rare celery allergy. Diuretic effect. Photosensitivity (furocoumarins) possible. Small preliminary trials; effect sizes typically modest. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "elecampane-tincture",
      "title": "Elecampane Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Elecampane-Tincture-Gardenix-Vitamins-_-Supplements-128489255.jpg?v=1787592786",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "elecampane",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804536721605",
      "vsf_explanation": "Elecampane Tincture is single-ingredient liquid tincture Elecampane (Inula helenium). Elecampane has been used in European or global folk medicine for respiratory complaints (cough, mucus, congestion). No modern RCT evidence supports specific respiratory claims for Elecampane. The evidence base is limited to traditional-use precedent and, in some cases, small in-vitro antimicrobial data. Well-tolerated at label doses. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mullein-leaf-tincture",
      "title": "Mullein Leaf Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Mullein-Leaf-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10119427.jpg?v=1787592786",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mullein",
        "leaf",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804536819909",
      "vsf_explanation": "Mullein Leaf Tincture is single-ingredient liquid tincture Mullein (Verbascum thapsus). Mullein leaf and flower have been used in European and Native American folk medicine for cough and lung complaints. Iridoid glycosides and mucilage are candidate actives. No modern RCT evidence for respiratory claims. Rests on traditional-use precedent and in-vitro anti-inflammatory data. Well-tolerated. Filter tinctures/teas well — leaf hairs can irritate throat. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "collinsonia-tincture",
      "title": "Collinsonia Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Collinsonia-Tincture-Gardenix-Vitamins-_-Supplements-126120916.jpg?v=1787592786",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "collinsonia",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804537114821",
      "vsf_explanation": "Collinsonia Tincture is single-ingredient liquid tincture Collinsonia (Stone Root) (Collinsonia canadensis). Stone root was used by Eclectic physicians for venous congestion and hemorrhoids. No modern RCT evidence. Well-tolerated at label doses. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mullein-flower-tincture",
      "title": "Mullein Flower Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Mullein-Flower-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10114634.jpg?v=1787592786",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mullein",
        "flower",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804537213125",
      "vsf_explanation": "Mullein Flower Tincture is single-ingredient liquid tincture Mullein (Verbascum thapsus). Mullein leaf and flower have been used in European and Native American folk medicine for cough and lung complaints. Iridoid glycosides and mucilage are candidate actives. No modern RCT evidence for respiratory claims. Rests on traditional-use precedent and in-vitro anti-inflammatory data. Well-tolerated. Filter tinctures/teas well — leaf hairs can irritate throat. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sassafras-tincture",
      "title": "Sassafras Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Sassafras-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10045053.jpg?v=1787592786",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sassafras",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 35,
        "manufacturing": 40,
        "safety": 10,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804537016517",
      "vsf_explanation": "Sassafras Tincture is single-ingredient liquid tincture Sassafras (Sassafras albidum). Sassafras root bark was historically used in root beer and folk medicine. Safrole is the major aromatic constituent. No credible therapeutic evidence base. IMPORTANT: Safrole is a demonstrated animal carcinogen (rodent hepatocarcinogen). FDA banned safrole as a food additive in 1960 and prohibits sassafras oil, safrole, and its derivatives for human consumption. Do not use. FDA banned safrole as a food additive in 1960; sassafras oil prohibited for human consumption. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "teasel-tincture",
      "title": "Teasel Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Teasel-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10055415.jpg?v=1787592788",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "teasel",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 35,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804537311429",
      "vsf_explanation": "Teasel Tincture is single-ingredient liquid tincture Teasel (Dipsacus fullonum / sylvestris). Teasel root is used in some contemporary herbal Lyme protocols (Buhner protocol). No traditional-use precedent for this indication. No RCT evidence for Lyme disease or any other systemic claim. Lyme disease requires diagnosis and antibiotic treatment. Herbal Lyme self-treatment can delay effective medical care with real consequences. Seek clinical evaluation for suspected Lyme disease. Traditional use plus documented safety concerns. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "couch-grass-tincture",
      "title": "Couch Grass Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Couch-Grass-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10123465.jpg?v=1787592787",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "couch",
        "grass",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804537409733",
      "vsf_explanation": "Couch Grass Tincture is single-ingredient liquid tincture Couch Grass (Elymus repens). Couch grass rhizome is used in European folk medicine as a mild diuretic and demulcent for urinary tract complaints. No modern RCT evidence. Well-tolerated. Diuretic effect. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "slippery-elm-tincture",
      "title": "Slippery Elm Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Slippery-Elm-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10127455.jpg?v=1787592788",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "slippery",
        "elm",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804537508037",
      "vsf_explanation": "Slippery Elm Tincture is single-ingredient liquid tincture Slippery Elm (Ulmus rubra). Slippery elm inner bark was used by Native American peoples and 19th-century Eclectic physicians as a demulcent for sore throat and GI mucosal complaints. Mucilage is the operative constituent. Essentially no modern controlled evidence. Demulcent action is mechanistically plausible for GI mucosal soothing but has not been rigorously tested. Well-tolerated. Can bind and reduce absorption of oral medications — take 1-2 hours apart. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "guggul-tincture",
      "title": "Guggul Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Guggul-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10056221.jpg?v=1787592790",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "guggul",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804537606341",
      "vsf_explanation": "Guggul Tincture is single-ingredient liquid tincture Guggul (Commiphora mukul). Guggul is a foundational Ayurvedic resin used for cholesterol and joint conditions. Guggulsterones are the standardized markers. Szapary 2003 US trial found no benefit for LDL cholesterol; some Indian trials show benefit. Effect on cholesterol is uncertain and appears preparation-dependent. GI upset, skin rash possible. Anticoagulant and thyroid effects. Numerous drug interactions. Traditional use with weak or inconsistent RCT support. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chanca-piedra-tincture",
      "title": "Chanca Piedra Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Chanca-Piedra-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10125860.jpg?v=1787592791",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chanca",
        "piedra",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804537835717",
      "vsf_explanation": "Chanca Piedra Tincture is single-ingredient liquid tincture Chanca Piedra (Phyllanthus niruri). Chanca Piedra (\"stone breaker\") is a Latin American herb traditionally used for kidney stones and hepatoprotection. Nishiura 2004 small trial and preclinical work suggest reduced calcium oxalate crystal aggregation. Formal RCT evidence for stone passage or hepatoprotection is limited. Generally well-tolerated. Hypoglycemia and hypotension possible at high doses. Small preliminary trials; effect sizes typically modest. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "black-peppercorn-tincture",
      "title": "Black Peppercorn Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Black-Peppercorn-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10128263.jpg?v=1787592790",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "black",
        "peppercorn",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804537737413",
      "vsf_explanation": "Black Peppercorn Tincture is single-ingredient liquid tincture Black Peppercorn (Piper nigrum). Black pepper is a global culinary spice; piperine is the alkaloid. Piperine has documented bioavailability-enhancement effects on curcumin, coenzyme Q10, and other compounds. Standalone supplement claims are weak. Well-tolerated. Piperine affects CYP450 enzymes and P-glycoprotein — increases exposure to many drugs. Caution with narrow-therapeutic-index medications. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dan-shen-tincture",
      "title": "Dan Shen Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Dan-Shen-Tincture-Gardenix-Vitamins-_-Supplements-116751897.jpg?v=1787592790",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dan",
        "shen",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804537934021",
      "vsf_explanation": "Dan Shen Tincture is single-ingredient liquid tincture Red Sage (Dan Shen) (Salvia miltiorrhiza). Dan Shen is a foundational herb in Traditional Chinese Medicine used for cardiovascular conditions (\"blood stasis\"). Tanshinones and salvianolic acids are actives. Chinese literature includes many trials in coronary heart disease and stroke recovery, but methodological quality is variable and much of the strong evidence is with injectable or IV preparations, not oral capsules. Anticoagulant activity — significant interaction with warfarin. Avoid with anticoagulants. Preliminary RCT signal; not yet a well-established evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chaparral-tincture",
      "title": "Chaparral Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Chaparral-Tincture-Gardenix-Vitamins-_-Supplements-116753342.jpg?v=1787592792",
      "score": 28,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chaparral",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 12,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804538065093",
      "vsf_explanation": "Chaparral Tincture is single-ingredient liquid tincture Chaparral (Larrea tridentata). Chaparral is a Southwestern US desert shrub used historically by Native peoples for skin and infection complaints. NDGA (nordihydroguaiaretic acid) is a marker constituent. FDA issued a warning about chaparral hepatotoxicity in 1992 after multiple case reports of severe hepatitis (some requiring transplant). No credible therapeutic evidence base. FDA has flagged chaparral for hepatotoxicity — do not use internally. Reports of acute hepatitis, cirrhosis, and liver failure. Documented hepatotoxicity with case reports of liver failure. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "skullcap-tincture",
      "title": "Skullcap Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Skullcap-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10057878.jpg?v=1787592791",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "skullcap",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 35,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804538163397",
      "vsf_explanation": "Skullcap Tincture is single-ingredient liquid tincture Skullcap (Scutellaria lateriflora). American skullcap has been used in Eclectic herbal medicine for anxiety and nervous tension. Baicalin and scutellarin are candidate flavonoids. Wolfson 2003 and Brock 2014 small trials suggest mild anxiolytic effect. Evidence is preliminary. Historically confused/adulterated with germander (Teucrium) — a documented hepatotoxin. Buy only from suppliers with confirmed Scutellaria lateriflora identity. Traditional use plus documented safety concerns. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "rue-tincture",
      "title": "Rue Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Rue-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10054634.jpg?v=1787592791",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "rue",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 35,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804538261701",
      "vsf_explanation": "Rue Tincture is single-ingredient liquid tincture Rue (Ruta graveolens). Rue has been used in European folk medicine as an emmenagogue, insect repellent, and, historically, an abortifacient. No modern RCT evidence for legitimate supplement claims. Known abortifacient — do not use in pregnancy (case reports of severe hepatorenal toxicity following abortifacient use). Phototoxic. Hepatotoxicity reports. Traditional use plus documented safety concerns. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "red-sage-tincture",
      "title": "Red Sage Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Red-Sage-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10124298.jpg?v=1787592792",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "sage",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804538360005",
      "vsf_explanation": "Red Sage Tincture is single-ingredient liquid tincture Red Sage (Dan Shen) (Salvia miltiorrhiza). Dan Shen is a foundational herb in Traditional Chinese Medicine used for cardiovascular conditions (\"blood stasis\"). Tanshinones and salvianolic acids are actives. Chinese literature includes many trials in coronary heart disease and stroke recovery, but methodological quality is variable and much of the strong evidence is with injectable or IV preparations, not oral capsules. Anticoagulant activity — significant interaction with warfarin. Avoid with anticoagulants. Preliminary RCT signal; not yet a well-established evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dandelion-root-tincture",
      "title": "Dandelion Root Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Dandelion-Root-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10125093.jpg?v=1787592792",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dandelion",
        "root",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804538458309",
      "vsf_explanation": "Dandelion Root Tincture is single-ingredient liquid tincture Dandelion Root (Taraxacum officinale (root)). Dandelion root has been used as a bitter tonic in European folk medicine, and prepared as \"coffee substitute.\" Sesquiterpene lactones (taraxinic acid) and inulin are constituents. No convincing modern RCT evidence for hepatic \"detox\" claims. In-vitro liver-protective activity in preclinical models. Rare Asteraceae allergy. Interaction with cytochrome-metabolized drugs possible. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cascara-sagrada-tincture",
      "title": "Cascara Sagrada Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Cascara-Sagrada-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10126660.jpg?v=1787592793",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cascara",
        "sagrada",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 35,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804538556613",
      "vsf_explanation": "Cascara Sagrada Tincture is single-ingredient liquid tincture Cascara Sagrada (Rhamnus purshiana). Cascara sagrada is a Pacific Northwest bark used as a stimulant laxative. Hydroxyanthracene glycosides (cascarosides) are the actives. Real stimulant-laxative activity (traditionally effective, comparable to senna). FDA removed cascara from OTC laxative status in 2002 due to lack of manufacturer-submitted safety data, not proven harm. Stimulant laxative — do not use >1 week without medical supervision. Can cause dependence, hypokalemia, melanosis coli. Contraindicated in pregnancy, bowel obstruction, kidney disease. Traditional use plus documented safety concerns. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cryptolepis-tincture",
      "title": "Cryptolepis Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Cryptolepis-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10047447.jpg?v=1787592792",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cryptolepis",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804538654917",
      "vsf_explanation": "Cryptolepis Tincture is single-ingredient liquid tincture Cryptolepis (Cryptolepis sanguinolenta). Cryptolepis is a West African vine traditionally used for malaria and infections. Cryptolepine is the alkaloid marker. Bugyei 2010 open-label trial in uncomplicated malaria showed comparable parasite clearance to some conventional treatments. Overall evidence base is small. Insufficient long-term safety data. Not for self-treatment of infections that require medical care. Small preliminary trials; effect sizes typically modest. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "burdock-tincture",
      "title": "Burdock Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Burdock-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10045830.jpg?v=1787592793",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "burdock",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804538753221",
      "vsf_explanation": "Burdock Tincture is single-ingredient liquid tincture Burdock Root (Arctium lappa). Burdock root has been used in European and East Asian folk medicine as a bitter tonic and \"blood purifier\"; also an ingredient in the Essiac formula. No rigorous modern RCT evidence for systemic claims. Well-tolerated. Diuretic effect. Rare Asteraceae allergy. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "feverfew-tincture",
      "title": "Feverfew Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Feverfew-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10058664.jpg?v=1787592794",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "feverfew",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804538851525",
      "vsf_explanation": "Feverfew Tincture is single-ingredient liquid tincture Feverfew (Tanacetum parthenium). Feverfew is a European folk remedy specifically used for migraine prevention. Parthenolide is the presumed active sesquiterpene lactone. Pittler 2004 Cochrane review found equivocal results, but a later RCT (Diener 2005) of MIG-99 (a stable parthenolide 6.25 mg TID extract) showed statistically significant reduction in migraine frequency vs placebo. Generic feverfew leaf without parthenolide standardization has thinner evidence. Sudden discontinuation after long use can cause \"post-feverfew syndrome\" (rebound headache, anxiety, insomnia). Avoid in pregnancy (theoretical uterotonic). Moderate RCT evidence base, generally at standardized doses. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "corn-silk-tincture",
      "title": "Corn Silk Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Corn-Silk-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10042655.jpg?v=1787592794",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "corn",
        "silk",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804538949829",
      "vsf_explanation": "Corn Silk Tincture is single-ingredient liquid tincture Corn Silk (Zea mays (silk)). Corn silk (the stigmas of the corn plant) has been used in European and Chinese folk medicine as a mild diuretic and for urinary tract complaints. No modern RCT evidence. Well-tolerated. Diuretic effect. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cilantro-tincture",
      "title": "Cilantro Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Cilantro-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10043450.jpg?v=1787592794",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cilantro",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804539048133",
      "vsf_explanation": "Cilantro Tincture is single-ingredient liquid tincture Coriander (Cilantro) (Coriandrum sativum). Coriander seed is a culinary spice used traditionally for digestive complaints. No robust modern RCT evidence for supplement-form claims. Traditional-use precedent. Well-tolerated. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "eyebright-tincture",
      "title": "Eyebright Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Eyebright-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10053821.jpg?v=1787592794",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "eyebright",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804539146437",
      "vsf_explanation": "Eyebright Tincture is single-ingredient liquid tincture Eyebright (Euphrasia officinalis). Eyebright is a European folk remedy historically used for ophthalmic complaints and, less consistently, for upper-respiratory allergies. No modern RCT evidence for ophthalmic or systemic claims. Generally well-tolerated at label doses. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "clove-tincture",
      "title": "Clove Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Clove-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10048270.jpg?v=1787592794",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "clove",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804539244741",
      "vsf_explanation": "Clove Tincture is single-ingredient liquid tincture Clove (Syzygium aromaticum). Clove is a culinary spice traditionally used for dental pain (eugenol is a mild topical anesthetic) and digestive complaints. Eugenol has documented in-vitro antimicrobial activity and topical anesthetic action (used in dentistry). Oral supplement-form evidence is thin. Anticoagulant activity — caution with warfarin. Rare hepatotoxicity with concentrated clove oil ingestion. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hydrangea-tincture",
      "title": "Hydrangea Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Hydrangea-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10121022.jpg?v=1787592794",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hydrangea",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804539343045",
      "vsf_explanation": "Hydrangea Tincture is single-ingredient liquid tincture Hydrangea Root (Hydrangea arborescens). Hydrangea root was used by Cherokee peoples for urinary tract complaints, later adopted by Eclectic physicians for prostate and kidney conditions. No modern RCT evidence. Rests entirely on traditional-use precedent. Well-tolerated at label doses. Diuretic effect. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "korean-red-ginseng-tincture",
      "title": "Korean Red Ginseng Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Korean-Red-Ginseng-Tincture-Gardenix-Vitamins-_-Supplements-116754595.jpg?v=1787592794",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "korean",
        "red",
        "ginseng",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804539441349",
      "vsf_explanation": "Korean Red Ginseng Tincture is single-ingredient liquid tincture Korean Red Ginseng (Panax ginseng (steamed)). Korean red ginseng is Panax ginseng root steamed and dried, a foundational Traditional Chinese and Korean tonic. Ginsenosides Rb1, Rg1, Rd are actives. Lee 2008 meta-analysis found modest improvements in erectile function; Reay 2010 studies suggest cognitive-arousal effects; small evidence for fatigue in cancer patients (Barton 2013). Insomnia at high doses. Anticoagulant activity. Avoid with MAOIs. Not for use with hormone-sensitive conditions. Moderate RCT evidence base, generally at standardized doses. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "self-heal-tincture",
      "title": "Self Heal Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Self-Heal-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10053013.jpg?v=1787592795",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "self",
        "heal",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804539539653",
      "vsf_explanation": "Self Heal Tincture is single-ingredient liquid tincture Self Heal (Prunella vulgaris). Self Heal has been used in traditional herbalism for immune-supportive positioning. Modern RCT evidence for specific immune claims for Self Heal is limited. In-vitro and traditional-use data provide the current support. Generally well-tolerated at label doses. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "wasabi-tincture",
      "title": "Wasabi Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Wasabi-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10049835.jpg?v=1787592795",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wasabi",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804539637957",
      "vsf_explanation": "Wasabi Tincture is single-ingredient liquid tincture Wasabi (Wasabia japonica / Eutrema japonicum). Wasabi (the Japanese horseradish rhizome) contains isothiocyanates with in-vitro antimicrobial activity. Most commercial wasabi is actually horseradish-mustard blends. Small in-vitro and animal studies suggest antimicrobial activity. No human RCT evidence for supplement-form claims. Well-tolerated. Isothiocyanates — theoretical thyroid caution with iodine deficiency. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "onion-tincture",
      "title": "Onion Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Onion-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10044295.jpg?v=1787592795",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "onion",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804539736261",
      "vsf_explanation": "Onion Tincture is single-ingredient liquid tincture Onion (Allium cepa) (Allium cepa). Onion is used as a food and in folk medicine for cardiovascular and antimicrobial claims. Quercetin and organosulfur compounds are candidate actives. Some small human studies (Sohn 2013) suggest modest BP-lowering with concentrated onion peel extract. Whole-onion capsule evidence is much weaker than for garlic. GI upset possible. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "white-willow-tincture",
      "title": "White Willow Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/White-Willow-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10115481.jpg?v=1787592796",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "white",
        "willow",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804539834565",
      "vsf_explanation": "White Willow Tincture is single-ingredient liquid tincture White Willow (Salix alba). White willow bark is a natural source of salicin, from which aspirin was originally derived. Salicin metabolizes to salicylic acid. Chrubasik 2001 RCT and later trials show benefit for lower back pain and osteoarthritis at 240 mg/day salicin, comparable to low-dose NSAIDs. Effect is modest but reproducible. Aspirin-like effects — anticoagulant activity, GI irritation. Avoid with aspirin allergy, in children (Reye syndrome), pre-surgery, and with warfarin/DOACs. Moderate RCT evidence base, generally at standardized doses. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "goldenseal-root-tincture",
      "title": "Goldenseal Root Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Goldenseal-Root-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10113831.jpg?v=1787592797",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "goldenseal",
        "root",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 35,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804539932869",
      "vsf_explanation": "Goldenseal Root Tincture is single-ingredient liquid tincture Goldenseal (Hydrastis canadensis). Goldenseal is a North American herb used by Native peoples and Eclectic physicians for mucous-membrane and infection complaints. Berberine and hydrastine are the actives. No large modern RCT evidence for infection or immune claims. Berberine (a shared alkaloid) has separately been studied for metabolic conditions but at much higher doses than in a goldenseal capsule. CYP3A4 inhibition — many drug interactions. Bilirubin displacement — avoid in pregnancy and newborns. Sustainability concern: goldenseal is CITES Appendix II listed due to wild-harvest pressure; buy certified organic and cultivated only. Traditional use plus documented safety concerns. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solomons-seal-tincture",
      "title": "Solomon's Seal Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Solomon_s-Seal-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10117826.jpg?v=1787592797",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solomon",
        "seal",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804540031173",
      "vsf_explanation": "Solomon's Seal Tincture is single-ingredient liquid tincture Solomon's Seal (Polygonatum biflorum). Solomon's Seal has been used in traditional herbalism for joint, bone, or connective-tissue support. No large modern RCT evidence supports specific joint claims for Solomon's Seal. Generally well-tolerated at label doses. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "saw-palmetto-tincture",
      "title": "Saw Palmetto Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Saw-Palmetto-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10051411.jpg?v=1787592798",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "saw",
        "palmetto",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804540129477",
      "vsf_explanation": "Saw Palmetto Tincture is single-ingredient liquid tincture Saw Palmetto (Serenoa repens). Saw Palmetto is a North American dwarf palm whose berries have been used in Southeastern US folk medicine for urinary complaints. The lipidosterolic extract (fatty acids and phytosterols) is the standardized preparation. Barry 2011 (CAMUS trial, negative) and Wilt 2000 Cochrane (initially positive; updated 2012 negative) show mixed results. The dominant modern read is: fatty-acid extracts (Permixon, 320 mg/day) may offer small BPH symptom benefit, but effect is modest and inconsistent. Powdered berry capsules and tinctures at unstandardized doses have very weak evidence. Well-tolerated. Rare GI upset. Theoretical antiplatelet effect. Moderate RCT evidence base, generally at standardized doses. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "alfalfa-tincture",
      "title": "Alfalfa Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Alfalfa-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10122678.jpg?v=1787592798",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alfalfa",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 35,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804540326085",
      "vsf_explanation": "Alfalfa Tincture is single-ingredient liquid tincture Alfalfa (Medicago sativa). Alfalfa is a legume traditionally used as a general nutritive tonic and for cholesterol claims. Small older trials suggest modest cholesterol effect; not robustly replicated. Vitamin K content is nutritionally meaningful. L-canavanine content — case reports of lupus-like syndrome and autoimmune flares. Avoid with SLE or on warfarin (vitamin K). Traditional use plus documented safety concerns. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "wild-cherry-tincture",
      "title": "Wild Cherry Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Wild-Cherry-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10116295.jpg?v=1787592798",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wild",
        "cherry",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804540227781",
      "vsf_explanation": "Wild Cherry Tincture is single-ingredient liquid tincture Wild Cherry Bark (Prunus serotina). Wild Cherry Bark has been used in European or global folk medicine for respiratory complaints (cough, mucus, congestion). No modern RCT evidence supports specific respiratory claims for Wild Cherry Bark. The evidence base is limited to traditional-use precedent and, in some cases, small in-vitro antimicrobial data. Contains cyanogenic glycosides — use only prepared extracts, never raw bark or leaves. Standard tinctures are safe at label doses. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sarsaparilla-tincture",
      "title": "Sarsaparilla Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Sarsaparilla-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10050616.jpg?v=1787592799",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sarsaparilla",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804540522693",
      "vsf_explanation": "Sarsaparilla Tincture is single-ingredient liquid tincture Sarsaparilla (Smilax ornata / regelii). Sarsaparilla root was historically promoted as a \"blood purifier\" and for skin complaints. Sarsapogenin and other saponins are constituents. No modern RCT evidence for systemic claims. Well-tolerated at label doses. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lomatium-tincture",
      "title": "Lomatium Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Lomatium-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10118621.jpg?v=1787592799",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lomatium",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 21.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804540424389",
      "vsf_explanation": "Lomatium Tincture is single-ingredient liquid tincture Lomatium (Lomatium dissectum). Lomatium is a Pacific Northwest root used by Native peoples for respiratory infections, adopted by naturopaths particularly during the 1917-18 influenza pandemic. No rigorous modern RCT evidence. Reports of measles-like rash with certain preparations (may be a pyranocoumarin sensitivity). Isolate resins are more implicated than whole tinctures. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "yarrow-tincture-1",
      "title": "Yarrow Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Yarrow-Tincture-Gardenix-Vitamins-_-Supplements-116752880.jpg?v=1787592801",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "yarrow",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804540620997",
      "vsf_explanation": "Yarrow Tincture is single-ingredient liquid tincture Yarrow (Achillea millefolium). Yarrow has been used since antiquity in European folk medicine as a wound herb, bitter tonic, and diaphoretic. No modern RCT evidence for supplement-form claims. Traditional-use precedent. Rare Asteraceae allergy. Avoid in pregnancy. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "horsetail-tincture",
      "title": "Horsetail Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Horsetail-Tincture-Gardenix-Vitamins-_-Supplements-143140478.jpg?v=1787592801",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "horsetail",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 35,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804540719301",
      "vsf_explanation": "Horsetail Tincture is single-ingredient liquid tincture Horsetail (Equisetum arvense). Horsetail is used in European folk medicine as a mild diuretic and for its silica content, sometimes marketed for hair, nails, and bones. Costa-Rodrigues 2012 in-vitro work suggests bone-related activity, but no rigorous human RCT for bone-density outcomes. Thiaminase content — historically linked to thiamine deficiency with long-term high-dose use. Avoid E. palustre (contains toxic alkaloids). Look for thiaminase-free (heat-treated) preparations for long use. Traditional use plus documented safety concerns. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "brahmi-capsules",
      "title": "Brahmi Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Brahmi-Capsules-Gardenix-Vitamins-_-Supplements-128492269.jpg?v=1787592842",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "brahmi",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 18.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804542554309",
      "vsf_explanation": "Brahmi Capsules is single-ingredient capsulated Bacopa monnieri (Brahmi) (Bacopa monnieri). Bacopa (Brahmi in Ayurveda) is a rasayana used for memory consolidation and attention. Bacosides A and B are the presumed active constituents. Kongkeaw 2014 meta-analysis of 9 RCTs found small-to-moderate improvement in memory acquisition (delayed word recall) at 300 mg/day of a 55%-bacosides extract, typically taken for 12 weeks. Effect is subtle and requires 8-12 weeks to manifest. Common GI side effects (nausea, cramping) — take with food. Well-tolerated otherwise in short trials. Real RCT evidence base at standardized doses. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cascara-sagrada-capsules",
      "title": "Cascara Sagrada Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Cascara-Sagrada-Capsules-gardenixx-60-Capsules-Vitamins-_-Supplements-10151330.jpg?v=1787592842",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cascara",
        "sagrada",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 35,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 18.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804542619845",
      "vsf_explanation": "Cascara Sagrada Capsules is single-ingredient capsulated Cascara Sagrada (Rhamnus purshiana). Cascara sagrada is a Pacific Northwest bark used as a stimulant laxative. Hydroxyanthracene glycosides (cascarosides) are the actives. Real stimulant-laxative activity (traditionally effective, comparable to senna). FDA removed cascara from OTC laxative status in 2002 due to lack of manufacturer-submitted safety data, not proven harm. Stimulant laxative — do not use >1 week without medical supervision. Can cause dependence, hypokalemia, melanosis coli. Contraindicated in pregnancy, bowel obstruction, kidney disease. Traditional use plus documented safety concerns. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "butchers-broom-capsules",
      "title": "Butcher's Broom Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Butcher_s-Broom-Capsules-gardenixx-60-Capsules-Vitamins-_-Supplements-10150621.jpg?v=1787592842",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "butcher",
        "broom",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804542685381",
      "vsf_explanation": "Butcher's Broom Capsules is single-ingredient capsulated Butcher's Broom (Ruscus aculeatus). Butcher's broom is used in European herbalism for chronic venous insufficiency (leg heaviness, varicose symptoms). Ruscogenins are candidate saponin actives. Kakkos 2018 systematic review of Butcher's broom (often combined with hesperidin methylchalcone and ascorbic acid — the Cyclo 3 Fort formulation) shows modest benefit for chronic venous insufficiency symptoms. Well-tolerated. Rare GI upset. Preliminary RCT signal; not yet a well-established evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "rhodiola-tincture",
      "title": "Rhodiola Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Rhodiola-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10059416.jpg?v=1787592847",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "rhodiola",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804542783685",
      "vsf_explanation": "Rhodiola Tincture is single-ingredient liquid tincture Rhodiola rosea (Rhodiola rosea). Rhodiola is a Scandinavian and Russian adaptogen historically used for physical endurance and mental fatigue. The active constituents are rosavins and salidroside, both concentrated in the root. Multiple randomized trials — Cropley 2015 (life-stress symptoms), Panossian 2010 review, Ishaque 2012 meta-analysis — show modest but reproducible benefit for stress-related fatigue at 200-600 mg/day of a standardized root extract (typically 3% rosavins, 1% salidroside). Effect sizes are moderate, not dramatic. Well-tolerated in short-term trials. Mild activation possible; take before mid-afternoon. Not studied in pregnancy. Real RCT evidence base at standardized doses. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hops-tincture",
      "title": "Hops Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Hops-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10060244.jpg?v=1787592847",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hops",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804543078597",
      "vsf_explanation": "Hops Tincture is single-ingredient liquid tincture Hops (Humulus lupulus). Hops (the flowering strobiles used to bitter beer) have been used in European folk medicine as a mild sedative and nervine. Xanthohumol, humulones, and lupulones are constituents. Small trials (Franco 2012, Kyrou 2017) suggest modest anxiolytic and sleep-quality effects, often studied in combination with valerian rather than alone. Sedation possible. Phytoestrogen content — theoretical hormonal effect. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lungwort-tincture",
      "title": "Lungwort Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Lungwort-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10129024.jpg?v=1787592847",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lungwort",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804542881989",
      "vsf_explanation": "Lungwort Tincture is single-ingredient liquid tincture Lungwort (Pulmonaria officinalis). Lungwort has been used in European or global folk medicine for respiratory complaints (cough, mucus, congestion). No modern RCT evidence supports specific respiratory claims for Lungwort. The evidence base is limited to traditional-use precedent and, in some cases, small in-vitro antimicrobial data. Well-tolerated at label doses. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "holy-basil-tincture",
      "title": "Holy Basil Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Holy-Basil-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10061064.jpg?v=1787592848",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "holy",
        "basil",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804542980293",
      "vsf_explanation": "Holy Basil Tincture is single-ingredient liquid tincture Holy Basil (Tulsi) (Ocimum sanctum / tenuiflorum). Tulsi is one of the most sacred Ayurvedic herbs, classified as a rasayana adaptogen for stress and immunity. Jamshidi 2017 systematic review of 24 human studies (mixed methodology) suggests benefit for stress-related symptoms, immune markers, and blood sugar. Individual trials are small and heterogeneous. Generally well-tolerated. Theoretical antifertility effect at high doses. Anticoagulant activity — caution with warfarin. Preliminary RCT signal; not yet a well-established evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "butchers-broom-tincture",
      "title": "Butcher's Broom Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Butcher_s-Broom-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10130595.jpg?v=1787592847",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "butcher",
        "broom",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804543176901",
      "vsf_explanation": "Butcher's Broom Tincture is single-ingredient liquid tincture Butcher's Broom (Ruscus aculeatus). Butcher's broom is used in European herbalism for chronic venous insufficiency (leg heaviness, varicose symptoms). Ruscogenins are candidate saponin actives. Kakkos 2018 systematic review of Butcher's broom (often combined with hesperidin methylchalcone and ascorbic acid — the Cyclo 3 Fort formulation) shows modest benefit for chronic venous insufficiency symptoms. Well-tolerated. Rare GI upset. Preliminary RCT signal; not yet a well-established evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lavender-tincture",
      "title": "Lavender Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Lavender-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10061882.jpg?v=1787592847",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lavender",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804543373509",
      "vsf_explanation": "Lavender Tincture is single-ingredient liquid tincture Lavender (Lavandula angustifolia). Lavender has been used in European folk medicine for anxiety and sleep. Linalool and linalyl acetate are the primary volatile actives. Kasper 2010 and Woelk 2010 trials of oral Silexan (a specific 80 mg lavender essential oil capsule) show anxiolytic effect comparable to paroxetine in generalized anxiety disorder. Note: unstandardized lavender tincture is not the same preparation and has much weaker evidence. Well-tolerated. Rare GI upset. High-dose lavender essential oil has been associated with prepubertal gynecomastia in isolated case reports — evidence contested. Moderate RCT evidence base, generally at standardized doses. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chickweed-tincture",
      "title": "Chickweed Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Chickweed-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10135394.jpg?v=1787592847",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chickweed",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804543275205",
      "vsf_explanation": "Chickweed Tincture is single-ingredient liquid tincture Chickweed (Stellaria media). Chickweed is a common European weed used in folk medicine as a mild demulcent and for weight-loss claims. No modern RCT evidence for weight-loss or systemic claims. Well-tolerated as food. Saponin content at high doses may cause GI upset. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cordyceps-tincture",
      "title": "Cordyceps Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Cordyceps-Tincture-Gardenix-Vitamins-_-Supplements-116755057.jpg?v=1787592847",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cordyceps",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804543471813",
      "vsf_explanation": "Cordyceps Tincture is single-ingredient liquid tincture Cordyceps (Cordyceps militaris / sinensis). Cordyceps is a parasitic fungus long used in Traditional Chinese Medicine for stamina and lung function. Cordycepin and adenosine analogs are candidate actives. Most modern products use cultivated C. militaris (not the wild caterpillar-grown C. sinensis). Chen 2010 (elderly cyclists) and Chen 2017 (young men) trials found small improvements in VO2 max and exercise tolerance. Effect sizes are modest. Generally well-tolerated. Anticoagulant activity possible. Preliminary RCT signal; not yet a well-established evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gentian-tincture",
      "title": "Gentian Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Gentian-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10136128.jpg?v=1787592847",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gentian",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804543570117",
      "vsf_explanation": "Gentian Tincture is single-ingredient liquid tincture Gentian (Gentiana lutea). Gentian root is one of the most bitter herbs known and a classic European bitter tonic (component of Angostura bitters). Gentiopicroside is the marker. Long traditional use for digestive stimulation; bitter-receptor mechanism supported by modern research. Formal RCT evidence limited. Well-tolerated at label doses. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cinchona-tincture",
      "title": "Cinchona Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Cinchona-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10132948.jpg?v=1787592847",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cinchona",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 15,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804543668421",
      "vsf_explanation": "Cinchona Tincture is single-ingredient liquid tincture Quinine (Cinchona spp. (source)). Quinine is an alkaloid derived from Cinchona bark, historically used to treat malaria and, until 2010, for nocturnal leg cramps. Quinine has real antimalarial activity but is a prescription-only drug for that use. For leg-cramp prevention, the FDA banned the last OTC formulation in 2010 after cases of severe thrombotic thrombocytopenic purpura, hemolytic uremic syndrome, and cardiac arrhythmia — including deaths. Cinchonism (tinnitus, nausea, deafness) at high doses. Thrombocytopenia. Cardiac arrhythmia (QT prolongation). QT-prolonging drug interactions. Avoid entirely as a supplement. FDA banned OTC quinine formulations in 2010 due to fatal thrombotic and cardiac adverse events. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "wormwood-tincture",
      "title": "Wormwood Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Wormwood-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10132160.jpg?v=1787592847",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wormwood",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 35,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804543865029",
      "vsf_explanation": "Wormwood Tincture is single-ingredient liquid tincture Wormwood (Artemisia absinthium). Wormwood is a bitter European herb used traditionally as a digestive bitter and antiparasitic. It is the primary flavoring in absinthe. Small trials suggest bitter-tonic digestive effects. Krebs 2010 small trial found benefit in Crohn's disease. Evidence is preliminary. Thujone content — the neurotoxic constituent responsible for absinthe's historic seizure and psychosis reports at very high doses. Modern tinctures are generally low-thujone but limit duration of use to 2-4 weeks. Avoid in pregnancy and seizure disorder. Traditional use plus documented safety concerns. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ginger-tincture",
      "title": "Ginger Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Ginger-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10064242.jpg?v=1787592848",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ginger",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804543766725",
      "vsf_explanation": "Ginger Tincture is single-ingredient liquid tincture Ginger (Zingiber officinale). Ginger rhizome has been used in Ayurveda and Traditional Chinese Medicine for millennia for nausea and digestive complaints. Gingerols and shogaols are the active constituents. Marx 2015 meta-analysis of 12 RCTs shows benefit for chemotherapy-induced nausea. Ernst 2000 and Ozgoli 2009 confirm efficacy for pregnancy-related morning sickness at 1-1.5 g/day of ginger powder or equivalent. Modest anti-inflammatory effect in OA (Terry 2011). Well-tolerated. Mild reflux possible at high doses. Anticoagulant activity — theoretical caution. Real RCT evidence base at standardized doses. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "long-pepper-tincture",
      "title": "Long Pepper Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Long-Pepper-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10133742.jpg?v=1787592848",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "long",
        "pepper",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804543963333",
      "vsf_explanation": "Long Pepper Tincture is single-ingredient liquid tincture Long Pepper (Piper longum). Long pepper (Pippali) is a foundational Ayurvedic herb related to black pepper. Piperine is the alkaloid. Piperine has documented bioenhancer activity (raises bioavailability of curcumin and other compounds) but standalone RCT evidence is limited. Well-tolerated. Piperine affects CYP450 enzymes and increases absorption of many drugs — theoretical drug-interaction considerations. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "olive-tincture",
      "title": "Olive Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Olive-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10129747.jpg?v=1787592847",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "olive",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804544061637",
      "vsf_explanation": "Olive Tincture is single-ingredient liquid tincture Olive Leaf (Olea europaea). Olive leaf is a Mediterranean folk remedy for cardiovascular and antimicrobial support. Oleuropein is the marker. Susalit 2011 RCT found blood pressure lowering with olive leaf extract (500 mg BID) comparable to captopril at 12 weeks. Modest effect. Well-tolerated. Hypoglycemia possible with high doses. Preliminary RCT signal; not yet a well-established evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "catnip-tincture",
      "title": "Catnip Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Catnip-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10062640.jpg?v=1787592848",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "catnip",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804544159941",
      "vsf_explanation": "Catnip Tincture is single-ingredient liquid tincture Catnip (Nepeta cataria). Catnip has been used in European or global folk medicine as a nervine (nervous-system tonic) for anxiety, sleep, or mood complaints. No large modern RCT evidence supports specific psychiatric or sleep claims for Catnip. The evidence base rests on traditional-use precedent. Mild sedation possible. Avoid combining with alcohol or CNS depressants. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "burdock-capsules",
      "title": "Burdock Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Burdock-Capsules-gardenixx-60-Capsules-Vitamins-_-Supplements-10149280.jpg?v=1787592848",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "burdock",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 18.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804544258245",
      "vsf_explanation": "Burdock Capsules is single-ingredient capsulated Burdock Root (Arctium lappa). Burdock root has been used in European and East Asian folk medicine as a bitter tonic and \"blood purifier\"; also an ingredient in the Essiac formula. No rigorous modern RCT evidence for systemic claims. Well-tolerated. Diuretic effect. Rare Asteraceae allergy. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "guarana-tincture",
      "title": "Guarana Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Guarana-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10070630.jpg?v=1787592850",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "guarana",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804544389317",
      "vsf_explanation": "Guarana Tincture is single-ingredient liquid tincture Guarana (Paullinia cupana). Guarana seed has been used by Amazonian peoples for stamina; it is naturally caffeine-rich (2-8% caffeine). Kennedy 2004 studies found alertness improvements plausibly attributable to caffeine content. Weight-loss effect is essentially a caffeine effect. Caffeine content — same cautions as coffee (anxiety, insomnia, cardiovascular). Do not combine with other stimulants. Preliminary RCT signal; not yet a well-established evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "astragalus-capsules",
      "title": "Astragalus Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Astragalus-Capsules-gardenixx-60-Capsules-Vitamins-_-Supplements-10146477.jpg?v=1787592850",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "astragalus",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804544487621",
      "vsf_explanation": "Astragalus Capsules is single-ingredient capsulated Astragalus (Astragalus membranaceus). Huang Qi has been used in Traditional Chinese Medicine for over 2,000 years for qi deficiency and immune support. Astragalosides and polysaccharides are presumed actives. Small trials suggest immune-supportive effects, particularly in chemotherapy adjunct settings (Zhang 2012 meta), but methodological quality is generally low. Best-quality evidence is in Chinese literature. Well-tolerated. Avoid with autoimmune disease (theoretical stimulation). Diuretic effect. Preliminary RCT signal; not yet a well-established evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "catuaba-tincture",
      "title": "Catuaba Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Catuaba-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10073053.jpg?v=1787592850",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "catuaba",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804544520389",
      "vsf_explanation": "Catuaba Tincture is single-ingredient liquid tincture Catuaba (Trichilia catigua / Erythroxylum vaccinifolium). Catuaba is a Brazilian bark traditionally used for libido and central nervous system tonic. Multiple botanical sources sold under the same trade name. No rigorous modern RCT evidence. Well-tolerated at label doses. Botanical identity confusion is a real concern with unstandardized products. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "rosemary-tincture",
      "title": "Rosemary Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Rosemary-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10069881.jpg?v=1787592851",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "rosemary",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804544651461",
      "vsf_explanation": "Rosemary Tincture is single-ingredient liquid tincture Rosemary (Rosmarinus officinalis). Rosemary is a culinary herb long associated in European tradition with memory. Rosmarinic acid and 1,8-cineole are candidate actives. Moss 2003 (aroma) and Pengelly 2012 (oral) small studies suggest cognitive effects. Small evidence base. Well-tolerated. Avoid essential-oil-strength preparations in pregnancy or seizure disorder. Small preliminary trials; effect sizes typically modest. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bugleweed-capsules",
      "title": "Bugleweed Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Bugleweed-Capsules-Gardenix-Vitamins-_-Supplements-117628397.jpg?v=1787592851",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bugleweed",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 42,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 21.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804544749765",
      "vsf_explanation": "Bugleweed Capsules is single-ingredient capsulated Bugleweed (Lycopus virginicus / europaeus). Bugleweed is used in European folk medicine for mild hyperthyroid symptoms (Graves-related palpitations). Rosmarinic acid derivatives inhibit thyroid-stimulating antibody binding in vitro. Small German trials (Auf'mkolk 1984) suggest anti-thyroid activity. Modern rigorous trials are lacking. Real anti-thyroid activity — do not use with hypothyroidism or on thyroid hormone replacement. Avoid in pregnancy. Preliminary evidence but documented safety concern lowers the score. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "brahmi-tincture",
      "title": "Brahmi Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Brahmi-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10071447.jpg?v=1787592851",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "brahmi",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804544815301",
      "vsf_explanation": "Brahmi Tincture is single-ingredient liquid tincture Bacopa monnieri (Brahmi) (Bacopa monnieri). Bacopa (Brahmi in Ayurveda) is a rasayana used for memory consolidation and attention. Bacosides A and B are the presumed active constituents. Kongkeaw 2014 meta-analysis of 9 RCTs found small-to-moderate improvement in memory acquisition (delayed word recall) at 300 mg/day of a 55%-bacosides extract, typically taken for 12 weeks. Effect is subtle and requires 8-12 weeks to manifest. Common GI side effects (nausea, cramping) — take with food. Well-tolerated otherwise in short trials. Real RCT evidence base at standardized doses. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "blue-vervain-capsules",
      "title": "Blue Vervain Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Blue-Vervain-Capsules-gardenixx-60-Capsules-Vitamins-_-Supplements-10147892.jpg?v=1787592851",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "blue",
        "vervain",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 18.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804544913605",
      "vsf_explanation": "Blue Vervain Capsules is single-ingredient capsulated Blue Vervain (Verbena hastata). Blue Vervain has been used in European or global folk medicine as a nervine (nervous-system tonic) for anxiety, sleep, or mood complaints. No large modern RCT evidence supports specific psychiatric or sleep claims for Blue Vervain. The evidence base rests on traditional-use precedent. Mild sedation possible. Avoid combining with alcohol or CNS depressants. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ginkgo-biloba-tincture",
      "title": "Ginkgo Biloba Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Ginkgo-Biloba-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10074632.jpg?v=1787592852",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ginkgo",
        "biloba",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804544979141",
      "vsf_explanation": "Ginkgo Biloba Tincture is single-ingredient liquid tincture Ginkgo biloba (Ginkgo biloba). Ginkgo has been used in Traditional Chinese Medicine for over a millennium for memory and circulation. The active fraction is a standardized leaf extract containing 24% flavone glycosides and 6% terpene lactones — this is what \"EGb 761,\" the branded German extract used in most positive trials, contains. Kandiah 2019 clinical practice guideline recommends EGb 761 for early cognitive complaints. Cochrane reviews of dementia are mixed — modest benefit in some cognitive endpoints, no clear effect on progression. Generic ginkgo capsules without the 24/6 standardization spec have thinner evidence. Anticoagulant effect; do not combine with warfarin, aspirin, or DOACs without clinician sign-off. Discontinue 2 weeks before surgery. Real RCT evidence base at standardized doses. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bacopa-tincture",
      "title": "Bacopa Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Bacopa-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10069085.jpg?v=1787592852",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bacopa",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804545077445",
      "vsf_explanation": "Bacopa Tincture is single-ingredient liquid tincture Bacopa monnieri (Brahmi) (Bacopa monnieri). Bacopa (Brahmi in Ayurveda) is a rasayana used for memory consolidation and attention. Bacosides A and B are the presumed active constituents. Kongkeaw 2014 meta-analysis of 9 RCTs found small-to-moderate improvement in memory acquisition (delayed word recall) at 300 mg/day of a 55%-bacosides extract, typically taken for 12 weeks. Effect is subtle and requires 8-12 weeks to manifest. Common GI side effects (nausea, cramping) — take with food. Well-tolerated otherwise in short trials. Real RCT evidence base at standardized doses. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "star-anise-tincture",
      "title": "Star Anise Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Star-Anise-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10144146.jpg?v=1787592852",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "star",
        "anise",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804545175749",
      "vsf_explanation": "Star Anise Tincture is single-ingredient liquid tincture Star Anise (Illicium verum). Star anise is a Chinese culinary spice traditionally used for digestive complaints. It is the industrial source of shikimic acid used to synthesize oseltamivir (Tamiflu). No modern RCT evidence for supplement-form claims. Note: Japanese star anise (Illicium anisatum) is toxic and has contaminated Chinese star anise preparations, causing seizures in infants — always confirm Illicium verum. Ensure preparation is Illicium verum, not the toxic I. anisatum. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "white-peony-tincture",
      "title": "White Peony Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/White-Peony-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10073881.jpg?v=1787592852",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "white",
        "peony",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804545274053",
      "vsf_explanation": "White Peony Tincture is single-ingredient liquid tincture White Peony (Paeonia lactiflora). White peony root (Bai Shao) is a foundational herb in Traditional Chinese Medicine, particularly in women's formulas and as a component of the classic combination with licorice (Shao Yao Gan Cao Tang) for muscle spasm and menstrual cramps. Traditional formula evidence is stronger than monotherapy evidence. Small trials of the peony-licorice combination in polycystic ovary syndrome (Takahashi 1994) and muscle cramps show benefit. Isolated peony monotherapy has thinner RCT support. Generally well-tolerated. Anticoagulant activity possible. Avoid in pregnancy without practitioner guidance. Small preliminary trials; effect sizes typically modest. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "black-walnut-capsules",
      "title": "Black Walnut Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Black-Walnut-Capsules-gardenixx-60-Capsules-Vitamins-_-Supplements-10147177.jpg?v=1787592852",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "black",
        "walnut",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804545372357",
      "vsf_explanation": "Black Walnut Capsules is single-ingredient capsulated Black Walnut (Juglans nigra). Black walnut hull has been used in Eclectic herbal medicine for parasites and skin conditions. Juglone is the marker. In-vitro antiparasitic activity documented; human RCT evidence essentially absent. Nut allergy risk. Juglone content — some GI irritation possible. Tannin-rich, can bind minerals if taken with meals. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ashwagandha-tincture",
      "title": "Ashwagandha Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Ashwagandha-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10068278.jpg?v=1787592852",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ashwagandha",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804545437893",
      "vsf_explanation": "Ashwagandha Tincture is single-ingredient liquid tincture Ashwagandha (Withania somnifera). Ashwagandha is a foundational Ayurvedic adaptogen classified as a rasayana (rejuvenative). The withanolides in the root are the presumed active constituents. Chandrasekhar 2012 and Lopresti 2019 (both with KSM-66 standardized extract, 300-600 mg) show statistically significant reductions in Perceived Stress Scale and morning cortisol vs placebo. Salve 2019 showed sleep-quality improvement. Generic root powder without standardization has thinner evidence — most positive trials used a specific branded extract. Generally well-tolerated. Rare hepatotoxicity case reports exist (Iceland cluster 2020) — avoid with liver disease. Thyroid-stimulating; caution with hyperthyroidism. Real RCT evidence base at standardized doses. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "quinine-tincture",
      "title": "Quinine Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Quinine-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10136975.jpg?v=1787592856",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "quinine",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 15,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804545667269",
      "vsf_explanation": "Quinine Tincture is single-ingredient liquid tincture Quinine (Cinchona spp. (source)). Quinine is an alkaloid derived from Cinchona bark, historically used to treat malaria and, until 2010, for nocturnal leg cramps. Quinine has real antimalarial activity but is a prescription-only drug for that use. For leg-cramp prevention, the FDA banned the last OTC formulation in 2010 after cases of severe thrombotic thrombocytopenic purpura, hemolytic uremic syndrome, and cardiac arrhythmia — including deaths. Cinchonism (tinnitus, nausea, deafness) at high doses. Thrombocytopenia. Cardiac arrhythmia (QT prolongation). QT-prolonging drug interactions. Avoid entirely as a supplement. FDA banned OTC quinine formulations in 2010 due to fatal thrombotic and cardiac adverse events. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "agaricus-blazei-capsules",
      "title": "Agaricus Blazei Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Agaricus-Blazei-Capsules-gardenixx-60-Capsules-Vitamins-_-Supplements-10144991.jpg?v=1787592856",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "agaricus",
        "blazei",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804545765573",
      "vsf_explanation": "Agaricus Blazei Capsules is single-ingredient capsulated Agaricus blazei (ABM) (Agaricus subrufescens). Agaricus blazei (Agaricus subrufescens, \"almond mushroom\") is a Brazilian medicinal mushroom promoted for immune support. Beta-glucans are the primary constituent. Small Japanese trials suggest possible immune modulation in cancer chemotherapy adjunct settings, but methodological quality is low and results are inconsistent. Insufficient evidence to support health claims. Rare severe hepatotoxicity case reports (Mukumoto 2014). Users with liver disease should avoid. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "passionflower-tincture",
      "title": "Passionflower Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Passionflower-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10065027.jpg?v=1787592856",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "passionflower",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804545831109",
      "vsf_explanation": "Passionflower Tincture is single-ingredient liquid tincture Passionflower (Passiflora incarnata). Passionflower is a Central and North American vine used traditionally for anxiety and insomnia. Flavonoids (chrysin, vitexin) and beta-carbolines are presumed active. Akhondzadeh 2001 small RCT found comparable anxiolysis to oxazepam in GAD; Movafegh 2008 showed pre-operative anxiety reduction. Evidence base is small (a handful of trials, small sample sizes). Well-tolerated. Sedating — avoid with alcohol/CNS depressants. Small preliminary trials; effect sizes typically modest. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "astragalus-tincture",
      "title": "Astragalus Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Astragalus-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10145654.jpg?v=1787592856",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "astragalus",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804545929413",
      "vsf_explanation": "Astragalus Tincture is single-ingredient liquid tincture Astragalus (Astragalus membranaceus). Huang Qi has been used in Traditional Chinese Medicine for over 2,000 years for qi deficiency and immune support. Astragalosides and polysaccharides are presumed actives. Small trials suggest immune-supportive effects, particularly in chemotherapy adjunct settings (Zhang 2012 meta), but methodological quality is generally low. Best-quality evidence is in Chinese literature. Well-tolerated. Avoid with autoimmune disease (theoretical stimulation). Diuretic effect. Preliminary RCT signal; not yet a well-established evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "licorice-tincture",
      "title": "Licorice Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Licorice-Tincture-gardenixx-Vitamins-_-Supplements-10139373.jpg?v=1787592856",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "licorice",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 52,
        "manufacturing": 50,
        "safety": 40,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804546027717",
      "vsf_explanation": "Licorice Tincture is single-ingredient liquid tincture Licorice (Glycyrrhiza glabra). Licorice root has been used in Traditional Chinese Medicine and European herbalism for cough, GI complaints, and adrenal support. Glycyrrhizin is the marker constituent. Small trials support use for functional dyspepsia (Raveendra 2012, GutGard extract) and eczema-associated inflammation. Traditional TCM use for cough is well-documented. IMPORTANT: Glycyrrhizin causes pseudo-aldosteronism at 100 mg+ daily (hypertension, hypokalemia, water retention). Avoid with hypertension, heart failure, kidney disease, and with digoxin, potassium-losing diuretics, and warfarin. Deglycyrrhizinated licorice (DGL) is safer for chronic use. Modest evidence with documented safety concern. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "american-ginseng-tincture",
      "title": "American Ginseng Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/American-Ginseng-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10140156.jpg?v=1787592856",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "american",
        "ginseng",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804546126021",
      "vsf_explanation": "American Ginseng Tincture is single-ingredient liquid tincture American Ginseng (Panax quinquefolius). American ginseng is a Panax species native to the northeastern US and Canada, traditionally used by Iroquois and other peoples. Ginsenosides differ from Asian ginseng — Rb1 higher, Rg1 lower. Barton 2013 large trial (Wisconsin Ginseng, 2000 mg/day) found significant reduction in cancer-related fatigue. Vuksan 2000 studies suggest post-prandial glucose reduction. Well-tolerated at modest doses. Anticoagulant activity. Avoid with MAOIs. Moderate RCT evidence base, generally at standardized doses. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mucuna-tincture",
      "title": "Mucuna Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Mucuna-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10072299.jpg?v=1787592856",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mucuna",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 21.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804546224325",
      "vsf_explanation": "Mucuna Tincture is single-ingredient liquid tincture Mucuna pruriens (Mucuna pruriens). Mucuna is an Ayurvedic legume traditionally used for nervous-system and reproductive complaints. Its distinguishing constituent is L-DOPA (levodopa), the direct dopamine precursor. Katzenschlager 2004 small trial in Parkinson's disease found benefit at 30 g mucuna powder (~1500 mg L-DOPA). Evidence for other indications is preliminary. L-DOPA content produces real pharmacological effects — do not combine with prescription levodopa or MAOIs. GI upset common. Preliminary RCT signal; not yet a well-established evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "andrographis-tincture",
      "title": "Andrographis Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Andrographis-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10143317.jpg?v=1787592856",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "andrographis",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804546322629",
      "vsf_explanation": "Andrographis Tincture is single-ingredient liquid tincture Andrographis (Andrographis paniculata). Andrographis (\"King of Bitters\") is used in Ayurveda and Traditional Chinese Medicine for fevers and upper-respiratory infections. Andrographolide is the marker diterpene lactone. Coon 2004 systematic review found moderate benefit for uncomplicated upper-respiratory tract infection symptoms (Kalmcold, KalmCold Plus, and generic 60 mg/day andrographolide extracts). Effect is on symptom severity and duration. Bitter taste. Rare hepatotoxicity reports at high doses. Reduces fertility in animals — avoid when trying to conceive. Moderate RCT evidence base, generally at standardized doses. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "blue-vervain-tincture",
      "title": "Blue Vervain Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Blue-Vervain-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10063456.jpg?v=1787592857",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "blue",
        "vervain",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804546420933",
      "vsf_explanation": "Blue Vervain Tincture is single-ingredient liquid tincture Blue Vervain (Verbena hastata). Blue Vervain has been used in European or global folk medicine as a nervine (nervous-system tonic) for anxiety, sleep, or mood complaints. No large modern RCT evidence supports specific psychiatric or sleep claims for Blue Vervain. The evidence base rests on traditional-use precedent. Mild sedation possible. Avoid combining with alcohol or CNS depressants. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chamomile-tincture",
      "title": "Chamomile Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Chamomile-Tincture-Gardenix-Vitamins-_-Supplements-84108384.jpg?v=1787592857",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chamomile",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804546519237",
      "vsf_explanation": "Chamomile Tincture is single-ingredient liquid tincture Chamomile (Matricaria chamomilla). German chamomile has been used in European herbalism for anxiety, sleep, and digestive complaints. Apigenin (a partial BZD-receptor agonist) and bisabolol are presumed actives. Amsterdam 2009 RCT found modest anxiolytic effect at 220-1100 mg/day of a 1.2% apigenin standardized extract in GAD. Long-term Amsterdam 2016 continuation showed sustained but small benefit. Well-tolerated. Rare Asteraceae-family allergy. Mild sedation possible. Small preliminary trials; effect sizes typically modest. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "coriander-tincture",
      "title": "Coriander Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Coriander-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10140988.jpg?v=1787592857",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coriander",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804546617541",
      "vsf_explanation": "Coriander Tincture is single-ingredient liquid tincture Coriander (Cilantro) (Coriandrum sativum). Coriander seed is a culinary spice used traditionally for digestive complaints. No robust modern RCT evidence for supplement-form claims. Traditional-use precedent. Well-tolerated. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "valerian-tincture",
      "title": "Valerian Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Valerian-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10066618.jpg?v=1787592857",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "valerian",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804546715845",
      "vsf_explanation": "Valerian Tincture is single-ingredient liquid tincture Valerian (Valeriana officinalis). Valerian root has been used in European herbalism since the Greeks for sleep and anxiety. Valerenic acid and iridoid valepotriates are active constituents; mechanism appears to involve GABA-A modulation. Bent 2006 meta-analysis of 16 RCTs found modest improvement in subjective sleep quality but not consistently in objective sleep-onset latency. Effect size is small. Better evidence for anxiety-related sleep disturbance than idiopathic insomnia. Well-tolerated short-term. Morning grogginess in some users. Avoid combining with alcohol or benzodiazepines. Moderate RCT evidence base, generally at standardized doses. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "artichoke-tincture",
      "title": "Artichoke Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Artichoke-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10142570.jpg?v=1787592857",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "artichoke",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804546814149",
      "vsf_explanation": "Artichoke Tincture is single-ingredient liquid tincture Artichoke Leaf (Cynara scolymus). Artichoke leaf has been used in European folk medicine as a bitter tonic and for hepatic/dyspeptic complaints. Cynarin and chlorogenic acid are candidate actives. Holtmann 2003 (functional dyspepsia) and Bundy 2004 (IBS) trials show modest symptom benefit for standardized artichoke leaf extract (320-640 mg/day). Cholesterol trials are equivocal. Rare Asteraceae allergy. Bile-duct obstruction contraindicated. Small preliminary trials; effect sizes typically modest. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "oregon-grape-tincture",
      "title": "Oregon Grape Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Oregon-Grape-Tincture-Gardenix-Vitamins-_-Supplements-149233112.jpg?v=1787592858",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "oregon",
        "grape",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804546945221",
      "vsf_explanation": "Oregon Grape Tincture is single-ingredient liquid tincture Oregon Grape (Mahonia aquifolium). Oregon grape root contains berberine, the same alkaloid found in goldenseal, and has been used for GI and skin complaints. Small trials (Gulliver 2005) suggest topical benefit for psoriasis with a Mahonia cream. Oral evidence is thinner than for berberine itself. Berberine-containing herbs — bilirubin displacement (avoid in newborns), CYP interactions, avoid in pregnancy. Preliminary RCT signal; not yet a well-established evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "horehound-tincture",
      "title": "Horehound Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Horehound-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10137729.jpg?v=1787592858",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "horehound",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804547043525",
      "vsf_explanation": "Horehound Tincture is single-ingredient liquid tincture White Horehound (Marrubium vulgare). White horehound is used in European folk medicine as a bitter cough remedy and digestive tonic. Marrubiin is the marker constituent. German Commission E monograph supports use as an expectorant based on traditional-use precedent; no rigorous modern RCT. Well-tolerated at label doses. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bitter-melon-tincture",
      "title": "Bitter Melon Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Bitter-Melon-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10134537.jpg?v=1787592859",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bitter",
        "melon",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804547174597",
      "vsf_explanation": "Bitter Melon Tincture is single-ingredient liquid tincture Bitter Melon (Momordica charantia). Bitter melon fruit has been used in Ayurvedic, Chinese, and Caribbean folk medicine for diabetes. Charantin, vicine, and polypeptide-p are candidate actives. Yin 2014 meta-analysis found small HbA1c and fasting glucose reduction in type 2 diabetes; effect smaller than metformin. Quality of underlying trials is variable. GI upset common at high doses. Hypoglycemia risk with diabetes medication. Avoid in pregnancy (abortifacient historically). Preliminary RCT signal; not yet a well-established evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chicory-tincture",
      "title": "Chicory Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Chicory-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10141795.jpg?v=1787592860",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chicory",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804547272901",
      "vsf_explanation": "Chicory Tincture is single-ingredient liquid tincture Chicory (Cichorium intybus). Chicory root has been used in European folk medicine as a bitter tonic and coffee substitute. Rich in inulin (a prebiotic fiber). Inulin content provides established prebiotic effect at meaningful doses (5-10 g/day). Tincture doses are typically far below this. Diuretic effect — maintain fluid intake. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lemon-balm-tincture",
      "title": "Lemon Balm Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Lemon-Balm-Tincture-Gardenix-Vitamins-_-Supplements-84972632.jpg?v=1787592861",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lemon",
        "balm",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804547371205",
      "vsf_explanation": "Lemon Balm Tincture is single-ingredient liquid tincture Lemon Balm (Melissa officinalis). Lemon balm has been used in European herbalism since the Greeks for anxiety, sleep, and digestive complaints. Rosmarinic acid and terpenes are presumed actives. Kennedy 2003 small crossover trials show mild anxiolytic and cognitive effects. Cases 2011 open-label found benefit in mild-moderate anxiety and sleep disturbance. Evidence is preliminary but consistent for mild anxiolysis at 300-600 mg/day. Well-tolerated. Mild sedation possible. Theoretical thyroid interaction (hypothyroid caution). Preliminary RCT signal; not yet a well-established evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chickweed-capsules",
      "title": "Chickweed Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Chickweed-Capsules-Gardenix-Vitamins-_-Supplements-116755586.jpg?v=1787592907",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chickweed",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804547797189",
      "vsf_explanation": "Chickweed Capsules is single-ingredient capsulated Chickweed (Stellaria media). Chickweed is a common European weed used in folk medicine as a mild demulcent and for weight-loss claims. No modern RCT evidence for weight-loss or systemic claims. Well-tolerated as food. Saponin content at high doses may cause GI upset. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutmeg-tincture",
      "title": "Nutmeg Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nutmeg-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10075436.jpg?v=1787592907",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutmeg",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 35,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804547862725",
      "vsf_explanation": "Nutmeg Tincture is single-ingredient liquid tincture Nutmeg (Myristica fragrans). Nutmeg seed is used both as a culinary spice and, historically, in folk medicine. Myristicin and elemicin are aromatic actives. Essentially no modern RCT evidence for supplement-form claims. Traditional-use precedent for digestive complaints. IMPORTANT safety flag: nutmeg at doses of 5 g or more (roughly two whole nutmegs) can cause hallucinogenic and cardiotoxic effects (myristicin toxicity) with severe delirium, tachycardia, and, rarely, death. Label capsule/tincture doses are well below this range but cumulative daily use should be monitored. Not for use in pregnancy. Traditional use plus documented safety concerns. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "couch-grass-capsules",
      "title": "Couch Grass Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Couch-Grass-Capsules-gardenixx-60-Capsules-Vitamins-_-Supplements-10155543.jpg?v=1787592908",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "couch",
        "grass",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 17.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804548026565",
      "vsf_explanation": "Couch Grass Capsules is single-ingredient capsulated Couch Grass (Elymus repens). Couch grass rhizome is used in European folk medicine as a mild diuretic and demulcent for urinary tract complaints. No modern RCT evidence. Well-tolerated. Diuretic effect. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ginkgo-biloba-capsules",
      "title": "Ginkgo Biloba Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Ginkgo-Biloba-Capsules-gardenixx-60-Capsules-Vitamins-_-Supplements-10159058.jpg?v=1787592907",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ginkgo",
        "biloba",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804547961029",
      "vsf_explanation": "Ginkgo Biloba Capsules is single-ingredient capsulated Ginkgo biloba (Ginkgo biloba). Ginkgo has been used in Traditional Chinese Medicine for over a millennium for memory and circulation. The active fraction is a standardized leaf extract containing 24% flavone glycosides and 6% terpene lactones — this is what \"EGb 761,\" the branded German extract used in most positive trials, contains. Kandiah 2019 clinical practice guideline recommends EGb 761 for early cognitive complaints. Cochrane reviews of dementia are mixed — modest benefit in some cognitive endpoints, no clear effect on progression. Generic ginkgo capsules without the 24/6 standardization spec have thinner evidence. Anticoagulant effect; do not combine with warfarin, aspirin, or DOACs without clinician sign-off. Discontinue 2 weeks before surgery. Real RCT evidence base at standardized doses. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hyssop-capsules",
      "title": "Hyssop Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Hyssop-Capsules-gardenixx-60-Capsules-Vitamins-_-Supplements-10163223.jpg?v=1787592907",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hyssop",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 20.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804548092101",
      "vsf_explanation": "Hyssop Capsules is single-ingredient capsulated Hyssop (Hyssopus officinalis). Hyssop has been used in European or global folk medicine for respiratory complaints (cough, mucus, congestion). No modern RCT evidence supports specific respiratory claims for Hyssop. The evidence base is limited to traditional-use precedent and, in some cases, small in-vitro antimicrobial data. Pinocamphone (a volatile constituent) is a convulsant at very high doses. Avoid essential-oil-strength preparations; tincture is much diluted. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "muira-puama-and-catuaba-tincture",
      "title": "Muira Puama and Catuaba Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Muira-Puama-and-Catuaba-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10078645.jpg?v=1787592907",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "muira",
        "puama",
        "and",
        "catuaba",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804548387013",
      "vsf_explanation": "Muira Puama and Catuaba Tincture is single-ingredient liquid tincture Muira Puama + Catuaba (Ptychopetalum olacoides + Trichilia catigua). Muira Puama and Catuaba are Amazonian tonic barks traditionally used for male vitality and libido. Waynberg 1994 open-label study suggested libido benefit in men with erectile complaints; no rigorous placebo-controlled RCT. Generally well-tolerated at label doses. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "catuaba-capsules",
      "title": "Catuaba Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Catuaba-Capsules-Gardenix-Vitamins-_-Supplements-152838098.jpg?v=1787592908",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "catuaba",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804548223173",
      "vsf_explanation": "Catuaba Capsules is single-ingredient capsulated Catuaba (Trichilia catigua / Erythroxylum vaccinifolium). Catuaba is a Brazilian bark traditionally used for libido and central nervous system tonic. Multiple botanical sources sold under the same trade name. No rigorous modern RCT evidence. Well-tolerated at label doses. Botanical identity confusion is a real concern with unstandardized products. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "wild-lettuce-tincture",
      "title": "Wild Lettuce Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Wild-Lettuce-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10076282.jpg?v=1787592907",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wild",
        "lettuce",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804548288709",
      "vsf_explanation": "Wild Lettuce Tincture is single-ingredient liquid tincture Wild Lettuce (Lactuca virosa). Wild lettuce contains lactucin, a compound with mild sedative activity in preclinical models. Historically used as an opium substitute in European folk medicine. No modern RCT evidence. Lactucin has weak opioid-receptor activity in in-vitro models. Mild sedation possible. Avoid combining with alcohol or CNS depressants. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "prickly-ash-tincture",
      "title": "Prickly Ash Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Prickly-Ash-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10077014.jpg?v=1787592907",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "prickly",
        "ash",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804548681925",
      "vsf_explanation": "Prickly Ash Tincture is single-ingredient liquid tincture Prickly Ash (Zanthoxylum americanum). Prickly Ash is a traditional herb used in European or global folk medicine, in this case for circulatory-support positioning. No modern RCT evidence supports specific cardiovascular claims for Prickly Ash. Any effect rests on traditional-use precedent and in-vitro or animal data. Generally well-tolerated at label doses. See specific interactions on the ingredient page. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "shepherds-purse-tincture",
      "title": "Shepherd's Purse Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Shepherd_s-Purse-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10077852.jpg?v=1787592907",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shepherd",
        "purse",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804548583621",
      "vsf_explanation": "Shepherd's Purse Tincture is single-ingredient liquid tincture Shepherd's Purse (Capsella bursa-pastoris). Shepherd's Purse is used in European folk medicine for heavy menstrual bleeding and mild wound-related bleeding. No large modern RCT evidence supports specific women's-health claims for Shepherd's Purse. Rests on traditional-use precedent. Generally well-tolerated. See specific pregnancy contraindications on the ingredient page. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "corn-silk-capsules",
      "title": "Corn Silk Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Corn-Silk-Capsules-gardenixx-60-Capsules-Vitamins-_-Supplements-10154839.jpg?v=1787592908",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "corn",
        "silk",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 20.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804548157637",
      "vsf_explanation": "Corn Silk Capsules is single-ingredient capsulated Corn Silk (Zea mays (silk)). Corn silk (the stigmas of the corn plant) has been used in European and Chinese folk medicine as a mild diuretic and for urinary tract complaints. No modern RCT evidence. Well-tolerated. Diuretic effect. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mugwort-tincture",
      "title": "Mugwort Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Mugwort-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10080245.jpg?v=1787592908",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mugwort",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 35,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804548485317",
      "vsf_explanation": "Mugwort Tincture is single-ingredient liquid tincture Mugwort (Artemisia vulgaris). Mugwort has been used in European and East Asian folk medicine for menstrual regulation and, historically, moxibustion. No modern RCT evidence for oral supplementation claims. Contains thujone — same cautions as wormwood but generally lower content. Avoid in pregnancy (uterotonic/abortifacient). Traditional use plus documented safety concerns. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chicory-capsules",
      "title": "Chicory Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Chicory-Capsules-gardenixx-60-Capsules-Vitamins-_-Supplements-10154166.jpg?v=1787592908",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chicory",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804548780229",
      "vsf_explanation": "Chicory Capsules is single-ingredient capsulated Chicory (Cichorium intybus). Chicory root has been used in European folk medicine as a bitter tonic and coffee substitute. Rich in inulin (a prebiotic fiber). Inulin content provides established prebiotic effect at meaningful doses (5-10 g/day). Tincture doses are typically far below this. Diuretic effect — maintain fluid intake. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "stinging-nettle-leaf-tincture",
      "title": "Stinging Nettle Leaf Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Stinging-Nettle-Leaf-Tincture-gardenixx-Alcohol-FREE-2-OZ-Vitamins-_-Supplements-10079493.jpg?v=1787592907",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "stinging",
        "nettle",
        "leaf",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804548845765",
      "vsf_explanation": "Stinging Nettle Leaf Tincture is single-ingredient liquid tincture Stinging Nettle Leaf (Urtica dioica (leaf)). Nettle leaf has been used in European herbalism for allergic rhinitis, joint pain, and as a general nutritive tonic. Flavonoids and histamine-modulating compounds are candidate actives. Roschek 2009 pilot found freeze-dried nettle better than placebo for hay-fever symptoms. Small, single-center. Chrubasik 1997 pilot suggested benefit for OA when used alongside NSAIDs. Overall evidence is preliminary. Well-tolerated orally. Diuretic. Theoretical antihypertensive interaction. Small preliminary trials; effect sizes typically modest. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "licorice-capsules",
      "title": "Licorice Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Licorice-Capsules-gardenixx-60-Capsules-Vitamins-_-Supplements-10164699.jpg?v=1787592907",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "licorice",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 52,
        "manufacturing": 50,
        "safety": 40,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 18.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804548944069",
      "vsf_explanation": "Licorice Capsules is single-ingredient capsulated Licorice (Glycyrrhiza glabra). Licorice root has been used in Traditional Chinese Medicine and European herbalism for cough, GI complaints, and adrenal support. Glycyrrhizin is the marker constituent. Small trials support use for functional dyspepsia (Raveendra 2012, GutGard extract) and eczema-associated inflammation. Traditional TCM use for cough is well-documented. IMPORTANT: Glycyrrhizin causes pseudo-aldosteronism at 100 mg+ daily (hypertension, hypokalemia, water retention). Avoid with hypertension, heart failure, kidney disease, and with digoxin, potassium-losing diuretics, and warfarin. Deglycyrrhizinated licorice (DGL) is safer for chronic use. Modest evidence with documented safety concern. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chaparral-capsules",
      "title": "Chaparral Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Chaparral-Capsules-gardenixx-60-Capsules-Vitamins-_-Supplements-10152790.jpg?v=1787592908",
      "score": 28,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chaparral",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 12,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804549009605",
      "vsf_explanation": "Chaparral Capsules is single-ingredient capsulated Chaparral (Larrea tridentata). Chaparral is a Southwestern US desert shrub used historically by Native peoples for skin and infection complaints. NDGA (nordihydroguaiaretic acid) is a marker constituent. FDA issued a warning about chaparral hepatotoxicity in 1992 after multiple case reports of severe hepatitis (some requiring transplant). No credible therapeutic evidence base. FDA has flagged chaparral for hepatotoxicity — do not use internally. Reports of acute hepatitis, cirrhosis, and liver failure. Documented hepatotoxicity with case reports of liver failure. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "star-anise-capsules",
      "title": "Star Anise Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Star-Anise-Capsules-gardenixx-60-Capsules-Vitamins-_-Supplements-10171676.jpg?v=1787592909",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "star",
        "anise",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 22.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804549075141",
      "vsf_explanation": "Star Anise Capsules is single-ingredient capsulated Star Anise (Illicium verum). Star anise is a Chinese culinary spice traditionally used for digestive complaints. It is the industrial source of shikimic acid used to synthesize oseltamivir (Tamiflu). No modern RCT evidence for supplement-form claims. Note: Japanese star anise (Illicium anisatum) is toxic and has contaminated Chinese star anise preparations, causing seizures in infants — always confirm Illicium verum. Ensure preparation is Illicium verum, not the toxic I. anisatum. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "stinging-nettle-root-capsules",
      "title": "Stinging Nettle Root Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Stinging-Nettle-Root-Capsules-Gardenix-Vitamins-_-Supplements-133403847.jpg?v=1787592909",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "stinging",
        "nettle",
        "root",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804549140677",
      "vsf_explanation": "Stinging Nettle Root Capsules is single-ingredient capsulated Stinging Nettle Root (Urtica dioica). Stinging Nettle root has been used in European herbalism for urinary symptoms in older men. Lignans and beta-sitosterol are candidate actives. Safarinejad 2005 RCT and Lopatkin 2005 combination trial (with saw palmetto) show modest benefit for BPH symptom scores. Evidence is thinner than for saw palmetto itself. Nettle *leaf* (for allergic rhinitis / joint pain) has separate small trials. Well-tolerated. Diuretic effect. Theoretical antihypertensive interaction. Preliminary RCT signal; not yet a well-established evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "wormwood-capsules",
      "title": "Wormwood Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Wormwood-Capsules-Gardenix-Vitamins-_-Supplements-75702796.jpg?v=1787592911",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wormwood",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 35,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804549238981",
      "vsf_explanation": "Wormwood Capsules is single-ingredient capsulated Wormwood (Artemisia absinthium). Wormwood is a bitter European herb used traditionally as a digestive bitter and antiparasitic. It is the primary flavoring in absinthe. Small trials suggest bitter-tonic digestive effects. Krebs 2010 small trial found benefit in Crohn's disease. Evidence is preliminary. Thujone content — the neurotoxic constituent responsible for absinthe's historic seizure and psychosis reports at very high doses. Modern tinctures are generally low-thujone but limit duration of use to 2-4 weeks. Avoid in pregnancy and seizure disorder. Traditional use plus documented safety concerns. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sage-tincture",
      "title": "Sage Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Sage-Tincture-Gardenix-Vitamins-_-Supplements-116755934.jpg?v=1787592911",
      "score": 52,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sage",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804549304517",
      "vsf_explanation": "Sage Tincture is single-ingredient liquid tincture Sage (Salvia officinalis). Common sage has been used in European folk medicine for sore throat, digestion, and hot flashes. Bommer 2011 open-label found benefit for menopausal hot flashes with a proprietary fresh-sage extract. Kennedy 2011 studies suggest mild cognitive effects. Evidence is preliminary. Thujone content — avoid long-term high-dose use and in pregnancy. Not for use with seizure disorder. Small preliminary trials; effect sizes typically modest. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sheep-sorrel-capsules",
      "title": "Sheep Sorrel Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Sheep-Sorrel-Capsules-gardenixx-60-Capsules-Vitamins-_-Supplements-10170918.jpg?v=1787592912",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sheep",
        "sorrel",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 20.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804549402821",
      "vsf_explanation": "Sheep Sorrel Capsules is single-ingredient capsulated Sheep Sorrel (Rumex acetosella). Sheep sorrel is an ingredient in the Essiac herbal formula (with burdock, slippery elm, Indian rhubarb) promoted as a cancer therapy — a claim with no supporting RCT evidence. No modern RCT evidence. Essiac has been studied and shown no benefit for cancer. Oxalate content — avoid with kidney stones or kidney disease. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "quinine-capsules",
      "title": "Quinine Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Quinine-Capsules-gardenixx-60-Capsules-Vitamins-_-Supplements-10168829.jpg?v=1787592913",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "quinine",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 15,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 23.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804549501125",
      "vsf_explanation": "Quinine Capsules is single-ingredient capsulated Quinine (Cinchona spp. (source)). Quinine is an alkaloid derived from Cinchona bark, historically used to treat malaria and, until 2010, for nocturnal leg cramps. Quinine has real antimalarial activity but is a prescription-only drug for that use. For leg-cramp prevention, the FDA banned the last OTC formulation in 2010 after cases of severe thrombotic thrombocytopenic purpura, hemolytic uremic syndrome, and cardiac arrhythmia — including deaths. Cinchonism (tinnitus, nausea, deafness) at high doses. Thrombocytopenia. Cardiac arrhythmia (QT prolongation). QT-prolonging drug interactions. Avoid entirely as a supplement. FDA banned OTC quinine formulations in 2010 due to fatal thrombotic and cardiac adverse events. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "red-sage-capsules",
      "title": "Red Sage Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Red-Sage-Capsules-gardenixx-60-Capsules-Vitamins-_-Supplements-10168172.jpg?v=1787592913",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "sage",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 20.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804549566661",
      "vsf_explanation": "Red Sage Capsules is single-ingredient capsulated Red Sage (Dan Shen) (Salvia miltiorrhiza). Dan Shen is a foundational herb in Traditional Chinese Medicine used for cardiovascular conditions (\"blood stasis\"). Tanshinones and salvianolic acids are actives. Chinese literature includes many trials in coronary heart disease and stroke recovery, but methodological quality is variable and much of the strong evidence is with injectable or IV preparations, not oral capsules. Anticoagulant activity — significant interaction with warfarin. Avoid with anticoagulants. Preliminary RCT signal; not yet a well-established evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "red-root-tincture",
      "title": "Red Root Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Red-Root-Tincture-Gardenix-Vitamins-_-Supplements-141082531.jpg?v=1787592914",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "red",
        "root",
        "tincture",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 21.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804549697733",
      "vsf_explanation": "Red Root Tincture is single-ingredient liquid tincture Red Root (Ceanothus americanus). Red root (New Jersey tea) was used by Native American peoples and Eclectic physicians for lymphatic and upper-respiratory conditions. No modern RCT evidence. Well-tolerated at label doses. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "thyme-capsules",
      "title": "Thyme Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Thyme-Capsules-Gardenix-Vitamins-_-Supplements-128426180.jpg?v=1787592913",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "thyme",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 18.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804549632197",
      "vsf_explanation": "Thyme Capsules is single-ingredient capsulated Thyme (Thymus vulgaris). Thyme has been used in European or global folk medicine for respiratory complaints (cough, mucus, congestion). Thymol (main volatile) has documented in-vitro antimicrobial activity. Kemmerich 2007 combination trial (thyme + primrose) suggested benefit for acute bronchitis; monotherapy trials are limited. Well-tolerated at label doses. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "rhodiola-capsules",
      "title": "Rhodiola Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Rhodiola-Capsules-gardenixx-60-Capsules-Vitamins-_-Supplements-10169528.jpg?v=1787592913",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "rhodiola",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 28.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804549796037",
      "vsf_explanation": "Rhodiola Capsules is single-ingredient capsulated Rhodiola rosea (Rhodiola rosea). Rhodiola is a Scandinavian and Russian adaptogen historically used for physical endurance and mental fatigue. The active constituents are rosavins and salidroside, both concentrated in the root. Multiple randomized trials — Cropley 2015 (life-stress symptoms), Panossian 2010 review, Ishaque 2012 meta-analysis — show modest but reproducible benefit for stress-related fatigue at 200-600 mg/day of a standardized root extract (typically 3% rosavins, 1% salidroside). Effect sizes are moderate, not dramatic. Well-tolerated in short-term trials. Mild activation possible; take before mid-afternoon. Not studied in pregnancy. Real RCT evidence base at standardized doses. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "devils-claw-capsules",
      "title": "Devil's Claw Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Devil_s-Claw-Capsules-gardenixx-60-Capsules-Vitamins-_-Supplements-10156968.jpg?v=1787592915",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "devil",
        "claw",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 21.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804549861573",
      "vsf_explanation": "Devil's Claw Capsules is single-ingredient capsulated Devil's Claw (Harpagophytum procumbens). Devil's Claw is a Southern African root traditionally used for musculoskeletal pain. Harpagoside is the marker iridoid glycoside. Warnock 2007 (open-label but sizeable), Chrubasik 2007 meta-analysis, and multiple German trials show benefit comparable to NSAIDs for knee/hip osteoarthritis at 50-100 mg harpagoside/day. Not as heavily studied as glucosamine but the evidence base is real. Well-tolerated. Avoid with active peptic ulcer. Theoretical anticoagulant activity. Real RCT evidence base at standardized doses. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ladys-mantle-capsules",
      "title": "Lady's Mantle Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Lady_s-Mantle-Capsules-gardenixx-60-Capsules-Vitamins-_-Supplements-10163941.jpg?v=1787592915",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lady",
        "mantle",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804549927109",
      "vsf_explanation": "Lady's Mantle Capsules is single-ingredient capsulated Lady's Mantle (Alchemilla vulgaris). Lady's Mantle has been used in traditional herbalism, particularly in women's health contexts. No large modern RCT evidence supports specific women's-health claims for Lady's Mantle. Rests on traditional-use precedent. Generally well-tolerated. See specific pregnancy contraindications on the ingredient page. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "horehound-capsules",
      "title": "Horehound Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Horehound-Capsules-gardenixx-60-Capsules-Vitamins-_-Supplements-10161179.jpg?v=1787592916",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "horehound",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804549992645",
      "vsf_explanation": "Horehound Capsules is single-ingredient capsulated White Horehound (Marrubium vulgare). White horehound is used in European folk medicine as a bitter cough remedy and digestive tonic. Marrubiin is the marker constituent. German Commission E monograph supports use as an expectorant based on traditional-use precedent; no rigorous modern RCT. Well-tolerated at label doses. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sarsaparilla-capsules",
      "title": "Sarsaparilla Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Sarsaparilla-Capsules-gardenixx-60-Capsules-Vitamins-_-Supplements-10170230.jpg?v=1787592916",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sarsaparilla",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804550058181",
      "vsf_explanation": "Sarsaparilla Capsules is single-ingredient capsulated Sarsaparilla (Smilax ornata / regelii). Sarsaparilla root was historically promoted as a \"blood purifier\" and for skin complaints. Sarsapogenin and other saponins are constituents. No modern RCT evidence for systemic claims. Well-tolerated at label doses. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "horsetail-capsules",
      "title": "Horsetail Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Horsetail-Capsules-gardenixx-60-Capsules-Vitamins-_-Supplements-10161884.jpg?v=1787592916",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "horsetail",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 35,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804550123717",
      "vsf_explanation": "Horsetail Capsules is single-ingredient capsulated Horsetail (Equisetum arvense). Horsetail is used in European folk medicine as a mild diuretic and for its silica content, sometimes marketed for hair, nails, and bones. Costa-Rodrigues 2012 in-vitro work suggests bone-related activity, but no rigorous human RCT for bone-density outcomes. Thiaminase content — historically linked to thiamine deficiency with long-term high-dose use. Avoid E. palustre (contains toxic alkaloids). Look for thiaminase-free (heat-treated) preparations for long use. Traditional use plus documented safety concerns. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hibiscus-capsules",
      "title": "Hibiscus Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Hibiscus-Capsules-gardenixx-60-Capsules-Vitamins-_-Supplements-10159794.jpg?v=1787592918",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hibiscus",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804550189253",
      "vsf_explanation": "Hibiscus Capsules is single-ingredient capsulated Hibiscus (Hibiscus sabdariffa). Hibiscus (Roselle) has been used in African and Middle Eastern folk medicine as a cooling tea for blood pressure. Anthocyanins are presumed actives. Serban 2015 meta-analysis of 5 RCTs found small systolic and diastolic BP reduction (~7/3 mmHg) with hibiscus tea/extract. Effect is modest but real in mild hypertension. Well-tolerated. Diuretic. Theoretical interaction with antihypertensives, hydrochlorothiazide, acetaminophen. Preliminary RCT signal; not yet a well-established evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "meadowsweet-capsules",
      "title": "Meadowsweet Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Meadowsweet-Capsules-Gardenix-Vitamins-_-Supplements-126621150.jpg?v=1787592919",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "meadowsweet",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 21.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804550254789",
      "vsf_explanation": "Meadowsweet Capsules is single-ingredient capsulated Meadowsweet (Filipendula ulmaria). Meadowsweet is a European plant naturally rich in salicylic-acid precursors — indeed, aspirin (acetyl-salicylic acid) is named for Spiraea (meadowsweet's old genus name). Traditionally used for GI upset and mild pain. No large modern RCT evidence. Salicylate content provides mechanistic plausibility for anti-inflammatory effect at high doses. Aspirin-like activity — avoid with aspirin allergy, in children (Reye syndrome), pre-surgery, with warfarin/DOACs. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "elecampane-capsules",
      "title": "Elecampane Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Elecampane-Capsules-gardenixx-60-Capsules-Vitamins-_-Supplements-10157666.jpg?v=1787592921",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "elecampane",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 20.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804550451397",
      "vsf_explanation": "Elecampane Capsules is single-ingredient capsulated Elecampane (Inula helenium). Elecampane has been used in European or global folk medicine for respiratory complaints (cough, mucus, congestion). No modern RCT evidence supports specific respiratory claims for Elecampane. The evidence base is limited to traditional-use precedent and, in some cases, small in-vitro antimicrobial data. Well-tolerated at label doses. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "prickly-ash-capsules",
      "title": "Prickly Ash Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Prickly-Ash-Capsules-gardenixx-60-Capsules-Vitamins-_-Supplements-10167489.jpg?v=1787592921",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "prickly",
        "ash",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 21.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804550385861",
      "vsf_explanation": "Prickly Ash Capsules is single-ingredient capsulated Prickly Ash (Zanthoxylum americanum). Prickly Ash is a traditional herb used in European or global folk medicine, in this case for circulatory-support positioning. No modern RCT evidence supports specific cardiovascular claims for Prickly Ash. Any effect rests on traditional-use precedent and in-vitro or animal data. Generally well-tolerated at label doses. See specific interactions on the ingredient page. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutmeg-capsules",
      "title": "Nutmeg Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nutmeg-Capsules-gardenixx-60-Capsules-Vitamins-_-Supplements-10166091.jpg?v=1787592921",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutmeg",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 35,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 21.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804550516933",
      "vsf_explanation": "Nutmeg Capsules is single-ingredient capsulated Nutmeg (Myristica fragrans). Nutmeg seed is used both as a culinary spice and, historically, in folk medicine. Myristicin and elemicin are aromatic actives. Essentially no modern RCT evidence for supplement-form claims. Traditional-use precedent for digestive complaints. IMPORTANT safety flag: nutmeg at doses of 5 g or more (roughly two whole nutmegs) can cause hallucinogenic and cardiotoxic effects (myristicin toxicity) with severe delirium, tachycardia, and, rarely, death. Label capsule/tincture doses are well below this range but cumulative daily use should be monitored. Not for use in pregnancy. Traditional use plus documented safety concerns. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dandelion-leaf-capsules",
      "title": "Dandelion Leaf Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Dandelion-Leaf-Capsules-gardenixx-60-Capsules-Vitamins-_-Supplements-10156234.jpg?v=1787592922",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dandelion",
        "leaf",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 20.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804550811845",
      "vsf_explanation": "Dandelion Leaf Capsules is single-ingredient capsulated Dandelion Leaf (Taraxacum officinale (leaf)). Dandelion leaf has been used as a mild diuretic and bitter tonic in European folk medicine. Sesquiterpene lactones and potassium content are relevant. Clare 2009 small pilot found brief diuretic effect. Otherwise limited modern evidence for hepatic or renal claims. Diuretic — maintain fluid intake. Asteraceae allergy possible. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hydrangea-capsules",
      "title": "Hydrangea Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Hydrangea-Capsules-Gardenix-Vitamins-_-Supplements-151803043.jpg?v=1787592921",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hydrangea",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 20.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804550615237",
      "vsf_explanation": "Hydrangea Capsules is single-ingredient capsulated Hydrangea Root (Hydrangea arborescens). Hydrangea root was used by Cherokee peoples for urinary tract complaints, later adopted by Eclectic physicians for prostate and kidney conditions. No modern RCT evidence. Rests entirely on traditional-use precedent. Well-tolerated at label doses. Diuretic effect. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hops-capsules",
      "title": "Hops Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Hops-Capsules-gardenixx-60-Capsules-Vitamins-_-Supplements-10160455.jpg?v=1787592922",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hops",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804550746309",
      "vsf_explanation": "Hops Capsules is single-ingredient capsulated Hops (Humulus lupulus). Hops (the flowering strobiles used to bitter beer) have been used in European folk medicine as a mild sedative and nervine. Xanthohumol, humulones, and lupulones are constituents. Small trials (Franco 2012, Kyrou 2017) suggest modest anxiolytic and sleep-quality effects, often studied in combination with valerian rather than alone. Sedation possible. Phytoestrogen content — theoretical hormonal effect. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "eyebright-capsules",
      "title": "Eyebright Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Eyebright-Capsules-gardenixx-60-Capsules-Vitamins-_-Supplements-10158396.jpg?v=1787592922",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "eyebright",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 20.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804550680773",
      "vsf_explanation": "Eyebright Capsules is single-ingredient capsulated Eyebright (Euphrasia officinalis). Eyebright is a European folk remedy historically used for ophthalmic complaints and, less consistently, for upper-respiratory allergies. No modern RCT evidence for ophthalmic or systemic claims. Generally well-tolerated at label doses. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "onion-capsules",
      "title": "Onion Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Onion-Capsules-gardenixx-60-Capsules-Vitamins-_-Supplements-10166764.jpg?v=1787592922",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "onion",
        "capsules",
        "garden",
        "organics"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804550877381",
      "vsf_explanation": "Onion Capsules is single-ingredient capsulated Onion (Allium cepa) (Allium cepa). Onion is used as a food and in folk medicine for cardiovascular and antimicrobial claims. Quercetin and organosulfur compounds are candidate actives. Some small human studies (Sohn 2013) suggest modest BP-lowering with concentrated onion peel extract. Whole-onion capsule evidence is much weaker than for garlic. GI upset possible. Traditional-use precedent only; no meaningful RCT evidence base. Garden Organics is a small US-based single-ingredient herbal line; every product is one botanical in capsule or tincture form (no proprietary blends). Third-party COAs, per-lot heavy-metal/microbial data, and specific standardization percentages are not publicly disclosed at the product level, which is a real transparency gap despite the honest single-ingredient formatting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnesium-glycine-health-supplement-liquid",
      "title": "Magnesium Glycine Health Supplement Liquid",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1e69e9d3-b6a4-4433-936f-ed30d540e3bb.jpg?v=1787593246",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "glycine",
        "health",
        "supplement",
        "liquid",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 12,
        "formulation": 10,
        "manufacturing": 10,
        "safety": 8,
        "transparency": 6,
        "sustainability": 4
      },
      "price": 17.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804560150725",
      "vsf_explanation": "Magnesium glycinate (magnesium bound to glycine) in liquid format. Same evidence base as capsules — bioavailable, well-tolerated, gentle on the GI tract. Liquid format allows dose titration but has the same low-volume limitation as drops for reaching effective doses. This SKU discloses no per-serving elemental mg, no total mg per bottle, and no COA. Standard 50/100: real ingredient in a legitimate but not-optimal format, held down by no dose disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "muscle-recovery-energy-supplement-drops",
      "title": "Muscle Recovery Energy Supplement Drops",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c01b34bc-bba5-4caf-86cc-6a73ed642a4b.jpg?v=1787593246",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "muscle",
        "recovery",
        "energy",
        "supplement",
        "drops",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 8,
        "manufacturing": 8,
        "safety": 6,
        "transparency": 5,
        "sustainability": 3
      },
      "price": 17.41,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804560183493",
      "vsf_explanation": "Generic 'muscle recovery energy supplement drops' with no disclosed ingredients. Drops format is a suboptimal delivery for the trial-evidenced muscle recovery compounds — creatine 5g/day, EAAs 5-10g/day, protein 20-40g post-workout, tart cherry 300-500mg anthocyanins — all require multi-gram doses that drops cannot deliver. 'Energy' framing implies caffeine but content is undisclosed. Autofailed under misleading_naming + proprietary_blend_hides_dose. Rejected at 42.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "dietary-supplement-4",
      "title": "Dietary Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/99ee991d-d66d-40a1-bc28-133c6df71181.jpg?v=1787593251",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dietary",
        "supplement",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 8,
        "formulation": 6,
        "manufacturing": 6,
        "safety": 5,
        "transparency": 4,
        "sustainability": 3
      },
      "price": 21.58,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804560281797",
      "vsf_explanation": "Second SKU in this batch titled literally 'Dietary Supplement.' Same misleading_naming autofail as Dietary Supplement item 7 (moringa 11000mg). Cannot assess without disclosed ingredients. Rejected at 32.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "male-health-support-capsule",
      "title": "Male Health Support Capsule",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f0edab7e-1b7f-4e3c-8fcc-63bbb4deb009.jpg?v=1787593251",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "male",
        "health",
        "support",
        "capsule",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 8,
        "manufacturing": 8,
        "safety": 6,
        "transparency": 5,
        "sustainability": 3
      },
      "price": 19.65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804560314565",
      "vsf_explanation": "Same category as Male Health Support Drops but in capsule form. Per Vyvata's brand context on the Vivalo catalog (prior batch flagged Male Health Support Drops as proprietary autofail), this SKU falls into the same category. Male-enhancement supplements without full ingredient disclosure are a documented FDA adulteration risk. Autofailed under proprietary_blend_hides_dose. Rejected at 38.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "saffron-capsules-vitamin-dietary-supplement-capsules",
      "title": "Saffron Capsules Vitamin Dietary Supplement Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/344011f1-367e-4abe-9693-e0633901f85f.jpg?v=1787593251",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "saffron",
        "capsules",
        "vitamin",
        "dietary",
        "supplement",
        "capsules",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 11,
        "manufacturing": 11,
        "safety": 8,
        "transparency": 7,
        "sustainability": 4
      },
      "price": 21.78,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804560412869",
      "vsf_explanation": "Saffron (Crocus sativus stigma) is one of the most impressive-evidence herbal supplements of the past decade — meta-analyses (Lopresti & Drummond 2014; Marx 2019) show effects comparable to SSRIs for mild-to-moderate depression at 30mg/day of standardized extract (saffron stigma extract standardized to crocin/safranal, brand names include Affron, Satiereal). Also evidence for premenstrual syndrome (Ayati 2016), age-related macular degeneration (Falsini 2010), and sexual dysfunction in SSRI users (Kashani 2013). Effective dose is remarkably low — 15-30mg/day of standardized extract, which is why 'saffron gold' pricing works economically. This SKU discloses only 'saffron' with no standardization, no per-cap mg, and no brand-extract identification. Standard 55/100: exceptional evidence base for the ingredient class, held down by no standardization or dose disclosure. Would score higher if Affron/Satiereal extract with 30mg dose disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mao-ruihua-respiratory-health-drops",
      "title": "Mao Ruihua Respiratory Health Drops",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2450d280-fe03-404f-81cd-0b817fb55912.jpg?v=1787593251",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mao",
        "ruihua",
        "respiratory",
        "health",
        "drops",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 8,
        "manufacturing": 8,
        "safety": 6,
        "transparency": 5,
        "sustainability": 3
      },
      "price": 19.22,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804560511173",
      "vsf_explanation": "'Mao Ruihua' is an obscure Chinese brand name; 'respiratory health drops' implies medical claims for lung function. Disclosed ingredients: lung leaf extract, ginger, bromelain, lemon peel, Cordyceps extract. Individual ingredients have variable evidence — Cordyceps for exercise oxygen utilization (some evidence at 3-4g/day of Cs-4), bromelain for inflammation (moderate evidence at 500-1000mg/day), ginger for anti-inflammatory. But 'lung leaf' is not a recognized botanical (may be Lobaria pulmonaria the lichen, or a translation of Chinese medicinal herb name), and drops-format delivery cannot reach effective doses for Cordyceps (grams/day) or bromelain (hundreds of mg). Combined with 'respiratory health' medical implication and obscure brand, autofail under misleading_naming. Rejected at 42.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "fitness-boost-weight-lifting-smelling-salt",
      "title": "Fitness Boost Weight Lifting Smelling Salt",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/dbd07bb4-cc89-42b6-a32b-6effc7811d91_fine.jpg?v=1787593251",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fitness",
        "boost",
        "weight",
        "lifting",
        "smelling",
        "salt",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 6,
        "formulation": 5,
        "manufacturing": 5,
        "safety": 4,
        "transparency": 3,
        "sustainability": 2
      },
      "price": 13.33,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804560347333",
      "vsf_explanation": "Smelling salts (ammonia inhalants) are not a supplement — they are volatile ammonia solutions used pre-lift by strength athletes for a brief sympathetic-nervous-system arousal effect. Ammonia inhalants historically had medical use for reviving fainting patients (obsolete practice), and modern powerlifting/strongman use has some tradition (Bartolomei 2018 small trial showed no ergogenic effect but real acute arousal). But smelling salts fall entirely outside the five Vyvata scored categories (supplements, wearables, diagnostics, sleep, recovery). They are not ingested, they are volatile chemicals, and they are not a category Vyvata evaluates. Autofailed under out_of_scope_for_biohacking. Rejected at 25.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "magnesium-glycinate-drops-1",
      "title": "Magnesium Glycinate Drops",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1026f0f9-a9b5-486f-a439-bc863f01d771.jpg?v=1787593251",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "glycinate",
        "drops",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 13,
        "formulation": 10,
        "manufacturing": 10,
        "safety": 8,
        "transparency": 6,
        "sustainability": 4
      },
      "price": 22.62,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804560445637",
      "vsf_explanation": "Magnesium glycinate in drops format — the same evidence base as Magnesium Glycinate Capsules but a different delivery vehicle. Drops offer fine dose titration but low total mg per volume — reaching 200-400mg elemental magnesium requires substantial drop volume (typically 4-8mL of glycinate liquid = many drops). This makes drops a suboptimal delivery for magnesium at trial-evidenced doses. Vivalo discloses no elemental mg per drop, no drops per serving, and no total mg per bottle. Standard 52/100: real ingredient in an unusual delivery format, held down by no dose disclosure and format-appropriateness questions.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "food-supplement",
      "title": "Food Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/73a5b57e-1740-44f9-a850-ceb83ae77df7.jpg?v=1787593251",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "food",
        "supplement",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 8,
        "formulation": 6,
        "manufacturing": 6,
        "safety": 4,
        "transparency": 4,
        "sustainability": 2
      },
      "price": 22.91,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804560642245",
      "vsf_explanation": "Product title is literally 'Food Supplement' — the European regulatory term (EU Directive 2002/46/EC) for what US regulators call 'dietary supplements.' It's a category name, not a product name. No ingredients disclosed. Autofailed under misleading_naming. Rejected at 30.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "hip-augmentation-dietary-supplement",
      "title": "Hip Augmentation Dietary Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/69b4344d-15c1-481a-9f51-978561a7c70e.jpg?v=1787593251",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hip",
        "augmentation",
        "dietary",
        "supplement",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 8,
        "formulation": 6,
        "manufacturing": 6,
        "safety": 4,
        "transparency": 4,
        "sustainability": 2
      },
      "price": 12.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804560478405",
      "vsf_explanation": "'Hip augmentation' via oral supplement is an unverified medical/cosmetic claim of the highest order. No oral supplement in scientific literature has ever demonstrated targeted fat redistribution or muscle-mass gain in specific body regions from ingested compounds — this is a well-established fact in exercise physiology (spot reduction/enlargement is a myth per Kostek 2007 and decades of body composition research). The disclosed ingredients — the same template block used across Vivalo drops products (TCM extract, gluconic acid lactone, vitamin B1, potassium sorbate, mint) — contain nothing with any hormonal, adipogenic, or myogenic mechanism. Autofailed under unverified_medical_claim. Rejected at 30.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "supplement-drops-for-body-health-regulation",
      "title": "Supplement Drops For Body Health Regulation",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/029ffe62-a3d3-4eda-8af9-25ae350396d8.jpg?v=1787593251",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "supplement",
        "drops",
        "for",
        "body",
        "health",
        "regulation",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 8,
        "formulation": 6,
        "manufacturing": 6,
        "safety": 5,
        "transparency": 4,
        "sustainability": 3
      },
      "price": 17.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804560675013",
      "vsf_explanation": "Generic 'supplement drops for body health regulation' provides no product identification. 'Body health regulation' is vague marketing language — no biological endpoint is defined. Ingredients not disclosed. Autofailed under misleading_naming + proprietary_blend_hides_dose. Rejected at 32.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "vitamin-candidiasis-purification-capsule",
      "title": "Vitamin Candidiasis Purification Capsule",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/025ccbf1-9a74-48d6-a511-2b9a9cfb452a.jpg?v=1787593251",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "candidiasis",
        "purification",
        "capsule",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 8,
        "formulation": 6,
        "manufacturing": 6,
        "safety": 5,
        "transparency": 4,
        "sustainability": 3
      },
      "price": 22.42,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804560543941",
      "vsf_explanation": "'Candidiasis' is a specific medical diagnosis — a fungal infection (Candida albicans or related species) that can be superficial (oral thrush, vaginal candidiasis, skin/nail) or systemic (candidemia, invasive candidiasis). All forms of candidiasis have specific medical treatments (topical antifungals for superficial, oral fluconazole/itraconazole for systemic). Naming a supplement as treatment for a specific diagnosed medical condition without FDA drug approval is textbook unverified_medical_claim. The 'systemic candida' overgrowth concept popular in alternative medicine has weak/absent evidence outside immunocompromised patients. This SKU discloses no ingredients. Autofailed under unverified_medical_claim. Rejected at 32.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "magnesium-citrate-capsules",
      "title": "Magnesium Citrate Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c28363f1-7c54-434b-9d29-66adf1c44384.jpg?v=1787593251",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "citrate",
        "capsules",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 11,
        "manufacturing": 11,
        "safety": 8,
        "transparency": 7,
        "sustainability": 4
      },
      "price": 22.71,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804560740549",
      "vsf_explanation": "Magnesium citrate is one of the two most-bioavailable and best-tolerated oral magnesium forms (see Magnesium Glycinate SKU for the other). Citrate has ~30-40% absorption, mildly laxative effect at higher doses (200mg+ elemental), and is well-studied for constipation, general magnesium supplementation, and migraine prophylaxis. Effective doses: 200-400mg elemental for supplementation; 400-600mg elemental for migraine prophylaxis (Chiu 2016); 500mg+ elemental for osmotic laxative effect. This SKU discloses no elemental mg per cap. Standard 55/100: real ingredient, real form, held down by no dose disclosure and no COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mens-multivitamin-tablet-60-pieces",
      "title": "Men's Multivitamin Tablet 60 Pieces",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1a64960c-7027-4ce0-aabb-ce023b0ee0e2.jpg?v=1787593251",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "men",
        "multivitamin",
        "tablet",
        "pieces",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 13,
        "formulation": 10,
        "manufacturing": 10,
        "safety": 8,
        "transparency": 6,
        "sustainability": 4
      },
      "price": 22.37,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804560707781",
      "vsf_explanation": "Men's multivitamins are a legitimate category with modest evidence for select outcomes. Physicians' Health Study II (Gaziano 2012 JAMA) tracked 14,641 male physicians for 11 years on a daily multivitamin and found a small (8%) reduction in total cancer incidence with no effect on cardiovascular events. Multivitamin evidence for general 'health' or longevity in well-nourished adults is weak. This SKU discloses no ingredient breakdown, no vitamin/mineral doses, and no 'men's' rationale (typically lower iron than women's multi, sometimes with saw palmetto or other prostate-support add-ons). Standard 52/100: legitimate category with weak but real evidence, held down by no ingredient breakdown and no COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ashwagandha-immune-support-capsules-vitamin",
      "title": "Ashwagandha Immune Support Capsules Vitamin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4b95a828-2fbf-4ffe-b072-f8894c24d8dd.jpg?v=1787593251",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ashwagandha",
        "immune",
        "support",
        "capsules",
        "vitamin",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 11,
        "manufacturing": 11,
        "safety": 8,
        "transparency": 7,
        "sustainability": 4
      },
      "price": 22.05,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804560773317",
      "vsf_explanation": "Ashwagandha (Withania somnifera) has substantial evidence for stress, anxiety, and cortisol reduction at 300-600mg/day of standardized extract (KSM-66 or Sensoril brands; standardized to 5% withanolides). Meta-analyses (Pratte 2014; Salve 2019; Lopresti 2019) show consistent moderate effects on perceived stress and anxiety scores. Also some evidence for sleep, muscle recovery, and testosterone in men with low T. 'Immune support' is a less-well-supported indication for ashwagandha — the evidence is primarily on stress-adrenal-cortisol axis, not immune function directly. 'Vitamin' in the name is misleading (ashwagandha is a botanical, not a vitamin). This SKU discloses no standardization, no per-cap mg, and no brand extract. Standard 55/100: strong ingredient evidence base for its actual mechanisms (stress, not immune), held down by wrong-mechanism marketing framing and no dose/standardization disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "tincture-of-annona-prickly-fruit",
      "title": "Tincture Of Annona Prickly Fruit",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/aa8ab1ef-1630-45cf-ac4e-9e4a02046441.jpg?v=1787593251",
      "score": 28,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tincture",
        "annona",
        "prickly",
        "fruit",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 7,
        "formulation": 6,
        "manufacturing": 6,
        "safety": 4,
        "transparency": 3,
        "sustainability": 2
      },
      "price": 17.73,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804560871621",
      "vsf_explanation": "Second Annona-family product in this batch — this one specifically named 'Annona prickly fruit tincture' (Annona muricata, soursop/graviola) at 60ml. See Annona Aceratum Drops SKU for full analysis of the annonacin neurotoxin safety concern documented by Caparros-Lefebvre 1999 (Lancet), Champy 2005, Lannuzel 2008, and formal advisories from EFSA and French ANSES. A tincture (alcohol extract) is even more concentrated for acetogenin content than a fresh whole fruit. Autofailed under safety_concern. Rejected at 28.",
      "vsf_autofail_rule": "safety_concern"
    },
    {
      "handle": "body-massage-gun-electric-exercising-muscle-fascia-gun-heads",
      "title": "Body Massage Gun Electric Exercising Muscle Fascia Gun Heads",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3de25ee3-08fc-4b27-b763-70bc2d628f8a.jpg?v=1787593252",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "body",
        "massage",
        "gun",
        "electric",
        "exercising",
        "muscle",
        "fascia",
        "gun",
        "heads",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 8,
        "formulation": 6,
        "manufacturing": 6,
        "safety": 5,
        "transparency": 4,
        "sustainability": 3
      },
      "price": 180.82,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804560904389",
      "vsf_explanation": "A massage gun is a percussion therapy device — a Cat 2 Recovery & Regeneration product under Vyvata's rubric, not a supplement. Under Cat 2, powered recovery devices without UL/ETL/CE electrical certification autofail. This SKU is a no-brand generic massage gun from CJ Dropshipping with no UL/ETL/CE certification disclosed, no manufacturer identification, no IEC 60601-1 medical device compliance, and no independent parameter verification (percussion amplitude, frequency, torque). Additionally the batch is scored as supplements — under supplements this is out-of-scope. Under either scoring framework, autofail applies. Rejected at 32.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "horseradish-tree-capsules-support-daily-health",
      "title": "Horseradish Tree Capsules Support Daily Health",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/75cc309a-df8a-449c-9382-e5b75c77197b.jpg?v=1787593252",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "horseradish",
        "tree",
        "capsules",
        "support",
        "daily",
        "health",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 12,
        "formulation": 10,
        "manufacturing": 10,
        "safety": 8,
        "transparency": 6,
        "sustainability": 4
      },
      "price": 22.62,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804561952965",
      "vsf_explanation": "'Horseradish tree' is the common English name for moringa (Moringa oleifera) — so named because the roots have a horseradish-like flavor. This is essentially another moringa SKU (see Moringa Leaves Capsules for detailed analysis). Standard 50/100: real ingredient with real evidence for mild glycemic and antioxidant effects, held down by undisclosed per-cap dose, no organic certification, and no heavy-metal COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "female-vitamin-hormone-capsules",
      "title": "Female Vitamin Hormone Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9d5ee53e-a33e-4490-b42c-17c2a4fd5895.jpg?v=1787593254",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "female",
        "vitamin",
        "hormone",
        "capsules",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 8,
        "manufacturing": 8,
        "safety": 6,
        "transparency": 5,
        "sustainability": 3
      },
      "price": 25.03,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804561985733",
      "vsf_explanation": "'Hormone' as an ingredient claim on a supplement is a significant regulatory red flag. FDA does not permit supplements to be marketed as hormone therapy — hormone therapy is a prescription-drug regulatory category (estradiol, progesterone, testosterone, thyroid hormones). Supplements that market as 'hormone' products are either (a) using the word loosely to imply hormone-modulating effects (unverified), or (b) actually containing unlabeled hormones (an FDA adulteration concern that has occurred repeatedly with 'female hormone support' products). Additionally, 'vitamin' + 'hormone' compound naming implies functional overlap that does not exist — vitamins don't work like hormones. This SKU discloses no ingredients. Autofailed under unverified_medical_claim (hormone claim without evidence or disclosed ingredients). Rejected at 38.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "weight-loss-control-drops",
      "title": "Weight Loss Control Drops",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0ead5594-2ea0-48aa-b51f-7884e2a75752.jpg?v=1787593255",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "weight",
        "loss",
        "control",
        "drops",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 8,
        "formulation": 6,
        "manufacturing": 6,
        "safety": 4,
        "transparency": 4,
        "sustainability": 2
      },
      "price": 16.51,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804562051269",
      "vsf_explanation": "Homeopathic weight-loss drops — same category as Slimming Health Boost Drops and Herbal Shaping Health Drops. FTC-enforcement-targeted category. Disclosed 'style' (translation of 'ingredients'): the same template block used across Vivalo drops products — mint, TCM extract, gluconic acid lactone (pH buffer), potassium sorbate (preservative), vitamin B1. Autofailed under unverified_medical_claim. Rejected at 30.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "herbal-supplement",
      "title": "Herbal Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/873b4f9f-517d-4f6b-a112-930430a06fbb.jpg?v=1787593256",
      "score": 36,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "herbal",
        "supplement",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 9,
        "formulation": 7,
        "manufacturing": 7,
        "safety": 5,
        "transparency": 4,
        "sustainability": 3
      },
      "price": 16.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804562084037",
      "vsf_explanation": "Same generic 'Herbal Supplement' title as SKU #27 with no ingredients disclosed. Autofailed under misleading_naming + proprietary_blend_hides_dose. Rejected at 36.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "vitamin-b2-capsule-60-capsules",
      "title": "Vitamin B2 Capsule 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f1acdcc7-0179-4114-896f-b5b880e8d69e.jpg?v=1787593255",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "capsule",
        "capsules",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 11,
        "manufacturing": 11,
        "safety": 8,
        "transparency": 7,
        "sustainability": 4
      },
      "price": 25.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804562116805",
      "vsf_explanation": "Vitamin B2 (riboflavin) is an essential B vitamin with specific evidence for migraine prevention at 400mg/day (Boehnke 2004 Neurology RCT showing 59% reduction in migraine frequency; Schoenen 1998 established the dose). Dietary insufficiency of B2 is rare in Western diets. This SKU is 60 capsules of vitamin B2 with no per-capsule dose disclosed. For migraine prophylaxis the trial-evidenced dose is 400mg/day; RDA is 1.1-1.3mg/day — a 300x difference between deficiency-correction and migraine-therapy dose. Without per-capsule mg, buyers cannot dose intentionally for either use. Standard 55/100: legitimate isolated vitamin with real evidence for a specific therapeutic use, held down by no dose disclosure and no COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "googeer-oral-supplements-body-treatment",
      "title": "Googeer Oral Supplements Body Treatment",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/93bf0692-fc91-4fcd-b41c-e7f944059c1a.jpg?v=1787593256",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "googeer",
        "oral",
        "supplements",
        "body",
        "treatment",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 8,
        "formulation": 6,
        "manufacturing": 6,
        "safety": 5,
        "transparency": 4,
        "sustainability": 3
      },
      "price": 15.24,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804562149573",
      "vsf_explanation": "The listing contains an explicit red flag: 'for export sales only, domestic sales are prohibited, and purchase is equivalent to the default disclaimer.' This is a standard warning phrase for Chinese-domestic-market products that lack regulatory approval for sale within China itself — the Chinese equivalent of a black-market disclaimer. Products carrying this notice have failed to obtain the Chinese CFDA/NMPA approval required for domestic sale, either because ingredients are unapproved, dose exceeds Chinese regulatory limits, or claims cannot be substantiated for Chinese regulators. Selling such products via export to unregulated foreign markets is a known channel for products that would not survive domestic review. Additionally the 'body treatment' + 'oral supplement' framing is category-mixed (oral vs topical). Autofailed under misleading_naming + regulatory-red-flag. Rejected at 32.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "curcumin-turmeric-powder-capsules",
      "title": "Curcumin Turmeric Powder Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fe6ba14a-05b6-466b-ab10-391726e0ca9e.png?v=1787593256",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "curcumin",
        "turmeric",
        "powder",
        "capsules",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 11,
        "manufacturing": 11,
        "safety": 8,
        "transparency": 7,
        "sustainability": 4
      },
      "price": 22.14,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804562182341",
      "vsf_explanation": "Curcumin is the primary polyphenol in turmeric (Curcuma longa) with a substantial evidence base for anti-inflammatory effects at high doses. Meta-analyses show meaningful effects on inflammatory markers (Sahebkar 2016), knee osteoarthritis pain (Daily 2016 vs NSAIDs), depression (Ng 2017), and lipid parameters. The critical issue with plain curcumin capsules is bioavailability — free curcumin has <1% oral bioavailability without a delivery enhancer. Piperine (from black pepper) at 5-20mg increases curcumin bioavailability up to 20x (Shoba 1998); other enhanced forms include Meriva (phytosome), BCM-95, Longvida (nanoparticle), and Theracurmin. Plain turmeric powder or raw curcumin without a bioavailability enhancer will be largely unabsorbed. This SKU discloses 'curcumin turmeric powder' without piperine, bioavailability enhancer, or per-capsule mg. Standard 55/100: real ingredient with real evidence for high-dose use, held down by likely poor bioavailability (no enhancer disclosed), no dose, no COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fish-oil-and-vitamin-e-softcapsules",
      "title": "Fish Oil And Vitamin E Softcapsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3e04bcf8-797f-4115-b80d-efb53168f082.jpg?v=1787593255",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fish",
        "oil",
        "and",
        "vitamin",
        "softcapsules",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 11,
        "manufacturing": 11,
        "safety": 8,
        "transparency": 7,
        "sustainability": 4
      },
      "price": 30.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804562215109",
      "vsf_explanation": "Fish oil + vitamin E is a common and rational combination — vitamin E (as mixed tocopherols or alpha-tocopherol) is added to fish oil products both to prevent oxidation in the capsule and to support vitamin E status. Vitamin E at 15-30 IU/day meets RDA; higher doses (400+ IU/day) are not recommended and have been associated with slightly increased mortality in some trials (Miller 2005 meta-analysis). For evidence on fish oil see Fish Oil Soft Capsule SKU. This SKU discloses no EPA/DHA breakdown, no vitamin E form/dose, and no per-capsule mg. Standard 55/100: real ingredient combination, held down by no dose disclosure and no COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "maca-capsule",
      "title": "Maca Capsule",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/03dc488b-d157-4820-a994-b2d85eb11b2c.jpg?v=1787593256",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood",
        "energy",
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "maca",
        "capsule",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 12,
        "formulation": 10,
        "manufacturing": 10,
        "safety": 8,
        "transparency": 6,
        "sustainability": 4
      },
      "price": 18.86,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804562280645",
      "vsf_explanation": "Maca (Lepidium meyenii) — see Maca Nursing Capsules SKU for full analysis. This is the same botanical in a plain-capsule format without the 'nursing' framing ambiguity. Standard 50/100: real ingredient with moderate evidence for female sexual function and perimenopausal support, held down by undisclosed color/type, undisclosed dose, and no COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "complex-vitamin-b-gummies",
      "title": "Complex Vitamin B Gummies",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8a3d168d-0100-437a-aad9-5d683d414dae.jpg?v=1787593257",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "complex",
        "vitamin",
        "gummies",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 12,
        "formulation": 10,
        "manufacturing": 10,
        "safety": 8,
        "transparency": 6,
        "sustainability": 4
      },
      "price": 24.21,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804562313413",
      "vsf_explanation": "B-complex gummies are a legitimate format for vitamins that are heat-stable and water-soluble. The tradeoff is (a) sugar load (2-4g per gummy typical), (b) usually lower per-serving vitamin doses than capsules or tablets (limited by gummy size), and (c) folic acid rather than methylfolate in most cheap gummies. B-complex evidence is strong for correcting dietary insufficiency in specific populations (see Vitamin B Capsules SKU). This SKU discloses no per-gummy vitamin breakdown, no vitamer forms, and no sugar content. Standard 50/100: real ingredient class, gummy format has real tradeoffs, held down by no disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "googeer-brain-health-drops-body-treatment",
      "title": "Googeer Brain Health Drops Body Treatment",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a08a5c6c-fd41-47b8-99ae-e242f0aa4b67.jpg?v=1787593257",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "googeer",
        "brain",
        "health",
        "drops",
        "body",
        "treatment",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 8,
        "manufacturing": 8,
        "safety": 6,
        "transparency": 5,
        "sustainability": 3
      },
      "price": 17.81,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804562346181",
      "vsf_explanation": "Product title 'Googeer Brain Health Drops Body Treatment' is confusing — 'brain health drops' and 'body treatment' describe different use categories (oral cognitive supplement vs topical body product). The disclosed ingredients — Pseudoportulaca oleracea extract, ginseng root extract, Ginkgo biloba extract, Hericium erinaceus (Lion's Mane), L-theanine — are legitimate cognitive/nootropic ingredients but the mixed 'brain vs body' framing raises whether this is oral or topical. Without per-drop dosing for any ingredient, and with 'Googeer' being an obscure Chinese brand name, autofail applies under misleading_naming (product category ambiguity + brand obscurity). Rejected at 42.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "in-stock-capsules-of-magnesium-methionine-vitamin",
      "title": "In Stock Capsules Of Magnesium Methionine Vitamin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e9c970b2-73c2-41c6-bbd5-74f0b9538c50.jpg?v=1787593258",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "stock",
        "capsules",
        "magnesium",
        "methionine",
        "vitamin",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 12,
        "formulation": 10,
        "manufacturing": 10,
        "safety": 7,
        "transparency": 6,
        "sustainability": 4
      },
      "price": 25.1,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804562444485",
      "vsf_explanation": "Magnesium + methionine + vitamin(s) is an unusual combination. Magnesium has strong evidence (see Magnesium Glycinate SKU); methionine is an essential sulfur amino acid, precursor to SAM-e and glutathione; the 'vitamin' component is undisclosed. Combining magnesium with methionine is not a standard evidence-based formulation — the closest evidenced combination would be magnesium + B6 for PMS/mood, or magnesium + malate for fibromyalgia. 'In Stock' as part of the title suggests machine-copied inventory language, not intentional product naming. Standard 48/100 near the Rejected boundary: real ingredient category but scattershot combination with no dose disclosure and awkward naming.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "rhodiola-rosea-capsules",
      "title": "Rhodiola Rosea Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cfbcbcad-526d-471b-82cf-f7ad575a54ae.jpg?v=1787593258",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "rhodiola",
        "rosea",
        "capsules",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 11,
        "manufacturing": 11,
        "safety": 8,
        "transparency": 7,
        "sustainability": 4
      },
      "price": 20.2,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804562542789",
      "vsf_explanation": "Rhodiola rosea is an adaptogen with moderate evidence for mental fatigue, stress-related exhaustion, and mild-to-moderate depression. Panossian 2010 systematic review found consistent effects on fatigue and cognitive function in stressed individuals at 200-600mg/day of standardized SHR-5 extract (3% rosavins, 1% salidroside). Effects are small-to-moderate but reproducible. This SKU discloses only 'Rhodiola Rosea' without extract standardization, per-capsule mg, or source authentication. Rhodiola is a globally-common substitution target — cheaper Rhodiola crenulata is often sold as R. rosea, and the two species have different chemistry (rosavins are near-absent in crenulata). Standard 55/100: real ingredient with real evidence, held down by no standardization disclosure, no per-cap dose, no species-authentication statement.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "citrulline-arginine-capsules",
      "title": "Citrulline-arginine Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5b419def-d902-41b0-b600-3aba92cc0106.jpg?v=1787593258",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "citrulline",
        "arginine",
        "capsules",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 12,
        "manufacturing": 12,
        "safety": 9,
        "transparency": 7,
        "sustainability": 5
      },
      "price": 21.72,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804562510021",
      "vsf_explanation": "L-citrulline and L-arginine are both nitric-oxide (NO) precursors used in sports supplementation for vasodilation ('pump'), endurance, and mild blood-pressure effects. L-citrulline has better oral bioavailability than L-arginine (arginine is degraded by intestinal arginase; citrulline is not, and is then converted to arginine in the kidneys, producing higher and more sustained plasma arginine than direct arginine supplementation — Schwedhelm 2008). Effective doses: L-citrulline 6-8g/day (as citrulline malate 8-10g), or L-arginine 3-6g/day. Combined citrulline+arginine is redundant biologically (citrulline becomes arginine), but marketing-common. This SKU discloses no per-capsule mg for either ingredient. Standard 58/100: real ingredients with real evidence for their claimed uses, held down by undisclosed doses.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "amino-acid-energy-soft-candy",
      "title": "Amino Acid Energy Soft Candy",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f88f75c6-41f4-4342-b4d0-31cd5bee4c75.jpg?v=1787593258",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "amino",
        "acid",
        "energy",
        "soft",
        "candy",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 11,
        "formulation": 9,
        "manufacturing": 9,
        "safety": 7,
        "transparency": 5,
        "sustainability": 4
      },
      "price": 21.63,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804562641093",
      "vsf_explanation": "Amino acid + caffeine soft candies (gummies) are a legitimate delivery format for pre-workout supplementation. The problem with candy formats is (a) sugar load per serving (2-6g typical), (b) subtherapeutic amino acid doses that fit in a small gummy (usually 100-500mg per piece, well below the 5-10g EAA or 6-8g citrulline used in trials), and (c) caffeine content variability. This SKU discloses no ingredients, no amino acid identity, no caffeine content, and no per-piece doses. Without ingredient disclosure, this cannot be scored as anything but a candy product with vague health claims. Standard 45/100 near the Rejected boundary: the format has legitimate uses but the SKU discloses essentially nothing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "male-health-support-drops-1",
      "title": "Male Health Support Drops",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/99512ebb-9578-4e24-8a5a-e3f3fa211e22.jpg?v=1787593259",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "male",
        "health",
        "support",
        "drops",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 9,
        "formulation": 7,
        "manufacturing": 7,
        "safety": 5,
        "transparency": 4,
        "sustainability": 3
      },
      "price": 17.81,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804562673861",
      "vsf_explanation": "Male-enhancement/health-support drops with no ingredients disclosed. Per Vyvata's brand context on this Vivalo catalog (prior batch flagged Male Health Support Drops as proprietary autofail), this SKU falls into the same category. Male-enhancement supplements without full disclosure are a documented FDA adulteration risk category — hundreds of FDA warnings for undisclosed sildenafil/tadalafil in men's-health supplements. Autofailed under proprietary_blend_hides_dose. Rejected at 35.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "capsule",
      "title": "Capsule",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0ff74ecf-4019-4be1-b698-9b1766f32309.jpg?v=1787593259",
      "score": 28,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "capsule",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 7,
        "formulation": 6,
        "manufacturing": 6,
        "safety": 4,
        "transparency": 3,
        "sustainability": 2
      },
      "price": 28.87,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804562739397",
      "vsf_explanation": "Product title is literally the word 'Capsule.' Not a name, not a description — just the dosage form. Zero information about ingredients, dose, or intended use. Autofailed under misleading_naming. Rejected at 28.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "60-simple-household-cleaning-capsules",
      "title": "60 Simple Household Cleaning Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/70db6c48-7690-4544-9b63-5d4957f8cb15.jpg?v=1787593259",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "simple",
        "household",
        "cleaning",
        "capsules",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 6,
        "formulation": 5,
        "manufacturing": 5,
        "safety": 4,
        "transparency": 3,
        "sustainability": 2
      },
      "price": 31.56,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804562837701",
      "vsf_explanation": "This is a household cleaning product — laundry or dishwasher detergent pods — not a supplement. The listing describes 'cleansing capsule' at 60 count/2 boxes for household cleaning, with no oral-consumption intent whatsoever. The word 'capsule' here refers to a single-use detergent pod, the same product category that has been the subject of poison-control alerts for the past decade because young children mistake them for candy (over 12,000 US Poison Control calls per year for detergent pod ingestion, per AAPCC data). Miscategorization on Vivalo's storefront as a supplement is not just an error — it's a potentially dangerous listing that could increase accidental ingestion risk. Autofailed under out_of_scope_for_biohacking with an added safety flag: household cleaning products should never appear in a supplement search. Rejected at 25.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "dietary-supplement-capsules-for-oral-use",
      "title": "Dietary Supplement Capsules For Oral Use",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0e9ab8fb-189a-48eb-b0eb-b863c5e69cc7.jpg?v=1787593260",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dietary",
        "supplement",
        "capsules",
        "for",
        "oral",
        "use",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 8,
        "formulation": 6,
        "manufacturing": 6,
        "safety": 5,
        "transparency": 4,
        "sustainability": 3
      },
      "price": 19.01,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804562936005",
      "vsf_explanation": "The product title is a compound of regulatory-category words: 'Dietary Supplement' + 'Capsules' + 'For Oral Use.' Every one of these is a category descriptor, not a product identity. Every capsule supplement is a dietary supplement in capsule form for oral use — the title contains zero identifying information. No ingredients disclosed. Autofailed under misleading_naming + proprietary_blend_hides_dose. Rejected at 32.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "nicotinamide-mononucleotide-capsules",
      "title": "Nicotinamide Mononucleotide Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2470a44c-3baf-403e-94fd-8a289b7e382b.jpg?v=1787593259",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nicotinamide",
        "mononucleotide",
        "capsules",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 8,
        "formulation": 6,
        "manufacturing": 6,
        "safety": 5,
        "transparency": 4,
        "sustainability": 3
      },
      "price": 20.07,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804562968773",
      "vsf_explanation": "The product title advertises 'Nicotinamide Mononucleotide Capsules' — NMN, the widely-hyped NAD+ precursor with substantial celebrity-longevity marketing (Sinclair, Bryan Johnson) and modest human evidence. But the body copy discloses the actual main raw material as L-tyrosine — an amino acid precursor to catecholamines with completely different biology. This is a title-to-ingredient mismatch of the worst kind: buyers pay for NMN (a high-cost novel longevity supplement at ~$1-3 per gram of Uthever-branded NMN) and receive L-tyrosine (a low-cost amino acid at ~$0.05-0.20 per gram). Whether this is intentional deception or catalog error is unclear, but the listing as-is is unacceptable. Autofailed under misleading_naming (product title materially differs from disclosed ingredient). Rejected at 32.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "dongge-ali-capsule-60-capsules",
      "title": "Dongge Ali Capsule 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d1e5f574-1da9-428b-a612-2e176b99f31b.jpg?v=1787593259",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dongge",
        "ali",
        "capsule",
        "capsules",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 12,
        "formulation": 10,
        "manufacturing": 10,
        "safety": 8,
        "transparency": 6,
        "sustainability": 4
      },
      "price": 23.7,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804563034309",
      "vsf_explanation": "'Dongge Ali' is a Chinese-market transliteration of Tongkat Ali (Eurycoma longifolia jack), a Southeast Asian botanical with moderate evidence for testosterone support in men with low-normal T (Tambi 2012 showed 200mg/day of standardized tongkat root extract for one month increased serum T by ~46% in hypogonadal men), stress-cortisol modulation (Talbott 2013), and libido. Effective doses in trials use a standardized extract (typically Physta 100:1 or LJ100), not raw root powder. This SKU discloses only 'Dongge Ali' as main raw material with no extract ratio, no standardization, no per-capsule mg. The Chinese-transliterated name is a mild transparency red flag but not fatal. Standard 50/100: real ingredient with real evidence, held down by no dose, no extract disclosure, no COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "active-probiotics-supplement",
      "title": "Active Probiotics Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e977d75b-0a0b-4b6f-af19-4fad70afbe1a_fine.jpg?v=1787593262",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "active",
        "probiotics",
        "supplement",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 8,
        "manufacturing": 8,
        "safety": 6,
        "transparency": 5,
        "sustainability": 3
      },
      "price": 36.66,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804563067077",
      "vsf_explanation": "Generic 'active probiotics' with no strain identification, no CFU count, and no delivery-form disclosure (enteric-coated vs bare capsule). See earlier Probiotic Extract Capsules For Women analysis for full probiotic-scoring rationale. 'Active' is a marketing modifier of no clinical significance (all commercially-marketed probiotics are, by definition, marketed as active/live). Autofailed under proprietary_blend_hides_dose. Rejected at 42.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "resveratrol-sleep-supplement-capsules-for-men",
      "title": "Resveratrol Sleep Supplement Capsules For Men",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9510c369-ea1d-4740-ad37-4703aa4856fd.jpg?v=1787593261",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "cardiovascular",
        "sleep"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "resveratrol",
        "sleep",
        "supplement",
        "capsules",
        "for",
        "men",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 8,
        "manufacturing": 8,
        "safety": 6,
        "transparency": 5,
        "sustainability": 3
      },
      "price": 23.56,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804563165381",
      "vsf_explanation": "Resveratrol has an equivocal evidence base — early enthusiasm (Sinclair sirtuin-activation hypothesis, animal longevity models) has been tempered by disappointing human trials at typical doses (100-500mg/day). It has small effects on inflammatory markers (Poulsen 2013 meta-analysis) and some vascular endpoints, but no established evidence for sleep. The 'sleep supplement' claim for resveratrol is not supported by clinical trials — the compound has no known GABA-ergic, melatonergic, or otherwise sedative mechanism. The 'for men' qualifier is arbitrary — resveratrol has no sex-specific evidence. Combining a compound with weak evidence for one endpoint (resveratrol for antioxidant/vascular) with a claim it has no evidence for (sleep) is a marketing pattern designed to capture multiple search categories. Standard tier at 42, near the Rejected boundary: real ingredient with weak but real evidence for its actual use cases, but the 'sleep supplement' claim is unverified and the 'for men' qualifier is meaningless.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "womens-curmonitol-capsules-with-folic-acid",
      "title": "Women's Curmonitol Capsules With Folic Acid",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/891f28e4-cc50-483c-9da0-e1966b60676d.jpg?v=1787593261",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "women",
        "curmonitol",
        "capsules",
        "with",
        "folic",
        "acid",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 12,
        "formulation": 10,
        "manufacturing": 10,
        "safety": 8,
        "transparency": 6,
        "sustainability": 4
      },
      "price": 39.03,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804563263685",
      "vsf_explanation": "'Curmonitol' appears to be a corruption or transliteration — the intended ingredient is likely myo-inositol or a curcumin+inositol combination, given the 'with folic acid' and 'women's' framing which aligns with the standard PCOS supplementation triad of myo-inositol + D-chiro-inositol + folic acid (per Facchinetti 2015 protocol). If the product is genuinely inositol + folate for PCOS/fertility support, this represents a legitimate combination. But the misspelling/mistranslation of the primary ingredient is a real transparency failure and no per-cap doses are disclosed. Standard 50/100: probable legitimate PCOS-support blend, held down by ambiguous ingredient naming and no dose disclosure. Folate at appropriate doses (400-800 mcg/day of folic acid or 800-1000 mcg/day of L-methylfolate) is standard preconception nutrition supported by USPSTF.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "60ml-methyl-folic-acid-drops",
      "title": "60ml Methyl Folic Acid Drops",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/40e69919-99fd-42d7-a99d-ee5dcedeaee0.jpg?v=1787593262",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "60ml",
        "methyl",
        "folic",
        "acid",
        "drops",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 11,
        "manufacturing": 11,
        "safety": 8,
        "transparency": 7,
        "sustainability": 4
      },
      "price": 19.73,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804563427525",
      "vsf_explanation": "L-methylfolate (5-MTHF, the active reduced form of folate) is a legitimate supplement — preferred over synthetic folic acid for people with MTHFR variants (~40% of the population have one variant that reduces folate conversion efficiency, ~10% have two variants with substantially reduced conversion). Methylfolate is used in preconception nutrition, treatment-resistant depression as adjunct (Deplin at 7.5-15mg/day), and elderly with poor folate metabolism. Drops format allows fine dose titration. Effective doses: 400-800 mcg/day for general/preconception; 1-15mg/day for specific psychiatric or hematologic indications. This SKU is 60ml drops but discloses no mcg per drop and no vehicle (glycerin, water, or oil). Standard 55/100: real ingredient in a real format, held down by no dose disclosure and no COA. The methylfolate active form choice is itself a positive quality indicator vs cheaper folic acid.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "maca-nursing-capsules",
      "title": "Maca Nursing Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/884893a7-655c-4941-a13b-b98d8f934fe5.jpg?v=1787593262",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood",
        "energy",
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "maca",
        "nursing",
        "capsules",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 12,
        "formulation": 10,
        "manufacturing": 10,
        "safety": 7,
        "transparency": 6,
        "sustainability": 4
      },
      "price": 26.56,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804563296453",
      "vsf_explanation": "Maca (Lepidium meyenii) is a Peruvian cruciferous root with a moderate evidence base for female sexual function (Dording 2015 antidepressant-induced sexual dysfunction, small RCT), some evidence for perimenopausal symptoms (Meissner 2006), and mixed evidence for libido and fertility. The 'nursing' framing in the title is concerning — 'nursing' typically refers to breastfeeding/lactation, and maca is NOT recommended during breastfeeding (limited safety data, potential hormone-modulating effects). If 'nursing' here means 'nurturing/care' (poor translation), the ambiguity is a labeling failure. If it genuinely markets to breastfeeding women, it's a safety-inappropriate claim. Additionally, maca's active glucosinolate content varies enormously by species (red, yellow, black maca have different clinical uses per traditional use) and extraction method; this SKU does not disclose color/type or dose. Standard 48/100 near the Rejected threshold: real ingredient with real evidence for specific women's-health uses, but the 'nursing' framing ambiguity and no ingredient specifications keep it low.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sleep-melatonin-drops",
      "title": "Sleep Melatonin Drops",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/087aa25e-59c7-42e9-8f6d-b685b0ff591d.jpg?v=1787593263",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sleep",
        "melatonin",
        "drops",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 11,
        "formulation": 9,
        "manufacturing": 9,
        "safety": 7,
        "transparency": 5,
        "sustainability": 4
      },
      "price": 13.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804563493061",
      "vsf_explanation": "Melatonin as an isolated ingredient is a legitimate sleep supplement — meta-analyses (Ferracioli-Oda 2013 PLoS ONE, Auld 2017 Sleep Med Rev) show small effects on sleep onset latency (~7 min faster) and total sleep time (~8 min longer) at 0.5-5mg doses taken 30-60 min before bed. Higher doses are not better and often worse (rebound insomnia). The critical issue with this SKU: melatonin is buried in a mixed formula ('mint leaf extract, traditional Chinese medicine extract, gluconic acid lactone, potassium sorbate, vitamin B1, melatonin') where the melatonin dose is not disclosed and the unnamed TCM extract could contain sedating botanicals with pharmacological interactions. The identical base ingredient block appears on multiple other Vivalo 'drops' products in this batch (Weight Loss Control Drops, Hip Augmentation, Herbal Shaping) — confirming this is a single template formula with melatonin added. Autofailed under proprietary_blend_hides_dose (unnamed TCM extract) + melatonin dose not disclosed. Rejected at 45.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "fish-oil-soft-capsule-lemon-flavor",
      "title": "Fish Oil Soft Capsule Lemon Flavor",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9f67db7a-f73b-44e9-8ef1-1cc5e80813d9_fine.jpg?v=1787593263",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fish",
        "oil",
        "soft",
        "capsule",
        "lemon",
        "flavor",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 11,
        "manufacturing": 11,
        "safety": 8,
        "transparency": 6,
        "sustainability": 4
      },
      "price": 24.41,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804563525829",
      "vsf_explanation": "Fish oil (see earlier 'Soft Capsules' analysis for full evidence review). This SKU is slightly better than the earlier fish oil listing because it names the product ('Fish Oil Soft Capsule') rather than just 'Soft Capsules,' and the lemon flavoring is a light indicator of oxidation-management effort (rancid fish oil tastes/smells fishy; lemon flavoring is commonly added to mask early oxidation but a fresh oil should not need heavy masking). Standard 54/100 — real ingredient category, held down by no EPA/DHA breakdown, no source-fish disclosure, no TOTOX oxidation testing, no per-capsule mg or omega-3 percentage.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mens-body-nutrition-drops",
      "title": "Men's Body Nutrition Drops",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/77404246-c8e2-4d9b-8595-8a6fc1901e2b.jpg?v=1787593264",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "men",
        "body",
        "nutrition",
        "drops",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 8,
        "manufacturing": 8,
        "safety": 6,
        "transparency": 5,
        "sustainability": 3
      },
      "price": 12.06,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804563558597",
      "vsf_explanation": "Generic 'men's body nutrition' drops with no disclosed ingredients. The 'men's' framing typically signals male-enhancement or testosterone-support positioning, but without ingredient disclosure the product cannot be evaluated. Autofailed under proprietary_blend_hides_dose. Given the pattern in the Vivalo batch context of undisclosed male-enhancement products triggering autofail (per Vyvata's brand context notes on Male Health Support Drops and Epimedium Male Healthy Capsule), this SKU falls into the same category. Rejected at 40.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "vitamin-saw-palmetto-drops",
      "title": "Vitamin Saw Palmetto Drops",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/053d8212-96b2-479d-9017-d52b1b81382b.jpg?v=1787593265",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "saw",
        "palmetto",
        "drops",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 12,
        "formulation": 10,
        "manufacturing": 10,
        "safety": 8,
        "transparency": 6,
        "sustainability": 4
      },
      "price": 24.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804563820741",
      "vsf_explanation": "Saw palmetto (Serenoa repens) is one of the most-studied herbal supplements for benign prostatic hyperplasia (BPH), with a moderate evidence base. Early trials suggested benefit (Wilt 1998 meta-analysis) but larger and more rigorous trials showed less benefit (Barry 2011 CAMUS trial, JAMA, found saw palmetto 320-960mg/day equivalent to placebo for lower urinary tract symptoms). The current consensus is that saw palmetto has small effects on LUTS at 320mg/day of the standardized lipidosterolic extract, comparable to lifestyle modification but inferior to alpha-blockers or 5-alpha-reductase inhibitors for moderate-to-severe BPH. Drops format for saw palmetto is unusual — the evidence is primarily on the lipidosterolic extract (Permixon, Serenoa berry extract) delivered in capsules at 320mg/day. Vivalo does not disclose extraction ratio, standardization, or per-drop dose. Standard 50/100: real ingredient with moderate evidence for a narrow use case, held down by format uncertainty and no dose disclosure. Adding 'vitamin' to the name is misleading — no vitamins are disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-d-drop",
      "title": "Vitamin D Drop",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/bdafc1e2-ecc1-4846-a23a-a5d88cb897d7_fine.jpg?v=1787593265",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "drop",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 12,
        "manufacturing": 12,
        "safety": 9,
        "transparency": 7,
        "sustainability": 5
      },
      "price": 21.58,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804563853509",
      "vsf_explanation": "Vitamin D3 (cholecalciferol) is one of the best-evidenced supplements in nutrition science. The Endocrine Society (Holick 2011 guidelines), IOM, and multiple meta-analyses agree that supplementation is warranted in verified deficiency (25-OH vitamin D <30 ng/mL affects 40-70% of the US population depending on latitude, season, and race). Drops (liquid vitamin D3 in an oil vehicle) is a legitimate and even preferred format — fat-soluble vitamins benefit from lipid delivery, and drops permit precise dose titration (typical concentrations: 1000-2000 IU per drop). Effective daily doses: 1000-2000 IU/day for general health in most adults; 4000-5000 IU/day for correction of deficiency under lab monitoring; up to 10,000 IU/day short-term for severe deficiency. This SKU does not disclose IU per drop, oil vehicle (MCT vs olive vs coconut), or vitamin D2 vs D3 form. Standard 58/100: strong ingredient evidence, appropriate format, held from Verified only by missing IU-per-drop disclosure and form specification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "biyode-wholesale-acetyl-l-carnitine-gummiegel-gummies-natural-daily-brain-wellness-supplement",
      "title": "Biyode Wholesale Acetyl L-Carnitine Gummiegel Gummies Natural Daily Brain Wellness Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/802d0dc9-a64a-4b11-a34b-476717f92ef9.jpg?v=1787593265",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "biyode",
        "wholesale",
        "acetyl",
        "carnitine",
        "gummiegel",
        "gummies",
        "natural",
        "daily",
        "brain",
        "wellness",
        "supplement",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 13,
        "formulation": 10,
        "manufacturing": 10,
        "safety": 8,
        "transparency": 6,
        "sustainability": 4
      },
      "price": 29.67,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804563886277",
      "vsf_explanation": "Acetyl-L-carnitine (ALCAR) is a real cognitive/energy supplement with moderate evidence for age-related cognitive decline and depression in older adults (Malaguarnera 2007, Am J Clin Nutr; Wang 2014 meta-analysis for depression). It also has modest evidence for peripheral neuropathy (particularly diabetic and chemotherapy-induced). Effective trial doses: 1500-3000mg/day, typically split into 500-1000mg 2-3x/day. Gummy format is a problematic delivery vehicle for ALCAR: (a) each gummy typically holds 100-300mg of active — reaching 1.5-3g/day requires 5-30 gummies; (b) gummies contain 2-4g sugar per piece — 30 gummies is 60-120g of added sugar, comparable to soda; (c) heat-processing gummy manufacture can degrade heat-sensitive amino acid conjugates like ALCAR. 'Biyode' is a generic Chinese OEM brand. Standard 52/100: real ingredient with real evidence, held down by gummy-format subtherapeutic dosing and sugar load, and no per-gummy mg disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "metabolic-balance-health-explosion-bead",
      "title": "Metabolic Balance Health Explosion Bead",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d4b2bba2-93a2-4b03-a7e7-510f6fac7176.jpg?v=1787593265",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "metabolic",
        "balance",
        "health",
        "explosion",
        "bead",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 8,
        "formulation": 6,
        "manufacturing": 6,
        "safety": 4,
        "transparency": 4,
        "sustainability": 2
      },
      "price": 16.88,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804563951813",
      "vsf_explanation": "This is a topical product — not an oral supplement. The ingredient list ('bee venom, mint leaves; inactive ingredients: water, glycerin, mineral oil, glycerol stearate, 1,2-hexanediol, carbomer, triethanolamine, allantoin') is a cosmetic formulation, not a supplement — carbomer, glyceryl stearate, and triethanolamine are cream/gel emulsifiers, mineral oil is a topical emollient, and allantoin is a topical soothing agent. 'Blasting beads' is a topical cosmetic format (bath/shower beads or single-use topical pods). The product does not belong in a supplement category. Autofailed under out_of_scope_for_biohacking. Rejected at 30.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "spirulina-capsules-120-capsules",
      "title": "Spirulina Capsules 120 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f6f9d6ec-916b-4af7-bc12-b48a9c1c9b1e.jpg?v=1787593307",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "spirulina",
        "capsules",
        "120",
        "capsules",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 11,
        "manufacturing": 11,
        "safety": 8,
        "transparency": 7,
        "sustainability": 4
      },
      "price": 28.25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804564541637",
      "vsf_explanation": "Spirulina (Arthrospira platensis and A. maxima) is a cyanobacterium with a long food-use history and legitimate evidence for lipid modulation (Serban 2016 meta-analysis showed 46 mg/dL LDL reduction and 42 mg/dL triglyceride reduction with 1-10g/day), and small effects on blood pressure and glycemic markers. It's also nutrient-dense — high in protein, iron, B vitamins, phycocyanin (a pigment with antioxidant activity). The critical safety issue with spirulina is contamination risk: (a) heavy metals from growing water, (b) microcystin (a hepatotoxin) contamination when cross-contaminated with wild Microcystis cyanobacteria — this has caused documented spirulina product recalls. Only spirulina grown in monoculture-controlled ponds with per-batch microcystin testing is safe for daily use. This SKU is 120 capsules of unspecified origin with no dose per cap, no origin disclosure, and no microcystin testing statement. Standard 55: real ingredient with real evidence, held down by no dose disclosure, no origin/contamination testing, no COA. Would need to be scored lower without the ingredient's genuine evidence base.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "seaweed-compound-vitamin-capsules",
      "title": "Seaweed Compound Vitamin Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/591a530b-a9b3-46f6-b7b4-1e450d7b1b8e.jpg?v=1787593307",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "seaweed",
        "compound",
        "vitamin",
        "capsules",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 12,
        "formulation": 10,
        "manufacturing": 10,
        "safety": 7,
        "transparency": 6,
        "sustainability": 4
      },
      "price": 24.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804564574405",
      "vsf_explanation": "Seaweed (kelp, kombu, wakame, nori, etc.) is a legitimate iodine source and provides trace minerals. But iodine content in commercial kelp products is famously variable and often excessive: US FDA analysis found some kelp supplements contain 500-3000% of the RDA per capsule, and this can cause iodine-induced hyperthyroidism (Jod-Basedow phenomenon), especially in people with autonomous thyroid nodules. Zava et al. (2011) documented multiple case reports of kelp-induced thyrotoxicosis. Additionally, some seaweeds concentrate arsenic (particularly hijiki, which has documented inorganic arsenic content exceeding safe intake limits). This SKU is generic 'seaweed compound vitamin' with no species disclosure, no iodine content per cap, and no arsenic testing. 'Compound Vitamin' implies co-formulated vitamins that are undisclosed. Standard 48/100: seaweed is a real ingredient with real (mainly iodine) nutritional value, but the variability and safety concerns push this near the Rejected threshold. Iodine supplementation should be dose-calibrated, not consumed via undisclosed kelp products.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "herbal-supplement-1",
      "title": "Herbal Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/09a459fc-c627-464a-98c4-8ef413fc698e.jpg?v=1787593307",
      "score": 36,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "herbal",
        "supplement",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 9,
        "formulation": 7,
        "manufacturing": 7,
        "safety": 5,
        "transparency": 4,
        "sustainability": 3
      },
      "price": 11.86,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804564607173",
      "vsf_explanation": "Product titled literally 'Herbal Supplement' — same category-as-name failure as 'Dietary Supplement' and 'Capsule.' No ingredients disclosed. Autofailed under misleading_naming + proprietary_blend_hides_dose. Rejected at 36.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "creatine-monohydrate-original-flavor-powder-270g",
      "title": "Creatine Monohydrate Original Flavor Powder 270g",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/80e3f512-bb96-4560-9f20-d9b7f9107a6d.jpg?v=1787593318",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "creatine",
        "monohydrate",
        "original",
        "flavor",
        "powder",
        "270g",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 16,
        "formulation": 12,
        "manufacturing": 12,
        "safety": 9,
        "transparency": 7,
        "sustainability": 5
      },
      "price": 30.51,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804564803781",
      "vsf_explanation": "Creatine monohydrate is the single most-studied ergogenic supplement in human sports nutrition, with 1,000+ trials and the ISSN's 2017 position stand (Kreider et al.) affirming safety and efficacy for strength, power output, and lean-mass accrual at ~3-5g/day loading- or maintenance-dosed. This SKU is a straightforward 270g powder in original (unflavored) form from Vivalo, a CJ Dropshipping-affiliated reseller of generic OEM Chinese manufacture. The evidence base for the ingredient class is unambiguously strong (TIER-A). What holds the score down and prevents any Verified-tier consideration: (1) Vivalo does not disclose the source manufacturer, purity grade, or whether the powder is Creapure-branded (the industry benchmark for pharmaceutical-grade German creatine); (2) no per-lot third-party certificate of analysis is published for identity, heavy metals (a documented concern with cheaper Chinese creatine sources), or contaminating creatinine/dicyandiamide; (3) the label does not disclose per-serving dose or scoop size, forcing users to self-measure a compound where under-dosing at <3g/day produces no measurable strength benefit and over-dosing at >10g/day causes GI distress. Placed at 62 on the Standard band: the ingredient earns its way onto the platform on evidence grounds; the SKU's opacity and generic OEM sourcing keep it from the Verified tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-b-capsules",
      "title": "Vitamin B Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/af59df0f-f30d-4842-9ec1-40dd6a1b9648.jpg?v=1787593319",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "capsules",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 11,
        "manufacturing": 11,
        "safety": 8,
        "transparency": 7,
        "sustainability": 4
      },
      "price": 27.41,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804564836549",
      "vsf_explanation": "A generic 90-count B-vitamin capsule from Vivalo with no disclosed formulation. The listing does not specify which B vitamins are included (B1/B2/B3/B5/B6/B7/B9/B12), what form (folic acid vs methylfolate, cyanocobalamin vs methylcobalamin), or per-serving milligrams for any of them. B-complex products can be legitimate and useful — deficiencies in B12 and folate are common in vegans, older adults, and those on metformin or PPIs — but a scored evaluation requires knowing what is in the bottle. On evidence grounds the ingredient class scores TIER-A for named deficiencies (Kennedy 2016 review, Nutrients); on this SKU's own disclosure it earns baseline credit for being a real supplement category with real utility, but no more. Held at 55 on the Standard band because the ingredient category is legitimate but transparency is minimal — no B-vitamer breakdown, no bioactive-form specification, no dose disclosure, no COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "soft-capsules",
      "title": "Soft Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1934779613721137152.jpg?v=1787593319",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "soft",
        "capsules",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 8,
        "manufacturing": 8,
        "safety": 6,
        "transparency": 5,
        "sustainability": 3
      },
      "price": 31.84,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804565065925",
      "vsf_explanation": "The product title is literally 'Soft Capsules' — a generic dosage-form descriptor, not a product name. The body copy reveals it is fish oil at 1200mg per capsule, but the SKU title provides zero identification and no EPA/DHA breakdown is disclosed anywhere in the listing. Fish oil is a legitimate supplement category with strong evidence for cardiovascular endpoints when EPA+DHA totals exceed roughly 1000mg/day (Innes & Calder 2020 meta-analysis, Int J Mol Sci), but the actual omega-3 content of a 1200mg fish oil capsule is what matters — quality products are 60-90% omega-3 (720-1080mg EPA+DHA per 1200mg cap), while cheap fish oils are 15-30% omega-3 (180-360mg EPA+DHA), meaning users would need 3-6x the capsules to reach an effective dose without knowing it. Autofailed under misleading_naming: 'Soft Capsules' is not a product name, and the lack of EPA/DHA breakdown, source-fish disclosure (anchovy/sardine vs cheaper alternatives), or oxidation testing (TOTOX value) makes verification impossible. Cannot be listed on Vyvata as titled.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "glutathione-skin-supplement",
      "title": "Glutathione Skin Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/27640f80-da07-4940-a6a7-fe0e2a9f7bf3.jpg?v=1787593319",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glutathione",
        "skin",
        "supplement",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 12,
        "formulation": 10,
        "manufacturing": 10,
        "safety": 7,
        "transparency": 6,
        "sustainability": 4
      },
      "price": 40.7,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804565360837",
      "vsf_explanation": "Glutathione is the body's most abundant intracellular antioxidant tripeptide (glutamate-cysteine-glycine). Oral glutathione has a contested bioavailability profile — early pharmacokinetic studies showed poor absorption because gut peptidases hydrolyze the molecule, but newer trials with liposomal and sublingual forms show meaningful plasma-level increases (Sinha et al. 2018, Eur J Clin Nutr found 500mg/day oral for 6 months increased blood GSH by 30% and skin lightening in Filipino subjects). For the skin-lightening claim specifically, there is a moderate evidence base in Asian populations at 250-1000mg/day but efficacy in fair-skinned populations is weaker and no FDA-approved 'skin lightening' oral supplement exists. This SKU discloses only 'glutathione' as raw material with no dose, form (reduced GSH vs liposomal vs S-acetyl-glutathione), or per-lot COA. Held at 48/100 in the low-Standard band: the ingredient has partial evidence for the claimed use, but the form/dose opacity keeps it near the Rejected threshold. Bumped above the autofail line only because glutathione has a real evidence file, unlike homeopathic 'skin drops.'",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "moringa-leaves-capsules",
      "title": "Moringa Leaves Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/67a13341-01b0-4152-80f9-6b9ce2d6c2c6.jpg?v=1787593319",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "moringa",
        "leaves",
        "capsules",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 11,
        "manufacturing": 11,
        "safety": 8,
        "transparency": 7,
        "sustainability": 4
      },
      "price": 20.13,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804564869317",
      "vsf_explanation": "Moringa oleifera is a legitimate botanical with a growing evidence base for glycemic control, lipid profile, and antioxidant markers (Kou et al. 2018 Nutrients review; Vergara-Jimenez 2017 antioxidant meta-analysis). This SKU is a 60-count capsule of moringa leaf powder from Vivalo/CJ Dropshipping generic OEM. What holds the score at 55/100: (1) no per-capsule mg is disclosed, (2) no leaf-vs-extract clarification (whole-leaf powder is 100-300mg per capsule with mild effect; standardized extract 4:1 or 10:1 delivers more actives per capsule), (3) no per-lot COA for heavy metals (moringa is a soil hyper-accumulator and cheap moringa often tests high for lead), (4) no organic or pesticide-testing disclosure. The ingredient class is honestly Standard-tier on evidence grounds; this SKU inherits none of the Vivalo brand-transparency deficits that would push it lower.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pepper-drops",
      "title": "Pepper Drops",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/32a36088-d62e-4e0b-b3f2-f21287d2bd23.jpg?v=1787593319",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pepper",
        "drops",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 8,
        "manufacturing": 8,
        "safety": 6,
        "transparency": 5,
        "sustainability": 3
      },
      "price": 28.57,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804564934853",
      "vsf_explanation": "The product title is 'Pepper Drops' with body copy revealing it is 'chili pepper drops' at 60ml per bottle. This is not a product name — 'pepper' could refer to black pepper (piperine), cayenne/chili (capsaicin), or bell pepper extract; the body copy suggests capsaicin but provides no capsaicinoid concentration, no Scoville measure, no standardization, and no dose per drop. Capsaicin has genuine evidence for modest metabolic-rate increases (Whiting 2012 meta-analysis) and thermic effect (Ludy 2012); piperine has real bioavailability-enhancement evidence (Shoba 1998 turmeric bioavailability study). But both compounds have narrow effective-dose windows and this SKU discloses none of what is in the bottle at what concentration. Autofailed under misleading_naming: 'Pepper Drops' is not a product name and the lack of species disclosure, capsaicinoid concentration, and dose-per-drop makes it impossible to score or use intentionally.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "dietary-supplement-5",
      "title": "Dietary Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/935cf743-b90c-458d-a813-1d1b373ef410.jpg?v=1787593319",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dietary",
        "supplement",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 8,
        "manufacturing": 8,
        "safety": 6,
        "transparency": 5,
        "sustainability": 3
      },
      "price": 21.58,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804564902085",
      "vsf_explanation": "The product title is literally 'Dietary Supplement' — a regulatory category (per DSHEA 1994), not a product name. Body copy discloses the actual formula: moringa 11,000mg equivalent (from moringa leaf powder + moringa oleifera 50:1 extract) per capsule x 60 capsules. If accurate, this is actually a strong moringa dose — 11g equivalent per capsule is far above typical 200-500mg moringa capsules — and would represent a reasonable value for a moringa-focused user. But 'Dietary Supplement' as a product title fails the misleading_naming autofail: buyers cannot identify the product from its name, product will not surface in category searches, and the SKU is functionally invisible in a scored marketplace. Autofail applies regardless of underlying ingredient quality. Ingredient itself would score Standard 58 with an honest name; misleading title forces Rejected 40.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "collagen-vitamin-capsules",
      "title": "COLLAGEN VITAMIN CAPSULES",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7a232790-0ad0-4dbc-a810-4c6af14d600f.jpg?v=1787593319",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "collagen",
        "vitamin",
        "capsules",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 12,
        "formulation": 10,
        "manufacturing": 10,
        "safety": 8,
        "transparency": 6,
        "sustainability": 4
      },
      "price": 51.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804565098693",
      "vsf_explanation": "Hydrolyzed collagen peptides have real evidence for skin elasticity, hydration, and joint pain reduction at daily doses of 10-15g (Choi 2019 skin meta-analysis; Bello 2006 joint pain review; Zdzieblik 2015 tendinopathy). The problem with capsule-format collagen is a mathematical one: a typical capsule holds 500-800mg, meaning users need 12-30 capsules per day to reach the 10-15g effective dose. Most consumers take 1-3 capsules and receive 500-2400mg — a subtherapeutic dose that produces no measurable benefit. This SKU discloses '246g per bottle' but not per-capsule mg or capsule count, so effective dose cannot be calculated. 'Collagen Vitamin' also implies a vitamin blend beyond just collagen — commonly vitamin C, biotin, hyaluronic acid — but none of those are disclosed on this listing. Standard tier at 50/100: real ingredient with real evidence, but the capsule format almost guarantees subtherapeutic dosing and the vitamin co-formula is undisclosed. Powder-format collagen at 10-15g/day is the only realistic way to receive collagen's evidenced benefits.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "xilaizhi-honey-stick-shilajit-honey-sticks",
      "title": "Xilaizhi Honey Stick Shilajit Honey Sticks",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0ce80429-6d6a-48cc-9367-561f8a62ad49_fine.jpg?v=1787593319",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "xilaizhi",
        "honey",
        "stick",
        "shilajit",
        "honey",
        "sticks",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 8,
        "manufacturing": 8,
        "safety": 6,
        "transparency": 5,
        "sustainability": 3
      },
      "price": 57.61,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804565262533",
      "vsf_explanation": "Shilajit is a mineral-rich resin sourced from Himalayan and Altai rock formations, traditionally used in Ayurveda. Its evidence base is emerging — Pandit 2016 showed increased free testosterone in oligospermic men at 250mg/day of PrimaVie-branded purified shilajit for 90 days; other trials show mitochondrial and antioxidant benefits. BUT: unpurified shilajit routinely tests high for lead, arsenic, and mercury (Wilson 2011, J AOAC Int; Carrasco-Gallardo 2012 review), because the raw resin absorbs environmental heavy metals from the rock it forms in. Only shilajit that has been laboratory-purified (fulvic acid concentration standardized, heavy metals below USP limits) is safe for regular consumption. 'Xilaizhi' is an obscure Chinese-branded shilajit + honey format (30 sticks/box), with no PrimaVie branding, no purification method disclosed, no heavy-metal COA, and no fulvic acid standardization. Compounding this: it's Chinese-manufactured, and Chinese-sourced 'shilajit' has repeatedly tested worse for heavy metals than Indian PrimaVie-branded shilajit. Autofailed under safety_concern: shilajit without published heavy-metal COA is a documented lead-exposure vector, and this SKU discloses nothing about purity testing. Rejected at 42.",
      "vsf_autofail_rule": "safety_concern"
    },
    {
      "handle": "hot-product-lipozem-fat-zinc-probiotic-capsules",
      "title": "Hot Product Lipozem Fat Zinc Probiotic Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/456524d8-981c-4ab9-be2e-d6b5de3dfca8.jpg?v=1787593319",
      "score": 26,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hot",
        "product",
        "lipozem",
        "fat",
        "zinc",
        "probiotic",
        "capsules",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 6,
        "formulation": 5,
        "manufacturing": 5,
        "safety": 4,
        "transparency": 3,
        "sustainability": 2
      },
      "price": 22.63,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804565196997",
      "vsf_explanation": "This product is a textbook shadow-pharmacy listing: 'Lipozem' is a name deliberately designed to phonetically evoke Ozempic (semaglutide), the FDA-approved GLP-1 receptor agonist for type-2 diabetes and weight loss. Vyvata's Shadow Pharmacy investigation (blog: shadow-pharmacy-supplements-impersonating-prescription-drugs-2026-tirzepatide-glp1-dmaa-coral-calcium) documented this exact pattern — supplements branded to mimic prescription drug names, implying comparable efficacy without any of the actual pharmacology or FDA review. 'Fat Zinc' is not a compound that exists in nutrition science; it is nonsense marketing wordplay. The undisclosed 'probiotic' ingredient without strain identification is a further transparency failure. There is zero credible mechanism by which zinc + generic probiotics + oral capsules produces GLP-1-like glucose or weight effects; the entire product is designed to convert Ozempic-seeking search traffic into supplement sales. Autofailed under unverified_medical_claim (Ozempic-mimic marketing implies prescription-drug-comparable weight loss without evidence) and would additionally trip misleading_naming (both 'Lipozem' as an Ozempic-clone name and 'Fat Zinc' as a fake ingredient category). Rejected at 26. Not listable in any form; the product identity itself is the violation.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "slimming-health-boost-drops",
      "title": "Slimming  Health Boost Drops",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/21d13499-6d80-4f8c-bd6e-f9170e569ca2.jpg?v=1787593319",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "slimming",
        "health",
        "boost",
        "drops",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 8,
        "formulation": 6,
        "manufacturing": 6,
        "safety": 4,
        "transparency": 4,
        "sustainability": 2
      },
      "price": 18.58,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804565164229",
      "vsf_explanation": "Homeopathic-format weight-loss drops are one of the FTC's most enforcement-targeted supplement categories, dating to Kevin Trudeau's $37M judgment (FTC v. Trudeau 2011) and continuing through the FTC's ongoing enforcement of unsubstantiated 'natural weight loss' liquid products. The disclosed formula — 'NAD+ and NR, moringa oleifera, ginkgo biloba extract, echinacea purpurea, probiotics, and green tea extract' at unspecified doses in an unspecified vehicle — is a random assembly of ingredients with no shared mechanism for weight loss and no plausible sublingual bioavailability. NAD+ orally is destroyed by gut peptidases (<1% absorption for the intact molecule); moringa has mild glycemic effects but no weight-loss trial evidence; ginkgo is a circulation/cognition supplement with no metabolism data; echinacea is an immune modulator; probiotics require specific strains at 10-100 billion CFU for any GI benefit; green tea extract at 300-800mg/day has small thermogenic effects. Bundling these into 'slimming drops' without disclosed doses is textbook unverified_medical_claim. Rejected at 30 with FTC enforcement precedent citation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "annona-aceratum-drops",
      "title": "Annona Aceratum Drops",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1934778695546048512.png?v=1787593319",
      "score": 28,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "annona",
        "aceratum",
        "drops",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 7,
        "formulation": 6,
        "manufacturing": 6,
        "safety": 4,
        "transparency": 3,
        "sustainability": 2
      },
      "price": 29.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804565426373",
      "vsf_explanation": "Annona species (custard apple, soursop/graviola, cherimoya, sweetsop) contain a class of alkaloids called acetogenins, of which the most studied is annonacin. Annonacin is a complex I mitochondrial inhibitor at nanomolar concentrations and has been implicated as a probable cause of atypical parkinsonism in Guadeloupe, where soursop consumption is culturally high (Caparros-Lefebvre & Elbaz 1999 Lancet; Champy et al. 2005 Mov Disord; Lannuzel et al. 2008). The population-level association is strong: Guadeloupean atypical parkinsonism prevalence is 5-10x the expected rate, and the epidemiological signal maps to annonacin exposure. EFSA and the French ANSES have issued advisory statements against habitual consumption of concentrated Annona products. This SKU is a tincture (60ml drops) of 'Annona aceratum' — a concentrated extract that maximizes acetogenin content relative to the whole fruit. Autofailed under safety_concern: repeated oral exposure to concentrated Annona is a documented risk factor for atypical parkinsonism. Rejected at 28. Not listable regardless of any other quality factors.",
      "vsf_autofail_rule": "safety_concern"
    },
    {
      "handle": "herbal-shaping-health-drops",
      "title": "Herbal Shaping Health Drops",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ed1a1d7c-61b1-41d3-acd0-9116494b6d4d.jpg?v=1787593319",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "herbal",
        "shaping",
        "health",
        "drops",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 8,
        "formulation": 6,
        "manufacturing": 6,
        "safety": 5,
        "transparency": 4,
        "sustainability": 3
      },
      "price": 15.36,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804565229765",
      "vsf_explanation": "Same FTC-enforcement-targeted category as 'Slimming Health Boost Drops.' The disclosed formula — 'traditional Chinese medicine extract, gluconic acid lactone, vitamin B1, potassium sorbate, mint leaf extract' — contains one preservative (potassium sorbate), one pH buffer (gluconic acid lactone), a trace vitamin (B1), a flavoring (mint), and one undefined 'traditional Chinese medicine extract' that could be any of thousands of formulas. The identical ingredient block appears verbatim on multiple Vivalo 'drops' products in this batch (Sleep Melatonin Drops, Weight Loss Control Drops, Hip Augmentation Dietary Supplement, Herbal Shaping) with only the marketing positioning changing — this is a single base formula rebranded for different searchable use-cases. Autofailed under unverified_medical_claim (weight-loss/shaping claim without evidence) and would additionally trip misleading_naming (identical formula sold under multiple names). Rejected at 32.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "male-small-intestinal-gas-groin-compression-belt",
      "title": "Male Small Intestinal Gas Groin Compression Belt",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ba626339-d0e6-4cff-8496-717a24ba8f19.jpg?v=1787593319",
      "score": 28,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "male",
        "small",
        "intestinal",
        "gas",
        "groin",
        "compression",
        "belt",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 7,
        "formulation": 6,
        "manufacturing": 6,
        "safety": 4,
        "transparency": 3,
        "sustainability": 2
      },
      "price": 31.53,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804565557445",
      "vsf_explanation": "This is not a supplement, wearable, diagnostic device, sleep product, or recovery modality — it is a neoprene compression belt marketed as a truss for inguinal hernia support. Compression trusses are traditional support garments for reducible inguinal hernias but have been superseded by surgical repair as the standard of care (BMJ 2018 hernia guidelines; American College of Surgeons hernia repair standards). Wearing a truss is not a treatment for inguinal hernia — it does not repair the abdominal-wall defect, only provides external compression to reduce bulging. Long-term truss use is associated with skin breakdown, muscle atrophy, and can mask progression to strangulation (a surgical emergency). Regardless of medical merit, this product falls entirely outside Vyvata's four scored categories: supplements, wearables/tracking, diagnostics, sleep, and recovery. Autofailed under out_of_scope_for_biohacking. Rejected at 28.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "creatine-capsules-calcium-phosphate-supplement-capsules",
      "title": "Creatine Capsules Calcium Phosphate Supplement Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/29e1df37-48c9-4304-9e86-3ec71461d779.jpg?v=1787593318",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "creatine",
        "capsules",
        "calcium",
        "phosphate",
        "supplement",
        "capsules",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 11,
        "manufacturing": 11,
        "safety": 8,
        "transparency": 7,
        "sustainability": 4
      },
      "price": 25.62,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804565033157",
      "vsf_explanation": "Creatine monohydrate + calcium phosphate is an uncommon combination. Creatine has the strongest evidence base of any ergogenic supplement (see the standalone creatine SKU analysis). Calcium phosphate is a common excipient (as calcium hydrogen phosphate dibasic) used as a tablet binder in cheap manufacturing, but the product name calling it out as an 'active ingredient' suggests either (a) calcium supplementation intent (calcium phosphate is a reasonable form for bone-health-adjacent supplementation) or (b) marketing dress-up of an excipient. Without per-serving mg for either compound, this cannot be scored precisely. Creatine in capsule format is a subtherapeutic choice for most users — reaching 5g/day requires 8-16 capsules of 300-600mg each, at which point creatine powder (5g = one small scoop) becomes vastly cheaper and easier. Standard 56/100: creatine's evidence carries the score, but capsule format is a suboptimal delivery vehicle and calcium phosphate as a co-active is not evidence-based for any performance endpoint.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "inositol-complex-care-vitamin-capsules",
      "title": "Inositol Complex Care Vitamin Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7748decf-f0f7-42d4-8592-1f727fba93d9_fine.jpg?v=1787593319",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "inositol",
        "complex",
        "care",
        "vitamin",
        "capsules",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 13,
        "formulation": 10,
        "manufacturing": 10,
        "safety": 8,
        "transparency": 6,
        "sustainability": 4
      },
      "price": 18.86,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804565328069",
      "vsf_explanation": "Myo-inositol is a legitimate supplement with real evidence for PCOS-related insulin resistance and menstrual regularity (Unfer 2016 meta-analysis, Endocrine; Facchinetti 2015 for combined myo/D-chiro at 40:1 ratio), and moderate evidence for anxiety and panic disorder at higher doses (Levine 1995 at 12g/day; Palatnik 2001). Effective doses are substantial: 2-4g/day for PCOS, 12-18g/day for mood. 'Inositol Complex' without disclosure of which inositols (myo, D-chiro, scyllo, chiro) at what ratio is a common transparency failure — the 40:1 myo:D-chiro ratio is the evidenced PCOS formulation, and cheaper products use only myo-inositol (still valid) or unspecified 'inositol.' 'Vitamin' in the name implies co-formulated vitamins but none are disclosed. Held at 52 on the low-Standard band: the ingredient class has real evidence, but capsule format at undisclosed doses will likely deliver 500-1500mg/day (subtherapeutic for PCOS at 2-4g target and vastly subtherapeutic for mood).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "household-hot-selling-magnesium-glycinate-capsules",
      "title": "Household Hot-selling Magnesium Glycinate Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a468755e-94e7-4ef8-add3-fe7965f4a439.jpg?v=1787593319",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "household",
        "hot",
        "selling",
        "magnesium",
        "glycinate",
        "capsules",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 12,
        "manufacturing": 12,
        "safety": 9,
        "transparency": 7,
        "sustainability": 5
      },
      "price": 26.41,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804565131461",
      "vsf_explanation": "Magnesium glycinate (magnesium bisglycinate) is one of the two best-tolerated and most-bioavailable oral magnesium forms (the other being magnesium citrate). It delivers elemental magnesium bound to glycine, which reduces GI side effects (loose stools/diarrhea that limit magnesium oxide and citrate) and gives glycine's mild calming effect as a bonus. Evidence for magnesium: strong for supplementing deficiency (roughly 50% of Americans have inadequate intake per NHANES), moderate for sleep (Abbasi 2012 elderly RCT), moderate for migraine prevention (Chiu 2016 systematic review), and mixed for anxiety (Boyle 2017 review). The '\"hot-selling\"' phrase in the title is amateur-tier retail copy that doesn't affect scoring. Vivalo does not disclose per-capsule elemental mg — the critical number for magnesium — nor whether the product is buffered glycinate (contains magnesium oxide) or true bisglycinate (all bound). Standard 58: real ingredient in a real form, moderate-strong evidence base, held from Verified by undisclosed elemental dose and no COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "metabolism-enhancing-herbal-supplements",
      "title": "Metabolism Enhancing Herbal Supplements",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/69b23b86-be4c-47ca-ac63-bb3e158b463d.jpg?v=1787593319",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "metabolism",
        "enhancing",
        "herbal",
        "supplements",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 8,
        "manufacturing": 8,
        "safety": 6,
        "transparency": 5,
        "sustainability": 3
      },
      "price": 43.72,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804565688517",
      "vsf_explanation": "'Metabolism enhancing' is unverified medical-claim language. No oral herbal supplement has produced clinically meaningful increases in resting metabolic rate (>5% RMR) in well-controlled trials in the general population. The strongest 'metabolism' ingredients — caffeine, green tea catechins (EGCG), capsaicin — produce small acute thermogenic effects (30-100 kcal/day) that reliably regress over 4-8 weeks as the body adapts. This SKU discloses no ingredients on the listing — it is titled and marketed as a metabolic booster without any transparency into what the buyer receives. Autofailed under unverified_medical_claim (metabolism-enhancement claim without evidence) + proprietary_blend_hides_dose (no ingredients disclosed at all). Rejected at 40.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "probiotic-extract-capsules-for-women",
      "title": "Probiotic Extract Capsules For Women",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7719a670-8838-49c7-8d5b-17e3705c0634.jpg?v=1787593319",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "probiotic",
        "extract",
        "capsules",
        "for",
        "women",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 11,
        "formulation": 9,
        "manufacturing": 9,
        "safety": 7,
        "transparency": 5,
        "sustainability": 4
      },
      "price": 25.48,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804565393605",
      "vsf_explanation": "Women-targeted probiotics are a legitimate category with some strain-specific evidence: Lactobacillus rhamnosus GR-1 and L. reuteri RC-14 (Urex/Fem-Dophilus) have real trial data for urogenital and vaginal microbiome support (Reid 2003, Petricevic 2008). But a scored probiotic evaluation requires (a) strain identification at the sub-species level with CFU counts, (b) shelf-stability data, and (c) delivery-form clarification (enteric-coated to survive stomach acid vs bare capsule). This SKU discloses none of these — 'Probiotic Extract Capsules' without strain, CFU, or delivery-form information. Additionally, 'probiotic extract' is a nonsensical phrase — probiotics are live bacteria; an 'extract' would be dead bacteria (paraprobiotics or postbiotics), which have separate but weaker evidence. Autofailed under proprietary_blend_hides_dose: undisclosed strains + undisclosed CFU + confusing 'extract' language makes verification impossible. Rejected at 45.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "vegetarian-herbal-supplement-drops",
      "title": "Vegetarian Herbal Supplement Drops",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b7af0e42-afa3-4281-846a-7a2e3a49f3c4.jpg?v=1787593319",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vegetarian",
        "herbal",
        "supplement",
        "drops",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 8,
        "manufacturing": 8,
        "safety": 6,
        "transparency": 5,
        "sustainability": 3
      },
      "price": 11.94,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804565524677",
      "vsf_explanation": "The product title 'Vegetarian Herbal Supplement Drops' is a compound generic description with no product identity. 'Vegetarian' describes a capsule-shell material (typically HPMC/plant cellulose vs bovine gelatin), 'herbal' describes an ingredient class, 'supplement' is the regulatory category, and 'drops' is the delivery format. None of this identifies what is in the bottle or what it does. Vivalo also discloses no ingredients on the listing. Autofailed under misleading_naming (title provides zero product identification) + proprietary_blend_hides_dose (no ingredients disclosed). Rejected at 38.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "health-boost-drops",
      "title": "Health Boost Drops",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/181d9cae-300e-4a45-8e27-e41af52e2d37_fine.jpg?v=1787593319",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "health",
        "boost",
        "drops",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 8,
        "manufacturing": 8,
        "safety": 6,
        "transparency": 5,
        "sustainability": 3
      },
      "price": 17.81,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804565655749",
      "vsf_explanation": "'Health Boost Drops' is a generic marketing phrase, not a product name — 'health' is not a defined biological endpoint, and 'boost' is unmeasurable. The listing discloses no ingredients. This is the same pattern as multiple Vivalo drops SKUs in this batch: a single formulation base sold under multiple generic 'boost' names for different search categories. Autofailed under misleading_naming + proprietary_blend_hides_dose. Rejected at 38.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "portable-finger-clip-pulse-saturation-detector",
      "title": "Portable Finger Clip Pulse Saturation Detector",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/52f2d1d0-2374-49e0-b182-82a66638ffa6.jpg?v=1787593319",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "portable",
        "finger",
        "clip",
        "pulse",
        "saturation",
        "detector",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 8,
        "formulation": 6,
        "manufacturing": 6,
        "safety": 5,
        "transparency": 4,
        "sustainability": 3
      },
      "price": 12.87,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804565917893",
      "vsf_explanation": "This is a fingertip pulse oximeter — a device that measures peripheral capillary oxygen saturation (SpO2) via infrared/red-light absorption spectroscopy. Pulse oximeters are FDA-regulated as Class II medical devices when marketed for clinical use, with 510(k) clearance required. Consumer-grade pulse oximeters from established brands (Masimo MightySat, Nonin Onyx, Zacurate, iHealth) have varying degrees of FDA clearance and independent validation. This SKU is a no-brand LK89 model from a CJ Dropshipping supplier with no FDA 510(k) disclosed, no ISO 13485 disclosed, no independent accuracy validation, and no manufacturer identification. Additionally, this batch is scored as supplements — a pulse oximeter is a wearable/diagnostic device outside the supplement category. If evaluated under the Cat 1 Wearables rubric, it would autofail on 'uncleared medical diagnosis claim' (measures a clinical biomarker without FDA clearance). Rejected at 32 under unverified_medical_claim (the device claims to measure a clinical parameter without regulatory clearance).",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "soft-capsules-300-tablets-of-oregano-oil",
      "title": "Soft Capsules 300 Tablets Of Oregano Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/94092507-980c-4753-bb9a-36f0436feb2e.jpg?v=1787593319",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "soft",
        "capsules",
        "300",
        "tablets",
        "oregano",
        "oil",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 12,
        "formulation": 10,
        "manufacturing": 10,
        "safety": 8,
        "transparency": 6,
        "sustainability": 4
      },
      "price": 48.12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804565983429",
      "vsf_explanation": "Oregano oil (Origanum vulgare essential oil) is a legitimate herbal supplement with in-vitro antimicrobial activity (Sienkiewicz 2011) and some evidence for GI parasite and small intestinal bacterial overgrowth (Force 2000, Phytother Res, small trial). The active compound is carvacrol at ~60-80% of the oil, with thymol as a secondary. Effective doses in the Force 2000 trial were 200mg oil (containing ~120mg carvacrol) 3x/day for 6 weeks. This SKU delivers 300 soft capsules of oregano oil at undisclosed mg per cap — the mg-per-serving is what matters, and it is not disclosed. Also unclear whether this is emulsified/encapsulated oregano oil (usable orally) or raw essential oil (can cause GI irritation at concentrated doses). Standard 50/100 — real ingredient with real evidence for niche uses (SIBO, parasites), held down by undisclosed carvacrol content, no dose per capsule, and no COA. Not a first-line immune supplement despite marketing framing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "use-balanced-intestinal-dietary-supplements",
      "title": "Use Balanced Intestinal Dietary Supplements",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2a51aacc-33b4-4483-80ce-cd5d3b37dd20.jpg?v=1787593319",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "use",
        "balanced",
        "intestinal",
        "dietary",
        "supplements",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 8,
        "manufacturing": 8,
        "safety": 6,
        "transparency": 5,
        "sustainability": 3
      },
      "price": 18.58,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46804566016197",
      "vsf_explanation": "Title reads as an awkward machine-translation of a Chinese-language product name. 'Use Balanced Intestinal Dietary Supplements' is not a product name — it's a phrase. No ingredients are disclosed on the listing. Autofailed under misleading_naming + proprietary_blend_hides_dose. Rejected at 38.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "solgar-calcium-citrate-with-vitamin-d3-120-tablets",
      "title": "Solgar Calcium Citrate with Vitamin D3 120 Tablets",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33984004313.jpg?v=1788035833",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "calcium",
        "citrate",
        "with",
        "vitamin",
        "120",
        "tablets",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 74,
        "formulation": 75,
        "manufacturing": 78,
        "safety": 68,
        "transparency": 68,
        "sustainability": 62
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830126137541",
      "vsf_explanation": "Solgar Calcium Citrate with Vitamin D3 — same brand quality context as the Solgar K2 product scored above. Solgar is a premium US vitamin brand (est. 1947, cGMP-certified, amber-glass light-protective bottles, single-ingredient discipline). Calcium citrate is the better-absorbed form (see Citracal note); Solgar's version pairs it with Vitamin D3 at conservative maintenance dosing. Solgar generally scores well in ConsumerLab spot testing for label accuracy and does not use proprietary blends. Verified tier for the combination of premium brand track record, well-formulated calcium citrate + D3, and honest single-purpose formulation. Held out of Elite by (1) same absence of publicly-posted per-lot COAs as noted before, (2) no K2 pairing, and (3) evidence for calcium supplementation on hard outcomes has softened over the past decade (Bolland 2010 CV signal, Bolland 2015 meta-analysis on fracture reduction more modest than earlier estimates).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "phyto-phytophanere-dietary-supplement-2-month-supply-120-capsules",
      "title": "PHYTO PHYTOPHANÈRE Dietary Supplement - 2 Month Supply (120 Capsules)",
      "vendor": "Nava Beauty",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/phyto-phytophanere-dietary-supplement-2-month-supply-120-capsules.webp?v=1788035839",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "phyto",
        "phytophan",
        "dietary",
        "supplement",
        "month",
        "supply",
        "120",
        "capsules",
        "nava",
        "beauty"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 12,
        "manufacturing": 11,
        "safety": 10,
        "transparency": 6,
        "sustainability": 5
      },
      "price": 60,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830126727365",
      "vsf_explanation": "PHYTO Phytophanère is a hair and nail supplement from a well-established Paris-based haircare brand (PHYTO / Phyto Paris), positioning around essential fatty acids and an antioxidant blend for keratin production. As a category, hair-nail supplements have modest RCT evidence — biotin correction helps only in genuine deficiency; omega fatty acids modestly support scalp health; multi-ingredient hair supplements (Nutrafol, Viviscal) with more elaborate patented complexes have somewhat stronger trial evidence than simpler multivitamin-style formulations. PHYTO's brand pedigree in professional haircare is real, though this supplement extension does not benefit from the same clinical infrastructure as their salon products. Description doesn't itemise all ingredients or per-capsule milligrams. Solid Standard on brand credibility and reasonable category positioning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "citracal-petites-calcium-citrate-supplement-with-vitamin-d3-200-coated-caplets",
      "title": "Citracal Petites Calcium Citrate Supplement with Vitamin D3, 200 Coated Caplets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/302593439.jpg?v=1788035854",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "citracal",
        "petites",
        "calcium",
        "citrate",
        "supplement",
        "with",
        "vitamin",
        "200",
        "coated",
        "caplets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 68,
        "manufacturing": 72,
        "safety": 65,
        "transparency": 62,
        "sustainability": 60
      },
      "price": 14.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830128005317",
      "vsf_explanation": "Citracal (Bayer) is one of the most-recognized calcium supplement brands in the US, using calcium citrate — the better-absorbed form especially in low-stomach-acid users (elderly, PPI/H2 blocker users). Petites deliver 400mg calcium citrate + 500 IU D3 per two-caplet serving; the 500 IU D3 is a conservative maintenance dose (below the aggressive 5,000 IU levels seen in other products). Citrate absorbs at 20-25% regardless of stomach acid vs. carbonate's 40% only with food and adequate acid. The Recker 1985 and Heaney 1988 studies established citrate's advantages in specific populations. Bayer manufacturing is cGMP-certified with regulatory infrastructure standards. 'No. 1 doctor and pharmacist recommended calcium brand' is a marketing claim substantiated by pharmacy survey data. Solid Standard tier — a reliable, well-formulated, mainstream calcium product. Held out of Verified by the absence of publicly-posted per-lot COAs and by the small D3 dose (which some users need higher; others prefer higher K2-paired formulas rather than adding calcium supplementation at all).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "buried-treasure-fulvic-minerals-unflavored-liquid-mineral-supplement-with-70-trace-elements-from-humic-shale-33-oz-bottle",
      "title": "Buried Treasure Fulvic Minerals – Unflavored Liquid Mineral Supplement with 70+ Trace Elements from Humic Shale | 33 oz Bottle",
      "vendor": "Buried Treasure Liquid Nutrients",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_23f8731d-2dfa-424c-8cdd-2efdfda530fe.jpg?v=1788035870",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "buried",
        "treasure",
        "fulvic",
        "minerals",
        "unflavored",
        "liquid",
        "mineral",
        "supplement",
        "with",
        "trace",
        "elements",
        "from",
        "humic",
        "shale",
        "bottle",
        "buried",
        "treasure",
        "liquid",
        "nutrients"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 11,
        "formulation": 10,
        "manufacturing": 9,
        "safety": 8,
        "transparency": 6,
        "sustainability": 5
      },
      "price": 34.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830129545413",
      "vsf_explanation": "Buried Treasure's Fulvic Minerals is a humic-shale-derived liquid claiming 70+ trace elements. Fulvic and humic acids are legitimately real substances (organic complex acids from decomposed plant matter in soil and shale) with some in-vitro antioxidant and mineral-chelation activity. The clinical evidence for oral supplementation is thin — a handful of small trials on general wellness, fatigue, and immune markers. The '70+ trace elements' framing is where the product runs into rubric trouble: (1) most of those elements are not essential minerals for humans (the body uses ~14), and their inclusion doesn't add nutritional value; (2) humic-shale sources have real heavy-metal accumulation risk — aluminum, arsenic, lead, cadmium — and per-lot COA is not published; (3) 'trace elements' framing parallels the same problematic marketing seen in colloidal-mineral products. Combined with the 1995 legacy claim (not evidence), lands at Rejected.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "iron-strips",
      "title": "Iron Strips",
      "vendor": "Muscle Faktor",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/iron-strips-hero.png?v=1788035998",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "iron",
        "strips",
        "muscle",
        "faktor"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 12,
        "manufacturing": 10,
        "safety": 8,
        "transparency": 6,
        "sustainability": 5
      },
      "price": 28.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830139310277",
      "vsf_explanation": "Muscle Faktor's Iron Strips are a quick-dissolving oral strip format delivering iron plus co-factor nutrients involved in red blood cell formation. Oral strip delivery has practical advantages (fast onset, no pill fatigue, portable) but also constraints (mass limit per strip caps the deliverable elemental iron; some absorption may be sublingual which changes the pharmacokinetics from swallowed iron). Iron's evidence base is unchanged from the mineral concentrate SKUs — iron deficiency anaemia is the world's most common nutrient deficiency but iron loading is harmful in men and postmenopausal women without deficiency. Description doesn't surface elemental iron per strip. Same contraindications and safety cautions apply — this should not be a self-directed default supplement. Standard tier on real ingredient held back by same contraindications and dose opacity.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "multivitamin-bear-gummies-adult",
      "title": "Multivitamin Bear Gummies (Adult)",
      "vendor": "Muscle Faktor",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1755212822486-generated-label-image-0.jpg?v=1788036003",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "multivitamin",
        "bear",
        "gummies",
        "adult",
        "muscle",
        "faktor"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 13,
        "formulation": 11,
        "manufacturing": 10,
        "safety": 10,
        "transparency": 7,
        "sustainability": 4
      },
      "price": 19.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830139441349",
      "vsf_explanation": "Muscle Faktor's adult gummy multivitamin containing vitamins A, C, D, B6, B12, biotin, folate, plus zinc and iodine. Gummy multivitamins have real trade-offs: (1) they carry added sugar or sugar alcohols (matters for macros, dental health, and blood glucose), (2) they impose a low mass ceiling on each nutrient (hard to fit therapeutic amounts of calcium, magnesium, or vitamin C into a chewable gummy), and (3) evidence base for multivitamins in general population is mixed (USPSTF 2022 insufficient for CVD/cancer prevention; COSMOS-Mind modest cognitive benefit in older adults). Muscle Faktor's gummy is a straightforward take on the category. Description begins to itemise ingredients (sodium citrate, retinol acetate, ascorbic acid), which is a positive signal. Solid Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "muscle-faktor-polar-flex-menthol-cooling-recovery-gel",
      "title": "Muscle Faktor Polar Flex Menthol Cooling Recovery Gel",
      "vendor": "Muscle Faktor",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/20250908151521-unnamed--15.png?v=1788036003",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "muscle",
        "faktor",
        "polar",
        "flex",
        "menthol",
        "cooling",
        "recovery",
        "gel",
        "muscle",
        "faktor"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 8,
        "formulation": 10,
        "manufacturing": 10,
        "safety": 10,
        "transparency": 6,
        "sustainability": 4
      },
      "price": 16.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830139474117",
      "vsf_explanation": "Muscle Faktor's Polar Flex is a topical menthol cooling gel (menthol crystals, arnica flower, aloe leaf juice, witch hazel, botanical essential oils) marketed for post-activity skin comfort. This is a topical cosmetic product, not an oral supplement — outside Vyvata's biohacking-supplement scope. Menthol as a topical counterirritant has legitimate short-term local analgesic effect via TRPM8 activation; arnica has mixed topical evidence for bruising and post-activity soreness. As a cosmetic gel, the product is likely well-formulated and reasonably safe, but it does not fit the supplement category the platform is designed to evaluate. Auto-fail under out_of_scope_for_biohacking (topical/cosmetic).",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "keto-thrive",
      "title": "Keto Thrive",
      "vendor": "Muscle Faktor",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/20250717182304-keto-image.png?v=1788036003",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "keto",
        "thrive",
        "muscle",
        "faktor"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 8,
        "manufacturing": 10,
        "safety": 9,
        "transparency": 5,
        "sustainability": 4
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830139506885",
      "vsf_explanation": "Muscle Faktor's Keto Thrive discloses one ingredient by name (calcium citrate) and explicitly labels the rest as 'proprietary blend.' Under the Zero-Assumption Rule and proprietary_blend_hides_dose autofail rule, undisclosed multi-ingredient formulations forfeit tier eligibility regardless of how well-formulated they might be. The 'keto' positioning implies exogenous ketones (BHB salts) or MCTs as the likely undisclosed content, but without disclosure a reviewer cannot verify. Calcium citrate at supplement doses (typically 200-500 mg per capsule) is a legitimate calcium form; on its own it does not support a 'keto' claim. Rejected on the proprietary blend and the mismatch between the 'keto' branding and the only disclosed ingredient (calcium).",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "muscle-faktor-birch-chaga-antioxidant-truffles-with-pine-bark",
      "title": "Muscle Faktor Birch Chaga Antioxidant Truffles with Pine Bark",
      "vendor": "Muscle Faktor",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1756341304593-generated-label-image-0.jpg?v=1788036004",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "muscle",
        "faktor",
        "birch",
        "chaga",
        "antioxidant",
        "truffles",
        "with",
        "pine",
        "bark",
        "muscle",
        "faktor"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 13,
        "formulation": 13,
        "manufacturing": 10,
        "safety": 10,
        "transparency": 7,
        "sustainability": 5
      },
      "price": 35.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830139539653",
      "vsf_explanation": "Muscle Faktor's chaga + pine bark truffles combine two real botanicals with antioxidant profiles in a functional-food format. Chaga (Inonotus obliquus) has among the highest ORAC-rated antioxidant activity of any documented natural source, with mechanistic evidence for immune modulation and oxidative-stress reduction; human trials are small but generally positive on antioxidant markers. Pine bark extract (Pycnogenol is the trademarked reference; generic pine bark is comparable) has RCT evidence for endothelial function, blood pressure, and cognitive endpoints at doses of 100-200 mg/day. Truffle format (flaxseed + cacao) is a legitimate functional-food delivery vehicle. Description doesn't surface per-truffle milligrams of chaga extract or pine bark. Solid mid-Standard on real ingredients with plausible functional-food positioning; held back by dose opacity.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "rubidium-rb-2oz-concentrate",
      "title": "Rubidium (Rb) - 2oz. Concentrate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CartPhotos-153.jpg?v=1788036080",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "rubidium",
        "2oz",
        "concentrate",
        "completeh2ominerals",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 6,
        "formulation": 6,
        "manufacturing": 7,
        "safety": 5,
        "transparency": 5,
        "sustainability": 4
      },
      "price": 48,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830140555461",
      "vsf_explanation": "A rubidium chloride concentrate marketed as modifying 'coupling between circadian oscillators' and equalising 'circadian rhythm even for stressed organisms.' Rubidium is an alkali metal not classified as essential for humans by any mainstream nutritional-science body. Trace amounts occur in food and water, but no deficiency state exists and no metabolic pathway requires it. Rubidium chloride has some historical psychiatric-research interest (small studies in depression in the 1970s-80s at pharmacological doses of 700-1000 mg elemental rubidium daily) but was abandoned in favour of better-tolerated medications. The circadian-oscillator claim is derived from a highly specialised body of neuroscience research and does not translate to a consumer-supplement use case. Auto-fail under unverified_medical_claim.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "twin-kit-1",
      "title": "Twin Kit 1",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/kit1.jpg?v=1788036084",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "twin",
        "kit",
        "completeh2ominerals",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 8,
        "formulation": 8,
        "manufacturing": 8,
        "safety": 8,
        "transparency": 5,
        "sustainability": 4
      },
      "price": 100,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830140588229",
      "vsf_explanation": "A multi-product bundle labelled 'Twin Kit 1' containing 'Potassium Zinc, Mag/Cal, Complete Essentials, and Complete Vitamins Plus.' The bundle inherits the transparency problems of its components: Complete Vitamins Plus has no published description, Complete Essentials is not itemised, Mag/Cal is not disclosed at what elemental milligram ratio, and Potassium Zinc combines two minerals with important-but-different safety profiles. A kit that is a wrapper around four undisclosed formulations cannot be reviewed above the auto-fail threshold. The generic 'Twin Kit 1' name provides no information about who this kit is for or what the intended use case is. Rejected on cascading transparency failures across the bundle components.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "indium-in-mineral-water",
      "title": "Indium (In) - Mineral Water",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CartPhotos-64.jpg?v=1788036084",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "indium",
        "mineral",
        "water",
        "completeh2ominerals",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 5,
        "formulation": 6,
        "manufacturing": 7,
        "safety": 4,
        "transparency": 5,
        "sustainability": 4
      },
      "price": 22.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830140653765",
      "vsf_explanation": "The 'mineral water' (16 oz / 32 oz) version of indium — same non-essential heavy metal as the 2 oz concentrate, but at a diluted format for direct drinking. Same autofail applies: indium is not classified as essential for humans, no deficiency state exists, and no controlled human clinical trial supports any physiological role. Description claims 'beneficial effect on the thyroid gland,' 'energy boost,' 'assimilate other important nutrients,' and 'increase the life span of red blood cells' — none of these effects are supported by peer-reviewed human evidence. Occupational indium exposure is associated with a documented pulmonary disease (indium lung). Auto-fail under unverified_medical_claim.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "gold-au-2oz-concentrate",
      "title": "Gold (Au) - 2oz. Concentrate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CartPhotos-136.jpg?v=1788036084",
      "score": 28,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gold",
        "2oz",
        "concentrate",
        "completeh2ominerals",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 4,
        "formulation": 5,
        "manufacturing": 6,
        "safety": 3,
        "transparency": 4,
        "sustainability": 4
      },
      "price": 48,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830140784837",
      "vsf_explanation": "A colloidal or ionic 'gold' concentrate marketed for mental clarity, balance, and cellular support with claims of 'historical use in wellness traditions.' Gold is not classified as essential for humans by any mainstream nutritional-science body. No deficiency state is defined; no metabolic pathway requires gold. Consumer marketing around monatomic gold and colloidal gold derives from David Hudson's Ormus/ORMEs framework in the 1990s — a body of alternative-chemistry claims not accepted by mainstream chemistry or physics. Pharmacological gold (auranofin, gold sodium thiomalate) has real but limited clinical use in rheumatoid arthritis, with well-documented toxicities (nephrotoxicity, dermatitis, thrombocytopenia). Consumer colloidal gold at supplement doses lacks both the therapeutic rationale of pharmacological gold and any evidence base. Auto-fail under unverified_medical_claim.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "gold-au-mineral-water",
      "title": "Gold (Au) - Mineral Water",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CartPhotos-46.jpg?v=1788036085",
      "score": 28,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gold",
        "mineral",
        "water",
        "completeh2ominerals",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 4,
        "formulation": 5,
        "manufacturing": 6,
        "safety": 3,
        "transparency": 4,
        "sustainability": 4
      },
      "price": 32.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830140719301",
      "vsf_explanation": "The 'mineral water' (16 oz / 32 oz) format of the gold product — same non-essential trace metal, marketed for clarity, balance, and cellular support. Same autofail rationale applies: gold is not classified as essential for humans; no controlled human trials support the marketed effects; consumer colloidal-gold marketing derives from an alternative-chemistry framework (Ormus/ORMEs) not accepted by mainstream science. Diluted format arguably lowers immediate exposure but does not change the fundamental lack of evidence for benefit or safety architecture. Auto-fail under unverified_medical_claim.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "calcium-ca-2oz-concentrate",
      "title": "Calcium (Ca) - 2oz. Concentrate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CartPhotos-110.jpg?v=1788036085",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "calcium",
        "2oz",
        "concentrate",
        "completeh2ominerals",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 12,
        "manufacturing": 9,
        "safety": 9,
        "transparency": 8,
        "sustainability": 4
      },
      "price": 38,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830140981445",
      "vsf_explanation": "A calcium liquid concentrate disclosing '60 mcg of calcium' per serving — a specific dose disclosure that many other trace-mineral SKUs miss. The dose itself is a curious flag: 60 micrograms is far below any nutritionally meaningful amount (adult RDA is 1000-1200 milligrams — a factor of nearly 20,000 higher). Even accounting for the possibility that the label intended milligrams rather than micrograms, 60 mg is still only 5-6% of RDA per serving. Calcium's evidence base for bone health is well established for at-risk populations (postmenopausal women, older adults), though recent literature raises legitimate concerns about isolated calcium supplementation without concurrent D3 and K2 driving arterial calcification. A calcium product without D3+K2 pairing is a suboptimal modern formulation. Mid-Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "molybdenum-mo-mineral-water",
      "title": "Molybdenum (Mo) - Mineral Water",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CartPhotos-52.jpg?v=1788036085",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "molybdenum",
        "mineral",
        "water",
        "completeh2ominerals",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 11,
        "formulation": 10,
        "manufacturing": 9,
        "safety": 9,
        "transparency": 6,
        "sustainability": 4
      },
      "price": 22.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830141014213",
      "vsf_explanation": "The mineral-water (16 oz / 32 oz) version of the molybdenum SKU. Same evidence context: molybdenum is a trace essential mineral (RDA 45 mcg/day adults) required for three specific enzymes. Same real-world gap: dietary intake in the US typically exceeds RDA substantially through legumes, grains, and nuts, and true deficiency is essentially unheard of outside genetic molybdenum-cofactor deficiency. The description repeats the physiologically inaccurate claim that molybdenum 'helps carry oxygen to the cells' — that is haemoglobin's function, requires iron, not molybdenum. Rejected on the mismatch between no real deficiency population and inaccurate description.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "copper-cu-2oz-concentrate",
      "title": "Copper (Cu) - 2oz. Concentrate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CartPhotos-121.jpg?v=1788036085",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "copper",
        "2oz",
        "concentrate",
        "completeh2ominerals",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 13,
        "manufacturing": 9,
        "safety": 10,
        "transparency": 9,
        "sustainability": 5
      },
      "price": 38,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830140817605",
      "vsf_explanation": "A copper liquid concentrate disclosing 1.5 mg of copper per serving — a meaningful and reasonable dose (RDA is 900 mcg for adults; 1.5 mg is within the range typical for supplementation and well below the tolerable upper intake of 10 mg/day). Copper is a genuinely essential trace mineral required for ceruloplasmin, cytochrome c oxidase, superoxide dismutase, and lysyl oxidase (connective tissue). Deficiency is real and often iatrogenic — chronic high-dose zinc (>40 mg/day) depletes copper via shared transporters, and bariatric surgery patients are at risk. The dose disclosure is above-average transparency for this brand line and pushes the score into solid Standard. Would need form disclosure (glycinate vs sulphate vs bisglycinate) and third-party COA to reach Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "iron-fe-2oz-concentrate",
      "title": "Iron (Fe) - 2oz. Concentrate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CartPhotos-115.jpg?v=1788036085",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "iron",
        "2oz",
        "concentrate",
        "completeh2ominerals",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 12,
        "manufacturing": 9,
        "safety": 8,
        "transparency": 7,
        "sustainability": 5
      },
      "price": 38,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830141079749",
      "vsf_explanation": "An iron liquid concentrate with an accurate description of iron's role in oxygen transport, red blood cell formation, and its importance in muscle myoglobin. Iron deficiency anaemia is the most common nutrient deficiency worldwide, particularly in menstruating women, pregnant women, vegetarians/vegans, and endurance athletes. The description sensibly notes that vitamin C, B12, B6, and copper enhance iron effectiveness — accurate physiology. The scoring caveat is that iron supplementation is not a benign default: iron loading is harmful to men, postmenopausal women without deficiency, and haemochromatosis carriers (roughly 1 in 200 of European ancestry). Iron supplements should be used only when deficiency is documented. Description doesn't surface the iron form (ferrous sulphate vs bisglycinate vs polysaccharide-iron-complex) or per-serving mg. Solid Standard on real mineral with real use case, held back by contraindications and lack of form/dose disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "iodine-i-mineral-water",
      "title": "Iodine (I) - Mineral Water",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CartPhotos-34.jpg?v=1788036084",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "iodine",
        "mineral",
        "water",
        "completeh2ominerals",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 12,
        "manufacturing": 9,
        "safety": 9,
        "transparency": 7,
        "sustainability": 5
      },
      "price": 22.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830140883141",
      "vsf_explanation": "Iodine is a genuinely essential trace mineral (RDA 150 mcg/day adults; 220 mcg pregnancy; 290 mcg lactation) required for thyroid hormone synthesis (T3 and T4). Deficiency remains a global public-health concern despite iodised salt programs — WHO estimates roughly 2 billion people worldwide have insufficient iodine intake. In the US, iodine intake has trended downward since the 1970s as sea-salt use has grown and fortified-salt use has declined. The description accurately identifies iodine's role in thyroid hormones, brain development, and metabolic regulation. Safety window is narrow: chronic intake above 1100 mcg/day (tolerable upper intake) can cause hyperthyroidism or, paradoxically, iodine-induced hypothyroidism and thyroiditis. Form (potassium iodide vs iodine tincture vs kelp-derived) is not disclosed. Solid Standard on essential mineral with real deficiency population, held back by narrow safety window and undisclosed form.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "b6-and-b12-folic-acid-4-oz-bottle",
      "title": "B6 and B12 Folic Acid - 4 oz. Bottle",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CartPhotos-86.jpg?v=1788036085",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "and",
        "b12",
        "folic",
        "acid",
        "bottle",
        "completeh2ominerals",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 16,
        "formulation": 12,
        "manufacturing": 10,
        "safety": 9,
        "transparency": 10,
        "sustainability": 5
      },
      "price": 16.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830140850373",
      "vsf_explanation": "A B6 + B12 + folic acid liquid combination with disclosed doses: 5 mg pyridoxine HCl (B6), 400 mcg folic acid (B9), and 1000 mcg methylcobalamin (B12). Dose disclosure is above average and earns strong transparency credit. Formulation choices are mixed: methylcobalamin (bioactive B12) is correct; pyridoxine HCl at 5 mg is a moderate dose (RDA 1.3-1.7 mg, tolerable upper intake 100 mg — 5 mg is safe long-term); folic acid (folate synthetic form) is a defensible choice for the general population but not optimal for MTHFR-variant users, who benefit more from L-methylfolate. The B6/B12/folate combination has real clinical use for hyperhomocysteinaemia and is the standard homocysteine-lowering intervention. Cardiovascular outcome benefits from lowering homocysteine per se have been disappointing in RCTs (HOPE-2, NORVIT), though the mechanistic case remains. Solid Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "calcium-ca-mineral-water",
      "title": "Calcium (Ca) - Mineral Water",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CartPhotos-70.jpg?v=1788036084",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "calcium",
        "mineral",
        "water",
        "completeh2ominerals",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 11,
        "manufacturing": 9,
        "safety": 9,
        "transparency": 7,
        "sustainability": 4
      },
      "price": 22.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830141112517",
      "vsf_explanation": "The mineral-water format of calcium (16 oz, 32 oz, and extra-strength 32 oz). Same evidence context as the 2 oz concentrate. Calcium's evidence base for bone health is well established in at-risk populations. Modern nutrition consensus favours calcium + D3 + K2 rather than isolated calcium, given meta-analytic concerns about isolated calcium and cardiovascular events. The description does not specify per-serving elemental calcium; extra-strength is described but the actual milligram number is not surfaced. Users seeking calcium supplementation from a liquid format would generally need many servings per day to meet meaningful dietary supplement doses (500-1000 mg). Standard tier — real ingredient, sub-optimal single-mineral formulation, incomplete dose disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ultimate-electrolytes-4-oz-bottles",
      "title": "Ultimate Electrolytes - 4 oz. Bottles",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CartPhotos-79.jpg?v=1788036084",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ultimate",
        "electrolytes",
        "bottles",
        "completeh2ominerals",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 13,
        "formulation": 13,
        "manufacturing": 10,
        "safety": 10,
        "transparency": 7,
        "sustainability": 5
      },
      "price": 16.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830140948677",
      "vsf_explanation": "A concentrated liquid electrolyte formula containing sodium, potassium, magnesium, and calcium — the four core cations with legitimate physiologic roles in fluid balance, muscle contraction, and cardiac rhythm. The formulation approach (all four major cations, concentrated for dilution into water) is sensible for endurance-training and heat-stress contexts. Evidence for electrolyte supplementation in heavy sweat loss, hot climates, extended endurance events, and post-illness rehydration is real. The description does not surface per-serving milligrams of each mineral, which caps transparency. Liquid concentrates have practical advantages (customisable serving size, faster GI absorption than powder-in-water for some users). Solid Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "platinum-pt-2oz-concentrate",
      "title": "Platinum (PT) - 2oz. Concentrate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CartPhotos-130.jpg?v=1788036084",
      "score": 28,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "platinum",
        "2oz",
        "concentrate",
        "completeh2ominerals",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 4,
        "formulation": 5,
        "manufacturing": 6,
        "safety": 3,
        "transparency": 4,
        "sustainability": 4
      },
      "price": 48,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830141210821",
      "vsf_explanation": "A platinum liquid concentrate marketed to 'energize human cells, stimulate healthy cellular division (mitosis), and assist in repairing DNA damage.' Platinum is not classified as essential for humans by any mainstream nutritional-science body. No deficiency state exists; no metabolic pathway requires it. Platinum-based drugs (cisplatin, carboplatin, oxaliplatin) are prescription chemotherapies that damage DNA in tumour cells — the opposite of the marketing claim about DNA repair. Consumer platinum supplementation derives from the same Ormus/ORMEs alternative-chemistry framework as monatomic gold, which is not accepted by mainstream science. Platinum toxicity is documented in chemotherapy contexts (nephrotoxicity, neurotoxicity, ototoxicity). Consumer supplement doses are lower but long-term oral safety at these doses has not been characterised. Auto-fail under unverified_medical_claim.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "chromium-cr-mineral-water",
      "title": "Chromium (Cr) - Mineral Water",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CartPhotos-73.jpg?v=1788036085",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chromium",
        "mineral",
        "water",
        "completeh2ominerals",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 13,
        "formulation": 12,
        "manufacturing": 9,
        "safety": 9,
        "transparency": 7,
        "sustainability": 5
      },
      "price": 22.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830141243589",
      "vsf_explanation": "The mineral-water version of chromium. Chromium is a trace essential mineral (adequate intake 25-35 mcg/day adults) historically associated with insulin sensitivity via 'glucose tolerance factor,' though modern nutritional science has moved away from asserting essentiality — some authorities now question whether chromium is truly essential in humans. RCTs of chromium picolinate for type 2 diabetes have shown small and inconsistent effects on HbA1c and fasting glucose. Chromium's marketed roles in 'fat and cholesterol synthesis in the liver' reflect older biochemical hypotheses rather than confirmed clinical outcomes. The mineral is not typically deficient in mixed Western diets. Description does not surface form (picolinate vs polynicotinate vs chloride vs GTF-chromium) or per-serving dose. Solid mid-Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "balanced-life",
      "title": "Balanced Life",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CartPhotos-25.jpg?v=1788036085",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "balanced",
        "life",
        "completeh2ominerals",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 11,
        "formulation": 10,
        "manufacturing": 9,
        "safety": 9,
        "transparency": 8,
        "sustainability": 5
      },
      "price": 22.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830141341893",
      "vsf_explanation": "A multi-mineral blend disclosing calcium (21 mg) as one component. The disclosed calcium dose is a fraction of RDA (1000-1200 mg for adults) — 21 mg is roughly 2% of daily requirement, which is essentially nutritionally insignificant even at multiple daily servings. The 'Balanced Life' branding gestures at broad wellness without a specific use case. The description begins to itemise ingredients but at doses that seem more appropriate to a natural mineral spring water than to a formulated supplement. Under Vyvata's rubric, mineral products at trace/water-level concentrations that market themselves as 'supplements' misrepresent the delivered nutritional value. Rejected on the marketing-vs-delivery mismatch and generic branding.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "iodine-i-2oz-concentrate",
      "title": "Iodine (I) - 2oz. Concentrate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CartPhotos-133.jpg?v=1788036084",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "iodine",
        "2oz",
        "concentrate",
        "completeh2ominerals",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 12,
        "manufacturing": 9,
        "safety": 9,
        "transparency": 7,
        "sustainability": 5
      },
      "price": 38,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830141309125",
      "vsf_explanation": "The 2 oz concentrate format of iodine. Same evidence base as the mineral-water version — iodine is essential (RDA 150 mcg adults; 220 pregnancy; 290 lactation), and deficiency remains a real public-health concern despite iodised salt programs. The 2 oz concentrate format is intended for dilution before consumption, which requires user attention to dose since it's easier to over-consume from a concentrated liquid than from a diluted mineral water. Description accurately identifies iodine's role in thyroid hormones. Same safety concerns as the mineral water: narrow safety window (tolerable upper intake 1100 mcg/day), thyroid conditions require endocrinologist review before supplementation, and form is not disclosed. Solid Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnesium-mg-2oz-concentrate",
      "title": "Magnesium (Mg) - 2oz. Concentrate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Magnesium2ozDropsLifestylesquare.png?v=1788036085",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "2oz",
        "concentrate",
        "completeh2ominerals",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 13,
        "manufacturing": 9,
        "safety": 10,
        "transparency": 7,
        "sustainability": 5
      },
      "price": 38,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830141440197",
      "vsf_explanation": "A magnesium liquid concentrate accurately identifying magnesium's roles in bone/joint/teeth health, muscle function, and general well-being. Magnesium is one of the strongest-evidence essential minerals: NHANES data suggest ~45% of US adults consume below the Estimated Average Requirement; supplementation has documented benefits in sleep quality, migraine prophylaxis, blood pressure, and cardiac arrhythmia in specific contexts. Liquid magnesium is a legitimate delivery format — liquid absorption can be faster than tablet form. The description doesn't specify the magnesium form (chloride, sulphate, glycinate, citrate), which meaningfully affects both bioavailability and GI tolerability, and doesn't surface per-serving elemental magnesium. Solid mid-Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chromium-cr-2oz-concentrate",
      "title": "Chromium (Cr) - 2oz. Concentrate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CartPhotos-118.jpg?v=1788036085",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chromium",
        "2oz",
        "concentrate",
        "completeh2ominerals",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 13,
        "formulation": 12,
        "manufacturing": 9,
        "safety": 9,
        "transparency": 10,
        "sustainability": 5
      },
      "price": 38,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830141472965",
      "vsf_explanation": "A chromium concentrate disclosing 750 mcg per serving (375% DV). Dose disclosure is above average for this brand line and earns transparency credit. The dose itself is high — DV is 35 mcg (older 120 mcg for supplement labelling), and 750 mcg is well above the RDA-equivalent range while remaining below the toxicity threshold. Chromium's marginal essentiality (some authorities have questioned whether it's truly essential) and modest RCT evidence for type 2 diabetes and insulin sensitivity remain the underlying evidence context. Description mentions role in fat and cholesterol synthesis in the liver, which reflects older biochemical hypotheses more than confirmed clinical outcomes. Solid Standard on the strength of dose disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "complete-vitamins-plus-4-oz-bottle",
      "title": "Complete Vitamins Plus - 4 oz. Bottle",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CartPhotos-82.jpg?v=1788036091",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "complete",
        "vitamins",
        "plus",
        "bottle",
        "completeh2ominerals",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 5,
        "formulation": 5,
        "manufacturing": 5,
        "safety": 6,
        "transparency": 3,
        "sustainability": 4
      },
      "price": 16.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830141538501",
      "vsf_explanation": "A 'Complete Vitamins Plus' 4 oz liquid multivitamin with no product description at all — the description field is empty. Under Vyvata's Zero-Assumption Rule, no disclosed data equals zero credit for any criterion that would rely on that data. Compounded by generic naming ('Complete Vitamins Plus') that provides no information about actual composition, this is misleading by omission. A product without any published ingredient list, dose disclosure, or use-case description cannot be reviewed at all. Auto-fail on misleading naming and total absence of disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zinc-zn-2oz-concentrate",
      "title": "Zinc (Zn) - 2oz. Concentrate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ZincDrops2ozLifestylesquare.png?v=1788036093",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zinc",
        "2oz",
        "concentrate",
        "completeh2ominerals",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 12,
        "manufacturing": 10,
        "safety": 10,
        "transparency": 7,
        "sustainability": 6
      },
      "price": 38,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830141571269",
      "vsf_explanation": "Zinc is a genuinely essential trace mineral (RDA 11 mg/day men, 8 mg/day women) with clear evidence for immune function, wound healing, taste and smell, reproductive function, and skin health. Deficiency is real and documented in vegetarians, elderly, alcohol-use-disorder patients, and users with GI absorption issues. Zinc lozenges started at cold symptom onset have Cochrane-review support for shortening cold duration (~30% reduction in some analyses). The description accurately identifies zinc's roles in immunity, skin, and hair health. Safety needs attention: chronic supplementation above 40 mg/day (tolerable upper intake) depletes copper via shared intestinal transporters and can cause anaemia and neurologic symptoms over months. Liquid concentrates typically deliver zinc as sulphate, gluconate, or picolinate; form is not disclosed. Solid Standard on a legitimate essential mineral, held back by lack of form and dose disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "indium-in-2oz-concentrate",
      "title": "Indium (In) - 2oz. Concentrate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CartPhotos-113.jpg?v=1788036094",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "indium",
        "2oz",
        "concentrate",
        "completeh2ominerals",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 5,
        "formulation": 6,
        "manufacturing": 7,
        "safety": 4,
        "transparency": 5,
        "sustainability": 4
      },
      "price": 38,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830141636805",
      "vsf_explanation": "An indium concentrate with essentially no product description ('FDA & GMP guidelines observed' plus disclaimer text). Indium is a post-transition metal not classified as essential for humans by any mainstream nutrition science body — no deficiency state exists, no metabolic requirement is defined, and no controlled human trial supports any physiological role. Consumer marketing around 'indium supplementation' derives from alternative-medicine claims about pineal-gland, hormonal, and anti-aging effects that have never been substantiated in peer-reviewed literature. Occupational indium exposure (workers in semiconductor manufacturing) is associated with a documented pulmonary disease (indium lung / indium tin oxide lung disease). Auto-fail under unverified_medical_claim for supplementing a non-essential heavy metal without any published human evidence base.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "vanadium-v-2oz-concentrate",
      "title": "Vanadium (V) - 2oz. Concentrate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CartPhotos-139.jpg?v=1788036095",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vanadium",
        "2oz",
        "concentrate",
        "completeh2ominerals",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 10,
        "manufacturing": 8,
        "safety": 7,
        "transparency": 5,
        "sustainability": 4
      },
      "price": 38,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830141669573",
      "vsf_explanation": "A standalone vanadium concentrate marketed as stimulating blood sugar oxidation, transport in fat cells, and glycogen synthesis in liver and muscle. Vanadium is not classified as essential for humans by NIH ODS. Vanadyl sulfate has been studied for insulin-sensitising effects in type 2 diabetes at doses of 100-300 mg/day — the trials that showed effects also showed GI toxicity (cramping, diarrhoea) at those doses, and tolerable-upper-intake for total vanadium is 1.8 mg/day. Consumer supplement doses typically fall below the pharmacological range for insulin effects but above the safety-margin cushion. The description makes physiologically-specific claims about glycogen synthesis and fat-cell glucose uptake that reflect the trial literature but overpromise for consumer-dose contexts. Rejected on non-essentiality, narrow safety window, and clinical-dose vs consumer-dose mismatch.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vanadium-chromium-zinc-16-oz",
      "title": "Vanadium, Chromium, Zinc - 16 oz.",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CartPhotos-40.jpg?v=1788036095",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vanadium",
        "chromium",
        "zinc",
        "completeh2ominerals",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 11,
        "formulation": 10,
        "manufacturing": 8,
        "safety": 8,
        "transparency": 6,
        "sustainability": 4
      },
      "price": 22.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830141735109",
      "vsf_explanation": "A three-mineral blend (vanadium, chromium, zinc) in a 16 oz liquid format. Zinc is an essential mineral with clear physiological roles; chromium is considered essential at trace levels (RDA 25-35 mcg); vanadium is not classified as essential for humans by the NIH ODS (evidence for essentiality is limited to some animal models). Combining a genuinely essential mineral (zinc) with a marginally essential one (chromium) and a non-essential one (vanadium) at undisclosed doses is a formulation that includes an unnecessary ingredient. Vanadium at supplemental doses has been studied for insulin-sensitising effects in type 2 diabetes but at doses (>100 mg/day of vanadyl sulfate) that carry GI toxicity concerns. The description does not surface per-mineral milligrams. Rejected end of Standard range on the vanadium inclusion (non-essential, potential toxicity), lack of dose disclosure, and cardiovascular-focused claim.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "molybdenum-mo-2oz-concentrate",
      "title": "Molybdenum (Mo) - 2oz. Concentrate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CartPhotos-104.jpg?v=1788036095",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "molybdenum",
        "2oz",
        "concentrate",
        "completeh2ominerals",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 12,
        "formulation": 11,
        "manufacturing": 9,
        "safety": 9,
        "transparency": 6,
        "sustainability": 4
      },
      "price": 38,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830141800645",
      "vsf_explanation": "Molybdenum is a trace essential mineral (RDA 45 mcg/day adults) required as a cofactor for three enzymes: sulfite oxidase, xanthine oxidase/dehydrogenase, and aldehyde oxidase. Dietary intake in the US typically exceeds RDA — molybdenum deficiency is essentially unheard of in the general population and has been documented only in very specific parenteral nutrition contexts. The description accurately identifies the three enzyme functions but includes an inaccurate statement that molybdenum 'helps carry oxygen to the cells' — this is haemoglobin's function (which requires iron, not molybdenum). The lack of a real deficiency population plus factual inaccuracy in the description caps the score at Rejected. Standalone molybdenum has essentially no consumer supplementation use case outside genetic molybdenum-cofactor deficiency (an extremely rare paediatric metabolic disorder).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "selenium-se-2oz-concentrate",
      "title": "Selenium (Se) - 2oz. Concentrate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/selenium-11.jpg?v=1788036095",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "selenium",
        "2oz",
        "concentrate",
        "completeh2ominerals",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 12,
        "manufacturing": 9,
        "safety": 9,
        "transparency": 7,
        "sustainability": 4
      },
      "price": 38,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830141767877",
      "vsf_explanation": "Selenium is a genuinely essential trace mineral (RDA 55 mcg/day adults) required for the glutathione peroxidase and thioredoxin reductase antioxidant systems and for thyroid hormone deiodinase enzymes. Deficiency is uncommon in the US but real in parts of China, New Zealand, and Finland where soil selenium is low, and can present as Keshan cardiomyopathy or Kashin-Beck osteochondropathy. Modest evidence exists for selenium in Hashimoto's thyroiditis (autoimmune thyroid) reducing antibody levels at 200 mcg/day. The safety window is narrow — chronic intake above 400 mcg/day (tolerable upper intake) causes selenosis (hair and nail changes, GI symptoms, neuropathy). The description's antioxidant and immune framing is accurate; the product does not disclose the form (selenomethionine vs selenite) or per-serving mcg. Mid-Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "manganese-mn-2oz-concentrate",
      "title": "Manganese (Mn) - 2oz. Concentrate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CartPhotos-101.jpg?v=1788036096",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "manganese",
        "2oz",
        "concentrate",
        "completeh2ominerals",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 11,
        "formulation": 10,
        "manufacturing": 9,
        "safety": 8,
        "transparency": 6,
        "sustainability": 4
      },
      "price": 38,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830141833413",
      "vsf_explanation": "Manganese is an essential trace mineral (adequate intake 1.8-2.3 mg/day) used as a cofactor for manganese superoxide dismutase (MnSOD), arginase, glutamine synthetase, and pyruvate carboxylase. Dietary intake is nearly always sufficient in the general population (whole grains, nuts, legumes, tea). Deficiency in humans is essentially unheard of outside experimental settings. The safety concern with supplemental manganese is real: chronic overexposure is associated with manganism, a neurologic syndrome resembling parkinsonism, historically documented in welders and mining populations. Water sources with elevated manganese have been epidemiologically associated with cognitive deficits in children. The tolerable upper intake in adults is 11 mg/day — supplementation risks approaching this. Rejected on the mismatch between no real deficiency population and documented neurotoxicity risk with supplemental use.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sulfur-s-2oz-concentrate",
      "title": "Sulfur (S) - 2oz. Concentrate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CartPhotos-150.jpg?v=1788036096",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sulfur",
        "2oz",
        "concentrate",
        "completeh2ominerals",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 9,
        "formulation": 9,
        "manufacturing": 8,
        "safety": 7,
        "transparency": 5,
        "sustainability": 4
      },
      "price": 38,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830141866181",
      "vsf_explanation": "A 'sulfur' liquid concentrate marketed for repair and growth of blood vessels, bones, gums, cells, and teeth. Elemental sulphur is not a nutrient the body absorbs or uses in that form — dietary sulphur enters as sulphur-containing amino acids (methionine, cysteine) and inorganic sulphate. The description does not clarify whether this is sulphate, MSM (methylsulfonylmethane), or some other form; without that disclosure, the reviewer cannot evaluate what's actually delivered. MSM has a real (if modest) evidence base for osteoarthritis pain reduction; inorganic sulphate is essentially not a supplement category. The generic 'sulphur' framing plus undisclosed form leaves the product below the honest-standard threshold. Rejected on undisclosed chemical form of an otherwise legitimate biochemical building block.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "potassium-k-2oz-concentrate",
      "title": "Potassium (K) - 2oz. Concentrate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CartPhotos-159.jpg?v=1788036096",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "potassium",
        "2oz",
        "concentrate",
        "completeh2ominerals",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 8,
        "formulation": 8,
        "manufacturing": 8,
        "safety": 6,
        "transparency": 5,
        "sustainability": 4
      },
      "price": 38,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830141898949",
      "vsf_explanation": "A 'potassium concentrate' whose product description erroneously describes calcium — a copy-paste labelling error where the description text discusses calcium's role in bones and muscles rather than potassium. That labelling error alone would justify a Rejected tier under misleading_naming/misleading_labelling. Setting that aside, potassium is an essential mineral (adequate intake 3400 mg/day for men, 2600 for women) and most Americans consume below AI. Real deficiency is documented and can be corrected. However, supplemental potassium in dose forms above 99 mg per pill is FDA-restricted for a specific safety reason: high-dose potassium can cause life-threatening hyperkalaemia in users with kidney disease, on ACE inhibitors/ARBs, or on potassium-sparing diuretics, and undisclosed-dose liquid potassium supplements bypass that safety architecture. Rejected on both labelling error and safety-window narrowness.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "phosphorus-p-2oz-concentrate",
      "title": "Phosphorus (P) - 2oz. Concentrate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CartPhotos-156.jpg?v=1788036098",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "phosphorus",
        "2oz",
        "concentrate",
        "completeh2ominerals",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 8,
        "formulation": 8,
        "manufacturing": 8,
        "safety": 7,
        "transparency": 6,
        "sustainability": 4
      },
      "price": 38,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830141931717",
      "vsf_explanation": "A phosphoric acid (H3PO4) liquid concentrate. Phosphorus is an essential mineral (RDA 700 mg/day for adults), but dietary phosphorus is nearly universally over-consumed in Western diets — average intakes exceed 1200-1500 mg/day, well above RDA, driven by phosphate additives in processed foods and beverages. There is essentially no clinical case for phosphorus supplementation in healthy adults with normal kidney function; deficiency is rare and typically presents in specific medical contexts (severe malnutrition, refeeding syndrome, alcohol use disorder). Excess phosphorus is a real problem for chronic kidney disease patients (contributes to secondary hyperparathyroidism, vascular calcification, cardiovascular mortality) and shifts calcium-phosphorus balance unfavourably. Selling a phosphorus supplement without a clear deficiency-correction use case is a low-value proposition. Rejected on the mismatch between dietary reality and product positioning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "silver-ag-2oz-concentrate",
      "title": "Silver (Ag) - 2oz. Concentrate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cart-4.jpg?v=1788036098",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "silver",
        "2oz",
        "concentrate",
        "completeh2ominerals",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 5,
        "formulation": 5,
        "manufacturing": 6,
        "safety": 3,
        "transparency": 5,
        "sustainability": 4
      },
      "price": 38,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830141964485",
      "vsf_explanation": "A colloidal or ionic silver 'concentrate' marketed as 'Nature's Timeless Shield' with immune and skin support framing. Silver is not an essential human nutrient — it has no known physiological role in humans, and the body has no metabolic pathway that requires it. Oral silver at any dose carries documented risk of argyria, an irreversible bluish-grey discolouration of skin and mucous membranes caused by silver deposition in dermal tissues. The FDA has stated for decades that OTC silver products offered for internal use are not generally recognized as safe or effective (21 CFR 310.548). Auto-fail on two independent grounds: (1) unverified medical claim (silver as immune modulator or 'defender against harmful organisms' in humans lacks controlled clinical evidence), and (2) documented safety concern (argyria risk). Not listable.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cellular-hydration",
      "title": "Cellular Hydration",
      "vendor": "Longevity Rx",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/05485_LongevityRx_Cellular-Hydration-Carton_05_Set_300.jpg?v=1788036118",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cellular",
        "hydration",
        "longevity"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 14,
        "manufacturing": 10,
        "safety": 10,
        "transparency": 8,
        "sustainability": 6
      },
      "price": 69.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830142161093",
      "vsf_explanation": "Longevity Rx Cellular Hydration is an electrolyte stick pack (wild berry) with an optimised sodium-to-potassium ratio plus watermelon, celery, and coconut water for natural electrolyte content. The category — modern electrolyte powders (LMNT, Liquid IV, Nuun) — has real physiologic justification for endurance athletes, hot climates, hangovers, low-carb dieters, and post-illness rehydration. Sodium 500-1500 mg + potassium 200-400 mg is the standard therapeutic range. The 'drives hydration deep into your cells' framing is marketing — cellular hydration is a function of osmolality gradient, and while sodium/potassium do drive intracellular water shifts, the effect is not category-specific to this brand. Real electrolyte formulation, honest wellness category, held back from Verified by lack of per-serving mineral disclosure at the description level.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "probiotic-trillion",
      "title": "Probiotic Trillion",
      "vendor": "Longevity Rx",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/05485_LongevityRx_Bottle_Probiotic-Trillion_01_Front_300.jpg?v=1788036118",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "probiotic",
        "trillion",
        "longevity"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 11,
        "formulation": 10,
        "manufacturing": 9,
        "safety": 9,
        "transparency": 5,
        "sustainability": 4
      },
      "price": 99.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830142193861",
      "vsf_explanation": "Longevity Rx Probiotic Trillion features Bacillus subtilis AB-22 and the marketing claim that it 'may help counteract the harmful effects of glyphosate, a common environmental toxin.' The glyphosate-detox claim is where the product hits an autofail: (1) glyphosate is not a documented human-body toxin at general-population environmental exposure levels according to EFSA and EPA reviews (though IARC classifies it as probably carcinogenic — the toxicology debate exists but is not consumer-detox-relevant); (2) no supplement, including B. subtilis, has demonstrated glyphosate detoxification in human clinical endpoints; (3) 'trillion' CFU framing (10^12) is a marketing escalation from the standard 10-100 billion range, without corresponding strain-level evidence for the higher count. Auto-fail applied for unverified medical claim regarding glyphosate counteraction. Underlying B. subtilis is a legitimate probiotic strain family; the marketing frames it as something it isn't.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mitomultiply-methylated-multivitamin",
      "title": "MitoMultiply | Methylated Multivitamin",
      "vendor": "Longevity Rx",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/05485_LongevityRx_Bottle_MitoMultiply_01_Front_300.jpg?v=1788036123",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mitomultiply",
        "methylated",
        "multivitamin",
        "longevity"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 13,
        "manufacturing": 10,
        "safety": 10,
        "transparency": 8,
        "sustainability": 5
      },
      "price": 79.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830142259397",
      "vsf_explanation": "Longevity Rx MitoMultiply positions itself as a methylated multivitamin centred on active B6, folate, and B12 for energy metabolism, cognition, and cellular repair. Methylated B-vitamin forms (P-5-P, methylfolate, methylcobalamin) are a reasonable formulation choice — they bypass conversion steps that a subset of users perform inefficiently (MTHFR variants). The 'mitochondrial' and 'cellular energy' framing is defensible at the mechanism level for B-vitamin cofactors in mitochondrial pathways, though 'boosts cellular energy' as a felt effect is overpromised for a general audience. The description does not surface per-vitamin milligrams. Solid Standard on the methylation-focused formulation logic and honest B-vitamin category framing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liv120-superfood-powder",
      "title": "Liv120 Superfood Powder",
      "vendor": "Longevity Rx",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/05485_LongevityRx_Jar_Liv120_01_Front_300_copy.jpg?v=1788036123",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liv120",
        "superfood",
        "powder",
        "longevity"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 11,
        "formulation": 10,
        "manufacturing": 10,
        "safety": 9,
        "transparency": 6,
        "sustainability": 6
      },
      "price": 79.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830142292165",
      "vsf_explanation": "Longevity Rx Liv120 is a pomegranate-goji antioxidant blend marketed for mitochondrial function, circulation, and healthy aging. The named ingredients — pomegranate polyphenols and goji berry — each have modest RCT support for specific endpoints (pomegranate for cardiovascular markers; goji for eye and antioxidant status), but the '120' framing and 'mitochondrial function' claim reach further than the evidence supports. The name itself gestures at Liv 52 (a traditional Ayurvedic hepatoprotective) without confirming any liver-related ingredient. The description does not itemise a full ingredient list or per-ingredient milligrams. Combined with the 'longevity' branding — no supplement has ever demonstrated lifespan extension in humans — the product sits below the honest-standard threshold. Rejected on undisclosed formulation combined with unverified longevity/mitochondrial framing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mag18-peptide-powered-daily-magnesium",
      "title": "Mag18 | Peptide-Powered Daily Magnesium",
      "vendor": "Longevity Rx",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/05485_LongevityRx_Bottle_Mag18_01_Front_300.jpg?v=1788036123",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mag18",
        "peptide",
        "powered",
        "daily",
        "magnesium",
        "longevity"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 13,
        "formulation": 12,
        "manufacturing": 10,
        "safety": 10,
        "transparency": 6,
        "sustainability": 5
      },
      "price": 69.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830142324933",
      "vsf_explanation": "Longevity Rx Mag18 pairs magnesium with 18 amino-acid peptides derived from hydrolysed spirulina, plus zinc, selenium, copper, and chromium. Magnesium's evidence base is real (sleep, migraine, blood pressure, dietary insufficiency). The 'peptide-powered absorption' claim is more speculative — hydrolysed spirulina peptides may modestly aid mineral chelation and absorption, but head-to-head studies against standard magnesium glycinate showing superior absorption are not published for this formulation. Adding zinc, selenium, copper, and chromium at a claimed 'precise copper-to-zinc ratio' is a defensible micronutrient stack, though 'blood sugar balance' and 'immunity' claims add categories that dilute the primary magnesium mission. Without per-mineral milligram disclosure and without cited peptide-absorption data, mid-Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "daily-mushroom-brew-7-4-oz",
      "title": "Daily Mushroom Brew, 7.4 oz",
      "vendor": "Minimo Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1753762347310-generated-label-image-0.jpg?v=1788036169",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "daily",
        "mushroom",
        "brew",
        "minimo",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 13,
        "formulation": 12,
        "manufacturing": 10,
        "safety": 10,
        "transparency": 6,
        "sustainability": 5
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830142783685",
      "vsf_explanation": "A six-mushroom brew (functional coffee substitute) combining organic fermented mushrooms with green tea extract, prebiotics, and vitamin C. As a coffee-alternative category, the concept is reasonable — mushroom coffee blends have gained traction because they combine antioxidant/adaptogenic mushrooms with a lower caffeine load. Fermentation is a plausible pre-processing step for bioavailability. The evidence gaps: the description does not disclose which six mushrooms, fruiting-body vs mycelium, extract ratios, or per-mushroom milligrams. Green tea extract at unspecified dose adds EGCG (some hepatotoxicity risk at high chronic doses). Solid mid-Standard for the concept and multi-ingredient category framing; opacity on the ingredient panel caps the tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sea-moss-with-bladderwrack-and-burdock-root-60-ct",
      "title": "Sea Moss with Bladderwrack and Burdock Root, 60 ct.",
      "vendor": "Minimo Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1752340368656-generated-label-image-0.jpg?v=1788036169",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sea",
        "moss",
        "with",
        "bladderwrack",
        "and",
        "burdock",
        "root",
        "minimo",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 10,
        "manufacturing": 8,
        "safety": 6,
        "transparency": 6,
        "sustainability": 4
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830142816453",
      "vsf_explanation": "A sea moss (Irish moss, Chondrus crispus), bladderwrack (Fucus vesiculosus), and burdock root capsule that repeats the widely-circulated but scientifically dubious '92 out of 102 minerals' claim. The '92 minerals' figure originates from Dr. Sebi mythology and has no basis in analytical chemistry — the human body uses roughly 14 minerals, and no seaweed contains a bespoke set of '92 out of 102' anything. The safety concerns are real and specific: sea moss and bladderwrack are extremely high in iodine, with reported analyses showing single doses potentially exceeding the tolerable upper intake of 1100 mcg/day for adults; chronic overshoot causes thyroid dysfunction in both directions (hyperthyroidism or Hashimoto's-like hypothyroidism), and seaweeds are documented lead, arsenic, cadmium, and mercury accumulators. Auto-fail under unverified_medical_claim for the '92 minerals' framing plus a genuine safety concern for iodine overload and heavy-metal exposure without published testing.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "organic-ashwagandha-with-black-pepper-60-ct",
      "title": "Organic Ashwagandha with Black Pepper, 60 ct.",
      "vendor": "Minimo Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1752339494823-generated-label-image-0.jpg?v=1788036176",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "ashwagandha",
        "with",
        "black",
        "pepper",
        "minimo",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 13,
        "manufacturing": 10,
        "safety": 10,
        "transparency": 7,
        "sustainability": 5
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830142914757",
      "vsf_explanation": "Minimo Nutrition's ashwagandha with added black pepper (piperine) for bioavailability. Ashwagandha (Withania somnifera) has one of the stronger evidence bases among adaptogenic herbs — multiple RCTs support cortisol reduction, anxiety improvement, and modest sleep improvement in mildly stressed populations, with the most robust data on standardised KSM-66 and Sensoril extracts at 300-600 mg/day. The description does not clarify whether this SKU uses a standardised extract (KSM-66, Sensoril, or generic root powder) or the milligrams per capsule, which caps transparency credit. Piperine addition is a common bioenhancer that modestly improves absorption of some compounds but is not necessary for ashwagandha's withanolides. Solid mid-Standard: strong category, plausible formulation, but standardisation and dose disclosure would elevate the score.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "probiotic-40-billion-with-prebiotics-60-ct",
      "title": "Probiotic 40 Billion with Prebiotics, 60 ct.",
      "vendor": "Minimo Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1752346154910-generated-label-image-0.jpg?v=1788036176",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "probiotic",
        "billion",
        "with",
        "prebiotics",
        "minimo",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 13,
        "formulation": 13,
        "manufacturing": 10,
        "safety": 11,
        "transparency": 6,
        "sustainability": 5
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830142947525",
      "vsf_explanation": "A 40 billion CFU multi-strain probiotic with Lactobacillus acidophilus, plus prebiotic support. Probiotic evidence is strain-specific — total CFU count is a poor proxy for efficacy, and 40 billion CFU without strain-level disclosure (species, strain designation like La-14 or NCFM, and per-strain CFU) doesn't tell a reviewer whether the trial-proven strains are included. Best-studied indications for probiotics: antibiotic-associated diarrhoea prevention (moderate evidence for L. rhamnosus GG and S. boulardii), IBS symptom relief (mixed by strain), and Clostridium difficile prevention. General 'gut health' in healthy adults has weaker evidence. Formulation adds prebiotics, which is a reasonable synbiotic approach. Held back by strain-level opacity.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnesium-glycinate-90-ct",
      "title": "Magnesium Glycinate, 90 ct.",
      "vendor": "Minimo Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1752339852634-generated-label-image-0.jpg?v=1788036176",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "glycinate",
        "minimo",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 16,
        "formulation": 14,
        "manufacturing": 10,
        "safety": 11,
        "transparency": 8,
        "sustainability": 5
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830143111365",
      "vsf_explanation": "A magnesium glycinate (bisglycinate) supplement. Form choice is correct for the target use cases: magnesium glycinate has better GI tolerability than oxide, citrate, or chloride, and is the preferred form for sleep, anxiety, and general repletion in most adults. Magnesium's evidence base for correction of dietary insufficiency (estimated to affect roughly 45% of US adults), for sleep quality, migraine prophylaxis, and blood pressure is solid. The description implies the '70% deficient' figure, which is overstated (NHANES data suggest ~45% intake below EAR — not the same as clinical deficiency), but the underlying case for supplementation in modern diets is real. Elemental magnesium per capsule is not surfaced in the description snippet — the standard dose is 200-400 mg elemental. Solid mid-Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "brain-focus-formula-60-ct",
      "title": "Brain & Focus Formula, 60 ct.",
      "vendor": "Minimo Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/IMG_0785.png?v=1788036176",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "brain",
        "focus",
        "formula",
        "minimo",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 8,
        "manufacturing": 10,
        "safety": 9,
        "transparency": 5,
        "sustainability": 4
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830142980293",
      "vsf_explanation": "Minimo Nutrition's 'Brain & Focus Formula' positions itself as a 'cognitive enhancer' with 'heightened mental acuity' and 'unlock your mental potential' language. The category is nootropic multi-ingredient blend, which almost universally underperforms honest single-ingredient dosing of the same active compounds. The public description does not itemise ingredients or per-ingredient milligrams — a critical omission for a nootropic. Under the Zero-Assumption Rule and proprietary_blend_hides_dose autofail rule, undisclosed multi-ingredient formulations forfeit tier eligibility. The 'ultimate cognitive enhancer' marketing framing is materially stronger than what any legal supplement claim can support. Auto-fail applied on the presumption that any Brain & Focus multi-ingredient product without published ingredient/dose panel is a proprietary blend.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "organic-beetroot-capsuled-powder-60-ct",
      "title": "Organic Beetroot Capsuled Powder, 60 ct.",
      "vendor": "Minimo Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1752339146926-generated-label-image-0.jpg?v=1788036176",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "beetroot",
        "capsuled",
        "powder",
        "minimo",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 12,
        "manufacturing": 10,
        "safety": 10,
        "transparency": 7,
        "sustainability": 5
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830143078597",
      "vsf_explanation": "An encapsulated organic beetroot powder. Beetroot's evidence base is real and specific: dietary nitrates in beetroot are converted to nitrite and then nitric oxide, transiently lowering blood pressure (systolic drops of 3-10 mmHg in acute trials) and improving exercise economy in trained athletes at doses of 400-800 mg dietary nitrate (roughly 500 mL of concentrated beetroot juice). The problem for capsule formats: capsule mass is far below the dose used in evidence-based endpoints. A typical 60-count capsule bottle at 500 mg per capsule delivers 30 g of beetroot powder over a month — a fraction of the nitrate content of a single beetroot juice serving. Solid category, honest ingredient, sub-clinical delivery. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "platinum-turmeric-60-ct",
      "title": "Platinum Turmeric, 60 ct.",
      "vendor": "Minimo Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1752342979402-generated-label-image-0.jpg?v=1788036176",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "platinum",
        "turmeric",
        "minimo",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 13,
        "formulation": 12,
        "manufacturing": 10,
        "safety": 10,
        "transparency": 6,
        "sustainability": 5
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830143045829",
      "vsf_explanation": "A turmeric supplement labelled 'Platinum' with 'various forms of turmeric.' Curcumin has a moderate evidence base for inflammatory conditions — osteoarthritis pain (multiple RCTs at 500-1500 mg standardised curcumin daily show effects comparable to NSAIDs in some studies), metabolic syndrome markers, and depression as an adjunct. The problem is bioavailability: raw curcumin absorption is famously poor, and only formulations with piperine (BCM-95), phytosomes (Meriva), micronization (Theracurmin), or nanoparticles produce plasma levels associated with clinical effect. The description mentions 'various forms' but does not surface which enhanced-absorption form (or piperine content, or standardisation percentage of curcuminoids) is used. That opacity caps the tier. Solid mid-Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "creatine-monohydrate-powder-8-8-oz",
      "title": "Creatine Monohydrate Powder, 8.8 oz",
      "vendor": "Minimo Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1753198459582-generated-label-image-0.jpg?v=1788036176",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "creatine",
        "monohydrate",
        "powder",
        "minimo",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 14,
        "manufacturing": 10,
        "safety": 12,
        "transparency": 6,
        "sustainability": 4
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830143013061",
      "vsf_explanation": "Minimo Nutrition's 100% pure creatine monohydrate powder in an 8.8 oz format (about 250 g / 50 servings at 5 g). Same evidence context as any monohydrate SKU — hundreds of RCTs supporting strength, power, high-intensity performance, and emerging cognitive endpoints under sleep deprivation. The ISSN position stand supports monohydrate as the reference form. The 8.8 oz size gives roughly a 50-day supply at the standard 5 g maintenance dose. The description does not surface source purity certification (Creapure or equivalent), micronization status, or a third-party COA. Solid Standard on the strength of the ingredient's evidence base and clean single-ingredient formulation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ginkgo-biloba-ginseng-60-ct",
      "title": "Ginkgo Biloba + Ginseng, 60 ct.",
      "vendor": "Minimo Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1752340111246-generated-label-image-0.jpg?v=1788036176",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive",
        "energy",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ginkgo",
        "biloba",
        "ginseng",
        "minimo",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 13,
        "formulation": 12,
        "manufacturing": 10,
        "safety": 10,
        "transparency": 6,
        "sustainability": 5
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830143242437",
      "vsf_explanation": "Same botanical pairing as the APACHE STAR SKU — ginkgo biloba plus Panax ginseng — but without the standardisation percentages that APACHE STAR discloses. Evidence context is unchanged: ginkgo mixed for healthy-adult cognition (GEM Study 2008 negative for dementia prevention), modest data for mild cognitive impairment and vertigo; Panax ginseng modest RCT support for cognitive performance under stress. Without standardisation percentages (24% ginkgo flavones is the pharmaceutical benchmark; 4-7% ginsenosides is the Panax standard), a reviewer cannot verify trial-grade concentrations. Same drug-interaction cautions apply — bleeding risk with anticoagulants. Standard tier reflects a fair category with fair execution.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bone-heart-support-60-ct",
      "title": "Bone & Heart Support, 60 ct.",
      "vendor": "Minimo Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1752340784988-generated-label-image-0.jpg?v=1788036176",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bone",
        "heart",
        "support",
        "minimo",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 13,
        "formulation": 11,
        "manufacturing": 10,
        "safety": 10,
        "transparency": 6,
        "sustainability": 5
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830143209669",
      "vsf_explanation": "A multi-vitamin combination positioned as bone and heart support. Likely combining calcium, D3, K2, and possibly magnesium — the classic bone-cardiovascular partitioning stack. The mechanism (D3 for calcium absorption, K2 for calcium partitioning to bone vs artery) is defensible. The scoring drag is that the description does not itemise ingredients or per-ingredient milligrams — a critical omission for a mineral+vitamin combination. Recent literature on calcium supplementation raises legitimate concerns about isolated calcium supplementation (without D3+K2) and cardiovascular calcification; a well-formulated bone-heart product should explicitly address the K2 partitioning story. Without disclosed ingredients and doses, scoring lands at the lower end of Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "complete-multivitamin-immunity-boost-60-ct",
      "title": "Complete Multivitamin + Immunity Boost, 60 ct.",
      "vendor": "Minimo Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/IMG_0787.png?v=1788036176",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "complete",
        "multivitamin",
        "immunity",
        "boost",
        "minimo",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 13,
        "formulation": 11,
        "manufacturing": 10,
        "safety": 10,
        "transparency": 6,
        "sustainability": 5
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830143176901",
      "vsf_explanation": "A daily multivitamin with added 'immunity boost' framing centred on vitamin C and zinc. Multivitamin category evidence remains mixed (USPSTF 2022 insufficient for CVD/cancer prevention, COSMOS-Mind modest cognitive benefit in older adults). Immune-boost framing is technically true for correction of specific deficiencies — zinc deficiency impairs innate immunity, vitamin C deficiency (scurvy) is an immune catastrophe — but 'boost' implies above-baseline enhancement that supplementation in a well-nourished person does not reliably produce. Real supported immune claims: zinc lozenges may shorten cold duration when started at symptom onset; vitamin C daily may shorten cold duration slightly (Cochrane 8-14%). Solid low-Standard on the mixed evidence base and missing per-ingredient milligram disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "digestive-enzyme-pro-blend-60-ct",
      "title": "Digestive Enzyme Pro Blend, 60 ct.",
      "vendor": "Minimo Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1752341258129-generated-label-image-0.jpg?v=1788036176",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "digestive",
        "enzyme",
        "pro",
        "blend",
        "minimo",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 12,
        "formulation": 12,
        "manufacturing": 10,
        "safety": 10,
        "transparency": 6,
        "sustainability": 5
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830143275205",
      "vsf_explanation": "A digestive enzyme blend targeting fat, protein, and carbohydrate breakdown, with mention of Aspergillus oryzae as a fungal-source enzyme. Prescription pancreatic enzyme replacement (pancrelipase) has clear evidence in pancreatic insufficiency (cystic fibrosis, chronic pancreatitis). OTC broad-spectrum enzyme blends in healthy adults have weaker evidence — some symptomatic benefit for post-meal bloating, gas, and fullness has been reported in small trials, but effects are inconsistent. Aspergillus oryzae-derived amylase and protease are legitimate enzyme sources. The description does not itemise per-enzyme activity units (measured in DU, HUT, FCC), which is the transparency bar for enzyme products. Standard tier on the strength of ingredients and reasonable mechanism, held back by unit-of-activity opacity.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "smart-body-tape-measure-cf10a",
      "title": "Smart Body Tape Measure CF10A",
      "vendor": "Arboleaf",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CF10A-main.png?v=1788036198",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "smart",
        "body",
        "tape",
        "measure",
        "cf10a",
        "arboleaf"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "smartwatches"
      ],
      "vsf_dimensions": {
        "evidence": 12,
        "formulation": 12,
        "manufacturing": 10,
        "safety": 12,
        "transparency": 6,
        "sustainability": 4
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830143537349",
      "vsf_explanation": "A consumer-grade Bluetooth tape measure that syncs body circumferences to the Arboleaf app, computes derived body-composition estimates, and connects to Apple Health, Google Fit, and Fitbit. As a category, tape measurements of waist, hip, thigh, arm, and neck are legitimately useful — waist circumference in particular has strong outcome-linked evidence as a cardiometabolic risk marker, arguably better than BMI for many purposes. The scoring drag is on the 'body composition stats' framing: derived-composition estimates from circumference-only measurements are indirect predictions (Navy method, Jackson-Pollock), not measurements — they should not be presented at the same confidence as DEXA or BIA. Bluetooth accuracy for a smart tape depends on tension consistency, which users may not standardise. Solid Standard as a tracking convenience device; not a validated body-composition instrument.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mother-earth-labs-b-vitamin-formula-60-capsules",
      "title": "Mother Earth Labs B Vitamin Formula - 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Mother-Earth-Labs-B-Vitamin-Formula-60-Capsules.jpg?v=1788036544",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mother",
        "earth",
        "labs",
        "vitamin",
        "formula",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 72,
        "manufacturing": 60,
        "safety": 78,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 46.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830151237829",
      "vsf_explanation": "Mother Earth Labs B Vitamin Formula is a B-complex marketed with 'cell-ready' bioavailable forms rather than the cheaper synthetic forms found in most multivitamins. That formulation choice is legitimate and meaningful: methylfolate (5-MTHF) instead of folic acid, methylcobalamin instead of cyanocobalamin, P-5-P instead of pyridoxine, and R5P instead of riboflavin all improve utilization in users with common MTHFR gene variants and generally have better absorption characteristics. B-vitamin supplementation has genuine indication for older adults (B12 absorption declines with age), vegans (B12 is animal-derived), pregnant women (folate for neural tube defects), and users with documented deficiencies. For well-nourished general population, incremental benefit from B-complex supplementation is small. Mother Earth Labs's formulation approach earns credit; documentation is above average for the space but not at clinical-grade brand level. Standard-tier B-complex with legitimate formulation choices.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "5-nutrition-joint-defender-200-capsules",
      "title": "5% Nutrition Joint Defender - 200 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5-Nutrition-Joint-Defender-200-Capsules.jpg?v=1788036543",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrition",
        "joint",
        "defender",
        "200",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 40.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830151467205",
      "vsf_explanation": "5% Nutrition Joint Defender combines glucosamine, chondroitin sulfate, MSM, and KollaGen II-xs (undenatured type II collagen at 2 g). The joint-support category has mixed RCT evidence: glucosamine plus chondroitin has been studied extensively (GAIT trial and follow-ups) with modest benefit for moderate-to-severe osteoarthritis pain and minimal benefit for mild osteoarthritis or general joint 'maintenance' in healthy adults. MSM has some RCT support for OA pain at 3-6 g/day. Undenatured type II collagen (UC-II) has emerging RCT support at 40 mg/day (roughly 1/50th the 2 g dose 5% Nutrition uses — the higher dose is not necessarily better because the immunomodulatory mechanism has a threshold effect). 5% Nutrition's formulation covers the major joint ingredients but at doses that may miss ideal thresholds. Transparency and manufacturing documentation is below top tier. Standard-tier joint product for someone with mild-to-moderate joint discomfort; better-documented single-ingredient options exist.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "5-nutrition-core-fish-oil-120-softgels",
      "title": "5% Nutrition Core Fish Oil - 120 Softgels",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5-Nutrition-Core-Fish-Oil-120-Softgels.jpg?v=1788036544",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrition",
        "core",
        "fish",
        "oil",
        "120",
        "softgels",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 75,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830151729349",
      "vsf_explanation": "5% Nutrition Core Fish Oil is a basic EPA/DHA omega-3 supplement in softgel format. The ingredient — long-chain omega-3s from marine sources — has one of the strongest evidence bases in the supplement category, with RCT and meta-analytic support for triglyceride reduction, cardiovascular endpoints (in specific populations at higher doses), inflammatory-marker reduction, and neurological benefits. The evidence tier deserves a strong rating. Where this SKU takes hits is on formulation and transparency: 5% Nutrition does not typically publish specific EPA/DHA content per softgel with the precision of clinical-grade brands, does not publish IFOS (International Fish Oil Standards) or GOED certification for oxidation and heavy-metal testing, and does not disclose the specific fish species or sustainability certification (MSC, Friend of the Sea) that best-in-class brands do. The category ingredient is real; the specific SKU's execution is Standard-tier rather than Verified. A defensible cheap option; better-documented fish oils at similar or modest price premiums exist.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mother-earth-s-lugols-iodine-plus-90-capsules",
      "title": "Mother Earth’s Lugol's Iodine Plus, 90 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Mother-Earths-Lugols-Iodine-Plus-90-Capsules.jpg?v=1788036544",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mother",
        "earth",
        "lugol",
        "iodine",
        "plus",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 45,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 30.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830151303365",
      "vsf_explanation": "Mother Earth's Lugol's Iodine Plus delivers iodine in the Lugol's format (both molecular iodine I2 and iodide I-). Iodine is genuinely essential for thyroid hormone synthesis, and modest supplementation makes sense for populations with documented deficiency (pregnancy, restrictive diets that avoid iodized salt, seafood, and dairy). However, the framing that 'up to 90% of Americans may be deficient in iodine' overstates the evidence — surveillance data from NHANES shows median urinary iodine in the sufficient range for the US population, with pregnant women being the identifiable gap. High-dose Lugol's iodine supplementation (5-50 mg elemental iodine daily) exceeds the RDA (150 mcg for adults) by 30-300x and is a known trigger for both hyperthyroidism (Jod-Basedow phenomenon) and hypothyroidism (Wolff-Chaikoff effect) in susceptible individuals with autoimmune thyroid predisposition. The 'Iodine Plus' framing is common in the alternative-health iodine advocacy community but rests on contested claims about pharmacologic iodine's role in health. Safety score is reduced due to real thyroid-disruption risk. Standard-tier for the underlying nutrient; caution warranted on high-dose Lugol's specifically.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "5-nutrition-stage-ready-60-capsules",
      "title": "5% Nutrition Stage Ready - 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5-Nutrition-Stage-Ready-60-Capsules.jpg?v=1788036543",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrition",
        "stage",
        "ready",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 32,
        "manufacturing": 45,
        "safety": 22,
        "transparency": 38,
        "sustainability": 40
      },
      "price": 23.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830151434437",
      "vsf_explanation": "5% Nutrition Stage Ready is a diuretic supplement marketed as 'the most powerful diuretic on the market' using dandelion root, shavegrass, and uva ursi. The product is specifically positioned for competitive bodybuilders trying to reduce subcutaneous water in the final 3-7 days before a stage appearance. Herbal diuretics at high doses cause meaningful diuresis; they also cause electrolyte imbalances (especially potassium depletion), acute hypotension, muscle cramps, and in extreme cases cardiac arrhythmias. The bodybuilding-industry history includes documented deaths from stage-prep diuretic protocols (Andreas Munzer 1996 is the most cited case, from prescription diuretics; but herbal-diuretic-adjacent deaths and hospitalizations have been reported). The Rich Piana history the marketing invokes is itself a red flag — Piana died in 2017 at 46, and while cause of death was heart-related without direct diuretic attribution, the bodybuilding-industry pattern of stage-prep dehydration protocols correlates with cardiovascular events. Autofailed on unverified_medical_claim (the 'stage ready' positioning is a competitive-athletic-prep claim that oversells modest herbal diuretics' effects) and safety concerns for the target-user protocol. Not listable in current form.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "nutrabio-l-theanine-200-mg-90-capsules",
      "title": "NutraBio L-Theanine 200 mg - 90 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NutraBio-L-Theanine-200-mg-90-Capsules.jpg?v=1788036543",
      "score": 74,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "cognitive",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrabio",
        "theanine",
        "200",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 82,
        "manufacturing": 82,
        "safety": 88,
        "transparency": 88,
        "sustainability": 55
      },
      "price": 23.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830151499973",
      "vsf_explanation": "NutraBio L-Theanine 200 mg is a single-ingredient L-theanine capsule. L-theanine is a free-form amino acid from green tea with a well-supported RCT base for stress reduction, cognitive performance under stress, sleep-onset quality, and — most reliably — pairing with caffeine to blunt the jittery/anxious component while preserving alertness. Effect sizes are modest but consistent: EEG studies show alpha-wave increases within 30-60 minutes, subjective calm reports without sedation, and stress-response blunting in acute-stressor tasks. The classic caffeine-plus-theanine 1:2 ratio (100 mg caffeine + 200 mg theanine) has replicated well as a cognitive-enhancement stack. NutraBio's execution is single-ingredient, appropriately dosed at the well-tested 200 mg level, transparent-label, third-party tested. Very clean safety profile — L-theanine is essentially non-toxic at usable doses. Solid Verified-tier product; the ingredient's evidence base is real and the execution is best-in-class.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mother-earth-labs-essential-daily-essentials-120-capsules",
      "title": "Mother Earth Labs Essential Daily Essentials - 120 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Mother-Earth-Labs-Essential-Daily-Essentials-120-Capsules.jpg?v=1788036544",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mother",
        "earth",
        "labs",
        "essential",
        "daily",
        "essentials",
        "120",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 39.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830151270597",
      "vsf_explanation": "Mother Earth Labs Essential Multivitamin is a daily multivitamin positioned as 'the most bioavailable, cell-ready' with a 30-day money-back guarantee. Marketing claims of 'most bioavailable' are common in the multi category and rarely backed by head-to-head absorption studies against well-formulated competitors like Thorne Basic Nutrients or Pure Encapsulations O.N.E. Multi. Mother Earth Labs's use of methylated B vitamins, chelated minerals, and other bioavailable forms is a legitimate formulation choice but does not make them uniquely bioavailable versus other clinical-grade multis using the same approach. The multivitamin category itself has modest RCT support for hard endpoints in well-nourished adults; genuine indication is for gap-filling in restrictive diets, older adults with reduced absorption, and identified deficiencies. Documentation is above sport-supplement average but not at clinical-grade brand level. Standard-tier competent multi.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrabio-taurine-powder-500g",
      "title": "NutraBio Taurine Powder - 500g",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NutraBio-Taurine-Powder-500g.jpg?v=1788036543",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrabio",
        "taurine",
        "powder",
        "500g",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 80,
        "manufacturing": 82,
        "safety": 82,
        "transparency": 88,
        "sustainability": 55
      },
      "price": 22.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830151532741",
      "vsf_explanation": "NutraBio Taurine is a bulk single-ingredient taurine powder. Taurine has one of the more interesting and expanding evidence bases in the amino-acid supplement category: RCT support for cardiovascular endpoints (blood-pressure reduction, endothelial function), exercise performance (endurance and time-to-exhaustion), oxidative-stress markers, and — more recently — longevity signals (2023 Science paper on taurine deficiency in aging). Effective daily doses range from 1-6 g/day depending on the endpoint. Taurine is well-tolerated with a very clean safety profile (functional food status in most jurisdictions, wide safety margin). NutraBio's execution is single-ingredient, transparent-label, third-party tested — the standard NutraBio approach. Bulk powder format allows dose flexibility for different use cases (1-2 g cardiovascular, 3-6 g exercise performance). Solid Verified-tier product with growing evidence base and clean execution.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hosstile-cdx-cluster-dextrin",
      "title": "Hosstile CDX Cluster Dextrin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Hosstile-CDX-Cluster-Dextrin_c78a4578.jpg?v=1788036543",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hosstile",
        "cdx",
        "cluster",
        "dextrin",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 78,
        "transparency": 68,
        "sustainability": 45
      },
      "price": 47.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830151336133",
      "vsf_explanation": "Hosstile CDX is a highly-branched cyclic dextrin (HBCD) carbohydrate powder for intra-workout and post-workout use. HBCD is a legitimate specialty carbohydrate: enzymatically-produced from waxy maize starch, it has a very low osmolality despite its high molecular weight, which means it clears the stomach faster than dextrose or maltodextrin, produces less GI distress at high intake rates, and delivers rapid glycogen replenishment. RCT support exists for HBCD's use in endurance athletes and hard intra-workout carb loading. For a general resistance-training user with adequate daily carbs from food, HBCD is a convenience premium, not a physiological requirement. Hosstile is a straightforward single-ingredient HBCD product. Formulation is honest, safety at label doses is fine. The tier is capped at Standard because HBCD provides a modest edge over cheaper maltodextrin only in specific high-carb-intake scenarios (endurance training over 90 minutes, ultra-high-volume resistance sessions, competitive athletes optimizing intra-workout fueling). Standard-tier specialty carb.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrabio-magnesium-200-mg-120-capsules",
      "title": "NutraBio Magnesium 200 mg - 120 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NutraBio-Magnesium-200-mg-120-Capsules.jpg?v=1788036543",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrabio",
        "magnesium",
        "200",
        "120",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 78,
        "manufacturing": 82,
        "safety": 82,
        "transparency": 88,
        "sustainability": 55
      },
      "price": 21.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830151565509",
      "vsf_explanation": "NutraBio Magnesium 200 mg is a single-ingredient magnesium capsule. Magnesium is an essential mineral with widespread US population intake gaps: NHANES data suggests roughly 50% of adults have magnesium intakes below the estimated average requirement. Magnesium supplementation has RCT support for blood pressure reduction (modest effect), sleep quality, muscle cramp prevention, glucose regulation, and general cardiovascular support. The evidence base is solid across multiple endpoints. The critical spec that this SKU's label needs to disclose is the specific magnesium compound: magnesium oxide (cheapest, poor absorption), magnesium citrate (good absorption, some laxative effect), magnesium glycinate (very good absorption, best for sleep and cramps), magnesium malate (good absorption, energy-supportive), or magnesium threonate (specialized for cognitive endpoints). NutraBio's specific version should specify. Score assumes a bioavailable form (glycinate or citrate typical for NutraBio); if oxide, score would drop. Transparent-label execution and third-party testing. Solid Verified-tier essential mineral supplement.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mother-earth-labs-live-active-core-daily",
      "title": "Mother Earth Labs Live Active - Core Daily",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Mother-Earth-Labs-Live-Active-Core-Daily.jpg?v=1788036544",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mother",
        "earth",
        "labs",
        "live",
        "active",
        "core",
        "daily",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 36,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830151631045",
      "vsf_explanation": "Mother Earth Labs Live Active Core Daily is another multivitamin/foundational entry in the Mother Earth Labs line, positioned as a daily energy/wellness formula. The critique of Mother Earth Labs's multi products applies: bioavailable forms are a real formulation plus, but the 'core daily' positioning does not clearly differentiate this SKU from their other multivitamin offerings (Comprehensive Core, Essential Daily Essentials), suggesting SKU proliferation more than distinct product logic. The multivitamin category has modest RCT support for hard endpoints in well-nourished adults. Documentation is decent for the space but not clinical-grade. Standard-tier acceptable multi; overlap with other Mother Earth Labs multis creates confusion about which product to choose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "project-ad-ravenous",
      "title": "Project AD Ravenous",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Project-AD-Ravenous.webp?v=1788036543",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "project",
        "ravenous",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 42,
        "sustainability": 45
      },
      "price": 31.96,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830151762117",
      "vsf_explanation": "Project AD Ravenous is an appetite/digestion/nutrient-utilization formula combining enzyme and herbal complexes. Appetite-enhancement supplements for bulking-phase bodybuilders are a legitimate niche market, but the ingredient categories used (bitter herbs, digestive enzymes, sometimes ghrelin-adjacent botanicals) rest on inferential rather than outcome-level RCT evidence for appetite stimulation, and Project AD's formulas historically use proprietary blend disclosure. Without per-ingredient dosing, the enzyme complex and herbal-appetite matrix cannot be evaluated for whether individual ingredients hit thresholds. Autofailed on proprietary_blend_hides_dose. Digestive enzymes for a healthy adult eating standard meals are largely unnecessary (endogenous pancreatic enzymes handle typical protein/fat/carb loads); their utility is for specific malabsorption states or very large calorie loads. Not listable in current form; would score Standard with full disclosure and modest evidence base.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "efx-kre-alkalyn-120-capsules",
      "title": "EFX Kre-Alkalyn - 120 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/EFX-Kre-Alkalyn-120-Capsules.jpg?v=1788036543",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "efx",
        "kre",
        "alkalyn",
        "120",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 65,
        "safety": 78,
        "transparency": 70,
        "sustainability": 45
      },
      "price": 27.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830151696581",
      "vsf_explanation": "This is the 120-capsule SKU of EFX Kre-Alkalyn, same product as the 260-capsule version just in a smaller pack size. Same evaluation applies: Kre-Alkalyn is a buffered creatine monohydrate (pH 12), Informed Sport certified banned-substance-free. The Informed Sport certification is a genuine plus for competitively-tested athletes. The problem is the underlying premise: independent head-to-head RCTs comparing Kre-Alkalyn to plain creatine monohydrate at matched creatine content have found no consistent, clinically meaningful advantage on strength, hypertrophy, or performance endpoints. The 'crushes strength gains' marketing citation to the Bulgarian weightlifter study is a small, unblinded, sponsor-funded study that has not been independently replicated. Standard tier for tested-athlete value from the Informed Sport certification; the price premium over plain monohydrate is hard to justify on scientific evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mother-earth-labs-live-active-ageless-me",
      "title": "Mother Earth Labs Live Active - Ageless ME",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Mother-Earth-Labs-Live-Active-Ageless-ME.jpg?v=1788036544",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mother",
        "earth",
        "labs",
        "live",
        "active",
        "ageless",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 46.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830151598277",
      "vsf_explanation": "Mother Earth Labs Ageless ME is an anti-aging beauty-from-within product positioned for skin elasticity, wrinkle reduction, hair and nail nourishment. Anti-aging beauty supplements typically combine collagen peptides, vitamin C, biotin, hyaluronic acid, and various antioxidants. Individual ingredients have varying evidence tiers: collagen peptides at 5-15 g/day have RCT support for modest improvements in skin hydration and elasticity; vitamin C is a required cofactor for collagen synthesis; biotin's role in hair/nail growth in non-deficient adults is minimal despite heavy marketing; hyaluronic acid oral supplementation has some RCT support for skin hydration. The 'reduce wrinkles and sagging skin' language edges toward specific benefit claims that outpace the modest effect sizes actually documented in RCTs. Without ingredient-level dose disclosure, the specific evidence-hitting doses cannot be verified. Score is bounded at Standard because the category's honest evidence is modest and the marketing claims oversell what the ingredients deliver.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrabio-zma-90-capsules",
      "title": "NutraBio ZMA - 90 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NutraBio-ZMA-90-Capsules.jpg?v=1788036543",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrabio",
        "zma",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 78,
        "manufacturing": 82,
        "safety": 78,
        "transparency": 88,
        "sustainability": 55
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830151663813",
      "vsf_explanation": "NutraBio ZMA delivers the original patented ZMA blend: zinc monomethionine aspartate, magnesium aspartate, and vitamin B6. The formulation was developed by Victor Conte's BALCO Labs in the 1990s with early studies showing testosterone-support and sleep-quality effects in athletes with zinc deficiency. The evidence base is more mixed than the marketing suggests: the original testosterone-boosting studies were in athletes with documented zinc/magnesium gaps (real deficiency correction can meaningfully affect hormones); subsequent RCTs in non-deficient trained athletes have shown minimal testosterone or performance effects. The sleep-quality effect is more consistent, driven primarily by the magnesium component. NutraBio's execution is transparent-label, third-party tested, and delivers the standard patented formulation cleanly. Standard-tier for a legitimate zinc/magnesium/B6 combination product; the testosterone-boost framing outpaces the trained-athlete RCT evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hi-tech-pharmaceuticals-berberine-hcl-120-capsules",
      "title": "Hi-Tech Pharmaceuticals Berberine HCL - 120 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Hi-Tech-Pharmaceuticals-Berberine-HCL-120-Capsules.jpg?v=1788036544",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tech",
        "pharmaceuticals",
        "berberine",
        "hcl",
        "120",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 68,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 38.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830151860421",
      "vsf_explanation": "Hi-Tech Berberine HCL uses their proprietary Nexrutine XS delivery system claiming 10x bioavailability improvement over standard berberine with extended retention time. Berberine itself is one of the more evidence-backed botanicals in the metabolic-health category: multiple RCTs and meta-analyses support meaningful effects on fasting glucose, HbA1c, LDL cholesterol, and triglycerides — effect sizes in some studies approach those of metformin for glucose management. Standard berberine has notoriously poor oral bioavailability (roughly 1%) requiring 500 mg three times daily doses to achieve therapeutic effect. Any legitimate bioavailability enhancement is genuinely valuable. Nexrutine XS's claimed 10x improvement is manufacturer-sponsored data — independent replication is limited. Hi-Tech's regulatory history (FDA warning letters on other product lines) is a documentation flag but berberine specifically is a well-characterized commodity ingredient. Score is bounded by brand-level documentation quality and the fact that the bioavailability claim rests on sponsor-funded studies. Standard tier for a real ingredient in a marketing-enhanced format.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrabio-glutamine",
      "title": "NutraBio Glutamine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NutraBio-Glutamine.jpg?v=1788036544",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrabio",
        "glutamine",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 78,
        "manufacturing": 82,
        "safety": 82,
        "transparency": 88,
        "sustainability": 55
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830151794885",
      "vsf_explanation": "NutraBio Glutamine is a single-ingredient fermented L-glutamine powder. Glutamine has been aggressively marketed for muscle recovery for decades but its RCT evidence for muscle building in normal-diet resistance athletes is thin — most well-designed studies in adequately-fed lifters show minimal effect on hypertrophy or strength versus placebo. Where glutamine has legitimate RCT support: immune modulation in high-volume endurance athletes and post-exercise upper-respiratory-infection risk reduction, gut-barrier integrity in leaky-gut and intestinal-permeability contexts, and clinical use in surgical recovery, burn patients, and critical illness where catabolic states create genuine glutamine demand. NutraBio delivers clean single-ingredient glutamine, transparent-label, third-party tested — the execution is Verified-tier but the ingredient's actual evidence for the marketed muscle-building use case is Standard-tier. Solid product for the legitimate use cases; oversold for the marketing use case.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "revive-kidney-support-supplement",
      "title": "Revive Kidney Support Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Revive-Kidney-Support-Supplement.jpg?v=1788036543",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "revive",
        "kidney",
        "support",
        "supplement",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 68,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 54.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830151925957",
      "vsf_explanation": "Revive Kidney Support is a botanical formula positioned for kidney health and function, vegan-friendly and gluten-free. Revive is a legitimate DTC clean-label brand generally recognized for reasonable formulation choices and disclosed dosing. The kidney-support category itself is evidence-limited — no oral supplement has cleared the FDA/EMA evidentiary bar for kidney-protective claims, and kidney disease is a specific medical diagnosis requiring nephrology care, not a supplement solution. Botanical ingredients commonly used in kidney-support formulas (astragalus, dandelion, uva ursi, cranberry, nettle, buchu) have varying levels of traditional-use and modest clinical evidence for adjacent endpoints (urinary-tract infection prevention, diuretic effects) but limited RCT support for actual renal function improvement in either healthy adults or in chronic kidney disease patients. Score is bounded at Standard by the modest evidence tier and the category-level concern that kidney support is not a supplement category with strong outcome data.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mother-earth-labs-live-active-joint-fortify",
      "title": "Mother Earth Labs Live Active - Joint Fortify",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Mother-Earth-Labs-Live-Active-Joint-Fortify.jpg?v=1788036544",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mother",
        "earth",
        "labs",
        "live",
        "active",
        "joint",
        "fortify",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 54.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830151893189",
      "vsf_explanation": "Mother Earth Labs Joint Fortify is a joint-support formula in the Live Active line. Joint-support supplements typically combine glucosamine, chondroitin, MSM, collagen (types I/II), boswellia, turmeric, and hyaluronic acid. Individual ingredients have varying evidence: glucosamine plus chondroitin has modest RCT support for moderate-to-severe osteoarthritis pain (GAIT trial and follow-ups); MSM has small effect sizes at 3-6 g/day; UC-II undenatured type II collagen has emerging RCT support at 40 mg/day; turmeric/curcumin at bioavailable-enhanced doses has meta-analytic support for OA pain. Without ingredient-level dose disclosure, individual ingredient effectiveness cannot be verified. Mother Earth Labs's documentation is above average for the space. Standard-tier joint product with reasonable ingredient philosophy; per-ingredient dosing questions cap the tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "species-nutrition-v-mineralyze",
      "title": "Species Nutrition V-Mineralyze",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Species-Nutrition-V-Mineralyze.jpg?v=1788036544",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "species",
        "nutrition",
        "mineralyze",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 49.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830153793733",
      "vsf_explanation": "Species Nutrition V-Mineralyze is a chelated calcium and magnesium formula fortified with vitamin D3 and blueberry extract. Calcium and magnesium chelates (glycinate, bisglycinate) are legitimately better-absorbed forms than oxide or carbonate versions. Vitamin D3 is the appropriate form for supplementation. Calcium supplementation is somewhat controversial in current cardiovascular literature — some meta-analyses suggest supplemental calcium (as opposed to dietary calcium) may modestly raise cardiovascular event risk in certain populations, though the finding is not universally accepted. Most experts recommend calcium primarily from food sources with supplementation reserved for identified gaps. Magnesium and vitamin D supplementation have better evidence bases (gaps are common in both). Species Nutrition's blueberry extract addition is diffuse — a small polyphenol dose in a mineral formula is marketing decoration. Standard-tier essential-mineral formula with reasonable form choices; calcium supplementation warrants individualized consideration rather than default use.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ghost®-basics-digestive-enzymes",
      "title": "Ghost® Basics Digestive Enzymes",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Ghost-Basics-Digestive-Enzymes.jpg?v=1788036544",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ghost",
        "basics",
        "digestive",
        "enzymes",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 65,
        "manufacturing": 65,
        "safety": 78,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 39.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830151958725",
      "vsf_explanation": "Ghost Basics Digestive Enzymes is positioned as a pre-meal enzyme supplement to reduce bloating after protein-heavy meals. Digestive enzyme supplementation for a healthy adult is a limited-utility category: endogenous pancreatic amylase, lipase, and proteases are generally sufficient for typical mixed meals with normal digestive function. Where enzyme supplementation has real utility: very large single-meal protein loads (over 50 g), specific malabsorption states (pancreatic insufficiency, cystic fibrosis, some post-surgical states), lactase for lactose intolerance, alpha-galactosidase for legume/cruciferous vegetable gas, and clinical exocrine pancreatic insufficiency. For general 'high protein means need enzymes' framing, the physiological requirement is small. Ghost's Basics line is generally cleaner and more transparent than their proprietary-blend performance products. Standard-tier product for a specific-use case; oversold as general daily necessity.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mother-earth-labs-probiotics-30-capsules",
      "title": "Mother Earth Labs Probiotics - 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Mother-Earth-Labs-Probiotics-30-Capsules.jpg?v=1788036543",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mother",
        "earth",
        "labs",
        "probiotics",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 24.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830152155333",
      "vsf_explanation": "Mother Earth Labs Probiotics delivers 20 billion CFUs across 9 clinically studied strains with acid-resistant delivery. The probiotic category is more complex than most marketing suggests: strain specificity matters enormously — clinical effects documented for one Lactobacillus rhamnosus strain do not necessarily apply to other L. rhamnosus products. For general 'gut microbiome support' in healthy adults, RCT evidence for lasting microbiome shifts is limited; probiotics typically transit the gut without permanent colonization. Genuine RCT-supported indications: antibiotic-associated diarrhea prevention (multiple specific strains), traveler's diarrhea prevention (Saccharomyces boulardii), IBS symptom management for specific strains, and infant colic (L. reuteri DSM 17938 specifically). The 20 billion CFU dose is in a reasonable therapeutic range. Without specific strain-and-dose disclosure to match clinical evidence, general 'gut health' claims outpace what specific strain-dose combinations have demonstrated. Standard-tier general probiotic; strain-specific single-purpose products often deliver more evidence-matched effects.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "raw-nutrition-christophers-juicy-pumps",
      "title": "Raw Nutrition Christopher's Juicy Pumps",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Raw-Nutrition-Christophers-Juicy-Pumps.webp?v=1788036543",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "raw",
        "nutrition",
        "christopher",
        "juicy",
        "pumps",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 39.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830151991493",
      "vsf_explanation": "RAW Nutrition Juicy Pumps is a Chris Bumstead-signature non-stim pump product marketed for late-night sessions and pre-workout stacking. Non-stim pump formulas typically combine citrulline, glycerol (HydroMax or similar), betaine, potentially agmatine, and various trademarked pump ingredients (Vasodrive-AP, S7, HydroPrime). If per-ingredient doses hit clinical thresholds (citrulline 6-8 g, glycerol 1.5-3 g elemental glycerol, betaine 2.5 g), the product delivers a real pump effect. RAW Nutrition CBUM formulas historically use proprietary-blend disclosure for pump matrices, which autofails on proprietary_blend_hides_dose. The signature-athlete branding adds price premium without corresponding transparency improvement. Not listable in current form; would score in Standard range with full disclosure and if the main actives are dosed at clinical thresholds.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "innovapharm-novapump-neuro",
      "title": "InnovaPharm NovaPump Neuro",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/InnovaPharm-NovaPump-Neuro.webp?v=1788036544",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "innovapharm",
        "novapump",
        "neuro",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 48,
        "manufacturing": 52,
        "safety": 55,
        "transparency": 32,
        "sustainability": 45
      },
      "price": 54.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830152024261",
      "vsf_explanation": "InnovaPharm NovaPump Neuro is the stim-free pump plus nootropic version of NovaPump, adding a 'Neuro Enhancement Matrix' to the base pump formula. The base pump matrix and the Neuro Enhancement Matrix are both proprietary blend structures, hiding per-ingredient doses across at least two major matrices. Individual actives commonly used in this format (citrulline, glycerol, betaine for pumps; alpha-GPC, huperzine A, tyrosine, choline sources for cognition) can hit clinical thresholds when properly dosed, but with two overlapping proprietary blends the label cannot be evaluated for whether any specific ingredient reaches its evidence-supported dose. Autofailed on proprietary_blend_hides_dose. The 'mind-muscle connection' framing for a nootropic-plus-pump stack is marketing that outpaces the RCT literature (nootropics can support acute cognitive performance; whether that meaningfully translates to better resistance-training outcomes is not well-established). Not listable in current form.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "ghost®-clear-whey-protein",
      "title": "Ghost® Clear Whey Protein",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Ghost-Clear-Whey-Protein_41d37dab.jpg?v=1788036544",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ghost",
        "clear",
        "whey",
        "protein",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 75,
        "manufacturing": 70,
        "safety": 78,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 44.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830152188101",
      "vsf_explanation": "Ghost Clear Whey delivers 25 g whey protein isolate per serving in a light, juice-like clear-whey format with zero fat and zero sugar. Ghost is a legitimate mainstream sports brand with generally disclosed dosing on their Basics line. The base ingredient — hydrolyzed whey isolate — is a well-supported protein source at the standard 25 g dose that cleanly hits the muscle protein synthesis threshold. Ghost's clear-whey execution matches the category standard (Myprotein Clear Whey, NutraBio Clear Whey and others). Ghost's overall documentation is above sports-supplement average but not at NutraBio's per-lot COA level; the brand includes trademarked flavor-partnership products (Warheads, Sour Patch Kids) that carry additional marketing premium. Standard-tier competent clear whey; NutraBio's clear-whey version has more documentation at similar price.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrabio-multi-collagen-powder",
      "title": "NutraBio Multi Collagen Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NutraBio-Multi-Collagen-Powder.jpg?v=1788036544",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrabio",
        "multi",
        "collagen",
        "powder",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 78,
        "manufacturing": 82,
        "safety": 82,
        "transparency": 85,
        "sustainability": 55
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830152122565",
      "vsf_explanation": "NutraBio Multi Collagen combines types I, II, III, V, and X collagen from wild-caught fish, grass-fed bovine, chicken, and eggshell membrane sources, plus patented Astrion for collagen synthesis support. The multi-source collagen approach targets different collagen types found in different body tissues (I in skin and tendons, II in cartilage, III in blood vessels and skin, V in various connective tissues, X in bone). Hydrolyzed collagen at 5-15 g/day has real RCT support for modest improvements in skin hydration, skin elasticity, and joint discomfort — effect sizes are moderate but replicated. The mechanism is not that oral collagen becomes body collagen intact (proteins are hydrolyzed in the gut); it is that collagen-derived signaling peptides may stimulate fibroblast collagen synthesis. NutraBio's execution is transparent-label, multi-source (which is a real differentiation from single-source products), and third-party tested. Astrion's independent evidence is limited. Solid Standard-plus-tier collagen product; the category evidence caps ceiling.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "innovapharm-mvpre-3-0",
      "title": "InnovaPharm MVPre 3.0",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/InnovaPharm-MVPre-3_0.jpg?v=1788036544",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "innovapharm",
        "mvpre",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830152286405",
      "vsf_explanation": "InnovaPharm MVPre 3.0 is the flagship pre-workout in the MVPre line, positioned as an 'elite' formula for energy, pump, power, and focus. InnovaPharm formulas historically use proprietary-blend disclosure for the energy, pump, and nootropic matrices. Without per-ingredient dose disclosure across those three functional categories, the label cannot be evaluated for whether flagship ingredients (citrulline, beta-alanine, caffeine, alpha-GPC, tyrosine) hit clinical thresholds. Autofailed on proprietary_blend_hides_dose. The 'elite' positioning and 3.0 versioning suggest ongoing reformulations that make evaluation across product generations difficult. Even with disclosure, the flagship pre-workout category ceilings around Standard because well-executed pre-workouts converge on similar main-ingredient stacks (citrulline, beta-alanine, caffeine, taurine) that have well-characterized effect sizes. Not listable in current form.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "raw-nutrition-cbum-essential-pre-workout",
      "title": "Raw Nutrition CBUM Essential Pre-Workout",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Raw-Nutrition-CBUM-Essential-Pre-Workout_c3882199.webp?v=1788036544",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "raw",
        "nutrition",
        "cbum",
        "essential",
        "pre",
        "workout",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 68,
        "sustainability": 45
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830152483013",
      "vsf_explanation": "RAW Nutrition CBUM Essential Pre-Workout discloses specific doses for the main actives: 4 g L-citrulline, 3 g beta-alanine, 1 g betaine anhydrous, plus natural caffeine. The disclosed-dose approach saves this product from the autofail territory that catches many CBUM performance products. The dosing philosophy is 'essential' rather than 'maximum' — 4 g citrulline is at the low end of the clinical range (6-8 g is stronger), 3 g beta-alanine is right at the standard 3.2 g dose, and 1 g betaine is well below the 2.5 g clinical threshold. The caffeine dose depends on the specific label but appears to be moderate. The formulation is honest about being an 'essential' (lower-intensity) pre-workout for daily-driver use rather than maximum-performance stacking. Solid Standard-tier disclosed-dose product. Not autofail, not Verified — because the doses are conservative rather than maximum and documentation is not at clinical-grade level.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "raw-nutrition-cbum-itholate-2-lb",
      "title": "Raw Nutrition CBUM Itholate - 2 lb",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Raw-Nutrition-CBUM-Itholate-2-lb.webp?v=1788036544",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "raw",
        "nutrition",
        "cbum",
        "itholate",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 70,
        "manufacturing": 60,
        "safety": 75,
        "transparency": 60,
        "sustainability": 45
      },
      "price": 49.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830153138373",
      "vsf_explanation": "RAW Nutrition CBUM Itholate is a 25 g whey protein isolate serving formulated by Chris Bumstead. The base product — micro-filtered whey isolate at 25 g/scoop with low fat and low carbs — is a straightforward proven protein source that cleanly hits the muscle protein synthesis threshold. Isolate specifically (as opposed to concentrate or blend) reduces lactose content to under 1%, making it comfortable for mild lactose intolerance and appropriate for post-workout use. The 'Thavage lifestyle' branding is athlete-signature marketing. RAW Nutrition's documentation is decent for the sports space but not at NutraBio-level per-lot COA publication. The 2 lb tub size is a reasonable consumer trial size. Standard-tier competent whey isolate; the athlete-signature premium is real, and better-documented isolates at similar price points exist.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "raw-nutrition-cbum-whey-blend-5-lb",
      "title": "Raw Nutrition CBUM Whey Blend - 5 lb",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Raw-Nutrition-CBUM-Whey-Blend-5-lb.jpg?v=1788036544",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "raw",
        "nutrition",
        "cbum",
        "whey",
        "blend",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 68,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 58,
        "sustainability": 45
      },
      "price": 96.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830153695429",
      "vsf_explanation": "RAW Nutrition CBUM Whey Blend is a Chris Bumstead-signature microfiltered whey blend at 25 g protein per scoop with low fat and low carbs. The base ingredient — microfiltered whey blend — is a legitimate protein source at the standard 25 g dose that cleanly hits the muscle-protein-synthesis threshold. The 'micro-filtered whey protein blend' description suggests a mix of whey concentrate and whey isolate rather than pure isolate; that is a normal formulation choice that reduces cost while retaining most of the muscle-building effect. Transparency concerns hold the score at Standard: 'blend' without specifying the isolate/concentrate ratio, the specific processing details, and per-lot COA publication is not at NutraBio-level. Chris Bumstead's signature branding adds a marketing premium without adding demonstrable formulation quality. The base product is fine for post-workout use; better-documented isolates at similar prices exist. Standard-tier signature-athlete whey.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrifitt-lee-priest-crucifix",
      "title": "Nutrifitt Lee Priest Crucifix",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nutrifitt-Lee-Priest-Crucifix.webp?v=1788036552",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrifitt",
        "lee",
        "priest",
        "crucifix",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 50,
        "transparency": 32,
        "sustainability": 45
      },
      "price": 49.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830153924805",
      "vsf_explanation": "Nutrifitt CRUCIFIX is a Lee Priest-branded pre-workout marketed as a high-intensity performance formula. Bodybuilder-signature pre-workouts historically lean on proprietary blends with high-stim doses to deliver the 'aggressive' pre-workout experience the target market wants. Without disclosed per-ingredient doses across the pump/stim/nootropic matrices, this autofails on proprietary_blend_hides_dose. High-stim signature pre-workouts also carry safety concerns: total caffeine loads over 400 mg per serving are common in this genre, sometimes with undisclosed yohimbine or DMHA-class stimulants, and stacking with other caffeinated products can push single-session caffeine over 600 mg. The signature-athlete branding adds a marketing premium without adding disclosed formulation quality. Not listable in current form; would score in Standard range with full disclosure and moderate stimulant loading.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "nutrabio-nac-90-capsules",
      "title": "NutraBio NAC - 90 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NutraBio-NAC-90-Capsules.jpg?v=1788036687",
      "score": 74,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrabio",
        "nac",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 80,
        "manufacturing": 82,
        "safety": 78,
        "transparency": 88,
        "sustainability": 55
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830155661509",
      "vsf_explanation": "NutraBio NAC (N-acetyl-cysteine) is a single-ingredient NAC capsule with transparent-label documentation. NAC has one of the better evidence bases in the antioxidant category: as a glutathione precursor, it has RCT support for acetaminophen overdose (FDA-approved indication in IV form), for COPD/bronchitis mucolytic effects at 600-1800 mg/day, and increasingly for oxidative-stress markers and specific inflammatory conditions. Multiple meta-analyses support its effect on glutathione levels and oxidative-stress markers; effect sizes on downstream clinical endpoints are smaller and condition-specific. NutraBio delivers a well-dosed single-ingredient version at 600 or 900 mg per capsule (typical NutraBio format) with published third-party testing. Safety is generally good but not perfect — chronic high-dose NAC can occasionally cause GI discomfort and rarely paradoxical oxidative effects. Note: FDA has periodically challenged NAC's status as a dietary supplement (arguing its 1963 pharmaceutical approval precedes DSHEA), an ongoing regulatory tension that has not affected commercial availability. Solid Verified-tier single-ingredient antioxidant.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrabio-hmb-120-capsules",
      "title": "NutraBio HMB, 120 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NutraBio-HMB-120-Capsules.jpg?v=1788036687",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrabio",
        "hmb",
        "120",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 75,
        "manufacturing": 82,
        "safety": 78,
        "transparency": 88,
        "sustainability": 55
      },
      "price": 21.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830155694277",
      "vsf_explanation": "NutraBio HMB (beta-hydroxy beta-methylbutyrate) delivers 1,000 mg per serving. HMB is a metabolite of leucine that has been studied for muscle-anti-catabolic effects at 3 g/day (typically as 3 x 1 g doses). The evidence picture is mixed: RCTs in untrained novice lifters show meaningful anti-catabolic and lean-mass benefits; RCTs in trained athletes show much smaller effect sizes, and some well-designed trained-athlete studies show no significant benefit versus placebo. The 2017 ISSN position stand endorses HMB at 3 g/day; independent meta-analyses have been more skeptical about trained-athlete effects. NutraBio delivers a single-ingredient version at a proper 1 g/dose, transparent-label, third-party tested — the execution is clean. The score is capped at Standard because the ingredient's evidence tier is genuinely mixed for the audience most likely to buy it (trained lifters). For older adults, injured athletes returning to training, or in catabolic states, HMB has stronger support and this format delivers it well.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrabio-beta-alanine-powder",
      "title": "NutraBio Beta Alanine Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NutraBio-Beta-Alanine-Powder.jpg?v=1788036686",
      "score": 76,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrabio",
        "beta",
        "alanine",
        "powder",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 82,
        "formulation": 82,
        "manufacturing": 82,
        "safety": 82,
        "transparency": 88,
        "sustainability": 55
      },
      "price": 35.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830155727045",
      "vsf_explanation": "NutraBio Beta-Alanine is a single-ingredient beta-alanine powder — a well-established sports-nutrition amino acid. Beta-alanine at the standard 3.2 g/day loading dose (or split 1.6 g twice daily) raises muscle carnosine content over roughly 4 weeks, and elevated muscle carnosine buffers hydrogen-ion accumulation during high-intensity exercise. The RCT evidence is strong for high-repetition, all-out efforts in the 1-4 minute range (rowing 2K, cycling max efforts, weightlifting sets of 15-30 reps). Effect sizes are modest but consistent — a 2-3% improvement in time-to-exhaustion or work capacity in the target duration. NutraBio's single-ingredient transparent-label format delivers the standard clinical dose cleanly. The paresthesia (tingling sensation) is a well-known and harmless dose-dependent effect that fades with continued use. Solid Verified-tier ingredient with well-characterized mechanism and appropriate dosing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrabio-l-arginine-powder",
      "title": "NutraBio L-Arginine Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nutrabio-L-Arginine-Powder.jpg?v=1788036687",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrabio",
        "arginine",
        "powder",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 78,
        "manufacturing": 82,
        "safety": 78,
        "transparency": 88,
        "sustainability": 55
      },
      "price": 23.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830155759813",
      "vsf_explanation": "NutraBio L-Arginine Powder is a single-ingredient HPLC-verified L-arginine powder positioned for nitric oxide, growth hormone, and pump effects. The RCT evidence for oral L-arginine is more nuanced than the marketing suggests: while arginine is the direct substrate for nitric oxide synthesis, oral supplementation is limited by low bioavailability (roughly 20% due to hepatic first-pass arginase metabolism), and human studies at doses under 6 g/day often show minimal plasma NO uplift. L-citrulline, which the body converts to arginine downstream of first-pass metabolism, has largely displaced L-arginine as the preferred oral NO precursor because it produces higher and more sustained plasma arginine levels than direct arginine dosing. Growth-hormone-stimulation effects require very high doses (12-15 g) that most users will not take. NutraBio's execution is transparent and clean; the ingredient itself is honestly a Standard-tier choice mostly because citrulline usually outperforms it at similar cost. A defensible pick for anyone with a specific reason to prefer arginine.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "innovapharm-mvpre-365",
      "title": "InnovaPharm MVPre 365",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/InnovaPharm-MVPre-365.jpg?v=1788036687",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "innovapharm",
        "mvpre",
        "365",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830155792581",
      "vsf_explanation": "InnovaPharm MVPre 365 is a nootropic-plus-moderate-stimulant pre-workout positioned as 'daily-driver' for energy, focus, and endurance. The marketing framing highlights nootropics and 'moderate' stimulants without disclosed doses in the primary marketing copy. InnovaPharm formulas historically use proprietary-blend disclosure for the nootropic and stimulant matrices, which autofails on proprietary_blend_hides_dose. The 'daily-driver' positioning (implying 365-day use) is a safety concern independently — chronic daily caffeine plus nootropic stimulant stacks build tolerance and can produce adrenal-fatigue-adjacent symptoms and sleep degradation over 6-12 months. Even individual ingredients well-selected would need per-ingredient dose disclosure to evaluate whether the cognitive-enhancement ingredients (typically alpha-GPC, huperzine A, tyrosine, choline sources) clear their clinical thresholds. Not listable in current form.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "nutrabio-dim-60-capsules",
      "title": "NutraBio DIM - 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NutraBio-DIM-60-Capsules.jpg?v=1788036687",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrabio",
        "dim",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 75,
        "manufacturing": 82,
        "safety": 68,
        "transparency": 85,
        "sustainability": 55
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830155890885",
      "vsf_explanation": "NutraBio DIM combines diindolylmethane (DIM), calcium-D-glucarate, and BioPerine for estrogen-metabolism support. DIM is a metabolite of indole-3-carbinol from cruciferous vegetables, and RCT-adjacent evidence supports its modulating effect on estrogen-2/16 hydroxylation ratios (favoring the '2-hydroxy' pathway associated with more favorable estrogen metabolism). The evidence is stronger for the biochemistry than for hard clinical endpoints — DIM does shift measurable estrogen-metabolite ratios, but claims about body composition, hormone balance for muscle building, or general 'estrogen detox' rest on inferential logic more than on outcome-level RCTs. Calcium-D-glucarate supports the glucuronidation pathway, which is a reasonable adjunct for supporting hepatic estrogen conjugation. NutraBio delivers 100 mg DIM plus supporting ingredients in a transparent-label format with third-party testing. Standard-tier for a legitimate estrogen-metabolism-support use case; not Verified because outcome-level clinical evidence remains modest.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bucked-up-golf-shot",
      "title": "Bucked Up Golf Shot",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Bucked-Up-Golf-Shot.webp?v=1788036687",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bucked",
        "golf",
        "shot",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 52,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 42,
        "sustainability": 45
      },
      "price": 2.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830155923653",
      "vsf_explanation": "Bucked Up Golf Shot (a rebrand of Buck Shot Energy) is an energy/focus/mood shot marketed for daytime cognitive performance during golf and general productivity. The category (functional energy shots) has mixed evidence — caffeine plus nootropic combinations produce measurable acute cognitive effects, but formula-specific proprietary blending typical of Bucked Up hides per-ingredient doses. Without disclosure it is impossible to evaluate whether nootropic ingredients (typically tyrosine, alpha-GPC, huperzine, choline sources) hit clinical thresholds or are label-decoration doses. The Bucked Up brand's overall use of proprietary blends across their line puts this SKU in the same autofail category. The specific golf positioning is marketing repositioning — the formula is likely a Buck Shot Energy variant with different flavoring and label design. Rejected on proprietary_blend_hides_dose. Even with disclosure the category ceilings around Standard because acute caffeine plus nootropic stacks have modest documented effect sizes.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "raw-nutrition-bum-energy-drink-12-for-2-06-each",
      "title": "Raw Nutrition Bum Energy Drink (12+ for $2.06/each)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Raw-Nutrition-Bum-Energy-Drink-12-for-2_06each.jpg?v=1788036687",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "raw",
        "nutrition",
        "bum",
        "energy",
        "drink",
        "for",
        "each",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 65,
        "safety": 68,
        "transparency": 70,
        "sustainability": 45
      },
      "price": 2.75,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830156021957",
      "vsf_explanation": "RAW Nutrition Bum Energy Drink combines natural caffeine with Cognizin Citicoline for daytime energy and focus. This is a ready-to-drink can product marketed with clean-label positioning (no sugar, no artificial colors). Natural caffeine at typical energy-drink dose (150-200 mg) delivers real acute cognitive and alertness effects. Cognizin Citicoline is a genuinely well-supported nootropic ingredient — RCTs at 250-500 mg support acute cognitive performance and attention effects. If the disclosed doses of both actives clear their clinical thresholds, this is a defensible functional-beverage entry. Raw Nutrition typically discloses main-active doses in labeling. Score is capped at Standard by the category — ready-to-drink energy beverages are convenient but rarely deliver differentiated evidence over disclosed-dose pre-workout powders or standalone caffeine plus citicoline capsules. Aluminum-can packaging is a sustainability negative. A reasonable Standard-tier daily-driver energy beverage with real actives.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mother-earth-labs-ph-support-formula-240-capsules",
      "title": "Mother Earth Labs pH Support Formula - 240 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Mother-Earth-Labs-pH-Support-Formula-240-Capsules_12558701.jpg?v=1788036691",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mother",
        "earth",
        "labs",
        "support",
        "formula",
        "240",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 67.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830156579013",
      "vsf_explanation": "Mother Earth Labs pH Support (formerly pH Balancer) is an all-in-one alkalinizer/adaptogen/superfood formula marketed to 'balance body pH' and 'replace your overflowing cabinet.' The core premise — that oral supplements can meaningfully alkalinize systemic body pH — is not supported by human physiology or clinical evidence. Blood pH is homeostatically maintained at 7.35-7.45 by the kidneys and respiratory system regardless of dietary intake; only urine pH varies with diet, and urine pH is not a health outcome. The 'acid-alkaline diet' or 'pH-balancing supplement' framing is a well-documented pseudoscientific model. This autofails on unverified_medical_claim because the entire product positioning rests on a mechanism that human physiology contradicts. The underlying ingredients (adaptogens, greens, minerals) may have their own individual effects, but the pH-balancing framing that unifies them is unverified. Not listable in current form; would require dropping the pH-balancing claim entirely and repositioning as a general adaptogen/superfood formula, at which point the diffuse-ingredient problem (many ingredients, fractional doses) would still cap it at Standard.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "mother-earth-labs-comprehensive-core-120-capsules",
      "title": "Mother Earth Labs Comprehensive Core - 120 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Mother-Earth-Labs-Comprehensive-Core-120-Capsules_e7ecaf1b.jpg?v=1788036691",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mother",
        "earth",
        "labs",
        "comprehensive",
        "core",
        "120",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 72.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830156611781",
      "vsf_explanation": "Mother Earth Labs Comprehensive Core is a daily multivitamin with added plant-based nutrients positioned for energy, focus, cardiovascular, and immune support. The multivitamin category has modest RCT evidence for general-population supplementation — most head-to-head trials in adequately-nourished adults show minimal effect on hard endpoints like cardiovascular events or cognitive decline. Where multivitamins earn genuine credit is filling nutrient gaps in restrictive diets, older adults with reduced absorption, and specific micronutrient shortfalls (D, B12, iodine). The 'comprehensive' framing with plant-based add-ins is a differentiation play — the additions do not meaningfully change the physiological effect of the core vitamins/minerals. Mother Earth Labs uses bioavailable forms (methylated B vitamins, chelated minerals typically) which is a legitimate formulation choice. Documentation is above average for the category but not at NutraBio/Thorne level. A defensible Standard-tier daily multi.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hi-tech-creatine-monohydrate-1000-g",
      "title": "Hi-Tech Creatine Monohydrate 1000 g",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Hi-Tech-Creatine-Monohydrate-1000-g.jpg?v=1788036691",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tech",
        "creatine",
        "monohydrate",
        "1000",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 92,
        "formulation": 65,
        "manufacturing": 45,
        "safety": 62,
        "transparency": 45,
        "sustainability": 42
      },
      "price": 54.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830156644549",
      "vsf_explanation": "Hi-Tech Creatine Monohydrate 1000 g is a straightforward single-ingredient creatine monohydrate powder. The active ingredient is best-in-category by RCT evidence — 500-plus trials, meta-analytic consensus for strength/lean-mass/exercise-performance uplift. The evidence dimension deserves a top score. Where this SKU takes hits is at the brand level: Hi-Tech Pharmaceuticals has a decades-long FDA warning-letter and civil-enforcement history for prohormone products, DMAA/DMHA stimulants, and unlawful drug claims. That corporate history does not mean the creatine specifically is compromised — creatine monohydrate is a well-characterized commodity ingredient and Hi-Tech buys it from the same manufacturers everyone else uses — but it reflects on the brand's overall documentation, third-party testing rigor, and regulatory reliability. Score is bounded by transparency and manufacturing dimensions rather than the active. A Standard-tier acceptable option if price-per-gram matters and the brand affiliation does not; better-documented monohydrate at similar price exists.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "purus-labs-noxygen-liquicaps",
      "title": "Purus Labs Noxygen Liquicaps",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Purus-Labs-Noxygen-Liquicaps.jpg?v=1788036691",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "purus",
        "labs",
        "noxygen",
        "liquicaps",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 21.21,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830156677317",
      "vsf_explanation": "Purus Labs Noxygen Liquicaps is marketed as the only liquid nitrate stim-free pump product. Nitrates from beetroot extract and other sources have real RCT support for nitric-oxide-mediated blood-flow and exercise-performance endpoints — the mechanism is sound and the dose-response relationship is well-characterized (3-6 g/day nitrate-standardized beetroot or roughly 300-600 mg elemental nitrate). The critical questions are the specific nitrate source (inorganic sodium nitrate vs. beetroot vs. amaranth extract) and the per-serving nitrate dose. Purus Labs's Noxygen positions on the 'only liquid nitrate' angle but the label typically discloses total capsule content rather than nitrate-equivalent dose, and the branded liquid-nitrate positioning does not necessarily hit the 300-600 mg elemental nitrate range that RCT literature supports. Autofailed on proprietary_blend_hides_dose because per-ingredient nitrate content is not clearly disclosed at a clinically-relevant level. Not listable in current form; a fully-disclosed nitrate product at clinical doses would score in Standard range.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "efx-kre-alkalyn-260-capsules",
      "title": "EFX Kre-Alkalyn - 260 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/EFX-Kre-Alkalyn-260-Capsules.jpg?v=1788036691",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "efx",
        "kre",
        "alkalyn",
        "260",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 65,
        "safety": 78,
        "transparency": 70,
        "sustainability": 45
      },
      "price": 36.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830156710085",
      "vsf_explanation": "EFX Kre-Alkalyn is a buffered creatine monohydrate (creatine at pH 12 as marketed) certified Informed Sport banned-substance-free. The certification is a genuine plus — Informed Sport testing catches banned-substance contamination from shared manufacturing lines and adds a real assurance layer for competitive athletes. The problem is the underlying premise: the marketing claim that Kre-Alkalyn is meaningfully better than plain creatine monohydrate because of its higher pH is not supported by the head-to-head RCT literature. Multiple independent trials comparing Kre-Alkalyn to plain creatine monohydrate have found no significant advantage on strength, hypertrophy, or performance endpoints, and the theoretical basis (that regular creatine degrades to creatinine in stomach acid) has been shown to be minimal in transit-time-normal humans. The 'crushes strength gains' marketing reference to the Bulgarian weightlifting study has been criticized on methodology. The Informed Sport certification saves this from Rejected territory; the price premium over plain monohydrate is hard to justify on evidence. Standard tier for tested-athlete value; Rejected on scientific merit alone.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "5-nutrition-crea-ten-10-in-1-creatine",
      "title": "5% Nutrition Crea-TEN 10-in-1 Creatine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5-Nutrition-Crea-TEN-10-in-1-Creatine.jpg?v=1788036691",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrition",
        "crea",
        "ten",
        "creatine",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 38,
        "sustainability": 45
      },
      "price": 37.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830156775621",
      "vsf_explanation": "5% Nutrition Crea-TEN combines 10 different creatine forms — monohydrate, HCl, ethyl ester, Kre-Alkalyn, magnesium chelate, nitrate, MagnaPower, pyruvate, orotate, citrate, and similar variants — in a single blended product. The rationale ('you get every form so you cover every mechanism') is marketing over science: the RCT literature comparing every one of these patented forms head-to-head against plain monohydrate has consistently found no advantage for any of them. Combining 10 forms into one blend spreads the total creatine dose across them, which means the primary evidence-backed form (monohydrate) is likely delivered at a fractional dose — you might get 500 mg of monohydrate in the blend instead of a full 3-5 g. Autofailed on proprietary_blend_hides_dose because the individual creatine-form doses are typically not itemized. Even with disclosure, the fundamental premise (that 10 forms are additively better than one) is not supported by RCTs. Not listable; the honest scientific play is single-ingredient monohydrate at 3-5 g/day.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "nutrabio-creatine-monohydrate-300-g",
      "title": "NutraBio Creatine Monohydrate - 300 g",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NutraBio-Creatine-Monohydrate-300-g.jpg?v=1788036692",
      "score": 78,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrabio",
        "creatine",
        "monohydrate",
        "300",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 95,
        "formulation": 82,
        "manufacturing": 85,
        "safety": 88,
        "transparency": 92,
        "sustainability": 55
      },
      "price": 23.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830156972229",
      "vsf_explanation": "This is the unflavored 300 g single-ingredient version of NutraBio's creatine monohydrate — micronized to 200 mesh, no flavoring, no additives, no fillers. Creatine monohydrate is the most heavily studied supplement in sports nutrition, with over 500 RCTs and multiple meta-analyses converging on 5-15% strength gains, 1-2 kg lean-mass gains over 8-12 week loading-plus-maintenance protocols, and improvements in high-intensity exercise capacity. NutraBio's transparent-label documentation regime (published per-lot COAs, third-party testing for identity/potency/heavy metals/microbials, non-proprietary label) puts this in the top decile of documentation for the entire supplement industry. The 200-mesh micronization improves mixability without changing the physiological effect. The unflavored single-ingredient format is the most cost-efficient and versatile way to take creatine — mix into any drink or scoop. This is textbook Verified-tier and is close to a category exemplar for what a well-executed single-ingredient supplement should look like.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "inspired-nutraceuticals-fsu-serum-non-stim-pre-workout",
      "title": "Inspired Nutraceuticals FSU: Serum Non-Stim Pre-Workout",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Inspired-Nutraceuticals-FSU-Serum-Non-Stim-Pre-Workout.jpg?v=1788036692",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "inspired",
        "nutraceuticals",
        "fsu",
        "serum",
        "non",
        "stim",
        "pre",
        "workout",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 68,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 44.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830157004997",
      "vsf_explanation": "Inspired FSU Serum is a non-stimulant pre-workout centered on clinical-grade GlycoClear glycerol (99.7% pure) plus supporting pump ingredients. The glycerol-based pump category has real RCT support for hyperhydration and pump aesthetics at 1-1.5 g/kg dosing, and a clinical-grade glycerol source is a legitimate ingredient choice. Inspired publishes disclosed doses for the main actives (glycerol, plus typically citrulline and other pump ingredients). The non-stim format has legitimate use cases: late-day training where caffeine would disrupt sleep, stacking with a separate caffeine source, and users sensitive to stimulants. The overall documentation regime is above average for the space but not at NutraBio's level; per-lot COA publication is not documented. Safety at label doses is fine; glycerol requires adequate co-ingested water to work correctly. A defensible Standard-tier non-stim pre-workout; the ingredient selection is honest and the glycerol dose likely clears the clinical threshold.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "axe-sledge-hydraulic-v2",
      "title": "Axe & Sledge Hydraulic V2",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Axe-Sledge-Hydraulic-V2.jpg?v=1788036692",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "axe",
        "sledge",
        "hydraulic",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 49.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830157136069",
      "vsf_explanation": "Axe & Sledge Hydraulic V2 is a non-stim pump pre-workout featuring L-citrulline, beta-alanine, plus trademarked ingredients (Vasodrive-AP, Citrapeak, Cognatiq, AstraGin, HydroMax glycerol). Individual actives here have real support — HydroMax glycerol at effective doses, L-citrulline at clinical doses, and beta-alanine at 3.2 g/day — but Axe & Sledge's product line historically uses proprietary-blend disclosure for the supporting matrix, hiding per-ingredient doses on the trademarked pump/cognition ingredients (Vasodrive-AP, Citrapeak, Cognatiq). Without disclosure of those specific doses, several of the branded ingredients are likely under-dosed relative to their clinical evidence (Vasodrive-AP needs 254 mg BID; Citrapeak needs specific citrus-flavonoid content; Cognatiq needs 100+ mg). Autofailed on proprietary_blend_hides_dose. Individual actives may be at clinical doses (the marketing implies so for citrulline and beta-alanine) but the supporting matrix conceals dosing. Not listable in current form; would score in Standard range with full disclosure.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "mushroom-extract-complex",
      "title": "MUSHROOM EXTRACT COMPLEX",
      "vendor": "APACHE STAR",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1782458363176-generated-label-image-0.jpg?v=1788036724",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mushroom",
        "extract",
        "complex",
        "apache",
        "star"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 13,
        "formulation": 12,
        "manufacturing": 10,
        "safety": 10,
        "transparency": 6,
        "sustainability": 5
      },
      "price": 29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830157955269",
      "vsf_explanation": "APACHE STAR's ten-mushroom gummy blend delivers 10:1 extracts of Maitake, Shiitake, Lion's Mane, Reishi, Cordyceps, Chaga, Turkey Tail, White Button, Black Fungus, and Royal Sun in a raspberry-flavoured gummy. The 10:1 extract-ratio disclosure is a positive transparency signal — most gummy mushroom products don't disclose extract strength. The scoring headwinds: (1) 10-mushroom blends spread total mass thin across many ingredients, so each individual mushroom is present at sub-clinical amounts; (2) gummies as a delivery form impose a low mass ceiling — you cannot fit 500 mg per mushroom in a chewable gummy; (3) the description does not specify fruiting-body vs mycelium sourcing, which materially affects active-compound content; (4) no per-mushroom milligram breakdown. Solid mid-Standard: honest gummy category, real ingredients, but likely under-dosed at any single functional mushroom.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-glutamine-powder-2",
      "title": "L-GLUTAMINE POWDER",
      "vendor": "APACHE STAR",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/APACHE_STAR_L-GLUTAMINE_POWDER.jpg?v=1788036724",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glutamine",
        "powder",
        "apache",
        "star"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 14,
        "manufacturing": 10,
        "safety": 10,
        "transparency": 8,
        "sustainability": 4
      },
      "price": 49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830158086341",
      "vsf_explanation": "A pure single-ingredient L-glutamine powder, unflavoured, no fillers. Ingredient discipline is exemplary — one ingredient, one purpose, no proprietary noise. L-glutamine is the most abundant free amino acid in the body and has three defensible use cases: gut barrier / intestinal permeability support (some clinical evidence in critical illness, IBD, and post-chemotherapy), immune support in stress states, and modest utility in endurance and prolonged-training recovery. Sports-nutrition trials for muscle recovery and performance in healthy trained adults have been consistently mixed to negative. This is a legitimate ingredient at a fair category; the score is capped at Standard because the finished product does not publish a per-lot COA or third-party purity certificate.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "creatine-monohydrate-7",
      "title": "CREATINE MONOHYDRATE",
      "vendor": "APACHE STAR",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/APACHE_STAR_CREATINE_MONOHYDRATE.jpg?v=1788036724",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "creatine",
        "monohydrate",
        "apache",
        "star"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 15,
        "manufacturing": 10,
        "safety": 12,
        "transparency": 7,
        "sustainability": 4
      },
      "price": 39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830158020805",
      "vsf_explanation": "A pure micronized creatine monohydrate powder, unflavoured, no fillers. Creatine monohydrate is the most-studied ergogenic aid in sports nutrition — hundreds of RCTs support strength, power, high-intensity performance, and, more recently, cognitive endpoints under sleep deprivation and mental fatigue (Turner 2015; Rae 2003). The International Society of Sports Nutrition position stand supports monohydrate as the reference form; more expensive versions (HCl, buffered, ethyl ester) do not outperform monohydrate. Micronized simply improves solubility. Single-ingredient discipline, standard dose, and correct form choice earn strong evidence and formulation credit. The remaining gap is Creapure or equivalent third-party purity certification is not disclosed — that would push this into Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ginkgo-biloba-ginseng-2",
      "title": "GINKGO BILOBA + GINSENG",
      "vendor": "APACHE STAR",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/20250618121506-vox4gink-sf_049ab8e9-1dc4-4665-b55b-fde7166bee46.png?v=1788036724",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive",
        "energy",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ginkgo",
        "biloba",
        "ginseng",
        "apache",
        "star"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 14,
        "manufacturing": 10,
        "safety": 10,
        "transparency": 8,
        "sustainability": 4
      },
      "price": 29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830157988037",
      "vsf_explanation": "APACHE STAR pairs Ginkgo biloba leaf (powder plus 24% flavones extract) with Red Panax Ginseng standardised to 7% ginsenosides. The standardisation percentages are the correct disclosures for both botanicals — 24% ginkgo flavones matches the EGb 761 pharmaceutical extract used in most RCTs, and 7% ginsenosides is a common commercial Panax standardisation. Evidence: ginkgo for cognitive support is mixed at best in healthy adults (GEM Study 2008 found no dementia-prevention benefit) but has some efficacy in mild cognitive impairment and vertigo; Panax ginseng has modest RCT support for cognitive performance under stress and fatigue. The combination is a traditional pairing without unique combination-specific evidence. Solid Standard on formulation discipline and standardisation transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pharmanex®-colostrum-defense-igg",
      "title": "Pharmanex® Colostrum Defense - IgG",
      "vendor": "Leaders Beauty & Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Colostrum-Defense-PDP-Main-Image.jpg?v=1788036767",
      "score": 55,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pharmanex",
        "colostrum",
        "defense",
        "igg",
        "leaders",
        "beauty",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 48,
        "sustainability": 50
      },
      "price": 74,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830158577861",
      "vsf_explanation": "Pharmanex is Nu Skin's supplement sub-brand (NYSE:NUS). Colostrum Defense delivers bovine colostrum concentrated for immunoglobulin G (IgG) content. Bovine colostrum has some evidence for immune support: Kelly 2003 review, small studies for URI reduction in athletes (Crooks 2006) and reduced gut permeability. The evidence base is moderate but consistent. The pharmacokinetic question — how much orally-ingested IgG survives gastric acid and reaches the small intestine to modulate mucosal immunity — is only partially resolved (some intact IgG passes; most is denatured). Nu Skin/Pharmanex uses MLM distribution and has the regulatory-history context described above. Formulation and ingredient quality are defensible; the concerns are (a) MLM distribution and price premium, (b) 1997 FTC consent order and ongoing scrutiny of product-claim substantiation, and (c) less independent third-party verification than practitioner-grade colostrum brands (Sovereign Laboratories, Symbiotics). Positioned at Standard-borderline in a normal retail context; the Nu Skin distribution context is unfavorable. Landing at Rejected for the combination of MLM context + moderate evidence + premium price without proportional independent verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ageloc-rose-gold-lumispa®-io",
      "title": "ageLOC Rose Gold LumiSpa® iO",
      "vendor": "Leaders Beauty & Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Screenshot2025-12-31211705.png?v=1788036776",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ageloc",
        "rose",
        "gold",
        "lumispa",
        "leaders",
        "beauty",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 217,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830158676165",
      "vsf_explanation": "The Nu Skin ageLOC LumiSpa iO is a topical skincare cleansing device (facial cleanser + IoT-enabled oscillating silicone treatment head), not an ingestible supplement. Out of scope for the supplement rubric. Beyond the scope issue, Nu Skin is a multilevel-marketing company (NYSE:NUS) with a documented regulatory history — the 1997 FTC $47M consent order settling deceptive-earnings and product-claim charges; ongoing regulatory scrutiny of MLM structure by FTC and various state AGs. The ageLOC product line's 'anti-aging gene targeting' marketing has been criticized as scientifically overstated. Auto-failed under out_of_scope_for_biohacking (topical device).",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "nutrafol-skin-one-month-supply",
      "title": "NUTRAFOL SKIN ONE MONTH SUPPLY",
      "vendor": "NUTRAFOL @ NYALLERGY",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/11292023_Google_Skin0682_R1-2.jpg?v=1788036813",
      "score": 74,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrafol",
        "skin",
        "one",
        "month",
        "supply",
        "nutrafol",
        "nyallergy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 78,
        "manufacturing": 75,
        "safety": 72,
        "transparency": 70,
        "sustainability": 68
      },
      "price": 79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830159036613",
      "vsf_explanation": "Nutrafol Skin is Nutrafol's targeted acne-and-skin-clarity formula for women 18+. Nutrafol (Nutraceutical Wellness Inc, NY) has the strongest RCT evidence base in the ingestible beauty category — Ablon 2019 (J Drugs Dermatol) and Ablon & Kogan 2018 for the core Women's product showed measurable improvements in hair thickness and coverage vs. placebo; the Skin product uses a related nutraceutical framework (adaptogens, marine collagen peptides, vitamins/minerals) targeting the acne and post-acne axis. The 'physician-formulated' positioning is defensible; Nutrafol runs actual clinical studies. Formula is transparent about ingredient categories, though the proprietary blend structure obscures per-ingredient mg. Nutrafol is USD $88-$99/month at retail, positioned as a premium clinical wellness product. Held out of Elite by (1) proprietary Synergen Complex hiding per-ingredient doses, (2) the Skin product has less RCT-specific evidence than the flagship hair products (evidence is more categorical), and (3) 'reduce acne breakouts and post-acne dark spots' language is aggressive for a supplement. Verified tier stands.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrafol-women-hair-serum",
      "title": "NUTRAFOL WOMEN HAIR SERUM",
      "vendor": "NUTRAFOL @ NYALLERGY",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HairSerumforWomen.jpg?v=1788036813",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "nutrafol",
        "women",
        "hair",
        "serum",
        "nutrafol",
        "nyallergy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 65,
        "manufacturing": 68,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830159069381",
      "vsf_explanation": "Nutrafol Women Hair Serum is a topical hair product (patent-pending Ashwagandha Exosomes technology), not an ingestible supplement. Vyvata's scoring rubric evaluates ingestible supplements against a supplement-oriented rubric; topical cosmetic and topical hair products require different criteria (dermatological safety, penetration data, cosmetic industry FDA framework rather than DSHEA). The product is clearly a well-formulated topical from a credible brand, but it is out of scope for supplement scoring — comparable to how a skincare cream would be out of scope. Auto-failed under out_of_scope_for_biohacking (topical, non-ingestible).",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "happy-dim",
      "title": "Happy DIM",
      "vendor": "Happy Healthy You",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HHY-Dim60.jpg?v=1788036897",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "happy",
        "dim",
        "happy",
        "healthy",
        "you"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 8,
        "manufacturing": 8,
        "safety": 8,
        "transparency": 5,
        "sustainability": 4
      },
      "price": 32.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830159986885",
      "vsf_explanation": "A women's DIM (diindolylmethane) product explicitly self-described as a 'proprietary blend.' DIM as a single ingredient has a real evidence base for oestrogen metabolism support (shifting the 2-hydroxyestrone / 16-hydroxyestrone ratio toward 2-OH), which is a plausible mechanism for premenstrual symptom and hormone-clearance support. If this were a clearly-dosed DIM product at 100-200 mg, it could score Standard. But calling it a 'proprietary blend' by name — Happy DIM is 'a proprietary blend formulated by Dr Jeff Butterworth' — tells the reviewer that the exact DIM milligram amount and any other actives are not disclosed. Under the Zero-Assumption Rule and the proprietary_blend_hides_dose autofail rule, undisclosed multi-ingredient formulations forfeit tier eligibility. Auto-fail applied.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "happy-greens",
      "title": "Happy Greens",
      "vendor": "Happy Healthy You",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HHY-Greens60.jpg?v=1788036902",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "happy",
        "greens",
        "happy",
        "healthy",
        "you"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 8,
        "formulation": 8,
        "manufacturing": 8,
        "safety": 8,
        "transparency": 4,
        "sustainability": 4
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830160019653",
      "vsf_explanation": "A greens powder positioned as a 'natural alkaline-forming' hormone-supporting superfood blend from Happy Healthy You. Two structural issues force Rejected: (1) the acid-alkaline body-pH thesis is not supported by physiology — arterial blood pH is tightly regulated at 7.35-7.45 by the kidneys and lungs, and no food or supplement meaningfully shifts systemic pH; the 'alkaline-forming' framing is an unverified mechanism widely rejected in mainstream nutrition science; (2) greens/superfood blends generically list many ingredients without disclosing the milligram amount of each — proprietary-blend formulations that obscure dose. Combined with 'hormone support' as an outcome claim, the product exceeds what a greens powder can honestly promise in a healthy adult. Auto-fail under unverified_medical_claim for the alkaline-diet mechanism.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "ortho-molecular-products-dhea-25-mg-90-capsules",
      "title": "Ortho Molecular Products DHEA 25 Mg - 90 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/88129842.png?v=1788037031",
      "score": 58,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ortho",
        "molecular",
        "products",
        "dhea",
        "capsules",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 68,
        "manufacturing": 72,
        "safety": 48,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830161297605",
      "vsf_explanation": "Ortho Molecular Products (Woodstock IL) is a practitioner-grade brand — clinician-channel, higher-end formulation quality, cGMP-registered manufacturing, third-party tested for identity/potency, USP-standard raw materials. The product warns explicitly that resale is not allowed and lots are tracked — a practitioner-brand quality control signal. 25mg DHEA at the studied dose range. The formulation and brand quality would push toward Standard/Verified for a general supplement, but DHEA specifically has hormone-conversion safety concerns that keep this borderline Rejected/Standard. Practitioner-channel brands like Ortho Molecular are designed to be dispensed with clinical oversight; sold as a general OTC through a pharmacy reseller, that oversight is absent. Rejected on hormone-safety grounds — the brand quality does not resolve the ingredient concerns.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "good-neighbor-pharmacy-dhea-25mg-capsules-60ct",
      "title": "Good Neighbor Pharmacy DHEA 25MG Capsules 60ct",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/267958892.jpg?v=1788037038",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "good",
        "neighbor",
        "pharmacy",
        "dhea",
        "25mg",
        "capsules",
        "60ct",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 52,
        "manufacturing": 50,
        "safety": 40,
        "transparency": 42,
        "sustainability": 48
      },
      "price": 4.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830161330373",
      "vsf_explanation": "Good Neighbor Pharmacy is AmerisourceBergen's private-label brand for independent pharmacies — essentially a store brand for the independent-pharmacy cooperative. 25mg DHEA at the studied dose range, but this is a generic-tier private label with no brand-specific formulation R&D and no publicly-posted per-lot testing. The listing text is generic ('essential precursor hormone,' 'supports vitality, energy, immune system, wellbeing') and does not surface any of the appropriate cautions for a hormone-active OTC. Same safety issues as previous DHEA products: hormone conversion, hormone-sensitive cancer risk, sports drug testing bans, drug interactions. Rejected on the same combined-dimension basis.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "force-factor®-dhea-50-mg-capsule-100-ea",
      "title": "Force Factor® DHEA 50 mg Capsule, 100 EA",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/256013368.jpg?v=1788037042",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "force",
        "factor",
        "dhea",
        "capsule",
        "100",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 52,
        "manufacturing": 55,
        "safety": 35,
        "transparency": 42,
        "sustainability": 50
      },
      "price": 12.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830161428677",
      "vsf_explanation": "Force Factor is a men's-supplement mass-retail brand (owned by Integrated Nutraceutical Sciences, part of the WK Kellogg / K-Roc portfolio). This SKU delivers 50mg DHEA per capsule — double the previous product. 50mg is at the upper end of studied doses (Arlt 1999 adrenal insufficiency: 25-50mg; higher-dose 'vitality' claims are not evidence-supported). Higher dose amplifies the hormone-conversion risks discussed above — more testosterone conversion in women (hirsutism, acne, voice deepening), more estradiol conversion in men (gynecomastia, water retention). 'Healthy aging support' and 'balanced energy' claims outrun the evidence base at 50mg for healthy adults. Vegan capsule and 100% vegan/non-GMO ingredients are defensible transparency notes. Rejected — the dose is aggressive for a general-population OTC and the marketing claims outrun the RCT support.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-truth-dhea-25-mg-tablets",
      "title": "Nature's Truth DHEA 25 Mg Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/49053624.jpg?v=1788037060",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "truth",
        "dhea",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 40,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 12.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830162215109",
      "vsf_explanation": "Nature's Truth is a mid-tier US mass-retail supplement brand (Piping Rock-affiliated, NY). DHEA (dehydroepiandrosterone) at 25mg is a prohormone that converts to both testosterone and estrogens in the body. DHEA is a schedule III controlled substance in Canada and banned by WADA/NCAA/most sports federations. The evidence for DHEA supplementation is genuinely mixed: some benefit in adrenal insufficiency (Arlt 1999) and postmenopausal women with low libido and low DHEA-S (Genazzani 2011), but no consistent benefit for general 'anti-aging' or 'vitality' in healthy adults with normal DHEA. Safety concerns include acne, hair loss, mood changes, elevated liver enzymes, and — importantly — theoretical increase in hormone-sensitive cancer risk (breast, prostate, ovarian). The listing is skeletal and does not discuss any of this. Rejected for the combination of (a) hormone-active ingredient with genuine safety flags, (b) minimal safety framing in the listing, and (c) evidence-to-marketing gap.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "medera-butyera-calcium-butyrate-dietary-supplement-60-capsules",
      "title": "Medera ButyEra Calcium Butyrate Dietary Supplement 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Qej1ZHPHAII7a9G30G5pM1cJHFAJvVE4jieMjFKC.jpg?v=1788037139",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "medera",
        "butyera",
        "calcium",
        "butyrate",
        "dietary",
        "supplement",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 48,
        "sustainability": 55
      },
      "price": 36.03,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830162870469",
      "vsf_explanation": "Medera ButyEra is a Turkish-market calcium butyrate supplement — a single-ingredient (calcium butyrate salt of butyric acid) targeting gut health. Butyrate is a short-chain fatty acid produced by colonic bacterial fermentation of fiber and is the primary energy source for colonocytes; oral calcium butyrate has some evidence for IBD and IBS (Banasiewicz 2013 for UC symptom scores at 300-600mg/day, small studies for IBS). Single-ingredient formulation is honest — no proprietary blend. The main concern is that oral butyrate is largely absorbed in the upper GI tract and never reaches the colon where it is most needed, unless the delivery is coated or enteric-protected. The listing does not describe delivery format. Turkish regulatory context (lighter than US/EU) applies. Standard tier for the coherent single-ingredient approach and defensible evidence base; held out of higher by delivery-format opacity, absence of per-lot COAs, and lighter regulatory verification norms.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-digestive-enzymes-ultra-support-supplement-60-capsules",
      "title": "Pure Digestive Enzymes Ultra Support Supplement 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/sSGuQAbOrzGC1BHwJCEDEDhlkPn9qbJdtZDdJqUK.jpg?v=1788037148",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "digestive",
        "enzymes",
        "ultra",
        "support",
        "supplement",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 42,
        "manufacturing": 45,
        "safety": 52,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 20.85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830162968773",
      "vsf_explanation": "The listing describes 'digestive enzymes' but does not disclose (a) a brand name, (b) which enzymes are included, (c) potency units (FCC-USP standards use FIP, DU, HUT, ALU units for amylase, protease, lipase, cellulase), or (d) a manufacturer. Digestive enzyme products are only clinically meaningful when the specific enzyme (amylase, protease, lipase, lactase, papain, bromelain, etc.), dose in activity units (not milligrams), and pH-stability profile are disclosed. Without that, the product is a black box. Auto-fail is close but not tripped — the product does say it contains 'enzymes' (not a made-up claim); rejection is on cumulative dimension weakness (transparency, evidence, formulation) rather than a strict auto-fail category. Category is medically thin for OTC use in the first place — most healthy adults do not benefit from broad enzyme supplementation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "orzaks-ocean-methyl-balance-dietary-supplement-30-capsules",
      "title": "Orzaks Ocean Methyl Balance - Dietary Supplement | 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/qAZzXu5CYftcaDuuE7wxIt4FKTJgghs6ATdIF5hg.jpg?v=1788037193",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "orzaks",
        "ocean",
        "methyl",
        "balance",
        "dietary",
        "supplement",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 48,
        "sustainability": 55
      },
      "price": 24.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830164803781",
      "vsf_explanation": "Ocean Methyl Balance is a Turkish-market methylation-support supplement combining Betaine (TMG), Choline, L-Serine, and B vitamins. Methylation support is a real evidence area — TMG at 1-6g/day lowers homocysteine (Olthof 2003), choline supports phosphatidylcholine synthesis, methylated B vitamins (methylfolate, methylcobalamin, P5P) support one-carbon metabolism especially in MTHFR C677T variants. The formulation logic is defensible; the concern is dose disclosure — TMG needs to be at 1000mg+ for clinical effect on homocysteine, and putting TMG + choline + L-serine + Bs into a single 30-capsule bottle at one-a-day dosing means each ingredient is likely sub-therapeutic (TMG at maybe 100-500mg, well below the 1000mg threshold). Turkish supplement regulation is lighter than US/EU. Rejected for the likely-sub-therapeutic dose pattern typical of stacked methylation blends and the lack of per-ingredient disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nac-n-acetyl-cysteine-drops-600-mg-antioxidant-amino-acid-supplement",
      "title": "NAC N-Acetyl Cysteine Drops, 600 mg Antioxidant Amino Acid Supplement",
      "vendor": "Tailor Made Herbal Products",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/IMG-2022.jpg?v=1788037218",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nac",
        "acetyl",
        "cysteine",
        "drops",
        "600",
        "antioxidant",
        "amino",
        "acid",
        "supplement",
        "tailor",
        "made",
        "herbal",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 48,
        "sustainability": 55
      },
      "price": 23,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830165033157",
      "vsf_explanation": "This NAC drops product delivers 600mg NAC per serving in a liquid format under a small herbal-supplements label. NAC has a strong evidence base at 600-1200mg/day (Poe 2004 for respiratory, Grandjean 2013 for glutathione precursor supplementation) and is FDA-approved as an intravenous agent for acetaminophen overdose. However, NAC in a liquid drop delivery format is unusual and raises stability questions — NAC is prone to oxidation and off-taste (sulfurous), which is why nearly all clinical NAC products are enteric-coated capsules or effervescent tablets. Delivering 600mg NAC as a liquid means either a very large volume per dose or a low actual delivered dose after oxidation losses. The small-label brand behind this SKU does not publish stability data or third-party COAs. Also relevant: the FDA sent warning letters in 2020-2022 questioning whether NAC could be sold as a dietary supplement (the ingredient was studied as a drug first, per FD&C Act 201(ff)(3)(B)). Regulatory status is currently permissive but historically contested. Rejected for delivery-format concerns and brand transparency gaps.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "now-c-1000-with-rose-hips-antioxidant-supplement-100-tablets",
      "title": "Now C-1000 with Rose Hips Antioxidant Supplement 100 Tablets",
      "vendor": "NOW",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/FVXGwEkNPJ75Oorh64sLEu4u4Z5F6d6XWO6By4GO.jpg?v=1788037257",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "1000",
        "with",
        "rose",
        "hips",
        "antioxidant",
        "supplement",
        "100",
        "tablets",
        "now"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 68,
        "manufacturing": 72,
        "safety": 68,
        "transparency": 68,
        "sustainability": 62
      },
      "price": 42.44,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830165360837",
      "vsf_explanation": "NOW Foods (Bloomingdale IL, founded 1968) is a large, well-regarded mid-tier US supplement brand — cGMP-certified manufacturing, one of a small handful of brands ConsumerLab and USP Verified track favorably, transparent about testing, family-owned. This product is 1,000mg vitamin C with rose hips per tablet — straightforward, well-formulated. Rose hips add some natural vitamin C and bioflavonoids. NOW discloses per-lot testing on many products through its testing lab (the largest in-house lab in the industry at ~200 chemists), publishes results, and is transparent about sourcing. 1,000mg vitamin C is at the high end of the tolerable range (2,000mg is the tolerable UL; higher doses cause GI upset in many users). Evidence for vitamin C at 1000mg on immune outcomes is weak in adequately-nourished adults — Hemila 2013 Cochrane found no effect on cold incidence but modest effect on cold duration in regular supplementers. Standard tier — a defensible pick when a user wants supplemental C.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "prem-inochast-a-dietary-supplement-for-women-to-support-hormone-balance-menstrual-cycle-and-healthy-ovarian-function",
      "title": "Prem Inochast-A Dietary Supplement for Women to Support Hormone Balance, Menstrual Cycle and Healthy Ovarian Function",
      "vendor": "cotidelle",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1--_1_-1.jpg?v=1788037279",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "prem",
        "inochast",
        "dietary",
        "supplement",
        "for",
        "women",
        "support",
        "hormone",
        "balance",
        "menstrual",
        "cycle",
        "and",
        "healthy",
        "ovarian",
        "function",
        "cotidelle"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 52,
        "manufacturing": 55,
        "safety": 48,
        "transparency": 42,
        "sustainability": 50
      },
      "price": 29.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830165557445",
      "vsf_explanation": "Prem Inochast markets to women for hormone balance, menstrual cycle regularity, ovarian function, and 'symptoms of perimenopause and menopause.' The visible listing describes structure/function claims but does not surface a Supplement Facts panel with per-ingredient doses. Women's hormone-balance botanicals with clinical support include: Vitex agnus-castus (chasteberry) 20-40mg/day for PMS (Ma 2010, Girman 2003); myo-inositol 2-4g/day for PCOS ovulation (Unfer 2016 meta-analysis); DIM 100-200mg for estrogen metabolism modulation. Without knowing what is in this specific formula, and the 'menopause symptoms' language starts to bridge from structure/function into disease-adjacent territory. Standard hormone-support blends often use standardized chasteberry with vitamins B6/B12/folate, but the mixture and doses here are not disclosed. Rejected for the combination of opacity and claim breadth without ingredient-level substantiation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "prem-radiance-a-liquid-dietary-supplement-to-support-healthy-skin-with-marine-collagen-biotin-hyaluronic-acid-and-cordycepts",
      "title": "Prem Radiance A Liquid Dietary Supplement to Support Healthy Skin with Marine Collagen,Biotin ,Hyaluronic Acid and Cordycepts",
      "vendor": "cotidelle",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1--_2.jpg?v=1788037289",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "prem",
        "radiance",
        "liquid",
        "dietary",
        "supplement",
        "support",
        "healthy",
        "skin",
        "with",
        "marine",
        "collagen",
        "biotin",
        "hyaluronic",
        "acid",
        "and",
        "cordycepts",
        "cotidelle"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 50,
        "sustainability": 52
      },
      "price": 36.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830165819589",
      "vsf_explanation": "Prem Radiance is a marine collagen + biotin + hyaluronic acid + cordyceps liquid beauty supplement. The formula uses MoriKol® Tripeptide Marine Collagen — a branded ingredient with some published RCT data (Yamashita 2024 and earlier tripeptide fish collagen work by Sugihara 2018 on facial elasticity and hydration at 2-5g/day for 8+ weeks). Marine collagen has moderate evidence at 2.5-10g/day. Biotin at 300-2500mcg has anecdotal skin/hair support but weak RCT evidence outside of overt biotin deficiency. Hyaluronic acid oral (~120mg/day) has some human evidence (Kawada 2014). Cordyceps in a beauty product is unusual — it is more associated with performance and immune positioning. Liquid delivery format has bioavailability arguments and shelf-stability arguments both ways. Held to Standard by (1) proprietary blend risk (dose per ingredient not disclosed at the listing level), (2) 'collagen rebuilding' language that overstates the mechanism (oral collagen breaks into amino acids and short peptides absorbed via intestinal transporters; net skin effect is modest), and (3) cordyceps inclusion without clear beauty-relevant evidence. Standard-tier formulation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "advanced-women-s-probiotic-for-gut-health-vaginal-microbiome-uti-immunity-support",
      "title": "Advanced Women’s Probiotic for Gut Health, Vaginal Microbiome, UTI & Immunity Support",
      "vendor": "cotidelle",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1--_3_-1.jpg?v=1788037295",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "advanced",
        "women",
        "probiotic",
        "for",
        "gut",
        "health",
        "vaginal",
        "microbiome",
        "uti",
        "immunity",
        "support",
        "cotidelle"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 50,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 42,
        "sustainability": 50
      },
      "price": 29.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830165917893",
      "vsf_explanation": "Advanced Daily Probiotic markets to women for gut + vaginal microbiome + UTI + immune support — a broad four-target claim set. Probiotics for vaginal microbiome and UTI prevention have moderate evidence for specific Lactobacillus strains (L. rhamnosus GR-1, L. reuteri RC-14 per Beerepoot 2012 and Reid 2013 for recurrent UTIs), but strain identity and CFU count at ship time are the make-or-break variables. The visible description does not list strains, CFU counts, or delivery mechanism (delayed-release capsules protecting against stomach acid). Without strain-level disclosure, a probiotic product cannot be evaluated for the specific clinical claims it makes. The 'UTI support' claim edges toward medical-treatment language. Not on strict auto-fail for medical claim (technically structure/function), but the evidence-to-claim gap and transparency gap keep it in Rejected. Also 'Advanced Daily Probiotic' as a name is generic.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "elevated-daily-multivitamin-for-women-with-hormonal-balance-immune-support-longevity-wellness-eye-health-and-detox",
      "title": "Elevated Daily Multivitamin for Women with Hormonal Balance, Immune Support, Longevity, Wellness, Eye Health and Detox",
      "vendor": "cotidelle",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1--_4.jpg?v=1788037295",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune",
        "longevity"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "elevated",
        "daily",
        "multivitamin",
        "for",
        "women",
        "with",
        "hormonal",
        "balance",
        "immune",
        "support",
        "longevity",
        "wellness",
        "eye",
        "health",
        "and",
        "detox",
        "cotidelle"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 48,
        "manufacturing": 48,
        "safety": 52,
        "transparency": 38,
        "sustainability": 45
      },
      "price": 39.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830165950661",
      "vsf_explanation": "This is a women's multivitamin that stacks 'Hormonal Balance,' 'Immune Support,' 'Longevity,' 'Wellness,' 'Eye Health,' and 'Detox' into a single-product claim set — six positioning verticals in one bottle. The 'Detox' claim triggers the same unverified_medical_claim concern discussed in earlier products (no oral supplement has cleared FDA/EMA evidentiary bars for detoxifying the body in a healthy person). Beyond the detox claim, multi-target 'do everything' multivitamins invariably underdose the marquee-claim ingredients — clinical doses for hormone-balance ingredients (DIM 100-200mg, chasteberry 20-40mg standardized), immune (zinc 15mg, D3 2000IU, C 500mg+), longevity (NAD precursors 250-500mg), and eye health (lutein 10mg, zeaxanthin 2mg) do not fit into one daily capsule at their studied doses. Auto-fail on unverified_medical_claim for the 'detox' positioning.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "dietary-supplement-6",
      "title": "Dietary Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d575e5a3-c0c4-46c4-9ff1-20c122cb0fa7.jpg?v=1788037349",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dietary",
        "supplement",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 38,
        "manufacturing": 30,
        "safety": 42,
        "transparency": 22,
        "sustainability": 40
      },
      "price": 23.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830166376645",
      "vsf_explanation": "This SKU is sold under the literal generic name 'Dietary Supplement' with an ingredient list (vitamin C, vitamin D3, turmeric root powder, berberine, ginseng extract, cinnamon, ginger extract, green tea extract, black pepper extract) that reads as a metabolic / anti-inflammatory / glucose-lowering blend. Berberine + cinnamon + green tea is a common glucose-management ingredient set; the framing is implicit unverified_disease_claim territory. Nine ingredients in 100 capsules with no per-ingredient dose. Auto-failed under unverified_disease_claim (implied glucose management via berberine/cinnamon combination) and misleading_naming.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "glucosamine-supplement-capsules",
      "title": "Glucosamine Supplement Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f553fe52-9460-4466-9b48-666647908b91.jpg?v=1788037626",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glucosamine",
        "supplement",
        "capsules",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 42,
        "manufacturing": 32,
        "safety": 48,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 21.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830169587909",
      "vsf_explanation": "This SKU is sold as 'Glucosamine Supplement Capsules' with an ingredient list (vitamin C, glucosamine, chondroitin sulfate, MSM, hyaluronic acid, 'franklinic acid,' curcumin) that is a recognizable joint-support blend. 'Franklinic acid' is not a recognized compound and appears to be a scraped OCR error (possibly meant to be frankincense/boswellia). No manufacturer, no per-ingredient dose, no glucosamine form (sulfate vs hydrochloride). Glucosamine sulfate 1500 mg/day + chondroitin 1200 mg/day is the GAIT-trial-referenced dosing pair; without disclosure this is not evaluable. Auto-failed under misleading_naming.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "resting-and-night-nourishing-dietary-tablets",
      "title": "Resting And Night Nourishing Dietary Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a692f0f1-9549-40cf-a628-a0d936092cb3.jpg?v=1788037627",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "resting",
        "and",
        "night",
        "nourishing",
        "dietary",
        "tablets",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 30,
        "safety": 45,
        "transparency": 22,
        "sustainability": 40
      },
      "price": 18.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830169555141",
      "vsf_explanation": "This SKU is sold as 'Resting And Night Nourishing Dietary Tablets' with a single disclosed ingredient (melatonin) and no dose, no manufacturer, no brand identity, no facility of origin. Melatonin is one of the most-studied sleep-support compounds, but dose matters enormously — 0.3-0.5 mg is the most evidence-supported dose for sleep onset in adults, while consumer products routinely deliver 3-10 mg (2-30x higher than research dose), which can cause next-day grogginess, vivid dreams, and paradoxical sleep-quality worsening. A 2017 JAMA analysis of commercial melatonin products found 71% had label-dose accuracy problems, with actual content ranging from 17% to 478% of stated. Auto-failed under misleading_naming.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "60-garlic-capsules",
      "title": "60 Garlic Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/958d3746-b0b9-434d-a6dc-c6a475efd68f.jpg?v=1788037627",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "garlic",
        "capsules",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 35,
        "manufacturing": 28,
        "safety": 48,
        "transparency": 20,
        "sustainability": 40
      },
      "price": 15.1,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830169653445",
      "vsf_explanation": "This SKU is sold as '60 Garlic Capsules' with 'Production process: None' as the disclosed production information (literal 'none') and no manufacturer, per-capsule mg, allicin content, or standardization. Garlic supplementation has modest evidence for small blood-pressure reductions and lipid effects, but efficacy depends heavily on form (aged garlic extract vs fresh garlic powder), allicin yield, and enteric coating. Undisclosed garlic capsules vary dramatically in allicin content. Auto-failed under misleading_naming.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "beef-offal-capsules-90-count",
      "title": "Beef Offal Capsules 90 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cea05bd8-32a7-4417-bb6a-c555ac5e65ae.jpg?v=1788037627",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beef",
        "offal",
        "capsules",
        "count",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 32,
        "manufacturing": 28,
        "safety": 42,
        "transparency": 22,
        "sustainability": 32
      },
      "price": 17.08,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830169686213",
      "vsf_explanation": "This SKU is sold as 'Beef Offal Capsules 90 Count' with 'beef organ extract' as the disclosed key ingredient — no specification of which organ(s), no source (grass-fed vs conventional), no country of origin (BSE risk region considerations), no manufacturer. Organ-meat supplement products have a growing consumer following in ancestral-diet circles, and legitimate branded products (Ancestral Supplements, Heart & Soil) publish sourcing and organ-specific composition. Undisclosed beef organ capsules carry heightened concerns: bovine spongiform encephalopathy (BSE) has known geographic risk patterns, and organ tissues (particularly brain and spinal cord) carry the highest concentration of prion-related risk if any exists. Auto-failed under misleading_naming.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "soft-candy",
      "title": "Soft Candy",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6c651e8f-b3a5-4b88-9051-8ce6cdc88479.jpg?v=1788037626",
      "score": 16,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "soft",
        "candy",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 5,
        "formulation": 10,
        "manufacturing": 18,
        "safety": 25,
        "transparency": 8,
        "sustainability": 28
      },
      "price": 22.25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830169620677",
      "vsf_explanation": "This SKU is sold as 'Soft Candy' — literally the word candy, with no active ingredients disclosed, no vitamins or supplements identified, no dose, no manufacturer. Category is 'Gummy Candy.' This is not a supplement in any meaningful sense; it is a candy sold in a supplement category. Auto-failed under misleading_naming. Would arguably also qualify for out_of_scope_for_biohacking, though it is technically an oral product.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "chengjing-huanshu-capsule",
      "title": "Chengjing Huanshu Capsule",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/367a41fa-0b03-42d5-ae57-a678435ee15f.jpg?v=1788037627",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chengjing",
        "huanshu",
        "capsule",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 52,
        "manufacturing": 32,
        "safety": 55,
        "transparency": 28,
        "sustainability": 40
      },
      "price": 16.15,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830169817285",
      "vsf_explanation": "This SKU is sold under an untranslated placeholder name ('Chengjing Huanshu Capsule') with an ingredient list — eight magnesium forms: bisglycinate, threonate, malate, taurate, citrate, glycerophosphate, orotate, lactate — that is actually the most sophisticated magnesium formulation in this batch. Magnesium threonate specifically has CNS-penetration evidence for cognitive support; bisglycinate for sleep and general use; malate for energy contexts; taurate for cardiovascular. An eight-form complex without disclosed per-form milligrams is defeated by its own complexity, though — the same 500 mg capsule divided eight ways delivers trivial amounts of any single form. No manufacturer. Auto-failed under misleading_naming and proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "tanning-capsules-oral",
      "title": "Tanning Capsules Oral",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b8389a6e-9dc8-464d-9062-d35e6e875ced.jpg?v=1788037627",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tanning",
        "capsules",
        "oral",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 8,
        "formulation": 15,
        "manufacturing": 18,
        "safety": 15,
        "transparency": 12,
        "sustainability": 25
      },
      "price": 23.13,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830169751749",
      "vsf_explanation": "This SKU is sold as 'Tanning Capsules Oral' with no ingredient list, no manufacturer, and no disclosure — only product images. Oral tanning pills are a specifically-regulated category: the FDA has never approved any oral tanning agent for the US market, and canthaxanthin — the primary compound previously marketed for oral tanning — has been associated with canthaxanthin retinopathy (crystalline pigment deposits in the retina). The FDA issued explicit warnings against oral tanning pills in 1988 and reaffirmed them in 2004. Products in this category sold cross-border have been found to contain canthaxanthin at doses well above safety thresholds or to contain undisclosed synthetic melanotan analogues. Auto-failed under unverified_medical_claim and misleading_naming.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "henghu-shunxun-capsule",
      "title": "Henghu Shunxun Capsule",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5661a8bb-a664-4416-bfc0-fe685014ec22.jpg?v=1788037627",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "henghu",
        "shunxun",
        "capsule",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 32,
        "safety": 55,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 20.75,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830169784517",
      "vsf_explanation": "This SKU is sold under an untranslated placeholder name ('Henghu Shunxun Capsule') with a simple, defensible two-ingredient formula: turmeric root powder + black pepper fruit extract. The turmeric + black pepper (piperine) pairing is the correct absorption-enhanced turmeric formulation (piperine increases curcumin bioavailability roughly 20-fold). But no manufacturer, no curcumin content, no piperine mg, no COA. Turmeric supply chain has documented lead-contamination issues (India-sourced turmeric has been found by multiple studies to contain elevated lead from adulterant addition). Auto-failed under misleading_naming.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "dietary-supplement-7",
      "title": "Dietary Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/35a62bf0-0467-44c1-8522-f8bde296aac3.jpg?v=1788037627",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dietary",
        "supplement",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 38,
        "manufacturing": 30,
        "safety": 45,
        "transparency": 22,
        "sustainability": 40
      },
      "price": 18.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830169948357",
      "vsf_explanation": "This SKU is sold under the literal generic name 'Dietary Supplement' with an ingredient list (vitamin C, vitamin B6, vitamin D3, glycerol monolaurate, lysine, probiotic combination) that reads as an immune-antiviral blend — the glycerol monolaurate + lysine + vitamins C/D3 pattern is used in Herpes simplex management and general antiviral positioning. Undisclosed probiotic strains, doses, and CFU counts. No manufacturer. Auto-failed under misleading_naming and proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "milk-thistle-capsules-with-waterwort-extract",
      "title": "Milk Thistle Capsules With Waterwort Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0c7ee65a-79d1-427a-a44f-393588d7c1c4.jpg?v=1788037627",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "milk",
        "thistle",
        "capsules",
        "with",
        "waterwort",
        "extract",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 42,
        "manufacturing": 32,
        "safety": 52,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 28.37,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830169981125",
      "vsf_explanation": "This SKU is sold as 'Milk Thistle Capsules With Waterwort Extract' with 'Standard' as the production process, no disclosed manufacturer, no silymarin standardization percentage (the critical potency measure for milk thistle), no per-capsule mg, and no facility of origin. 'Waterwort' (Elatinaceae genus) is an unusual ingredient — it is not a standard supplement botanical and its inclusion is unexplained; possibly a mistranslation of another herb. Milk thistle standardized to 70-80% silymarin at 200-400 mg/day has modest evidence for liver-marker improvement in specific liver conditions; unstandardized product is not evaluable. Auto-failed under misleading_naming.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "sleep-gummies",
      "title": "Sleep Gummies",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2b3a1165-4c7f-4d2c-a734-1367cf7ff3bd.jpg?v=1788037627",
      "score": 22,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sleep",
        "gummies",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 18,
        "manufacturing": 22,
        "safety": 30,
        "transparency": 12,
        "sustainability": 30
      },
      "price": 36.92,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830169850053",
      "vsf_explanation": "This SKU is sold as 'Sleep Gummies' with no product description at all — only images. No ingredient list, no melatonin content, no manufacturer, no dose, no facility of origin. Sleep gummies are typically melatonin-based; the melatonin dose-accuracy problem (2017 JAMA analysis found 71% of commercial products off-label) is compounded here by having no label at all. Auto-failed under misleading_naming.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "dietary-supplement-8",
      "title": "Dietary Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e0f1f4a8-68f5-484e-8f78-10b182e3cecb.jpg?v=1788037627",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dietary",
        "supplement",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 45,
        "manufacturing": 32,
        "safety": 50,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 18.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830170112197",
      "vsf_explanation": "This SKU is sold under the literal generic name 'Dietary Supplement' with an ingredient list (vitamin B6 — pyridoxine HCl, vitamin D3 — cholecalciferol, magnesium complex — six forms: glycinate, orotate, citrate, malate, gluconate, carbonate, and astragalus root extract) that reads as a magnesium + vitamin D + astragalus stack. Six magnesium forms in a single formula with no per-form disclosure has the same dilution problem noted elsewhere. Astragalus is a legitimate immune-modulating botanical with modest evidence. No manufacturer, no doses. Auto-failed under misleading_naming and proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "mens-vitality-support-drops",
      "title": "Mens Vitality Support Drops",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/27ef622b-9270-4533-aae8-54f6790a3188.jpg?v=1788037627",
      "score": 28,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mens",
        "vitality",
        "support",
        "drops",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 30,
        "manufacturing": 28,
        "safety": 35,
        "transparency": 20,
        "sustainability": 35
      },
      "price": 20.65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830170079429",
      "vsf_explanation": "This SKU is sold as 'Mens Vitality Support Drops' — 'vitality' being a coded testosterone/libido claim — with an ingredient list (maca, ashwagandha, beet extract, L-arginine, fenugreek, tongkat ali, ginseng, turmeric, nettle, elm bark) that is a typical men's-supplement kitchen sink. Ten ingredients in a liquid dropper format with no per-drop dose disclosure means every component is present in trace amounts. 'Male vitality' framing walks up to but does not quite cross the line for implied ED / testosterone treatment claims. No manufacturer, no doses. Auto-failed under misleading_naming and proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "dietary-supplement-9",
      "title": "Dietary Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2339de93-425a-44dc-955e-485fee75e433.jpg?v=1788037627",
      "score": 36,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dietary",
        "supplement",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 40,
        "manufacturing": 30,
        "safety": 48,
        "transparency": 22,
        "sustainability": 40
      },
      "price": 18.7,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830170144965",
      "vsf_explanation": "This SKU is sold under the literal generic name 'Dietary Supplement' with an ingredient list (vitamin E, vitamin A, vitamin D3, zinc, fish oil, olive oil, L-theanine, chamomile extract, zeaxanthin) that mixes eye-support ingredients (vitamin A, zeaxanthin) with relaxation ingredients (L-theanine, chamomile) and general supports. Nine ingredients across three functional categories with no manufacturer, no doses, and no coherent positioning. Auto-failed under misleading_naming and proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "dietary-supplement-10",
      "title": "Dietary Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/36976059-868c-4a6f-a905-c58ea1141f1c.jpg?v=1788037627",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dietary",
        "supplement",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 38,
        "manufacturing": 30,
        "safety": 45,
        "transparency": 22,
        "sustainability": 40
      },
      "price": 18.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830170177733",
      "vsf_explanation": "This SKU is sold under the literal generic name 'Dietary Supplement' with an ingredient list (vitamin C, zinc, nattokinase, grape seed extract, garlic extract, ginger, quercetin, green tea extract, turmeric extract) that reads as a cardiovascular / immune / anti-inflammatory multi. Nine ingredients in 60 capsules with no per-ingredient dose means every component is likely sub-clinical, and nattokinase inclusion re-introduces the FU-not-mg measurement issue plus anticoagulant potentiation risk. Panel error ('5. Garlic extract: support cardiovascular health support' with numeric prefix) suggests scraped text. Auto-failed under misleading_naming and proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "vitamin-supplement-drops",
      "title": "Vitamin Supplement Drops",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d2c8a551-62ae-4222-8a83-f59fbd7d6a56.jpg?v=1788037629",
      "score": 26,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "supplement",
        "drops",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 18,
        "formulation": 25,
        "manufacturing": 25,
        "safety": 35,
        "transparency": 18,
        "sustainability": 32
      },
      "price": 11.22,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830170210501",
      "vsf_explanation": "This SKU is sold as 'Vitamin Supplement Drops' with an ingredient list built around 'mint extract, traditional Chinese medicine extract, glucolactone, potassium sorbate, vitamin B1.' 'TCM extract' as an ingredient with no botanical identity is the primary problem — the actual active component is opaque. Vitamin B1 (thiamine) is a real vitamin but is not typically dosed via drops. No manufacturer, no per-drop dose, no B1 mg. Auto-failed under misleading_naming and proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "health-care-products-oregano-oil-capsule-dietary-supplement-soft-capsules-2",
      "title": "Health Care Products Oregano Oil Capsule Dietary Supplement Soft Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/163d4fb6-246d-4850-9ace-d0bb08f1f4a5_aa7ad93c-5a3c-4ca4-acdb-ac24d24dd2f0.jpg?v=1788037628",
      "score": 36,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "health",
        "care",
        "products",
        "oregano",
        "oil",
        "capsule",
        "dietary",
        "supplement",
        "soft",
        "capsules",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 38,
        "manufacturing": 30,
        "safety": 45,
        "transparency": 22,
        "sustainability": 40
      },
      "price": 22.12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830170243269",
      "vsf_explanation": "This SKU is sold under a keyword-stuffed title mashing 'health care products,' 'oregano oil capsule,' and 'dietary supplement soft capsules' — with 'OEM/spot' as the disclosed production process (OEM literally means original equipment manufacturer, i.e. white-label — the seller is explicitly stating no brand identity). No manufacturer, no per-capsule carvacrol content (the standardization measure that matters for oregano oil), no dose, no COA. Oregano oil has small-trial evidence for antimicrobial activity when standardized to carvacrol content, but unstandardized 'oregano oil' capsules vary enormously in potency. Auto-failed under misleading_naming.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "capsules-a-best-selling-export-product-shilajit-extract-sourced-directly-from-the-manufacturer",
      "title": "Capsules A Best-selling Export Product Shilajit Extract Sourced Directly From The Manufacturer",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1124cc81-8c54-475e-98e3-38ddef42f0b2_water.jpg?v=1788037629",
      "score": 28,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "capsules",
        "best",
        "selling",
        "export",
        "product",
        "shilajit",
        "extract",
        "sourced",
        "directly",
        "from",
        "the",
        "manufacturer",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 28,
        "manufacturing": 25,
        "safety": 32,
        "transparency": 20,
        "sustainability": 35
      },
      "price": 13.08,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830170276037",
      "vsf_explanation": "This SKU is sold under a keyword-stuffed title ('Capsules A Best-selling Export Product Shilajit Extract Sourced Directly From The Manufacturer') with no disclosed manufacturer name (the title's 'sourced directly from the manufacturer' claim is self-defeating without disclosing who that manufacturer is), no per-capsule fulvic acid or shilajit content, no source region (Himalayan shilajit varies dramatically by geographic origin), and no COA. Shilajit is a category with well-documented heavy-metal contamination concerns — Himalayan and Altai shilajit source material has been shown to contain elevated lead, arsenic, and mercury from soil and mineral origins. Independent testing of shilajit consumer products has repeatedly found products with heavy-metal levels above safety thresholds. Auto-failed under misleading_naming.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "sealed-bottled-health-care-supplies-capsules",
      "title": "Sealed Bottled Health Care Supplies Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/39cee1ad-e717-4f80-b636-f4b183772abe.jpg?v=1788037629",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sealed",
        "bottled",
        "health",
        "care",
        "supplies",
        "capsules",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 8,
        "formulation": 10,
        "manufacturing": 18,
        "safety": 25,
        "transparency": 10,
        "sustainability": 28
      },
      "price": 38.65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830170308805",
      "vsf_explanation": "This SKU is sold as 'Sealed Bottled Health Care Supplies Capsules' — a keyword-stuffed generic descriptor that names neither an ingredient nor a use case — with no disclosed manufacturer, brand identity, ingredient list, dose, or facility of origin. The product-information section is entirely about physical packaging (60 pieces/bottle, capsule dosage form, 50 g weight). This is a floor case for uninformative product listings. Auto-failed under misleading_naming.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "butter-soft-capsules",
      "title": "Butter Soft Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/83cc09bb-3a2e-4cda-8a49-25876c25eca1_fine.jpg?v=1788037630",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "butter",
        "soft",
        "capsules",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 15,
        "manufacturing": 20,
        "safety": 28,
        "transparency": 12,
        "sustainability": 30
      },
      "price": 19.78,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830170341573",
      "vsf_explanation": "This SKU is sold as 'Butter Soft Capsules' with no ingredient list, no manufacturer, no brand identity, no dose, no facility of origin, and no product description beyond package specifications (180 or 300 capsules per bottle). 'Butter' as a product name provides no meaningful ingredient information — could refer to shea butter, cocoa butter, or nothing at all. Auto-failed under misleading_naming.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "dietary-supplement-11",
      "title": "Dietary Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a8466fe7-708b-4948-b794-92bf5c95a50a.jpg?v=1788037630",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dietary",
        "supplement",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 30,
        "safety": 42,
        "transparency": 22,
        "sustainability": 40
      },
      "price": 18.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830170439877",
      "vsf_explanation": "This SKU is sold under the literal generic name 'Dietary Supplement' with an ingredient list (vitamin C, berberine hydrochloride, digestive enzyme combination, artichoke leaf extract, zinc citrate) that mixes a digestive-support framework (enzymes, artichoke) with berberine — a compound with meaningful glucose-lowering activity. Berberine's presence introduces implied glucose-management and drug-interaction concerns even when the overall product is framed as digestive. No manufacturer, no doses, no enzyme unit measurements. Auto-failed under misleading_naming and proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "dietary-supplement-12",
      "title": "Dietary Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ef36f3dc-6177-4fbf-a3fc-488c76c41590.jpg?v=1788037631",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dietary",
        "supplement",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 35,
        "manufacturing": 28,
        "safety": 40,
        "transparency": 20,
        "sustainability": 38
      },
      "price": 19.8,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830170472645",
      "vsf_explanation": "This SKU is sold under the literal generic name 'Dietary Supplement' with an ingredient list (vitamin E, vitamin B6, zinc, chromium, L-glutamine, glycine, Berberis extract, Momordica charantia extract) that unambiguously targets blood-glucose regulation — chromium, berberine (Berberis), and bitter melon (Momordica charantia) are three well-known glucose-lowering ingredients. Products marketed for glucose lowering without FDA-approved drug status walk directly into unverified_disease_claim territory when they imply management of diabetes or 'healthy blood sugar.' No manufacturer, no doses, no berberine standardization. Auto-failed under unverified_disease_claim and misleading_naming.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "creatine-jelly",
      "title": "Creatine Jelly",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1934778635747856384.jpg?v=1788037631",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "creatine",
        "jelly",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 48,
        "manufacturing": 32,
        "safety": 55,
        "transparency": 32,
        "sustainability": 38
      },
      "price": 58.65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830170505413",
      "vsf_explanation": "This SKU is sold as 'Creatine Jelly' in three flavor variants (raspberry: 5,000 mg creatine per 4 tablets; blueberry: 5,000 mg creatine monohydrate + 1,000 mg licorice extract + 0.2 mg B12; strawberry: 5,000 mg creatine + 100 mg taurine + 50 mg betaine anhydrous + 50 mg alpha-GPC + 200 μg B12). This is the strongest dose disclosure in the batch — 5 g creatine per serving is the correct research-supported maintenance dose. But no manufacturer, no brand identity, no source, no COA. Creatine monohydrate has documented adulteration risk from cheap Chinese source material. The 1,000 mg licorice in the blueberry variant is a specific safety concern for prolonged use — glycyrrhizin causes mineralocorticoid-like effects (potassium loss, sodium retention, hypertension). Auto-failed under misleading_naming.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "multivitamin-capsules-90-count",
      "title": "Multivitamin Capsules 90 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2959d4b1-7c90-4ec2-a0fd-51b65d0b0dd6_water.jpg?v=1788037631",
      "score": 26,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "multivitamin",
        "capsules",
        "count",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 22,
        "manufacturing": 28,
        "safety": 35,
        "transparency": 18,
        "sustainability": 32
      },
      "price": 18.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830170767557",
      "vsf_explanation": "This SKU is sold as 'Multivitamin Capsules 90 Count' with the package specification 'Weight-loss Multivitamin Capsules' — combining a generic multivitamin identity with a weight-loss claim. No vitamin identities, no potencies, no manufacturer, and no ingredient list. Multivitamins in general have no evidence for weight loss; the pairing of 'multivitamin' with 'weight-loss' is either a false claim or an undisclosed stimulant-blend product mislabeled as a multivitamin. Auto-failed under unverified_medical_claim and misleading_naming.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "collagen-capsule-1",
      "title": "Collagen Capsule",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4725189a-5ca1-4b35-8428-e7ecbd8e8468.jpg?v=1788037632",
      "score": 36,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "collagen",
        "capsule",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 30,
        "safety": 48,
        "transparency": 22,
        "sustainability": 40
      },
      "price": 23.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830170800325",
      "vsf_explanation": "This SKU is sold as 'Collagen Capsule' with no disclosed manufacturer, brand identity, collagen type (I, II, III), source (bovine, marine, chicken, egg membrane), per-capsule milligrams, or facility of origin. Sixty capsules per bottle. Collagen in capsule format is structurally poor for delivering a clinical dose — hydrolyzed collagen peptide research uses 2.5-10 g/day, which requires powder or 20+ capsules to approximate. Auto-failed under misleading_naming.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "dietary-supplement-13",
      "title": "Dietary Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2fb9e6a5-e822-482a-be26-5f91449a8b14.jpg?v=1788037632",
      "score": 36,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dietary",
        "supplement",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 42,
        "manufacturing": 30,
        "safety": 48,
        "transparency": 22,
        "sustainability": 40
      },
      "price": 19.8,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830170996933",
      "vsf_explanation": "This SKU is sold under the literal generic name 'Dietary Supplement' with an ingredient list (vitamin C, vitamin E, zinc, marigold — lutein/zeaxanthin source, bilberry, blackcurrant, capsaicin) that reads as an eye-health / macular-support blend. Lutein and zeaxanthin at 10 mg and 2 mg respectively have AREDS2 clinical support for age-related macular degeneration progression. Bilberry and blackcurrant have modest evidence for night-vision and eye-fatigue endpoints. Capsaicin in an eye formula is unusual and unexplained. But no manufacturer, no doses, no lutein/zeaxanthin milligrams. Auto-failed under misleading_naming and proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "cell-vitality-dietary-capsules",
      "title": "Cell Vitality Dietary Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b71d1fed-5981-4fe4-a4a1-d10fc4062999.jpg?v=1788037633",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cell",
        "vitality",
        "dietary",
        "capsules",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 45,
        "manufacturing": 32,
        "safety": 55,
        "transparency": 28,
        "sustainability": 40
      },
      "price": 21.65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830171029701",
      "vsf_explanation": "This SKU is sold as 'Cell Vitality Dietary Capsules' with an ingredient list (vitamin C, broccoli seed extract with 13% glucosinolate, broccoli bud extract with active sulforaphane, mustard seed extract with active sulforaphane) that is a defensible sulforaphane-delivery stack — sulforaphane has legitimate research for Nrf2 pathway activation and detoxification-enzyme induction. Broccoli sprout extracts standardized to glucoraphanin content and paired with myrosinase-active mustard seed is the correct formulation approach. But no manufacturer, no per-capsule milligrams, no glucoraphanin mg or sulforaphane-equivalent yield. Auto-failed under misleading_naming.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "l-carnitine-l-tartrate-capsules",
      "title": "L-Carnitine L-Tartrate Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a7c1fe79-a160-4ccc-a8b4-6ae4da661da3.jpg?v=1788037635",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "carnitine",
        "tartrate",
        "capsules",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 40,
        "manufacturing": 32,
        "safety": 55,
        "transparency": 25,
        "sustainability": 38
      },
      "price": 64.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830171062469",
      "vsf_explanation": "This SKU is sold as 'L-Carnitine L-Tartrate Capsules' with no disclosed manufacturer, brand identity, per-capsule milligrams, or facility of origin — no descriptive text at all beyond images. L-carnitine L-tartrate has legitimate meta-analytic support for exercise-recovery endpoints at 1-2 g/day, but a bottle with zero label information is unlistable. Auto-failed under misleading_naming.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "magnesium-complex-supplement-with-glycinate-citrate-malate-oxide-supports-bone-muscle-digestive-health-vegan-non-gmo-60-capsules",
      "title": "Magnesium Complex Supplement With Glycinate Citrate, Malate Oxide, Supports Bone, Muscle Digestive Health, Vegan Non-GMO, 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e7f9b70e-ad9d-4ba4-a7e6-59916892ddf2.jpg?v=1788037635",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "complex",
        "supplement",
        "with",
        "glycinate",
        "citrate",
        "malate",
        "oxide",
        "supports",
        "bone",
        "muscle",
        "digestive",
        "health",
        "vegan",
        "non",
        "gmo",
        "capsules",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 50,
        "manufacturing": 35,
        "safety": 60,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 19.96,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830171128005",
      "vsf_explanation": "This SKU is sold as a four-form magnesium complex (glycinate, citrate, malate, oxide) with no disclosed manufacturer, brand identity, per-form milligrams, elemental magnesium total, or facility of origin. The four-form design is defensible — glycinate for sleep and low GI irritability, citrate for laxative and general-use, malate for muscle/energy contexts, oxide as low-cost bulk — but combining oxide (which has ~4% bioavailability) with three highly-bioavailable forms without disclosing the ratio is a hidden dilution problem: cheap oxide can dominate the mg total while the buyer thinks they're getting glycinate. 'Supports bone, muscle, digestive health' is at the acceptable structure/function edge. Vegan/non-GMO claims are self-declared without certification. Auto-failed under misleading_naming and proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "nutrition-powder",
      "title": "Nutrition Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/40cec341-46aa-4f04-9307-5b941b20c4e3.jpg?v=1788037635",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrition",
        "powder",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 8,
        "formulation": 10,
        "manufacturing": 18,
        "safety": 25,
        "transparency": 10,
        "sustainability": 25
      },
      "price": 16.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830171095237",
      "vsf_explanation": "This SKU is sold as 'Nutrition Powder' with no ingredient list, no manufacturer, no brand, no dose, and no product description whatsoever — the entire product page consists of one image. This is not a scoreable product. Auto-failed under misleading_naming (product is a category placeholder, not a formulation).",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "dietary-supplement-14",
      "title": "Dietary Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/806d4eba-787c-4fb9-93e9-b72b5217d03a.jpg?v=1788037635",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dietary",
        "supplement",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 40,
        "manufacturing": 30,
        "safety": 50,
        "transparency": 22,
        "sustainability": 40
      },
      "price": 18.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830171259077",
      "vsf_explanation": "This SKU is sold under the literal generic name 'Dietary Supplement' with a single disclosed ingredient (L-serine) but no manufacturer, brand identity, per-capsule milligrams, or facility of origin. L-serine has an emerging evidence base for neurological indications — most notably ALS (RCTs at 15-30 g/day for slowing progression) and neurodegenerative disease research — but effective research doses are enormous (15-30 g/day, i.e. dozens of capsules) and no dose is disclosed here. Auto-failed under misleading_naming.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "collagen-peptide-supplement-powder",
      "title": "Collagen Peptide Supplement Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b1b06905-21c1-4d73-b35e-30d3aef411f2.jpg?v=1788037635",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "collagen",
        "peptide",
        "supplement",
        "powder",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 32,
        "manufacturing": 28,
        "safety": 45,
        "transparency": 22,
        "sustainability": 38
      },
      "price": 36.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830171291845",
      "vsf_explanation": "This SKU is sold as 'Collagen Peptide Supplement Powder' with an ingredient list that describes an 'NAD exclusive compound formula' with 'nicotinamide adenine dinucleotide, biotin, collagen III.' The word 'exclusive' is a marketing modifier. NAD as a raw dietary ingredient is essentially nonfunctional — oral NAD does not survive digestion; the actual clinical NAD-precursor market uses NR (nicotinamide riboside) or NMN (nicotinamide mononucleotide). 'NAD' as a supplement ingredient is either a mislabel of one of those precursors or a placebo entry. No manufacturer, no per-ingredient dose. Auto-failed under misleading_naming and proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "dietary-supplement-15",
      "title": "Dietary Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/90bcb8a2-1d30-452c-835c-15002caf4129.jpg?v=1788037635",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dietary",
        "supplement",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 45,
        "manufacturing": 32,
        "safety": 50,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 18.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830171324613",
      "vsf_explanation": "This SKU is sold under the literal generic name 'Dietary Supplement' with an ingredient list (vitamin C, vitamin E, urolithin A, pomegranate extract, resveratrol, quercetin, coenzyme Q10, alpha-lipoic acid, acetyl-L-carnitine) that reads as a plausible longevity/mitochondrial stack. Urolithin A is a legitimate emerging longevity compound (the branded Mitopure product has RCTs at 500 mg/day). CoQ10, ALCAR, ALA all have decent evidence. But: nine ingredients in 60 capsules without dose disclosure means every individual dose is a rounding error compared to research amounts (urolithin A alone is dosed at 500 mg/day). Auto-failed under misleading_naming and proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "qingsi-hengjing-nutritional-capsules",
      "title": "Qingsi Hengjing Nutritional Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/91683f2e-cbeb-4d54-86ed-fe2d29c34abc.jpg?v=1788037635",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "qingsi",
        "hengjing",
        "nutritional",
        "capsules",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 32,
        "manufacturing": 25,
        "safety": 40,
        "transparency": 20,
        "sustainability": 35
      },
      "price": 18.33,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830171390149",
      "vsf_explanation": "This SKU is sold under an untranslated placeholder name ('Qingsi Hengjing Nutritional Capsules') with an ingredient list built around an 'Alpinia oxyphylla mushroom mixture' (containing phosphatidylserine 20%, acetyl L-carnitine hydrochloride, Cordyceps, Ganoderma lucidum, Hericium erinaceus, Rhus verniciflua) and a 'probiotic mixture (Lactobacillus plantarum).' Multiple ingredient bundles under a single 'mixture' label is textbook proprietary-blend framing — buyer cannot know the dose of any individual component. Rhus verniciflua (Chinese lacquer tree) is toxicologically concerning: raw extracts contain urushiol and can cause severe allergic reactions; 'detoxified' extracts have some Korean-market use but require careful preparation. Auto-failed under proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "dietary-supplement-16",
      "title": "Dietary Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1a0b40eb-41d1-4d24-b3f2-c71a8779a3ea.jpg?v=1788037636",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dietary",
        "supplement",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 38,
        "manufacturing": 30,
        "safety": 45,
        "transparency": 22,
        "sustainability": 40
      },
      "price": 18.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830171357381",
      "vsf_explanation": "This SKU is sold under the literal generic name 'Dietary Supplement' with an ingredient list (nattokinase, turmeric, quercetin — mislabeled 'quercus' on the panel, green tea, bromelain, nigella seed, dandelion root) that reads as a systemic-enzyme / anti-inflammatory / respiratory blend marketed post-2020 for immune and cardiovascular support. No manufacturer, no per-ingredient dose, no nattokinase FU, no COA. Panel error ('quercus' — which is oak — instead of 'quercetin') suggests OCR/machine translation. Auto-failed under misleading_naming and proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "nitric-oxide-beetroot-capsules-nitrilixoe-powder-betainefactory-direct-sales",
      "title": "Nitric Oxide Beetroot Capsules NITRILIXOE Powder BetaineFactory Direct Sales",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/92b6ee47-a494-45ac-9827-f447c8eb6609_fine.jpg?v=1788037636",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nitric",
        "oxide",
        "beetroot",
        "capsules",
        "nitrilixoe",
        "powder",
        "betainefactory",
        "direct",
        "sales",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 35,
        "manufacturing": 28,
        "safety": 45,
        "transparency": 20,
        "sustainability": 35
      },
      "price": 18.04,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830171455685",
      "vsf_explanation": "This SKU is sold under a keyword-stuffed spam title ('Nitric Oxide Beetroot Capsules NITRILIXOE Powder BetaineFactory Direct Sales') that mashes together multiple SEO fragments. No disclosed manufacturer, brand identity, per-capsule milligrams, or nitrate standardization. Ninety capsules per bottle. Beetroot for nitric oxide has real exercise-performance evidence but requires nitrate content disclosure to be meaningful. 'NITRILIXOE' is not a recognized ingredient or brand — appears to be a scraped or fabricated name. Auto-failed under misleading_naming.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "shunfujingchang-capsule",
      "title": "Shunfujingchang Capsule",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f14203ad-b8a1-45e6-bbbc-2eefc236d684.jpg?v=1788037636",
      "score": 26,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shunfujingchang",
        "capsule",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 25,
        "manufacturing": 22,
        "safety": 28,
        "transparency": 18,
        "sustainability": 32
      },
      "price": 20.75,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830171422917",
      "vsf_explanation": "This SKU is sold under an untranslated placeholder name ('Shunfujingchang Capsule') with a single disclosed ingredient — 'activated zeolite composite composition.' Oral zeolite (clinoptilolite) is a category with significant safety concerns: FDA does not recognize zeolite as safe for oral supplementation, and mineral zeolites are commonly contaminated with heavy metals (lead, aluminum, arsenic) from mining source. Marketing claims for 'detox' and 'chelation' via oral zeolite are not supported by controlled human evidence and have drawn FTC enforcement action. Auto-failed under unverified_medical_claim (implied detoxification via zeolite) and misleading_naming.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "relieve-male-front-discomfort-yang-warming-kidney-body-care-capsule",
      "title": "Relieve Male Front Discomfort Yang Warming Kidney Body Care Capsule",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a5201c21-4e9a-4b60-82ab-abbac7acd59a.jpg?v=1788037636",
      "score": 22,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "relieve",
        "male",
        "front",
        "discomfort",
        "yang",
        "warming",
        "kidney",
        "body",
        "care",
        "capsule",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 22,
        "manufacturing": 22,
        "safety": 28,
        "transparency": 15,
        "sustainability": 30
      },
      "price": 14.26,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830171488453",
      "vsf_explanation": "This SKU is sold under a title that stacks multiple unverified medical claims: 'Relieve Male Front Discomfort' (implied prostate/urological treatment), 'Yang Warming Kidney' (TCM diagnostic-treatment language), and 'Body Care.' 'Male front discomfort' is a euphemism for genitourinary symptoms and constitutes an implied treatment claim for a specific medical condition — a category the FDA regulates as drugs, not supplements. The ingredient list includes 'purified water' as an ingredient (which is nonsensical in a capsule), dogwood, angelica, ginseng, astragalus, and palm oil. Auto-failed under unverified_medical_claim and unverified_disease_claim.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "90-natto-capsules",
      "title": "90 Natto Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/dee02a55-73b0-4c9d-ab4e-0326922c478c.jpg?v=1788037636",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "natto",
        "capsules",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 30,
        "safety": 48,
        "transparency": 25,
        "sustainability": 38
      },
      "price": 16.43,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830171619525",
      "vsf_explanation": "This SKU is sold as '90 Natto Capsules' with 'designed specifically for export trade' framing and no disclosed manufacturer, per-capsule milligrams, or — critically for nattokinase — fibrinolytic units (FU). Nattokinase has small-trial evidence for modest blood-pressure reduction at 2,000 FU/day, but potency is measured in FU, not mg, and unlabeled products can be anywhere from sub-clinical to over-clinical. 'For export trade' framing usually indicates a product not compliant with domestic (Chinese) retail labeling requirements. Auto-failed under misleading_naming.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "soft-candy-improves-resistance-and-supplements-energy",
      "title": "Soft Candy Improves Resistance And Supplements Energy",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6a3a14f0-fc27-44cc-bca6-4fb70194bee1.jpg?v=1788037636",
      "score": 24,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "soft",
        "candy",
        "improves",
        "resistance",
        "and",
        "supplements",
        "energy",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 20,
        "manufacturing": 22,
        "safety": 32,
        "transparency": 15,
        "sustainability": 30
      },
      "price": 32.41,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830171652293",
      "vsf_explanation": "This SKU is sold as 'Soft Candy Improves Resistance And Supplements Energy' with no ingredient list, no manufacturer, no dose, and product-information text that describes only size and shelf life. 'Improves resistance' is an implied immune-treatment claim. The product is literally a candy with an implied medical benefit. Auto-failed under misleading_naming and unverified_medical_claim.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "tongheng-huanti-drops",
      "title": "Tongheng Huanti Drops",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9408e1f3-87de-41d5-b399-813d488dea83.jpg?v=1788037637",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tongheng",
        "huanti",
        "drops",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 35,
        "manufacturing": 28,
        "safety": 45,
        "transparency": 20,
        "sustainability": 38
      },
      "price": 18.8,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830171685061",
      "vsf_explanation": "This SKU is sold under an untranslated placeholder name ('Tongheng Huanti Drops') with no disclosed manufacturer, brand identity, or facility of origin. The disclosed ingredients — elderberry extract, Echinacea purpurea extract, dandelion leaf extract — form a recognizable immune-support botanical stack with modest evidence (elderberry has small-trial support for reducing cold and flu symptom duration; echinacea has mixed evidence). No per-drop milligrams, no standardization, no COA. Auto-failed under misleading_naming.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "female-light-rejuvenating-supplement-capsule",
      "title": "Female Light Rejuvenating Supplement Capsule",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/514b0a13-bf27-46da-84ee-8a388b2659e9.jpg?v=1788037637",
      "score": 26,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "female",
        "light",
        "rejuvenating",
        "supplement",
        "capsule",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 18,
        "formulation": 25,
        "manufacturing": 28,
        "safety": 30,
        "transparency": 22,
        "sustainability": 32
      },
      "price": 18.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830171717829",
      "vsf_explanation": "This SKU is sold as 'Female Light Rejuvenating Supplement Capsule' — 'rejuvenating' being an unverified anti-aging claim — with an ingredient list (green tea extract, green coffee bean extract, raspberry ketone, Garcinia cambogia extract, anhydrous caffeine) that is unambiguously a weight-loss stimulant blend, not a rejuvenation formula. The name-formula mismatch itself is a red flag. Raspberry ketone has no credible human evidence for weight loss (the popular claim is based on rodent-only data); Garcinia cambogia has been repeatedly shown to produce no meaningful weight loss in RCTs and carries a documented FDA hepatotoxicity signal; anhydrous caffeine at unstated doses in a multi-ingredient blend is a stimulant-overdose risk. Auto-failed under unverified_medical_claim ('rejuvenating') and misleading_naming.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "dietary-supplement-17",
      "title": "Dietary Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0fb90ba8-16fe-469b-93da-32d37a4f1411.jpg?v=1788037639",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dietary",
        "supplement",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 38,
        "manufacturing": 28,
        "safety": 42,
        "transparency": 22,
        "sustainability": 38
      },
      "price": 18.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830171783365",
      "vsf_explanation": "This SKU is sold under the literal generic name 'Dietary Supplement' with no disclosed manufacturer, brand identity, or facility of origin. The ingredient list (vitamin E, nattokinase, curcumin, bromelain, Panax ginseng, serrapeptase, ginger root) is a recognizable 'systemic enzyme / fibrinolytic' stack marketed elsewhere for cardiovascular and inflammation support — but none of the doses are disclosed, and nattokinase clinical dosing (2,000 FU/day) requires a fibrinolytic-unit measurement that this label does not provide. Serrapeptase carries FDA safety-signal caveats (respiratory reactions in a small number of case reports). Auto-failed under misleading_naming (product literally named 'Dietary Supplement') and proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "moringa-oleifera-capsule",
      "title": "Moringa Oleifera Capsule",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ebcc1884-9a52-4570-85a1-d0037db76f13.jpg?v=1788037639",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "moringa",
        "oleifera",
        "capsule",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 28,
        "manufacturing": 28,
        "safety": 45,
        "transparency": 18,
        "sustainability": 38
      },
      "price": 21.54,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830171750597",
      "vsf_explanation": "This SKU is sold as 'Moringa Oleifera Capsule' with a self-contradicting product description ('Main raw materials: vitamins') that misidentifies the compound category — moringa is a botanical, not a vitamin. No disclosed manufacturer, brand identity, per-capsule milligrams, extraction ratio, standardization, or facility of origin. Sixty capsules per bottle, dose unstated. The listing errors (vitamins vs botanical) suggest scraped copy rather than a curated formulation. Auto-failed under misleading_naming.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "best-selling-collagen-vitamin-capsules",
      "title": "Best-selling Collagen Vitamin Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3f5e245c-d7d4-47a9-922c-16169ed6a4ab.jpg?v=1788037639",
      "score": 28,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "best",
        "selling",
        "collagen",
        "vitamin",
        "capsules",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 25,
        "manufacturing": 28,
        "safety": 40,
        "transparency": 18,
        "sustainability": 35
      },
      "price": 19.67,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830171816133",
      "vsf_explanation": "This SKU is sold as 'Best-selling Collagen Vitamin Capsules' with a self-declared marketing claim ('Best-selling') and no disclosed manufacturer, no ingredient identity beyond the words 'collagen' and 'vitamin,' no collagen type (I, II, or III), no source (bovine, marine, chicken), no per-capsule milligrams, and no vitamin identity or dose. The 'Best-selling' claim is unsubstantiated (no ranking authority is cited). Multiple package-size variants (30/60/90/120) are offered without differentiating price or dose per capsule. Auto-failed under misleading_naming.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "liquid-chlorophyll-1",
      "title": "Liquid Chlorophyll",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c79a010d-c396-417e-859f-b153e7030f8a.jpg?v=1788037639",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liquid",
        "chlorophyll",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 30,
        "manufacturing": 28,
        "safety": 45,
        "transparency": 20,
        "sustainability": 40
      },
      "price": 35.46,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830172012741",
      "vsf_explanation": "This SKU is sold as 'Liquid Chlorophyll' with no product description at all — only product images — no disclosed manufacturer, no chlorophyllin vs chlorophyll distinction, no per-serving milligrams, no source plant, and no facility of origin. Chlorophyllin (the water-soluble semi-synthetic derivative used in commercial 'liquid chlorophyll' drops) has limited human evidence — a small body of work on odor reduction in specific clinical populations (colostomy patients, trimethylaminuria) and one 2015 study on breath odor. Skin, weight-loss, and 'detox' claims that drove the TikTok-era popularity of the category are not evidence-supported. Auto-failed under misleading_naming: zero disclosure beyond images.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "muscle-recovery-support-capsule",
      "title": "Muscle Recovery Support Capsule",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/dea8d7a4-248c-49ec-a9b8-928c60e6b809.jpg?v=1788037640",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "muscle",
        "recovery",
        "support",
        "capsule",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 30,
        "safety": 45,
        "transparency": 22,
        "sustainability": 40
      },
      "price": 18.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830172111045",
      "vsf_explanation": "This SKU is sold as 'Muscle Recovery Support Capsule' with a list of fifteen individual amino acids (L-valine, L-glutamine, L-glycine, L-proline, L-lysine, L-alanine, L-arginine, L-histidine, L-leucine, L-tyrosine, L-serine, L-threonine, L-isoleucine, L-tryptophan) but no manufacturer, no brand identity, and no per-amino-acid milligram dose. Sixty capsules cannot plausibly deliver research-relevant doses of fifteen amino acids simultaneously — effective BCAA doses alone are 5-10 g/day, effective glutamine doses 5-15 g/day. A capsule format across fifteen aminos means every individual dose is a rounding error. Auto-failed under misleading_naming and proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "mannose-capsules",
      "title": "Mannose Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/82a47689-01be-48b8-a0fe-d702e65c491d_water.jpg?v=1788037640",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mannose",
        "capsules",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 42,
        "manufacturing": 35,
        "safety": 55,
        "transparency": 28,
        "sustainability": 40
      },
      "price": 37.66,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830172176581",
      "vsf_explanation": "This SKU is sold as 'Mannose Capsules' (D-mannose, 120 capsule count) with no disclosed manufacturer, brand identity, per-capsule milligram dose, or facility of origin. D-mannose is a legitimate, evidence-supported sugar with multiple RCTs demonstrating efficacy in reducing recurrent urinary tract infection frequency at 1.5-2 g/day. A published 2022 JAMA Internal Medicine trial (n=598) was less positive, though, showing no significant reduction versus placebo, so the evidence base is mixed but real. The 'main nutrients: vitamins' descriptor is a scraped error — D-mannose is a monosaccharide, not a vitamin. Auto-failed under misleading_naming: no manufacturer, no dose, and a description that misidentifies the compound category.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "xiongneng-homogeneous-compound-capsule",
      "title": "Xiongneng Homogeneous Compound Capsule",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/47a19b6c-159b-4a64-bc0c-2080e7128f6f.jpg?v=1788037640",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "xiongneng",
        "homogeneous",
        "compound",
        "capsule",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 42,
        "manufacturing": 32,
        "safety": 48,
        "transparency": 28,
        "sustainability": 40
      },
      "price": 24.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830172340421",
      "vsf_explanation": "This SKU is sold under a machine-translated placeholder name ('Xiongneng Homogeneous Compound Capsule') with no disclosed manufacturer, brand identity, or facility of origin. The disclosed ingredient is beetroot extract at a 30:1 extract ratio equivalent to 9,000 mg raw beetroot — an actual dose disclosure, which is uncommon in this batch. Beetroot has moderate evidence for exercise-performance improvements via nitrate-driven nitric oxide upregulation, though the 30:1 extract ratio does not preserve nitrate content well (nitrates are water-soluble and often lost in concentration). No standardization of nitrate content is stated, and the untranslated product name plus no manufacturer identity trigger auto-fail. Auto-failed under misleading_naming.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "dietary-supplement-18",
      "title": "Dietary Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fee0618c-833e-400e-953c-8c9272707f6e.jpg?v=1788037641",
      "score": 36,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dietary",
        "supplement",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 30,
        "safety": 45,
        "transparency": 22,
        "sustainability": 40
      },
      "price": 18.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830172405957",
      "vsf_explanation": "This SKU is sold under the literal generic name 'Dietary Supplement' with no disclosed manufacturer, brand identity, or facility of origin. The disclosed ingredient list — pantothenic acid, B-vitamin (unclear which), cyanocobalamin (B12), magnesium, zinc, ashwagandha (Withania somnifera) extract, holy basil (Ocimum sanctum) extract, L-theanine — is a recognizable adaptogen-plus-cofactor stress-support stack with several legitimate ingredients. But zero per-ingredient milligrams are disclosed, extract standardization is not specified (ashwagandha efficacy depends heavily on whether it is KSM-66 or Sensoril standardized withanolides), and no manufacturer name is attached. Auto-failed under misleading_naming (literal generic title) and proprietary_blend_hides_dose (multi-ingredient formula with no doses).",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "creatine-powder",
      "title": "Creatine Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/75b4f945-2c58-4626-aed8-ac41785ed096.jpg?v=1788037683",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "creatine",
        "powder",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 55,
        "manufacturing": 38,
        "safety": 60,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 39.64,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830172831941",
      "vsf_explanation": "This SKU is sold as 'Creatine Powder' with an unusually specific dose disclosure — 5 g creatine per 6 g serving (watermelon flavor) — but with no disclosed manufacturer, brand identity, creatine form (monohydrate vs HCl vs micronized), source country, or third-party certificate of analysis. Creatine monohydrate is arguably the single most evidence-backed sports supplement in existence, with hundreds of RCTs and decades of safety data supporting the 5 g/day maintenance dose disclosed here. The compound itself would score Verified-tier from a legitimate brand. But 'nameless bag of powder' — even with the correct dose printed — cannot be listed on Vyvata because the buyer cannot verify what is actually in it. Creatine has a well-documented supply-chain adulteration history (dextrose cutting, unreported heavy metals from Chinese source material). Auto-failed under misleading_naming.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "health-vinegar-capsules-1",
      "title": "Health Vinegar Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/619aca01-e545-48e4-9fab-758502c46e40_da634788-cabb-4559-9be6-36f5332b3e33.jpg?v=1788037683",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "health",
        "vinegar",
        "capsules",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 28,
        "manufacturing": 30,
        "safety": 45,
        "transparency": 22,
        "sustainability": 35
      },
      "price": 28.75,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830172963013",
      "vsf_explanation": "This SKU is sold as 'Health Vinegar Capsules' — implied apple-cider-vinegar capsules — with no disclosed manufacturer, brand identity, per-capsule mg dose of acetic acid or vinegar solids, or facility of origin. 'Health' as a modifier is a marketing word, not a claim substrate. Apple cider vinegar has modest early-stage evidence for small post-meal glucose blunting at 15-30 mL liquid doses, but capsule products are notorious for underdelivering — the acetic acid content per capsule is typically low and often undisclosed, as here. No Supplement Facts panel, no acetic-acid percentage, no COA. Auto-failed under misleading_naming for the manufacturer-less identity; 'health' as a product-name modifier is also a soft unverified_medical_claim.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "cider-vinegar-gummies-cider-vinegar-grapefruit",
      "title": "Cider Vinegar Gummies Cider Vinegar  Grapefruit",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0e9e032e-7257-4e8b-b445-b46c5307be9c.jpg?v=1788037683",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cider",
        "vinegar",
        "gummies",
        "cider",
        "vinegar",
        "grapefruit",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 30,
        "manufacturing": 32,
        "safety": 48,
        "transparency": 25,
        "sustainability": 35
      },
      "price": 30.38,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830172897477",
      "vsf_explanation": "This SKU is sold as apple-cider-vinegar gummies with a grapefruit flavor descriptor and no disclosed manufacturer, brand identity, per-gummy mg of ACV solids, or acetic acid content. Gummy-format ACV products are structurally the worst-delivering vehicle for the compound — the acetic-acid content per gummy is typically 100-300 mg dried ACV powder (roughly 1-2% of the acetic acid in one tablespoon of liquid vinegar), and the sugar / gelatin base contributes calories without benefit. Independent lab testing published in 2022 (Consumer Reports) found several ACV gummy brands contained no detectable acetic acid at all. Auto-failed under misleading_naming for the manufacturer-less identity.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "moringa-health-drops",
      "title": "Moringa Health Drops",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1e15bf13-b527-497e-9bd1-07d2ad3fbe2f.jpg?v=1788037688",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "moringa",
        "health",
        "drops",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 28,
        "manufacturing": 25,
        "safety": 35,
        "transparency": 22,
        "sustainability": 30
      },
      "price": 16.18,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830173126853",
      "vsf_explanation": "This SKU is sold as 'Moringa Health Drops' with no disclosed manufacturer, brand identity, or facility of origin. The ingredient list mixes moringa seed and mint leaf with two ambiguous entries — 'traditional Chinese medicine extract' (no botanical identity, no dose) and curcumin — plus food-grade preservatives (gluconic acid lactone, potassium sorbate) and vitamin B1. 'Traditional Chinese medicine extract' as an ingredient name is not a formulation; it is a placeholder that could describe any of hundreds of botanicals, several of which carry documented hepatotoxicity risk at unstated doses. No per-drop mg, no extraction ratio, no COA. Auto-failed under proprietary_blend_hides_dose (undisclosed 'TCM extract' in a consumable liquid) and misleading_naming (no manufacturer identity). Consumers cannot identify who formulated or manufactured this product.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "body-supplements-supplement-body-energy",
      "title": "Body Supplements Supplement Body Energy",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/691b6b30-d187-4491-b93f-03dfab11dc2a.jpg?v=1788037688",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "body",
        "supplements",
        "supplement",
        "body",
        "energy",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 12,
        "manufacturing": 20,
        "safety": 25,
        "transparency": 12,
        "sustainability": 25
      },
      "price": 23.55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830173028549",
      "vsf_explanation": "This SKU is sold under a keyword-stuffed generic descriptor ('Body Supplements Supplement Body Energy') with no disclosed manufacturer, no brand identity, no ingredient list, no dose, and no facility of origin. The entire product-information section reads 'Applicable object: any skin type / Type: Capsule / Specification: one bottle' — this is not a formulation, it is placeholder copy scraped for search visibility. Consumers cannot identify who formulated or manufactured this product, what is inside it, or what it is supposed to do beyond the vague word 'energy.' Auto-failed under misleading_naming. There is no possible informed-consent purchase decision available here.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "bsys-7-day-colon-cleanse-detox-formula-60s",
      "title": "BSYS 7 Day Colon Cleanse & Detox Formula 60's",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4334ad32-cb9a-41c2-be5f-279d6e8d8418.jpg?v=1788037688",
      "score": 26,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bsys",
        "day",
        "colon",
        "cleanse",
        "detox",
        "formula",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 22,
        "manufacturing": 25,
        "safety": 30,
        "transparency": 20,
        "sustainability": 30
      },
      "price": 59.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830173094085",
      "vsf_explanation": "This SKU is sold as a '7 Day Colon Cleanse & Detox Formula' under a 'BSYS' descriptor with no disclosed manufacturer, physical company address, or facility of origin — 'BSYS' is not a known dietary-supplement brand with published corporate presence. The product name stacks two unverified medical claims ('colon cleanse' and 'detox') that Cochrane reviews and NIH NCCIH have consistently found to lack rigorous human evidence. The colon self-clears daily in a healthy person, and the liver, kidneys, and lymphatics perform detoxification continuously and do not require supplementation to do so. No Supplement Facts panel, no per-ingredient milligrams, and no third-party COA are surfaced. Auto-failed under unverified_medical_claim for the 'detox' positioning and misleading_naming for the opaque brand shell. Not listable in current form.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "moringa-leaf-capsules-1",
      "title": "Moringa Leaf Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/54c22ac3-1475-48c1-be5d-82fc2feac72b.jpg?v=1788037689",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "moringa",
        "leaf",
        "capsules",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 38,
        "safety": 55,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 24.7,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830173159621",
      "vsf_explanation": "This SKU is sold as 'Moringa Leaf Capsules' with a single named raw material (moringa leaves) but no disclosed manufacturer, brand identity, per-capsule milligram dose, extraction ratio, standardization, or facility of origin. Moringa oleifera is a legitimate food botanical with modest early-stage clinical evidence for small glucose and inflammatory-marker improvements at 2-8 g/day of standardized leaf powder — but 'spicy leaf capsule' with no dose disclosure cannot be evaluated against that evidence base. There is no per-lot COA for identity, heavy metals (moringa is known to accumulate soil-derived cadmium and lead), or microbial contamination. Auto-failed under misleading_naming: no manufacturer or brand identity is disclosed. The single-ingredient identity avoids proprietary-blend concerns and lifts this above the 'Dietary Supplement' floor, but a nameless bottle of undosed moringa is still not listable.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "bsys-l-carnitine-l-tartrate-60s-1",
      "title": "BSYS L-Carnitine L-Tartrate 60's",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0c8dffd0-e77b-4047-8328-ba4c1888408d_621866cd-46da-4bb0-999b-b3c588158713.jpg?v=1788037688",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bsys",
        "carnitine",
        "tartrate",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 38,
        "safety": 55,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 60.85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830173323461",
      "vsf_explanation": "This SKU is sold as 'L-Carnitine L-Tartrate' under a 'BSYS' descriptor with no disclosed manufacturer identity, physical address, or facility of origin. L-carnitine L-tartrate is a legitimate, well-studied compound — meta-analyses in Sports Medicine and Nutrition Reviews document 1-2 g/day supporting exercise recovery markers (reduced muscle soreness, lower markers of exercise-induced muscle damage). The problem is not the ingredient; it is the packaging identity. No per-capsule milligrams are disclosed, so a buyer cannot know whether the bottle delivers the research-relevant 1-2 g/day dose or a fraction. No third-party COA for identity or purity. 'BSYS' is not a published dietary-supplement brand. Auto-failed under misleading_naming.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "allmax-taurine-400g",
      "title": "Allmax Taurine, 400g",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/TAURINE-400G-US1017-main.webp?v=1788037691",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "allmax",
        "taurine",
        "400g",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 78,
        "manufacturing": 68,
        "safety": 70,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 8,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830173388997",
      "vsf_explanation": "Allmax Nutrition is a Canadian sports-nutrition brand (Toronto, founded ~1998) with a mid-tier presence in strength/performance retail. Straight taurine powder, 400g, single-ingredient, no fillers or flavors. Taurine has a defensible evidence base at 1-3g/day for cardiovascular support (blood pressure — Militante 2002 review, Zhang 2004 meta-analysis), endurance performance (Waldron 2018 meta-analysis, small ergogenic effect), and glucose metabolism. Single-ingredient powder in bulk format is honest and cost-effective. Held to Standard by (1) sports-nutrition-brand track record without top-tier third-party verification (no Informed-Sport per lot published), (2) 'muscle contraction and nerve function' claims that outrun the evidence, and (3) taurine mostly synthesized endogenously — the case for exogenous supplementation is weakest in healthy young adults.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnesi-om-magnesium-powder-with-l-theanine-for-relaxation-natural-organic-mixed-berry-or-lemon-flavor",
      "title": "Magnesi-Om Magnesium Powder with L-Theanine for Relaxation, Natural, Organic Mixed Berry or Lemon Flavor",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/nwW8YEDMwFL8P8MaRtBPjxCEci5CMLKZanVjHPIu.jpg?v=1788037696",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "cognitive",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesi",
        "magnesium",
        "powder",
        "with",
        "theanine",
        "for",
        "relaxation",
        "natural",
        "organic",
        "mixed",
        "berry",
        "lemon",
        "flavor",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 72,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 62,
        "sustainability": 65
      },
      "price": 111.84,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830173421765",
      "vsf_explanation": "Magnesi-Om is Moon Juice's flagship magnesium formula — a three-magnesium blend (gluconate + citrate + acetyl taurate) plus L-theanine and monk fruit for flavoring. Moon Juice is a Los Angeles-based adaptogen and wellness brand (Amanda Chantal Bacon, founded 2011). The formulation is thoughtful: magnesium acetyl taurate is a specific form with limited human data (proposed to cross the BBB, some rodent studies for anxiety) and citrate + gluconate are well-absorbed general-purpose forms. Delivers 310mg elemental magnesium per serving plus 200mg L-theanine (a defensible calming dose per Kimura 2007). L-theanine at 200mg has a real evidence base for reduced stress and improved sleep onset. Held to Standard by (1) the magnesium acetyl taurate marketing outrunning the specific-form evidence, (2) no per-lot COA published, and (3) premium price without proportional independent verification. A defensible pick for a magnesium-plus-calm formula.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cardio-support",
      "title": "Cardio Support",
      "vendor": "Rooted Owl Pet Supplements",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1CardioSupport.webp?v=1788037738",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cardio",
        "support",
        "rooted",
        "owl",
        "pet",
        "supplements"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 45,
        "safety": 40,
        "transparency": 38,
        "sustainability": 40
      },
      "price": 32,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830174175429",
      "vsf_explanation": "Rooted Owl Cardio Support is L-Carnitine + L-Taurine for canine cardiovascular support, particularly in aging dogs. Taurine deficiency is a documented cause of dilated cardiomyopathy (DCM) in cats and in certain dog breeds fed grain-free diets (see the FDA 2018-2022 grain-free DCM investigation, which centered on legume-heavy diets that may impair taurine synthesis). L-Carnitine has some canine cardiomyopathy evidence too. Ingredient logic is defensible for pets, but this is a pet supplement and outside Vyvata's evaluation scope. Auto-failed under out_of_scope_for_biohacking.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "joint-muscle-health",
      "title": "Joint & Muscle Health",
      "vendor": "Rooted Owl Pet Supplements",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_01f8ce3a-27c9-47ed-b78e-22b24930449d.webp?v=1788037750",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "joint",
        "muscle",
        "health",
        "rooted",
        "owl",
        "pet",
        "supplements"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 38,
        "manufacturing": 48,
        "safety": 42,
        "transparency": 38,
        "sustainability": 42
      },
      "price": 43,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830174535877",
      "vsf_explanation": "Rooted Owl Joint & Muscle Health for cats and small dogs under 30 lbs, same Lonza UC-II + L-Carnitine formulation as the medium/large dog SKU, dose-adjusted for small animals. Same scope decision: pet supplement, out of Vyvata's evaluation scope. Auto-failed under out_of_scope_for_biohacking.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "joint-muscle-health-1",
      "title": "Joint & Muscle Health",
      "vendor": "Rooted Owl Pet Supplements",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_2ce00a47-09d8-46a0-ae59-0bf68328213d.webp?v=1788037750",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "joint",
        "muscle",
        "health",
        "rooted",
        "owl",
        "pet",
        "supplements"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 38,
        "manufacturing": 48,
        "safety": 42,
        "transparency": 38,
        "sustainability": 42
      },
      "price": 45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830174568645",
      "vsf_explanation": "Rooted Owl Joint & Muscle Health for medium and large dogs, combining Lonza UC-II (undenatured type II collagen) with L-Carnitine. UC-II has a real veterinary evidence base (Deparle 2005, Gupta 2016 for canine osteoarthritis) at 40mg daily, and Lonza is the reference supplier for the ingredient. Formulation is coherent, but this is a canine product, not a human product. Vyvata does not score pet supplements. Auto-failed under out_of_scope_for_biohacking.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "urinary-support-1",
      "title": "Urinary Support",
      "vendor": "Rooted Owl Pet Supplements",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_d278e720-d406-41e1-9aa5-57a4e117ca4a.webp?v=1788037756",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "urinary",
        "support",
        "rooted",
        "owl",
        "pet",
        "supplements"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 32,
        "manufacturing": 45,
        "safety": 40,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 31,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830174798021",
      "vsf_explanation": "Rooted Owl Urinary Support is a canine supplement formulated for dogs (cranberry extract + echinacea + vitamin C). Vyvata's catalog scores human biohacking and longevity products; pet supplements are out of scope. The product is not a human supplement, is not intended for human use, and cannot be scored on Vyvata's rubric because the safety, efficacy, and dosing frameworks differ substantially between human and canine physiology (dogs metabolize many botanicals differently and have different renal clearance profiles). Auto-failed under out_of_scope_for_biohacking.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "turmeric-2",
      "title": "Turmeric",
      "vendor": "Rooted Owl Pet Supplements",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_6a8db5d9-aec3-4c7f-aa4f-3d8f0556ea7e.webp?v=1788037755",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "turmeric",
        "rooted",
        "owl",
        "pet",
        "supplements"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 32,
        "manufacturing": 45,
        "safety": 40,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 34,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830174830789",
      "vsf_explanation": "Rooted Owl Turmeric is a canine-and-feline turmeric-plus-black-pepper-plus-vitamin-C supplement. Curcumin has some evidence in dogs for anti-inflammatory support (limited controlled data), and the piperine-enhanced absorption is scientifically sound in both humans and dogs. But this SKU is not a human product — dose, safety windows, and drug interactions differ from human formulations. Vyvata does not score pet supplements. Auto-failed under out_of_scope_for_biohacking.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "spirulina-chlorella",
      "title": "Spirulina & Chlorella",
      "vendor": "Rooted Owl Pet Supplements",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_e327b750-8d92-4ed0-a4b3-bb0eca355803.webp?v=1788037755",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "spirulina",
        "chlorella",
        "rooted",
        "owl",
        "pet",
        "supplements"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 32,
        "manufacturing": 45,
        "safety": 38,
        "transparency": 35,
        "sustainability": 42
      },
      "price": 32,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830174863557",
      "vsf_explanation": "Rooted Owl Spirulina & Chlorella is marketed for canine and feline red blood cell support and 'detoxification during recovery.' The 'detoxification' framing is unverified even in human medicine and imports the same evidentiary problem into the pet product. More importantly, this SKU is a pet supplement, not a human supplement. Vyvata's rubric is not designed for pet products. Auto-failed under out_of_scope_for_biohacking.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "mushroom-immune-support",
      "title": "Mushroom Immune Support",
      "vendor": "Rooted Owl Pet Supplements",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_0d92c9f3-e861-46d7-a77a-a799bf9518ce.webp?v=1788037756",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mushroom",
        "immune",
        "support",
        "rooted",
        "owl",
        "pet",
        "supplements"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 38,
        "manufacturing": 48,
        "safety": 40,
        "transparency": 38,
        "sustainability": 42
      },
      "price": 41,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830174896325",
      "vsf_explanation": "Rooted Owl Natural Immunity is a triple-mushroom (Reishi + Shiitake + Maitake) canine-and-feline supplement with 'standardized extracts.' Beta-glucans from these species have real immunomodulatory activity in vitro and in some in-vivo mammalian studies, and the ingredient profile is defensible. But this SKU is a pet supplement, and the human-supplement rubric does not apply. Auto-failed under out_of_scope_for_biohacking.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "raw-essentials-liquid-glycerol",
      "title": "RAW Essentials Liquid Glycerol",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/RAW-Essentials-Liquid-Glycerol.jpg?v=1788037861",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "raw",
        "essentials",
        "liquid",
        "glycerol",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 62,
        "sustainability": 45
      },
      "price": 23.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830177321157",
      "vsf_explanation": "RAW Essentials Liquid Glycerol is a single-ingredient hyperhydration/pump product. Glycerol at 1-1.5 g/kg bodyweight has legitimate RCT support as a hyperhydration agent — it draws water into extracellular compartments, increasing plasma volume and cellular hydration for 2-4 hours, with documented benefits for endurance-athlete thermoregulation in heat. For resistance-training 'pump' effects, the mechanism (increased intracellular water in muscle tissue) also has some support at 60-90 minutes pre-workout. The main critique of the category is that WADA restricted glycerol as a plasma-volume expander (banned for competitive athletes in some competitions), and the pump-supplement version of the use case works but is bounded — glycerol adds fullness, not strength. RAW Essentials is a straightforward single-ingredient version; formulation is honest. Score is bounded by the modest evidence tier for the specific use case and overall documentation not at NutraBio level.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "project-ad-shredabull",
      "title": "Project AD Shredabull",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Project-AD-Shredabull.jpg?v=1788037860",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "project",
        "shredabull",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 50,
        "safety": 42,
        "transparency": 30,
        "sustainability": 42
      },
      "price": 39.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830177386693",
      "vsf_explanation": "Project AD Shredabull Untamed 2.0 is a high-stimulant thermogenic fat burner positioned to 'ignite fat-burning' and 'boost metabolism.' The category as a whole underperforms marketing — meta-analyses of OTC thermogenic stacks show 1-2% additional weight loss over placebo across 8-12 week studies, effect sizes that are clinically small versus the caloric-deficit fundamentals fat loss actually requires. Project AD's fat-burner formulations use proprietary blend disclosure with a stimulant complex that combines caffeine, yohimbine, and often synephrine or DMHA-class compounds where per-ingredient doses are hidden. This is autofail territory on proprietary_blend_hides_dose; it is also a safety flag because uncapped stimulant doses in a single serving can push total caffeine over 400 mg and stack yohimbine at doses that cause anxiety, tachycardia, and blood-pressure spikes. Even with full disclosure the category ceilings at Standard on evidence grounds. Not listable in current form.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "mother-earth-labs-organi-earth-superfoods-organic-greens",
      "title": "Mother Earth Labs Organi Earth Superfoods & Organic Greens",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Mother-Earth-Labs-Organi-Earth-Superfoods-Organic-Greens.jpg?v=1788037860",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mother",
        "earth",
        "labs",
        "organi",
        "earth",
        "superfoods",
        "organic",
        "greens",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 55,
        "sustainability": 62
      },
      "price": 77.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830177419461",
      "vsf_explanation": "Mother Earth Labs Organi Earth is a comprehensive greens-plus-multivitamin powder claiming 174 nutrients across organic greens, fruits, and vitamin/mineral fortification. The core evidence problem for the greens-plus-multi category is that ingredient counts in the hundreds necessarily force each ingredient to a fractional dose — a 10 g scoop cannot deliver clinically-meaningful amounts of 174 separate nutrients. Mother Earth Labs offers organic sourcing (a legitimate sustainability plus) and reasonable transparency about ingredient categories, but per-ingredient dosing for the marker compounds (specific polyphenol content, standardized adaptogen doses, vitamin/mineral RDIs) is under-specified. The 'all-in-one' positioning is aspirational rather than mechanistic — combining a fortified multi with a greens blend and superfood powder in one scoop is a convenience play, not a demonstrated additive benefit. Safety at label servings is fine; the ingredients are food-derived. A defensible Standard-tier pick for someone who wants a single-scoop convenience product and does not need clinical-dose ingredients; better single-purpose products exist at similar prices.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mother-earth-labs-grass-fed-whey-isolate",
      "title": "Mother Earth Labs Grass Fed Whey Isolate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Mother-Earth-Labs-Grass-Fed-Whey-Isolate.jpg?v=1788037860",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mother",
        "earth",
        "labs",
        "grass",
        "fed",
        "whey",
        "isolate",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 72,
        "manufacturing": 65,
        "safety": 78,
        "transparency": 65,
        "sustainability": 68
      },
      "price": 53.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830177452229",
      "vsf_explanation": "Mother Earth Labs Grass Fed Whey Isolate is a US-sourced grass-fed whey protein isolate. The grass-fed sourcing is a genuine sustainability and nutritional plus over commodity conventional whey — grass-fed dairy has a modestly better omega-3-to-omega-6 ratio and conjugated linoleic acid content in the milk fat, though the effect on protein-only isolate (which contains minimal fat) is negligible. The main sustainability delta is animal welfare and pasture-management, which is legitimate. The base protein (whey isolate at typical 25 g/serving) is well-supported by RCTs for post-workout muscle protein synthesis. Transparency is decent — grass-fed is specified — but per-lot COA documentation is not published at NutraBio's level, and the specific amino-acid profile per serving is not typically detailed. A defensible Standard-plus-tier pick for someone who values grass-fed sourcing and is willing to pay the premium; the strict RCT-level uplift for post-workout muscle building is minimal versus conventional isolate.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrabio-cgt-max",
      "title": "NutraBio CGT-MAX",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NutraBio-CGT-MAX.jpg?v=1788037860",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrabio",
        "cgt",
        "max",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 78,
        "manufacturing": 82,
        "safety": 85,
        "transparency": 88,
        "sustainability": 55
      },
      "price": 39.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830177550533",
      "vsf_explanation": "NutraBio CGT-Max combines three well-established sports-nutrition ingredients — creatine monohydrate, L-glutamine, and taurine — in a single powder. Creatine at 3-5 g is the highest-evidence sports supplement in the entire category; taurine at 1-2 g has RCT support for exercise-endurance and cardiovascular effects; L-glutamine has been over-marketed relative to its RCT support (immune-modulation and gut-integrity effects at higher doses in specific catabolic states, minimal muscle-building effect in normal-diet athletes). NutraBio publishes full quantitative doses, third-party tests every lot, and does not proprietary-blend the actives. The formulation delivers the creatine and taurine cleanly and adds glutamine at whatever dose the label specifies — the honest read is that the creatine is the main worker and the other two are complementary rather than additive game-changers. Solid Verified-tier product for someone wanting a bundled cell-volumizing formula rather than separate scoops; single-ingredient creatine plus optional standalone taurine is equally effective and often cheaper.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "metabolic-nutrition-hydra-eaa-hydration",
      "title": "Metabolic Nutrition Hydra EAA + Hydration",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Metabolic-Nutrition-Hydra-EAA-Hydration.jpg?v=1788037860",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "metabolic",
        "nutrition",
        "hydra",
        "eaa",
        "hydration",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 59.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830177616069",
      "vsf_explanation": "Metabolic Nutrition Hydra EAA claims 18 g of essential amino acids plus hydration electrolytes per serving. If the 18 g label figure is delivered as verified essential amino acids (not a mixed EAA plus BCAA plus non-essential blend), that is a high dose for the category — 15-20 g EAAs approaches the muscle protein synthesis response of a full whey scoop. Transparency concerns hold the score to Standard: the 18 g figure needs verification against the full amino-acid breakdown (specifically the leucine content, which must clear roughly 2.5-3 g to hit the muscle protein synthesis trigger), and Metabolic Nutrition does not publish per-lot COAs at NutraBio's level. Electrolyte doses in amino products are typically token amounts, not real hot-weather replacement. Safety at label servings is fine. A defensible Standard pick for someone who wants a large EAA scoop; the muscle protein synthesis effect ceiling is capped by the leucine content, which the marketing does not always fully specify.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-vitamin-k2-100-mcg-50-vegetable-capsules-5-oz",
      "title": "Solgar Vitamin K2 100 mcg - 50 Vegetable Capsules - 5 Oz",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/natural-vitamin-k2.png?v=1788037895",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "vitamin",
        "100",
        "mcg",
        "vegetable",
        "capsules",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 78,
        "manufacturing": 78,
        "safety": 72,
        "transparency": 68,
        "sustainability": 65
      },
      "price": 20.1,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830178074821",
      "vsf_explanation": "Solgar (founded 1947, Leonia NJ) is one of the reference US premium vitamin brands — cGMP-certified, no artificial preservatives, single-ingredient product line discipline, and a long track record in professional and retail channels. This product is 100mcg MK-7 (natto-derived) per vegetable capsule — clean, transparent formulation. Natto-derived MK-7 is naturally all-trans, the biologically active isomer. Vegan capsule. Solgar's Gold Standard Isotope-tested products (their premium sub-line) publish testing detail; their standard line does not consistently publish per-lot COAs, which is the main gap between them and Elite-tier peers. The K2 evidence base (Knapen 2015 arterial stiffness, Sato 2020 bone Gla protein, Rotterdam Study observational) supports 100-180mcg MK-7 daily for bone/CV outcomes. Verified tier for the combination of brand track record, honest formulation, and defensible dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "akavital-drcaps-acacia-gum-resveratrol-vitamin-c-d3-k2-supplement-enhanced-immune-bone-health-support",
      "title": "Akavital DRcaps: Acacia Gum, Resveratrol & Vitamin C D3 K2 Supplement - Enhanced Immune & Bone Health Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cyREVix8jyDwoE8NT7R4MzlodcjcpfH62duTGLrb.jpg?v=1788037932",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "longevity",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "akavital",
        "drcaps",
        "acacia",
        "gum",
        "resveratrol",
        "vitamin",
        "supplement",
        "enhanced",
        "immune",
        "bone",
        "health",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 48,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 42,
        "sustainability": 55
      },
      "price": 59.18,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830178566341",
      "vsf_explanation": "Akavital is a Turkish-market supplement brand. The formula stacks five things into a single capsule (acacia gum for prebiotic fiber, resveratrol for antioxidant, vitamin C, D3, K2) without publicly-disclosed per-ingredient doses. Each individual ingredient has some evidence at specific doses (resveratrol at 250-500mg for cardiometabolic markers, D3 at 1000-4000 IU, K2 at 90-180mcg MK-7, vitamin C at 200-1000mg for immune, acacia at 5-10g for prebiotic effect on gut microbiome). The problem is that 5-10g of acacia will not fit into a capsule; if the acacia is at 100-500mg per serving (capsule-realistic), it is sub-therapeutic. Multi-ingredient stacks that do not disclose per-ingredient doses risk hiding sub-therapeutic dosing of the marquee ingredient. Not on auto-fail (doses might be borderline defensible, we cannot tell), but transparency and formulation gaps push into Rejected. Turkish-market brand.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "windmill®-vitamin-k2-with-vitamin-d3-tablet-60-ea",
      "title": "Windmill® Vitamin K2 with Vitamin D3 Tablet, 60 EA",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/73526788.jpg?v=1788037948",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "windmill",
        "vitamin",
        "with",
        "vitamin",
        "tablet",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 13.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830178697413",
      "vsf_explanation": "Windmill Health Products is a legacy vitamin brand (founded 1963, NJ) — one of the older pharmacy-shelf mid-tier lines. The listing text is very sparse — it does not disclose D3 IU per tablet, K2 mcg per tablet, MK-4 vs MK-7 form, or any COA data. Windmill products are typically formulated at conservative middle-of-the-road doses and manufactured at cGMP facilities. The lack of on-listing dose disclosure is the biggest concern — a K2+D3 buyer should be able to see IU/mcg and MK-form before purchase. Standard tier based on brand track record; would move higher with per-serving dose transparency and any third-party COA publication.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-soft-capsules-k2-vitamin-180-tablets",
      "title": "Vitamin Soft Capsules K2 Vitamin 180 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/719dda6d-1911-4c27-9199-ab841589f0fc.jpg?v=1788037965",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "soft",
        "capsules",
        "vitamin",
        "180",
        "tablets",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 28,
        "manufacturing": 30,
        "safety": 48,
        "transparency": 18,
        "sustainability": 30
      },
      "price": 34.14,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830178861253",
      "vsf_explanation": "The product name is a scrambled generic string — 'Vitamin Soft Capsules K2 Vitamin 180 Tablets' — where 'Capsules' and 'Tablets' are contradicted within the same title. The description states 'Product Name: vitamin D3 k' and 'Type: other carbohydrates' — inconsistent, non-diagnostic metadata typical of machine-translated CJ Dropshipping listings. Images host on oss-cf.cjdropshipping.com. No brand, no manufacturer, no per-serving vitamin content, no MK-4 or MK-7 form, no cGMP claim, no COA. Auto-failed under misleading_naming for the incoherent title + anonymous supply chain.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "googeer-prostate-supplements-body-treatment",
      "title": "Googeer Prostate Supplements Body Treatment",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/438b724b-8a1d-4479-8a60-f5a81730d8c8.jpg?v=1788037978",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "googeer",
        "prostate",
        "supplements",
        "body",
        "treatment",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 18,
        "formulation": 22,
        "manufacturing": 28,
        "safety": 42,
        "transparency": 15,
        "sustainability": 30
      },
      "price": 19.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830178959557",
      "vsf_explanation": "'Googeer' is not a recognisable supplement brand — a Google search surfaces only the CJ Dropshipping catalog listings. The description is boilerplate ('Body Care Kit', 60ml, image links to cf.cjdropshipping.com and oss-cf.cjdropshipping.com), and the title lumps 'Prostate Supplements Body Treatment' together with no ingredient list, no serving size, no active-compound disclosure, and no manufacturer. Prostate supplements as a category (saw palmetto, beta-sitosterol, pygeum) have modest evidence bases when standardized and dose-disclosed, but this SKU discloses nothing. The name 'Body Treatment' framing on a prostate product is also ambiguous — treatment is medical language. Auto-fail on misleading_naming for the anonymous-brand + generic-title pattern.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "vitamin-d3-k2-capsules-advanced-bone-heart-support",
      "title": "Vitamin D3 & K2 Capsules | Advanced Bone & Heart Support",
      "vendor": "Halea Life: Nutrition & Skincare",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1772189287498-generated-label-image-0.jpg?v=1788037985",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "capsules",
        "advanced",
        "bone",
        "heart",
        "support",
        "halea",
        "life",
        "nutrition",
        "skincare"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 72,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 62,
        "sustainability": 58
      },
      "price": 12.96,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830179123397",
      "vsf_explanation": "Halea Life discloses this formula openly: 5,000 IU D3 as cholecalciferol + 100mcg MK-7 + 210mg calcium carbonate + supporting ingredients per the product description. That is a well-formulated D3+K2 stack for bone/CV support, with the notable inclusion of calcium (which is scientifically defensible — D3 without dietary calcium sufficiency provides less benefit for bone). MK-7 100mcg is at the effective threshold; 5,000 IU D3 is high-dose maintenance (see note above about serum monitoring). Halea Life is a small US-based nutrition/skincare brand — not a major label, no independent third-party verifications discovered, and no publicly-posted per-lot COAs. Formulation quality and label disclosure are solid; brand size, third-party verification, and evidence for the specific stack (vs. component evidence) are the gaps. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "venatura-vitamin-k2-60-capsules-vegan-gluten-free-supplement-for-bone-cardiovascular-health",
      "title": "VeNatura Vitamin K2 60 Capsules - Vegan, Gluten-Free Supplement for Bone & Cardiovascular Health",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/frB1StaCnEX61RDG8WIoKHwbp6ftOtrLkEPZIYA2.jpg?v=1788037992",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "venatura",
        "vitamin",
        "capsules",
        "vegan",
        "gluten",
        "free",
        "supplement",
        "for",
        "bone",
        "cardiovascular",
        "health",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 62
      },
      "price": 22.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830179221701",
      "vsf_explanation": "VeNatura is a Turkish-market natural-supplement brand marketed as vegan and gluten-free. This K2 product discloses 100mcg of vitamin K as MK-7 per capsule — a good, clinical-range dose within the 90-180mcg used in Knapen 2015 and Sato 2020. Single-ingredient formulation (no proprietary blend). The evidence base for MK-7 on arterial calcification and bone Gla-protein activation is real (Rotterdam Study, Knapen 2015). Turkish regulatory oversight is lighter than US/EU (as above). Vegan + gluten-free claims are useful. Held to Standard by the absence of third-party COAs, USP/NSF verification, and detailed MK-7 sourcing (natto-derived vs. synthetic, all-trans confirmed).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-vitamin-d3-k2",
      "title": "Organic Vitamin D3 + K2",
      "vendor": "veggimins.com",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/D3_K2_6adf8234-4af7-433f-b080-edbc4c3d8506.png?v=1788038006",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "vitamin",
        "veggimins",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 16,
        "formulation": 14,
        "manufacturing": 10,
        "safety": 11,
        "transparency": 8,
        "sustainability": 5
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830179320005",
      "vsf_explanation": "A liquid D3+K2 (MK-7) combination with plant-based D3 (typically lichen-derived) and nano-emulsification for improved absorption. The formulation is well-thought-through: D3 alone has strong evidence for deficiency correction, bone health, and immune modulation; MK-7 is the K2 form with the longest half-life and most consistent clinical evidence for calcium partitioning in the arterial vs bone axis. The K2-directs-calcium-to-bone mechanism is well-supported at the biochemistry level; large clinical outcome trials in healthy adults are still emerging. Nano-emulsification is a legitimate absorption strategy for a fat-soluble vitamin without the need for a fatty meal. Milligram disclosure would push this to Verified — the description does not surface IU or mcg per serving.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "multivitamin-mens",
      "title": "Multivitamin - Mens",
      "vendor": "veggimins.com",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Multi-Mens.png?v=1788038025",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "multivitamin",
        "mens",
        "veggimins",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 12,
        "manufacturing": 10,
        "safety": 10,
        "transparency": 6,
        "sustainability": 5
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830179483845",
      "vsf_explanation": "A men's liquid multivitamin featuring magnesium, D3, K2, and a full B-vitamin spectrum. The category itself — daily multivitamins — has famously mixed evidence: the 2022 USPSTF review found insufficient evidence to recommend multivitamins for prevention of cardiovascular disease or cancer in healthy adults, while the recent COSMOS-Mind trial showed a modest cognitive benefit in older adults from a daily MVI. So the product category is defensible for niche use cases (dietary gaps, older adults, restricted diets) but not as a universal 'must-take.' The specific formulation choices — D3+K2 pairing for calcium partitioning, magnesium for typical dietary shortfalls — are sensible. Milligram-per-serving amounts for each nutrient are not surfaced in the description, which under Zero-Assumption Rule caps transparency credit. Solid Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "multivitamin-women",
      "title": "Multivitamin - Women",
      "vendor": "veggimins.com",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Multi-Womens.png?v=1788038025",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "multivitamin",
        "women",
        "veggimins",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 12,
        "manufacturing": 10,
        "safety": 11,
        "transparency": 6,
        "sustainability": 5
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830179549381",
      "vsf_explanation": "A women's liquid multivitamin built around biotin, folate, D3+K2, and antioxidant vitamins C and E. The category-level evidence caveats from the men's SKU apply here too, with two nuances specific to women: (1) folate is meaningful in reproductive-age women because periconceptional folate reduces neural tube defect risk — a real, replicated, high-quality evidence base; (2) iron may be relevant for menstruating women with heavy cycles, though iron is not typically indicated for postmenopausal women. The description does not surface per-serving milligrams, which caps transparency credit. Sensible formulation choices for a mixed-age women's audience, though the label does not distinguish premenopausal from postmenopausal targets — an area where a better product would offer differentiated SKUs.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "multivitamin-adult",
      "title": "Multivitamin - Adult",
      "vendor": "veggimins.com",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Multi-Adult.png?v=1788038025",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "multivitamin",
        "adult",
        "veggimins",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 12,
        "manufacturing": 10,
        "safety": 10,
        "transparency": 6,
        "sustainability": 5
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830179516613",
      "vsf_explanation": "A gender-neutral daily multivitamin covering essential vitamins and trace minerals in a plant-based liquid format. Same evidence caveats as the men's and women's SKUs — the multivitamin category has mixed evidence for prevention of chronic disease in healthy adults, moderate evidence for cognitive support in older adults (COSMOS-Mind), and consistent evidence for correcting sub-clinical dietary gaps. This SKU does not distinguish between male and female nutrient needs, which is a formulation limitation for reproductive-age women who benefit from higher folate and menstruating women who may need iron. Per-serving milligrams are not disclosed. Mid-Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-b-complex",
      "title": "Vitamin B-Complex",
      "vendor": "veggimins.com",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BComplex_1a00d392-ff2a-4ae4-b677-06725cbc0950.png?v=1788038031",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "complex",
        "veggimins",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 13,
        "manufacturing": 10,
        "safety": 10,
        "transparency": 7,
        "sustainability": 5
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830179647685",
      "vsf_explanation": "A liquid full-spectrum B-complex targeting energy metabolism, cognition, and nervous-system function — three of the best-established use cases for B vitamins. The mechanism is uncontroversial: B1, B2, B3, B5, B6, B7, B9, and B12 are cofactors in every major energy-transfer pathway (Krebs cycle, β-oxidation, one-carbon metabolism). Where the product lands depends on which forms are used and at what doses. If methylated B9 (methylfolate) and B12 (methylcobalamin) are used and the dropper-per-serving milligram amounts are published, this is a legitimate mid-tier B-complex. The public description does not surface those specifics, so under the Zero-Assumption Rule the higher-tier credit cannot be awarded. No published per-lot COA. Lands solidly Standard — evidence-backed category, honest dose form (liquid, sublingual-friendly), but incomplete label transparency at the description level.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-vitamin-c",
      "title": "Organic Vitamin C",
      "vendor": "veggimins.com",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/C_9eb5d65c-970a-43a1-8d5b-a39ace0e0e36.png?v=1788038030",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "vitamin",
        "veggimins",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 12,
        "manufacturing": 10,
        "safety": 10,
        "transparency": 7,
        "sustainability": 5
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830179680453",
      "vsf_explanation": "Whole-food vitamin C sourced from organic acerola (Malpighia emarginata) and amla (Emblica officinalis) rather than synthetic ascorbic acid. The food-source thesis has some merit — acerola and amla naturally deliver bioflavonoids alongside ascorbic acid, and observational data on food-form vitamin C is generally favourable — but head-to-head bioavailability studies comparing food-form to synthetic ascorbic acid consistently show equivalent plasma levels at matched doses. The 4-dropperful (4 mL) serving is unusually large for a vitamin C product, and the description does not disclose milligrams of ascorbic acid per serving. Zero-Assumption Rule prevents crediting an undisclosed dose. Vitamin C's evidence base for collagen synthesis, iron absorption, and modest cold-duration reduction is real. The product is honest about being 'gentle liquid form'; it just doesn't publish enough to earn Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-lions-mane-mushroom-2oz",
      "title": "Organic Lion's Mane Mushroom, 2oz",
      "vendor": "veggimins.com",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Lions_Mane_2oz.png?v=1788038030",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "lion",
        "mane",
        "mushroom",
        "2oz",
        "veggimins",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 14,
        "manufacturing": 10,
        "safety": 11,
        "transparency": 7,
        "sustainability": 5
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830179713221",
      "vsf_explanation": "Fruiting-body-only Hericium erinaceus extract in a 2 oz liquid tincture. The fruiting-body-only qualifier is genuinely important — much of the negative press around lion's mane 'not working' comes from myceliated grain products that are largely starch with trace mushroom, whereas fruiting-body extracts contain the hericenones and erinacines that drive the NGF-related neuroplasticity mechanism. Human evidence is small but consistent: Mori 2009 (Japanese adults 50-80, mild cognitive impairment, 3 g/day for 16 weeks) and Saitsu 2019 both show cognitive improvement vs placebo. Effect sizes are modest and only durable while dosing continues. The product does not disclose extract strength (e.g. beta-glucan percentage, hericenone content, extract ratio) or milligrams-per-serving, which caps the Verified potential. Fruiting-body sourcing and honest cognitive positioning earn mid-Standard credit — this is one of the better lion's mane products a small brand could ship, provided the ingredient claim is accurate.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-vitamin-b12",
      "title": "Organic Vitamin B12",
      "vendor": "veggimins.com",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/B12_31b82eee-9762-4356-b1fb-3393e44db47d.png?v=1788038030",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "vitamin",
        "b12",
        "veggimins",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 16,
        "formulation": 14,
        "manufacturing": 10,
        "safety": 11,
        "transparency": 8,
        "sustainability": 5
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830179745989",
      "vsf_explanation": "Sublingual liquid B12 explicitly in the methylcobalamin form. That form choice is meaningful and correct for the target audience: vegans, older adults, PPI users, and metformin users are the four groups most at risk of B12 deficiency, and methylcobalamin bypasses the intrinsic-factor-dependent absorption pathway that many of them have impaired. Sublingual administration is a rational delivery route because it partially bypasses gastric absorption. Evidence for B12 replacement in true deficiency is airtight (Class I). The remaining gap in the score is transparency: the description does not surface mcg-per-mL, and even a well-formulated methylcobalamin drop should publish that alongside a per-lot COA. If the dose is at the therapeutic 500-1000 mcg range, this is a well-targeted product for its audience.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-reishi-mushroom",
      "title": "Organic Reishi Mushroom",
      "vendor": "veggimins.com",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Reishi_4fc37833-d440-430c-836d-95997932e64d.png?v=1788038031",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "reishi",
        "mushroom",
        "veggimins",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 13,
        "manufacturing": 10,
        "safety": 10,
        "transparency": 6,
        "sustainability": 5
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830179778757",
      "vsf_explanation": "Fruiting-body Ganoderma lucidum extract sold as an adaptogen/vitality tonic. Reishi has centuries of traditional use in East Asian medicine and a moderate modern evidence base — mostly small trials on immune-modulation, sleep quality, and fatigue in cancer supportive care. Cochrane reviews for reishi in cancer have concluded that evidence is suggestive of quality-of-life benefit but not definitive for oncologic outcomes. Fruiting-body sourcing is the correct signal (mycelium-on-grain reishi is largely starch). The formulation is undermined by (a) no disclosed extract ratio, (b) no beta-glucan or triterpene percentage, and (c) no per-lot COA. 'Longevity' as a marketing benefit is a stretch — no human trial has ever demonstrated lifespan extension from any supplement. Mid-Standard is fair.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-methylfolate-15mg-b12",
      "title": "Organic Methylfolate 15mg + B12",
      "vendor": "veggimins.com",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5-MTHF.png?v=1788038031",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "methylfolate",
        "15mg",
        "b12",
        "veggimins",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 16,
        "formulation": 13,
        "manufacturing": 10,
        "safety": 9,
        "transparency": 9,
        "sustainability": 5
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830179811525",
      "vsf_explanation": "A high-dose methylfolate (15 mg) plus B12 sublingual — clearly targeting the MTHFR / methylation-support audience rather than general use. Milligram disclosure earns transparency credit that most other SKUs in this brand line miss. The evidence context matters: 15 mg is a very high dose of L-5-MTHF, well above RDA (400 mcg DFE) and matching the doses used in prescription-strength L-methylfolate products such as Deplin, which are used adjunctively in refractory depression and in select MTHFR-related presentations. That is a legitimate clinical dose range, not casual daily use. Because the dose is prescription-magnitude and MTHFR is often self-diagnosed, safety scoring is trimmed — this SKU should not be used casually. Formulation and evidence for methylation support at high-dose methylfolate is genuine, and transparency is above average for this brand line.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hair-skin-nails-1",
      "title": "Hair, Skin & Nails",
      "vendor": "veggimins.com",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HairSkinNails.png?v=1788038031",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hair",
        "skin",
        "nails",
        "veggimins",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 14,
        "formulation": 12,
        "manufacturing": 10,
        "safety": 10,
        "transparency": 7,
        "sustainability": 5
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830179844293",
      "vsf_explanation": "A liquid beauty formula built around Collawise vegan collagen peptides (a proprietary GENIC-Bio Peruvian-nopal cactus polysaccharide/vegan collagen alternative), biotin, bamboo silica, hyaluronic acid, and vitamins C and E. The four-ingredient thesis is defensible: bamboo silica is a recognized silicon source relevant to keratin and connective tissue; hyaluronic acid at oral doses has meta-analysis support for skin hydration; biotin fills real deficiency-driven brittle-nail cases (though most users are not biotin-deficient); vitamin C is required for collagen synthesis. The weakness is that this SKU is a plant-based collagen substitute, not a hydrolysed marine or bovine peptide — evidence for functional collagen benefit from a vegan analogue is thinner than for animal peptides. Milligram-per-serving disclosure on Collawise, bamboo silica, and HA is not visible in the description, and no per-lot COA is published. Lands mid-Standard: honest formulation, real ingredients, but no third-party testing published and no clinical validation of the specific finished blend.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "suda-vitamin-suda-d-d3-k2-daily-support-supplement-60-capsules",
      "title": "Suda Vitamin Suda-D D3+K2 Daily Support Supplement 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/suda-vitamin-suda-d-d3k2-takviye-edici-gida-60-kapsul-16448-52-B.png?v=1788038058",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "suda",
        "vitamin",
        "suda",
        "daily",
        "support",
        "supplement",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 58,
        "manufacturing": 52,
        "safety": 60,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 11.3,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830180171973",
      "vsf_explanation": "Suda Vitamin is a Turkish supplement brand (Türkiye-market) marketed as a daily D3+K2 support. K2 disclosed at 50mcg per capsule, which is a defensible MK-7 dose (below the 90-180mcg upper efficacy range from Rotterdam-derived data but adequate for maintenance). D3 dose in the accessible listing text is not fully quantified. The evidence base for D3+K2 co-supplementation is real (see K2/vascular-calcification comment below) but modest. Turkish supplement regulation is administered by the Ministry of Agriculture and Forestry (Tarım ve Orman Bakanlığı) under Codex Alimentarius-adjacent standards; enforcement is generally lighter than US FDA cGMP inspection, and third-party verifications like USP/NSF are rare in the Turkish market. Formulation itself is defensible; held to Standard by the sparse dose disclosure and by the lighter regulatory backstop.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bronson-vitamin-k2-mk7-with-d3-supplement-non-gmo-formula-5000-iu-vitamin-d3-90-mcg-vitamin-k2-mk-7-easy-to-swallow-vitamin-d-k-complex-120-capsules",
      "title": "Bronson Vitamin K2 (MK7) with D3 Supplement Non-GMO Formula 5000 IU Vitamin D3 & 90 mcg Vitamin K2 MK-7 Easy to Swallow Vitamin D & K Complex, 120 Capsules",
      "vendor": "NutritionAdvice",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/91KP1D_HUoL._AC_SL1500_12a5c245-a639-45e5-8c86-715241670b5f.jpg?v=1788038071",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bronson",
        "vitamin",
        "mk7",
        "with",
        "supplement",
        "non",
        "gmo",
        "formula",
        "5000",
        "vitamin",
        "mcg",
        "vitamin",
        "easy",
        "swallow",
        "vitamin",
        "complex",
        "120",
        "capsules",
        "nutritionadvice"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 60,
        "transparency": 58,
        "sustainability": 60
      },
      "price": 51.74,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830180303045",
      "vsf_explanation": "Bronson is a mid-market vitamin brand (founded 1960, Utah — 'Vitamins from A to Zinc' era). Formulation is exactly what a D3+K2 buyer wants: 5,000 IU D3 (cholecalciferol) + 90mcg K2 as MK-7 (the long-half-life form validated by Sato 2020 for arterial calcification). Dose is at the top of the maintenance range (5,000 IU is the higher-dose end; some deficient users benefit, but many non-deficient adults hit the 4,000 IU IOM UL). The MK-7 90mcg is a defensible daily dose per the K2 rotterdam-study derived range. Non-GMO claim is disclosed. Held to Standard by (1) 5,000 IU D3 without a caveat about testing serum 25(OH)D — many users overshoot with this dose, (2) no third-party COA published, (3) mid-tier brand without USP verification. A perfectly reasonable, unglamorous D3+K2.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bragg-apple-cider-vinegar-capsules-vitamin-d3-zinc-750mg-of-acetic-acid-immune-weight-management-support-non-gmo-vegan-gluten-free-no-sugar-1",
      "title": "Bragg Apple Cider Vinegar Capsules - Vitamin D3 & Zinc - 750mg of Acetic Acid – Immune & Weight Management Support - Non-GMO, Vegan, Gluten Free, No Sugar (1)",
      "vendor": "NutritionAdvice",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/51m-qkgHM8L._AC_SL1000.jpg?v=1788038100",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bragg",
        "apple",
        "cider",
        "vinegar",
        "capsules",
        "vitamin",
        "zinc",
        "750mg",
        "acetic",
        "acid",
        "immune",
        "weight",
        "management",
        "support",
        "non",
        "gmo",
        "vegan",
        "gluten",
        "free",
        "sugar",
        "nutritionadvice"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 62,
        "manufacturing": 65,
        "safety": 68,
        "transparency": 58,
        "sustainability": 60
      },
      "price": 58.64,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830180663493",
      "vsf_explanation": "Bragg is a heritage brand (founded 1912) with strong name recognition in the ACV category — their liquid ACV is the reference product for the 'raw, unfiltered, with the mother' segment. The capsule format delivers 750mg acetic acid per serving, which is a defensible amount (equivalent to ~1 tablespoon of ACV) plus D3 and zinc. The evidence for ACV in weight management is weak: Kondo 2009 (Biosci Biotechnol Biochem) showed modest (~2 lb over 12 weeks) weight reduction in a Japanese population with obesity taking 15-30ml daily; the 2024 Khezri BMJ Nutr Prev Health study in adolescents was retracted for data integrity issues. 'Immune support' from 15mg zinc and 1000IU D3 is defensible for zinc-D deficient users, less so as a stand-alone claim. The capsule format loses the presumed 'mother' benefits of unfiltered liquid ACV. Standard tier for the honest formulation and disclosed doses; held back by weak evidence base for the primary marketed benefit.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "colon-sweep-digestive-support",
      "title": "Colon Sweep Digestive Support",
      "vendor": "NutritionAdvice",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_21.jpg?v=1788038106",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "colon",
        "sweep",
        "digestive",
        "support",
        "nutritionadvice"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 42,
        "manufacturing": 45,
        "safety": 52,
        "transparency": 32,
        "sustainability": 45
      },
      "price": 51.31,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830180794565",
      "vsf_explanation": "Hard Rock Health's Colon Sweep is positioned around 'cleansing processes' and 'colon health' language. The colon does not need sweeping — it moves food residue via peristalsis every ~24-72 hours and does not accumulate 'toxins' that require flushing. The 'colon cleanse' concept was medically discredited more than a century ago (post-1919 rejection of autointoxication theory) and modern gastroenterology (Mishori 2011 J Fam Pract review) finds no evidence for improvements in health from colon cleansing, with documented risks (electrolyte imbalance, dehydration, dependence for stimulant laxatives, bowel perforation). Auto-failed under unverified_medical_claim for the 'cleansing' positioning. The 'natural ingredients' phrasing without a Supplement Facts panel adds a transparency gap.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "nordic-naturals-ultimate-omega-1",
      "title": "Nordic Naturals Ultimate Omega",
      "vendor": "Nordic Naturals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/511MJ88jLrL.jpg?v=1788038105",
      "score": 78,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nordic",
        "naturals",
        "ultimate",
        "omega",
        "nordic",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 82,
        "formulation": 82,
        "manufacturing": 82,
        "safety": 78,
        "transparency": 75,
        "sustainability": 68
      },
      "price": 50.32,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830180860101",
      "vsf_explanation": "Nordic Naturals Ultimate Omega is one of the most rigorously-benchmarked fish oil products on the US market — 1,280mg total omega-3 per two-softgel serving (650mg EPA + 450mg DHA) in the triglyceride form (not ethyl ester), which absorbs 70% better in the Dyerberg 2010 head-to-head. Third-party tested by IFOS (International Fish Oil Standards) to five-star levels for CoA-verified potency, oxidation (peroxide value + p-anisidine), heavy metals (mercury, lead, cadmium, arsenic), PCBs, and dioxins — publicly posted per lot at ifosprogram.com. Sourced from wild-caught anchovies and sardines. Friend of the Sea certified. Non-GMO Project Verified. Nordic Naturals is a private brand founded 1995 (Watsonville, CA) with in-house R&D. The evidence base for high-dose EPA+DHA on cardiovascular events (REDUCE-IT 2019 icosapent ethyl, though pharmaceutical-grade) and triglycerides (JELIS, meta-analyses of omega-3 supplementation) supports the category. Held out of Elite by wild-fish sourcing (higher heavy-metal risk than algal but well-controlled) and by the 'Aids in Mood' claim in marketing that outruns the mixed antidepressant evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutricost-coleus-forskohlii",
      "title": "Nutricost Coleus Forskohlii",
      "vendor": "NutritionAdvice",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/41OmiYA6wSL.jpg?v=1788038105",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutricost",
        "coleus",
        "forskohlii",
        "nutritionadvice"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 48,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 34.44,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830180827333",
      "vsf_explanation": "Nutricost is a mid-market single-ingredient supplement brand (Utah-based, Vitasource-affiliated) with reasonable manufacturing (cGMP-registered facility, generally accurate labels). This product is 500mg Coleus forskohlii extract per serving, but the label does not disclose the forskolin standardization percentage — most clinically-studied Coleus products use 10% forskolin (Godard 2005 fat-loss study used 250mg twice daily of 10% standardized ForsLean). Without a standardization percentage disclosed, buyers cannot confirm they are getting the studied dose. Beyond the standardization gap, the evidence for Coleus forskohlii in weight loss is weak: Godard 2005 showed body composition changes in overweight men (n=30) but Henderson 2005 in overweight women (n=23) found no fat loss. Meta-analytic evidence is absent. Coleus can lower blood pressure, has anti-platelet activity, and interacts with anticoagulants — safety flag. The evidence gap plus the standardization gap keep this in Rejected, not on auto-fail but on cumulative dimension weakness.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-sunwarrior-warrior-blend-plant-based-raw-vegan-protein-powder-with-peas-hemp-chocolate-30-servings-26-4-ounce",
      "title": "Organic Sunwarrior - Warrior Blend, Plant Based, Raw Vegan Protein Powder with Peas & Hemp, Chocolate, 30 Servings, 26.4 Ounce",
      "vendor": "NutritionAdvice",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/41SAGxH2BpL.jpg?v=1788038107",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "sunwarrior",
        "warrior",
        "blend",
        "plant",
        "based",
        "raw",
        "vegan",
        "protein",
        "powder",
        "with",
        "peas",
        "hemp",
        "chocolate",
        "servings",
        "ounce",
        "nutritionadvice"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 68,
        "manufacturing": 65,
        "safety": 68,
        "transparency": 62,
        "sustainability": 70
      },
      "price": 27.91,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830181023941",
      "vsf_explanation": "Sunwarrior Warrior Blend is one of the earlier premium plant-protein formulas — pea protein + hemp seed + goji berry + coconut MCTs. Delivers ~18g protein per serving (below the 20g clinical threshold; a bit light). Certified USDA Organic and Non-GMO Project Verified. Sunwarrior is a real brand (2007, Utah) with direct manufacturer relationships. The Sunwarrior Classic Plus product (not this one) has historically scored well in Clean Label Project heavy-metal testing; Warrior Blend has mid-pack results in the same audits. The formulation includes MCTs and 'super antioxidants/goji berries' — the added ingredients dilute per-serving protein and add cost without a strong evidence base. Held to Standard by (1) sub-clinical per-serving protein (18g vs 20-40g clinical range), (2) mid-tier heavy-metal results, and (3) 'super antioxidants' marketing language that is not evidence-substantiated at this dose. Not autofail — the product is honest and label-accurate.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "optimum-nutrition-gold-standard-100-protein-powder",
      "title": "Optimum Nutrition Gold Standard 100% Protein Powder",
      "vendor": "Optimum Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/41oFZhsQQ0L.jpg?v=1788038133",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "optimum",
        "nutrition",
        "gold",
        "standard",
        "100",
        "protein",
        "powder",
        "optimum",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 74,
        "formulation": 68,
        "manufacturing": 72,
        "safety": 72,
        "transparency": 62,
        "sustainability": 60
      },
      "price": 40.24,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830181908677",
      "vsf_explanation": "Optimum Nutrition Gold Standard 100% Whey is the reference sports-nutrition whey blend — 24g protein per serving from whey isolate + whey concentrate + whey peptides, 5g+ BCAAs, informed-choice-tested for banned substances at various points, and Glanbia-owned (large ingredient supplier). The evidence base for whey protein on muscle-protein synthesis is the most-studied in sports nutrition (Devries 2015, Morton 2018 meta-analysis, Jager 2017 ISSN position stand). Glanbia's whey supply is documented cGMP, and Gold Standard has held Informed-Choice certification on many production runs (batch-dependent). Held out of Verified by: (1) the blend obscures the ratio of isolate to concentrate to peptides ('blend' formulation ambiguity), (2) sucralose and artificial flavor system in most flavors, and (3) per-lot heavy-metal COAs are not publicly posted. Category-standard for whey and a defensible pick for the strength-training user.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-vegan-protein-powder-packaging-may-vary",
      "title": "Organic Vegan Protein Powder, (Packaging May Vary)",
      "vendor": "NutritionAdvice",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/41RHnJhqzML.jpg?v=1788038137",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "vegan",
        "protein",
        "powder",
        "packaging",
        "may",
        "vary",
        "nutritionadvice"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 58,
        "sustainability": 65
      },
      "price": 40.2,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830183219397",
      "vsf_explanation": "This is Orgain Organic Plant Based Protein Powder (2.03 lb, Creamy Chocolate Fudge). Orgain is a well-established plant-protein brand founded by Dr. Andrew Abraham; the formula delivers 21g protein per serving from pea, brown rice, and chia, with a clean supporting profile (USDA Organic, Non-GMO Project Verified, gluten-free, dairy-free, soy-free, kosher, no added sugar). The evidence base for plant-blend proteins matching whey on muscle-protein synthesis when total leucine and daily protein intake are matched (Van Vliet 2015, Monteyne 2020) supports the category. Common gaps for plant proteins in this class: no per-lot Prop 65 heavy-metal COA published, no third-party certifications beyond USDA Organic, no per-batch lead/cadmium disclosure — plant proteins are the highest-heavy-metal supplement category per Clean Label Project 2020. Formulation is honest and label-accurate; score sits in solid Standard tier without pushing into Verified, because Orgain does not publish per-lot heavy-metal COAs and has been flagged in Clean Label Project reports for above-average lead levels in some batches.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrabio-100-whey-protein-isolate-50-servings",
      "title": "NutraBio 100% Whey Protein Isolate - 50 Servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NutraBio-100-Whey-Protein-Isolate-50-Servings.jpg?v=1788038238",
      "score": 78,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrabio",
        "100",
        "whey",
        "protein",
        "isolate",
        "servings",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 82,
        "formulation": 82,
        "manufacturing": 85,
        "safety": 88,
        "transparency": 90,
        "sustainability": 55
      },
      "price": 109.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830187610309",
      "vsf_explanation": "NutraBio 100% Whey Protein Isolate is the flagship isolate SKU: 25 g cross-flow-microfiltered whey isolate per serving with no whey concentrate blending, no amino spiking, and no added carbs beyond what naturally occurs in isolate. This is the most-recommended sports-nutrition category (whey isolate) delivered in one of the most transparent formulations available at any price point. The 25 g dose cleanly clears the muscle-protein-synthesis threshold, leucine content is roughly 2.7-3.0 g (adequate for even older adults with elevated leucine thresholds), and the cross-flow microfiltration process retains native protein fractions including immunoglobulins. NutraBio publishes per-lot certificates of analysis for identity, protein content, heavy metals, and microbial testing — the level of documentation that separates Verified from Standard products. Sustainability holds the score below Elite (no grass-fed sourcing statement, no carbon-footprint reporting, plastic tub), but on evidence-formulation-manufacturing-transparency-safety this is textbook top-of-category.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dragon-pharma-flavored-creatine-monohydrate",
      "title": "Dragon Pharma Flavored Creatine Monohydrate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Dragon-Pharma-Flavored-Creatine-Monohydrate_c2817eb1.jpg?v=1788038237",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dragon",
        "pharma",
        "flavored",
        "creatine",
        "monohydrate",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 92,
        "formulation": 70,
        "manufacturing": 58,
        "safety": 85,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 24.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830187413701",
      "vsf_explanation": "Dragon Pharma Flavored Creatine Monohydrate is a straightforward flavored creatine monohydrate. The active ingredient — creatine monohydrate — is the most heavily studied and most robustly supported sports supplement in the category, with over 500 RCTs and multiple meta-analyses converging on modest strength, lean-mass, and high-intensity-work capacity gains. Score is bounded by the brand's overall documentation regime rather than the ingredient itself: Dragon Pharma publishes headline claims but does not publish per-lot COAs at the level of transparent-label brands, and the flavoring/sweetener blend is under-specified in public marketing. The formulation delivers the same physiological outcome as any other 5 g/day creatine monohydrate scoop; if a Dragon Pharma flavor works for you and drives daily compliance, the product does its job. Not Verified-tier because documentation lags best-in-class, but the underlying active earns Standard cleanly.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrabio-muscle-matrix-2-lb",
      "title": "NutraBio Muscle Matrix - 2 lb",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NutraBio-Muscle-Matrix-2-lb.jpg?v=1788038244",
      "score": 74,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrabio",
        "muscle",
        "matrix",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 80,
        "manufacturing": 82,
        "safety": 85,
        "transparency": 88,
        "sustainability": 55
      },
      "price": 54.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830187839685",
      "vsf_explanation": "NutraBio Muscle Matrix is a 55/45 whey-isolate-plus-micellar-casein blend delivered at approximately 25 g protein per serving in the 2 lb tub. The fast/slow-digesting protein-blend concept is one of the better-studied sports-nutrition strategies: whey isolate spikes plasma leucine and drives acute muscle protein synthesis, while micellar casein forms a slow-releasing gastric coagulum that extends aminoacidemia for six to eight hours, which is the mechanism the label references. NutraBio publishes a full, non-proprietary Supplement Facts panel, discloses each protein source separately, and third-party tests every lot for identity, potency, heavy metals, and microbial contamination — a level of transparency that puts them in the top decile of sports-nutrition brands. The formula includes no amino spiking, no dextrose or maltodextrin filler, and the label lists ingredients honestly. The main deductions are on sustainability (no disclosed grass-fed sourcing, no carbon-footprint reporting, plastic tub packaging) and on evidence-tier boost (protein-blend RCTs are numerous but effect sizes over whey-alone are modest). A defensible Verified pick for anyone wanting a nighttime or between-meals protein rather than post-workout only.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "inspired-nutraceuticals-greens-superfood-powder",
      "title": "Inspired Nutraceuticals GREENS: Superfood Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Inspired-Nutraceuticals-GREENS-Superfood-Powder.jpg?v=1788038244",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "inspired",
        "nutraceuticals",
        "greens",
        "superfood",
        "powder",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 68,
        "manufacturing": 65,
        "safety": 75,
        "transparency": 72,
        "sustainability": 50
      },
      "price": 44.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830187905221",
      "vsf_explanation": "Inspired Nutraceuticals GREENS is one of the more-transparent entries in a category dominated by 20-ingredient proprietary blends. The brand explicitly calls out the sub-10-mg-per-ingredient problem in its own marketing and claims disclosed doses for the flagship compounds (spirulina, chlorella, spinach, kale, beetroot). That framing gets the product across the misleading_naming/proprietary_blend threshold — it does not autofail. What it cannot do is escape the fundamental evidence problem of the greens-powder category: the RCT literature for whole-food-based greens blends on hard endpoints (blood pressure, inflammatory markers, gut microbiota shifts) is thin, the effect sizes are small versus simply eating vegetables, and much of the marketing rests on ORAC-value hand-waving. Formulation is honest, per-ingredient doses appear disclosed, but ingredients like nootropic add-ons and 'gut health' additives typically appear in doses well below their clinical thresholds. A defensible Standard-tier pick for someone who genuinely will not eat vegetables and wants a fibre-and-phytonutrient hedge, but not a Verified-tier product because the underlying evidence does not clear that bar and dosing on the smaller ingredients likely falls short.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrabio-creatine-monohydrate-powder",
      "title": "NutraBio Creatine Monohydrate Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NutraBio-Creatine-Monohydrate-Powder.jpg?v=1788038244",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrabio",
        "creatine",
        "monohydrate",
        "powder",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 92,
        "formulation": 78,
        "manufacturing": 82,
        "safety": 88,
        "transparency": 82,
        "sustainability": 50
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830188069061",
      "vsf_explanation": "This is NutraBio's flavored creatine burst using Pharmapure micronized creatine monohydrate — the same active as their unflavored 300 g SKU, just delivered in a flavored powder. Creatine monohydrate is the most heavily studied and best-supported sports supplement in the entire category: over five hundred RCTs and multiple meta-analyses converge on modest but real increases in strength (roughly 5-15% over placebo across studies), lean body mass (about 1-2 kg over an 8-week loading-and-maintenance cycle), and high-intensity exercise capacity. NutraBio uses the well-established micronized monohydrate (not the marketing-driven creatine HCl or Kre-Alkalyn variants which have never been shown in controlled trials to outperform monohydrate), publishes a full transparent facts panel, and third-party tests every lot. The flavored format loses a couple of points versus the unflavored version on sustainability (sweeteners, flavoring, colorants add manufacturing steps) and on the marginal 'if you are going to add sugar-free flavor to your creatine anyway, just mix unflavored monohydrate into your drink' argument, but the underlying active is best-in-class.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "metabolic-nutrition-iso-pwdr",
      "title": "Metabolic Nutrition ISO PWDR",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Metabolic-Nutrition-ISO-PWDR.jpg?v=1788038244",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "metabolic",
        "nutrition",
        "iso",
        "pwdr",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 62,
        "manufacturing": 65,
        "safety": 72,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830188167365",
      "vsf_explanation": "Metabolic Nutrition ISO PWDR is a whey protein isolate with a digestive-enzyme coating and 'ultra-microfiltration' processing. The base protein — whey isolate — is a straightforward, well-supported source at roughly 25 g/scoop with strong RCT support for post-workout muscle-protein-synthesis effects. The transparency concerns are around the enzyme coating and the exact isolate source: Metabolic Nutrition discloses the total protein per serving but the proprietary enzyme complex is not fully broken down by ingredient dose, and there is no published third-party testing regime comparable to NutraBio's. Digestive enzymes added to whey isolate have thin RCT support — most healthy adults produce adequate proteases for a 25 g scoop, and the added marketing benefit is small. Formulation is fine, safety is fine (no red flags), but transparency and manufacturing documentation sit noticeably below best-in-class. A defensible Standard-tier isolate for someone who prefers the flavor profile, but a NutraBio or Ghost isolate offers more transparency at similar price points.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bucked-up-buck-naked-1",
      "title": "Bucked Up Buck Naked",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Bucked-Up-Buck-Naked.jpg?v=1788038244",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bucked",
        "buck",
        "naked",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 38,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 35,
        "sustainability": 48
      },
      "price": 42.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830188298437",
      "vsf_explanation": "Bucked Up Buck Naked is a thermogenic fat-loss formula positioned as 'support fat metabolism, energy levels, and body composition.' The category itself is one of the most evidence-thin in supplements: no over-the-counter thermogenic has cleared the FDA/EMA bar for a fat-loss claim, and meta-analyses of green-tea catechin, capsaicinoid, yohimbine, and caffeine stacks show effect sizes of roughly 1-2% additional weight loss over placebo across 8-12 week studies — clinically small and inconsistent. Bucked Up's fat-burner formulations across their line have historically leaned on proprietary blends with undisclosed per-ingredient doses, which puts specific ingredient dosing behind a marketing wall the label does not open. The 'support fat metabolism' language is careful FDA-safe phrasing but crosses into unverified benefit claim territory when paired with the 'lean physique' marketing. Autofailed on proprietary blend hiding dose (bulk of active matrix in undisclosed blend). Even with disclosed doses, this category rarely earns better than Standard because the underlying mechanism (small metabolic-rate bump plus mild appetite suppression) does not do what fat loss actually requires (caloric deficit and adherence).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "redcon1-pre-workout-x-deion-sanders-prime-time-punch",
      "title": "REDCON1 Pre-Workout x Deion Sanders - Prime Time Punch",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/REDCON1-Pre-Workout-x-Deion-Sanders-Prime-Time-Punch.jpg?v=1788038244",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "redcon1",
        "pre",
        "workout",
        "deion",
        "sanders",
        "prime",
        "time",
        "punch",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 70,
        "manufacturing": 65,
        "safety": 68,
        "transparency": 72,
        "sustainability": 50
      },
      "price": 41.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830188331205",
      "vsf_explanation": "REDCON1 Prime Time is a celebrity-athlete-branded pre-workout that publishes disclosed doses of its three headline actives: 200 mg caffeine, 3.2 g beta-alanine, and 6 g L-citrulline. Those three ingredients are the workhorses of any legitimate pre-workout and all three are dosed at or near their clinical thresholds. Beta-alanine at 3.2 g meets the daily loading dose established for muscle carnosine buffering and improved high-rep endurance; L-citrulline at 6 g clears the 6-8 g range shown in RCTs to raise plasma L-arginine and modestly enhance blood-flow and repetition endpoints; 200 mg caffeine is a moderate stim load suitable for most trained users. Full formulation transparency (based on disclosed doses in the marketing) pushes the product above autofail. The reason it stays Standard rather than Verified is the celebrity-endorsement price premium, uncertainty about the complete label (marketing shows three actives; the full facts panel may include additional under-dosed ingredients), and REDCON1's overall documentation not matching NutraBio-level third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrabio-clear-whey-protein-isolate",
      "title": "NutraBio Clear Whey Protein Isolate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NutraBio-Clear-Whey-Protein-Isolate.jpg?v=1788038244",
      "score": 74,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrabio",
        "clear",
        "whey",
        "protein",
        "isolate",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 78,
        "manufacturing": 82,
        "safety": 85,
        "transparency": 88,
        "sustainability": 52
      },
      "price": 42.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830188363973",
      "vsf_explanation": "NutraBio Clear Whey is a hydrolyzed whey isolate reformulated to a clear, juice-like consistency at 20 g protein per serving — the same category pioneered by Myprotein and now offered by most transparent-label brands. The clear-whey manufacturing process uses hydrolyzed isolate to reduce foaming and cloudiness; per-gram protein is slightly lower than a traditional milkshake-style isolate (20 g vs 25 g typical) because you cannot dissolve as much protein in water while maintaining the clear texture. As with the rest of the NutraBio line, this SKU carries a full disclosed facts panel and third-party testing regime. The RCT case for the underlying active — hydrolyzed whey isolate — is strong: hydrolysis pre-cleaves protein to di- and tri-peptides which absorb faster than intact isolate, though the acute-performance advantage over standard isolate is small. The clear format shines for people who dislike milkshake texture, want a hot-weather workout drink, or want a low-fat/low-carb protein in a lighter format. A defensible Verified pick.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dragon-pharma-isophorm®-whey-protein-isolate",
      "title": "Dragon Pharma ISOPHORM® - Whey Protein Isolate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Dragon-Pharma-ISOPHORM-Whey-Protein-Isolate.jpg?v=1788038244",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dragon",
        "pharma",
        "isophorm",
        "whey",
        "protein",
        "isolate",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 65,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 54.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830188527813",
      "vsf_explanation": "Dragon Pharma Isophorm is marketed as a hydrolyzed whey protein isolate delivering 25 g protein per serving. The base protein — hydrolyzed whey isolate — is a well-supported ingredient with strong RCT support for post-workout muscle protein synthesis, and 25 g/serving hits the standard muscle protein synthesis threshold cleanly. The core deductions are on transparency and manufacturing documentation: Dragon Pharma is a bodybuilder-facing brand whose overall documentation regime does not match transparent-label brands like NutraBio (no published per-lot COAs at the level of best-in-class, less rigorous third-party testing disclosure). The 'hydrolyzed' claim needs verification — much of what is marketed as hydrolyzed whey in the sports space is actually blended (partial hydrolysate plus intact isolate); without full label disclosure of the hydrolysis percentage and molecular weight profile, the claim is directionally accurate but under-specified. Safety is fine at label doses. A defensible Standard-tier pick if you prefer the flavor and price; better-documented isolates exist at similar price points.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "inspired-nutraceuticals-amino-vegan-eaas",
      "title": "Inspired Nutraceuticals AMINO: Vegan EAAs",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Inspired-Nutraceuticals-AMINO-Vegan-EAAs_8228354b.jpg?v=1788038245",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "inspired",
        "nutraceuticals",
        "amino",
        "vegan",
        "eaas",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 72,
        "manufacturing": 65,
        "safety": 72,
        "transparency": 68,
        "sustainability": 60
      },
      "price": 37.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830188691653",
      "vsf_explanation": "Inspired Nutraceuticals AMINO is a vegan essential amino acid (EAA) formula featuring all nine EAAs plus electrolytes and AstraGin. The category is legitimate — EAAs at 5-15 g contain the same anabolic-signaling amino acids as a whey scoop with less caloric load — but EAA supplementation is genuinely useful in a narrow window: for people who cannot tolerate dairy, who want intra-workout aminos without disrupting a fast, or who want to sip aminos during long training sessions. For anyone eating adequate daily protein from food or whey, EAAs are largely redundant. Inspired is one of the more disclosed-dose brands in this space, and the vegan positioning is honest (whey isolate would be non-vegan). The AstraGin add-in is under-supported by RCTs — the branded ingredient markets absorption enhancement but human evidence for meaningful uplift is thin. Formulation is fine, transparency is above average for the category. A defensible Standard-tier pick with real use cases; not category-leading because EAA products in general struggle to differentiate on RCT evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-d3-k2-hawthorn-fruit-supplement-liquid-drops",
      "title": "Vitamin D3 K2 Hawthorn Fruit Supplement Liquid Drops",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d54c504c-1f80-4128-8850-d97137b70a12_fine.jpg?v=1788038277",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "hawthorn",
        "fruit",
        "supplement",
        "liquid",
        "drops",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 32,
        "manufacturing": 30,
        "safety": 48,
        "transparency": 20,
        "sustainability": 32
      },
      "price": 20.16,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830189281477",
      "vsf_explanation": "The title lists three legitimate ingredients (Vitamin D3, Vitamin K2, hawthorn fruit) but the listing does not name a brand, and the images are hosted on CJ Dropshipping's CDN — the anonymous white-label supply chain used by cross-border dropshippers. The bodyHtml discloses only a 60ml volume and a 2-year shelf life, no IU/mcg per drop, no MK-7 vs MK-4 form, no hawthorn standardization, and no manufacturer. Hawthorn (Crataegus) has some evidence for mild-to-moderate heart failure symptoms (Pittler 2008 Cochrane) but requires standardization to extract ratio (e.g. WS 1442) and per-dose measurement to be meaningful; a liquid drop with no per-drop dose disclosure cannot be scored positively. Not autofailing on unverified medical claim (no explicit medical claim in the sparse listing), but transparency and formulation gaps put it firmly in Rejected.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "body-supplements-supplement-energy",
      "title": "Body Supplements Supplement Energy",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0901c299-104a-4e0d-b627-118b4f11a0c5.jpg?v=1788038284",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "body",
        "supplements",
        "supplement",
        "energy",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 20,
        "manufacturing": 28,
        "safety": 42,
        "transparency": 12,
        "sustainability": 30
      },
      "price": 16.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830189379781",
      "vsf_explanation": "The title 'Body Supplements Supplement Energy' does not name a brand, an active ingredient, a dose, a delivery format, or a mechanism. The description talks about a 30ml bottle, 24-month shelf life, and links to CJ dropshipping product images — a hallmark of anonymous white-label AliExpress/CJdropshipping inventory being resold without any manufacturer accountability. There is no Supplement Facts panel, no COA, no listed manufacturer, no cGMP claim, and no country of origin. A supplement that will not tell the buyer what is inside the bottle cannot be evaluated for safety or efficacy, and its title functions as a generic keyword string rather than an identifying product name. Auto-failed under misleading_naming — the product name conveys no product-identifying information.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "solgar-calcium-citrate-with-vitamin-d3-240-tablets",
      "title": "Solgar Calcium Citrate with Vitamin D3 240 Tablets",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33984025516-1.png?v=1788038487",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "calcium",
        "citrate",
        "with",
        "vitamin",
        "240",
        "tablets",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 70,
        "manufacturing": 75,
        "safety": 62,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830191182021",
      "vsf_explanation": "Solgar Calcium Citrate with Vitamin D3 pairs calcium citrate (the better-absorbed calcium salt, particularly for people with low stomach acid, elderly adults, and PPI users) with vitamin D3 (cholecalciferol, the more effective vitamin D form for raising 25-OH-D levels vs. D2). The combination is evidence-aligned: vitamin D is required for calcium absorption in the intestine, and the paired product simplifies coverage of both micronutrients. Where the product is genuinely useful: postmenopausal women, older adults at fracture risk, people on chronic PPI or H2-blocker therapy (which impairs calcium carbonate but not calcium citrate absorption), people with low dietary calcium intake (<600-800 mg/day from food), and people with limited sun exposure. Where the safety score is capped: recent meta-analyses of calcium supplementation without vitamin D have raised concerns about cardiovascular event risk (Bolland 2010, though disputed), and calcium supplementation should ideally be food-first and only added to reach the ~1000-1200 mg/day target rather than layered on top of an already-adequate dietary intake. Solgar manufacturing is solid (GMP-certified, kosher-parve, decades-established); no per-lot third-party COAs routinely published. Solid Standard-tier bone-health supplement for the populations who benefit; oversupplementation is not benign.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-methylcobalamin-vitamin-b12-1000mcg-30-nuggets",
      "title": "Solgar Methylcobalamin (Vitamin B12) 1000mcg 30 Nuggets",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33984019508.png?v=1788038494",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "methylcobalamin",
        "vitamin",
        "b12",
        "1000mcg",
        "nuggets",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 72,
        "manufacturing": 75,
        "safety": 72,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 7.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830191313093",
      "vsf_explanation": "Solgar Methylcobalamin 1000 mcg is a well-executed single-ingredient B12 supplement in the active methylcobalamin form (as opposed to cyanocobalamin, the synthetic form that requires enzymatic conversion). The 1000 mcg dose per nugget is well above the RDA (2.4 mcg/day) but appropriate for the supplement form — B12 absorption via intrinsic factor is saturable at low doses, so high oral doses rely on passive diffusion (~1-2% absorption of the total dose), and 1000 mcg reliably corrects most non-pernicious-anemia deficiency states. Sublingual nugget formulation adds modest additional absorption via oral mucosa, though the head-to-head evidence versus swallowed tablets at similar doses is mixed. Methylcobalamin is particularly reasonable for people with MTHFR variants or age-related reduced methylation capacity, though the 'active form' framing is often overstated in marketing. Solgar's manufacturing standards are strong (GMP-certified, kosher-parve certification, decades-established brand). Transparency capped by lack of routinely published per-lot third-party COAs. Solid Standard-tier B12 supplement — genuinely useful for the populations who need B12 supplementation (older adults, vegans/vegetarians, metformin or PPI users, malabsorption states, pernicious anemia when injectable is not required).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "optimum-essential-amino-energy-270-gr",
      "title": "Optimum Essential Amino Energy 270 Gr",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/optimum_essential_amino_energy_270_gr_57127.jpg?v=1788041062",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "optimum",
        "essential",
        "amino",
        "energy",
        "270",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 65,
        "manufacturing": 72,
        "safety": 70,
        "transparency": 60,
        "sustainability": 48
      },
      "price": 42.05,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830226800837",
      "vsf_explanation": "Optimum Nutrition Essential Amino Energy is a well-established sports-nutrition product from Optimum Nutrition (Glanbia-owned, one of the largest and most-regulated sports-supplement manufacturers globally) combining ~5 g essential amino acids (including 2.5 g BCAAs) with 100 mg of caffeine per two-scoop serving. The core ingredients — EAAs plus low-dose caffeine — are both individually well-evidenced: EAAs at 3-6 g stimulate muscle protein synthesis effectively (Wolfe 2017), and 100 mg caffeine reliably improves training focus, perceived exertion, and endurance in the Grgic 2020 meta-analysis without the sleep-disruption risk of higher doses. Optimum's manufacturing is cGMP-certified with NSF-audit oversight and vitamin C fortification adds a minor cofactor benefit. Standard tier — legitimate manufacturer, honest label, evidence-based ingredients at reasonable doses. Held below Verified by transparency gaps (per-EAA milligrams shown as a group total in many editions), the use of artificial sweeteners in some flavors, and the fact that EAAs and low-dose caffeine can be sourced more cheaply and cleanly as separate products.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nature-made-super-b-energy-complex-softgels-60ct",
      "title": "Nature Made Super B Energy Complex Softgels - 60ct",
      "vendor": "Nature Made",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/50458566.jpg?v=1788041093",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "made",
        "super",
        "energy",
        "complex",
        "softgels",
        "60ct",
        "nature",
        "made"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 78,
        "safety": 68,
        "transparency": 60,
        "sustainability": 52
      },
      "price": 8.85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830227062981",
      "vsf_explanation": "Nature Made Super B Energy Complex is a standard B-vitamin softgel from Pharmavite's flagship consumer supplement brand — the mass-retail US brand most consistently associated with USP verification, which independently confirms label-vs-actual dose accuracy, purity limits, and dissolution. The B-complex composition typically covers the eight B vitamins (thiamine, riboflavin, niacin, pantothenic acid, B6, biotin, folate, B12) plus vitamin C. B vitamins are legitimate essential micronutrients required for energy metabolism (mitochondrial substrate metabolism, one-carbon transfer, neurotransmitter synthesis) — the 'energy metabolism support' language matches the actual biochemistry rather than being an unverified performance claim. What caps the score: for adults without documented B-vitamin deficiency (which is relatively uncommon in the US outside of specific populations — vegans/vegetarians for B12, older adults for B12, alcohol-use-disorder for thiamine and folate, pregnancy for folate), B-complex supplementation does not produce a subjective energy boost — the marketing implication that B vitamins provide caffeine-like alertness is misleading. Manufacturing and third-party quality verification are the strongest dimensions; transparency is capped by aggregate USP verification rather than per-lot public COAs. Standard-tier mass-retail B-complex — appropriate for documented deficiency or targeted populations, oversold for the general population.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "irwin-naturals-stored-fat-belly-burner-targeted-weight-management-liquid-soft-gels",
      "title": "Irwin Naturals Stored-Fat Belly Burner – Targeted Weight Management (Liquid Soft-Gels)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/100014449_6b01c11e-c342-4f73-a026-50952f66e08b.jpg?v=1788041129",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "irwin",
        "naturals",
        "stored",
        "fat",
        "belly",
        "burner",
        "targeted",
        "weight",
        "management",
        "liquid",
        "soft",
        "gels",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 52,
        "manufacturing": 58,
        "safety": 52,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 18.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830227325125",
      "vsf_explanation": "Irwin Naturals is a decades-established US mass-retail supplement brand known for its liquid soft-gel delivery format. The 'Stored-Fat Belly Burner' SKU centers on Sinetrol, a branded citrus polyphenol extract (Fytexia, France) that does have a handful of company-funded small RCTs (Dallas 2008, Dallas 2014) showing modest reductions in abdominal fat and waist circumference over 12 weeks at 900 mg/day. What sinks the score: the 'targeted' spot-fat-reduction framing ('metabolizes stored fat in stubborn areas such as the belly, waist and hips') is a misleading naming pattern — human physiology does not permit selective site-specific fat mobilization from a supplement, and the underlying Sinetrol trials showed general fat-mass reduction rather than site-selective 'belly' targeting. The proprietary Irwin Naturals liquid soft-gel matrix includes multiple additional ingredients (typically caffeine, green tea, guarana, other thermogenics) that are not fully disclosed per constituent milligram at the title level, moving the formulation toward proprietary-blend structure. Weight-management claims combined with 'targeted' spot-reduction framing and incomplete per-ingredient disclosure place this in low-Rejected tier despite Sinetrol having real underlying evidence. Not autofailed outright because Sinetrol's evidence base is real and Irwin Naturals is an established GMP-compliant manufacturer, but the 'targeted belly fat' marketing crosses the misleading-naming boundary.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "3-pack-goli-apple-cider-vinegar-gummy-vitamins",
      "title": "3-Pack: Goli Apple Cider Vinegar Gummy Vitamins",
      "vendor": "EasyOptionXY",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3-pack-goli-apple-cider-vinegar-gummy-vitamins-wellness-dailysale-187055.jpg?v=1788041136",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pack",
        "goli",
        "apple",
        "cider",
        "vinegar",
        "gummy",
        "vitamins",
        "easyoptionxy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 45,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 115.18,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830227423429",
      "vsf_explanation": "Goli is one of the largest and most-recognized DTC ACV gummy brands, delivering 500 mg ACV per gummy (typical serving 2 gummies = 1,000 mg) with added B9 and B12 in a vegan, non-GMO, gluten-free format. Goli's manufacturing infrastructure is real and USA-based with cGMP certification, and the brand publishes more transparency than most ACV-gummy competitors. But the SKU faces the same structural problem as every other ACV gummy: pectin matrix buffers the acetic acid, gummy format bypasses the pre-meal timing window that positive glycemic trials (Johnston 2004, White 2007) required, and 500-1,000 mg per serving is 3-12x below the studied liquid-equivalent trial dose (~3,000-6,000 mg dehydrated). Rejected on evidence + delivery format, held near the top of Rejected by legitimate brand infrastructure, USDA Organic and Non-GMO certifications, and vegan gelatin-free formulation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamized-beetroot-gummies-nitric-oxide-supplement",
      "title": "VITAMIZED Beetroot Gummies - Nitric Oxide Supplement",
      "vendor": "The VITAMIZED Shop",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/VitamizedUrinary_Gummies_ae8c71d0-a9e8-4bbd-b12a-6a291b6dc616.png?v=1788041157",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamized",
        "beetroot",
        "gummies",
        "nitric",
        "oxide",
        "supplement",
        "the",
        "vitamized",
        "shop"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 45,
        "manufacturing": 52,
        "safety": 62,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 23.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830227620037",
      "vsf_explanation": "VITAMIZED Beetroot Gummies deliver beetroot powder with added grape seed extract and B12 in a pomegranate-flavored chewable format, positioned as a nitric-oxide supplement for heart health, circulation, and blood pressure. The core mechanism problem: beetroot's cardiovascular effects are driven by dietary nitrate content, which is converted to nitrite by oral bacteria and then to nitric oxide systemically. The blood-pressure and endurance evidence (Kapil 2015, Wylie 2013) used 300-800 mg dietary nitrate — roughly equivalent to 3-6 oz of concentrated beetroot juice or 5-8 g of high-nitrate beetroot powder per serving. Gummy formats deliver at most a few hundred mg of beetroot powder, which contains only trace nitrate — 10-50 mg, well below the studied threshold. Rejected on sub-therapeutic dose in this format; the underlying category (beetroot for NO) has real evidence but not achievable in a small gummy.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "confidence",
      "title": "CONFIDENCE",
      "vendor": "CVMK GLOBAL",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/kjI5aIPoGsCCmtUPlYaT-Ag_0_gps_generated.png?v=1788041485",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "confidence",
        "cvmk",
        "global"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 38,
        "manufacturing": 42,
        "safety": 55,
        "transparency": 28,
        "sustainability": 40
      },
      "price": 100,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830232797381",
      "vsf_explanation": "'CONFIDENCE' is a proprietary-name daily supplement marketed for 'healthy weight-management goals when combined with balanced diet and regular exercise,' healthy metabolism, and everyday energy. Three failures. (1) The product name is a generic mood/lifestyle descriptor rather than a distinct brand identity in the SKU title. (2) The description uses structure/function safe-harbor language layered onto weight-management positioning, but does not disclose per-ingredient milligrams — a proprietary-blend concern for whatever the formula contains. (3) The weight-management supplement category as a whole has a very weak evidence base — Cochrane and Cochrane-adjacent reviews of the most studied ingredients (garcinia, green coffee, African mango) have concluded that clinically relevant weight-loss effects cannot be confirmed. Rejected on transparency + naming + evidence gaps for the category.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fight-betes",
      "title": "FIGHT BETES",
      "vendor": "CVMK GLOBAL",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fight-betes-334973.jpg?v=1788041490",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fight",
        "betes",
        "cvmk",
        "global"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 18,
        "formulation": 30,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 25,
        "sustainability": 38
      },
      "price": 50,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830232928453",
      "vsf_explanation": "'FIGHT BETES' is sold under a proprietary product name that is a phonetic play on 'diabetes' — a positioning Vyvata treats as an unverified disease claim, as it implies the product treats or prevents diabetes. FDA and FTC actively police supplement products marketed with disease-adjacent names, and DSHEA explicitly prohibits structure/function claims that name specific diseases. The product-page description leans on structure/function safe-harbor language ('supports healthy blood sugar already within normal range'), but the product name itself does the disease-claim work that the description tries to disclaim. Additional failures: no per-ingredient milligrams disclosed for whatever's in the formula; no extractable brand identity beyond the SKU name; no visible per-lot COA. Rejected — the naming alone would trip both unverified_disease_claim and misleading_naming.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "no-worries",
      "title": "No Worries",
      "vendor": "CVMK GLOBAL",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/no-worries-210933.jpg?v=1788041490",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "worries",
        "cvmk",
        "global"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 35,
        "manufacturing": 42,
        "safety": 50,
        "transparency": 25,
        "sustainability": 38
      },
      "price": 40,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830232961221",
      "vsf_explanation": "'No Worries' is a proprietary-name supplement marketed for daily stress management, anxiety reduction, and 'improved wellbeing.' Three failures combine to push this into deep Rejected. (1) The product-page copy explicitly names 'anxiety' as a target ('formulated to reduce anxiety') — anxiety is a diagnosed medical condition and marketing a non-prescription supplement to treat it is an unverified_disease_claim under FDA rules. (2) No per-ingredient milligram disclosure in the reviewed description — a proprietary-blend concern that hides whether any ingredient reaches a studied dose. (3) The product name is a generic mood descriptor rather than a distinct brand identity, and no extractable brand appears in the title. Rejected primarily on the disease-claim + naming failures; even the most credible stress supplements (ashwagandha KSM-66, l-theanine, magnesium glycinate) do not claim to 'reduce anxiety' in FDA-compliant marketing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "superpower",
      "title": "SuperPower",
      "vendor": "CVMK GLOBAL",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SuperPower_1.png?v=1788041491",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "superpower",
        "cvmk",
        "global"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 80,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830232993989",
      "vsf_explanation": "'SuperPower' is a proprietary-name pre-workout marketed for 'clean energy, skin-splitting pumps, sharp focus, and mind-muscle connection' — the standard pre-workout marketing script. Pre-workout formulas can be legitimate when they disclose per-ingredient milligrams (caffeine 150-300 mg, beta-alanine 3.2 g, citrulline malate 6-8 g, creatine 3-5 g are evidence-based components at those doses). The reviewed description reveals no per-ingredient milligrams — a textbook proprietary-blend failure. Also concerning: the product name is a generic superlative rather than a distinct brand identity within the SKU title. Rejected on transparency + proprietary blend, held above 40 because pre-workouts are a legitimate supplement category with real evidence-based ingredients that a reformulation could unlock.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "batterup",
      "title": "BatterUp",
      "vendor": "CVMK GLOBAL",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/batterup-886295.png?v=1788041492",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "batterup",
        "cvmk",
        "global"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 32,
        "manufacturing": 42,
        "safety": 45,
        "transparency": 25,
        "sustainability": 38
      },
      "price": 45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830233059525",
      "vsf_explanation": "'BatterUp' is a proprietary-name supplement marketed for 'bedroom performance' and male sexual function ('helping you hit those home-runs,' 'give your partner the pleasure they deserve') — an unverified disease/function claim domain that is heavily FDA-policed. Male-enhancement supplements are the single most-tainted category in the US supplement market: the FDA's Tainted Sexual Enhancement Products database lists 500+ SKUs that have been found to contain undeclared PDE-5 inhibitors (sildenafil, tadalafil analogues) or other prescription drugs. Without third-party sport-drug testing and per-ingredient milligram disclosure, this category cannot be evaluated on stated ingredients alone. Rejected — the marketed claim is a disease-adjacent function claim (erectile dysfunction is a diagnosed condition), the proprietary name does not tie to a verifiable brand, and no per-ingredient disclosure or third-party testing appears on the SKU.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "warrior-thirst",
      "title": "Warrior Thirst",
      "vendor": "CVMK GLOBAL",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/gps_generated_104a229f-3974-4ef2-9006-e360e75d57f7.png?v=1788041491",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "warrior",
        "thirst",
        "cvmk",
        "global"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 42,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 32,
        "sustainability": 40
      },
      "price": 65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830233092293",
      "vsf_explanation": "'Warrior Thirst' is a proprietary-name low-stimulant pre-workout marketed for 'clean, sustained energy and serious muscle pump.' Same pattern as the SuperPower SKU above: the pre-workout category has legitimate evidence-based ingredients (caffeine, beta-alanine, citrulline malate, creatine) at specific doses, but the reviewed description does not disclose per-ingredient milligrams, which fails proprietary-blend disclosure standards. 'Low stimulant' is a real formulation choice with a market (users sensitive to caffeine, evening trainers) but without the per-ingredient milligram sheet the caffeine content and other actives cannot be verified. Rejected on transparency + proprietary blend, held above 40 by legitimate category and honest 'low stimulant' positioning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "saucy",
      "title": "Saucy",
      "vendor": "CVMK GLOBAL",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/saucy-397593.jpg?v=1788041490",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "saucy",
        "cvmk",
        "global"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 48,
        "manufacturing": 50,
        "safety": 65,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 50,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830233026757",
      "vsf_explanation": "'Saucy' is a proprietary-name branched-chain amino acid (BCAA) product marketed for recovery, hydration, and 'pushing through' fatigue. BCAAs are a legitimate supplement category — the effective ratio is 2:1:1 (leucine:isoleucine:valine), with total-serving doses of 5-10 g typical, and leucine as the primary anabolic driver at 2.5-3 g per serving. But two problems drop this into Rejected. (1) The reviewed description does not disclose per-BCAA milligrams — a proprietary-blend concern where the leucine share cannot be verified. (2) Recent evidence (Wolfe 2017, Trommelen 2016) shows that in well-fed omnivores consuming adequate protein (0.8-1.6 g/kg/day), added BCAAs offer minimal ergogenic or muscle-protein-synthesis benefit above what dietary protein already provides — the category is losing its evidence base for general trainees. Rejected on transparency + evidence for the category niche, held near the top of Rejected by legitimate category and BCAAs' clean safety profile.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "super-thick",
      "title": "Super Thick",
      "vendor": "CVMK GLOBAL",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Super_Super_Thick.png?v=1788041491",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "super",
        "thick",
        "cvmk",
        "global"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 68,
        "transparency": 40,
        "sustainability": 42
      },
      "price": 60,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830233125061",
      "vsf_explanation": "'Super Thick' is a proprietary-name creatine product marketed to lifters and athletes. Creatine is the single most-studied and best-evidenced sports supplement — over 500 human trials, ISSN position stand endorses 3-5 g/day of creatine monohydrate for strength, power, hypertrophy, and cognitive endpoints (Kreider 2017, 2022). One structural problem holds this below the Standard band. The reviewed description does not disclose the specific creatine form (monohydrate is the gold standard; malate, HCl, buffered, and ethyl ester have no clinical advantage) or per-serving milligrams. Without those disclosures, users cannot verify they're getting the evidence-based form and dose. If reformulated to explicitly label 'creatine monohydrate, 5 g per serving' the SKU would move directly to Standard or higher. Rejected on transparency, held just below Standard by the excellent underlying category evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "truhealth™",
      "title": "TruHealth™",
      "vendor": "TruDiagnostic™",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Main_Media_908e2b43-b85d-4ce9-9009-dbce6bc84e10.jpg?v=1788041547",
      "score": 74,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "truhealth",
        "trudiagnostic"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "genetic_dna"
      ],
      "vsf_dimensions": {
        "analytical_validity": 78,
        "clinical_utility": 72,
        "transparency": 78,
        "results_delivery": 76,
        "privacy_data": 72,
        "value": 68
      },
      "price": 499,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830233551045",
      "vsf_explanation": "TruHealth is TruDiagnostic's epigenetic wellness-panel test — same Illumina Infinium MethylationEPIC BeadChip methodology as the flagship TruAge, processed at TruDiagnostic's CLIA-certified lab in Lexington, Kentucky, but reporting 105+ methylation-derived biomarkers across 19 biological systems (immune, metabolic, inflammatory, cardiovascular, neurocognitive, hepatic, renal, and more) rather than pure biological-age clocks. The underlying methodology is legitimate and well-published — DNA methylation at hundreds of thousands of CpG sites is a validated biomarker layer, and the systems-level panel builds on peer-reviewed epigenetic-clock literature (Horvath, Levine PhenoAge, Lu GrimAge, Belsky DunedinPACE). Analytical validity is strong (typical CV <3% for the underlying clocks); clinical utility is moderate because system-level methylation scores are population-validated but individual longitudinal interpretation over short windows is noisier than the marketing implies. Transparency is a genuine strength — TruDiagnostic co-authors much of the underlying peer-reviewed literature and publishes methodology openly. Value is the weakest dimension at $300-500 per test. Verified-tier epigenetic wellness test; not a substitute for clinical labs (LDL, HbA1c, TSH, etc.) that a primary-care physician orders for actual disease screening.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "truage™-truhealth™-combination-kit",
      "title": "TruAge™ + TruHealth™ Combination Kit",
      "vendor": "TruDiagnostic™",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MainMedia.png?v=1788041547",
      "score": 77,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "truage",
        "truhealth",
        "combination",
        "kit",
        "trudiagnostic"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "genetic_dna"
      ],
      "vsf_dimensions": {
        "analytical_validity": 80,
        "clinical_utility": 75,
        "transparency": 80,
        "results_delivery": 78,
        "privacy_data": 72,
        "value": 74
      },
      "price": 849,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830233583813",
      "vsf_explanation": "TruDiagnostic's combined kit runs both flagship epigenetic panels — the TruAge biological-age clocks (OMICmAge, DunedinPACE, GrimAge-adjacent) and the TruHealth 19-system wellness biomarker panel — from a single saliva sample processed at TruDiagnostic's CLIA-certified Kentucky lab on Illumina Infinium MethylationEPIC BeadChip. 180+ epigenetic biomarkers reported in total. Combining both tests from one sample is meaningfully better value than purchasing them separately, which lifts the value dimension into the mid-70s (vs. 68 for TruHealth-alone). The underlying methodology is the best-published commercial biological-age testing on the market — Horvath 2013, Levine PhenoAge 2018, Lu GrimAge 2019, Belsky DunedinPACE 2022 — with TruDiagnostic scientists co-authoring several extensions. Analytical validity is strong (CV <3% for the core clocks). Clinical utility remains moderate rather than strong because individual short-term change interpretation is noisier than the marketing implies and no clock has FDA clearance as a disease-diagnostic device. Solid Verified-tier bundled diagnostic — the most defensible commercial offering in the direct-to-consumer epigenetic-age space, particularly for users planning longitudinal tracking of DunedinPACE.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nettle-leaf-tincture",
      "title": "Nettle Leaf Tincture",
      "vendor": "Evergreen Apothecary",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/nettle5.jpg?v=1788041697",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nettle",
        "leaf",
        "tincture",
        "evergreen",
        "apothecary"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 24,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830235189445",
      "vsf_explanation": "Evergreen Apothecary Nettle Leaf Tincture is single-ingredient Urtica dioica leaf. Nettle leaf has traditional-use precedent for seasonal allergies (rhinitis), joint discomfort, mineral tonic use, and general nutritive tonic. Modern evidence: Mittman 1990 (Planta Med) tested freeze-dried nettle leaf at 300 mg for allergic rhinitis in a small RCT with modest symptom improvement; Roschek 2009 documented in vitro histamine-receptor and mast-cell degranulation activity. Nettle leaf is nutritionally rich in magnesium, iron, calcium, potassium, silica, chlorophyll, and flavonoids — but the tincture format concentrates lipophilic/alcohol-soluble compounds and delivers less of the mineral fraction than food-form nettle tea or capsules. Considered safe in pregnancy in traditional herbal practice at food-form doses. Single-ingredient honest formulation, plausible traditional-use rationale, strong safety profile. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "open-pathways-tincture",
      "title": "Open Pathways, Tincture",
      "vendor": "Evergreen Apothecary",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/open1_0c9f497c-e875-4946-920b-5a045212084c.jpg?v=1788041698",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "open",
        "pathways",
        "tincture",
        "evergreen",
        "apothecary"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 45,
        "manufacturing": 52,
        "safety": 55,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 30,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830235156677",
      "vsf_explanation": "Evergreen Apothecary Open Pathways Tincture is positioned as a prerequisite to detox and parasite-cleanse protocols by 'opening the body's elimination pathways' (liver, skin, bowels, lymphatic, kidneys). The 'blocked pathways' framing and the entire elimination-pathway-priming construct are unverified medical claims. Healthy liver, kidneys, gut, skin, and lymphatic function are physiologically active continuously in every healthy person; they do not require priming, opening, or supplemental preparation before further intervention. Cochrane and NIH NCCIH reviews of commercial detox products have found no evidence supporting these constructs. The pathways framing is closely associated with wellness-marketing patterns that sell sequential supplement protocols (open pathways → parasite cleanse → detox → gut restore) that scale bill totals without clinical basis. The individual botanicals in the tincture (not fully specified in the visible description) may be safe herbs; the medical positioning is the problem. Rejected under unverified_medical_claim.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pcosync",
      "title": "PCOSync",
      "vendor": "Evergreen Apothecary",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/pcos2.jpg?v=1788041697",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pcosync",
        "evergreen",
        "apothecary"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 42,
        "manufacturing": 50,
        "safety": 48,
        "transparency": 40,
        "sustainability": 52
      },
      "price": 28,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830235287749",
      "vsf_explanation": "Evergreen Apothecary PCOSync Tincture is explicitly positioned for polycystic ovary syndrome (PCOS) and PCOS-related symptoms (menstrual regularity, hormonal balance). PCOS is a defined medical diagnosis (Rotterdam criteria: oligo/anovulation, hyperandrogenism, polycystic ovarian morphology on ultrasound — 2 of 3) with real complications (metabolic, cardiovascular, endometrial cancer risk). Marketing a herbal tincture specifically for a named medical condition triggers unverified_disease_claim under FTC and Vyvata rubric. The evidence-based interventions for PCOS include: myo-inositol + D-chiro-inositol at 4 g myo + 100 mg DCI (Nordio 2019, Facchinetti 2015) for insulin sensitivity and ovulation; metformin for insulin sensitivity; spironolactone for androgen excess; combined oral contraceptives for cycle regularity; and lifestyle intervention (weight management improves outcomes at 5-10% loss per Legro 2013). Botanical tinctures with unspecified ingredients do not have RCT evidence approaching these interventions. Rejected under unverified_disease_claim.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "junior-parasite-tincture",
      "title": "Junior Parasite Tincture",
      "vendor": "Evergreen Apothecary",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/648A7607.jpg?v=1788041697",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "junior",
        "parasite",
        "tincture",
        "evergreen",
        "apothecary"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 40,
        "manufacturing": 48,
        "safety": 25,
        "transparency": 40,
        "sustainability": 52
      },
      "price": 30,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830235222213",
      "vsf_explanation": "Evergreen Apothecary Junior Parasite Tincture is a pediatric-formulated parasite cleanse for children ages 2+. The parasite-cleanse category has the same unverified_medical_claim problem as the adult version (see 10-Day Parasite Cleanse scoring) — parasitic infection in the general US pediatric population is uncommon, is diagnosed via stool testing, and is treated with prescription antiparasitic pharmaceuticals with documented efficacy. Applying the concept to children compounds the concern because: (1) pediatric supplement safety data is far thinner than adult data for most herbs; (2) children have narrower therapeutic windows and higher relative dosing sensitivity; (3) common parasite-cleanse herbs (wormwood/Artemisia absinthium contains thujone; black walnut hull contains juglone; clove is generally safe) have inadequate pediatric safety documentation; (4) the diagnostic frame (fussy child, poor appetite, sleep issues, tummy pain) overlaps with dozens of common childhood conditions from viral infection to iron-deficiency anemia to normal developmental variation. Rejected under unverified_medical_claim + safety_concern for pediatric use of unstandardized botanicals.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nervous-system-reset-tincture",
      "title": "Nervous System Reset Tincture",
      "vendor": "Evergreen Apothecary",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/nervous1.jpg?v=1788041697",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nervous",
        "system",
        "reset",
        "tincture",
        "evergreen",
        "apothecary"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 26,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830235353285",
      "vsf_explanation": "Evergreen Apothecary Nervous System Reset Tincture is positioned as nervine herbal support for chronic stress, sympathetic-nervous-system overactivation (fight-or-flight), and dysregulation. Nervine herbs — traditional Western herbalism category including passionflower, skullcap, oats/oat straw, chamomile, hops, lemon balm, lavender — have varying evidence bases for anxiolytic and mild sedative effects. Best-documented: passionflower for anxiety (Akhondzadeh 2001 comparing passionflower vs oxazepam for GAD showed non-inferiority); lemon balm at 300-600 mg for stress (Kennedy 2004 acute cognitive effects); skullcap traditional. The 'nervous system reset' naming is metaphorical — no botanical resets the nervous system in a physiologically meaningful sense, but adaptogenic and nervine herbs modulate stress response modestly. Specific ingredient list not visible in description snippet. Standard tier for defensible traditional-nervine category; would score higher with per-herb dose disclosure and standardization to passionflower/skullcap markers.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "skip-the-shot-metabolic-support-capsules",
      "title": "Skip The Shot, (Metabolic Support) Capsules",
      "vendor": "Evergreen Apothecary",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/648A7567.jpg?v=1788041697",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "skip",
        "the",
        "shot",
        "metabolic",
        "support",
        "capsules",
        "evergreen",
        "apothecary"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 45,
        "manufacturing": 52,
        "safety": 55,
        "transparency": 45,
        "sustainability": 52
      },
      "price": 50,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830235386053",
      "vsf_explanation": "Evergreen Apothecary Skip the Shot Metabolic Support Capsules is the capsule companion to the Skip the Shot Tincture, explicitly positioning itself as an alternative to GLP-1 receptor agonist injections. Same misleading_naming problem as the tincture: no botanical or supplement approaches GLP-1 agonist pharmacology (semaglutide, tirzepatide) in clinical effect size for weight loss or glycemic control. The Skip the Shot framing sets a therapeutic expectation that no herbal metabolic-support blend can meet. Regardless of the specific ingredient composition (not fully specified in description), the naming itself triggers the autofail — Vyvata does not list products whose primary positioning is a substitute for evidence-based pharmaceutical treatment they cannot pharmacologically emulate. Rejected under misleading_naming.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "calm-colon-tincture-constipation-support",
      "title": "Calm Colon Tincture, Constipation Support",
      "vendor": "Evergreen Apothecary",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/colon2.jpg?v=1788041697",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "calm",
        "colon",
        "tincture",
        "constipation",
        "support",
        "evergreen",
        "apothecary"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 48,
        "manufacturing": 52,
        "safety": 38,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 28,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830235320517",
      "vsf_explanation": "Evergreen Apothecary Calm Colon Tincture features yellow dock (Rumex crispus) for constipation support, positioning it as safe for daily use without dependency risk. Yellow dock contains anthraquinone glycosides — the same chemistry family as cascara sagrada, senna, aloe latex, and rhubarb root — that stimulate intestinal motility through colonic bacterial hydrolysis to anthrones. Yellow dock's anthraquinone content is lower than cascara or senna, but the chemistry is the same class the EU restricted in food supplements (Commission Regulation 2021/468 covering hydroxyanthracene derivatives from Rhamnus, Aloe, Cassia senna, and Rheum) due to genotoxicity concerns. The product page's claim that yellow dock is safe for daily use without dependency risk contradicts stimulant-laxative pharmacology — chronic stimulant laxative use (any anthraquinone-based agent) can produce cathartic colon changes and functional bowel dependence. Rejected under safety_concern for the daily-use positioning of a stimulant-laxative herb.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-c-support-tincture",
      "title": "Vitamin C Support Tincture",
      "vendor": "Evergreen Apothecary",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/vitc.jpg?v=1788041697",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "support",
        "tincture",
        "evergreen",
        "apothecary"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 48,
        "manufacturing": 52,
        "safety": 62,
        "transparency": 45,
        "sustainability": 58
      },
      "price": 28,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830235254981",
      "vsf_explanation": "Evergreen Apothecary Vitamin C Support Tincture is positioned as vitamin C support from plants naturally containing ascorbic acid (rose hips, likely acerola, camu camu, or similar). The core evidence issue: vitamin C content in an alcohol-based tincture is generally very low relative to food-form or supplement-form vitamin C, and vitamin C is water-soluble and heat/oxidation-sensitive so tincture processing degrades ascorbic acid content. Rose hips are indeed vitamin C-rich in fresh form (0.5-1.5 g per 100 g fresh weight) but the vitamin C content in a preserved tincture is typically a small fraction of what could be delivered by a food-form rose hip preparation, ascorbic acid powder, or standard vitamin C supplement. A typical tincture dropperful may deliver <10 mg vitamin C vs 500-1000 mg from a standard supplement. Marketing this as meaningful vitamin C support sets an expectation the delivery format cannot meet. Not a safety concern; a dose-vs-marketing mismatch.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "deep-sleep-tincture",
      "title": "Deep Sleep Tincture",
      "vendor": "Evergreen Apothecary",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/deepsleep.webp?v=1788041697",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "deep",
        "sleep",
        "tincture",
        "evergreen",
        "apothecary"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 28,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830235418821",
      "vsf_explanation": "Evergreen Apothecary Deep Sleep Tincture is positioned for sleep-onset and sleep-maintenance support. Specific herbal composition not visible in description snippet but is likely a nervine-sedative blend (passionflower, valerian, hops, chamomile, lemon balm, skullcap, or similar). Passionflower has anxiety/sleep evidence (Akhondzadeh 2001 vs oxazepam for GAD non-inferiority); valerian has modest sleep-onset RCT support at 400-900 mg extract (Bent 2006 meta-analysis showed statistically significant sleep-quality improvement but modest effect size); hops shows sedative activity in preclinical work; chamomile per Amsterdam 2009 for anxiety with sleep-adjacent benefit. Tincture format allows titration but does not disclose per-herb dose equivalent to trial doses. Nervine sleep tinctures are a defensible category with real (modest) evidence; standard tier for typical execution. Held from higher by dose disclosure gap and evidence-base modesty.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "candida-cleanse",
      "title": "Candida Cleanse",
      "vendor": "Evergreen Apothecary",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/candida6.jpg?v=1788041697",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "candida",
        "cleanse",
        "evergreen",
        "apothecary"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 50,
        "transparency": 40,
        "sustainability": 52
      },
      "price": 28,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830235582661",
      "vsf_explanation": "Evergreen Apothecary Candida Cleanse is positioned for systemic candida overgrowth or candida-related dysbiosis. The medical concept of 'systemic candida overgrowth' as a general-population wellness diagnosis is not recognized by mainstream infectious disease or gastroenterology guidelines. Actual clinically-significant candidiasis has specific forms with specific diagnoses: oropharyngeal (thrush, diagnosed on exam), esophageal (endoscopy, in immunocompromised), vulvovaginal (clinical + wet mount/culture), cutaneous, or invasive candidemia (blood culture, in ICU/immunocompromised). Each is treated with specific antifungals (fluconazole, nystatin, amphotericin B) with documented efficacy. The wellness-marketing 'candida cleanse' construct uses non-specific symptoms (fatigue, brain fog, bloating, cravings, skin issues) that overlap with dozens of common conditions to sell a treatment for an unlikely diagnosis. Rejected under unverified_medical_claim.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "energy-tincture",
      "title": "+Energy Tincture",
      "vendor": "Evergreen Apothecary",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/energy.webp?v=1788041697",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "energy",
        "tincture",
        "evergreen",
        "apothecary"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 28,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830235484357",
      "vsf_explanation": "Evergreen Apothecary +Energy Tincture combines green tea, ginkgo biloba, and goji berries for energy and cognitive support. Ingredient-by-ingredient: green tea contains caffeine (~30-50 mg per cup) and L-theanine, with real evidence for calm-alertness and modest metabolic effects; ginkgo biloba at 120-240 mg standardized to 24% flavone glycosides and 6% terpene lactones (EGb 761) has evidence for cognitive support in age-related cognitive decline (Zhang 2016 Cochrane review found mixed evidence for dementia, better data for mild cognitive impairment) and specific cerebrovascular indications; goji berries have modest antioxidant data and traditional-use precedent but limited RCT support for specific energy claims. Green tea + ginkgo is a defensible energy/nootropic combination direction. Per-herb dose not disclosed. Standard tier for coherent ingredient rationale with real evidence base for green tea and ginkgo.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "anxiety-tincture",
      "title": "Anxiety Tincture",
      "vendor": "Evergreen Apothecary",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/anxiety1_05d5ac43-24fe-4dd3-ae71-16b70f8a1aa4.jpg?v=1788041697",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "anxiety",
        "tincture",
        "evergreen",
        "apothecary"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 52,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 28,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830235451589",
      "vsf_explanation": "Evergreen Apothecary Anxiety Tincture combines tulsi (holy basil, Ocimum sanctum), skullcap (Scutellaria lateriflora), and wood betony (Stachys officinalis / Betonica officinalis). The product is named for a specific medical diagnosis (anxiety) rather than a symptom or general use — this triggers scrutiny under unverified_disease_claim. Anxiety disorders (GAD, panic disorder, social anxiety, specific phobia) are defined medical conditions with evidence-based treatments (CBT, SSRIs, SNRIs, buspirone, short-course benzodiazepines) and specific diagnostic criteria (GAD-7 score, DSM-5 criteria). Marketing an herbal tincture explicitly by the diagnostic name misrepresents the clinical landscape. Individually, the herbs have modest evidence: tulsi (Cohen 2014) for stress markers; skullcap (Wolfson 2003 anxiolytic activity in mice, some small human data) with traditional-use precedent; wood betony traditional-use with essentially no modern RCT support. Herbal support for stress is defensible as adjunctive; naming a product 'Anxiety Tincture' overreaches. Rejected under unverified_disease_claim; would score Standard if renamed to describe the herbal category (nervine, adaptogen) or the state (stress support) rather than the diagnosis.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "raspberry-leaf-tincture",
      "title": "Raspberry Leaf Tincture",
      "vendor": "Evergreen Apothecary",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/rasp2.jpg?v=1788041697",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "raspberry",
        "leaf",
        "tincture",
        "evergreen",
        "apothecary"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 26,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830235549893",
      "vsf_explanation": "Evergreen Apothecary Raspberry Leaf Tincture is single-ingredient Rubus idaeus leaf, marketed for menstrual, pregnancy, and postpartum support. Red raspberry leaf has extensive traditional-use precedent in Western herbalism as a uterine tonic, particularly in late-pregnancy preparation and postpartum recovery. Modern evidence: Simpson 2001 (J Midwifery Womens Health) retrospective study of 108 low-risk pregnant women taking raspberry leaf tablets showed shortened second stage of labor and reduced instrumental delivery vs matched controls, though the study design was not RCT. Parsons 1999 randomized small pilot found no significant difference in labor length. The evidence is limited and mostly traditional; safety in pregnancy at food-form doses is generally accepted with the standard caveat to introduce in late pregnancy (usually third trimester) rather than early. Single-ingredient honest formulation, traditional-use precedent, generally accepted pregnancy safety at appropriate timing. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "milk-thistle-capsules",
      "title": "Milk Thistle Capsules",
      "vendor": "Evergreen Apothecary",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/milkthistle_831f52d9-cbf1-4de1-8a1f-8dc5b788441b.webp?v=1788041697",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "milk",
        "thistle",
        "capsules",
        "evergreen",
        "apothecary"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 27.96,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830235648197",
      "vsf_explanation": "Evergreen Apothecary Milk Thistle Capsules is single-ingredient Silybum marianum seed, positioned for liver support and hepatocellular protection. Milk thistle is one of the better-studied herbal supplements: silymarin (a complex of flavonolignans including silybin, silydianin, silychristin) at 140 mg standardized extract three times daily (420 mg/day, Legalon standardization at 70-80% silymarin) is the reference clinical dose. Evidence base: Ferenci 1989 in alcoholic cirrhosis showed reduced mortality vs placebo; multiple hepatitis C trials mixed (Rambaldi 2007 Cochrane review found no significant clinical outcome improvement but noted some biomarker improvements); Mengs 2012 review for hepatoprotection. The clinical picture is: real biochemical hepatoprotective mechanism, mixed clinical outcome data, best-studied at the Legalon 140 mg three times daily dose. Evergreen Apothecary's product does not specify silymarin standardization or the Legalon-equivalent dose. Standard tier for reasonable evidence base at appropriate execution; held there by absence of silymarin standardization discussion.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "deep-relief-tincture",
      "title": "Deep Relief Tincture",
      "vendor": "Evergreen Apothecary",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/deepreli_d694c2d2-888f-4207-8534-1c04c90efedb.webp?v=1788041697",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "deep",
        "relief",
        "tincture",
        "evergreen",
        "apothecary"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 28,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830235517125",
      "vsf_explanation": "Evergreen Apothecary Deep Relief Tincture combines white willow bark (Salix alba), meadowsweet (Filipendula ulmaria), skullcap (Scutellaria lateriflora), mullein (Verbascum thapsus), Solomon's seal (Polygonatum spp.), and valerian for pain and connective-tissue support. White willow bark contains salicin, which is metabolized to salicylic acid in vivo — the same active as aspirin but at lower doses (typical willow bark at 240 mg salicin ≈ 87 mg aspirin equivalent per Chrubasik 2001). Chrubasik 2000 (Rheumatology) showed willow bark extract at 240 mg salicin daily improved chronic low-back pain vs placebo. Meadowsweet also contains salicylates (name origin of the word 'aspirin'). Skullcap and valerian have modest anxiolytic/sedative evidence. Solomon's seal and mullein have traditional-use precedent for connective-tissue and respiratory support with minimal modern RCT evidence. Coherent traditional pain-blend rationale. Salicylate content means users on anticoagulants, aspirin, or with salicylate sensitivity should not use.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mood-boost-saffron-tincture",
      "title": "Mood Boost, Saffron Tincture",
      "vendor": "Evergreen Apothecary",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/moodboost.webp?v=1788041697",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mood",
        "boost",
        "saffron",
        "tincture",
        "evergreen",
        "apothecary"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 48,
        "manufacturing": 52,
        "safety": 42,
        "transparency": 45,
        "sustainability": 52
      },
      "price": 30,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830235615429",
      "vsf_explanation": "Evergreen Apothecary Mood Boost Saffron Tincture combines St. John's Wort (Hypericum perforatum), passionflower, and saffron (Crocus sativus). The product description makes a specific efficacy claim that saffron is 'just as useful as medications' for ADHD — this is unverified_medical_claim territory. Individual evidence: St. John's Wort has strong evidence for mild-to-moderate depression (Cochrane 2008 review showed non-inferiority vs standard antidepressants for mild-moderate MDD) at 300 mg three times daily standardized to 0.3% hypericin (LI 160/Jarsin); saffron has real emerging evidence for mild-moderate depression at 30 mg standardized extract daily (Lopresti 2014 systematic review) and modest ADHD evidence (Baziar 2019 in children); passionflower for anxiety. THE MAJOR CONCERN: St. John's Wort has more clinically-significant drug interactions than almost any other herbal supplement — it induces CYP3A4, CYP1A2, CYP2C9, and P-glycoprotein, reducing plasma levels of oral contraceptives, warfarin, cyclosporine, digoxin, HIV antivirals, some chemotherapy agents, statins, immunosuppressants, and many antidepressants (SSRI + St. John's Wort combination has documented serotonin syndrome risk). Marketing SJW-containing products without prominent interaction warnings is inadequate. Rejected under safety_concern + unverified_medical_claim.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "parasite-detox-tincture",
      "title": "Parasite Detox Tincture",
      "vendor": "Evergreen Apothecary",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/648A7660_ca751877-158f-4a11-bd8b-23f080ac8d96.jpg?v=1788041697",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "parasite",
        "detox",
        "tincture",
        "evergreen",
        "apothecary"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 42,
        "manufacturing": 50,
        "safety": 45,
        "transparency": 40,
        "sustainability": 55
      },
      "price": 30,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830235680965",
      "vsf_explanation": "Evergreen Apothecary Parasite Detox Tincture is the tincture companion to the 10-Day Parasite Cleanse Capsules and uses the same symptom checklist (diarrhea, nausea, fatigue, low iron, bloating, cramping, palpitations, hair loss, itching). Same unverified_medical_claim problem: parasitic infection in the general US population is uncommon, is diagnosed via stool testing, and is treated with prescription antiparasitic pharmaceuticals with documented efficacy. The symptom cluster has essentially zero specificity for parasitic infection and overlaps with dozens of common non-parasitic conditions. The tincture format itself changes nothing about the underlying category concern. Rejected under unverified_medical_claim.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "burdock-root-tincture",
      "title": "Burdock Root Tincture",
      "vendor": "Evergreen Apothecary",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/burdockroot.webp?v=1788041704",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "burdock",
        "root",
        "tincture",
        "evergreen",
        "apothecary"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 58
      },
      "price": 24,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830235779269",
      "vsf_explanation": "Evergreen Apothecary Burdock Root Tincture is a single-ingredient Arctium lappa root tincture. Burdock has extensive traditional-use precedent in Western, Chinese, and Japanese herbalism as a bitter digestive, mild diuretic, and lymphatic support herb. Modern evidence: the inulin content (up to 30-45% of root dry weight per Chan 2011) provides prebiotic fermentation; small clinical work on burdock root tea and constipation exists but is underpowered; anti-inflammatory activity is documented in cell and animal models. Burdock is a food ingredient in Japan (gobo) and Korea (ueong), which gives it strong traditional safety precedent. Single-ingredient honest formulation. Extract ratio and per-dropperful marker content not disclosed. Standard tier for honest single-herb tincture with reasonable traditional-use precedent and food-use safety history.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dandelion-root-tincture-1",
      "title": "Dandelion Root Tincture",
      "vendor": "Evergreen Apothecary",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/dand9_d85f7faf-cde1-4193-8be0-9365e2450e98.jpg?v=1788041704",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dandelion",
        "root",
        "tincture",
        "evergreen",
        "apothecary"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 58
      },
      "price": 24,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830235812037",
      "vsf_explanation": "Evergreen Apothecary Dandelion Root Tincture is single-ingredient Taraxacum officinale root. Dandelion has traditional-use precedent in European, Chinese, and North American herbalism as a bitter digestive, choleretic (bile-flow stimulant), and mild diuretic. Modern evidence: Clare 2009 small pilot (5 subjects) showed brief diuretic effect of dandelion leaf tincture; bitter-receptor activation stimulates gastric secretion; inulin content (dandelion root is 25-40% inulin by dry weight) provides prebiotic effect. Well-tolerated food-adjacent herb with long use history. Extract ratio and per-dropperful concentration not disclosed. Users on lithium, diuretics, or with gallbladder obstruction should exercise caution. Standard tier for honest single-herb tincture; held there by evidence-base modesty and dose transparency gap.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "skip-the-shot-with-yerba-mate-tincture",
      "title": "Skip The Shot with Yerba Mate, Tincture",
      "vendor": "Evergreen Apothecary",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/648A7973.jpg?v=1788041704",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "skip",
        "the",
        "shot",
        "with",
        "yerba",
        "mate",
        "tincture",
        "evergreen",
        "apothecary"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 45,
        "sustainability": 52
      },
      "price": 35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830235877573",
      "vsf_explanation": "Evergreen Apothecary Skip the Shot Tincture is positioned as a botanical alternative to GLP-1 receptor agonist injections (semaglutide, tirzepatide) for weight management and blood sugar. The product name explicitly frames itself as a substitute for GLP-1 injections. This is a misleading_naming pattern: no botanical or supplement has demonstrated GLP-1 agonist pharmacology comparable to semaglutide or tirzepatide, which are engineered peptide analogs that bind and activate GLP-1 receptors with 94% and 55% sequence homology respectively to native GLP-1. Yerba mate (Ilex paraguariensis) has caffeine, chlorogenic acids, and modest data on modest weight-loss and glycemic effects at high daily doses (typically 3g/day of leaves per Kim 2015), but delivers ~1-2% of the weight loss and glycemic effect magnitude of GLP-1 agonists in trials. The Skip the Shot framing sets a therapeutic expectation the product cannot meet. Rejected under misleading_naming.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnesium-spray",
      "title": "Magnesium Spray",
      "vendor": "Evergreen Apothecary",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/mag8.jpg?v=1788041704",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "spray",
        "evergreen",
        "apothecary"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "stretch_mobility"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 22,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830235844805",
      "vsf_explanation": "Evergreen Apothecary Magnesium Spray is a topical magnesium (typically magnesium chloride in water) formulation with lavender and clove for muscle tension, sleep, and circulation claims. The core evidence question for topical magnesium products is transdermal absorption. Multiple controlled studies have found essentially NO measurable systemic magnesium absorption through intact skin: Kass 2013 (Magnes Res) reviewed the topical magnesium literature and concluded absorption evidence was inadequate; Grober 2017 (Nutrients) noted that transdermal absorption of magnesium salts is at best minimal and highly variable. The one commonly-cited study supporting transdermal absorption (Watkins 2010) is a small unblinded pilot with methodological limitations. The lavender and clove additions may contribute topical soothing and aromatherapy effects independent of magnesium absorption. Users seeking systemic magnesium for sleep, muscle cramps, or deficiency should use oral magnesium glycinate or citrate. Rejected on evidence and misleading-benefit grounds.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chamomile-tincture-1",
      "title": "Chamomile Tincture",
      "vendor": "Evergreen Apothecary",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/chamomile6.jpg?v=1788041704",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chamomile",
        "tincture",
        "evergreen",
        "apothecary"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 58
      },
      "price": 26,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830235910341",
      "vsf_explanation": "Evergreen Apothecary Chamomile Tincture is single-ingredient Matricaria recutita (German chamomile). Chamomile has one of the better-documented modern evidence bases among common herbal supplements: Amsterdam 2009 (J Clin Psychopharmacol) tested standardized chamomile extract at 220-1100 mg/day in 57 adults with generalized anxiety disorder for 8 weeks and showed significant Hamilton Anxiety Rating reduction vs placebo; Amsterdam 2016 confirmed at 500 mg 3x daily. Chang 2016 in elderly showed sleep quality improvement. Traditional-use precedent for GI upset (spasmolytic) is well-established. Chamomile is extensively used as a food-form tea globally, giving very strong safety precedent. Tincture format allows dose titration; per-dropperful equivalent to trial doses is not disclosed. Single-ingredient honest formulation, real anxiety evidence, food-safety precedent. Standard tier; would score Verified with standardization to apigenin content and dose-equivalency guidance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "wild-yam-tallow",
      "title": "Wild Yam Tallow",
      "vendor": "Evergreen Apothecary",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/648A7379.jpg?v=1788041705",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wild",
        "yam",
        "tallow",
        "evergreen",
        "apothecary"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 48,
        "manufacturing": 52,
        "safety": 55,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 17,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830235943109",
      "vsf_explanation": "Evergreen Apothecary Wild Yam Tallow is a topical cream combining wild yam root (Dioscorea villosa) and clary sage in a tallow (rendered beef fat) base, positioned for hormone balance and endogenous progesterone production. The core marketing claim — that wild yam encourages the body's own progesterone production — is a well-documented myth. Diosgenin, the sapogenin in wild yam, is a starting material used in INDUSTRIAL LABORATORY synthesis of progesterone (Marker degradation, 1940s pharmaceutical chemistry), but the human body cannot perform this multi-step chemical conversion. Diosgenin ingested or applied topically is NOT converted to progesterone in vivo (Komesaroff 2001 Climacteric randomized 23 postmenopausal women to topical wild yam cream vs placebo for 3 months and found NO change in progesterone, estradiol, FSH, LH, lipids, or symptom scores). The 'natural progesterone production' claim is unverified_medical_claim regardless of the product's other qualities. The topical tallow-plus-botanical formulation itself is not harmful, but the mechanism it claims to enact does not occur.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "10-day-parasite-cleanse-capsules",
      "title": "10-Day Parasite Cleanse Capsules",
      "vendor": "Evergreen Apothecary",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/648A7550.jpg?v=1788041705",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "day",
        "parasite",
        "cleanse",
        "capsules",
        "evergreen",
        "apothecary"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 42,
        "manufacturing": 52,
        "safety": 45,
        "transparency": 40,
        "sustainability": 55
      },
      "price": 50,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830235975877",
      "vsf_explanation": "Evergreen Apothecary 10-Day Parasite Cleanse Capsules is positioned as a general-population parasite detox and lists a symptom cluster (diarrhea, nausea, fatigue, low iron, bloating, dizziness, cramping, hair loss, food allergies, itching, palpitations) that overlaps substantially with dozens of non-parasitic conditions including IBS, SIBO, hypothyroidism, iron-deficiency anemia, celiac disease, IBD, endometriosis, autoimmune disease, and normal anxiety. Actual clinically-significant parasitic infection in the US general population (giardia, cryptosporidium, pinworm, strongyloides, etc.) is diagnosed by stool ova and parasites testing (or PCR), NOT by symptom self-checklist, and is treated with prescription antiparasitic pharmaceuticals (metronidazole, nitazoxanide, ivermectin, praziquantel) with documented efficacy — not with herbal blends. The 'parasite cleanse' category is one of the most well-documented unverified_medical_claim wellness patterns: it uses non-specific symptoms to sell a treatment for an unlikely diagnosis, and can delay real medical workup for conditions like anemia, thyroid dysfunction, or IBD that share the symptom overlap. Rejected under unverified_medical_claim.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cortisol-cleanup",
      "title": "Cortisol Cleanup",
      "vendor": "Evergreen Apothecary",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/648A7968_36a37179-d3e8-4655-b028-336ad9b88765.jpg?v=1788041705",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cortisol",
        "cleanup",
        "evergreen",
        "apothecary"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 30,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830236008645",
      "vsf_explanation": "Evergreen Apothecary Cortisol Cleanup Tincture is positioned as adaptogenic stress support for symptoms of dysregulated cortisol (wired-tired feeling, sleep-onset difficulty, anxiety, brain fog, overwhelm). The naming 'Cortisol Cleanup' is more marketing than physiology — the body cannot 'clean up' cortisol; healthy HPA axis function regulates cortisol production and clearance. However, adaptogenic herb tinctures for stress support are a defensible category with real (if modest) evidence: ashwagandha standardized extracts at 300-600 mg/day reduce cortisol in stressed adults (Chandrasekhar 2012, Lopresti 2019); rhodiola at 200-400 mg/day for stress-related fatigue (Panossian 2010); holy basil (tulsi) at 500-1000 mg/day for stress markers (Cohen 2014); L-theanine at 200 mg for acute stress response. Specific ingredient list and per-herb dose disclosure not visible in the description snippet. Standard tier for defensible adaptogenic direction; held there by the metaphorical 'cleanup' naming and dose disclosure gap.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "midnight-calm-tincture",
      "title": "Midnight Calm Tincture",
      "vendor": "Evergreen Apothecary",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/calm1_1b663fb6-d65d-490f-bb29-42808bb4aad3.jpg?v=1788041705",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "midnight",
        "calm",
        "tincture",
        "evergreen",
        "apothecary"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 26,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830236041413",
      "vsf_explanation": "Evergreen Apothecary Midnight Calm Tincture combines Mugwort (Artemisia vulgaris), Motherwort (Leonurus cardiaca), and Chamomile (Matricaria recutita) for nighttime wakefulness. Each herb has traditional-use precedent and modest modern data: chamomile has GAD evidence at 500-1500 mg standardized (Amsterdam 2009) and some sleep RCTs (Chang 2016); motherwort has traditional cardiac and anxiolytic uses with limited modern RCT support; mugwort has minimal modern clinical data for sleep. Safety note: Mugwort is a documented emmenagogue and uterine stimulant, contraindicated in pregnancy. Mugwort is also cross-reactive with ragweed (Compositae family) allergy. The tincture format allows dose titration, which is a strength, but the specific extract ratio and per-herb strength are not published. Standard tier for defensible traditional formula; held there by evidence-base modesty and pregnancy contraindication that must be noted.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "suma",
      "title": "Suma",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SumaT.png?v=1788041858",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "suma",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830237417669",
      "vsf_explanation": "Suma is a Prairie Star Botanicals single-ingredient liquid extract containing Suma (Pfaffia paniculata) — Brazilian Ginseng, positioned for adrenal, liver, men's and women's health support. Suma is a South American folk adaptogen with preclinical ergogenic and hormonal screening. Some in-vitro data on ecdysteroid content. No meaningful human RCT evidence supports the adaptogen positioning at supplement doses. Generally well-tolerated at label doses. Not for hormone-sensitive conditions (theoretical estrogenic effect). Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "reishi-mushroom",
      "title": "Reishi Mushroom",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ReishiT.png?v=1788041858",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "reishi",
        "mushroom",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 50,
        "sustainability": 60
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830237679813",
      "vsf_explanation": "Reishi Mushroom is a Prairie Star Botanicals single-ingredient liquid extract containing Reishi (Ganoderma lucidum), positioned for immune, sleep, and adaptogen support. Reishi has RCT support for immune-modulation markers, cancer-adjunct quality-of-life, and mild fatigue reduction (Jin 2016 Cochrane). Effective doses are typically 1.5-6 g/day of standardized dual-extract mushroom powder. Prairie Star's tincture format contains less concentrated beta-glucans and triterpenes than the studied dual-extract preparations. Well-tolerated. Rare hepatotoxicity reports with unregulated products. Mild GI upset possible. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "yucca",
      "title": "Yucca",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/YuccaT.png?v=1788041858",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "yucca",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 52,
        "sustainability": 60
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830237548741",
      "vsf_explanation": "Yucca is a Prairie Star Botanicals single-ingredient liquid extract containing Yucca (Yucca schidigera / glauca) root, positioned for liver, circulatory, adrenal, urinary support. Yucca saponins are FDA-approved as GRAS food additives (foaming agent) and have small pilot evidence for arthritis pain reduction (Bingham 1975). Broader multi-system tincture positioning has no RCT support. GI upset at higher doses. Saponins can reduce fat-soluble vitamin absorption with chronic high intake. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "yerba-santa",
      "title": "Yerba Santa",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/YerbaSantaT.png?v=1788041858",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "yerba",
        "santa",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830237810885",
      "vsf_explanation": "Yerba Santa is a Prairie Star Botanicals single-ingredient liquid extract containing Yerba Santa (Eriodictyon californicum) leaf, positioned for lung, circulatory, urinary support. Yerba santa is a Southwestern California Indigenous respiratory expectorant with strong traditional use. Contains eriodictyol (flavonoid) with preclinical antioxidant activity. No modern RCT support at supplement doses. Very well-tolerated at label doses. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "white-peony",
      "title": "White Peony",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/White_Peony_T.png?v=1788041858",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "white",
        "peony",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830238073029",
      "vsf_explanation": "White Peony is a Prairie Star Botanicals single-ingredient liquid extract containing White Peony (Paeonia lactiflora) root — Bai Shao, positioned for liver, circulatory, and women's health support. White peony is a foundational TCM herb (Bai Shao) appearing in classical menstrual and hormonal formulas. Combination formulas (Xiao Yao San / Free-and-Easy-Wanderer, Shakuyaku-kanzo-to / TJ-68) have Chinese and Japanese RCT literature for menstrual pain, hyperandrogenism, and muscle cramps. Isolated single-herb tincture RCT evidence at Western dosing is thin. Generally well-tolerated. Diarrhea possible at high doses. Not for cold-yang-deficient TCM patterns. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "yellow-sweetclover",
      "title": "Yellow Sweetclover",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/YellowSweetCloverT.png?v=1788041858",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "yellow",
        "sweetclover",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 35,
        "transparency": 52,
        "sustainability": 60
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830237941957",
      "vsf_explanation": "Yellow Sweetclover is a Prairie Star Botanicals single-ingredient liquid extract containing Yellow Sweetclover (Melilotus officinalis), positioned for circulation support. Yellow sweetclover contains coumarin, which converts to the anticoagulant dicoumarol on spoilage (the discovery leading to warfarin). Small European evidence exists for standardized coumarin/troxerutin combinations in chronic venous insufficiency, but the tincture format has unpredictable coumarin content and real anticoagulant risk. Anticoagulant effect (bleeding risk, hepatotoxicity from moldy/aged material). Not with warfarin, NSAIDs, upcoming surgery, or pregnancy. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "easy-sleep-spray",
      "title": "Easy Sleep Spray",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/EasySleep.jpg?v=1788041859",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "easy",
        "sleep",
        "spray",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_environment"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 45,
        "sustainability": 60
      },
      "price": 6,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830238335173",
      "vsf_explanation": "Easy Sleep Spray is a Prairie Star Botanicals single-ingredient liquid extract containing Easy Sleep Spray (Lavender, Grapefruit, Neroli essential oils in water/vodka carrier — room/linen aromatherapy spray), positioned for sleep environment aromatherapy for room and linens. Lavender aromatherapy has small RCT support for subjective sleep quality and pre-sleep anxiety (Hirokawa 2012, Lillehei 2015). Effective delivery in RCTs is typically inhalation from a diffuser at defined concentrations or direct oil inhalation, not ambient linen spray. Grapefruit and neroli have thin small studies for stress markers. Topical/environmental use only; not for ingestion. Photosensitivity risk (bergapten in some grapefruit oils). Standard essential-oil precautions. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sharp-as-a-tack",
      "title": "Sharp as a Tack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SharpasaTack.png?v=1788041859",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sharp",
        "tack",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 25,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 30,
        "sustainability": 60
      },
      "price": 15,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830238367941",
      "vsf_explanation": "Sharp as a Tack is a Prairie Star Botanicals multi-herb proprietary-blend tincture containing Sharp as a Tack (proprietary blend of Ginkgo, Peppermint, Rosemary), positioned for cerebral function and memory. Ginkgo biloba (EGb 761 standardized 24% flavonoids / 6% terpene lactones) has substantial RCT evidence at 120-240 mg/day for cognitive function in cognitive-impairment populations. Rosemary aroma has small acute cognition studies. Without per-herb dosing, RCT evidence cannot transfer. Ginkgo antiplatelet interaction (aspirin, warfarin); pre-surgical discontinuation; general blend caution. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "happy-heart-tonic",
      "title": "Happy Heart Tonic",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HappyHeartTonic.png?v=1788041859",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "happy",
        "heart",
        "tonic",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 25,
        "manufacturing": 55,
        "safety": 45,
        "transparency": 30,
        "sustainability": 60
      },
      "price": 15,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830238499013",
      "vsf_explanation": "Happy Heart Tonic is a Prairie Star Botanicals multi-herb proprietary-blend tincture containing Happy Heart Tonic (proprietary blend of Linden, Motherwort, Yarrow, Ginkgo, Rosemary, Mugwort, American Ginseng, Aronia), positioned for heart function support. Motherwort has traditional cardiotonic use with small preclinical data; aronia has real RCT evidence for BP and lipids at specific standardized-anthocyanin doses. Without per-herb dosing, none transfers. Mugwort thujone (not for pregnancy); ginkgo antiplatelet interaction; motherwort uterotonic; general cardiac-medication interaction risk. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "digestive-bitters-1",
      "title": "Digestive Bitters",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/DigestiveBitters.png?v=1788041860",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "digestive",
        "bitters",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 25,
        "manufacturing": 55,
        "safety": 45,
        "transparency": 30,
        "sustainability": 60
      },
      "price": 15,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830238630085",
      "vsf_explanation": "Digestive Bitters is a Prairie Star Botanicals multi-herb proprietary-blend tincture containing Digestive Bitters (proprietary blend of Angelica, Dandelion, Yellow Dock, Mugwort, Ginger), positioned for digestion via traditional bitter-tonic. Bitter tonics have plausible physiologic mechanism (vagal stimulation, salivary and gastric secretion) but limited modern RCT support. Individual ingredients (ginger, dandelion) have small pilot data. Without per-herb dosing, transfer is limited. Mugwort thujone (not for pregnancy, uterotonic); angelica photosensitivity and anticoagulant interaction; yellow dock anthraquinone (mild laxative) chronic-use caution. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "first-defense",
      "title": "First Defense",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/FirstDefense.png?v=1788041860",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "first",
        "defense",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 25,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 30,
        "sustainability": 60
      },
      "price": 15,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830238761157",
      "vsf_explanation": "First Defense is a Prairie Star Botanicals multi-herb proprietary-blend tincture containing First Defense (proprietary blend of Echinacea, Boneset, Elder Flower, Isatis, Goldenseal, Horehound, Hyssop, Yarrow, Ginger, Mountain Mint), positioned for onset-of-cold acute immune support. Echinacea and elderberry have real acute-URI RCT support at specific doses. Boneset (Eupatorium perfoliatum) is a traditional diaphoretic with no modern RCT evidence. Isatis (Ban Lan Gen) has TCM combination-formula use for acute infection. Goldenseal berberine not for pregnancy; echinacea allergic reaction in Asteraceae-sensitized people; alcohol tincture caution; proprietary-blend dosing. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "happy-tummy",
      "title": "Happy Tummy",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HappyTummy.png?v=1788041860",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "happy",
        "tummy",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 25,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 30,
        "sustainability": 60
      },
      "price": 15,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830238892229",
      "vsf_explanation": "Happy Tummy is a Prairie Star Botanicals multi-herb proprietary-blend tincture containing Happy Tummy (proprietary blend of Anise Hyssop, Lemon Balm, Chamomile, Catnip, Ginger, Peppermint, Dandelion, Wild Bergamot), positioned for digestion support (carminative). Ginger and peppermint have real RCT support for IBS and functional dyspepsia at specific doses. Chamomile has small anxiolytic and mild digestive support. Without per-herb dosing, the RCT evidence cannot transfer. Ginger anticoagulant caution at high doses; peppermint reflux; general blend caution. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "happy-nose",
      "title": "Happy Nose",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HappyNose.png?v=1788041860",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "happy",
        "nose",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 25,
        "manufacturing": 55,
        "safety": 40,
        "transparency": 30,
        "sustainability": 60
      },
      "price": 15,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830239154373",
      "vsf_explanation": "Happy Nose is a Prairie Star Botanicals multi-herb proprietary-blend tincture containing Happy Nose (proprietary blend of Plantain, Stinging Nettle, Horseradish, Goldenseal, Goldenrod, Thyme, Ragweed, Elder Flower), positioned for sinus and clear-breathing support. Stinging nettle root has small allergic-rhinitis evidence at standardized doses. Ragweed inclusion is problematic — ragweed is the primary North American airborne allergen and internal use can trigger allergic reactions in the substantial sensitized population. Ragweed allergic-reaction risk; goldenseal berberine (pregnancy contraindication); horseradish GI irritation; proprietary-blend dosing risk. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "happy-nerve",
      "title": "Happy Nerve",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HappyNerve.png?v=1788041860",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "happy",
        "nerve",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 25,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 30,
        "sustainability": 60
      },
      "price": 15,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830239023301",
      "vsf_explanation": "Happy Nerve is a Prairie Star Botanicals multi-herb proprietary-blend tincture containing Happy Nerve (proprietary blend of Skullcap, California Poppy, Wood Betony, Passionflower, Linden, Hops, Lemon Balm, Mugwort), positioned for nervine calming. Passionflower and hops have small anxiolytic and sleep-supportive RCT evidence at specific doses. Without per-herb dosing this cannot transfer. Mugwort contains thujone with real safety flags. Skullcap has hepatotoxicity case reports (some due to American Skullcap adulteration). Mugwort thujone (not for pregnancy, potential abortifacient); skullcap hepatotoxicity signal; proprietary-blend dosing risk. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "immune-boost",
      "title": "Immune Boost",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ImmuneBoost.png?v=1788041860",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "immune",
        "boost",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 25,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 30,
        "sustainability": 60
      },
      "price": 15,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830239285445",
      "vsf_explanation": "Immune Boost is a Prairie Star Botanicals multi-herb proprietary-blend tincture containing Immune Boost (proprietary blend of Elderberry, Echinacea, Hyssop, Thyme, Mullein, Ginger), positioned for daily immune support. Elderberry (standardized black elderberry syrup) and echinacea (E. purpurea aerial) have real RCT support for upper respiratory infection duration and severity at specific doses. Without per-herb dosing this evidence cannot transfer. Well-tolerated ingredients individually. Echinacea allergic-reaction risk in Asteraceae-sensitized people. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "childrens-defense",
      "title": "Children's Defense",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ChildrensDefense.png?v=1788041861",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "youth_under_18",
      "tokens": [
        "children",
        "defense",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 22,
        "manufacturing": 55,
        "safety": 30,
        "transparency": 25,
        "sustainability": 55
      },
      "price": 15,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830239416517",
      "vsf_explanation": "Children's Defense is a Prairie Star Botanicals multi-herb proprietary-blend tincture containing Children's Defense (proprietary blend of Echinacea, Horehound, Elder Flower, Goldenseal, Isatis, Elderberry, Thyme, Hyssop, Ginger), positioned for pediatric immune support. Elderberry has small pediatric RCT support for URI duration; echinacea pediatric evidence is mixed. Without per-herb dosing pediatric-specific safety cannot be verified. Goldenseal berberine content is not recommended for infants (kernicterus risk in neonates). Goldenseal berberine not for infants; alcohol-based tincture inappropriate for young children in many jurisdictions; proprietary-blend dosing prevents pediatric dose verification; isatis TCM combination-context normally. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "black-walnut",
      "title": "Black Walnut",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BlackWalnutT.png?v=1788041860",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "black",
        "walnut",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 40,
        "transparency": 40,
        "sustainability": 60
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830239547589",
      "vsf_explanation": "Black Walnut is a Prairie Star Botanicals single-ingredient liquid extract containing Black Walnut (Juglans nigra) hull, positioned for \"healthy cleansing\" and thyroid function. Black walnut hull is a folk antiparasitic and iodine source. No modern RCT evidence supports antiparasitic or thyroid claims at supplement doses. The \"cleansing\" positioning is unsubstantiated and triggers the unverified-medical-claim autofail regardless of the herb's traditional use. Iodine variability (thyroid risk). Tree-nut allergy cross-reactivity. Juglone content is neurotoxic at high doses. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "kidney-cleanse",
      "title": "Kidney Cleanse",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/KidneyCleanse.png?v=1788041861",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "kidney",
        "cleanse",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 22,
        "manufacturing": 55,
        "safety": 40,
        "transparency": 25,
        "sustainability": 55
      },
      "price": 15,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830239809733",
      "vsf_explanation": "Kidney Cleanse is a Prairie Star Botanicals single-ingredient liquid extract containing Kidney Cleanse (proprietary blend of Uva Ursi, Cleavers, Juniper Berry, Parsley Root, Plantain), positioned for \"kidney cleanse\" and bladder support. Uva ursi has small UTI evidence but is limited to short-course use (<2 weeks) due to hydroquinone content. Juniper berry historical caution for renal-irritation with prolonged use. No RCT support for \"cleanse\" positioning; kidneys are self-regulating filtration organs — \"cleanse\" is not a medical concept. Uva ursi hydroquinone short-course only; juniper berry chronic-use renal irritation; not for pregnancy or existing kidney disease. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sagebrush",
      "title": "Sagebrush",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SagebrushT.png?v=1788041861",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sagebrush",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 40,
        "transparency": 52,
        "sustainability": 60
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830239678661",
      "vsf_explanation": "Sagebrush is a Prairie Star Botanicals single-ingredient liquid extract containing Sagebrush (Artemisia tridentata), positioned for digestion, liver, lymphatic, women's health. Sagebrush is a Great Basin Indigenous ceremonial and medicinal herb. Artemisia tridentata contains thujone and other terpenoids. No modern RCT support. Multi-system tincture positioning is folk-medicine only. Thujone content warrants dose limits; not for pregnancy (uterine stimulant, potential abortifacient); not for chronic daily use. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "watercress",
      "title": "Watercress",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/WatercressT.png?v=1788041862",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "watercress",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 52,
        "sustainability": 60
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830239940805",
      "vsf_explanation": "Watercress is a Prairie Star Botanicals single-ingredient liquid extract containing Watercress (Nasturtium officinale), positioned for liver function support. Watercress is a nutrient-dense cruciferous green with PEITC (phenethyl isothiocyanate) content. Small dietary intervention studies show reduced DNA damage biomarkers with fresh watercress intake (Gill 2007). Tincture form does not deliver the intact PEITC in meaningful amounts. Very well-tolerated as food. Thyroid caution at very high intake. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ragweed",
      "title": "Ragweed",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/RagweedT.png?v=1788041862",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ragweed",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 35,
        "transparency": 52,
        "sustainability": 60
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830240071877",
      "vsf_explanation": "Ragweed is a Prairie Star Botanicals single-ingredient liquid extract containing Ragweed (Ambrosia artemisiifolia), positioned for sinus, digestion, eye/ear support. Ragweed is best known as one of the most potent airborne allergens in North America (hay fever primary cause). Some folk-medicine use exists but no modern RCT evidence supports internal use. Consuming ragweed carries real allergic-reaction risk in the sensitized population (~10-20% of US adults). Allergic reaction risk (up to anaphylaxis) in sensitized people. Not for anyone with grass/weed allergies. Cross-reacts with chamomile, echinacea, other Asteraceae. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "partridgeberry",
      "title": "Partridgeberry",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/PartridgeberryT.png?v=1788041862",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "partridgeberry",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830240202949",
      "vsf_explanation": "Partridgeberry is a Prairie Star Botanicals single-ingredient liquid extract containing Partridgeberry (Mitchella repens), positioned for female reproductive system support. Partridgeberry is a traditional Cherokee and Eclectic herbal preparation historically used as a \"partus preparator\" (birth-preparation) in the last weeks of pregnancy. No modern RCT evidence supports the positioning. Any pregnancy-related use should be under midwife/clinician supervision. Not for early pregnancy (traditionally restricted to third trimester with practitioner supervision). Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "parsley-1",
      "title": "Parsley",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Parsley_Leaf_T.png?v=1788041862",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "parsley",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 52,
        "sustainability": 60
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830240465093",
      "vsf_explanation": "Parsley is a Prairie Star Botanicals single-ingredient liquid extract containing Parsley (Petroselinum crispum), positioned for kidney, liver, digestion support. Parsley has traditional diuretic use; small preclinical evidence for mild diuretic effect (Kreydiyyeh 2002). No meaningful human RCT evidence for the tincture positioning. Well-tolerated at food doses. Apiol content in seed/high-dose tincture is uterotonic — not for pregnancy. Photosensitivity (furocoumarins) at high doses. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "wild-lettuce-1",
      "title": "Wild Lettuce",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/WildLettuceT.png?v=1788041862",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wild",
        "lettuce",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 52,
        "sustainability": 60
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830240334021",
      "vsf_explanation": "Wild Lettuce is a Prairie Star Botanicals single-ingredient liquid extract containing Wild Lettuce (Lactuca virosa), positioned for calm nerves, muscle and joint support (traditional sedative-analgesic). Wild lettuce sap (\"lactucarium\") is a historical mild sedative-analgesic recorded from 19th-century Eclectic and European use. No modern RCT evidence supports the positioning. Recreational-use resurgence exists in the harm-reduction literature with mixed toxicity reports. Generally well-tolerated at label doses. Case reports of poisoning at very high recreational doses. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fringed-sage",
      "title": "Fringed Sage",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/FringedSageT.png?v=1788041863",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fringed",
        "sage",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 45,
        "transparency": 52,
        "sustainability": 60
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830240727237",
      "vsf_explanation": "Fringed Sage is a Prairie Star Botanicals single-ingredient liquid extract containing Fringed Sage (Artemisia frigida), positioned for liver/gallbladder and women's health support. Fringed sage is a Great Plains Indigenous ceremonial and medicinal herb with folk-medicine use for menstrual, digestive, and respiratory complaints. Contains thujone (Artemisia genus). No modern RCT support. Thujone content warrants dose limits; not for pregnancy (uterine stimulant, potential abortifacient). Not for chronic use. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "jamaican-dogwood",
      "title": "Jamaican Dogwood",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/JamaicanDogwoodT.png?v=1788041864",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "jamaican",
        "dogwood",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 40,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830240858309",
      "vsf_explanation": "Jamaican Dogwood is a Prairie Star Botanicals single-ingredient liquid extract containing Jamaican Dogwood (Piscidia piscipula), positioned for mental function and joint/muscle support (traditional sedative/analgesic). Jamaican dogwood bark is a traditional Caribbean sedative and analgesic. No modern RCT evidence supports the positioning. The plant is historically used as a fish poison (\"fishfuddle\") — the same isoflavonoid alkaloids responsible for narcotic effect on fish contribute to human toxicity at higher doses. Potentially toxic at moderate doses; historical fish poison. Not for pregnancy, children, or with sedative medications. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pipsissewa",
      "title": "Pipsissewa",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/PipsissewaT.png?v=1788041864",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pipsissewa",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830240989381",
      "vsf_explanation": "Pipsissewa is a Prairie Star Botanicals single-ingredient liquid extract containing Pipsissewa (Chimaphila umbellata), positioned for kidney function and lymphatic support. Pipsissewa is a traditional Native American and Eclectic urinary-tract herb (like uva ursi, contains arbutin). No modern RCT support. Related to uva ursi, which itself has thin evidence. Arbutin/hydroquinone content warrants dose limits and short-course use. Not for pregnancy or kidney impairment. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "rehmannia",
      "title": "Rehmannia",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/RehmanniaT.png?v=1788041864",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "rehmannia",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830241120453",
      "vsf_explanation": "Rehmannia is a Prairie Star Botanicals single-ingredient liquid extract containing Rehmannia (Rehmannia glutinosa) root — Shu Di Huang, positioned for blood, adrenal, and women's health support. Rehmannia is a foundational TCM \"blood tonic\" herb appearing in classical formulas (Liu Wei Di Huang Wan, Da Bu Yin Wan). Chinese-language RCT literature exists for combination formulas addressing renal function, diabetes, and menstrual disorders. Isolated single-herb tincture RCT evidence at Western dosing is very thin. Generally well-tolerated. GI upset (unprocessed form). Not for spleen-yang deficiency in TCM framework. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "saw-palmetto-1",
      "title": "Saw Palmetto",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SawPalmettoT.png?v=1788041864",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "saw",
        "palmetto",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830241284293",
      "vsf_explanation": "Saw Palmetto is a Prairie Star Botanicals single-ingredient liquid extract containing Saw Palmetto (Serenoa repens), positioned for prostate and lower urinary tract support. Saw Palmetto has substantial RCT and meta-analysis support for lower urinary tract symptoms (LUTS) related to benign prostatic hyperplasia, though the largest Cochrane review (Tacklind 2012) concluded effects are modest and not superior to placebo for most endpoints. Effective RCT doses are 320 mg/day of the standardized 85-95% fatty acid liposterolic extract (Permixon, Prostaserene). Prairie Star's berry tincture is not the standardized liposterolic form, so RCT evidence transfers weakly. Very well-tolerated; rare GI upset. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "xanthium",
      "title": "Xanthium",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/XanthiumT.png?v=1788041866",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "xanthium",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 30,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830241448133",
      "vsf_explanation": "Xanthium is a Prairie Star Botanicals single-ingredient liquid extract containing Xanthium (Xanthium sibiricum) fruit — Cang Er Zi, positioned for sinus function support. Cang Er Zi is a traditional TCM herb for sinus/nasal complaints, appearing in formulas such as Cang Er Zi San. HEPATOTOXICITY is well-documented — carboxyatractyloside content has caused reported cases of acute liver injury, including fatalities in China. The World Health Organization and TCM regulatory bodies specifically flag Xanthium as needing careful processing (fry-processed form, dose limits, short-course use). Documented hepatotoxicity; not for pregnancy, children, chronic use, or hepatic impairment. Even properly processed xanthium is limited to short courses (<2 weeks) in TCM practice. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "wild-cherry-bark",
      "title": "Wild Cherry Bark",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Wild_Cherry_Bark_T.png?v=1788041866",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wild",
        "cherry",
        "bark",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 45,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830241579205",
      "vsf_explanation": "Wild Cherry Bark is a Prairie Star Botanicals single-ingredient liquid extract containing Wild Cherry Bark (Prunus serotina), positioned for lung, circulatory, and digestive support. Wild cherry bark is a traditional cough suppressant (used in old syrups) via prunasin cyanogenic glycoside. No modern RCT support for the positioning. Prunasin releases hydrogen cyanide on hydrolysis — the traditional caution to avoid heat/boiling in preparation exists for this reason. Cyanogenic glycoside content warrants dose limits; not for pregnancy or children. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "feverfew",
      "title": "Feverfew",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/FeverfewT.png?v=1788041868",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "feverfew",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 60
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830241710277",
      "vsf_explanation": "Feverfew is a Prairie Star Botanicals single-ingredient liquid extract containing Feverfew (Tanacetum parthenium), positioned for migraine prophylaxis and circulatory support. Feverfew has Cochrane-review-level support for migraine prophylaxis with mixed but net-positive results (Wider 2015). The effective dose in most RCTs is standardized to 0.2-0.6% parthenolide at 50-150 mg/day of leaf powder. Prairie Star's liquid extract does not disclose a parthenolide percentage. Generally well-tolerated. Mouth ulcers with fresh-leaf chewing; not for pregnancy (uterine stimulant). Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "herbal-sunshine",
      "title": "Herbal Sunshine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HerbalSunshine.png?v=1788041867",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "herbal",
        "sunshine",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 25,
        "manufacturing": 55,
        "safety": 40,
        "transparency": 30,
        "sustainability": 60
      },
      "price": 15,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830241841349",
      "vsf_explanation": "Herbal Sunshine is a Prairie Star Botanicals multi-herb proprietary-blend tincture containing Herbal Sunshine (proprietary blend of St. John's Wort, Lemon Balm, Holy Basil, Calamus, Prairie White Sage, Rosemary, Prairie Wild Rose, Compass Leaf), positioned for mood and mental-function support. St. John's Wort has real RCT evidence for mild-to-moderate depression at 300 mg TID standardized to hyperforin. Lemon balm has small anxiety RCT support. Without per-herb doses, none of this transfers. St. John's Wort is a strong CYP3A4 inducer — reduces effectiveness of birth control, warfarin, HIV protease inhibitors, transplant meds, many others. Serotonin syndrome risk with SSRIs/SNRIs. Calamus (Acorus calamus) contains beta-asarone with FDA safety concern (banned in US as food additive). Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "osha",
      "title": "Osha",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/OshaT.png?v=1788041870",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "osha",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 50,
        "sustainability": 40
      },
      "price": 20,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830241972421",
      "vsf_explanation": "Osha is a Prairie Star Botanicals single-ingredient liquid extract containing Osha (Ligusticum porteri), positioned for lung and immune function. Osha is a Rocky Mountain Indigenous respiratory herb with strong regional traditional use. No modern RCT evidence supports the positioning. Osha is also at-risk from overharvest — United Plant Savers lists it as a species of concern. Not for pregnancy (potential uterine stimulant). Well-tolerated at label doses. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gumweed",
      "title": "Gumweed",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/GumweedT.png?v=1788041870",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gumweed",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 52,
        "sustainability": 60
      },
      "price": 16,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830242103493",
      "vsf_explanation": "Gumweed is a Prairie Star Botanicals single-ingredient liquid extract containing Gumweed (Grindelia squarrosa), positioned for lung function support (traditional expectorant). Gumweed is a Great Plains traditional respiratory herb used for asthma, bronchitis, and skin complaints. Modern data limited to preclinical anti-inflammatory screening. No human RCT support. Generally well-tolerated at label doses. May concentrate selenium from soil. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "forsythia",
      "title": "Forsythia",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ForsythiaT.png?v=1788041871",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "forsythia",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830242234565",
      "vsf_explanation": "Forsythia is a Prairie Star Botanicals single-ingredient liquid extract containing Forsythia (Forsythia suspensa) fruit — Lian Qiao, positioned for immune and circulatory support. Lian Qiao is a traditional TCM antimicrobial herb combined in formulas such as Yin Qiao San for early respiratory infection. RCT evidence exists for combination TCM formulas (during SARS/COVID adjunct trials) but not for the isolated tincture at Prairie Star's dosing. Generally well-tolerated at label doses. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "para-cleanse",
      "title": "Para~Cleanse",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Para-Cleanse.png?v=1788041871",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "para",
        "cleanse",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 20,
        "manufacturing": 55,
        "safety": 30,
        "transparency": 25,
        "sustainability": 55
      },
      "price": 15,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830242365637",
      "vsf_explanation": "Para~Cleanse is a Prairie Star Botanicals single-ingredient liquid extract containing Para~Cleanse (proprietary blend of Elecampane, Epazote, Wormwood, Sweet Annie, Black Walnut, Prairie White Sage), positioned for \"cleanse\" and small-intestine support (antiparasitic). Wormwood (Artemisia absinthium) contains thujone; sweet annie (Artemisia annua) contains artemisinin (real antimalarial but prescription-regulated in many jurisdictions); epazote contains ascaridole (traditional antiparasitic with real toxicity). No RCT support at supplement doses. The \"cleanse\" positioning is an unverified medical claim. Thujone (wormwood) neurotoxicity; ascaridole (epazote) toxicity with reported fatalities; artemisinin resistance concerns; not for pregnancy on multiple grounds. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "prairie-wild-rose",
      "title": "Prairie Wild Rose",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/PrairieWildRoseT.png?v=1788041871",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "prairie",
        "wild",
        "rose",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 52,
        "sustainability": 60
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830242496709",
      "vsf_explanation": "Prairie Wild Rose is a Prairie Star Botanicals single-ingredient liquid extract containing Prairie Wild Rose (Rosa arkansana) aerial, positioned for heart function and mood/stress support. Rose (rosa spp.) has folk-medicine use as a mild nervine and cardiotonic. Rose hip has small RCT support for osteoarthritis pain (galactolipid GOPO extract), but that's the fruit, not the aerial parts. No modern RCT supports the tincture's heart/mood positioning. Very well-tolerated. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fenugreek",
      "title": "Fenugreek",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/FenugreekT.png?v=1788041872",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fenugreek",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830242627781",
      "vsf_explanation": "Fenugreek is a Prairie Star Botanicals single-ingredient liquid extract containing Fenugreek (Trigonella foenum-graecum), positioned for glucose, digestion, and male hormone support. Fenugreek seed has modest RCT support for fasting glucose and HbA1c in type-2 diabetes (Neelakantan 2014 meta-analysis) at 5-10 g/day of ground seed. A branded standardized furostanolic saponin extract (Testofen/Furosap) has small RCTs on free testosterone. Prairie Star's tincture is not the standardized branded extract. Well-tolerated. Maple-syrup body odor; anticoagulant caution; not for pregnancy (uterine stimulant). Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "barberry",
      "title": "Barberry",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BarberryT.png?v=1788041871",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "barberry",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830242758853",
      "vsf_explanation": "Barberry is a Prairie Star Botanicals single-ingredient liquid extract containing Barberry (Berberis vulgaris), positioned for liver function support (contains berberine). Barberry root bark contains berberine, which has substantial RCT support for glucose, lipids, and metabolic syndrome (Lan 2015 meta-analysis) at 500-1500 mg/day of berberine HCl. Prairie Star's liquid tincture does not disclose berberine content; a typical unstandardized barberry extract delivers a small fraction of the RCT berberine dose. Berberine causes GI upset. Not for pregnancy or infants (kernicterus risk). Multiple CYP-450 interactions. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lymphatic-cleanse",
      "title": "Lymphatic Cleanse",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/LymphaticCleanse.png?v=1788041871",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lymphatic",
        "cleanse",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 22,
        "manufacturing": 55,
        "safety": 45,
        "transparency": 25,
        "sustainability": 60
      },
      "price": 15,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830242889925",
      "vsf_explanation": "Lymphatic Cleanse is a Prairie Star Botanicals single-ingredient liquid extract containing Lymphatic Cleanse (proprietary blend of Cleavers, Red Root, Burdock, Calendula, Red Clover, Heal All, Ground Ivy, Figwort, Mayapple), positioned for \"cleanse\" and lymphatic-support. Mayapple (Podophyllum peltatum) contains podophyllotoxin — a real cytotoxic compound used in topical wart treatment (Podofilox) and as the parent for etoposide chemotherapy. Internal use has documented severe toxicity including fatalities. No RCT evidence supports lymphatic \"cleanse\" positioning. Mayapple podophyllotoxin is genuinely toxic internally (GI necrosis, neuropathy, cytopenia); not for pregnancy; short-course only. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "happy-hormone",
      "title": "Happy Hormone",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HappyHormone.png?v=1788041874",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "happy",
        "hormone",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 22,
        "manufacturing": 55,
        "safety": 40,
        "transparency": 25,
        "sustainability": 55
      },
      "price": 15,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830243053765",
      "vsf_explanation": "Happy Hormone is a Prairie Star Botanicals multi-herb proprietary-blend tincture containing Happy Hormone (proprietary blend of Black Cohosh, Motherwort, White Peony, Blue Vervain, Sage, Mugwort), positioned for hormonal balance support. Black cohosh has real menopausal-symptom evidence at standardized doses; white peony appears in TCM combinations. Without per-herb doses, the evidence cannot transfer. Mugwort contains thujone — the same safety flag as absinthe. Mugwort thujone content is not for pregnancy (potential abortifacient); black cohosh has case reports of hepatotoxicity; multi-Artemisia stacking. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "prairie-horsemint",
      "title": "Prairie Horsemint",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/PrairieHorsemintT.png?v=1788041874",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "prairie",
        "horsemint",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 52,
        "sustainability": 60
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830243184837",
      "vsf_explanation": "Prairie Horsemint is a Prairie Star Botanicals single-ingredient liquid extract containing Prairie Horsemint (Monarda punctata), positioned for digestion, circulation, and mood support. Prairie horsemint has Great Plains Indigenous and settler folk-medicine use for digestive, respiratory, and antimicrobial claims (high thymol content). No modern RCT evidence supports the tincture positioning. Well-tolerated at label doses. Thymol content warrants moderate use. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "celery-seed",
      "title": "Celery seed",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CelerySeedT.png?v=1788041878",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "celery",
        "seed",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830243348677",
      "vsf_explanation": "Celery seed is a Prairie Star Botanicals single-ingredient liquid extract containing Celery Seed (Apium graveolens), positioned for digestion, joint, urinary, and respiratory support. Celery seed has small pilot studies suggesting mild uric-acid lowering (relevant to gout) and modest blood-pressure reduction (NBP-3-nB-butylphthalide branded extract). Unstandardized tincture format has thin transfer to those pilot doses. Well-tolerated. Photosensitivity (furocoumarins) at high doses. Not for pregnancy. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vital-energy",
      "title": "Vital Energy",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/VitalEnergy.png?v=1788041878",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vital",
        "energy",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 25,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 30,
        "sustainability": 60
      },
      "price": 15,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830243479749",
      "vsf_explanation": "Vital Energy is a Prairie Star Botanicals multi-herb proprietary-blend tincture containing Vital Energy (proprietary blend including Ashwagandha, American Ginseng, Licorice, Compass and other herbs), positioned for adrenal system and stress-resilience support. Ashwagandha (KSM-66, Sensoril) and American ginseng each have real RCT evidence for stress and cognition at specific doses. Without per-herb dose disclosure, these evidence bases cannot transfer to this blend. Licorice glycyrrhizin causes hypertension and hypokalemia with chronic use; ashwagandha thyroid interaction; general blend caution. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cardamom",
      "title": "Cardamom",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CardamomT.png?v=1788041878",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cardamom",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830243610821",
      "vsf_explanation": "Cardamom is a Prairie Star Botanicals single-ingredient liquid extract containing Cardamom (Elettaria cardamomum), positioned for digestion, respiratory, and men's health support. Cardamom seed powder has small RCT support for blood-pressure reduction (Verma 2009) and lipid modulation at 3 g/day. Digestive-carminative positioning is traditional-use only. \"Men's health\" positioning has no clinical support. Very well-tolerated as culinary spice and supplement. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bayberry",
      "title": "Bayberry",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BayberryRootBarkT.png?v=1788041878",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bayberry",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830243741893",
      "vsf_explanation": "Bayberry is a Prairie Star Botanicals single-ingredient liquid extract containing Bayberry (Myrica cerifera), positioned for digestion, liver, and lung support. Bayberry root bark is a traditional Eclectic/Physiomedicalist herb with astringent tannin content. No modern RCT evidence supports the multi-system claims. Sodium retention concern with chronic use. Chronic use may raise blood pressure via mineralocorticoid effect; not for pregnancy or hypertension. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bladderwrack",
      "title": "Bladderwrack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BladderwrackT.png?v=1788041879",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bladderwrack",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 40,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830243872965",
      "vsf_explanation": "Bladderwrack is a Prairie Star Botanicals single-ingredient liquid extract containing Bladderwrack (Fucus vesiculosus), positioned for thyroid function support. Bladderwrack is a seaweed source of iodine (variable, often 500-2000 mcg per gram of dried herb). Iodine supplementation is medically valid for iodine deficiency, but bladderwrack's unpredictable iodine content makes it a poor delivery form — it can cause both hypo- and hyperthyroid effects. Also concentrates heavy metals (arsenic, cadmium) from ocean water. Unpredictable iodine dose risks hyperthyroidism and Hashimoto's flares. Heavy-metal contamination risk without third-party testing. Anticoagulant interaction (fucoidan). Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chinese-skullcap-1",
      "title": "Chinese Skullcap",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ChineseSkullcapT.png?v=1788041879",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chinese",
        "skullcap",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830244004037",
      "vsf_explanation": "Chinese Skullcap is a Prairie Star Botanicals single-ingredient liquid extract containing Chinese Skullcap (Scutellaria baicalensis), positioned for liver, respiratory, and anti-inflammatory support via baicalin and wogonin. Chinese Skullcap flavonoids (baicalin, baicalein, wogonin) have real preclinical and small clinical evidence for anti-inflammatory and hepatoprotective effects. Human RCT data is largely on combination TCM formulas (PHY906) rather than the isolated tincture, and cases of hepatotoxicity have been reported with certain products, though rarely. Rare hepatotoxicity signal in isolated case reports (Skullcap-associated liver injury has been ascribed to American Skullcap adulterants but also to some Scutellaria baicalensis products). Discontinue if LFT changes. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "spearmint",
      "title": "Spearmint",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SpearmintT.png?v=1788041887",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "spearmint",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 52,
        "sustainability": 60
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830244200645",
      "vsf_explanation": "Spearmint is a Prairie Star Botanicals single-ingredient liquid extract containing Spearmint (Mentha spicata), positioned for cognitive and digestive support. A branded standardized spearmint extract (Neumentix, rosmarinic-acid-enriched) has RCT support for working memory and reaction time in older adults (Herrlinger 2018) and for PCOS-related androgen reduction (Grant 2010). Prairie Star's tincture is not the Neumentix standardization, so the RCT evidence transfers only weakly. Very well-tolerated. Anti-androgenic potential (helpful in PCOS; consider if male on androgen support). Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "japanese-knotweed",
      "title": "Japanese Knotweed",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/JapaneseKnotweedT.png?v=1788041915",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "japanese",
        "knotweed",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 52,
        "sustainability": 60
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830245445829",
      "vsf_explanation": "Japanese Knotweed is a Prairie Star Botanicals single-ingredient liquid extract containing Japanese Knotweed (Polygonum cuspidatum), positioned for immune, lung, circulatory support (contains resveratrol). Japanese Knotweed root is the primary commercial source of trans-resveratrol used in supplement manufacturing. Resveratrol RCT evidence exists for endothelial and metabolic markers at 150-500 mg/day of purified trans-resveratrol. Prairie Star's tincture does not disclose resveratrol content; typical unstandardized knotweed root extract delivers only a fraction of the RCT dose. Also widely used in Buhner Lyme protocols with clinical experience but no RCT support. Generally well-tolerated. Antiplatelet caution. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "devils-club",
      "title": "Devil's Club",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Devil_sClubT.png?v=1788041915",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "devil",
        "club",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830244528325",
      "vsf_explanation": "Devil's Club is a Prairie Star Botanicals single-ingredient liquid extract containing Devil's Club (Oplopanax horridus), positioned for muscle, joint, and adrenal support. Devil's Club has significant Pacific-Northwest Indigenous ethnobotanical use for musculoskeletal, respiratory, and metabolic complaints. Modern evidence is limited to preclinical antidiabetic and antimicrobial screening. No human RCT support for the tincture positioning. Generally well-tolerated at label doses. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "amla",
      "title": "Amla",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/AmlaT.png?v=1788041915",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "amla",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830245314757",
      "vsf_explanation": "Amla is a Prairie Star Botanicals single-ingredient liquid extract containing Amla (Emblica officinalis), positioned for digestive, liver, and antioxidant support. Amla has meaningful RCT support for lipid modulation and antioxidant/oxidative-stress markers (Upadya 2019, Fatima 2018) with typical doses of 500 mg to 1 g standardized fruit extract twice daily. Amla is rich in vitamin C and tannins; the liquid extract format contains less concentrated actives than the studied capsule extracts. Generally well-tolerated. Mild GI upset possible. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lobelia",
      "title": "Lobelia",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Lobelia_T_278d6ef7-3faf-4dc3-8bf1-47c89dd4f925.png?v=1788041915",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lobelia",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 35,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830245183685",
      "vsf_explanation": "Lobelia is a Prairie Star Botanicals single-ingredient liquid extract containing Lobelia (Lobelia inflata), positioned for lung function support (traditional emetic and nicotinic-receptor active). Lobeline is a nicotinic-receptor partial agonist historically studied for smoking cessation with disappointing results (Stead 2012 Cochrane). \"Lung function support\" positioning is traditional-use only. Also called \"Indian tobacco\" and used as an emetic in eclectic herbalism. Toxic at moderate doses — nausea, vomiting, tremors, respiratory depression. Prairie Star flags this as \"low-dose herb, consult a practitioner before use,\" which is appropriate. Not for pregnancy, cardiac disease, seizure disorders. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cordyceps-mushroom",
      "title": "Cordyceps Mushroom",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CordycepsT.png?v=1788041915",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cordyceps",
        "mushroom",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830244659397",
      "vsf_explanation": "Cordyceps Mushroom is a Prairie Star Botanicals single-ingredient liquid extract containing Cordyceps (Cordyceps sinensis / militaris) mycelium, positioned for energy, exercise capacity, and immune support. Cordyceps militaris has small RCT support for VO2 max, ventilatory threshold, and exercise tolerance in trained adults (Hirsch 2017, Chen 2010). Effective doses in RCTs are typically 1-4 g/day of standardized fruiting body powder. Prairie Star's product is a MYCELIUM extract, which is a less potent (and less studied) form than the fruiting body. Very well-tolerated. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bilberry",
      "title": "Bilberry",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BilberryT.png?v=1788041915",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bilberry",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 52,
        "sustainability": 60
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830244921541",
      "vsf_explanation": "Bilberry is a Prairie Star Botanicals single-ingredient liquid extract containing Bilberry (Vaccinium myrtillus), positioned for eye and vascular support via anthocyanins. Bilberry anthocyanins have modest RCT support for visual fatigue in screen users (Kamiya 2013, Kosehira 2020) and vascular endothelial function. Effect sizes are small and most RCTs test standardized anthocyanin extracts (25-36%) at 160-320 mg/day, not unstandardized liquid extracts. Prairie Star does not publish an anthocyanin percentage. Generally well-tolerated at label doses. Theoretical antiplatelet effect at high doses. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "black-pepper",
      "title": "Black Pepper",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BlackPepperT.png?v=1788041915",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "black",
        "pepper",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830245052613",
      "vsf_explanation": "Black Pepper is a Prairie Star Botanicals single-ingredient liquid extract containing Black Pepper (Piper nigrum), positioned for digestion and respiratory support via piperine. Piperine (5-20 mg) is well-known as a bioavailability enhancer for other actives (curcumin, resveratrol). As a standalone digestive or respiratory supplement, no meaningful RCT evidence supports specific benefit claims. Traditional use only. GI irritation possible at high doses. Modulates CYP3A4 (drug-interaction relevance). Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "turkey-rhubarb-1",
      "title": "Turkey Rhubarb",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/TurkeyRhubarbT.png?v=1788041915",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "turkey",
        "rhubarb",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 40,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830245576901",
      "vsf_explanation": "Turkey Rhubarb is a Prairie Star Botanicals single-ingredient liquid extract containing Turkey Rhubarb (Rheum palmatum), positioned for \"healthy elimination\" (stimulant laxative). Turkey Rhubarb root contains anthraquinone glycosides (sennosides, rhein) similar to senna. Effects are laxative rather than restorative. FDA and EMA warn against chronic anthraquinone laxative use (>2 weeks) due to melanosis coli, cathartic-colon dependence, and electrolyte disturbance. Chronic use causes laxative dependence, potassium depletion, and colon changes. Not for pregnancy, nursing, IBD, or children. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "eye-health-tonic",
      "title": "Eye Health Tonic",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/EyeHealth.png?v=1788041915",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "eye",
        "health",
        "tonic",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 25,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 30,
        "sustainability": 60
      },
      "price": 15,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830244790469",
      "vsf_explanation": "Eye Health Tonic is a Prairie Star Botanicals multi-herb proprietary-blend tincture containing Eye Health Tonic (proprietary blend of Ginkgo, Goji Berry, Angelica and other herbs), positioned for eye function support. The formula contains herbs with individually meaningful evidence (ginkgo for microcirculation, goji for macular pigment). However, no individual herb doses are disclosed on the label — the RCT-supported doses for each component cannot be verified. Ginkgo antiplatelet interaction; Angelica photosensitivity and anticoagulant interaction; general blend caution. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "clove",
      "title": "Clove",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CloveT.png?v=1788041915",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "clove",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830245707973",
      "vsf_explanation": "Clove is a Prairie Star Botanicals single-ingredient liquid extract containing Clove (Syzygium aromaticum), positioned for nerve function (traditional analgesic). Clove eugenol has strong topical dental-analgesic evidence (canaliculitis, dry socket). As a systemic tincture for \"nerve function,\" no RCT evidence supports the positioning. Traditional culinary and topical use only. GI upset at high oral doses. Anticoagulant caution (eugenol antiplatelet). Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cilantro",
      "title": "Cilantro",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CilantroT.png?v=1788041915",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cilantro",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 52,
        "sustainability": 60
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830245970117",
      "vsf_explanation": "Cilantro is a Prairie Star Botanicals single-ingredient liquid extract containing Cilantro (Coriandrum sativum) leaf, positioned for digestion support (widely marketed elsewhere as \"heavy-metal chelation\"). Cilantro has traditional culinary use and thin small-animal data on lead/mercury chelation. No human RCT supports the heavy-metal-chelation claim popular in alternative-medicine positioning. Digestive-support claim is traditional-use only. Very well-tolerated as food. Rare allergy. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "black-horehound",
      "title": "Black Horehound",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BlackHorehoundT.png?v=1788041915",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "black",
        "horehound",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830246101189",
      "vsf_explanation": "Black Horehound is a Prairie Star Botanicals single-ingredient liquid extract containing Black Horehound (Ballota nigra), positioned for digestion and antiemetic. Black Horehound has European folk-medicine use as an antiemetic for motion sickness and nervous nausea. No modern RCT evidence supports specific benefit claims. Diterpenoids and phenylpropanoids are candidate actives with in-vitro data only. Generally well-tolerated at label doses. Dopamine-antagonist caution with Parkinson's medications. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cayenne",
      "title": "Cayenne",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CayenneT.png?v=1788041915",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cayenne",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 52,
        "sustainability": 60
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830246232261",
      "vsf_explanation": "Cayenne is a Prairie Star Botanicals single-ingredient liquid extract containing Cayenne (Capsicum annuum), positioned for circulation support via capsaicin. Capsaicin has strong topical evidence for neuropathic pain (Qutenza 8% patch is FDA-approved). Small oral RCTs suggest modest thermogenic and satiety effects. Direct evidence for \"circulation support\" from oral tincture doses is thin and mechanism-based rather than outcome-tested. GI irritation and heartburn common. GERD contraindication. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "goji-berry",
      "title": "Goji Berry",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/GojiBerryT.png?v=1788041915",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "goji",
        "berry",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 52,
        "sustainability": 60
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830245839045",
      "vsf_explanation": "Goji Berry is a Prairie Star Botanicals single-ingredient liquid extract containing Goji Berry (Lycium barbarum), positioned for liver, longevity, and eye support via zeaxanthin and polysaccharides. Small RCTs on standardized Lycium barbarum polysaccharide (LBP) extracts show modest improvements in subjective wellbeing, macular pigment optical density, and antioxidant markers (Amagase 2008, Bucheli 2011). Effect sizes are small and unstandardized berry tinctures have thinner evidence than the branded LBP extracts tested. Generally well-tolerated. Documented warfarin interaction case reports. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "peach-leaf",
      "title": "Peach Leaf",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/PeachLeafT.png?v=1788041915",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "peach",
        "leaf",
        "prairie",
        "star",
        "botanicals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 52,
        "sustainability": 60
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830246363333",
      "vsf_explanation": "Peach Leaf is a Prairie Star Botanicals single-ingredient liquid extract containing Peach Leaf (Prunus persica) leaf, positioned for digestion, lung, and circulatory support. Peach Leaf is a traditional Southern American / Southern European folk remedy. No modern RCT evidence supports the multi-system claims. Contains small amounts of amygdalin (cyanogenic glycoside) — dose relevance minimal at tincture level but worth flagging. Amygdalin content warrants moderate-dose caution; not for pregnancy. Prairie Star Botanicals is a small US herbalist line built around locally-harvested (where possible) single-herb liquid extracts. The single-ingredient tincture format is honest — you can see exactly what you're taking. What Prairie Star Botanicals does NOT publish at the product level: third-party certificates of analysis, per-lot heavy-metal or microbial testing, herb-to-menstruum extraction ratios, or standardized marker-compound percentages. That opacity is what caps most of the line at Standard-tier or below in Vyvata's rubric even when the herb itself has real evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "horbaach-apple-cider-vinegar-gummies-apple-flavor-400-mg-90-count",
      "title": "Horbäach Apple Cider Vinegar Gummies – Apple Flavor, 400 mg, 90 Count",
      "vendor": "Apple Cider Vinegar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ChatGPTImageJul24_2026at12_45_35AM.png?v=1788042007",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "horb",
        "ach",
        "apple",
        "cider",
        "vinegar",
        "gummies",
        "apple",
        "flavor",
        "400",
        "count",
        "apple",
        "cider",
        "vinegar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 26,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 48,
        "sustainability": 42
      },
      "price": 12.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830247149765",
      "vsf_explanation": "Horbäach Apple Cider Vinegar Gummies deliver 400 mg of ACV per daily serving in a pectin-based, laboratory-tested chewable format. Horbäach is a legitimate US-based supplement operator with third-party lab testing on many SKUs — one of the small formulation positives here. Same core problems as every other ACV gummy: pectin matrix buffers the acid, gummy delivery bypasses the pre-meal timing window Johnston 2004 required, and 400 mg per serving is 8-15x below the studied liquid-equivalent dose (~3,000-6,000 mg dehydrated for the 15-30 ml doses used in trials). Rejected on evidence + delivery + underdose — the low milligram figure here actually makes the underdose more acute than in most competitor gummies.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sports-research-organic-apple-cider-vinegar-gummies-500-mg-sugar-free-60-count",
      "title": "Sports Research Organic Apple Cider Vinegar Gummies – 500 mg, Sugar-Free, 60 Count",
      "vendor": "Apple Cider Vinegar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ChatGPTImageJul24_2026at12_51_18AM.png?v=1788042007",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sports",
        "research",
        "organic",
        "apple",
        "cider",
        "vinegar",
        "gummies",
        "500",
        "sugar",
        "free",
        "count",
        "apple",
        "cider",
        "vinegar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 48,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830247116997",
      "vsf_explanation": "Sports Research Organic ACV Gummies deliver 500 mg of organic ACV per serving in a sugar-free, organic-certified gummy. Sports Research is one of the more credible mid-market DTC supplement brands with real transparency practices — third-party testing on many SKUs, published COAs on some, cGMP manufacturing, and consumer-friendly returns. USDA Organic certification adds a real quality-control layer for the ACV source. But the delivery format problem persists: pectin-buffered gummy matrix breaks the acetic-acid mechanism that Johnston 2004 and White 2007 established. 500 mg per serving is 6-12x below the studied liquid-equivalent dose. Sugar-free removes the glycemic offset that trips other ACV gummies — a real formulation positive. Rejected on evidence + delivery but held near the top of Rejected by strong brand transparency and organic certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-original-ingredients-apple-cider-vinegar-capsules-non-gmo-no-fillers-365-count",
      "title": "Pure Original Ingredients Apple Cider Vinegar Capsules – Non-GMO, No Fillers, 365 Count",
      "vendor": "Apple Cider Vinegar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71fnstm7G5L.jpg?v=1788042012",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "original",
        "ingredients",
        "apple",
        "cider",
        "vinegar",
        "capsules",
        "non",
        "gmo",
        "fillers",
        "365",
        "count",
        "apple",
        "cider",
        "vinegar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830247248069",
      "vsf_explanation": "Pure Original Ingredients Apple Cider Vinegar Capsules deliver undiluted ACV powder in a clean capsule (no magnesium stearate, no fillers, no rice flour), which is a real transparency positive. The core mechanistic problem is the same as with gummies: the small body of positive glycemic-response evidence for ACV (Johnston 2004, White 2007) required liquid vinegar consumed with or before a carbohydrate meal, so the acetic acid could delay gastric emptying and modestly blunt postprandial glucose. Capsule delivery buffers the acid, delays gastric release (the capsule shell dissolves in ~30 min in the stomach), and delivers the ACV as a bolus after the meal's carbohydrates have already begun digestion. Some observational and small-trial data suggest capsule ACV may have modest lipid effects (Khezri 2018, small n) but not the glycemic effects the marketing typically invokes. Rejected on mechanism/evidence gap, held above 45 by clean-label formulation and honest 'no fillers' positioning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "healthfare-maximum-strength-apple-cider-vinegar-capsules-3200-mg",
      "title": "HealthFare Maximum Strength Apple Cider Vinegar Capsules – 3200 mg",
      "vendor": "Apple Cider Vinegar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ChatGPTImageJul23_2026at02_43_00PM.png?v=1788042012",
      "score": 47,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "healthfare",
        "maximum",
        "strength",
        "apple",
        "cider",
        "vinegar",
        "capsules",
        "3200",
        "apple",
        "cider",
        "vinegar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 48,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 55,
        "sustainability": 42
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830247280837",
      "vsf_explanation": "HealthFare Maximum Strength Apple Cider Vinegar Capsules deliver 3,200 mg of apple cider vinegar per serving in vegan capsules, manufactured in a US GMP-certified facility. 3,200 mg is a legitimate dose (roughly equivalent to 15 ml of dehydrated liquid vinegar) — meaningfully above the typical 500 mg capsule ACV product. But the delivery format issue persists: the positive human trials for ACV's glycemic effects (Johnston 2004, White 2007) required liquid vinegar consumed pre-meal so the acetic acid could delay gastric emptying. Capsules buffer and delay acid delivery. Even at 3,200 mg, no published human RCT has shown ACV capsules replicate the postprandial glucose effects of liquid ACV at trial-doses. Rejected on mechanism/evidence gap, held above 45 by honest labeling of the mg dose (many capsule ACV products understate) and by GMP manufacturing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "amazon-basics-apple-cider-vinegar-gummies-with-vitamin-b12-500-mg-60-count",
      "title": "Amazon Basics Apple Cider Vinegar Gummies with Vitamin B12 – 500 mg, 60 Count",
      "vendor": "Apple Cider Vinegar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7248E06F-6E90-4316-96FF-9CC1C51CE006.png?v=1788042012",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "amazon",
        "basics",
        "apple",
        "cider",
        "vinegar",
        "gummies",
        "with",
        "vitamin",
        "b12",
        "500",
        "count",
        "apple",
        "cider",
        "vinegar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 48,
        "sustainability": 42
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830247313605",
      "vsf_explanation": "Amazon Basics Apple Cider Vinegar Gummies deliver 500 mg of ACV per gummy plus added Vitamin B12 in a naturally-flavored apple gummy. Two structural problems. (1) Gummy delivery destroys the acetic-acid mechanism the marketing invokes — Johnston 2004 and subsequent glycemic-response trials used liquid vinegar taken before/during a carb meal to slow gastric emptying; buffering ACV into a pectin/sugar matrix eliminates this pathway. (2) 500 mg per gummy is well below the ~15 ml (roughly 3,000 mg dehydrated) dose in the trials, and typical serving sizes of 1-2 gummies deliver 500-1,000 mg — sub-therapeutic even before the format problem. Amazon Basics as a private-label brand has legitimate manufacturing oversight but publishes minimal per-lot transparency for its supplement SKUs. Rejected on evidence + delivery format, held above 40 by inexpensive B12 addition (which is not harmful) and Amazon's baseline quality-control on private-label consumables.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dietworks-cider-trim-apple-cider-vinegar-capsules-120-count",
      "title": "DietWorks Cider Trim Apple Cider Vinegar Capsules – 120 Count",
      "vendor": "Apple Cider Vinegar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ChatGPTImageJul23_2026at02_52_06PM.png?v=1788042012",
      "score": 41,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dietworks",
        "cider",
        "trim",
        "apple",
        "cider",
        "vinegar",
        "capsules",
        "120",
        "count",
        "apple",
        "cider",
        "vinegar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 42,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 38,
        "sustainability": 42
      },
      "price": 21.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830247346373",
      "vsf_explanation": "DietWorks Cider Trim combines apple cider vinegar with green tea, garcinia cambogia, green coffee extract, cayenne, and ginger in a multi-ingredient capsule marketed for weight support. Three failures compound to push this below 45. (1) 'Cider Trim' branding and the multi-ingredient thermogenic blend positioning invokes weight-loss benefit; the underlying evidence for these ingredients (garcinia hydroxycitric acid, green coffee chlorogenic acid, cayenne capsaicin) is either negative or weakly positive at doses higher than a shared capsule can practically deliver — a 2020 Cochrane review on garcinia (Onakpoya) concluded 'clinically relevant weight-loss effect cannot be confirmed.' (2) Per-ingredient milligrams for the six actives are not disclosed in the description reviewed, tripping the proprietary-blend concern. (3) Green tea extract at unspecified concentration has documented hepatotoxicity signals at high doses (FDA warned in 2022 on EGCG-heavy supplements). Rejected on evidence + disclosure gaps + safety flag on green tea extract.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bulk-supplements-organic-apple-cider-vinegar-powder",
      "title": "Bulk Supplements Organic Apple Cider Vinegar Powder",
      "vendor": "Apple Cider Vinegar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ChatGPTImageJul23_2026at02_32_51PM.png?v=1788042012",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bulk",
        "supplements",
        "organic",
        "apple",
        "cider",
        "vinegar",
        "powder",
        "apple",
        "cider",
        "vinegar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 55,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 62,
        "sustainability": 45
      },
      "price": 17.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830247379141",
      "vsf_explanation": "BulkSupplements Organic Apple Cider Vinegar Powder delivers 500 mg per serving of organic dehydrated ACV in a resealable 500 g pouch — mixable into water, smoothies, or shakes. BulkSupplements is a legitimate Nevada-based bulk-ingredient supplier that publishes per-lot COAs on many SKUs, uses cGMP-certified facilities, and offers third-party testing on request — one of the more transparent operators in the bulk-ingredient space. When rehydrated in liquid and taken pre-meal, ACV powder may partially reconstitute the acid load the Johnston 2004 mechanism relies on, though PK equivalence to liquid vinegar has not been rigorously tested. 500 mg per serving is well below the ~3,000-6,000 mg dehydrated equivalent used in the positive glycemic trials, so users would need 6-12 servings to match trial doses. Rejected on dose + partial-format issue but held near the top of the Rejected band by legitimate manufacturer transparency and the fact that mixing into water gets closer to the trial format than a gummy or capsule ever could.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "country-farms-apple-cider-vinegar-capsules-with-ginger-cayenne-maple-90-count",
      "title": "Country Farms Apple Cider Vinegar Capsules with Ginger, Cayenne & Maple – 90 Count",
      "vendor": "Apple Cider Vinegar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ChatGPTImageJul23_2026at02_45_26PM.png?v=1788042013",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "country",
        "farms",
        "apple",
        "cider",
        "vinegar",
        "capsules",
        "with",
        "ginger",
        "cayenne",
        "maple",
        "count",
        "apple",
        "cider",
        "vinegar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 48,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830247674053",
      "vsf_explanation": "Country Farms ACV Capsules combine 500 mg apple cider vinegar with a 100 mg blend of ginger, cayenne, and maple in a daily capsule. Same core mechanism problem as other capsule ACV products: gummy/capsule format buffers the acid load and delays gastric release, breaking the pre-meal timing that positive glycemic trials (Johnston 2004, White 2007) relied on. 500 mg ACV per serving is roughly 3-6x below the studied liquid-equivalent dose. The 100 mg ginger-cayenne-maple 'blend' is not broken out per-ingredient, so cayenne (which requires 6-9 mg capsaicin for thermogenic effects) and ginger (which shows modest anti-nausea/GI effects at 500-2,000 mg/day) are both very likely sub-therapeutic. Rejected on delivery format + sub-therapeutic dosing + proprietary blend for the added actives.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "the-twisted-shot-organic-apple-cider-vinegar-wellness-shots",
      "title": "The Twisted Shot Organic Apple Cider Vinegar Wellness Shots",
      "vendor": "Apple Cider Vinegar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/81oITNrZIAL.jpg?v=1788042012",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "the",
        "twisted",
        "shot",
        "organic",
        "apple",
        "cider",
        "vinegar",
        "wellness",
        "shots",
        "apple",
        "cider",
        "vinegar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830247575749",
      "vsf_explanation": "The Twisted Shot is a ready-to-drink 2 oz liquid ACV wellness shot combining organic unfiltered apple cider vinegar with ginger, turmeric, honey, cinnamon, and cayenne. This is the one format in the ACV category that actually delivers on the mechanism the marketing invokes — a 2 oz (60 ml) shot at organic-vinegar concentration delivers roughly the same acid load as the 15-30 ml straight-vinegar doses used in the Johnston 2004 and White 2007 glycemic trials, in the correct pre-meal-liquid format. Added ginger, turmeric, and cinnamon each have small evidence bases for GI comfort, anti-inflammatory signaling, and modest glucose modulation respectively; the honey adds ~4-8 g of sugar which slightly offsets glycemic benefit. Standard tier — legitimate delivery format, honest liquid product, mid-band held there by added sugar (glycemic offset), dental-enamel risk from repeated acid exposure, and the fact that homemade liquid ACV is cheaper.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "health-nutrition-zero-sugar-apple-cider-vinegar-gummies-with-the-mother-vitamin-b12",
      "title": "Health Nutrition Zero-Sugar Apple Cider Vinegar Gummies with the Mother & Vitamin B12",
      "vendor": "Apple Cider Vinegar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ChatGPTImageJul24_2026at12_53_12AM.png?v=1788042012",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "health",
        "nutrition",
        "zero",
        "sugar",
        "apple",
        "cider",
        "vinegar",
        "gummies",
        "with",
        "the",
        "mother",
        "vitamin",
        "b12",
        "apple",
        "cider",
        "vinegar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 40,
        "manufacturing": 48,
        "safety": 60,
        "transparency": 32,
        "sustainability": 42
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830247510213",
      "vsf_explanation": "This SKU is titled with the generic descriptor 'Health Nutrition' — a category phrase, not a distinct brand identity — combined with the ubiquitous 'ACV Gummies with the Mother & B12' feature list. Two compounding failures. (1) misleading_naming — 'Health Nutrition' as a brand name is generic enough that it cannot be reliably traced to a specific manufacturer, facility, or COA history; a user searching for it lands on hundreds of similarly-named private-label products with no way to verify quality. (2) Gummy delivery destroys the acetic-acid mechanism the marketing invokes (Johnston 2004 required liquid vinegar taken pre-meal to blunt post-meal glucose). Zero-sugar formulation is a small positive (avoids the sugar-offset that trips other ACV gummies) but does not restore the mechanism. Rejected on brand-identity failure + delivery format + evidence gap.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ancient-bliss-apple-cider-vinegar-capsules-with-the-mother-1600-mg",
      "title": "Ancient Bliss Apple Cider Vinegar Capsules with the Mother – 1600 mg",
      "vendor": "Apple Cider Vinegar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/81RqMw4RUwL.jpg?v=1788042012",
      "score": 47,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ancient",
        "bliss",
        "apple",
        "cider",
        "vinegar",
        "capsules",
        "with",
        "the",
        "mother",
        "1600",
        "apple",
        "cider",
        "vinegar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 48,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830247706821",
      "vsf_explanation": "Ancient Bliss ACV Capsules deliver 1,600 mg of raw, unfiltered apple cider vinegar 'with the Mother' per serving in an easy-to-take capsule format. 1,600 mg is roughly 2-3x higher than typical capsule ACV products and equivalent to roughly 7-8 ml of dehydrated liquid vinegar — still below the 15-30 ml (~3,000-6,000 mg equivalent) doses studied in the positive glycemic trials, and delivered in the format that breaks the acid-load timing mechanism the trials relied on. 'With the Mother' has limited meaning in a dehydrated-powder capsule format because biological content is degraded during processing. Rejected on delivery format + sub-therapeutic dose, held near the top of Rejected by the honestly-stated milligram content (many capsule ACV products understate).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "asquared-nutrition-apple-cider-vinegar-gummies-with-the-mother-1-500-mg",
      "title": "aSquared Nutrition Apple Cider Vinegar Gummies with the Mother – 1,500 mg",
      "vendor": "Apple Cider Vinegar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/IMG-3147.png?v=1788042012",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "asquared",
        "nutrition",
        "apple",
        "cider",
        "vinegar",
        "gummies",
        "with",
        "the",
        "mother",
        "500",
        "apple",
        "cider",
        "vinegar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 42,
        "manufacturing": 52,
        "safety": 62,
        "transparency": 45,
        "sustainability": 42
      },
      "price": 33.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830247739589",
      "vsf_explanation": "aSquared Nutrition ACV Gummies deliver 1,500 mg of ACV per serving in a gummy format 'with the Mother.' aSquared Nutrition is a legitimate US-based DTC supplement brand with mid-tier transparency, but the SKU faces the same structural problem as every gummy ACV product: the pectin-and-sugar gummy matrix buffers the acetic acid, and gummy delivery bypasses the pre-meal timing window the positive glycemic trials (Johnston 2004, White 2007) required. 1,500 mg is a reasonable milligram number relative to competitors but still below the 3,000-6,000 mg dehydrated equivalent of the trial doses, and delivery format breaks the mechanism regardless. Rejected on evidence + delivery, held above 42 by honest mg labeling and mid-tier brand.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "orphic-nutrition-apple-cider-vinegar-gummies-with-the-mother-1-000-mg-120-count",
      "title": "Orphic Nutrition Apple Cider Vinegar Gummies with the Mother – 1,000 mg, 120 Count",
      "vendor": "Apple Cider Vinegar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71CdXcr1ooL._AC_SL1500.jpg?v=1788042013",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "orphic",
        "nutrition",
        "apple",
        "cider",
        "vinegar",
        "gummies",
        "with",
        "the",
        "mother",
        "000",
        "120",
        "count",
        "apple",
        "cider",
        "vinegar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 42,
        "manufacturing": 52,
        "safety": 62,
        "transparency": 45,
        "sustainability": 42
      },
      "price": 27.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830247805125",
      "vsf_explanation": "Orphic Nutrition ACV Gummies deliver 1,000 mg of ACV per serving 'with the Mother' plus added Vitamin B12 in a chewable gummy. Orphic is a legitimate mid-market DTC supplement brand. Same core problems as other ACV gummies: pectin-based gummy matrix buffers the acetic acid and eliminates the pre-meal timing window that positive glycemic trials (Johnston 2004, White 2007) required. 1,000 mg per serving is 3-6x below the studied liquid-equivalent trial dose, and delivery format breaks the mechanism regardless. Added B12 is a mild positive for the small subset of users with deficiency but is not why anyone should choose an ACV product. Rejected on evidence + delivery format.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "numo-apple-cider-vinegar-gummies-with-the-mother-probiotics",
      "title": "Numo Apple Cider Vinegar Gummies with the Mother & Probiotics",
      "vendor": "Apple Cider Vinegar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71lH5oieP6L.jpg?v=1788042056",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "numo",
        "apple",
        "cider",
        "vinegar",
        "gummies",
        "with",
        "the",
        "mother",
        "probiotics",
        "apple",
        "cider",
        "vinegar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 42,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830248263877",
      "vsf_explanation": "Numo Apple Cider Vinegar Gummies package ACV with 'the Mother,' baobab pulp, MCT oil, and 250 million CFU of added probiotics into a chewable gummy format. The core mechanistic problem is delivery format: the small body of positive glycemic-response evidence for ACV (Johnston 2004, White 2007) used liquid vinegar delivered before or during a carbohydrate meal, where acetic acid slowed gastric emptying and blunted postprandial glucose. Gummy delivery destroys this mechanism — the acetic acid is chelated into a pectin/sugar matrix, buffered, and delivered as a chewable sweet rather than an acid load. There is no published human trial showing ACV gummies produce meaningful glycemic, weight-loss, or 'cleanse' effects. The 250 million CFU probiotic addition is well below the 1-10 billion CFU range where probiotic effects are typically demonstrated. Rejected — the gummy format does not preserve the mechanism the marketing invokes, and the probiotic add-on is sub-therapeutic.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liposomal-spermidine-capsules",
      "title": "Liposomal Spermidine Capsules",
      "vendor": "Neurogan Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Liposomal_Spermidine_Capsules_bottle_and_box.png?v=1788042100",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liposomal",
        "spermidine",
        "capsules",
        "neurogan",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 58,
        "sustainability": 48
      },
      "price": 55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830248689861",
      "vsf_explanation": "Neurogan Health Liposomal Spermidine Capsules deliver 50 mg of spermidine per capsule using a synthetic wheat-free source (allows precise dosing, gluten-free) in a phospholipid liposomal delivery system. 50 mg is substantially above the 1-6 mg doses used in the Wirth 2018 / Schwarz 2018 cognitive RCTs and above the ~7 mg dietary intake associated with the Kiechl 2018 mortality-benefit observational data. Liposomal delivery is a defensible bioavailability strategy for polyamines, which are otherwise subject to gut-bacterial metabolism and intestinal enzyme degradation, though product-specific PK data are not published. Standard tier — legitimate delivery format, honest brand, but the dose is well above the studied range without corresponding human outcome data at that dose, and the transparency gap on per-lot COA holds it below Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liposomal-fisetin-capsules",
      "title": "Liposomal Fisetin Capsules",
      "vendor": "Neurogan Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Liposomal_Fisetin_Capsules_Front_Shadow.jpg?v=1788042100",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liposomal",
        "fisetin",
        "capsules",
        "neurogan",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 52,
        "sustainability": 48
      },
      "price": 50,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830248722629",
      "vsf_explanation": "Neurogan Health Liposomal Fisetin Capsules use a phospholipid-based liposomal delivery system intended to improve fisetin's notoriously poor oral bioavailability (~2% for free fisetin). Liposomal encapsulation is a defensible bioavailability strategy — Kadari 2017 and other PK studies show 2-4x improvements in plasma AUC for liposomal flavonoids vs. free-form powders — though independent head-to-head PK comparisons for this specific product are not published. Per-capsule fisetin dose is not clearly stated in the description reviewed, which is a transparency gap. The daily-dose regimen (1-2 caps/day) does not match the intermittent senolytic protocol being studied in the Mayo Clinic AFFIRM trial. Standard tier — legitimately-designed bioavailability format that partly addresses fisetin's PK limitations, held back by dose transparency and by the general early-stage human evidence for fisetin itself.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "resveratrol-capsules",
      "title": "Resveratrol Capsules",
      "vendor": "Neurogan Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MicronizedTrans-Resveratrol_Capsules_Front_Shadow.jpg?v=1788042105",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "resveratrol",
        "capsules",
        "neurogan",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 70,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 60,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830248788165",
      "vsf_explanation": "Neurogan Health Resveratrol Capsules deliver 1,400 mg of micronized resveratrol per two-capsule serving in a vegan, cGMP-manufactured capsule. Neurogan is a real, US-based CBD-adjacent brand with a transparent website and cGMP-certified production. Micronization is a defensible bioavailability step — reduces particle size and improves dissolution — though it does not resolve resveratrol's fundamental low oral bioavailability (~1% systemic). Human RCT evidence for resveratrol is mixed: positive signals on endothelial function and glycemic markers in some diabetic populations (Movahed 2013, Bhatt 2012), but disappointing longevity/insulin-sensitivity results in healthy adults (Yoshino 2012, Poulsen 2013 — 'resveratrol supplementation in nonobese women does not improve metabolic function'). Standard tier — honest, single-ingredient, correctly dosed for the category, held back from Verified by the low absolute bioavailability and the mixed clinical picture.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "spermidine-drops",
      "title": "Spermidine Drops",
      "vendor": "Neurogan Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Spermidine_Drops_Bottle_and_box.jpg?v=1788042105",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "spermidine",
        "drops",
        "neurogan",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 68,
        "manufacturing": 65,
        "safety": 68,
        "transparency": 60,
        "sustainability": 48
      },
      "price": 30,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830248820933",
      "vsf_explanation": "Neurogan Health Spermidine Drops deliver 20 mg of highly purified spermidine trihydrochloride per 0.5 ml serving from a 2 oz dropper — a synthetic, wheat-free source that allows precise dosing (an advantage over wheat-germ-derived spermidine, where per-lot content varies). 20 mg is the highest oral spermidine dose commercially available and sits above the ~1-6 mg range studied in the SmartAge and other cognitive/longevity RCTs (Wirth 2018, Schwarz 2018). The evidence base for oral spermidine is early-stage but interesting: observational data (Kiechl 2018) associates higher dietary spermidine with lower all-cause mortality, and small RCTs suggest modest memory-performance improvement in older adults with subjective cognitive complaints. Standard tier — legitimate delivery format, honest dosing, real brand, held back by thin clinical evidence and by the fact that dietary spermidine (wheat germ, aged cheese, mushrooms, natto) delivers meaningful amounts at zero cost.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "urolithin-a-pro-capsules",
      "title": "Urolithin A Pro Capsules",
      "vendor": "Neurogan Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/UrolithinAPro_Product_Jar_Box.jpg?v=1788042105",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "urolithin",
        "pro",
        "capsules",
        "neurogan",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 100,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830248886469",
      "vsf_explanation": "Neurogan Health Urolithin A PRO Capsules deliver 1,000 mg of ultra-micronized Urolithin A per two-capsule serving, derived from ellagic acid (a pomegranate/walnut precursor). Urolithin A is a legitimate mitophagy-inducing molecule with a growing human evidence base — the AMAZ-02 trial (Andreux 2019) and the follow-on trial in older adults (Liu 2022) both showed improvements in mitochondrial biomarkers and muscle strength at 500-1,000 mg/day. Two caveats keep this in Standard tier rather than higher. (1) The gold-standard clinical evidence used Mitopure/Timeline's proprietary bioconverted urolithin A (matched for bioavailability), and independent-manufacturer versions have not been shown in head-to-head PK trials to reach equivalent plasma levels — micronization is a defensible attempt at bioavailability but not a demonstrated equivalence. (2) Per-lot certificates of analysis and Urolithin A purity/isomer-composition data are not clearly published on the SKU.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pea-pro-capsules",
      "title": "PEA Pro Capsules",
      "vendor": "Neurogan Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/PEAPro_Product_Front_Shadow.jpg?v=1788042105",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pea",
        "pro",
        "capsules",
        "neurogan",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 58,
        "sustainability": 48
      },
      "price": 34,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830248919237",
      "vsf_explanation": "Neurogan Health PEA Pro Capsules deliver 1,500 mg of ultra-micronized palmitoylethanolamide (PEA) per three-capsule serving. PEA is an endogenous fatty-acid amide with a real and moderately robust clinical evidence base — multiple RCTs and a Cochrane-adjacent systematic review (Paladini 2016) support PEA for chronic-pain endpoints (particularly neuropathic and inflammatory pain) at 600-1,200 mg/day, and micronization is the pharmacologically preferred form because it addresses PEA's poor water solubility. 1,500 mg/day sits at the upper end of the studied range. Standard tier — legitimate, correctly-dosed, ultra-micronized form is the right choice, real brand. Held back from Verified by the transparency gap (no published per-lot COA on the SKU) and by the fact that PEA is often stacked with luteolin (Mirodenafil-Menopause-adjacent PEA-LUT combinations show additional efficacy in trigeminal-neuralgia trials) — a solo PEA is honest but suboptimal.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fisetin-capsules",
      "title": "Fisetin Capsules",
      "vendor": "Neurogan Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Neurogan_Health_Fisetin_Capsules_bottle.png?v=1788042105",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fisetin",
        "capsules",
        "neurogan",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 55,
        "sustainability": 48
      },
      "price": 30,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830248952005",
      "vsf_explanation": "Neurogan Health Fisetin Capsules deliver 500 mg of fisetin per capsule sourced from Rhus succedanea (Japanese wax tree) fruit extract, marketed for cellular health and 'healthy aging.' Fisetin is a flavonoid with real preclinical senolytic activity — Yousefzadeh 2018 (EBioMedicine) identified fisetin as the most potent of ten tested flavonoids for clearing senescent cells in mice, and Mayo Clinic launched a Phase 2 human trial (AFFIRM) in 2020 using 20 mg/kg for two consecutive days per month. Human outcome data are not yet published. 500 mg/day is well below the intermittent-dose regimen used in the Mayo trials (~1,400 mg/day for a 70 kg adult, for two days per month), so this SKU is dosed for daily general antioxidant support, not for the studied senolytic protocol. Standard tier — legitimate ingredient, correctly labeled, but the daily-low-dose regimen does not match the emerging senolytic evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-organic-beet-root-20-1-extract-400-mg-black-pepper-4-1-extract-10-mg-200-veggie-caps-vegan-non-gmo",
      "title": "NusaPure Organic Beet Root 20:1 Extract, 400 mg - Black Pepper 4:1 Extract, 10 mg - 200 Veggie caps (Vegan, Non-GMO)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-130668v7-Org-Beet-Root-Black-Pepper-3D-01.jpg?v=1788042151",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "organic",
        "beet",
        "root",
        "extract",
        "400",
        "black",
        "pepper",
        "extract",
        "200",
        "veggie",
        "caps",
        "vegan",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 48,
        "manufacturing": 50,
        "safety": 62,
        "transparency": 48,
        "sustainability": 50
      },
      "price": 23.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830249705669",
      "vsf_explanation": "NusaPure Organic Beet Root uses a 20:1 extract at 400 mg per veggie capsule combined with 10 mg of 4:1 black pepper extract. The 20:1 extract ratio (400 mg extract = 8000 mg raw beetroot equivalent) is a common marketing framing but is essentially meaningless for beetroot because the bioactive of interest for cardiovascular and exercise-performance endpoints is nitrate, and nitrate is not concentrated proportionally in a 20:1 extract — the extraction ratio does not standardize to nitrate content. Every published beetroot cardiovascular or exercise trial (Lansley 2011, Wylie 2013, Bailey 2010) used nitrate-standardized beetroot juice at 5-8 mmol nitrate per serving. NusaPure does not publish a per-serving nitrate content or standardize this extract to nitrate, so the product cannot be evidence-matched to the beet nitrate literature. The 4:1 black pepper does not meaningfully enhance nitrate absorption. Honest single-ingredient framing and safe positioning; misleading extraction-ratio marketing and no nitrate standardization keep it Rejected.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-usda-organic-stinging-nettle-30-1-extract-400-mg-120-veg-caps-suitable-for-vegetarians-and-vegans-non-gmo",
      "title": "NusaPure USDA Organic Stinging Nettle 30:1 Extract, 400 mg 120 Veg Caps Suitable for Vegetarians and Vegans, Non-GMO",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-133079v2-Stinging-Nettle-3D-01.jpg?v=1788042151",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "usda",
        "organic",
        "stinging",
        "nettle",
        "extract",
        "400",
        "120",
        "veg",
        "caps",
        "suitable",
        "for",
        "vegetarians",
        "and",
        "vegans",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 48,
        "manufacturing": 50,
        "safety": 62,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 19.1,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830249672901",
      "vsf_explanation": "NusaPure Stinging Nettle uses a 30:1 organic extract at 400 mg per capsule. Stinging nettle (Urtica dioica) has two distinct evidence bases: nettle LEAF for seasonal allergy symptom relief at 300-600 mg standardized freeze-dried extract (Mittman 1990); and nettle ROOT for BPH-associated lower urinary tract symptoms at 300-600 mg standardized methanol extract twice daily (Safarinejad 2005, Ghorbanibirgani 2013). The product does not specify whether it uses leaf or root, does not standardize to a marker compound (scopoletin, sterols for root, or beta-sitosterol), and the 30:1 extraction ratio (implying 12 g raw equivalent per 400 mg dose) is not the same as the freeze-dried or methanol-standardized extracts used in trials. Without part-of-plant disclosure and marker standardization, class-level evidence does not attach. Rejected under sub_therapeutic_dose due to non-standardized preparation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-black-cherry-extract-20-1-suitable-for-vegetarian-vegan-non-gmo-150mg-250-capsules",
      "title": "NusaPure Black Cherry Extract 20:1 - Suitable for Vegetarian/Vegan, Non - GMO - 150mg 250 Capsules",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-131867v3-Black-Cherry-3D-01.jpg?v=1788042151",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "black",
        "cherry",
        "extract",
        "suitable",
        "for",
        "vegetarian",
        "vegan",
        "non",
        "gmo",
        "150mg",
        "250",
        "capsules",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 42,
        "manufacturing": 50,
        "safety": 65,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830249640133",
      "vsf_explanation": "NusaPure Black Cherry Extract is a 20:1 whole-fruit cherry extract at 150 mg per capsule. The published evidence for tart cherry (Prunus cerasus, Montmorency) — the specific variety used in trials — targets gout uric acid reduction, exercise recovery, and sleep quality using tart cherry JUICE or concentrate at 240-480 mg anthocyanin equivalent per day (Howatson 2010 for exercise recovery, Howatson 2012 for sleep, Zhang 2012 for gout). The 150 mg 20:1 extract this product delivers implies 3 g raw cherry equivalent — well below the anthocyanin loads used in trials (typically 480 mg concentrated tart cherry powder = CherryPURE dose). Additionally, black cherry (Prunus serotina) is a distinct species from Montmorency tart cherry and does not automatically share the tart cherry evidence base. The product does not specify Montmorency variety, does not standardize to anthocyanin content, and uses a sub-therapeutic dose. Rejected under sub_therapeutic_dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-apricot-20-1-extract-1000-mg-150-veggie-capsules-vegan-non-gmo",
      "title": "NusaPure Apricot 20:1 Extract, 1000 mg 150 Veggie Capsules (Vegan, Non-GMO)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-132225v3-Apricot-3D-01.jpg?v=1788042152",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "apricot",
        "extract",
        "1000",
        "150",
        "veggie",
        "capsules",
        "vegan",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 42,
        "manufacturing": 48,
        "safety": 40,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 25.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830250066117",
      "vsf_explanation": "NusaPure Apricot 20:1 Extract at 1000 mg per serving does not specify whether it is derived from apricot FRUIT (safe, minimal evidence base) or apricot KERNEL/SEED (containing amygdalin/laetrile, cyanogenic glycoside safety concern). This distinction is critical: apricot kernel-derived amygdalin/laetrile has been marketed as an alternative cancer treatment for decades despite FDA warnings and repeated case reports of cyanide poisoning from kernel or laetrile consumption (Bromley 2005 BMJ case report, Sauer 2015 case series, Konstantatos 2017). The FDA banned laetrile from interstate commerce as an unapproved cancer treatment. There is essentially no meaningful RCT evidence for apricot fruit extract supplementation delivering marketed benefits. Rejected under safety_concern for the ambiguity between fruit (low-value) and kernel (potentially cyanogenic) sourcing without disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-african-mango-10-1-extract-500-mg-per-veggie-caps-180-capsules-non-gmo-vegan",
      "title": "NusaPure African Mango 10:1 Extract, 500 mg per Veggie Caps 180 Capsules (Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nusapure-African-Mango-3D-v11-01.jpg?v=1788042152",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "african",
        "mango",
        "extract",
        "500",
        "per",
        "veggie",
        "caps",
        "180",
        "capsules",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 42,
        "sustainability": 45
      },
      "price": 25.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830249771205",
      "vsf_explanation": "NusaPure African Mango 10:1 Extract at 500 mg per capsule uses a non-branded generic Irvingia gabonensis extract. The published weight-loss evidence for African mango comes almost exclusively from studies using the IGOB131 branded extract at 150 mg twice daily (Ngondi 2005, Ngondi 2009, Oben 2008) — a specific standardized extract from a specific Cameroonian source. Concerns exist about the reproducibility of the Ngondi results: subsequent independent trials (Judd 2019, Onakpoya 2013 Cochrane-style review) have found the evidence base underpowered and single-source-dependent, and the American Society for Nutrition Journal of Nutrition raised concerns about IGOB131 study methodology. Generic 10:1 African mango extract (implying 5 g raw seed equivalent per 500 mg dose) does not automatically inherit whatever benefit IGOB131 may have and cannot be matched to any dose-response curve. Additionally, weight-loss supplements in this category are consistently overpromised and underdelivered. Rejected under sub_therapeutic_dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-dong-quai-with-angelica-sinensis-root-100mg-extract-20-1-suitable-for-vegetarian-vegan-non-gmo-2000-mg-150-capsules",
      "title": "NusaPure Dong Quai with Angelica Sinensis Root 100mg Extract 20:1 - Suitable for Vegetarian/Vegan, Non- GMO - 2000 mg - 150 Capsules",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-132955v3-DongQuai-3D-01.jpg?v=1788042151",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "dong",
        "quai",
        "with",
        "angelica",
        "sinensis",
        "root",
        "100mg",
        "extract",
        "suitable",
        "for",
        "vegetarian",
        "vegan",
        "non",
        "gmo",
        "2000",
        "150",
        "capsules",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 38,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830249738437",
      "vsf_explanation": "NusaPure Dong Quai (Angelica sinensis) at a 20:1 extract 100 mg per capsule (marketed as 2000 mg raw equivalent). Dong quai is a traditional Chinese medicine herb used for menstrual and menopausal support. The published RCT evidence is limited and largely negative: Hirata 1997 (Fertil Steril) tested dong quai 4.5 g/day vs placebo in postmenopausal women and found NO benefit for hot flashes, vaginal maturation, or endometrial thickness. Documented safety concerns are substantial: dong quai contains furanocoumarins that cause photosensitization (Yun 2015); it has anticoagulant activity that potentiates warfarin (Page 1999, Ellis 2002 documented INR increases and bleeding events); it is a uterine stimulant contraindicated in pregnancy; and it may have estrogenic activity concerning for hormone-sensitive cancer history. The combination of thin efficacy evidence and multiple documented safety concerns places it firmly in Rejected under safety_concern.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-inulin-powder-20-1-extract-300-mg-200-veg-capsules-usda-organic-suitable-for-vegetarians-vegan-non-gmo-supplement",
      "title": "NusaPure Inulin Powder 20:1 Extract, 300 mg | 200 Veg Capsules |USDA Organic Suitable for Vegetarians, Vegan, Non-GMO Supplement",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-132076v3-Organic-Inulin-3D-01.jpg?v=1788042151",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "inulin",
        "powder",
        "extract",
        "300",
        "200",
        "veg",
        "capsules",
        "usda",
        "organic",
        "suitable",
        "for",
        "vegetarians",
        "vegan",
        "non",
        "gmo",
        "supplement",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 24.8,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830249803973",
      "vsf_explanation": "NusaPure Inulin at 300 mg per capsule (marketed as 20:1 extract from organic artichoke source) is dramatically below any dose used in the prebiotic literature. Inulin is a well-studied prebiotic fiber with established fermentation and microbiome effects at 5-15 g/day (Slavin 2013 J Nutr; Meyer 2015 systematic review; Verspreet 2016). The 2018 EU health-claim authorization for inulin-type fructans and normal bowel function requires 12 g/day. NusaPure's 300 mg is one-fortieth to one-fiftieth of a functional prebiotic dose. Additionally, the '20:1 extract' framing is nonsensical for inulin because inulin is itself the concentrated bioactive — it is not an extractable marker compound but a purified fructan polymer, typically supplied as a bulk powder (chicory inulin, agave inulin). Marketing 300 mg encapsulated inulin as a prebiotic is a categorically sub-therapeutic dose regardless of extraction ratio. Rejected under sub_therapeutic_dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-artichoke-20-1-extract-600-mg-200-veggie-caps-non-gmo-gluten-free",
      "title": "NusaPure Artichoke 20:1 Extract, 600 mg 200 Veggie caps (Non-GMO, Gluten Free)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nusapure-Artichoke-Leaf-3D-v3-01.jpg?v=1788042151",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "artichoke",
        "extract",
        "600",
        "200",
        "veggie",
        "caps",
        "non",
        "gmo",
        "gluten",
        "free",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 50,
        "manufacturing": 50,
        "safety": 62,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830249869509",
      "vsf_explanation": "NusaPure Artichoke 20:1 Extract at 600 mg per two-capsule serving. Artichoke leaf extract (Cynara scolymus) has a modest but real evidence base: Holtmann 2003 tested a standardized extract at 320 mg twice daily for functional dyspepsia with symptom improvement; Bundy 2004 tested 640 mg/day for IBS symptoms in general practice with modest benefit; Englisch 2000 showed cholesterol reduction. Trials consistently used ARTICHOKE LEAF extract standardized to cynarin or caffeoylquinic acid content. NusaPure's 20:1 extract (600 mg = 12 g raw equivalent) does not specify plant part (leaf vs whole vegetable) and does not standardize to cynarin. Generic whole-plant extracts do not automatically carry the trial evidence base. Held higher in Rejected band than several other NusaPure products because the class-level evidence for artichoke leaf is genuinely reasonable — falls short mainly on standardization discipline.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-sarsaparilla-root-20-1-extract-suitable-for-vegetarian-vegan-non-gmo-150-mg-150-capsules",
      "title": "NusaPure Sarsaparilla Root 20:1 Extract - Suitable for Vegetarian/Vegan, Non - GMO - 150 mg - 150 Capsules",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-132220v3-NusaPure-Sarsaparilla-3D-01.jpg?v=1788042151",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "sarsaparilla",
        "root",
        "extract",
        "suitable",
        "for",
        "vegetarian",
        "vegan",
        "non",
        "gmo",
        "150",
        "150",
        "capsules",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 42,
        "manufacturing": 50,
        "safety": 58,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 27.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830249836741",
      "vsf_explanation": "NusaPure Sarsaparilla Root 20:1 Extract at 150 mg per capsule. Sarsaparilla (Smilax spp.) is a traditional herb with a long history of medicinal use for skin conditions, syphilis (historically), and 'blood purification.' Modern RCT evidence for supplementation is essentially absent — the literature is dominated by in vitro sarsaponin studies and traditional-use accounts. PubMed searches for Smilax clinical trials in humans return few methodologically-adequate studies of Smilax-only interventions for the marketed indications. The 150 mg 20:1 extract dose (implying 3 g raw equivalent) is also low relative to traditional use (typical tincture or decoction preparations were consumed in larger quantities). Not a safety-based rejection — sarsaparilla is generally well-tolerated. Rejected on evidence and dose grounds.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-calcium-d-glucarate-500-mg-150-veggie-caps-vegan-non-gmo-gluten-free",
      "title": "NusaPure Calcium D-Glucarate 500 mg 150 Veggie Caps, Vegan, Non-GMO, Gluten-Free",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4d6529ab.jpg?v=1788042151",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "calcium",
        "glucarate",
        "500",
        "150",
        "veggie",
        "caps",
        "vegan",
        "non",
        "gmo",
        "gluten",
        "free",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 24.47,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830249902277",
      "vsf_explanation": "NusaPure Calcium D-Glucarate at 500 mg per capsule delivers a dose within the studied range for beta-glucuronidase inhibition and estrogen/toxin conjugate clearance. Calcium D-glucarate is a natural compound found in fruits and vegetables that yields D-glucaric acid in vivo, which inhibits intestinal beta-glucuronidase and reduces enterohepatic recycling of glucuronidated compounds (estrogens, xenobiotics). Human pharmacokinetic data (Walaszek 1996) supports 1500-4500 mg/day as effective for beta-glucuronidase inhibition; some estrogen-metabolism protocols use 1-2 g/day (Heerdt 1995). NusaPure's 500 mg per capsule is within the low end of studied doses per capsule and users could reasonably scale to 3 capsules/day. Single-ingredient, honest dose disclosure, defensible mechanism. Held out of Verified by absence of third-party purity testing and no marker standardization discussion.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-high-absorption-triple-chlorophyll-1000-mg-150-veg-caps-suitable-for-vegetarians-and-vegans-non-gmo",
      "title": "NusaPure High Absorption Triple Chlorophyll 1000 mg 150 Veg Caps Suitable for Vegetarians and Vegans, Non-GMO",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Breen_Triple_Chlorophyll_a1.png?v=1788042152",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "high",
        "absorption",
        "triple",
        "chlorophyll",
        "1000",
        "150",
        "veg",
        "caps",
        "suitable",
        "for",
        "vegetarians",
        "and",
        "vegans",
        "non",
        "gmo",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 42,
        "manufacturing": 50,
        "safety": 58,
        "transparency": 38,
        "sustainability": 50
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830249935045",
      "vsf_explanation": "NusaPure Triple Chlorophyll at 1000 mg per serving uses marketing modifiers ('High Absorption,' 'Triple') without defined meanings. Chlorophyll supplements are marketed for detoxification, antioxidant, and deodorant claims but the clinical evidence base for oral chlorophyll supplementation is thin. The relevant literature is largely on chlorophyllin (semi-synthetic sodium copper chlorophyllin, not natural chlorophyll) at 100-300 mg/day for internal deodorization in ostomy or urinary incontinence contexts (Yamazaki 2012, Egner 2001), and some aflatoxin-binding data (Egner 2001). Natural leaf chlorophyll is poorly absorbed and largely degraded in the GI tract. Marketing 1000 mg of unspecified chlorophyll (natural extract vs chlorophyllin, single vs mixed source, sourced from what plant material) as 'high absorption' without disclosing the actual chemistry is opaque. Rejected on evidence and transparency grounds.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-pterostilbene-suitable-for-vegetarian-vegan-non-gmo-250mg-60-capsules",
      "title": "NusaPure Pterostilbene - Suitable for Vegetarian/Vegan, Non-GMO - 250mg - 60 Capsules",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4427c3cd.jpg?v=1788042151",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "pterostilbene",
        "suitable",
        "for",
        "vegetarian",
        "vegan",
        "non",
        "gmo",
        "250mg",
        "capsules",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 29.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830249967813",
      "vsf_explanation": "NusaPure Pterostilbene at 250 mg per capsule delivers a dose within the studied range. Pterostilbene is a dimethylated analogue of resveratrol found in blueberries, with better oral bioavailability (~80% vs ~2% for resveratrol per Kapetanovic 2011) and longer plasma half-life. The most-cited human clinical trial is Riche 2013 (Nutr Res) which tested pterostilbene at 125 mg twice daily (250 mg/day) or 50 mg twice daily for 6-8 weeks and observed reductions in LDL cholesterol, blood pressure, and body weight but ALSO an increase in total cholesterol at the higher dose. McCormack 2013 reviewed pterostilbene's mechanism (Sirt1 activation, anti-inflammatory, anti-oxidant). Pterostilbene is a defensible longevity-adjacent supplement with a small but real human dataset at exactly the 250 mg/day dose this product delivers. Held in Standard by evidence-base still being early-stage, no branded standardization discussion, and no third-party purity COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-cascara-sagrada-10-1-extract-900-mg-per-veggie-caps-180-capsules-non-gmo-vegan",
      "title": "NusaPure Cascara Sagrada 10:1 Extract, 900 mg per Veggie Caps - 180 Capsules (Non-GMO, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NSP-130860v4-Cascara-Sagrada-3D-01.jpg?v=1788042152",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "cascara",
        "sagrada",
        "extract",
        "900",
        "per",
        "veggie",
        "caps",
        "180",
        "capsules",
        "non",
        "gmo",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 48,
        "safety": 25,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 30,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830250033349",
      "vsf_explanation": "NusaPure Cascara Sagrada 10:1 Extract at 900 mg per capsule (implying 9 g raw bark equivalent) is a stimulant laxative containing hydroxyanthracene glycosides (cascarosides A-D) that hydrolyze in the colon to release anthrones stimulating intestinal motility. FDA regulatory history: in 2002 the FDA declared cascara sagrada (along with aloe latex) NOT generally recognized as safe and effective for OTC laxative use because the manufacturers failed to provide safety and effectiveness data required for continued OTC monograph status (21 CFR Part 310, 67 Fed Reg 31125). The EMA and multiple European monographs restrict cascara to short-term use (<1-2 weeks) due to concerns about melanosis coli, electrolyte disturbances, dependence, and potential (though contested) genotoxicity of hydroxyanthracenes. In 2020-2021 the EU Commission Regulation 2021/468 prohibited hydroxyanthracene derivatives in food supplements. Rejected under safety_concern.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nusapure-butterbur-extract-100mg-per-caps-200-veggie-capsules-non-gmo-vegetarian-vegan",
      "title": "NusaPure Butterbur Extract 100mg per caps 200 Veggie Capsules (Non-GMO, Vegetarian, Vegan)",
      "vendor": "NusaPure",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d950ad11.jpg?v=1788042151",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nusapure",
        "butterbur",
        "extract",
        "100mg",
        "per",
        "caps",
        "200",
        "veggie",
        "capsules",
        "non",
        "gmo",
        "vegetarian",
        "vegan",
        "nusapure"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 20,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 20.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830250000581",
      "vsf_explanation": "NusaPure Butterbur Extract at 100 mg per capsule does not disclose whether it is processed to be PA-free (pyrrolizidine alkaloid free). Butterbur (Petasites hybridus) has documented efficacy for migraine prophylaxis at 75 mg twice daily (Lipton 2004, Diener 2004) using the Petadolex branded standardized PA-free extract. However, natural butterbur contains pyrrolizidine alkaloids (petasin-adjacent PAs and other PAs) that are hepatotoxic and hepatocarcinogenic. In 2012 the German Federal Institute for Drugs and Medical Devices (BfArM) withdrew Petadolex approval after cases of butterbur-associated hepatotoxicity, and the American Academy of Neurology 2012 guideline for migraine prophylaxis subsequently removed the Level A recommendation for butterbur in a 2015 update after hepatotoxicity signals emerged. The AAN and American Headache Society jointly stated butterbur should not be recommended until manufacturers can guarantee PA-free processing. NusaPure does not specify PA-free processing, PA testing, or hepatic safety monitoring guidance. Rejected under safety_concern.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "green-superfood-energy-complex",
      "title": "Green Superfood Energy Complex",
      "vendor": "Protein Zone",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1759892965889-generated-label-image-0.jpg?v=1788042268",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "green",
        "superfood",
        "energy",
        "complex",
        "protein",
        "zone"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 38,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 28,
        "sustainability": 45
      },
      "price": 37.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830251049157",
      "vsf_explanation": "'Green Superfood Energy Complex' is sold under a generic product-descriptor title with no extractable brand identity, positioned as a greens-and-reds powder combining 'four synergistic complexes' from vegetables, fruits, roots, and herbs. Three structural failures push this into Rejected. (1) misleading_naming — no brand identity in the title means users cannot look up manufacturer, facility, or COA history. (2) Multi-complex proprietary-blend structure with no per-ingredient milligrams — 'greens complex,' 'reds complex,' etc. is a textbook opaque-label design that hides how much of each botanical is actually present. (3) 'Superfood' is a marketing term with no regulatory or scientific meaning in nutrition; and 'energy complex' framing implies stimulant-like effects that greens powders typically cannot deliver without added caffeine or B-vitamin megadoses. The category itself (greens powders) is under-evidenced — even the best-studied products (AG1, Green Vibrance) show only modest biomarker changes in industry-funded trials.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "african-mango-fusion-weight-management-metabolic-support",
      "title": "African Mango Fusion | Weight Management & Metabolic Support",
      "vendor": "Protein Zone",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1758915929764-generated-label-image-0.jpg?v=1788042268",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "african",
        "mango",
        "fusion",
        "weight",
        "management",
        "metabolic",
        "support",
        "protein",
        "zone"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 42,
        "safety": 55,
        "transparency": 28,
        "sustainability": 40
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830251081925",
      "vsf_explanation": "'African Mango Fusion' is sold under a generic product-descriptor title with no extractable brand identity, positioned for 'weight management and metabolic support' around Irvingia gabonensis (African mango) seed extract. Three compounding failures. (1) misleading_naming — no brand identity in the title, so users cannot verify manufacturer or COA history. (2) The African-mango category itself sits on very weak clinical ground: the widely-cited Ngondi 2009 trial (150 mg IGOB131 twice daily, 10 weeks) reported dramatic weight-loss effects that no independent group has replicated, and the 2013 Cochrane-adjacent review (Onakpoya) concluded 'weak methodological quality and high risk of bias — clinically relevant weight-loss effect cannot be confirmed.' (3) 'Fusion' implies a blend, and without a full quantitative Supplement Facts panel the specific extract (IGOB131 or generic Irvingia) and dose cannot be verified. The safety picture for African mango is also incomplete — mild GI effects and headaches reported in trials.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fermented-mushroom-complex-organic-7-mushroom-immunity-blend",
      "title": "Fermented Mushroom Complex | Organic 7-Mushroom Immunity Blend",
      "vendor": "Protein Zone",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1758915295908-generated-label-image-0.jpg?v=1788042273",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fermented",
        "mushroom",
        "complex",
        "organic",
        "mushroom",
        "immunity",
        "blend",
        "protein",
        "zone"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 38,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830251180229",
      "vsf_explanation": "This SKU is sold under a generic product-descriptor name ('Fermented Mushroom Complex') with no extractable brand identity in the title, no publisher/manufacturer disclosed at product-page level, and no per-mushroom milligram breakdown of the '7-mushroom immunity blend.' Three failures compound: (1) misleading_naming — Vyvata cannot list a product that carries no brand identity, because users can't research the maker, and per-lot COA lookup is impossible; (2) proprietary_blend_hides_dose — a seven-mushroom blend at unstated per-species doses is almost certainly sub-therapeutic on each individual mushroom relative to the beta-glucan doses studied (200-750 mg/day for reishi, cordyceps, chaga, etc.); (3) fermentation processing is invoked as a marketing feature but not tied to any published bioavailability data for these specific mushrooms. Rejected primarily on the naming and disclosure failures, not on the underlying mushroom category which has legitimate immune-modulation evidence at proper doses.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-lion-s-mane-mushroom-tincture-2oz",
      "title": "Organic Lion’s Mane Mushroom Tincture 2oz.",
      "vendor": "Mycoterra Farm",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Lion_s_Mane_Tincture_Outside_02.jpg?v=1788042302",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "lion",
        "mane",
        "mushroom",
        "tincture",
        "2oz",
        "mycoterra",
        "farm"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 72,
        "transparency": 55,
        "sustainability": 65
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830251409605",
      "vsf_explanation": "Mycoterra Farm is a certified-organic Massachusetts mushroom farm producing single-species Lion's Mane (Hericium erinaceus) tincture from fruit body via triple extraction (water + alcohol + heat) — the correct process to solubilize both water-soluble beta-glucans and alcohol-soluble hericenones/erinacines. Fruit-body sourcing (vs. mycelium-on-grain, which is common in cheap Lion's Mane products) is a meaningful quality signal because the erinacines associated with nerve-growth-factor stimulation are concentrated in the fruit body. Small farm-scale operation with real vertical integration. Downgrades: per-dropper hericenone/erinacine content is not quantified, per-lot certificates of analysis are not clearly published, and the human clinical evidence for Lion's Mane in cognitive endpoints is limited to a few small trials (Mori 2009 in mild cognitive impairment; Saitsu 2019 in menopausal women) with mixed replication. Standard tier for a legitimately-sourced botanical from a real farm, held back by opaque active-compound dosing and thin RCT base.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "upgraded-detox-debloat-capsules-90-ct",
      "title": "Upgraded Detox + Debloat Capsules (90 ct)",
      "vendor": "Upgraded Formulas®",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Upgraded_Detox_Debloat_4e987e25-d745-4888-9057-c7ae5a20f504.png?v=1788042416",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "upgraded",
        "detox",
        "debloat",
        "capsules",
        "upgraded",
        "formulas"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 40,
        "sustainability": 48
      },
      "price": 59.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830252458181",
      "vsf_explanation": "The 'detox' positioning is an unverified medical claim — the liver, kidneys, gut lining, lymphatic system, and skin already perform detoxification continuously in every healthy person, and no oral supplement has cleared the FDA/EMA evidentiary bar for the general-population claim of 'detoxifying the body.' Cochrane and NIH NCCIH reviews of commercial detox products have consistently concluded that human clinical evidence is absent or of poor methodological quality. Upgraded Formulas is a legitimate biohacker-adjacent brand with credible single-ingredient mineral products elsewhere in its line, but this multi-ingredient blend combines the auto-fail 'detox' claim with a proprietary-blend structure that does not disclose per-constituent milligrams for the botanicals, digestive enzymes, or debloat actives in the formula. The 'debloat' component is the more defensible half — digestive enzymes, ginger, and fennel can genuinely reduce post-prandial bloating short-term — but without per-ingredient dosing that clinical support does not attach to this specific SKU. Auto-failed on unverified_medical_claim for the 'detox' framing. Would move above Standard with a name change (drop 'detox'), full quantitative facts panel, and refocus on the digestive-enzyme/carminative science that does have real support.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "upgraded-selenium",
      "title": "Upgraded Selenium",
      "vendor": "Upgraded Formulas®",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Selenium_2oz.png?v=1788042416",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "upgraded",
        "selenium",
        "upgraded",
        "formulas"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 32.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830252490949",
      "vsf_explanation": "Single-ingredient selenium in a nano-mineral liquid delivery format from Upgraded Formulas (founder Barton Scott's biohacker-adjacent brand). Selenium itself is a legitimate essential trace mineral with well-established roles in thyroid hormone metabolism (deiodinase enzymes), glutathione peroxidase antioxidant function, and immune modulation; the Recommended Dietary Allowance is 55 mcg/day for adults and the Tolerable Upper Intake Level is 400 mcg/day. Where the product loses points: the '99.99% absorption rate' claim is marketing language without published pharmacokinetic head-to-head comparison against standard selenomethionine or selenium-enriched yeast, and 'promotes youthfulness' is a soft-wellness framing rather than a validated outcome claim. Per-drop selenium dose is disclosed in Upgraded Formulas' product literature, which keeps this out of proprietary-blend autofail territory. Manufacturing is small-brand DTC without published per-lot COAs at the SKU-page level. Safety concern: selenium has a relatively narrow therapeutic window and chronic supplementation above 200 mcg/day has been associated with adverse outcomes in some longitudinal studies (SELECT trial) — a nano-liquid format makes dose creep easier than a fixed-capsule product. Solid low-Standard tier as a targeted micronutrient for verified selenium insufficiency; not a general-population supplement without a clear rationale.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "upgraded-iodine",
      "title": "Upgraded Iodine",
      "vendor": "Upgraded Formulas®",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Iodine_4oz.png?v=1788042416",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "upgraded",
        "iodine",
        "upgraded",
        "formulas"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 52,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 37.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830252622021",
      "vsf_explanation": "Single-ingredient iodine in a nano-liquid delivery format from Upgraded Formulas. Iodine is a legitimate essential trace mineral required for thyroid hormone synthesis (T3, T4) with a Recommended Dietary Allowance of 150 mcg/day for adults and a Tolerable Upper Intake Level of 1,100 mcg/day. Where the product loses points: the claim stack ('reduces fatigue, cold sensitivity, and weight gain by improving thyroid function') implies iodine supplementation will fix subclinical hypothyroidism symptoms in the general population — a claim that only holds for people who are actually iodine-deficient. In iodine-sufficient adults (which most US adults are, thanks to iodized salt and dairy), additional iodine supplementation does not improve thyroid function and can paradoxically trigger or worsen autoimmune thyroid disease (Hashimoto's flares from iodine excess are a documented phenomenon). The 'nano' framing does not overcome the underlying issue that iodine excess in an iodine-sufficient person is not benign. Per-drop dose is disclosed, avoiding proprietary-blend autofail, but the population-level fatigue/weight-gain framing borders on unverified medical claim territory. Low-Standard tier as a targeted micronutrient for documented iodine insufficiency (pregnancy, restrictive diets, certain regions); not appropriate for undirected general-population use.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "total-longevity-upgrade",
      "title": "Total Longevity Upgrade",
      "vendor": "Upgraded Formulas®",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_4.png?v=1788042416",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "total",
        "longevity",
        "upgrade",
        "upgraded",
        "formulas"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 48,
        "sustainability": 52
      },
      "price": 69.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830252654789",
      "vsf_explanation": "Multi-ingredient '6-in-1' cellular energy, focus and longevity formula featuring liposomal NMN plus paraxanthine as headline actives, alongside additional supporting ingredients that are not fully quantified at the SKU-page level. The individual actives are legitimate: liposomal NMN has emerging pharmacokinetic support in humans (Yoshino, Trammell, and others) and paraxanthine is the primary human metabolite of caffeine with a favorable side-effect profile compared to caffeine itself in early studies (Yoo 2021, Xing 2024 small RCTs). What sinks the score: the 'longevity' framing is a strong claim that no over-the-counter supplement has cleared the FDA/EMA evidentiary bar for, the multi-ingredient combination is not disclosed with per-constituent milligrams for all six actives (proprietary-blend-adjacent structure), and there is no published RCT on this specific commercial formulation as sold. The '6-in-1 cellular energy + focus + longevity' framing packs three distinct claim territories into one SKU, none of which are individually validated for this exact combination and dose. Not autofailed outright because the individual actives are real and paraxanthine is a defensible focus/energy ingredient — but the aggregate longevity positioning and incomplete disclosure pattern place it in low-Rejected tier. Would move to Standard with full per-ingredient dose disclosure, narrower claim positioning (energy or focus, not longevity), and third-party COAs.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "upgraded-colostrum",
      "title": "Upgraded Colostrum",
      "vendor": "Upgraded Formulas®",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_Main_Image_Amazon.webp?v=1788042415",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "upgraded",
        "colostrum",
        "upgraded",
        "formulas"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 69.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830252523717",
      "vsf_explanation": "Bovine colostrum concentrate positioned around 'very high IgG levels' for skin, immunity, and gut health. Bovine colostrum is a legitimate ingredient with a moderate evidence base — IgG-standardized colostrum has published support for reducing upper-respiratory-infection incidence in athletes and preserving gut barrier function under exercise-induced permeability (Davison 2021 meta-analysis; Halasa 2017 on leaky gut and NSAID-induced permeability). Where the product loses points: the specific IgG percentage per gram is claimed as 'very high' but not disclosed as a numerical spec (typical commercial colostrum ranges from 15-40% IgG by weight and the therapeutic dose in trials is usually 20-60 g/day of colostrum providing 3-10 g/day IgG), the sourcing (grass-fed, US vs New Zealand vs European, first-milking timing) is not fully documented at the SKU-page level, and no third-party testing certificate is routinely published. The 'skin' and 'immunity' framing is defensible for the gut-barrier and URTI evidence base; the 'youthful skin' framing that Upgraded Formulas uses elsewhere in the line is softer. Low-mid Standard tier — legitimate ingredient category with acceptable single-ingredient formulation but with disclosure gaps that keep it out of the mid-60s Standard range.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "argivit-focus-30-tablet-cognitive-boost-30-tablets",
      "title": "Argivit Focus 30 Tablet - Cognitive Boost | 30 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/XfCaj1T7huyEduG8j3FEOGWtCUdJlIbIPg05vbTG_b9a05dcb-50e8-47a5-9bab-cb5c850e9689.jpg?v=1788043368",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "argivit",
        "focus",
        "tablet",
        "cognitive",
        "boost",
        "tablets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 38,
        "sustainability": 40
      },
      "price": 27.12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830267662533",
      "vsf_explanation": "Argivit Focus is a Turkish-market cognitive-support tablet combining phosphatidylserine, L-arginine, and a multivitamin/mineral base marketed for adults, students, and 'health-conscious individuals.' Two structural weaknesses drop this into Rejected. (1) The product description lists ingredient categories but does not disclose per-ingredient milligrams for the two clinically active constituents — phosphatidylserine requires 100-300 mg/day for the memory endpoints in Kingsley 2005 and Vakhapova 2010, and L-arginine's small cognitive-blood-flow signals require multi-gram doses that a single 30-day tablet regimen cannot deliver. Without disclosed milligrams the formula could be sub-therapeutic. (2) The 'Cognitive Boost' marketing pairs a vague ingredient panel with implied focus/memory benefit — a positioning Vyvata treats skeptically without dose disclosure. Held above 45 by the presence of at least one ingredient (phosphatidylserine) with a real cognitive evidence base and by the tablet's inclusion of standard B-vitamin cofactors, which are not harmful.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "now-foods-magnesium-malate-1000-mg-for-muscle-energy-180-tablets",
      "title": "Now Foods Magnesium Malate 1000 mg for Muscle Energy 180 Tablets",
      "vendor": "Now Foods",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/lFR69sGtBp5W8FjsKnSaYCYl65Zwkl95OBGzYgap.jpg?v=1788043380",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "foods",
        "magnesium",
        "malate",
        "1000",
        "for",
        "muscle",
        "energy",
        "180",
        "tablets",
        "now",
        "foods"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 72,
        "manufacturing": 78,
        "safety": 80,
        "transparency": 70,
        "sustainability": 50
      },
      "price": 64.77,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830267793605",
      "vsf_explanation": "NOW Foods Magnesium Malate delivers 1,000 mg of magnesium malate per serving (yielding ~115 mg elemental magnesium plus ~885 mg malic acid). NOW Foods is a legitimate Illinois-based manufacturer with UL, NSF-GMP, and TGA-audited facilities, publishing per-lot COAs on its corporate site — one of the strongest transparency records in the mid-market vitamin space. Malate form is well-tolerated (fewer GI effects than magnesium oxide) and the malic-acid component has small-trial evidence for fibromyalgia-related musculoskeletal complaints (Russell 1995, Abraham 1992). Downgrade: the elemental magnesium yield (~115 mg) is below the 320-420 mg RDA for adults and would require 3-4 tablets to reach a repletion dose, which increases cost per effective serving. Standard tier — honest, correctly formulated, held back from Verified by the modest elemental yield per tablet and by the tablet form (harder swallow, includes stearate excipients).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nature-made-melatonin-3-mg-tablets-100-drug-free-sleep-aid-for-adults",
      "title": "Nature Made Melatonin 3 Mg Tablets 100% Drug Free Sleep Aid For Adults",
      "vendor": "Nature Made",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/320658959.jpg?v=1788043406",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "made",
        "melatonin",
        "tablets",
        "100",
        "drug",
        "free",
        "sleep",
        "aid",
        "for",
        "adults",
        "nature",
        "made"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 65,
        "manufacturing": 78,
        "safety": 70,
        "transparency": 62,
        "sustainability": 52
      },
      "price": 6.75,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830268252357",
      "vsf_explanation": "Nature Made is the mainstream US retail supplement brand most consistently associated with USP verification — its melatonin line carries USP Verified marking, which means the tablets have been independently tested for label-vs-actual dose accuracy, purity from contaminants, and dissolution. That third-party verification is a meaningful differentiator versus the wider melatonin market where the Erland/Saxena 2017 JAMA study found dose variance from 17% below to 478% above label. The 3 mg dose is a common consumer sleep-latency dose, bracketed by published RCT evidence but not the lowest-effective dose (0.3-1 mg matches endogenous physiology better and is often equally effective with fewer residual next-day effects). Formulation is a standard tablet with modest excipient load; no proprietary-blend concerns. Manufacturing scores strongly on the USP verification and Pharmavite (Nature Made's parent) audited-facility record. Transparency is capped by the aggregate USP program rather than per-lot public COAs. Solid Standard-tier mass-retail sleep supplement — for occasional short-term sleep-onset difficulty, not chronic maintenance insomnia.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "omega-3-fish-oil",
      "title": "Omega-3 Fish Oil",
      "vendor": "Midwest Method",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1782334358046-generated-label-image-0.jpg?v=1788043528",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "omega",
        "fish",
        "oil",
        "midwest",
        "method"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 62,
        "sustainability": 45
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830269235397",
      "vsf_explanation": "Midwest Method Omega-3 Fish Oil delivers 180 mg EPA and 120 mg DHA per serving (300 mg combined EPA+DHA). The per-serving disclosure is transparent and clean, but the dose is well below evidence-based cardiovascular thresholds. The AHA (Kris-Etherton 2019) recommends 1000 mg EPA+DHA daily for cardiovascular disease prevention; secondary-prevention trials (GISSI-Prevenzione, JELIS, REDUCE-IT) used 850-4000 mg per day. The 300 mg combined this product delivers is closer to a general dietary omega-3 top-up than a cardiovascular dose. Additionally, the product does not disclose triglyceride vs ethyl ester form (rTG has better absorption per Neubronner 2011), source fish species, IFOS third-party purity certification, or oxidation state (peroxide value, TOTOX). Honest dose disclosure and generally safe positioning hold it in low Standard; the sub-therapeutic dose relative to cardiovascular trials and absence of purity certification cap the score.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "energy-powder-iq-sour-grape",
      "title": "Energy Powder IQ (Sour Grape)",
      "vendor": "Midwest Method",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1782637262669-generated-label-image-0.jpg?v=1788043529",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "energy",
        "powder",
        "sour",
        "grape",
        "midwest",
        "method"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 52,
        "transparency": 38,
        "sustainability": 50
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830269202629",
      "vsf_explanation": "Midwest Method Energy Powder IQ (Sour Grape) is an eight-ingredient nootropic-energy powder combining Alpha-GPC, natural caffeine from green tea, L-theanine, L-arginine HCl, Asian ginseng extract, inositol, black pepper extract, and a B-vitamin complex. Every one of these ingredients has an evidence-based dose: Alpha-GPC for cognitive/power output at 300-600 mg (Bellar 2015); caffeine at 100-300 mg with dose-response; L-theanine at 100-200 mg with the 2:1 caffeine:L-theanine ratio for calm-alertness (Owen 2008, Haskell 2008); Asian ginseng at 200-400 mg standardized to ginsenosides (Reay 2005); inositol at 2-18 g for anxiety/mood; L-arginine as discussed elsewhere with poor bioavailability. The per-ingredient dose disclosure is missing from the visible product description, which prevents evidence-matching for an eight-ingredient stack where each active has a real dose-response curve. Trips proprietary_blend_hides_dose. The caffeine-L-theanine base combined with Alpha-GPC is a reasonable nootropic direction if dosed correctly.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "creatine-hydration-formula",
      "title": "Creatine Hydration Formula",
      "vendor": "Midwest Method",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1782335759884-generated-label-image-0.jpg?v=1788043529",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "creatine",
        "hydration",
        "formula",
        "midwest",
        "method"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830269268165",
      "vsf_explanation": "Midwest Method Creatine Hydration Formula combines creatine monohydrate with magnesium, sodium, and potassium electrolytes in a powdered format for hydration-plus-performance positioning. Creatine monohydrate has the strongest evidence base of any sports-nutrition supplement (see Creatine Monohydrate scoring above). The electrolyte layer — sodium, potassium, magnesium — is nutritionally sensible for exercise contexts especially in hot weather or long-duration training, though the specific mg amounts per serving are not disclosed in the visible product description. The pairing is defensible: creatine draws water into muscle cells (osmotic effect) and adding electrolytes helps maintain intracellular and extracellular fluid balance. Held back from Verified by absence of per-ingredient dose disclosure, no disclosure of creatine sourcing (Creapure vs generic), and no COA. Better than a plain multi-ingredient blend because the ingredient rationale is coherent.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sleep-formula-2",
      "title": "Sleep Formula",
      "vendor": "Midwest Method",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1782444838678-generated-label-image-0.jpg?v=1788043535",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sleep",
        "formula",
        "midwest",
        "method"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 48,
        "transparency": 32,
        "sustainability": 50
      },
      "price": 22.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830269333701",
      "vsf_explanation": "Midwest Method Sleep Formula is a seven-ingredient blend containing melatonin, valerian root extract, chamomile extract, GABA, L-tryptophan, lemon balm, and passion flower. The listing enumerates the ingredients but does not disclose per-ingredient milligram doses in the product description, which is the classic proprietary-blend pattern the FDA still allows but which prevents evidence-matching. Each of the seven ingredients has its own dose-response literature (melatonin 0.3-3 mg per Zhdanova 2001; valerian 400-900 mg standardized extract; L-tryptophan 1-4 g; passion flower 500-1200 mg; chamomile 220-1100 mg standardized; GABA 100-300 mg where oral bioavailability itself is debated) and without disclosed per-ingredient doses a reviewer cannot verify whether any single component reaches its evidence-based threshold. Cumulative under-dosing across seven actives is the more likely scenario. Autofailed under proprietary_blend_hides_dose. Would become listable at Standard tier if the label disclosed per-ingredient milligrams that mapped to at least one RCT dose per active.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "beetroot",
      "title": "Beetroot",
      "vendor": "Midwest Method",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1782495109240-generated-label-image-0.jpg?v=1788043535",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beetroot",
        "midwest",
        "method"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 70,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 22.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830269432005",
      "vsf_explanation": "Midwest Method Beetroot is a single-ingredient supplement delivering 1,300 mg of organic beetroot powder per two-capsule serving. The product is honestly named, disclosed to a per-serving milligram, and made from certified-organic beetroot with a short ingredient list. The evidence for beetroot in cardiovascular and exercise-performance contexts is real but comes almost entirely from beetroot JUICE trials at doses containing 5-8 mmol of nitrate (Lansley 2011, Wylie 2013, Bailey 2009 in J Appl Physiol). Beetroot POWDER at 1,300 mg per day delivers a small fraction of that nitrate load because water-soluble nitrate concentrates in juice and dilutes in whole-root powder, and Midwest Method does not standardize to a specific nitrate content or publish a per-serving nitrate value. The product is therefore an honest and safe daily beetroot addition but is not a nitric-oxide performance dose. Scores Standard on the strength of the single-ingredient honesty and organic sourcing, held back by dose-vs-evidence mismatch and lack of nitrate standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ashwagandha-3",
      "title": "Ashwagandha",
      "vendor": "Midwest Method",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1782495378942-generated-label-image-0.jpg?v=1788043535",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ashwagandha",
        "midwest",
        "method"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830269366469",
      "vsf_explanation": "Midwest Method Ashwagandha is single-ingredient organic ashwagandha root plus organic black pepper, capsulated. The product uses generic organic ashwagandha ROOT POWDER rather than a branded standardized extract such as KSM-66 or Sensoril. This distinction matters because essentially every controlled trial showing meaningful cortisol reduction, anxiety score improvement, or testosterone uplift used a specific branded extract (Chandrasekhar 2012 used KSM-66 at 300 mg twice daily, Auddy 2008 used Sensoril at 125-250 mg, Lopresti 2019 used KSM-66 at 240 mg). Generic root powder without withanolide standardization delivers a variable and generally lower withanolide load and cannot inherit the class-level evidence from those branded-extract trials. The product also does not publish the per-capsule ashwagandha milligrams or withanolide percentage. Honest single-ingredient positioning and organic sourcing hold it in Standard tier, but the evidence-match is weak.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "complete-multivitamin-1",
      "title": "Complete Multivitamin",
      "vendor": "Midwest Method",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1782494658960-generated-label-image-0.jpg?v=1788043535",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "complete",
        "multivitamin",
        "midwest",
        "method"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830269399237",
      "vsf_explanation": "Midwest Method Complete Multivitamin combines vitamins A, C, D, E, a full B-complex, and minerals (calcium, magnesium, zinc, selenium, copper, manganese, chromium, molybdenum) with a botanical add-on layer that includes green tea extract, echinacea, spirulina, lutein, lycopene, garlic, and other herb-derived compounds. The vitamin/mineral core of a multivitamin can be scored on the strength of its forms (methylated folate vs folic acid, K2 MK-7 vs none, D3 vs D2, magnesium glycinate vs oxide) and per-nutrient percent-DV. The public description does not disclose these forms or the per-nutrient milligrams and micrograms, and the botanical add-on layer is described qualitatively rather than as a quantitative proprietary blend with per-herb doses. The combination of vitamin-form opacity plus an undisclosed herbal blend prevents an honest formulation review. Trips proprietary_blend_hides_dose on the botanical layer. Would score Standard tier if reformulated with a fully disclosed Supplement Facts panel including nutrient forms and per-herb milligrams.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lions-mane-mushroom-4",
      "title": "Lion's Mane Mushroom",
      "vendor": "Midwest Method",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1782447030921-generated-label-image-0.jpg?v=1788043536",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lion",
        "mane",
        "mushroom",
        "midwest",
        "method"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 62,
        "sustainability": 58
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830269497541",
      "vsf_explanation": "Midwest Method Lion's Mane is single-ingredient organic Hericium erinaceus using both fruiting body AND mycelium, standardized to 40% polysaccharides, delivering approximately 400 mg per capsule. The fruiting-body-plus-mycelium approach is common in mid-tier mushroom supplements; premium brands (Real Mushrooms, Nootropics Depot) generally use fruiting-body only and standardize to beta-glucans rather than total polysaccharides because total-polysaccharide standardization includes starch/dextrin from grain substrate that mycelium is grown on and inflates the marker without adding bioactive fungal content. The published cognitive-support evidence for lion's mane (Mori 2009 at 3 g/day in adults with mild cognitive impairment; Saitsu 2019 at 3.2 g/day) used fruiting-body powder at gram-scale doses. Midwest Method's per-capsule 400 mg is well below these trial doses even at a two-capsule serving. Honest single-ingredient labeling and standardization disclosure hold it in Standard tier; the polysaccharide-vs-beta-glucan choice and sub-trial dose keep it out of Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "grass-fed-hydrolyzed-collagen-peptides-unflavored",
      "title": "Grass-Fed Hydrolyzed Collagen Peptides (Unflavored)",
      "vendor": "Midwest Method",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1782446000699-generated-label-image-0.jpg?v=1788043535",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "grass",
        "fed",
        "hydrolyzed",
        "collagen",
        "peptides",
        "unflavored",
        "midwest",
        "method"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 70,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830269464773",
      "vsf_explanation": "Midwest Method Grass-Fed Hydrolyzed Collagen Peptides is an unflavored bovine-derived collagen peptide powder positioned for skin, hair, nail, and joint support. The evidence for collagen peptides is real but modest and dose-dependent. Skin-elasticity endpoints in Proksch 2014 and Bolke 2019 used 2.5-10 g/day of hydrolyzed collagen (often as Verisol or specific bioactive peptide brands); Zdzieblik 2015 used TendoForte at 5 g/day for joint pain in athletes; Clark 2008 used 10 g/day of collagen hydrolysate. Grass-fed sourcing is a marketing plus but does not change the amino-acid profile or bioactive peptide content meaningfully. The product does not specify a branded bioactive peptide (Verisol, Fortigel, TendoForte, Naticol) and does not publish a per-serving hydroxyproline content or a molecular-weight profile — both of which drive the pharmacokinetics of collagen peptide absorption. Honest positioning, real (if modest) evidence, and grass-fed sourcing hold it in mid-Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "creatine-monohydrate-unflavored",
      "title": "Creatine Monohydrate (Unflavored)",
      "vendor": "Midwest Method",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1782271099165-generated-label-image-0.jpg?v=1788043535",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "creatine",
        "monohydrate",
        "unflavored",
        "midwest",
        "method"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 68,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830269563077",
      "vsf_explanation": "Midwest Method Creatine Monohydrate is a single-ingredient unflavored creatine monohydrate powder. Creatine monohydrate has the strongest evidence base of any sports-nutrition supplement: hundreds of RCTs, multiple meta-analyses (Kreider 2017 J Int Soc Sports Nutr consensus statement, Chilibeck 2017 meta-analysis of strength adaptations, Rae 2003 for cognitive benefit), an ISSN position statement affirming safety and efficacy, and a well-established mechanism (phosphocreatine buffering of ATP resynthesis in high-intensity work). The evidence is essentially form-agnostic for monohydrate — the extensively-studied form — provided quality is at Creapure (Alz-Chem) or equivalent USP-grade micronized standard. Midwest Method does not disclose whether this is Creapure-branded creatine or generic Chinese-manufactured monohydrate, and does not publish a per-serving dose or third-party purity COA. The evidence base is essentially universal for the ingredient class, but sourcing quality (Creapure vs generic) and per-serving dose (3-5 g/day maintenance is standard) discipline are not verifiable from the public product page.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nitric-oxide-2",
      "title": "Nitric Oxide",
      "vendor": "Midwest Method",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1782447295804-generated-label-image-0.jpg?v=1788043535",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nitric",
        "oxide",
        "midwest",
        "method"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830269595845",
      "vsf_explanation": "Midwest Method Nitric Oxide combines three amino acids — L-citrulline DL-malate, L-arginine hydrochloride, and L-arginine alpha-ketoglutarate — into a capsule product without disclosing per-ingredient milligrams in the public product description. The evidence for each amino acid is dose-dependent: L-citrulline for exercise performance and BP requires 6-8 g/day (Bailey 2010, 2015); L-arginine for endothelial function and BP requires 6-30 g/day and has poor oral bioavailability (~30%) that is inferior to citrulline because ingested arginine is largely metabolized in the gut; AAKG at 4-12 g/day. Capsule delivery of any of these amino acids at trial-relevant grams typically requires 8-15 capsules per serving. Without disclosed per-ingredient milligrams, a reviewer cannot verify whether the two-capsule serving reaches even a fraction of trial doses. Trips proprietary_blend_hides_dose. Additionally, L-arginine directly is a known suboptimal choice vs L-citrulline for nitric oxide precursor supplementation because arginine is first-pass metabolized in enterocytes.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "platinum-turmeric-2",
      "title": "Platinum Turmeric",
      "vendor": "Midwest Method",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1782447235801-generated-label-image-0.jpg?v=1788043535",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "platinum",
        "turmeric",
        "midwest",
        "method"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 42,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 35,
        "sustainability": 50
      },
      "price": 22.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830269530309",
      "vsf_explanation": "Midwest Method Platinum Turmeric is a multi-ingredient joint-support blend combining turmeric root powder, glucosamine sulfate, additional turmeric forms, Boswellia extract (frankincense), piperine, and additional 'natural extracts.' The product name uses the marketing modifier 'Platinum' with no defined meaning. Per-ingredient milligrams are not disclosed in the visible product description. The turmeric-glucosamine-boswellia stack is a common joint formula pattern where every ingredient has evidence-based doses: glucosamine sulfate 1500 mg/day (Reginster 2001), boswellia extract 100-250 mg 5-Loxin or 100 mg AprèsFlex daily (Sengupta 2010, Vishal 2011), curcumin 500-1000 mg standardized as Meriva, Longvida, or C3 Complex with piperine (Panahi 2014 knee OA at 1500 mg Curcumin C3 + piperine daily). Non-standardized turmeric root powder has essentially zero curcumin bioavailability. The multi-ingredient sub-therapeutic sprinkle-in pattern combined with proprietary blend format and undefined marketing modifier ('Platinum') trips proprietary_blend_hides_dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sea-moss",
      "title": "Sea Moss",
      "vendor": "Midwest Method",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1782448286962-generated-label-image-0.jpg?v=1788043535",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sea",
        "moss",
        "midwest",
        "method"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 48,
        "manufacturing": 55,
        "safety": 42,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830269628613",
      "vsf_explanation": "Midwest Method Sea Moss combines organic Irish moss (Chondrus crispus), organic bladderwrack (Fucus vesiculosus), organic burdock root, and BioPerine (branded piperine) in capsule form. Sea moss / Irish moss achieved viral wellness-supplement status via social media claims (92 essential minerals, thyroid support, immune boost) that are not supported by clinical evidence. There is essentially no RCT evidence base for Irish moss or bladderwrack supplementation delivering the marketed benefits. Bladderwrack is meaningful specifically for iodine content (variable 50-2000 mcg per gram depending on source) which is a real safety concern: uncontrolled iodine dosing can cause both hypothyroidism and thyrotoxicosis, and Fucus-associated thyroid dysfunction cases are documented (Konno 1994, Muller 2007). Burdock is a mild traditional bitter. The BioPerine addition does not meaningfully enhance sea moss bioactives. Combining bladderwrack (iodine-loaded and thyroid-active) with undisclosed iodine content is a safety concern.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mutant-creakong-cx8-creatine-30-servings",
      "title": "Mutant Creakong CX8 Creatine, 30 servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Picture21_8ce9e634-2e0d-4a23-89e8-1766a4f6a3db.jpg?v=1788043557",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mutant",
        "creakong",
        "cx8",
        "creatine",
        "servings",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 42,
        "sustainability": 38
      },
      "price": 18.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830269825221",
      "vsf_explanation": "Mutant Creakong CX8 is a 'triple creatine' blend (creatine monohydrate + creatine malate + creatine magnesium chelate) plus added BCAAs, taurine, and additional 'creatine-supporting' amino acids delivering 4 g total creatine per scoop. Two problems drop this out of the Standard band. (1) Creatine monohydrate is the only form with robust evidence — over 500 published human trials — and the ISSN position stand explicitly notes there is no meaningful clinical advantage to malate, HCl, magnesium chelate, or 'enhanced' forms once you're already at effective monohydrate dosing (3-5 g/day). Blending three forms at 4 g total means the monohydrate share is likely below the 3 g/day maintenance threshold. (2) The exact per-form milligram breakdown of the creatine trio and the amino acid additions is not disclosed on the label as reviewed, which trips the proprietary-blend concern. Rejected for underdosed effective form + opaque split, not for safety.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-melatonin-3mg-120-nuggets",
      "title": "Solgar Melatonin 3mg 120 Nuggets",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33984019355.png?v=1788043624",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "melatonin",
        "3mg",
        "120",
        "nuggets",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 68,
        "manufacturing": 75,
        "safety": 70,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 10.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830270415045",
      "vsf_explanation": "Solgar is a decades-established US supplement brand under Nestlé Health Science with a demonstrated commitment to standardized single-ingredient formulations, disclosed doses, and controlled manufacturing (GMP-certified US facilities, kosher-parve certification, published allergen statements). The 3 mg melatonin dose is a legitimate mid-range dose — 0.3-1 mg is sufficient for chronobiotic effects and 3-5 mg is the more common consumer sleep-latency dose, both bracketed by published RCT evidence. Melatonin itself has robust meta-analytic support for reducing sleep-onset latency and modest support for jet-lag mitigation. Where Solgar loses transparency points: no independent third-party COA is routinely published per lot, and consumer-grade melatonin as a category has repeatedly been shown (Erland/Saxena 2017 JAMA) to have wide label-vs-actual dose variance across brands. Solgar sits in the better-audited quartile of that space but does not publish per-lot assay data publicly. Solid Standard-tier product for occasional sleep-onset difficulty; not a candidate for chronic use without a clinician conversation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "rhubestryn-menopause-symptom-relief-30-capsules",
      "title": "Rhubestryn Menopause Symptom Relief - 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/165-30-rhubestryn-min.webp?v=1788043700",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "postmenopausal",
      "tokens": [
        "rhubestryn",
        "menopause",
        "symptom",
        "relief",
        "capsules",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 35,
        "sustainability": 50
      },
      "price": 38.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830271168709",
      "vsf_explanation": "Rhubestryn is a low-visibility SKU whose brand-provenance trail is thin — no clearly identifiable manufacturer disclosure, no published Supplement Facts panel at the title level, and no independent third-party lab documentation. The listing describes generic menopause-symptom-relief positioning (hot flashes, mood swings, sleep) without naming the actual botanical stack, dose per constituent, or standardization. The most likely active is a rhubarb-root extract (ERr 731, marketed elsewhere as Estrovera) given the 'Rhu-' prefix — that specific extract does have moderate RCT support for vasomotor-symptom reduction, but without the manufacturer confirming it is ERr 731 at the studied 4 mg/day dose, a reviewer cannot map this product to that evidence base. Menopause symptom-relief claims combined with undisclosed dosing and thin brand provenance are exactly the pattern the transparency and misleading-naming autofail rules exist to catch. Not autofailed outright only because the underlying category (rhubarb-root ERr 731) has legitimate evidence — but the specific SKU as sold cannot be verified as delivering that active. Would need full quantitative facts panel, explicit ingredient identity (is this ERr 731?), and third-party COA to move above Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "allmax-glutamine-80-servings",
      "title": "Allmax Glutamine, 80 Servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/GLUTAMINE400GUS1018Amain.jpg?v=1788043801",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "allmax",
        "glutamine",
        "servings",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 70,
        "manufacturing": 66,
        "safety": 78,
        "transparency": 55,
        "sustainability": 40
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830272217285",
      "vsf_explanation": "Allmax Glutamine is a single-ingredient L-glutamine powder marketed for post-workout recovery, immune support, and gut lining maintenance. The 5 g per-scoop dose sits within the range studied for exercise recovery (Cordova-Martinez 2021 showed reduced muscle-damage markers at 5-10 g/day; Legault 2015 reported faster peak-torque recovery), so the formulation is honestly dosed and micronized for solubility. Allmax is a mid-tier Canadian sports-nutrition brand with a real cGMP-audited production footprint. Downgrades: independent third-party purity testing (Informed Sport, NSF Certified for Sport) is not clearly disclosed on the SKU, per-lot certificates of analysis are not linked publicly, and the mechanistic evidence for oral glutamine as a recovery ergogenic remains modest — well-fed omnivores rarely show a deficiency. Standard tier for a straightforward, correctly-dosed amino acid from a legitimate manufacturer, held back from Verified by the transparency gap.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ortho-molecular-products-hiphenolic-dietary-supplement-60-capsules",
      "title": "Ortho Molecular Products HiPhenolic Dietary Supplement 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/162-60-hiphenolic.png?v=1788043832",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ortho",
        "molecular",
        "products",
        "hiphenolic",
        "dietary",
        "supplement",
        "capsules",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 72,
        "manufacturing": 78,
        "safety": 72,
        "transparency": 60,
        "sustainability": 58
      },
      "price": 43.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830272512197",
      "vsf_explanation": "Ortho Molecular Products is a practitioner-channel brand with a solid manufacturing reputation — NSF-registered facility, published quality documentation, and clinician-verification gating that keeps it out of the mass-retail SKU-proliferation problem. HiPhenolic pairs a French-maritime-pine-bark-adjacent grape/olive polyphenolic complex with a stated aim of supporting healthy blood pressure and satiety. Individual polyphenolic constituents (procyanidins, hydroxytyrosol, oleuropein) have modest but real published RCT support for endothelial-function and post-prandial glycemia outcomes at gram-scale doses. Where the product loses points: it is disclosed as a proprietary polyphenolic complex rather than as fully quantified per-constituent milligrams, so a reviewer cannot verify that the standardized-polyphenol content in each capsule reaches the therapeutic thresholds from the underlying trials. No autofail because Ortho Molecular does disclose the aggregate polyphenol dose per capsule and the clinician-facing product literature outlines the constituent extracts, but the transparency dimension is capped by the lack of per-marker standardization percentages at the SKU-page level. Solid Standard-tier practitioner supplement — the weight-management and satiety framing is the softest part of the claim stack and rests on smaller mechanistic and short trials rather than durable outcome data.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "her-fantasy-box-fresh-clean-boric-acid-600-mg-30-suppositories-exp-04-2029",
      "title": "Her Fantasy Box Fresh & Clean Boric Acid 600 mg, 30 Suppositories, EXP 04/2029",
      "vendor": "Take It or Leave It",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/download_d6a65047-0db6-4c0a-8e89-bf4f264bb941.jpg?v=1788046722",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "her",
        "fantasy",
        "box",
        "fresh",
        "clean",
        "boric",
        "acid",
        "600",
        "suppositories",
        "exp",
        "2029",
        "take",
        "leave"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 35,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 11.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830409351365",
      "vsf_explanation": "Boric acid vaginal suppositories at 600mg are a legitimate second-line treatment for recurrent vulvovaginal candidiasis (particularly non-albicans Candida species like C. glabrata and C. krusei that are often azole-resistant) and for recurrent bacterial vaginosis unresponsive to antibiotics. The clinical evidence base is real: CDC's Sexually Transmitted Infections Treatment Guidelines list intravaginal boric acid 600mg/day for 14 days as an alternative treatment for recurrent VVC, and multiple published trials support the protocol. However, this product cannot be evaluated as a Vyvata supplement listing because it falls significantly outside the biohacking/longevity/wellness scope Vyvata covers, has serious safety implications requiring physician oversight (oral ingestion of boric acid is toxic — reported LD50 in adults is roughly 5-20g; vaginal use is safe only when not confused with oral use; pregnancy is a contraindication; the branding suggests recreational/OTC use rather than medical treatment), and the branding style (\"Her Fantasy Box Fresh & Clean\") frames a medical antifungal treatment as a cosmetic \"freshness\" product — which is exactly the class of positioning the FDA has warned against for vaginal boric acid products, as it misrepresents medical treatment as hygiene/cosmetic use and can normalize regular use of a compound that should be limited to specific clinical scenarios under physician direction. Rejected: out_of_scope_for_biohacking combined with misleading positioning as a hygiene product rather than a medical antifungal.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "macuhealth-with-micro-micelle-technology-90-softgels-exp-06-2028",
      "title": "MacuHealth with Micro-Micelle Technology, 90 Softgels, EXP 06/2028",
      "vendor": "Take It or Leave It",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/download_1703b609-d22b-4c12-8bab-4a9f5d3c9856.jpg?v=1788046722",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "macuhealth",
        "with",
        "micro",
        "micelle",
        "technology",
        "softgels",
        "exp",
        "2028",
        "take",
        "leave"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 82,
        "formulation": 78,
        "manufacturing": 74,
        "safety": 78,
        "transparency": 68,
        "sustainability": 60
      },
      "price": 64,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830409318597",
      "vsf_explanation": "MacuHealth is a specialty ophthalmology-focused supplement brand whose flagship product delivers all three macular pigment carotenoids — lutein (10mg), zeaxanthin (2mg), and meso-zeaxanthin (10mg) — in a specific formulation supported by a substantial dedicated clinical trial program. The macular carotenoid category is one of the better-evidenced supplement categories: the Age-Related Eye Disease Study (AREDS and AREDS2, sponsored by the NIH National Eye Institute) established that lutein and zeaxanthin at supplemental doses reduce progression from intermediate to advanced age-related macular degeneration. MacuHealth's distinctive contribution is the addition of meso-zeaxanthin — a rare carotenoid that is the dominant pigment in the central macula but is not present in typical diet or in most competitor formulas. The Meso-Zeaxanthin Ocular Supplementation Trial (MOST) and multiple follow-on trials led by John Nolan's group at the Waterford Institute of Technology have shown that adding meso-zeaxanthin to lutein and zeaxanthin produces greater macular pigment optical density (MPOD) increases than lutein and zeaxanthin alone. The \"Micro-Micelle Technology\" refers to a lipid-based delivery system designed to improve carotenoid bioavailability, and MacuHealth has published PK data supporting improved absorption. This is one of the more evidence-supported single-purpose supplements in retail distribution. Verified tier reflects strong single-purpose brand focus, real dedicated clinical trial program, differentiated formulation (meso-zeaxanthin inclusion), and legitimate ophthalmology practitioner-channel positioning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "horbaach-cordyceps-cs-4-strain-2000-mg-200-capsules-exp-10-2028",
      "title": "Horbaach Cordyceps CS-4 Strain 2000 mg, 200 Capsules, EXP 10/2028",
      "vendor": "Take It or Leave It",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/download_f27721c3-c3ea-4f6a-9a81-f5be780bd8cd.jpg?v=1788046727",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "horbaach",
        "cordyceps",
        "strain",
        "2000",
        "200",
        "capsules",
        "exp",
        "2028",
        "take",
        "leave"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 48,
        "manufacturing": 52,
        "safety": 62,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830409515205",
      "vsf_explanation": "Horbaach is a Long Island-based mass-market supplement house that packages a wide range of single-ingredient botanicals and vitamins at low cost. Cordyceps CS-4 refers to a specific mycelial strain of Cordyceps sinensis (the wild traditional Chinese species, distinct from Cordyceps militaris) that was isolated in China in the 1980s and is now cultivated on liquid fermentation media because wild C. sinensis harvesting is unsustainable and the species does not produce fruiting bodies in captivity. The \"2000mg per serving\" label typically references the mycelium-plus-substrate mass rather than pure fruiting body — CS-4 by definition is fermented mycelium. Compared to fruit-body cordyceps (like Mycoterra's product in this batch), CS-4 mycelial biomass has substantially different bioactive content: lower cordycepin, less clear beta-glucan profile, and higher residual polysaccharide from the fermentation broth. The product has no visible third-party assay, no standardization to specific bioactives, no disclosure of cordycepin content, and Horbaach's brand-level manufacturing QC has produced mixed results in Consumer Lab-style independent testing over the years. Rejected: while the general cordyceps use case is legitimate, the CS-4 mycelium form at commodity mass-market grade without standardization or third-party verification does not meet Vyvata's evidence-listing threshold.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "jade-dragon-cool-sinus-herbal-supplement-200-pills-exp-11-2028",
      "title": "Jade Dragon Cool Sinus Herbal Supplement 200 Pills EXP 11/2028",
      "vendor": "Take It or Leave It",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5ac7bfae-1812-4c27-a082-f72c5ba97ff7.jpg?v=1788046727",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "jade",
        "dragon",
        "cool",
        "sinus",
        "herbal",
        "supplement",
        "200",
        "pills",
        "exp",
        "2028",
        "take",
        "leave"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 42,
        "safety": 45,
        "transparency": 25,
        "sustainability": 50
      },
      "price": 23,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830409547973",
      "vsf_explanation": "Jade Dragon Cool Sinus is a Traditional Chinese Medicine (TCM) patent formula — specifically Bi Yan Wan, a classical multi-herb combination historically used in TCM practice for nasal congestion and sinus inflammation from wind-cold or wind-heat pattern presentations. The formula typically contains 12-15 herbs including Cang Er Zi (Xanthium sibiricum fruit), Xin Yi (Magnolia biondii flower bud), Bai Zhi (Angelica dahurica root), Fang Feng (Saposhnikovia divaricata root), Ju Hua (Chrysanthemum morifolium flower), and others in specific proportions. Two significant flags apply. First, the Cang Er Zi component contains sesquiterpene lactones with documented hepatotoxicity risk — multiple published case reports have linked Xanthium-containing TCM preparations to acute hepatitis, and the FDA has monitored the class. Second, TCM patent formulas as a category have persistent quality control issues in retail distribution: mainland-Chinese-manufactured tea pills have been repeatedly identified as containing undisclosed pharmaceutical adulterants (corticosteroids, NSAIDs, antihistamines), heavy metal contamination, and mislabeled ingredients. Without visible US-market third-party assay, GMP certification, and independent contamination testing, this falls into the proprietary_blend_hides_dose category — no per-herb milligrams are disclosed, safety cannot be verified. Rejected.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "amazon-elements-biotin-5000-mcg-dietary-supplement-130-capsules-exp-3-2027",
      "title": "Amazon Elements Biotin 5000 mcg Dietary Supplement, 130 Capsules EXP 3/2027",
      "vendor": "Take It or Leave It",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c096ffda-b1d7-438d-8937-9bd8084967fa.jpg?v=1788046727",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "amazon",
        "elements",
        "biotin",
        "5000",
        "mcg",
        "dietary",
        "supplement",
        "130",
        "capsules",
        "exp",
        "2027",
        "take",
        "leave"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 60,
        "manufacturing": 65,
        "safety": 55,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 4,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830409580741",
      "vsf_explanation": "Amazon Elements is Amazon's private-label supplement line, which uses a transparency program (an \"Item Element\" code links each unit to a specific manufacturing facility and lot with published ingredient sourcing information) that is genuinely better than most mass-market brands on the manufacturing-provenance dimension. Biotin (vitamin B7) at 5000mcg is a common OTC dose. The evidence issue is what biotin actually does at this dose. Biotin is genuinely essential — it functions as a coenzyme for carboxylase enzymes involved in fatty acid and amino acid metabolism, and true biotin deficiency causes hair loss, skin rash, and neurological symptoms. However, true biotin deficiency is rare in Americans (the microbiome produces meaningful biotin, and dietary intake is adequate for most people). Supplementation at 5000mcg (over 16000% of the RDA of 30mcg) has weak evidence for hair, skin, and nail improvement in non-deficient adults — the only well-controlled trial showing benefit was in patients with confirmed uncombable hair syndrome. A serious safety flag: high-dose biotin (>1000mcg/day) interferes with many immunoassay-based lab tests including troponin (heart attack detection), TSH, and hormone panels — the FDA issued a safety communication about biotin interference in 2017, and dangerous misdiagnoses have been reported. Standard tier reflecting a legitimate manufacturing-transparent B-vitamin, tempered by weak general-population efficacy evidence for cosmetic claims and real lab-test-interference safety concerns.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-niacin-500mg-dietary-supplement-120-capsules-exp-4-28",
      "title": "Nature's Bounty Niacin 500mg Dietary Supplement 120 Capsules EXP 4/28",
      "vendor": "Take It or Leave It",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e3384e7f-e1d7-4992-a70b-9e2ed793db41.jpg?v=1788046727",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "niacin",
        "500mg",
        "dietary",
        "supplement",
        "120",
        "capsules",
        "exp",
        "take",
        "leave"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 50,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 12.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830409613509",
      "vsf_explanation": "Nature's Bounty is a longstanding mass-market vitamin brand (owned by The Bountiful Company / Nestle Health Science). This specific product delivers 500mg of niacin in the form of Inositol Hexanicotinate (labeled 400mg niacin + 100mg inositol per capsule) — sometimes called \"flush-free niacin\" or \"no-flush niacin.\" This form is distinct from the two evidence-supported niacin forms used clinically: nicotinic acid (immediate-release, produces the characteristic flush, lowers LDL and raises HDL at 1-3g/day dose used in cardiovascular trials) and nicotinamide (does not flush, does not have the lipid-modifying effect, has separate evidence for skin cancer prevention at 500mg twice daily). Inositol hexanicotinate — the compound in this Nature's Bounty product — is a metabolic conjugate that in human PK studies does NOT release nicotinic acid meaningfully into circulation and does NOT produce the cardiovascular lipid-modifying effects of true niacin. This is a well-documented issue in the niacin literature: users buying \"flush-free niacin\" for cardiovascular benefit are getting a form with essentially none of the cardiovascular pharmacology of nicotinic acid. Rejected on misleading_naming — labeling a product 'Niacin' when the delivered form (inositol hexanicotinate) does not release nicotinic acid or produce niacin's characteristic effects misleads buyers seeking cardiovascular benefit.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "alfa-vitamins-alfa-369-omega-369-flax-oil-1000-mg-100-softgels-exp-04-2029",
      "title": "Alfa Vitamins ALFA 369 Omega 369 Flax Oil 1000 mg, 100 Softgels, EXP 04/2029",
      "vendor": "Take It or Leave It",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/download_89b4d21e-da10-4c8e-bddb-a7422728acc5.jpg?v=1788046728",
      "score": 47,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alfa",
        "vitamins",
        "alfa",
        "369",
        "omega",
        "369",
        "flax",
        "oil",
        "1000",
        "100",
        "softgels",
        "exp",
        "2029",
        "take",
        "leave"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 58,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 23.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830409646277",
      "vsf_explanation": "Alfa Vitamins is a Miami-based mass-market Hispanic-market-oriented vitamin brand. This product is 1000mg of flax oil in a softgel, marketed as \"Omega 3-6-9.\" The misleading_naming issue is significant: flax oil contains alpha-linolenic acid (ALA, a plant omega-3), linoleic acid (omega-6, abundant throughout the standard American diet), and modest oleic acid (omega-9, which is not an essential fatty acid). Buyers reading \"Omega 3-6-9\" from marketing that they associate with fish oil are being invited to substitute a plant ALA source for marine EPA/DHA — and the substitution does not work pharmacologically. ALA is converted to EPA and DHA at very low efficiency in humans (approximately 5% of ALA converts to EPA, less than 0.5% to DHA in typical adults; the rate is even lower in men). The EPA/DHA pharmacology that produces the cardiovascular and neurological benefits of fish oil is not meaningfully replicated by ALA supplementation. Additionally, most Americans already consume excess omega-6 from seed oils in the standard diet; adding more omega-6 via flax oil supplementation moves the omega-6:omega-3 ratio in the wrong direction. The omega-9 marketing addition is essentially cosmetic (oleic acid is not essential, is abundant in olive oil and most cooking fats, and is not something anyone needs to supplement). Rejected: this product's naming invites confusion with fish oil while delivering a fundamentally different fatty acid profile.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "horbaach-selenium-200-mcg-dietary-supplement-120-tablets-exp-5-2027",
      "title": "Horbaach Selenium 200 mcg Dietary Supplement, 120 Tablets EXP 5/2027",
      "vendor": "Take It or Leave It",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/237ad8ec-8a0c-4937-b1bc-cf9af78ea9fb.jpg?v=1788046727",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "horbaach",
        "selenium",
        "200",
        "mcg",
        "dietary",
        "supplement",
        "120",
        "tablets",
        "exp",
        "2027",
        "take",
        "leave"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46830409679045",
      "vsf_explanation": "Selenium is a well-characterized essential trace mineral required for glutathione peroxidase and thioredoxin reductase antioxidant enzyme systems, and for iodothyronine deiodinase enzymes involved in thyroid hormone metabolism. RDA is 55mcg/day for adults; typical soil selenium levels in most of North America produce dietary intake of 80-150mcg/day (Brazil nuts are extraordinary selenium sources at ~90mcg per single nut). The 200mcg dose in this Horbaach product sits below the 400mcg upper tolerable intake but above what most people already get from diet. Selenium supplementation for cardiovascular and cancer prevention was widely marketed after the Clark 1996 skin cancer prevention trial, but the SELECT trial (2011, n=35,000+) found no cancer prevention benefit for selenium alone and identified a signal for increased type 2 diabetes risk. Adequate selenium is important for thyroid health, particularly in Hashimoto's thyroiditis where 200mcg/day of selenomethionine has some published evidence for reducing thyroid peroxidase antibody titers. Horbaach's product does not specify the selenium form (selenomethionine vs. selenium yeast vs. inorganic sodium selenite — bioavailability and safety differ), and mass-market brand-level QC without visible third-party assay is a concern. Standard tier reflecting a legitimate trace mineral at a reasonable dose, tempered by ambient dietary adequacy in most users, undisclosed selenium form, and mass-market brand QC.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "axe-sledge-the-grind-eaas-bcaas-hydration",
      "title": "Axe & Sledge The Grind - EAAs + BCAAs + Hydration",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Axe-Sledge-The-Grind-EAAs-BCAAs-Hydration.jpg?v=1788061513",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "axe",
        "sledge",
        "the",
        "grind",
        "eaas",
        "bcaas",
        "hydration",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831012118725",
      "vsf_explanation": "Axe & Sledge (Seth Feroce's brand) The Grind is a stimulant-free intra- and post-workout amino-acid-and-hydration formula built around 6 g BCAAs (leucine, isoleucine, valine), a supplemental EAA blend, an electrolyte matrix, and AstraGin (Panax notoginseng plus Astragalus extract, marketed for amino-acid absorption). The 6 g BCAA dose is at the low end of published leucine-driven muscle-protein-synthesis dosing (the leucine 'threshold' for MPS stimulation is roughly 2.5-3 g leucine per feeding, which requires about 5-7 g of a 2:1:1 BCAA blend), so the dose is functionally adequate for post-workout leucine-signaling purposes. The larger evidence question is whether standalone BCAA supplementation adds anything above adequate whole-protein intake, and the current consensus (Wolfe 2017 review; ISSN 2017 position stand nuance) is that in the presence of sufficient daily protein (~1.6-2.2 g/kg for training individuals) standalone BCAA supplementation does not add measurable MPS or performance benefit — the value is convenience and low-calorie intra-workout hydration rather than an anabolic edge. EAA content is a genuine addition that BCAA-only products lack. Electrolyte matrix is a modest addition for training-session hydration. AstraGin evidence for amino-acid absorption enhancement is thin — brand-sponsored studies show modest effect, independent replication is limited. Manufacturing is in a cGMP-registered US facility, per-lot COAs available on request, no Informed Sport / NSF certification. Safety profile is high (stim-free amino acids). Would move to Standard 65+ with published Informed Sport certification and clearer positioning as convenience-hydration rather than as an MPS-driver.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "arq8™-creatine-monohydrate-gummies",
      "title": "Arq8™ Creatine Monohydrate Gummies",
      "vendor": "Arq8",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/collection-gummies.png?v=1788061520",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "arq8",
        "creatine",
        "monohydrate",
        "gummies",
        "arq8"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831012577477",
      "vsf_explanation": "Arq8 Creatine Monohydrate Gummies market a 5 g clinical dose of creatine monohydrate in gummy format using proprietary 'FullDissolve Nano-Creatine Monohydrate' technology, plus three unnamed supporting ingredients. Creatine monohydrate is the most evidence-supported ergogenic aid in the supplement category — meta-analyses (Kreider 2017, Antonio 2021) support ~5-15% strength and power improvements, muscle mass gains of 1-2 kg over 8-12 weeks at 3-5 g/day, and emerging cognitive benefits in older adults. 5 g per serving matches the standard maintenance dose. The concerns with this specific SKU: (1) gummy format is a challenging delivery for gram-scale doses — a 5 g creatine dose is a lot of gummy volume and sugar; (2) 'FullDissolve Nano-Creatine' marketing is unverified — creatine monohydrate is already water-soluble enough that 'nano' engineering claims don't add measurable value, and no independent PK study of 'nano' creatine exists; (3) three unnamed supporting ingredients constitute proprietary blend. Creatine's core evidence is strong enough to keep this in Standard tier despite formulation opacity, but 'nano' marketing and hidden supporting ingredients hold it back. Powder creatine monohydrate at 5 g/day is cheaper and more transparent.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrex-hmb-1000-120-caps",
      "title": "Nutrex HMB 1000, 120 Caps",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HMB.webp?v=1788061536",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrex",
        "hmb",
        "1000",
        "120",
        "caps",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 65,
        "safety": 70,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 10.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831013331141",
      "vsf_explanation": "Nutrex Research HMB 1000 delivers 1000 mg calcium HMB (beta-hydroxy-beta-methylbutyrate) per serving in vegetable capsules, 60 servings per bottle. HMB is a metabolite of leucine with real ingredient-level evidence for reducing exercise-induced muscle protein breakdown, supporting recovery, and preserving lean mass during caloric deficit. Meta-analyses (Wilson 2013, Rowlands 2009) show consistent modest effects on lean mass preservation particularly in untrained subjects and older adults. The classic studied protocol is 3 g/day (typically split as 3x1g), so 1000 mg per serving matches one dose of the studied 3x1g protocol. Nutrex is a real US sports-nutrition brand with mass-retail distribution. Class-level evidence and disclosure profile are Standard-tier. Held from Verified by absence of Informed Sport / NSF Sport certification and by product-level marketing being reasonable rather than exceptional. Solid entry.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "now-l-lysine-500-mg-dietary-supplement-100-tablets",
      "title": "Now L-Lysine 500 mg Dietary Supplement 100 Tablets",
      "vendor": "NOW",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NrGhZr5JTY2QWIBKNn5ez2c5GMnokY24N2HlR7NM.jpg?v=1788061542",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "lysine",
        "500",
        "dietary",
        "supplement",
        "100",
        "tablets",
        "now"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 70,
        "safety": 75,
        "transparency": 68,
        "sustainability": 58
      },
      "price": 32.83,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831013691589",
      "vsf_explanation": "NOW Foods is a well-established US supplement brand founded in 1968 with an in-house quality control program (they operate multiple ISO-certified testing labs). L-Lysine 500 mg is a single-ingredient tablet at a disclosed dose, 100-tablet supply for cost-effective long-term use. Same evidence base as the Solgar L-Lysine 1000 mg SKU scored earlier — moderate RCT evidence for HSV-1 outbreak reduction at daily doses of 1000-3000 mg (Griffith 1978, DiGiovanna 1984). 500 mg per tablet gives users granular dose control (2-6 tablets/day for typical HSV protocols). NOW's brand-level manufacturing quality is credible; NOW is one of the more commonly-cited brands in independent testing publications with generally-good labeling accuracy. Standard-tier entry — held from Verified by absence of visible USP certification on this specific SKU (NOW has USP-Verified products but not all SKUs). Solid single-ingredient basic.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-encapsulations-l-carnitine-60-capsules",
      "title": "Pure Encapsulations L-Carnitine 60 Capsules",
      "vendor": "Pure Encapsulations",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/pure_encapsulations_l_carnitine_60_kapsl_72284.jpg?v=1788061574",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "encapsulations",
        "carnitine",
        "capsules",
        "pure",
        "encapsulations"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 72,
        "manufacturing": 75,
        "safety": 72,
        "transparency": 68,
        "sustainability": 58
      },
      "price": 49.42,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831015100613",
      "vsf_explanation": "Pure Encapsulations is a premium clinical-grade supplement brand (owned by Nestlé Health Science / Atrium Innovations) with hypoallergenic formulations, no unnecessary excipients, and a research-forward positioning targeted at healthcare-practitioner distribution. L-Carnitine 60 Capsules delivers a disclosed 1360 mg L-carnitine per serving in vegetable-capsule format suitable for vegans and vegetarians. This is a substantial disclosed dose — carnitine RCTs studying exercise performance, fatty acid oxidation, and metabolic outcomes typically use 1000-2000 mg/day, so 1360 mg per serving is dose-appropriate. Ingredient category has moderate evidence: L-carnitine (as L-carnitine L-tartrate or acetyl-L-carnitine) has RCT support for cardiovascular outcomes in dialysis patients and modest evidence for exercise recovery, cognitive function in aging (ALCAR at 1500 mg), and fatigue in specific populations. Pure Encapsulations brand-level QC is at premium tier — closest to Verified without visible individual sport certification. Standard tier, approaching Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "one-a-day-women-s-multivitamin-gummies-80-count",
      "title": "One A Day Women’s Multivitamin Gummies - 80 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/188954967.jpg?v=1788061646",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "one",
        "day",
        "women",
        "multivitamin",
        "gummies",
        "count",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 65,
        "safety": 72,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 12.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831018115269",
      "vsf_explanation": "One A Day (Bayer HealthCare) is one of the most mass-market multivitamin lines in the US, with wide distribution and a decades-long manufacturing history under Bayer's consumer-health division. Women's Multivitamin Gummies delivers vitamins A, B12, B6, C, D, E, folic acid, biotin, iodine, zinc, and calcium in a gummy format specifically formulated for women, targeting bone health, immune health, skin health. Bayer's manufacturing quality is credible — parent-company pharmaceutical infrastructure supports GMP standards. Gummy format has the industry-wide labeling-accuracy concern (ConsumerLab 2017 flagged some gummy multis for under/over-labeled content) that USP verification would address; One A Day gummies are not universally USP Verified. Formulation is standard for a women's multi. Iron is not disclosed in the excerpted product copy — premenopausal women need iron in a multi (18 mg RDA), post-menopausal women should not have iron. Standard-tier entry for the mainstream women's multi category.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "super-aloe-250",
      "title": "Super Aloe 250",
      "vendor": "O Body + Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/821-100-super-aloe-250_cf659fbb-67fb-4fd1-8bb1-5c5dae43be30.webp?v=1788061658",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "super",
        "aloe",
        "250",
        "body",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 70,
        "safety": 55,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831018770629",
      "vsf_explanation": "Super Aloe 250 is Ortho Molecular's lower-dose Cape aloe stimulant laxative — 250mg per capsule versus the 450mg strength product in this same batch. Same underlying mechanism (anthraquinone glycosides metabolized by gut bacteria into peristalsis-stimulating anthrones), same short-course intended use, same chronic-use safety concerns (dependence risk, historical carcinogenicity signal for chronic high-dose aloin). The lower dose is appropriate for milder cases and for users who found the 450mg strength produced too rapid or too dramatic a response. From a formulation perspective, having two dose strengths in the product line reflects thoughtful practitioner-brand titration options — a real quality signal. All the caveats from the Super Aloe 450 entry apply here, with slightly better safety margin at the lower dose because chronic-use exposure is proportionally lower. Standard tier consistent with the higher-dose sibling product, with safety dimension marginally better due to lower daily anthraquinone exposure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fiber-mgp",
      "title": "Fiber MGP",
      "vendor": "O Body + Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/715-fiber-mgp.webp?v=1788061678",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fiber",
        "mgp",
        "body",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 68,
        "manufacturing": 74,
        "safety": 72,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831020277957",
      "vsf_explanation": "Fiber MGP is Ortho Molecular's fiber supplement delivering 11g of fiber per serving — a substantial dose that represents roughly 30-40% of the USDA daily fiber recommendation (25-38g/day depending on sex and age). The average American consumes only 15-17g of fiber daily against that recommendation, so fiber supplementation has one of the clearest population-level rationales in the entire supplement category. The \"MGP\" naming suggests a proprietary fiber blend (likely combining soluble fibers like partially hydrolyzed guar gum, resistant maltodextrin, and possibly inulin) engineered for gentle digestion and minimal gas/bloating — a real formulation problem for many fiber products where undigested oligofructose and inulin cause meaningful GI discomfort. Ortho Molecular's product page explicitly mentions gentle digestion and optimal tolerance, which reflects awareness of this issue. Standard tier at the upper end reflects strong single-purpose formulation (fiber addressing a real dietary gap) at a meaningful dose from a quality practitioner brand, held below Verified by absent per-fiber-type disclosure in retail-visible metadata.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ortho-spore-ig-90ct",
      "title": "Ortho Spore IG 90ct",
      "vendor": "O Body + Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/475-orthosporeig.webp?v=1788061678",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ortho",
        "spore",
        "90ct",
        "body",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 70,
        "manufacturing": 74,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831020310725",
      "vsf_explanation": "Ortho Spore IG combines spore-based probiotic organisms (likely Bacillus coagulans, Bacillus subtilis, and Bacillus clausii — the three most-used commercial spore-forming probiotic Bacillus species) with serum-derived bovine immunoglobulins (SBI). The product is explicitly positioned for small intestinal bacterial overgrowth (SIBO). Two distinct actives, both with real published evidence: (1) Spore-forming Bacillus probiotics survive gastric acid because of their spore coats (unlike Lactobacillus and Bifidobacterium probiotics that need enteric coating), and B. clausii specifically has documented antibacterial and immunomodulatory activity in the small bowel that has been studied in SIBO contexts. (2) Serum-derived bovine immunoglobulins (SBI, branded as IgY Max or ImmunoLin depending on source) contain concentrated IgG antibodies that bind bacterial antigens and toxins in the gut lumen — Wilson 2013 and Weinstock 2014 showed SBI reduced HIV enteropathy and IBS-D symptoms respectively. This is a coherent SIBO-adjacent formulation. Standard tier reflecting real practitioner-formulated combination on a specific clinical use case, held below Verified by absent CFU counts and immunoglobulin dose disclosure at title level and by SIBO diagnosis and treatment properly requiring physician oversight beyond OTC supplementation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "indigo-greens-powder",
      "title": "Indigo Greens Powder",
      "vendor": "O Body + Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/indigo-greens-613030.tmb-media470.png?v=1788061679",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "indigo",
        "greens",
        "powder",
        "body",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 65,
        "manufacturing": 72,
        "safety": 68,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831020376261",
      "vsf_explanation": "Indigo Greens Powder is the powdered format of the same Ortho Molecular fruit/berry/vegetable antioxidant blend as the Indigo Greens Capsules product. All the analysis from the capsule version applies — real brand quality applied to a category with modest incremental evidence over eating produce, whole foods remain the priority, greens supplements function as gap-fillers rather than replacements. The powder format has practical advantages over capsules for greens products: (1) larger per-serving dose is feasible without swallowing 6-10 capsules, (2) can be mixed into smoothies or beverages, (3) typically cheaper per gram of dried plant material than capsules. The powder format also has disadvantages: (1) taste can be off-putting for greens products with high vegetable content, (2) requires water or a mixer, (3) less portable than capsules. For a user actually intending to hit a meaningful daily dose of concentrated fruit and vegetable extracts, powder is the more practical format. Standard tier consistent with the capsule version — legitimate brand quality applied to a category with real gap-filler value and modest whole-food-replacement limits.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnesium-threonate-60ct",
      "title": "Magnesium Threonate 60ct",
      "vendor": "O Body + Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/262-60_mag_threonate-min.webp?v=1788061678",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "threonate",
        "60ct",
        "body",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 78,
        "manufacturing": 74,
        "safety": 74,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 75,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831020343493",
      "vsf_explanation": "Magnesium L-threonate — the branded ingredient Magtein, developed by Guosong Liu's group at MIT (Slutsky 2010) and licensed through AIDP — is the only magnesium form with published evidence for meaningfully crossing the blood-brain barrier and elevating cerebrospinal fluid magnesium concentration. The Slutsky 2010 rodent study and the Liu 2016 human trial (n=44, 12 weeks at 1.5-2g Magtein/day) showed improvements in cognitive function, particularly executive function and working memory, in older adults. Magnesium is a required cofactor for over 300 enzymatic reactions and a modulator of NMDA glutamate receptor activity in the brain — mechanistically it is a plausible cognitive-support intervention. Ortho Molecular's Mag Threonate delivers 2g of concentrated magnesium L-threonate per two capsules (which is the dose used in the human trial), and Ortho Molecular's practitioner-brand manufacturing quality is a real quality signal. This is one of the better single-active picks in this batch. Verified tier reflecting best-in-class magnesium form for cognitive support, delivered at the clinically-tested dose from a quality brand. Held out of Elite tier by the single-trial nature of the human evidence base and by the price premium (Magtein costs 3-5x per gram vs. other magnesium forms).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hiphenolic",
      "title": "HiPhenolic",
      "vendor": "O Body + Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/162-60-hiphenolic.webp?v=1788061684",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hiphenolic",
        "body",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 74,
        "safety": 68,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 58,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831020736709",
      "vsf_explanation": "HiPhenolic is Ortho Molecular Products' concentrated polyphenolic blood-pressure and metabolic-support formula — Ortho Molecular is a top-tier practitioner-channel supplement brand widely used in functional and integrative medicine practices, and formulation quality standards are generally excellent across their line. HiPhenolic combines several polyphenol classes typically including grape seed extract, olive leaf extract, and hibiscus (based on their published formulation history — exact current composition should be verified from the label) at concentrations targeting a documented cardiovascular effect: multiple RCTs on olive leaf extract standardized to oleuropein have shown modest systolic blood pressure reductions of 5-11 mmHg in prehypertensive adults, hibiscus at 250-500mg has similar published effects, and grape seed extract has documented endothelial function improvements. The product name signals \"high phenolic\" content, and Ortho Molecular typically publishes per-ingredient milligrams on their supplement facts panels. Standard tier reflecting a legitimate practitioner-grade formula with real polyphenol evidence base, tempered by the fact that this is a multi-ingredient blend rather than a single-active with pharmaceutical-grade evidence, and by absent third-party assay disclosure in the product-page metadata (though Ortho Molecular's internal QC standards are strong).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "indigo-greens-capsules-180ct",
      "title": "Indigo Greens Capsules 180ct",
      "vendor": "O Body + Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/indigo-greens-612180.tmb-media470.png?v=1788061684",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "indigo",
        "greens",
        "capsules",
        "180ct",
        "body",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 65,
        "manufacturing": 72,
        "safety": 68,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 72,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831020802245",
      "vsf_explanation": "Indigo Greens is Ortho Molecular's concentrated fruit/berry/vegetable antioxidant blend positioned as a phytonutrient reserve builder for adults who are not eating the USDA-recommended 5+ servings of fruits and vegetables daily. Capsulated greens products are a real category — they compress large amounts of freeze-dried plant material into a small daily dose and deliver a portion of the polyphenol, carotenoid, and phytonutrient load of eating whole produce. Ortho Molecular's manufacturing quality is a legitimate quality signal. Two structural caveats apply to the entire greens-capsule category: (1) capsule format inherently limits total dose — 180 capsules is a strong volume, but the total dried plant material per daily serving is still much less than eating actual fruits and vegetables and cannot replicate fiber content; (2) the whole-food vs. supplement debate matters here — polyphenols from whole foods appear to have superior bioavailability and health effect compared to isolated concentrated extracts in many trials. Standard tier reflecting real brand quality applied to a category with modest incremental evidence over eating produce.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "super-aloe-450",
      "title": "Super Aloe 450",
      "vendor": "O Body + Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/820-100-super-aloe-450.webp?v=1788061684",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "super",
        "aloe",
        "450",
        "body",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 70,
        "safety": 45,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 15,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831020900549",
      "vsf_explanation": "Super Aloe 450 is Ortho Molecular's concentrated Cape aloe (Aloe ferox) capsule at 450mg per dose — a stimulant laxative product with a distinctly different mechanism and safety profile than the aloe vera inner-leaf gel used in oral gut-healing formulations. Cape aloe contains anthraquinone glycosides (aloin, aloin A/B, aloeresins) that are metabolized by gut bacteria into anthrones, which stimulate intestinal peristalsis and increase water secretion into the colon lumen — producing a laxative effect within 6-12 hours. This is a real and effective mechanism for acute constipation relief and has documented pharmacological activity comparable to senna. Two significant safety flags apply: (1) chronic stimulant laxative use can cause laxative dependence (colon nerve down-regulation, cathartic colon syndrome) with long-term use over months; (2) FDA classified oral aloe anthraquinones as generally-not-recognized-as-safe in 2002 for chronic use in OTC laxative products (specifically because a rodent carcinogenicity study on aloin showed colon cancer signals — though the direct human relevance is contested and the dosing was much higher than typical human use). Ortho Molecular positions this as short-course use rather than daily maintenance, which is the appropriate framing. Standard tier: legitimate practitioner formulation with real short-course efficacy, tempered by chronic-use safety concerns.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "collagen-stick-packs",
      "title": "CollaGEN Stick Packs",
      "vendor": "O Body + Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/collagen-stick-box-333-0012da6aa30-b24e-4883-8b12-a3e552f3df54.webp?v=1788061684",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "collagen",
        "stick",
        "packs",
        "body",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 74,
        "safety": 68,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 74,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831020835013",
      "vsf_explanation": "CollaGEN is Ortho Molecular's connective-tissue support formula combining collagen peptides with amino acid cofactors and micronutrients (typically L-glutamine, L-proline, L-lysine, N-acetyl-glucosamine, and vitamin C — cofactors for endogenous collagen synthesis). Ortho Molecular's practitioner-channel formulation quality is strong, and the mechanistic pitch is coherent: hydrolyzed collagen provides the specific proline/hydroxyproline/glycine substrate, vitamin C is required for prolyl and lysyl hydroxylase activity in collagen post-translational modification, and glucosamine adds a cartilage-matrix component. The stick pack format supports flexible dosing and travel. Clinical evidence for the individual actives is real: 10-15g/day collagen peptides has moderate joint-pain and skin-elasticity evidence, vitamin C is uncontroversial cofactor territory, glucosamine has modest but real joint-symptom evidence in mild-to-moderate osteoarthritis. Standard tier reflects legitimate practitioner-grade formulation with real evidence-supported actives, tempered by absent per-active milligram disclosure in retail-visible metadata and multi-active blend structure that may not hit clinical-dose thresholds for each component.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "motility-pro®-60ct",
      "title": "Motility PRO® 60ct",
      "vendor": "O Body + Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/main_481e2b5fe9d-dab7-4edd-90ae-d68221bda1bf.tmb-media470.png?v=1788061684",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "motility",
        "pro",
        "60ct",
        "body",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 72,
        "manufacturing": 74,
        "safety": 72,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831020867781",
      "vsf_explanation": "Motility PRO is Ortho Molecular's gastric motility formula built around a patented combination of ginger (Zingiber officinale) extract and artichoke leaf extract (Cynara cardunculus) — the branded ingredient is Prodigest, a specific clinically-studied ginger/artichoke combination developed by Indena and tested in placebo-controlled trials for functional dyspepsia and delayed gastric emptying. Giacosa 2015 in a randomized double-blind placebo-controlled trial showed significant improvement in functional dyspepsia symptoms with Prodigest over four weeks. The clinical trial evidence is real, the dose in the commercial formula matches the tested dose, and the mechanism (ginger's prokinetic effect via 5-HT3 antagonism and cholinergic activation, artichoke's cynarin-mediated bile and digestive secretion) is well-characterized. Ortho Molecular's product page explicitly references \"clinically proven dose,\" which is unusual and accurate marketing language for a supplement — most brands overstate but here the reference is grounded. This is one of the better-evidenced Ortho Molecular products in this batch. Standard tier at the upper end reflects strong single-purpose formulation on a specific patented ingredient with real RCT support, held below Verified only by the multi-active blend structure and absent explicit third-party assay disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "buffered-c-90ct",
      "title": "Buffered C 90ct",
      "vendor": "O Body + Wellness",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/112090.webp?v=1788061684",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "buffered",
        "90ct",
        "body",
        "wellness"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 70,
        "manufacturing": 74,
        "safety": 74,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831020966085",
      "vsf_explanation": "Buffered C is Ortho Molecular's vitamin C capsule using calcium, magnesium, and potassium ascorbate salts rather than plain ascorbic acid — the buffered form is chosen for gastric tolerance in users who experience acid-mediated stomach upset from high-dose plain ascorbic acid. Vitamin C itself is well-characterized (see earlier MRI Vitamin C entry). The buffered format delivers the same absorbed ascorbate ion as plain ascorbic acid, with better GI tolerance at higher doses. Ortho Molecular's positioning as a practitioner-channel brand implies strong manufacturing QC — the calcium/magnesium/potassium mineral ratios in a well-formulated buffered C matter (excess calcium can crowd out magnesium absorption over time, and imbalanced ratios can create their own issues), so brand-level QC on this specific format matters more than for plain ascorbic acid. Standard tier at the upper end reflecting a legitimate practitioner-brand formulation of a well-characterized nutrient in a genuinely superior format for a subset of users (those with plain ascorbic acid intolerance).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "21st-century-one-daily-womens-50-multivitamin-multimineral-100-tablets",
      "title": "21st Century One Daily, Women's 50+, Multivitamin Multimineral, 100 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/343707449.jpg?v=1788061719",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "21st",
        "century",
        "one",
        "daily",
        "women",
        "multivitamin",
        "multimineral",
        "100",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 8.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831022670021",
      "vsf_explanation": "21st Century HealthCare is a US supplement brand focused on value-oriented mainstream formulations. Their One Daily Women's 50+ multivitamin is explicitly positioned as a store-brand equivalent to One a Day Women's 50+ (Bayer), non-GMO, gluten-free, without artificial sweeteners or flavors. For women over 50 (post-menopausal), the appropriate multi formulation is iron-free (iron accumulates and is not needed post-menstruation), calcium-forward, adequate vitamin D3 (1000-2000 IU for bone health), and adequate B12 (absorption declines with age). Whether this specific SKU hits those calibrations depends on the label (not fully visible in excerpt) — the 50+ positioning implies these adjustments are made. Standard-tier entry for a real category-appropriate product. Held from Verified by 21st Century's lower brand-level QC visibility than USP-Verified brands (Nature Made) and absence of visible individual USP mark on this SKU.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "emotional-ally-a-big-herbal-hug",
      "title": "Emotional Ally, A Big Herbal Hug",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/EMOm1_656490014715_Emotional_Ally_background_b4451096-7b74-4941-be94-e1cf8ab98e6c.jpg?v=1788061741",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "emotional",
        "ally",
        "big",
        "herbal",
        "hug",
        "wishgarden",
        "herbs"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 48,
        "sustainability": 55
      },
      "price": 12.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831023882437",
      "vsf_explanation": "WishGarden Herbs is an established Colorado-based herbal-tincture brand with public GMP certification and a long track record of single-purpose formulas. 'Emotional Ally' is marketed for 'grief, stress, sadness' — emotional-support herbal tincture with 'calming and soothing' herbs. The category is legitimate — herbal anxiolytics like lemon balm, passionflower, chamomile, and ashwagandha have real ingredient-level evidence for stress and mood support. The concern is transparency: 'artisanal blend' language without disclosed per-herb doses is proprietary_blend_hides_dose. WishGarden generally does disclose ingredient lists on physical bottles but the reviewed product copy does not commit to specific milligrams per serving. Emotional-support framing during 'grief, stress, sadness' is close to but not quite disease-claim — grief-adjacent marketing is not the same as depression treatment. Not a strong autofail but pulled into Rejected by dose opacity. A single-ingredient version of any of the individual herbs at a stated dose would score higher.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "nature-made-folic-acid-400-mcg-tablets-250-tablets",
      "title": "Nature Made Folic Acid 400 Mcg Tablets, 250 Tablets",
      "vendor": "Nature Made",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/121015551_17d640ec-c6f2-4bc3-b087-0af76ffdf255.jpg?v=1788061769",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "made",
        "folic",
        "acid",
        "400",
        "mcg",
        "tablets",
        "250",
        "tablets",
        "nature",
        "made"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 68,
        "manufacturing": 72,
        "safety": 72,
        "transparency": 68,
        "sustainability": 58
      },
      "price": 5.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831024931013",
      "vsf_explanation": "Nature Made Folic Acid 400 mcg is a single-ingredient tablet at the exact RDA-adjacent daily dose for adults, with 250-tablet supply for cost-efficient long-term use. The specific ingredient has one of the highest-evidence supplement contexts in the entire category: folic acid supplementation in women of childbearing age reduces the risk of neural tube defects (spina bifida, anencephaly) by 50-70% (MRC Vitamin Study 1991, Czeizel 1992), and CDC and USPHS guidance since 1992 has been that all women of childbearing potential take 400 mcg folic acid daily. This is one of the strongest public-health-supported supplement recommendations in medicine. Nature Made brand offers USP Verified certification on many SKUs (should be verified per-bottle). No gluten, no color additives, no artificial flavors is a clean formulation. Approaches Verified tier for the pregnancy-prevention indication. Held from Verified by absence of visible USP mark on this specific SKU listing (may be present on physical label).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "triple-anti-solution™",
      "title": "Triple Anti Solution™",
      "vendor": "EZZDAY",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/triple-anti.png?v=1788061803",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "triple",
        "anti",
        "solution",
        "ezzday"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 32,
        "sustainability": 42
      },
      "price": 39.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831026241733",
      "vsf_explanation": "EZZDAY 'Triple Anti Solution' is a 'triple-layer gummy' marketed for anti-aging, antioxidant, and inflammation support 'to outsmart aging.' The gummy structure implies three separate layers of actives targeting different mechanisms. Product copy provides zero specific ingredient information, no per-serving milligrams, no evidence citations, and no mechanism disclosure — just three trademarked benefit claims ('Anti-Aging, Antioxidant, Inflammation Support'). 'Outsmart aging' is unverified_medical_claim territory. Multi-layer gummy formulation with three trademarked but undisclosed blends is proprietary_blend_hides_dose. World's #1 branding claim is unverifiable marketing hyperbole. Aging is not a single treatable condition and no supplement 'outsmarts' it. Autofail on unverified_medical_claim.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "colon-detox-supplements",
      "title": "Colon Detox Supplements",
      "vendor": "EZZDAY",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/colon_6b976c1d-c303-4ebe-a9e8-3b5ae3157b55.png?v=1788061813",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "colon",
        "detox",
        "supplements",
        "ezzday"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 32,
        "manufacturing": 40,
        "safety": 42,
        "transparency": 30,
        "sustainability": 42
      },
      "price": 35.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831026569413",
      "vsf_explanation": "EZZDAY Colon Detox Supplements combines three trademarked proprietary blends — RenewElixir 10-in-1 herbal blend, FreshGuard odor-control complex, and a Probiotic + Prebiotic duo — marketed as a colon cleanse that 'flushes toxins' and 'refreshes your scent from the inside out.' Multiple simultaneous autofails: (1) 'colon detox' is unverified_medical_claim — the colon has continuous peristaltic clearance and does not accumulate 'toxins' that need periodic flushing; (2) three named proprietary blends triggers proprietary_blend_hides_dose; (3) the '10-in-1 herbal blend' likely includes stimulant laxatives (senna, cascara sagrada, aloe latex) which can cause dependence, electrolyte imbalance, and chronic colon damage with regular use; (4) the internal-body-odor marketing angle is a novel pseudoscientific claim without evidentiary support. Compound autofail on unverified_medical_claim.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "organic-turkey-tail-mushroom-tincture-2oz",
      "title": "Organic Turkey Tail Mushroom Tincture 2oz.",
      "vendor": "Mycoterra Farm",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Turkey_Tail_Tincture_Outside_02.jpg?v=1788061854",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "turkey",
        "tail",
        "mushroom",
        "tincture",
        "2oz",
        "mycoterra",
        "farm"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 68,
        "safety": 68,
        "transparency": 60,
        "sustainability": 72
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831030829253",
      "vsf_explanation": "Turkey tail (Trametes versicolor, Coriolus versicolor) has one of the more robust research portfolios in the medicinal mushroom space, driven by two isolated polysaccharopeptide fractions — PSK (Krestin) and PSP — that have been approved and widely used as adjuvant cancer therapy in Japan since the 1980s. PSK is the second-most-widely used oncology adjuvant in Japan for gastric, colorectal, and lung cancer supportive care, with meta-analyses showing modest survival benefit when added to chemotherapy. This is the strongest published cancer-adjuvant evidence for any medicinal mushroom fraction. The oral consumer tincture does not deliver isolated PSK/PSP at Japanese-clinical doses, but a fruit-body triple-extract does capture the beta-glucan and polysaccharopeptide fractions that underlie the pharmacology. Turkey tail is also one of the safer mushrooms — no meaningful drug interactions, minimal contraindications, well tolerated in long-term use. Mycoterra's fruit-body sourcing is again the appropriate quality signal. Standard tier reflecting the strongest evidence-base within the Mycoterra lineup for an immune-support mushroom, tempered by the tincture form not being the exact PSK/PSP isolate form studied in oncology trials.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-cordyceps-mushroom-tincture-2oz",
      "title": "Organic Cordyceps Mushroom Tincture 2oz",
      "vendor": "Mycoterra Farm",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Cordyceps_Tincture_Outside_02.jpg?v=1788061859",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "cordyceps",
        "mushroom",
        "tincture",
        "2oz",
        "mycoterra",
        "farm"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 65,
        "manufacturing": 68,
        "safety": 68,
        "transparency": 62,
        "sustainability": 72
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831031124165",
      "vsf_explanation": "Mycoterra Farm is a small-scale mushroom farm in western Massachusetts that grows and processes its own fruiting bodies — a genuine quality signal that distinguishes it from the majority of commercial mushroom supplements, which are grown as mycelium-on-grain in Chinese fermentation facilities and contain substantial residual grain starch rather than true fruiting body material. Cordyceps militaris (the cultivated species, distinct from wild Cordyceps sinensis / Ophiocordyceps sinensis) has real published evidence for modest improvements in exercise tolerance (Chen 2010, Rossi 2014 in older adults; effect sizes are small but reproducible), and for cordycepin content (a nucleoside analog with in-vitro anti-inflammatory and antiviral activity). Triple-extraction tincture (water + alcohol + heat) is a legitimate method for pulling both water-soluble beta-glucans and alcohol-soluble triterpenes/cordycepin. The 2oz bottle at typical dropper dosing is a 30-60 day supply. Standard tier reflects a genuine fruit-body product from a real US farm with legitimate extraction methodology, tempered by the fact that per-dose milligrams of active compounds (beta-glucan content, cordycepin percentage) are not standardized or published, no third-party COA for heavy metals or lot-level assay is linked, and clinical evidence for the exercise/energy claims is modest rather than definitive.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-maitake-mushroom-tincture-2oz",
      "title": "Organic Maitake Mushroom Tincture 2oz.",
      "vendor": "Mycoterra Farm",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Maitake_Tincture_Outside_02.jpg?v=1788061859",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "maitake",
        "mushroom",
        "tincture",
        "2oz",
        "mycoterra",
        "farm"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 62,
        "manufacturing": 68,
        "safety": 68,
        "transparency": 60,
        "sustainability": 72
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831031025861",
      "vsf_explanation": "Maitake (Grifola frondosa, \"hen of the woods\") has a legitimate research portfolio focused on beta-glucan-mediated immunomodulation. Its signature bioactive is the D-fraction and MD-fraction — proteoglycan-beta-glucan complexes that have been studied in Japanese and US oncology-adjuvant contexts (small trials showing NK-cell activation in cancer patients), and in metabolic contexts for modest glucose-tolerance effects. The general-population immune-support case is more suggestive than definitive: beta-glucans engage dectin-1 and complement receptor 3 on innate immune cells, but the translation to clinically meaningful outcomes in healthy adults is modest. Mycoterra's triple-extracted fruiting-body tincture is the right form for this category — it captures both the water-soluble beta-glucans (the primary immune-relevant fraction) and the alcohol-soluble triterpenes. Weakness: per-dose beta-glucan milligrams and D-fraction content are not disclosed. Standard tier reflects genuine sourcing and extraction methodology at a small US farm, tempered by modest general-population evidence and absent standardization disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-shiitake-mushroom-tincture-2oz",
      "title": "Organic Shiitake Mushroom Tincture 2oz.",
      "vendor": "Mycoterra Farm",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Shiitake_Tincture_Outside_02.jpg?v=1788061859",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "shiitake",
        "mushroom",
        "tincture",
        "2oz",
        "mycoterra",
        "farm"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 62,
        "manufacturing": 68,
        "safety": 68,
        "transparency": 58,
        "sustainability": 72
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831031091397",
      "vsf_explanation": "Shiitake (Lentinula edodes) is a widely consumed culinary mushroom with a modest but real supplement research portfolio. Its signature bioactive is lentinan, a beta-1,3-glucan with beta-1,6 branches, which has been used as an injectable adjuvant in Japanese oncology (gastric cancer supportive care) — the oral tincture form does not replicate injectable lentinan pharmacokinetics, but oral beta-glucans still engage gut-associated lymphoid tissue and produce measurable immune signaling. Shiitake also contains ergothioneine (a mitochondrial antioxidant that mammalian cells actively transport and retain), and eritadenine, a compound with modest lipid-lowering effects in animal studies. General-population supplementation evidence is thin — most human research is either injectable lentinan (not applicable to tinctures) or dietary-level shiitake consumption (whole mushrooms are cheaper and deliver more mass). Standard tier: legitimate small-farm fruit-body product, but shiitake has a weaker oral-supplement case than cordyceps, reishi, or lion's mane and per-dose bioactive standardization is not disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-chaga-mushroom-tincture-2oz",
      "title": "Organic Chaga Mushroom Tincture 2oz.",
      "vendor": "Mycoterra Farm",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Chaga_Tincture_Outside_02.jpg?v=1788061859",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "chaga",
        "mushroom",
        "tincture",
        "2oz",
        "mycoterra",
        "farm"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 62,
        "manufacturing": 68,
        "safety": 62,
        "transparency": 60,
        "sustainability": 72
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831031156933",
      "vsf_explanation": "Chaga (Inonotus obliquus) is a wild-harvested (traditionally) or cultivated sclerotial mass that grows primarily on birch trees in cold northern climates. It contains a distinctive suite of triterpenoids (inotodiol, betulinic acid derivatives, ergosterol peroxide), a very high ORAC-measured antioxidant load driven by melanin and polyphenolic compounds, and beta-glucans. In vitro and animal studies show notable antioxidant, immune-modulating, and some cancer-cell-cytotoxic activity; human trial evidence is much thinner — small trials in psoriasis (topical) and inflammatory bowel disease, no large placebo-controlled outcome trials in healthy adults. Two real caveats: chaga is very high in oxalates (contains ~14mg oxalate per gram of dried chaga in some analyses) which has been implicated in at least one case report of chaga-induced oxalate nephropathy in a chronic user with pre-existing kidney disease; and chaga's blood-thinning effect (via ergosterol peroxide and other constituents) means users on warfarin or antiplatelet drugs should avoid it. Mycoterra's fruit-body triple extraction is the appropriate methodology. Standard tier with a modest safety flag reflected in the safety dimension score.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-mega-blend-mushroom-tincture-2oz",
      "title": "Organic Mega Blend Mushroom Tincture 2oz.",
      "vendor": "Mycoterra Farm",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MegaMushroomBlendOutside02.jpg?v=1788061859",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "mega",
        "blend",
        "mushroom",
        "tincture",
        "2oz",
        "mycoterra",
        "farm"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 58,
        "manufacturing": 68,
        "safety": 68,
        "transparency": 55,
        "sustainability": 72
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831031058629",
      "vsf_explanation": "An eight-species mushroom blend combining chaga, cordyceps, lion's mane, maitake, reishi, shiitake, tremella, and turkey tail (typical composition for a mycoterra-style mega blend based on their farm species list). The pitch is broad-spectrum immune and general-wellness support drawing on complementary beta-glucan, triterpene, and polysaccharide profiles across species. The single strongest argument for a multi-species blend is that beta-glucan structural diversity may engage a broader repertoire of pattern recognition receptors than any single species alone. The strongest argument against is that per-species dose necessarily drops as the number of species increases — an eight-way split of a fixed extraction volume delivers 1/8 of the species-specific bioactive load compared to a single-species tincture of the same volume. Mycoterra's fruit-body triple-extraction sourcing remains a genuine quality signal for a category (blended mushroom products) where competitors frequently use mycelium-on-grain. Standard tier reflects real sourcing quality offset by the dilution problem inherent to multi-species blending and absence of per-species standardization disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-trifecta-blend-mushroom-tincture-2oz",
      "title": "Organic Trifecta Blend Mushroom Tincture 2oz.",
      "vendor": "Mycoterra Farm",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Trifecta_Tincture_Outside_02.jpg?v=1788061859",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "trifecta",
        "blend",
        "mushroom",
        "tincture",
        "2oz",
        "mycoterra",
        "farm"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 65,
        "manufacturing": 68,
        "safety": 68,
        "transparency": 60,
        "sustainability": 72
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831031189701",
      "vsf_explanation": "The Trifecta Blend combines lion's mane (Hericium erinaceus), chaga (Inonotus obliquus), and reishi (Ganoderma lucidum) — a well-chosen three-species combination that covers cognitive/nerve-support (lion's mane hericenones and erinacines are the most-cited stimulators of nerve growth factor synthesis), antioxidant/general-tonic (chaga's triterpenoid and melanin profile), and adaptogenic/immune modulation (reishi's ganoderic acid triterpenes and beta-glucans). This is a more targeted combination than the eight-species Mega Blend and delivers a more meaningful per-species dose because the split is three-way rather than eight-way. Lion's mane specifically has the most interesting recent literature (Mori 2009 in mild cognitive impairment showed cognitive score improvement; Nagano 2010 showed subjective mood improvement in perimenopausal women), and reishi has a substantial body of adaptogen and sleep-quality evidence. Standard tier reflecting good species selection, appropriate fruit-body triple-extraction methodology, and coherent formulation logic, tempered by lack of per-species standardization disclosure and the absence of published beta-glucan or hericenone content.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "trace-mineral-complex",
      "title": "Trace Mineral Complex",
      "vendor": "Anderson Health Solutions",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Trace-Mineral-Complex-4-oz-PDP-2026.jpg?v=1788062104",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "trace",
        "mineral",
        "complex",
        "anderson",
        "health",
        "solutions"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 42,
        "sustainability": 55
      },
      "price": 14.16,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831045673157",
      "vsf_explanation": "Anderson Health Solutions Trace Mineral Complex derives from Great Salt Lake water in Utah, marketed as 'full-spectrum blend of trace minerals... expertly crafted to support your body's essential functions.' Great Salt Lake water is a real source of dissolved minerals including magnesium, potassium, calcium, and trace elements (chromium, selenium, zinc, and others at variable concentrations). The problem is dose transparency — 'full spectrum' framing does not commit to specific per-serving milligrams for any mineral, and dose ranges required for meaningful supplementation vary widely by mineral (chromium at 200 mcg, selenium at 100 mcg, magnesium at 200-400 mg, zinc at 15-30 mg). Without disclosed per-mineral dose it is impossible to verify whether the product delivers meaningful amounts of anything. Some trace mineral products deliver essentially cosmetic amounts. Great Salt Lake water also contains sodium in high concentrations — sodium content should be disclosed for users on low-sodium diets. Proprietary_blend_hides_dose applies. Middling scores reflect that the source ingredient category is legitimate; the specific formulation opacity is not.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "usda-organic-moringa-capsules-120-ct",
      "title": "USDA Organic Moringa Capsules (120 Ct.)",
      "vendor": "Pura Vida Moringa",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/moringa-capsules-pura-vida-500mg-120-capsules-3201426.jpg?v=1788062110",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "usda",
        "organic",
        "moringa",
        "capsules",
        "120",
        "pura",
        "vida",
        "moringa"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 52,
        "sustainability": 62
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831045902533",
      "vsf_explanation": "Pura Vida Moringa produces single-ingredient USDA Organic moringa capsules. Single-ingredient formulation is a formulation positive — no proprietary blend, no unrelated actives to obscure dose. Moringa oleifera has moderate ingredient-level evidence: small RCTs (Kumari 2010, Anthanont 2016, Leone 2018) show modest improvements in fasting glucose and lipid markers at daily doses of 4-8 g leaf powder. It is nutrient-dense as a food — modestly high in vitamin A, vitamin C, calcium, and protein per gram. USDA Organic certification is a meaningful quality signal, particularly for herbs where pesticide residue is a real concern in conventional supply chains. Per-capsule dose is not visible in the reviewed excerpt; if a 120-capsule bottle at typical serving of 2-4 capsules/day delivers 1-2 g moringa per serving, that is at the low end of studied dose range and users chasing the metabolic evidence typically need higher intake than capsule format allows. Standard-tier entry — clean single-ingredient formulation with real ingredient evidence, held from Verified by capsule-format dose ceiling.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-omega-3-fish-oil-concentrate-120-softgels",
      "title": "Solgar Omega-3 Fish Oil Concentrate 120 Softgels",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33984017887.jpg?v=1788062138",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "omega",
        "fish",
        "oil",
        "concentrate",
        "120",
        "softgels",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 68,
        "manufacturing": 72,
        "safety": 75,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 17.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831047409861",
      "vsf_explanation": "Solgar Omega-3 Fish Oil Concentrate is a concentrated EPA/DHA product from deep-sea cold-water fish, molecularly distilled to remove mercury and other contaminants. The molecular-distillation step is a critical formulation disclosure — bulk fish oil supply chain has documented mercury and PCB contamination risk (Consumer Reports 2003, Clean Label Project 2018), and molecular distillation is the standard purification step that removes these. Omega-3 EPA/DHA has one of the largest evidence bases in the supplement category: cardiovascular outcomes at high dose (REDUCE-IT 2019 with 4 g/day icosapent ethyl, though this is a prescription form), triglyceride reduction, and pregnancy/development support are well-established. General-population cardiovascular event reduction at supplement doses (1-2 g/day) is more contested (VITAL 2019 was largely null). Solgar's typical per-softgel EPA+DHA content (visible on label) determines the achievable daily dose. Standard-tier entry with real evidence base and credible manufacturing. Held from Verified by no visible IFOS certification (International Fish Oil Standards, the third-party fish-oil quality benchmark).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-l-lysine-1000-mg-100-tablets",
      "title": "Solgar L-Lysine 1000 mg 100 Tablets",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33984017016.jpg?v=1788062159",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "lysine",
        "1000",
        "100",
        "tablets",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 68,
        "manufacturing": 72,
        "safety": 75,
        "transparency": 68,
        "sustainability": 58
      },
      "price": 15.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831048196293",
      "vsf_explanation": "Solgar is a well-established US supplement brand with a public quality-control program (Gold Standard testing, published COAs on some SKUs) and a long track record in single-ingredient supplements. L-Lysine 1000 mg is a single-ingredient tablet at a disclosed dose — the exact profile Vyvata prefers for evaluability. Lysine has moderate evidence for reducing HSV-1 outbreak frequency and severity at doses of 1000-3000 mg/day (Griffith 1978, DiGiovanna 1984); the mechanism is competition with arginine for viral replication substrate. Also used in collagen synthesis, calcium absorption support, and general amino-acid replenishment. 1000 mg is at the low end of studied dose range for HSV — users chasing that outcome typically take 2-3 tablets/day, with some clinicians recommending higher acute doses during outbreak prodrome. Safety profile is favorable at these doses; caution with renal disease. Solid Standard entry — held from Verified by no visible USP or NSF verification on this SKU (Solgar does not universally carry those certifications despite in-house testing).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nad-nmn-cellular-vitality-organic-formula-with-resveratrol",
      "title": "NAD+ & NMN Cellular Vitality Organic Formula with Resveratrol",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Green_Eyes.png?v=1788062218",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nad",
        "nmn",
        "cellular",
        "vitality",
        "organic",
        "formula",
        "with",
        "resveratrol",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 48,
        "manufacturing": 48,
        "safety": 55,
        "transparency": 42,
        "sustainability": 48
      },
      "price": 29.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831050850501",
      "vsf_explanation": "VeggieVerve/Livingston Naturals NAD+/NMN with resveratrol formulation targets the fastest-growing supplement segment (longevity_cellular). The ingredient category has real emerging RCT evidence: NMN at 250-500 mg/day (Yoshino 2021 crossover, Yamane 2023) has demonstrated modest increases in serum NAD+ levels, and Tru Niagen's nicotinamide riboside has larger trials (Martens 2018, Airhart 2017) with similar findings. Resveratrol has extensive but mostly-underwhelming trials at 100-500 mg/day. The problem with this specific SKU is transparency — the reviewed product copy references NMN and resveratrol but does not disclose per-serving milligram content for either, meaning a reviewer cannot verify whether the formula delivers doses matching the Yoshino/Yamane trial ranges or subclinical amounts. NAD+ precursor products in general have been shown by third-party testing (ConsumerLab 2022) to sometimes contain far less NMN than labeled — some products tested at 30-50% of claimed content. Without disclosed doses and without third-party lot testing, autofail on proprietary_blend_hides_dose applies. The category is legitimate; the specific SKU disclosure is insufficient.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "miracle-of-amazon-herbal-liquid-blend",
      "title": "Miracle of Amazon Herbal Liquid Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/miracle-of-amazon-product-square.png?v=1788062244",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "miracle",
        "amazon",
        "herbal",
        "liquid",
        "blend",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 42,
        "manufacturing": 45,
        "safety": 52,
        "transparency": 42,
        "sustainability": 50
      },
      "price": 29.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831051800773",
      "vsf_explanation": "VeggieVerve/Livingston Naturals 'Miracle of Amazon' concentrated herbal liquid featuring Amazonian botanicals (likely including guarana, catuaba, muira puama, chuchuhuasi, or similar traditional South American energy herbs) marketed for 'energy, alertness, vitality, everyday wellness.' Product-name 'miracle' language is a marketing red flag. Amazonian ethnobotany contains many real botanicals with traditional-use history, but few have controlled clinical trials at defined doses. Guarana has evidence for caffeine-based alertness effects (proportional to caffeine content). Muira puama and catuaba have very limited modern RCT evidence for the vitality/libido claims traditionally associated with them. Multi-herb blend at undisclosed doses = proprietary_blend_hides_dose. 'Miracle' framing is unverified_medical_claim territory. Middling safety score because most Amazonian traditional-use ingredients have relatively low acute-toxicity profiles at typical tincture doses.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-plant-based-kidney-cleanse",
      "title": "Organic, plant-based Kidney Cleanse",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/organic-plant-based-kidney-cleanse-405978.jpg?v=1788062248",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "plant",
        "based",
        "kidney",
        "cleanse",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 35,
        "manufacturing": 42,
        "safety": 45,
        "transparency": 40,
        "sustainability": 48
      },
      "price": 29.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831053111493",
      "vsf_explanation": "VeggieVerve/Livingston Naturals 'Kidney Cleanse' is textbook autofail territory. Kidneys perform continuous filtration and homeostatic ion regulation in every healthy person and do not require or benefit from oral 'cleansing.' The 'cleanse' framing is an unverified medical claim under FDA and Cochrane review standards — no oral supplement has established evidence for enhancing kidney filtration beyond baseline. For users with actual kidney disease (chronic kidney disease, glomerulonephritis, kidney stones), the concern is inverted: many herbal ingredients marketed as 'kidney-supportive' can worsen kidney function or interact with medications that CKD patients take. Ingredients commonly used in this class (parsley root, uva ursi, juniper, dandelion) are diuretics — they change urine output without changing filtration quality — and can cause electrolyte imbalance in kidney-compromised patients. Autofail on unverified_medical_claim, with real safety implications for the population that would be attracted to a 'kidney cleanse.'",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "natural-herpes-immune-support-formula-by-livingston-naturals",
      "title": "Natural Herpes Immune Support Formula –  by Livingston Naturals",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Natural_Herpes_Immune_Support_Formula_16_fl_oz_by_Livingston_Naturals.jpg?v=1788062248",
      "score": 28,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "natural",
        "herpes",
        "immune",
        "support",
        "formula",
        "livingston",
        "naturals",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 22,
        "manufacturing": 35,
        "safety": 25,
        "transparency": 30,
        "sustainability": 40
      },
      "price": 49.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831053177029",
      "vsf_explanation": "VeggieVerve/Livingston Naturals 'Natural Herpes Immune Support Formula' is one of the most severe autofail cases in this batch. First, herpes (HSV-1, HSV-2, VZV/shingles) is a diagnosed viral infection — naming a supplement after a specific disease and marketing it for 'cold sores, shingles, viral immunity' is textbook unverified_disease_claim, an FDA warning-letter category that supplement brands are repeatedly cited for. Second, the disclosed dose is dangerous: '35,000 mg vitamin C' translates to 35 grams — more than 500x the RDA of 65-90 mg and roughly 20x the tolerable upper limit of 2000 mg/day. At 35 g/day, vitamin C causes severe osmotic diarrhea, kidney stones in oxalate-prone individuals, iron overload in hemochromatosis, and possible interference with chemotherapy. This is not a formulation choice, it is a safety_concern. Third, self-treating herpes with an OTC supplement delays evidence-based antiviral treatment (acyclovir, valacyclovir, famciclovir) that meaningfully reduces outbreak duration and transmission risk. Compound autofails: unverified_disease_claim + safety_concern (megadose vitamin C).",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "organic-moringa-soursop-liquid-immune-detox-cell-support",
      "title": "Organic Moringa + Soursop Liquid – Immune, Detox & Cell Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Moringa_Soursop_Liquid_Formula_25_Herbs_for_Total_Wellness.png?v=1788062249",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "moringa",
        "soursop",
        "liquid",
        "immune",
        "detox",
        "cell",
        "support",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 30,
        "manufacturing": 40,
        "safety": 32,
        "transparency": 40,
        "sustainability": 48
      },
      "price": 29.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831053242565",
      "vsf_explanation": "VeggieVerve moringa + soursop liquid combines two autofail-triggering concerns. First, 'detox' is unverified_medical_claim (see Kidney Cleanse rationale above). Second, soursop (Annona muricata) contains annonacin, a mitochondrial complex I inhibitor associated with atypical parkinsonism in chronic-consumption epidemiological studies from Guadeloupe (Caparros-Lefebvre 1999, 2002). A daily liquid tincture built around soursop as a lead ingredient is exactly the chronic-exposure pattern the safety literature warns against. Moringa has moderate ingredient-level evidence for glycemic and lipid markers at 4-8 g/day whole-leaf equivalent, but combining it with soursop in a marketed 'detox' formulation forfeits any positive score. Autofail on unverified_medical_claim (detox) + safety_concern (chronic soursop).",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "organic-herbal-bone-joint-support",
      "title": "Organic Herbal Bone & Joint Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Bones2.jpg?v=1788062248",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "herbal",
        "bone",
        "joint",
        "support",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 45,
        "manufacturing": 48,
        "safety": 55,
        "transparency": 45,
        "sustainability": 52
      },
      "price": 29.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831053308101",
      "vsf_explanation": "VeggieVerve/Livingston Naturals 'Organic Herbal Bone & Joint Support' with vitamin D3 combines plant-based minerals, herbal extracts, and D3 as a liquid formulation. Bone and joint support is a defensible category with real ingredient-level evidence — vitamin D3 at 1000-4000 IU has RCT support for bone health, calcium (from food ideally) is foundational, vitamin K2 has RCT support for bone density in older adults, and collagen at 5-10 g/day has moderate joint-comfort evidence. Herbal additions (turmeric, boswellia) have moderate joint-comfort evidence. The concern with this specific SKU is opacity: 'plant-based minerals' as a formula descriptor is vague, per-herb and per-mineral doses are not disclosed in the reviewed metadata, and the liquid format constrains achievable per-serving mineral doses. Multi-herb blend at undisclosed doses = proprietary_blend_hides_dose. Vitamin D3 disclosure alone is not enough. Middling scores reflect that the ingredient category is legitimate; the specific execution is not verifiable.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-inflammation-formula-by-livingston-naturals-natural-herbal-labs",
      "title": "Organic Inflammation Formula by  Livingston Naturals, Natural Herbal Labs",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/organic-inflammation-formula-by-livingston-naturals-natural-herbal-labs-16-fl-oz-375542.png?v=1788062249",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "inflammation"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "inflammation",
        "formula",
        "livingston",
        "naturals",
        "natural",
        "herbal",
        "labs",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 42,
        "manufacturing": 45,
        "safety": 48,
        "transparency": 45,
        "sustainability": 52
      },
      "price": 29.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831053340869",
      "vsf_explanation": "VeggieVerve/Livingston Naturals 'Inflammation Formula' is a multi-herb liquid tincture with turmeric named as a lead ingredient. Turmeric/curcumin has one of the strongest evidence bases among anti-inflammatory botanicals — Daily 2016 meta-analysis of 8 RCTs found curcumin extracts at 1000-2000 mg/day reduced OA pain scores comparably to low-dose NSAIDs, and Hewlings 2017 reviewed inflammatory-marker reduction across multiple studies. That evidence is for standardized curcumin extracts (typically 95% curcuminoids) at gram-scale doses, not for whole turmeric root at undisclosed concentrations in a multi-herb tincture. The multi-herb 'inflammation' format also creates ambiguity — inflammation is not a single unified process, and marketing anti-inflammatory blends for undefined 'inflammation' is a mismatch with the granular immune biology (acute vs chronic, local vs systemic, cytokine-specific patterns). Autofail on proprietary_blend_hides_dose given the multi-herb formulation without per-ingredient doses. A single-ingredient standardized curcumin extract at a stated dose would score meaningfully higher.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "pure-batana-oil-paste",
      "title": "Pure Batana Oil Paste",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/call_ktUfDO6fAqfPEKN3uye2JGPb.png?v=1788062249",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "batana",
        "oil",
        "paste",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831053471941",
      "vsf_explanation": "VeggieVerve/Livingston Naturals Batana Oil Paste is a topical hair-and-scalp product from Elaeis oleifera nut oil, marketed for hair restoration, moisture, and shine. Batana oil has traditional Honduran use as a hair-care ingredient, and its high oleic acid + tocotrienol content is consistent with the general emollient-for-dry-hair mechanism seen with other plant oils (coconut, argan, jojoba). Peer-reviewed clinical evidence for batana specifically is essentially absent — it does not have RCTs comparable to minoxidil for hair regrowth, nor even comparable to argan oil for skin/hair care outcomes. Marketing implications of 'ancient hair secret' and 'restored hair' are aspirational rather than evidenced. More structurally: this is a topical product, which places it outside Vyvata's biohacking/supplement scope. The rubric autofail 'out_of_scope_for_biohacking' applies to topical-only cosmetic products since Vyvata is oriented toward ingestible interventions with systemic biological effect. Middling safety score reflects that batana oil is a low-risk plant oil (no acute toxicity signals); this is not a listable category on Vyvata regardless of the product's cosmetic merits.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "organic-herbal-liquid-blood-parasite-cleanse",
      "title": "Organic Herbal Liquid Blood & Parasite Cleanse",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Organic_Herbal_Liquid_Blood_Parasite.png?v=1788062249",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "herbal",
        "liquid",
        "blood",
        "parasite",
        "cleanse",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 28,
        "manufacturing": 35,
        "safety": 35,
        "transparency": 32,
        "sustainability": 42
      },
      "price": 30.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831053406405",
      "vsf_explanation": "'Blood & Parasite Cleanse' is one of the most extreme autofail patterns in the supplement category. First, 'parasite cleanse' marketing to a general population is functionally unverified_disease_claim — parasitic infections (giardia, cryptosporidium, tapeworm, roundworm, etc.) are diagnosed by stool ova-and-parasites testing or blood serology and treated with specific antiparasitic drugs (metronidazole, albendazole, ivermectin, praziquantel) targeted to the confirmed organism. General-population 'parasite cleanses' targeted at 'toxins' and 'flare-ups' are not medically coherent. Second, 'blood cleanse' has no physiological correlate — the kidneys and liver continuously clear blood metabolites in every healthy person; there is nothing to 'cleanse.' Third, the marketing framing ('reclaim your vitality... eliminate harmful parasites... restore total body balance') is textbook cleanse-scare marketing that convinces healthy users they have a hidden problem needing an expensive product. Compound autofail on unverified_medical_claim + unverified_disease_claim. This is one of the strongest rejections possible.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "lung-breathing-cleanse-organic-herbal-respiratory-support-tonic",
      "title": "Lung & Breathing Cleanse – Organic Herbal Respiratory Support Tonic",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Lung_and_breathing_Cleanse.jpg?v=1788062248",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lung",
        "breathing",
        "cleanse",
        "organic",
        "herbal",
        "respiratory",
        "support",
        "tonic",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 48,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 29.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831053504709",
      "vsf_explanation": "VeggieVerve/Livingston Naturals 'Lung & Breathing Cleanse' liquid formula with mullein, nettle, white horehound, osha root, elecampane, peppermint, eucalyptus, turmeric, black seed, and vitamin C. Two problems. First, 'lung cleanse' is unverified_medical_claim — the lungs have mucociliary clearance mechanisms that continuously clear inhaled particles in every healthy person, and there is no oral supplement that meaningfully 'cleanses' the lungs. Real respiratory conditions (COPD, asthma, bronchitis, pneumonia, ILD) are diagnosed by pulmonology workup and treated with evidence-based medications. Substituting an herbal tincture delays treatment. Second, some individual ingredients have modest traditional-use evidence for cough/cold symptomatic relief (mullein, peppermint, eucalyptus have soothing effects), but osha root has documented liver toxicity in some case reports, and the multi-herb blend at undisclosed doses is proprietary_blend_hides_dose. Compound autofail on unverified_medical_claim (lung cleanse framing).",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "organic-appetite-booster-liquid-herbal-formula-for-healthy-weight-gain-appetite-support",
      "title": "Organic Appetite Booster – Liquid Herbal Formula for Healthy Weight Gain & Appetite Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Appetite_Booster_Front_1024x1024_2x_png.webp?v=1788062249",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "appetite",
        "booster",
        "liquid",
        "herbal",
        "formula",
        "for",
        "healthy",
        "weight",
        "gain",
        "appetite",
        "support",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 42,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 48,
        "sustainability": 52
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831053570245",
      "vsf_explanation": "VeggieVerve/Livingston Naturals 'Super Appetite Booster' liquid with gentian, centaury, blessed thistle, fenugreek, burdock, ashwagandha, Siberian ginseng, ginger, turmeric and other bitter and nourishing herbs. The category — appetite stimulation for underweight adults and children — is real and legitimate (chemotherapy patients, cachexia, eating disorder recovery, geriatric malnutrition all have real clinical need), but it is a category where evidence-based interventions are prescription (dronabinol, mirtazapine, megestrol) or clinical dietetics-guided, not multi-herb tinctures at undisclosed doses. The 'suitable for adults and children above 3.5 years' framing is a serious concern — pediatric supplement dosing is highly regulated for good reason, and multi-herb tinctures with adaptogens and phytoestrogens (fenugreek in particular is contraindicated in children and pregnancy due to phytoestrogenic activity) should not be dosed to young children without pediatric endocrine review. Autofail on safety_concern (pediatric use of adult-formulated adaptogen blends) + proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "safety_concern"
    },
    {
      "handle": "organic-soursop-turmeric-bitters",
      "title": "Organic Soursop Turmeric Bitters",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/soursop_turmeric.png?v=1788062256",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "soursop",
        "turmeric",
        "bitters",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 35,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 29.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831053766853",
      "vsf_explanation": "VeggieVerve/Livingston Naturals 'Organic Soursop Turmeric Bitters' combines soursop (multiple parts of the plant), turmeric, nettle, Cape aloe, ginger, clove, black pepper, and apple cider vinegar as a digestive bitters formulation. Bitters as a category have modest traditional-use evidence for stimulating digestive secretions, but the specific product carries a foreground safety concern: soursop (Annona muricata) contains annonacin, an inhibitor of mitochondrial complex I associated with atypical parkinsonism in Guadeloupe epidemiological studies (Caparros-Lefebvre 1999, 2002). Featuring 'multiple parts of the soursop plant' as the leading ingredient in a formula intended for regular daily use is exactly the chronic-exposure pattern the neurological safety data warns against. Cape aloe is a stimulant laxative associated with dependence and electrolyte disturbance at chronic doses. Multi-herb anticoagulant potentiation (turmeric + ginger + clove) creates bleeding-risk concerns for users on prescription blood thinners. Autofail on safety_concern.",
      "vsf_autofail_rule": "safety_concern"
    },
    {
      "handle": "organic-plant-based-cholesterol-formula",
      "title": "Organic Plant-based Cholesterol Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/organic-plant-based-cholesterol-formula-653925.jpg?v=1788062265",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "plant",
        "based",
        "cholesterol",
        "formula",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 32,
        "manufacturing": 42,
        "safety": 35,
        "transparency": 45,
        "sustainability": 52
      },
      "price": 29.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831054094533",
      "vsf_explanation": "VeggieVerve (Livingston Naturals sub-line) 'Organic Plant-based Cholesterol Formula' is an 18+ herb liquid tincture with Bergamot, Red Yeast Rice, Hawthorn, Olive Leaf, Pine Tree, Artichoke, Garlic, Arjuna, Rooibos, Flaxseed, Ginger, Fenugreek, Fennel, Pumpkin Seed, Sunflower Seed, Turmeric, Black Pepper, and Stevia. Two serious concerns. First, cholesterol lowering is a disease claim (hypercholesterolemia is a diagnosed medical condition) that FDA has repeatedly issued warning letters over for supplement brands. Second, red yeast rice contains monacolin K — the same molecule as prescription lovastatin — and unregulated red yeast rice supplements have documented cases of muscle toxicity, liver injury, and unpredictable dose (Cohen 2017 tested commercial red yeast rice products and found monacolin K content ranging from 0 to 10.9 mg per capsule — a 100x variance). FDA warns unregulated red yeast rice can cross into unapproved-drug territory. Turmeric alongside garlic and ginger creates real bleeding-risk potentiation for users on anticoagulants. Autofails on unverified_medical_claim (cholesterol treatment) and safety_concern (red yeast rice regulatory status + anticoagulant interactions).",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "back-pain-sciatica-organic-liquid-herbal-formula",
      "title": "Back Pain & Sciatica Organic Liquid Herbal Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Back_pain_sciatica.jpg?v=1788062266",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "back",
        "pain",
        "sciatica",
        "organic",
        "liquid",
        "herbal",
        "formula",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 38,
        "manufacturing": 45,
        "safety": 48,
        "transparency": 45,
        "sustainability": 52
      },
      "price": 29.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831054127301",
      "vsf_explanation": "'Back Pain & Sciatica' is a diagnosed medical condition — sciatica specifically is a neurological entity involving lumbar nerve root compression, disc herniation, or spinal stenosis, and warrants physician evaluation. Naming an oral herbal supplement after a specific diagnosis is textbook disease-claim marketing, and FDA has issued warning letters over exactly this pattern. The product is positioned as 'liquid botanical formula for people who want to stay active, flexible' — a hedge — but the SKU name and the target-diagnosis framing put it firmly in the unverified_medical_claim category. Herbal blends for musculoskeletal comfort have some ingredient-level evidence (turmeric/curcumin at 1000+ mg/day for OA pain, boswellia serrata for joint inflammation, willow bark for pain), but naming a product after 'sciatica' — a neurological diagnosis with real red-flag possibilities (cauda equina syndrome, spinal cord compression) — is inappropriate. Autofail on unverified_medical_claim.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "organic-black-seed-oil-with-oil-of-oregano-moringa-maximum-strength-liquid-formula",
      "title": "Organic Black Seed Oil with Oil of Oregano & Moringa – Maximum Strength Liquid Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Black_Seed_Moringa_1024x1024_2x_png.webp?v=1788062265",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "black",
        "seed",
        "oil",
        "with",
        "oil",
        "oregano",
        "moringa",
        "maximum",
        "strength",
        "liquid",
        "formula",
        "veggieverve"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 34.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831054160069",
      "vsf_explanation": "VeggieVerve/Livingston Naturals 'Maximum Strength' black seed oil liquid discloses 1500 mg total with 1.2% thymoquinone (the active in Nigella sativa/black seed) and blends with oil of oregano, moringa, sea moss, soursop leaf, turmeric, and black pepper. Black seed oil has moderate ingredient-level evidence: Razmpoosh 2019 and Amin 2015 meta-analyses show modest improvements in glycemic and lipid markers at 1-2 g/day of oil. 1500 mg with 1.2% thymoquinone (~18 mg TQ) is roughly in the studied range. Positive: thymoquinone percentage disclosed, total oil dose disclosed. Concerns: (1) soursop leaf contains annonacin, a mitochondrial toxin associated with atypical Parkinsonism in Guadeloupe epidemiological studies (Caparros-Lefebvre 1999) — this is a real safety_concern for chronic use of any soursop-containing product; (2) multi-herb blend format dilutes each ingredient's individual dose; (3) 'maximum strength' is marketing language. Not autofailing because black seed oil disclosure is meaningfully better than most VeggieVerve SKUs, but soursop safety concern and multi-herb dilution pull the score into low Rejected.",
      "vsf_autofail_rule": "safety_concern"
    },
    {
      "handle": "bucked-up-mother-bucker-20-servings",
      "title": "Bucked Up Mother Bucker, 20 Servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/bucker-up-mother-bucker-pre-workout..png?v=1788062282",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bucked",
        "mother",
        "bucker",
        "servings",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 52,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 37.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831055405253",
      "vsf_explanation": "Bucked Up Mother Bucker is a high-stimulant pre-workout from Bucked Up (parent brand DAS Labs), a real US sports-nutrition brand with distribution and a public product line. This SKU explicitly discloses 400 mg total caffeine from fast and delayed-release sources, which is a critical honest disclosure — pre-workout products in the 300-400 mg caffeine range are common but many hide the dose. 400 mg is at the FDA-cited safe daily limit for healthy adults, meaning even a single serving hits the day's ceiling; caffeine-sensitive users, those under 5 ft 5 in / 130 lb, and anyone with cardiovascular baseline risk should avoid it. Beyond caffeine, pre-workouts in this class typically include beta-alanine (RCT evidence for high-intensity work at 3-6 g/day loading), citrulline malate (evidence for pumps and repeated-set performance at 6-8 g), L-tyrosine, and various proprietary 'focus' blends. Full ingredient panel not visible in the excerpt; if the non-caffeine actives are dose-disclosed, Standard is appropriate. If they are hidden in a proprietary blend the score drops. Standard tier reflects legitimate brand, extreme-user honesty about caffeine dose, and inherent safety trade-off of high-stim category.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nootropack-our-nootropic-bundle",
      "title": "Nootropack: Our Nootropic Bundle",
      "vendor": "Stoned Ape, Inc",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/StonedApe-Nootropack.png?v=1788062311",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nootropack",
        "our",
        "nootropic",
        "bundle",
        "stoned",
        "ape",
        "inc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 42,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 35,
        "sustainability": 48
      },
      "price": 84.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831056584901",
      "vsf_explanation": "Stoned Ape Inc.'s Nootropack expands the AM/PM concept to a 3-formula stack timed to circadian rhythm (presumably morning cognition, afternoon focus, evening recovery/sleep). Same brand and same transparency gap as the AM/PM Bundle — no per-formula, per-ingredient milligram disclosure in the reviewed product copy. Multi-formula nootropic stacks are one of the most abused categories in supplement marketing because 'more formulas' implies 'more optimization' without necessarily delivering more evidence per dollar. Onnit's Alpha BRAIN is the category benchmark that carries an actual RCT of the finished formula (Solomon 2016 on memory and executive function); most nootropic stacks do not have finished-product RCTs. Autofail on proprietary_blend_hides_dose. A stack that publishes per-capsule ingredient milligrams for each of three formulas would earn a materially different score.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "am-pm-bundle",
      "title": "AM/PM Bundle",
      "vendor": "Stoned Ape, Inc",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ProductShot-Bundle_4d6210d4-83a9-480c-8117-850439434f83.jpg?v=1788062316",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bundle",
        "stoned",
        "ape",
        "inc"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 38,
        "sustainability": 48
      },
      "price": 62.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831056781509",
      "vsf_explanation": "Stoned Ape Inc.'s AM/PM Bundle pairs 'Xnergy' (morning nootropic) with 'Dream' (nighttime nootropic) marketed as a 24-hour cognition, mood, recovery, and circadian-optimization stack. Circadian-timed nootropic formulations are a legitimate framing — the brain has different neurochemistry demands across the day, and morning caffeine + adaptogen + afternoon focus + nighttime GABA/melatonin/magnesium is a reasonable conceptual approach. Problem: neither Xnergy nor Dream discloses per-ingredient milligrams in the reviewed metadata, and multi-ingredient morning-nootropic and sleep-support formulations are exactly the category the proprietary_blend_hides_dose autofail addresses. Both products likely include ingredients with real evidence at studied doses (caffeine, L-theanine, ashwagandha, magnesium, GABA, melatonin), but without disclosure a reviewer cannot check whether any are present at effective concentrations or below-threshold amounts. Bundle format also implies both products carry the same disclosure gap. Autofail on proprietary_blend_hides_dose. Brand ('Stoned Ape' referencing a fringe theory about psilocybin driving primate cognition) is a stylistic red flag but not a scoring driver.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "nature-made-advanced-multi-for-adults-multivitamin-gummies-mixed-berry-flavor",
      "title": "Nature Made Advanced Multi For Adults Multivitamin Gummies Mixed Berry Flavor",
      "vendor": "Nature Made",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/279816655.jpg?v=1788062337",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "made",
        "advanced",
        "multi",
        "for",
        "adults",
        "multivitamin",
        "gummies",
        "mixed",
        "berry",
        "flavor",
        "nature",
        "made"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 72,
        "safety": 75,
        "transparency": 65,
        "sustainability": 58
      },
      "price": 16.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831057436869",
      "vsf_explanation": "Nature Made is a mass-market US supplement brand owned by Otsuka Pharmaceutical, and a substantial share of Nature Made SKUs carry USP Verified certification — an independent-lab check that the pills contain what the label claims, dissolve properly, and are free of common contaminants. Advanced Multi Gummies deliver a broad multivitamin panel plus magnesium, calcium, and all 8 B vitamins in a gummy format, positioned as '60% more total nutrients' than baseline gummy multis, gluten-free, no HFCS, no artificial flavors or synthetic dyes. Gummy format has documented labeling-accuracy issues industry-wide (a 2017 ConsumerLab review found some gummy multis under- or over-labeled), which is one reason USP verification on gummies is a meaningful signal. Formula is standard adult multivitamin territory with credible manufacturing behind it. Held back from Verified by absence of iron-vs-no-iron distinction (a gender-neutral adult multi should typically be iron-free) and by gummy delivery being a lower-density format than tablets (achievable per-serving doses are lower).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "axolt-daily-packs",
      "title": "Axolt Daily Packs",
      "vendor": "Axolt",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/axolt-daily-packs-6660488.webp?v=1788062354",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "axolt",
        "daily",
        "packs",
        "axolt"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 25,
        "manufacturing": 35,
        "safety": 40,
        "transparency": 12,
        "sustainability": 35
      },
      "price": 89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831058059461",
      "vsf_explanation": "The product listing has an empty body/description field — there is literally no product copy, no ingredient list, no dose information, no marketing language, and no evaluable content whatsoever besides the SKU title 'Axolt Daily Packs' and vendor name Axolt. A listing with no product description is functionally unlistable — a buyer cannot know what they are purchasing, and a reviewer cannot verify anything about the product. Autofail on no_brand_provenance / misleading_naming — the SKU exists in the catalog with zero content. This is a data-quality issue as much as a product-quality issue; even a legitimate underlying product cannot be evaluated without content.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "energize",
      "title": "Energize",
      "vendor": "Vitamin Patch Club",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ENERGIZEMAIN.webp?v=1788062376",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "energize",
        "vitamin",
        "patch",
        "club"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 40,
        "sustainability": 45
      },
      "price": 29.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831059075269",
      "vsf_explanation": "Vitamin Patch Club 'Energize' patch stacks multiple actives — natural caffeine from yerba mate, green tea, and green coffee extract, plus B-complex, panax ginseng, black maca, CoQ10, and black pepper extract — into a single transdermal patch. Two overlapping problems. First, the transdermal-B-vitamin bioavailability critique from the Super8 patch applies here as well: water-soluble B vitamins have essentially no peer-reviewed transdermal-absorption evidence. Second, caffeine is one of the few compounds with real transdermal potential (small molecule, moderately lipid-soluble), but the achievable dose via a skin patch is far below the 50-100 mg oral effective dose without a permeation enhancer, and the release profile is slow enough to be pharmacologically ambiguous. Combining seven or more actives in a single patch increases the aggregate uncertainty rather than resolving it, and 'peel, stick, feel the difference — no pills, no jitters' framing is marketing rather than evidence. Autofail on proprietary_blend_hides_dose because none of the seven ingredients are dose-disclosed at a per-patch level.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "b-performance-8",
      "title": "B-Performance 8",
      "vendor": "Vitamin Patch Club",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/B-performance-patch.png?v=1788062385",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "performance",
        "vitamin",
        "patch",
        "club"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 45,
        "manufacturing": 52,
        "safety": 58,
        "transparency": 42,
        "sustainability": 48
      },
      "price": 39.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831059501253",
      "vsf_explanation": "Vitamin Patch Club 'Super8' B-Performance is a transdermal vitamin patch delivering all 8 essential B vitamins for cardiovascular support, metabolic burn, and energy. The core mechanism problem is that transdermal vitamin absorption has essentially no peer-reviewed bioavailability evidence for most water-soluble vitamins, including B-complex. The skin is designed to be a barrier — it evolved to keep foreign molecules out. Compounds that can cross skin efficiently are small (under ~500 Da), lipid-soluble, and often require permeation enhancers (like the skin-penetration drivers in transdermal nicotine or hormone patches). B vitamins are mostly water-soluble (except B12), typically well over 500 Da, and have essentially no clinical evidence of meaningful transdermal absorption despite marketing claims across the vitamin-patch industry. B12 is the one exception with limited pharmacokinetic support (Berlin 1968 injectable-vs-oral B12 studies; a 2019 open-label transdermal B12 patch study by Vitamin Patch Club vendors showed variable serum-level increases). Autofail on unverified_medical_claim for the 'cardio support, metabolic burn, energy' claims delivered by an unvalidated route. Not a category Vyvata endorses as-is.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "riize-xtra",
      "title": "Riize Xtra",
      "vendor": "Riize Strips",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/RZ-Xtra-RenderedPackaging.png?v=1788062428",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "riize",
        "xtra",
        "riize",
        "strips"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 42,
        "manufacturing": 52,
        "safety": 55,
        "transparency": 28,
        "sustainability": 48
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831061008581",
      "vsf_explanation": "Riize Xtra is a 'high-intensity oral strip designed to deliver fast-acting energy and sharpen focus.' Same brand pattern as Riize Energy and Riize Sleep — novel buccal-delivery format, but with no ingredient list, no dose, no active-compound identity disclosed in the product copy. 'High-intensity' framing suggests a caffeine dose above the mild Riize Energy tier, potentially in the 100-200 mg per strip range if the intent is match to a strong pre-workout hit. Without disclosure, no evaluation is possible. Autofail on proprietary_blend_hides_dose. Buccal caffeine at disclosed doses is a defensible energy-format innovation; the current product lacks the disclosure floor for that credit.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "riize-deziire-strips-3-pack",
      "title": "Riize Deziire Strips - 3-Pack",
      "vendor": "Riize Strips",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/rizzz.png?v=1788062433",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "riize",
        "deziire",
        "strips",
        "pack",
        "riize",
        "strips"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 38,
        "manufacturing": 48,
        "safety": 50,
        "transparency": 25,
        "sustainability": 42
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831061237957",
      "vsf_explanation": "Riize Deziire (phonetic play on 'desire') is a women's-vitality oral strip marketed for 'hormone balance, mood, and confidence' — vague benefit claims that the product copy fails to tie to specific ingredients or doses. The 'Active Ingredients' section is truncated in the metadata excerpt, but multi-benefit hormonal claims for women (mood, libido, hormone balance) at undisclosed doses are the same proprietary-blend pattern seen across the T-booster batch. Additional concerns: product-name phonetic mimicry of 'Desyrel' (trade name for the antidepressant trazodone) borders on misleading_naming that could confuse buyers about whether the product is drug-adjacent, and multi-symptom hormonal claims for women that are marketed 'anytime, anywhere' as a strip suggest lightweight formulation rather than serious hormonal support. Autofail on proprietary_blend_hides_dose. Real hormonal or libido support in women requires an evaluation of what is actually depleted or dysregulated (estrogen, testosterone, thyroid, cortisol, iron, B12) and treats accordingly — not a mood-vibe strip.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "riize-sleep",
      "title": "Riize Sleep",
      "vendor": "Riize Strips",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/RZ-Sleep-RenderedPackaging_40b8af90-2da0-4e6c-b432-e9c44acdf5a2.png?v=1788062443",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "riize",
        "sleep",
        "riize",
        "strips"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 45,
        "manufacturing": 52,
        "safety": 55,
        "transparency": 30,
        "sustainability": 48
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831061827781",
      "vsf_explanation": "Same brand, same disclosure gap. Riize Sleep is marketed as a 'fast-acting oral strip designed to help you unwind and ease into restful sleep' with 'natural ingredients' — but no ingredient list, no dose, no active-compound identity in the reviewed metadata. Sleep-supplement strips typically deliver melatonin at 0.3-3 mg per strip (buccal absorption allows lower effective doses than pills), sometimes with L-theanine, magnesium citrate, or GABA. Without disclosure the product cannot be evaluated. Buccal melatonin at low disclosed doses is a defensible formulation — Zhdanova 1995 showed 0.3 mg melatonin is often sufficient for sleep-onset, and lower doses avoid the morning grogginess of the widely-sold 5-10 mg pill format. Autofail on proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "riize-energy",
      "title": "Riize Energy",
      "vendor": "Riize Strips",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/RZ-Energy-RenderedPackaging_c63b2bcb-a55d-43f1-bde6-5493c73740c2.png?v=1788062448",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "riize",
        "energy",
        "riize",
        "strips"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 45,
        "manufacturing": 52,
        "safety": 55,
        "transparency": 30,
        "sustainability": 48
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831062024389",
      "vsf_explanation": "Riize Strips is a small brand producing dissolving oral strips as a novel supplement delivery format. Riize Energy is marketed as a 'fast-acting oral strip formulated to boost energy levels and enhance mental clarity' but the reviewed product copy provides no ingredient list, no per-strip dose, no active-compound disclosure, and no basis for evaluation. Oral-strip delivery is buccal absorption partially — a portion of the active compound absorbs sublingually/buccally bypassing first-pass metabolism, but the total dose that fits on a strip is limited (typically <100 mg of active) and per-strip content varies widely by manufacturer. Without disclosure, this cannot be evaluated. Autofail on proprietary_blend_hides_dose. The novel format is a real trade-off — faster onset for lower total dose — that a well-disclosed strip could earn credit for.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "blood-pressure-tincture",
      "title": "Blood Pressure Tincture",
      "vendor": "ABĒCA Naturals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/FullSizeRender_c8789a3c-b935-4bc6-9c97-9102572326fd.jpg?v=1788062478",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "blood",
        "pressure",
        "tincture",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 45,
        "sustainability": 48
      },
      "price": 24,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831062909125",
      "vsf_explanation": "ABĒCA Naturals 'Blood Pressure Tincture' is a two-herb liquid blend of lemon balm (Melissa officinalis) and yarrow (Achillea millefolium) marketed to 'alleviate elevated blood pressure caused by high levels of stress' and 'keep blood pressure from rising too much due to stress.' Blood pressure is a diagnosed medical condition (hypertension is a major cardiovascular risk factor requiring physician evaluation and treatment) and product-name framing plus outcome claims are exactly the disease-adjacent structure the FDA warns against. Neither lemon balm nor yarrow has controlled human RCT evidence for meaningful blood-pressure reduction; lemon balm has some anxiolytic and mild-hypnotic evidence at studied doses (Cases 2011), and yarrow has traditional use with sparse modern clinical validation. Autofail on unverified_medical_claim. The 'stress-mediated BP elevation' framing is a partial hedge but the product name and claim structure still make it a de facto blood-pressure-treatment marketing position without evidence.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "mri-performance-no2-nitric-oxide-original-formula",
      "title": "MRI Performance NO2 Nitric Oxide Original Formula",
      "vendor": "MRI Performance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MRINO290sNEW.png?v=1788062493",
      "score": 41,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mri",
        "performance",
        "no2",
        "nitric",
        "oxide",
        "original",
        "formula",
        "mri",
        "performance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 28,
        "sustainability": 45
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831063433413",
      "vsf_explanation": "The \"NO2 Original Formula\" is the older sibling to NO2 Black in MRI's nitric oxide product line. The original NO2 launched in the early 2000s built around L-arginine as the primary NO precursor — an era before the sports nutrition literature had fully embraced L-citrulline as the superior oral NO precursor. Arginine's oral bioavailability is limited by first-pass intestinal and hepatic arginase activity, so oral doses raise plasma arginine only modestly and produce blunted NO effects compared to L-citrulline at equivalent doses. Regardless of specific ingredient list, the typical NO2 product structure uses a proprietary blend labeling that discloses total blend weight but hides per-ingredient milligrams — triggering the proprietary_blend_hides_dose autofail. Even if the per-ingredient doses were disclosed and clinically appropriate, the choice of arginine over citrulline as the primary active reflects a dated formulation that has been superseded by ~15 years of pharmacokinetic evidence. Rejected on the proprietary blend structure; the underlying formulation approach is also aging.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "mri-performance-zinc-60-count",
      "title": "MRI Performance Zinc (60 Count)",
      "vendor": "MRI Performance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MRI_ZINC_Front_Shadow_1.png?v=1788062525",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mri",
        "performance",
        "zinc",
        "count",
        "mri",
        "performance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831066087621",
      "vsf_explanation": "MRI Performance Zinc is a single-ingredient zinc capsule from an established sports-nutrition brand with practitioner and NPC-federation ties dating back to the late 1990s. Zinc itself is one of the best-characterized essential trace minerals — required for over 300 enzymatic reactions, well-studied for immune function, testosterone-adjacent enzyme cofactor status, wound healing, and taste/smell perception. Baseline RDA is 8-11mg/day and typical supplement doses of 15-30mg are safe for daily use, with upper tolerable intake at 40mg/day. The product loses points because MRI does not publish the exact zinc form (picolinate, bisglycinate chelate, gluconate, oxide — bioavailability varies materially) in the title-level metadata, and there is no per-lot certificate of analysis linked from the product page. Zinc taken chronically at higher doses without compensating copper can induce copper deficiency and anemia, and MRI does not co-formulate copper here. Sports positioning implies performance/testosterone benefits that zinc only supports when the user is actually deficient — a nuance the marketing does not fully convey. Standard tier reflects a real single-nutrient supplement from a real brand at a reasonable dose, but not a premium-tier formulation with disclosed form, third-party testing, or copper balance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mri-performance-trt-support-testosterone-replacement-therapy-90-count",
      "title": "MRI Performance TRT Support Testosterone Replacement Therapy (90 Count)",
      "vendor": "MRI Performance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MRITRTFrontShadow1280.png?v=1788062524",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "mri",
        "performance",
        "trt",
        "support",
        "testosterone",
        "replacement",
        "therapy",
        "count",
        "mri",
        "performance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 40,
        "transparency": 32,
        "sustainability": 45
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831066022085",
      "vsf_explanation": "The product name explicitly reads \"TRT Support Testosterone Replacement Therapy.\" Testosterone Replacement Therapy is a specific, FDA-regulated medical treatment that uses actual exogenous testosterone (injections, gels, pellets, or patches) delivered under a physician's prescription for men diagnosed with clinical hypogondism via laboratory testing. It is a Schedule III controlled substance in the United States. An over-the-counter herbal capsule cannot legally deliver testosterone and cannot legally be labeled as \"replacement therapy.\" Regardless of what ingredients are inside — likely some combination of tongkat ali, fenugreek, D-aspartic acid, zinc, ashwagandha, and boron — the naming creates a direct impression of medical equivalence that the product cannot deliver and that FDA labeling guidance for dietary supplements explicitly prohibits. This is a textbook misleading_naming autofail: the average buyer reading \"TRT Support\" and \"Testosterone Replacement Therapy\" on a bottle at a retailer is being invited to substitute a supplement for a medically supervised, monitored, blood-tested hormone protocol. The blend content itself may include ingredients with real per-molecule evidence (ashwagandha for stress-mediated testosterone recovery, boron for SHBG modulation, zinc for cofactor status in deficient men), but that does not rehabilitate a product name that overreaches into prescription-only medical territory. Rejected under misleading_naming.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "mri-performance-omega-3-60-count",
      "title": "MRI Performance Omega 3 (60 Count)",
      "vendor": "MRI Performance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MRI_Omega_3_Front_Shadow.png?v=1788062525",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mri",
        "performance",
        "omega",
        "count",
        "mri",
        "performance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831066054853",
      "vsf_explanation": "Omega-3 fish oil is one of the best-evidenced supplement categories in the entire market — decades of trials show EPA and DHA support triglyceride reduction, resolution of inflammation via specialized pro-resolving mediators (resolvins, protectins, maresins), retinal and neurological development, and cardiovascular endpoints in high-dose prescription contexts (Vascepa EPA-only 4g/day for hypertriglyceridemia). MRI Performance Omega 3 sits in this well-established category as a mainstream sports-brand entry. The product loses ground because the title does not disclose the per-softgel EPA and DHA milligrams — the two numbers that actually matter for dosing (total \"fish oil mg\" is meaningless without knowing the omega-3 concentration). It also does not indicate triglyceride vs. ethyl ester form (TG form is roughly 50% better absorbed), does not publish a peroxide/anisidine value for oxidation, and does not carry visible IFOS or Friend of the Sea third-party certification. At 60 softgels the bottle is likely a 30-day supply at 2/day, suggesting per-day EPA+DHA in the 500-1000mg range — adequate for general cardiovascular support in a healthy adult but below the 2-4g/day used in triglyceride-lowering or inflammation trials. Standard tier: a legitimate omega-3 product, but not competitive on transparency or third-party verification with Nordic Naturals, Carlson, or Thorne Super EPA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mri-performance-vitamin-c-180-count",
      "title": "MRI Performance Vitamin C (180 Count)",
      "vendor": "MRI Performance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MRI_Vitamin_C_Front_Shadow_1.png?v=1788062526",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mri",
        "performance",
        "vitamin",
        "180",
        "count",
        "mri",
        "performance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831066120389",
      "vsf_explanation": "Vitamin C (ascorbic acid) is a well-characterized water-soluble antioxidant and essential cofactor for collagen hydroxylation, carnitine biosynthesis, catecholamine synthesis, and iron absorption. RDA sits at 75-90mg/day for adults; supplement doses of 250-1000mg are common, absorption saturates around 200mg per single dose, and the tolerable upper intake is 2000mg/day (higher doses cause osmotic diarrhea). MRI Performance Vitamin C is a straightforward single-ingredient capsule at 180 count from an established sports-nutrition brand. The product does not disclose the per-capsule dose in the title (likely 500mg or 1000mg) or specify whether it is plain ascorbic acid, buffered (calcium/sodium/magnesium ascorbate), or contains bioflavonoids. Plain high-dose ascorbic acid can cause GI upset in sensitive users — a buffered version (like Ortho Molecular's Buffered C, also in this batch) mitigates that but costs more. Standard tier: a real single-nutrient vitamin C from a real brand at a reasonable count, unremarkable on transparency but not problematic on safety.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mri-performance-collagen-joint-muscle-bone-support-20-servings",
      "title": "MRI Performance Collagen Joint + Muscle + Bone Support (20 Servings)",
      "vendor": "MRI Performance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MRI_Collagen_Front_Shadow.png?v=1788062525",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mri",
        "performance",
        "collagen",
        "joint",
        "muscle",
        "bone",
        "support",
        "servings",
        "mri",
        "performance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831066153157",
      "vsf_explanation": "This is a combination collagen product fortified per the description with vitamin D, calcium, and L-leucine, targeting joint, muscle, and bone support. The individual actives are all well-characterized: hydrolyzed collagen peptides at 10-15g/day have moderate evidence for reducing joint pain in athletes (Clark 2008, Zdzieblik 2017), calcium and vitamin D are the pillar bone-density interventions in the medical literature, and L-leucine is the primary trigger for muscle protein synthesis via mTORC1 signaling (needs ~2.5-3g per meal to hit the leucine threshold). The formula is coherent on paper. Weakness: the product does not disclose collagen source (bovine hide, marine, chicken sternal type II), per-serving milligrams of each active, molecular weight of the collagen peptides (which affects absorption), or standardization of the vitamin D and calcium forms (K2 co-formulation for calcium partitioning is absent based on the ingredient list). At 20 servings the tub is a fairly small supply (three-week course), which is typical for a joint-support cycle but suggests dosing frequency guidance would help. Standard tier: legitimate combination product covering three real areas, but not a premium formulation with disclosed collagen type/molecular weight, K2 pairing, or third-party assay.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mri-performance-no2-black-muscle-pump-nitric-oxide-30-servings",
      "title": "MRI Performance NO2 Black Muscle + Pump Nitric Oxide (30 servings)",
      "vendor": "MRI Performance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/300_PPI_MRI_NO2_Blk_30_Srv_Jacked_Juice_Bag_R2b_Front_shadow_1.jpg?v=1788062524",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mri",
        "performance",
        "no2",
        "black",
        "muscle",
        "pump",
        "nitric",
        "oxide",
        "servings",
        "mri",
        "performance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 42,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 28,
        "sustainability": 45
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831066185925",
      "vsf_explanation": "\"NO2 Black\" is a nitric-oxide-focused pre-workout / pump product from MRI's sport line. Nitric oxide precursors — L-arginine, L-citrulline, citrulline malate, and dietary nitrate (beetroot) — have real evidence for acute vasodilation, blood flow to skeletal muscle, and modest performance/pump effects at correct doses (L-citrulline: 6-8g/day; citrulline malate: 8g pre-workout; beetroot nitrate: 300-500mg). The category convention among sports brands is to bundle these actives into a proprietary blend labeled \"NO Matrix\" or similar without per-ingredient milligrams. Based on the product name and typical MRI formulation practice for this SKU line, the formula is expected to use exactly this proprietary-blend structure — total blend weight disclosed, per-ingredient milligrams hidden — which prevents a buyer from verifying whether L-citrulline hits the 6g threshold or is under-dosed to 1-2g. That structure is the textbook proprietary_blend_hides_dose autofail. If per-ingredient milligrams were disclosed and the actives hit clinical doses, the product would land in Standard territory; without that disclosure it cannot clear the autofail rule. Rejected.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "mri-performance-ultra-whey-protein-2lb",
      "title": "MRI Performance Ultra Whey Protein 2lb",
      "vendor": "MRI Performance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MRI_Ultra_Marsh_Front_Shadow.jpg?v=1788062524",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mri",
        "performance",
        "ultra",
        "whey",
        "protein",
        "2lb",
        "mri",
        "performance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831066316997",
      "vsf_explanation": "Whey protein is one of the best-evidenced sports-nutrition products in the market — dozens of trials confirm it triggers muscle protein synthesis (via a leucine-rich amino acid profile), improves body composition when paired with resistance training, and functions as a convenient protein source for hitting daily protein targets of ~1.6g/kg for active adults. MRI Performance Ultra Whey Protein at 2lb is a mainstream sports-brand entry. The product loses points because the title does not specify whey isolate vs. concentrate vs. blend (isolate is ~90% protein by weight and lactose-poor; concentrate is 70-80% protein and contains some lactose and immunoglobulins), the per-scoop protein grams are not in the title, the amino acid profile / per-scoop leucine content is not stated, and no Informed Sport or NSF Certified for Sport third-party badge is visible — a real gap for a product marketed to athletes given the meaningful contamination-with-banned-substances history in the sports supplement category. At 2lb the tub is a 20-30 serving supply depending on scoop size. Standard tier: legitimate whey from a real brand, unremarkable on transparency, no third-party purity certification visible.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mri-performance-dhea-50mg-healthy-aging-hormone-adrenal-support",
      "title": "MRI Performance DHEA 50MG  Healthy Aging, Hormone & Adrenal Support",
      "vendor": "MRI Performance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/DHEA_50_100ct_Front_1_3.jpg?v=1788062525",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mri",
        "performance",
        "dhea",
        "50mg",
        "healthy",
        "aging",
        "hormone",
        "adrenal",
        "support",
        "mri",
        "performance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 48,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831066382533",
      "vsf_explanation": "DHEA (dehydroepiandrosterone) is a real adrenal steroid precursor that declines by roughly 80% between age 20 and age 70 in humans and serves as a substrate for downstream sex hormone synthesis. Randomized trial evidence for DHEA supplementation is genuinely mixed: modest benefits in bone density in older women, potential adjunctive benefit in adrenal insufficiency, and marginal-to-null effects on mood, libido, and body composition in most general-population trials. The clinical dosing range is 25-50mg/day; 50mg is at the higher end. Safety notes: DHEA converts to both testosterone and estrogen downstream, which means users with hormone-sensitive conditions (prostate cancer, breast cancer, PCOS, endometriosis) should avoid it, and monitoring of estradiol/testosterone/PSA is prudent for long-term use. DHEA is banned in-competition by the WADA prohibited list. MRI Performance discloses the dose (50mg) directly in the product name, which is transparency in the right direction. The product loses ground because DHEA marketed for \"healthy aging, hormone & adrenal support\" for a general-consumer audience overstates the evidence base — most well-controlled trials in healthy middle-aged adults show minimal effect — and because the safety profile warrants clinician oversight that a retail product does not enforce.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mri-performance-glutamine-1000g",
      "title": "MRI Performance Glutamine 1000G",
      "vendor": "MRI Performance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MRI_Glutamine_1000_Front_Shadow.png?v=1788062525",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mri",
        "performance",
        "glutamine",
        "1000g",
        "mri",
        "performance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831066415301",
      "vsf_explanation": "L-glutamine is the most abundant free amino acid in human plasma and skeletal muscle, and it is a conditionally essential amino acid — becoming genuinely essential during severe catabolic stress (major surgery, sepsis, burns), where clinical enteral or parenteral glutamine supplementation has evidence for reduced infections and shorter ICU stays. In the general sports-nutrition context, however, oral glutamine's story is much weaker: healthy trained athletes with adequate protein intake show minimal-to-no benefit for muscle protein synthesis, recovery, or immune function from adding oral glutamine on top of a normal high-protein diet. Glutamine's utility in gut-lining support (leaky gut, IBD) is more promising, and it is often recommended at 5-10g/day for gut integrity in functional-medicine contexts. MRI Performance Glutamine at 1000g (2.2 lb bulk powder) is a real single-ingredient product at a fair price. Standard tier: legitimate but not category-leading — the supplement itself is honest, but the underlying evidence for the sports-recovery framing is weak in trained athletes.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mri-performance-micronized-creatine-monohydrate",
      "title": "MRI Performance Micronized Creatine Monohydrate",
      "vendor": "MRI Performance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MRI_Creatine_1000_Front_Shadow.png?v=1788062525",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mri",
        "performance",
        "micronized",
        "creatine",
        "monohydrate",
        "mri",
        "performance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 92,
        "formulation": 72,
        "manufacturing": 65,
        "safety": 82,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831066448069",
      "vsf_explanation": "Creatine monohydrate is the most-studied sports supplement in existence — over 1,000 published trials since the mid-1990s document reliable effects on strength, power output, muscle mass, and (increasingly) cognitive performance under stress or sleep deprivation. Dosing consensus is well-established: 3-5g/day (no loading required, though a 20g/day loading phase for 5-7 days accelerates saturation). Creatine monohydrate is the reference form — no other form (HCl, ethyl ester, magnesium chelate, kre-alkalyn) has demonstrated superior clinical outcomes to plain monohydrate at fair comparison. Safety profile is excellent: no evidence of renal harm in healthy adults across long-term trials, no evidence of hair loss (the DHT rumor traces to a single small rugby-player study that has never replicated). \"Micronized\" refers to particle-size reduction that improves powder dispersion in water without changing the molecule. This product's core substance is essentially unimpeachable. The 71 score reflects that the substance itself is best-in-class evidence, tempered by the absence of a visible Creapure branded ingredient badge (the German-manufactured, chromatographically-verified creatine standard used by top-tier brands like Momentous and Thorne), absence of visible NSF Certified for Sport testing, and undisclosed per-scoop dosing at the title level.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "rock-the-shot",
      "title": "Rock The Shot",
      "vendor": "Rock The Shot",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Rock_The_Shot_Chocolate.webp?v=1788062549",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "rock",
        "the",
        "shot",
        "rock",
        "the",
        "shot"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831067562181",
      "vsf_explanation": "Rock The Shot positions itself as 'foundational nutrition for your GLP-1 journey' — a daily shake for people on semaglutide, tirzepatide, or similar GLP-1 receptor agonists, delivering collagen, BCAAs, fiber, and micronutrients. This is a sensible category to address: GLP-1 medications produce clinically meaningful weight loss but a documented fraction of that loss (25-40% in some analyses) comes from lean muscle mass, and patients report reduced appetite that can make hitting daily protein and fiber targets difficult. A protein-plus-fiber-plus-micronutrient shake is a real functional match to the physiology. Ingredient identity is disclosed at the class level but per-serving grams for protein, collagen, and fiber are not visible in the metadata excerpt. Publishing per-serving macronutrient targets calibrated to GLP-1-user needs (e.g., 25 g protein, 8-10 g fiber, 400-800 mg leucine) would strengthen the case. Standard-tier entry — the category is legitimate, execution appears reasonable, but transparency is not yet at Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-arginine-supplement-60-capsules-by-aziza-fae",
      "title": "L-Arginine Supplement (60 Capsules) by Aziza & Fae",
      "vendor": "TristanChristopher.ART",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8729232188912976876_2048.jpg?v=1788062611",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "arginine",
        "supplement",
        "capsules",
        "aziza",
        "fae",
        "tristanchristopher",
        "art"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 52,
        "sustainability": 48
      },
      "price": 22,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831072051397",
      "vsf_explanation": "Aziza & Fae is a small US-based health and wellness brand, and this SKU is a single-ingredient L-arginine capsule. L-arginine is a semi-essential amino acid and the substrate for endothelial nitric oxide synthase — plausible mechanism for improved vasodilation. Human RCT evidence is mixed: some cardiovascular trials show modest blood-pressure reduction at doses of 6-9 g/day (Dong 2011 meta-analysis), some erectile-dysfunction trials show mild benefit at 3-6 g/day, and post-VISP trial concerns (Schulman 2006) noted increased mortality in post-MI patients supplemented with L-arginine — meaning cardiovascular disease patients should be cautious. Per-capsule dose is not clearly disclosed in the metadata excerpt; if the product delivers 500-1000 mg per capsule with a 1-2 capsule daily serving, that is below the studied cardiovascular range (6-9 g/day) but consistent with general-wellness supplementation. Standard-tier entry pending disclosed dose confirmation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "olimp-amino-5500-400-capsules",
      "title": "Olimp Amino 5500 400 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/olimp_amino_5500_400_kapsl_7201.jpg?v=1788062630",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "olimp",
        "amino",
        "5500",
        "400",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 112.77,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831072608453",
      "vsf_explanation": "Olimp Sport Nutrition is an established Polish sports-supplement brand with distribution across Europe and select US markets, and a public history of contract manufacturing to industry standards. Amino 5500 delivers 5,425 mg of amino acids per serving using their 'Mega Caps' capsule technology (larger capsules meaning fewer per serving), 34% of which is disclosed as BCAAs (~1,844 mg BCAAs per serving) with vitamin B6 added for protein-synthesis cofactor support. Doses are disclosed at the class level. 5.4 g total amino acids per serving is below the leucine-anabolic threshold identified in Wolfe 2017 (~3 g leucine per anabolic bolus, roughly requiring 6-8 g complete EAAs), so a single serving is a modest amino contribution — users needing anabolic dosing typically multi-scoop. The capsule format constrains achievable per-serving dose vs powder equivalents. Middling manufacturing/transparency scores reflect real brand, class-level dose disclosure, no visible sport certification. Reasonable Standard entry.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "redmonkey-sports-acid-block®",
      "title": "RedMonkey Sports Acid Block®",
      "vendor": "RedMonkey Sports",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Acid_Block_edited_3.png?v=1788062670",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "redmonkey",
        "sports",
        "acid",
        "block",
        "redmonkey",
        "sports"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 45,
        "manufacturing": 52,
        "safety": 58,
        "transparency": 45,
        "sustainability": 42
      },
      "price": 5.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831073657029",
      "vsf_explanation": "RedMonkey Sports Acid Block is a US-patented (US 10,213,453) alkaline-mineral caplet marketed to cyclists and endurance athletes for 'raising lactate threshold' and 'combatting exercise-induced body acidosis.' The scientific premise is a decades-old misconception: lactate itself does not cause muscle fatigue or acidosis in the way endurance-supplement marketing implies. Robergs 2004 (American Journal of Physiology) formally corrected the lactate-acidosis story — the H+ ions responsible for exercise acidosis come from ATP hydrolysis, not from lactate, and lactate itself is actually a buffered fuel substrate that the liver and other muscles readily oxidize. Buffering blood pH with oral alkaline minerals has some evidence for high-intensity performance (sodium bicarbonate at 300 mg/kg has RCT support for 1-7 minute all-out efforts — Peart 2012 meta-analysis), but the effect is small and specific to buffering acute high-intensity work, not to 'raising lactate threshold.' A US patent validates novelty, not efficacy. Marketing claim 'proven that raising your Lactate Threshold will allow you to ride stronger for longer' misrepresents the underlying physiology. Autofail on unverified_medical_claim for the specific 'raises lactate threshold via oral buffer' claim.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "natures-bounty-coq10-200mg-dietary-supplement-30-capsules",
      "title": "Nature's Bounty CoQ10 200mg Dietary Supplement - 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/natures-bounty-coq10-200-mg-30-kapsul-76032-27-B.jpg?v=1788062723",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "coq10",
        "200mg",
        "dietary",
        "supplement",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 68,
        "safety": 75,
        "transparency": 62,
        "sustainability": 58
      },
      "price": 31.32,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831077654725",
      "vsf_explanation": "Nature's Bounty is a mainstream US supplement brand owned by Bountiful Company with mass-retail distribution. This SKU is a single-ingredient CoQ10 at a disclosed 200 mg per capsule dose taken once daily. CoQ10 has one of the stronger cardiovascular-health evidence bases in the supplement category: the Q-SYMBIO trial (Mortensen 2014) showed CoQ10 300 mg/day reduced major cardiovascular events in chronic heart failure patients, and multiple meta-analyses support use in statin-associated myalgia (Fedacko 2013, Banach 2015). 200 mg is a reasonable daily dose — the studied range is 100-400 mg with mid-range trials at 200 mg showing measurable serum-level increases. Ubiquinone (oxidized) vs ubiquinol (reduced) form matters somewhat — ubiquinol has 2-3x better bioavailability in older adults — but Nature's Bounty typically uses ubiquinone which is fine for most users. Standard-tier entry. USP verification and disclosed form (ubiquinone vs ubiquinol) would push toward Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "approved-medical-solutions-nitric-oxide-supplements-60ct",
      "title": "Approved Medical Solutions Nitric Oxide Supplements - 60ct",
      "vendor": "Orthopedic Outfitters",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/orthout_approved-medical-solutions_nitric-oxide-supplements_1.jpg?v=1788062776",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "approved",
        "medical",
        "solutions",
        "nitric",
        "oxide",
        "supplements",
        "60ct",
        "orthopedic",
        "outfitters"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 48,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 42,
        "sustainability": 50
      },
      "price": 64.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831079260357",
      "vsf_explanation": "The Approved Medical Solutions Nitric Oxide Supplement positions itself against category incumbents (Berkeley Life, HumanN's Neo40, Superbeets) by dismissing L-arginine, beets, and spinach as either ineffective (arginine over 40) or oxalate-risky (beets, spinach), and by claiming to use 'the highest N-O-containing food.' That claim is where the product loses credibility: no publicly disclosed quantitative Supplement Facts panel is available at the title level for this SKU, the specific plant-derived nitrate source is not named, and per-serving nitrate content is not disclosed. Whole-food nitrate concentrations are dominated by leafy greens (arugula 480 mg/100g nitrate; spinach ~740 mg/100g; beets ~300 mg/100g in the flesh) — the claim to have found 'the highest' NO-containing food without naming it, and while dismissing the specific top-nitrate leafy greens, is inconsistent with the underlying phytochemistry. On oxalate safety, the concern about spinach and beet oxalates is real for kidney-stone-prone individuals but is systematically overstated in wellness-marketing versus its actual population risk. Without disclosure of the ingredient, the specific dose, and per-lot COA data, the product can't be evaluated on formulation or safety. Rejected on transparency and misleading-naming grounds: 'nitric oxide supplement' with undisclosed source, undisclosed dose, and marketing that positions against the mechanism (dietary nitrate → nitrite → NO) rather than for it. Would move to Standard 58+ with full disclosure of source plant, nitrate content per serving, and per-lot COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "approved-medical-nitric-oxide-indicator-strips-50-count",
      "title": "Approved Medical Nitric Oxide Indicator Strips - 50 Count",
      "vendor": "Orthopedic Outfitters",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/AMS_nitirc_oxide_indicator_strips_front.webp?v=1788062822",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "approved",
        "medical",
        "nitric",
        "oxide",
        "indicator",
        "strips",
        "count",
        "orthopedic",
        "outfitters"
      ],
      "vsf_category": "diagnostics_testing",
      "vsf_subcategory": [
        "nutrient_deficiency_testing"
      ],
      "vsf_dimensions": {
        "analytical_validity": 45,
        "clinical_utility": 45,
        "transparency": 55,
        "build_quality": 55,
        "warranty_support": 50,
        "value": 55
      },
      "price": 42.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831081095365",
      "vsf_explanation": "Salivary nitric-oxide test strips (Approved Medical / Approved Medical Solutions and comparable branded strips like Berkeley Life and Neogenis / HumanN) measure salivary nitrite as a proxy for whole-body nitric oxide status. The analytical-validity concern is meaningful: salivary nitrite reflects the enterosalivary nitrate cycle — dietary nitrate (leafy greens, beets) is reduced to nitrite by oral commensal bacteria on the tongue — and is only a partial and heavily-diet-timing-dependent proxy for actual physiological nitric-oxide bioavailability and endothelial function. Peer-reviewed comparisons of salivary strip results against plasma nitrate/nitrite and against flow-mediated dilation (the gold standard for endothelial-NO function) show modest correlation at best, with meaningful noise from recent meal, oral hygiene, antibacterial mouthwash use (which suppresses the oral bacteria that make the reduction happen), and hydration. Practically: a low strip reading might reflect low dietary nitrate intake, recent chlorhexidine mouthwash, or high oral acidity — not necessarily impaired systemic NO physiology. Clinical utility for a consumer testing NO status is limited: the actionable intervention (eat more leafy greens or beets) is a general dietary recommendation that doesn't require a strip result. Rejected on analytical-validity and clinical-utility grounds — the strip measures something real but it's a poor proxy for the underlying question, and the resulting action is diet advice a user could act on without the strip. Would move to Standard 58+ with published third-party validation against plasma nitrate/nitrite and clear disclosure of the confounders.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "brownmed-imak-arthritis-gloves",
      "title": "Brownmed IMAK Arthritis Gloves",
      "vendor": "Orthopedic Outfitters",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/orthout_brownmed_arthritis-gloves_2.jpg?v=1788062821",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "brownmed",
        "imak",
        "arthritis",
        "gloves",
        "orthopedic",
        "outfitters"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "compression_therapy"
      ],
      "vsf_dimensions": {
        "analytical_validity": 62,
        "clinical_utility": 68,
        "transparency": 65,
        "build_quality": 68,
        "warranty_support": 60,
        "value": 65
      },
      "price": 18.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831080931525",
      "vsf_explanation": "The IMAK Compression Arthritis Gloves (Brownmed) are one of the few compression-glove products carrying the Arthritis Foundation's Ease of Use Commendation — a real, structurally-independent credential based on the Foundation's usability evaluation. The clinical claim is mild compression plus warmth for symptomatic relief of arthritic hand pain and stiffness, and the evidence base for mild-compression gloves in rheumatoid arthritis and hand osteoarthritis is genuinely supportive: multiple RCTs (Rennie 1996, Hammond 2014 and follow-up) show modest short-term reductions in perceived pain and morning stiffness with compression-glove use, and the effect is one of the better-supported non-pharmacologic hand-arthritis interventions. Effect sizes are small-to-moderate and symptomatic rather than disease-modifying. Build quality is solid — breathable cotton-and-lycra construction, fingerless design allowing hand function during wear, sizing across XS-XL. Brownmed is a legitimate medical-supply company with practitioner-channel distribution. Standard 64 reflects a genuinely evidence-supported compression garment with an independent credential and reasonable build. Would move to Verified 70+ with published measured compression profile (mmHg), extended warranty, and clearer positioning for both RA and OA hand indications.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "rangemaster-blueranger-shoulder-pulley",
      "title": "RangeMaster BlueRanger Shoulder Pulley",
      "vendor": "Orthopedic Outfitters",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/orthout_rangemaster_blueranger_1.jpg?v=1788062822",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "rangemaster",
        "blueranger",
        "shoulder",
        "pulley",
        "orthopedic",
        "outfitters"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "stretch_mobility"
      ],
      "vsf_dimensions": {
        "analytical_validity": 62,
        "clinical_utility": 68,
        "transparency": 60,
        "build_quality": 65,
        "warranty_support": 58,
        "value": 62
      },
      "price": 14.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831081160901",
      "vsf_explanation": "RangeMaster (OPTP-adjacent PT-channel brand) BlueRanger Shoulder Pulley is a classic post-surgical and rehabilitation tool used for passive-range-of-motion (PROM) and active-assisted-range-of-motion (AAROM) shoulder work — the standard intervention for post-rotator-cuff-repair, post-shoulder-arthroplasty, adhesive-capsulitis (frozen shoulder), and chronic shoulder-mobility limitations. The door-mounted pulley system uses the uninvolved arm to assist the involved arm through elevation, flexion, and abduction ranges, with the pulley bracket providing mechanical advantage and controlled range. Evidence base for pulley-assisted shoulder mobility is solid within its clinical role: multiple post-operative rehab protocols and RCTs include pulley work as a core PROM/AAROM component in the early rehabilitation phase, particularly for frozen shoulder where progressive mobility work is the primary intervention (Diercks 2004, Neviaser 2011 review). Effect is directly on range of motion, and improved ROM is a clinically meaningful outcome for the target users. Build quality on RangeMaster is institutional-PT-grade with metal bracket and nylon strap options for door mounting. Standard 62 reflects legitimate clinical tool used correctly, with the practical caveat that home use without PT-directed progression can produce diminishing returns or provoke pain if pushed too hard. Would move to Verified 70+ with a companion progression protocol, extended warranty, and published clinical-outcome data for home-use variants.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "biofreeze-pain-relief-roll-on",
      "title": "Biofreeze Pain Relief Roll-on",
      "vendor": "Orthopedic Outfitters",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/UBHB_biofreezepro3ozrollon-colorless.webp?v=1788062826",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "biofreeze",
        "pain",
        "relief",
        "roll",
        "orthopedic",
        "outfitters"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "contrast_therapy"
      ],
      "vsf_dimensions": {
        "analytical_validity": 65,
        "clinical_utility": 65,
        "transparency": 65,
        "build_quality": 62,
        "warranty_support": 58,
        "value": 65
      },
      "price": 13.73,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831081423045",
      "vsf_explanation": "Biofreeze (Performance Health) is the incumbent professional-channel topical menthol analgesic — the product most commonly seen in physical therapy, chiropractic, athletic training, and massage-therapy practice settings across the US. Formula is menthol-based (3.5% in the standard formulation, up to 10.5% in the professional formulation depending on SKU; this roll-on typically runs 3.5%), with the counterirritant analgesic effect mediated by TRPM8 cooling-receptor activation. Evidence base is the strongest of the topical menthol category: Sundstrup 2014 and multiple ATC-supervised RCTs show modest reductions in perceived low-back and neck pain, DOMS, and post-activity soreness, and Biofreeze has been the reference topical menthol product in a significant fraction of the published topical-rubefacient literature. Effect sizes are small-to-moderate and short-duration (1-4 hours), and the product is symptomatic rather than disease-modifying. Roll-on delivery format is a genuine value-add for practitioner use — clean application, no hand contact, easy over-clothes-adjacent use. Performance Health is a legitimate cGMP-regulated OTC manufacturer with published labeling and FDA-registered OTC status. Standard 63 sits at the top of the topical-analgesic tier for us: strongest evidence base and reputation in the category. Would move to Verified 70+ with head-to-head RCT superiority evidence versus generic OTC menthol competitors and clearer disclosure of exact menthol percentage on retail SKUs.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "biotone®-ease-z-diabetics-pain-relieving-foot-cream",
      "title": "BIOTONE® EASE-Z Diabetics' Pain Relieving Foot Cream",
      "vendor": "Orthopedic Outfitters",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/EASE-Z-Pain_Front_Dealer.webp?v=1788062826",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "biotone",
        "ease",
        "diabetics",
        "pain",
        "relieving",
        "foot",
        "cream",
        "orthopedic",
        "outfitters"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "contrast_therapy"
      ],
      "vsf_dimensions": {
        "analytical_validity": 50,
        "clinical_utility": 50,
        "transparency": 52,
        "build_quality": 55,
        "warranty_support": 45,
        "value": 50
      },
      "price": 17.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831081455813",
      "vsf_explanation": "The EASE-Z Diabetics' Pain Relieving Foot Cream from BIOTONE combines zinc (barrier and skin-soothing), capsaicin (topical analgesic with modest evidence for diabetic neuropathy pain — Derry 2017 Cochrane review supports high-concentration capsaicin patches for post-herpetic and diabetic neuropathy but consumer-grade OTC concentrations show weaker signal), and menthol (TRPM8 counterirritant analgesia) in a formulation specifically indicated for diabetic foot pain and neuropathy symptoms. The formulation itself is competent and the indication is real (diabetic peripheral neuropathy is a well-established clinical concern), but the same scope problem as the EASE-Z Dry Skin variant applies here: this is a condition-specific medical adjunct for a chronic-disease population, not a biohacking or general-wellness recovery product. Diabetics with painful peripheral neuropathy need clinician-directed care — pharmacologic (gabapentinoids, SNRIs), interventional, and appropriate topical adjuncts — with monitoring, not consumer-platform recommendations. Vyvata is not the correct sales channel for medical-management adjuncts. Rejected under out_of_scope_for_biohacking on the same rationale as the sibling SKU: not a quality issue with the product, a fit issue with the platform. Would become listable at Standard 55+ only if repositioned as general-population topical foot-pain relief (dropping the diabetic-specific indication).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bsn-medical-leukotape-p-sports-tape-1-5in-x-15yds",
      "title": "BSN Medical Leukotape P Sports Tape - 1.5in x 15yds",
      "vendor": "Orthopedic Outfitters",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/orthout_bsn-medical_leukotape-p_1.jpg?v=1788062826",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bsn",
        "medical",
        "leukotape",
        "sports",
        "tape",
        "5in",
        "15yds",
        "orthopedic",
        "outfitters"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "compression_therapy"
      ],
      "vsf_dimensions": {
        "analytical_validity": 65,
        "clinical_utility": 68,
        "transparency": 62,
        "build_quality": 70,
        "warranty_support": 55,
        "value": 65
      },
      "price": 13.91,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831081488581",
      "vsf_explanation": "Leukotape P (BSN Medical, now Essity) is a category-defining rigid athletic strapping tape used across the physical-therapy, athletic-training, and sports-medicine channels. The specific value proposition is high-strength rigid tape with a zinc-oxide adhesive, purpose-built for joint immobilization, patellofemoral taping techniques (McConnell technique for anterior knee pain), shoulder realignment, and structural support of joints where a flexible kinesiology tape would not provide the necessary rigidity. Evidence for taping-based interventions is technique-specific: McConnell patellar taping has RCT support for short-term reduction of anterior knee pain (Callaghan 2012 and related work); rigid strapping for ankle-sprain support has evidence for reducing recurrence during return-to-activity (though external ankle brace evidence is stronger); kinesiology taping (a different product class) has weaker evidence overall. Leukotape's zinc-oxide adhesive is genuinely stronger than most consumer athletic tapes and is the correct choice when the technique requires the tape to actually hold the joint under load. Manufacturing by Essity meets pharmaceutical-grade quality standards. Skin-reaction rate to zinc-oxide adhesive is meaningfully higher than to hypoallergenic athletic tape, and Leukotape is typically applied over a hypoallergenic underwrap (Cover-Roll) rather than directly on skin. Standard 64 reflects a genuinely professional-grade product used correctly, with the caveat that home use without technique training limits utility. Would move to Verified 70+ with a companion application-technique protocol and clearer disclosure of skin-sensitivity handling.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "biotone®-ease-z-diabetics-dry-skin-therapy-foot-cream",
      "title": "BIOTONE® EASE-Z Diabetics' Dry Skin Therapy Foot Cream",
      "vendor": "Orthopedic Outfitters",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/EASE-Z_Foot_Front_Dealers.webp?v=1788062873",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "biotone",
        "ease",
        "diabetics",
        "dry",
        "skin",
        "therapy",
        "foot",
        "cream",
        "orthopedic",
        "outfitters"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "compression_therapy"
      ],
      "vsf_dimensions": {
        "analytical_validity": 48,
        "clinical_utility": 50,
        "transparency": 52,
        "build_quality": 55,
        "warranty_support": 45,
        "value": 50
      },
      "price": 15.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831084142789",
      "vsf_explanation": "BIOTONE's EASE-Z Diabetics' Dry Skin Therapy Foot Cream is a competently formulated diabetic-specific foot care product (zinc-based barrier, shea butter and lecithin moisturizing components) marketed to a legitimate clinical need: diabetic peripheral neuropathy and diabetic-foot skin breakdown are well-established complications requiring dedicated skincare. The product is honest about its indication and BIOTONE is a real brand. The issue for a Vyvata listing is scope: this is a condition-specific medical skincare product for diabetics, not a biohacking-optimization or general-wellness recovery product. Vyvata's platform is for consumers making choices about performance, recovery, sleep, diagnostics, and cognitive-supplement products — not for medical-management adjuncts for chronic conditions like diabetes. The category taxonomy has no clean home for diabetic-foot skincare, and the buyer motivation is disease management rather than wellness optimization. Placed under compression_therapy only because there is no better subcategory fit. Rejected as out_of_scope_for_biohacking — not because the product is harmful or dishonest, but because the platform is not the correct channel. Diabetic-foot skincare belongs in a medical-retail or pharmacy channel with clinician guidance. Would become listable at Standard 55+ only if repositioned as general-population dry-foot skincare (dropping the diabetic-specific indication and the medical-adjacent claims).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "stopain-clinical-pain-relief",
      "title": "Stopain Clinical Pain Relief",
      "vendor": "Orthopedic Outfitters",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/orthout_stopain-clinical_gel_3.jpg?v=1788062876",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "stopain",
        "clinical",
        "pain",
        "relief",
        "orthopedic",
        "outfitters"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "contrast_therapy"
      ],
      "vsf_dimensions": {
        "analytical_validity": 62,
        "clinical_utility": 62,
        "transparency": 65,
        "build_quality": 60,
        "warranty_support": 55,
        "value": 62
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831084306629",
      "vsf_explanation": "Stopain Clinical is a professional-strength topical analgesic marketed by Troikaa Pharmaceuticals through practitioner and DTC channels. The formula discloses 10% menthol as the primary counterirritant active, with dimethylsulfone (MSM) and glucosamine included as ancillary joint-support ingredients. Topical menthol at 5-10% is a genuinely evidence-supported category — the Cochrane and academic-review literature (e.g., Derry 2017 for topical rubefacients; Higashi 2010 for menthol RCTs in DOMS and low-back pain) shows modest, real, short-term analgesic effect via TRPM8 receptor activation and a cooling counterirritant sensation. Effect sizes are small-to-moderate and short-duration (typically 1-4 hours per application), and topical menthol is not disease-modifying — it is symptomatic relief. The MSM and glucosamine additions are honest additions but the transdermal absorption evidence for oral-dose systemic-joint effects is thin; consider them as label-credibility inputs rather than proven joint-modifying actives. Manufactured by Troikaa (a legitimate Indian pharmaceutical company operating cGMP facilities), OTC-compliant labeling, gel-and-roll-on forms. Standard 60 sits at the middle of the topical-analgesic tier for us — real ingredient, honest labeling, modest evidence base. Would move to Verified 70+ with published head-to-head RCTs against Biofreeze / Icy Hot, and with clearer dose specification for the MSM and glucosamine content per application.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cando-fabstretch-4-level-incline-slant-board",
      "title": "CanDo FabStretch 4-Level Incline/Slant Board",
      "vendor": "Orthopedic Outfitters",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/10-1179_v1.jpg?v=1788062876",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cando",
        "fabstretch",
        "level",
        "incline",
        "slant",
        "board",
        "orthopedic",
        "outfitters"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "stretch_mobility"
      ],
      "vsf_dimensions": {
        "analytical_validity": 65,
        "clinical_utility": 68,
        "transparency": 62,
        "build_quality": 68,
        "warranty_support": 60,
        "value": 65
      },
      "price": 82.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831084372165",
      "vsf_explanation": "CanDo (Fabrication Enterprises) is one of the incumbent US suppliers to the physical-therapy institutional channel — a real practitioner-grade brand, not a DTC white-label. The FabStretch incline/slant board is a heavy-duty plastic board with a 400 lb weight capacity, four discrete angle settings, and a flat-fold design for storage. Calf and Achilles-stretching slant boards have a well-established role in PT rehabilitation for Achilles tendinopathy, plantar fasciitis, calf strains, and general ankle-dorsiflexion mobility work; the mechanistic case (passive gastrocnemius/soleus lengthening under bodyweight) is straightforward and the practical utility is broadly accepted in orthopedic PT even where controlled RCT evidence for the specific intervention is limited. Build quality is at the institutional-durable spec (400 lb capacity is above the ~250-300 lb spec on cheap consumer versions). No electronics, so no reliability decay over time. Standard-issue plastic construction that will not degrade meaningfully with home use. Warranty on CanDo is typically 1-year limited through the institutional channel. Value proposition versus purpose-built wooden professional slant boards (2-4x the price) or cheap 1-angle stamped consumer boards is genuinely middle-of-market. Would move to Verified 70+ with published biomechanical validation of angle-specific dorsiflexion targets, extended warranty terms, and a companion PT protocol / usage guide.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "biotone®-deep-tissue-massage-lotion",
      "title": "BIOTONE® Deep-tissue Massage Lotion",
      "vendor": "Orthopedic Outfitters",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/orthout_biotone_deep-tissue-massage-lotion_2.jpg?v=1788062876",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "biotone",
        "deep",
        "tissue",
        "massage",
        "lotion",
        "orthopedic",
        "outfitters"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "percussion_vibration"
      ],
      "vsf_dimensions": {
        "analytical_validity": 55,
        "clinical_utility": 60,
        "transparency": 58,
        "build_quality": 62,
        "warranty_support": 55,
        "value": 62
      },
      "price": 77.44,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831084404933",
      "vsf_explanation": "BIOTONE is a legitimate practitioner-channel massage-therapy brand (US-based, founded 1979), supplying massage therapists and physical therapists with professional-grade lubricants and lotions. The Deep-tissue formula is designed with a lower glide profile than standard massage oils and cremes — the point is to allow the therapist to actually grip and manipulate tissue rather than skate across it, which matters for trigger-point work, deep-tissue techniques, and myofascial release. Categorization here is genuinely awkward: massage lotion is an adjunct to hands-on or percussion-device recovery work rather than a recovery device in itself, and no subcategory in the taxonomy is a clean fit — percussion_vibration is the closest home because the primary user-context is percussion-massager work and deep-tissue self-massage. Ingredient transparency on BIOTONE professional lotions is standard for the practitioner channel (fragrance-free, hypoallergenic variants available, latex-free), and the brand's clinical reputation is solid across LMT/PT practice. Weakness is that this is a lotion, not a device — the evidence question is 'does deep-tissue massage work' (Grade B/C, modest RCT support for DOMS and short-term flexibility), not 'does this lotion work.' Standard 58 reflects that this is a genuine professional-grade adjunct product but not itself the intervention. Would move to Standard 65+ with published ingredient-level disclosure (allergen list) and clearer positioning as an adjunct rather than a recovery product.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "free-up-massage-cream",
      "title": "Free-Up Massage Cream",
      "vendor": "Orthopedic Outfitters",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/orthout_pre-pak_free-up-massage-cream.jpg?v=1788062876",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "free",
        "massage",
        "cream",
        "orthopedic",
        "outfitters"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "percussion_vibration"
      ],
      "vsf_dimensions": {
        "analytical_validity": 55,
        "clinical_utility": 60,
        "transparency": 60,
        "build_quality": 60,
        "warranty_support": 55,
        "value": 60
      },
      "price": 36.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831084437701",
      "vsf_explanation": "Free-Up is a professional-channel massage cream from PrePak Products, used across the chiropractic, physical-therapy, and manual-therapy segments in the US. It occupies the same category slot as the BIOTONE Deep-tissue Lotion — a lubricant designed for tissue-perception and slow-absorbing use rather than skate-across-skin glide, and marketed specifically for soft-tissue technique work and burn-patient wound care where a slower-absorbing skin-softening cream is required. Practitioner reputation is good; the value proposition is that a small amount lasts long, which is meaningful in a professional practice buying 32-oz or 128-oz sizes. Ingredient panel discloses standard cosmetic-lotion inputs plus soothing agents. Same taxonomy compromise as with BIOTONE — categorized under percussion_vibration as an adjunct rather than as a recovery intervention itself. The evidence question is about the underlying massage technique (soft-tissue work, myofascial release: modest RCT support with small-to-moderate effect sizes for DOMS and short-term flexibility), not the cream. Standard 58 reflects real professional-grade product used correctly as an adjunct. Would move to Standard 65+ with clearer allergen/ingredient disclosure and a companion technique guide.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cando-balance-pad",
      "title": "CanDo Balance Pad",
      "vendor": "Orthopedic Outfitters",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/orthout_fab-ent_cando-balance-pad_1.jpg?v=1788062876",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cando",
        "balance",
        "pad",
        "orthopedic",
        "outfitters"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "stretch_mobility"
      ],
      "vsf_dimensions": {
        "analytical_validity": 62,
        "clinical_utility": 65,
        "transparency": 60,
        "build_quality": 65,
        "warranty_support": 58,
        "value": 65
      },
      "price": 75,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831084470469",
      "vsf_explanation": "The CanDo Balance Pad is a foam proprioception platform used across vestibular rehabilitation, ankle-sprain rehab, geriatric fall-prevention programs, and general postural-control training. CanDo (Fabrication Enterprises) is a real institutional-PT supplier with a mid-market reputation. Dimensions listed (16 x 20 x 2.5 in) match the standard PT-clinic balance-pad footprint, which is important because standing surface size affects the difficulty of the balance task. Foam density is not specified in the listing but institutional-quality CanDo pads use closed-cell EVA foam that holds shape over years of use. Analytical case for balance training is solid: proprioception, ankle-strategy postural control, and vestibular-input adaptation all improve with regular unstable-surface training, and the intervention has RCT support in ankle-sprain rehab (Hupperets 2009), geriatric fall prevention (Sherrington 2019 Cochrane review), and vestibular disorders. Not a high-tech device — no electronics, no reliability decay. Standard 62 reflects legitimate PT-grade product with the practical caveat that a foam pad is a general-fitness input, not a specifically-instrumented recovery intervention. Would move to Standard 68+ with published foam-density spec, extended warranty, and a companion balance-progression protocol.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "incrediwear-elbow-sleeve",
      "title": "Incrediwear Elbow Sleeve",
      "vendor": "Orthopedic Outfitters",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Elbow_Sleeve_Grey_Side_600x_2094d621-1a87-423c-943a-798edcd38552.png?v=1788062876",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "incrediwear",
        "elbow",
        "sleeve",
        "orthopedic",
        "outfitters"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "compression_therapy"
      ],
      "vsf_dimensions": {
        "analytical_validity": 50,
        "clinical_utility": 58,
        "transparency": 55,
        "build_quality": 62,
        "warranty_support": 58,
        "value": 58
      },
      "price": 45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831084503237",
      "vsf_explanation": "Incrediwear is a US-based recovery-apparel brand whose signature claim is that fabric embedded with germanium and carbon microparticles improves peripheral blood flow via infrared re-emission from body heat, thereby accelerating healing and reducing recovery time. That mechanistic claim substantially exceeds the published evidence. The company has sponsored small studies (thermographic imaging showing skin-surface warmth changes, and industry-funded proof-of-concept pilots) but there are no independent large-scale RCTs demonstrating clinically meaningful acceleration of soft-tissue healing versus a matched control compression garment, and the germanium-and-carbon infrared-emission mechanism as a therapy is not supported by controlled physiological data at the doses and duration realistically achievable through fabric contact. That said, the garment itself is a competently-constructed lightweight compression elbow sleeve — breathable, low-profile, non-slip — and mild compression (10-20 mmHg range typical for consumer sleeves) does have modest evidence for perceived recovery, proprioceptive feedback, and swelling control after activity. Standard 56 reflects that the sleeve as a compression garment is legitimate and useful, while the specific brand claim ('semiconductor-fabric accelerates healing') is a marketing overreach that we flag rather than endorse. Would move to Standard 62+ with retracted/toned-down healing-acceleration claims, and Verified only with independent RCT evidence for the fabric-specific mechanism.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "orzax-ocean-daily-one-energy-30-tablets-multivitamin-mineral",
      "title": "Orzax Ocean Daily One Energy - 30 Tablets | Multivitamin & Mineral",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f7kZ6BaF1l4dbTPt2omFecADdYT65GKFnTvVt2hV_6b9294ee-542e-4541-8a50-1cba266a937d.jpg?v=1788062909",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "orzax",
        "ocean",
        "daily",
        "one",
        "energy",
        "tablets",
        "multivitamin",
        "mineral",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 16.12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831085486277",
      "vsf_explanation": "Orzax is an established Turkish supplement brand with real distribution across European and Middle Eastern markets. 'Ocean Daily One Energy' is their once-daily multivitamin/multimineral tablet formulated for adults with the standard vitamin panel (A, C, D, E, K, B-complex) plus essential minerals (iron, zinc, magnesium, calcium, potassium) and antioxidant trace minerals (selenium, copper, manganese). This is textbook once-daily multi formulation. Once-daily multis have a modest evidence base — meta-analyses (COSMOS-Web 2022) show small but measurable cognitive-aging benefits for older adults using standard-formula multis, and the CDC 2010 NHANES analysis confirmed multivitamin use closes measurable micronutrient shortfalls in Americans not eating five daily servings of fruit/vegetables. Standard-tier entry. Held back from higher marks by no visible USP or ConsumerLab verification and by the presence of iron in an adult once-daily (iron is appropriate for menstruating women but unnecessary and potentially harmful for adult men and post-menopausal women).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "an-chi-huan-heng-dietary-fudge",
      "title": "An Chi Huan Heng Dietary Fudge",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/16f2c514-bdd3-4bd6-b072-6c54a0456fb7.jpg?v=1788062950",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chi",
        "huan",
        "heng",
        "dietary",
        "fudge",
        "vivalo"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 28,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 20,
        "sustainability": 32
      },
      "price": 24.92,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831086665925",
      "vsf_explanation": "This is a dropshipping listing (cf.cjdropshipping.com images visible in metadata) with a Chinese-market product name transliterated into English ('An Chi Huan Heng'). Ingredient list is briefly disclosed — vitamin D3, magnesium, zinc, unspecified 'vitamin,' GABA, and L-theanine — as a 60-gummy sleep-adjacent format. The ingredient shortlist is reasonable for a sleep supplement (magnesium and L-theanine both have moderate evidence for sleep-onset support at studied doses of 200-400 mg magnesium and 200 mg L-theanine), but doses are not disclosed and the 'vitamin' entry is undefined. There is no identifiable brand behind the product (transliterated Chinese phrase is not a brand), no manufacturer of record, no third-party testing, and no chain-of-custody documentation. Chinese-import supplements without FDA-facility registration have documented adulteration and quality-control issues. Autofails on no_brand_provenance and proprietary_blend_hides_dose. Middling-not-worst safety score because the disclosed ingredient shortlist is at least category-appropriate.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "daily-nutritional-supplement-capsules-for-overall-health-and-wellness",
      "title": "Daily Nutritional Supplement Capsules For Overall Health And Wellness",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/50b54d81-ec69-4f5b-b97b-e63bc347fcbe.jpg?v=1788062957",
      "score": 24,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "daily",
        "nutritional",
        "supplement",
        "capsules",
        "for",
        "overall",
        "health",
        "and",
        "wellness",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 12,
        "formulation": 18,
        "manufacturing": 25,
        "safety": 32,
        "transparency": 10,
        "sustainability": 28
      },
      "price": 20.56,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831086895301",
      "vsf_explanation": "This is a raw dropshipping listing with a keyword-string title ('Daily Nutritional Supplement Capsules For Overall Health And Wellness'), CJ-dropshipping-sourced images (cf.cjdropshipping.com URLs), zero brand identification, zero ingredient list, and metadata written in body-care-product template language ('Skin Type: All Skin Types, Category: Body Care Set, Applicable Area: Universal') that has clearly been auto-populated from a wholesale template rather than reflecting an actual product. There is no way to determine what is in the capsules, who makes them, or what any dose is. Autofails simultaneously on no_brand_provenance, misleading_naming (generic keyword title, template category mismatch), and proprietary_blend_hides_dose. Not listable in any recoverable form.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "bucked-up-pre-workout",
      "title": "Bucked Up Pre-Workout",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Bucked-Up-Pre-Workout_8bae4c0d.jpg?v=1788062979",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bucked",
        "pre",
        "workout",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 39.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831087419589",
      "vsf_explanation": "The original Bucked Up Pre-Workout is the moderate-stim sibling to Woke AF — same fully-disclosed dosing philosophy, same 6 g L-citrulline malate, same brand-signature deer antler velvet, but with the caffeine dialed to 200 mg per scoop rather than the ~333 mg of Woke AF. That caffeine level is a genuine strength: it sits in the well-tolerated 150-250 mg range for a training session, leaves room in the day's total caffeine budget, and rarely causes the sleep-disruption problems the high-stim pre-workouts do. The 6 g of citrulline malate hits the evidence-supported pump/endurance range (Bailey 2015, Perez-Guisado 2010). Beta-alanine dosing is honest at label-decoration-vs-clinical (~2 g per scoop, below the 3.2-6.4 g ISSN dose but usable across the day). Alpha-GPC and taurine are present at sub-effective label-credibility doses. Deer antler velvet remains the brand-signature marketing input with no controlled human RCTs supporting the IGF-1 pathway claim at oral pre-workout doses. Manufacturing is cGMP-registered US contract; per-lot COAs available on request; no Informed Sport or NSF Certified for Sport designation on this SKU. Overall: this is the correct default Bucked Up SKU for most users — clean stim load, real citrulline dose, honest label, weaker on the cognitive/adaptogen stack. Would move to Verified 70+ with Informed Sport certification, clinically-dosed alpha-GPC (600 mg), and dropping the deer antler velvet marketing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dark-labs-creatine-500g-expired-06-2026",
      "title": "Dark Labs Creatine 500g (Expired 06/2026)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Dark-Labs-Creatine-500g-Expired-062026.jpg?v=1788062990",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dark",
        "labs",
        "creatine",
        "500g",
        "expired",
        "2026",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 35,
        "manufacturing": 32,
        "safety": 30,
        "transparency": 25,
        "sustainability": 45
      },
      "price": 9.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831088894149",
      "vsf_explanation": "This SKU carries an expiration date of 06/2026 and is being listed for sale on 2026-08-29 — two months past its stated shelf life. That is the entire finding. Creatine monohydrate itself is one of the most stability-tested supplement raw materials in the category (moisture is the primary degradation vector, and dry powder in a sealed container remains stable for years past printed dates in most tested lots), so the product may well still be efficacious. But selling an expired product with the expiration status disclosed in the product title and no updated third-party lot testing is a listing-integrity problem independent of the ingredient. There is also no product description, no dose disclosure, no confirmation of monohydrate versus a less-supported salt form (creatine HCl, ethyl ester, etc.), no third-party purity certification, and no publisher COA for the specific lot being sold post-expiry. Rejected as a listing on safety-and-integrity grounds. Vyvata's rule of thumb: a supplement past its printed expiration is not listable regardless of chemical stability, because the consumer contract implied by the expiration date has been broken by the seller. Would become listable at Standard 60-68 if replaced with a current-dated Dark Labs Creatine SKU that discloses form (creatine monohydrate), dose (5 g per scoop), and per-lot COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dragon-pharma-venom-new",
      "title": "Dragon Pharma Venom (New)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Dragon-Pharma-Venom-New.webp?v=1788062997",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dragon",
        "pharma",
        "venom",
        "new",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 40,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 59.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831089156293",
      "vsf_explanation": "Dragon Pharma VENOM is a very-high-stimulant pre-workout carrying 400 mg of caffeine per serving, marketed for experienced users only. Even taking the brand's marketing at face value on 'clinically dosed performance ingredients,' the 400 mg single-scoop caffeine load is the primary problem: it hits FDA's total-day guidance in a single dose, leaves no room for coffee, a stacked pump product, or a second scoop, and pushes cardiovascular and sleep-disruption risk into a range where Vyvata will not list. That threshold applies even when the rest of the formula is competent. The reformulated (New) VENOM improved dose disclosure over the earlier prop-blend version, and Dragon Pharma operates cGMP-registered US contract manufacturing, but published per-lot COAs and third-party sport certification (Informed Sport / NSF Certified for Sport) are not standard on this line. Combined with the caffeine load, and typical secondary stimulants in the category (theobromine, higenamine or synephrine analogs common in 400 mg-caffeine pre-workouts) the safety profile is a hard gate. Rejected on safety grounds — not because the ingredients are novel or unstudied, but because the total stimulant load at a single serving crosses the guardrail we set for a home-use consumer product. Would become listable at Standard 55-62 with a caffeine cap at ~300 mg per scoop, dropping any synephrine/higenamine-class secondary stimulants, and adding Informed Sport certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mutant-whey-5lbs",
      "title": "Mutant Whey, 5lbs",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/mutant-whey-5lbs-chocolate..jpg?v=1788063007",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mutant",
        "whey",
        "5lbs",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 65,
        "safety": 72,
        "transparency": 58,
        "sustainability": 52
      },
      "price": 69.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831089549509",
      "vsf_explanation": "Mutant is a Canadian sports-nutrition brand with real distribution and a long-running catalog. Whey protein is one of the most rigorously studied categories in sports nutrition — the class-level evidence for whey supporting muscle protein synthesis and recovery is essentially settled (Cermak 2012 meta-analysis, Morton 2018 meta-analysis). 5 lb bulk whey is a commodity format where value is judged on protein-per-serving, amino profile, digestibility, and third-party testing rather than novel ingredient innovation. Standard-tier entries in this category typically publish per-serving protein grams, leucine content, and micronutrient contribution. Mutant Whey is a whey blend rather than isolate-only, which is a formulation choice that trades slightly higher lactose for lower cost. Held back from Verified by absence of visible sport certification and by generic marketing copy that does not disclose the specific blend ratios in the metadata excerpt.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrex-eaa-hydration-30-servings",
      "title": "Nutrex EAA+ Hydration, 30 Servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/EAA-MT.webp?v=1788063015",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrex",
        "eaa",
        "hydration",
        "servings",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831089844421",
      "vsf_explanation": "Nutrex Research is a legitimate US sports-nutrition brand with distribution at mass retailers and gyms. This SKU delivers 8 g of essential amino acids per serving including 6 g of BCAAs, plus electrolytes for hydration. Doses are disclosed at the class level, which is the primary requirement — 8 g EAA is at or near the anabolic threshold identified in Wolfe 2017 leucine-signaling work (~3 g leucine, roughly consistent with 6 g BCAA if leucine share is ~40-50%). The hydration angle is straightforward electrolyte replacement. The class-level RCT evidence for EAAs supporting recovery and preserving lean mass during caloric deficit is reasonable (Wolfe 2017 review, Church 2020). Held back from Verified by absence of visible third-party sport certification (Informed Sport, NSF Sport), which is a meaningful signal for competitive athletes given the historical contamination risk in this category. Solid Standard entry.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dr-loves-moringa",
      "title": "Dr Love's Moringa",
      "vendor": "Dr. Robert Love’s Supplements",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Moringa1bottle.png?v=1788063034",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "love",
        "moringa",
        "robert",
        "love",
        "supplements"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 45,
        "manufacturing": 52,
        "safety": 55,
        "transparency": 42,
        "sustainability": 50
      },
      "price": 59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831090663621",
      "vsf_explanation": "Dr. Robert Love is a chiropractor and social-media health personality with a branded supplement line. This SKU is a moringa product marketed simultaneously as a brain nootropic ('Superfood for Your Brain,' 'boosts memory,' 'eliminates brain fog') AND a metabolic-support supplement ('supports healthy cholesterol and blood sugar levels'). Moringa oleifera has a moderate ingredient-level evidence base — several small RCTs support modest glycemic and lipid effects at high daily doses (typically 4-8 g of leaf powder), and it is nutrient-dense as a food ingredient. It does NOT have peer-reviewed human RCT evidence for the specific cognitive claims (memory, brain fog elimination). The 'eliminates brain fog' and 'boosts memory' language is unverified_medical_claim territory, and cholesterol/blood-sugar are borderline disease claims that FDA has warned supplement brands about. Autofail on unverified_medical_claim. Middling scores reflect that moringa itself is a real, reasonably safe botanical — not an endorsement of the specific claims.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "raw-nutrition-cbum-series-thavage-pre-workout",
      "title": "Raw Nutrition CBUM Series Thavage Pre-Workout",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Raw-Nutrition-CBUM-Series-Thavage-Pre-Workout.webp?v=1788063082",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "raw",
        "nutrition",
        "cbum",
        "series",
        "thavage",
        "pre",
        "workout",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 52,
        "transparency": 68,
        "sustainability": 52
      },
      "price": 49.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831092007109",
      "vsf_explanation": "Thavage is the flagship pre-workout in Raw Nutrition's CBUM Series (co-developed with 5x Mr. Olympia Chris Bumstead) and is one of the fully-disclosed high-stimulant formulas in the athlete-signature segment. The full label discloses individual doses: 8 g L-citrulline (above the 6-8 g clinical range for pump/endurance — genuinely well-dosed), 3.2 g beta-alanine (hits the ISSN position-stand dose for the tingle and chronic carnosine loading), 2.5 g betaine anhydrous (in the 2.5 g clinical range for power output; Cholewa 2013), 1 g L-tyrosine (below the 2-3 g clinical range for stress-cognition endpoints), 300 mg alpha-GPC 50% (yields ~150 mg alpha-GPC — well below the 600 mg cognitive dose), and a stimulant stack of ~275 mg caffeine anhydrous plus dicaffeine malate (Infinergy) — putting effective caffeine at ~325-340 mg per scoop. Formulation quality is genuinely above the market median for the category, and the athlete-brand co-development doesn't come at the cost of scientific rigor on citrulline, beta-alanine, and betaine. Weaknesses: alpha-GPC and tyrosine are under-dosed for their cognitive-effect ranges (present at what look like label-decoration doses); the ~330 mg total caffeine load is at the upper end for a single scoop; no third-party sport certification (Informed Sport / NSF) on this SKU. Manufactured in cGMP-registered US facility. Would move to Verified 70+ with Informed Sport certification, clinically-dosed alpha-GPC (600 mg) and tyrosine (2 g), and published per-lot COAs.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bucked-up-woke-af-high-stimulant-pre-workout",
      "title": "Bucked Up Woke AF High-Stimulant Pre-Workout",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Bucked-Up-Woke-AF-High-Stimulant-Pre-Workout.jpg?v=1788063120",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bucked",
        "woke",
        "high",
        "stimulant",
        "pre",
        "workout",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 68,
        "manufacturing": 65,
        "safety": 55,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 52.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46927237251269",
      "vsf_explanation": "Bucked Up (Das Labs) is a legitimate mid-tier US sports-nutrition brand that publishes fully-disclosed formulas rather than proprietary blends — a real transparency win in a category dominated by opaque \"energy matrix\" prop blends. Woke AF is the brand's high-stimulant pre-workout, built around 6 g L-citrulline (meets the 6-8 g clinical range for nitric-oxide-mediated pump and endurance benefit; see Bailey 2015, Perez-Guisado 2010), 2 g beta-alanine (below the 3.2-6.4 g dose used in the ISSN position stand for chronic loading, but usable if stacked across the day), and a stimulant matrix built on ~333 mg caffeine anhydrous plus dicaffeine malate and methylliberine — putting the effective caffeine load at the upper end of what's considered safe in a single serving for caffeine-tolerant users. Evidence-supported ingredients (citrulline, beta-alanine, caffeine, alpha-GPC at 200 mg) share the label with weaker choices: deer antler velvet is a marketing signature but has no controlled evidence for pre-workout endpoints in humans, and \"AlphaSize\" alpha-GPC is at the sub-cognitive-effect dose (600 mg is the typical clinical dose for acute focus effects). Manufacturing is done in cGMP-registered US facilities and Bucked Up publishes lot COAs on request. No third-party certification (Informed Sport, NSF Certified for Sport) is standard on the line, which is a real gap for competitive athletes. Would move to Verified 70+ with a full Informed Sport certification, published lot COAs, and dropping the sub-effective alpha-GPC / deer antler velvet in favor of clinically-dosed inputs.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "max-test™-testosterone-booster-120-capsules",
      "title": "Max Test™, Testosterone Booster, 120 Capsules",
      "vendor": "Price Is Right Miami",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/287fde60-8bcb-403a-ac28-e327f42129b4.jpg?v=1788063124",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "max",
        "test",
        "testosterone",
        "booster",
        "120",
        "capsules",
        "price",
        "right",
        "miami"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 35,
        "manufacturing": 45,
        "safety": 52,
        "transparency": 22,
        "sustainability": 40
      },
      "price": 69.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831094595781",
      "vsf_explanation": "Product copy is a single sentence — 'Max Test is a testosterone booster supplement, 120 capsules per bottle, aimed at supporting men's fitness goals. See label photos for full ingredient and serving details.' The 'see label photos' instruction pushes the entire evaluation to images not present in the reviewed metadata, which is functionally a non-disclosure. There is no identifiable brand behind 'Max Test' (it is a common generic supplement name reused by multiple manufacturers), no dose, no ingredient list, no manufacturer of record, and no evidence base. This fails multiple autofails simultaneously — misleading_naming (generic name reused across manufacturers), no_brand_provenance, and proprietary_blend_hides_dose. Male-hormonal-claim products with this level of opacity are precisely the category the FDA repeatedly flags for undeclared PDE5 or aromatase-inhibitor adulteration.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "testosterone-booster-cp-60",
      "title": "Testosterone Booster Cp 60",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/247026857_3534b06d-d484-4a2f-8ae8-d55bd7cb8adb.jpg?v=1788063158",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "testosterone",
        "booster",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 38,
        "manufacturing": 48,
        "safety": 52,
        "transparency": 28,
        "sustainability": 42
      },
      "price": 14.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831095447749",
      "vsf_explanation": "This is Cybergenics 'Isotest,' another SKU in the same revived-1990s-bodybuilding brand family as the Cybergenics Maximum Male multivitamin scored above. Product copy is entirely marketing language — 'science-based product... safe and highly effective ingredients... designed to support maximum male performance' — with no visible facts panel, no ingredient list, no dose disclosure, and no third-party testing referenced. The pattern is the same as other 1990s-legacy T-booster brands relaunched with new ownership: recognizable brand name, minimal disclosure, generic proprietary formula. Autofail on proprietary_blend_hides_dose because there is not even a proprietary-blend name to interrogate — the copy discloses nothing at all. Testosterone claims combined with zero disclosure is the strongest possible signal to reject.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "testosterone-booster",
      "title": "TESTOSTERONE BOOSTER",
      "vendor": "APACHE STAR",
      "image_url": "",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "testosterone",
        "booster",
        "apache",
        "star"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 35,
        "sustainability": 48
      },
      "price": 39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831096004805",
      "vsf_explanation": "APACHE STAR Testosterone Booster markets 'natural T-level support' and 'premium ingredients' but the visible product copy does not include a quantitative Supplement Facts panel with per-ingredient doses. The category — natural OTC T-boosters — has a consistent pattern in the peer-reviewed literature: individual ingredients like tribulus, zinc, magnesium, ashwagandha, fenugreek, and D-aspartic acid each have a small number of RCTs, most showing null-to-modest effects in eugonadal men. Even the strongest OTC candidate, ashwagandha (KSM-66 at 300-600 mg), produces T changes of ~10-15% in mostly-untrained subjects — meaningful but far from prescription TRT. Without a panel disclosing which ingredients are included at what doses, this cannot be validated against the RCT literature. Marked autofail proprietary_blend_hides_dose. APACHE STAR does have a real brand footprint (their creatine SKU scored acceptably in a prior batch), so the rejection is specific to the disclosure gap on this SKU rather than a brand-level dismissal.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "collagen-gummies",
      "title": "COLLAGEN GUMMIES",
      "vendor": "APACHE STAR",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/APACHE_STAR_COLLAGEN_GUMMIES.jpg?v=1788063181",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "collagen",
        "gummies",
        "apache",
        "star"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831096201413",
      "vsf_explanation": "APACHE STAR Collagen Gummies pair hydrolyzed marine collagen peptides (from tilapia and cod, disclosed) with vitamin C, zinc, biotin, and vitamin E in an orange-flavored gummy taken as two gummies daily. The formulation choices are sensible: vitamin C is a required cofactor for endogenous collagen synthesis, biotin and zinc support keratin/skin turnover, and hydrolyzed peptides are the collagen form with the strongest human RCT evidence for skin elasticity and hydration (Choi 2019 meta-analysis, Bolke 2019 RCT). The two-gummy-per-day format constrains the achievable peptide dose — clinical trials showing skin benefits generally use 2.5-10 g of collagen peptides per day, and a two-gummy serving typically delivers 1-2.5 g, likely on the low end of clinically meaningful. Manufacturer disclosure of the fish source is a transparency positive; a full milligram-by-milligram Supplement Facts panel and lot COAs would move this into Verified territory. Solid Standard entry with a small-brand handicap.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "2-pack-angry-supplements-test-booster-for-men",
      "title": "2-Pack: Angry Supplements Test Booster for Men",
      "vendor": "EasyOptionXY",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2-pack-angry-supplements-test-booster-for-men-wellness-fitness-dailysale-161277.jpg?v=1788063264",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "pack",
        "angry",
        "supplements",
        "test",
        "booster",
        "for",
        "men",
        "easyoptionxy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 42,
        "manufacturing": 52,
        "safety": 55,
        "transparency": 35,
        "sustainability": 42
      },
      "price": 76.78,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831098429637",
      "vsf_explanation": "Angry Supplements is a real US-based nutraceutical brand carried at mainstream mass retail, and their 'Monster Test' testosterone booster is a familiar SKU. Marketing copy claims '100% natural and pure testosterone-boosting ingredients... tested to the highest standards and proven to work,' which is not supported by any published human RCT of the finished formula. The formula reliably layers tribulus terrestris, zinc, magnesium, and a proprietary blend of adaptogens/herbs at undisclosed doses. As noted for other T-boosters, tribulus has repeatedly failed to elevate testosterone in eugonadal men (Rogerson 2007, Neychev 2005), and zinc/magnesium only correct T levels in the deficient. 'Proven to work' language is a promotional overreach given the actual evidence base. Autofail on proprietary_blend_hides_dose. Manufacturing/safety are middling because the brand is real and mainstream-distributed, not because the specific claims are validated.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "custom-label-supplement-manufacturer-wholesale-tablets-men-power-muscle-support-supplements-male-boost-capsules",
      "title": "Custom Label Supplement Manufacturer Wholesale Tablets Men Power Muscle Support Supplements Male Boost Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/16079ee0-d11f-4662-9fbd-906b4dc25541.jpg?v=1788063326",
      "score": 22,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "custom",
        "label",
        "supplement",
        "manufacturer",
        "wholesale",
        "tablets",
        "men",
        "power",
        "muscle",
        "support",
        "supplements",
        "male",
        "boost",
        "capsules",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 15,
        "manufacturing": 25,
        "safety": 30,
        "transparency": 8,
        "sustainability": 25
      },
      "price": 30.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831099314373",
      "vsf_explanation": "The product title is a raw dropshipping-marketplace keyword string — 'Custom Label Supplement Manufacturer Wholesale Tablets Men Power Muscle Support Supplements Male Boost Capsules' — with images sourced from cf.cjdropshipping.com. There is no identifiable brand, no ingredient panel, no manufacturer of record, no dose, no country of origin verification, no COA, and no evidence base. The listing appears to be an unbranded generic that any reseller can white-label. Under Vyvata's rubric this fails multiple autofails simultaneously: misleading_naming (the title is a keyword-stuffed SEO string rather than a product name), no_brand_provenance (no identifiable brand behind the product), and proprietary_blend_hides_dose (no dose disclosure). Male-enhancement-adjacent unbranded generics are also a known channel for adulteration with undeclared PDE5 inhibitors (sildenafil, tadalafil), which the FDA has issued repeated public health warnings about. Not listable in any form; would require complete re-manufacture under an identifiable brand with a published facts panel and third-party testing.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "pmd-test-z-reinforcer-nighttime-testosterone-support-90-capsules",
      "title": "PMD Test Z Reinforcer – Nighttime Testosterone Support – 90 Capsules",
      "vendor": "Price Is Right Miami",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/DD094FBD-5D49-424E-839A-5DC45BA4E3FF.jpg?v=1788063343",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone",
        "sleep"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "pmd",
        "test",
        "reinforcer",
        "nighttime",
        "testosterone",
        "support",
        "capsules",
        "price",
        "right",
        "miami"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 38,
        "manufacturing": 48,
        "safety": 55,
        "transparency": 22,
        "sustainability": 40
      },
      "price": 89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831099674821",
      "vsf_explanation": "PMD Sports Nutrition is a longstanding but mid-tier bodybuilding-supplement brand whose 'Test Z Reinforcer' names three trademarked proprietary blends — Nocturnal Grow Complex, Trib-X Blend, and Mental Relax-5 — with no per-ingredient milligram disclosure available in the product description. Nighttime testosterone-support formulas typically layer tribulus terrestris (weak-to-null RCT evidence for T-elevation in eugonadal men), an adaptogen, magnesium, and often 5-HTP or GABA-adjacent compounds for the 'sleep + recovery' angle. Without dose disclosure a reviewer cannot check any of that. Autofail on proprietary_blend_hides_dose. Testosterone-support claims are particularly consequential because low T is a diagnosable medical condition warranting bloodwork, not a supplement-store impulse purchase. Middling manufacturing/safety scores reflect that PMD is a real brand with distribution — not an endorsement.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "cybergenics-maximum-male-multivitamin-for-men-60-tablets",
      "title": "Cybergenics Maximum Male, Multivitamin For Men 60 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/347453470_8076f422-42ff-4960-9e5c-5ebd949fea8b.jpg?v=1788063410",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "cybergenics",
        "maximum",
        "male",
        "multivitamin",
        "for",
        "men",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 40,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 14.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831101214917",
      "vsf_explanation": "Cybergenics is a 1990s-era performance-supplement brand that has been repeatedly resold and re-launched with little continuity of formulation team, contract-manufacturing partner, or published testing. This SKU markets itself as a men's multivitamin plus an undisclosed 'herbal blend' for stamina, energy, immune, and heart support. No quantitative Supplement Facts panel appears in the product copy, the herbal blend is not itemized to milligram level, and there is no per-lot COA or third-party verification (USP, NSF, ConsumerLab). Multivitamin foundations for adult men are commodity chemistry that can be executed well cheaply, but the combination with an opaque proprietary herbal component and vague 'supports heart health, energy, immune system' claims is exactly the pattern the autofail rules target. Marked with proprietary_blend_hides_dose. Middling-not-terrible dimension scores reflect that the multivitamin backbone is probably fine at label doses — this is not an endorsement.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "debloat-gas-relief-pro",
      "title": "Debloat & Gas Relief Pro",
      "vendor": "EZZDAY",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/debloat_8f7599d5-5859-43a9-bc9c-70c72e8f5985.png?v=1788063593",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "debloat",
        "gas",
        "relief",
        "pro",
        "ezzday"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 32,
        "sustainability": 45
      },
      "price": 33.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831129657541",
      "vsf_explanation": "This product is somewhat more informative than the paired \"Vaginal Probiotics\" listing — it names four branded ingredients (Flora-Focus probiotics, DigeZyme enzymes, EnzyPro botanicals, and KSM-66 ashwagandha) — and that partial ingredient disclosure is meaningful because those are real branded raw materials from established B2B ingredient suppliers. KSM-66 is Ixoreal Biomed's clinically-studied ashwagandha extract with real evidence at 600 mg/day. DigeZyme is Sabinsa's digestive enzyme blend. Flora-Focus is a branded probiotic complex. EnzyPro is a lesser-known botanical blend. The problem is that named-ingredient disclosure without per-ingredient milligrams is only half the transparency the rubric requires. The product description does not disclose: the CFU count of the Flora-Focus probiotic, the enzyme units (typically FCC-standardized units — HUT, DPP-IV, ALU, etc.) for DigeZyme's enzymes, the milligrams and standardization percentage of KSM-66 in this specific product, or the composition of EnzyPro. This is `proprietary_blend_hides_dose` at the milligram level even though ingredient identity is partially disclosed. The generic \"Debloat & Gas Relief Pro\" naming with a category-noun quality also edges toward `misleading_naming` given the absence of a brand identity beyond the product name itself. Not listable in current form; would be salvageable with full per-ingredient dose disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "species-nutrition-omegalyze-advanced-180-capsules",
      "title": "Species Nutrition Omegalyze Advanced - 180 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Species-Nutrition-Omegalyze-Advanced-180-Capsules.jpg?v=1788063606",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "species",
        "nutrition",
        "omegalyze",
        "advanced",
        "180",
        "capsules",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 68,
        "manufacturing": 60,
        "safety": 78,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 42.46,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831129755845",
      "vsf_explanation": "Fatty-acid blend combining omega-3 fish oil, evening primrose oil (omega-6 GLA source), and omega-7 (palmitoleic acid) in a 180-capsule bottle marketed for cardiovascular and hormonal health. Omega-3 fish oil (EPA + DHA) has the strongest evidence in this stack — cardiovascular risk-marker improvement (Bhatt 2019 REDUCE-IT trial with icosapent ethyl at 4 g/day showed a real event-rate reduction; general fish-oil supplementation evidence is more modest but consistent for triglyceride reduction at 2–4 g EPA+DHA/day), triglyceride reduction at prescription-equivalent doses, and modest anti-inflammatory effects. Evening primrose oil (GLA source) has thinner evidence — small trials for atopic eczema, PMS symptoms, and rheumatoid arthritis show inconsistent results (Bamford 2013 Cochrane review found no benefit for eczema). Palmitoleic acid (omega-7) is a newer supplement ingredient with limited human RCT support — some preliminary evidence for improved lipid markers and reduced inflammation, but far below fish oil's evidence base. Standard-band placement reflects the mixed-quality ingredient stack: fish oil is the anchor with real evidence, evening primrose and omega-7 are add-ons with thinner support. Per-ingredient dose disclosure matters — a genuine fish-oil dose needs 1–2 g of EPA+DHA per day (not total fish oil weight), and blended products often deliver 300–500 mg EPA+DHA per capsule which requires 3–5 capsules for a working dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vaginal-probiotics-ph-balance™",
      "title": "Vaginal Probiotics & pH Balance™",
      "vendor": "EZZDAY",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Image_20251017135426_320_347.jpg?v=1788063628",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vaginal",
        "probiotics",
        "balance",
        "ezzday"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 28,
        "manufacturing": 32,
        "safety": 45,
        "transparency": 20,
        "sustainability": 35
      },
      "price": 39.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831129985221",
      "vsf_explanation": "The product name is a category noun (\"Vaginal Probiotics & pH Balance\"), and the entire product description is the phrase \"Advance Vaginal Care.\" There is no brand identifiable in the title. There is no strain-level disclosure of the probiotic content — vaginal-health probiotic evidence attaches to specific strains (Lactobacillus rhamnosus GR-1, Lactobacillus reuteri RC-14, Lactobacillus crispatus CTV-05, and a few others), and a probiotic marketed for vaginal health without strain-level disclosure is functionally unverifiable. There is no CFU count. There is no delivery-vehicle disclosure (oral capsule for gut-microbiome-mediated effect, oral capsule for a serotype the manufacturer claims translocates to the vaginal tract, or vaginal suppository). There is no clinical claim structure, no COA, no manufacturing disclosure. This is the pure form of three independent auto-fail conditions: `misleading_naming` (category-noun product name), `no_brand_provenance` (no identifiable brand), and effectively `proprietary_blend_hides_dose` (nothing disclosed). Not listable at any tier level.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "nutrex-glutamine-pure-60-servings",
      "title": "Nutrex Glutamine Pure, 60 Servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Glutamine-60.webp?v=1788063816",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrex",
        "glutamine",
        "pure",
        "servings",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 82,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831131590853",
      "vsf_explanation": "L-glutamine at 5 g per serving in unflavored powder format — the standard supplement dose used in almost every healthy-adult trial. Functionally equivalent to the Mutant Glutamine SKU: same core evidence problem (glutamine has weak evidence for strength/hypertrophy/recovery in well-fed trained adults per Candow 2001, Wilkinson 2006, Legault 2015), same real but narrow indications (endurance overtraining, GI-permeability, catabolic contexts), same honest labeling and delivery format. The 5 g dose in a powder is meaningfully more usable than the 900 mg-per-capsule NutraKey format — this is a working dose. Nutrex is a real mid-tier brand with a long presence in the US sports-supplement channel and disclosed labeling. Standard-band placement mirrors the Mutant Glutamine assessment: honest product, correct dose, weak underlying evidence base for the intended user population; useful for specific indications, not on the shortlist for a general training adult.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bucked-up-bamf-high-stimulant-nootropic-pre-workout-30-servings",
      "title": "Bucked Up BAMF High Stimulant Nootropic Pre-Workout, 30 Servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Picture11_1c131133-fc40-4ea0-81d2-684ae441ce3c.jpg?v=1788063817",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bucked",
        "bamf",
        "high",
        "stimulant",
        "nootropic",
        "pre",
        "workout",
        "servings",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 42,
        "manufacturing": 55,
        "safety": 38,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831132999877",
      "vsf_explanation": "High-stimulant nootropic pre-workout from Bucked Up with 333 mg caffeine, 3.2 g beta-alanine, and — critically — deer antler velvet. Two independent problems force a Rejected placement. First, deer antler velvet is marketed as a source of IGF-1 (insulin-like growth factor 1) with recovery and 'growth' claims. IGF-1 does not survive oral digestion — sublingual and oral IGF-1 does not appreciably enter systemic circulation, so any 'growth-support' claim tied to deer antler IGF-1 content is not supported by human pharmacology. IGF-1 supplementation is also on the World Anti-Doping Agency prohibited list; the ingredient signaling matters for tested athletes and misrepresents effect mechanism to non-tested users. This is a textbook unverified_medical_claim autofail pattern. Second, at 333 mg caffeine per serving plus a 'nootropic blend' (typically alpha-GPC, huperzine A, DMAE, and often undisclosed additional stimulants), the aggregate stimulant load is genuinely high — near the FDA-suggested 400 mg/day cap in a single serving before any additional coffee or caffeine sources. Even for the ingredients that are disclosed at working doses (beta-alanine 3.2 g is correct, caffeine at 333 mg is real), the deer-antler component and typical accompanying 'nootropic blend' opacity push this into Rejected territory.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "nutrex-lipo-6-black-ultra-concentrate-60-caps",
      "title": "Nutrex LIPO-6 Black Ultra Concentrate, 60 Caps",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Lipo6-BlackUC-60.webp?v=1788063816",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrex",
        "lipo",
        "black",
        "ultra",
        "concentrate",
        "caps",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 32,
        "manufacturing": 55,
        "safety": 38,
        "transparency": 28,
        "sustainability": 45
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831131623621",
      "vsf_explanation": "Ultra-concentrated thermogenic fat-burner capsule — LIPO-6 is a long-established Nutrex line built on a proprietary stimulant matrix (caffeine anhydrous, synephrine or its analogs, yohimbine, theobromine, sometimes rauwolscine and DMHA in older or international lots) at undisclosed per-ingredient doses. The 'Ultra Concentrate' framing signals maximized stimulant load per capsule. This is precisely the proprietary_blend_hides_dose autofail category: a customer cannot verify caffeine dose (relevant to daily cap and interaction with other caffeine sources), yohimbine dose (relevant to cardiovascular safety and dose-response toxicity above 0.4 mg/kg), or synephrine/analog dose (relevant to cardiac rhythm and BP effects). Beyond the transparency failure, the category-level evidence for meaningful fat loss beyond a caloric deficit is essentially absent (see AllMax RapidCuts scoring above — Jurgens Cochrane on green tea, Pooyandjoo on carnitine, Stohs on synephrine, all show effect sizes indistinguishable from the deficit prescribed alongside). The LIPO-6 line has been through multiple reformulations over the years including DMAA-era formulas that faced FDA action; while the current US-market formula does not contain DMAA, the proprietary-blend structure preserves the ambiguity. Auto-failed proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "nutrex-vitadapt-complete-90-caps",
      "title": "Nutrex Vitadapt Complete, 90 caps",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Picture16_4acaae28-7d5c-4718-b27c-0f740190926f.jpg?v=1788063817",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrex",
        "vitadapt",
        "complete",
        "caps",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 72,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831131754693",
      "vsf_explanation": "Multivitamin with added adaptogen blend targeting athletes and active adults. The base multivitamin case is well-understood: for adults hitting a normal Western diet with vegetables and animal protein, a daily multivitamin does not measurably improve health outcomes (PHS-II Sesso 2012, Grodstein 2013 — the large long-term multivitamin trials showed at most a small cancer-incidence signal in men over 50, no consistent cardiovascular or cognitive benefit). Multivitamins are more useful as a safety net for people with genuinely restricted diets, high training volume that raises micronutrient turnover, older adults with reduced absorption, or specific documented deficiencies. The adaptogen additions (typically ashwagandha, Rhodiola, eleuthero, or similar in this class of product) have real but modest evidence for stress and cortisol response in specific contexts — full ashwagandha ergogenic dosing is 300–600 mg/day of KSM-66 or Sensoril extracts, which is higher than what fits inside a multivitamin capsule alongside 25 other ingredients. Standard-band placement reflects an honest 'better than nothing but not transformative' multivitamin from a real brand — nothing broken, nothing exceptional. The label calls out 'comprehensive nutrient support' and 'adaptogen blend' without disclosing per-adaptogen doses, which is the transparency gap keeping this out of Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrakey-caffeine-200mg-100-capsules",
      "title": "NutraKey Caffeine 200mg, 100 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NutraKey-CAFFEINE-100-Capsules.webp?v=1788063817",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrakey",
        "caffeine",
        "200mg",
        "100",
        "capsules",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 88,
        "formulation": 70,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 6.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831132016837",
      "vsf_explanation": "Plain caffeine anhydrous 200 mg per capsule — functionally identical to the Allmax and Mutant caffeine SKUs already scored in this batch. Caffeine is a chemically defined molecule and brand does not change the pharmacology. Standard-band placement mirrors the other caffeine capsule scores in this round: strong underlying evidence (ISSN position stand Guest 2021), honest single-ingredient labeling, and no meaningful brand differentiation once GMP is satisfied. The 'ultra-micronized' language on the label is defensible marketing for a mid-tier brand but does not change the pharmacokinetic profile in any measurable way for oral caffeine. Safety issue is the same category-level concern: 200 mg per capsule times 100 capsules is 20 g of caffeine in a bottle, and the failure modes come from user aggregate-daily-intake stacking (pre-workout + coffee + energy drink + capsule = cardiac and anxiety events at doses well above the FDA-suggested 400 mg/day cap for healthy adults).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrex-caffeine-200mg-60-caps",
      "title": "Nutrex Caffeine 200mg, 60 Caps",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Picture54.jpg?v=1788063816",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrex",
        "caffeine",
        "200mg",
        "caps",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 88,
        "formulation": 70,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 6.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831131787461",
      "vsf_explanation": "Plain caffeine anhydrous 200 mg per capsule from Nutrex — the fourth 200 mg caffeine SKU in this batch and functionally identical to the Allmax, Mutant, and NutraKey versions. Same underlying evidence base (ISSN Guest 2021 position stand), same reliable 200 mg dose per capsule, same honest single-ingredient labeling. Caffeine anhydrous is a defined molecule and there is no meaningful pharmacological difference between mid-tier US/Canadian sports brands selling the same molecule at the same dose. Standard-band placement is the honest ceiling: solid evidence, honest label, no brand-quality differentiation, category-level safety discipline (aggregate daily intake tracking, avoiding stacking with pre-workouts/coffee/energy drinks) is user judgment rather than product quality.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrex-bcaa-6000-recovery-30-servings",
      "title": "Nutrex BCAA 6000 Recovery, 30 Servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BCAA-FP.webp?v=1788063816",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrex",
        "bcaa",
        "6000",
        "recovery",
        "servings",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 78,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 11.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831131656389",
      "vsf_explanation": "Branched-chain amino acid formula at 6,000 mg BCAAs per serving in a flavored powder — same core evidence issue as the NutraKey BCAA Optima SKU. BCAAs in isolation cannot maximally stimulate muscle protein synthesis because they lack the other six essential amino acids required for translation (Wolfe 2017 J Int Soc Sports Nutr). In a well-fed adult hitting 1.6+ g/kg protein daily from whole food or whey, intra-workout BCAAs produce measurably no additional MPS or hypertrophy over an 8-week block (Jackman 2017). The 6 g dose is at the upper end of the standard commercial range, but dose is not the fix — the fix is delivering the other essential amino acids (i.e., a full EAA blend, or just whey). Product is honestly labeled, safe, and useful as an intra-workout flavor-and-electrolyte system for people who would not otherwise hydrate. Held at the low end of Standard because the marketed 'recovery' benefit is category-weak in the intended user population.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrex-creatine-monohydrate-200-servings",
      "title": "Nutrex Creatine Monohydrate, 200 Servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Picture3_38f05ec1-e668-4687-a093-516d056169e3.jpg?v=1788063817",
      "score": 78,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrex",
        "creatine",
        "monohydrate",
        "200",
        "servings",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 92,
        "formulation": 82,
        "manufacturing": 72,
        "safety": 88,
        "transparency": 78,
        "sustainability": 55
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831131852997",
      "vsf_explanation": "Micronized creatine monohydrate at 5 g per serving, 200 servings per container, unflavored — the platonic ideal of a creatine SKU. Creatine monohydrate is the most rigorously studied ergogenic aid in sports supplementation, with hundreds of RCTs, an ISSN position stand (Kreider et al. 2017 J Int Soc Sports Nutr), and consistent effect on strength, power, lean mass, and recovery in resistance-trained populations. Emerging cognitive-support evidence (Prokopidis 2023 meta-analysis on short-term memory) adds a second use-case. Micronization improves solubility and reduces GI complaints versus non-micronized monohydrate, without changing pharmacology. The unflavored format is a plus — no sweetener, no dye, no per-scoop calorie overhead — and works in coffee, water, protein shakes, or juice. Verified-band placement reflects real evidence at the correct dose from a real regulated brand with an honest single-ingredient label. Not Elite because (1) this SKU does not carry NSF Certified for Sport or Informed Sport certification (relevant for tested athletes), (2) the label does not disclose per-lot heavy-metal and identity testing publicly, and (3) creatine is a commodified ingredient where brand-quality differentiation above GMP is minimal — a Creapure-branded monohydrate would earn an additional point or two for supply-chain provenance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrex-lipo-6-intense-ultra-concentrate-60-caps",
      "title": "Nutrex LIPO-6 Intense Ultra Concentrate, 60 Caps",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Lipo6-INT.webp?v=1788063816",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrex",
        "lipo",
        "intense",
        "ultra",
        "concentrate",
        "caps",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 35,
        "manufacturing": 55,
        "safety": 42,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 18,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831131951301",
      "vsf_explanation": "Another LIPO-6 line variant — 'Intense Ultra Concentrate' capsule — with the same underlying issues as LIPO-6 Black Ultra Concentrate: proprietary stimulant matrix at undisclosed per-ingredient doses, category-level evidence for fat loss beyond a caloric deficit is essentially absent, and stacking-safety concerns are real. The description explicitly identifies this as a 'stimulant-based supplement designed for experienced adult supplement users,' which is language that in the supplement channel almost always signals a proprietary blend at aggressive stimulant totals with limited per-ingredient disclosure. Auto-failed proprietary_blend_hides_dose. Functionally the same rejection reasoning as LIPO-6 Black Ultra Concentrate — same brand, same product family, same failure mode.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "nutrex-lipo-6-stim-free-60-caps-new-formula",
      "title": "Nutrex LIPO-6 Stim-Free, 60 Caps (New Formula)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Picture77_42bd5ec3-d54a-44bf-9344-57b1a82d828d.jpg?v=1788063817",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrex",
        "lipo",
        "stim",
        "free",
        "caps",
        "new",
        "formula",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831131820229",
      "vsf_explanation": "'Stim-free' variant of the LIPO-6 line — the marketing angle is that this SKU delivers thermogenic and fat-metabolism support without caffeine or other stimulants, targeting users who want fat-burner claims without the stimulant safety concern. Stim-free fat burners typically rely on some combination of L-carnitine, CLA, green tea catechin (decaffeinated), garcinia cambogia, chromium, and 'lipolytic support' proprietary blends. The individual ingredient evidence is uniformly weak-to-absent at commercial doses (see AllMax CLA Femme scoring for the CLA case, Jurgens 2012 Cochrane for green tea, Pooyandjoo 2016 for L-carnitine), and combining them in a proprietary blend does not sum small null effects into a real one. Removing the stimulant portion improves the safety profile substantially but strips out the only ingredient class (caffeine) that has any real ergogenic and appetite-suppression effect in the fat-loss context. Auto-failed proprietary_blend_hides_dose for the underlying blend structure characteristic of the line; also a strong case for unverified_medical_claim on the 'true thermogenic without stimulants' framing since removing stimulants removes the primary mechanism of any real thermogenic effect. Slightly higher score than the stimulant variants because the safety profile is genuinely cleaner, but still Rejected on the evidence and transparency dimensions.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "allmax-egt20-30-capsules",
      "title": "Allmax EGT20+, 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Picture30_4dc398f7-17b3-45e6-93b5-c72b3e3d8657.jpg?v=1788063817",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "allmax",
        "egt20",
        "capsules",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 65,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 14,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831131984069",
      "vsf_explanation": "Ergothioneine (EGT) supplement — a naturally occurring amino acid derivative found in mushrooms (particularly oyster and king oyster mushrooms at high concentration) that has attracted real research interest as a 'longevity vitamin' candidate over the past decade. Ergothioneine is uniquely retained in cells via a dedicated transporter (SLC22A4/OCTN1), accumulates in tissues with high oxidative burden (liver, kidney, bone marrow, eye lens), and has plausible antioxidant mechanisms. Human RCT evidence remains thin: preclinical and epidemiological studies are consistent with a beneficial role (Cheah 2016 Free Radic Res review, Beelman 2020), and blood ergothioneine levels decline with age and correlate with all-cause mortality risk in observational studies. Actual outcome-endpoint RCTs at supplement doses are limited — most work is preclinical or short-term biomarker studies. The 20 mg per capsule dose is common in commercial ergothioneine products and roughly matches high-mushroom-diet daily intake (5–20 mg/day). Safety profile is favorable in the trials to date. Standard-band placement reflects a genuinely interesting ingredient with limited but building human evidence, honest labeling, but insufficient RCT support at outcome endpoints to justify Verified positioning. This is a defensible speculative buy for users interested in the longevity/antioxidant hypothesis; it is not a proven intervention.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrex-mass-infusion-12lbs-19-servings",
      "title": "Nutrex Mass Infusion, 12lbs - 19 Servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Picture12_e8058926-2800-4ded-8de9-1dc3e7519344.jpg?v=1788063817",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrex",
        "mass",
        "infusion",
        "12lbs",
        "servings",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 59.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831132049605",
      "vsf_explanation": "Mass-gainer powder at 50 g protein and 100 g carbohydrates per serving in a 19-serving 12 lb tub — a category built around delivering large caloric loads (typically 700–1,200 kcal per serving) to underweight lifters trying to gain weight. Mass gainers are honest about what they are — high-calorie protein-plus-carbohydrate powders — and the underlying evidence for a caloric surplus driving weight gain is trivially true. The category-level questions are (1) the carbohydrate source — usually maltodextrin, which is a refined high-glycemic starch that delivers calories efficiently but has none of the fiber/micronutrient profile of whole-food carbohydrate, (2) the protein blend quality — this SKU does not disclose whey isolate/concentrate/casein split, characteristic of the category, and (3) whether the user is actually better off eating additional whole food. For a genuinely underweight lifter who cannot eat enough whole food to gain, mass gainers work; for a lifter with normal appetite trying to bulk, adding whole-food calories (rice, oats, milk, eggs, fruit) is nutritionally better. Standard placement reflects honest labeling and a workable use case for a specific user, held below Verified because the blend composition is opaque and the category is fundamentally 'calories in a scoop,' which whole food does more nutritiously.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mutant-big-greens-30-servings",
      "title": "Mutant Big Greens, 30 Servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Picture111_43b0093f-4a01-4254-a631-406830db7067.jpg?v=1788063817",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mutant",
        "big",
        "greens",
        "servings",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 42,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 32,
        "sustainability": 55
      },
      "price": 32.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831131885765",
      "vsf_explanation": "Greens powder marketed with '40+ superfoods, greens, and plant-based nutrients' — a formulation pattern that is essentially the AG1 (Athletic Greens) problem at a lower price point. When you cram 40+ ingredients into a ~10–15 g scoop, mathematically most of the marquee ingredients are present at 50–200 mg — well below any studied active dose for any of them. The per-ingredient milligram breakdown is typically not disclosed at the label level (a proprietary 'superfood blend' pattern), which is precisely the proprietary_blend_hides_dose autofail category. This is the specific pattern the special AG1-alternatives note in the brief flags: a greens product with 20–30 disclosed ingredients at reasonable doses is defensible Standard; a 40+ ingredient product with proprietary-blend structure at homeopathic doses is the same failure mode as AG1. The 15-ingredient AllMax AllGreens+ scored earlier in this batch at 60 (Standard) precisely because the ingredient count was disciplined; this 40+ SKU inverts that discipline. Compare to the 15-ingredient AllGreens SKU: same brand family, same category, but the 40+ ingredient count with typical proprietary structure pushes this into Rejected. Auto-failed proprietary_blend_hides_dose.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "universal-nutrition-boost-focus-30-servings",
      "title": "Universal Nutrition Boost & Focus, 30 Servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Picture84.jpg?v=1788063817",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "universal",
        "nutrition",
        "boost",
        "focus",
        "servings",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 35,
        "sustainability": 50
      },
      "price": 5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831132246213",
      "vsf_explanation": "Nootropic-adjacent energy powder positioned for cognitive focus, mental clarity, and daily productivity. Products in the caffeine-plus-nootropic-blend category typically list caffeine at a disclosed dose alongside an undisclosed 'focus matrix' or 'cognitive blend' combining alpha-GPC, L-theanine, tyrosine, Lion's Mane, huperzine A, or DMAE at collectively opaque doses. Without per-ingredient disclosure, the customer cannot verify (a) whether the caffeine + theanine ratio approximates the studied 1:2 ratio shown to reduce jitters (Owen 2008 Nutr Neurosci), (b) whether alpha-GPC is at the 300–600 mg working dose (Marcus 2017), or (c) whether huperzine A is at a safe 50–100 μg dose or dangerously higher. Universal Nutrition is a real long-standing brand with a lifter reputation predating the nootropic-marketing wave, but this SKU sits in the proprietary-blend nootropic pre-workout category and inherits the transparency failure. Auto-failed proprietary_blend_hides_dose. The 'clean energy, mental clarity' framing implies effects that a disclosed single-ingredient caffeine plus theanine stack would deliver at 20% the cost with full dose transparency.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "nutrex-flavored-creatine-monohydrate-60-servings",
      "title": "Nutrex Flavored Creatine Monohydrate, 60 Servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/nutrex-fruit-punch-creatine..jpg?v=1788063817",
      "score": 75,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrex",
        "flavored",
        "creatine",
        "monohydrate",
        "servings",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 92,
        "formulation": 78,
        "manufacturing": 72,
        "safety": 85,
        "transparency": 72,
        "sustainability": 52
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831132180677",
      "vsf_explanation": "Flavored version of Nutrex's creatine monohydrate — 5 g pure creatine monohydrate per serving with a flavor system for taste-driven consumption. Same underlying evidence base as the unflavored 200-serving SKU scored above (Kreider 2017 ISSN position stand; strongest supplement evidence in sport). Held slightly below the unflavored variant (75 vs. 78) because (1) the flavor system typically uses artificial sweeteners (sucralose or acesulfame potassium) plus dye and flavor — a modest downside for users sensitive to sweeteners or preferring cleaner ingredient lists, (2) the added flavor components use scoop-volume budget that would otherwise be creatine or empty, and (3) cost-per-serving on flavored creatine is typically slightly higher than unflavored for the same 5 g creatine dose. For users who will not consistently take unflavored creatine because of taste, the flavored version drives adherence and is worth the marginal downside. Verified band is honest — real ingredient, correct dose, honest label. If you would take either format daily, the unflavored version is the technically cleaner buy; if flavor drives your adherence, this is the right choice.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnum-limitless-x16-pre-workout-20-servings",
      "title": "Magnum Limitless X16 Pre-WorkOut, 20 Servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Picture6_f0599990-9bbc-440f-9f3f-f531d0f0c5d4.jpg?v=1788063817",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnum",
        "limitless",
        "x16",
        "pre",
        "workout",
        "servings",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 40,
        "transparency": 32,
        "sustainability": 45
      },
      "price": 24,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831132344517",
      "vsf_explanation": "'X16 Pre-Workout' with 'extreme energy and performance' and 'high-stim formula' framing — the standard language pattern for a proprietary high-stimulant pre-workout matrix. Magnum is a Canadian sports brand with a longer-standing category presence than some competitors, but the SKU-level formulation pattern (high-stimulant proprietary blend without per-ingredient disclosure at the front-panel level, aggressive stimulant + nootropic + performance blend combination) fits the proprietary_blend_hides_dose autofail category same as the other high-stim pre-workouts in this batch. 'X16' likely refers to 16 ingredients in the pre-workout blend — that is roughly the same ingredient-count dilution problem as the mass-market nootropic-pre-workout category, where scoop-weight budget divided across many ingredients means most doses fall below the studied working amount for each ingredient. Auto-failed proprietary_blend_hides_dose. Alternate honest single-ingredient stack (caffeine + citrulline + beta-alanine + creatine) delivers what this product markets at a fraction of the cost with full dose transparency.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "mutant-eaa-extreme-30-servings",
      "title": "Mutant EAA Extreme, 30 Servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/mutant-eaa-extreme-cherry-pomegranate..png?v=1788063817",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mutant",
        "eaa",
        "extreme",
        "servings",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 58,
        "safety": 78,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 17.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831132508357",
      "vsf_explanation": "Essential amino acid formula (EAAs) — the honest upgrade from BCAAs. All nine essential amino acids in a flavored intra-workout / recovery powder. The evidence case is meaningfully stronger than for BCAAs alone: EAAs at 6–15 g pre- or intra-workout can stimulate a real muscle protein synthesis response even in a fasted state, because they provide the complete substrate mix needed for translation (Volpi 2003, Katsanos 2006). In a fed state with adequate protein intake, the marginal benefit of an EAA intra-workout drink on top of daily whey feedings is small — but non-zero. EAA products earn more credit than BCAA-only products for delivering the honest ingredient mix; they earn less credit than whey protein for being more expensive per gram of usable amino acid substrate and lacking the food-matrix benefits of whey. Standard-band placement is honest: a real ingredient class with better evidence than BCAAs at a modestly higher price, held below Verified because per-amino-acid dose disclosure is typically incomplete at the front-panel level and the intra-workout use case has weaker evidence than a post-workout whey feeding.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mutant-hardcore-whey-5lbs",
      "title": "Mutant Hardcore Whey, 5lbs",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Picture5_550843b4-a5e1-416f-a5ce-77d223a721a0.jpg?v=1788063817",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mutant",
        "hardcore",
        "whey",
        "5lbs",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 82,
        "transparency": 48,
        "sustainability": 50
      },
      "price": 79.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831132115141",
      "vsf_explanation": "Whey protein blend — 'high-quality whey protein blend for muscle growth' framing without disclosure of the isolate/concentrate/hydrolysate split at the front-panel level. Same category-level analysis as the Mutant Pro Triple Whey SKU scored earlier: core evidence for whey blends at 20–30 g per serving is well-established, the muscle-building outcome is the same as pure isolate at matched leucine content per serving, but the undisclosed blend composition allows the product to be economically weighted toward the cheapest form (concentrate) while the label implies a premium multi-source blend. The 'Hardcore Whey' branding is a category convention for mass-market lifter blends. Held at a slightly lower score than Mutant Pro Triple Whey (62 vs. 66) because the 'Hardcore' framing signals a more concentrate-heavy blend (typical positioning for the lifter mass market at a lower price point per pound), and the transparency dimension takes a hit for undisclosed composition on a product line whose family has both isolate-forward and concentrate-forward variants. Standard-band placement is honest: functional whey protein at a reasonable per-gram-protein cost, held below Verified because the blend composition is opaque and there is no third-party quality certification disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mutant-multi-60-caplets",
      "title": "Mutant Multi, 60 Caplets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Picture32_4f1eb924-7115-4993-80b4-79f472a8ffa0.jpg?v=1788063817",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mutant",
        "multi",
        "caplets",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 72,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831132311749",
      "vsf_explanation": "Multivitamin caplet targeting active adults — same category analysis as the Nutrex Vitadapt Complete SKU, minus the adaptogen blend addition. Base multivitamin evidence in healthy adults with a reasonable diet is essentially neutral (PHS-II Sesso 2012 in men over 50 showed small cancer-incidence signal, no cardiovascular benefit; Grodstein 2013 no cognitive benefit) — multivitamins are more useful as a safety net for populations with genuine dietary gaps, older adults with reduced absorption, athletes with high micronutrient turnover, or documented deficiencies. Standard-band placement reflects honest 'reasonable general-purpose multivitamin' from a real brand at a fair price. Held below the Vitadapt score (58 vs. 60) because there is no differentiating angle (adaptogens, targeted athlete nutrients, or specific bioavailability form choices) beyond the base multivitamin composition. Nothing broken; nothing exceptional.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrex-l-carnitine-1000-120-caps",
      "title": "Nutrex L-Carnitine 1000, 120 Caps",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Picture19_6d69f2f1-5978-4b70-ab6d-7eb61a2ad54e.jpg?v=1788063817",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrex",
        "carnitine",
        "1000",
        "120",
        "caps",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 75,
        "transparency": 62,
        "sustainability": 48
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831132704965",
      "vsf_explanation": "L-carnitine at 1,000 mg per serving marketed for fat metabolism and energy support. L-carnitine's biological role — shuttling long-chain fatty acids into the mitochondria for beta-oxidation — is real, but the outcome effect on measurable fat loss or endurance performance in healthy adults is small. Pooyandjoo 2016 meta-analysis found ~1.3 kg mean weight difference over 3–6 months of L-carnitine supplementation, likely overlapping with the caloric deficit in trial arms. Wall 2011 showed L-carnitine plus carbohydrate over 6 months increased muscle carnitine content ~20% and produced modest performance improvements — but the protocol required chronic carbohydrate co-ingestion (~80 g) with each carnitine dose, which is rarely how consumers take capsule L-carnitine. Free-form L-carnitine has poor oral bioavailability (~15%) without co-ingested carbohydrate; L-tartrate and L-carnitine acetyl (ALCAR) have better absorption profiles. Standard-band placement reflects real if modest evidence at the correct dose, held below Verified because the fat-metabolism marketing implication ahead of the outcome data and the free-carnitine format is less bioavailable than L-tartrate or ALCAR alternatives. Roughly equivalent scoring to the NutraKey ALCAR SKU minus a few points for the less-CNS-active form.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrex-creatine-hmb-30-servings",
      "title": "Nutrex Creatine+ HMB, 30 Servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/nutrex-creatine_-hmb-powder-fruit-punch..png?v=1788063817",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrex",
        "creatine",
        "hmb",
        "servings",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 65,
        "manufacturing": 65,
        "safety": 82,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 18.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831132606661",
      "vsf_explanation": "Combination product delivering creatine and HMB in one serving — leveraging the strongest supplement evidence (creatine monohydrate at 3–5 g/day, ISSN Kreider 2017) alongside a supplementary anti-catabolic (HMB at 3 g/day, discussed in the NutraKey HMB SKU scoring above). Combination products in this category require per-ingredient dose disclosure to earn a defensible score — the customer needs to verify (a) that creatine is present at 3–5 g per serving (the studied working dose) and (b) that HMB is present at 1 g per serving so a standard 3 x daily dosing protocol reaches 3 g total. Without disclosed per-ingredient milligrams, the risk is that the product delivers 2 g creatine plus 500 mg HMB per serving — both below their studied thresholds. This SKU's label description does not surface per-ingredient milligrams in the storefront excerpt, but the two-ingredient nature makes it more defensible than multi-ingredient blends. Standard-band placement reflects the combination approach: real ingredients, real evidence for both individually, but the combined per-serving math is likely below the ideal creatine dose (5 g) alone because scoop budget must accommodate both. A user chasing evidence-based effects gets better outcomes from separate creatine monohydrate and HMB SKUs at their respective working doses — this is a convenience play, not a superior formulation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrex-lipo-6-hers-ultra-concentrate-60-caps",
      "title": "Nutrex LIPO-6 Hers Ultra Concentrate, 60 Caps",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Lipo6-Hers.webp?v=1788063816",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrex",
        "lipo",
        "hers",
        "ultra",
        "concentrate",
        "caps",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 35,
        "manufacturing": 55,
        "safety": 42,
        "transparency": 32,
        "sustainability": 45
      },
      "price": 17.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831132737733",
      "vsf_explanation": "Female-marketed variant of the LIPO-6 line — 'thermogenic, energy, appetite, and metabolism support for women' framing on the same underlying proprietary stimulant matrix as LIPO-6 Black and LIPO-6 Intense. Two independent problems for a Rejected placement. First, the gender-targeted 'Hers' variant is a marketing wrap on the same category-level product — there is no published pharmacological basis for a different fat-metabolism formula for women, and controlled trials of fat-loss ingredients have not established a female-specific effect that would justify differentiated formulation (see AllMax CLA Femme scoring for the same gender-marketing pattern). Second, and more important, the underlying proprietary blend structure characteristic of the LIPO-6 line preserves the same transparency failure: undisclosed per-ingredient doses of caffeine, synephrine or analogs, yohimbine, and other stimulants that individually matter for safety (yohimbine dose-response toxicity above 0.4 mg/kg, caffeine at aggregate daily intake tracking) and collectively deliver essentially no measurable fat loss beyond a caloric deficit (Cochrane and meta-analytic literature discussed in the AllMax RapidCuts scoring). Auto-failed proprietary_blend_hides_dose. Same failure mode as the other LIPO-6 variants scored earlier.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "mutant-all-in-full-dose-pre-workout-40-20-servings",
      "title": "Mutant All-In Full-Dose Pre-Workout, 40/20 Servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/mutant-all-infull-dosepre-workout..jpg?v=1788063817",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mutant",
        "all",
        "full",
        "dose",
        "pre",
        "workout",
        "servings",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46898191237317",
      "vsf_explanation": "'Full-dose' pre-workout — the naming explicitly commits to delivering ingredients at studied working doses rather than proprietary-blend garnish amounts. The 40/20 serving convention (40 half-scoops or 20 full-scoops per tub) is a category signal that the full scoop is a heavy dose intended for 'hardcore training sessions.' This is a differently-positioned pre-workout from the proprietary-matrix competitors — brands using 'full-dose' language typically disclose per-ingredient milligrams because that is the entire marketing angle. If the label delivers on the claim (6–8 g citrulline malate, 3.2 g beta-alanine, 2.5 g betaine, 200–400 mg caffeine, 3–5 g creatine, per-ingredient milligrams disclosed), the product is a genuinely defensible bundled pre-workout in a category where most SKUs are not. The scoring pattern here is contingent on the label actually meeting the 'full dose' claim — without direct label verification from the storefront excerpt, I placed it at the top of the Standard band as a category-honest bundled product that is likely delivering on its marketing framing but not confirmed at every dose. If per-ingredient doses turn out to fall short (e.g., 4 g citrulline instead of 6–8 g, 200 mg caffeine but under-dosed betaine), the effective placement drops. Held below Verified because bundling still imposes fixed dose ratios that a user could optimize individually; even at 'full dose' the bundle is more expensive per unit ergogenic effect than assembling from single ingredients.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bucked-up-black-ant-pre-workout-40-servings",
      "title": "Bucked Up Black Ant Pre-workout, 40 Servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/bucked-up-black-ant-pre-workout..png?v=1788063817",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bucked",
        "black",
        "ant",
        "pre",
        "workout",
        "servings",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 48,
        "transparency": 42,
        "sustainability": 45
      },
      "price": 28,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831132868805",
      "vsf_explanation": "Bucked Up pre-workout SKU disclosing creatine, beta-alanine, betaine, and L-citrulline as headline ingredients. The Bucked Up line has a house-brand pattern of including deer antler velvet extract across most SKUs as a differentiator — the same unverified_medical_claim issue detailed in the Bucked Up BAMF scoring above (IGF-1 does not survive oral digestion, WADA prohibited-list ingredient, marketing implies effects the oral form cannot deliver). Even if the four disclosed sports-nutrition ingredients (creatine, beta-alanine, betaine, citrulline) are delivered at working doses — which would be a genuine step up from a fully proprietary pre-workout — the deer antler component drags the SKU into Rejected territory on the unverified_medical_claim / brand-line inheritance basis. The 'Black Ant' variant naming likely refers to Polyrhachis vicina (Chinese black ant) extract, a traditional Chinese medicine ingredient with essentially no controlled human trial evidence for exercise performance or recovery outcomes despite marketing claims of testosterone-support and adaptogen properties. Combined with the deer antler pattern, the SKU carries two ingredient claims not supported by controlled human evidence. Held above the fully proprietary pre-workouts because the disclosed sports-nutrition core is honest, but the ancillary ingredient claims force a Rejected placement.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "allmax-melatonin-hr-60-capsules",
      "title": "Allmax Melatonin HR, 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Picture14_8b851b58-c401-4e35-a355-f67f0290b2b4.jpg?v=1788063816",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "allmax",
        "melatonin",
        "capsules",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 10,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831132836037",
      "vsf_explanation": "Melatonin capsule with 'dual-action immediate and sustained-release' framing — a formulation approach that pairs a fast-acting fraction to promote sleep onset with a slower-release fraction to support sleep maintenance overnight. Melatonin has strong evidence for circadian rhythm shifting (jet lag, shift work — Herxheimer 2002 Cochrane review) and modest but real evidence for sleep-onset latency reduction in adults with delayed sleep phase (Buscemi 2005 meta-analysis showed ~7 minute reduction in sleep-onset latency versus placebo — statistically real but clinically modest). The dose that matters is smaller than the market has settled on: 0.3–1 mg is the physiological dose that most consistently improves sleep-onset latency without disrupting endogenous melatonin production. Most commercial melatonin (including Allmax) delivers 3–10 mg per capsule — 10–30x the physiological dose, which raises real questions about receptor down-regulation with chronic use and next-day grogginess. The label description does not disclose the specific milligram dose in the storefront excerpt. Standard-band placement reflects real evidence for the ingredient class, honest 'sleep support' framing, but the commercial-dose-vs-physiological-dose issue is real, and the sustained-release format encourages higher-than-needed dosing. Melatonin is broadly safe short-term but the ideal use case is intermittent (travel, shift adjustment) rather than nightly indefinite use.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrakey-l-citrulline-malate-1500mg-90-capsules",
      "title": "NutraKey L-Citrulline Malate 1500mg, 90 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/LCitrulline_Front_New.webp?v=1788063818",
      "score": 53,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrakey",
        "citrulline",
        "malate",
        "1500mg",
        "capsules",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 42,
        "manufacturing": 58,
        "safety": 78,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 16.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831133130949",
      "vsf_explanation": "L-citrulline malate at 1500 mg per serving — an ingredient with real evidence for exercise performance (nitric oxide pathway support, reduced fatigue in resistance-training sets, improved endurance in cycling and running) — dosed substantially below the level used in the human RCTs that established the ingredient's reputation. The core evidence base for citrulline malate uses 6,000–8,000 mg pre-exercise (Perez-Guisado 2010, Wax 2015, Trexler 2019 review) — a 1,500 mg dose is roughly 20% of the studied protocol. At 1,500 mg the plasma arginine bump is measurable but the ergogenic effect is not consistently distinguishable from placebo. To dose the studied protocol from this SKU a user would need 4–5 capsules pre-workout, at which point the cost-per-effective-serving is well above what a bulk citrulline powder would deliver. This is the sub_therapeutic_dose pattern where the ingredient is real but the delivered dose is materially below what the label implies through association with citrulline research. Auto-failed under sub_therapeutic_dose. The ingredient itself is safe and honest — the problem is that 1,500 mg is a marketing dose, not a working dose.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "nutrakey-glutamine-900mg-100-capsules",
      "title": "NutraKey Glutamine 900mg, 100 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Picture25_503d041b-a7c2-4c78-8276-4c582353b8f9.jpg?v=1788063818",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrakey",
        "glutamine",
        "900mg",
        "100",
        "capsules",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 38,
        "manufacturing": 58,
        "safety": 78,
        "transparency": 62,
        "sustainability": 48
      },
      "price": 10.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831133163717",
      "vsf_explanation": "L-glutamine at 900 mg per capsule — an ingredient category that already has weak evidence in healthy resistance-trained adults (see Mutant Glutamine SKU above), compounded here by an aggressive sub-therapeutic per-capsule dose. The standard glutamine dose in the healthy-adult literature is 5 g/day (roughly 5–6 of these capsules per day for a nominal dose); clinical protocols for GI-permeability and endurance-overtraining contexts reach 20–30 g/day (22–33 capsules per day). The 900 mg per capsule format is a well-known pattern — it lets the label imply glutamine benefits without requiring the customer to buy the bulk powder that would actually deliver a working dose at a reasonable cost. Combined with the weak underlying evidence base for glutamine in the intended-user population (healthy training adults), this SKU is a rejection on two independent grounds: (1) the delivered dose per capsule is a fraction of studied protocols, making the marketing implication misleading, and (2) even at the correct dose the ingredient has minimal measurable effect in the marketed population. Auto-failed under sub_therapeutic_dose.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "nutrakey-dim-100mg-90-capsules",
      "title": "NutraKey DIM 100mg, 90 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/DIM_Front.webp?v=1788063818",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrakey",
        "dim",
        "100mg",
        "capsules",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 62,
        "sustainability": 48
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831133229253",
      "vsf_explanation": "Diindolylmethane (DIM) at 100 mg per capsule — same active ingredient at the same standard dose as the Allmax DIM SKU, with the same underlying evidence base (Dalessandri 2004, Thomson 2017 showing the 2:16 hydroxyestrone metabolite ratio shift at 100–200 mg/day). Sits two points below the Allmax version at 58 vs 60 because the framing here — 'hormone balance for both men and women' with only mild claims — is defensible, but the manufacturing and public quality documentation on NutraKey is thinner than on Allmax, and there is no differentiation on absorption technology (BioPerine or enhanced-bioavailability DIM would justify a bump, and neither is disclosed on the SKU description). Same drug-interaction cautions apply: DIM inhibits CYP3A4 which handles roughly 30% of prescription drugs, so people on hormonal therapy, statins, or SSRIs should coordinate with a clinician before starting. Standard-band placement is honest: real ingredient at the standard dose, real if modest mechanistic effect on estrogen metabolism, marketing implications for muscle definition or 'fat loss' ahead of the actual outcome literature.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrakey-acetyl-l-carnitine-1000mg-60-capsules",
      "title": "NutraKey Acetyl-L-Carnitine 1000mg, 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Picture12_96658b91-b0c4-4717-91ff-a0cd5f7e5c8a.jpg?v=1788063819",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrakey",
        "acetyl",
        "carnitine",
        "1000mg",
        "capsules",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 72,
        "manufacturing": 58,
        "safety": 78,
        "transparency": 65,
        "sustainability": 48
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831133196485",
      "vsf_explanation": "Acetyl-L-carnitine (ALCAR) at 1,000 mg per capsule — the acetylated form of L-carnitine that crosses the blood-brain barrier more effectively than plain L-carnitine, and the form used in most cognitive-effect and neuroprotection RCTs. The best evidence supports ALCAR for age-related cognitive decline (Malaguarnera 2011 in mild hepatic encephalopathy, Montgomery 2003 meta-analysis in mild cognitive impairment), diabetic peripheral neuropathy (Sima 2005 randomized trial at 2,000 mg/day), and reduced fatigue in older adults (Malaguarnera 2007). Data in healthy young adults is thinner but plausible for cognitive-fatigue reduction and mitochondrial support during high metabolic demand. The 1,000 mg dose per capsule is workable — most clinical protocols use 1,500–3,000 mg/day divided into 2–3 doses, so this is a one-to-three-cap-per-day product depending on target dose. Standard placement reflects real evidence and honest dosing, held below Verified because (1) marketing framing implies fat-loss benefit that the ingredient does not consistently deliver in healthy adults (the fat-metabolism story is real biochemically but the outcome effect on body composition is small and inconsistent in trials), and (2) no third-party identity or heavy-metal testing is publicly disclosed on this SKU.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mutant-pro-triple-whey-protein-powder-5lbs",
      "title": "Mutant Pro Triple Whey Protein Powder, 5lbs",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Picture7_50c88802-9c65-4867-85d4-8ddfc8a7d994.jpg?v=1788063820",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mutant",
        "pro",
        "triple",
        "whey",
        "protein",
        "powder",
        "5lbs",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 82,
        "transparency": 55,
        "sustainability": 52
      },
      "price": 60,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831133294789",
      "vsf_explanation": "Whey protein blend at 24 g per serving, marketed as a 'triple whey' — typically indicating a mix of whey isolate, concentrate, and hydrolysate. Whey protein blends at 20–30 g per serving have the same core evidence support as pure whey isolate for muscle protein synthesis and recovery (Morton 2018 meta-analysis), and the blend format is functionally equivalent for most users while being cheaper per gram of protein than pure isolate. The transparency issue that keeps this at Standard rather than Verified: the label does not disclose the percentage split across isolate, concentrate, and hydrolysate — a proprietary-blend pattern for whey blends specifically. That matters because a nominally 'triple whey' can economically be 80% cheap concentrate plus 10% each of the marquee forms, with a total protein content that meets label but reflects a different value equation than the naming implies. Amino-spike history in the whey category (2015 ConsumerLab investigation) makes this a relevant transparency issue. Standard-band placement is honest: reasonable protein delivery per serving, real underlying ingredient category, mid-tier brand, incomplete disclosure of the blend composition.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrakey-hmb-strength-recovery-90-capsules",
      "title": "NutraKey HMB Strength & Recovery, 90 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HMB_Front_640x640_3a969604-35f0-47e4-9444-eb362bc241a2.webp?v=1788063818",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrakey",
        "hmb",
        "strength",
        "recovery",
        "capsules",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 78,
        "transparency": 62,
        "sustainability": 48
      },
      "price": 12.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831133262021",
      "vsf_explanation": "Beta-hydroxy-beta-methylbutyrate (HMB) — a leucine metabolite marketed for muscle preservation and anti-catabolism. The evidence base is bimodal: HMB shows meaningful and consistent benefit in untrained beginners starting a resistance program (Nissen 1996 original trial), in older adults for sarcopenia prevention (Molfino 2013 meta-analysis), and in high-volume catabolic contexts (military basic training, weight-cut protocols). In already-trained resistance athletes with adequate protein intake, the effect is much smaller and inconsistent — the 2013 Wilson meta-analysis in J Int Soc Sports Nutr found effects in trained athletes that were later challenged by better-controlled trials (Estoche 2019). The standard studied dose is 3 g/day split into 3 x 1 g doses, timed around training. If this SKU delivers ~1 g per capsule (typical commercial format — the label does not specify the exact per-capsule amount from the description snippet), then a full studied dose is 3 capsules/day, which is workable. Standard-band placement reflects real evidence in specific populations and honest labeling, held below Verified because the marketing implies benefit for the trained-lifter population where the evidence is weakest, and the label does not disclose whether the HMB form is calcium-HMB (studied) or free-acid HMB (better bioavailability but thinner evidence).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "insane-labz-psychotic-rated-r-25-servings",
      "title": "Insane Labz Psychotic Rated R, 25 Servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/insane-labz-psychotic-rated-r..png?v=1788063824",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "insane",
        "labz",
        "psychotic",
        "rated",
        "servings",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 28,
        "manufacturing": 45,
        "safety": 32,
        "transparency": 22,
        "sustainability": 40
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831133327557",
      "vsf_explanation": "High-stimulant proprietary pre-workout from Insane Labz — a brand line that has repeatedly appeared in FDA warning letters and Cohen-lab detection studies for containing undeclared stimulants (DMHA, higenamine, methylsynephrine). The Psychotic line specifically has a documented history of proprietary 'stimulant matrix' blends that pack multiple stimulants under a single milligram total, making dose-per-ingredient unverifiable. Even the label's own 'high-stimulant' 'hardcore performance' framing signals that this is a stack-multiple-stimulants product where the individual components — caffeine, DMHA or a legal analog, yohimbine, huperzine — are undisclosed at the ingredient level. This is precisely the pattern proprietary_blend_hides_dose autofail is designed to catch. Compounding safety concern: Insane Labz has faced FDA warning letters (2019) for products containing DMAA and other unauthorized stimulants; consumer-lab investigations have found label inaccuracies. The category-level failure mode is not hypothetical — proprietary high-stim pre-workouts have documented case reports of cardiac events, hypertensive emergencies, and psychiatric episodes in young otherwise-healthy users. Auto-failed for proprietary_blend_hides_dose. Not listable.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "mutant-creakong-75-servings",
      "title": "Mutant Creakong, 75 servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Picture6_c36ece0d-d28c-4975-9a13-005b34079bc6.jpg?v=1788063826",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mutant",
        "creakong",
        "servings",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 42,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 38,
        "sustainability": 50
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831133393093",
      "vsf_explanation": "A 'triple creatine blend' at 4 g total per serving marketed as combining three advanced creatine forms. Two problems make this a Rejected placement despite creatine itself being the strongest-evidenced sports ergogenic aid in the market. First, the total dose is 4 g, which sits below the 5 g/day maintenance protocol used in essentially all creatine monohydrate research (Kreider 2017 ISSN position stand). Any 'blend' that dilutes monohydrate with alternative forms and lands under 5 g total is delivering a sub-therapeutic dose of the only creatine form with robust evidence. Second, and more importantly, 'triple creatine blend' language without disclosure of the mg breakdown across the three forms is the exact pattern the proprietary_blend_hides_dose autofail is designed to catch. A user cannot verify how much of each form is present — they cannot know whether the product is 3.8 g monohydrate plus 100 mg each of two decorative forms, or 1.3 g of each, or something worse. The alternative creatine forms (creatine HCl, creatine ethyl ester, buffered creatine) collectively have no controlled human evidence of superiority over monohydrate at equivalent doses and are meaningfully more expensive per gram. The category-level pattern of dressing up under-dosed monohydrate with 'advanced form' language is exactly what a Vyvata reviewer should reject.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "allmax-rapidcuts-extreme-powder-30-servings",
      "title": "AllMax RapidCuts Extreme Powder, 30 Servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/allmax_rapidcuts_xtreme..jpg?v=1788063826",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "allmax",
        "rapidcuts",
        "extreme",
        "powder",
        "servings",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 32,
        "manufacturing": 55,
        "safety": 42,
        "transparency": 32,
        "sustainability": 45
      },
      "price": 20,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831133425861",
      "vsf_explanation": "High-stimulant thermogenic fat-burner powder positioned as 'metabolic ignition' with energy, focus, and calorie-burn claims. Products in this category almost universally rely on undisclosed 'thermogenic blends' or 'energy matrix' proprietary formulas that mix stimulants (caffeine, yohimbine, synephrine, higenamine), thermogenics (L-carnitine, green tea catechins), and 'fat-mobilizing' ingredients at collectively opaque doses. Even if individual actives were disclosed, the human evidence for measurable and clinically meaningful fat-loss beyond what a caloric deficit produces is essentially absent for every thermogenic ingredient class — meta-analyses of green tea extract (Jurgens 2012 Cochrane), L-carnitine (Pooyandjoo 2016), and synephrine/bitter orange (Stohs 2012) show effect sizes of 0.5–1.5 kg over 8–12 weeks that are not distinguishable from the caloric deficit prescribed alongside the intervention. Meanwhile, the stimulant-stack safety profile of this class is real: hepatotoxicity case reports (particularly with concentrated green tea catechins and 'Fat Burner' blends — Mazzanti 2015), cardiovascular events with yohimbine plus caffeine plus synephrine, and psychological dependence on 'thermogenic' rituals for weight control. Auto-failed under proprietary_blend_hides_dose (typical for the category) and unverified_medical_claim for 'metabolic ignition' framing that no ingredient in this class actually delivers.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "allmax-yohimbine-rauwolscine-60-caps",
      "title": "Allmax Yohimbine + Rauwolscine, 60 Caps",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/YOHIMBINE-US1008-main-1.webp?v=1788063826",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "allmax",
        "yohimbine",
        "rauwolscine",
        "caps",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 32,
        "transparency": 52,
        "sustainability": 45
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831133491397",
      "vsf_explanation": "Yohimbine plus its more potent stereoisomer alpha-yohimbine (rauwolscine), positioned for stubborn-fat mobilization via alpha-2 adrenergic receptor blockade. The pharmacological rationale is real — alpha-2 antagonism does increase lipolysis in adipose tissue, and fasted-state exercise plus yohimbine has shown small effects in some trials (Ostojic 2006 in soccer players, 2.2% body-fat reduction over 21 days). But two facts make this a Rejected placement. First, the safety profile of yohimbine + rauwolscine stacking is genuinely concerning: yohimbine is a nonselective alpha-2 antagonist that reliably raises blood pressure and heart rate, is associated with case reports of hypertensive crisis, anxiety attacks, and cardiac arrhythmia, and has documented dose-response toxicity above ~0.4 mg/kg (Cohen 2016). Adding rauwolscine — a more potent congener — compounds this in an unpredictable way that has essentially no controlled dose-response literature. Second, Cohen et al. 2015 in Drug Test Anal analyzed 49 commercially available yohimbine products and found label yohimbine content ranged from 23% to 147% of stated dose, meaning even a disciplined user cannot reliably know what they are ingesting. Combined with the pattern of stacking these products with pre-workouts, caffeine, and fat-burners, the aggregate stimulant safety envelope collapses fast. Auto-failed under safety_concern — the ergogenic ceiling is small, the dose-quality control problem is documented across the category, and the failure modes (hypertensive event, anxiety crisis, cardiac arrhythmia) are meaningfully worse than what other supplement categories carry.",
      "vsf_autofail_rule": "safety_concern"
    },
    {
      "handle": "allmax-allgreens-30-servings",
      "title": "AllMax AllGreens+, 30 Servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/allmax-nutrition-allgreens_..jpg?v=1788063826",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "allmax",
        "allgreens",
        "servings",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 58,
        "sustainability": 62
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831133524165",
      "vsf_explanation": "Greens powder with a stated 15 superfoods, added digestive enzymes, and Bacillus coagulans BC99 probiotic. In the greens-powder category, the honest evaluation hinges on ingredient count discipline and disclosure — the widely-marketed AG1 (Athletic Greens) product buries 75+ ingredients under a proprietary blend and delivers homeopathic doses of most of them; a greens SKU with 15–30 clearly-listed ingredients at reasonable per-serving amounts is on the defensible end of the category. This SKU sits in the middle: 15 ingredient count is honest, BC99 is a specific probiotic strain (not a generic 'probiotic blend'), and the digestive enzyme inclusion is a differentiator. What it does not do is publish per-ingredient milligram breakdowns on the front of the panel — the total-'superfood-blend' language is standard-industry-obscure. On the evidence side, greens powders as a category have modest measurable effects on phytonutrient intake markers (Zhang 2020) but essentially no controlled evidence for downstream clinical outcomes (energy, immune function, cognition) versus baseline diet. They are a defensible micronutrient safety net for people whose vegetable intake is genuinely low, not a health intervention for people who eat 5+ servings of vegetables daily. Standard placement reflects the honest category — real ingredients, reasonable count, incomplete transparency, modest but real benefit for a specific user profile.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrakey-nac-600mg-60-capsules",
      "title": "NutraKey NAC 600mg, 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0082010345640.webp?v=1788063826",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrakey",
        "nac",
        "600mg",
        "capsules",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 72,
        "manufacturing": 58,
        "safety": 78,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831133622469",
      "vsf_explanation": "N-acetyl-cysteine at 600 mg per capsule — functionally the same product as the Allmax NAC SKU with the same underlying evidence base (glutathione precursor supply, mucolytic activity, PCOS insulin-sensitivity RCTs). The 600 mg dose is standard across the supplement literature; the ingredient itself is one of the most-studied 'antioxidant' compounds in medicine because of its established prescription use in acetaminophen overdose. Placement one point below the Allmax NAC SKU (68 vs. 70) reflects two brand-level factors: NutraKey publishes less-detailed public quality documentation than Allmax and does not consistently publish per-lot COAs on the site; and the 'glutathione, liver, wellness' framing on this SKU is somewhat less loaded than 'Immune Support' branding but still ahead of the general-population evidence base. Same category-level regulatory caveat about NAC's unresolved FDA status applies. Fundamentally: a well-dosed common ingredient at a standard price from a mid-tier brand — Standard band is the honest placement.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrakey-bcaa-optima-30-servings",
      "title": "Nutrakey BCAA Optima, 30 Servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/nutrakey-bcaa-optima-rainbow-30-servings.png?v=1788063828",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrakey",
        "bcaa",
        "optima",
        "servings",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 78,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 10,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831133688005",
      "vsf_explanation": "Branched-chain amino acid formula delivering 7 g BCAAs plus glutamine, taurine, and electrolytes per serving in a zero-calorie flavored powder. The core evidence problem is well-summarized in the Wolfe 2017 review in J Int Soc Sports Nutr: BCAAs in isolation cannot stimulate muscle protein synthesis maximally because they lack the other six essential amino acids required for translation — you get a transient rise in signaling (mTOR/p70S6K) without the substrate to build with. In adults hitting a normal protein target from whole food or whey, adding intra-workout BCAAs produces measurably no additional muscle protein synthesis, no additional hypertrophy over an 8-week training block (Jackman 2017), and no meaningful reduction in muscle soreness that survives methodological scrutiny. The taurine, electrolyte, and glutamine additions are honest inclusions but do not fix the core issue — the product is a hydration flavor system with amino acids that would be more effective if they were 20 g of whey or 10 g of EAAs. Product sits in the Standard band because it is honest about what it contains, correctly dosed for what BCAAs claim to be, safe, and useful for taste-driven hydration during training — the issue is category-level, not brand-level.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "allmax-d-i-m-100mg-60-veggie-caps",
      "title": "Allmax D.I.M. 100mg, 60 Veggie Caps",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Allmax-DIM-60-484593-408007_700x700_76008869-68b7-43b6-8a4f-018bde14ad28.webp?v=1788063829",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "allmax",
        "100mg",
        "veggie",
        "caps",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 62,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831133786309",
      "vsf_explanation": "Diindolylmethane (DIM) at 100 mg — a phytochemical derived from indole-3-carbinol in cruciferous vegetables that modulates estrogen metabolism, shifting the ratio of 2-hydroxyestrone to 16-alpha-hydroxyestrone toward the 2-OH pathway (the 'more favorable' metabolite ratio from a breast-cancer-risk-modeling standpoint). Human data is limited but real: Dalessandri 2004 in tamoxifen-treated breast cancer patients, Thomson 2017 in postmenopausal women, and several smaller trials show the 2:16 hydroxyestrone shift at 100–200 mg/day. Clinical outcome data (actual reductions in hormone-driven symptoms, breast tissue markers, or body-composition change) is much thinner and mostly inferred from the metabolite shift rather than directly demonstrated. The 100 mg dose is standard commercial practice and reasonable given DIM's variable oral bioavailability. Sits in the Standard band because the mechanistic story is real, but marketing implications (improved muscle definition, fat loss, direct strength benefit) far outrun the outcome evidence. There are also legitimate safety questions: DIM at higher doses (300+ mg/day) has case reports of headaches, GI symptoms, and hormone-driven side effects, and it interacts with cytochrome P450 3A4 which raises real drug-interaction concerns for people on hormonal therapy, SSRIs, or statins.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "allmax-nac-immune-support-60-veggie-caps",
      "title": "Allmax NAC (Immune Support), 60 Veggie Caps",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/61MCUw4wXVL.__AC_SX300_SY300_QL70_FMwebp.webp?v=1788063830",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "longevity",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "allmax",
        "nac",
        "immune",
        "support",
        "veggie",
        "caps",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 75,
        "manufacturing": 62,
        "safety": 78,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 12.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831133851845",
      "vsf_explanation": "N-acetyl-cysteine (NAC) at 600 mg per capsule — a clinically-used molecule with an unusual profile for a dietary supplement: it is the standard emergency-department antidote for acetaminophen overdose, a prescription mucolytic in some countries, and the subject of hundreds of controlled trials for oxidative-stress-related conditions. As a supplement, the best evidence supports NAC for glutathione precursor supply in populations with depleted glutathione (chronic heavy alcohol use, hepatic stress, chronic pulmonary conditions), modestly for reducing acute-respiratory-infection duration in older adults (De Flora 1997), and for polycystic ovary syndrome insulin sensitivity (Thakker 2015 meta-analysis). The 600 mg dose is the standard used across most of the supplement-context literature. Sits in the Verified band because the ingredient is genuinely well-studied and honestly dosed, and there is no proprietary blend or misleading positioning. Not Elite because (1) FDA's 2020 position that NAC is 'not a lawful dietary ingredient' remains legally unresolved and creates category-level regulatory uncertainty about NAC-in-supplement-form, (2) this SKU does not publish third-party identity or heavy-metal testing that would distinguish it in a category where impurity has occasionally been an issue, and (3) the 'Immune Support' framing on the front panel oversells the immune evidence for a general healthy adult — the immune-focused trials were largely in older adults with baseline glutathione depletion.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "allmax-caffeine-200mg-100-capsules",
      "title": "Allmax Caffeine 200mg, 100 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CAFFEINE-US1011-main.webp?v=1788063831",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "allmax",
        "caffeine",
        "200mg",
        "100",
        "capsules",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 88,
        "formulation": 70,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 5.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831133819077",
      "vsf_explanation": "Plain caffeine anhydrous at 200 mg per capsule — same core evidence base as any commercially available caffeine SKU (ISSN position stand Guest et al. 2021; Grgic 2020 meta-analyses on sprint, endurance, cognitive performance). This is the smaller-count Allmax version of what Mutant sells in a 240-tablet bottle: a commoditized ingredient in an honest single-ingredient package. The 3–6 mg/kg pre-exercise window is well-established, and 200 mg is a workable single dose for most adults. Standard-band placement mirrors the Mutant caffeine SKU: real evidence, honest label, but not brand-differentiated on quality once GMP is satisfied, and the loose-tablet format demands user judgment on daily total-caffeine tracking. The capsule format on this SKU is a minor plus over a naked tablet — encapsulation slows any accidental oral-mucosa exposure and improves dosing discretion. The 'Enhances mental alertness, focus, and endurance' language on the front panel is defensible; the real caveats are chronic tolerance (Beaumont 2017 — 4 weeks of habitual use halves the ergogenic response) and the aggregate-daily-intake safety issue for stacking with pre-workouts and coffee.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "allmax-cla-80-femme-60-softgels",
      "title": "Allmax CLA 80 Femme, 60 SoftGels",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cla-80-femme-allmaxnutrition-60-ct-587156_1024x1024_c87b87ea-74ab-4d43-a979-c2425550e194.webp?v=1788063831",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "allmax",
        "cla",
        "femme",
        "softgels",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 55,
        "manufacturing": 62,
        "safety": 62,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831133884613",
      "vsf_explanation": "Conjugated linoleic acid softgels marketed as a fat-loss/lean-mass aid, with a 'Femme' gender-marketing wrap targeting women. The evidence problem is central: the largest and best-controlled human meta-analyses on CLA for weight and fat loss (Whigham et al. 2007 Am J Clin Nutr; Onakpoya et al. 2012 Public Health Nutr) found effect sizes on the order of 0.05–0.2 kg of fat loss over months of supplementation — smaller than measurement noise and not clinically meaningful for anyone using it as advertised. Meanwhile the safety signal is not zero: several trials report worsened insulin sensitivity and increased inflammatory markers (particularly with the t10,c12 isomer that is enriched in supplement CLA versus the c9,t11 isomer dominant in food-source CLA). The 'Femme' naming is pure marketing — there is no female-specific formulation reason for a CLA softgel; the product is compositionally the same as any other CLA capsule. Auto-failed under unverified_medical_claim for the fat-loss / body-recomposition positioning, which is not supported by the human evidence base at commercially available doses. Would need to drop the fat-loss claim and reposition as a plain omega-family fatty-acid supplement to be listable, and the 'Femme' gender-differentiation would still be misleading.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "allmax-beta-alanine-125-servings",
      "title": "Allmax Beta-Alanine, 125 Servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4173VJb9KML._AC_SL1000.webp?v=1788063831",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "allmax",
        "beta",
        "alanine",
        "125",
        "servings",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 82,
        "formulation": 75,
        "manufacturing": 65,
        "safety": 78,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 17.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831133917381",
      "vsf_explanation": "Single-ingredient beta-alanine powder — one of the small number of sports-supplement ingredients that carries a full International Society of Sports Nutrition (ISSN) position stand endorsing efficacy (Trexler et al. 2015). Chronic beta-alanine loading at 3.2–6.4 g/day for 4–10 weeks raises intramuscular carnosine roughly 60–80%, which measurably improves performance in exercise bouts lasting 1–4 minutes (the classic time domain where lactic acid accumulation limits output) — think high-intensity intervals, 400–1500 m running, and lifting sets in the 8–20 rep range. Effect size in that time domain is real and repeatable across meta-analyses (Hobson 2012, Saunders 2017 Br J Sports Med). Sits at the low end of the Verified band because (1) the product is a single-ingredient bulk powder without brand-specific banned-substance certification (relevant for tested athletes), (2) the label does not disclose per-lot heavy-metal or identity testing, and (3) beta-alanine has almost no measurable ergogenic benefit outside the 1–4 minute duration window — a lot of the marketing implies general 'endurance' and 'strength' benefits that the ingredient does not actually deliver for long endurance efforts or 1-rep-max lifting.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "allmax-r-ala-alpha-lipoic-acid-125mg-60-capsules",
      "title": "Allmax R-ALA (Alpha Lipoic Acid) 125mg, 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Allmax-R-ALA-60-526064_700x700_4302eb28-f571-4bde-bea7-507b7017f2d4.webp?v=1788063831",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "allmax",
        "ala",
        "alpha",
        "lipoic",
        "acid",
        "125mg",
        "capsules",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831133950149",
      "vsf_explanation": "R-alpha lipoic acid (R-ALA) is the biologically active R-isomer of alpha-lipoic acid, distinct from the racemic R/S mixture that dominates the cheaper alpha-lipoic acid market. The strongest human evidence for ALA is in diabetic peripheral neuropathy — the SYDNEY 2 (Ziegler 2006) and NATHAN 1 (Ziegler 2011) trials showed measurable symptom relief at 600 mg/day over months, and ALA is prescribed clinically in Germany for that indication. There is also plausible evidence for modest improvements in insulin sensitivity and glucose disposal in prediabetic and diabetic populations (Rahimlou 2019 meta-analysis). The 125 mg per capsule dose is on the low end of the evidence base — most clinical protocols use 300–600 mg/day, so a user chasing the studied effect would need 3–5 capsules/day. R-ALA specifically is more bioavailable than the racemic form gram-for-gram, which partially compensates for the lower per-capsule dose, but the marketing implication that 125 mg of R-ALA equals a full clinical dose is not fully supported by the pharmacokinetic literature. Sits in the Standard band because the ingredient is real and studied, the isomer choice is defensible, but the dose is lower than the studied protocols and the marketing suggests general 'antioxidant / nutrient absorption' benefits beyond the neuropathy/glycemic evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mutant-caffeine-240-tablets",
      "title": "Mutant Caffeine, 240 tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Picture31_7f944506-fc95-43cb-80aa-2f559bb84091.jpg?v=1788063831",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mutant",
        "caffeine",
        "240",
        "tablets",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 88,
        "formulation": 72,
        "manufacturing": 58,
        "safety": 62,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 8.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831133982917",
      "vsf_explanation": "Plain caffeine anhydrous at 200 mg per tablet — one of the most rigorously studied ergogenic aids in sport, backed by an ISSN position stand (Guest et al. 2021), decades of RCTs across sprint, endurance, and cognitive-performance endpoints, and clear pharmacokinetics. Caffeine at 3–6 mg/kg bodyweight roughly 30–60 minutes before exercise reliably improves endurance performance, reaction time, alertness, and repeated-sprint output; effect sizes are among the largest of any legal supplement. The product itself is simple, honestly labeled, and the 200 mg per tablet is a reasonable dosing increment. Sits in the Standard band rather than Verified for two reasons: (1) caffeine is a functionally interchangeable commodity — a bottle of 200 mg caffeine tablets is the same regardless of brand and does not differentiate on quality once the tablet is manufactured to GMP standards, (2) the safety profile requires more user judgment than the label implies. 240 tablets in a shaker with no dose-tracking is a real overdose exposure if a user takes multiples out of habit, layers it on top of coffee, or dry-scoops. Also relevant: caffeine tolerance builds fast (2–4 weeks of daily use blunts most ergogenic effects — Beaumont 2017), so the marketing implication of sustained pre-workout benefit is only true if you cycle it.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mutant-glutamine-60-servings",
      "title": "Mutant Glutamine, 60 servings",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/mutant-glutamine..png?v=1788063833",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mutant",
        "glutamine",
        "servings",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 68,
        "manufacturing": 62,
        "safety": 82,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831134015685",
      "vsf_explanation": "Single-ingredient 5 g L-glutamine powder from Mutant, a Canadian sports-nutrition brand with a long presence in the mass-market lifter channel. The formulation is honest — pure L-glutamine, no blend, no undisclosed additions — but the evidence case for supplemental glutamine in healthy resistance-trained adults is genuinely weak. The best-controlled trials (Candow et al. 2001, Wilkinson et al. 2006, Legault et al. 2015) found no meaningful improvement in muscle protein synthesis, strength, hypertrophy, or recovery when added on top of an adequate protein diet. Glutamine is conditionally essential during severe catabolic stress (burn injury, critical illness, high-intensity endurance overtraining, gut-injury protocols) — those clinical contexts have some evidence and are where the ingredient earned its reputation. Extrapolating from ICU literature to a healthy lifter hitting 150 g protein/day is not warranted. Product sits in the Standard band because it is honest, safe, and correctly dosed if you happen to want glutamine — it is not sub-therapeutic and not autofail-material — but the ingredient itself is doing less than the marketing implies for the intended user.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "relivaid™",
      "title": "Relivaid™",
      "vendor": "Trelli",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/WhatsAppImage2026-06-01at9.06.13PM.jpg?v=1788063924",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "relivaid",
        "trelli"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 32,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 20,
        "sustainability": 38
      },
      "price": 45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831134736581",
      "vsf_explanation": "The Relivaid product description is essentially one sentence: \"Formulated by doctors, Relivaid provides pain support with innovative, naturally derived bioactives, optimized for rapid absorption.\" Nothing else is disclosed. No ingredients, no doses, no mechanism, no indication of what specific pain the product addresses (nociceptive, neuropathic, inflammatory, headache, joint), no clinical trial reference for the \"formulated by doctors\" claim, no identification of which doctors formulated it or their qualifications, no COA, no manufacturing disclosure, no safety information. \"Naturally derived bioactives\" is category-noun language that could describe any botanical or nutraceutical from turmeric to boswellia to willow bark to CBD to essentially anything sold as a supplement. \"Rapid absorption\" is a marketing claim with no measurable specification. This is the compound form of two auto-fail conditions: `misleading_naming` (a portmanteau brand name with no functional description) and `proprietary_blend_hides_dose` (no disclosure of ingredients at all, let alone doses). The pain-support claim itself edges toward `unverified_medical_claim` in the absence of any evidence disclosure. Not listable at any tier.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "sleep-deeply™️",
      "title": "SLEEP DEEPLY™️",
      "vendor": "Muzzle Sleep",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SleepDeeplyFront.png?v=1788063944",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sleep",
        "deeply",
        "muzzle",
        "sleep"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831136506053",
      "vsf_explanation": "Muzzle Sleep 'SLEEP DEEPLY' is an herbal sleep supplement positioned as an alternative to synthetic melatonin, marketed as supporting the body's own melatonin production and sleep-wake rhythm. Without the full ingredient panel visible in the description reviewed ('crafted with powerful, all-natural ingredients' is not a Supplement Facts panel), several factors are unclear: specific ingredient list, per-ingredient doses, whether the formula uses a proprietary blend (which would be a proprietary_blend_hides_dose autofail concern), and whether it hits evidence-anchored doses for whatever ingredients are used. Typical 'natural sleep support' formulations use some subset of magnesium glycinate, L-theanine, ashwagandha, GABA precursors, valerian, passionflower, chamomile, and low-dose melatonin (despite the marketing claim, many 'natural' sleep products include melatonin at 0.3-1 mg doses). Effect sizes across the class are modest and heterogeneous. Marketing framing ('deep, restorative sleep without heavy drowsiness, brain fog, or next-day crash') is DSHEA-permissible structure-function. Standard tier at moderate score based on category expectations — cannot fully evaluate without ingredient disclosure. Transparency subscore reflects lack of visible facts panel. Would move higher with full quantitative panel, confirmation that the product does or does not contain melatonin (and at what dose), evidence-anchored doses for the botanicals used, and third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "muzzle®-beauty-patch-mouth-tape",
      "title": "Muzzle® Beauty Patch Mouth Tape",
      "vendor": "Muzzle Sleep",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Beauty_Patch_-_Hero_Image_-_5.png?v=1788063948",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "muzzle",
        "beauty",
        "patch",
        "mouth",
        "tape",
        "muzzle",
        "sleep"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_environment"
      ],
      "vsf_dimensions": {
        "analytical_validity": 48,
        "clinical_utility": 50,
        "transparency": 65,
        "build_quality": 62,
        "warranty_support": 55,
        "value": 55
      },
      "price": 39.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831136604357",
      "vsf_explanation": "Muzzle® Beauty Patch Mouth Tape is a hybrid mouth-tape product infused with Vitamin E, hyaluronic acid, and collagen, marketed for overnight lip hydration and 'natural lip plumping' in addition to mouth-tape's usual nasal-breathing encouragement. The product tries to serve two functions — mouth taping for breathing plus topical beauty ingredient delivery to the lips. Neither claim is strongly supported: mouth taping evidence is thin (as with the standard Muzzle products), and 'natural lip plumping' from overnight adhesive strip contact with vitamin E/HA/collagen is a marketing claim without substantive controlled-trial support (transdermal collagen delivery in a strip format is not established, and overnight hydration effect on lip fullness is transient at best). The topical safety flag: adhesive strips infused with active ingredients require particular attention to skin sensitivity — some users develop reactions to niacinamide, hyaluronic acid formulations, or preservatives. Category placement mirrors the other Muzzle tape products (sleep_optimization/sleep_environment) since the mouth-tape function is primary. Standard tier at moderate score on hybrid-function ambiguity + real product but overreaching cosmetic claims. Same OSA-screening caveat as all mouth-tape products. Would move higher with honest positioning around modest overnight lip hydration and dropping the 'plumping' claim.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "muzzle®-nasal-strips-for-adults",
      "title": "Muzzle® Nasal Strips for Adults",
      "vendor": "Muzzle Sleep",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nasal_Strip_-_1.png?v=1788063969",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "muzzle",
        "nasal",
        "strips",
        "for",
        "adults",
        "muzzle",
        "sleep"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_environment"
      ],
      "vsf_dimensions": {
        "analytical_validity": 60,
        "clinical_utility": 62,
        "transparency": 65,
        "build_quality": 65,
        "warranty_support": 55,
        "value": 65
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831136833733",
      "vsf_explanation": "Muzzle® Nasal Strips for Adults are external adhesive strips that mechanically open the nasal passages by pulling laterally on the nasal wings via spring-like plastic. This is the Breathe Right-style category, and unlike mouth-taping, nasal strips have a more established evidence base: mechanical objective measurements show ~30% increase in nasal cross-sectional area at the internal nasal valve during use (Latte 2005), and RCTs show modest reductions in snoring intensity and improvements in subjective breathing during exercise. Nasal strips are OTC and don't carry the OSA-screening concerns of mouth taping — they open the airway rather than restricting it. Effect sizes are modest but consistent. For mild snoring, congestion during colds, or nasal-valve-narrow athletes, they have a legitimate use case. Category placement in sleep_optimization/sleep_environment is reasonable per task guidance. Muzzle's version competes with GSK's Breathe Right (the market-defining brand) — head-to-head comparability depends on adhesive quality and spring tension. Standard tier on real evidence base + legitimate consumer product. Would move higher with third-party comparative testing versus Breathe Right and explicit spring-tension specification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "muzzle-nasal-sticks-mint-scented-3-pack",
      "title": "Muzzle Nasal Sticks - Mint Scented (3 Pack)",
      "vendor": "Muzzle Sleep",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0a9416a6d54a098b593251daecd51d31bc630411.jpg?v=1788063975",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "muzzle",
        "nasal",
        "sticks",
        "mint",
        "scented",
        "pack",
        "muzzle",
        "sleep"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_environment"
      ],
      "vsf_dimensions": {
        "analytical_validity": 45,
        "clinical_utility": 50,
        "transparency": 60,
        "build_quality": 60,
        "warranty_support": 50,
        "value": 60
      },
      "price": 24.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831136997573",
      "vsf_explanation": "Muzzle Mint Nasal Sticks are inhaler-format essential oil sticks containing peppermint, spearmint, eucalyptus, and menthol, marketed for a 'refreshing breathing experience.' Category placement in sleep_optimization/sleep_environment is imperfect — the product is more of a general aromatherapy inhaler than a sleep-specific device, but Muzzle Sleep's brand identity is sleep-adjacent and Vyvata's taxonomy has no closer match. Menthol-based inhalers can produce a subjective sensation of easier breathing via cold-receptor (TRPM8) activation without actually changing nasal airflow (Eccles 2003 — the menthol cooling sensation is not the same as objective decongestion). Evidence for menthol/eucalyptus inhalation for sleep-related breathing improvements is thin. Not autofailed because no explicit medical claims are made in the description reviewed. Rejected tier reflects category-fit ambiguity + thin evidence for the primary use case + limited placement in Vyvata's sleep-optimization framing where CPAP, sleep tracking, and structured environment interventions dominate the evidence. Would move higher only with substantial repositioning as a general aromatherapy product outside Vyvata's core sleep-optimization category.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "muzzle®-mouth-tape-for-adults-medium-hold",
      "title": "Muzzle® Mouth Tape for Adults (Medium Hold)",
      "vendor": "Muzzle Sleep",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0_1.webp?v=1788063975",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "muzzle",
        "mouth",
        "tape",
        "for",
        "adults",
        "medium",
        "hold",
        "muzzle",
        "sleep"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_environment"
      ],
      "vsf_dimensions": {
        "analytical_validity": 52,
        "clinical_utility": 55,
        "transparency": 68,
        "build_quality": 65,
        "warranty_support": 55,
        "value": 62
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831137030341",
      "vsf_explanation": "Muzzle® Mouth Tape for Adults (Medium Hold) is breathable adhesive strips designed to encourage nasal breathing during sleep. The mouth-taping category is a fast-growing consumer sleep product with a thin evidence base: mostly observational studies and biohacker anecdote, popularized by James Nestor's 2020 book 'Breath.' Small non-blinded trials suggest modest reductions in mild snoring and possibly improved subjective sleep quality in habitual mouth-breathers; larger controlled trials are absent. Muzzle is one of the leading dedicated mouth-tape brands and uses medical-grade adhesive with breathable material, which addresses common consumer concerns (skin irritation, adhesive residue). Category placement in sleep_optimization/sleep_environment is the closest taxonomic fit per task guidance. The important safety flag: mouth taping is contraindicated in undiagnosed sleep apnea — closed-mouth combined with an obstructed airway can worsen hypoxia — and users experiencing symptoms of OSA (loud snoring, witnessed apneas, morning headaches, excessive daytime sleepiness) should have a sleep study before adopting mouth tape. Not FDA-cleared as a medical device (it's marketed as a wellness product). Standard tier on real product + emerging use case + honest positioning. Would move higher with third-party clinical study on the specific product, better OSA-screening guidance in the packaging, and adhesive-safety documentation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "posture-corrector",
      "title": "Posture Corrector",
      "vendor": "Muzzle Sleep",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/posturecorrectormainimage.jpg?v=1788063975",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "posture",
        "corrector",
        "muzzle",
        "sleep"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "stretch_mobility"
      ],
      "vsf_dimensions": {
        "analytical_validity": 30,
        "clinical_utility": 40,
        "transparency": 30,
        "build_quality": 45,
        "warranty_support": 40,
        "value": 45
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831137128645",
      "vsf_explanation": "The Muzzle Sleep 'Posture Corrector' product listing has an empty product description in the source data, which is itself a red flag — a device product with no description cannot be evaluated for any of the transparency, build quality, or clinical utility criteria that a device score depends on. The generic name 'Posture Corrector' provides no branding, no mechanism specification (elastic shoulder brace, magnetic device, wearable sensor-based feedback?), and no context for why Muzzle Sleep (a mouth-tape brand) is selling it. Posture correctors as a category have mixed and generally weak evidence: brief postural changes are achievable but sustained neuromuscular retraining requires ongoing use plus physical therapy or targeted exercise; passive braces have small short-term evidence and can theoretically cause dependency if worn continuously without concurrent strengthening. Category placement in recovery_regeneration/stretch_mobility is the closest available; the product could arguably also be out-of-scope for Vyvata's core biohacking framing. Rejected tier reflects the empty description + generic naming + off-brand-adjacency issues. Autofail on out_of_scope_for_biohacking is arguable but not applied because generic posture braces do sit in a general wellness/recovery adjacent space; they're not clearly out of scope, just poorly documented at this listing. Would become listable at Standard 55+ with actual product description, brand identity, mechanism disclosure, and honest evidence framing.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "muzzle®-mouth-tape-for-youth-medium-hold",
      "title": "Muzzle® Mouth Tape For Youth (Medium Hold)",
      "vendor": "Muzzle Sleep",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0_6a738dff-32dd-4720-bf4a-9da78dd7350e.webp?v=1788063976",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "muzzle",
        "mouth",
        "tape",
        "for",
        "youth",
        "medium",
        "hold",
        "muzzle",
        "sleep"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_environment"
      ],
      "vsf_dimensions": {
        "analytical_validity": 45,
        "clinical_utility": 45,
        "transparency": 60,
        "build_quality": 62,
        "warranty_support": 55,
        "value": 55
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831137161413",
      "vsf_explanation": "Muzzle® Mouth Tape For Youth (Medium Hold) is the pediatric size of the adult mouth-tape product. Pediatric mouth taping raises meaningfully more safety concern than adult use: (1) pediatric obstructive sleep apnea has different presentations and different underlying anatomy (adenotonsillar hypertrophy is the leading cause, addressable by surgery, not by tape), (2) mouth breathing in children can be a sign of allergic rhinitis, adenoid hypertrophy, or other treatable conditions that warrant pediatric ENT evaluation, and (3) taping a child's mouth closed without addressing the underlying reason for mouth breathing does not fix the underlying condition and may mask progression of pediatric OSA. The American Academy of Pediatric Dentistry and the American Academy of Otolaryngology have not endorsed mouth taping for pediatric populations. Rejected tier reflects the compounded pediatric-specific safety flag on top of the already-thin adult mouth-tape evidence base. Not autofailed because no explicit medical claims are made about treating pediatric conditions in the description reviewed — but the pediatric-appropriateness question is significant. Would move higher only with prominent pediatric-specific safety warnings, mandatory pediatrician evaluation before use language, and explicit contraindication guidance for signs of pediatric OSA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "adult-extra-sensitive-tape",
      "title": "Adult Extra Sensitive Tape",
      "vendor": "Muzzle Sleep",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/IMG-3364.png?v=1788063975",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "adult",
        "extra",
        "sensitive",
        "tape",
        "muzzle",
        "sleep"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_environment"
      ],
      "vsf_dimensions": {
        "analytical_validity": 52,
        "clinical_utility": 55,
        "transparency": 68,
        "build_quality": 68,
        "warranty_support": 55,
        "value": 62
      },
      "price": 34.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831137259717",
      "vsf_explanation": "Muzzle Adult Extra Sensitive Tape is Muzzle's premium mouth-tape variant designed for sensitive or reactive skin. Same category-fit and evidence-base observations apply as with the Medium Hold adult version: mouth-taping is a fast-growing consumer sleep category with thin evidence (mostly observational + biohacker anecdote, popularized by James Nestor's 'Breath'), Muzzle uses medical-grade adhesive, and Vyvata's closest taxonomic placement is sleep_optimization/sleep_environment. The Extra Sensitive variant scores marginally higher than the Medium Hold specifically because it addresses the most common consumer concern (adhesive irritation) with a genuinely differentiated product — this is a real quality distinction, not just marketing. Standard tier on legitimate consumer product + emerging use case + reasonable claim discipline. Same OSA-screening safety caveat applies. Would move higher with third-party clinical study on the specific product and prominent OSA-screening guidance in the packaging.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "muzzle®-mouth-tape-for-adults-strong-hold",
      "title": "Muzzle® Mouth Tape for Adults (Strong Hold)",
      "vendor": "Muzzle Sleep",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0_70c4c8a0-c7ac-4871-bfb4-ded63c590ddb.webp?v=1788063976",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "muzzle",
        "mouth",
        "tape",
        "for",
        "adults",
        "strong",
        "hold",
        "muzzle",
        "sleep"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_environment"
      ],
      "vsf_dimensions": {
        "analytical_validity": 52,
        "clinical_utility": 55,
        "transparency": 65,
        "build_quality": 65,
        "warranty_support": 55,
        "value": 60
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831137358021",
      "vsf_explanation": "Muzzle® Mouth Tape for Adults (Strong Hold) is the higher-adhesive-strength variant of Muzzle's mouth-tape line, designed for users whose mouth opens more forcefully during sleep or who have facial hair the tape needs to hold against. Category-fit and evidence-base observations are identical to the Medium Hold variant: emerging use case, thin controlled-trial evidence, Muzzle is a legitimate dedicated mouth-tape brand with medical-grade adhesive, closest Vyvata taxonomic placement is sleep_optimization/sleep_environment. Standard tier on real product + emerging use case + reasonable positioning. Strong Hold specifically has slightly elevated adhesive-safety consideration — stronger tape on sensitive skin causes more irritation, and morning removal requires more care. Same OSA-screening safety caveat as all mouth-tape products. Would move higher with third-party clinical study on the specific product.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lithium-ascorbate-1-mg",
      "title": "Lithium Ascorbate 1 mg",
      "vendor": "Normotim",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0430_LA_1_mg.jpg?v=1788064001",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lithium",
        "ascorbate",
        "normotim"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 19.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831137652933",
      "vsf_explanation": "Normotim is a Russian-origin nutraceutical brand marketing low-dose (1 mg elemental) lithium as lithium ascorbate for mood and brain-wellness support. Two things are worth pulling apart. First, the dose: 1 mg of elemental lithium is roughly 1,000x below the therapeutic dose range for bipolar-disorder lithium carbonate (900-1800 mg/day of elemental lithium equivalent), which is a real prescription medication with a narrow therapeutic index. At 1 mg the safety envelope is very different — lithium at this dose sits within the range of naturally-occurring dietary lithium exposure in mineral-rich drinking water and does not carry the toxicity concerns of prescription lithium. Second, the evidence: nutritional-lithium research is a small but not fabricated corpus. Ecological studies from Texas (Schrauzer 1990), Japan (Ohgami 2009), and a Danish nationwide cohort (Kessing 2017) associate higher naturally-occurring drinking-water lithium with reduced suicide rates and lower incidence of dementia. A small number of interventional studies (Nunes 2013 in Alzheimer-adjacent populations) have examined nutritional-lithium doses. This is an emerging-evidence category with more signal than most supplement categories but well below RCT-level evidence for individual mood outcomes. Lithium ascorbate is a defensible chemical form (paired with vitamin C for absorption and reduced GI irritation). Standard tier reflects a legitimate niche with a modest evidence base and a clear low-dose safety profile.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "base-amino",
      "title": "BASE Amino",
      "vendor": "BASE Performance",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BasePerformance_AminoW_5a4fa29c-7de6-467d-b85d-20fe7f539cb6.png?v=1788064150",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "base",
        "amino",
        "base",
        "performance"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 65,
        "safety": 72,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 49.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831140307141",
      "vsf_explanation": "BASE Performance is a real endurance-sports brand with distribution in the triathlon and cycling channels, and BASE Amino is a positioned as their branched-chain and full-spectrum amino acid blend for endurance-athlete recovery. Amino acid supplementation — particularly BCAAs (leucine, isoleucine, valine at a 2:1:1 ratio) and EAAs (all nine essential amino acids in balanced ratios) — has a real but qualified evidence base. Meta-analytic evidence supports BCAAs for reducing exercise-induced muscle damage markers (creatine kinase, delayed-onset muscle soreness) at 5-10 g/day around workouts. EAAs at 6-15 g/day have muscle-protein-synthesis evidence, particularly in low-protein-intake or older-adult populations. The full efficacy debate hinges on whether the athlete is already consuming adequate dietary protein (~1.6-2.2 g/kg/day for training athletes) — when protein intake is adequate, isolated amino supplementation delivers minimal additional benefit. What holds BASE Amino at Standard is that the product description does not disclose the specific amino acid profile (BCAA vs EAA vs multi-amino), the per-serving milligrams of each, or the standardization of the blend. Real brand, real ingredient class, unclear specific formulation on the visible product copy.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "strength",
      "title": "Strength",
      "vendor": "Vitamin Patch Club",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/STRENGTHMAIN.webp?v=1788064205",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "strength",
        "vitamin",
        "patch",
        "club"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 18,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 29.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831141060805",
      "vsf_explanation": "Vitamin Patch Club is a real DTC brand focused on transdermal vitamin patch delivery. The \"Strength\" patch is marketed as iron (III) bisglycinate + BCAAs (leucine, isoleucine, valine) + CoQ10 delivered through a skin-adherent patch. The disqualifying problem is that transdermal delivery for iron, BCAAs, and CoQ10 has essentially no supporting peer-reviewed pharmacokinetic evidence. Iron bisglycinate is a chelated form optimized for oral absorption through the intestinal DMT1 transporter — the skin has no equivalent uptake mechanism, and human PK studies of transdermal iron delivery are absent. Branched-chain amino acids are hydrophilic molecules with molecular weights (131-146 Da) at the upper edge of passive transdermal absorption, and no published human PK study demonstrates meaningful systemic exposure from patch delivery at the doses relevant for muscle protein synthesis (grams, not micrograms). CoQ10 has a molecular weight of 863 Da, well above the ~500 Da threshold generally considered the practical limit for passive skin penetration, and no published data show meaningful blood-level increases from transdermal CoQ10 patches. The marketing implicit claim — that a patch delivers these nutrients to the bloodstream at doses that produce iron-repletion, ergogenic BCAA, and CoQ10-antioxidant effects — is not supported by human PK data. This is `unverified_medical_claim` for the transdermal delivery efficacy itself, regardless of the ingredients' oral-form evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sleep-patch",
      "title": "Sleep Patch",
      "vendor": "Vitamin Patch Club",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SLEEPMAIN.webp?v=1788064205",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sleep",
        "patch",
        "vitamin",
        "patch",
        "club"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 49.74,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831141159109",
      "vsf_explanation": "The Sleep Patch stacks L-tryptophan, GABA, melatonin, and 5-HTP for transdermal delivery. Each component fails a different peer-reviewed absorption question. Melatonin transdermal PK has been studied (a handful of small studies from cosmetics-adjacent research contexts) and shows highly variable and generally low bioavailability compared with oral dosing — no patch has been submitted to FDA for a systemic melatonin indication. GABA at 103 Da is small enough to potentially cross skin, but GABA notoriously does not cross the blood-brain barrier when given orally, and no published data suggest transdermal GABA produces central nervous system effects; the entire clinical premise fails at the blood-brain barrier, not at the skin. L-tryptophan and 5-HTP are the serotonin-pathway precursors that do have oral evidence for sleep (L-tryptophan ~1-3 g, 5-HTP 50-300 mg), but at those masses no patch can physically deliver the dose, and no PK study demonstrates meaningful serum-tryptophan or serum-5-HTP elevation from transdermal patches. As with the other Vitamin Patch Club SKUs, the ingredient evidence exists in oral form and does not transfer to the patch delivery vehicle. `unverified_medical_claim` applies for the transdermal sleep-support claim.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "beauty",
      "title": "Beauty",
      "vendor": "Vitamin Patch Club",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BEAUTYMAIN.webp?v=1788064204",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beauty",
        "vitamin",
        "patch",
        "club"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 48,
        "sustainability": 42
      },
      "price": 29.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831141355717",
      "vsf_explanation": "The Beauty Patch combines biotin (vitamin B7), keratin, marine collagen types I & III, and aloe vera in a wearable transdermal patch, positioned for hair, nail, and skin support. Marine collagen molecules are 300 kDa+ triple-helix proteins — many orders of magnitude larger than the ~500 Da practical threshold for passive skin penetration. Even hydrolyzed collagen peptides (2-10 kDa) are far above that threshold; the oral-collagen evidence base (which does exist at 2.5-10 g/day of hydrolyzed peptides) requires that the peptides survive digestion into di- and tri-peptides that circulate systemically. Keratin at 40-60 kDa fails the same skin-penetration test. Biotin has essentially no published transdermal PK data at doses relevant to hair or nail effects (2500-5000 mcg oral typical), and the biotin-for-hair oral evidence itself is weak outside of frank biotin deficiency. Aloe vera in a topical context has genuine dermatological utility (moisturization, minor wound healing) but delivering aloe transdermally as a systemic beauty ingredient is a different claim entirely. This is a `unverified_medical_claim` — the claimed systemic effects of the ingredient set are not delivered by the patch vehicle. Not listable.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "restore",
      "title": "Restore",
      "vendor": "Vitamin Patch Club",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/RESTOREMAIN.webp?v=1788064204",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "restore",
        "vitamin",
        "patch",
        "club"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "hrv_recovery_apps"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 48,
        "sustainability": 42
      },
      "price": 29.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831141257413",
      "vsf_explanation": "The Restore Patch stacks zinc glycinate, L-glutamine, Boswellia serrata extract, curcumin, and CoQ10 for transdermal delivery, positioned for inflammation, immune support, and muscle recovery. Each of those ingredients has some level of oral evidence — Boswellia (AKBA-standardized) has real anti-inflammatory data at 250-500 mg/day of standardized extract; curcumin (particularly Meriva/Longvida/Theracurmin bioavailability-enhanced forms) has anti-inflammatory data at 500-1500 mg/day; CoQ10 has recovery and cardiovascular data at 100-300 mg/day oral. None of them has published transdermal PK data at doses that would produce those effects. Curcumin is famously poorly absorbed even by mouth (which is why bioavailability-enhanced formulations exist); its skin penetration is essentially research-stage rather than a demonstrated clinical delivery vehicle. Boswellia's boswellic acids (particularly AKBA) are large molecules with limited transdermal permeability data. CoQ10 at 863 Da is above the practical passive-absorption threshold. As with the other Vitamin Patch Club SKUs, the underlying oral ingredient evidence does not transfer to a patch vehicle where the delivery has not been demonstrated. `unverified_medical_claim` applies for the transdermal recovery-support claim.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "night-caps",
      "title": "Night Caps",
      "vendor": "ABĒCA Naturals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/FullSizeRender_4064d01d-4104-4c5f-809f-0c3282d3e7fb.jpg?v=1788064375",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "night",
        "caps",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 31,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831143649477",
      "vsf_explanation": "Traditional sleep/relaxation blend built around valerian and hops. Valerian has real if modest RCT evidence for sleep latency at 300-600 mg extract (Fernandez-San-Martin 2010 meta-analysis, mixed results). Hops (Humulus lupulus) has traditional-use sleep pedigree and some small trials combining hops with valerian. Per-capsule ingredient milligrams not disclosed. Standard tier for a well-established traditional sleep blend.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "old-timers-blend",
      "title": "Old Timer's Blend",
      "vendor": "ABĒCA Naturals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/FullSizeRender_d1976232-53b9-47c4-ac26-518a5b17df16.jpg?v=1788064375",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "old",
        "timer",
        "blend",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831143682245",
      "vsf_explanation": "Cognitive-support blend of peppermint, Siberian ginseng (eleuthero), skullcap, and other herbs positioned to 'improve memory' and 'overcome the effects of aging on the brain.' The 'overcome effects of aging' framing borders on treatment-claim for cognitive decline — a diagnosable medical condition. Eleuthero has modest evidence for mental performance and fatigue reduction. Per-capsule doses not disclosed. Standard tier at the middle — traditional herbal blend with borderline claim framing that stops just short of autofail.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gaba-capsules",
      "title": "GABA Capsules",
      "vendor": "ABĒCA Naturals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/GABA.png?v=1788064375",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gaba",
        "capsules",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 58,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831143715013",
      "vsf_explanation": "500 mg per capsule GABA — dose disclosed transparently, which is a plus. However, oral GABA's ability to cross the blood-brain barrier is limited and contested — the calming effects reported in trials may work via peripheral (enteric nervous system) rather than direct CNS effects (Boonstra 2015 review). Effect size in the human literature is modest and variable. Standard tier — honest dose disclosure but the mechanism and efficacy for CNS calming from oral GABA is not fully established.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cholesterol-regulation-capsules",
      "title": "Cholesterol Regulation Capsules",
      "vendor": "ABĒCA Naturals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/FullSizeRender_7eaa1e0c-c644-44ae-bb61-b2c22493b890.jpg?v=1788064380",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cholesterol",
        "regulation",
        "capsules",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 50,
        "manufacturing": 48,
        "safety": 45,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 33.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831143747781",
      "vsf_explanation": "The product name and description make explicit claims to \"reduce cholesterol build up\" and 'regulate lipid levels' — this is a disease-treatment framing (elevated cholesterol/hyperlipidemia is a diagnosable medical condition managed by physicians, typically with statins or PCSK9 inhibitors). No herbal blend has cleared the FDA evidentiary bar for cholesterol-lowering as a claim. The ingredient class (plantain leaf, fenugreek, black cohosh, cayenne, hawthorn, orange peel) contains some botanicals with modest lipid-adjacent evidence (fenugreek Neelakantan 2014, hawthorn Pittler 2003) but no established cholesterol-reduction protocol. The 'eat away cholesterol deposits' framing is scientifically inaccurate (atherosclerotic plaques don't dissolve on herbal intake). Autofailed under unverified_disease_claim.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "respiratory-support",
      "title": "Respiratory Support",
      "vendor": "ABĒCA Naturals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/FullSizeRender_cb3056f1-f961-4527-baaf-419942444c83.jpg?v=1788064380",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "respiratory",
        "support",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 22,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831143813317",
      "vsf_explanation": "Product claims include \"alleviate breathing difficulties, strengthens lungs, and provides overall wellness for your respiratory system\" and \"cough support blend.\" Framing crosses from generic wellness into implied treatment of respiratory dysfunction — 'alleviate breathing difficulties' particularly borders on disease-treatment claim, and 'strengthens lungs' implies a therapeutic effect not supported by RCT evidence for herbal blends. Mullein leaf has traditional-use pedigree for respiratory support but very limited controlled clinical data. The disclaimer about slowing drug absorption is honest but doesn't undo the disease-adjacent framing. Rejected under unverified_disease_claim (borderline).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "alfalfa-capsules",
      "title": "Alfalfa Capsules",
      "vendor": "ABĒCA Naturals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/unnamed.jpg?v=1788064380",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alfalfa",
        "capsules",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 62,
        "sustainability": 60
      },
      "price": 21,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831143780549",
      "vsf_explanation": "Alfalfa (Medicago sativa) leaf capsules. Alfalfa contains real vitamin/mineral content and phytoestrogenic compounds. The 'may relieve arthritis discomfort' claim uses appropriately hedged language and carries the FDA disclaimer. Product is honest about the autoimmune contraindication (alfalfa is known to trigger lupus flares — Hargraves 1968, Malinow 1981). Standard tier for a legitimately-labeled traditional herbal supplement with real safety awareness.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "womens-delight-capsules",
      "title": "Women's Delight Capsules",
      "vendor": "ABĒCA Naturals",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/womendelightcaps.png?v=1788064380",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "women",
        "delight",
        "capsules",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 60,
        "sustainability": 60
      },
      "price": 29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831143911621",
      "vsf_explanation": "Herbal capsule blend with ashwagandha and saw palmetto, positioned for stress management and libido. Ashwagandha has strong stress/cortisol evidence at 300-600 mg standardized extract. Saw palmetto is more established for male benign prostatic hyperplasia (BPH) than for female applications — its use in this women's blend rests on testosterone-balance theory rather than female-specific RCT support. Per-capsule dosing not disclosed. Standard tier at the middle.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "portions-master-omega-3-fish-oil-epa-dha-60-count",
      "title": "Portions Master Omega 3 Fish Oil EPA DHA (60 Count)",
      "vendor": "Portions Master",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Omega_3_60s_shadow__41556.1712945145.1280.1280_858d8b36-f507-4cd4-924c-fbf16876ef49.png?v=1788064441",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "portions",
        "master",
        "omega",
        "fish",
        "oil",
        "epa",
        "dha",
        "count",
        "portions",
        "master"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 60,
        "sustainability": 58
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831144534213",
      "vsf_explanation": "Portions Master Omega 3 Fish Oil is a straightforward EPA + DHA fish oil for cardiovascular, brain, and eye health. Omega-3 evidence base is strong: decades of trials support a role in cardiovascular health, with variable outcome signals depending on dose, form, and population (ASCEND, VITAL, REDUCE-IT with pure prescription EPA at 4 g/day, STRENGTH). Consumer-grade fish oil at maintenance doses (500-1,000 mg EPA+DHA/day) is a legitimate general cardiovascular-and-brain support supplement. Portions Master's bariatric-focused positioning is appropriate here too — post-bariatric fat malabsorption affects omega-3 absorption, and omega-3 supplementation is a reasonable adjunct given the increased cardiovascular risk profile that can persist post-op. Standard tier on strong evidence + reasonable formulation; transparency and manufacturing subscores reflect need to verify EPA+DHA milligrams per serving, TOTOX (oxidation) value, and third-party heavy-metals COA — all standard fish-oil quality markers that separate mainstream brands from top-tier (Nordic Naturals, Carlson, Bare Biology). Would move higher with those verification items published on the current product page.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "portions-master-biotin-hair-skin-nails-support-90-count",
      "title": "Portions Master Biotin Hair, Skin & Nails Support (90 Count)",
      "vendor": "Portions Master",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Biotin_90s_shadow__43382.1712941440.1280.1280_563c126f-c483-4aea-95f8-6b56e6ac5e4b.png?v=1788064475",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "portions",
        "master",
        "biotin",
        "hair",
        "skin",
        "nails",
        "support",
        "count",
        "portions",
        "master"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 60,
        "sustainability": 58
      },
      "price": 22.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831144992965",
      "vsf_explanation": "Portions Master Biotin is a straightforward biotin (Vitamin B7) hair-skin-nails supplement. Portions Master is a bariatric-focused DTC brand serving post-gastric-bypass and post-sleeve patients, so the product is positioned in a specific clinical-adjacent niche (bariatric patients frequently develop micronutrient deficiencies including biotin and need supplementation). Evidence caveats on biotin for hair-skin-nails outcomes in the general adult population: the strong evidence base is only for biotin-deficient individuals (rare in general population, more common in bariatric, alcoholic, pregnant, and long-term antibiotic populations) — biotin supplementation in already-sufficient adults does not clearly improve hair, skin, or nail growth per systematic reviews (Patel 2017, Lipner 2018 — literature review noted only case reports, not RCTs, supporting supplementation for hair/nail outcomes in non-deficient adults). Post-bariatric context is where biotin supplementation is more legitimately supported. Safety-side concern: high-dose biotin (>5 mg) interferes with many clinical lab immunoassays including troponin, TSH, and hormonal panels, potentially producing false results — this is a real and clinically documented issue. Standard tier on legitimate use case in bariatric context, mediocre evidence for general-population hair-skin-nails claim, and real lab-interference safety flag. Would move higher with prominent lab-interference disclaimer and lower default dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "portions-master-vitamin-d-3-90-count",
      "title": "Portions Master Vitamin D-3 (90 Count)",
      "vendor": "Portions Master",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Vitamin_D3_90s_shadow__80350.1712945411.1280.1280_be1fe3f3-b385-458e-8c7f-28e20b2a3825.png?v=1788064475",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "portions",
        "master",
        "vitamin",
        "count",
        "portions",
        "master"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 65,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 60,
        "sustainability": 58
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831145058501",
      "vsf_explanation": "Portions Master Vitamin D-3 is a plain cholecalciferol (Vitamin D3) supplement. D3 is one of the most-supplemented and best-evidenced nutrients in the OTC catalog: adequate D status matters for bone health, immune function, and possibly cardiovascular and mood outcomes; widespread deficiency (25-OH-D <30 ng/mL) affects a substantial portion of the US adult population and is nearly universal in some populations (dark-skinned, high-latitude, indoor-work, obese, and post-bariatric individuals). D3 (cholecalciferol) is more effective at raising 25-OH-D than D2 (ergocalciferol) at equivalent doses. For post-bariatric patients (Portions Master's core market), Vitamin D deficiency is the most common post-surgical micronutrient issue, and supplementation is routine standard of care. Portions Master brand context is legitimate for the bariatric use case. Standard tier on strong evidence baseline; dose per capsule and specific IU strength should be verified on the panel — bariatric dosing typically ranges from 2,000-5,000 IU daily maintenance to 50,000 IU weekly for repletion. Would move higher with clear IU disclosure and third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "portions-master-30-billion-probiotic-plus-gastrointestinal-support-60-count",
      "title": "Portions Master 30 Billion Probiotic Plus Gastrointestinal Support (60 Count)",
      "vendor": "Portions Master",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/30_Billion_Plus_Probiotic_60s_shadow__88432.1712938523.1280.1280_faaebe7b-cd10-4162-bf9e-58bfa3ef862f.png?v=1788064475",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "portions",
        "master",
        "billion",
        "probiotic",
        "plus",
        "gastrointestinal",
        "support",
        "count",
        "portions",
        "master"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 65,
        "safety": 68,
        "transparency": 62,
        "sustainability": 60
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831145025733",
      "vsf_explanation": "Portions Master 30 Billion Probiotic Plus features DE111 (Bacillus subtilis DE111), a spore-based probiotic with reasonable clinical documentation for shelf stability, gastric survival, and gut-transit resilience. DE111 has small-RCT evidence for digestive comfort, immune markers, and post-antibiotic recovery (Colom 2021, Cuentas 2017). Spore-based probiotics generally have better shelf and gastric survival than fragile Lactobacillus/Bifidobacterium strains — a real category advantage. 30 billion CFU is on the higher end of consumer probiotic dosing (10-50 billion is the typical range), though CFU count is a heterogeneous quality metric — strain identity and viability at end-of-shelf-life matter more than the peak number at manufacture. For bariatric patients, probiotic use is generally supportive (gut motility, dysbiosis, and diarrhea are common post-op) with routine safety. Standard tier on evidence-supported strain + reasonable dose + bariatric-appropriate context. Would move higher with confirmed strain-level identity (DE111 specifically), end-of-shelf-life CFU guarantee, and third-party per-lot verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "portions-master-womens-multi-vitamin-90-count",
      "title": "Portions Master Women's Multi-Vitamin (90 Count)",
      "vendor": "Portions Master",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Womens_Multi-Vitamin_90s_shadow__28723.1691413614.1280.1280_f32cafde-2f5c-48f6-ac40-3ed381bf03dd.png?v=1788064475",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "portions",
        "master",
        "women",
        "multi",
        "vitamin",
        "count",
        "portions",
        "master"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 58,
        "sustainability": 58
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831145091269",
      "vsf_explanation": "Portions Master Women's Multi-Vitamin is a general women's daily multivitamin. The women's-multi category is heterogeneous — most products deliver standard fat- and water-soluble vitamins plus women-relevant minerals (iron for pre-menopausal, calcium/D3/K2 for bone health, iodine, folate). Evidence for daily multivitamins in women is modest: the PHS-II and COSMOS-Mind trials showed small cognitive-decline slowing signals in older adults on daily multivitamins, and prenatal multivitamins have strong evidence for neural-tube-defect prevention when they contain folic acid. General women's-multi products in non-pregnant, adequately-nourished adults have less consistent outcome data — supplementing when dietary intake is adequate provides insurance rather than measurable benefit. For post-bariatric context (Portions Master's core market), a women's multi with higher B-complex, iron, and D3 is genuinely appropriate — bariatric micronutrient deficiencies are documented and clinical guidelines recommend targeted supplementation. Standard tier on legitimate use case + reasonable formulation. Would move higher with confirmed bariatric-appropriate dosing (methylated folate, methylcobalamin B12, chelated iron), full quantitative facts panel, and per-lot COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "portions-master-dha-prenatal-pregnancy-breastfeeding-30-count",
      "title": "Portions Master DHA Prenatal Pregnancy & Breastfeeding (30 Count)",
      "vendor": "Portions Master",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/DHA_Prenatal_30s_shadow__99394.1691413917.1280.1280_2bc29db3-ea41-499e-b502-cf3d2197777a.png?v=1788064475",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "female",
      "life_stage": "prenatal",
      "tokens": [
        "portions",
        "master",
        "dha",
        "prenatal",
        "pregnancy",
        "breastfeeding",
        "count",
        "portions",
        "master"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 68,
        "manufacturing": 65,
        "safety": 70,
        "transparency": 62,
        "sustainability": 60
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831145124037",
      "vsf_explanation": "Portions Master DHA Prenatal is a docosahexaenoic acid (DHA) supplement specifically for pregnancy and breastfeeding. This is one of the better-evidenced niches in the supplement world: DHA transfer from mother to fetus is substantial during the third trimester (when fetal brain fatty acid accretion is highest), and DHA in breastmilk depends on maternal intake. WHO and multiple national obstetric societies recommend 200-300 mg DHA/day during pregnancy and lactation for fetal/infant neurodevelopment. Meta-analyses (Gould 2013, Middleton 2018) show modest reductions in preterm birth risk with prenatal DHA supplementation, particularly in low-baseline-intake populations. Portions Master's positioning in the bariatric market translates well here — post-bariatric pregnancy is a documented high-risk scenario where micronutrient adequacy including DHA matters more, not less. Standard tier at higher end on strong evidence baseline + legitimate maternal-health positioning. Would move higher with confirmed DHA milligrams per serving (200-300 mg is the guideline target), fish-source and purity/heavy-metal COA, and clear pregnancy-safety documentation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "portions-master-vegan-protein-blend-chocolate",
      "title": "Portions Master Vegan Protein Blend Chocolate",
      "vendor": "Portions Master",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/VeganProteinBlend750gChocshadow_1.png?v=1788064476",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "portions",
        "master",
        "vegan",
        "protein",
        "blend",
        "chocolate",
        "portions",
        "master"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 58,
        "sustainability": 65
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831145287877",
      "vsf_explanation": "Portions Master Vegan Protein Blend Chocolate is a plant-based protein powder targeting bariatric patients and non-dairy-consuming adults. Plant-protein blends (typically pea + brown rice + hemp + sometimes pumpkin seed or fava) can achieve a complete amino acid profile when combined appropriately — pea protein is lysine-rich but low in methionine, rice protein is methionine-rich but low in lysine, so the combination hits both essential aminos. Leucine content per serving matters most for muscle protein synthesis (MPS): leucine ~2.5-3.0 g per serving is the threshold for maximally stimulating MPS in adults. Plant-protein blends often need higher total protein per serving (30-40 g) to hit that leucine target vs whey (which hits it at 20-25 g). For bariatric patients, protein intake targets are 60-80+ g/day, which is often difficult to meet from food alone due to reduced meal capacity — protein supplementation is standard bariatric practice. Vegan plant protein is appropriate for lactose-intolerant, dairy-avoidant, or ethically-vegan bariatric patients. Standard tier on legitimate use case + reasonable plant-protein formulation. Would move higher with confirmed complete amino acid profile disclosure (with leucine, EAA breakdown), third-party PDCAAS score, and pesticide/heavy-metal COA (plant proteins can carry higher heavy-metal loads than whey).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "portions-master-advanced-probiotic-5-75-billion-gastrointestinal-support-60-count",
      "title": "Portions Master Advanced Probiotic 5.75 Billion Gastrointestinal Support (60 Count)",
      "vendor": "Portions Master",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Advanced_Probiotic_60s_shadow__08864.1712938960.1280.1280_7d87700e-fee3-47ba-ae7f-23cf4352af8b.png?v=1788064475",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "portions",
        "master",
        "advanced",
        "probiotic",
        "billion",
        "gastrointestinal",
        "support",
        "count",
        "portions",
        "master"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 58,
        "sustainability": 58
      },
      "price": 28.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831145189573",
      "vsf_explanation": "Portions Master Advanced Probiotic at 5.75 Billion CFU is a lower-CFU probiotic sibling to the brand's 30 Billion product. The 5.75 billion figure is unusually specific for a probiotic label, suggesting a defined multi-strain blend where individual strain CFUs sum to that number. Lower CFU count is not inherently a negative — strain-level identity and viable-at-end-of-shelf-life count matter more than peak CFU at manufacture. That said, most consumer probiotics in the digestive-comfort category are formulated at 10-50 billion CFU based on the assumption that gastric transit reduces viable count by 1-2 log units, so 5.75 billion at intake likely translates to relatively low colonic delivery unless strains are gastric-resistant (spore-based) or the product is enteric-coated. For general digestive maintenance and post-bariatric context, either the 5.75B or the 30B product is reasonable — the higher CFU is more likely to hit therapeutic thresholds for GI symptom reduction. Standard tier at moderate score on lower relative dose for the category. Would move higher with strain identity disclosure, viability guarantee at end of shelf life, and enteric-coating or gastric-resistant strain confirmation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "portions-master-keto-body-protein-peptides-vanilla-cream",
      "title": "Portions Master Keto Body Protein Peptides Vanilla Cream",
      "vendor": "Portions Master",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Keto_Body_750g_Van_Front_shadow__90880.1689711435.1280.1280_23405c13-e895-4eb7-a220-481ce7cf8686.png?v=1788064475",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "portions",
        "master",
        "keto",
        "body",
        "protein",
        "peptides",
        "vanilla",
        "cream",
        "portions",
        "master"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831145255109",
      "vsf_explanation": "Portions Master Keto Body Protein Peptides is a peptide-based protein powder positioned for ketogenic-diet-compatible protein intake. 'Peptides' in this context typically refers to hydrolyzed proteins pre-digested into shorter chains, which are marketed for faster absorption — the actual bioavailability advantage over intact whey isolate is smaller than marketing suggests (whey absorbs rapidly on its own; hydrolysis matters more for infant formula and clinical enteral nutrition than for typical adult supplementation). Ketogenic-diet framing implies low-carb formulation (typically <5 g carbs, low or zero sugar). For bariatric patients who benefit from higher-protein-lower-carb intake and ketosis-adjacent metabolic goals, this positioning is appropriate. Standard tier on legitimate use case + reasonable peptide-hydrolysate formulation; evidence and transparency subscores reflect thin real-world advantage of peptides over intact isolate and typical marketing overreach on the peptide-bioavailability claim. Would move higher with confirmed leucine content per serving, EAA breakdown, third-party ketosis-compatible carb count, and full ingredient panel.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "portions-master-lutein-eye-health-support-60-count",
      "title": "Portions Master Lutein Eye Health Support (60 Count)",
      "vendor": "Portions Master",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Lutein_60s_shadow__93338.1691414032.1280.1280_324c98ac-07dd-4c65-a762-2c97a339071c.png?v=1788064475",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "portions",
        "master",
        "lutein",
        "eye",
        "health",
        "support",
        "count",
        "portions",
        "master"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 55,
        "sustainability": 58
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831145156805",
      "vsf_explanation": "Portions Master Lutein Eye Health Support is a straightforward lutein supplement for macular health. Lutein has strong evidence in the eye-supplement space: the AREDS2 trial (Age-Related Eye Disease Study 2, N=4,203) established that 10 mg lutein + 2 mg zeaxanthin per day slowed progression of intermediate-to-advanced age-related macular degeneration. Beyond AMD progression, lutein supports macular pigment optical density and modestly benefits contrast sensitivity and glare recovery. Whether Portions Master Lutein is a pure lutein product or a lutein+zeaxanthin combination affects the AREDS2 evidence alignment — pure lutein alone has less direct trial support than the paired combination. Standard tier on evidence-supported ingredient class; transparency subscore reflects need to confirm lutein and zeaxanthin milligrams on the panel. For bariatric patients (Portions Master's core market), lutein is not a bariatric-specific replacement need — it's a general eye-health supplement. Would move higher with AREDS2-dose match confirmation (10 mg lutein + 2 mg zeaxanthin), source disclosure (marigold flower is standard), and per-lot COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "portions-master-collagen-3000-hair-skin-nails-bones-support-120-count",
      "title": "Portions Master Collagen 3000 Hair, Skin, Nails, & Bones Support (120 Count)",
      "vendor": "Portions Master",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Collagen_3000_120s_shadow__55485.1712943424.1280.1280_4ceb7b28-7b0e-4b27-bbad-e7bacd6b7825.png?v=1788064475",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "portions",
        "master",
        "collagen",
        "3000",
        "hair",
        "skin",
        "nails",
        "bones",
        "support",
        "120",
        "count",
        "portions",
        "master"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831145222341",
      "vsf_explanation": "Portions Master Collagen 3000 is a collagen supplement targeting hair, skin, nails, and bone health. The '3000' typically refers to milligrams per serving. Collagen peptides (hydrolyzed collagen) have real evidence in specific outcomes: RCTs at 2.5-10 g/day of hydrolyzed collagen show modest improvements in skin hydration and elasticity (Kim 2018, Choi 2019), joint pain (Clark 2008, Zdzieblik 2017), and, less consistently, hair and nail parameters. Bone-density effects have limited human trial support at typical supplement doses. 3 g/day is at the lower end of trial-studied doses (skin trials typically use 2.5-10 g/day; joint trials 5-10 g/day) — the felt effect will be modest at this dose. Source (bovine, marine, chicken, or eggshell membrane) and peptide molecular weight distribution matter for both absorption and target-tissue affinity, and neither is clear at the title level. For bariatric patients (Portions Master's core market), collagen supplementation is not a specific bariatric replacement need, but adequate total protein intake — which collagen contributes to — is central to bariatric outcomes. Standard tier on evidence-supported ingredient at modest dose. Would move higher with source and peptide-weight disclosure, third-party heavy-metals COA, and evidence-anchored dose match (5-10 g/day rather than 3 g/day).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "portions-master-caffeine-plus-60-count",
      "title": "Portions Master Caffeine Plus (60 Count)",
      "vendor": "Portions Master",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Caffeine_Plus_60s_shadow__05386.1712942918.1280.1280_b138388e-4724-4bdd-8e4f-1b7b02c73be3.png?v=1788064475",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "portions",
        "master",
        "caffeine",
        "plus",
        "count",
        "portions",
        "master"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831145320645",
      "vsf_explanation": "Portions Master Caffeine Plus delivers 200 mg of caffeine per serving. Caffeine is one of the best-studied performance and cognitive interventions in the supplement world: meta-analyses consistently show modest improvements in endurance performance, high-intensity effort, reaction time, and vigilance at 3-6 mg/kg body weight (roughly 200-400 mg for a 70 kg adult). 200 mg is a moderate acute dose — comparable to a large coffee. Standard caffeine safety considerations apply: sleep disruption if taken within 6-8 hours of bed (caffeine half-life ~5 hours in most adults, longer in slow metabolizers), blood pressure and heart rate acute effects, dependence and withdrawal with regular use, and interactions with anxiety, arrhythmia, and pregnancy. For bariatric patients (Portions Master's core market), caffeine is not contraindicated but should be used mindfully — some post-op protocols recommend limiting caffeine during the immediate recovery period to avoid mucosal irritation and GERD-adjacent symptoms. Standard tier on strong ingredient evidence + reasonable dose + real safety-context flag. Would move higher with clear dosing guidance for the bariatric population, warnings about sleep timing, and disclosure of any additional ingredients ('Plus' suggests co-ingredients that are not detailed at the title level).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "portions-master-calcium-mineral-bone-support-120-count",
      "title": "Portions Master Calcium Mineral Bone Support (120 Count)",
      "vendor": "Portions Master",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Calcium_120s_shadow__33768.1691413710.1280.1280_85ac7d70-8a38-4140-8b75-d9459d035bb3.png?v=1788064475",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "portions",
        "master",
        "calcium",
        "mineral",
        "bone",
        "support",
        "120",
        "count",
        "portions",
        "master"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831145353413",
      "vsf_explanation": "Portions Master Calcium Mineral Bone Support is a calcium-plus-cofactors bone-health supplement. The bariatric focus of the brand is directly relevant here: post-bariatric surgery calcium malabsorption is well-documented, and calcium citrate specifically (not calcium carbonate) is the recommended form because it does not require stomach acid for absorption and works around the achlorhydria common after Roux-en-Y gastric bypass and sleeve gastrectomy. Bariatric society guidelines (ASMBS) recommend 1,200-2,400 mg elemental calcium citrate per day post-op in divided doses, along with 3,000+ IU Vitamin D3 and magnesium. Whether the Portions Master formulation matches this bariatric-adjusted target needs verification on the panel. For non-bariatric adults, general calcium supplementation should target closing dietary gaps rather than adding on top of adequate intake — the calcium-plus-cardiovascular-event debate makes over-supplementation ill-advised. Standard tier on legitimate bariatric-focused positioning + reasonable formulation. Would move higher with confirmed calcium citrate form, elemental calcium disclosure, split-dose guidance for post-bariatric patients, and per-lot COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "portions-master-apple-cider-vinegar-90-count",
      "title": "Portions Master Apple Cider Vinegar (90 Count)",
      "vendor": "Portions Master",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Apple_Cider_Vinegar_90s_shadow__95946.1712940711.1280.1280_319c927a-640d-492a-bd54-e5c3a9c8b16b.png?v=1788064475",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "portions",
        "master",
        "apple",
        "cider",
        "vinegar",
        "count",
        "portions",
        "master"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 58,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831145418949",
      "vsf_explanation": "Portions Master Apple Cider Vinegar is a capsule ACV product. The ACV weight-loss and metabolic-health category is heavy on marketing and light on rigorous evidence. Small trials (Johnston 2004, N=11, showing modest postprandial glucose reduction; Kondo 2009, N=155 over 12 weeks showing 1-2 kg weight difference on 15-30 mL vinegar/day) exist but are limited by small sample sizes, short duration, and lack of validation in larger populations. A 2024 BMJ Nutrition Prevention & Health study on ACV weight loss received substantial critical peer response about methodology and effect-size magnitude. Capsule ACV also does not provide the postprandial-satiety effect of liquid vinegar (via delayed gastric emptying), which is the more mechanistically-supported ACV benefit. For bariatric patients specifically, adding ACV capsules is not part of bariatric standard of care and offers little advantage over general dietary and behavioral interventions. Safety: capsule ACV avoids the enamel erosion and esophageal-irritation issues of liquid ACV, which is a genuine practical advantage. Rejected tier reflects thin evidence for the marketed weight-loss/metabolic claims not the ingredient's safety. Not autofailed because the marketing language reviewed is relatively restrained ('support your health') rather than explicit disease-treatment claims.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "portions-master-black-cumin-seed-oil-90-count",
      "title": "Portions Master Black Cumin Seed Oil  (90 Count)",
      "vendor": "Portions Master",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Black_Cumin_Seed_Oil_90s_shadow__13979.1712941855.1280.1280_71d91f4e-dabd-4af9-af7e-fd951be696cd.png?v=1788064475",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "portions",
        "master",
        "black",
        "cumin",
        "seed",
        "oil",
        "count",
        "portions",
        "master"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 60,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831145451717",
      "vsf_explanation": "Portions Master Black Cumin Seed Oil is a Nigella sativa (black seed) oil supplement. Nigella sativa has a substantial traditional-medicine history across Middle Eastern, South Asian, and North African medical systems, and a growing preliminary trial literature: small RCTs and meta-analyses suggest modest effects on blood pressure (Sahebkar 2016 meta-analysis showed ~3-5 mmHg systolic reductions), fasting glucose and HbA1c (Daryabeygi-Khotbehsara 2017), and lipid parameters. The active constituent thymoquinone has in vitro antioxidant and anti-inflammatory activity. Effect sizes across trials are typically small-to-moderate, sample sizes are limited, and most trials are single-center. Marketing language ('The Power of Nature') is DSHEA-permissible structure-function. Category placement in immune_antioxidants is reasonable given the antioxidant thymoquinone framing; some would also place it under cardiovascular_heart. Standard tier on emerging evidence base + reasonable traditional-use history. Would move higher with confirmed thymoquinone standardization percentage, cold-press extraction disclosure, and third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "portions-master-electrolyte-plus-100-count",
      "title": "Portions Master Electrolyte Plus (100 Count)",
      "vendor": "Portions Master",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Electrolyte_Plus_100s_shadow__49212.1691414158.1280.1280_b28f2a32-8ae0-482e-b7a0-12477eab4392.png?v=1788064475",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "portions",
        "master",
        "electrolyte",
        "plus",
        "100",
        "count",
        "portions",
        "master"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 62,
        "manufacturing": 60,
        "safety": 68,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831145386181",
      "vsf_explanation": "Portions Master Electrolyte Plus is an electrolyte supplement, capsule format. Electrolyte balance (sodium, potassium, magnesium, chloride) is directly evidence-based for hydration, exercise performance in heat and duration >60 minutes, and specific medical contexts (post-bariatric surgery, ketogenic diets, GI illness with vomiting/diarrhea). Capsule electrolyte products can deliver targeted milligrams of each cation without added sugar, artificial dye, or the acidic drink matrix of ready-to-drink electrolyte formulas — advantage for people avoiding calories or minimizing added ingredients. Sodium content per capsule is the key variable — typical exercise electrolyte targets are 200-500 mg sodium per liter of fluid, so a serving-relevant sodium dose matters. Potassium and magnesium co-supplementation is standard. For bariatric patients (Portions Master's core market), electrolyte adequacy is a documented clinical need — post-op dehydration is common, and standard bariatric care includes electrolyte supplementation particularly in the immediate post-op period and during illness. Standard tier on legitimate use case + reasonable formulation; transparency subscore reflects need to verify per-capsule sodium/potassium/magnesium milligrams. Would move higher with confirmed cation dosing that matches exercise or bariatric targets.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "portions-master-vitamin-d-3-k-2-heart-bones-support-90-count",
      "title": "Portions Master Vitamin D-3 + K-2 Heart & Bones Support (90 Count)",
      "vendor": "Portions Master",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Vitamin_D3_K2_90s_shadow__58077.1712946478.1280.1280_b1fb908d-d025-4594-bbda-baf2d1cceeb0.png?v=1788064475",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "portions",
        "master",
        "vitamin",
        "heart",
        "bones",
        "support",
        "count",
        "portions",
        "master"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 72,
        "manufacturing": 65,
        "safety": 68,
        "transparency": 62,
        "sustainability": 60
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46831145517253",
      "vsf_explanation": "Portions Master Vitamin D-3 + K-2 combines cholecalciferol (D3) with menaquinone (K2, ideally MK-7 form). This is one of the more evidence-supported micronutrient combinations for cardiovascular-plus-bone health in the current supplement space. D3 evidence is strong (bone health, immune function, likely cardiovascular and mood signals). K2 MK-7 has RCT evidence for slowing arterial calcification and improving bone density: Knapen 2013 RCT (N=244 postmenopausal women, 180 mcg MK-7/day for 3 years) showed statistically significant improvements in bone mineral density and slowed carotid arterial stiffness; multiple other trials support the K2 arterial-calcification-and-bone-density mechanism. The pairing addresses the calcium paradox — dietary/supplemental calcium alone can be deposited in arterial walls; K2 activates matrix Gla protein to redirect calcium into bones instead. For bariatric patients (Portions Master's core market), both D3 and K2 supplementation are appropriate — post-bariatric fat malabsorption affects both fat-soluble vitamins. Higher-end Standard tier on strong evidence + solid formulation. Would move to Verified with confirmed MK-7 (not MK-4) K2 form, ≥90 mcg K2 dose, ≥2,000 IU D3 dose, and third-party COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrabio-100-whey-protein-isolate-2-lb",
      "title": "NutraBio 100% Whey Protein Isolate - 2 lb",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NutraBio-100-Whey-Protein-Isolate-2-lb_319f3d37.jpg?v=1788101547",
      "score": 78,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrabio",
        "100",
        "whey",
        "protein",
        "isolate",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 82,
        "formulation": 82,
        "manufacturing": 78,
        "safety": 88,
        "transparency": 85,
        "sustainability": 55
      },
      "price": 59.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46833399595205",
      "vsf_explanation": "NutraBio is one of the small handful of US sports-nutrition brands that has built its reputation on full label transparency — no proprietary blends, every gram of every active on the panel. This SKU delivers 25 g of whey protein isolate per serving with no added whey concentrate, no amino-spiking fillers, and no undisclosed 'protein matrix.' The evidence base for whey isolate at 20–30 g/dose for post-exercise muscle protein synthesis is among the strongest in sports supplementation (Morton et al. 2018 meta-analysis in Br J Sports Med; Schoenfeld & Aragon 2018 protein-distribution review). NutraBio publishes third-party lab tests including heavy-metal, amino-acid-spike, and identity assays on its site, and manufactures in an FDA-registered, NSF-GMP facility. The primary reason this sits at the top of the Verified band rather than Elite is (1) no NSF Certified for Sport or Informed Sport banned-substance certification on this specific SKU (relevant for tested athletes), and (2) whey isolate is a mature, commodified category — the ingredient itself is unambiguously effective but there is no product-specific RCT that would justify Elite. For general muscle-recovery, lean-mass maintenance, and hitting daily protein targets, this is a clean, honestly-labeled choice.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natrol®-melatonin-3-mg-tablets",
      "title": "Natrol® Melatonin – 3 mg – Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/196648856.jpg?v=1788101569",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "natrol",
        "melatonin",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_supplements_nutraceuticals"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 62,
        "manufacturing": 74,
        "safety": 65,
        "transparency": 72,
        "sustainability": 62
      },
      "price": 20.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46833400086725",
      "vsf_explanation": "Natrol (Aurobindo Pharma-owned) is the largest melatonin brand in the US retail channel and one of the more institutionally credible mass-market sleep-supplement labels. Melatonin itself has real evidence for sleep-onset latency reduction, jet lag, and shift-work disorder — the meta-analytic evidence base is one of the more mature in the supplement space (Ferracioli-Oda 2013, and shift-work-specific reviews). What holds this at Standard rather than Verified is the specific 3 mg dose. Contemporary sleep-medicine evidence (particularly Zhdanova 2001 and subsequent dose-response work) indicates that physiological melatonin doses of 0.3-0.5 mg produce sleep effects equivalent to or better than the standard retail 3-10 mg doses, with better next-day cognitive tolerance and better preservation of endogenous melatonin rhythm. The 3 mg tablet is the entrenched retail dose but is roughly ten times physiological — for most shoppers it is more than needed. There is also the 2023 JAMA Consumer Reports-style testing that found significant labeled-dose variance in over-the-counter melatonin products; Natrol's USP-verified line is more reliable than the average, but the specific SKU shopper should check for the USP mark. Not an auto-fail; a legitimate mainstream sleep product where the labeled dose is defensible but not optimal by contemporary evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gnc-amp-complete-omega-60-softgels-sealed-discontinued-exp-11-2026-rare",
      "title": "GNC AMP Complete Omega 60 Softgels Sealed Discontinued Exp 11/2026 Rare",
      "vendor": "Price Is Right Miami",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8936da99-8ba3-42d1-8cae-2fc87a2c7827.jpg?v=1788111668",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gnc",
        "amp",
        "complete",
        "omega",
        "softgels",
        "sealed",
        "discontinued",
        "exp",
        "2026",
        "rare",
        "price",
        "right",
        "miami"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 52,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 40,
        "sustainability": 42
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46833581162693",
      "vsf_explanation": "This is a resale listing of a discontinued GNC AMP Complete Omega SKU, expiration November 2026. Today is September 2026 — so the softgels have roughly two months before best-by. GNC AMP is a real GNC in-house line that carried marker-brand credibility when it was in-market, and omega-3 fatty acids have among the strongest evidence bases in the supplement category (particularly EPA + DHA for triglyceride reduction, mood support at 1-2 g EPA-dominant, and general cardiovascular endpoints per the REDUCE-IT and STRENGTH trials with prescription-grade EPA). What disqualifies this listing is the combination of \"discontinued formula\" plus \"sold as rare inventory\" plus two-month remaining shelf life on a lipid-based softgel. Fish-oil softgels are especially vulnerable to lipid oxidation — the polyunsaturated fats oxidize on a predictable timeline once encapsulated, and rancidity is a real and measurable phenomenon that is worse in a manufacturer-abandoned SKU without ongoing cold-chain and inventory-turnover discipline. The \"rare\" collectible framing (\"Sealed Discontinued Rare\") is a red flag for supplement sale: nutraceuticals are not collectibles, and the seller's own copy suggests the value proposition is scarcity rather than freshness. A listing where the seller cannot vouch for cold-chain integrity of the manufactured lot, on a lipid-oxidation-sensitive category, at two months before expiration, is not listable as a wellness product.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zahler-teenfocus™-for-the-healthy-active-brain-concentration-calmness-support-90-capsules",
      "title": "Zahler TeenFocus™ For the Healthy Active Brain  Concentration & Calmness Support 90 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/image_99e02033-afb3-42c9-9ced-74bae4eeadf0.png?v=1788111681",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zahler",
        "teenfocus",
        "for",
        "the",
        "healthy",
        "active",
        "brain",
        "concentration",
        "calmness",
        "support",
        "capsules",
        "singers",
        "health",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 65,
        "safety": 58,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 42.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46833581359301",
      "vsf_explanation": "Zahler TeenFocus is a cognitive-and-calm support formula specifically marketed for adolescents. The teen framing is a marketing choice; the actual formulation typically uses adult-nootropic ingredients (phosphatidylserine, bacopa, L-theanine, B-complex, and often adaptogens) at teen-appropriate doses. Pediatric evidence for these ingredients specifically in adolescents is thinner than adult evidence — L-theanine has one small pediatric ADHD-adjacent trial (Lyon 2011), phosphatidylserine has a small pediatric ADHD trial (Hirayama 2014). Marketing framing ('healthy active brain,' 'concentration and calmness') is DSHEA-permissible and avoids the ADHD-treatment claim that would be an autofail. Two adolescent-specific concerns: (1) teens with actual attention or mood diagnoses need clinical evaluation, not supplementation as first-line; (2) supplement marketing to teens and parents in the ADHD-adjacent space is high-risk territory for over-selling. Zahler's brand quality supports Standard tier at moderate score. Would move higher with pediatric-specific per-ingredient dosing rationale and clear disclaimers directing parents to clinician evaluation for suspected ADHD or anxiety.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "young-living-hinoki-essential-oil-5ml-grounding-purifying-woodsy-aromatherapy",
      "title": "Young Living Hinoki Essential Oil 5ml Grounding Purifying & Woodsy Aromatherapy",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/image_d3e8cab6-99ca-41f4-ba37-c71536d01f38.png?v=1788111814",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "young",
        "living",
        "hinoki",
        "essential",
        "oil",
        "5ml",
        "grounding",
        "purifying",
        "woodsy",
        "aromatherapy",
        "singers",
        "health",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 52,
        "manufacturing": 55,
        "safety": 48,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46833583292613",
      "vsf_explanation": "Young Living Hinoki Essential Oil (5ml, Chamaecyparis obtusa Japanese cypress) is a specialty aromatherapy essential oil marketed for grounding, air purification, and forest-bathing (Shinrin-yoku) atmosphere. The oil itself is a legitimate steam-distilled hinoki oil, and hinoki cypress has cultural and traditional use in Japan going back centuries. Aromatherapy evidence for forest-bathing constituents is real but small: Li 2009, 2010 human studies on phytoncides from hinoki and other coniferous species show modest short-term effects on NK-cell activity and cortisol reduction after inhalation exposure. Same category-fit and brand-context concerns apply as with all Young Living essential oils: Vyvata's rubric does not have an aromatherapy category, and Young Living's MLM distributor sales history has drawn multiple FDA warning letters for unauthorized health claims (though the specific claims on this SKU description are DSHEA-permissible). The 'grounding, purifying, woodsy aromatherapy' framing on Hinoki specifically stays closer to legitimate aromatherapy positioning than the more aggressive cognitive/nervous-system claims on the Basil oil variant. Rejected tier reflects the composite of thin cognitive/wellness-outcome evidence, MLM brand context, and category-fit ambiguity — not the oil itself, which is a legitimate product.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "young-living-basil-premium-essential-oil-15ml-mental-clarity-focus-natural-stress-relief",
      "title": "Young Living Basil Premium Essential Oil 15ml Mental Clarity Focus & Natural Stress Relief",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/image_91bef513-653e-4aba-a1ce-92abec57700f.png?v=1788111814",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "young",
        "living",
        "basil",
        "premium",
        "essential",
        "oil",
        "15ml",
        "mental",
        "clarity",
        "focus",
        "natural",
        "stress",
        "relief",
        "singers",
        "health",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 52,
        "manufacturing": 55,
        "safety": 45,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46833583325381",
      "vsf_explanation": "Young Living Basil Premium Essential Oil 15ml is the larger-format sibling of the 5ml Basil oil SKU. Marketing and description language is identical: 'mental clarity, sharp focus, nervous system restoration, and natural stress relief.' All observations from the 5ml Basil write-up apply: essential oils don't map cleanly to Vyvata's five verticals, the aromatherapy evidence base for the specific 'mental clarity' and 'nervous system restoration' claims is thin and expectation-confounded, and Young Living's MLM brand context with FDA warning-letter history around distributor medical claims weighs the score down. Basil oil's methyl chavicol (estragole) content is a specific safety flag for internal use, which Young Living's Vitality-line marketing has historically encouraged despite FDA cautions. The 15ml format offers better value per ml for legitimate topical/diffuser aromatherapy use if you already use basil oil. Rejected tier consistent with the 5ml SKU.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zahler-accuvision™-advanced-eye-health-formula-30-capsules",
      "title": "Zahler AccuVision™ Advanced Eye Health Formula – 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/image_9d32b2bc-49cd-49a9-97ca-20fb822d8710.png?v=1788111820",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zahler",
        "accuvision",
        "advanced",
        "eye",
        "health",
        "formula",
        "capsules",
        "singers",
        "health",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 70,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 65,
        "sustainability": 62
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46833583653061",
      "vsf_explanation": "Zahler AccuVision is an eye-health formula featuring lutein and zeaxanthin from marigold flower plus supporting antioxidants, vitamins, and botanicals. Zahler is a real US kosher-certified supplement brand (Kof-K certified) with a long-standing catalog and reasonable third-party testing standards for the category. The evidence base for lutein and zeaxanthin in eye health is genuinely strong: the AREDS2 trial (Age-Related Eye Disease Study 2, NEI/NIH-funded, N=4,203) established that a lutein-plus-zeaxanthin formulation slowed progression of intermediate-to-advanced age-related macular degeneration and became the reference formulation for AMD supplementation. Depending on whether AccuVision hits the AREDS2 doses (10 mg lutein + 2 mg zeaxanthin) or goes lighter, the evidence weight varies. Transparency deduction: full Supplement Facts panel with per-ingredient milligrams needs verification on the current product page. Sits comfortably in Standard on ingredient-selection merit and Zahler's brand-quality baseline; would push toward Verified with confirmed AREDS2-matched dosing, published third-party COA, and clear disclosure of every co-ingredient dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "forever-living-calcium-supplement-bone-health-support",
      "title": "Forever Living Calcium Supplement - Bone Health Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/image_6e3b40ef-5768-42c7-bdef-0a0c1847cb20.png?v=1788111843",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "forever",
        "living",
        "calcium",
        "supplement",
        "bone",
        "health",
        "support",
        "singers",
        "health",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 25.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46833583620293",
      "vsf_explanation": "Forever Living Calcium combines calcium citrate with Vitamin D and magnesium in a straightforward bone-health stack. Calcium citrate is the more absorbable form (versus calcium carbonate) and does not require stomach acid for absorption — a genuine formulation advantage for older adults, people on PPIs, and post-bariatric contexts. Adding Vitamin D and magnesium is standard practice: Vitamin D drives intestinal calcium absorption, and magnesium is a co-factor in bone matrix formation. The formulation is unremarkable but sound for a general bone-health supplement. Where the product loses points: Forever Living is a multi-level marketing (MLM) brand founded 1978 (Rex Maughan), with an FTC-scrutiny history and income-claim regulatory attention that is orthogonal to formulation quality but affects trust — the brand distributes primarily through commission-based independent distributors rather than through retail or DTC channels, which historically correlates with lower per-lot testing transparency. Standard tier on real formulation merit; transparency and sustainability scores reflect thin per-lot COA disclosure and the MLM distribution model. Would move higher with published third-party per-lot COAs and specific ingredient milligrams (elemental calcium content, D3 IU, magnesium salt form) confirmed on the current panel.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zahler-candaid™-with-probiotics-intestinal-health-yeast-balance-60-capsules",
      "title": "Zahler CandAid™ With Probiotics – Intestinal Health & Yeast Balance | 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Z_CA_v2_2.webp?v=1788111820",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zahler",
        "candaid",
        "with",
        "probiotics",
        "intestinal",
        "health",
        "yeast",
        "balance",
        "capsules",
        "singers",
        "health",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 60,
        "sustainability": 60
      },
      "price": 40.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46833583587525",
      "vsf_explanation": "Zahler CandAid combines botanicals traditionally used for yeast/gut-flora balance with probiotics. 'Yeast balance' is DSHEA-permissible structure-function language and avoids the higher-risk 'treats candida' or 'cures systemic yeast overgrowth' framing that would trigger unverified-medical-claim. The formulation typically includes some subset of caprylic acid, oregano oil, berberine, garlic, and probiotic strains — each has some in vitro or small-trial evidence for antimicrobial or gut-flora-modulation activity. The systemic-candida-overgrowth concept as popularized in alternative-medicine circles is not a mainstream medical diagnosis (invasive candidiasis is a real ICU concern; the popular 'candida diet' framing is not evidence-based). Zahler's brand quality is a positive: real US kosher-certified supplement brand with reasonable third-party testing. Scores Standard on brand + reasonable formulation + acceptable claim discipline. Transparency subscore reflects need for per-ingredient dose disclosure to verify each botanical hits its studied dose. Would move higher with confirmed effective doses on the panel and published COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zahler-thyraid™-thyroid-support-formula-60-capsules",
      "title": "Zahler Thyraid™ Thyroid Support Formula – 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/image_0852045d-8afd-4e60-85bd-be9347e285ea.png?v=1788111821",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zahler",
        "thyraid",
        "thyroid",
        "support",
        "formula",
        "capsules",
        "singers",
        "health",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 65,
        "safety": 62,
        "transparency": 62,
        "sustainability": 60
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46833583685829",
      "vsf_explanation": "Zahler Thyraid is a thyroid-support formula built around vitamins, minerals, and botanical extracts (typically iodine, selenium, zinc, tyrosine, ashwagandha, guggul, and coleus in this class). Thyroid support is DSHEA-permissible structure-function; the product does not claim to treat hypothyroidism or Hashimoto's, which would be an unverified-medical-claim. Selenium (55-200 mcg/day) and iodine at appropriate doses have real evidence for thyroid function support — selenium is a co-factor in deiodinase enzymes that convert T4 to active T3, and iodine is the fundamental thyroid-hormone substrate (though excess iodine can trigger or worsen autoimmune thyroid disease, so dose matters). Ashwagandha has small-RCT evidence (Sharma 2018, Gannon 2014) for subclinical hypothyroidism marker improvement. Zahler is a real Kof-K kosher US brand with reasonable manufacturing standards. Scores Standard on evidence-supported ingredient selection + brand quality; transparency subscore reflects need to verify each ingredient's specific milligram/microgram dose. Buyers with any thyroid diagnosis should coordinate with an endocrinologist before adding this — iodine excess is a real risk in Hashimoto's patients.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zahler-inflamix™-occasional-inflammation-support-potent-herbal-mix-for-natural-recovery-120-capsules",
      "title": "Zahler InflaMix™ – Occasional Inflammation Support Potent Herbal Mix for Natural Recovery | 120 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/image_6f498e1b-6e91-45b8-9948-2b4c0fa10beb.png?v=1788111820",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "inflammation"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zahler",
        "inflamix",
        "occasional",
        "inflammation",
        "support",
        "potent",
        "herbal",
        "mix",
        "for",
        "natural",
        "recovery",
        "120",
        "capsules",
        "singers",
        "health",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46833583751365",
      "vsf_explanation": "Zahler InflaMix is a botanical anti-inflammatory blend typically containing curcumin/turmeric, boswellia, ginger, and related herbal extracts — the standard 'natural recovery' stack. Marketing language ('Occasional Inflammation Support') is DSHEA-compliant structure-function and avoids the unverified-medical-claim territory of claiming to treat arthritis, rheumatoid disease, or any diagnosed inflammatory condition. Ingredient evidence: curcumin has moderate-to-strong meta-analytic support for reducing inflammatory markers (CRP, IL-6) at bioavailable doses (typically 500-1,000 mg/day of curcuminoids from a bioavailable form — Meriva phytosome, C3 Complex + BioPerine, or Longvida); boswellia AKBA fraction has RCT evidence for osteoarthritis knee pain reduction (Sengupta 2008, Kimmatkar 2003); ginger has clinical evidence for post-exercise soreness. Formulation quality depends on curcumin's bioavailability enhancer and boswellia AKBA standardization — key transparency items that need panel verification. Standard tier on solid ingredient rationale + Zahler brand quality. Would move higher with confirmed bioavailable curcumin form and standardized boswellia AKBA%.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "forever-living-arctic-supplement-a-perfect-balanced-blend-of-omega-3s-120-softgels",
      "title": "Forever living Arctic Supplement a perfect balanced blend of Omega 3s 120 softgels",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/forever-arctic-sea-product-background.png?v=1788111833",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "forever",
        "living",
        "arctic",
        "supplement",
        "perfect",
        "balanced",
        "blend",
        "omega",
        "120",
        "softgels",
        "singers",
        "health",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46833583784133",
      "vsf_explanation": "Forever Living Arctic Supplement is a blended omega-3 formulation combining fish, calamari, and plant sources of EPA and DHA (per Forever Living's public product page — 'exclusive blend of omega-3s'). Marketing claims (supports healthy heart, supports optimal cognition) are DSHEA-compliant. Omega-3 evidence is genuinely strong for cardiovascular health at meaningful EPA+DHA daily doses (typical target: 1-2 g/day EPA+DHA combined; the ASCEND, VITAL, REDUCE-IT, and STRENGTH trials collectively show variable benefit signals depending on dose, form, and population). The concern with this specific SKU is per-serving EPA + DHA content, which is not clearly disclosed at the title level — many multi-source omega-3 blends deliver 300-500 mg EPA+DHA per serving, which is a valid maintenance dose but not the higher-dose therapeutic range. Forever Living's MLM-distribution model reduces per-lot testing transparency and third-party verification (oxidation status, heavy metals) is not routinely published. Standard tier on omega-3-class evidence merit; transparency and sustainability subscores reflect MLM-model testing/sourcing opacity. Would move higher with clearly disclosed EPA+DHA milligrams per serving, third-party oxidation (TOTOX) test, and heavy-metal COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zahler-revolution™-complete-urinary-tract-formula-60-capsules",
      "title": "Zahler Revolution™ – Complete Urinary Tract Formula | 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/image_e483e5ed-874d-44af-8673-81fb8c758b0b.png?v=1788111820",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zahler",
        "revolution",
        "complete",
        "urinary",
        "tract",
        "formula",
        "capsules",
        "singers",
        "health",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 65,
        "safety": 68,
        "transparency": 60,
        "sustainability": 60
      },
      "price": 46.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46833583718597",
      "vsf_explanation": "Zahler Revolution is a urinary tract health formula combining D-mannose, cranberry extract, probiotics (~50 billion CFU L. acidophilus), and superfruit antioxidants. The ingredient logic is solid: D-mannose has RCT evidence (Kranjčec 2014, N=308) for reducing UTI recurrence in women with recurrent uncomplicated UTIs; cranberry proanthocyanidins have moderate meta-analytic evidence for UTI recurrence prevention (Cochrane review — mixed but with a real signal for recurrent-UTI populations); Lactobacillus acidophilus supports urogenital microbiome. Marketing language ('take back control of your urinary health,' 'complete urinary tract formula') is DSHEA-permissible structure-function and stops short of claiming to treat active UTIs. Real UTIs — acute cystitis with symptoms, pyelonephritis, complicated UTIs — need antibiotic treatment under clinician care; supplements are for recurrence prevention in appropriate candidates. Zahler brand quality supports Standard tier. Would move higher with confirmed proanthocyanidin (PAC) mg per serving (36 mg is the evidence-anchored dose) and D-mannose dose match to Kranjčec protocol (2 g/day for first 6 months).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "forever-bee-pollen-natural-energy-nutrition-supplement",
      "title": "Forever Bee Pollen - Natural Energy & Nutrition Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/forever_bee_pollen__pd_main_512_X_512_1649278499431.png?v=1788111826",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "forever",
        "bee",
        "pollen",
        "natural",
        "energy",
        "nutrition",
        "supplement",
        "singers",
        "health",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 50,
        "manufacturing": 55,
        "safety": 48,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46833583947973",
      "vsf_explanation": "Forever Bee Pollen is a whole-food bee pollen tablet marketed for 'natural energy,' immune function, and 'overall vitality.' Bee pollen has a very thin clinical evidence base: nutritional-composition studies confirm it contains a diverse micronutrient profile (B-complex vitamins, amino acids, trace minerals, antioxidants), but no substantive RCTs support the 'sustained energy' or 'vitality' claims at typical supplement doses. The real safety issue is allergenic potential — bee pollen can trigger anaphylaxis in people with pollen or bee-product allergies, and case reports of severe reactions exist in the literature (including several published fatality reports in pollen-allergic individuals). The FDA has issued warning letters and case notices about bee pollen adverse events historically. Combined with Forever Living's MLM distribution model (thin per-lot testing transparency) and the thin evidence base, Rejected tier is honest — the product does not clearly harm anyone at typical doses but does not deliver evidence-supported benefit and carries genuine allergen risk. Not autofailed because the safety issue is manageable with proper labeling and consumer awareness rather than being a structural product defect.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "forever-active-ha®-this-advanced-blend-of-joint-supporting-ingredients-like-the-beneficial-ginger-and-turmeric-is-a-great-supplement-to-help-keep-you-moving60-softgels",
      "title": "Forever Active HA®. This advanced blend of joint-supporting ingredients like the beneficial ginger and turmeric is a great supplement to help keep you moving60 softgels",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/forever-active-ha-product-background.png?v=1788111824",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "forever",
        "active",
        "this",
        "advanced",
        "blend",
        "joint",
        "supporting",
        "ingredients",
        "like",
        "the",
        "beneficial",
        "ginger",
        "and",
        "turmeric",
        "great",
        "supplement",
        "help",
        "keep",
        "you",
        "moving60",
        "softgels",
        "singers",
        "health",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46833584013509",
      "vsf_explanation": "Forever Active HA is a joint-support softgel featuring hyaluronic acid (HA) with ginger and turmeric as supporting botanicals. Ingredient logic: oral HA has small-RCT evidence for joint comfort and skin hydration (Kalman 2008, Nelson 2015 — statistically significant improvements in Western Ontario McMaster Osteoarthritis Index and skin dryness at ~120-200 mg/day of high-molecular-weight oral HA over 8-12 weeks); ginger has meta-analytic evidence for osteoarthritis pain reduction; turmeric bioavailability caveats apply. Marketing language ('lubricates and cushions joints,' 'promotes proper joint function,' 'supports skin hydration') stretches into 'lubricates joints' territory which is mechanistically simplified — oral HA does not directly enter synovial fluid intact — but stays within DSHEA structure-function. Forever Living MLM distribution reduces per-lot testing transparency. Standard tier on ingredient rationale + reasonable claim discipline. Product name in the source catalog is comically long — a formatting/SEO issue rather than a formulation issue. Would move higher with confirmed HA milligrams, turmeric bioavailability form disclosure, and per-lot COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "forever-multi-maca-natural-energy-vitality-supplement",
      "title": "Forever Multi Maca - Natural Energy & Vitality Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/image_5da66df1-36aa-4e21-bdf8-51d64aeee8f5.png?v=1788111820",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "energy",
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "forever",
        "multi",
        "maca",
        "natural",
        "energy",
        "vitality",
        "supplement",
        "singers",
        "health",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 50,
        "sustainability": 55
      },
      "price": 28,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46833583882437",
      "vsf_explanation": "Forever Multi Maca is a maca root formulation for energy and vitality, in the Andean adaptogen category. Maca (Lepidium meyenii) has small-RCT evidence for improvements in subjective sexual function and mood in menopausal women (Meissner 2006) and in mild male sexual health markers (Zenico 2009), but does not appear to shift testosterone or other measured hormone levels. Marketing language ('sustained energy,' 'mental clarity,' 'stamina,' 'traditionally valued') is DSHEA-permissible structure-function and honestly reflects the evidence base's ambiguity. Forever Living MLM distribution model reduces per-lot testing transparency. Additional concern: maca cultivar (yellow, red, black) affects the marker compounds (macamides, macaenes) and clinical positioning — 'Multi Maca' suggests a blend but specific cultivar disclosure is unclear at the title level. Standard tier on legitimate ingredient rationale + reasonable claims; transparency subscore reflects opaque cultivar and marker-compound standardization. Would move higher with cultivar disclosure, macamide/macaene standardization, and published COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zahler-adultfocus™-cognitive-health-support-90-capsules",
      "title": "Zahler AdultFocus™ Cognitive Health Support – 90 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/image_bae31429-c62e-42a2-a338-6b4e16ad8903.png?v=1788111820",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zahler",
        "adultfocus",
        "cognitive",
        "health",
        "support",
        "capsules",
        "singers",
        "health",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 60,
        "sustainability": 60
      },
      "price": 41.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46833583849669",
      "vsf_explanation": "Zahler AdultFocus is a caffeine-free cognitive-support formula targeting adults, typically featuring some subset of L-theanine, phosphatidylserine, bacopa, rhodiola, ginkgo, B-complex vitamins, and choline-adjacent compounds. Marketing language ('crystal-clear thinking, steady concentration, mental energy without caffeine crashes') is DSHEA-permissible structure-function. Ingredient evidence in the nootropic class is heterogeneous: phosphatidylserine has small-RCT evidence for age-related cognitive complaints (Kato-Kataoka 2010, at 300 mg/day); bacopa has moderate-quality trials for memory (Stough 2001, 2008, Calabrese 2008 — 300 mg/day of Bacopa monnieri extract at ~55% bacosides over 8-12 weeks); L-theanine has some evidence for attention when combined with caffeine, less alone; rhodiola has stress-adaptation and fatigue-reduction evidence at 200-600 mg/day. Effect sizes are modest across the class. Standard tier on real ingredient rationale + Zahler brand quality. Would move higher with confirmed evidence-anchored per-ingredient doses (300 mg bacopa, 300 mg phosphatidylserine, etc.) and published COA. Transparency deduction reflects need to verify each nootropic hits its studied dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zahler-omega-3-platinum-d™-advanced-fish-oil-vitamin-d3-premium-grade-omega-3-softgels",
      "title": "Zahler Omega 3 Platinum+D™ Advanced Fish Oil + Vitamin D3 Premium Grade Omega-3 Softgels",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/image_fdeaa946-83f4-44bd-9e31-cc11e739e253.png?v=1788111820",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zahler",
        "omega",
        "platinum",
        "advanced",
        "fish",
        "oil",
        "vitamin",
        "premium",
        "grade",
        "omega",
        "softgels",
        "singers",
        "health",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 70,
        "manufacturing": 68,
        "safety": 70,
        "transparency": 65,
        "sustainability": 62
      },
      "price": 42.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46833583816901",
      "vsf_explanation": "Zahler Omega 3 Platinum+D is a premium-grade fish oil with added Vitamin D3, positioned in the higher-quality tier of the OTC omega-3 category. Zahler is a real US kosher-certified supplement brand with reasonable third-party testing standards. Ingredient logic and evidence are strong: omega-3 EPA and DHA have decades of cardiovascular research (variable outcome signals across ASCEND, VITAL, REDUCE-IT, STRENGTH depending on dose, purity, and population), with the most consistent evidence for triglyceride lowering (dose-dependent, 2-4 g/day EPA+DHA) and secondary-prevention cardiovascular benefit at high-purity EPA doses (REDUCE-IT icosapent ethyl 4 g/day). Adding Vitamin D3 addresses widespread deficiency and pairs a fat-soluble vitamin with the oily carrier. Marketing language ('fresh smell,' 'no fishy aftertaste,' 'heart, brain, joints, immune system') is DSHEA-compliant. The 'fresh smell' claim is meaningful — it correlates with lower TOTOX (total oxidation) values, which is a real quality metric for fish oil. Higher-tier Standard on brand quality + evidence-supported ingredient class + reasonable transparency. Would push to Verified with published TOTOX values, EPA+DHA milligrams clearly on the panel, and third-party heavy-metal COA per lot.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zahler-bonefactor™-plant-based-calcium-d3-k2-magnesium-maximum-bone-joint-support",
      "title": "Zahler BoneFactor™ – Plant-Based Calcium + D3, K2 & Magnesium Maximum Bone & Joint Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/image_f14852aa-8ab7-41a8-9413-a601ea1b864e.png?v=1788111820",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zahler",
        "bonefactor",
        "plant",
        "based",
        "calcium",
        "magnesium",
        "maximum",
        "bone",
        "joint",
        "support",
        "singers",
        "health",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 72,
        "manufacturing": 68,
        "safety": 70,
        "transparency": 62,
        "sustainability": 68
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46833583915205",
      "vsf_explanation": "Zahler BoneFactor combines plant-sourced calcium with Vitamin D3, K2, and magnesium — the current best-practice bone-health micronutrient stack. Ingredient logic is strong: D3 drives intestinal calcium absorption, K2 directs calcium deposition to bone (MK-7 form, ~90-180 mcg/day, has trial evidence for bone mineral density and slowing arterial calcification in postmenopausal women — Knapen 2013, Rønn 2016), magnesium is a co-factor in bone matrix formation and D3 activation, and plant-sourced calcium (typically algae-derived, e.g. Aquamin, Aquamin F) provides trace minerals (boron, strontium, silica) alongside calcium citrate/carbonate. Plant-sourced calcium formulations have small comparative trial evidence (Michalek 2005, Adluri 2010) suggesting comparable or slightly better bone-density signals versus purified calcium salts. Marketing language ('build stronger bones,' 'plant-based calcium') is DSHEA-permissible structure-function. Zahler kosher-certified brand quality supports Standard tier at the higher end. Would move to Verified with confirmed MK-7 K2 dose, elemental calcium dose, and third-party COA per lot.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "young-living-basil-essential-oil-5ml-mental-clarity-focus-natural-stress-relief",
      "title": "Young Living Basil Essential Oil 5ml Mental Clarity Focus & Natural Stress Relief",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/image_0bd04fe8-3c01-4c9f-aec2-8e243dd0f242.png?v=1788111821",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "young",
        "living",
        "basil",
        "essential",
        "oil",
        "5ml",
        "mental",
        "clarity",
        "focus",
        "natural",
        "stress",
        "relief",
        "singers",
        "health",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 52,
        "manufacturing": 55,
        "safety": 45,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46833583980741",
      "vsf_explanation": "Young Living Basil Essential Oil (5ml, Ocimum basilicum) is an aromatherapy essential oil marketed for 'mental clarity, sharp focus, nervous system restoration, and natural stress relief.' Essential oils occupy an awkward position in Vyvata's rubric — they are not supplements in the traditional sense (not intended as oral dietary supplements, though Young Living controversially encouraged internal 'Vitality' branding for some SKUs), and Vyvata does not have an aromatherapy category. The stress_mood_mental placement is the closest fit for the marketed positioning. Evidence-side: aromatherapy in general has small-RCT evidence for short-term stress and mood modulation (typically session-based inhalation of lavender, bergamot, or basil), but effect sizes are small and typically confounded by expectation. Young Living is a multi-level-marketing brand with a substantive FDA regulatory history: multiple FDA warning letters to Young Living distributors historically for unauthorized disease claims (cancer, Ebola, autism, and others), and the MLM distributor sales model can amplify medical-claim proliferation beyond company-controlled marketing. The essential oil itself is presumably legitimate steam-distilled basil; the concern is the brand and marketing ecosystem around it. Score sits in Rejected on the composite of thin evidence for the marketed cognitive/stress claims, Young Living's brand regulatory history, and safety concerns around ingestion of essential oils (which Young Living's Vitality line has historically encouraged despite FDA cautions). Not autofailed because the description reviewed here does not itself make explicit disease claims — but the brand context and category fit both weigh the score down.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zahler-heightfactor™-natural-growth-support-formula-120-capsules",
      "title": "Zahler HeightFactor™ – Natural Growth Support Formula | 120 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/image_9116ff82-3345-4451-8732-a949bd38fc68.png?v=1788111820",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zahler",
        "heightfactor",
        "natural",
        "growth",
        "support",
        "formula",
        "120",
        "capsules",
        "singers",
        "health",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 55,
        "manufacturing": 65,
        "safety": 58,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 49.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46833584079045",
      "vsf_explanation": "Zahler HeightFactor is marketed as a 'Natural Growth Support Formula' targeting parents of children in 'the critical growing years.' The core claim — that a nutritional supplement can meaningfully add height beyond adequately-nourished baseline growth — is not supported by controlled trials. Height is overwhelmingly determined by genetics (heritability ~80%) plus adequate nutrition and health during childhood; children who are already receiving adequate calories, protein, calcium, D3, zinc, and iron do not grow taller from supplementation. The marketing framing implies otherwise, which is the concern: it targets parents' anxiety about growth and implies causation between the product and final height that does not hold in evidence. Formulation-wise, HeightFactor typically contains vitamins and minerals that ARE relevant if a deficiency exists (D3, calcium, zinc, magnesium), plus botanical adaptogens with no pediatric evidence base. For a demonstrably nutritionally-deficient child, closing those deficits with a pediatrician's guidance is appropriate; for a normally-nourished child, a 'growth support' supplement neither adds height nor accelerates puberty. Autofailed on unverified_medical_claim — 'Natural Growth Support Formula' when applied to children implies growth outcomes that supplementation does not deliver. Would become listable at Standard tier if renamed to a general pediatric multivitamin with honest positioning around nutrient adequacy rather than 'growth support.'",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "zahler-mushroom-complex™-premium-7-mushroom-blend-focus-calmness-immunity-support-60-capsules",
      "title": "Zahler Mushroom Complex™ – Premium 7-Mushroom Blend | Focus, Calmness & Immunity Support | 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Z-MC5_1_1.webp?v=1788111820",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zahler",
        "mushroom",
        "complex",
        "premium",
        "mushroom",
        "blend",
        "focus",
        "calmness",
        "immunity",
        "support",
        "capsules",
        "singers",
        "health",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 36.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46833584046277",
      "vsf_explanation": "Zahler Mushroom Complex is a functional-mushroom blend spanning seven species — typically Lion's Mane, Reishi, Cordyceps, Chaga, Maitake, Shiitake, and Turkey Tail — marketed for focus, calmness, and immunity. Ingredient class evidence is genuinely present across the individual species: Turkey Tail (PSK/PSP) has oncology-adjuvant literature; Reishi has small-RCT evidence for sleep and immune markers; Lion's Mane (Hericium erinaceus) has small human trials for mild cognitive complaints (Mori 2009, N=30, 3 g/day of the fruit body powder for 16 weeks showed cognitive-scale improvements); Cordyceps has small trials for exercise capacity. Effect sizes are modest across the class. Two transparency-side concerns are typical for multi-mushroom blends: (1) whether the product uses fruit body (higher beta-glucan content, better evidence base) or mycelium-on-grain (cheaper, higher starch content, lower beta-glucan), and (2) whether the total dose is realistic per species — a 7-mushroom, 500 mg-per-serving product cannot deliver 3 g of Lion's Mane fruit body (the studied dose), so it's necessarily at proof-of-concept dosing rather than trial-matched dosing. Zahler brand quality supports Standard tier. Would move higher with fruit-body-only sourcing disclosure, beta-glucan standardization percentage, and per-species milligram breakdown on the panel.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zahler-synerg™-advanced-glucosamine-sulfate-supports-healthy-joint-cartilage-regeneration-120-capsules",
      "title": "Zahler SynerG™ – Advanced Glucosamine Sulfate | Supports Healthy Joint Cartilage Regeneration | 120 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/image_1767d916-2c1c-40a3-98f7-3c98267dfc5c.png?v=1788111832",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zahler",
        "synerg",
        "advanced",
        "glucosamine",
        "sulfate",
        "supports",
        "healthy",
        "joint",
        "cartilage",
        "regeneration",
        "120",
        "capsules",
        "singers",
        "health",
        "products"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 68,
        "safety": 68,
        "transparency": 60,
        "sustainability": 60
      },
      "price": 36.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46833584111813",
      "vsf_explanation": "Zahler SynerG is a glucosamine sulfate joint-support formula. Glucosamine sulfate specifically (as distinct from glucosamine hydrochloride) has moderate-quality RCT evidence for knee osteoarthritis symptomatic improvement at 1,500 mg/day (Reginster 2001, Pavelka 2002 — 3-year studies showed statistically significant WOMAC pain and function improvements versus placebo). The GAIT trial (Clegg 2006) was more equivocal for glucosamine + chondroitin as a combination in the general OA population but showed benefit in moderate-to-severe OA subgroup. EULAR (European Rheumatology) guidelines have historically recommended glucosamine sulfate as a modest symptomatic OA intervention; ACR (American College of Rheumatology) has been more skeptical. The 'cartilage regeneration' claim in the product title is a stretch — evidence for structural cartilage regeneration is weak; symptomatic pain and function improvement is the more supportable claim. Marketing language is otherwise DSHEA-permissible. Zahler kosher brand quality supports Standard tier. Would move higher with confirmed 1,500 mg/day glucosamine sulfate dose match, third-party COA, and softening of the 'cartilage regeneration' framing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hhs-a-plus-l-carnitine-lepidium-herbal-capsules-natural-support-with-ginger-garcinia-maca",
      "title": "HHS A Plus L-Carnitine Lepidium Herbal Capsules | Natural Support with Ginger, Garcinia & Maca",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/A-Plus-L-Carnitine-ve-Lepidium-Iceren-Kapsul-Takviye-Edici-Gidaa-1.jpg?v=1788111869",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood",
        "energy",
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hhs",
        "plus",
        "carnitine",
        "lepidium",
        "herbal",
        "capsules",
        "natural",
        "support",
        "with",
        "ginger",
        "garcinia",
        "maca",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 42,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 28,
        "sustainability": 42
      },
      "price": 222.01,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46833585356997",
      "vsf_explanation": "HHS is a small-market herbal brand of unclear provenance. The formula stacks L-carnitine and Lepidium (maca) with ginger, garcinia (Garcinia cambogia), cardamom, and cinnamon — a multi-ingredient blend that reads as a weight-loss / metabolism formula but is described in the product copy with hedged language (\"may help boost hydration and provide natural support for your body's energy balance\"). Per-ingredient doses are not disclosed, extraction ratios for the botanicals are not disclosed, and no standardization percentages are published. The specific ingredient set flags additional concerns: Garcinia cambogia has been the subject of FDA safety communications for hepatotoxicity when used chronically at self-directed doses, has essentially no reliable clinical evidence for meaningful weight loss (multiple meta-analyses show effect sizes of ~1 kg at 12 weeks, well within placebo noise), and its inclusion in a multi-ingredient blend with undisclosed dose makes hepatotoxicity risk-attribution impossible. `proprietary_blend_hides_dose` applies for the undisclosed multi-ingredient formula; the garcinia inclusion adds a `safety_concern` overlay. Weight-management category with hedged \"support\" language, undisclosed multi-herb dosing, and a hepatotoxicity-flagged ingredient is not listable in the current form.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "amino-acid-capsules",
      "title": "Amino acid capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3B90B4AA6DE8F706E806756C9DB39EE3.jpg?v=1788111904",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "amino",
        "acid",
        "capsules",
        "digital",
        "presence"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 25,
        "manufacturing": 30,
        "safety": 45,
        "transparency": 20,
        "sustainability": 30
      },
      "price": 22.66,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46833585782981",
      "vsf_explanation": "The product's name is literally \"Amino acid capsules.\" There is no brand. There is no functional claim. There is no disclosure of which amino acids the capsules contain, at what doses, in what ratios, or for what use case (BCAA/EAA for muscle protein synthesis, single amino for a specific pathway like L-tryptophan for sleep or L-lysine for cold sores, glycine for sleep, taurine for cardiovascular). The description page reads as a template-form product spec — \"Shelf life: 2 years,\" \"Net content: 60 capsules,\" \"Type: Amino acid capsule,\" \"Target audience: Adults\" — the fingerprint of a white-label bulk-import product listed by a resale operator with no involvement in formulation or brand. This is the pure form of the failure modes the rubric was written to catch: `misleading_naming` (a category noun used as a product name), `no_brand_provenance` (no identified brand at all), and `proprietary_blend_hides_dose` (no ingredient disclosure of any kind). Not listable at any level of the tier structure. There is nothing to score.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "leader™-one-daily-multivitamin-adult-formula",
      "title": "Leader™ One Daily Multivitamin – Adult Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/251323800.jpg?v=1788111946",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "leader",
        "one",
        "daily",
        "multivitamin",
        "adult",
        "formula",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 52,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 10.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46833586405573",
      "vsf_explanation": "Leader is a Cardinal Health-affiliated pharmacy private-label brand — the generic-equivalent SKU that sits next to Centrum and One A Day on independent-pharmacy shelves. It is a real, FDA-registered manufacturer's product; it is not a fly-by-night label. A 365-tablet one-a-day adult multivitamin at pharmacy-generic pricing is a defensible baseline-nutrition product for the shopper who wants insurance coverage against dietary gaps at the lowest reasonable cost. Where the score lands in Standard rather than Verified is what a generic multivitamin actually delivers: retinyl palmitate rather than mixed carotenoids for vitamin A, dl-alpha-tocopherol (synthetic) rather than mixed tocopherols for vitamin E, cyanocobalamin rather than methylcobalamin for B12, folic acid rather than methylfolate, and mineral forms optimized for cost rather than absorption (oxide rather than glycinate for magnesium, carbonate for calcium). These forms work for the general population — they are why the RDA recommendations have not shifted — but they are not the premium formulations preferred by evidence-forward supplement shoppers. There is also the well-established literature (Physicians' Health Study II 2012, USPSTF 2022 evidence review) showing that daily multivitamin use produces small cognitive and possibly cardiovascular signals in older adults but essentially no measurable benefit for baseline-nutrient-replete adults on a mixed Western diet. Not an auto-fail; a genuine baseline product with genuine limitations.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "animal-creatine-chews-tablets-enhanced-creatine-monohydrate-with-astragin-to",
      "title": "Animal Creatine Chews Tablets - Enhanced Creatine Monohydrate with Astragin to",
      "vendor": "Price Is Right Miami",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/665d2f8c-22bb-42c4-bcbe-69161f11d316.jpg?v=1788112018",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "animal",
        "creatine",
        "chews",
        "tablets",
        "enhanced",
        "creatine",
        "monohydrate",
        "with",
        "astragin",
        "price",
        "right",
        "miami"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 55,
        "manufacturing": 65,
        "safety": 75,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46833596891333",
      "vsf_explanation": "Animal (Universal Nutrition, active since the 1970s) is a real bodybuilding-market brand with legitimate manufacturing and long retail presence. The active ingredient is creatine monohydrate, which is arguably the single best-evidenced ergogenic and cognitive supplement in the entire nutraceutical space — dozens of RCTs and multiple meta-analyses (Kreider 2017 JISSN position stand; recent 2024 meta-analyses) confirm effects on strength, lean body mass, and short-duration high-intensity performance at 3-5 g/day, with a genuinely durable safety record extending across decades of use. The AstraGin addition (Ginseng + Astragalus extract) is a NuLiv Science branded absorption-enhancement complex; the AstraGin evidence base is modest but not fabricated, with company-sponsored studies showing marginal amino-acid uptake improvements. The problem is chew format arithmetic. A therapeutic creatine dose is 3-5 g/day, which is 3,000-5,000 mg. Chewable creatine tablets typically deliver 1-1.5 g per serving because of tablet-mass constraints — a shopper needs to chew 3-5 tablets daily to reach the studied dose, and the product description does not disclose per-tablet creatine milligrams or the total-tub serving count clearly. Without that dose disclosure, a shopper cannot verify whether the label serving delivers ergogenic dose or subclinical dose. Standard tier reflects strong ingredient evidence and real brand offset by opaque per-tablet dosing and a chewable format that often under-delivers on the studied protocol.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nature-made-sam-e-200-mg-complete-tablets",
      "title": "Nature Made SAM-e 200 Mg Complete Tablets",
      "vendor": "Nature Made",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/241066814.jpg?v=1788112034",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "made",
        "sam",
        "200",
        "complete",
        "tablets",
        "nature",
        "made"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 74,
        "manufacturing": 82,
        "safety": 70,
        "transparency": 76,
        "sustainability": 62
      },
      "price": 58.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46833598660805",
      "vsf_explanation": "Nature Made (Pharmavite, US) is one of the two or three most institutionally credible mainstream supplement brands in the United States: a large USP-verified product line, FDA-registered manufacturing in California, and a long track record with the pharmacy channel. S-adenosyl-L-methionine (SAM-e) is one of the better-evidenced mood and joint compounds in the supplement aisle. Two meta-analyses in Journal of Clinical Psychiatry (Sarris 2020) and a Cochrane review of adjunctive SAM-e in depression found effect sizes comparable to SSRIs at doses of 400-1600 mg/day, with an especially good safety profile relative to pharmaceutical antidepressants. For osteoarthritis, a Cochrane review found SAM-e equivalent to NSAIDs on pain and function at 600-1200 mg/day. The 200 mg per-tablet dose in this product is at the low end of the studied range; a shopper would typically take 2-4 tablets/day to reach studied efficacy levels, which is consistent with the label instruction \"Start with 2 tablets per day.\" SAM-e is chemically labile and requires enteric coating to survive stomach acid; Nature Made's tablet uses enteric coating and blister-pack single-tablet packaging, which is the appropriate manufacturing approach. Score reflects verified brand, real evidence at the studied dose range, transparent labeling, and a mainstream safety profile. Not Elite because the 200 mg per-tablet dose requires multi-tablet dosing to reach clinical range, and because SAM-e can interact with SSRIs and MAOIs — clinician oversight is meaningfully important for anyone on prescription mood medication.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-a-soluble-capsule-10mu-100ct",
      "title": "Vitamin A  Soluble Capsule 10Mu 100Ct",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/160027417.jpg?v=1788112071",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "soluble",
        "capsule",
        "10mu",
        "100ct",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 35,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 5.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46833600397509",
      "vsf_explanation": "Major Vitamin A 10,000 IU is a Cardinal Health private-label pharmacy staple — a single-ingredient vitamin A softgel at 10,000 IU (~3,000 mcg RAE preformed retinyl palmitate) per capsule. The Major brand line is a legitimate US pharmacy generic with FDA-registered manufacturing, and the label is transparent about dose and form. What disqualifies it is the specific dose. The current US Tolerable Upper Intake Level (UL) for preformed vitamin A in adults is 3,000 mcg RAE — which is exactly 10,000 IU — meaning this capsule delivers 100% of the safety ceiling per dose, before any dietary intake from liver, dairy, fortified cereals, or a daily multivitamin. Chronic intake at or above the UL is linked to hepatotoxicity, dose-dependent bone-mineral-density loss in older adults, and teratogenicity risk in pregnancy (vitamin A is the classical teratogen for which the UL was originally set). No functional-medicine or dermatology guideline recommends 10,000 IU/day of preformed vitamin A as a routine supplement for the general adult population; the entrenched retail availability of the SKU reflects legacy labeling, not current safety consensus. This is a `safety_concern` — a real, verifiable dose sitting at the toxicity ceiling with no clinical indication that justifies daily intake at that level for a general shopper.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "goodday-dim-plus-60-tablet-natural-dietary-supplement",
      "title": "Goodday DIM Plus 60 Tablet - Natural Dietary Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4nknfejZe3khocBhNlh9hNHhpRlWyV8kO6JZahsz.jpg?v=1788112081",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "goodday",
        "dim",
        "plus",
        "tablet",
        "natural",
        "dietary",
        "supplement",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 42,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 30,
        "sustainability": 42
      },
      "price": 52.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46833601577157",
      "vsf_explanation": "Diindolylmethane (DIM) is a real cruciferous-vegetable-derived metabolite with peer-reviewed evidence for supporting healthy estrogen metabolism (favoring the 2-hydroxyestrone pathway over 16-alpha-hydroxyestrone) at studied doses of ~100-200 mg/day. If this product delivered a well-characterized DIM dose with an appropriate absorption vehicle (BioResponse DIM, phosphatidylcholine, or vitamin E as bioavailability aids), it would score in Standard or Verified. Instead, the Goodday label description is a paragraph of stock-photo copy — \"nutritional support through its blend of herbal extracts and other essential ingredients,\" \"plant-based extracts,\" \"health-conscious adults looking for a natural approach\" — that does not disclose the per-tablet DIM milligrams, the additional \"herbal extracts,\" the extraction ratios, or any standardization. \"DIM Plus\" implies additional actives beyond DIM, but the \"Plus\" is not defined on the front description. This is `proprietary_blend_hides_dose` — a real active ingredient wrapped in undisclosed accompanying ingredients at undisclosed doses. The brand is a small-market label with limited public GMP documentation and no third-party testing published. Not listable until DIM milligrams are disclosed and the \"Plus\" component is defined.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "revitalize-renew",
      "title": "Revitalize & Renew",
      "vendor": "elvis+elvin",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/revitalizerenew.jpg?v=1788112127",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "revitalize",
        "renew",
        "elvis",
        "elvin"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 42,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 25,
        "sustainability": 40
      },
      "price": 68,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46833609310405",
      "vsf_explanation": "\"Revitalize & Renew\" is a marketing phrase, not a product name. The label is a scattergun of amino acids (L-lysine, L-arginine, L-proline, L-cysteine, L-glutamine) mixed with grape seed extract, Ganoderma (reishi) powder, and Schizonepeta extract, and it is positioned as a \"daily adult wellness supplement\" with no defined use-case, no target biomarker, and no clinical mechanism tying those particular ingredients together at those particular doses. The description does not disclose per-ingredient milligrams, extraction ratios for the botanical inputs (a 4:1 reishi is very different from a 40:1), or the standardization percentage on grape seed extract (polyphenol/OPC content is the whole point of grape seed). The formulation reads as a proprietary blend engineered around whatever the contract manufacturer had in inventory, not around a specific health goal. Two independent auto-fail conditions apply: `misleading_naming` (a two-word emotive phrase with no functional claim) and `proprietary_blend_hides_dose` (a multi-ingredient formula without published per-input milligrams). Not listable in current form. A rescore would require a clear health-claim vertical, per-ingredient dosing at levels supported by class-level evidence, and standardization disclosure on the botanicals.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "hydrogenator®-flask-blue",
      "title": "Hydrogenator® Flask - Blue",
      "vendor": "Piurify",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BlueFlaskNoBackground.jpg?v=1788487855",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hydrogenator",
        "flask",
        "blue",
        "piurify"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "contrast_therapy"
      ],
      "vsf_dimensions": {
        "analytical_validity": 55,
        "clinical_utility": 52,
        "transparency": 62,
        "build_quality": 65,
        "warranty_support": 68,
        "value": 55
      },
      "price": 199.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46859260231877",
      "vsf_explanation": "The Piurify Hydrogenator Flask (Blue) is a hydrogen water generator using SPE/PEM (solid polymer electrolyte / proton-exchange-membrane) electrolysis to dissolve molecular hydrogen (H2) into drinking water. Piurify claims maximum ~8,630 ppb (parts per billion) hydrogen concentration, a 5,000 mAh battery, BPA-free materials, and a lifetime warranty. The category fit within Vyvata's rubric is imperfect — hydrogen water is a fringe/emerging biohacking modality that does not map cleanly to any of our five verticals; we default to recovery_regeneration under contrast_therapy because most peer-reviewed hydrogen-water research (LeBaron et al. small RCTs on soft-tissue injury, Ostojić 2014-2018 sports-performance trials, Mikami 2019 on inflammatory markers) focuses on recovery, oxidative stress, and inflammation rather than on any of the other Vyvata verticals. The evidence base itself is genuinely emerging: several small RCTs and animal studies show modulation of oxidative-stress and inflammation biomarkers, but sample sizes are typically 10-30 subjects per arm, dosing is heterogeneous, and no large phase-3 human outcome trial exists. The device hardware appears legitimate — SPE/PEM electrolysis is a real technology used across the hydrogen-water category (Lourdes, Trusii, Susosu) — and Piurify offers a lifetime warranty, which is stronger than most competitors. Scores Standard on real-hardware + emerging-evidence merit. Would move toward Verified with published third-party hydrogen-concentration verification for this specific SKU and a controlled clinical trial on brand-tested output.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hydrogenator®-bottle-with-handle-brown",
      "title": "Hydrogenator® Bottle with Handle - Brown",
      "vendor": "Piurify",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Mainimage_BrownnnoboxNoBackground.jpg?v=1788487855",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hydrogenator",
        "bottle",
        "with",
        "handle",
        "brown",
        "piurify"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "contrast_therapy"
      ],
      "vsf_dimensions": {
        "analytical_validity": 55,
        "clinical_utility": 52,
        "transparency": 60,
        "build_quality": 62,
        "warranty_support": 60,
        "value": 55
      },
      "price": 151,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46859260264645",
      "vsf_explanation": "The Piurify Hydrogenator Bottle with Handle (Brown) is a 500ml / 17.6 oz portable hydrogen water bottle claiming up to 9,970 ppb H2 concentration via SPE/PEM electrolysis and 'third-party certified' output. Same category-fit caveat as the rest of the Piurify line: hydrogen water is a fringe biohacking modality with an emerging small-RCT evidence base (LeBaron, Ostojić, Mikami) but no large clinical outcomes data, and the closest Vyvata subcategory (contrast_therapy in recovery_regeneration) is a proxy rather than a clean taxonomic fit. Hardware is the on-the-go form factor with a handle for carrying; SPE/PEM is a legitimate electrolysis technology in the category. Scores Standard on real-hardware + emerging-evidence + reasonable claims. Would move toward Verified with published third-party test reports specific to this SKU verifying the 9,970 ppb claim under real-use conditions, and battery/electrode longevity data.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hydrogenator®-bottle-with-handle-dark-blue",
      "title": "Hydrogenator® Bottle with Handle - Dark Blue",
      "vendor": "Piurify",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HandleBottlenoBackground.jpg?v=1788487855",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hydrogenator",
        "bottle",
        "with",
        "handle",
        "dark",
        "blue",
        "piurify"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "contrast_therapy"
      ],
      "vsf_dimensions": {
        "analytical_validity": 55,
        "clinical_utility": 52,
        "transparency": 60,
        "build_quality": 62,
        "warranty_support": 60,
        "value": 55
      },
      "price": 151,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46859260330181",
      "vsf_explanation": "Piurify Hydrogenator Bottle with Handle (Dark Blue) is a color variant of the same 500ml SPE/PEM hydrogen water bottle with a handle grip and claimed 9,970 ppb H2 output. All device-level assessment (see the Brown SKU write-up) applies identically: hardware and technology are legitimate, the evidence base for hydrogen water is emerging with small RCTs on oxidative stress and recovery but no large outcome trials, and the closest Vyvata subcategory (contrast_therapy) is a proxy for a modality that does not have a native taxonomic home in our five verticals. Standard tier reflects real-hardware + emerging-evidence + reasonable claims. Would move toward Verified with SKU-specific published third-party hydrogen-concentration verification and battery/electrode-longevity documentation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "piurify-hydrogenator®-hydrogen-water-bottle-pink",
      "title": "PIURIFY Hydrogenator® Hydrogen Water Bottle - Pink",
      "vendor": "Piurify",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/piurify-champagnecopy2.png?v=1788487856",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "piurify",
        "hydrogenator",
        "hydrogen",
        "water",
        "bottle",
        "pink",
        "piurify"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "contrast_therapy"
      ],
      "vsf_dimensions": {
        "analytical_validity": 55,
        "clinical_utility": 50,
        "transparency": 58,
        "build_quality": 60,
        "warranty_support": 58,
        "value": 55
      },
      "price": 129.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46859260362949",
      "vsf_explanation": "PIURIFY Hydrogenator Hydrogen Water Bottle (Pink) is a color variant in Piurify's standard hydrogen-water-bottle line using SPE/PEM electrolysis. The product description reviewed leans harder on marketing language ('versatile and adaptable solution,' 'active natural antioxidant hydrogen molecules') and lighter on specific technical claims than the flask and handle variants — no specific ppb concentration, battery capacity, or third-party certification is stated in the description reviewed. Same category fit and emerging-evidence caveats as the rest of the line: fringe modality with small-RCT evidence for oxidative stress and recovery, no large outcome trials, and no native taxonomic home in Vyvata's five verticals (contrast_therapy is used as the closest proxy). Scores Standard on the strength of the underlying technology and brand consistency, with a slightly lower transparency score reflecting the thinner spec disclosure on this specific SKU description. Buyers should confirm the ppb concentration and warranty terms on the product page before purchase.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "piurify-hydrogenator®-hydrogen-water-bottle-black",
      "title": "PIURIFY Hydrogenator® Hydrogen Water Bottle - Black",
      "vendor": "Piurify",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/piurify-blackcopy2.png?v=1788487855",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "piurify",
        "hydrogenator",
        "hydrogen",
        "water",
        "bottle",
        "black",
        "piurify"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "contrast_therapy"
      ],
      "vsf_dimensions": {
        "analytical_validity": 55,
        "clinical_utility": 50,
        "transparency": 58,
        "build_quality": 60,
        "warranty_support": 58,
        "value": 55
      },
      "price": 129.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46859260297413",
      "vsf_explanation": "PIURIFY Hydrogenator Hydrogen Water Bottle (Black) is a color variant of the base water-bottle line in Piurify's SPE/PEM hydrogen-water range. Description text is essentially identical to the Pink variant and lighter on specific technical claims than the flask and handle SKUs. Same category-fit and evidence caveats apply: hydrogen water is a fringe modality with emerging small-RCT data on oxidative stress and post-exercise recovery, no large clinical outcome trials, and no native taxonomic home in Vyvata's five verticals (contrast_therapy is a proxy). Scores Standard on the underlying technology being real and the brand being consistent; transparency subscore reflects the thinner spec disclosure on the water-bottle line versus the flask.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "piurify-hydrogenator®-hydrogen-water-bottle-turquoise",
      "title": "PIURIFY Hydrogenator® Hydrogen Water Bottle - Turquoise",
      "vendor": "Piurify",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/piurify-tealcopy2.png?v=1788487856",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "piurify",
        "hydrogenator",
        "hydrogen",
        "water",
        "bottle",
        "turquoise",
        "piurify"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "contrast_therapy"
      ],
      "vsf_dimensions": {
        "analytical_validity": 55,
        "clinical_utility": 50,
        "transparency": 58,
        "build_quality": 60,
        "warranty_support": 58,
        "value": 55
      },
      "price": 129.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46859260428485",
      "vsf_explanation": "PIURIFY Hydrogenator Hydrogen Water Bottle (Turquoise) is a color variant of Piurify's base SPE/PEM hydrogen-water bottle line. Product description reviewed matches the other base color variants: general marketing language about 'active natural antioxidant hydrogen molecules,' no specific ppb concentration or battery specification stated at this listing level. All device-level and evidence-base observations from the Black/Pink/Silver variants apply identically. Standard tier reflects the underlying technology being legitimate SPE/PEM and the brand being consistent, with transparency subscore reflecting thinner spec disclosure on the base water-bottle line than on the flask.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "piurify-hydrogenator®-hydrogen-water-bottle-silver",
      "title": "PIURIFY Hydrogenator® Hydrogen Water Bottle - Silver",
      "vendor": "Piurify",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/piurify-silvercopy2.png?v=1788487856",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "piurify",
        "hydrogenator",
        "hydrogen",
        "water",
        "bottle",
        "silver",
        "piurify"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "contrast_therapy"
      ],
      "vsf_dimensions": {
        "analytical_validity": 55,
        "clinical_utility": 50,
        "transparency": 58,
        "build_quality": 60,
        "warranty_support": 58,
        "value": 55
      },
      "price": 129.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46859260395717",
      "vsf_explanation": "PIURIFY Hydrogenator Hydrogen Water Bottle (Silver) is another color variant of Piurify's base SPE/PEM hydrogen-water bottle. Product description reviewed uses the same generic marketing template as the Black/Pink/Turquoise variants and does not add SKU-specific technical claims. Standard tier for the same reasons: real underlying electrolysis technology, plausible mechanism, thin-but-not-empty evidence base for oxidative stress and recovery, no native Vyvata taxonomy home. Buyers should verify specific ppb, battery, and warranty details on the current Piurify product page rather than relying on the base-line description.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hydrogenator®-flask-black",
      "title": "Hydrogenator® Flask - Black",
      "vendor": "Piurify",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/FlaskMainimageNoBackground.jpg?v=1788487855",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hydrogenator",
        "flask",
        "black",
        "piurify"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "contrast_therapy"
      ],
      "vsf_dimensions": {
        "analytical_validity": 55,
        "clinical_utility": 52,
        "transparency": 62,
        "build_quality": 65,
        "warranty_support": 68,
        "value": 55
      },
      "price": 199.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46859260461253",
      "vsf_explanation": "The Piurify Hydrogenator Flask (Black) is the color variant of the same SPE/PEM hydrogen water flask reviewed under the Blue SKU, with the same claimed engineered-for-maximum-concentration positioning and BPA-free construction. The description reviewed for this SKU is thin ('Engineered for maximum hydrogen concentration, longer battery performance, and premium BPA-free materials'), but Piurify's flask line consistently claims ~8,630 ppb maximum concentration and a lifetime warranty across colors. Same category fit and evidence-base observations as the rest of the Piurify line apply. Standard tier on real hardware + emerging-evidence + reasonable claims. The flask form factor scores marginally higher than the base water-bottle variants because Piurify's flask line publishes more specific technical spec (concentration, battery, warranty) than the base water-bottle line does.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bestby10-25-ehp-labs-oxygreens-super-greens-powder-30-serve-strawberry-margarita",
      "title": "BestBy10/25 EHP Labs OxyGreens Super Greens Powder 30 Serve Strawberry Margarita",
      "vendor": "Deal US",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/open-uri20251113-282306-er8p6w.jpg?v=1788736793",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bestby10",
        "ehp",
        "labs",
        "oxygreens",
        "super",
        "greens",
        "powder",
        "serve",
        "strawberry",
        "margarita",
        "deal"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 20,
        "transparency": 30,
        "sustainability": 35
      },
      "price": 19.65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873042813125",
      "vsf_explanation": "This is a discounted-inventory listing of EHP Labs' OxyGreens greens powder in Strawberry Margarita, and the title itself discloses the disqualifying fact: \"BestBy10/25\" — best-by date October 2025. Today is September 2026, which puts this SKU eleven months past its best-by date. Manufacturers set best-by dates on probiotic-, enzyme-, and antioxidant-containing powders because the biological activity of those inputs declines predictably after that window; a greens powder eleven months out is likely to be delivering a substantially diminished version of its label claim, particularly for the heat- and moisture-sensitive fruit and vegetable extracts and any live-culture or enzyme components. EHP Labs itself is a legitimate Australian sports-nutrition brand with a real product line, and a fresh unit of OxyGreens would score in the Standard tier as a mid-tier greens powder with a partially transparent formulation. But an expired-inventory sale ships a product the manufacturer explicitly says is past the point where they will stand behind its potency. This is a `safety_concern` auto-fail — not because the powder is likely to make anyone acutely ill, but because Vyvata will not list nutraceuticals that are past their best-by date at time of sale. The listing itself is the disclosure of the disqualifying fact.",
      "vsf_autofail_rule": "safety_concern"
    },
    {
      "handle": "super-greens",
      "title": "Super Greens",
      "vendor": "Be Amazing",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/DoleOrangePeachMangoGreensBeAmazing.png?v=1788736801",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "super",
        "greens",
        "amazing"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 30,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 25,
        "sustainability": 50
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873042911429",
      "vsf_explanation": "Product title is a generic single-phrase name ('Super Greens') with no body content, no ingredient list, no dosing, no manufacturer transparency at the title level. Autofail under misleading_naming — a generic wellness-category name with no differentiation and no disclosed formulation. Vyvata does not list products whose only identifying information is a category label. If Be Amazing is a real brand with a substantial product page elsewhere, it needs to be reflected in the Shopify listing to be evaluable.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "wilderness-poets-organic-alkalizing-super-greens-3-5oz",
      "title": "Wilderness Poets - Organic Alkalizing Super Greens (3.5OZ)",
      "vendor": "The Epicurean Trader",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0b710d932712020e0487ada05e675351.jpg?v=1788736817",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wilderness",
        "poets",
        "organic",
        "alkalizing",
        "super",
        "greens",
        "5oz",
        "the",
        "epicurean",
        "trader"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 48,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 13,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873043239109",
      "vsf_explanation": "Wilderness Poets Organic Alkalizing Super Greens is positioned with marketing framing including \"Balance, flush out toxins and support your immunity...naturally detoxifying, energizing benefits.\" The phrases \"flush out toxins\" and \"naturally detoxifying\" are explicit detox/cleanse claims — autofail under unverified_medical_claim. The 'alkalizing' framing compounds the problem (alkaline diet claims lack RCT support for the health outcomes commonly claimed). Rejected — the ingredient class of dried greens can be reasonable, but the marketing is autofail-triggering.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "organic-tropics-raw-greens-micronutrient-powders",
      "title": "Organic Tropics & Raw Greens Micronutrient Powders",
      "vendor": "Pure Choice Farms",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/organic-tropics-raw-greens-micronutrient-powders-7520147.png?v=1788736827",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "tropics",
        "raw",
        "greens",
        "micronutrient",
        "powders",
        "pure",
        "choice",
        "farms"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 55,
        "sustainability": 65
      },
      "price": 97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873043501253",
      "vsf_explanation": "Combo pack of tropical fruit + greens micronutrient powders — same marketing package as Pure Choice Farms' Sweet Greens combo, with the same over-inflated '3000+ antioxidants' and '325% vitamin C' claims. Freeze-dried format is a legitimate plus. Standard tier at the lower end.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-greens-lg",
      "title": "PURE GREENS LG",
      "vendor": "Pure Green",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Pure-Greens-Lemon-Ginger-scaled.webp?v=1788736845",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "greens",
        "pure",
        "green"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 62,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 8.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873043796165",
      "vsf_explanation": "Cold-pressed lemon-ginger green juice — lighter blend with fewer sweeter fruits than Pure Greens Apple. Lower-sugar option in the line. Real cold-pressed greens content plus ginger and lemon. Standard tier for a well-executed lower-sugar green juice.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "heartbeet-shot",
      "title": "HEARTBEET SHOT",
      "vendor": "Pure Green",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Heartbeet_Shot.jpg?v=1788736852",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "heartbeet",
        "shot",
        "pure",
        "green"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 65,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 4.25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873044058309",
      "vsf_explanation": "2oz concentrated cold-pressed beet root shot. Beet juice dietary nitrates have strong evidence base for blood pressure (Siervo 2013 meta-analysis) and exercise performance (Domínguez 2017). A concentrated 2oz shot from whole beet delivers meaningful nitrate — depending on beet concentration, likely 300-600 mg nitrate, in the range of clinical trial protocols (400-800 mg for BP effect). Higher-end Standard for an evidence-supported ingredient in a convenient delivery format.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-watermelon",
      "title": "PURE WATERMELON",
      "vendor": "Pure Green",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Pure-Watermelon-scaled.webp?v=1788736883",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "watermelon",
        "pure",
        "green"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 8.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873044287685",
      "vsf_explanation": "Cold-pressed watermelon juice with a touch of lemon. Simple, honest two-ingredient formulation. Watermelon is naturally rich in L-citrulline — real evidence for nitric-oxide-mediated blood pressure and mild exercise-performance effects (Figueroa 2017 for BP, Bailey 2015 for exercise). A 16oz serving of cold-pressed watermelon delivers meaningful citrulline (roughly 1-2 g typical), which is in the range of clinical trial protocols (3-6 g/day for BP effects). Standard tier — real evidence, real product, expensive per-serving vs eating watermelon.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-greens-apple",
      "title": "PURE GREENS APPLE",
      "vendor": "Pure Green",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Pure-Greens-A-scaled.webp?v=1788736883",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "greens",
        "apple",
        "pure",
        "green"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 60,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 8.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873044353221",
      "vsf_explanation": "Cold-pressed apple + leafy greens juice. Delivers real vegetable and fruit micronutrients with the palatability boost of apple. Cold-pressing preserves heat-sensitive nutrients. Standard tier for a well-executed entry-level green juice — no autofail, no evidence-graded therapeutic claim.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "soul-kick",
      "title": "SOUL KICK",
      "vendor": "Pure Green",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Soul-Kick-scaled.webp?v=1788736884",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "soul",
        "kick",
        "pure",
        "green"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 60,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 8.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873044418757",
      "vsf_explanation": "Cold-pressed citrus (orange, lemon) with cayenne. Delivers real vitamin C and modest thermogenic effect from capsaicin. Cayenne has some evidence for mild metabolic and appetite effects (Whiting 2014 systematic review). Standard tier for a defensible citrus-forward cold-pressed juice.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-gingerade",
      "title": "PURE GINGERADE",
      "vendor": "Pure Green",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Pure-Gingerade-scaled.webp?v=1788736884",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "gingerade",
        "pure",
        "green"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 8.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873044484293",
      "vsf_explanation": "Cold-pressed ginger + lemon juice. Ginger has one of the stronger RCT evidence bases in herbal supplements — nausea, digestion, mild anti-inflammatory (Nikkhah Bodagh 2019, Marx 2015). Cold-pressed fresh ginger delivers gingerol/shogaol at meaningful doses per serving. Standard tier for a well-supported ingredient in an honest juice format.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "rockin-beet",
      "title": "ROCKIN BEET",
      "vendor": "Pure Green",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Rockin-Beet-scaled.webp?v=1788736884",
      "score": 67,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "rockin",
        "beet",
        "pure",
        "green"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 65,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 8.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873044549829",
      "vsf_explanation": "Cold-pressed beet juice. Beet juice has one of the strongest evidence bases in sports nutrition — meta-analyses show meaningful blood pressure reductions (Siervo 2013, Bahadoran 2017) and modest exercise performance improvements at 400-800 mg dietary nitrate (roughly 250-500 mL beet juice). A 16oz serving of concentrated cold-pressed beet delivers a clinical-relevant nitrate dose. Cold-pressing preserves nitrates better than heat processing. Higher end of Standard — real evidence, real dose, real product.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "melon-hydr8",
      "title": "MELON HYDR8",
      "vendor": "Pure Green",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Melon-Hydr8-scaled.webp?v=1788736884",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "melon",
        "hydr8",
        "pure",
        "green"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 60,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 8.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873044680901",
      "vsf_explanation": "Cold-pressed melon hydration juice. Fresh melons deliver water, natural sugars, potassium, and some vitamin C. Marketing framing (\"replenish at the cellular level\") is generic; the actual product is just cold-pressed melon juice. Standard tier for an honest, well-executed single-fruit juice.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "grape-hydr8",
      "title": "GRAPE HYDR8",
      "vendor": "Pure Green",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Grape_Hydr8.jpg?v=1788736884",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "grape",
        "hydr8",
        "pure",
        "green"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 60,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 8.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873045139653",
      "vsf_explanation": "Cold-pressed grape juice — naturally rich in resveratrol, quercetin, and grape polyphenols. Grape polyphenols have modest cardiovascular RCT support (endothelial function, LDL oxidation). Sugar content is significant. Standard tier for a legitimately polyphenol-rich cold-pressed juice.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-greens-alg",
      "title": "PURE GREENS ALG",
      "vendor": "Pure Green",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Pure-Greens-Apple-Lemon-Ginger-scaled.webp?v=1788736884",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "greens",
        "alg",
        "pure",
        "green"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 65,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 8.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873044746437",
      "vsf_explanation": "Cold-pressed 11-green juice blend including spinach, kale, and romaine. Real vegetable micronutrients in a clean-label format. HPP preservation maintains vitamin C and polyphenols. Standard tier, high end — for people who won't eat vegetables reliably, this is a real delivery format.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "immunity-shot",
      "title": "IMMUNITY SHOT",
      "vendor": "Pure Green",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Immunity_Shot.jpg?v=1788736883",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "immunity",
        "shot",
        "pure",
        "green"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 4.25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873044811973",
      "vsf_explanation": "2oz concentrated cold-pressed ginger + lemon shot. Ginger has strong RCT support; lemon delivers vitamin C. Concentrated 2oz format delivers meaningful active-compound doses in a small volume. Standard tier for a well-formulated single-purpose wellness shot.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "turmeric-tonic-shot",
      "title": "TURMERIC TONIC SHOT",
      "vendor": "Pure Green",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Turmeric_Tonic_Shot.jpg?v=1788736883",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "turmeric",
        "tonic",
        "shot",
        "pure",
        "green"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 4.25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873044615365",
      "vsf_explanation": "2oz cold-pressed turmeric + ginger + black pepper shot. Piperine (from black pepper) is the well-documented curcumin bioavailability enhancer — Shoba 1998 showed 2000% increase in curcumin AUC with piperine. Product formulation explicitly acknowledges this. Real curcumin bioavailability formulation via a real cold-pressed juice format. Higher-end Standard for a well-engineered functional shot.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "wake-me-up-shot",
      "title": "WAKE ME UP SHOT",
      "vendor": "Pure Green",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Wake_Me_Up_Shot.jpg?v=1788736884",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wake",
        "shot",
        "pure",
        "green"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 60,
        "manufacturing": 68,
        "safety": 70,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 4.25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873044943045",
      "vsf_explanation": "2oz cold-pressed ginger + lemon + cayenne energy shot. Thermogenic effect from capsaicin is real but modest (Whiting 2014); the 'jitter-free energy' framing is more perceived-warmth than sustained-alertness. No caffeine. Standard tier — pleasant, honest, but the energy claim is limited to a warming thermogenic bump, not caffeine-equivalent alertness.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "green-boost-shot",
      "title": "GREEN BOOST SHOT",
      "vendor": "Pure Green",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Green_Boost_Shot.jpg?v=1788736883",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "green",
        "boost",
        "shot",
        "pure",
        "green"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 62,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 4.25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873044877509",
      "vsf_explanation": "2oz cold-pressed spirulina + leafy greens concentrate. Spirulina has meaningful evidence for lipid profile and modest blood pressure effects at 4-8 g/day (Serban 2016 meta-analysis). Per-shot spirulina content isn't disclosed; likely 500-1500 mg based on typical shot formulations, below the clinical-trial doses. Standard tier for a concentrated greens shot.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "active-charcoal",
      "title": "ACTIVE CHARCOAL",
      "vendor": "Pure Green",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Active-Charcoal-scaled.webp?v=1788736884",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "active",
        "charcoal",
        "pure",
        "green"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 50,
        "manufacturing": 62,
        "safety": 42,
        "transparency": 62,
        "sustainability": 55
      },
      "price": 8.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873045008581",
      "vsf_explanation": "Cold-pressed juice featuring activated charcoal and lemon. Marketing positions it explicitly as a \"cleanse-day\" and \"reset\" juice — this is a detox/cleanse claim triggering autofail under unverified_medical_claim. Activated charcoal is a real substance used clinically for acute poisoning (single-dose 25-100 g in emergency medicine); general-population daily-use \"cleanse\" application has no supporting RCT evidence and carries a real interaction problem: charcoal is highly non-selective and binds oral medications, vitamins, and nutrients along with any 'toxins.' Cochrane reviews of activated charcoal for detoxification outside acute poisoning show no meaningful benefit. Rejected under unverified_medical_claim.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "wake-up-call",
      "title": "WAKE UP CALL",
      "vendor": "Pure Green",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Wake-Up-Call-scaled.webp?v=1788736884",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wake",
        "call",
        "pure",
        "green"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 60,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 8.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873045074117",
      "vsf_explanation": "16oz cold-pressed apple + ginger + cayenne juice. Fruit-sugar-driven energy with warming cayenne thermogenic effect. No caffeine. Legitimate, honest, but the 'sustained energy' claim is really 'natural fruit sugar plus warmth' — not a caffeine or ergogenic-equivalent effect. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "coconut-hydrate",
      "title": "COCONUT HYDRATE",
      "vendor": "Pure Green",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Coconut-Hydr8-scaled.webp?v=1788736883",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "coconut",
        "hydrate",
        "pure",
        "green"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 65,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 75,
        "sustainability": 55
      },
      "price": 8.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873045205189",
      "vsf_explanation": "Cold-pressed coconut water hydration. Coconut water is a genuine natural electrolyte source (potassium, magnesium, modest sodium). Real hydration value; nothing artificial added. Kalman 2012 compared coconut water to sports drinks and found broadly comparable rehydration performance. Standard tier for a clean, honestly-marketed hydration product.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "golden-girl",
      "title": "GOLDEN GIRL",
      "vendor": "Pure Green",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Golden-Girl-scaled.webp?v=1788736884",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "golden",
        "girl",
        "pure",
        "green"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 70,
        "sustainability": 55
      },
      "price": 8.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873045270725",
      "vsf_explanation": "16oz cold-pressed turmeric + lemon + ginger juice. Same active ingredients as the Turmeric Tonic Shot but at more dilute concentration without published piperine (black pepper) co-formulation. Real anti-inflammatory pedigree from ginger + turmeric. Standard tier for a well-formulated cold-pressed anti-inflammatory beverage.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "blue-biotic-shot",
      "title": "BLUE BIOTIC SHOT",
      "vendor": "Pure Green",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Blue-Biotic_Shot.jpg?v=1788736899",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "blue",
        "biotic",
        "shot",
        "pure",
        "green"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 62,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 4.25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873045434565",
      "vsf_explanation": "Pure Green is a real cold-pressed juice brand. This 2oz HPP cold-pressed shot combines blue spirulina (phycocyanin), probiotic cultures, and cold-pressed greens. Blue spirulina/phycocyanin has emerging in-vitro and small-human antioxidant evidence. Probiotic viability in HPP cold-pressed juice depends on the strains used and storage temperature — CFU count and strain identity aren't published at title level. Cold-pressed juice format is expensive per serving. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-powdered-superfood-greens",
      "title": "Organic Powdered Superfood Greens",
      "vendor": "Pure Choice Farms",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/OrganicSweetGreens_1.png?v=1788736924",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "powdered",
        "superfood",
        "greens",
        "pure",
        "choice",
        "farms"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 55,
        "sustainability": 65
      },
      "price": 55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873046319301",
      "vsf_explanation": "Freeze-dried greens powder with '6 organic plants' and 'over 300 essential nutrients' claim. The '300 nutrients' phrasing is over-marketed; humans have ~40 essential nutrients, and 'phytonutrients' as a category doesn't have an evidence-graded count. Freeze-drying is a legitimate preservation method. Standard tier — a defensible small-ingredient greens powder with over-inflated micronutrient marketing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "moringa-super-greens-superfood-gummies",
      "title": "Moringa & Super Greens Superfood Gummies",
      "vendor": "Kuli Kuli Foods",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/KK_Gummies_GreenApple_FRONT_5.png?v=1788736945",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "moringa",
        "super",
        "greens",
        "superfood",
        "gummies",
        "kuli",
        "kuli",
        "foods"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 68,
        "safety": 72,
        "transparency": 68,
        "sustainability": 75
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873046843589",
      "vsf_explanation": "Kuli Kuli is a real moringa-focused brand founded by Peace Corps volunteers to support West African moringa farming. Moringa (Moringa oleifera) has emerging clinical evidence for glycemic control (Kou 2018 review) and lipid profile improvement (Coppin 2013). Gummy format inherently limits per-serving active dose vs powder or capsule extracts. Sustainability and provenance mission are legitimate strengths. Standard tier for a real-mission brand with a modest-dose gummy delivery format.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "purivibe-chlorophyll-lemon-juice-shots",
      "title": "PuriVibe Chlorophyll & Lemon Juice Shots",
      "vendor": "VAS Exclusive",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/02-Hero_17277717-bde3-49bc-9f42-6c69ffa7acab.jpg?v=1788736964",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "purivibe",
        "chlorophyll",
        "lemon",
        "juice",
        "shots",
        "vas",
        "exclusive"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 40,
        "sustainability": 55
      },
      "price": 26.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873047433413",
      "vsf_explanation": "PuriVibe Chlorophyll & Lemon Juice Shots are marketed explicitly with 'DAILY DETOX & BODY ODOR SUPPORT,' 'natural detoxification,' and 'gentle cleansing' language in the description reviewed. That framing crosses the line from DSHEA structure-function into unverified-medical-claim territory: no oral supplement — chlorophyll included — has cleared the FDA/EMA evidentiary bar for a general-population 'detoxifying the body' claim, and Cochrane and NIH NCCIH reviews of commercial detox products have consistently found either no rigorous human trials or no meaningful benefit over placebo. Chlorophyllin (the semisynthetic water-soluble form used in most 'liquid chlorophyll' shots) does have a small legitimate evidence base for topical wound healing and for a modest deodorant effect on colostomy odor (Howard 1980s literature), but the general-population 'detox' and 'internal freshness' claims are not supported. Auto-failed under unverified_medical_claim. Would become listable at Standard tier with the detox/cleanse language removed, honest positioning around chlorophyllin's actual evidence (limited deodorant effect, antioxidant polyphenol content of lemon juice), and full Supplement Facts disclosure.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "purivibe-pineapple-ginger-shots",
      "title": "PuriVibe Pineapple Ginger Shots",
      "vendor": "VAS Exclusive",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/03-Hero_30_Pack_1.jpg?v=1788736969",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "purivibe",
        "pineapple",
        "ginger",
        "shots",
        "vas",
        "exclusive"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 55,
        "safety": 70,
        "transparency": 55,
        "sustainability": 60
      },
      "price": 27.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873047498949",
      "vsf_explanation": "PuriVibe Pineapple Ginger Shots are a whole-food functional-shot format built around ginger juice, turmeric juice, pineapple juice, acerola cherry (Vitamin C), and coconut water. The underlying ingredients each carry legitimate structure-function evidence: ginger has meta-analysed data for post-exercise soreness and nausea relief, turmeric/curcumin has decades of literature on inflammation-marker modulation (though bioavailability is a known limitation without piperine or lipid delivery), acerola is a dense natural Vitamin C source, and coconut water is a real potassium-plus-sodium hydration base. The product avoids the two claim-side landmines that would autofail similar shots — no explicit 'detox' or 'cleanse' language in the description reviewed — and marketing sticks to DSHEA-compatible structure-function language ('digestive support,' 'immune support'). Weaknesses are transparency-side: milligrams of each juice per serving, curcumin standardization percentage, and Vitamin C content per serving are not clearly disclosed at the title level, and there is no published third-party COA. Manufacturing facility (FDA-registered, cGMP status) is also not clearly documented. Sits comfortably in Standard on formulation merit as a real functional-shot product; would move toward Verified with a full quantitative Supplement Facts panel, curcumin standardization disclosure, and a published lab COA.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "force-factor®-smarter-greens™-summer-berry-soft-chews",
      "title": "Force Factor® Smarter Greens™ – Summer Berry – Soft Chews",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/97160710.jpg?v=1788736973",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "force",
        "factor",
        "smarter",
        "greens",
        "summer",
        "berry",
        "soft",
        "chews",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 40,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 30,
        "sustainability": 45
      },
      "price": 21.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873047564485",
      "vsf_explanation": "Force Factor is a real DTC brand (owned by ProSupps) with retail distribution at GNC and Walgreens, so provenance is not the problem. The problem is the format. \"Smarter Greens Soft Chews\" packages a claimed 25+ fruit, vegetable, and superfood blend into two small strawberry-flavored gummy-style chews, and the published Supplement Facts panel lists that whole botanical inventory as a single proprietary \"Fruit & Vegetable Blend\" totaling ~1.6 g per serving — the individual milligrams of spirulina, spinach, kale, wheatgrass, beet, broccoli, blueberry, and every other ingredient are not disclosed. At roughly 1.6 g total across 25+ inputs, no single greens ingredient can be present at a dose that matches any published research (a typical greens-powder serving is 8-12 g). The soft-chew delivery format also carries added sugar and gelatin bulk that displaces active-ingredient mass. This is `proprietary_blend_hides_dose` in textbook form: the label lets the marketing claim \"a complete blend of over 25 fruits, vegetables, and superfoods\" while hiding whether any of them is present at more than a dusting. Vyvata cannot verify that any nutritional benefit is delivered from a proprietary blend at this total mass, and cannot list the product until per-ingredient milligrams are published.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "alpha-green-packs-premium-green-juice-and-superfood-blend",
      "title": "Alpha Green Packs - Premium Green Juice and Superfood Blend",
      "vendor": "Organic Pharmer",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/A25C57DB-9611-4BFD-97EB-1D541A146B40.jpg?v=1788736985",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alpha",
        "green",
        "packs",
        "premium",
        "green",
        "juice",
        "and",
        "superfood",
        "blend",
        "organic",
        "pharmer"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 62,
        "manufacturing": 65,
        "safety": 72,
        "transparency": 65,
        "sustainability": 65
      },
      "price": 65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873047630021",
      "vsf_explanation": "Greens blend from Organic Pharmer, highly relevant to the AG1-alternatives conversation. Evaluated in that context: a defensible greens product should list its ingredients with reasonable dosing rather than pack 75+ ingredients at homeopathic amounts. This product's specific per-serving ingredient dosing isn't published at title level. Standard tier — a legitimate plant-based greens blend positioned honestly, without the extreme dose-inflation of AG1's 75-ingredient blend.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "fitness-trainer-protein-shake-packs-plant-based-nutrition",
      "title": "Fitness Trainer Protein Shake Packs - Plant-Based Nutrition",
      "vendor": "Organic Pharmer",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4467E2D9-94D9-492E-B3C4-E6E3A1FC97B2.jpg?v=1788737001",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fitness",
        "trainer",
        "protein",
        "shake",
        "packs",
        "plant",
        "based",
        "nutrition",
        "organic",
        "pharmer"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 65,
        "safety": 72,
        "transparency": 62,
        "sustainability": 65
      },
      "price": 55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873047793861",
      "vsf_explanation": "Plant-based chocolate protein shake for active users. Similar profile to the Marathon pack: legitimate plant-based formulation with undisclosed per-serving protein grams. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "defense-protein-shake-packs-wellness-boosters",
      "title": "Defense+ Protein Shake Packs - Wellness Boosters",
      "vendor": "Organic Pharmer",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/defense_bottle_shot.jpg?v=1788737001",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "defense",
        "protein",
        "shake",
        "packs",
        "wellness",
        "boosters",
        "organic",
        "pharmer"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 60,
        "manufacturing": 65,
        "safety": 72,
        "transparency": 60,
        "sustainability": 65
      },
      "price": 55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873047924933",
      "vsf_explanation": "Plant-based protein shake with immune-forward framing (\"Fuel Your Inner Warrior\"). Product positioning is generic-immunity marketing; specific immune-active ingredients and dosing aren't highlighted at title level. Real brand, real plant-protein base. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "relax-botanical-beverage-packs-calming-stress-relief",
      "title": "Relax Botanical Beverage Packs - Calming & Stress Relief",
      "vendor": "Organic Pharmer",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/D7D20ACA-DC2E-4EEB-8A82-CF18EDFAF24A.jpg?v=1788737006",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "relax",
        "botanical",
        "beverage",
        "packs",
        "calming",
        "stress",
        "relief",
        "organic",
        "pharmer"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 65,
        "sustainability": 62
      },
      "price": 50,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873048088773",
      "vsf_explanation": "Plant-based beverage pack featuring lavender, chamomile, and lemon balm — all traditional calming botanicals with modest RCT support (chamomile Amsterdam 2016 for GAD; lemon balm Cases 2011 for stress). Organic Pharmer is a legitimate DTC plant-based brand. Per-serving standardized dosing of the calming botanicals isn't disclosed; this is a functional beverage, not a metered supplement. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "happy-gut-botanical-beverage-pack-promote-digestive-wellness",
      "title": "Happy Gut Botanical Beverage Pack - Promote Digestive Wellness",
      "vendor": "Organic Pharmer",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/A8E3A4C4-920C-45EF-82C9-2960A1105385.jpg?v=1788737006",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "happy",
        "gut",
        "botanical",
        "beverage",
        "pack",
        "promote",
        "digestive",
        "wellness",
        "organic",
        "pharmer"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 65,
        "sustainability": 62
      },
      "price": 55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873048219845",
      "vsf_explanation": "Plant-based digestive-wellness beverage from Organic Pharmer. Ingredient class includes traditional digestive herbs, fruits, and seeds — the specific components have varying levels of clinical support. Functional beverage format, honestly positioned, real DTC brand. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "marathon-protein-shake-packs-enhance-endurance-and-performance",
      "title": "Marathon Protein Shake Packs: Enhance Endurance and Performance",
      "vendor": "Organic Pharmer",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/A0079FF9-5ABB-4811-B3CC-DF467F54E61A.jpg?v=1788737007",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "marathon",
        "protein",
        "shake",
        "packs",
        "enhance",
        "endurance",
        "and",
        "performance",
        "organic",
        "pharmer"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 65,
        "safety": 72,
        "transparency": 62,
        "sustainability": 65
      },
      "price": 55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873048350917",
      "vsf_explanation": "Plant-based protein shake pack with greens and botanical infusion. Plant protein blends (pea, hemp, brown rice) can deliver a complete amino acid profile if formulated correctly — per-scoop protein grams and specific protein sources aren't disclosed at title level. Endurance/performance framing is generic; no specific ergogenic ingredient (beta-alanine, creatine, beetroot) is highlighted. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sweet-greens-organic-tropics",
      "title": "Sweet Greens & Organic Tropics",
      "vendor": "Pure Choice Farms",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/sweet-greens-organic-tropics-1957533.png?v=1788737061",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sweet",
        "greens",
        "organic",
        "tropics",
        "pure",
        "choice",
        "farms"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 55,
        "sustainability": 65
      },
      "price": 97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873050022085",
      "vsf_explanation": "Greens combo pack from Pure Choice Farms. Description leans on inflated marketing metrics (\"3000+ Powerful Antioxidants,\" \"325% Vitamin C\") without qualifying context — antioxidant counts of that magnitude aren't a meaningful supplement metric (units like ORAC are contested and not health-outcome-graded). Freeze-dried powder format from organic sources is a genuine plus for nutrient retention. Per-ingredient dosing and full label transparency at the title level are limited. Low-end Standard for a defensible plant-source product with over-marketed metrics.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "green-energy",
      "title": "Green Energy",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/green_energy_coffee_and_cacao.jpg?v=1788737103",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "green",
        "energy",
        "kauai",
        "farmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 58,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 62,
        "sustainability": 78
      },
      "price": 50,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873050448069",
      "vsf_explanation": "\"Superfood coffee\" — a plant-protein greens blend with cacao, positioned as an alkalizing, energizing beverage. Marketing leans on \"pure mana of Kauai\" mystical framing and \"alkalizing\" concepts (the alkaline diet has minimal RCT support for the health claims commonly made for it). Ingredients are farm-grown greens including katuk — a well-provenanced source. Per-scoop protein and micronutrient content aren't published. Standard tier because ingredient quality and provenance are real, but claims lean on unverified concepts and dosing is not disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "wellness-tea",
      "title": "Wellness Tea",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2ozwellness_05e343c7-65e3-4219-8210-7bd9bf2be428.jpg?v=1788737170",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wellness",
        "tea",
        "kauai",
        "farmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 68,
        "sustainability": 78
      },
      "price": 32,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873050874053",
      "vsf_explanation": "Herbal tea blend built around noni leaf with supporting antioxidant-rich Kauai-grown herbs. Noni has some emerging clinical characterization; other typical blend components (unspecified at title level) contribute traditional-use pedigree. Tea format, honestly positioned as a nourishing daily beverage. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "womens-wellness",
      "title": "Women's Wellness",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2oz-Women_sWellness-1600x_16da600e-5672-4a1e-b21b-897530c0a107.jpg?v=1788737174",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "women",
        "wellness",
        "kauai",
        "farmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 70,
        "sustainability": 78
      },
      "price": 32,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873050972357",
      "vsf_explanation": "Herbal tea blend for women's wellness, built around chaste berry (Vitex) with supporting herbs. Chaste berry has real RCT evidence (see chaste-berry tincture entry). Tea infusion delivers a variable, generally lower dose than standardized capsule extracts. Kauai-grown, ingredient identity disclosed. Standard tier for a well-provenanced traditional women's blend.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "allspice-honey",
      "title": "Allspice Honey",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/AllspiceHoneyproductphoto.jpg?v=1788737176",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "allspice",
        "honey",
        "kauai",
        "farmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 65,
        "sustainability": 78
      },
      "price": 28,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873051627717",
      "vsf_explanation": "Allspice (Pimenta dioica) infused into farm honey. Allspice essential oil contains eugenol (also in clove) with in-vitro antimicrobial and analgesic activity; human clinical evidence for oral or culinary allspice at food doses is limited. Culinary product, honestly positioned, Kauai-grown honey base. Standard tier for a functional-food-format spice honey.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "immunitea",
      "title": "Immunitea",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/immunitea1.jpg?v=1788737176",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "immunitea",
        "kauai",
        "farmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 68,
        "sustainability": 78
      },
      "price": 32,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873051103429",
      "vsf_explanation": "Herbal tea blend of loquat, soursop, ginger, and turmeric. Ginger and turmeric have solid ingredient-level evidence; loquat and soursop are traditional-use herbs with in-vitro antioxidant characterization but limited human RCT support. Tea format delivers variable, generally lower doses than standardized extracts. Kauai-grown, honest positioning as a daily wellness tea. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ginger-honey",
      "title": "Ginger Honey",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/GingerHoneymailchimp2.jpg?v=1788737175",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ginger",
        "honey",
        "kauai",
        "farmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 65,
        "sustainability": 78
      },
      "price": 25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873051070661",
      "vsf_explanation": "Ginger-infused Kauai honey. Ginger has strong evidence for nausea and adjunct anti-inflammatory effects (Nikkhah Bodagh 2019). Honey has meaningful cough-suppressant literature (Cochrane 2018). Combined as a functional culinary product, this is a well-supported traditional pantry item. Standard tier because the food-format dosing isn't metered like a supplement.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "comfrey-cast",
      "title": "Comfrey Cast",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ComfreyCastproductphoto.jpg?v=1788737175",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "comfrey",
        "cast",
        "kauai",
        "farmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 55,
        "transparency": 68,
        "sustainability": 78
      },
      "price": 95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873051136197",
      "vsf_explanation": "Comfrey (Symphytum officinale) root powder positioned for TOPICAL application (mix with water, apply to the body). Comfrey has RCT evidence for topical use (bruises, sprains, back pain — Kucera 2004, Grube 2007). Critical safety context: comfrey pyrrolizidine alkaloids (PAs) are hepatotoxic on oral ingestion, and root has higher PA content than leaf — the FDA and multiple regulators have effectively banned oral comfrey since 2001. Topical use on unbroken skin, short-term (<4-6 weeks), is considered acceptable per EMA and German Commission E monographs for PA-reduced preparations. Product is topical-only and positioned appropriately. Standard tier — well-supported traditional topical use, with real safety caveats that keep the safety dimension moderate. Pyrrolizidine-alkaloid safety note: comfrey is safe for external use only, on intact (unbroken) skin, and should not be used for more than 4-6 weeks continuously or during pregnancy/breastfeeding — it should never be ingested or applied to open wounds or broken skin.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitalitea",
      "title": "Vitalitea",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2ozvitalitea.jpg?v=1788737174",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitalitea",
        "kauai",
        "farmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 58,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 68,
        "sustainability": 78
      },
      "price": 30,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873051168965",
      "vsf_explanation": "Antioxidant-forward herbal tea blend featuring noni and other Kauai-grown botanicals, positioned for daily vitality and longevity. Noni (Morinda citrifolia) has been studied for antioxidant activity with mixed clinical evidence; a small number of trials show some markers move but no consistent longevity outcomes. Food-format herbal tea, honestly positioned, traceable farm provenance. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "turmeric-hydrosol",
      "title": "Turmeric Hydrosol",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/TurmericHydrosolProductPhoto.jpg?v=1788737176",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "turmeric",
        "hydrosol",
        "kauai",
        "farmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 65,
        "safety": 68,
        "transparency": 65,
        "sustainability": 78
      },
      "price": 28,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873051300037",
      "vsf_explanation": "Turmeric hydrosol — the aromatic water fraction of turmeric distillation for topical/facial use. Curcumin, turmeric's primary studied compound, is fat-soluble and largely absent from a water-fraction hydrosol; the hydrosol carries turmeric's aromatic volatile compounds (ar-turmerone and related). Topical use is traditional; limited controlled RCT evidence for turmeric hydrosol specifically. Standard tier for a niche traditional aromatic preparation from a real farm.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "endurance-powder",
      "title": "Endurance Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Enduranceproductshot.jpg?v=1788737174",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "endurance",
        "powder",
        "kauai",
        "farmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 60,
        "sustainability": 78
      },
      "price": 55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873051267269",
      "vsf_explanation": "Herbal powder built around ashwagandha and other supporting herbs, positioned for libido, stamina, and digestion. Ashwagandha has meaningful evidence for stress, testosterone (in stressed men), and sexual health at 300-600 mg/day standardized extract doses; per-serving withanolide content of this powder isn't disclosed, so dose-matching to RCT protocols isn't possible. Positioning language leans on \"life force\" framing but avoids explicit disease claims. Kauai-grown, small-batch. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "turmeric-tincture-1",
      "title": "Turmeric Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/TurmericTincture.jpg?v=1788737174",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "turmeric",
        "tincture",
        "kauai",
        "farmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 68,
        "sustainability": 78
      },
      "price": 30,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873051365573",
      "vsf_explanation": "Alcohol tincture of Kauai-grown turmeric rhizome. Turmeric's primary active curcumin has real anti-inflammatory evidence (Daily 2016 meta-analysis for osteoarthritis; Panahi 2016 for lipid effects) — but curcumin is fat-soluble and poorly absorbed. Alcohol tinctures extract some curcumin (alcohol is a decent solvent for it) but bioavailability from a tincture without lipid co-administration is modest. Kauai-grown, honestly positioned. Description mentions \"cleanse toxins\" — borderline framing but presented in a traditional-herbal context rather than as an autofail-worthy detox claim. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "brahmi-tincture-1",
      "title": "Brahmi Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BrahmiTincture.jpg?v=1788737174",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "brahmi",
        "tincture",
        "kauai",
        "farmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 58,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 68,
        "sustainability": 78
      },
      "price": 40,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873051332805",
      "vsf_explanation": "Alcohol tincture of Bacopa monnieri (brahmi). Bacopa has meaningful RCT evidence for cognitive support — improved memory acquisition and reduced anxiety at 300-450 mg/day standardized extract (typically 45-55% bacosides A+B) over 12+ weeks (Stough 2001, Calabrese 2008, Kongkeaw 2014 meta-analysis). This is a traditional alcohol tincture; per-mL bacoside content isn't published, so precise dose-matching to trial protocols isn't possible. Kauai-grown, honestly positioned. Higher-end Standard for a well-supported herb in a traditional format.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "tulsi-tea-blend",
      "title": "Tulsi Tea Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2oztulsiholybasil.jpg?v=1788737174",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tulsi",
        "tea",
        "blend",
        "kauai",
        "farmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 68,
        "sustainability": 78
      },
      "price": 35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873051463877",
      "vsf_explanation": "Herbal tea blend built around tulsi (Ocimum sanctum / holy basil). Tulsi has emerging clinical evidence for stress reduction, blood-glucose, and metabolic markers (Jamshidi 2017 systematic review). Tea format delivers variable, generally lower doses than standardized extracts. Kauai-grown, honestly positioned as a daily adaptogenic ritual. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "comfrey-noni-serum",
      "title": "Comfrey Noni Serum",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Comfrey_noni_Serum_new_bottle.jpg?v=1788737174",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "comfrey",
        "noni",
        "serum",
        "kauai",
        "farmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 60,
        "transparency": 65,
        "sustainability": 78
      },
      "price": 45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873051398341",
      "vsf_explanation": "Topical macadamia-oil serum infused with comfrey and noni for external skin use. Comfrey has real RCT evidence for topical use (bruises, sprains, joint pain — see Comfrey Salve entry). Noni topical evidence is thinner but the traditional Polynesian use has broad history. Topical only; comfrey pyrrolizidine alkaloid concerns are relevant even in topical form (short-term use on unbroken skin per EMA guidance). Kauai-grown, honestly positioned. Standard tier for a traditional topical from a real farm. Pyrrolizidine-alkaloid safety note: comfrey is safe for external use only, on intact (unbroken) skin, and should not be used for more than 4-6 weeks continuously or during pregnancy/breastfeeding — it should never be ingested or applied to open wounds or broken skin.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "curry-blend",
      "title": "Curry Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CurryBlendupdated.jpg?v=1788737175",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "curry",
        "blend",
        "kauai",
        "farmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 68,
        "sustainability": 78
      },
      "price": 50,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873051562181",
      "vsf_explanation": "Culinary curry spice blend featuring actual curry leaf (Murraya koenigii) plus supporting spices. Curry leaf has some emerging clinical evidence for glycemic and lipid effects but at doses substantially higher than culinary use. Culinary product, honestly positioned as a cooking spice — not marketed as a supplement. Kauai-grown, small-batch. Standard tier for a functional culinary product.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "turmeric-honey",
      "title": "Turmeric Honey",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Turmerichoneyproductphoto.jpg?v=1788737175",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "turmeric",
        "honey",
        "kauai",
        "farmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 65,
        "sustainability": 78
      },
      "price": 25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873051431109",
      "vsf_explanation": "Turmeric-infused Kauai honey. Turmeric's active curcumin has real anti-inflammatory RCT evidence; absorption from honey without piperine or lipid carrier is modest. Honey itself carries antimicrobial and cough-suppressant literature. Culinary functional food, honestly positioned, farm-grown ingredients. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "tulsi-tincture",
      "title": "Tulsi Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/TulsiTIncture.jpg?v=1788737175",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tulsi",
        "tincture",
        "kauai",
        "farmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 68,
        "sustainability": 78
      },
      "price": 32,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873051594949",
      "vsf_explanation": "Alcohol tincture of Kauai-grown tulsi (Ocimum sanctum / holy basil). Tulsi has emerging clinical evidence for stress and metabolic markers (Jamshidi 2017 systematic review). Tincture form; per-mL eugenol/ursolic acid content isn't published. Traditional herbal preparation from a real farm. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "comfrey-hydrosol",
      "title": "Comfrey Hydrosol",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ComfreyHydrosol.jpg?v=1788737176",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "comfrey",
        "hydrosol",
        "kauai",
        "farmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 65,
        "safety": 68,
        "transparency": 65,
        "sustainability": 78
      },
      "price": 30,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873051693253",
      "vsf_explanation": "Comfrey (Symphytum officinale) hydrosol — the aromatic water fraction from distillation, milder than essential oil or salve. Topical/aromatic use. Comfrey has real RCT evidence for topical salve applications (bruises, sprains, joint pain); the hydrosol form is more dilute and less well-studied. Standard tier for a niche traditional preparation from a real Hawaii farm. Pyrrolizidine-alkaloid safety note: comfrey is safe for external use only, on intact (unbroken) skin, and should not be used for more than 4-6 weeks continuously or during pregnancy/breastfeeding — it should never be ingested or applied to open wounds or broken skin.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "chaste-berry-tincture",
      "title": "Chaste Berry Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ChasteBerryTincture.jpg?v=1788737176",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "chaste",
        "berry",
        "tincture",
        "kauai",
        "farmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 68,
        "sustainability": 78
      },
      "price": 55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873051660485",
      "vsf_explanation": "Vitex agnus-castus (chaste berry) tincture — one of the more evidence-supported women's-health botanicals for PMS and cyclic mastalgia (Schellenberg 2001, van Die 2013 review). Standardized extracts (Ze 440, BNO 1095) hold the majority of RCT data at 20-40 mg daily. This is a small-batch alcohol tincture without published per-mL casticin/agnuside content, so dose-matching to trial protocols is imprecise. Kauai-grown, transparent provenance. Higher-end Standard for a well-supported herb in a traditional but non-standardized delivery format.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cleanse-powder",
      "title": "Cleanse Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CleansePowderproductshot.jpg?v=1788737176",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cleanse",
        "powder",
        "kauai",
        "farmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 75
      },
      "price": 50,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873051726021",
      "vsf_explanation": "The product's primary positioning — \"cleanse ourselves from the inside out,\" \"cleansing experience\" — is an unverified medical claim under the Vyvata rubric. The liver, kidneys, gut, lymphatic system, and skin perform detoxification continuously; no oral supplement has cleared FDA/EMA evidentiary bars for a general-population \"cleansing\" claim, and Cochrane/NIH NCCIH reviews of commercial cleanse products have consistently found human clinical evidence to be absent or of poor methodological quality. Even a real farm-grown Kauai producer cannot escape the autofail on \"cleanse\" framing — the framing itself is the problem. Rejected under unverified_medical_claim. To become listable: drop \"Cleanse\" from the product name and positioning; the underlying botanical blend (essential amino acids, plant proteins, antioxidants per the description) could be repositioned as a nourishing greens/protein blend without medical framing.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "cuban-oregano-tincture",
      "title": "Cuban Oregano Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CubanOreganoTincture.jpg?v=1788737176",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cuban",
        "oregano",
        "tincture",
        "kauai",
        "farmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 55,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 65,
        "sustainability": 78
      },
      "price": 35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873051758789",
      "vsf_explanation": "Tincture of Cuban oregano (Plectranthus amboinicus), a Coleus-related herb distinct from Mediterranean Origanum vulgare. Some in-vitro antimicrobial research on the essential oil constituents (carvacrol, thymol) exists but human RCT evidence is minimal. Kauai-grown small-batch tincture; per-drop dosing not published. Standard tier for a traditional-use tincture with limited clinical data.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "comfrey-salve",
      "title": "Comfrey Salve",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ComfreySalveproductphoto.jpg?v=1788737176",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "comfrey",
        "salve",
        "kauai",
        "farmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 65,
        "safety": 60,
        "transparency": 68,
        "sustainability": 78
      },
      "price": 48,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873051791557",
      "vsf_explanation": "Comfrey (Symphytum officinale) topical salve — one of the better-supported herbal topicals with actual RCT data for bruise resolution, sprain pain, and osteoarthritis symptom management (Kucera 2004, Grube 2007, D'Anchise 2011). Comfrey contains allantoin (well-established for skin regeneration) and rosmarinic acid. Critical safety note: comfrey pyrrolizidine alkaloids are hepatotoxic on oral ingestion, but this is a topical preparation — external-only use avoids the hepatotoxicity concern per current German Commission E and EMA guidance for topical PA-reduced comfrey. Small-batch Kauai-grown, honestly positioned. Higher-end Standard for a well-supported topical. Pyrrolizidine-alkaloid safety note: comfrey is safe for external use only, on intact (unbroken) skin, and should not be used for more than 4-6 weeks continuously or during pregnancy/breastfeeding — it should never be ingested or applied to open wounds or broken skin.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ginger-tincture-1",
      "title": "Ginger Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/GingerTincture.jpg?v=1788737176",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ginger",
        "tincture",
        "kauai",
        "farmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 68,
        "sustainability": 78
      },
      "price": 30,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873051857093",
      "vsf_explanation": "Ginger (Zingiber officinale) tincture — one of the strongest evidence bases in the herbal-supplement category. Multiple meta-analyses (Nikkhah Bodagh 2019, Marx 2015) show ginger effective for nausea (pregnancy, chemotherapy-induced, motion sickness) at doses around 1 g dried root equivalent, plus adjunct anti-inflammatory activity. Farm-grown, small-batch tincture format — per-mL dry-herb equivalent isn't published, so exact clinical-dose matching is impossible. Higher-end Standard: ingredient evidence is strong, product transparency is real, but the tincture format loses points on dose reproducibility vs standardized capsule extracts.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "annatto-tincture",
      "title": "Annatto Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/annattotincture.jpg?v=1788737176",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "annatto",
        "tincture",
        "kauai",
        "farmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 65,
        "sustainability": 78
      },
      "price": 40,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873051889861",
      "vsf_explanation": "Tincture of annatto seed (Bixa orellana). The seeds contain bixin/norbixin carotenoids and small amounts of geranylgeraniol and delta-tocotrienol. Some traditional-medicine use in Amazonian and Caribbean regions for skin, digestive, and antimicrobial applications. Modern controlled trials for oral annatto tincture are minimal. Small-batch, farm-grown, honest positioning as a traditional-use botanical. Standard tier for a niche traditional tincture.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ashwagandha-protein-powder",
      "title": "Ashwagandha Protein Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Ashwagandha_protein_powder_product_pic_copy.jpg?v=1788737178",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ashwagandha",
        "protein",
        "powder",
        "kauai",
        "farmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 65,
        "sustainability": 78
      },
      "price": 65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873051922629",
      "vsf_explanation": "A protein powder combining ashwagandha with farm-grown \"jungle greens\" (moringa, katuk, bele spinach). Ashwagandha has strong evidence for stress and cortisol; moringa has some emerging evidence for glycemic and lipid support. Per-scoop protein content, amino acid profile, and ashwagandha withanolide dose are not disclosed at the title level. Green-leafy proteins are generally lower in essential amino acids than whey or soy per gram, so functional protein content per serving may be modest. Standard tier: real ingredients, real farm provenance, but no disclosed protein-per-serving or withanolide-per-serving to grade against typical protein powder benchmarks.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "blue-vervain-tincture-1",
      "title": "Blue Vervain Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Bluevervaintinctureproductphotocopywebsite.jpg?v=1788737178",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "blue",
        "vervain",
        "tincture",
        "kauai",
        "farmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 68,
        "sustainability": 78
      },
      "price": 40,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873051955397",
      "vsf_explanation": "Wild-harvested Kauai blue vervain (Stachytarpheta sp.) tincture, positioned for calming and tension release. Vervain (particularly Verbena officinalis in European tradition) has some in-vitro and animal literature for anxiolytic and anti-inflammatory effects; the Stachytarpheta sp. wild-harvested on Kauai is more of a naturalized ethnobotanical use with even less controlled research. Small-batch, wild-harvested, disclosed provenance — Standard tier for a traditional-use tincture with limited RCT support.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "annatto-salve",
      "title": "Annatto Salve",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/AnnattoSalveProductPic.jpg?v=1788737180",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "annatto",
        "salve",
        "kauai",
        "farmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 65,
        "sustainability": 78
      },
      "price": 50,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873051988165",
      "vsf_explanation": "Topical salve infused with annatto (Bixa orellana) — the seeds contain bixin and norbixin carotenoids and small amounts of tocotrienols. Traditional Amazonian/Caribbean use for skin. Modern RCT evidence for topical annatto is thin. Small-batch, farm-sourced, honest topical positioning. Standard tier for a niche traditional-use topical.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "aura-hair-skin-serum",
      "title": "AURA Hair & Skin Serum",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/AURAproductphoto.jpg?v=1788737180",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "aura",
        "hair",
        "skin",
        "serum",
        "kauai",
        "farmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 62,
        "manufacturing": 65,
        "safety": 72,
        "transparency": 65,
        "sustainability": 78
      },
      "price": 85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873052020933",
      "vsf_explanation": "Cold-pressed kukui nut oil serum for hair and skin. Kukui (candlenut) oil has a real place in Native Hawaiian topical tradition and a decent fatty-acid profile (linoleic and alpha-linolenic acids) for skin barrier support. Human RCT evidence is thin but the biochemistry is defensible. Farm-sourced and cold-pressed — a legitimate, honestly-positioned cosmetic oil. Standard tier for a well-provenanced single-ingredient beauty oil.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "golden-milk-powder",
      "title": "Golden Milk Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Golden_Milk_product_photo.jpg?v=1788737182",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "golden",
        "milk",
        "powder",
        "kauai",
        "farmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 68,
        "sustainability": 78
      },
      "price": 54,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873052053701",
      "vsf_explanation": "Traditional golden-milk blend of cacao, turmeric, ginger, vanilla, allspice, and macadamia nut — a culinary superfood powder for warm milk drinks. Turmeric and ginger have real anti-inflammatory research, though turmeric's curcumin absorption is dose-limited without piperine or lipid carrier (not disclosed here). Ingredient list is transparent; per-ingredient milligrams aren't. Farm-grown, low-harm, honestly-framed as a nourishing daily beverage. Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cacao-honey",
      "title": "Cacao Honey",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CacaoHoney1.jpg?v=1788737182",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cacao",
        "honey",
        "kauai",
        "farmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 65,
        "sustainability": 78
      },
      "price": 25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873052315845",
      "vsf_explanation": "Cacao-infused honey — culinary functional food combining raw cacao's flavanol content with raw honey's polyphenols and antimicrobial character. Both ingredients have real evidence pedigree (Ried 2017 for cocoa flavanols; Cochrane 2018 for honey and cough). This is a food-format, not a metered supplement; positioning is honest but per-serving polyphenol content isn't published. Standard tier for a well-provenanced culinary honey with real functional ingredients.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cacao-ashwagandha-serum",
      "title": "Cacao Ashwagandha Serum",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/IMG_4929_1_2.jpg?v=1788737182",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cacao",
        "ashwagandha",
        "serum",
        "kauai",
        "farmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 55,
        "manufacturing": 65,
        "safety": 70,
        "transparency": 65,
        "sustainability": 78
      },
      "price": 45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873052348613",
      "vsf_explanation": "A macadamia-oil topical serum infused with cacao and ashwagandha, marketed with sensual/aphrodisiac framing (\"stamina of a stallion\"). Transdermal absorption of withanolides through skin oil for systemic adaptogenic effect is not established in the literature — aphrodisiac and stress claims for ashwagandha come from oral RCTs, not topical application. Product is honestly positioned as a serum/oil for skin and sensuality, not marketed as an oral supplement. Standard tier as a cosmetic oil with plant infusions; the systemic-effect implication isn't evidence-backed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vetiver-hydrosol",
      "title": "Vetiver Hydrosol",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Vetiver_Hydrosol_product_photo.jpg?v=1788737183",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vetiver",
        "hydrosol",
        "kauai",
        "farmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 65,
        "safety": 70,
        "transparency": 65,
        "sustainability": 78
      },
      "price": 28,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873052381381",
      "vsf_explanation": "Steam-distilled vetiver hydrosol for external/aromatic use. Vetiver essential oil has some in-vitro antimicrobial and anxiolytic-adjacent research; hydrosols (the aromatic water fraction of distillation) are milder than essential oils and carry lighter evidence support. The \"natural antiseptic\" claim is borderline but not directly medical. Kauai-grown, small-batch, low-harm topical/aromatic product — Standard is appropriate for a niche traditional-use category with limited RCT support.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ashwagandha-tincture-1",
      "title": "Ashwagandha Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/AshwagandhaTincture.jpg?v=1788737184",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ashwagandha",
        "tincture",
        "kauai",
        "farmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 58,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 68,
        "sustainability": 78
      },
      "price": 70,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873052414149",
      "vsf_explanation": "Ashwagandha (Withania somnifera) is one of the best-supported adaptogens with multiple modern RCTs for stress, cortisol reduction, and sleep quality (Chandrasekhar 2012, Lopresti 2019 on KSM-66; Salve 2019 on Shoden). This is a farm-grown, small-batch alcohol tincture rather than a standardized extract (KSM-66, Sensoril, Shoden) — so it doesn't inherit the RCT-specific formulation evidence. Kauai-grown provenance is transparent; per-drop withanolide content isn't disclosed. Higher end of Standard because ashwagandha as an ingredient class earns evidence credit, but the specific tincture form doesn't match any RCT protocol.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "butterfly-pea-tincture",
      "title": "Butterfly Pea Tincture",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ButterflyPeaTincture.jpg?v=1788737187",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "butterfly",
        "pea",
        "tincture",
        "kauai",
        "farmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 68,
        "sustainability": 78
      },
      "price": 45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873052446917",
      "vsf_explanation": "Single-herb tincture from Clitoria ternatea, wild-grown on Kauai. Butterfly pea flowers are rich in anthocyanins (delphinidin-glycosides) with in-vitro antioxidant activity and some emerging animal and small-human research on cognitive and metabolic effects (Thongrong 2023, Lakshan 2019 for glycemic response). Human RCT base is small and preliminary. Tincture form with disclosed botanical identity and small-batch farm production; per-ml alcohol/dry-herb ratio and per-drop compound content aren't published, which caps the score at Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "botanical-broth-blend",
      "title": "Botanical Broth Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BotanicalBrothBlendProductPhoto1.jpg?v=1788737187",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "botanical",
        "broth",
        "blend",
        "kauai",
        "farmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 58,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 65,
        "sustainability": 78
      },
      "price": 70,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873052479685",
      "vsf_explanation": "A dried herbal blend for making broth — a culinary preparation with functional herbs. Traditional bone-broth-style culinary use of medicinal herbs has cultural precedent but limited RCT literature. Kauai Farmacy's transparent farm sourcing is a genuine plus. Product doesn't make strong therapeutic claims; it's more of a nourishing pantry blend. Standard tier because it's an honest culinary product with legitimate ingredients, not because it has controlled-trial support.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cookie-dough-honey",
      "title": "Cookie Dough Honey",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CookieDoughproductphoto.jpg?v=1788737189",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cookie",
        "dough",
        "honey",
        "kauai",
        "farmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 62,
        "safety": 70,
        "transparency": 62,
        "sustainability": 75
      },
      "price": 55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873052512453",
      "vsf_explanation": "A culinary superfood blend suspended in honey, marketed as \"pure bliss in a jar\" — the framing leans heavily on flavor and \"caloric frequency\" language rather than measured therapeutic effect. Ingredients likely include nuts, cacao, vanilla, spices — real food, real farm sourcing. Scored Standard because the product doesn't over-promise medicinal effects (it's honest about being a treat), but it's more of a functional pantry item than a supplement with graded evidence. No autofail; just not therapeutic.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cacao-elixir-powder",
      "title": "Cacao Elixir Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CacaoElixir.jpg?v=1788737190",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cacao",
        "elixir",
        "powder",
        "kauai",
        "farmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 65,
        "sustainability": 78
      },
      "price": 54,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873052545221",
      "vsf_explanation": "Kauai Farmacy is a small-batch herbalist brand growing its own botanicals on a farm on Kauai — a real provenance story that earns credit for sustainability and traceability. Cacao Elixir Powder is a culinary superfood blend of raw cacao and warming spices intended as a hot-chocolate style drink. The marketing leans on mystical language (\"elevate the frequency of the body and soul\", \"medicine\") that isn't backed by controlled trials, and per-ingredient milligram doses are not disclosed at the title level. Raw cacao does carry legitimate flavanol antioxidant content (Cocoa Meta-analyses, e.g. Ried 2017 on blood pressure), but this is a low-single-serving blend, not a standardized flavanol extract. Scored Standard on the strength of ingredient identity, farm-grown provenance, and low harm profile — but not Verified because the therapeutic claims outrun the evidence base and doses aren't disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cacao-ginger-turmeric-honey",
      "title": "Cacao Ginger Turmeric Honey",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Cacaogingturmhoneycrop1.jpg?v=1788737190",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cacao",
        "ginger",
        "turmeric",
        "honey",
        "kauai",
        "farmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 60,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 68,
        "sustainability": 78
      },
      "price": 55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873052577989",
      "vsf_explanation": "A culinary honey infusion of Kauai-grown cacao, ginger, and turmeric. All three ingredients have real, well-cited functional pedigree — ginger for nausea/GI (Nikkhah Bodagh 2019 meta-analysis), turmeric for anti-inflammatory activity when bioavailability is boosted, and cacao for polyphenols. Honey itself has emerging antimicrobial and cough-suppressant literature (Cochrane 2018, honey vs placebo for pediatric cough). Per-ingredient dosing isn't disclosed; this is honey with herbs, not a standardized extract. Small-batch, farm-sourced, low-harm — Standard rather than Verified because it's a food-grade infusion, not a dose-controlled supplement.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nature-made-maximum-strength-vitamin-b12-5000-mcg-softgels-60ct",
      "title": "Nature Made Maximum Strength Vitamin B12 5000 Mcg Softgels - 60ct",
      "vendor": "Nature Made",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/330232930.jpg?v=1788737766",
      "score": 73,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "made",
        "maximum",
        "strength",
        "vitamin",
        "b12",
        "5000",
        "mcg",
        "softgels",
        "60ct",
        "nature",
        "made"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 70,
        "manufacturing": 85,
        "safety": 80,
        "transparency": 82,
        "sustainability": 60
      },
      "price": 19.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873059557573",
      "vsf_explanation": "Nature Made Maximum Strength B12 5000mcg is USP-Verified for label accuracy and purity. High-dose format positioned by label for adults with diagnosed low B12 — including vegans, older adults and metformin users — with physician-guided use recommended on-pack.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-b-complex-100-vegetable-capsules",
      "title": "Solgar B-Complex “100” Vegetable Capsules",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/96837516.jpg?v=1788738041",
      "score": 74,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "complex",
        "100",
        "vegetable",
        "capsules",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 78,
        "manufacturing": 80,
        "safety": 70,
        "transparency": 78,
        "sustainability": 65
      },
      "price": 58.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873063686341",
      "vsf_explanation": "Solgar B-Complex '100' Extra High Potency delivers 100mg-tier doses of the primary B vitamins in vegan capsules. Kosher (KOF-K), allergen-free label, mature brand governance and clear per-nutrient dose transparency — the same trusted core B-complex formula.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natrol-vitamin-b12-5000-mcg-fast-dissolve-strawberry-flavor",
      "title": "Natrol Vitamin B12 5000 Mcg Fast Dissolve Strawberry Flavor",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/38120690.jpg?v=1788738049",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "natrol",
        "vitamin",
        "b12",
        "5000",
        "mcg",
        "fast",
        "dissolve",
        "strawberry",
        "flavor",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 68,
        "manufacturing": 68,
        "safety": 78,
        "transparency": 65,
        "sustainability": 55
      },
      "price": 12.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873063817413",
      "vsf_explanation": "Natrol's fast-dissolve B12 delivers 5000mcg per tablet — a high-dose format used for correcting deficiency in vegans, older adults and metformin/PPI users. Natrol has NSF cGMP registration; label transparency on this SKU is adequate but not lab-verified per-batch.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nature-made-vitamin-c-extra-strength-1000-mg-tablets",
      "title": "Nature Made Vitamin C, Extra Strength, 1000 Mg, Tablets",
      "vendor": "Nature Made",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/314645565.jpg?v=1788738076",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "made",
        "vitamin",
        "extra",
        "strength",
        "1000",
        "tablets",
        "nature",
        "made"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 68,
        "manufacturing": 85,
        "safety": 82,
        "transparency": 78,
        "sustainability": 60
      },
      "price": 13.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873064177861",
      "vsf_explanation": "Nature Made Extra Strength Vitamin C 1000mg is USP-Verified — an independent seal confirming label accuracy and purity. Standard supportive dose for daily antioxidant, immune and collagen-synthesis needs; clean-label with no artificial flavors, colors or preservatives.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-vitamin-b12-500mcg-100-tablets",
      "title": "Solgar Vitamin B12 500mcg 100 Tablets",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33984032200.jpg?v=1788738087",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "vitamin",
        "b12",
        "500mcg",
        "100",
        "tablets",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 68,
        "manufacturing": 80,
        "safety": 85,
        "transparency": 75,
        "sustainability": 62
      },
      "price": 10.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873064210629",
      "vsf_explanation": "Solgar B12 at 500mcg is a higher-maintenance dose for adults with elevated needs (older adults, vegans, PPI/metformin users). Cyanocobalamin is stable and well-absorbed at this dose. Vegan, kosher and allergen-free with Solgar's mature manufacturing pedigree.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-vitamin-b6-100mg-100-tablets",
      "title": "Solgar Vitamin B6 100mg 100 Tablets",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33984031203.jpg?v=1788738097",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "vitamin",
        "100mg",
        "100",
        "tablets",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 55,
        "manufacturing": 78,
        "safety": 45,
        "transparency": 72,
        "sustainability": 62
      },
      "price": 8.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873064243397",
      "vsf_explanation": "Solgar B6 delivers 100mg pyridoxine — at the US Tolerable Upper Intake Level. Chronic supplementation above ~50mg/day carries documented risk of sensory peripheral neuropathy (case-series, EFSA 2023 revised UL to 12mg/day). Best used short-term with provider guidance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nature-made-cranberry-500mg-capsules-60ct",
      "title": "Nature Made Cranberry 500mg Capsules - 60ct",
      "vendor": "Nature Made",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/205499976.jpg?v=1788738121",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "made",
        "cranberry",
        "500mg",
        "capsules",
        "60ct",
        "nature",
        "made"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 85,
        "safety": 80,
        "transparency": 78,
        "sustainability": 55
      },
      "price": 23.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873064276165",
      "vsf_explanation": "Nature Made Cranberry 500mg with 90mg vitamin C targets urinary tract support. Cranberry evidence for UTI prevention is modest but real (Cochrane 2023: benefit for recurrent UTI in women). USP-Verified brand adds strong label-accuracy discipline.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-truth-sambucus-black-elderberry-immune-complex-plus-vitamin-c-zinc-natural-mixed-berry-60-chewable-tablets",
      "title": "Nature's Truth Sambucus Black Elderberry Immune Complex Plus Vitamin C & Zinc, Natural Mixed Berry, 60 Chewable Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/104778853.jpg?v=1788738136",
      "score": 67,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "truth",
        "sambucus",
        "black",
        "elderberry",
        "immune",
        "complex",
        "plus",
        "vitamin",
        "zinc",
        "natural",
        "mixed",
        "berry",
        "chewable",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 72,
        "safety": 78,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 10.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873064767685",
      "vsf_explanation": "Nature's Truth combines 1000mg Sambucus elderberry (Austrian-sourced) with 250mg vitamin C and 15mg zinc in a Tru-ID DNA-verified chewable. Elderberry has modest RCT evidence (Tiralongo 2016; Ismail 2019) for shortening cold/flu duration; formulation is transparent.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "halal-coq-10-vitamin-e-softgels",
      "title": "Halal CoQ 10 + Vitamin E Softgels",
      "vendor": "Zaytun Vitamins",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_5ec64bb3-b1d8-4e44-aec7-2dbc0714a8e3.png?v=1788738167",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "halal",
        "coq",
        "vitamin",
        "softgels",
        "zaytun",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 72,
        "manufacturing": 68,
        "safety": 78,
        "transparency": 65,
        "sustainability": 58
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873064898757",
      "vsf_explanation": "Zaytun Vitamins' CoQ10 + Vitamin E Softgels deliver 100 mg CoQ10 per softgel, paired with vitamin A and vitamin E (D-alpha-tocopherol, the natural stereoisomer preferred over synthetic dl-alpha-tocopherol) in a rice-bran-oil base that Zaytun describes as '2.5x more absorbable' than dry-powder alternatives. CoQ10 is one of the more legitimately-supported cardiovascular supplement categories, with meta-analytic evidence for modest blood-pressure reductions (Rosenfeldt 2007 Journal of Human Hypertension), particularly meaningful evidence in statin-induced myopathy (Banach 2015 Mayo Clinic Proceedings — statins deplete CoQ10, and repletion can reduce muscle-symptom burden), and endpoints in chronic heart failure (Mortensen 2014 Q-SYMBIO trial showed reduced mortality with 300 mg/day in NYHA class III-IV heart failure). 100 mg/day is a defensible cardiovascular-support dose (research doses range 100-300 mg/day). Halal-certified formulation with a rice-bran-oil base is a meaningful choice for the target market since many CoQ10 softgels use bovine gelatin from non-halal-slaughtered sources. The '2.5x more absorbable' marketing claim is directionally supported (oil-based CoQ10 does absorb better than powdered ubiquinone) but the exact multiplier is a manufacturer claim rather than a published PK finding. Verified — real halal-focused brand, evidence-supported cardiovascular ingredient, clinically-relevant dose, absorption-conscious formulation. Held below Elite on absent third-party testing and on the fact that ubiquinol (the reduced/active form) is superior for older adults whose conversion of ubiquinone declines with age; this product uses ubiquinone.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mason-natural-vitamin-c-500-mg-100-tablets",
      "title": "Mason Natural Vitamin C, 500 Mg, 100 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/51783266_b5293533-d806-4b1b-88bc-c5b9c1f6669d.jpg?v=1788738192",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mason",
        "natural",
        "vitamin",
        "500",
        "100",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 78,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 5.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873065029829",
      "vsf_explanation": "Mason Natural Vitamin C 500mg is a straightforward daily antioxidant and immune-support tablet at a budget price point. Basic cGMP manufacturing, minimal formulation and transparency detail beyond the labeled dose, no third-party seal referenced.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nature-made-vitamin-d3-1000-iu-100-tablets-25-mcg",
      "title": "Nature Made Vitamin D3 1000 IU 100 Tablets 25 Mcg",
      "vendor": "Nature Made",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/187807280.jpg?v=1788738203",
      "score": 76,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "made",
        "vitamin",
        "1000",
        "100",
        "tablets",
        "mcg",
        "nature",
        "made"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 72,
        "manufacturing": 85,
        "safety": 85,
        "transparency": 82,
        "sustainability": 60
      },
      "price": 6.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873065062597",
      "vsf_explanation": "Nature Made Vitamin D3 1000 IU is USP-Verified — one of the strongest independent quality seals in the OTC supplement space, confirming label accuracy, purity and manufacturing controls. Standard supportive D3 dose backed by extensive population evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-vitamin-b-12-natural-cherry-500-mcg-100-quick-dissolve-tablets",
      "title": "Nature's Bounty Vitamin B-12, Natural Cherry, 500 Mcg, 100 Quick Dissolve Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/181916837.png?v=1788738216",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "vitamin",
        "natural",
        "cherry",
        "500",
        "mcg",
        "100",
        "quick",
        "dissolve",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 65,
        "safety": 80,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 9.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873065095365",
      "vsf_explanation": "Nature's Bounty B-12 delivers 500mcg in a quick-dissolve cherry-flavored tablet suited for sublingual-style absorption. Solid maintenance dose for most adults, natural flavor, standard cGMP manufacturing without an explicit third-party certification on this SKU.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-vitamin-b-2-100-mg-coated-tablets",
      "title": "Nature's Bounty Vitamin B-2, 100 Mg, Coated Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/148727453_7eba90fb-fd44-4aa1-80e3-6352bc670f2d.jpg?v=1788738229",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "vitamin",
        "100",
        "coated",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 60,
        "manufacturing": 65,
        "safety": 78,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 10.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873065128133",
      "vsf_explanation": "Nature's Bounty B-2 delivers 100mg riboflavin per coated tablet — a high dose with published RCT support in migraine prevention (Schoenen 1998; 400mg tier) and well tolerated. Nature's Bounty operates cGMP; third-party sealing varies across the line.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sss-tonic-liquid-iron-vitamin-b-supplement-20-fl-oz",
      "title": "SSS Tonic Liquid Iron & Vitamin B Supplement 20 Fl. Oz",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/204721985_50967c56-d291-4050-b2fe-7f924fe2a718.jpg?v=1788738255",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sss",
        "tonic",
        "liquid",
        "iron",
        "vitamin",
        "supplement",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 65,
        "transparency": 35,
        "sustainability": 45
      },
      "price": 13.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873065160901",
      "vsf_explanation": "SSS Tonic is a legacy liquid iron and B-complex formula in a tonic-style delivery. Extremely thin public label transparency — no ingredient doses, no iron form (heme vs non-heme, ferrous vs bisglycinate) and no third-party verification disclosed in this listing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-calcium-600-from-oyster-shell-with-vitamin-d3-240-tablets",
      "title": "Solgar Calcium \"600\" From Oyster Shell With Vitamin D3, 240 Tablets",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/148384440.jpg?v=1788738266",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "calcium",
        "600",
        "from",
        "oyster",
        "shell",
        "with",
        "vitamin",
        "240",
        "tablets",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 78,
        "safety": 78,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 24.7,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873065193669",
      "vsf_explanation": "Solgar's oyster-shell calcium (essentially calcium carbonate) provides 600mg with vitamin D3 for absorption. Carbonate is cost-effective but less bioavailable than citrate, especially in older adults with lower stomach acid — take with meals for best uptake.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "halal-vitamin-b-12-methylcobalamin-tablets",
      "title": "Halal Vitamin B-12 (Methylcobalamin) Tablets",
      "vendor": "Zaytun Vitamins",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Zaytun-Vitamin-B12-1000MCG-Front.png?v=1788738294",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "halal",
        "vitamin",
        "methylcobalamin",
        "tablets",
        "zaytun",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 78,
        "manufacturing": 72,
        "safety": 82,
        "transparency": 68,
        "sustainability": 60
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873065226437",
      "vsf_explanation": "Zaytun Vitamins is a real halal-certified nutraceutical brand serving Muslim consumers who need certified halal supplement options — a legitimate underserved market segment for whom mainstream vitamin products (which often use bovine or non-halal-slaughtered gelatin, alcohol-based extracts, or non-halal-derived enzymes) present a genuine barrier to compliance. The Vitamin B-12 product uses methylcobalamin (the bioactive form B12 preferentially used by the nervous system) rather than the cheaper cyanocobalamin, at 1,000 mcg per tablet (indicated by the product image filename), in a chewable cherry-flavored format that also suits people with malabsorption or swallowing difficulties. B12 supplementation has clear evidence for deficiency-driven neurological and hematological symptoms (Green 2017 NEJM review), is important for vegans and vegetarians who lack reliable dietary sources, and is one of the more likely-to-be-deficient vitamins in the general population (particularly in adults over 50, in whom absorption declines with age-related loss of intrinsic factor). ISA-certified halal is a legitimate third-party attestation. 120 tablets = 4-month supply is honest math on the label. Verified — real brand with a defensible target-market focus, bioactive B12 form, honest labeling and multi-month supply, third-party halal certification. Held below Elite on absent third-party potency testing (USP-verified or Labdoor tested) and on the general reality that most B12 supplements at 1,000 mcg deliver 100-500x the DV, which is safe but oversized for baseline replacement.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-vitamin-d3-cholecalciferol-25mcg-1000-iu-100-chewable-tablets",
      "title": "Solgar Vitamin D3 (Cholecalciferol) 25mcg (1000 IU) 100 Chewable Tablets",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33984549562.png?v=1788738828",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "vitamin",
        "cholecalciferol",
        "25mcg",
        "1000",
        "100",
        "chewable",
        "tablets",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 72,
        "manufacturing": 80,
        "safety": 82,
        "transparency": 75,
        "sustainability": 62
      },
      "price": 9.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873068437701",
      "vsf_explanation": "Solgar's D3 chewable delivers 1000 IU (25mcg) cholecalciferol — the more bioactive D3 form — in a family-friendly chewable. Widely supported dose for maintaining serum 25(OH)D in adults with moderate sun exposure. Clean label, mature brand governance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vm100-liquid-multivitamin-and-multimineral-daily-supplement-100-nutrients-with-vitamins-minerals-antioxidants-and-superfoods-32-oz",
      "title": "VM100 Liquid Multivitamin and Multimineral Daily Supplement - 100+ Nutrients with Vitamins, Minerals, Antioxidants, and Superfoods - 32 oz",
      "vendor": "Buried Treasure Liquid Nutrients",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/VM100-daily_multi-main_image.png?v=1788738851",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vm100",
        "liquid",
        "multivitamin",
        "and",
        "multimineral",
        "daily",
        "supplement",
        "100",
        "nutrients",
        "with",
        "vitamins",
        "minerals",
        "antioxidants",
        "and",
        "superfoods",
        "buried",
        "treasure",
        "liquid",
        "nutrients"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 65,
        "manufacturing": 65,
        "safety": 68,
        "transparency": 55,
        "sustainability": 62
      },
      "price": 45.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873068765381",
      "vsf_explanation": "Buried Treasure's VM100 is a liquid multivitamin-plus-mineral formulation with a 32 oz bottle format positioning itself around comprehensive daily coverage: fat- and water-soluble vitamins (A, C, D, E, B-complex), 70+ colloidal trace minerals from fulvic-acid-sourced humic shale, and a superfood blend (beets, bilberry, pomegranate, barley grass, spinach, goji, chlorophyll, cranberries, spirulina). The brand is real and established since 1996. The formulation choices are defensible for a liquid multi — methylfolate and methylcobalamin (the bioactive B-vitamin forms rather than the cheaper folic-acid/cyanocobalamin) are a meaningful upgrade over budget multivitamins and matter for the meaningful portion of the population with MTHFR polymorphisms who convert folic acid poorly. The '100+ nutrients' framing is largely a marketing artifact of counting each trace mineral individually and does not necessarily indicate superior formulation — most people are not deficient in the majority of 70 trace minerals. The 'superfood blend' is included at unspecified doses per serving; individually the ingredients are legitimate polyphenol sources, but at splash-of-color doses in a 32 oz bottle they are contributing more color and marketing than functional biochemistry. The listing does not publish per-serving milligrams for every nutrient. Standard tier: real brand, defensible B-vitamin forms, some genuine formulation choices — but held below Verified by transparency gaps and the general reality that liquid multivitamins struggle with stability (fat-soluble vitamin oxidation once the bottle is open).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-vitamin-b12-100mcg-100-tablets",
      "title": "Solgar Vitamin B12 100mcg 100 Tablets",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33984031807.png?v=1788738868",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "vitamin",
        "b12",
        "100mcg",
        "100",
        "tablets",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 80,
        "safety": 85,
        "transparency": 75,
        "sustainability": 62
      },
      "price": 7.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46873068798149",
      "vsf_explanation": "Solgar's B12 uses cyanocobalamin at 100mcg — an adequate maintenance dose, though less bioactive than methylcobalamin or adenosylcobalamin. Vegan, kosher, gluten/dairy/soy-free with clean excipients and Solgar's established manufacturing pedigree behind the label.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "plant-based-protein-powder-chocolate-21-servings",
      "title": "Plant Based Protein Powder: Chocolate (21 Servings)",
      "vendor": "Elements Truffles",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2_4b240231-c38a-4bb5-a02b-db73c0dc2f9e.png?v=1788794478",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "plant",
        "based",
        "protein",
        "powder",
        "chocolate",
        "servings",
        "elements",
        "truffles"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 70,
        "manufacturing": 62,
        "safety": 72,
        "transparency": 60,
        "sustainability": 72
      },
      "price": 45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46877200285893",
      "vsf_explanation": "Elements Truffles Plant Based Protein Powder is a clean-label pea-protein product built on a minimalist six-ingredient formulation — organic pea protein, organic cacao, Ayurvedic adaptogens, monk fruit sweetener — with 20 g complete protein per serving in a 21-serving tub. Pea protein at 20 g per serving is a legitimate protein dose (Babault 2015 showed pea protein comparable to whey for muscle-mass gains when leucine is adequate, though the leucine content per serving is lower than whey and typically requires either higher serving size or a leucine-added blend). The six-ingredient minimalism ('no gums, no sugar alcohols, no artificial flavors') is meaningful for shoppers avoiding common protein-powder additives (xanthan gum, sucralose, acesulfame potassium). The gaps: the specific 'Ayurvedic adaptogens' are unnamed (ashwagandha? holy basil? shatavari? all three?), which is a real transparency issue when adaptogens carry their own dose and interaction considerations; the leucine content per serving is not published, which matters for muscle-protein-synthesis planning; and total per-serving amino profile is not disclosed. Real small brand, clean-label positioning, defensible protein dose — but the 'Ayurvedic adaptogens' handwave is a proprietary-blend-adjacent transparency gap that keeps this in Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "peppermint-hot-chocolate",
      "title": "Peppermint Hot Chocolate",
      "vendor": "Elements Truffles",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/PeppermintHero_1126c87a-c5e7-4aac-81b8-3754b588956c.png?v=1788794489",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "peppermint",
        "hot",
        "chocolate",
        "elements",
        "truffles"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 48,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 45,
        "sustainability": 62
      },
      "price": 16,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46877200744645",
      "vsf_explanation": "Elements Truffles is a legitimate small-batch chocolatier and functional-food brand, and Peppermint Hot Chocolate is by their own description a culinary hot-chocolate product — 'indulge in decadent, minty peppermint hot chocolate' made with organic ceremonial cacao, real peppermint, and organic coconut sugar. The product is a food item, not a supplement or biohacking tool. It carries no supplement facts panel, makes no health claim, discloses no functional-ingredient dose, and is not positioned as a therapeutic product. The Vyvata catalog scores biohacking- and health-optimization-relevant products; hot chocolate mixes are outside that scope regardless of how clean the ingredient list is. This is not a knock on the product — it is a genuinely nice-looking culinary offering from a real brand — it is a scope determination. Rejected under the `out_of_scope_for_biohacking` autofail rule.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "vitrocap-n-eye-health-dietary-supplement-90-capsules",
      "title": "VitroCap N Eye Health Dietary Supplement 90 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/OocsSFPqvoqfJrqrR7qqItLhdXBejj8D9papTSq8.jpg?v=1788794545",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitrocap",
        "eye",
        "health",
        "dietary",
        "supplement",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 68,
        "safety": 68,
        "transparency": 55,
        "sustainability": 58
      },
      "price": 83.87,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46877201694917",
      "vsf_explanation": "VitroCap N is a specialty eye-health nutraceutical developed by Nordic Labs (French/European) and positioned specifically at people experiencing vitreous floaters and age-related changes in visual comfort. The featured ingredients are grape seed extract (a rich source of oligomeric proanthocyanidins with a genuine antioxidant evidence base) and vitamin C (for collagen synthesis and general antioxidant support). VitroCap N has a small but real piece of published clinical evidence — a 2018 Kellogg Eye Center pilot trial (Horkaew, Journal of Ophthalmology) reported reduced vitreous opacity scores and improved patient-reported visual disturbance after 6 months. It is one of the very few floater-specific supplements with any published human data at all, which is unusual in this narrow niche. What the listing does not do is publish per-capsule milligrams of grape seed extract, vitamin C, or the other 'plant-based antioxidants' referenced. The full formula is more complex than the two ingredients called out on the product page. Standard tier — genuine niche brand, one small piece of published clinical support (which is more than 95% of eye-supplement listings can claim), real target use case — held below Verified on incomplete formulation disclosure and the fact that the pilot trial is small (n<100) and not yet independently replicated. Note: 'eye health' does not have a dedicated subcategory in the Vyvata taxonomy; classified under immune_antioxidants as the closest ingredient-class match.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "buried-treasure-hard-2-beet-15-1-concentrated-beetroot-juice-dietary-supplement-16-oz-48-liquid-servings",
      "title": "Buried Treasure Hard 2 Beet, 15:1 Concentrated Beetroot Juice Dietary Supplement, 16 oz, 48 Liquid Servings",
      "vendor": "Buried Treasure Liquid Nutrients",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/01H2B-render_camera_n3d.jpg?v=1788794555",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "buried",
        "treasure",
        "hard",
        "beet",
        "concentrated",
        "beetroot",
        "juice",
        "dietary",
        "supplement",
        "liquid",
        "servings",
        "buried",
        "treasure",
        "liquid",
        "nutrients"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 68,
        "manufacturing": 65,
        "safety": 68,
        "transparency": 55,
        "sustainability": 68
      },
      "price": 42.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46877240524997",
      "vsf_explanation": "Buried Treasure is a real specialty brand focused on liquid nutraceuticals, in market since 1996 with an established retail presence. Hard 2 Beet is a 15:1 concentrated beetroot juice in a 16 oz / 48-serving liquid format. Beetroot juice is one of the more legitimately-evidence-supported nutraceutical categories — the nitrate content converts via the nitrate-nitrite-nitric oxide pathway to increase nitric oxide bioavailability, with meta-analytic evidence for modest blood-pressure reductions (Siervo 2013 in Journal of Nutrition, ~4/2 mmHg systolic/diastolic on average) and small-trial evidence for exercise performance improvements in endurance activities (Domínguez 2017 in Nutrients). The 15:1 concentration ratio is a real formulation approach that lets the liquid deliver more nitrate per volume than un-concentrated beet juice. The primary transparency gap is the same one that plagues every beet product: the listing does not publish milligrams of dietary nitrate per serving, and nitrate is the active ingredient — not beet-juice mass. Research-relevant nitrate doses are 300-600 mg/day, and buyers cannot verify whether the product hits that window. Vegan, non-GMO, gluten-free positioning; liquid format is genuinely more convenient than beet powders that can be gritty. Standard tier: category is strong, brand is real, held below Verified on nitrate-content disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mutant-mass-5lbs",
      "title": "Mutant Mass, 5lbs",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/mutant-mass-5lbs..png?v=1788794569",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mutant",
        "mass",
        "5lbs",
        "poorboysupplements",
        "com"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46877240688837",
      "vsf_explanation": "Mutant is a real Canadian sports-nutrition brand (owned by Fit Foods / PVL Nutrients) with mainstream retail distribution in North America and Europe, particularly well-known in the hardcore bodybuilding segment. Mutant Mass is a category-standard weight-gainer targeted at 'hard gainers' — the format packages protein plus carbohydrates plus calories into a high-calorie shake meant to make hitting a caloric surplus easier for people who struggle to eat enough whole food. The evidence for weight-gainer supplements is generally straightforward: they work if used as a supplemental caloric-surplus tool alongside adequate training stimulus (Kreider 2010 ISSN position stand on nutrient timing recognizes the utility of liquid post-workout calories for mass gain). The listing on the product page does not publish the specific macronutrient breakdown at the per-scoop level (grams of protein, carbs, sugar, calories per serving), which is the primary transparency gap — a mass gainer's usefulness lives entirely in that macro split, and most competing brands publish it prominently. Real brand, legitimate category, but the listing is under-specified. Standard tier: category-appropriate, but held below Verified by insufficient per-serving nutrition disclosure and the general reality that a lot of mass gainers rely heavily on cheap maltodextrin for calorie inflation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "weider-premium-whey-protein-powder-2300-gr",
      "title": "Weider Premium Whey Protein Powder 2300 Gr",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/weider_premium_whey_protein_tozu_2300_gr_105321.jpg?v=1788794583",
      "score": 75,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "weider",
        "premium",
        "whey",
        "protein",
        "powder",
        "2300",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 78,
        "manufacturing": 78,
        "safety": 80,
        "transparency": 78,
        "sustainability": 62
      },
      "price": 369.46,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46877241114821",
      "vsf_explanation": "Weider is one of the oldest and most established brands in sports nutrition — founded by Joe Weider in the 1930s and a mass-market presence in bodybuilding, fitness, and general protein-supplement retail for nearly a century. The Premium Whey Protein Powder is a straightforward, transparently-labeled whey blend: 20% whey protein isolate + 66-72% whey protein concentrate, 23 g protein per 30 g scoop, 2.3 kg tub / 77 servings, complete amino-acid profile disclosed at the per-serving level (including 2,369 mg leucine, 1,472 mg each isoleucine and valine), 2 g added glutamine, low-heat and low-pressure processing to preserve native protein structure. The 30 g scoop delivering 23 g protein represents good protein-per-scoop density (~77% protein by mass, which is what you'd expect from an isolate-concentrate blend). Whey protein at 20-30 g per serving is the most well-studied protein-supplement category in nutrition (Morton 2018 systematic review confirming muscle-protein synthesis effect in resistance-trained adults). Verified — established brand, transparent formulation, adequate leucine content per serving to trigger MPS (~2.4 g leucine per scoop meets the leucine threshold), full amino-acid profile disclosure. Held below Elite on absent third-party testing disclosure (Informed-Sport, NSF-Certified for Sport, or Labdoor certifications would push a whey product into Elite range).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "velavit-dim-complex-support-with-diindolylmethane-sulforaphane-dietary-supplement-with-broccoli-extract-calcium-d-glucarate",
      "title": "Velavit DIM Complex: Support with Diindolylmethane & Sulforaphane - Dietary Supplement with Broccoli Extract & Calcium D-Glucarate",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/jUDbrdB5UpnmKafnRfvdfn2ONl3VSuLolXjm4gRH.jpg?v=1788794599",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "velavit",
        "dim",
        "complex",
        "support",
        "with",
        "diindolylmethane",
        "sulforaphane",
        "dietary",
        "supplement",
        "with",
        "broccoli",
        "extract",
        "calcium",
        "glucarate",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 72,
        "manufacturing": 65,
        "safety": 72,
        "transparency": 78,
        "sustainability": 62
      },
      "price": 58.36,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46877241573573",
      "vsf_explanation": "Velavit DIM Complex is a cruciferous-vegetable-derived estrogen-metabolism formulation that stands out in this batch for actually disclosing per-tablet milligrams of every active: DIM 100 mg, calcium D-glucarate 250 mg, sulforaphane 250 mcg (from broccoli extract), plus piperine for absorption support. Full dose disclosure is meaningfully rare in this category and pushes the score up. The ingredient stack is coherent for its intended use — DIM (a metabolite of indole-3-carbinol) shifts estrogen metabolism toward the 2-hydroxyestrone pathway in small human PK studies (Michnovicz 1997, Reed 2005); calcium D-glucarate inhibits beta-glucuronidase and supports estrogen conjugation clearance (small-trial mechanistic evidence); sulforaphane is one of the more-studied Nrf2 activators with a growing evidence base for antioxidant-response and phase-II detoxification enzyme induction (Fahey 2015 broccoli sprout extract). Piperine at pharmacologically-relevant doses enhances absorption of several co-administered compounds. The DIM dose (100 mg) is on the lower end of clinically-studied doses (100-300 mg/day range), and the sulforaphane content in mcg quantities is meaningful but modest relative to fresh broccoli sprout intake. Verified — full disclosure, coherent formulation, evidence-supported ingredient class — held below Elite on modest doses and the mechanistic (rather than hard clinical outcome) nature of the underlying evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "alpha-lion-superhuman®-intra",
      "title": "Alpha Lion SuperHuman® Intra",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Alpha-Lion-SuperHuman-Intra.jpg?v=1788794613",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alpha",
        "lion",
        "superhuman",
        "intra",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 78,
        "manufacturing": 72,
        "safety": 70,
        "transparency": 72,
        "sustainability": 55
      },
      "price": 39.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46877242032325",
      "vsf_explanation": "Alpha Lion is a real DTC sports-nutrition brand with GNC and mainstream retail distribution. SuperHuman Intra is an intra-workout EAA/BCAA formula that discloses total serving-level amino-acid content — 3,000 mg BCAAs, 2,000 mg EAAs (5,000 mg full-spectrum amino support), plus 1,875 mg electrolytes per scoop — and calls out branded raw-material components including Calci-K (calcium/potassium bicarbonate), Aquamin (marine mineral complex), InstAminos (fermentation-derived amino acids), and AstraGin (bioavailability enhancer). Branded raw-materials with independent published research (Aquamin in particular has ~30 published studies) is meaningful transparency and dose accountability. The category itself — full-spectrum EAAs during resistance training — has legitimate evidence for muscle-protein-synthesis support in trained lifters when protein intake is otherwise sub-optimal (Jackman 2017, Moberg 2016). Where the honest read tempers is that 3,000 mg BCAAs is on the lower end of research-relevant BCAA doses and that intra-workout amino acid supplementation is a marginal add-on for lifters who already eat adequate protein daily (whole-day protein sufficiency matters more than intra-workout timing per Schoenfeld 2013 systematic review). Verified — solid brand, transparent dosing, real branded ingredients, evidence-supported category — held below Elite on the general point that intra-workout aminos are a small performance edge rather than a foundational category.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bee-you-dietary-supplement-shots-vitamin-c-zinc-d3-propolis-12-x-50ml-shots-for-natural-immune-support",
      "title": "BEE & YOU Dietary Supplement Shots - Vitamin C, Zinc, D3 & Propolis - 12 x 50ml Shots for Natural Immune Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8kRuSUlGrS1BPyBg3nH03YIC08WF4e3yQm7u5WA5.jpg?v=1788794644",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bee",
        "you",
        "dietary",
        "supplement",
        "shots",
        "vitamin",
        "zinc",
        "propolis",
        "50ml",
        "shots",
        "for",
        "natural",
        "immune",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 62,
        "safety": 68,
        "transparency": 48,
        "sustainability": 58
      },
      "price": 26.62,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46877242785989",
      "vsf_explanation": "BEE & YOU is a legitimate Turkish natural-products brand focused on bee-derived ingredients (propolis, raw honey, royal jelly) with international distribution. The immune-shot format packages vitamin C, zinc, vitamin D3, and propolis in a ready-to-drink 50 ml single-serve format, with 12 shots per pack. The core micronutrients are the standard immune-support triad — vitamin C at 500-1000 mg has weak-to-moderate evidence for shortening common-cold duration in some populations (Hemila Cochrane 2013), zinc at 75+ mg/day started within 24 hours of symptom onset has modest RCT evidence for cold duration (Science 2012), and vitamin D at adequate serum status reduces respiratory-infection incidence (Martineau 2017 BMJ). Propolis has small-trial evidence for upper-respiratory endpoints. What the listing does not publish is per-shot milligrams of vitamin C, zinc, or D3 — the key transparency gap. Shot format has real convenience advantages but adds sugar mass (via orange juice and honey), which a diabetic or low-carb shopper should note. Standard tier — legitimate brand with a coherent formula, held below Verified by dose opacity.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "aga-e-dietary-supplement-60-tablets-with-saw-palmetto-biotin-and-zinc",
      "title": "Aga-E Dietary Supplement - 60 Tablets with Saw Palmetto, Biotin, and Zinc",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/sA9pEhL6jhfVIrd6FQrW9L7PiaPItoIpuPQeXT3J_897ea5da-3c79-402f-bc2e-d37221dca8a9.jpg?v=1788794659",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "immune",
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "aga",
        "dietary",
        "supplement",
        "tablets",
        "with",
        "saw",
        "palmetto",
        "biotin",
        "and",
        "zinc",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 50.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46877243375813",
      "vsf_explanation": "Aga-E is a Turkish-origin hair-support supplement combining saw palmetto extract, pumpkin seed extract, and B-vitamin plus zinc micronutrient support (B1, B5, B6, biotin, zinc). The mechanistic case for the ingredient stack is coherent — saw palmetto is a modest 5-alpha-reductase inhibitor with small-trial evidence for androgenic alopecia (Prager 2002, Rossi 2012), pumpkin seed oil has one small positive trial in male AGA (Cho 2014), and biotin plus zinc are legitimate cofactors in hair-follicle biology (though biotin supplementation for hair growth in non-deficient people has thin RCT support). The listing does not publish per-tablet milligrams of any active — a research-relevant saw palmetto dose is 320 mg/day standardized extract, and this cannot be verified from the product page. The suggested 3-6 month duration is honest for hair-cycle timing. Standard tier: coherent stack, plausible ingredient set, small-scale evidence base, but dose opacity and the fact that biotin supplementation lacks strong RCT support outside deficiency keep it in the middle band.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vital-proteins-marine-collagen-supplement-neutral-flavor-collagen-peptides-powder-for-skin-hair-joint-health",
      "title": "Vital Proteins Marine Collagen Supplement - Neutral Flavor Collagen Peptides Powder for Skin, Hair & Joint Health",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/lVm6uin51lIrzD0ZCczz72HsfI1wZvKoTwM5W6xa.jpg?v=1788794669",
      "score": 74,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vital",
        "proteins",
        "marine",
        "collagen",
        "supplement",
        "neutral",
        "flavor",
        "collagen",
        "peptides",
        "powder",
        "for",
        "skin",
        "hair",
        "joint",
        "health",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 78,
        "manufacturing": 82,
        "safety": 80,
        "transparency": 72,
        "sustainability": 58
      },
      "price": 111.84,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46877243572421",
      "vsf_explanation": "Vital Proteins is one of the two or three most-established collagen-peptide brands globally, acquired by Nestle in 2020, and its marine (fish-derived) collagen line is the seafood-source alternative to its more familiar bovine line. The formulation is straightforward — hydrolyzed marine collagen peptides in a neutral-flavor mixable powder, 10 g per serving mixed with 200 ml liquid. Ten grams is a defensible daily dose that lands in the mid-range of most published collagen-peptide trials (typically 2.5-15 g/day). Collagen peptides have a growing evidence base for skin elasticity and hydration (Choi 2019, Barati 2020 meta-analyses) and modest evidence for joint comfort (Clark 2008 for athletes, Zdzieblik 2017 for knee osteoarthritis) — the marketed claim set is broadly evidence-supported. Marine sourcing has an advantage over bovine on allergen/religious-dietary grounds (halal/kosher accessibility, no bovine spongiform encephalopathy concern), though shellfish/fish allergy is a countervailing flag. Verified — an established brand with an evidence-supported ingredient at a research-relevant dose. Held below Elite on absent third-party testing narrative and on the fact that hair-growth claims for oral collagen have weaker evidence than the skin claims.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "tabvitamins-berista-liposomal-berberine-herbal-dietary-supplement-tablets",
      "title": "Tabvitamins Berista: Liposomal Berberine & Herbal Dietary Supplement Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/mowP0hGEYRMnVTlO1bj8Zbcbs9UeB7FTq7FmvVQu.jpg?v=1788794685",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tabvitamins",
        "berista",
        "liposomal",
        "berberine",
        "herbal",
        "dietary",
        "supplement",
        "tablets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 60,
        "transparency": 48,
        "sustainability": 52
      },
      "price": 60.82,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46877244063941",
      "vsf_explanation": "Tabvitamins Berista is a berberine-anchored metabolic-support formula that also includes barberry extract (Berberis vulgaris, the botanical source of berberine), Gymnema sylvestre, milk thistle, chromium, and choline. The ingredient stack is coherent — berberine at clinically-studied doses (500-1500 mg/day) has meta-analytic evidence for fasting glucose and HbA1c in prediabetic and type 2 diabetic populations (Dong 2012, Lan 2015), and the supporting herbs (gymnema for glucose-craving reduction, milk thistle for hepatic support, chromium for insulin sensitivity) all have legitimate evidence tracks. The 'liposomal' framing addresses a real problem with berberine — oral bioavailability is famously poor (~5%) — but the listing does not describe the encapsulating matrix or provide comparative PK data supporting the liposomal claim. Per-tablet milligrams of berberine and the other actives are not disclosed on the product page, which is the primary transparency ceiling. Real brand, coherent stack, evidence-supported anchor ingredient — Standard on the strength of ingredient identity, held below Verified on dose opacity.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "21st-century-turmeric-complex-500-mg-vegetarian-capsules",
      "title": "21st Century Turmeric Complex – 500 mg (Vegetarian Capsules)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/90416652.jpg?v=1788794697",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "21st",
        "century",
        "turmeric",
        "complex",
        "500",
        "vegetarian",
        "capsules",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 75,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 7.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46877244293317",
      "vsf_explanation": "21st Century Turmeric Complex provides 500mg turmeric per capsule — below the 1000–2000mg curcumin-extract dose used in most anti-inflammatory RCTs — and includes no piperine, phospholipid or nano-formulation to improve absorption. Standardization percentage isn't disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "centrum-silver-women-50-multivitamin-tablets-100ct",
      "title": "Centrum Silver Women 50 + Multivitamin Tablets 100Ct",
      "vendor": "Centrum",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/170992692_ff57ec87-f91d-4deb-a2e1-8356c123c3fb.jpg?v=1788794712",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "female",
      "life_stage": "women_50_plus",
      "tokens": [
        "centrum",
        "silver",
        "women",
        "multivitamin",
        "tablets",
        "100ct",
        "centrum"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 68,
        "manufacturing": 75,
        "safety": 80,
        "transparency": 68,
        "sustainability": 55
      },
      "price": 16.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46877244588229",
      "vsf_explanation": "Centrum Silver 50+ is the same core formula backed by COSMOS-Mind (Baker 2023) and Physicians' Health Study II — large RCTs showing modest cognitive benefit in older adults. Non-GMO/gluten-free, transparent nutrient panel, established GMP manufacturing at scale.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "geritol-multivitamin-nutrition-support-tablets-100-ct",
      "title": "Geritol Multivitamin Nutrition Support Tablets - 100 ct",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/46085652.jpg?v=1788794746",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "geritol",
        "multivitamin",
        "nutrition",
        "support",
        "tablets",
        "100",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 75,
        "transparency": 45,
        "sustainability": 45
      },
      "price": 12.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46877245472965",
      "vsf_explanation": "Geritol's classic multivitamin covers essential vitamins and minerals with an antioxidant emphasis (A, C, E). Very thin public label transparency, dated formulation vs modern multis, no third-party verification named, and marketing copy that reads more legacy than evidence-led.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liposomal-magnesium-glycinate-120-vegetable-capsules-bb-01-2028",
      "title": "Liposomal Magnesium Glycinate, 120 Vegetable Capsules BB 01/2028",
      "vendor": "Price Is Right Miami",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/69a42325-ad0a-4530-8295-bcc2580e1e9e.jpg?v=1788794757",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liposomal",
        "magnesium",
        "glycinate",
        "120",
        "vegetable",
        "capsules",
        "2028",
        "price",
        "right",
        "miami"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 32,
        "safety": 55,
        "transparency": 22,
        "sustainability": 40
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46877245702341",
      "vsf_explanation": "The product title carries no brand — it reads 'Liposomal Magnesium Glycinate, 120 Vegetable Capsules BB 01/2028' with a best-by date embedded in the title. The listing description is a single sentence directing the buyer to 'see label photos' for ingredient and serving details. There is no identifiable manufacturer, no supplement facts panel, no elemental magnesium disclosure per capsule, no third-party testing narrative, no country of origin, no allergen statement. Magnesium glycinate as an ingredient class has real, well-supported evidence — it is one of the better-absorbed and better-tolerated magnesium forms — but that class-level evidence cannot transfer to an anonymous listing where the buyer cannot identify who manufactured the capsule or what is actually inside it. 'Liposomal' framing adds a further disclosure burden (a genuine liposomal preparation should describe the encapsulating phospholipid and manufacturing method) that is not met. Rejected under the `no_brand_provenance` autofail — Vyvata's rubric requires an identifiable brand a shopper can research, and this listing does not provide one.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "solgar-b-complex-100-100-vegetable-capsules",
      "title": "Solgar B-Complex \"100\" 100 Vegetable Capsules",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33984011502.png?v=1788794787",
      "score": 74,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "complex",
        "100",
        "100",
        "vegetable",
        "capsules",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 78,
        "manufacturing": 80,
        "safety": 70,
        "transparency": 78,
        "sustainability": 65
      },
      "price": 24.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46877284827333",
      "vsf_explanation": "Solgar's B-Complex '100' delivers substantial doses of all eight B vitamins (100mg tier for B1/B2/B3/B5/B6) in vegan capsules. KOF-K kosher, free of common allergens, mature governance and clear per-nutrient dose transparency across the panel.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "life-time-q-bromelain-dietary-supplement-60-tablets",
      "title": "Life Time Q-Bromelain Dietary Supplement 60 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/u5hwPeQYnye9RrMYitQpHAbI3IHTxyu2efkAPBKj.jpg?v=1788794798",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "life",
        "time",
        "bromelain",
        "dietary",
        "supplement",
        "tablets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 45,
        "sustainability": 55
      },
      "price": 34.26,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46877285122245",
      "vsf_explanation": "Life Time is a real Turkish supplement brand with a broad OTC nutraceutical line and mainstream pharmacy distribution in the Turkish market. Q-Bromelain is a two-ingredient formula pairing bromelain (a proteolytic enzyme from pineapple stems) with quercetin (a plant flavonoid). The pairing is a well-established combination in nutraceutical formulation — bromelain is thought to enhance quercetin absorption, and both are studied individually for inflammatory, immune, and allergy-adjacent endpoints (Shoskes 1999 chronic prostatitis, Meltzer 2020 allergic rhinitis for quercetin). What the product listing does not do is publish per-tablet milligrams of bromelain (in GDU or FIP units) or quercetin. Bromelain in particular is dose-sensitive — meaningful effects in the literature come from 500-2000 mg divided daily doses at defined enzymatic activity. Without those numbers, a class-level evidence lift can't be attributed to this product. Real brand, defensible ingredient pairing, honest ingredient naming — but the dose opacity is the ceiling on the score.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "species-nutrition-fiberlyze",
      "title": "Species Nutrition Fiberlyze",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Species-Nutrition-Fiberlyze.jpg?v=1788794825",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "species",
        "nutrition",
        "fiberlyze",
        "ultimate",
        "sport",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 58,
        "manufacturing": 62,
        "safety": 65,
        "transparency": 48,
        "sustainability": 55
      },
      "price": 29.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46877286039749",
      "vsf_explanation": "Species Nutrition is a legitimate specialty sports-nutrition brand associated with the bodybuilding-coaching community and has been in market for over a decade. Fiberlyze is a soluble-plus-insoluble fiber powder built around psyllium husk and wheat bran, positioned for cholesterol support, glycemic response, and regularity. The evidence base for these two ingredients is unusually strong — psyllium in particular has an FDA-authorized health claim for coronary heart disease risk reduction at 7 g/day soluble fiber from psyllium seed husk, and is one of the more robustly-studied nutraceuticals for cholesterol and glycemic response. The problem for the score is transparency: the product listing describes the ingredients but does not publish per-scoop milligrams of psyllium versus wheat bran on the product page, and does not specify whether the psyllium dose per scoop meets the FDA-recognized 7 g/day threshold. Suggested-use guidance recommends 1-3 scoops per day, which is appropriate for a titrated fiber product. Standard-tier on the strength of ingredient identity and evidence but blocked from Verified by dose opacity — a legitimate fiber product that could easily move up if per-scoop dosing were published.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "primal-queen-beef-organ-superfood-30-day-refill-female-optimized-beef-organ-superfood-supplement-beef-liver-kidney-heart-3-more-100-grass-fed-pasture-raised-cattle-balance-hormones-energy-more-for-women",
      "title": "Primal Queen Beef Organ Superfood - 30 Day Refill，Female-Optimized Beef Organ Superfood Supplement (Beef Liver, Kidney, Heart, & 3 More) - 100% Grass Fed, Pasture Raised Cattle - Balance Hormones, Energy, & More for Women",
      "vendor": "solostarhealth",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9895d86026ae83d8e07a28bc4545e01d.jpg?v=1788794849",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "primal",
        "queen",
        "beef",
        "organ",
        "superfood",
        "day",
        "refill",
        "female",
        "optimized",
        "beef",
        "organ",
        "superfood",
        "supplement",
        "beef",
        "liver",
        "kidney",
        "heart",
        "more",
        "100",
        "grass",
        "fed",
        "pasture",
        "raised",
        "cattle",
        "balance",
        "hormones",
        "energy",
        "more",
        "for",
        "women",
        "solostarhealth"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 45,
        "sustainability": 68
      },
      "price": 5.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46877286760645",
      "vsf_explanation": "Primal Queen is a real DTC brand in the ancestral-nutrition segment, positioned as the female-oriented counterpart to brands like Ancestral Supplements. The premise is desiccated bovine organ meat capsules (liver, kidney, heart, plus three additional organs) from 100% grass-fed pasture-raised cattle, framed around 'balance hormones, energy' claims for women. The provenance/sourcing story is a genuine strength: pasture-raised cattle desiccated at low temperature is a coherent, longstanding nutritional-tradition category. But the listing itself is thin — the product page ships an image-only description with no supplement facts, no per-organ milligrams, no serving size, no total capsule count called out at the title level, no third-party testing narrative. The $5.99 price point on the listing appears to be a promotional/refill anchor rather than the actual full-size price and adds to the difficulty of assessing what the buyer is receiving. Evidence for organ-meat capsules is largely traditional and anecdotal — there is no RCT for the female-hormone claim. Sits at the low end of Standard: real brand, real sourcing story, honest ancestral positioning, but insufficient label transparency and evidence to justify Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "biotin-10-000-mcg-tablets-100ct",
      "title": "Biotin 10,000 Mcg - Tablets 100Ct",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/120883165.jpg?v=1788794896",
      "score": 53,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "biotin",
        "000",
        "mcg",
        "tablets",
        "100ct",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 16.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46877288562885",
      "vsf_explanation": "Windmill's 10,000mcg biotin is a mega-dose — over 33,000% Daily Value — with weak human evidence for hair, skin or nails outside diagnosed deficiency. High-dose biotin also interferes with thyroid, troponin and hormone lab assays (FDA safety communication, 2017/2019).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "osteo-bi-flex-triple-strength-joint-health-supplement-glucosamine-chondroitin-coated-tablets",
      "title": "Osteo Bi-Flex Triple Strength, Joint Health Supplement, Glucosamine Chondroitin, Coated Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/110913439.jpg?v=1788794915",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "osteo",
        "flex",
        "triple",
        "strength",
        "joint",
        "health",
        "supplement",
        "glucosamine",
        "chondroitin",
        "coated",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 68,
        "safety": 80,
        "transparency": 55,
        "sustainability": 55
      },
      "price": 42.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46877288923333",
      "vsf_explanation": "Osteo Bi-Flex Triple Strength stacks glucosamine and chondroitin with its Joint Shield blend (5-Loxin Advanced AKBA from Boswellia). Marketing implies 7-day comfort; glucosamine/chondroitin evidence is mixed (GAIT trial), while 5-Loxin has moderate short-term RCT support.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "osteocare-90-tablets",
      "title": "Osteocare 90 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/qrBZCiSBOmDwUrUhFOTjFeYSX4OCY0AVzRSkFoAz.jpg?v=1788794949",
      "score": 74,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "osteocare",
        "tablets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 78,
        "manufacturing": 78,
        "safety": 82,
        "transparency": 78,
        "sustainability": 62
      },
      "price": 38.86,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46877290365125",
      "vsf_explanation": "Osteocare from Vitabiotics is the UK's category-leading bone-support formula and has been on sale for decades under one of the largest vitamin-and-mineral-supplement companies in Britain, with mainstream pharmacy distribution across the UK, Europe, and international markets. The formula is the textbook 'bone-health quartet' — calcium 800 mg, magnesium 250 mg, zinc 10 mg, and vitamin D 10 mcg per 2-tablet daily serving — with every milligram disclosed on the label. Calcium and vitamin D at these doses have long-standing evidence for bone mineral density support (e.g., Weaver 2016 NOF meta-analyses; Institute of Medicine 2011 DRI review). Magnesium at 250 mg is a functional dose that supports calcium metabolism; zinc rounds out cofactor coverage. Nothing exotic, nothing hidden, no proprietary blend. The formulation is conservative rather than cutting-edge (no K2-MK7, no vitamin K, no boron), which is why the score sits in the middle of the Verified band rather than the top. But for a shopper who wants a full-dose calcium-plus-D bone formula from a large, reputable brand with a long safety and sales history, Osteocare is exactly what the category is supposed to look like.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "21st-century-sentry-senior-50-womens-tablets-100ct",
      "title": "21st Century Sentry Senior 50 Womens Tablets 100Ct",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/78241736.jpg?v=1788794957",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "adults_50_plus",
      "tokens": [
        "21st",
        "century",
        "sentry",
        "senior",
        "womens",
        "tablets",
        "100ct",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 75,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 7.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46877290463429",
      "vsf_explanation": "21st Century Sentry Senior 50+ delivers a broad multivitamin/mineral base positioned for women over 50 (D3, B12, calcium, antioxidant blend). Generic senior formulation, budget positioning, and thin transparency on nutrient forms, sourcing and third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-skin-nails-and-hair-120-tablets",
      "title": "Solgar Skin Nails and Hair 120 Tablets",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33984017368.png?v=1788795009",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "skin",
        "nails",
        "and",
        "hair",
        "120",
        "tablets",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 75,
        "manufacturing": 80,
        "safety": 85,
        "transparency": 78,
        "sustainability": 60
      },
      "price": 24.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46877328965829",
      "vsf_explanation": "Solgar pairs OptiMSM (a branded, GMP-verified methylsulfonylmethane) with vitamin C and copper to support collagen inputs from within. Kosher/Halal/vegan-certified, KOF-K supervised, no proprietary blends, and mature manufacturing governance behind the label.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "21st-century-prostate-health-with-beta-sitosterol-125-mg-60-softgels",
      "title": "21st Century Prostate Health With Beta-Sitosterol, 125 Mg, 60 Softgels",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/P5530522_1.jpg?v=1788795015",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "21st",
        "century",
        "prostate",
        "health",
        "with",
        "beta",
        "sitosterol",
        "125",
        "softgels",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 55,
        "safety": 75,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 18.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46877329129669",
      "vsf_explanation": "21st Century supplies 125mg beta-sitosterol (from 450mg plant sterol esters) per serving — within the range studied for benign prostate symptoms in older meta-analyses. Budget-tier positioning, basic GMP, no third-party verification seal disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dynamic-saunas-elite-1-person-infrared-sauna-with-red-light-therapy",
      "title": "DYNAMIC SAUNAS Elite 1-Person Infrared Sauna with Red Light Therapy",
      "vendor": "Vyvata",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/UntitledDesign_93.png?v=1789335880",
      "score": 51,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dynamic",
        "saunas",
        "elite",
        "person",
        "infrared",
        "sauna",
        "with",
        "red",
        "light",
        "therapy",
        "vyvata"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 37,
        "formulation": 50,
        "manufacturing": 70,
        "safety": 46,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 1549.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46908534096069",
      "vsf_explanation": "This shares its manufacturing, transparency, and sustainability scores with the Dynamic Saunas Andora model in this batch since both come from the same manufacturer (Golden Designs) and carry the same ETL/CETL/CE certification and 5-year warranty terms; this is a smaller 1-person unit with fewer heating panels, which slightly lowers its formulation score. As with its sibling product, no study is cited for the device's specific parameters and no heat-exposure contraindications are disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "x-vcak-1-2-person-infrared-sauna-dry-heat-sauna-with-red-light-therapy-1",
      "title": "X-Vcak 1-2 Person Infrared Sauna, Dry Heat Sauna with Red Light Therapy",
      "vendor": "Vyvata",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/UntitledDesign_95.png?v=1789336140",
      "score": 37,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vcak",
        "person",
        "infrared",
        "sauna",
        "dry",
        "heat",
        "sauna",
        "with",
        "red",
        "light",
        "therapy",
        "vyvata"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 33,
        "formulation": 42,
        "manufacturing": 30,
        "safety": 38,
        "transparency": 38,
        "sustainability": 50
      },
      "price": 1624.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46908548939973",
      "vsf_explanation": "X-Vcak discloses a basic electrical safety feature (three-prong plug with leakage protection) and modest usage guidance (10-15 minute sessions, hydration reminder), but no formal certification body is named for electrical safety or EMF, and heat-exposure contraindications are absent.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dynamic-saunas-andora-2-person-infrared-sauna-with-red-light-therapy",
      "title": "DYNAMIC SAUNAS Andora 2-Person Infrared Sauna with Red Light Therapy",
      "vendor": "Vyvata",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/UntitledDesign_97.png?v=1789336469",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dynamic",
        "saunas",
        "andora",
        "person",
        "infrared",
        "sauna",
        "with",
        "red",
        "light",
        "therapy",
        "vyvata"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 54,
        "manufacturing": 70,
        "safety": 48,
        "transparency": 52,
        "sustainability": 55
      },
      "price": 2449.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46908575187141",
      "vsf_explanation": "Dynamic Saunas is a real, established manufacturer (part of Golden Designs, producing wellness products since 2008) with independently verifiable ETL, CETL, and CE electrical safety certification and a documented 5-year limited warranty — the strongest build-quality profile in this batch. It still falls short of the Standard tier because no study is cited for the device's specific therapeutic parameters and no heat-exposure contraindications are disclosed on the product page.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mnlr-2-person-infrared-home-sauna",
      "title": "MNLR 2 Person Infrared Home Sauna",
      "vendor": "Vyvata",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/UntitledDesign_99.png?v=1789336704",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mnlr",
        "person",
        "infrared",
        "home",
        "sauna",
        "vyvata"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 34,
        "formulation": 44,
        "manufacturing": 36,
        "safety": 45,
        "transparency": 42,
        "sustainability": 50
      },
      "price": 1149.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46908594258117",
      "vsf_explanation": "MNLR discloses a fairly detailed safety design — flame-retardant materials with an intelligent auto shut-off after 30 minutes of inactivity or a preset heating time — which is more specific than most competitors here. Still, no independent electrical certification body is named, and no contraindications for heat exposure are provided.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "retisland-1-person-far-infrared-sauna-with-low-emf-9-color-light-therapy",
      "title": "Retisland 1 Person FAR Infrared Sauna with Low EMF, 9 Color Light Therapy",
      "vendor": "Vyvata",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/UntitledDesign-2026-09-13T160309.387.png?v=1789337010",
      "score": 39,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "retisland",
        "person",
        "far",
        "infrared",
        "sauna",
        "with",
        "low",
        "emf",
        "color",
        "light",
        "therapy",
        "vyvata"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 34,
        "formulation": 42,
        "manufacturing": 36,
        "safety": 38,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 1649.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46908612247749",
      "vsf_explanation": "Retisland claims 'Certificated EMF (under 2mg)' but does not name the certifying organization, and includes a roof vent for air circulation which is a modest safety-conscious design detail. No UL/ETL/CE electrical certification is disclosed, and heat-exposure contraindications are absent from the listing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "real-relax-sauna-1-2-person-low-emf-infrared-sauna-with-red-light-therapy",
      "title": "Real Relax Sauna 1-2 Person Low EMF Infrared Sauna with Red Light Therapy",
      "vendor": "Vyvata",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/UntitledDesign-2026-09-13T160614.477.png?v=1789337192",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "real",
        "relax",
        "sauna",
        "person",
        "low",
        "emf",
        "infrared",
        "sauna",
        "with",
        "red",
        "light",
        "therapy",
        "vyvata"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 45,
        "manufacturing": 48,
        "safety": 40,
        "transparency": 42,
        "sustainability": 50
      },
      "price": 1849.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46908629024965",
      "vsf_explanation": "Real Relax is an established, independently operating sauna brand with its own storefront and a specific EMF claim ('Near Zero EMF Certification,' under 2mG), which supports a stronger manufacturing score than the generic listings in this batch, though no certifying body is named for that claim and no UL/ETL electrical certification is disclosed. No contraindications for heat exposure are provided anywhere in the listing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cedarluma-infrared-sauna-with-fda-certified-red-light-therapy-660nm-850nm",
      "title": "CedarLuma Infrared Sauna with FDA-Certified Red Light Therapy 660nm & 850nm",
      "vendor": "Vyvata",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/UntitledDesign-2026-09-13T161035.584.png?v=1789337453",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cedarluma",
        "infrared",
        "sauna",
        "with",
        "fda",
        "certified",
        "red",
        "light",
        "therapy",
        "660nm",
        "850nm",
        "vyvata"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 48,
        "manufacturing": 45,
        "safety": 48,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 1449.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46908643246277",
      "vsf_explanation": "CedarLuma is the most specific listing in this batch: it states a quantified EMF range (1.4-2.6mG), names literature-supported red/near-infrared wavelengths (660nm and 850nm), notes 'FDA-Registered' status for the light panel, and includes protective goggles for red-light use. It still stops short of full marks because 'FDA-registered' is a weaker claim than FDA clearance, no UL/ETL certification is named for the main heating unit, and no contraindications for heat exposure are disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "breezestival-wood-infrared-sauna-for-home-infdoor-home-sauna-with-red-light-1-person-infrared-sauna",
      "title": "Breezestival Wood Infrared Sauna for Home, Infdoor Home Sauna with Red Light, 1 Person Infrared Sauna",
      "vendor": "Vyvata",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/UntitledDesign-2026-09-13T161344.364.png?v=1789337643",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "breezestival",
        "wood",
        "infrared",
        "sauna",
        "for",
        "home",
        "infdoor",
        "home",
        "sauna",
        "with",
        "red",
        "light",
        "person",
        "infrared",
        "sauna",
        "vyvata"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 33,
        "formulation": 42,
        "manufacturing": 35,
        "safety": 35,
        "transparency": 42,
        "sustainability": 50
      },
      "price": 1049.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46908659171525",
      "vsf_explanation": "Breezestival's claims are comparatively modest (no disease or weight-loss language) and the listing discloses a one-year warranty and clear temperature/timer specs, which is a transparency positive relative to peers. However, no electrical certification body is named and contraindications for heat exposure are not disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dravonlab-2-person-far-infrared-sauna-wood-sauna-with-red-light-therapy",
      "title": "Dravonlab 2 Person Far Infrared Sauna, Wood Sauna with Red Light Therapy",
      "vendor": "Vyvata",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/UntitledDesign-2026-09-13T161748.008.png?v=1789337882",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dravonlab",
        "person",
        "far",
        "infrared",
        "sauna",
        "wood",
        "sauna",
        "with",
        "red",
        "light",
        "therapy",
        "vyvata"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 38,
        "manufacturing": 33,
        "safety": 33,
        "transparency": 38,
        "sustainability": 50
      },
      "price": 1749.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46908678209733",
      "vsf_explanation": "Dravonlab includes a 'standalone oxygen bar' claiming to release 'negative ions' for health benefit — a claim with limited credible clinical support that drags down the evidence score. No electrical safety certification body is named, and heat-related contraindications are not disclosed anywhere in the listing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pabimia-2-person-infrared-sauna",
      "title": "Pabimia 2-Person Infrared Sauna",
      "vendor": "Vyvata",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/UntitledDesign-2026-09-13T162110.647.png?v=1789338084",
      "score": 39,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pabimia",
        "person",
        "infrared",
        "sauna",
        "vyvata"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 42,
        "manufacturing": 35,
        "safety": 42,
        "transparency": 42,
        "sustainability": 50
      },
      "price": 1249.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46908690596037",
      "vsf_explanation": "Pabimia discloses real safety engineering (flame-retardant materials, automatic 30-minute shut-off) and a specific comfort temperature range, which is better documentation than several competitors in this batch, but no independent electrical certification body is named and no contraindications are disclosed. Evidence for infrared sauna recovery benefits exists at the category level but nothing here is cited to a specific study.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "kunsana-ceramic-infrared-sauna-2-person-infrared-sauna-w-red-light-therapy",
      "title": "Kunsana Ceramic Infrared Sauna 2 Person Infrared Sauna w/Red Light Therapy",
      "vendor": "Vyvata",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/UntitledDesign-2026-09-13T162559.383.png?v=1789338373",
      "score": 33,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "kunsana",
        "ceramic",
        "infrared",
        "sauna",
        "person",
        "infrared",
        "sauna",
        "red",
        "light",
        "therapy",
        "vyvata"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 28,
        "safety": 32,
        "transparency": 38,
        "sustainability": 50
      },
      "price": 1624.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46908707897541",
      "vsf_explanation": "The listing makes sweeping, uncited wellness claims (weight loss, 'cellular rejuvenation,' improved skin tone) without linking to any published research, and no electrical safety certification (UL/ETL/CE) or EMF testing body is named anywhere in the description. No contraindications for heat exposure are disclosed, which is a meaningful safety gap for an enclosed heated cabin.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nmn-supplement-1000-mg-99-9-pure-bontac®-β-nmn-made-in-japan",
      "title": "NMN Supplement 1000 mg | 99.9% Pure BONTAC® β-NMN | Made in Japan",
      "vendor": "NOVERA",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Novera_NMN_30000_60_Capsules.png?v=1789523395",
      "score": 76,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nmn",
        "supplement",
        "1000",
        "pure",
        "bontac",
        "nmn",
        "made",
        "japan",
        "novera"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 82,
        "manufacturing": 88,
        "safety": 78,
        "transparency": 78,
        "sustainability": 62
      },
      "price": 79.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46928542171333",
      "vsf_explanation": "Novera NMN 30,000 pushes the transparency envelope for the NAD+-precursor category. The formula uses BONTAC beta-NMN — a raw-material identity whose provenance is publicly documented; the same source has appeared in peer-reviewed preclinical work co-authored by a Harvard Medical School researcher (see the brand's linked evidence page). Dose is fully disclosed at 500 mg per capsule and 1,000 mg per serving (2 capsules), the finished product is manufactured in Japan under international GMP, each lot carries a batch-level 99.9%-purity certificate, and Novera includes a Certificate of Free Sale from the Japanese government — verification pathways almost no U.S. competitor exposes. Vegan HPMC capsule, 60 caps/30 servings, 30-day money-back. The catch — and it is a real one for a scoring rubric that rewards transparency — is regulatory: FDA communications in 2022 asserted that NMN cannot be marketed as a dietary supplement in the U.S. because it had been previously authorized for investigation as a drug. Enforcement has been inconsistent and NMN remains widely sold, but a fully honest score has to acknowledge that the U.S. legal status is unsettled. Held to Verified rather than Elite on that regulatory uncertainty plus the ordinary NAD+-precursor evidence gap (RCT endpoints for NMN in humans are still largely biomarker-only, not hard outcome).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "talya-nmn-nicotinamide-mononucleotide-dietary-supplement-30-capsules",
      "title": "Talya NMN Nicotinamide Mononucleotide Dietary Supplement 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/talya-nmn-nikotinamid-mononukleotid-30-kapsul-22914.jpg?v=1789529384",
      "score": 22,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "talya",
        "nmn",
        "nicotinamide",
        "mononucleotide",
        "dietary",
        "supplement",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 15,
        "manufacturing": 12,
        "safety": 30,
        "transparency": 15,
        "sustainability": 50
      },
      "price": 24.06,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46928772268229",
      "vsf_explanation": "Talya combines NMN with Pomegranate Peel Extract but discloses no milligram amount for either ingredient, so the dose cannot be checked against published NMN research (typically 250-900mg/day) or evaluated for the added extract. No manufacturing, testing, or sourcing information is provided beyond the generic marketing description.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nmn-1",
      "title": "NMN",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_8ce4c0da-46ff-4fbd-aac0-cf17f4efd4b7.png?v=1789529404",
      "score": 17,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nmn",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 10,
        "manufacturing": 10,
        "safety": 20,
        "transparency": 8,
        "sustainability": 50
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46928772923589",
      "vsf_explanation": "The product is titled simply 'NMN' with no brand name disclosed anywhere on the page, and unlike the other NMN listings in this batch, it does not even state a per-capsule milligram dose. Without a disclosed dose, it is impossible to compare this product against the 250-900mg range used in published NMN human trials.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "cramp-a-way",
      "title": "Cramp-A-Way",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_c39ce74e-a022-47a2-a1f1-5bb2bd0770fa.png?v=1789529410",
      "score": 16,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cramp",
        "way",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 10,
        "manufacturing": 10,
        "safety": 25,
        "transparency": 8,
        "sustainability": 50
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46928773382341",
      "vsf_explanation": "The product title 'Cramp-A-Way' carries no identifiable brand name, and the listing's marketing copy ('vitamins, minerals, and botanicals') names no specific ingredients or doses, making it impossible to evaluate evidence, formulation, or safety. This is functionally worse than a labeled proprietary blend, since not even a blend name or ingredient panel is disclosed.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "nad-advanced-500mg-liposomal-nad-with-resveratrol-nad-supplement-for-men-women-nmn-alternative-for-cellular-energy-healthy-aging-60-capsules-30-day-supply",
      "title": "NAD+ Advanced 500MG Liposomal NAD+ with Resveratrol - NAD Supplement for Men & Women - NMN Alternative for Cellular Energy & Healthy Aging - 60 Capsules, 30 Day Supply",
      "vendor": "solostarhealth",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f0941d93d902002c4c778ec92d1dd19e.jpg?v=1789529418",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy",
        "cardiovascular"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "nad",
        "advanced",
        "500mg",
        "liposomal",
        "nad",
        "with",
        "resveratrol",
        "nad",
        "supplement",
        "for",
        "men",
        "women",
        "nmn",
        "alternative",
        "for",
        "cellular",
        "energy",
        "healthy",
        "aging",
        "capsules",
        "day",
        "supply",
        "solostarhealth"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 15,
        "manufacturing": 10,
        "safety": 25,
        "transparency": 5,
        "sustainability": 50
      },
      "price": 5.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46928773644485",
      "vsf_explanation": "The product page consists of a single image and contains no descriptive text, ingredient list, directions, or company information, so no real brand can be identified from the title alone. Direct oral NAD+ (as opposed to NMN/NR precursors) also has weaker evidence for intact absorption, and the resveratrol amount is undisclosed, compounding the transparency failure.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "simple-nutritions-nmn-50-mg-dietary-supplement-60-capsules",
      "title": "Simple Nutritions NMN 50 mg Dietary Supplement 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/simple-nutritions-nmn-50-mg-60-kapsul-23195.jpg?v=1789529434",
      "score": 36,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "simple",
        "nutritions",
        "nmn",
        "dietary",
        "supplement",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 25,
        "manufacturing": 40,
        "safety": 40,
        "transparency": 35,
        "sustainability": 30
      },
      "price": 22.1,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46928774299845",
      "vsf_explanation": "NMN as an ingredient class has real published human research (Yoshino et al. 2021, Igarashi et al. 2022), but those trials used 250-900mg/day — this product's 50mg dose sits well below every studied range, making it sub-therapeutic rather than merely conservative. The product page's own 'Key Ingredients' list is empty, and no third-party testing, COA, or manufacturing disclosure is provided, so most quality dimensions default to zero under the zero-assumption rule.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "true-matrx-dna-support-supplement-2-11-oz-60-servings-86797-rev-1-bb-09-26",
      "title": "TRUE MATRX DNA Support Supplement 2.11 oz, 60 servings 86797 Rev 1 BB 09/26",
      "vendor": "PayWut",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/DA687F45-281A-47C6-A255-FA592FCC8E5E.jpg?v=1789529447",
      "score": 36,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "true",
        "matrx",
        "dna",
        "support",
        "supplement",
        "servings",
        "86797",
        "rev",
        "paywut"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 15,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 20,
        "sustainability": 25
      },
      "price": 50,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46928774758597",
      "vsf_explanation": "TRUE MATRX presents as a more formally manufactured product, with a lot/revision number and best-by dating suggesting real quality-control processes, and it combines two ingredients — NMN and trans-resveratrol — with reasonable individual research bases for cellular aging support. However, the listing discloses no milligram amount for either active ingredient, making it impossible to verify the formula delivers a studied or effective dose of either compound.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "alfenix-revinad-30-dr-capsules-with-nad-and-nmn-support",
      "title": "Alfenix Revinad 30 DR Capsules with NAD and NMN Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/revinad-30-dr-kapsul-19778.jpg?v=1789529457",
      "score": 26,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alfenix",
        "revinad",
        "capsules",
        "with",
        "nad",
        "and",
        "nmn",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 15,
        "manufacturing": 30,
        "safety": 55,
        "transparency": 15,
        "sustainability": 20
      },
      "price": 115.1,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46928775119045",
      "vsf_explanation": "The product name claims 'NAD and NMN Support,' but the only disclosed key ingredient is trigonelline (from fenugreek) — no NMN, NAD+, or NAD+ precursor beyond trigonelline itself is listed anywhere in the formula, and no dose is disclosed for the fenugreek extract either. Trigonelline has limited emerging research related to NAD+ biosynthesis pathways, but marketing the product's name around 'NMN Support' when NMN is not a disclosed ingredient is a meaningful mismatch between naming and actual contents.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "nutrient-extraction-supplement-capsules",
      "title": "Nutrient Extraction Supplement Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c9c08dea-0048-4f8b-8ada-9f14cb246137.jpg?v=1789529482",
      "score": 5,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrient",
        "extraction",
        "supplement",
        "capsules",
        "perfecsy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 10,
        "safety": 10,
        "transparency": 0,
        "sustainability": 20
      },
      "price": 15.67,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46928775971013",
      "vsf_explanation": "This listing's title, 'Nutrient Extraction Supplement Capsules,' does not identify a single active ingredient, dosage, health claim, or intended use — the entire product description contains only generic packaging details (60 tablets, 'production process: extraction'). With no disclosed ingredients whatsoever, it is impossible to assess evidence, formulation, or safety, and no brand is identifiable.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "nad-capsules-resveratrol-liposomal-nicotinamide-riboside-quercetin-vitamin-b3-nad-supplement-for-women-and-men-anti-aging-boost-focus-and-energy-cell-regeneration-supplement-120-capsules",
      "title": "NAD Capsules Resveratrol Liposomal Nicotinamide Riboside Quercetin Vitamin B3 NAD Supplement for Women and Men Anti Aging Boost Focus and Energy Cell Regeneration Supplement 120 Capsules",
      "vendor": "Zamzamas",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/353a945a-e9cd-499b-bfd6-ba8f88ac648b.jpg?v=1789529519",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy",
        "cardiovascular",
        "cognitive"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "nad",
        "capsules",
        "resveratrol",
        "liposomal",
        "nicotinamide",
        "riboside",
        "quercetin",
        "vitamin",
        "nad",
        "supplement",
        "for",
        "women",
        "and",
        "men",
        "anti",
        "aging",
        "boost",
        "focus",
        "and",
        "energy",
        "cell",
        "regeneration",
        "supplement",
        "120",
        "capsules",
        "zamzamas"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 8,
        "manufacturing": 15,
        "safety": 40,
        "transparency": 8,
        "sustainability": 20
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46928778035397",
      "vsf_explanation": "This listing has an extremely keyword-stuffed title with no identifiable brand, and combines resveratrol, liposomal nicotinamide riboside, quercetin, and vitamin B3 with zero per-ingredient dosing disclosed anywhere on the page. Broad, unsubstantiated claims around anti-aging, focus, energy, and cell regeneration are made without any supporting citations or dosage transparency, consistent with a generic, unverified dropshipped listing.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "magnesium-glycinate-softgels-400mg-sleep-softgels-for-kids-adults-magnesium-glycinate-high-absorption-for-muscle-recovery-better-sleep-relaxation-60-count-pineapple",
      "title": "Magnesium Glycinate Softgels 400mg   Sleep Softgels for Kids & Adults   Magnesium Glycinate High Absorption for Muscle Recovery Better Sleep & Relaxation 60 Count Pineapple",
      "vendor": "Zamzamas",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e5f3f33d-8f3c-48a0-bbdd-8e60f156dc37.jpg?v=1789529529",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "youth_under_18",
      "tokens": [
        "magnesium",
        "glycinate",
        "softgels",
        "400mg",
        "sleep",
        "softgels",
        "for",
        "kids",
        "adults",
        "magnesium",
        "glycinate",
        "high",
        "absorption",
        "for",
        "muscle",
        "recovery",
        "better",
        "sleep",
        "relaxation",
        "count",
        "pineapple",
        "zamzamas"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 15,
        "safety": 35,
        "transparency": 10,
        "sustainability": 20
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46928778363077",
      "vsf_explanation": "Magnesium glycinate has reasonable evidence supporting muscle relaxation, sleep quality, and general nervous-system function, but this listing discloses no identifiable brand or manufacturer anywhere in the title or description. It is unclear whether the stated 400mg refers to elemental magnesium or the magnesium glycinate compound weight, a common and materially significant mislabeling issue in this category. Marketing the same undifferentiated dose to both 'kids and adults' without any age-specific dosing guidance is a further safety-transparency concern.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "liposomal-nicotinamide-riboside-900mg-resveratrol-quercetin-nad-supplement-plus-for-anti-aging-cellular-energy-improve-health-80-capsules-1",
      "title": "Liposomal Nicotinamide Riboside 900mg Resveratrol & Quercetin – NAD Supplement Plus for Anti Aging, Cellular Energy & Improve Health- 80 Capsules",
      "vendor": "solostarhealth",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/fad5cefbd058f0a5195696a88208b4b9_54cda168-fe5c-4bb0-91ca-6da048e9b402.jpg?v=1789529549",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liposomal",
        "nicotinamide",
        "riboside",
        "900mg",
        "resveratrol",
        "quercetin",
        "nad",
        "supplement",
        "plus",
        "for",
        "anti",
        "aging",
        "cellular",
        "energy",
        "improve",
        "health",
        "capsules",
        "solostarhealth"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 8,
        "manufacturing": 15,
        "safety": 40,
        "transparency": 10,
        "sustainability": 20
      },
      "price": 5.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46928779083973",
      "vsf_explanation": "No brand is identifiable on this listing, whose entire product description consists of a single embedded image with no text content, ingredient breakdown, or dosing information beyond the title. The title bundles three actives — nicotinamide riboside, resveratrol, and quercetin — under a single '900mg' figure with no per-ingredient dose disclosed, making it impossible to verify how much of any individual compound the product actually delivers.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "nmn-500mg-nad-booster-for-cellular-energy-peak-performance",
      "title": "NMN 500mg | NAD+ Booster for Cellular Energy & Peak Performance",
      "vendor": "Halea Life: Nutrition & Skincare",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1776703077441-generated-label-image-0.jpg?v=1789529558",
      "score": 67,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nmn",
        "500mg",
        "nad",
        "booster",
        "for",
        "cellular",
        "energy",
        "peak",
        "performance",
        "halea",
        "life",
        "nutrition",
        "skincare"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 85,
        "manufacturing": 50,
        "safety": 85,
        "transparency": 75,
        "sustainability": 35
      },
      "price": 24.96,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46928779411653",
      "vsf_explanation": "Halea Life discloses a clean, single-ingredient 500mg NMN formula with only three additional excipients and no proprietary blend, and 500mg sits within the roughly 250-900mg range used in published human NMN trials, so the dose itself is credible rather than under- or over-dosed. NMN's human evidence base is moderate and still developing relative to more established longevity ingredients. No third-party manufacturing certification or facility detail is disclosed, which limits build-quality confidence, and sustainability information is not provided.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-niacin-vitamin-b3-500-mg-100-vegetable-capsules-5oz",
      "title": "Solgar Niacin Vitamin B3 500 mg - 100 Vegetable Capsules - 5Oz",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SO_018518_F_1.png?v=1789529567",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "niacin",
        "vitamin",
        "500",
        "100",
        "vegetable",
        "capsules",
        "5oz",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 75,
        "manufacturing": 85,
        "safety": 75,
        "transparency": 72,
        "sustainability": 50
      },
      "price": 16.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46928779673797",
      "vsf_explanation": "Niacin (vitamin B3) has well-established evidence for carbohydrate and protein metabolism, cardiovascular health, and nervous system function, and this is a clean single-ingredient formula with the dose clearly disclosed. 500mg is on the higher end of common OTC niacin doses and can commonly cause a temporary flushing sensation, which the listing does not call out as a contraindication or side effect — a modest safety-disclosure gap. Manufacturing, transparency, and sustainability reflect Solgar's brand-wide standards.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-cellular-energy-28-capsules",
      "title": "Solgar Cellular Energy 28 Capsules",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/solgar-cellular-energy-28-kapsul--6c50_ef5cdb0e-aa96-4b0c-b3b3-c66c68058e6e.jpg?v=1789529578",
      "score": 75,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "cellular",
        "energy",
        "capsules",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 78,
        "manufacturing": 85,
        "safety": 88,
        "transparency": 72,
        "sustainability": 50
      },
      "price": 120.82,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46928780099781",
      "vsf_explanation": "This Solgar formula uses patented nicotinamide riboside chloride alongside a full spectrum of B vitamins and vitamin C, with every ingredient's milligram amount clearly disclosed on the label — a strong formulation-transparency signal and no proprietary blend. Nicotinamide riboside and B-vitamin evidence for cellular energy support is reasonable but still developing for the broader 'cellular energy' framing. Manufacturing, transparency, and sustainability reflect Solgar's brand-wide quality standards, consistent across the company's product line.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "slimming-health-boost-drops-1",
      "title": "Slimming  Health Boost Drops",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/980d74c2-829f-4f20-98c1-38b55239f6fd.jpg?v=1789529595",
      "score": 12,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "slimming",
        "health",
        "boost",
        "drops",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 8,
        "formulation": 5,
        "manufacturing": 12,
        "safety": 30,
        "transparency": 8,
        "sustainability": 20
      },
      "price": 18.58,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46928780591301",
      "vsf_explanation": "No brand is identifiable anywhere on this listing, and the four-ingredient blend (moringa leaf extract, citrus essential oil, peppermint essential oil, stevia leaf extract) is disclosed with zero dosage information for any component. There is no clinical evidence supporting this specific combination for weight management or general health, and the listing shows the hallmarks of a generic, unverified dropshipped product.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "venatura-lipozomal-nmn-dietary-supplement-anti-aging-cellular-health-support-60-capsules",
      "title": "VeNatura Lipozomal NMN Dietary Supplement - Anti-aging, Cellular Health Support, 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/sEaGlszaGwbTOxcGiNYDlqn74Rnd6kVBcu1zASkr.jpg?v=1789529611",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "venatura",
        "lipozomal",
        "nmn",
        "dietary",
        "supplement",
        "anti",
        "aging",
        "cellular",
        "health",
        "support",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 10,
        "manufacturing": 35,
        "safety": 75,
        "transparency": 55,
        "sustainability": 30
      },
      "price": 42.72,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46928781246661",
      "vsf_explanation": "This product discloses only 50mg of NMN per capsule at one capsule daily, well below the roughly 250-900mg daily doses used in the published human NMN trials that underpin the ingredient's evidence base — this is a sub-therapeutic dose relative to the research the marketing implicitly leans on. The 'liposomal' bioavailability claim is not independently substantiated. While the formula and dose are clearly disclosed (a transparency positive) and NMN has a favorable safety profile even at low doses, the dose itself is unlikely to deliver the cellular-health or anti-aging effects referenced in the product description.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "simple-nutritions-nr-300-mg-nicotinamide-riboside-30-capsules",
      "title": "Simple Nutritions NR 300 mg Nicotinamide Riboside 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/simple-nutritions-nr-300-30-kapsul-23194.jpg?v=1789529623",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "simple",
        "nutritions",
        "300",
        "nicotinamide",
        "riboside",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 72,
        "manufacturing": 40,
        "safety": 85,
        "transparency": 35,
        "sustainability": 30
      },
      "price": 56.2,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46928781738181",
      "vsf_explanation": "Nicotinamide riboside has a reasonable and growing human evidence base for safely raising NAD+ levels, and 300mg is within the commonly studied and marketed dose range for NR products. This is a single-ingredient formula with a clearly stated dose, which helps formulation transparency, but the brand discloses no third-party certification, sourcing information, or manufacturing facility detail, which limits confidence relative to more established longevity brands.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "glp-1-supplement-liquid-drops-nad-blood-sugar-control-for-women-men-metabolism-booster-weight-management-for-women",
      "title": "Glp-1 Supplement Liquid Drops Nad Blood Sugar Control For Women Men Metabolism Booster & Weight Management  For Women",
      "vendor": "Pet Zen",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Sb13a47097a75435a8d29f4abf0d4d603y.webp?v=1789529635",
      "score": 9,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "glp",
        "supplement",
        "liquid",
        "drops",
        "nad",
        "blood",
        "sugar",
        "control",
        "for",
        "women",
        "men",
        "metabolism",
        "booster",
        "weight",
        "management",
        "for",
        "women",
        "pet",
        "zen"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 5,
        "formulation": 5,
        "manufacturing": 10,
        "safety": 15,
        "transparency": 5,
        "sustainability": 20
      },
      "price": 59.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46928782098629",
      "vsf_explanation": "This listing names itself a 'GLP-1 Supplement' with claims of 'blood sugar control,' language that directly invokes a prescription drug class (GLP-1 receptor agonists) without any clinical substantiation, ingredient list, or dosage disclosure — the product description only vaguely references a 'natural herbal formula.' The disclosed brand name is an unverifiable white-label supplier with no public quality track record, and no evidence supports the metabolic or blood-sugar claims made on the page.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "moringa-slimming-health-drops",
      "title": "Moringa Slimming Health Drops",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/66052295-db78-4368-af30-c358fbbc24c8.jpg?v=1789529650",
      "score": 12,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "moringa",
        "slimming",
        "health",
        "drops",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 5,
        "manufacturing": 15,
        "safety": 20,
        "transparency": 10,
        "sustainability": 20
      },
      "price": 17.81,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46928782590149",
      "vsf_explanation": "This listing discloses no identifiable brand and combines eight-plus active ingredients — apple vinegar powder, green tea extract, moringa, turmeric, an NAD+/NR mixture, echinacea, ginkgo, and a probiotic blend — with zero dosage information for any of them, making it impossible to assess whether any ingredient is present at an effective or even meaningful level. There is no clinical evidence supporting this specific combination for 'slimming,' and the listing bears the hallmarks of a generic dropshipped product rather than a formulated, quality-controlled supplement.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "reflex-creapure-creatine-500-gr",
      "title": "Reflex Creapure Creatine 500 Gr",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/reflex_creapure_creatine_500_gr_38874.jpg?v=1789529716",
      "score": 83,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "reflex",
        "creapure",
        "creatine",
        "500",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 95,
        "formulation": 90,
        "manufacturing": 76,
        "safety": 92,
        "transparency": 78,
        "sustainability": 40
      },
      "price": 110.12,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46928785146053",
      "vsf_explanation": "Creatine monohydrate is one of the most extensively studied and effective supplements in sports nutrition, backed by decades of RCTs and a strong safety record, and this product uses Creapure — the pharmaceutical-grade, German-manufactured creatine raw material recognized for high purity and low levels of manufacturing byproducts. The formula is 100% creatine monohydrate at a standard 5g serving with no proprietary blend. The listing doesn't disclose independent batch-testing or facility certification specific to this SKU, which keeps manufacturing confidence a notch below top-tier scores, and no sustainability information is provided.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-ester-c-plus-1000-mg-vitamin-c-50-capsules",
      "title": "Solgar Ester-C Plus 1000 Mg Vitamin C 50 Capsules",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/94051161.jpg?v=1789572292",
      "score": 80,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "ester",
        "plus",
        "1000",
        "vitamin",
        "capsules",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 80,
        "formulation": 82,
        "manufacturing": 85,
        "safety": 90,
        "transparency": 72,
        "sustainability": 50
      },
      "price": 18.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46940492038341",
      "vsf_explanation": "Ester-C is a patented, buffered vitamin C form with published data showing extended retention in white blood cells compared to standard ascorbic acid, giving it a slightly stronger evidence footing than plain vitamin C. The 1000mg dose sits comfortably within the studied and generally-regarded-as-safe range for vitamin C (well under the 2,000mg/day tolerable upper intake level), and the buffered form is gentler on the stomach. Manufacturing, transparency, and sustainability scores reflect Solgar's brand-wide quality practices, consistent with the company's other listings in this batch.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "21st-century-b-complex-plus-vitamin-c-100-tablets",
      "title": "21st Century B Complex Plus Vitamin C - 100 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/329952923.jpg?v=1789572298",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive",
        "mood",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "21st",
        "century",
        "complex",
        "plus",
        "vitamin",
        "100",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 75,
        "manufacturing": 65,
        "safety": 88,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 7.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46940492103877",
      "vsf_explanation": "21st Century is a recognizable value-tier vitamin brand with a full B-complex plus vitamin C formula and no hidden proprietary blend. B vitamins have solid evidence for supporting energy metabolism and nervous system function in people with intake gaps, though the 'energy support' framing overstates benefit for people who are not deficient. The listing offers no third-party certification, COA, or sourcing detail beyond a generic 'laboratory tested' claim, which caps transparency and manufacturing confidence relative to premium-tier brands.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "solgar-vitamin-c-500mg-100-vegetable-capsules",
      "title": "Solgar Vitamin C 500mg 100 Vegetable Capsules",
      "vendor": "Solgar",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/33984032606.png?v=1789572313",
      "score": 79,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "solgar",
        "vitamin",
        "500mg",
        "100",
        "vegetable",
        "capsules",
        "solgar"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 80,
        "manufacturing": 85,
        "safety": 90,
        "transparency": 72,
        "sustainability": 50
      },
      "price": 12.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46940492300485",
      "vsf_explanation": "Solgar is a long-established supplement manufacturer with a reputation for rigorous in-house quality control, and this is a clean, single-ingredient 500mg vitamin C formula with a full excipient disclosure. Vitamin C's role in immune function, collagen synthesis, and antioxidant defense is well documented, and the dose is squarely within the studied and safe supplementation range. Manufacturing and sustainability figures reflect brand-level standards shared across Solgar's product line, since Solgar's facility practices apply company-wide.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nature-made-vitamin-c-500-mg-caplets-with-rose-hips-130ct",
      "title": "Nature Made Vitamin C 500 Mg Caplets With Rose Hips - 130ct",
      "vendor": "Nature Made",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/120877077.jpg?v=1789572338",
      "score": 78,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "made",
        "vitamin",
        "500",
        "caplets",
        "with",
        "rose",
        "hips",
        "130ct",
        "nature",
        "made"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 80,
        "manufacturing": 85,
        "safety": 90,
        "transparency": 70,
        "sustainability": 50
      },
      "price": 12.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46940492529861",
      "vsf_explanation": "Nature Made is a well-established, USP Verified vitamin brand, and 500mg of vitamin C is a standard, well-studied supplementation dose for immune and antioxidant support. Formulation is single-ingredient with no proprietary blend, and the USP verification mark gives above-average confidence in potency and manufacturing quality. Vitamin C has an excellent long-term safety record at this dose. Sustainability practices are not disclosed on the listing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bluebonnet-optimum-vitamin-c-formula-90-vegetable-capsules",
      "title": "Bluebonnet Optimum Vitamin C Formula, 90 Vegetable Capsules",
      "vendor": "Bluebonnet",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/743715005327F_bwhgzr.jpg?v=1789572374",
      "score": 67,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bluebonnet",
        "optimum",
        "vitamin",
        "formula",
        "vegetable",
        "capsules",
        "bluebonnet"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 75,
        "manufacturing": 55,
        "safety": 80,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 31.25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46940495052997",
      "vsf_explanation": "Bluebonnet's Optimum-C formula discloses a specific 1,000mg vitamin C dose from buffered calcium ascorbate plus a named, sourced ingredient — Leucoselect grape seed extract from Indena, a recognized specialty raw-material supplier — alongside rose hips, acerola, and citrus bioflavonoids, giving unusually specific formulation transparency for this category. Vitamin C and grape seed extract both have solid evidence for antioxidant and immune support. The listing discloses Kosher certification and a full major-allergen-free statement, and Bluebonnet is an established, identifiable supplement manufacturer, though specific third-party GMP or NSF facility certification isn't stated in this listing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "halal-iron-vitamin-c-capsules",
      "title": "Halal Iron + Vitamin C Capsules",
      "vendor": "Zaytun Vitamins",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_c956e6bb-14c6-4c0f-af6e-30e66d829dbe.png?v=1789572422",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "halal",
        "iron",
        "vitamin",
        "capsules",
        "zaytun",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 35,
        "manufacturing": 35,
        "safety": 45,
        "transparency": 25,
        "sustainability": 50
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46940496888005",
      "vsf_explanation": "Pairing iron with vitamin C is a well-supported combination since vitamin C meaningfully improves non-heme iron absorption, and the use of ferrous bisglycinate chelate is a genuinely good formulation choice for GI tolerability. The listing does not disclose the actual milligram dose of iron per capsule, which is a real safety gap given that iron overdose is one of the more dangerous outcomes of unsupervised supplementation, particularly for non-deficient users. No brand or manufacturer is identified beyond 'Made in the USA with ethically sourced ingredients' and a halal certification claim.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "halal-fish-oil-omega-3-halal-gelatin-softgels",
      "title": "Halal Fish Oil Omega-3 (Halal Gelatin) Softgels",
      "vendor": "Zaytun Vitamins",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Fish-Oil-Omega-3-Bottle.png?v=1789572479",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "halal",
        "fish",
        "oil",
        "omega",
        "halal",
        "gelatin",
        "softgels",
        "zaytun",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 55,
        "manufacturing": 38,
        "safety": 75,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46940497772741",
      "vsf_explanation": "Omega-3 fatty acids from fish oil have strong, consistent evidence for cardiovascular and cognitive support, and this softgel discloses 1,200mg per serving sourced from wild-caught anchovies and sardines with claimed purification for heavy metals. The listing doesn't break out actual EPA/DHA content within that 1,200mg total, which is the figure that matters most when comparing against the clinical literature. No specific brand or manufacturer is identified beyond 'Made in the USA' and halal certification, limiting independent verification of purity testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "halal-prenatal-vitamins-dha-ginger",
      "title": "Halal Prenatal Vitamins + DHA & Ginger",
      "vendor": "Zaytun Vitamins",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/PRENATALListingimages_1.png?v=1789572479",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "female",
      "life_stage": "prenatal",
      "tokens": [
        "halal",
        "prenatal",
        "vitamins",
        "dha",
        "ginger",
        "zaytun",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 30,
        "manufacturing": 32,
        "safety": 45,
        "transparency": 25,
        "sustainability": 50
      },
      "price": 21.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46940497739973",
      "vsf_explanation": "Prenatal supplementation with folic acid, iron, and DHA has strong evidence for supporting maternal health and fetal neurodevelopment, but this listing discloses none of the actual amounts of folic acid, iron, or DHA per serving — a critical gap for a product pregnant users are meant to take daily for months. Because prenatal formulas carry real overdose risk for nutrients like iron and vitamin A when doses are unknown, the lack of disclosure here is a meaningful safety concern, not just a transparency one. No manufacturer or brand is identified beyond 'Made in the USA' and a halal certification claim.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "halal-coq-10-vitamin-e-softgels-3-pack",
      "title": "Halal CoQ-10 + Vitamin E Softgels (3-Pack)",
      "vendor": "Zaytun Vitamins",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitled-2_50068613-0534-4989-bf92-7485b60e0edd.png?v=1789572479",
      "score": 39,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "halal",
        "coq",
        "vitamin",
        "softgels",
        "pack",
        "zaytun",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 20,
        "manufacturing": 22,
        "safety": 70,
        "transparency": 20,
        "sustainability": 50
      },
      "price": 52.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46940497805509",
      "vsf_explanation": "CoQ10 has moderate evidence for cardiovascular and mitochondrial support, particularly for statin users, but this listing never discloses the actual milligram dose of CoQ10 per softgel — describing it only as a 'pure, potent, and clean formula.' Without a stated dose, it's impossible to compare this product against the 100–200mg range used in most clinical research on CoQ10. No brand or manufacturer is identified beyond a halal certification claim.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "halal-magnesium-glycinate-tablets",
      "title": "Halal Magnesium Glycinate Tablets",
      "vendor": "Zaytun Vitamins",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_7e3eef69-347e-4f0b-82d7-6b6876ce6fd5.png?v=1789572479",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "halal",
        "magnesium",
        "glycinate",
        "tablets",
        "zaytun",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 20,
        "manufacturing": 32,
        "safety": 75,
        "transparency": 22,
        "sustainability": 50
      },
      "price": 16.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46940497838277",
      "vsf_explanation": "Magnesium glycinate is a well-absorbed, well-tolerated form of magnesium with reasonable evidence for muscle relaxation and nervous-system support, but this listing discloses no milligram dose per tablet, describing it only as a 'high absorption formula.' Without a known dose, it can't be compared to the 200–400mg elemental magnesium range typically used in supporting research. No manufacturer or brand is identified beyond 'Made in the USA' and a halal certification claim.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "halal-vitamin-d3-5000-iu-softgels",
      "title": "Halal Vitamin D3 5000 IU Softgels",
      "vendor": "Zaytun Vitamins",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Vitamin_D3_5000IU_Softgels_a04b7070-01f7-46e9-81f1-b6763760687c.png?v=1789572479",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "halal",
        "vitamin",
        "5000",
        "softgels",
        "zaytun",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 55,
        "manufacturing": 32,
        "safety": 65,
        "transparency": 35,
        "sustainability": 50
      },
      "price": 17.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46940497871045",
      "vsf_explanation": "Vitamin D3 has strong evidence for bone health and immune function, and this softgel discloses a specific 5,000 IU dose — a commonly sold high-potency maintenance dose that sits modestly above the 4,000 IU/day tolerable upper intake level set for general adult use without monitoring, though it is widely sold and used at this level. No brand or manufacturer is identified beyond 'Made in the USA' and a halal certification claim, which limits verification of potency testing and quality control.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "halal-black-seed-oil-veggie-capsules",
      "title": "Halal Black Seed Oil Veggie Capsules",
      "vendor": "Zaytun Vitamins",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Blackseedlistingimages_1.png?v=1789572479",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "halal",
        "black",
        "seed",
        "oil",
        "veggie",
        "capsules",
        "zaytun",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 20,
        "manufacturing": 22,
        "safety": 65,
        "transparency": 22,
        "sustainability": 50
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46940497903813",
      "vsf_explanation": "Black seed oil (Nigella sativa) has emerging but still limited clinical evidence for anti-inflammatory and immune benefits, well short of the established evidence base for more mainstream ingredients. The listing discloses no milligram dose of black seed oil per capsule, making it impossible to compare against the doses used in the available research. No brand or manufacturer is identified beyond a halal certification and a non-GMO, cold-pressed sourcing claim.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "halal-fish-oil-omega-3-halal-gelatin-softgels-3pack",
      "title": "Halal Fish Oil Omega-3 (Halal Gelatin) Softgels (3Pack)",
      "vendor": "Zaytun Vitamins",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3-Pack.png?v=1789572479",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "halal",
        "fish",
        "oil",
        "omega",
        "halal",
        "gelatin",
        "softgels",
        "3pack",
        "zaytun",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 55,
        "manufacturing": 38,
        "safety": 75,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 51.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46940497936581",
      "vsf_explanation": "This is the same fish oil formula as the single-pack listing, sold in a larger 360-softgel (12-month) quantity — 1,200mg per softgel sourced from wild-caught anchovies and sardines, with a claimed purification step for heavy metals. Omega-3 fatty acids carry strong cardiovascular and cognitive evidence, though the listing still doesn't specify actual EPA/DHA content within the 1,200mg total. No specific brand or manufacturer is identified beyond 'Made in the USA' and halal certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "halal-vitamin-d3-5000-iu-softgels-3pack",
      "title": "Halal Vitamin D3 5000 IU Softgels (3Pack)",
      "vendor": "Zaytun Vitamins",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Halal-Vitamin-D-3Pack.png?v=1789572479",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "halal",
        "vitamin",
        "5000",
        "softgels",
        "3pack",
        "zaytun",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 55,
        "manufacturing": 32,
        "safety": 65,
        "transparency": 35,
        "sustainability": 50
      },
      "price": 47.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46940498002117",
      "vsf_explanation": "This is the same 5,000 IU vitamin D3 formula as the single-pack listing, sold in a larger 540-softgel (18-month) quantity. Vitamin D3 has strong evidence for bone health and immune function, and the specific IU dose is disclosed, though it sits modestly above the 4,000 IU/day general adult upper limit for unsupervised long-term use. No brand or manufacturer is identified beyond 'Made in the USA' and a halal certification claim, limiting verification of potency and quality control.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "halal-vitamin-c-tablets",
      "title": "Halal Vitamin C Tablets",
      "vendor": "Zaytun Vitamins",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/VitCAmazonlisting_1.png?v=1789572479",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "halal",
        "vitamin",
        "tablets",
        "zaytun",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 25,
        "manufacturing": 22,
        "safety": 75,
        "transparency": 22,
        "sustainability": 50
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46940497969349",
      "vsf_explanation": "Vitamin C from rose hips and natural herbs has strong, well-established evidence for immune support and antioxidant activity, but this listing discloses no milligram dose per tablet, only broad claims of being a 'powerful' antioxidant. Without a stated dose, the product can't be benchmarked against the levels used in supporting clinical research. No brand or manufacturer is identified beyond a halal certification claim.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "halal-multivitamin-tablets",
      "title": "Halal Multivitamin Tablets",
      "vendor": "Zaytun Vitamins",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Halal-Multivitamin-Tablets.png?v=1789572480",
      "score": 47,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "halal",
        "multivitamin",
        "tablets",
        "zaytun",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 30,
        "manufacturing": 35,
        "safety": 70,
        "transparency": 35,
        "sustainability": 50
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46940498034885",
      "vsf_explanation": "This multivitamin covers 28 vitamins and minerals in a single daily tablet, including a full B-complex, vitamin C, D3, A, E, zinc, and magnesium — a reasonably comprehensive foundational formula. The listing names the included nutrients without disclosing individual amounts or %DV for any of them, which prevents verification against RDA and upper-limit guidance. It does disclose it is made in the USA with ethically sourced ingredients and halal certified by a named certifying body (Islamic Services of America), more disclosure than most items in this batch, though a specific manufacturer or brand is still not identified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "halal-collagen-peptides-powder",
      "title": "Halal Collagen Peptides Powder",
      "vendor": "Zaytun Vitamins",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_79c8bcd3-a225-472d-92ea-e2a5273d0140.png?v=1789572479",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "halal",
        "collagen",
        "peptides",
        "powder",
        "zaytun",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 65,
        "manufacturing": 32,
        "safety": 80,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 23.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46940498067653",
      "vsf_explanation": "This hydrolyzed Type I & III collagen peptide powder discloses a clear 11g per serving dose, which aligns well with the 10–15g range used in most collagen research for skin, joint, and gut support — a real formulation strength for this batch. Collagen peptides carry a strong safety profile with minimal known risk. The product is undermined by the absence of any identifiable brand or manufacturer beyond 'Made in the USA' and a halal certification claim, which limits independent verification of sourcing and purity testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-c-vitamin-b-12-black-seed-oil-bundle",
      "title": "Vitamin C + Vitamin B-12 + Black Seed Oil Bundle",
      "vendor": "Zaytun Vitamins",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MEN_6_82467484-2d7d-44fb-8ef6-8bf9251230b6.jpg?v=1789572479",
      "score": 14,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "vitamin",
        "black",
        "seed",
        "oil",
        "bundle",
        "zaytun",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 5,
        "manufacturing": 10,
        "safety": 20,
        "transparency": 5,
        "sustainability": 50
      },
      "price": 35.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46940498100421",
      "vsf_explanation": "This bundle listing has no product description at all — no ingredients, no doses, no manufacturer, and no usage information of any kind. Under Vyvata's Zero-Assumption Rule, undisclosed data scores zero, and this listing discloses essentially nothing beyond the bundle's name. Even though vitamin C, B12, and black seed oil are individually reasonable ingredient choices, there is no way to verify what this specific bundle actually contains or in what amounts.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "halal-calcium-vitamin-d3-tablets",
      "title": "Halal Calcium + Vitamin D3 Tablets",
      "vendor": "Zaytun Vitamins",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/front.png?v=1789572479",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "halal",
        "calcium",
        "vitamin",
        "tablets",
        "zaytun",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 25,
        "manufacturing": 25,
        "safety": 70,
        "transparency": 25,
        "sustainability": 50
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46940498133189",
      "vsf_explanation": "Calcium paired with vitamin D3 is a well-established combination for bone density support, since D3 meaningfully improves calcium absorption. This listing discloses no milligram or IU amounts for either ingredient, only that it's a 'premium' formulation — a significant gap for nutrients where both under- and over-supplementation carry real considerations. No brand or manufacturer is identified beyond a halal certification claim from a named certifying body.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "halal-zinc-tablets",
      "title": "Halal Zinc Tablets",
      "vendor": "Zaytun Vitamins",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_7401dda9-0ba1-418c-932d-ceec9a75e730.png?v=1789572499",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "halal",
        "zinc",
        "tablets",
        "zaytun",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 40,
        "manufacturing": 22,
        "safety": 40,
        "transparency": 25,
        "sustainability": 50
      },
      "price": 13.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46940498919621",
      "vsf_explanation": "Zinc is a well-studied immune-support mineral, but this tablet delivers 50mg per dose as a one-per-day, 100-tablet (3+ month) supply — above the 40mg/day tolerable upper intake level established for adults, which raises real concern for copper deficiency and immune dysfunction with sustained daily use. No brand or manufacturer is identified in the listing beyond a halal certification claim, so sourcing, testing, and facility standards cannot be verified. The combination of an unverifiable source and a chronic dose above the established upper limit keeps this product below Vyvata's listing threshold.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "halal-joint-support-with-glucosamine-turmeric-chondroitin-tablets",
      "title": "Halal Joint Support with Glucosamine + Turmeric + Chondroitin Tablets",
      "vendor": "Zaytun Vitamins",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Listing_1_b7cd5ff0-c8c7-4729-a555-2f233fd2bc7f.png?v=1789572499",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "halal",
        "joint",
        "support",
        "with",
        "glucosamine",
        "turmeric",
        "chondroitin",
        "tablets",
        "zaytun",
        "vitamins"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 32,
        "safety": 70,
        "transparency": 35,
        "sustainability": 50
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46940498952389",
      "vsf_explanation": "This joint formula combines glucosamine HCl (1,500mg), chondroitin (300mg), MSM (500mg), and turmeric — a reasonable combination with real, if mixed, clinical evidence for joint comfort. The glucosamine dose matches levels used in published research, but the chondroitin dose sits well below the 800–1,200mg typically studied, and turmeric's actual curcumin content isn't disclosed. No manufacturer or brand is identified beyond 'Made in the USA' and a halal certification claim, limiting independent verification of quality control.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutriway-vitamin-c-plus-extended-release-180-tablets",
      "title": "Nutriway Vitamin C Plus Extended Release (180 tablets)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/product-image_800_800_109743_TR_NEW.jpg?v=1789572570",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutriway",
        "vitamin",
        "plus",
        "extended",
        "release",
        "180",
        "tablets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 75,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 56.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46940501147845",
      "vsf_explanation": "Nutriway's extended-release Vitamin C tablet uses a slow-release delivery format intended to extend absorption across the day, a reasonable approach for one of the best-studied nutrients in the supplement category. The listing does not disclose the actual milligram dose of vitamin C per tablet, which limits formulation verification even though the underlying ingredient (ascorbic acid) has strong safety and efficacy data. The product avoids artificial flavors, colors, and preservatives and is formulated as vegan-friendly.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "alertiq-alpha-brain-focus-stack-by-onnit",
      "title": "ALERTIQ + ALPHA BRAIN Focus Stack by ONNIT",
      "vendor": "2020WFG",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ADDERRAL_ALPHA_BRAIN_Focus_Stack_by_ONNIT.png?v=1789861885",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alertiq",
        "alpha",
        "brain",
        "focus",
        "stack",
        "onnit",
        "2020wfg"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 25,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 35,
        "sustainability": 50
      },
      "price": 95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973450027205",
      "vsf_explanation": "This listing bundles Alpha Brain, Onnit's well-known nootropic with at least one published clinical trial showing modest verbal-memory improvement, together with a second item called ALERTIQ for which no ingredients, doses, or manufacturer are disclosed anywhere in the listing. Alpha Brain itself uses proprietary 'Flow,' 'Focus,' and 'Fuel' blends that don't disclose individual ingredient amounts, which already limits formulation transparency on its own. Because half of this stack is a complete formulation unknown, Vyvata can't verify what a buyer is actually taking, which drags the combined score well below what Alpha Brain alone would earn.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cutting-edge-stack-fat-loss-muscle-preservation-supplement-cycle",
      "title": "Cutting Edge Stack – Fat Loss & Muscle Preservation Supplement Cycle",
      "vendor": "2020WFG",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CuttingEdgeStack.png?v=1789861974",
      "score": 10,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cutting",
        "edge",
        "stack",
        "fat",
        "loss",
        "muscle",
        "preservation",
        "supplement",
        "cycle",
        "2020wfg"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 5,
        "formulation": 5,
        "manufacturing": 10,
        "safety": 5,
        "transparency": 5,
        "sustainability": 50
      },
      "price": 128.25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973454385349",
      "vsf_explanation": "This 3-phase 'cutting stack' bundles three unnamed proprietary blends (T3-VOLT, ClenVenom, ANAVOL-X) with zero disclosed ingredients or dosages — a complete formulation black box under Vyvata's Zero-Assumption Rule. The naming echoes prescription and banned compounds (thyroid hormone T3, clenbuterol, anabolic steroids) without any evidence these products actually contain or are equivalent to those substances, which is itself a misleading-marketing red flag. No manufacturer, facility, or country of origin is disclosed anywhere in the listing, and the 'cycle' dosing language mirrors unregulated performance-enhancing regimens rather than a verifiable supplement protocol.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "primobolean-metabolic-support-60-capsules-green-coffee-bean-natural-energy-for-active-lifestyles",
      "title": "PRIMOBOLEAN: Metabolic Support | 60 Capsules – Green Coffee Bean & Natural Energy for Active Lifestyles",
      "vendor": "2020WFG",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/12_92d91985-d030-4722-bea3-ca89b49361e1.png?v=1789861980",
      "score": 21,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "primobolean",
        "metabolic",
        "support",
        "capsules",
        "green",
        "coffee",
        "bean",
        "natural",
        "energy",
        "for",
        "active",
        "lifestyles",
        "2020wfg"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 14,
        "manufacturing": 12,
        "safety": 35,
        "transparency": 8,
        "sustainability": 50
      },
      "price": 45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973454581957",
      "vsf_explanation": "The name directly echoes Primobolan (methenolone), an anabolic steroid, despite the product apparently being a green coffee bean-based energy/metabolism capsule with modest, generalized evidence for that ingredient class. No dosage of green coffee bean extract or standardized chlorogenic acid content is disclosed, so its therapeutic relevance cannot be verified. No manufacturer or certification data is available.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "trenocut-am-fat-metabolism-activator-60-capsules-clinically-studied-ingredients-for-targeted-fat-loss",
      "title": "TRENOCUT: AM Fat Metabolism Activator | 60 Capsules – Clinically Studied Ingredients for Targeted Fat Loss",
      "vendor": "2020WFG",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/14_e4289b7b-895c-4321-824f-e6fb15f3f18a.png?v=1789861980",
      "score": 19,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "trenocut",
        "fat",
        "metabolism",
        "activator",
        "capsules",
        "clinically",
        "studied",
        "ingredients",
        "for",
        "targeted",
        "fat",
        "loss",
        "2020wfg"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 18,
        "formulation": 13,
        "manufacturing": 12,
        "safety": 32,
        "transparency": 7,
        "sustainability": 50
      },
      "price": 45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973454516421",
      "vsf_explanation": "The name references trenbolone (\"Tren\"), a powerful veterinary/black-market anabolic steroid, on a listing that claims 'clinically studied ingredients' without naming or dosing a single one. Vague, unverifiable evidence claims combined with a deceptive steroid-adjacent name are a serious integrity problem. No manufacturing or certification information is disclosed.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "t3-volt-metabolic-efficiency-catalyst-60-capsules-acai-berry-iodine-kelp-for-healthy-thyroid-function-energy",
      "title": "T3-VOLT: Metabolic Efficiency Catalyst | 60 Capsules – Acai Berry, Iodine & Kelp for Healthy Thyroid Function & Energy",
      "vendor": "2020WFG",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7_bf67e33d-3e9a-4250-b7e7-893756c9e8bd.png?v=1789861980",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "volt",
        "metabolic",
        "efficiency",
        "catalyst",
        "capsules",
        "acai",
        "berry",
        "iodine",
        "kelp",
        "for",
        "healthy",
        "thyroid",
        "function",
        "energy",
        "2020wfg"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 13,
        "manufacturing": 12,
        "safety": 22,
        "transparency": 6,
        "sustainability": 50
      },
      "price": 40,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973454713029",
      "vsf_explanation": "The name 'T3-VOLT' directly evokes triiodothyronine (T3), a regulated thyroid hormone medication, while the actual formula appears to rely on iodine and kelp. Iodine supplementation genuinely affects thyroid physiology, but self-supplementing to 'catalyze' thyroid function without a disclosed dose or medical oversight carries real risk of thyroid dysfunction, especially for anyone with undiagnosed thyroid disease. No dosage, manufacturer, or safety disclosure is available.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "calmora-stress-relief-blend-organic-ashwagandha-black-pepper",
      "title": "Calmora: Stress Relief Blend - Organic Ashwagandha & Black Pepper",
      "vendor": "2020WFG",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/10_92bd129f-002c-4f6d-9b71-e6bf41f9bd60.png?v=1789861980",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "calmora",
        "stress",
        "relief",
        "blend",
        "organic",
        "ashwagandha",
        "black",
        "pepper",
        "2020wfg"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 20,
        "manufacturing": 15,
        "safety": 45,
        "transparency": 15,
        "sustainability": 50
      },
      "price": 35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973454450885",
      "vsf_explanation": "Ashwagandha has reasonably strong published evidence for cortisol reduction and stress relief, and black pepper (piperine) is a legitimate bioavailability enhancer, so this is the most evidence-plausible product in the batch. However, no ashwagandha extract standardization, dose, or piperine amount is disclosed, and no accountable brand or manufacturer name appears anywhere in the listing. Absent that transparency, the formula's real-world efficacy and quality cannot be verified.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "fentraburn-metabolic-cleanse-support-60-capsules-psyllium-husk-probiotics-botanical-blend-for-appetite-management",
      "title": "FENTRABURN: Metabolic Cleanse Support | 60 Capsules – Psyllium Husk, Probiotics & Botanical Blend for Appetite Management",
      "vendor": "2020WFG",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4_29509af2-4999-4407-b418-19fe73b4556d.png?v=1789861980",
      "score": 22,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fentraburn",
        "metabolic",
        "cleanse",
        "support",
        "capsules",
        "psyllium",
        "husk",
        "probiotics",
        "botanical",
        "blend",
        "for",
        "appetite",
        "management",
        "2020wfg"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 15,
        "manufacturing": 13,
        "safety": 25,
        "transparency": 6,
        "sustainability": 50
      },
      "price": 40,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973454483653",
      "vsf_explanation": "The 'FENTRA-' prefix reads as a deliberate echo of a controlled/prescription substance name (evoking fentanyl or phentermine) attached to what is actually a fiber-and-probiotic appetite product; psyllium husk and probiotics do have real evidence for satiety and digestive support. The naming choice is a serious integrity concern independent of the underlying ingredients, and no probiotic strain, CFU count, or fiber dose is disclosed. No manufacturer identity is available.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "noxalin-stress-cognitive-support-60-capsules-l-theanine-gaba-b-complex-for-calm-mental-clarity",
      "title": "NOXALIN: Stress & Cognitive Support | 60 Capsules – L-Theanine, GABA & B-Complex for Calm Mental Clarity",
      "vendor": "2020WFG",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6_c737fb82-129b-475f-8086-ff437361cd21.png?v=1789861980",
      "score": 29,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive",
        "mood",
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "noxalin",
        "stress",
        "cognitive",
        "support",
        "capsules",
        "theanine",
        "gaba",
        "complex",
        "for",
        "calm",
        "mental",
        "clarity",
        "2020wfg"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 18,
        "manufacturing": 14,
        "safety": 48,
        "transparency": 14,
        "sustainability": 50
      },
      "price": 35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973454549189",
      "vsf_explanation": "L-theanine has solid evidence for promoting calm, alert focus, and B-complex vitamins are foundational and generally well tolerated; oral GABA's ability to cross the blood-brain barrier is more debated in the literature. None of the three ingredient doses are disclosed, which prevents any real efficacy assessment. No accountable brand or manufacturer name appears in the listing.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "anadrax-circulation-complex-60-capsules-l-arginine-niacin-nitric-oxide-support-for-active-lifestyles",
      "title": "ANADRAX: Circulation Complex | 60 Capsules - L-Arginine, Niacin & Nitric Oxide Support for Active Lifestyles",
      "vendor": "2020WFG",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/17_12ba64c4-b99a-4888-9525-01305224399a.png?v=1789861980",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "anadrax",
        "circulation",
        "complex",
        "capsules",
        "arginine",
        "niacin",
        "nitric",
        "oxide",
        "support",
        "for",
        "active",
        "lifestyles",
        "2020wfg"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 14,
        "manufacturing": 12,
        "safety": 28,
        "transparency": 7,
        "sustainability": 50
      },
      "price": 50,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973454614725",
      "vsf_explanation": "The name references Anadrol (oxymetholone), an anabolic steroid, on a listing for what is actually an L-arginine/niacin nitric-oxide support formula; L-arginine has modest evidence for circulation via nitric oxide, and niacin can cause a known flushing reaction at even moderate doses. No dose of either ingredient is disclosed, which prevents assessing whether flushing or other niacin-related effects are likely. No manufacturer information is available.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "winsrol-metabolic-definition-catalyst-60-capsules-white-kidney-bean-natural-actives-for-lean-physique-support",
      "title": "WINSROL: Metabolic Definition Catalyst | 60 Capsules – White Kidney Bean & Natural Actives for Lean Physique Support",
      "vendor": "2020WFG",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8_8da8549c-a8bd-4b16-a195-6fecf1ad2a75.png?v=1789861980",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "winsrol",
        "metabolic",
        "definition",
        "catalyst",
        "capsules",
        "white",
        "kidney",
        "bean",
        "natural",
        "actives",
        "for",
        "lean",
        "physique",
        "support",
        "2020wfg"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 13,
        "manufacturing": 12,
        "safety": 32,
        "transparency": 6,
        "sustainability": 50
      },
      "price": 50,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973454778565",
      "vsf_explanation": "The name directly mimics Winstrol (stanozolol), a well-known anabolic steroid, while the actual formula centers on white kidney bean extract, a carbohydrate-blocker ingredient with modest supporting evidence for weight management when adequately dosed. No extract standardization or dose is disclosed, and the 'natural actives' in the blend are unnamed. No manufacturer or brand identity is available.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "anavol-x-multi-collagen-muscle-fat-joint-hybrid-90-capsules",
      "title": "ANAVOL-X | Multi-Collagen Muscle, Fat & Joint Hybrid – 90 Capsules",
      "vendor": "2020WFG",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/16_7cdbeda7-9657-4ff5-8300-a75f8376822c.png?v=1789861980",
      "score": 22,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "anavol",
        "multi",
        "collagen",
        "muscle",
        "fat",
        "joint",
        "hybrid",
        "capsules",
        "2020wfg"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 15,
        "manufacturing": 13,
        "safety": 38,
        "transparency": 6,
        "sustainability": 50
      },
      "price": 50,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973454745797",
      "vsf_explanation": "The name closely mirrors Anavar (oxandrolone), a widely known anabolic steroid, while the product itself appears to be a multi-collagen blend; collagen peptides have real published evidence for joint comfort and skin, but essentially no evidence supports collagen as a 'muscle' or 'fat' modifier as the title claims. No collagen type, source, or dose is disclosed, and no manufacturer identity is available.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "d-bulk-anabolic-nutrient-partitioning-complex-60-servings-magnesium-horny-goat-weed-natural-actives-for-muscle-performance",
      "title": "D-BULK: Anabolic Nutrient Partitioning Complex | 60 Servings – Magnesium, Horny Goat Weed & Natural Actives for Muscle Performance",
      "vendor": "2020WFG",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/13_efb0b11b-0f5e-4a05-a63b-518c033901b2.png?v=1789861980",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bulk",
        "anabolic",
        "nutrient",
        "partitioning",
        "complex",
        "servings",
        "magnesium",
        "horny",
        "goat",
        "weed",
        "natural",
        "actives",
        "for",
        "muscle",
        "performance",
        "2020wfg"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 13,
        "manufacturing": 12,
        "safety": 30,
        "transparency": 5,
        "sustainability": 50
      },
      "price": 50,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973454844101",
      "vsf_explanation": "The name and the explicit word 'Anabolic' both reference anabolic steroid-style muscle building (echoing products like D-Bal), yet the listed ingredients are magnesium and horny goat weed, neither of which has credible evidence for 'nutrient partitioning' or anabolic muscle effects in humans. This is one of the most direct unverified-claim/misleading-naming combinations in the batch. No dose or manufacturer information is disclosed.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "alertiq-cognitive-support-60-capsules-focus-complex-with-l-theanine-bacopa-natural-energy",
      "title": "ALERTIQ: Cognitive Support | 60 Capsules – Focus Complex with L-Theanine, Bacopa & Natural Energy",
      "vendor": "2020WFG",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2_079b98aa-ca11-4b92-ba6c-ff9fe866e414.png?v=1789861980",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "cognitive",
        "mood",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alertiq",
        "cognitive",
        "support",
        "capsules",
        "focus",
        "complex",
        "with",
        "theanine",
        "bacopa",
        "natural",
        "energy",
        "2020wfg"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 18,
        "manufacturing": 14,
        "safety": 46,
        "transparency": 15,
        "sustainability": 50
      },
      "price": 50,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973454876869",
      "vsf_explanation": "L-theanine and bacopa monnieri are both reasonably well-studied for focus and cognitive support, giving this formula genuine (if unquantified) evidence plausibility. However, no extract standardization or dose for either ingredient is disclosed, the 'natural energy' component is unnamed (likely undisclosed caffeine), and no accountable brand or manufacturer appears in the listing.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "clenvenom-thermogenic-complex-60-capsules-green-tea-extract-raspberry-ketones-natural-energy-support",
      "title": "CLENVENOM: Thermogenic Complex | 60 Capsules - Green Tea Extract, Raspberry Ketones & Natural Energy Support",
      "vendor": "2020WFG",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_22d0f0e5-0b58-4f9a-9aa3-ed176073969e.png?v=1789861980",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "clenvenom",
        "thermogenic",
        "complex",
        "capsules",
        "green",
        "tea",
        "extract",
        "raspberry",
        "ketones",
        "natural",
        "energy",
        "support",
        "2020wfg"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 13,
        "manufacturing": 12,
        "safety": 24,
        "transparency": 5,
        "sustainability": 50
      },
      "price": 45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973454942405",
      "vsf_explanation": "The name directly references clenbuterol ('Clen'), a banned bronchodilator/stimulant widely abused for fat loss, attached to a green tea extract/raspberry ketone thermogenic stack. Green tea extract (EGCG/catechins) has moderate evidence for modest thermogenic effects, but raspberry ketone lacks credible human evidence, and neither ingredient's dose is disclosed, which is a real safety gap for a stimulant-adjacent stack. No manufacturer information is available.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "alphatex-hardcore-testosterone-support-muscle-growth-drive-tablets-for-men-60-count",
      "title": "ALPHATEX: Hardcore Testosterone Support | Muscle Growth Drive Tablets for Men (60 Count)",
      "vendor": "2020WFG",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3_b41a482d-a0c4-41b3-ae30-0dcbc2df9764.png?v=1789861980",
      "score": 18,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "alphatex",
        "hardcore",
        "testosterone",
        "support",
        "muscle",
        "growth",
        "drive",
        "tablets",
        "for",
        "men",
        "count",
        "2020wfg"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 12,
        "manufacturing": 12,
        "safety": 30,
        "transparency": 8,
        "sustainability": 50
      },
      "price": 40,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973454975173",
      "vsf_explanation": "The listing makes an explicit 'hardcore testosterone support' and 'muscle growth' claim without naming or dosing a single active ingredient anywhere in the visible content, which is an unverified medical/physiological claim on its face. Testosterone-support supplements in this category typically rely on weakly-evidenced botanicals (e.g., tribulus, horny goat weed), but since nothing is disclosed here, no evidence assessment is possible. No manufacturer identity is available.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "hgh-x2-elite-muscle-recovery-formula-pharma-grade-l-glutamine-powder-60-servings",
      "title": "HGH-X2: Elite Muscle Recovery Formula  (Pharma-Grade L-Glutamine Powder – 60 Servings)",
      "vendor": "2020WFG",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/20_a780ed96-f912-43ae-8c73-00f38b2a4213.png?v=1789861980",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hgh",
        "elite",
        "muscle",
        "recovery",
        "formula",
        "pharma",
        "grade",
        "glutamine",
        "powder",
        "servings",
        "2020wfg"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 15,
        "manufacturing": 13,
        "safety": 38,
        "transparency": 6,
        "sustainability": 50
      },
      "price": 45.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973454909637",
      "vsf_explanation": "The name directly references human growth hormone (HGH), and is also the name of an existing 'legal steroid alternative' product line, while the actual disclosed ingredient is plain L-glutamine, an amino acid with no credible evidence for stimulating growth-hormone release at oral supplement doses. The 'pharma-grade' descriptor is an unverifiable marketing claim with no certification cited. No manufacturer information is disclosed.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "hydrabolin-advanced-electrolyte-formula-blue-raspberry-flavor",
      "title": "HYDRABOLIN – Advanced Electrolyte Formula | Blue Raspberry Flavor",
      "vendor": "2020WFG",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/21_5f006495-f3a3-45cc-b874-6dbe5e04edba.png?v=1789861981",
      "score": 28,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hydrabolin",
        "advanced",
        "electrolyte",
        "formula",
        "blue",
        "raspberry",
        "flavor",
        "2020wfg"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 18,
        "manufacturing": 14,
        "safety": 42,
        "transparency": 8,
        "sustainability": 50
      },
      "price": 55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973455007941",
      "vsf_explanation": "Electrolyte replenishment for hydration is a well-established physiological use case, so the underlying product category has reasonable inherent evidence. But the '-bolin' suffix follows a recognizable anabolic-steroid naming convention (echoing products like Deca-Durabolin), which is a deceptive branding choice for what is otherwise a routine electrolyte drink mix. No specific electrolyte panel (sodium, potassium, magnesium amounts) or manufacturer is disclosed.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "durogen-cellular-performance-complex-60-capsules-activated-b-vitamins-coq10-mitochondrial-support-for-recovery-vitality",
      "title": "DUROGEN: Cellular Performance Complex | 60 Capsules – Activated B-Vitamins, CoQ10 & Mitochondrial Support for Recovery & Vitality",
      "vendor": "2020WFG",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/15_a42d4e9a-5cfd-4d21-a5a1-92e24652883e.png?v=1789861980",
      "score": 29,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy",
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "durogen",
        "cellular",
        "performance",
        "complex",
        "capsules",
        "activated",
        "vitamins",
        "coq10",
        "mitochondrial",
        "support",
        "for",
        "recovery",
        "vitality",
        "2020wfg"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 17,
        "manufacturing": 14,
        "safety": 45,
        "transparency": 14,
        "sustainability": 50
      },
      "price": 44,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973455040709",
      "vsf_explanation": "Activated (methylated) B-vitamins and CoQ10 both have credible evidence for supporting cellular energy metabolism and mitochondrial function, making this one of the more plausible formulas in the batch. However, no B-vitamin forms/doses or CoQ10 milligram amount (and whether it's ubiquinone vs. the more bioavailable ubiquinol) is disclosed, and no accountable manufacturer or brand name appears anywhere in the listing.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "redzone-9-circulation-vitality-complex-60-capsules-horny-goat-weed-maca-root-nitric-oxide-support-for-male-wellness",
      "title": "REDZONE-9: Circulation & Vitality Complex 60 Capsules - Horny Goat Weed, Maca Root & Nitric Oxide Support for Male Wellness",
      "vendor": "2020WFG",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9_e6841157-17a1-431b-b0ea-2af423802e49.png?v=1789861981",
      "score": 21,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood",
        "energy",
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "redzone",
        "circulation",
        "vitality",
        "complex",
        "capsules",
        "horny",
        "goat",
        "weed",
        "maca",
        "root",
        "nitric",
        "oxide",
        "support",
        "for",
        "male",
        "wellness",
        "2020wfg"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 14,
        "manufacturing": 13,
        "safety": 35,
        "transparency": 10,
        "sustainability": 50
      },
      "price": 44.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973455073477",
      "vsf_explanation": "Maca root has modest published evidence for libido support, while horny goat weed's human evidence for male sexual/vitality claims is considerably weaker despite common use in this category. No dose of maca, horny goat weed, or the nitric oxide-support component is disclosed, preventing any real efficacy assessment. No accountable brand or manufacturer name appears in the listing.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "tadalafilon-elite-natural-testosterone-vitality-enhancer",
      "title": "TADALAFILON – Elite Natural Testosterone & Vitality Enhancer",
      "vendor": "2020WFG",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/18_a4b8048b-7be1-4d18-9505-1f40baaab5e6.png?v=1789861989",
      "score": 15,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "tadalafilon",
        "elite",
        "natural",
        "testosterone",
        "vitality",
        "enhancer",
        "2020wfg"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 12,
        "manufacturing": 12,
        "safety": 15,
        "transparency": 5,
        "sustainability": 50
      },
      "price": 95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973455139013",
      "vsf_explanation": "The product name deliberately echoes tadalafil, a prescription PDE5-inhibitor drug (brand name Cialis), while the listing discloses no actual ingredient panel, dosages, or clinical data to substantiate a 'testosterone & vitality' effect. This naming pattern risks consumers believing they are getting a pharmaceutical-strength erectile-function product, which is dangerous given undisclosed interaction risk with nitrate medications. No manufacturer, GMP certification, or third-party testing could be identified from the listing.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "penta-vitals-vitamin-b-12-5000-mcg-with-folic-acid-60-lozenges",
      "title": "Penta Vitals Vitamin B-12 5000 mcg with Folic Acid – 60 Lozenges",
      "vendor": "Mann Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/penta-vitals-vitamin-b-12-5000-mcg-with-folic-acid-60-lozenges-2588738.png?v=1789862005",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "penta",
        "vitals",
        "vitamin",
        "5000",
        "mcg",
        "with",
        "folic",
        "acid",
        "lozenges",
        "mann",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 62,
        "manufacturing": 40,
        "safety": 78,
        "transparency": 48,
        "sustainability": 40
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973455335621",
      "vsf_explanation": "Penta Vitals Vitamin B-12 delivers a clearly disclosed 5,000 mcg of B-12 (as cyanocobalamin) plus 680 mcg DFE folate per lozenge — a high but well-tolerated dose given B12's wide safety margin and common absorption inefficiencies. The lozenge format is a sensible choice for a water-soluble, high-dose vitamin. The brand uses cyanocobalamin rather than the more bioavailable methylcobalamin form, and as with the rest of the Penta Vitals line, offers no third-party testing or certifications beyond a self-attested GMP claim.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "penta-vitals-zinc-picolinate-50mg-immune-support-60-veg-capsules",
      "title": "Penta Vitals Zinc Picolinate 50mg – Immune Support | 60 Veg Capsules",
      "vendor": "Mann Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/penta-vitals-zinc-picolinate-50mg-immune-support-60-veg-capsules-3839020.png?v=1789862005",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "penta",
        "vitals",
        "zinc",
        "picolinate",
        "50mg",
        "immune",
        "support",
        "veg",
        "capsules",
        "mann",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 40,
        "safety": 48,
        "transparency": 48,
        "sustainability": 40
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973455368389",
      "vsf_explanation": "Penta Vitals Zinc Picolinate delivers 50mg of elemental zinc — more than 4x the RDA and above the 40mg/day tolerable upper intake level NIH sets for chronic supplementation. Zinc picolinate is a well-absorbed chelated form and the dose is clearly disclosed, but the listing includes no copper-depletion warning and no guidance limiting duration of use. Sustained intake at this level without added copper carries a well-documented risk of copper deficiency and paradoxical immune suppression that this listing does not address, pulling down the safety score.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "penta-vitals-omega-3-fish-oil-1000mg-epa-dha-100-softgels",
      "title": "Penta Vitals Omega-3 Fish Oil 1000mg – EPA & DHA | 100 Softgels",
      "vendor": "Mann Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/penta-vitals-omega-3-fish-oil-1000mg-epa-dha-100-softgels-9759625.png?v=1789862011",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "penta",
        "vitals",
        "omega",
        "fish",
        "oil",
        "1000mg",
        "epa",
        "dha",
        "100",
        "softgels",
        "mann",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 58,
        "manufacturing": 40,
        "safety": 75,
        "transparency": 48,
        "sustainability": 40
      },
      "price": 19.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973455499461",
      "vsf_explanation": "Penta Vitals' Omega-3 Fish Oil discloses a clear 600mg combined EPA/DHA per 2-softgel serving (360mg EPA + 240mg DHA) — a dose within the range studied for general cardiovascular support, though below the 1–4g range used in more intensive lipid-management trials. The brand states non-GMO sourcing and a GMP-compliant facility but discloses no third-party purity testing for heavy metals or oxidation (TOTOX), the two quality risks that matter most for fish oil. A serviceable, clearly dosed omega-3 held back mainly by unverified manufacturing claims.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "penta-vitals-cordyceps-750-mg-90-veg-caps",
      "title": "Penta Vitals Cordyceps 750 mg  90 Veg Caps",
      "vendor": "Mann Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/penta-vitals-cordyceps-750-mg-90-veg-caps-1718654.png?v=1789862010",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "penta",
        "vitals",
        "cordyceps",
        "750",
        "veg",
        "caps",
        "mann",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 35,
        "manufacturing": 40,
        "safety": 60,
        "transparency": 48,
        "sustainability": 40
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973455466693",
      "vsf_explanation": "Penta Vitals Cordyceps provides 750mg per capsule but discloses no extract standardization, cordycepin or polysaccharide percentage, or species/part used (fruiting body vs. mycelium-on-grain) — a meaningful quality gap in a category where mycelium-based fillers are common and materially weaker than standardized fruiting-body extracts. Human evidence for cordyceps' energy and endurance claims is mixed and moderate at best, and without standardization there is no way to confirm the dose delivers a research-relevant amount of active compound. Combined with no disclosed third-party testing, this lands in the Rejected tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "penta-vitals-super-antioxidants-60-veg-caps",
      "title": "Penta Vitals Super Antioxidants -60 Veg Caps",
      "vendor": "Mann Nutrition",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/penta-vitals-super-antioxidants-60-veg-caps-5380414.png?v=1789862011",
      "score": 47,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "penta",
        "vitals",
        "super",
        "antioxidants",
        "veg",
        "caps",
        "mann",
        "nutrition"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 48,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 48,
        "sustainability": 40
      },
      "price": 24.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973455532229",
      "vsf_explanation": "Penta Vitals Super Antioxidants discloses meaningful doses and standardizations for its primary actives (green tea extract 200mg at 40% catechins, milk thistle 100mg at 80% silymarin, turmeric 100mg at 95% curcuminoids, quercetin 100mg), each backed by reasonable ingredient-level evidence. However, the formula also lists a trailing 'powerful herbal blend' of rosemary, grape seed, ginkgo biloba, hawthorn, cranberry, and bilberry with zero disclosed individual dosing — a partial proprietary-blend pattern that obscures whether those ingredients are present at meaningful levels. No interaction warnings are disclosed despite the inclusion of ginkgo biloba, and no third-party testing is cited.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "therafrost-flow",
      "title": "TheraFrost Flow",
      "vendor": "Therasage",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Photo_Nov_13_2024_11_41_36_PM.jpg?v=1789862082",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "therafrost",
        "flow",
        "therasage"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "cold_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 0,
        "transparency": 0,
        "sustainability": 0
      },
      "price": 987,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973455990981",
      "vsf_explanation": "TheraFrost Flow is a filtration/pump accessory that adds ozone treatment and water circulation to an existing ice bath — a hardware accessory, not an ingestible supplement. It has no ingredient or dosing profile and falls outside the Vyvata Supplement Scoring Framework's scope.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "healing-pad-small-infrared-heating-pad",
      "title": "Healing Pad Small Infrared Heating Pad",
      "vendor": "Therasage",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/190_aaec467a-2911-499e-888f-7ff57f78c3b4.png?v=1789862089",
      "score": 26,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "healing",
        "pad",
        "small",
        "infrared",
        "heating",
        "pad",
        "therasage"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 38,
        "manufacturing": 0,
        "safety": 65,
        "transparency": 0,
        "sustainability": 0
      },
      "price": 218,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973456187589",
      "vsf_explanation": "This is a powered infrared heating device, not an ingestible or topical supplement, so it's out of scope for a category built around ingredient-based products. Basic heat therapy for muscle and joint pain has legitimate general evidence, and the listing discloses FDA Class II medical device registration and ISO9001-certified manufacturing, which are genuinely verifiable claims that improve build-quality confidence relative to the brand's other listed products. The added 'negative ion' and 'grounding therapy' claims layered on top of the heat mechanism are not independently supported.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "therao3-ozone-bubbler-110v",
      "title": "TheraO3 Ozone Bubbler 110V",
      "vendor": "Therasage",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/266_b0d0cc98-598c-4ce0-9da6-6b25cc5fc27c.png?v=1789862089",
      "score": 8,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "therao3",
        "ozone",
        "bubbler",
        "110v",
        "therasage"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 8,
        "formulation": 15,
        "manufacturing": 0,
        "safety": 20,
        "transparency": 0,
        "sustainability": 0
      },
      "price": 108,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973456285893",
      "vsf_explanation": "This is a home ozone-generating device, not a supplement, so it is categorically out of scope, but the more serious finding is a genuine safety concern: ozone gas has no established clinical benefit for the anti-aging, immune, and detoxification claims made here, and regulatory bodies including the FDA have specifically warned that ozone is a toxic gas with no proven medical benefit. The listing's reference to 'insufflation (consult advisor)' for direct-body ozone exposure is a red flag, as unsupervised ozone insufflation carries documented risks including gas embolism and respiratory injury.",
      "vsf_autofail_rule": "safety_concern"
    },
    {
      "handle": "therafrost-the-ultimate-plunge",
      "title": "TheraFrost - The Ultimate Plunge",
      "vendor": "Therasage",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Website_Pics-2.png?v=1789862089",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "therafrost",
        "the",
        "ultimate",
        "plunge",
        "therasage"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "cold_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 0,
        "transparency": 0,
        "sustainability": 0
      },
      "price": 4988,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973456220357",
      "vsf_explanation": "TheraFrost is a portable cold-plunge tub (a physical recovery device with a built-in water chiller and ozone/structured-water system) — it is not an ingestible dietary supplement. It falls entirely outside the Vyvata Supplement Scoring Framework, which evaluates ingredient evidence, dosing, and formulation, none of which apply to a hardware product. This listing should be routed to the Recovery & Regeneration (cold_therapy) device rubric rather than scored as a supplement.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "healing-pad-mini-infrared-heating-pad",
      "title": "Healing Pad Mini Infrared Heating Pad",
      "vendor": "Therasage",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/192_0ef9e3bf-a711-4626-a6ba-0826a1ccb187.png?v=1789862089",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "healing",
        "pad",
        "mini",
        "infrared",
        "heating",
        "pad",
        "therasage"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 0,
        "transparency": 0,
        "sustainability": 0
      },
      "price": 144,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973456122053",
      "vsf_explanation": "The Healing Pad Mini is a jade-stone infrared heating pad — a wearable heat-therapy device, not an ingestible supplement. It sits outside the scope of the Vyvata Supplement Scoring Framework and should be evaluated under the Recovery & Regeneration (red_light_photobiomodulation / sauna_heat_therapy) device rubric instead.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "thera360-floor-chair",
      "title": "Thera360 Floor Chair",
      "vendor": "Therasage",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/242.png?v=1789862088",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "thera360",
        "floor",
        "chair",
        "therasage"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 0,
        "transparency": 0,
        "sustainability": 0
      },
      "price": 60,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973456089285",
      "vsf_explanation": "The Thera360 Floor Chair is a cushioned seating accessory for use inside a Thera360 portable sauna — a furniture accessory, not a supplement, and not even a standalone therapeutic device. It has no ingredients, dosing, or formulation to evaluate and falls entirely outside the Vyvata Supplement Scoring Framework.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "healing-pad-small-worldwide-voltage-110-240v",
      "title": "Healing Pad Small - Worldwide Voltage (110-240V)",
      "vendor": "Therasage",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/190.png?v=1789862089",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "healing",
        "pad",
        "small",
        "worldwide",
        "voltage",
        "110",
        "240v",
        "therasage"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 0,
        "transparency": 0,
        "sustainability": 0
      },
      "price": 252,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973456482501",
      "vsf_explanation": "The Healing Pad Small is a jade-stone infrared heating pad, a wearable heat-therapy hardware device rather than an ingestible supplement. It falls outside the Vyvata Supplement Scoring Framework and belongs under the Recovery & Regeneration device rubric.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "therao3-bubbler-worldwide-110v-240v-north-america-plug-included-ships-in-approx-2-weeks",
      "title": "TheraO3 - Bubbler (Worldwide 110v-240v North America Plug Included) - Ships in Approx. 2 Weeks",
      "vendor": "Therasage",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/266.png?v=1789862089",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "therao3",
        "bubbler",
        "worldwide",
        "110v",
        "240v",
        "north",
        "america",
        "plug",
        "included",
        "ships",
        "approx",
        "weeks",
        "therasage"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "stretch_mobility"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 10,
        "manufacturing": 10,
        "safety": 15,
        "transparency": 5,
        "sustainability": 50
      },
      "price": 137,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973456351429",
      "vsf_explanation": "No listed subcategory fits an ozone water/bath device — closest imperfect fit chosen. Ozone does have real industrial water-disinfection chemistry, but claiming a consumer device 'eliminates bacteria/parasites/pathogens from food and water' plus 'anti-aging' and 'immune health' benefits, without EPA registration or clinical substantiation, crosses from wellness marketing into specific, unsubstantiated physiological/pathogen-elimination claims.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "thera360-plus-portable-infrared-sauna",
      "title": "Thera360 Plus Portable Infrared Sauna",
      "vendor": "Therasage",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Resized_Sauna_Open.jpg?v=1789862088",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "thera360",
        "plus",
        "portable",
        "infrared",
        "sauna",
        "therasage"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 0,
        "transparency": 0,
        "sustainability": 0
      },
      "price": 1428,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973456416965",
      "vsf_explanation": "The Thera360 Plus is a powered portable infrared sauna combining infrared panels, red light, and ion generation — a multi-modality wellness device, not an ingestible supplement. It falls entirely outside the Vyvata Supplement Scoring Framework and belongs under the Recovery & Regeneration (sauna_heat_therapy) device rubric.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "thera360-plus-portable-infrared-sauna-white",
      "title": "Thera360 Plus Portable Infrared Sauna – White",
      "vendor": "Therasage",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/White_Sauna_Open.png?v=1789862088",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "thera360",
        "plus",
        "portable",
        "infrared",
        "sauna",
        "white",
        "therasage"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 0,
        "transparency": 0,
        "sustainability": 0
      },
      "price": 1428,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973456515269",
      "vsf_explanation": "This is the white color variant of the Thera360 Plus portable infrared sauna — a powered wellness device, not an ingestible supplement. It falls outside the Vyvata Supplement Scoring Framework and belongs under the Recovery & Regeneration device rubric.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "therapro™-pemf-infrared-red-light-therapy-recovery-pad-regular-ships-within-two-weeks",
      "title": "TheraPro™ PEMF, Infrared & Red Light Therapy Recovery Pad – Regular (Ships within two weeks)",
      "vendor": "Therasage",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5_9123cbdb-c06b-43fd-b913-aa46c3e309d6.png?v=1789862089",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "therapro",
        "pemf",
        "infrared",
        "red",
        "light",
        "therapy",
        "recovery",
        "pad",
        "regular",
        "ships",
        "within",
        "two",
        "weeks",
        "therasage"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 0,
        "transparency": 0,
        "sustainability": 0
      },
      "price": 597,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973456711877",
      "vsf_explanation": "The TheraPro is a powered PEMF/infrared/red-light recovery pad — a multi-modality electrical device, not an ingestible supplement. It has no ingredient or dosing profile and falls outside the Vyvata Supplement Scoring Framework's scope.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "therasage-tri-lite™-red-light-therapy-panel",
      "title": "Therasage Tri-Lite™ Red Light Therapy Panel",
      "vendor": "Therasage",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4_fe3d79c0-45ab-4bc2-8e65-c6c84bf6b0ba.png?v=1789862089",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "therasage",
        "tri",
        "lite",
        "red",
        "light",
        "therapy",
        "panel",
        "therasage"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 0,
        "transparency": 0,
        "sustainability": 0
      },
      "price": 249,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973456384197",
      "vsf_explanation": "The Tri-Lite panel is a powered red/near-infrared LED light-therapy panel — a hardware device, not an ingestible supplement. It falls outside the Vyvata Supplement Scoring Framework and belongs under the Recovery & Regeneration (red_light_photobiomodulation) device rubric.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "therao3-ozone-module",
      "title": "TheraO3 Ozone Module",
      "vendor": "Therasage",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3_77afb44c-596d-49fa-99d9-39c7e4b6ed35.png?v=1789862088",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "therao3",
        "ozone",
        "module",
        "therasage"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 5,
        "formulation": 15,
        "manufacturing": 10,
        "safety": 5,
        "transparency": 5,
        "sustainability": 50
      },
      "price": 164,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973456613573",
      "vsf_explanation": "Subcategory chosen because the sauna-amplification use case is its most defined function, but standalone (outside the sauna) it's marketed to 'emit breathable low gamma ozone to purify personal airspace' in cars, offices, and hotel rooms without disclosing that the EPA and FDA both hold that ozone at human-safe concentrations is not proven effective against pathogens, and that ozone is a documented lung irritant. Claiming both safety and airspace-purification efficacy without addressing that tension is exactly the undisclosed-risk pattern this rubric treats as a safety concern.",
      "vsf_autofail_rule": "safety_concern"
    },
    {
      "handle": "theraglow-neck-chest",
      "title": "TheraGlow - Neck & Chest",
      "vendor": "Therasage",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/IMG_7279_2.jpg?v=1789862088",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "theraglow",
        "neck",
        "chest",
        "therasage"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 0,
        "transparency": 0,
        "sustainability": 0
      },
      "price": 299,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973456318661",
      "vsf_explanation": "TheraGlow Neck & Chest is a wearable multi-color LED chromotherapy device for skin, not an ingestible supplement. It has no ingredient or dosing profile and falls outside the Vyvata Supplement Scoring Framework's scope.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "therabrush-with-copper-bristles-long-handle-vegan",
      "title": "TheraBrush With Copper Bristles - LONG HANDLE (Vegan)",
      "vendor": "Therasage",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/144.png?v=1789862088",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "therabrush",
        "with",
        "copper",
        "bristles",
        "long",
        "handle",
        "vegan",
        "therasage"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "stretch_mobility"
      ],
      "vsf_dimensions": {
        "evidence": 8,
        "formulation": 30,
        "manufacturing": 30,
        "safety": 45,
        "transparency": 10,
        "sustainability": 60
      },
      "price": 57,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973456580805",
      "vsf_explanation": "No recovery subcategory fits a manual dry-brush tool — closest imperfect fit chosen. Mechanical exfoliation itself is a legitimate, low-risk skincare practice, and we credit that; but 'lymphatic drainage and detoxification,' 'energizes the body,' and 'boosts immune resilience' are unsubstantiated claims that fall squarely in the rubric's named auto-fail categories (detox, immune health).",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "theraperfect-pad™-with-tri-lite-red-near-infrared-therapy",
      "title": "TheraPerfect Pad™ with Tri-Lite Red & Near Infrared Therapy",
      "vendor": "Therasage",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Website_Pics_bbf7018a-7d43-4515-8ae2-05ba63408e3a.png?v=1789862089",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "theraperfect",
        "pad",
        "with",
        "tri",
        "lite",
        "red",
        "near",
        "infrared",
        "therapy",
        "therasage"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 0,
        "transparency": 0,
        "sustainability": 0
      },
      "price": 420,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973456679109",
      "vsf_explanation": "The TheraPerfect Pad is a flexible red/near-infrared light-and-heat recovery pad — a wearable hardware device, not an ingestible supplement. It falls outside the Vyvata Supplement Scoring Framework's scope.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "gaia-therafrost-the-ultimate-plunge",
      "title": "Gaia-TheraFrost - The Ultimate Plunge",
      "vendor": "Therasage",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Untitleddesign_50_81175d61-5379-4501-907d-80a1ec2477f8.png?v=1789862088",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gaia",
        "therafrost",
        "the",
        "ultimate",
        "plunge",
        "therasage"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "cold_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 0,
        "transparency": 0,
        "sustainability": 0
      },
      "price": 4988,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973456777413",
      "vsf_explanation": "This is a branded ('Gaia') listing variant of the TheraFrost cold-plunge tub — the same hardware recovery device as the standard TheraFrost listing, not an ingestible supplement. It falls outside the Vyvata Supplement Scoring Framework's scope.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "therasage-bio-bands-sport-infrared-negative-ion-bracelet",
      "title": "Therasage Bio Bands Sport Infrared Negative Ion Bracelet",
      "vendor": "Therasage",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BioBands_7_906ef44f-d1d9-4b74-ab41-bd458d16e851.png?v=1789862089",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "therasage",
        "bio",
        "bands",
        "sport",
        "infrared",
        "negative",
        "ion",
        "bracelet",
        "therasage"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "stretch_mobility"
      ],
      "vsf_dimensions": {
        "evidence": 2,
        "formulation": 10,
        "manufacturing": 20,
        "safety": 20,
        "transparency": 5,
        "sustainability": 50
      },
      "price": 75,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973456810181",
      "vsf_explanation": "No listed subcategory fits a wearable magnet bracelet — closest imperfect fit chosen. Same brand-level issue as the Metal Bio Band: 'counteracts EMF exposure effects,' 'promotes balanced energy/circulation/cellular function,' and 'EMF protection' via magnets and unspecified 'natural earth elements' have no credible scientific support.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "gaia-theracomfort-weighted-eye-pillow",
      "title": "Gaia-TheraComfort Weighted Eye Pillow",
      "vendor": "Therasage",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71xrpL9QqaL._AC_SX679_96c456d1-2fdd-4fd6-a208-993ac6c8b99f.jpg?v=1789862104",
      "score": 19,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gaia",
        "theracomfort",
        "weighted",
        "eye",
        "pillow",
        "therasage"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_environment"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 20,
        "manufacturing": 0,
        "safety": 68,
        "transparency": 0,
        "sustainability": 0
      },
      "price": 33,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973457793221",
      "vsf_explanation": "This is a variant of the TheraComfort weighted, gemstone-embedded eye pillow — a physical sleep accessory rather than a supplement, so it's out of scope for the Vyvata Supplement Framework. Weighted pressure and light-blocking for sleep have plausible general benefit, but claims around 'gemstone technology,' 'earth energies,' and 'pineal gland support' are not backed by peer-reviewed evidence. It is scored here only to document why it does not belong in a supplement catalog.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "therasage-bio-bands-metal-infrared-negative-ion-bracelet",
      "title": "Therasage Bio Bands Metal Infrared Negative Ion Bracelet",
      "vendor": "Therasage",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/307_0c255dc2-8436-4c9c-8ac2-b93d48b91286.png?v=1789862110",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "therasage",
        "bio",
        "bands",
        "metal",
        "infrared",
        "negative",
        "ion",
        "bracelet",
        "therasage"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "stretch_mobility"
      ],
      "vsf_dimensions": {
        "evidence": 2,
        "formulation": 10,
        "manufacturing": 25,
        "safety": 20,
        "transparency": 5,
        "sustainability": 50
      },
      "price": 99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973457825989",
      "vsf_explanation": "Note: no listed recovery subcategory fits a wearable magnet/mineral bracelet — we picked the closest available option, but it's an imperfect fit. On substance: 'defense against harmful radiation,' 'continuous energetic balance,' and 'enhanced blood oxygenation' via germanium, jade, and magnets have no credible physics or clinical support, and Therasage itself has an FDA history (2015 recall, 'Labeling False and Misleading') for this exact pattern of unsubstantiated negative-ion and detox claims on its other products.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "theracomfort-weighted-blanket",
      "title": "TheraComfort Weighted Blanket",
      "vendor": "Therasage",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/149.png?v=1789862109",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "theracomfort",
        "weighted",
        "blanket",
        "therasage"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_environment"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 20,
        "manufacturing": 0,
        "safety": 65,
        "transparency": 0,
        "sustainability": 0
      },
      "price": 189,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973458153669",
      "vsf_explanation": "This is a physical weighted blanket, not a supplement, so it's out of scope for a product category built around ingested or topically applied ingredients. Deep pressure stimulation from weighting has some legitimate research support for anxiety and sleep, but the added gemstone (Amethyst, Tourmaline, Rose Quartz, Shungite), 'negative ion,' and EMF-shielding claims layered on top have no credible clinical evidence. It is scored here only to document why it does not belong in a supplement catalog.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "theracomfort-weighted-eye-pillow",
      "title": "TheraComfort Weighted Eye Pillow",
      "vendor": "Therasage",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/147.png?v=1789862110",
      "score": 19,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "theracomfort",
        "weighted",
        "eye",
        "pillow",
        "therasage"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_environment"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 20,
        "manufacturing": 0,
        "safety": 68,
        "transparency": 0,
        "sustainability": 0
      },
      "price": 33,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973458186437",
      "vsf_explanation": "This is a weighted, gemstone-embedded eye pillow, a physical sleep accessory rather than a supplement, so it's out of scope for the Vyvata Supplement Framework. Weighted pressure on the eyes and light-blocking for sleep have plausible general benefit, but claims around 'gemstone technology,' 'earth energies,' and 'pineal gland support' are not backed by peer-reviewed evidence. It is scored here only to document why it does not belong in a supplement catalog.",
      "vsf_autofail_rule": "out_of_scope_for_biohacking"
    },
    {
      "handle": "jigsaw-magrelief™",
      "title": "Jigsaw MagRelief™",
      "vendor": "Jigsaw Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/jigsaw-magrelief-shelf.png?v=1789862146",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "jigsaw",
        "magrelief",
        "jigsaw",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 65,
        "manufacturing": 68,
        "safety": 78,
        "transparency": 72,
        "sustainability": 50
      },
      "price": 29.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973458481349",
      "vsf_explanation": "This is a topical magnesium chloride lotion, and the evidence for meaningful transdermal magnesium absorption into systemic circulation is mixed and weaker than for oral supplementation, which is the main drag on the evidence score. Formulation quality is otherwise solid, using genuine Zechstein magnesium chloride, branded OptiMSM, and certified organic oils, with clear 'free of parabens/phenoxyethanol' disclosures. As a topical product, systemic safety risk is low.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamin-k2-e-complex",
      "title": "Vitamin K2 + E Complex",
      "vendor": "Jigsaw Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/jigsaw-vitamin-k2-plus-e-complex-shelf.png?v=1789862146",
      "score": 73,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "complex",
        "jigsaw",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 78,
        "manufacturing": 68,
        "safety": 78,
        "transparency": 72,
        "sustainability": 50
      },
      "price": 39.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973458514117",
      "vsf_explanation": "MenaQ7 is a well-validated, clinically-studied MK-7 vitamin K2 form with genuine evidence for directing calcium into bone rather than soft tissue, and pairing it with a full-spectrum vitamin E complex (rather than isolated alpha-tocopherol) reflects a more complete-nutrient formulation approach. Using named, branded actives is a transparency strength. Vitamin K2 does interact with blood-thinning medications, and that contraindication isn't called out on this product page, which is a minor safety-disclosure gap.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "jigsaw-probiotics-essential-blend™",
      "title": "Jigsaw Probiotics - Essential Blend™",
      "vendor": "Jigsaw Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/jigsaw-essential-blend-probiotics-shelf.png?v=1789862152",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "jigsaw",
        "probiotics",
        "essential",
        "blend",
        "jigsaw",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 74,
        "formulation": 76,
        "manufacturing": 68,
        "safety": 82,
        "transparency": 72,
        "sustainability": 50
      },
      "price": 44.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973458612421",
      "vsf_explanation": "25 billion CFU across five clinically-researched strains per capsule is a clearly disclosed potency, and probiotic supplementation for digestive and immune support has a solid general evidence base. The product page doesn't list the specific strain names/species, which matters for probiotics since efficacy is strain-specific, so formulation confidence is good but not complete. Probiotics are broadly well-tolerated with low safety risk for the general population.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "jigsaw-magsoothe®",
      "title": "Jigsaw MagSoothe®",
      "vendor": "Jigsaw Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/jigsaw-magsoothe-all-hero.png?v=1789862152",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "jigsaw",
        "magsoothe",
        "jigsaw",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 76,
        "manufacturing": 68,
        "safety": 80,
        "transparency": 72,
        "sustainability": 50
      },
      "price": 49.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973458645189",
      "vsf_explanation": "Magnesium glycinate has a solid evidence base for supporting relaxation and sleep quality, and glycinate is a well-absorbed, GI-gentle chelate compared to cheaper forms like oxide. The powder format doesn't disclose an exact elemental magnesium dose on this page, which is the main gap versus a full formulation score. Magnesium glycinate is generally very well tolerated.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "jigsaw-coq10-w-srt®",
      "title": "Jigsaw CoQ10 w/SRT®",
      "vendor": "Jigsaw Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/jigsaw-coq10-w-srt-shelf.png?v=1789862152",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "jigsaw",
        "coq10",
        "srt",
        "jigsaw",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 68,
        "manufacturing": 68,
        "safety": 82,
        "transparency": 72,
        "sustainability": 50
      },
      "price": 49.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973458710725",
      "vsf_explanation": "CoQ10 has good evidence for cardiovascular and cellular energy support, particularly for people on statins, and MicroActive CoQ10 is an established bioavailable delivery form. The proprietary 'Sustained Release Technology' (SRT) claim of 24-hour time release isn't independently published or validated, which is a transparency gap common to branded-technology marketing. CoQ10 itself has an excellent long-term safety record.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "jigsaw-curcumin-c3-complex®",
      "title": "Jigsaw Curcumin C3 Complex®",
      "vendor": "Jigsaw Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/jigsaw-curcumin-c3-complex-shelf.png?v=1789862152",
      "score": 76,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "jigsaw",
        "curcumin",
        "complex",
        "jigsaw",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 85,
        "formulation": 80,
        "manufacturing": 68,
        "safety": 82,
        "transparency": 72,
        "sustainability": 50
      },
      "price": 34.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973458743493",
      "vsf_explanation": "C3 Complex is a specific, patented curcuminoid extract genuinely backed by over 45 published studies, making it one of the better-researched turnstile ingredients in the joint/anti-inflammatory space. The formula uses the three primary research-validated curcuminoids rather than a generic turmeric extract, which is a meaningful formulation strength. Curcumin has a strong overall safety record at typical supplemental doses.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "jigsaw-multi-mineral-essential-blend™",
      "title": "Jigsaw Multi-Mineral - Essential Blend™",
      "vendor": "Jigsaw Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/jigsaw-essential-blend-multi-mineral-shelf.png?v=1789862152",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "jigsaw",
        "multi",
        "mineral",
        "essential",
        "blend",
        "jigsaw",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 55,
        "manufacturing": 68,
        "safety": 74,
        "transparency": 72,
        "sustainability": 50
      },
      "price": 29.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973458776261",
      "vsf_explanation": "Chelated zinc, copper, and chromium address well-documented micronutrient gaps in modern diets, which is a reasonable evidence base for a foundational mineral product. The '60+ micro-minerals Trace Mineral Blend' is described without individual dosing for each trace mineral, which is the kind of undosed blend language that limits both formulation and transparency confidence even though it isn't the primary active ingredient. Standard multi-mineral doses carry low safety risk for most adults.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "jigsaw-activated-b-w-srt®",
      "title": "Jigsaw Activated B w/SRT®",
      "vendor": "Jigsaw Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/jigsaw-activated-b-w-srt-shelf.png?v=1789862153",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "jigsaw",
        "activated",
        "srt",
        "jigsaw",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 76,
        "formulation": 72,
        "manufacturing": 68,
        "safety": 80,
        "transparency": 72,
        "sustainability": 50
      },
      "price": 49.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973458809029",
      "vsf_explanation": "Using 'active' methylated B-vitamin forms (e.g., methylfolate, methylcobalamin) rather than synthetic precursors has decent evidence for improved bioavailability, especially for people with common MTHFR gene variants. As with the brand's other 'w/SRT' products, the proprietary sustained-release delivery claim isn't independently validated, which caps the transparency score. B vitamins are water-soluble and carry a strong general safety record.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "jigsaw-adrenal-cocktail™-wholefood-vitamin-c",
      "title": "Jigsaw Adrenal Cocktail™ + Wholefood Vitamin C",
      "vendor": "Jigsaw Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/jigsaw-adrenal-cocktail-all-hero.png?v=1789862153",
      "score": 67,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "mood",
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "jigsaw",
        "adrenal",
        "cocktail",
        "wholefood",
        "vitamin",
        "jigsaw",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 70,
        "manufacturing": 68,
        "safety": 78,
        "transparency": 72,
        "sustainability": 50
      },
      "price": 39.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973458841797",
      "vsf_explanation": "The individual ingredients — potassium bicarbonate, sea salt, and acerola cherry vitamin C — each have their own evidence, but 'adrenal cocktail' as a functional-medicine concept and the specific claim of supporting 'balanced response to stress' aren't backed by dedicated clinical trials on this combination. The three-ingredient formula is simple and reasonably transparent, using whole-food vitamin C rather than synthetic ascorbic acid alone. Ingredients are generally well-tolerated at typical doses.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "jigsaw-pureway-c®-plus™",
      "title": "Jigsaw Pureway-C® Plus™",
      "vendor": "Jigsaw Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/jigsaw-pureway-c-plus-shelf.png?v=1789862153",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "jigsaw",
        "pureway",
        "plus",
        "jigsaw",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 74,
        "formulation": 76,
        "manufacturing": 68,
        "safety": 80,
        "transparency": 72,
        "sustainability": 50
      },
      "price": 34.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973458940101",
      "vsf_explanation": "PureWay-C is a patented vitamin C formulation with published data suggesting improved absorption and retention versus standard ascorbic acid, and pairing it with L-lysine and standardized Quercifit quercetin supports immune function and antioxidant activity. Using named, branded ingredient forms rather than generic versions is a formulation and transparency strength. Vitamin C, lysine, and quercetin are all well-tolerated at typical doses.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "jigsaw-magpure™",
      "title": "Jigsaw MagPure™",
      "vendor": "Jigsaw Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/jigsaw-magpure-all-hero.png?v=1789862153",
      "score": 73,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "jigsaw",
        "magpure",
        "jigsaw",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 78,
        "manufacturing": 68,
        "safety": 80,
        "transparency": 72,
        "sustainability": 50
      },
      "price": 29.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973459005637",
      "vsf_explanation": "Offering separate Magnesium Malate (energy) and Magnesium Glycinate (calming) options lets users match the form to the intended use, which is a genuine formulation strength since these forms have different physiological profiles and evidence bases. Magnesium malate's link to mitochondrial energy production and glycinate's calming/sleep support are both reasonably well-documented. Both chelated forms are well-tolerated with low GI side-effect risk compared to magnesium oxide.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "jigsaw-brain-boost™",
      "title": "Jigsaw Brain Boost™",
      "vendor": "Jigsaw Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/jigsaw-brain-boost-shelf.png?v=1789862153",
      "score": 74,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "jigsaw",
        "brain",
        "boost",
        "jigsaw",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 80,
        "formulation": 78,
        "manufacturing": 68,
        "safety": 80,
        "transparency": 72,
        "sustainability": 50
      },
      "price": 59.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973459071173",
      "vsf_explanation": "Magnesium L-Threonate is one of the better-researched cognitive-support magnesium forms, with published research on its ability to cross the blood-brain barrier and support memory and learning receptors, unlike most magnesium forms. Using a single, clinically-studied ingredient rather than a proprietary multi-ingredient blend is a formulation and transparency strength. Magnesium L-threonate is generally well-tolerated.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "jigsaw-alaskan-cod-liver-oil™",
      "title": "Jigsaw Alaskan Cod Liver Oil™",
      "vendor": "Jigsaw Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/jigsaw-alaskan-cod-liver-oil-all-hero.png?v=1789862153",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "jigsaw",
        "alaskan",
        "cod",
        "liver",
        "oil",
        "jigsaw",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 74,
        "manufacturing": 68,
        "safety": 74,
        "transparency": 72,
        "sustainability": 50
      },
      "price": 59.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973459103941",
      "vsf_explanation": "Omega-3 fatty acids from cod liver oil have strong evidence for cardiovascular, brain, and eye health, and naturally-occurring vitamins A and D add value beyond a standard fish oil. Sourcing from MSC-certified, line-caught cod in Dutch Harbor, Alaska is a genuine sustainability differentiator versus most fish oil brands. The product page doesn't disclose exact EPA/DHA or vitamin A/D milligram amounts, which limits a full formulation score, and unspecified vitamin A content warrants awareness for anyone stacking multiple vitamin A sources.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "jigsaw-potassium-cocktail™",
      "title": "Jigsaw Potassium Cocktail™",
      "vendor": "Jigsaw Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/jigsaw-potassium-cocktail-all-hero.png?v=1789862170",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "jigsaw",
        "potassium",
        "cocktail",
        "jigsaw",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 75,
        "manufacturing": 68,
        "safety": 78,
        "transparency": 72,
        "sustainability": 50
      },
      "price": 49.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973459202245",
      "vsf_explanation": "800mg of potassium (roughly two bananas' worth) plus magnesium lysinate glycinate chelate and trace-mineral sea salt is a clearly dosed electrolyte formula, not a hidden blend. Potassium and magnesium supplementation for hydration and blood pressure support have solid clinical grounding, though this specific 'cocktail' combination hasn't been studied as a unit. No sugar or caffeine keeps the formula clean for daily use.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "jigsaw-magnesium-w-srt®",
      "title": "Jigsaw Magnesium w/SRT®",
      "vendor": "Jigsaw Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/jigsaw-magnesium-w-srt-hero.png?v=1789862176",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "jigsaw",
        "magnesium",
        "srt",
        "jigsaw",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 68,
        "manufacturing": 68,
        "safety": 78,
        "transparency": 72,
        "sustainability": 50
      },
      "price": 49.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973459431621",
      "vsf_explanation": "Jigsaw Health's MagSRT stands out for having an actual placebo-controlled human clinical trial specific to this sustained-release magnesium formula published in the peer-reviewed Journal of the American College of Nutrition — a level of product-specific clinical evidence that's uncommon in the mass-market supplement space and directly supports the marketed claims around energy, sleep, and leg cramp relief. The Sustained Release Technology (SRT) formulation approach is a legitimate response to magnesium's common gastrointestinal tolerability issues, though the listing here doesn't disclose the exact elemental magnesium dose per serving. Jigsaw Health has a reputation in the wellness space for citing its own research directly rather than relying on generic ingredient claims, supporting above-average transparency, making this a strong Standard-tier product, just below the Verified threshold, driven primarily by genuine product-specific clinical evidence.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "jigsaw-electrolyte-supreme™",
      "title": "Jigsaw Electrolyte Supreme™",
      "vendor": "Jigsaw Health",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/jigsaw-electrolyte-supreme-all-hero.png?v=1789862176",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "jigsaw",
        "electrolyte",
        "supreme",
        "jigsaw",
        "health"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 68,
        "safety": 80,
        "transparency": 72,
        "sustainability": 50
      },
      "price": 49.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973459497157",
      "vsf_explanation": "Electrolyte supplementation has a reasonable, well-established evidence base for hydration and exercise-performance support, and this Jigsaw Electrolyte Supreme formula is positioned as a full-spectrum electrolyte powder with complementary minerals and vitamins, sugar-free and keto-friendly. Unlike Jigsaw's MagSRT product, this specific listing doesn't cite a product-specific clinical trial or disclose exact sodium/potassium/magnesium amounts per serving, so formulation and evidence scores are more moderate and general-category-based rather than product-specific. Jigsaw Health's brand-level reputation for research-oriented, transparent marketing still supports above-average manufacturing and transparency confidence relative to unbranded competitors, landing this as a Standard-tier product on the strength of a sound product category and a credible brand, tempered by the lack of product-specific dosing disclosure in this listing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pro-100-probiotic",
      "title": "Pro-100 Probiotic",
      "vendor": "Vitamin Bounty",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Pro100_ProductHero_393089bf-428c-4f86-8a38-44e0811812c0.jpg?v=1789862270",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pro",
        "100",
        "probiotic",
        "vitamin",
        "bounty"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 58,
        "safety": 75,
        "transparency": 35,
        "sustainability": 50
      },
      "price": 32.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46973460021445",
      "vsf_explanation": "Probiotics as a category have a reasonable evidence base for digestive and immune support, but the specific strains and their individual CFU (colony-forming unit) counts are the primary factors determining a probiotic's actual efficacy — and this Vitamin Bounty listing discloses neither, only stating '13 hand-picked probiotic strains' without naming them or their counts. The added Vitamin C and zinc are reasonable complementary immune-support ingredients, but their doses also aren't disclosed. Vitamin Bounty is an active, moderately established subscription-model brand without major red flags, but the near-complete absence of dosing specificity for the product's core active ingredients is a significant transparency and formulation gap, pulling the product into Rejected tier despite probiotics generally being a well-regarded supplement category.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "life-extension-senolytic-activator-36-caps-autophagy-renew-30-caps-longevity-bundle-quercetin-fisetin-luteolin",
      "title": "Life Extension Senolytic Activator 36 Caps + Autophagy Renew 30 Caps | Longevity Bundle | Quercetin Fisetin Luteolin",
      "vendor": "Life Extension",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_1_8b056bd5-3eb1-44a3-8c6d-62b56c8e401b.webp?v=1789915427",
      "score": 75,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "life",
        "extension",
        "senolytic",
        "activator",
        "caps",
        "autophagy",
        "renew",
        "caps",
        "longevity",
        "bundle",
        "quercetin",
        "fisetin",
        "luteolin",
        "life",
        "extension"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 75,
        "manufacturing": 85,
        "safety": 78,
        "transparency": 72,
        "sustainability": 52
      },
      "price": 37.88,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976071205061",
      "vsf_explanation": "This Life Extension bundle combines two cellular-aging-focused formulas with research-informed ingredient choices: Bio-Quercetin phytosome (a bioavailability-enhanced quercetin delivery form), standardized fisetin (18%, 56mg — a well-studied senolytic flavonoid), theaflavins, and apigenin, all with specific disclosed amounts rather than a hidden proprietary blend. Senolytic and autophagy-support science is genuinely promising but still maturing — solid preclinical and early human mechanistic evidence exists, but large-scale human outcome trials for these specific compound combinations remain limited, capping the evidence score below Elite tier. Life Extension is a well-established, longstanding supplement manufacturer known for detailed ingredient sourcing disclosure and its own research/testing infrastructure, supporting above-average manufacturing and transparency scores, and this lands as a Verified-tier product on the strength of ingredient-level dose transparency and a reputable, research-oriented manufacturer.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamatic-magnesium-glycinate-500mg-180-vegetarian-tablets",
      "title": "Vitamatic Magnesium Glycinate 500mg | 180 Vegetarian Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6c32c87cd5703e255a1b69eeac8b2bbed41e59e46ff317a609ca36f18fb53b2b.png?v=1789915620",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamatic",
        "magnesium",
        "glycinate",
        "500mg",
        "180",
        "vegetarian",
        "tablets",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 45,
        "safety": 78,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 17.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976084574405",
      "vsf_explanation": "Magnesium glycinate (bisglycinate) is a well-studied, highly bioavailable chelated form of magnesium, and this Vitamatic product's 500mg dose is consistent with commercial and research-range dosing for supporting muscle, heart, and enzyme function. Vitamatic states the product is manufactured in a GMP-compliant, FDA-registered US facility, providing reasonable baseline manufacturing confidence, though no independent lab testing or COA is disclosed. The formulation is single-ingredient and straightforward, which supports formulation clarity even without deeper certification data, landing this as a Standard-tier product on the strength of a well-chosen, well-dosed ingredient form from an established mid-market brand.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamatic-vitamin-b12-5000mcg-365-fast-dissolve-tablets-energy-nerve-cardiovascular-support-non-gmo",
      "title": "Vitamatic Vitamin B12 5000mcg – 365 Fast-Dissolve Tablets | Energy, Nerve & Cardiovascular Support | Non-GMO",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d13116bf03674f96402735c553d1ae736c7de7aa0b308adb0bc9228a4e129235.png?v=1789915620",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamatic",
        "vitamin",
        "b12",
        "5000mcg",
        "365",
        "fast",
        "dissolve",
        "tablets",
        "energy",
        "nerve",
        "cardiovascular",
        "support",
        "non",
        "gmo",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 45,
        "safety": 82,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 17.77,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976084607173",
      "vsf_explanation": "Vitamin B12 has an extremely well-established evidence base for energy metabolism, red blood cell formation, and nervous system health, and methylcobalamin (the form used here) is a bioactive form with good research support; the sublingual fast-dissolve delivery format also has evidence supporting improved absorption versus standard swallowed tablets. Vitamatic clearly discloses the exact dose (5000mcg, 208,333% DV) and delivery format, giving this product strong formulation and label transparency. Because B12 is water-soluble with an extremely wide margin of safety, even a high-dose product like this carries minimal safety risk for the general population, making this a solidly Standard-tier product driven by an exceptionally well-evidenced, clearly dosed, and low-risk ingredient.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamatic-quercetin-with-bromelain-120-vegetable-capsules",
      "title": "Vitamatic Quercetin with Bromelain | 120 Vegetable Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/faf2898f2e2715a370dbd71ec1a61e2879cee76a72d8fa864bf3eb681e41dca5.png?v=1789915620",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamatic",
        "quercetin",
        "with",
        "bromelain",
        "120",
        "vegetable",
        "capsules",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 58,
        "manufacturing": 45,
        "safety": 76,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 17.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976084639941",
      "vsf_explanation": "Quercetin has a reasonable evidence base for antioxidant, cardiovascular, and immune-related support, and pairing it with bromelain is a formulation choice supported by research suggesting bromelain can enhance quercetin's bioavailability. However, the listing does not disclose the specific milligram doses of either quercetin or bromelain, a meaningful transparency gap for a combination product where dosing directly affects expected benefit. Vitamatic's GMP-compliant manufacturing claim provides moderate baseline confidence, but without dose disclosure it's not possible to fully evaluate whether the formulation matches doses used in quercetin/bromelain research, making this a Standard-tier product held back primarily by the missing dose information.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "himalayan-pure-shilajit-1000mg-120-caps-naturally-occurring-fulvic-acid",
      "title": "Himalayan Pure Shilajit 1000mg 120 Caps Naturally Occurring Fulvic Acid",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_becffcfe-7ad8-4ae3-a012-c190cde1903a.jpg?v=1789915627",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "himalayan",
        "pure",
        "shilajit",
        "1000mg",
        "120",
        "caps",
        "naturally",
        "occurring",
        "fulvic",
        "acid",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 10,
        "safety": 25,
        "transparency": 5,
        "sustainability": 50
      },
      "price": 16.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976084902085",
      "vsf_explanation": "'Himalayan' describes origin, not a brand — no actual company name appears anywhere in this listing, leaving no accountable party for Vyvata to verify against. Shilajit has emerging but still-limited clinical evidence, and the 500mg-per-capsule dose is within commonly used ranges, but the absence of any disclosed heavy-metal purity testing is a real safety concern given shilajit's documented contamination risk when unpurified.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "bromelain-3600",
      "title": "Bromelain 3600",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3ffce1fbded23fef92f784277a5ee9d3e60a953b18121830e7dae092ae1d5550.jpg?v=1789915627",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bromelain",
        "3600",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 72,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 35,
        "sustainability": 50
      },
      "price": 19.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976085000389",
      "vsf_explanation": "The product description identifies Toniiq as the brand behind this high-potency bromelain (3,600 GDU/gram, well above the 1,800 GDU/gram common in competing products), and bromelain itself has moderate clinical support for digestion and inflammation. Manufacturing disclosure is limited to a vague 'state-of-the-art extraction process' claim without a specific GMP or facility statement, and the listing doesn't flag the pineapple/latex allergy cross-reactivity caution.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-citrulline-3000mg-240-capsules-gmp-certified-non-gmo-free-form-amino",
      "title": "L-Citrulline 3000mg 240 Capsules GMP Certified & Non-GMO Free Form Amino",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_d5369f74-7027-4b2d-83f1-4c92b0af0520.jpg?v=1789915626",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "citrulline",
        "3000mg",
        "240",
        "capsules",
        "gmp",
        "certified",
        "non",
        "gmo",
        "free",
        "form",
        "amino",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 45,
        "manufacturing": 35,
        "safety": 65,
        "transparency": 8,
        "sustainability": 50
      },
      "price": 24.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976084836549",
      "vsf_explanation": "L-citrulline has solid clinical support for nitric oxide production and exercise performance, but the studied dose range for pump/performance effects is typically 6-8g, and this product's 3,000mg (4 capsules) serving sits below that range, which limits its formulation score. No brand name appears anywhere in the listing, so despite a 'GMP Certified' claim in the title, there's no identifiable company to verify that claim against.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "gymnema-sylvestre-12500mg-150-vegan-caps-bioperine-gymnemic-acids-nongmo-no-glutein",
      "title": "Gymnema Sylvestre 12500mg 150 Vegan Caps Bioperine/Gymnemic Acids NonGMO/No Glutein",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_6971da12-ca59-49d5-93d7-216b6c8a9a05.jpg?v=1789915626",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gymnema",
        "sylvestre",
        "12500mg",
        "150",
        "vegan",
        "caps",
        "bioperine",
        "gymnemic",
        "acids",
        "nongmo",
        "glutein",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 30,
        "transparency": 8,
        "sustainability": 50
      },
      "price": 27.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976084934853",
      "vsf_explanation": "Gymnema sylvestre has moderate human evidence for supporting healthy blood sugar levels, but the '50:1 extract equivalent to 12,500mg' labeling obscures the actual extract weight per capsule and doesn't disclose standardized gymnemic acid content, which limits the formulation score. No brand name appears anywhere in the listing, and critically, the product omits any caution that gymnema can meaningfully affect blood sugar — a real concern for anyone on diabetes medication.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "lions-mane-mushroom-7500mg-240-capsules-10-1-extract-brain-immune-support",
      "title": "Lion's Mane Mushroom 7500mg | 240 Capsules | 10:1 Extract | Brain & Immune Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_630946cd-4729-4a46-90f4-429ae5433aeb.jpg?v=1789915626",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lion",
        "mane",
        "mushroom",
        "7500mg",
        "240",
        "capsules",
        "extract",
        "brain",
        "immune",
        "support",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 42,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 8,
        "sustainability": 50
      },
      "price": 25.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976084803781",
      "vsf_explanation": "Lion's mane has a growing body of evidence for cognitive support, mostly from animal studies and a handful of promising small human trials on nerve growth factor. Like the other 10:1 extract listing in this batch, the '7,500mg' figure appears to be a raw-material equivalent rather than the actual extract weight per capsule, which obscures true potency, and no brand name is disclosed anywhere despite a stated '3rd-party lab tested' claim.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "ginkgo-biloba-120mg-standardized-extract-200caps-puritan-brain-health",
      "title": "Ginkgo Biloba 120mg Standardized Extract 200Caps Puritan Brain Health",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l960.jpg?v=1789915626",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ginkgo",
        "biloba",
        "120mg",
        "standardized",
        "extract",
        "200caps",
        "puritan",
        "brain",
        "health",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 50,
        "manufacturing": 64,
        "safety": 80,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 17.05,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976084967621",
      "vsf_explanation": "Ginkgo biloba is one of the more extensively studied cognitive-support botanicals, with human trials generally using standardized extracts (commonly 120-240mg/day) for memory and circulation support, which aligns with this product's 120mg standardized-extract dose. However, the listing does not disclose the specific flavone-glycoside/terpene-lactone standardization percentage used in most published trials, making it impossible to confirm this extract matches the studied formulation. Puritan's Pride is an established, GMP-oriented mainstream brand, which supports moderate manufacturing confidence, but no third-party COA or lab-testing disclosure is provided on this listing. Overall this lands as a Standard-tier product: real evidence base for the ingredient class, offset by incomplete formulation transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ancient-bliss-trans-resveratrol-1500mg-with-polyphenol-complex-120caps",
      "title": "Ancient Bliss Trans-Resveratrol 1500mg with Polyphenol Complex 120Caps",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4b2efe7af083634c852ac5c9500c949017fa56dd7158b53440acf7d4e45f938a.webp?v=1789915626",
      "score": 41,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ancient",
        "bliss",
        "trans",
        "resveratrol",
        "1500mg",
        "with",
        "polyphenol",
        "complex",
        "120caps",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 45,
        "manufacturing": 10,
        "safety": 72,
        "transparency": 35,
        "sustainability": 50
      },
      "price": 26.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976084869317",
      "vsf_explanation": "Trans-resveratrol has a substantial preclinical evidence base for antioxidant and cardiovascular-support pathways, but robust human RCT evidence for general healthy-aging claims at consumer doses remains limited and mixed. The 1500mg dose is on the higher end of what's been studied in humans, so it is not automatically a formulation red flag, but the accompanying undisclosed 'Polyphenol Complex' means the full ingredient composition beyond resveratrol itself is not quantified. Ancient Bliss is a small, low-visibility brand with no publicly available manufacturing certifications, COAs, or facility information, which significantly limits manufacturing and transparency confidence. The combination of broad healthy-aging/cardiovascular marketing claims with minimal brand verification pulls this into Rejected tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "organic-spirulina-1000mg-300tabs-vegeterian-non-gmo-blue-algae-superfood-amino",
      "title": "Organic Spirulina 1000mg 300Tabs Vegeterian/Non-GMO/Blue Algae Superfood Amino",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_ae44dd1b-ccb5-40b6-8f39-3b74b830e12f.png?v=1789915627",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "spirulina",
        "1000mg",
        "300tabs",
        "vegeterian",
        "non",
        "gmo",
        "blue",
        "algae",
        "superfood",
        "amino",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 58,
        "manufacturing": 40,
        "safety": 75,
        "transparency": 25,
        "sustainability": 50
      },
      "price": 17.21,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976085164229",
      "vsf_explanation": "Spirulina has a reasonably solid evidence base as a nutrient-dense whole-food supplement, with documented protein, amino acid, and antioxidant content, and the 1000mg dose (2 tablets) is a standard, non-blended, single-ingredient formulation. However, no brand name appears anywhere in the title or product description — a critical transparency gap, since it cannot be verified who manufactures the product, under what quality standards, or where it's sourced. Per Vyvata's zero-assumption rule, an unidentifiable brand cannot receive benefit-of-the-doubt credit for manufacturing or provenance, which is why this product is rejected despite spirulina itself being a reasonably evidence-backed ingredient.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "organic-turmeric-1440mg-with-black-pepper-ginger-120-vega",
      "title": "Organic Turmeric 1440mg with Black Pepper & Ginger |120 Vega",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e5eb4d90170fda906effe396024546e0845a637a1425b3df790d2eb738960286.jpg?v=1789915626",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "turmeric",
        "1440mg",
        "with",
        "black",
        "pepper",
        "ginger",
        "120",
        "vega",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 78,
        "transparency": 30,
        "sustainability": 50
      },
      "price": 14.31,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976085065925",
      "vsf_explanation": "This Prowise-branded turmeric formula discloses clear per-capsule dosing (670mg organic turmeric, 40mg ginger, and 10mg black pepper per capsule), and pairing turmeric with black pepper (piperine) is a formulation choice directly supported by research showing black pepper can meaningfully increase curcumin absorption. Turmeric/curcumin has a substantial evidence base for anti-inflammatory and antioxidant support, though this is a whole-turmeric powder rather than a curcumin-standardized extract, so it likely delivers less curcuminoid content per gram than extract-based competitors. Prowise is a UK-based manufacturer with reasonable GMP-oriented practices, but the listing provides no third-party COA or independent testing data, capping manufacturing and transparency in the mid-range. This lands as a Standard-tier product on the strength of clear dosing and an absorption-conscious formulation.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ginkgo-biloba-and-korean-ginseng-tablets-8000mg-180-vegan-tablets-ginkgo-6000mg-korean-ginseng-root-2000mg-uk-manufactured-by-prowise-healthcare",
      "title": "Ginkgo Biloba and Korean Ginseng Tablets 8000mg 180 Vegan Tablets | Ginkgo 6000mg & Korean Ginseng Root 2000mg | UK Manufactured by Prowise Healthcare",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/61ed1yrhnDL._AC_SL1500.jpg?v=1789915626",
      "score": 47,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive",
        "energy",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ginkgo",
        "biloba",
        "and",
        "korean",
        "ginseng",
        "tablets",
        "8000mg",
        "180",
        "vegan",
        "tablets",
        "ginkgo",
        "6000mg",
        "korean",
        "ginseng",
        "root",
        "2000mg",
        "manufactured",
        "prowise",
        "healthcare",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics",
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 35,
        "manufacturing": 55,
        "safety": 70,
        "transparency": 30,
        "sustainability": 50
      },
      "price": 16.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976085098693",
      "vsf_explanation": "This Prowise-branded combination product has a significant labeling inconsistency: the outer product title states 'Ginkgo 6000mg & Korean Ginseng Root 2000mg,' while the product description headline states the reverse — 'Ginkgo Biloba 2000mg and Korean Ginseng 6000mg.' Since ginkgo and ginseng have very different evidence profiles and typical effective dose ranges, this contradiction makes it impossible to know which ingredient actually dominates the formula. Both ginkgo (cognitive/circulatory support) and Korean ginseng (energy/vitality support) have real research bases individually, but the dosing confusion undermines confidence in the product as formulated and labeled, triggering a misleading-naming auto-fail regardless of underlying ingredient quality.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "nattokinase-400-mg-8-000-fu-fibrinolytic-units-240-caps-high-potency",
      "title": "Nattokinase 400 mg 8,000 FU Fibrinolytic Units 240 Caps High Potency",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_40db1b55-c96d-4bd3-91dd-b26978e2aa46.png?v=1789915626",
      "score": 41,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nattokinase",
        "400",
        "000",
        "fibrinolytic",
        "units",
        "240",
        "caps",
        "high",
        "potency",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 30,
        "manufacturing": 38,
        "safety": 55,
        "transparency": 20,
        "sustainability": 50
      },
      "price": 36.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976085033157",
      "vsf_explanation": "This nattokinase listing has a serious internal dosing contradiction: the product title states 400mg per capsule at 8,000 FU in a 240-capsule bottle, while the product description headline states an entirely different formula — 200mg at 20,000 FU in a 200-capsule bottle with a 3-capsule serving size. Because nattokinase's fibrinolytic activity is measured and dosed specifically in FU (fibrinolytic units) and has real bleeding-risk relevance for anyone on blood thinners, this potency mismatch is a genuine safety-relevant transparency failure, not just a copy error. No brand name is identified anywhere in the listing, compounding the inability to verify actual product contents, and the combination triggers a misleading-naming auto-fail.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "oregano-oil-9-000mg-300-softgels-carvacrol-mediterranean-wild-harvest-immune-support",
      "title": "Oregano Oil 9,000mg – 300 Softgels | Carvacrol | Mediterranean Wild Harvest | Immune Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600.jpg?v=1789915626",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "oregano",
        "oil",
        "000mg",
        "300",
        "softgels",
        "carvacrol",
        "mediterranean",
        "wild",
        "harvest",
        "immune",
        "support",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 30,
        "manufacturing": 38,
        "safety": 60,
        "transparency": 25,
        "sustainability": 50
      },
      "price": 34.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976085131461",
      "vsf_explanation": "This oregano oil listing advertises a '9,000mg per serving' potency figure without disclosing any carvacrol standardization percentage, dilution ratio, or how that number was calculated — a common pattern where equivalency-based numbers dramatically overstate actual concentrated-oil content, presented here without the substantiation needed to verify it. Oregano oil's carvacrol content does have legitimate in-vitro and limited human evidence for antimicrobial activity, but marketing language like 'combat harmful bacteria, fungi, and pathogens' edges into stronger claims than the current human evidence base fully supports. No brand or manufacturer is identified anywhere in the listing, and the unsubstantiated potency claim combined with unidentifiable provenance triggers a misleading-naming auto-fail.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "activated-charcoal-1200mg-200-capsules-high-potency-made-in-uk-prowise",
      "title": "Activated Charcoal 1200mg – 200 Capsules | High Potency | Made in UK | Prowise",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/701b69b03cb8e2d8b1e4cc613fc5d3ba17b58bb4584c9e0b0b5043ea7df0f355.jpg?v=1789915627",
      "score": 47,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "activated",
        "charcoal",
        "1200mg",
        "200",
        "capsules",
        "high",
        "potency",
        "made",
        "prowise",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 52,
        "manufacturing": 55,
        "safety": 48,
        "transparency": 30,
        "sustainability": 50
      },
      "price": 16.25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976085295301",
      "vsf_explanation": "This Prowise-branded activated charcoal product clearly discloses its 1200mg daily dose (4 capsules) and coconut-shell sourcing, giving it reasonable formulation transparency for a single-ingredient product. However, the evidence base for daily 'detox/cleansing' use of activated charcoal in healthy people is weak — its strongest evidence is for acute overdose/poisoning treatment in clinical settings, and its core adsorption mechanism means it can also bind and reduce absorption of medications and other nutrients taken nearby. The listing does caution to take it away from meals and medications, a positive partial disclosure, but doesn't prominently flag this interaction risk. This lands in Rejected tier primarily due to the mismatch between the evidence for daily use and the product's general-wellness marketing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "phi-naturals-magnesium-citrate-400mg-sleep-relaxation-muscle-energy-support-non-gmo-gluten-free",
      "title": "Phi Naturals Magnesium Citrate 400mg – Sleep, Relaxation, Muscle & Energy Support | Non-GMO, Gluten Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/346c467fae123724d8f554c9564506130e722e3dfac5a4de4cb5719bb31b3405.jpg?v=1789915626",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "phi",
        "naturals",
        "magnesium",
        "citrate",
        "400mg",
        "sleep",
        "relaxation",
        "muscle",
        "energy",
        "support",
        "non",
        "gmo",
        "gluten",
        "free",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 68,
        "manufacturing": 48,
        "safety": 78,
        "transparency": 58,
        "sustainability": 50
      },
      "price": 16.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976085229765",
      "vsf_explanation": "Magnesium citrate is one of the better-absorbed and most-studied forms of magnesium, with a reasonable evidence base for sleep quality, relaxation, and muscle function support, and this Phi Naturals product's 400mg dose falls within the commonly studied range. The listing transparently discloses the 13-14% elemental magnesium content of the citrate form, an uncommon level of specificity for a mid-market brand. Phi Naturals is a smaller, less-established brand with no publicly available manufacturing certifications or third-party testing disclosed, which caps the manufacturing score. This is a Standard-tier product: solid ingredient science and above-average dosing transparency, offset by limited brand-level verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "resveratrol-45-000mg-180-caps-polygonum-cuspidatum-ultra-high-potency-antioxidant-longevity-support",
      "title": "Resveratrol 45,000mg – 180 Caps | Polygonum Cuspidatum | Ultra-High Potency Antioxidant & Longevity Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_7fdb0d78-a2de-4f3b-ae83-54e3ad1a74ce.webp?v=1789915626",
      "score": 33,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "resveratrol",
        "000mg",
        "180",
        "caps",
        "polygonum",
        "cuspidatum",
        "ultra",
        "high",
        "potency",
        "antioxidant",
        "longevity",
        "support",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 20,
        "manufacturing": 35,
        "safety": 55,
        "transparency": 15,
        "sustainability": 50
      },
      "price": 28.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976085262533",
      "vsf_explanation": "This listing advertises '45,000mg equivalent per serving' of resveratrol from Polygonum cuspidatum root extract without disclosing any standardization percentage for actual trans-resveratrol content — a well-known pattern where raw-herb equivalency weights produce dramatically inflated headline numbers that don't reflect the actual concentration of the active compound. Resveratrol itself has real, if still-developing, human evidence at doses far below this figure, but the marketing layers on mechanistic claims (sirtuin activation, cellular rejuvenation) that outpace current human clinical evidence. No brand or manufacturer is identified in the listing, and the combination of an unsubstantiated, dramatically inflated potency claim with unidentifiable provenance triggers a misleading-naming auto-fail.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "vitamatic-mastic-gum-1000mg-per-serving-120-capsules",
      "title": "Vitamatic Mastic Gum 1000mg per Serving | 120 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/983bac4403cc8d668edd96f5f40de2fe9869b8845a8cef9bcb9fecc2a1cdbab5.png?v=1789915627",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamatic",
        "mastic",
        "gum",
        "1000mg",
        "per",
        "serving",
        "120",
        "capsules",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 58,
        "manufacturing": 45,
        "safety": 75,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 14.77,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976085328069",
      "vsf_explanation": "Mastic gum has a real, if modest, evidence base — several human studies (particularly around H. pylori and digestive comfort) support its traditional use for stomach and digestive health, and this Vitamatic product's 1000mg single-ingredient dose is straightforward and clearly labeled. Vitamatic states the product is manufactured in GMP-compliant, FDA-registered US facilities, giving it moderate manufacturing confidence, though no independent COA or lab testing is referenced. This is a Standard-tier product: a real, evidence-supported ingredient in a clearly dosed, single-ingredient formulation from an established mid-market brand.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "glucosamine-and-chondroitin-complex-200-high-strength-tablet",
      "title": "Glucosamine and Chondroitin Complex 200 High Strength Tablet",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8919f5f5f2c35214decb89301bee34d79ac15a33079ddd8293cc45e1b32b9e46.jpg?v=1789915626",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "glucosamine",
        "and",
        "chondroitin",
        "complex",
        "200",
        "high",
        "strength",
        "tablet",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 48,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 30,
        "sustainability": 50
      },
      "price": 17.42,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976085196997",
      "vsf_explanation": "This Prowise-branded joint formula clearly discloses its two headline actives — 1147mg glucosamine sulfate and 195mg chondroitin sulfate per serving — both within ranges used in the glucosamine/chondroitin joint-health research literature, which shows mixed but real evidence for mobility and comfort support. However, the formula is 'enriched' with MSM, Boswellia, Vitamin C, turmeric, ginger root, and rosehip without disclosing individual amounts for any of these six additional ingredients — a meaningful transparency gap, even though it falls short of a full proprietary-blend dose-hiding violation since the primary marketed actives are quantified. Prowise's UK manufacturing is GMP-oriented but doesn't include published third-party testing, and this lands just below the Standard threshold in Rejected tier primarily due to the undisclosed secondary ingredient amounts.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "r-alpha-lipoic-acid-600mg-r-ala-benfotiamine-300mg-true-r-form-ala-antioxidant-nerve-support",
      "title": "R-Alpha Lipoic Acid 600mg (R-ALA) + Benfotiamine 300mg | True R-Form ALA | Antioxidant & Nerve Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_e9a38e04-6433-4780-bd65-ce4cf709514b.png?v=1789915627",
      "score": 47,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alpha",
        "lipoic",
        "acid",
        "600mg",
        "ala",
        "benfotiamine",
        "300mg",
        "true",
        "form",
        "ala",
        "antioxidant",
        "nerve",
        "support",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 75,
        "manufacturing": 12,
        "safety": 50,
        "transparency": 8,
        "sustainability": 50
      },
      "price": 37.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976085360837",
      "vsf_explanation": "Both R-alpha lipoic acid and benfotiamine have reasonably solid clinical research behind them for nerve health, antioxidant activity, and glucose metabolism, and the 600mg R-ALA / 300mg benfotiamine doses fall within the ranges used in those studies. No brand name appears anywhere in the listing, there's no manufacturing disclosure, and the product omits the standard caution that ALA can affect blood sugar levels in people on diabetes medication.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "pure-shilajit-10000mg-10-1-extract-150-capsules-fulvic-acid-non-gmo",
      "title": "Pure Shilajit 10000mg (10:1 Extract) | 150 Capsules | Fulvic Acid | Non-GMO",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/81zQac1XQuL.__AC_SX300_SY300_QL70_FMwebp.webp?v=1789915628",
      "score": 28,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "shilajit",
        "10000mg",
        "extract",
        "150",
        "capsules",
        "fulvic",
        "acid",
        "non",
        "gmo",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 35,
        "manufacturing": 10,
        "safety": 25,
        "transparency": 5,
        "sustainability": 50
      },
      "price": 25.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976085393605",
      "vsf_explanation": "No identifiable brand appears anywhere in this listing — only descriptive terms like 'Pure' — so under Vyvata's zero-assumption rule there is no accountable party to verify sourcing, purity, or manufacturing claims against. Shilajit carries genuine but still-emerging clinical evidence, but unpurified shilajit has documented heavy-metal contamination risk that requires third-party purity testing, and none is disclosed here; the '10:1 extract equivalent to 10,000mg' labeling also obscures the actual extract weight per capsule.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "vitamin-d3-50000-iu-from-lanolin-50-gels-now-foods-olive-oil",
      "title": "Vitamin D3 50000 IU from Lanolin 50 gels Now Foods Olive Oil",
      "vendor": "Now Foods",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_b0a14e22-c695-49ee-9864-d379e4525c3d.jpg?v=1789915628",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "50000",
        "from",
        "lanolin",
        "gels",
        "now",
        "foods",
        "olive",
        "oil",
        "now",
        "foods"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 85,
        "formulation": 75,
        "manufacturing": 47,
        "safety": 11,
        "transparency": 24,
        "sustainability": 50
      },
      "price": 14.55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976085426373",
      "vsf_explanation": "Vitamin D3 has among the strongest evidence bases in the entire supplement category for bone, immune, and overall health, and 50,000 IU weekly is the standard clinical dose used to correct diagnosed deficiency, so this formulation directly matches the studied protocol. The safety score is capped because a dose this potent is normally taken under physician monitoring, and while the label does responsibly warn against daily use and recommends monitoring vitamin D and calcium levels, selling it as an unsupervised OTC product still carries real hypercalcemia/toxicity risk if misused. 50,000 IU is a prescription-scale dose meant for short-term physician-monitored repletion, not routine daily use. Selling it at Verified implied it was fine to take routinely, which is a real hypercalcemia and toxicity risk without blood-level monitoring — held at Rejected under safety_concern.",
      "vsf_autofail_rule": "safety_concern"
    },
    {
      "handle": "calcium-citrate-1000mg-200-caps-bone-muscle-heart-health-the-vitamin-stop",
      "title": "Calcium Citrate 1000mg – 200 Caps | Bone, Muscle & Heart Health | The Vitamin Stop",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_e4f5d516-dd7e-42c5-83f4-bc7d72be7f94.png?v=1789915628",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "joint",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "calcium",
        "citrate",
        "1000mg",
        "200",
        "caps",
        "bone",
        "muscle",
        "heart",
        "health",
        "the",
        "vitamin",
        "stop",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 55,
        "manufacturing": 15,
        "safety": 72,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 16.44,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976085459141",
      "vsf_explanation": "Calcium citrate has strong evidence supporting bone density and is well-established as the more bioavailable calcium form for people with reduced stomach acid. The listing doesn't disclose the elemental calcium amount (1,000mg of citrate salt yields roughly 200-210mg elemental calcium), and there's no GMP or facility registration statement anywhere in the listing, which drives the manufacturing score down under the zero-assumption rule despite reasonable medication-interaction warnings.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bacopa-50",
      "title": "Bacopa 50%",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7921d77c2845effe86a3e8e3f997db51136987ce00c094aae1808ceae8d8a9f7.jpg?v=1789915629",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bacopa",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 75,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 10,
        "sustainability": 50
      },
      "price": 16.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976085557445",
      "vsf_explanation": "Bacopa monnieri is one of the better-researched nootropic herbs, with multiple randomized trials supporting memory and cognitive benefits, and this 500mg serving at a 50%-bacoside standardization (28:1 extract) lands within the range used in that research. However, the title carries no identifiable brand at all — just the ingredient name — so despite the welcome 'third-party lab tested' claim, there's no accountable company Vyvata can verify that claim against.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "oregano-oil-7500mg-360gels-contains-carvacrol-mediterranean-and-wild-harvest",
      "title": "Oregano Oil 7500mg 360gels Contains Carvacrol mediterranean and wild Harvest",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_f86978f5-ded7-4211-8d7d-40cd59ddb43f.jpg?v=1789915628",
      "score": 29,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "oregano",
        "oil",
        "7500mg",
        "360gels",
        "contains",
        "carvacrol",
        "mediterranean",
        "and",
        "wild",
        "harvest",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 45,
        "manufacturing": 10,
        "safety": 35,
        "transparency": 5,
        "sustainability": 50
      },
      "price": 33.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976085524677",
      "vsf_explanation": "Oregano oil and its carvacrol content have mostly in-vitro and animal antimicrobial data, with limited controlled human trials to support the immune claims made here. No brand name appears anywhere in the listing, no GMP or facility information is disclosed, and the label omits any caution about GI irritation at high doses (7,500mg herbal equivalent is a substantial dose), which is a meaningful safety gap.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "ancient-bliss-quercetin-with-bromelain-1200mg-120-caps-organic-vegan",
      "title": "Ancient Bliss Quercetin with Bromelain 1200mg 120 Caps Organic/Vegan",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7ea97ce4baf0bd84d4c0f1ed2dae0571ff23a3054e3a13c73fa9dfb153207e40.webp?v=1789915628",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ancient",
        "bliss",
        "quercetin",
        "with",
        "bromelain",
        "1200mg",
        "120",
        "caps",
        "organic",
        "vegan",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 10,
        "safety": 45,
        "transparency": 35,
        "sustainability": 50
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976085491909",
      "vsf_explanation": "Quercetin and bromelain both have moderate clinical evidence individually for antioxidant and anti-inflammatory support, and this combination (1,000mg quercetin / 200mg bromelain) uses doses within commonly studied ranges. The product listing is very thin on detail beyond the dose, with no GMP or facility disclosure and no mention of bromelain's known blood-thinning interaction caution, which limits both manufacturing and safety scores.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamatic-benfotiamine-300mg-90-vegetarian-capsules",
      "title": "Vitamatic Benfotiamine 300mg | 90 Vegetarian Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/82feee6475df4041d8f19a269ad4dfdf5563f3890ca563825e924cfdfc4b72c9.png?v=1789915631",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamatic",
        "benfotiamine",
        "300mg",
        "vegetarian",
        "capsules",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 75,
        "manufacturing": 45,
        "safety": 72,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 14.77,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976085688517",
      "vsf_explanation": "Benfotiamine, the fat-soluble form of vitamin B1, has multiple randomized trials supporting its role in reducing markers of oxidative stress and supporting nerve health in metabolic contexts, and the 300mg dose falls squarely within the 300-900mg range used in that research. It's well tolerated with no significant documented safety concerns, though manufacturing disclosure is limited to general GMP claims.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamatic-dim-diindolylmethane-with-bioperine-300mg",
      "title": "Vitamatic DIM (Diindolylmethane) with BioPerine 300mg",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2038884f62b9d62a7ab065fa160239992fb9e6d8315ed357040ab981afcbb4ed.png?v=1789915631",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamatic",
        "dim",
        "diindolylmethane",
        "with",
        "bioperine",
        "300mg",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "hormonal_endocrine"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 68,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 17.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976085754053",
      "vsf_explanation": "DIM has some evidence for shifting estrogen metabolite ratios, but the listing markets it directly against PCOS — a diagnosed medical condition — without citing any clinical evidence that DIM treats or relieves it, which is the kind of unverified disease claim Vyvata's rubric flags. The BioPerine addition for absorption is a reasonable formulation choice, but the unsubstantiated PCOS claim also pulls down transparency, and hormone-modulating supplements like this typically carry medication-interaction cautions that aren't disclosed here.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "vitamatic-magnesium-citrate-500mg-180-vegetarian-capsules",
      "title": "Vitamatic Magnesium Citrate 500mg | 180 Vegetarian Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/081ecb7d3344cf9563bd161766b9f711ac2ada04c0a7c7207f0b87ab6a72f890.png?v=1789915632",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamatic",
        "magnesium",
        "citrate",
        "500mg",
        "180",
        "vegetarian",
        "capsules",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 72,
        "manufacturing": 45,
        "safety": 75,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 11.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976085819589",
      "vsf_explanation": "Magnesium citrate is one of the most well-researched, highly bioavailable magnesium forms, with strong evidence for correcting deficiency and supporting muscle, nerve, and cardiovascular function. The 150mg elemental magnesium per serving is a sensible supplemental contribution toward the ~310-420mg RDA, and magnesium citrate has a well-established, generally mild safety profile (occasional GI loosening at higher doses).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamatic-bromelain-500-mg-2400-gdu-gram-180-capsules",
      "title": "Vitamatic Bromelain 500 mg (2400 GDU/gram) 180 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6788feccfd65a526666b88aeac6e01712bc2f0dd8953b49890756bbd0d697894.png?v=1789915632",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamatic",
        "bromelain",
        "500",
        "2400",
        "gdu",
        "gram",
        "180",
        "capsules",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 72,
        "manufacturing": 45,
        "safety": 62,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 16.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976085786821",
      "vsf_explanation": "Bromelain has moderate clinical support for digestive and anti-inflammatory use, and this listing discloses both the dose (500mg) and potency (2,400 GDU/gram), which is more specific than most competing listings. It's generally well tolerated, though the label doesn't flag the known cross-reactivity risk for people with pineapple or latex allergies.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamatic-mullein-leaf-extract-1000mg-200-capsules",
      "title": "Vitamatic Mullein Leaf Extract 1000mg | 200 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7a2a669d6deb773425f4cfbaad83c4ae2b09f24de83b0cb15d75799e65a90ce0.png?v=1789915632",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamatic",
        "mullein",
        "leaf",
        "extract",
        "1000mg",
        "200",
        "capsules",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 60,
        "manufacturing": 45,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 17.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976085852357",
      "vsf_explanation": "Mullein leaf has a long history of traditional use for respiratory support, but published human clinical trial evidence is minimal — most data is traditional-use or preliminary in-vitro work. The 1000mg dose and single-ingredient formulation are straightforward, and mullein carries a generally clean safety profile with no major documented interactions.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamatic-vitamin-b6-pyridoxine-hci-500-mg-120-tablets",
      "title": "Vitamatic Vitamin B6 (Pyridoxine HCI) 500 mg | 120 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f6cf8f04acfdd875a9c33b1d9f389a6651ce4c1805263ff24811a0c2aab96f52.png?v=1789915634",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamatic",
        "vitamin",
        "pyridoxine",
        "hci",
        "500",
        "120",
        "tablets",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 30,
        "manufacturing": 45,
        "safety": 8,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 14.66,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976085917893",
      "vsf_explanation": "Vitamin B6 is essential for energy metabolism and nervous system function at physiologic doses, but unlike water-soluble B1, pyridoxine has well-documented dose-dependent toxicity: the NIH tolerable upper intake level is 100mg/day, and this product delivers 500mg daily — five times that limit — with no warning about the peripheral sensory neuropathy risk that has been repeatedly documented in the medical literature at chronic high-dose B6 intake. Marketing this as a daily-use capsule with no upper-limit caution is a genuine safety concern that overrides any credit the ingredient's baseline evidence would otherwise earn.",
      "vsf_autofail_rule": "safety_concern"
    },
    {
      "handle": "vitamatic-beta-sitosterol-400mg-180-capsules-non-gmo-gluten-free-made-in-usa",
      "title": "Vitamatic Beta Sitosterol 400mg 180 Capsules Non-GMO Gluten Free Made in USA",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c76e0d91f5bbdb54edd813d9f9921ab1c318e332c9ba07bd3da443d6584bca4f.png?v=1789915634",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamatic",
        "beta",
        "sitosterol",
        "400mg",
        "180",
        "capsules",
        "non",
        "gmo",
        "gluten",
        "free",
        "made",
        "usa",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 78,
        "manufacturing": 45,
        "safety": 68,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 18.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976085885125",
      "vsf_explanation": "Beta-sitosterol is one of the better-studied phytosterols for BPH symptom relief and LDL cholesterol support, with multiple human trials at doses in the 60-400mg/day range, so the 400mg single-ingredient dose here sits comfortably within studied territory. Vitamatic discloses GMP and Made-in-USA manufacturing but not a specific facility registration or third-party COA, and the label carries an appropriate pregnancy/medication warning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamatic-biotin-20-000mcg-with-keratin-120-veg-tablets",
      "title": "Vitamatic Biotin 20,000mcg with Keratin | 120 Veg Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/43d0d7ba1523532e2f6f026509aa0180e23f67e35009ff730d7c3450e6b68b12.png?v=1789915633",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamatic",
        "biotin",
        "000mcg",
        "with",
        "keratin",
        "120",
        "veg",
        "tablets",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 14.77,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976085950661",
      "vsf_explanation": "Clinical evidence that biotin improves hair, skin, or nails in people without a true deficiency is weak, and orally ingested keratin has no established route to being absorbed intact, so the pairing is more marketing than mechanism. At 20,000mcg (over 600x the RDI) the product also omits the well-documented warning that high-dose biotin can skew common lab tests (thyroid panels, troponin), which is a meaningful safety-disclosure gap.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamatic-methyl-folate-15mg-120-vegetable-capsules",
      "title": "Vitamatic Methyl Folate 15mg | 120 Vegetable Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4036a5c8f4b50bfc03ab936c0e62c712891bcef88e3388a5790780fe908898ec.png?v=1789915634",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamatic",
        "methyl",
        "folate",
        "15mg",
        "120",
        "vegetable",
        "capsules",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 70,
        "manufacturing": 45,
        "safety": 40,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976085983429",
      "vsf_explanation": "L-methylfolate has decent clinical backing for homocysteine management and as an adjunct in MTHFR-related folate metabolism, and the 15mg dose actually matches the clinical-strength range used in published trials (7.5-15mg), so it isn't sub-therapeutic. The safety score is docked because a folate dose this high — sold without a prescription or B12 co-formulation — carries the well-known risk of masking vitamin B12 deficiency symptoms, and the listing does not disclose that warning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamatic-vitamin-b1-thiamine-500mg-120-capsules",
      "title": "Vitamatic Vitamin B1 (Thiamine) 500mg | 120 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/90c74cd6f76f6f3c86893a94d6e421c937fb12ff68b432c0038fea616f349488.png?v=1789915637",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamatic",
        "vitamin",
        "thiamine",
        "500mg",
        "120",
        "capsules",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 75,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 15.1,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976086016197",
      "vsf_explanation": "Thiamine (B1) has well-established evidence for energy metabolism and nervous system function at physiologic doses, and because it's water-soluble it carries essentially no toxicity risk even at high intakes, which keeps the safety score strong. The 500mg dose is roughly 400x the RDA with no stated rationale (such as a specific deficiency or clinical indication) for why a megadose is needed, which is a formulation weakness even though it isn't a safety hazard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hyaluronic-acid-275mg-95-pure-180-veggie-capsules",
      "title": "Hyaluronic Acid – 275mg 95%+ Pure – 180 Veggie Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/94d82c3d743159001e14c5db3082771dae510782f0efa49c6bdb546f7f0eded5.jpg?v=1789915637",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hyaluronic",
        "acid",
        "275mg",
        "pure",
        "180",
        "veggie",
        "capsules",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 65,
        "manufacturing": 68,
        "safety": 65,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 19.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976086048965",
      "vsf_explanation": "This listing stands out for process transparency: it states a specific 95%+ purity standard, a non-GMO fermentation production method, and — unusually for this catalog — claims both in-house and independent third-party laboratory batch testing for purity and contaminants. Oral hyaluronic acid's own clinical evidence base is still limited, and no brand name is disclosed, but the unusually detailed manufacturing and testing claims are enough to lift this into Standard tier despite the missing brand identity.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "resveratrol-98-resveratrol-and-quercetin-combination-with-mct-oil",
      "title": "RESVERATROL+ 98%  Resveratrol and Quercetin Combination with MCT Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9b7b11d038128e1cfddc2cd013c32c98146689c803d04f59fe416ebf2577f7d5.jpg?v=1789915637",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "resveratrol",
        "resveratrol",
        "and",
        "quercetin",
        "combination",
        "with",
        "mct",
        "oil",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 45,
        "manufacturing": 40,
        "safety": 62,
        "transparency": 35,
        "sustainability": 50
      },
      "price": 33.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976086081733",
      "vsf_explanation": "Toniiq is transparent that the resveratrol-plus-quercetin longevity thesis is still largely supported by animal studies rather than robust human trials, which is honest but does mean the evidence score stays modest. The listing states a 98% resveratrol purity standard and manufacturing in a GMP-certified, NSF-approved US facility, but never discloses the actual milligram dose of resveratrol or quercetin per serving, which is a meaningful formulation and transparency gap.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ancient-bliss-turmeric-curcumin-1500mg-120-caps-ginger-black-pepper",
      "title": "Ancient Bliss Turmeric Curcumin 1500mg 120 Caps Ginger Black Pepper",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9780a78bb3495f75ee5583291ad76549717d0fdfe8288e48e693dd562b61f3a7.webp?v=1789915637",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ancient",
        "bliss",
        "turmeric",
        "curcumin",
        "1500mg",
        "120",
        "caps",
        "ginger",
        "black",
        "pepper",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 10,
        "safety": 55,
        "transparency": 35,
        "sustainability": 50
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976086114501",
      "vsf_explanation": "Turmeric curcumin with ginger and black pepper is a reasonable formulation approach for inflammation support, but the marketing copy goes well beyond what the evidence supports by referencing 'reducing chronic disease risk, including certain cancers' and 'potential anti-cancer' effects — an unverified disease claim that dietary supplements are not permitted to make. Combined with no disclosed manufacturing certification, this claim is a serious integrity issue that overrides the otherwise reasonable ingredient formulation.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "rosehip-health-5000mg-120-vegetarian-vegan-tablets-high",
      "title": "Rosehip Health+ 5000mg 120 Vegetarian & Vegan Tablets | High",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/db91a305de6e8a4b4cc7e68cf03f6fe6f40aa03c5f3334bd0c7a6b37392a2be7.jpg?v=1789915638",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "rosehip",
        "health",
        "5000mg",
        "120",
        "vegetarian",
        "vegan",
        "tablets",
        "high",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 45,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 30,
        "sustainability": 50
      },
      "price": 15.13,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976086180037",
      "vsf_explanation": "Rosa canina rosehip does have some genuine clinical support (notably Scandinavian trials) for joint comfort in osteoarthritis, but this listing makes unsubstantiated comparative medical claims — describing rosehip as 'better than painkillers for arthritis' and 'three times more effective than paracetamol for pain relief' without citing the source study or matching dose. Presenting a supplement as outperforming a specific over-the-counter drug without verifiable citation is an unverified medical claim that significantly undermines the listing's credibility regardless of the underlying ingredient's real evidence base.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "vitamatic-pumpkin-seed-oil-2000mg-180-softgels-cold-pressed-non-gmo-gluten-free",
      "title": "Vitamatic Pumpkin Seed Oil 2000mg 180 Softgels Cold Pressed Non-GMO Gluten Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/03ddf309bd4511aac7ed35bd3f84ac9383ac30e5bff656f13a779b798f565058.png?v=1789915638",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamatic",
        "pumpkin",
        "seed",
        "oil",
        "2000mg",
        "180",
        "softgels",
        "cold",
        "pressed",
        "non",
        "gmo",
        "gluten",
        "free",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 65,
        "manufacturing": 45,
        "safety": 64,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 16.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976086212805",
      "vsf_explanation": "Pumpkin seed oil has modest but real evidence for prostate and urinary comfort, and this listing clearly discloses a single 2,000mg cold-pressed dose per softgel with appropriate structure/function framing rather than overreaching medical claims. Vitamatic's generic self-declared GMP claim keeps manufacturing at only partial credit, and the product lands just short of Standard tier on the strength of its evidence and formulation alone.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sea-moss-capsules-with-raw-bladderwrack-150-capsules",
      "title": "Sea Moss Capsules with Raw Bladderwrack (150 Capsules)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/24604ae9852eea376e806f91a6944d6cbd1c198a3e0930ab33332dcd342f1dab.png?v=1789915639",
      "score": 23,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sea",
        "moss",
        "capsules",
        "with",
        "raw",
        "bladderwrack",
        "150",
        "capsules",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 25,
        "manufacturing": 12,
        "safety": 20,
        "transparency": 18,
        "sustainability": 50
      },
      "price": 18.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976086311109",
      "vsf_explanation": "Sea moss, bladderwrack, and burdock root have very limited human clinical evidence behind the general wellness claims made here, and the '12,000mg equivalent' style dosing for two of the three ingredients obscures the actual extract weight delivered. Most importantly, bladderwrack is a kelp-family seaweed with naturally variable and sometimes high iodine content, and this listing discloses no iodine amount and no caution for people with thyroid conditions — a genuine safety-transparency gap for an ingredient combination that can affect thyroid function.",
      "vsf_autofail_rule": "safety_concern"
    },
    {
      "handle": "bio-cultures-complex-probiotics-and-prebiotics",
      "title": "Bio Cultures Complex Probiotics and Prebiotics",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9a4d9180eddc5cd9df015c1988052537719780d57bf38d13ddb20f8bb7c7fdaa.jpg?v=1789915641",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bio",
        "cultures",
        "complex",
        "probiotics",
        "and",
        "prebiotics",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 30,
        "manufacturing": 12,
        "safety": 60,
        "transparency": 20,
        "sustainability": 50
      },
      "price": 15.01,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976086376645",
      "vsf_explanation": "The named strains (L. acidophilus, L. gasseri, L. plantarum, L. rhamnosus, L. reuteri, B. longum) are genuinely well-studied probiotic species, which supports a reasonable evidence score. But the listing itself contradicts its own core potency claim — the headline promises '77 Billion CFU' while the body copy states '50 billion CFU' — an internal label inconsistency on the single most important number for a probiotic, and no brand name is disclosed to hold accountable for the discrepancy.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "ancient-bliss-magnesium-glycinate-500mg-60-caps-with-black-pepper",
      "title": "Ancient Bliss Magnesium Glycinate 500mg 60 Caps with Black Pepper",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9fb5e923ea479cf5f4a18516685986ac2fbc258b707f04d0294baec9f7a69b23.webp?v=1789915641",
      "score": 51,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ancient",
        "bliss",
        "magnesium",
        "glycinate",
        "500mg",
        "caps",
        "with",
        "black",
        "pepper",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 70,
        "manufacturing": 10,
        "safety": 66,
        "transparency": 35,
        "sustainability": 50
      },
      "price": 21.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976086409413",
      "vsf_explanation": "Magnesium glycinate has strong evidence for supporting relaxation, sleep, and healthy muscle and mood function, and 500mg with black pepper for absorption is a sound formulation choice. Ancient Bliss discloses no supplement facts panel detail, no manufacturing facility information, and no GMP or FDA registration anywhere in the marketing copy, which under a zero-assumption standard pulls the overall score well below what the ingredient formulation alone would earn.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "prowise-vegan-omega-3-dha-from-algae-oil-60-softgels-with",
      "title": "Prowise Vegan Omega-3 DHA from Algae Oil | 60 Softgels with",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e14510b51dfd624b125c61cb4da16952f45a6e63c9622a2bf0e321ee93667ac4.jpg?v=1789915642",
      "score": 49,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "prowise",
        "vegan",
        "omega",
        "dha",
        "from",
        "algae",
        "oil",
        "softgels",
        "with",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 35,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 30,
        "sustainability": 50
      },
      "price": 14.66,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976086442181",
      "vsf_explanation": "Algae-derived DHA is a well-evidenced, sustainable vegan alternative to fish oil, and pairing it with vitamin E for absorption is a reasonable formulation choice — the algae sourcing claim is a genuine, specific sustainability disclosure rather than a vague one. However, the listing never states the actual milligram amount of DHA per softgel, which is a significant transparency and formulation gap since the effective dose cannot be verified, and no manufacturing certification is disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamatic-hyaluronic-acid-200mg-120-capsules",
      "title": "Vitamatic Hyaluronic Acid 200mg | 120 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71227406f47fb029057d2124223cebdf7951def8ef69c29f4459f68b2392721c.png?v=1789915644",
      "score": 49,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamatic",
        "hyaluronic",
        "acid",
        "200mg",
        "120",
        "capsules",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 68,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 17.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976086474949",
      "vsf_explanation": "Oral hyaluronic acid has only a limited body of clinical evidence for skin hydration and joint comfort, weaker than most other ingredient categories in this batch, though the 200mg dose is clearly disclosed and within ranges used in some published studies. Vitamatic's generic 'strict GMP Standards' claim earns modest partial manufacturing credit but is not independently verifiable, keeping the overall score in Rejected territory largely due to thin evidence for the ingredient itself.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-arginine-l-citrulline-3000mg-supplement-240-capsules",
      "title": "L Arginine L Citrulline 3000mg Supplement (240 Capsules)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/813a260f7baaf28b4fdeca208a14c035c60aac6d999d3d37bb1a5701897570f2.jpg?v=1789915646",
      "score": 33,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "arginine",
        "citrulline",
        "3000mg",
        "supplement",
        "240",
        "capsules",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 18,
        "manufacturing": 12,
        "safety": 58,
        "transparency": 22,
        "sustainability": 50
      },
      "price": 23.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976086507717",
      "vsf_explanation": "L-citrulline in particular has decent evidence for supporting nitric oxide production and exercise blood flow, but this listing discloses only a combined '3000mg' total for both L-arginine and L-citrulline with no individual milligram breakdown — a proprietary-blend problem, since the two amino acids have very different effective dose ranges and oral bioavailabilities. No brand name is disclosed anywhere on the listing, compounding the transparency gap.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "vitamatic-valerian-root-5000-mg-240-vegetable-capsules",
      "title": "Vitamatic Valerian Root 5000 mg | 240 vegetable capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/c7e72198f96beee50a7b1fda91826232e0a63912e4243ec613ad34751c5f4b29.png?v=1789915648",
      "score": 47,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamatic",
        "valerian",
        "root",
        "5000",
        "240",
        "vegetable",
        "capsules",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 42,
        "manufacturing": 45,
        "safety": 58,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 16.18,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976087523525",
      "vsf_explanation": "Valerian root has modest, mixed clinical evidence for sleep and relaxation support, weaker than better-studied options like magnesium or L-theanine. The label markets '5000mg' but qualifies it as a '20X Concentrated Extract,' meaning the actual capsule content is almost certainly a small fraction of that headline figure — a common but confusing labeling practice this listing never clarifies with an actual per-capsule extract weight, which drags down both formulation and transparency scores.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamatic-magnesium-bisglycinate-500mg-120-veg-capsules",
      "title": "Vitamatic Magnesium Bisglycinate 500mg 120 Veg Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/dd551722a9c602d8554bcbe341ae71a8da98b719cb85709114d0e3708efcf883.png?v=1789915656",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamatic",
        "magnesium",
        "bisglycinate",
        "500mg",
        "120",
        "veg",
        "capsules",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 75,
        "manufacturing": 45,
        "safety": 68,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 14.66,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976087720133",
      "vsf_explanation": "Magnesium bisglycinate is one of the best-evidenced, most bioavailable chelated forms of magnesium, and the added black pepper extract is a reasonable absorption aid; the 500mg dose and clean allergen-free formulation are clearly disclosed. Vitamatic states it manufactures in a 'GMP Compliant, FDA Registered Facility,' which earns partial manufacturing credit as a self-declared claim, but the absence of a verifiable registration number or third-party COA keeps this in Standard rather than Verified territory.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lions-mane-10-1",
      "title": "Lion's Mane 10:1",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/d3fc3a2313d16652a7e10329964c93f80681219bf5eb97e5480688e19bfef53f.jpg?v=1789915685",
      "score": 52,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lion",
        "mane",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 68,
        "manufacturing": 40,
        "safety": 65,
        "transparency": 35,
        "sustainability": 50
      },
      "price": 23.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976088703173",
      "vsf_explanation": "Toniiq is identified as the brand, but as with its resveratrol listing, this page offers only generic quality marketing language without naming a GMP certification or third-party testing partner, which limits manufacturing and transparency. Lion's Mane has a real, growing evidence base for cognitive support from several small human trials, and the 1,800mg dose with 540mg of disclosed polysaccharide content is reasonably well standardized and within studied ranges. The ingredient itself carries low safety risk, but the brand's overall documentation gap keeps this below Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-arginine-1000mg-l-citrulline-2000mg-240-caps-nitric-oxide-muscle-support-non-gmo-gluten-free",
      "title": "L-Arginine 1000mg + L-Citrulline 2000mg – 240 Caps | Nitric Oxide & Muscle Support | Non-GMO, Gluten-Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_8f62d7d3-4948-4509-820d-01a8714aa311.webp?v=1789915685",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "arginine",
        "1000mg",
        "citrulline",
        "2000mg",
        "240",
        "caps",
        "nitric",
        "oxide",
        "muscle",
        "support",
        "non",
        "gmo",
        "gluten",
        "free",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 65,
        "safety": 55,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 22.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976088735941",
      "vsf_explanation": "Dorado Nutrition discloses a US-based, GMP-certified, third-party-tested manufacturing process, which supports a reasonable manufacturing and transparency score. L-citrulline has decent evidence for nitric oxide and blood-flow support, though most performance-focused trials use citrulline in the 6–8g range — this product's 2,000mg citrulline dose (plus 1,000mg arginine, which has limited oral bioavailability) is on the lower end of what's typically studied for a standalone effect. No contraindication guidance is provided for arginine's caution with herpes simplex virus or vasodilator medications.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "harmonify-magnesium-l-threonate-120-purified-veggie-capsule-1000-mg-gluten-free-non-gmo",
      "title": "HARMONIFY Magnesium L Threonate 120 Purified Veggie Capsule, 1000 mg, Gluten Free, Non-GMO",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/harmonifymagn.jpg?v=1789915685",
      "score": 49,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "harmonify",
        "magnesium",
        "threonate",
        "120",
        "purified",
        "veggie",
        "capsule",
        "1000",
        "gluten",
        "free",
        "non",
        "gmo",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 35,
        "manufacturing": 65,
        "safety": 75,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 23.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976088768709",
      "vsf_explanation": "HARMONIFY discloses GMP-certified manufacturing and third-party test reports, giving a moderate manufacturing score, but the listing doesn't confirm this is the patented Magtein® form of magnesium L-threonate used in the cognitive/sleep research on this ingredient, and generic versions aren't guaranteed to replicate the studied particle characteristics. The listing also states '1000mg' without clarifying whether that's the compound or elemental magnesium — magnesium L-threonate is only about 8% elemental magnesium by weight, so the actual elemental dose delivered is far below what the headline number suggests. Magnesium itself is very safe, but the dose-labeling ambiguity and unclear evidence-to-product match keep this below Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "alpha-lipoic-acid-ala-600mg-240-veggie-caps-vitamatic-antioxidant-brain-support",
      "title": "Alpha Lipoic Acid (ALA) 600mg – 240 Veggie Caps | Vitamatic Antioxidant & Brain Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/vitamaticala.jpg?v=1789915685",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alpha",
        "lipoic",
        "acid",
        "ala",
        "600mg",
        "240",
        "veggie",
        "caps",
        "vitamatic",
        "antioxidant",
        "brain",
        "support",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 78,
        "manufacturing": 45,
        "safety": 82,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 18.77,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976088801477",
      "vsf_explanation": "Vitamatic's ALA delivers a clearly disclosed 600mg per serving of a single, well-characterized antioxidant with a clean excipient list and a printed medication-interaction warning for diabetes drugs. Alpha lipoic acid has solid peer-reviewed evidence for antioxidant and blood-sugar-metabolism support, though the brain-health claims on the label lean more optimistic than the literature strictly supports. Manufacturing claims (US-made, GMP) are brand-stated rather than third-party verified, which caps the overall Integrity Score in the Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "osha-root-1500mg-150-caps-with-bioperine-2-5mg-respiratory-immune-support",
      "title": "Osha Root 1500mg 150 Caps with BioPerine 2.5mg | Respiratory & Immune Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_8e966f1d-5e0c-4617-9851-8f700e39e4f8.webp?v=1789915685",
      "score": 28,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "osha",
        "root",
        "1500mg",
        "150",
        "caps",
        "with",
        "bioperine",
        "5mg",
        "respiratory",
        "immune",
        "support",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 25,
        "manufacturing": 15,
        "safety": 55,
        "transparency": 15,
        "sustainability": 50
      },
      "price": 17.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976088899781",
      "vsf_explanation": "This listing's title claims '1500mg' of Osha Root, but the printed Supplement Facts panel in the product description lists only 900mg per serving — a nearly 70% overstatement that triggers a misleading-naming flag. No manufacturer or brand name appears anywhere on the listing, so none of the sourcing, sustainability, or manufacturing claims can be verified. Osha root itself also lacks rigorous clinical trial evidence beyond traditional use, and wild-harvested Osha carries a known risk of misidentification with toxic look-alike plants that this listing does not address.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "ultra-concentrated-milk-thistle-25-000mg-90-caps-80-silymarin",
      "title": "Ultra Concentrated Milk Thistle 25,000mg 90 Caps 80% Silymarin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_111b4501-fdb8-4812-8849-23134eab2513.webp?v=1789915685",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ultra",
        "concentrated",
        "milk",
        "thistle",
        "000mg",
        "caps",
        "silymarin",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 75,
        "manufacturing": 40,
        "safety": 78,
        "transparency": 35,
        "sustainability": 50
      },
      "price": 24.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976088867013",
      "vsf_explanation": "Toniiq discloses both the actual capsule weight (500mg) and the extraction ratio (50:1) behind its 25,000mg-equivalent claim, plus a silymarin content figure (>400mg) that lets buyers cross-check potency — a level of dosing transparency most competitors in this batch don't provide. Silymarin has a substantial, though mixed, body of clinical research supporting liver-protective and antioxidant effects. The brand's stated GMP-certified, NSF-approved US manufacturing facility is a meaningful (if still brand-reported) quality signal that pushes this product into Vyvata Verified territory.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "neuro-magnesium-l-threonate-120-veggie-caps-2000-mg-gluten-free-non-gmo",
      "title": "Neuro Magnesium L Threonate 120 Veggie Caps 2000 mg, Gluten Free, Non-GMO",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6a1c2187f5022164c54b91022986a8a40342a0e00e229644725887503a54572a.png?v=1789915685",
      "score": 47,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "neuro",
        "magnesium",
        "threonate",
        "120",
        "veggie",
        "caps",
        "2000",
        "gluten",
        "free",
        "non",
        "gmo",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 55,
        "manufacturing": 20,
        "safety": 65,
        "transparency": 20,
        "sustainability": 50
      },
      "price": 23.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976088965317",
      "vsf_explanation": "This listing references the trademarked ingredient names 'Neuro-Mag' and 'Magtein' but names no actual manufacturer or brand anywhere in the title or body copy, so Vyvata cannot verify who makes this product or whether it is a licensed, quality-controlled source of the branded magnesium L-threonate compound. Magnesium L-threonate itself has genuine peer-reviewed research behind its cognitive and memory claims at doses in this range, which keeps the underlying evidence score respectable. Without verifiable brand provenance, however, none of the manufacturing or quality claims can be trusted, which is enough on its own to fail Vyvata's provenance check.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "pure-shilajit-10-000mg-150-caps-himalayan-asphaltum-naturally-occurring-fulvic-acid-non-gmo",
      "title": "Pure Shilajit 10,000mg – 150 Caps | Himalayan Asphaltum | Naturally Occurring Fulvic Acid | Non-GMO",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_097ccad5-1b8d-465f-9fbc-632db735c4dc.webp?v=1789915685",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "shilajit",
        "000mg",
        "150",
        "caps",
        "himalayan",
        "asphaltum",
        "naturally",
        "occurring",
        "fulvic",
        "acid",
        "non",
        "gmo",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 45,
        "manufacturing": 18,
        "safety": 40,
        "transparency": 20,
        "sustainability": 50
      },
      "price": 18.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976089030853",
      "vsf_explanation": "No brand or manufacturer is named anywhere on this shilajit listing, which is a significant concern for a raw mineral resin product with a well-documented risk of heavy metal and polycyclic aromatic hydrocarbon contamination if not properly purified and tested. Shilajit has a growing but still limited clinical evidence base for energy and testosterone support, and this listing provides no purity or heavy-metal testing data to offset that risk. The combination of unverifiable sourcing and an untested contamination-prone raw material is enough to keep this in Vyvata's Rejected tier.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "grape-seed-extract-24-000mg-180-caps-non-gmo-vegetarian-gluten-free-polyphenols",
      "title": "Grape Seed Extract 24,000mg 180 Caps Non GMO Vegetarian Gluten Free Polyphenols",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_1_4cecea0c-4872-441c-9748-37eedf77075b.webp?v=1789915685",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "grape",
        "seed",
        "extract",
        "000mg",
        "180",
        "caps",
        "non",
        "gmo",
        "vegetarian",
        "gluten",
        "free",
        "polyphenols",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 50,
        "manufacturing": 18,
        "safety": 68,
        "transparency": 22,
        "sustainability": 52
      },
      "price": 18.71,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976088998085",
      "vsf_explanation": "Grape seed extract's oligomeric proanthocyanidins (OPCs) are a reasonably well-studied class of antioxidants with supportive cardiovascular and skin-health research, and this listing does include a helpful blood-thinner interaction warning. However, no brand or manufacturer is identified anywhere on the listing, so sourcing, extraction method, and manufacturing quality are entirely unverifiable, and the '24,000mg' figure is given without any stated extraction ratio to clarify actual capsule content. That lack of provenance is the primary reason this product lands in Vyvata's Rejected tier despite a decent underlying ingredient evidence base.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "triple-strength-cranberry-30-000mg-vitamin-c-240mg-50-1-extract-urinary-tract-immune-support",
      "title": "Triple Strength Cranberry 30,000mg + Vitamin C 240mg | 50:1 Extract | Urinary Tract & Immune Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4a402d6e2149e0a720da3db4cf27ec08cc380af544059dfefa2c0d8c1000fa75.jpg?v=1789915685",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "triple",
        "strength",
        "cranberry",
        "000mg",
        "vitamin",
        "240mg",
        "extract",
        "urinary",
        "tract",
        "immune",
        "support",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 68,
        "manufacturing": 55,
        "safety": 75,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 15.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976088932549",
      "vsf_explanation": "Prowise discloses both the cranberry extract's 50:1 concentration ratio and a specific Vitamin C amount (240mg), giving buyers a reasonably transparent dosing picture. Cranberry has modest but real Cochrane-reviewed evidence for reducing UTI recurrence, and combining it with Vitamin C is a well-tolerated, low-risk pairing. The brand's manufacturing and certification claims remain self-reported rather than independently verified, which keeps the product in Vyvata's Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "citrus-bergamot-extract-15-000mg-200-caps-maximum-strength-vegan-non-gmo",
      "title": "Citrus Bergamot Extract 15,000mg – 200 Caps | Maximum Strength | Vegan, Non-GMO",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_779208eb-35a3-4efa-aaa9-fca53f4c6d75.webp?v=1789915685",
      "score": 47,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "citrus",
        "bergamot",
        "extract",
        "000mg",
        "200",
        "caps",
        "maximum",
        "strength",
        "vegan",
        "non",
        "gmo",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 65,
        "manufacturing": 18,
        "safety": 65,
        "transparency": 25,
        "sustainability": 50
      },
      "price": 22.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976088834245",
      "vsf_explanation": "Citrus bergamot has a growing body of human clinical research, mostly from Italian research groups, supporting its role in healthy cholesterol and lipid metabolism, and this listing does disclose both the extraction ratio (25:1) and the actual per-capsule extract weight (600mg), which is better dosing transparency than most products in this batch. However, no brand or manufacturer name appears anywhere on the listing, making it impossible to verify sourcing, testing, or manufacturing quality, and the co-formulated BioPerine's dose is left undisclosed. The absence of any verifiable brand identity is the deciding factor that places this product in Vyvata's Rejected tier.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "ultra-prostate-formula-saw-palmetto-24000mg-pumpkin-seed-oil-3000mg-pygeum-3000mg-60-caps",
      "title": "Ultra Prostate Formula | Saw Palmetto 24000mg + Pumpkin Seed Oil 3000mg + Pygeum 3000mg | 60 Caps",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_1_4a21dc4b-f768-44cd-98e0-b920169591d0.webp?v=1789915685",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "ultra",
        "prostate",
        "formula",
        "saw",
        "palmetto",
        "24000mg",
        "pumpkin",
        "seed",
        "oil",
        "3000mg",
        "pygeum",
        "3000mg",
        "caps",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 45,
        "manufacturing": 15,
        "safety": 55,
        "transparency": 18,
        "sustainability": 50
      },
      "price": 16.65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976089161925",
      "vsf_explanation": "This three-herb prostate blend (saw palmetto, pumpkin seed oil, pygeum) does disclose an individual milligram amount for each ingredient rather than hiding them in an undosed blend, which is a formulation positive. However, saw palmetto's clinical evidence for BPH symptoms is genuinely mixed — including large placebo-controlled trials showing no significant benefit — and none of the three ingredients here state an extraction ratio to clarify actual potency behind the large equivalence numbers. With no identifiable brand or manufacturer anywhere on the listing, none of the sourcing or quality claims can be verified, landing this product in Vyvata's Rejected tier.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "ginkgo-biloba-korean-ginseng-16000mg-180-vegan-tablets-brain-energy-support",
      "title": "Ginkgo Biloba & Korean Ginseng 16000mg 180 Vegan Tablets | Brain & Energy Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9fae4f11384c75a1c05e2702851748e10e51a19fb662575d3e2b21b28c650bf7.jpg?v=1789915685",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive",
        "energy",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ginkgo",
        "biloba",
        "korean",
        "ginseng",
        "16000mg",
        "180",
        "vegan",
        "tablets",
        "brain",
        "energy",
        "support",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 25,
        "manufacturing": 55,
        "safety": 50,
        "transparency": 30,
        "sustainability": 50
      },
      "price": 18.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976089063621",
      "vsf_explanation": "Ginkgo Biloba and Korean Ginseng are combined into a single 16,000mg 'blend' with no individual breakdown of how much of that total is ginkgo versus ginseng, which means buyers can't verify either ingredient meets a clinically meaningful dose — this triggers Vyvata's proprietary-blend auto-fail. Ginkgo's clinical evidence for cognitive protection is itself mixed (large trials like the GEM study found no significant dementia-prevention benefit), and the listing doesn't disclose ginkgo's known bleeding-risk interaction with blood thinners. Despite otherwise-reasonable manufacturing claims from the parent brand, the combination of hidden individual dosing and an unmentioned safety interaction is disqualifying.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "saw-palmetto-8000mg-120-capsules-high-potency-prostate-urinary-support-dht-balance-non-gmo",
      "title": "Saw Palmetto 8000mg 120 Capsules | High-Potency Prostate & Urinary Support | DHT Balance | Non-GMO",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_1_55983463-a67f-45cf-b493-3219aab08ef3.webp?v=1789915685",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "saw",
        "palmetto",
        "8000mg",
        "120",
        "capsules",
        "high",
        "potency",
        "prostate",
        "urinary",
        "support",
        "dht",
        "balance",
        "non",
        "gmo",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 48,
        "manufacturing": 18,
        "safety": 68,
        "transparency": 22,
        "sustainability": 50
      },
      "price": 18.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976089194693",
      "vsf_explanation": "Saw palmetto's evidence for prostate and urinary symptom support is mixed, with some positive studies alongside large placebo-controlled trials showing no significant benefit, so this ingredient earns a middling evidence score on its own merits. The listing states '8,000mg equivalent per serving' without disclosing the extraction ratio needed to know the actual extract weight, and no brand or manufacturer is named anywhere in the listing. Without verifiable sourcing or manufacturing information, this product cannot clear Vyvata's provenance bar despite saw palmetto's generally favorable safety profile.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "magnesium-glycinate-90-caps-magnesium-bisglycinate-life-extension",
      "title": "Magnesium Glycinate 90 Caps Magnesium Bisglycinate/ Life Extension",
      "vendor": "Life Extension",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_1_5e6ff8b2-16d9-4267-915e-439aa5810f86.webp?v=1789915685",
      "score": 78,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "glycinate",
        "caps",
        "magnesium",
        "bisglycinate",
        "life",
        "extension",
        "life",
        "extension"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 80,
        "manufacturing": 85,
        "safety": 85,
        "transparency": 72,
        "sustainability": 52
      },
      "price": 18,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976089129157",
      "vsf_explanation": "Life Extension is a well-established supplement brand known for citing primary research directly in its product literature (as this listing does with numbered references) and for maintaining in-house testing infrastructure. Magnesium glycinate has strong evidence for bioavailability and gastrointestinal tolerance compared to other magnesium forms, supporting the bone, muscle, nerve, and cardiovascular claims made here. The combination of a well-documented, single-ingredient formulation and a reputable, research-citing brand earns this product Vyvata Verified status.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "high-potency-serrapeptase-240-000-spu-120-veggie-caps-gluten-free-vegetarian",
      "title": "High Potency Serrapeptase 240,000 SPU 120 Veggie Caps Gluten Free Vegetarian",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_1_2ca0b872-6079-4949-ad63-eea981b7bfc4.webp?v=1789915685",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "high",
        "potency",
        "serrapeptase",
        "240",
        "000",
        "spu",
        "120",
        "veggie",
        "caps",
        "gluten",
        "free",
        "vegetarian",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 35,
        "manufacturing": 15,
        "safety": 45,
        "transparency": 18,
        "sustainability": 50
      },
      "price": 17.78,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976089096389",
      "vsf_explanation": "This serrapeptase product is dosed at 240,000 SPU per capsule, well above the range typically used in the (already limited) clinical literature on oral proteolytic enzymes, and no brand or manufacturer is identified to explain the sourcing or enteric-coating quality control that affects whether an oral enzyme survives digestion intact. The clinical evidence for oral serrapeptase's anti-inflammatory effects remains contested, partly due to questions about oral bioavailability. Combined with a blood-thinner interaction warning that appears but no verifiable manufacturer behind it, this product falls into Vyvata's Rejected tier.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "oregano-oil-9-000mg-black-seed-oil-300-softgels-carvacrol-immune-antimicrobial-support",
      "title": "Oregano Oil 9,000mg & Black Seed Oil – 300 Softgels | Carvacrol | Immune & Antimicrobial Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_1_32de0a11-ab11-4eb6-bf37-c1e9b1bbe222.webp?v=1789915685",
      "score": 29,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "oregano",
        "oil",
        "000mg",
        "black",
        "seed",
        "oil",
        "300",
        "softgels",
        "carvacrol",
        "immune",
        "antimicrobial",
        "support",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 22,
        "manufacturing": 15,
        "safety": 42,
        "transparency": 15,
        "sustainability": 50
      },
      "price": 20.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976089227461",
      "vsf_explanation": "While Oregano Oil's dose is disclosed at 9,000mg per serving, the Black Seed Oil in the same softgel is listed only as 'included per serving' with no milligram amount whatsoever — a fully undisclosed dose for a named active ingredient, which triggers Vyvata's proprietary-blend auto-fail. Both ingredients have some supporting research (carvacrol's in-vitro antimicrobial activity, black seed oil's metabolic and anti-inflammatory studies), but neither the doses nor a manufacturer are verifiable here. No safety warnings are provided despite oregano oil's potential for GI irritation at high doses and black seed oil's known interactions with blood pressure and diabetes medications.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "activated-charcoal-capsules-1200mg-200-high-strength-vegan-capsules-coconut-shell",
      "title": "Activated Charcoal Capsules 1200mg 200 High Strength Vegan Capsules Coconut Shell",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/701b69b03cb8e2d8b1e4cc613fc5d3ba17b58bb4584c9e0b0b5043ea7df0f355_a1ce917a-d118-419c-8973-b6a74680e7a4.jpg?v=1789915685",
      "score": 51,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "activated",
        "charcoal",
        "capsules",
        "1200mg",
        "200",
        "high",
        "strength",
        "vegan",
        "capsules",
        "coconut",
        "shell",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 58,
        "transparency": 30,
        "sustainability": 50
      },
      "price": 16.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976089292997",
      "vsf_explanation": "Activated charcoal has a well-established, narrow medical use for acute poisoning and toxin adsorption, but this listing extends that into broader 'detox' and digestive-wellness marketing claims that aren't supported by the same level of clinical evidence — a common overreach in this product category. On the positive side, the listing includes a genuinely useful safety instruction (avoid taking within two hours of medications, since charcoal can bind and block absorption of drugs), and the coconut-shell sourcing and dose are clearly disclosed. The gap between the narrow evidence base and the broad wellness framing keeps this product just below Vyvata's Standard threshold.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pomegranate-complete-12-000mg-180-caps-punicic-acid-punicalagins-whole-plant-formula",
      "title": "Pomegranate Complete 12,000mg – 180 Caps | Punicic Acid & Punicalagins Whole-Plant Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_1_639e795c-24bc-48f3-a5e4-6a6a1852c916.webp?v=1789915685",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pomegranate",
        "complete",
        "000mg",
        "180",
        "caps",
        "punicic",
        "acid",
        "punicalagins",
        "whole",
        "plant",
        "formula",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 35,
        "manufacturing": 18,
        "safety": 68,
        "transparency": 25,
        "sustainability": 52
      },
      "price": 18.88,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976089260229",
      "vsf_explanation": "Pomegranate's punicalagins and punicic acid have reasonably good antioxidant and cardiovascular-endothelial research behind them, but this listing combines pomegranate flower, seed oil, and fruit into one undifferentiated 12,000mg 'whole-plant blend' without disclosing how much of the total comes from each plant part — a formulation transparency gap, since these sub-fractions have different active compound profiles. No brand or manufacturer name appears anywhere on the listing, which prevents verification of sourcing or quality control. Pomegranate itself carries a favorable safety profile with no major contraindications, but the combination of an undifferentiated blend and unverifiable provenance places this in Vyvata's Rejected tier.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "ginkgo-biloba-9000mg-200-capsules-no-preservatives-gluten-free-memory-focus-circulation-support",
      "title": "Ginkgo Biloba 9000mg 200 Capsules | No Preservatives Gluten Free | Memory Focus & Circulation Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_1_55819125-fbf4-4e4b-a13c-a3b8fbf97742.webp?v=1789915685",
      "score": 37,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ginkgo",
        "biloba",
        "9000mg",
        "200",
        "capsules",
        "preservatives",
        "gluten",
        "free",
        "memory",
        "focus",
        "circulation",
        "support",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 45,
        "manufacturing": 18,
        "safety": 48,
        "transparency": 22,
        "sustainability": 50
      },
      "price": 18.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976089325765",
      "vsf_explanation": "Ginkgo biloba's clinical evidence for memory and cognitive support is genuinely mixed, with some positive smaller trials offset by large studies (including the NIH-funded GEM trial) that found no significant dementia-prevention benefit. This listing discloses a single ingredient at a stated '9,000mg equivalent' but no extraction ratio, and critically omits any mention of ginkgo's well-documented bleeding-risk interaction with blood thinners and surgery. With no brand or manufacturer named anywhere on the listing, none of the sourcing or safety claims can be independently verified.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "uric-acid-flush-60-caps-celery-seed-montmorency-tart-cherry-chanca-piedra-turmeric-95",
      "title": "Uric Acid Flush – 60 Caps | Celery Seed, Montmorency Tart Cherry, Chanca Piedra & Turmeric 95%",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_1_af101372-4fcb-4bc3-82f8-c7f860065658.webp?v=1789915685",
      "score": 26,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "uric",
        "acid",
        "flush",
        "caps",
        "celery",
        "seed",
        "montmorency",
        "tart",
        "cherry",
        "chanca",
        "piedra",
        "turmeric",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 15,
        "manufacturing": 12,
        "safety": 40,
        "transparency": 12,
        "sustainability": 50
      },
      "price": 15.55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976089358533",
      "vsf_explanation": "This four-ingredient blend (celery seed, tart cherry, chanca piedra, turmeric) discloses zero individual milligram amounts for any of its active ingredients — the entire supplement facts section lists only ingredient names with no doses at all, the most severe dosing-transparency failure in this batch, triggering Vyvata's proprietary-blend auto-fail. Montmorency tart cherry has the best individual evidence base among the four for uric acid/gout support, but at an unknown dose that value can't be assessed. No brand is named, no drug-interaction warnings are given despite turmeric's known interactions with blood thinners, and manufacturing cannot be verified.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "vitamin-d3-4000iu-k2-mk7-100μg-180-vegetarian-tablets-bone-immune-support",
      "title": "Vitamin D3 4000IU & K2 MK7 100μg 180 Vegetarian Tablets | Bone Immune Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/95395a5ba038a2589845344c8c3428b1d8593c2021ee36574c09d5bd994e0ede.jpg?v=1789915686",
      "score": 67,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "4000iu",
        "mk7",
        "100",
        "180",
        "vegetarian",
        "tablets",
        "bone",
        "immune",
        "support",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 82,
        "formulation": 78,
        "manufacturing": 55,
        "safety": 80,
        "transparency": 30,
        "sustainability": 50
      },
      "price": 15.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976089555141",
      "vsf_explanation": "Vitamin D3 and K2 (as MK7) is a well-researched pairing, with D3 supporting calcium absorption and K2 directing that calcium toward bone rather than arterial tissue — both doses here (4000 IU D3, 100mcg K2) are individually disclosed and sit within safe, commonly studied ranges. The listing's reference to EFSA claim substantiation for the D3 component is a genuine transparency positive, since it ties the marketing language to an actual regulatory standard rather than an unverifiable brand claim. Manufacturing certification remains self-reported rather than third-party verified, which keeps this product in Vyvata's Standard tier just short of Verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gentian-root-900mg-gentiana-lutea-digestive-anti-inflammatory-herbal-support-90-capsules",
      "title": "Gentian Root 900mg | Gentiana Lutea | Digestive & Anti-Inflammatory Herbal Support | 90 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_1_bb3e45a9-f27c-46ba-bec6-94f04eaef976.webp?v=1789915685",
      "score": 39,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gentian",
        "root",
        "900mg",
        "gentiana",
        "lutea",
        "digestive",
        "anti",
        "inflammatory",
        "herbal",
        "support",
        "capsules",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 58,
        "manufacturing": 18,
        "safety": 62,
        "transparency": 28,
        "sustainability": 50
      },
      "price": 14.41,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976089391301",
      "vsf_explanation": "Gentian root is a traditional European bitter herb used for digestive support, but it has very limited modern clinical trial evidence behind its traditional-use claims. The listing does disclose a clear single-ingredient dose (900mg) and includes genuinely useful safety disclosures — an explicit contraindication for those with gastric or duodenal ulcers and an age restriction — which is better safety transparency than most other unbranded products in this batch. However, no brand or manufacturer is named anywhere on the listing, so sourcing and manufacturing quality remain unverifiable, which keeps this product in Vyvata's Rejected tier.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "vitamins-because-gla-gamma-linolenic-acid-800mg-200-capsules-borage-oil-omega-6",
      "title": "Vitamins Because GLA (Gamma-Linolenic Acid) 800mg | 200 Capsules | Borage Oil Omega-6",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_1_50859957-103d-4658-8f94-c1bbfac3aa53.webp?v=1789915685",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamins",
        "because",
        "gla",
        "gamma",
        "linolenic",
        "acid",
        "800mg",
        "200",
        "capsules",
        "borage",
        "oil",
        "omega",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 72,
        "manufacturing": 12,
        "safety": 62,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 18.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976089424069",
      "vsf_explanation": "GLA from borage oil has modest, mixed clinical evidence for skin and inflammatory support, and the 800mg dose sits within the range used in published borage-oil trials with a clean, single-ingredient label. However, Vitamins Because discloses no GMP registration number, third-party testing, or facility certification anywhere on the listing, which under a zero-assumption standard caps the manufacturing and overall score well below what the formulation alone would earn.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "turmeric-curcumin-ginger-6-000mg-180-caps-joint-pain-anti-inflammatory-antioxidant-support",
      "title": "Turmeric Curcumin & Ginger 6,000mg – 180 Caps | Joint Pain, Anti-Inflammatory & Antioxidant Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_1_4453aa40-8ea6-48d5-900f-7021d097a62c.webp?v=1789915686",
      "score": 31,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "turmeric",
        "curcumin",
        "ginger",
        "000mg",
        "180",
        "caps",
        "joint",
        "pain",
        "anti",
        "inflammatory",
        "antioxidant",
        "support",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 15,
        "manufacturing": 12,
        "safety": 55,
        "transparency": 25,
        "sustainability": 50
      },
      "price": 18.66,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976089456837",
      "vsf_explanation": "Turmeric and ginger both have real anti-inflammatory research behind them, but this listing discloses only a combined '6,000mg Turmeric Curcumin & Ginger Blend' with no per-ingredient breakdown and no curcuminoid standardization percentage, which is a proprietary-blend problem that hides the actual dose of the active compound. No brand name appears anywhere in the title or body copy — only a generic product description — so there is no company to hold accountable for the formulation or manufacturing claims.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "artichoke-leaf-extract-12000mg-liver-digestive-support-240-capsules-non-gmo-gluten-free",
      "title": "Artichoke Leaf Extract 12000mg | Liver & Digestive Support | 240 Capsules | Non-GMO, Gluten Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_1_293ad746-fa2d-4216-aed2-b049648f36d6.webp?v=1789915685",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "artichoke",
        "leaf",
        "extract",
        "12000mg",
        "liver",
        "digestive",
        "support",
        "240",
        "capsules",
        "non",
        "gmo",
        "gluten",
        "free",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 58,
        "manufacturing": 12,
        "safety": 60,
        "transparency": 42,
        "sustainability": 50
      },
      "price": 17.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976089489605",
      "vsf_explanation": "Artichoke leaf extract has modest traditional and preliminary clinical evidence for bile production and digestive comfort, and this listing at least states a single-ingredient dose rather than an undisclosed blend. The '12,000mg (equivalent)' phrasing is a common industry shorthand for a much smaller actual extract weight expressed at a dried-herb ratio, which the listing never explains, and no brand name or manufacturing certification appears anywhere on the page.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sea-buckthorn-oil-omega-7-12-000mg-180-caps-skin-hair-wellness-support-gluten-free",
      "title": "Sea Buckthorn Oil Omega-7 12,000mg – 180 Caps | Skin, Hair & Wellness Support | Gluten Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_1_e380c404-7a38-42bd-bfa8-2a1ca81cf50d.webp?v=1789915685",
      "score": 41,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sea",
        "buckthorn",
        "oil",
        "omega",
        "000mg",
        "180",
        "caps",
        "skin",
        "hair",
        "wellness",
        "support",
        "gluten",
        "free",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 55,
        "manufacturing": 12,
        "safety": 60,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976089522373",
      "vsf_explanation": "Sea buckthorn's omega-7 (palmitoleic acid) content has preliminary human evidence for skin hydration and mucosal support, but the research base is still thin relative to more established fatty acids. Like other listings in this catalog, the '12,000mg' figure is stated as an extract-equivalent without explaining the underlying ratio, and no brand name, GMP certification, or third-party testing is disclosed anywhere on the page.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pumpkin-seed-oil-saw-palmetto-3000mg-300-softgels-cold-pressed-virgin-oil-phytosterols-prostate-hair-support",
      "title": "Pumpkin Seed Oil & Saw Palmetto 3000mg 300 Softgels | Cold Pressed Virgin Oil Phytosterols | Prostate Hair Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_1_23be18df-6dd4-49c0-894f-0d3fab725c0b.webp?v=1789915686",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone",
        "skin"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "pumpkin",
        "seed",
        "oil",
        "saw",
        "palmetto",
        "3000mg",
        "300",
        "softgels",
        "cold",
        "pressed",
        "virgin",
        "oil",
        "phytosterols",
        "prostate",
        "hair",
        "support",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 62,
        "manufacturing": 12,
        "safety": 62,
        "transparency": 48,
        "sustainability": 50
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976089587909",
      "vsf_explanation": "Saw palmetto has a moderate, if mixed, body of clinical research for prostate and urinary comfort, and pumpkin seed oil phytosterols have reasonable supporting evidence as well; this listing at least states each ingredient's dose separately rather than hiding it inside an undisclosed blend. It still loses significant ground on manufacturing and transparency because no brand name, GMP registration, or independent testing is disclosed anywhere on the page.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ashwagandha-10",
      "title": "Ashwagandha 10%",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9d43e10f479e28ee99e4d48d863d4a254c1e5236732989a672237730c699f94e.jpg?v=1789915691",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood",
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ashwagandha",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 15,
        "safety": 30,
        "transparency": 15,
        "sustainability": 50
      },
      "price": 17.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976089718981",
      "vsf_explanation": "No brand name appears on this listing beyond a generic 'third-party lab tested' claim with no testing body named, so under the zero-assumption rule manufacturing and transparency can only receive minimal credit. Ashwagandha itself has a strong and growing evidence base for stress, cortisol, and sleep support, but this product's roughly 130mg-withanolide dose (from a 20:1 extract at 10% withanolides, 1,300mg serving) is well above the 15–30mg withanolide doses used in most published trials, and there's no disclosure of standard ashwagandha contraindications (thyroid conditions, pregnancy, autoimmune conditions). Rejected for lack of brand provenance.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "vitabod-cold-pressed-pumpkin-seed-oil-3000mg-180-softgels-prostate-urinary-heart-support-non-gmo",
      "title": "Vitabod Cold Pressed Pumpkin Seed Oil 3000mg 180 Softgels | Prostate Urinary & Heart Support Non-GMO",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ca97cc809f73b44d73232bf1c729cc0e84f73ae67b2a4901105419d48bbe3888.png?v=1789915691",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone",
        "cardiovascular"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "vitabod",
        "cold",
        "pressed",
        "pumpkin",
        "seed",
        "oil",
        "3000mg",
        "180",
        "softgels",
        "prostate",
        "urinary",
        "heart",
        "support",
        "non",
        "gmo",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 65,
        "manufacturing": 20,
        "safety": 70,
        "transparency": 30,
        "sustainability": 50
      },
      "price": 14.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976089751749",
      "vsf_explanation": "Vitabod is named as the brand, but the listing discloses essentially no manufacturing information beyond 'Non-GMO, gluten free' — no GMP statement, no third-party testing, no facility disclosure — which holds manufacturing and transparency down under the zero-assumption rule. Pumpkin seed oil has a modest but genuine evidence base for prostate and urinary symptom support, and the ingredient itself carries very low safety risk. The score falls short of Standard tier primarily on documentation quality, not ingredient safety.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "life-extension-optimized-saffron-extract-88-5mg-60-caps-satiereal®-appetite-mood-support",
      "title": "Life Extension Optimized Saffron Extract 88.5mg – 60 Caps | Satiereal® | Appetite & Mood Support",
      "vendor": "Life Extension",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_281ed115-ad7a-4533-9b8d-f9398dadbdcb.webp?v=1789915691",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "life",
        "extension",
        "optimized",
        "saffron",
        "extract",
        "5mg",
        "caps",
        "satiereal",
        "appetite",
        "mood",
        "support",
        "life",
        "extension"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 72,
        "manufacturing": 85,
        "safety": 78,
        "transparency": 72,
        "sustainability": 52
      },
      "price": 27,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976089784517",
      "vsf_explanation": "Life Extension's Satiereal® saffron extract is one of the few ingredients in this batch backed by actual published human trials (the Gout et al. studies) showing reduced snacking and improved mood markers, standardized to 0.3% safranal for consistent potency. This listing's 88.25mg single-daily dose is at the lower end of what the original clinical trials used (176.5mg/day split into two doses), so benefits may be more modest than marketing implies, though it remains within a studied range for this patented extract. Life Extension's established manufacturing and disclosure practices support strong manufacturing and transparency scores.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamatic-vitamin-b2-riboflavin-250-mg-200-capsules",
      "title": "Vitamatic | Vitamin B2 (Riboflavin) 250 mg | 200 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cfc57df4cdba74682c28769d84e8e9e6703afcaa7becad1204ae6050511ddbe2.png?v=1789915690",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamatic",
        "vitamin",
        "riboflavin",
        "250",
        "200",
        "capsules",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 70,
        "manufacturing": 45,
        "safety": 85,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 15.28,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976089817285",
      "vsf_explanation": "Riboflavin is an essential, well-tolerated vitamin, and at 250mg this dose sits well above the RDA and approaches ranges studied for migraine prophylaxis — though this listing markets general 'energy and metabolism' benefits rather than the migraine indication where high-dose B2 has its strongest evidence, so the marketed claims and the strongest evidence don't fully align. Riboflavin's safety profile at high doses is excellent, since it's water-soluble and excess is excreted in urine. Vitamatic's GMP-compliant, FDA-registered facility supports a reasonable manufacturing score, though the listing lacks third-party testing disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "resveratrol-98-180-capsules",
      "title": "RESVERATROL 98% (180 capsules)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8a35d936b5159d3884faa972316f5a61039330360173b22f729a1ef111767529.jpg?v=1789915691",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "resveratrol",
        "180",
        "capsules",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 68,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 35,
        "sustainability": 50
      },
      "price": 51.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976089850053",
      "vsf_explanation": "Toniiq is identified as the brand, but this listing makes only generic 'highest quality, ethically sourced' claims without naming any GMP certification, third-party lab, or facility standard, which limits manufacturing and transparency credit. Resveratrol has extensive preclinical longevity research but comparatively weak human RCT evidence for anti-aging outcomes, and plain trans-resveratrol (as opposed to enhanced-bioavailability forms) has known absorption limitations. The 600mg dose also carries a real but undisclosed drug-interaction risk via CYP450 enzyme inhibition.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "resveratrol-600mg-98-pure-60-veggie-capsules",
      "title": "Resveratrol – 600mg 98% Pure - 60 Veggie Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/099b927b10de71939b5f4f6651b52824db83e5d02139afdf90cc9d657f887375.jpg?v=1789915691",
      "score": 49,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "resveratrol",
        "600mg",
        "pure",
        "veggie",
        "capsules",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 68,
        "manufacturing": 55,
        "safety": 45,
        "transparency": 20,
        "sustainability": 50
      },
      "price": 31.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976089882821",
      "vsf_explanation": "This listing describes a GMP-certified, NSF-approved facility with per-batch third-party testing — more manufacturing detail than most unbranded listings in this batch provide — but no company name is given anywhere on the page, so there is no accountable entity a consumer could verify those claims against, which keeps transparency low under the zero-assumption rule. The ingredient itself (600mg, 98% trans-resveratrol) matches what a Toniiq-branded listing in this same batch sells product-for-product, underscoring how much scoring here hinges on brand accountability rather than formulation. Rejected for lack of brand provenance despite above-average process disclosure.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "vitamatic-l-tryptophan-1000mg-120-tablets",
      "title": "Vitamatic | L-Tryptophan 1000mg | 120 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2793bd5be1987fefc5195c9acf639d4c282826ea5474b526f0a3c1f95d1b5d1c.png?v=1789915693",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamatic",
        "tryptophan",
        "1000mg",
        "120",
        "tablets",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 70,
        "manufacturing": 45,
        "safety": 45,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 14.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976089981125",
      "vsf_explanation": "Vitamatic discloses a GMP-compliant, FDA-registered manufacturing facility, and the 1,000mg L-tryptophan dose is clearly labeled and within the range used in mood/sleep-support research. L-tryptophan has a reasonably solid pharmacological evidence base as a serotonin/melatonin precursor, though much of the clinical literature is decades old. Manufacturing quality control matters significantly for this ingredient (the 1989 eosinophilia-myalgia outbreak was traced to a contaminated batch from a single producer), and this listing includes no third-party purity testing statement or MAOI/SSRI interaction warning, which holds the safety score down.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitamatic-lithium-orotate-20mg-90-capsules",
      "title": "Vitamatic | Lithium Orotate 20mg | 90 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a36776a027527b929ac52a16c20fe3b122d976abed19d8a2f64929dc2a067fd8.png?v=1789915693",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamatic",
        "lithium",
        "orotate",
        "20mg",
        "capsules",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 20,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 12.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976090013893",
      "vsf_explanation": "Lithium orotate is a pharmacologically active lithium salt, and even at this low 20mg dose it carries the class-wide safety considerations associated with lithium — kidney, thyroid, and cardiac monitoring concerns with sustained use — none of which are disclosed here beyond a generic 'third-party tested' claim. Clinical evidence specific to lithium orotate at supplement doses is essentially absent; virtually all of lithium's established mood-research uses prescription lithium carbonate at monitored therapeutic doses, not the orotate salt sold over the counter. This product is rejected on a safety-concern autofail for marketing an unmonitored pharmacologically active mineral without contraindication guidance.",
      "vsf_autofail_rule": "safety_concern"
    },
    {
      "handle": "nattokinase-6-000-fu-100-softgels-50-servings-heart-brain-blood-circulation-support-naturally-sourced",
      "title": "Nattokinase 6,000 FU – 100 Softgels | 50 Servings | Heart, Brain & Blood Circulation Support | Naturally Sourced",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_1_2748fc23-a717-4111-a2c1-5d0a3c94dbba.webp?v=1789915695",
      "score": 28,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nattokinase",
        "000",
        "100",
        "softgels",
        "servings",
        "heart",
        "brain",
        "blood",
        "circulation",
        "support",
        "naturally",
        "sourced",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 0,
        "safety": 25,
        "transparency": 10,
        "sustainability": 50
      },
      "price": 21.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976090112197",
      "vsf_explanation": "This nattokinase listing discloses no brand name at all, so manufacturing and transparency default to near-zero under the zero-assumption rule, and there is no accountable company to verify that the stated 6,000 FU of fibrinolytic activity is what's actually in the softgel. This dose is also meaningfully above the 2,000–4,000 FU range used in most published nattokinase trials, which combined with nattokinase's known bleeding-risk profile and zero contraindication disclosure on this listing is a real safety gap. Rejected for lack of brand provenance.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "organic-oregano-oil-6-000mg-300-softgels-carvacrol-165mg-thymoquinone-immune-antimicrobial-support",
      "title": "Organic Oregano Oil 6,000mg – 300 Softgels | Carvacrol 165mg & Thymoquinone | Immune & Antimicrobial Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_1_e2300b27-12c1-4f8d-927a-1c4dbeb0f13f.webp?v=1789915696",
      "score": 26,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "organic",
        "oregano",
        "oil",
        "000mg",
        "300",
        "softgels",
        "carvacrol",
        "165mg",
        "thymoquinone",
        "immune",
        "antimicrobial",
        "support",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 0,
        "safety": 40,
        "transparency": 10,
        "sustainability": 50
      },
      "price": 19.88,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976090144965",
      "vsf_explanation": "This listing markets '6,000mg' of oregano oil per serving but only discloses 165mg of carvacrol — the actual bioactive compound — creating a large gap between the headline dose and what's pharmacologically active, a misleading-naming concern independent of the missing brand name. Human clinical evidence for oregano oil and carvacrol supporting immune function is largely limited to in vitro and animal data rather than controlled human trials. No brand is identified anywhere on the page, so manufacturing and transparency also default to near-zero under the zero-assumption rule.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "silica-horsetail-extract-12-000mg-180-caps-equisetum-arvense-hair-skin-nails-bone-support-gluten-free",
      "title": "Silica Horsetail Extract 12,000mg – 180 Caps | Equisetum Arvense | Hair, Skin, Nails & Bone Support | Gluten Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_1_ef7ac9cb-1600-4efd-8513-26f3c02beb09.webp?v=1789915697",
      "score": 23,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "silica",
        "horsetail",
        "extract",
        "000mg",
        "180",
        "caps",
        "equisetum",
        "arvense",
        "hair",
        "skin",
        "nails",
        "bone",
        "support",
        "gluten",
        "free",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 35,
        "manufacturing": 0,
        "safety": 30,
        "transparency": 10,
        "sustainability": 50
      },
      "price": 18.55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976090177733",
      "vsf_explanation": "No brand name appears anywhere in this listing, so manufacturing and transparency default to near-zero under the zero-assumption rule — there's no company to verify that the horsetail extract has been properly processed to deactivate thiaminase, an enzyme in raw horsetail that can deplete B1 with prolonged use. Human evidence for horsetail silica improving hair, skin, nail, or bone outcomes is thin and largely traditional-use based rather than controlled-trial based, and the extract isn't standardized to a specific silica percentage. Rejected for lack of brand provenance.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "nad-cell-support-nmn-300mg-90-veggie-caps-cellular-energy-healthy-aging-life-extension",
      "title": "NAD+ Cell Support NMN 300mg – 90 Veggie Caps | Cellular Energy & Healthy Aging | Life Extension",
      "vendor": "Life Extension",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/nad_90.jpg?v=1789915698",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nad",
        "cell",
        "support",
        "nmn",
        "300mg",
        "veggie",
        "caps",
        "cellular",
        "energy",
        "healthy",
        "aging",
        "life",
        "extension",
        "life",
        "extension"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 75,
        "manufacturing": 85,
        "safety": 72,
        "transparency": 72,
        "sustainability": 52
      },
      "price": 28.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976090276037",
      "vsf_explanation": "Life Extension is a long-established, GMP-audited manufacturer with a track record of standardized formulations, and this product's 300mg NMN dose sits within the range used in recent human NAD+-elevation trials. Evidence for NMN's healthy-aging benefits is still emerging: several small human studies show it raises blood NAD+ levels, but robust long-term outcome data in humans remains limited, and NMN's status as a dietary ingredient has been contested by the FDA. No sustainability disclosures were found on this listing, so that dimension defaults to the rubric's neutral baseline.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ceylon-cinnamon-9000mg-true-cinnamon-15-1-extract-blood-sugar-antioxidant-support-180-capsules-non-gmo-gluten-free",
      "title": "Ceylon Cinnamon 9000mg | True Cinnamon 15:1 Extract | Blood Sugar & Antioxidant Support | 180 Capsules | Non-GMO, Gluten Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_1_ee8168ee-36e4-4989-8541-70bdc21c3b86.webp?v=1789915697",
      "score": 31,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ceylon",
        "cinnamon",
        "9000mg",
        "true",
        "cinnamon",
        "extract",
        "blood",
        "sugar",
        "antioxidant",
        "support",
        "180",
        "capsules",
        "non",
        "gmo",
        "gluten",
        "free",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 0,
        "safety": 35,
        "transparency": 10,
        "sustainability": 50
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976090308805",
      "vsf_explanation": "No brand name appears anywhere on this listing, so under Vyvata's zero-assumption rule the manufacturing and transparency dimensions cannot be credited — there is no company to verify GMP status, third-party testing, or sourcing against. The underlying evidence for cinnamon supporting healthy blood sugar is real but mixed, and mostly built on Cassia cinnamon studies rather than Ceylon; the '9,000mg equivalent' framing (from a 15:1 extract that is really about 600mg of concentrate) also inflates the apparent dose relative to what's actually in the capsule. This product is rejected for lack of brand provenance, not for the ingredient itself.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "saw-palmetto-5-000mg-pumpkin-seed-300-caps-prostate-urinary-hair-health-support-gluten-free-no-soy",
      "title": "Saw Palmetto 5,000mg + Pumpkin Seed – 300 Caps | Prostate, Urinary & Hair Health Support | Gluten-Free, No Soy",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_1_cfa6e15a-e225-45b5-b80d-1342ab559342.webp?v=1789915697",
      "score": 31,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone",
        "skin"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "saw",
        "palmetto",
        "000mg",
        "pumpkin",
        "seed",
        "300",
        "caps",
        "prostate",
        "urinary",
        "hair",
        "health",
        "support",
        "gluten",
        "free",
        "soy",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 0,
        "safety": 45,
        "transparency": 10,
        "sustainability": 50
      },
      "price": 30.3,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976090341573",
      "vsf_explanation": "This listing carries no identifiable brand name, so per Vyvata's zero-assumption rule manufacturing and transparency cannot be scored above a token level — there's no accountable company to check for GMP certification or certificates of analysis. Saw palmetto has a genuine research history for prostate and urinary symptoms, though recent larger trials found weaker effects than earlier smaller studies suggested, and this listing doesn't disclose the extract's standardization (e.g., % fatty acids), so the actual potency behind the '5,000mg equivalent' claim can't be verified. Rejected for lack of brand provenance.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "betaine-hcl-1-200mg-180-caps-betaine-hydrochloride-stomach-acid-protein-digestion-support-non-gmo-gluten-free",
      "title": "Betaine HCl 1,200mg – 180 Caps | Betaine Hydrochloride | Stomach Acid & Protein Digestion Support | Non-GMO, Gluten Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_1_2294213c-981c-4163-9782-f95f15a81528.webp?v=1789915697",
      "score": 31,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "betaine",
        "hcl",
        "200mg",
        "180",
        "caps",
        "betaine",
        "hydrochloride",
        "stomach",
        "acid",
        "protein",
        "digestion",
        "support",
        "non",
        "gmo",
        "gluten",
        "free",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 65,
        "manufacturing": 0,
        "safety": 30,
        "transparency": 10,
        "sustainability": 50
      },
      "price": 18.66,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976090374341",
      "vsf_explanation": "No brand is disclosed anywhere in this listing, so manufacturing and transparency default to near-zero under the zero-assumption rule — there's no company of record to verify GMP compliance or purity testing for an acid-forming supplement where quality control genuinely matters. Betaine HCl has a long history of practitioner use for low stomach acid, but modern controlled-trial evidence is thin, and this listing doesn't disclose the standard contraindications (active ulcers, gastritis, concurrent NSAID use) that responsible betaine HCl labeling should include. Rejected for lack of brand provenance.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "life-extension-ginkgo-biloba-120mg-certified-extract™-2-365-veggie-caps-730-total-24-flavone-glycosides-memory-focus-brain-circulation",
      "title": "Life Extension Ginkgo Biloba 120mg Certified Extract™ – 2×365 Veggie Caps (730 Total) | 24% Flavone Glycosides | Memory, Focus & Brain Circulation",
      "vendor": "Life Extension",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/57_317212c1-24c4-446e-93d6-8d839f19f347.jpg?v=1789915697",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "life",
        "extension",
        "ginkgo",
        "biloba",
        "120mg",
        "certified",
        "extract",
        "365",
        "veggie",
        "caps",
        "730",
        "total",
        "flavone",
        "glycosides",
        "memory",
        "focus",
        "brain",
        "circulation",
        "life",
        "extension"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 82,
        "manufacturing": 85,
        "safety": 60,
        "transparency": 72,
        "sustainability": 52
      },
      "price": 75.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976090407109",
      "vsf_explanation": "Life Extension's Certified Extract is precisely standardized to 24% flavone glycosides, 6% terpene lactones, and under 1ppm ginkgolic acid, which is genuinely strong formulation transparency, and the 120mg dose sits within the range used in most published ginkgo cognition and circulation trials. Evidence for ginkgo's memory benefits is real but mixed in healthy adults, with more consistent signal in age-related cognitive decline populations. Ginkgo carries a known bleeding-risk interaction with anticoagulants and antiplatelet drugs that isn't flagged on this listing, which limits the safety score despite the brand's overall manufacturing credibility.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "now-foods-nattokinase-100mg-2-000-fu-60-veg-caps-circulation-cardiovascular-support-non-gmo",
      "title": "NOW Foods Nattokinase 100mg – 2,000 FU | 60 Veg Caps | Circulation & Cardiovascular Support | Non-GMO",
      "vendor": "Now Foods",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/57_705a70a6-6a65-469b-b2bc-eb36c66a0ab9.jpg?v=1789915699",
      "score": 69,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "foods",
        "nattokinase",
        "100mg",
        "000",
        "veg",
        "caps",
        "circulation",
        "cardiovascular",
        "support",
        "non",
        "gmo",
        "now",
        "foods"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 78,
        "manufacturing": 85,
        "safety": 55,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 18.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976090538181",
      "vsf_explanation": "NOW Foods is a well-established, GMP-audited manufacturer with strong in-house and third-party testing infrastructure, and this nattokinase delivers a clearly disclosed 100mg/2,000 FU dose that falls within the range used in published fibrinolytic-activity research. Evidence for nattokinase's cardiovascular benefits is real but still moderate — multiple human studies exist, but not yet meta-analysis-level consensus. Positioning the product as suitable for those 'on anticoagulant therapy' oversteps what's medically appropriate without a physician-supervision caveat, which caps the safety score. No sustainability data is disclosed, so that dimension defaults to the rubric's neutral baseline.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "alpha-lipoic-acid-ala-600mg-240-veggie-caps-antioxidant-brain-nerve-skin-support-non-gmo-nutriment-boutique",
      "title": "Alpha Lipoic Acid (ALA) 600mg – 240 Veggie Caps | Antioxidant, Brain, Nerve & Skin Support | Non-GMO Nutriment Boutique",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/20260524_222135.jpg?v=1789915701",
      "score": 53,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive",
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alpha",
        "lipoic",
        "acid",
        "ala",
        "600mg",
        "240",
        "veggie",
        "caps",
        "antioxidant",
        "brain",
        "nerve",
        "skin",
        "support",
        "non",
        "gmo",
        "nutriment",
        "boutique",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 30,
        "safety": 65,
        "transparency": 30,
        "sustainability": 52
      },
      "price": 18.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976090570949",
      "vsf_explanation": "This product's 600mg ALA dose matches the therapeutic dose used in well-known European clinical research on diabetic neuropathy, and the listing claims third-party testing and GMP manufacturing — more specific manufacturing claims than most comparable listings, though still self-declared and unverified. However, no real brand or manufacturer is identifiable; the name appearing in the title is a marketplace storefront, not a supplement brand, so we can't independently confirm the testing or GMP claims made on the page. That gap in verifiable provenance is why this product lands in the Rejected tier despite ALA itself being a well-studied, well-dosed ingredient.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "nattokinase-400mg-8-000-fu-120-caps-high-potency-fibrinolytic-enzyme-circulation-cardiovascular-support",
      "title": "Nattokinase 400mg – 8,000 FU | 120 Caps | High Potency Fibrinolytic Enzyme | Circulation & Cardiovascular Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_1_24c9f364-0ed5-45ca-898a-282b4c8242e3.webp?v=1789915702",
      "score": 41,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nattokinase",
        "400mg",
        "000",
        "120",
        "caps",
        "high",
        "potency",
        "fibrinolytic",
        "enzyme",
        "circulation",
        "cardiovascular",
        "support",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 60,
        "manufacturing": 15,
        "safety": 45,
        "transparency": 25,
        "sustainability": 50
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976090669253",
      "vsf_explanation": "Nattokinase has moderate clinical evidence supporting fibrinolytic activity and modest cardiovascular benefits, and this product's 8,000 FU dose sits within commonly studied ranges. However, no manufacturer is identified anywhere on the listing, so GMP compliance and testing can't be verified, and — as with any fibrinolytic enzyme — the product discloses no caution around use alongside blood thinners or before surgery. The combination of unverifiable manufacturing and missing safety disclosure keeps this in the Rejected tier despite nattokinase itself having a reasonable evidence base.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "boswellia-serrata-extract-10-000mg-200-veggie-caps-joint-inflammation-support-non-gmo-gluten-free",
      "title": "Boswellia Serrata Extract 10,000mg – 200 Veggie Caps | Joint & Inflammation Support | Non-GMO, Gluten-Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/20260523_222731.jpg?v=1789915702",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "boswellia",
        "serrata",
        "extract",
        "000mg",
        "200",
        "veggie",
        "caps",
        "joint",
        "inflammation",
        "support",
        "non",
        "gmo",
        "gluten",
        "free",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 50,
        "manufacturing": 25,
        "safety": 70,
        "transparency": 30,
        "sustainability": 52
      },
      "price": 24.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976090734789",
      "vsf_explanation": "Boswellia serrata has solid overall clinical evidence for joint comfort and inflammation support across multiple RCTs, and this product adds BioPerine for absorption enhancement, which is a genuine formulation plus. However, the listing doesn't disclose standardization to AKBA (acetyl-keto-beta-boswellic acid), the specific active compound most clinical trials standardize to, making it hard to compare this extract's real potency to the research. No manufacturer is named beyond a generic 'Made in the USA, cGMP-compliant facility' claim that can't be independently verified, which limits the transparency and manufacturing scores.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "optimized-nad-nmn-300mg-with-resveratrol-elite™-30-veggie-caps-cellular-aging-support-life-extension",
      "title": "Optimized NAD+ NMN 300mg with Resveratrol Elite™ – 30 Veggie Caps | Cellular Aging Support | Life Extension",
      "vendor": "Life Extension",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/nad_nmn.jpg?v=1789915702",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "optimized",
        "nad",
        "nmn",
        "300mg",
        "with",
        "resveratrol",
        "elite",
        "veggie",
        "caps",
        "cellular",
        "aging",
        "support",
        "life",
        "extension",
        "life",
        "extension"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 50,
        "manufacturing": 85,
        "safety": 75,
        "transparency": 72,
        "sustainability": 52
      },
      "price": 16.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976090767557",
      "vsf_explanation": "Life Extension manufactures this longevity-focused formula under established cGMP standards, and the core NMN dose of 300mg is within the range used in current human research on raising NAD+ levels — an active and promising but still-developing area of science. The 'Resveratrol Elite' component is a named proprietary blend, though it does disclose that trans-resveratrol makes up roughly 10mg of the 55mg blend, a dose notably below the 150-500mg range used in most resveratrol clinical trials. Overall this lands as Standard: solid manufacturing credibility offset by emerging (not yet fully established) evidence and a resveratrol dose likely too low to match its own research base.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "l-citrulline-3-000mg-240-caps-free-form-amino-acid-nitric-oxide-performance-support",
      "title": "L-Citrulline 3,000mg – 240 Caps | Free Form Amino Acid | Nitric Oxide & Performance Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_1_2473707a-e2d7-417c-a9bb-a05233099726.webp?v=1789915702",
      "score": 47,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "citrulline",
        "000mg",
        "240",
        "caps",
        "free",
        "form",
        "amino",
        "acid",
        "nitric",
        "oxide",
        "performance",
        "support",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 15,
        "safety": 75,
        "transparency": 30,
        "sustainability": 50
      },
      "price": 23.55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976090800325",
      "vsf_explanation": "L-citrulline has solid clinical evidence for supporting nitric oxide production, blood flow, and exercise performance, though most of the strongest performance-related trials use doses of 6-8g/day — roughly double this product's 3,000mg serving. The free-form, single-ingredient formulation is cleanly disclosed with no fillers or blends, which is a genuine formulation plus. However, no manufacturer is named on the listing, so GMP compliance and testing can't be verified, which caps the overall score despite citrulline's own reasonable evidence base.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "nattokinase-12-000-fu-serrapeptase-360-000-spu-lumbrokinase-coq10-max-strength-systemic-enzyme-complex",
      "title": "Nattokinase 12,000 FU + Serrapeptase 360,000 SPU + Lumbrokinase & CoQ10 — Max Strength Systemic Enzyme Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/20260616_225103.jpg?v=1789915748",
      "score": 27,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nattokinase",
        "000",
        "serrapeptase",
        "360",
        "000",
        "spu",
        "lumbrokinase",
        "coq10",
        "max",
        "strength",
        "systemic",
        "enzyme",
        "complex",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 30,
        "manufacturing": 15,
        "safety": 25,
        "transparency": 10,
        "sustainability": 50
      },
      "price": 20.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976092569797",
      "vsf_explanation": "This product combines three high-potency fibrinolytic enzymes — nattokinase (12,000 FU), serrapeptase (360,000 SPU), and lumbrokinase (10,000 FUV) — in a single formula with zero disclosure of bleeding-risk, anticoagulant drug interactions, or pre-surgical cautions, despite stacking three enzymes that can each independently affect clotting. Serrapeptase in particular has controversial, largely unsubstantiated clinical evidence and known oral bioavailability concerns that aren't addressed (no mention of enteric coating). Combined with a cofactor and 'digestive & antioxidant blend' that lists ingredients without individual amounts and no identified manufacturer, this is flagged as a safety concern and rejected.",
      "vsf_autofail_rule": "safety_concern"
    },
    {
      "handle": "now-foods-betaine-hcl-ox-bile-120-capsules-1500mg-betaine-42-cholic-acid-ox-bile",
      "title": "NOW Foods Betaine HCl & Ox Bile 120 Capsules | 1500mg Betaine + 42% Cholic Acid Ox Bile",
      "vendor": "Now Foods",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_1_2bfe3200-ad9f-4a13-bcec-e62d33e95a8f.webp?v=1789915748",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "foods",
        "betaine",
        "hcl",
        "bile",
        "120",
        "capsules",
        "1500mg",
        "betaine",
        "cholic",
        "acid",
        "bile",
        "now",
        "foods"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 65,
        "manufacturing": 85,
        "safety": 55,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 25.55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976092602565",
      "vsf_explanation": "NOW Foods is a well-established, reputable US supplement manufacturer with a strong GMP and quality-testing track record, and this product clearly discloses its two active ingredients (1,500mg betaine, ox bile standardized to 42% cholic acid). Evidence for betaine HCl and ox bile supporting stomach acid and fat digestion is reasonable in a practitioner-guided context, though it's more niche/therapeutic-use evidence than broad general-population RCT data. The main gap is that betaine HCl carries real contraindications — it shouldn't be used by people with active peptic ulcers or gastritis — and this listing doesn't disclose that caution.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "gotu-kola-12-000mg-200-caps-centella-asiatica-brain-memory-circulation-support-gluten-free-no-preservatives",
      "title": "Gotu Kola 12,000mg – 200 Caps | Centella Asiatica | Brain, Memory & Circulation Support | Gluten-Free, No Preservatives",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_38b33d97-d27f-4fcc-abd1-d5834b9dcfc9.webp?v=1789915757",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "gotu",
        "kola",
        "000mg",
        "200",
        "caps",
        "centella",
        "asiatica",
        "brain",
        "memory",
        "circulation",
        "support",
        "gluten",
        "free",
        "preservatives",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 35,
        "manufacturing": 15,
        "safety": 45,
        "transparency": 15,
        "sustainability": 50
      },
      "price": 19.88,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976092700869",
      "vsf_explanation": "This listing does not name a manufacturer anywhere on the page, so we cannot verify GMP compliance, third-party testing, or sourcing — a hard zero under our zero-assumption transparency rule. Gotu kola (Centella asiatica) has modest human evidence for circulation and cognitive support, but the '12,000mg equivalent' claim describes a crude-herb equivalency rather than a standardized extract dose, making the actual active-compound intake impossible to verify. Because we cannot confirm who makes this product or how it's tested, we cannot recommend it despite gotu kola itself having a reasonable traditional-use and preliminary-evidence profile.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "pygeum-12-000mg-180-caps-no-preservatives-prostate-urinary-health",
      "title": "Pygeum 12,000mg | 180 Caps | No Preservatives | Prostate & Urinary Health",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_1_9cd189d6-b7ea-4438-90e6-8220dbf3b129.webp?v=1789915757",
      "score": 36,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "pygeum",
        "000mg",
        "180",
        "caps",
        "preservatives",
        "prostate",
        "urinary",
        "health",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 35,
        "manufacturing": 15,
        "safety": 50,
        "transparency": 15,
        "sustainability": 52
      },
      "price": 18.88,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976092733637",
      "vsf_explanation": "Pygeum africanum bark extract has moderate published evidence supporting urinary and prostate comfort in men, typically at standardized extract doses far lower than the '12,000mg equivalent' claimed here. Because the listing provides no manufacturer name, we cannot verify GMP status, extract standardization, or third-party testing, which is a hard transparency failure under our zero-assumption rule. The ambiguous herb-equivalency dosing language further obscures how much active extract is actually delivered per serving.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "life-extension-hepatopro-ppc-polyunsaturated-phosphatidylcholine-900mg-60-softgels",
      "title": "Life Extension HepatoPro PPC Polyunsaturated Phosphatidylcholine 900mg 60 Softgels",
      "vendor": "Life Extension",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/57_b6db7da7-45d5-4206-906f-e4b13e8d2169.jpg?v=1789915757",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "life",
        "extension",
        "hepatopro",
        "ppc",
        "polyunsaturated",
        "phosphatidylcholine",
        "900mg",
        "softgels",
        "life",
        "extension"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 75,
        "manufacturing": 85,
        "safety": 75,
        "transparency": 72,
        "sustainability": 52
      },
      "price": 40.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976092766405",
      "vsf_explanation": "Life Extension is a long-established, cGMP-manufacturing supplement brand with a track record of publishing full ingredient disclosures, and this product's polyenylphosphatidylcholine (PPC) dose of 900mg is within ranges used in European liver-support research. Evidence for PPC supporting liver cell membrane integrity is reasonable but not extensive in modern high-quality RCTs, and the single-ingredient formula with a full supplement facts disclosure supports a solid transparency score. Overall this lands as Vyvata Verified based on strong manufacturing credibility and moderate evidence quality.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "astaxanthin-12mg-120-softgels-4-month-supply-fresh-microalgae-source-antioxidant-skin-eye-joint-support-non-gmo-gluten-free",
      "title": "Astaxanthin 12mg – 120 Softgels | 4-Month Supply | Fresh Microalgae Source | Antioxidant, Skin, Eye & Joint Support | Non-GMO, Gluten-Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8163.jpg?v=1789915757",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "astaxanthin",
        "12mg",
        "120",
        "softgels",
        "month",
        "supply",
        "fresh",
        "microalgae",
        "source",
        "antioxidant",
        "skin",
        "eye",
        "joint",
        "support",
        "non",
        "gmo",
        "gluten",
        "free",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 15,
        "safety": 70,
        "transparency": 25,
        "sustainability": 52
      },
      "price": 17.44,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976092799173",
      "vsf_explanation": "Astaxanthin has a reasonably strong human evidence base for skin, eye, and exercise-recovery benefits at doses in the 4-12mg/day range, and this product's 12mg dose sits within that studied window. However, the listing names no manufacturer, so we cannot verify GMP compliance, microalgae sourcing quality, or third-party testing, which caps the score under our zero-assumption transparency rule despite the ingredient's own solid research base. Several of the marketing claims ('6,000x stronger than Vitamin C') overstate the certainty of the underlying science.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "pumpkin-seed-oil-saw-palmetto-4000mg-300-softgels-cold-pressed-virgin-oil-with-phytosterols",
      "title": "Pumpkin Seed Oil & Saw Palmetto 4000mg – 300 Softgels | Cold-Pressed Virgin Oil with Phytosterols",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_1_db1a2e92-75c5-40b3-b8dd-7d8d1bd93f7b.webp?v=1789915757",
      "score": 32,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pumpkin",
        "seed",
        "oil",
        "saw",
        "palmetto",
        "4000mg",
        "300",
        "softgels",
        "cold",
        "pressed",
        "virgin",
        "oil",
        "with",
        "phytosterols",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 20,
        "manufacturing": 15,
        "safety": 65,
        "transparency": 10,
        "sustainability": 50
      },
      "price": 24.44,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976092831941",
      "vsf_explanation": "This product lists its two active ingredients as a single combined 4,000mg 'blend' rather than disclosing individual amounts of pumpkin seed oil versus saw palmetto extract, which is a proprietary-blend-style transparency failure — we can't verify either ingredient is present at a clinically meaningful dose. Saw palmetto's evidence for prostate symptom relief is genuinely mixed, with large modern RCTs failing to show significant benefit over placebo, while pumpkin seed oil has more modest supporting evidence for hair and urinary symptoms. Combined with the absence of any named manufacturer, this product scores poorly on formulation and transparency.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "grass-fed-beef-liver-3-000mg-new-zealand-non-gmo-90-caps",
      "title": "Grass Fed Beef Liver 3,000mg | New Zealand | Non-GMO | 90 Caps",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/20260603_124719.png?v=1789915758",
      "score": 41,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "grass",
        "fed",
        "beef",
        "liver",
        "000mg",
        "new",
        "zealand",
        "non",
        "gmo",
        "caps",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 20,
        "safety": 45,
        "transparency": 30,
        "sustainability": 65
      },
      "price": 16.77,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976092864709",
      "vsf_explanation": "Desiccated beef liver is a legitimate source of highly bioavailable vitamin A, B12, iron, and copper, and this listing includes real, specific sourcing claims (New Zealand pasture-raised, non-GMO verified) that go beyond typical generic marketing language. However, no manufacturer is named, so GMP compliance and testing can't be verified, and the product discloses no caution around vitamin A intake — a meaningful gap given desiccated liver can deliver very high preformed vitamin A, which carries real risk for pregnant women and anyone already supplementing vitamin A elsewhere. The combination of unverifiable manufacturing and missing safety disclosure limits the score despite genuine nutrient density.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "tart-cherry-extract-12000mg-200-veg-capsules-antioxidant-uric-acid-sleep-support",
      "title": "Tart Cherry Extract 12000mg – 200 Veg Capsules | Antioxidant, Uric Acid & Sleep Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_1_264b9d20-c822-414c-9868-ef09345bec16.webp?v=1789915758",
      "score": 41,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tart",
        "cherry",
        "extract",
        "12000mg",
        "200",
        "veg",
        "capsules",
        "antioxidant",
        "uric",
        "acid",
        "sleep",
        "support",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 35,
        "manufacturing": 15,
        "safety": 75,
        "transparency": 15,
        "sustainability": 50
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976092897477",
      "vsf_explanation": "Tart cherry (Montmorency) has reasonable small-trial evidence for exercise recovery, uric acid balance, and sleep support, largely tied to its anthocyanin and melatonin-precursor content. This listing's '12,000mg equivalent' language is a crude-herb equivalency rather than a disclosed extract concentration, making it impossible to verify the actual anthocyanin dose delivered. With no manufacturer named anywhere on the page, GMP compliance and testing can't be verified, which caps the overall score.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "magnesium-glycinate-1500mg-ksm-66®-ashwagandha-turmeric-2000mg-vitamin-b6-90-caps-4-in-1-relaxation-stress-vitality-formula-made-in-uk",
      "title": "Magnesium Glycinate 1500mg + KSM-66® Ashwagandha + Turmeric 2000mg + Vitamin B6 – 90 Caps | 4-in-1 Relaxation, Stress & Vitality Formula | Made in UK",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_1_0331354e-402c-487d-aa9a-36f33ab76462.webp?v=1789915757",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "mood",
        "cognitive",
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnesium",
        "glycinate",
        "1500mg",
        "ksm",
        "ashwagandha",
        "turmeric",
        "2000mg",
        "vitamin",
        "caps",
        "relaxation",
        "stress",
        "vitality",
        "formula",
        "made",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 18.77,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976092930245",
      "vsf_explanation": "This 4-in-1 formula is manufactured by Prowise Healthcare in the UK under GMP conditions and combines genuinely well-evidenced ingredients: magnesium glycinate at a 300mg elemental dose within the commonly studied range, and KSM-66 ashwagandha, one of the most clinically researched ashwagandha extracts for stress and cortisol support. Turmeric extract and vitamin B6 round out the formula with reasonable supporting evidence. The main gap is that this product doesn't disclose contraindications for ashwagandha (thyroid conditions, pregnancy, autoimmune disease), which keeps the safety score from being higher despite the formula's overall solid ingredient quality.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "super-miraforte-with-standardized-lignans-120-capsules-life-extension",
      "title": "Super Miraforte with Standardized Lignans 120 Capsules | Life Extension",
      "vendor": "Life Extension",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_1_14e66dc9-8af9-4080-bbf2-d30fcef7ea84.webp?v=1789915758",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "super",
        "miraforte",
        "with",
        "standardized",
        "lignans",
        "120",
        "capsules",
        "life",
        "extension",
        "life",
        "extension"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 55,
        "manufacturing": 85,
        "safety": 65,
        "transparency": 72,
        "sustainability": 52
      },
      "price": 46.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976092995781",
      "vsf_explanation": "Life Extension manufactures this formula under established cGMP standards with full ingredient disclosure, which supports strong manufacturing and transparency scores. However, the evidence behind the core claim — supporting 'healthy free testosterone levels' via chrysin, nettle root lignans, muira puama, and maca — is weak; chrysin has poor oral bioavailability with little human evidence for raising testosterone, and nettle root's lignan mechanism is plausible but thinly supported by rigorous human trials. This is a case where strong brand-level manufacturing credibility is offset by a genuinely unproven efficacy claim.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "blessed-thistle-extract-900mg-highest-potency-200-capsules-cnicus-benedictus",
      "title": "Blessed Thistle Extract 900mg | Highest Potency | 200 Capsules | Cnicus benedictus",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/13934BlessedThistle200caps_6959b879-ce72-4fff-8f23-be10741ee217_1024x1024_2x_1.jpg?v=1789915757",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "blessed",
        "thistle",
        "extract",
        "900mg",
        "highest",
        "potency",
        "200",
        "capsules",
        "cnicus",
        "benedictus",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 55,
        "manufacturing": 15,
        "safety": 55,
        "transparency": 25,
        "sustainability": 50
      },
      "price": 14.44,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976092963013",
      "vsf_explanation": "Blessed thistle (Cnicus benedictus) is a traditional European herbal remedy for digestion and lactation support, but modern clinical trial evidence for either use is very limited — most support comes from historical use rather than controlled human studies. No manufacturer is identified on this listing, so GMP compliance and testing can't be verified. The product does include a caution notice, which is a modest positive, but overall this lands solidly in the Rejected tier on weak evidence and unverifiable manufacturing.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "life-extension-vinpocetine-10mg-100-tablets-memory-cognition-cerebral-circulation-support",
      "title": "Life Extension Vinpocetine 10mg | 100 Tablets | Memory, Cognition & Cerebral Circulation Support",
      "vendor": "Life Extension",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/LEXvinpo.jpg?v=1789915758",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "life",
        "extension",
        "vinpocetine",
        "10mg",
        "100",
        "tablets",
        "memory",
        "cognition",
        "cerebral",
        "circulation",
        "support",
        "life",
        "extension"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 65,
        "manufacturing": 85,
        "safety": 11,
        "transparency": 60,
        "sustainability": 52
      },
      "price": 15.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976093028549",
      "vsf_explanation": "Life Extension manufactures this product under solid cGMP standards, supporting a strong manufacturing score. However, vinpocetine carries a documented FDA safety concern: the agency has flagged animal data suggesting a risk of miscarriage and reduced fetal growth, and has moved toward excluding it from the dietary supplement category — yet this listing discloses no pregnancy or reproductive-risk caution whatsoever. Given the seriousness and complete absence of that disclosure, this product is flagged as a safety concern and rejected despite reasonable manufacturing credibility and decades-old (though dated) evidence for cognitive/cerebral circulation support.",
      "vsf_autofail_rule": "safety_concern"
    },
    {
      "handle": "life-extension-standardized-cistanche-30-capsules-22-echinacosides",
      "title": "Life Extension Standardized Cistanche 30 Capsules | 22% Echinacosides",
      "vendor": "Life Extension",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_1_0cdf70af-dc3f-438e-a6a7-c6e93d68b2cc.webp?v=1789915758",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "life",
        "extension",
        "standardized",
        "cistanche",
        "capsules",
        "echinacosides",
        "life",
        "extension"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 50,
        "manufacturing": 85,
        "safety": 70,
        "transparency": 72,
        "sustainability": 52
      },
      "price": 15,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976093061317",
      "vsf_explanation": "Life Extension's standardized Cistanche tubulosa extract benefits from strong manufacturing and transparency thanks to the brand's established cGMP practices and full-disclosure labeling, including standardization to 22% echinacosides. However, human clinical evidence for cistanche's immune, blood pressure, and longevity claims is thin — most support comes from traditional Chinese medicine use and animal/mechanistic research rather than rigorous human RCTs. The modest 210mg dose is also considerably lower than doses used in most traditional preparations, raising some question about whether it's therapeutically meaningful.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "prostate-defend-complex-saw-palmetto-pygeum-nettle-beta-sitosterol-lycopene-60-caps",
      "title": "Prostate Defend Complex | Saw Palmetto, Pygeum, Nettle, Beta-Sitosterol & Lycopene | 60 Caps",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/s-l1600_1_70eb4ea7-cebe-476d-97c3-4f66d832c15b.webp?v=1789915757",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "prostate",
        "defend",
        "complex",
        "saw",
        "palmetto",
        "pygeum",
        "nettle",
        "beta",
        "sitosterol",
        "lycopene",
        "caps",
        "nutrimentboutique"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 20,
        "manufacturing": 15,
        "safety": 45,
        "transparency": 10,
        "sustainability": 50
      },
      "price": 16.55,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46976093094085",
      "vsf_explanation": "This 5-ingredient prostate formula (saw palmetto, pygeum, nettle, beta-sitosterol, lycopene) doesn't disclose individual ingredient amounts anywhere on the product page, directing customers instead to 'see supplement facts panel' — a proprietary-blend-style transparency failure that makes it impossible to confirm any single ingredient is present at a clinically studied dose. The underlying evidence for the ingredients individually is mixed, with saw palmetto's benefit for BPH symptoms notably unproven in large modern trials while beta-sitosterol has more consistent support. No manufacturer is named, compounding the transparency problem.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "life-extension-bio-fisetin-cellular-health-cognition-longevity-30-vegetarian-capsules",
      "title": "Life Extension Bio-Fisetin | Cellular Health, Cognition & Longevity | 30 Vegetarian Capsules",
      "vendor": "Life Extension",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/57_708c0c28-ce54-43f7-ba1e-2ff7262eacec.jpg?v=1789931936",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "life",
        "extension",
        "bio",
        "fisetin",
        "cellular",
        "health",
        "cognition",
        "longevity",
        "vegetarian",
        "capsules",
        "life",
        "extension"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 50,
        "manufacturing": 82,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 11.25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46977977417925",
      "vsf_explanation": "Fisetin has genuine, if early-stage, senolytic research, and this listing discloses the actual milligram amount (8mg) despite labeling it a 'Proprietary Blend' — a partial-disclosure case, not a hidden dose, though about half the blend's weight remains unnamed and the 8mg fisetin dose is well below amounts used in most human senolytic research.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "optimized-resveratrol-elite™-60-veggie-caps-trans-resveratrol-250mg-quercetin-fisetin-longevity-antioxidant-support-life-extension",
      "title": "Optimized Resveratrol Elite™ – 60 Veggie Caps | Trans-Resveratrol 250mg + Quercetin + Fisetin | Longevity & Antioxidant Support | Life Extension",
      "vendor": "Life Extension",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/57_61fe152c-05b0-4a6a-8360-efd9c79d954e.png?v=1789931947",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "optimized",
        "resveratrol",
        "elite",
        "veggie",
        "caps",
        "trans",
        "resveratrol",
        "250mg",
        "quercetin",
        "fisetin",
        "longevity",
        "antioxidant",
        "support",
        "life",
        "extension",
        "life",
        "extension"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 80,
        "manufacturing": 82,
        "safety": 55,
        "transparency": 75,
        "sustainability": 50
      },
      "price": 27,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46977977450693",
      "vsf_explanation": "A cleanly disclosed, full supplement-facts formula combining trans-resveratrol, quercetin, and fisetin at specific milligram amounts, all ingredients with genuine (if still-developing) published longevity and antioxidant research.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "life-extension-geroprotect-autophagy-renew-longevity-ampk-cellular-energy-30caps",
      "title": "Life Extension Geroprotect Autophagy Renew Longevity AMPK cellular energy 30caps",
      "vendor": "Life Extension",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/57_ecd684f9-d846-4840-a672-8b8ca56d032d.jpg?v=1789931952",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "life",
        "extension",
        "geroprotect",
        "autophagy",
        "renew",
        "longevity",
        "ampk",
        "cellular",
        "energy",
        "30caps",
        "life",
        "extension"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 25,
        "manufacturing": 82,
        "safety": 50,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 19.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46977977516229",
      "vsf_explanation": "Names two real, specific compounds (luteolin and piperlongumine) tied to early-stage autophagy research, but discloses no milligram amounts for either — a significant gap for a product built around a still-emerging area of longevity science.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "resveratrol-600mg-cellular-health-longevity-support",
      "title": "Resveratrol 600mg | Cellular Health & Longevity Support",
      "vendor": "Halea Life: Nutrition & Skincare",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1776257830144-generated-label-image-0.jpg?v=1789931991",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "resveratrol",
        "600mg",
        "cellular",
        "health",
        "longevity",
        "support",
        "halea",
        "life",
        "nutrition",
        "skincare"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 90,
        "manufacturing": 0,
        "safety": 80,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 16.96,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/46977979482309",
      "vsf_explanation": "Halea Life discloses a precise, standardized dose (600mg extract standardized to 50% trans-resveratrol, delivering 300mg of active trans-resveratrol) — specificity most competing resveratrol products skip — and proactively warns about the real interaction with blood-thinning medications. It's the most transparent listing in this batch, though it still discloses no third-party testing, GMP certification, or manufacturing details.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "qunol-mega-ubiquinol-100-mg-60-softgels",
      "title": "Qunol Mega Ubiquinol 100 Mg, 60 Softgels",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/241103792_b88cc917-6424-4b93-bbe7-d53f468d6fbd.jpg?v=1790529558",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "qunol",
        "mega",
        "ubiquinol",
        "100",
        "softgels",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 70,
        "manufacturing": 65,
        "safety": 55,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 29.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575021834437",
      "vsf_explanation": "Ubiquinol, the reduced/active form of CoQ10, has independently published research showing better absorption than standard ubiquinone, and this listing clearly discloses both the form and the 100mg dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "qunol-extra-strength-magnesium-citrate-gummies-200mg-per-serving-60-count-high-absorption-delicious-chewable-supplement",
      "title": "Qunol Extra Strength Magnesium Citrate Gummies, 200mg per Serving, 60 Count - High Absorption, Delicious Chewable Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/217550146.jpg?v=1790529563",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "qunol",
        "extra",
        "strength",
        "magnesium",
        "citrate",
        "gummies",
        "200mg",
        "per",
        "serving",
        "count",
        "high",
        "absorption",
        "delicious",
        "chewable",
        "supplement",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 65,
        "safety": 50,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 13.69,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575021998277",
      "vsf_explanation": "Unlike Qunol's magnesium capsule, this gummy clearly names magnesium citrate as the compound used, which is a well-established, better-absorbed form than magnesium oxide — a genuinely disclosed and defensible formulation choice.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "qunol-magnesium-extra-strength-420-mg-capsules",
      "title": "Qunol Magnesium, Extra Strength, 420 Mg, Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/353706765.jpg?v=1790529569",
      "score": 47,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "qunol",
        "magnesium",
        "extra",
        "strength",
        "420",
        "capsules",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 35,
        "manufacturing": 65,
        "safety": 50,
        "transparency": 35,
        "sustainability": 50
      },
      "price": 17.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575022129349",
      "vsf_explanation": "This listing claims superior absorption 'compared to standard magnesium oxide' but never discloses which magnesium compound is actually used, making it impossible to verify the absorption claim or evaluate the formulation honestly.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "qunol-ultra-coq10-100mg-softgels-3x-better-absorption-coenzyme-q10-supplements-antioxidant-supplement-for-vascular-and-heart-health-energy-production",
      "title": "Qunol Ultra CoQ10 100mg Softgels- 3X Better Absorption Coenzyme Q10 Supplements - Antioxidant Supplement for Vascular and Heart Health & Energy Production",
      "vendor": "Shahmori",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71xvaRje3hL_10a58f8d-9432-430c-9879-5d1a9936d7f7.jpg?v=1790529578",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "qunol",
        "ultra",
        "coq10",
        "100mg",
        "softgels",
        "better",
        "absorption",
        "coenzyme",
        "q10",
        "supplements",
        "antioxidant",
        "supplement",
        "for",
        "vascular",
        "and",
        "heart",
        "health",
        "energy",
        "production",
        "shahmori"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 75,
        "manufacturing": 65,
        "safety": 55,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575023112389",
      "vsf_explanation": "CoQ10 is well-studied for heart health and replenishing levels depleted by statin use, and this is Qunol's flagship, most well-documented solubilization technology, with a clearly disclosed 100mg dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "qunol-extra-strength-turmeric-1000mg-capsules",
      "title": "Qunol Extra Strength Turmeric 1000mg Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/302717228.jpg?v=1790529670",
      "score": 53,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "qunol",
        "extra",
        "strength",
        "turmeric",
        "1000mg",
        "capsules",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 65,
        "safety": 50,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 26.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575027798213",
      "vsf_explanation": "Turmeric/curcumin is a well-studied anti-inflammatory ingredient and Qunol's water-dispersion absorption technology is a real, patented approach, but this listing labels the product a 1000mg 'Complex' without disclosing what percentage is actual curcuminoid content, making the effective dose impossible to verify.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "tabvitamins-pqq-20-mg-dietary-supplement-30-capsules",
      "title": "Tabvitamins PQQ 20 mg Dietary Supplement 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/tabvitamins-pqq-pirolokinolin-kinon-20-mg-30-kapsul-84528-38-B.jpg?v=1790529708",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tabvitamins",
        "pqq",
        "dietary",
        "supplement",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 85,
        "manufacturing": 0,
        "safety": 45,
        "transparency": 35,
        "sustainability": 50
      },
      "price": 28.27,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575030485189",
      "vsf_explanation": "Tabvitamins sells a single, cleanly disclosed ingredient (20mg PQQ) at a dose matching the small number of available human studies, but PQQ's evidence base remains preliminary, and there is no manufacturing or company information disclosed anywhere in the listing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liveyourself-pqq-coenzyme-q10-dietary-supplement-30-capsules",
      "title": "LiveYourself PQQ Coenzyme Q10 Dietary Supplement 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/liveyourself-pqq-coenzyme-q10-takviye-edici-gida-30-kapsul-liveyourself-162855-72-B.jpg?v=1790529710",
      "score": 47,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liveyourself",
        "pqq",
        "coenzyme",
        "q10",
        "dietary",
        "supplement",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 80,
        "manufacturing": 0,
        "safety": 50,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 48.02,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575030517957",
      "vsf_explanation": "LiveYourself discloses real, specific doses for both actives (100mg CoQ10, 20mg PQQ) that align with amounts used in available human research, a genuine positive, but the listing provides no manufacturing, testing, or company-identity information at all, so it can't be verified as anything beyond an unverified marketplace listing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "berline-ilac-inferline-men-nmn-pqq-supplement-30-sachets",
      "title": "Berline Ilac Inferline Men NMN & PQQ Supplement 30 Sachets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/inferline-men-30-sase-20350.jpg?v=1790529717",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "berline",
        "ilac",
        "inferline",
        "men",
        "nmn",
        "pqq",
        "supplement",
        "sachets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 0,
        "transparency": 0,
        "sustainability": 0
      },
      "price": 121.05,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575031730373",
      "vsf_explanation": "Berline Ilac names NMN and PQQ but discloses no doses for either, and rounds out the formula with vague, unnamed 'plant extracts' and 'vitamins and minerals' — this is among the least transparent listings in the batch.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "validus-nmn-50mg-mumiyo-200mg-pqq-20mg-complex-30-capsules",
      "title": "Validus NMN 50mg + Mumiyo 200mg + PQQ 20mg Complex 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/validus-nmn-50-mg-mumiyo-200-mg-pqq-20-mg-30-kapsul-5.webp?v=1790529723",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "validus",
        "nmn",
        "50mg",
        "mumiyo",
        "200mg",
        "pqq",
        "20mg",
        "complex",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 0,
        "transparency": 0,
        "sustainability": 0
      },
      "price": 30.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575031763141",
      "vsf_explanation": "Validus is unusual for actually stating exact doses (NMN 50mg, Mumiyo 200mg, PQQ 20mg) in the title, but the headline ingredient, NMN, is dosed far below the amounts used in available human research (typically 250mg+), making the 'precise dosage' marketing misleading about likely efficacy.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "bioremedy-arn-synaptica-citicoline-pqq-complex-90-capsules",
      "title": "Bioremedy ARN Synaptica Citicoline & PQQ Complex 90 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/arn-synaptica-sitikolin-huperzin-a-pqq-90-kapsul-23582.jpg?v=1790529728",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bioremedy",
        "arn",
        "synaptica",
        "citicoline",
        "pqq",
        "complex",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 0,
        "transparency": 0,
        "sustainability": 0
      },
      "price": 87.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575031795909",
      "vsf_explanation": "Bioremedy combines seven different actives (citicoline, PQQ, Lion's Mane, Korean ginseng, B-vitamins, phosphatidylserine, alpha lipoic acid) with zero dosing disclosed for any of them — a maximal blend that hides its real composition.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "barbaris-7-oxi-advanced-antioxidant-supplement-30-capsules",
      "title": "Barbaris 7 Oxi Advanced Antioxidant Supplement 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/barbaris-7-oxi-advanced-30-kapsul-39953-86401-39-B.jpg?v=1790529737",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "barbaris",
        "oxi",
        "advanced",
        "antioxidant",
        "supplement",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 0,
        "transparency": 0,
        "sustainability": 0
      },
      "price": 10.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575037432005",
      "vsf_explanation": "Barbaris 7 combines SOD, resveratrol, and an orange extract without disclosing a single milligram amount for any of them, hiding the actual composition behind vague blend language.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "dietary-supplement-19",
      "title": "Dietary Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/11a73de3-1b45-4a1f-b407-b3f2539cf717_c6914c4e-7f22-48c7-bda9-165e2dc64d4a.jpg?v=1790529742",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dietary",
        "supplement",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 0,
        "transparency": 0,
        "sustainability": 0
      },
      "price": 15.51,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575037497541",
      "vsf_explanation": "This listing's title is literally 'Dietary Supplement' with no identifiable brand, despite combining six longevity-oriented ingredients (including the relatively well-studied Urolithin A) with zero dosing disclosed for any of them — the lack of any brand identity is itself a transparency failure regardless of the ingredient list's potential.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "dietary-supplement-20",
      "title": "Dietary Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/873b1999-d553-4e39-9005-d9b826cf64df.jpg?v=1790529749",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dietary",
        "supplement",
        "vivalo"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 0,
        "transparency": 0,
        "sustainability": 0
      },
      "price": 24.9,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575037530309",
      "vsf_explanation": "This listing's title is literally 'Dietary Supplement' with no brand or product identity anywhere, even though creatine and taurine are well-studied ingredients — with no company standing behind it and no doses disclosed, there's no way to hold anyone accountable for what's actually inside.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "swiss-bork-magnesium-l-threonate-focus-supplement-90-capsules",
      "title": "Swiss Bork Magnesium L-Threonate Focus Supplement 90 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/swiss-bork-magnesium-l-theronat-focus-30-kapsul-13071.jpg?v=1790529773",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "swiss",
        "bork",
        "magnesium",
        "threonate",
        "focus",
        "supplement",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 0,
        "transparency": 0,
        "sustainability": 0
      },
      "price": 32.43,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575039267013",
      "vsf_explanation": "Swiss Bork's flagship ingredient, magnesium L-threonate, is listed with no dose at all, alongside undosed citicoline and PQQ, and the listing doesn't even specify a serving size — there's no way to assess whether this delivers a meaningful amount of anything.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "vitaberg-nadh-antioxidant-support-with-coq10-resveratrol-30-capsules",
      "title": "Vitaberg NADH Antioxidant+ Support with CoQ10 & Resveratrol, 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/vitabeg-nadh-antioksidan-30-kapsul-vitaberg-219187-89-B.jpg?v=1790529797",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy",
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitaberg",
        "nadh",
        "antioxidant",
        "support",
        "with",
        "coq10",
        "resveratrol",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 0,
        "transparency": 0,
        "sustainability": 0
      },
      "price": 85.46,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575040970949",
      "vsf_explanation": "Vitaberg names four headline actives (NADH, PQQ, CoQ10, resveratrol) but discloses a dose only for a minor filler ingredient (bromelain) — the actual active amounts are completely hidden, which we can't credit regardless of the ingredients' individual merit.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "referans-nutra-quatronad-energy-support-sublingual-30-tablets",
      "title": "Referans Nutra QuatroNAD Energy Support Sublingual 30 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/referans-nutra-quatronad-takviye-edici-gida-30-dilalti-tablet-referans-nutra-216359-89-B.jpg?v=1790529808",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "referans",
        "nutra",
        "quatronad",
        "energy",
        "support",
        "sublingual",
        "tablets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 0,
        "transparency": 0,
        "sustainability": 0
      },
      "price": 114,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575041003717",
      "vsf_explanation": "Referans Nutra markets this as a 'blend of four components' built around NADH and CoQ10 but discloses zero milligram amounts for either — there's no way to know if the doses are meaningful, which is the proprietary-blend dose-hiding our standards reject outright.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "life-extension-nad-cell-regenerator-300-mg-energy-support-30-caps",
      "title": "Life Extension NAD+ Cell Regenerator 300 mg Energy Support 30 Caps",
      "vendor": "Life Extension",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/life-extension-nad-cell-regenerator-300-mg-30-vegetarian-capsules-ithal.webp?v=1790529921",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "life",
        "extension",
        "nad",
        "cell",
        "regenerator",
        "300",
        "energy",
        "support",
        "caps",
        "life",
        "extension"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 80,
        "manufacturing": 82,
        "safety": 55,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 234.98,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575047131333",
      "vsf_explanation": "A clean, single-ingredient nicotinamide riboside formula at a clearly disclosed 300 mg dose, which sits within the range used in published human NAD+-boosting research.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "life-extension-neuro-mag-magnesium-l-threonate-supplement-90-capsules",
      "title": "Life Extension Neuro-Mag Magnesium L-Threonate Supplement 90 Capsules",
      "vendor": "Life Extension",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/life-extension-neuro-mag-magnesium-l-threonate-90-vegetarian-capsules-ithal-1.webp?v=1790529924",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "life",
        "extension",
        "neuro",
        "mag",
        "magnesium",
        "threonate",
        "supplement",
        "capsules",
        "life",
        "extension"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 55,
        "manufacturing": 82,
        "safety": 55,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 181.04,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575047164101",
      "vsf_explanation": "Uses the patented Magtein form of magnesium L-threonate, which has real published research on brain magnesium levels and cognitive support, but this listing does not disclose the actual elemental magnesium amount per serving.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "doctors-best-vitamin-d3-2000iu-supports-bone-teeth-heart-health",
      "title": "DOCTOR'S BEST: Vitamin D3 2000Iu - Supports Bone, Teeth & Heart Health",
      "vendor": "Doctor's Best",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/753950002104_C1N1.jpg?v=1790530008",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "doctor",
        "best",
        "vitamin",
        "2000iu",
        "supports",
        "bone",
        "teeth",
        "heart",
        "health",
        "doctor",
        "best"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 75,
        "manufacturing": 55,
        "safety": 45,
        "transparency": 30,
        "sustainability": 50
      },
      "price": 9.34,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575051555013",
      "vsf_explanation": "A well-dosed, single-ingredient 2000 IU vitamin D3 within the range supported by published research, but the listing relies heavily on hyperbolic marketing language rather than concrete disclosure, which limits how much we can credit for transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mnk-dietary-supplement-vitamin-d3-1000-iu-softgels-120-count",
      "title": "Mnk Dietary Supplement Vitamin D3 1000 IU Softgels 120 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/mnk-vitamin-d3-120-softgel-7427.jpg?v=1790530013",
      "score": 49,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mnk",
        "dietary",
        "supplement",
        "vitamin",
        "1000",
        "softgels",
        "120",
        "count",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 85,
        "manufacturing": 0,
        "safety": 55,
        "transparency": 20,
        "sustainability": 50
      },
      "price": 36.54,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575051587781",
      "vsf_explanation": "Mnk's Vitamin D3 softgel discloses a single, clearly-dosed ingredient (1000 IU) within the well-studied maintenance range, but the listing provides no manufacturing certifications, testing, or company information of any kind, so how or where it's made can't be verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "leader-vitamin-d3-400-iu-tablets",
      "title": "Leader Vitamin D3, 400 IU, Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/96707946.jpg?v=1790530018",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "leader",
        "vitamin",
        "400",
        "tablets",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 70,
        "manufacturing": 45,
        "safety": 80,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 3.19,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575053848773",
      "vsf_explanation": "A straightforward, honestly-labeled single-ingredient Vitamin D3 tablet at a basic maintenance dose, with clear FDA disclaimer and allergen disclosure, from a store-brand manufacturer with no elevated third-party certification disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nature-made-immune-max-tangerine-3-in-1-blend-gummies",
      "title": "Nature Made Immune Max, Tangerine, 3 In 1 Blend, Gummies",
      "vendor": "Nature Made",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/187808690.jpg?v=1790530025",
      "score": 39,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "made",
        "immune",
        "max",
        "tangerine",
        "blend",
        "gummies",
        "nature",
        "made"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 15,
        "manufacturing": 82,
        "safety": 45,
        "transparency": 20,
        "sustainability": 50
      },
      "price": 16.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575053881541",
      "vsf_explanation": "This specific listing does not disclose an ingredient list or dosing for the '3-in-1' blend, so we can't verify what's actually in it or at what amount, even though Nature Made is a well-known, USP Verified manufacturer overall.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ultra-testosterone",
      "title": "Ultra Testosterone",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_66c79526-f225-43a6-93fb-3086c8570d5a.png?v=1790530051",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "ultra",
        "testosterone",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 60,
        "safety": 0,
        "transparency": 0,
        "sustainability": 50
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575054143685",
      "vsf_explanation": "The name 'Ultra Testosterone' strongly implies a substantial testosterone-elevating effect, but zero ingredients are disclosed anywhere — just 'a premium blend of vitamins, minerals, and traditional botanicals.' Naming a fully undisclosed formula 'Ultra Testosterone' sets an expectation the product cannot substantiate.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "white-kidney-bean-1",
      "title": "White Kidney Bean",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_7d7ea6d8-3b04-4e38-88dc-051a38c6940c.png?v=1790530119",
      "score": 53,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "white",
        "kidney",
        "bean",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 45,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575058370757",
      "vsf_explanation": "White kidney bean (Phaseolus vulgaris) extract is a single, clearly named ingredient marketed as a carb-blocker, but the human clinical evidence is mixed and modest, and efficacy depends on standardized alpha-amylase inhibitor content, which isn't disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pct-mens-hormonal-support",
      "title": "PCT - Men's Hormonal Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_4febaf69-c27a-4bdf-b432-0a3270767015.png?v=1790530124",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "pct",
        "men",
        "hormonal",
        "support",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 60,
        "safety": 0,
        "transparency": 0,
        "sustainability": 50
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575058534597",
      "vsf_explanation": "No specific vitamins, minerals, or botanicals are named despite the copy referencing all three categories — this is a completely undisclosed formula. The 'PCT' (post-cycle therapy) branding also implies hormonal-recovery effects from anabolic steroid use that nothing here substantiates.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "l-arginine-2",
      "title": "L-Arginine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_8593cd0c-6d12-478f-8e92-d487d1d098fa.png?v=1790530124",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "arginine",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 45,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575058567365",
      "vsf_explanation": "L-arginine is a single, clearly named ingredient with a reasonably well-studied evidence base for nitric-oxide/circulatory support. However, no per-serving dose is disclosed, and arginine's studied effective range (typically several grams/day) is dose-dependent, so we can't confirm this product meets it.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "berberine-5",
      "title": "Berberine",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_51b24b4b-175a-4c8f-b6b9-0f05cb9caf81.png?v=1790530125",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "berberine",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 45,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575058698437",
      "vsf_explanation": "Berberine is a single, clearly named ingredient with a comparatively strong clinical evidence base for glucose metabolism support — among the better-evidenced ingredients in this batch. No per-serving dose is disclosed though, and berberine's effects/tolerability are notably dose-dependent.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "prostate-support-1",
      "title": "Prostate Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_1809faf3-6076-46fa-90eb-28c6604c2d61.png?v=1790530125",
      "score": 21,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "prostate",
        "support",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 60,
        "safety": 35,
        "transparency": 0,
        "sustainability": 50
      },
      "price": 7.36,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575058600133",
      "vsf_explanation": "LISTING DATA QUALITY ISSUE: this product's live body copy is a copy-paste error that duplicates an unrelated 'Nighttime Fat Burn' description rather than describing prostate support at all. Treated as having no real product description whatsoever.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "healthy-glucose-support",
      "title": "Healthy Glucose Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_c348b70d-eb41-44b9-b666-ad1ed6e76412.png?v=1790530125",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "healthy",
        "glucose",
        "support",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 60,
        "safety": 0,
        "transparency": 0,
        "sustainability": 50
      },
      "price": 7.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575058862277",
      "vsf_explanation": "No specific vitamins, minerals, or botanicals are named — just a 'thoughtfully selected blend.' The 'already within normal ranges' language appropriately avoids a disease claim, but a completely undisclosed formula for a glucose-metabolism product means customers can't evaluate ingredient identity, dose, or safety at all.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "womens-probiotic-50-billion-cfu",
      "title": "Women's Probiotic - 50 Billion CFU",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_31c3955a-41dd-4a8a-9641-2e37882023cf.png?v=1790530125",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "women",
        "probiotic",
        "billion",
        "cfu",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 7.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575058796741",
      "vsf_explanation": "Discloses a real CFU count (50 billion), a meaningful and verifiable dose metric, but no specific probiotic strains are named — and strain identity is what most clinical evidence is actually tied to.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "myo-d-chiro-inositol-plus-womens-hormonal-support",
      "title": "Myo & D-Chiro Inositol Plus - Women's Hormonal Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_958885d2-0975-489a-889d-7e1c6be1a2da.png?v=1790530125",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "myo",
        "chiro",
        "inositol",
        "plus",
        "women",
        "hormonal",
        "support",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 8.18,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575059058885",
      "vsf_explanation": "Names both actives (myo-inositol and D-chiro-inositol) and specifically flags a 'balanced ratio' between them, which is the clinically relevant variable for this combination. However, the actual ratio and per-serving doses aren't disclosed, so we can't confirm this formula matches the evidence base.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "men-s-daily-multivitamin",
      "title": "Men’s Daily Multivitamin",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_873c7af1-91a2-4d1b-b063-46124b27c6f2.png?v=1790530124",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "men",
        "daily",
        "multivitamin",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 25,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 35,
        "sustainability": 50
      },
      "price": 6.58,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575058960581",
      "vsf_explanation": "No specific vitamins, minerals, or amounts are disclosed anywhere — just 'essential vitamins, minerals, and antioxidants.' Multivitamins are a well-understood category, so this isn't treated as a hidden blend, but without a visible facts panel we can't confirm what's actually in it.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "raspberry-ketones",
      "title": "Raspberry Ketones",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_3bd0daa4-cedf-4736-8674-f0ed91cbec41.png?v=1790530125",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "raspberry",
        "ketones",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 30,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 7.88,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575059124421",
      "vsf_explanation": "Raspberry ketones lack solid human clinical evidence for weight-loss efficacy — most support comes from animal or in-vitro studies at doses far exceeding typical supplemental amounts. The body copy is also vaguer than the title suggests.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mushroom-complex",
      "title": "Mushroom Complex",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_2e4490f0-d2d1-4e23-937c-f2d3771a6869.png?v=1790530125",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mushroom",
        "complex",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 60,
        "safety": 0,
        "transparency": 0,
        "sustainability": 50
      },
      "price": 7.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575059189957",
      "vsf_explanation": "Functional mushrooms (e.g. lion's mane, reishi, cordyceps) have real individual evidence bases for immune and cognitive support, but zero species are actually named here — just 'a powerful blend of functional mushrooms.'",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "colon-sweep-1",
      "title": "Colon Sweep",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_8070dac1-ad34-430a-a3cc-e0b778add083.png?v=1790530125",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "colon",
        "sweep",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 60,
        "safety": 0,
        "transparency": 0,
        "sustainability": 50
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575059321029",
      "vsf_explanation": "No specific fiber sources or 'traditional digestive-support ingredients' are actually named — the copy describes a category, not a formula. A completely undisclosed ingredient list for a digestive/laxative-adjacent product is an auto-fail.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "shilajit-vitality-support",
      "title": "Shilajit - Vitality Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_288f80ec-30d6-43d9-92b9-53f0440a930d.png?v=1790530125",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shilajit",
        "vitality",
        "support",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 45,
        "manufacturing": 60,
        "safety": 62,
        "transparency": 68,
        "sustainability": 50
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575059353797",
      "vsf_explanation": "Shilajit is a single, clearly named ingredient with an emerging but still limited clinical evidence base. No dose is disclosed, and unpurified shilajit has known heavy-metal contamination risk industry-wide — without independent purity testing disclosed, that risk can't be ruled out here.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "immune-support",
      "title": "Immune Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_2bbe9ceb-8019-4409-9737-572a4a9c8d0c.png?v=1790530128",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "immune",
        "support",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 35,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 6.28,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575060500677",
      "vsf_explanation": "Vitamin C, Zinc, and Elderberry are all named and each has a reasonable human evidence base for immune support, but no doses are disclosed for any of them, and an additional undisclosed 'herbal blend' is appended that undercuts full transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "digestive-enzymes-3",
      "title": "Digestive Enzymes",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_aa2e3f93-ee12-4610-a69f-4e5ed5647a7d.png?v=1790530126",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "digestive",
        "enzymes",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 60,
        "safety": 40,
        "transparency": 15,
        "sustainability": 50
      },
      "price": 7.03,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575059452101",
      "vsf_explanation": "Described only as a 'comprehensive enzyme blend' with no specific enzymes (e.g., protease, amylase, lipase) or activity units (HUT/DU/FCCPU) named — this is functionally identical to the other hidden-dose blend products in this batch, so it's treated the same way.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "nighttime-fat-burn",
      "title": "Nighttime Fat Burn",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_56ecc1db-faec-48a4-9d70-2c86c2d7ac36.png?v=1790530127",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nighttime",
        "fat",
        "burn",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 60,
        "safety": 40,
        "transparency": 15,
        "sustainability": 50
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575059550405",
      "vsf_explanation": "Described only as 'metabolism-supporting nutrients with calming ingredients' — no ingredients or doses named, so neither the weight-management claims nor the bedtime-safety profile can be evaluated.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "resveratrol-5",
      "title": "Resveratrol",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_8c877ef6-92d7-4801-ad0e-6ed81a5205d0.png?v=1790530127",
      "score": 49,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "resveratrol",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 30,
        "manufacturing": 60,
        "safety": 72,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 7.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575059615941",
      "vsf_explanation": "Resveratrol is a single, clearly named ingredient, but human RCT evidence for its benefits is mixed and heavily limited by poor natural bioavailability, and no dose or purity/standardization is disclosed to confirm this product delivers a meaningful amount.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ginseng-ginkgo",
      "title": "Ginseng + Ginkgo",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_ae1e69d5-fb5f-4194-8c80-8be95261e286.png?v=1790530127",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive",
        "energy",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ginseng",
        "ginkgo",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 25,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 6.54,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575059714245",
      "vsf_explanation": "Both Ginkgo biloba and ginseng have real human research for cognitive/energy support, but the listing doesn't specify the ginseng species, standardization, or individual doses of either ingredient, and Ginkgo's known interaction risk with blood thinners is not addressed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sleep-formula-3",
      "title": "Sleep Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_e2b2d999-15ed-4d5c-a14b-c01de059226b.png?v=1790530127",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sleep",
        "formula",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 60,
        "safety": 40,
        "transparency": 15,
        "sustainability": 50
      },
      "price": 6.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575059910853",
      "vsf_explanation": "Described only as 'a calming blend of natural ingredients' — no melatonin, magnesium, valerian, GABA, or any other specific sleep-support ingredient is named, so nothing here can be evaluated.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "beet-root-capsules",
      "title": "Beet Root Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/output.png?v=1790530127",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beet",
        "root",
        "capsules",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 30,
        "manufacturing": 60,
        "safety": 78,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 6.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575059812549",
      "vsf_explanation": "Beetroot's cardiovascular/exercise benefits in research are driven by its nitrate content, which varies widely and is not disclosed here — whole beet root powder typically delivers far less nitrate than the concentrated juice/extracts used in most studies.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "liver-support-4",
      "title": "Liver Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_b7954b11-b971-45fc-8d87-bf1fb6a8731b.png?v=1790530127",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liver",
        "support",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 60,
        "safety": 40,
        "transparency": 15,
        "sustainability": 50
      },
      "price": 6.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575060009157",
      "vsf_explanation": "Described only as 'a comprehensive blend of traditional herbs and botanicals' — no ingredients like milk thistle, dandelion, or artichoke are named, so nothing can be verified for evidence or liver-relevant safety.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "max-detox-complete",
      "title": "Max Detox Complete",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_105d3e04-530a-4fc2-b961-d9adcd99ff80.png?v=1790530127",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "max",
        "detox",
        "complete",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 60,
        "safety": 40,
        "transparency": 15,
        "sustainability": 50
      },
      "price": 6.58,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575060107461",
      "vsf_explanation": "Described only as 'a carefully selected blend of herbs, botanicals, and antioxidants' — no ingredients are named, so 'detox' claims and safety can't be substantiated at all.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "elderberry-extract",
      "title": "Elderberry Extract",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/output_727089fa-d761-4b81-b9f7-37b827d8371c.png?v=1790530127",
      "score": 51,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "elderberry",
        "extract",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 35,
        "manufacturing": 60,
        "safety": 65,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575060205765",
      "vsf_explanation": "Elderberry (Sambucus nigra) has one of the better human evidence bases in this batch for reducing cold/flu duration, and the ingredient is clearly named — but no dose or standardization is disclosed, which matters since raw/underprocessed elderberry carries known toxicity concerns.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "probiotic-formula-40-billion-cfu",
      "title": "Probiotic Formula – 40 Billion CFU",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_90211e84-626a-4012-8f82-ecfed6a598e2.png?v=1790530127",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "probiotic",
        "formula",
        "billion",
        "cfu",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 62,
        "sustainability": 50
      },
      "price": 7.51,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575060271301",
      "vsf_explanation": "Discloses a real, meaningful dose metric (40 billion CFU per serving), which puts it well ahead of Kaya's vague-blend products, but the individual probiotic strains are never named, and strain identity is what most clinical evidence for gut/immune benefits is actually tied to.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "oxy-burn-thermogenic",
      "title": "Oxy Burn Thermogenic",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_df4ef2aa-8c18-4903-8839-ff7af5bd05b8.png?v=1790530127",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "oxy",
        "burn",
        "thermogenic",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 60,
        "safety": 0,
        "transparency": 0,
        "sustainability": 50
      },
      "price": 6.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575060369605",
      "vsf_explanation": "Not a single ingredient or amount is disclosed anywhere — just 'a carefully selected blend of thermogenic ingredients.' Thermogenics commonly rely on stimulant compounds where dose matters for safety, so a completely undisclosed formula in this category is an auto-fail regardless of the brand's general manufacturing practices.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "ceylon-cinnamon",
      "title": "Ceylon Cinnamon",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_38f48b73-a030-498e-8144-df579ba3a5c8.png?v=1790530129",
      "score": 53,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ceylon",
        "cinnamon",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 40,
        "manufacturing": 60,
        "safety": 75,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 6.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575060598981",
      "vsf_explanation": "True Ceylon cinnamon (vs. higher-coumarin Cassia) is a reasonable, well-tolerated choice for metabolic support, and it's named as a single clean ingredient — but no dose per serving is disclosed, and most human evidence for blood-sugar effects comes from Cassia cinnamon studies, not Ceylon specifically.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "apple-cider-vinegar-gummies",
      "title": "Apple Cider Vinegar Gummies",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_a0e24ab2-97ac-4322-8a96-ad5aece07d11.png?v=1790530129",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "apple",
        "cider",
        "vinegar",
        "gummies",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 55,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 75,
        "sustainability": 50
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575060795589",
      "vsf_explanation": "The most transparent listing in this batch — it names all five actives and discloses the ACV dose (1,000mg) — but ACV's own evidence for weight/blood-sugar benefits is modest, and B12/Folic Acid/pomegranate/beet juice doses aren't given.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "best-sellers-blend",
      "title": "Best Sellers Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_40d5134b-645a-4bd3-a380-c34362f75a4d.png?v=1790530129",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "best",
        "sellers",
        "blend",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 60,
        "safety": 40,
        "transparency": 15,
        "sustainability": 50
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575060828357",
      "vsf_explanation": "No individual ingredients are named — described only as 'some of our most popular wellness ingredients' — so there's no way to evaluate evidence, dose, or purpose. It's listed honestly, but rejected for hiding its composition.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "womens-skin-hydration",
      "title": "Women's Skin Hydration",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_14bd5ffe-3ba9-442e-a038-bd8aac8cc659.png?v=1790530131",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "women",
        "skin",
        "hydration",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 60,
        "safety": 0,
        "transparency": 0,
        "sustainability": 50
      },
      "price": 7.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575061090501",
      "vsf_explanation": "No ingredient is named — only 'beauty-supporting nutrients and antioxidants' — so there is nothing specific to evaluate for evidence, dose, or formulation quality.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "blood-sugar-support",
      "title": "Blood Sugar Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_49c05317-4548-4b7b-b213-afd5207f2a37.png?v=1790530132",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "blood",
        "sugar",
        "support",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 60,
        "safety": 0,
        "transparency": 0,
        "sustainability": 50
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575061156037",
      "vsf_explanation": "No ingredient is named — only 'vitamins, minerals, and botanicals' — which is especially concerning for a blood-sugar product, since people managing glucose (including on medication) need to know exactly what they're taking to avoid interaction or hypoglycemia risk.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "collagen-powder",
      "title": "Collagen Powder",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_8c33b270-e7b1-42aa-876d-5be24796b378.png?v=1790530132",
      "score": 51,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "collagen",
        "powder",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 35,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 34.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575061221573",
      "vsf_explanation": "Collagen peptides have a real (if modest) human evidence base for skin/joint support, but this listing doesn't disclose the collagen type, source, or dose per serving, so we can't confirm it matches the amounts used in studies showing benefit.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "best-energy-blend",
      "title": "Best Energy Blend",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_bfce4d67-fb93-47e4-aade-1e7bf46326ee.png?v=1790530132",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "best",
        "energy",
        "blend",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 60,
        "safety": 40,
        "transparency": 15,
        "sustainability": 50
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575061254341",
      "vsf_explanation": "This listing names no specific active ingredients or amounts — just 'vitamins, botanicals, and performance-supporting ingredients' — so there is nothing here to evaluate for evidence or dose, and it contradicts Kaya Naturals' own stated policy against proprietary blends. Still listed, but rejected.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "maca-root",
      "title": "Maca Root",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_eb1af484-7bc1-4cf8-9ba1-a5a85cf4381c.png?v=1790530133",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood",
        "energy",
        "hormone"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "maca",
        "root",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 25,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575061287109",
      "vsf_explanation": "Maca root has preliminary, mixed-quality human evidence for energy and vitality, largely resting on traditional use rather than strong RCTs, and the listing names the ingredient but discloses no dose or extract standardization.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "daily-multivitamin-gummies",
      "title": "Daily Multivitamin Gummies",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_7a436929-af65-4b2a-a108-5a2783d22d21.png?v=1790530134",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "daily",
        "multivitamin",
        "gummies",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 15,
        "manufacturing": 60,
        "safety": 50,
        "transparency": 22,
        "sustainability": 50
      },
      "price": 16.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575061352645",
      "vsf_explanation": "Multivitamins can be a reasonable nutritional gap-filler, but this listing names no specific vitamins or minerals and no amounts at all — gummy multivitamins in particular are known to sometimes under-dose fat-soluble vitamins, and there's no way to check that here.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nitric-blast-pre-workout-capsules",
      "title": "Nitric Blast - Pre-workout Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_bfb7c74a-9e1d-4f01-b4eb-4426ee6ed353.png?v=1790530134",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nitric",
        "blast",
        "pre",
        "workout",
        "capsules",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 60,
        "safety": 0,
        "transparency": 0,
        "sustainability": 50
      },
      "price": 6.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575061385413",
      "vsf_explanation": "No ingredient is named — only 'performance-focused ingredients' — which is a particularly serious gap for a pre-workout product, since this category commonly contains stimulants or nitrate compounds that customers need disclosed for safety and interaction reasons.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "menopause-support",
      "title": "Menopause Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_6e490186-3ddc-40ec-bd8a-498bfb4bb187.png?v=1790530134",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone"
      ],
      "sex_relevance": "female",
      "life_stage": "postmenopausal",
      "tokens": [
        "menopause",
        "support",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 60,
        "safety": 0,
        "transparency": 0,
        "sustainability": 50
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575061483717",
      "vsf_explanation": "No ingredient is named — only 'traditional botanicals, vitamins, and minerals' — which is especially concerning in a menopause/hormonal-support product, since common botanicals in this category (e.g., black cohosh) carry contraindications that customers can't check without knowing what's actually in the capsule.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "collagen-peptides-1",
      "title": "Collagen Peptides",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_f98fed5a-476f-4458-a302-2c18bd39ee72.png?v=1790530137",
      "score": 41,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "collagen",
        "peptides",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 18,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 32,
        "sustainability": 50
      },
      "price": 6.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575061582021",
      "vsf_explanation": "Hydrolyzed collagen has moderate evidence for skin and joint benefits, but the studies that show effects use specific doses of specific collagen types (typically 2.5-15g), and this listing blends 'five types from multiple sources' without disclosing the amount of any single type, so the effective-dose claim can't be verified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "quercetin-plus",
      "title": "Quercetin Plus",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_05fc7196-428b-430a-a701-06e21f276d71.png?v=1790530138",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "quercetin",
        "plus",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 15,
        "manufacturing": 60,
        "safety": 45,
        "transparency": 28,
        "sustainability": 50
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575061680325",
      "vsf_explanation": "Quercetin has only preliminary, mixed human evidence for immune or antioxidant benefits at typical consumer doses, and the product name itself signals an undisclosed additional ('Plus') ingredient that is never identified anywhere in the listing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "psyllium-husk",
      "title": "Psyllium Husk",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_6fcb132b-9708-4a18-b931-71d4c2f41c8a.png?v=1790530139",
      "score": 53,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "psyllium",
        "husk",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 35,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 42,
        "sustainability": 50
      },
      "price": 15.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575061876933",
      "vsf_explanation": "Psyllium husk has strong, well-established evidence for digestive regularity and cholesterol support at typical fiber doses (roughly 5-10g), making this the best-evidenced product in the batch, but the listing still discloses no per-serving gram amount, which is why it narrowly misses Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "daily-stress-support",
      "title": "Daily Stress Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_09f90ee0-7150-4df9-914d-cb64af96dfb5.png?v=1790530142",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "daily",
        "stress",
        "support",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 0,
        "formulation": 0,
        "manufacturing": 60,
        "safety": 0,
        "transparency": 0,
        "sustainability": 50
      },
      "price": 6.48,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575061909701",
      "vsf_explanation": "The listing never names a single actual ingredient — only 'adaptogenic herbs and calming nutrients' — so there is nothing to verify evidence, dose, or formulation against; treated the same as other fully-undisclosed Kaya Naturals blends.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "b-12-liquid-drops",
      "title": "B-12 Liquid Drops",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_d5694a7d-d9d8-496e-b925-e76aa92f0e9d.png?v=1790530146",
      "score": 41,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "liquid",
        "drops",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 20,
        "manufacturing": 60,
        "safety": 60,
        "transparency": 30,
        "sustainability": 50
      },
      "price": 9.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575062008005",
      "vsf_explanation": "B-12 is well-evidenced for correcting true deficiency, but the 'energy' benefit implied here has weak support in people who aren't deficient, and the title (B-12) doesn't match the body copy (a 'blend of essential B vitamins'), leaving customers unclear what's actually in the bottle.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "omega-3-fish-oil-1",
      "title": "Omega-3 Fish Oil",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_63ce7132-540c-45f8-b2ea-f5b245e75819.png?v=1790530151",
      "score": 51,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "omega",
        "fish",
        "oil",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 32,
        "manufacturing": 60,
        "safety": 58,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 7.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575062204613",
      "vsf_explanation": "EPA/DHA have a solid general research base for cardiovascular and cognitive health, and the listing at least names the specific fatty acids, but no mg amounts, EPA:DHA ratio, or oil form are disclosed, so the claimed benefits can't be confirmed at this specific dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "apple-cider-vinegar-capsules-3",
      "title": "Apple Cider Vinegar Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1_822b1a5c-763d-4ae1-83bd-ad613968a134.png?v=1790530151",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "apple",
        "cider",
        "vinegar",
        "capsules",
        "kaya",
        "naturals"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 25,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 40,
        "sustainability": 50
      },
      "price": 14.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575062270149",
      "vsf_explanation": "A single named ingredient (apple cider vinegar) with weak, mostly preliminary human evidence for digestion or metabolism claims, and no per-serving dose or acetic acid concentration disclosed, so there's no way to confirm the capsule delivers an effective amount.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "percussion-massage-gun",
      "title": "Percussion Massage Gun",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Image_-01_1.jpg?v=1790545425",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "percussion",
        "massage",
        "gun",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "percussion_vibration"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 60,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 129.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575615525061",
      "vsf_explanation": "Auto-failed: this powered massage gun discloses real, useful specs (3 intensity levels at 1800/2400/3200 RPM, 4-hour battery, 4 interchangeable heads, 45dB noise, 1-year warranty) and has modest but real DOMS/flexibility evidence behind percussion therapy generally — but we could find no electrical safety certification anywhere, which is a hard requirement for any powered device in this category.",
      "vsf_autofail_rule": "powered_device_no_electrical_cert"
    },
    {
      "handle": "fullglow™-360-full-body-red-light-near-infrared-bag",
      "title": "FullGlow™ 360 Full Body Red Light & Near Infrared Bag",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/FullGrow_360_Red_Light_Therapy_Product_Image.png?v=1790545434",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "fullglow",
        "360",
        "full",
        "body",
        "red",
        "light",
        "near",
        "infrared",
        "bag",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "red_light_photobiomodulation"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 0,
        "transparency": 0,
        "sustainability": 50
      },
      "price": 1499.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575615557829",
      "vsf_explanation": "Red light/near-infrared photobiomodulation is a category with genuine, growing evidence — but only when wavelength and dose are actually disclosed, and here nothing was provided at all. As a powered light-emitting device with no certification information available, it also fails the electrical safety requirement automatically.",
      "vsf_autofail_rule": "powered_device_no_electrical_cert"
    },
    {
      "handle": "wearable-far-infrared-heating-pad-for-knee-pain-relief",
      "title": "Wearable Far Infrared Heating Pad for Knee Pain Relief",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/KNeeWrap.webp?v=1790545504",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wearable",
        "far",
        "infrared",
        "heating",
        "pad",
        "for",
        "knee",
        "pain",
        "relief",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 0,
        "transparency": 0,
        "sustainability": 50
      },
      "price": 89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575616737477",
      "vsf_explanation": "No product description was provided at all — under the Zero-Assumption Rule, nearly everything scores at or near zero simply because nothing is disclosed. It also falls into the same iReliev heating-pad family that lacks any disclosed electrical safety certification, which is an automatic fail on its own.",
      "vsf_autofail_rule": "powered_device_no_electrical_cert"
    },
    {
      "handle": "wired-small-and-large-electrode-pad-bundle",
      "title": "Wired Small and Large Electrode Pad Bundle",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1000_x_1000_33.jpg?v=1790545504",
      "score": 41,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wired",
        "small",
        "and",
        "large",
        "electrode",
        "pad",
        "bundle",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "ems_tens"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 40,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 39.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575616770245",
      "vsf_explanation": "A consumable electrode-pad accessory for TENS units, not a standalone device — bundle contents (4 pad packs, 2 gels, skin-prep wipes) are clearly disclosed, but there's no independent material-safety, allergen (e.g. latex), or hydrogel-quality certification to back the 'premium-grade' claim.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "tens-mini-pain-relief-patch",
      "title": "TENS Mini Pain Relief Patch",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Lifestyle-image-4-Resized.jpg?v=1790545509",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tens",
        "mini",
        "pain",
        "relief",
        "patch",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "ems_tens"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 35,
        "manufacturing": 70,
        "safety": 65,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 24.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575616803013",
      "vsf_explanation": "A portable single-modality TENS patch backed by real company details (US-based, phone support, a 2-year registered warranty), but the listing gives no output/intensity specs, which limits how precisely we can match it to the clinical TENS evidence base; falls just short of Standard on that basis.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "relaxable™-eye-massager-with-heat",
      "title": "Relaxable™ Eye Massager with Heat",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/EYE_Massager_HERO_1500_x_1500.jpg?v=1790545509",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "relaxable",
        "eye",
        "massager",
        "with",
        "heat",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "percussion_vibration"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 35,
        "manufacturing": 20,
        "safety": 35,
        "transparency": 30,
        "sustainability": 50
      },
      "price": 79.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575616835781",
      "vsf_explanation": "Auto-failed for the same reason as iReliev's other massage/heat devices — no electrical safety certification found anywhere — and separately, the '10 acupressure points' framing is unsubstantiated marketing language not backed by cited evidence; warm-compress therapy itself has real but modest evidence for eye strain, which we credit honestly without endorsing the acupressure claim.",
      "vsf_autofail_rule": "powered_device_no_electrical_cert"
    },
    {
      "handle": "amp-leg-compression-socks",
      "title": "AMP Leg Compression Socks",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/White-leg-sock.png?v=1790545509",
      "score": 53,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "amp",
        "leg",
        "compression",
        "socks",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "compression_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 58,
        "manufacturing": 50,
        "safety": 15,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575617130693",
      "vsf_explanation": "AMP Wear socks disclose 18-25mmHg compression (spanning mild-to-moderate, real but less firmly in the well-studied medical-grade range than a clean 20-30mmHg product), combed-cotton material, moisture-wicking claims, and reinforced zones, backed by iReliev's verified Texas-based identity and 2-year warranty. The blended compression tier plus the absence of textile certification and contraindication disclosure keep it just below the Standard threshold.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "amp-ankle-compression-socks",
      "title": "AMP Ankle Compression Socks",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/White-ankle-sock.png?v=1790545509",
      "score": 53,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "amp",
        "ankle",
        "compression",
        "socks",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "compression_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 58,
        "manufacturing": 50,
        "safety": 15,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575616934085",
      "vsf_explanation": "AMP Wear socks disclose 18-25mmHg compression (spanning mild-to-moderate, real but less firmly in the well-studied medical-grade range than a clean 20-30mmHg product), combed-cotton material, moisture-wicking claims, and reinforced zones, backed by iReliev's verified Texas-based identity and 2-year warranty. The blended compression tier plus the absence of textile certification and contraindication disclosure keep it just below the Standard threshold.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "amp-crew-compression-socks",
      "title": "AMP Crew Compression Socks",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/White-crew-sock.png?v=1790545510",
      "score": 53,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "amp",
        "crew",
        "compression",
        "socks",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "compression_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 58,
        "manufacturing": 50,
        "safety": 15,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575617327301",
      "vsf_explanation": "AMP Wear socks disclose 18-25mmHg compression (spanning mild-to-moderate, real but less firmly in the well-studied medical-grade range than a clean 20-30mmHg product), combed-cotton material, moisture-wicking claims, and reinforced zones, backed by iReliev's verified Texas-based identity and 2-year warranty. The blended compression tier plus the absence of textile certification and contraindication disclosure keep it just below the Standard threshold.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "memory-foam-travel-pillow",
      "title": "Memory Foam Travel Pillow",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/CS-100_Travel_Pillow_HERO_1500_x_1500.jpg?v=1790545509",
      "score": 41,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "memory",
        "foam",
        "travel",
        "pillow",
        "ireliev"
      ],
      "vsf_category": "sleep_optimization",
      "vsf_subcategory": [
        "sleep_pillows_positional"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 40,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 45,
        "sustainability": 50
      },
      "price": 19.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575616901317",
      "vsf_explanation": "Note: this is a travel comfort item, not a recovery/regeneration modality — we're scoring it here as the closest available category fit, but it's an imperfect match. As a plain memory-foam travel pillow it makes no pseudoscientific claims, which is a point in its favor, but disclosure is thin: no CertiPUR or foam-safety certification, no independent testing, and only a 2-year warranty and Texas-based company location to go on.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "far-infrared-natural-jade-and-tourmaline-heating-pad-31-x-21",
      "title": "Far Infrared Natural Jade and Tourmaline Heating Pad, 31\" x 21\"",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/iReliev_Red_Light_Pro_Handheld_Laser_User_Manual_11_x_8.5_in_2000_x_2000_px_-_2024-11-29T090012.015.png?v=1790545509",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "far",
        "infrared",
        "natural",
        "jade",
        "and",
        "tourmaline",
        "heating",
        "pad",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 50,
        "manufacturing": 30,
        "safety": 30,
        "transparency": 20,
        "sustainability": 50
      },
      "price": 199.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575617523909",
      "vsf_explanation": "The best-specified product in the iReliev heating-pad line (smart controller, dual voltage, 3-year warranty), but we directly checked this exact product's live page and confirmed no UL/ETL/CE certification is listed anywhere — an automatic fail for a powered heating device. The claimed '4-6 inches of heat penetration' is also physically implausible for far-infrared and is not something we credit.",
      "vsf_autofail_rule": "powered_device_no_electrical_cert"
    },
    {
      "handle": "mvp-shocduo-massage-tool-head",
      "title": "MVP+ ShocDuo  Massage Tool Head",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/PM_MVP-2010-ShocDuo-Hero_Box-500x500-1.png?v=1790545509",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mvp",
        "shocduo",
        "massage",
        "tool",
        "head",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "percussion_vibration"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 60,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 39.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575617556677",
      "vsf_explanation": "An accessory attachment head for the MVP+ percussion massage gun with an unusually specific engineering description of its flex mechanism, scored on its own build merits rather than borrowing the parent gun's modality-evidence score; low mechanical risk since it has no heat element or electronics.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "far-infrared-heating-pad-wrap-with-far-jade",
      "title": "Far Infrared Heating Pad Wrap with Far Jade",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Wrap_Hero_2.jpg?v=1790545510",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "far",
        "infrared",
        "heating",
        "pad",
        "wrap",
        "with",
        "far",
        "jade",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 45,
        "manufacturing": 18,
        "safety": 35,
        "transparency": 20,
        "sustainability": 50
      },
      "price": 89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575617589445",
      "vsf_explanation": "Has the best disclosed safety feature in this batch — an explicit 4-hour automatic shutdown — plus a stated 103F-159F range, which we credit. But it's still a powered heating device sold worldwide (110-240V) with no electrical safety certification disclosed, which is an automatic fail.",
      "vsf_autofail_rule": "powered_device_no_electrical_cert"
    },
    {
      "handle": "therapeutic-wearable-tens-ems-system",
      "title": "Therapeutic Wearable TENS+EMS System",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Therapeutic_Wearable_System_by_iReliev_1500_x_1500.png?v=1790545510",
      "score": 53,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "therapeutic",
        "wearable",
        "tens",
        "ems",
        "system",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "ems_tens"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 45,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 25,
        "sustainability": 50
      },
      "price": 219.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575617622213",
      "vsf_explanation": "iReliev is a legitimate, FDA-cleared TENS+EMS brand with a documented pacemaker warning and IEC 60601 test-level compliance in its manuals — but this specific Shopify listing has zero product description, so a customer landing on this page gets none of that information directly.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "premium-tens-ems-pain-relief-recovery",
      "title": "Premium TENS + EMS Pain Relief & Recovery",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ET-8080_TENS_UNit_by_iReliev_1500_x_1500_1.png?v=1790545510",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "premium",
        "tens",
        "ems",
        "pain",
        "relief",
        "recovery",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "ems_tens"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 70,
        "manufacturing": 65,
        "safety": 65,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 119.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575617687749",
      "vsf_explanation": "iReliev's best-selling TENS+EMS unit publishes real specs (80mA output, 25 intensity levels, 14 therapy modes, dual channel), which is unusually good transparency for this batch, and the brand discloses the pacemaker contraindication on its FAQ/manuals — though not on this exact product page.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "shiatsu-neck-back-massager",
      "title": "Shiatsu Neck & Back Massager",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Lifestyle_-1.png?v=1790545510",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shiatsu",
        "neck",
        "back",
        "massager",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "percussion_vibration"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 20,
        "manufacturing": 20,
        "safety": 35,
        "transparency": 20,
        "sustainability": 50
      },
      "price": 59.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575617786053",
      "vsf_explanation": "Auto-failed: this is a powered electric massager with no publicly disclosed electrical safety certification anywhere we could find, and this specific Shopify listing has no product description at all — we're listing it honestly with a Rejected tier rather than hiding it.",
      "vsf_autofail_rule": "powered_device_no_electrical_cert"
    },
    {
      "handle": "mvpmini-heattip-massage-head",
      "title": "MVPmini HeatTip Massage Head",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/iReliev_Red_Light_Pro_Handheld_Laser_User_Manual_11_x_8.5_in_2000_x_2000_px_59.png?v=1790545510",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mvpmini",
        "heattip",
        "massage",
        "head",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "percussion_vibration"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 39.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575617753285",
      "vsf_explanation": "This is an accessory attachment head for the MVP Mini percussion massage gun, not a standalone therapeutic device — scored on its own build/material merits rather than forcing a full modality-evidence score onto a plastic heated tip, and it's honestly disclosed as accessory-only, low-risk hardware with no independent material safety certification found.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "far-infrared-natural-jade-and-tourmaline-heating-pad-23-5-x-16",
      "title": "Far Infrared Natural Jade and Tourmaline Heating Pad, 23.5\" x 16\"",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/iReliev_Red_Light_Pro_Handheld_Laser_User_Manual_11_x_8.5_in_2000_x_2000_px_-_2024-11-29T074641.114.png?v=1790545510",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "far",
        "infrared",
        "natural",
        "jade",
        "and",
        "tourmaline",
        "heating",
        "pad",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 20,
        "manufacturing": 15,
        "safety": 15,
        "transparency": 15,
        "sustainability": 50
      },
      "price": 139.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575617818821",
      "vsf_explanation": "This is a powered electric heating pad with no UL/ETL/CE certification disclosed anywhere by iReliev — a hard requirement for any powered heating device. Plain heat therapy does have real evidence for muscle/back pain relief, but the 'jade emits healing far-infrared rays' framing is unsubstantiated marketing, not a real added mechanism beyond warmth.",
      "vsf_autofail_rule": "powered_device_no_electrical_cert"
    },
    {
      "handle": "mvp-heattip-heated-massage-head",
      "title": "MVP+ HeatTip Heated Massage Head",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/PM_MVP-2040-HeatTip-WebImages-Hero_Box_500x500-1_93d8ce67-b3ac-43b1-8e3d-a2a9baa3ad37.png?v=1790545510",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mvp",
        "heattip",
        "heated",
        "massage",
        "head",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "percussion_vibration"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 55,
        "sustainability": 50
      },
      "price": 39.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575617851589",
      "vsf_explanation": "This is an accessory heated attachment head for the MVP+ percussion massage gun, not a standalone device — scored on its own build/material merits; safety is scored slightly below its MVPmini sibling because the active heating element adds a burn-risk consideration with no disclosed thermal limit.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "wearable-far-infrared-heating-pad-for-back-pain-relief",
      "title": "Wearable Far Infrared Heating Pad for Back Pain Relief",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/H23Y1Hero.jpg?v=1790545510",
      "score": 0,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wearable",
        "far",
        "infrared",
        "heating",
        "pad",
        "for",
        "back",
        "pain",
        "relief",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "sauna_heat_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 45,
        "manufacturing": 18,
        "safety": 25,
        "transparency": 25,
        "sustainability": 50
      },
      "price": 119.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575617884357",
      "vsf_explanation": "A vibrating heat belt with a disclosed, plausible 103-159F range — better spec disclosure than most in this batch — but still a powered heating device with no UL/ETL/CE certification found anywhere, which is an automatic fail regardless of how reasonable the rest of the design is.",
      "vsf_autofail_rule": "powered_device_no_electrical_cert"
    },
    {
      "handle": "bamboo-anti-fatigue-compression-socks",
      "title": "Bamboo Anti-Fatigue Compression Socks",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/iReliev_CompressionSocks-WEB-Gallery-White3-1.png?v=1790545510",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bamboo",
        "anti",
        "fatigue",
        "compression",
        "socks",
        "ireliev"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "compression_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 85,
        "formulation": 65,
        "manufacturing": 50,
        "safety": 15,
        "transparency": 65,
        "sustainability": 50
      },
      "price": 9.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575617917125",
      "vsf_explanation": "iReliev is a verified real, Texas-based company with a genuine 2-year registered warranty, and this listing discloses 20-30mmHg medical-grade compression plus bamboo material composition and moisture/odor-control claims — solid, well-rounded disclosure for this category. It falls short of Verified because no textile safety certification or contraindication guidance (PAD, neuropathy) is disclosed anywhere in iReliev's compression line.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "knee-high-compression-socks-solid",
      "title": "Knee-High Compression Socks - Solid",
      "vendor": "Comrad",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/KHC-SL1801-nylon-solid_heather-charcoal_flat-lil.jpg?v=1790545530",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "knee",
        "high",
        "compression",
        "socks",
        "solid",
        "comrad"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "compression_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 15,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 34,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575620702405",
      "vsf_explanation": "15-20 mmHg is a real, disclosed mild graduated-compression tier aimed at general fatigue and comfort — a genuine but weaker evidence base than 20-30mmHg medical-grade compression. Comrad's verified USA manufacturing and clear mmHg disclosure are positives, but the milder compression tier combined with brand-wide gaps in certification and contraindication disclosure land it just below Standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "knee-high-compression-socks-solid-20-30-mmhg",
      "title": "Knee-High Compression Socks - Solid (20-30 mmHg)",
      "vendor": "Comrad",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/KHC-SL001-Solid-Nylon_black_flat-lil.jpg?v=1790545533",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "knee",
        "high",
        "compression",
        "socks",
        "solid",
        "mmhg",
        "comrad"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "compression_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 85,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 15,
        "transparency": 60,
        "sustainability": 50
      },
      "price": 38,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575620899013",
      "vsf_explanation": "20-30 mmHg is genuine medical-grade graduated compression with real supporting clinical literature (varicose veins, DVT prevention on flights, post-surgical swelling), and Comrad is a verified USA-made brand backed by a no-blister guarantee — both credited generously. It still lands at the low end of Standard because the listing discloses no material composition, no textile safety certification, and no contraindication guidance (e.g., PAD, neuropathy).",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "knee-high-compression-socks-ombre",
      "title": "Knee-High Compression Socks - Ombre",
      "vendor": "Comrad",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/KHC-OM001-Ombre-Nylon_black_flat-lil_4f3123e9-a17e-4502-8db4-ebe78b94a47d.jpg?v=1790545540",
      "score": 36,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "knee",
        "high",
        "compression",
        "socks",
        "ombre",
        "comrad"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "compression_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 15,
        "transparency": 30,
        "sustainability": 50
      },
      "price": 38,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575621128389",
      "vsf_explanation": "This is a genuine Comrad SKU from a verified, USA-made DTC compression brand, but unlike its two sibling SKUs in this batch, this specific listing doesn't disclose an mmHg compression level, so we can't verify whether it's therapeutically meaningful graduated compression. No certification or contraindication guidance is disclosed either, landing it well below its mmHg-labeled siblings.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "endurance-graduated-compression-sock",
      "title": "Endurance Graduated Compression Sock",
      "vendor": "Covert Threads-A Military Sock For Every Clime & Place",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/endurance-graduated-compression-sock-216777.jpg?v=1790545589",
      "score": 36,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "endurance",
        "graduated",
        "compression",
        "sock",
        "covert",
        "threads",
        "military",
        "sock",
        "for",
        "every",
        "clime",
        "place"
      ],
      "vsf_category": "recovery_regeneration",
      "vsf_subcategory": [
        "compression_therapy"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 60,
        "manufacturing": 42,
        "safety": 15,
        "transparency": 35,
        "sustainability": 50
      },
      "price": 27.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575621521605",
      "vsf_explanation": "Covert Threads is a real, veteran-founded USA sock manufacturer, which supports brand credibility, but this listing discloses no mmHg compression level at all — only vague 'performance-fit' language — so we can't verify it delivers therapeutically meaningful graduated compression rather than just a snug athletic sock. Reinforced heel/toe construction and cool-wicking nylon are genuine positives, but the missing compression rating and absent certification/contraindication guidance keep this in Rejected territory.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "med-pat-bp-r-round-blood-pressure-monitor-automatic-digital-bp-machine-fda-cleared",
      "title": "Med-Pat BP-R Round Blood Pressure Monitor | Automatic Digital BP Machine – FDA Cleared",
      "vendor": "MedPat Solutions",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/medpat-solutions-bp-default-title-med-pat-bp-r-round-blood-pressure-monitor-automatic-digital-bp-machine-25456957816967.jpg?v=1790545802",
      "score": 36,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "med",
        "pat",
        "round",
        "blood",
        "pressure",
        "monitor",
        "automatic",
        "digital",
        "machine",
        "fda",
        "cleared",
        "medpat",
        "solutions"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "blood_pressure"
      ],
      "vsf_dimensions": {
        "evidence": 24,
        "formulation": 15,
        "manufacturing": 50,
        "safety": 67,
        "transparency": 25,
        "sustainability": 50
      },
      "price": 29.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575633187013",
      "vsf_explanation": "Like its sibling model, this device's 'FDA Cleared' claim checks out against the real FDA 510(k) record (K244000), but that clearance belongs to an undisclosed OEM manufacturer rather than the seller itself, and no accuracy spec, independent validation, or algorithm disclosure could be found. The cumulative Zero-Assumption gaps place it in the Rejected tier, not any single auto-fail.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "med-pat-bp-s-arm-blood-pressure-monitor-fda-cleared-easy-to-read-display-one-touch-operation",
      "title": "Med-Pat BP-S Arm Blood Pressure Monitor – FDA Cleared, Easy-to-Read Display & One-Touch Operation",
      "vendor": "MedPat Solutions",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/medpat-solutions-bp-default-title-med-pat-bp-s-arm-blood-pressure-monitor-accurate-and-reliable-home-health-device-with-easy-to-read-display-and-one-touch-operation-25456955359367.jpg?v=1790545811",
      "score": 36,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "med",
        "pat",
        "arm",
        "blood",
        "pressure",
        "monitor",
        "fda",
        "cleared",
        "easy",
        "read",
        "display",
        "one",
        "touch",
        "operation",
        "medpat",
        "solutions"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "blood_pressure"
      ],
      "vsf_dimensions": {
        "evidence": 24,
        "formulation": 15,
        "manufacturing": 50,
        "safety": 67,
        "transparency": 25,
        "sustainability": 50
      },
      "price": 42,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575633285317",
      "vsf_explanation": "The 'FDA Cleared' claim on this listing is real and verifiable (510(k) K244000), but no published accuracy specification, independent clinical validation, or algorithm/methodology disclosure could be found for this device, and the seller never names the device's actual manufacturer on its own site. This is not a hard auto-fail, but the cumulative gaps under our Zero-Assumption Rule land it in the Rejected tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "blood-pressure-monitor-digital-wrist-blood-pressure-machine-automatic-cuff-bp-detector",
      "title": "Blood Pressure Monitor Digital Wrist Blood Pressure Machine Automatic Cuff BP Detector",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/blood-pressure-monitor-digital-wrist-blood-pressure-machine-automatic-cuff-bp-detector-wellness-black-voice-dailysale-569080.jpg?v=1790545829",
      "score": 9,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "blood",
        "pressure",
        "monitor",
        "digital",
        "wrist",
        "blood",
        "pressure",
        "machine",
        "automatic",
        "cuff",
        "detector",
        "dailysale"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "blood_pressure"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 0,
        "transparency": 0,
        "sustainability": 50
      },
      "price": 39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575633481925",
      "vsf_explanation": "This wrist blood pressure monitor is sold under a generic, unbranded listing with no identifiable manufacturer behind it — the title does not match any specific named product line we could trace. Without a verifiable brand, we could not confirm FDA clearance, independent accuracy validation, or a privacy policy, so most dimensions score at zero under our Zero-Assumption Rule.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "a-d-medical-wide-range-cuff-blood-pressure-monitor-white-w-black-ua-651-ac",
      "title": "A&D MEDICAL Wide Range Cuff Blood Pressure Monitor White w/ Black UA-651-AC",
      "vendor": "PayWut",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/D29702C1-3FDC-4D22-956F-AA7F32D5289C.jpg?v=1790545842",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "medical",
        "wide",
        "range",
        "cuff",
        "blood",
        "pressure",
        "monitor",
        "white",
        "black",
        "651",
        "paywut"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "blood_pressure"
      ],
      "vsf_dimensions": {
        "evidence": 80,
        "formulation": 45,
        "manufacturing": 75,
        "safety": 67,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 20,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575634104517",
      "vsf_explanation": "This exact model (UA-651) has FDA 510(k) clearance (K141160), is listed on both validatebp.org and stridebp.org, and an independent validation tracker confirms two peer-reviewed clinical validation studies — the strongest evidence base of the five devices in this batch. It loses points because the -AC variant has no Bluetooth/app connectivity, and the manufacturer's privacy policy never addresses whether health data is sold.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dixie-aneroid-sphygmomanometer-blood-pressure-cuff",
      "title": "Dixie Aneroid Sphygmomanometer - Blood Pressure Cuff",
      "vendor": "quakekits.com",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/143401.jpg?v=1790545879",
      "score": 20,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dixie",
        "aneroid",
        "sphygmomanometer",
        "blood",
        "pressure",
        "cuff",
        "quakekits",
        "com"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "blood_pressure"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 67,
        "transparency": 8,
        "sustainability": 50
      },
      "price": 16.57,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575635022021",
      "vsf_explanation": "This is a manual, non-digital aneroid cuff from Dixie EMS, a real and verifiable 30+ year medical supply company sold through Medline, McKesson, Amazon, and Walmart. Because it collects no digital data, there is no biometric privacy concern, but no FDA 510(k) clearance, ISO 13485 certification, or independent accuracy study could be found under the Dixie name, so it does not meet the evidentiary bar for a passing score.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "wrist-sphygmomanometer-rechargeable-blood-pressure-meter-wrist-blood-pressure-eter-smart-touch-screen-blood-pressure-meter-household-electronics",
      "title": "Wrist Sphygmomanometer Rechargeable Blood Pressure Meter Wrist Blood Pressure Eter Smart Touch Screen Blood Pressure Meter Household Electronics",
      "vendor": "My Store",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/880c1115-82ba-4b71-930e-bd9634fa2c1b.jpg?v=1790545912",
      "score": 9,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wrist",
        "sphygmomanometer",
        "rechargeable",
        "blood",
        "pressure",
        "meter",
        "wrist",
        "blood",
        "pressure",
        "eter",
        "smart",
        "touch",
        "screen",
        "blood",
        "pressure",
        "meter",
        "household",
        "electronics",
        "store"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "blood_pressure"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 0,
        "transparency": 0,
        "sustainability": 50
      },
      "price": 37.28,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575635153093",
      "vsf_explanation": "This device's own title contains garbled, machine-translated text — a strong signal of an anonymous dropship listing with no real manufacturer behind it. We could not confirm FDA clearance, independent validation, or a privacy policy for any responsible company, so most dimensions score at zero under our Zero-Assumption Rule.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "omron-10-series-wireless-upper-arm-blood-pressure-monitor-model-bp786-1ea",
      "title": "Omron 10 Series Wireless Upper Arm Blood Pressure Monitor Model BP786 -1ea",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/326007454.jpg?v=1790545919",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "omron",
        "series",
        "wireless",
        "upper",
        "arm",
        "blood",
        "pressure",
        "monitor",
        "model",
        "bp786",
        "1ea",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "blood_pressure"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 65,
        "manufacturing": 75,
        "safety": 60,
        "transparency": 25,
        "sustainability": 38
      },
      "price": 103.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575635873989",
      "vsf_explanation": "This specific 10 Series model (BP786 / HEM-7321T-Z) is FDA-cleared and has a published accuracy spec, but despite Omron's generic 'clinically validated' marketing language, it is not on the U.S. Validated Device Listing or the international STRIDE BP registry, and an independent device-validation tracker explicitly states it has not been clinically validated with any peer-reviewed study. That evidence gap — not a safety problem — is why this model lands well below its sibling Omron monitors.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "omron-blood-pressure-monitor-ekg-complete-wireless-upper-arm",
      "title": "Omron Blood Pressure Monitor + EKG, Complete Wireless Upper Arm",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/239799668.jpg?v=1790545928",
      "score": 69,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "omron",
        "blood",
        "pressure",
        "monitor",
        "ekg",
        "complete",
        "wireless",
        "upper",
        "arm",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "blood_pressure"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 65,
        "manufacturing": 75,
        "safety": 67,
        "transparency": 83,
        "sustainability": 38
      },
      "price": 162.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575635906757",
      "vsf_explanation": "This is the Omron Complete (BP7900), whose blood pressure function is on the AMA Validated Device Listing and whose single-lead ECG/AFib-detection feature has its own genuine FDA 510(k) clearance (developed with AliveCor) — so no auto-fail applies to its heart-rhythm claim. It loses points for undisclosed algorithm methodology, mixed independent battery-life feedback, and an ambiguous data-sale policy across the two apps it relies on.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "omron-evolv-bluetooth-wireless-upper-arm-blood-pressure-monitor",
      "title": "Omron Evolv Bluetooth Wireless Upper Arm Blood Pressure Monitor",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/239797775_e2cad3f3-995a-4b46-809f-1cce2e2bd46b.jpg?v=1790545947",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "omron",
        "evolv",
        "bluetooth",
        "wireless",
        "upper",
        "arm",
        "blood",
        "pressure",
        "monitor",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "blood_pressure"
      ],
      "vsf_dimensions": {
        "evidence": 80,
        "formulation": 65,
        "manufacturing": 75,
        "safety": 67,
        "transparency": 83,
        "sustainability": 38
      },
      "price": 103.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575636136133",
      "vsf_explanation": "The Omron Evolv (BP7000) is independently validated against a mercury reference to AAMI/ESH/ISO 81060-2 standards (±3 mmHg mean difference, ±8 mmHg SD) and appears on both the U.S. Validated Device Listing and STRIDE BP registry, backed by FDA clearance and ISO 13485 certification. It loses points mainly on algorithm-methodology disclosure, unconfirmed battery-life claims, and an ambiguous data-sale policy.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "omron-manual-blood-pressure-monitor",
      "title": "Omron Manual Blood Pressure Monitor",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/104116599.jpg?v=1790545953",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "omron",
        "manual",
        "blood",
        "pressure",
        "monitor",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "blood_pressure"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 45,
        "manufacturing": 75,
        "safety": 93,
        "transparency": 58,
        "sustainability": 38
      },
      "price": 35.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575636299973",
      "vsf_explanation": "Verified this is a manual-inflation (squeeze-bulb) digital oscillometric monitor, not a fully automatic or aneroid device — it uses Omron's standard oscillometric measurement technology with a published ±3 mmHg accuracy spec, but has no Bluetooth, app, or account, so it carries no digital-privacy exposure. Score is limited mainly by the generic listing title, which prevented us from confirming an exact model's own validation-registry entry.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "omron-10-series-blood-pressure-monitor",
      "title": "Omron 10 Series Blood Pressure Monitor",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/344713011.jpg?v=1790545959",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "omron",
        "series",
        "blood",
        "pressure",
        "monitor",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "blood_pressure"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 55,
        "manufacturing": 75,
        "safety": 53,
        "transparency": 83,
        "sustainability": 38
      },
      "price": 101.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575636332741",
      "vsf_explanation": "A generic '10 Series Upper Arm Blood Pressure Monitor' entry exists on the AMA Validated Device Listing and Omron publishes brand-wide accuracy and clearance data, but since this listing gives no specific model number we could not confirm which exact 10 Series SKU is sold, so several device-specific claims (connectivity, battery) were scored conservatively.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "omron-7-series-wireless-upper-arm-blood-pressure-monitor",
      "title": "Omron 7 Series Wireless Upper Arm Blood Pressure Monitor",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/302951087.jpg?v=1790545973",
      "score": 67,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "omron",
        "series",
        "wireless",
        "upper",
        "arm",
        "blood",
        "pressure",
        "monitor",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "blood_pressure"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 65,
        "manufacturing": 75,
        "safety": 53,
        "transparency": 83,
        "sustainability": 38
      },
      "price": 91.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575636758725",
      "vsf_explanation": "This 7 Series model's underlying measurement technology is on the AMA-backed U.S. Validated Device Listing and Omron publishes a ±3 mmHg accuracy spec, backed by company-wide FDA clearance and ISO 13485 certification. It loses points for an ambiguous data-sale policy, no independently confirmed battery-life or IP rating data, and no published algorithm methodology beyond marketing language.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "omron-7-series-upper-arm-blood-pressure-monitor",
      "title": "Omron 7 Series Upper Arm Blood Pressure Monitor",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/186234559_70202d5d-1062-44cf-91b3-59a76143a642.jpg?v=1790546008",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "omron",
        "series",
        "upper",
        "arm",
        "blood",
        "pressure",
        "monitor",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "blood_pressure"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 65,
        "manufacturing": 75,
        "safety": 60,
        "transparency": 42,
        "sustainability": 38
      },
      "price": 90.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575639838917",
      "vsf_explanation": "Identified as model BP7360 (HEM-7376T1-Z); it is directly listed on the U.S. Validated Device Listing (validatebp.org) and publishes a ±3 mmHg accuracy spec with full Bluetooth app data export. Its built-in AFib screening feature is marketed with appropriate 'consult your physician' screening language rather than a diagnostic claim, so no auto-fail applies, but we could not independently confirm a dedicated peer-reviewed validation paper for this exact model, and its privacy/return-rate/IP-rating transparency is only average.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lifesource-blood-pressure-monitor-advanced-manual-inflate-medium",
      "title": "LifeSource Blood Pressure Monitor Advanced Manual Inflate Medium",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/57813355_88c4a6c4-0145-4f8d-b236-0b1f8e7415bb.jpg?v=1790546021",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lifesource",
        "blood",
        "pressure",
        "monitor",
        "advanced",
        "manual",
        "inflate",
        "medium",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "blood_pressure"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 50,
        "sustainability": 50
      },
      "price": 39.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575639937221",
      "vsf_explanation": "This manual-inflate model (UA-705V) is A&D Medical's North American consumer brand (LifeSource) and has a genuine, independently published clinical validation study, plus FDA-regulated Class II status at the corporate level. It stays in the Standard tier rather than higher because it has no digital connectivity of any kind (no app, no data export), a privacy policy that is silent on whether health data is sold, and no documented data-deletion process.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "automatic-wrist-blood-pressure-monitor",
      "title": "Automatic Wrist Blood Pressure Monitor",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/automatic-wrist-blood-pressure-monitor-wellness-dailysale-136997.jpg?v=1790546050",
      "score": 9,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "automatic",
        "wrist",
        "blood",
        "pressure",
        "monitor",
        "dailysale"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "blood_pressure"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 0,
        "manufacturing": 0,
        "safety": 0,
        "transparency": 0,
        "sustainability": 50
      },
      "price": 25,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575640920261",
      "vsf_explanation": "This wrist blood pressure monitor is sold under a generic, unbranded listing with no identifiable manufacturer behind it. Without a verifiable brand, we could not confirm FDA clearance, independent accuracy validation, or a privacy policy, so most dimensions score at zero under our Zero-Assumption Rule.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "omron-blood-pressure-monitor-3-series-wrist-bp6100",
      "title": "Omron Blood Pressure Monitor 3 Series Wrist BP6100",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/329571211_592b358d-00bb-4d11-b780-092cf259f3b6.png?v=1790546061",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "omron",
        "blood",
        "pressure",
        "monitor",
        "series",
        "wrist",
        "bp6100",
        "pasteur",
        "pharmacy"
      ],
      "vsf_category": "wearables_tracking",
      "vsf_subcategory": [
        "blood_pressure"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 65,
        "manufacturing": 75,
        "safety": 73,
        "transparency": 42,
        "sustainability": 38
      },
      "price": 59.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575641018565",
      "vsf_explanation": "This wrist monitor is included on the AMA/AHA-backed U.S. Validated Device Listing and publishes a ±3 mmHg accuracy spec, but an independent EU device tracker flags that the specific U.S. hardware relies on an unpublished equivalence claim rather than its own dedicated validation paper, and the maker's ISO rating and privacy language are only average.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "orzax-resveratrol-200mg-dietary-supplement-antioxidant-support-for-health-wellness-30-capsules",
      "title": "Orzax Resveratrol 200mg Dietary Supplement - Antioxidant Support for Health & Wellness, 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Nu4lUznzshlE06Ibibyo43ahuPX4sU2YH1yG00rN_5e7f991f-857c-4d7d-b169-1933ae0347f1.jpg?v=1790548836",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "orzax",
        "resveratrol",
        "200mg",
        "dietary",
        "supplement",
        "antioxidant",
        "support",
        "for",
        "health",
        "wellness",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 60,
        "sustainability": 38
      },
      "price": 41.07,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575785492677",
      "vsf_explanation": "Orzax Resveratrol discloses a clear 200mg per-capsule dose within typical commercial ranges, but its marketing language about 'potentially reducing the risk of chronic diseases' outpaces the strength of current human clinical evidence for this ingredient. It scores Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lifextra-l-glutamin-supplement-for-adults-30-sachets",
      "title": "LifeXtra L-Glutamin - Supplement for Adults | 30 Sachets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/dAnSkiyj8Y6gfqdusLqWhia3iCVykv3hiVnF1DAD.jpg?v=1790549831",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lifextra",
        "glutamin",
        "supplement",
        "for",
        "adults",
        "sachets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 68,
        "manufacturing": 74,
        "safety": 75,
        "transparency": 70,
        "sustainability": 40
      },
      "price": 34.96,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575858303173",
      "vsf_explanation": "LifeXtra L-Glutamin discloses a 5000mg per-sachet dose within studied ranges for exercise recovery and cites a Turkish supplement approval number, from the same ISO-certified manufacturer as the brand's other products.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitaniq-cogni-zone-sitikolin-kids-nutritional-supplement-150-ml",
      "title": "VitaniQ Cogni-zone Sitikolin Kids - Nutritional Supplement | 150 ml",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7dtjlNl8CjqoKmIPZwCeyK7b2LMMYvod5koFNGiF.jpg?v=1790549831",
      "score": 41,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "youth_under_18",
      "tokens": [
        "vitaniq",
        "cogni",
        "zone",
        "sitikolin",
        "kids",
        "nutritional",
        "supplement",
        "150",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 35,
        "transparency": 45,
        "sustainability": 30
      },
      "price": 60.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575858335941",
      "vsf_explanation": "VitaniQ Cogni-zone markets a citicoline (Sitikolin) supplement directly to children as young as 4 for concentration and school performance, but citicoline's published cognitive research is concentrated in adult and elderly populations, not healthy children, and no pediatric safety or efficacy data is disclosed for this use.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "vitabiotics-ultra-cranberry-30-tablets-supplement",
      "title": "Vitabiotics Ultra Cranberry - 30 Tablets | Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71IJxBxDS0L.jpg?v=1790549831",
      "score": 68,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitabiotics",
        "ultra",
        "cranberry",
        "tablets",
        "supplement",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 62,
        "manufacturing": 88,
        "safety": 72,
        "transparency": 66,
        "sustainability": 55
      },
      "price": 27.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575858434245",
      "vsf_explanation": "Vitabiotics Ultra Cranberry discloses a clear 750mg extract dose with stated Canadian sourcing, supporting a moderate evidence and formulation score for urinary tract health. It scores Standard tier, with the brand's established manufacturing base as a strong contributor.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "assos-premesis-plus-60-tablet-nutritional-supplement",
      "title": "Assos Premesis Plus 60 Tablet - Nutritional Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/UHlRNA4z3NKUH7quWg8uswZElNxkSLjlR5yhV5Hi.jpg?v=1790549830",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "assos",
        "premesis",
        "plus",
        "tablet",
        "nutritional",
        "supplement",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 48,
        "safety": 60,
        "transparency": 62,
        "sustainability": 32
      },
      "price": 27.63,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575858401477",
      "vsf_explanation": "Assos Premesis Plus discloses clear per-ingredient doses of ginger extract and B vitamins, with ginger in particular having genuine published evidence for reducing nausea. The listing lacks manufacturing certification and doesn't explicitly state its intended use case, keeping it at Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "xpecia-for-men-60-tablets-hair-health-supplement-mens-health",
      "title": "Xpecia For Men 60 Tablets - Hair Health Supplement | Men's Health",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/XpeciaMen3boxesx60tablets_2_a0621d9b-5296-4de1-a779-312e1ae0e5ef.png?v=1790549831",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "xpecia",
        "for",
        "men",
        "tablets",
        "hair",
        "health",
        "supplement",
        "men",
        "health",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 75,
        "manufacturing": 52,
        "safety": 65,
        "transparency": 72,
        "sustainability": 35
      },
      "price": 26.96,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575858467013",
      "vsf_explanation": "Xpecia For Men fully discloses doses for all ten of its active ingredients, including saw palmetto at a dose consistent with hormone-related research, alongside biotin, zinc, and amino acids commonly used in hair-support formulas. Missing manufacturing certification and sustainability information keep it at Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sovital-tall-girls-boys-growth-support-supplement-90-capsules",
      "title": "Sovital Tall Girls & Boys - Growth Support Supplement | 90 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/utO0G3S2q4T2N8Tsgit4OBUzGiLGmw7kMUd2g4nG.jpg?v=1790549830",
      "score": 37,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sovital",
        "tall",
        "girls",
        "boys",
        "growth",
        "support",
        "supplement",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 45,
        "manufacturing": 40,
        "safety": 50,
        "transparency": 45,
        "sustainability": 32
      },
      "price": 73.38,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575858368709",
      "vsf_explanation": "Sovital Tall markets itself directly to children and teenagers with the claim that its capsules support height growth, but the core claim is not supported by credible evidence, and the amino acid doses used are far below any amount studied in growth-related research. This is an unverified physiological claim marketed to a young population.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "imuneks-farma-food-supplement-containing-10-mg-beta-glucan-40-capsules",
      "title": "Imuneks Farma Food Supplement Containing 10 mg Beta Glucan 40 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/imuneks-farma-10-mg-beta-glukan-iceren--561f5_2906cd55-02c0-44dd-a404-e66ac06eec72.jpg?v=1790549830",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "imuneks",
        "farma",
        "food",
        "supplement",
        "containing",
        "beta",
        "glucan",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 30,
        "manufacturing": 70,
        "safety": 70,
        "transparency": 55,
        "sustainability": 38
      },
      "price": 17.2,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575858499781",
      "vsf_explanation": "Imuneks Farma Beta Glucan discloses its 10mg dose honestly, but that amount is far below the 250-500mg range typically used in the immune-support research cited for beta-glucan, making the dose sub-therapeutic relative to the evidence base.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "selinecza-vitix-tablet-dietary-supplement-30-tablets",
      "title": "Selinecza Vitix Tablet - Dietary Supplement | 30 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/jPYkCpHDryX9nFlYF7FZYzySFQlwl4WH3H0QFdML.jpg?v=1790549830",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "selinecza",
        "vitix",
        "tablet",
        "dietary",
        "supplement",
        "tablets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 68,
        "manufacturing": 50,
        "safety": 68,
        "transparency": 66,
        "sustainability": 33
      },
      "price": 56.54,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575858532549",
      "vsf_explanation": "Selinecza's Vitix tablet fully discloses standard doses of well-established immune and antioxidant nutrients (vitamin C, zinc, selenium, vitamin E) along with clear safety warnings. Missing manufacturing certification and sustainability information keep it at Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pharmaton-50-plus-daily-vitamin-mineral-supplement-60-capsules",
      "title": "Pharmaton 50 Plus - Daily Vitamin & Mineral Supplement | 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/kbqnWvc45heXObTdtj9agZOJHOIBKmZUw6M57C5l.jpg?v=1790549830",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pharmaton",
        "plus",
        "daily",
        "vitamin",
        "mineral",
        "supplement",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 78,
        "safety": 68,
        "transparency": 55,
        "sustainability": 42
      },
      "price": 54.43,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575858598085",
      "vsf_explanation": "Pharmaton 50 Plus comes from an established, internationally distributed brand with real market history, giving it stronger manufacturing credibility than the small unknown brands in this batch. However, this specific listing names ten included nutrients without disclosing individual doses, which caps its transparency and formulation scores at Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "new-life-b12-plus-methyl-b12-supplement-60-tablets",
      "title": "New Life B12 Plus - Methyl B12 Supplement | 60 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/PLBZ9XEu057Rp9XcPWVnSxCIfmPloC0jejSEK3SI_e371d63b-3157-4230-aa75-a93c2a1d0944.jpg?v=1790549830",
      "score": 69,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "new",
        "life",
        "b12",
        "plus",
        "methyl",
        "b12",
        "supplement",
        "tablets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 70,
        "manufacturing": 76,
        "safety": 82,
        "transparency": 72,
        "sustainability": 42
      },
      "price": 21.73,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575858630853",
      "vsf_explanation": "New Life B12 Plus is a sublingual methylcobalamin B12, folic acid, and biotin tablet with fully disclosed doses and standard consumer safety warnings, produced by an established Turkish supplement manufacturer.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "elenatal-multivitamin-supplement-for-pregnancy-30-capsules-prenatal-vitamins-with-metafolin-vitamins-and-minerals-for-fetal-development",
      "title": "Elenatal Multivitamin Supplement for Pregnancy - 30 Capsules, Prenatal Vitamins with Metafolin, Vitamins and Minerals for Fetal Development",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/E6ieaWdvSy3mgzfCpItjjcoBXPlTBLJbBINkxWXE_85c4c942-d1dc-40f7-b19c-4a36abd6ddbf.jpg?v=1790549830",
      "score": 47,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "female",
      "life_stage": "prenatal",
      "tokens": [
        "elenatal",
        "multivitamin",
        "supplement",
        "for",
        "pregnancy",
        "capsules",
        "prenatal",
        "vitamins",
        "with",
        "metafolin",
        "vitamins",
        "and",
        "minerals",
        "for",
        "fetal",
        "development",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 35,
        "sustainability": 32
      },
      "price": 24.3,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575858565317",
      "vsf_explanation": "Elenatal names Metafolin, a well-researched bioavailable folate form, but discloses no dose for it or for any other ingredient in the formula, leaving most of this prenatal multivitamin's actual contents unverified. For a product marketed specifically for fetal development, this level of non-disclosure is a significant gap.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ocean-methyl-folat-30-tablet-folic-acid-supplement",
      "title": "Ocean Methyl Folat - 30 Tablet Folic Acid Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/71Y0-xF4kDL_238b6e7c-77c9-4222-998d-004ce62a8fec.jpg?v=1790549830",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ocean",
        "methyl",
        "folat",
        "tablet",
        "folic",
        "acid",
        "supplement",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 30,
        "manufacturing": 58,
        "safety": 70,
        "transparency": 30,
        "sustainability": 35
      },
      "price": 17.36,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575858663621",
      "vsf_explanation": "Ocean's 'Methyl Folat' tablet is titled after methylfolate (5-MTHF) but its own product description only ever describes '400 mcg of fourth-generation folic acid,' a chemically different compound with a different evidence and use profile. Because buyers seeking methylfolate specifically (e.g., for an MTHFR variant) cannot verify what is actually in the tablet, this product is rejected for misleading naming.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "suda-collagen-90-tablet-3-month-supply-health-supplement",
      "title": "Suda Collagen 90 Tablet - 3-Month Supply | Health Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/oVX1rKFCaTVH1w5elpUHroF5cwpO6qvLoVKzQjSN.jpg?v=1790549831",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "suda",
        "collagen",
        "tablet",
        "month",
        "supply",
        "health",
        "supplement",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 68,
        "manufacturing": 50,
        "safety": 60,
        "transparency": 70,
        "sustainability": 27
      },
      "price": 32.36,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575858696389",
      "vsf_explanation": "Suda's Collagen product provides the most thorough ingredient breakdown in the brand's line, disclosing exact amounts for all six components, though its 1000mg collagen dose sits below the range used in most supporting clinical trials. That evidence-dose gap, combined with missing manufacturing disclosure, places it at Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "argivit-smart-multivitamin-supplement-30-tablets-premium-formula",
      "title": "Argivit Smart Multivitamin Supplement 30 Tablets | Premium Formula",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/argivit-smart-30-tablet-e-413a_89ed2399-4ff4-453b-9c22-58734e58d0d1.jpg?v=1790549830",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "argivit",
        "smart",
        "multivitamin",
        "supplement",
        "tablets",
        "premium",
        "formula",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 58,
        "sustainability": 38
      },
      "price": 36.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575858729157",
      "vsf_explanation": "Argivit Smart Multivitamin discloses clear per-tablet mg amounts for all eight of its ingredients, well above the disclosure level typical for this brand's other SKUs. It scores Standard tier, held back by an unreconciled labeling inconsistency between the per-tablet doses and separately listed gram figures.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "proxeed-plus-supplement-30-sachets",
      "title": "Proxeed Plus Supplement - 30 Sachets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/zl5wG6hLheahQGz1qNXCfFO1A0bTqLHvf9ethRJo.jpg?v=1790549831",
      "score": 79,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "proxeed",
        "plus",
        "supplement",
        "sachets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 82,
        "formulation": 85,
        "manufacturing": 82,
        "safety": 78,
        "transparency": 80,
        "sustainability": 45
      },
      "price": 94.22,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575858761925",
      "vsf_explanation": "Proxeed Plus is a well-established, internationally sold male-fertility supplement whose core L-carnitine/CoQ10/zinc/folate formula matches published clinical research showing improved sperm parameters. Full ingredient transparency and a real manufacturing pedigree place it at Verified tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "day2day-collagen-mag-plus-30-sachets-collagen-supplement-with-magnesium-vitamin-c-hyaluronic-acid",
      "title": "Day2Day Collagen Mag Plus 30 Sachets - Collagen Supplement with Magnesium, Vitamin C & Hyaluronic Acid",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5953y1KLSCjvJSKQJH4pm2SWeExzEtKfH4XkcTGb_99721295-d167-4404-8930-a62896cf9b03.jpg?v=1790549832",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "immune",
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "day2day",
        "collagen",
        "mag",
        "plus",
        "sachets",
        "collagen",
        "supplement",
        "with",
        "magnesium",
        "vitamin",
        "hyaluronic",
        "acid",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 50,
        "sustainability": 40
      },
      "price": 55.3,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575858860229",
      "vsf_explanation": "Day2Day Collagen Mag Plus discloses clear doses for its magnesium, vitamin C, and zinc content and references a formal supplement approval number, but the collagen amount itself is not quantified. It scores Standard tier, held back mainly by that core ingredient gap.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "venatura-curcumin-supplement-30-soft-capsules-anti-inflammatory-support-natural-wellness",
      "title": "VeNatura Curcumin Supplement - 30 Soft Capsules, Anti-Inflammatory Support & Natural Wellness",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/gsN60bnqAh0pBpnt4OlKdZH1KyZAznamaYsRoOfJ.jpg?v=1790549833",
      "score": 49,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "venatura",
        "curcumin",
        "supplement",
        "soft",
        "capsules",
        "anti",
        "inflammatory",
        "support",
        "natural",
        "wellness",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 42,
        "manufacturing": 40,
        "safety": 75,
        "transparency": 68,
        "sustainability": 25
      },
      "price": 31.36,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575858892997",
      "vsf_explanation": "VeNatura discloses its curcumin dose with unusual precision, but at 41 mg of actual curcumin per capsule, it falls well below the doses used in most supporting clinical research, even accounting for its claimed micellar delivery technology. That dose gap, not a lack of disclosure, is the reason this product is rejected.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "natuwell-zinc-copper-dietary-supplement-60-capsules-for-immune-system-support",
      "title": "Natuwell Zinc Copper Dietary Supplement - 60 Capsules for Immune System Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/wpXPpUeGvJHcOGESRdEU144JwHZQP1cUTht5A4v9.jpg?v=1790549833",
      "score": 29,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "natuwell",
        "zinc",
        "copper",
        "dietary",
        "supplement",
        "capsules",
        "for",
        "immune",
        "system",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 15,
        "manufacturing": 50,
        "safety": 42,
        "transparency": 20,
        "sustainability": 16
      },
      "price": 31.36,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575858925765",
      "vsf_explanation": "Natuwell Zinc Copper names its two active minerals but discloses no dose for either, even in its fully-rendered technical specifications section, making it impossible to confirm the product delivers a safe and effective amount. This hidden-dose formulation triggers an autofail and Rejected tier.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "folactive-dietary-supplement-90-tablets-for-nutritional-support-and-health-benefits",
      "title": "Folactive Dietary Supplement - 90 Tablets for Nutritional Support and Health Benefits",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/l8FMwKMEhljGM7dnNhuuFwBKj54SuauoY4c6IYhN.jpg?v=1790549833",
      "score": 23,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "folactive",
        "dietary",
        "supplement",
        "tablets",
        "for",
        "nutritional",
        "support",
        "and",
        "health",
        "benefits",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 15,
        "manufacturing": 35,
        "safety": 30,
        "transparency": 10,
        "sustainability": 30
      },
      "price": 38.82,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575858958533",
      "vsf_explanation": "Folactive's listing never names a single ingredient or dose despite the brand name implying a folate-based supplement, making it impossible to verify what the product actually delivers. This is one of the least transparent listings in the batch.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "foling-folic-acid-dietary-supplement-for-prenatal-nutrition-60-tablets",
      "title": "Foling Folic Acid Dietary Supplement for Prenatal Nutrition - 60 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/eCUtJU0Z6tds4mAYQOfPqBVXd5EiW6X6vjIOZtGn.jpg?v=1790549834",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "female",
      "life_stage": "prenatal",
      "tokens": [
        "foling",
        "folic",
        "acid",
        "dietary",
        "supplement",
        "for",
        "prenatal",
        "nutrition",
        "tablets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 75,
        "manufacturing": 50,
        "safety": 65,
        "transparency": 68,
        "sustainability": 35
      },
      "price": 46.66,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575859056837",
      "vsf_explanation": "Foling clearly discloses standard, prenatal-appropriate doses of bioavailable folate, iodine, and B12, all well-established nutrients for pregnancy support. The brand lacks disclosed manufacturing certification and sustainability information, keeping it at Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "collagen-forte-collagen-supplement-1500mg-premium-hydrolyzed-collagen-peptides-for-skin-hair-nail-joint-health-support",
      "title": "Collagen Forte Collagen Supplement 1500mg - Premium Hydrolyzed Collagen Peptides for Skin, Hair, Nail & Joint Health Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4E7qMrPQrgqLPr3eitbJz7lMMIPnLR4l6sibycNO.jpg?v=1790549834",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "collagen",
        "forte",
        "collagen",
        "supplement",
        "1500mg",
        "premium",
        "hydrolyzed",
        "collagen",
        "peptides",
        "for",
        "skin",
        "hair",
        "nail",
        "joint",
        "health",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 45,
        "safety": 65,
        "transparency": 55,
        "sustainability": 30
      },
      "price": 25.38,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575859024069",
      "vsf_explanation": "Collagen Forte discloses a 1500mg hydrolyzed collagen dose per serving, on the lower end of amounts used in published collagen research, and never discloses the collagen's animal source. Combined with the absence of manufacturing and sustainability information, the product falls just short of Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "alora-ultra-passiflora-30-tablets-natural-relaxation-aid-sleep-support-supplement-for-adults",
      "title": "Alora Ultra Passiflora 30 Tablets - Natural Relaxation Aid & Sleep Support Supplement for Adults",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/sUixCqsQXRCGNKtX9pLwjqLy8CCI5uHGRdGrNeBt_53219694-eb61-4c3f-98d6-6696ba0b1bec.jpg?v=1790549834",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alora",
        "ultra",
        "passiflora",
        "tablets",
        "natural",
        "relaxation",
        "aid",
        "sleep",
        "support",
        "supplement",
        "for",
        "adults",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 68,
        "manufacturing": 48,
        "safety": 62,
        "transparency": 60,
        "sustainability": 32
      },
      "price": 14.27,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575859089605",
      "vsf_explanation": "Alora Ultra Passiflora discloses a clear, traditionally-consistent dose of Passiflora extract, an herbal ingredient with modest published support for relaxation and sleep. It lacks sedative-interaction warnings and manufacturing/sustainability disclosures, landing it at Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mm-12-vitamin-b12-supplement-1000-µg-metilkobalamin-600-µg-methylfolate-sublingual-chewable-tablets-for-enhanced-bioavailability-30-count",
      "title": "MM-12 Vitamin B12 Supplement, 1000 µg Metilkobalamin & 600 µg Methylfolate, Sublingual Chewable Tablets for Enhanced Bioavailability - 30 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9uAEhuZEDwrVBOhgINvdLoBthNxu2nuN7qnLajDI.jpg?v=1790549834",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitamin",
        "b12",
        "supplement",
        "1000",
        "metilkobalamin",
        "600",
        "methylfolate",
        "sublingual",
        "chewable",
        "tablets",
        "for",
        "enhanced",
        "bioavailability",
        "count",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 75,
        "manufacturing": 55,
        "safety": 68,
        "transparency": 65,
        "sustainability": 35
      },
      "price": 20.88,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575859122373",
      "vsf_explanation": "MM-12 discloses precise, standard doses of methylcobalamin and methylfolate, both well-established nutrients, in a sublingual chewable format. Sourcing claims (Spain/Switzerland) are stated but not certified, and sustainability information is absent, placing it at Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ocean-vitamin-c-sr-sustained-release-vitamin-c-supplement-for-adults-30-tablets-immune-system-support",
      "title": "Ocean Vitamin C-SR Sustained Release Vitamin C Supplement for Adults - 30 Tablets, Immune System Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/hUTMq1f42lDZtqdVYrsVOsgGGpwzO2yZzXoJj1oS_a6369e64-d2ec-4eb0-a591-8d0cf74525fa.jpg?v=1790549835",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ocean",
        "vitamin",
        "sustained",
        "release",
        "vitamin",
        "supplement",
        "for",
        "adults",
        "tablets",
        "immune",
        "system",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 60,
        "manufacturing": 58,
        "safety": 85,
        "transparency": 50,
        "sustainability": 35
      },
      "price": 17.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575860990149",
      "vsf_explanation": "Ocean's Vitamin C-SR tablet discloses a clear, very safe 500 mg dose backed by strong generic evidence for immune support, though the sustained-release delivery claim is not backed by any dissolution or release-rate data. Manufacturing and transparency reflect Ocean's typical eczane-channel disclosure level.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "venatura-dietary-supplement-inositol-and-folic-acid-methylfolate-20-sachets",
      "title": "Venatura Dietary Supplement - Inositol and Folic Acid (Methylfolate) - 20 Sachets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/tmkGfYP0izxDbnYZxwQYefRnscZZFP9yF7MkMsOv.jpg?v=1790549835",
      "score": 51,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "venatura",
        "dietary",
        "supplement",
        "inositol",
        "and",
        "folic",
        "acid",
        "methylfolate",
        "sachets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 55,
        "manufacturing": 40,
        "safety": 62,
        "transparency": 60,
        "sustainability": 25
      },
      "price": 31.36,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575861022917",
      "vsf_explanation": "VeNatura's Inositol and Folic Acid sachets disclose specific doses of both actives, but the 200 mcg methylfolate amount falls below standard prenatal folate recommendations (400-800 mcg) even though the product is explicitly marketed to pregnant and breastfeeding women for fetal development. That dose-to-claim mismatch for a sensitive use-case is the primary reason for rejection.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "nbl-probiotic-comfort-probiotic-supplement-for-gut-health-support-10-sachets",
      "title": "NBL Probiotic Comfort Probiotic Supplement for Gut Health Support - 10 Sachets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/dZvZDxuye53draKoL82GrzlsA48Dey8PTe8UPTAn.jpg?v=1790549836",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nbl",
        "probiotic",
        "comfort",
        "probiotic",
        "supplement",
        "for",
        "gut",
        "health",
        "support",
        "sachets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 66,
        "manufacturing": 50,
        "safety": 80,
        "transparency": 50,
        "sustainability": 16
      },
      "price": 14.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575861940421",
      "vsf_explanation": "NBL Probiotic Comfort names four specific, well-studied probiotic strains and discloses an exact CFU count per sachet, a genuinely transparent formulation. Standard tier reflects this clean disclosure offset by the absence of manufacturing certification or third-party testing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "day2day-collagen-beauty-intense-strawberry-flavor-anti-aging-collagen-supplement",
      "title": "Day2Day Collagen Beauty Intense Strawberry Flavor - Anti-Aging Collagen Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Uj8YfZepEL7jFEhKAhoe6D6tjfiJHMqCYmmEAekh.jpg?v=1790549837",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint",
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "day2day",
        "collagen",
        "beauty",
        "intense",
        "strawberry",
        "flavor",
        "anti",
        "aging",
        "collagen",
        "supplement",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 38,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 116.63,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575863447749",
      "vsf_explanation": "Day2Day Collagen Beauty Intense's listing contains no disclosed collagen dose or supporting ingredient amounts anywhere in the available product content, only marketing language about skin benefits. Under a zero-assumption scoring standard this drops the product to Rejected tier until dosing is disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "orzax-ocean-osteofine-calcium-supplement-180-tablets",
      "title": "Orzax Ocean Osteofine - Calcium Supplement | 180 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0vtLDXOuIxdGQRQ1jmtY4cSd1vVvqVlLaHZOaxrF.jpg?v=1790549837",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "orzax",
        "ocean",
        "osteofine",
        "calcium",
        "supplement",
        "180",
        "tablets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 70,
        "manufacturing": 58,
        "safety": 70,
        "transparency": 75,
        "sustainability": 38
      },
      "price": 44.42,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575863480517",
      "vsf_explanation": "Orzax Ocean Osteofine discloses a full, well-balanced multi-mineral bone-health formula with exact mg amounts and %DV for all 8 ingredients — the most complete disclosure in this batch. It remains Standard tier because manufacturing certification and sustainability practices are not disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "osende-methylcobalamin-vitamin-b12-supplement-30-orally-disintegrating-tablets-for-energy-nerve-support",
      "title": "Osende Methylcobalamin Vitamin B12 Supplement - 30 Orally Disintegrating Tablets for Energy & Nerve Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/xoDIO3XuNZPMU6RTntB5HPiBjvps6GXZAImVE5tJ_c60d8df4-fff0-4755-9f76-e84cf09bcd3a.jpg?v=1790549837",
      "score": 53,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "osende",
        "methylcobalamin",
        "vitamin",
        "b12",
        "supplement",
        "orally",
        "disintegrating",
        "tablets",
        "for",
        "energy",
        "nerve",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 35,
        "manufacturing": 74,
        "safety": 78,
        "transparency": 35,
        "sustainability": 40
      },
      "price": 14.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575863546053",
      "vsf_explanation": "Osende Methylcobalamin B12 is a strawberry-mint orally disintegrating B12 tablet from an ISO-certified Turkish manufacturer, but the listing never discloses the actual microgram dose of its only active ingredient.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nbt-life-duobalance-mood-probiotic-supplement-30-capsules",
      "title": "NBT Life Duobalance Mood - Probiotic Supplement | 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4PuWiuqw4jY7lbKiRGaVMk0mAY9ymKD2SVaxeqeM_d9d8deb4-45f0-4f0f-abc6-210e7a449291.jpg?v=1790549837",
      "score": 53,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nbt",
        "life",
        "duobalance",
        "mood",
        "probiotic",
        "supplement",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 52,
        "safety": 68,
        "transparency": 66,
        "sustainability": 27
      },
      "price": 45.36,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575863513285",
      "vsf_explanation": "NBTLife's Duobalance Mood discloses a thorough allergen-free and additive-free ingredient posture but never names its probiotic strains or a CFU count, which are the two most essential facts for evaluating a probiotic product. That formulation gap places this SKU in Rejected tier despite a reasonably supportive gut-brain-axis evidence backdrop.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutraxin-folic-acid-400-mcg-dietary-supplement-100-tablets-vegan-allergen-free",
      "title": "Nutraxin Folic Acid 400 mcg Dietary Supplement - 100 Tablets, Vegan & Allergen-Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/mpyk4EBMw1QK72jFrDx33qebnS8dIZUOKO6WmTOk.jpg?v=1790549837",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutraxin",
        "folic",
        "acid",
        "400",
        "mcg",
        "dietary",
        "supplement",
        "100",
        "tablets",
        "vegan",
        "allergen",
        "free",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 70,
        "manufacturing": 45,
        "safety": 76,
        "transparency": 60,
        "sustainability": 20
      },
      "price": 15.41,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575863578821",
      "vsf_explanation": "Nutraxin's Folic Acid 400 mcg tablet discloses a clear, well-evidenced dose with an excellent safety margin and vegan-friendly, allergen-free formulation. It reaches Standard tier on clean dosing and labeling, though the brand's undisclosed manufacturing and sustainability practices cap it there.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "venatura-vitamin-d3-and-k2-dietary-supplement-liquid-20ml-supports-bone-health-and-immune-function",
      "title": "VeNatura Vitamin D3 and K2 Dietary Supplement Liquid - 20ml, Supports Bone Health and Immune Function",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/QOXBPv1q5tLYcDee9PP5OpPzFcpnL6ldmuhH7u63.jpg?v=1790549837",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "venatura",
        "vitamin",
        "and",
        "dietary",
        "supplement",
        "liquid",
        "20ml",
        "supports",
        "bone",
        "health",
        "and",
        "immune",
        "function",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 82,
        "manufacturing": 40,
        "safety": 80,
        "transparency": 65,
        "sustainability": 25
      },
      "price": 13.4,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575863644357",
      "vsf_explanation": "VeNatura's Vitamin D3 and K2 liquid discloses precise, well-evidenced doses using the more bioavailable K2 MK-7 form, making it the strongest-evidenced product in this batch. It reaches Standard tier, limited primarily by the brand's undisclosed manufacturing certification and sustainability practices.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "mega-joint-joint-health-mobility-supplement-for-active-individuals-60-tablets",
      "title": "Mega Joint - Joint Health & Mobility Supplement for Active Individuals - 60 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3yXebFjpxgrUXIKAt5gZFRD34GrHdA6UL37cEwWP.jpg?v=1790549837",
      "score": 22,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "mega",
        "joint",
        "joint",
        "health",
        "mobility",
        "supplement",
        "for",
        "active",
        "individuals",
        "tablets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 15,
        "manufacturing": 30,
        "safety": 30,
        "transparency": 10,
        "sustainability": 30
      },
      "price": 53.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575863611589",
      "vsf_explanation": "\"Mega Joint\" is a generic product label rather than a traceable brand, and the listing never names a single active ingredient or dose behind its joint-health claims. With no verifiable formula or manufacturer, this product cannot be responsibly assessed or recommended.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "day2day-collagen-supplement-5000mg-collagen-peptides-age-defying-skin-radiance-cherry-flavored-sugar-free",
      "title": "Day2Day Collagen Supplement - 5000mg Collagen Peptides, Age-Defying, Skin Radiance, Cherry Flavored, Sugar-Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/VTuqV07kncqFC7Tw7jiNViDJs32vN4p5yVLRRz5s.jpg?v=1790549837",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "day2day",
        "collagen",
        "supplement",
        "5000mg",
        "collagen",
        "peptides",
        "age",
        "defying",
        "skin",
        "radiance",
        "cherry",
        "flavored",
        "sugar",
        "free",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 66,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 68,
        "transparency": 52,
        "sustainability": 40
      },
      "price": 71.75,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575863677125",
      "vsf_explanation": "Day2Day's 5000mg Collagen Supplement clearly discloses its primary collagen dose and sourcing details, which supports a moderate evidence score, but three supporting antioxidant ingredients are named without amounts. It sits in the Standard tier pending fuller disclosure of the full formula.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nourkrin-man-hair-loss-supplement-for-men-supports-hair-health-growth-with-marilex-m-biotin-silica-60-tablets",
      "title": "Nourkrin Man Hair Loss Supplement for Men - Supports Hair Health & Growth with Marilex-M, Biotin & Silica - 60 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/tRR96kMs8VZIh1qsM9LKBNlg7uttSKp7wBqLkNPr.jpg?v=1790549838",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "nourkrin",
        "man",
        "hair",
        "loss",
        "supplement",
        "for",
        "men",
        "supports",
        "hair",
        "health",
        "growth",
        "with",
        "marilex",
        "biotin",
        "silica",
        "tablets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 78,
        "formulation": 72,
        "manufacturing": 78,
        "safety": 75,
        "transparency": 65,
        "sustainability": 45
      },
      "price": 143,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575863709893",
      "vsf_explanation": "Nourkrin Man is built around Marilex-M, a patented fish-extract proteoglycan complex with genuine published clinical research supporting hair growth outcomes, backed by an internationally established brand with real market history. Some ingredient amounts (Marilex-M, Fenugreek) are not individually quantified, which keeps it at Verified rather than Elite.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "new-life-c-1000-plus-food-supplement-30-capsules",
      "title": "New Life C-1000 Plus Food Supplement 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/newlifevitamin.jpg?v=1790549839",
      "score": 69,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "new",
        "life",
        "1000",
        "plus",
        "food",
        "supplement",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 72,
        "manufacturing": 76,
        "safety": 80,
        "transparency": 72,
        "sustainability": 42
      },
      "price": 31.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575863742661",
      "vsf_explanation": "New Life C-1000 Plus is a fully-dosed vitamin C, zinc, selenium, and vitamin D combination with every ingredient amount disclosed, made by an established Turkish supplement manufacturer with GMP-certified production.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natuwell-broline-bromelain-supplement-500mg-capsules-for-digestive-health-anti-inflammatory-support",
      "title": "Natuwell Broline Bromelain Supplement - 500mg Capsules for Digestive Health & Anti-Inflammatory Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/OWluVQQZ5FHncLVEvSjjpxZE1hYf4sNMB1CDnMkh.jpg?v=1790549839",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "natuwell",
        "broline",
        "bromelain",
        "supplement",
        "500mg",
        "capsules",
        "for",
        "digestive",
        "health",
        "anti",
        "inflammatory",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 56,
        "formulation": 64,
        "manufacturing": 50,
        "safety": 76,
        "transparency": 46,
        "sustainability": 16
      },
      "price": 17.38,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575863775429",
      "vsf_explanation": "Natuwell Broline is a clean single-ingredient bromelain supplement with a clear 500mg dose and a reasonable general safety profile. Standard tier reflects solid, verifiable dosing offset by the absence of manufacturing certification and blood-thinner interaction guidance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "voonka-sambucus-nigra-immune-support-supplement-42-chewing-tablets-for-adults-natural-wellness-energy-boost",
      "title": "Voonka Sambucus Nigra Immune Support Supplement - 42 Chewing Tablets for Adults, Natural Wellness & Energy Boost",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Hl8KXlv2BZvbFvF4STDumUXvxsjLffgjfuhKW363.jpg?v=1790549839",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "voonka",
        "sambucus",
        "nigra",
        "immune",
        "support",
        "supplement",
        "chewing",
        "tablets",
        "for",
        "adults",
        "natural",
        "wellness",
        "energy",
        "boost",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 35,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 38,
        "sustainability": 33
      },
      "price": 19.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575863808197",
      "vsf_explanation": "Voonka's Sambucus Nigra tablet names elderberry extract, CoQ10, and Vitamin C as actives but discloses the dose of none of them, making it impossible to verify whether the formula delivers a meaningful amount of any single ingredient. Because actual potency cannot be confirmed from the listing, this product is rejected pending full dose disclosure.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "nutraxin-vitamin-c-1000-mg-supplement-natural-allergen-friendly-gluten-free-30-tablets-for-immune-support",
      "title": "Nutraxin Vitamin C 1000 mg Supplement - Natural, Allergen-Friendly, Gluten-Free, 30 Tablets for Immune Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/lq0ZklCY3UsqY8mwwePtFePPy4H8NVOlzGfP7ySw_19d9f4f1-e61f-45ff-b5ad-8e00c8062b08.jpg?v=1790549839",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutraxin",
        "vitamin",
        "1000",
        "supplement",
        "natural",
        "allergen",
        "friendly",
        "gluten",
        "free",
        "tablets",
        "for",
        "immune",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 70,
        "manufacturing": 45,
        "safety": 76,
        "transparency": 60,
        "sustainability": 20
      },
      "price": 13.68,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575863840965",
      "vsf_explanation": "Nutraxin's Vitamin C 1000 mg tablet discloses a clear, well-evidenced dose with an excellent safety margin and allergen-free formulation. It reaches Standard tier on clean dosing and labeling, though the brand's undisclosed manufacturing and sustainability practices cap it there.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "folbiotic-folate-supplement-30-capsules-for-pregnancy-support-and-folate-deficiency",
      "title": "Folbiotic Folate Supplement - 30 Capsules for Pregnancy Support and Folate Deficiency",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/RKgl2kJ5A7BQesP1tiQjmMiLyA49yew1XV6aFiTB.jpg?v=1790549839",
      "score": 37,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "prenatal",
      "tokens": [
        "folbiotic",
        "folate",
        "supplement",
        "capsules",
        "for",
        "pregnancy",
        "support",
        "and",
        "folate",
        "deficiency",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 25,
        "manufacturing": 45,
        "safety": 50,
        "transparency": 15,
        "sustainability": 35
      },
      "price": 28.37,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575863873733",
      "vsf_explanation": "Folbiotic markets itself directly at pregnant and folate-deficient users but never discloses how much folate is actually in a capsule or what form of folate is used, making it impossible for a buyer to verify they are receiving an effective, safe prenatal dose.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "shiffa-home-vitamin-b12-ginkgo-biloba-supplement-28-tablets-natural-ingredients",
      "title": "Shiffa Home Vitamin B12 & Ginkgo Biloba Supplement - 28 Tablets | Natural Ingredients",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/10595032_01_f9392daa-0add-4085-9322-872afe9ae181.jpg?v=1790549841",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "shiffa",
        "home",
        "vitamin",
        "b12",
        "ginkgo",
        "biloba",
        "supplement",
        "tablets",
        "natural",
        "ingredients",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 30,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 20,
        "sustainability": 35
      },
      "price": 11.36,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575863939269",
      "vsf_explanation": "Shiffa Home's B12 & Ginkgo Biloba tablets name their active ingredients but never disclose how much of each active is actually in a tablet, only the total tablet weight. Without individual ingredient amounts, buyers cannot verify they are receiving a meaningful dose of either active.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "day2day-collagen-beauty-plus-nutritional-supplement-40-ml-x-30-packs",
      "title": "Day2Day Collagen Beauty Plus - Nutritional Supplement | 40 ml x 30 Packs",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/day2day-the-collagen-beauty-plus-liqui--dd06_b0a2be79-5504-4b7a-bf0e-06e6b704d624.jpg?v=1790549841",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "day2day",
        "collagen",
        "beauty",
        "plus",
        "nutritional",
        "supplement",
        "packs",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 58,
        "safety": 70,
        "transparency": 62,
        "sustainability": 40
      },
      "price": 60.56,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575863972037",
      "vsf_explanation": "Day2Day Collagen Beauty Plus discloses a full ingredient panel with specific per-serving amounts for collagen, vitamin C, and supporting actives, which is above average for this brand's line. It lands in the Standard tier because manufacturing and sustainability practices are not independently disclosed or certified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "day2day-collagen-all-body-300g-powder-supplement",
      "title": "Day2Day Collagen All Body - 300g Powder Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/qrDlceA2kvzPGE4P3tlLuoFO0tXUjtQ8RyoEUF22.jpg?v=1790549841",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "day2day",
        "collagen",
        "all",
        "body",
        "300g",
        "powder",
        "supplement",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 64,
        "formulation": 70,
        "manufacturing": 58,
        "safety": 70,
        "transparency": 60,
        "sustainability": 40
      },
      "price": 34.96,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575864004805",
      "vsf_explanation": "Day2Day Collagen All Body discloses a detailed per-scoop ingredient breakdown across 12 actives including three collagen types plus vitamin D3 and K2. The listing's incomplete disclaimer text is a content-quality flag, and the product remains Standard tier pending disclosed manufacturing certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutraxin-bromelain-500-mg-dietary-supplement-60-capsules",
      "title": "Nutraxin Bromelain 500 mg - Dietary Supplement | 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9o1DUggLomkIMmxYOTkwEySs4NUCB6alhUp7kREi.jpg?v=1790549841",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutraxin",
        "bromelain",
        "500",
        "dietary",
        "supplement",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 66,
        "manufacturing": 45,
        "safety": 74,
        "transparency": 60,
        "sustainability": 20
      },
      "price": 23.02,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575864037573",
      "vsf_explanation": "Nutraxin's Bromelain 500 mg capsules disclose a specific dose and potency and carry the most thorough safety-caution language of any bromelain SKU in this batch, including allergy and medication-interaction guidance. It reaches Standard tier on clear labeling and responsible safety communication.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "abay-pharma-ahcc-professional-shitake-mushroom-supplement-30-sachets",
      "title": "Abay Pharma AHCC Professional Shitake Mushroom Supplement 30 Sachets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/QJKs2vUDwGiGaBTQcbNOcDRSRZ0BsYTFHg0UhDcB.jpg?v=1790549841",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "abay",
        "pharma",
        "ahcc",
        "professional",
        "shitake",
        "mushroom",
        "supplement",
        "sachets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 70,
        "manufacturing": 55,
        "safety": 65,
        "transparency": 60,
        "sustainability": 40
      },
      "price": 173.65,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575864070341",
      "vsf_explanation": "Abay Pharma's AHCC Professional delivers a clearly dosed 1000mg-per-sachet shiitake-derived AHCC extract, an ingredient with genuine published immune-function research, at doses consistent with that research. It lacks manufacturing certifications and sustainability disclosures, placing it solidly in Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "argivit-multivitamin-supplement-30-tablets",
      "title": "Argivit Multivitamin Supplement - 30 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Z6C2dVVNbAzpuT5HPEQgQVyUWQVtCyTl3HentMvw.jpg?v=1790549843",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "argivit",
        "multivitamin",
        "supplement",
        "tablets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 35,
        "manufacturing": 55,
        "safety": 55,
        "transparency": 25,
        "sustainability": 38
      },
      "price": 23.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575864365253",
      "vsf_explanation": "This Argivit multivitamin names seven individual ingredients including L-arginine and phosphatidylserine but discloses no dose for any of them. With no quantified amounts to evaluate, the product scores Rejected under a zero-assumption standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "cebrolux-nf-vitamin-supplement-30-sachets",
      "title": "Cebrolux NF Vitamin Supplement - 30 Sachets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/YjRmggU7bgNzexXV449SQqwAQqT3IKZLyr3E6fly.jpg?v=1790549845",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "cebrolux",
        "vitamin",
        "supplement",
        "sachets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 30,
        "manufacturing": 48,
        "safety": 68,
        "transparency": 30,
        "sustainability": 30
      },
      "price": 35.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575864398021",
      "vsf_explanation": "Cebrolux NF combines citicoline with a broad vitamin blend (A, B-complex, beta carotene, biotin, C, zinc, E, folic acid) in a lemon-flavored sachet. This listing names all ingredients but discloses no dose for citicoline or any vitamin, which limits assessment of the formula's effective strength.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutraxin-bromelain-500-mg-digestive-health-supplement-60-tablets",
      "title": "Nutraxin Bromelain 500 mg - Digestive Health Supplement | 60 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ZrECvuPqPeGpskq4CNESGVKuRIPbmyrSk8FX6fFA.jpg?v=1790549846",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutraxin",
        "bromelain",
        "500",
        "digestive",
        "health",
        "supplement",
        "tablets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 66,
        "manufacturing": 45,
        "safety": 72,
        "transparency": 60,
        "sustainability": 20
      },
      "price": 18.54,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575864430789",
      "vsf_explanation": "Nutraxin's Bromelain 500 mg (Digestive Health) tablet discloses a specific dose and potency and includes a clear compliance disclaimer that it is not a medication. It reaches Standard tier on clear labeling and responsible claims, though brand-level manufacturing and sustainability disclosures remain absent.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sinfer-20-sachets-iron-folate-vitamin-c-supplement-20-pack",
      "title": "Sinfer 20 Sachets Iron, Folate & Vitamin C Supplement 20 Pack",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/khFDfwTIMh412gpWwu7rpS2mi9zE5Q4nwvV3LSFW.jpg?v=1790549846",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sinfer",
        "sachets",
        "iron",
        "folate",
        "vitamin",
        "supplement",
        "pack",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 78,
        "manufacturing": 55,
        "safety": 80,
        "transparency": 72,
        "sustainability": 32
      },
      "price": 23.05,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575864463557",
      "vsf_explanation": "Sinfer discloses a full supplement facts table (17 mg iron, 100 mg vitamin C, 600 mcg folic acid per sachet) and explicitly disclaims disease-treatment intent, reflecting responsible labeling. Facility and third-party testing information is not disclosed in this listing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutraxin-artroflex-easy-move-joint-support-supplement-30-sachets",
      "title": "Nutraxin Artroflex Easy Move - Joint Support Supplement | 30 Sachets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/wS65XwYW74FHSv4Z1NVWRS29PoSmxKmDYINtFLp1.jpg?v=1790549846",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutraxin",
        "artroflex",
        "easy",
        "move",
        "joint",
        "support",
        "supplement",
        "sachets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 66,
        "formulation": 68,
        "manufacturing": 45,
        "safety": 68,
        "transparency": 60,
        "sustainability": 20
      },
      "price": 40.77,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575864496325",
      "vsf_explanation": "Nutraxin Artroflex Easy Move discloses specific, well-evidenced doses for its five headline joint-support ingredients, though a handful of additional ingredients are left unnamed and undosed. It reaches Standard tier on the strength of its disclosed core formula, with the brand's undisclosed manufacturing and sustainability practices capping it there.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ocean-alfa-lipoik-asit-200-mg-dietary-supplement-30-vegetable-capsules",
      "title": "Ocean Alfa Lipoik Asit 200 mg Dietary Supplement - 30 Vegetable Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/RJds7daFIgSlqmktXkZ93VSK1NpaQDjTQ7MmiiTK_813f2050-8630-41df-8fe4-1211fd26e705.jpg?v=1790549892",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ocean",
        "alfa",
        "lipoik",
        "asit",
        "200",
        "dietary",
        "supplement",
        "vegetable",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 68,
        "manufacturing": 58,
        "safety": 78,
        "transparency": 58,
        "sustainability": 35
      },
      "price": 26.86,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575867379909",
      "vsf_explanation": "Ocean's Alpha Lipoic Acid capsule discloses both a clear 200 mg dose and the specific R-isomer, the form most associated with biological activity in the moderate clinical evidence base for ALA. Manufacturing and sustainability reflect Ocean's typical eczane-channel standard, unchanged from other SKUs in the brand.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "regula-3-gold-omega-3-supplement-30-capsules",
      "title": "Regula-3 Gold Omega-3 Supplement, 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/e7uwBh6APdGVjrhapEeF6R9cfazPztGCFuVwKeae.jpg?v=1790549893",
      "score": 29,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "regula",
        "gold",
        "omega",
        "supplement",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 15,
        "manufacturing": 45,
        "safety": 55,
        "transparency": 15,
        "sustainability": 25
      },
      "price": 46.31,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575867412677",
      "vsf_explanation": "Regula-3 Gold is marketed as an omega-3 capsule supplement, but this listing discloses no ingredient source, dose, or composition detail beyond the product category itself. The near-total absence of formulation information prevents any meaningful evidence or safety assessment.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutraxin-vitamin-max-c-d-zinc-supplement-for-adults-vitamin-c-d3-zinc-60-tablets-vegetarian-vegan-friendly",
      "title": "Nutraxin Vitamin Max C&D Zinc Supplement for Adults - Vitamin C, D3 & Zinc - 60 Tablets, Vegetarian & Vegan Friendly",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/kYwPpuCsMfrD2S7dpDYPNdsn3uFyih9O5fua8J39.jpg?v=1790549892",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutraxin",
        "vitamin",
        "max",
        "zinc",
        "supplement",
        "for",
        "adults",
        "vitamin",
        "zinc",
        "tablets",
        "vegetarian",
        "vegan",
        "friendly",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 70,
        "manufacturing": 45,
        "safety": 74,
        "transparency": 60,
        "sustainability": 20
      },
      "price": 23.93,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575867510981",
      "vsf_explanation": "Nutraxin Vitamin Max C&D Zinc discloses clear, appropriately dosed amounts of three generically well-evidenced immune-support ingredients. It reaches Standard tier on clean formulation and dosing, though the brand's undisclosed manufacturing and sustainability practices cap it there.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "imuneks-magnesium-supplement-combo-30-tablets-for-overall-health-wellness",
      "title": "Imuneks Magnesium Supplement Combo - 30 Tablets for Overall Health & Wellness",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/TiHrwmI40DVhi80AJ3z1uaSOIb0TWAQm5z1UG9E6.jpg?v=1790549892",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "imuneks",
        "magnesium",
        "supplement",
        "combo",
        "tablets",
        "for",
        "overall",
        "health",
        "wellness",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 25,
        "manufacturing": 70,
        "safety": 55,
        "transparency": 30,
        "sustainability": 38
      },
      "price": 13.4,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575867445445",
      "vsf_explanation": "Imuneks Magnesium Combo is marketed for general health and wellness, but the listing never discloses which magnesium form(s) it contains or the actual dose, making the formulation impossible to verify.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "nutraxin-biotin-forte-60-tablets-hair-growth-support-skin-health-supplement",
      "title": "Nutraxin Biotin Forte 60 Tablets - Hair Growth Support & Skin Health Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/EvtyWLmaEmWDZaitEYtISg070ZzFxBVqMlgNja6g_0dfb078f-6393-4c05-b318-d4471ff3b582.jpg?v=1790549892",
      "score": 39,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutraxin",
        "biotin",
        "forte",
        "tablets",
        "hair",
        "growth",
        "support",
        "skin",
        "health",
        "supplement",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 30,
        "manufacturing": 45,
        "safety": 65,
        "transparency": 35,
        "sustainability": 20
      },
      "price": 20.57,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575867543749",
      "vsf_explanation": "Nutraxin Biotin Forte is branded as a high-strength biotin product but discloses no actual dose anywhere on its page, making its central 'Forte' claim unverifiable. That transparency gap, combined with the brand's undisclosed manufacturing and sustainability practices, results in a Rejected-tier score.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "krilom-omega-3-dietary-supplement-100-softgel-capsules-with-epa-dha-and-astaxanthin-for-heart-health",
      "title": "Krilom Omega-3 Dietary Supplement - 100 Softgel Capsules with EPA, DHA, and Astaxanthin for Heart Health",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9nYYZP0R8ikBMzZ8VWXwv01yPh1CnB7Ds0s8MXma.jpg?v=1790549892",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "krilom",
        "omega",
        "dietary",
        "supplement",
        "100",
        "softgel",
        "capsules",
        "with",
        "epa",
        "dha",
        "and",
        "astaxanthin",
        "for",
        "heart",
        "health",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 78,
        "manufacturing": 52,
        "safety": 78,
        "transparency": 70,
        "sustainability": 32
      },
      "price": 44.81,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575867609285",
      "vsf_explanation": "Krilom discloses a full and clear per-serving dose breakdown (950 mg fish oil, 340 mg EPA, 235 mg DHA, 110 mcg astaxanthin), doses consistent with published omega-3 and antioxidant research. Manufacturing certifications and fish sourcing are not disclosed in this listing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bestiron-iron-and-vitamin-c-supplement-drops-for-kids-30ml-dietary-support",
      "title": "Bestiron Iron and Vitamin C Supplement Drops for Kids - 30ml Dietary Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/DQdsWbBjJkGwUC9fnDyBOqIjwyiqHnjSNwjc2OiM.jpg?v=1790549892",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "youth_under_18",
      "tokens": [
        "bestiron",
        "iron",
        "and",
        "vitamin",
        "supplement",
        "drops",
        "for",
        "kids",
        "30ml",
        "dietary",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 35,
        "manufacturing": 50,
        "safety": 55,
        "transparency": 32,
        "sustainability": 28
      },
      "price": 23.87,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575867740357",
      "vsf_explanation": "Bestiron discloses iron and vitamin C concentration per mL (8 mg iron, 80 mg vitamin C) for children aged 4-10, and includes a responsible disclaimer against disease-treatment claims. However, the actual recommended daily dose volume is not disclosed in this listing, which matters for a pediatric iron product given iron's narrow safety margin in children.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lookvitneo-dietary-supplement-with-resveratrol-saffron-astaxanthin-fish-oil-30-capsules",
      "title": "Lookvitneo Dietary Supplement with Resveratrol, Saffron, Astaxanthin & Fish Oil - 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/KZ2zLPQRhsfT2ZlhxkmwkOjFeaQ29KaHzWAVueNb.jpg?v=1790549893",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive",
        "longevity"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lookvitneo",
        "dietary",
        "supplement",
        "with",
        "resveratrol",
        "saffron",
        "astaxanthin",
        "fish",
        "oil",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 32,
        "manufacturing": 48,
        "safety": 68,
        "transparency": 32,
        "sustainability": 30
      },
      "price": 49.3,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575867478213",
      "vsf_explanation": "Lookvitneo combines liposomal resveratrol, saffron, astaxanthin and fish oil for antioxidant and wellness support, ingredients with individual research bases. This listing does not disclose the dose of any of the four active ingredients, which limits confidence in the formula's effective strength.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ocean-plus-omega-3-supplement-1200-mg-purified-fish-oil-capsules",
      "title": "Ocean Plus Omega-3 Supplement - 1200 mg Purified Fish Oil Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/TJD4iDaOldPyqNWIvtaQ1drGoTIPyiTUKPqpjJng_918a6d9a-40eb-4a90-883c-4907f25425e5.jpg?v=1790549893",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ocean",
        "plus",
        "omega",
        "supplement",
        "1200",
        "purified",
        "fish",
        "oil",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 58,
        "safety": 76,
        "transparency": 60,
        "sustainability": 35
      },
      "price": 17.2,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575867576517",
      "vsf_explanation": "Ocean's Plus Omega-3 capsule discloses a specific EPA/DHA breakdown and describes a purification process, going further than most SKUs in this brand's line, and is backed by strong generic evidence for omega-3's cardiovascular and brain benefits. Its 'sustainable sourcing' claim is unverified and did not change the sustainability score, and manufacturing follows Ocean's typical eczane-channel standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bioxcin-biotin-5000-mcg-hair-skin-nail-supplement-60-tablets-2-month-supply",
      "title": "Bioxcin Biotin 5000 mcg - Hair, Skin & Nail Supplement | 60 Tablets | 2-Month Supply",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/B548CYH8PVznGYBPGAVnbbaRCdeklcLHkj1nkpQX.jpg?v=1790549893",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "bioxcin",
        "biotin",
        "5000",
        "mcg",
        "hair",
        "skin",
        "nail",
        "supplement",
        "tablets",
        "month",
        "supply",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 64,
        "manufacturing": 65,
        "safety": 68,
        "transparency": 50,
        "sustainability": 25
      },
      "price": 17.82,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575867674821",
      "vsf_explanation": "Bioxcin Biotin 5000mcg is a clean, single-ingredient formula with a clearly disclosed high-potency dose from an established brand, though evidence for hair/skin/nail benefit specifically in non-deficient users is weaker than the marketing implies. Standard tier reflects solid formulation transparency offset by unaddressed lab-test-interference safety guidance.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "venatura-n-acetyl-d-glucosamine-supplement-90-tablets-for-joint-health-support",
      "title": "VeNatura N-Acetyl D-Glucosamine Supplement - 90 Tablets for Joint Health Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/tEAIYfaeBsp9Nm29n8CwyGsTdwOOoViiwqA4I5fW_f8ae8b5f-0203-4735-b4dd-c310d0d5248c.jpg?v=1790549892",
      "score": 38,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "venatura",
        "acetyl",
        "glucosamine",
        "supplement",
        "tablets",
        "for",
        "joint",
        "health",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 32,
        "formulation": 30,
        "manufacturing": 40,
        "safety": 68,
        "transparency": 30,
        "sustainability": 25
      },
      "price": 23.87,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575867707589",
      "vsf_explanation": "VeNatura markets N-Acetyl-D-Glucosamine specifically for joint comfort, but the well-studied joint-health clinical literature centers on glucosamine sulfate/HCl, not NAG, and no per-tablet dose is disclosed for the active used here. This evidence-to-claim mismatch and dosing gap place the product in the Rejected tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "i̇munol-complex-beta-glucan-supplement-boosts-immune-system-support-30-capsules-dietary-supplement-for-health-conscious-individuals",
      "title": "İmunol Complex Beta Glucan Supplement - Boosts Immune System Support, 30 Capsules, Dietary Supplement for Health-Conscious Individuals",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/I6rxMoWk2cOqD1Rh0yqyWmUCUvCdJNnwDDWhq3G6_bedaba08-944f-438e-8eb7-43d79f1f8638.jpg?v=1790549892",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "munol",
        "complex",
        "beta",
        "glucan",
        "supplement",
        "boosts",
        "immune",
        "system",
        "support",
        "capsules",
        "dietary",
        "supplement",
        "for",
        "health",
        "conscious",
        "individuals",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 32,
        "manufacturing": 48,
        "safety": 70,
        "transparency": 32,
        "sustainability": 30
      },
      "price": 19.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575867642053",
      "vsf_explanation": "İmunol Complex is a single-ingredient beta-glucan supplement, an ingredient with genuine published immune-modulation research. This listing does not disclose the per-capsule beta-glucan dose, which limits confidence in whether the amount is efficacious.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "thendojen-collagen-supplement-for-joint-health-skin-hydration-500-mg-tablets-with-hyaluronic-acid-vitamin-c-zinc-copper",
      "title": "Thendojen Collagen Supplement for Joint Health & Skin Hydration - 500 mg Tablets with Hyaluronic Acid, Vitamin C, Zinc & Copper",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/1D7QKq8Sjf7H3VXPPVSYreFrKvOf5PDz8BN6w6Fk.jpg?v=1790549893",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "thendojen",
        "collagen",
        "supplement",
        "for",
        "joint",
        "health",
        "skin",
        "hydration",
        "500",
        "tablets",
        "with",
        "hyaluronic",
        "acid",
        "vitamin",
        "zinc",
        "copper",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 45,
        "manufacturing": 50,
        "safety": 72,
        "transparency": 42,
        "sustainability": 30
      },
      "price": 40.34,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575867773125",
      "vsf_explanation": "Thendojen discloses 500 mg of hydrolyzed collagen per tablet alongside hyaluronic acid, vitamin C, zinc and copper for joint and skin support. Doses for the non-collagen actives and the total daily tablet count are not disclosed, limiting assessment of the complete daily dose.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "now-red-krill-oil-500mg-supplement-omega-3-epa-dha-dietary-30-capsules",
      "title": "NOW Red Krill Oil 500mg Supplement - Omega-3 EPA & DHA Dietary - 30 Capsules",
      "vendor": "NOW",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/szQoE1OsVo4NDRhgZZAbDtMjWbTUPxgt6Sycvxxe.jpg?v=1790549893",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "now",
        "red",
        "krill",
        "oil",
        "500mg",
        "supplement",
        "omega",
        "epa",
        "dha",
        "dietary",
        "capsules",
        "now"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 75,
        "manufacturing": 75,
        "safety": 80,
        "transparency": 68,
        "sustainability": 38
      },
      "price": 40.86,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575867838661",
      "vsf_explanation": "This is a genuine NOW Foods product, a large and well-established U.S. supplement manufacturer, offering a clearly dosed Red Krill Oil supplement (500 mg krill oil, 66 mg EPA, 35 mg DHA per capsule). Facility-specific certifications and krill sourcing details are not disclosed in this particular listing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nbt-life-magnesium-p5p-vitamin-b6-supplement-60-capsules-for-overall-health-wellness",
      "title": "Nbt Life Magnesium P5P Vitamin B6 Supplement - 60 Capsules for Overall Health & Wellness",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/a0Wm0UWuaw1xKihnE7I7TZIg6IWFw1oE9F7aDGR2.jpg?v=1790549893",
      "score": 53,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nbt",
        "life",
        "magnesium",
        "p5p",
        "vitamin",
        "supplement",
        "capsules",
        "for",
        "overall",
        "health",
        "wellness",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 42,
        "manufacturing": 52,
        "safety": 50,
        "transparency": 62,
        "sustainability": 27
      },
      "price": 25.38,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575867871429",
      "vsf_explanation": "NBTLife's Magnesium P5P B6 product names its two active ingredients but never discloses their per-capsule mg amounts anywhere in the available listing copy, a significant gap for a two-ingredient supplement. That omission drags formulation and safety scores down enough to place this SKU in Rejected tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "retendo-dietary-supplement-for-joint-health-support-30-capsules-with-mukopoligen-complex-glucosamine-and-vitamin-c",
      "title": "Retendo Dietary Supplement for Joint Health Support - 30 Capsules with Mukopoligen Complex, Glucosamine, and Vitamin C",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/YWZyiVByvDaWFhvJV9mN4Bx0NgTtMQ601UHa8Fcq.jpg?v=1790549893",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "retendo",
        "dietary",
        "supplement",
        "for",
        "joint",
        "health",
        "support",
        "capsules",
        "with",
        "mukopoligen",
        "complex",
        "glucosamine",
        "and",
        "vitamin",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 20,
        "manufacturing": 48,
        "safety": 62,
        "transparency": 20,
        "sustainability": 28
      },
      "price": 59.77,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575867805893",
      "vsf_explanation": "Retendo centers its formula on an undefined 'Mukopoligen Complex' alongside glucosamine, collagen and vitamin C, but discloses no dose for any of the four components and does not explain what specific ingredients make up the named complex. This lack of ingredient-level dose disclosure behind a named complex is treated as a proprietary blend hiding dose.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "nutraxin-psyllium-husk-fiber-30-sachets-natural-digestive-health-support-constipation-relief-supplement",
      "title": "Nutraxin Psyllium Husk Fiber 30 Sachets - Natural Digestive Health Support & Constipation Relief Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4zuiPeRQKhjJooHoXhXP0C4ZNl37i30XNrOoZ2IX.jpg?v=1790549893",
      "score": 53,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutraxin",
        "psyllium",
        "husk",
        "fiber",
        "sachets",
        "natural",
        "digestive",
        "health",
        "support",
        "constipation",
        "relief",
        "supplement",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 45,
        "safety": 68,
        "transparency": 50,
        "sustainability": 20
      },
      "price": 26.41,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575867904197",
      "vsf_explanation": "Nutraxin's Psyllium Husk Fiber uses a well-evidenced natural fiber ingredient, but the product page never discloses the gram weight per sachet, which is the key variable for whether the dose is actually effective. That gap, plus undisclosed manufacturing and sustainability practices, results in a Rejected-tier score.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "argivit-mens-health-supplement-stress-management-energy-hair-loss-prevention-for-adult-men",
      "title": "Argivit Men's Health Supplement - Stress Management, Energy & Hair Loss Prevention for Adult Men",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BrbukgBR4g3wSK0yk7KT8X4ZHGfxeVncIEqF6OWP.jpg?v=1790549893",
      "score": 35,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood",
        "energy",
        "skin"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "argivit",
        "men",
        "health",
        "supplement",
        "stress",
        "management",
        "energy",
        "hair",
        "loss",
        "prevention",
        "for",
        "adult",
        "men",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 25,
        "manufacturing": 55,
        "safety": 45,
        "transparency": 18,
        "sustainability": 38
      },
      "price": 52.86,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575867936965",
      "vsf_explanation": "Argivit's men's health supplement is marketed under a branded 'Gold Kompleks' blend name spanning four separate health claims (stress, energy, hair, prostate) without disclosing a single ingredient or dose behind it. This proprietary-blend non-disclosure pattern results in a Rejected score.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "wellcare-vitamin-b12-supplement-methylcobalamin-energy-support-5ml",
      "title": "Wellcare Vitamin B12 Supplement - Methylcobalamin Energy Support 5ml",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/rlYtazzvO2BIrsyWybOO8GQVFaApAv6kKsgpjzhn_9656f347-2d27-4a68-817a-445e711ac9b6.jpg?v=1790549896",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wellcare",
        "vitamin",
        "b12",
        "supplement",
        "methylcobalamin",
        "energy",
        "support",
        "5ml",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 60,
        "manufacturing": 52,
        "safety": 80,
        "transparency": 48,
        "sustainability": 18
      },
      "price": 19.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575867969733",
      "vsf_explanation": "Wellcare Vitamin B12 delivers a clearly dosed 1000mcg methylcobalamin, the well-evidenced active form of the vitamin, though its energy-boosting marketing overstates benefits for non-deficient users. Standard tier reflects clean disclosure paired with no manufacturing or sustainability transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sjomanns-vitamin-d3-1000-iu-chewable-jelly-supplement-for-bone-health-support",
      "title": "Sjomanns Vitamin D3 1000 IU Chewable Jelly Supplement for Bone Health Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/t8Gc1BIae2GOJCRVR02utUlihKYZN4QlUSaR6oRi.jpg?v=1790549896",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sjomanns",
        "vitamin",
        "1000",
        "chewable",
        "jelly",
        "supplement",
        "for",
        "bone",
        "health",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 72,
        "manufacturing": 52,
        "safety": 80,
        "transparency": 62,
        "sustainability": 30
      },
      "price": 13.4,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575868002501",
      "vsf_explanation": "Sjomanns delivers a clearly disclosed 1000 IU dose of vitamin D3 (cholecalciferol) in an easy-to-consume chewable jelly format, a dose within standard, well-tolerated ranges. No facility or testing certifications are disclosed for this specific product.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dynavit-biotin-2000-mcg-supplement-100-tablets-for-hair-skin-nail-health",
      "title": "Dynavit Biotin 2000 Mcg Supplement - 100 Tablets for Hair, Skin & Nail Health",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MDZTIxuzeVYstqEsxQoBkYq7zpDZgwcHFKsx6gfr.jpg?v=1790549896",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dynavit",
        "biotin",
        "2000",
        "mcg",
        "supplement",
        "100",
        "tablets",
        "for",
        "hair",
        "skin",
        "nail",
        "health",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 65,
        "manufacturing": 82,
        "safety": 68,
        "transparency": 68,
        "sustainability": 48
      },
      "price": 32.85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575868035269",
      "vsf_explanation": "Dynavit Biotin 2000mcg discloses a moderate, clearly stated dose for hair, skin, and nail support, manufactured under the Eczacıbaşı pharmaceutical group, though the evidence for benefit is strongest in biotin-deficient users.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "advancemax-vitamin-d3-k2-spray-liposomal-vitamin-supplement-for-kids-and-adults-gluten-free-lactose-free-1-01-fl-oz",
      "title": "Advancemax Vitamin D3 K2 Spray, Liposomal Vitamin Supplement for Kids and Adults - Gluten-Free, Lactose-Free, 1.01 fl oz",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Rd2fk0o4RpJh1tE9mhMr37VWDDsRsMhkVHdQwIwA.jpg?v=1790549896",
      "score": 47,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "youth_under_18",
      "tokens": [
        "advancemax",
        "vitamin",
        "spray",
        "liposomal",
        "vitamin",
        "supplement",
        "for",
        "kids",
        "and",
        "adults",
        "gluten",
        "free",
        "lactose",
        "free",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 38,
        "manufacturing": 50,
        "safety": 75,
        "transparency": 38,
        "sustainability": 30
      },
      "price": 21.32,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575868068037",
      "vsf_explanation": "Advancemax markets a liposomal vitamin D3/K2 spray for both children and adults, free of common allergens. This listing does not disclose the amount of D3 or K2 delivered per spray, which is a notable gap for a product explicitly marketed for pediatric dosing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutraxin-hyaluronic-acid-30-tablets-anti-aging-dietary-supplement-for-skin-health-support",
      "title": "Nutraxin Hyaluronic Acid 30 Tablets - Anti-Aging Dietary Supplement for Skin Health Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/n72DLlQ2A8aXBzD3nvL6i1q0dL8EbSRMkPjNK1Yk.jpg?v=1790549898",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutraxin",
        "hyaluronic",
        "acid",
        "tablets",
        "anti",
        "aging",
        "dietary",
        "supplement",
        "for",
        "skin",
        "health",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 45,
        "safety": 73,
        "transparency": 60,
        "sustainability": 20
      },
      "price": 12.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575868133573",
      "vsf_explanation": "Nutraxin's Hyaluronic Acid tablet discloses clear, individually dosed amounts of three generically well-evidenced skin-support ingredients. It reaches Standard tier on clean dosing and formulation, though the brand's undisclosed manufacturing and sustainability practices cap it there.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutraxin-multivitamin-mineral-immune-support-supplement-60-tablets-boosts-immune-system-energy",
      "title": "Nutraxin Multivitamin Mineral Immune Support Supplement - 60 Tablets | Boosts Immune System & Energy",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/nutraxin-multivitamin-mineral-immune-6-72-866_ef1cc7a8-f725-49cd-8e9c-a58bf4410c86.jpg?v=1790549898",
      "score": 49,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutraxin",
        "multivitamin",
        "mineral",
        "immune",
        "support",
        "supplement",
        "tablets",
        "boosts",
        "immune",
        "system",
        "energy",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 66,
        "transparency": 50,
        "sustainability": 20
      },
      "price": 20.57,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575868166341",
      "vsf_explanation": "Nutraxin's Multivitamin Mineral Immune Support product combines a broad vitamin/mineral base with named immune-support botanicals, but discloses no individual ingredient doses, making the actual strength of the formula unverifiable. That gap, plus undisclosed manufacturing and sustainability practices, results in a Rejected-tier score.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "debin-vitamin-d3-and-k2-supplement-60-capsules-for-bone-health-and-immune-support",
      "title": "Debin Vitamin D3 and K2 Supplement - 60 Capsules for Bone Health and Immune Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/KGBexOjZIdkh3du9dNsdSDxYYe1z8buvkRCkcPVH.jpg?v=1790549898",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "debin",
        "vitamin",
        "and",
        "supplement",
        "capsules",
        "for",
        "bone",
        "health",
        "and",
        "immune",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 68,
        "manufacturing": 52,
        "safety": 72,
        "transparency": 45,
        "sustainability": 30
      },
      "price": 17.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575868199109",
      "vsf_explanation": "Debin discloses clear per-capsule doses of vitamin D3 (25 mcg) and K2 (11.25 mcg), both within standard, well-tolerated ranges. However, the listing states the product reduces osteoporosis risk, a specific disease-risk claim made without a calcium component or supporting citation, which is treated as an unverified disease claim.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "nbl-probiotic-gold-10-stick-probiotic-supplement-for-digestive-health-immune-system-support",
      "title": "NBL Probiotic Gold 10 Stick - Probiotic Supplement for Digestive Health & Immune System Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/GFS8jRR8UB2JC2CRwuobEiadnCRH02XnwmnwMocf.jpg?v=1790549899",
      "score": 29,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nbl",
        "probiotic",
        "gold",
        "stick",
        "probiotic",
        "supplement",
        "for",
        "digestive",
        "health",
        "immune",
        "system",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 15,
        "manufacturing": 50,
        "safety": 42,
        "transparency": 20,
        "sustainability": 16
      },
      "price": 20.88,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575868231877",
      "vsf_explanation": "NBL Probiotic Gold makes digestive and immune claims without disclosing which probiotic strain(s) or what CFU potency the product delivers, unlike the brand's own Comfort variant. This hidden-potency formulation triggers an autofail and Rejected tier.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "zade-vital-probiyotik-feminen-probiotic-dietary-supplement-for-womens-health-30-capsules",
      "title": "Zade Vital Probiyotik Feminen Probiotic Dietary Supplement for Women's Health - 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/C3cQTogNYgqrRXvHK2gCryw66BV3EB2Zm8dUUgJ4_08135433-a75b-4ca7-bedf-04a714c3635e.jpg?v=1790549899",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "zade",
        "vital",
        "probiyotik",
        "feminen",
        "probiotic",
        "dietary",
        "supplement",
        "for",
        "women",
        "health",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 78,
        "manufacturing": 48,
        "safety": 68,
        "transparency": 66,
        "sustainability": 27
      },
      "price": 32.09,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575868264645",
      "vsf_explanation": "Zade Vital's Probiyotik Feminen names specific, research-backed probiotic strains and discloses exact CFU and prebiotic doses, giving it the strongest evidence and transparency profile in the brand's line and earning it the highest score among Zade Vital SKUs in this batch. Missing manufacturing facility and sustainability disclosure still cap it at Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "hyalix-hyaluronic-acid-supplement-for-joint-health-skin-hydration-30-capsules",
      "title": "Hyalix Hyaluronic Acid Supplement for Joint Health & Skin Hydration - 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0UlYSdUmSREGRcpmR8wCNFTEKJMiu16o1FCWQAae.jpg?v=1790549900",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "hyalix",
        "hyaluronic",
        "acid",
        "supplement",
        "for",
        "joint",
        "health",
        "skin",
        "hydration",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 35,
        "manufacturing": 50,
        "safety": 72,
        "transparency": 35,
        "sustainability": 30
      },
      "price": 56.78,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575868330181",
      "vsf_explanation": "Hyalix combines hyaluronic acid, glucosaminoglycan and hydrolyzed collagen for joint and skin support, a combination with individual research support. This listing discloses dosing frequency but not the amount of any active ingredient, which limits confidence in whether the formula matches studied doses.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "bioxcin-womens-hair-supplement-30-tablets-supports-hair-growth-reduces-hair-loss",
      "title": "Bioxcin Women's Hair Supplement, 30 Tablets - Supports Hair Growth & Reduces Hair Loss",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BioxcinWomensHair30Tablet_1.jpg?v=1790549901",
      "score": 31,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "bioxcin",
        "women",
        "hair",
        "supplement",
        "tablets",
        "supports",
        "hair",
        "growth",
        "reduces",
        "hair",
        "loss",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 18,
        "formulation": 10,
        "manufacturing": 65,
        "safety": 45,
        "transparency": 22,
        "sustainability": 25
      },
      "price": 16.21,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575868362949",
      "vsf_explanation": "Bioxcin Women's Hair Supplement makes explicit hair-growth and hair-loss claims while disclosing no ingredients or doses whatsoever on the listing. Despite Bioxcin's established brand reputation, the complete absence of formulation transparency for this specific SKU triggers an autofail and Rejected tier.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "ocean-black-seed-oil-supplement-1000mg-corek-otu-yagi-capsules-60-count-1-1-free-natural-health-support",
      "title": "Ocean Black Seed Oil Supplement - 1000mg Çörek Otu Yağı Capsules, 60 Count (1+1 Free) - Natural Health Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/718St8XsX5L.jpg?v=1790549900",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ocean",
        "black",
        "seed",
        "oil",
        "supplement",
        "1000mg",
        "rek",
        "otu",
        "capsules",
        "count",
        "free",
        "natural",
        "health",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 75,
        "transparency": 50,
        "sustainability": 35
      },
      "price": 34.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575868395717",
      "vsf_explanation": "Ocean's black seed oil capsule discloses a clear 1000 mg dose and its softgel ingredients, supported by an emerging but still preliminary evidence base for Nigella sativa's metabolic and antioxidant effects. Manufacturing and transparency reflect Ocean's typical eczane-channel disclosure level.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ocean-l-glutamine-5000-mg-dietary-supplement-60-sachets-for-muscle-recovery-gut-health",
      "title": "Ocean L-Glutamine 5000 Mg Dietary Supplement - 60 Sachets for Muscle Recovery & Gut Health",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/sAHWttd43jjUB2KzatD6VMxacy87wqm58Icr3rNN.jpg?v=1790549900",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ocean",
        "glutamine",
        "5000",
        "dietary",
        "supplement",
        "sachets",
        "for",
        "muscle",
        "recovery",
        "gut",
        "health",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 65,
        "manufacturing": 58,
        "safety": 75,
        "transparency": 50,
        "sustainability": 35
      },
      "price": 71.75,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575868428485",
      "vsf_explanation": "Ocean's L-Glutamine sachet discloses a clear 5000 mg dose in a convenient pre-measured format, but the muscle-recovery claim for healthy exercisers is only weakly supported by current evidence even though the gut-health rationale is better founded. Manufacturing and transparency reflect Ocean's typical eczane-channel disclosure level.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "osende-beauty-collagen-supplement-5500mg-liquid-collagen-for-skin-hair-and-nail-health",
      "title": "Osende Beauty Collagen Supplement 5500mg - Liquid Collagen for Skin, Hair, and Nail Health",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/jUrbRLtpqPxP0VVIHHmIAHPnodHgnjDqSHVPCxv9.jpg?v=1790549901",
      "score": 63,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "osende",
        "beauty",
        "collagen",
        "supplement",
        "5500mg",
        "liquid",
        "collagen",
        "for",
        "skin",
        "hair",
        "and",
        "nail",
        "health",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 60,
        "manufacturing": 74,
        "safety": 75,
        "transparency": 58,
        "sustainability": 40
      },
      "price": 38.82,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575868461253",
      "vsf_explanation": "Osende Beauty Collagen delivers a disclosed 5500mg collagen dose per liquid serving, within ranges studied for skin benefits, from an ISO-certified Turkish manufacturer, though the collagen source/type is not specified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sorvagen-brewers-yeast-and-vitamin-b12-supplement-250-tablets-gluten-lactose-free-supports-nutritional-health",
      "title": "Sorvagen Brewer's Yeast and Vitamin B12 Supplement - 250 Tablets, Gluten & Lactose Free, Supports Nutritional Health",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/o8U73Jmb3rjXlMJ8zYTACdmVt5OeZLOI8WAao7XA.jpg?v=1790549901",
      "score": 47,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sorvagen",
        "brewer",
        "yeast",
        "and",
        "vitamin",
        "b12",
        "supplement",
        "250",
        "tablets",
        "gluten",
        "lactose",
        "free",
        "supports",
        "nutritional",
        "health",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 38,
        "manufacturing": 50,
        "safety": 75,
        "transparency": 42,
        "sustainability": 30
      },
      "price": 20.88,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575868526789",
      "vsf_explanation": "Sorvagen combines brewer's yeast with vitamin B12 in a gluten- and lactose-free tablet, ingredients with individual nutritional research support. This listing does not disclose the dose of either active ingredient, which limits assessment of adequacy.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "neoforce-glucomannan-konjac-gum-60-capsules-natural-weight-management-dietary-fiber-supplement",
      "title": "Neoforce Glucomannan Konjac Gum 60 Capsules - Natural Weight Management & Dietary Fiber Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/vml8Zue7oZA8Oje6swDcXNufrh6L4Msq42o3GIky.jpg?v=1790549902",
      "score": 42,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "neoforce",
        "glucomannan",
        "konjac",
        "gum",
        "capsules",
        "natural",
        "weight",
        "management",
        "dietary",
        "fiber",
        "supplement",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "weight_metabolic_health"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 32,
        "manufacturing": 48,
        "safety": 62,
        "transparency": 30,
        "sustainability": 30
      },
      "price": 38.82,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575868494021",
      "vsf_explanation": "Neoforce is a single-ingredient glucomannan (konjac root fiber) capsule marketed for weight management and dietary fiber support, a category with genuine published research at adequate doses. This listing does not disclose the per-capsule glucomannan amount or any water-intake guidance, which limits assessment of both efficacy and safety.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ocean-milk-thistle-dietary-supplement-300mg-silibin-per-tablet-30-count",
      "title": "Ocean Milk Thistle Dietary Supplement - 300mg Silibin per Tablet, 30 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/sAxICF3gKuadqT8XSscfvVAsG8qcVWcBbcVNpF3x.jpg?v=1790549902",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ocean",
        "milk",
        "thistle",
        "dietary",
        "supplement",
        "300mg",
        "silibin",
        "per",
        "tablet",
        "count",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 68,
        "manufacturing": 58,
        "safety": 80,
        "transparency": 62,
        "sustainability": 35
      },
      "price": 20.88,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575868559557",
      "vsf_explanation": "Ocean's Milk Thistle tablet stands out within the brand's line for disclosing both its total extract weight and its standardized 300 mg silibin active content, supported by a moderate generic evidence base for liver-enzyme support. Manufacturing and sustainability reflect Ocean's typical eczane-channel standard, unchanged from other SKUs in the brand.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutraxin-omega-3-coq-10-dietary-supplement-for-heart-health-support-60-softgel-capsules",
      "title": "Nutraxin Omega-3 + CoQ-10 Dietary Supplement for Heart Health Support - 60 Softgel Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/nPN0jeCAFz9uew8btvEVZhVDhTqFm0OBjnma1lus.jpg?v=1790549901",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutraxin",
        "omega",
        "coq",
        "dietary",
        "supplement",
        "for",
        "heart",
        "health",
        "support",
        "softgel",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 75,
        "manufacturing": 45,
        "safety": 75,
        "transparency": 60,
        "sustainability": 20
      },
      "price": 34.33,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575868592325",
      "vsf_explanation": "Nutraxin's Omega-3 + CoQ-10 softgels disclose a fully quantified, well-evidenced dose profile for cardiovascular support, among the most transparent formulas in this batch. It reaches Standard tier on strong dosing clarity, though the brand's undisclosed manufacturing certification and sustainability/sourcing practices cap it there.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutraxin-magnesium-citrate-250mg-60-tablets-natural-dietary-supplement-for-adults",
      "title": "Nutraxin Magnesium Citrate 250mg - 60 Tablets - Natural Dietary Supplement for Adults",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Mn2yacRr7aOEdvj0eKV6dfdvEszCbHa3h58aPrWU.jpg?v=1790549904",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutraxin",
        "magnesium",
        "citrate",
        "250mg",
        "tablets",
        "natural",
        "dietary",
        "supplement",
        "for",
        "adults",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 45,
        "safety": 75,
        "transparency": 65,
        "sustainability": 20
      },
      "price": 17.36,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575868690629",
      "vsf_explanation": "Nutraxin Magnesium Citrate 250mg discloses a clear, well-evidenced dose and, uniquely among this batch, a specific Turkish regulatory registration number confirming its compliance pathway. It reaches Standard tier on clean formulation and this added regulatory transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnimore-plus-magnesium-supplement-30-tablets-for-muscle-support-overall-wellness",
      "title": "Magnimore Plus Magnesium Supplement - 30 Tablets for Muscle Support & Overall Wellness",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/psuz5U9cepOHYLXx8HMBDeLdd0A4Dq1r4JMzNIRM.jpg?v=1790549904",
      "score": 51,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnimore",
        "plus",
        "magnesium",
        "supplement",
        "tablets",
        "for",
        "muscle",
        "support",
        "overall",
        "wellness",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 38,
        "sustainability": 40
      },
      "price": 22.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575868723397",
      "vsf_explanation": "Magnimore Plus is marketed around a 'unique blend' of three magnesium forms without disclosing how much magnesium the blend actually delivers. Because the dose behind this proprietary blend is never quantified, the product is scored Rejected.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "offstone-dietary-supplement-terebinth-ginger-avocado-capsules-for-health-benefits",
      "title": "OffStone Dietary Supplement - Terebinth, Ginger, Avocado Capsules for Health Benefits",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/PIPgYNNrnUzMquhikmkBXkF9Ob54e03AUjZtnR6K.jpg?v=1790549904",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "offstone",
        "dietary",
        "supplement",
        "terebinth",
        "ginger",
        "avocado",
        "capsules",
        "for",
        "health",
        "benefits",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 30,
        "manufacturing": 48,
        "safety": 65,
        "transparency": 28,
        "sustainability": 30
      },
      "price": 56.78,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575868756165",
      "vsf_explanation": "OffStone combines terebinth (menengiç), ginger and avocado extracts marketed around traditional digestive and wellness use. This listing does not disclose the amount of any of the three ingredients, and the health claims made are traditional rather than clinically cited, which limits confidence in efficacy.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "argivit-immune-support-supplement-boosts-immune-system-relieves-dry-eyes-30-capsules",
      "title": "Argivit Immune Support Supplement - Boosts Immune System & Relieves Dry Eyes - 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MsUq3CqVYqmLFLkRSHlcTjVEvohDoIVE3e8bq7QX.jpg?v=1790549905",
      "score": 31,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "argivit",
        "immune",
        "support",
        "supplement",
        "boosts",
        "immune",
        "system",
        "relieves",
        "dry",
        "eyes",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 25,
        "manufacturing": 55,
        "safety": 30,
        "transparency": 20,
        "sustainability": 38
      },
      "price": 60.08,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575868887237",
      "vsf_explanation": "This Argivit immune supplement's listing claims potential benefit 'during viral and cytokine storms' — cytokine storm is a specific, life-threatening medical condition — without disclosing any ingredients, doses, or clinical evidence to support such a claim. This is scored Rejected and flagged as an unverified disease-related claim.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "imuneks-farma-bromelain-500-mg-anti-inflammatory-dietary-supplement-for-digestive-health-support-30-tablets",
      "title": "Imuneks Farma Bromelain 500 mg - Anti-Inflammatory Dietary Supplement for Digestive Health Support, 30 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/kzEU5pjzvhCBeglhywR2oVK944ReXcWkZUK8earc.jpg?v=1790549905",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "imuneks",
        "farma",
        "bromelain",
        "500",
        "anti",
        "inflammatory",
        "dietary",
        "supplement",
        "for",
        "digestive",
        "health",
        "support",
        "tablets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 70,
        "safety": 65,
        "transparency": 62,
        "sustainability": 38
      },
      "price": 11.82,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575868920005",
      "vsf_explanation": "Imuneks Farma Bromelain discloses a 500mg per-tablet dose for digestive support, produced by an established Turkish pharmaceutical company, though potency units and interaction cautions are not stated.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zade-vital-coconut-oil-supplement-60-softgel-capsules-cold-pressed-kosher-halal-certified",
      "title": "Zade Vital Coconut Oil Supplement - 60 Softgel Capsules, Cold-Pressed, Kosher & Halal Certified",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/UIgfQlswmSErMu5zXzQP1pEF43BgzlYa6Z8LpPXs.jpg?v=1790549905",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zade",
        "vital",
        "coconut",
        "oil",
        "supplement",
        "softgel",
        "capsules",
        "cold",
        "pressed",
        "kosher",
        "halal",
        "certified",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 48,
        "manufacturing": 48,
        "safety": 58,
        "transparency": 58,
        "sustainability": 27
      },
      "price": 19.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575868952773",
      "vsf_explanation": "Zade Vital's coconut oil softgel sits on a weaker mainstream evidence base than the brand's vitamin/mineral products and never discloses the actual mg dose of coconut oil per capsule, which limits both formulation and safety assessment. Combined with no manufacturing or sustainability disclosure, this places the SKU in Rejected tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnimore-magnesium-citrate-supplement-with-vitamin-b6-60-capsules-supports-muscle-and-nerve-function",
      "title": "Magnimore Magnesium Citrate Supplement with Vitamin B6 - 60 Capsules, Supports Muscle and Nerve Function",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/QZjMdxjspcuuD6HU6Mt13QetfIWJRfkhGirsjB9G.jpg?v=1790549906",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnimore",
        "magnesium",
        "citrate",
        "supplement",
        "with",
        "vitamin",
        "capsules",
        "supports",
        "muscle",
        "and",
        "nerve",
        "function",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 64,
        "sustainability": 40
      },
      "price": 16.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575868985541",
      "vsf_explanation": "This Magnimore magnesium citrate and B6 supplement clearly discloses both active doses (250mg magnesium, 10mg B6) for a well-established combination. It scores Standard tier, limited mainly by the absence of any disclosed manufacturing certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lifextra-biotin-5000-mcg-supplement-supports-hair-skin-nail-health-60-tablets",
      "title": "Lifextra Biotin 5000 mcg Supplement - Supports Hair, Skin & Nail Health | 60 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7YeQahH4VRJ10D84bTXxgv1HiNjozhbRM4c7X0LG.jpg?v=1790549905",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lifextra",
        "biotin",
        "5000",
        "mcg",
        "supplement",
        "supports",
        "hair",
        "skin",
        "nail",
        "health",
        "tablets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 65,
        "manufacturing": 74,
        "safety": 62,
        "transparency": 70,
        "sustainability": 40
      },
      "price": 25.38,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575869018309",
      "vsf_explanation": "LifeXtra Biotin 5000mcg discloses its exact dose and a Turkish supplement registration number, but the evidence for hair/skin/nail benefit is strongest in biotin-deficient individuals rather than the general population implied by the marketing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zade-vital-vitamin-d3-1000iu-spray-supplement-supports-bone-health-immune-function-20ml",
      "title": "Zade Vital Vitamin D3 1000IU Spray Supplement - Supports Bone Health & Immune Function, 20ml",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/AYXGNa7a6DXpQ1PFr1qVGue7Tu6asQiyf4pLHZwK.jpg?v=1790549906",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zade",
        "vital",
        "vitamin",
        "1000iu",
        "spray",
        "supplement",
        "supports",
        "bone",
        "health",
        "immune",
        "function",
        "20ml",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 70,
        "manufacturing": 48,
        "safety": 65,
        "transparency": 58,
        "sustainability": 27
      },
      "price": 16.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575869051077",
      "vsf_explanation": "Zade Vital's D3 spray discloses both active ingredient doses clearly and pairs a well-evidenced vitamin with an appropriately hedged complementary ingredient, earning Standard tier. Missing facility, testing, and interaction-caution disclosures keep it out of Verified tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutraxin-womens-multivitamin-mineral-complex-supplement-60-tablets-for-overall-health-wellness",
      "title": "Nutraxin Women's Multivitamin Mineral Complex Supplement - 60 Tablets for Overall Health & Wellness",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Z8hI3DWlwZE2h6wFHf27eFTB1CamPXB9Ucznoyqx.jpg?v=1790549905",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "nutraxin",
        "women",
        "multivitamin",
        "mineral",
        "complex",
        "supplement",
        "tablets",
        "for",
        "overall",
        "health",
        "wellness",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 46,
        "formulation": 48,
        "manufacturing": 45,
        "safety": 66,
        "transparency": 50,
        "sustainability": 20
      },
      "price": 18.84,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575869083845",
      "vsf_explanation": "Nutraxin's Women's Multivitamin Mineral Complex names an unusually thorough list of vitamins, minerals, and specialty compounds, but discloses no dose for any of them, so nutritional adequacy can't be verified. That gap, plus undisclosed manufacturing and sustainability practices, results in a Rejected-tier score.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutraxin-bromelain-1000mg-dietary-supplement-60-tablets-for-anti-inflammatory-support-digestive-health",
      "title": "Nutraxin Bromelain 1000mg Dietary Supplement - 60 Tablets for Anti-Inflammatory Support & Digestive Health",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/C1fA6AiC3O81LLJtkaET1Nsogt8n6vQfjUoGWYku.jpg?v=1790549907",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutraxin",
        "bromelain",
        "1000mg",
        "dietary",
        "supplement",
        "tablets",
        "for",
        "anti",
        "inflammatory",
        "support",
        "digestive",
        "health",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 45,
        "safety": 70,
        "transparency": 60,
        "sustainability": 20
      },
      "price": 23.32,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575869149381",
      "vsf_explanation": "Nutraxin's Bromelain 1000mg product discloses a clear total serving dose for an ingredient with moderate generic evidence for digestive support. It reaches Standard tier on clear per-serving labeling, though brand-level manufacturing and sustainability disclosures remain absent.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ocean-resveratrol-200-mg-antioxidant-dietary-supplement-for-cardiovascular-health-anti-aging-30-capsules",
      "title": "Ocean Resveratrol 200 mg - Antioxidant Dietary Supplement for Cardiovascular Health & Anti-Aging, 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/rkc6LpFGZo6XunksnbRrE6KazhUkJWe1Jc3xjL6f.jpg?v=1790549907",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "longevity",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ocean",
        "resveratrol",
        "200",
        "antioxidant",
        "dietary",
        "supplement",
        "for",
        "cardiovascular",
        "health",
        "anti",
        "aging",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "longevity_cellular"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 78,
        "transparency": 50,
        "sustainability": 35
      },
      "price": 32.85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575869182149",
      "vsf_explanation": "Ocean's resveratrol capsule discloses a clear 200 mg per-capsule dose within commonly studied human ranges, supported by a mixed but real evidence base for cardiovascular and antioxidant benefits, though anti-aging claims lean on preclinical research. Manufacturing and transparency reflect Ocean's typical eczane-channel disclosure level.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "impryl-dietary-supplement-vitamin-and-mineral-supplement-for-health-and-wellness-30-tablets",
      "title": "Impryl Dietary Supplement - Vitamin and Mineral Supplement for Health and Wellness, 30 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/srAYwDO39i4C6SSw0Rpq9fZplcnKTQgLHHl2BpkC.jpg?v=1790549907",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "impryl",
        "dietary",
        "supplement",
        "vitamin",
        "and",
        "mineral",
        "supplement",
        "for",
        "health",
        "and",
        "wellness",
        "tablets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 40,
        "formulation": 35,
        "manufacturing": 48,
        "safety": 68,
        "transparency": 30,
        "sustainability": 28
      },
      "price": 122.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575869214917",
      "vsf_explanation": "Impryl is a general multivitamin and mineral tablet naming betaine, L-cystine, niacin, zinc, B6, riboflavin, folate and B12, claimed to provide 100% of recommended daily intake. This listing does not disclose the absolute amount of any nutrient, only the relative RDI claim, which limits independent verification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zade-vital-vitamin-d3-supplement-30-capsules-supports-bone-health-immune-system",
      "title": "Zade Vital Vitamin D3 Supplement - 30 Capsules, Supports Bone Health & Immune System",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/TP33NFoBIOoAtXn8JxzteYtyB2nOyATAq4Yve9NK.jpg?v=1790549921",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zade",
        "vital",
        "vitamin",
        "supplement",
        "capsules",
        "supports",
        "bone",
        "health",
        "immune",
        "system",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 45,
        "manufacturing": 48,
        "safety": 55,
        "transparency": 58,
        "sustainability": 27
      },
      "price": 11.11,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575869378757",
      "vsf_explanation": "Zade Vital's plain D3 capsule never discloses the actual IU dose of Vitamin D3 anywhere in the available product copy, which is the single most important fact for a Vitamin D supplement. That omission drags formulation and safety scores down enough to place this SKU in Rejected tier despite Vitamin D3 itself being well-evidenced.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-calcium-magnesium-zinc-d3-100-tablets-bone-health-support-supplement",
      "title": "Nature's Bounty Calcium Magnesium Zinc+D3 100 Tablets - Bone Health Support Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/kFUNMiPXJkmr6ITQ5iKbuTZg65LGX9fr1Oxvy7F7.jpg?v=1790549957",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "immune",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "calcium",
        "magnesium",
        "zinc",
        "100",
        "tablets",
        "bone",
        "health",
        "support",
        "supplement",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 48,
        "manufacturing": 85,
        "safety": 65,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 18.38,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575870755013",
      "vsf_explanation": "Nature's Bounty's Calcium Magnesium Zinc+D3 tablet combines four minerals/vitamins with solid generic evidence for bone health, manufactured under the brand's established cGMP-certified US facility standards. However, the listing does not disclose the per-tablet amount of any of the four actives, which limits verification of dosing and keeps this product in Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutraxin-bromelain-500-mg-digestive-enzyme-supplement-for-anti-inflammatory-support",
      "title": "Nutraxin Bromelain 500 mg - Digestive Enzyme Supplement for Anti-Inflammatory Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Acj0bCG0jqLCQOLcHQvR2PHNtyphSysSAnWS0nyz.jpg?v=1790549957",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutraxin",
        "bromelain",
        "500",
        "digestive",
        "enzyme",
        "supplement",
        "for",
        "anti",
        "inflammatory",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 65,
        "manufacturing": 45,
        "safety": 70,
        "transparency": 60,
        "sustainability": 20
      },
      "price": 22.3,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575870886085",
      "vsf_explanation": "Nutraxin's Bromelain 500 mg tablet discloses a specific, verifiable dose and potency for an ingredient with moderate generic evidence for digestive and post-exertion support. It reaches Standard tier on clear labeling, though brand-level manufacturing and sustainability disclosures remain absent.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ellips-hair-vitamin-supplement-for-smooth-shiny-hair-50-capsules",
      "title": "Ellips Hair Vitamin Supplement for Smooth & Shiny Hair - 50 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/vfC5eMFqvlJaQIn9ZgfXVhLQXc0fl2tK9rKhnWrV.jpg?v=1790549957",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ellips",
        "hair",
        "vitamin",
        "supplement",
        "for",
        "smooth",
        "shiny",
        "hair",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 15,
        "manufacturing": 80,
        "safety": 25,
        "transparency": 20,
        "sustainability": 50
      },
      "price": 29.38,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575870853317",
      "vsf_explanation": "This listing frames Ellips as an oral hair vitamin, but Ellips capsules are a topical leave-in hair oil applied directly to strands after shampooing, not a swallowed supplement, making the internal-nourishment framing misleading.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "natures-bounty-ester-c-1000-mg-vitamin-c-supplement-60-tablets-sugar-free-gluten-free-allergen-friendly",
      "title": "Natures Bounty Ester-C 1000 mg Vitamin C Supplement - 60 Tablets, Sugar-Free, Gluten-Free, Allergen-Friendly",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/eTorZFD2wkzdnm4LerL2mOJpvqYzwIQpNG2tI4U9.jpg?v=1790549957",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "natures",
        "bounty",
        "ester",
        "1000",
        "vitamin",
        "supplement",
        "tablets",
        "sugar",
        "free",
        "gluten",
        "free",
        "allergen",
        "friendly",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 64,
        "formulation": 68,
        "manufacturing": 85,
        "safety": 85,
        "transparency": 75,
        "sustainability": 45
      },
      "price": 34.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575870787781",
      "vsf_explanation": "Nature's Bounty's Ester-C tablet discloses a clear, very safe 1000 mg dose in a gentler buffered form, with an explicit allergen-free and additive-free profile that goes beyond the brand's typical disclosure. Combined with the brand's established cGMP manufacturing standard, this SKU reaches Verified tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "lifextra-bromelain-30-capsules-supplement",
      "title": "LifeXtra Bromelain 30 Capsules - Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Egsz0MFrhiwsieQHxpRLO5QHSuIOYX04qyS9ZQub.jpg?v=1790549957",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "lifextra",
        "bromelain",
        "capsules",
        "supplement",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 68,
        "manufacturing": 74,
        "safety": 65,
        "transparency": 65,
        "sustainability": 40
      },
      "price": 19.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575870722245",
      "vsf_explanation": "LifeXtra Bromelain discloses a 1500mg/2-capsule dose within commonly studied ranges, produced by an ISO-certified Turkish manufacturer, though bromelain potency units and interaction cautions are not disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ellips-hair-vitamin-supplement-for-black-hair-50-capsules-for-shine-nourishment",
      "title": "Ellips Hair Vitamin Supplement for Black Hair - 50 Capsules for Shine & Nourishment",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/jOGDm6U0zSeWE1vXCu6JyLcRTar0P14E2TVVp2uO.jpg?v=1790549957",
      "score": 33,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ellips",
        "hair",
        "vitamin",
        "supplement",
        "for",
        "black",
        "hair",
        "capsules",
        "for",
        "shine",
        "nourishment",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 18,
        "formulation": 12,
        "manufacturing": 80,
        "safety": 25,
        "transparency": 18,
        "sustainability": 50
      },
      "price": 32.85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575870820549",
      "vsf_explanation": "This listing markets an Ellips variant as an ingestible hair vitamin tailored to 'black hair needs,' but Ellips capsules are a topical leave-in oil applied externally, and no formulation difference for this variant is disclosed, making both the ingestion framing and the targeted-formulation claim unverifiable.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "macushield-gold-eye-health-supplement-90-capsules-with-lutein-zeaxanthin-antioxidants",
      "title": "MacuShield Gold Eye Health Supplement - 90 Capsules with Lutein, Zeaxanthin & Antioxidants",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/61xl6QimMVL_ccc3281c-8b3a-4890-bab8-566f191c2830.jpg?v=1790549957",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "macushield",
        "gold",
        "eye",
        "health",
        "supplement",
        "capsules",
        "with",
        "lutein",
        "zeaxanthin",
        "antioxidants",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 85,
        "formulation": 70,
        "manufacturing": 68,
        "safety": 80,
        "transparency": 55,
        "sustainability": 35
      },
      "price": 65.76,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575870984389",
      "vsf_explanation": "MacuShield Gold is a genuine, internationally distributed eye-health formula built around meso-zeaxanthin, lutein and zeaxanthin, a combination studied in published macular pigment research. This specific listing discloses the full ingredient set and daily dosing but not per-ingredient milligram amounts or manufacturing certifications, and the age-related macular degeneration risk-reduction language is not independently cited here.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "wellcare-vitamin-d3-intense-1000iu-12ml-liquid-vitamin-d3-supplement-for-bone-health",
      "title": "Wellcare Vitamin D3 Intense 1000IU 12ml - Liquid Vitamin D3 Supplement for Bone Health",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/pTT9BmjhWPN5lJutKiLDfbR2vagG102rhBdTDA48_d4d9728f-e559-40ea-b5b0-b670e1add3de.jpg?v=1790549957",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "wellcare",
        "vitamin",
        "intense",
        "1000iu",
        "12ml",
        "liquid",
        "vitamin",
        "supplement",
        "for",
        "bone",
        "health",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 65,
        "manufacturing": 52,
        "safety": 78,
        "transparency": 48,
        "sustainability": 18
      },
      "price": 11.59,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575870918853",
      "vsf_explanation": "Wellcare Vitamin D3 Intense is a single-ingredient liquid supplement with a clearly disclosed 1000IU per-drop dose, a well-evidenced nutrient for bone and immune support. It lacks any manufacturing, testing, or sustainability disclosure typical of higher-tier products, placing it solidly in the Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "naturalnest-vitamin-b12-1000-mcg-sublingual-tablets-high-strength-b12-supplement-for-deficiency-energy-support",
      "title": "NaturalNest Vitamin B12 1000 mcg Sublingual Tablets - High Strength B12 Supplement for Deficiency & Energy Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/yY4AajlMyHVp4tUWHTkS2TadsQZmM7njP3EJH3Ct.jpg?v=1790549957",
      "score": 64,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "naturalnest",
        "vitamin",
        "b12",
        "1000",
        "mcg",
        "sublingual",
        "tablets",
        "high",
        "strength",
        "b12",
        "supplement",
        "for",
        "deficiency",
        "energy",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 75,
        "manufacturing": 55,
        "safety": 82,
        "transparency": 65,
        "sustainability": 32
      },
      "price": 19.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575870951621",
      "vsf_explanation": "NaturalNest's B12 tablets disclose a clear single-ingredient dose (1000 mcg) in a sublingual format with a supplement registration number, supporting basic regulatory transparency. Vitamin B12 itself has strong general safety and efficacy evidence for deficiency support, though no facility or testing information specific to this brand is disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "orzax-ocean-black-seed-oil-supplement-60-capsules-1000mg-cold-pressed-oil-immune-system-support",
      "title": "Orzax Ocean Black Seed Oil Supplement - 60 Capsules, 1000mg Cold-Pressed Oil, Immune System Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3tEXaxFibbgATXSgUvgjWAITKkjbXonibPCHReya_bfbb2487-93be-45ea-b882-869f4810791d.jpg?v=1790549957",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "orzax",
        "ocean",
        "black",
        "seed",
        "oil",
        "supplement",
        "capsules",
        "1000mg",
        "cold",
        "pressed",
        "oil",
        "immune",
        "system",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 62,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 62,
        "sustainability": 38
      },
      "price": 17.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575871115461",
      "vsf_explanation": "Orzax Ocean Black Seed Oil clearly discloses its per-capsule dose (1,000mg cold-pressed oil) and extraction method, supporting a moderate evidence and formulation score. It scores Standard tier, with immune-support claims resting on generic ingredient research rather than product-specific studies.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutraxin-vitamin-b12-supplement-1000mcg-methylcobalamin-60-tablets-for-energy-and-neurological-health",
      "title": "Nutraxin Vitamin B12 Supplement 1000mcg Methylcobalamin - 60 Tablets for Energy and Neurological Health",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Q4Y5TpY7IX00EoEUkwRZciC32925BQwwHo8t4el4_d9b0bef2-81d8-4b94-bff9-4f39f5da0250.jpg?v=1790549957",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutraxin",
        "vitamin",
        "b12",
        "supplement",
        "1000mcg",
        "methylcobalamin",
        "tablets",
        "for",
        "energy",
        "and",
        "neurological",
        "health",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 70,
        "manufacturing": 45,
        "safety": 80,
        "transparency": 60,
        "sustainability": 20
      },
      "price": 24.01,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575871017157",
      "vsf_explanation": "This Nutraxin B12 tablet discloses a clear, well-evidenced dose for energy and neurological support with an excellent safety profile. It reaches Standard tier on clean formulation and dosing, though the brand's undisclosed manufacturing and sustainability practices cap it there.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitabiotics-wellman-multivitamin-supplement-for-men-daily-vitamin-and-mineral-boost-for-energy-and-overall-health",
      "title": "Vitabiotics Wellman Multivitamin Supplement for Men - Daily Vitamin and Mineral Boost for Energy and Overall Health",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/8ieUFX48AZcC5yXRQuhS1753ewH0QzBgl6A5eEKM_4940dbd3-a9b7-4ed3-9190-383b98a10ee0.jpg?v=1790549957",
      "score": 66,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "vitabiotics",
        "wellman",
        "multivitamin",
        "supplement",
        "for",
        "men",
        "daily",
        "vitamin",
        "and",
        "mineral",
        "boost",
        "for",
        "energy",
        "and",
        "overall",
        "health",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 55,
        "manufacturing": 88,
        "safety": 70,
        "transparency": 58,
        "sustainability": 55
      },
      "price": 31.84,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575871377605",
      "vsf_explanation": "Vitabiotics Wellman is a well-known, long-running men's multivitamin from a major UK brand, naming a comprehensive set of ingredients for energy and general wellness. It scores Standard tier because this listing does not disclose specific per-ingredient doses.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "reprodo-m-30-sachets-dietary-supplement-powder-multivitamin-l-carnitine-l-arginine-coenzyme-q10",
      "title": "Reprodo M 30 Sachets Dietary Supplement Powder - Multivitamin, L-Carnitine, L-Arginine, Coenzyme Q10",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/dmUkANj4DAI5H0lL9ODyOBkdLA3xXyyDPgmmikNQ.jpg?v=1790549957",
      "score": 47,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "reprodo",
        "sachets",
        "dietary",
        "supplement",
        "powder",
        "multivitamin",
        "carnitine",
        "arginine",
        "coenzyme",
        "q10",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 42,
        "manufacturing": 50,
        "safety": 68,
        "transparency": 35,
        "sustainability": 32
      },
      "price": 71.75,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575871148229",
      "vsf_explanation": "Reprodo M pairs a multivitamin base with L-carnitine, L-arginine and coenzyme Q10, ingredients with individual research support in energy and wellness contexts. This listing does not disclose the amount of any active ingredient, which prevents confirming whether doses fall within studied ranges.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrafarm-vitamin-c-complex-1000mg-high-dose-immune-support-supplement-for-health-conscious-adults",
      "title": "Nutrafarm Vitamin C Complex 1000mg - High Dose Immune Support Supplement for Health-Conscious Adults",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/V85wgYzN7TiugHf2NUxEqeRH5hE4A4dmikYUfkZA.jpg?v=1790549957",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutrafarm",
        "vitamin",
        "complex",
        "1000mg",
        "high",
        "dose",
        "immune",
        "support",
        "supplement",
        "for",
        "health",
        "conscious",
        "adults",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 58,
        "manufacturing": 48,
        "safety": 82,
        "transparency": 44,
        "sustainability": 16
      },
      "price": 17.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575871049925",
      "vsf_explanation": "Nutrafarm Vitamin C Complex clearly discloses its primary 1000mg Vitamin C dose in a well-evidenced buffered form, with supporting bioflavonoid ingredients left unquantified. It lands in Standard tier on the strength of clear primary dosing and a strong safety profile, offset by no manufacturing or sustainability disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-biotin-5000-mcg-dietary-supplement-for-hair-skin-and-nail-health-72-soft-capsules",
      "title": "Nature's Bounty Biotin 5000 mcg Dietary Supplement for Hair, Skin, and Nail Health - 72 Soft Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/GxSQRyKnOUKy2rJwzbqBsStNJSxWfsscFdYaunkL.jpg?v=1790549958",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "biotin",
        "5000",
        "mcg",
        "dietary",
        "supplement",
        "for",
        "hair",
        "skin",
        "and",
        "nail",
        "health",
        "soft",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 55,
        "manufacturing": 85,
        "safety": 62,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 20,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575871574213",
      "vsf_explanation": "Nature's Bounty's Biotin softgel discloses a clear but very high 5000 mcg dose that is not proportionally backed by clinical evidence for non-deficient users, and the listing omits the FDA-flagged risk that high-dose biotin can interfere with common lab tests. Strong brand-wide manufacturing keeps it in Standard tier rather than lower.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "delta-vitamin-b6-supplement-liquid-10-14-fl-oz-p-5-p-active-form-for-optimal-bioavailability",
      "title": "Delta Vitamin B6 Supplement Liquid - 10.14 fl oz, P-5-P Active Form for Optimal Bioavailability",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/U2k8bt1mVUYjDXGuSXeEGqUQKMBKeRuO05lBlHIU.jpg?v=1790549957",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "delta",
        "vitamin",
        "supplement",
        "liquid",
        "active",
        "form",
        "for",
        "optimal",
        "bioavailability",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 75,
        "manufacturing": 45,
        "safety": 58,
        "transparency": 63,
        "sustainability": 25
      },
      "price": 53.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575871344837",
      "vsf_explanation": "Delta's Vitamin B6 liquid clearly discloses its per-ml P-5-P dose and offers precise pipette dosing for a single-ingredient formula, earning the highest score in the Delta line for this batch. Missing manufacturing facility disclosure and a stated maximum daily dose keep it below Verified tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "voonka-vitamin-d3-k2-dietary-supplement-liquid-25ml-bottle-supports-bone-health-immune-function",
      "title": "Voonka Vitamin D3+K2 Dietary Supplement Liquid - 25ml Bottle, Supports Bone Health & Immune Function",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ibyuR7eHJMaJS3iZMCCg7OhYqth2ujWlu3Md5TqE.jpg?v=1790549957",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "voonka",
        "vitamin",
        "dietary",
        "supplement",
        "liquid",
        "25ml",
        "bottle",
        "supports",
        "bone",
        "health",
        "immune",
        "function",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 55,
        "safety": 80,
        "transparency": 58,
        "sustainability": 33
      },
      "price": 14.11,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575871180997",
      "vsf_explanation": "Voonka's Vitamin D3+K2 liquid discloses precise per-drop dosing for both actives, supported by decent generic evidence for bone and cardiovascular health from combining these two fat-soluble vitamins. Manufacturing and sustainability reflect Voonka's typical eczane/retail-channel Turkish-brand standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "life-l-arginine-1000mg-dietary-supplement-for-adults-90-tablets-cardiovascular-health-support",
      "title": "Life - L-Arginine 1000mg Dietary Supplement for Adults - 90 Tablets - Cardiovascular Health Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/LPVqRFChhsiXFFaQoalvgPD59UbqKpCtI3Jt92Da.jpg?v=1790549957",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "life",
        "arginine",
        "1000mg",
        "dietary",
        "supplement",
        "for",
        "adults",
        "tablets",
        "cardiovascular",
        "health",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 58,
        "manufacturing": 45,
        "safety": 68,
        "transparency": 40,
        "sustainability": 30
      },
      "price": 23.87,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575871213765",
      "vsf_explanation": "This L-Arginine 1000mg product discloses its per-tablet dose and basic usage instructions, but no verifiable manufacturer, company, or certification information could be found for the 'Life' brand, unlike every other brand identified in this batch.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "sambucol-plus-black-elderberry-dietary-supplement-with-vitamin-c-zinc-boosts-immune-system-support-20-tablets",
      "title": "Sambucol Plus Black Elderberry Dietary Supplement with Vitamin C & Zinc - Boosts Immune System Support - 20 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/u7ZM7UCgv6Job2aBcykwhd1CTf9OdWDHZuWQohpr_9da7c714-c3cb-4a7c-93a3-8987336b1d35.jpg?v=1790549957",
      "score": 72,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sambucol",
        "plus",
        "black",
        "elderberry",
        "dietary",
        "supplement",
        "with",
        "vitamin",
        "zinc",
        "boosts",
        "immune",
        "system",
        "support",
        "tablets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 82,
        "formulation": 80,
        "manufacturing": 62,
        "safety": 80,
        "transparency": 72,
        "sustainability": 35
      },
      "price": 22.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575871312069",
      "vsf_explanation": "Sambucol Plus is a genuine, internationally distributed elderberry formula backed by published clinical research on cold-duration support, and this listing fully discloses per-serving doses for elderberry, vitamin C and zinc. Manufacturing certifications specific to this SKU are not disclosed here, which keeps it just short of Elite-level transparency.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zade-vital-vitamin-d3-k2-dietary-supplement-for-bone-health-30-capsules",
      "title": "Zade Vital Vitamin D3 + K2 Dietary Supplement for Bone Health - 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/dNi7xfwXjwgWWmdunMJ9eiJTalZ8t27iVGESLrHF.jpg?v=1790549957",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zade",
        "vital",
        "vitamin",
        "dietary",
        "supplement",
        "for",
        "bone",
        "health",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 75,
        "manufacturing": 48,
        "safety": 65,
        "transparency": 58,
        "sustainability": 27
      },
      "price": 15.66,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575871082693",
      "vsf_explanation": "Zade Vital's D3+K2 combination uses well-established, clearly disclosed doses for bone-related support, earning a solid Standard-tier score. Lack of disclosed manufacturing facility, testing, or drug-interaction cautions keeps it below Verified tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dermoskin-mens-dietary-supplement-biotin-b-vitamins-saw-palmetto",
      "title": "Dermoskin Men's Dietary Supplement - Biotin, B Vitamins, Saw Palmetto",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/uRL07KozgIqK4MN3g1hAn60jiEVFigT55nslLCnN.jpg?v=1790549957",
      "score": 51,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin",
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "dermoskin",
        "men",
        "dietary",
        "supplement",
        "biotin",
        "vitamins",
        "saw",
        "palmetto",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 48,
        "manufacturing": 52,
        "safety": 70,
        "transparency": 45,
        "sustainability": 30
      },
      "price": 17.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575871246533",
      "vsf_explanation": "Dermoskin's men's formula combines biotin, B vitamins, saw palmetto and pumpkin seed extract, ingredient categories with individual wellness research behind them. This listing names all ten ingredients but does not disclose the amount of any of them, limiting confidence in whether doses are adequate.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "voonka-vitamin-b-complex-supplement-62-tablets-supports-overall-health-nutrition-with-b-vitamins-essential-nutrients",
      "title": "Voonka Vitamin B Complex Supplement - 62 Tablets | Supports Overall Health & Nutrition with B Vitamins & Essential Nutrients",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/OQz7U7j6jEqLRMq75gdkTCDbP8YfNnh1a5OgbeuT.jpg?v=1790549957",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "voonka",
        "vitamin",
        "complex",
        "supplement",
        "tablets",
        "supports",
        "overall",
        "health",
        "nutrition",
        "with",
        "vitamins",
        "essential",
        "nutrients",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 62,
        "transparency": 40,
        "sustainability": 33
      },
      "price": 14.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575871410373",
      "vsf_explanation": "Voonka's Vitamin B Complex tablet names nine active ingredients but discloses the dose of none of them, making it impossible to verify whether the formula delivers meaningful amounts of any single nutrient. Because actual potency cannot be confirmed from the listing, this product is rejected pending full dose disclosure.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "dinamis-multi-collagen-supplement-powder-with-vitamin-c-hydrolyzed-collagen-for-skin-hair-and-joint-health-pineapple-flavor",
      "title": "Dinamis Multi Collagen Supplement Powder with Vitamin C - Hydrolyzed Collagen for Skin, Hair, and Joint Health - Pineapple Flavor",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/EQbAsp7Zgcoldo9IRh0ks342wt0fxrNgSZZKKcvi.jpg?v=1790549957",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dinamis",
        "multi",
        "collagen",
        "supplement",
        "powder",
        "with",
        "vitamin",
        "hydrolyzed",
        "collagen",
        "for",
        "skin",
        "hair",
        "and",
        "joint",
        "health",
        "pineapple",
        "flavor",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 75,
        "manufacturing": 55,
        "safety": 78,
        "transparency": 68,
        "sustainability": 30
      },
      "price": 38.82,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575871443141",
      "vsf_explanation": "Dinamis Multi Collagen discloses a generous, clearly stated 10,000 mg collagen dose plus 60 mg vitamin C per serving, doses consistent with the ranges used in published collagen research. The collagen source and any manufacturing certifications are not disclosed in this listing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutrafarm-medobiocomplex-e-dietary-supplement-for-men-supports-energy-prostate-health-overall-well-being",
      "title": "Nutrafarm Medobiocomplex-E Dietary Supplement for Men - Supports Energy, Prostate Health & Overall Well-being",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ZLRG40rAm1YeWxaB4WEAUe0nZ3usjl5gUqUlz734.jpg?v=1790549957",
      "score": 29,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "hormone",
        "energy"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "nutrafarm",
        "medobiocomplex",
        "dietary",
        "supplement",
        "for",
        "men",
        "supports",
        "energy",
        "prostate",
        "health",
        "overall",
        "well",
        "being",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 15,
        "manufacturing": 48,
        "safety": 40,
        "transparency": 20,
        "sustainability": 16
      },
      "price": 34.35,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575871475909",
      "vsf_explanation": "Nutrafarm Medobiocomplex-E names ten active ingredients for men's energy and prostate support but discloses a dose amount for none of them, making it impossible to verify the formula's efficacy or safety. This hidden-dose, kitchen-sink formulation results in an autofail and Rejected tier.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "venatura-chlorella-dietary-supplement-520mg-per-capsule-60-count-vegan-wellness-support",
      "title": "VeNatura Chlorella Dietary Supplement - 520mg per Capsule, 60 Count - Vegan Wellness Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/7iYTqY6JrTE41LfqYGvt8XQ59RrD92J4N4bEJr2B.jpg?v=1790549957",
      "score": 51,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "venatura",
        "chlorella",
        "dietary",
        "supplement",
        "520mg",
        "per",
        "capsule",
        "count",
        "vegan",
        "wellness",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 42,
        "formulation": 65,
        "manufacturing": 40,
        "safety": 72,
        "transparency": 58,
        "sustainability": 25
      },
      "price": 28.37,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575871508677",
      "vsf_explanation": "VeNatura's Chlorella supplement clearly discloses its 520 mg dose and avoids the overstated detox claims seen on a sibling SKU, but the underlying generic evidence for general wellness benefit remains thin. Combined with the brand's undisclosed manufacturing certification, this keeps the product in the Rejected tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "voonka-calcium-magnesium-alpha-galactosidase-dietary-supplement-32-chewable-tablets-for-digestive-health",
      "title": "Voonka Calcium Magnesium Alpha-Galactosidase Dietary Supplement - 32 Chewable Tablets for Digestive Health",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/D2sJqGx8FqWWYN3VNbHWRUexTBB93eTipUaiGjEx.jpg?v=1790549958",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "joint",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "voonka",
        "calcium",
        "magnesium",
        "alpha",
        "galactosidase",
        "dietary",
        "supplement",
        "chewable",
        "tablets",
        "for",
        "digestive",
        "health",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 56,
        "formulation": 66,
        "manufacturing": 55,
        "safety": 72,
        "transparency": 55,
        "sustainability": 33
      },
      "price": 13.4,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575871541445",
      "vsf_explanation": "Voonka's Calcium Magnesium Alpha-Galactosidase chewable discloses clear per-tablet doses for all three actives, combining an evidence-based digestive enzyme with generic bone-support minerals. Manufacturing and sustainability reflect Voonka's typical eczane/retail-channel Turkish-brand standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "venatura-magnesium-citrate-and-vitamin-b6-supplement-60-tablets-for-muscle-and-nerve-support",
      "title": "VeNatura Magnesium Citrate and Vitamin B6 Supplement - 60 Tablets for Muscle and Nerve Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/pkdIfOYZPitMNK3CrUpqnyxNDbhCCUIM3ahwcVJx.jpg?v=1790549959",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "venatura",
        "magnesium",
        "citrate",
        "and",
        "vitamin",
        "supplement",
        "tablets",
        "for",
        "muscle",
        "and",
        "nerve",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 78,
        "manufacturing": 40,
        "safety": 80,
        "transparency": 62,
        "sustainability": 25
      },
      "price": 17.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575871606981",
      "vsf_explanation": "VeNatura's Magnesium Citrate and Vitamin B6 supplement discloses clear, well-established, and appropriately dosed active ingredients for muscle and nerve support. It reaches Standard tier, limited by the brand's undisclosed manufacturing certification and sustainability practices.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nbtlife-methyllife-dietary-supplement-60-capsules-vitamin-b-complex-zinc-inositol-betain-supplement-for-health-and-wellness",
      "title": "NBTLife Methyllife Dietary Supplement - 60 Capsules, Vitamin B Complex, Zinc, Inositol, Betain Supplement for Health and Wellness",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/X5fUoM6svONT942cPsy8bfoyKnEVANRU3c6i9TYv.jpg?v=1790549958",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive",
        "mood",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nbtlife",
        "methyllife",
        "dietary",
        "supplement",
        "capsules",
        "vitamin",
        "complex",
        "zinc",
        "inositol",
        "betain",
        "supplement",
        "for",
        "health",
        "and",
        "wellness",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 68,
        "manufacturing": 52,
        "safety": 62,
        "transparency": 72,
        "sustainability": 27
      },
      "price": 58.29,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575871639749",
      "vsf_explanation": "NBTLife's Methyllife discloses a fully itemized, exact-dose ten-ingredient B-complex and methylation-support formula, giving it strong transparency, though several B-vitamin doses are well above standard RDA levels in a megadose pattern common to this supplement category. It lands at Standard tier due to missing manufacturing and sustainability disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-supreme-omega-3-fish-oil-supplement-1000mg-heart-brain-health-support-30-enteric-coated-softgels",
      "title": "Nature's Supreme Omega-3 Fish Oil Supplement 1000mg - Heart & Brain Health Support, 30 Enteric-Coated Softgels",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/JQZqWcNdOeyOFjdnCBI3zfdUbvXu0fm7THmPohvr.jpg?v=1790549959",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "supreme",
        "omega",
        "fish",
        "oil",
        "supplement",
        "1000mg",
        "heart",
        "brain",
        "health",
        "support",
        "enteric",
        "coated",
        "softgels",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 72,
        "manufacturing": 45,
        "safety": 65,
        "transparency": 55,
        "sustainability": 22
      },
      "price": 20.88,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575871672517",
      "vsf_explanation": "Nature's Supreme discloses a full EPA/DHA dose profile using MEG-3 branded raw material, a recognized traceable omega-3 ingredient source, giving it more sourcing credibility than most products in this batch. It remains in Standard due to missing finishing-manufacturer identity and no sustainable-fishing certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "skin-hydrator-ceramide-and-hyaluronic-acid-supplement-visibly-plump-dewy-skin-in-30-days",
      "title": "Skin Hydrator Ceramide and Hyaluronic Acid Supplement - Visibly Plump, Dewy Skin in 30 Days",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/b6bBpdLErEMFyKmrjChXPNtlYjsZgUdHsnICXLyr.jpg?v=1790549961",
      "score": 26,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "skin",
        "hydrator",
        "ceramide",
        "and",
        "hyaluronic",
        "acid",
        "supplement",
        "visibly",
        "plump",
        "dewy",
        "skin",
        "days",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 15,
        "manufacturing": 30,
        "safety": 50,
        "transparency": 15,
        "sustainability": 20
      },
      "price": 87.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575871738053",
      "vsf_explanation": "This listing has no identifiable brand name - it is titled only with a generic descriptive phrase ('Skin Hydrator'), which means buyers cannot verify who actually manufactures or stands behind the product. Combined with undisclosed ingredient doses and an unsubstantiated 'Clean & Planet Aware' claim, this is treated as a naming/provenance failure.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "venatura-l-carnitine-and-taurine-supplement-25ml-x-20-bottles-vegan-gluten-free-energy-support",
      "title": "VeNatura L-Carnitine and Taurine Supplement - 25ml x 20 Bottles - Vegan, Gluten-Free Energy Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/oRXsdghL1xXYHCEAGP7QkBBEsvM3sbpozGMFXEJP.jpg?v=1790549961",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "venatura",
        "carnitine",
        "and",
        "taurine",
        "supplement",
        "25ml",
        "bottles",
        "vegan",
        "gluten",
        "free",
        "energy",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 72,
        "manufacturing": 40,
        "safety": 75,
        "transparency": 60,
        "sustainability": 25
      },
      "price": 52.31,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575871770821",
      "vsf_explanation": "VeNatura's L-Carnitine and Taurine liquid discloses specific, reasonable per-serving doses of both actives with useful free-from labeling. It reaches Standard tier, limited by the brand's undisclosed manufacturing certification and sustainability practices.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "venatura-ginger-extract-supplement-500mg-60-tablets-natural-anti-inflammatory-digestive-health-support",
      "title": "VeNatura Ginger Extract Supplement 500mg - 60 Tablets - Natural Anti-Inflammatory & Digestive Health Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cs2eQwb1KdTkIQQTcMZTbz3BhQdMPBwNTpItYM2b.jpg?v=1790549961",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "venatura",
        "ginger",
        "extract",
        "supplement",
        "500mg",
        "tablets",
        "natural",
        "anti",
        "inflammatory",
        "digestive",
        "health",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 70,
        "manufacturing": 40,
        "safety": 75,
        "transparency": 58,
        "sustainability": 25
      },
      "price": 26.86,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575871803589",
      "vsf_explanation": "VeNatura's Ginger Extract supplement discloses a clear 500 mg dose consistent with commonly used ranges for digestive comfort, without disease-treatment claims. It reaches Standard tier, limited by the brand's undisclosed manufacturing certification and sustainability practices.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nondo-ester-c-complex-vitamin-c-supplement-30-absorbable-tablets-for-immune-system-support",
      "title": "Nondo Ester C Complex Vitamin C Supplement - 30 Absorbable Tablets for Immune System Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9Pzq9sGtGOLJF52z44txyFN9W6HOJEkHnBTzlhpx.jpg?v=1790549961",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nondo",
        "ester",
        "complex",
        "vitamin",
        "supplement",
        "absorbable",
        "tablets",
        "for",
        "immune",
        "system",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 65,
        "manufacturing": 66,
        "safety": 75,
        "transparency": 72,
        "sustainability": 36
      },
      "price": 22.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575871836357",
      "vsf_explanation": "Nondo Ester C Complex fully discloses its five active ingredients and their doses, with solid evidence behind the vitamin C and zinc components, though the beta-glucan amount is well below typically studied immune-support doses and the 'Ester-C' naming is not independently confirmed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "kondromin-glucosamine-chondroitin-supplement-for-joint-health-support-60-tablets",
      "title": "Kondromin - Glucosamine & Chondroitin Supplement for Joint Health Support - 60 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/f1NAcd98qcaVVzK026sSEP447c7MqVSTc4QeHLHQ.jpg?v=1790549961",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "kondromin",
        "glucosamine",
        "chondroitin",
        "supplement",
        "for",
        "joint",
        "health",
        "support",
        "tablets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 75,
        "manufacturing": 38,
        "safety": 60,
        "transparency": 55,
        "sustainability": 22
      },
      "price": 47.81,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575871869125",
      "vsf_explanation": "Kondromin discloses Glucosamine HCl and Chondroitin Sulfate at doses that closely match amounts used in well-known joint-health clinical research. The formula is honestly and completely dosed, though manufacturing and sourcing details are not disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "venatura-zinc-l-carnosine-supplement-60-capsules-for-immune-system-support",
      "title": "VeNatura Zinc L-Carnosine Supplement - 60 Capsules for Immune System Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Ve40vYTObOxGa0ls4IzTXkdA3jHwzszkWSKpOhEg.jpg?v=1790549966",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "venatura",
        "zinc",
        "carnosine",
        "supplement",
        "capsules",
        "for",
        "immune",
        "system",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 68,
        "manufacturing": 40,
        "safety": 72,
        "transparency": 55,
        "sustainability": 25
      },
      "price": 32.85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575872098501",
      "vsf_explanation": "VeNatura's Zinc L-Carnosine product discloses a dose comparable to published research, but that research is concentrated on gastric mucosal support rather than the general 'immune system support' claim made on the label. This evidence-to-claim mismatch, combined with the brand's undisclosed manufacturing certification, places it in the Rejected tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "suda-vitamin-bromelain-500-mg-natural-digestive-enzyme-supplement-for-protein-digestion-support-60-tablets",
      "title": "Suda Vitamin Bromelain 500 mg - Natural Digestive Enzyme Supplement for Protein Digestion Support - 60 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/rOmPFhHCzC49JICDTAANQr1txDNbb5YQLiI2xE3S.jpg?v=1790549966",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "suda",
        "vitamin",
        "bromelain",
        "500",
        "natural",
        "digestive",
        "enzyme",
        "supplement",
        "for",
        "protein",
        "digestion",
        "support",
        "tablets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 70,
        "manufacturing": 50,
        "safety": 58,
        "transparency": 60,
        "sustainability": 27
      },
      "price": 18.84,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575872164037",
      "vsf_explanation": "Suda's Bromelain product discloses a clear single-ingredient dose and appropriately avoids overstating its therapeutic role, earning Standard tier. Missing enzyme-activity units, allergy caution, and manufacturing disclosure keep it below Verified tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "zinco-zinc-supplement-with-herbal-oil-blend-dietary-supplement-for-immune-support-30-ml-liquid-drops",
      "title": "Zinco - Zinc Supplement with Herbal Oil Blend - Dietary Supplement for Immune Support - 30 ml Liquid Drops",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/p4Fg3xXolSwOEzO3Qin5XlFZILdhgf0Ph9aIhun2.jpg?v=1790549966",
      "score": 25,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zinco",
        "zinc",
        "supplement",
        "with",
        "herbal",
        "oil",
        "blend",
        "dietary",
        "supplement",
        "for",
        "immune",
        "support",
        "liquid",
        "drops",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 12,
        "manufacturing": 30,
        "safety": 38,
        "transparency": 20,
        "sustainability": 18
      },
      "price": 13.4,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575872131269",
      "vsf_explanation": "Zinco combines zinc sulfate with cumin and oregano oil in a liquid drop format, but never discloses the concentration of any of the three ingredients - only a '4 drops twice daily' volume instruction is given. Without concentration data, the actual zinc dose and the safety of the oregano oil content cannot be verified.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "ellips-hair-vitamin-supplement-for-hair-vitality-and-health-50-capsules",
      "title": "Ellips Hair Vitamin Supplement for Hair Vitality and Health - 50 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/mdWJ6t8ReTktyYKAFkuSKzJJLKjjaUBmrGVetyzM.jpg?v=1790549967",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ellips",
        "hair",
        "vitamin",
        "supplement",
        "for",
        "hair",
        "vitality",
        "and",
        "health",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 15,
        "manufacturing": 80,
        "safety": 25,
        "transparency": 20,
        "sustainability": 50
      },
      "price": 35.52,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575872196805",
      "vsf_explanation": "This listing markets Ellips as an ingestible hair vitamin supplement that works 'from the inside out,' but Ellips capsules are actually a topical leave-in hair oil meant to be broken open and applied directly to hair, not swallowed, making the listing's core premise misleading.",
      "vsf_autofail_rule": "misleading_naming"
    },
    {
      "handle": "zade-vital-iron-supplement-with-prebiotic-support-for-adults-vegan-vegetarian-friendly-dietary-supplement",
      "title": "Zade Vital - Iron Supplement with Prebiotic Support for Adults, Vegan & Vegetarian Friendly Dietary Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/mm4Cic6qrNHUTaxoOrpB3cDkuPNlRN23zpxd09BC.jpg?v=1790549971",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "zade",
        "vital",
        "iron",
        "supplement",
        "with",
        "prebiotic",
        "support",
        "for",
        "adults",
        "vegan",
        "vegetarian",
        "friendly",
        "dietary",
        "supplement",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 70,
        "manufacturing": 48,
        "safety": 60,
        "transparency": 58,
        "sustainability": 27
      },
      "price": 20.2,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575872262341",
      "vsf_explanation": "Zade Vital's iron and inulin combination is dosed clearly and addresses a well-documented nutrient function, earning a Standard-tier score. The brand does not disclose manufacturing facility details, third-party testing, or sustainability practices, which caps the score below Verified tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "venatura-coenzyme-q10-200mg-supplement-antioxidant-support-for-energy-cardiovascular-health",
      "title": "VeNatura Coenzyme Q10 200mg Supplement - Antioxidant Support for Energy & Cardiovascular Health",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/nPP5oVY9yUsRQAWyEgJfkRpg4azBZ224mvWx0Bw7.jpg?v=1790549972",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "venatura",
        "coenzyme",
        "q10",
        "200mg",
        "supplement",
        "antioxidant",
        "support",
        "for",
        "energy",
        "cardiovascular",
        "health",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 75,
        "manufacturing": 40,
        "safety": 78,
        "transparency": 60,
        "sustainability": 25
      },
      "price": 23.87,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575872327877",
      "vsf_explanation": "VeNatura's CoQ10 supplement discloses a clear 200 mg dose within a commonly studied range, backed by a genuine generic evidence base for energy and cardiovascular support. It reaches Standard tier, limited by the brand's undisclosed manufacturing certification and sustainability practices.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "kc-f1-dietary-supplement-for-liver-support-energy-60-tablets",
      "title": "KC F1 Dietary Supplement for Liver Support & Energy - 60 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/C73gXmPnP0PcUP5YLErAjITRzntRuGO99xymmXqS.jpg?v=1790549973",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dietary",
        "supplement",
        "for",
        "liver",
        "support",
        "energy",
        "tablets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 50,
        "manufacturing": 36,
        "safety": 55,
        "transparency": 42,
        "sustainability": 20
      },
      "price": 55.3,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575872360645",
      "vsf_explanation": "KC F1 discloses solid per-serving doses for its BCAA, phosphatidylcholine and glutathione content, but the milk thistle, artichoke, and dandelion extracts that anchor its 'liver support' claim have no disclosed amount. The energy-support portion of the formula is more transparently dosed than the liver-support portion.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "motilex-dietary-supplement-for-energy-and-vitality-30-capsules",
      "title": "Motilex Dietary Supplement for Energy and Vitality - 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/iYsj7H77H9yUTO5najfbxrcdkX4IHDSMOl8GRuAJ.jpg?v=1790549977",
      "score": 27,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "motilex",
        "dietary",
        "supplement",
        "for",
        "energy",
        "and",
        "vitality",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 12,
        "manufacturing": 32,
        "safety": 42,
        "transparency": 22,
        "sustainability": 18
      },
      "price": 128.6,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575872393413",
      "vsf_explanation": "Motilex names an extensive list of energy, immune, and antioxidant ingredients - L-Carnitine, L-Arginine, Panax Ginseng, vitamins, minerals, and antioxidants - but discloses zero dosing for any of them. With no quantities disclosed for such a large ingredient list, the formula's actual strength cannot be assessed.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "beeo-water-soluble-propolis-extract-supplement-drops-10-pure-propolis-halal-certified-natural-health-support",
      "title": "Beeo Water-Soluble Propolis Extract Supplement Drops - 10% Pure Propolis, Halal Certified, Natural Health Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/aLSgU9sIjKyCPbx0RYQZjTecurbGHuibtErssxNV.jpg?v=1790549979",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "beeo",
        "water",
        "soluble",
        "propolis",
        "extract",
        "supplement",
        "drops",
        "pure",
        "propolis",
        "halal",
        "certified",
        "natural",
        "health",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 55,
        "safety": 48,
        "transparency": 58,
        "sustainability": 25
      },
      "price": 29.85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575872426181",
      "vsf_explanation": "Beeo's propolis extract stands out for naming a specific, verifiable development origin (İTÜ ARI Teknokent, a real Turkish technology park) and a TÜBİTAK-awarded processing method, plus halal certification. However, the listing never states a daily-use dose, and propolis itself has more limited clinical evidence than single-nutrient ingredients.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutraxin-vitamin-b12-supplement-1000-mcg-methylcobalamin-sublingual-tablets-for-vegans-vegetarians-60-count",
      "title": "Nutraxin Vitamin B12 Supplement 1000 mcg - Methylcobalamin Sublingual Tablets for Vegans & Vegetarians, 60 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/IkIBF6oVVmnPdiD4TDlIsdAJcxfEX8nb3vSw7W9i.jpg?v=1790549979",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutraxin",
        "vitamin",
        "b12",
        "supplement",
        "1000",
        "mcg",
        "methylcobalamin",
        "sublingual",
        "tablets",
        "for",
        "vegans",
        "vegetarians",
        "count",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 72,
        "manufacturing": 45,
        "safety": 80,
        "transparency": 60,
        "sustainability": 20
      },
      "price": 18.84,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575872458949",
      "vsf_explanation": "This Nutraxin sublingual B12 tablet discloses a clear, well-evidenced dose in a form well-suited to vegans and vegetarians, with an excellent safety profile. It reaches Standard tier on clean formulation and dosing, though the brand's undisclosed manufacturing and sustainability practices cap it there.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "suda-vitamin-d3-1000-iu-vitamin-d3-supplement-100-tablets-for-immune-system-bone-health-support",
      "title": "Suda Vitamin D3 1000 IU Vitamin D3 Supplement - 100 Tablets for Immune System & Bone Health Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/BchCTKeu0oOzpUOlucRrOm1qbLHEc9Mkh0O4Td3b.jpg?v=1790549982",
      "score": 62,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "suda",
        "vitamin",
        "1000",
        "vitamin",
        "supplement",
        "100",
        "tablets",
        "for",
        "immune",
        "system",
        "bone",
        "health",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 72,
        "manufacturing": 50,
        "safety": 68,
        "transparency": 60,
        "sustainability": 27
      },
      "price": 14.89,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575872557253",
      "vsf_explanation": "Suda's Vitamin D3 tablets use a well-established nutrient claim, a clearly disclosed standard dose, and an explicit non-medication safety note, earning Standard tier. Missing manufacturing facility and sourcing disclosure keep it below Verified tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "doppelherz-aktiv-demir-iron-supplement-with-vitamin-c-l-histidine-dietary-supplement-30-tablets",
      "title": "Doppelherz Aktiv Demir Iron Supplement with Vitamin C & L-Histidine Dietary Supplement - 30 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/aEpiozFWmoGAGXfpCXPafg5QBFPwTP8Uc2RnJAdA.jpg?v=1790549982",
      "score": 70,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "immune",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "doppelherz",
        "aktiv",
        "demir",
        "iron",
        "supplement",
        "with",
        "vitamin",
        "histidine",
        "dietary",
        "supplement",
        "tablets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 75,
        "manufacturing": 82,
        "safety": 68,
        "transparency": 68,
        "sustainability": 35
      },
      "price": 31.36,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575872590021",
      "vsf_explanation": "Doppelherz Aktiv Demir discloses a full, clinically standard iron/vitamin C/folic acid/B12 formula at moderate, non-excessive doses. As an established German OTC brand with real EU manufacturing infrastructure, it scores meaningfully higher on manufacturing and transparency than the single-market Turkish brands in this batch.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutraxin-beauty-collagen-complex-90-tablets-hydrolyzed-collagen-supplement-with-hyaluronic-acid-vitamin-c-for-skin-hair-joint-health",
      "title": "Nutraxin Beauty Collagen Complex 90 Tablets - Hydrolyzed Collagen Supplement with Hyaluronic Acid & Vitamin C for Skin, Hair & Joint Health",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/5APIy6T514dy5x2yxEzrZLVECs0p1sEab2voQjOl.jpg?v=1790549986",
      "score": 48,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutraxin",
        "beauty",
        "collagen",
        "complex",
        "tablets",
        "hydrolyzed",
        "collagen",
        "supplement",
        "with",
        "hyaluronic",
        "acid",
        "vitamin",
        "for",
        "skin",
        "hair",
        "joint",
        "health",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 48,
        "manufacturing": 45,
        "safety": 70,
        "transparency": 50,
        "sustainability": 20
      },
      "price": 50,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575872622789",
      "vsf_explanation": "Nutraxin Beauty Collagen Complex uses a multi-type hydrolyzed collagen blend with generically well-evidenced co-ingredients, but the page discloses no gram amount for the collagen itself, so the dose can't be checked against the research it's implicitly trading on. That gap, plus undisclosed manufacturing and sustainability practices, results in a Rejected-tier score.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "memoran-collagen-supplement-with-omega-3-b-vitamins-60-capsules-for-skin-hair-heart-health",
      "title": "Memoran Collagen Supplement with Omega-3 & B Vitamins - 60 Capsules for Skin, Hair & Heart Health",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/cLfBvDJKOQeUmGty9W0xBxU0pmqL67qMGObdbLSK.jpg?v=1790549987",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive",
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "memoran",
        "collagen",
        "supplement",
        "with",
        "omega",
        "vitamins",
        "capsules",
        "for",
        "skin",
        "hair",
        "heart",
        "health",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 55,
        "manufacturing": 36,
        "safety": 58,
        "transparency": 48,
        "sustainability": 20
      },
      "price": 46.31,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575872655557",
      "vsf_explanation": "Memoran discloses collagen peptide and omega-3 doses per serving, but the collagen amount (150mg per capsule) sits at the lower end of what collagen research typically studies, and several named B vitamins have no disclosed amount. It is honestly labeled but modestly dosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "melatin-melatonin-supplement-30-tablets-supports-sleep-regulation-quality",
      "title": "Melatin Melatonin Supplement 30 Tablets - Supports Sleep Regulation & Quality",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/DEUEouVmMBnvr17CnHKByU2hRz4JXPMVXVT54q94.jpg?v=1790549988",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "melatin",
        "melatonin",
        "supplement",
        "tablets",
        "supports",
        "sleep",
        "regulation",
        "quality",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 64,
        "formulation": 68,
        "manufacturing": 38,
        "safety": 62,
        "transparency": 58,
        "sustainability": 22
      },
      "price": 23.87,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575872688325",
      "vsf_explanation": "Melatin delivers a clearly disclosed 3mg melatonin dose with usage instructions and an age restriction, giving buyers a genuinely transparent single-ingredient product. Manufacturing and sourcing information remain undisclosed, keeping it at Standard rather than a higher tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "onvita-nutrition-creatine-supplement-powder-enhances-muscle-strength-athletic-performance",
      "title": "OnVita Nutrition Creatine Supplement Powder - Enhances Muscle Strength & Athletic Performance",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/UsynDq6hnKOTFJaUUHc1Pu9VOxJrdg2CTz5UNwr5.jpg?v=1790550011",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "recovery",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "onvita",
        "nutrition",
        "creatine",
        "supplement",
        "powder",
        "enhances",
        "muscle",
        "strength",
        "athletic",
        "performance",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "protein_amino_acids"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 70,
        "manufacturing": 38,
        "safety": 68,
        "transparency": 50,
        "sustainability": 22
      },
      "price": 44.36,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575876391109",
      "vsf_explanation": "OnVita Nutrition's creatine powder discloses clear per-serving doses of creatine monohydrate and tricreatine malate, ingredients with strong evidence for muscle strength and performance. Manufacturing transparency and sustainability information are not disclosed, keeping it in the Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-turmeric-1000-mg-plus-black-pepper-supplement-anti-inflammatory-antioxidant-support-60-capsules",
      "title": "Natures Bounty Turmeric 1000 mg Plus Black Pepper Supplement - Anti-Inflammatory, Antioxidant Support, 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Aq26ZGCPQ9BLhhRkrjZjp6QJEtkKnWEcMNCIPjCP.jpg?v=1790550011",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "natures",
        "bounty",
        "turmeric",
        "1000",
        "plus",
        "black",
        "pepper",
        "supplement",
        "anti",
        "inflammatory",
        "antioxidant",
        "support",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 72,
        "manufacturing": 85,
        "safety": 78,
        "transparency": 72,
        "sustainability": 45
      },
      "price": 38.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575876423877",
      "vsf_explanation": "Nature's Bounty's Turmeric capsule discloses a precise, evidence-aligned 95 mg curcuminoid (95% standardization) plus piperine formulation, backed by a moderate-to-good generic evidence base for joint and anti-inflammatory support. Combined with the brand's established cGMP manufacturing standard, this SKU reaches Verified tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitendix-collagen-supplement-for-joint-support-skin-health-anti-inflammatory-benefits-type-1-fish-collagen-hyaluronic-acid-msm-more-30-tablets",
      "title": "Vitendix: Collagen Supplement for Joint Support, Skin Health & Anti-Inflammatory Benefits - Type 1 Fish Collagen, Hyaluronic Acid, MSM & More (30 Tablets)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Vphvc2LHbRatPUwK46pHXvgaDgyBT3ILaC0JYlV5.jpg?v=1790550019",
      "score": 27,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint",
        "inflammation"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitendix",
        "collagen",
        "supplement",
        "for",
        "joint",
        "support",
        "skin",
        "health",
        "anti",
        "inflammatory",
        "benefits",
        "type",
        "fish",
        "collagen",
        "hyaluronic",
        "acid",
        "msm",
        "more",
        "tablets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 15,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 25,
        "sustainability": 20
      },
      "price": 56.45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575876718789",
      "vsf_explanation": "Vitendix combines fish collagen, hyaluronic acid, MSM, and Boswellia for joint and skin support, but the listing never states how much of any ingredient is actually in each tablet. Without disclosed doses, buyers cannot verify the formula contains therapeutically relevant amounts of its headline ingredients.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "ligone-day-night-supplement-24-hour-nutritional-support-with-daily-nighttime-capsules-30-day-supply",
      "title": "Ligone Day & Night Supplement: 24-Hour Nutritional Support with Daily & Nighttime Capsules, 30-Day Supply",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0t0BwIoVpSeGgiZrcnU2BxZ8TGV1A9sbVAnJ71m7.jpg?v=1790550019",
      "score": 31,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ligone",
        "day",
        "night",
        "supplement",
        "hour",
        "nutritional",
        "support",
        "with",
        "daily",
        "nighttime",
        "capsules",
        "day",
        "supply",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 10,
        "manufacturing": 68,
        "safety": 40,
        "transparency": 12,
        "sustainability": 38
      },
      "price": 82.23,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575876784325",
      "vsf_explanation": "Ligone Day & Night Supplement claims to support daytime energy and nighttime relaxation with a two-capsule regimen, but the listing discloses no ingredients or doses for either capsule, making the entire formulation unverifiable.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "goodday-vitamin-c-1000mg-60-capsules-high-dose-immune-support-supplement-for-enhanced-well-being",
      "title": "Goodday Vitamin C 1000mg - 60 Capsules - High-Dose Immune Support Supplement for Enhanced Well-being",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/zktbxNCTOKbkzaSUgYwmIR8qARGOR1IniizvICTF.jpg?v=1790550019",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "goodday",
        "vitamin",
        "1000mg",
        "capsules",
        "high",
        "dose",
        "immune",
        "support",
        "supplement",
        "for",
        "enhanced",
        "well",
        "being",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 62,
        "manufacturing": 56,
        "safety": 68,
        "transparency": 65,
        "sustainability": 38
      },
      "price": 27.91,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575876751557",
      "vsf_explanation": "Goodday Vitamin C 1000mg clearly discloses a single, well-defined 1,000mg dose per capsule, and its cold-duration claim is reasonably aligned with published vitamin C research. It scores Standard tier, limited by the absence of disclosed manufacturing certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vikolin-advanced-antioxidant-supplement-with-citicoline-glutathione-coq10-resveratrol-vitamins-memory",
      "title": "Vikolin: Advanced & Antioxidant Supplement with Citicoline, Glutathione, CoQ10, Resveratrol & Vitamins - Memory",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/vx8xZ1EDyEtJJHMJlAymevAm1LeEoV1ulthg52sp.jpg?v=1790550019",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy",
        "longevity",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vikolin",
        "advanced",
        "antioxidant",
        "supplement",
        "with",
        "citicoline",
        "glutathione",
        "coq10",
        "resveratrol",
        "vitamins",
        "memory",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 70,
        "manufacturing": 42,
        "safety": 65,
        "transparency": 52,
        "sustainability": 25
      },
      "price": 59.18,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575876882629",
      "vsf_explanation": "Vikolin discloses specific per-dose amounts for citicoline, glutathione, CoQ10, and resveratrol, giving buyers a real basis to evaluate the formula. Manufacturing and sustainability information is not disclosed, which keeps it in Standard rather than a higher tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "intra-k2-hydrolyzed-bovine-collagen-supplement-boost-skin-health-joint-support-30-vials-for-a-months-supply",
      "title": "Intra K2 Hydrolyzed Bovine Collagen Supplement: Boost Skin Health & Joint Support - 30 Vials for a Month's Supply",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/JA3nQZO38URKxzuWx0UmfECaTwK2OMXp6TGjEUa7.jpg?v=1790550019",
      "score": 33,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "intra",
        "hydrolyzed",
        "bovine",
        "collagen",
        "supplement",
        "boost",
        "skin",
        "health",
        "joint",
        "support",
        "vials",
        "for",
        "month",
        "supply",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 20,
        "manufacturing": 35,
        "safety": 55,
        "transparency": 30,
        "sustainability": 20
      },
      "price": 133.23,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575876980933",
      "vsf_explanation": "Intra K2 is a single-ingredient hydrolyzed bovine collagen liquid, but the listing never discloses how much collagen is actually in each vial. Without that number, buyers cannot compare this product to the doses used in collagen research.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "delta-ceraplus-ceramide-biotin-multimineral-supplement-hair-growth-skin-health-nail-strengthening-30-capsules",
      "title": "Delta Ceraplus: Ceramide Biotin Multimineral Supplement - Hair Growth, Skin Health & Nail Strengthening - 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NAksl6jqSZyoVOqQpgAQSMTyNRjBwChw4GdJy12l.jpg?v=1790550019",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "delta",
        "ceraplus",
        "ceramide",
        "biotin",
        "multimineral",
        "supplement",
        "hair",
        "growth",
        "skin",
        "health",
        "nail",
        "strengthening",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 68,
        "manufacturing": 45,
        "safety": 52,
        "transparency": 62,
        "sustainability": 25
      },
      "price": 67.41,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575877013701",
      "vsf_explanation": "Delta's Ceraplus discloses exact doses for all four active ingredients and rests on generally well-established beauty-nutrient claims, but its high-dose biotin (5000mcg) carries an undisclosed lab-test-interference risk. That safety gap, plus no manufacturing disclosure, keeps this SKU at the low end of Standard tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "do_aderma-tribudeha-herbal-supplement-with-tribulus-damiana-ginkgo-amp-ginseng-30-capsules",
      "title": "Do_aDerma Tribudeha Herbal Supplement with Tribulus, Damiana, Ginkgo &amp; Ginseng - 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/pxYiip5PtSmrDSGndcdhjzF7x7g7KxoKhGarZtqp.jpg?v=1790550019",
      "score": 24,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive",
        "energy",
        "mood",
        "hormone",
        "recovery"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "do_aderma",
        "tribudeha",
        "herbal",
        "supplement",
        "with",
        "tribulus",
        "damiana",
        "ginkgo",
        "amp",
        "ginseng",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 10,
        "manufacturing": 30,
        "safety": 40,
        "transparency": 20,
        "sustainability": 15
      },
      "price": 90.45,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575876849861",
      "vsf_explanation": "DoğaDerma's Tribudeha blends four traditional herbs (Tribulus, Damiana, Ginkgo, Ginseng) for male vitality, but the listing provides no dose for any of them. With a two-sentence description and no quantities disclosed, the formula's actual strength cannot be evaluated.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "delta-betamax-30-tablets-daily-health-dietary-supplement-convenient-oral-tablet-form",
      "title": "Delta Betamax 30 Tablets: Daily Health & Dietary Supplement - Convenient Oral Tablet Form",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/gAGTb0AwjfqF8zDr0gnJUzIY12cRTPr9LCpgInqb.jpg?v=1790550019",
      "score": 22,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "delta",
        "betamax",
        "tablets",
        "daily",
        "health",
        "dietary",
        "supplement",
        "convenient",
        "oral",
        "tablet",
        "form",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 10,
        "manufacturing": 45,
        "safety": 20,
        "transparency": 15,
        "sustainability": 25
      },
      "price": 31.2,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575876948165",
      "vsf_explanation": "Delta Betamax's available product copy never names a single active ingredient, compound, or dose anywhere in the listing, making it impossible to evaluate evidence, formulation, or safety for this product. This is the most severe disclosure failure in the batch and places the product in Rejected tier with an autofail flag.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "anti-peptocyn-betaine-hcl-pepsin-supplement-for-optimal-digestion-stomach-acid-support-90-vegetarian-capsules",
      "title": "Anti Peptocyn: Betaine HCL & Pepsin Supplement for Optimal Digestion & Stomach Acid Support - 90 Vegetarian Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/jIH03CSsproqPln7rTFp0TuDuWtfAG2ggzWtXGEL.jpg?v=1790550019",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "anti",
        "peptocyn",
        "betaine",
        "hcl",
        "pepsin",
        "supplement",
        "for",
        "optimal",
        "digestion",
        "stomach",
        "acid",
        "support",
        "vegetarian",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 68,
        "manufacturing": 38,
        "safety": 50,
        "transparency": 50,
        "sustainability": 20
      },
      "price": 34.49,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575876817093",
      "vsf_explanation": "Anti Peptocyn discloses clear per-capsule doses of Betaine HCL and Pepsin for digestive support. The listing omits the standard ulcer/NSAID caution associated with Betaine HCL supplements and provides no manufacturing detail, which caps the score.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "citoserin-omega-3-citicoline-phosphatidylserine-dietary-supplement-capsules",
      "title": "Citoserin: Omega 3, Citicoline & Phosphatidylserine - Dietary Supplement Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/hlwWHfrdILLaVGTq1My9b8ibod3Ry6DaWGPDlDq5.jpg?v=1790550019",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "citoserin",
        "omega",
        "citicoline",
        "phosphatidylserine",
        "dietary",
        "supplement",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 30,
        "manufacturing": 33,
        "safety": 52,
        "transparency": 30,
        "sustainability": 20
      },
      "price": 88.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575876915397",
      "vsf_explanation": "Citoserin discloses a standard omega-3 fish oil dose but never states how much citicoline or phosphatidylserine it actually contains, despite naming both in the title. Buyers cannot verify the two cognitive-support actives are present in an effective amount.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "delta-cognimax-advanced-brain-health-supplement-boost-memory-focus-cognitive-function-with-citicoline-pine-bark-extract-b-vitamins",
      "title": "Delta Cognimax: Advanced Brain Health Supplement | Boost Memory, Focus & Cognitive Function with Citicoline, Pine Bark Extract, B Vitamins",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/KShMgR5XCKCcOOFe5voUwtpNTPOgHRr7mqE11HDU.jpg?v=1790550019",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "delta",
        "cognimax",
        "advanced",
        "brain",
        "health",
        "supplement",
        "boost",
        "memory",
        "focus",
        "cognitive",
        "function",
        "with",
        "citicoline",
        "pine",
        "bark",
        "extract",
        "vitamins",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 75,
        "manufacturing": 45,
        "safety": 62,
        "transparency": 63,
        "sustainability": 25
      },
      "price": 49.3,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575877046469",
      "vsf_explanation": "Delta Cognimax combines citicoline and pine bark extract at doses consistent with published clinical research, giving it the strongest evidence and formulation profile in the Delta line for this batch. Missing manufacturing facility disclosure keeps it at Standard rather than Verified tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "tetrafolic-enhanced-folic-acid-supplement-supports-healthy-cell-growth-fetal-development-30-easy-swallow-vegetable-capsules",
      "title": "Tetrafolic: Enhanced Folic Acid Supplement - Supports Healthy Cell Growth & Fetal Development - 30 Easy-Swallow Vegetable Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/F4ObeBjmzQuKhClbhF7cGJHvUiHsEsVd8kZ6coH3.jpg?v=1790550019",
      "score": 36,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "tetrafolic",
        "enhanced",
        "folic",
        "acid",
        "supplement",
        "supports",
        "healthy",
        "cell",
        "growth",
        "fetal",
        "development",
        "easy",
        "swallow",
        "vegetable",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 20,
        "manufacturing": 35,
        "safety": 55,
        "transparency": 30,
        "sustainability": 20
      },
      "price": 37.79,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575877177541",
      "vsf_explanation": "Tetrafolic markets 'enhanced absorption' folic acid for fetal development and cell growth, but never states the actual folic acid content per capsule. For a product marketed specifically to pregnant or child-bearing-age users, the missing dose is a material gap.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "delta-p-5-p-vitamin-b6-supplement-enhanced-absorption-liquid-formula-for-nerve-brain-health-300-ml",
      "title": "Delta P-5-P Vitamin B6 Supplement: Enhanced Absorption Liquid Formula for Nerve & Brain Health - 300 ml",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/grcNvYmw6vc73ADfrvm9oQFsu0AMkkHcROoD1eoj.jpg?v=1790550019",
      "score": 51,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "delta",
        "vitamin",
        "supplement",
        "enhanced",
        "absorption",
        "liquid",
        "formula",
        "for",
        "nerve",
        "brain",
        "health",
        "300",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 48,
        "transparency": 55,
        "sustainability": 25
      },
      "price": 46.06,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575877275845",
      "vsf_explanation": "Delta's P-5-P liquid for nerve and brain health never discloses an mg-per-serving dose anywhere in the available copy, despite naming a well-established active B6 form. That gap makes it impossible to rule out either an ineffective or an excessive dose, placing this SKU in Rejected tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "sperra-dietary-supplement-capsules-boost-your-health-wellness-naturally",
      "title": "Sperra Dietary Supplement Capsules: Boost Your Health & Wellness Naturally",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/embmL1uHnGu5eajdnLFY8YSCVvKV1m4AhyVZFosc.jpg?v=1790550019",
      "score": 15,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "sperra",
        "dietary",
        "supplement",
        "capsules",
        "boost",
        "your",
        "health",
        "wellness",
        "naturally",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 5,
        "manufacturing": 25,
        "safety": 30,
        "transparency": 10,
        "sustainability": 15
      },
      "price": 59.18,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575877243077",
      "vsf_explanation": "Sperra is marketed as general wellness support, but the listing never names a single active ingredient, dose, or nutrient. There is no way to determine what this product actually contains or whether it can deliver any of its marketed benefits.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "nutraxin-d3-k2-vitamin-supplement-120-tablets-for-bone-health-immune-support-vitamin-d3-1000-iu-k2-25-mcg-boost-calcium-absorption",
      "title": "Nutraxin D3 K2 Vitamin Supplement: 120 Tablets for Bone Health, Immune Support - Vitamin D3 1000 IU & K2 25 mcg - Boost Calcium Absorption",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/XqKrGaLtQXdpz8U1126UsDN95Scp3u3H9fJX3Ugy_365fe687-636f-4e24-b4f7-275ab72b7f46.jpg?v=1790550019",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutraxin",
        "vitamin",
        "supplement",
        "120",
        "tablets",
        "for",
        "bone",
        "health",
        "immune",
        "support",
        "vitamin",
        "1000",
        "mcg",
        "boost",
        "calcium",
        "absorption",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 70,
        "manufacturing": 45,
        "safety": 75,
        "transparency": 60,
        "sustainability": 20
      },
      "price": 24.52,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575877144773",
      "vsf_explanation": "This Nutraxin D3/K2 tablet discloses clear, appropriately dosed amounts of both active ingredients backed by solid generic evidence for bone and calcium-regulation support. It lands in Standard tier because the brand has no disclosed manufacturing certification or sustainability information.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-probiotic-acidophilus-capsules-support-digestive-gut-health-100-count-probiotic-supplement-for-optimal-intestinal-flora",
      "title": "Nature's Bounty Probiotic Acidophilus Capsules: Support Digestive & Gut Health, 100 Count - Probiotic Supplement for Optimal Intestinal Flora",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/tq1InK9CgK45BmQfK5Lt3n9pdBZLOnXCJVTmtC5M.jpg?v=1790550020",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "probiotic",
        "acidophilus",
        "capsules",
        "support",
        "digestive",
        "gut",
        "health",
        "100",
        "count",
        "probiotic",
        "supplement",
        "for",
        "optimal",
        "intestinal",
        "flora",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 45,
        "formulation": 40,
        "manufacturing": 85,
        "safety": 78,
        "transparency": 50,
        "sustainability": 45
      },
      "price": 41.07,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575877210309",
      "vsf_explanation": "Nature's Bounty's Probiotic Acidophilus capsule is manufactured under the brand's established cGMP-certified US facility standards, but the listing does not disclose the CFU count or specific bacterial strain, the two pieces of information needed to assess a probiotic's actual potency. That gap keeps this product in Standard tier despite strong manufacturing.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "magnimore-pro-advanced-magnesium-supplement-with-magtein-vitamin-d3-c-b6-supports-bone-health-muscle-function-cognitive-health",
      "title": "Magnimore Pro: Advanced Magnesium Supplement with Magtein, Vitamin D3, C & B6 - Supports Bone Health, Muscle Function & Cognitive Health",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/KWZr1DnwEx2RrkJz94alVz912ZQVIQUtZooh1sHa.jpg?v=1790550019",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "immune",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnimore",
        "pro",
        "advanced",
        "magnesium",
        "supplement",
        "with",
        "magtein",
        "vitamin",
        "supports",
        "bone",
        "health",
        "muscle",
        "function",
        "cognitive",
        "health",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 72,
        "formulation": 68,
        "manufacturing": 60,
        "safety": 70,
        "transparency": 62,
        "sustainability": 40
      },
      "price": 67.41,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575877112005",
      "vsf_explanation": "Magnimore Pro uses two patented magnesium forms (Magtein and ATA-Mg) with published ingredient-level research and discloses a clear 165mg magnesium dose per capsule. It scores Standard tier because the accompanying vitamin C, B6, and D3 amounts are not quantified and no finished-product manufacturing certification is disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nbtlife-endofer-iron-vitamin-c-supplement-boost-energy-enhance-absorption-vegan-friendly-30-capsules",
      "title": "Nbtlife Endofer: Iron & Vitamin C Supplement - Boost Energy, Enhance Absorption, Vegan Friendly - 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/HAMa0ViPH4yufdByc48XpnWeQXlCOz5XSLvzGVGP_313c5c65-d15e-4138-a7e5-8b24e7f0d9d8.jpg?v=1790550019",
      "score": 65,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nbtlife",
        "endofer",
        "iron",
        "vitamin",
        "supplement",
        "boost",
        "energy",
        "enhance",
        "absorption",
        "vegan",
        "friendly",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 75,
        "formulation": 78,
        "manufacturing": 52,
        "safety": 65,
        "transparency": 68,
        "sustainability": 27
      },
      "price": 49.3,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575877308613",
      "vsf_explanation": "NBTLife's Endofer pairs a well-established iron-and-Vitamin-C absorption mechanism with clearly disclosed doses and a detailed allergen-free formulation claim, earning the highest score in the NBTLife line for this batch. Missing manufacturing facility disclosure keeps it at Standard rather than Verified tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ocean-hepalex-advanced-liver-support-detox-milk-thistle-artichoke-dandelion-choline-antioxidant-supplement-60-softgels",
      "title": "Ocean Hepalex: Advanced Liver Support & Detox - Milk Thistle, Artichoke, Dandelion, Choline, Antioxidant Supplement - 60 Softgels",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/E9ywnwPaIBkOybifyVtqrsCKuejm9lIDKRLdtmYv_75e84c56-7c9a-42df-8389-519c9c9bc564.jpg?v=1790550019",
      "score": 40,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ocean",
        "hepalex",
        "advanced",
        "liver",
        "support",
        "detox",
        "milk",
        "thistle",
        "artichoke",
        "dandelion",
        "choline",
        "antioxidant",
        "supplement",
        "softgels",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 25,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 30,
        "sustainability": 35
      },
      "price": 31.2,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575877079237",
      "vsf_explanation": "Ocean's Hepalex blends five liver-related ingredients without disclosing the dose of any single one, and pairs that with unverified 'detox' and liver-regeneration claims that overstate what the underlying ingredients have shown in human studies. Because the actual per-ingredient doses cannot be verified from the listing, this product is rejected pending full dose disclosure.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "voonka-zinc-picolinate-highly-absorbable-zinc-supplement-for-enhanced-immunity-optimal-health-60-tablets-15mg-zinc",
      "title": "Voonka Zinc Picolinate: Highly Absorbable Zinc Supplement for Enhanced Immunity & Optimal Health - 60 Tablets, 15mg Zinc",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/RK19QjVHYxHCmxLk0jv6aRGvQQDtsjfR8UvTsJfB.jpg?v=1790550019",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "voonka",
        "zinc",
        "picolinate",
        "highly",
        "absorbable",
        "zinc",
        "supplement",
        "for",
        "enhanced",
        "immunity",
        "optimal",
        "health",
        "tablets",
        "15mg",
        "zinc",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 80,
        "transparency": 48,
        "sustainability": 33
      },
      "price": 24.62,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575877374149",
      "vsf_explanation": "Voonka's zinc picolinate tablet discloses a clear, safe 15 mg per-tablet dose in a bioavailable chelated form, backed by generic evidence for zinc's immune role. Manufacturing and transparency reflect Voonka's typical eczane/retail-channel Turkish-brand standard, with no third-party certification disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "metiofitina-15-vegan-tablets-boost-metabolism-energy-with-plant-based-nutritional-support-dietary-supplement",
      "title": "Metiofitina 15 Vegan Tablets: Boost Metabolism & Energy with Plant-Based Nutritional Support Dietary Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/x5ZdSTAPfEsgOw1STMeXhWLpu3e3u18g1yC2QeAj.jpg?v=1790550019",
      "score": 16,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "metiofitina",
        "vegan",
        "tablets",
        "boost",
        "metabolism",
        "energy",
        "with",
        "plant",
        "based",
        "nutritional",
        "support",
        "dietary",
        "supplement",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 12,
        "formulation": 5,
        "manufacturing": 25,
        "safety": 32,
        "transparency": 12,
        "sustainability": 15
      },
      "price": 46.01,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575877341381",
      "vsf_explanation": "Metiofitina markets a vegan tablet for metabolism and energy support, but no specific ingredient or nutrient is ever named in the listing. Without any disclosed formulation, the metabolism/energy claims cannot be substantiated.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "voop-vitamin-c-d3-zinc-supplement-boost-immune-support-with-orange-flavored-effervescent-vitamin-sachets-for-daily-wellness",
      "title": "Voop Vitamin C D3 Zinc Supplement: Boost Immune Support with Orange Flavored Effervescent Vitamin Sachets for Daily Wellness",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Oe8VPIeAJGyNZJqkVVIrJHkWTlITCxn17pVO7tK4.jpg?v=1790550020",
      "score": 30,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "voop",
        "vitamin",
        "zinc",
        "supplement",
        "boost",
        "immune",
        "support",
        "with",
        "orange",
        "flavored",
        "effervescent",
        "vitamin",
        "sachets",
        "for",
        "daily",
        "wellness",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 15,
        "manufacturing": 32,
        "safety": 55,
        "transparency": 25,
        "sustainability": 20
      },
      "price": 27.91,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575877439685",
      "vsf_explanation": "Voop combines Vitamin C, D3 and Zinc in an orange-flavored effervescent sachet, but the listing never discloses the actual amount of any of the three ingredients. This is a common, generally low-risk nutrient combination, but the missing doses prevent verification of an effective daily amount.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "prostavit-advanced-saw-palmetto-prostate-health-supplement-with-epimedium-ginseng-pumpkin-seed-zinc-support-urinary-function-male-vitality",
      "title": "Prostavit: Advanced Saw Palmetto Prostate Health Supplement with Epimedium, Ginseng, Pumpkin Seed & Zinc - Support Urinary Function & Male Vitality",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/pRiwFlpq1jFfuRQa65raGFhGanayKDsW7hfNhJiY.jpg?v=1790550019",
      "score": 46,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune",
        "energy",
        "mood",
        "hormone"
      ],
      "sex_relevance": "male",
      "life_stage": "general",
      "tokens": [
        "prostavit",
        "advanced",
        "saw",
        "palmetto",
        "prostate",
        "health",
        "supplement",
        "with",
        "epimedium",
        "ginseng",
        "pumpkin",
        "seed",
        "zinc",
        "support",
        "urinary",
        "function",
        "male",
        "vitality",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "mens_health"
      ],
      "vsf_dimensions": {
        "evidence": 52,
        "formulation": 55,
        "manufacturing": 38,
        "safety": 50,
        "transparency": 42,
        "sustainability": 22
      },
      "price": 85.5,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575877406917",
      "vsf_explanation": "Prostavit discloses saw palmetto, pumpkin seed, and pygeum africana at doses consistent with commonly studied amounts for prostate and urinary support, but Epimedium, Ginseng, and Zinc are named without any dose. The urinary-symptom marketing language sits close to a BPH-treatment claim without disclosing it as a structure/function claim only.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitaly-one-premium-type-1-collagen-omega-3-fish-oil-and-turmeric-supplement-for-joint-support-healthy-skin-anti-inflammatory-benefits-30-softgels",
      "title": "Vitaly One: Premium Type 1 Collagen, Omega 3 Fish Oil, and Turmeric Supplement for Joint Support, Healthy Skin & Anti-Inflammatory Benefits - 30 Softgels",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/88R3Le93rv8gQzWTr3NYdDJSEYNbKz0XWVo5F14n.jpg?v=1790550019",
      "score": 33,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive",
        "joint",
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitaly",
        "one",
        "premium",
        "type",
        "collagen",
        "omega",
        "fish",
        "oil",
        "and",
        "turmeric",
        "supplement",
        "for",
        "joint",
        "support",
        "healthy",
        "skin",
        "anti",
        "inflammatory",
        "benefits",
        "softgels",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 20,
        "manufacturing": 35,
        "safety": 55,
        "transparency": 45,
        "sustainability": 22
      },
      "price": 50.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575877472453",
      "vsf_explanation": "Vitaly One discloses its doses transparently, which is a strength, but that same transparency reveals its headline joint/skin ingredient - Type 1 Collagen - is present at only 40mg per serving, far below amounts used in collagen research. The omega-3 and bromelain doses are reasonable, but the core collagen claim is not supported by the disclosed amount.",
      "vsf_autofail_rule": "sub_therapeutic_dose"
    },
    {
      "handle": "infinity-pqr-33-dietary-supplement-convenient-nutritional-support-vitamin-capsules-for-overall-health",
      "title": "Infinity PQR 33 Dietary Supplement: Convenient Nutritional Support Vitamin Capsules for Overall Health",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/dw4ctBmEeP7bbyJkdPvFKdRGZNnWKzU6UCKhdelb.jpg?v=1790550019",
      "score": 16,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "infinity",
        "pqr",
        "dietary",
        "supplement",
        "convenient",
        "nutritional",
        "support",
        "vitamin",
        "capsules",
        "for",
        "overall",
        "health",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 10,
        "formulation": 5,
        "manufacturing": 25,
        "safety": 32,
        "transparency": 10,
        "sustainability": 15
      },
      "price": 125.03,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575877505221",
      "vsf_explanation": "Infinity PQR 33 is marketed for general nutritional support, but the listing never names a single vitamin, mineral, or active ingredient. Without any disclosed formulation, none of the product's health claims can be evaluated.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "life-in-collagen-copper-tablets-boost-skin-joint-health-daily-adult-supplement",
      "title": "Life In Collagen & Copper Tablets: Boost Skin & Joint Health | Daily Adult Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/rT6j6QhY6VELDVROUxof3aIUn9PIC5ru16FeVBDD_faaffd86-b997-4822-b26e-01b1c1e9a7bd.jpg?v=1790550021",
      "score": 44,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "life",
        "collagen",
        "copper",
        "tablets",
        "boost",
        "skin",
        "joint",
        "health",
        "daily",
        "adult",
        "supplement",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 22,
        "manufacturing": 62,
        "safety": 60,
        "transparency": 25,
        "sustainability": 35
      },
      "price": 26.27,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575877570757",
      "vsf_explanation": "Life In Collagen & Copper Tablets pair two ingredients with a legitimate physiological rationale, sold through the established Gratis retail chain, but the listing discloses no dose for either collagen or copper.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "venatura-zinc-copper-supplement-boost-immunity-balance-minerals-high-absorption-zinc-picolinate-copper-sulfate-60-capsules",
      "title": "VeNatura Zinc & Copper Supplement: Boost Immunity & Balance Minerals - High Absorption Zinc Picolinate & Copper Sulfate - 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/q7tGcd27G75eokooX75AIvzF3smnYtEgZlKVTTwD.jpg?v=1790550021",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "venatura",
        "zinc",
        "copper",
        "supplement",
        "boost",
        "immunity",
        "balance",
        "minerals",
        "high",
        "absorption",
        "zinc",
        "picolinate",
        "copper",
        "sulfate",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 78,
        "manufacturing": 40,
        "safety": 78,
        "transparency": 62,
        "sustainability": 25
      },
      "price": 17.57,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575877603525",
      "vsf_explanation": "VeNatura's Zinc & Copper supplement discloses specific, appropriately-balanced doses and forms of both minerals, reflecting sound formulation practice. It reaches Standard tier, limited by the brand's undisclosed manufacturing certification and sustainability practices.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "esomed-esopecia-dietary-supplement-for-hair-loss-growth-60-tablets-multivitamin-for-hair-health",
      "title": "Esomed Esopecia Dietary Supplement for Hair Loss & Growth - 60 Tablets, Multivitamin for Hair Health",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/aNVqzxV3EaypTBmCMEaw37apPe9sM42DIlVmfbCF.jpg?v=1790550020",
      "score": 26,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune",
        "skin"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "esomed",
        "esopecia",
        "dietary",
        "supplement",
        "for",
        "hair",
        "loss",
        "growth",
        "tablets",
        "multivitamin",
        "for",
        "hair",
        "health",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 24,
        "formulation": 14,
        "manufacturing": 33,
        "safety": 48,
        "transparency": 20,
        "sustainability": 12
      },
      "price": 39.42,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575877636293",
      "vsf_explanation": "Esomed Esopecia names seven active ingredients for hair loss and growth across a detailed benefits narrative but discloses a dose for none of them. This hidden-dose, multi-ingredient formulation triggers an autofail and Rejected tier.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "nutraxin-iron-max-high-potency-iron-supplement-for-deficiency-anemia-boost-energy-red-blood-cell-production-30-tablets",
      "title": "Nutraxin Iron Max: High Potency Iron Supplement for Deficiency & Anemia - Boost Energy & Red Blood Cell Production (30 Tablets)",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/t36FA8wiJAtJ0ADfRZD7lXfXOGfMBVjkJdrO0j6Q_27f04f14-61f4-4d8f-86f9-f50dd1789866.jpg?v=1790550021",
      "score": 33,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutraxin",
        "iron",
        "max",
        "high",
        "potency",
        "iron",
        "supplement",
        "for",
        "deficiency",
        "anemia",
        "boost",
        "energy",
        "red",
        "blood",
        "cell",
        "production",
        "tablets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 25,
        "formulation": 30,
        "manufacturing": 45,
        "safety": 40,
        "transparency": 35,
        "sustainability": 20
      },
      "price": 22.63,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575877734597",
      "vsf_explanation": "Nutraxin Iron Max markets itself as a treatment for the diagnosed medical condition anemia, a claim a dietary supplement is not permitted to make, and its product page discloses no actual iron dose to substantiate the 'high potency' and 'max strength' claims. This combination of an unverified disease claim and undisclosed dosing results in an autofail.",
      "vsf_autofail_rule": "unverified_disease_claim"
    },
    {
      "handle": "osende-zinc-copper-supplement-enhanced-absorption-zinc-picolinate-for-immune-support-mineral-balance-60-capsules",
      "title": "Osende Zinc Copper Supplement - Enhanced Absorption Zinc Picolinate for Immune Support & Mineral Balance - 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ECrsQjfsIJZAf6gd8iMvs9Qmy2z9yMEgpzPIoqCg_77a6464a-b874-4d57-9185-df80ddaccc40.jpg?v=1790550022",
      "score": 54,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "osende",
        "zinc",
        "copper",
        "supplement",
        "enhanced",
        "absorption",
        "zinc",
        "picolinate",
        "for",
        "immune",
        "support",
        "mineral",
        "balance",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 40,
        "manufacturing": 74,
        "safety": 65,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 23.21,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575877767365",
      "vsf_explanation": "Osende Zinc Copper pairs zinc picolinate with copper for mineral balance, a reasonable formulation concept from an established Turkish pharmaceutical manufacturer, but the listing does not disclose the actual milligram amount of either mineral.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-st-johns-wort-300mg-capsules-100-count-dietary-supplement-for-mood-support",
      "title": "Nature's Bounty St. John's Wort 300mg Capsules - 100 Count Dietary Supplement for Mood Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6l6XxOfwsZVORYcsA37ddUvAaOTtdvri3mAedRx7.jpg?v=1790550023",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "john",
        "wort",
        "300mg",
        "capsules",
        "100",
        "count",
        "dietary",
        "supplement",
        "for",
        "mood",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "stress_mood_mental"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 55,
        "manufacturing": 85,
        "safety": 55,
        "transparency": 55,
        "sustainability": 45
      },
      "price": 26.11,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575877800133",
      "vsf_explanation": "Nature's Bounty's St. John's Wort capsule is backed by a genuine moderate-quality evidence base for mood support, manufactured under the brand's established cGMP-certified US facility standards. However, the listing omits St. John's Wort's well-documented interactions with antidepressants, hormonal contraceptives, and blood thinners, which caps this product below Verified tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ocean-gummies-vitamin-d3-1000-iu-delicious-orange-flavored-chewable-gummies-for-adults-kids-natural-supplement-for-vitamin-d-deficiency",
      "title": "Ocean Gummies: Vitamin D3 1000 IU - Delicious Orange Flavored Chewable Gummies for Adults & Kids - Natural Supplement for Vitamin D Deficiency",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/t0lKoQiYbR8J5TLRLl3XHf54luYjeTeKSIppQNnU.jpg?v=1790550023",
      "score": 57,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "youth_under_18",
      "tokens": [
        "ocean",
        "gummies",
        "vitamin",
        "1000",
        "delicious",
        "orange",
        "flavored",
        "chewable",
        "gummies",
        "for",
        "adults",
        "kids",
        "natural",
        "supplement",
        "for",
        "vitamin",
        "deficiency",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 55,
        "manufacturing": 58,
        "safety": 65,
        "transparency": 48,
        "sustainability": 35
      },
      "price": 24.62,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575877832901",
      "vsf_explanation": "Ocean's Vitamin D3 gummy delivers a standard, evidence-supported 1000 IU dose in a palatable chewable format, but marketing the same adult-strength gummy for both adults and children without age-tiered dosing guidance is a real gap. Manufacturing and transparency reflect Ocean's typical eczane-channel disclosure level, with no third-party testing shown.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "orzax-ocean-d3-k2-vitamin-drops-superior-liquid-d3k2-supplement-for-bone-immune-support-gluten-free-sugar-free-lactose-free",
      "title": "Orzax Ocean D3 K2 Vitamin Drops: Superior Liquid D3K2 Supplement for Bone & Immune Support - Gluten-Free, Sugar-Free, Lactose-Free",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/U86KvxuhUrFFpPBKjv8v2Ec5QJaMg72guIQ6A6bV.jpg?v=1790550023",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "orzax",
        "ocean",
        "vitamin",
        "drops",
        "superior",
        "liquid",
        "d3k2",
        "supplement",
        "for",
        "bone",
        "immune",
        "support",
        "gluten",
        "free",
        "sugar",
        "free",
        "lactose",
        "free",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 58,
        "safety": 55,
        "transparency": 40,
        "sustainability": 38
      },
      "price": 24.08,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575877865669",
      "vsf_explanation": "Orzax Ocean D3 K2 Drops pairs two well-evidenced vitamins in a liquid format, but the listing discloses no IU or mcg dose for either D3 or K2. Because dosing for a fat-soluble vitamin like D3 is safety-relevant information, the product is scored Rejected under a zero-assumption standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "debloat-anti-bloat-supplement-fast-bloating-gas-relief-with-digestive-enzymes-turmeric-licorice-root-for-improved-gut-health",
      "title": "Debloat+ Anti-Bloat Supplement: Fast Bloating & Gas Relief with Digestive Enzymes, Turmeric & Licorice Root for Improved Gut Health",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/byHrNUC2LcyUJ3v1ZLyYEP70oVJiOjfhRUNDQFqV.jpg?v=1790550024",
      "score": 21,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "inflammation",
        "joint",
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "debloat",
        "anti",
        "bloat",
        "supplement",
        "fast",
        "bloating",
        "gas",
        "relief",
        "with",
        "digestive",
        "enzymes",
        "turmeric",
        "licorice",
        "root",
        "for",
        "improved",
        "gut",
        "health",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 10,
        "manufacturing": 28,
        "safety": 38,
        "transparency": 15,
        "sustainability": 10
      },
      "price": 82.14,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575877898437",
      "vsf_explanation": "Debloat+ claims relief in 30 minutes from a blend of 17 unnamed digestive enzymes plus turmeric and licorice root, none of which are dosed anywhere on the listing. Licorice root's known blood-pressure risk at high or prolonged doses makes the total lack of dosing especially concerning; this hidden-dose formulation triggers an autofail and Rejected tier.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "venatura-fosfotidilserin-omega-3-supplement-boost-brain-health-memory-support-heart-health-30-soft-capsules",
      "title": "VeNatura Fosfotidilserin Omega 3 Supplement: Boost Brain Health, Memory & Support Heart Health - 30 Soft Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/venatura-fosfotidilserin-ve-omega-3-takviye-edici-gida-30-yumusak-kapsul-venatura-192138-61-B.jpg?v=1790550024",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "venatura",
        "fosfotidilserin",
        "omega",
        "supplement",
        "boost",
        "brain",
        "health",
        "memory",
        "support",
        "heart",
        "health",
        "soft",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cognitive_nootropics"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 32,
        "manufacturing": 40,
        "safety": 65,
        "transparency": 28,
        "sustainability": 25
      },
      "price": 41.07,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575877931205",
      "vsf_explanation": "VeNatura combines phosphatidylserine and omega-3 fatty acids, both real generic evidence classes for cognitive and heart health, but discloses no dose for either ingredient in this two-active blend. Because buyers cannot verify how much of either active they are getting, this product is rejected.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "magnimore-sm-magnesium-citrate-malate-supplement-energy-muscle-support-and-deficiency-relief-in-convenient-sachets",
      "title": "Magnimore SM: Magnesium Citrate Malate Supplement - Energy, Muscle Support, and Deficiency Relief in Convenient Sachets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Se4QoXds5ZExXrh2Ya3D9EReZOogdL5BHNklib6P.jpg?v=1790550025",
      "score": 51,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "magnimore",
        "magnesium",
        "citrate",
        "malate",
        "supplement",
        "energy",
        "muscle",
        "support",
        "and",
        "deficiency",
        "relief",
        "convenient",
        "sachets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 45,
        "manufacturing": 60,
        "safety": 55,
        "transparency": 40,
        "sustainability": 40
      },
      "price": 29.56,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575877963973",
      "vsf_explanation": "Magnimore SM names two well-regarded magnesium forms (citrate and malate) but discloses no actual per-sachet dose anywhere in the listing. Without a quantified amount to evaluate, the product is scored Rejected under a zero-assumption standard.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitendo-combo-90-tablet-joint-health-supplement-with-glucosamine-chondroitin-and-collagen",
      "title": "Vitendo Combo 90 Tablet - Joint Health Supplement with Glucosamine, Chondroitin, and Collagen",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/DNGaOMD76mWaz8scHdvDeikcj7BJKumZrBge5SYs_0f8ed5a5-f3b8-4591-8f74-7f3aec279bad.jpg?v=1790550025",
      "score": 26,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitendo",
        "combo",
        "tablet",
        "joint",
        "health",
        "supplement",
        "with",
        "glucosamine",
        "chondroitin",
        "and",
        "collagen",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 24,
        "formulation": 13,
        "manufacturing": 33,
        "safety": 50,
        "transparency": 20,
        "sustainability": 12
      },
      "price": 50.68,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575877996741",
      "vsf_explanation": "Vitendo Combo names nine active ingredients for joint health across a detailed benefits narrative but discloses a dose for none of them. This hidden-dose, kitchen-sink formulation triggers an autofail and Rejected tier.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "kiperin-postbiyotik-supplement-21-capsules-for-gut-health-support-with-lactobacillus-rhamnosus-plantarum",
      "title": "Kiperin Postbiyotik Supplement - 21 Capsules for Gut Health Support with Lactobacillus Rhamnosus & Plantarum",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/KYlCjT04SmNmun6HfSDvmlZwJsLK4yMR1fYNjK0r.jpg?v=1790550026",
      "score": 27,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "gut",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "kiperin",
        "postbiyotik",
        "supplement",
        "capsules",
        "for",
        "gut",
        "health",
        "support",
        "with",
        "lactobacillus",
        "rhamnosus",
        "plantarum",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 24,
        "formulation": 14,
        "manufacturing": 33,
        "safety": 52,
        "transparency": 22,
        "sustainability": 12
      },
      "price": 46.01,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575878029509",
      "vsf_explanation": "Kiperin Postbiyotik names two probiotic strains for gut health but discloses no CFU or potency measure for either, even in its complete technical specifications section. This hidden-dose formulation triggers an autofail and Rejected tier.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "nutraxin-my-vision-eye-health-supplement-vitamins-minerals-for-vision-support-60-capsules",
      "title": "Nutraxin My Vision: Eye Health Supplement - Vitamins & Minerals for Vision Support - 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/0XCC6mIAQhr9SvboKoAOZoHQvjQN4gtWCqJ9fFO7.jpg?v=1790550026",
      "score": 47,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutraxin",
        "vision",
        "eye",
        "health",
        "supplement",
        "vitamins",
        "minerals",
        "for",
        "vision",
        "support",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 45,
        "manufacturing": 45,
        "safety": 65,
        "transparency": 50,
        "sustainability": 20
      },
      "price": 37.77,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575878062277",
      "vsf_explanation": "Nutraxin My Vision markets itself as a research-backed eye-health formula, but its product page names no specific vitamins, minerals, or doses, so the claim can't be verified against the actual formula. That gap, plus the brand's undisclosed manufacturing and sustainability practices, results in a Rejected-tier score.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "intramax-hydrolyzed-collagen-supplement-boost-joint-health-skin-elasticity-with-easy-to-absorb-liquid-vials-30-flakon",
      "title": "Intramax: Hydrolyzed Collagen Supplement - Boost Joint Health & Skin Elasticity with Easy-to-Absorb Liquid Vials, 30 Flakon",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ryvT5q3wBZDsAfsj3IaCFMfltAzRIc96Q5wLgOGN.jpg?v=1790550029",
      "score": 27,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "intramax",
        "hydrolyzed",
        "collagen",
        "supplement",
        "boost",
        "joint",
        "health",
        "skin",
        "elasticity",
        "with",
        "easy",
        "absorb",
        "liquid",
        "vials",
        "flakon",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "skin_hair_beauty"
      ],
      "vsf_dimensions": {
        "evidence": 26,
        "formulation": 14,
        "manufacturing": 32,
        "safety": 55,
        "transparency": 18,
        "sustainability": 12
      },
      "price": 118.43,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575879471301",
      "vsf_explanation": "Intramax Hydrolyzed Collagen makes joint and skin-elasticity claims across detailed marketing copy but never states an actual collagen dose per vial, using vague phrasing like 'concentrated dose' instead of a number. This hidden-dose formulation triggers an autofail and Rejected tier.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "new-life-4-hepa-liver-support-supplement-silibin-phospholipid-complex-choline-artichoke-dandelion-for-liver-health-detox",
      "title": "New Life 4 Hepa: Liver Support Supplement - Silibin Phospholipid Complex, Choline, Artichoke & Dandelion for Liver Health & Detox",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/V3fTbhHy9fGeNyPEa2vK2PTEabSgVDwpWEilpdQL_6fea6352-b484-4aa3-ad06-035362e9db24.jpg?v=1790550031",
      "score": 45,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "new",
        "life",
        "hepa",
        "liver",
        "support",
        "supplement",
        "silibin",
        "phospholipid",
        "complex",
        "choline",
        "artichoke",
        "dandelion",
        "for",
        "liver",
        "health",
        "detox",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 35,
        "formulation": 25,
        "manufacturing": 76,
        "safety": 55,
        "transparency": 35,
        "sustainability": 42
      },
      "price": 36.14,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575879504069",
      "vsf_explanation": "New Life 4 Hepa combines milk thistle, choline, artichoke, and dandelion for liver support, but the listing never discloses how much of any ingredient is actually in each softgel, so the formulation cannot be verified against the research behind these ingredients.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "venatura-silymarin-milk-thistle-extract-60-capsules-for-liver-support-natural-herbal-supplement-detox",
      "title": "Venatura Silymarin Milk Thistle Extract - 60 Capsules for Liver Support, Natural Herbal Supplement & Detox",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/xHfCFLZEJa1Dk71pj7yX6z9o6kToG2tn1HPgDMjM_9691d122-9bc6-4fb3-909b-b3daf5cae90b.jpg?v=1790550031",
      "score": 43,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "venatura",
        "silymarin",
        "milk",
        "thistle",
        "extract",
        "capsules",
        "for",
        "liver",
        "support",
        "natural",
        "herbal",
        "supplement",
        "detox",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 35,
        "manufacturing": 40,
        "safety": 65,
        "transparency": 30,
        "sustainability": 25
      },
      "price": 31.2,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575879536837",
      "vsf_explanation": "VeNatura's Silymarin product draws on a legitimate generic evidence base for milk thistle liver support, but the available listing never discloses an actual per-capsule dose or standardization level, making it impossible to verify what buyers receive. That disclosure gap is the primary reason for the Rejected tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "actibiyol-l-arginine-coq10-ginseng-supplement-tablets-boost-energy-support-immunity-heart-health-90-tablets",
      "title": "Actibiyol L-Arginine, CoQ10 & Ginseng Supplement Tablets: Boost Energy, Support Immunity & Heart Health - 90 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/dmJLH4nn6uBtAT5nxMxFYLz74Mh97edWnhbLXTZF.jpg?v=1790550031",
      "score": 26,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy",
        "mood",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "actibiyol",
        "arginine",
        "coq10",
        "ginseng",
        "supplement",
        "tablets",
        "boost",
        "energy",
        "support",
        "immunity",
        "heart",
        "health",
        "tablets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 24,
        "formulation": 14,
        "manufacturing": 32,
        "safety": 48,
        "transparency": 18,
        "sustainability": 12
      },
      "price": 110.2,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575879569605",
      "vsf_explanation": "Actibiyol names five active ingredients across extensive marketing copy covering energy, immunity, and heart health, but discloses a dose for none of them. This hidden-dose, multi-ingredient formulation triggers an autofail and Rejected tier.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "venatura-klorella-chlorella-supplement-natural-algae-detox-dietary-support-60-capsules",
      "title": "Venatura Klorella Chlorella Supplement - Natural Algae Detox & Dietary Support, 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/bTIZI5mykuMAFo7zd9xTmdf1CNCapWZMhE4nhoxY.jpg?v=1790550036",
      "score": 34,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "venatura",
        "klorella",
        "chlorella",
        "supplement",
        "natural",
        "algae",
        "detox",
        "dietary",
        "support",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 35,
        "manufacturing": 40,
        "safety": 55,
        "transparency": 30,
        "sustainability": 25
      },
      "price": 41.07,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575879635141",
      "vsf_explanation": "VeNatura markets this chlorella product with a specific heavy-metal-binding detoxification claim that is not well supported by human clinical evidence, combined with no disclosed per-capsule dose. The unverified mechanism claim is the primary reason this product is rejected.",
      "vsf_autofail_rule": "unverified_medical_claim"
    },
    {
      "handle": "suda-vitamin-c-1000mg-60-capsules-for-powerful-immune-support-high-potency-ascorbic-acid-supplement",
      "title": "Suda Vitamin C 1000mg - 60 Capsules for Powerful Immune Support | High Potency Ascorbic Acid Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/WyeAIAIaZcxMODxke9BocRwFopmicUrkupqlc4RU_5ecfc778-982c-434c-8e44-70fcf16bd974.jpg?v=1790550038",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "suda",
        "vitamin",
        "1000mg",
        "capsules",
        "for",
        "powerful",
        "immune",
        "support",
        "high",
        "potency",
        "ascorbic",
        "acid",
        "supplement",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 70,
        "formulation": 72,
        "manufacturing": 50,
        "safety": 62,
        "transparency": 60,
        "sustainability": 27
      },
      "price": 14.74,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575879733445",
      "vsf_explanation": "Suda's Vitamin C product uses a well-established nutrient claim and clearly discloses its single-ingredient 1000mg dose, earning a solid Standard-tier score. Missing manufacturing facility and sustainability disclosure keep it below Verified tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ntramag-day-night-24-7-magnesium-supplement-b6",
      "title": "ntramag Day&Night: 24/7 Magnesium Supplement, B6",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/lQxo1QxKKO7QAW2X4fSVMNdHs773WrCYC4sh78MQ.jpg?v=1790550041",
      "score": 21,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ntramag",
        "day",
        "night",
        "magnesium",
        "supplement",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 20,
        "formulation": 10,
        "manufacturing": 30,
        "safety": 38,
        "transparency": 12,
        "sustainability": 10
      },
      "price": 50.95,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575879766213",
      "vsf_explanation": "Intramag Day&Night claims a differentiated 24/7 magnesium formula but discloses no magnesium dose, form, or the actual composition difference between its 'day' and 'night' blends anywhere on the listing. This total absence of dosing information triggers an autofail and Rejected tier.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "ntrago-egg-shell-supplement-advanced-30-tablets",
      "title": "ntrago Egg Shell Supplement: Advanced - 30 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/loLOsfMmit6HFQ2oj2dPpjOfFlMvxrrvo0ACDzPA.jpg?v=1790550047",
      "score": 23,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ntrago",
        "egg",
        "shell",
        "supplement",
        "advanced",
        "tablets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 22,
        "formulation": 12,
        "manufacturing": 30,
        "safety": 42,
        "transparency": 15,
        "sustainability": 10
      },
      "price": 64.11,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575882027205",
      "vsf_explanation": "Intrago Egg Shell Supplement names five ingredient categories for joint comfort but discloses zero dose amounts for any of them in its complete product description. This hidden-dose formulation triggers an autofail and Rejected tier.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "omepa-q10-ultra-absorbable-omega-3-ubiquinol-supplement-600mg-omega-3-100mg-kaneka-ubiquinol-30-softgels",
      "title": "Omepa-Q10: Ultra-Absorbable Omega-3 Ubiquinol Supplement - 600mg Omega-3, 100mg Kaneka Ubiquinol, 30 Softgels",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/gStAhbCO0D6vS1O0EbfohanxlSFbcthdJWAUCyrT_2dc2c3cc-0c38-4e69-bd0d-67b62360d777.jpg?v=1790550049",
      "score": 47,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "omepa",
        "q10",
        "ultra",
        "absorbable",
        "omega",
        "ubiquinol",
        "supplement",
        "600mg",
        "omega",
        "100mg",
        "kaneka",
        "ubiquinol",
        "softgels",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 58,
        "manufacturing": 40,
        "safety": 75,
        "transparency": 22,
        "sustainability": 13
      },
      "price": 32.85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575882092741",
      "vsf_explanation": "Omepa-Q10 names two well-evidenced, precisely dosed cardiovascular ingredients (Omega-3 and Kaneka Ubiquinol) in its title, but the listing has no product description at all, leaving no brand provenance, manufacturer, or supporting context to evaluate. The near-total absence of any page content beyond the title triggers an autofail on brand provenance.",
      "vsf_autofail_rule": "no_brand_provenance"
    },
    {
      "handle": "godday-betain-hcl-supplement-digestive-health-support-with-pepsin-gentiana-lutea-root-extract-60-capsules",
      "title": "Godday Betain HCL Supplement - Digestive Health Support with Pepsin & Gentiana Lutea Root Extract, 60 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/NFeHjae1vUZRtPOs6w1vMp5Zc22Kq56aGij7h91P.jpg?v=1790550072",
      "score": 59,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "gut"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "godday",
        "betain",
        "hcl",
        "supplement",
        "digestive",
        "health",
        "support",
        "with",
        "pepsin",
        "gentiana",
        "lutea",
        "root",
        "extract",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "gut_digestive"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 64,
        "manufacturing": 56,
        "safety": 62,
        "transparency": 64,
        "sustainability": 38
      },
      "price": 32.85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575882322117",
      "vsf_explanation": "Godday Betain HCL discloses clear per-serving doses for its three digestive-support ingredients (betaine HCL, pepsin, gentian root). It scores Standard tier, with a safety note that no warning about betaine HCL's interaction with acid-reducing medications is disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ocean-zinc-supplement-boosts-immune-system-with-zinc-picolinate-30-15-tablets",
      "title": "Ocean Zinc Supplement - Boosts Immune System with Zinc Picolinate - 30+15 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/6XkMtxyzPYwQKJ7pBb21ZX2MyAIpwdbk6rZdmB4W.jpg?v=1790550072",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ocean",
        "zinc",
        "supplement",
        "boosts",
        "immune",
        "system",
        "with",
        "zinc",
        "picolinate",
        "tablets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 65,
        "manufacturing": 58,
        "safety": 80,
        "transparency": 50,
        "sustainability": 35
      },
      "price": 22.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575882354885",
      "vsf_explanation": "Ocean's zinc picolinate tablet discloses a clear, safe 15 mg per-tablet dose in a bioavailable chelated form, backed by generic (not product-specific) evidence for zinc's immune role. Manufacturing and transparency are typical of an eczane-channel Turkish brand, with no third-party certification or lab testing disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "venatura-iron-supplement-with-vitamin-c-dietary-supplement-for-immune-system-support-90-capsules",
      "title": "Venatura Iron Supplement with Vitamin C - Dietary Supplement for Immune System Support, 90 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/FjSLjez2qehdzT4vLv0vr4rTcEANl11PU8SXTV1q.jpg?v=1790550072",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "venatura",
        "iron",
        "supplement",
        "with",
        "vitamin",
        "dietary",
        "supplement",
        "for",
        "immune",
        "system",
        "support",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 60,
        "formulation": 75,
        "manufacturing": 40,
        "safety": 78,
        "transparency": 55,
        "sustainability": 25
      },
      "price": 21.75,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575882289349",
      "vsf_explanation": "VeNatura pairs iron with vitamin C in doses that reflect real, well-documented absorption synergy, using compliant non-disease-claim language. It reaches Standard tier, limited by the brand's undisclosed manufacturing certification and sustainability practices.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "vitabiotics-osteocare-dietary-supplement-for-bone-health-270-tablets",
      "title": "Vitabiotics Osteocare Dietary Supplement for Bone Health - 270 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/Gwag2rsq32VbZc2nJzKdFuW65v2iletLsDc1sda9.jpg?v=1790550082",
      "score": 69,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "vitabiotics",
        "osteocare",
        "dietary",
        "supplement",
        "for",
        "bone",
        "health",
        "270",
        "tablets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 66,
        "formulation": 60,
        "manufacturing": 88,
        "safety": 72,
        "transparency": 60,
        "sustainability": 55
      },
      "price": 73.99,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575884746949",
      "vsf_explanation": "Vitabiotics Osteocare is a long-established bone-health formula from a major, internationally distributed UK brand, combining seven well-evidenced minerals and vitamins. It scores Standard tier because this specific listing does not include per-tablet mg amounts, despite the brand's strong manufacturing and market track record.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "venatura-vitamin-b-complex-supplement-30-capsules",
      "title": "VeNatura Vitamin B Complex Supplement - 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/vpmVXyqzeJQ2yWKPZMPtKBrjOLVBzrywHlrAV1k7.jpg?v=1790550083",
      "score": 26,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "cognitive",
        "mood"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "venatura",
        "vitamin",
        "complex",
        "supplement",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 15,
        "formulation": 15,
        "manufacturing": 40,
        "safety": 45,
        "transparency": 18,
        "sustainability": 25
      },
      "price": 24.62,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575884779717",
      "vsf_explanation": "VeNatura markets this as a general B-vitamin blend, but the listing discloses no individual vitamins or doses, making it impossible to verify what a buyer is actually taking. Combined with no disclosed manufacturing facility or certification, this product does not meet Vyvata's bar for a verifiable supplement.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "goodday-magnesium-bisglycinate-supplement-30-tablets-supports-muscle-function-overall-wellness",
      "title": "Goodday Magnesium Bisglycinate Supplement 30 Tablets - Supports Muscle Function & Overall Wellness",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/JkQCGBePnL26OnG1nC7gvgtY5GBLF7CXGPI42P4O.jpg?v=1790550082",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "goodday",
        "magnesium",
        "bisglycinate",
        "supplement",
        "tablets",
        "supports",
        "muscle",
        "function",
        "overall",
        "wellness",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 66,
        "manufacturing": 56,
        "safety": 70,
        "transparency": 64,
        "sustainability": 38
      },
      "price": 22.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575884878021",
      "vsf_explanation": "Goodday Magnesium Bisglycinate discloses clear per-serving doses (250mg magnesium, 10mg active-form B6) using well-regarded, bioavailable ingredient forms. It scores Standard tier, limited by the absence of disclosed manufacturing certification.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nbtlife-na-r-alfa-lipoik-asit-200-mg-high-bioavailability-alpha-lipoic-acid-supplement-for-antioxidant-support-30-capsules",
      "title": "NBTLife Na-R Alfa Lipoik Asit 200 mg - High Bioavailability Alpha Lipoic Acid Supplement for Antioxidant Support - 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/VEo0fxYhuUl3n133hWaiGE1BLnYAhvlEvuiY84qU.jpg?v=1790550082",
      "score": 61,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nbtlife",
        "alfa",
        "lipoik",
        "asit",
        "200",
        "high",
        "bioavailability",
        "alpha",
        "lipoic",
        "acid",
        "supplement",
        "for",
        "antioxidant",
        "support",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 75,
        "manufacturing": 52,
        "safety": 60,
        "transparency": 62,
        "sustainability": 27
      },
      "price": 41.07,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575884910789",
      "vsf_explanation": "NBTLife's Na-R ALA product discloses a clear, commonly used 200 mg dose and a legitimate stabilized-form rationale, earning Standard tier. An unsupported bioavailability comparison claim and missing manufacturing/interaction disclosures keep it below Verified tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "pure-iron-c-dietary-supplement-iron-and-vitamin-c-capsules-for-healthy-red-blood-cell-production-and-immune-system-support",
      "title": "Pure Iron-C Dietary Supplement - Iron and Vitamin C Capsules for Healthy Red Blood Cell Production and Immune System Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/uSUGoFRYZg2SnZzpPERMaPW6nvo4z2tymR2tbhVX.jpg?v=1790550082",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "pure",
        "iron",
        "dietary",
        "supplement",
        "iron",
        "and",
        "vitamin",
        "capsules",
        "for",
        "healthy",
        "red",
        "blood",
        "cell",
        "production",
        "and",
        "immune",
        "system",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 64,
        "manufacturing": 46,
        "safety": 72,
        "transparency": 52,
        "sustainability": 13
      },
      "price": 31.2,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575884943557",
      "vsf_explanation": "Pure Iron-C clearly discloses both of its active ingredient doses (15mg iron, 175mg Vitamin C) in a well-evidenced absorption-enhancing combination. Standard tier reflects clean, verifiable dosing offset by an unverifiable manufacturer and no pediatric-safety caution.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "newvit-iron-supplement-drops-natural-demir-damla-for-iron-deficiency-anemia-relief-1-69-fl-oz",
      "title": "Newvit Iron Supplement Drops - Natural Demir Damla for Iron Deficiency & Anemia Relief, 1.69 fl oz",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/MrOJDyIpKRz82SYtE5FXKE015cRWnpAUYFkqE971.jpg?v=1790550082",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "newvit",
        "iron",
        "supplement",
        "drops",
        "natural",
        "demir",
        "damla",
        "for",
        "iron",
        "deficiency",
        "anemia",
        "relief",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 56,
        "formulation": 66,
        "manufacturing": 48,
        "safety": 70,
        "transparency": 54,
        "sustainability": 16
      },
      "price": 21.32,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575884845253",
      "vsf_explanation": "Newvit Demir Damla discloses a clear 17mg iron sulfate dose per 10 drops in a paraben/BHA/BHT-free formulation. Standard tier reflects good dose transparency offset by the lack of pediatric dosing guidance despite marketing toward children.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutraxin-multivitamin-mineral-energy-supplement-60-tablets-boost-energy-overall-health",
      "title": "Nutraxin Multivitamin Mineral Energy Supplement - 60 Tablets - Boost Energy & Overall Health",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/3yg8gihjHmholg3W0mUUq4309OLcpHkecwXEy1Ni.jpg?v=1790550082",
      "score": 50,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutraxin",
        "multivitamin",
        "mineral",
        "energy",
        "supplement",
        "tablets",
        "boost",
        "energy",
        "overall",
        "health",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 50,
        "formulation": 52,
        "manufacturing": 45,
        "safety": 68,
        "transparency": 50,
        "sustainability": 20
      },
      "price": 24.52,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575884812485",
      "vsf_explanation": "Nutraxin Multivitamin Mineral Energy combines a broad vitamin/mineral base with common energy-support botanicals, but the product page discloses no individual ingredient doses, making it impossible to verify strength against studied ranges. Nutraxin is a genuine, pharmacy-channel Turkish brand, but no facility, certification, or sustainability disclosures were found for this line.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutraxin-vitamin-d3k2-supplement-spray-1000-iu-vitamin-d3-25-mcg-vitamin-k2-per-spray-allergen-free-bone-health-support-30ml",
      "title": "Nutraxin Vitamin D3K2 Supplement Spray - 1000 IU Vitamin D3 & 25 mcg Vitamin K2 per Spray, Allergen-Free, Bone Health Support, 30ml",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/eGNdPvTt6nS3bs0ls1agbbdUCwDAaYXuWemXMA5K.jpg?v=1790550082",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "cardiovascular"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutraxin",
        "vitamin",
        "d3k2",
        "supplement",
        "spray",
        "1000",
        "vitamin",
        "mcg",
        "vitamin",
        "per",
        "spray",
        "allergen",
        "free",
        "bone",
        "health",
        "support",
        "30ml",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 68,
        "formulation": 70,
        "manufacturing": 45,
        "safety": 75,
        "transparency": 60,
        "sustainability": 20
      },
      "price": 18.84,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575884976325",
      "vsf_explanation": "Nutraxin's D3K2 spray discloses clear, appropriately dosed amounts of both active ingredients backed by solid generic evidence for bone and calcium-regulation support. It lands in Standard tier because the brand has no disclosed manufacturing certification or sustainability information, and the K2 form isn't specified.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "voonka-coq10-200mg-dietary-supplement-for-heart-health-energy-support-32-soft-capsules",
      "title": "Voonka CoQ10 200mg Dietary Supplement for Heart Health & Energy Support - 32 Soft Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/SBFgmV2YAfCErygkCq4KBM2SO28JdIjWLdiWSa5H.jpg?v=1790550082",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "voonka",
        "coq10",
        "200mg",
        "dietary",
        "supplement",
        "for",
        "heart",
        "health",
        "energy",
        "support",
        "soft",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 65,
        "manufacturing": 55,
        "safety": 80,
        "transparency": 55,
        "sustainability": 33
      },
      "price": 27.91,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575885009093",
      "vsf_explanation": "Voonka's CoQ10 capsule discloses a clear 200 mg CoQ10 plus 12 mg Vitamin E dose, supported by a moderate generic evidence base for cellular energy and cardiovascular support. Manufacturing and sustainability reflect Voonka's typical eczane/retail-channel Turkish-brand standard, with no third-party certification disclosed.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "duosvit-multivitamin-supplement-with-omega-3-fatty-acids-30-capsules-for-overall-health-and-wellness",
      "title": "Duosvit Multivitamin Supplement with Omega-3 Fatty Acids - 30 Capsules for Overall Health and Wellness",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/TCIzKGGALnq6qOKlakateSX8lk7QGNaIojqKHvQX.jpg?v=1790550082",
      "score": 29,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive",
        "energy",
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "duosvit",
        "multivitamin",
        "supplement",
        "with",
        "omega",
        "fatty",
        "acids",
        "capsules",
        "for",
        "overall",
        "health",
        "and",
        "wellness",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 28,
        "formulation": 16,
        "manufacturing": 42,
        "safety": 45,
        "transparency": 24,
        "sustainability": 14
      },
      "price": 32.85,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575885074629",
      "vsf_explanation": "Duosvit Multivitamin names a broad list of vitamins, minerals, and omega-3 fatty acids but discloses no dose for any of them, making its heart, brain, and immune claims unverifiable. This hidden-dose formulation triggers an autofail and Rejected tier.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "_mubest-immune-support-syrup-boosts-immunity-with-black-elder-extract-beta-glucan-vitamin-c-zinc-150ml-dietary-supplement",
      "title": "_mubest Immune Support Syrup - Boosts Immunity with Black Elder Extract, Beta Glucan, Vitamin C & Zinc - 150ml Dietary Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/9Rv7hu6y5j4noLHxmjbnSF8xQae5LRZpH03vFh64.jpg?v=1790550083",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "_mubest",
        "immune",
        "support",
        "syrup",
        "boosts",
        "immunity",
        "with",
        "black",
        "elder",
        "extract",
        "beta",
        "glucan",
        "vitamin",
        "zinc",
        "150ml",
        "dietary",
        "supplement",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 56,
        "formulation": 70,
        "manufacturing": 46,
        "safety": 74,
        "transparency": 56,
        "sustainability": 16
      },
      "price": 19.68,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575885107397",
      "vsf_explanation": "Imubest Immune Support Syrup fully quantifies all four of its active ingredients (elderberry extract, beta-glucan, Vitamin C, zinc) per serving, a genuinely transparent formulation with reasonable ingredient-level evidence. Standard tier reflects this clean disclosure offset by no manufacturing certification and no sugar-content or pediatric dosing information.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "dynavit-selenium-100-mcg-dietary-supplement-tablets-for-antioxidant-support-90-count",
      "title": "Dynavit Selenium 100 mcg Dietary Supplement Tablets for Antioxidant Support - 90 Count",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/JBlJEMoXixtXXxc7wtG9FsuCNxWkaiaG0hgAlibU.jpg?v=1790550082",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "dynavit",
        "selenium",
        "100",
        "mcg",
        "dietary",
        "supplement",
        "tablets",
        "for",
        "antioxidant",
        "support",
        "count",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "immune_antioxidants"
      ],
      "vsf_dimensions": {
        "evidence": 62,
        "formulation": 72,
        "manufacturing": 82,
        "safety": 80,
        "transparency": 70,
        "sustainability": 48
      },
      "price": 22.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575885140165",
      "vsf_explanation": "Dynavit Selenium delivers a clearly disclosed, well-evidenced 100mcg dose for antioxidant and immune support, backed by the manufacturing credibility of the Eczacıbaşı pharmaceutical group.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ch-alpha-plus-collagen-supplement-with-rosehip-extract-vitamin-c-30-sachets-for-skin-joint-health",
      "title": "CH Alpha PLUS Collagen Supplement with Rosehip Extract & Vitamin C - 30 Sachets for Skin & Joint Health",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/4AMp5eE8K5n8POTHUJ7mH93tmQaWNDKMPjwh6m88.jpg?v=1790550082",
      "score": 60,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "immune",
        "skin",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "alpha",
        "plus",
        "collagen",
        "supplement",
        "with",
        "rosehip",
        "extract",
        "vitamin",
        "sachets",
        "for",
        "skin",
        "joint",
        "health",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 68,
        "manufacturing": 58,
        "safety": 82,
        "transparency": 54,
        "sustainability": 22
      },
      "price": 79.27,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575885172933",
      "vsf_explanation": "CH Alpha PLUS fully quantifies its collagen, rosehip, and Vitamin C content per serving at doses consistent with the collagen research literature, from an established international brand. Standard tier reflects strong formulation transparency offset by the absence of manufacturing certification or allergen disclosure.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "venatura-krom-200-mcg-chromium-picolinate-supplement-90-capsules-for-nutritional-support",
      "title": "Venatura Krom 200 mcg Chromium Picolinate Supplement - 90 Capsules for Nutritional Support",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/W5o9zzcPzOlPM1MROPPQ9D3LD8BoLunYGRLFdU6o.jpg?v=1790550082",
      "score": 55,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "venatura",
        "krom",
        "200",
        "mcg",
        "chromium",
        "picolinate",
        "supplement",
        "capsules",
        "for",
        "nutritional",
        "support",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 70,
        "manufacturing": 40,
        "safety": 80,
        "transparency": 58,
        "sustainability": 25
      },
      "price": 16.39,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575885041861",
      "vsf_explanation": "VeNatura's Krom supplement clearly discloses a single, well-defined dose of chromium picolinate within the typically studied range, with no problematic claims. The score is held back mainly by the brand's lack of any disclosed manufacturing certification or sustainability practices, which apply across the VeNatura line.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "ligone-rhodiola-rosea-complex-dietary-supplement-for-energy-30-capsules",
      "title": "Ligone Rhodiola Rosea Complex Dietary Supplement for Energy - 30 Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/bXgtCyAiJWEBg2mo6KjCcCfsLU9o92UHQeIj6onf.jpg?v=1790550082",
      "score": 37,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "mood",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "ligone",
        "rhodiola",
        "rosea",
        "complex",
        "dietary",
        "supplement",
        "for",
        "energy",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "energy_metabolic"
      ],
      "vsf_dimensions": {
        "evidence": 30,
        "formulation": 15,
        "manufacturing": 68,
        "safety": 50,
        "transparency": 20,
        "sustainability": 38
      },
      "price": 22.97,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575885271237",
      "vsf_explanation": "Ligone Rhodiola Rosea Complex is marketed for energy support, but the listing discloses no ingredient list, dose, or standardization for the named 'complex,' making the formulation impossible to verify.",
      "vsf_autofail_rule": "proprietary_blend_hides_dose"
    },
    {
      "handle": "venatura-iron-17mg-dietary-supplement-90-vegan-capsules-gluten-free-supports-healthy-iron-levels",
      "title": "VeNatura Iron 17mg Dietary Supplement - 90 Vegan Capsules, Gluten-Free, Supports Healthy Iron Levels",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ByORfNR2HKko7cqi7thIipU5mieGoHwQWiel2TcB.jpg?v=1790550083",
      "score": 56,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "venatura",
        "iron",
        "17mg",
        "dietary",
        "supplement",
        "vegan",
        "capsules",
        "gluten",
        "free",
        "supports",
        "healthy",
        "iron",
        "levels",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 55,
        "formulation": 72,
        "manufacturing": 40,
        "safety": 78,
        "transparency": 52,
        "sustainability": 25
      },
      "price": 21.32,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575885304005",
      "vsf_explanation": "VeNatura's Iron 17mg supplement discloses a clear, appropriately-dosed amount of iron with compliant, non-disease-claim language and useful vegan/gluten-free labeling. It lands in Standard tier, held back by the brand's undisclosed manufacturing certification and sustainability practices.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "suda-vitamin-glucosamine-chondroitin-with-msm-vitamin-k2-90-tablets-joint-health-wellness-supplement",
      "title": "Suda Vitamin Glucosamine Chondroitin with MSM Vitamin K2 90 Tablets - Joint Health & Wellness Supplement",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/ncCJuOQ28XZgKzLbYFYkUmUhLujCgigFG59dasVO.jpg?v=1790550083",
      "score": 51,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "joint"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "suda",
        "vitamin",
        "glucosamine",
        "chondroitin",
        "with",
        "msm",
        "vitamin",
        "tablets",
        "joint",
        "health",
        "wellness",
        "supplement",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "joint_bone_connective"
      ],
      "vsf_dimensions": {
        "evidence": 58,
        "formulation": 48,
        "manufacturing": 50,
        "safety": 52,
        "transparency": 60,
        "sustainability": 27
      },
      "price": 29.56,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575885238469",
      "vsf_explanation": "Suda's joint-health formula names its ingredients but never discloses the specific mg doses of glucosamine, chondroitin, or MSM, and glucosamine/chondroitin's own clinical evidence is mixed at the category level. Combined with an undisclosed shellfish-sourcing risk, this places the SKU in Rejected tier.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "natures-bounty-omega-3-600-mg-high-potency-heart-health-brain-function-support-supplement-90-soft-capsules",
      "title": "Nature's Bounty Omega-3 600 mg - High Potency Heart Health & Brain Function Support Supplement - 90 Soft Capsules",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/2ojNpRI1Il7ljUQoMeEpNUExu8NFpoYvqkuXbXZw.jpg?v=1790550082",
      "score": 71,
      "tier": "verified",
      "certifications": [],
      "goal_tags": [
        "cardiovascular",
        "inflammation",
        "cognitive"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nature",
        "bounty",
        "omega",
        "600",
        "high",
        "potency",
        "heart",
        "health",
        "brain",
        "function",
        "support",
        "supplement",
        "soft",
        "capsules",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 66,
        "formulation": 68,
        "manufacturing": 85,
        "safety": 82,
        "transparency": 68,
        "sustainability": 45
      },
      "price": 42.72,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575885205701",
      "vsf_explanation": "Nature's Bounty's Omega-3 softgel discloses a specific EPA/DHA breakdown backed by strong generic evidence for heart and brain health, manufactured under the brand's established cGMP-certified US facility standards. This combination of clear dosing and established manufacturing places it in Verified tier despite the lack of a product-specific clinical trial.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nondo-celery-extract-supplement-30-capsules-natural-health-product-for-adults",
      "title": "Nondo Celery Extract Supplement - 30 Capsules | Natural Health Product for Adults",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/xzNrpCPsv52T3YIifg85XnvioQzeD3bKdRqioOeO.jpg?v=1790550083",
      "score": 53,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nondo",
        "celery",
        "extract",
        "supplement",
        "capsules",
        "natural",
        "health",
        "product",
        "for",
        "adults",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "cardiovascular_heart"
      ],
      "vsf_dimensions": {
        "evidence": 38,
        "formulation": 60,
        "manufacturing": 66,
        "safety": 58,
        "transparency": 60,
        "sustainability": 36
      },
      "price": 21.32,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575885336773",
      "vsf_explanation": "Nondo Celery Extract discloses a clear 500mg per-capsule dose, but the evidence supporting celery extract's health claims is limited and the listing omits a known celery allergen warning.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutraxin-magnesium-complex-vitamin-b6-supplement-60-tablets-supports-energy-production-and-muscle-function",
      "title": "Nutraxin Magnesium Complex + Vitamin B6 Supplement - 60 Tablets, Supports Energy Production and Muscle Function",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/RKnrjp0hTazDKA2UBthNSDziNH5IiunshgSrrDMW.jpg?v=1790550082",
      "score": 58,
      "tier": "standard",
      "certifications": [],
      "goal_tags": [
        "sleep",
        "recovery",
        "cardiovascular",
        "energy"
      ],
      "sex_relevance": "neutral",
      "life_stage": "general",
      "tokens": [
        "nutraxin",
        "magnesium",
        "complex",
        "vitamin",
        "supplement",
        "tablets",
        "supports",
        "energy",
        "production",
        "and",
        "muscle",
        "function",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "vitamins_micronutrients"
      ],
      "vsf_dimensions": {
        "evidence": 65,
        "formulation": 68,
        "manufacturing": 45,
        "safety": 72,
        "transparency": 60,
        "sustainability": 20
      },
      "price": 24.52,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575885402309",
      "vsf_explanation": "This magnesium and B6 combination discloses a clear elemental dose and uses a multi-form magnesium blend with solid generic evidence for energy and muscle function. It reaches Standard tier on the strength of clear dosing, but the brand's lack of disclosed manufacturing certification and sustainability information caps it there.",
      "vsf_autofail_rule": ""
    },
    {
      "handle": "nutraxin-multivitamin-mineral-complex-for-women-womens-health-supplement-60-tablets",
      "title": "Nutraxin Multivitamin & Mineral Complex For Women - Women's Health Supplement - 60 Tablets",
      "vendor": "",
      "image_url": "https://cdn.shopify.com/s/files/1/0781/3116/7429/files/M8RAGkL2YD4SxbWjNWwHEIv2kBK6v85Umymq8fNO.jpg?v=1790550082",
      "score": 49,
      "tier": "rejected",
      "certifications": [],
      "goal_tags": [
        "energy",
        "immune"
      ],
      "sex_relevance": "female",
      "life_stage": "general",
      "tokens": [
        "nutraxin",
        "multivitamin",
        "mineral",
        "complex",
        "for",
        "women",
        "women",
        "health",
        "supplement",
        "tablets",
        "beauty",
        "care",
        "bag"
      ],
      "vsf_category": "supplements",
      "vsf_subcategory": [
        "womens_health"
      ],
      "vsf_dimensions": {
        "evidence": 48,
        "formulation": 50,
        "manufacturing": 45,
        "safety": 68,
        "transparency": 50,
        "sustainability": 20
      },
      "price": 22.63,
      "currency": "USD",
      "variant_id": "gid://shopify/ProductVariant/50575885369541",
      "vsf_explanation": "Nutraxin's Women's Multivitamin & Mineral Complex claims to be tailored to women's health needs, but the product page discloses no actual ingredient list or doses to verify that claim. Combined with the brand's undisclosed manufacturing and sustainability practices, this results in a Rejected-tier score.",
      "vsf_autofail_rule": ""
    }
  ]
};
